webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(10);
	
	__webpack_require__(229);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _blockUi = __webpack_require__(230);
	
	var _blockUi2 = _interopRequireDefault(_blockUi);
	
	__webpack_require__(473);
	
	__webpack_require__(479);
	
	__webpack_require__(848);
	
	__webpack_require__(486);
	
	__webpack_require__(323);
	
	__webpack_require__(322);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	__webpack_require__(846);
	
	__webpack_require__(188);
	
	__webpack_require__(477);
	
	__webpack_require__(227);
	
	__webpack_require__(478);
	
	__webpack_require__(324);
	
	__webpack_require__(1571);
	
	__webpack_require__(1564);
	
	__webpack_require__(849);
	
	__webpack_require__(838);
	
	__webpack_require__(720);
	
	__webpack_require__(556);
	
	__webpack_require__(735);
	
	__webpack_require__(582);
	
	__webpack_require__(588);
	
	__webpack_require__(801);
	
	__webpack_require__(723);
	
	__webpack_require__(661);
	
	__webpack_require__(755);
	
	__webpack_require__(655);
	
	__webpack_require__(649);
	
	__webpack_require__(645);
	
	__webpack_require__(501);
	
	__webpack_require__(500);
	
	__webpack_require__(830);
	
	__webpack_require__(494);
	
	__webpack_require__(616);
	
	__webpack_require__(828);
	
	__webpack_require__(598);
	
	__webpack_require__(619);
	
	__webpack_require__(604);
	
	__webpack_require__(656);
	
	__webpack_require__(657);
	
	__webpack_require__(659);
	
	__webpack_require__(771);
	
	__webpack_require__(643);
	
	__webpack_require__(653);
	
	__webpack_require__(790);
	
	__webpack_require__(788);
	
	__webpack_require__(569);
	
	__webpack_require__(647);
	
	__webpack_require__(651);
	
	__webpack_require__(792);
	
	__webpack_require__(813);
	
	__webpack_require__(817);
	
	__webpack_require__(816);
	
	__webpack_require__(509);
	
	__webpack_require__(798);
	
	__webpack_require__(692);
	
	__webpack_require__(705);
	
	__webpack_require__(559);
	
	__webpack_require__(687);
	
	__webpack_require__(690);
	
	__webpack_require__(572);
	
	__webpack_require__(758);
	
	__webpack_require__(760);
	
	__webpack_require__(759);
	
	__webpack_require__(761);
	
	__webpack_require__(560);
	
	__webpack_require__(775);
	
	__webpack_require__(679);
	
	__webpack_require__(681);
	
	__webpack_require__(769);
	
	__webpack_require__(666);
	
	__webpack_require__(668);
	
	__webpack_require__(624);
	
	__webpack_require__(627);
	
	__webpack_require__(678);
	
	__webpack_require__(825);
	
	__webpack_require__(633);
	
	__webpack_require__(565);
	
	__webpack_require__(683);
	
	__webpack_require__(636);
	
	__webpack_require__(726);
	
	__webpack_require__(639);
	
	__webpack_require__(739);
	
	__webpack_require__(748);
	
	__webpack_require__(784);
	
	__webpack_require__(807);
	
	__webpack_require__(767);
	
	__webpack_require__(585);
	
	__webpack_require__(763);
	
	__webpack_require__(699);
	
	__webpack_require__(695);
	
	__webpack_require__(696);
	
	__webpack_require__(753);
	
	__webpack_require__(777);
	
	__webpack_require__(630);
	
	__webpack_require__(590);
	
	__webpack_require__(843);
	
	__webpack_require__(842);
	
	__webpack_require__(841);
	
	__webpack_require__(836);
	
	__webpack_require__(839);
	
	__webpack_require__(495);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Set up your application entry point here...
	__webpack_require__(1061);
	__webpack_require__(1062);
	__webpack_require__(1127);
	// export it to the window, so ricochet dev's can use it too,
	// and will not affect us
	
	window.moment = _moment2.default;
	// Remove Dependency in future, only using inputmask
	// import "./lib/jasny-bootstrap";
	
	// we have to specially import this file because it incorrectly
	// references a variable in the main package, so we fix it
	
	
	_jquery2.default.validator.addClassRules("isrequired", { required: true });
	
	// this is generated from an alias in webpack configs
	__webpack_require__(476);
	// import "./lib/dataTables";
	
	// load all store data from data attributes first
	
	
	// import "./utilities/quickToggler";
	// import "./utilities/quickExpander/quickExpanderTest";
	
	// When complete, the below import will include the actual
	// functionality for the hcu guides page provided by Jigar
	
	
	// import "./pages/consumerReturns/consumerReturnsView/index";
	
	// import "./pages/hcu/hcuFAQ/index";
	// import "./pages/hcu/hcuGlossary/index";
	
	// import "./pages/ecds/index";
	
	// import "./pages/orderConfiguration/index";
	
	// FOR ERROR PAGE SLASH SYSTEM DOWN FOR MAINTENANCE PAGE AND MODAL
	// import "./pages/systemDownMaintenance/index";
	
	// Commerce Drawer
	
	
	//HB-7172
	
	
	//--------------------------------------------//
	// PAGES
	//--------------------------------------------//
	
	// Could not find the folder
	// import "./pages/addressValidationStub/addressValidationStub";
	
	// Could not find the folder
	// import "./pages/bundleDetailStub/bundleDetailStub";
	
	// Rips out: RMSUI Portal
	// import "./pages/teamMembers/details/index.js";
	
	//--------------------------------------------//
	// EMAIL TEMPLATES
	//--------------------------------------------//
	
	// Rips out: HTML el
	// import "./pages/stubs/emailWorkOrderNotificationGeneric/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailTemplateWithPurpleBar/";
	
	// Rips out HTML el
	// import "./pages/stubs/ebayConnectionsEmailTemplate/";
	
	// Rips out: HTML el
	// import "./pages/stubs/suspiciousActivityEmailTemplate/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailRueLaLa/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailTemplateFxoLabel/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailTemplateSupplyChainLabel/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailPastDueInvoices/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailPastDueInvoices30Days/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailInvoicePosted/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailShopifyConnection/";
	
	// Rips out: HTML el
	// import "./pages/stubs/businessExceptionsEmailNotifications/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailPasswordExpired/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailInboundShipmentNotifications/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailMissingInternationalDocuments/";
	
	// Rips out: HTML el
	// import "./pages/stubs/emailAddressValidationPreferences/";
	//--------------------------------------------//
	// UTILITIES
	//--------------------------------------------//
	
	// Rips out Channel Portal
	// import "./utilities/productsModalUtilities/example.js";
	
	// Rips out Global Channel Portal
	// import "./utilities/datePicker/example.js";
	
	//--------------------------------------------//
	// COMPONENTS
	//--------------------------------------------//
	
	// Rips out Global Components Portal
	// import "./components/ProductModal/example";
	
	// Rips out Global Components Portal
	// import "./components/widgetEngine/example";
	
	// Rips out Global Components Portal
	// import "./components/lookupTable/example";
	
	// Rips out Global Components Portal
	// import "./components/timePicker/example";
	
	// Rips out Global Components Portal
	// import "./components/resourceProgress/example";
	
	// Rips out Global Components Portal
	// import "./components/SubmitModalFlow/example";
	
	// Rips out Global Components Portal
	// import "./components/ErrorModal/example";
	
	// Rips out Global Components Portal
	// import "./components/SaveThenDestroy/example";
	
	// Rips out Global Components Portal
	// import "./components/pagableComponent/example";
	
	// Rips out Global Components Portal
	// import "./components/fileUploader/example";
	
	// Rips out Global Components Portal
	// import "./components/scheduler/example";
	
	//--------------------------------------------//
	// STUBS
	//--------------------------------------------//
	
	// Rips out Global Development Portal
	// import "./pages/stubs/addressValidationStub/addressValidationStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/bundleNewStub/bundleNewStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/workOrderDetailsRetailerStub/workOrderDetailsStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/workOrderNewStub/workOrderNewStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/systemDownMaintenance/systemDownMaintenanceStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/hcuGuideStub/hcuGuideStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/hcuFAQ/hcuFAQStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/hcuHomepageStub/hcuHomepageStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/hcuGlossary/hcuGlossaryStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/hcuGlossaryTerm/hcuGlossaryTermStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/hcuTopNavStub/hcuTopNavStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/hcuSearchResults/hcuSearchResultsStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonFBAPalletSearchStub/amazonFBAPalletSearchStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonFBAPackageLabel/";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonFBAPackageLabelScan/";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonFBAPackageLabelPrint/";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonLPNInfo/amazonLPNInfoStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonLPNScan/amazonLPNScanStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/brandingLogin/brandingLoginStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/connectionModal/connectionModalStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/relatedReturnsRevamp/relatedReturnsRevampStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/bundleDetailStub/bundleDetailStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/productCatalogBtnStub/productCatalogBtnStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/newCollateralStub/newCollateralWizardStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/collateralRulesStub/collateralRulesStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/collateralDetailStub/collateralDetailStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/inboundShipmentPalletFutureStub/inboundShipmentPalletFutureStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/inboundShipmentParcelFutureStub/inboundShipmentParcelFutureStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/collateralRuleDetailStub/collateralRuleDetailStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/editOrderDocumentsSettingsStub/editOrderDocumentsSettings";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderDocumentsSettingsStub/orderDocumentsSettings";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderDetailPartialStub/orderDetailStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderDetailStub/orderDetailStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/productDetailStub/productDetailStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/productDetailWizard/";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderSplitStub/orderSplitStub"
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonFBAConnectionsStub/amazonFBAConnectionsStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonMarketplaceConnectionsStub/amazonMarketplaceConnectionsStub"
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonFBAOrderWizardStub/amazonFBAOrderWizardStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/retailerWizardStub/retailerWizardStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/retailerDetailStub/retailerDetailStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonFBAConnectionDetailStub/amazonFBAConnectionDetailStub"
	
	// Rips out Global Development Portal
	// import "./pages/stubs/amazonMarketplaceConnectionDetailStub/amazonMarketplaceConnectionDetailStub"
	
	// Portal used may be UI-Dev portlet
	// Rips out Global Development Portal
	// import "./pages/stubs/reportsStub/reports";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/consumerReturnsView/index.js";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/billingInformation/billingInformation"
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderConfiguration/orderConfiguration";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderConfigurationDetail/orderConfigurationDetail";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/supplyChainFacilityModal/supplyChainFacilityModal";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/commerceDrawer/commerceDrawerStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderWizard/orderWizard";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/notificationPreferences/notificationPreferences";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/notificationPreferencesDetail/notificationPreferencesDetail";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/commerceLeftNav/commerceLeftNav";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/typeAheadExample/typeAheadExample";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/asnWizard/asnWizard";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/csvErrors/csvErrors";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/asnDetail/asnDetail";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/inventoryDetail/inventoryDetail";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/teamMembers/details/index.js";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/teamMembers/manage/index.js";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/merchantConfig/merchantConfigManage/index.js";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/merchantConfig/merchantConfigView/index.js";
	
	// Rips out Body
	// EXTRA NOTE: comment out required CSS at the top of this page to see this stub.
	// import "./pages/stubs/oauthAcceptPage";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/returnRequestsWizard";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/returnRequestsDetails";
	
	// Rips out Body
	// EXTRA NOTE: comment out required CSS at the top of this page to see this stub.
	// import "./pages/stubs/oauthLoginPage";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/returnsEngineManage";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/returnsEngineLookup";
	
	// Rips out GLobal Development Portal
	// import "./pages/stubs/returnsEngineDetails";
	
	// Rips out Global Development portal
	// import "./pages/stubs/returnsEngineHcDetails";
	
	// Rips out Global Development portal
	// import "./pages/stubs/returnsEngineHcManage";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/transferOrderDetail";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/transferOrderWizard";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/fedexAccountManagement";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/fedexAccountManagementForm/famf";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderDesk/orderDesk.js";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/ebayConnectionWizardStub/ebayConnectionsStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/locationsDetailsStub/details";
	
	// Rips out Globla Development Portal
	// import "./pages/stubs/locationsManageStub/manage";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/ebayConnectionDetailsStub/ebayConnectionDetailStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/fxoConfigurationForm/";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/fxoConfigurationDetails/";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/bulkUploadTable";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderCommunicationsForm/";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderCommunicationsConfirmation/";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/asnBulkUpload";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/asnBulkUploadDetail/";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/initialStateForLookupTables/initialStateForLookupTables";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/notificationManagement/notificationManagement";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/fxoReceivingScreen";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/vendorManagementOrganizationFormNew";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/vendorManagementOrganizationFormEdit";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/vendorManagementCustomerFormNew";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/vendorManagementCustomerFormEdit";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/vendorManagementOrganizationDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/vendorManagementCustomerDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/purchaseOrderWizard";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/purchaseOrderDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderTypeWizard";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderTypeDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/passwordGuidelinesStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/bulkUploadForOrdersNewFrameworkPartialStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/podUserAdminForm";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/podAdminUserDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/podPackageDetailsScreen";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/podAdvancedShipmentForm";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/locationMapping";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/walmartConnectionWizardStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/walmartConnectionDetailsStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/newFacilityForm";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/resetPasswordScreen";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/userPreferencePage";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/changePasswordScreen";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/rmaEntryLiteVersionForm";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/rmaEntryLiteVersionDetail";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/customShippingMethodNewEdit";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/customShippingMethodDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/standardPlatformFacilitySetupWizard";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/standardPlatformFacilitySetupDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/returnDispositionMerchantConfigurationStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/returnDispositionMerchantConfigurationDetailsStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderClaimsNewEdit";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orderClaimsDetail";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/dockConfigDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/dockConfigNewEdit";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/dockNewEdit";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/editAppointmentConfigurations";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/appointmentConfigurationsView";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/appointmentForm";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/appointmentDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/shopifyWizard";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/shopifyDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orgTeamMemberNewEdit";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orgNewEdit";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/orgDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/standardPlatformProductDetailsStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/standardPlatformProductWizardStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/crimsonOrderReleaseNewEdit";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/crimsonOrderReleaseDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/crimsonErrorModals";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/masterAccountSetupModal";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/configureAppointmentsDockDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/configureAppointmentsDockForm";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/webhookLookup";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/doorLookup";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/appointmentSchedulingNotSet";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/appointmentSchedulingSet";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/editAppointmentScheduling";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/dimDivisorLookup";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/newDimDivisor";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/dimDivisorDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/discountLookup";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/newDiscount";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/discountDetails";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/trappedOrderDetailsStub";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/shipmentStringMapping";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/returnsTechnologyRegistration";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/selfOnboarding";
	
	// Rips out Global Development Portal
	// import "./pages/stubs/verizonVsigma";
	
	//--------------------------------------------//
	
	// Rips out Global Stub Portal
	// import "./loadStubs";
	
	// Rips out Global UI Component Portal
	// import "./loadUiComponents";
	
	// Rips our Global Component Portal
	// import "./loadComponent";
	
	window.jqueryBundle = _jquery2.default;

/***/ },
/* 1 */,
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = run;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function run(selector, cb) {
	  (0, _jquery2.default)(function () {
	    var el = (0, _jquery2.default)(selector);
	    if (el.length) {
	      cb(el);
	    }
	  });
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRadioState = exports.disableInput = exports.enableInput = undefined;
	exports.selectVal = selectVal;
	exports.boolToHuman = boolToHuman;
	exports.toggleClassViaBool = toggleClassViaBool;
	exports.ib = ib;
	exports.resetDisplay = resetDisplay;
	exports.insertTextAndClean = insertTextAndClean;
	exports.allElements = allElements;
	exports.formatAddress = formatAddress;
	exports.setDisabled = setDisabled;
	exports.setEnabled = setEnabled;
	exports.setDisabledClass = setDisabledClass;
	exports.setUniqNames = setUniqNames;
	exports.setUniqIds = setUniqIds;
	exports.setUniqNamesAndIds = setUniqNamesAndIds;
	exports.setRequired = setRequired;
	exports.removeRequired = removeRequired;
	exports.setPhoneUs = setPhoneUs;
	exports.combineElements = combineElements;
	exports.setElementsFromScope = setElementsFromScope;
	exports.swapClasses = swapClasses;
	exports.swapClassesViaBool = swapClassesViaBool;
	exports.hide = hide;
	exports.show = show;
	exports.handleDisplayFor = handleDisplayFor;
	exports.handleDisplayForV2 = handleDisplayForV2;
	exports.setCheckboxState = setCheckboxState;
	exports.setOptionsForSelect = setOptionsForSelect;
	exports.insertValAndManageFocus = insertValAndManageFocus;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inputsSelector = "input, textarea, select";
	
	var noop = function noop() {};
	
	function selectVal(el) {
	  var val = el.val();
	  if (val === "-1") {
	    val = "";
	  }
	  return val;
	}
	
	function boolToHuman(val) {
	  if ((0, _general.isTruthy)(val)) {
	    return "Yes";
	  } else {
	    return "No";
	  }
	}
	
	function toggleClassViaBool(el, cls, val) {
	  if ((0, _general.isTruthy)(val)) {
	    el.addClass(cls);
	  } else {
	    el.removeClass(cls);
	  }
	}
	
	function ib(el) {
	  el.css({ display: "inline-block" });
	}
	
	function resetDisplay(el) {
	  el.css({ display: "" });
	}
	
	function insertTextAndClean(el, val) {
	  el.text(val);
	}
	
	function allElements(elsMap) {
	  var out = (0, _jquery2.default)();
	
	  (0, _underscore2.default)(elsMap).mapObject(function (el, k) {
	    out = out.add(el);
	  });
	  return out;
	}
	
	function formatAddress(_ref) {
	  var address1 = _ref.address1,
	      address2 = _ref.address2,
	      city = _ref.city,
	      state = _ref.state,
	      zip = _ref.zip,
	      country = _ref.country;
	
	  var output = (address1 + "\n    " + address2 + "\n    " + city + ",\n    " + state + "\n    " + zip + "\n    " + country).replace(/ +(?= )/g, '');
	  return output;
	}
	
	function setDisabled(elsArr) {
	  (0, _underscore2.default)(elsArr).map(function (el) {
	    el.prop("disabled", true);
	  });
	}
	
	function setEnabled(elsArr) {
	  (0, _underscore2.default)(elsArr).map(function (el) {
	    el.prop("disabled", false);
	  });
	}
	
	function setDisabledClass(elsArr) {
	  (0, _underscore2.default)(elsArr).map(function (el) {
	    el.addClass("disabled");
	  });
	}
	
	function setUniqNames(elsArr) {
	  (0, _underscore2.default)(elsArr).map(function (el) {
	    el.attr("name", _underscore2.default.uuid());
	  });
	}
	
	function setUniqIds(elsArr) {
	  (0, _underscore2.default)(elsArr).map(function (el) {
	    el.attr("id", _underscore2.default.uuid());
	  });
	}
	
	function setUniqNamesAndIds(elsArr) {
	  (0, _underscore2.default)(elsArr).map(function (el) {
	    var id = _underscore2.default.uuid();
	    el.attr("name", id);
	    el.attr("id", id);
	  });
	}
	
	function setRequired(elsArr) {
	  (0, _underscore2.default)(elsArr).map(function (el) {
	    el.addClass("isrequired");
	  });
	}
	
	function removeRequired(elsArr) {
	  (0, _underscore2.default)(elsArr).map(function (el) {
	    el.removeClass("isrequired");
	  });
	}
	
	function setPhoneUs(elsArr, data) {
	  (0, _underscore2.default)(elsArr).map(function (el) {
	    if (data == "+1") {
	      el.addClass("phoneUS");
	    } else {
	      el.removeClass("phoneUS");
	    }
	  });
	}
	
	function combineElements(arr) {
	  var output = (0, _jquery2.default)();
	  (0, _underscore2.default)(arr).each(function (el) {
	    output = output.add((0, _jquery2.default)(el));
	  });
	  return output;
	}
	
	function setElementsFromScope(targetObj, elementsDict, scope) {
	  (0, _underscore2.default)(elementsDict).each(function (v, k) {
	    // console.log(`${v} ${k}`)
	    targetObj[k] = scope.find(v);
	  });
	}
	
	function swapClasses(el, _ref2) {
	  var fromClasses = _ref2.fromClasses,
	      toClasses = _ref2.toClasses;
	
	  el.removeClass(fromClasses);
	  el.addClass(toClasses);
	}
	
	function swapClassesViaBool(el, trueClasses, falseClasses, val) {
	  if ((0, _general.isTruthy)(val)) {
	    el.removeClass(falseClasses);
	    el.addClass(trueClasses);
	  } else {
	    el.removeClass(trueClasses);
	    el.addClass(falseClasses);
	  }
	}
	
	function hide(el) {
	  el.css('display', 'none');
	}
	
	function show(el) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var displayType = opts.displayType || 'block';
	  el.css('display', displayType);
	}
	
	var enableInput = exports.enableInput = enableDisableInputFunc(false);
	var disableInput = exports.disableInput = enableDisableInputFunc(true);
	
	function enableDisableInputFunc(status) {
	  return function (el) {
	    if (el.is(inputsSelector)) {
	      el.prop('disabled', status);
	    } else {
	      el = el.find(inputsSelector);
	      el.prop('disabled', status);
	    }
	  };
	}
	
	function handleDisplayFor(el, val) {
	  if (val) {
	    show(el);
	  } else {
	    hide(el);
	  }
	}
	
	// make a v2 function of above
	// so we can slowly port over old
	// usage to new, more robust function
	function handleDisplayForV2(el, val) {
	  if ((0, _general.isTruthy)(val)) {
	    resetDisplay(el);
	  } else {
	    hide(el);
	  }
	}
	
	function setCheckboxState(el, state) {
	  if ((0, _general.isTruthy)(state)) {
	    el.prop('checked', true);
	  } else {
	    el.prop('checked', false);
	  }
	}
	
	var setRadioState = exports.setRadioState = setCheckboxState;
	
	function setOptionsForSelect(_ref3) {
	  var selectElement = _ref3.selectElement,
	      list = _ref3.list,
	      _ref3$afterOptionCrea = _ref3.afterOptionCreate,
	      afterOptionCreate = _ref3$afterOptionCrea === undefined ? noop : _ref3$afterOptionCrea,
	      _ref3$initialSelectVa = _ref3.initialSelectValue,
	      initialSelectValue = _ref3$initialSelectVa === undefined ? noop : _ref3$initialSelectVa,
	      _ref3$valueDataKey = _ref3.valueDataKey,
	      valueDataKey = _ref3$valueDataKey === undefined ? "value" : _ref3$valueDataKey,
	      _ref3$textDataKey = _ref3.textDataKey,
	      textDataKey = _ref3$textDataKey === undefined ? "text" : _ref3$textDataKey;
	
	  // fastest using context of keys and named function
	  var optionsArr = (0, _underscore2.default)(list).map(setOptionViaData, { valueDataKey: valueDataKey, textDataKey: textDataKey, afterOptionCreate: afterOptionCreate });
	  var options = combineElements(optionsArr);
	  selectElement.append(options);
	  var val = void 0;
	  if (_underscore2.default.isFunction(initialSelectValue)) {
	    val = initialSelectValue(selectElement, list, options);
	  } else {
	    val = initialSelectValue;
	  };
	  val = _underscore2.default.isRegExp(val) ? findDefaultOptionViaRgxVal(optionsArr, val) : val;
	  selectElement.val(val);
	}
	
	function findDefaultOptionViaRgxVal(optionsArr, rgx) {
	  var option = (0, _underscore2.default)(optionsArr).find(function (option) {
	    return (0, _general.rgxTest)(rgx, option.val());
	  });
	  if (option) {
	    return option.val();
	  } else {
	    return null;
	  }
	}
	
	function setOptionViaData(data) {
	  var valueDataKey = this.valueDataKey,
	      textDataKey = this.textDataKey,
	      afterOptionCreate = this.afterOptionCreate;
	
	  var option = (0, _jquery2.default)('<option/>');
	  option.val(data[valueDataKey]);
	  option.text(data[textDataKey]);
	  afterOptionCreate({ option: option, data: data });
	  return option;
	}
	
	function insertValAndManageFocus(input, val) {
	  if (input.length) {
	    var inputWasFocused = input.is(":focus");
	    var canGrabSelection = !input.is('[type="number"]');
	
	    var origCaret = void 0;
	    // if input was focused,
	    // find out what part was focused
	    //console.log('input was focused,', inputWasFocused);
	    if (canGrabSelection && inputWasFocused) {
	      origCaret = input.range();
	    }
	    // then, always set the val
	    // to updated val,
	    // but also check if val
	    // is undefined or null,
	    // so we can set the val
	    // to empty string
	    if (_underscore2.default.isNull(val) || _underscore2.default.isUndefined(val)) {
	      val = "";
	    }
	
	    // only insert value if:
	    // the input was NOT focused
	    // --- OR ----
	    // you can ensure you are able to grab the selection
	    // to refocus the previously-focused input
	    if (!inputWasFocused || canGrabSelection) {
	      if (input.val() !== val) {
	        input.val(val);
	      }
	    }
	
	    // now, if the input was originally
	    // focused, we need to put the caret
	    // back to where it was
	    if (inputWasFocused && canGrabSelection) {
	      if (_underscore2.default.isNull(origCaret) || _underscore2.default.isUndefined(origCaret)) {
	        input.focus();
	      } else if (origCaret.start === origCaret.end) {
	        input.caret(origCaret.start);
	      } else {
	        input.range(origCaret.start, origCaret.end);
	      }
	    }
	  }
	}

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.merge = undefined;
	exports.isTruthy = isTruthy;
	exports.isFalsey = isFalsey;
	exports.isPresent = isPresent;
	exports.isBlank = isBlank;
	exports.isGtZero = isGtZero;
	exports.toWeekDayMonthAndDay = toWeekDayMonthAndDay;
	exports.convertMilitaryToInt = convertMilitaryToInt;
	exports.militaryToPeriodTime = militaryToPeriodTime;
	exports.getHoliday = getHoliday;
	exports.getWeekend = getWeekend;
	exports.isDaylightSavingsTimeInEffect = isDaylightSavingsTimeInEffect;
	exports.stdTimezoneOffset = stdTimezoneOffset;
	exports.rgxTest = rgxTest;
	exports.keyDefaultFalseOption = keyDefaultFalseOption;
	exports.removeAmpersand = removeAmpersand;
	exports.removeNonDigit = removeNonDigit;
	exports.createPreventDefault = createPreventDefault;
	exports.formateDateUtil = formateDateUtil;
	exports.shallAllowClick = shallAllowClick;
	exports.getMilitaryTimeFromDate = getMilitaryTimeFromDate;
	exports.fuseDateTimeValueToStandard = fuseDateTimeValueToStandard;
	exports.getESTDate = getESTDate;
	exports.formatPhone = formatPhone;
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	__webpack_require__(840);
	
	var _deepmerge = __webpack_require__(268);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.merge = _deepmerge2.default;
	function isTruthy(val) {
	  return val === "true" || val === true;
	}
	
	function isFalsey(val) {
	  return val === "false" || val === false;
	}
	
	function isPresent(val) {
	  return !_underscore2.default.isUndefined(val) && !_underscore2.default.isNull(val) && val !== "";
	}
	
	function isBlank(val) {
	  return _underscore2.default.isUndefined(val) || _underscore2.default.isNull(val) || val === "";
	}
	
	function isGtZero(val) {
	  return val > 0;
	}
	
	function toWeekDayMonthAndDay(val) {
	  return (0, _moment2.default)(val, "MM/DD/YYYY").format("dddd, MMMM Do");
	}
	
	function convertMilitaryToInt(time) {
	  var mmt = (0, _moment2.default)(time, 'HH:mm').format('HHmm');
	  return parseInt(mmt, 10);
	}
	
	function militaryToPeriodTime(time) {
	  return (0, _moment2.default)(time, 'HH:mm').format('h:mm A');
	}
	
	function getHoliday(str) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$pattern = _ref.pattern,
	      pattern = _ref$pattern === undefined ? "MM/DD/YYYY" : _ref$pattern,
	      includes = _ref.includes,
	      holidayLookup = _ref.holidayLookup;
	
	  return (0, _moment2.default)(str, pattern).holiday({ includes: includes, holidayLookup: holidayLookup });
	}
	
	function getWeekend(str) {
	  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref2$pattern = _ref2.pattern,
	      pattern = _ref2$pattern === undefined ? "MM/DD/YYYY" : _ref2$pattern;
	
	  var day = (0, _moment2.default)(str, pattern).day();
	  return day == 6 || day == 0;
	}
	
	function isDaylightSavingsTimeInEffect(date) {
	  return date.getTimezoneOffset() < stdTimezoneOffset(date);
	}
	
	function stdTimezoneOffset(date) {
	  var jan = new Date(date.getFullYear(), 0, 1);
	  var jul = new Date(date.getFullYear(), 6, 1);
	  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
	}
	
	function rgxTest(rgx, str) {
	  return rgx.test(str);
	}
	
	// This function is used to check if a given key
	// in an object exists AND equals false, in order
	// to explicitly return false as the default option,
	// other wise return true
	function keyDefaultFalseOption(obj, key) {
	  if ((0, _underscore2.default)(obj).has(key) && !obj[key]) {
	    return false;
	  } else {
	    return true;
	  }
	}
	
	function removeAmpersand(e) {
	  $(this).val($(this).val().replace(/&/g, ""));
	}
	
	function removeNonDigit(e) {
	  $(this).val($(this).val().replace(/[^0-9]+/g, ""));
	}
	
	function createPreventDefault(func) {
	  return function (e) {
	    e.preventDefault();
	    func();
	  };
	}
	
	function formateDateUtil(createdDate, type, data) {
	  if (createdDate != null && createdDate != "") {
	    var date = new Date(createdDate); //createdDate is long time format
	    var month = date.getMonth() + 1;
	    var today = new Date();
	    var oneDay = 24 * 60 * 60 * 1000;
	    today.setHours(0, 0, 0, 0);
	    date.setHours(0, 0, 0, 0);
	    var diffDays = Math.floor(Math.abs((today.getTime() - date.getTime()) / oneDay));
	    var friendlyText = "";
	    var datePillHTML = "";
	    if (diffDays < 100) {
	      friendlyText = diffDays.toString() + ' Days Ago';
	      datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	    }
	    if (diffDays == 0) {
	      friendlyText = 'Today';
	    } else if (diffDays == 1) {
	      friendlyText = 'Yesterday';
	    }
	    return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
	  } else {
	    return "";
	  }
	}
	
	function shallAllowClick(currentObj) {
	  return !$(currentObj).hasClass("disabled");
	}
	
	function getMilitaryTimeFromDate(date) {
	  return date.getHours() + ":" + date.getMinutes();
	}
	
	function fuseDateTimeValueToStandard(date, time) {
	  var dateString = date + " " + time;
	  return new Date(dateString);
	}
	
	function getESTDate(date) {
	  //EST
	  var offset = 0;
	  if (isDaylightSavingsTimeInEffect(date)) {
	    //check time zone for given date
	    offset = -4.0;
	  } else {
	    offset = -5.0;
	  }
	  var utc = date.getTime() + date.getTimezoneOffset() * 60000;
	  date = new Date(utc + 3600000 * offset);
	  return date;
	}
	
	function formatPhone(phoneNumberString) {
	  //+1 (420) 234-2347
	  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
	  var match = cleaned.match(/(\d{1,3})?(\d{3})(\d{3})(\d{4})$/);
	  if (match) {
	    var intlCode = match[1] ? '+' + match[1] : '';
	    return [intlCode, ' (', match[2], ') ', match[3], '-', match[4]].join('');
	  }
	  return null;
	}

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = render;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_underscore2.default.templateSettings = {
	  interpolate: /\{%=([\s\S]+?)%\}/g,
	  escape: /\{%-([\s\S]+?)%\}/g,
	  evaluate: /\{%([\s\S]+?)%\}/g
	};
	
	function render(html) {
	  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  html = html || "";
	  var template = _underscore2.default.template(html);
	  data = _underscore2.default.extend({}, data, { render: render, _: _underscore2.default });
	  // mitigate undefined issues for optional keys
	  data.optional = _underscore2.default.extend({}, data);
	  return template(data);
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return isArray(this._weekdays) ? this._weekdays :
	                this._weekdays['standalone'];
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(1558)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.22.2';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)(module)))

/***/ },
/* 8 */,
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SubmitModalFlow;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _ErrorModal = __webpack_require__(464);
	
	var _ErrorModal2 = _interopRequireDefault(_ErrorModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	// const modalHtml = require("./html/baseModal.html");
	var modalHtml = __webpack_require__(11);
	var modalAlertHtml = __webpack_require__(182);
	
	__webpack_require__(1066);
	
	var elementsMap = {
	  closeBtn: ".top-close-btn",
	  confirmBtn: ".confirm-btn"
	};
	
	//Expose SubmitModal globally for old code
	window.SubmitModalFlow = SubmitModalFlow;
	
	function SubmitModalFlow() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var self = this;
	  var els = {};
	  var standardModal = void 0,
	      loadingModal = void 0,
	      successModal = void 0;
	
	  var errorModal = new _ErrorModal2.default();
	  errorModal.init();
	
	  var showErrorModal = errorModal.showModal;
	  var hideErrorModal = errorModal.hideModal;
	
	  self.setErrors = errorModal.setErrors;
	
	  self.init = function () {
	    buildHtml();
	    setElements();
	    bindElements();
	  };
	
	  self.showConfirmModal = function () {
	    showComfirmModal();
	  };
	
	  self.showLoadingModal = function () {
	    hideAllModals();
	    showLoadingModal();
	  };
	
	  self.showSuccessModal = function () {
	    hideAllModals();
	    showSuccessModal();
	  };
	
	  self.showFailureModal = function () {
	    hideAllModals();
	    showFailureModal();
	  };
	
	  self.hideAllModals = function () {
	    hideAllModals();
	  };
	
	  self.getConfirmModalBody = function () {
	    return standardModal.find(".modal-body");
	  };
	
	  function buildHtml() {
	    // Set Options
	    var modalDefaults = {
	      backdrop: 'static',
	      keyboard: false,
	      show: false
	    };
	
	    // Build Modals
	    standardModal = $((0, _render2.default)(modalHtml, {
	      title: options.confirmModalTitle || 'Confirm',
	      subtitle: options.confirmModalSubtitle,
	      leftAlignTitle: (0, _general.keyDefaultFalseOption)(options, "confirmModalLeftAlignTitle"),
	      body: options.confirmModalBody || 'Are you sure?',
	      topCloseBtn: (0, _general.keyDefaultFalseOption)(options, "confirmModalTopClose"),
	      modalDialogClass: options.modalDialogClass || "",
	      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" class="base-btn purple-btn confirm-btn">' + (options.confirmModalBtnText || 'Confirm') + '</a>'
	    }));
	    loadingModal = $((0, _render2.default)(modalAlertHtml, {
	      title: 'Submitting Request',
	      body: '<div class="q-pad-all-xl"><div class="inline-dots-loader"></div></div>'
	    }));
	    successModal = $((0, _render2.default)(modalAlertHtml, {
	      title: 'Success',
	      body: '<div class="q-pad-all-xl"><i class="fa fa-check-circle-o q-fa-success fa-4x"></i></div>'
	    }));
	
	    // Apply Options
	    (0, _selectorHelpers.combineElements)([standardModal, loadingModal, successModal]).modal(modalDefaults);
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, standardModal);
	  }
	
	  function bindElements() {
	    els.confirmBtn.on('click', onConfirmClick);
	    els.closeBtn.on('click', onConfirmCloseClick);
	  }
	
	  function showComfirmModal() {
	    standardModal.modal("show");
	  }
	
	  function showLoadingModal() {
	    loadingModal.modal("show");
	  }
	
	  function showSuccessModal() {
	    successModal.modal("show");
	  }
	
	  function showFailureModal() {
	    showErrorModal();
	  }
	
	  function hideConfirmModal() {
	    standardModal.modal("hide");
	  }
	
	  function hideAllModals() {
	    standardModal.modal("hide");
	    loadingModal.modal("hide");
	    successModal.modal("hide");
	    hideErrorModal();
	  }
	
	  function onConfirmClick(e) {
	    e.preventDefault();
	    options.onConfirmClick && options.onConfirmClick();
	  }
	
	  function onConfirmCloseClick(e) {
	    e.preventDefault();
	    var shouldClose = options.shouldCloseModal && options.shouldCloseModal();
	    if (shouldClose !== false) {
	      hideConfirmModal();
	    }
	  }
	}

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SUCCESS_MODAL_TIMEOUT = exports.SUCCESS_MODAL_TIMEOUT = 1500;
	var SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT = exports.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT = 500;
	var MAX_FILE_SIZE = exports.MAX_FILE_SIZE = 5242880; // 5MB in bytes
	
	window.constants = {
	  SUCCESS_MODAL_TIMEOUT: SUCCESS_MODAL_TIMEOUT,
	  SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT: SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT,
	  MAX_FILE_SIZE: MAX_FILE_SIZE
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal fade q-modal q-default-base q-default q-reset\" role=dialog {% if (optional.staticBackdrop) { %} data-backdrop=static {% } %}> <div class=\"modal-dialog {%- optional.modalDialogClass %}\"> <div class=modal-content> <div class=\"modal-header q-modal-header-double {% if (optional.leftAlignTitle) { %} q-text-left {% } %}\"> {% if( optional.topCloseBtn ){ %} <a href=# class=\"close q-modal-close-x top-close-btn {%- optional.autoHideTop ? 'modal-auto-hide' : '' %}\" aria-label=Close data-dismiss=modal><span aria-hidden=true>&times;</span></a> {% } %} <h4 class=q-modal-title>{%- title %}</h4> {% if( optional.subtitle ){ %} <h5 class=q-modal-sub-title>{%- optional.subtitle %}</h5> {% } %} </div> <div class=\"modal-body {%= optional.modalBodyClass %}\"> {%= optional.body %} </div> <div class=modal-footer> <div class=q-modal-footer-space-btns> {%= optional.footerLeft %} <div class=\"q-modal-footer-space-btns-inner btn-target\"> {%= footerBtns %} </div> </div> </div> </div> </div> </div>";

/***/ },
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _storeUtils = __webpack_require__(56);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _relationships = __webpack_require__(55);
	
	var _general = __webpack_require__(5);
	
	var _QuoteStore = __webpack_require__(98);
	
	var _QuoteStore2 = _interopRequireDefault(_QuoteStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PLANNED = "Planned";
	
	var general = {};
	var asns = {};
	var defaults = {
	  // NOTE: for now, just hard code the only facility
	  // because we only have one
	  facilities: "1",
	  pickupTimeFrom: "09:00",
	  pickupTimeTo: "17:00",
	  status: "New"
	};
	
	var AsnStore = (0, _storeUtils.createStore)({
	  storeEventBaseKey: "asns",
	  normalizr: _relationships.asnKeyNormalizr,
	  normalizrKey: "asns",
	  getData: function getData() {
	    return asns;
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  requestQuoteSucceeded: function requestQuoteSucceeded(asn) {
	    return _underscore2.default.has(asn, "requestQuoteSuccess") && asn.requestQuoteSuccess;
	  },
	  requestQuoteFailed: function requestQuoteFailed(asn) {
	    // does not explicitly equal false
	    return _underscore2.default.has(asn, "requestQuoteSuccess") && asn.requestQuoteSuccess === false;
	  },
	  hasSpecialQuote: function hasSpecialQuote(asn) {
	    return _underscore2.default.has(asn, "specialQuote") && asn.specialQuote;
	  },
	  didRequestQuotes: function didRequestQuotes(asn) {
	    return this.hasSpecialQuote(asn) || this.requestQuoteSucceeded(asn) || this.requestQuoteFailed(asn);
	  },
	  hasSelectedQuote: function hasSelectedQuote(asn) {
	    return !!this.getSelectedQuote(asn);
	  },
	  getSelectedQuote: function getSelectedQuote(asn) {
	    return this.getSelectedQuoteForAsn(asn);
	  },
	  getSelectedQuoteForAsn: function getSelectedQuoteForAsn(asn) {
	    var attrs = (0, _underscore2.default)(asn).pick("quoteId", "optionId");
	    return _QuoteStore2.default.findWhere(attrs);
	  },
	  getAvailableQuotesForAsn: function getAvailableQuotesForAsn(asn) {
	    return _QuoteStore2.default.where({ asnId: asn.id });
	  },
	  getAvailableAndSelectedQuotesForAsn: function getAvailableAndSelectedQuotesForAsn(asn) {
	    return _QuoteStore2.default.filter(filterQuoteAvailableOrSelectedForAsn, asn);
	  },
	  resetQuotesRelatedFlags: function resetQuotesRelatedFlags(asn) {
	    var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    if (asn) {
	      var quotes = this.getAvailableAndSelectedQuotesForAsn(asn);
	      _QuoteStore2.default.removeDataByIdsAndEmit(_QuoteStore2.default.pluckIdsFromArray(quotes));
	      // create a new snapshot based on most
	      var newData = _underscore2.default.extend({}, { quoteId: null, optionId: null, quotesAreValid: null, showQuotesRemovedBecauseInfoChangedMessage: null, isFetchingQuotes: null, requestQuoteSuccess: null, specialQuote: null }, overrides);
	      this.updateObjectAndEmit(asn.id, newData);
	    }
	  },
	  areQuotesInvalid: function areQuotesInvalid(asn) {
	    return _underscore2.default.has(asn, "quotesAreValid") && asn.quotesAreValid === false;
	  },
	  shouldShowQuotesRemovedBecauseInfoChangedMessage: function shouldShowQuotesRemovedBecauseInfoChangedMessage(asn) {
	    return !!asn.showQuotesRemovedBecauseInfoChangedMessage;
	  },
	  isFetchingQuotes: function isFetchingQuotes(asn) {
	    return asn.isFetchingQuotes;
	  },
	  isSubmitted: function isSubmitted(asn) {
	    var status = asn.status;
	    return status && status !== PLANNED;
	  },
	  isPallet: function isPallet(asn) {
	    return asn.shippingMethod === "pallet";
	  },
	  isParcel: function isParcel(asn) {
	    return asn.shippingMethod === "parcel";
	  },
	  getCarrierBroker: function getCarrierBroker() {
	    return general.carrierBrokerSelection;
	  },
	  selectCarrierBroker: function selectCarrierBroker(value) {
	    this.selectCarrierBrokerMethod(value);
	  },
	  isGTL: function isGTL(asn) {
	    return this.isPallet(asn) && this.hasShippingPartner(asn);
	  },
	  selectParcel: function selectParcel() {
	    this.selectShippingMethod('parcel');
	  },
	  selectPallet: function selectPallet() {
	    this.selectShippingMethod('pallet');
	  },
	  selectShippingMethod: function selectShippingMethod(method) {
	    general.shippingMethod = method;
	    this.emitEvent('shipping_method_changed', method);
	  },
	  selectCarrierBrokerMethod: function selectCarrierBrokerMethod(method) {
	    general.carrierBrokerSelection = method;
	    this.emitEvent('carrier_broker_method_changed', method);
	  },
	  hasShippingPartner: function hasShippingPartner(asn) {
	    return (0, _general.isTruthy)(asn.shippingPartner);
	  },
	  hasShippingPartnerSelected: function hasShippingPartnerSelected(asn) {
	    return !_underscore2.default.isNull(asn.shippingPartner) && !_underscore2.default.isUndefined(asn.shippingPartner);
	  },
	  selectShippingPartner: function selectShippingPartner(asn, status) {
	    status = (0, _general.isTruthy)(status);
	    asn.shippingPartner = status;
	    this.emitEvent('shipping_partner_changed', status);
	  },
	  selectFreightShipping: function selectFreightShipping(asn, status) {
	    status = (0, _general.isTruthy)(status);
	    asn.freightShipping = status;
	    this.emitEvent('freight_shipping_changed', status);
	  },
	  hasFreigthSelected: function hasFreigthSelected(asnId) {
	    var asn = this.getAsn(asnId);
	    if (asn && (0, _general.isPresent)(asn.freightShipping)) {
	      return (0, _general.isTruthy)(asn.freightShipping);
	    } else {
	      return undefined;
	    }
	  },
	  selectCaseShipping: function selectCaseShipping(asn, status) {
	    status = (0, _general.isTruthy)(status);
	    asn.caseShipping = status;
	    this.emitEvent('case_shipping_changed', status);
	  },
	  hasCaseShippingSelected: function hasCaseShippingSelected(asnId) {
	    return (0, _general.isTruthy)(this.getAsn(asnId).caseShipping);
	  },
	  createNewAsn: function createNewAsn(data) {
	    data = _underscore2.default.extend({ id: _underscore2.default.uuid() }, defaults, data);
	    return this.addAsn(data);
	  },
	  addAsn: function addAsn(data) {
	    return this.addObjectsAndEmit(asns, data);
	  },
	  getAsnWithShippingMethod: function getAsnWithShippingMethod(shippingMethod) {
	    if (_underscore2.default.isUndefined(shippingMethod)) {
	      shippingMethod = this.getShippingMethod();
	    }
	    return _underscore2.default.chain(asns).values().find(function (asn) {
	      return asn.shippingMethod === shippingMethod;
	    }).value();
	  },
	  getShippingMethod: function getShippingMethod() {
	    return general.shippingMethod;
	  },
	  getOrCreateAsnWithShippingMethod: function getOrCreateAsnWithShippingMethod(shippingMethod) {
	    var asn = (0, _underscore2.default)(asns).find(function (asn) {
	      return asn.shippingMethod === shippingMethod;
	    });
	    if (!asn) {
	      asn = this.createNewAsn({ shippingMethod: shippingMethod });
	    }
	    return asn;
	  },
	  allAsnDetailsHaveDimensionsAndWeight: function allAsnDetailsHaveDimensionsAndWeight(asn) {
	    var asnDetails = this.getAsnDetails(asn);
	    return _AsnDetailStore2.default.haveDimensionsAndWeight(asnDetails);
	  },
	  allAsnShippingPalletsHaveDimensionsAndWeight: function allAsnShippingPalletsHaveDimensionsAndWeight(asn) {
	    var asnShippingPallets = this.getAsnShipppingPallets(asn);
	    return AsnShippingPalletStore.haveDimensionsAndWeight(asnShippingPallets);
	  },
	  hasAllPickupTimeFields: function hasAllPickupTimeFields(asn) {
	    return (0, _general.isPresent)(asn.pickupTimeFrom) && (0, _general.isPresent)(asn.pickupTimeTo);
	  },
	  getPickupDateHoliday: function getPickupDateHoliday(asn) {
	    return (0, _general.getHoliday)(asn.pickupDate, { holidayLookup: "shippingHolidays" });
	  },
	  getPickupDateWeekend: function getPickupDateWeekend(asn) {
	    return (0, _general.getWeekend)(asn.pickupDate);
	  },
	  getAsnDetails: function getAsnDetails(asn) {
	    return _AsnDetailStore2.default.where({ asnId: asn.id });
	  },
	  getAsnShipppingPallets: function getAsnShipppingPallets(asn) {
	    return AsnShippingPalletStore.where({ asnId: asn.id });
	  },
	  isPickupTimeRangeValid: function isPickupTimeRangeValid(asn) {
	    return (0, _general.convertMilitaryToInt)(asn.pickupTimeFrom) < (0, _general.convertMilitaryToInt)(asn.pickupTimeTo);
	  },
	  getAsns: function getAsns() {
	    return asns;
	  },
	  getAsn: function getAsn(id) {
	    return asns[id];
	  },
	  getAllGeneralData: function getAllGeneralData() {
	    return general;
	  }
	});
	
	function filterQuoteAvailableOrSelectedForAsn(quote) {
	  var asn = this;
	  return (quote.asnId === asn.id || asn.quoteId === quote.quoteId && asn.optionId === quote.optionId) && quote.estimatedCost != '';
	}
	
	window.AsnStore = AsnStore;
	exports.default = AsnStore;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _objectAssign = __webpack_require__(107);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditChecker = createEditChecker();
	
	function createEditChecker() {
		var pageIsDirty = false;
	
		var elementsMap = {
			menu: "#side-menu",
			dockbar: "#_145_dockbar"
		};
	
		var els = {};
	
		var buttonClass = "purple-btn";
	
		var modal = (0, _jquery2.default)();
	
		var checker = (0, _objectAssign2.default)({
			isDirty: function isDirty() {
				return pageIsDirty;
			},
			setPageDirty: function setPageDirty() {
				pageIsDirty = true;
			},
			setPageClean: function setPageClean() {
				pageIsDirty = false;
			},
			setButtonClass: function setButtonClass(cls) {
				buttonClass = cls;
			},
			bindNavigation: function bindNavigation() {
				//Setup event listeners for various page elements
				(0, _selectorHelpers.setElementsFromScope)(els, elementsMap, (0, _jquery2.default)(document));
	
				els.menu.on("click", ".nav-redirect-link", handleNavigationEvent);
				els.dockbar.on("click", ".dropdown-menu a", handleNavigationEvent);
	
				//Fallback to browser handling if click event is not caught
				(0, _jquery2.default)(window).bind('beforeunload', function () {
					if (pageIsDirty) return 'There is unsaved data on this page, are you sure you want to leave?';
				});
			},
			bindCustomNavigation: function bindCustomNavigation(parent, event, selector) {
				(0, _jquery2.default)(parent).on(event, selector, handleNavigationEvent);
			},
			bindChangeListener: function bindChangeListener(selector) {
				var self = this;
				(0, _jquery2.default)(selector).on("change", function (e) {
					handleChangeListener();
				});
			},
			bindCancelButton: function bindCancelButton(selector) {
				var self = this;
				(0, _jquery2.default)(selector).on("click", function (e) {
					e.preventDefault();
	
					if (!(0, _jquery2.default)(this).hasClass('disabled')) {
						self.showCancelModal({
							redirectUrl: (0, _jquery2.default)(this).data("edit-checker-redirect")
						});
					}
				});
			},
			showCancelModal: function showCancelModal() {
				var spec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
				var defaultSpec = {
					title: "Cancel",
					body: "<div class='q-marg-all-xl'>Are you sure you'd like to cancel? Your work will not be saved.</div>",
					allowButton: "Leave Page",
					denyButton: "Stay"
				};
	
				var options = _jquery2.default.extend({}, defaultSpec, spec);
	
				this.showModal(options);
			},
			showModal: function showModal() {
				var spec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
				var self = this;
				var defaultSpec = {
					title: "Unsaved Information",
					body: "<div class='q-marg-all-xl'>By leaving this page, you will lose all unsaved work. Would you like to continue?</div>",
					allowButton: "Leave Page",
					denyButton: "Stay",
					btnClass: buttonClass
				};
	
				var options = _jquery2.default.extend({}, defaultSpec, spec);
	
				if (this.isDirty()) {
					if (options.isDirtyCallback && typeof options.isDirtyCallback === "function") {
						options.isDirtyCallback();
					}
	
					generateModal(options);
					modal.modal('show');
	
					modal.on("click", ".allow-navigation-btn", function () {
						self.setPageClean();
						if (options.allowCallback && typeof options.allowCallback === "function") {
							options.allowCallback();
						}
	
						if (options.redirectUrl) {
							window.location.href = options.redirectUrl;
						}
					});
	
					modal.on("click", ".deny-navigation-btn", function () {
						self.hideModal();
						if (options.denyCallback && typeof options.denyCallback === "function") {
							options.denyCallback();
						}
					});
				} else {
					if (options.allowCallback && typeof options.allowCallback === "function") {
						options.allowCallback();
					}
	
					if (options.redirectUrl) {
						window.location.href = options.redirectUrl;
					}
				}
			},
			hideModal: function hideModal() {
				modal.modal('hide');
			}
		});
	
		function generateModal(options) {
			modal.remove();
			var modalBtns = "<button type=\"button\" class=\"base-btn v2-btn " + options.btnClass + " allow-navigation-btn\">" + options.allowButton + "</button>\n\t\t                    <button type=\"button\" class=\"base-btn " + options.btnClass + " deny-navigation-btn\">" + options.denyButton + "</button>";
			options.footerBtns = modalBtns;
			modal = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(11), options));
			(0, _jquery2.default)("body").append(modal);
		};
	
		function handleNavigationEvent(e) {
			if (pageIsDirty) {
				e.preventDefault();
				checker.showModal({
					redirectUrl: (0, _jquery2.default)(this).attr("href")
				});
			}
		}
	
		function handleChangeListener() {
			checker.setPageDirty();
		}
	
		return checker;
	}
	
	window.EditChecker = EditChecker;
	exports.default = EditChecker;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.pillStatusClasses = undefined;
	exports.alterSearchCriteriForController = alterSearchCriteriForController;
	exports.readSpecificKeyFromSearchCriteria = readSpecificKeyFromSearchCriteria;
	exports.pushFilterSessionCacheState = pushFilterSessionCacheState;
	exports.retriveCriteriaObjectByKey = retriveCriteriaObjectByKey;
	exports.retriveCriteriaObjectByOperation = retriveCriteriaObjectByOperation;
	exports.doAjax = doAjax;
	exports.isNew = isNew;
	exports.readSpecificObjectFromCurrentData = readSpecificObjectFromCurrentData;
	exports.isEdit = isEdit;
	exports.isOnlyLookupDataUpdate = isOnlyLookupDataUpdate;
	exports.isDeleteView = isDeleteView;
	exports.prepareDataToSendController = prepareDataToSendController;
	exports.statusPillRender = statusPillRender;
	exports.removeSpecificObjectFromSearchCriteria = removeSpecificObjectFromSearchCriteria;
	exports.buildExport = buildExport;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _ = __webpack_require__(2);
	
	var modalHtml = __webpack_require__(11);
	var modalBodyHtml = __webpack_require__(1467);
	var modalFooterHtml = __webpack_require__(1468);
	
	function alterSearchCriteriForController(searchCriteria) {
		// This omit is require cause, lookup component is adding below information in searchCriteria which was not the case earlier,
		// so instead change controller side code beeter to send what contrller is expecting.
		var revisedSearchCriteria = _.omit(searchCriteria, function (value, key, object) {
			return value.key == 'fixedRange' || value.key == 'startDate' || value.key == 'endDate';
		});
		return _.toArray(revisedSearchCriteria);
	}
	
	function readSpecificKeyFromSearchCriteria(searchCriteria, key) {
		var value = "";
		_jquery2.default.each(searchCriteria, function (i, item) {
			if (item.key == key) {
				value = item.value[0];
			}
		});
		return value;
	}
	
	function pushFilterSessionCacheState() {
		if (history.pushState) {
			var filterTime = new Date().getTime();
			history.pushState(null, null, '?filterApply=' + filterTime);
		}
	}
	
	function retriveCriteriaObjectByKey(searchCriteria, key) {
		var targetObj = "";
		_jquery2.default.each(searchCriteria, function (i, item) {
			if (item.key == key) {
				targetObj = item;
			}
		});
		return targetObj;
	}
	
	function retriveCriteriaObjectByOperation(searchCriteria, operationName) {
		var targetObj = "";
		_jquery2.default.each(searchCriteria, function (i, item) {
			if (item.operation == operationName) {
				targetObj = item;
			}
		});
		return targetObj;
	}
	
	function doAjax(_ref) {
		var url = _ref.url,
		    success = _ref.success,
		    error = _ref.error,
		    data = _ref.data;
	
		_jquery2.default.ajax({
			data: data,
			url: url,
			type: 'POST',
			dataType: "json",
			success: success,
			error: error,
			async: false
		});
	}
	
	function isNew(data) {
		var isNewView = false;
		if (data.savedViewTarget == "newSavedView") {
			isNewView = true;
		}
		return isNewView;
	}
	
	function readSpecificObjectFromCurrentData(data, keyToRead) {
		return data.keyToRead;
	}
	
	function isEdit(data) {
		return data.updateView && data.savedViewTarget != "newSavedView";
	}
	
	function isOnlyLookupDataUpdate(data) {
		return !data.updateView && !(0, _general.isPresent)(data.deletedView);
	}
	
	function isDeleteView(data) {
		return (0, _general.isPresent)(data.deletedView);
	}
	
	function prepareDataToSendController(currentData, portletNamespace) {
		var _data;
	
		var startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"], 'startDate');
		var endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"], 'endDate');
		var fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"], 'fixedRange');
		var revisedSearchCriteria = alterSearchCriteriForController(currentData["searchCriteria"]);
		portletNamespace = (0, _general.isPresent)(portletNamespace) ? portletNamespace : "";
		var data = (_data = {}, _defineProperty(_data, portletNamespace + "savedViewTarget", currentData.savedViewTarget), _defineProperty(_data, portletNamespace + "savedViewName", currentData.savedViewTitle), _defineProperty(_data, portletNamespace + "columns", JSON.stringify(currentData.targetColumns)), _defineProperty(_data, portletNamespace + "page", currentData["number"]), _defineProperty(_data, portletNamespace + "size", currentData["size"]), _defineProperty(_data, portletNamespace + "orderByType", currentData["orderByType"]), _defineProperty(_data, portletNamespace + "orderBy", currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"]), _defineProperty(_data, portletNamespace + "sortType", currentData["sortType"]), _defineProperty(_data, portletNamespace + "sortField", currentData["sortField"]), _defineProperty(_data, portletNamespace + "searchCriteria", JSON.stringify(revisedSearchCriteria)), _defineProperty(_data, portletNamespace + "fixedRange", fixedRangeDate), _defineProperty(_data, portletNamespace + "startDate", startDate), _defineProperty(_data, portletNamespace + "endDate", endDate), _defineProperty(_data, portletNamespace + "deleteViewTarget", isDeleteView(currentData) ? currentData.deletedView.target : ""), _data);
		//Exposing this variable so that we can check/debug at anytime in any environment 	
		window.prepareDataObj = data;
		return data;
	}
	
	//Below is resuable pills class , we can only use if your status from DB you want to display as it is , if there are any business logic around of it like if status is "Pending" you want to display "All pending" in this case , this fun.
	// wont help.
	var statusPillRenderTemplate = __webpack_require__(187);
	
	// Just keep adding your status and class here and use statusPillRender method in columns render method.
	var pillStatusClasses = exports.pillStatusClasses = {
		"default": "q-pill-white-and-grey",
		"Error": "q-pill-red",
		"In Process": "q-pill-blue-border",
		"Released": "q-pill-blue-border",
		"Shipped": "q-pill-blue",
		"Partially Shipped": "q-pill-blue-border",
		"Canceled": "q-pill-light-grey",
		"Held": "q-pill-blue-border",
		"Cancel Pending": "q-pill-light-grey",
		"Hold Pending": "q-pill-blue-border",
		"Pending": " q-pill-blue-border",
		"Backordered": "q-pill-red",
		"Partially Released": "q-pill-blue-border",
		"Self Fulfill": "q-pill-blue",
		"Complete": "q-pill-green",
		"Delivered": "q-pill-green",
		"Planned": "q-pill-blue-border",
		"In Transit": "q-pill-blue-border",
		"Receiving": "q-pill-green-border",
		"Out of Stock": "q-pill-red",
		"Low Stock": "q-pill-orange",
		"Active": "q-pill-blue",
		"Inactive": "q-pill-light-grey",
		"Created": "q-pill-blue-border"
	};
	
	function statusPillRender(data, type, row) {
		var newRender = void 0;
		var pillClass = pillStatusClasses[data] || pillStatusClasses.default;
		return newRender = (0, _render2.default)(statusPillRenderTemplate, {
			data: data,
			pillClass: pillClass
		});
	}
	
	function removeSpecificObjectFromSearchCriteria(searchCriteria, key) {
		var targetObj = "";
		_jquery2.default.each(searchCriteria, function (i, item) {
			if (item.key == key) {
				targetObj = _.without(searchCriteria, item);
			}
		});
		return targetObj;
	}
	
	function buildExport() {
		var self = this;
		var url = "";
		var exportModal = void 0;
	
		self.init = function (exportObj) {
			var title = exportObj.title,
			    cssClassNameForCount = exportObj.cssClassNameForCount,
			    exportAttemptTextPart1Lang = exportObj.exportAttemptTextPart1Lang,
			    exportAttemptTextPart2Lang = exportObj.exportAttemptTextPart2Lang,
			    exportMaxLimitLang = exportObj.exportMaxLimitLang,
			    cssClassNameForExportButtonOnPage = exportObj.cssClassNameForExportButtonOnPage,
			    cssClassNameForExportButtonOnPopup = exportObj.cssClassNameForExportButtonOnPopup,
			    cssClassNameForSelectFileTypeOnPopup = exportObj.cssClassNameForSelectFileTypeOnPopup;
	
			var insertTarget = 'body';
			var buildExportModalBody = function buildExportModalBody() {
				var exportModalBody = (0, _render2.default)(modalBodyHtml, {
					exportAttemptTextPart1Lang: exportAttemptTextPart1Lang,
					exportAttemptTextPart2Lang: exportAttemptTextPart2Lang,
					exportMaxLimitLang: exportMaxLimitLang,
					totalRows: 0,
					cssClassNameForSelectFileTypeOnPopup: cssClassNameForSelectFileTypeOnPopup,
					cssClassNameForCount: cssClassNameForCount
				});
				return exportModalBody;
			};
	
			var buildExportModalFooter = function buildExportModalFooter() {
				var exportModalFooter = (0, _render2.default)(modalFooterHtml, {
					cssClassNameForExportButtonOnPopup: cssClassNameForExportButtonOnPopup
				});
				return exportModalFooter;
			};
	
			exportModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
				title: title,
				leftAlignTitle: true,
				topCloseBtn: true,
				autoHideTop: true,
				staticBackdrop: false,
				body: buildExportModalBody(),
				footerBtns: buildExportModalFooter()
			}));
	
			(0, _jquery2.default)(insertTarget).append(exportModal);
	
			//exportBtn -  is the css class which present "Export" button on your page.
			var exportBtn = (0, _general.isPresent)(cssClassNameForExportButtonOnPage) ? "." + cssClassNameForExportButtonOnPage : ".exportData";
			//selectFileTypeCls -  is the class of the select drop down where you select file type PDF and CSV.
			var selectFileTypeCls = (0, _general.isPresent)(cssClassNameForSelectFileTypeOnPopup) ? "." + cssClassNameForSelectFileTypeOnPopup : ".dataFileType";
			// modalExportBtnCls- is the css class which present "Export" button on export popup.
			var modalExportBtnCls = (0, _general.isPresent)(cssClassNameForExportButtonOnPopup) ? "." + cssClassNameForExportButtonOnPopup : ".modalExportData";
	
			(0, _jquery2.default)(document).on('click', exportBtn, function () {
				exportModal.modal('show');
			});
	
			//    $(exportBtn).click(function() {
			//     exportModal.modal('show');
			// });
	
	
			(0, _jquery2.default)(document).on('change', selectFileTypeCls, function () {
				(0, _jquery2.default)(modalExportBtnCls).attr('disabled', false);
			});
		};
	
		self.buildExportBasicURL = function (resourceURL, currentData, portletNamespace) {
			var startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"], 'startDate');
			var endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"], 'endDate');
			var fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"], 'fixedRange');
			var revisedSearchCriteria = alterSearchCriteriForController(currentData["searchCriteria"]);
			var orderBy = currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"];
			var searchCriteria = _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);
	
			//Ampersand in search criteria data was causing URL parsing issues on server side
			searchCriteria = encodeURIComponent(searchCriteria);
	
			portletNamespace = (0, _general.isPresent)(portletNamespace) ? portletNamespace : "";
			//url = resourceURL+"&endDate="+endDate+"&startDate="+startDate+"&fixedRange="+fixedRangeDate+"&page=0"+"&size=1000"+"&orderBy="+orderBy+"&orderByType="+currentData["sortType"]+"&searchCriteria="+searchCriteria;
			url = resourceURL + ["&" + portletNamespace + "endDate="] + endDate + ["&" + portletNamespace + "startDate="] + startDate + ["&" + portletNamespace + "fixedRange="] + fixedRangeDate + ["&" + portletNamespace + "page=0&" + portletNamespace + "size=1000&" + portletNamespace + "orderBy"] + orderBy + ["&" + portletNamespace + "orderByType="] + currentData["sortType"] + ["&" + portletNamespace + "searchCriteria="] + searchCriteria;
		};
		//changes for 7674 
		self.buildExportCustomBasicURL = function (resourceURL, currentData, portletNamespace) {
			url = resourceURL;
		};
	
		self.getCurrentUrl = function () {
			return url;
		};
	
		self.bindExportEvent = function (portletNamespace, cssClassNameForExportButtonOnPopup, cssClassNameForSelectFileTypeOnPopup) {
			//optionalClass = isPresent(optionalClass) ? optionalClass : '.modalExportData';
			//dataFileType = isPresent(dataFileType) ? `${dataFileType} :selected` : '.dataFileType :selected';
			var selectFileTypeCls = (0, _general.isPresent)(cssClassNameForSelectFileTypeOnPopup) ? "." + cssClassNameForSelectFileTypeOnPopup + " :selected" : ".dataFileType :selected";
			var modalExportBtnCls = (0, _general.isPresent)(cssClassNameForExportButtonOnPopup) ? "." + cssClassNameForExportButtonOnPopup : ".modalExportData";
			(0, _jquery2.default)(document).on('click', modalExportBtnCls, function () {
				var fileType = (0, _jquery2.default)(selectFileTypeCls).val();
				portletNamespace = (0, _general.isPresent)(portletNamespace) ? portletNamespace : "";
				var finalURL = url + ["&" + portletNamespace + "fileType="] + fileType;
				doExport(finalURL);
				exportModal.modal("hide");
			});
		};
	
		self.setExportCount = function (exportCount, cssClassNameForCount) {
			var rowCountCss = (0, _general.isPresent)(cssClassNameForCount) ? "." + cssClassNameForCount : ".row-count";
			(0, _jquery2.default)(rowCountCss).html(exportCount);
		};
	
		function doExport(url) {
			window.open(url);
		}
	}

/***/ },
/* 17 */,
/* 18 */,
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = LookupTable;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _select2able = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var $ = __webpack_require__(1);
	
	__webpack_require__(1069);
	
	var elementsMap = {
	  manageViewBtn: ".js-manage-view-modal-open",
	  prevBtn: ".js-prev-page",
	  nextBtn: ".js-next-page",
	  pageDataInfo: ".page-data-info",
	  searchInput: ".search-input",
	  searchInputBtn: ".search-icon",
	  searchInputDropdown: ".search-input-dropdown",
	  perPageInput: ".total-per-page",
	  loadingOverlay: ".table-loading-overlay",
	  tableOrderHeaderTargets: "th:not(.sorting_disabled)",
	  bulkSelectorHeader: ".lookup-bulk-select-thead",
	  bulkSelectorsTbody: ".lookup-bulk-select-tbody",
	  noDataErrorMsgWrap: ".data-table-error-msg-wrap",
	  savedSearchLink: ".saved-search-link",
	  savedSearchDropdown: "#savedSearch",
	  newSavedViewBtn: ".new-saved-view-btn",
	  savedSearchContainer: ".saved-search-section",
	  filterBarContainer: ".applied-filter-section",
	  appliedFilterPills: ".applied-filter-pills",
	  pillFilter: ".pill-filter",
	  deletePillFilterBtn: ".delete-pill-filter"
	};
	
	var manageViewModalElementsMap = {
	  applyViewBtn: ".js-apply-view",
	  parentInput: ".filter-modal-input",
	  dateRangeInputs: ".func-date-range-input",
	  toggleColumnInput: ".column-modal-input",
	  dateRangeStart: ".func-date-range-input#startDate",
	  dateRangeEnd: ".func-date-range-input#endDate",
	  manageViewModalForm: ".manageViewModalForm",
	  btnTabTrigger: ".btn-tab-trigger",
	  topCloseBtn: ".top-close-btn",
	  manageModalCancelBtn: ".js-manage-modal-cancel",
	  deleteSavedViewBtn: ".js-delete-saved-view",
	  manageViewNameInput: '.manage-view-name'
	};
	
	var modalHtml = __webpack_require__(11);
	var defaultDesktopHtml = __webpack_require__(1161);
	var mobileWithTitleHtml = __webpack_require__(1168);
	var baseHtml = __webpack_require__(1156);
	var bulkSelectTemplateHtml = __webpack_require__(1158);
	var perPageSelectHtml = __webpack_require__(1175);
	var pageNavigationHtml = __webpack_require__(1174);
	var pageDataInfoHtml = __webpack_require__(1173);
	var columnModalCheckboxHtml = __webpack_require__(1160);
	var filterGroupCheckboxHtml = __webpack_require__(1162);
	var filterGroupRadioHtml = __webpack_require__(1164);
	var filterGroupDateRangeHtml = __webpack_require__(1163);
	var filterModalBodyGroupHtml = __webpack_require__(1165);
	var childFiltersWrapHtml = __webpack_require__(1159);
	var btnSectionHtml = __webpack_require__(1157);
	var searchInputHtml = __webpack_require__(1177);
	var searchDropdownOptionHtml = __webpack_require__(1176);
	var noDataAlertHtml = __webpack_require__(1172);
	var savedSearchBarListWrapHtml = __webpack_require__(1169);
	var savedSearchBarLinkHtml = __webpack_require__(1170);
	var savedSearchBarOptionHtml = __webpack_require__(1171);
	var appliedFilterBarHtml = __webpack_require__(1155);
	var manageViewModalBodyHtml = __webpack_require__(1167);
	var filterPillTemplateHtml = __webpack_require__(1166);
	
	var buildFilterModalInputListConfig = {
	  checkbox: filterGroupCheckboxHtml,
	  radio: filterGroupRadioHtml,
	  dateRange: filterGroupDateRangeHtml
	};
	
	function LookupTable() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  //Create sorting type of noop so that sorting doesnt happen
	  $.fn.dataTable.ext.order['noop'] = function (settings, col) {
	    return this.api().column(col, { order: 'index' }).data().map(function () {
	      return null;
	    });
	  };
	
	  var self = this;
	  var tableWrapEl = void 0,
	      tableEl = void 0,
	      responsiveTable = void 0,
	      noDataErrorMsg = void 0,
	      manageViewModal = void 0;
	  var els = {};
	  var manageViewModalEls = {};
	  // Currently set to md breakpoint
	  var isMobile = window.innerWidth < 991;
	  var firstRender = true;
	  var pillFilter = void 0;
	  var updateView = false;
	  var date = new Date();
	  var validator = void 0;
	  var deletedView = void 0;
	  var bulkSelectObj = {
	    data: "select",
	    title: "Select",
	    render: renderSelect
	  };
	
	  var bulkSelectModalColumn = {
	    data: "select",
	    title: "Bulk Select",
	    active: true,
	    canToggle: false
	
	    // Sets default options, overridden by user defined ones.
	  };var opts = (0, _general.merge)(options, {
	    // NOTE: Merge does not seem to work on direct 'key: "string"' pairs.
	    dataTable: {
	      dom: "t",
	      paging: false,
	      ordering: true,
	      info: false,
	      autoWidth: false
	    }
	  });
	
	  if (_underscore2.default.isUndefined(opts.tableSearch)) {
	    opts.tableSearch = true;
	  }
	  opts.newViewIndexOverride = opts.newViewIndexOverride ? opts.newViewIndexOverride : 0;
	
	  var pageNumberTarget = currentPageNumber();
	
	  var dataTableOpts = opts.dataTable;
	
	  var validationOpts = {
	    debug: true,
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  };
	
	  addSavedStateBulkSelect();
	
	  if (opts.bulkSelect === true) {
	    opts.dataTable.columns.unshift(bulkSelectObj);
	
	    opts.dataTable.columnDefs.push({
	      className: "select-for-bulk-upload",
	      targets: [0],
	      orderable: false,
	      width: "50px"
	    });
	  }
	
	  function renderSelect(data, type, row, meta) {
	    return (0, _render2.default)(bulkSelectTemplateHtml, {
	      value: meta.row,
	      placement: "tbody"
	    });
	  }
	
	  // Function to add a render function to each column if user-defined one doesn't exist
	  opts.dataTable.columns = (0, _underscore2.default)(opts.dataTable.columns).map(function (columnConfig) {
	    var render = columnConfig.render;
	    columnConfig = _underscore2.default.extend(columnConfig, {
	      render: smartRenderRow(render),
	      //Set the default sorting to new sort type of noop to prevent data table sorting implementation
	      orderDataType: "noop"
	    });
	    return columnConfig;
	  });
	
	  function defaultDesktopRender(data, type, row) {
	    return data;
	  }
	
	  // Exposed Functions
	
	  self.init = function () {
	    buildHtml();
	    setElements();
	    bindElements();
	    setPaginationData(opts.paginationData);
	    handleWindowResize();
	    toggleFilterModalChildInput();
	    handleDisabledBtns();
	  };
	
	  self.generateData = function () {
	    return generateData();
	  };
	
	  self.setNewData = function (data) {
	    setNewData(data);
	  };
	
	  self.setPaginationData = function (data) {
	    setPaginationData(data);
	  };
	
	  self.getBulkSelectedData = function () {
	    return getBulkSelectedData();
	  };
	
	  self.onBulkSelectChange = function () {
	    onBulkSelectChange();
	  };
	
	  self.showLoadingOverlay = function () {
	    showLoadingOverlay();
	  };
	
	  self.hideLoadingOverlay = function () {
	    hideLoadingOverlay();
	  };
	
	  self.setNewSavedViewData = function (newSearchData, dataTarget) {
	    setNewSavedViewData(newSearchData, dataTarget);
	  };
	
	  self.removeSavedView = function (target) {
	    removeSavedView(target);
	  };
	
	  self.uncheckAllSelected = function () {
	    uncheckAllSelected();
	  };
	
	  function bindElements() {
	    els.nextBtn.on('click', handlePageNavNext);
	    els.prevBtn.on('click', handlePageNavPrev);
	    tableWrapEl.on('click', elementsMap.manageViewBtn, onManageViewBtnClick);
	    els.searchInput.on('keyup', onSearchEnter);
	    els.searchInputBtn.on('click', resetPageThenFetch);
	    els.perPageInput.on('change', resetPageThenFetch);
	    els.bulkSelectorsTbody.on('change', onBulkSelectChange);
	    manageViewModal.on('click', manageViewModalElementsMap.applyViewBtn, onManageViewApplyClick);
	    // manageViewModal.on('change', manageViewModalElementsMap.toggleColumnInput, toggleVisibleColumn);
	    manageViewModal.on('change', manageViewModalElementsMap.parentInput, toggleFilterModalChildInput);
	    tableWrapEl.on('click', elementsMap.savedSearchLink, onSavedSearchClick);
	    tableEl.on('click', elementsMap.tableOrderHeaderTargets, onOrderTableHeaderClick);
	    tableEl.on('change', elementsMap.bulkSelectorHeader, handleAllBulkSelectsChange);
	    tableEl.on('change', elementsMap.bulkSelectorsTbody, onBulkSelectChange);
	    tableWrapEl.on('change', elementsMap.savedSearchDropdown, onSavedSearchClick);
	    manageViewModal.on('click', manageViewModalElementsMap.topCloseBtn, onManageViewCancelClick);
	    manageViewModal.on('click', manageViewModalElementsMap.manageModalCancelBtn, onManageViewCancelClick);
	    tableWrapEl.on('click', elementsMap.newSavedViewBtn, onNewSavedSearchClick);
	    manageViewModal.on('click', manageViewModalElementsMap.deleteSavedViewBtn, onDeleteSavedViewClick);
	    tableWrapEl.on('click', elementsMap.deletePillFilterBtn, onDeletePillFilterClick);
	    // Look at the button tab trigger function to make a component later...
	    manageViewModal.on('click', manageViewModalElementsMap.btnTabTrigger, toggleShownTab);
	    bindManageModalBody();
	  }
	
	  function buildHtml() {
	    var initialModalBody = void 0;
	    var initialModalButtons = void 0;
	    var hasTableSearch = true;
	    if (opts.tableSearch === false) {
	      hasTableSearch = false;
	    }
	    if (opts.savedViews && opts.savedViews.length >= 1) {
	      pillFilter = true;
	      var targetView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	      initialModalBody = buildManageModalBody(targetView.filters, targetView.columns, targetView.title, targetView.target);
	      initialModalButtons = "\n        <a href=\"#\" class=\"base-btn v2-btn js-manage-modal-cancel\">Cancel</a>\n        <a href=\"#\" class=\"base-btn v2-btn js-delete-saved-view\">Delete View</a>\n        <a href=\"#\" class=\"base-btn purple-btn js-apply-view\">Save View</a>\n      ";
	    } else {
	      initialModalBody = buildManageModalBody(opts.tableFilters.data, opts.tableColumnModal.data);
	      initialModalButtons = "\n        <a href=\"#\" class=\"base-btn v2-btn js-manage-modal-cancel\">Cancel</a>\n        <a href=\"#\" class=\"base-btn purple-btn js-apply-view\">Save Filters</a>\n       ";
	    }
	
	    var searchPlaceholder = "Enter your search here...";
	    var searchInput = "";
	    if (opts.tableSearchInput) {
	      searchPlaceholder = opts.tableSearchInput.placeholder;
	      searchInput = opts.tableSearchInput.value;
	    }
	    tableWrapEl = $((0, _render2.default)(baseHtml, {
	      tableSearch: hasTableSearch,
	      searchInput: (0, _render2.default)(searchInputHtml, {
	        dropDownOptions: setSearchDropdownOptions(),
	        searchInputPlaceholder: searchPlaceholder,
	        searchInputValue: searchInput
	      }),
	      savedSearchBar: renderSavedSearchSection(opts.savedViews),
	      appliedFilterBar: renderAppliedFilterBar(),
	      btnSectionHtml: btnSectionHtml,
	      perPageSelectHtml: perPageSelectHtml,
	      pageDataInfo: (0, _render2.default)(pageDataInfoHtml, {
	        pageData: buildPageInfoText()
	      }),
	      pageNavigation: (0, _render2.default)(pageNavigationHtml, {
	        nextPage: nextPageNumber(),
	        prevPage: prevPageNumber()
	      })
	    }));
	    manageViewModal = $((0, _render2.default)(modalHtml, {
	      title: "Manage View",
	      leftAlignTitle: true,
	      topCloseBtn: true,
	      autoHideTop: false,
	      staticBackdrop: true,
	      body: initialModalBody,
	      footerBtns: initialModalButtons
	    }));
	    $('body').append(manageViewModal);
	    $(opts.target).html(tableWrapEl);
	    tableWrapEl.find(elementsMap.appliedFilterPills).html(renderAppliedFilterPills());
	    tableEl = tableWrapEl.find('.data-table-component');
	    noDataErrorMsg = tableWrapEl.find(elementsMap.noDataErrorMsgWrap);
	    responsiveTable = tableEl.dataTable(_extends({}, dataTableOpts));
	    responsiveTable.find(".select-for-bulk-upload").html(renderBulkSelectHeader());
	    noDataErrorMsg.html(getNoDataAlert());
	    // If this if block doesn't run, dropdown will default to first value
	    // This needs to run after HTML of dropdown and input is rendered
	    if (opts.tableSearch && opts.tableSearchDropdown.selected) {
	      $(elementsMap.searchInputDropdown).val(opts.tableSearchDropdown.selected).trigger("change.select2");
	    }
	  }
	
	  function renderBulkSelectHeader() {
	    return (0, _render2.default)(bulkSelectTemplateHtml, {
	      value: "header",
	      rowObj: "",
	      placement: "thead"
	    });
	  }
	
	  function getNoDataAlert() {
	    return (0, _render2.default)(noDataAlertHtml);
	  }
	
	  function checkForHasData() {
	    // NOTE: this looks for "totalElements" in paginationData in the object
	    if (!hasTableData()) {
	      responsiveTable.addClass("q-display-none");
	      noDataErrorMsg.removeClass("q-display-none");
	    } else {
	      responsiveTable.removeClass("q-display-none");
	      noDataErrorMsg.addClass("q-display-none");
	    }
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, tableWrapEl);
	    (0, _selectorHelpers.setElementsFromScope)(manageViewModalEls, manageViewModalElementsMap, manageViewModal);
	  }
	
	  function smartRenderRow(func) {
	    return function (data, type, row, meta) {
	      if (isMobile) {
	        return handleMobileRender(data, type, row);
	      } else {
	        if (func) {
	          return func(data, type, row, meta);
	        } else {
	          return handleDesktopRender(data, type, row, meta);
	        }
	      }
	    };
	  }
	
	  $(window).on('resize', _underscore2.default.debounce(handleWindowResize));
	
	  function handleWindowResize() {
	    if (window.innerWidth < 991 && (!isMobile || firstRender)) {
	      isMobile = true;
	      _underscore2.default.each(dataTableOpts.columns, function (obj, i) {
	        hideColumnsForMobile(obj, i);
	      });
	      responsiveTable.api().rows().invalidate();
	      responsiveTable.api().draw(false);
	    } else if (window.innerWidth >= 991 && (isMobile || firstRender)) {
	      isMobile = false;
	      setVisibleColumns();
	      responsiveTable.api().rows().invalidate();
	      responsiveTable.api().draw(false);
	    }
	    firstRender = false;
	  }
	
	  function hideColumnsForMobile(obj, i) {
	    if (i === 0) {
	      responsiveTable.api().columns(i).visible(true);
	    } else {
	      responsiveTable.api().columns(i).visible(false);
	    }
	  }
	
	  function handleMobileRender(data, type, row) {
	    var newData = (0, _underscore2.default)(opts.mobileColumns).map(function (config) {
	      if (config.render) {
	        // Remap the given row's data based on current mobile columns
	        // data key. Because of this, we are making the assumption that
	        // mobile columns will never exceed the number of desktop columns.
	
	        // Make sure 'type' is mapped correctly, based on row
	        return config.render(row[config.data], type, row);
	      } else {
	        return handleDefaultMobileColumnRender(config, data, type, row);
	      }
	    });
	    if (els.bulkSelectorHeader && opts.bulkSelect === true) {
	      els.bulkSelectorHeader.prop("checked", false);
	    }
	    return newData.join('');
	  }
	
	  function handleDefaultMobileColumnRender(config, data, type, row) {
	    var link = void 0;
	    var linkConfig = row[config.linkKey];
	    if (linkConfig && config.data === linkConfig.data) {
	      link = row[config.linkKey].link;
	    }
	    var item = {
	      content: row[config.data],
	      label: config.title,
	      link: link
	    };
	    return buildMobileData(item);
	  }
	
	  function handleDesktopRender(data, type, row, meta) {
	    var link = void 0;
	    var columnTarget = opts.dataTable.columns[meta.col].data;
	    var linkObj = row[opts.dataTable.columns[meta.col].linkKey];
	    if (linkObj !== undefined && columnTarget === linkObj.data) {
	      link = linkObj.link;
	    }
	    var item = {
	      content: data,
	      link: link
	    };
	    return buildDesktopData(item);
	  }
	
	  function buildDesktopData(item) {
	    var newCell = (0, _render2.default)(defaultDesktopHtml, item);
	    return newCell;
	  }
	
	  function buildMobileData(item) {
	    var newCell = (0, _render2.default)(mobileWithTitleHtml, item);
	    return newCell;
	  }
	
	  function onFetch() {
	    options.onFetch && options.onFetch();
	    responsiveTable.api().draw(false);
	    if (opts.savedViews && opts.savedViews.length >= 1) {
	      pillFilter = true;
	      updateView = false;
	    }
	    deletedView = '';
	  }
	
	  function resetPageThenFetch() {
	    pageNumberTarget = 0;
	    onFetch();
	  }
	
	  function handlePageNavNext(e) {
	    e.preventDefault();
	    var btnEl = $(this);
	    if (!btnEl.hasClass('disabled')) {
	      pageNumberTarget = nextPageNumber();
	      onFetch();
	    }
	  }
	
	  function handlePageNavPrev(e) {
	    e.preventDefault();
	    var btnEl = $(this);
	    if (!btnEl.hasClass('disabled')) {
	      pageNumberTarget = prevPageNumber();
	      onFetch();
	    }
	  }
	
	  function generateData() {
	    var targetView = void 0;
	    var savedViewTarget = void 0;
	    var savedViewTitle = void 0;
	    var targetColumns = void 0;
	    if (opts.savedViews && opts.savedViews.length >= 1) {
	      targetView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	      targetColumns = targetView.columns;
	      savedViewTarget = targetView.target;
	      savedViewTitle = targetView.title;
	    } else {
	      targetColumns = opts.tableColumnModal.data;
	    }
	    if (opts.bulkSelect === true && targetColumns[0].title === "Bulk Select") {
	      targetColumns.shift();
	    };
	    // appliedFilterPills: ".applied-filter-pills",
	    // pillFilter: ".pill-filter",
	    //
	    var filterDataArray = void 0;
	    if (!pillFilter) {
	      filterDataArray = getFilterModalData(manageViewModal, '.manage-filter-list input:checked, .manage-filter-list input[type="text"]');
	    } else {
	      filterDataArray = getFilterModalData($(elementsMap.appliedFilterPills), elementsMap.pillFilter);
	    }
	    var searchData = getSearchData();
	    var searchCriteria = [searchData].concat(_toConsumableArray(filterDataArray));
	    searchCriteria = (0, _underscore2.default)(searchCriteria).filter(function (filterData) {
	      return filterData && _underscore2.default.has(filterData, "key") && _underscore2.default.has(filterData, "operation") && _underscore2.default.has(filterData, "value");
	    });
	    var tableData = _extends({
	      searchCriteria: searchCriteria,
	      size: getItemsPerPageData(),
	      number: pageNumberTarget,
	      totalElements: totalResults()
	    }, generateOrderData(), {
	      targetColumns: [].concat(_toConsumableArray(targetColumns)),
	      savedViewTarget: savedViewTarget,
	      savedViewTitle: savedViewTitle,
	      deletedView: deletedView,
	      updateView: updateView
	    });
	    addSavedStateBulkSelect();
	    return tableData;
	  }
	
	  function generateOrderData() {
	    var orderData = {};
	    // IF USING DATATABLES SORTING
	    var order = responsiveTable.api().order();
	    var sortColumnIdx = order[0][0];
	    orderData.sortField = opts.dataTable.columns[sortColumnIdx].data;
	    orderData.sortType = order[0][1];
	    orderData.orderBy = orderData.sortField;
	    orderData.orderByType = orderData.sortType;
	
	    return orderData;
	  }
	
	  function setNewData(data) {
	    if (opts.bulkSelect === true) {
	      els.bulkSelectorHeader.prop("checked", false);
	    }
	    responsiveTable.fnClearTable();
	    if (data.length > 0) {
	      responsiveTable.fnAddData(data);
	    }
	  }
	
	  function getFilterModalData(parent, target) {
	    // filterGroups = {
	    //   status: {
	    //     key: 'status'
	    //     operation: 'equal',
	    //     value: ['inStock','lowStock']
	    //   },
	    // }
	    var filterGroups = {};
	    (0, _underscore2.default)(parent.find(target)).each(function (item) {
	      var key = $(item).attr('name') || $(item).data('name');
	      var operation = $(item).data('operator');
	      var value = $(item).val() || $(item).data('value');
	      filterGroups[key] = filterGroups[key] || { value: [] };
	      filterGroups[key].value.push(value);
	      filterGroups[key].operation = operation;
	      filterGroups[key].key = key;
	    });
	    return (0, _underscore2.default)(filterGroups).values();
	  }
	
	  function getSearchData() {
	    var filterGroup = {};
	    // If no search term is used, they want this to be blank.
	    if (!els.searchInput.val()) {
	      return;
	    }
	    // Value needs to be returned as an array, will investigate solution based on UX reqs in the future (thinking we pull previous search terms into array as well).
	    filterGroup = {
	      key: els.searchInputDropdown.val(),
	      value: [$.trim(els.searchInput.val())],
	      operation: 'like'
	    };
	    return filterGroup;
	  }
	
	  function getSearchInputData() {
	    var searchInput = tableWrapEl.find('.search-input');
	    var searchObj = {
	      value: searchInput.val() || ""
	    };
	    return searchObj;
	  }
	
	  function getBulkSelectedData() {
	    var bulkSelected = [];
	    $.each(tableEl.find(elementsMap.bulkSelectorsTbody), function (i, v) {
	      var trInput = $(v);
	      var targetRow = trInput.closest('tr');
	      if (trInput.is(":checked")) {
	        var passedData = {
	          checkboxIndex: i,
	          rowIndex: responsiveTable.api().row(targetRow).index(),
	          data: responsiveTable.api().row(targetRow).data()
	        };
	        bulkSelected.push(passedData);
	      };
	    });
	
	    return bulkSelected;
	  }
	
	  function setSearchDropdownOptions() {
	    var hasTableSearch = true;
	    if (opts.tableSearch === false) {
	      hasTableSearch = false;
	    }
	    if (hasTableSearch) {
	      var _options = (0, _underscore2.default)(opts.tableSearchDropdown.columns).map(function (item) {
	        var option = (0, _render2.default)(searchDropdownOptionHtml, {
	          name: item.name,
	          value: item.value,
	          title: item.title
	        });
	        return option;
	      });
	      return _options;
	    }
	  }
	
	  function getItemsPerPageData() {
	    return parseInt(els.perPageInput.val());
	  }
	
	  function setPaginationData(data) {
	    setTableData(data);
	    renderPagination();
	    checkForHasData();
	  }
	
	  function openManageViewModal() {
	    manageViewModal.modal("show");
	  }
	
	  function closeManageViewModal() {
	    manageViewModal.modal("hide");
	  }
	
	  function onManageViewBtnClick(e) {
	    e.preventDefault();
	    $(manageViewModalElementsMap.manageViewModalForm).parents('.modal-content').find(manageViewModalElementsMap.deleteSavedViewBtn).show();
	    openManageViewModal();
	  }
	
	  function onManageViewCancelClick(e) {
	    e.preventDefault();
	    addSavedStateBulkSelect();
	    var updateModalBody = void 0;
	    var savedSearchTargetView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	    if (opts.savedViews && opts.savedViews.length >= 1) {
	      var targetView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	      updateModalBody = buildManageModalBody(targetView.filters, targetView.columns, targetView.title, targetView.target);
	    } else {
	      updateModalBody = buildManageModalBody(opts.tableFilters.data, opts.tableColumnModal.data);
	    }
	    closeManageViewModal();
	    // Timeout to match the animation timing.
	    setTimeout(function () {
	      $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(updateModalBody);
	      bindManageModalBody();
	    }, 300);
	  }
	
	  function onManageViewApplyClick(e) {
	    e.preventDefault();
	    addSavedStateBulkSelect();
	    pillFilter = false;
	    var isValid = validateChildren();
	    var formTarget = $(manageViewModalElementsMap.manageViewModalForm).data('target-view');
	    var inputVal = $(manageViewModalElementsMap.manageViewModalForm).find(manageViewModalElementsMap.manageViewNameInput).val();
	    updateView = true;
	    if (isValid) {
	      var currentActiveView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	      if (formTarget === 'newSavedView') {
	        currentActiveView.active = false;
	        var newSavedView = {
	          title: inputVal,
	          target: "newSavedView",
	          active: true,
	          canRemove: true,
	          canEdit: true,
	          // Expecting these to be returned in the setting of new saved data...
	          filters: [],
	          // Expecting these to be returned in the setting of new saved data...
	          columns: []
	        };
	        opts.savedViews.push(newSavedView);
	        els.filterBarContainer.html(renderAppliedFilterBar());
	      } else if (currentActiveView) {
	        currentActiveView.title = inputVal;
	      }
	      tableWrapEl.find(elementsMap.appliedFilterPills).html(renderAppliedFilterPills());
	      closeManageViewModal();
	      setNewColumnList();
	      setVisibleColumns();
	      resetPageThenFetch();
	    }
	  }
	
	  function setVisibleColumns() {
	    // probably a better way to do this, but it works for now.
	    addSavedStateBulkSelect();
	    if (!isMobile) {
	      var columnSource = void 0;
	      if (opts.savedViews && opts.savedViews.length >= 1) {
	        columnSource = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true }).columns;
	      } else {
	        columnSource = opts.tableColumnModal.data;
	      }
	      (0, _underscore2.default)(manageViewModal.find('.manage-column-list input')).each(function (input, i) {
	        var newIndex = i;
	        if (opts.bulkSelect === true) {
	          newIndex = i + 1;
	        };
	        var status = false;
	        var checkboxEl = $(input);
	        var columnTarget = columnSource[checkboxEl.data('column-index')];
	        if (checkboxEl.prop('checked')) {
	          status = true;
	        }
	        if (!checkboxEl.attr('disabled')) {
	          columnTarget.active = status;
	        }
	        responsiveTable.api().column(newIndex).visible(status);
	      });
	    }
	  }
	
	  // function toggleVisibleColumn() {
	  // addSavedStateBulkSelect();
	  // let checkboxEl = $(this);
	  // let columnSource;
	  // if (opts.savedViews && opts.savedViews.length >= 1) {
	  //   columnSource = _(opts.savedViews).findWhere({active: true}).columns;
	  // } else {
	  //   columnSource = opts.tableColumnModal.data;
	  // }
	  // let columnTarget = columnSource[checkboxEl.data('column-index')];
	  // let status = false;
	  // if ($(this).prop('checked')) {
	  //   status = true;
	  // }
	  // if (!checkboxEl.attr('disabled')) {
	  //   columnTarget.active = status;
	  // }
	  // }
	
	  function onSearchEnter(e) {
	    e.preventDefault();
	    var keycode = e.keyCode ? e.keyCode : e.which;
	    if (keycode == '13') {
	      $(this).blur();
	      resetPageThenFetch();
	    }
	  }
	
	  function showLoadingOverlay() {
	    els.loadingOverlay.show();
	  }
	
	  function hideLoadingOverlay() {
	    els.loadingOverlay.hide();
	  }
	
	  function onBulkSelectChange() {
	    options.onBulkSelectChange && options.onBulkSelectChange();
	  }
	
	  // START: Saved Search
	
	  function renderSavedSearchSection(data) {
	    if (data && data.length >= 1) {
	      var addSavedViews = true;
	      if (opts.newSavedViews === false) {
	        addSavedViews = false;
	      }
	      var listObj = {
	        linkList: '',
	        optionList: ''
	      };
	      var activeSearch = true;
	      var filterList = (0, _underscore2.default)(data).map(function (view) {
	        var linkRender = renderSavedSearchItem(view, savedSearchBarLinkHtml);
	        var optionRender = renderSavedSearchItem(view, savedSearchBarOptionHtml);
	        listObj.linkList = listObj.linkList + linkRender;
	        listObj.optionList = listObj.optionList + optionRender;
	        if (view.active === true) {
	          activeSearch = false;
	        }
	      });
	      var returnRender = (0, _render2.default)(savedSearchBarListWrapHtml, _extends({}, listObj, {
	        dropdownId: 'savedSearch',
	        dropdownName: 'savedSearch',
	        dropdownPlaceholder: '',
	        dropdownMinResultsForSearch: '5',
	        newSavedViews: addSavedViews
	      }));
	      return returnRender;
	    }
	  }
	
	  function renderAppliedFilterPills() {
	    var pillList = [];
	    var startDate = void 0;
	    (0, _underscore2.default)(manageViewModal.find('.manage-filter-list input:checked, .manage-filter-list input[type="text"]')).each(function (item) {
	      var $item = $(item);
	      var itemLabel = void 0;
	      var visible = true;
	      if ($item.attr('id') === 'endDate' || $(item).attr('id') === 'startDate') {
	        visible = false;
	      } else {
	        if ($item.attr('type') === 'radio') {
	          itemLabel = $.trim($item.siblings('.q-cr-label').text());
	        } else {
	          itemLabel = $.trim($item.siblings('.cb-label-inner').text());
	        }
	      }
	      var pillRender = (0, _render2.default)(filterPillTemplateHtml, {
	        operator: $item.data('operator'),
	        name: $item.attr('name'),
	        value: $item.val(),
	        title: itemLabel,
	        visible: visible
	      });
	      pillList.push(pillRender);
	    });
	    return pillList;
	  }
	
	  function renderSavedSearchItem(view, template) {
	    var uniqueClass = elementsMap.savedSearchLink.split('.').join("");
	    var newRender = (0, _render2.default)(template, {
	      targetKey: view.target,
	      text: view.title,
	      linkHref: "#",
	      uniqueClass: uniqueClass,
	      active: view.active
	    });
	    return newRender;
	  }
	
	  function initAndBindSavedSearchDropdown() {
	    (0, _select2able.instantiateSelect2)($(elementsMap.savedSearchDropdown));
	    var currentView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	    $(elementsMap.savedSearchDropdown).val(currentView.target).trigger('change.select2');
	  }
	
	  function onSavedSearchClick(e) {
	    // How to get only the clicked target, for future reference if needed
	    // let savedSearchTargetView = _(opts.savedViews).findWhere({target: savedSearchTarget});
	    e.preventDefault();
	    pillFilter = false;
	    // Get target
	    var clickedBtnEl = $(e.target);
	    // Get data from target, or value from select
	    var savedSearchTarget = clickedBtnEl.data('link-info') || clickedBtnEl.val();
	    // Set Clone Array Data...
	    // opts.savedViews = JSON.parse(JSON.stringify(opts.savedViews));
	    // If clicked item is active, don't run
	    if (clickedBtnEl.hasClass('active')) {
	      return;
	    }
	    // Loop over list, setting the new active state
	    var savedViewList = (0, _underscore2.default)(opts.savedViews).map(function (view) {
	      if (view.target == savedSearchTarget) {
	        view.active = true;
	        els.filterBarContainer.html(renderAppliedFilterBar());
	        addSavedStateBulkSelect();
	        $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(view.filters, view.columns, view.title, view.target));
	        setVisibleColumns();
	        $(elementsMap.savedSearchLink).removeClass('active');
	        $(elementsMap.savedSearchLink + '[data-link-info="' + savedSearchTarget + '"]').addClass('active');
	      } else {
	        view.active = false;
	      }
	    });
	    // render pills
	    tableWrapEl.find(elementsMap.appliedFilterPills).html(renderAppliedFilterPills());
	    bindManageModalBody();
	    // Fetch new data.
	    initAndBindSavedSearchDropdown();
	    resetPageThenFetch();
	  }
	
	  function onDeleteSavedViewClick(e) {
	    e.preventDefault();
	    pillFilter = false;
	    deletedView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	    opts.savedViews[0].active = true;
	    closeManageViewModal();
	    // Timeout to match the animation timing.
	    setTimeout(function () {
	      els.filterBarContainer.html(renderAppliedFilterBar());
	      // els.savedSearchContainer.html(renderSavedSearchSection(opts.savedViews));
	      $(elementsMap.savedSearchLink).removeClass('active');
	      $(elementsMap.savedSearchLink + '[data-link-info="' + opts.savedViews[0].target + '"]').addClass('active');
	      addSavedStateBulkSelect();
	      $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(opts.savedViews[opts.newViewIndexOverride].filters, opts.savedViews[opts.newViewIndexOverride].columns, opts.savedViews[opts.newViewIndexOverride].title, opts.savedViews[opts.newViewIndexOverride].target));
	      tableWrapEl.find(elementsMap.appliedFilterPills).html(renderAppliedFilterPills());
	      setVisibleColumns();
	      bindManageModalBody();
	      resetPageThenFetch();
	    }, 300);
	  }
	
	  function removeSavedView(deleteTarget) {
	    opts.savedViews = _underscore2.default.without(opts.savedViews, _underscore2.default.findWhere(opts.savedViews, {
	      target: deleteTarget
	    }));
	    els.savedSearchContainer.html(renderSavedSearchSection(opts.savedViews));
	    initAndBindSavedSearchDropdown();
	  }
	
	  function onDeletePillFilterClick(e) {
	    e.preventDefault();
	    var clickedPillEl = $(e.target);
	    var clickedPillParentEl = $(e.target).closest(elementsMap.pillFilter);
	    if (clickedPillParentEl.data('value') === 'customRange') {
	      clickedPillParentEl.siblings('[data-name="startDate"], [data-name="endDate"]').removeAttr('data-value');
	    }
	    clickedPillParentEl.remove();
	    resetPageThenFetch();
	  }
	
	  function setNewSavedViewData(newSearchData, dataTarget) {
	    if (opts.savedViews && opts.savedViews.length >= 1) {
	      var targetView = (0, _underscore2.default)(opts.savedViews).findWhere({ target: dataTarget });
	      if (targetView) {
	        targetView.title = newSearchData.title;
	        targetView.target = newSearchData.target;
	        targetView.active = newSearchData.active;
	        targetView.canRemove = newSearchData.canRemove;
	        targetView.canEdit = newSearchData.canEdit;
	        targetView.filters = newSearchData.filters;
	        targetView.columns = newSearchData.columns;
	        // targetView = {...targetView, ...newSearchData};
	        // console.log(opts.savedViews);
	      }
	      var activeView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	      els.savedSearchContainer.html(renderSavedSearchSection(opts.savedViews));
	      initAndBindSavedSearchDropdown();
	      addSavedStateBulkSelect();
	      $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(activeView.filters, activeView.columns, activeView.title, activeView.target));
	      setVisibleColumns();
	      bindManageModalBody();
	    }
	    // else if (opts.savedViews && opts.savedViews.length < 1) {
	    //   opts.savedViews.push(newSearchData);
	    //   els.savedSearchContainer.html(renderSavedSearchSection(opts.savedViews));
	    //   let savedViewList = _(opts.savedViews).map((view)=>{
	    //     els.filterBarContainer.html(renderAppliedFilterBar());
	    //     addSavedStateBulkSelect();
	    //     $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(view.filters, view.columns, view.title, view.target));
	    //     setVisibleColumns();
	    //     bindManageModalBody();
	    //   });
	    // }
	  }
	
	  function setNewColumnList() {
	    if (opts.savedViews && opts.savedViews.length >= 1) {
	      var savedSearchTargetView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	      savedSearchTargetView.columns = [];
	      (0, _underscore2.default)(manageViewModal.find('.manage-column-list input[type="checkbox"]')).each(function (column) {
	        var columnEl = $(column);
	        var toggleable = true;
	        if (columnEl.attr('disabled')) {
	          toggleable = false;
	        }
	        var newColumnObj = {
	          data: columnEl.val(),
	          title: $.trim(columnEl.siblings('span').text()),
	          active: columnEl.prop('checked'),
	          canToggle: toggleable
	        };
	        savedSearchTargetView.columns.push(newColumnObj);
	      });
	      addSavedStateBulkSelect();
	    }
	  }
	
	  function addSavedStateBulkSelect() {
	    if (opts.savedViews && opts.savedViews.length >= 1) {
	      var savedSearchTargetView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	      if (opts.bulkSelect === true && savedSearchTargetView.columns[0].title !== "Bulk Select") {
	        savedSearchTargetView.columns.unshift(bulkSelectModalColumn);
	      }
	    } else {
	      if (opts.bulkSelect === true && opts.tableColumnModal.data[0].title !== "Bulk Select") {
	        opts.tableColumnModal.data.unshift(bulkSelectModalColumn);
	      }
	    }
	  }
	
	  function onNewSavedSearchClick(e) {
	    e.preventDefault();
	    $(manageViewModalElementsMap.manageViewModalForm).closest('div').html(buildManageModalBody(opts.savedViews[opts.newViewIndexOverride].filters, opts.savedViews[opts.newViewIndexOverride].columns, '', 'newSavedView'));
	    $(manageViewModalElementsMap.manageViewModalForm).parents('.modal-content').find(manageViewModalElementsMap.deleteSavedViewBtn).hide();
	    bindManageModalBody();
	    openManageViewModal();
	  }
	
	  function renderAppliedFilterBar() {
	    if (opts.savedViews && opts.savedViews.length >= 1) {
	      var savedSearchTargetView = (0, _underscore2.default)(opts.savedViews).findWhere({ active: true });
	      var appliedFilterRender = (0, _render2.default)(appliedFilterBarHtml, {
	        target: savedSearchTargetView.target,
	        canEdit: savedSearchTargetView.canEdit,
	        canRemove: savedSearchTargetView.canRemove,
	        title: savedSearchTargetView.title
	      });
	      return appliedFilterRender;
	    }
	  }
	
	  // END: Saved Search
	
	  // Manage View Modal
	
	  function buildManageModalBody(filterData, columnData, inputValue, targetView) {
	    var modalBody = (0, _render2.default)(manageViewModalBodyHtml, {
	      inputValue: inputValue,
	      targetView: targetView,
	      filterList: buildFilterModalGroupBody(filterModalBodyGroupHtml, filterData),
	      columnList: buildColumnModalInputList(columnModalCheckboxHtml, columnData)
	    });
	    return modalBody;
	  }
	
	  function bindManageModalBody() {
	    // have to re-bind all of these things since I'm re-rendering
	    $(manageViewModalElementsMap.dateRangeInputs).datepicker({
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	    manageViewModal.find(manageViewModalElementsMap.dateRangeEnd).on('click', function (e) {
	      var initDate = $(manageViewModalElementsMap.dateRangeStart).datepicker('getDate');
	      if (initDate) {
	        initDate = moment(initDate).add(1, 'days').toDate();
	        manageViewModal.find(manageViewModalElementsMap.dateRangeEnd).datepicker('setStartDate', initDate);
	      } else if (initDate === null) {
	        manageViewModal.find(manageViewModalElementsMap.dateRangeEnd).datepicker('setStartDate', null);
	      }
	    });
	    manageViewModal.find(manageViewModalElementsMap.dateRangeStart).on('click', function (e) {
	      var initDate = $(manageViewModalElementsMap.dateRangeEnd).datepicker('getDate');
	      if (initDate) {
	        initDate = moment(initDate).subtract(1, 'days').toDate();
	        manageViewModal.find(manageViewModalElementsMap.dateRangeStart).datepicker('setEndDate', initDate);
	      } else if (initDate === null) {
	        manageViewModal.find(manageViewModalElementsMap.dateRangeStart).datepicker('setEndDate', null);
	      }
	    });
	    validator = manageViewModal.find(manageViewModalElementsMap.manageViewModalForm).validate(validationOpts);
	    validator.settings.ignore = ":disabled,:hidden";
	    $(manageViewModalElementsMap.manageViewNameInput).rules("add", {
	      required: true,
	      maxlength: 30,
	      messages: {
	        required: "This field is required.",
	        maxlength: "Characters can't exceed 30."
	      }
	    });
	  }
	
	  // Column List
	
	  function buildColumnModalInputList(template, list) {
	    var columnInputList = (0, _underscore2.default)(list).map(function (column, index) {
	      if (opts.bulkSelect === true && index === 0) {
	        return;
	      }
	      return (0, _render2.default)(template, {
	        title: column.title,
	        name: column.data,
	        value: column.data,
	        active: (0, _general.keyDefaultFalseOption)(column, "active"),
	        columnIndex: index,
	        canToggle: (0, _general.keyDefaultFalseOption)(column, "canToggle")
	      });
	    });
	    return columnInputList.join('');
	  }
	
	  // Filter List
	
	  function buildFilterModalGroupBody(template, list) {
	    var filters = (0, _underscore2.default)(list).map(function (item, index) {
	      if (!item.filterGroupInputs) {
	        item.filterGroupInputs = [{}];
	      }
	      var filterList = buildFilterModalInputList(item, item.filterGroupInputs, item.filterGroupType);
	      return (0, _render2.default)(template, {
	        title: item.filterGroup,
	        filterList: filterList,
	        index: index
	      });
	    });
	    return filters.join('');
	  }
	
	  function buildFilterModalInputList(item, list, type) {
	    var filterList = (0, _underscore2.default)(list).map(function (input) {
	      // Example:
	      // {
	      //   checkbox: filterGroupCheckboxHtml,
	      // }
	      var filterTemplate = buildFilterModalInputListConfig[type];
	      var filterChildren = "";
	      if (input.childFilters) {
	        filterChildren = buildFilterModalGroupBody(childFiltersWrapHtml, input.childFilters);
	      }
	      return (0, _render2.default)(filterTemplate, {
	        title: input.filterTitle,
	        name: input.filterName || item.filterGroupName,
	        dateRangeNameStart: item.dateRangeNameStart,
	        dateRangeNameEnd: item.dateRangeNameEnd,
	        dateRangeStartVal: item.dateRangeStartVal || "",
	        dateRangeEndVal: item.dateRangeEndVal || "",
	        value: input.filterValue,
	        active: input.active,
	        operator: input.filterOperator,
	        childFiltersHtml: filterChildren
	      });
	    });
	    return filterList.join('');
	  }
	
	  function toggleFilterModalChildInput(e) {
	    var $self = $(this);
	    if ($self.attr('type') === 'radio') {
	      toggleFilterModalChildRadios($self);
	    };
	    var $target = $self.closest('.divider-group').find('.child-filters-entry');
	    validator.resetForm();
	    // USE BETTER SHOW/HIDE, LOW PRIORITY
	    $target.show();
	  }
	
	  function toggleFilterModalChildRadios(radioEl) {
	    var $radios = radioEl.closest('.input-list-section').find('input[type="radio"]');
	    $radios.each(function () {
	      var $curRadio = $(this);
	      var $target = $curRadio.closest('.divider-group').find('.child-filters-entry');
	      // Reset datepicker options.
	      manageViewModalEls.dateRangeInputs.datepicker("setStartDate", false);
	      manageViewModalEls.dateRangeInputs.datepicker("setEndDate", false);
	      // USE BETTER SHOW/HIDE, LOW PRIORITY
	      $target.find('input[type="text"]').val("");
	      $target.hide();
	    });
	  }
	
	  function uncheckAllSelected() {
	    $(elementsMap.bulkSelectorHeader + ":checked").prop('checked', false);
	    $(elementsMap.bulkSelectorsTbody + ":checked").each(function () {
	      $(this).prop('checked', false);
	    });
	  }
	
	  // Validation
	  function validateChildren() {
	    var isValid = false;
	    if ($(manageViewModalElementsMap.manageViewModalForm).valid()) {
	      isValid = true;
	    }
	    return isValid;
	  }
	
	  // PAGINATION HELPER FUNCTIONS, TAKEN FROM PAGINATION COMPONENT:
	
	  function renderPagination() {
	    (0, _selectorHelpers.insertTextAndClean)(els.pageDataInfo, buildPageInfoText());
	    handleDisabledBtns();
	    els.perPageInput.val(perPageSize()).trigger('change.select2');
	  };
	
	  function setTableData(data) {
	    opts.paginationData = (0, _general.merge)(opts.paginationData, data, { clone: true });
	    renderPagination();
	  }
	
	  function handleDisabledBtns() {
	    handleDisabledNextBtn();
	    handleDisabledPrevBtn();
	  }
	
	  function handleDisabledNextBtn() {
	    if (isBeforeLastPage()) {
	      els.nextBtn.removeClass('disabled');
	      els.nextBtn.data('next-page', nextPageNumber());
	    } else {
	      els.nextBtn.addClass('disabled');
	      els.nextBtn.data('next-page', null);
	    }
	  }
	
	  function handleDisabledPrevBtn() {
	    if (!isFirstPage()) {
	      els.prevBtn.removeClass('disabled');
	      els.prevBtn.parent().data('previous-page', prevPageNumber());
	    } else {
	      els.prevBtn.addClass('disabled');
	      els.prevBtn.parent().data('previous-page', null);
	    }
	  }
	
	  function onOrderTableHeaderClick(e) {
	    e.preventDefault();
	    onFetch();
	  }
	
	  function handleAllBulkSelectsChange(e) {
	    e.preventDefault();
	    var headerIsSelected = $(e.target).is(":checked");
	    setAllBulkSelects(headerIsSelected);
	    onBulkSelectChange();
	  }
	
	  function setAllBulkSelects(headerIsSelected) {
	    responsiveTable.find(elementsMap.bulkSelectorsTbody).prop("checked", headerIsSelected);
	  }
	
	  // function setBulkSelectHeader(isSelected){
	  //   responsiveTable.find(elementsMap.bulkSelectorHeader).prop("checked", isSelected);
	  //   setAllBulkSelects(isSelected);
	  // }
	
	  function buildPageInfoText() {
	    var paginationText = "Showing";
	    if (hasTableData()) {
	      return paginationText + " " + exclusiveResultsShownTotal() + " - " + computedInclusiveResultsShownTotal() + " of " + totalResults();
	    } else {
	      return "";
	    }
	  }
	
	  // This is a smart function to return either
	  // the total inclusive results or, if we've exceeded
	  // the computed total then return just the totalResults
	  function computedInclusiveResultsShownTotal() {
	    if (isBeforeLastPage()) {
	      return inclusiveResultsShownTotal();
	    } else {
	      return totalResults();
	    }
	  }
	
	  // the total amount of records up-to-and-including current page
	  function inclusiveResultsShownTotal() {
	    return perPageSize() * nextPageNumber();
	  }
	
	  // the total amount of records up-to-excluding current page (add 1 after for range)
	  function exclusiveResultsShownTotal() {
	    return perPageSize() * currentPageNumber() + 1;
	  }
	
	  function totalResults() {
	    return getTableData().totalElements;
	  }
	
	  function hasTableData() {
	    return totalResults() > 0;
	  }
	
	  function isFirstPage() {
	    return currentPageNumber() <= 0;
	  }
	
	  function isBeforeLastPage() {
	    return totalResults() > inclusiveResultsShownTotal();
	  }
	
	  function perPageSize() {
	    return getTableData().size;
	  }
	
	  function currentPageNumber() {
	    return getTableData().number;
	  }
	
	  function nextPageNumber() {
	    return currentPageNumber() + 1;
	  }
	
	  function prevPageNumber() {
	    return currentPageNumber() - 1;
	  }
	
	  function getTableData() {
	    return opts.paginationData;
	  }
	
	  // BUTTON TABS (DID I MENTION THIS WILL BE A COMPONENT?)
	  function toggleShownTab(e) {
	    e.preventDefault();
	    var btnEl = $(e.target);
	    var parentClass = "." + btnEl.data('parent');
	    var targetClass = "." + btnEl.data('target');
	    var parentEl = btnEl.closest(parentClass);
	    var targetContainerEl = parentEl.find(targetClass);
	    var isValid = validateChildren();
	    if (isValid) {
	      parentEl.find('.active').removeClass('active');
	      targetContainerEl.addClass('active');
	      btnEl.addClass('active');
	    }
	  }
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _storeUtils = __webpack_require__(56);
	
	var _general = __webpack_require__(5);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _normalizr = __webpack_require__(192);
	
	var _relationships = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	window._underscore = _underscore2.default;
	
	var asnDetails = {};
	var defaults = {
	  sku: "",
	  unitsPerCase: 1,
	  numberOfCases: 1,
	  numberOfPallets: 1,
	  caseLineNumber: 1,
	  palletLineNumber: 1
	  // skuLineNumber: 1
	};
	
	var AsnDetailStore = (0, _storeUtils.createStore)({
	  storeEventBaseKey: "asn_details",
	  normalizrKey: "asnDetails",
	  normalizr: _relationships.asnDetailsKeyToArrayOfAsnDetails,
	  getData: function getData() {
	    return asnDetails;
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  calcTotalQuantityForDetails: function calcTotalQuantityForDetails(details) {
	    var _this = this;
	
	    var total = 0;
	    (0, _underscore2.default)(details).map(function (detail) {
	      total += _this.calcTotalQuantityFor(detail);
	    });
	    return total;
	  },
	  calcTotalQuantityFor: function calcTotalQuantityFor(detail) {
	    var unitsPerCase = detail.unitsPerCase,
	        numberOfCases = detail.numberOfCases,
	        numberOfPallets = detail.numberOfPallets;
	
	    return defaultToOne(unitsPerCase) * defaultToOne(numberOfCases) * defaultToOne(numberOfPallets);
	  },
	
	  setNumberOfCasesForIds: setAttrForIdsFunc("numberOfCases"),
	  setNumberOfPalletsForIds: setAttrForIdsFunc("numberOfPallets"),
	  setLengthForIds: setAttrForIdsFunc("asd_package_length"),
	  setWidthForIds: setAttrForIdsFunc("asd_package_width"),
	  setHeightForIds: setAttrForIdsFunc("asd_package_height"),
	  setWeightForIds: setAttrForIdsFunc("asd_package_weight"),
	  setAttrsForIds: setAttrsForIds,
	  isSingularInPallet: function isSingularInPallet(detail) {
	    return !(0, _underscore2.default)(asnDetails).find(function (curDetail, k) {
	      return detail.id !== curDetail.id && detail.palletLineNumber === curDetail.palletLineNumber;
	    });
	  },
	  copyDimensionsToAllCasesForSameAsn: function copyDimensionsToAllCasesForSameAsn(asnDetailId) {
	    var asnDetail = this.getAsnDetail(asnDetailId);
	    var asd_package_length = asnDetail.asd_package_length,
	        asd_package_width = asnDetail.asd_package_width,
	        asd_package_height = asnDetail.asd_package_height,
	        asd_package_weight = asnDetail.asd_package_weight,
	        stackablePallet = asnDetail.stackablePallet;
	
	    var similarAsnDetails = (0, _underscore2.default)(asnDetails).pick(function (_ref) {
	      var asnId = _ref.asnId;
	
	      return asnDetail.asnId === asnId;
	    });
	    similarAsnDetails = (0, _underscore2.default)(similarAsnDetails).mapObject(function (curAsnDetail) {
	      return _underscore2.default.assign(curAsnDetail, { asd_package_length: asd_package_length, asd_package_width: asd_package_width, asd_package_height: asd_package_height, asd_package_weight: asd_package_weight, stackablePallet: stackablePallet });
	    });
	    this.updateObjectsAndEmit(similarAsnDetails);
	  },
	  copyObjectToAllCasesViaAsnId: function copyObjectToAllCasesViaAsnId(asnId, newData) {
	    var similarAsnDetails = (0, _underscore2.default)(asnDetails).pick(function (asnDetail) {
	      return asnDetail.asnId === asnId;
	    });
	
	    similarAsnDetails = (0, _underscore2.default)(similarAsnDetails).mapObject(function (curAsnDetail) {
	      return _underscore2.default.assign(curAsnDetail, newData);
	    });
	    this.updateObjectsAndEmit(similarAsnDetails);
	  },
	  createNewPalletIncrementedAsnDetail: function createNewPalletIncrementedAsnDetail(data) {
	    var getNextFunc = getNextIntegerFor.bind(this);
	    var palletLineNumber = getNextFunc("palletLineNumber");
	    return this.createNewAsnDetail(_extends({}, data, { caseLineNumber: 1, palletLineNumber: palletLineNumber }));
	  },
	  removeAsnDetailsByIds: function removeAsnDetailsByIds() {
	    var caseIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    this.removeObjectsByIdsAndEmit(asnDetails, caseIds);
	  },
	  createNewCaseIncrementedAsnDetail: function createNewCaseIncrementedAsnDetail(data) {
	    var getNextFunc = getNextIntegerFor.bind(this);
	    var caseLineNumber = getNextFunc("caseLineNumber");
	    return this.createNewAsnDetail(_extends({}, data, { caseLineNumber: caseLineNumber }));
	  },
	  maxBy: function maxBy(key) {
	    //based on shippingMethod
	    var details = AsnStore.getAsnDetails(getAsnByKey(key));
	    return (0, _underscore2.default)(details).max(function (obj) {
	      return parseInt(obj[key]);
	    });
	  },
	  update: function update(id, newData) {
	    var detail = asnDetails[id];
	    asnDetails[id] = _extends({}, detail, newData);
	    // emit a global/generic change that we can listen to
	    this.emitEvent("change", detail);
	    return this.emitObjectChange(asnDetails[id]);
	  },
	  createNewCaseSkeletonIncrementedAsnDetail: function createNewCaseSkeletonIncrementedAsnDetail(data) {
	    var getNextFunc = getNextIntegerFor.bind(this);
	    var caseLineNumber = getNextFunc("caseLineNumber");
	    return this.createSkeletonAsnDetail(_extends({}, data, { caseLineNumber: caseLineNumber }));
	  },
	  getNextCaseNumber: function getNextCaseNumber() {
	    var getNextFunc = getNextIntegerFor.bind(this);
	    return getNextFunc("caseLineNumber");
	  },
	  getNextPalletNumber: function getNextPalletNumber() {
	    var getNextFunc = getNextIntegerFor.bind(this);
	    return getNextFunc("palletLineNumber");
	  },
	  createNewPalletSkeletonIncrementedAsnDetail: function createNewPalletSkeletonIncrementedAsnDetail(data) {
	    var getNextFunc = getNextIntegerFor.bind(this);
	    var palletLineNumber = getNextFunc("palletLineNumber");
	    return this.createSkeletonAsnDetail(_extends({}, data, { caseLineNumber: 1, palletLineNumber: palletLineNumber }));
	  },
	  createSkeletonAsnDetail: function createSkeletonAsnDetail(data) {
	    return _underscore2.default.extend({ id: _underscore2.default.uuid() }, defaults, data);
	  },
	  createNewAsnDetail: function createNewAsnDetail(data) {
	    data = _underscore2.default.extend({ id: _underscore2.default.uuid() }, defaults, data);
	    return this.addAsnDetail(data);
	  },
	  addAsnDetail: function addAsnDetail(data) {
	    return this.addObjectsAndEmit(asnDetails, data);
	  },
	  getAllAsnDetails: function getAllAsnDetails() {
	    return asnDetails;
	  },
	  getAsnDetail: function getAsnDetail(id) {
	    return asnDetails[id];
	  },
	  getAsnDetails: function getAsnDetails(ids) {
	    var _$chain;
	
	    return (_$chain = _underscore2.default.chain(asnDetails)).pick.apply(_$chain, _toConsumableArray(ids)).values().value();
	  },
	  asnDetailsAsArray: function asnDetailsAsArray() {
	    return (0, _underscore2.default)(asnDetails).values();
	  },
	  haveDimensionsAndWeight: function haveDimensionsAndWeight(details) {
	    return (0, _underscore2.default)(details).all(this.hasDimensionsAndWeight, this);
	  },
	  hasDimensionsAndWeight: function hasDimensionsAndWeight(detail) {
	    return (0, _general.isGtZero)(detail.asd_package_length) && (0, _general.isGtZero)(detail.asd_package_width) && (0, _general.isGtZero)(detail.asd_package_height) && (0, _general.isGtZero)(detail.asd_package_weight);
	  },
	  organizeIntoPalletsAndCases: function organizeIntoPalletsAndCases(details) {
	    var _this2 = this;
	
	    return _underscore2.default.chain(this.organizeIntoPallets(details)).map(function (palletData) {
	      return _this2.organizeIntoCases(palletData);
	    }).value();
	  },
	
	  organizeIntoPallets: organizeIntoFunc("palletLineNumber"),
	  organizeIntoCases: organizeIntoFunc("caseLineNumber"),
	
	  hasAnyMixedSkuCasesInAnyPallets: function hasAnyMixedSkuCasesInAnyPallets(details) {
	    return (0, _underscore2.default)(this.organizeIntoPalletsAndCases(details)).any(function (palletData) {
	      return arrayIsGreaterThanOne(palletData) || (0, _underscore2.default)(palletData).any(arrayIsGreaterThanOne);
	    });
	  },
	  hasAnyMixedSkuCases: function hasAnyMixedSkuCases(details) {
	    return (0, _underscore2.default)(this.organizeIntoCases(details)).any(arrayIsGreaterThanOne);
	  },
	  groupBySku: function groupBySku() {
	    var details = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return (0, _underscore2.default)(details).groupBy(function (detail) {
	      return detail.sku;
	    });
	  },
	  where: function where(attrs) {
	    return (0, _underscore2.default)(this.asnDetailsAsArray()).where(attrs);
	  },
	  whereAsObject: function whereAsObject(attrs) {
	    return (0, _underscore2.default)(asnDetails).pick(function (detail, id) {
	      return !!(0, _underscore2.default)([detail]).where(attrs).length;
	    });
	  },
	  storeFromUploadJson: function storeFromUploadJson(newArray) {
	    var asn = AsnStore.getAsnWithShippingMethod();
	    var curNormalizr = this.normalizr;
	    var newData = (0, _normalizr.normalize)({ asnDetails: newArray }, curNormalizr).entities.asnDetails;
	    var dvlForAllResult = false;
	
	    (0, _underscore2.default)(newData).map(function (item) {
	      if (item.dvlForAll != 'undefined') {
	        dvlForAllResult = item.dvlForAll;
	      }
	    });
	    //alert(dvlForAllResult);
	    //AsnStore.updateObjectAndEmit(asn.id, {[key]: val});
	    AsnStore.updateObjectAndEmit(asn.id, { "applyDvl": dvlForAllResult });
	    //AsnStore.emitEvent("dvl-inside-case");
	    asnDetails = (0, _underscore2.default)(asnDetails).omit(function (asnDetail) {
	      return asnDetail.asnId === asn.id;
	    });
	
	    asnDetails = _extends({}, asnDetails, newData);
	
	    //this.emitEvent('add', newData);
	  }
	});
	
	function getAsnByShippingMethod(shippingMethod) {
	  return AsnStore.getOrCreateAsnWithShippingMethod(shippingMethod);
	}
	
	function getAsnByKey(key) {
	  if (key == 'palletLineNumber') return getAsnByShippingMethod("pallet");else return getAsnByShippingMethod("parcel");
	}
	
	function defaultToOne(numb) {
	  return numb || 1;
	}
	
	function setAttrForIdsFunc(groupKey) {
	  return function (ids, val) {
	    var _$chain2,
	        _this3 = this;
	
	    var out = (_$chain2 = _underscore2.default.chain(asnDetails)).pick.apply(_$chain2, _toConsumableArray(ids)).mapObject(function (detail, k) {
	      detail[groupKey] = val;
	      return detail;
	    }).mapObject(function (detail, k) {
	      _this3.emitObjectChange(detail);
	    }).value();
	    // emit a global change as well
	    this.emitEvent('change', out);
	    this.emitEvent('changes:' + groupKey, out);
	
	    return out;
	  };
	}
	
	function setAttrsForIds(ids) {
	  var _this4 = this;
	
	  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  (0, _underscore2.default)(attrs).mapObject(function (v, k) {
	    var func = setAttrForIdsFunc(k).bind(_this4);
	    func(ids, v);
	  });
	}
	
	function getNextIntegerFor(key) {
	  var numb = this.maxBy(key)[key];
	  if (_underscore2.default.isNull(numb) || _underscore2.default.isUndefined(numb) || numb === "") {
	    numb = 0;
	    // console.log('null or undefined for max key');
	  }
	  numb = parseInt(numb, 10);
	  return numb + 1;
	}
	
	function arrayIsGreaterThanOne(arr) {
	  return arr.length > 1;
	}
	
	function organizeIntoFunc(key) {
	  return function (data) {
	    return _underscore2.default.chain(data).values().groupBy(function (asnDetail) {
	      return asnDetail[key];
	    }).values().value();
	  };
	}
	window.AsnDetailStore = AsnDetailStore;
	exports.default = AsnDetailStore;

/***/ },
/* 21 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleCustomDropdownEvents = handleCustomDropdownEvents;
	// const $ = require('jquery');
	
	function handleCustomDropdownEvents() {
	
	  var dropdownMenu = void 0,
	      target = void 0;
	  $(window).on('show.bs.dropdown', onDropdownShow);
	  $(window).on('hide.bs.dropdown', onDropdownHide);
	  $(window).on('scroll.customDropdown resize.customDropdown', onScrollOrResize);
	
	  function onDropdownHide(e) {
	    if (target && dropdownMenu && $(".overflow-dropdown").length > 0) {
	      target.append(dropdownMenu.detach());
	      dropdownMenu.hide();
	    }
	  }
	
	  function onDropdownShow(e) {
	    target = $(e.target);
	    if (target.hasClass("overflow-dropdown")) {
	      dropdownMenu = target.find('.dropdown-menu');
	      $('body').append(dropdownMenu.detach());
	      var eOffset = $(e.target).offset();
	      dropdownMenu.css({
	        'display': 'block',
	        'top': eOffset.top + $(e.target).outerHeight(),
	        'left': eOffset.left
	      });
	    }
	  }
	
	  function onScrollOrResize() {
	    if (target && target.length > 0 && target.hasClass('overflow-dropdown')) {
	      if (target) {
	        target.removeClass('open');
	      }
	      onDropdownHide();
	    }
	  }
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.instantiateSelect2 = instantiateSelect2;
	exports.validateOnAllSelectChanges = validateOnAllSelectChanges;
	exports.bindDocSelect2CloseRefocus = bindDocSelect2CloseRefocus;
	exports.addCustomClassForSelect2 = addCustomClassForSelect2;
	exports.bindSelect2OnTypeForDesktop = bindSelect2OnTypeForDesktop;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _general = __webpack_require__(5);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	var _uaDetect = __webpack_require__(845);
	
	var _fuse = __webpack_require__(278);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	var _fuseSearchSettings = __webpack_require__(225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// need reference to window js jquery because Portal Devs
	// need to utilize this functionality from old JS files
	var $old = jQuery;
	
	
	// console.log(searchSettings);
	
	var select2FuseKeys = {
	  keys: [{
	    name: 'id',
	    weight: 0.3
	  }, {
	    name: 'text',
	    weight: 0.7
	  }]
	};
	
	function filterLogicFunc(el, config) {
	  return function filterLogic(data) {
	    var s2 = el.data('select2');
	    var searchInput = s2.dropdown.$search;
	    if (!searchInput || !searchInput.val()) {
	      return data;
	    }
	    var term = searchInput.val();
	    var select2Fuse = new _fuse2.default(data, config);
	    var res = select2Fuse.search(term);
	    return res;
	  };
	}
	
	function matcherByPass(term, obj) {
	  return obj;
	}
	
	function instantiateSelect2(els) {
	  els.each(function () {
	    var el = this;
	    var $el = (0, _jquery2.default)(this);
	    var options = (0, _collectDataAttributesFor2.default)(el, { prefix: "s2" });
	    var resultType = _fuseSearchSettings.searchSettings[options.searchLogic] || _fuseSearchSettings.searchSettings.base;
	    var select2FuseConfig = (0, _general.merge)(resultType, select2FuseKeys, { clone: true });
	    //options.matcher = matcherByPass; Commented out to fix the filtering in multi select2. Can be configured for custom filtering in future.
	    options.sorter = filterLogicFunc($el, select2FuseConfig);
	    $el.select2(options);
	    // select2 has baked in functionality that forces the select
	    // open after clear. Functionality below allows opting out.
	    // if autoOpenOnClear is explicitly equal to false,
	    // then we handle keeping the selectbox close on unselecting
	
	    var isDisabled = $el.is(':disabled');
	
	    if (isDisabled) {
	      var disabledTargetEl = $el.data('target-closest');
	      var parentEl = $el.closest(disabledTargetEl);
	      parentEl.find('.select2-container').css('pointer-events', 'none');
	    }
	
	    var isInputGrp = $el.parent().hasClass('q-input-group');
	
	    if (isInputGrp) {
	      var isFirstChild = $el.siblings().first().get(0).tagName === 'SPAN' ? true : false;
	      var isLastChild = $el.siblings().last().get(0).tagName === 'SPAN' ? true : false;
	
	      if (isFirstChild) {
	        $el.next().find('.select2-selection').css({
	          'border-radius': '3px 0px 0px 3px',
	          'border-right': '0px'
	        });
	      } else if (isLastChild) {
	        $el.next().find('.select2-selection').css({
	          'border-radius': '0px 3px 3px 0px'
	        });
	      } else {
	        $el.next().find('.select2-selection').css({
	          'border-radius': '0px',
	          'border-right': '0px'
	        });
	      }
	    }
	
	    var isFullWidthList = options.fullWidthList;
	
	    function makeListWidthFull() {
	      var $list = (0, _jquery2.default)('.select2-dropdown');
	      var listWidth = $el.parent().width();
	      $list.css({
	        'width': listWidth + "px"
	      });
	      // Following takes care of the scenario where select2 is not the first child
	      var $elParentLeftPosition = $el.parent().offset().left;
	      $list.offset({
	        left: $elParentLeftPosition
	      });
	    }
	
	    $el.on('select2:open', function () {
	      if (isFullWidthList) {
	        setTimeout(makeListWidthFull, 1);
	        (0, _jquery2.default)(window).scroll(function () {
	          makeListWidthFull();
	        });
	        (0, _jquery2.default)(window).resize(function () {
	          makeListWidthFull();
	        });
	      }
	    });
	
	    if (options.autoOpenOnClear === false) {
	      $el.on("select2:unselecting", function (e) {
	        (0, _jquery2.default)(this).select2("val", 0);
	        e.preventDefault();
	      });
	    }
	
	    if ($el.data('custom-select2-cls')) {
	      var customClass = $el.data('custom-select2-cls');
	      addCustomClassForSelect2($el, customClass);
	    }
	  });
	}
	
	function validateOnAllSelectChanges() {
	  (0, _jquery2.default)(document).on("change", "select", function () {
	    if ((0, _jquery2.default)(this).get(0).form) {
	      (0, _jquery2.default)(this).valid();
	    }
	  });
	}
	
	function bindDocSelect2CloseRefocus() {
	  (0, _jquery2.default)(document).on('select2:close', focusTargetFromEvent(_jquery2.default));
	  $old(document).on('select2:close', focusTargetFromEvent($old));
	}
	
	function addCustomClassForSelect2(select2El, cls) {
	  select2El.data('select2').$container.addClass(cls);
	  select2El.data('select2').$dropdown.addClass(cls);
	  select2El.data('select2').$selection.addClass(cls);
	}
	
	function focusTargetFromEvent($) {
	  return function (e) {
	    $(e.target).focus();
	  };
	}
	
	function bindSelect2OnTypeForDesktop() {
	  if ((0, _uaDetect.isDesktop)()) {
	    (0, _jquery2.default)(document).on('keydown', 'span.select2', createDropdownSelectSpanFromEvent(_jquery2.default));
	    $old(document).on('keydown', 'span.select2', createDropdownSelectSpanFromEvent($old));
	  }
	}
	
	function createDropdownSelectSpanFromEvent($) {
	  return function dropdownSelectSpanFromEvent(ev) {
	    var selectEl = $(this).prev('select:not([multiple])');
	
	    var $target = $(ev.target).closest('.select2-container');
	    if (!selectEl.data('select2') || !$target.length) {
	      return;
	    }
	    var $search = selectEl.data('select2').dropdown.$search || selectEl.data('select2').selection.$search;
	
	    if ($target.hasClass('select2-container--open')) {
	      return;
	    }
	    searchSelect2Now({ selectElement: selectEl, $target: $target, $search: $search, event: ev });
	  };
	
	  function searchSelect2Now(_ref) {
	    var selectElement = _ref.selectElement,
	        $target = _ref.$target,
	        $search = _ref.$search,
	        event = _ref.event;
	
	    /* NOTE: due to browser comptibility issues, search only filters in Safari and Edge, not in other browsers,
	        and attempting to implement search and filter on non-search-input dropdowns created a bug in Edge, which, as
	        Microsoft's latest browser, may need to be supported */
	
	    $target = $target.prev();
	    /* Might be needed in future, but needs to be rewritten to follow code structure we're targeting */
	    // if (!$target.length || !$target.get(0).isEqualNode(this.element[0])) {
	    //     return;
	    // }
	
	    if (event.which >= 32) {
	      /* Safari does not have key */
	      var key = event.key ? event.key : String.fromCharCode(event.which);
	
	      if (key.length === 1) {
	        $search.val(key);
	      }
	
	      selectElement.select2('open');
	
	      var selectObj = selectElement.data('select2');
	      selectObj.trigger('query', { term: key });
	
	      // NOTE: select2 component is full of setTimeout functions, so the only way to work around the search input is to put our own in.
	      setTimeout(function () {
	        $search.caret(1);
	      }, 0);
	    }
	  }
	}

/***/ },
/* 23 */,
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.instantiateSwitchery = instantiateSwitchery;
	exports.setSwitchery = setSwitchery;
	exports.setSwitcheryWithoutChange = setSwitcheryWithoutChange;
	exports.enableSwitchery = enableSwitchery;
	exports.disableSwitchery = disableSwitchery;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _switchery = __webpack_require__(481);
	
	var _switchery2 = _interopRequireDefault(_switchery);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function instantiateSwitchery(els) {
		var jsOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		var res = [];
		var clsName = getAdditionalFieldsClass(els);
		els.each(function () {
			var el = (0, _jquery2.default)(this);
			if (!el.data(clsName)) {
				var options = (0, _collectDataAttributesFor2.default)(el.get(0), { prefix: clsName });
				options = _jquery2.default.extend({}, options, jsOpts);
				var sw = (0, _switchery2.default)(this, options);
				el.data(clsName, sw);
			}
			res.push(el.data(clsName));
		});
		return res;
	};
	
	function getAdditionalFieldsClass(els) {
		var clsName;
		els.each(function () {
			var ele = (0, _jquery2.default)(this);
			for (var i = 0; i < ele.length; i++) {
				var clssName = ele[i].className;
				if (clssName.includes("reference-show-field-switchery")) {
					clsName = "reference-show-field-switchery";
				} else if (clssName.includes("department-show-field-switchery")) {
					clsName = "department-show-field-switchery";
				} else if (clssName.includes("po-show-field-switchery")) {
					clsName = "po-show-field-switchery";
				} else if (clssName.includes("invoice-show-field-switchery")) {
					clsName = "invoice-show-field-switchery";
				} else if (clssName.includes("reference-required-field-switchery")) {
					clsName = "reference-required-field-switchery";
				} else if (clssName.includes("reference-custom-label-switchery")) {
					clsName = "reference-custom-label-switchery";
				} else if (clssName.includes("department-required-field-switchery")) {
					clsName = "department-required-field-switchery";
				} else if (clssName.includes("department-custom-label-switchery")) {
					clsName = "department-custom-label-switchery";
				} else if (clssName.includes("po-required-field-switchery")) {
					clsName = "po-required-field-switchery";
				} else if (clssName.includes("po-custom-label-switchery")) {
					clsName = "po-custom-label-switchery";
				} else if (clssName.includes("invoice-required-field-switchery")) {
					clsName = "invoice-required-field-switchery";
				} else if (clssName.includes("invoice-custom-label-switchery")) {
					clsName = "invoice-custom-label-switchery";
				} else {
					clsName = "js-switchery";
				}
			}
		});
		return clsName;
	}
	
	function setSwitchery(switchElement, checkedBool) {
		var clsName = getAdditionalFieldsClass(switchElement);
		if (switchElement instanceof _jquery2.default) {
			switchElement = switchElement.data(clsName);
		}
	
		if (checkedBool && !switchElement.isChecked() || !checkedBool && switchElement.isChecked()) {
			switchElement.setPosition(true);
			switchElement.handleOnchange(true);
		}
	};
	
	function setSwitcheryWithoutChange(switchElement, checkedBool) {
		var clsName = getAdditionalFieldsClass(switchElement);
		if (switchElement instanceof _jquery2.default) {
			switchElement = switchElement.data(clsName);
		}
	
		if (checkedBool && !switchElement.isChecked() || !checkedBool && switchElement.isChecked()) {
			switchElement.setPosition(true);
		}
	};
	
	function enableSwitchery(switchElement) {
		var clsName = getAdditionalFieldsClass(switchElement);
		if (switchElement instanceof _jquery2.default) {
			switchElement = switchElement.data(clsName);
		}
		switchElement.enable();
	};
	
	function disableSwitchery(switchElement) {
		var clsName = getAdditionalFieldsClass(switchElement);
		if (switchElement instanceof _jquery2.default) {
			switchElement = switchElement.data(clsName);
		}
		switchElement.disable();
	};

/***/ },
/* 25 */,
/* 26 */
/***/ function(module, exports) {

	module.exports = "<div class=\"dropdown q-dropdown dropdown-parent-{%- index %} q-block-at-md overflow-dropdown\"> <a class=\"base-btn purple-btn v2-btn q-block-at-md\" href=# data-toggle=dropdown role=button aria-haspopup=true aria-expanded=true><span class=\"fa fa-chevron-down\"></span></a> <ul class=\"dropdown-menu overflow-dropdown-menu q-dropdown-left q-dropdown-no-max q-dropdown-full-at-mid\" data-parent-index=\"{%- index %}\"> {%= list %} </ul> </div>";

/***/ },
/* 27 */
/***/ function(module, exports) {

	module.exports = "<li> <a href=# class=\"action-link {%- cls %} {% if (disabled) { %} disabled {% } %}\"> <i class=\"fa fa-{%- icon %}\" aria-hidden=true></i> {%- title %} </a> </li>";

/***/ },
/* 28 */,
/* 29 */,
/* 30 */
/***/ function(module, exports) {

	module.exports = "<div class=\"action-header-btn dropdown q-dropdown q-block-at-md overflow-dropdown dropdown-parent-header\"> <a class=\"base-btn purple-btn q-block-at-md disabled\" href=# data-toggle=dropdown role=button aria-haspopup=true aria-expanded=true> <div class=btn-text-wrap> <span class=btn-text> Actions <span class=\"fa fa-chevron-down q-marg-left-xxxs\"></span> </span> </div> </a> <ul class=\"dropdown-menu q-dropdown-left q-dropdown-no-max q-dropdown-full-at-mid overflow-dropdown-menu\" data-parent-index=header> {%= list %} </ul> </div>";

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _additions = __webpack_require__(465);
	
	var _additions2 = _interopRequireDefault(_additions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var Velocity = __webpack_require__(1579);
	__webpack_require__(1065);
	
	
	var inputsSelector = "input, select, textarea";
	var customValidatorSelector = "[data-qw-custom-validator]";
	var validatableSelector = inputsSelector + ', ' + customValidatorSelector;
	
	var notInputsSelector = ":submit, :reset, :image";
	var hiddenDisabledSelector = ":hidden, :disabled";
	var baseVelocityOpts = {
	  duration: 300,
	  easing: "ease"
	};
	/*
	*   Long Term Todos For QuickWizard:
	*     none
	*
	*
	*
	*/
	//
	// export QuickWizard to window
	// so it can be referenced in the theme repo
	// for external use (ricochet) and internal bundle
	window.QuickWizard = QuickWizard;
	
	function QuickWizard(el) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  $ = options.$ || $;
	  var self = this;
	  var _formWasReady = false;
	  var _formWasAttempted = false;
	  var shouldStopRecurseAdjustHeightToCurrentForm = false;
	
	  self.options = options;
	  var customRules = self.options.customRules;
	  var errorCheckDeferredArray = [];
	
	  var wizardElement = $(el);
	  self.wind = $(window);
	
	  self.getWizardElement = function () {
	    return wizardElement;
	  };
	
	  if (!wizardElement.length) {
	    throw "First argument to QuickForm must be an element";
	  }
	
	  // public functions
	  self.init = function () {
	    findElements();
	    addValidationMethods();
	    calcAndSetWidthOfStepLinks();
	    addStepNumbersToStepLinks();
	    setDefaultActiveLink();
	    slideToActiveForm();
	    determineVisibleBtns();
	    bindElements();
	  };
	
	  self.destroy = function () {
	    $(window).off("resize", handleResize);
	    wizardElement.off("wizard:reconcileHeight", adjustHeightOfFormsOuterToCurrentForm);
	    $(document).off("focusout qwcustomchange", handleInputchangeForCurrentForm);
	  };
	
	  // public functions
	
	  // this method set all the inputs on the tab to disable.
	  self.setTabDisabled = function (tabArr) {
	    tabArr.map(function (tabEl) {
	      $(tabEl + ' :input').attr('disabled', true);
	      $(tabEl + ' a').addClass('disabled');
	    });
	  };
	
	  self.findValidatableElementsForScope = findValidatableElementsForScope;
	
	  self.allPreviousFieldsUpToTargetForm = function (targetForm) {
	    return findValidatableElementsForScope(targetForm.prevAll());
	  };
	
	  self.gotToForm = function (form) {
	    var link = getLinkFromForm(form);
	    attemptTraversalToTargetLink(link);
	  };
	
	  self.goToFirstIncompleteForm = function () {
	    var form = self.getFirstIncompleteForm();
	    self.gotToForm(form);
	  };
	
	  self.getFirstIncompleteForm = function () {
	    var forms = self.getForms();
	
	    // initialize firstInvalidForm with first form
	    // incase no other forms are valid/finished.
	    var firstInvalidForm = forms.get(0);
	
	    // FYI: use es2015 find function, NOT jquery find,
	    // this allows for short circuit filtering, which 
	    // jquery does not
	    firstInvalidForm = self.getForms().toArray().find(function (el) {
	      var form = $(el);
	      var inputs = findValidatableElementsForScope(form).not(notInputsSelector);
	
	      // if given form is not valid,
	      // short circuit
	      if (!self.areInputsValid(inputs)) {
	        return true;
	      }
	    });
	
	    return $(firstInvalidForm);
	  };
	
	  function getCurrentDirection(currentLink, targetLink) {
	    var currentDirection = void 0;
	    var currentLinkLength = currentLink.prevAll().length;
	    var targetLinkLength = targetLink.prevAll().length;
	    if (targetLinkLength < currentLinkLength) {
	      currentDirection = "BACKWARDS";
	    } else {
	      currentDirection = "FORWARDS";
	    }
	    return currentDirection;
	  }
	
	  function findValidatableElementsForScope(scope) {
	    return scope.find(validatableSelector);
	  }
	
	  self.hasAjaxValidationsPending = function () {
	    return errorCheckDeferredArray.length;
	  };
	
	  function removeErrorsInternallyInJQueryValidation(validator, els) {}
	
	  // USE THIS PUBLIC VALIDATING FUNCTION
	  // INSTEAD OF JQUERY VALID()
	  // so you get custom validations
	  // that are NOT element specific
	  self.areInputsValid = function (inputs) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        displayErrors = _ref.displayErrors,
	        validationsComplete = _ref.validationsComplete,
	        shouldFilter = _ref.filterAutoValidate;
	
	    if (self.hasAjaxValidationsPending()) {
	      return "pending";
	    }
	    var result = true;
	    var validator = wizardElement.validate();
	
	    var el = validator.elements();
	    if (shouldFilter) {
	      el = filterAutoValidate(el);
	    }
	
	    var jValidateEls = inputs.filter(el);
	
	    // check jquery inputs 'valid' first
	    jValidateEls.each(function () {
	      var input = $(this);
	      // validator.check() softly sets errors
	      // within it's local error storage, which
	      // is bad for use because jquery validation
	      // then shows the error on it's next iteration
	
	      setResult((0, _additions2.default)(validator, input, { $: $ }));
	    });
	    // console.log(result);
	    // validator.valid() does a SOFT validation
	    // setResult(validator.valid());
	
	    // validator.resetForm();
	
	    if (displayErrors) {
	      // validator.prepareForm();
	      // validator.resetForm();
	      // elements.valid() does a HARD validation
	      jValidateEls.length && jValidateEls.valid();
	    }
	
	    if (customRules) {
	      // First, remove inputs that jquery validate
	      // cares about because we don't need them.
	      // Second, filter any given element within
	      // the customRules argument selector that is within inputs var.
	      // If so, call custom validation, loop over customRules
	      // calling given isValid cb.
	      // if returns false, show error via selector, else hide
	      inputs = inputs.filter(customValidatorSelector);
	
	      (0, _underscore2.default)(customRules).each(function (_ref2, selector) {
	        var isValid = _ref2.isValid,
	            errorMessageSelector = _ref2.errorMessageSelector;
	
	        var input = inputs.filter(selector);
	        if (input.length) {
	          var handleErrors = function handleErrors(valid) {
	            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            // console.log(`handleErrors called with: ${valid}`);
	            if (valid) {
	              setResult(true);
	              if (displayErrors || options.displayErrors) {
	                hide(errorEl);
	              }
	            } else {
	              setResult(false);
	              if (displayErrors || options.displayErrors) {
	                show(errorEl);
	              }
	            }
	          };
	
	          var createDeferredDoneCb = function createDeferredDoneCb() {
	            var deferred = new $.Deferred();
	            errorCheckDeferredArray.push(deferred);
	            return function (isValidRetVal) {
	              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	              var idx = (0, _underscore2.default)(errorCheckDeferredArray).indexOf(deferred);
	              errorCheckDeferredArray.splice(idx, 1);
	              handleErrors(isValidRetVal, options);
	              deferred.resolve(isValidRetVal);
	            };
	          };
	
	          var errorEl = $(errorMessageSelector);
	          var doneCb = createDeferredDoneCb();
	          var isValidValue = isValid({ input: input, done: doneCb });
	
	          if (isValidValue !== doneCb) {
	            doneCb(isValidValue);
	          }
	        }
	      });
	    }
	
	    // handle callback style validation
	    // in order to facilitate ajax based validation
	    if (validationsComplete) {
	      var _$;
	
	      (_$ = $).when.apply(_$, errorCheckDeferredArray).then(function () {
	        return validationsComplete(result);
	      });
	    } else {
	      return result;
	    }
	
	    function setResult(res) {
	      // only set result if it hasn't
	      // been set yet OR if it's not false already
	      if (result !== false) {
	        result = res;
	      }
	    }
	  };
	
	  self.getForms = getForms.bind(self);
	  self.getActiveTargetForm = getActiveTargetFormFromLink.bind(self);
	  self.formIsReadyNow = formIsReadyNow.bind(self);
	
	  // private functions
	
	  function filterAutoValidate(el) {
	    var _this = this;
	
	    return el.filter(function () {
	      return $(_this).data("qw-auto-validate") !== "false";
	    });
	  }
	
	  function findElements() {
	    self.qwNavLinks = wizardElement.find('.qw-nav-step');
	    self.nextBtn = wizardElement.find('.qw-next');
	    self.prevBtn = wizardElement.find('.qw-prev');
	  }
	
	  function getLinkFromForm(form) {
	    form = $(form).get(0);
	    if (!form) {
	      return $();
	    }
	
	    return self.qwNavLinks.filter(function () {
	      return $($(this).data("qw-form-target")).get(0) === form;
	    });
	  }
	
	  function addStepNumbersToStepLinks() {
	    self.qwNavLinks.each(function (i, el) {
	      el = $(el);
	      i = i + 1;
	      var stepNum = el.find('.qw-step-num');
	      if (!stepNum.length) {
	        stepNum = $("<span class='qw-step-num'></span>");
	        el.prepend(stepNum);
	      }
	      stepNum.text(i);
	    });
	  }
	
	  function formIsReadyNow() {
	    quickPulse(self.nextBtn);
	  }
	
	  function calcAndSetWidthOfStepLinks() {
	    var tl = totalLinks();
	    var perc = 100 / tl;
	    self.qwNavLinks.css({ width: perc + '%' });
	  }
	
	  function totalLinks() {
	    return self.qwNavLinks.length;
	  }
	
	  function recurseAdjustHeightToCurrentForm() {
	    if (shouldStopRecurseAdjustHeightToCurrentForm || wizardElement.is(":hidden")) {
	      return;
	    }
	    adjustHeightOfFormsOuterToCurrentForm();
	    return setTimeout(recurseAdjustHeightToCurrentForm.bind(self), 1000);
	  }
	
	  function bindElements() {
	    // ALL RESIZE HANDLES
	    $(window).on("resize", handleResize);
	    handleResize();
	
	    recurseAdjustHeightToCurrentForm();
	
	    wizardElement.on("wizard:reconcileHeight", adjustHeightOfFormsOuterToCurrentForm);
	
	    // NAV LINK CLICK
	    self.qwNavLinks.bind('click', function (e) {
	      e.preventDefault();
	      var el = $(this);
	      self.options.onNavLinkClick && self.options.onNavLinkClick(e, { targetLink: el, wizardElement: wizardElement });
	      attemptTraversalToTargetLink(el);
	    });
	
	    // NEXT BTN CLICK
	    self.nextBtn.on('click', function (e) {
	      e.preventDefault();
	      var currentLink = getActiveLink();
	      var targetLink = currentLink.next();
	      if (!targetLink.length) {
	        return;
	      }
	      self.options.onNextBtnClick && self.options.onNextBtnClick(e, { targetLink: targetLink, wizardElement: wizardElement });
	      attemptTraversalToTargetLink(targetLink);
	    });
	
	    // PREV BTN CLICK
	    self.prevBtn.on('click', function (e) {
	      e.preventDefault();
	      var currentLink = getActiveLink();
	      var targetLink = currentLink.prev();
	      if (!targetLink.length) {
	        return false;
	      }
	      self.options.onNextPrevClick && self.options.onNextPrevClick(e, { targetLink: targetLink, wizardElement: wizardElement });
	      attemptTraversalToTargetLink(targetLink);
	    });
	
	    // ORIGINALLY: change keyup blur paste qwcustomchange
	    // we are changing to just focusout and custom event.
	    // This will help
	    $(document).on("focusout qwcustomchange", handleInputchangeForCurrentForm);
	    // if(self.options.enableAutoValidateAllOnFocusout){
	    //   $(document).on("focusout qwcustomchange", handleInputchangeForCurrentForm.bind(self));
	    // }
	    // $(document).on("keydown", handleTabKeyDown.bind(self));
	  }
	
	  // tabbing bugfix is inherently non-existent
	  // now because the only visible form now is
	  // the one that is active.
	
	  // function handleTabKeyDown(e){
	  //   if (e.keyCode === 9) {
	  //     const form = getActiveTargetFormFromLink();
	  //     const inputs = form.find(inputsSelector).not(notInputsSelector).not(hiddenDisabledSelector);
	  //     const currentInput = e.target;
	  //     const lastInput = inputs.last();
	  //     // first check, simply see if the input is the last input
	  //     // on the current form, if so, don't tab to next!
	  //     if(currentInput === lastInput.get(0)){
	  //       e.preventDefault();
	  //       self.nextBtn.focus();
	  //       return;
	  //     }
	
	  //     let s2 = lastInput.data('select2');
	
	  //     // second check, if we are using a wrapped select
	  //     // via select2 plugin, get the actual focused select2
	  //     // and compare it to the target input
	  //     if(s2 && s2.$selection && s2.$selection.filter($(currentInput)).length){
	  //       e.preventDefault();
	  //       self.nextBtn.focus();
	  //     } 
	  //   }
	  // }
	
	  function handleInputchangeForCurrentForm(e) {
	    var currentInput = $(e.target);
	    var currentForm = getActiveTargetFormFromLink();
	    if (currentForm.find(currentInput).length) {
	      // const currentInputs = findValidatableElementsForScope(currentForm);
	      self.options.onInputChange && self.options.onInputChange({ currentForm: currentForm, currentInputs: currentInputs, currentInput: currentInput });
	      onInputChange(currentInput);
	    }
	  }
	
	  var debouncedInputChange = _underscore2.default.debounce(onInputChange, 400);
	
	  function onInputChange(currentInputs) {
	    currentInputs = currentInputs.not(notInputsSelector);
	
	    // if the form was already attempted to traverse to the next form,
	    // do a full validation and display erors
	    var inputsValid = self.areInputsValid(currentInputs, {
	      displayErrors: false,
	      filterAutoValidate: true
	    });
	
	    // if the form was not ready and the inputs are valid,
	    // execute the formIsReady function
	    if (!_formWasReady && inputsValid) {
	      self.formIsReadyNow();
	      _formWasReady = true;
	    }
	    // if the inputs are not valid,
	    // then the form is was no longer ready
	    else if (!inputsValid) {
	        _formWasReady = false;
	      }
	  }
	
	  function handleResize() {
	    // make sure that the width of the form
	    // is not affecting the translateX value
	    // of the sliding logic
	    slideToActiveForm({ noAnimation: true });
	    handleNavStepsResize();
	  }
	
	  function handleNavStepsResize() {
	    if (_underscore2.default.isNumber(self.options.mobileWidthNavStep)) {
	      if (self.wind.width() < self.options.mobileWidthNavStep) {
	        swapClasses(self.qwNavLinks, { fromClasses: "qw-nav-step-tablet", toClasses: "qw-nav-step-mobile" });
	      } else if (self.wind.width() < self.options.tabletWidthNavStep) {
	        swapClasses(self.qwNavLinks, { fromClasses: "qw-nav-step-mobile", toClasses: "qw-nav-step-tablet" });
	      } else {
	        self.qwNavLinks.removeClass("qw-nav-step-mobile qw-nav-step-tablet");
	      }
	    }
	  }
	
	  function swapClasses(el, _ref3) {
	    var fromClasses = _ref3.fromClasses,
	        toClasses = _ref3.toClasses;
	
	    el.removeClass(fromClasses);
	    el.addClass(toClasses);
	  }
	
	  function determineVisibleBtns() {
	    var currentLink = getActiveLink();
	    if (self.qwNavLinks.last().get(0) === currentLink.get(0)) {
	      hide(self.nextBtn);
	    } else {
	      show(self.nextBtn);
	    }
	
	    if (self.qwNavLinks.first().get(0) === currentLink.get(0)) {
	      hide(self.prevBtn);
	    } else {
	      show(self.prevBtn);
	    }
	  }
	
	  function hide(el) {
	    el.css('display', 'none');
	  }
	
	  function show(el) {
	    el.css('display', 'block');
	  }
	
	  function getTraversalDirection(current, target) {
	    var direction = "BACKWARDS";
	    // if current link is before target link, direction is FORWARDS
	    if (target.prevAll(current).length) {
	      direction = 'FORWARDS';
	    }
	    return direction;
	  }
	
	  function attemptTraversalToTargetLink(el) {
	    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        skipCallbacks = _ref4.skipCallbacks;
	
	    // return if:
	    // 1. we already on the current active form,
	    // 2. we have pending error checking ajax calls
	    if (el.hasClass('active') || self.hasAjaxValidationsPending()) {
	      return;
	    }
	
	    var targetForm = getTargetFormFromLink(el);
	    var currentLink = getActiveLink();
	    var currentForm = getTargetFormFromLink(currentLink);
	
	    var direction = getTraversalDirection(currentLink, el);
	    // console.log(direction);
	    //This direction was not returned correct, hence wrote a method to fix it 
	    var currentDirection = getCurrentDirection(currentForm, targetForm);
	
	    var canNav = true;
	    if (!skipCallbacks) {
	      canNav = self.options.shouldNavigateToForm && self.options.shouldNavigateToForm({ currentForm: currentForm, targetForm: targetForm, direction: direction, done: done });
	    }
	
	    // if we are given back the callback
	    // that we had originally passed in,
	    // the developer is indicating that
	    // we need to what for him/her to
	    // call this callback to actually
	    // get a value that we can rely
	    // on to determine if we can actually
	    // navigate
	
	    // So, if the value returned from shouldNavigateToForm
	    // is NOT our callback we passed in, we can assume
	    // we can just manually call it ourselves (ie. no ajax).
	    // Otherwise, don't call the callback, and wait
	    // for developer to call it when ajax is finished
	    if (canNav !== done) {
	      done(canNav);
	    }
	
	    function done(canNav) {
	      if (canNav !== false) {
	        var allPrevLinks = getAllLinksBefore(el);
	        makeLinkVisited(allPrevLinks);
	        makeLinkActive(el);
	        slideToActiveForm();
	        slideToTopOfWizard();
	        adjustHeightOfFormsOuterToForm(targetForm);
	        determineVisibleBtns();
	        // we are on a new form, so it is not ready to start
	        _formWasReady = false;
	        _formWasAttempted = false;
	        self.options.didNavigateToForm && self.options.didNavigateToForm({ currentForm: targetForm, previousForm: currentForm, currentDirection: currentDirection });
	      } else {
	        _formWasAttempted = true;
	        quickShake(currentForm.children(".qw-form-inner"));
	      }
	    }
	  }
	
	  self.didAttemptToNavigateAwayFromCurrentForm = function () {
	    return _formWasAttempted;
	  };
	
	  function showAllForms() {
	    getForms().css("visibility", "visible");
	  }
	
	  function hideAllFormsExcept(form) {
	    getForms().css("visibility", "hidden");
	    form.css("visibility", "visible");
	  }
	
	  function adjustHeightOfFormsOuterToForm(form) {
	    getFormsOuter().css({
	      height: form.outerHeight() + "px"
	    });
	  }
	
	  function adjustHeightOfFormsOuterToCurrentForm() {
	    adjustHeightOfFormsOuterToForm(getActiveTargetFormFromLink());
	  }
	
	  function getFormsOuter() {
	    return wizardElement.find('.qw-forms-outer').first();
	  }
	
	  function slideToTopOfWizard() {
	    $('html, body').animate({ scrollTop: wizardElement.offset().top + "px" }, 200);
	  }
	
	  function quickShake(el) {
	    el.addClass('quick-shake');
	    setTimeout(function () {
	      el.removeClass('quick-shake');
	    }, 500);
	  }
	
	  function quickPulse(el) {
	    el.addClass('quick-pulse');
	    setTimeout(function () {
	      el.removeClass('quick-pulse');
	    }, 400);
	  }
	
	  function makeLinkVisited(el) {
	    getAllLinks().removeClass('visited');
	    el.addClass('visited');
	  }
	
	  function makeLinkActive(el) {
	    self.qwNavLinks.removeClass('active');
	    el.addClass('active');
	  }
	
	  function getIndexOf(form, forms) {
	    return forms.index(form);
	  }
	
	  function slideToActiveForm() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var dur = 300;
	    if (options.noAnimation) {
	      dur = 0;
	    }
	    var targetForm = getActiveTargetFormFromLink();
	    var forms = getForms();
	    var formsArray = forms.toArray();
	    var idx = getIndexOf(targetForm, forms);
	    var formWidth = targetForm.outerWidth();
	    var left = 0 - idx * formWidth;
	
	    showAllForms();
	
	    Velocity(formsArray, "stop");
	    Velocity(forms.toArray(), {
	      translateX: left + "px"
	    }, _extends({}, baseVelocityOpts, {
	      duration: dur,
	      complete: function complete() {
	        hideAllFormsExcept(targetForm);
	      }
	    }));
	  }
	
	  function getActiveTargetFormFromLink() {
	    var activeLink = getActiveLink();
	    return getTargetFormFromLink(activeLink);
	  }
	
	  function getTargetFormFromLink(link) {
	    return wizardElement.find(link.data('qw-form-target'));
	  }
	
	  function getActiveLink() {
	    var activeLink = self.qwNavLinks.filter(".active");
	    if (!activeLink.length) {
	      activeLink = self.qwNavLinks.first();
	    } else if (activeLink.length > 1) {
	      activeLink = activeLink.first();
	    }
	    return activeLink;
	  }
	
	  function getAllLinks() {
	    return self.qwNavLinks;
	  }
	
	  function getAllLinksBefore(link) {
	    return link.prevAll(".qw-nav-step");
	  }
	
	  function setDefaultActiveLink() {
	    getActiveLink().addClass('active');
	  }
	
	  function getForms() {
	    return wizardElement.find('.qw-form');
	  }
	  function addValidationMethods() {
	    $.validator.addMethod("notAllSpaces", function (value, element) {
	      return value.trim().length != 0;
	    }, "Value can't be all spaces");
	  }
	}
	
	exports.default = QuickWizard;

/***/ },
/* 32 */,
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = QuickBtnGroup;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1063);
	
	
	//options = multi = true,
	function QuickBtnGroup(quickBtnGroup) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var self = this;
	  self.options = options;
	
	  self.init = function () {
	    bindElements();
	    distributeBtnWidthEqually();
	    activateInitialKey();
	    handleDisable();
	  };
	
	  self.activateBtnViaKey = function (btnKey) {
	    var btn = getBtnViaKey(btnKey);
	    deactivateAllBtnEls();
	    activateBtnEl(btn);
	    updateHiddenInputToReflectBtn(btn);
	    btn.trigger('click');
	  };
	
	  function bindElements() {
	    getBtns().on('click', onBtnClick);
	  }
	
	  function onBtnClick(e) {
	    e.preventDefault();
	    if (isAllDisabled()) {
	      return;
	    }
	
	    var btn = (0, _jquery2.default)(e.target);
	    var btnKey = btn.data('qb-key');
	
	    self.options.onBtnClick && self.options.onBtnClick({ btn: btn, btnKey: btnKey });
	    if (self.options.manualActivation) {
	      return;
	    }
	    var canNav = true;
	    canNav = self.options.shouldActivateBtn && self.options.shouldActivateBtn({ btn: btn, btnKey: btnKey });
	    if (canNav !== false && options.multi) {
	      checkForActiveMulti(btn);
	    } else if (canNav !== false) {
	      deactivateAllBtnEls();
	      activateBtnEl(btn);
	      updateHiddenInputToReflectBtn(btn);
	      self.options.didActivateBtn && self.options.didActivateBtn({ btn: btn, btnKey: btnKey });
	    }
	  }
	
	  self.getActiveBtnKey = function () {
	    return getHiddenInput().val();
	  };
	
	  function checkForActiveMulti(btn) {
	    if (btn.hasClass('active')) {
	      btn.removeClass('active');
	      updateHiddenInputToReflectBtn(btn);
	    } else {
	      activateBtnEl(btn);
	      updateHiddenInputToReflectBtn(btn);
	      self.options.didActivateBtn && self.options.didActivateBtn({ btn: btn, btnKey: btnKey });
	    }
	  }
	
	  function activateInitialKey() {
	    var initialActiveKey = self.options.initialActiveKey;
	
	    var activeBtns = (0, _jquery2.default)();
	
	    if (initialActiveKey) {
	      activeBtns = getBtnViaKey(initialActiveKey);
	    } else if (getActiveBtnsFromClass().length) {
	      activeBtns = getActiveBtnsFromClass();
	    }
	
	    if (activeBtns.length) {
	      deactivateAllBtnEls();
	      activateBtnEl(activeBtns);
	      updateHiddenInputToReflectBtn(activeBtns);
	    }
	  }
	
	  function updateHiddenInputToReflectBtn(btn) {
	    var btnKey = "";
	    if (options.multi) {
	      var btnGroup = btn.closest(".multi-btn-group");
	      _jquery2.default.each(btnGroup.find('.active'), function (i, v) {
	        btnKey += (0, _jquery2.default)(v).data("qbKey") + ",";
	      });
	      btnKey = btnKey.slice(0, -1);
	    } else {
	      btnKey = btn.data('qb-key');
	    }
	    var hiddenInput = getHiddenInput();
	    hiddenInput.val(btnKey);
	    hiddenInput.trigger("change");
	  }
	
	  function handleDisable() {
	    if (isAllDisabled()) {
	      getBtns().addClass("disabled");
	    }
	  }
	
	  function isAllDisabled() {
	    return options.disableAll;
	  }
	
	  function distributeBtnWidthEqually() {
	    if (self.options.distributeWidth) {
	      var tl = totalBtns();
	      var perc = 100 / tl;
	      getBtns().css({ width: perc + "%" });
	    }
	  }
	
	  function getBtnViaKey(btnKey) {
	    return getBtns().filter(function () {
	      return (0, _jquery2.default)(this).data('qb-key') === btnKey;
	    });
	  }
	
	  function getBtns() {
	    return quickBtnGroup.find('.q-btn');
	  }
	
	  function totalBtns() {
	    return getBtns().length;
	  }
	
	  function getActiveBtnsFromClass() {
	    return getBtns().filter(".active");
	  }
	
	  function deactivateAllBtnEls() {
	    getBtns().removeClass('active');
	  }
	  function activateBtnEl(btn) {
	    btn.addClass('active');
	  }
	  function getHiddenInput() {
	    return quickBtnGroup.find(".quick-btn-group-hidden-input");
	  }
	}

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
	  function getOwnPropertyDescriptors(obj) {
	    var keys = Object.keys(obj);
	    var descriptors = {};
	    for (var i = 0; i < keys.length; i++) {
	      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
	    }
	    return descriptors;
	  };
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  if (typeof process !== 'undefined' && process.noDeprecation === true) {
	    return fn;
	  }
	
	  // Allow for deprecating things in the process of starting up.
	  if (typeof process === 'undefined') {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnvRegex = /^$/;
	
	if (process.env.NODE_DEBUG) {
	  var debugEnv = process.env.NODE_DEBUG;
	  debugEnv = debugEnv.replace(/[|\\{}()[\]^$+?.]/g, '\\$&')
	    .replace(/\*/g, '.*')
	    .replace(/,/g, '$|^')
	    .toUpperCase();
	  debugEnvRegex = new RegExp('^' + debugEnv + '$', 'i');
	}
	exports.debuglog = function(set) {
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (debugEnvRegex.test(set)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').slice(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.slice(1, -1);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	exports.types = __webpack_require__(1578);
	
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	exports.types.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	exports.types.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	exports.types.isNativeError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(1577);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(1474);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
	
	exports.promisify = function promisify(original) {
	  if (typeof original !== 'function')
	    throw new TypeError('The "original" argument must be of type Function');
	
	  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
	    var fn = original[kCustomPromisifiedSymbol];
	    if (typeof fn !== 'function') {
	      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
	    }
	    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	      value: fn, enumerable: false, writable: false, configurable: true
	    });
	    return fn;
	  }
	
	  function fn() {
	    var promiseResolve, promiseReject;
	    var promise = new Promise(function (resolve, reject) {
	      promiseResolve = resolve;
	      promiseReject = reject;
	    });
	
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	    args.push(function (err, value) {
	      if (err) {
	        promiseReject(err);
	      } else {
	        promiseResolve(value);
	      }
	    });
	
	    try {
	      original.apply(this, args);
	    } catch (err) {
	      promiseReject(err);
	    }
	
	    return promise;
	  }
	
	  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
	
	  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
	    value: fn, enumerable: false, writable: false, configurable: true
	  });
	  return Object.defineProperties(
	    fn,
	    getOwnPropertyDescriptors(original)
	  );
	}
	
	exports.promisify.custom = kCustomPromisifiedSymbol
	
	function callbackifyOnRejected(reason, cb) {
	  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
	  // Because `null` is a special error value in callbacks which means "no error
	  // occurred", we error-wrap so the callback consumer can distinguish between
	  // "the promise rejected with null" or "the promise fulfilled with undefined".
	  if (!reason) {
	    var newReason = new Error('Promise was rejected with a falsy value');
	    newReason.reason = reason;
	    reason = newReason;
	  }
	  return cb(reason);
	}
	
	function callbackify(original) {
	  if (typeof original !== 'function') {
	    throw new TypeError('The "original" argument must be of type Function');
	  }
	
	  // We DO NOT return the promise as it gives the user a false sense that
	  // the promise is actually somehow related to the callback's execution
	  // and that the callback throwing will reject the promise.
	  function callbackified() {
	    var args = [];
	    for (var i = 0; i < arguments.length; i++) {
	      args.push(arguments[i]);
	    }
	
	    var maybeCb = args.pop();
	    if (typeof maybeCb !== 'function') {
	      throw new TypeError('The last argument must be of type Function');
	    }
	    var self = this;
	    var cb = function() {
	      return maybeCb.apply(self, arguments);
	    };
	    // In true node style we process the callback on `nextTick` with all the
	    // implications (stack, `uncaughtException`, `async_hooks`)
	    original.apply(this, args)
	      .then(function(ret) { process.nextTick(cb.bind(null, null, ret)) },
	            function(rej) { process.nextTick(callbackifyOnRejected.bind(null, rej, cb)) });
	  }
	
	  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
	  Object.defineProperties(callbackified,
	                          getOwnPropertyDescriptors(original));
	  return callbackified;
	}
	exports.callbackify = callbackify;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(193)))

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unbindAll = unbindAll;
	exports.extractElements = extractElements;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unbindAll(views) {
	  (0, _underscore2.default)(views).each(function (view) {
	    view.unbindListeners();
	  });
	}
	
	function extractElements(views) {
	  return views.map(function (view) {
	    return view.getElement();
	  });
	}

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addressValidationFactory;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _AddressEventBus = __webpack_require__(111);
	
	var _AddressEventBus2 = _interopRequireDefault(_AddressEventBus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	//import { truncate } from 'fs-extra';
	
	function addressValidationFactory(el, scopeForData) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var isAlreadyValid = options.isAlreadyValid,
	      currentTab = options.currentTab;
	
	  if (!el) {
	    // if el passed as null, then user currentTab div to asociate an AddressValidation instance instead of attaching to same address valiadtion modal div.
	    el = (0, _jquery2.default)(currentTab);
	  }
	
	  var addressValidation = el.data('address-validation-modal');
	  if (addressValidation) {
	    return addressValidation;
	  } else {
	    addressValidation = new AddressValidation(el, scopeForData, options);
	    addressValidation.init();
	    el.data('address-validation-modal', addressValidation);
	    return addressValidation;
	  }
	}
	
	function AddressValidation(el, scopeForData) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	
	  var self = this;
	  //const scopeForData = wizard.getscopeForData();
	  self.options = options;
	  var isAlreadyValid = options.isAlreadyValid,
	      currentTab = options.currentTab,
	      disableUserEnteredAddressRadio = options.disableUserEnteredAddressRadio,
	      disableSubmitAddressBtnIfInvalidAddress = options.disableSubmitAddressBtnIfInvalidAddress;
	
	  var els = {};
	  var done = void 0;
	  var addressResponse = {};
	  var namespace = "";
	  self.init = function () {
	    setElements();
	    bindElements();
	  };
	
	  var validateWizardAddressURL = scopeForData.data("address-validation-url");
	  var rtlAddressValidationLevel = scopeForData.data("rtl-address-validation-level");
	  var screenName = scopeForData.data("address-validation-for");
	  var generalErrorMessage = scopeForData.data("general-error-message");
	  var addressFoundTitleText = scopeForData.data("add-validation-add-found-title-text");
	  var addressNotFoundText = scopeForData.data("add-validation-system-not-found-add-text");
	  var fedexCrossBorderAdd = scopeForData.data("add-validation-cross-border-address");
	  var valReqdCountries = scopeForData.data("validation-reqd-countries");
	
	  console.log('screenName :' + screenName);
	
	  function setElements() {
	    screenSpecificFuncs[screenName + "SetElements"]();
	    setComboElement();
	  }
	
	  self.setIsAlreadyValid = function (val) {
	    isAlreadyValid = val;
	  };
	
	  self.getAlreadyValid = function () {
	    return isAlreadyValid;
	  };
	
	  self.getAddressResponse = function () {
	    return addressResponse;
	  };
	
	  self.resetAddressResponse = function () {
	    addressResponse = {};
	  };
	
	  function isValidationReqdCountry() {
	    //console.log(valReqdCountries);
	    var cVal = els.country.val();
	    var isValidCountry = false;
	    (0, _jquery2.default)(valReqdCountries).each(function () {
	      if (screenName === "asn" && this.cdmValue === cVal) {
	        isValidCountry = true;
	        return false;
	      } else if (screenName === "order" && this.cdmMeaning === cVal) {
	        isValidCountry = true;
	        return false;
	      } else if (screenName === "maintainRetailer" && this.cdmValue === cVal) {
	        isValidCountry = true;
	        return false;
	      } else if (screenName === "standardPlatformFacility" && this.cdmMeaning === cVal) {
	        isValidCountry = true;
	        return false;
	      } else if (screenName === "SelfOnboardRetailer") {
	        isValidCountry = true;
	        return false;
	      } else if (screenName === "AccountConfiguration") {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (!isValidCountry) {
	      addressResponse = {};
	      isAlreadyValid = true;
	    }
	    console.log("isValidationReqdCountry" + isValidCountry);
	  }
	
	  /**
	    HB-14019
	  */
	  function isAddressValidationReqd() {
	    if ((0, _general.isPresent)(rtlAddressValidationLevel) && rtlAddressValidationLevel === "Level0") {
	      isAlreadyValid = true;
	      console.log("isAddressValidationReqd" + isAlreadyValid);
	    }
	  }
	
	  self.determineAddressValidity = function (doneFunc) {
	    done = doneFunc || function () {};
	    //if country is not part of the validation required
	    //country we don't need the validation. so first check the
	    //country and proceed with validation.
	    isValidationReqdCountry();
	    isAddressValidationReqd();
	    if (isAlreadyValid) {
	      console.log('no validation needed.');
	      if (screenName === 'AccountConfiguration' && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined') {
	        (0, _jquery2.default)("#addLocationFlagForAddressValidation").val("Validated");
	        (0, _jquery2.default)("#shipToLocations").css("display", "block");
	        (0, _jquery2.default)("#shipToLocationsEdit").css("display", "block");
	        (0, _jquery2.default)("#saveLocationSection").css("dsiplay", "none");
	        //document.getElementById("saveLocationSection").style.visibility = "hidden";
	        document.getElementById("saveLocationSection").style.display = "none";
	        document.getElementById("completeFieldsMsg").style.visibility = "hidden";
	
	        (0, _jquery2.default)("#confirmationBoxToSaveAccountAddress").modal("hide");
	      }
	
	      done(true);
	      if (screenName === "SelfOnboardRetailer") {
	        (0, _jquery2.default)("#confirmationBox").modal("show");
	      }
	      if (screenName === 'AccountConfiguration' && currentTab === ".so-accounts-tab") {
	        (0, _jquery2.default)("#confirmationBoxToSaveAccountAddress").modal("show");
	      }
	    } else {
	      console.log('validation needed.');
	      validateWizardAddress({ url: validateWizardAddressURL, success: validateAddressSuccess, error: validateAddressError });
	    }
	  };
	
	  function validateWizardAddress(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error;
	
	    showModal();
	    showLoadingModal();
	
	    var countryVal = els.country.val();
	    var stateVal = "";
	    var data = {};
	
	    if (countryVal == "1" || countryVal == "2" || countryVal == "US" || countryVal == "CA") {
	      stateVal = els.state.val();
	    } else {
	      stateVal = els.stateText.val();
	    }
	    if (screenName === "order" || screenName === "maintainRetailer" || screenName === "standardPlatformFacility" || screenName === "SelfOnboardRetailer" || screenName === 'AccountConfiguration') {
	      data = {
	        address1: els.address1.val(),
	        address2: els.address2.val(),
	        city: els.city.val(),
	        zipcode: els.zipcode.val(),
	        state: stateVal,
	        country: els.country.val(),
	        callType: "addressValidation"
	      };
	    } else {
	      var _data;
	
	      data = (_data = {}, _defineProperty(_data, namespace + "address1", els.address1.val()), _defineProperty(_data, namespace + "address2", els.address2.val()), _defineProperty(_data, namespace + "city", els.city.val()), _defineProperty(_data, namespace + "zipcode", els.zipcode.val()), _defineProperty(_data, namespace + "state", stateVal), _defineProperty(_data, namespace + "country", els.country.val()), _defineProperty(_data, namespace + "callType", "addressValidation"), _data);
	    }
	    _jquery2.default.ajax({
	      data: data,
	      url: url,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function validateAddressSuccess(data) {
	
	    addressResponse = data;
	    if (data.response == "success" && !data.isAddFixed) {
	      if (data.resolvedFlag == 'true') {
	        addressFoundModal(data);
	      } else {
	        addressNotFoundModal(data);
	      }
	    } else if (data.response == "crossborder" && !data.isAddFixed) {
	      crossBorderAddress(data);
	    } else {
	      isAlreadyValid = true;
	      hideModal();
	      if (screenName === 'AccountConfiguration' && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined') {
	        (0, _jquery2.default)("#addLocationFlagForAddressValidation").val("Validated");
	        (0, _jquery2.default)("#shipToLocations").css("display", "block");
	        (0, _jquery2.default)("#shipToLocationsEdit").css("display", "block");
	        (0, _jquery2.default)("#saveLocationSection").css("dsiplay", "none");
	        (0, _jquery2.default)("#confirmationBoxToSaveAccountAddress").modal("hide");
	        //document.getElementById("saveLocationSection").style.visibility = "hidden";
	        document.getElementById("saveLocationSection").style.display = "none";
	        document.getElementById("completeFieldsMsg").style.visibility = "hidden";
	      }
	      done(true);
	      if (screenName === "SelfOnboardRetailer") {
	        (0, _jquery2.default)("#confirmationBox").modal("show");
	      }
	      if (screenName === 'AccountConfiguration' && currentTab === ".so-accounts-tab") {
	        (0, _jquery2.default)("#confirmationBoxToSaveAccountAddress").modal("show");
	      }
	    }
	  }
	
	  function validateAddressError() {
	    hideModal();
	    if (screenName === "maintainRetailer") {
	      // user should not be able to navigate further, orther screens is ok
	      done(false);
	    } else {
	      done(true);
	    }
	    alert(generalErrorMessage);
	  }
	
	  function empty(str) {
	    if (typeof str == 'undefined' || !str || str.length === 0 || str === "" || !/[^\s]/.test(str) || /^\s*$/.test(str) || str.replace(/\s/g, "") === "") {
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  function addressFoundModal(data) {
	    var userAddHtml = data.address1;
	    if (!empty(data.address2)) {
	      userAddHtml += "," + data.address2 + "," + data.city + "," + data.state + "," + data.zip;
	    } else {
	      userAddHtml += "," + data.city + "," + data.state + "," + data.zip;
	    }
	
	    (0, _jquery2.default)("#add-validation-user-entered-add").html(userAddHtml);
	
	    var sysAddHtml = data.stdAddress1;
	    if (!empty(data.stdAddress2)) {
	      sysAddHtml += "," + data.stdAddress2 + "," + data.stdCity + (data.stdState == null ? "" : "," + data.stdState) + (data.stdZip == null ? "" : "," + data.stdZip);
	    } else {
	      sysAddHtml += "," + data.stdCity + (data.stdState == null ? "" : "," + data.stdState) + (data.stdZip == null ? "" : "," + data.stdZip);
	    }
	
	    (0, _jquery2.default)("#add-validation-system-found-add").html(sysAddHtml);
	    showAddressFoundModal();
	  }
	
	  function addressNotFoundModal(data) {
	
	    var userAddHtml = data.address1;
	    if (!empty(data.address2)) {
	      userAddHtml += "," + data.address2 + "," + data.city + "," + data.state + "," + data.zip;
	    } else {
	      userAddHtml += "," + data.city + "," + data.state + "," + data.zip;
	    }
	
	    (0, _jquery2.default)("#add-validation-user-entered-add").html(userAddHtml);
	    showAddressNotFoundModal();
	  }
	
	  function crossBorderAddress(data) {
	
	    var userAddHtml = data.address1;
	    if (!empty(data.address2)) {
	      userAddHtml += "," + data.address2 + "," + data.city + "," + data.state + "," + data.zip;
	    } else {
	      userAddHtml += "," + data.city + "," + data.state + "," + data.zip;
	    }
	    (0, _jquery2.default)("#add-validation-user-entered-add").html(userAddHtml);
	    showCrossBorderAddressModal();
	  }
	
	  (0, _jquery2.default)('.mod-address-btn').click(function (e) {
	    (0, _jquery2.default)(".crossborder-address-section").hide();
	    if (screenName === 'AccountConfiguration' && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined') {
	      (0, _jquery2.default)("#shipToLocations").css("display", "none");
	      (0, _jquery2.default)("#saveLocationSection").css("dsiplay", "block");
	      (0, _jquery2.default)("#shipToLocationsEdit").css("display", "block");
	    }
	    e.preventDefault();
	    isAlreadyValid = false;
	    hideModal();
	    done(false);
	  });
	
	  (0, _jquery2.default)('.use-selected-address-btn').click(function (e) {
	    e.preventDefault();
	    if (screenName === 'AccountConfiguration' && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined') {
	      (0, _jquery2.default)("#addLocationFlagForAddressValidation").val("Validated");
	      (0, _jquery2.default)("#shipToLocations").css("display", "block");
	      (0, _jquery2.default)("#shipToLocationsEdit").css("display", "block");
	      (0, _jquery2.default)("#saveLocationSection").css("dsiplay", "none");
	      (0, _jquery2.default)("#confirmationBoxToSaveAccountAddress").modal("hide");
	      document.getElementById("noneAddedMsg").style.visibility = "hidden";
	      //document.getElementById("saveLocationSection").style.visibility = "hidden";
	      document.getElementById("saveLocationSection").style.display = "none";
	      document.getElementById("completeFieldsMsg").style.visibility = "hidden";
	    }
	    // in some case like in maintain retailer, the button may be disabled and we dont want to process the event
	    var useThisAddressBtnDisabled = (0, _jquery2.default)('.use-selected-address-btn').is('[disabled=disabled]');
	    // sometimes AddressValidation object is created but doneFunc is never created from determineAddressValidaty
	    // if that happens, addressResponse is empty and the done() function at end of this method fails.
	    if (_jquery2.default.isEmptyObject(addressResponse) || useThisAddressBtnDisabled) {
	      return;
	    }
	    var useStdAddress = (0, _jquery2.default)('[name=radioAddressChoice]:checked').val();
	
	    if (useStdAddress === "1") {
	      addressResponse.useStdAddress = useStdAddress;
	
	      var countryVal = addressResponse.stdCountry;
	      els.address1.val(addressResponse.stdAddress1);
	      els.address2.val(addressResponse.stdAddress2);
	      els.city.val(addressResponse.stdCity);
	      els.zipcode.val(addressResponse.stdZip);
	      els.country.val(countryVal);
	      if (countryVal == "1" || countryVal == "2" || countryVal == "US" || countryVal == "CA") {
	        els.state.val(addressResponse.stdState);
	      } else {
	        els.stateText.val(addressResponse.stdState);
	      }
	      if (screenName === "maintainRetailer") {
	        // currently only required for Manage retailer screens
	        els.commercialAddressFlag.val(addressResponse.isCommercial);
	      }
	
	      // make sure to notify event bus of possible
	      // silent input changes that were performed above...
	      // This is terrible because the correct archetecture
	      // was not followed here.
	      _AddressEventBus2.default.emitChange();
	    } else {
	      addressResponse.useStdAddress = "0";
	    }
	
	    isAlreadyValid = true;
	    hideModal();
	    done(true);
	    if (screenName === "SelfOnboardRetailer") {
	      (0, _jquery2.default)("#confirmationBox").modal("show");
	    }
	    if (screenName === 'AccountConfiguration' && currentTab === ".so-accounts-tab") {
	      (0, _jquery2.default)("#confirmationBoxToSaveAccountAddress").modal("show");
	    }
	  });
	
	  function showLoadingModal() {
	    (0, _jquery2.default)("#address-found-or-not-text").html("");
	    (0, _jquery2.default)(".address-select-choices-outer").hide();
	    (0, _jquery2.default)(".address-validation-loading-outer").show();
	    (0, _jquery2.default)(".mod-address-btn").hide();
	    (0, _jquery2.default)(".use-selected-address-btn").hide();
	    (0, _jquery2.default)(".validate-address-btn").hide();
	  }
	
	  function showModal() {
	    (0, _jquery2.default)("#add-validation-model").modal("show");
	  }
	
	  function hideModal() {
	    (0, _jquery2.default)("#add-validation-model").modal("hide");
	  }
	
	  function showAddressFoundModal() {
	    (0, _jquery2.default)("#address-found-or-not-text").html(addressFoundTitleText);
	    if ((0, _jquery2.default)("#radio-entered-address").hasClass("q-radio-hide")) {
	      (0, _jquery2.default)("#radio-entered-address").removeClass("q-radio-hide");
	    }
	    (0, _jquery2.default)("#radio-entered-address").prop("checked", false);
	    (0, _jquery2.default)("#radio-found-address").prop("checked", true);
	    (0, _jquery2.default)(".address-select-choices-outer").show();
	    (0, _jquery2.default)(".found-address-item").show();
	    (0, _jquery2.default)(".modify-address-section").hide();
	    (0, _jquery2.default)(".no-address-found-section").hide();
	    (0, _jquery2.default)(".address-validation-loading-outer").hide();
	    (0, _jquery2.default)(".mod-address-btn").show();
	    (0, _jquery2.default)(".use-selected-address-btn").show();
	    (0, _jquery2.default)(".use-selected-address-btn").attr("disabled", false); // if this options is passed
	    (0, _jquery2.default)(".validate-address-btn").hide();
	  }
	
	  function showAddressNotFoundModal() {
	    (0, _jquery2.default)("#address-found-or-not-text").html(addressNotFoundText);
	    if ((0, _jquery2.default)("#radio-entered-address").hasClass("q-radio-hide")) {
	      (0, _jquery2.default)("#radio-entered-address").removeClass("q-radio-hide");
	    }
	    (0, _jquery2.default)("#radio-entered-address").prop("checked", true);
	    (0, _jquery2.default)("#radio-found-address").prop("checked", false);
	    (0, _jquery2.default)(".address-select-choices-outer").show();
	    (0, _jquery2.default)(".found-address-item").hide();
	    (0, _jquery2.default)(".modify-address-section").hide();
	    (0, _jquery2.default)(".no-address-found-section").show();
	    (0, _jquery2.default)(".address-validation-loading-outer").hide();
	    (0, _jquery2.default)(".mod-address-btn").show();
	    (0, _jquery2.default)(".use-selected-address-btn").show();
	    (0, _jquery2.default)(".validate-address-btn").hide();
	  }
	
	  function showCrossBorderAddressModal() {
	    (0, _jquery2.default)("#address-found-or-not-text").html(fedexCrossBorderAdd);
	    if ((0, _jquery2.default)("#radio-entered-address").hasClass("q-radio-hide")) {
	      (0, _jquery2.default)("#radio-entered-address").removeClass("q-radio-hide");
	    }
	    (0, _jquery2.default)('#radio-entered-address').attr("disabled", disableUserEnteredAddressRadio); // If this option is passed
	    (0, _jquery2.default)("#radio-found-address").removeAttr('checked');
	    (0, _jquery2.default)(".address-select-choices-outer").hide();
	    (0, _jquery2.default)(".found-address-item").hide();
	    (0, _jquery2.default)(".modify-address-section").hide();
	    (0, _jquery2.default)(".no-address-found-section").show();
	    (0, _jquery2.default)(".address-validation-loading-outer").hide();
	    (0, _jquery2.default)(".mod-address-btn").show();
	    (0, _jquery2.default)(".use-selected-address-btn").attr("disabled", false); // if this options is passed
	    (0, _jquery2.default)(".use-selected-address-btn").hide();
	    (0, _jquery2.default)(".validate-address-btn").hide();
	    (0, _jquery2.default)(".crossborder-address-section").show();
	  }
	
	  var screenSpecificFuncs = {
	    orderSetElements: function orderSetElements() {
	      els.address1 = scopeForData.find("#destination-tab-address1");
	      els.address2 = scopeForData.find("#destination-tab-address2");
	      els.city = scopeForData.find("#destination-tab-city");
	      els.zipcode = scopeForData.find("#destination-tab-zipCode");
	      els.state = scopeForData.find("#destination-tab-state");
	      els.stateText = scopeForData.find("#destination-tab-stateText");
	      els.country = scopeForData.find("#destination-tab-country");
	    },
	
	    asnSetElements: function asnSetElements() {
	      namespace = scopeForData.data('namespace');
	
	      els.address1 = scopeForData.find("#" + namespace + "cadAddress1");
	      els.address2 = scopeForData.find("#" + namespace + "cadAddress2");
	      els.city = scopeForData.find("#" + namespace + "cadCity");
	      els.zipcode = scopeForData.find("#" + namespace + "cadZipcode");
	      els.state = scopeForData.find("#" + namespace + "states");
	      els.stateText = scopeForData.find("#" + namespace + "cadStateText");
	      els.country = scopeForData.find("#" + namespace + "cadCountry");
	    },
	    maintainRetailerSetElements: function maintainRetailerSetElements() {
	      els.address1 = (0, _jquery2.default)(currentTab).find(".ret-address1");
	      els.address2 = (0, _jquery2.default)(currentTab).find(".ret-address2");
	      els.city = (0, _jquery2.default)(currentTab).find(".ret-city");
	      els.zipcode = (0, _jquery2.default)(currentTab).find(".ret-zip-code");
	      els.state = (0, _jquery2.default)(currentTab).find(".ret-state");
	      els.stateText = (0, _jquery2.default)(currentTab).find(".ret-state-text");
	      els.country = (0, _jquery2.default)(currentTab).find(".ret-country");
	      els.commercialAddressFlag = (0, _jquery2.default)(currentTab).find(".commercial-addr-flag");
	    },
	    standardPlatformFacilitySetElements: function standardPlatformFacilitySetElements() {
	      els.address1 = scopeForData.find("#fac-address-tab-address1");
	      els.address2 = scopeForData.find("#fac-address-tab-address2");
	      els.city = scopeForData.find("#fac-address-tab-city");
	      els.zipcode = scopeForData.find("#fac-address-tab-zip");
	      els.state = scopeForData.find("#fac-address-tab-state");
	      els.stateText = scopeForData.find("#fac-address-tab-stateText");
	      els.country = scopeForData.find("#fac-address-tab-country");
	    },
	    SelfOnboardRetailerSetElements: function SelfOnboardRetailerSetElements() {
	      els.address1 = scopeForData.find(".ret-address1");
	      els.address2 = scopeForData.find(".ret-address2");
	      els.city = scopeForData.find(".ret-city");
	      els.zipcode = scopeForData.find(".ret-zip-code");
	      els.state = scopeForData.find(".ret-state");
	      els.stateText = scopeForData.find(".ret-state-text");
	      els.country = scopeForData.find(".ret-country");
	      // els.commercialAddressFlag = scopeForData.find(".commercial-addr-flag");
	    },
	    AccountConfigurationSetElements: function AccountConfigurationSetElements() {
	      console.log("currentTab is" + currentTab);
	
	      els.address1 = scopeForData.find(".ret-address1");
	      els.address2 = scopeForData.find(".ret-address2");
	      els.city = scopeForData.find(".ret-city");
	      els.zipcode = scopeForData.find(".ret-zip-code");
	      els.state = scopeForData.find(".ret-state");
	      els.stateText = scopeForData.find(".ret-state-text");
	      els.country = scopeForData.find(".acc-country");
	
	      if (screenName === 'AccountConfiguration' && currentTab === ".so-locations-tab" && document.getElementById('addLocationFlagForAddressValidation').value != 'undefined') {
	        els.address1 = scopeForData.find(".fac-address1");
	        els.address2 = scopeForData.find(".fac-address2");
	        els.city = scopeForData.find(".fac-city");
	        els.zipcode = scopeForData.find(".fac-zip-code");
	        els.state = scopeForData.find(".fac-state");
	        els.stateText = scopeForData.find(".fac-state-text");
	        els.country = scopeForData.find(".fac-country");
	      }
	    }
	
	  };
	
	  function setComboElement() {
	    els.allInputs = (0, _selectorHelpers.combineElements)([els.address1, els.address2, els.city, els.zipcode, els.state, els.stateText, els.country]);
	  }
	
	  // bind all elements in els
	  // on change of any of these elements, mark isAlreadyValid false
	  // on next/jump-to-future-tab (determineAddressValidity)
	  // we need to use isAlreadyValid to determine if crap should happend.
	
	  function bindElements() {
	    els.address1.on("change", handleAddressInputChange);
	    els.address2.on("change", handleAddressInputChange);
	    els.city.on("change", handleAddressInputChange);
	    els.zipcode.on("change", handleAddressInputChange);
	    els.state.on("change", handleAddressInputChange);
	    els.stateText.on("change", handleAddressInputChange);
	    els.country.on("change", handleAddressInputChange);
	  }
	
	  function handleAddressInputChange(e) {
	    e.preventDefault();
	    isAlreadyValid = false;
	    console.log('handleAddressInputChange');
	  }
	}

/***/ },
/* 37 */,
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = timePicker;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _select2able = __webpack_require__(22);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1073);
	var rawTemplateHtml = __webpack_require__(1188);
	// dependencies:
	// select2
	
	
	function timePicker(el, options) {
	  el = (0, _jquery2.default)(el);
	
	  var tmEl = void 0;
	
	  if (el.children().length) {
	    tmEl = getTimePicker();
	  } else {
	    el.html(rawTemplateHtml);
	    tmEl = getTimePicker();
	  }
	
	  function getTimePicker() {
	    var tm = el.data("time-picker");
	    if (tm) {
	      tm.setOptions(options);
	    } else {
	      tm = new TimePicker(el, options);
	    }
	    return tm;
	  }
	
	  return tmEl;
	}
	
	var DEFAULTS = {};
	
	var HOURS_DATA_DEFAULT = {
	  hoursData: {
	    data: [{
	      id: "",
	      text: "HH"
	    }]
	  }
	};
	
	var MINUTES_DATA_DEFAULT = {
	  minutesData: {
	    data: [{
	      id: "",
	      text: "MM"
	    }]
	  }
	};
	
	var elementsMap = {
	  hoursSelect: ".time-picker-hours-select",
	  minutesSelect: ".time-picker-minutes-select",
	  periodSelect: ".time-picker-period-select",
	  timePickerSeparater: ".time-picker-seperater"
	};
	
	function TimePicker(el) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var self = this;
	  var opts = void 0;
	  var els = {};
	
	  generateHours();
	  generateMinutes();
	
	  setOptions(options);
	  setElements();
	  handleReadOnly();
	  setWidgets();
	  bindElements();
	
	  self.setOptions = setOptions;
	
	  self.setTimeFromMilitary = function (time) {
	    var _moment$format$split = (0, _moment2.default)(time, 'HH:mm').format('h:mm:A').split(":"),
	        _moment$format$split2 = _slicedToArray(_moment$format$split, 3),
	        hours = _moment$format$split2[0],
	        minutes = _moment$format$split2[1],
	        period = _moment$format$split2[2];
	
	    if (hours !== "Invalid date") {
	      setVal(els.hoursSelect, hours);
	      setVal(els.minutesSelect, minutes);
	      setVal(els.periodSelect, period);
	    }
	  };
	
	  function setVal(el, val) {
	    el.val(val).trigger('change.select2');
	  }
	
	  self.getMilitaryTime = function () {
	    var hours = getHoursVal();
	    var minutes = getMinutesVal();
	    var period = getPeriodVal();
	
	    return (0, _moment2.default)(hours + ":" + minutes + " " + period, 'h:mm A').format('HH:mm');
	  };
	
	  self.resetTime = function () {
	    setVal(els.hoursSelect, '');
	    setVal(els.minutesSelect, '');
	    setVal(els.periodSelect, 'AM');
	  };
	
	  self.disableTimePicker = function () {
	    (0, _selectorHelpers.setDisabled)([els.hoursSelect, els.minutesSelect, els.periodSelect]);
	    els.timePickerSeparater.css('background-color', '#f5f5f5');
	    handleDisabledSelect2();
	  };
	
	  self.enableTimePicker = function () {
	    (0, _selectorHelpers.setEnabled)([els.hoursSelect, els.minutesSelect, els.periodSelect]);
	    els.timePickerSeparater.css('background-color', '');
	    handleEnabledSelect2();
	  };
	
	  function getHoursVal() {
	    return getVal(els.hoursSelect);
	  }
	  function getMinutesVal() {
	    return getVal(els.minutesSelect);
	  }
	  function getPeriodVal() {
	    return getVal(els.periodSelect);
	  }
	
	  function getVal(el) {
	    return el.val();
	  }
	
	  function bindElements() {}
	
	  function parsedNotNaN(val) {
	    return !_underscore2.default.isNaN(parseDigit(val));
	  }
	
	  function parseDigit(val) {
	    return parseInt(val, 10);
	  }
	
	  function setOptions() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    opts = _underscore2.default.defaults(options, DEFAULTS);
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	  }
	
	  function setWidgets() {
	    setSelect2s();
	  }
	
	  function setSelect2s() {
	    els.periodSelect.select2({
	      minimumResultsForSearch: "Infinity",
	      data: [{
	        id: "AM",
	        text: "AM"
	      }, {
	        id: "PM",
	        text: "PM"
	      }]
	    });
	    els.hoursSelect.select2({
	      minimumResultsForSearch: "Infinity",
	      data: HOURS_DATA_DEFAULT.hoursData.data,
	      placeholder: 'HH'
	    });
	    els.minutesSelect.select2({
	      minimumResultsForSearch: "Infinity",
	      data: MINUTES_DATA_DEFAULT.minutesData.data,
	      placeholder: 'MM'
	    });
	
	    els.periodSelect.data('select2').$dropdown.addClass('time-picker-period-select-dropdown');
	
	    if (opts.addSelect2Class) {
	      (0, _select2able.addCustomClassForSelect2)(els.hoursSelect, opts.addSelect2Class);
	      (0, _select2able.addCustomClassForSelect2)(els.minutesSelect, opts.addSelect2Class);
	      (0, _select2able.addCustomClassForSelect2)(els.periodSelect, opts.addSelect2Class);
	    }
	  }
	
	  function generateHours() {
	    if (HOURS_DATA_DEFAULT.hoursData.data.length > 1) {
	      return;
	    }
	    var data = HOURS_DATA_DEFAULT.hoursData.data;
	    fillWithData(data, 1, 12, { prefixZero: false });
	  }
	
	  function generateMinutes() {
	    if (MINUTES_DATA_DEFAULT.minutesData.data.length > 1) {
	      return;
	    }
	    var data = MINUTES_DATA_DEFAULT.minutesData.data;
	    fillWithData(data, 0, 59, { prefixZero: true });
	  }
	
	  function fillWithData(data, start, finish, _ref) {
	    var prefixZero = _ref.prefixZero;
	
	    for (var i = start; i <= finish; i++) {
	      var str = "";
	      if (prefixZero && i >= 0 && i < 10) {
	        // "01"
	        str = "0" + i;
	      } else {
	        str = "" + i;
	      }
	      data.push({ id: str, text: str });
	    }
	  }
	
	  function handleReadOnly() {
	    if (options.disableAll) {
	      (0, _selectorHelpers.setDisabled)([els.hoursSelect, els.minutesSelect, els.periodSelect]);
	      setComponentLevelDisabled();
	    }
	  }
	
	  function setComponentLevelDisabled() {
	    el.addClass("disabled");
	  }
	
	  function handleDisabledSelect2() {
	    [els.hoursSelect, els.minutesSelect, els.periodSelect].map(function (eachSelect2) {
	      eachSelect2.closest('.q-time-picker-default').find('.select2-container') // Targeting parent class div to avoid selection is disabled mode.
	      .css('pointer-events', 'none'); // This would take care of every timePicker whether new or old.
	    });
	  }
	
	  function handleEnabledSelect2() {
	    [els.hoursSelect, els.minutesSelect, els.periodSelect].map(function (eachSelect2) {
	      eachSelect2.closest('.q-time-picker-default').find('.select2-container').css('pointer-events', '');
	    });
	  }
	}

/***/ },
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _storeUtils = __webpack_require__(56);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _relationships = __webpack_require__(55);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// let cmrServices = {
	//   0: {
	
	//   },
	//   1: {
	
	//   },
	//   2: {
	
	//   }
	// };
	
	
	var cmrServices = {};
	
	var defaults = {};
	
	var CmrServiceStore = (0, _storeUtils.createStore)({
	  storeEventBaseKey: "cmr_services",
	  normalizr: _relationships.cmrServicesKeyToArrayOfCmrServices,
	  normalizrKey: "cmrServices",
	  getData: function getData() {
	    return cmrServices;
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  removeServicesByIds: function removeServicesByIds(ids) {
	    this.removeObjectsByIdsAndEmit(cmrServices, ids);
	  },
	  createOrUpdateServicesForAsnDetailIds: function createOrUpdateServicesForAsnDetailIds() {
	    var _this = this;
	
	    var detailIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var data = arguments[1];
	
	    data.csv_entity_type = "asn_detail";
	    var detailIdAndTypeToServices = this.detailIdAndTypeToServices();
	    (0, _underscore2.default)(detailIds).map(function (detailId) {
	      var specificData = _underscore2.default.extend({}, data, { csv_entity_id: detailId });
	      var service = (0, _underscore2.default)(detailIdAndTypeToServices[detailId + '_asn_detail']).findWhere({ cdm_id: data.cdm_id });
	      if (!service) {
	        _this.createNewService(specificData);
	      } else {
	        _this.updateObjectAndEmit(service.id, specificData);
	      }
	    });
	  },
	  createOrUpdateServicesForAsnId: function createOrUpdateServicesForAsnId(asnId, data) {
	    var specificData = _underscore2.default.extend({}, data, { csv_entity_type: "asn", csv_entity_id: asnId });
	    var service = (0, _underscore2.default)(this.getServicesViaAsnId(asnId)).findWhere({ cdm_id: specificData.cdm_id });
	    if (!service) {
	      this.createNewService(specificData);
	    } else {
	      this.updateObjectAndEmit(service.id, specificData);
	    }
	  },
	  detailIdAndTypeToServices: function detailIdAndTypeToServices(services) {
	    if (!services) {
	      services = this.dataAsArray();
	    }
	    return (0, _underscore2.default)(services).groupBy(function (service) {
	      return service.csv_entity_id + '_' + service.csv_entity_type;
	    });
	  },
	  getServicesViaAsnId: function getServicesViaAsnId(asnId) {
	    return (0, _underscore2.default)(this.dataAsArray()).where({ csv_entity_id: asnId, csv_entity_type: "asn" });
	  },
	  getServicesViaAsnDetailIds: function getServicesViaAsnDetailIds() {
	    var detailIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var detailIdAndTypeToServices = this.detailIdAndTypeToServices();
	    return _underscore2.default.chain(detailIds).map(function (detailId) {
	      return detailIdAndTypeToServices[detailId + '_asn_detail'];
	    }).filter(function (service) {
	      return service;
	    }).flatten().value();
	  },
	  getServicesViaAsnDetailId: function getServicesViaAsnDetailId(detailId) {
	    return (0, _underscore2.default)(this.dataAsArray()).where({ csv_entity_id: detailId, csv_entity_type: "asn_detail" });
	  },
	  organizeByEntity: function organizeByEntity() {
	    var services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return (0, _underscore2.default)(this.detailIdAndTypeToServices(services)).values();
	  },
	  createNewService: function createNewService(data) {
	    data = _underscore2.default.extend({ id: _underscore2.default.uuid() }, defaults, data);
	    return this.addService(data);
	  },
	  addService: function addService(data) {
	    return this.addObjectsAndEmit(cmrServices, data);
	  }
	});
	
	window.CmrServiceStore = CmrServiceStore;
	exports.default = CmrServiceStore;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = collectDataAttributesFor;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function collectDataAttributesFor(el, _ref) {
	  var prefix = _ref.prefix,
	      _ref$camelize = _ref.camelize,
	      camelize = _ref$camelize === undefined ? true : _ref$camelize;
	
	  var data = {};
	  var rgx = new RegExp('^data-');
	  var numbToDash = 5;
	  if (prefix) {
	    numbToDash = numbToDash + prefix.length + 1;
	    rgx = new RegExp('^data-' + prefix + '-');
	  }
	  var $el = (0, _jquery2.default)(el);
	  [].forEach.call(el.attributes || [], function (attr) {
	    if (rgx.test(attr.name)) {
	      var key = attr.name.substr(numbToDash);
	      if (camelize) {
	        key = key.replace(/-(.)/g, function ($0, $1) {
	          return $1.toUpperCase();
	        });
	      }
	      // example: attr.name = "data-s2-whatever" 
	      // so we need to remove "data-" from it
	      // so then we can use jquery for it's smart
	      // data attribute getter/setter
	      var jqDataAttrName = attr.name.substr(5);
	      data[key] = $el.data(jqDataAttrName);
	    }
	  });
	  return data;
	}

/***/ },
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _storeUtils = __webpack_require__(56);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _relationships = __webpack_require__(55);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var asnShippingPallets = {};
	
	var defaults = {
	  asp_pallet_stackable: false
	};
	
	var AsnShippingPalletStore = (0, _storeUtils.createStore)({
	  storeEventBaseKey: "asn_shipping_pallet",
	  normalizrKey: "asnShippingPallets",
	  normalizr: _relationships.asnShippingPalletsKeyToArrayOfAsnhippingPallets,
	  getData: function getData() {
	    return asnShippingPallets;
	  },
	  getAsnShippingPallets: function getAsnShippingPallets(ids) {
	    var _$chain;
	
	    return (_$chain = _underscore2.default.chain(asnShippingPallets)).pick.apply(_$chain, _toConsumableArray(ids)).values().value();
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  createFreightShippingPallet: function createFreightShippingPallet(data) {
	    data = _underscore2.default.extend({ id: _underscore2.default.uuid() }, data);
	    addAsnShippingPallate(data);
	  },
	  addAsnShippingPallate: function addAsnShippingPallate(data) {
	    return this.addObjectsAndEmit(asnShippingPallate, data);
	  },
	  update: function update(id, newData) {
	    var detail = asnShippingPallate[id];
	    asnShippingPallate[id] = _extends({}, detail, newData);
	
	    this.emitEvent("change", detail);
	    return this.emitObjectChange(asnShippingPallate[id]);
	  },
	  copyDimensionsToAllCasesForSameAsn: function copyDimensionsToAllCasesForSameAsn(asnShippingPalletId) {
	    var asnShippingPallet = this.getAsnShippingPallet(asnShippingPalletId);
	    var asp_pallet_length = asnShippingPallet.asp_pallet_length,
	        asp_pallet_width = asnShippingPallet.asp_pallet_width,
	        asp_pallet_height = asnShippingPallet.asp_pallet_height,
	        asp_pallet_weight = asnShippingPallet.asp_pallet_weight,
	        asp_pallet_stackable = asnShippingPallet.asp_pallet_stackable;
	
	    var similarAsnShippingPallet = (0, _underscore2.default)(asnShippingPallets).pick(function (_ref) {
	      var asnId = _ref.asnId;
	
	      return asnShippingPallet.asnId === asnId;
	    });
	
	    $("input.asn-detail-length").val(asp_pallet_length);
	    $("input.asn-detail-width").val(asp_pallet_width);
	    $("input.asn-detail-height").val(asp_pallet_height);
	    $("input.asn-detail-weight").val(asp_pallet_weight);
	    if (asp_pallet_stackable) {
	      $(".stackable-pallet-checkbox").prop("checked", true);
	    } else {
	      $(".stackable-pallet-checkbox").prop("checked", false);
	    }
	
	    similarAsnShippingPallet = (0, _underscore2.default)(similarAsnShippingPallet).mapObject(function (curAsnShippingPallet) {
	
	      return _underscore2.default.assign(curAsnShippingPallet, { asp_pallet_length: asp_pallet_length, asp_pallet_width: asp_pallet_width, asp_pallet_height: asp_pallet_height, asp_pallet_weight: asp_pallet_weight, asp_pallet_stackable: asp_pallet_stackable });
	    });
	
	    this.updateObjectsAndEmit(similarAsnShippingPallet);
	  },
	  getAsnShippingPallet: function getAsnShippingPallet(id) {
	    return asnShippingPallets[id];
	  },
	  getAllAsnShippingPallets: function getAllAsnShippingPallets() {
	    return asnShippingPallets;
	  },
	  removeAllAsnShippingPallets: function removeAllAsnShippingPallets() {
	    var removeIds = (0, _underscore2.default)(asnShippingPallets).pluck("id");
	    this.removeDataByIdsAndEmit(removeIds);
	  },
	  createNewAsnShippingPalletDetail: function createNewAsnShippingPalletDetail(data) {
	    data = _underscore2.default.extend({ id: _underscore2.default.uuid() }, data);
	    return this.addAsnShippingPallet(data);
	  },
	  addAsnShippingPallet: function addAsnShippingPallet(data) {
	    return this.addObjectsAndEmit(asnShippingPallets, data);
	  },
	  haveDimensionsAndWeight: function haveDimensionsAndWeight(details) {
	    return (0, _underscore2.default)(details).all(this.hasDimensionsAndWeight, this);
	  },
	  hasDimensionsAndWeight: function hasDimensionsAndWeight(detail) {
	    return (0, _general.isGtZero)(detail.asp_pallet_length) && (0, _general.isGtZero)(detail.asp_pallet_width) && (0, _general.isGtZero)(detail.asp_pallet_height) && (0, _general.isGtZero)(detail.asp_pallet_weight);
	  },
	
	
	  organizeIntoPallets: organizeIntoFunc("id"),
	  organizeIntoCases: organizeIntoFunc("id"),
	  organizeIntoPalletsAndCases: function organizeIntoPalletsAndCases(details) {
	    var _this = this;
	
	    return _underscore2.default.chain(this.organizeIntoPallets(details)).map(function (palletData) {
	      return _this.organizeIntoCases(palletData);
	    }).value();
	  }
	});
	
	function organizeIntoFunc(key) {
	  return function (data) {
	    return _underscore2.default.chain(data).values().groupBy(function (asnShippingPallet) {
	      return asnShippingPallet[key];
	    }).values().value();
	  };
	}
	
	function setAttrForIdsFunc(groupKey) {
	  return function (ids, val) {
	    var _$chain2,
	        _this2 = this;
	
	    var out = (_$chain2 = _underscore2.default.chain(asnShippingPallets)).pick.apply(_$chain2, _toConsumableArray(ids)).mapObject(function (asnShippingPallet, k) {
	      asnShippingPallet[groupKey] = val;
	      return asnShippingPallet;
	    }).mapObject(function (asnShippingPallet, k) {
	      _this2.emitObjectChange(asnShippingPallet);
	    }).value();
	    // emit a global change as well
	    this.emitEvent('change', out);
	    this.emitEvent('changes:' + groupKey, out);
	
	    return out;
	  };
	}
	
	function setAttrsForIds(ids) {
	  var _this3 = this;
	
	  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  (0, _underscore2.default)(attrs).mapObject(function (v, k) {
	    var func = setAttrForIdsFunc(k).bind(_this3);
	    func(ids, v);
	  });
	}
	
	window.AsnShippingPalletStore = AsnShippingPalletStore;
	exports.default = AsnShippingPalletStore;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _storeUtils = __webpack_require__(56);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _relationships = __webpack_require__(55);
	
	var _currency = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	
	let cmrDomains = {
	  1: {
	    id: 1,
	    cdm_domain: "shipment_level_services",
	    cdm_meaning: "25 % quality Audit",
	    cdm_description: 0.53
	  },
	  2: {
	    id: 2,
	    cdm_domain: "item_level_services",
	    cdm_meaning: "polybag - small",
	    cdm_description: 0 // this is free, convert to 1 during math calculation
	  },
	  3: {
	    id: 3,
	    cdm_domain: "item_level_services",
	    cdm_meaning: "polybag - large",
	    cdm_description: 2.2
	  },
	  4: {
	    id: 4,
	    cdm_domain: "item_level_services",
	    cdm_meaning: "polybag - huge",
	    cdm_description: 0.3
	  },
	  5: {
	    id: 5,
	    cdm_domain: "shipment_level_services",
	    cdm_meaning: "50 % quality Audit",
	    cdm_description: 0.79
	  },
	  6: {
	    id: 6,
	    cdm_domain: "barcode_item_level_mandatory_services",
	    cdm_meaning: "Barcode printing charge",
	    cdm_description: .5 
	  },
	  7: {
	    id: 7,
	    cdm_domain: "fragile_item_level_mandatory_services",
	    cdm_meaning: "Fragile item handling charge",
	    cdm_description: 0.2 
	  }
	};
	
	
	// let cmrDomains = {};
	
	*/
	
	var cmrDomains = {};
	
	var defaults = {};
	
	var CmrDomainStore = (0, _storeUtils.createStore)({
	  storeEventBaseKey: "cmr_domains",
	  normalizr: _relationships.cmrDomainsKeyToArrayOfCmrDomains,
	  normalizrKey: "cmrDomains",
	  getData: function getData() {
	    return cmrDomains;
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  getOnlyProductServiceLevels: function getOnlyProductServiceLevels() {
	    return this.getOnlyServiceLevelsWith("item_level_services");
	  },
	  getOnlyShipmentServiceLevels: function getOnlyShipmentServiceLevels() {
	    return this.getOnlyServiceLevelsWith("shipment_level_services");
	  },
	  getOnlyServiceLevelsWith: function getOnlyServiceLevelsWith(serviceLevel) {
	    return _underscore2.default.chain(this.getData()).values().where({ cdm_domain: serviceLevel }).value();
	  },
	  currencyToHtml: function currencyToHtml(domain) {
	    if (domain.cdm_description === 0 || domain.cdm_description === "0") {
	      return "FREE";
	    }
	    return (0, _currency.toCurrency)(domain.cdm_description);
	  },
	  getTitle: function getTitle(domain) {
	    return domain.cdm_meaning;
	  },
	  getValue: function getValue(domain) {
	    return domain.cdm_description;
	  },
	  isMandatoryDomain: function isMandatoryDomain(domain) {
	    return !!/_level_mandatory_services$/.test(domain.cdm_domain);
	  },
	  groupByCdmDomain: function groupByCdmDomain() {
	    return _underscore2.default.chain(this.getData()).values().groupBy(function (domain) {
	      return domain.cdm_domain;
	    }).value();
	  }
	});
	
	window.CmrDomainStore = CmrDomainStore;
	exports.default = CmrDomainStore;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.abilitiesKeyToArrayOfAbilities = exports.asnShippingPalletsKeyToArrayOfAsnhippingPallets = exports.quoteIdAttribute = exports.quotesKeyToArrayOfQuotes = exports.asnDetailsKeyToArrayOfAsnDetails = exports.brokerKeyToArrayOfBroker = exports.shippingMethodsKeyToArrayOfShippingMethods = exports.cmrDomainsKeyToArrayOfCmrDomains = exports.cmrServicesKeyToArrayOfCmrServices = exports.asnKeyNormalizr = exports.productsItemsKeyToArrayOfProductItems = exports.productItemNormalizr = undefined;
	
	var _normalizr = __webpack_require__(192);
	
	var productItemNormalizr = new _normalizr.Schema('productItems', { idAttribute: "prdId" });
	var productsItemsKeyToArrayOfProductItems = { productItems: (0, _normalizr.arrayOf)(productItemNormalizr) };
	
	var shippingMethodNormalizr = new _normalizr.Schema('shippingMethods', { idAttribute: "orgId" });
	var shippingMethodsKeyToArrayOfShippingMethods = { shippingMethods: (0, _normalizr.arrayOf)(shippingMethodNormalizr) };
	var brokerNormalizr = new _normalizr.Schema('brokers', { idAttribute: "orgId" });
	var brokerKeyToArrayOfBroker = { brokers: (0, _normalizr.arrayOf)(brokerNormalizr) };
	
	var abilitiesNormalizr = new _normalizr.Schema('abilities');
	var abilitiesKeyToArrayOfAbilities = { abilities: (0, _normalizr.arrayOf)(abilitiesNormalizr) };
	
	var quoteIdAttribute = function quoteIdAttribute(entity) {
	  return entity.quoteId + entity.optionId;
	};
	var quoteNormalizr = new _normalizr.Schema('quotes', { idAttribute: quoteIdAttribute });
	var quotesKeyToArrayOfQuotes = { quotes: (0, _normalizr.arrayOf)(quoteNormalizr) };
	
	var asnNormalizr = new _normalizr.Schema('asns');
	var asnDetailNormalizr = new _normalizr.Schema('asnDetails');
	var asnDetailsKeyToArrayOfAsnDetails = { asnDetails: (0, _normalizr.arrayOf)(asnDetailNormalizr) };
	
	var asnShippinigPalletNormalizr = new _normalizr.Schema('asnShippingPallets');
	var asnShippingPalletsKeyToArrayOfAsnhippingPallets = { asnShippingPallets: (0, _normalizr.arrayOf)(asnShippinigPalletNormalizr) };
	
	var CmrServiceNormalizr = new _normalizr.Schema('cmrServices');
	var cmrServicesKeyToArrayOfCmrServices = { cmrServices: (0, _normalizr.arrayOf)(CmrServiceNormalizr) };
	
	var cmrDomainsNormalizr = new _normalizr.Schema('cmrDomains');
	var cmrDomainsKeyToArrayOfCmrDomains = { cmrDomains: (0, _normalizr.arrayOf)(cmrDomainsNormalizr) };
	
	asnNormalizr.define({
	  asnDetails: (0, _normalizr.arrayOf)(asnDetailNormalizr),
	  asnShippingPallets: (0, _normalizr.arrayOf)(asnShippinigPalletNormalizr)
	});
	
	var asnKeyNormalizr = { asn: asnNormalizr };
	
	exports.productItemNormalizr = productItemNormalizr;
	exports.productsItemsKeyToArrayOfProductItems = productsItemsKeyToArrayOfProductItems;
	exports.asnKeyNormalizr = asnKeyNormalizr;
	exports.cmrServicesKeyToArrayOfCmrServices = cmrServicesKeyToArrayOfCmrServices;
	exports.cmrDomainsKeyToArrayOfCmrDomains = cmrDomainsKeyToArrayOfCmrDomains;
	exports.shippingMethodsKeyToArrayOfShippingMethods = shippingMethodsKeyToArrayOfShippingMethods;
	exports.brokerKeyToArrayOfBroker = brokerKeyToArrayOfBroker;
	exports.asnDetailsKeyToArrayOfAsnDetails = asnDetailsKeyToArrayOfAsnDetails;
	exports.quotesKeyToArrayOfQuotes = quotesKeyToArrayOfQuotes;
	exports.quoteIdAttribute = quoteIdAttribute;
	exports.asnShippingPalletsKeyToArrayOfAsnhippingPallets = asnShippingPalletsKeyToArrayOfAsnhippingPallets;
	exports.abilitiesKeyToArrayOfAbilities = abilitiesKeyToArrayOfAbilities;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createStore = createStore;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _events = __webpack_require__(131);
	
	var _objectAssign = __webpack_require__(107);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _normalizr = __webpack_require__(192);
	
	var _NormalizedEmitter = __webpack_require__(835);
	
	var _NormalizedEmitter2 = _interopRequireDefault(_NormalizedEmitter);
	
	var _general = __webpack_require__(5);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	// we need a deep extend function, eventually we 
	// can drop jquery dependency
	
	
	var CHANGE_EVENT = 'change';
	
	function createStore(spec) {
	  var dataSnapshotDict = {};
	
	  var store = (0, _objectAssign2.default)({
	    pluckIdsFromArray: function pluckIdsFromArray(array) {
	      if (_underscore2.default.isFunction(this.idAttribute)) {
	        return (0, _underscore2.default)(array).map(this.idAttribute);
	      } else {
	        return (0, _underscore2.default)(array).pluck(this.idAttribute);
	      }
	    },
	    createDataSnapshot: function createDataSnapshot(tag) {
	      if (!(0, _general.isPresent)(tag)) {
	        tag = _underscore2.default.uuid();
	      }
	      var sp = _jquery2.default.extend(true, {}, this.getData());
	      dataSnapshotDict[tag] = sp;
	      return sp;
	    },
	    hasDataSnapshots: function hasDataSnapshots() {
	      return !!this.getDataSnapshotsAsArray().length;
	    },
	    getDataSnapshotsAsArray: function getDataSnapshotsAsArray() {
	      return (0, _underscore2.default)(this.getDataSnapshots()).toArray();
	    },
	    getDataSnapshots: function getDataSnapshots() {
	      return dataSnapshotDict;
	    },
	    getDataSnapshotViaTag: function getDataSnapshotViaTag(tag) {
	      return dataSnapshotDict[tag];
	    },
	
	    // getLatestDataSnapshot(){
	    //   return dataSnapshots[dataSnapshots.length - 1];
	    // },
	    clearAllDataSnapshots: function clearAllDataSnapshots() {
	      dataSnapshotDict = {};
	    },
	    removeDataSnapshotViaTag: function removeDataSnapshotViaTag(tag) {
	      return delete dataSnapshotDict[tag];
	    },
	    removeDataSnapshot: function removeDataSnapshot(sp) {
	      var tag = (0, _underscore2.default)(dataSnapshots).findKey(_findKeyInDictViaSnapshot, sp);
	      return this.removeDataSnapshotViaTag(tag);
	    },
	    hasDataChangesSinceSnapshotViaTag: function hasDataChangesSinceSnapshotViaTag(tag) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var id = options.id;
	      var s1 = this.getData();
	      var s2 = this.getDataSnapshotViaTag(tag);
	
	      if (!_underscore2.default.isNull(id) && !_underscore2.default.isUndefined(id)) {
	        s1 = s1[id];
	        s2 = s2[id];
	      }
	
	      return this.hasChanges(s1, s2, options);
	    },
	    hasChanges: function hasChanges(s1, s2, _ref) {
	      var only = _ref.only,
	          except = _ref.except;
	
	      if (only) {
	        s1 = (0, _underscore2.default)(s1).only(only);
	        s2 = (0, _underscore2.default)(s2).only(only);
	      } else if (except) {
	        s1 = (0, _underscore2.default)(s1).except(except);
	        s2 = (0, _underscore2.default)(s2).except(except);
	      }
	      return !_underscore2.default.isEqual(s1, s2);
	    },
	
	
	    // General Data regarding store
	    setGeneralFetchingStatus: function setGeneralFetchingStatus(val) {
	      this.getGeneral().fetching = val;
	      this.emitEvent('general:changed', val);
	    },
	    isGeneralFetching: function isGeneralFetching() {
	      return !!this.getGeneral().fetching;
	    },
	    updateGeneralAndEmit: function updateGeneralAndEmit(newGeneral) {
	      _underscore2.default.extend(this.getGeneral(), newGeneral);
	      this.emitEvent("general:changed", data);
	    },
	
	
	    // Data Specific Entity within store
	    setDataFetchingStatus: function setDataFetchingStatus(id, val) {
	      var data = this.getDataViaId(id);
	      data.fetching = val;
	      this.emitObjectChange(allData);
	    },
	    isDataFetching: function isDataFetching(id) {
	      return !!this.getGeneral().fetching;
	    },
	    isDataFetchingSuccess: function isDataFetchingSuccess(id) {
	      return !!this.getGeneral().fetchSuccess;
	    },
	    removeObjectsByIds: function removeObjectsByIds(obj) {
	      var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      if (ids.length) {
	        var _ref2;
	
	        // capture objects that are being removed
	        // before removing
	        var deletedObjects = (_ref2 = (0, _underscore2.default)(obj)).pick.apply(_ref2, _toConsumableArray(ids));
	
	        (0, _underscore2.default)(ids).each(function (id) {
	          delete obj[id];
	        });
	
	        return deletedObjects;
	      }
	    },
	    removeDataByIdsAndEmit: function removeDataByIdsAndEmit(ids) {
	      this.removeObjectsByIdsAndEmit(this.getData(), ids);
	    },
	    removeObjectsByIdsAndEmit: function removeObjectsByIdsAndEmit(obj) {
	      var ids = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      if (ids.length) {
	        var deletedObjects = this.removeObjectsByIds(obj, ids);
	        this.emitEvent('remove', deletedObjects);
	      }
	    },
	    setAttrsForIds: function setAttrsForIds(ids) {
	      var _this = this;
	
	      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var data = this.getData();
	      (0, _underscore2.default)(ids).map(function (id) {
	        var item = data[id];
	        if (item) {
	          _underscore2.default.extend(item, attrs);
	          _this.emitObjectChange(item);
	        }
	      });
	      this.emitEvent('change');
	    },
	    addObjectsAndEmit: function addObjectsAndEmit(object, data) {
	      if (data) {
	        // inplace extend as indicated above
	        var dataAndId = _defineProperty({}, data.id, data);
	        _underscore2.default.extend(object, dataAndId);
	        this.emitEvent('add', data);
	        return data;
	      }
	    },
	    updateObjectAndEmit: function updateObjectAndEmit(id, newData) {
	      var allData = this.getData();
	      var existingData = allData[id];
	      allData[id] = _extends({}, existingData, newData);
	      // emit a global/generic change that we can listen to
	      this.emitEvent("change", allData[id]);
	      return this.emitObjectChange(allData[id]);
	    },
	
	    // this function takes the given new object data: {whatever: "xyz"}
	    // and updates ALL updates in the entire store with this data of key val pairs
	    updateAllObjectsAndEmit: function updateAllObjectsAndEmit(newData) {
	      var _this2 = this;
	
	      var allData = this.getData();
	      //const existingData = allData[id];
	      (0, _underscore2.default)(allData).mapObject(function (currData, id) {
	        allData[id] = _extends({}, currData, newData);
	        _this2.emitObjectChange(allData[id]);
	      });
	      // emit a global/generic change that we can listen to
	      this.emitEvent("change", allData);
	    },
	
	    // this function takes multiple data points: {'dfdsd': {id: 'dfdsd', whatever: "nice"}, 'seww': {id: 'seww', whatever: "nice"}}
	    // and updates just those items in the store
	    updateObjectsAndEmit: function updateObjectsAndEmit(multiData) {
	      var _this3 = this;
	
	      var allData = this.getData();
	      //const existingData = allData[id];
	      (0, _underscore2.default)(multiData).mapObject(function (newData, id) {
	        var oldData = allData[id] || {};
	        allData[id] = _extends({}, oldData, newData);
	        _this3.emitObjectChange(allData[id]);
	      });
	      // emit a global/generic change that we can listen to
	      this.emitEvent("change", allData);
	    },
	    emitObjectChange: function emitObjectChange(obj) {
	      this.emitEvent.apply(this, ['change:' + obj.id].concat(_toConsumableArray(obj)));
	      return obj;
	    },
	    emitChange: function emitChange() {
	      this.emit.apply(this, [CHANGE_EVENT].concat(Array.prototype.slice.call(arguments)));
	    },
	    emitEvent: function emitEvent(key) {
	      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        data[_key - 1] = arguments[_key];
	      }
	
	      this.emit.apply(this, [this.storeEventBaseKey + ':' + key].concat(data));
	    },
	    bindListener: function bindListener(eventKey, callback) {
	      this.on(eventKey, callback);
	    },
	    unbindListener: function unbindListener(eventKey, callback) {
	      this.removeListener(eventKey, callback);
	    },
	    addChangeListener: function addChangeListener(callback) {
	      this.on(CHANGE_EVENT, callback);
	    },
	    removeChangeListener: function removeChangeListener(callback) {
	      this.removeListener(CHANGE_EVENT, callback);
	    },
	    getDataViaId: function getDataViaId(id) {
	      return this.getData()[id];
	    },
	    getDataViaIds: function getDataViaIds() {
	      var _$chain;
	
	      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      return (_$chain = _underscore2.default.chain(this.getData())).pick.apply(_$chain, _toConsumableArray(ids)).values().value();
	    },
	    dataAsArray: function dataAsArray() {
	      return (0, _underscore2.default)(this.getData()).values();
	    },
	    findWhere: function findWhere(attrs) {
	      return (0, _underscore2.default)(this.dataAsArray()).findWhere(attrs);
	    },
	    filter: function filter() {
	      var _ref3;
	
	      return (_ref3 = (0, _underscore2.default)(this.dataAsArray())).filter.apply(_ref3, arguments);
	    },
	    where: function where(attrs) {
	      return (0, _underscore2.default)(this.dataAsArray()).where(attrs);
	    },
	    normalizeAndStoreData: function normalizeAndStoreData(initialData) {
	      if (!initialData) {
	        return;
	      }
	      if (this.getData && this.getDefaults && this.normalizr) {
	        var _data = this.getData();
	        var defaults = this.getDefaults();
	        var curNormalizr = this.normalizr;
	        initialData = (0, _normalizr.normalize)(initialData, curNormalizr).entities;
	
	        _NormalizedEmitter2.default.emit("normalized_data", initialData, { namespaced: true });
	      } else {
	        console.warn('please define a getData and getDefaults function in all of your stores!');
	      }
	    },
	    mergeData: function mergeData(newData) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (options.namespaced) {
	        newData = newData[this.normalizrKey];
	      }
	      if (!newData) {
	        return;
	      }
	      var data = this.getData();
	      var defaults = this.getDefaults();
	      _underscore2.default.extend(data, newData);
	      (0, _underscore2.default)(data).mapObject(this.setDefaults);
	      this.emitEvent('change', data);
	    },
	    setDefaults: function setDefaults(obj) {
	      _underscore2.default.defaults(obj, this.getDefaults());
	    },
	    bindListenersForSubsetOfDataViaIds: function bindListenersForSubsetOfDataViaIds() {
	      this._handleListenersForSubsetOfDataViaIds.apply(this, [].concat(Array.prototype.slice.call(arguments), ["bindListener"]));
	    },
	    unbindListenersForSubsetOfDataViaIds: function unbindListenersForSubsetOfDataViaIds() {
	      this._handleListenersForSubsetOfDataViaIds.apply(this, [].concat(Array.prototype.slice.call(arguments), ["unbindListener"]));
	    },
	    _handleListenersForSubsetOfDataViaIds: function _handleListenersForSubsetOfDataViaIds(ids, eventNamePrefix, cbFunc, funcStr) {
	      var _$chain2,
	          _this4 = this;
	
	      (_$chain2 = _underscore2.default.chain(this.getData())).pick.apply(_$chain2, _toConsumableArray(ids)).mapObject(function (item, id) {
	        _this4[funcStr](eventNamePrefix + ':' + id, cbFunc);
	      }).value();
	    }
	  }, spec, _events.EventEmitter.prototype);
	
	  _underscore2.default.each(store, function (val, key) {
	    if (_underscore2.default.isFunction(val)) {
	      store[key] = store[key].bind(store);
	    }
	  });
	
	  _NormalizedEmitter2.default.on("normalized_data", store.mergeData);
	
	  store.setMaxListeners(0);
	  return store;
	}
	
	function _findKeyInDictViaSnapshot(sp, k) {
	  var origSp = this;
	  return origSp === sp;
	}

/***/ },
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(327);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _storeUtils = __webpack_require__(56);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _relationships = __webpack_require__(55);
	
	var _general = __webpack_require__(5);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// let productItems = {
	//   1:  {
	//     prdId: 1,
	//     itmSku:"perisable date item",
	//     prdBatchLotRequired: "",
	//     prdBarcodeRequired: "",
	//     prdBattery: "true",
	//     prdFragile: "true",
	//     prdHazardMaterial: "false",
	//     prdId: "50",
	//     prdName: "asdfa",
	//     prdPerishable: "true",
	//     shelfLife: "3",
	//     prdPolyBagRequired: "",
	//     prdSerializationRequired: "",
	//     prdShipAlone: ""
	//   },
	//   2:  {
	//     prdId: 2,
	//     itmSku:"longer perisable date item",
	//     prdBatchLotRequired: "",
	//     prdBarcodeRequired: "",
	//     prdBattery: "true",
	//     prdFragile: "true",
	//     prdHazardMaterial: "false",
	//     prdId: "50",
	//     prdName: "asdfa",
	//     prdPerishable: "true",
	//     shelfLife: "20",
	//     prdPolyBagRequired: "",
	//     prdSerializationRequired: "",
	//     prdShipAlone: ""
	//   }
	// };
	
	var productItems = {};
	
	var defaults = {};
	
	var ProductItemStore = (0, _storeUtils.createStore)({
	  storeEventBaseKey: "product_items",
	  normalizr: _relationships.productsItemsKeyToArrayOfProductItems,
	  normalizrKey: "productItems",
	  getData: function getData() {
	    return productItems;
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  getSkus: function getSkus() {
	    return _underscore2.default.chain(this.getData()).values().pluck("itmSku").value();
	  },
	  doesRequireLotNumber: function doesRequireLotNumber(productItem) {
	    return (0, _general.isTruthy)(productItem.prdBatchLotRequired);
	  },
	  isPerishable: function isPerishable(productItem) {
	    return (0, _general.isTruthy)(productItem.prdPerishable);
	  },
	  isFragile: function isFragile(productItem) {
	    return (0, _general.isTruthy)(productItem.prdFragile);
	  },
	  needsBarcode: function needsBarcode(productItem) {
	    // needs barcode is actually the oposite,
	    // the value should be "false" or false
	    // for you to need a barcode
	    return (0, _general.isFalsey)(productItem.prdBarcodeRequired);
	  },
	  getDataViaAsnDetail: function getDataViaAsnDetail(detail) {
	    return (0, _underscore2.default)(this.dataAsArray()).where({ itmSku: detail.sku });
	  },
	  doesSkuExist: function doesSkuExist(val) {
	    return !!(0, _underscore2.default)(this.dataAsArray()).findWhere({ itmSku: val });
	  },
	  addSkuToStore: function addSkuToStore(sku, searchItemURL) {
	    $.ajax({
	      url: searchItemURL,
	      type: 'POST',
	      dataType: 'json',
	      async: false,
	      data: {
	        _asn_WAR_hcportlet_itmSku: sku
	      },
	      beforeSend: function beforeSend() {
	        $.blockUI({ message: 'Please Wait...' });
	      },
	      complete: function complete() {
	        $.unblockUI();
	      },
	      success: function success(resp) {
	        var item = resp;
	        var targetItem = buildProductJson(item);
	        var dataAndId = _defineProperty({}, targetItem.prdId, targetItem);
	        ProductItemStore.mergeData(dataAndId);
	      },
	      error: function error(xhr, status, _error) {
	        alert("Error in getting Item details");
	      }
	    });
	  },
	  addSkusArrayToStore: function addSkusArrayToStore(skusArray, getItemsBySkusUrl) {
	    $.ajax({
	      url: getItemsBySkusUrl,
	      type: 'POST',
	      dataType: 'json',
	      async: false,
	      data: {
	        _asn_WAR_hcportlet_itmSkus: skusArray
	      },
	      beforeSend: function beforeSend() {
	        $.blockUI({ message: 'Please Wait...' });
	      },
	      complete: function complete() {
	        $.unblockUI();
	      },
	      success: function success(resp) {
	        (0, _underscore2.default)(resp).map(function (item, rowIdx) {
	          var targetItem = buildProductJson(item);
	          var dataAndId = _defineProperty({}, targetItem.prdId, targetItem);
	          ProductItemStore.mergeData(dataAndId);
	        });
	        _AsnDetailStore2.default.emitEvent('change');
	      },
	      error: function error(xhr, status, _error2) {
	        alert("Error in getting Item details");
	      }
	    });
	  }
	});
	
	function buildProductJson(item) {
	  var targetItem = {};
	  targetItem.prdId = item.product.prdId;
	  targetItem.prdName = item.product.prdName != null ? item.product.prdName : "";
	  targetItem.prdBattery = item.product.prdBattery;
	  targetItem.prdFragile = item.product.prdFragile;
	  targetItem.prdPerishable = item.product.prdPerishable;
	  targetItem.itmSku = item.itmSku;
	  targetItem.itmCost = item.itmCost != null ? item.itmCost : "0";
	  targetItem.prdHazardMaterial = item.product.prdHazardMaterial;
	  targetItem.prdShipAlone = item.product.prdShipAlone;
	  targetItem.prdPolyBagRequired = item.product.prdPolyBagRequired;
	  targetItem.prdSerializationRequired = item.product.prdSerializationRequired;
	  targetItem.prdBatchLotRequired = item.product.prdBatchLotRequired;
	  targetItem.prdBarcodeRequired = item.product.prdBarcodeMarked;
	  targetItem.prdDescription = item.product.prdName != null ? item.product.prdName : "";
	  targetItem.shelfLife = item.product.prdShelfLife != null ? item.product.prdShelfLife : "";
	
	  return targetItem;
	}
	
	window.ProductItemStore = ProductItemStore;
	exports.default = ProductItemStore;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toCurrency = toCurrency;
	
	var _numeral = __webpack_require__(1561);
	
	var _numeral2 = _interopRequireDefault(_numeral);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toCurrency(numb) {
	  return (0, _numeral2.default)(numb).format('$0,0.00');
	}

/***/ },
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bindJumpToWizardLinks = bindJumpToWizardLinks;
	exports.handleQueryParamTraversalToWizardTab = handleQueryParamTraversalToWizardTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function bindJumpToWizardLinks() {
	  (0, _jquery2.default)(document).on("click", '[data-refresh-to-target-form]', handleRefreshWithQueryKey);
	}
	
	function handleRefreshWithQueryKey(e) {
	  e.preventDefault();
	  var link = (0, _jquery2.default)(this);
	  var newUrl = generateNewUrlFromLink(link);
	  window.location = newUrl;
	}
	
	function generateNewUrlFromLink(link) {
	  var targetStr = link.data('refresh-to-target-form');
	  var href = link.attr('href');
	  var idx = href.indexOf('?');
	  var domainAndPath = href.substring(0, idx);
	  var queryStr = href.substring(idx + 1);
	  var queryObj = _jquery2.default.deparam(queryStr);
	  queryObj.jumptowizardtab = targetStr;
	  queryStr = _jquery2.default.param(queryObj);
	
	  return domainAndPath + "?" + queryStr;
	}
	
	function handleQueryParamTraversalToWizardTab(wizard) {
	  var queryStr = window.location.search.substring(1);
	  var queryObj = _jquery2.default.deparam(queryStr);
	  var targetForm = wizard.getWizardElement().find(queryObj.jumptowizardtab);
	  if (targetForm.length) {
	    wizard.gotToForm(targetForm);
	  }
	}

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = typeAheadSource;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _escapeStringRegexp = __webpack_require__(271);
	
	var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);
	
	var _general = __webpack_require__(5);
	
	var _fuse = __webpack_require__(278);
	
	var _fuse2 = _interopRequireDefault(_fuse);
	
	var _fuseSearchSettings = __webpack_require__(225);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	window.typeAheadSource = typeAheadSource;
	
	function typeAheadSource(dataArray, namedCombo) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  // ["sku-efje", "sku-2323", "another-34343"]
	  // inside of map: "sku-ufje"
	  // will return each map over: {data: "sku-efje"}
	  // finally, map will return: [{data: "sku-efje"}, {data: "sku-2323"}, {data: "another-34343"}]
	  // then assign back to dataArray  
	  dataArray = (0, _underscore2.default)(dataArray).map(function (str) {
	    return { data: str };
	  });
	
	  options = (0, _general.merge)(options, _fuseSearchSettings.searchSettings[namedCombo] || _fuseSearchSettings.searchSettings.base);
	  // override any "keys" key that was passed in because we've transformed
	  // the array of strings to array of objects with "data" as only key
	  options.keys = ["data"];
	
	  var fuse = new _fuse2.default(dataArray, options);
	
	  return function (q, syncResults) {
	    // var matches, substrRegex;
	
	    // an array that will be populated with substring matches
	    // matches = [];
	
	    var res = fuse.search(q);
	    // regex used to determine if a string contains the substring `q`
	    // substrRegex = new RegExp(EscapeStringRegexp(q), 'i');
	    res = (0, _underscore2.default)(res).map(function (obj) {
	      return obj.data;
	    });
	    // iterate through the pool of strings and for any string that
	    // contains the substring `q`, add it to the `matches` array
	    // _(dataArray).each((str)=>{
	    //   if(substrRegex.test(str)){
	    //     matches.push(str);
	    //   }
	    // });
	    syncResults(res);
	  };
	}

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(133);
	
	var callBindBasic = __webpack_require__(150);
	
	/** @type {(thisArg: string, searchString: string, position?: number) => number} */
	var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);
	
	/** @type {import('.')} */
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		/* eslint no-extra-parens: 0 */
	
		var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBindBasic(/** @type {const} */ ([intrinsic]));
		}
		return intrinsic;
	};


/***/ },
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xs-at-md> <a href=\"{%=renderURL %}&{%- portletNamespace %}{%- idName %}={%- id %}\"> {%- displayVal %} </a> </div>";

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.quickFileUploader = undefined;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	__webpack_require__(1064);
	
	
	// export QuickFileUploader to window
	// so it can be referenced in the theme repo
	// for external use (ricochet) and internal bundle
	window.QuickFileUploader = QuickFileUploader;
	
	// FACTORY
	function quickFileUploader(el, options) {
	  if (el && el.length) {
	    if (el.data('quick-file-uploader')) {
	      var qfu = el.data('quick-file-uploader');
	      qfu.setOptions(options);
	      return qfu;
	    } else {
	      var _qfu = new QuickFileUploader(el, options);
	
	      return _qfu;
	    }
	  }
	}
	
	var elementsMap = {
	  fileTextInput: ".qfu-file-text-input",
	  fileInput: ".qfu-file-input",
	  selectFileBtn: ".qfu-select-file-btn",
	  removeBtn: ".qfu-remove-file-btn"
	};
	
	function QuickFileUploader(el) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var self = this;
	  $ = opts.$ || $;
	  var els = {};
	  var options = {};
	  var fileMeta = null;
	
	  self.setOptions = setOptions;
	  self.getFile = getFile;
	
	  function getFile() {
	    return fileMeta;
	  }
	
	  setOptions(opts);
	  init();
	
	  function init() {
	    setElements();
	    render();
	
	    bindElements();
	  }
	
	  function render() {
	    if ((0, _general.isPresent)(els.fileTextInput.val())) {
	      showRemoveBtn();
	    } else {
	      hideRemoveBtn();
	    }
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	  }
	
	  function setOptions(opts) {
	    options = opts;
	  }
	
	  function hideRemoveBtn() {
	    (0, _selectorHelpers.handleDisplayForV2)(els.removeBtn, false);
	  }
	
	  function showRemoveBtn() {
	    (0, _selectorHelpers.handleDisplayForV2)(els.removeBtn, true);
	  }
	
	  function bindElements() {
	    els.selectFileBtn.on("click", handleSelectBtnClick);
	    els.fileInput.on("change", handleFileInputChange);
	    els.removeBtn.on("click", handleRemoveBtnClick);
	  }
	
	  function handleRemoveBtnClick(e) {
	    e.preventDefault();
	    els.fileInput.val("");
	    els.fileTextInput.val("");
	    fileMeta = null;
	    hideRemoveBtn();
	    // check if option available in seperate function and then call option option.afterRemoveFile
	    handleRemoveFileOption();
	  }
	
	  function handleRemoveFileOption() {
	    if (opts.afterRemoveFile) {
	      removeFileAndCallOption();
	    }
	  }
	
	  function removeFileAndCallOption() {
	    opts.afterRemoveFile();
	  }
	
	  function handleFileInputChange(e) {
	    if (fileApiSupported()) {
	      fileMeta = e.target.files[0];
	      setFileMeta(fileMeta);
	      handleReadFileOption();
	      insertFileTextToInput();
	      showRemoveBtn();
	      console.log(fileMeta);
	    } else {
	      alert("Your Browser is Vintage! File upload is not available on this old of a browser.");
	    }
	  }
	
	  function handleReadFileOption() {
	    if (opts.afterReadFile && (0, _general.isPresent)(fileMeta)) {
	      readFileAndCallOption();
	    }
	  }
	
	  function readFileAndCallOption() {
	    var reader = new FileReader();
	    reader.onload = handleFileReadComplete;
	    reader.readAsDataURL(fileMeta);
	  }
	
	  function handleFileReadComplete(e) {
	    var result = e.target.result;
	    opts.afterReadFile(e, result);
	  }
	
	  function insertFileTextToInput() {
	    els.fileTextInput.val(fileMeta.name);
	  }
	
	  function handleSelectBtnClick(e) {
	    e.preventDefault();
	    openNativeFileBrowser();
	  }
	
	  function openNativeFileBrowser() {
	    els.fileInput.trigger("click");
	  }
	
	  function fileApiSupported() {
	    return !!(window.File && window.FileReader && window.FileList && window.Blob);
	  }
	
	  function setFileMeta(fm) {
	    els.fileInput.data('file-meta', fm);
	    fileMeta = fm;
	  }
	}
	
	exports.quickFileUploader = quickFileUploader;
	exports.default = QuickFileUploader;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PagableComponent;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _select2able = __webpack_require__(22);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pagingHtml = __webpack_require__(1180); /*
	                                                      Base file for index file in component.
	                                                      A short description can go here, but more
	                                                      detailed info can be placed in the README.
	                                                    */
	
	// IMPORTS GO HERE
	
	var pageSelectHtml = __webpack_require__(1178);
	var pagingButtonsHtml = __webpack_require__(1181);
	var pageTrayHtml = __webpack_require__(1179);
	var loaderOverlayHtml = __webpack_require__(317);
	__webpack_require__(1070);
	
	function PagableComponent() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // functional code for component here
	  var self = this;
	  var defaults = {
	    pageSizeOptions: [10, 25, 50, 100],
	    pageSize: 10
	  };
	  var settings = _underscore2.default.extend(defaults, options);
	  var dataContainer = (0, _jquery2.default)(settings.dataContainer);
	  var pagingContainer = (0, _jquery2.default)(settings.pagingContainer);
	  var els = {};
	  var elementsMap = {
	    pageSelect: '.page-select',
	    pageInfo: '.page-info',
	    navBtnWrap: '.nav-btn-wrap',
	    loadingOverlay: '.loading-overlay'
	  };
	
	  var totalRows = settings.data.totalElements;
	  var pageSizeOptions = settings.pageSizeOptions;
	  var pageSize = settings.pageSize;
	  var currentPageNumber = settings.data.page;
	  var pagingData = settings.data.content || [];
	  var pageTrayElements = void 0;
	  var totalPages = getTotalPages();
	
	  function getTotalPages() {
	    return Math.ceil(totalRows / pageSize);
	  }
	
	  self.init = function () {
	    setInitialState();
	    buildHtml();
	    setElements();
	    bindElements();
	    (0, _select2able.instantiateSelect2)((0, _jquery2.default)('.page-select'));
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, pagingContainer);
	  }
	
	  function bindElements() {
	    els.pageSelect.on('change', onPageSelectChange);
	    els.navBtnWrap.on('click', '.page-num', onPageNumClick);
	    els.navBtnWrap.on('click', '.next-btn', onNextBtnClick);
	    els.navBtnWrap.on('click', '.prev-btn', onPrevBtnClick);
	  }
	
	  function onPageSelectChange() {
	    pageSize = parseInt(els.pageSelect.val());
	    totalPages = getTotalPages();
	    currentPageNumber = 0;
	    getData();
	    updatePagingArea();
	  }
	
	  function onPageNumClick(e) {
	    e.preventDefault();
	    var pageNumClicked = (0, _jquery2.default)(this).data('page-num');
	    if (currentPageNumber != pageNumClicked) {
	      currentPageNumber = pageNumClicked;
	      getData();
	      updatePagingArea();
	    }
	  }
	
	  function onNextBtnClick() {
	    if (currentPageNumber == totalPages - 1) {
	      els.navBtnWrap.find('.next-btn').addClass('quick-shake');
	      setTimeout(function () {
	        els.navBtnWrap.find('.next-btn').removeClass('quick-shake');
	      }, 500);
	    } else {
	      currentPageNumber++;
	      getData();
	      updatePagingArea();
	    }
	  }
	
	  function onPrevBtnClick() {
	    if (currentPageNumber == 0) {
	      els.navBtnWrap.find('.prev-btn').addClass('quick-shake');
	      setTimeout(function () {
	        els.navBtnWrap.find('.prev-btn').removeClass('quick-shake');
	      }, 500);
	    } else {
	      currentPageNumber--;
	      getData();
	      updatePagingArea();
	    }
	  }
	
	  function setInitialState() {
	    if (!_underscore2.default.contains(pageSizeOptions, pageSize)) {
	      pageSize = pageSizeOptions[0];
	    }
	  }
	
	  function getData() {
	    settings.onFetch && settings.onFetch(currentPageNumber, pageSize);
	  }
	
	  function buildHtml() {
	    renderPagingArea();
	    renderDataRows();
	  }
	
	  function renderPagingArea() {
	    var pagingArea = (0, _render2.default)(pagingHtml, {
	      pageSelect: renderPageSelect(),
	      pageInfo: renderPageInfoText(),
	      pageButtons: renderPageButtons(),
	      loaderOverlay: loaderOverlayHtml
	    });
	    pagingContainer.html(pagingArea);
	  }
	
	  function renderPageSelect() {
	    var pageOptionHtml = (0, _underscore2.default)(pageSizeOptions).map(function (pageOption) {
	      return (0, _render2.default)(pageSelectHtml, {
	        pageData: pageOption,
	        pageSize: pageSize
	      });
	    });
	    return pageOptionHtml.join('');
	  }
	
	  function renderPageInfoText() {
	    return 'Showing ' + exclusiveResultsShownTotal() + '-' + computedInclusiveResultsShownTotal() + ' of ' + totalRows;
	  }
	
	  function exclusiveResultsShownTotal() {
	    return currentPageNumber * pageSize + 1;
	  }
	
	  function computedInclusiveResultsShownTotal() {
	    if (isBeforeLastPage()) {
	      return inclusiveResultsShownTotal();
	    } else {
	      return totalRows;
	    }
	  }
	
	  function isBeforeLastPage() {
	    return totalRows > inclusiveResultsShownTotal();
	  }
	
	  function inclusiveResultsShownTotal() {
	    return pageSize * (currentPageNumber + 1);
	  }
	
	  function renderPageButtons() {
	    return (0, _render2.default)(pagingButtonsHtml, {
	      pageNumTray: generatePageNumTray()
	    });
	  }
	
	  function generatePageNumTray() {
	    var pageNumTrayHtml = generatePageElements().map(function (pageNumElements) {
	      var isLink = pageNumElements === '...' ? false : true;
	      return (0, _render2.default)(pageTrayHtml, {
	        pageNumber: pageNumElements,
	        link: isLink,
	        currentPage: currentPageNumber
	      });
	    });
	    return pageNumTrayHtml.join('');
	  }
	
	  function generatePageElements() {
	    pageTrayElements = [];
	    if (totalPages > 6) {
	      if (currentPageNumber <= 2) {
	        pageTrayElements = ['1', '2', '3', '...', totalPages];
	      } else if (currentPageNumber >= 3 && currentPageNumber < totalPages - 3) {
	        pageTrayElements = ['1', '...', currentPageNumber, currentPageNumber + 1, currentPageNumber + 2, '...', totalPages];
	      } else {
	        pageTrayElements = ['1', '...', totalPages - 2, totalPages - 1, totalPages];
	      }
	    } else {
	      (0, _underscore2.default)(totalPages).times(function (page) {
	        pageTrayElements.push(page + 1);
	      });
	    }
	    return pageTrayElements;
	  }
	
	  function updatePagingArea() {
	    els.pageInfo.html(renderPageInfoText());
	    els.navBtnWrap.html(renderPageButtons());
	  }
	
	  function renderDataRows() {
	    dataContainer.html('');
	    (0, _underscore2.default)(pagingData).each(function (el) {
	      dataContainer.append(settings.showData(el));
	    });
	  }
	
	  self.setData = function (moreData) {
	    pagingData = moreData;
	    renderDataRows();
	  };
	
	  self.showLoadingOverlay = function () {
	    showLoadingOverlay();
	  };
	
	  self.hideLoadingOverlay = function () {
	    hideLoadingOverlay();
	  };
	
	  function showLoadingOverlay() {
	    els.loadingOverlay.show();
	  }
	
	  function hideLoadingOverlay() {
	    els.loadingOverlay.hide();
	  }
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anyChecked = anyChecked;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function anyChecked(checkboxes) {
	  return (0, _underscore2.default)(checkboxes.toArray()).any(function (item) {
	    return $(item).is(":checked");
	  });
	}

/***/ },
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/** @type {import('.')} */
	var $gOPD = __webpack_require__(1133);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1497),
	    getValue = __webpack_require__(1510);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fileUploader;
	exports.photoUploader = photoUploader;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// IMPORTS GO HERE
	__webpack_require__(1068);
	var uploaderBodyHtml = __webpack_require__(1154);
	var fileNameRowHtml = __webpack_require__(1153);
	
	// rename to match what this component is...
	function fileUploader() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // functional code for component here
	  var self = this;
	  var defaults = {
	    maxFileSize: 10
	  };
	
	  var setting = _underscore2.default.extend(defaults, options);
	  var els = {};
	  var elementsMap = {
	    selectFileBtn: '.select-files-btn',
	    mfuFileInput: '.mfu-file-input',
	    fileNameRenderArea: '.file-name-render-area',
	    fileNameRow: '.file-name-row'
	  };
	  var uploaderContainer = (0, _jquery2.default)(setting.target);
	
	  var multiple = false;
	
	  if (setting.multiple) {
	    multiple = true;
	  }
	
	  var acceptedFileFormats = setting.accept || [];
	
	  var fileFormatTextOnBody = acceptedFileFormats.length > 0 ? acceptedFileFormats.join(" ").toUpperCase() : 'All file formats are accepted.';
	
	  var fileFormatForAcceptAttr = acceptedFileFormats.length > 0 ? acceptedFileFormats.join(",") : '';
	
	  var maxFileSize = setting.maxFileSize;
	
	  var fileMeta = null,
	      fileList = [];
	
	  self.init = function () {
	    buildHtml();
	    setElements();
	    bindElements();
	  };
	
	  function buildHtml() {
	    uploaderContainer.html(renderMultiFileUploader());
	  }
	
	  function renderMultiFileUploader() {
	    return (0, _render2.default)(uploaderBodyHtml, {
	      multiple: multiple,
	      maxFileSize: maxFileSize,
	      fileFormat: fileFormatTextOnBody,
	      accept: fileFormatForAcceptAttr
	    });
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, uploaderContainer);
	  }
	
	  function bindElements() {
	    els.selectFileBtn.on('click', onSelectFileBtnClick);
	    els.mfuFileInput.on('change', handleFileInputChange);
	    uploaderContainer.on('click', '.file-remove-btn', handleRemoveBtnClick);
	  }
	
	  function onSelectFileBtnClick(e) {
	    e.preventDefault();
	    els.mfuFileInput.trigger('click');
	  }
	
	  function handleFileInputChange(e) {
	    if (fileApiSupported()) {
	      if (!multiple) {
	        fileList = [];
	      }
	      fileMeta = e.target.files;
	      if (fileList.length < 1) {
	        fileList = Object.keys(fileMeta).map(function (key) {
	          return fileMeta[key];
	        });
	      } else {
	        var newSelection = Object.keys(fileMeta).map(function (key) {
	          return fileMeta[key];
	        });
	        fileList = fileList.concat(newSelection);
	      }
	      //console.log(fileMeta);
	      //console.log(fileList);
	      renderSelectedFilesInRow(fileList);
	    } else {
	      alert("Your Browser is Vintage! File upload is not available on this old of a browser.");
	    }
	  }
	
	  function fileApiSupported() {
	    return !!(window.File && window.FileReader && window.FileList && window.Blob);
	  }
	
	  function renderSelectedFilesInRow(list) {
	    var fileListHtml = list.map(function (item, index) {
	      var ndx = index;
	      var errorHtml = void 0,
	          extension = void 0,
	          hasError = void 0,
	          isInvalidFileFormat = void 0;
	
	      if (acceptedFileFormats.length > 0) {
	        acceptedFileFormats = acceptedFileFormats.map(function (opt) {
	          return opt.toUpperCase();
	        });
	        extension = getFileExtension(item.name);
	        isInvalidFileFormat = !(0, _underscore2.default)(acceptedFileFormats).contains(extension);
	      }
	
	      if (isInvalidFileFormat || isFileSizeAllowed(item.size)) {
	        errorHtml = '<div class="q-alert q-alert-red q-marg-top-xs">File is too big or the wrong format. Please delete this file and reupload a corrected file.</div>';
	        hasError = 'has-error';
	      }
	
	      return (0, _render2.default)(fileNameRowHtml, {
	        fileName: item.name,
	        error: errorHtml,
	        ndx: ndx,
	        hasError: hasError
	      });
	    });
	
	    els.fileNameRenderArea.html(fileListHtml.join(""));
	    handleCallBacksAfterSelection();
	  }
	
	  function handleRemoveBtnClick(e) {
	    e.preventDefault();
	    var targetClosestEl = (0, _jquery2.default)(this).closest(".file-name-row");
	    var indexToRemove = targetClosestEl.data('file-list-index');
	    if (indexToRemove > -1) {
	      fileList.splice(indexToRemove, 1);
	    }
	    renderSelectedFilesInRow(fileList);
	  }
	
	  function getFileExtension(name) {
	    return '.' + name.split('.').pop().toUpperCase();
	  }
	
	  function isFileSizeAllowed(size) {
	    return Math.ceil(size / 1000000) > maxFileSize;
	  }
	
	  function isSelectionValid() {
	    if (els.fileNameRenderArea.children().length) {
	      return !els.fileNameRenderArea.children().hasClass('has-error');
	    }
	  }
	
	  function handleCallBacksAfterSelection() {
	    if (isSelectionValid()) {
	      options.afterValidSelection && options.afterValidSelection();
	    } else {
	      options.afterInvalidSelection && options.afterInvalidSelection(fileList.length);
	    }
	  }
	
	  self.getFiles = function () {
	    if (isSelectionValid()) {
	      return fileList;
	    }
	  };
	};
	
	function photoUploader() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // functional code for component here
	  var self = this;
	  var defaults = {
	    maxFileSize: 10
	  };
	
	  var setting = _underscore2.default.extend(defaults, options);
	  var els = {};
	  var elementsMap = {
	    selectFileBtn: '.select-files-btn',
	    mfuFileInput: '.mfu-file-input',
	    fileNameRenderArea: '.file-name-render-area',
	    fileNameRow: '.file-name-row'
	  };
	  var uploaderContainer = (0, _jquery2.default)(setting.target);
	
	  var multiple = false;
	
	  if (setting.multiple) {
	    multiple = true;
	  }
	
	  var acceptedFileFormats = setting.accept || [];
	
	  var fileFormatTextOnBody = acceptedFileFormats.length > 0 ? acceptedFileFormats.join(" ").toUpperCase() : 'All file formats are accepted.';
	
	  var fileFormatForAcceptAttr = acceptedFileFormats.length > 0 ? acceptedFileFormats.join(",") : '';
	
	  var maxFileSize = setting.maxFileSize;
	
	  var fileMeta = null,
	      fileList = [];
	
	  self.init = function () {
	    buildHtml();
	    setElements();
	    bindElements();
	  };
	
	  function buildHtml() {
	    uploaderContainer.html(renderMultiFileUploader());
	  }
	
	  function renderMultiFileUploader() {
	    return (0, _render2.default)(uploaderBodyHtml, {
	      multiple: multiple,
	      maxFileSize: maxFileSize,
	      fileFormat: fileFormatTextOnBody,
	      accept: fileFormatForAcceptAttr
	    });
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, uploaderContainer);
	  }
	
	  function bindElements() {
	    els.selectFileBtn.on('click', onSelectFileBtnClick);
	    els.mfuFileInput.on('change', handleFileInputChange);
	    uploaderContainer.on('click', '.file-remove-btn', handleRemoveBtnClick);
	  }
	
	  function onSelectFileBtnClick(e) {
	    e.preventDefault();
	    els.mfuFileInput.trigger('click');
	  }
	
	  function handleFileInputChange(e) {
	    if (fileApiSupported()) {
	      if (!multiple) {
	        fileList = [];
	      }
	      fileMeta = e.target.files;
	      if (fileList.length < 1) {
	        fileList = Object.keys(fileMeta).map(function (key) {
	          return fileMeta[key];
	        });
	      } else {
	        var newSelection = Object.keys(fileMeta).map(function (key) {
	          return fileMeta[key];
	        });
	        fileList = fileList.concat(newSelection);
	      }
	      //console.log(fileMeta);
	      //console.log(fileList);
	      renderSelectedFilesInRow(fileList);
	    } else {
	      alert("Your Browser is Vintage! File upload is not available on this old of a browser.");
	    }
	  }
	
	  function fileApiSupported() {
	    return !!(window.File && window.FileReader && window.FileList && window.Blob);
	  }
	
	  function renderSelectedFilesInRow(list) {
	    var fileListHtml = list.map(function (item, index) {
	      var ndx = index;
	      var errorHtml = void 0,
	          extension = void 0,
	          hasError = void 0,
	          isInvalidFileFormat = void 0;
	
	      if (acceptedFileFormats.length > 0) {
	        acceptedFileFormats = acceptedFileFormats.map(function (opt) {
	          return opt.toUpperCase();
	        });
	        extension = getFileExtension(item.name);
	        isInvalidFileFormat = !(0, _underscore2.default)(acceptedFileFormats).contains(extension);
	      }
	
	      if (isInvalidFileFormat || isFileSizeAllowed(item.size)) {
	        errorHtml = '<div class="q-alert q-alert-red q-marg-top-xs">File is too big or the wrong format. Please delete this file and reupload a corrected file.</div>';
	        hasError = 'has-error';
	      }
	
	      return (0, _render2.default)(fileNameRowHtml, {
	        fileName: item.name,
	        error: errorHtml,
	        ndx: ndx,
	        hasError: hasError
	      });
	    });
	
	    els.fileNameRenderArea.html(fileListHtml.join(""));
	    handleCallBacksAfterSelection();
	  }
	
	  function handleRemoveBtnClick(e) {
	    e.preventDefault();
	    var targetClosestEl = (0, _jquery2.default)(this).closest(".file-name-row");
	    var indexToRemove = targetClosestEl.data('file-list-index');
	    if (indexToRemove > -1) {
	      fileList.splice(indexToRemove, 1);
	    }
	    renderSelectedFilesInRow(fileList);
	  }
	
	  function getFileExtension(name) {
	    return '.' + name.split('.').pop().toUpperCase();
	  }
	
	  function isFileSizeAllowed(size) {
	    return size / 1000000 > maxFileSize;
	  }
	
	  function isSelectionValid() {
	    if (els.fileNameRenderArea.children().length) {
	      return !els.fileNameRenderArea.children().hasClass('has-error');
	    }
	  }
	
	  function handleCallBacksAfterSelection() {
	    if (isSelectionValid()) {
	      options.afterValidSelection && options.afterValidSelection();
	    } else {
	      options.afterInvalidSelection && options.afterInvalidSelection(fileList.length);
	    }
	  }
	
	  self.getFiles = function () {
	    if (isSelectionValid()) {
	      return fileList;
	    }
	  };
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _storeUtils = __webpack_require__(56);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _relationships = __webpack_require__(55);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var abilities = {};
	
	var defaults = {};
	
	var AbilityStore = (0, _storeUtils.createStore)({
	  storeEventBaseKey: "abilities",
	  normalizr: _relationships.abilitiesKeyToArrayOfAbilities,
	  normalizrKey: "abilities",
	  getData: function getData() {
	    return abilities;
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  ask: function ask(key) {
	    // For testing, uncomment
	    // if(key === "canEditGtlAsn"){
	    //   return false;
	    // }
	    var v = this.getData()[key] && this.getData()[key].value;
	    // we make everything default to true,
	    // unless explicitly set to false
	    // (not truly happy about this, but
	    //  alvin is not sending this key on
	    //  create action, which break the logic)
	    // By defaulting to true, we are allowed
	    // edit in any case, unless explicity set to false
	    return (0, _general.isBlank)(v) || (0, _general.isTruthy)(v);
	  }
	});
	
	window.AbilityStore = AbilityStore;
	exports.default = AbilityStore;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mockPayload = undefined;
	
	var _storeUtils = __webpack_require__(56);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _relationships = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var quotes = {};
	var general = {};
	
	var defaults = {};
	
	var QuoteStore = (0, _storeUtils.createStore)({
	  idAttribute: _relationships.quoteIdAttribute,
	  storeEventBaseKey: "quotes",
	  normalizr: _relationships.quotesKeyToArrayOfQuotes,
	  normalizrKey: "quotes",
	  getData: function getData() {
	    return quotes;
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  getGeneral: function getGeneral() {
	    return general;
	  }
	});
	
	window.QuoteStore = QuoteStore;
	exports.default = QuoteStore;
	var mockPayload = exports.mockPayload = {
	  quotes: [{
	    quoteId: "1",
	    optionId: "1234",
	    bolNumber: "6547",
	    estimatedPickupDate: "12/24/2016",
	    estimatedTransitTime: "2 Days",
	    estimatedCost: 3145.50
	
	  }, {
	    quoteId: "2",
	    optionId: "123",
	    bolNumber: "654",
	    estimatedPickupDate: "12/24/2016",
	    estimatedTransitTime: "3 Days",
	    estimatedCost: 2045
	  }, {
	    quoteId: "3",
	    optionId: "1239",
	    bolNumber: "6545",
	    estimatedPickupDate: "12/24/2016",
	    estimatedTransitTime: "4 Days",
	    estimatedCost: 1005
	  }]
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ProductItemStore = __webpack_require__(65);
	
	var _ProductItemStore2 = _interopRequireDefault(_ProductItemStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _ShippingMethodStore = __webpack_require__(113);
	
	var _ShippingMethodStore2 = _interopRequireDefault(_ShippingMethodStore);
	
	var _BrokerStore = __webpack_require__(223);
	
	var _BrokerStore2 = _interopRequireDefault(_BrokerStore);
	
	var _AbilityStore = __webpack_require__(97);
	
	var _AbilityStore2 = _interopRequireDefault(_AbilityStore);
	
	var _QuoteStore = __webpack_require__(98);
	
	var _QuoteStore2 = _interopRequireDefault(_QuoteStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stores = {
	  ProductItemStore: _ProductItemStore2.default,
	  AsnStore: _AsnStore2.default,
	  AsnDetailStore: _AsnDetailStore2.default,
	  CmrServiceStore: _CmrServiceStore2.default,
	  CmrDomainStore: _CmrDomainStore2.default,
	  ShippingMethodStore: _ShippingMethodStore2.default,
	  BrokerStore: _BrokerStore2.default,
	  AbilityStore: _AbilityStore2.default,
	  QuoteStore: _QuoteStore2.default
	};
	
	exports.default = stores;

/***/ },
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1131);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 107 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 108 */,
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _configPanel = __webpack_require__(1189);
	
	var _configPanel2 = _interopRequireDefault(_configPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1076);
	
	function ConfigPanel() {
	  var self = this;
	  var element = void 0;
	
	  self.init = function () {
	    setElements();
	  };
	
	  self.getElement = function () {
	    return element;
	  };
	
	  function setElements() {
	    element = $(_configPanel2.default);
	  }
	
	  self.attachToBody = function () {
	    if (!gConfig.disableAll) {
	      $('body').append(element);
	    }
	  };
	
	  self.show = function () {
	    (0, _selectorHelpers.resetDisplay)(element);
	  };
	  self.hide = function () {
	    (0, _selectorHelpers.hide)(element);
	  };
	}
	
	var gConfig = {};
	
	ConfigPanel.gConfig = function () {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  gConfig.disableAll = options.disableAll;
	};
	
	exports.default = ConfigPanel;

/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  QUOTES_RELATED_SNAPSHOT: "QUOTES_RELATED_SNAPSHOT",
	  INITIAL_ASN_RELATED_SNAPSHOT: "INITIAL_ASN_RELATED_SNAPSHOT"
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _events = __webpack_require__(131);
	
	var _objectAssign = __webpack_require__(107);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CHANGE_EVENT = 'change';
	
	var AddressEventBus = (0, _objectAssign2.default)({
	  emitChange: function emitChange() {
	    this.emit.apply(this, [CHANGE_EVENT].concat(Array.prototype.slice.call(arguments)));
	  },
	  bindListener: function bindListener(eventKey, callback) {
	    this.on(eventKey, callback);
	  },
	  unbindListener: function unbindListener(eventKey, callback) {
	    this.removeListener(eventKey, callback);
	  },
	  addChangeListener: function addChangeListener(callback) {
	    this.on(CHANGE_EVENT, callback);
	  },
	  removeChangeListener: function removeChangeListener(callback) {
	    this.removeListener(CHANGE_EVENT, callback);
	  }
	}, _events.EventEmitter.prototype);
	
	exports.default = AddressEventBus;

/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getMap = getMap;
	exports.getAdditionalCarrierMap = getAdditionalCarrierMap;
	exports.getReviewTabElements = getReviewTabElements;
	function getMap() {
	    return elementsPageMap;
	}
	
	function getAdditionalCarrierMap() {
	    return additionalCarrierElementsPageMap;
	}
	
	function getReviewTabElements() {
	    return reviewTabElements;
	}
	
	var elementsPageMap = {
	    packingTab: ".packing-tab-section-hidden",
	    packingTabB2c: ".packing-tab-b2c",
	    reviewTabB2c: ".packingTabB2c",
	    b2bPackTab: ".b2b-packing-tab",
	    business: ".b2b-b2b-info-msg",
	    b2b: ".b2b",
	    b2c: ".b2c",
	    orderTypeRetailerSwitch: '.order-type-retailer-switch',
	    orderTypeRetailerSwitchSection: '.specific-retailer-toggle-target',
	    orderTypeRetailerList: '.order-type-retailer-list',
	    orderTypeDropShipSwitch: '.order-type-dropShip-switch',
	    orderTypeNameInput: '.orderTypeNameInput',
	    orderTypeCodeInput: '.orderTypeCodeInput',
	    orderTypeDuplicateError: "#create-order-type-duplicate",
	    orderTypeFullfillmentCenter: '#order_type_fulfillmentCenter',
	    orderTypeBillingMethod: '#order_type_billingMethod',
	    orderTypeCarrier: '#order_type_carrier',
	    carrierDropDownSection: ".carrier-drop-section",
	    fedExSection: ".fedex-section",
	    upsSection: ".ups-section",
	    orderTypeFedexAccountNumber: '.order-type-fedex-account-number',
	    orderTypeUpsAccountNumber: '.order-type-ups-account-number',
	    orderTypeBillto: '.order-type-billto',
	    orderTypeDetailCountry: '.order-type-detail-country',
	    orderTypeDetailAddress: '.order-type-detail-address',
	    orderTypeDetailAddress2: '.order-type-detail-address2',
	    orderTypeDetailCity: '.order-type-detail-city',
	    orderTypeDetailState: '.order-type-detail-state',
	    orderTypeDetailStateInput: '.order-type-detail-state-input',
	    orderTypeDetailPostalcode: '.order-type-detail-postalcode',
	    destinationTabStateTextWrapper: '.destination-tab-stateText-wrapper',
	    orderTypeDetailStateDropdown: '.order-type-detail-state-dropdown',
	    orderTypeDetailAddcarrier: '.order-type-detail-addcarrier',
	    orderTypedetailAddcarrierDiv: '.order-type-detail-addcarrier-div',
	    orderDestinationTabFfcMsg: ".order-destination-tab-ffc-msg",
	    errorText: ".errorText",
	    dupErrorText: ".dupErrorText",
	    orderTypeBoxType: "#order-type-boxType",
	    orderTypeTissuePaper: "#order-type-tissuePaper",
	    orderPackingSlip: "#order-packing-slip",
	    includePackageDiv: ".includePackageDiv",
	    packagePackingSlip: "#package-packing-slip",
	    orderTypeCountryCode: "#order-type-countryCode",
	    facilityAddress: "#order-type-facility",
	    packageSlip: "#order-type-package-slip",
	    orderSlip: "#order-type-order-slip",
	    boxTypeDesc: "#boxType-desc",
	    tissuePaperDesc: "#tissuePaper-desc",
	    customizeSection: '.customize-section',
	    orderTypeFacilityAddrss1: '#order-type-facility-add-1',
	    orderTypeFacilityAddrss2: '#order-type-facility-add-2',
	    companyNameInput: ".companyNameInput",
	    customDocEmail: "#order-type-custom-doc-email",
	    customHeader: ".customHeader",
	    customBody: ".customBody",
	    includePackageLabel: ".includePackageLabel",
	    customDocPhoneNumber: ".phone-number"
	};
	
	var additionalCarrierElementsPageMap = {
	
	    additionalCarrierDrop: '.additionalCarrierDrop',
	    fedexAccountNumber: "#fedexAccountNumber",
	    upsAccountNumber: "#upsAccountNumber",
	    additionalCarrierBillTo: ".additional-carrier-billTo",
	    additionalCarrierCountry: ".additional-carrier-country",
	    additionalCarrierAddress1: ".additional-carrier-address1",
	    additionalCarrierAddress2: ".additional-carrier-address2",
	    additionalCarrierCity: ".additional-carrier-city",
	    additionalCarrierDetailState: ".additional-carrier-detail-state",
	    additionalCarrierDetailStateText: ".additional-carrier-detail-state-text",
	    additionalCarrierPostalCode: ".additional-carrier-postalCode",
	    additionalCarrierDetailStateWrapper: ".additional-carrier-detail-state-wrapper",
	    additionalCarrierDetailStateTextWrapper: ".additional-carrier-detail-state-text-wrapper",
	    orderTypeDetailRemove: ".order-type-detail-remove",
	    additionalCarrierMainDiv: ".additional-carrier",
	    additionalCarrierFedexNumber: '.additional-carrier-fedexnumber',
	    additionalCarrierUPSNumber: '.additional-carrier-upsnumber'
	};
	
	var reviewTabElements = {
	    sectionTitlesReviewTab: ".section-step-title-inner",
	    specifiedRetailerSection: ".specified-retailer-seciton",
	    retailerName: ".spec-retailer-name",
	    dropShippingNo: ".dropShipNo",
	    dropShippingYes: ".dropShipNoYes",
	    detailsSection: ".detailsSection",
	    orderTypeName: ".order-type-name",
	    orderTypeCode: ".order-type-code",
	    fulfillmentCenterSection: ".fulfillmentSection",
	    fulfillmentCenter: ".fulfillment-center",
	    carrierSection: ".carrierSection",
	    billMethod: ".bill-method",
	    nonPrepaidLabels: ".non-prepaid",
	    carrierName: ".carrier-name",
	    accountNumber: ".account-number",
	    billToName: ".bill-to-name",
	    billToAddressLine: ".address-line",
	    cityStatePostalCode: ".city-state-postalCode",
	    billToCountry: ".country",
	    additionalCarrierSection: ".additional-carrier-section",
	    additionalCarrierName: ".additional-carrier-name",
	    nonFedExSection: ".non-fedex",
	    additionalCarrierAccountNumber: ".additional-carrier-number",
	    additionalNonFedEx: ".additional-non-fedex",
	    additonalBillToName: ".additional-bill-to-name",
	    additionalBillToAddressLine: ".additional-address-line",
	    additionalCityStatePostalCode: ".additional-city-state-postalCode",
	    additionalBillToCountry: ".additional-country",
	    orderPackingSection: ".order-packing-section",
	    boxType: ".box-type",
	    boxTypeCost: ".box-type-cost",
	    tissuePaper: ".tissue-paper",
	    tissuePaperCost: ".tissue-paper-cost",
	    orderDocumentSection: ".order-document-section",
	    packageLevelSlipOn: ".package-level-slip-on",
	    packageLevelSlipOff: ".package-level-slip-off",
	    packageLevelSlipTemplate: ".package-level-slip-template",
	    orderLevelSlipOn: ".order-level-slip-on",
	    orderLevelSlipOff: ".order-level-slip-off",
	    orderLevelSlipTemplate: ".order-level-slip-template",
	    includeLabelOn: ".include-label-on",
	    includeLabelOff: ".include-label-off",
	    includeLabelDiv: ".includeLabelDiv",
	    customDocSection: ".customized-document-section",
	    customDocName: ".custom-doc-name",
	    customDocFacilityName: ".custom-doc-facility-name",
	    customDocAddressLine: ".custom-doc-address-line",
	    customDocCityState: ".custom-doc-city-state",
	    customDocPhone: ".custom-doc-phone-number",
	    customDocEmail: ".custom-doc-email",
	    customDocHeader: ".custom-doc-header",
	    customDocBody: ".custom-doc-body",
	    submitBtn: ".submit-order-type-wizard"
	};

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _storeUtils = __webpack_require__(56);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _relationships = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var shippingMethods = {};
	
	// let cmrDomains = {};
	
	var defaults = {};
	
	var ShippingMethodStore = (0, _storeUtils.createStore)({
	  storeEventBaseKey: "shipping_methods",
	  normalizr: _relationships.shippingMethodsKeyToArrayOfShippingMethods,
	  normalizrKey: "shippingMethods",
	  getData: function getData() {
	    return shippingMethods;
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  getShippingMethods: function getShippingMethods() {
	    return shippingMethods;
	  },
	  getShippingMethod: function getShippingMethod(id) {
	    return shippingMethods[id];
	  }
	});
	
	window.ShippingMethodStore = ShippingMethodStore;
	exports.default = ShippingMethodStore;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = generateDatePicker;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var standardDatePickerHtml = __webpack_require__(1466); // IMPORTS GO HERE
	
	var rangeDatePickerHtml = __webpack_require__(1465);
	
	// rename to match what this utility is...
	function generateDatePicker(els) {
	  // functional code for utility here
	  els.each(function () {
	    var el = this;
	    var $el = (0, _jquery2.default)(this);
	    var defaults = {
	      todayBtn: 'linked',
	      keyboardNavigation: false,
	      autoclose: true
	    };
	    var options = (0, _collectDataAttributesFor2.default)(el, { prefix: "dp" });
	
	    var settings = _underscore2.default.extend(defaults, options);
	
	    var type = settings.type;
	
	    var startVal = settings.startVal;
	    var endVal = settings.endVal;
	
	    if (settings.startDate == 'today') {
	      settings.startDate = (0, _moment2.default)().format('MM/DD/YYYY');
	    }
	
	    if (type == 'single') {
	      $el.html((0, _render2.default)(standardDatePickerHtml, {
	        uniqueIdentifier: settings.uniqueIdentifier
	      }));
	    }
	
	    if (type == 'range') {
	      $el.html((0, _render2.default)(rangeDatePickerHtml, {
	        uniqueIdentifier: settings.uniqueIdentifier
	      }));
	    }
	
	    var standardDatePickerEL = $el.find('.' + settings.uniqueIdentifier),
	        rangeDatePickerStartEl = $el.find('.' + settings.uniqueIdentifier + '-start'),
	        rangeDatePickerEndEl = $el.find('.' + settings.uniqueIdentifier + '-end');
	
	    standardDatePickerEL.datepicker(settings);
	    rangeDatePickerStartEl.datepicker(settings).on('hide', function () {
	      if (!rangeDatePickerStartEl.val().length) {
	        resetRangeEndDateEl();
	      }
	    });
	    resetRangeEndDateEl();
	
	    rangeDatePickerStartEl.on('change', function () {
	      var oldStartDate = rangeDatePickerStartEl.val();
	      if (oldStartDate.length) {
	        var newStartDate = new Date(Date.parse(oldStartDate) + 86400000);
	        settings.startDate = formatDate(newStartDate);
	        rangeDatePickerEndEl.removeAttr('disabled');
	        rangeDatePickerEndEl.val('');
	        rangeDatePickerEndEl.datepicker('remove');
	        rangeDatePickerEndEl.datepicker(settings);
	      } else {
	        resetRangeEndDateEl();
	      }
	    });
	
	    function formatDate(date) {
	      var day = date.getDate(),
	          month = date.getMonth() + 1,
	          year = date.getFullYear();
	      return month + '/' + day + '/' + year;
	    }
	
	    if (type == 'single' && startVal) {
	      standardDatePickerEL.val(startVal);
	    }
	
	    if (type == 'range' && startVal || endVal) {
	      rangeDatePickerStartEl.val(startVal);
	      rangeDatePickerEndEl.val(endVal);
	      rangeDatePickerEndEl.removeAttr('disabled');
	      rangeDatePickerEndEl.datepicker(settings);
	    }
	
	    function resetRangeEndDateEl() {
	      rangeDatePickerEndEl.attr('disabled', 'disabled');
	      rangeDatePickerEndEl.val('');
	      rangeDatePickerEndEl.datepicker('remove');
	    }
	  });
	};

/***/ },
/* 115 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bindHardSubmit = bindHardSubmit;
	function bindHardSubmit(_ref) {
	  var form = _ref.form,
	      links = _ref.links;
	
	  links.on('click', handleSubmit(form));
	}
	
	function handleSubmit(form) {
	  return function (e) {
	    e.preventDefault();
	    form.submit();
	  };
	}

/***/ },
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	var $defineProperty = Object.defineProperty || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ },
/* 131 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 132 */
92,
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Object = __webpack_require__(270);
	
	var $Error = __webpack_require__(1057);
	var $EvalError = __webpack_require__(1056);
	var $RangeError = __webpack_require__(1058);
	var $ReferenceError = __webpack_require__(1059);
	var $SyntaxError = __webpack_require__(269);
	var $TypeError = __webpack_require__(63);
	var $URIError = __webpack_require__(1060);
	
	var abs = __webpack_require__(1549);
	var floor = __webpack_require__(1550);
	var max = __webpack_require__(1552);
	var min = __webpack_require__(1553);
	var pow = __webpack_require__(1554);
	var round = __webpack_require__(1555);
	var sign = __webpack_require__(1556);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = __webpack_require__(93);
	var $defineProperty = __webpack_require__(130);
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(1135)();
	
	var getProto = __webpack_require__(181);
	var $ObjectGPO = __webpack_require__(279);
	var $ReflectGPO = __webpack_require__(280);
	
	var $apply = __webpack_require__(148);
	var $call = __webpack_require__(149);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': $Object,
		'%Object.getOwnPropertyDescriptor%': $gOPD,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	
		'%Function.prototype.call%': $call,
		'%Function.prototype.apply%': $apply,
		'%Object.defineProperty%': $defineProperty,
		'%Object.getPrototypeOf%': $ObjectGPO,
		'%Math.abs%': abs,
		'%Math.floor%': floor,
		'%Math.max%': max,
		'%Math.min%': min,
		'%Math.pow%': pow,
		'%Math.round%': round,
		'%Math.sign%': sign,
		'%Reflect.getPrototypeOf%': $ReflectGPO
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(105);
	var hasOwn = __webpack_require__(282);
	var $concat = bind.call($call, Array.prototype.concat);
	var $spliceApply = bind.call($apply, Array.prototype.splice);
	var $replace = bind.call($call, String.prototype.replace);
	var $strSlice = bind.call($call, String.prototype.slice);
	var $exec = bind.call($call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = __webpack_require__(281);
	
	/** @type {import('.')} */
	module.exports = function hasToStringTagShams() {
		return hasSymbols() && !!Symbol.toStringTag;
	};


/***/ },
/* 135 */
/***/ function(module, exports) {

	module.exports = "<option value=\"{%- targetKey %}\">{%- text %}</option>";

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1520),
	    listCacheDelete = __webpack_require__(1521),
	    listCacheGet = __webpack_require__(1522),
	    listCacheHas = __webpack_require__(1523),
	    listCacheSet = __webpack_require__(1524);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(329);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(190),
	    getRawTag = __webpack_require__(1507),
	    objectToString = __webpack_require__(1533);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1517);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(94);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 141 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
	var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
	var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
	var mapForEach = hasMap && Map.prototype.forEach;
	var hasSet = typeof Set === 'function' && Set.prototype;
	var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
	var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
	var setForEach = hasSet && Set.prototype.forEach;
	var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
	var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
	var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
	var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
	var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
	var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
	var booleanValueOf = Boolean.prototype.valueOf;
	var objectToString = Object.prototype.toString;
	var functionToString = Function.prototype.toString;
	var $match = String.prototype.match;
	var $slice = String.prototype.slice;
	var $replace = String.prototype.replace;
	var $toUpperCase = String.prototype.toUpperCase;
	var $toLowerCase = String.prototype.toLowerCase;
	var $test = RegExp.prototype.test;
	var $concat = Array.prototype.concat;
	var $join = Array.prototype.join;
	var $arrSlice = Array.prototype.slice;
	var $floor = Math.floor;
	var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
	var gOPS = Object.getOwnPropertySymbols;
	var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
	var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
	// ie, `has-tostringtag/shams
	var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
	    ? Symbol.toStringTag
	    : null;
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	
	var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
	    [].__proto__ === Array.prototype // eslint-disable-line no-proto
	        ? function (O) {
	            return O.__proto__; // eslint-disable-line no-proto
	        }
	        : null
	);
	
	function addNumericSeparator(num, str) {
	    if (
	        num === Infinity
	        || num === -Infinity
	        || num !== num
	        || (num && num > -1000 && num < 1000)
	        || $test.call(/e/, str)
	    ) {
	        return str;
	    }
	    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
	    if (typeof num === 'number') {
	        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
	        if (int !== num) {
	            var intStr = String(int);
	            var dec = $slice.call(str, intStr.length + 1);
	            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
	        }
	    }
	    return $replace.call(str, sepRegex, '$&_');
	}
	
	var utilInspect = __webpack_require__(1581);
	var inspectCustom = utilInspect.custom;
	var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
	
	var quotes = {
	    __proto__: null,
	    'double': '"',
	    single: "'"
	};
	var quoteREs = {
	    __proto__: null,
	    'double': /(["\\])/g,
	    single: /(['\\])/g
	};
	
	module.exports = function inspect_(obj, options, depth, seen) {
	    var opts = options || {};
	
	    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
	        throw new TypeError('option "quoteStyle" must be "single" or "double"');
	    }
	    if (
	        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
	            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
	            : opts.maxStringLength !== null
	        )
	    ) {
	        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
	    }
	    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
	    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
	        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
	    }
	
	    if (
	        has(opts, 'indent')
	        && opts.indent !== null
	        && opts.indent !== '\t'
	        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
	    ) {
	        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
	    }
	    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
	        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
	    }
	    var numericSeparator = opts.numericSeparator;
	
	    if (typeof obj === 'undefined') {
	        return 'undefined';
	    }
	    if (obj === null) {
	        return 'null';
	    }
	    if (typeof obj === 'boolean') {
	        return obj ? 'true' : 'false';
	    }
	
	    if (typeof obj === 'string') {
	        return inspectString(obj, opts);
	    }
	    if (typeof obj === 'number') {
	        if (obj === 0) {
	            return Infinity / obj > 0 ? '0' : '-0';
	        }
	        var str = String(obj);
	        return numericSeparator ? addNumericSeparator(obj, str) : str;
	    }
	    if (typeof obj === 'bigint') {
	        var bigIntStr = String(obj) + 'n';
	        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
	    }
	
	    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
	    if (typeof depth === 'undefined') { depth = 0; }
	    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
	        return isArray(obj) ? '[Array]' : '[Object]';
	    }
	
	    var indent = getIndent(opts, depth);
	
	    if (typeof seen === 'undefined') {
	        seen = [];
	    } else if (indexOf(seen, obj) >= 0) {
	        return '[Circular]';
	    }
	
	    function inspect(value, from, noIndent) {
	        if (from) {
	            seen = $arrSlice.call(seen);
	            seen.push(from);
	        }
	        if (noIndent) {
	            var newOpts = {
	                depth: opts.depth
	            };
	            if (has(opts, 'quoteStyle')) {
	                newOpts.quoteStyle = opts.quoteStyle;
	            }
	            return inspect_(value, newOpts, depth + 1, seen);
	        }
	        return inspect_(value, opts, depth + 1, seen);
	    }
	
	    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
	        var name = nameOf(obj);
	        var keys = arrObjKeys(obj, inspect);
	        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
	    }
	    if (isSymbol(obj)) {
	        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
	        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
	    }
	    if (isElement(obj)) {
	        var s = '<' + $toLowerCase.call(String(obj.nodeName));
	        var attrs = obj.attributes || [];
	        for (var i = 0; i < attrs.length; i++) {
	            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
	        }
	        s += '>';
	        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
	        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
	        return s;
	    }
	    if (isArray(obj)) {
	        if (obj.length === 0) { return '[]'; }
	        var xs = arrObjKeys(obj, inspect);
	        if (indent && !singleLineValues(xs)) {
	            return '[' + indentedJoin(xs, indent) + ']';
	        }
	        return '[ ' + $join.call(xs, ', ') + ' ]';
	    }
	    if (isError(obj)) {
	        var parts = arrObjKeys(obj, inspect);
	        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
	            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
	        }
	        if (parts.length === 0) { return '[' + String(obj) + ']'; }
	        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
	    }
	    if (typeof obj === 'object' && customInspect) {
	        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
	            return utilInspect(obj, { depth: maxDepth - depth });
	        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
	            return obj.inspect();
	        }
	    }
	    if (isMap(obj)) {
	        var mapParts = [];
	        if (mapForEach) {
	            mapForEach.call(obj, function (value, key) {
	                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
	            });
	        }
	        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
	    }
	    if (isSet(obj)) {
	        var setParts = [];
	        if (setForEach) {
	            setForEach.call(obj, function (value) {
	                setParts.push(inspect(value, obj));
	            });
	        }
	        return collectionOf('Set', setSize.call(obj), setParts, indent);
	    }
	    if (isWeakMap(obj)) {
	        return weakCollectionOf('WeakMap');
	    }
	    if (isWeakSet(obj)) {
	        return weakCollectionOf('WeakSet');
	    }
	    if (isWeakRef(obj)) {
	        return weakCollectionOf('WeakRef');
	    }
	    if (isNumber(obj)) {
	        return markBoxed(inspect(Number(obj)));
	    }
	    if (isBigInt(obj)) {
	        return markBoxed(inspect(bigIntValueOf.call(obj)));
	    }
	    if (isBoolean(obj)) {
	        return markBoxed(booleanValueOf.call(obj));
	    }
	    if (isString(obj)) {
	        return markBoxed(inspect(String(obj)));
	    }
	    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
	    /* eslint-env browser */
	    if (typeof window !== 'undefined' && obj === window) {
	        return '{ [object Window] }';
	    }
	    if (
	        (typeof globalThis !== 'undefined' && obj === globalThis)
	        || (typeof global !== 'undefined' && obj === global)
	    ) {
	        return '{ [object globalThis] }';
	    }
	    if (!isDate(obj) && !isRegExp(obj)) {
	        var ys = arrObjKeys(obj, inspect);
	        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
	        var protoTag = obj instanceof Object ? '' : 'null prototype';
	        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
	        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
	        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
	        if (ys.length === 0) { return tag + '{}'; }
	        if (indent) {
	            return tag + '{' + indentedJoin(ys, indent) + '}';
	        }
	        return tag + '{ ' + $join.call(ys, ', ') + ' }';
	    }
	    return String(obj);
	};
	
	function wrapQuotes(s, defaultStyle, opts) {
	    var style = opts.quoteStyle || defaultStyle;
	    var quoteChar = quotes[style];
	    return quoteChar + s + quoteChar;
	}
	
	function quote(s) {
	    return $replace.call(String(s), /"/g, '&quot;');
	}
	
	function canTrustToString(obj) {
	    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
	}
	function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
	function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
	function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
	function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
	function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
	function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
	function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }
	
	// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
	function isSymbol(obj) {
	    if (hasShammedSymbols) {
	        return obj && typeof obj === 'object' && obj instanceof Symbol;
	    }
	    if (typeof obj === 'symbol') {
	        return true;
	    }
	    if (!obj || typeof obj !== 'object' || !symToString) {
	        return false;
	    }
	    try {
	        symToString.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isBigInt(obj) {
	    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
	        return false;
	    }
	    try {
	        bigIntValueOf.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
	function has(obj, key) {
	    return hasOwn.call(obj, key);
	}
	
	function toStr(obj) {
	    return objectToString.call(obj);
	}
	
	function nameOf(f) {
	    if (f.name) { return f.name; }
	    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
	    if (m) { return m[1]; }
	    return null;
	}
	
	function indexOf(xs, x) {
	    if (xs.indexOf) { return xs.indexOf(x); }
	    for (var i = 0, l = xs.length; i < l; i++) {
	        if (xs[i] === x) { return i; }
	    }
	    return -1;
	}
	
	function isMap(x) {
	    if (!mapSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        mapSize.call(x);
	        try {
	            setSize.call(x);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof Map; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakMap(x) {
	    if (!weakMapHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakMapHas.call(x, weakMapHas);
	        try {
	            weakSetHas.call(x, weakSetHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakRef(x) {
	    if (!weakRefDeref || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakRefDeref.call(x);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isSet(x) {
	    if (!setSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        setSize.call(x);
	        try {
	            mapSize.call(x);
	        } catch (m) {
	            return true;
	        }
	        return x instanceof Set; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakSet(x) {
	    if (!weakSetHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakSetHas.call(x, weakSetHas);
	        try {
	            weakMapHas.call(x, weakMapHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isElement(x) {
	    if (!x || typeof x !== 'object') { return false; }
	    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
	        return true;
	    }
	    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
	}
	
	function inspectString(str, opts) {
	    if (str.length > opts.maxStringLength) {
	        var remaining = str.length - opts.maxStringLength;
	        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
	        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
	    }
	    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
	    quoteRE.lastIndex = 0;
	    // eslint-disable-next-line no-control-regex
	    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
	    return wrapQuotes(s, 'single', opts);
	}
	
	function lowbyte(c) {
	    var n = c.charCodeAt(0);
	    var x = {
	        8: 'b',
	        9: 't',
	        10: 'n',
	        12: 'f',
	        13: 'r'
	    }[n];
	    if (x) { return '\\' + x; }
	    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
	}
	
	function markBoxed(str) {
	    return 'Object(' + str + ')';
	}
	
	function weakCollectionOf(type) {
	    return type + ' { ? }';
	}
	
	function collectionOf(type, size, entries, indent) {
	    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
	    return type + ' (' + size + ') {' + joinedEntries + '}';
	}
	
	function singleLineValues(xs) {
	    for (var i = 0; i < xs.length; i++) {
	        if (indexOf(xs[i], '\n') >= 0) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function getIndent(opts, depth) {
	    var baseIndent;
	    if (opts.indent === '\t') {
	        baseIndent = '\t';
	    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
	        baseIndent = $join.call(Array(opts.indent + 1), ' ');
	    } else {
	        return null;
	    }
	    return {
	        base: baseIndent,
	        prev: $join.call(Array(depth + 1), baseIndent)
	    };
	}
	
	function indentedJoin(xs, indent) {
	    if (xs.length === 0) { return ''; }
	    var lineJoiner = '\n' + indent.prev + indent.base;
	    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
	}
	
	function arrObjKeys(obj, inspect) {
	    var isArr = isArray(obj);
	    var xs = [];
	    if (isArr) {
	        xs.length = obj.length;
	        for (var i = 0; i < obj.length; i++) {
	            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
	        }
	    }
	    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
	    var symMap;
	    if (hasShammedSymbols) {
	        symMap = {};
	        for (var k = 0; k < syms.length; k++) {
	            symMap['$' + syms[k]] = syms[k];
	        }
	    }
	
	    for (var key in obj) { // eslint-disable-line no-restricted-syntax
	        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
	            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
	            continue; // eslint-disable-line no-restricted-syntax, no-continue
	        } else if ($test.call(/[^\w$]/, key)) {
	            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
	        } else {
	            xs.push(key + ': ' + inspect(obj[key], obj));
	        }
	    }
	    if (typeof gOPS === 'function') {
	        for (var j = 0; j < syms.length; j++) {
	            if (isEnumerable.call(obj, syms[j])) {
	                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
	            }
	        }
	    }
	    return xs;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Pagination = undefined;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	// FACTORY
	function pagination(el, options) {
	  if (el && el.length) {
	    if (el.data('pagination')) {
	      var paginator = el.data('pagination');
	      paginator.setOptions(options);
	      return paginator;
	    } else {
	      var _paginator = new Pagination(el, options);
	      return _paginator;
	    }
	  }
	}
	
	var elementsMap = {
	  prevBtn: ".pagination-prev-btn",
	  nextBtn: ".pagination-next-btn",
	  pageInfo: ".pagination-page-info",
	  itemsPerPageSelect: ".pagination-select",
	  totalRowsHiddenInput: ".pagination-total-rows"
	};
	
	// DOC:
	// options.tableData =
	// {
	//    // perPageSize()
	//    size: 20,
	//    // currentPageNumber()
	//    number: 1,
	//    // totalResults() - the total results of ALL pages as number
	//    totalElements: 100,
	//    
	// }
	
	function Pagination(el) {
	  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var self = this;
	  $ = opts.$ || $;
	  var data = {};
	  var options = {
	    tableData: {},
	    els: {},
	    lang: {}
	  };
	
	  self.setOptions = setOptions;
	  self.setTableData = setTableData;
	
	  setOptions(opts);
	
	  function init() {
	    unbindElements();
	    setElements();
	    setDataAttrs();
	    render();
	    bindElements();
	  }
	
	  function render() {
	    renderPagination();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(options.els, elementsMap, el);
	    options.els.paginationOuter = el;
	  }
	
	  function setDataAttrs() {
	
	    data.paginationText = options.lang['lookup-filter-pagination-showing'];
	  }
	
	  function setTableData(data) {
	    options.tableData = (0, _general.merge)(options.tableData, data, { clone: true });
	    renderPagination();
	  }
	
	  function setOptions() {
	    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    options = (0, _general.merge)(options, opts, { clone: true });
	    init();
	  }
	
	  function bindElements() {}
	
	  function unbindElements() {
	    if (_underscore2.default.keys(options.els).length) {
	      // unbind specific listeners
	    }
	  }
	
	  function renderPagination() {
	    (0, _selectorHelpers.insertTextAndClean)(options.els.pageInfo, buildPageInfoText());
	    handleDisabledBtns();
	    options.els.totalRowsHiddenInput.val(totalResults());
	    options.els.itemsPerPageSelect.val(perPageSize());
	  };
	
	  function handleDisabledBtns() {
	    handleDisabledNextBtn();
	    handleDisabledPrevBtn();
	  }
	
	  function handleDisabledNextBtn() {
	    if (isBeforeLastPage()) {
	      options.els.nextBtn.removeClass('disabled');
	      // yeah...the other external js file in the hc-portlet filters.js file
	      // decided to put this attribute on the parent of the actual link you
	      // click on...so I have to traverse up to the parent to grab it
	      options.els.nextBtn.parent().data('next-page', nextPageNumber());
	    } else {
	      options.els.nextBtn.addClass('disabled');
	      options.els.nextBtn.parent().data('next-page', null);
	    }
	  }
	
	  function handleDisabledPrevBtn() {
	    if (!isFirstPage()) {
	      options.els.prevBtn.removeClass('disabled');
	      options.els.prevBtn.parent().data('previous-page', prevPageNumber());
	    } else {
	      options.els.prevBtn.addClass('disabled');
	      options.els.prevBtn.parent().data('previous-page', null);
	    }
	  }
	
	  function buildPageInfoText() {
	    if (hasTableData()) {
	      return paginationText + " " + exclusiveResultsShownTotal() + " - " + computedInclusiveResultsShownTotal() + " of " + totalResults() + " results.";
	    } else {
	      return "";
	    }
	  }
	
	  // This is a smart function to return either
	  // the total inclusive results or, if we've exceeded
	  // the computed total then return just the totalResults
	  function computedInclusiveResultsShownTotal() {
	    if (isBeforeLastPage()) {
	      return inclusiveResultsShownTotal();
	    } else {
	      return totalResults();
	    }
	  }
	
	  // the total amount of records up-to-and-including current page
	  function inclusiveResultsShownTotal() {
	    return perPageSize() * nextPageNumber();
	  }
	
	  // the total amount of records up-to-excluding current page (add 1 after for range)
	  function exclusiveResultsShownTotal() {
	    return perPageSize() * currentPageNumber() + 1;
	  }
	
	  function totalResults() {
	    return getTableData().totalElements;
	  }
	
	  function hasTableData() {
	    return totalResults() > 0;
	  }
	
	  function isFirstPage() {
	    return currentPageNumber() <= 0;
	  }
	
	  function isBeforeLastPage() {
	    return totalResults() > inclusiveResultsShownTotal();
	  }
	
	  function perPageSize() {
	    return getTableData().size;
	  }
	
	  function currentPageNumber() {
	    return getTableData().number;
	  }
	
	  function nextPageNumber() {
	    return currentPageNumber() + 1;
	  }
	
	  function prevPageNumber() {
	    return currentPageNumber() - 1;
	  }
	
	  function getTableData() {
	    return options.tableData.page;
	  }
	}
	
	exports.Pagination = Pagination;
	exports.default = pagination;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _timePicker = __webpack_require__(38);
	
	Object.keys(_timePicker).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _timePicker[key];
	    }
	  });
	});
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _timePicker2.default;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = PreparationTab;
	exports.calcShippingMethod = calcShippingMethod;
	exports.resetAccessorialSection = resetAccessorialSection;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _general = __webpack_require__(5);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _util = __webpack_require__(34);
	
	var _timePicker = __webpack_require__(144);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var releaseTypeHtml = __webpack_require__(1381);
	
	function PreparationTab(wizard) {
	
		//Shipping Tab
		var self = this;
		var elsPage = {};
		var wizardElement = wizard.getWizardElement();
		var elementsPageMap = {};
		var orderDetailsForEdit = wizardElement.data("edit-order-details");
		var orderCreatedDate = wizardElement.data("order-create-date");
		var initialOrderGiftMessageInEdit = wizardElement.data("order-gift-message");
		var shippingTabOrdReleaseType = (0, _jquery2.default)("#shipping-tab-order-release-type");
		var gpHours = shippingTabOrdReleaseType.data("gp-hours");
		var gpMinutes = shippingTabOrdReleaseType.data("gp-minutes");
		var gracePeriod = shippingTabOrdReleaseType.data("grace-period");
		var channelGracePeriod = shippingTabOrdReleaseType.data("channel-grace-period");
		var isChannelOrder = wizardElement.data("is-channel-order");
		var orderReleaseType = shippingTabOrdReleaseType.data('options');
		var viewOrderPackagingDetail = (0, _jquery2.default)('#create-order-form').data('view-order-packaging-detail-url');
		var orderPkgDetailLink = (0, _jquery2.default)('.order-pkg-detail-link');
		var serviceCenterHelpURL = (0, _jquery2.default)("#create-order-form").data("service-center-help-url");
		var createOrderHelpCenterURL = (0, _jquery2.default)("#create-order-form").data("create-order-help-center-url");
		var helpCenterButton = (0, _jquery2.default)("#create-order-form").find("#helpCenterUrl");
		var createOrderHelpCenterButton = (0, _jquery2.default)("#create-order-form").find("#createOrderHelpUrl");
		var getShipmentMethodsUrl = (0, _jquery2.default)('#create-order-form').data('get-shipment-methods-url');
		var getServiceLevelsUrl = (0, _jquery2.default)('#create-order-form').data('get-service-levels-url');
		var declaredValueDiv = (0, _jquery2.default)("#declared-value-div");
		var isDVLValueSet = declaredValueDiv.data("is-set-in-order-config");
		var shipmentMethodsToExcludeDVL = declaredValueDiv.data("shipment-methods-to-exclude-for-dvl");
		var declaredValueCheckbox = (0, _jquery2.default)("#declared-value-checkbox");
		var dateFormat = "MM/DD/YYYY";
		var datTimeFormat = "MM/DD/YYYY hh:mm A";
		var shippingTypeHidden = (0, _jquery2.default)("#shipping-type-hidden");
	
		if ((0, _underscore2.default)(orderDetailsForEdit).isEmpty() && isDVLValueSet) {
			declaredValueCheckbox.prop("checked", true);
		} else {
			declaredValueCheckbox.prop("checked", false);
		}
	
		var shipmentAccessorialMap = (0, _jquery2.default)('#create-order-form').data('shipment-method-accessorial');
		var uniqueShipmentArray = _underscore2.default.chain(shipmentAccessorialMap).map(function (accessorial) {
			return accessorial.accessorial_code;
		}).uniq().value();
	
		var serviceLevelsAccessorialMap = (0, _jquery2.default)('#create-order-form').data('service-levels-method-accessorial');
		var uniqueServiceLevelArray = _underscore2.default.chain(serviceLevelsAccessorialMap).map(function (accessorial) {
			return accessorial.accessorial_code;
		}).uniq().value();
	
		var allValidShipServiceLevels = uniqueShipmentArray.concat(uniqueServiceLevelArray);
	
		var fedexShippingMethodBtn = (0, _jquery2.default)(".fedex-shipping-method-btn");
		var serviceLevelsBtn = (0, _jquery2.default)(".service-levels-btn");
	
		var fedexShippingMethodBtnValueCheck = (0, _jquery2.default)("#fedex-shipping-method-btn-value-check");
		var serviceLevelsBtnValueCheck = (0, _jquery2.default)("#service-levels-btn-value-check");
	
		//7775 Changes START
	
	
		var shippingTabAccessorialeNote = (0, _jquery2.default)("#shipping-tab-accessorials-signature");
		var accessorialsSignature = (0, _jquery2.default)("#shipping-tab-accessorials-signature");
		var signatureOptionsSelect = (0, _jquery2.default)("#signature-options-select");
		var saturdayDeliveryCheckbox = (0, _jquery2.default)("#saturday-delivery-checkbox");
		saturdayDeliveryCheckbox.on("change", populateSaturdayDelivery);
	
		var shippingTabOrdReleaseNote = (0, _jquery2.default)("#shipping-tab-order-release-note");
		var shippingTabOrdRelease = (0, _jquery2.default)("#shipping-tab-order-release");
		var shippingTabScheduleRelease = (0, _jquery2.default)("#shipping-tab-schedule-release");
	
		var shippingMethodDropDown = (0, _jquery2.default)("#shipping-tab-shipping-method-with-usa");
		shippingMethodDropDown.on("change", populateShippingAccessorialValues);
	
		var serviceLevelsDropDown = (0, _jquery2.default)("#shipping-tab-shipping-service-level-with-usa");
		serviceLevelsDropDown.on("change", populateServiceAccessorialValues);
	
		var shippingMethodCanadaDropDown = (0, _jquery2.default)("#shipping-tab-shipping-method-with-canada");
		shippingMethodCanadaDropDown.on("change", populateCanadaShippingAccessorialValues);
	
		var shippingMethodOtherDropDown = (0, _jquery2.default)("#shipping-tab-shipping-method-other");
		shippingMethodOtherDropDown.on("change", populateOtherShippingAccessorialValues);
	
		var retainChannelShipmentMethodSwitch = (0, _jquery2.default)("#channelShippingMethodCheck");
		(0, _instantiateSwitchery.instantiateSwitchery)(retainChannelShipmentMethodSwitch, {});
		retainChannelShipmentMethodSwitch.on("change", handleRetainChannelShipmentMethod);
	
		saturdayDeliveryCheckbox.prop("checked", false);
		saturdayDeliveryCheckbox.prop("disabled", true);
		saturdayDeliveryCheckbox.val("");
	
		var closestEl = signatureOptionsSelect.data('target-closest');
		var closestParentEl = signatureOptionsSelect.closest(closestEl);
		function handleSignatureOptionEnable(el) {
			signatureOptionsSelect.attr("disabled", false);
			el.find(".select2-container").css("pointer-events", '');
		}
		function handleSignatureOptionDisable(el) {
			signatureOptionsSelect.attr("disabled", true);
			el.find(".select2-container").css("pointer-events", 'none');
		}
	
		var shippingTypeDropDown = (0, _jquery2.default)("#shipping-tab-shipping-type-select");
		var closestShippingTypeEl = shippingTypeDropDown.data('target-closest');
		var closestShippingTypeParentEl = shippingTypeDropDown.closest(closestShippingTypeEl);
		function handleShippingTypeEnable(el) {
			shippingTypeDropDown.attr("disabled", false);
			el.find(".select2-container").css("pointer-events", '');
		}
		function handleShippingTypeDisable(el) {
			shippingTypeDropDown.attr("disabled", true);
			el.find(".select2-container").css("pointer-events", 'none');
		}
	
		function handleRetainChannelShipmentMethod() {
			var orderDetails = orderDetailsForEdit.orderDetails;
			if (retainChannelShipmentMethodSwitch.is(":checked")) {
				(0, _instantiateSwitchery.setSwitchery)(retainChannelShipmentMethodSwitch, true);
				handleShippingTypeDisable(closestShippingTypeParentEl);
				wizardElement.find(".retainShippingMethod").removeClass("hidden");
				wizardElement.find("#channel-shipping-method").val(orderDetails.ordShippingMethod);
				wizardElement.find(".shipping-method-div").addClass("hidden");
				wizardElement.find("#shipping-tab-parcel-msg").addClass("hidden");
				wizardElement.find("#shipping-tab-shipping-method-with-usa-wrapper-selection").hide();
				wizardElement.find("#shipping-tab-service-level-with-usa-wrapper-selection").hide();
				wizardElement.find("#shipping-tab-service-level-estimated-date").hide();
				wizardElement.find(".estimated-delivery-date-message").hide();
				//Accessorials are read only for Channel the first time
				loadAccessoraialsForChannel(orderDetails);
			} else {
				(0, _instantiateSwitchery.setSwitchery)(retainChannelShipmentMethodSwitch, false);
				handleShippingTypeEnable(closestShippingTypeParentEl);
				wizardElement.find(".retainShippingMethod").addClass("hidden");
				wizardElement.find(".shipping-method-div").removeClass("hidden");
				wizardElement.find("#shipping-tab-parcel-msg").removeClass("hidden");
				fedexShippingMethodBtn.removeClass("active");
				fedexShippingMethodBtnValueCheck.val("false");
				serviceLevelsBtn.removeClass("active");
				serviceLevelsBtnValueCheck.val("false");
				shippingMethodDropDown.val("-1").trigger("change.select2");
				serviceLevelsDropDown.val("-1").trigger("change.select2");
			}
		}
	
		var date = new Date();
		var enddate = new Date();
		enddate.setDate(enddate.getDate() + 30);
		(0, _jquery2.default)('#scheduleReleaseDate').datepicker({
			todayBtn: "linked",
			startDate: date,
			endDate: enddate,
			keyboardNavigation: false,
			forceParse: false,
			calendarWeeks: false,
			autoclose: true
		}).on("changeDate", function (e) {
			(0, _jquery2.default)('#scheduleReleaseDate').trigger('blur');
		});
	
		var scheduleReleaseDateVal = void 0;
	
		var scheduledReleaseTimePickerEl = (0, _jquery2.default)('.scheduled-release-time-picker');
		var scheduledReleaseTimePicker = (0, _timePicker2.default)(scheduledReleaseTimePickerEl);
	
		var estimatedDeliveryDatePicker = (0, _jquery2.default)('.estimated-delivery-date-picker');
		estimatedDeliveryDatePicker.datepicker({
			startDate: '+1d',
			keyboardNavigation: true,
			autoclose: true
		});
	
		function populateOtherShippingAccessorialValues() {
			loadAccessorialSectionValues(shippingMethodOtherDropDown.val(), shipmentAccessorialMap);
			(0, _jquery2.default)('#signature-options-select').trigger('change');
		}
	
		function populateCanadaShippingAccessorialValues() {
			loadAccessorialSectionValues(shippingMethodCanadaDropDown.val(), shipmentAccessorialMap);
			(0, _jquery2.default)('#signature-options-select').trigger('change');
		}
	
		function populateShippingAccessorialValues() {
			loadAccessorialSectionValues(shippingMethodDropDown.val(), shipmentAccessorialMap);
			(0, _jquery2.default)('#signature-options-select').trigger('change');
		}
	
		function populateServiceAccessorialValues() {
			loadAccessorialSectionValues(serviceLevelsDropDown.val(), serviceLevelsAccessorialMap);
			(0, _jquery2.default)('#signature-options-select').trigger('change');
		}
		function populateSaturdayDelivery() {
			if ((0, _jquery2.default)(this).prop("checked") == true) {
				saturdayDeliveryCheckbox.val("SAT");
			} else if ((0, _jquery2.default)(this).prop("checked") == false) {
				saturdayDeliveryCheckbox.val("");
			}
		}
	
		function loadAccessorialSectionValues(shipmentServiceValue, accessorialMap) {
			signatureOptionsSelect.empty();
			handleSignatureOptionDisable(closestParentEl);
	
			saturdayDeliveryCheckbox.prop("checked", false);
			saturdayDeliveryCheckbox.val("");
	
			var value = shipmentServiceValue;
	
			if ((0, _underscore2.default)(shipmentMethodsToExcludeDVL).contains(value)) {
				declaredValueCheckbox.prop("checked", false);
				declaredValueCheckbox.prop("disabled", true);
			} else {
				declaredValueCheckbox.prop("disabled", false);
			}
	
			var selectedValues = [];
			_jquery2.default.each(accessorialMap, function (index) {
				if (accessorialMap[index].accessorial_code == value) {
					selectedValues.push(accessorialMap[index]);
				}
			});
	
			var checkboxDisabled = false;
			var defaultOption = (0, _jquery2.default)('<option /\>');
			defaultOption.attr('value', "-1").text("Select signature option");
			signatureOptionsSelect.append(defaultOption);
	
			_jquery2.default.each(selectedValues, function (index, selectedValue) {
				//Signature validation
				if (selectedValues[index].accessorial_code == value && selectedValues[index].accessorial_object.cdmMeaning == 'Y' && selectedValues[index].accessorial_object.cdmDescription != "Saturday Delivery") {
					handleSignatureOptionEnable(closestParentEl);
					var option = (0, _jquery2.default)('<option /\>');
					option.attr('value', selectedValue.accessorial_object.cdmValue).text(selectedValue.accessorial_object.cdmDescription);
					signatureOptionsSelect.append(option);
				}
				//check box validation
				if (selectedValues[index].accessorial_code == value && selectedValues[index].accessorial_object.cdmMeaning == 'N') {
					saturdayDeliveryCheckbox.attr("disabled", true);
					saturdayDeliveryCheckbox.hide();
				} else {
					saturdayDeliveryCheckbox.show();
					saturdayDeliveryCheckbox.attr("disabled", false);
				}
			});
			// For Fedex Smart post there is going to be no value in the signature drop down
			if (signatureOptionsSelect.find('option').length == 1) {
				handleSignatureOptionDisable(closestParentEl);
			}
		}
	
		(0, _jquery2.default)("#signature-options-select").change(function (e) {
			var accessorialValue = (0, _jquery2.default)("#signature-options-select option:selected").text();;
			if (accessorialValue == "Direct Signature Required") {
				accessorialsSignature.show();
				shippingTabAccessorialeNote.html("Signature from someone at delivery address.");
			} else if (accessorialValue == "Adult Signature Required") {
				accessorialsSignature.show();
				shippingTabAccessorialeNote.html("Signature from someone at least 21 years old at the delivery address. Government issued photo ID required.");
			} else {
				shippingTabAccessorialeNote.html("");
			}
		});
	
		shippingTabOrdReleaseType.on("change", handleOrdReleaseChange);
	
		//7775 Changes END
	
		function loadAccessorialSectionValuesForEdit(shipmentServiceValue, accessorialMap, orderDetails) {
			signatureOptionsSelect.empty();
			handleSignatureOptionDisable(closestParentEl);
			saturdayDeliveryCheckbox.prop("checked", false);
			saturdayDeliveryCheckbox.val("");
	
			var shipmentServiceAccessorialValues = [];
			//Set the Declared Value if available in the Order
			if (!(0, _underscore2.default)(shipmentMethodsToExcludeDVL).contains(shipmentServiceValue) && (0, _general.isTruthy)(orderDetails.ordDvl)) {
				declaredValueCheckbox.prop("checked", true);
				declaredValueCheckbox.prop("disabled", false);
			} else {
				declaredValueCheckbox.prop("checked", false);
			}
	
			_jquery2.default.each(accessorialMap, function (index) {
				if (accessorialMap[index].accessorial_code == shipmentServiceValue) {
					shipmentServiceAccessorialValues.push(accessorialMap[index]);
				}
			});
			var defaultOption = (0, _jquery2.default)('<option /\>');
			defaultOption.attr('value', "-1").text("Select signature option");
			signatureOptionsSelect.append(defaultOption);
	
			_jquery2.default.each(shipmentServiceAccessorialValues, function (index, selectedValue) {
				//Signature validation
				if (shipmentServiceAccessorialValues[index].accessorial_code == shipmentServiceValue && shipmentServiceAccessorialValues[index].accessorial_object.cdmMeaning == 'Y' && shipmentServiceAccessorialValues[index].accessorial_object.cdmDescription != "Saturday Delivery") {
					handleSignatureOptionEnable(closestParentEl);
					var option = (0, _jquery2.default)('<option /\>');
					option.attr('value', selectedValue.accessorial_object.cdmValue).text(selectedValue.accessorial_object.cdmDescription);
					signatureOptionsSelect.append(option);
				}
				//check box validation
				if (shipmentServiceAccessorialValues[index].accessorial_code == shipmentServiceValue && shipmentServiceAccessorialValues[index].accessorial_object.cdmMeaning == 'N') {
					saturdayDeliveryCheckbox.attr("disabled", true);
					saturdayDeliveryCheckbox.hide();
				} else {
					saturdayDeliveryCheckbox.show();
					saturdayDeliveryCheckbox.attr("disabled", false);
				}
			});
	
			//Set the signature option to the one recieved from the Order
			if ((0, _general.isPresent)(orderDetails.ordSignatureOption)) {
				var selectedSignatureValue = void 0;
				var currentShipmentMethod = orderDetails.ordShippingMethod;
				if (orderDetails.ordSignatureOption === "COS") {
					//Direct Signature
					selectedSignatureValue = currentShipmentMethod + "_DIRECT";
				} else if (orderDetails.ordSignatureOption === "COA") {
					//Adult Signature
					selectedSignatureValue = currentShipmentMethod + "_ADULT";
				}
	
				signatureOptionsSelect.val(selectedSignatureValue).trigger("change.select2");
				signatureOptionsSelect.trigger("change");
			}
	
			//Set the saturday delivery check box if present
			if (orderDetails.ordSaturdayDelivery == "SAT") {
				saturdayDeliveryCheckbox.prop("checked", true);
				saturdayDeliveryCheckbox.trigger("change");
			}
		}
	
		self.init = function () {
			setElements();
			if (!(0, _underscore2.default)(orderDetailsForEdit).isEmpty()) {
				fillShippingTabForEdit(orderDetailsForEdit);
			}
		};
	
		self.getScheduleReleaseTimeAndDate = function () {
			var scheduleDateAndTime = void 0,
			    scheduleReleaseTimeVal = void 0;
			scheduleReleaseDateVal = (0, _jquery2.default)('#scheduleReleaseDate').val();
			scheduleReleaseTimeVal = scheduledReleaseTimePicker.getMilitaryTime();
			if (scheduleReleaseTimeVal == "Invalid date") {
				var isBefore = (0, _moment2.default)(scheduleReleaseDateVal, dateFormat).isBefore(new Date());
				//If current date 11:59 PM
				if (isBefore) {
					scheduleReleaseTimeVal = "23:59";
				} else {
					scheduleReleaseTimeVal = "00:00";
				} //Else, when its future date 00:00 AM
			}
			scheduleDateAndTime = (0, _general.fuseDateTimeValueToStandard)(scheduleReleaseDateVal, scheduleReleaseTimeVal);
			(0, _jquery2.default)("#standardDateAndTime").val((0, _moment2.default)(scheduleDateAndTime).format(datTimeFormat));
		};
	
		self.checkIfDateTimeInPast = function () {
			var orderTypeValue = shippingTabOrdReleaseType.find(':selected').val();
			if (orderTypeValue == "Scheduled Release") {
				scheduleReleaseDateVal = (0, _jquery2.default)('#scheduleReleaseDate').val();
				var scheduleDateAndTime = (0, _general.fuseDateTimeValueToStandard)(scheduleReleaseDateVal, scheduledReleaseTimePicker.getMilitaryTime());
				var isBefore = (0, _moment2.default)(scheduleDateAndTime).isBefore(new Date());
				return isBefore;
			} else {
				return false;
			}
		};
	
		function loadOrderReleaseType(wizardElement, orderDetails) {
			var orderActualGracePeriod = void 0,
			    scheduledDate = void 0,
			    currentDate = void 0;
			var isScheduleDateExpired = void 0;
			if ((0, _general.isPresent)(orderDetails.ordCreatedDate) && (0, _general.isPresent)(orderDetails.ordGracePeriod) && orderDetails.ordGracePeriod != 0) {
				orderActualGracePeriod = (0, _moment2.default)(orderCreatedDate, datTimeFormat).add(orderDetails.ordGracePeriod, 'm');
				scheduledDate = (0, _moment2.default)(orderActualGracePeriod).format(dateFormat);
				var timePickerValue = (0, _moment2.default)(orderActualGracePeriod);
				var hoursMinutesValue = (0, _general.getMilitaryTimeFromDate)(timePickerValue._d);
				scheduledReleaseTimePicker.setTimeFromMilitary(hoursMinutesValue);
				var dateTimeSchDate = (0, _moment2.default)(orderActualGracePeriod).format(datTimeFormat);
				currentDate = (0, _moment2.default)(new Date()).format(datTimeFormat);
				currentDate > dateTimeSchDate ? isScheduleDateExpired = true : isScheduleDateExpired = false;
			}
	
			//If Release type present it is manual order, retain the Release type if Hold Indefinitely/ Release Immediately
			// If Grace period expired then set to Release Immeditely else Sched
			// Else for Channel orders, check the grace period if expired
	
			if ((0, _general.isPresent)(orderDetails.ordReleaseType)) {
				if (orderDetails.ordReleaseType == 'Release Immediately' || orderDetails.ordReleaseType == 'Hold Indefinitely') {
					wizardElement.find("#shipping-tab-order-release-type").val(orderDetails.ordReleaseType).trigger("change.select2");
				} else {
					if ((0, _general.isTruthy)(isScheduleDateExpired)) {
						wizardElement.find("#shipping-tab-order-release-type").val("Release Immediately").trigger("change.select2");
					} else {
						wizardElement.find("#shipping-tab-order-release-type").val("Scheduled Release").trigger("change.select2");
						(0, _jquery2.default)('#scheduleReleaseDate').val(scheduledDate).trigger("change");
					}
				}
			} else {
				if ((0, _general.isTruthy)(isScheduleDateExpired)) {
					wizardElement.find("#shipping-tab-order-release-type").val("Release Immediately").trigger("change.select2");
				} else {
					wizardElement.find("#shipping-tab-order-release-type").val("Scheduled Release").trigger("change.select2");
					(0, _jquery2.default)('#scheduleReleaseDate').val(scheduledDate).trigger("change");;
				}
			}
	
			wizardElement.find("#shipping-tab-order-release-type").trigger("change");
		}
	
		function loadAccessoraialsForChannel(orderDetails) {
			if ((0, _general.isTruthy)(orderDetails.ordDvl)) {
				declaredValueCheckbox.prop("checked", true);
				declaredValueCheckbox.prop("disabled", true);
			}
	
			if ((0, _general.isPresent)(orderDetails.ordSignatureOption)) {
				handleSignatureOptionDisable(closestParentEl);
				var defaultOption = (0, _jquery2.default)('<option value ="-1">Select signature option</option>');
				signatureOptionsSelect.append(defaultOption);
				var directOption = (0, _jquery2.default)('<option value ="DEFAULT_DIRECT">Direct Signature Required</option>');
				signatureOptionsSelect.append(directOption);
				var adultOption = (0, _jquery2.default)('<option value ="DEFAULT_ADULT">Adult Signature Required</option>');
				signatureOptionsSelect.append(adultOption);
	
				var selectedSignatureValue = void 0;
				var currentShipmentMethod = orderDetails.ordShippingMethod;
				if (orderDetails.ordSignatureOption === "COS") {
					//Direct Signature
					selectedSignatureValue = "DEFAULT_DIRECT";
				} else if (orderDetails.ordSignatureOption === "COA") {
					//Adult Signature
					selectedSignatureValue = "DEFAULT_ADULT";
				}
				signatureOptionsSelect.val(selectedSignatureValue).trigger("change.select2");
				signatureOptionsSelect.trigger("change");
			} else {
				handleSignatureOptionDisable(closestParentEl);
				var _defaultOption = (0, _jquery2.default)('<option value ="-1">Select signature option</option>');
				signatureOptionsSelect.append(_defaultOption);
				signatureOptionsSelect.val("-1").trigger("change.select2");
				signatureOptionsSelect.trigger("change");
			}
			if (orderDetails.ordSaturdayDelivery == "SAT") {
				saturdayDeliveryCheckbox.prop("checked", true);
				saturdayDeliveryCheckbox.prop("disabled", true);
				saturdayDeliveryCheckbox.trigger("change");
			} else {
				saturdayDeliveryCheckbox.prop("checked", false);
				saturdayDeliveryCheckbox.prop("disabled", true);
				saturdayDeliveryCheckbox.trigger("change");
			}
		}
	
		function fillShippingTabForEdit(orderDetailsForEdit) {
			var orderDetails = orderDetailsForEdit.orderDetails;
			var shipmentMethod = orderDetails.ordShippingMethod;
			if (!(0, _underscore2.default)(shipmentMethod).isEmpty()) {
				if ((0, _underscore2.default)(allValidShipServiceLevels).contains(shipmentMethod)) {
					if (retainChannelShipmentMethodSwitch.length > 0) {
						(0, _instantiateSwitchery.setSwitchery)(retainChannelShipmentMethodSwitch, false);
						(0, _instantiateSwitchery.disableSwitchery)(retainChannelShipmentMethodSwitch);
					}
					//hide the shipping method text box
					wizardElement.find(".retainShippingMethod").hide();
					wizardElement.find(".shipping-method-div").show();
					if ((0, _underscore2.default)(uniqueShipmentArray).contains(shipmentMethod)) {
						//active shipping method toggle
						fedexShippingMethodBtn.addClass("active");
						fedexShippingMethodBtn.trigger("click");
						fedexShippingMethodBtnValueCheck.val("true");
						serviceLevelsBtn.removeClass("active");
						serviceLevelsBtnValueCheck.val("false");
						loadAccessorialSectionValuesForEdit(shipmentMethod, shipmentAccessorialMap, orderDetails);
					} else if ((0, _underscore2.default)(uniqueServiceLevelArray).contains(shipmentMethod)) {
						//active service level toggle
						serviceLevelsBtn.addClass("active");
						serviceLevelsBtn.trigger("click");
						serviceLevelsBtnValueCheck.val("true");
						fedexShippingMethodBtn.removeClass("active");
						fedexShippingMethodBtnValueCheck.val("false");
						loadAccessorialSectionValuesForEdit(shipmentMethod, serviceLevelsAccessorialMap, orderDetails);
					}
				} else {
					wizardElement.find("#channel-shipping-method").val(orderDetails.ordShippingMethod);
					if (retainChannelShipmentMethodSwitch.length > 0) {
						retainChannelShipmentMethodSwitch.removeAttr("disabled");
						(0, _instantiateSwitchery.setSwitchery)(retainChannelShipmentMethodSwitch, true);
						retainChannelShipmentMethodSwitch.trigger("change");
					}
					wizardElement.find(".shipping-method-div").addClass("hidden");
					wizardElement.find("#shipping-tab-parcel-msg").addClass("hidden");
					//Accessorials are read only for Channel the first time
					loadAccessoraialsForChannel(orderDetails);
				}
			}
			if ((0, _general.isPresent)(orderDetails.ordFreightCost)) {
				wizardElement.find("#freight-costs").val(orderDetails.ordFreightCost);
			}
			if ((0, _general.isPresent)(orderDetails.ordInsuranceCost)) {
				wizardElement.find("#insurance-costs").val(orderDetails.ordInsuranceCost);
			}
			if ((0, _general.isPresent)(orderDetails.ordDutiesTaxes)) {
				wizardElement.find("#duties-taxes").val(orderDetails.ordDutiesTaxes);
			}
	
			//If Order Has Estimated Delivery Date Populate the value
			if ((0, _general.isPresent)(orderDetails.ordEstDlvyDate)) {
				(0, _jquery2.default)('.estimated-delivery-date-picker').val((0, _moment2.default)(orderDetails.ordEstDlvyDate).format(dateFormat));
			}
	
			//Set the Order Release Type
			loadOrderReleaseType(wizardElement, orderDetails);
	
			//Set the Shipping Type
			wizardElement.find("#shipping-tab-shipping-type-select").val(orderDetails.ordShippingType);
			shippingTypeHidden.val(orderDetails.ordShippingType);
			wizardElement.find("#shipping-tab-shipping-type-select").trigger("change");
	
			//Set the Alternate Packing Value if available in the Order
			if (orderDetails.ordAlternatePackagingReq) {
				wizardElement.find("#bulk-packaging").prop("checked", true);
			} else {
				wizardElement.find("#bulk-packaging").prop("checked", false);
			}
	
			//Set the Collateral Value if available in the Order
			if (orderDetails.ordExcludeCollateral) {
				wizardElement.find("#exclude-collateral").prop("checked", true);
			} else {
				wizardElement.find("#exclude-collateral").prop("checked", false);
			}
	
			//Set the Gift message turned on if available in the Order
			wizardElement.find("#gift-textarea").val(initialOrderGiftMessageInEdit);
		}
	
		function setElements() {
			(0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, wizardElement);
			handleShippingTypeEnable(closestShippingTypeParentEl);
		}
	
		(0, _jquery2.default)(helpCenterButton).on('click', function () {
			window.open(serviceCenterHelpURL);
		});
	
		(0, _jquery2.default)(createOrderHelpCenterButton).on('click', function () {
			window.open(createOrderHelpCenterURL);
		});
	
		(0, _jquery2.default)(orderPkgDetailLink).on("click", function (e) {
			_jquery2.default.ajax({
				url: viewOrderPackagingDetail,
				type: 'POST',
				success: function success(data) {
					{
						window.open(data, 'OrderPackaging');
					}
				}
			});
		});
	
		shippingTabOrdReleaseType.append(generateOrderReleaseTypeOptions(orderReleaseType));
	
		function generateOrderReleaseTypeOptions(ordRelType) {
			var orderReleaseTypeOptionsHtml = ordRelType.map(function (relType) {
				var scheduleReleaseTogglerTarget = relType == 'Scheduled Release' ? '#shipping-tab-schedule-release' : '#shipping-tab-order-release';
				var ifInternalOrd = relType == 'Internal Order Grace Period' && gpHours == 0 && gpMinutes == 0 ? 'disabled' : '';
				return (0, _render2.default)('<option value=\'{%- value %}\' data-quick-toggler-target=\'{%- target %}\' {%- isDisabled %}>{%- value %}</option>', {
					value: relType,
					target: scheduleReleaseTogglerTarget,
					isDisabled: ifInternalOrd
				});
			});
			return orderReleaseTypeOptionsHtml.join('');
		}
	
		var shippingTypeSelect = (0, _jquery2.default)("#shipping-tab-shipping-type-select");
		var shippingTypeList = shippingTypeSelect.data('options');
	
		(0, _jquery2.default)(shippingTypeList).each(function () {
			var option = (0, _jquery2.default)('<option />');
			option.attr('value', this.cdmValue).text(this.cdmMeaning);
			shippingTypeSelect.append(option);
		});
	
		var destTabOrderType = (0, _jquery2.default)("#destination-tab-order-type-select");
		var destTabDropShipFlag = (0, _jquery2.default)("#dropShipFlag");
		var giftNoteSection = (0, _jquery2.default)(".gift-note-section");
		var giftCheckboxTogglable = (0, _jquery2.default)(".gift-checkbox-togglable");
		var shippingTabIsAGiftCheckbox = (0, _jquery2.default)("#gift-checkbox");
		var shippingTabGiftTextArea = (0, _jquery2.default)("#gift-textarea");
	
		destTabOrderType.on("change", handleDestTabOrderTypeChange);
		destTabDropShipFlag.on("change", handleDestTabOrderTypeChange);
		shippingTypeSelect.on("change", handleShippingTypeChange);
		handleGiftNoteSectionDisplay();
		calcShippingMethod();
	
		self.handleDestTabOrderTypeLoad = function () {
			var serviceLevelsUsaId = (0, _jquery2.default)("#shipping-tab-shipping-service-level-with-usa");
			var shippingMethodUsaId = (0, _jquery2.default)("#shipping-tab-shipping-method-with-usa");
			var shippingCanadaId = (0, _jquery2.default)("#shipping-tab-shipping-method-with-canada");
			var shippingOtherId = (0, _jquery2.default)("#shipping-tab-shipping-method-other");
			var currentCountryValOnDestinationTab = (0, _jquery2.default)('#destination-tab-country  :selected').val();
			var orderDetails = (0, _general.isPresent)(orderDetailsForEdit.orderDetails) ? orderDetailsForEdit.orderDetails : null;
			var shippingMethod = null;
			if ((0, _general.isPresent)(orderDetails)) {
				shippingMethod = orderDetails.ordShippingMethod;
			}
	
			//If Selected Country Code is US
			if (currentCountryValOnDestinationTab == "-1" || currentCountryValOnDestinationTab == "1") {
				if (!(0, _underscore2.default)(shippingMethod).isEmpty()) {
					if ((0, _underscore2.default)(uniqueShipmentArray).contains(shippingMethod)) {
						var shippingOptionsSelected = shippingMethodUsaId.find("option");
						var shippingValArr = (0, _underscore2.default)(shippingOptionsSelected).pluck('value');
						if ((0, _underscore2.default)(shippingValArr).contains(shippingMethod)) {
							shippingMethodUsaId.val(shippingMethod).trigger("change.select2");
							shippingMethodUsaId.trigger("change");
							loadAccessorialSectionValuesForEdit(shippingMethod, shipmentAccessorialMap, orderDetails);
						} else {
							resetAccessorialSection();
						}
					} else if ((0, _underscore2.default)(uniqueServiceLevelArray).contains(shippingMethod)) {
						var serviceOptionsSelected = serviceLevelsUsaId.find("option");
						var serviceValArr = (0, _underscore2.default)(serviceOptionsSelected).pluck('value');
						if ((0, _underscore2.default)(serviceValArr).contains(shippingMethod)) {
							serviceLevelsUsaId.val(shippingMethod).trigger("change.select2");
							serviceLevelsUsaId.trigger("change");
							loadAccessorialSectionValuesForEdit(shippingMethod, serviceLevelsAccessorialMap, orderDetails);
						} else {
							resetAccessorialSection();
						}
					}
				} else {
					var shippingMethodValue = (0, _jquery2.default)('#shipping-tab-shipping-method-with-usa  :selected').val();
					var shippingServiceValue = (0, _jquery2.default)('#shipping-tab-shipping-service-level-with-usa  :selected').val();
					if (shippingMethodValue === "-1" && shippingServiceValue === '-1') {
						handleDestTabOrderTypeChange();
					}
				}
			} else if (currentCountryValOnDestinationTab == "2") {
				//If Selected Country Code is Canada 
				var _shippingOptionsSelected = shippingCanadaId.find("option");
				var _shippingValArr = (0, _underscore2.default)(_shippingOptionsSelected).pluck('value');
				if ((0, _underscore2.default)(_shippingValArr).contains(shippingMethod)) {
					shippingCanadaId.val(shippingMethod).trigger("change.select2");
					shippingCanadaId.trigger("change");
					loadAccessorialSectionValuesForEdit(shippingMethod, shipmentAccessorialMap, orderDetails);
				} else {
					resetAccessorialSection();
				}
			} else {
				//If Selected Country Code is Other than US/Canada
				var _shippingOptionsSelected2 = shippingOtherId.find("option");
				var _shippingValArr2 = (0, _underscore2.default)(_shippingOptionsSelected2).pluck('value');
				if ((0, _underscore2.default)(_shippingValArr2).contains(shippingMethod)) {
					shippingOtherId.val(shippingMethod).trigger("change.select2");
					shippingOtherId.trigger("change");
					loadAccessorialSectionValuesForEdit(shippingMethod, shipmentAccessorialMap, orderDetails);
				} else {
					resetAccessorialSection();
				}
			}
		};
	
		function handleDestTabOrderTypeChange() {
			handleGiftNoteSectionDisplay();
			loadShipmentMethods(destTabOrderType.val(), destTabDropShipFlag.prop("checked"));
			loadServiceLevels(destTabOrderType.val(), destTabDropShipFlag.prop("checked"));
		}
	
		function handleGiftNoteSectionDisplay() {
			var isB2C = isOrderTypeB2C(destTabOrderType.val(), destTabDropShipFlag.prop("checked"));
			(0, _selectorHelpers.handleDisplayForV2)(giftNoteSection, isB2C);
			(0, _selectorHelpers.handleDisplayForV2)(giftCheckboxTogglable, isB2C);
			//reset checkbox and message
			if (!isB2C) {
				shippingTabIsAGiftCheckbox.prop("checked", false);
				shippingTabGiftTextArea.val("");
			}
		}
	
		function isOrderTypeB2C(orderType, dropShipFlag) {
			if (orderType === 'B2C' || orderType !== 'B2B' && dropShipFlag) {
				return true;
			}
			return false;
		}
	
		function handleShippingTypeChange() {
			calcShippingMethod();
		}
	
		function loadShipmentMethods(orderType, dropShipFlag) {
			_jquery2.default.ajax({
				url: getShipmentMethodsUrl,
				type: 'POST',
				dataType: 'JSON',
				data: { orderType: orderType, dropShipFlag: dropShipFlag },
				success: function success(data) {
					var shippingMethodUsaId = (0, _jquery2.default)("#shipping-tab-shipping-method-with-usa");
					shippingMethodUsaId.empty();
					var option = (0, _jquery2.default)('<option /\>');
					option.attr('value', "-1").text("Please select shipping method");
					option.attr('disabled', 'disabled');
					option.attr('selected', 'selected');
					shippingMethodUsaId.append(option);
					_jquery2.default.each(data, function (index, value) {
						var option = (0, _jquery2.default)('<option /\>');
						option.attr('value', value.cdmValue).text(value.cdmMeaning);
						shippingMethodUsaId.append(option);
					});
				}
			});
		}
	
		function loadServiceLevels(orderType, dropShipFlag) {
			_jquery2.default.ajax({
				url: getServiceLevelsUrl,
				type: 'POST',
				dataType: 'JSON',
				data: { orderType: orderType, dropShipFlag: dropShipFlag },
				success: function success(data) {
					if (data.length > 0) {
						var serviceLevelsUsaId = (0, _jquery2.default)("#shipping-tab-shipping-service-level-with-usa");
						serviceLevelsUsaId.empty();
						var option = (0, _jquery2.default)('<option /\>');
						option.attr('value', "-1").text("Select from Service Levels");
						option.attr('disabled', 'disabled');
						option.attr('selected', 'selected');
						serviceLevelsUsaId.append(option);
						_jquery2.default.each(data, function (index, value) {
							var option = (0, _jquery2.default)('<option /\>');
							option.attr('value', value.cdmValue).text(value.cdmMeaning);
							serviceLevelsUsaId.append(option);
						});
					} else {
						var _serviceLevelsUsaId = (0, _jquery2.default)("#shipping-tab-shipping-service-level-with-usa");
						_serviceLevelsUsaId.empty();
					}
				}
			});
		}
	
		function handleOrdReleaseChange() {
			var orderTypeValue = shippingTabOrdReleaseType.find(':selected').val();
			if (orderTypeValue == "Internal Order Grace Period") {
				if ((0, _underscore2.default)(orderDetailsForEdit).isEmpty()) {
					shippingTabOrdReleaseNote.html('Order will be released in <b>' + gpHours + ' hrs ' + gpMinutes + ' mins</b>.');
				} else {
					var _datTimeFormat = "MM/DD/YYYY hh:mm A";
					var orderDetails = orderDetailsForEdit.orderDetails;
					var oriGracePeriod = void 0;
					if (!(0, _underscore2.default)(orderDetails.ordGracePeriod).isEmpty()) {
						oriGracePeriod = orderDetails.ordGracePeriod;
					} else {
						if ((0, _general.isTruthy)(isChannelOrder)) {
							oriGracePeriod = channelGracePeriod;
						} else {
							oriGracePeriod = gracePeriod;
						}
					}
	
					var scheduledReleaseDate = (0, _moment2.default)(orderDetailsForEdit.orderDetails.orderCreatedDate).add(oriGracePeriod, 'm');
					var scheduledRelease = (0, _moment2.default)(scheduledReleaseDate).format(_datTimeFormat) + " ET";
					shippingTabOrdReleaseNote.html((0, _render2.default)(releaseTypeHtml, {
						orderScheduledReleaseTimePeriod: scheduledRelease
					}));
				}
			} else if (orderTypeValue == "Release Immediately") {
				shippingTabOrdReleaseNote.html("Order will be released when submitted.");
			} else if (orderTypeValue == "Hold Indefinitely") {
				shippingTabOrdReleaseNote.html("Order must be manually released.");
			}
		}
	
		var shippingMethodCanadaId = (0, _jquery2.default)("#shipping-tab-shipping-method-with-canada");
		var shippingMethodCanadaList = shippingMethodCanadaId.data('options');
		_jquery2.default.each(shippingMethodCanadaList, function (index, value) {
			var option = (0, _jquery2.default)('<option /\>');
			option.attr('value', value.cdmValue).text(value.cdmMeaning);
			shippingMethodCanadaId.append(option);
		});
	
		var shippingMethodOtherId = (0, _jquery2.default)("#shipping-tab-shipping-method-other");
		var shippingMethodOtherList = shippingMethodOtherId.data('options');
		_jquery2.default.each(shippingMethodOtherList, function (index, value) {
			var option = (0, _jquery2.default)('<option /\>');
			option.attr('value', value.cdmValue).text(value.cdmMeaning);
			shippingMethodOtherId.append(option);
		});
	};
	
	function calcShippingMethod() {
		var self = this;
		var fedexShippingMethodBtn = (0, _jquery2.default)(".fedex-shipping-method-btn");
		var serviceLevelsBtn = (0, _jquery2.default)(".service-levels-btn");
		var fedexShippingMethodBtnValueCheck = (0, _jquery2.default)("#fedex-shipping-method-btn-value-check");
		var serviceLevelsBtnValueCheck = (0, _jquery2.default)("#service-levels-btn-value-check");
		var state = (0, _jquery2.default)('#destination-tab-state  :selected').val();
		var countryVal = (0, _jquery2.default)('#destination-tab-country  :selected').val();
		var shippingType = (0, _jquery2.default)('#shipping-tab-shipping-type-select :selected').val();
		var selectMethod = (0, _jquery2.default)(".select-method");
		var shippingMethodUsa = (0, _jquery2.default)("#shipping-tab-shipping-method-with-usa-wrapper");
		var shippingMethodCanada = (0, _jquery2.default)("#shipping-tab-shipping-method-with-canada-wrapper");
		var shippingMethodOther = (0, _jquery2.default)("#shipping-tab-shipping-method-other-wrapper");
		var internationalProductShippingCost = (0, _jquery2.default)("#international-product-shipping-cost");
		var shippingMethodLtlMsg = (0, _jquery2.default)("#shipping-tab-ltl-msg");
		var shippingMethodUsaSelect = (0, _jquery2.default)("#shipping-tab-shipping-method-with-usa-wrapper-selection");
		var shippingMethodParcelMsg = (0, _jquery2.default)("#shipping-tab-parcel-msg");
		var serviceLevelUsaSelect = (0, _jquery2.default)("#shipping-tab-service-level-with-usa-wrapper-selection");
		var estimatedDeliveryDate = (0, _jquery2.default)("#shipping-tab-service-level-estimated-date");
		var serviceLevelsMessage = (0, _jquery2.default)(".estimated-delivery-date-message");
		var dontShowSectionForParcelSelection = (0, _jquery2.default)(".dont-show-for-parcel-selection");
		var dontShowSectionForLtlSelection = (0, _jquery2.default)(".hide-for-ltl-selection");
		var serviceLevelsUsaId = (0, _jquery2.default)("#shipping-tab-shipping-service-level-with-usa");
		var shippingMethodUsaId = (0, _jquery2.default)("#shipping-tab-shipping-method-with-usa");
		var btnClickVar = false;
		var signatureOptionsSelect = (0, _jquery2.default)("#signature-options-select");
		var saturdayDeliveryCheckbox = (0, _jquery2.default)("#saturday-delivery-checkbox");
		var shippingTypeHidden = (0, _jquery2.default)("#shipping-type-hidden");
	
		deactivateBtns();
	
		shippingTypeHidden.val(shippingType);
		var closestEl = signatureOptionsSelect.data('target-closest');
		var closestParentEl = signatureOptionsSelect.closest(closestEl);
		function handleSignatureOptionEnable(el) {
			signatureOptionsSelect.attr("disabled", false);
			el.find(".select2-container").css("pointer-events", '');
		}
		function handleSignatureOptionDisable(el) {
			signatureOptionsSelect.attr("disabled", true);
			el.find(".select2-container").css("pointer-events", 'none');
		}
	
		function fedexShippingSelected() {
			shippingMethodUsaSelect.show();
			fedexShippingMethodBtn.addClass("active");
			serviceLevelsBtn.removeClass("active");
			serviceLevelUsaSelect.hide();
			btnClickVar = true;
			estimatedDeliveryDate.hide();
			serviceLevelsBtnValueCheck.val(false);
			serviceLevelsMessage.hide();
			(0, _jquery2.default)("#saturday-delivery-checkbox1").show();
		}
	
		function serviceLevelsSelected() {
			shippingMethodUsaSelect.hide();
			fedexShippingMethodBtn.removeClass("active");
			serviceLevelsBtn.addClass("active");
			serviceLevelUsaSelect.show();
			btnClickVar = true;
			estimatedDeliveryDate.show();
			fedexShippingMethodBtnValueCheck.val(false);
			serviceLevelsMessage.show();
			estimatedDeliveryDate.show();
			serviceLevelsMessage.show();
			(0, _jquery2.default)("#saturday-delivery-checkbox1").hide();
		}
	
		if (fedexShippingMethodBtnValueCheck.val() == "true") {
			fedexShippingSelected();
		}
	
		if (serviceLevelsBtnValueCheck.val() == "true") {
			serviceLevelsSelected();
		}
	
		fedexShippingMethodBtn.on("click", function (e) {
			fedexShippingSelected();
		});
	
		serviceLevelsBtn.on("click", function (e) {
			serviceLevelsSelected();
		});
	
		function deactivateBtns() {
			serviceLevelsBtn.removeClass("active");
			fedexShippingMethodBtn.removeClass("active");
		}
	
		if (shippingType == "-1") {
			shippingMethodUsa.hide();
			shippingMethodCanada.hide();
			shippingMethodOther.hide();
			shippingMethodLtlMsg.hide();
			shippingMethodParcelMsg.hide();
			internationalProductShippingCost.hide();
			selectMethod.hide();
		} else if (shippingType == "PCL") {
			if (countryVal == "1") {
				var serviceLevelslength = serviceLevelsUsaId.children('option').length;
				if (serviceLevelslength == 0) {
					//No serviceLevel data
					fedexShippingMethodBtn.trigger('click');
					shippingMethodLtlMsg.hide();
					selectMethod.hide();
					shippingMethodParcelMsg.hide();
				} else {
					selectMethod.show();
					shippingMethodUsa.show();
					shippingMethodCanada.hide();
					shippingMethodOther.hide();
					internationalProductShippingCost.hide();
					shippingMethodLtlMsg.hide();
					shippingMethodParcelMsg.show();
					dontShowSectionForParcelSelection.hide();
				}
			} else if (countryVal == "2") {
				selectMethod.show();
				shippingMethodUsa.hide();
				shippingMethodCanada.show();
				shippingMethodOther.hide();
				shippingMethodUsaSelect.hide();
				serviceLevelUsaSelect.hide();
				estimatedDeliveryDate.hide();
				serviceLevelsMessage.hide();
				internationalProductShippingCost.show();
				shippingMethodLtlMsg.hide();
			} else {
				selectMethod.show();
				internationalProductShippingCost.show();
				shippingMethodUsa.hide();
				shippingMethodCanada.hide();
				shippingMethodOther.show();
				shippingMethodUsaSelect.hide();
				serviceLevelUsaSelect.hide();
				estimatedDeliveryDate.hide();
				serviceLevelsMessage.hide();
				shippingMethodLtlMsg.hide();
			}
		} else {
			shippingMethodUsa.hide();
			shippingMethodCanada.hide();
			shippingMethodOther.hide();
			internationalProductShippingCost.hide();
			shippingMethodLtlMsg.show();
			selectMethod.hide();
			shippingMethodParcelMsg.hide();
			shippingMethodUsaSelect.hide();
			serviceLevelUsaSelect.hide();
			serviceLevelsBtnValueCheck.val(false);
			fedexShippingMethodBtnValueCheck.val(false);
			estimatedDeliveryDate.hide();
			serviceLevelsMessage.hide();
			handleSignatureOptionDisable(closestParentEl);
			saturdayDeliveryCheckbox.attr("disabled", true);
		}
	}
	
	function resetAccessorialSection() {
		var shippingMethodUsaId = (0, _jquery2.default)("#shipping-tab-shipping-method-with-usa");
		var signatureOptionsSelect = (0, _jquery2.default)("#signature-options-select");
		var shippingTabAccessorialeNote = (0, _jquery2.default)("#shipping-tab-accessorials-signature");
		var saturdayDeliveryCheckbox = (0, _jquery2.default)("#saturday-delivery-checkbox");
		var internationalShippingCosts = (0, _jquery2.default)(".international-product-shipping-container");
		var countryVal = (0, _jquery2.default)('#destination-tab-country  :selected').val();
	
		shippingMethodUsaId.val("-1").trigger("change.select2");
		signatureOptionsSelect.empty();
		shippingTabAccessorialeNote.html("");
	
		saturdayDeliveryCheckbox.prop("checked", false);
		saturdayDeliveryCheckbox.prop("disabled", true);
	
		internationalShippingCosts.find(':input[type="number"]').each(function () {
			if (countryVal === "1") {
				(0, _jquery2.default)(this).val("");
			}
		});
	}

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bindCheckboxRowItems = bindCheckboxRowItems;
	exports.addSimpleCheckboxRows = addSimpleCheckboxRows;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: I don't have time to make a legitimate component for this,
	// so we will just make a one-off utility....
	var simpleCheckboxRowHtml = __webpack_require__(1464);
	
	
	var checkboxRowSelectedClass = "additional-filter-selected";
	
	function bindCheckboxRowItems() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      namespace = _ref.namespace,
	      selector = _ref.selector;
	
	  var DEFAULT_CHECKBOX_ROW_SELECTOR = "#" + namespace + "additional-filter-modal .filter-list a";
	  selector = selector || DEFAULT_CHECKBOX_ROW_SELECTOR;
	  (0, _jquery2.default)(document).on("click", selector, handleCheckboxRowClick);
	}
	
	function handleCheckboxRowClick(e) {
	  var checkboxClicked = e.target.type === 'checkbox';
	  if (!checkboxClicked) {
	    e.preventDefault();
	  }
	  handleSelectingItem((0, _jquery2.default)(this), checkboxClicked);
	}
	
	function handleSelectingItem(el, checkboxClicked) {
	  var checkbox = el.find(":checkbox");
	  var isChecked = checkbox.is(':checked');
	  if (checkboxClicked) {
	    // if the checkbox was clicked, we should force
	    // the checkbox and highlighting class 
	    // into the target state that it is currently in,
	    // NOT toggle, because the checkbox handled 
	    // 'checking' itself
	    toggleCheckboxRowViaBool(el, checkbox, isChecked);
	  } else {
	    // if it was the row that was clicked,
	    // we do want to handle toggling both the row class
	    // AND the checkbox
	    toggleCheckboxRowViaBool(el, checkbox, !isChecked);
	  }
	};
	
	function toggleCheckboxRowViaBool(el, checkbox, bool) {
	  checkbox.prop('checked', bool);
	  var func = bool ? 'addClass' : 'removeClass';
	  el[func](checkboxRowSelectedClass);
	}
	
	function addSimpleCheckboxRows(el, list) {
	  el.append(renderSimpleCheckboxRows(list));
	}
	
	function renderSimpleCheckboxRows(list) {
	  if (!_underscore2.default.isArray(list)) {
	    list = [list];
	  }
	  var ElArray = (0, _underscore2.default)(list).map(renderSimpleCheckboxRow);
	  ElArray = (0, _selectorHelpers.combineElements)(ElArray);
	  return ElArray;
	}
	
	function renderSimpleCheckboxRow(data) {
	  data.isPresent = _general.isPresent;
	  return (0, _jquery2.default)((0, _render2.default)(simpleCheckboxRowHtml, data));
	}

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.applySortingRelatedIconsAndSetHiddenFields = applySortingRelatedIconsAndSetHiddenFields;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The majority of this is legacy,
	// I've updated the arguments for sanity
	function applySortingRelatedIconsAndSetHiddenFields(_ref) {
	  var headerElement = _ref.headerElement,
	      elements = _ref.elements,
	      sortField = _ref.sortField,
	      callback = _ref.callback;
	
	  var icon = headerElement.find("i");
	  if (icon.hasClass('fa-sort-asc')) {
	    icon.removeClass('fa-sort-asc');
	    icon.addClass("fa-sort-desc");
	    elements.sortFieldHiddenInput.val(sortField);
	    elements.sortTypeHiddenInput.val('desc');
	    callback();
	  } else {
	    icon.removeClass("fa-sort-desc");
	    headerElement.find("i").addClass("fa-sort-asc");
	    elements.sortFieldHiddenInput.val(sortField);
	    elements.sortTypeHiddenInput.val('asc');
	    callback();
	  }
	  var otherIcons = headerElement.parent().siblings().find("i");
	  otherIcons.removeClass("fa-sort-asc fa-sort-desc");
	  otherIcons.addClass("fa-sort");
	};

/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./functionApply')} */
	module.exports = Function.prototype.apply;


/***/ },
/* 149 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./functionCall')} */
	module.exports = Function.prototype.call;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(105);
	var $TypeError = __webpack_require__(63);
	
	var $call = __webpack_require__(149);
	var $actualApply = __webpack_require__(231);
	
	/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
	module.exports = function callBindBasic(args) {
		if (args.length < 1 || typeof args[0] !== 'function') {
			throw new $TypeError('a function is required');
		}
		return $actualApply(bind, $call, args);
	};


/***/ },
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
92,
/* 179 */
92,
/* 180 */
92,
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reflectGetProto = __webpack_require__(280);
	var originalGetProto = __webpack_require__(279);
	
	var getDunderProto = __webpack_require__(1055);
	
	/** @type {import('.')} */
	module.exports = reflectGetProto
		? function getProto(O) {
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return reflectGetProto(O);
		}
		: originalGetProto
			? function getProto(O) {
				if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
					throw new TypeError('getProto: not an object');
				}
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return originalGetProto(O);
			}
			: getDunderProto
				? function getProto(O) {
					// @ts-expect-error TS can't narrow inside a closure, for some reason
					return getDunderProto(O);
				}
				: null;


/***/ },
/* 182 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal fade q-modal q-default-base q-default q-reset q-text-center\" role=dialog> <div class=\"modal-dialog q-modal-dialog-500\"> <div class=modal-content> <div class=modal-body> <div class=q-pad-all-xl> <h1 class=\"q-title q-no-marg\">{%- optional.title %}</h1> <div class=\"q-pad-top-lg q-pad-bottom-sm\">{%= optional.body %}</div> </div> </div> </div> </div> </div>";

/***/ },
/* 183 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-card q-card-white\"> <div class=\"q-main-header clearfix\"> <div class=q-inline-block-til-md> <div class=\"q-border-bottom-at-md q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"><i class=\"fa fa-book q-icon-marg-right\"></i> {%- organizationDetails.orgName %} </h2> </div> </div> <div class=q-pull-right-til-md> <div class=\"q-main-header-actions-container q-text-right-til-md q-pad-left-sm-til-md\"> <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn v2-btn\" id=backToListBtn> Back to List </a> <a href={%- orgEditUrl %} class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn\"> Edit </a> </div> </div> </div> <div class=q-section> <div class=q-marg-horz-lg> <div class=\"q-tc-container q-min-height-65 q-pad-vert-xxs\"> <div class=\"q-tc-row q-v-align-children-middle\"> <div class=q-col-fix-130> <div class=q-marg-vert-md-at-md> <div class=\"q-pill q-pill-detail q-block q-pill-white-and-blue q-display-none active-status-pill\">Active</div> <div class=\"q-pill q-pill-detail q-block q-pill-white-and-grey inactive-status-pill\">Inactive</div> </div> </div> <div class=q-col-7> <div class=q-marg-vert-md-at-md> <span> {%- orgModifiedDateTime %} by {%- organizationDetails.orgModifiedBy %}. </span> </div> </div> <div class=q-col-3> <div class=\"q-text-right-til-md q-marg-vert-md-at-md\"> <a href=# class=\"base-btn purple-btn q-text-center q-block-at-md q-marg-top-md-at-md activate-org-btn q-display-none\">Activate</a> <a href=# class=\"base-btn purple-btn q-text-center q-block-at-md q-marg-top-md-at-md deactivate-org-btn\">Deactivate</a> </div> </div> </div> </div> </div> </div> </div> <div class=q-marg-top-xl> <div class=\"q-card q-card-white\"> <div class=q-section> <div class=q-main-header-title-container> <h2 class=\"q-title q-boldest\">Details</h2> </div> </div> <div class=\"q-section org-info-details\"> <div class=q-overflow-hidden> <div class=\"q-row full-vertical-break-at-md\"> <div class=\"q-col-6 q-relfix\"> <div class=q-marg-all-xl> <h2 class=q-section-title> <a href=# data-target-form=\"\"> <span>Organization Details</span> <a href={%- orgEditUrl %}> <i class=\"fa fa-pencil q-icon-marg-left q-link-icon q-icon-md\" aria-hidden=true></i> </a> </a> </h2> <div class=q-marg-bottom-md> <div class=row> <div class=col-md-6> <span class=q-boldest>Organization Type:</span> </div> <div class=col-md-6> {%- organizationDetails.orgType %} </div> </div> </div> <div class=\"solo-divider ds-bottom-at-md ds-grey\"></div> <div class=\"solo-divider ds-pulled-full-height ds-right-til-md ds-full-height ds-grey\"></div> </div> </div> <div class=\"q-col-6 q-relfix\"> <div class=q-marg-all-xl> <h2 class=q-section-title> <a href=# data-target-form=\"\"> <span>Organization Contact</span> <a href={%- orgEditUrl %}> <i class=\"fa fa-pencil q-icon-marg-left q-link-icon q-icon-md\" aria-hidden=true></i> </a> </a> </h2> <div class=q-marg-bottom-md> <div class=row> <div class=col-md-6> <span class=q-boldest>Contact Name:</span> </div> <div class=col-md-6> <span> {%- organizationDetails.cmrAddress[0].cadContactName %} </span> </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=col-md-6> <span class=q-boldest>Email:</span> </div> <div class=col-md-6> <span>{%- organizationDetails.cmrAddress[0].cadContactEmail %} </span> </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=col-md-6> <span class=q-boldest>Phone:</span> </div> <div class=col-md-6> <span>{%- orgFormattedPhone %} </span> </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=col-md-6> <span class=q-boldest>Address:</span> </div> <div class=col-md-6> {% if (organizationDetails.cmrAddress[0] !== null) { %} <span>{%- organizationDetails.cmrAddress[0].cadAddress1 %}</span> <br/> <span>{%- organizationDetails.cmrAddress[0].cadAddress2 %}</span> <br/> <span>{%- organizationDetails.cmrAddress[0].cadCity %}</span>, <span>{%- organizationDetails.cmrAddress[0].cadState %} </span> <span>{%- organizationDetails.cmrAddress[0].cadZipcode %} </span><br/> <span>{%- organizationDetails.cmrAddress[0].cadCountry %}</span> <br/> {% } %} </div> </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> <a data-target-form=\"\" href=#> <span>Affiliated Carriers</span> <a href={%- orgEditUrl %}> <i class=\"fa fa-pencil q-icon-marg-left q-link-icon q-icon-md\" aria-hidden=true></i> </a> </a> </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.affiliated-carrier data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-expand q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"affiliated-carrier q-expandable-default\"> <div class=carrier-details-main-area></div> <div class=carrier-details-paging-area></div> </div> </div> </div> <div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> <a data-target-form=\"\" href=#> <span>Team Members</span> <a href={%- orgEditUrl %}> <i class=\"fa fa-pencil q-icon-marg-left q-link-icon q-icon-md\" aria-hidden=true></i> </a> </a> </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.org-team-member data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-expand q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"org-team-member q-expandable-default\"> {%= teamMembers %} </div> </div> </div> <div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> History </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.org-history data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"org-history q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Created On:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- orgCreateDateTime %} </span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Created By:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- organizationDetails.orgCreatedBy %} </span> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"row q-marg-top-md-at-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Modified On:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- orgModifiedDateTime %} </span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Modified By:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- organizationDetails.orgModifiedBy %} </span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 184 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group dg-lg day-shift-row\" data-day-of-week=\"{%- day.toLowerCase() %}\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox value=\"\" name=dayOfTheWeekCheck class=day-of-week-checkbox /> <span class=\"cb-label-inner q-boldest\"> {%- day %} </span> </label> </div> </div> <div class=\"col-md-9 col-xs-12\"> <div class=\"time-picker-area q-marg-top-xs-at-md\" data-day-of-week=\"{%- day.toLowerCase() %}\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-display-none q-block-at-md\">Start Time</span> <div class=time-picker-from> </div> </div> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-display-none q-block-at-md\">End Time</span> <div class=time-picker-to> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=q-marg-top-xs-at-md> <a href=# class=\"base-btn purple-btn add-shift-btn disabled default-add-shift-btn\">Add Time Block</a> </div> </div> </div> </div> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=\"q-alert q-alert-red q-display-none\"> End time cannot be before start time. </div> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=\"q-alert-t q-alert-red q-display-none\"> Each selected day requires at least one time block. </div> </div> </div> </div>";

/***/ },
/* 185 */
/***/ function(module, exports) {

	module.exports = "<form class=new-dock-form> <div class=\"q-default-base q-max-page-width-md q-page-center-margin\"> <div class=\"q-card q-card-white\"> <div class=\"q-section q-no-border-bottom\"> <div class=\"q-marg-all-xl q-no-marg-bottom\"> <h2 class=q-section-title> <span>Dock Door Details</span> </h2> <div class=divider-group-title> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Dock Door Name * </label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required door-name\" name=doorname placeholder=\"Enter dock door name\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Dock Door Uses * </label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select required door-uses\" style=width:100% data-s2-minimum-results-for-search=Infinity data-error-placement-append-closest=div name=dooruses> <option value=\"Inbound and Outbound\">Inbound and Outbound</option> <option value=\"Inbound only\">Inbound only</option> <option value=\"Outbound only\">Outbound only</option> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Appointment Types Accepted * </label> </div> <div class=\"col-md-9 col-xs-12\"> <div class=appointment-types-accepted> <select class=\"select2-select required doorAppointmentTypes\" style=width:100% multiple=multiple data-s2-minimum-results-for-search=Infinity data-s2-placeholder=\"Select all appointment types this dock is capable of processing\" data-error-placement-append-closest=div> <option value=\"\"></option> <option value=\"Live Load\">Live Load</option> <option value=\"Live Unload\">Live Unload</option> <option value=\"Pickup Load\">Pickup Load</option> <option value=\"Pickup Empty\">Pickup Empty</option> <option value=\"Drop Empty\">Drop Empty</option> <option value=\"Drop Unload\">Drop Unload</option> </select> </div> </div> </div> </div> </div> </div> </div> <div class=master-togglable-parent> <div class=\"q-marg-bottom-xl q-marg-horz-xl\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Use master appointment schedule?</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input id=master type=checkbox name=master class=\"js-switchery quick-toggler use-master-toggle\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-unchecked=true data-quick-toggler-closest=.master-togglable-parent data-quick-toggler-target=.master-togglable-target checked=true /> </div> </div> </div> </div> <div class=\"q-section q-border-top master-togglable-target\"> <div class=q-marg-all-xl> <h2 class=q-section-title> Dock Door Schedule </h2> <div class=q-marg-vert-md> Select the days of the week that this dock door will be operational and open for appointments. </div> <div class=q-marg-vert-md> <div class=\"divider-group divider-group-title dg-lg q-display-none-at-md\"> <div class=row> <div class=\"col-md-9 col-md-offset-3\"> <div class=row> <div class=col-md-3> <span class=q-tag> Start Time </span> </div> <div class=col-md-3> <span class=q-tag> End Time </span> </div> </div> </div> </div> </div> {%= shiftRows %} </div> </div> </div> </div> </div> </div> </form>";

/***/ },
/* 186 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-vert-xl additional-carrier\"> <div class=q-marg-vert-xl> <h2 class=q-section-title> Additional Carrier </h2> </div> <div class=\"q-marg-vert-md carrier-drop-section\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Carrier *</label> </div> <div class=\"col-md-3 col-xs-12\"> <select required class=\"select2-select required q-input additionalCarrierDrop\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Carrier\" data-s2-minimum-results-for-search=7 id=\"additionalCarrier-{%-arrayIndex%}\" name=additionalCarrierDrop data-array-index=additionalCarrier> <option disabled=disabled selected=selected>Select a carrier</option> {%= additionalCarrierDropdown %} </select> </div> </div> </div> <div class=\"q-marg-vert-md hidden\" id=fedexAccountNumber> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>FedEx Account Number *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required type=text data-error-placement-append-closest=div class=\"q-input q-stretch required additional-carrier-fedexnumber\" id=\"additional-carrier-fedexnumber-{%-arrayIndex%}\" name=additional-carrier-fedexnumber placeholder=\"Enter a FedEx account number\"> </div> </div> </div> <div class=\"q-marg-vert-md hidden\" id=upsAccountNumber> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>UPS Account Number *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required type=text data-error-placement-append-closest=div class=\"q-input required q-stretch additional-carrier-upsnumber\" id=\"additional-carrier-upsnumber-{%-arrayIndex%}\" name=additional-carrier-upsnumber placeholder=\"Enter a UPS account number\"> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Bill To *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required type=text data-error-placement-append-closest=div class=\"q-input required q-stretch additional-carrier-billTo\" id=\"additional-carrier-billTo-{%-arrayIndex%}\" name=additional-carrier-billTo placeholder=\"Company Name\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Country *</label> </div> <div class=\"col-md-3 col-xs-12\"> <select required class=\"select2-select q-input additional-carrier-country\" style=width:100% name=additional-carrier-country id=\"additional-carrier-country-{%-arrayIndex%}\" data-error-placement-append-closest=div data-s2-placeholder=\"Select Country\" data-s2-minimum-results-for-search=7 data-option=\"{%-countryList %}\"> <option disabled=disabled selected=selected>Select country</option> {%= countryList %} </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input type=text class=\"q-input q-stretch additional-carrier-address1 required\" data-error-placement-append-closest=div id=\"additional-carrier-address1-{%-arrayIndex%}\" name=additional-carrier-address1 placeholder=\"Address Line 1\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <input type=text class=\"q-input q-stretch additional-carrier-address2\" id=\"additional-carrier-address2-{%-arrayIndex%}\" name=additional-carrier-address2 placeholder=\"Address Line 2 (Optional)\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch additional-carrier-city required\" data-error-placement-append-closest=div id=\"additional-carrier-city-{%-arrayIndex%}\" name=additional-carrier-city placeholder=City> </div> </div> </div> <div class=\"q-marg-vert-md additional-carrier-detail-state-wrapper\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>State/Province/Region *</label> </div> <div class=\"col-md-3 col-xs-12\"> <select required class=\"select2-select q-input additional-carrier-detail-state\" style=width:100% id=\"additional-carrier-detail-state-{%-arrayIndex%}\" name=additional-carrier-detail-state data-error-placement-append-closest=div data-s2-placeholder=\"Select State/Province/Region\" data-s2-minimum-results-for-search=7> </select> </div> </div> </div> <div class=\"q-marg-vert-md additional-carrier-detail-state-text-wrapper hidden\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>State/Province/Region</label> </div> <div class=\"col-md-3 col-xs-12\"> <input type=text class=\"q-input q-stretch additional-carrier-detail-state-text\" id=\"additional-carrier-detail-state-text-{%-arrayIndex%}\" name=additional-carrier-detail-state-text placeholder=State/Province/Region> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Postal Code *</label> </div> <div class=\"col-md-3 col-xs-12\"> <input required type=text class=\"q-input q-stretch additional-carrier-postalCode\" id=\"additional-carrier-postalCode-{%-arrayIndex%}\" name=additional-carrier-postalCode placeholder=\"Postal Code\"> </div> </div> </div> </div> <div class=\"q-marg-vert-xl order-type-detail-remove-div\"> <div class=\"q-basic-divider q-bd-bottom-grey q-marg-bottom-md\"></div> <a href=# class=\"base-btn purple-btn v2-btn q-text-center q-block-at-md order-type-detail-remove\">Remove Carrier</a> </div> </div>";

/***/ },
/* 187 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pill q-pill-table q-marg-all-xs-at-md q-block {%- pillClass %}\">{%- data %}</div>";

/***/ },
/* 188 */,
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(94),
	    root = __webpack_require__(64);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(64);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 191 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Schema = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.arrayOf = arrayOf;
	exports.valuesOf = valuesOf;
	exports.unionOf = unionOf;
	exports.normalize = normalize;
	
	var _EntitySchema = __webpack_require__(1559);
	
	var _EntitySchema2 = _interopRequireDefault(_EntitySchema);
	
	var _IterableSchema = __webpack_require__(1560);
	
	var _IterableSchema2 = _interopRequireDefault(_IterableSchema);
	
	var _UnionSchema = __webpack_require__(457);
	
	var _UnionSchema2 = _interopRequireDefault(_UnionSchema);
	
	var _isEqual = __webpack_require__(1545);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _isObject = __webpack_require__(106);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultAssignEntity(normalized, key, entity) {
	  normalized[key] = entity;
	}
	
	function visitObject(obj, schema, bag, options) {
	  var _options$assignEntity = options.assignEntity;
	  var assignEntity = _options$assignEntity === undefined ? defaultAssignEntity : _options$assignEntity;
	
	
	  var defaults = schema && schema.getDefaults && schema.getDefaults();
	  var schemaAssignEntity = schema && schema.getAssignEntity && schema.getAssignEntity();
	  var normalized = (0, _isObject2.default)(defaults) ? _extends({}, defaults) : {};
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      var entity = visit(obj[key], schema[key], bag, options);
	      assignEntity.call(null, normalized, key, entity, obj, schema);
	      if (schemaAssignEntity) {
	        schemaAssignEntity.call(null, normalized, key, entity, obj, schema);
	      }
	    }
	  }
	  return normalized;
	}
	
	function defaultMapper(iterableSchema, itemSchema, bag, options) {
	  return function (obj) {
	    return visit(obj, itemSchema, bag, options);
	  };
	}
	
	function polymorphicMapper(iterableSchema, itemSchema, bag, options) {
	  return function (obj) {
	    var schemaKey = iterableSchema.getSchemaKey(obj);
	    var result = visit(obj, itemSchema[schemaKey], bag, options);
	    return { id: result, schema: schemaKey };
	  };
	}
	
	function visitIterable(obj, iterableSchema, bag, options) {
	  var itemSchema = iterableSchema.getItemSchema();
	  var curriedItemMapper = defaultMapper(iterableSchema, itemSchema, bag, options);
	
	  if (Array.isArray(obj)) {
	    return obj.map(curriedItemMapper);
	  } else {
	    return Object.keys(obj).reduce(function (objMap, key) {
	      objMap[key] = curriedItemMapper(obj[key]);
	      return objMap;
	    }, {});
	  }
	}
	
	function visitUnion(obj, unionSchema, bag, options) {
	  var itemSchema = unionSchema.getItemSchema();
	  return polymorphicMapper(unionSchema, itemSchema, bag, options)(obj);
	}
	
	function defaultMergeIntoEntity(entityA, entityB, entityKey) {
	  for (var key in entityB) {
	    if (!entityB.hasOwnProperty(key)) {
	      continue;
	    }
	
	    if (!entityA.hasOwnProperty(key) || (0, _isEqual2.default)(entityA[key], entityB[key])) {
	      entityA[key] = entityB[key];
	      continue;
	    }
	
	    console.warn('When merging two ' + entityKey + ', found unequal data in their "' + key + '" values. Using the earlier value.', entityA[key], entityB[key]);
	  }
	}
	
	function visitEntity(entity, entitySchema, bag, options) {
	  var _options$mergeIntoEnt = options.mergeIntoEntity;
	  var mergeIntoEntity = _options$mergeIntoEnt === undefined ? defaultMergeIntoEntity : _options$mergeIntoEnt;
	
	
	  var entityKey = entitySchema.getKey();
	  var id = entitySchema.getId(entity);
	
	  if (!bag.hasOwnProperty(entityKey)) {
	    bag[entityKey] = {};
	  }
	
	  if (!bag[entityKey].hasOwnProperty(id)) {
	    bag[entityKey][id] = {};
	  }
	
	  var stored = bag[entityKey][id];
	  var normalized = visitObject(entity, entitySchema, bag, options);
	  mergeIntoEntity(stored, normalized, entityKey);
	
	  return id;
	}
	
	function visit(obj, schema, bag, options) {
	  if (!(0, _isObject2.default)(obj) || !(0, _isObject2.default)(schema)) {
	    return obj;
	  }
	
	  if (schema instanceof _EntitySchema2.default) {
	    return visitEntity(obj, schema, bag, options);
	  } else if (schema instanceof _IterableSchema2.default) {
	    return visitIterable(obj, schema, bag, options);
	  } else if (schema instanceof _UnionSchema2.default) {
	    return visitUnion(obj, schema, bag, options);
	  } else {
	    return visitObject(obj, schema, bag, options);
	  }
	}
	
	function arrayOf(schema, options) {
	  return new _IterableSchema2.default(schema, options);
	}
	
	function valuesOf(schema, options) {
	  return new _IterableSchema2.default(schema, options);
	}
	
	function unionOf(schema, options) {
	  return new _UnionSchema2.default(schema, options);
	}
	
	exports.Schema = _EntitySchema2.default;
	function normalize(obj, schema) {
	  var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  if (!(0, _isObject2.default)(obj)) {
	    throw new Error('Normalize accepts an object or an array as its input.');
	  }
	
	  if (!(0, _isObject2.default)(schema) || Array.isArray(schema)) {
	    throw new Error('Normalize accepts an object for schema.');
	  }
	
	  var bag = {};
	  var result = visit(obj, schema, bag, options);
	
	  return {
	    entities: bag,
	    result: result
	  };
	}

/***/ },
/* 193 */,
/* 194 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	var Format = {
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};
	
	module.exports = {
	    'default': Format.RFC3986,
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return String(value);
	        }
	    },
	    RFC1738: Format.RFC1738,
	    RFC3986: Format.RFC3986
	};


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AdditionalServicesView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	var _currency = __webpack_require__(66);
	
	var _ServiceView = __webpack_require__(529);
	
	var _ServiceView2 = _interopRequireDefault(_ServiceView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1233);
	
	
	var elementsMap = {
	  additionalServices: ".additional-services-target",
	  noServicesAdded: ".no-services-added"
	};
	
	function AdditionalServicesView(_unused, _ref) {
	  var onRemoveServiceRow = _ref.onRemoveServiceRow,
	      getRelaventServices = _ref.getRelaventServices,
	      getDomains = _ref.getDomains,
	      getServices = _ref.getServices,
	      onAddService = _ref.onAddService,
	      getAggregateCurrencyTotalViaCurrencyPerUnits = _ref.getAggregateCurrencyTotalViaCurrencyPerUnits,
	      shouldShowServiceCloseBtn = _ref.shouldShowServiceCloseBtn,
	      shouldShowCurrencyPerUnits = _ref.shouldShowCurrencyPerUnits,
	      readOnly = _ref.readOnly;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var serviceViews = [];
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {}
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    // if there are services,
	    // always just render the services
	    var hasServices = getServices().length;
	    if (hasServices) {
	      serviceViews = renderServices();
	      els.additionalServices.html((0, _viewHelpers.extractElements)(serviceViews));
	    }
	    (0, _selectorHelpers.handleDisplayFor)(els.noServicesAdded, !hasServices);
	  }
	
	  self.unbindListeners = function () {};
	
	  function bindElements() {}
	
	  function onAddServiceChanged() {}
	
	  function updateValues() {}
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindElements();
	  }
	
	  function renderServices() {
	    return (0, _underscore2.default)(getServices()).map(function (service, rowIdx) {
	      var serviceView = new _ServiceView2.default(service, {
	        getAggregateCurrencyTotalViaCurrencyPerUnits: getAggregateCurrencyTotalViaCurrencyPerUnits,
	        shouldShowServiceCloseBtn: shouldShowServiceCloseBtn,
	        shouldShowCurrencyPerUnits: shouldShowCurrencyPerUnits,
	        onRemoveServiceRow: onRemoveServiceRow,
	        readOnly: readOnly
	      });
	      serviceView.init();
	      return serviceView;
	    });
	  }
	
	  function getServiceSelectDataArray() {
	    return (0, _underscore2.default)(getDomains()).map(function (domain) {
	      return { id: domain.id.toString(), text: domainToSelectOptionText(domain) };
	    });
	  }
	
	  function domainToSelectOptionText(domain) {
	    return domain.cdm_meaning + " (" + CmrDomainStore.currencyToHtml(domain) + ")";
	  }
	}

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ServicesTab;
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ProductLevelServicesView = __webpack_require__(525);
	
	var _ProductLevelServicesView2 = _interopRequireDefault(_ProductLevelServicesView);
	
	var _ShipmentLevelServicesView = __webpack_require__(530);
	
	var _ShipmentLevelServicesView2 = _interopRequireDefault(_ShipmentLevelServicesView);
	
	var _ReviewServicesView = __webpack_require__(528);
	
	var _ReviewServicesView2 = _interopRequireDefault(_ReviewServicesView);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _calcSubTotalServicesForAsnId = __webpack_require__(549);
	
	var _calcSubTotalServicesForAsnId2 = _interopRequireDefault(_calcSubTotalServicesForAsnId);
	
	var _currency = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1077);
	
	
	var elementsMap = {
	  productServicesEntryPoint: '.product-services-entry-point',
	  shipmentServicesEntryPoint: ".shipment-services-entry-point",
	  reviewServicesOuter: ".review-services-outer",
	  subTotal: ".sub-total-currency"
	};
	
	function ServicesTab(wizard) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      scopeElement = _ref.scopeElement,
	      readOnly = _ref.readOnly;
	
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  if (!scopeElement) {
	    scopeElement = wizardElement.find('.services-tab');
	  }
	
	  var els = {};
	
	  self.init = function () {
	    setElements();
	    attachWidgets();
	    updateSelf();
	    bindElements();
	    bindStores();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, scopeElement);
	  }
	
	  function attachWidgets() {
	    var productLevelServicesView = new _ProductLevelServicesView2.default(els.productServicesEntryPoint, { readOnly: readOnly });
	    productLevelServicesView.init();
	    var shipmentLevelServicesView = new _ShipmentLevelServicesView2.default(els.shipmentServicesEntryPoint, { readOnly: readOnly });
	    shipmentLevelServicesView.init();
	    var reviewServicesView = new _ReviewServicesView2.default(els.reviewServicesOuter, { calcSubTotal: calcSubTotal, readOnly: readOnly });
	    reviewServicesView.init();
	  }
	
	  function bindElements() {}
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", updateSelf);
	
	    _AsnDetailStore2.default.bindListener("asn_details:add", updateSelf);
	    _AsnDetailStore2.default.bindListener("asn_details:remove", updateSelf);
	    _AsnDetailStore2.default.bindListener("asn_details:change", updateSelf);
	
	    _CmrServiceStore2.default.bindListener("cmr_services:add", updateSelf);
	    _CmrServiceStore2.default.bindListener("cmr_services:remove", updateSelf);
	    _CmrServiceStore2.default.bindListener("cmr_services:change", updateSelf);
	  }
	
	  function updateSelf() {
	    updateText();
	  }
	
	  function updateText() {
	    els.subTotal.text(calcSubTotal());
	  }
	
	  function calcSubTotal() {
	    var val = (0, _calcSubTotalServicesForAsnId2.default)(getAsnId());
	    return (0, _currency.toCurrency)(val);
	  }
	
	  function getAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	
	  function getAsnId() {
	    return getAsn().id;
	  }
	}

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ConfigurationTab;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _utilities = __webpack_require__(87);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	
	__webpack_require__(178);
	
	var moment = __webpack_require__(7);
	
	function ConfigurationTab(wizard) {
	
	  var self = this;
	  var el = wizard.getWizardElement();
	  self.init = function () {
	    bindElements();
	    orderProcessingDateTimeDropdown();
	    if (!(0, _general.isPresent)(retpartner)) {
	      (0, _selectorHelpers.setRequired)([orderProcessingDateTimeSelect]);
	    }
	    onLoad();
	  };
	  function bindElements() {
	    orderProcessingTogglers.on("change", function () {
	      toggleOrderProcessingDateTime(this.value, this.text);
	    });
	    orderProcessingDateTimeSelect.on('change', function () {
	      orderProcessingSelectChanged(this.value, this.text);
	    });
	    (0, _timePicker2.default)(timePickerTarget);
	    orderProcessingDateTimeSelectList = orderProcessingDateTimeSelect.data('options');
	    inventorySyncTogglers.on("change", function () {
	      toggleInventorySyncSwitch(this.id, this.value);
	    });
	  }
	
	  function orderProcessingDateTimeDropdown() {
	    var returnTypeList = "";
	    returnTypeList = orderProcessingDateTimeSelectList.map(function (el) {
	      return (0, _render2.default)("<option value = '{%-key %}'>{%-value %}</option>", {
	        key: el.cdmValue,
	        value: el.cdmDescription
	
	      });
	    });
	    orderProcessingDateTimeSelect.html(returnTypeList);
	    orderProcessingDateTimeSelect.val("");
	    orderProcessingDateTimeSelect.trigger('change');
	  }
	
	  function validateConfigTab() {
	    var isValid = false;
	    if (el.valid()) {
	      isValid = true;
	    }
	    return isValid;
	  }
	  self.didNavigateToForm = function () {
	    // validateConfigTab();
	  };
	
	  var retpartner = el.data("retailer-partners-info");
	  var parName = el.data("par-name");
	  var parId = el.data("partner-id");
	  var amazonParId = el.data("amazon-par-id");
	  var amazonMktPlcParId = el.data("amazon-market-palce-par-id");
	
	  var startDateValue = el.data("start-date-value");
	  var timePickerHoursSelectValue = el.data("time-picker-hours-select-value");
	  var timePickerMinSelectValue = el.data("time-picker-minutes-select-value");
	  var timePickerPeriodSelectValue = el.data("time-picker-period-select-value");
	
	  var orderProcessingTogglers = el.find("#orderProcessingIcon");
	  var inventorySyncTogglers = el.find(".inventory-sync-toggler");
	  var orderProcessingDateTimeSelect = el.find("#orderProcessingDateTimeOptions");
	  var orderProcessingDateTimeSelectList = orderProcessingDateTimeSelect.data('options');
	
	  var orderProcessingDateTimeSection = el.find("#order-processing-date-time");
	  var orderProcessingSelect = el.find("#order-processing-select");
	  var dateTimePickerSection = el.find("#order-processing-date-time-picker");
	
	  var orderProcessingIcon = el.find("#orderProcessingIcon");
	  var inventorySyncIcon = el.find("#inventorySyncIcon");
	
	  var startDate = el.find(".start-date");
	  var timePickerHoursSelect = el.find(".time-picker-hours-select");
	  var timePickerMinSelect = el.find(".time-picker-minutes-select");
	  var timePickerPeriodSelect = el.find(".time-picker-period-select");
	
	  var timePickerTarget = el.find('.time-picker');
	  (0, _timePicker2.default)(timePickerTarget);
	
	  var orderProcessingIconStatus = false;
	  var inventorySyncIconStatus = false;
	  var dateTime = "";
	  var beginOrderProcessingFrom = "";
	
	  function onLoad() {
	    loadConfiguration(retpartner);
	  }
	
	  function loadConfiguration(data) {
	    loadOrderProcessingConfiguration(data);
	    loadInventorySyncConfiguration(data);
	    toggleOrderProcessingDateTime(orderProcessingIcon, data.repOrdersProcessingFlag);
	    var isOn = (0, _utilities.anyChecked)(orderProcessingTogglers);
	    if ((0, _general.isPresent)(data) && isOn) {
	      dateTimePickerSection.show();
	      startDate.val(startDateValue);
	      startDate.change();
	      timePickerHoursSelect.val(timePickerHoursSelectValue);
	      timePickerHoursSelect.change();
	      timePickerMinSelect.val(timePickerMinSelectValue);
	      timePickerMinSelect.change();
	      timePickerPeriodSelect.val(timePickerPeriodSelectValue);
	      timePickerPeriodSelect.change();
	    }
	    toggleInventorySyncSwitch(inventorySyncIcon, data.repInventorySyncFlag);
	  }
	
	  function loadOrderProcessingConfiguration(data) {
	    if (data.repOrdersProcessingFlag) {
	      (0, _jquery2.default)("#orderProcessingIcon").val(true);
	      (0, _jquery2.default)("#orderProcessingIcon").prop('checked', true);
	    } else {
	      (0, _jquery2.default)("#orderProcessingIcon").val(false);
	      (0, _jquery2.default)("#orderProcessingIcon").prop('checked', false);
	    }
	
	    beginOrderProcessingFrom = data.repPullOrdersUri;
	  }
	
	  function loadInventorySyncConfiguration(data) {
	    if (data.repInventorySyncFlag) {
	      (0, _jquery2.default)("#inventorySyncIcon").val(true);
	      (0, _jquery2.default)("#inventorySyncIcon").prop('checked', true);
	    } else {
	      (0, _jquery2.default)("#inventorySyncIcon").val(false);
	      (0, _jquery2.default)("#inventorySyncIcon").prop('checked', false);
	    }
	  }
	
	  function toggleOrderProcessingDateTime(toggleSwitchId, toggleSwitchValue) {
	    var isOn = (0, _utilities.anyChecked)(orderProcessingTogglers);
	    dateTimePickerSection.hide();
	    if (isOn) {
	      dateTimePickerSection.show();
	      orderProcessingDateTimeSelect.change();
	      orderProcessingTogglers.val(true);
	      orderProcessingTogglers.prop('checked', true);
	    } else {
	      dateTimePickerSection.hide();
	      orderProcessingSelectChanged(null, null);
	      orderProcessingDateTimeSelect.val("");
	      orderProcessingTogglers.val(false);
	      orderProcessingTogglers.prop('checked', false);
	    }
	  }
	
	  function toggleInventorySyncSwitch(toggleSwitchId, toggleSwitchValue) {
	    var isOn = (0, _utilities.anyChecked)(inventorySyncIcon);
	
	    if (toggleSwitchId == "inventorySyncIcon") {
	      if (isOn) {
	        (0, _jquery2.default)("#inventorySyncIcon").val(true);
	        (0, _jquery2.default)("#inventorySyncIcon").prop('checked', true);
	      } else {
	        (0, _jquery2.default)("#inventorySyncIcon").val(false);
	        (0, _jquery2.default)("#inventorySyncIcon").prop('checked', false);
	      }
	    }
	  }
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: orderProcessingDateTimeSelect,
	    list: orderProcessingDateTimeSelectList,
	    valueDataKey: "cdmValue",
	    textDataKey: "cdmDescription"
	  });
	
	  function orderProcessingSelectChanged(val, text) {
	    startDate.val("");
	    timePickerHoursSelect.val("1");
	    timePickerMinSelect.val("00");
	    timePickerPeriodSelect.val("AM");
	    if (val === "future" || val === "past") {
	      dateTimePickerSection.show();
	      (0, _selectorHelpers.setRequired)([startDate]);
	      setCalendarProperties(val);
	    } else {
	      (0, _selectorHelpers.removeRequired)([startDate]);
	      dateTimePickerSection.hide();
	    }
	    timePickerHoursSelect.change();
	    timePickerMinSelect.change();
	    timePickerPeriodSelect.change();
	  }
	
	  function setDateTimePeriodDefaultValue() {
	    timePickerHoursSelect.val("1");
	    timePickerMinSelect.val("00");
	    timePickerPeriodSelect.val("AM");
	  }
	  function setCalendarProperties(selectedDropdownValue) {
	    (0, _jquery2.default)(".func-date-range-input").datepicker("destroy");
	    var date = new Date();
	    if (selectedDropdownValue === "future") {
	      (0, _jquery2.default)(".func-date-range-input").datepicker({
	        minDate: date,
	        todayBtn: "linked",
	        keyboardNavigation: false,
	        autoclose: true,
	        forceParse: false,
	        startDate: new Date()
	      });
	    } else if (selectedDropdownValue === "past") {
	      (0, _jquery2.default)(".func-date-range-input").datepicker({
	        todayBtn: "linked",
	        endDate: new Date(),
	        maxDate: date,
	        keyboardNavigation: false,
	        forceParse: false,
	        autoclose: true
	      });
	    }
	  }
	}

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = ConnectionTab;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	__webpack_require__(178);
	function ConnectionTab(wizard) {
	
		var self = this;
		var el = wizard.getWizardElement();
	
		var amazonCmrDomainConfigData = el.data("amazon-connection-setup");
		var retpartner = el.data("retailer-partners-info");
		var addChannel = el.data("add-channel");
		var parName = el.data("par-name");
		var parId = el.data("partner-id");
		var amazonParId = el.data("amazon-par-id");
		var amazonMktPlcParId = el.data("amazon-market-palce-par-id");
		var testAmazonConnection = el.data("test-amazon-connection-url");
		var completeConnectionSetup = el.data("complete-connection-setup-url");
		var saveConnectionSetupUrl = el.data("save-connection-setup-url");
		var viewChannelsUrl = el.data("view-channel-url");
		var viewChannelDetailUrl = el.data("view-channel-detail-url");
		var completeConnectionSetupBtn = el.find("#amazon-save-on-connection-success");
		var defaultFileFormatList = el.data("ftp-default-file-formats");
		var ftpInbDetails = el.data("ftp-inb-details");
		var ftpOubDetails = el.data("ftp-oub-details");
		var retailerPartnerFileFormat = el.data("retailer-partner-file-format");
		var fileFormatSelect = el.find(".fileFormat");
		var getRetailersExistingAmazonCredentials = el.data("retailers-existing-amazon-credentials");
		var amazonFbaConnectionExists = el.find("#amazonFbaConnectionExists");
		var amazonMarketplaceConnectionExists = el.find("#amazonMarketplaceConnectionExists");
		var realTimeApiRetailerPartnerData = el.data("retailer-realtime-api-details");
		var realTimeApiParId = el.data("realtime-api-par-id");
		var realtimeApiApplicationName = el.find("#realtimeApiApplicationName");
		var realtimeApiClientId = el.find("#realtimeApiClientId");
		var confirmationModalTxt = el.data("confirmation-modal-txt");
		var connectionStatus = "";
		var retailerSelectedFileFormat = retailerPartnerFileFormat.fileFormat;
		var submitModalFlow = new _SubmitModalFlow2.default();
		submitModalFlow.init();
	
		self.init = function () {
			onLoad();
		};
	
		self.didNavigateToForm = function () {
			done();
		};
	
		function onLoad() {
			if (amazonParId == parId) {
	
				fillAmazonData(amazonCmrDomainConfigData, retpartner);
				checkConnectionStatus(retpartner);
			} else if (amazonMktPlcParId == parId) {
				fillAmazonData(amazonCmrDomainConfigData, retpartner);
				checkConnectionStatus(retpartner);
			} else if (realTimeApiParId == parId) {
				fillRealTimeApiData(realTimeApiRetailerPartnerData, retpartner);
				manuallyActivateCompleteConnectionSetup();
			} else {
	
				fillFileFormatList(defaultFileFormatList);
				fillCrossBorderData(retpartner);
				if (retailerSelectedFileFormat != "" || retailerSelectedFileFormat != null) {
					fillRetailerFileFormat(retailerSelectedFileFormat);
				}
				fillFtpConnectionTabData(retpartner);
				fillInboundFoldersData(ftpInbDetails);
				fillOutboundFoldersData(ftpOubDetails);
			}
		}
	
		(0, _jquery2.default)("#channel-connection-fileformat").change(onFileFormatChange);
		(0, _jquery2.default)("#channel-connection-fileformat").on('click', onFileFormatChange);
		//$(".amazonSection").change(onAmazonSectionChange);
		(0, _jquery2.default)(".amazonSection").on('input', onAmazonSectionChange);
	
		(0, _jquery2.default)('.amazonFbaConnectionExists').click(function (e) {
			if (this.checked) {
				getRetailerExistingAmazonFBACredentials({ url: getRetailersExistingAmazonCredentials, success: retrevialSuccess, error: retrevialError });
			} else {
				clearAmazonData();
			}
		});
	
		(0, _jquery2.default)('.amazonMarketplaceconnectionExists').click(function () {
			if (this.checked) {
				getRetailerExistingAmazonMarketPlaceCredentials({ url: getRetailersExistingAmazonCredentials, success: retrevialSuccess, error: retrevialError });
			} else {
				clearAmazonData();
			}
		});
	
		function fillInboundFoldersData(ftpINB) {
			if (ftpINB.length > 0) {
				ftpINB.forEach(function (ftpINB) {
					var ftp_inb_folders = ftpINB.cdmValue;
					var trHTML = '';
					trHTML += '<tr><td>' + ftpINB.cdmValue + '</td></tr>';
					(0, _jquery2.default)('#inb_records_table').append(trHTML);
				});
			}
		}
	
		function fillOutboundFoldersData(ftpOUB) {
			if (ftpOUB.length > 0) {
				ftpOUB.forEach(function (ftpOUB) {
					var ftp_oub_folders = ftpOUB.cdmValue;
					var trHTML = '';
					trHTML += '<tr><td>' + ftpOUB.cdmValue + '</td></tr>';
					(0, _jquery2.default)('#oub_records_table').append(trHTML);
				});
			}
		}
	
		function fillFtpConnectionTabData(retpartnerJson) {
			(0, _jquery2.default)("#connectionDescription").val(retpartnerJson.repDescription);
			(0, _jquery2.default)("#shortLink").val(retpartnerJson.repStoreLink);
		}
	
		function fillCrossBorderData(retpartnerJson) {
			(0, _jquery2.default)("#fedexCrossBorderMerchantId").val(retpartnerJson.repToken);
		}
	
		function fillRetailerFileFormat(retailerSelectedFileFormat) {
			(0, _jquery2.default)("#channel-connection-fileformat").val(retailerSelectedFileFormat);
		}
		function onFileFormatChange() {
			var downloadXmlURL = el.data("download-xml-url");
			var downloadCsvURL = el.data("download-csv-url");
			var fileFormat = (0, _jquery2.default)('#channel-connection-fileformat').find(':selected').val();
	
			if (fileFormat == "XML") {
				(0, _jquery2.default)("#channel-connection-downloadtemplate").attr('href', downloadXmlURL);
			} else if (fileFormat == "CSV") {
				(0, _jquery2.default)("#channel-connection-downloadtemplate").attr('href', downloadCsvURL);
			}
		}
	
		function fillFileFormatList(data) {
			_.each(data, function (val, key) {
				var option = (0, _jquery2.default)('<option />');
				option.attr('value', key).text(val);
				fileFormatSelect.append(option);
			});
		}
	
		function checkConnectionStatus(data) {
			connectionStatus = data.repConnectionTest;
			if (connectionStatus == 0) {
				connectionError();
			} else if (connectionStatus == 1) {
				setConnectionSuccessOnReviewTab();
			}
		}
	
		function fillAmazonData(data, retpartner) {
			var amazonPartnerDescription = data.parDescription;
			var amazonSellerId = data.amazonSellerId;
			var amazonMarketplaceId = data.amazonMarketplaceId;
			var amazonConnectionDescription = retpartner.repDescription;
			var amazonConnectionStatus = retpartner.repConnectionTest;
	
			(0, _jquery2.default)("#amazonPartnerNameId").html(parName);
			(0, _jquery2.default)("#amazonPartnerNameId").val(parName);
			(0, _jquery2.default)("#amazonSellerId").val(data.amazonSellerId);
			(0, _jquery2.default)("#amazonMarketplaceId").val(amazonMarketplaceId);
			(0, _jquery2.default)("#amazonConnectionDescriptionId").val(amazonConnectionDescription);
			(0, _jquery2.default)(".connection-status").val(amazonConnectionStatus);
		}
	
		function fillRealTimeApiData(data, retpartner) {
			var realtimeApiApplicationName = retpartner.repHostName;
			var realtimeApiClientId = retpartner.repToken;
	
			(0, _jquery2.default)("#realtimeApiApplicationName").val(realtimeApiApplicationName);
			(0, _jquery2.default)("#realtimeApiClientId").val(realtimeApiClientId);
		}
	
		function clearAmazonData() {
			(0, _jquery2.default)("#amazonPartnerNameId").html();
			(0, _jquery2.default)("#amazonPartnerNameId").val("");
			(0, _jquery2.default)("#amazonSellerId").val("");
			(0, _jquery2.default)("#amazonMarketplaceId").val("");
			(0, _jquery2.default)("#amazonConnectionDescriptionId").val("");
		}
	
		(0, _jquery2.default)("#retPartner-save").click(function (e) {
			var canSaveConn = canSave(wizard);
			if (canSaveConn) {
				saveConnection({ url: saveConnectionSetupUrl, success: saveSuccess, error: saveError, request: amazonCmrDomainConfigData });
			}
		});
	
		(0, _jquery2.default)(".retPartner-save").click(function (e) {
			if (completeConnectionSetupBtn.hasClass('disabled')) {
				return;
			} else {
				saveConnection({ url: saveConnectionSetupUrl, success: saveSuccess, error: saveError, request: amazonCmrDomainConfigData });
			}
		});
	
		function saveConnection(_ref) {
			var url = _ref.url,
			    success = _ref.success,
			    error = _ref.error,
			    request = _ref.request;
	
			var submitModalFlow = new _SubmitModalFlow2.default({
				confirmModalBody: '<div class="q-pad-all-xl">' + confirmationModalTxt + '</div>',
				onConfirmClick: function onConfirmClick() {
					submitModalFlow.showLoadingModal();
					_jquery2.default.ajax({
						data: (0, _jquery2.default)('#create-channel-form').serialize(),
						url: url,
						dataType: "JSON",
						type: 'POST',
						success: saveSuccess,
						error: saveError
					});
				}
			});
			submitModalFlow.init();
			submitModalFlow.showConfirmModal();
		}
	
		function saveSuccess() {
			EditChecker.setPageClean();
			if (parId != "" && parId != amazonParId) {
				var detailPageUrl = viewChannelDetailUrl + '&parId=' + parId + '&orgName=' + parName;
				submitModalFlow.showSuccessModal();
				setTimeout(function () {
					location.href = detailPageUrl;
				}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			} else if (parId != "" && parId == amazonParId && connectionStatus == 0) {
				var detailPageUrl = viewChannelDetailUrl + '&parId=' + parId + '&orgName=' + parName;
				submitModalFlow.showSuccessModal();
				setTimeout(function () {
					location.href = detailPageUrl;
				}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			} else if (parId != "" && parId == amazonParId && connectionStatus == 1) {
				var detailPageUrl = viewChannelDetailUrl + '&parId=' + parId + '&orgName=' + parName;
				submitModalFlow.showSuccessModal();
				setTimeout(function () {
					location.href = detailPageUrl;
				}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			} else {
				EditChecker.setPageDirty();
				submitModalFlow.showFailureModal();
				/*$('#create-channel-form').unmask();*/
			}
	
			//Uncommented above section as it was commented by somoeone who worked on submission modal and QA raised issue regarding save Modal.
			/*if(parId != "")
	  {
	    submitModalFlow.showSuccessModal();
	    setTimeout(function() {
	  	 const detailPageUrl = `${viewChannelDetailUrl}&$&parId=${parId}`;
	  	 window.location.href = detailPageUrl;
	    }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	  }
	  else{
	    submitModalFlow.showFailureModal();
	  }*/
		}
	
		function saveError() {
			submitModalFlow.hideAllModals();
		}
	
		(0, _jquery2.default)(".test-amazon-connection").click(function (e) {
			e.preventDefault();
			var canSaveConn = canSave(wizard);
			if (canSaveConn) {
				testConnection({ url: testAmazonConnection, success: connectionSuccess, error: connectionError });
			}
		});
	
		function testConnection(_ref2) {
			var url = _ref2.url,
			    success = _ref2.success,
			    error = _ref2.error;
	
			var testConnectionJson = getFromDataForTestConnection();
			_jquery2.default.ajax({
				url: url,
				type: 'POST',
				dataType: 'JSON',
				data: {
					parId: testConnectionJson.parId,
					parName: testConnectionJson.parName,
					amazonSellerId: testConnectionJson.amazonSellerId,
					authToken: testConnectionJson.amazonMarketplaceId,
					accessKeyId: testConnectionJson.amazonAwsAccessKeyId,
					secretKey: testConnectionJson.amazonSecretKey
				},
				success: success,
				error: error
			});
		}
	
		function canSave(wizard) {
			var currentForm = wizard.getActiveTargetForm();
			var isValid = true;
			if (currentForm.filter(".connection-tab").length) {
				isValid = areInputsValidForForm(currentForm);
			}
			return isValid;
		}
	
		function areInputsValidForForm(form) {
			var inputs = wizard.findValidatableElementsForScope(form);
			var valid = wizard.areInputsValid(inputs, { displayErrors: true });
			return valid;
		}
	
		function connectionSuccess(data) {
			if (data.connStatus == "Success") {
				(0, _jquery2.default)("#connection-status-id").val("1");
				connectionStatus = 1;
				(0, _jquery2.default)("#amazon-connection-success-div").removeAttr("style");
				(0, _jquery2.default)("#test-amazon-connection-div").attr("style", "display:none");
				(0, _jquery2.default)(".next-btn-channel-setup").removeAttr('disabled');
				(0, _jquery2.default)("#amazon-connection-failed-div").attr("style", "display:none");
				setConnectionSuccessOnReviewTab();
			} else {
				connectionError();
			}
		}
	
		function connectionError() {
			(0, _jquery2.default)("#connection-status-id").val("0");
			connectionStatus = 0;
			(0, _jquery2.default)("#amazon-connection-failed-div").removeAttr("style");
			setConnectionFailedOnReviewTab();
		}
	
		function onAmazonSectionChange() {
			(0, _jquery2.default)("#test-amazon-connection-div").removeAttr('style');
			connectionStatus = 0;
			(0, _jquery2.default)("#connection-status-id").val("0");
			(0, _jquery2.default)("#amazon-connection-success-div").attr("style", "display:none");
			(0, _jquery2.default)("#amazon-connection-failed-div").attr("style", "display:none");
			setConnectionFailedOnReviewTab();
		}
	
		function setConnectionFailedOnReviewTab() {
			(0, _jquery2.default)(".review-tab-connection-failed").removeAttr("style");
			(0, _jquery2.default)(".review-tab-connection-success").attr("style", "display:none");
			completeConnectionSetupBtn.addClass("disabled");
		}
	
		function setConnectionSuccessOnReviewTab() {
			(0, _jquery2.default)(".review-tab-connection-success").removeAttr("style");
			(0, _jquery2.default)(".review-tab-connection-failed").attr("style", "display:none");
			completeConnectionSetupBtn.removeClass("disabled");
		}
	
		function getFromDataForTestConnection() {
			var formData = new Object();
			formData.parId = parId;
			formData.parName = parName;
			formData.amazonSellerId = (0, _jquery2.default)("#amazonSellerId").val();
			formData.amazonMarketplaceId = (0, _jquery2.default)("#amazonMarketplaceId").val();
			formData.amazonAwsAccessKeyId = (0, _jquery2.default)("#amazonAwsAccessKeyId").val();
			formData.amazonSecretKey = (0, _jquery2.default)("#amazonSecretKey").val();
			return formData;
		}
	
		function getRetailerExistingAmazonMarketPlaceCredentials(_ref3) {
			var url = _ref3.url,
			    success = _ref3.success,
			    error = _ref3.error;
	
			var parIdToBeUsedForRetreival = amazonMktPlcParId;
			_jquery2.default.ajax({
				url: url,
				type: 'POST',
				dataType: 'JSON',
				data: {
					parId: parIdToBeUsedForRetreival,
					parName: parName
				},
				success: success,
				error: error
			});
		}
	
		function getRetailerExistingAmazonFBACredentials(_ref4) {
			var url = _ref4.url,
			    success = _ref4.success,
			    error = _ref4.error;
	
			var parIdToBeUsedForRetreival = amazonParId;
			_jquery2.default.ajax({
				url: url,
				type: 'POST',
				dataType: 'JSON',
				data: {
					parId: parIdToBeUsedForRetreival,
					parName: parName
				},
				success: success,
				error: error
			});
		}
	
		function retrevialSuccess(data) {
			fillAmazonData(data, "");
		}
	
		function retrevialError(data) {
			console.log("There was an issue retreiving existing connection details");
		}
	
		function manuallyActivateCompleteConnectionSetup() {
			completeConnectionSetupBtn.removeClass("disabled");
		}
	
		var cancelBtn = (0, _jquery2.default)(".cancel-channel-config-btn");
		var cancelURL = (0, _jquery2.default)("#create-channel-form").data("view-channel-url");
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EbayConfigurationsTab;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _utilities = __webpack_require__(87);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	function EbayConfigurationsTab(wizard) {
	
	  var self = this;
	  var el = wizard.getWizardElement();
	  var retpartner = el.data("retailer-partners-info");
	  var orderProcessingTogglers = el.find("#ebayOrderProcessingCheck");
	  var orderProcessingIcon = el.find("#ebayOrderProcessingCheck");
	  var orderProcessingIconStatus = false;
	  var dateTime = "";
	  var beginOrderProcessingFrom = "";
	  var startDateValue = el.data("start-date-value");
	  var timePickerHoursSelectValue = el.data("time-picker-hours-select-value");
	  var timePickerMinSelectValue = el.data("time-picker-minutes-select-value");
	  var timePickerPeriodSelectValue = el.data("time-picker-period-select-value");
	  var orderProcessingDateTimeSelect = el.find("#orderProcessingDateTimeOptions");
	  var orderProcessingDateTimeSelectList = orderProcessingDateTimeSelect.data('options');
	  var dateTimePickerSection = el.find("#order-processing-date-time-picker");
	  var startDate = el.find(".start-date");
	  var timePickerHoursSelect = el.find(".time-picker-hours-select");
	  var timePickerMinSelect = el.find(".time-picker-minutes-select");
	  var timePickerPeriodSelect = el.find(".time-picker-period-select");
	  var timePickerTarget = el.find('.time-picker');
	  (0, _timePicker2.default)(timePickerTarget);
	
	  self.init = function () {
	    onLoad();
	  };
	
	  self.didNavigateToForm = function () {};
	
	  function onLoad() {
	    loadConfiguration(retpartner);
	  }
	
	  function loadConfiguration(data) {
	    loadOrderProcessingConfiguration(data);
	    toggleOrderProcessingDateTime(orderProcessingIcon, data.repOrdersProcessingFlag);
	  }
	
	  function loadOrderProcessingConfiguration(data) {
	    if (data.repOrdersProcessingFlag) {
	      (0, _jquery2.default)("#ebayOrderProcessingCheck").val(true);
	      (0, _jquery2.default)("#ebayOrderProcessingCheck").prop('checked', true);
	    } else {
	      (0, _jquery2.default)("#ebayOrderProcessingCheck").val(false);
	      (0, _jquery2.default)("#ebayOrderProcessingCheck").prop('checked', false);
	    }
	    beginOrderProcessingFrom = data.repPullOrdersUri;
	    orderProcessingDateTimeSelect.val(beginOrderProcessingFrom);
	    orderProcessingDateTimeSelect.trigger('change');
	  }
	
	  toggleOrderProcessingDateTime();
	
	  orderProcessingTogglers.on("change", function (e) {
	    toggleOrderProcessingDateTime(this.id, this.value);
	  });
	
	  function toggleOrderProcessingDateTime(toggleSwitchId, toggleSwitchValue) {
	    var isOn = (0, _utilities.anyChecked)(orderProcessingIcon);
	
	    dateTimePickerSection.hide();
	    if (isOn) {
	      dateTimePickerSection.show();
	      orderProcessingDateTimeSelect.change();
	      (0, _jquery2.default)("#ebayOrderProcessingCheck").val(true);
	      (0, _jquery2.default)("#ebayOrderProcessingCheck").prop('checked', true);
	    } else {
	      dateTimePickerSection.hide();
	      orderProcessingSelectChanged(null, null);
	      orderProcessingDateTimeSelect.val("");
	      (0, _jquery2.default)("#ebayOrderProcessingCheck").val(false);
	      (0, _jquery2.default)("#ebayOrderProcessingCheck").prop('checked', false);
	    }
	  }
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: orderProcessingDateTimeSelect,
	    list: orderProcessingDateTimeSelectList,
	    valueDataKey: "cdmValue",
	    textDataKey: "cdmDescription"
	  });
	
	  orderProcessingDateTimeSelect.on('change', function () {
	    orderProcessingSelectChanged(this.value, this.text);
	  });
	
	  function orderProcessingSelectChanged(val, text) {
	    if (val === "future" || val === "past") {
	      dateTimePickerSection.show();
	      setCalendarProperties(val);
	
	      if (startDateValue === null || startDateValue === "") {
	        setDateTimePeriodDefaultValue();
	      } else {
	        startDate.val(startDateValue);
	        timePickerHoursSelect.val(timePickerHoursSelectValue);
	        timePickerHoursSelect.change();
	        timePickerMinSelect.val(timePickerMinSelectValue);
	        timePickerMinSelect.change();
	        timePickerPeriodSelect.val(timePickerPeriodSelectValue);
	        timePickerPeriodSelect.change();
	      }
	    } else {
	      dateTimePickerSection.hide();
	      startDate.val("");
	      timePickerHoursSelect.change();
	      timePickerMinSelect.change();
	      timePickerPeriodSelect.change();
	    }
	  }
	
	  function setDateTimePeriodDefaultValue() {
	    timePickerHoursSelect.val("1");
	    timePickerMinSelect.val("00");
	    timePickerPeriodSelect.val("AM");
	  }
	
	  function setCalendarProperties(selectedDropdownValue) {
	    var date = new Date();
	    if (selectedDropdownValue === "future") {
	      (0, _jquery2.default)(".func-date-range-input").datepicker({
	        minDate: date,
	        todayBtn: "linked",
	        keyboardNavigation: false,
	        autoclose: true
	      });
	    } else if (selectedDropdownValue === "past") {
	      (0, _jquery2.default)(".func-date-range-input").datepicker({
	        maxDate: date,
	        todayBtn: "linked",
	        keyboardNavigation: false,
	        autoclose: true
	      });
	    }
	  }
	}

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EbayConnectionsTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	function EbayConnectionsTab(wizard) {
	
	  var self = this;
	  var el = wizard.getWizardElement();
	
	  var retpartner = el.data("retailer-partners-info");
	  var statusVal = el.data("status-val");
	  var openEbayChannelBtn = el.find("#open-ebay-channel-button");
	  var ebayUrl = el.data("ebay-url");
	  var loadEbayChannel = el.find("#load-ebay-channel");
	  var closedBeforeAuth = el.find(".closed-before-authorization");
	  var connNotAuth = el.find(".conn-not-authorized");
	  var connAuth = el.find(".conn-authorized");
	  var connAuthDateTime = el.find("#conn-auth-time");
	  var okayToClose = false;
	  var connectionStatus = false;
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  self.init = function () {
	    onLoad();
	  };
	
	  self.didNavigateToForm = function () {};
	
	  self.areInputsValidForForm = function () {
	    return connectionStatus;
	  };
	
	  function onLoad() {
	    closedBeforeAuth.hide();
	    connNotAuth.hide();
	    connAuth.hide();
	    if (statusVal) {
	      connAuth.text(getConnAuthText(retpartner.connAuthDate, retpartner.connAuthTime));
	      connAuth.show();
	      openEbayChannelBtn.hide();
	      connectionStatus = true;
	    }
	    if ((0, _general.isPresent)(retpartner)) {
	      connAuthDateTime.val(retpartner.connAuthDateTime);
	    }
	  }
	
	  window.addEventListener("storage", function (event) {
	    connectionStatus = localStorage.getItem("connectionStatus");
	    localStorage.removeItem("connectionStatus");
	    okayToClose = true;
	  }, true);
	
	  openEbayChannelBtn.click(function (e) {
	    openEbayChannelBtn.hide();
	    loadEbayChannel.show();
	    var childWindow = window.open(ebayUrl, "_blank");
	    var pollTimer = window.setInterval(function () {
	      if (okayToClose) {
	        childWindow.close();
	      }
	      if ((0, _general.isTruthy)(childWindow.closed)) {
	        window.clearInterval(pollTimer);
	        onChildWindowClose(childWindow);
	      }
	    }, 200);
	  });
	
	  function onChildWindowClose(childWindow) {
	    if (okayToClose) {
	      if ((0, _general.isTruthy)(connectionStatus)) {
	        getAuthDateAndTime();
	        loadEbayChannel.hide();
	        connAuth.show();
	      } else {
	        openEbayChannelBtn.show();
	        loadEbayChannel.hide();
	        connNotAuth.show();
	      }
	    } else {
	      openEbayChannelBtn.show();
	      loadEbayChannel.hide();
	      closedBeforeAuth.show();
	    }
	  }
	
	  function getAuthDateAndTime() {
	    var date = new Date();
	    var hours = date.getHours();
	    var minutes = date.getMinutes();
	    var ampm = hours >= 12 ? 'PM' : 'AM';
	    hours = hours % 12;
	    hours = hours ? hours : 12; // the hour '0' should be '12'
	    minutes = minutes < 10 ? '0' + minutes : minutes;
	    var strTime = hours + ':' + minutes + ' ' + ampm;
	    connAuth.text(getConnAuthText(date.toLocaleDateString(), strTime));
	    connAuthDateTime.val(date.toLocaleDateString() + ',' + strTime);
	  }
	
	  function getConnAuthText(date, time) {
	    return 'Connection authorized: ' + date + ' at ' + time + ' Click \'Next\' to review and activate this channel.';
	  }
	}

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = EbayReviewTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _utilities = __webpack_require__(87);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  ebayPartnerNameReviewTab: ".review-tab-partner-name",
	  ebayPartnerName: "#ebayPartnerNameId",
	
	  sectionTitlesReviewTab: ".section-step-title-inner",
	
	  orderProcessingIcon: "#ebayOrderProcessingCheck",
	  reviewTabOrderProcessingIcon: ".review-tab-order-processing-icon",
	
	  orderProcessingStatusYes: ".order-processing-status-yes",
	  orderProcessingDateTimeYes: ".order-processing-status-yes-date-time",
	
	  orderProcessingStatusNo: ".order-processing-status-no",
	
	  startDate: ".start-date",
	  timePickerHoursSelect: ".time-picker-hours-select",
	  timePickerMinSelect: ".time-picker-minutes-select",
	  timePickerPeriodSelect: ".time-picker-period-select",
	
	  reviewTabTimePickerHoursSelect: ".review-tab-time-picker-hours-select",
	  reviewTabTimePickerMinSelect: ".review-tab-time-picker-minutes-select",
	  reviewTabTimePickerPeriodSelect: ".review-tab-time-picker-period-select",
	
	  reviewTabDateSetter: ".review-tab-start-date-td",
	  reviewTabTimeSetter: ".review-tab-start-time-td",
	
	  orderProcessingDateTimeOptionsSelect: ".orderProcessingDateTimeOptions"
	};
	
	function EbayReviewTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	  var retpartner = wizardElement.data("retailer-partners-info");
	  var saveConnectionSetupUrl = wizardElement.data("save-connection-setup-url");
	  var completeConnectionSetup = wizardElement.data("complete-connection-setup-url");
	  var ebayCmrDomainConfigData = wizardElement.data("ebay-connection-setup");
	  var viewChannelsUrl = wizardElement.data("view-channel-url");
	  var viewChannelDetailUrl = wizardElement.data("view-channel-detail-url");
	  var parName = wizardElement.data("par-name");
	  var parId = wizardElement.data("partner-id");
	  var confirmationModalTxt = wizardElement.data("confirmation-modal-txt");
	  var orderProcessingIconStatusReviewTab = false;
	  var orderProcessingSelectValue = "";
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  self.init = function () {
	    setElements();
	    bindElements();
	    fillChannelsReviewTab();
	  };
	
	  self.didNavigateToForm = function () {
	    fillChannelsReviewTab();
	  };
	
	  function bindElements() {
	    els.sectionTitlesReviewTab.bind('click', function () {
	      var form = wizardElement.find((0, _jquery2.default)(this).data("target-form"));
	      wizard.gotToForm(form);
	    });
	  }
	
	  function setElements() {
	    setElementsFromScope(els, elementsMap, wizardElement);
	  }
	
	  function setElementsFromScope(targetObj, elementsDict, scope) {
	    (0, _underscore2.default)(elementsDict).each(function (v, k) {
	      //console.log(`${v} ${k}`)
	      targetObj[k] = scope.find(v);
	    });
	  }
	
	  function fillChannelsReviewTab() {
	    els.ebayPartnerNameReviewTab.text(els.ebayPartnerName.text());
	    (0, _jquery2.default)(".review-tab-active-since").text(dateFromatCustomChange(retpartner.repActiveSince));
	
	    setConfigurationReviewSection();
	  }
	
	  function setConfigurationReviewSection() {
	    orderProcessingIconStatusReviewTab = (0, _utilities.anyChecked)(els.orderProcessingIcon);
	    setOrderProcessingOnReviewTab(orderProcessingIconStatusReviewTab);
	    setReviewTabDate();
	  }
	
	  function setOrderProcessingOnReviewTab(data) {
	    if (data) {
	      els.orderProcessingStatusYes.show();
	      els.orderProcessingDateTimeYes.show();
	      els.orderProcessingStatusNo.hide();
	    } else {
	      els.orderProcessingStatusYes.hide();
	      els.orderProcessingDateTimeYes.hide();
	      els.orderProcessingStatusNo.show();
	    }
	  }
	
	  function setReviewTabDate() {
	    els.reviewTabDateSetter.text(els.startDate.val());
	    setReviewTabTime();
	    hideShowStartTimeSection();
	  }
	
	  function setReviewTabTime() {
	    els.reviewTabTimePickerHoursSelect.text(els.timePickerHoursSelect.find("option:selected").val());
	    els.reviewTabTimePickerMinSelect.text(els.timePickerMinSelect.find("option:selected").val());
	    els.reviewTabTimePickerPeriodSelect.text(els.timePickerPeriodSelect.find("option:selected").val());
	  }
	
	  function hideShowStartTimeSection() {
	    orderProcessingSelectValue = els.orderProcessingDateTimeOptionsSelect.find(":selected").val();
	
	    if (orderProcessingSelectValue == "future" || orderProcessingSelectValue == "past") {
	      els.orderProcessingDateTimeYes.show();
	    } else {
	      els.orderProcessingDateTimeYes.hide();
	      els.startDate.val("");
	      els.reviewTabTimePickerHoursSelect.val("");
	      els.reviewTabTimePickerMinSelect.val("");
	      els.reviewTabTimePickerPeriodSelect.val("");
	    }
	  }
	
	  function dateFromatCustomChange(activeSince) {
	    if (activeSince != null) {
	      var date = convertUTCDateToLocalDate(new Date(activeSince));
	    } else {
	      var date = new Date();
	    }
	    var curr_day = date.getDate();
	    var curr_month = date.getMonth();
	    var curr_year = date.getFullYear();
	    curr_month++; // In js, first month is 0, not 1
	    var newDate = curr_month + "/" + curr_day + "/" + curr_year;
	    return newDate;
	  }
	
	  function convertUTCDateToLocalDate(date) {
	    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
	
	    var offset = date.getTimezoneOffset() / 60;
	    var hours = date.getHours();
	
	    newDate.setHours(hours - offset);
	
	    return newDate;
	  }
	
	  (0, _jquery2.default)(".retPartner-save").click(function (e) {
	    saveConnection({ url: saveConnectionSetupUrl, success: saveSuccess, error: saveError, request: ebayCmrDomainConfigData });
	  });
	
	  (0, _jquery2.default)("#retPartner-save").click(function (e) {
	    var canSaveConn = canSave(wizard);
	    if (canSaveConn) {
	      saveConnection({ url: saveConnectionSetupUrl, success: saveSuccess, error: saveError, request: ebayCmrDomainConfigData });
	    }
	  });
	
	  function canSave(wizard) {
	    var currentForm = wizard.getActiveTargetForm();
	    var isValid = true;
	    if (currentForm.filter(".connections-tab").length) {
	      isValid = areInputsValidForForm(currentForm);
	    }
	    return isValid;
	  }
	
	  function areInputsValidForForm(form) {
	    var inputs = wizard.findValidatableElementsForScope(form);
	    var valid = wizard.areInputsValid(inputs, { displayErrors: true });
	    return valid;
	  }
	
	  function saveConnection(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error,
	        request = _ref.request;
	
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalBody: '<div class="q-pad-all-xl">' + confirmationModalTxt + '</div>',
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        _jquery2.default.ajax({
	          data: (0, _jquery2.default)('#create-ebay-channel-form').serialize(),
	          url: url,
	          dataType: "JSON",
	          type: 'POST',
	          success: saveSuccess,
	          error: saveError
	        });
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	
	  function saveSuccess() {
	    EditChecker.setPageClean();
	    if (parId != "") {
	      var detailPageUrl = viewChannelDetailUrl + '&$&parId=' + parId + '&$&orgName=' + parName;
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        location.href = detailPageUrl;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      EditChecker.setPageDirty();
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function saveError() {
	    submitModalFlow.hideAllModals();
	  }
	}

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReviewTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _general = __webpack_require__(5);
	
	var _utilities = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  amazonPartnerNameReviewTab: ".review-tab-partner-name",
	  amazonPartnerName: "#amazonPartnerNameId",
	
	  amazonConnectionDescriptionReviewTab: ".review-tab-connection-description",
	  amazonConnectionDescription: "#amazonConnectionDescriptionId",
	
	  amazonSellerIdReviewTab: ".review-tab-amazon-seller-id",
	  amazonSellerId: "#amazonSellerId",
	
	  amazonMarketplaceIdReviewTab: ".review-tab-amazon-marketplace-id",
	  amazonMarketplaceId: "#amazonMarketplaceId",
	
	  amazonAwsAccessKeyIdReviewTab: ".review-tab-amazon-aws-access-key-id",
	  amazonAwsAccessKeyId: "#amazonAwsAccessKeyId",
	
	  amazonSecretKeyReviewTab: ".review-tab-amazon-secret-key-id",
	  amazonSecretKey: "#amazonSecretKey",
	
	  sectionTitlesReviewTab: ".section-step-title-inner",
	
	  amazonCurrentConnectionStatusReviewTab: ".test-status",
	  amazonCurrentConnectionStatus: ".current-status-of-amazon-connection",
	
	  amazonConnectionStatus: ".connection-status",
	  amazonReviewTabConnectionStatus: ".review-tab-connection-status",
	
	  orderProcessingIcon: "#orderProcessingIcon",
	  reviewTabOrderProcessingIcon: ".review-tab-order-processing-icon",
	
	  inventorySyncIcon: "#inventorySyncIcon",
	  reviewTabInventorySyncIcon: "review-tab-inventory-sync-icon",
	
	  orderProcessingStatusYes: ".order-processing-status-yes",
	  orderProcessingDateTimeYes: ".order-processing-status-yes-date-time",
	
	  inventorySyncStatusYes: ".inventory-sync-status-yes",
	
	  orderProcessingStatusNo: ".order-processing-status-no",
	  inventorySyncStatusNo: ".inventory-sync-status-no",
	
	  startDate: ".start-date",
	  timePickerHoursSelect: ".time-picker-hours-select",
	  timePickerMinSelect: ".time-picker-minutes-select",
	  timePickerPeriodSelect: ".time-picker-period-select",
	
	  reviewTabTimePickerHoursSelect: ".review-tab-time-picker-hours-select",
	  reviewTabTimePickerMinSelect: ".review-tab-time-picker-minutes-select",
	  reviewTabTimePickerPeriodSelect: ".review-tab-time-picker-period-select",
	
	  reviewTabDateSetter: ".review-tab-start-date-td",
	  reviewTabTimeSetter: ".review-tab-start-time-td",
	
	  orderProcessingDateTimeOptionsSelect: ".orderProcessingDateTimeOptions",
	
	  realtimeApiApplicationName: "#realtimeApiApplicationName",
	  reviewTabRealtimeApiApplicationName: ".review-tab-api-connection-application-name",
	
	  realtimeApiClientId: "#realtimeApiClientId",
	  reviewTabRealtimeApiClientId: ".review-tab-api-connection-client-id"
	};
	
	function ReviewTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var retpartner = wizardElement.data("retailer-partners-info");
	  var els = {};
	  var orderProcessingIconStatusReviewTab = false;
	  var inventorySyncIconStatusReviewTab = false;
	  var orderProcessingSelectValue = "";
	
	  self.init = function () {
	    setElements();
	    bindElements();
	    fillChannelsReviewTab();
	  };
	
	  self.didNavigateToForm = function () {
	    fillChannelsReviewTab();
	  };
	
	  function bindElements() {
	    els.sectionTitlesReviewTab.bind('click', function () {
	      var form = wizardElement.find((0, _jquery2.default)(this).data("target-form"));
	      wizard.gotToForm(form);
	    });
	  }
	
	  function setElements() {
	    setElementsFromScope(els, elementsMap, wizardElement);
	  }
	
	  function setElementsFromScope(targetObj, elementsDict, scope) {
	    (0, _underscore2.default)(elementsDict).each(function (v, k) {
	      //console.log(`${v} ${k}`)
	      targetObj[k] = scope.find(v);
	    });
	  }
	
	  function fillChannelsReviewTab() {
	    els.amazonPartnerNameReviewTab.text(els.amazonPartnerName.val());
	    els.amazonSellerIdReviewTab.text(els.amazonSellerId.val());
	    els.amazonConnectionDescriptionReviewTab.text(els.amazonConnectionDescription.val());
	    els.amazonMarketplaceIdReviewTab.text(els.amazonMarketplaceId.val());
	    els.amazonAwsAccessKeyIdReviewTab.text(els.amazonAwsAccessKeyId.val());
	    els.amazonSecretKeyReviewTab.text(els.amazonSecretKey.val());
	    els.amazonCurrentConnectionStatusReviewTab.text(els.amazonCurrentConnectionStatus.val());
	    els.amazonReviewTabConnectionStatus.text(els.amazonConnectionStatus.val());
	    (0, _jquery2.default)(".review-tab-active-since").text(dateFromatCustomChange(retpartner.repActiveSince));
	    (0, _jquery2.default)(".review-tab-partner-name").text(retpartner.parName);
	
	    setConfigurationReviewSection();
	
	    els.reviewTabRealtimeApiApplicationName.text(els.realtimeApiApplicationName.val());
	    els.reviewTabRealtimeApiClientId.text(els.realtimeApiClientId.val());
	  }
	
	  function setConfigurationReviewSection() {
	    orderProcessingIconStatusReviewTab = (0, _utilities.anyChecked)(els.orderProcessingIcon);
	    setOrderProcessingOnReviewTab(orderProcessingIconStatusReviewTab);
	    inventorySyncIconStatusReviewTab = (0, _utilities.anyChecked)(els.inventorySyncIcon);
	    setInventorySyncOnReviewTab(inventorySyncIconStatusReviewTab);
	    setReviewTabDate();
	  }
	
	  function setOrderProcessingOnReviewTab(data) {
	    if (data) {
	      els.orderProcessingStatusYes.show();
	      els.orderProcessingDateTimeYes.show();
	      els.orderProcessingStatusNo.hide();
	    } else {
	      els.orderProcessingStatusYes.hide();
	      els.orderProcessingDateTimeYes.hide();
	      els.orderProcessingStatusNo.show();
	    }
	  }
	
	  function setInventorySyncOnReviewTab(data) {
	    if (data) {
	      els.inventorySyncStatusYes.show();
	      els.inventorySyncStatusNo.hide();
	    } else {
	      els.inventorySyncStatusYes.hide();
	      els.inventorySyncStatusNo.show();
	    }
	  }
	
	  function setReviewTabDate() {
	    els.reviewTabDateSetter.text(els.startDate.val());
	    setReviewTabTime();
	    hideShowStartTimeSection();
	  }
	
	  function setReviewTabTime() {
	    els.reviewTabTimePickerHoursSelect.text(els.timePickerHoursSelect.find("option:selected").val());
	    els.reviewTabTimePickerMinSelect.text(els.timePickerMinSelect.find("option:selected").val());
	    els.reviewTabTimePickerPeriodSelect.text(els.timePickerPeriodSelect.find("option:selected").val());
	  }
	
	  function hideShowStartTimeSection() {
	    orderProcessingSelectValue = els.orderProcessingDateTimeOptionsSelect.find(":selected").val();
	
	    if (orderProcessingSelectValue == "future" || orderProcessingSelectValue == "past" || (0, _general.isPresent)(els.startDate.val())) {
	      els.orderProcessingDateTimeYes.show();
	    } else {
	      els.orderProcessingDateTimeYes.hide();
	    }
	  }
	
	  function dateFromatCustomChange(activeSince) {
	    if (activeSince != null) {
	      var date = convertUTCDateToLocalDate(new Date(activeSince));
	    } else {
	      var date = new Date();
	    }
	    var curr_day = date.getDate();
	    var curr_month = date.getMonth();
	    var curr_year = date.getFullYear();
	    curr_month++; // In js, first month is 0, not 1
	    var newDate = curr_month + "/" + curr_day + "/" + curr_year;
	    return newDate;
	  }
	
	  function convertUTCDateToLocalDate(date) {
	    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
	
	    var offset = date.getTimezoneOffset() / 60;
	    var hours = date.getHours();
	
	    newDate.setHours(hours - offset);
	
	    return newDate;
	  }
	}

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = walmartConfigurationTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _utilities = __webpack_require__(87);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function walmartConfigurationTab(wizard) {
	  var self = this;
	  var el = wizard.getWizardElement();
	
	  self.didNavigateToForm = function () {
	    return validateConfigTab();
	  };
	
	  var retpartner = el.data("retailer-partners-info");
	  var startDateValue = el.data("start-date-value");
	  var timePickerHoursSelectValue = el.data("time-picker-hours-select-value");
	  var timePickerMinSelectValue = el.data("time-picker-minutes-select-value");
	  var timePickerPeriodSelectValue = el.data("time-picker-period-select-value");
	  var orderProcessingDateTimeSelectList = void 0;
	  var elsPage = {};
	  var elsMap = {
	    orderProcessingTogglers: "#walmartOrderProcessingCheck",
	    orderProcessingDateTimeSelect: "#orderProcessingDateTimeOptions",
	    dateTimePickerSection: "#order-processing-date-time-picker",
	    startDate: ".start-date",
	    timePickerHoursSelect: ".time-picker-hours-select",
	    timePickerMinSelect: ".time-picker-minutes-select",
	    timePickerPeriodSelect: ".time-picker-period-select",
	    timePickerTarget: '.time-picker',
	    inventorySyncingTogglers: "#walmartInventorySyncingCheck"
	  };
	
	  self.init = function () {
	    setElements();
	    bindElements();
	    orderProcessingDateTimeDropdown();
	    if (!(0, _general.isPresent)(retpartner)) {
	      (0, _selectorHelpers.setRequired)([elsPage.orderProcessingDateTimeSelect]);
	    }
	    loadConfiguration(retpartner);
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elsMap, el);
	  }
	
	  function validateConfigTab() {
	    var isValid = false;
	    if (el.valid()) {
	      isValid = true;
	    }
	    return isValid;
	  }
	
	  function bindElements() {
	    elsPage.orderProcessingTogglers.on("change", function () {
	      toggleOrderProcessingDateTime(this.value, this.text);
	    });
	    elsPage.orderProcessingDateTimeSelect.on('change', function () {
	      orderProcessingSelectChanged(this.value, this.text);
	    });
	    (0, _timePicker2.default)(elsPage.timePickerTarget);
	    orderProcessingDateTimeSelectList = elsPage.orderProcessingDateTimeSelect.data('options');
	    elsPage.inventorySyncingTogglers.on("change", function () {
	      toggleInventorySyncSwitch(this.id, this.value);
	    });
	  }
	
	  function toggleInventorySyncSwitch(toggleSwitchId, toggleSwitchValue) {
	    var isOn = (0, _utilities.anyChecked)(elsPage.inventorySyncingTogglers);
	    if (toggleSwitchId == elsPage.inventorySyncingTogglers) {
	      if (isOn) {
	        elsPage.inventorySyncingTogglers.val(true);
	        elsPage.inventorySyncingTogglers.prop('checked', true);
	      } else {
	        elsPage.inventorySyncingTogglers.val(false);
	        elsPage.inventorySyncingTogglers.prop('checked', false);
	      }
	    }
	  }
	
	  function orderProcessingDateTimeDropdown() {
	    var returnTypeList = "";
	    returnTypeList = orderProcessingDateTimeSelectList.map(function (el) {
	      return (0, _render2.default)("<option value = '{%-key %}'>{%-value %}</option>", {
	        key: el.cdmValue,
	        value: el.cdmDescription
	
	      });
	    });
	    elsPage.orderProcessingDateTimeSelect.html(returnTypeList);
	    elsPage.orderProcessingDateTimeSelect.val("");
	    elsPage.orderProcessingDateTimeSelect.trigger('change');
	  }
	
	  function loadConfiguration(data) {
	    loadOrderProcessingConfiguration(data);
	    toggleOrderProcessingDateTime(elsPage.orderProcessingTogglers, data.repOrdersProcessingFlag);
	    var isOn = (0, _utilities.anyChecked)(elsPage.orderProcessingTogglers);
	    if ((0, _general.isPresent)(data) && isOn) {
	      elsPage.dateTimePickerSection.show();
	      elsPage.startDate.val(startDateValue);
	      elsPage.startDate.change();
	      elsPage.timePickerHoursSelect.val(timePickerHoursSelectValue);
	      elsPage.timePickerHoursSelect.change();
	      elsPage.timePickerMinSelect.val(timePickerMinSelectValue);
	      elsPage.timePickerMinSelect.change();
	      elsPage.timePickerPeriodSelect.val(timePickerPeriodSelectValue);
	      elsPage.timePickerPeriodSelect.change();
	    }
	
	    loadInventorySyncConfiguration(data);
	    toggleInventorySyncSwitch(elsPage.inventorySyncingTogglers, data.repInventorySyncFlag);
	  }
	
	  function loadInventorySyncConfiguration(data) {
	    if (data.repInventorySyncFlag) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(elsPage.inventorySyncingTogglers, {});
	      (0, _instantiateSwitchery.setSwitchery)(elsPage.inventorySyncingTogglers, data.repInventorySyncFlag);
	    }
	  }
	
	  function loadOrderProcessingConfiguration(data) {
	    if (data.repOrdersProcessingFlag) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(elsPage.orderProcessingTogglers, {});
	      (0, _instantiateSwitchery.setSwitchery)(elsPage.orderProcessingTogglers, data.repOrdersProcessingFlag);
	    }
	  }
	
	  function toggleOrderProcessingDateTime(toggleSwitchId, toggleSwitchValue) {
	    var isOn = (0, _utilities.anyChecked)(elsPage.orderProcessingTogglers);
	    elsPage.dateTimePickerSection.hide();
	    if (isOn) {
	      elsPage.dateTimePickerSection.show();
	      elsPage.orderProcessingDateTimeSelect.change();
	      elsPage.orderProcessingTogglers.val(true);
	      elsPage.orderProcessingTogglers.prop('checked', true);
	    } else {
	      elsPage.dateTimePickerSection.hide();
	      orderProcessingSelectChanged(null, null);
	      elsPage.orderProcessingDateTimeSelect.val("");
	      elsPage.orderProcessingTogglers.val(false);
	      elsPage.orderProcessingTogglers.prop('checked', false);
	    }
	  }
	
	  function orderProcessingSelectChanged(val, text) {
	    elsPage.startDate.val("");
	    elsPage.timePickerHoursSelect.val("1");
	    elsPage.timePickerMinSelect.val("00");
	    elsPage.timePickerPeriodSelect.val("AM");
	    if (val === "future" || val === "past") {
	      elsPage.dateTimePickerSection.show();
	      (0, _selectorHelpers.setRequired)([elsPage.startDate]);
	      setCalendarProperties(val);
	    } else {
	      (0, _selectorHelpers.removeRequired)([elsPage.startDate]);
	      elsPage.dateTimePickerSection.hide();
	    }
	    elsPage.timePickerHoursSelect.change();
	    elsPage.timePickerMinSelect.change();
	    elsPage.timePickerPeriodSelect.change();
	  }
	
	  function setCalendarProperties(selectedDropdownValue) {
	    (0, _jquery2.default)(".func-date-range-input").datepicker("destroy");
	    var date = new Date();
	    if (selectedDropdownValue === "future") {
	      (0, _jquery2.default)(".func-date-range-input").datepicker({
	        minDate: date,
	        todayBtn: "linked",
	        keyboardNavigation: false,
	        autoclose: true,
	        forceParse: false,
	        startDate: new Date()
	      });
	    } else if (selectedDropdownValue === "past") {
	      (0, _jquery2.default)(".func-date-range-input").datepicker({
	        todayBtn: "linked",
	        endDate: new Date(),
	        maxDate: date,
	        keyboardNavigation: false,
	        forceParse: false,
	        autoclose: true
	      });
	    }
	  }
	}

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = walmartConnectionTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function walmartConnectionTab(wizard) {
	  var self = this;
	  var el = wizard.getWizardElement();
	  var connectionStatus = false;
	
	  self.didNavigateToForm = function () {
	    return connectionStatus;
	  };
	
	  var conId = "";
	  var retpartner = el.data("retailer-partners-info");
	  var authenticateConnectionUrl = el.data("test-connection-url");
	  var parName = el.data("par-name");
	  var consumerIdPplaceholder = "Enter the Consumer ID provided by " + parName;
	  var privateKeyPlaceholder = "Enter Private Key as avaliable in " + parName + " Seller Center";
	  var privateKey = void 0;
	  var consumerId = void 0;
	  var elsPage = {};
	  var elsMap = {
	    authenticateConnectionBtn: "#authorizeConnectionBtn",
	    privateKey: "#privateKey",
	    consumerId: "#consumerId",
	    description: "#description",
	    loading: "#authenticateConnectionLoading",
	    nextBtn: "#walmart-next-button",
	    authenticateMsg: "#authenticateMsg",
	    connNotAuth: ".conn-not-authorized",
	    connAuth: ".conn-authorized",
	    connAuthDateTime: "#conn-auth-time"
	  };
	
	  self.areInputsValidForForm = function () {
	    var privateKey1 = elsPage.privateKey.val();
	    var consumerId1 = elsPage.consumerId.val();
	    if (privateKey == privateKey1 && consumerId1 == consumerId && connectionStatus == true) {
	      return connectionStatus;
	    } else {
	      elsPage.authenticateConnectionBtn.removeClass("hidden");
	      elsPage.connAuth.hide();
	      connectionStatus = false;
	      return connectionStatus;
	    }
	  };
	
	  self.init = function () {
	    setElements();
	    bindElements();
	    (0, _selectorHelpers.setUniqNames)([elsPage.privateKey, elsPage.consumerId]);
	    (0, _selectorHelpers.setRequired)([elsPage.privateKey, elsPage.consumerId]);
	    onLoad();
	    populateEditForm(retpartner);
	    elsPage.consumerId.attr('placeholder', consumerIdPplaceholder);
	    elsPage.privateKey.attr('placeholder', privateKeyPlaceholder);
	  };
	
	  function onLoad() {
	    elsPage.connNotAuth.hide();
	    elsPage.connAuth.hide();
	  }
	
	  function populateEditForm(retpartner) {
	    if (retpartner != null) {
	      elsPage.description.val(retpartner.repDescription);
	      elsPage.consumerId.val(retpartner.consumerId);
	      elsPage.privateKey.val(retpartner.privateKey);
	      elsPage.connAuthDateTime.val(retpartner.connAuthDateTime);
	      if (retpartner.repConnectionTest == "1") {
	        elsPage.authenticateConnectionBtn.addClass("hidden");
	        privateKey = elsPage.privateKey.val();
	        consumerId = elsPage.consumerId.val();
	        elsPage.connAuth.text(getConnAuthText(retpartner.connAuthDate, retpartner.connAuthTime));
	        elsPage.connAuth.show();
	        connectionStatus = true;
	      } else if (retpartner.repConnectionTest == "0") {
	        connectionStatus = false;
	      }
	    }
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elsMap, el);
	  }
	
	  function bindElements() {
	    elsPage.authenticateConnectionBtn.on("click", authenticateBtnHandler);
	  }
	
	  // Validation
	  function validateConnectionTab() {
	    var isValid = false;
	    var allPrevInputs = wizard.allPreviousFieldsUpToTargetForm(el.find(".configurations-tab"));
	
	    if (wizard.areInputsValid(allPrevInputs, { displayErrors: true })) {
	      isValid = true;
	    }
	
	    return isValid;
	  }
	
	  function authenticateBtnHandler(e) {
	    e.preventDefault();
	    var isValid = validateConnectionTab();
	    if (isValid) {
	      elsPage.authenticateConnectionBtn.addClass("hidden");
	      elsPage.loading.removeClass("hidden");
	      privateKey = elsPage.privateKey.val();
	      consumerId = elsPage.consumerId.val();
	      _jquery2.default.ajax({
	        url: authenticateConnectionUrl,
	        type: "POST",
	        dataType: "JSON",
	        data: {
	          privateKey: privateKey,
	          consumerId: consumerId
	        },
	        success: onConnectionSuccess,
	        error: onConnectionError
	      });
	    }
	  }
	
	  function onConnectionSuccess(data) {
	    if (data.success) {
	      connectionStatus = true;
	      elsPage.loading.addClass("hidden");
	      getAuthDateAndTime();
	      elsPage.connAuth.show();
	      elsPage.connNotAuth.hide();
	    } else {
	      onConnectionError(data);
	    }
	  }
	
	  function onConnectionError(data) {
	    connectionStatus = false;
	    elsPage.loading.addClass("hidden");
	    elsPage.connNotAuth.show();
	    elsPage.authenticateConnectionBtn.removeClass("hidden");
	  }
	
	  function getAuthDateAndTime() {
	    var date = new Date();
	    var hours = date.getHours();
	    var minutes = date.getMinutes();
	    var ampm = hours >= 12 ? 'PM' : 'AM';
	    hours = hours % 12;
	    hours = hours ? hours : 12; // the hour '0' should be '12'
	    minutes = minutes < 10 ? '0' + minutes : minutes;
	    var strTime = hours + ':' + minutes + ' ' + ampm;
	    elsPage.connAuth.text(getConnAuthText(date.toLocaleDateString(), strTime));
	    elsPage.connAuthDateTime.val(date.toLocaleDateString() + "," + strTime);
	  }
	
	  function getConnAuthText(date, time) {
	    return "Connection authorized: " + date + " at " + time + " Click 'Next' to review and activate this channel.";
	  }
	}

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = walmartReviewTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _utilities = __webpack_require__(87);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function walmartReviewTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	
	  var elementsMap = {
	    walmartPartnerNameReviewTab: ".review-tab-partner-name",
	    inventoryStatusMsg: ".inventory-sync-status-msg",
	    walmartActiveSince: ".review-tab-active-since",
	    walmartPartnerName: "#walmartPartnerNameId",
	    sectionTitlesReviewTab: ".section-step-title-inner",
	    orderProcessingIcon: "#walmartOrderProcessingCheck",
	    walmartInventorySyncingCheck: "#walmartInventorySyncingCheck",
	    reviewTabOrderProcessingIcon: ".review-tab-order-processing-icon",
	    connectionDescription: "#connection-description",
	    orderProcessingStatusYes: ".order-processing-status-yes",
	    orderProcessingDateTimeYes: ".order-processing-status-yes-date-time",
	    consumerId: "#consumer-id",
	    orderProcessingStatusNo: ".order-processing-status-no",
	    privateKey: "#private-key",
	    startDate: ".start-date",
	    timePickerHoursSelect: ".time-picker-hours-select",
	    timePickerMinSelect: ".time-picker-minutes-select",
	    timePickerPeriodSelect: ".time-picker-period-select",
	    inventorySyncYes: ".inventory-sync-status-yes",
	    reviewTabTimePickerHoursSelect: ".review-tab-time-picker-hours-select",
	    reviewTabTimePickerMinSelect: ".review-tab-time-picker-minutes-select",
	    reviewTabTimePickerPeriodSelect: ".review-tab-time-picker-period-select",
	    inventorySyncNo: ".inventory-sync-status-no",
	    reviewTabDateSetter: ".review-tab-start-date-td",
	    reviewTabTimeSetter: ".review-tab-start-time-td",
	    privateKeyField: "#privateKey",
	    consumerIdField: "#consumerId",
	    descriptionField: "#description",
	    orderProcessingDateTimeOptionsSelect: ".orderProcessingDateTimeOptions",
	    wizardSubmitBtn: ".submit-walmart-connection",
	    connAuthDateTime: "#conn-auth-time"
	  };
	
	  var retpartner = wizardElement.data("retailer-partners-info");
	  var viewChannelDetailUrl = wizardElement.data("view-channel-detail-url");
	  var saveChannelUrl = wizardElement.data("save-connection-setup-url");
	  var parName = wizardElement.data("par-name");
	  var parId = wizardElement.data("partner-id");
	  var orderProcessingSelectValue = "";
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  self.init = function () {
	    setElements();
	    bindElements();
	    fillChannelsReviewTab();
	  };
	
	  self.didNavigateToForm = function () {
	    fillChannelsReviewTab();
	  };
	
	  function bindElements() {
	    els.sectionTitlesReviewTab.bind('click', function () {
	      var form = wizardElement.find((0, _jquery2.default)(this).data("target-form"));
	      wizard.gotToForm(form);
	    });
	    els.wizardSubmitBtn.on("click", submitBtnHandler);
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardElement);
	  }
	
	  /* function setElementsFromScope(targetObj, elementsDict, scope) {
	     _(elementsDict).each((v, k) => {
	       targetObj[k] = scope.find(v);
	     });
	   }
	  */
	  function fillChannelsReviewTab() {
	    els.walmartPartnerNameReviewTab.text(els.walmartPartnerName.text());
	    els.walmartActiveSince.text(retpartner.repActiveSince);
	    els.connectionDescription.text(els.descriptionField.val());
	    els.privateKey.text(els.privateKeyField.val());
	    els.consumerId.text(els.consumerIdField.val());
	    setConfigurationReviewSection();
	  }
	
	  function setConfigurationReviewSection() {
	    setOrderProcessingOnReviewTab((0, _utilities.anyChecked)(els.orderProcessingIcon));
	    setInventorySyncOnReviewTab((0, _utilities.anyChecked)(els.walmartInventorySyncingCheck));
	    setReviewTabDate();
	  }
	
	  function setInventorySyncOnReviewTab(data) {
	    if (data) {
	      els.inventorySyncYes.show();
	      els.inventoryStatusMsg.show();
	      els.inventorySyncNo.hide();
	    } else {
	      els.inventorySyncNo.show();
	      els.inventorySyncYes.hide();
	      els.inventoryStatusMsg.hide();
	    }
	  }
	
	  function setOrderProcessingOnReviewTab(data) {
	    if (data) {
	      els.orderProcessingStatusYes.show();
	      els.orderProcessingDateTimeYes.show();
	      els.orderProcessingStatusNo.hide();
	    } else {
	      els.orderProcessingStatusYes.hide();
	      els.orderProcessingDateTimeYes.hide();
	      els.orderProcessingStatusNo.show();
	    }
	  }
	
	  function setReviewTabDate() {
	    els.reviewTabDateSetter.text(els.startDate.val());
	    setReviewTabTime();
	    hideShowStartTimeSection();
	  }
	
	  function setReviewTabTime() {
	    els.reviewTabTimePickerHoursSelect.text(els.timePickerHoursSelect.find("option:selected").val());
	    els.reviewTabTimePickerMinSelect.text(els.timePickerMinSelect.find("option:selected").val());
	    els.reviewTabTimePickerPeriodSelect.text(els.timePickerPeriodSelect.find("option:selected").val());
	  }
	
	  function hideShowStartTimeSection() {
	    orderProcessingSelectValue = els.orderProcessingDateTimeOptionsSelect.find(":selected").val();
	
	    if (orderProcessingSelectValue == "future" || orderProcessingSelectValue == "past" || (0, _general.isPresent)(els.startDate.val())) {
	      els.orderProcessingDateTimeYes.show();
	    } else {
	      els.orderProcessingDateTimeYes.hide();
	    }
	  }
	
	  function submitBtnHandler() {
	
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: "Confirm Connection",
	      confirmModalBody: '<div class="q-pad-all-xl">Once you confirm this connection\'s information, you will be able to begin fulfilling orders from ' + parName + '</div>',
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        _jquery2.default.ajax({
	          data: {
	            consumerId: els.consumerIdField.val(),
	            privateKey: els.privateKeyField.val(),
	            description: els.descriptionField.val(),
	            walmartOrderProcessingCheck: (0, _utilities.anyChecked)(els.orderProcessingIcon),
	            startDate: els.startDate.val(),
	            startOfOrderProcessingHours: els.timePickerHoursSelect.val(),
	            startOfOrderProcessingMinutes: els.timePickerMinSelect.val(),
	            startOfOrderProcessingPeriod: els.timePickerPeriodSelect.val(),
	            orderProcessingSelectValue: els.orderProcessingDateTimeOptionsSelect.find(":selected").val(),
	            walmartInventorySyncingCheck: (0, _utilities.anyChecked)(els.walmartInventorySyncingCheck),
	            connAuthDateTime: els.connAuthDateTime.val()
	          },
	          url: saveChannelUrl,
	          dataType: "JSON",
	          type: 'POST',
	          success: function success(data) {
	            _EditChecker2.default.setPageClean();
	            if (parId != "") {
	              var detailPageUrl = viewChannelDetailUrl + '&$&parId=' + parId + '&$&orgName=' + parName;
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = detailPageUrl;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            } else {
	              _EditChecker2.default.setPageDirty();
	              submitModalFlow.showFailureModal();
	            }
	          },
	          error: function error(data) {
	            submitModalFlow.hideAllModals();
	          }
	        });
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	}

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FamfLogic;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _submitHelpers = __webpack_require__(115);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var famfAcctNumberBlockTemplate = __webpack_require__(1328);
	
	
	var elementsPageMap = {
	  addProductBtn: '#find-rma-item',
	  addFedexAccntBtn: '.add-fedex-acct-btn2',
	  fedexAccoutsContainer: ".fedex-accounts-container",
	  fedexAccntBlock: ".fedex-acct-block",
	  fedexAccntNumber: ".fedex-acct-number",
	  smartPostAccntNumber: ".smartpost-acct-number",
	  smartPostHubIdOptions: ".smartpost-hub-id-options",
	  editFedexAccountsBtn: ".edit-fedex-accounts-btn",
	  fedexAccountsForm: "#fedex-accounts-management-form",
	  fedexAccountsDetailPage: ".fedex-accounts-detail-page",
	  hasCorrespondingSmartPost: "#ret-require-smartpost",
	  singleAcctNumHubIdDupDiv: ".single-acctNum-hubId-dup-div",
	  multipleAcctNumHBIdDupDiv: ".multiple-acctNum-hubId-dup-div",
	  singleAcctNumHubIdDupErrMsg: "#single-acctNum-hubId-dup-error",
	  multipleAcctNumHubIdDupErrMsg: "#multiple-acctNum-hubId-dup-error"
	};
	
	function FamfLogic(mainEl) {
	  var isHoneyCombUser = $(elementsPageMap.fedexAccountsDetailPage).data("is-honey-comb-user");
	
	  var self = this;
	  var elsPage = {};
	  var elsModals = {};
	
	  self.init = function () {
	    setElements();
	    bindElements();
	    requireSmartpostState();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, mainEl);
	  }
	
	  function bindElements() {
	    elsPage.addFedexAccntBtn.on("click", addAdditionalAccounts);
	    elsPage.hasCorrespondingSmartPost.on("change", requireSmartpostState);
	  }
	
	  function addAdditionalAccounts() {
	    var fedexAccountsTemplate = $(famfAcctNumberBlockTemplate);
	    var fedexAccntBlockSize = elsPage.fedexAccoutsContainer.find(".fedex-acct-block").length;
	    var fedexAccntBlockIdSize = elsPage.fedexAccoutsContainer.find(".fedex-acct-block").length + 1;
	
	    var accntNumber = fedexAccountsTemplate.find('.fedex-acct-number');
	    accntNumber.attr('name', 'fedexAccounts[' + fedexAccntBlockSize + '].cmtAccountNumber');
	    accntNumber.attr('id', 'fedex-acct-number-' + fedexAccntBlockIdSize);
	    var accntNumberHiddenId = fedexAccountsTemplate.find('.fedex-accnt-hidden-id');
	    accntNumberHiddenId.attr('name', 'fedexAccounts[' + fedexAccntBlockSize + '].cmtId');
	
	    var smartPostAccntNumber = fedexAccountsTemplate.find('.smartpost-acct-number');
	    smartPostAccntNumber.attr('name', 'fedexAccounts[' + fedexAccntBlockSize + '].cmtHubId');
	    smartPostAccntNumber.attr('id', 'smartpost-hub-id-' + fedexAccntBlockIdSize);
	    smartPostAccntNumber.select2();
	    addOptionsToSmartPostHub(smartPostAccntNumber);
	
	    elsPage.fedexAccoutsContainer.append(fedexAccountsTemplate);
	    requireSmartpostState();
	  }
	
	  function addOptionsToSmartPostHub(smartPostAccntNumber) {
	    var smartPostHubIdOptionsVar = elsPage.smartPostHubIdOptions.data('options');
	    $(smartPostHubIdOptionsVar).each(function () {
	      var option = $('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmDescription);
	      smartPostAccntNumber.append(option);
	    });
	  }
	
	  (0, _submitHelpers.bindHardSubmit)({
	    form: $(elementsPageMap.fedexAccountsForm),
	    links: $(elementsPageMap.editFedexAccountsBtn)
	  });
	
	  $(elementsPageMap.fedexAccountsForm).validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  });
	
	  $(elementsPageMap.fedexAccountsForm).on("submit", function (e) {
	    e.preventDefault();
	    var hubIdArray = [];
	    var uniqueHubIdArray = [];
	    if (mainEl.valid()) {
	      if (isHoneyCombUser === "HONEYCOMB_RMS") {
	        elsPage.singleAcctNumHubIdDupDiv.hide();
	        elsPage.multipleAcctNumHBIdDupDiv.hide();
	        for (var i = 0; i <= $("option:selected").length; i++) {
	          for (j = i + 1; j < $("option:selected").length; j++) {
	            if ($("option:selected")[i].value === $("option:selected")[j].value) {
	              if ($("input[type='text']")[i].value === $("input[type='text']")[j].value) {
	                hubIdArray.push($("option:selected")[i].value);
	              }
	            }
	          }
	        }
	        $.each(hubIdArray, function (i, el) {
	          if ($.inArray(el, uniqueHubIdArray) === -1) uniqueHubIdArray.push(el);
	        });
	        if (uniqueHubIdArray.length === 1) {
	          elsPage.singleAcctNumHubIdDupErrMsg.text(uniqueHubIdArray);
	          elsPage.singleAcctNumHubIdDupDiv.show();
	          return false;
	        } else if (uniqueHubIdArray.length > 1) {
	          elsPage.multipleAcctNumHubIdDupErrMsg.text(uniqueHubIdArray);
	          elsPage.multipleAcctNumHBIdDupDiv.show();
	          return false;
	        }
	      }
	      var submitModalFlow = new SubmitModalFlow({
	        confirmModalTitle: "Edit Fedex Accounts",
	        confirmModalBody: '<div class="q-pad-all-xl">By submitting this configuration, the service configuration information will be saved for current retailer.</div>',
	        confirmModalBtnText: "Submit",
	        onConfirmClick: function onConfirmClick() {
	          submitModalFlow.showLoadingModal();
	          var formData = $(elementsPageMap.fedexAccountsForm).serialize();
	          $.ajax({
	            url: mainEl.attr("action"),
	            type: "POST",
	            data: formData,
	            success: function success(resp) {
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = $(elementsPageMap.fedexAccountsDetailPage).data("fedex-accounts-detail-page-uri");
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            },
	            error: function error(_error) {
	              // TODO: error modal displaying from all.js file, so commenting show error modal code here!
	              //submitModalFlow.showFailureModal();
	            }
	          });
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  });
	
	  $("body").on("click", ".remove-fedex-acct-block-btn", function (e) {
	    e.preventDefault();
	    var fedexAcctBlock = $(this).closest(".fedex-acct-block");
	    fedexAcctBlock.remove();
	  });
	
	  function requireSmartpostState() {
	    var ifSmartpostReq = $(".if-smartpost-required");
	    if (elsPage.hasCorrespondingSmartPost.is(":checked")) {
	      ifSmartpostReq.show();
	    } else {
	      ifSmartpostReq.hide();
	      $(".smartpost-acct-number").val("").trigger("change.select2");
	    }
	  };
	};

/***/ },
/* 207 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  "actions": [{
	    title: "FixIt Order",
	    cls: "fixit-order",
	    icon: "hourglass",
	    disabled: true
	  }]
	};

/***/ },
/* 208 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var fixitOrderLookupFieldDropdown = exports.fixitOrderLookupFieldDropdown = [
	/*{
		title: "POS Location Number",
		value: "posLocation"
	},*/
	{
		title: "VZW Order Number",
		value: "vzOrderNumber"
	}, {
		title: "SAP Delivery Number",
		value: "sapNumber"
	},
	/*{
	  title: "Order Type",
	  value: "type"
	},*/
	{
		title: "Order Status",
		value: "status"
	}];

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FxoConfigurationWizardLogic;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var fxoCasAccountTemplate = __webpack_require__(1330);
	
	var elementsPageMap = {
	  casAccountEditContainer: ".fxo-cas-account-edit-container",
	  noCasAccountEditContainer: ".fxo-no-cas-account-edit-container",
	  noCasAccountEditContainers: ".fxo-no-cas-account-edit-containers",
	  packagingSkusEditContainer: ".fxo-packaging-skus-edit-container",
	  accumulationShipSchedEditContainer: ".fxo-acc-ship-sched-edit-container",
	
	  fxoConfigCasAddButton: ".fxo-config-cas-add-button",
	  fxoConfigCasEditButton: ".fxo-config-cas-edit-button",
	  fxoConfigCasEditText: ".fxo-config-cas-edit-text",
	  casAccountNo: ".cas-account-no",
	  casAccountType: ".cas-account-type",
	  casServiceSku: ".cas-service-sku",
	  casAccountNumberInput: ".cas-account-number-input",
	  casAccountTypeInput: ".cas-account-type-input",
	  casServiceSkuInput: ".cas-service-sku-input",
	  casAccountNoHidden: ".cas-account-no-hidden",
	  casAccountTypeHidden: ".cas-account-type-hidden",
	  casServiceSkuHidden: ".cas-service-sku-hidden",
	  casServiceSkuRow: ".cas-service-sku-row",
	  fxoReceiptTypeField: "#fxo-receipt-type-field",
	  receiptTypeConsolidatedMsg: ".receipt-type-consolidated-msg",
	  casRequiredMandatoryFields: ".cas-required-mandatory-fields",
	  containerIfNoCas: ".if-no-cas-number-container",
	  containerIfCas: ".if-cas-number-container",
	  duplicateCasRow: "#cas-account-exist-error",
	  fxoConfigCasRemoveButton: ".remove-acct",
	  fxoCasAccountExist: ".fxo-cas-account-exist"
	};
	
	function FxoConfigurationWizardLogic(mainEl) {
	  var self = this;
	  var elsPage = {};
	  var elsModals = {};
	  var casAccountCount = 0;
	
	  self.init = function () {
	    setElements();
	    bindElements();
	    hideInitial();
	  };
	
	  function hideInitial() {}
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, mainEl);
	  }
	
	  function bindElements() {
	    elsPage.fxoConfigCasAddButton.on("click", addCasAccountRowFunc);
	    elsPage.casAccountTypeInput.on("change", hideCasServiceSkuFunc);
	  }
	
	  $(document).on('click', '.remove-acct', function () {
	    var singleSkuWrapper = $(this).closest(".fxo-cas-account-wrapper");
	    singleSkuWrapper.remove();
	
	    var recordExists = mainEl.find('.fxo-cas-account-exist');
	    if (recordExists.length == 0) {
	      elsPage.noCasAccountEditContainer.show();
	    }
	  });
	
	  var hideCasServiceSkuFunc = function hideCasServiceSkuFunc() {
	    elsPage.receiptTypeConsolidatedMsg.hide();
	    if (this.value == 'Retailer Packaging') {
	      // Not able to select 'Retailer Packaging when Receipt type is Consolidated'
	      if ($("#fxo-receipt-type-field").val() != 'single_ship') {
	        elsPage.receiptTypeConsolidatedMsg.show();
	        elsPage.casAccountTypeInput.val('');
	        return false;
	      } else {
	        // hide CAS Service Sku
	        elsPage.casServiceSkuInput.val('');
	        elsPage.casServiceSkuRow.hide();
	      }
	    } else {
	      elsPage.casServiceSkuRow.show();
	      elsPage.receiptTypeConsolidatedMsg.hide();
	    }
	  };
	  var casNumber = "";
	  $(document).on('click', '.fxo-config-cas-edit-button', function () {
	    var id = this.id;
	    var div_id = "#" + id.split("_")[1];
	    var txt_id = "#txt_" + id.split("_")[1];
	    $(txt_id).css('display', 'block');
	    casNumber = $(div_id).contents().get(2).nodeValue;
	    $(div_id).contents().get(2).nodeValue = " ";
	  });
	
	  $(document).on('change keydown keypress', '.fxo-config-cas-edit-text', function (e) {
	    var enterPressed = false;
	    var tabOut = false;
	    if (e.type === 'keypress') {
	      var keycode = e.keyCode ? e.keyCode : e.which;
	      if (keycode == '13') {
	        enterPressed = true;
	      }
	    }
	    if (e.type === 'keydown') {
	      var _keycode = e.keyCode ? e.keyCode : e.which;
	      if (_keycode == '9') {
	        tabOut = true;
	      }
	    }
	    if (e.type === 'change' || enterPressed || tabOut) {
	      var txt_id = this.id;
	      var value = $("#" + txt_id).val();
	      var div_id = "#" + txt_id.split("_")[1];
	      var retailerId = document.getElementById('fxo-cas-account-retailer-id').value;
	      var ID = txt_id.split("_")[1];
	      var ccaCasAccountNumber = casNumber;
	      var editedCasAccountNo = value;
	      var duplicate = false;
	      if (editedCasAccountNo.length < 10 || editedCasAccountNo.length > 25 || !$.isNumeric(editedCasAccountNo)) {
	        $("#lbl_" + ID).text("Please enter only numbers between 10 and 25 digits");
	        $("#lbl_" + ID).css('display', 'inline-block');
	        return false;
	      } else if (ccaCasAccountNumber == editedCasAccountNo) {
	        $("#lbl_" + ID).text("CAS Account Already Exists");
	        $("#lbl_" + ID).css('display', 'inline-block');
	        duplicate = true;
	        return false;
	      } else {
	        $("#cas-account-exist-error").css('display', 'none');
	        $("#lbl_" + ID).css('display', 'none');
	        var casurl = $("#ca-account-fields").data("duplicate-url");
	        $.ajax({
	          url: casurl,
	          type: 'GET',
	          dataType: 'json',
	          data: { "casAccount": editedCasAccountNo, "retailerId": retailerId },
	          success: function success(resp) {
	            if (resp && resp.status == 'Success') {
	              $("#lbl_" + ID).text("CAS Account Already Exists");
	              $("#lbl_" + ID).css('display', 'inline-block');
	              duplicate = true;
	              return false;
	            }
	            /*else
	            {
	              $(div_id).contents().get(2).nodeValue = value;
	              $("#"+txt_id).css('display', 'none');
	              var casurl = $("#"+txt_id).data("url");
	              $.ajax({
	                  url: casurl,
	                  type: 'GET',
	                  dataType: 'json',
	                  data: {"retailerId":retailerId,"ID":ID,"ccaCasAccountNumber":ccaCasAccountNumber,"editedCasAccountNo":editedCasAccountNo},
	                  success: function(resp){
	                    if(resp && resp.status == 'Success') {
	                        $("#lbl_"+ID).css('display','none');
	                          return true;
	                        }    
	                  },    
	                  error: function(xhr,status,error) {
	                    $("#cas-server-error").html("There appears to be an error that has occurred. Please contact your customer service representative.");
	                    $("#cas-server-error").show();
	                    return false;
	                  }
	              });
	            } */
	          },
	          error: function error(xhr, status, _error) {
	            $("#cas-account-exist-error").css('display', 'none');
	            return false;
	          }
	        });
	      }
	    }
	  });
	
	  var casAccountArray = [];
	  var addCasAccountRowFunc = function addCasAccountRowFunc() {
	    elsPage.casRequiredMandatoryFields.hide();
	    /* var casServiceSkuInputFlag = true;
	    if(elsPage.casAccountTypeInput.val() != 'Retailer Packaging'  && elsPage.casServiceSkuInput.val() == '') {
	      casServiceSkuInputFlag = false;
	    } */
	    if (elsPage.casAccountNumberInput.val() != '' && elsPage.casAccountTypeInput.val() != ''
	    /* && casServiceSkuInputFlag */) {
	        var formObjName = "cmrCasAccounts";
	        var fxoCasAccountEl = $(fxoCasAccountTemplate);
	        var accountNo = fxoCasAccountEl.find(elementsPageMap.casAccountNo);
	        //accountNo.text(elsPage.casAccountNumberInput.val());
	        var accountType = fxoCasAccountEl.find(elementsPageMap.casAccountType);
	        accountType.text($(".cas-account-type-input option:selected").val());
	        var serviceSku = fxoCasAccountEl.find(elementsPageMap.casServiceSku);
	        serviceSku.text($(".cas-service-sku-input option:selected").val());
	
	        // set hidden attributesF
	        var casAccountNoHiddenVar = fxoCasAccountEl.find(elementsPageMap.casAccountNoHidden);
	        casAccountNoHiddenVar.val(elsPage.casAccountNumberInput.val());
	        casAccountNoHiddenVar.attr('name', formObjName + "[" + casAccountCount + "].ccaCasAccountnNumber");
	        var casAccountTypeHiddenVar = fxoCasAccountEl.find(elementsPageMap.casAccountTypeHidden);
	        casAccountTypeHiddenVar.val(elsPage.casAccountTypeInput.val());
	        casAccountTypeHiddenVar.attr('name', formObjName + "[" + casAccountCount + "].ccaCasAccountnType");
	        var casServiceSkuHiddenVar = fxoCasAccountEl.find(elementsPageMap.casServiceSkuHidden);
	        casServiceSkuHiddenVar.val(elsPage.casServiceSkuInput.val());
	        casServiceSkuHiddenVar.attr('name', formObjName + "[" + casAccountCount + "].ccaCasServiceSku");
	
	        hasDuplicates(elsPage.casAccountNumberInput.val());
	
	        if (hasDupCasAccount === true) {
	          elsPage.duplicateCasRow.show();
	        } else {
	          elsPage.duplicateCasRow.hide();
	          casAccountArray.push(elsPage.casAccountNumberInput.val());
	          elsPage.casAccountEditContainer.append(fxoCasAccountEl);
	          casAccountCount = casAccountCount + 1;
	          elsPage.noCasAccountEditContainer.hide();
	          elsPage.noCasAccountEditContainers.hide();
	          elsPage.casAccountEditContainer.show();
	          //emptyCasAccountDetail();
	          elsPage.containerIfCas.show();
	          elsPage.containerIfNoCas.hide();
	        }
	      } else {
	      elsPage.casRequiredMandatoryFields.show();
	    }
	  };
	
	  var hasDupCasAccount = false;
	  function hasDuplicates(accountnumber) {
	    for (var index = 0; index < casAccountArray.length; index++) {
	      if (accountnumber === casAccountArray[index]) {
	        hasDupCasAccount = true;
	        return hasDupCasAccount;
	      } else {
	        hasDupCasAccount = false;
	      }
	    }
	  }
	
	  function emptyCasAccountDetail() {
	    elsPage.casAccountNumberInput.val('');
	    elsPage.casAccountTypeInput.val(null).trigger('change');
	    elsPage.casServiceSkuInput.val(null).trigger('change');
	  }
	
	  function removeCasAccountRow() {
	    var singleCasRowWrapper = $(this).closest(".fxo-cas-account-wrapper");
	    singleCasRowWrapper.remove();
	  }
	}

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FxoReceivingHomePageLogic;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var modalHtml = __webpack_require__(11);
	var ctStateModalHtml = __webpack_require__(1334);
	__webpack_require__(179);
	
	function FxoReceivingHomePageLogic(mainEl) {
	  var self = this;
	  var fxoSearchRetailerNameFm = $('#fxo-search-retailer-name');
	  var fxoSearchRetailerNameHidden = $('.fxo-search-retailer-name-hidden');
	  var fxoContinueSubmitCtModal = $('.fxo-continue-submit-ct-modal');
	
	  self.init = function () {
	    bindElements();
	    checkCtStateCondition();
	    fxoContinueSubmitCtModal.val('');
	  };
	
	  function bindElements() {
	    fxoSearchRetailerNameFm.on("click", '.continue-att-return', continueAttBtnClick);
	  }
	
	  var ctStateModal = $((0, _render2.default)(modalHtml, {
	    modalDialogClass: 'q-modal-dialog-500',
	    title: 'Equipment Confirmation',
	    leftAlignTitle: true,
	    body: ctStateModalHtml,
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide cancel-rtn-btn">Cancel Return</a> <a href="#" class="base-btn purple-btn continue-att-return">Continue AT&T Return</a>'
	  }));
	  fxoSearchRetailerNameFm.append(ctStateModal);
	
	  function checkCtStateCondition() {
	    var checkCondition = fxoSearchRetailerNameFm.data('ct-state-condition-ret-name');
	    if (checkCondition != '') {
	      fxoSearchRetailerNameHidden.val(checkCondition);
	      ctStateModal.modal("show");
	    } else {
	      ctStateModal.modal("hide");
	    }
	  }
	
	  function continueAttBtnClick() {
	    fxoContinueSubmitCtModal.val('true');
	    fxoSearchRetailerNameFm.submit();
	  }
	}

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FxoReceivingScreenLogic;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _select2able = __webpack_require__(22);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var modalHtml = __webpack_require__(11);
	var mainModalHtml = __webpack_require__(1333);
	var receiptExistForBanNoHtml = __webpack_require__(1337);
	var updateBoxQuantityModalBody = __webpack_require__(1338);
	var updatePolyBagsQuantityModalBody = __webpack_require__(1339);
	var warningModalBodyFor10BoxBody = __webpack_require__(1340);
	var warningModalBodyFor10PolyBagBody = __webpack_require__(1341);
	var warningModalBodyFor30BoxBody = __webpack_require__(301);
	var warningModalBodyFor30PolyBagBody = __webpack_require__(301);
	var invalidEntryModalBodyForSerialNumberHtml = __webpack_require__(1332);
	
	var packingSkuListHtml = __webpack_require__(1335);
	var packingSkuOptionHtml = __webpack_require__(1336);
	
	__webpack_require__(179);
	var fxoReceivingAddProductTemplate = __webpack_require__(1331);
	
	function FxoReceivingScreenLogic(mainEl) {
	  var self = this;
	  var elsPage = {};
	  var elsModals = {};
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  var totalItemsOnPage = mainEl.data('total-items') || 0;
	  var addBoxWarnLimit = mainEl.data('add-box-warning-total') || 10;
	  var addBoxWarnDisplay = mainEl.data('add-box-warning-display') || 'ten';
	  var addPolyBagWarnLimit = mainEl.data('add-poly-bag-warning-total') || 5;
	  var addPolyBagWarnDisplay = mainEl.data('add-poly-bag-warning-display') || 'five';
	  var addBoxMaxLimit = mainEl.data('add-box-max-total') || 30;
	  var addPolyBagMaxLimit = mainEl.data('add-poly-bag-max-total') || 30;
	  var addBoxMaxDisplay = mainEl.data('add-box-max-display') || 'thirty';
	  var addPolyBagMaxDisplay = mainEl.data('add-poly-bag-max-display') || 'thirty';
	
	  self.init = function () {
	    bindElements();
	    hideInitial();
	    chooseInputPlaceholder();
	    showATTOptionsDiv();
	
	    //This needs to be delayed to allow select2 to initialize
	    setTimeout(function () {
	      setItemsInitialState();
	    }, 10);
	  };
	
	  function hideInitial() {
	    $("#ban-order-number-div").hide();
	    $("#last-house-zip-div").hide();
	    $("#last-house-zip-serial-div").hide();
	
	    hideAddBoxValidationPills(mainEl);
	  }
	
	  function showATTOptionsDiv() {
	    var searchByValue = $("#customer-search-by").val();
	    var attOptionsData = mainEl.data('att-options-json-object');
	    if (searchByValue == 'ACCOUNT_SEARCH') {
	      $("#single-search-value").val("");
	      $("#ban-order-number-div").show();
	      $("#last-house-zip-div").hide();
	      $("#last-house-zip-serial-div").hide();
	      var accSearchOptions = attOptionsData.ACCOUNT_SEARCH;
	      $(accSearchOptions).each(function () {
	        if (this.cdmDescription == 'Y') {
	          $("#single-search-value").prop('required', true);
	        } else {
	          $("#single-search-value").prop('required', false);
	        }
	        $("#single-search-value").attr("placeholder", this.cdmMeaning);
	      });
	    } else if (searchByValue == 'ORDER_SEARCH') {
	      $("#single-search-value").val("");
	      $("#ban-order-number-div").show();
	      $("#last-house-zip-div").hide();
	      $("#last-house-zip-serial-div").hide();
	      var orderSearchOptions = attOptionsData.ORDER_SEARCH;
	      $(orderSearchOptions).each(function () {
	        if (this.cdmDescription == 'Y') {
	          $("#single-search-value").prop('required', true);
	        } else {
	          $("#single-search-value").prop('required', false);
	        }
	        $("#single-search-value").attr("placeholder", this.cdmMeaning);
	      });
	    } else if (searchByValue == 'HOUSE_SEARCH') {
	      $("#first-search-value").val("");
	      $("#second-search-value").val("");
	      $("#third-search-value").val("");
	      $("#last-house-zip-div").show();
	      $("#ban-order-number-div").hide();
	      $("#last-house-zip-serial-div").hide();
	      var houseSearchOptions = attOptionsData.HOUSE_SEARCH;
	      $(houseSearchOptions).each(function () {
	        if (this.cdmValue == 'lastName') {
	          if (this.cdmDescription == 'Y') {
	            $("#first-search-value").prop('required', true);
	          } else {
	            $("#first-search-value").prop('required', false);
	          }
	          $("#first-search-value").attr("placeholder", this.cdmMeaning);
	        } else if (this.cdmValue == 'houseNumber') {
	          if (this.cdmDescription == 'Y') {
	            $("#second-search-value").prop('required', true);
	          } else {
	            $("#second-search-value").prop('required', false);
	          }
	          $("#second-search-value").attr("placeholder", this.cdmMeaning);
	        } else {
	          if (this.cdmDescription == 'Y') {
	            $("#third-search-value").prop('required', true);
	          } else {
	            $("#third-search-value").prop('required', false);
	          }
	          $("#third-search-value").attr("placeholder", this.cdmMeaning);
	        }
	      });
	    } else if (searchByValue == 'HOUSE_AND_SERIAL_SEARCH') {
	      $("#one-search-value").val("");
	      $("#two-search-value").val("");
	      $("#three-search-value").val("");
	      $("#four-search-value").val("");
	      $("#last-house-zip-serial-div").show();
	      $("#last-house-zip-div").hide();
	      $("#ban-order-number-div").hide();
	      var houseSerialSearchOptions = attOptionsData.HOUSE_AND_SERIAL_SEARCH;
	      $(houseSerialSearchOptions).each(function () {
	        if (this.cdmValue == 'lastName') {
	          if (this.cdmDescription == 'Y') {
	            $("#one-search-value").prop('required', true);
	          } else {
	            $("#one-search-value").prop('required', false);
	          }
	          $("#one-search-value").attr("placeholder", this.cdmMeaning);
	        } else if (this.cdmValue == 'houseNumber') {
	          if (this.cdmDescription == 'Y') {
	            $("#two-search-value").prop('required', true);
	          } else {
	            $("#two-search-value").prop('required', false);
	          }
	          $("#two-search-value").attr("placeholder", this.cdmMeaning);
	        } else if (this.cdmValue == 'zipCode') {
	          if (this.cdmDescription == 'Y') {
	            $("#three-search-value").prop('required', true);
	          } else {
	            $("#three-search-value").prop('required', false);
	          }
	          $("#three-search-value").attr("placeholder", this.cdmMeaning);
	        } else {
	          if (this.cdmDescription == 'Y') {
	            $("#four-search-value").prop('required', true);
	          } else {
	            $("#four-search-value").prop('required', false);
	          }
	          $("#four-search-value").attr("placeholder", this.cdmMeaning);
	        }
	      });
	    }
	  }
	
	  function initComponents() {
	    (0, _select2able.instantiateSelect2)($('.select2-select'));
	    (0, _instantiateSwitchery.instantiateSwitchery)($('.js-switchery'));
	    (0, _select2able.bindDocSelect2CloseRefocus)();
	    (0, _select2able.bindSelect2OnTypeForDesktop)();
	    setItemsInitialState();
	  }
	
	  //bind only the fxo-receiving-submit-screen.jsp elements here.
	  function bindElements() {
	    $("#cutomer-serach-by").change(chooseInputPlaceholder);
	    $(".retrieve-customer-return").click(searchCustomerReturn);
	    $(".customer-serach-value").keyup(searchCustomerReturnOnEnter);
	
	    EditChecker.bindNavigation();
	    EditChecker.bindChangeListener("#fxo-return-rma-form");
	    EditChecker.bindCancelButton("#fxo-rma-return-cancel");
	    EditChecker.bindChangeListener("#fxo-search-customer-details-form");
	
	    // AT&T: serial number input search
	    // on click event for serial plus number text button
	    parentForm.on("click", '.prod-ser-num-search', prodSerNumSearch);
	    if ($("#fxo-receiving-screen").data("fxo-scan-remove-ampersand") == true) {
	      parentForm.on("keyup keypress change", '.product-serial-number-input', _general.removeAmpersand);
	      parentForm.on("keyup keypress change", '#single-search-value', _general.removeAmpersand);
	      parentForm.on("keyup keypress change", '#four-search-value', _general.removeAmpersand);
	    }
	    // item search by sku from model popup
	    parentForm.on("click", '.sku_upc_section_search', skuUpcSectionSearchFun);
	    parentForm.on("click", '.sku_upc_btn', showSkuUpcSection);
	    parentForm.on("click", '.model_number_btn', showModelNumSection);
	    parentForm.on("click", '#submit-fox-returns-btn', validateAndSubmit);
	    parentForm.on("change", '.rma-receiving-product-checkbox', selectItemChange);
	    parentForm.on("click", '.view-item-image-btn', getItemImages);
	    parentForm.on("click", '.model-add-return-item-btn', modelAddReturnItemFun);
	    parentForm.on("change", '#customer-search-by', showATTOptionsDiv);
	    // manual check in button click event
	    parentForm.on("click", '.manual-check-in-btn', manualCheckinClick);
	    parentForm.on("click", '.go-to-return-lookup', goToReturnLookup);
	
	    parentForm.on("click", '.update-boxes-btn', showUpdateBoxQuantityModal);
	    parentForm.on("click", '.update-poly-bags-btn', showUpdatePolyBagQuantityModal);
	
	    parentForm.on("change", '#number-of-poly-bags', showWarningsForPolyBagsQuantityExceeds);
	    parentForm.on("click", '.update-boxes-btn-on-modal', addMoreShipmentBoxes);
	    parentForm.on("click", '.update-poly-bags-btn-on-modal', addMoreShipmentPolyBags);
	    parentForm.on("click", '.remove-box-btn', removeBox);
	    parentForm.on("click", '.remove-poly-bag-btn', removePolyBag);
	
	    parentForm.on("click", '.edit-max-box-quantity-on-modal', showUpdateBoxQuantityModal);
	    parentForm.on("click", '.edit-max-poly-bag-quantity-on-modal', showUpdatePolyBagQuantityModal);
	
	    parentForm.on("change", '.select-ship-boxes', validateBoxSelection);
	    parentForm.on("change", '.select-ship-poly-bags', validatePolyBagSelection);
	    parentForm.on("keyup keypress change", '.quantity-in-box-input', _general.removeNonDigit);
	    parentForm.on("keyup keypress change", '.quantity-in-poly-bag-input', _general.removeNonDigit);
	    parentForm.on("click", '.go-to-serial-number', goToSerialNumber);
	    parentForm.on("click", '.cancel-polyBag', cancelPolybagCount);
	    parentForm.on("click", '.close-polyBag .top-close-btn', cancelPolybagCount);
	
	    parentForm.on("click", '.cancel-box', cancelBoxCount);
	    parentForm.on("click", '.close-box .top-close-btn', cancelBoxCount);
	  }
	
	  var mainModal = $((0, _render2.default)(modalHtml, {
	    title: 'Serial Number Not Found',
	    leftAlignTitle: true,
	    body: mainModalHtml,
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>'
	  }));
	
	  var receiptExistModal = $((0, _render2.default)(modalHtml, {
	    title: 'Receipt Already Exist',
	    leftAlignTitle: true,
	    body: receiptExistForBanNoHtml,
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide go-to-return-lookup">Go to Return Lookup</a> <a href="#" class="base-btn purple-btn modal-auto-hide">Continue</a>'
	  }));
	
	  var updateBoxQuantityModal = $((0, _render2.default)(modalHtml, {
	    modalDialogClass: 'q-modal-dialog-500 close-box',
	    title: 'How many boxes?',
	    leftAlignTitle: true,
	    body: updateBoxQuantityModalBody,
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide cancel-box">Cancel</a><a href="#" class="base-btn purple-btn update-boxes-btn-on-modal">Update Boxes</a>'
	  }));
	
	  var updatePolyBagQuantityModal = $((0, _render2.default)(modalHtml, {
	    modalDialogClass: 'q-modal-dialog-500 close-polyBag',
	    title: 'How many poly bags?',
	    leftAlignTitle: true,
	    body: updatePolyBagsQuantityModalBody,
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide cancel-polyBag">Cancel</a><a href="#" class="base-btn purple-btn update-poly-bags-btn-on-modal">Update PolyBags</a>'
	  }));
	
	  var warningModalBodyFor10Modal = $((0, _render2.default)(modalHtml, {
	    modalDialogClass: 'q-modal-dialog-500',
	    title: 'Box Quantity Alert',
	    leftAlignTitle: true,
	    body: (0, _render2.default)(warningModalBodyFor10BoxBody, {
	      warnDisplay: addBoxWarnDisplay,
	      maxDisplay: addBoxMaxDisplay
	    }),
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn modal-auto-hide">Continue</a>'
	  }));
	
	  var warningModalBodyFor30Modal = $((0, _render2.default)(modalHtml, {
	    modalDialogClass: 'q-modal-dialog-500',
	    title: 'Maximum Box Quantity',
	    leftAlignTitle: true,
	    body: (0, _render2.default)(warningModalBodyFor30BoxBody, {
	      maxDisplay: addBoxMaxDisplay
	    }),
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-max-box-quantity-on-modal">Edit Box Quantity</a>'
	  }));
	
	  var invalidEntryModalForSerialNumber = $((0, _render2.default)(modalHtml, {
	    modalDialogClass: '.q-modal-dialog-800',
	    title: 'Invalid Entry',
	    leftAlignTitle: true,
	    body: invalidEntryModalBodyForSerialNumberHtml,
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn purple-btn modal-auto-hide go-to-serial-number">Okay</a>'
	  }));
	
	  $('#fxo-receiving-screen').append(mainModal);
	  $('#fxo-receiving-screen').append(receiptExistModal, updateBoxQuantityModal, updatePolyBagQuantityModal, warningModalBodyFor10Modal, warningModalBodyFor30Modal, invalidEntryModalForSerialNumber);
	  var prodSerNumSearchBtn = $('.prod-ser-num-search');
	  var fxoReturnRmaForm = $('#fxo-return-rma-form');
	  var parentForm = $('#fxo-receiving-screen');
	  var skuUpcBtnFromModel = $('.sku_upc_btn');
	  var skuUpcBtnTxt = $('.sku_upc_btn_txt');
	  var modelNumBtn = $('.model_number_btn');
	  var modelNumBtnTxt = $('.model_num_btn_txt');
	  var skuUpcSection = $('.sku_upc_section');
	  var skuUpcSectionPanel = $('.sku_upc_section_panel');
	  var skuUpcSectionSearchInput = $('.sku_upc_section_search_input');
	  var modelNumSection = $('.model_number_section');
	  var modelNumSectionPanel = $('.model_number_section_panel');
	  var modelNumberSectionSearch = $('.model_number_section_search');
	  var modelNumberSectionSearchInput = $('.model_number_section_search_input');
	  var serialSearchModalForm = $('#serial-search-modal-form');
	  var skuAddProductsContainer = $(".sku-add-products-container");
	  var modelAddProductsContainer = $(".model-add-products-container");
	  var modelAddProductErr = $('.model-add-product-err');
	  var skuAddProductErr = $('.sku-add-product-err');
	  var manualCheckinSection = $('.manual-check-in-section');
	  var fxoManualCheckinCustomMsg = $('.fxo-manual-checkin-custom-msg');
	  var fxoNoOfBoxInput = $("#number-of-boxes");
	  var fxoNoOfPolyBagInput = $("#number-of-poly-bags");
	  var expectedReturnQty = $("#fxo-receiving-screen").data("extected-return-qty");
	  var retailerReturnConfig = $("#fxo-receiving-screen").data("retailer-return-config");
	  var productSerialNumberInputErrorDiv = $('#product-serial-number-input-error-div');
	  // AT&T: first call
	  // serial number serach for AT&T
	  function prodSerNumSearch(e) {
	
	    e.preventDefault();
	    var serialNumberValue = $('.product-serial-number-input').val().trim();
	    if (serialNumberValue == '') {
	      $('#product-serial-number-input-error-div').show();
	    } else {
	      if (serialNumberValue.indexOf(',') > -1 || serialNumberValue.indexOf('.') > -1 || serialNumberValue.indexOf(' ') > -1 || serialNumberValue.length > 25) {
	        showInvalidSkuModal();
	      } else {
	        searchItmSku(serialNumberValue, e);
	      }
	    }
	  }
	
	  function cancelPolybagCount() {
	    $("#number-of-poly-bags").val($("#number-of-poly-bags-hidden").val());
	  }
	
	  function cancelBoxCount() {
	    $("#number-of-boxes").val($("#number-of-boxes-input-hidden").val());
	  }
	
	  function searchItmSku(serialVal, e) {
	    e.preventDefault();
	    var itmfound = false;
	    $.ajax({
	      url: mainEl.data('serial-search-sku-url'),
	      type: 'POST',
	      dataType: 'json',
	      data: { 'sku': serialVal },
	      success: function success(resp) {
	        var itemData = resp.data;
	        if (itemData && itemData != null && itemData != 'null') {
	          showInvalidSkuModal();
	        } else {
	          sucessfulSearchItmSkuValidSerial(e);
	        }
	      },
	      error: function error(_error) {
	        errorSearchItmSku();
	      }
	    });
	    return itmfound;
	  }
	
	  function showInvalidSkuModal() {
	    submitModalFlow.hideAllModals();
	    invalidEntryModalForSerialNumber.modal('show');
	  }
	  // AT&T: search further after a valid serial number no commas etc
	  function sucessfulSearchItmSkuValidSerial(e) {
	    productSerialNumberInputErrorDiv.hide();
	    submitModalFlow.showLoadingModal();
	    if ($('.product-serial-number-input').val().toUpperCase() === "UNSCANNABLE") {
	      $('.product-serial-number-input').val("UNSCANNABLE");
	      submitModalFlow.hideAllModals();
	      mainModal.modal("show");
	      showSkuUpcSection();
	    } else {
	      serialNumberReceiptValidation(e);
	    }
	  }
	
	  function errorSearchItmSku() {
	    submitModalFlow.showFailureModal();
	  }
	
	  var serialNumberValidated = function serialNumberValidated() {
	    var serialNumberInput = $('.product-serial-number-input').val();
	    var serialNumberValidationFlag = false;
	    $.each($(".fxo-loopable-item-container"), function (index, itemDiv) {
	      if ($(itemDiv).find('.serial-receipts' + index).val() == serialNumberInput) {
	        submitModalFlow.hideAllModals();
	        $('.serial-number-validated-msg' + index).show();
	        $(itemDiv).find('.serialNumberInput' + index).val(serialNumberInput);
	        $(itemDiv).find('.serialNumberInput' + index).attr('disabled', 'disabled');
	        $(itemDiv).find('.rma-receiving-product-checkbox').prop('checked', true);
	        // remove disable of item checkbox on serial number match
	        $(itemDiv).find('.rma-receiving-product-checkbox').removeAttr('disabled');
	        $(itemDiv).find(".rma-receiving-product-checkbox").trigger("change");
	        serialNumberValidationFlag = true;
	      }
	    });
	    return serialNumberValidationFlag;
	  };
	
	  // From modal, SKU/UPC search button event
	  function showSkuUpcSection() {
	    skuUpcSection.show();
	    skuUpcBtnFromModel.addClass('modal-link-active');
	    modelNumBtnTxt.addClass('link-color');
	    modelNumBtn.removeClass('modal-link-active');
	    skuUpcBtnTxt.removeClass('link-color');
	    skuUpcSectionPanel.hide();
	    modelNumSection.hide();
	    skuAddProductErr.hide();
	  }
	
	  function showModelNumSection() {
	    modelNumSection.show();
	    modelNumBtn.addClass('modal-link-active');
	    skuUpcBtnTxt.addClass('link-color');
	    skuUpcBtnFromModel.removeClass('modal-link-active');
	    modelNumBtnTxt.removeClass('link-color');
	    modelNumSectionPanel.hide();
	    skuUpcSection.hide();
	    modelAddProductErr.hide();
	  }
	
	  function handleNoSelectionErrorDisplay(itemSelected) {
	    if (itemSelected) {
	      $(".fxo-return-empty-selection-error-message").hide();
	    } else {
	      $(".fxo-return-empty-selection-error-message").show();
	    }
	  }
	
	  function handleNotAllBoxesUsedErrorDisplay(allBoxesUsed) {
	    if (allBoxesUsed) {
	      $(".fxo-return-not-all-boxes-used-error-message").hide();
	    } else {
	      $(".fxo-return-not-all-boxes-used-error-message").show();
	    }
	  }
	
	  function handleNotAllPolyBagsUsedErrorDisplay(allPolyBagsUsed) {
	    if (allPolyBagsUsed) {
	      $(".fxo-return-not-all-poly-bags-used-error-message").hide();
	    } else {
	      $(".fxo-return-not-all-poly-bags-used-error-message").show();
	    }
	  }
	
	  function handleQtExceedErrorDisplay(allowedQty) {
	    if (allowedQty) {
	      $(".fxo-return-qty-exceed-error-message").hide();
	    } else {
	      $(".fxo-return-qty-exceed-error-message").show();
	    }
	  }
	
	  function allocateOneBoxPerProduct() {
	    var noOfBoxes = $(".rma-receiving-product-checkbox:checked").length;
	    if (noOfBoxes > 0) {
	      var boxNo = 1;
	      $.each($(".fxo-loopable-item-container"), function (i, v) {
	        var itemCheckbox = $(v).find(".rma-receiving-product-checkbox");
	        if (itemCheckbox.is(":checked")) {
	          $(v).find(".boxNumber").val(boxNo);
	          $(v).find(".box-number-txt").text(boxNo + ' of ' + noOfBoxes);
	          boxNo++;
	        } else {
	          $(v).find(".boxNumber").val('');
	          $(v).find(".box-number-txt").text('');
	        }
	      });
	    } else {
	      $(".box-number-txt").text('');
	    }
	  }
	  function allocateOnePolyBagPerProduct() {
	    var noOfPolyBags = $(".rma-receiving-product-checkbox:checked").length;
	    if (noOfPolyBags > 0) {
	      var polyBagNo = 1;
	      $.each($(".fxo-loopable-item-container"), function (i, v) {
	        var itemCheckbox = $(v).find(".rma-receiving-product-checkbox");
	        if (itemCheckbox.is(":checked")) {
	          $(v).find(".polyBagNumber").val(polyBagNo);
	          $(v).find(".poly-bag-number-txt").text(polyBagNo + ' of ' + noOfPolyBags);
	          polyBagNo++;
	        } else {
	          $(v).find(".polyBagNumber").val('');
	          $(v).find(".poly-bag-number-txt").text('');
	        }
	      });
	    } else {
	      $(".poly-bag-number-txt").text('');
	    }
	  }
	
	  function showUpdateBoxQuantityModal() {
	    hideAllBoxModals();
	
	    var modalErrEl = updateBoxQuantityModal.find(".add-box-modal-error");
	    modalErrEl.html("");
	    modalErrEl.hide();
	    $("#number-of-boxes-input-hidden").val(fxoNoOfBoxInput.val());
	    updateBoxQuantityModal.modal('show');
	  }
	
	  function showUpdatePolyBagQuantityModal() {
	    hideAllPolyBagModals();
	    var modalwarnEl = updatePolyBagQuantityModal.find(".add-poly-bag-modal-error");
	    modalwarnEl.html("");
	    modalwarnEl.hide();
	    $("#number-of-poly-bags-hidden").val(fxoNoOfPolyBagInput.val());
	    updatePolyBagQuantityModal.modal('show');
	  }
	
	  function showWarningsForPolyBagsQuantityExceeds() {
	    var noOfPolyBags = fxoNoOfPolyBagInput.val();
	    if (retailerReturnConfig != 'defaultItemReturn') {
	      var modalwarnEl = updatePolyBagQuantityModal.find(".add-poly-bag-modal-error");
	      modalwarnEl.hide();
	      modalwarnEl.html("You have requested more poly bags than product quantity.  Please confirm poly bag count.  Use as few poly bags as possible.");
	      if (noOfPolyBags > totalItemsOnPage) {
	        modalwarnEl.show();
	      } else {
	        modalwarnEl.hide();
	      }
	    } else {
	      var _modalwarnEl = updatePolyBagQuantityModal.find(".add-poly-bag-modal-error");
	      _modalwarnEl.hide();
	      _modalwarnEl.html("Use as few poly bags as possible.  Select Update Quantity if this amount is correct, or reduce quantity as needed then select Update Quantity ");
	      if (noOfPolyBags > addPolyBagWarnLimit) {
	        _modalwarnEl.show();
	      } else _modalwarnEl.hide();
	    }
	  }
	
	  function updateShipmentBoxesForDefaultItems() {
	    var requstedNoOfBoxes = fxoNoOfBoxInput.val();
	    var curNoOfBoxes = $(".fxo-loopable-item-container").length;
	    if (requstedNoOfBoxes > curNoOfBoxes) {
	      for (var i = curNoOfBoxes + 1; i <= requstedNoOfBoxes; i++) {
	        var newBoxDiv = $("#fxo-loopable-item-container").clone();
	        newBoxDiv.find(".quantity-in-box-input").val('');
	        newBoxDiv.find(".boxNumber").val('');
	        newBoxDiv.find(".box-number-txt").text('');
	        $("#returnable-items-container").append(newBoxDiv);
	        newBoxDiv.find(".remove-box-btn-div").show();
	      }
	    } else if (requstedNoOfBoxes < curNoOfBoxes && curNoOfBoxes > 1) {
	      var curBoxes = $(".fxo-loopable-item-container");
	      var boxesTobeRemoved = curNoOfBoxes - requstedNoOfBoxes;
	      for (var i = curNoOfBoxes - 1; i >= requstedNoOfBoxes; i--) {
	        curBoxes[i].remove();
	      }
	    }
	    renameClonedReceiptInputNamesForDataBinding();
	    allocateOneBoxPerProduct();
	  }
	
	  function updateShipmentPolyBagsForDefaultItems() {
	    var requstedNoOfPolyBags = fxoNoOfPolyBagInput.val();
	    var curNoOfPolyBags = $(".fxo-loopable-item-container").length;
	    if (requstedNoOfPolyBags > curNoOfPolyBags) {
	      for (var i = curNoOfPolyBags + 1; i <= requstedNoOfPolyBags; i++) {
	        var newPolyBagDiv = $("#fxo-loopable-item-container").clone();
	        newPolyBagDiv.find(".quantity-in-poly-bag-input").val('');
	        newPolyBagDiv.find(".polyBagNumber").val('');
	        newPolyBagDiv.find(".poly-bag-number-txt").text('');
	        $("#returnable-items-container").append(newPolyBagDiv);
	        newPolyBagDiv.find(".remove-poly-bag-btn-div").show();
	      }
	    } else if (requstedNoOfPolyBags < curNoOfPolyBags && curNoOfPolyBags > 1) {
	      var curPolyBags = $(".fxo-loopable-item-container");
	      var polyBagsTobeRemoved = curNoOfPolyBags - requstedNoOfPolyBags;
	      for (var i = curNoOfPolyBags - 1; i >= requstedNoOfPolyBags; i--) {
	        curPolyBags[i].remove();
	      }
	    }
	    renameClonedReceiptInputNamesForDataBinding();
	    allocateOnePolyBagPerProduct();
	  }
	
	  function updateShipmentPolyBagsForProductCatalogue() {
	    var requstedNoOfPolyBags = fxoNoOfPolyBagInput.val();
	    var curNoOfPolyBags = $(".fxo-loopable-item-container").length;
	    if (requstedNoOfPolyBags == curNoOfPolyBags) {
	      $(".additional-item-div").show();
	      $(".additional-item-div .remove-poly-bag-btn-div").show();
	    } else if (requstedNoOfPolyBags > curNoOfPolyBags) {
	      $(".additional-item-div").show();
	      $(".additional-item-div .remove-poly-bag-btn-div").show();
	      for (var i = curNoOfPolyBags + 1; i <= requstedNoOfPolyBags; i++) {
	
	        var newPolyBagDiv = $(".fxo-loopable-item-container:last").clone();
	        newPolyBagDiv.find(".select2").remove();
	        newPolyBagDiv.find("select").select2();
	        $(".additional-item-div").append(newPolyBagDiv);
	        newPolyBagDiv.find(".remove-poly-bag-btn-div").show();
	
	        lineItemIndexing();
	      }
	    } else if (requstedNoOfPolyBags < curNoOfPolyBags && curNoOfPolyBags > 1) {
	      var curPolyBags = $(".fxo-loopable-item-container");
	      var polyBagsTobeRemoved = curNoOfPolyBags - requstedNoOfPolyBags;
	      for (var i = curNoOfPolyBags - 1; i >= requstedNoOfPolyBags; i--) {
	        if (i != totalItemsOnPage && !i < totalItemsOnPage) {
	          curPolyBags[i].remove();
	        }
	        if (i == totalItemsOnPage) {
	          document.getElementById(curPolyBags[i].parentElement.id).style.display = "none";
	          break;
	        }
	      }
	    }
	    renameClonedReceiptInputNamesForDataBinding();
	    allocateOnePolyBagPerProduct();
	  }
	
	  function removeBox() {
	    $(this).closest(".fxo-loopable-item-container").remove();
	    renameClonedReceiptInputNamesForDataBinding();
	    allocateOneBoxPerProduct();
	    fxoNoOfBoxInput.val(fxoNoOfBoxInput.val() - 1);
	    var curNoOfBoxes = $(".fxo-loopable-item-container").length;
	    updateBoxPackingSkuDropdowns(curNoOfBoxes);
	  }
	
	  function removePolyBag() {
	    $(".fxo-return-not-all-poly-bags-used-error-message").hide();
	    var additionalItems = $(".additional-item-div .fxo-loopable-item-container").length;
	    if (additionalItems == 1) {
	      document.getElementById("additional-item-div-id").style.display = "none";
	    } else {
	      $(this).closest(".fxo-loopable-item-container").remove();
	    }
	    renameClonedReceiptInputNamesForDataBinding();
	    allocateOnePolyBagPerProduct();
	    fxoNoOfPolyBagInput.val(fxoNoOfPolyBagInput.val() - 1);
	    var curNoOfPolyBags = $(".fxo-loopable-item-container").length;
	
	    //if(retailerReturnConfig != 'defaultItemReturn'){  // removed if condition to apply indexing for default flwo as well
	    lineItemIndexing();
	    var noOfPolyBags = fxoNoOfPolyBagInput.val();
	    $(".select-ship-poly-bags").empty().append('<option value="">Select PolyBag</option>');
	    for (var i = 1; i <= noOfPolyBags; i++) {
	      $(".select-ship-poly-bags").append('<option value="' + i + '">' + i + ' of ' + noOfPolyBags + '</option>');
	    }
	    //}
	  }
	
	  function lineItemIndexing() {
	    //this will add indexes Explicitly for all line items including additional line item(checkbox, dropdown list & poly bag qty input in each line item and 14 hidden elements)
	    var hiddenRecItemSkuName = 0;
	    $(".hiddenRecItemSku").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecItemSkuName++ + "].recItmSku");
	    });
	    var hiddenRecItemSkuId = 0;
	    $(".hiddenRecItemSku").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecItemSkuId++ + "].recItmSku");
	    });
	
	    var hiddenRecItmUpcName = 0;
	    $(".hiddenRecItmUpc").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecItmUpcName++ + "].recItmUpc");
	    });
	    var hiddenRecItmUpcId = 0;
	    $(".hiddenRecItmUpc").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecItmUpcId++ + "].recItmUpc");
	    });
	
	    var hiddenRecProductDescriptionName = 0;
	    $(".hiddenRecProductDescription").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecProductDescriptionName++ + "].recProductDescription");
	    });
	    var hiddenRecProductDescriptionId = 0;
	    $(".hiddenRecProductDescription").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecProductDescriptionId++ + "].recProductDescription");
	    });
	
	    var hiddenRecCostName = 0;
	    $(".hiddenRecCost").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecCostName++ + "].recCost");
	    });
	    var hiddenRecCostId = 0;
	    $(".hiddenRecCost").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecCostId++ + "].recCost");
	    });
	
	    var hiddenRecRetailCostName = 0;
	    $(".hiddenRecRetailCost").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecRetailCostName++ + "].recRetailCost");
	    });
	    var hiddenRecRetailCostId = 0;
	    $(".hiddenRecRetailCost").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecRetailCostId++ + "].recRetailCost");
	    });
	
	    var hiddenRecWeightName = 0;
	    $(".hiddenRecWeight").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecWeightName++ + "].recWeight");
	    });
	    var hiddenRecWeightId = 0;
	    $(".hiddenRecWeight").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecWeightId++ + "].recWeight");
	    });
	
	    var hiddenRecOrderNumberName = 0;
	    $(".hiddenRecOrderNumber").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecOrderNumberName++ + "].recOrderNumber");
	    });
	    var hiddenRecOrderNumberId = 0;
	    $(".hiddenRecOrderNumber").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecOrderNumberId++ + "].recOrderNumber");
	    });
	
	    var hiddenRecRmaOrderNumberName = 0;
	    $(".hiddenRecRmaOrderNumber").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecRmaOrderNumberName++ + "].recRmaOrderNumber");
	    });
	    var hiddenRecRmaOrderNumberId = 0;
	    $(".hiddenRecRmaOrderNumber").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecRmaOrderNumberId++ + "].recRmaOrderNumber");
	    });
	
	    var hiddenRecRmaOrderDateName = 0;
	    $(".hiddenRecRmaOrderDate").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecRmaOrderDateName++ + "].recRmaOrderDate");
	    });
	    var hiddenRecRmaOrderDateId = 0;
	    $(".hiddenRecRmaOrderDate").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecRmaOrderDateId++ + "].recRmaOrderDate");
	    });
	
	    var hiddenRecQtyName = 0;
	    $(".hiddenRecQty").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecQtyName++ + "].recQty");
	    });
	    var hiddenRecQtyId = 0;
	    $(".hiddenRecQty").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecQtyId++ + "].recQty");
	    });
	
	    var hiddenRecDestinationName = 0;
	    $(".hiddenRecDestination").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecDestinationName++ + "].recDestination");
	    });
	    var hiddenRecDestinationId = 0;
	    $(".hiddenRecDestination").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecDestinationId++ + "].recDestination");
	    });
	
	    var hiddenItmShipToAddressIdName = 0;
	    $(".hiddenItmShipToAddressId").each(function () {
	      $(this).attr('name', "receipts[" + hiddenItmShipToAddressIdName++ + "].itmShipToAddressId");
	    });
	    var hiddenItmShipToAddressIdId = 0;
	    $(".hiddenItmShipToAddressId").each(function () {
	      $(this).attr('id', "receipts[" + hiddenItmShipToAddressIdId++ + "].itmShipToAddressId");
	    });
	
	    var hiddenRecWsTypeName = 0;
	    $(".hiddenRecWsType").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecWsTypeName++ + "].recWsType");
	    });
	    var hiddenRecWsTypeId = 0;
	    $(".hiddenRecWsType").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecWsTypeId++ + "].recWsType");
	    });
	
	    var hiddenRecRmdIdName = 0;
	    $(".hiddenRecRmdId").each(function () {
	      $(this).attr('name', "receipts[" + hiddenRecRmdIdName++ + "].recRmdId");
	    });
	    var hiddenRecRmdIdId = 0;
	    $(".hiddenRecRmdId").each(function () {
	      $(this).attr('id', "receipts[" + hiddenRecRmdIdId++ + "].recRmdId");
	    });
	
	    //
	    var checkBoxName = 0;
	    $(".rma-receiving-product-checkbox").each(function () {
	      $(this).attr('name', "receipts[" + checkBoxName++ + "].returnRmaItem");
	    });
	    var checkBoxId = 0;
	    $(".rma-receiving-product-checkbox").each(function () {
	      $(this).attr('id', "receipts[" + checkBoxId++ + "].returnRmaItem");
	    });
	    // below for poly bag count 1 of 1, 1 of 2 so on during default flow 
	    var polyBagCountName = 0;
	    $(".polyBagNumber").each(function () {
	      $(this).attr('name', "receipts[" + polyBagCountName++ + "].shipmentBoxNo");
	    });
	    var polyBagCountId = 0;
	    $(".polyBagNumber").each(function () {
	      $(this).attr('id', "receipts[" + polyBagCountId++ + "].shipmentBoxNo");
	    });
	    //below indesing for dropdown list in product catalogue flow
	    var selectPolyBagDropdownName = 0;
	    $(".select-ship-poly-bags").each(function () {
	      $(this).attr('name', "receipts[" + selectPolyBagDropdownName++ + "].shipmentBoxNo");
	    });
	    var selectPolyBagDropdownId = 0;
	    $(".select-ship-poly-bags").each(function () {
	      $(this).attr('id', "receipts[" + selectPolyBagDropdownId++ + "].shipmentBoxNo");
	    });
	
	    var polyBagQtyInputName = 0;
	    $(".quantity-in-poly-bag-input").each(function () {
	      $(this).attr('name', "receipts[" + polyBagQtyInputName++ + "].recQty");
	    });
	    var polyBagQtyInputId = 0;
	    $(".quantity-in-poly-bag-input").each(function () {
	      $(this).attr('id', "receipts[" + polyBagQtyInputId++ + "].recQty");
	    });
	  }
	
	  function validateBoxSelection(e) {
	    var self = $(this);
	    var parent = self.closest('.fxo-loopable-item-container');
	    if (self.val() != "") {
	      parent.find('.add-box-valid').show();
	      parent.find('.add-box-error').hide();
	    } else {
	      parent.find('.add-box-error').show();
	      parent.find('.add-box-valid').hide();
	    }
	  }
	
	  function validatePolyBagSelection(e) {
	    var self = $(this);
	    var parent = self.closest('.fxo-loopable-item-container');
	    if (self.val() != "") {
	      parent.find('.add-poly-bag-valid').show();
	      parent.find('.add-poly-bag-error').hide();
	    } else {
	      parent.find('.add-poly-bag-error').show();
	      parent.find('.add-poly-bag-valid').hide();
	    }
	    $(".fxo-return-not-all-poly-bags-used-error-message").hide();
	  }
	
	  function hideAddBoxValidationPills(el) {
	    el.find(".add-box-valid").hide();
	    el.find(".add-box-error").hide();
	  }
	
	  function hideAddPolyBagValidationPills(el) {
	    el.find(".add-poly-bag-valid").hide();
	    el.find(".add-poly-bag-error").hide();
	  }
	
	  function initAddBoxValidationPills(el) {
	    el.find(".add-box-valid").hide();
	    el.find(".add-box-error").show();
	  }
	
	  function initAddPolyBagValidationPills(el) {
	    el.find(".add-poly-bag-valid").hide();
	    el.find(".add-poly-bag-error").show();
	  }
	
	  function addMoreShipmentBoxes(e) {
	    e.preventDefault();
	    //hideAddBoxValidationPills();
	    var noOfBoxes = fxoNoOfBoxInput.val();
	
	    if (retailerReturnConfig != 'defaultItemReturn' && noOfBoxes > totalItemsOnPage) {
	      var modalErrEl = updateBoxQuantityModal.find(".add-box-modal-error");
	      modalErrEl.html("The number of boxes cannot exceed the total number of items.");
	      modalErrEl.show();
	    } else {
	      $("#number-of-boxes-input-hidden").val(fxoNoOfBoxInput.val());
	      hideAllBoxModals();
	      if (noOfBoxes > addBoxMaxLimit) {
	        showMaxBoxError();
	      } else {
	        //hideAllBoxModals();
	        if (noOfBoxes >= addBoxWarnLimit) {
	          showAddBoxWarning();
	        }
	        if (retailerReturnConfig == 'defaultItemReturn') {
	          updateShipmentBoxesForDefaultItems();
	          updateBoxPackingSkuDropdowns(noOfBoxes);
	        } else {
	          if (noOfBoxes <= 1) {
	            // set all items box no to 1
	            $(".shipment-box-footer").hide();
	            updateBoxPackingSkuDropdowns(noOfBoxes);
	          } else {
	            mainEl.find('.add-box-error').show();
	            $(".select-ship-boxes").empty().append('<option value="">Select Box</option>');
	            for (var i = 1; i <= noOfBoxes; i++) {
	              $(".select-ship-boxes").append('<option value="' + i + '">' + i + ' of ' + noOfBoxes + '</option>');
	            }
	            $(".shipment-box-footer").show();
	            updateBoxPackingSkuDropdowns(noOfBoxes);
	          }
	        }
	      }
	    }
	  }
	
	  function addMoreShipmentPolyBags(e) {
	    e.preventDefault();
	    $(".fxo-return-not-all-poly-bags-used-error-message").hide();
	    var noOfPolyBags = fxoNoOfPolyBagInput.val();
	    $("#number-of-poly-bags-hidden").val(fxoNoOfPolyBagInput.val());
	    if (retailerReturnConfig != 'defaultItemReturn') {
	      //  && noOfPolyBags >= totalItemsOnPage - this fixed issue when we reduce qty less than physical item
	      hideAllPolyBagModals();
	      updateShipmentPolyBagsForProductCatalogue();
	      $(".select-ship-poly-bags").empty().append('<option value="">Select PolyBag</option>');
	      for (var i = 1; i <= noOfPolyBags; i++) {
	        $(".select-ship-poly-bags").append('<option value="' + i + '">' + i + ' of ' + noOfPolyBags + '</option>');
	      }
	    } else if (retailerReturnConfig == 'defaultItemReturn') {
	      hideAllPolyBagModals();
	      updateShipmentPolyBagsForDefaultItems();
	      $(".select-ship-poly-bags").empty().append('<option value="">Select PolyBag</option>');
	      for (var i = 1; i <= noOfPolyBags; i++) {
	        $(".select-ship-poly-bags").append('<option value="' + i + '">' + i + ' of ' + noOfPolyBags + '</option>');
	      }
	    }
	  }
	
	  function updateBoxPackingSkuDropdowns(noOfBoxes) {
	    var casSkus = mainEl.data('cas-sku-list');
	    var allCasSkus = casSkus.allSkus;
	    var casSkuOptions = allCasSkus.map(function (el) {
	      return (0, _render2.default)(packingSkuOptionHtml, {
	        key: el.efcValue,
	        value: el.efcDescription
	      });
	    }).join('');
	
	    var outputHtml = '';
	    for (var i = 1; i <= noOfBoxes; i++) {
	      outputHtml += (0, _render2.default)(packingSkuListHtml, {
	        boxId: i,
	        totalBoxes: noOfBoxes,
	        packingSkuList: casSkuOptions
	      });
	    }
	    mainEl.find('.multi-box-paking-sku-container').html(outputHtml);
	    initComponents();
	  }
	
	  function updatePolyBagPackingSkuDropdowns(noOfPolyBags) {
	    var casSkus = mainEl.data('cas-sku-list');
	    var allCasSkus = casSkus.allSkus;
	    var casSkuOptions = allCasSkus.map(function (el) {
	      return (0, _render2.default)(packingSkuOptionHtml, {
	        key: el.efcValue,
	        value: el.efcDescription
	      });
	    }).join('');
	
	    var outputHtml = '';
	    for (var i = 1; i <= noOfPolyBags; i++) {
	      outputHtml += (0, _render2.default)(packingSkuListHtml, {
	        polyBagId: i,
	        totalPolyBags: noOfPolyBags,
	        packingSkuList: casSkuOptions
	      });
	    }
	    mainEl.find('.multi-poly-bag-paking-sku-container').html(outputHtml);
	    initComponents();
	  }
	
	  function hideAllBoxModals() {
	    updateBoxQuantityModal.modal('hide');
	    warningModalBodyFor10Modal.modal('hide');
	    warningModalBodyFor30Modal.modal('hide');
	  }
	
	  function hideAllPolyBagModals() {
	    updatePolyBagQuantityModal.modal('hide');
	    //warningModalBodyFor10Modal.modal('hide');
	    //warningModalBodyFor30Modal.modal('hide');
	  }
	
	  function showMaxBoxError() {
	    warningModalBodyFor30Modal.modal('show');
	  }
	
	  function showMaxPolyBagError() {
	    warningModalBodyFor30Modal.modal('hide');
	  }
	
	  function showAddBoxWarning() {
	    warningModalBodyFor10Modal.modal('show');
	  }
	
	  function showAddPolyBagWarning() {
	    warningModalBodyFor10Modal.modal('hide');
	  }
	
	  function selectItemChange() {
	    var itemContainer = $(this).closest(".fxo-loopable-item-container");
	    var itemCheckbox = $(this);
	    $.each(itemContainer.find(".requiredWhenSelected"), function (i, v) {
	      if (itemCheckbox.is(":checked")) {
	        $(v).addClass("required");
	        handleNoSelectionErrorDisplay(true);
	      } else {
	        $(v).removeClass("required");
	        $(v).val("").trigger("change");
	        $("#fxo-return-rma-form").valid();
	        itemContainer.find('.serial-number-validated-static-msg').hide();
	      }
	    });
	
	    // Make checkbox disable if click event is happen
	    if ($(itemContainer.find(".serial-number-section")).val() != undefined && !itemCheckbox.is(":checked")) {
	
	      itemCheckbox.prop('disabled', true);
	    }
	    if (($("#rmaReceivingType").val() == 'mmc' || $("#rmaReceivingType").val() == 'consolidated_acceptance') && retailerReturnConfig == 'defaultItemReturn') {
	      allocateOnePolyBagPerProduct();
	    } else if (($("#rmaBoxConfig").val() == 'OPSB' || retailerReturnConfig == 'defaultItemReturn') && !($("#rmaReceivingType").val() == 'mmc' && $("#rmaReceivingType").val() == 'consolidated_acceptance')) {
	      allocateOneBoxPerProduct();
	    }
	
	    //Handle toggle item disabled/enabled state
	    handleToggleItem(itemCheckbox);
	  }
	
	  function handleCheckItemSelection() {
	    var itemSelected = false;
	    var allBoxesUsed = [];
	
	    $.each($(".fxo-loopable-item-container"), function (i, v) {
	      var itemCheckbox = $(v).find(".rma-receiving-product-checkbox");
	      if (itemCheckbox.is(":checked")) {
	        itemSelected = true;
	        if (retailerReturnConfig == 'defaultItemReturn') {
	          allBoxesUsed.push($(v).find(".boxNumber").val());
	        } else {
	          allBoxesUsed.push($(v).find('.select-ship-boxes').val());
	        }
	      }
	    });
	
	    handleNoSelectionErrorDisplay(itemSelected);
	
	    //Piggy pack on validation if they didnt use all the boxes
	    itemSelected = handleCheckBoxSelection(allBoxesUsed);
	
	    return itemSelected;
	  }
	
	  function handleCheckItemSelectionForPolyBag() {
	    var itemSelected = false;
	    var allPolyBagsUsed = [];
	    $.each($(".fxo-loopable-item-container"), function (i, v) {
	      var itemCheckbox = $(v).find(".rma-receiving-product-checkbox");
	      if (itemCheckbox.is(":checked")) {
	        itemSelected = true;
	        if (retailerReturnConfig == 'defaultItemReturn') {
	          allPolyBagsUsed.push($(v).find(".polyBagNumber").val());
	        } else {
	          if ($(v).find('.select-ship-poly-bags').val().trim().length > 0) {
	            allPolyBagsUsed.push($(v).find('.select-ship-poly-bags').val());
	          }
	        }
	      }
	    });
	
	    handleNoSelectionErrorDisplay(itemSelected);
	    itemSelected = handleCheckBoxSelectionForPolyBags(allPolyBagsUsed);
	
	    return itemSelected;
	  }
	
	  function handleCheckBoxSelection(allBoxesUsed) {
	    var valid = true;
	    var noOfBoxes = fxoNoOfBoxInput.val();
	    var uniqueBoxes = _underscore2.default.uniq(allBoxesUsed);
	
	    if (noOfBoxes != uniqueBoxes.length) {
	      valid = false;
	    }
	    // Used same function as FCR and handled error msg in jsp
	    handleNotAllPolyBagsUsedErrorDisplay(valid);
	    return valid;
	  }
	
	  function handleCheckBoxSelectionForPolyBags(allPolyBagsUsed) {
	    var valid = true;
	    var noOfPolyBags = fxoNoOfPolyBagInput.val();
	    var uniquePolyBags = _underscore2.default.uniq(allPolyBagsUsed);
	    var requstedNoOfPolyBags = fxoNoOfPolyBagInput.val();
	
	    if (noOfPolyBags != uniquePolyBags.length) {
	      valid = false;
	    }
	    handleNotAllPolyBagsUsedErrorDisplay(valid);
	    return valid;
	  }
	
	  // This method is required for Jquery validation and Spring data bining
	  function renameClonedReceiptInputNamesForDataBinding() {
	    $(".fxo-loopable-item-container").each(function (index, boxDiv) {
	      $(boxDiv).find('[name^=receipts]').each(function (i, inputEle) {
	        var newName = $(this).attr('name').replace('[0]', '[' + index + ']');
	        $(this).attr('name', newName);
	        $(this).attr('id', newName);
	      });
	    });
	  }
	
	  function validateAndSubmit(e) {
	    e.preventDefault();
	    var requstedNoOfPolyBags = fxoNoOfPolyBagInput.val();
	    var curNoOfPolyBags = $(".fxo-loopable-item-container").length;
	
	    var itemSelectValidity;
	    var validity = $("#fxo-return-rma-form").valid();
	    if ($("#rmaReceivingType").val() == 'mmc' || $("#rmaReceivingType").val() == 'consolidated_acceptance') {
	      itemSelectValidity = handleCheckItemSelectionForPolyBag();
	    } else {
	      itemSelectValidity = handleCheckItemSelection();
	    }
	    if (validity && itemSelectValidity) {
	      if (($("#rmaReceivingType").val() == 'mmc' || $("#rmaReceivingType").val() == 'consolidated_acceptance') && retailerReturnConfig != 'defaultItemReturn') {
	        if (requstedNoOfPolyBags <= totalItemsOnPage) {
	          deleteRow();
	        }
	      }
	      submitFxoReturns();
	    }
	  }
	  function deleteRow() {
	    var additionalItemDiv = document.getElementsByClassName("additional-item-div");
	    $("#" + additionalItemDiv[0].id).remove();
	    //alert("Add Removed" );
	    //AJAX call here
	    //pass this clickedId to Servlet and delete the row , show response back to user 
	  }
	
	  // Search items from sku or upc
	  function skuUpcSectionSearchFun(e) {
	    e.preventDefault();
	    skuAddProductErr.hide();
	    if (serialSearchModalForm.valid()) {
	      $.ajax({
	        url: mainEl.data('serial-sku-url'),
	        type: 'POST',
	        dataType: 'json',
	        data: { 'sku': skuUpcSectionSearchInput.val() }, // skuUpcSectionSearchInput.val(),
	        success: function success(resp) {
	          var itemData = resp.data;
	          skuAddProductsContainer.html('');
	          if (itemData && itemData != null && itemData != 'null' && itemData.length > 0) {
	            skuUpcSectionPanel.show();
	            $.each(itemData, function (i, v) {
	              var fxoReceivingAddProductEl = $((0, _render2.default)(fxoReceivingAddProductTemplate, { dataItem: v }));
	              skuAddProductsContainer.append(fxoReceivingAddProductEl);
	            });
	          } else {
	            skuUpcSectionPanel.hide();
	            skuAddProductErr.show();
	          }
	        },
	        error: function error(_error2) {
	          submitModalFlow.showFailureModal();
	        }
	      });
	    }
	  };
	
	  // Search items from model number
	  modelNumberSectionSearch.on('click', function (e) {
	    e.preventDefault();
	    modelAddProductErr.hide();
	    if (serialSearchModalForm.valid()) {
	      $.ajax({
	        url: mainEl.data('serial-model-url'),
	        type: 'POST',
	        data: { 'model': modelNumberSectionSearchInput.val() }, // skuUpcSectionSearchInput.val(),
	        success: function success(resp) {
	          var itemData = JSON.parse(resp).data;
	          modelAddProductsContainer.html('');
	          if (itemData && itemData != null && itemData != 'null' && itemData.length > 0) {
	            modelNumSectionPanel.show();
	            $.each(itemData, function (i, v) {
	              var fxoReceivingAddProductEl = $((0, _render2.default)(fxoReceivingAddProductTemplate, { dataItem: v }));
	              modelAddProductsContainer.append(fxoReceivingAddProductEl);
	            });
	          } else {
	            modelNumSectionPanel.hide();
	            modelAddProductErr.show();
	          }
	        },
	        error: function error(_error3) {
	          submitModalFlow.showFailureModal();
	        }
	      });
	    }
	  });
	
	  function submitFxoReturns() {
	    submitModalFlow.showLoadingModal();
	    var form = $("#fxo-return-rma-form").serialize();
	    var url = $("#fxo-receiving-screen").data("submit-fxo-return-url");
	    $.ajax({
	      url: url,
	      type: 'POST',
	      dataType: 'html',
	      data: form,
	      success: function success(resp) {
	        EditChecker.setPageClean();
	        submitModalFlow.showSuccessModal();
	        setTimeout(function () {
	          submitModalFlow.hideAllModals();
	          $("#receipt-modal").html(resp);
	          $("#fxo-return-receipt-summary-modal").modal("show");
	          $("#fxo-return-receipt-summary-modal").on('shown.bs.modal', function () {
	            //FxoRmaRevObj.fxoReceiptHandleEnableBtn(); - TODO
	          });
	        }, window.constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    });
	  }
	
	  function getItemImages(e) {
	    e.preventDefault();
	    var url = $(this).data("url");
	    submitModalFlow.showLoadingModal();
	    $.ajax({
	      url: url,
	      type: 'POST',
	      dataType: 'html',
	      success: function success(resp) {
	        submitModalFlow.hideAllModals();
	        if (resp) {
	          $("#item-image-modal").html(resp);
	          $("#view-image-of-product-modal").modal("show");
	          autoSelectFirstThumbnail();
	        }
	      }
	    });
	  }
	
	  function autoSelectFirstThumbnail() {
	    //var thumbnailLength = fxoRmaRevDomVars.linkThumbnailContainer.find(".rma-rev-image-thumbnail").length;
	    var thumbnailLength = $(".rma-rev-thumbnail-container").find(".rma-rev-image-thumbnail").length;
	    if (thumbnailLength > 0) {
	      //dynamically added content, so defining it again
	      var firstThumbnail = $("#view-image-of-product-modal .rma-rev-image-thumbnail:first");
	      //NOTE: this simulates a user click event, which should run handleThumbnailClickEvent function below
	      firstThumbnail.trigger("click");
	    }
	  }
	
	  function chooseInputPlaceholder() {
	    //var selectedText = $("#search-dropdown-options option:selected").text().trim();
	    var selectedText = $("#cutomer-serach-by").val();
	    var serachBy = $("#customer-serach-value");
	    if (selectedText === "Work Order Number") {
	      serachBy.prop("placeholder", "Enter or Scan Work Order Number");
	    } else if (selectedText === "Serial Number") {
	      serachBy.prop("placeholder", "Enter Serial Number");
	    } else if (selectedText === "Order Number") {
	      serachBy.prop("placeholder", "Enter Order Number");
	    } else if (selectedText === "RMA Number") {
	      serachBy.prop("placeholder", "Enter or Scan RMA Number");
	    } else if (selectedText === "Customer Account #") {
	      serachBy.prop("placeholder", "Enter Customer Account #");
	    } else if (selectedText === "Customer Email") {
	      serachBy.prop("placeholder", "Enter Customer Email");
	    } else if (selectedText === "First Name") {
	      serachBy.prop("placeholder", "Enter Customer First Name");
	    } else if (selectedText === "Last Name") {
	      serachBy.prop("placeholder", "Enter Customer Last Name");
	    } else if (selectedText === "House Number") {
	      serachBy.prop("placeholder", "Enter Customer House number");
	    } else if (selectedText === "Zip Code") {
	      serachBy.prop("placeholder", "Enter Customer Zip Code");
	    }
	  }
	
	  function searchCustomerReturnOnEnter(e) {
	    var code = e.keyCode ? e.keyCode : e.which;
	    if (code == 13) {
	      searchCustomerReturn(e);
	    }
	  }
	
	  function searchCustomerReturn(e) {
	    if ($("#fxo-search-customer-details-form").valid()) {
	      e.preventDefault();
	      submitModalFlow.showLoadingModal();
	      var url = $(".retrieve-customer-return").data("url");
	      var searchBy = $(".cutomer-serach-by").val();
	      var searchValue = '';
	      if (searchBy == 'HOUSE_SEARCH') {
	        searchValue = $("#first-search-value").val() + ',' + $("#second-search-value").val() + ',' + $("#third-search-value").val();
	      } else if (searchBy == 'HOUSE_AND_SERIAL_SEARCH') {
	        searchValue = $("#one-search-value").val() + ',' + $("#two-search-value").val() + ',' + $("#three-search-value").val() + ',' + $("#four-search-value").val();
	      } else {
	        searchValue = $(".customer-serach-value").val();
	      }
	      $.ajax({
	        url: url,
	        type: 'POST',
	        dataType: 'html',
	        data: { retailerId: $("#rtlId").val(), searchBy: searchBy, searchValue: searchValue },
	        success: function success(resp) {
	          submitModalFlow.hideAllModals();
	          if (manualCheckinSection.hide()) {
	            manualCheckinSection.show();
	          }
	          $("#fxo-receiving-submit-return-items-section").html(resp);
	          if ($('.fxo-loopable-item-container').length < 1) {
	            $('.manual-check-in-div').show();
	            // check if iib lookup service response has error code
	            var errorMsgFromIIBLookupService = $('.fxo-receiving-screen').data('error-msg-from-iib-lookup');
	            if (errorMsgFromIIBLookupService != '') {
	              fxoManualCheckinCustomMsg.html('ATTENTION: ' + errorMsgFromIIBLookupService);
	            } else {
	              fxoManualCheckinCustomMsg.html("Select from the drop down above to retrieve the customer's return information. If the customer cannot be found, begin the return manually by selecting Manual Check In below.");
	            }
	          } else {
	            manualCheckinSection.hide();
	            fxoManualCheckinCustomMsg.html("Select from the drop down above to retrieve the customer's return information.");
	          }
	          initComponents();
	          EditChecker.bindChangeListener("#fxo-return-rma-form");
	          $('.product-serial-number-input').focus();
	        }
	      });
	    }
	  }
	
	  // Call ajax for render item in receiving screen - manualItemCheckin
	  function modelAddReturnItemFun(e) {
	    e.preventDefault();
	    mainModal.modal("hide");
	    // clear sku and model number field form Model
	    $('.sku_upc_section_search_input').val('');
	    $('.model_number_section_search_input').val('');
	
	    submitModalFlow.showLoadingModal();
	    var recordNo = $(".fxo-loopable-item-container").length;
	    var itemObj = $(this).closest(".model-add-return-item-btn").data('item');
	
	    var url = $("#fxo-receiving-screen").data("manual-checkin-url") + "&index=" + recordNo + "&itemSku=" + itemObj.itmSku;
	    var form = $("#fxo-return-rma-form").serialize();
	    $.ajax({
	      url: url,
	      type: 'POST',
	      dataType: 'html',
	      data: form,
	      success: function success(resp) {
	        submitModalFlow.hideAllModals();
	        manualCheckinSection.hide();
	        if ($('.return-items-page').hide()) {
	          $('.return-items-page').show();
	        }
	        $('#returnable-items-container').append($(resp).find('#fxo-loopable-item-container'));
	
	        initComponents();
	        //Call init methos for the new html;
	        var productSerialNumberInput = $('.product-serial-number-input');
	        var newItemCont = $($(".fxo-loopable-item-container")[recordNo]);
	        newItemCont.find(".rma-receiving-product-checkbox").change(selectItemChange);
	        newItemCont.find('.rma-receiving-product-checkbox').prop('checked', true);
	        // remove disable of item checkbox on serial number match
	        newItemCont.find('.rma-receiving-product-checkbox').removeAttr('disabled');
	        newItemCont.find(".rma-receiving-product-checkbox").trigger("change");
	        // getting the serial no which user has entered and paste it on new added item
	        newItemCont.find('.serial-receipts' + recordNo).val(productSerialNumberInput.val());
	        newItemCont.find('.serialNumberInput' + recordNo).val(productSerialNumberInput.val());
	        newItemCont.find('.serialNumberInput' + recordNo).attr('disabled', 'disabled');
	        newItemCont.find('.serial-number-added-static-msg').hide();
	        // Clear the serial number capturing text box
	        productSerialNumberInput.val('');
	        productSerialNumberInput.focus();
	        $('.serial-number-added-msg' + recordNo).show();
	      }
	    });
	  }
	
	  // manual check in button click event
	  function manualCheckinClick(e) {
	    e.preventDefault();
	    var serialNoValidation = $('.fxo-receiving-screen').data('serial-no-validation');
	    if (serialNoValidation != true) {
	      mainModal.modal("show");
	      showSkuUpcSection();
	    } else {
	      $('.return-items-page').show();
	    }
	  }
	
	  // Call ajax for render item in receiving screen from AT&T call - manualItemCheckin
	  function manualCheckinSerialNoSearch(e) {
	    // submitModalFlow.showLoadingModal();
	    var recordNo = $(".fxo-loopable-item-container").length;
	    var productSerialNumberInput = $(".product-serial-number-input");
	    var form = $("#fxo-return-rma-form").serialize();
	    var url = $("#fxo-receiving-screen").data("serial-number-lookup-checkin-url") + "&index=" + recordNo + "&serialNumber=" + productSerialNumberInput.val();
	    $.ajax({
	      url: url,
	      type: 'POST',
	      dataType: 'html',
	      data: form,
	      success: function success(resp) {
	        submitModalFlow.hideAllModals();
	        if ($($(resp).find('.fxoReceiptExist')).val() === true) {
	          receiptExistModal.modal("show");
	        } else if ($(resp).find('.fxo-loopable-item-sku').text().trim() == '') {
	          mainModal.modal("show");
	          showSkuUpcSection();
	        } else {
	          $('#returnable-items-container').append($(resp).find('#fxo-loopable-item-container'));
	          initComponents();
	          //Call init methos for the new html;
	          var newItemCont = $($(".fxo-loopable-item-container")[recordNo]);
	          newItemCont.find(".rma-receiving-product-checkbox").change(selectItemChange);
	          newItemCont.find('.rma-receiving-product-checkbox').prop('checked', true);
	          // remove disable of item checkbox on serial number match
	          newItemCont.find('.rma-receiving-product-checkbox').removeAttr('disabled');
	          newItemCont.find(".rma-receiving-product-checkbox").trigger("change");
	          // getting the serial no which user has entered and paste it on new added item
	          newItemCont.find('.serial-receipts' + recordNo).val(productSerialNumberInput.val());
	          newItemCont.find('.serialNumberInput' + recordNo).val(productSerialNumberInput.val());
	          newItemCont.find('.serialNumberInput' + recordNo).attr('disabled', 'disabled');
	          newItemCont.find('.serial-number-added-static-msg').hide();
	          // Clear the serial number capturing text box
	          productSerialNumberInput.val('');
	          productSerialNumberInput.focus();
	          $('.serial-number-validated-msg' + recordNo).show();
	        }
	      }
	    });
	  }
	  // AT&T: for any input other than UNSCANNABLE
	  // serial number receipt validation
	  function serialNumberReceiptValidation(e) {
	    var productSerialNumberInput = $(".product-serial-number-input");
	    var form = $("#fxo-return-rma-form").serialize();
	    var url = $("#fxo-receiving-screen").data("serial-number-validation-url") + "&serialNumber=" + productSerialNumberInput.val();
	    $.ajax({
	      url: url,
	      type: 'POST',
	      dataType: 'html',
	      data: form,
	      success: function success(resp) {
	        if (JSON.parse(resp).data == 'true') {
	          submitModalFlow.hideAllModals();
	          receiptExistModal.modal("show");
	          productSerialNumberInput.val('');
	          productSerialNumberInput.focus();
	        } else if (!serialNumberValidated()) {
	          manualCheckinSerialNoSearch(e);
	        } else {
	          submitModalFlow.hideAllModals();
	          productSerialNumberInput.val('');
	          productSerialNumberInput.focus();
	        }
	      }
	    });
	  }
	
	  function goToSerialNumber() {
	    $('.product-serial-number-input').val("");
	    $('.product-serial-number-input').focus();
	    invalidEntryModalForSerialNumber.hide();
	  }
	
	  function goToReturnLookup() {
	    window.location.href = $("#fxo-return-rma-form").data("return-lookup-page-url");
	  }
	
	  function setItemsInitialState() {
	    var itemContainer = mainEl.find(".fxo-loopable-item-container").each(function (index, item) {
	      var itemCheckbox = $(item).find('.rma-receiving-product-checkbox');
	      handleToggleItem(itemCheckbox);
	    });
	  }
	
	  function handleToggleItem(el) {
	    var closestTargetEl = el.data('target-closest');
	    var parentEl = el.closest(closestTargetEl);
	    if (el.prop('checked')) {
	      handleToggleItemEnabledState(parentEl);
	      initAddBoxValidationPills(parentEl);
	    } else {
	      handleToggleItemDisabledState(parentEl);
	      hideAddBoxValidationPills(parentEl);
	    }
	  }
	
	  function handleToggleItemEnabledState(el) {
	    el.find('.q-pct-body').removeClass('q-pct-body-disable');
	    el.find('.q-pct-body :input').removeAttr('disabled');
	    el.find('.q-pct-footer :input').removeAttr('disabled');
	    el.find('.select2-container').css('pointer-events', '');
	  }
	
	  function handleToggleItemDisabledState(el) {
	    el.find('.q-pct-body').addClass('q-pct-body-disable');
	    el.find('.q-pct-body :input').attr('disabled', 'true');
	    el.find('.q-pct-footer :input').attr('disabled', 'true');
	    el.find('.select2-container').css('pointer-events', 'none');
	  }
	}

/***/ },
/* 212 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateCutOffTime = calculateCutOffTime;
	function calculateCutOffTime(hours, minutes) {
	  var sameDayCutOffHours = 18 - hours; /* Warehouse cut off time 6 PM */
	  var sameDayCutOffMinutes = 60 - minutes;
	  if (sameDayCutOffMinutes == 60) {
	    sameDayCutOffMinutes = 0;
	  } else {
	    sameDayCutOffHours = sameDayCutOffHours - 1;
	  }
	  var cutOffTime = "";
	  if (sameDayCutOffMinutes < 10) {
	    sameDayCutOffMinutes = "0" + sameDayCutOffMinutes;
	  }
	  if (sameDayCutOffHours < 12) {
	    if (sameDayCutOffHours == 0) sameDayCutOffHours = 12;
	    cutOffTime = sameDayCutOffHours + ":" + sameDayCutOffMinutes + " AM ET";
	  } else {
	    sameDayCutOffHours = sameDayCutOffHours % 12;
	    if (sameDayCutOffHours == 0) sameDayCutOffHours = 12;
	    cutOffTime = sameDayCutOffHours + ":" + sameDayCutOffMinutes + " PM ET";
	  }
	  return cutOffTime;
	}

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = DetailsTab;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _elementsbindMap = __webpack_require__(112);
	
	var _util = __webpack_require__(34);
	
	var _select2able = __webpack_require__(22);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsPageMap = (0, _elementsbindMap.getMap)();
	var additionalCarrierElementsMap = (0, _elementsbindMap.getAdditionalCarrierMap)();
	var elsPage = {};
	var entryEl = (0, _jquery2.default)("<div class='entry-point'></div>");
	var targetSelector = "#create-order-type-form";
	var additionalCarrierHtml = __webpack_require__(186);
	
	function DetailsTab(wizard) {
	
		var self = this;
		var wizardEl = wizard.getWizardElement();
		var mainEl = (0, _jquery2.default)(".details-tab");
		var editFlag = wizardEl.data("edit-flag");
		var isDup = wizardEl.data("dup-flag");
		var editOrderType = {};
		if (editFlag) {
			editOrderType = wizardEl.data("edit-order-type-data");
		}
	
		init();
	
		var orderTypeList = elsPage.orderTypeRetailerList.data('options');
		var fulfillmentList = elsPage.orderTypeFullfillmentCenter.data('options');
		var billingMethodList = elsPage.orderTypeBillingMethod.data('options');
		var carrierList = elsPage.orderTypeCarrier.data('options');
		var countryList = elsPage.orderTypeDetailCountry.data('options');
		var usaStates = elsPage.orderTypeDetailState.data('usa-states');
		var caProvinces = elsPage.orderTypeDetailState.data('ca-provinces');
		var consolidatedOrderTypeList = elsPage.orderTypeRetailerList.data("consolidated-order-type-list");
		var groupedOrderTypeList = _underscore2.default.groupBy(consolidatedOrderTypeList, 'ortRetailerName');
		var retailerZeroList = elsPage.orderTypeRetailerList.data("retailer-zero");
		loadDropDowns();
	
		function init() {
			setElements();
			bindElements();
		}
	
		function setElements() {
			(0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, wizardEl);
		};
	
		function bindElements() {
			elsPage.orderTypeRetailerSwitchSection.hide();
			elsPage.orderTypeRetailerSwitch.on("change", function () {
				if (!elsPage.orderTypeRetailerSwitch.is(":checked")) {
					elsPage.orderTypeRetailerList.val("-1").trigger("change");
					(0, _instantiateSwitchery.setSwitchery)(elsPage.orderTypeDropShipSwitch, false);
					(0, _selectorHelpers.enableInput)(elsPage.orderTypeCodeInput);
					elsPage.orderTypeDuplicateError.hide();
					elsPage.orderTypeCodeInput.val("");
					elsPage.orderTypeNameInput.val("");
				}
				handlePackageLabel();
			});
	
			elsPage.orderTypeDropShipSwitch.on("change", function () {
				handlePackageLabel();
			});
	
			elsPage.orderTypeBillingMethod.on("change", function (e) {
				if (elsPage.orderTypeBillingMethod.val() === "Third Party") {
					elsPage.carrierDropDownSection.removeClass("hidden");
					elsPage.orderTypedetailAddcarrierDiv.removeClass("hidden");
				} else {
					elsPage.carrierDropDownSection.addClass("hidden");
					elsPage.fedExSection.addClass('hidden');
					elsPage.upsSection.addClass('hidden');
					elsPage.orderTypedetailAddcarrierDiv.addClass("hidden");
					fieldResetForBillMethod();
				}
			});
			elsPage.orderTypeCarrier.on("change", function (e) {
				showHideFedexUPSValues(elsPage.fedExSection, elsPage.upsSection, elsPage.orderTypeCarrier.val(), "mainCarrier");
			});
	
			elsPage.orderTypeDetailCountry.on("change", handleSwitchingStateInput);
			elsPage.orderTypeDetailAddcarrier.on("click", addNewCarriers);
			elsPage.orderTypeRetailerList.on("change", showHideDropFlag);
			elsPage.orderTypeFullfillmentCenter.on("change", changeFullfillmentInformationText);
	
			elsPage.orderTypeCodeInput.on("blur", orderTypeCodeValidation);
	
			wizardEl.on("change", ".additionalCarrierDrop", additionalCarrierDiv);
			wizardEl.on("change", ".additional-carrier-country", handleSwitchingStateAddtionaCarrier);
			wizardEl.on("click", ".order-type-detail-remove", handleHideAdditionalCarrier);
		}
	
		function handlePackageLabel() {
			if (elsPage.orderTypeRetailerSwitch.is(":checked") && !elsPage.orderTypeDropShipSwitch.is(":checked")) {
				elsPage.includePackageDiv.show();
				(0, _instantiateSwitchery.setSwitchery)(elsPage.includePackageLabel, true);
			} else {
				elsPage.includePackageDiv.hide();
			}
		}
	
		function handleHideAdditionalCarrier(e) {
			if (e != "changeOnMainCarrier") {
				e.preventDefault();
			}
			wizardEl.find(elsPage.additionalCarrierMainDiv).remove();
			wizardEl.find(elsPage.orderTypeDetailRemove).hide();
			wizardEl.find(elsPage.orderTypeDetailAddcarrier).show();
		}
	
		function orderTypeCodeValidation() {
			var orderTypeCodeValue = elsPage.orderTypeCodeInput.val();
			elsPage.orderTypeCodeInput.val("");
			elsPage.orderTypeCodeInput.val(orderTypeCodeValue.toUpperCase());
		}
	
		function changeFullfillmentInformationText() {
			if (elsPage.orderTypeFullfillmentCenter.val() != '') {
				elsPage.orderDestinationTabFfcMsg.html('This order type will be fulfilled by the ' + (0, _jquery2.default)('#order_type_fulfillmentCenter :selected').text() + '.');
			} else {
				elsPage.orderDestinationTabFfcMsg.html('Order will be fulfilled based on your order processing configurations');
			}
		}
	
		function showHideDropFlag() {
			var cotCode = elsPage.orderTypeRetailerList.val();
			//Get only the code for this order type code or an empty list
			var orderTypeList = groupedOrderTypeList[cotCode] || [];
	
			var showDropShipFlag = false;
			var dropShipAvail = {
				"Y": false,
				"N": false
			};
	
			_jquery2.default.each(orderTypeList, function (index, value) {
				if (!(0, _util.isNull)(value.ortDropShip)) {
					showDropShipFlag = true;
	
					if (value.ortDropShip) {
						dropShipAvail.Y = true;
					} else {
						dropShipAvail.N = true;
					}
				}
			});
	
			var dropShipFlagEl = elsPage.orderTypeDropShipSwitch;
			if (showDropShipFlag) {
				(0, _instantiateSwitchery.disableSwitchery)(dropShipFlagEl);
				(0, _instantiateSwitchery.setSwitchery)(dropShipFlagEl, false);
				if (dropShipAvail.Y && dropShipAvail.N) {
					(0, _instantiateSwitchery.enableSwitchery)(dropShipFlagEl);
				} else if (dropShipAvail.Y) {
					(0, _instantiateSwitchery.setSwitchery)(dropShipFlagEl, true);
				}
			} else {
				//Reset the elements
				(0, _instantiateSwitchery.setSwitchery)(dropShipFlagEl, false);
				(0, _instantiateSwitchery.disableSwitchery)(dropShipFlagEl);
			}
			populateOrderTypeAndCode(cotCode);
		}
	
		function populateOrderTypeAndCode(cotCode) {
			for (var i = 0; i < retailerZeroList.length; i++) {
				if (retailerZeroList[i].ortRetailerName === cotCode && retailerZeroList[i].ortRtlId == 0) {
					elsPage.orderTypeNameInput.val(retailerZeroList[i].ortRetailerName);
					populateAndDisableOrderTypeCode(retailerZeroList[i]);
					break;
				}
			}
		}
	
		function populateAndDisableOrderTypeCode(orderTypeCodeValue) {
			elsPage.orderTypeCodeInput.val(orderTypeCodeValue.ortTypeCode);
			(0, _selectorHelpers.disableInput)(elsPage.orderTypeCodeInput);
		}
	
		function additionalCarrierDiv() {
			(0, _selectorHelpers.setElementsFromScope)(elsPage, additionalCarrierElementsMap, wizardEl);
			var additionalCarrierDropValue = wizardEl.find(elsPage.additionalCarrierDrop);
			showHideFedexUPSValues(elsPage.fedexAccountNumber, elsPage.upsAccountNumber, elsPage.additionalCarrierDrop.val(), "additionalCarrier");
			fieldRestForAdditionalCarrier();
		}
	
		function showHideFedexUPSValues(fedexAccountDiv, upsAccountDiv, carrierValue, carrierChange) {
			if (carrierValue == "FedEx") {
				fedexAccountDiv.removeClass("hidden");
				upsAccountDiv.addClass("hidden");
			} else if (carrierValue == "UPS") {
				upsAccountDiv.removeClass("hidden");
				fedexAccountDiv.addClass("hidden");
			} else {
				fedexAccountDiv.addClass("hidden");
				upsAccountDiv.addClass("hidden");
			}
			var additionalCarrierDropDown = wizardEl.find('#additionalCarrier-0');
			if (additionalCarrierDropDown.length > 0 && carrierChange == "mainCarrier") {
				handleHideAdditionalCarrier("changeOnMainCarrier");
				addNewCarriers("changeOnMainCarrier");
			}
		}
	
		function addNewCarriers(e) {
			if (e != "changeOnMainCarrier") {
				e.preventDefault();
			}
			var arrayIndex = 0;
			var additionalCarrierMainDiv = wizardEl.find('#additionalCarrier-0');
			if (!additionalCarrierMainDiv.length > 0) {
				renderCountryList(countryList);
				var AdditonalCarriersAdd = (0, _jquery2.default)((0, _render2.default)(additionalCarrierHtml, {
					additionalCarrierDropdown: getRenderedCarrierDropDown(carrierList),
					countryList: renderCountryList(countryList),
					arrayIndex: arrayIndex
				}));
				elsPage.orderTypedetailAddcarrierDiv.append(AdditonalCarriersAdd);
				(0, _select2able.instantiateSelect2)(elsPage.orderTypedetailAddcarrierDiv.find('.select2-select'));
				(0, _selectorHelpers.setElementsFromScope)(elsPage, additionalCarrierElementsMap, wizardEl);
				fieldResetForAdditionalBillMethod();
			}
			wizardEl.find(elsPage.orderTypeDetailAddcarrier).hide();
		}
	
		function getRenderedCarrierDropDown(addtionalCarrierDropValue) {
			var carrierValue = elsPage.orderTypeCarrier.val();
			var addtionalCarrierDropHtml = '<option value="{%- addtionalCarrier.cdmValue %}">{%- addtionalCarrier.cdmValue %}</option>';
			var response = _underscore2.default.map(addtionalCarrierDropValue, function (addtionalCarrier) {
				if (carrierValue != addtionalCarrier.cdmValue) {
					return (0, _render2.default)(addtionalCarrierDropHtml, {
						addtionalCarrier: addtionalCarrier
					});
				}
			});
			return response.join("");
		}
	
		function handleSwitchingStateInput() {
			var countryVal = (0, _jquery2.default)('.order-type-detail-country  :selected').val();
			if (countryVal == "US" || countryVal == "CA") {
				elsPage.orderTypeDetailStateDropdown.removeClass("hidden");
				elsPage.destinationTabStateTextWrapper.addClass("hidden");
				getRenderedStatesorProvince(countryVal, elsPage.orderTypeDetailState);
			} else {
				elsPage.orderTypeDetailStateDropdown.addClass("hidden");
				elsPage.destinationTabStateTextWrapper.removeClass("hidden");
			}
		}
	
		function handleSwitchingStateAddtionaCarrier() {
	
			var countryVal = (0, _jquery2.default)('.additional-carrier-country  :selected').val();
			if (countryVal == "US" || countryVal == "CA") {
				wizardEl.find(elsPage.additionalCarrierDetailStateWrapper).removeClass("hidden");
				wizardEl.find(elsPage.additionalCarrierDetailStateTextWrapper).addClass("hidden");
				getRenderedStatesorProvince(countryVal, elsPage.additionalCarrierDetailState);
			} else {
				wizardEl.find(elsPage.additionalCarrierDetailStateWrapper).addClass("hidden");
				wizardEl.find(elsPage.additionalCarrierDetailStateTextWrapper).removeClass("hidden");
			}
		}
	
		function getRenderedStatesorProvince(countryVal, stateComponent) {
			var stateTypeSelect = stateComponent;
			stateTypeSelect.html('');
			var defaultSelectText = "";
			if (countryVal == "US") {
				defaultSelectText = "Select State";
			} else {
				defaultSelectText = "Select Province";
			}
			var option = (0, _jquery2.default)('<option />');
			option.attr('value', "-1").text(defaultSelectText);
			option.attr('selected', 'selected');
			option.attr('disabled', 'disabled');
			stateTypeSelect.append(option);
			if (countryVal == "US") {
				(0, _jquery2.default)(usaStates).each(function () {
					var option = (0, _jquery2.default)('<option />');
					option.attr('value', this.cdmValue).text(this.cdmMeaning);
					stateTypeSelect.append(option);
				});
			} else if (countryVal == "CA") {
				(0, _jquery2.default)(caProvinces).each(function () {
					var option = (0, _jquery2.default)('<option />');
					option.attr('value', this.cdmValue).text(this.cdmMeaning);
					stateTypeSelect.append(option);
				});
			}
			stateTypeSelect.addClass("select2 select");
			(0, _select2able.instantiateSelect2)(stateTypeSelect);
		}
	
		function loadDropDowns() {
			(0, _jquery2.default)(fulfillmentList).each(function () {
				var option = (0, _jquery2.default)('<option />');
				option.attr('value', this.facId).text(this.facName);
				elsPage.orderTypeFullfillmentCenter.append(option);
			});
	
			(0, _jquery2.default)(billingMethodList).each(function () {
				var option = (0, _jquery2.default)('<option />');
				option.attr('value', this.cdmValue).text(this.cdmMeaning);
				elsPage.orderTypeBillingMethod.append(option);
			});
	
			(0, _jquery2.default)(carrierList).each(function () {
				var option = (0, _jquery2.default)('<option />');
				option.attr('value', this.cdmValue).text(this.cdmValue);
				elsPage.orderTypeCarrier.append(option);
			});
	
			_jquery2.default.each(orderTypeList, function (index, object) {
				var dataAttr = void 0;
				if (!(0, _util.isNull)(object.ortRetailerName) && !_underscore2.default.isEmpty(object.ortRetailerName)) {
					var value = '' + object.ortRetailerName;
					var option = (0, _jquery2.default)('<option /\>');
					option.data('quick-toggler-target', dataAttr);
					option.attr('value', object.ortRetailerName).text(value);
					elsPage.orderTypeRetailerList.append(option);
				}
			});
	
			(0, _jquery2.default)(countryList).each(function () {
				var option = (0, _jquery2.default)('<option />');
				option.attr('value', this.conCode).text(this.conName);
				elsPage.orderTypeDetailCountry.append(option);
			});
			if (editFlag) {
				fillDropDownValues();
			}
		}
	
		function renderCountryList(countryList) {
			var addtionalCarrierCountryDropHtml = '<option value="{%- addtionalCarrierCountry.conCode %}">{%- addtionalCarrierCountry.conName %}</option>';
			var response = _underscore2.default.map(countryList, function (addtionalCarrierCountry) {
				return (0, _render2.default)(addtionalCarrierCountryDropHtml, {
					addtionalCarrierCountry: addtionalCarrierCountry
				});
			});
	
			return response.join("");
		}
	
		function fieldResetForBillMethod() {
			elsPage.orderTypeCarrier.val("").trigger('change');
			fieldRestForCarrier();
		}
	
		function fillDropDownValues() {
	
			(0, _instantiateSwitchery.instantiateSwitchery)(elsPage.orderTypeRetailerSwitch, {});
			(0, _instantiateSwitchery.instantiateSwitchery)(elsPage.orderTypeDropShipSwitch, {});
			if (!(0, _util.isNullOrUndefined)(editOrderType.retailerName)) {
				(0, _instantiateSwitchery.setSwitchery)(elsPage.orderTypeRetailerSwitch, true);
				if (!isDup) {
					elsPage.orderTypeRetailerList.val(editOrderType.retailerName).trigger('change');
					(0, _instantiateSwitchery.setSwitchery)(elsPage.orderTypeDropShipSwitch, editOrderType.dropShip);
				} else {
					(0, _instantiateSwitchery.setSwitchery)(elsPage.orderTypeDropShipSwitch, false);
				}
			} else {
				(0, _instantiateSwitchery.setSwitchery)(elsPage.orderTypeRetailerSwitch, false);
			}
	
			(0, _instantiateSwitchery.setSwitchery)(elsPage.includePackageLabel, editOrderType.includingPackageLabel);
			if (!isDup) {
				elsPage.orderTypeNameInput.val(editOrderType.name);
				elsPage.orderTypeCodeInput.val(editOrderType.code);
			}
			if (editOrderType.code.toUpperCase() == "B2B" || editOrderType.code.toUpperCase() == "B2C") {
				elsPage.business.removeClass('hidden');
				if (editOrderType.code.toUpperCase() == "B2B") {
					elsPage.b2b.removeClass('hidden');
					elsPage.b2bPackTab.removeClass('hidden');
					elsPage.packingTab.addClass('hidden');
				}
				if (!isDup) {
					(0, _selectorHelpers.disableInput)(elsPage.orderTypeCodeInput);
					(0, _selectorHelpers.disableInput)(elsPage.orderTypeNameInput);
				}
			}
			if (!(0, _util.isNullOrUndefined)(editOrderType.fulfillmentCenter)) {
				elsPage.orderTypeFullfillmentCenter.val(editOrderType.fulfillmentCenter).trigger('change');
			}
			if (!(0, _util.isNullOrUndefined)(editOrderType.billing)) {
				elsPage.orderTypeBillingMethod.val(editOrderType.billing.billingMethod).trigger('change');
				if (!(0, _util.isNullOrUndefined)(editOrderType.billing.carriers[0])) {
					if (editOrderType.billing.carriers[0].carrierName.toUpperCase() == 'FEDEX') {
						elsPage.orderTypeCarrier.val(editOrderType.billing.carriers[0].carrierName).trigger('change');
					} else {
						elsPage.orderTypeCarrier.val(editOrderType.billing.carriers[0].carrierName).trigger('change');
						if (!(0, _util.isNullOrUndefined)(editOrderType.billing.carriers[0].billToAddress)) elsPage.orderTypeDetailCountry.val(editOrderType.billing.carriers[0].billToAddress.country).trigger('change');
	
						if (!(0, _util.isNullOrUndefined)(editOrderType.billing.carriers[0].billToAddress)) elsPage.orderTypeDetailState.val(editOrderType.billing.carriers[0].billToAddress.state).trigger('change');
					}
				}
				if (!(0, _util.isNullOrUndefined)(editOrderType.billing.carriers[1])) {
					(0, _selectorHelpers.setElementsFromScope)(elsPage, additionalCarrierElementsMap, wizardEl);
					if (editOrderType.billing.carriers[1].carrierName.toUpperCase() == 'FEDEX') {
						elsPage.additionalCarrierDrop.val(editOrderType.billing.carriers[1].carrierName).trigger('change');
						elsPage.additionalCarrierFedexNumber.val(editOrderType.billing.carriers[1].accountNumber);
					} else {
						elsPage.additionalCarrierDrop.val(editOrderType.billing.carriers[1].carrierName).trigger('change');
						elsPage.additionalCarrierCountry.val(editOrderType.billing.carriers[1].billToAddress.country).trigger('change');
						elsPage.additionalCarrierDetailState.val(editOrderType.billing.carriers[1].billToAddress.state).trigger('change');
						elsPage.additionalCarrierUPSNumber.val(editOrderType.billing.carriers[1].accountNumber);
						elsPage.additionalCarrierBillTo.val(editOrderType.billing.carriers[1].billToAddress.name);
						elsPage.additionalCarrierAddress1.val(editOrderType.billing.carriers[1].billToAddress.addressLine1);
						if (!(0, _util.isNullOrUndefined)(editOrderType.billing.carriers[1].billToAddress.addressLine2)) {
							elsPage.additionalCarrierAddress2.val(editOrderType.billing.carriers[1].billToAddress.addressLine2);
						}
						elsPage.additionalCarrierCity.val(editOrderType.billing.carriers[1].billToAddress.city);
						elsPage.additionalCarrierDetailStateText.val(editOrderType.billing.carriers[1].billToAddress.state);
						elsPage.additionalCarrierPostalCode.val(editOrderType.billing.carriers[1].billToAddress.postalCode);
					}
				}
			}
		}
	
		function fieldRestForCarrier() {
			elsPage.orderTypeFedexAccountNumber.val("");
			elsPage.orderTypeUpsAccountNumber.val("");
			elsPage.orderTypeBillto.val("");
			elsPage.orderTypeDetailCountry.val("").trigger('change');
			elsPage.orderTypeDetailAddress.val("");
			elsPage.orderTypeDetailAddress2.val("");
			elsPage.orderTypeDetailCity.val("");
			elsPage.orderTypeDetailState.val("").trigger('change');
			elsPage.orderTypeDetailStateInput.val("");
			elsPage.orderTypeDetailPostalcode.val("");
		}
	
		function fieldResetForAdditionalBillMethod() {
			wizardEl.find(elsPage.additionalCarrierDrop).val("").trigger('change');
			fieldRestForAdditionalCarrier();
		}
	
		function fieldRestForAdditionalCarrier() {
			wizardEl.find(elsPage.additionalCarrierFedexNumber).val("");
			wizardEl.find(elsPage.additionalCarrierUPSNumber).val("");
			wizardEl.find(elsPage.additionalCarrierBillTo).val("");
			wizardEl.find(elsPage.additionalCarrierAddress1).val("");
			wizardEl.find(elsPage.additionalCarrierAddress2).val("");
			wizardEl.find(elsPage.additionalCarrierCity).val("");
			wizardEl.find(elsPage.additionalCarrierDetailStateText).val("");
			wizardEl.find(elsPage.additionalCarrierPostalCode).val("");
		}
	}

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PackagingTab;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _elementsbindMap = __webpack_require__(112);
	
	var _util = __webpack_require__(34);
	
	var _select2able = __webpack_require__(22);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsPageMap = (0, _elementsbindMap.getMap)();
	var additionalCarrierElementsMap = (0, _elementsbindMap.getAdditionalCarrierMap)();
	var elsPage = {};
	var entryEl = (0, _jquery2.default)("<div class='entry-point'></div>");
	var targetSelector = "#create-order-type-form";
	var additionalCarrierHtml = __webpack_require__(186);
	
	function PackagingTab(wizard) {
	
	    var self = this;
	    var wizardEl = wizard.getWizardElement();
	    var mainEl = (0, _jquery2.default)(".packaging-tab");
	    var editFlag = mainEl.data("edit-flag");
	    var isDup = wizardEl.data("dup-flag");
	    var editOrderType = {};
	    if (editFlag) {
	        editOrderType = mainEl.data("edit-order-type-data");
	    }
	
	    init();
	
	    self.didNavigateToForm = function () {
	        return validatePackagingTab();
	    };
	
	    var boxTypeList = elsPage.orderTypeBoxType.data('options');
	    var tissuePaperList = elsPage.orderTypeTissuePaper.data('options');
	    var orderSlipList = elsPage.orderSlip.data('options');
	    var packageSlipList = elsPage.packageSlip.data('options');
	    var orderTypeCountryCodeList = elsPage.orderTypeCountryCode.data('options');
	    var facilityAddressObj = elsPage.facilityAddress.data('options');
	    var retailerAddress = facilityAddressObj.retailerAddress;
	    var facilityAddressList = facilityAddressObj.facilitiesAddress;
	
	    loadDropDowns();
	
	    function validatePackagingTab() {
	        var isValid = false;
	        if (wizardEl.valid()) {
	            isValid = true;
	        }
	        return isValid;
	    }
	
	    function init() {
	        setElements();
	        bindElements();
	        elsPage.customDocPhoneNumber.inputmask({
	            mask: "(999) 999-9999"
	        });
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, wizardEl);
	    };
	
	    function bindElements() {
	        if (elsPage.orderTypeRetailerSwitch.is(":checked") && !elsPage.orderTypeDropShipSwitch.is(":checked")) {
	            elsPage.includePackageDiv.show();
	        } else {
	            elsPage.includePackageDiv.hide();
	        }
	
	        elsPage.orderTypeBoxType.on("change", function (e) {
	            _jquery2.default.each(boxTypeList, function (index, value) {
	                var boxTypeVal = elsPage.orderTypeBoxType.val();
	                if (boxTypeVal == this.cdmValue) {
	                    elsPage.boxTypeDesc.text(this.cdmDescription);
	                }
	            });
	        });
	
	        elsPage.orderTypeTissuePaper.on("change", function (e) {
	            _jquery2.default.each(tissuePaperList, function (index, value) {
	                var tissuePaperVal = elsPage.orderTypeTissuePaper.val();
	                if (tissuePaperVal == this.cdmValue) {
	                    elsPage.tissuePaperDesc.text(this.cdmDescription);
	                }
	            });
	        });
	
	        elsPage.packagePackingSlip.on("change", function (e) {
	            if (elsPage.packagePackingSlip.prop("checked") == true || elsPage.orderPackingSlip.prop("checked") == true) {
	                (0, _jquery2.default)('.customize-section').show();
	            } else {
	                (0, _jquery2.default)('.customize-section').hide();
	            }
	        });
	
	        elsPage.orderPackingSlip.on("change", function (e) {
	            if (elsPage.packagePackingSlip.prop("checked") == true || elsPage.orderPackingSlip.prop("checked") == true) {
	                (0, _jquery2.default)('.customize-section').show();
	            } else {
	                (0, _jquery2.default)('.customize-section').hide();
	            }
	        });
	
	        elsPage.facilityAddress.on("change", function (e) {
	
	            var selVal = elsPage.facilityAddress.val();
	            var selTxt = (0, _jquery2.default)('.order-type-facility option:selected').text();
	            var addressTxt1 = "";
	            var addressTxt2 = "";
	
	            if (selTxt == 'Main Location') {
	                var retAddrss = retailerAddress[0];
	                addressTxt1 = retAddrss.rtlAddress1 + (retAddrss.rtlAddress2 == null ? "" : ", " + retAddrss.rtlAddress2);
	                addressTxt2 = retAddrss.rtlCity + ", " + retAddrss.rtlState + ", " + retAddrss.rtlZip;
	            } else {
	
	                _jquery2.default.each(facilityAddressList, function (index, value) {
	                    if (selVal == this.cadLocationName) {
	                        var cmrAddrss = this;
	                        addressTxt1 = cmrAddrss.cadAddress1 + (cmrAddrss.cadAddress2 == null ? "" : ", " + cmrAddrss.cadAddress2);
	                        addressTxt2 = cmrAddrss.cadCity + ", " + cmrAddrss.cadState + ", " + cmrAddrss.cadZipcode;
	                    }
	                });
	            }
	
	            elsPage.orderTypeFacilityAddrss1.text(addressTxt1);
	            elsPage.orderTypeFacilityAddrss2.text(addressTxt2);
	        });
	    }
	
	    function loadDropDowns() {
	        _jquery2.default.each(boxTypeList, function (index, value) {
	            var option = (0, _jquery2.default)('<option />');
	            option.attr('value', this.cdmValue).text(this.cdmValue);
	            elsPage.orderTypeBoxType.append(option);
	        });
	        elsPage.boxTypeDesc.text(boxTypeList[0].cdmDescription);
	
	        _jquery2.default.each(tissuePaperList, function (index, value) {
	            var option = (0, _jquery2.default)('<option />');
	            option.attr('value', this.cdmValue).text(this.cdmValue);
	            if (this.cdmDescription == 'No Additional Charge') {
	                option.attr('selected', 'true');
	                elsPage.tissuePaperDesc.text(tissuePaperList[index].cdmDescription);
	            }
	            elsPage.orderTypeTissuePaper.append(option);
	        });
	
	        _jquery2.default.each(orderTypeCountryCodeList, function (index, value) {
	            var option = (0, _jquery2.default)('<option />');
	            option.attr('value', this.conPhoneCode).text(this.conName + ' ' + this.conPhoneCode);
	            elsPage.orderTypeCountryCode.append(option);
	        });
	
	        _jquery2.default.each(orderSlipList, function (index, value) {
	            var option = (0, _jquery2.default)('<option />');
	            option.attr('value', this.cdmValue).text(this.cdmMeaning);
	            elsPage.orderSlip.append(option);
	        });
	
	        _jquery2.default.each(packageSlipList, function (index, value) {
	            var option = (0, _jquery2.default)('<option />');
	            option.attr('value', this.cdmValue).text(this.cdmMeaning);
	            elsPage.packageSlip.append(option);
	        });
	
	        var retAddrss = retailerAddress[0];
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', retAddrss.rtlId).text("Main Location");
	        elsPage.facilityAddress.append(option);
	
	        _jquery2.default.each(facilityAddressList, function (index, value) {
	            var option = (0, _jquery2.default)('<option />');
	            option.attr('value', this.cadLocationName).text(this.cadLocationName);
	            elsPage.facilityAddress.append(option);
	        });
	
	        var addressTxt1 = retAddrss.rtlAddress1 + (retAddrss.rtlAddress2 == null ? "" : ", " + retAddrss.rtlAddress2);
	        var addressTxt2 = retAddrss.rtlCity + ", " + retAddrss.rtlState + ", " + retAddrss.rtlZip;
	
	        elsPage.orderTypeFacilityAddrss1.text(addressTxt1);
	        elsPage.orderTypeFacilityAddrss2.text(addressTxt2);
	        if (editFlag) {
	            fillDropDownValues();
	        }
	    }
	
	    function fillDropDownValues() {
	        if (!(0, _util.isNullOrUndefined)(editOrderType.retailerName) && isDup) {
	            //Reset Fields To Default
	        } else {
	            elsPage.orderTypeBoxType.val(editOrderType.boxType);
	            elsPage.boxTypeDesc.text(editOrderType.boxTypeDescription);
	            elsPage.orderTypeTissuePaper.val(editOrderType.tissuePaper);
	            elsPage.tissuePaperDesc.text(editOrderType.tissuePaperDesc);
	        }
	        if (!(0, _util.isNullOrUndefined)(editOrderType.packingSlipCI.citemplate)) {
	            elsPage.orderSlip.val(editOrderType.packingSlipCI.citemplate);
	        }
	        if (!(0, _util.isNullOrUndefined)(editOrderType.packingSlipCI.packingSlipTemplate)) {
	            elsPage.packageSlip.val(editOrderType.packingSlipCI.packingSlipTemplate);
	        }
	        if (!(0, _util.isNullOrUndefined)(editOrderType.packingSlipCI.customizedDocument.facility)) {
	            elsPage.facilityAddress.val(editOrderType.packingSlipCI.customizedDocument.facility.facilityName);
	            var editAddressTxt1 = editOrderType.packingSlipCI.customizedDocument.facility.addressLine1 + (editOrderType.packingSlipCI.customizedDocument.facility.addressLine2 == null ? "" : ", " + editOrderType.packingSlipCI.customizedDocument.facility.addressLine2);
	            var editAddressTxt2 = editOrderType.packingSlipCI.customizedDocument.facility.city + ", " + editOrderType.packingSlipCI.customizedDocument.facility.state + ", " + editOrderType.packingSlipCI.customizedDocument.facility.postalCode;
	            elsPage.orderTypeFacilityAddrss1.text(editAddressTxt1);
	            elsPage.orderTypeFacilityAddrss2.text(editAddressTxt2);
	        }
	        if (!(0, _util.isNullOrUndefined)(editOrderType.packingSlipCI.customizedDocument.countryCode)) {
	            elsPage.orderTypeCountryCode.val(editOrderType.packingSlipCI.customizedDocument.countryCode);
	        }
	    }
	}

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = ReviewTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _constants = __webpack_require__(10);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _elementsbindMap = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ReviewTab(wizard) {
	
	    var self = this;
	    var wizardEl = wizard.getWizardElement();
	    var isEdit = wizardEl.data("edit-flag");
	    var isDup = wizardEl.data("dup-flag");
	    var els = {};
	    var elsDetails = {};
	    var additionalCarrier = {};
	
	    var reviewTabElements = (0, _elementsbindMap.getReviewTabElements)();
	    var detailsTabElements = (0, _elementsbindMap.getMap)();
	    var additionalCarrierMap = (0, _elementsbindMap.getAdditionalCarrierMap)();
	
	    var orderTypeObj = {};
	
	    init();
	
	    function init() {
	        setElements();
	        bindElements();
	    }
	
	    self.didNavigateToForm = function () {
	        //Functions To Fill Up the review Tab
	        orderTypeObj = prepareDataForSubmit();
	        fillDetailsSection();
	        fillCarrierSection();
	        fillOrderPackingSection();
	        fillOrderDocumentSection();
	    };
	
	    function fillOrderDocumentSection() {
	        if (orderTypeObj.packingSlipCI.includingPackingSlip) {
	            els.packageLevelSlipOn.removeClass("hidden");
	            els.packageLevelSlipOff.addClass("hidden");
	            els.packageLevelSlipTemplate.text(elsDetails.packageSlip.find("option:selected").text());
	        } else {
	            els.packageLevelSlipOn.addClass("hidden");
	            els.packageLevelSlipOff.removeClass("hidden");
	        }
	        if (orderTypeObj.packingSlipCI.includingCI) {
	            els.orderLevelSlipOn.removeClass("hidden");
	            els.orderLevelSlipOff.addClass("hidden");
	            els.orderLevelSlipTemplate.text(elsDetails.orderSlip.find("option:selected").text());
	        } else {
	            els.orderLevelSlipOn.addClass("hidden");
	            els.orderLevelSlipOff.removeClass("hidden");
	        }
	
	        if (orderTypeObj.isForSpecifiedRetailer && !orderTypeObj.dropShip) {
	            els.includeLabelDiv.removeClass("hidden");
	            if (orderTypeObj.includingPackageLabel) {
	                els.includeLabelOn.removeClass("hidden");
	                els.includeLabelOff.addClass("hidden");
	            } else {
	                els.includeLabelOn.addClass("hidden");
	                els.includeLabelOff.removeClass("hidden");
	            }
	        } else {
	            els.includeLabelDiv.addClass("hidden");
	        }
	
	        if (orderTypeObj.packingSlipCI.includingCI || orderTypeObj.packingSlipCI.includingPackingSlip) {
	            els.customDocSection.removeClass("hidden");
	            var customDoc = orderTypeObj.packingSlipCI.customizedDocument;
	            els.customDocName.text(customDoc.companyName);
	            els.customDocFacilityName.text(elsDetails.facilityAddress.find("option:selected").text());
	            els.customDocAddressLine.text(elsDetails.orderTypeFacilityAddrss1.text());
	            els.customDocCityState.text(elsDetails.orderTypeFacilityAddrss2.text());
	            if (customDoc.phoneNumber) {
	                els.customDocPhone.text(customDoc.countryCode + " " + customDoc.phoneNumber);
	            }
	            els.customDocEmail.text(customDoc.contactEmail);
	            els.customDocHeader.text(customDoc.customNoteHeader);
	            els.customDocBody.text(customDoc.customNoteBody);
	        } else {
	            els.customDocSection.addClass("hidden");
	        }
	    }
	
	    function fillDetailsSection() {
	        els.orderTypeName.text(orderTypeObj.orderTypeName);
	        els.orderTypeCode.text(orderTypeObj.orderTypeCode);
	        els.fulfillmentCenter.text(elsDetails.orderTypeFullfillmentCenter.find('option:selected').text());
	        if (orderTypeObj.isForSpecifiedRetailer) {
	            els.specifiedRetailerSection.removeClass("hidden");
	            els.retailerName.text(elsDetails.orderTypeRetailerList.find('option:selected').text());
	            if (orderTypeObj.dropShip) {
	                els.dropShippingYes.removeClass("hidden");
	                els.dropShippingNo.addClass("hidden");
	            } else {
	                els.dropShippingYes.addClass("hidden");
	                els.dropShippingNo.removeClass("hidden");
	            }
	        } else {
	            if (!els.specifiedRetailerSection.hasClass("hidden")) {
	                els.specifiedRetailerSection.addClass("hidden");
	            }
	        }
	    }
	
	    function fillCarrierSection() {
	        (0, _selectorHelpers.setElementsFromScope)(additionalCarrier, additionalCarrierMap, wizardEl);
	        els.billMethod.text(elsDetails.orderTypeBillingMethod.find('option:selected').text());
	        if (orderTypeObj.billing.isPrepaid) {
	            els.nonPrepaidLabels.addClass("hidden");
	            els.additionalCarrierSection.addClass("hidden");
	        } else {
	            els.nonPrepaidLabels.removeClass("hidden");
	            els.carrierName.text(orderTypeObj.billing.carriers[0].carrierName);
	            els.accountNumber.text(orderTypeObj.billing.carriers[0].accountNumber);
	            if (orderTypeObj.billing.carriers[0].carrierName == "FedEx") {
	                els.nonFedExSection.addClass("hidden");
	            } else {
	                //For UPS
	                var billToAddress = orderTypeObj.billing.carriers[0].billToAddress;
	                els.nonFedExSection.removeClass("hidden");
	                els.billToName.text(billToAddress.addressName);
	                els.billToAddressLine.text(billToAddress.addressLine1 + " " + billToAddress.addressLine2);
	                els.cityStatePostalCode.text(billToAddress.city + ", " + billToAddress.state + ", " + billToAddress.postalCode);
	                els.billToCountry.text(elsDetails.orderTypeDetailCountry.find('option:selected').text());
	            }
	            if (!additionalCarrier.additionalCarrierMainDiv.hasClass("hidden") && additionalCarrier.additionalCarrierMainDiv.length > 0) {
	                els.additionalCarrierSection.removeClass("hidden");
	                var index = 0;
	                if (orderTypeObj.billing.carriers.length > 1) {
	                    index = 1;
	                }
	                els.additionalCarrierName.text(orderTypeObj.billing.carriers[index].carrierName);
	                els.additionalCarrierAccountNumber.text(orderTypeObj.billing.carriers[index].accountNumber);
	                if (orderTypeObj.billing.carriers[index].carrierName == "FedEx") {
	                    els.additionalNonFedEx.addClass("hidden");
	                } else {
	                    //For UPS
	                    var additionalBillToAddress = orderTypeObj.billing.carriers[index].billToAddress;
	                    els.additionalNonFedEx.removeClass("hidden");
	                    els.additonalBillToName.text(additionalBillToAddress.addressName);
	                    els.additionalBillToAddressLine.text(additionalBillToAddress.addressLine1 + " " + additionalBillToAddress.addressLine2);
	                    els.additionalCityStatePostalCode.text(additionalBillToAddress.city + ", " + additionalBillToAddress.state + ", " + additionalBillToAddress.postalCode);
	                    els.additionalBillToCountry.text(additionalCarrier.additionalCarrierCountry.find('option:selected').text());
	                }
	            } else {
	                els.additionalCarrierSection.addClass("hidden");
	            }
	        }
	    }
	
	    function fillOrderPackingSection() {
	        els.boxType.text(elsDetails.orderTypeBoxType.find('option:selected').text());
	        els.boxTypeCost.text(elsDetails.boxTypeDesc.text());
	        els.tissuePaper.text(elsDetails.orderTypeTissuePaper.find('option:selected').text());
	        els.tissuePaperCost.text(elsDetails.tissuePaperDesc.text());
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, reviewTabElements, wizardEl);
	        (0, _selectorHelpers.setElementsFromScope)(elsDetails, detailsTabElements, wizardEl);
	    }
	
	    function bindElements() {
	        //Fucntion For Submit Button
	        els.submitBtn.on("click", submitOrderTypeHandler);
	        els.sectionTitlesReviewTab.on("click", editPencilClick);
	    }
	
	    function editPencilClick() {
	        var form = wizardEl.find((0, _jquery2.default)(this).data("target-form"));
	        wizard.gotToForm(form);
	    }
	
	    function submitOrderTypeHandler() {
	        var detailsPageUrl = els.submitBtn.data("order-type-details-page-url");
	        var saveOrderTypeUrl = els.submitBtn.data("save-order-type-url");
	        var submitModalFlow = new _SubmitModalFlow2.default({
	            confirmModalTitle: "Submitting Order Type",
	            confirmModalBody: '<div class="q-pad-all-xl"> Once this order type is submitted and saved to the system, it will be an option to select from when creating orders.</div>',
	            confirmModalBtnText: "Submit",
	            onConfirmClick: function onConfirmClick() {
	                var orderTypeObj = prepareDataForSubmit();
	                submitModalFlow.showLoadingModal();
	                _jquery2.default.ajax({
	                    data: {
	                        orderType: JSON.stringify(orderTypeObj)
	                    },
	                    url: saveOrderTypeUrl,
	                    dataType: "JSON",
	                    type: 'POST',
	                    success: function success(data) {
	                        _EditChecker2.default.setPageClean();
	                        submitModalFlow.hideAllModals();
	                        if (data != null) {
	                            submitModalFlow.showSuccessModal();
	                            setTimeout(function () {
	                                location.href = detailsPageUrl + "&ortId=" + data;
	                            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	                        } else {
	                            submitModalFlow.showFailureModal();
	                        }
	                    },
	                    error: function error() {
	                        submitModalFlow.hideAllModals();
	                        submitModalFlow.showFailureModal();
	                    }
	                });
	            }
	        });
	        submitModalFlow.init();
	        submitModalFlow.showConfirmModal();
	    }
	
	    function prepareDataForSubmit() {
	        (0, _selectorHelpers.setElementsFromScope)(additionalCarrier, additionalCarrierMap, wizardEl);
	        var orderTypeObj = {};
	        var billToAddressId = void 0;
	        var boxTypeOpcId = void 0;
	        orderTypeObj.orderTypeName = elsDetails.orderTypeNameInput.val();
	        orderTypeObj.orderTypeCode = elsDetails.orderTypeCodeInput.val();
	        if (isEdit && !isDup) {
	            var orderType = wizardEl.data("edit-order-type-data");
	            orderTypeObj.isEdit = true;
	            orderTypeObj.ortStatus = orderType.status;
	            orderTypeObj.customOrderTypeId = orderType.customOrderTypeId;
	            if (orderType.billing.carriers.length > 0) {
	                orderTypeObj.carrierId = orderType.billing.carriers[0].id;
	                if (elsDetails.orderTypeCarrier.val() != "FedEx" && orderType.billing.carriers[0].billToAddress) {
	                    //carrierName
	                    billToAddressId = orderType.billing.carriers[0].billToAddress.id;
	                }
	            }
	            orderTypeObj.boxTypeOpcId = orderType.boxTypeOpcId;
	        } else {
	            orderTypeObj.isEdit = false;
	        }
	        if (elsDetails.orderTypeRetailerSwitch.is(":checked")) {
	            orderTypeObj.retailerName = elsDetails.orderTypeRetailerList.val();
	            if (elsDetails.orderTypeDropShipSwitch.is(":checked")) {
	                orderTypeObj.dropShip = true;
	            } else {
	                orderTypeObj.dropShip = false;
	            }
	            orderTypeObj.isForSpecifiedRetailer = true;
	        } else {
	            orderTypeObj.isForSpecifiedRetailer = false;
	        }
	        orderTypeObj.fulfillmentCenter = elsDetails.orderTypeFullfillmentCenter.val();
	
	        if (orderTypeObj.isForSpecifiedRetailer && !orderTypeObj.dropShip) {
	            if (elsDetails.includePackageLabel.is(":checked")) {
	                orderTypeObj.includingPackageLabel = true;
	            } else {
	                orderTypeObj.includingPackageLabel = false;
	            }
	        }
	        orderTypeObj.boxType = elsDetails.orderTypeBoxType.val();
	        //orderTypeObj.boxTypeOpcId = boxTypeOpcId;
	        orderTypeObj.tissuePaper = elsDetails.orderTypeTissuePaper.val();
	        var billing = {};
	        billing.billingMethod = elsDetails.orderTypeBillingMethod.val();
	        var carriersArray = [];
	        if (billing.billingMethod != "Prepaid") {
	            //For Main Carrier
	            billing.isPrepaid = false;
	            var carrierObj = {};
	            carrierObj.carrierName = elsDetails.orderTypeCarrier.val();
	            carrierObj.accountNumber = elsDetails.orderTypeFedexAccountNumber.val();
	            carrierObj.id = orderTypeObj.carrierId;
	            if (carrierObj.carrierName != "FedEx") {
	                carrierObj.accountNumber = elsDetails.orderTypeUpsAccountNumber.val();
	                var billAddress = {};
	                billAddress.addressName = elsDetails.orderTypeBillto.val();
	                billAddress.addressLine1 = elsDetails.orderTypeDetailAddress.val();
	                billAddress.addressLine2 = elsDetails.orderTypeDetailAddress2.val();
	                billAddress.city = elsDetails.orderTypeDetailCity.val();
	                billAddress.postalCode = elsDetails.orderTypeDetailPostalcode.val();
	                billAddress.country = elsDetails.orderTypeDetailCountry.val();
	                billAddress.state = elsDetails.orderTypeDetailState.val();
	                billAddress.id = billToAddressId;
	                if (billAddress.country != "US") {
	                    billAddress.state = elsDetails.orderTypeDetailStateInput.val();
	                }
	                carrierObj.billToAddress = billAddress;
	            }
	            carriersArray.push(carrierObj);
	            if (!additionalCarrier.additionalCarrierMainDiv.hasClass("hidden") && additionalCarrier.additionalCarrierMainDiv.length > 0) {
	                var additionalCarrierObj = {};
	                additionalCarrierObj.carrierName = additionalCarrier.additionalCarrierDrop.val();
	                additionalCarrierObj.accountNumber = additionalCarrier.additionalCarrierFedexNumber.val();
	                if (additionalCarrierObj.carrierName != "FedEx") {
	                    additionalCarrierObj.accountNumber = additionalCarrier.additionalCarrierUPSNumber.val();
	                    var _billAddress = {};
	                    _billAddress.addressName = additionalCarrier.additionalCarrierBillTo.val();
	                    _billAddress.addressLine1 = additionalCarrier.additionalCarrierAddress1.val();
	                    _billAddress.addressLine2 = additionalCarrier.additionalCarrierAddress2.val();
	                    _billAddress.city = additionalCarrier.additionalCarrierCity.val();
	                    _billAddress.postalCode = additionalCarrier.additionalCarrierPostalCode.val();
	                    _billAddress.country = additionalCarrier.additionalCarrierCountry.val();
	                    if (_billAddress.country != "US") {
	                        _billAddress.state = additionalCarrier.additionalCarrierDetailStateText.val();
	                    } else {
	                        _billAddress.state = additionalCarrier.additionalCarrierDetailState.val();
	                    }
	                    additionalCarrierObj.billToAddress = _billAddress;
	                }
	                carriersArray.push(additionalCarrierObj);
	            }
	            billing.carriers = carriersArray;
	        } else {
	            billing.isPrepaid = true;
	        }
	        orderTypeObj.billing = billing;
	        var packingSlipCIObj = {};
	        packingSlipCIObj.includingPackingSlip = elsDetails.packagePackingSlip.is(":checked");
	        if (packingSlipCIObj.includingPackingSlip) {
	            packingSlipCIObj.packingSlipTemplate = elsDetails.packageSlip.val();
	        }
	        packingSlipCIObj.includingCI = elsDetails.orderPackingSlip.is(":checked");
	        if (packingSlipCIObj.includingCI) {
	            packingSlipCIObj.CITemplate = elsDetails.orderSlip.val();
	        }
	        if (packingSlipCIObj.includingCI || packingSlipCIObj.includingPackingSlip) {
	            var customizedDocumentObj = {};
	            customizedDocumentObj.companyName = elsDetails.companyNameInput.val();
	            customizedDocumentObj.contactEmail = elsDetails.customDocEmail.val();
	            customizedDocumentObj.countryCode = elsDetails.orderTypeCountryCode.val();
	            customizedDocumentObj.phoneNumber = elsDetails.customDocPhoneNumber.val();
	            customizedDocumentObj.customNoteHeader = elsDetails.customHeader.val();
	            customizedDocumentObj.customNoteBody = elsDetails.customBody.val();
	            var facilityObj = {};
	            facilityObj.facilityName = elsDetails.facilityAddress.val();
	            customizedDocumentObj.facility = facilityObj;
	            packingSlipCIObj.customizedDocument = customizedDocumentObj;
	        }
	        orderTypeObj.packingSlipCI = packingSlipCIObj;
	        return orderTypeObj;
	    }
	}

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = DestinationTab;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _typeAheadSource = __webpack_require__(71);
	
	var _typeAheadSource2 = _interopRequireDefault(_typeAheadSource);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _util = __webpack_require__(34);
	
	var _preparationTab = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalHtml = __webpack_require__(11);
	var changeInternationalCountryModalBody = __webpack_require__(1379);
	
	function DestinationTab(wizard) {
		var self = this;
		var wizardEl = wizard.getWizardElement();
		var facilityTypeahead = wizardEl.find("#destinationTab-typeahead");
		var isInternationalOrder = (0, _jquery2.default)("#create-order-form").data("is-international-order");
		var targetArray = [".b2b-section, .address-section", ".b2c-section, .address-section"];
		var orderTypeSelect = (0, _jquery2.default)("#destination-tab-order-type-select");
		var orderTypeList = orderTypeSelect.data('options');
		var consolidatedOrderTypeList = orderTypeSelect.data("consolidated-order-type-list");
		var groupedOrderTypeList = _underscore2.default.groupBy(consolidatedOrderTypeList, 'ortTypeCode');
		var defaultContry = orderTypeSelect.data('default-country');
		var usaStates = orderTypeSelect.data('usa-states');
		var caProvinces = orderTypeSelect.data('ca-provinces');
		var countriesPhoneCodeSelect = (0, _jquery2.default)(".destination-tab-country-phone-code");
		var countriesPhoneCode = orderTypeSelect.data('country-phone-code-list');
		var productsTabEl = wizardEl.find('.products-tab');
		var shippingTabEl = wizardEl.find('.shipping-tab');
		var isChannelOrder = wizardEl.data("is-channel-order");
		var productsTableProductsTab = (0, _jquery2.default)("#product-bundle-row");
		var contactName = (0, _jquery2.default)("#destination-tab-contactName");
		var customerEmail = (0, _jquery2.default)("#destination-tab-btob-customerEmail");
		var phoneNumber = (0, _jquery2.default)("#destination-tab-btob-customerPhoneNumber");
		//const country= $("#destination-tab-country");
		var address1 = (0, _jquery2.default)("#destination-tab-address1");
		var address2 = (0, _jquery2.default)("#destination-tab-address2");
		var city = (0, _jquery2.default)("#destination-tab-city");
		var zipCode = (0, _jquery2.default)("#destination-tab-zipCode");
		var stateTextInput = (0, _jquery2.default)("#destination-tab-stateText");
		var stateSelect = (0, _jquery2.default)("#destination-tab-state");
		var customerPhoneNumber = (0, _jquery2.default)("#destination-tab-customerPhoneNumber");
		var orderDetailsForEdit = (0, _jquery2.default)("#create-order-form").data("edit-order-details");
		var retailerfacilitiesList = (0, _jquery2.default)("#create-order-form").data("retailer-facility-addresses");
		var destinationTabCountry = (0, _jquery2.default)("#destination-tab-country");
		var countries = destinationTabCountry.data('options');
		var sendTrackingInfoCheckB2b = (0, _jquery2.default)("#destination-tab-btob-sendTrackingInfo");
		var emailTextBoxB2b = (0, _jquery2.default)("#destination-tab-btob-customerEmail");
		//B2C fields
		var customerName = wizardEl.find('.customerName');
		var company = wizardEl.find('.company');
		var sendTrackingInfoCheck = (0, _jquery2.default)("#destination-tab-sendTrackingInfo");
		var emailTextBox = (0, _jquery2.default)("#destination-tab-customerEmail");
		var facilityTypeaheadDiv = wizardEl.find(".destinationTab-typeahead-div");
		var facilityTypeTextBoxDiv = wizardEl.find(".destinationTabTextBoxDiv");
		var facilityTypeTextBox = wizardEl.find(".destination-tab-facility-type-text-box");
	
		var orderReferenceNumber = wizardEl.find("#orderReferenceNumber");
		var previousCountry = "";
		wizardEl.on("click", '.change-country-modal-cancel', changeCountryCancelModal);
		wizardEl.on("click", '.change-country-modal-continue', changeCountryContinueModal);
		wizardEl.on("click", '.change-country-modal-continue', changeCountryContinueModal);
		var getShipmentMethodsUrl = (0, _jquery2.default)('#create-order-form').data('get-shipment-methods-url');
		var getServiceLevelsUrl = (0, _jquery2.default)('#create-order-form').data('get-service-levels-url');
		var hiddenAddressInput = (0, _jquery2.default)("#order-validated-address");
		var internationalShippingEnabled = wizardEl.data("is-international-order");
		var internationalmsg = wizardEl.find(".destination-tab-international-msg");
		var validationReqdCountries = (0, _jquery2.default)("#create-order-form").data("validation-reqd-countries");
		self.init = function () {
			loadRetailerFacilities();
			loadOrderTypeList();
			setPhoneNumberInputMask();
			loadCountryPhoneCodesList();
			loadCountriesList();
			handleCountryChange();
			destinationTabCountry.on("change", handleCountryChange);
			setPhoneCodeValidation();
			facilityTypeTextBoxDiv.hide();
			setDestinationTab(orderDetailsForEdit.orderDetails);
			if (!(0, _underscore2.default)(orderDetailsForEdit.orderDetails).isEmpty()) {
				loadShippingService(orderDetailsForEdit.orderDetails);
			}
		};
	
		function loadShippingService(orderDetails) {
			var destTabOrderType = (0, _jquery2.default)("#destination-tab-order-type-select");
			var destTabDropShipFlag = (0, _jquery2.default)("#dropShipFlag");
			loadShipmentMethods(destTabOrderType.val(), destTabDropShipFlag.prop("checked"));
			loadServiceLevels(destTabOrderType.val(), destTabDropShipFlag.prop("checked"));
		}
	
		function loadShipmentMethods(orderType, dropShipFlag) {
			var shippingMethodUsaId = (0, _jquery2.default)("#shipping-tab-shipping-method-with-usa");
			_jquery2.default.ajax({
				url: getShipmentMethodsUrl,
				type: 'POST',
				dataType: 'JSON',
				data: { orderType: orderType, dropShipFlag: dropShipFlag },
				success: function success(data) {
					shippingMethodUsaId.empty();
					var option = (0, _jquery2.default)('<option /\>');
					option.attr('value', "-1").text("Please select shipping method");
					option.attr('disabled', 'disabled');
					option.attr('selected', 'selected');
					shippingMethodUsaId.append(option);
					_jquery2.default.each(data, function (index, value) {
						var option = (0, _jquery2.default)('<option /\>');
						option.attr('value', value.cdmValue).text(value.cdmMeaning);
						shippingMethodUsaId.append(option);
					});
				}
			});
		}
	
		function loadServiceLevels(orderType, dropShipFlag, shippingMethod) {
			var serviceLevelsUsaId = (0, _jquery2.default)("#shipping-tab-shipping-service-level-with-usa");
			_jquery2.default.ajax({
				url: getServiceLevelsUrl,
				type: 'POST',
				dataType: 'JSON',
				data: { orderType: orderType, dropShipFlag: dropShipFlag },
				success: function success(data) {
					serviceLevelsUsaId.empty();
					var option = (0, _jquery2.default)('<option /\>');
					option.attr('value', "-1").text("Select from Service Levels");
					option.attr('disabled', 'disabled');
					option.attr('selected', 'selected');
					serviceLevelsUsaId.append(option);
					_jquery2.default.each(data, function (index, value) {
						var option = (0, _jquery2.default)('<option /\>');
						option.attr('value', value.cdmValue).text(value.cdmMeaning);
						serviceLevelsUsaId.append(option);
					});
				}
			});
		}
		function loadRetailerFacilities() {
			(0, _selectorHelpers.setOptionsForSelect)({
				selectElement: facilityTypeahead,
				list: retailerfacilitiesList,
				valueDataKey: "id",
				textDataKey: "text"
			});
		}
	
		facilityTypeahead.on("select2:select", function (e) {
			var selectedB2BFacilityAttributes = retailerfacilitiesList.find(function (obj) {
				return obj.id == e.params.data.id;
			});
			setB2BDestinationTabForNewOrder(selectedB2BFacilityAttributes);
		});
	
		//NOTE: change event, so making it send functional jobs to another function
		function select2FieldChange() {
			handleSelect2IndividualValidate((0, _jquery2.default)(this));
		}
	
		// NOTE: since select2 components are tricky, we specifically target them as well with the EditChecker component, and also have to validate them individually
		function handleSelect2IndividualValidate(selectField) {
			selectField.valid();
			EditChecker.setPageDirty();
		};
	
		function loadOrderTypeList() {
			_jquery2.default.each(orderTypeList, function (index, object) {
				var dataAttr = void 0;
				if (object.ortTypeCode != 'B2B') {
					dataAttr = targetArray[1];
				} else {
					dataAttr = targetArray[0];
				}
				var value = object.ortTypeCode + '-' + (object.ortRetailerName || object.ortName);
				var option = (0, _jquery2.default)('<option /\>');
				option.data('quick-toggler-target', dataAttr);
				option.attr('value', object.ortTypeCode).text(value);
				orderTypeSelect.append(option);
			});
		}
	
		/*const retailerTypeSelect = $("#destination-tab-retialer-type-select");
	 const retailerTypeList = retailerTypeSelect.data('options');
	 
	 $.each(retailerTypeList, function(index, value) {
	 
	 	const option = $('<option /\>');
	 	if(value == "Other")
	 	{
	 		option.data('quick-toggler-target', '#retailer-other-outer');
	 	}
	 	option.attr('value', value).text(value);
	 	retailerTypeSelect.append(option);
	 });*/
	
		function loadCountryPhoneCodesList() {
			(0, _jquery2.default)(countriesPhoneCode).each(function () {
				var option = (0, _jquery2.default)('<option />');
				option.attr('value', this.conPhoneCode).text(this.conPhoneText);
				countriesPhoneCodeSelect.append(option);
			});
		}
	
		function loadCountriesList() {
			(0, _jquery2.default)(countries).each(function () {
				var option = (0, _jquery2.default)('<option />');
				option.attr('value', this.conId).text(this.conName);
				if (isInternationalOrder) {
					destinationTabCountry.append(option);
				} else {
					if (this.conId == "1") {
						destinationTabCountry.append(option);
					}
				}
			});
		}
	
		function setStates(countryVal) {
			var destinationTabStatesSelect = (0, _jquery2.default)("#destination-tab-state");
			destinationTabStatesSelect.html('');
			var defaultSelectText = "";
			if (countryVal == "1") {
				defaultSelectText = "Select State";
			} else {
				defaultSelectText = "Select Province";
			}
			var option = (0, _jquery2.default)('<option />');
			option.attr('value', "-1").text(defaultSelectText);
			option.attr('selected', 'selected');
			option.attr('disabled', 'disabled');
			destinationTabStatesSelect.append(option);
			if (countryVal == "1") {
				(0, _jquery2.default)(usaStates).each(function () {
					var option = (0, _jquery2.default)('<option />');
					option.attr('value', this.cdmValue).text(this.cdmMeaning);
					destinationTabStatesSelect.append(option);
				});
			} else if (countryVal == "2") {
				(0, _jquery2.default)(caProvinces).each(function () {
					var option = (0, _jquery2.default)('<option />');
					option.attr('value', this.cdmValue).text(this.cdmMeaning);
					destinationTabStatesSelect.append(option);
				});
			}
		}
	
		function handleCountryChange(e) {
			var products = productsTableProductsTab.find('.product-data-row');
			var countryNewVal = (0, _jquery2.default)('#destination-tab-country  :selected').val();
			if (products.length > 0 && previousCountry == 1 && destinationTabCountry.val() != 1) {
				changeInternationalCountryModal.modal('show');
			}
	
			handleSwitchingStateInput();
			triggerProductTabSwappingForCountry();
			showInternationlShippingConfigMessage();
			var originalCountryOfOrder = void 0,
			    orderDetails = void 0;
			if (!(0, _underscore2.default)(orderDetailsForEdit).isEmpty() && !(0, _underscore2.default)(e).isUndefined()) {
				orderDetails = orderDetailsForEdit.orderDetails;
				originalCountryOfOrder = orderDetails.ordShipToCountry;
				if (originalCountryOfOrder != null && originalCountryOfOrder != 'US' && countryNewVal == 1 && isChannelOrder == true) {
					triggerDisableChannelSwitch();
				}
			}
	
			(0, _preparationTab.resetAccessorialSection)();
		}
	
		function triggerProductTabSwappingForCountry() {
			productsTabEl.trigger("country-select-change");
		}
		function triggerDisableChannelSwitch() {
			var retainChannelShipmentCheck = shippingTabEl.find("#channelShippingMethodCheck");
			if (retainChannelShipmentCheck.length > 0) {
				(0, _instantiateSwitchery.instantiateSwitchery)(retainChannelShipmentCheck);
				(0, _instantiateSwitchery.setSwitchery)(retainChannelShipmentCheck, false);
				(0, _instantiateSwitchery.disableSwitchery)(retainChannelShipmentCheck);
				retainChannelShipmentCheck.trigger("change");
			}
		}
	
		// create and initialize modal when change country to International
		var changeInternationalCountryModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
			modalDialogClass: 'q-modal-dialog-500',
			title: 'Products will be lost',
			leftAlignTitle: true,
			body: changeInternationalCountryModalBody,
			topCloseBtn: false,
			autoHideTop: true,
			footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide change-country-modal-cancel">Cancel</a><a href="#" class="base-btn purple-btn modal-auto-hide change-country-modal-continue">Continue</a>'
		}));
	
		wizardEl.append(changeInternationalCountryModal);
	
		function handleSwitchingStateInput() {
			var isValidCountry = false;
			var countryId = "";
			var checkZipCode = false;
			var countryVal = (0, _jquery2.default)('#destination-tab-country  :selected').val();
			previousCountry = countryVal;
			(0, _jquery2.default)(countries).each(function () {
				if (this.conId.toString() === countryVal.toString()) {
					countryId = this.conCode.toString();
					if (this.conPostalCodeRequired.toString() === "Y") {
						checkZipCode = true;
					}
					return false;
				}
			});
			(0, _jquery2.default)(validationReqdCountries).each(function () {
				if (this.cdmValue.toString() === countryId.toString()) {
					isValidCountry = true;
					return false;
				}
			});
			if (isValidCountry) {
				(0, _jquery2.default)(".country-not-supported-primary").hide();
			} else {
				(0, _jquery2.default)(".country-not-supported-primary").show();
			}
			if (countryVal == "1" || countryVal == "2") {
	
				(0, _jquery2.default)(".destination-tab-stateText-wrapper").hide();
				(0, _jquery2.default)(".destination-tab-state-wrapper").show();
				setStates(countryVal);
				(0, _jquery2.default)(".destination-tab-mandatory-label").show();
				(0, _jquery2.default)("#destination-tab-zipCode").prop('required', true);
			} else {
				(0, _jquery2.default)(".state-label").hide();
				if (checkZipCode) {
					(0, _jquery2.default)(".destination-tab-stateText-wrapper").show();
					(0, _jquery2.default)(".destination-tab-state-wrapper").hide();
					(0, _jquery2.default)(".zipcode-label").show();
					(0, _jquery2.default)("#destination-tab-zipCode").prop('required', true);
				} else {
					(0, _jquery2.default)(".destination-tab-stateText-wrapper").show();
					(0, _jquery2.default)(".destination-tab-state-wrapper").hide();
					(0, _jquery2.default)(".zipcode-label").hide();
					(0, _jquery2.default)("#destination-tab-zipCode").prop('required', false);
				}
			}
		}
	
		sendTrackingInfoCheck.change(function () {
			if (sendTrackingInfoCheck.is(':checked')) {
				emailTextBox.rules("add", {
					required: true,
					messages: {
						required: "This field is required."
					}
				});
			} else {
	
				emailTextBox.rules("remove");
			}
		});
	
		sendTrackingInfoCheckB2b.change(function () {
			if (sendTrackingInfoCheckB2b.is(':checked')) {
				emailTextBoxB2b.rules("add", {
					required: true,
					messages: {
						required: "This field is required."
					}
				});
			} else {
				emailTextBoxB2b.rules("remove");
			}
		});
	
		// Need USA as default - defaultContry is coming from jsp
		destinationTabCountry.val(defaultContry).trigger('change');
		countriesPhoneCodeSelect.val("+1").trigger('change');
	
		function changeCountryCancelModal() {
			destinationTabCountry.val(1).trigger('change');
		}
	
		function changeCountryContinueModal() {
			EditChecker.setPageDirty();
			productsTableProductsTab.empty();
			changeInternationalCountryModal.modal('hide');
		}
	
		orderTypeSelect.on('change', function (e) {
	
			showHideDropFlag(orderTypeSelect.val(), (0, _jquery2.default)("#destination-tab-order-type-select option:selected").text());
			setPhoneCodeValidation();
		});
	
		countriesPhoneCodeSelect.on('change', function (e) {
			setPhoneCodeValidation();
		});
	
		function showHideDropFlag(cotCode, name) {
			var dropShipSection = (0, _jquery2.default)('#dropShipSection');
	
			//Get only the code for this order type code or an empty list
			var orderTypeList = groupedOrderTypeList[cotCode] || [];
	
			var showDropShipFlag = false;
			var dropShipAvail = {
				"Y": false,
				"N": false
			};
	
			_jquery2.default.each(orderTypeList, function (index, value) {
				if (!(0, _util.isNull)(value.ortDropShip)) {
					showDropShipFlag = true;
	
					if (value.ortDropShip) {
						dropShipAvail.Y = true;
					} else {
						dropShipAvail.N = true;
					}
				}
			});
	
			var dropShipFlagEl = dropShipSection.find("#dropShipFlag");
			(0, _instantiateSwitchery.instantiateSwitchery)(dropShipFlagEl);
			if (showDropShipFlag) {
				dropShipSection.removeClass('hidden');
				(0, _instantiateSwitchery.setSwitchery)(dropShipFlagEl, false);
				(0, _instantiateSwitchery.disableSwitchery)(dropShipFlagEl);
				if (dropShipAvail.Y && dropShipAvail.N) {
					(0, _instantiateSwitchery.enableSwitchery)(dropShipFlagEl);
				} else if (dropShipAvail.Y) {
					(0, _instantiateSwitchery.setSwitchery)(dropShipFlagEl, true);
				}
			} else {
				//Reset the elements
				dropShipSection.addClass('hidden');
				(0, _instantiateSwitchery.setSwitchery)(dropShipFlagEl, false);
				(0, _instantiateSwitchery.disableSwitchery)(dropShipFlagEl);
			}
		}
		function setPhoneNumberInputMask() {
			phoneNumber.inputmask({
				mask: "(999) 999-9999"
			});
			customerPhoneNumber.inputmask({
				mask: "(999) 999-9999"
			});
		}
	
		function setPhoneCodeValidation() {
			if ((0, _jquery2.default)(".destination-tab-country-phone-code-b2b").val() == "+1") {
				phoneNumber.attr("placeholder", "(999) 999-9999");
				phoneNumber.addClass("phoneUS");
				phoneNumber.removeClass("phoneNonUS");
				phoneNumber.inputmask({
					mask: "(999) 999-9999"
				});
			} else if ((0, _jquery2.default)(".destination-tab-country-phone-code-b2b").val() != "+1") {
				/*
	   	Please dont just add else, because if order type is other than b2b, then  
	   	the else condition will be always true
	   */
				phoneNumber.removeAttr("placeholder");
				phoneNumber.removeClass("phoneUS");
				phoneNumber.addClass("phoneNonUS");
				phoneNumber.inputmask({
					mask: ""
				});
				var val = phoneNumber.val();
	
				if (val) {
					var v = val.replace(/[- )(]/g, '');
					v = v.replace(/[^0-9.]/g, "");
					phoneNumber.val(v);
				}
			}
			if ((0, _jquery2.default)(".destination-tab-country-phone-code-b2c").val() == "+1") {
				customerPhoneNumber.attr("placeholder", "(999) 999-9999");
				customerPhoneNumber.addClass("phoneUS");
				customerPhoneNumber.removeClass("phoneNonUS");
				customerPhoneNumber.inputmask({
					mask: "(999) 999-9999"
				});
			} else if ((0, _jquery2.default)(".destination-tab-country-phone-code-b2c").val() != "+1") {
				/*
	   	Please dont just add else, because if order type is other than b2c, then  
	   	the else condition will be always true
	   */
				customerPhoneNumber.removeAttr("placeholder");
				customerPhoneNumber.removeClass("phoneUS");
				customerPhoneNumber.addClass("phoneNonUS");
				customerPhoneNumber.inputmask({
					mask: ""
				});
				var _val = customerPhoneNumber.val();
				if (_val) {
					var _v = _val.replace(/[- )(]/g, '');
					_v = _v.replace(/[^0-9.]/g, "");
					customerPhoneNumber.val(_v);
				}
			}
		}
	
		if (!_jquery2.default.isEmptyObject(orderDetailsForEdit)) {
			var order = orderDetailsForEdit.orderDetails;
			var error = orderDetailsForEdit.error;
			setDestinationTab(order);
		}
	
		function setDestinationTab(data) {
			if ((0, _general.isPresent)(data)) {
				orderTypeSelect.val(data.ordOrderType);
				var _order = orderDetailsForEdit.orderDetails;
	
				if (data.ordOrderType != 'B2B') {
					setB2CDestinationTabForExistingOrder(_order);
					setCustomerAddress(data);
					showHideDropFlag(data.ordOrderType, data.ordOrtName);
				} else {
					if ((0, _general.isPresent)(_order)) {
						setB2BDestinationTabForExistingOrder(_order);
						setCustomerAddress(data);
						showHideDropFlag(data.ordOrderType, data.ordOrtName);
					}
				}
			}
		}
	
		function setB2CDestinationTabForExistingOrder(data) {
			customerName.val(data.ordShipToName);
			company.val(data.ordShipToCompany);
			emailTextBox.val(data.ordShipToEmail);
			if (data.ordShipToPhone.length > 10 && data.ordShipToPhone.includes("+")) {
				customerPhoneNumber.val(data.ordShipToPhone.substring(2, data.ordShipToPhone.length));
			} else {
				customerPhoneNumber.val(data.ordShipToPhone);
			}
			if (data.ordSendTrackingInfo == 1) {
				sendTrackingInfoCheck.prop("checked", true);
			} else {
				sendTrackingInfoCheck.prop("checked", false);
			}
		}
	
		function setB2BDestinationTabForExistingOrder(data) {
			var ordShipToCompany = retailerfacilitiesList.find(function (obj) {
				return obj.id == data.ordShipToCompany;
			});
			if ((0, _general.isPresent)(ordShipToCompany)) {
				facilityTypeaheadDiv.show();
				facilityTypeahead.val(data.ordShipToCompany).trigger("change");
			} else {
				facilityTypeaheadDiv.hide();
				facilityTypeTextBoxDiv.show();
				facilityTypeTextBox.val(data.ordShipToCompany);
			}
			contactName.val(data.ordShipToName);
			customerEmail.val(data.ordShipToEmail);
			if (data.ordSendTrackingInfo == 1) {
				sendTrackingInfoCheckB2b.prop("checked", true);
			} else {
				sendTrackingInfoCheckB2b.prop("checked", false);
			}
			if (data.ordShipToPhone.length > 10 && data.ordShipToPhone.includes("+")) {
				phoneNumber.val(data.ordShipToPhone.substring(2, data.ordShipToPhone.length));
			} else {
				phoneNumber.val(data.ordShipToPhone);
			}
		}
	
		function setB2BDestinationTabForNewOrder(data) {
			contactName.val(data.contactname);
			customerEmail.val(data.emailaddress);
			phoneNumber.val(data.phonenumber);
			destinationTabCountry.val(data.country).trigger("change");
			if (data.country == "1" || data.country == "2") {
				stateSelect.val(data.state).trigger("change");
			} else {
				stateTextInput.val(data.state);
			}
			address1.val(data.address1);
			address2.val(data.address2);
			city.val(data.city);
	
			zipCode.val(data.postalcode);
			countriesPhoneCodeSelect.val(data.phonecode).trigger("change");
		}
	
		function setCustomerAddress(data) {
			orderReferenceNumber.val(data.ordParOrderNumber);
			orderReferenceNumber.prop('readonly', true);
			var facilityCountry = countries.find(function (obj) {
				return obj.conCode == data.ordShipToCountry;
			});
			destinationTabCountry.val(facilityCountry.conId).trigger("change");
			if (facilityCountry.conId == "1" || facilityCountry.conId == "2") {
				stateSelect.val(data.ordShipToState).trigger("change");
			} else {
				stateTextInput.val(data.ordShipToState);
			}
			address1.val(data.ordShipToAddress1);
			address2.val(data.ordShipToAddress2);
			city.val(data.ordShipToCity);
			zipCode.val(data.ordShipToZip);
			if ((0, _general.isPresent)(data.ordShipToCountryPhoneCode)) {
				countriesPhoneCodeSelect.val(data.ordShipToCountryPhoneCode).trigger("change");
			} else {
				countriesPhoneCodeSelect.val("+1").trigger("change");
			}
	
			setAddressValidationHiddenFieldValueOnEdit(data);
		}
	
		function setAddressValidationHiddenFieldValueOnEdit(data) {
			var addressResponse = {};
			addressResponse = {
				address1: data.ordShipToAddress1,
				address2: data.ordShipToAddress2,
				stdCity: data.ordShipToCity,
				zip: data.ordShipToZip,
				state: data.ordShipToState,
				stdCountry: destinationTabCountry.val()
			};
			hiddenAddressInput.val(JSON.stringify(addressResponse));
		}
	
		self.checkForAddressValidationBusinessException = function (orderDetailsForEdit) {
			var addressValidationRequired = false;
			if (orderDetailsForEdit != null && orderDetailsForEdit.exceptionLog != null) {
				_underscore2.default.each(orderDetailsForEdit.exceptionLog, function (exception) {
					if ((exception.code === "ERR-ORD-0043" || exception.code === "ERR-ORD-0044") && exception.status !== "Resolved") {
						addressValidationRequired = true;
					}
				});
			}
	
			return addressValidationRequired;
		};
	
		function showInternationlShippingConfigMessage() {
			if (!internationalShippingEnabled && (0, _jquery2.default)('#destination-tab-country  :selected').val() != "1") {
				internationalmsg.show();
			} else {
				internationalmsg.hide();
				validateHsCodeErrorMessage();
			}
		}
	
		function validateHsCodeErrorMessage() {
			var products = productsTableProductsTab.find('.product-data-row');
			products.each(function () {
				var product = (0, _jquery2.default)(this);
				if (product.find(".hs-code-missing").length != 0 && (0, _jquery2.default)('#destination-tab-country  :selected').val() == "1") {
					product.find(".hs-code-missing").remove();
				}
			});
		}
	}

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (mainEl) {
	    var self = this;
	    var current = $('#current');
	    var password1 = $('#newpwd');
	    var password2 = $('#confirmpwd');
	    var uppercaseRequired = $('.one-uppercase-req-checkbox');
	    var lowercaseRequired = $('.one-lowercase-req-checkbox');
	    var numberRequired = $('.one-number-req-checkbox');
	    var minCharRequired = $('.min-characters-req-checkbox');
	    var matchRequired = $('.passwords-match-req-checkbox');
	    var showPassword = $('.show-password-checkbox');
	    var guidelinesList = $('.guidelines-list');
	    var updatePasswordSubmitBtn = $('.update-password-submit-btn');
	    var passGuidelines = $('.pass-guidelines');
	    var passFuncGuidelines = $('.pass-function-guidelines');
	    var updatePasswordMainForm = mainEl.find("form[name*='updatefm']");
	    var currentPasswordErrorMsg = mainEl.find(".invalid-current-message");
	    var emptyCurrentPwdMsg = mainEl.find('.empty-current-password');
	
	    self.init = function () {
	        bindElements();
	        passGuidelines.hide();
	        passFuncGuidelines.hide();
	    };
	
	    function bindElements() {
	        password1.on("keyup", password1Validation);
	        password2.on("keyup", password2Validation);
	        showPassword.on("change", showPasswordFunc);
	        updatePasswordSubmitBtn.on('click', updatePasswordSubmitFunc);
	    }
	
	    function password1Validation() {
	        var passwordInput = password1.val();
	        // Must include at least (1) uppercase character
	        if (passwordInput.search(/[A-Z]/) == -1) {
	            uppercaseRequired.removeAttr('checked');
	        } else {
	            uppercaseRequired.attr('checked', 'checked');
	        }
	        // Must include at least (1) lowercase character
	        if (passwordInput.search(/[a-z]/) == -1) {
	            lowercaseRequired.removeAttr('checked');
	        } else {
	            lowercaseRequired.attr('checked', 'checked');
	        }
	        // Must include at least (1) number
	        if (passwordInput.search(/\d/) == -1) {
	            numberRequired.removeAttr('checked');
	        } else {
	            numberRequired.attr('checked', 'checked');
	        }
	        // Minimum 8 characters
	        if (passwordInput.length < 8) {
	            minCharRequired.removeAttr('checked');
	        } else {
	            minCharRequired.attr('checked', 'checked');
	        }
	    }
	
	    function password2Validation() {
	        // New Password & Confirm Password must match
	        if (password1.val() != password2.val()) {
	            matchRequired.removeAttr('checked');
	        } else {
	            matchRequired.attr('checked', 'checked');
	        }
	    }
	
	    function showPasswordFunc() {
	        if (showPassword.is(":checked")) {
	            password1.prop('type', 'text');
	            password2.prop('type', 'text');
	        } else {
	            password1.prop('type', 'password');
	            password2.prop('type', 'password');
	        }
	    }
	
	    function updatePasswordSubmitFunc(e) {
	        e.preventDefault();
	        passGuidelines.hide();
	        passFuncGuidelines.hide();
	
	        // check password general guidelines
	        var validPassword = true;
	        $.each(guidelinesList, function (index, value) {
	            if (!$(value).is(":checked")) {
	                validPassword = false;
	            }
	        });
	
	        // check password function guidelines
	        var validFuncPassword = true;
	        var passInput = password1.val();
	        var firstName = updatePasswordMainForm.data('first-name');
	        var lastName = updatePasswordMainForm.data('last-name');
	        var retName = updatePasswordMainForm.data('retailer-name');
	        if (passInput.indexOf(firstName) != -1 || passInput.indexOf(lastName) != -1 || retName != '' && passInput.indexOf(retName) != -1) {
	            validFuncPassword = false;
	        }
	
	        //Check current password is empty 
	        var currentPwd = current.val();
	
	        if (_underscore2.default.isEmpty(currentPwd)) {
	            emptyCurrentPwdMsg.removeClass('hidden');
	            currentPasswordErrorMsg.hide();
	        } else if (!validPassword) {
	            emptyCurrentPwdMsg.addClass('hidden');
	            currentPasswordErrorMsg.hide();
	            passGuidelines.show();
	        } else if (!validFuncPassword) {
	            emptyCurrentPwdMsg.addClass('hidden');
	            currentPasswordErrorMsg.hide();
	            passFuncGuidelines.show();
	        } else {
	            emptyCurrentPwdMsg.addClass('hidden');
	            currentPasswordErrorMsg.hide();
	            updatePasswordMainForm.attr('action', updatePasswordMainForm.data('update-url'));
	            updatePasswordMainForm.submit();
	        }
	    }
	};
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	__webpack_require__(180);

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PasswordGuidelinesLogic;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	__webpack_require__(180);
	
	function PasswordGuidelinesLogic(mainEl) {
	    var self = this;
	    var password1 = $('#password1');
	    var password2 = $('#password2');
	    var uppercaseRequired = $('.one-uppercase-req-checkbox');
	    var lowercaseRequired = $('.one-lowercase-req-checkbox');
	    var numberRequired = $('.one-number-req-checkbox');
	    var minCharRequired = $('.min-characters-req-checkbox');
	    var matchRequired = $('.passwords-match-req-checkbox');
	    var showPassword = $('.show-password-checkbox');
	    var guidelinesList = $('.guidelines-list');
	    var updatePasswordSubmitBtn = $('.update-password-submit-btn');
	    var passGuidelines = $('.pass-guidelines');
	    var passFuncGuidelines = $('.pass-function-guidelines');
	    var updatePasswordContainer = $('.update-password-container');
	    var updatePasswordMainForm = $('#fm');
	
	    self.init = function () {
	        bindElements();
	        passGuidelines.hide();
	        passFuncGuidelines.hide();
	    };
	
	    function bindElements() {
	        password1.on("keyup", password1Validation);
	        password2.on("keyup", password2Validation);
	        showPassword.on("change", showPasswordFunc);
	        updatePasswordSubmitBtn.on('click', updatePasswordSubmitFunc);
	    }
	
	    function password1Validation() {
	        var passwordInput = password1.val();
	        // Must include at least (1) uppercase character
	        if (passwordInput.search(/[A-Z]/) == -1) {
	            uppercaseRequired.removeAttr('checked');
	        } else {
	            uppercaseRequired.attr('checked', 'checked');
	        }
	        // Must include at least (1) lowercase character
	        if (passwordInput.search(/[a-z]/) == -1) {
	            lowercaseRequired.removeAttr('checked');
	        } else {
	            lowercaseRequired.attr('checked', 'checked');
	        }
	        // Must include at least (1) number
	        if (passwordInput.search(/\d/) == -1) {
	            numberRequired.removeAttr('checked');
	        } else {
	            numberRequired.attr('checked', 'checked');
	        }
	        // Minimum 8 characters
	        if (passwordInput.length < 8) {
	            minCharRequired.removeAttr('checked');
	        } else {
	            minCharRequired.attr('checked', 'checked');
	        }
	    }
	
	    function password2Validation() {
	        // New Password & Confirm Password must match
	        if (password1.val() != password2.val()) {
	            matchRequired.removeAttr('checked');
	        } else {
	            matchRequired.attr('checked', 'checked');
	        }
	    }
	
	    function showPasswordFunc() {
	        if (showPassword.is(":checked")) {
	            password1.prop('type', 'text');
	            password2.prop('type', 'text');
	        } else {
	            password1.prop('type', 'password');
	            password2.prop('type', 'password');
	        }
	    }
	
	    function updatePasswordSubmitFunc(e) {
	        e.preventDefault();
	        passGuidelines.hide();
	        passFuncGuidelines.hide();
	
	        // check password general guidelines
	        var validPassword = true;
	        $.each(guidelinesList, function (index, value) {
	            if (!$(value).is(":checked")) {
	                validPassword = false;
	            }
	        });
	
	        // check password function guidelines
	        var validFuncPassword = true;
	        var passInput = password1.val();
	        var firstName = updatePasswordMainForm.data('first-name');
	        var lastName = updatePasswordMainForm.data('last-name');
	        var retName = updatePasswordMainForm.data('retailer-name');
	        if (passInput.indexOf(firstName) != -1 || passInput.indexOf(lastName) != -1 || retName != '' && passInput.indexOf(retName) != -1) {
	            validFuncPassword = false;
	        }
	
	        if (!validPassword) {
	            passGuidelines.show();
	        } else if (!validFuncPassword) {
	            passFuncGuidelines.show();
	        } else {
	            updatePasswordMainForm.attr('action', updatePasswordMainForm.data('url'));
	            updatePasswordMainForm.submit();
	        }
	    }
	}

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.displayCustomReporting = displayCustomReporting;
	exports.getDropDownDisplayValue = getDropDownDisplayValue;
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _typeAheadSource = __webpack_require__(71);
	
	var _typeAheadSource2 = _interopRequireDefault(_typeAheadSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function displayCustomReporting(mainEl, appendTo, params, paramDetails) {
	  var values = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var isScheduler = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	  params.content.forEach(function (param) {
	    var value = values[param.crpKey];
	
	    if (param.crpKey === 'DATE_RANGE') {
	      renderDateRangeParam(appendTo, values['DATE_RANGE'], values['DATE_RANGE1'], values['DATE_RANGE2'], isScheduler ? false : true);
	    } else if (param.crpKey === 'WAREHOUSE' || param.crpKey === 'DESTINATION_FACILITY' || param.crpKey === 'RMA_STATUS' || param.crpKey === 'RMA_ADDRESS' || param.crpKey === 'AGING_DAYS' || param.crpKey === 'WAREHOUSE_REQ' || param.crpKey === 'ATT_WS_TYPES' || param.crpKey === 'ATT_DESTINATIONS' || param.crpKey === 'WAREHOUSE_BREAKDOWN' || param.crpKey === 'INCLUDE_INVENTORY' || param.crpKey === 'ITEM_STATUS' || param.crpKey === 'RETAILER_ID_REQ' || param.crpKey === 'STOCK_LEVEL') {
	      var crpDetails = getCrpDropDownDetails(mainEl, param.crpKey, paramDetails);
	      var hasAll = true;
	
	      if (param.crpKey === 'WAREHOUSE_REQ') {
	        hasAll = false;
	
	        if ((0, _general.isBlank)(value) && crpDetails.data && crpDetails.data.length > 0) {
	          value = crpDetails.data[0].facCode || '';
	        }
	      }
	
	      if (param.crpKey === 'RETAILER_ID_REQ') {
	        hasAll = false;
	      }
	      console.log('Value is: ', value);
	
	      renderDropDownParam(appendTo, param.crpKey, crpDetails.detail, crpDetails.data, crpDetails.keyName, crpDetails.valName, value, hasAll);
	    } else if (param.crpKey === 'DATE_RANGE_TYPE') {
	      renderDateRangeTypeParam(appendTo, param.crpKey, paramDetails[param.crpKey], mainEl.data('date-range-types'), value);
	    } else if (param.crpKey === 'RMA_LAST_NAME' || param.crpKey === 'RMA_EMAIL') {
	      renderInputParam(appendTo, param.crpKey, paramDetails[param.crpKey], value);
	    } else if (param.crpKey === 'RMA_NUMBER' || param.crpKey === 'TRACKING_NUMBER' || param.crpKey === 'ORDER_NUMBER' || param.crpKey === 'FXO_STORE') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], { tags: true }, [], '', '', value);
	    } else if (param.crpKey === 'CAS_SKUS') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('cas-skus'), 'cdmValue', 'cdmValue', value);
	    } else if (param.crpKey === 'RETAILER_NAME') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('retailers'), 'rtlName', 'rtlName', value);
	    } else if (param.crpKey === 'CHANNELS') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('channels'), 'parId', 'parName', value);
	    } else if (param.crpKey === 'ADDRESS_TYPES') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('address-types'), 'cdmValue', 'cdmMeaning', value);
	    } else if (param.crpKey === 'CREDIT_TYPES') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('credit-types'), 'cdmValue', 'cdmMeaning', value);
	    } else if (param.crpKey === 'PRODUCTS') {
	      renderRemoteSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], { url: mainEl.data('product-typeahead-url'), data: configureDataCallback({ paramKey: 'likeSku' }), minLengthOfChars: 3 }, value);
	    } else if (param.crpKey === 'SHIPMENTS') {
	      renderRemoteSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], { url: mainEl.data('shipment-typeahead-url'), data: configureDataCallback({ paramKey: 'likeShipmentId' }), minLengthOfChars: 3 }, value);
	    } else if (param.crpKey === 'ORDER_STATUS') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('order-status'), 'cdmValue', 'cdmValue', value);
	    } else if (param.crpKey === 'WORK_ORDER_STATUS') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('work-order-status'), 'cdmValue', 'cdmValue', value);
	    } else if (param.crpKey === 'ATT_FXO_STORE' || param.crpKey === 'ATT_BAN_NUMBER' || param.crpKey === 'ATT_REC_ID' || param.crpKey === 'ITEM_MODEL' || param.crpKey === 'RECEIPT_SERIAL_NUMBER' || param.crpKey === 'RECEIPT_ID') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], { tags: true }, [], '', '', value);
	    } else if (param.crpKey === 'INBOUND_SHIPMENT_STATUS') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('asn-status'), 'cdmValue', 'cdmValue', value);
	    } else if (param.crpKey === 'CATEGORY') {
	      renderSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], {}, mainEl.data('item-categories'), 'catId', 'catName', value);
	    } else if (param.crpKey === 'UPC') {
	      renderRemoteSplitParam(appendTo, param.crpKey, paramDetails[param.crpKey], { url: mainEl.data('upc-typeahead-url'), data: configureDataCallback({ paramKey: 'likeUpc' }), minLengthOfChars: 3 }, value);
	    }
	  });
	}
	
	function getDropDownDisplayValue(mainEl, crpKey, paramDetails, dataKey) {
	  var dddetails = getCrpDropDownDetails(mainEl, crpKey, paramDetails);
	  var retval = '';
	
	  if (crpKey == 'DATE_RANGE') {
	    if (dataKey == "24_HOURS") {
	      retval = "Last 24 Hours";
	    } else if (dataKey == "48_HOURS") {
	      retval = "Last 48 Hours";
	    } else if (dataKey == "7_DAYS") {
	      retval = "Last 7 Days";
	    } else if (dataKey == "30_DAYS") {
	      retval = "Last 30 Days";
	    } else if (dataKey == "90_DAYS") {
	      retval = "Last 90 Days";
	    }
	  } else {
	    if (dddetails) {
	      var dataValues = dataKey.split(',');
	      dataValues.forEach(function (val) {
	        dddetails.data.forEach(function (record, index) {
	          if (record[dddetails.keyName] == val) {
	            if (retval.length > 0) retval += ", ";
	            retval += record[dddetails.valName];
	          }
	        });
	      });
	    } else {
	      retval = dataKey;
	    }
	  }
	
	  return retval;
	}
	
	function getCrpDropDownDetails(mainEl, crpKey, paramDetails) {
	  var retval = null;
	
	  if (crpKey === 'WAREHOUSE' || crpKey === 'DESTINATION_FACILITY' || crpKey === 'WAREHOUSE_REQ') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('facilities');
	    retval.keyName = 'facCode';
	    retval.valName = 'facName';
	  } else if (crpKey === 'DATE_RANGE_TYPE') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('date-range-types');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmMeaning';
	  } else if (crpKey === 'WAREHOUSE_BREAKDOWN') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('facilities-with-breakdown');
	    retval.keyName = 'facCode';
	    retval.valName = 'facName';
	  } else if (crpKey === 'RMA_STATUS') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('rma-statuses');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmMeaning';
	  } else if (crpKey === 'RMA_ADDRESS') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('rma-addresses');
	    retval.keyName = 'cadId';
	    retval.valName = 'cadLocationName';
	  } else if (crpKey === 'AGING_DAYS') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('aging-days');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmMeaning';
	  } else if (crpKey === 'RETAILER_ID_REQ') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('retailers');
	    retval.keyName = 'rtlId';
	    retval.valName = 'rtlName';
	  } else if (crpKey === 'CHANNELS') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('channels');
	    retval.keyName = 'parId';
	    retval.valName = 'parName';
	  } else if (crpKey === 'ADDRESS_TYPES') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('address-types');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmMeaning';
	  } else if (crpKey === 'CREDIT_TYPES') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('credit-types');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmMeaning';
	  } else if (crpKey === 'ATT_WS_TYPES') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('att-ws-types');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmMeaning';
	  } else if (crpKey === 'ATT_DESTINATIONS') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('att-des-types');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmMeaning';
	  } else if (crpKey === 'ORDER_STATUS') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('order-status');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmValue';
	  } else if (crpKey === 'WORK_ORDER_STATUS') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('work-order-status');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmValue';
	  } else if (crpKey === 'INCLUDE_INVENTORY') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('inventory');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmMeaning';
	  } else if (crpKey === 'ITEM_STATUS') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('item-status');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmValue';
	  } else if (crpKey === 'CATEGORY') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('item-categories');
	    retval.keyName = 'catId';
	    retval.valName = 'catName';
	  } else if (crpKey === 'STOCK_LEVEL') {
	    retval = {};
	    retval.detail = paramDetails[crpKey];
	    retval.data = mainEl.data('stock-level');
	    retval.keyName = 'cdmValue';
	    retval.valName = 'cdmMeaning';
	  }
	
	  return retval;
	}
	
	function renderInputParam(appendTo, key, name) {
	  var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	  var inputParam = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(1416), {
	    key: key,
	    name: name,
	    value: value
	  }));
	  inputParam.appendTo(appendTo);
	}
	
	function renderDropDownParam(appendTo, key, name, data, param, display) {
	  var value = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '%';
	  var hasAll = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : true;
	
	  var dropDownParam = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(1415), {
	    key: key,
	    name: name,
	    hasAll: hasAll
	  }));
	  dropDownParam.appendTo(appendTo);
	  var $select2 = dropDownParam.find('select.select2-select');
	
	  $select2.select2();
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: $select2,
	    list: data,
	    valueDataKey: param,
	    textDataKey: display,
	    initialSelectValue: value
	  });
	}
	
	function renderSplitParam(appendTo, key, name) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var data = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var displayId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
	  var displayText = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
	  var value = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
	
	  var hasInitialValue = false;
	  var values = [];
	  if (value != null && value.length > 0 && value != '%') {
	    hasInitialValue = true;
	    values = value.split(',');
	  }
	
	  var splitParam = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(310), {
	    key: key,
	    name: name,
	    hasInitialValue: hasInitialValue,
	    values: ''
	  }));
	
	  splitParam.appendTo(appendTo);
	
	  var $toggler = splitParam.find('.' + key + '-toggler');
	  var $typeAhead = splitParam.find('#' + key + '-values');
	
	  var initialValue = hasInitialValue ? '#' : '%';
	
	  var btnGrp = new _QuickBtnGroup2.default($toggler, {
	    initialActiveKey: initialValue,
	    distributeWidth: true,
	    onBtnClick: function onBtnClick(obj) {
	      if (obj.btnKey === '#') {
	        $typeAhead.parent().removeClass("hidden");
	      } else {
	        $typeAhead.val('').trigger('change');
	        $typeAhead.parent().addClass("hidden");
	      }
	    }
	  });
	  btnGrp.init();
	
	  var dataArr = data;
	  if (displayId != null && displayId.length > 0) {
	    dataArr = _underscore2.default.map(data, function (el) {
	      return { id: el[displayId], text: el[displayText] };
	    });
	  }
	
	  instantiateTypeAhead($typeAhead, options, name, dataArr);
	
	  if (!hasInitialValue) {
	    $typeAhead.parent().addClass("hidden");
	  } else {
	    $typeAhead.val(values).trigger('change');
	  }
	}
	
	function renderDateRangeParam(appendTo) {
	  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '24_HOURS';
	  var dateRange1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var dateRange2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	  var showCustom = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  var dateRangeParam = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(1413), {
	    allowCustomDateRange: showCustom,
	    dropDownValue: value,
	    dateRange1: dateRange1,
	    dateRange2: dateRange2
	  }));
	
	  dateRangeParam.appendTo(appendTo);
	
	  var $select2 = dateRangeParam.find('select.select2-select');
	  $select2.select2();
	
	  function checkDisplayDateRangeSelector() {
	    if (this.value === 'customDate') {
	      appendTo.find("#customDateRangeFields").show();
	
	      appendTo.find("#DATE_RANGE1").datepicker({
	        todayBtn: "linked",
	        keyboardNavigation: false,
	        autoclose: true
	      });
	
	      appendTo.find("#DATE_RANGE2").datepicker({
	        todayBtn: "linked",
	        keyboardNavigation: false,
	        autoclose: true
	      });
	      (0, _jquery2.default)(".create-schedule-btn-w-params").attr('disabled', true);
	      (0, _jquery2.default)(".cannot-schedule-custom-date-warning").removeClass('hide');
	    } else {
	      appendTo.find("#customDateRangeFields").hide();
	      (0, _jquery2.default)(".create-schedule-btn-w-params").attr('disabled', false);
	      (0, _jquery2.default)(".cannot-schedule-custom-date-warning").addClass('hide');
	    }
	  }
	  var dateRangeSelector = appendTo.find("#DATE_RANGE");
	  dateRangeSelector.on("change", checkDisplayDateRangeSelector);
	  dateRangeSelector.trigger("change");
	}
	
	function renderDateRangeTypeParam(appendTo, key, name) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	
	
	  var optionsHtml = _underscore2.default.map(options, function (el, index) {
	    var displayClass = '';
	    var activeClass = '';
	
	    if (index === 0) {
	      displayClass = 'first-child';
	
	      if (value === '') {
	        activeClass = 'active';
	      }
	    }
	
	    if (el.cdmValue === value) {
	      activeClass = 'active';
	    }
	
	    if (index === options.length - 1) {
	      displayClass = 'last-child';
	    }
	
	    return (0, _render2.default)(__webpack_require__(1412), {
	      display: el.cdmMeaning,
	      value: el.cdmValue,
	      displayClass: displayClass,
	      activeClass: activeClass
	    });
	  }).join("");
	
	  var dateRangeTypeParam = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(1414), {
	    key: key,
	    name: name,
	    value: value,
	    options: optionsHtml
	  }));
	
	  dateRangeTypeParam.appendTo(appendTo);
	
	  var $toggler = dateRangeTypeParam.find('.date-range-type-toggler');
	
	  var btnGrp = new _QuickBtnGroup2.default($toggler, {
	    initialActiveKey: value,
	    distributeWidth: true
	  });
	  btnGrp.init();
	}
	
	var select2AjaxDefaults = {
	  dataType: 'json',
	  delay: 250,
	  processResults: function processResults(data, params) {
	    params.page = params.page || 1;
	    return {
	      results: data,
	      pagination: {
	        more: params.page * 20 < data.total_count
	      }
	    };
	  },
	  cache: true
	};
	
	function configureDataCallback(_ref) {
	  var paramKey = _ref.paramKey;
	
	  return function (params) {
	    return _defineProperty({}, paramKey, params.term);
	  };
	}
	
	function renderRemoteSplitParam(appendTo, key, name) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
	
	  var hasInitialValue = false;
	  var values = [];
	  if (value != null && value.length > 0 && value != '%') {
	    hasInitialValue = true;
	    values = value.split(',');
	  }
	
	  var splitParam = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(310), {
	    key: key,
	    name: name,
	    hasInitialValue: hasInitialValue,
	    values: values
	  }));
	
	  splitParam.appendTo(appendTo);
	
	  var $toggler = splitParam.find('.' + key + '-toggler');
	  var $typeAhead = splitParam.find('#' + key + '-values');
	
	  var initialValue = hasInitialValue ? '#' : '%';
	
	  var btnGrp = new _QuickBtnGroup2.default($toggler, {
	    initialActiveKey: initialValue,
	    distributeWidth: true,
	    onBtnClick: function onBtnClick(obj) {
	      if (obj.btnKey === '#') {
	        $typeAhead.parent().removeClass("hidden");
	      } else {
	        $typeAhead.val('').trigger('change');
	        $typeAhead.parent().addClass("hidden");
	      }
	    }
	  });
	  btnGrp.init();
	
	  instantiateRemoteTypeAhead($typeAhead, options, name);
	
	  if (!hasInitialValue) {
	    $typeAhead.parent().addClass("hidden");
	  } else {
	    $typeAhead.val(values).trigger('change');
	  }
	}
	
	function instantiateRemoteTypeAhead(el, options) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
	  el.select2({
	    ajax: _extends({}, select2AjaxDefaults, {
	      url: options.url,
	      data: options.data
	    }),
	    minimumInputLength: options.minLengthOfChars,
	    placeholder: 'Type ' + name,
	    width: '100%'
	  });
	}
	
	function instantiateTypeAhead(el) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	  var $options = _jquery2.default.extend({
	    multiple: true,
	    placeholder: 'Type ' + name,
	    tags: false,
	    data: data,
	    width: '100%'
	  }, options);
	  var typeAhead = el.select2($options);
	}

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = loadModal;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _reportsUtil = __webpack_require__(219);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recipientHtml = __webpack_require__(1417);
	
	__webpack_require__(275);
	
	var scheduleReportUrl = null;
	var reportId = null;
	var receiptCount = 2;
	
	function loadModal(getReportParamsUrl, inpScheduleReportUrl, crtId, reportParamInput, scheduleParams, onSubmitSuccessCallback) {
	  var error = {};
	
	  scheduleReportUrl = inpScheduleReportUrl;
	  reportId = crtId;
	
	  var searchRequest = _jquery2.default.ajax({
	    url: getReportParamsUrl,
	    type: 'POST',
	    data: { reportId: crtId },
	    dataType: 'JSON',
	    // DONT DO THIS
	    // async: false,
	    success: function success(reportParams) {
	      var scheduleModal = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(11), {
	        title: 'Report Scheduling',
	        footerBtns: '<a href="#" class="base-btn v2-btn purple-btn m-close-btn">Cancel</a>\
	          <a href="#" class="base-btn purple-btn schedule-report-btn">Schedule</a>',
	        body: __webpack_require__(1419),
	        modalDialogClass: 'q-modal-dialog-800'
	      }));
	      //Destroy modal on hide
	      scheduleModal.on('hidden.bs.modal', function () {
	        (0, _jquery2.default)(this).data('bs.modal', null);
	        scheduleModal.remove();
	      });
	
	      setupModal(scheduleModal, reportParams, reportParams.paramDetails, reportParamInput, scheduleParams, onSubmitSuccessCallback);
	    },
	    error: error
	  });
	}
	
	var elementsMap = {
	  scheduleModalForm: '.scheduleModalForm',
	  addRecipientButton: '.add-recipient',
	  deleteRecipientButton: '.delete-recipient',
	  recipients: '#recipients',
	  action: '#action',
	  jobId: '#jobId',
	  //Schedule Name
	  scheduleName: '#scheduleName',
	  //Date Range
	  dateRange: '.modal-report-range-selector',
	  //Warehouse
	  warehouseSelect: '.warehouse-select',
	  //Schedule Channel
	  scheduleChannelAll: '#scheduleChannelAll',
	  scheduleChannelSpecific: '#scheduleChannelSpecific',
	  scheduleChannel: '#scheduleChannel',
	  //Schedule Product
	  scheduleProductAll: '#scheduleProductAll',
	  scheduleProductSpecific: '#scheduleProductSpecific',
	  scheduleProduct: '#scheduleProduct',
	  //Schedule Times
	  runDailySched: "#runDailySched",
	  runWeeklySched: "#runWeeklySched",
	  runMonthlySched: "#runMonthlySched",
	  runQuarterlySched: "#runQuarterlySched",
	  runFreqSel: ".modal-run-freq-selector",
	  //Weekly Schedule Handlers
	  weeklyScheduleButtons: ".modal-schedule-day-toggler .q-btn-cube",
	  //Day of Month Handlers
	  dayOfMonth: "#dayOfMonth",
	  specificDay: "#specificDay",
	  specificDayDiv: "#specificDayDiv",
	  //End Date
	  endDateSel: ".modal-schedule-end-date-selector",
	  endDateDiv: ".end-date-input-div",
	  endDateInp: "#endDateInput",
	  //Cancel/Schedule
	  cancelButton: ".m-close-btn",
	  scheduleButton: ".schedule-report-btn",
	  //Recipients
	  recipientEmails: ".schedule-modal-recipients-input",
	  //Time Pickers
	  timePickerZone: ".modal-time-zone-selector",
	  dailyTimeEl: ".time-picker-daily-run",
	  weeklyTimeEl: ".time-picker-weekly-run",
	  //Run Days Selectors
	  scheduleDayToggler: ".modal-schedule-day-toggler ",
	  selectedCubes: ".q-btn-cube.active",
	  dayCubes: ".q-btn-cube"
	};
	
	function setupModal(scheduleModal, reportParams, reportParamDetails, reportParamInput, scheduleParams) {
	  var onSubmitSuccessCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
	
	  //console.log('calling loadModal');
	  //console.log('setupModal.reportParamInput - ', reportParamInput);
	  //console.log('setupModal.scheduleParams - ', scheduleParams);
	
	  var mainEl = (0, _jquery2.default)('.reports-outer');
	  var reportParamsModalInputAnchor = scheduleModal.find('#reportParamsModalInputAnchor');
	  var modalDaysBtnGroupEl = scheduleModal.find('.modal-schedule-day-toggler');
	  var modalDaysBtnGroup = new _QuickBtnGroup2.default(modalDaysBtnGroupEl, { multi: true });
	  modalDaysBtnGroup.init();
	
	  (0, _reportsUtil.displayCustomReporting)(mainEl, reportParamsModalInputAnchor, reportParams, reportParamDetails, reportParamInput, true);
	
	  function showScheduleReportModal() {
	    scheduleModal.modal("show");
	  }
	
	  function hideScheduleReportModal() {
	    scheduleModal.modal("hide");
	  }
	
	  var els = {};
	
	  setElements();
	  setValidator();
	
	  els.dailyTimePicker = (0, _timePicker2.default)(els.dailyTimeEl);
	  els.weeklyTimePicker = (0, _timePicker2.default)(els.weeklyTimeEl);
	
	  /*
	      let timePickerWeeklyRun = scheduleModal.find('.time-picker-weekly-run');
	      timePickerWeeklyRun = timePicker(timePickerWeeklyRun);
	      console.log('timePickerWeeklyRun: ', timePickerWeeklyRun);
	  */
	
	  function setValidator() {
	    var validator = els.scheduleModalForm.validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          (0, _jquery2.default)(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	    validator.settings.ignore = ":disabled,:hidden";
	  }
	
	  function loadJobData() {
	    if (scheduleParams && scheduleParams.jobId) {
	      els.jobId.val(scheduleParams.jobId);
	      els.action.val('Update');
	      els.scheduleName.val(scheduleParams.jobName);
	      els.scheduleName.prop('disabled', true);
	      els.runFreqSel.val(scheduleParams.runFrequency).trigger('change');
	
	      if (scheduleParams.jobEndDate) {
	        els.endDateInp.val(scheduleParams.jobEndDate);
	        els.endDateSel.val('schedEndDate').trigger('change');
	        onEndDateSelChanged();
	      }
	
	      els.dailyTimePicker.setTimeFromMilitary(scheduleParams.runTime);
	      els.weeklyTimePicker.setTimeFromMilitary(scheduleParams.runTime);
	
	      if (scheduleParams.runFrequency == 'Weekly') {
	        var dayEls = els.scheduleDayToggler.find(elementsMap.dayCubes);
	        dayEls.removeClass("active");
	        dayEls.each(function (idx, el) {
	          var btn = (0, _jquery2.default)(el);
	          var day = btn.data("qb-key");
	          var days = scheduleParams.commaSepDays;
	          if (day == 'Sunday' && days.indexOf("1") >= 0) {
	            btn.addClass("active");
	          }
	          if (day == 'Monday' && days.indexOf("2") >= 0) {
	            btn.addClass("active");
	          }
	          if (day == 'Tuesday' && days.indexOf("3") >= 0) {
	            btn.addClass("active");
	          }
	          if (day == 'Wednesday' && days.indexOf("4") >= 0) {
	            btn.addClass("active");
	          }
	          if (day == 'Thursday' && days.indexOf("5") >= 0) {
	            btn.addClass("active");
	          }
	          if (day == 'Friday' && days.indexOf("6") >= 0) {
	            btn.addClass("active");
	          }
	          if (day == 'Saturday' && days.indexOf("7") >= 0) {
	            btn.addClass("active");
	          }
	        });
	      }
	
	      els.dayOfMonth.val(scheduleParams.dayOfMonth);
	      els.specificDay.val(scheduleParams.specificDay);
	
	      var emails = scheduleParams.email.split(';');
	      var emailElArray = els.recipientEmails.toArray();
	      emails.forEach(function (email, index) {
	        if (index < emailElArray.length) {
	          (0, _jquery2.default)(emailElArray[index]).val(email);
	        } else {
	          var emailEl = onAddRecipientClick();
	          emailEl.val(email);
	        }
	      });
	      //console.log('emails: ', emails);
	      //onAddRecipientClick
	
	      // recipients
	      //console.log("reqData: ", reqData)
	    } else {
	      els.action.val('Create');
	    }
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, scheduleModal);
	    els.scheduleModal = scheduleModal;
	  }
	
	  els.addRecipientButton.on('click', onAddRecipientClick);
	  els.deleteRecipientButton.on('click', onRemoveRecipientClick);
	
	  function onAddRecipientClick() {
	    var recipRow = (0, _jquery2.default)((0, _render2.default)(recipientHtml, { index: receiptCount }));
	    receiptCount++;
	    recipRow.appendTo((0, _jquery2.default)(els.recipients));
	    (0, _jquery2.default)(recipRow).find(".delete-recipient").on('click', onRemoveRecipientClick);
	    return recipRow.find('.schedule-modal-recipients-input');
	  }
	
	  function onRemoveRecipientClick() {
	    (0, _jquery2.default)(this).closest(".recipient-row").remove();
	  }
	
	  //
	  // Frequency Selector Handlers
	  //
	  els.runFreqSel.on('change', onFreqSelChanged);
	  els.runFreqSel.select2();
	
	  function onFreqSelChanged() {
	    var val = els.runFreqSel.val();
	
	    if (val == 'Daily') {
	      els.runDailySched.show();
	      els.runWeeklySched.hide();
	      els.runMonthlySched.hide();
	      els.runQuarterlySched.hide();
	    } else if (val == 'Weekly') {
	      els.runDailySched.hide();
	      els.runWeeklySched.show();
	      els.runMonthlySched.hide();
	      els.runQuarterlySched.hide();
	    } else if (val == 'Monthly') {
	      els.runDailySched.hide();
	      els.runWeeklySched.hide();
	      els.runMonthlySched.show();
	      els.runQuarterlySched.hide();
	    } else if (val == 'Quarterly') {
	      els.runDailySched.hide();
	      els.runWeeklySched.hide();
	      els.runMonthlySched.hide();
	      els.runQuarterlySched.show();
	    } else {
	      console.error('invalid frequency selected');
	    }
	  }
	
	  //
	  // Day of Month Handler
	  //
	  els.dayOfMonth.on('change', onDayOfMonthSelChange);
	  els.dayOfMonth.select2();
	  els.specificDay.select2();
	
	  function onDayOfMonthSelChange() {
	    var val = els.dayOfMonth.val();
	
	    if (val === 'SpecificDay') {
	      els.specificDayDiv.show();
	    } else {
	      els.specificDayDiv.hide();
	    }
	  }
	
	  //
	  // Time Zone Picker
	  //
	  els.timePickerZone.select2();
	
	  //
	  // End Date Handlers
	  //
	  els.endDateSel.on('change', onEndDateSelChanged);
	  els.endDateSel.select2();
	
	  function onEndDateSelChanged() {
	    var val = els.endDateSel.val();
	    //console.log('End Date Sel Val: ', val);
	
	    if (val === 'noSchedEndDate') {
	      els.endDateDiv.hide();
	    } else {
	      els.endDateDiv.show();
	    }
	  }
	
	  els.endDateInp.datepicker({
	    startDate: new Date(),
	    todayBtn: "linked",
	    keyboardNavigation: false,
	    autoclose: true
	  });
	
	  //
	  // Cancel Button Handler
	  //
	  els.cancelButton.on('click', onCancelButtonClick);
	
	  function onCancelButtonClick(e) {
	    e.preventDefault();
	    hideScheduleReportModal();
	  }
	
	  //
	  // Schedule Button Handler
	  //
	  els.scheduleButton.on('click', onScheduleButtonClick);
	
	  function onScheduleButtonClick(e) {
	    e.preventDefault();
	    if (isModalValid()) {
	      scheduleOrUpdateReport();
	      //hideScheduleReportModal();
	    }
	  }
	
	  function isModalValid() {
	    var isValid = false;
	    if (els.scheduleModalForm.valid()) {
	      isValid = true;
	    }
	
	    if (els.runFreqSel.val() == 'Daily' && els.endDateSel.val() == 'schedEndDate') {
	      var now = (0, _moment2.default)((0, _general.getESTDate)(new Date()), 'MM/DD/YYYY HH:mm:ss');
	      var dailyTimePicker = (0, _timePicker2.default)(els.dailyTimeEl);
	      var endDateSelectedStr = els.endDateInp.val() + " " + dailyTimePicker.getMilitaryTime() + ":00";
	      var endDateSelectedMoment = (0, _moment2.default)(endDateSelectedStr, 'MM/DD/YYYY HH:mm:ss');
	      if (endDateSelectedMoment.isBefore(now)) {
	        if (now.startOf('day').isSame(endDateSelectedMoment.startOf('day'))) {
	          var errName = (0, _jquery2.default)("#invalidTime");
	          errName.show();
	          errName.html("<label class='error'>Invalid Time</label>");
	        } else {
	          var errName = (0, _jquery2.default)("#invalidDate");
	          errName.show();
	          errName.html("<label class='error'>Invalid End Date</label>");
	        }
	        isValid = false;
	      }
	    }
	
	    return isValid;
	  }
	  function getSelectedDays() {
	    var dayEls = els.scheduleDayToggler.find(elementsMap.selectedCubes);
	    var selectedDays = [];
	    dayEls.each(function (idx, el) {
	      var btn = (0, _jquery2.default)(el);
	      selectedDays.push(btn.data("qb-key"));
	    });
	    return selectedDays;
	  }
	
	  function scheduleOrUpdateReport() {
	    var self = this;
	    var domain = (0, _jquery2.default)("#add-domain-name").val();
	
	    var reqData = {
	      "scheduleName": els.scheduleName.val() || "",
	      "scheduleChannel": els.scheduleChannel.val() || "",
	      "scheduleProduct": els.scheduleProduct.val() || "",
	      "selectedDays": getSelectedDays(),
	      "endDate": els.endDateInp.val() || "",
	      "reportId": reportId,
	      "dayOfMonth": els.dayOfMonth.val(),
	      "specificDay": els.specificDay.val(),
	      "action": els.action.val(),
	      "userAction": els.action.val(),
	      "jobId": els.jobId.val(),
	      "frequency": els.runFreqSel.val()
	    };
	
	    var zone = els.timePickerZone.val();
	    if (zone == null || zone === "") zone = "EST";
	
	    if (reqData.frequency == "Daily") {
	      reqData.scheduleTime = els.dailyTimePicker.getMilitaryTime() + " " + zone;
	    } else if (reqData.frequency == "Weekly") {
	      reqData.scheduleTime = els.weeklyTimePicker.getMilitaryTime() + " " + zone;
	    }
	
	    //console.log("reqData: ", reqData)
	
	    reportParams.content.forEach(function (value) {
	      if (value.crpKey == 'DATE_RANGE') {
	        var data = reportParamsModalInputAnchor.find("#" + value.crpKey).val();
	        var data1 = reportParamsModalInputAnchor.find("#" + value.crpKey + "1").val();
	        var data2 = reportParamsModalInputAnchor.find("#" + value.crpKey + "2").val();
	        reqData[value.crpKey] = data;
	        reqData[value.crpKey + "1"] = data1;
	        reqData[value.crpKey + "2"] = data2;
	      } else {
	        var el = reportParamsModalInputAnchor.find("#" + value.crpKey);
	        var _data = el.val();
	        if (el.hasClass('split-button') && _data === '#') {
	          _data = reportParamsModalInputAnchor.find("#" + value.crpKey + "-values").val().join(",");
	        }
	        reqData[value.crpKey] = _data;
	      }
	    });
	
	    var recStr = '';
	    var first = true;
	    scheduleModal.find(elementsMap.recipientEmails).each(function (index) {
	      if (!first) recStr = recStr + ';';else first = false;
	      recStr = recStr + this.value;
	    });
	
	    reqData.recipients = recStr;
	
	    _jquery2.default.ajax({
	      url: scheduleReportUrl,
	      type: 'POST',
	      data: reqData,
	      dataType: 'JSON',
	      async: true,
	      success: function success(response) {
	        hideScheduleReportModal();
	        location.reload();
	        onSubmitSuccessCallback(response);
	      },
	      error: function error(response) {
	        //console.log('Error on response from scheduleReport: ', response);
	      }
	    });
	  }
	
	  loadJobData();
	  onFreqSelChanged();
	  onEndDateSelChanged();
	  onDayOfMonthSelChange();
	  showScheduleReportModal();
	
	  // scheduleModal.find(".select2-select").each(function(curElem) {
	  //   $(curElem).select2();
	  // });
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ReturnRequestsWizardLogic;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	var productTemplate = __webpack_require__(1424);
	var warehouseProductTemplate = __webpack_require__(1422);
	var reviewProductTemplate = __webpack_require__(1426);
	var reviewWarehouseProductTemplate = __webpack_require__(1427);
	var productAttrTemplate = __webpack_require__(1425);
	var modalHtml = __webpack_require__(11);
	var duplicateSkuTemplate = __webpack_require__(1423);
	
	var unauthPrintHeader = false;
	
	var elementsPageMap = {
	  addProductBtn: '#find-rma-item',
	  addWarehouseProductBtn: '#warehouse-find-rma-item',
	  itmSku: '.itmSku',
	  warehouseitmSku: '.warehouseitmSku',
	  itmUpc: '.itmUpc',
	  warehouseitmUpc: '.warehouseitmUpc',
	  itmDescription: '.itmDescription',
	  warehouseitmDescription: '.warehouseitmDescription',
	  itmBrand: '.itmBrand',
	  itmModel: '.itmModel',
	  warehouseitmModel: '.warehouseitmModel',
	  warehouseRTV: '#warehouseRTV',
	  warehouseRmaNoItemFound: '#warehouse-rma-no-item-found',
	  warehouseRmaNoItemAdded: '#warehouse-rma-no-item-added',
	  rmaLevel: '#rma-level',
	
	  revRmaProdSku: '.rev-rma-prod-sku',
	  revRmaUpc: '.rev-rma-upc',
	  revRmaDesc: '.rev-rma-prod-descrip',
	  revRmaQty: '.rev-rma-qty',
	  revRmaReason: '.rev-rma-reason',
	  revRmaColor: '.rev-rma-color',
	  revRmaBrand: '.rev-rma-brand',
	  revRmaSize: '.rev-rma-size',
	  revRmaModel: '.rev-rma-model',
	  revRmaStyle: '.rev-rma-style',
	  addRmaItmAttrName: ".add-rma-itm-attr-name",
	  addRmaItmAttrValue: ".add-rma-itm-attr-value",
	
	  itmSkuHidden: '.itmSkuHidden',
	  itmSelectBlock: ".product-select-block",
	  itemSkuAlreadyAdded: '#item-sku-already-added',
	  warehouseItemSkuAlreadyAdded: '#warehouse-item-sku-already-added',
	  addRmaProductQuantity: ".add-rma-product-quantity",
	  addRmaProductNo: ".add-rma-order-number",
	  addRmaReturnQuantity: '#add-rma-return-quantity',
	  addRmaReturnQuantityError: '#add-rma-return-quantity-error',
	  addRmaReason: ".add-rma-reason",
	  addRmaReasonDiv: ".add-rma-reason-div",
	  addRmaProductWeignt: ".add-rma-product-weight",
	  addRmaProductWeigntDiv: ".add-rma-product-weight-div",
	  addRmaNotes: ".add-rma-notes",
	  addRmaNotesDiv: ".add-rma-notes-div",
	  addRmaOrderNumber: ".add-rma-order-number",
	  addRmaItmAttr: ".add-rma-itm-attr",
	  reviewRmaItmAttr: ".review-rma-itm-attr",
	  reviewRmaNotes: ".review-rma-notes",
	  itemMarkedAsNonReturnableMsg: ".item-marked-as-non-returnable-msg",
	
	  itmSkuOrUpc: "#find-rma-by-sku-and-upc",
	  warehouseItmSkuUPCModal: "#warehouse-find-itm-by-sku-upc-and-modal",
	  returnFromState: "#rma-state",
	  rmaMultiItemsWarning: "#rma-multi-items-warning",
	
	  addRmaReturnsShipToAddress: '.add-rma-returns-ship-to-address',
	  ifReturnToShipAddressSet: '.if-return-to-ship-address-set',
	  addRmaReturnsShippingService: '.add-rma-returns-shipping-service',
	  ifReturnsShipServiceSet: '.if-returns-ship-service-set',
	  returnsShipServiceMessage: '.returns-ship-service-message',
	  sapConfigMessageSet: '.sap-no-config-set-msg',
	  sapCasSectionMessage: '.sap-cas-section',
	  sapSplCreditMessage: '.sap-spl-cred-section',
	  sapRetLabelMessage: '.sap-ret-label-disp-section',
	  sapRetShipMessage: '.sap-ret-ship-overrides-section',
	  sapDecalredMessage: '.sap-dec-val-section',
	
	  addRmaSpecialCreditProcess: '.add-rma-special-credit-process',
	  specialEarlyCreditMsg: '.special-early-credit-msg',
	  specialNonCreditMsg: '.special-non-credit-msg',
	  specialGiftCreditMsg: '.special-gift-msg',
	
	  addRmaSearchItemDiv: '.add-rma-search-item-div',
	  addWarehouseRmaSearchItemDiv: '.add-warehouse-rma-search-item-div',
	  addRmaProductFinalSale: ".add-rma-product-final-sale",
	  addRmaProductFinalSaleDiv: ".add-rma-product-final-sale-div",
	
	  originalOrderNumberDiv: '.original-order-number',
	
	  originalOrderNumberLabelRequired: '.original-order-number-required',
	  originalOrderNumberLabelNotRequired: '.original-order-number-not-required',
	  addRmaParent: '#add-rma',
	
	  //9043 Fields changes
	  declaredValue: '.add-rma-declared-value',
	  declaredErrorMsg: '.declared-value-error-msg',
	  rmaCustomerIdTypeAhead: "#find-rma-by-address-or-location",
	
	  warehouseCountry: "#warehouse-country",
	  warehouseUsaStateDiv: "#warehouse-usa-state-div",
	  warehouseCanadaProvinceDiv: "#warehouse-canada-province-div",
	  warehouseStateTextDiv: "#warehouse-state-text-div",
	
	  revWhsRmaProdSku: '.rev-whs-rma-prod-sku',
	  revWhsRmaUpc: '.rev-whs-rma-upc',
	  revWhsRmaDesc: '.rev-whs-rma-modal',
	  revWhsRmaQty: '.rev-whs-rma-qty',
	  revWhsRmaRtv: '.rev-whs-rma-rtv',
	  prepaidCollectBtnGrp: '.prepaid-or-collect-btn-toggler'
	};
	
	function ReturnRequestsWizardLogic(mainEl) {
	  var self = this;
	  var elsPage = {};
	  var elsModals = {};
	  var rmaItemCount = 0;
	  var oonVisible = mainEl.data("original-order-number-visible");
	  var oonMandatory = mainEl.data("original-order-number-mandatory");
	  var defaultItemConfig = mainEl.data("default-item-config-for-all-returns");
	  var defaultItem = mainEl.data("default-item-for-all-returns");
	  var captureReturnReason = mainEl.data("capture-return-reason");
	  var captureWeight = mainEl.data("capture-weight");
	  var captureFinalSale = mainEl.data("capture-final-sale");
	  var captureProductNotes = mainEl.data("capture-product-notes");
	  var capturesapAllConfigvisible = mainEl.data("capture-sapall-config-visible");
	  var captureReturnLabelsVisible = mainEl.data("return-label-display-config-visible");
	  var captureReturnShippingOverrideDisplay = mainEl.data("return-shipping-overrides-config-visible");
	  var captureCreditProcessingValue = mainEl.data("return-credit-processing-value");
	  var warehouseLevelRmas = mainEl.data("warehouse-level-rmas");
	
	  var rmaData = mainEl.data("rma-data-json");
	  var rmaId = rmaData.rmaId;
	  var isHoneyComb = mainEl.data('is-honeycomb');
	  var duplicateSkuModal = void 0;
	  var itemSkuGlobal = void 0;
	
	  self.init = function () {
	    setElements();
	    setInitialState();
	    bindElements();
	    hideInitial();
	    renderDuplicateSkuModal();
	
	    var prepaidCollectBtnGrp = elsPage.prepaidCollectBtnGrp;
	    var prepaidCollectBtnToggler = new _QuickBtnGroup2.default(prepaidCollectBtnGrp, {
	      distributeWidth: true
	    });
	    prepaidCollectBtnToggler.init();
	
	    $(".add-rma-product-quantity").change(function () {
	      fillDynamicContentToWizard();
	    });
	
	    // edit functionality starts here
	    if (rmaData.rmaId != null && rmaData.rmaId != "") {
	      var rmaItems = rmaData.rmaItemDetails;
	      var rmaItemDetailUnAuthList = rmaData.rmaItemDetailUnAuthList;
	
	      // Customer ID
	      $("#find-rma-by-address-or-location").append("<option value=\"" + rmaData.rmaWarehouseCustomerID + "\">" + rmaData.rmaWarehouseCustomerID + "</option>");
	      $("#find-rma-by-address-or-location").val(rmaData.rmaWarehouseCustomerID).trigger("change");
	      // Shipping Required
	      if (rmaData.rmaShippingRequired) {
	        $('.rmaShippingYes').attr('checked', 'checked');
	      } else {
	        $('.rmaShippingNo').attr('checked', 'checked');
	      }
	      // Prepaid or Collect
	      prepaidCollectBtnToggler.activateBtnViaKey(rmaData.rmaWarehousePrepaidCollect);
	
	      // Returning Products
	      // Unauth Item
	      if (rmaItemDetailUnAuthList) {
	        for (var i = 0; i < rmaItemDetailUnAuthList.length; i++) {
	          if (i == 0) {
	            unauthPrintHeader = true;
	          }
	          elsPage.addWarehouseRmaSearchItemDiv.append(buildWarehouseProductEdit(rmaData, rmaItemDetailUnAuthList[i], i));
	          fillDynamicContentToWizard();
	          unauthPrintHeader = false;
	        }
	      }
	
	      //Auth Items
	      if (rmaItems) {
	        for (var _i = 0; _i < rmaItems.length; _i++) {
	          elsPage.addWarehouseRmaSearchItemDiv.append(buildWarehouseProductEdit(rmaData, rmaItems[_i], _i));
	          fillDynamicContentToWizard();
	        }
	      }
	
	      // Processing & Shipping tab
	      $("#return-ship-to-address").val(rmaData.rmaShipments[0].returnAddress.cadId).trigger("change");
	
	      // Review tab
	      //$("#find-rma-by-address-or-location").val(rmaData.rmaWarehouseCustomerID);
	    }
	  };
	
	  function buildWarehouseProductEdit(rmaData, rmaItems, rmaItemCount) {
	
	    rmaItemCount = $(".warehouse-item-returning-loop-wrapper").length;
	
	    var formObjName = "rmaItemDetails";
	    var formIndexElement = formObjName + "[" + rmaItemCount + "]";
	    var warehouseProductEl = (0, _render2.default)(warehouseProductTemplate, {
	      formIndexEle: formIndexElement,
	      sku: rmaItems.itemSku,
	      upc: rmaItems.itemUpc,
	      model: rmaItems.itmModel,
	      skuHidden: rmaItems.itemSku,
	      itemExpectedQty: rmaItems.itemExpectedQty,
	      rtvNum: rmaItems.rmaItemRtvNumber,
	      rmdId: rmaItems.rmdId,
	      rmdAmlStatus: rmaItems.rmdAmlStatus,
	      rmaFromCountry: rmaData.rmaFromCountry,
	      rmaItemCount: rmaItemCount,
	      unauthPrintHeader: unauthPrintHeader,
	      showOrHide: "show"
	    });
	    return warehouseProductEl;
	  }
	
	  function setInitialState() {
	    instantiateRmaCustomerIdTypeAhead();
	    var rmaCustomerIdLookup = elsPage.rmaCustomerIdTypeAhead;
	    rmaCustomerIdLookup.on("select2:select", function () {
	      var res = rmaCustomerIdLookup.select2('data')[0].text;
	      var shipToAddressId = rmaCustomerIdLookup.select2('data')[0].shipAddressId;
	      $("#return-ship-to-address").val(shipToAddressId).trigger("change");
	    });
	  };
	
	  function instantiateRmaCustomerIdTypeAhead() {
	    var select2AjaxDefaults = {
	      dataType: 'json',
	      delay: 250,
	      async: false,
	      processResults: function processResults(data, params) {
	        params.page = params.page || 1;
	        return {
	          results: data,
	          pagination: {
	            more: params.page * 20 < data.total_count
	          }
	        };
	      },
	      cache: true
	
	    };
	
	    function configureDataCallback(_ref) {
	      var paramKey = _ref.paramKey;
	
	      return function (params) {
	        return _defineProperty({}, paramKey, params.term);
	      };
	    }
	
	    elsPage.rmaCustomerIdTypeAhead.select2({
	      placeholder: "Select Customer ID",
	      allowClear: true,
	      ajax: _extends({}, select2AjaxDefaults, {
	        url: elsPage.rmaCustomerIdTypeAhead.data('get-rma-customer-id-list'),
	        data: configureDataCallback({ paramKey: 'cmrAddressByAddressIdOrLocation' }),
	        templateResult: function templateResult(result) {
	          return result.text;
	        }
	      }),
	      minimumInputLength: 3
	    });
	  }
	
	  function hideInitial() {
	    elsPage.rmaMultiItemsWarning.hide();
	    elsPage.itemMarkedAsNonReturnableMsg.hide();
	    hideAllCreditInfo();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, mainEl);
	  }
	
	  function bindElements() {
	    var rmaSelectedLevel = elsPage.rmaLevel.val();
	    if (rmaSelectedLevel == 'warehouse' || rmaSelectedLevel == 'customer') {
	      elsPage.addWarehouseProductBtn.click(function (e) {
	        verifyWarehouse(elsPage.warehouseItmSkuUPCModal.val());
	      });
	    } else {
	      elsPage.addProductBtn.click(function (e) {
	        verify(elsPage.itmSkuOrUpc.val());
	      });
	    }
	
	    elsPage.addRmaReturnQuantity.on('keyup', function (e) {
	      if ($(this).val() > 1) {
	        elsPage.addRmaReturnQuantityError.hide();
	      }
	    });
	
	    $(document).on("click", ".rma-item-remove", fillDynamicContentToWizard);
	    elsPage.addRmaSearchItemDiv.on("change", fillDynamicContentToWizard);
	    $(document).on("click", ".warehouse-rma-item-remove", fillDynamicContentToWizard);
	    elsPage.addWarehouseRmaSearchItemDiv.on("change", fillDynamicContentToWizard);
	
	    elsPage.addRmaReturnsShipToAddress.on("change", function () {
	      if ((0, _general.isBlank)(elsPage.addRmaReturnsShipToAddress.val()) || elsPage.addRmaReturnsShipToAddress.val() == '0') {
	        elsPage.ifReturnToShipAddressSet.hide();
	      } else {
	        elsPage.ifReturnToShipAddressSet.show();
	      }
	    });
	    elsPage.addRmaReturnsShippingService.on("change", function () {
	      if (elsPage.addRmaReturnsShippingService.val() == '') {
	        elsPage.ifReturnsShipServiceSet.hide();
	      } else {
	        if (elsPage.addRmaReturnsShippingService.val() == 'SP') {
	          elsPage.returnsShipServiceMessage.html("All products in this return will be shipped with this shipping service unless an event occurs where SmartPost is unavailable. In that case, the return will be defaulted to ship Ground.");
	        } else {
	          elsPage.returnsShipServiceMessage.html("All products in this return will be shipped with this shipping service.");
	        }
	        elsPage.ifReturnsShipServiceSet.show();
	      }
	    });
	    elsPage.addRmaSpecialCreditProcess.on("change", handleCreditChange);
	
	    //9043 Declared Value Validation
	    elsPage.declaredErrorMsg.hide();
	    elsPage.declaredValue.on("change", function () {
	      var declaredVal = parseFloat(elsPage.declaredValue.val()).toFixed(2);
	      elsPage.declaredValue.val(declaredVal);
	      elsPage.declaredErrorMsg.hide();
	      if (isHoneyComb == 'HONEYCOMB_RMS') {
	        if (elsPage.addRmaReturnsShippingService.val() == 'SP' && elsPage.declaredValue.val() > 999) {
	          elsPage.declaredErrorMsg.show();
	        } else {
	          elsPage.declaredErrorMsg.hide();
	        }
	      } else {
	        if (elsPage.addRmaReturnsShippingService.val() == 'SP' && elsPage.declaredValue.val() > 100) {
	          elsPage.declaredErrorMsg.show();
	        } else {
	          elsPage.declaredErrorMsg.hide();
	        }
	      }
	    });
	    if (capturesapAllConfigvisible) {
	      elsPage.sapConfigMessageSet.show();
	      elsPage.sapCasSectionMessage.hide();
	      elsPage.sapSplCreditMessage.hide();
	      elsPage.sapRetLabelMessage.hide();
	      elsPage.sapRetShipMessage.hide();
	      elsPage.sapDecalredMessage.hide();
	    } else {
	      elsPage.sapConfigMessageSet.hide();
	    }
	
	    if (captureReturnLabelsVisible) {
	      elsPage.sapRetLabelMessage.hide();
	    }
	
	    if (captureReturnShippingOverrideDisplay) {
	      elsPage.sapRetShipMessage.hide();
	    }
	
	    if (defaultItemConfig) {
	      elsPage.itmSkuOrUpc.removeAttr("multiple");
	      elsPage.itmSkuOrUpc.removeClass("quick-toggler");
	      elsPage.itmSkuOrUpc.addClass("select2-select");
	      (0, _selectorHelpers.setOptionsForSelect)({
	        selectElement: elsPage.itmSkuOrUpc,
	        list: defaultItem,
	        valueDataKey: "itmSku",
	        textDataKey: "itmSku",
	        initialSelectValue: function initialSelectValue() {
	          return defaultItem[0].itmSku;
	        }
	      });
	    } else {
	      elsPage.itmSkuOrUpc.select2({
	        ajax: _extends({}, select2AjaxDefaults, {
	
	          url: $("#find-rma-by-sku-and-upc").data('url'),
	          data: configureDataCallback({ paramKey: 'itmSkuOrUpc' }),
	          templateResult: function templateResult(result) {
	            return result.text;
	          }
	        }),
	        minimumInputLength: 3
	      });
	
	      elsPage.itmSkuOrUpc.on("select2:select", function (e) {
	        verify(this.value);
	        elsPage.itmSkuOrUpc.val(null).trigger('change');
	      });
	    }
	
	    //HB-11513 Start Initiated the Warehouse Select2 no default item config required for us
	    elsPage.warehouseItmSkuUPCModal.select2({
	      ajax: _extends({}, select2AjaxDefaults, {
	
	        url: $("#warehouse-find-itm-by-sku-upc-and-modal").data('url'),
	        data: configureDataCallback({ paramKey: 'itmSkuOrUpc' }),
	        templateResult: function templateResult(result) {
	          return result.text;
	        }
	      }),
	      minimumInputLength: 3
	    });
	
	    elsPage.warehouseItmSkuUPCModal.on("select2:select", function (e) {
	      verifyWarehouse(this.value);
	      elsPage.warehouseItmSkuUPCModal.val(null).trigger('change');
	    });
	    //HB-11513 end
	    // Click event from duplicate sku modal
	    $(document).on("click", '.duplicate-sku-close-modal', hideDuplicateSkuModal);
	    $(document).on("click", '.duplicate-sku-add-button', addDuplicateSkuFromModal);
	
	    var shipToAddress = $("#return-ship-to-address");
	    var shipToAddressOptions = shipToAddress.find('option').each(function (el) {
	      return el;
	    });
	    var canadaOptions = _underscore2.default.filter(shipToAddressOptions, function (v) {
	      return v.innerText.match(/CA/g);
	    });
	    var usOptions = _underscore2.default.filter(shipToAddressOptions, function (v) {
	      return v.innerText.match(/US/g);
	    });
	
	    elsPage.warehouseCountry.on("change", warehouseCountryOnChange);
	
	    function warehouseCountryOnChange(e) {
	      if (elsPage.warehouseCountry.val() === 'US') {
	        elsPage.warehouseUsaStateDiv.show();
	        elsPage.warehouseCanadaProvinceDiv.hide();
	        elsPage.warehouseStateTextDiv.hide();
	        if (warehouseLevelRmas) {
	          shipToAddress.empty().append(usOptions);
	        }
	      } else if (elsPage.warehouseCountry.val() === 'CA') {
	        elsPage.warehouseUsaStateDiv.hide();
	        elsPage.warehouseCanadaProvinceDiv.show();
	        elsPage.warehouseStateTextDiv.hide();
	        if (warehouseLevelRmas) {
	          shipToAddress.empty().append(canadaOptions);
	        }
	      } else {
	        elsPage.warehouseUsaStateDiv.hide();
	        elsPage.warehouseCanadaProvinceDiv.hide();
	        elsPage.warehouseStateTextDiv.show();
	        if (warehouseLevelRmas) {
	          shipToAddress.empty().append(shipToAddressOptions);
	        }
	      }
	    }
	
	    var initialCountryValue = $("#warehouse-country").val();
	    if (initialCountryValue == "US") {
	      elsPage.warehouseCountry.val(initialCountryValue).trigger("change");
	    }
	  }
	
	  function handleCreditChange() {
	    hideAllCreditInfo();
	
	    switch ($(this).val()) {
	      case "EC":
	        elsPage.specialEarlyCreditMsg.show();
	        break;
	      case "DC":
	        elsPage.specialNonCreditMsg.show();
	        break;
	      case "GO":
	        elsPage.specialGiftCreditMsg.show();
	        break;
	      default:
	        break;
	    }
	  }
	
	  function hideAllCreditInfo() {
	    elsPage.specialEarlyCreditMsg.hide();
	    elsPage.specialNonCreditMsg.hide();
	    elsPage.specialGiftCreditMsg.hide();
	  }
	
	  function displayMultiItemMsg() {
	    if (elsPage.addRmaSearchItemDiv.find(".item-returning-loop-wrapper").length > 1) {
	      elsPage.rmaMultiItemsWarning.show();
	    } else {
	      elsPage.rmaMultiItemsWarning.hide();
	    }
	  }
	
	  //HB-11513 start
	  function buildWarehouseProduct(dataObj, rmaItemCount) {
	
	    var rmaItems = rmaData.rmaItemDetails;
	
	    rmaItemCount = $(".warehouse-item-returning-loop-wrapper").length + 100;
	
	    var maxValue = rmaItemCount;
	    $(".add-warehouse-rma-product-quantity").each(function (index, obj) {
	      var qtyName = $(this).attr("name");
	      var regExp = /\[.+\]/g;
	      var matches = qtyName.match(regExp);
	      var qtyValue = parseInt(matches[0].replace("[", "").replace("]", ""));
	      if (qtyValue >= maxValue) {
	        maxValue = qtyValue;
	      }
	    });
	
	    rmaItemCount = maxValue + 1;
	
	    var formObjName = "rmaItemDetails";
	    var formIndexElement = formObjName + "[" + rmaItemCount + "]";
	
	    if ((0, _general.isBlank)(dataObj.itmReturnable) || (0, _general.isFalsey)(dataObj.itmReturnable)) {
	      formObjName = "nonReturnableItemDetails";
	    }
	
	    var warehouseProductEl = (0, _render2.default)(warehouseProductTemplate, {
	      formIndexEle: formIndexElement,
	      sku: dataObj.itmSku,
	      upc: dataObj.itmUpc,
	      model: dataObj.itmModel,
	      skuHidden: dataObj.itmSku,
	      rmdAmlStatus: dataObj.rmdAmlStatus,
	      rmaFromCountry: dataObj.rmaFromCountry,
	      rmaItemCount: rmaItemCount,
	      showOrHide: "hide"
	    });
	
	    return warehouseProductEl;
	  }
	  //HB-11513 end
	  function buildProduct(dataObj, rmaItemCount) {
	    var formObjName = "rmaItemDetails";
	    if ((0, _general.isBlank)(dataObj.itmReturnable) || (0, _general.isFalsey)(dataObj.itmReturnable)) {
	      formObjName = "nonReturnableItemDetails";
	    }
	    var productEl = $(productTemplate);
	    productEl.find(elementsPageMap.itemMarkedAsNonReturnableMsg).hide();
	
	    evaluateOrderNumberConfiguration(oonVisible, oonMandatory, productEl);
	
	    var sku = productEl.find(elementsPageMap.itmSku);
	    sku.text(dataObj.itmSku);
	    var upc = productEl.find(elementsPageMap.itmUpc);
	    upc.text(dataObj.itmUpc);
	    var description = productEl.find(elementsPageMap.itmDescription);
	    description.text(dataObj.product.prdName);
	    var brand = productEl.find(elementsPageMap.itmBrand);
	    brand.text(dataObj.itmBrand);
	    var model = productEl.find(elementsPageMap.itmModel);
	    model.text(dataObj.itmModel);
	
	    // painting product attributes on review page
	    $(dataObj.itemsAttributes).each(function (i, v) {
	      var procutAttrEl = $(productAttrTemplate);
	      var attrName = procutAttrEl.find(elementsPageMap.addRmaItmAttrName);
	      var attrValue = procutAttrEl.find(elementsPageMap.addRmaItmAttrValue);
	      attrName.text(v.itaAttributeKey);
	      attrValue.text(v.itaAttributeValue);
	      var addRmaItmAttrEle = productEl.find(".add-rma-itm-attr");
	      addRmaItmAttrEle.append(procutAttrEl);
	    });
	
	    var skuHidden = productEl.find(elementsPageMap.itmSkuHidden);
	    skuHidden.val(dataObj.itmSku);
	    skuHidden.attr('name', formObjName + "[" + rmaItemCount + "].itemSku");
	
	    var addRmaProductQuantityVar = productEl.find(elementsPageMap.addRmaProductQuantity);
	    addRmaProductQuantityVar.attr('name', formObjName + "[" + rmaItemCount + "].itemExpectedQty");
	    var addRmaProductOrderNo = productEl.find(elementsPageMap.addRmaProductNo);
	    addRmaProductOrderNo.attr('name', formObjName + "[" + rmaItemCount + "].rmdOrderNumber");
	
	    showOrHideProductCaptures(productEl, captureReturnReason, elementsPageMap.addRmaReasonDiv, elementsPageMap.addRmaReason, formObjName, rmaItemCount, "returnReason");
	    showOrHideProductCaptures(productEl, captureFinalSale, elementsPageMap.addRmaProductFinalSaleDiv, elementsPageMap.addRmaProductFinalSale, formObjName, rmaItemCount, "rmdFinalSaleItem");
	    showOrHideProductCaptures(productEl, captureWeight, elementsPageMap.addRmaProductWeigntDiv, elementsPageMap.addRmaProductWeignt, formObjName, rmaItemCount, "rmdWeight");
	    showOrHideProductCaptures(productEl, captureProductNotes, elementsPageMap.addRmaNotesDiv, elementsPageMap.addRmaNotes, formObjName, rmaItemCount, "rmdNotes");
	
	    if ((0, _general.isTruthy)(captureReturnReason)) {
	      var selectEl = productEl.find(elementsPageMap.itmSelectBlock);
	      selectEl.select2({ data: getReturnReasonData(dataObj.returnResons) });
	    }
	    if ((0, _general.isBlank)(dataObj.itmReturnable) || (0, _general.isFalsey)(dataObj.itmReturnable)) {
	      productEl.find(elementsPageMap.itemMarkedAsNonReturnableMsg).show();
	    }
	    return productEl;
	  }
	
	  function showOrHideProductCaptures(productEl, showCapture, divClassName, inputElementClassName, formObjName, rmaItemCount, propertyName) {
	    if ((0, _general.isTruthy)(showCapture)) {
	      var addRmaCaptureVar = productEl.find(inputElementClassName);
	      addRmaCaptureVar.attr('name', formObjName + "[" + rmaItemCount + "]." + propertyName);
	    } else {
	      productEl.find(divClassName).hide();
	    }
	  }
	
	  function appendProductAttr(itemsAttributes) {
	    itemsAttributes.each(function (i, v) {
	      var procutAttrEl = $(productAttrTemplate);
	      var attrName = procutAttrEl.find(elementsPageMap.addRmaItmAttrName);
	      var attrValue = procutAttrEl.find(elementsPageMap.addRmaItmAttrValue);
	      attrName.text(v.itaAttributeKey);
	      attrValue.text(v.itaAttributeValue);
	      var addRmaItmAttrEle = productEl.find(".add-rma-itm-attr");
	      addRmaItmAttrEle.append(procutAttrEl);
	    });
	  }
	
	  function getReturnReasonData(returnReasonDataObj) {
	    var returnReasonArray = [];
	    $(returnReasonDataObj).each(function (i, v) {
	      var row = {};
	      row.id = v.cdmValue;
	      row.text = v.cdmMeaning;
	      returnReasonArray.push(row);
	    });
	    return returnReasonArray;
	  }
	
	  var searchItem = function searchItem(searchedValue, addSkuCalledFromModal) {
	    var itemSkuOnPage = [];
	    elsPage.addRmaSearchItemDiv.find(".itmSku").each(function (i, v) {
	      itemSkuOnPage.push($(v).text());
	    });
	    var itemSkuInput = searchedValue;
	    itemSkuGlobal = searchedValue;
	    if (itemSkuOnPage.indexOf(itemSkuInput) == -1 || addSkuCalledFromModal) {
	      $.ajax({
	        url: elsPage.addProductBtn.data('url'),
	        type: 'POST',
	        dataType: 'json',
	        data: {
	          itmSkuOrUpc: itemSkuInput,
	          returnFromState: elsPage.returnFromState.val()
	        },
	        beforeSend: function beforeSend() {
	          $.blockUI({ message: 'Please Wait...' });
	        },
	        complete: function complete() {
	          $.unblockUI();
	        },
	        success: function success(resp) {
	          if (resp.data && resp.data != null && resp.data != 'null') {
	            if (resp.data.length === 1) {
	              var item = resp.data[0];
	              var _itemSkuOnPage = [];
	              elsPage.addRmaSearchItemDiv.find(".itmSku").each(function (i, v) {
	                _itemSkuOnPage.push($(v).text());
	              });
	              if (_itemSkuOnPage.indexOf(item.itmSku) === -1 || addSkuCalledFromModal) {
	                elsPage.addRmaSearchItemDiv.append(buildProduct(item, rmaItemCount));
	                rmaItemCount = rmaItemCount + 1;
	                elsPage.itmSkuOrUpc.val('');
	                fillDynamicContentToWizard();
	                // displayMultiItemMsg();
	              } else {
	                displayDuplicateSkuModal();
	                // comment below error and open modal for duplicate sku
	                // elsPage.itemSkuAlreadyAdded.show();
	              }
	            } else {
	              AddRmaObj.displayUpcModal(resp.data);
	              elsPage.itmSkuOrUpc.val('');
	            }
	          } else if (resp.data == null || resp.data == 'null') {
	            AddRmaObj.manualRmaItemSrchNull();
	          } else {
	            alert("Error in getting Item details");
	          }
	        },
	        error: function error(xhr, status, _error) {
	          alert("Error in getting Item details");
	        }
	      });
	    } else {
	      displayDuplicateSkuModal(); // comment below error and open modal for duplicate sku
	      // elsPage.itemSkuAlreadyAdded.show();
	    }
	  };
	
	  var searchWarehouseItem = function searchWarehouseItem(searchedValue, addSkuCalledFromModal) {
	    var itemSkuOnPage = [];
	    elsPage.addWarehouseRmaSearchItemDiv.find(".warehouseitmSku").each(function (i, v) {
	      itemSkuOnPage.push($(v).text());
	    });
	    var itemSkuInput = searchedValue;
	    itemSkuGlobal = searchedValue;
	    if (itemSkuOnPage.indexOf(itemSkuInput) == -1 || addSkuCalledFromModal) {
	      $.ajax({
	        url: elsPage.addWarehouseProductBtn.data('url'),
	        type: 'POST',
	        dataType: 'json',
	        data: {
	          itmSkuOrUpc: itemSkuInput,
	          returnFromState: elsPage.returnFromState.val()
	        },
	        beforeSend: function beforeSend() {
	          $.blockUI({ message: 'Please Wait...' });
	        },
	        complete: function complete() {
	          $.unblockUI();
	        },
	        success: function success(resp) {
	          if (resp.data && resp.data != null && resp.data != 'null') {
	            if (resp.data.length === 1) {
	              var item = resp.data[0];
	              var _itemSkuOnPage2 = [];
	              elsPage.addWarehouseRmaSearchItemDiv.find(".warehouseitmSku").each(function (i, v) {
	                _itemSkuOnPage2.push($(v).text());
	              });
	              if (_itemSkuOnPage2.indexOf(item.warehouseitmSku) === -1 || addSkuCalledFromModal) {
	                elsPage.addWarehouseRmaSearchItemDiv.append(buildWarehouseProduct(item, rmaItemCount));
	                rmaItemCount = rmaItemCount + 1;
	                elsPage.itmSkuOrUpc.val('');
	                fillDynamicContentToWizard();
	                // displayMultiItemMsg();
	              } else {
	                displayDuplicateSkuModal();
	                // comment below error and open modal for duplicate sku
	                // elsPage.itemSkuAlreadyAdded.show();
	              }
	            } else {
	              AddRmaObj.displayUpcModal(resp.data);
	              elsPage.itmSkuOrUpc.val('');
	            }
	          } else if (resp.data == null || resp.data == 'null') {
	            AddRmaObj.manualRmaItemSrchNull();
	          } else {
	            alert("Error in getting Item details");
	          }
	        },
	        error: function error(xhr, status, _error2) {
	          alert("Error in getting Item details");
	        }
	      });
	    } else {
	      displayDuplicateSkuModal(); // comment below error and open modal for duplicate sku
	      // elsPage.itemSkuAlreadyAdded.show();
	    }
	  };
	
	  function fillDynamicContentToWizard() {
	    var rmaSelectedLevel = elsPage.rmaLevel.val();
	    if (rmaSelectedLevel == 'warehouse') {
	      var _containerForItemsRevPg = $('.review-warehouse-rma-item-outer');
	      _containerForItemsRevPg.children().remove();
	      var _content = [];
	      $.each($(".warehouse-item-returning-loop-wrapper"), function (i, v) {
	        _content.push({
	          revWhsRmaProdSku: $(v).find(".warehouseitmSku").text(),
	          revWhsRmaUpc: $(v).find(".warehouseitmUpc").text(),
	          revWhsRmaDesc: $(v).find(".warehouseitmModel").text(),
	          revWhsRmaQty: $(v).find(".add-warehouse-rma-product-quantity").val(),
	          revWhsRmaRtv: $(v).find("#warehouseRTV").val()
	        });
	      });
	      var reviewProdElArray = (0, _underscore2.default)(_content).map(buildWarehouseReviewProduct);
	      _containerForItemsRevPg.append(reviewProdElArray);
	    } else {
	      var containerForItemsRevPg = $('.review-rma-item-outer');
	      containerForItemsRevPg.children().remove();
	      var content = [];
	      $.each($(".item-returning-loop-wrapper"), function (i, v) {
	        content.push({
	          itmSku: $(v).find(".itmSku").text(),
	          itmUpc: $(v).find(".itmUpc").text(),
	          itmDescription: $(v).find(".itmDescription").text(),
	          itmAttr: $(v).find(".add-rma-itm-attr"),
	
	          addRmaProductQty: $(v).find(".add-rma-product-quantity").val(),
	          addRmaReason: $(v).find(".add-rma-reason option:selected").text(),
	          addRmaOrderNumber: $(v).find(".add-rma-order-number").val(),
	          addRmaFinalSale: $(v).find(".add-rma-product-final-sale").is(':checked'),
	          addRmaProductWeight: $(v).find(".add-rma-product-weight").val(),
	          addRmaNotes: $(v).find(".add-rma-notes").val()
	        });
	      });
	      var _reviewProdElArray = (0, _underscore2.default)(content).map(buildReviewProduct);
	      containerForItemsRevPg.append(_reviewProdElArray);
	
	      displayMultiItemMsg();
	    }
	  }
	
	  function buildWarehouseReviewProduct(dataObj) {
	    var warehouseReviewProductEl = (0, _render2.default)(reviewWarehouseProductTemplate, {
	      sku: dataObj.revWhsRmaProdSku,
	      upc: dataObj.revWhsRmaUpc,
	      desc: dataObj.revWhsRmaDesc,
	      qty: dataObj.revWhsRmaQty,
	      rtv: dataObj.revWhsRmaRtv
	    });
	
	    return warehouseReviewProductEl;
	  };
	
	  function buildReviewProduct(dataObj) {
	    var reviewProductEl = $(reviewProductTemplate);
	    var sku = reviewProductEl.find(elementsPageMap.revRmaProdSku);
	    sku.text(dataObj.itmSku);
	    var upc = reviewProductEl.find(elementsPageMap.revRmaUpc);
	    upc.text(dataObj.itmUpc);
	    var desc = reviewProductEl.find(elementsPageMap.revRmaDesc);
	    desc.text(dataObj.itmDescription);
	
	    var reviewRmaItmAttrVar = reviewProductEl.find(elementsPageMap.reviewRmaItmAttr);
	    $.each(dataObj.itmAttr.find(".add-rma-itm-attr-div"), function (i, v) {
	      var procutAttrEl = $(productAttrTemplate);
	      var attrName = procutAttrEl.find(elementsPageMap.addRmaItmAttrName);
	      var attrValue = procutAttrEl.find(elementsPageMap.addRmaItmAttrValue);
	      attrName.text($(v).find(".add-rma-itm-attr-name").text());
	      attrValue.text($(v).find(".add-rma-itm-attr-value").text());
	      reviewRmaItmAttrVar.append(procutAttrEl);
	      if (defaultItemConfig) {
	        $(".add-rma-itm-attr-dropdown").hide();
	      }
	    });
	
	    // Add add rma product attr - Final Sale to review page
	    addMoreProductAttrToReviewTab(captureFinalSale, reviewRmaItmAttrVar, 'Final Sale:', dataObj.addRmaFinalSale, true);
	    // Add add rma product attr - Original Order Number to review page
	    addMoreProductAttrToReviewTab(oonVisible, reviewRmaItmAttrVar, 'Original Order Number:', dataObj.addRmaOrderNumber, false);
	    // Add add rma product attr - Vendor Authorization Number to review page
	    // addMoreProductAttrToReviewTab(reviewRmaItmAttrVar, 'Vendor Authorization Number:', dataObj.addRmaOrderNumber, false);
	    addMoreProductAttrToReviewTab(captureReturnReason, reviewRmaItmAttrVar, 'Reason For Return:', dataObj.addRmaReason, false);
	    addMoreProductAttrToReviewTab(captureWeight, reviewRmaItmAttrVar, 'Weight:', dataObj.addRmaProductWeight, false);
	    var notes = reviewProductEl.find(elementsPageMap.reviewRmaNotes);
	    if ((0, _general.isTruthy)(captureProductNotes)) {
	      var notesVal = notes.find(elementsPageMap.addRmaItmAttrValue);
	      notesVal.text(dataObj.addRmaNotes);
	    } else {
	      notes.hide();
	    }
	
	    var qty = reviewProductEl.find(elementsPageMap.revRmaQty);
	    qty.text(dataObj.addRmaProductQty);
	    return reviewProductEl;
	  };
	
	  function verify(selectedValue) {
	    if (selectedValue == "") {
	      return;
	    } else {
	      searchItem(selectedValue, false);
	    }
	  };
	  function verifyWarehouse(selectedValue) {
	    if (selectedValue == "") {
	      return;
	    } else {
	      searchWarehouseItem(selectedValue, false);
	    }
	  };
	
	  var select2AjaxDefaults = {
	    dataType: 'json',
	    delay: 250,
	    processResults: function processResults(data, params) {
	
	      params.page = params.page || 1;
	      return {
	        results: data,
	        pagination: {
	          more: params.page * 20 < data.total_count
	        }
	      };
	    },
	    cache: true
	  };
	
	  function configureDataCallback(_ref3) {
	    var paramKey = _ref3.paramKey;
	
	
	    return function (params) {
	      var _ref4;
	
	      return _ref4 = {}, _defineProperty(_ref4, paramKey, params.term), _defineProperty(_ref4, "customerId", $("#find-rma-by-address-or-location").val()), _defineProperty(_ref4, "rmaLevel", elsPage.rmaLevel.val()), _ref4;
	    };
	  }
	
	  // Add some(Final Sale, Order No, Vendor Auth No) product attributes to review page
	  function addMoreProductAttrToReviewTab(showCapture, reviewRmaItmAttrVar, prdAttrName, prdAttrValue, isBooleanAttrVal) {
	    if ((0, _general.isTruthy)(showCapture)) {
	      var procutAttrEl = $(productAttrTemplate);
	      var attrName = procutAttrEl.find(elementsPageMap.addRmaItmAttrName);
	      var attrValue = procutAttrEl.find(elementsPageMap.addRmaItmAttrValue);
	      attrName.text(prdAttrName);
	      if (isBooleanAttrVal) {
	        if (prdAttrValue == true) {
	          attrValue.text('Yes');
	        } else {
	          attrValue.text('No');
	        }
	      } else {
	        attrValue.text(prdAttrValue);
	      }
	      reviewRmaItmAttrVar.append(procutAttrEl);
	    }
	  }
	
	  function evaluateOrderNumberConfiguration(visible, mandatory, productEl) {
	
	    productEl.find(elementsPageMap.addRmaOrderNumber).on("input", function (e) {
	      $(this).next(".error").remove();
	    });
	
	    if (visible) {
	      productEl.find(elementsPageMap.originalOrderNumberDiv).show();
	      productEl.find(elementsPageMap.addRmaOrderNumber).prop('required', false);
	    } else {
	      productEl.find(elementsPageMap.originalOrderNumberDiv).hide();
	    }
	
	    if (mandatory) {
	      productEl.find(elementsPageMap.addRmaOrderNumber).prop('required', true);
	      productEl.find(elementsPageMap.originalOrderNumberLabelRequired).show();
	      productEl.find(elementsPageMap.originalOrderNumberLabelNotRequired).hide();
	    } else {
	      productEl.find(elementsPageMap.addRmaOrderNumber).prop('required', false);
	      productEl.find(elementsPageMap.originalOrderNumberLabelRequired).hide();
	      productEl.find(elementsPageMap.originalOrderNumberLabelNotRequired).show();
	    }
	  }
	
	  function renderDuplicateSkuModal() {
	    duplicateSkuModal = $((0, _render2.default)(modalHtml, {
	      modalDialogClass: 'q-modal-dialog-500',
	      title: 'Duplicate SKU Added',
	      leftAlignTitle: true,
	      body: duplicateSkuTemplate,
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn duplicate-sku-add-button">Add as Additional SKU</a> <a href="#" class="base-btn purple-btn duplicate-sku-close-modal">Do Not Add SKU</a>'
	    }));
	    elsPage.addRmaParent.append(duplicateSkuModal);
	  }
	
	  function displayDuplicateSkuModal() {
	    duplicateSkuModal.modal("show");
	  }
	  function hideDuplicateSkuModal() {
	    duplicateSkuModal.modal("hide");
	  }
	  function addDuplicateSkuFromModal() {
	    // add item with duplicate sku
	    var rmaSelectedLevel = elsPage.rmaLevel.val();
	    duplicateSkuModal.modal("hide");
	    if (rmaSelectedLevel == 'warehouse' || rmaSelectedLevel == 'customer') {
	      searchWarehouseItem(itemSkuGlobal, true);
	    } else {
	      searchItem(itemSkuGlobal, true);
	    }
	  }
	}

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = AsnSerializer;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// {
	//   "0": {
	//     id: 1,
	//     shippingMethod: "parcel"
	//   }
	// }
	function AsnSerializer(asn) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var self = this;
	  asn = _underscore2.default.extend({}, asn);
	
	  self.toJsonWithAsnDetails = function () {
	    asn = stampQuoteToAsn(asn);
	    asn = stampHolidayPickup(asn);
	    asn = stampWeekendPickup(asn);
	    asn.asnDetails = getAsnDetails();
	    asn.asnShippingPalletStore = getAsnShippingPallets();
	    return JSON.stringify(asn);
	  };
	
	  self.toJsonNestedIntoPalletsAndCases = function () {
	    asn = stampQuoteToAsn(asn);
	    asn = stampHolidayPickup(asn);
	    asn = stampWeekendPickup(asn);
	    var asnDetails = getAsnDetails();
	    asn.asnShippingPalletStore = getAsnShippingPallets();
	    /** This logic has been newly added to manage switching cases vs pallet while edit the ASN. We use ASN's status to identify
	    the newly created cases or pallet ASN **/
	    /** copy the necessary information in case we miss from original ASN while switching case or pallet **/
	    if (!(0, _general.isBlank)(asn.asnId)) {
	      (0, _underscore2.default)(asnDetails).map(function (detail) {
	        detail.asnId = asn.asnId;
	      });
	    }
	
	    if (options.includeServices) {
	      asnDetails = nestServicesForAsnDetails(asnDetails);
	      asn = nestServicesForAsn(asn);
	    }
	
	    if (_AsnStore2.default.isPallet(asn)) {
	      var palletObjects = origanizeIntoPalletAndCaseObjects(asnDetails);
	      asn.palletGroups = palletObjects;
	    } else {
	      var caseObjects = organizeIntoCaseObjects(asnDetails);
	      asn.caseGroups = caseObjects;
	
	      /*  Fix for HB 7904, HB-8171
	          commenting out this code because palletgroups is not required for cases. It also causes the issue for cases
	          and asd_case_line_no starts from 1 if palletLineNumber is not 1 by default. It breaks sequences for cases. */
	      //let palletObjects = origanizeIntoPalletAndCaseObjects(asnDetails);
	      //asn.palletGroups = palletObjects;
	    }
	
	    return JSON.stringify(asn);
	  };
	
	  function nestServicesForAsnDetails(asnDetails) {
	    return (0, _underscore2.default)(asnDetails).map(function (detail) {
	      detail.cmr_services = _CmrServiceStore2.default.getServicesViaAsnDetailId(detail.id);
	      return detail;
	    });
	  }
	
	  function nestServicesForAsn(asn) {
	    asn.cmr_services = _CmrServiceStore2.default.getServicesViaAsnId(asn.id);
	    return asn;
	  }
	
	  function stampQuoteToAsn(asn) {
	    var quote = _AsnStore2.default.getSelectedQuote(asn);
	    if (!!quote) {
	      asn.quote = _extends({}, quote);
	    }
	    return asn;
	  }
	
	  function stampHolidayPickup(asn) {
	    asn.isPickupDateWeekend = !!_AsnStore2.default.getPickupDateWeekend(asn);
	    return asn;
	  }
	  function stampWeekendPickup(asn) {
	    asn.isPickupDateHoliday = !!_AsnStore2.default.getPickupDateHoliday(asn);
	    return asn;
	  }
	  // [
	  //   [{
	  //     id: 1,
	  //     sku: "product-sku-1",
	  //     perishable: true,
	  //     requiresBatchLot: false,
	  //     fragile: true,
	  //     barcode: true,
	  //     caseLineNumber: 1,
	  //     palletLineNumber: 1,
	  //     unitsPerCase: 1
	  //   },
	  //   {
	  //     id: 2,
	  //     sku: "product-sku-2",
	  //     perishable: true,
	  //     requiresBatchLot: true,
	  //     fragile: false,
	  //     barcode: true,
	  //     caseLineNumber: 1,
	  //     palletLineNumber: 1,
	  //     unitsPerCase: 1
	  //   }]
	  // ]
	
	
	  function origanizeIntoPalletAndCaseObjects(asnDetails) {
	    var pallets = _AsnDetailStore2.default.organizeIntoPallets(asnDetails);
	    var palletObjects = [];
	    (0, _underscore2.default)(pallets).each(function (asnDetailSubset, palletIdx) {
	      var firstAsnDetail = asnDetailSubset[0];
	      var palletObject = {};
	      palletObject.numberOfPallets = firstAsnDetail.numberOfPallets;
	      destructureAsnDetailAndAssign(palletObject, firstAsnDetail);
	      // Per Rishish's request, renumber all pallet/caselineNumbers
	      // so there is no gaps, regardless of benefits/drawbacks
	      reassignKeyValueToObjects(asnDetailSubset, "palletLineNumber", palletIdx + 1);
	
	      palletObject.caseGroups = organizeIntoCaseObjects(asnDetailSubset, { excludeDimensions: true });
	      palletObjects.push(palletObject);
	    });
	    return palletObjects;
	  }
	
	  function organizeIntoCaseObjects(asnDetails) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        excludeDimensions = _ref.excludeDimensions;
	
	    var cases = _AsnDetailStore2.default.organizeIntoCases(asnDetails);
	    var caseObjects = [];
	    (0, _underscore2.default)(cases).each(function (asnDetailSubset, caseIdx) {
	      var firstAsnDetail = asnDetailSubset[0];
	      var caseObject = {};
	      caseObject.numberOfCases = firstAsnDetail.numberOfCases;
	      caseObject.declaredValue = firstAsnDetail.declaredValue;
	      caseObject.dvlInsideCase = firstAsnDetail.dvlInsideCase;
	      caseObject.useCalculatedVal = firstAsnDetail.useCalculatedVal;
	      if (!excludeDimensions) {
	        destructureAsnDetailAndAssign(caseObject, firstAsnDetail);
	      }
	      reassignKeyValueToObjects(asnDetailSubset, "caseLineNumber", caseIdx + 1);
	
	      caseObject.skus = asnDetailSubset;
	      caseObjects.push(caseObject);
	    });
	    return caseObjects;
	  }
	
	  function reassignKeyValueToObjects(arrOfObjs, key, val) {
	    (0, _underscore2.default)(arrOfObjs).each(function (obj) {
	      obj[key] = val;
	    });
	  }
	
	  function destructureAsnDetailAndAssign(target, asnDetail) {
	    var props = (0, _underscore2.default)(asnDetail).pick("asd_package_length", "asd_package_width", "asd_package_height", "asd_package_weight", "asd_tracking_number", "asd_expected_arrival_date");
	    _underscore2.default.extend(target, props);
	  }
	
	  function getAsnDetails() {
	    return _AsnDetailStore2.default.where({ asnId: asn.id });
	  }
	
	  function getAsnShippingPallets() {
	    return AsnShippingPalletStore.where({ asnId: asn.id });
	  }
	}
	
	window.AsnSerializer = AsnSerializer;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _storeUtils = __webpack_require__(56);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _relationships = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var brokers = {};
	
	// let cmrDomains = {};
	
	var defaults = {};
	
	var BrokerStore = (0, _storeUtils.createStore)({
	  storeEventBaseKey: "brokers",
	  normalizr: _relationships.brokerKeyToArrayOfBroker,
	  normalizrKey: "brokers",
	  getData: function getData() {
	    return brokers;
	  },
	  getDefaults: function getDefaults() {
	    return defaults;
	  },
	  getBrokers: function getBrokers() {
	    return brokers;
	  },
	  getBroker: function getBroker(id) {
	    return brokers[id];
	  }
	});
	
	window.BrokerStore = BrokerStore;
	exports.default = BrokerStore;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flipArrowIcon = flipArrowIcon;
	
	var _selectorHelpers = __webpack_require__(4);
	
	function flipArrowIcon(dir, icon) {
	  (0, _selectorHelpers.swapClassesViaBool)(icon, "fa-angle-down", "fa-angle-up", dir === "down");
	}

/***/ },
/* 225 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var searchSettings = exports.searchSettings = {
	  base: {
	    shouldSort: true,
	    threshold: 0.5,
	    location: 0,
	    distance: 100,
	    maxPatternLength: 32,
	    minMatchCharLength: 1
	  },
	  superStrict: {
	    shouldSort: true,
	    threshold: 0,
	    location: 0,
	    distance: 0,
	    maxPatternLength: 32,
	    minMatchCharLength: 1
	  },
	  superFuzzy: {
	    shouldSort: true,
	    threshold: 0.8,
	    location: 0,
	    distance: 50,
	    maxPatternLength: 32,
	    minMatchCharLength: 1
	  }
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.matchChildrenWidthsToParentCols = matchChildrenWidthsToParentCols;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Takes an entire table and uses it's rows,
	// OR takes a table and a specific set of rows
	function matchChildrenWidthsToParentCols(_ref) {
	  var table = _ref.table,
	      rows = _ref.rows;
	
	  var childRows = void 0;
	  if (rows) {
	    childRows = rows;
	  } else {
	    childRows = table.find('.child-table-row');
	  }
	
	  if (childRows.length) {
	    var parentColHeaders = table.find('> thead > tr > th');
	    childRows.each(function () {
	      var childCols = (0, _jquery2.default)(this).find('> td');
	      matchChildColWidthsToParentCols(childCols, parentColHeaders);
	    });
	  }
	}
	
	function matchChildColWidthsToParentCols(childCols, parentColHeaders) {
	  parentColHeaders.each(function (i) {
	    var parentCol = (0, _jquery2.default)(this);
	    var childCol = childCols.eq(i);
	    var width = parentCol.width();
	    childCol.css("width", width);
	  });
	}

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _arguments = arguments;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.bindFileInputChangeValidation = bindFileInputChangeValidation;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _general = __webpack_require__(5);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_jquery2.default.validator.addMethod("currencyDollarsCents", function (value) {
	  return (/^\d+\.\d\d$/.test(value)
	  );
	}, 'Please enter currency in the form: 0.00');
	
	_jquery2.default.validator.addMethod("wholeNumber", function (value) {
	  return (/^\d+$/.test(value)
	  );
	}, 'Please enter a whole number (no decimals).');
	
	_jquery2.default.validator.addMethod("dateRange", function (val, el) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [],
	      _ref2 = _slicedToArray(_ref, 1),
	      _ref2$ = _ref2[0];
	
	  _ref2$ = _ref2$ === undefined ? {} : _ref2$;
	  var dateStart = _ref2$.dateStart,
	      dateEnd = _ref2$.dateEnd;
	
	  // debugger;
	  var dsRaw = dateStart.apply(undefined, _arguments).val();
	  var deRaw = dateEnd.apply(undefined, _arguments).val();
	
	  if (!(0, _general.isPresent)(dsRaw) || !(0, _general.isPresent)(deRaw)) {
	    return true;
	  }
	
	  var ds = (0, _moment2.default)(dsRaw, "MM/DD/YYYY");
	  var de = (0, _moment2.default)(deRaw, "MM/DD/YYYY");
	
	  if (!ds.isValid() || !de.isValid()) {
	    return true;
	  }
	
	  return ds.diff(de) < 0;
	}, "Please select a valid date range.");
	
	// START
	// This Validation can only be used
	// by the QuickFileUploader Component,
	// or any other component setting a data-attribute
	// for 'file-meta'
	_jquery2.default.validator.addMethod("maxFileSizeBytes", function (val, el, maxBytes) {
	  el = (0, _jquery2.default)(el);
	  var fileSize = el.data('file-meta') && el.data('file-meta').size;
	  // if there is no file present (aka, no fileSize),
	  // this error shouldn't be visible, that is the 
	  // responsibility of the 'required' validation
	  if (!(0, _general.isPresent)(fileSize)) {
	    return true;
	  }
	  return fileSize <= maxBytes;
	}, "The size of this file too large.");
	
	_jquery2.default.validator.addMethod("permittedFileTypes", function (val, el, permittedFileTypes) {
	  el = (0, _jquery2.default)(el);
	  var fileType = el.data('file-meta') && el.data('file-meta').type;
	  // Same validation note as mentioned above
	  if (!(0, _general.isPresent)(fileType)) {
	    return true;
	  }
	  return (0, _underscore2.default)(permittedFileTypes).any(function (type) {
	    return fileType === type;
	  });
	}, "The file type is not permitted.");
	// END
	
	
	function bindFileInputChangeValidation() {
	  (0, _jquery2.default)(document).on("change", "input[type=file]", function () {
	    var input = (0, _jquery2.default)(this);
	    if (input.get(0).form && input.valid) {
	      input.valid();
	    }
	  });
	}
	
	_jquery2.default.validator.addClassRules("jqv-whole-number", { wholeNumber: true });

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.modalRenderCheckbox = modalRenderCheckbox;
	exports.modalRenderPillUnits = modalRenderPillUnits;
	exports.getCheckedRowsFromDataTable = getCheckedRowsFromDataTable;
	exports.getCheckedFromDataTable = getCheckedFromDataTable;
	exports.countCheckedFromDataTable = countCheckedFromDataTable;
	exports.handleTotalChecked = handleTotalChecked;
	exports.updateTotalCheckedArea = updateTotalCheckedArea;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalCheckboxHtml = __webpack_require__(1469);
	var modalPillUnitsHtml = __webpack_require__(1473);
	
	function modalRenderCheckbox(data, type, row) {
	  return (0, _render2.default)(modalCheckboxHtml, {
	    value: data
	  });
	}
	
	//Populate Available Unit Pills
	function modalRenderPillUnits(data, type, row) {
	  var pillColor = void 0;
	  if (data <= 0) {
	    pillColor = "q-pill-red";
	  } else {
	    pillColor = "q-pill-white-and-grey";
	  }
	  return (0, _render2.default)(modalPillUnitsHtml, {
	    value: data,
	    pillClassQty: pillColor
	  });
	}
	
	function getCheckedRowsFromDataTable(dt, selector) {
	  var checkedRows = (0, _underscore2.default)((0, _jquery2.default)(dt.api().rows().nodes()).toArray()).filter(function (tr) {
	    return !!(0, _jquery2.default)(tr).find(selector + ':checked').length;
	  });
	  return (0, _jquery2.default)(checkedRows);
	}
	
	function getCheckedFromDataTable(dt, selector) {
	  // We are not actually searching the dom for these elements using $,
	  // all we are doing is wrapping them in a jquery object because
	  // they are pre-selected
	  return (0, _jquery2.default)(dt.api().rows().nodes()).find(selector + ':checked');
	}
	
	function countCheckedFromDataTable(dt, selector) {
	  return getCheckedFromDataTable(dt, selector).length;
	}
	
	//hybrid function of checking both if search was performed with total seen checked AND general checked boxes
	function handleTotalChecked(addProductsModal, modalOrderTable, modalCheckboxSelector) {
	  var totalChecked = countCheckedFromDataTable(modalOrderTable, modalCheckboxSelector);
	  // console.log(getCheckedRowsFromDataTable(modalOrderTable, modalCheckboxSelector));
	  // console.log(totalChecked);
	  // $('.order-wizard-modal-total-checked').html(totalChecked);
	  updateTotalCheckedArea(addProductsModal, totalChecked);
	}
	//Time to mutate some HTML and populate the modal with the number of checked boxes!
	function updateTotalCheckedArea(addProductsModal, totalChecked) {
	  var checkedContent = "";
	  if (totalChecked == 1) {
	    checkedContent = '1 Product Selected';
	  } else {
	    checkedContent = totalChecked + ' Products Selected';
	  }
	  addProductsModal.find('.order-wizard-modal-total-checked').html(checkedContent);
	}

/***/ },
/* 229 */,
/* 230 */,
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(105);
	
	var $apply = __webpack_require__(148);
	var $call = __webpack_require__(149);
	var $reflectApply = __webpack_require__(851);
	
	/** @type {import('./actualApply')} */
	module.exports = $reflectApply || bind.call($call, $apply);


/***/ },
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.deepmerge = factory();
	    }
	}(this, function () {
	
	function isMergeableObject(val) {
	    var nonNullObject = val && typeof val === 'object'
	
	    return nonNullObject
	        && Object.prototype.toString.call(val) !== '[object RegExp]'
	        && Object.prototype.toString.call(val) !== '[object Date]'
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice()
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument)
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument)
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument))
	        }
	    })
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {}
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function (key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument)
	        })
	    }
	    Object.keys(source).forEach(function (key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument)
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument)
	        }
	    })
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var array = Array.isArray(source);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge }
	    var arrayMerge = options.arrayMerge || defaultArrayMerge
	
	    if (array) {
	        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	}
	
	return deepmerge
	
	}));


/***/ },
/* 269 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ },
/* 270 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Object;


/***/ },
/* 271 */
/***/ function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ },
/* 272 */
92,
/* 273 */
92,
/* 274 */
92,
/* 275 */
92,
/* 276 */
92,
/* 277 */
92,
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license
	 * Fuse - Lightweight fuzzy-search
	 *
	 * Copyright (c) 2012-2016 Kirollos Risk <kirollos@gmail.com>.
	 * All Rights Reserved. Apache Software License 2.0
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License")
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	;(function (global) {
	  'use strict'
	
	  /** @type {function(...*)} */
	  function log () {
	    console.log.apply(console, arguments)
	  }
	
	  var defaultOptions = {
	    // The name of the identifier property. If specified, the returned result will be a list
	    // of the items' dentifiers, otherwise it will be a list of the items.
	    id: null,
	
	    // Indicates whether comparisons should be case sensitive.
	
	    caseSensitive: false,
	
	    // An array of values that should be included from the searcher's output. When this array
	    // contains elements, each result in the list will be of the form `{ item: ..., include1: ..., include2: ... }`.
	    // Values you can include are `score`, `matchedLocations`
	    include: [],
	
	    // Whether to sort the result list, by score
	    shouldSort: true,
	
	    // The search function to use
	    // Note that the default search function ([[Function]]) must conform to the following API:
	    //
	    //  @param pattern The pattern string to search
	    //  @param options The search option
	    //  [[Function]].constructor = function(pattern, options)
	    //
	    //  @param text: the string to search in for the pattern
	    //  @return Object in the form of:
	    //    - isMatch: boolean
	    //    - score: Int
	    //  [[Function]].prototype.search = function(text)
	    searchFn: BitapSearcher,
	
	    // Default sort function
	    sortFn: function (a, b) {
	      return a.score - b.score
	    },
	
	    // The get function to use when fetching an object's properties.
	    // The default will search nested paths *ie foo.bar.baz*
	    getFn: deepValue,
	
	    // List of properties that will be searched. This also supports nested properties.
	    keys: [],
	
	    // Will print to the console. Useful for debugging.
	    verbose: false,
	
	    // When true, the search algorithm will search individual words **and** the full string,
	    // computing the final score as a function of both. Note that when `tokenize` is `true`,
	    // the `threshold`, `distance`, and `location` are inconsequential for individual tokens.
	    tokenize: false,
	
	    // When true, the result set will only include records that match all tokens. Will only work
	    // if `tokenize` is also true.
	    matchAllTokens: false,
	
	    // Regex used to separate words when searching. Only applicable when `tokenize` is `true`.
	    tokenSeparator: / +/g,
	
	    // Minimum number of characters that must be matched before a result is considered a match
	    minMatchCharLength: 1,
	
	    // When true, the algorithm continues searching to the end of the input even if a perfect
	    // match is found before the end of the same input.
	    findAllMatches: false
	  }
	
	  /**
	   * @constructor
	   * @param {!Array} list
	   * @param {!Object<string, *>} options
	   */
	  function Fuse (list, options) {
	    var key
	
	    this.list = list
	    this.options = options = options || {}
	
	    for (key in defaultOptions) {
	      if (!defaultOptions.hasOwnProperty(key)) {
	        continue;
	      }
	      // Add boolean type options
	      if (typeof defaultOptions[key] === 'boolean') {
	        this.options[key] = key in options ? options[key] : defaultOptions[key];
	      // Add all other options
	      } else {
	        this.options[key] = options[key] || defaultOptions[key]
	      }
	    }
	  }
	
	  Fuse.VERSION = '2.6.2'
	
	  /**
	   * Sets a new list for Fuse to match against.
	   * @param {!Array} list
	   * @return {!Array} The newly set list
	   * @public
	   */
	  Fuse.prototype.set = function (list) {
	    this.list = list
	    return list
	  }
	
	  Fuse.prototype.search = function (pattern) {
	    if (this.options.verbose) log('\nSearch term:', pattern, '\n')
	
	    this.pattern = pattern
	    this.results = []
	    this.resultMap = {}
	    this._keyMap = null
	
	    this._prepareSearchers()
	    this._startSearch()
	    this._computeScore()
	    this._sort()
	
	    var output = this._format()
	    return output
	  }
	
	  Fuse.prototype._prepareSearchers = function () {
	    var options = this.options
	    var pattern = this.pattern
	    var searchFn = options.searchFn
	    var tokens = pattern.split(options.tokenSeparator)
	    var i = 0
	    var len = tokens.length
	
	    if (this.options.tokenize) {
	      this.tokenSearchers = []
	      for (; i < len; i++) {
	        this.tokenSearchers.push(new searchFn(tokens[i], options))
	      }
	    }
	    this.fullSeacher = new searchFn(pattern, options)
	  }
	
	  Fuse.prototype._startSearch = function () {
	    var options = this.options
	    var getFn = options.getFn
	    var list = this.list
	    var listLen = list.length
	    var keys = this.options.keys
	    var keysLen = keys.length
	    var key
	    var weight
	    var item = null
	    var i
	    var j
	
	    // Check the first item in the list, if it's a string, then we assume
	    // that every item in the list is also a string, and thus it's a flattened array.
	    if (typeof list[0] === 'string') {
	      // Iterate over every item
	      for (i = 0; i < listLen; i++) {
	        this._analyze('', list[i], i, i)
	      }
	    } else {
	      this._keyMap = {}
	      // Otherwise, the first item is an Object (hopefully), and thus the searching
	      // is done on the values of the keys of each item.
	      // Iterate over every item
	      for (i = 0; i < listLen; i++) {
	        item = list[i]
	        // Iterate over every key
	        for (j = 0; j < keysLen; j++) {
	          key = keys[j]
	          if (typeof key !== 'string') {
	            weight = (1 - key.weight) || 1
	            this._keyMap[key.name] = {
	              weight: weight
	            }
	            if (key.weight <= 0 || key.weight > 1) {
	              throw new Error('Key weight has to be > 0 and <= 1')
	            }
	            key = key.name
	          } else {
	            this._keyMap[key] = {
	              weight: 1
	            }
	          }
	          this._analyze(key, getFn(item, key, []), item, i)
	        }
	      }
	    }
	  }
	
	  Fuse.prototype._analyze = function (key, text, entity, index) {
	    var options = this.options
	    var words
	    var scores
	    var exists = false
	    var existingResult
	    var averageScore
	    var finalScore
	    var scoresLen
	    var mainSearchResult
	    var tokenSearcher
	    var termScores
	    var word
	    var tokenSearchResult
	    var hasMatchInText
	    var checkTextMatches
	    var i
	    var j
	
	    // Check if the text can be searched
	    if (text === undefined || text === null) {
	      return
	    }
	
	    scores = []
	
	    var numTextMatches = 0
	
	    if (typeof text === 'string') {
	      words = text.split(options.tokenSeparator)
	
	      if (options.verbose) log('---------\nKey:', key)
	
	      if (this.options.tokenize) {
	        for (i = 0; i < this.tokenSearchers.length; i++) {
	          tokenSearcher = this.tokenSearchers[i]
	
	          if (options.verbose) log('Pattern:', tokenSearcher.pattern)
	
	          termScores = []
	          hasMatchInText = false
	
	          for (j = 0; j < words.length; j++) {
	            word = words[j]
	            tokenSearchResult = tokenSearcher.search(word)
	            var obj = {}
	            if (tokenSearchResult.isMatch) {
	              obj[word] = tokenSearchResult.score
	              exists = true
	              hasMatchInText = true
	              scores.push(tokenSearchResult.score)
	            } else {
	              obj[word] = 1
	              if (!this.options.matchAllTokens) {
	                scores.push(1)
	              }
	            }
	            termScores.push(obj)
	          }
	
	          if (hasMatchInText) {
	            numTextMatches++
	          }
	
	          if (options.verbose) log('Token scores:', termScores)
	        }
	
	        averageScore = scores[0]
	        scoresLen = scores.length
	        for (i = 1; i < scoresLen; i++) {
	          averageScore += scores[i]
	        }
	        averageScore = averageScore / scoresLen
	
	        if (options.verbose) log('Token score average:', averageScore)
	      }
	
	      mainSearchResult = this.fullSeacher.search(text)
	      if (options.verbose) log('Full text score:', mainSearchResult.score)
	
	      finalScore = mainSearchResult.score
	      if (averageScore !== undefined) {
	        finalScore = (finalScore + averageScore) / 2
	      }
	
	      if (options.verbose) log('Score average:', finalScore)
	
	      checkTextMatches = (this.options.tokenize && this.options.matchAllTokens) ? numTextMatches >= this.tokenSearchers.length : true
	
	      if (options.verbose) log('Check Matches', checkTextMatches)
	
	      // If a match is found, add the item to <rawResults>, including its score
	      if ((exists || mainSearchResult.isMatch) && checkTextMatches) {
	        // Check if the item already exists in our results
	        existingResult = this.resultMap[index]
	
	        if (existingResult) {
	          // Use the lowest score
	          // existingResult.score, bitapResult.score
	          existingResult.output.push({
	            key: key,
	            score: finalScore,
	            matchedIndices: mainSearchResult.matchedIndices
	          })
	        } else {
	          // Add it to the raw result list
	          this.resultMap[index] = {
	            item: entity,
	            output: [{
	              key: key,
	              score: finalScore,
	              matchedIndices: mainSearchResult.matchedIndices
	            }]
	          }
	
	          this.results.push(this.resultMap[index])
	        }
	      }
	    } else if (isArray(text)) {
	      for (i = 0; i < text.length; i++) {
	        this._analyze(key, text[i], entity, index)
	      }
	    }
	  }
	
	  Fuse.prototype._computeScore = function () {
	    var i
	    var j
	    var keyMap = this._keyMap
	    var totalScore
	    var output
	    var scoreLen
	    var score
	    var weight
	    var results = this.results
	    var bestScore
	    var nScore
	
	    if (this.options.verbose) log('\n\nComputing score:\n')
	
	    for (i = 0; i < results.length; i++) {
	      totalScore = 0
	      output = results[i].output
	      scoreLen = output.length
	
	      bestScore = 1
	
	      for (j = 0; j < scoreLen; j++) {
	        score = output[j].score
	        weight = keyMap ? keyMap[output[j].key].weight : 1
	
	        nScore = score * weight
	
	        if (weight !== 1) {
	          bestScore = Math.min(bestScore, nScore)
	        } else {
	          totalScore += nScore
	          output[j].nScore = nScore
	        }
	      }
	
	      if (bestScore === 1) {
	        results[i].score = totalScore / scoreLen
	      } else {
	        results[i].score = bestScore
	      }
	
	      if (this.options.verbose) log(results[i])
	    }
	  }
	
	  Fuse.prototype._sort = function () {
	    var options = this.options
	    if (options.shouldSort) {
	      if (options.verbose) log('\n\nSorting....')
	      this.results.sort(options.sortFn)
	    }
	  }
	
	  Fuse.prototype._format = function () {
	    var options = this.options
	    var getFn = options.getFn
	    var finalOutput = []
	    var item
	    var i
	    var len
	    var results = this.results
	    var replaceValue
	    var getItemAtIndex
	    var include = options.include
	
	    if (options.verbose) log('\n\nOutput:\n\n', results)
	
	    // Helper function, here for speed-up, which replaces the item with its value,
	    // if the options specifies it,
	    replaceValue = options.id ? function (index) {
	      results[index].item = getFn(results[index].item, options.id, [])[0]
	    } : function () {}
	
	    getItemAtIndex = function (index) {
	      var record = results[index]
	      var data
	      var j
	      var output
	      var _item
	      var _result
	
	      // If `include` has values, put the item in the result
	      if (include.length > 0) {
	        data = {
	          item: record.item
	        }
	        if (include.indexOf('matches') !== -1) {
	          output = record.output
	          data.matches = []
	          for (j = 0; j < output.length; j++) {
	            _item = output[j]
	            _result = {
	              indices: _item.matchedIndices
	            }
	            if (_item.key) {
	              _result.key = _item.key
	            }
	            data.matches.push(_result)
	          }
	        }
	
	        if (include.indexOf('score') !== -1) {
	          data.score = results[index].score
	        }
	
	      } else {
	        data = record.item
	      }
	
	      return data
	    }
	
	    // From the results, push into a new array only the item identifier (if specified)
	    // of the entire item.  This is because we don't want to return the <results>,
	    // since it contains other metadata
	    for (i = 0, len = results.length; i < len; i++) {
	      replaceValue(i)
	      item = getItemAtIndex(i)
	      finalOutput.push(item)
	    }
	
	    return finalOutput
	  }
	
	  // Helpers
	
	  function deepValue (obj, path, list) {
	    var firstSegment
	    var remaining
	    var dotIndex
	    var value
	    var i
	    var len
	
	    if (!path) {
	      // If there's no path left, we've gotten to the object we care about.
	      list.push(obj)
	    } else {
	      dotIndex = path.indexOf('.')
	
	      if (dotIndex !== -1) {
	        firstSegment = path.slice(0, dotIndex)
	        remaining = path.slice(dotIndex + 1)
	      } else {
	        firstSegment = path
	      }
	
	      value = obj[firstSegment]
	      if (value !== null && value !== undefined) {
	        if (!remaining && (typeof value === 'string' || typeof value === 'number')) {
	          list.push(value)
	        } else if (isArray(value)) {
	          // Search each item in the array.
	          for (i = 0, len = value.length; i < len; i++) {
	            deepValue(value[i], remaining, list)
	          }
	        } else if (remaining) {
	          // An object. Recurse further.
	          deepValue(value, remaining, list)
	        }
	      }
	    }
	
	    return list
	  }
	
	  function isArray (obj) {
	    return Object.prototype.toString.call(obj) === '[object Array]'
	  }
	
	  /**
	   * Adapted from "Diff, Match and Patch", by Google
	   *
	   *   http://code.google.com/p/google-diff-match-patch/
	   *
	   * Modified by: Kirollos Risk <kirollos@gmail.com>
	   * -----------------------------------------------
	   * Details: the algorithm and structure was modified to allow the creation of
	   * <Searcher> instances with a <search> method which does the actual
	   * bitap search. The <pattern> (the string that is searched for) is only defined
	   * once per instance and thus it eliminates redundant re-creation when searching
	   * over a list of strings.
	   *
	   * Licensed under the Apache License, Version 2.0 (the "License")
	   * you may not use this file except in compliance with the License.
	   *
	   * @constructor
	   */
	  function BitapSearcher (pattern, options) {
	    options = options || {}
	    this.options = options
	    this.options.location = options.location || BitapSearcher.defaultOptions.location
	    this.options.distance = 'distance' in options ? options.distance : BitapSearcher.defaultOptions.distance
	    this.options.threshold = 'threshold' in options ? options.threshold : BitapSearcher.defaultOptions.threshold
	    this.options.maxPatternLength = options.maxPatternLength || BitapSearcher.defaultOptions.maxPatternLength
	
	    this.pattern = options.caseSensitive ? pattern : pattern.toLowerCase()
	    this.patternLen = pattern.length
	
	    if (this.patternLen <= this.options.maxPatternLength) {
	      this.matchmask = 1 << (this.patternLen - 1)
	      this.patternAlphabet = this._calculatePatternAlphabet()
	    }
	  }
	
	  BitapSearcher.defaultOptions = {
	    // Approximately where in the text is the pattern expected to be found?
	    location: 0,
	
	    // Determines how close the match must be to the fuzzy location (specified above).
	    // An exact letter match which is 'distance' characters away from the fuzzy location
	    // would score as a complete mismatch. A distance of '0' requires the match be at
	    // the exact location specified, a threshold of '1000' would require a perfect match
	    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
	    distance: 100,
	
	    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
	    // (of both letters and location), a threshold of '1.0' would match anything.
	    threshold: 0.6,
	
	    // Machine word size
	    maxPatternLength: 32
	  }
	
	  /**
	   * Initialize the alphabet for the Bitap algorithm.
	   * @return {Object} Hash of character locations.
	   * @private
	   */
	  BitapSearcher.prototype._calculatePatternAlphabet = function () {
	    var mask = {},
	      i = 0
	
	    for (i = 0; i < this.patternLen; i++) {
	      mask[this.pattern.charAt(i)] = 0
	    }
	
	    for (i = 0; i < this.patternLen; i++) {
	      mask[this.pattern.charAt(i)] |= 1 << (this.pattern.length - i - 1)
	    }
	
	    return mask
	  }
	
	  /**
	   * Compute and return the score for a match with `e` errors and `x` location.
	   * @param {number} errors Number of errors in match.
	   * @param {number} location Location of match.
	   * @return {number} Overall score for match (0.0 = good, 1.0 = bad).
	   * @private
	   */
	  BitapSearcher.prototype._bitapScore = function (errors, location) {
	    var accuracy = errors / this.patternLen,
	      proximity = Math.abs(this.options.location - location)
	
	    if (!this.options.distance) {
	      // Dodge divide by zero error.
	      return proximity ? 1.0 : accuracy
	    }
	    return accuracy + (proximity / this.options.distance)
	  }
	
	  /**
	   * Compute and return the result of the search
	   * @param {string} text The text to search in
	   * @return {{isMatch: boolean, score: number}} Literal containing:
	   *                          isMatch - Whether the text is a match or not
	   *                          score - Overall score for the match
	   * @public
	   */
	  BitapSearcher.prototype.search = function (text) {
	    var options = this.options
	    var i
	    var j
	    var textLen
	    var findAllMatches
	    var location
	    var threshold
	    var bestLoc
	    var binMin
	    var binMid
	    var binMax
	    var start, finish
	    var bitArr
	    var lastBitArr
	    var charMatch
	    var score
	    var locations
	    var matches
	    var isMatched
	    var matchMask
	    var matchedIndices
	    var matchesLen
	    var match
	
	    text = options.caseSensitive ? text : text.toLowerCase()
	
	    if (this.pattern === text) {
	      // Exact match
	      return {
	        isMatch: true,
	        score: 0,
	        matchedIndices: [[0, text.length - 1]]
	      }
	    }
	
	    // When pattern length is greater than the machine word length, just do a a regex comparison
	    if (this.patternLen > options.maxPatternLength) {
	      matches = text.match(new RegExp(this.pattern.replace(options.tokenSeparator, '|')))
	      isMatched = !!matches
	
	      if (isMatched) {
	        matchedIndices = []
	        for (i = 0, matchesLen = matches.length; i < matchesLen; i++) {
	          match = matches[i]
	          matchedIndices.push([text.indexOf(match), match.length - 1])
	        }
	      }
	
	      return {
	        isMatch: isMatched,
	        // TODO: revisit this score
	        score: isMatched ? 0.5 : 1,
	        matchedIndices: matchedIndices
	      }
	    }
	
	    findAllMatches = options.findAllMatches
	
	    location = options.location
	    // Set starting location at beginning text and initialize the alphabet.
	    textLen = text.length
	    // Highest score beyond which we give up.
	    threshold = options.threshold
	    // Is there a nearby exact match? (speedup)
	    bestLoc = text.indexOf(this.pattern, location)
	
	    // a mask of the matches
	    matchMask = []
	    for (i = 0; i < textLen; i++) {
	      matchMask[i] = 0
	    }
	
	    if (bestLoc != -1) {
	      threshold = Math.min(this._bitapScore(0, bestLoc), threshold)
	      // What about in the other direction? (speed up)
	      bestLoc = text.lastIndexOf(this.pattern, location + this.patternLen)
	
	      if (bestLoc != -1) {
	        threshold = Math.min(this._bitapScore(0, bestLoc), threshold)
	      }
	    }
	
	    bestLoc = -1
	    score = 1
	    locations = []
	    binMax = this.patternLen + textLen
	
	    for (i = 0; i < this.patternLen; i++) {
	      // Scan for the best match; each iteration allows for one more error.
	      // Run a binary search to determine how far from the match location we can stray
	      // at this error level.
	      binMin = 0
	      binMid = binMax
	      while (binMin < binMid) {
	        if (this._bitapScore(i, location + binMid) <= threshold) {
	          binMin = binMid
	        } else {
	          binMax = binMid
	        }
	        binMid = Math.floor((binMax - binMin) / 2 + binMin)
	      }
	
	      // Use the result from this iteration as the maximum for the next.
	      binMax = binMid
	      start = Math.max(1, location - binMid + 1)
	      if (findAllMatches) {
	        finish = textLen;
	      } else {
	        finish = Math.min(location + binMid, textLen) + this.patternLen
	      }
	
	      // Initialize the bit array
	      bitArr = Array(finish + 2)
	
	      bitArr[finish + 1] = (1 << i) - 1
	
	      for (j = finish; j >= start; j--) {
	        charMatch = this.patternAlphabet[text.charAt(j - 1)]
	
	        if (charMatch) {
	          matchMask[j - 1] = 1
	        }
	
	        if (i === 0) {
	          // First pass: exact match.
	          bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch
	        } else {
	          // Subsequent passes: fuzzy match.
	          bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch | (((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1) | lastBitArr[j + 1]
	        }
	        if (bitArr[j] & this.matchmask) {
	          score = this._bitapScore(i, j - 1)
	
	          // This match will almost certainly be better than any existing match.
	          // But check anyway.
	          if (score <= threshold) {
	            // Indeed it is
	            threshold = score
	            bestLoc = j - 1
	            locations.push(bestLoc)
	
	            if (bestLoc > location) {
	              // When passing loc, don't exceed our current distance from loc.
	              start = Math.max(1, 2 * location - bestLoc)
	            } else {
	              // Already passed loc, downhill from here on in.
	              break
	            }
	          }
	        }
	      }
	
	      // No hope for a (better) match at greater error levels.
	      if (this._bitapScore(i + 1, location) > threshold) {
	        break
	      }
	      lastBitArr = bitArr
	    }
	
	    matchedIndices = this._getMatchedIndices(matchMask)
	
	    // Count exact matches (those with a score of 0) to be "almost" exact
	    return {
	      isMatch: bestLoc >= 0,
	      score: score === 0 ? 0.001 : score,
	      matchedIndices: matchedIndices
	    }
	  }
	
	  BitapSearcher.prototype._getMatchedIndices = function (matchMask) {
	    var matchedIndices = []
	    var start = -1
	    var end = -1
	    var i = 0
	    var match
	    var len = matchMask.length
	    for (; i < len; i++) {
	      match = matchMask[i]
	      if (match && start === -1) {
	        start = i
	      } else if (!match && start !== -1) {
	        end = i - 1
	        if ((end - start) + 1 >= this.options.minMatchCharLength) {
	            matchedIndices.push([start, end])
	        }
	        start = -1
	      }
	    }
	    if (matchMask[i - 1]) {
	      if ((i-1 - start) + 1 >= this.options.minMatchCharLength) {
	        matchedIndices.push([start, i - 1])
	      }
	    }
	    return matchedIndices
	  }
	
	  // Export to Common JS Loader
	  if (true) {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = Fuse
	  } else if (typeof define === 'function' && define.amd) {
	    // AMD. Register as an anonymous module.
	    define(function () {
	      return Fuse
	    })
	  } else {
	    // Browser globals (root is window)
	    global.Fuse = Fuse
	  }
	
	})(this);


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $Object = __webpack_require__(270);
	
	/** @type {import('./Object.getPrototypeOf')} */
	module.exports = $Object.getPrototypeOf || null;


/***/ },
/* 280 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./Reflect.getPrototypeOf')} */
	module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ },
/* 281 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./shams')} */
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		/** @type {{ [k in symbol]?: unknown }} */
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(105);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ },
/* 283 */
/***/ function(module, exports) {

	module.exports = "<div class=col-xs-4> <a href=# class=\"base-btn purple-btn v2-btn q-pull-right facility-edit-section-btn\"> Edit </a> <a href=# class=\"base-btn purple-btn v2-btn q-pull-right facility-update-section-btn\"> Update </a> <a href=# class=\"base-btn purple-btn v2-btn q-pull-right facility-cancel-section-btn\"> Cancel </a> </div>";

/***/ },
/* 284 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>{%- facility.cdmValue %}</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox data-error-placement-append-closest=.error-wrapper class=vmoFacilityType id=\"{%- facility.cdmMeaning %}{%- optional.arrayIndex  %}\" value=\"{%- facility.cdmMeaning %}\" name=facilityType {%- optional.isChecked %} /> <label for=\"{%- facility.cdmMeaning %}{%- optional.arrayIndex  %}\">{%- facility.cdmDescription %}</label> </div> </div> </div> </div>";

/***/ },
/* 285 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>{%- inboundClassificationItem.cdmMeaning %}</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12 error-wrapper\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox data-error-placement-append-closest=.error-wrapper id=\"{%- inboundClassificationItem.cdmValue %}{%- optional.arrayIndex %}\" value=\"{%- inboundClassificationItem.cdmValue %}\" name=inboundClassificationTypes {%- optional.isChecked %} /> <label for=\"{%- inboundClassificationItem.cdmValue %}{%- optional.arrayIndex %}\">&nbsp;</label> </div> </div> </div> </div>";

/***/ },
/* 286 */
/***/ function(module, exports) {

	module.exports = "<div class=\"org-team-member q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=\"q-pretty-container q-pct-lightest-grey org-team-member-toggler-parent\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=\"q-pad-vert q-marg-left-md-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\"> <i class=\"fa fa-user q-icon-marg-right q-icon-md\" aria-hidden=true></i> {%- firstname %} {%- lastname %} </span> </div> </div> <div class=\"col-md-3 col-xs-12 q-fs-lg q-text-center-at-md\"> <div class=\"q-marg-vert-xxs q-marg-horz q-pull-right-til-md q-marg-vert-md-at-md\"> <a class=\"base-btn purple-btn q-text-center q-stretch-at-md activate-org-team-member-btn {%- activateUser %}\" data-index-id=\"{%- userid %}\"> Activate </a> <a class=\"base-btn purple-btn q-text-center q-stretch-at-md deactivate-org-team-member-btn {%- inactivateUser %}\" data-index-id=\"{%- userid %}\"> Deactivate </a> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.org-team-member-toggler-target data-q-expander-closest=.org-team-member-toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"org-team-member-toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Status:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- status %}</span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Username:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- username %}</span> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"row q-marg-top-md-at-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Email:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- email %}</span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Phone:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- phone %}</span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 287 */
/***/ function(module, exports) {

	module.exports = "<div id=pickupTable class=q-overflow-x-auto> <div class=\"q-overflow-x-hidden q-min-width-sm\"> <table class=\"table q-table q-table-vert-middle q-no-marg q-table-min-height q-table-pad-tds-md\"> <thead> <tr> <th>Pickup Date</th> <th class=q-text-right>Estimated Time</th> <th class=q-text-right>Estimated Cost</th> </tr> </thead> <tbody id=quoteResponse> <tr> <td>{%- pickUpDate %}</td> <td class=q-text-right>{%- transit %} days</td> <td class=q-text-right>{%- quote %}</td> </tr> </tbody> </table> </div> </div>";

/***/ },
/* 288 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group q-pad-vert q-pad-horz\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-boldest> Product SKU: </div> </div> <div class=\"col-md-6 col-xs-12\"> {%- productSku %} </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-boldest> Quantity Packed: </div> </div> <div class=\"col-md-6 col-xs-12\"> {%- quantityPacked %} </div> </div> </div> </div> </div>";

/***/ },
/* 289 */
/***/ function(module, exports) {

	module.exports = "<p class=q-marg-all-sm> This order has {%- numberOfLpns %} more LPN(s). Please scan the next LPN. </p>";

/***/ },
/* 290 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-xl> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=\"q-pad-vert q-pad-left-til-md q-pad-horz-at-md q-pct-header-group-title\"> <div class=\"q-pad-vert-xs q-fs-xl\"> <i class=\"fa fa-paper-plane-o q-marg-right-md\" aria-hidden=true></i> <span class=q-boldest>LPN Number:</span> <span>{%- lpnNumber %}</span> <a href=# class=\"q-block-at-md q-pull-right-til-md q-text-center-at-md base-btn purple-btn v2-btn print-pkg-label-btn\" data-lpn-number=\"{%- lpnNumber %}\"> <i class=\"fa fa-print\" aria-hidden=true></i> <span> Print Package Label </span> </a> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 291 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Reason * </label> </div> <div class=\"col-md-9 col-xs-12\"> <select id=cancel-reason-select class=select2-select style=width:100% data-s2-placeholder=\"Select a reason for the cancelation\" data-s2-minimum-results-for-search=Infinity> <option value=\"\"></option> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Notes (Optional) </label> </div> <div class=\"col-md-9 col-xs-12\"> <textarea id=cancel-notes class=\"q-input q-input-md q-stretch\" placeholder=\"Enter text\"></textarea> </div> </div> </div> </div>";

/***/ },
/* 292 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section q-section-include-border asn-detail-row-review-view\"> <div class=q-pad-horz> <div class=row> <div class=\"col-md-2 col-xs-12\"> <div class=\"q-marg-vert-md q-marg-top-xs xs-pad-bottom\"> <div class=pallet-case-label-and-idx> <div class=pallet-case-idx> 1 </div> </div> </div> <div class=\"q-marg-vert-md xs-pad-bottom\"> <div class=\"pallet-case-icon text-grey\"> <i class=\"fa fa-th\" aria-hidden=true></i> </div> </div> </div> <div class=\"col-md-10 col-xs-12\"> <div class=row> <div class=\"col-md-8 col-xs-12\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-input-group q-marg-top-xs-til-md xs-pad-bottom\"> <div class=row> <div class=\"col-sm-5 col-xs-12\"> <div class=q-valuable>Length</div> </div> <div class=\"col-sm-7 col-xs-12 wrapper-helper\"> <span class=\"q-tag asn-detail-length\">48</span> <span class=q-tag>In</span> </div> </div> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-input-group q-marg-top-xs-til-md xs-pad-bottom\"> <div class=row> <div class=\"col-sm-5 col-xs-12\"> <div class=q-valuable>Width</div> </div> <div class=\"col-sm-7 col-xs-12 wrapper-helper\"> <span class=\"q-tag asn-detail-width\">48</span> <span class=q-tag>In</span> </div> </div> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-input-group q-marg-top-xs-til-md xs-pad-bottom\"> <div class=row> <div class=\"col-sm-5 col-xs-12\"> <div class=q-valuable>Height</div> </div> <div class=\"col-sm-7 col-xs-12 wrapper-helper\"> <span class=\"q-tag asn-detail-height\">48</span> <span class=q-tag>In</span> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=weight-outer> <div class=\"q-input-group xs-pad-bottom\"> <div class=row> <div class=\"col-sm-5 col-xs-12\"> <div class=q-valuable>Weight</div> </div> <div class=\"col-sm-7 col-xs-12 wrapper-helper\"> <span class=\"q-tag asn-detail-weight\">500 </span> <span class=q-tag>lbs</span> </div> </div> </div> </div> </div> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-marg-vert-md q-marg-top-xs-til-md xs-pad-bottom stackable-pallet-outer\"> <div class=row> <div class=\"col-md-7 col-sm-5 col-xs-12\"> <div class=q-valuable>Pallet is stackable</div> </div> <div class=\"col-md-5 col-sm-7 col-xs-12 wrapper-helper\"> <div class=q-tag> <div class=\"q-pretty-pill-tag stackable-pallet-val\"> YES </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 293 */
/***/ function(module, exports) {

	module.exports = "<div class=\"shipping-asn-details-rows-view q-marg-vert-md\"> <div class=\"q-input-group q-marg-vert-lg\"> <h2 class=q-section-title> <span> <span class=case-pallet-title>Pallet</span> Information </span> </h2> </div> <div class=\"shipping-asn-details-rows-outer q-section-border-top q-marg-vert-md\"> </div> </div>";

/***/ },
/* 294 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-xs\"> <div class=discount-values-1> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-pad-all-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\">{%= usSurchargesValue %}</span> </div> </div> </div> </div> <div class=\"q-pct-header-group-expander {%= btnExpandableTarget %}\"> {% if (expandableTarget) { %} <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=\".{%= expandableTarget %}\" data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> {% } %} </div> </div> <div class=\" {%= btnExpandableTarget %} {% if (expandableTarget) { %} {%= expandableTarget %} q-expandable-default {% } %} \"> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-marg-vert-xs q-display-none-at-md\"> <div class=row> <label class=\"col-md-7 col-xs-12\"> <span class=q-boldest>Surcharge</span> </label> <label class=\"col-md-5 col-xs-12\"> <span class=q-boldest>Discount %</span> </label> </div> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-marg-vert-xs q-display-none-at-md\"> <div class=row> <label class=\"col-md-7 col-xs-12\"> <span class=q-boldest>Surcharge</span> </label> <label class=\"col-md-5 col-xs-12\"> <span class=q-boldest>Discount %</span> </label> </div> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-marg-vert-xs q-display-none-at-md\"> <div class=row> <label class=\"col-md-7 col-xs-12\"> <span class=q-boldest>Surcharge</span> </label> <label class=\"col-md-5 col-xs-12\"> <span class=q-boldest>Discount %</span> </label> </div> </div> </div> <div class=q-section id=\"discount-values-{%=counter%}\"> </div> </div> </div> </div>";

/***/ },
/* 295 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group dg-lg {%- closureDate %} remove-date-details\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=q-marg-top-xs> <span class=q-tag> {%= plannedClosureDate%} </span> </div> </div> <div class=\"col-md-9 col-xs-12 large-text-toggle-parent\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-top-xs q-boldest\"> <span class=\"\"> Closed full 24 hours </span> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no q-marg-top-xs-at-md\"> <input name=largeSwitcheryTextInputName type=checkbox class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-unchecked=true data-quick-toggler-closest=.large-text-toggle-parent data-quick-toggler-target=.large-text-toggle-target /> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-top-md-at-md q-pull-right-til-md\"> <a href=# id=\"remove-date-btn-{%- toggleForClosure%}\" class=\"base-btn purple-btn v2-btn q-text-center q-stretch-at-md q-marg-bottom-sm-at-md remove-date-btn\" data-index-id=\"{%- toggleForClosure %}\"> Remove Date </a> </div> </div> </div> <div class=large-text-toggle-target> <div class=\"q-marg-vert-md q-alert q-alert-grey\"> Set hours within in normal operations hours which the dock will be close. </div> <div class=q-marg-top-md> <div class=q-grid> <div class=\"q-input-group q-input-group-connected no-pad-bottom q-row q-input-group-connected-break-at-sm time-picker-area q-marg-top-xs-at-md\"> <div class=\"q-input-group-connected-inner q-input-first q-static-col-3 q-input-first time-picker-area\"> <div class=q-marg-all-md> <span class=q-tag> Close Start Time </span> </div> <div class=time-picker-from> </div> </div> <div class=\"q-input-group-connected-inner q-static-col\"> <div class=\"q-sim-input q-no-border\"> </div> </div> <div class=\"q-input-group-connected-inner q-input-last q-static-col-3 q-input-last\"> <div class=q-marg-all-md> <span class=q-tag> Close End Time </span> </div> <div class=time-picker-to> </div> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 296 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row q-marg-top-md new-shift\"> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-display-none q-block-at-md\">Start Time</span> <div class=time-picker-from> </div> </div> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-display-none q-block-at-md\">End Time</span> <div class=time-picker-to> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-top-xs-at-md> <a href=# class=\"base-btn purple-btn q-marg-right-xs new-shift-add-shift-btn\">Add Time Block</a> <a href=# class=\"base-btn purple-btn v2-btn remove-shift-btn\">Remove</a> </div> </div> </div>";

/***/ },
/* 297 */
/***/ function(module, exports) {

	module.exports = "<div class=q-expandable-wrap id=planned-closure-details> <div class=q-expandable-header> <h2 class=q-expandable-title> Planned Operation Closures </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.planned-operation-closure data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"planned-operation-closure q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=q-marg-vert-md> Set all dates with planned exceptions to regular operation hours. All recorded times will be displayed in ET. </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Closed Date </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=wrapper-helper> <div class=\"q-input-with-inner-text q-inner-text-right func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input name=add-date-text class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input planned-date-area\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <a href=# class=\"base-btn purple-btn q-text-center q-block-at-md q-marg-top-md-at-md add-date-btn\"> Add Date </a> </div> </div> </div> <div class=q-marg-vert-md name=closure-details> <div class=\"divider-group divider-group-title q-no-pad-left-til-md\"> <h4 class=\"q-fw-normal q-no-marg\"> Planned Closure Dates </h4> </div> {% if(closureDates.length == 0) {%} <div class=q-marg-top-md> <div class=\"q-alert q-alert-grey\"> No planned closure dates or times. </div> </div> {% } %} {%= closureDates %} </div> </div> </div> </div>";

/***/ },
/* 298 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-label>{%- facility.cdmValue %}</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12 error-wrapper\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input class=facilityType type=checkbox data-error-placement-append-closest=.error-wrapper id=\"{%- facility.cdmMeaning %}\" value=\"{%- facility.cdmMeaning %}\" name=\"{%- facility.cdmMeaning %}\" {%- optional.isChecked %}/> <label for=\"{%- facility.cdmMeaning %}\">{%- facility.cdmDescription %}</label> </div> </div> </div> </div>";

/***/ },
/* 299 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>{%- inboundClassificationItem.cdmMeaning %}</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12 error-wrapper\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox data-error-placement-append-closest=.error-wrapper id=\"{%- inboundClassificationItem.cdmValue %}\" value=\"{%- inboundClassificationItem.cdmValue %}\" {%- optional.isChecked %} name=inboundClassificationTypes /> <label for=\"{%- inboundClassificationItem.cdmValue %}\">&nbsp;</label> </div> </div> </div> </div>";

/***/ },
/* 300 */
/***/ function(module, exports) {

	module.exports = "<form class=supplyChianConfigModalForm> <div class=\"q-section q-section-bg-grey\"> <div class=q-pad-all-xl> <h2 class=\"qw-section-title q-no-marg\"> <span class=facName>{%- optional.facilityName %}</span> <input type=hidden class=facId name=facId> </h2> </div> </div> <div class=q-section> <div class=q-pad-all-xl> <div class=\"pretty-well pw-border pw-border-rad\"> <div> <i class=\"fa fa-exclamation-circle fa-2x\" aria-hidden=true></i> </div> <div class=q-marg-top-md> You have enabled multiple warehouses for fulfillment in you FedEx Supply Chain Network. Orders will be split based on your Order Processing configurations. To learn more about order splitting, read the <a href={%- link %} target=_blank>Order Processing Guide.</a> </div> </div> </div> </div> <div class=q-section> <div class=q-pad-all-xl> <h2 class=qw-section-title> <span>Fulfillment</span> </h2> <div class=q-marg-vert-lg> <p>Configure the fulfillment functionality for this facility</p> <div class=\"divider-group q-pad-vert-xs\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-boldest q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">Fulfillment Center </div> </div> <div class=\"col-md-1 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=fulfillment-center class=fulfillment-center value=1 name=fulfillment-center /> <label for=fulfillment-center></label> </div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">B2C orders can be fulfilled from this facility.</div> </div> </div> </div> <div class=\"divider-group q-pad-vert-xs\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-boldest q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">Distribution Center </div> </div> <div class=\"col-md-1 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=distribution-center class=distribution-center value=1 name=distribution-center /> <label for=distribution-center></label> </div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">B2B orders can be fulfilled from this facility.</div> </div> </div> </div> <div class=\"divider-group q-pad-vert-xs\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-boldest q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">International Fulfillment Center</div> </div> <div class=\"col-md-1 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=international-fulfillment-center class=international-fulfillment-center value=1 name=international-fulfillment-center /> <label for=international-fulfillment-center></label> </div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">International orders can be fulfilled from this facility.</div> </div> </div> </div> <div class=\"divider-group q-pad-vert-xs\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-boldest q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">Additional Units of Measure</div> </div> <div class=\"col-md-1 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=additional-units-of-measure class=additional-units-of-measure value=1 name=additional-units-of-measure /> <label for=additional-units-of-measure class=additional-units-of-measure></label> </div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">Facility can support case and/or pallet ordered units of measure.</div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-pad-all-xl> <h2 class=qw-section-title> <span>Returns</span> </h2> <div class=q-marg-vert-lg> <p>Configure the returns functionality for this facility</p> <div class=\"divider-group q-pad-vert-xs\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-boldest q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">Returns Center </div> </div> <div class=\"col-md-1 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=returns-center class=returns-center value=1 name=returns-center /> <label for=returns-center></label> </div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">Returns can be sent to this facility.</div> </div> </div> </div> <div class=\"divider-group q-pad-vert-xs\" style=display:none id=fedex-account1> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-boldest q-marg-top-xs-til-md q-marg-vert-xxs-at-md\"> Use own FedEx Account </div> </div> <div class=\"col-md-1 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=fedex-account class=fedex-account value=1 name=fedex-account /> <label for=fedex-account> </label> </div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-marg-top-xs-til-md q-marg-vert-xxs-at-md\">Shipping changed to internal account. </div> </div> </div> </div> <div id=fedexAcntChecked style=display:none class=\"divider-group q-pad-vert-xs\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-boldest q-marg-top-xs-til-md q-marg-vert-xxs-at-md\" id=fedexAcntChecked> Return Location Account </div> </div> <div class=\"col-md-1 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=merchant-tier> <select class=\"select2-select q-input fedex-acct-num\" name=FedExAccountNumbers style=width:100% data-s2-minimum-results-for-search=Infinity data-s2-placeholder=\"Select FedEx Return Account\" data-error-placement-append-closest=div id=fedex-account-numbers value=\"{%- optional.cadCmtId %}\" required> <option value=\"\"></option> {%= rmsFedexAccounts %} </select> </div> </div> </div> </div> </div> </div> </div>    </form>";

/***/ },
/* 301 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red q-pad-vert-md q-pad-horz-xl\"> You have reached the maximum amount of {%- maxDisplay %} boxes. If you need more boxes, please split this into two returns. </div> </div>";

/***/ },
/* 302 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> {%= statusPill %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> This order is in an <b>Backordered Status</b> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> Once the products currently in backorder become available with inventory you will no longer be able to edit the order. This also means that if inventory becomes available while you are editing, you will not be able to save your edit. </div> </div> </div> </div>";

/***/ },
/* 303 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> {%= statusPill %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> This order is in Held status due to it's <b>Channel Order Grace Period</b> schedule. </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> Once this grace period expires, you will no longer be able to edit the order. Please confirm that you have an adequate amount of time to complete the edit based on the schedule release count down below. </div> </div> </div> <div class=q-marg-vert-md> <div class=\"divider-group dg-lg\"> <div class=row> <div class=col-xs-12> <div class=q-text-center> <span class=q-boldest>Scheduled to be release in:</span> <span class=\"q-box-border q-bb-lighter-grey q-text-center q-marg-left-md\"> <i class=\"fa fa-hourglass-half\" aria-hidden=true></i> <span class=countdown-time-modal></span> </span> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 304 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> {%= statusPill %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> This order is in Held status due to it's <b>custom Scheduled Release</b>. </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> Once this release time expires, you will no longer be able to edit the order. Please confirm that you have an adequate amount of time to complete the edit based on the schedule release count down below. </div> </div> </div> <div class=q-marg-vert-md> <div class=\"divider-group dg-lg\"> <div class=row> <div class=col-xs-12> <div class=q-text-center> <span class=q-boldest>Scheduled to be release in:</span> <span class=\"q-box-border q-bb-lighter-grey q-text-center q-marg-left-md\"> <i class=\"fa fa-hourglass-half\" aria-hidden=true></i> <span class=countdown-time-modal></span> </span> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 305 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> {%= statusPill %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> This order is in an <b>Error Status</b> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> Once the error reason is addressed and the order is released you will no longer be able to edit the order. This also means that if the error is resolved while you are editing the order, you will not be able to save your edit. </div> </div> </div> </div>";

/***/ },
/* 306 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> {%= statusPill %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> This order is in Held status due to a <b>manual hold</b> that will keep it in a held status until it is manually released. </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> Once released you will no longer be able to edit the order. </div> </div> </div> </div>";

/***/ },
/* 307 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> {%= statusPill %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> This order is in Held status due to it's <b>Portal Order Grace Period</b> schedule. </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> Once this release time expires, you will no longer be able to edit the order. Please confirm that you have an adequate amount of time to complete the edit based on the schedule release count down below. </div> </div> </div> <div class=q-marg-vert-md> <div class=\"divider-group dg-lg\"> <div class=row> <div class=col-xs-12> <div class=q-text-center> <span class=q-boldest>Scheduled to be release in:</span> <span class=\"q-box-border q-bb-lighter-grey q-text-center q-marg-left-md\"> <i class=\"fa fa-hourglass-half\" aria-hidden=true></i> <span class=countdown-time-modal></span> </span> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 308 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pill {%- statusPillClass %} q-stretch\"> {%- statusText %} </div>";

/***/ },
/* 309 */
/***/ function(module, exports) {

	module.exports = "<div class=q-text-center> <span class=\"products-tab-available-units q-pill q-pill-table {%- pillClass %} \" name=\"\"> <strong>{%- unit %} {%- measure %}</strong> <input type=hidden class=products-tab-available-qty value=\"{%- unit %}\"/> </span> </div>";

/***/ },
/* 310 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-lg> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> {%-name%}: </div> <div class=\"col-lg-3 q-marg-bottom-md-at-md\"> <div class=\"quick-btn-group qb-default qb-purple-theme q-text-center {%-key%}-toggler\"> <a href=# class=\"q-btn first-child active\" data-qb-key=%> All </a> <a href=# class=\"q-btn last-child\" data-qb-key=#> Specific </a> <input type=hidden class=\"split-button quick-btn-group-hidden-input\" id=\"{%-key%}\" name=\"{%-key%}\"/> </div> </div> <div class=\"col-lg-6 q-marg-bottom-md-at-md\"> <div class=\"q-typeahead-wrapper error-wrapper\"> <select id=\"{%-key%}-values\" name=\"{%-key%}-values\" multiple=\"\" class=\"q-input q-stretch required\" data-error-placement-append-closest=.error-wrapper> {% if(hasInitialValue){ %} {%   _(values).each((value)=>{ %} <option value=\"{%-value%}\" selected=selected>{%-value%}</option> {%   }); %} {% } %} </select> </div> </div> </div> </div>";

/***/ },
/* 311 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=q-section-title> 3. Products </h2> </div> <div class=q-marg-all-md> <p class=text-grey>When creating RMAs within FedEx Returns Technology you are required to have an item associated with every return. The system provides two options to choose how items are used in the system.</p> <p class=text-grey>Merchants can load a product catalog with each individual item listed in the system. This gives merchants visibility into what products are included in each return.</p> <p class=text-grey>Merchants who do not wish to load a product catalog can use the system Default Item. When using Default item, you will not have visibility into what products are included in each return prior to receipt at the return destination.</p> </div> </div> <div class=\"q-pad-horz-xl q-marg-vert-xl\"> <h2 class=q-section-title>Default Item Selection</h2> <div class=\"togglable-parent q-marg-bottom-xl\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=international-shipping class=q-label>Use default Item</label> </div> <div class=\"col-md-9 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input name=international-shipping id=international-shipping type=checkbox class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.togglable-parent data-quick-toggler-target=.togglable-target /> </div> </div> </div> <p class=\"q-italic q-marg-vert-md\">By selecting No for a default item you will be required to enter your individual items before RMA creation can happen.</p> <p class=\"q-boldest q-marg-vert-md q-underline\">Choices for entering items:</p> <ul> <li>Manual entry using the portal</li> <li>Bulk Upload</li> <li>API for Items</li> </ul> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <a href=# class=\"qw-next base-btn purple-btn default-prodct-btn enabled\" style=display:block> Next <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> </div> </div> </div>";

/***/ },
/* 312 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=q-section-title> 4. Returns Configurations </h2> <p class=\"q-italic text-grey\">The following basic configurations can be set at this time. </p> </div> <hr> <div class=\"fedEx-branded-togglable-parent q-marg-bottom-xl\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=fedEx-branded-email class=q-label>FedEx Branded Email Notifications</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input name=fedEx-branded-email id=fedEx-branded-email type=checkbox class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.fedEx-branded-togglable-parent data-quick-toggler-target=.fedEx-branded-togglable-target /> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=fedEx-branded-togglable-target> Return Email Notifications: Would you like the Returns Technology system to send a FedEx branded email to the customer when an RMA is created ? </div> </div> </div> </div> <p class=\"q-boldest q-marg-vert-md q-underline text-purple\">Shipping and Processing Overrides tab</p> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=\"show-ability-togglable-parent q-marg-bottom-xl\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <label for=show-ability-override class=q-label>Show ability to override the default shipping service</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input name=show-ability-override id=show-ability-override type=checkbox class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.show-ability-togglable-parent data-quick-toggler-target=.show-ability-togglable-target /> </div> </div> <div class=\"col-md-10 col-xs-12\"> <div class=show-ability-togglable-target> <div class=q-marg-top-md> This override allows the user entering the RMA to select the shipping service to use instead of system logic. </div> </div> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"show-ability-address-togglable-parent q-marg-bottom-xl\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <label for=show-ability-override-address class=q-label>Show ability to override the default ship to address</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input name=show-ability-override-address id=show-ability-override-address type=checkbox class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.show-ability-address-togglable-parent data-quick-toggler-target=.show-ability-address-togglable-target /> </div> </div> <div class=\"col-md-10 col-xs-12\"> <div class=show-ability-address-togglable-target> <div class=q-marg-top-md> This override allows the user entering the RMA to choose a location for this shipment to be sent to. </div> </div> </div> </div> </div> </div> </div> <div class=\"add-reason-section q-marg-top-md\"> <p class=q-boldest>By default the Reason for Return is set to show during RMA creation.</p> <p class=\"q-italic text-grey\">You can now build a list of values that will make up the dropdown for the reason for return.</p> <p class=\"q-italic text-grey\">You can add a value which is used for storage and a display value which will show in the drop down: <span class=txt-c-red>A maximum of three values can be entered now</span> </p> <div class=\"q-italic text-grey\"> <span>Example: Value = WS</span> <span class=q-marg-left-md>Display Value = Wrong Size</span> </div> <div class=row> <div class=\"col-md-5 col-xs-12\"> <label class=q-label>Value</label> <input type=text class=\"q-input q-stretch return-reason-short-value\"> </div> <div class=\"col-md-5 col-xs-12\"> <label class=q-label>Display Value</label> <input type=text class=\"q-input q-stretch retunr-reason-display-value\"> </div> <div class=\"col-md-2 col-xs-12\"> <a href=\"\" class=\"base-btn purple-btn q-marg-top-xl-til-md q-marg-top-md-at-md add-reason-btn\">Add Reason</a> </div> </div> <p class=\"q-boldest q-marg-vert-md\">Current drop-down list:</p> <ol id=responseData> </ol> </div> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <a href=# class=\"qw-next base-btn purple-btn email-shipping-address-btn enabled\" style=display:block> Next <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> </div> </div>";

/***/ },
/* 313 */
/***/ function(module, exports) {

	module.exports = "<form id=self-onboarding-wizard class=\"quick-wizard qw-default q-default-base qw-theme-purple q-max-page-width-md\"> <div class=qw-title-outer> <div class=\"header q-pad-vert-sm q-pad-horz-xl q-bg-c-purple\"></div> <div class=\"q-section q-no-border-bottom\"> <div class=q-marg-all-xl> <div class=logo-section> <img src=data:image/png;base64,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 /> </div> <h2 class=\"q-title q-boldest q-underline\"> Return Technology Registration </h2> <hr> <h4 class=qw-sub-title> Configuration Steps </h4> </div> </div> </div> <div class=qw-nav-steps> <a href=accounts.html class=\"qw-nav-step active\" id=accountsTabForm data-qw-form-target=.so-accounts-tab> </a> <a href=locations.html class=qw-nav-step data-qw-form-target=.so-locations-tab> </a> <a href=products.html class=qw-nav-step data-qw-form-target=.so-products-tab> </a> <a href=returnConfigurations.html class=qw-nav-step data-qw-form-target=.so-returnConfigurations-tab> </a> <a href=summary.html class=qw-nav-step data-qw-form-target=.so-summary-tab> </a> </div> <div class=qw-forms-outer> <div class=\"qw-form so-accounts-tab self-tab\" id=accountsTab name=accountsTab> <div class=\"qw-form-inner so-accounts-tab\" id=accountInnerTab name=accountInnerTab> {%= accounts %} </div> </div> <div class=\"qw-form so-locations-tab self-tab\" id=locationTab name=locationTab> <div class=\"qw-form-inner so-locations-tab\"> {%= locations %} </div> </div> <div class=\"qw-form so-products-tab self-tab\" id=productTab name=productTab> <div class=\"qw-form-inner so-products-tab\"> {%= products %} </div> </div> <div class=\"qw-form so-returnConfigurations-tab self-tab\"> <div class=qw-form-inner> {%= returnConfigurations %} </div> </div> <div class=\"qw-form so-summary-tab self-tab\"> <div class=qw-form-inner> {%= summary %} </div> </div> </div> <div class=\"modal fade q-modal q-default-base q-default fedex-account-select-modal q-reset\" style=display:none id=confirmationBoxToSaveAccountAddress role=dialog> <div class=modal-dialog> <div class=modal-content> <div class=\"modal-header q-modal-header-double\"> <h3 class=\"q-modal-title q-text-center\">Save Account Address <h4 class=q-modal-sub-title>Please continue to save the account address </h4> </h3></div> <div class=modal-body> <div class=q-bg-c-lightest-grey> <div class=q-section> </div> </div> </div> <div class=modal-footer> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <a href=# id=save-account-address-cancel class=\"base-btn purple-btn\"> <i class=\"fa fa-angle-left\" aria-hidden=true></i> Cancel </a> <a href=# id=save-account-address-continue class=\"base-btn purple-btn\"> Continue <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> </div> </div> </div> </div> </form>";

/***/ },
/* 314 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-md> <h2 class=\"q-section-title txt-c-green q-boldest\"> Congratulations your enrollment in Returns Technology is now complete! </h2> </div> <p class=\"q-italic text-grey\">At time you have completed the registration process, by default you will have the ability to create RMAs using the Returns Technology Portal. </p> <div class=q-marg-top-lg> <span class=q-boldest>Manual Entry:</span> <span class=q-italic>RMA are entered into the Returns Technology Portal directly.</span> </div> <hr> <p class=\"q-italic text-grey q-marg-bottom-md\">Other RMA entry possibilities are as follows: </p> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=q-boldest>Returns Tech Lite</div> <p class=\"q-italic text-grey q-marg-top-xxs\"> A hyperlink that can be added to a web page or sent in an email that allows the customer the ability to enter their return information and obtain a shipping label. </p> </div> <div class=\"col-md-4 col-xs-12\"> <div class=q-boldest>Returns Tech Window</div> <p class=\"q-italic text-grey q-marg-top-xxs\"> I want to send the RMA information in from a supporting Returns Technology window on my web based application. </p> </div> <div class=\"col-md-4 col-xs-12\"> <div class=q-boldest>Returns Tech APIs</div> <p class=\"q-italic text-grey q-marg-top-xxs\"> Utilize ther Returns Technology suite of APIs to create my RMAs </p> </div> </div> <div class=q-marg-top-md> <h4 class=q-title> Whats next: </h4> <div class=\"q-marg-vert-xl q-step-item\"> <div class=q-step-item-number> <div class=\"q-circle qc-purple\"> 1 </div> </div> <div class=\"q-step-item-text q-boldest\"> You will receive a welcome email stating how to get further assistance in setting up your returns environment with an introduction to the FedEx Customer Technology team. </div> </div> <div class=\"q-marg-vert-xl q-step-item\"> <div class=q-step-item-number> <div class=\"q-circle qc-purple\"> 2 </div> </div> <div class=\"q-step-item-text q-boldest\"> Log in to the Returns Technology portal and familiarize yourself with all that it offers. </div> </div> <div class=\"q-text-center q-boldest\"> Returns Technology URL:<span class=\"copy-text txt-c-purple\">https://fulfillment.fedex.com</span> </div> </div> <div class=q-section> <div class=\"q-marg-horz-xl q-marg-vert-xl\"> <a href=# class=\"base-btn middle-btn purple-btn block-btn q-text-center submit-facility-setup-wizard\"> Done </a> </div> </div> </div> </div>";

/***/ },
/* 315 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group dg-md\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs-til-md\"> <span class=q-boldest> {%- key %}: </span> </div> <div class=\"col-md-3 col-xs-12 q-marg-top-xxxs-til-md\"> {%- shiftTime %} </div> </div> </div>";

/***/ },
/* 316 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group dg-md\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> <span class=q-boldest> {%- text %} </span> </div> </div> </div>";

/***/ },
/* 317 */
/***/ function(module, exports) {

	module.exports = "<div class=loading-overlay> <div class=lo-content-wrap> <div class=lo-content> <i class=\"fa fa-spinner fa-5x fa-pulse\"></i> <div class=q-marg-top-xl> <h2> Loading... </h2> </div> </div> </div> </div>";

/***/ },
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1525),
	    mapCacheDelete = __webpack_require__(1526),
	    mapCacheGet = __webpack_require__(1527),
	    mapCacheHas = __webpack_require__(1528),
	    mapCacheSet = __webpack_require__(1529);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(1485),
	    arraySome = __webpack_require__(1492),
	    cacheHas = __webpack_require__(1502);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 327 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 328 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 329 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(64),
	    stubFalse = __webpack_require__(1548);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)(module)))

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(138),
	    isObject = __webpack_require__(106);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 332 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1498),
	    baseUnary = __webpack_require__(1501),
	    nodeUtil = __webpack_require__(1532);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'MMMM [de] D [de] YYYY',
	            LLL : 'MMMM [de] D [de] YYYY h:mm A',
	            LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka horan', 'ek hor'],
	            'hh': [number + ' horanim', number + ' horam'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	        monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(7)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isObject = __webpack_require__(106);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnionSchema = function () {
	  function UnionSchema(itemSchema, options) {
	    _classCallCheck(this, UnionSchema);
	
	    if (!(0, _isObject2.default)(itemSchema)) {
	      throw new Error('UnionSchema requires item schema to be an object.');
	    }
	
	    if (!options || !options.schemaAttribute) {
	      throw new Error('UnionSchema requires schemaAttribute option.');
	    }
	
	    this._itemSchema = itemSchema;
	
	    var schemaAttribute = options.schemaAttribute;
	    this._getSchema = typeof schemaAttribute === 'function' ? schemaAttribute : function (x) {
	      return x[schemaAttribute];
	    };
	  }
	
	  _createClass(UnionSchema, [{
	    key: 'getItemSchema',
	    value: function getItemSchema() {
	      return this._itemSchema;
	    }
	  }, {
	    key: 'getSchemaKey',
	    value: function getSchemaKey(item) {
	      return this._getSchema(item);
	    }
	  }]);
	
	  return UnionSchema;
	}();
	
	exports.default = UnionSchema;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(133);
	var callBound = __webpack_require__(72);
	var inspect = __webpack_require__(142);
	
	var $TypeError = __webpack_require__(63);
	var $Map = GetIntrinsic('%Map%', true);
	
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
	var $mapGet = callBound('Map.prototype.get', true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
	var $mapSet = callBound('Map.prototype.set', true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
	var $mapHas = callBound('Map.prototype.has', true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
	var $mapDelete = callBound('Map.prototype.delete', true);
	/** @type {<K, V>(thisArg: Map<K, V>) => number} */
	var $mapSize = callBound('Map.prototype.size', true);
	
	/** @type {import('.')} */
	module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
		/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */
	
		/** @type {Map<K, V> | undefined} */ var $m;
	
		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($m) {
					var result = $mapDelete($m, key);
					if ($mapSize($m) === 0) {
						$m = void undefined;
					}
					return result;
				}
				return false;
			},
			get: function (key) { // eslint-disable-line consistent-return
				if ($m) {
					return $mapGet($m, key);
				}
			},
			has: function (key) {
				if ($m) {
					return $mapHas($m, key);
				}
				return false;
			},
			set: function (key, value) {
				if (!$m) {
					// @ts-expect-error TS can't handle narrowing a variable inside a closure
					$m = new $Map();
				}
				$mapSet($m, key, value);
			}
		};
	
		// @ts-expect-error TODO: figure out why TS is erroring here
		return channel;
	};


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var formats = __webpack_require__(194);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? { __proto__: null } : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var merge = function merge(target, source, options) {
	    /* eslint no-param-reassign: 0 */
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object' && typeof source !== 'function') {
	        if (isArray(target)) {
	            target.push(source);
	        } else if (target && typeof target === 'object') {
	            if (
	                (options && (options.plainObjects || options.allowPrototypes))
	                || !has.call(Object.prototype, source)
	            ) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (isArray(target) && !isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	    }
	
	    if (isArray(target) && isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	var decode = function (str, defaultDecoder, charset) {
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var limit = 1024;
	
	/* eslint operator-linebreak: [2, "before"] */
	
	var encode = function encode(str, defaultEncoder, charset, kind, format) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(str);
	    }
	
	    if (charset === 'iso-8859-1') {
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        });
	    }
	
	    var out = '';
	    for (var j = 0; j < string.length; j += limit) {
	        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
	        var arr = [];
	
	        for (var i = 0; i < segment.length; ++i) {
	            var c = segment.charCodeAt(i);
	            if (
	                c === 0x2D // -
	                || c === 0x2E // .
	                || c === 0x5F // _
	                || c === 0x7E // ~
	                || (c >= 0x30 && c <= 0x39) // 0-9
	                || (c >= 0x41 && c <= 0x5A) // a-z
	                || (c >= 0x61 && c <= 0x7A) // A-Z
	                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
	            ) {
	                arr[arr.length] = segment.charAt(i);
	                continue;
	            }
	
	            if (c < 0x80) {
	                arr[arr.length] = hexTable[c];
	                continue;
	            }
	
	            if (c < 0x800) {
	                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
	                    + hexTable[0x80 | (c & 0x3F)];
	                continue;
	            }
	
	            if (c < 0xD800 || c >= 0xE000) {
	                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
	                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
	                    + hexTable[0x80 | (c & 0x3F)];
	                continue;
	            }
	
	            i += 1;
	            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));
	
	            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
	                + hexTable[0x80 | ((c >> 12) & 0x3F)]
	                + hexTable[0x80 | ((c >> 6) & 0x3F)]
	                + hexTable[0x80 | (c & 0x3F)];
	        }
	
	        out += arr.join('');
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b) {
	    return [].concat(a, b);
	};
	
	var maybeMap = function maybeMap(val, fn) {
	    if (isArray(val)) {
	        var mapped = [];
	        for (var i = 0; i < val.length; i += 1) {
	            mapped.push(fn(val[i]));
	        }
	        return mapped;
	    }
	    return fn(val);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isRegExp: isRegExp,
	    maybeMap: maybeMap,
	    merge: merge
	};


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var forEach = __webpack_require__(1130);
	var availableTypedArrays = __webpack_require__(461);
	var callBind = __webpack_require__(852);
	var callBound = __webpack_require__(72);
	var gOPD = __webpack_require__(93);
	var getProto = __webpack_require__(181);
	
	var $toString = callBound('Object.prototype.toString');
	var hasToStringTag = __webpack_require__(134)();
	
	var g = typeof globalThis === 'undefined' ? global : globalThis;
	var typedArrays = availableTypedArrays();
	
	var $slice = callBound('String.prototype.slice');
	
	/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */
	var $indexOf = callBound('Array.prototype.indexOf', true) || function indexOf(array, value) {
		for (var i = 0; i < array.length; i += 1) {
			if (array[i] === value) {
				return i;
			}
		}
		return -1;
	};
	
	/** @typedef {import('./types').Getter} Getter */
	/** @type {import('./types').Cache} */
	var cache = { __proto__: null };
	if (hasToStringTag && gOPD && getProto) {
		forEach(typedArrays, function (typedArray) {
			var arr = new g[typedArray]();
			if (Symbol.toStringTag in arr && getProto) {
				var proto = getProto(arr);
				// @ts-expect-error TS won't narrow inside a closure
				var descriptor = gOPD(proto, Symbol.toStringTag);
				if (!descriptor && proto) {
					var superProto = getProto(proto);
					// @ts-expect-error TS won't narrow inside a closure
					descriptor = gOPD(superProto, Symbol.toStringTag);
				}
				// @ts-expect-error TODO: fix
				cache['$' + typedArray] = callBind(descriptor.get);
			}
		});
	} else {
		forEach(typedArrays, function (typedArray) {
			var arr = new g[typedArray]();
			var fn = arr.slice || arr.set;
			if (fn) {
				cache[
					/** @type {`$${import('.').TypedArrayName}`} */ ('$' + typedArray)
				] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ (
					// @ts-expect-error TODO FIXME
					callBind(fn)
				);
			}
		});
	}
	
	/** @type {(value: object) => false | import('.').TypedArrayName} */
	var tryTypedArrays = function tryAllTypedArrays(value) {
		/** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
		forEach(
			/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ (cache),
			/** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
			function (getter, typedArray) {
				if (!found) {
					try {
						// @ts-expect-error a throw is fine here
						if ('$' + getter(value) === typedArray) {
							found = /** @type {import('.').TypedArrayName} */ ($slice(typedArray, 1));
						}
					} catch (e) { /**/ }
				}
			}
		);
		return found;
	};
	
	/** @type {(value: object) => false | import('.').TypedArrayName} */
	var trySlices = function tryAllSlices(value) {
		/** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
		forEach(
			/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */(cache),
			/** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function (getter, name) {
				if (!found) {
					try {
						// @ts-expect-error a throw is fine here
						getter(value);
						found = /** @type {import('.').TypedArrayName} */ ($slice(name, 1));
					} catch (e) { /**/ }
				}
			}
		);
		return found;
	};
	
	/** @type {import('.')} */
	module.exports = function whichTypedArray(value) {
		if (!value || typeof value !== 'object') { return false; }
		if (!hasToStringTag) {
			/** @type {string} */
			var tag = $slice($toString(value), 8, -1);
			if ($indexOf(typedArrays, tag) > -1) {
				return tag;
			}
			if (tag !== 'Object') {
				return false;
			}
			// node < 0.6 hits here on real Typed Arrays
			return trySlices(value);
		}
		if (!gOPD) { return null; } // unknown engine
		return tryTypedArrays(value);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var possibleNames = __webpack_require__(1562);
	
	var g = typeof globalThis === 'undefined' ? global : globalThis;
	
	/** @type {import('.')} */
	module.exports = function availableTypedArrays() {
		var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
		for (var i = 0; i < possibleNames.length; i++) {
			if (typeof g[possibleNames[i]] === 'function') {
				// @ts-expect-error
				out[out.length] = possibleNames[i];
			}
		}
		return out;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchShippingQuotesForAsnData = fetchShippingQuotesForAsnData;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _QuoteStore = __webpack_require__(98);
	
	var _QuoteStore2 = _interopRequireDefault(_QuoteStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _utilities = __webpack_require__(463);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ajaxFunc = _jquery2.default.ajax;
	var TEST = false;
	
	function ajaxable(_ref) {
	  var returnableFn = _ref.returnableFn,
	      success = _ref.success,
	      error = _ref.error;
	
	  if (TEST) {
	    var timeoutToken = setTimeout(function () {
	      success(returnableConstantsMap[returnableFn]());
	    }, 500);
	
	    return {
	      abort: function abort() {
	        clearTimeout(timeoutToken);
	      }
	    };
	  } else {
	    _jquery2.default.ajax(_underscore2.default.omit.apply(_underscore2.default, Array.prototype.slice.call(arguments).concat(["returnableFn"])));
	  }
	}
	
	function fetchShippingQuotesForAsnData(asnId, asnData, url) {
	  var asn = _AsnStore2.default.getDataViaId(asnId);
	  if (asn.isFetchingQuotes) {
	    console.log("already fetching shipping quotes");
	    return false;
	  }
	
	  var deferred = _jquery2.default.Deferred();
	  _AsnStore2.default.resetQuotesRelatedFlags(asn, { isFetchingQuotes: true });
	  // AsnStore.updateObjectAndEmit(asnId, {isFetchingQuotes: true, quotesAreValid: null, showQuotesRemovedBecauseInfoChangedMessage: null});
	  _AsnStore2.default.emitEvent("fetchingQuotes");
	
	  var xhr = ajaxable({
	    returnableFn: "QUOTES_MOCK_DATA",
	    data: asnData,
	    url: url,
	    dataType: "JSON",
	    type: 'POST',
	    success: _underscore2.default.partial(_utilities.successGET, deferred),
	    error: _underscore2.default.partial(_utilities.errorStoreGET, deferred, _QuoteStore2.default)
	  });
	
	  var xhrSetup = xhrListenerSetup(xhr);
	  xhrSetup.bindListener();
	
	  deferred.always(_underscore2.default.partial(fetchShippingQuotesForAsnDataComplete, asnId, xhrSetup));
	  deferred.fail(_underscore2.default.partial(fetchShippingQuotesForAsnDataFail, asnId));
	  deferred.then(_underscore2.default.partial(handleAsnQuotesOrSpecialQuoteNoteSuccess, asnId));
	
	  // return xhr;
	}
	
	window.fetchShippingQuotesForAsnData = fetchShippingQuotesForAsnData;
	
	function fetchShippingQuotesForAsnDataComplete(asnId, xhrSetup) {
	  // console.log('shipping quote fetching complete');
	  xhrSetup.unbindListener();
	}
	
	function fetchShippingQuotesForAsnDataFail(asnId, store, xhr, status) {
	  if (status === "abort") {
	    console.log('aborted');
	    _AsnStore2.default.updateObjectAndEmit(asnId, { quoteId: null, optionId: null, quotesAreValid: null, showQuotesRemovedBecauseInfoChangedMessage: null, isFetchingQuotes: false, requestQuoteSuccess: null });
	  } else {
	    _AsnStore2.default.updateObjectAndEmit(asnId, { quoteId: null, optionId: null, quotesAreValid: null, showQuotesRemovedBecauseInfoChangedMessage: null, isFetchingQuotes: false, requestQuoteSuccess: false });
	  }
	}
	
	function handleAsnQuotesOrSpecialQuoteNoteSuccess(asnId, data) {
	  _QuoteStore2.default.normalizeAndStoreData(data);
	  var quotes = data.quotes;
	  var quoteIds = _QuoteStore2.default.pluckIdsFromArray(quotes);
	  if (quoteIds.length) {
	    _QuoteStore2.default.setAttrsForIds(quoteIds, { asnId: asnId });
	  }
	  _AsnStore2.default.updateObjectAndEmit(asnId, { quoteId: null, optionId: null, quotesAreValid: true, showQuotesRemovedBecauseInfoChangedMessage: null, isFetchingQuotes: false, requestQuoteSuccess: true, specialQuote: data.specialQuote, quotesRefId: data.quotesRefId });
	}
	
	function xhrListenerSetup(xhr) {
	
	  var abortNow = function abortNow() {
	    xhr.abort();
	  };
	
	  var bindListener = function bindListener() {};
	  var unbindListener = function unbindListener() {};
	
	  return {
	    bindListener: bindListener,
	    unbindListener: unbindListener
	  };
	}
	
	var returnableConstantsMap = {
	  QUOTES_MOCK_DATA: function QUOTES_MOCK_DATA() {
	    return _QuoteStore.mockPayload;
	  },
	  SPECIAL_QUOTE_DATA: function SPECIAL_QUOTE_DATA() {
	    return { quotes: [], specialQuote: true, quotesRefId: 5 };
	  }
	};

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.successGET = successGET;
	exports.successStoreGET = successStoreGET;
	exports.errorStoreGET = errorStoreGET;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function successGET(deferred, data) {
	  deferred.resolve(data);
	}
	
	function successStoreGET(deferred, store, data) {
	  var _console;
	
	  console.log("success func called");
	  (_console = console).log.apply(_console, arguments);
	  store.normalizeAndStoreData(data);
	  deferred.resolve.apply(deferred, arguments);
	}
	
	function errorStoreGET(deferred, store, xhr, status) {
	  console.log("ajax error GET quotes, status:", status);
	  var args = argsExceptFirst.apply(undefined, arguments);
	  deferred.reject(args);
	}
	
	function argsExceptFirst() {
	  return Array.prototype.slice.call(arguments, 1);
	}

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ErrorModal;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var modalHtml = __webpack_require__(11);
	var modalBodyHtml = __webpack_require__(1136);
	
	
	var elementsMap = {
	  closeBtn: ".top-close-btn"
	};
	
	function ErrorModal() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var self = this;
	  var els = {};
	  var errorModal = void 0;
	
	  self.init = function () {
	    buildHtml();
	    setElements();
	    bindElements();
	  };
	
	  self.showModal = function () {
	    showModal();
	  };
	
	  self.hideModal = function () {
	    hideModal();
	  };
	
	  self.setErrors = function () {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var errorBody = $(buildErrorModalBody(data));
	    errorModal.find('.modal-body').html(errorBody);
	  };
	
	  function buildErrorModalBody() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _render2.default)(modalBodyHtml, {
	      errorTitle: data.errorTitle || options.errorTitle,
	      errorDescription: data.errorDescription || options.errorDescription
	    });
	  }
	
	  function buildHtml() {
	    // Set Options
	    var modalDefaults = {
	      backdrop: 'static',
	      keyboard: false,
	      show: false
	    };
	
	    // Build Modal
	    errorModal = $((0, _render2.default)(modalHtml, {
	      title: 'Sorry...',
	      leftAlignTitle: (0, _general.keyDefaultFalseOption)(options, "errorModalLeftAlignTitle"),
	      body: buildErrorModalBody(),
	      topCloseBtn: (0, _general.keyDefaultFalseOption)(options, "errorModalTopClose"),
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Close</a>\n        "
	    }));
	
	    // Apply Options
	    errorModal.modal(modalDefaults);
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, errorModal);
	  }
	
	  function bindElements() {
	    els.closeBtn.on('click', onCloseClick);
	  }
	
	  function showModal() {
	    errorModal.modal("show");
	  }
	
	  function hideModal() {
	    errorModal.modal('hide');
	  }
	
	  function onCloseClick(e) {
	    e.preventDefault();
	    var shouldClose = options.shouldCloseModal && options.shouldCloseModal();
	    if (shouldClose !== false) {
	      hideModal();
	    }
	  }
	}

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = jqueryValidationSoftCheck;
	var $ = __webpack_require__(1);
	
	function jqueryValidationSoftCheck(validator, element) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return jqueryElementFunc.call(validator, element, options);
	}
	
	function jqueryValidationSoftChecker(element) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (options.$) {
	    $ = options.$;
	  }
	
	  element = this.validationTargetFor(this.clean(element));
	
	  var rules = $(element).rules(),
	      rulesCount = $.map(rules, function (n, i) {
	    return i;
	  }).length,
	      dependencyMismatch = false,
	      val = this.elementValue(element),
	      result,
	      method,
	      rule;
	
	  // If a normalizer is defined for this element, then
	  // call it to retreive the changed value instead
	  // of using the real one.
	  // Note that `this` in the normalizer is `element`.
	  if (typeof rules.normalizer === "function") {
	    val = rules.normalizer.call(element, val);
	
	    if (typeof val !== "string") {
	      throw new TypeError("The normalizer should return a string value.");
	    }
	
	    // Delete the normalizer from rules to avoid treating
	    // it as a pre-defined method.
	    delete rules.normalizer;
	  }
	
	  for (method in rules) {
	    rule = { method: method, parameters: rules[method] };
	
	    result = $.validator.methods[method].call(this, val, element, rule.parameters);
	
	    // If a method indicates that the field is optional and therefore valid,
	    // don't mark it as valid when there are no other rules
	    if (result === "dependency-mismatch" && rulesCount === 1) {
	      dependencyMismatch = true;
	      continue;
	    }
	    dependencyMismatch = false;
	
	    if (result === "pending") {
	      // this.toHide = this.toHide.not( this.errorsFor( element ) );
	      return;
	    }
	
	    if (!result) {
	      // THIS IS WERE JQUERY  VALIDATION
	      // MESSED UP, WE NEED A FUNCTION JUST LIKE
	      // THIS ONE, BUT THAT IS A PURE FUNCTION,
	      // NOT A MUTATING ONE
	      // this.formatAndAdd( element, rule );
	      return false;
	    }
	  }
	  return true;
	}
	
	function jqueryElementFunc(element) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var cleanElement = this.clean(element),
	      checkElement = this.validationTargetFor(cleanElement),
	      v = this,
	      result = true,
	      rs,
	      group;
	
	  if (checkElement === undefined) {
	    // delete this.invalid[ cleanElement.name ];
	  } else {
	    // this.prepareElement( checkElement );
	
	    // If this element is grouped, then validate all group elements already
	    // containing a value
	    group = this.groups[checkElement.name];
	    if (group) {
	      $.each(this.groups, function (name, testgroup) {
	        if (testgroup === group && name !== checkElement.name) {
	          cleanElement = v.validationTargetFor(v.clean(v.findByName(name)));
	          if (cleanElement && cleanElement.name in v.invalid) {
	            // v.currentElements.push( cleanElement );
	            result = jqueryValidationSoftChecker.call(v, cleanElement, options) && result;
	          }
	        }
	      });
	    }
	
	    rs = jqueryValidationSoftChecker.call(v, checkElement, options) !== false;
	    result = result && rs;
	  }
	
	  return !!result;
	}

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = WidgetEngine;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _weToggleHandler = __webpack_require__(467);
	
	var _weToggleHandler2 = _interopRequireDefault(_weToggleHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var $ = __webpack_require__(1);
	
	__webpack_require__(1067);
	
	var modalHtml = __webpack_require__(11);
	var baseHtml = __webpack_require__(1137);
	var feedContainerTemplateHtml = __webpack_require__(1149);
	var rowTemplateHtml = __webpack_require__(1152);
	
	var filterGroupCheckboxHtml = __webpack_require__(1139);
	var filterGroupRadioHtml = __webpack_require__(1141);
	var filterGroupDateRangeHtml = __webpack_require__(1140);
	var filterModalBodyHtml = __webpack_require__(1142);
	var filterModalBodyGroupHtml = __webpack_require__(1143);
	var childFiltersWrapHtml = __webpack_require__(1138);
	
	var searchLinksWrapHtml = __webpack_require__(1462);
	var searchLinkTemplateHtml = __webpack_require__(1463);
	var searchOptionTemplateHtml = __webpack_require__(135);
	
	var elementsMap = {
	  filterModalBtn: ".we-filter-modal-open",
	  pageRefreshBtn: ".we-page-refresh-trigger",
	  itemsContainer: ".we-items-container",
	  filterContainer: ".we-filter-container",
	  loadingOverlay: ".widget-loading-overlay",
	  loadMoreBtn: ".load-more-btn",
	  loadingInProgress: ".loading-in-progress",
	  filterLinkContainer: ".filter-link-container",
	  filterLinkBtn: ".filter-link",
	  filterLinkSelect: ".filter-by-select",
	  feedContainer: ".we-feed-container",
	  feedDataDisplay: ".we-feed-data-display"
	};
	
	var elementsModalMap = {
	  exportTypeToggler: ".export-type-toggler",
	  exportDateRangeStart: ".export-date-range-start",
	  exportDateRangeEnd: ".export-date-range-end"
	};
	
	var buildFilterModalInputListConfig = {
	  checkbox: filterGroupCheckboxHtml,
	  radio: filterGroupRadioHtml,
	  dateRange: filterGroupDateRangeHtml
	};
	
	var filterModalElementsMap = {
	  tableFilterModalForm: '.tableFilterModal',
	  applyFiltersBtn: ".js-apply-filters",
	  parentInput: ".filter-modal-input",
	  dateRangeInputs: ".func-date-range-input",
	  dateRangeStart: ".func-date-range-input#startDate",
	  dateRangeEnd: ".func-date-range-input#endDate"
	
	  // rename to match what this component is...
	};function WidgetEngine() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // functional code for component here
	  var els = {};
	  var elsModal = {};
	  var baseHtmlWrap = void 0,
	      baseHtmlEl = void 0,
	      filterModal = void 0,
	      validator = void 0;
	
	  var self = this;
	
	  var opts = (0, _general.merge)(options, {});
	
	  var validationOpts = {
	    debug: true,
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  };
	
	  var filterModalEls = {};
	  var newWeToggler = void 0;
	  var allTablesHtml = void 0;
	
	  self.init = function () {
	    buildHtml();
	    generateModals();
	    weToggleHandlerInit();
	    setElements();
	    bindElements();
	    toggleFilterModalChildInput();
	    validateForMoreData(opts.moreData);
	    setFilterLinkActive(opts.filterListActive);
	  };
	
	  self.showLoadingBtn = function () {
	    showLoadingBtn();
	  };
	
	  self.hideLoadingBtn = function () {
	    hideLoadingBtn();
	  };
	
	  self.appendNewData = function (data) {
	    appendNewData(data);
	  };
	
	  self.setNewData = function (data) {
	    setNewData(data);
	  };
	
	  self.refreshAfterActionClicked = function () {
	    refreshAfterActionClicked();
	  };
	
	  self.validateForMoreData = function (moreData) {
	    validateForMoreData(moreData);
	  };
	
	  self.generateData = function () {
	    return generateData();
	  };
	
	  self.setFilterLinkActive = function (filterLinkActive) {
	    setFilterLinkActive(filterLinkActive);
	  };
	
	  self.handleNewActiveDataCount = function (newActiveDataCount) {
	    handleNewActiveDataCount(newActiveDataCount);
	  };
	
	  // NOTE: for upcoming story
	  // self.onViewToggleCallback = function(){
	  //   onViewToggleCallback();
	  // }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, baseHtmlEl);
	    (0, _selectorHelpers.setElementsFromScope)(filterModalEls, filterModalElementsMap, filterModal);
	  }
	
	  function bindElements() {
	    els.filterModalBtn.on('click', openFilterModal);
	    els.pageRefreshBtn.on('click', onPageRefreshClick);
	    els.loadMoreBtn.click((0, _general.createPreventDefault)(onLoadMoreClick));
	    // This is here so if user clicks btn while loading, it just returns
	    els.loadingInProgress.click((0, _general.createPreventDefault)(function () {
	      return;
	    }));
	    filterModalEls.applyFiltersBtn.on('click', (0, _general.createPreventDefault)(onApplyFiltersClick));
	    els.filterLinkBtn.click(setFilterLinkFromBtn);
	    els.filterLinkSelect.change(setFilterLinkFromSelect);
	    filterModalEls.parentInput.on('change', toggleFilterModalChildInput);
	
	    filterModalEls.dateRangeInputs.datepicker({
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	    filterModalEls.dateRangeEnd.on('click', function () {
	      var initDate = filterModalEls.dateRangeStart.datepicker('getDate');
	      if (initDate) {
	        initDate = moment(initDate).add(1, 'days').toDate();
	        filterModalEls.dateRangeEnd.datepicker('setStartDate', initDate);
	      } else if (initDate === null) {
	        filterModalEls.dateRangeEnd.datepicker('setStartDate', null);
	      }
	    });
	    filterModalEls.dateRangeStart.on('click', function () {
	      var initDate = filterModalEls.dateRangeEnd.datepicker('getDate');
	      if (initDate) {
	        initDate = moment(initDate).subtract(1, 'days').toDate();
	        filterModalEls.dateRangeStart.datepicker('setEndDate', initDate);
	      } else if (initDate === null) {
	        filterModalEls.dateRangeStart.datepicker('setEndDate', null);
	      }
	    });
	    validator = filterModalEls.tableFilterModalForm.validate(validationOpts);
	    validator.settings.ignore = ":disabled,:hidden";
	  }
	
	  function onLoadMoreClick() {
	    if (els.loadMoreBtn.hasClass("disabled")) {
	      return;
	    }
	
	    onFetch();
	  }
	
	  function onFetch() {
	    opts.onFetch && opts.onFetch();
	  }
	
	  function onFilter() {
	    opts.onFilter && opts.onFilter();
	  }
	
	  function showLoadingBtn() {
	    els.loadMoreBtn.hide();
	    els.loadingInProgress.show();
	  }
	
	  function hideLoadingBtn() {
	    els.loadingInProgress.hide();
	    els.loadMoreBtn.show();
	  }
	
	  function buildHtml() {
	    var dataset = opts.data.data;
	    var tablesHtml = getTableHtml(dataset);
	
	    baseHtmlWrap = (0, _render2.default)(baseHtml, {
	      hasViewToggler: opts.hasViewToggler,
	      viewToggler: opts.viewToggler || "",
	      filterLinkContainer: renderFilterLinkList(opts.filterList),
	      feedContainer: tablesHtml,
	      hasLinkContainer: true
	    });
	
	    baseHtmlEl = $(opts.target).html(baseHtmlWrap);
	  };
	
	  function appendNewData(data) {
	    opts.data.data = [].concat(_toConsumableArray(opts.data.data), _toConsumableArray(data));
	    handleNewData(opts.data.data);
	  }
	
	  function setNewData(data) {
	    opts.data.data = [].concat(_toConsumableArray(data));
	    handleNewData(opts.data.data);
	  }
	
	  function handleNewData(newDataset) {
	    var tablesHtml = getTableHtml(newDataset);
	    els.feedContainer.html(tablesHtml);
	  }
	
	  function handleNewActiveDataCount(dataCount) {
	    if (opts.viewTogglerDataCountTarget) {
	      $(opts.viewTogglerDataCountTarget).html(dataCount);
	    }
	  }
	
	  function getTableHtml(data) {
	    var allTablesHtml = void 0;
	    if (opts.groupBy) {
	      var groupedData = (0, _underscore2.default)(data).groupBy(opts.groupBy);
	      // NOTE - if view is multiple tables, this should create new tables to bottom
	      allTablesHtml = _underscore2.default.values((0, _underscore2.default)(groupedData).mapObject(renderTable)).join("");
	    } else {
	      // NOTE: if one tables, this should just render new rows to add to bottom of table
	      allTablesHtml = renderTable(data, opts.header);
	    }
	
	    return allTablesHtml;
	  }
	
	  function refreshAfterActionClicked() {
	    onFilter();
	  }
	
	  function renderTable(tableData, header) {
	    var tableHtml = (0, _underscore2.default)(tableData).map(renderRow).join("");
	    return (0, _render2.default)(feedContainerTemplateHtml, {
	      header: header,
	      feedListOnload: tableHtml
	    });
	  }
	
	  function renderRow(rowData) {
	    var rowColumns = (0, _underscore2.default)(opts.columns).map(function (_ref) {
	      var data = _ref.data,
	          render = _ref.render;
	
	      if (render) {
	        return render(data, rowData[data], rowData);
	      }
	    }).join("");
	
	    return (0, _render2.default)(rowTemplateHtml, {
	      rowColumns: rowColumns
	    });
	  }
	
	  function renderFilterLinkList(list) {
	    return (0, _render2.default)(searchLinksWrapHtml, {
	      linkList: buildLinkList(list),
	      optionList: buildOptionList(list),
	      dropdownName: opts.widgetFilters.filterDropdownName || "",
	      dropdownId: opts.widgetFilters.filterDropdownId || "",
	      dropdownPlaceholder: opts.widgetFilters.filterDropdownPlaceholder || "",
	      dropdownMinResultsForSearch: "7"
	    });
	  }
	
	  function buildLinkList(list) {
	    return (0, _underscore2.default)(list).map(renderLink).join("");
	  }
	
	  function buildOptionList(list) {
	    return (0, _underscore2.default)(list).map(renderOption).join("");
	  }
	
	  function renderLink(listItem) {
	    return (0, _render2.default)(searchLinkTemplateHtml, {
	      text: listItem.name,
	      targetKey: listItem.filterBy,
	      linkHref: listItem.href || "#",
	      uniqueClass: listItem.uniqueClass || ""
	    });
	  }
	
	  function renderOption(optItem) {
	    return (0, _render2.default)(searchOptionTemplateHtml, {
	      text: optItem.name,
	      targetKey: optItem.filterBy
	    });
	  }
	
	  function setFilterLinkActive(filterLinkActive) {
	    els.filterLinkBtn.removeClass("active");
	
	    _underscore2.default.each(els.filterLinkBtn, function (val, key) {
	      var btnToBeActive = $(val);
	      if (btnToBeActive.data("link-info") === filterLinkActive) {
	        btnToBeActive.addClass("active");
	      }
	    });
	
	    els.filterLinkSelect.val(filterLinkActive).trigger('change.select2');
	  }
	
	  function weToggleHandlerInit() {
	    newWeToggler = new _weToggleHandler2.default({
	      mainEl: baseHtmlEl
	      // NOTE: for upcoming story
	      // onViewToggleCallback: function(){
	      //   opts.onViewToggleCallback && opts.onViewToggleCallback();
	      // }
	    });
	
	    newWeToggler.init();
	  }
	
	  function setFilterLinkFromBtn(e) {
	    e.preventDefault();
	
	    var clickedFilter = $(this).data("link-info");
	
	    els.filterLinkContainer.data("filter-link", clickedFilter);
	    onApplyFiltersClick();
	  }
	
	  function setFilterLinkFromSelect() {
	    var selectedFilter = els.filterLinkSelect.val();
	
	    els.filterLinkContainer.data("filter-link", selectedFilter);
	    onApplyFiltersClick();
	  }
	
	  function generateModals() {
	    filterModal = $((0, _render2.default)(modalHtml, {
	      title: opts.filterModal.title,
	      subtitle: "Select filters to apply to your " + opts.filterModal.widgetType,
	      leftAlignTitle: true,
	      topCloseBtn: true,
	      autoHideTop: true,
	      body: buildFilterModalBody(filterModalBodyHtml, filterModalBodyGroupHtml, opts.widgetFilters.data),
	      footerBtns: '\n          <a href="#" class="base-btn purple-btn js-apply-filters">Apply</a>\n        '
	    }));
	
	    baseHtmlEl.append(filterModal);
	  }
	
	  // NOTE: on click or change (based on link click or select option change), set variables here
	  function generateData() {
	    var filterDataArray = getFilterModalData();
	    var filterLinkData = els.filterLinkContainer.data("filter-link");
	    var searchCriteria = [].concat(_toConsumableArray(filterDataArray));
	    searchCriteria = (0, _underscore2.default)(searchCriteria).filter(function (filterData) {
	      return filterData && _underscore2.default.has(filterData, "key") && _underscore2.default.has(filterData, "operation") && _underscore2.default.has(filterData, "value");
	    });
	
	    // NOTE: put on change or on click data here for links
	    var widgetData = {
	      searchCriteria: searchCriteria,
	      filterLinkData: filterLinkData
	    };
	    return widgetData;
	  }
	
	  function getFilterModalData() {
	    // filterGroups = {
	    //   status: {
	    //     key: 'status'
	    //     operation: 'equal',
	    //     value: ['inStock','lowStock']
	    //   },
	    // }
	    var filterGroups = {};
	    (0, _underscore2.default)(filterModal.find('input:checked, input[type="text"]')).each(function (item) {
	      var key = $(item).attr('name');
	      var operation = $(item).data('operator');
	      var value = $(item).val();
	      filterGroups[key] = filterGroups[key] || { value: [] };
	      filterGroups[key].value.push(value);
	      filterGroups[key].operation = operation;
	      filterGroups[key].key = key;
	    });
	    return (0, _underscore2.default)(filterGroups).values();
	  }
	
	  function openFilterModal() {
	    filterModal.modal("show");
	  }
	
	  function onPageRefreshClick(e) {
	    e.preventDefault();
	    location.reload();
	  }
	
	  function closeFilterModal() {
	    filterModal.modal("hide");
	  }
	
	  function onApplyFiltersClick() {
	    var isValid = validateVisibleChildren();
	    if (isValid) {
	      closeFilterModal();
	
	      onFilter();
	    }
	  }
	
	  function buildFilterModalBody(bodyTemplate, groupTemplate, list) {
	    var modalBody = (0, _render2.default)(bodyTemplate, {
	      groupList: buildFilterModalGroupBody(groupTemplate, list)
	    });
	    return modalBody;
	  }
	
	  function buildFilterModalGroupBody(template, list) {
	    var filters = (0, _underscore2.default)(list).map(function (item, index) {
	      if (!item.filterGroupInputs) {
	        item.filterGroupInputs = [{}];
	      }
	      // Add option to allow parental control of name.
	      var filterList = buildFilterModalInputList(item, item.filterGroupInputs, item.filterGroupType);
	      return (0, _render2.default)(template, {
	        title: item.filterGroup,
	        filterList: filterList,
	        index: index
	      });
	    });
	    return filters.join('');
	  }
	
	  function buildFilterModalInputList(item, list, type) {
	    var filterList = (0, _underscore2.default)(list).map(function (input) {
	      // Example:
	      // {
	      //   checkbox: filterGroupCheckboxHtml,
	      // }
	      var filterTemplate = buildFilterModalInputListConfig[type];
	      var filterChildren = "";
	      if (input.childFilters) {
	        filterChildren = buildFilterModalGroupBody(childFiltersWrapHtml, input.childFilters);
	      }
	      return (0, _render2.default)(filterTemplate, {
	        title: input.filterTitle,
	        name: input.filterName || item.filterGroupName,
	        dateRangeNameStart: item.dateRangeNameStart,
	        dateRangeNameEnd: item.dateRangeNameEnd,
	        dateRangeStartVal: item.dateRangeStartVal || "",
	        dateRangeEndVal: item.dateRangeEndVal || "",
	        value: input.filterValue,
	        active: input.active,
	        operator: input.filterOperator,
	        childFiltersHtml: filterChildren
	      });
	    });
	    return filterList.join('');
	  }
	
	  function toggleFilterModalChildInput(e) {
	    var $self = $(this);
	    if ($self.attr('type') === 'radio') {
	      toggleFilterModalChildRadios($self);
	    };
	    var $target = $self.closest('.divider-group').find('.child-filters-entry');
	    validator.resetForm();
	    // USE BETTER SHOW/HIDE, LOW PRIORITY
	    $target.show();
	  }
	
	  function toggleFilterModalChildRadios(radioEl) {
	    var $radios = radioEl.closest('.input-list-section').find('input[type="radio"]');
	    $radios.each(function () {
	      var $curRadio = $(this);
	      var $target = $curRadio.closest('.divider-group').find('.child-filters-entry');
	      // Reset datepicker options.
	      filterModalEls.dateRangeInputs.datepicker("setStartDate", false);
	      filterModalEls.dateRangeInputs.datepicker("setEndDate", false);
	      // USE BETTER SHOW/HIDE, LOW PRIORITY
	      $target.find('input[type="text"]').val("");
	      $target.hide();
	    });
	  }
	
	  // Validation
	  function validateVisibleChildren() {
	    var isValid = false;
	    if (filterModalEls.tableFilterModalForm.valid()) {
	      isValid = true;
	    }
	    return isValid;
	  }
	
	  function validateForMoreData(moreData) {
	    //functionality to enable or disable load more btn
	    if (moreData) {
	      els.loadMoreBtn.removeClass("disabled");
	    } else {
	      els.loadMoreBtn.addClass("disabled");
	    }
	  }
	};

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = weToggleHandler;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	var elementsMap = {
	  mainToggleContainer: ".we-main-toggle-container",
	  mainToggleBtn: ".we-main-toggle-btn"
	};
	
	function weToggleHandler() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var self = this;
	  var els = {};
	  self.init = function () {
	    setElements();
	    bindElements();
	  };
	
	  // self.onViewToggleCallback = function(){
	  //   // NOTE: for upcoming story, will implement later
	  // }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, options.mainEl);
	  }
	
	  function bindElements() {
	    els.mainToggleBtn.click(handleSettingActive);
	  }
	
	  function handleSettingActive(e) {
	    e.preventDefault();
	    var btnClicked = $(this);
	
	    if (btnClicked.hasClass("disabled")) {
	      return;
	    }
	
	    els.mainToggleBtn.removeClass("active");
	    btnClicked.addClass("active");
	  }
	}

/***/ },
/* 468 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var testSavedViews = exports.testSavedViews = [{
	  title: "All Orders",
	  target: "allOrders",
	  active: true,
	  canRemove: false,
	  canEdit: false,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": false
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": true,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate",
	        "dateRangeEndVal": "05/31/2017",
	        "dateRangeStartVal": "05/30/2017"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "ordStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "prodName",
	    title: "Product Name",
	    active: true,
	    canToggle: false
	  }, {
	    data: "description",
	    title: "Description",
	    active: true,
	    canToggle: true
	  }, {
	    data: "facility",
	    title: "Facility",
	    active: true,
	    canToggle: true
	  }, {
	    data: "available",
	    title: "Available",
	    active: true,
	    canToggle: true
	  }, {
	    data: "ordStatus",
	    title: "Order Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "allocated",
	    title: "Allocated",
	    active: true,
	    canToggle: true
	  }]
	}, {
	  title: "Saved Search 1",
	  target: "savedSearchOne",
	  active: false,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "ordStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "prodName",
	    title: "Product Name",
	    active: true,
	    canToggle: false
	  }, {
	    data: "description",
	    title: "Description",
	    active: false,
	    canToggle: true
	  }, {
	    data: "facility",
	    title: "Facility",
	    active: false,
	    canToggle: true
	  }, {
	    data: "available",
	    title: "Available",
	    active: false,
	    canToggle: true
	  }, {
	    data: "ordStatus",
	    title: "Order Status",
	    active: false,
	    canToggle: true
	  }, {
	    data: "allocated",
	    title: "Allocated",
	    active: false,
	    canToggle: true
	  }]
	}, {
	  title: "Saved Search 2",
	  target: "savedSearchTwo",
	  active: false,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "ordStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "prodName",
	    title: "Product Name",
	    active: true,
	    canToggle: false
	  }, {
	    data: "description",
	    title: "Description",
	    active: false,
	    canToggle: true
	  }, {
	    data: "facility",
	    title: "Facility",
	    active: true,
	    canToggle: true
	  }, {
	    data: "available",
	    title: "Available",
	    active: false,
	    canToggle: true
	  }, {
	    data: "ordStatus",
	    title: "Order Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "allocated",
	    title: "Allocated",
	    active: true,
	    canToggle: true
	  }]
	}, {
	  title: "Saved Search 3",
	  target: "savedSearchThree",
	  active: false,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "ordStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "prodName",
	    title: "Product Name",
	    active: true,
	    canToggle: false
	  }, {
	    data: "description",
	    title: "Description",
	    active: false,
	    canToggle: true
	  }, {
	    data: "facility",
	    title: "Facility",
	    active: true,
	    canToggle: true
	  }, {
	    data: "available",
	    title: "Available",
	    active: false,
	    canToggle: true
	  }, {
	    data: "ordStatus",
	    title: "Order Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "allocated",
	    title: "Allocated",
	    active: true,
	    canToggle: true
	  }]
	}, {
	  title: "Saved Search 4",
	  target: "savedSearchFour",
	  active: false,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "ordStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "prodName",
	    title: "Product Name",
	    active: true,
	    canToggle: false
	  }, {
	    data: "description",
	    title: "Description",
	    active: false,
	    canToggle: true
	  }, {
	    data: "facility",
	    title: "Facility",
	    active: true,
	    canToggle: true
	  }, {
	    data: "available",
	    title: "Available",
	    active: false,
	    canToggle: true
	  }, {
	    data: "ordStatus",
	    title: "Order Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "allocated",
	    title: "Allocated",
	    active: true,
	    canToggle: true
	  }]
	}, {
	  title: "Saved Search 5",
	  target: "savedSearchFive",
	  active: false,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "ordStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "prodName",
	    title: "Product Name",
	    active: true,
	    canToggle: false
	  }, {
	    data: "description",
	    title: "Description",
	    active: false,
	    canToggle: true
	  }, {
	    data: "facility",
	    title: "Facility",
	    active: true,
	    canToggle: true
	  }, {
	    data: "available",
	    title: "Available",
	    active: false,
	    canToggle: true
	  }, {
	    data: "ordStatus",
	    title: "Order Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "allocated",
	    title: "Allocated",
	    active: true,
	    canToggle: true
	  }]
	}, {
	  title: "Saved Search 6",
	  target: "savedSearchSix",
	  active: false,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "ordStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "prodName",
	    title: "Product Name",
	    active: true,
	    canToggle: false
	  }, {
	    data: "description",
	    title: "Description",
	    active: false,
	    canToggle: true
	  }, {
	    data: "facility",
	    title: "Facility",
	    active: true,
	    canToggle: true
	  }, {
	    data: "available",
	    title: "Available",
	    active: false,
	    canToggle: true
	  }, {
	    data: "ordStatus",
	    title: "Order Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "allocated",
	    title: "Allocated",
	    active: true,
	    canToggle: true
	  }]
	}, {
	  title: "Saved Search 7",
	  target: "savedSearchSeven",
	  active: false,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "ordStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "prodName",
	    title: "Product Name",
	    active: true,
	    canToggle: false
	  }, {
	    data: "description",
	    title: "Description",
	    active: false,
	    canToggle: true
	  }, {
	    data: "facility",
	    title: "Facility",
	    active: true,
	    canToggle: true
	  }, {
	    data: "available",
	    title: "Available",
	    active: false,
	    canToggle: true
	  }, {
	    data: "ordStatus",
	    title: "Order Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "allocated",
	    title: "Allocated",
	    active: true,
	    canToggle: true
	  }]
	}];
	
	var testNewSavedView = exports.testNewSavedView = {
	  title: "New Saved Search",
	  target: "savedViewUpdatedTarget",
	  active: true,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "ordStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "prodName",
	    title: "Product Name",
	    active: true,
	    canToggle: false
	  }, {
	    data: "description",
	    title: "Description",
	    active: false,
	    canToggle: true
	  }, {
	    data: "facility",
	    title: "Facility",
	    active: false,
	    canToggle: true
	  }, {
	    data: "available",
	    title: "Available",
	    active: false,
	    canToggle: true
	  }, {
	    data: "ordStatus",
	    title: "Order Status",
	    active: false,
	    canToggle: true
	  }, {
	    data: "allocated",
	    title: "Allocated",
	    active: false,
	    canToggle: true
	  }]
	};

/***/ },
/* 469 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var testColumns = exports.testColumns = [{
	  data: "ordStatus",
	  title: "Actions",
	  active: true,
	  canToggle: false
	}, {
	  data: "prodName",
	  title: "Product Name",
	  active: true,
	  canToggle: false
	}, {
	  data: "description",
	  title: "Description",
	  active: true,
	  canToggle: true
	}, {
	  data: "facility",
	  title: "Facility",
	  active: true,
	  canToggle: true
	}, {
	  data: "available",
	  title: "Available",
	  active: true,
	  canToggle: true
	}, {
	  data: "ordStatus",
	  title: "Order Status",
	  active: true,
	  canToggle: true
	}, {
	  data: "allocated",
	  title: "Allocated",
	  active: true,
	  canToggle: true
	}];

/***/ },
/* 470 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataTableFilterData = exports.dataTableFilterData = [{
	  "filterGroup": "Inventory Status",
	  "filterGroupType": "checkbox",
	  "filterGroupName": "status",
	  "filterGroupInputs": [{
	    "filterTitle": "In Stock",
	    "filterValue": "inStock",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterTitle": "Low Stock",
	    "filterValue": "lowStock",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterTitle": "Out of Stock",
	    "filterValue": "outOfStock",
	    "filterOperator": "equal",
	    "active": false
	  }]
	}, {
	  "filterGroup": "Date Range",
	  "filterGroupType": "radio",
	  "filterGroupName": "fixedRange",
	  "filterGroupInputs": [{
	    "filterName": "fixedRange",
	    "filterTitle": "Today",
	    "filterValue": "today",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterName": "fixedRange",
	    "filterTitle": "Yesterday",
	    "filterValue": "yesterday",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterName": "fixedRange",
	    "filterTitle": "Last 7 Days",
	    "filterValue": "lastSevenDays",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterName": "fixedRange",
	    "filterTitle": "Last 60 Days (Default)",
	    "filterValue": "lastSixtyDays",
	    "filterOperator": "equal",
	    "active": true
	  }, {
	    "filterName": "fixedRange",
	    "filterTitle": "Custom Date Range",
	    "filterValue": "customRange",
	    "filterOperator": "equal",
	    "active": false,
	    "childFilters": [{
	      "filterGroup": "Date Range",
	      "filterGroupType": "dateRange",
	      "filterGroupName": "dateRange",
	      "dateRangeNameStart": "startDate",
	      "dateRangeNameEnd": "endDate"
	    }]
	  }]
	}];

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = resourceProgress;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _objectAssign = __webpack_require__(107);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1071);
	
	var mainTemplate = __webpack_require__(1183);
	var cardTemplate = __webpack_require__(1182);
	
	//el refers to outer most container
	function resourceProgress(el, options) {
	  el = (0, _jquery2.default)(el);
	
	  if (el.length) {
	    var resourceProgressObject = el.data("resource-progress");
	    if (resourceProgressObject) {
	      resourceProgressObject.setOptions(options);
	    } else {
	      resourceProgressObject = resourceProgressFactory(el, options);
	      resourceProgressObject.init();
	      el.data("resource-progress", resourceProgressObject);
	    }
	    return resourceProgressObject;
	  } else {
	    throw new Error({ name: "No Element Error", message: "Element must be a jquery element or dom element" });
	  }
	}
	
	var themesMap = {
	  info: {
	    backgroundColor: "q-bg-c-blue"
	  },
	  success: {
	    backgroundColor: "q-bg-c-lime-green"
	  },
	  darkGrey: {
	    backgroundColor: "q-bg-c-more-light-grey"
	  },
	  lightGrey: {
	    backgroundColor: "q-bg-c-lighter-grey"
	  },
	  pending: {
	    backgroundColor: "q-bg-c-red"
	  }
	};
	
	var elsMap = {
	  resourceTitle: ".resource-title",
	  resourceTimestamp: ".resource-timestamp",
	  resourceIcon: ".resource-icon",
	  resourceBgColor: ".resource-background-color"
	};
	
	var iconsMap = {
	  backArrow: {
	    iconClass: "fa-reply",
	    color: "white"
	  },
	  calendar: {
	    iconClass: "fa-calendar",
	    color: "white"
	  },
	  cancel: {
	    iconClass: "fa-close",
	    color: "white"
	  },
	  dollar: {
	    iconClass: "fa-usd",
	    color: "white"
	  },
	  print: {
	    iconClass: "fa-print",
	    color: "white"
	  },
	  truck: {
	    iconClass: "fa-truck",
	    color: "white"
	  },
	  hazardTriangle: {
	    iconClass: "fa-exclamation-triangle",
	    color: "white"
	  }
	};
	
	function resourceProgressFactory(el, options) {
	  var self = {};
	  var statuses = options.data.statuses;
	  var lifecycleFinished = options.data.endOfLifecycle;
	  var htmlWrapper = el;
	  var outerMostEl = (0, _jquery2.default)(mainTemplate);
	  var outerEl = (0, _jquery2.default)(outerMostEl).find('.resource-progress-container');
	  var mainEl = outerEl.find(".resource-progress-inner");
	
	  // NOTE: optional function to let user change card options during runtime if needed
	  // self.setCardDataById = function(id, statusUpdate){
	  //   const originalStatus = _(statuses).find((item)=>{
	  //     return item.id == id;
	  //   })
	  //   const finalStatus = _.merge(originalStatus, statusUpdate)
	  //   const newCard = buildCard(finalStatus)
	  //   const oldCard = mainEl.find(`#${originalStatus.id}`)
	  //   newCard.after(oldCard);
	  //   oldCard.remove();
	  // }
	
	  //========================PRIVATE FUNCTIONS======================
	  /*data will need following vars: title, timestamp, way to indicate that it's
	   last in array?, some sort of status constant that will never change,
	   which will determine icon and icon color (if cancelled)*/
	
	  function appendOuterEl() {
	    htmlWrapper.append(outerMostEl);
	
	    appendCardEls();
	  }
	
	  function appendCardEls() {
	    var cardElArray = (0, _underscore2.default)(statuses).map(buildCard);
	
	    mainEl.append(cardElArray);
	
	    scrollContainerToRight();
	
	    (0, _underscore2.default)(mainEl.find(elsMap.resourceTitle).toArray()).map(truncateLongTitles);
	  }
	
	  function scrollContainerToRight() {
	    var mainElWidth = mainEl.width();
	    outerEl.scrollLeft(mainElWidth);
	  };
	
	  function buildCard(dataObj) {
	    var cardEl = (0, _jquery2.default)(cardTemplate);
	
	    // NOTE: optional prop to let user change card options during runtime if needed
	    // cardEl.prop('id', dataObj.id);
	
	    var icon = cardEl.find(elsMap.resourceIcon);
	    var iconBackground = cardEl.find(elsMap.resourceBgColor);
	    var title = cardEl.find(elsMap.resourceTitle);
	    var timeStamp = cardEl.find(elsMap.resourceTimestamp);
	    // FOR EXAMPLE: dataObj.icon = "truck";
	    var _iconsMap$dataObj$ico = iconsMap[dataObj.icon],
	        iconClass = _iconsMap$dataObj$ico.iconClass,
	        color = _iconsMap$dataObj$ico.color;
	
	    // FOR EXAMPLE: iconsMap.truck, or iconsMap.dollar
	
	    icon.addClass(iconClass);
	    icon.css({ color: color });
	
	    title.text(dataObj.title);
	    timeStamp.text(dataObj.time);
	
	    var cardColor = getCardColor(dataObj);
	    iconBackground.addClass(cardColor.backgroundColor);
	
	    return cardEl;
	  }
	
	  function getCardColor(dataObj) {
	    var hasThemeKey = (0, _underscore2.default)(dataObj).has('theme');
	    if (hasThemeKey) {
	      return getCardColorFromTheme(dataObj);
	    } else {
	      return getCardColorForActiveStatus(dataObj);
	    }
	  }
	
	  function getCardColorFromTheme(dataObj) {
	    // if the theme parameter is empty, or if string doesn't match themesMap, this defaults to getting color based on active status
	    var cardColor = themesMap[dataObj.theme] || getCardColorForActiveStatus(dataObj);
	    return cardColor;
	  }
	
	  function getCardColorForActiveStatus(dataObj) {
	    if (dataObj.active === true) {
	      return {
	        backgroundColor: "q-bg-c-purple"
	      };
	    } else {
	      return {
	        backgroundColor: "q-bg-c-lighter-grey"
	      };
	    }
	  };
	
	  function truncateLongTitles(title) {
	    (0, _jquery2.default)(title).dotdotdot({
	      wrap: "letter"
	    });
	  };
	
	  //===================PUBLIC FUNCTIONS===================
	  //options users can configure = for future development if needed
	  self.setOptions = function (options) {
	    //code code set configurable options here
	  };
	
	  self.init = function () {
	    appendOuterEl();
	  };
	
	  return self;
	}

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Scheduler;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// IMPORTS GO HERE
	__webpack_require__(1072);
	
	var baseTemplateHtml = __webpack_require__(1184);
	var dateContainerHtml = __webpack_require__(1186);
	var availTimeContainerHtml = __webpack_require__(1185);
	var timeBlockTemplateHtml = __webpack_require__(1187);
	
	// rename to match what this component is...
	function Scheduler() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  // functional code for component here
	  var self = this;
	
	  var targetEl = (0, _jquery2.default)(options.target);
	  var data = options.data || [];
	  var selectedTime = void 0,
	      selectedDayIndex = void 0,
	      timeStamp = void 0,
	      selectedTimeIndex = void 0,
	      selectionToSend = void 0;
	
	  var daysArr = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	  var monthArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
	
	  self.init = function () {
	    buildHtml();
	    bindElements();
	    setInitialState();
	  };
	
	  self.getSelection = function () {
	    return selectionToSend = [{
	      "date": data[selectedDayIndex].date,
	      "availTime": selectedTime
	    }];
	  };
	
	  function buildHtml() {
	    var schedulerHtml = (0, _render2.default)(baseTemplateHtml, {
	      availDates: renderAvailDate(),
	      availTimes: renderAvailTimeBlocks()
	    });
	
	    targetEl.html(schedulerHtml);
	  }
	
	  function renderAvailDate() {
	    var availDatesHtml = data.map(function (day) {
	      var dateToRender = new Date(day.date);
	      var dateTextToShow = daysArr[dateToRender.getDay()] + ', ' + monthArr[dateToRender.getMonth()] + ' ' + dateToRender.getDate() + nthDay(dateToRender.getDate());
	      return (0, _render2.default)(dateContainerHtml, {
	        date: dateTextToShow
	      });
	    });
	    return availDatesHtml.join('');
	  }
	
	  function renderAvailTimeBlocks() {
	    var availTimeBlockHtml = data.map(function (day, index) {
	      var availTimesArr = day.availTime || [];
	      return (0, _render2.default)(availTimeContainerHtml, {
	        timeBlock: renderTimeBlock(availTimesArr),
	        index: index
	      });
	    });
	    return availTimeBlockHtml.join("");
	  }
	
	  function renderTimeBlock(arr) {
	    var timeBlockHtml = void 0;
	
	    if (arr.length > 0) {
	      timeBlockHtml = arr.map(function (arrEl, index) {
	        timeStamp = (0, _moment2.default)(arrEl.startTime, 'HH:mm').format('h:mm A');
	        return (0, _render2.default)(timeBlockTemplateHtml, {
	          timeStamp: timeStamp,
	          index: index
	        });
	      });
	      return timeBlockHtml.join('');
	    } else {
	      return timeBlockHtml = '<div class="no-avail q-boldest">No Availability</div>';
	    }
	  }
	
	  function nthDay(d) {
	    if (d > 3 && d < 21) return 'th';
	    switch (d % 10) {
	      case 1:
	        return "st";
	      case 2:
	        return "nd";
	      case 3:
	        return "rd";
	      default:
	        return "th";
	    }
	  }
	
	  function bindElements() {
	    targetEl.on('click', '.time-block-div', onTimeBlockCheck);
	  }
	
	  function onTimeBlockCheck() {
	    selectedDayIndex = (0, _jquery2.default)(this).closest('td').data('day-index');
	    selectedTimeIndex = (0, _jquery2.default)(this).data('time-slot-index');
	    selectedTime = data[selectedDayIndex].availTime[selectedTimeIndex];
	  }
	
	  var activeIndex = options.activeIndex;
	
	  function setInitialState() {
	    (0, _jquery2.default)('.no-avail').closest('td').addClass('no-avail-cell');
	    (0, _jquery2.default)('table thead th:eq(' + activeIndex + ')').addClass('active');
	  }
	};

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                               * Bootstrap v3.3.4 (http://getbootstrap.com)
	                                                                                                                                                                                                                                                                               * Copyright 2011-2015 Twitter, Inc.
	                                                                                                                                                                                                                                                                               * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                               */
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (typeof _jquery2.default === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery');
	}
	
	+function ($) {
	  'use strict';
	
	  var version = $.fn.jquery.split(' ')[0].split('.');
	  if (version[0] < 2 && version[1] < 9 || version[0] == 1 && version[1] == 9 && version[2] < 1) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher');
	  }
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.3.4
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap');
	
	    var transEndEventNames = {
	      WebkitTransition: 'webkitTransitionEnd',
	      MozTransition: 'transitionend',
	      OTransition: 'oTransitionEnd otransitionend',
	      transition: 'transitionend'
	    };
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] };
	      }
	    }
	
	    return false; // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false;
	    var $el = this;
	    $(this).one('bsTransitionEnd', function () {
	      called = true;
	    });
	    var callback = function callback() {
	      if (!called) $($el).trigger($.support.transition.end);
	    };
	    setTimeout(callback, duration);
	    return this;
	  };
	
	  $(function () {
	    $.support.transition = transitionEnd();
	
	    if (!$.support.transition) return;
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function handle(e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
	      }
	    };
	  });
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.3.4
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]';
	  var Alert = function Alert(el) {
	    $(el).on('click', dismiss, this.close);
	  };
	
	  Alert.VERSION = '3.3.4';
	
	  Alert.TRANSITION_DURATION = 150;
	
	  Alert.prototype.close = function (e) {
	    var $this = $(this);
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	    }
	
	    var $parent = $(selector);
	
	    if (e) e.preventDefault();
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert');
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'));
	
	    if (e.isDefaultPrevented()) return;
	
	    $parent.removeClass('in');
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove();
	    }
	
	    $.support.transition && $parent.hasClass('fade') ? $parent.one('bsTransitionEnd', removeElement).emulateTransitionEnd(Alert.TRANSITION_DURATION) : removeElement();
	  };
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.alert');
	
	      if (!data) $this.data('bs.alert', data = new Alert(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.alert;
	
	  $.fn.alert = Plugin;
	  $.fn.alert.Constructor = Alert;
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old;
	    return this;
	  };
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close);
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.3.4
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function Button(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Button.DEFAULTS, options);
	    this.isLoading = false;
	  };
	
	  Button.VERSION = '3.3.4';
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  };
	
	  Button.prototype.setState = function (state) {
	    var d = 'disabled';
	    var $el = this.$element;
	    var val = $el.is('input') ? 'val' : 'html';
	    var data = $el.data();
	
	    state = state + 'Text';
	
	    if (data.resetText == null) $el.data('resetText', $el[val]());
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state]);
	
	      if (state == 'loadingText') {
	        this.isLoading = true;
	        $el.addClass(d).attr(d, d);
	      } else if (this.isLoading) {
	        this.isLoading = false;
	        $el.removeClass(d).removeAttr(d);
	      }
	    }, this), 0);
	  };
	
	  Button.prototype.toggle = function () {
	    var changed = true;
	    var $parent = this.$element.closest('[data-toggle="buttons"]');
	
	    if ($parent.length) {
	      var $input = this.$element.find('input');
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked') && this.$element.hasClass('active')) changed = false;else $parent.find('.active').removeClass('active');
	      }
	      if (changed) $input.prop('checked', !this.$element.hasClass('active')).trigger('change');
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'));
	    }
	
	    if (changed) this.$element.toggleClass('active');
	  };
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.button');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.button', data = new Button(this, options));
	
	      if (option == 'toggle') data.toggle();else if (option) data.setState(option);
	    });
	  }
	
	  var old = $.fn.button;
	
	  $.fn.button = Plugin;
	  $.fn.button.Constructor = Button;
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old;
	    return this;
	  };
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document).on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    var $btn = $(e.target);
	    if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn');
	    Plugin.call($btn, 'toggle');
	    e.preventDefault();
	  }).on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	    $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type));
	  });
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.4
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function Carousel(element, options) {
	    this.$element = $(element);
	    this.$indicators = this.$element.find('.carousel-indicators');
	    this.options = options;
	    this.paused = null;
	    this.sliding = null;
	    this.interval = null;
	    this.$active = null;
	    this.$items = null;
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this));
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element.on('mouseenter.bs.carousel', $.proxy(this.pause, this)).on('mouseleave.bs.carousel', $.proxy(this.cycle, this));
	  };
	
	  Carousel.VERSION = '3.3.4';
	
	  Carousel.TRANSITION_DURATION = 600;
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  };
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return;
	    switch (e.which) {
	      case 37:
	        this.prev();break;
	      case 39:
	        this.next();break;
	      default:
	        return;
	    }
	
	    e.preventDefault();
	  };
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false);
	
	    this.interval && clearInterval(this.interval);
	
	    this.options.interval && !this.paused && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));
	
	    return this;
	  };
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item');
	    return this.$items.index(item || this.$active);
	  };
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active);
	    var willWrap = direction == 'prev' && activeIndex === 0 || direction == 'next' && activeIndex == this.$items.length - 1;
	    if (willWrap && !this.options.wrap) return active;
	    var delta = direction == 'prev' ? -1 : 1;
	    var itemIndex = (activeIndex + delta) % this.$items.length;
	    return this.$items.eq(itemIndex);
	  };
	
	  Carousel.prototype.to = function (pos) {
	    var that = this;
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'));
	
	    if (pos > this.$items.length - 1 || pos < 0) return;
	
	    if (this.sliding) return this.$element.one('slid.bs.carousel', function () {
	      that.to(pos);
	    }); // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle();
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos));
	  };
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true);
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end);
	      this.cycle(true);
	    }
	
	    this.interval = clearInterval(this.interval);
	
	    return this;
	  };
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return;
	    return this.slide('next');
	  };
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return;
	    return this.slide('prev');
	  };
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active = this.$element.find('.item.active');
	    var $next = next || this.getItemForDirection(type, $active);
	    var isCycling = this.interval;
	    var direction = type == 'next' ? 'left' : 'right';
	    var that = this;
	
	    if ($next.hasClass('active')) return this.sliding = false;
	
	    var relatedTarget = $next[0];
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    });
	    this.$element.trigger(slideEvent);
	    if (slideEvent.isDefaultPrevented()) return;
	
	    this.sliding = true;
	
	    isCycling && this.pause();
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active');
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)]);
	      $nextIndicator && $nextIndicator.addClass('active');
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }); // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type);
	      $next[0].offsetWidth; // force reflow
	      $active.addClass(direction);
	      $next.addClass(direction);
	      $active.one('bsTransitionEnd', function () {
	        $next.removeClass([type, direction].join(' ')).addClass('active');
	        $active.removeClass(['active', direction].join(' '));
	        that.sliding = false;
	        setTimeout(function () {
	          that.$element.trigger(slidEvent);
	        }, 0);
	      }).emulateTransitionEnd(Carousel.TRANSITION_DURATION);
	    } else {
	      $active.removeClass('active');
	      $next.addClass('active');
	      this.sliding = false;
	      this.$element.trigger(slidEvent);
	    }
	
	    isCycling && this.cycle();
	
	    return this;
	  };
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.carousel');
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
	      var action = typeof option == 'string' ? option : options.slide;
	
	      if (!data) $this.data('bs.carousel', data = new Carousel(this, options));
	      if (typeof option == 'number') data.to(option);else if (action) data[action]();else if (options.interval) data.pause().cycle();
	    });
	  }
	
	  var old = $.fn.carousel;
	
	  $.fn.carousel = Plugin;
	  $.fn.carousel.Constructor = Carousel;
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old;
	    return this;
	  };
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function clickHandler(e) {
	    var href;
	    var $this = $(this);
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')); // strip for ie7
	    if (!$target.hasClass('carousel')) return;
	    var options = $.extend({}, $target.data(), $this.data());
	    var slideIndex = $this.attr('data-slide-to');
	    if (slideIndex) options.interval = false;
	
	    Plugin.call($target, options);
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex);
	    }
	
	    e.preventDefault();
	  };
	
	  $(document).on('click.bs.carousel.data-api', '[data-slide]', clickHandler).on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler);
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this);
	      Plugin.call($carousel, $carousel.data());
	    });
	  });
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.4
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function Collapse(element, options) {
	    this.$element = $(element);
	    this.options = $.extend({}, Collapse.DEFAULTS, options);
	    this.$trigger = $('[data-toggle="collapse"][href="#' + element.id + '"],' + '[data-toggle="collapse"][data-target="#' + element.id + '"]');
	    this.transitioning = null;
	
	    if (this.options.parent) {
	      this.$parent = this.getParent();
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger);
	    }
	
	    if (this.options.toggle) this.toggle();
	  };
	
	  Collapse.VERSION = '3.3.4';
	
	  Collapse.TRANSITION_DURATION = 350;
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  };
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width');
	    return hasWidth ? 'width' : 'height';
	  };
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return;
	
	    var activesData;
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing');
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse');
	      if (activesData && activesData.transitioning) return;
	    }
	
	    var startEvent = $.Event('show.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide');
	      activesData || actives.data('bs.collapse', null);
	    }
	
	    var dimension = this.dimension();
	
	    this.$element.removeClass('collapse').addClass('collapsing')[dimension](0).attr('aria-expanded', true);
	
	    this.$trigger.removeClass('collapsed').attr('aria-expanded', true);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.$element.removeClass('collapsing').addClass('collapse in')[dimension]('');
	      this.transitioning = 0;
	      this.$element.trigger('shown.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'));
	
	    this.$element.one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize]);
	  };
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return;
	
	    var startEvent = $.Event('hide.bs.collapse');
	    this.$element.trigger(startEvent);
	    if (startEvent.isDefaultPrevented()) return;
	
	    var dimension = this.dimension();
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight;
	
	    this.$element.addClass('collapsing').removeClass('collapse in').attr('aria-expanded', false);
	
	    this.$trigger.addClass('collapsed').attr('aria-expanded', false);
	
	    this.transitioning = 1;
	
	    var complete = function complete() {
	      this.transitioning = 0;
	      this.$element.removeClass('collapsing').addClass('collapse').trigger('hidden.bs.collapse');
	    };
	
	    if (!$.support.transition) return complete.call(this);
	
	    this.$element[dimension](0).one('bsTransitionEnd', $.proxy(complete, this)).emulateTransitionEnd(Collapse.TRANSITION_DURATION);
	  };
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']();
	  };
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each($.proxy(function (i, element) {
	      var $element = $(element);
	      this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element);
	    }, this)).end();
	  };
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in');
	
	    $element.attr('aria-expanded', isOpen);
	    $trigger.toggleClass('collapsed', !isOpen).attr('aria-expanded', isOpen);
	  };
	
	  function getTargetFromTrigger($trigger) {
	    var href;
	    var target = $trigger.attr('data-target') || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, ''); // strip for ie7
	
	    return $(target);
	  }
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.collapse');
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false;
	      if (!data) $this.data('bs.collapse', data = new Collapse(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.collapse;
	
	  $.fn.collapse = Plugin;
	  $.fn.collapse.Constructor = Collapse;
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old;
	    return this;
	  };
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this = $(this);
	
	    if (!$this.attr('data-target')) e.preventDefault();
	
	    var $target = getTargetFromTrigger($this);
	    var data = $target.data('bs.collapse');
	    var option = data ? 'toggle' : $this.data();
	
	    Plugin.call($target, option);
	  });
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.4
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop';
	  var toggle = '[data-toggle="dropdown"]';
	  var Dropdown = function Dropdown(element) {
	    $(element).on('click.bs.dropdown', this.toggle);
	  };
	
	  Dropdown.VERSION = '3.3.4';
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this);
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    clearMenus();
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $('<div class="dropdown-backdrop"/>').insertAfter($(this)).on('click', clearMenus);
	      }
	
	      var relatedTarget = { relatedTarget: this };
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.trigger('focus').attr('aria-expanded', 'true');
	
	      $parent.toggleClass('open').trigger('shown.bs.dropdown', relatedTarget);
	    }
	
	    return false;
	  };
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;
	
	    var $this = $(this);
	
	    e.preventDefault();
	    e.stopPropagation();
	
	    if ($this.is('.disabled, :disabled')) return;
	
	    var $parent = getParent($this);
	    var isActive = $parent.hasClass('open');
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus');
	      return $this.trigger('click');
	    }
	
	    var desc = ' li:not(.disabled):visible a';
	    var $items = $parent.find('[role="menu"]' + desc + ', [role="listbox"]' + desc);
	
	    if (!$items.length) return;
	
	    var index = $items.index(e.target);
	
	    if (e.which == 38 && index > 0) index--; // up
	    if (e.which == 40 && index < $items.length - 1) index++; // down
	    if (!~index) index = 0;
	
	    $items.eq(index).trigger('focus');
	  };
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return;
	    $(backdrop).remove();
	    $(toggle).each(function () {
	      var $this = $(this);
	      var $parent = getParent($this);
	      var relatedTarget = { relatedTarget: this };
	
	      if (!$parent.hasClass('open')) return;
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget));
	
	      if (e.isDefaultPrevented()) return;
	
	      $this.attr('aria-expanded', 'false');
	      $parent.removeClass('open').trigger('hidden.bs.dropdown', relatedTarget);
	    });
	  }
	
	  function getParent($this) {
	    var selector = $this.attr('data-target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	    }
	
	    var $parent = selector && $(selector);
	
	    return $parent && $parent.length ? $parent : $this.parent();
	  }
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.dropdown');
	
	      if (!data) $this.data('bs.dropdown', data = new Dropdown(this));
	      if (typeof option == 'string') data[option].call($this);
	    });
	  }
	
	  var old = $.fn.dropdown;
	
	  $.fn.dropdown = Plugin;
	  $.fn.dropdown.Constructor = Dropdown;
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old;
	    return this;
	  };
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	  // CUSTOM PREVENT HTML INSTANTIATION
	  // $(document)
	  // .on('click.bs.dropdown.data-api', clearMenus)
	  // .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	  // .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	  // .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	  // .on('keydown.bs.dropdown.data-api', '[role="menu"]', Dropdown.prototype.keydown)
	  // .on('keydown.bs.dropdown.data-api', '[role="listbox"]', Dropdown.prototype.keydown)
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.3.4
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function Modal(element, options) {
	    this.options = options;
	    this.$body = $(document.body);
	    this.$element = $(element);
	    this.$dialog = this.$element.find('.modal-dialog');
	    this.$backdrop = null;
	    this.isShown = null;
	    this.originalBodyPad = null;
	    this.scrollbarWidth = 0;
	    this.ignoreBackdropClick = false;
	
	    if (this.options.remote) {
	      this.$element.find('.modal-content').load(this.options.remote, $.proxy(function () {
	        this.$element.trigger('loaded.bs.modal');
	      }, this));
	    }
	  };
	
	  Modal.VERSION = '3.3.4';
	
	  Modal.TRANSITION_DURATION = 300;
	  Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  };
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget);
	  };
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this;
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });
	
	    this.$element.trigger(e);
	
	    if (this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = true;
	
	    this.checkScrollbar();
	    this.setScrollbar();
	    this.$body.addClass('modal-open');
	
	    this.escape();
	    this.resize();
	
	    // NOTE: we are commenting this out
	    // to avoid race conditions with theme
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true;
	      });
	    });
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade');
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body); // don't move modals dom position
	      }
	
	      that.$element.show().scrollTop(0);
	
	      that.adjustDialog();
	
	      if (transition) {
	        that.$element[0].offsetWidth; // force reflow
	      }
	
	      that.$element.addClass('in').attr('aria-hidden', false);
	
	      that.enforceFocus();
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget });
	
	      transition ? that.$dialog // wait for modal to slide in
	      .one('bsTransitionEnd', function () {
	        that.$element.trigger('focus').trigger(e);
	      }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger('focus').trigger(e);
	    });
	  };
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault();
	
	    e = $.Event('hide.bs.modal');
	
	    this.$element.trigger(e);
	
	    if (!this.isShown || e.isDefaultPrevented()) return;
	
	    this.isShown = false;
	
	    this.escape();
	    this.resize();
	
	    $(document).off('focusin.bs.modal');
	
	    this.$element.removeClass('in').attr('aria-hidden', true).off('click.dismiss.bs.modal').off('mouseup.dismiss.bs.modal');
	
	    this.$dialog.off('mousedown.dismiss.bs.modal');
	
	    $.support.transition && this.$element.hasClass('fade') ? this.$element.one('bsTransitionEnd', $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
	  };
	
	  Modal.prototype.enforceFocus = function () {
	    $(document).off('focusin.bs.modal') // guard against infinite focus loop
	    .on('focusin.bs.modal', $.proxy(function (e) {
	      if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
	        this.$element.trigger('focus');
	      }
	    }, this));
	  };
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide();
	      }, this));
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal');
	    }
	  };
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this));
	    } else {
	      $(window).off('resize.bs.modal');
	    }
	  };
	
	  Modal.prototype.hideModal = function () {
	    var that = this;
	    this.$element.hide();
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open');
	      that.resetAdjustments();
	      that.resetScrollbar();
	      that.$element.trigger('hidden.bs.modal');
	    });
	  };
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove();
	    this.$backdrop = null;
	  };
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this;
	    var animate = this.$element.hasClass('fade') ? 'fade' : '';
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate;
	
	      this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />').appendTo(this.$body);
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false;
	          return;
	        }
	        if (e.target !== e.currentTarget) return;
	        this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide();
	      }, this));
	
	      if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow
	
	      this.$backdrop.addClass('in');
	
	      if (!callback) return;
	
	      doAnimate ? this.$backdrop.one('bsTransitionEnd', callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in');
	
	      var callbackRemove = function callbackRemove() {
	        that.removeBackdrop();
	        callback && callback();
	      };
	      $.support.transition && this.$element.hasClass('fade') ? this.$backdrop.one('bsTransitionEnd', callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
	    } else if (callback) {
	      callback();
	    }
	  };
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog();
	  };
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    });
	  };
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    });
	  };
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth;
	    if (!fullWindowWidth) {
	      // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect();
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
	    this.scrollbarWidth = this.measureScrollbar();
	  };
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);
	    this.originalBodyPad = document.body.style.paddingRight || '';
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
	  };
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad);
	  };
	
	  Modal.prototype.measureScrollbar = function () {
	    // thx walsh
	    var scrollDiv = document.createElement('div');
	    scrollDiv.className = 'modal-scrollbar-measure';
	    this.$body.append(scrollDiv);
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	    this.$body[0].removeChild(scrollDiv);
	    return scrollbarWidth;
	  };
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.modal');
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
	
	      if (!data) $this.data('bs.modal', data = new Modal(this, options));
	      if (typeof option == 'string') data[option](_relatedTarget);else if (options.show) data.show(_relatedTarget);
	    });
	  }
	
	  var old = $.fn.modal;
	
	  $.fn.modal = Plugin;
	  $.fn.modal.Constructor = Modal;
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old;
	    return this;
	  };
	
	  // MODAL DATA-API
	  // ==============
	  // NOTE: we are commenting out this functionality to
	  // avoid html listener conflicts with other version of Bootstrap
	  // $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	  //   var $this   = $(this)
	  //   var href    = $this.attr('href')
	  //   var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	  //   var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	  //   if ($this.is('a')) e.preventDefault()
	
	  //   $target.one('show.bs.modal', function (showEvent) {
	  //     if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	  //     $target.one('hidden.bs.modal', function () {
	  //       $this.is(':visible') && $this.trigger('focus')
	  //     })
	  //   })
	  //   Plugin.call($target, option, this)
	  // })
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.4
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function Tooltip(element, options) {
	    this.type = null;
	    this.options = null;
	    this.enabled = null;
	    this.timeout = null;
	    this.hoverState = null;
	    this.$element = null;
	
	    this.init('tooltip', element, options);
	  };
	
	  Tooltip.VERSION = '3.3.4';
	
	  Tooltip.TRANSITION_DURATION = 150;
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  };
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled = true;
	    this.type = type;
	    this.$element = $(element);
	    this.options = this.getOptions(options);
	    this.$viewport = this.options.viewport && $(this.options.viewport.selector || this.options.viewport);
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
	    }
	
	    var triggers = this.options.trigger.split(' ');
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i];
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
	      } else if (trigger != 'manual') {
	        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';
	
	        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
	      }
	    }
	
	    this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
	  };
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS;
	  };
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options);
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      };
	    }
	
	    return options;
	  };
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options = {};
	    var defaults = this.getDefaults();
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value;
	    });
	
	    return options;
	  };
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (self && self.$tip && self.$tip.is(':visible')) {
	      self.hoverState = 'in';
	      return;
	    }
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'in';
	
	    if (!self.options.delay || !self.options.delay.show) return self.show();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show();
	    }, self.options.delay.show);
	  };
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
	      $(obj.currentTarget).data('bs.' + this.type, self);
	    }
	
	    clearTimeout(self.timeout);
	
	    self.hoverState = 'out';
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide();
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide();
	    }, self.options.delay.hide);
	  };
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type);
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e);
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
	      if (e.isDefaultPrevented() || !inDom) return;
	      var that = this;
	
	      var $tip = this.tip();
	
	      var tipId = this.getUID(this.type);
	
	      this.setContent();
	      $tip.attr('id', tipId);
	      this.$element.attr('aria-describedby', tipId);
	
	      if (this.options.animation) $tip.addClass('fade');
	
	      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;
	
	      var autoToken = /\s?auto?\s?/i;
	      var autoPlace = autoToken.test(placement);
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';
	
	      $tip.detach().css({ top: 0, left: 0, display: 'block' }).addClass(placement).data('bs.' + this.type, this);
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
	
	      var pos = this.getPosition();
	      var actualWidth = $tip[0].offsetWidth;
	      var actualHeight = $tip[0].offsetHeight;
	
	      if (autoPlace) {
	        var orgPlacement = placement;
	        var $container = this.options.container ? $(this.options.container) : this.$element.parent();
	        var containerDim = this.getPosition($container);
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > containerDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < containerDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > containerDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < containerDim.left ? 'right' : placement;
	
	        $tip.removeClass(orgPlacement).addClass(placement);
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);
	
	      this.applyPlacement(calculatedOffset, placement);
	
	      var complete = function complete() {
	        var prevHoverState = that.hoverState;
	        that.$element.trigger('shown.bs.' + that.type);
	        that.hoverState = null;
	
	        if (prevHoverState == 'out') that.leave(that);
	      };
	
	      $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	    }
	  };
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip = this.tip();
	    var width = $tip[0].offsetWidth;
	    var height = $tip[0].offsetHeight;
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10);
	    var marginLeft = parseInt($tip.css('margin-left'), 10);
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop)) marginTop = 0;
	    if (isNaN(marginLeft)) marginLeft = 0;
	
	    offset.top = offset.top + marginTop;
	    offset.left = offset.left + marginLeft;
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function using(props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        });
	      }
	    }, offset), 0);
	
	    $tip.addClass('in');
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth = $tip[0].offsetWidth;
	    var actualHeight = $tip[0].offsetHeight;
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight;
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);
	
	    if (delta.left) offset.left += delta.left;else offset.top += delta.top;
	
	    var isVertical = /top|bottom/.test(placement);
	    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';
	
	    $tip.offset(offset);
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
	  };
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
	  };
	
	  Tooltip.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
	    $tip.removeClass('fade in top bottom left right');
	  };
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this;
	    var $tip = $(this.$tip);
	    var e = $.Event('hide.bs.' + this.type);
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach();
	      that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
	      callback && callback();
	    }
	
	    this.$element.trigger(e);
	
	    if (e.isDefaultPrevented()) return;
	
	    $tip.removeClass('in');
	
	    $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
	
	    this.hoverState = null;
	
	    return this;
	  };
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element;
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
	    }
	  };
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle();
	  };
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element = $element || this.$element;
	
	    var el = $element[0];
	    var isBody = el.tagName == 'BODY';
	
	    var elRect = el.getBoundingClientRect();
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
	    }
	    var elOffset = isBody ? { top: 0, left: 0 } : $element.offset();
	    var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() };
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset);
	  };
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'top' ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'left' ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	    /* placement == 'right' */{ top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
	  };
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 };
	    if (!this.$viewport) return delta;
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
	    var viewportDimensions = this.getPosition(this.$viewport);
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
	      if (topEdgeOffset < viewportDimensions.top) {
	        // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset;
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
	        // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
	      }
	    } else {
	      var leftEdgeOffset = pos.left - viewportPadding;
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
	      if (leftEdgeOffset < viewportDimensions.left) {
	        // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset;
	      } else if (rightEdgeOffset > viewportDimensions.width) {
	        // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
	      }
	    }
	
	    return delta;
	  };
	
	  Tooltip.prototype.getTitle = function () {
	    var title;
	    var $e = this.$element;
	    var o = this.options;
	
	    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);
	
	    return title;
	  };
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do {
	      prefix += ~~(Math.random() * 1000000);
	    } while (document.getElementById(prefix));
	    return prefix;
	  };
	
	  Tooltip.prototype.tip = function () {
	    return this.$tip = this.$tip || $(this.options.template);
	  };
	
	  Tooltip.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
	  };
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true;
	  };
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false;
	  };
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled;
	  };
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this;
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type);
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
	        $(e.currentTarget).data('bs.' + this.type, self);
	      }
	    }
	
	    self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
	  };
	
	  Tooltip.prototype.destroy = function () {
	    var that = this;
	    clearTimeout(this.timeout);
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type);
	    });
	  };
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tooltip');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tooltip;
	
	  $.fn.tooltip = Plugin;
	  $.fn.tooltip.Constructor = Tooltip;
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old;
	    return this;
	  };
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.3.4
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function Popover(element, options) {
	    this.init('popover', element, options);
	  };
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js');
	
	  Popover.VERSION = '3.3.4';
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  });
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);
	
	  Popover.prototype.constructor = Popover;
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS;
	  };
	
	  Popover.prototype.setContent = function () {
	    var $tip = this.tip();
	    var title = this.getTitle();
	    var content = this.getContent();
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);
	    $tip.find('.popover-content').children().detach().end()[// we use append for html objects to maintain js events
	    this.options.html ? typeof content == 'string' ? 'html' : 'append' : 'text'](content);
	
	    $tip.removeClass('fade top bottom left right in');
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide();
	  };
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent();
	  };
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element;
	    var o = this.options;
	
	    return $e.attr('data-content') || (typeof o.content == 'function' ? o.content.call($e[0]) : o.content);
	  };
	
	  Popover.prototype.arrow = function () {
	    return this.$arrow = this.$arrow || this.tip().find('.arrow');
	  };
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.popover');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data && /destroy|hide/.test(option)) return;
	      if (!data) $this.data('bs.popover', data = new Popover(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.popover;
	
	  $.fn.popover = Plugin;
	  $.fn.popover.Constructor = Popover;
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old;
	    return this;
	  };
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.4
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body = $(document.body);
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element);
	    this.options = $.extend({}, ScrollSpy.DEFAULTS, options);
	    this.selector = (this.options.target || '') + ' .nav li > a';
	    this.offsets = [];
	    this.targets = [];
	    this.activeTarget = null;
	    this.scrollHeight = 0;
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this));
	    this.refresh();
	    this.process();
	  }
	
	  ScrollSpy.VERSION = '3.3.4';
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  };
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight);
	  };
	
	  ScrollSpy.prototype.refresh = function () {
	    var that = this;
	    var offsetMethod = 'offset';
	    var offsetBase = 0;
	
	    this.offsets = [];
	    this.targets = [];
	    this.scrollHeight = this.getScrollHeight();
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position';
	      offsetBase = this.$scrollElement.scrollTop();
	    }
	
	    this.$body.find(this.selector).map(function () {
	      var $el = $(this);
	      var href = $el.data('target') || $el.attr('href');
	      var $href = /^#./.test(href) && $(href);
	
	      return $href && $href.length && $href.is(':visible') && [[$href[offsetMethod]().top + offsetBase, href]] || null;
	    }).sort(function (a, b) {
	      return a[0] - b[0];
	    }).each(function () {
	      that.offsets.push(this[0]);
	      that.targets.push(this[1]);
	    });
	  };
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop = this.$scrollElement.scrollTop() + this.options.offset;
	    var scrollHeight = this.getScrollHeight();
	    var maxScroll = this.options.offset + scrollHeight - this.$scrollElement.height();
	    var offsets = this.offsets;
	    var targets = this.targets;
	    var activeTarget = this.activeTarget;
	    var i;
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh();
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i);
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null;
	      return this.clear();
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i] && scrollTop >= offsets[i] && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1]) && this.activate(targets[i]);
	    }
	  };
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target;
	
	    this.clear();
	
	    var selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';
	
	    var active = $(selector).parents('li').addClass('active');
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active.closest('li.dropdown').addClass('active');
	    }
	
	    active.trigger('activate.bs.scrollspy');
	  };
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector).parentsUntil(this.options.target, '.active').removeClass('active');
	  };
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.scrollspy');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.scrollspy', data = new ScrollSpy(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.scrollspy;
	
	  $.fn.scrollspy = Plugin;
	  $.fn.scrollspy.Constructor = ScrollSpy;
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old;
	    return this;
	  };
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this);
	      Plugin.call($spy, $spy.data());
	    });
	  });
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.3.4
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function Tab(element) {
	    this.element = $(element);
	  };
	
	  Tab.VERSION = '3.3.4';
	
	  Tab.TRANSITION_DURATION = 150;
	
	  Tab.prototype.show = function () {
	    var $this = this.element;
	    var $ul = $this.closest('ul:not(.dropdown-menu)');
	    var selector = $this.data('target');
	
	    if (!selector) {
	      selector = $this.attr('href');
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return;
	
	    var $previous = $ul.find('.active:last a');
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    });
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    });
	
	    $previous.trigger(hideEvent);
	    $this.trigger(showEvent);
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
	
	    var $target = $(selector);
	
	    this.activate($this.closest('li'), $ul);
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      });
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      });
	    });
	  };
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active = container.find('> .active');
	    var transition = callback && $.support.transition && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length);
	
	    function next() {
	      $active.removeClass('active').find('> .dropdown-menu > .active').removeClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', false);
	
	      element.addClass('active').find('[data-toggle="tab"]').attr('aria-expanded', true);
	
	      if (transition) {
	        element[0].offsetWidth; // reflow for transition
	        element.addClass('in');
	      } else {
	        element.removeClass('fade');
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element.closest('li.dropdown').addClass('active').end().find('[data-toggle="tab"]').attr('aria-expanded', true);
	      }
	
	      callback && callback();
	    }
	
	    $active.length && transition ? $active.one('bsTransitionEnd', next).emulateTransitionEnd(Tab.TRANSITION_DURATION) : next();
	
	    $active.removeClass('in');
	  };
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.tab');
	
	      if (!data) $this.data('bs.tab', data = new Tab(this));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.tab;
	
	  $.fn.tab = Plugin;
	  $.fn.tab.Constructor = Tab;
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old;
	    return this;
	  };
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function clickHandler(e) {
	    e.preventDefault();
	    Plugin.call($(this), 'show');
	  };
	
	  $(document).on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler).on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler);
	}(_jquery2.default);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.3.4
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2015 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function Affix(element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options);
	
	    this.$target = $(this.options.target).on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this)).on('click.bs.affix.data-api', $.proxy(this.checkPositionWithEventLoop, this));
	
	    this.$element = $(element);
	    this.affixed = null;
	    this.unpin = null;
	    this.pinnedOffset = null;
	
	    this.checkPosition();
	  };
	
	  Affix.VERSION = '3.3.4';
	
	  Affix.RESET = 'affix affix-top affix-bottom';
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  };
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    var targetHeight = this.$target.height();
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false;
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return scrollTop + this.unpin <= position.top ? false : 'bottom';
	      return scrollTop + targetHeight <= scrollHeight - offsetBottom ? false : 'bottom';
	    }
	
	    var initializing = this.affixed == null;
	    var colliderTop = initializing ? scrollTop : position.top;
	    var colliderHeight = initializing ? targetHeight : height;
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top';
	    if (offsetBottom != null && colliderTop + colliderHeight >= scrollHeight - offsetBottom) return 'bottom';
	
	    return false;
	  };
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset;
	    this.$element.removeClass(Affix.RESET).addClass('affix');
	    var scrollTop = this.$target.scrollTop();
	    var position = this.$element.offset();
	    return this.pinnedOffset = position.top - scrollTop;
	  };
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1);
	  };
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return;
	
	    var height = this.$element.height();
	    var offset = this.options.offset;
	    var offsetTop = offset.top;
	    var offsetBottom = offset.bottom;
	    var scrollHeight = $(document.body).height();
	
	    if ((typeof offset === 'undefined' ? 'undefined' : _typeof(offset)) != 'object') offsetBottom = offsetTop = offset;
	    if (typeof offsetTop == 'function') offsetTop = offset.top(this.$element);
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element);
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom);
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '');
	
	      var affixType = 'affix' + (affix ? '-' + affix : '');
	      var e = $.Event(affixType + '.bs.affix');
	
	      this.$element.trigger(e);
	
	      if (e.isDefaultPrevented()) return;
	
	      this.affixed = affix;
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null;
	
	      this.$element.removeClass(Affix.RESET).addClass(affixType).trigger(affixType.replace('affix', 'affixed') + '.bs.affix');
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      });
	    }
	  };
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this);
	      var data = $this.data('bs.affix');
	      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
	
	      if (!data) $this.data('bs.affix', data = new Affix(this, options));
	      if (typeof option == 'string') data[option]();
	    });
	  }
	
	  var old = $.fn.affix;
	
	  $.fn.affix = Plugin;
	  $.fn.affix.Constructor = Affix;
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old;
	    return this;
	  };
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this);
	      var data = $spy.data();
	
	      data.offset = data.offset || {};
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom;
	      if (data.offsetTop != null) data.offset.top = data.offsetTop;
	
	      Plugin.call($spy, data);
	    });
	  });
	}(_jquery2.default);

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// NOTE: THIS FILE HAS BEEN CHANGED 
	// DUE TO POOR PUBLISHER JS PACKAGING SKILLS.
	// The author did not wrap his functionality
	// in using the correct pattern for exporting
	// a compatible package. So I'm doing it.
	
	
	(function (window, document, undefined) {
	
	    var factory = function factory($, DataTable) {
	        "use strict";
	        /* Set the defaults for DataTables initialisation */
	
	        $.extend(true, $.fn.dataTable.defaults, {
	            "sDom": "<'row'<'col-sm-6'l><'col-sm-6'f>r>" + "t" + "<'row'<'col-sm-6'i><'col-sm-6'p>>",
	            "oLanguage": {
	                "sLengthMenu": "_MENU_ records per page"
	            }
	        });
	
	        /* Default class modification */
	        $.extend($.fn.dataTableExt.oStdClasses, {
	            "sWrapper": "dataTables_wrapper form-inline",
	            "sFilterInput": "form-control input-sm",
	            "sLengthSelect": "form-control input-sm"
	        });
	
	        // In 1.10 we use the pagination renderers to draw the Bootstrap paging,
	        // rather than  custom plug-in
	        if ($.fn.dataTable.Api) {
	            $.fn.dataTable.defaults.renderer = 'bootstrap';
	            $.fn.dataTable.ext.renderer.pageButton.bootstrap = function (settings, host, idx, buttons, page, pages) {
	                var api = new $.fn.dataTable.Api(settings);
	                var classes = settings.oClasses;
	                var lang = settings.oLanguage.oPaginate;
	                var btnDisplay, btnClass;
	
	                var attach = function attach(container, buttons) {
	                    var i, ien, node, button;
	                    var clickHandler = function clickHandler(e) {
	                        e.preventDefault();
	                        if (e.data.action !== 'ellipsis') {
	                            api.page(e.data.action).draw(false);
	                        }
	                    };
	
	                    for (i = 0, ien = buttons.length; i < ien; i++) {
	                        button = buttons[i];
	
	                        if ($.isArray(button)) {
	                            attach(container, button);
	                        } else {
	                            btnDisplay = '';
	                            btnClass = '';
	
	                            switch (button) {
	                                case 'ellipsis':
	                                    btnDisplay = '&hellip;';
	                                    btnClass = 'disabled';
	                                    break;
	
	                                case 'first':
	                                    btnDisplay = lang.sFirst;
	                                    btnClass = button + (page > 0 ? '' : ' disabled');
	                                    break;
	
	                                case 'previous':
	                                    btnDisplay = lang.sPrevious;
	                                    btnClass = button + (page > 0 ? '' : ' disabled');
	                                    break;
	
	                                case 'next':
	                                    btnDisplay = lang.sNext;
	                                    btnClass = button + (page < pages - 1 ? '' : ' disabled');
	                                    break;
	
	                                case 'last':
	                                    btnDisplay = lang.sLast;
	                                    btnClass = button + (page < pages - 1 ? '' : ' disabled');
	                                    break;
	
	                                default:
	                                    btnDisplay = button + 1;
	                                    btnClass = page === button ? 'active' : '';
	                                    break;
	                            }
	
	                            if (btnDisplay) {
	                                node = $('<li>', {
	                                    'class': classes.sPageButton + ' ' + btnClass,
	                                    'aria-controls': settings.sTableId,
	                                    'tabindex': settings.iTabIndex,
	                                    'id': idx === 0 && typeof button === 'string' ? settings.sTableId + '_' + button : null
	                                }).append($('<a>', {
	                                    'href': '#'
	                                }).html(btnDisplay)).appendTo(container);
	
	                                settings.oApi._fnBindAction(node, {
	                                    action: button
	                                }, clickHandler);
	                            }
	                        }
	                    }
	                };
	
	                attach($(host).empty().html('<ul class="pagination"/>').children('ul'), buttons);
	            };
	        } else {
	            // Integration for 1.9-
	            $.fn.dataTable.defaults.sPaginationType = 'bootstrap';
	
	            /* API method to get paging information */
	            $.fn.dataTableExt.oApi.fnPagingInfo = function (oSettings) {
	                return {
	                    "iStart": oSettings._iDisplayStart,
	                    "iEnd": oSettings.fnDisplayEnd(),
	                    "iLength": oSettings._iDisplayLength,
	                    "iTotal": oSettings.fnRecordsTotal(),
	                    "iFilteredTotal": oSettings.fnRecordsDisplay(),
	                    "iPage": oSettings._iDisplayLength === -1 ? 0 : Math.ceil(oSettings._iDisplayStart / oSettings._iDisplayLength),
	                    "iTotalPages": oSettings._iDisplayLength === -1 ? 0 : Math.ceil(oSettings.fnRecordsDisplay() / oSettings._iDisplayLength)
	                };
	            };
	
	            /* Bootstrap style pagination control */
	            $.extend($.fn.dataTableExt.oPagination, {
	                "bootstrap": {
	                    "fnInit": function fnInit(oSettings, nPaging, fnDraw) {
	                        var oLang = oSettings.oLanguage.oPaginate;
	                        var fnClickHandler = function fnClickHandler(e) {
	                            e.preventDefault();
	                            if (oSettings.oApi._fnPageChange(oSettings, e.data.action)) {
	                                fnDraw(oSettings);
	                            }
	                        };
	
	                        $(nPaging).append('<ul class="pagination">' + '<li class="prev disabled"><a href="#">&larr; ' + oLang.sPrevious + '</a></li>' + '<li class="next disabled"><a href="#">' + oLang.sNext + ' &rarr; </a></li>' + '</ul>');
	                        var els = $('a', nPaging);
	                        $(els[0]).bind('click.DT', {
	                            action: "previous"
	                        }, fnClickHandler);
	                        $(els[1]).bind('click.DT', {
	                            action: "next"
	                        }, fnClickHandler);
	                    },
	
	                    "fnUpdate": function fnUpdate(oSettings, fnDraw) {
	                        var iListLength = 5;
	                        var oPaging = oSettings.oInstance.fnPagingInfo();
	                        var an = oSettings.aanFeatures.p;
	                        var i,
	                            ien,
	                            j,
	                            sClass,
	                            iStart,
	                            iEnd,
	                            iHalf = Math.floor(iListLength / 2);
	
	                        if (oPaging.iTotalPages < iListLength) {
	                            iStart = 1;
	                            iEnd = oPaging.iTotalPages;
	                        } else if (oPaging.iPage <= iHalf) {
	                            iStart = 1;
	                            iEnd = iListLength;
	                        } else if (oPaging.iPage >= oPaging.iTotalPages - iHalf) {
	                            iStart = oPaging.iTotalPages - iListLength + 1;
	                            iEnd = oPaging.iTotalPages;
	                        } else {
	                            iStart = oPaging.iPage - iHalf + 1;
	                            iEnd = iStart + iListLength - 1;
	                        }
	
	                        for (i = 0, ien = an.length; i < ien; i++) {
	                            // Remove the middle elements
	                            $('li:gt(0)', an[i]).filter(':not(:last)').remove();
	
	                            // Add the new list items and their event handlers
	                            for (j = iStart; j <= iEnd; j++) {
	                                sClass = j == oPaging.iPage + 1 ? 'class="active"' : '';
	                                $('<li ' + sClass + '><a href="#">' + j + '</a></li>').insertBefore($('li:last', an[i])[0]).bind('click', function (e) {
	                                    e.preventDefault();
	                                    oSettings._iDisplayStart = (parseInt($('a', this).text(), 10) - 1) * oPaging.iLength;
	                                    fnDraw(oSettings);
	                                });
	                            }
	
	                            // Add / remove disabled classes from the static elements
	                            if (oPaging.iPage === 0) {
	                                $('li:first', an[i]).addClass('disabled');
	                            } else {
	                                $('li:first', an[i]).removeClass('disabled');
	                            }
	
	                            if (oPaging.iPage === oPaging.iTotalPages - 1 || oPaging.iTotalPages === 0) {
	                                $('li:last', an[i]).addClass('disabled');
	                            } else {
	                                $('li:last', an[i]).removeClass('disabled');
	                            }
	                        }
	                    }
	                }
	            });
	        }
	
	        /*
	         * TableTools Bootstrap compatibility
	         * Required TableTools 2.1+
	         */
	        if ($.fn.DataTable.TableTools) {
	            // Set the classes that TableTools uses to something suitable for Bootstrap
	            $.extend(true, $.fn.DataTable.TableTools.classes, {
	                "container": "DTTT btn-group",
	                "buttons": {
	                    "normal": "btn btn-default",
	                    "disabled": "disabled"
	                },
	                "collection": {
	                    "container": "DTTT_dropdown dropdown-menu",
	                    "buttons": {
	                        "normal": "",
	                        "disabled": "disabled"
	                    }
	                },
	                "print": {
	                    "info": "DTTT_print_info modal"
	                },
	                "select": {
	                    "row": "active"
	                }
	            });
	
	            // Have the collection use a bootstrap compatible dropdown
	            $.extend(true, $.fn.DataTable.TableTools.DEFAULTS.oTags, {
	                "collection": {
	                    "container": "ul",
	                    "button": "li",
	                    "liner": "a"
	                }
	            });
	        }
	    }; // /factory
	
	
	    // Define as an AMD module if possible
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(108)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
	        // Node/CommonJS
	        factory(require('jquery'), require('datatables'));
	    } else if (jQuery && $jQuery.fn.dataTable.defaults.renderer !== "bootstrap") {
	        // Otherwise simply initialise as normal, stopping multiple evaluation
	        factory(jQuery, jQuery.fn.dataTable);
	    }
	})(window, document);

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! Responsive 1.0.2
	 * 2014 SpryMedia Ltd - datatables.net/license
	 */
	
	/**
	 * @summary     Responsive
	 * @description Responsive tables plug-in for DataTables
	 * @version     1.0.2
	 * @file        dataTables.responsive.js
	 * @author      SpryMedia Ltd (www.sprymedia.co.uk)
	 * @contact     www.sprymedia.co.uk/contact
	 * @copyright   Copyright 2014 SpryMedia Ltd.
	 *
	 * This source file is free software, available under the following license:
	 *   MIT license - http://datatables.net/license/mit
	 *
	 * This source file is distributed in the hope that it will be useful, but
	 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
	 * or FITNESS FOR A PARTICULAR PURPOSE. See the license files for details.
	 *
	 * For details please refer to: http://www.datatables.net
	 */
	
	(function (window, document, undefined) {
	
	    var factory = function factory($, DataTable) {
	        "use strict";
	
	        /**
	         * Responsive is a plug-in for the DataTables library that makes use of
	         * DataTables' ability to change the visibility of columns, changing the
	         * visibility of columns so the displayed columns fit into the table container.
	         * The end result is that complex tables will be dynamically adjusted to fit
	         * into the viewport, be it on a desktop, tablet or mobile browser.
	         *
	         * Responsive for DataTables has two modes of operation, which can used
	         * individually or combined:
	         *
	         * * Class name based control - columns assigned class names that match the
	         *   breakpoint logic can be shown / hidden as required for each breakpoint.
	         * * Automatic control - columns are automatically hidden when there is no
	         *   room left to display them. Columns removed from the right.
	         *
	         * In additional to column visibility control, Responsive also has built into
	         * options to use DataTables' child row display to show / hide the information
	         * from the table that has been hidden. There are also two modes of operation
	         * for this child row display:
	         *
	         * * Inline - when the control element that the user can use to show / hide
	         *   child rows is displayed inside the first column of the table.
	         * * Column - where a whole column is dedicated to be the show / hide control.
	         *
	         * Initialisation of Responsive is performed by:
	         *
	         * * Adding the class `responsive` or `dt-responsive` to the table. In this case
	         *   Responsive will automatically be initialised with the default configuration
	         *   options when the DataTable is created.
	         * * Using the `responsive` option in the DataTables configuration options. This
	         *   can also be used to specify the configuration options, or simply set to
	         *   `true` to use the defaults.
	         *
	         *  @class
	         *  @param {object} settings DataTables settings object for the host table
	         *  @param {object} [opts] Configuration options
	         *  @requires jQuery 1.7+
	         *  @requires DataTables 1.10.1+
	         *
	         *  @example
	         *      $('#example').DataTable( {
	        *        responsive: true
	        *      } );
	         *    } );
	         */
	
	        var Responsive = function Responsive(settings, opts) {
	            // Sanity check that we are using DataTables 1.10 or newer
	            if (!DataTable.versionCheck || !DataTable.versionCheck('1.10.1')) {
	                throw 'DataTables Responsive requires DataTables 1.10.1 or newer';
	            }
	
	            this.s = {
	                dt: new DataTable.Api(settings),
	                columns: []
	            };
	
	            // Check if responsive has already been initialised on this table
	            if (this.s.dt.settings()[0].responsive) {
	                return;
	            }
	
	            // details is an object, but for simplicity the user can give it as a string
	            if (opts && typeof opts.details === 'string') {
	                opts.details = { type: opts.details };
	            }
	
	            this.c = $.extend(true, {}, Responsive.defaults, DataTable.defaults.responsive, opts);
	            settings.responsive = this;
	            this._constructor();
	        };
	
	        Responsive.prototype = {
	            /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	             * Constructor
	             */
	
	            /**
	             * Initialise the Responsive instance
	             *
	             * @private
	             */
	            _constructor: function _constructor() {
	                var that = this;
	                var dt = this.s.dt;
	
	                dt.settings()[0]._responsive = this;
	
	                // Use DataTables' private throttle function to avoid processor thrashing
	                $(window).on('resize.dtr orientationchange.dtr', dt.settings()[0].oApi._fnThrottle(function () {
	                    that._resize();
	                }));
	
	                // Destroy event handler
	                dt.on('destroy.dtr', function () {
	                    $(window).off('resize.dtr orientationchange.dtr');
	                });
	
	                // Reorder the breakpoints array here in case they have been added out
	                // of order
	                this.c.breakpoints.sort(function (a, b) {
	                    return a.width < b.width ? 1 : a.width > b.width ? -1 : 0;
	                });
	
	                // Determine which columns are already hidden, and should therefore
	                // remain hidden. TODO - should this be done? See thread 22677
	                //
	                // this.s.alwaysHidden = dt.columns(':hidden').indexes();
	
	                this._classLogic();
	                this._resizeAuto();
	
	                // First pass - draw the table for the current viewport size
	                this._resize();
	
	                // Details handler
	                var details = this.c.details;
	                if (details.type) {
	                    that._detailsInit();
	                    this._detailsVis();
	
	                    dt.on('column-visibility.dtr', function () {
	                        that._detailsVis();
	                    });
	
	                    $(dt.table().node()).addClass('dtr-' + details.type);
	                }
	            },
	
	            /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	             * Private methods
	             */
	
	            /**
	             * Calculate the visibility for the columns in a table for a given
	             * breakpoint. The result is pre-determined based on the class logic if
	             * class names are used to control all columns, but the width of the table
	             * is also used if there are columns which are to be automatically shown
	             * and hidden.
	             *
	             * @param  {string} breakpoint Breakpoint name to use for the calculation
	             * @return {array} Array of boolean values initiating the visibility of each
	             *   column.
	             *  @private
	             */
	            _columnsVisiblity: function _columnsVisiblity(breakpoint) {
	                var dt = this.s.dt;
	                var columns = this.s.columns;
	                var i, ien;
	
	                // Class logic - determine which columns are in this breakpoint based
	                // on the classes. If no class control (i.e. `auto`) then `-` is used
	                // to indicate this to the rest of the function
	                var display = $.map(columns, function (col) {
	                    return col.auto && col.minWidth === null ? false : col.auto === true ? '-' : $.inArray(breakpoint, col.includeIn) !== -1;
	                });
	
	                // Auto column control - first pass: how much width is taken by the
	                // ones that must be included from the non-auto columns
	                var requiredWidth = 0;
	                for (i = 0, ien = display.length; i < ien; i++) {
	                    if (display[i] === true) {
	                        requiredWidth += columns[i].minWidth;
	                    }
	                }
	
	                // Second pass, use up any remaining width for other columns
	                var widthAvailable = dt.table().container().offsetWidth;
	                var usedWidth = widthAvailable - requiredWidth;
	
	                for (i = 0, ien = display.length; i < ien; i++) {
	                    // Control column needs to always be included. This makes it sub-
	                    // optimal in terms of using the available with, but to stop layout
	                    // thrashing or overflow
	                    if (columns[i].control) {
	                        usedWidth -= columns[i].minWidth;
	                    } else if (display[i] === '-') {
	                        // Otherwise, remove the width
	                        display[i] = usedWidth - columns[i].minWidth < 0 ? false : true;
	
	                        // Continue counting down the width, so a smaller column to the
	                        // left won't be shown
	                        usedWidth -= columns[i].minWidth;
	                    }
	                }
	
	                // Determine if the 'control' column should be shown (if there is one).
	                // This is the case when there is a hidden column (that is not the
	                // control column). The two loops look inefficient here, but they are
	                // trivial and will fly through. We need to know the outcome from the
	                // first , before the action in the second can be taken
	                var showControl = false;
	
	                for (i = 0, ien = columns.length; i < ien; i++) {
	                    if (!columns[i].control && !columns[i].never && !display[i]) {
	                        showControl = true;
	                        break;
	                    }
	                }
	
	                for (i = 0, ien = columns.length; i < ien; i++) {
	                    if (columns[i].control) {
	                        display[i] = showControl;
	                    }
	                }
	
	                // Finally we need to make sure that there is at least one column that
	                // is visible
	                if ($.inArray(true, display) === -1) {
	                    display[0] = true;
	                }
	
	                return display;
	            },
	
	            /**
	             * Create the internal `columns` array with information about the columns
	             * for the table. This includes determining which breakpoints the column
	             * will appear in, based upon class names in the column, which makes up the
	             * vast majority of this method.
	             *
	             * @private
	             */
	            _classLogic: function _classLogic() {
	                var that = this;
	                var calc = {};
	                var breakpoints = this.c.breakpoints;
	                var columns = this.s.dt.columns().eq(0).map(function (i) {
	                    var className = this.column(i).header().className;
	
	                    return {
	                        className: className,
	                        includeIn: [],
	                        auto: false,
	                        control: false,
	                        never: className.match(/\bnever\b/) ? true : false
	                    };
	                });
	
	                // Simply add a breakpoint to `includeIn` array, ensuring that there are
	                // no duplicates
	                var add = function add(colIdx, name) {
	                    var includeIn = columns[colIdx].includeIn;
	
	                    if ($.inArray(name, includeIn) === -1) {
	                        includeIn.push(name);
	                    }
	                };
	
	                var column = function column(colIdx, name, operator, matched) {
	                    var size, i, ien;
	
	                    if (!operator) {
	                        columns[colIdx].includeIn.push(name);
	                    } else if (operator === 'max-') {
	                        // Add this breakpoint and all smaller
	                        size = that._find(name).width;
	
	                        for (i = 0, ien = breakpoints.length; i < ien; i++) {
	                            if (breakpoints[i].width <= size) {
	                                add(colIdx, breakpoints[i].name);
	                            }
	                        }
	                    } else if (operator === 'min-') {
	                        // Add this breakpoint and all larger
	                        size = that._find(name).width;
	
	                        for (i = 0, ien = breakpoints.length; i < ien; i++) {
	                            if (breakpoints[i].width >= size) {
	                                add(colIdx, breakpoints[i].name);
	                            }
	                        }
	                    } else if (operator === 'not-') {
	                        // Add all but this breakpoint (xxx need extra information)
	
	                        for (i = 0, ien = breakpoints.length; i < ien; i++) {
	                            if (breakpoints[i].name.indexOf(matched) === -1) {
	                                add(colIdx, breakpoints[i].name);
	                            }
	                        }
	                    }
	                };
	
	                // Loop over each column and determine if it has a responsive control
	                // class
	                columns.each(function (col, i) {
	                    var classNames = col.className.split(' ');
	                    var hasClass = false;
	
	                    // Split the class name up so multiple rules can be applied if needed
	                    for (var k = 0, ken = classNames.length; k < ken; k++) {
	                        var className = $.trim(classNames[k]);
	
	                        if (className === 'all') {
	                            // Include in all
	                            hasClass = true;
	                            col.includeIn = $.map(breakpoints, function (a) {
	                                return a.name;
	                            });
	                            return;
	                        } else if (className === 'none' || className === 'never') {
	                            // Include in none (default) and no auto
	                            hasClass = true;
	                            return;
	                        } else if (className === 'control') {
	                            // Special column that is only visible, when one of the other
	                            // columns is hidden. This is used for the details control
	                            hasClass = true;
	                            col.control = true;
	                            return;
	                        }
	
	                        $.each(breakpoints, function (j, breakpoint) {
	                            // Does this column have a class that matches this breakpoint?
	                            var brokenPoint = breakpoint.name.split('-');
	                            var re = new RegExp('(min\\-|max\\-|not\\-)?(' + brokenPoint[0] + ')(\\-[_a-zA-Z0-9])?');
	                            var match = className.match(re);
	
	                            if (match) {
	                                hasClass = true;
	
	                                if (match[2] === brokenPoint[0] && match[3] === '-' + brokenPoint[1]) {
	                                    // Class name matches breakpoint name fully
	                                    column(i, breakpoint.name, match[1], match[2] + match[3]);
	                                } else if (match[2] === brokenPoint[0] && !match[3]) {
	                                    // Class name matched primary breakpoint name with no qualifier
	                                    column(i, breakpoint.name, match[1], match[2]);
	                                }
	                            }
	                        });
	                    }
	
	                    // If there was no control class, then automatic sizing is used
	                    if (!hasClass) {
	                        col.auto = true;
	                    }
	                });
	
	                this.s.columns = columns;
	            },
	
	            /**
	             * Initialisation for the details handler
	             *
	             * @private
	             */
	            _detailsInit: function _detailsInit() {
	                var that = this;
	                var dt = this.s.dt;
	                var details = this.c.details;
	
	                // The inline type always uses the first child as the target
	                if (details.type === 'inline') {
	                    details.target = 'td:first-child';
	                }
	
	                // type.target can be a string jQuery selector or a column index
	                var target = details.target;
	                var selector = typeof target === 'string' ? target : 'td';
	
	                // Click handler to show / hide the details rows when they are available
	                $(dt.table().body()).on('click', selector, function (e) {
	                    // If the table is not collapsed (i.e. there is no hidden columns)
	                    // then take no action
	                    if (!$(dt.table().node()).hasClass('collapsed')) {
	                        return;
	                    }
	
	                    // Check that the row is actually a DataTable's controlled node
	                    if (!dt.row($(this).closest('tr')).length) {
	                        return;
	                    }
	
	                    // For column index, we determine if we should act or not in the
	                    // handler - otherwise it is already okay
	                    if (typeof target === 'number') {
	                        var targetIdx = target < 0 ? dt.columns().eq(0).length + target : target;
	
	                        if (dt.cell(this).index().column !== targetIdx) {
	                            return;
	                        }
	                    }
	
	                    // $().closest() includes itself in its check
	                    var row = dt.row($(this).closest('tr'));
	
	                    if (row.child.isShown()) {
	                        row.child(false);
	                        $(row.node()).removeClass('parent');
	                    } else {
	                        var info = that.c.details.renderer(dt, row[0]);
	                        row.child(info, 'child').show();
	                        $(row.node()).addClass('parent');
	                    }
	                });
	            },
	
	            /**
	             * Update the child rows in the table whenever the column visibility changes
	             *
	             * @private
	             */
	            _detailsVis: function _detailsVis() {
	                var that = this;
	                var dt = this.s.dt;
	
	                // Find how many columns are hidden
	                var hiddenColumns = dt.columns().indexes().filter(function (idx) {
	                    var col = dt.column(idx);
	
	                    if (col.visible()) {
	                        return null;
	                    }
	
	                    // Only counts as hidden if it doesn't have the `never` class
	                    return $(col.header()).hasClass('never') ? null : idx;
	                });
	                var haveHidden = true;
	
	                if (hiddenColumns.length === 0 || hiddenColumns.length === 1 && this.s.columns[hiddenColumns[0]].control) {
	                    haveHidden = false;
	                }
	
	                if (haveHidden) {
	                    // Got hidden columns
	                    $(dt.table().node()).addClass('collapsed');
	
	                    // Show all existing child rows
	                    dt.rows().eq(0).each(function (idx) {
	                        var row = dt.row(idx);
	
	                        if (row.child()) {
	                            var info = that.c.details.renderer(dt, row[0]);
	
	                            // The renderer can return false to have no child row
	                            if (info === false) {
	                                row.child.hide();
	                            } else {
	                                row.child(info, 'child').show();
	                            }
	                        }
	                    });
	                } else {
	                    // No hidden columns
	                    $(dt.table().node()).removeClass('collapsed');
	
	                    // Hide all existing child rows
	                    dt.rows().eq(0).each(function (idx) {
	                        dt.row(idx).child.hide();
	                    });
	                }
	            },
	
	            /**
	             * Find a breakpoint object from a name
	             * @param  {string} name Breakpoint name to find
	             * @return {object}      Breakpoint description object
	             */
	            _find: function _find(name) {
	                var breakpoints = this.c.breakpoints;
	
	                for (var i = 0, ien = breakpoints.length; i < ien; i++) {
	                    if (breakpoints[i].name === name) {
	                        return breakpoints[i];
	                    }
	                }
	            },
	
	            /**
	             * Alter the table display for a resized viewport. This involves first
	             * determining what breakpoint the window currently is in, getting the
	             * column visibilities to apply and then setting them.
	             *
	             * @private
	             */
	            _resize: function _resize() {
	                var dt = this.s.dt;
	                var width = $(window).width();
	                var breakpoints = this.c.breakpoints;
	                var breakpoint = breakpoints[0].name;
	
	                // Determine what breakpoint we are currently at
	                for (var i = breakpoints.length - 1; i >= 0; i--) {
	                    if (width <= breakpoints[i].width) {
	                        breakpoint = breakpoints[i].name;
	                        break;
	                    }
	                }
	
	                // Show the columns for that break point
	                var columns = this._columnsVisiblity(breakpoint);
	
	                dt.columns().eq(0).each(function (colIdx, i) {
	                    dt.column(colIdx).visible(columns[i]);
	                });
	            },
	
	            /**
	             * Determine the width of each column in the table so the auto column hiding
	             * has that information to work with. This method is never going to be 100%
	             * perfect since column widths can change slightly per page, but without
	             * seriously compromising performance this is quite effective.
	             *
	             * @private
	             */
	            _resizeAuto: function _resizeAuto() {
	                var dt = this.s.dt;
	                var columns = this.s.columns;
	
	                // Are we allowed to do auto sizing?
	                if (!this.c.auto) {
	                    return;
	                }
	
	                // Are there any columns that actually need auto-sizing, or do they all
	                // have classes defined
	                if ($.inArray(true, $.map(columns, function (c) {
	                    return c.auto;
	                })) === -1) {
	                    return;
	                }
	
	                // Clone the table with the current data in it
	                var tableWidth = dt.table().node().offsetWidth;
	                var columnWidths = dt.columns;
	                var clonedTable = dt.table().node().cloneNode(false);
	                var clonedHeader = $(dt.table().header().cloneNode(false)).appendTo(clonedTable);
	                var clonedBody = $(dt.table().body().cloneNode(false)).appendTo(clonedTable);
	
	                // This is a bit slow, but we need to get a clone of each row that
	                // includes all columns. As such, try to do this as little as possible.
	                dt.rows({ page: 'current' }).indexes().flatten().each(function (idx) {
	                    var clone = dt.row(idx).node().cloneNode(true);
	
	                    if (dt.columns(':hidden').flatten().length) {
	                        $(clone).append(dt.cells(idx, ':hidden').nodes().to$().clone());
	                    }
	
	                    $(clone).appendTo(clonedBody);
	                });
	
	                var cells = dt.columns().header().to$().clone(false).wrapAll('tr').appendTo(clonedHeader);
	                var inserted = $('<div/>').css({
	                    width: 1,
	                    height: 1,
	                    overflow: 'hidden'
	                }).append(clonedTable).insertBefore(dt.table().node());
	
	                // The cloned header now contains the smallest that each column can be
	                dt.columns().eq(0).each(function (idx) {
	                    columns[idx].minWidth = cells[idx].offsetWidth || 0;
	                });
	
	                inserted.remove();
	            }
	        };
	
	        /**
	         * List of default breakpoints. Each item in the array is an object with two
	         * properties:
	         *
	         * * `name` - the breakpoint name.
	         * * `width` - the breakpoint width
	         *
	         * @name Responsive.breakpoints
	         * @static
	         */
	        Responsive.breakpoints = [{ name: 'desktop', width: Infinity }, { name: 'tablet-l', width: 1024 }, { name: 'tablet-p', width: 768 }, { name: 'mobile-l', width: 480 }, { name: 'mobile-p', width: 320 }];
	
	        /**
	         * Responsive default settings for initialisation
	         *
	         * @namespace
	         * @name Responsive.defaults
	         * @static
	         */
	        Responsive.defaults = {
	            /**
	             * List of breakpoints for the instance. Note that this means that each
	             * instance can have its own breakpoints. Additionally, the breakpoints
	             * cannot be changed once an instance has been creased.
	             *
	             * @type {Array}
	             * @default Takes the value of `Responsive.breakpoints`
	             */
	            breakpoints: Responsive.breakpoints,
	
	            /**
	             * Enable / disable auto hiding calculations. It can help to increase
	             * performance slightly if you disable this option, but all columns would
	             * need to have breakpoint classes assigned to them
	             *
	             * @type {Boolean}
	             * @default  `true`
	             */
	            auto: true,
	
	            /**
	             * Details control. If given as a string value, the `type` property of the
	             * default object is set to that value, and the defaults used for the rest
	             * of the object - this is for ease of implementation.
	             *
	             * The object consists of the following properties:
	             *
	             * * `renderer` - function that is called for display of the child row data.
	             *   The default function will show the data from the hidden columns
	             * * `target` - Used as the selector for what objects to attach the child
	             *   open / close to
	             * * `type` - `false` to disable the details display, `inline` or `column`
	             *   for the two control types
	             *
	             * @type {Object|string}
	             */
	            details: {
	                renderer: function renderer(api, rowIdx) {
	                    var data = api.cells(rowIdx, ':hidden').eq(0).map(function (cell) {
	                        var header = $(api.column(cell.column).header());
	                        var idx = api.cell(cell).index();
	
	                        if (header.hasClass('control') || header.hasClass('never')) {
	                            return '';
	                        }
	
	                        // Use a non-public DT API method to render the data for display
	                        // This needs to be updated when DT adds a suitable method for
	                        // this type of data retrieval
	                        var dtPrivate = api.settings()[0];
	                        var cellData = dtPrivate.oApi._fnGetCellData(dtPrivate, idx.row, idx.column, 'display');
	
	                        return '<li data-dtr-index="' + idx.column + '">' + '<span class="dtr-title">' + header.text() + ':' + '</span> ' + '<span class="dtr-data">' + cellData + '</span>' + '</li>';
	                    }).toArray().join('');
	
	                    return data ? $('<ul data-dtr-index="' + rowIdx + '"/>').append(data) : false;
	                },
	
	                target: 0,
	
	                type: 'inline'
	            }
	        };
	
	        /*
	         * API
	         */
	        var Api = $.fn.dataTable.Api;
	
	        // Doesn't do anything - work around for a bug in DT... Not documented
	        Api.register('responsive()', function () {
	            return this;
	        });
	
	        Api.register('responsive.recalc()', function () {
	            this.iterator('table', function (ctx) {
	                if (ctx._responsive) {
	                    ctx._responsive._resizeAuto();
	                    ctx._responsive._resize();
	                }
	            });
	        });
	
	        Api.register('responsive.index()', function (li) {
	            li = $(li);
	
	            return {
	                column: li.data('dtr-index'),
	                row: li.parent().data('dtr-index')
	            };
	        });
	
	        /**
	         * Version information
	         *
	         * @name Responsive.version
	         * @static
	         */
	        Responsive.version = '1.0.2';
	
	        $.fn.dataTable.Responsive = Responsive;
	        $.fn.DataTable.Responsive = Responsive;
	
	        // Attach a listener to the document which listens for DataTables initialisation
	        // events so we can automatically initialise
	        $(document).on('init.dt.dtr', function (e, settings, json) {
	            if ($(settings.nTable).hasClass('responsive') || $(settings.nTable).hasClass('dt-responsive') || settings.oInit.responsive || DataTable.defaults.responsive) {
	                var init = settings.oInit.responsive;
	
	                if (init !== false) {
	                    new Responsive(settings, $.isPlainObject(init) ? init : {});
	                }
	            }
	        });
	
	        return Responsive;
	    }; // /factory
	
	
	    // Define as an AMD module if possible
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(108)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
	        // Node/CommonJS
	        factory(require('jquery'), require('datatables'));
	    } else if (jQuery && !jQuery.fn.dataTable.Responsive) {
	        // Otherwise simply initialise as normal, stopping multiple evaluation
	        factory(jQuery, jQuery.fn.dataTable);
	    }
	})(window, document);

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1074);
	
	__webpack_require__(108);
	
	__webpack_require__(475);
	
	__webpack_require__(474);

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	// NOTE: THIS FILE HAS BEEN EDITED BECAUSE
	// THE MAINTAINER OF THE PACKAGE ALLOWED
	// MERGER OF NON-EXISTENT JQUERY VAR CALL
	
	/*!
	 * jQuery Validation Plugin v1.15.0
	 *
	 * http://jqueryvalidation.org/
	 *
	 * Copyright (c) 2016 Jörn Zaefferer
	 * Released under the MIT license
	 */
	(function (factory) {
		if (( false ? "undefined" : _typeof(module)) === "object" && module.exports) {
			module.exports = factory(__webpack_require__(1));
		} else if (true) {
			// note, we are assuming that jquery validation is loaded
			// before this, but just in case, we have edited the load
			// of jquery-validation from a PATH to the actual node_module
			// (also, this else if shouldn't execute for the build process anyways)
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(188)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			factory(jQuery);
		}
	})(function ($) {
		var jQuery = $;
		(function () {
	
			function stripHtml(value) {
	
				// Remove html tags and space chars
				return value.replace(/<.[^<>]*?>/g, " ").replace(/&nbsp;|&#160;/gi, " ")
	
				// Remove punctuation
				.replace(/[.(),;:!?%#$'\"_+=\/\-“”’]*/g, "");
			}
	
			$.validator.addMethod("maxWords", function (value, element, params) {
				return this.optional(element) || stripHtml(value).match(/\b\w+\b/g).length <= params;
			}, $.validator.format("Please enter {0} words or less."));
	
			$.validator.addMethod("minWords", function (value, element, params) {
				return this.optional(element) || stripHtml(value).match(/\b\w+\b/g).length >= params;
			}, $.validator.format("Please enter at least {0} words."));
	
			$.validator.addMethod("rangeWords", function (value, element, params) {
				var valueStripped = stripHtml(value),
				    regex = /\b\w+\b/g;
				return this.optional(element) || valueStripped.match(regex).length >= params[0] && valueStripped.match(regex).length <= params[1];
			}, $.validator.format("Please enter between {0} and {1} words."));
		})();
	
		// Accept a value from a file input based on a required mimetype
		$.validator.addMethod("accept", function (value, element, param) {
	
			// Split mime on commas in case we have multiple types we can accept
			var typeParam = typeof param === "string" ? param.replace(/\s/g, "") : "image/*",
			    optionalValue = this.optional(element),
			    i,
			    file,
			    regex;
	
			// Element is optional
			if (optionalValue) {
				return optionalValue;
			}
	
			if ($(element).attr("type") === "file") {
	
				// Escape string to be used in the regex
				// see: http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
				// Escape also "/*" as "/.*" as a wildcard
				typeParam = typeParam.replace(/[\-\[\]\/\{\}\(\)\+\?\.\\\^\$\|]/g, "\\$&").replace(/,/g, "|").replace("\/*", "/.*");
	
				// Check if the element has a FileList before checking each file
				if (element.files && element.files.length) {
					regex = new RegExp(".?(" + typeParam + ")$", "i");
					for (i = 0; i < element.files.length; i++) {
						file = element.files[i];
	
						// Grab the mimetype from the loaded file, verify it matches
						if (!file.type.match(regex)) {
							return false;
						}
					}
				}
			}
	
			// Either return true because we've validated each file, or because the
			// browser does not support element.files and the FileList feature
			return true;
		}, $.validator.format("Please enter a value with a valid mimetype."));
	
		$.validator.addMethod("alphanumeric", function (value, element) {
			return this.optional(element) || /^\w+$/i.test(value);
		}, "Letters, numbers, and underscores only please");
	
		/*
	  * Dutch bank account numbers (not 'giro' numbers) have 9 digits
	  * and pass the '11 check'.
	  * We accept the notation with spaces, as that is common.
	  * acceptable: 123456789 or 12 34 56 789
	  */
		$.validator.addMethod("bankaccountNL", function (value, element) {
			if (this.optional(element)) {
				return true;
			}
			if (!/^[0-9]{9}|([0-9]{2} ){3}[0-9]{3}$/.test(value)) {
				return false;
			}
	
			// Now '11 check'
			var account = value.replace(/ /g, ""),
			    // Remove spaces
			sum = 0,
			    len = account.length,
			    pos,
			    factor,
			    digit;
			for (pos = 0; pos < len; pos++) {
				factor = len - pos;
				digit = account.substring(pos, pos + 1);
				sum = sum + factor * digit;
			}
			return sum % 11 === 0;
		}, "Please specify a valid bank account number");
	
		$.validator.addMethod("bankorgiroaccountNL", function (value, element) {
			return this.optional(element) || $.validator.methods.bankaccountNL.call(this, value, element) || $.validator.methods.giroaccountNL.call(this, value, element);
		}, "Please specify a valid bank or giro account number");
	
		/**
	  * BIC is the business identifier code (ISO 9362). This BIC check is not a guarantee for authenticity.
	  *
	  * BIC pattern: BBBBCCLLbbb (8 or 11 characters long; bbb is optional)
	  *
	  * Validation is case-insensitive. Please make sure to normalize input yourself.
	  *
	  * BIC definition in detail:
	  * - First 4 characters - bank code (only letters)
	  * - Next 2 characters - ISO 3166-1 alpha-2 country code (only letters)
	  * - Next 2 characters - location code (letters and digits)
	  *   a. shall not start with '0' or '1'
	  *   b. second character must be a letter ('O' is not allowed) or digit ('0' for test (therefore not allowed), '1' denoting passive participant, '2' typically reverse-billing)
	  * - Last 3 characters - branch code, optional (shall not start with 'X' except in case of 'XXX' for primary office) (letters and digits)
	  */
		$.validator.addMethod("bic", function (value, element) {
			return this.optional(element) || /^([A-Z]{6}[A-Z2-9][A-NP-Z1-9])(X{3}|[A-WY-Z0-9][A-Z0-9]{2})?$/.test(value.toUpperCase());
		}, "Please specify a valid BIC code");
	
		/*
	  * Código de identificación fiscal ( CIF ) is the tax identification code for Spanish legal entities
	  * Further rules can be found in Spanish on http://es.wikipedia.org/wiki/C%C3%B3digo_de_identificaci%C3%B3n_fiscal
	  */
		$.validator.addMethod("cifES", function (value) {
			"use strict";
	
			var num = [],
			    controlDigit,
			    sum,
			    i,
			    count,
			    tmp,
			    secondDigit;
	
			value = value.toUpperCase();
	
			// Quick format test
			if (!value.match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)")) {
				return false;
			}
	
			for (i = 0; i < 9; i++) {
				num[i] = parseInt(value.charAt(i), 10);
			}
	
			// Algorithm for checking CIF codes
			sum = num[2] + num[4] + num[6];
			for (count = 1; count < 8; count += 2) {
				tmp = (2 * num[count]).toString();
				secondDigit = tmp.charAt(1);
	
				sum += parseInt(tmp.charAt(0), 10) + (secondDigit === "" ? 0 : parseInt(secondDigit, 10));
			}
	
			/* The first (position 1) is a letter following the following criteria:
	   *	A. Corporations
	   *	B. LLCs
	   *	C. General partnerships
	   *	D. Companies limited partnerships
	   *	E. Communities of goods
	   *	F. Cooperative Societies
	   *	G. Associations
	   *	H. Communities of homeowners in horizontal property regime
	   *	J. Civil Societies
	   *	K. Old format
	   *	L. Old format
	   *	M. Old format
	   *	N. Nonresident entities
	   *	P. Local authorities
	   *	Q. Autonomous bodies, state or not, and the like, and congregations and religious institutions
	   *	R. Congregations and religious institutions (since 2008 ORDER EHA/451/2008)
	   *	S. Organs of State Administration and regions
	   *	V. Agrarian Transformation
	   *	W. Permanent establishments of non-resident in Spain
	   */
			if (/^[ABCDEFGHJNPQRSUVW]{1}/.test(value)) {
				sum += "";
				controlDigit = 10 - parseInt(sum.charAt(sum.length - 1), 10);
				value += controlDigit;
				return num[8].toString() === String.fromCharCode(64 + controlDigit) || num[8].toString() === value.charAt(value.length - 1);
			}
	
			return false;
		}, "Please specify a valid CIF number.");
	
		/*
	  * Brazillian CPF number (Cadastrado de Pessoas Físicas) is the equivalent of a Brazilian tax registration number.
	  * CPF numbers have 11 digits in total: 9 numbers followed by 2 check numbers that are being used for validation.
	  */
		$.validator.addMethod("cpfBR", function (value) {
	
			// Removing special characters from value
			value = value.replace(/([~!@#$%^&*()_+=`{}\[\]\-|\\:;'<>,.\/? ])+/g, "");
	
			// Checking value to have 11 digits only
			if (value.length !== 11) {
				return false;
			}
	
			var sum = 0,
			    firstCN,
			    secondCN,
			    checkResult,
			    i;
	
			firstCN = parseInt(value.substring(9, 10), 10);
			secondCN = parseInt(value.substring(10, 11), 10);
	
			checkResult = function checkResult(sum, cn) {
				var result = sum * 10 % 11;
				if (result === 10 || result === 11) {
					result = 0;
				}
				return result === cn;
			};
	
			// Checking for dump data
			if (value === "" || value === "00000000000" || value === "11111111111" || value === "22222222222" || value === "33333333333" || value === "44444444444" || value === "55555555555" || value === "66666666666" || value === "77777777777" || value === "88888888888" || value === "99999999999") {
				return false;
			}
	
			// Step 1 - using first Check Number:
			for (i = 1; i <= 9; i++) {
				sum = sum + parseInt(value.substring(i - 1, i), 10) * (11 - i);
			}
	
			// If first Check Number (CN) is valid, move to Step 2 - using second Check Number:
			if (checkResult(sum, firstCN)) {
				sum = 0;
				for (i = 1; i <= 10; i++) {
					sum = sum + parseInt(value.substring(i - 1, i), 10) * (12 - i);
				}
				return checkResult(sum, secondCN);
			}
			return false;
		}, "Please specify a valid CPF number");
	
		// http://jqueryvalidation.org/creditcard-method/
		// based on http://en.wikipedia.org/wiki/Luhn_algorithm
		$.validator.addMethod("creditcard", function (value, element) {
			if (this.optional(element)) {
				return "dependency-mismatch";
			}
	
			// Accept only spaces, digits and dashes
			if (/[^0-9 \-]+/.test(value)) {
				return false;
			}
	
			var nCheck = 0,
			    nDigit = 0,
			    bEven = false,
			    n,
			    cDigit;
	
			value = value.replace(/\D/g, "");
	
			// Basing min and max length on
			// http://developer.ean.com/general_info/Valid_Credit_Card_Types
			if (value.length < 13 || value.length > 19) {
				return false;
			}
	
			for (n = value.length - 1; n >= 0; n--) {
				cDigit = value.charAt(n);
				nDigit = parseInt(cDigit, 10);
				if (bEven) {
					if ((nDigit *= 2) > 9) {
						nDigit -= 9;
					}
				}
	
				nCheck += nDigit;
				bEven = !bEven;
			}
	
			return nCheck % 10 === 0;
		}, "Please enter a valid credit card number.");
	
		/* NOTICE: Modified version of Castle.Components.Validator.CreditCardValidator
	  * Redistributed under the the Apache License 2.0 at http://www.apache.org/licenses/LICENSE-2.0
	  * Valid Types: mastercard, visa, amex, dinersclub, enroute, discover, jcb, unknown, all (overrides all other settings)
	  */
		$.validator.addMethod("creditcardtypes", function (value, element, param) {
			if (/[^0-9\-]+/.test(value)) {
				return false;
			}
	
			value = value.replace(/\D/g, "");
	
			var validTypes = 0x0000;
	
			if (param.mastercard) {
				validTypes |= 0x0001;
			}
			if (param.visa) {
				validTypes |= 0x0002;
			}
			if (param.amex) {
				validTypes |= 0x0004;
			}
			if (param.dinersclub) {
				validTypes |= 0x0008;
			}
			if (param.enroute) {
				validTypes |= 0x0010;
			}
			if (param.discover) {
				validTypes |= 0x0020;
			}
			if (param.jcb) {
				validTypes |= 0x0040;
			}
			if (param.unknown) {
				validTypes |= 0x0080;
			}
			if (param.all) {
				validTypes = 0x0001 | 0x0002 | 0x0004 | 0x0008 | 0x0010 | 0x0020 | 0x0040 | 0x0080;
			}
			if (validTypes & 0x0001 && /^(5[12345])/.test(value)) {
				// Mastercard
				return value.length === 16;
			}
			if (validTypes & 0x0002 && /^(4)/.test(value)) {
				// Visa
				return value.length === 16;
			}
			if (validTypes & 0x0004 && /^(3[47])/.test(value)) {
				// Amex
				return value.length === 15;
			}
			if (validTypes & 0x0008 && /^(3(0[012345]|[68]))/.test(value)) {
				// Dinersclub
				return value.length === 14;
			}
			if (validTypes & 0x0010 && /^(2(014|149))/.test(value)) {
				// Enroute
				return value.length === 15;
			}
			if (validTypes & 0x0020 && /^(6011)/.test(value)) {
				// Discover
				return value.length === 16;
			}
			if (validTypes & 0x0040 && /^(3)/.test(value)) {
				// Jcb
				return value.length === 16;
			}
			if (validTypes & 0x0040 && /^(2131|1800)/.test(value)) {
				// Jcb
				return value.length === 15;
			}
			if (validTypes & 0x0080) {
				// Unknown
				return true;
			}
			return false;
		}, "Please enter a valid credit card number.");
	
		/**
	  * Validates currencies with any given symbols by @jameslouiz
	  * Symbols can be optional or required. Symbols required by default
	  *
	  * Usage examples:
	  *  currency: ["£", false] - Use false for soft currency validation
	  *  currency: ["$", false]
	  *  currency: ["RM", false] - also works with text based symbols such as "RM" - Malaysia Ringgit etc
	  *
	  *  <input class="currencyInput" name="currencyInput">
	  *
	  * Soft symbol checking
	  *  currencyInput: {
	  *     currency: ["$", false]
	  *  }
	  *
	  * Strict symbol checking (default)
	  *  currencyInput: {
	  *     currency: "$"
	  *     //OR
	  *     currency: ["$", true]
	  *  }
	  *
	  * Multiple Symbols
	  *  currencyInput: {
	  *     currency: "$,£,¢"
	  *  }
	  */
		$.validator.addMethod("currency", function (value, element, param) {
			var isParamString = typeof param === "string",
			    symbol = isParamString ? param : param[0],
			    soft = isParamString ? true : param[1],
			    regex;
	
			symbol = symbol.replace(/,/g, "");
			symbol = soft ? symbol + "]" : symbol + "]?";
			regex = "^[" + symbol + "([1-9]{1}[0-9]{0,2}(\\,[0-9]{3})*(\\.[0-9]{0,2})?|[1-9]{1}[0-9]{0,}(\\.[0-9]{0,2})?|0(\\.[0-9]{0,2})?|(\\.[0-9]{1,2})?)$";
			regex = new RegExp(regex);
			return this.optional(element) || regex.test(value);
		}, "Please specify a valid currency");
	
		$.validator.addMethod("dateFA", function (value, element) {
			return this.optional(element) || /^[1-4]\d{3}\/((0?[1-6]\/((3[0-1])|([1-2][0-9])|(0?[1-9])))|((1[0-2]|(0?[7-9]))\/(30|([1-2][0-9])|(0?[1-9]))))$/.test(value);
		}, $.validator.messages.date);
	
		/**
	  * Return true, if the value is a valid date, also making this formal check dd/mm/yyyy.
	  *
	  * @example $.validator.methods.date("01/01/1900")
	  * @result true
	  *
	  * @example $.validator.methods.date("01/13/1990")
	  * @result false
	  *
	  * @example $.validator.methods.date("01.01.1900")
	  * @result false
	  *
	  * @example <input name="pippo" class="{dateITA:true}" />
	  * @desc Declares an optional input element whose value must be a valid date.
	  *
	  * @name $.validator.methods.dateITA
	  * @type Boolean
	  * @cat Plugins/Validate/Methods
	  */
		$.validator.addMethod("dateITA", function (value, element) {
			var check = false,
			    re = /^\d{1,2}\/\d{1,2}\/\d{4}$/,
			    adata,
			    gg,
			    mm,
			    aaaa,
			    xdata;
			if (re.test(value)) {
				adata = value.split("/");
				gg = parseInt(adata[0], 10);
				mm = parseInt(adata[1], 10);
				aaaa = parseInt(adata[2], 10);
				xdata = new Date(Date.UTC(aaaa, mm - 1, gg, 12, 0, 0, 0));
				if (xdata.getUTCFullYear() === aaaa && xdata.getUTCMonth() === mm - 1 && xdata.getUTCDate() === gg) {
					check = true;
				} else {
					check = false;
				}
			} else {
				check = false;
			}
			return this.optional(element) || check;
		}, $.validator.messages.date);
	
		$.validator.addMethod("dateNL", function (value, element) {
			return this.optional(element) || /^(0?[1-9]|[12]\d|3[01])[\.\/\-](0?[1-9]|1[012])[\.\/\-]([12]\d)?(\d\d)$/.test(value);
		}, $.validator.messages.date);
	
		// Older "accept" file extension method. Old docs: http://docs.jquery.com/Plugins/Validation/Methods/accept
		$.validator.addMethod("extension", function (value, element, param) {
			param = typeof param === "string" ? param.replace(/,/g, "|") : "png|jpe?g|gif";
			return this.optional(element) || value.match(new RegExp("\\.(" + param + ")$", "i"));
		}, $.validator.format("Please enter a value with a valid extension."));
	
		/**
	  * Dutch giro account numbers (not bank numbers) have max 7 digits
	  */
		$.validator.addMethod("giroaccountNL", function (value, element) {
			return this.optional(element) || /^[0-9]{1,7}$/.test(value);
		}, "Please specify a valid giro account number");
	
		/**
	  * IBAN is the international bank account number.
	  * It has a country - specific format, that is checked here too
	  *
	  * Validation is case-insensitive. Please make sure to normalize input yourself.
	  */
		$.validator.addMethod("iban", function (value, element) {
	
			// Some quick simple tests to prevent needless work
			if (this.optional(element)) {
				return true;
			}
	
			// Remove spaces and to upper case
			var iban = value.replace(/ /g, "").toUpperCase(),
			    ibancheckdigits = "",
			    leadingZeroes = true,
			    cRest = "",
			    cOperator = "",
			    countrycode,
			    ibancheck,
			    charAt,
			    cChar,
			    bbanpattern,
			    bbancountrypatterns,
			    ibanregexp,
			    i,
			    p;
	
			// Check the country code and find the country specific format
			countrycode = iban.substring(0, 2);
			bbancountrypatterns = {
				"AL": "\\d{8}[\\dA-Z]{16}",
				"AD": "\\d{8}[\\dA-Z]{12}",
				"AT": "\\d{16}",
				"AZ": "[\\dA-Z]{4}\\d{20}",
				"BE": "\\d{12}",
				"BH": "[A-Z]{4}[\\dA-Z]{14}",
				"BA": "\\d{16}",
				"BR": "\\d{23}[A-Z][\\dA-Z]",
				"BG": "[A-Z]{4}\\d{6}[\\dA-Z]{8}",
				"CR": "\\d{17}",
				"HR": "\\d{17}",
				"CY": "\\d{8}[\\dA-Z]{16}",
				"CZ": "\\d{20}",
				"DK": "\\d{14}",
				"DO": "[A-Z]{4}\\d{20}",
				"EE": "\\d{16}",
				"FO": "\\d{14}",
				"FI": "\\d{14}",
				"FR": "\\d{10}[\\dA-Z]{11}\\d{2}",
				"GE": "[\\dA-Z]{2}\\d{16}",
				"DE": "\\d{18}",
				"GI": "[A-Z]{4}[\\dA-Z]{15}",
				"GR": "\\d{7}[\\dA-Z]{16}",
				"GL": "\\d{14}",
				"GT": "[\\dA-Z]{4}[\\dA-Z]{20}",
				"HU": "\\d{24}",
				"IS": "\\d{22}",
				"IE": "[\\dA-Z]{4}\\d{14}",
				"IL": "\\d{19}",
				"IT": "[A-Z]\\d{10}[\\dA-Z]{12}",
				"KZ": "\\d{3}[\\dA-Z]{13}",
				"KW": "[A-Z]{4}[\\dA-Z]{22}",
				"LV": "[A-Z]{4}[\\dA-Z]{13}",
				"LB": "\\d{4}[\\dA-Z]{20}",
				"LI": "\\d{5}[\\dA-Z]{12}",
				"LT": "\\d{16}",
				"LU": "\\d{3}[\\dA-Z]{13}",
				"MK": "\\d{3}[\\dA-Z]{10}\\d{2}",
				"MT": "[A-Z]{4}\\d{5}[\\dA-Z]{18}",
				"MR": "\\d{23}",
				"MU": "[A-Z]{4}\\d{19}[A-Z]{3}",
				"MC": "\\d{10}[\\dA-Z]{11}\\d{2}",
				"MD": "[\\dA-Z]{2}\\d{18}",
				"ME": "\\d{18}",
				"NL": "[A-Z]{4}\\d{10}",
				"NO": "\\d{11}",
				"PK": "[\\dA-Z]{4}\\d{16}",
				"PS": "[\\dA-Z]{4}\\d{21}",
				"PL": "\\d{24}",
				"PT": "\\d{21}",
				"RO": "[A-Z]{4}[\\dA-Z]{16}",
				"SM": "[A-Z]\\d{10}[\\dA-Z]{12}",
				"SA": "\\d{2}[\\dA-Z]{18}",
				"RS": "\\d{18}",
				"SK": "\\d{20}",
				"SI": "\\d{15}",
				"ES": "\\d{20}",
				"SE": "\\d{20}",
				"CH": "\\d{5}[\\dA-Z]{12}",
				"TN": "\\d{20}",
				"TR": "\\d{5}[\\dA-Z]{17}",
				"AE": "\\d{3}\\d{16}",
				"GB": "[A-Z]{4}\\d{14}",
				"VG": "[\\dA-Z]{4}\\d{16}"
			};
	
			bbanpattern = bbancountrypatterns[countrycode];
	
			// As new countries will start using IBAN in the
			// future, we only check if the countrycode is known.
			// This prevents false negatives, while almost all
			// false positives introduced by this, will be caught
			// by the checksum validation below anyway.
			// Strict checking should return FALSE for unknown
			// countries.
			if (typeof bbanpattern !== "undefined") {
				ibanregexp = new RegExp("^[A-Z]{2}\\d{2}" + bbanpattern + "$", "");
				if (!ibanregexp.test(iban)) {
					return false; // Invalid country specific format
				}
			}
	
			// Now check the checksum, first convert to digits
			ibancheck = iban.substring(4, iban.length) + iban.substring(0, 4);
			for (i = 0; i < ibancheck.length; i++) {
				charAt = ibancheck.charAt(i);
				if (charAt !== "0") {
					leadingZeroes = false;
				}
				if (!leadingZeroes) {
					ibancheckdigits += "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(charAt);
				}
			}
	
			// Calculate the result of: ibancheckdigits % 97
			for (p = 0; p < ibancheckdigits.length; p++) {
				cChar = ibancheckdigits.charAt(p);
				cOperator = "" + cRest + "" + cChar;
				cRest = cOperator % 97;
			}
			return cRest === 1;
		}, "Please specify a valid IBAN");
	
		$.validator.addMethod("integer", function (value, element) {
			return this.optional(element) || /^-?\d+$/.test(value);
		}, "A positive or negative non-decimal number please");
	
		$.validator.addMethod("ipv4", function (value, element) {
			return this.optional(element) || /^(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)\.(25[0-5]|2[0-4]\d|[01]?\d\d?)$/i.test(value);
		}, "Please enter a valid IP v4 address.");
	
		$.validator.addMethod("ipv6", function (value, element) {
			return this.optional(element) || /^((([0-9A-Fa-f]{1,4}:){7}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){6}:[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){5}:([0-9A-Fa-f]{1,4}:)?[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){4}:([0-9A-Fa-f]{1,4}:){0,2}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){3}:([0-9A-Fa-f]{1,4}:){0,3}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){2}:([0-9A-Fa-f]{1,4}:){0,4}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){6}((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|(([0-9A-Fa-f]{1,4}:){0,5}:((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|(::([0-9A-Fa-f]{1,4}:){0,5}((\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b)\.){3}(\b((25[0-5])|(1\d{2})|(2[0-4]\d)|(\d{1,2}))\b))|([0-9A-Fa-f]{1,4}::([0-9A-Fa-f]{1,4}:){0,5}[0-9A-Fa-f]{1,4})|(::([0-9A-Fa-f]{1,4}:){0,6}[0-9A-Fa-f]{1,4})|(([0-9A-Fa-f]{1,4}:){1,7}:))$/i.test(value);
		}, "Please enter a valid IP v6 address.");
	
		$.validator.addMethod("lettersonly", function (value, element) {
			return this.optional(element) || /^[a-z]+$/i.test(value);
		}, "Letters only please");
	
		$.validator.addMethod("letterswithbasicpunc", function (value, element) {
			return this.optional(element) || /^[a-z\-.,()'"\s]+$/i.test(value);
		}, "Letters or punctuation only please");
	
		$.validator.addMethod("mobileNL", function (value, element) {
			return this.optional(element) || /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)6((\s|\s?\-\s?)?[0-9]){8}$/.test(value);
		}, "Please specify a valid mobile number");
	
		/* For UK phone functions, do the following server side processing:
	  * Compare original input with this RegEx pattern:
	  * ^\(?(?:(?:00\)?[\s\-]?\(?|\+)(44)\)?[\s\-]?\(?(?:0\)?[\s\-]?\(?)?|0)([1-9]\d{1,4}\)?[\s\d\-]+)$
	  * Extract $1 and set $prefix to '+44<space>' if $1 is '44', otherwise set $prefix to '0'
	  * Extract $2 and remove hyphens, spaces and parentheses. Phone number is combined $prefix and $2.
	  * A number of very detailed GB telephone number RegEx patterns can also be found at:
	  * http://www.aa-asterisk.org.uk/index.php/Regular_Expressions_for_Validating_and_Formatting_GB_Telephone_Numbers
	  */
		$.validator.addMethod("mobileUK", function (phone_number, element) {
			phone_number = phone_number.replace(/\(|\)|\s+|-/g, "");
			return this.optional(element) || phone_number.length > 9 && phone_number.match(/^(?:(?:(?:00\s?|\+)44\s?|0)7(?:[1345789]\d{2}|624)\s?\d{3}\s?\d{3})$/);
		}, "Please specify a valid mobile number");
	
		/*
	  * The número de identidad de extranjero ( NIE )is a code used to identify the non-nationals in Spain
	  */
		$.validator.addMethod("nieES", function (value) {
			"use strict";
	
			value = value.toUpperCase();
	
			// Basic format test
			if (!value.match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)")) {
				return false;
			}
	
			// Test NIE
			//T
			if (/^[T]{1}/.test(value)) {
				return value[8] === /^[T]{1}[A-Z0-9]{8}$/.test(value);
			}
	
			//XYZ
			if (/^[XYZ]{1}/.test(value)) {
				return value[8] === "TRWAGMYFPDXBNJZSQVHLCKE".charAt(value.replace("X", "0").replace("Y", "1").replace("Z", "2").substring(0, 8) % 23);
			}
	
			return false;
		}, "Please specify a valid NIE number.");
	
		/*
	  * The Número de Identificación Fiscal ( NIF ) is the way tax identification used in Spain for individuals
	  */
		$.validator.addMethod("nifES", function (value) {
			"use strict";
	
			value = value.toUpperCase();
	
			// Basic format test
			if (!value.match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)")) {
				return false;
			}
	
			// Test NIF
			if (/^[0-9]{8}[A-Z]{1}$/.test(value)) {
				return "TRWAGMYFPDXBNJZSQVHLCKE".charAt(value.substring(8, 0) % 23) === value.charAt(8);
			}
	
			// Test specials NIF (starts with K, L or M)
			if (/^[KLM]{1}/.test(value)) {
				return value[8] === String.fromCharCode(64);
			}
	
			return false;
		}, "Please specify a valid NIF number.");
	
		jQuery.validator.addMethod("notEqualTo", function (value, element, param) {
			return this.optional(element) || !$.validator.methods.equalTo.call(this, value, element, param);
		}, "Please enter a different value, values must not be the same.");
	
		$.validator.addMethod("nowhitespace", function (value, element) {
			return this.optional(element) || /^\S+$/i.test(value);
		}, "No white space please");
	
		/**
	 * Return true if the field value matches the given format RegExp
	 *
	 * @example $.validator.methods.pattern("AR1004",element,/^AR\d{4}$/)
	 * @result true
	 *
	 * @example $.validator.methods.pattern("BR1004",element,/^AR\d{4}$/)
	 * @result false
	 *
	 * @name $.validator.methods.pattern
	 * @type Boolean
	 * @cat Plugins/Validate/Methods
	 */
		$.validator.addMethod("pattern", function (value, element, param) {
			if (this.optional(element)) {
				return true;
			}
			if (typeof param === "string") {
				param = new RegExp("^(?:" + param + ")$");
			}
			return param.test(value);
		}, "Invalid format.");
	
		/**
	  * Dutch phone numbers have 10 digits (or 11 and start with +31).
	  */
		$.validator.addMethod("phoneNL", function (value, element) {
			return this.optional(element) || /^((\+|00(\s|\s?\-\s?)?)31(\s|\s?\-\s?)?(\(0\)[\-\s]?)?|0)[1-9]((\s|\s?\-\s?)?[0-9]){8}$/.test(value);
		}, "Please specify a valid phone number.");
	
		/* For UK phone functions, do the following server side processing:
	  * Compare original input with this RegEx pattern:
	  * ^\(?(?:(?:00\)?[\s\-]?\(?|\+)(44)\)?[\s\-]?\(?(?:0\)?[\s\-]?\(?)?|0)([1-9]\d{1,4}\)?[\s\d\-]+)$
	  * Extract $1 and set $prefix to '+44<space>' if $1 is '44', otherwise set $prefix to '0'
	  * Extract $2 and remove hyphens, spaces and parentheses. Phone number is combined $prefix and $2.
	  * A number of very detailed GB telephone number RegEx patterns can also be found at:
	  * http://www.aa-asterisk.org.uk/index.php/Regular_Expressions_for_Validating_and_Formatting_GB_Telephone_Numbers
	  */
		$.validator.addMethod("phoneUK", function (phone_number, element) {
			phone_number = phone_number.replace(/\(|\)|\s+|-/g, "");
			return this.optional(element) || phone_number.length > 9 && phone_number.match(/^(?:(?:(?:00\s?|\+)44\s?)|(?:\(?0))(?:\d{2}\)?\s?\d{4}\s?\d{4}|\d{3}\)?\s?\d{3}\s?\d{3,4}|\d{4}\)?\s?(?:\d{5}|\d{3}\s?\d{3})|\d{5}\)?\s?\d{4,5})$/);
		}, "Please specify a valid phone number");
	
		/**
	  * Matches US phone number format
	  *
	  * where the area code may not start with 1 and the prefix may not start with 1
	  * allows '-' or ' ' as a separator and allows parens around area code
	  * some people may want to put a '1' in front of their number
	  *
	  * 1(212)-999-2345 or
	  * 212 999 2344 or
	  * 212-999-0983
	  *
	  * but not
	  * 111-123-5434
	  * and not
	  * 212 123 4567
	  */
		$.validator.addMethod("phoneUS", function (phone_number, element) {
			phone_number = phone_number.replace(/\s+/g, "");
			return this.optional(element) || phone_number.length > 9 && phone_number.match(/^(\+?1-?)?(\([2-9]([02-9]\d|1[02-9])\)|[2-9]([02-9]\d|1[02-9]))-?[2-9]([02-9]\d|1[02-9])-?\d{4}$/);
		}, "Please specify a valid phone number");
	
		$.validator.addMethod("phoneNonUS", function (phone_number, element) {
			return this.optional(element) || phone_number.match(/^\d+$/);
		}, "Please specify a valid phone number");
	
		/* For UK phone functions, do the following server side processing:
	  * Compare original input with this RegEx pattern:
	  * ^\(?(?:(?:00\)?[\s\-]?\(?|\+)(44)\)?[\s\-]?\(?(?:0\)?[\s\-]?\(?)?|0)([1-9]\d{1,4}\)?[\s\d\-]+)$
	  * Extract $1 and set $prefix to '+44<space>' if $1 is '44', otherwise set $prefix to '0'
	  * Extract $2 and remove hyphens, spaces and parentheses. Phone number is combined $prefix and $2.
	  * A number of very detailed GB telephone number RegEx patterns can also be found at:
	  * http://www.aa-asterisk.org.uk/index.php/Regular_Expressions_for_Validating_and_Formatting_GB_Telephone_Numbers
	  */
	
		// Matches UK landline + mobile, accepting only 01-3 for landline or 07 for mobile to exclude many premium numbers
		$.validator.addMethod("phonesUK", function (phone_number, element) {
			phone_number = phone_number.replace(/\(|\)|\s+|-/g, "");
			return this.optional(element) || phone_number.length > 9 && phone_number.match(/^(?:(?:(?:00\s?|\+)44\s?|0)(?:1\d{8,9}|[23]\d{9}|7(?:[1345789]\d{8}|624\d{6})))$/);
		}, "Please specify a valid uk phone number");
	
		/**
	  * Matches a valid Canadian Postal Code
	  *
	  * @example jQuery.validator.methods.postalCodeCA( "H0H 0H0", element )
	  * @result true
	  *
	  * @example jQuery.validator.methods.postalCodeCA( "H0H0H0", element )
	  * @result false
	  *
	  * @name jQuery.validator.methods.postalCodeCA
	  * @type Boolean
	  * @cat Plugins/Validate/Methods
	  */
		$.validator.addMethod("postalCodeCA", function (value, element) {
			return this.optional(element) || /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ] *\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i.test(value);
		}, "Please specify a valid postal code");
	
		/*
	 * Valida CEPs do brasileiros:
	 *
	 * Formatos aceitos:
	 * 99999-999
	 * 99.999-999
	 * 99999999
	 */
		$.validator.addMethod("postalcodeBR", function (cep_value, element) {
			return this.optional(element) || /^\d{2}.\d{3}-\d{3}?$|^\d{5}-?\d{3}?$/.test(cep_value);
		}, "Informe um CEP válido.");
	
		/* Matches Italian postcode (CAP) */
		$.validator.addMethod("postalcodeIT", function (value, element) {
			return this.optional(element) || /^\d{5}$/.test(value);
		}, "Please specify a valid postal code");
	
		$.validator.addMethod("postalcodeNL", function (value, element) {
			return this.optional(element) || /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/.test(value);
		}, "Please specify a valid postal code");
	
		// Matches UK postcode. Does not match to UK Channel Islands that have their own postcodes (non standard UK)
		$.validator.addMethod("postcodeUK", function (value, element) {
			return this.optional(element) || /^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i.test(value);
		}, "Please specify a valid UK postcode");
	
		/*
	  * Lets you say "at least X inputs that match selector Y must be filled."
	  *
	  * The end result is that neither of these inputs:
	  *
	  *	<input class="productinfo" name="partnumber">
	  *	<input class="productinfo" name="description">
	  *
	  *	...will validate unless at least one of them is filled.
	  *
	  * partnumber:	{require_from_group: [1,".productinfo"]},
	  * description: {require_from_group: [1,".productinfo"]}
	  *
	  * options[0]: number of fields that must be filled in the group
	  * options[1]: CSS selector that defines the group of conditionally required fields
	  */
		$.validator.addMethod("require_from_group", function (value, element, options) {
			var $fields = $(options[1], element.form),
			    $fieldsFirst = $fields.eq(0),
			    validator = $fieldsFirst.data("valid_req_grp") ? $fieldsFirst.data("valid_req_grp") : $.extend({}, this),
			    isValid = $fields.filter(function () {
				return validator.elementValue(this);
			}).length >= options[0];
	
			// Store the cloned validator for future validation
			$fieldsFirst.data("valid_req_grp", validator);
	
			// If element isn't being validated, run each require_from_group field's validation rules
			if (!$(element).data("being_validated")) {
				$fields.data("being_validated", true);
				$fields.each(function () {
					validator.element(this);
				});
				$fields.data("being_validated", false);
			}
			return isValid;
		}, $.validator.format("Please fill at least {0} of these fields."));
	
		/*
	  * Lets you say "either at least X inputs that match selector Y must be filled,
	  * OR they must all be skipped (left blank)."
	  *
	  * The end result, is that none of these inputs:
	  *
	  *	<input class="productinfo" name="partnumber">
	  *	<input class="productinfo" name="description">
	  *	<input class="productinfo" name="color">
	  *
	  *	...will validate unless either at least two of them are filled,
	  *	OR none of them are.
	  *
	  * partnumber:	{skip_or_fill_minimum: [2,".productinfo"]},
	  * description: {skip_or_fill_minimum: [2,".productinfo"]},
	  * color:		{skip_or_fill_minimum: [2,".productinfo"]}
	  *
	  * options[0]: number of fields that must be filled in the group
	  * options[1]: CSS selector that defines the group of conditionally required fields
	  *
	  */
		$.validator.addMethod("skip_or_fill_minimum", function (value, element, options) {
			var $fields = $(options[1], element.form),
			    $fieldsFirst = $fields.eq(0),
			    validator = $fieldsFirst.data("valid_skip") ? $fieldsFirst.data("valid_skip") : $.extend({}, this),
			    numberFilled = $fields.filter(function () {
				return validator.elementValue(this);
			}).length,
			    isValid = numberFilled === 0 || numberFilled >= options[0];
	
			// Store the cloned validator for future validation
			$fieldsFirst.data("valid_skip", validator);
	
			// If element isn't being validated, run each skip_or_fill_minimum field's validation rules
			if (!$(element).data("being_validated")) {
				$fields.data("being_validated", true);
				$fields.each(function () {
					validator.element(this);
				});
				$fields.data("being_validated", false);
			}
			return isValid;
		}, $.validator.format("Please either skip these fields or fill at least {0} of them."));
	
		/* Validates US States and/or Territories by @jdforsythe
	  * Can be case insensitive or require capitalization - default is case insensitive
	  * Can include US Territories or not - default does not
	  * Can include US Military postal abbreviations (AA, AE, AP) - default does not
	  *
	  * Note: "States" always includes DC (District of Colombia)
	  *
	  * Usage examples:
	  *
	  *  This is the default - case insensitive, no territories, no military zones
	  *  stateInput: {
	  *     caseSensitive: false,
	  *     includeTerritories: false,
	  *     includeMilitary: false
	  *  }
	  *
	  *  Only allow capital letters, no territories, no military zones
	  *  stateInput: {
	  *     caseSensitive: false
	  *  }
	  *
	  *  Case insensitive, include territories but not military zones
	  *  stateInput: {
	  *     includeTerritories: true
	  *  }
	  *
	  *  Only allow capital letters, include territories and military zones
	  *  stateInput: {
	  *     caseSensitive: true,
	  *     includeTerritories: true,
	  *     includeMilitary: true
	  *  }
	  *
	  */
		$.validator.addMethod("stateUS", function (value, element, options) {
			var isDefault = typeof options === "undefined",
			    caseSensitive = isDefault || typeof options.caseSensitive === "undefined" ? false : options.caseSensitive,
			    includeTerritories = isDefault || typeof options.includeTerritories === "undefined" ? false : options.includeTerritories,
			    includeMilitary = isDefault || typeof options.includeMilitary === "undefined" ? false : options.includeMilitary,
			    regex;
	
			if (!includeTerritories && !includeMilitary) {
				regex = "^(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])$";
			} else if (includeTerritories && includeMilitary) {
				regex = "^(A[AEKLPRSZ]|C[AOT]|D[CE]|FL|G[AU]|HI|I[ADLN]|K[SY]|LA|M[ADEINOPST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$";
			} else if (includeTerritories) {
				regex = "^(A[KLRSZ]|C[AOT]|D[CE]|FL|G[AU]|HI|I[ADLN]|K[SY]|LA|M[ADEINOPST]|N[CDEHJMVY]|O[HKR]|P[AR]|RI|S[CD]|T[NX]|UT|V[AIT]|W[AIVY])$";
			} else {
				regex = "^(A[AEKLPRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])$";
			}
	
			regex = caseSensitive ? new RegExp(regex) : new RegExp(regex, "i");
			return this.optional(element) || regex.test(value);
		}, "Please specify a valid state");
	
		// TODO check if value starts with <, otherwise don't try stripping anything
		$.validator.addMethod("strippedminlength", function (value, element, param) {
			return $(value).text().length >= param;
		}, $.validator.format("Please enter at least {0} characters"));
	
		$.validator.addMethod("time", function (value, element) {
			return this.optional(element) || /^([01]\d|2[0-3]|[0-9])(:[0-5]\d){1,2}$/.test(value);
		}, "Please enter a valid time, between 00:00 and 23:59");
	
		$.validator.addMethod("time12h", function (value, element) {
			return this.optional(element) || /^((0?[1-9]|1[012])(:[0-5]\d){1,2}(\ ?[AP]M))$/i.test(value);
		}, "Please enter a valid time in 12-hour am/pm format");
	
		// Same as url, but TLD is optional
		$.validator.addMethod("url2", function (value, element) {
			return this.optional(element) || /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)*(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
		}, $.validator.messages.url);
	
		/**
	  * Return true, if the value is a valid vehicle identification number (VIN).
	  *
	  * Works with all kind of text inputs.
	  *
	  * @example <input type="text" size="20" name="VehicleID" class="{required:true,vinUS:true}" />
	  * @desc Declares a required input element whose value must be a valid vehicle identification number.
	  *
	  * @name $.validator.methods.vinUS
	  * @type Boolean
	  * @cat Plugins/Validate/Methods
	  */
		$.validator.addMethod("vinUS", function (v) {
			if (v.length !== 17) {
				return false;
			}
	
			var LL = ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "P", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
			    VL = [1, 2, 3, 4, 5, 6, 7, 8, 1, 2, 3, 4, 5, 7, 9, 2, 3, 4, 5, 6, 7, 8, 9],
			    FL = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2],
			    rs = 0,
			    i,
			    n,
			    d,
			    f,
			    cd,
			    cdv;
	
			for (i = 0; i < 17; i++) {
				f = FL[i];
				d = v.slice(i, i + 1);
				if (i === 8) {
					cdv = d;
				}
				if (!isNaN(d)) {
					d *= f;
				} else {
					for (n = 0; n < LL.length; n++) {
						if (d.toUpperCase() === LL[n]) {
							d = VL[n];
							d *= f;
							if (isNaN(cdv) && n === 8) {
								cdv = LL[n];
							}
							break;
						}
					}
				}
				rs += d;
			}
			cd = rs % 11;
			if (cd === 10) {
				cd = "X";
			}
			if (cd === cdv) {
				return true;
			}
			return false;
		}, "The specified vehicle identification number (VIN) is invalid.");
	
		$.validator.addMethod("zipcodeUS", function (value, element) {
			return this.optional(element) || /^\d{5}(-\d{4})?$/.test(value);
		}, "The specified US ZIP Code is invalid");
	
		$.validator.addMethod("ziprange", function (value, element) {
			return this.optional(element) || /^90[2-5]\d\{2\}-\d{4}$/.test(value);
		}, "Your ZIP-code must be in the range 902xx-xxxx to 905xx-xxxx");
	
		$.validator.addMethod("required", function (value, element) {
			if ($.trim(value) == "") {
				return false;
			} else {
				return true;
			}
		}, "This field is required");
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)(module)))

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function ($, undefined) {
	
	    var _input = document.createElement('input');
	
	    var _support = {
	        setSelectionRange: 'setSelectionRange' in _input || 'selectionStart' in _input,
	        createTextRange: 'createTextRange' in _input || 'selection' in document
	    };
	
	    var _rNewlineIE = /\r\n/g,
	        _rCarriageReturn = /\r/g;
	
	    var _getValue = function _getValue(input) {
	        if (typeof input.value !== 'undefined') {
	            return input.value;
	        }
	        return $(input).text();
	    };
	
	    var _setValue = function _setValue(input, value) {
	        if (typeof input.value !== 'undefined') {
	            input.value = value;
	        } else {
	            $(input).text(value);
	        }
	    };
	
	    var _getIndex = function _getIndex(input, pos) {
	        var norm = _getValue(input).replace(_rCarriageReturn, '');
	        var len = norm.length;
	
	        if (typeof pos === 'undefined') {
	            pos = len;
	        }
	
	        pos = Math.floor(pos);
	
	        // Negative index counts backward from the end of the input/textarea's value
	        if (pos < 0) {
	            pos = len + pos;
	        }
	
	        // Enforce boundaries
	        if (pos < 0) {
	            pos = 0;
	        }
	        if (pos > len) {
	            pos = len;
	        }
	
	        return pos;
	    };
	
	    var _hasAttr = function _hasAttr(input, attrName) {
	        return input.hasAttribute ? input.hasAttribute(attrName) : typeof input[attrName] !== 'undefined';
	    };
	
	    /**
	     * @class
	     * @constructor
	     */
	    var Range = function Range(start, end, length, text) {
	        this.start = start || 0;
	        this.end = end || 0;
	        this.length = length || 0;
	        this.text = text || '';
	    };
	
	    Range.prototype.toString = function () {
	        return JSON.stringify(this, null, '    ');
	    };
	
	    var _getCaretW3 = function _getCaretW3(input) {
	        return input.selectionStart;
	    };
	
	    /**
	     * @see http://stackoverflow.com/q/6943000/467582
	     */
	    var _getCaretIE = function _getCaretIE(input) {
	        var caret, range, textInputRange, rawValue, len, endRange;
	
	        // Yeah, you have to focus twice for IE 7 and 8.  *cries*
	        input.focus();
	        input.focus();
	
	        range = document.selection.createRange();
	
	        if (range && range.parentElement() === input) {
	            rawValue = _getValue(input);
	
	            len = rawValue.length;
	
	            // Create a working TextRange that lives only in the input
	            textInputRange = input.createTextRange();
	            textInputRange.moveToBookmark(range.getBookmark());
	
	            // Check if the start and end of the selection are at the very end
	            // of the input, since moveStart/moveEnd doesn't return what we want
	            // in those cases
	            endRange = input.createTextRange();
	            endRange.collapse(false);
	
	            if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
	                caret = rawValue.replace(_rNewlineIE, '\n').length;
	            } else {
	                caret = -textInputRange.moveStart("character", -len);
	            }
	
	            return caret;
	        }
	
	        // TODO: This can occur when you highlight part of a textarea and then click in the middle of the highlighted portion in IE 6-10
	        //        alert("Your browser is incredibly stupid.  I don't know what else to say.");
	        //        alert(range + '\n\n' + range.parentElement().tagName + '#' + range.parentElement().id);
	
	        return 0;
	    };
	
	    /**
	     * Gets the position of the caret in the given input.
	     * @param {HTMLInputElement|HTMLTextAreaElement} input input or textarea element
	     * @returns {Number}
	     * @see http://stackoverflow.com/questions/263743/how-to-get-cursor-position-in-textarea/263796#263796
	     */
	    var _getCaret = function _getCaret(input) {
	        if (!input) {
	            return undefined;
	        }
	
	        // Mozilla, et al.
	        if (_support.setSelectionRange) {
	            return _getCaretW3(input);
	        }
	        // IE
	        else if (_support.createTextRange) {
	                return _getCaretIE(input);
	            }
	
	        return undefined;
	    };
	
	    var _setCaretW3 = function _setCaretW3(input, pos) {
	        input.setSelectionRange(pos, pos);
	    };
	
	    var _setCaretIE = function _setCaretIE(input, pos) {
	        var range = input.createTextRange();
	        range.move('character', pos);
	        range.select();
	    };
	
	    /**
	     * Sets the position of the caret in the given input.
	     * @param {HTMLInputElement|HTMLTextAreaElement} input input or textarea element
	     * @param {Number} pos
	     * @see http://parentnode.org/javascript/working-with-the-cursor-position/
	     */
	    var _setCaret = function _setCaret(input, pos) {
	        input.focus();
	
	        pos = _getIndex(input, pos);
	
	        // Mozilla, et al.
	        if (_support.setSelectionRange) {
	            _setCaretW3(input, pos);
	        }
	        // IE
	        else if (_support.createTextRange) {
	                _setCaretIE(input, pos);
	            }
	    };
	
	    /**
	     * Inserts the specified text at the current caret position in the given input.
	     * @param {HTMLInputElement|HTMLTextAreaElement} input input or textarea element
	     * @param {String} text
	     * @see http://parentnode.org/javascript/working-with-the-cursor-position/
	     */
	    var _insertAtCaret = function _insertAtCaret(input, text) {
	        var curPos = _getCaret(input);
	
	        var oldValueNorm = _getValue(input).replace(_rCarriageReturn, '');
	
	        var newLength = +(curPos + text.length + (oldValueNorm.length - curPos));
	        var maxLength = +input.getAttribute('maxlength');
	
	        if (_hasAttr(input, 'maxlength') && newLength > maxLength) {
	            var delta = text.length - (newLength - maxLength);
	            text = text.substr(0, delta);
	        }
	
	        _setValue(input, oldValueNorm.substr(0, curPos) + text + oldValueNorm.substr(curPos));
	
	        _setCaret(input, curPos + text.length);
	    };
	
	    var _getInputRangeW3 = function _getInputRangeW3(input) {
	        var range = new Range();
	
	        range.start = input.selectionStart;
	        range.end = input.selectionEnd;
	
	        var min = Math.min(range.start, range.end);
	        var max = Math.max(range.start, range.end);
	
	        range.length = max - min;
	        range.text = _getValue(input).substring(min, max);
	
	        return range;
	    };
	
	    /** @see http://stackoverflow.com/a/3648244/467582 */
	    var _getInputRangeIE = function _getInputRangeIE(input) {
	        var range = new Range();
	
	        input.focus();
	
	        var selection = document.selection.createRange();
	
	        if (selection && selection.parentElement() === input) {
	            var len,
	                normalizedValue,
	                textInputRange,
	                endRange,
	                start = 0,
	                end = 0;
	            var rawValue = _getValue(input);
	
	            len = rawValue.length;
	            normalizedValue = rawValue.replace(/\r\n/g, "\n");
	
	            // Create a working TextRange that lives only in the input
	            textInputRange = input.createTextRange();
	            textInputRange.moveToBookmark(selection.getBookmark());
	
	            // Check if the start and end of the selection are at the very end
	            // of the input, since moveStart/moveEnd doesn't return what we want
	            // in those cases
	            endRange = input.createTextRange();
	            endRange.collapse(false);
	
	            if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
	                start = end = len;
	            } else {
	                start = -textInputRange.moveStart("character", -len);
	                start += normalizedValue.slice(0, start).split("\n").length - 1;
	
	                if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
	                    end = len;
	                } else {
	                    end = -textInputRange.moveEnd("character", -len);
	                    end += normalizedValue.slice(0, end).split("\n").length - 1;
	                }
	            }
	
	            /// normalize newlines
	            start -= rawValue.substring(0, start).split('\r\n').length - 1;
	            end -= rawValue.substring(0, end).split('\r\n').length - 1;
	            /// normalize newlines
	
	            range.start = start;
	            range.end = end;
	            range.length = range.end - range.start;
	            range.text = normalizedValue.substr(range.start, range.length);
	        }
	
	        return range;
	    };
	
	    /**
	     * Gets the selected text range of the given input.
	     * @param {HTMLInputElement|HTMLTextAreaElement} input input or textarea element
	     * @returns {Range}
	     * @see http://stackoverflow.com/a/263796/467582
	     * @see http://stackoverflow.com/a/2966703/467582
	     */
	    var _getInputRange = function _getInputRange(input) {
	        if (!input) {
	            return undefined;
	        }
	
	        // Mozilla, et al.
	        if (_support.setSelectionRange) {
	            return _getInputRangeW3(input);
	        }
	        // IE
	        else if (_support.createTextRange) {
	                return _getInputRangeIE(input);
	            }
	
	        return undefined;
	    };
	
	    var _setInputRangeW3 = function _setInputRangeW3(input, startPos, endPos) {
	        input.setSelectionRange(startPos, endPos);
	    };
	
	    var _setInputRangeIE = function _setInputRangeIE(input, startPos, endPos) {
	        var i;
	        var tr = input.createTextRange();
	        var rawValue = _getValue(input);
	
	        // Fix IE from counting the newline characters as two separate characters
	        var stop_it = startPos;
	
	        // TODO: Optimize this awful code
	        for (i = 0; i < stop_it; i++) {
	            if (rawValue.substr(i, 1).search(_rNewlineIE) !== -1) {
	                startPos = startPos - 1;
	            }
	        }
	
	        stop_it = endPos;
	
	        // TODO: Optimize this awful code
	        for (i = 0; i < stop_it; i++) {
	            if (rawValue.substr(i, 1).search(_rNewlineIE) !== -1) {
	                endPos = endPos - 1;
	            }
	        }
	
	        tr.moveEnd('textedit', -1);
	        tr.moveStart('character', startPos);
	        tr.moveEnd('character', endPos - startPos);
	        tr.select();
	    };
	
	    /**
	     * Sets the selected text range of (i.e., highlights text in) the given input.
	     * @param {HTMLInputElement|HTMLTextAreaElement} input input or textarea element
	     * @param {Number} startPos Zero-based index
	     * @param {Number} endPos Zero-based index
	     * @see http://parentnode.org/javascript/working-with-the-cursor-position/
	     * @see http://stackoverflow.com/a/2966703/467582
	     */
	    var _setInputRange = function _setInputRange(input, startPos, endPos) {
	        startPos = _getIndex(input, startPos);
	        endPos = _getIndex(input, endPos);
	
	        // Mozilla, et al.
	        if (_support.setSelectionRange) {
	            _setInputRangeW3(input, startPos, endPos);
	        }
	        // IE
	        else if (_support.createTextRange) {
	                _setInputRangeIE(input, startPos, endPos);
	            }
	    };
	
	    /**
	     * Replaces the currently selected text with the given string.
	     * @param {HTMLInputElement|HTMLTextAreaElement} input input or textarea element
	     * @param {String} text New text that will replace the currently selected text.
	     * @see http://parentnode.org/javascript/working-with-the-cursor-position/
	     */
	    var _replaceInputRange = function _replaceInputRange(input, text) {
	        var $input = $(input);
	
	        var oldValue = $input.val();
	        var selection = _getInputRange(input);
	
	        var newLength = +(selection.start + text.length + (oldValue.length - selection.end));
	        var maxLength = +$input.attr('maxlength');
	
	        if ($input.is('[maxlength]') && newLength > maxLength) {
	            var delta = text.length - (newLength - maxLength);
	            text = text.substr(0, delta);
	        }
	
	        // Now that we know what the user selected, we can replace it
	        var startText = oldValue.substr(0, selection.start);
	        var endText = oldValue.substr(selection.end);
	
	        $input.val(startText + text + endText);
	
	        // Reset the selection
	        var startPos = selection.start;
	        var endPos = startPos + text.length;
	
	        _setInputRange(input, selection.length ? startPos : endPos, endPos);
	    };
	
	    var _selectAllW3 = function _selectAllW3(elem) {
	        var selection = window.getSelection();
	        var range = document.createRange();
	        range.selectNodeContents(elem);
	        selection.removeAllRanges();
	        selection.addRange(range);
	    };
	
	    var _selectAllIE = function _selectAllIE(elem) {
	        var range = document.body.createTextRange();
	        range.moveToElementText(elem);
	        range.select();
	    };
	
	    /**
	     * Select all text in the given element.
	     * @param {HTMLElement} elem Any block or inline element other than a form element.
	     */
	    var _selectAll = function _selectAll(elem) {
	        var $elem = $(elem);
	        if ($elem.is('input, textarea') || elem.select) {
	            $elem.select();
	            return;
	        }
	
	        // Mozilla, et al.
	        if (_support.setSelectionRange) {
	            _selectAllW3(elem);
	        }
	        // IE
	        else if (_support.createTextRange) {
	                _selectAllIE(elem);
	            }
	    };
	
	    var _deselectAll = function _deselectAll() {
	        if (document.selection) {
	            document.selection.empty();
	        } else if (window.getSelection) {
	            window.getSelection().removeAllRanges();
	        }
	    };
	
	    $.fn.extend({
	
	        /**
	         * Gets or sets the position of the caret or inserts text at the current caret position in an input or textarea element.
	         * @returns {Number|jQuery} The current caret position if invoked as a getter (with no arguments)
	         * or this jQuery object if invoked as a setter or inserter.
	         * @see http://web.archive.org/web/20080704185920/http://parentnode.org/javascript/working-with-the-cursor-position/
	         * @since 1.0.0
	         * @example
	         * <pre>
	         *    // Get position
	         *    var pos = $('input:first').caret();
	         * </pre>
	         * @example
	         * <pre>
	         *    // Set position
	         *    $('input:first').caret(15);
	         *    $('input:first').caret(-3);
	         * </pre>
	         * @example
	         * <pre>
	         *    // Insert text at current position
	         *    $('input:first').caret('Some text');
	         * </pre>
	         */
	        caret: function caret() {
	            var $inputs = this.filter('input, textarea');
	
	            // getCaret()
	            if (arguments.length === 0) {
	                var input = $inputs.get(0);
	                return _getCaret(input);
	            }
	            // setCaret(position)
	            else if (typeof arguments[0] === 'number') {
	                    var pos = arguments[0];
	                    $inputs.each(function (_i, input) {
	                        _setCaret(input, pos);
	                    });
	                }
	                // insertAtCaret(text)
	                else {
	                        var text = arguments[0];
	                        $inputs.each(function (_i, input) {
	                            _insertAtCaret(input, text);
	                        });
	                    }
	
	            return this;
	        },
	
	        /**
	         * Gets or sets the selection range or replaces the currently selected text in an input or textarea element.
	         * @returns {Range|jQuery} The current selection range if invoked as a getter (with no arguments)
	         * or this jQuery object if invoked as a setter or replacer.
	         * @see http://stackoverflow.com/a/2966703/467582
	         * @since 1.0.0
	         * @example
	         * <pre>
	         *    // Get selection range
	         *    var range = $('input:first').range();
	         * </pre>
	         * @example
	         * <pre>
	         *    // Set selection range
	         *    $('input:first').range(15);
	         *    $('input:first').range(15, 20);
	         *    $('input:first').range(-3);
	         *    $('input:first').range(-8, -3);
	         * </pre>
	         * @example
	         * <pre>
	         *    // Replace the currently selected text
	         *    $('input:first').range('Replacement text');
	         * </pre>
	         */
	        range: function range() {
	            var $inputs = this.filter('input, textarea');
	
	            // getRange() = { start: pos, end: pos }
	            if (arguments.length === 0) {
	                var input = $inputs.get(0);
	                return _getInputRange(input);
	            }
	            // setRange(startPos, endPos)
	            else if (typeof arguments[0] === 'number') {
	                    var startPos = arguments[0];
	                    var endPos = arguments[1];
	                    $inputs.each(function (_i, input) {
	                        _setInputRange(input, startPos, endPos);
	                    });
	                }
	                // replaceRange(text)
	                else {
	                        var text = arguments[0];
	                        $inputs.each(function (_i, input) {
	                            _replaceInputRange(input, text);
	                        });
	                    }
	
	            return this;
	        },
	
	        /**
	         * Selects all text in each element of this jQuery object.
	         * @returns {jQuery} This jQuery object
	         * @see http://stackoverflow.com/a/11128179/467582
	         * @since 1.5.0
	         * @example
	         * <pre>
	         *     // Select the contents of span elements when clicked
	         *     $('span').on('click', function() { $(this).highlight(); });
	         * </pre>
	         */
	        selectAll: function selectAll() {
	            return this.each(function (_i, elem) {
	                _selectAll(elem);
	            });
	        }
	
	    });
	
	    $.extend({
	        /**
	         * Deselects all text on the page.
	         * @returns {jQuery} The jQuery function
	         * @since 1.5.0
	         * @example
	         * <pre>
	         *     // Select some text
	         *     $('span').selectAll();
	         *
	         *     // Deselect the text
	         *     $.deselectAll();
	         * </pre>
	         */
	        deselectAll: function deselectAll() {
	            _deselectAll();
	            return this;
	        }
	    });
	})(_jquery2.default); /*! jQuery Caret Plugin - v1.5.0 - 2013-10-16
	                       * https://github.com/acdvorak/jquery.caret
	                       * Copyright (c) 2012-2013 Andrew C. Dvorak; Licensed MIT */

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 *	jQuery dotdotdot 1.8.3
	 *
	 *	Copyright (c) Fred Heusschen
	 *	www.frebsite.nl
	 *
	 *	Plugin website:
	 *	dotdotdot.frebsite.nl
	 *
	 *	Licensed under the MIT license.
	 *	http://en.wikipedia.org/wiki/MIT_License
	 */
	var jQuery = __webpack_require__(1);
	
	(function ($, undef) {
	  if ($.fn.dotdotdot) {
	    return;
	  }
	
	  $.fn.dotdotdot = function (o) {
	    if (this.length == 0) {
	      $.fn.dotdotdot.debug('No element found for "' + this.selector + '".');
	      return this;
	    }
	    if (this.length > 1) {
	      return this.each(function () {
	        $(this).dotdotdot(o);
	      });
	    }
	
	    var $dot = this;
	    var orgContent = $dot.contents();
	
	    if ($dot.data('dotdotdot')) {
	      $dot.trigger('destroy.dot');
	    }
	
	    $dot.data('dotdotdot-style', $dot.attr('style') || '');
	    $dot.css('word-wrap', 'break-word');
	    if ($dot.css('white-space') === 'nowrap') {
	      $dot.css('white-space', 'normal');
	    }
	
	    $dot.bind_events = function () {
	      $dot.bind('update.dot', function (e, c) {
	        $dot.removeClass("is-truncated");
	        e.preventDefault();
	        e.stopPropagation();
	
	        switch (_typeof(opts.height)) {
	          case 'number':
	            opts.maxHeight = opts.height;
	            break;
	
	          case 'function':
	            opts.maxHeight = opts.height.call($dot[0]);
	            break;
	
	          default:
	            opts.maxHeight = getTrueInnerHeight($dot);
	            break;
	        }
	
	        opts.maxHeight += opts.tolerance;
	
	        if (typeof c != 'undefined') {
	          if (typeof c == 'string' || 'nodeType' in c && c.nodeType === 1) {
	            c = $('<div />').append(c).contents();
	          }
	          if (c instanceof $) {
	            orgContent = c;
	          }
	        }
	
	        $inr = $dot.wrapInner('<div class="dotdotdot" />').children();
	        $inr.contents().detach().end().append(orgContent.clone(true)).find('br').replaceWith('  <br />  ').end().css({
	          'height': 'auto',
	          'width': 'auto',
	          'border': 'none',
	          'padding': 0,
	          'margin': 0
	        });
	
	        var after = false,
	            trunc = false;
	
	        if (conf.afterElement) {
	          after = conf.afterElement.clone(true);
	          after.show();
	          conf.afterElement.detach();
	        }
	
	        if (test($inr, opts)) {
	          if (opts.wrap == 'children') {
	            trunc = children($inr, opts, after);
	          } else {
	            trunc = ellipsis($inr, $dot, $inr, opts, after);
	          }
	        }
	        $inr.replaceWith($inr.contents());
	        $inr = null;
	
	        if ($.isFunction(opts.callback)) {
	          opts.callback.call($dot[0], trunc, orgContent);
	        }
	
	        conf.isTruncated = trunc;
	        return trunc;
	      }).bind('isTruncated.dot', function (e, fn) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        if (typeof fn == 'function') {
	          fn.call($dot[0], conf.isTruncated);
	        }
	        return conf.isTruncated;
	      }).bind('originalContent.dot', function (e, fn) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        if (typeof fn == 'function') {
	          fn.call($dot[0], orgContent);
	        }
	        return orgContent;
	      }).bind('destroy.dot', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        $dot.unwatch().unbind_events().contents().detach().end().append(orgContent).attr('style', $dot.data('dotdotdot-style') || '').removeClass('is-truncated').data('dotdotdot', false);
	      });
	      return $dot;
	    }; //	/bind_events
	
	    $dot.unbind_events = function () {
	      $dot.unbind('.dot');
	      return $dot;
	    }; //	/unbind_events
	
	    $dot.watch = function () {
	      $dot.unwatch();
	      if (opts.watch == 'window') {
	        var $window = $(window),
	            _wWidth = $window.width(),
	            _wHeight = $window.height();
	
	        $window.bind('resize.dot' + conf.dotId, function () {
	          if (_wWidth != $window.width() || _wHeight != $window.height() || !opts.windowResizeFix) {
	            _wWidth = $window.width();
	            _wHeight = $window.height();
	
	            if (watchInt) {
	              clearInterval(watchInt);
	            }
	            watchInt = setTimeout(function () {
	              $dot.trigger('update.dot');
	            }, 100);
	          }
	        });
	      } else {
	        watchOrg = getSizes($dot);
	        watchInt = setInterval(function () {
	          if ($dot.is(':visible')) {
	            var watchNew = getSizes($dot);
	            if (watchOrg.width != watchNew.width || watchOrg.height != watchNew.height) {
	              $dot.trigger('update.dot');
	              watchOrg = watchNew;
	            }
	          }
	        }, 500);
	      }
	      return $dot;
	    };
	    $dot.unwatch = function () {
	      $(window).unbind('resize.dot' + conf.dotId);
	      if (watchInt) {
	        clearInterval(watchInt);
	      }
	      return $dot;
	    };
	
	    var opts = $.extend(true, {}, $.fn.dotdotdot.defaults, o),
	        conf = {},
	        watchOrg = {},
	        watchInt = null,
	        $inr = null;
	
	    if (!(opts.lastCharacter.remove instanceof Array)) {
	      opts.lastCharacter.remove = $.fn.dotdotdot.defaultArrays.lastCharacter.remove;
	    }
	    if (!(opts.lastCharacter.noEllipsis instanceof Array)) {
	      opts.lastCharacter.noEllipsis = $.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis;
	    }
	
	    conf.afterElement = getElement(opts.after, $dot);
	    conf.isTruncated = false;
	    conf.dotId = dotId++;
	
	    $dot.data('dotdotdot', true).bind_events().trigger('update.dot');
	
	    if (opts.watch) {
	      $dot.watch();
	    }
	
	    return $dot;
	  };
	
	  //	public
	  $.fn.dotdotdot.defaults = {
	    'ellipsis': '... ',
	    'wrap': 'word',
	    'fallbackToLetter': true,
	    'lastCharacter': {},
	    'tolerance': 0,
	    'callback': null,
	    'after': null,
	    'height': null,
	    'watch': false,
	    'windowResizeFix': true
	  };
	  $.fn.dotdotdot.defaultArrays = {
	    'lastCharacter': {
	      'remove': [' ', '\u3000', ',', ';', '.', '!', '?'],
	      'noEllipsis': []
	    }
	  };
	  $.fn.dotdotdot.debug = function (msg) {};
	
	  //	private
	  var dotId = 1;
	
	  function children($elem, o, after) {
	    var $elements = $elem.children(),
	        isTruncated = false;
	
	    $elem.empty();
	
	    for (var a = 0, l = $elements.length; a < l; a++) {
	      var $e = $elements.eq(a);
	      $elem.append($e);
	      if (after) {
	        $elem.append(after);
	      }
	      if (test($elem, o)) {
	        $e.remove();
	        isTruncated = true;
	        break;
	      } else {
	        if (after) {
	          after.detach();
	        }
	      }
	    }
	    return isTruncated;
	  }
	  function ellipsis($elem, $d, $i, o, after) {
	    var isTruncated = false;
	
	    //	Don't put the ellipsis directly inside these elements
	    var notx = 'a, table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style';
	
	    //	Don't remove these elements even if they are after the ellipsis
	    var noty = 'script, .dotdotdot-keep';
	
	    $elem.contents().detach().each(function () {
	
	      var e = this,
	          $e = $(e);
	
	      if (typeof e == 'undefined') {
	        return true;
	      } else if ($e.is(noty)) {
	        $elem.append($e);
	      } else if (isTruncated) {
	        return true;
	      } else {
	        $elem.append($e);
	        if (after && !$e.is(o.after) && !$e.find(o.after).length) {
	          $elem[$elem.is(notx) ? 'after' : 'append'](after);
	        }
	        if (test($i, o)) {
	          if (e.nodeType == 3) // node is TEXT
	            {
	              isTruncated = ellipsisElement($e, $d, $i, o, after);
	            } else {
	            isTruncated = ellipsis($e, $d, $i, o, after);
	          }
	        }
	
	        if (!isTruncated) {
	          if (after) {
	            after.detach();
	          }
	        }
	      }
	    });
	    $d.addClass("is-truncated");
	    return isTruncated;
	  }
	  function ellipsisElement($e, $d, $i, o, after) {
	    var e = $e[0];
	
	    if (!e) {
	      return false;
	    }
	
	    var txt = getTextContent(e),
	        space = txt.indexOf(' ') !== -1 ? ' ' : '\u3000',
	        separator = o.wrap == 'letter' ? '' : space,
	        textArr = txt.split(separator),
	        position = -1,
	        midPos = -1,
	        startPos = 0,
	        endPos = textArr.length - 1;
	
	    //	Only one word
	    if (o.fallbackToLetter && startPos == 0 && endPos == 0) {
	      separator = '';
	      textArr = txt.split(separator);
	      endPos = textArr.length - 1;
	    }
	
	    while (startPos <= endPos && !(startPos == 0 && endPos == 0)) {
	      var m = Math.floor((startPos + endPos) / 2);
	      if (m == midPos) {
	        break;
	      }
	      midPos = m;
	
	      setTextContent(e, textArr.slice(0, midPos + 1).join(separator) + o.ellipsis);
	      $i.children().each(function () {
	        $(this).toggle().toggle();
	      });
	
	      if (!test($i, o)) {
	        position = midPos;
	        startPos = midPos;
	      } else {
	        endPos = midPos;
	
	        //	Fallback to letter
	        if (o.fallbackToLetter && startPos == 0 && endPos == 0) {
	          separator = '';
	          textArr = textArr[0].split(separator);
	          position = -1;
	          midPos = -1;
	          startPos = 0;
	          endPos = textArr.length - 1;
	        }
	      }
	    }
	
	    if (position != -1 && !(textArr.length == 1 && textArr[0].length == 0)) {
	      txt = addEllipsis(textArr.slice(0, position + 1).join(separator), o);
	      setTextContent(e, txt);
	    } else {
	      var $w = $e.parent();
	      $e.detach();
	
	      var afterLength = after && after.closest($w).length ? after.length : 0;
	
	      if ($w.contents().length > afterLength) {
	        e = findLastTextNode($w.contents().eq(-1 - afterLength), $d);
	      } else {
	        e = findLastTextNode($w, $d, true);
	        if (!afterLength) {
	          $w.detach();
	        }
	      }
	      if (e) {
	        txt = addEllipsis(getTextContent(e), o);
	        setTextContent(e, txt);
	        if (afterLength && after) {
	          var $parent = after.parent();
	
	          $(e).parent().append(after);
	
	          if (!$.trim($parent.html())) {
	            $parent.remove();
	          }
	        }
	      }
	    }
	
	    return true;
	  }
	  function test($i, o) {
	    return $i.innerHeight() > o.maxHeight;
	  }
	  function addEllipsis(txt, o) {
	    while ($.inArray(txt.slice(-1), o.lastCharacter.remove) > -1) {
	      txt = txt.slice(0, -1);
	    }
	    if ($.inArray(txt.slice(-1), o.lastCharacter.noEllipsis) < 0) {
	      txt += o.ellipsis;
	    }
	    return txt;
	  }
	  function getSizes($d) {
	    return {
	      'width': $d.innerWidth(),
	      'height': $d.innerHeight()
	    };
	  }
	  function setTextContent(e, content) {
	    if (e.innerText) {
	      e.innerText = content;
	    } else if (e.nodeValue) {
	      e.nodeValue = content;
	    } else if (e.textContent) {
	      e.textContent = content;
	    }
	  }
	  function getTextContent(e) {
	    if (e.innerText) {
	      return e.innerText;
	    } else if (e.nodeValue) {
	      return e.nodeValue;
	    } else if (e.textContent) {
	      return e.textContent;
	    } else {
	      return "";
	    }
	  }
	  function getPrevNode(n) {
	    do {
	      n = n.previousSibling;
	    } while (n && n.nodeType !== 1 && n.nodeType !== 3);
	
	    return n;
	  }
	  function findLastTextNode($el, $top, excludeCurrent) {
	    var e = $el && $el[0],
	        p;
	    if (e) {
	      if (!excludeCurrent) {
	        if (e.nodeType === 3) {
	          return e;
	        }
	        if ($.trim($el.text())) {
	          return findLastTextNode($el.contents().last(), $top);
	        }
	      }
	      p = getPrevNode(e);
	      while (!p) {
	        $el = $el.parent();
	        if ($el.is($top) || !$el.length) {
	          return false;
	        }
	        p = getPrevNode($el[0]);
	      }
	      if (p) {
	        return findLastTextNode($(p), $top);
	      }
	    }
	    return false;
	  }
	  function getElement(e, $i) {
	    if (!e) {
	      return false;
	    }
	    if (typeof e === 'string') {
	      e = $(e, $i);
	      return e.length ? e : false;
	    }
	    return !e.jquery ? false : e;
	  }
	  function getTrueInnerHeight($el) {
	    var h = $el.innerHeight(),
	        a = ['paddingTop', 'paddingBottom'];
	
	    for (var z = 0, l = a.length; z < l; z++) {
	      var m = parseInt($el.css(a[z]), 10);
	      if (isNaN(m)) {
	        m = 0;
	      }
	      h -= m;
	    }
	    return h;
	  }
	
	  //	override jQuery.html
	  var _orgHtml = $.fn.html;
	  $.fn.html = function (str) {
	    if (str != undef && !$.isFunction(str) && this.data('dotdotdot')) {
	      return this.trigger('update', [str]);
	    }
	    return _orgHtml.apply(this, arguments);
	  };
	
	  //	override jQuery.text
	  var _orgText = $.fn.text;
	  $.fn.text = function (str) {
	    if (str != undef && !$.isFunction(str) && this.data('dotdotdot')) {
	      str = $('<div />').text(str).html();
	      return this.trigger('update', [str]);
	    }
	    return _orgText.apply(this, arguments);
	  };
	})(jQuery);
	
	/*
	
	 ## Automatic parsing for CSS classes
	 Contributed by [Ramil Valitov](https://github.com/rvalitov)
	
	 ### The idea
	 You can add one or several CSS classes to HTML elements to automatically invoke "jQuery.dotdotdot functionality" and some extra features. It allows to use jQuery.dotdotdot only by adding appropriate CSS classes without JS programming.
	
	 ### Available classes and their description
	 * dot-ellipsis - automatically invoke jQuery.dotdotdot to this element. This class must be included if you plan to use other classes below.
	 * dot-resize-update - automatically update if window resize event occurs. It's equivalent to option `watch:'window'`.
	 * dot-timer-update - automatically update if window resize event occurs. It's equivalent to option `watch:true`.
	 * dot-load-update - automatically update after the window has beem completely rendered. Can be useful if your content is generated dynamically using using JS and, hence, jQuery.dotdotdot can't correctly detect the height of the element before it's rendered completely.
	 * dot-height-XXX - available height of content area in pixels, where XXX is a number, e.g. can be `dot-height-35` if you want to set maximum height for 35 pixels. It's equivalent to option `height:'XXX'`.
	
	 ### Usage examples
	 *Adding jQuery.dotdotdot to element*
	
	 <div class="dot-ellipsis">
	 <p>Lorem Ipsum is simply dummy text.</p>
	 </div>
	
	 *Adding jQuery.dotdotdot to element with update on window resize*
	
	 <div class="dot-ellipsis dot-resize-update">
	 <p>Lorem Ipsum is simply dummy text.</p>
	 </div>
	
	 *Adding jQuery.dotdotdot to element with predefined height of 50px*
	
	 <div class="dot-ellipsis dot-height-50">
	 <p>Lorem Ipsum is simply dummy text.</p>
	 </div>
	
	 */
	
	jQuery(document).ready(function ($) {
	  //We only invoke jQuery.dotdotdot on elements that have dot-ellipsis class
	  $(".dot-ellipsis").each(function () {
	    //Checking if update on window resize required
	    var watch_window = $(this).hasClass("dot-resize-update");
	
	    //Checking if update on timer required
	    var watch_timer = $(this).hasClass("dot-timer-update");
	
	    //Checking if height set
	    var height = 0;
	    var classList = $(this).attr('class').split(/\s+/);
	    $.each(classList, function (index, item) {
	      var matchResult = item.match(/^dot-height-(\d+)$/);
	      if (matchResult !== null) height = Number(matchResult[1]);
	    });
	
	    //Invoking jQuery.dotdotdot
	    var x = new Object();
	    if (watch_timer) x.watch = true;
	    if (watch_window) x.watch = 'window';
	    if (height > 0) x.height = height;
	    $(this).dotdotdot(x);
	  });
	});
	
	//Updating elements (if any) on window.load event
	jQuery(window).on('load', function () {
	  jQuery(".dot-ellipsis.dot-load-update").trigger("update.dot");
	});

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! powerbi-client v2.10.3 | (c) 2016 Microsoft Corporation MIT */
	!function (t, e) {
	  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["powerbi-client"] = e() : t["powerbi-client"] = e();
	}(undefined, function () {
	  return function (t) {
	    function e(a) {
	      if (r[a]) return r[a].exports;var i = r[a] = { exports: {}, id: a, loaded: !1 };return t[a].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
	    }var r = {};return e.m = t, e.c = r, e.p = "", e(0);
	  }([function (t, e, r) {
	    var a = r(1);e.service = a;var i = r(17);e.factories = i;var o = r(5);e.models = o;var n = r(6);e.Report = n.Report;var l = r(13);e.Dashboard = l.Dashboard;var s = r(14);e.Tile = s.Tile;var d = r(2);e.Embed = d.Embed;var u = r(8);e.Page = u.Page;var p = r(15);e.Qna = p.Qna;var c = r(16);e.Visual = c.Visual;var f = r(9);e.VisualDescriptor = f.VisualDescriptor;var h = new a.Service(i.hpmFactory, i.wpmpFactory, i.routerFactory);window.powerbi = h;
	  }, function (t, e, r) {
	    var a = r(2),
	        i = r(6),
	        o = r(12),
	        n = r(13),
	        l = r(14),
	        s = r(8),
	        d = r(15),
	        u = r(16),
	        p = r(3),
	        c = function () {
	      function t(e, r, a, i) {
	        var o = this;void 0 === i && (i = {}), this.wpmp = r(i.wpmpName, i.logMessages), this.hpm = e(this.wpmp, null, i.version, i.type), this.router = a(this.wpmp), this.uniqueSessionId = p.generateUUID(), this.router.post("/reports/:uniqueId/events/:eventName", function (t, e) {
	          var r = { type: "report", id: t.params.uniqueId, name: t.params.eventName, value: t.body };o.handleEvent(r);
	        }), this.router.post("/reports/:uniqueId/pages/:pageName/events/:eventName", function (t, e) {
	          var r = { type: "report", id: t.params.uniqueId, name: t.params.eventName, value: t.body };o.handleEvent(r);
	        }), this.router.post("/reports/:uniqueId/pages/:pageName/visuals/:visualName/events/:eventName", function (t, e) {
	          var r = { type: "report", id: t.params.uniqueId, name: t.params.eventName, value: t.body };o.handleEvent(r);
	        }), this.router.post("/dashboards/:uniqueId/events/:eventName", function (t, e) {
	          var r = { type: "dashboard", id: t.params.uniqueId, name: t.params.eventName, value: t.body };o.handleEvent(r);
	        }), this.router.post("/tile/:uniqueId/events/:eventName", function (t, e) {
	          var r = { type: "tile", id: t.params.uniqueId, name: t.params.eventName, value: t.body };o.handleEvent(r);
	        }), this.router.post("/qna/:uniqueId/events/:eventName", function (t, e) {
	          var r = { type: "qna", id: t.params.uniqueId, name: t.params.eventName, value: t.body };o.handleEvent(r);
	        }), this.router.post("/ready/:uniqueId", function (t, e) {
	          var r = { type: "report", id: t.params.uniqueId, name: "ready", value: t.body };o.handleEvent(r);
	        }), this.embeds = [], this.config = p.assign({}, t.defaultConfig, i), this.config.autoEmbedOnContentLoaded && this.enableAutoEmbed();
	      }return t.prototype.createReport = function (t, e) {
	        e.type = "create";var r = t,
	            a = new o.Create(this, r, e);return r.powerBiEmbed = a, this.addOrOverwriteEmbed(a, t), a;
	      }, t.prototype.init = function (t, e) {
	        var r = this;void 0 === e && (e = void 0), t = t && t instanceof HTMLElement ? t : document.body;var i = Array.prototype.slice.call(t.querySelectorAll("[" + a.Embed.embedUrlAttribute + "]"));return i.map(function (t) {
	          return r.embed(t, e);
	        });
	      }, t.prototype.embed = function (t, e) {
	        return void 0 === e && (e = {}), this.embedInternal(t, e);
	      }, t.prototype.load = function (t, e) {
	        return void 0 === e && (e = {}), this.embedInternal(t, e, !0, !1);
	      }, t.prototype.bootstrap = function (t, e) {
	        return this.embedInternal(t, e, !1, !0);
	      }, t.prototype.embedInternal = function (t, e, r, a) {
	        void 0 === e && (e = {});var i,
	            o = t;if (o.powerBiEmbed) {
	          if (a) throw new Error("Attempted to bootstrap element " + t.outerHTML + ", but the element is already a powerbi element.");i = this.embedExisting(o, e, r);
	        } else i = this.embedNew(o, e, r, a);return i;
	      }, t.prototype.getNumberOfComponents = function () {
	        return this.embeds ? this.embeds.length : 0;
	      }, t.prototype.getSdkSessionId = function () {
	        return this.uniqueSessionId;
	      }, t.prototype.embedNew = function (e, r, o, n) {
	        var l = r.type || e.getAttribute(a.Embed.typeAttribute);if (!l) throw new Error("Attempted to embed using config " + JSON.stringify(r) + " on element " + e.outerHTML + ", but could not determine what type of component to embed. You must specify a type in the configuration or as an attribute such as '" + a.Embed.typeAttribute + '="' + i.Report.type.toLowerCase() + "\"'.");r.type = l;var s = p.find(function (t) {
	          return l === t.type.toLowerCase();
	        }, t.components);if (!s) throw new Error("Attempted to embed component of type: " + l + " but did not find any matching component.  Please verify the type you specified is intended.");var d = new s(this, e, r, o, n);return e.powerBiEmbed = d, this.addOrOverwriteEmbed(d, e), d;
	      }, t.prototype.embedExisting = function (t, e, r) {
	        var a = p.find(function (e) {
	          return e.element === t;
	        }, this.embeds);if (!a) throw new Error("Attempted to embed using config " + JSON.stringify(e) + " on element " + t.outerHTML + " which already has embedded comopnent associated, but could not find the existing comopnent in the list of active components. This could indicate the embeds list is out of sync with the DOM, or the component is referencing the incorrect HTML element.");if (e.type && "qna" === e.type.toLowerCase()) return this.embedNew(t, e);if ("string" == typeof e.type && e.type !== a.config.type) {
	          if ("report" === e.type && "create" === a.config.type) {
	            var o = new i.Report(this, t, e, !1, !1, t.powerBiEmbed.iframe);return o.load(e), t.powerBiEmbed = o, this.addOrOverwriteEmbed(a, t), o;
	          }throw new Error("Embedding on an existing element with a different type than the previous embed object is not supported.  Attempted to embed using config " + JSON.stringify(e) + " on element " + t.outerHTML + ", but the existing element contains an embed of type: " + this.config.type + " which does not match the new type: " + e.type);
	        }return a.populateConfig(e, !1), a.load(a.config, r), a;
	      }, t.prototype.enableAutoEmbed = function () {
	        var t = this;window.addEventListener("DOMContentLoaded", function (e) {
	          return t.init(document.body);
	        }, !1);
	      }, t.prototype.get = function (t) {
	        var e = t;if (!e.powerBiEmbed) throw new Error("You attempted to get an instance of powerbi component associated with element: " + t.outerHTML + " but there was no associated instance.");return e.powerBiEmbed;
	      }, t.prototype.find = function (t) {
	        return p.find(function (e) {
	          return e.config.uniqueId === t;
	        }, this.embeds);
	      }, t.prototype.addOrOverwriteEmbed = function (t, e) {
	        this.embeds = this.embeds.filter(function (t) {
	          return t.element.id !== e.id;
	        }), this.embeds.push(t);
	      }, t.prototype.reset = function (t) {
	        var e = t;if (e.powerBiEmbed) {
	          var r = e.powerBiEmbed;r.frontLoadHandler && r.element.removeEventListener("ready", r.frontLoadHandler, !1), p.remove(function (t) {
	            return t === e.powerBiEmbed;
	          }, this.embeds), delete e.powerBiEmbed;var a = t.querySelector("iframe");a && (void 0 !== a.remove ? a.remove() : a.parentElement.removeChild(a));
	        }
	      }, t.prototype.handleTileEvents = function (t) {
	        "tile" === t.type && this.handleEvent(t);
	      }, t.prototype.handleEvent = function (t) {
	        var e = p.find(function (e) {
	          return e.config.uniqueId === t.id;
	        }, this.embeds);if (e) {
	          var r = t.value;if ("pageChanged" === t.name) {
	            var a = "newPage",
	                i = r[a];if (!i) throw new Error("Page model not found at 'event.value." + a + "'.");r[a] = new s.Page(e, i.name, i.displayName, !0);
	          }p.raiseCustomEvent(e.element, t.name, r);
	        }
	      }, t.prototype.preload = function (t, e) {
	        var r = document.createElement("iframe");r.setAttribute("style", "display:none;"), r.setAttribute("src", t.embedUrl), r.setAttribute("scrolling", "no"), r.setAttribute("allowfullscreen", "false");var a = e;return a || (a = document.getElementsByTagName("body")[0]), a.appendChild(r), r.onload = function () {
	          p.raiseCustomEvent(r, "preloaded", {});
	        }, r;
	      }, t.components = [l.Tile, i.Report, n.Dashboard, d.Qna, u.Visual], t.defaultConfig = { autoEmbedOnContentLoaded: !1, onError: function onError() {
	          for (var t = [], e = 0; e < arguments.length; e++) {
	            t[e - 0] = arguments[e];
	          }return console.log(t[0], t.slice(1));
	        } }, t;
	    }();e.Service = c;
	  }, function (t, e, r) {
	    var a = r(3),
	        i = r(4),
	        o = r(5),
	        n = function () {
	      function t(e, r, a, i, o, n) {
	        this.allowedEvents = [], Array.prototype.push.apply(this.allowedEvents, t.allowedEvents), this.eventHandlers = [], this.service = e, this.element = r, this.iframe = i, this.embeType = a.type.toLowerCase(), this.populateConfig(a, n), "create" === this.embeType ? this.setIframe(!1, o, n) : this.setIframe(!0, o, n);
	      }return t.prototype.createReport = function (t) {
	        var e = o.validateCreateReport(t);if (e) throw e;return this.service.hpm.post("/report/create", t, { uid: this.config.uniqueId, sdkSessionId: this.service.getSdkSessionId() }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, t.prototype.save = function () {
	        return this.service.hpm.post("/report/save", null, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        })["catch"](function (t) {
	          throw t.body;
	        });
	      }, t.prototype.saveAs = function (t) {
	        return this.service.hpm.post("/report/saveAs", t, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        })["catch"](function (t) {
	          throw t.body;
	        });
	      }, t.prototype.load = function (t, e) {
	        var r = this;if (t.accessToken) {
	          var o = e && "report" === t.type ? this.phasedLoadPath : this.loadPath,
	              n = { uid: this.config.uniqueId, sdkSessionId: this.service.getSdkSessionId(), bootstrapped: this.config.bootstrapped, sdkVersion: i["default"].version };return this.service.hpm.post(o, t, n, this.iframe.contentWindow).then(function (e) {
	            return a.assign(r.config, t), e.body;
	          }, function (t) {
	            throw t.body;
	          });
	        }
	      }, t.prototype.off = function (t, e) {
	        var r = this,
	            i = { name: t, type: null, id: null, value: null };if (e) a.remove(function (t) {
	          return t.test(i) && t.handle === e;
	        }, this.eventHandlers), this.element.removeEventListener(t, e);else {
	          var o = this.eventHandlers.filter(function (t) {
	            return t.test(i);
	          });o.forEach(function (e) {
	            a.remove(function (t) {
	              return t === e;
	            }, r.eventHandlers), r.element.removeEventListener(t, e.handle);
	          });
	        }
	      }, t.prototype.on = function (t, e) {
	        if (this.allowedEvents.indexOf(t) === -1) throw new Error("eventName is must be one of " + this.allowedEvents + ". You passed: " + t);this.eventHandlers.push({ test: function test(e) {
	            return e.name === t;
	          }, handle: e }), this.element.addEventListener(t, e);
	      }, t.prototype.reload = function () {
	        return this.load(this.config);
	      }, t.prototype.setAccessToken = function (e) {
	        var r = this,
	            a = this.config.type;return a = "create" === a || "visual" === a || "qna" === a ? "report" : a, this.service.hpm.post("/" + a + "/token", e, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (a) {
	          return r.config.accessToken = e, r.element.setAttribute(t.accessTokenAttribute, e), r.service.accessToken = e, a.body;
	        })["catch"](function (t) {
	          throw t.body;
	        });
	      }, t.prototype.getAccessToken = function (e) {
	        var r = this.config.accessToken || this.element.getAttribute(t.accessTokenAttribute) || e;if (!r) throw new Error("No access token was found for element. You must specify an access token directly on the element using attribute '" + t.accessTokenAttribute + "' or specify a global token at: powerbi.accessToken.");return r;
	      }, t.prototype.populateConfig = function (t, e) {
	        this.bootstrapConfig ? (this.config = a.assign({}, this.bootstrapConfig, t), this.bootstrapConfig = null) : this.config = a.assign({}, t), this.config.embedUrl = this.getEmbedUrl(e), this.config.groupId = this.getGroupId(), this.addLocaleToEmbedUrl(t), this.config.uniqueId = this.getUniqueId(), e ? (this.bootstrapConfig = this.config, this.bootstrapConfig.bootstrapped = !0) : this.config.accessToken = this.getAccessToken(this.service.accessToken), this.configChanged(e);
	      }, t.prototype.addLocaleToEmbedUrl = function (t) {
	        if (t.settings) {
	          var e = t.settings.localeSettings;e && e.language && (this.config.embedUrl = a.addParamToUrl(this.config.embedUrl, "language", e.language)), e && e.formatLocale && (this.config.embedUrl = a.addParamToUrl(this.config.embedUrl, "formatLocale", e.formatLocale));
	        }
	      }, t.prototype.getEmbedUrl = function (e) {
	        var r = this.config.embedUrl || this.element.getAttribute(t.embedUrlAttribute);if (e && !r && (r = this.getDefaultEmbedUrl(this.config.hostname)), "string" != typeof r || 0 === r.length) throw new Error("Embed Url is required, but it was not found. You must provide an embed url either as part of embed configuration or as attribute '" + t.embedUrlAttribute + "'.");return r;
	      }, t.prototype.getDefaultEmbedUrl = function (e) {
	        e || (e = t.defaultEmbedHostName);var r = this.getDefaultEmbedUrlEndpoint();if (e = e.toLowerCase().trim(), 0 === e.indexOf("http://")) throw new Error("HTTP is not allowed. HTTPS is required");return 0 === e.indexOf("https://") ? e + "/" + r : "https://" + e + "/" + r;
	      }, t.prototype.getUniqueId = function () {
	        return this.config.uniqueId || this.element.getAttribute(t.nameAttribute) || a.createRandomString();
	      }, t.prototype.getGroupId = function () {
	        return this.config.groupId || t.findGroupIdFromEmbedUrl(this.config.embedUrl);
	      }, t.prototype.fullscreen = function () {
	        var t = this.iframe.requestFullscreen || this.iframe.msRequestFullscreen || this.iframe.mozRequestFullScreen || this.iframe.webkitRequestFullscreen;t.call(this.iframe);
	      }, t.prototype.exitFullscreen = function () {
	        if (this.isFullscreen(this.iframe)) {
	          var t = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;t.call(document);
	        }
	      }, t.prototype.isFullscreen = function (t) {
	        var e = ["fullscreenElement", "webkitFullscreenElement", "mozFullscreenScreenElement", "msFullscreenElement"];return e.some(function (e) {
	          return document[e] === t;
	        });
	      }, t.prototype.setIframe = function (e, r, i) {
	        var o = this;if (!this.iframe) {
	          var n = document.createElement("iframe"),
	              l = this.config.uniqueId ? a.addParamToUrl(this.config.embedUrl, "uid", this.config.uniqueId) : this.config.embedUrl;n.style.width = "100%", n.style.height = "100%", n.setAttribute("src", l), n.setAttribute("scrolling", "no"), n.setAttribute("allowfullscreen", "true");for (var s = this.element; s.firstChild;) {
	            s.removeChild(s.firstChild);
	          }s.appendChild(n), this.iframe = s.firstChild;
	        }if (e) {
	          if (!i) {
	            var d = this.validate(this.config);if (d) throw d;
	          }this.iframe.addEventListener("load", function () {
	            return o.load(o.config, r);
	          }, !1), this.service.getNumberOfComponents() <= t.maxFrontLoadTimes && (this.frontLoadHandler = function () {
	            return o.frontLoadSendConfig(o.config);
	          }, this.element.addEventListener("ready", this.frontLoadHandler, !1));
	        } else this.iframe.addEventListener("load", function () {
	          return o.createReport(o.createConfig);
	        }, !1);
	      }, t.prototype.setComponentTitle = function (t) {
	        this.iframe && (null == t ? this.iframe.removeAttribute("title") : this.iframe.setAttribute("title", t));
	      }, t.prototype.setComponentTabIndex = function (t) {
	        this.element && this.element.setAttribute("tabindex", null == t ? "0" : t.toString());
	      }, t.prototype.removeComponentTabIndex = function (t) {
	        this.element && this.element.removeAttribute("tabindex");
	      }, t.findGroupIdFromEmbedUrl = function (t) {
	        var e,
	            r = /groupId="?([^&]+)"?/,
	            a = t.match(r);return a && (e = a[1]), e;
	      }, t.prototype.frontLoadSendConfig = function (t) {
	        if (t.accessToken) {
	          var e = this.validate(t);if (e) throw e;if (null != this.iframe.contentWindow) return this.service.hpm.post("/frontload/config", t, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	            return t.body;
	          }, function (t) {
	            throw t.body;
	          });
	        }
	      }, t.allowedEvents = ["loaded", "saved", "rendered", "saveAsTriggered", "error", "dataSelected", "buttonClicked"], t.accessTokenAttribute = "powerbi-access-token", t.embedUrlAttribute = "powerbi-embed-url", t.nameAttribute = "powerbi-name", t.typeAttribute = "powerbi-type", t.defaultEmbedHostName = "https://app.powerbi.com", t.maxFrontLoadTimes = 2, t;
	    }();e.Embed = n;
	  }, function (t, e) {
	    function r(t, e, r) {
	      var a;"function" == typeof CustomEvent ? a = new CustomEvent(e, { detail: r, bubbles: !0, cancelable: !0 }) : (a = document.createEvent("CustomEvent"), a.initCustomEvent(e, !0, !0, r)), t.dispatchEvent(a);
	    }function a(t, e) {
	      if (!Array.isArray(e)) throw new Error("You attempted to call find with second parameter that was not an array. You passed: " + e);var r;return e.some(function (e, a) {
	        if (t(e)) return r = a, !0;
	      }), r;
	    }function i(t, e) {
	      var r = a(t, e);return e[r];
	    }function o(t, e) {
	      var r = a(t, e);e.splice(r, 1);
	    }function n() {
	      for (var t = [], e = 0; e < arguments.length; e++) {
	        t[e - 0] = arguments[e];
	      }var r = t[0];if (void 0 === r || null === r) throw new TypeError("Cannot convert undefined or null to object");for (var a = Object(r), i = 1; i < arguments.length; i++) {
	        var o = arguments[i];if (void 0 !== o && null !== o) for (var n in o) {
	          o.hasOwnProperty(n) && (a[n] = o[n]);
	        }
	      }return a;
	    }function l() {
	      return c().toString(36).substring(1);
	    }function s() {
	      var t = new Date().getTime();return "undefined" != typeof performance && "function" == typeof performance.now && (t += performance.now()), "xxxxxxxxxxxxxxxxxxxx".replace(/[xy]/g, function (e) {
	        var r = c() % 16;return t >>= 4, r.toString(16);
	      });
	    }function d(t, e, r) {
	      var a = t.indexOf("?") > 0 ? "&" : "?";return t += a + e + "=" + r;
	    }function u(t, e, r) {
	      return t.get("/report/hasUnsavedChanges", { uid: e }, r).then(function (t) {
	        return !t.body;
	      }, function (t) {
	        throw t.body;
	      });
	    }function p(t) {
	      return t.toLowerCase().indexOf("/rdlembed?") >= 0;
	    }function c() {
	      var t = window.crypto || window.msCrypto,
	          e = new Uint32Array(1);return t.getRandomValues(e), e[0];
	    }e.raiseCustomEvent = r, e.findIndex = a, e.find = i, e.remove = o, e.assign = n, e.createRandomString = l, e.generateUUID = s, e.addParamToUrl = d, e.isSavedInternal = u, e.isRDLEmbed = p, e.getRandomValue = c;
	  }, function (t, e) {
	    var r = { version: "2.10.3", type: "js" };Object.defineProperty(e, "__esModule", { value: !0 }), e["default"] = r;
	  }, function (t, e, r) {
	    /*! powerbi-models v1.3.1 | (c) 2016 Microsoft Corporation MIT */
	    !function (e, r) {
	      t.exports = r();
	    }(this, function () {
	      return function (t) {
	        function e(a) {
	          if (r[a]) return r[a].exports;var i = r[a] = { exports: {}, id: a, loaded: !1 };return t[a].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
	        }var r = {};return e.m = t, e.c = r, e.p = "", e(0);
	      }([function (t, e, r) {
	        function a(t) {
	          return l(t) && !!t.keys;
	        }function i(t) {
	          return o(t) === K.Basic && !!t.keyValues;
	        }function o(t) {
	          if (t.filterType) return t.filterType;var e = t,
	              r = t;return "string" == typeof e.operator && Array.isArray(e.values) ? K.Basic : "string" == typeof r.logicalOperator && Array.isArray(r.conditions) ? K.Advanced : K.Unknown;
	        }function n(t) {
	          return void 0 !== t.table && void 0 !== t.measure;
	        }function l(t) {
	          return !(!t.table || !t.column || t.aggregationFunction);
	        }function s(t) {
	          return !(!(t.table && t.hierarchy && t.hierarchyLevel) || t.aggregationFunction);
	        }function d(t) {
	          return !!(t.table && t.hierarchy && t.hierarchyLevel && t.aggregationFunction);
	        }function u(t) {
	          return !!(t.table && t.column && t.aggregationFunction);
	        }function p(t) {
	          var e = t.message;return e || (e = t.path + " is invalid. Not meeting " + t.keyword + " constraint"), { message: e };
	        }function c(t) {
	          var r = e.Validators.visualSelectorValidator.validate(t);return r ? r.map(p) : void 0;
	        }function f(t) {
	          var r = e.Validators.slicerValidator.validate(t);return r ? r.map(p) : void 0;
	        }function h(t) {
	          var r = e.Validators.slicerStateValidator.validate(t);return r ? r.map(p) : void 0;
	        }function v(t) {
	          var r = e.Validators.playBookmarkRequestValidator.validate(t);return r ? r.map(p) : void 0;
	        }function y(t) {
	          var r = e.Validators.addBookmarkRequestValidator.validate(t);return r ? r.map(p) : void 0;
	        }function m(t) {
	          var r = e.Validators.applyBookmarkByNameRequestValidator.validate(t);return r ? r.map(p) : void 0;
	        }function g(t) {
	          var r = e.Validators.applyBookmarkStateRequestValidator.validate(t);return r ? r.map(p) : void 0;
	        }function V(t) {
	          var r = e.Validators.settingsValidator.validate(t);return r ? r.map(p) : void 0;
	        }function w(t) {
	          var r = e.Validators.customPageSizeValidator.validate(t);return r ? r.map(p) : void 0;
	        }function b(t) {
	          var r = e.Validators.extensionValidator.validate(t);return r ? r.map(p) : void 0;
	        }function E(t) {
	          var r = e.Validators.reportLoadValidator.validate(t);return r ? r.map(p) : void 0;
	        }function S(t) {
	          var r = e.Validators.reportCreateValidator.validate(t);return r ? r.map(p) : void 0;
	        }function T(t) {
	          var r = e.Validators.dashboardLoadValidator.validate(t);return r ? r.map(p) : void 0;
	        }function O(t) {
	          var r = e.Validators.tileLoadValidator.validate(t);return r ? r.map(p) : void 0;
	        }function P(t) {
	          var r = e.Validators.pageValidator.validate(t);return r ? r.map(p) : void 0;
	        }function _(t) {
	          var r = e.Validators.filtersValidator.validate(t);return r ? r.map(p) : void 0;
	        }function R(t) {
	          var r = e.Validators.saveAsParametersValidator.validate(t);return r ? r.map(p) : void 0;
	        }function A(t) {
	          var r = e.Validators.loadQnaValidator.validate(t);return r ? r.map(p) : void 0;
	        }function F(t) {
	          var r = e.Validators.qnaInterpretInputDataValidator.validate(t);return r ? r.map(p) : void 0;
	        }function C(t) {
	          var r = e.Validators.exportDataRequestValidator.validate(t);return r ? r.map(p) : void 0;
	        }function k(t) {
	          var r = e.Validators.visualHeaderValidator.validate(t);return r ? r.map(p) : void 0;
	        }function x(t) {
	          var r = e.Validators.visualSettingsValidator.validate(t);return r ? r.map(p) : void 0;
	        }function I(t) {
	          var r = e.Validators.commandsSettingsValidator.validate(t);return r ? r.map(p) : void 0;
	        }function q(t) {
	          var r = e.Validators.customThemeValidator.validate(t);return r ? r.map(p) : void 0;
	        }var M = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 }), e.Validators = r(1).Validators;var L;!function (t) {
	          t[t.Information = 0] = "Information", t[t.Verbose = 1] = "Verbose", t[t.Warning = 2] = "Warning", t[t.Error = 3] = "Error", t[t.ExpectedError = 4] = "ExpectedError", t[t.UnexpectedError = 5] = "UnexpectedError", t[t.Fatal = 6] = "Fatal";
	        }(L = e.TraceType || (e.TraceType = {}));var j;!function (t) {
	          t[t.Widescreen = 0] = "Widescreen", t[t.Standard = 1] = "Standard", t[t.Cortana = 2] = "Cortana", t[t.Letter = 3] = "Letter", t[t.Custom = 4] = "Custom";
	        }(j = e.PageSizeType || (e.PageSizeType = {}));var N;!function (t) {
	          t[t.FitToPage = 0] = "FitToPage", t[t.FitToWidth = 1] = "FitToWidth", t[t.ActualSize = 2] = "ActualSize";
	        }(N = e.DisplayOption || (e.DisplayOption = {}));var D;!function (t) {
	          t[t.Default = 0] = "Default", t[t.Transparent = 1] = "Transparent";
	        }(D = e.BackgroundType || (e.BackgroundType = {}));var U;!function (t) {
	          t[t.Visible = 0] = "Visible", t[t.Hidden = 1] = "Hidden";
	        }(U = e.VisualContainerDisplayMode || (e.VisualContainerDisplayMode = {}));var B;!function (t) {
	          t[t.Master = 0] = "Master", t[t.Custom = 1] = "Custom", t[t.MobilePortrait = 2] = "MobilePortrait", t[t.MobileLandscape = 3] = "MobileLandscape";
	        }(B = e.LayoutType || (e.LayoutType = {}));var W;!function (t) {
	          t[t.Navigate = 0] = "Navigate", t[t.NavigateAndRaiseEvent = 1] = "NavigateAndRaiseEvent", t[t.RaiseEvent = 2] = "RaiseEvent";
	        }(W = e.HyperlinkClickBehavior || (e.HyperlinkClickBehavior = {}));var H;!function (t) {
	          t[t.AlwaysVisible = 0] = "AlwaysVisible", t[t.HiddenInViewMode = 1] = "HiddenInViewMode";
	        }(H = e.SectionVisibility || (e.SectionVisibility = {}));var z;!function (t) {
	          t[t.Read = 0] = "Read", t[t.ReadWrite = 1] = "ReadWrite", t[t.Copy = 2] = "Copy", t[t.Create = 4] = "Create", t[t.All = 7] = "All";
	        }(z = e.Permissions || (e.Permissions = {}));var J;!function (t) {
	          t[t.View = 0] = "View", t[t.Edit = 1] = "Edit";
	        }(J = e.ViewMode || (e.ViewMode = {}));var Y;!function (t) {
	          t[t.Aad = 0] = "Aad", t[t.Embed = 1] = "Embed";
	        }(Y = e.TokenType || (e.TokenType = {}));var Q;!function (t) {
	          t[t.None = 0] = "None", t[t.HighContrast1 = 1] = "HighContrast1", t[t.HighContrast2 = 2] = "HighContrast2", t[t.HighContrastBlack = 3] = "HighContrastBlack", t[t.HighContrastWhite = 4] = "HighContrastWhite";
	        }(Q = e.ContrastMode || (e.ContrastMode = {}));var G;!function (t) {
	          t[t.Bottom = 0] = "Bottom", t[t.Top = 1] = "Top";
	        }(G = e.MenuLocation || (e.MenuLocation = {}));var $;!function (t) {
	          t[t.Report = 0] = "Report", t[t.Page = 1] = "Page", t[t.Visual = 2] = "Visual";
	        }($ = e.FiltersLevel || (e.FiltersLevel = {}));var K;!function (t) {
	          t[t.Advanced = 0] = "Advanced", t[t.Basic = 1] = "Basic", t[t.Unknown = 2] = "Unknown", t[t.IncludeExclude = 3] = "IncludeExclude", t[t.RelativeDate = 4] = "RelativeDate", t[t.TopN = 5] = "TopN", t[t.Tuple = 6] = "Tuple";
	        }(K = e.FilterType || (e.FilterType = {}));var X;!function (t) {
	          t[t.Days = 0] = "Days", t[t.Weeks = 1] = "Weeks", t[t.CalendarWeeks = 2] = "CalendarWeeks", t[t.Months = 3] = "Months", t[t.CalendarMonths = 4] = "CalendarMonths", t[t.Years = 5] = "Years", t[t.CalendarYears = 6] = "CalendarYears";
	        }(X = e.RelativeDateFilterTimeUnit || (e.RelativeDateFilterTimeUnit = {}));var Z;!function (t) {
	          t[t.InLast = 0] = "InLast", t[t.InThis = 1] = "InThis", t[t.InNext = 2] = "InNext";
	        }(Z = e.RelativeDateOperators || (e.RelativeDateOperators = {}));var tt = function () {
	          function t(t, e) {
	            this.target = t, this.filterType = e;
	          }return t.prototype.toJSON = function () {
	            var t = { $schema: this.schemaUrl, target: this.target, filterType: this.filterType };return void 0 !== this.displaySettings && (t.displaySettings = this.displaySettings), t;
	          }, t;
	        }();e.Filter = tt;var et = function (t) {
	          function e(r, a, i) {
	            var o = t.call(this, r, K.Unknown) || this;return o.message = a, o.notSupportedTypeName = i, o.schemaUrl = e.schemaUrl, o;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.message = this.message, e.notSupportedTypeName = this.notSupportedTypeName, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#notSupported", e;
	        }(tt);e.NotSupportedFilter = et;var rt = function (t) {
	          function e(r, a, i) {
	            var o = t.call(this, r, K.IncludeExclude) || this;return o.values = i, o.isExclude = a, o.schemaUrl = e.schemaUrl, o;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.isExclude = this.isExclude, e.values = this.values, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#includeExclude", e;
	        }(tt);e.IncludeExcludeFilter = rt;var at = function (t) {
	          function e(r, a, i, o) {
	            var n = t.call(this, r, K.TopN) || this;return n.operator = a, n.itemCount = i, n.schemaUrl = e.schemaUrl, n.orderBy = o, n;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.operator = this.operator, e.itemCount = this.itemCount, e.orderBy = this.orderBy, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#topN", e;
	        }(tt);e.TopNFilter = at;var it = function (t) {
	          function e(r, a, i, o, n) {
	            var l = t.call(this, r, K.RelativeDate) || this;return l.operator = a, l.timeUnitsCount = i, l.timeUnitType = o, l.includeToday = n, l.schemaUrl = e.schemaUrl, l;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.operator = this.operator, e.timeUnitsCount = this.timeUnitsCount, e.timeUnitType = this.timeUnitType, e.includeToday = this.includeToday, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#relativeDate", e;
	        }(tt);e.RelativeDateFilter = it;var ot = function (t) {
	          function e(r, a) {
	            for (var i = [], o = 2; o < arguments.length; o++) {
	              i[o - 2] = arguments[o];
	            }var n = t.call(this, r, K.Basic) || this;if (n.operator = a, n.schemaUrl = e.schemaUrl, 0 === i.length && "All" !== a) throw new Error('values must be a non-empty array unless your operator is "All".');return Array.isArray(i[0]) ? n.values = i[0] : n.values = i, n;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.operator = this.operator, e.values = this.values, e.requiresSingleSelect = !!this.requiresSingleSelect, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#basic", e;
	        }(tt);e.BasicFilter = ot;var nt = function (t) {
	          function e(e, r, a, i) {
	            var o = t.call(this, e, r, a) || this;o.keyValues = i, o.target = e;var n = e.keys ? e.keys.length : 0;if (n > 0 && !i) throw new Error("You should pass the values to be filtered for each key. You passed: no values and " + n + " keys");if (0 === n && i && i.length > 0) throw new Error("You passed key values but your target object doesn't contain the keys to be filtered");for (var l = 0; l < o.keyValues.length; l++) {
	              if (o.keyValues[l]) {
	                var s = o.keyValues[l].length;if (s !== n) throw new Error("Each tuple of key values should contain a value for each of the keys. You passed: " + s + " values and " + n + " keys");
	              }
	            }return o;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.keyValues = this.keyValues, e;
	          }, e;
	        }(ot);e.BasicFilterWithKeys = nt;var lt = function (t) {
	          function e(r, a, i) {
	            var o = t.call(this, r, K.Tuple) || this;return o.operator = a, o.schemaUrl = e.schemaUrl, o.values = i, o;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.operator = this.operator, e.values = this.values, e.target = this.target, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#tuple", e;
	        }(tt);e.TupleFilter = lt;var st = function (t) {
	          function e(r, a) {
	            for (var i = [], o = 2; o < arguments.length; o++) {
	              i[o - 2] = arguments[o];
	            }var n = t.call(this, r, K.Advanced) || this;if (n.schemaUrl = e.schemaUrl, "string" != typeof a || 0 === a.length) throw new Error("logicalOperator must be a valid operator, You passed: " + a);n.logicalOperator = a;var l;if (l = Array.isArray(i[0]) ? i[0] : i, 0 === l.length) throw new Error("conditions must be a non-empty array. You passed: " + i);if (l.length > 2) throw new Error("AdvancedFilters may not have more than two conditions. You passed: " + i.length);if (1 === l.length && "And" !== a) throw new Error('Logical Operator must be "And" when there is only one condition provided');return n.conditions = l, n;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.logicalOperator = this.logicalOperator, e.conditions = this.conditions, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#advanced", e;
	        }(tt);e.AdvancedFilter = st, e.isFilterKeyColumnsTarget = a, e.isBasicFilterWithKeys = i, e.getFilterType = o, e.isMeasure = n, e.isColumn = l, e.isHierarchyLevel = s, e.isHierarchyLevelAggr = d, e.isColumnAggr = u;var dt;!function (t) {
	          t[t.Interactive = 0] = "Interactive", t[t.ResultOnly = 1] = "ResultOnly";
	        }(dt = e.QnaMode || (e.QnaMode = {}));var ut;!function (t) {
	          t[t.Summarized = 0] = "Summarized", t[t.Underlying = 1] = "Underlying";
	        }(ut = e.ExportDataType || (e.ExportDataType = {}));var pt;!function (t) {
	          t[t.Off = 0] = "Off", t[t.Presentation = 1] = "Presentation";
	        }(pt = e.BookmarksPlayMode || (e.BookmarksPlayMode = {})), e.CommonErrorCodes = { TokenExpired: "TokenExpired", NotFound: "PowerBIEntityNotFound", InvalidParameters: "Invalid parameters", LoadReportFailed: "LoadReportFailed", NotAuthorized: "PowerBINotAuthorizedException", FailedToLoadModel: "ExplorationContainer_FailedToLoadModel_DefaultDetails" }, e.TextAlignment = { Left: "left", Center: "center", Right: "right" }, e.LegendPosition = { Top: "Top", Bottom: "Bottom", Right: "Right", Left: "Left", TopCenter: "TopCenter", BottomCenter: "BottomCenter", RightCenter: "RightCenter", LeftCenter: "LeftCenter" };var ct;!function (t) {
	          t[t.Ascending = 1] = "Ascending", t[t.Descending = 2] = "Descending";
	        }(ct = e.SortDirection || (e.SortDirection = {}));var ft = function () {
	          function t(t) {
	            this.$schema = t;
	          }return t.prototype.toJSON = function () {
	            return { $schema: this.$schema };
	          }, t;
	        }();e.Selector = ft;var ht = function (t) {
	          function e(r) {
	            var a = t.call(this, e.schemaUrl) || this;return a.pageName = r, a;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.pageName = this.pageName, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#pageSelector", e;
	        }(ft);e.PageSelector = ht;var vt = function (t) {
	          function e(r) {
	            var a = t.call(this, e.schemaUrl) || this;return a.visualName = r, a;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.visualName = this.visualName, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#visualSelector", e;
	        }(ft);e.VisualSelector = vt;var yt = function (t) {
	          function e(e) {
	            var r = t.call(this, vt.schemaUrl) || this;return r.visualType = e, r;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.visualType = this.visualType, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#visualTypeSelector", e;
	        }(ft);e.VisualTypeSelector = yt;var mt = function (t) {
	          function e(e) {
	            var r = t.call(this, vt.schemaUrl) || this;return r.target = e, r;
	          }return M(e, t), e.prototype.toJSON = function () {
	            var e = t.prototype.toJSON.call(this);return e.target = this.target, e;
	          }, e.schemaUrl = "http://powerbi.com/product/schema#slicerTargetSelector", e;
	        }(ft);e.SlicerTargetSelector = mt;var gt;!function (t) {
	          t[t.Enabled = 0] = "Enabled", t[t.Disabled = 1] = "Disabled", t[t.Hidden = 2] = "Hidden";
	        }(gt = e.CommandDisplayOption || (e.CommandDisplayOption = {}));var Vt;!function (t) {
	          t[t.Grouping = 0] = "Grouping", t[t.Measure = 1] = "Measure", t[t.GroupingOrMeasure = 2] = "GroupingOrMeasure";
	        }(Vt = e.VisualDataRoleKind || (e.VisualDataRoleKind = {}));var wt;!function (t) {
	          t[t.Measure = 0] = "Measure", t[t.Grouping = 1] = "Grouping";
	        }(wt = e.VisualDataRoleKindPreference || (e.VisualDataRoleKindPreference = {})), e.validateVisualSelector = c, e.validateSlicer = f, e.validateSlicerState = h, e.validatePlayBookmarkRequest = v, e.validateAddBookmarkRequest = y, e.validateApplyBookmarkByNameRequest = m, e.validateApplyBookmarkStateRequest = g, e.validateSettings = V, e.validateCustomPageSize = w, e.validateExtension = b, e.validateReportLoad = E, e.validateCreateReport = S, e.validateDashboardLoad = T, e.validateTileLoad = O, e.validatePage = P, e.validateFilter = _, e.validateSaveAsParameters = R, e.validateLoadQnaConfiguration = A, e.validateQnaInterpretInputData = F, e.validateExportDataRequest = C, e.validateVisualHeader = k, e.validateVisualSettings = x, e.validateCommandsSettings = I, e.validateCustomTheme = q;
	      }, function (t, e, r) {
	        Object.defineProperty(e, "__esModule", { value: !0 });var a = r(2),
	            i = r(3),
	            o = r(5),
	            n = r(6),
	            l = r(7),
	            s = r(8),
	            d = r(9),
	            u = r(10),
	            p = r(11),
	            c = r(12),
	            f = r(13),
	            h = r(14),
	            v = r(15),
	            y = r(16),
	            m = r(17),
	            g = r(18),
	            V = r(19),
	            w = r(20),
	            b = r(21),
	            E = r(22),
	            S = r(23),
	            T = r(24),
	            O = r(25);e.Validators = { addBookmarkRequestValidator: new n.AddBookmarkRequestValidator(), advancedFilterTypeValidator: new a.EnumValidator([0]), advancedFilterValidator: new l.AdvancedFilterValidator(), anyArrayValidator: new a.ArrayValidator([new d.AnyOfValidator([new a.StringValidator(), new a.NumberValidator(), new a.BooleanValidator()])]), anyFilterValidator: new d.AnyOfValidator([new l.BasicFilterValidator(), new l.AdvancedFilterValidator(), new l.IncludeExcludeFilterValidator(), new l.NotSupportedFilterValidator(), new l.RelativeDateFilterValidator(), new l.TopNFilterValidator()]), anyValueValidator: new d.AnyOfValidator([new a.StringValidator(), new a.NumberValidator(), new a.BooleanValidator()]), applyBookmarkByNameRequestValidator: new n.ApplyBookmarkByNameRequestValidator(), applyBookmarkStateRequestValidator: new n.ApplyBookmarkStateRequestValidator(), applyBookmarkValidator: new d.AnyOfValidator([new n.ApplyBookmarkByNameRequestValidator(), new n.ApplyBookmarkStateRequestValidator()]), backgroundValidator: new a.EnumValidator([0, 1]), basicFilterTypeValidator: new a.EnumValidator([1]), basicFilterValidator: new l.BasicFilterValidator(), booleanArrayValidator: new a.BooleanArrayValidator(), booleanValidator: new a.BooleanValidator(), commandDisplayOptionValidator: new a.EnumValidator([0, 1, 2]), commandExtensionSelectorValidator: new d.AnyOfValidator([new w.VisualSelectorValidator(), new w.VisualTypeSelectorValidator()]), commandExtensionValidator: new i.CommandExtensionValidator(), commandsSettingsArrayValidator: new a.ArrayValidator([new S.CommandsSettingsValidator()]), commandsSettingsValidator: new S.CommandsSettingsValidator(), conditionItemValidator: new l.ConditionItemValidator(), contrastModeValidator: new a.EnumValidator([0, 1, 2, 3, 4]), customLayoutDisplayOptionValidator: new a.EnumValidator([0, 1, 2]), customLayoutValidator: new g.CustomLayoutValidator(), customPageSizeValidator: new h.CustomPageSizeValidator(), customThemeValidator: new T.CustomThemeValidator(), dashboardLoadValidator: new c.DashboardLoadValidator(), datasetBindingValidator: new O.DatasetBindingValidator(), displayStateModeValidator: new a.EnumValidator([0, 1]), displayStateValidator: new g.DisplayStateValidator(), exportDataRequestValidator: new V.ExportDataRequestValidator(), extensionArrayValidator: new a.ArrayValidator([new i.ExtensionValidator()]), extensionPointsValidator: new i.ExtensionPointsValidator(), extensionValidator: new i.ExtensionValidator(), fieldRequiredValidator: new s.FieldRequiredValidator(), filterColumnTargetValidator: new l.FilterColumnTargetValidator(), filterConditionsValidator: new a.ArrayValidator([new l.ConditionItemValidator()]), filterHierarchyTargetValidator: new l.FilterHierarchyTargetValidator(), filterMeasureTargetValidator: new l.FilterMeasureTargetValidator(), filterTargetValidator: new d.AnyOfValidator([new l.FilterColumnTargetValidator(), new l.FilterHierarchyTargetValidator(), new l.FilterMeasureTargetValidator()]), filtersArrayValidator: new a.ArrayValidator([new d.AnyOfValidator([new l.BasicFilterValidator(), new l.AdvancedFilterValidator(), new l.RelativeDateFilterValidator()])]), filtersValidator: new l.FilterValidator(), hyperlinkClickBehaviorValidator: new a.EnumValidator([0, 1, 2]), includeExcludeFilterValidator: new l.IncludeExcludeFilterValidator(), includeExludeFilterTypeValidator: new a.EnumValidator([3]), layoutTypeValidator: new a.EnumValidator([0, 1, 2, 3]), loadQnaValidator: new v.LoadQnaValidator(), menuExtensionValidator: new i.MenuExtensionValidator(), menuLocationValidator: new a.EnumValidator([0, 1]), notSupportedFilterTypeValidator: new a.EnumValidator([2]), notSupportedFilterValidator: new l.NotSupportedFilterValidator(), numberArrayValidator: new a.NumberArrayValidator(), numberValidator: new a.NumberValidator(), pageLayoutValidator: new m.MapValidator([new a.StringValidator()], [new g.VisualLayoutValidator()]), pageSizeTypeValidator: new a.EnumValidator([0, 1, 2, 3, 4, 5]), pageSizeValidator: new h.PageSizeValidator(), pageValidator: new h.PageValidator(), pageViewFieldValidator: new h.PageViewFieldValidator(), pagesLayoutValidator: new m.MapValidator([new a.StringValidator()], [new g.PageLayoutValidator()]), permissionsValidator: new a.EnumValidator([0, 1, 2, 4, 7]), playBookmarkRequestValidator: new n.PlayBookmarkRequestValidator(), qnaInterpretInputDataValidator: new v.QnaInterpretInputDataValidator(), qnaSettingValidator: new v.QnaSettingsValidator(), relativeDateFilterOperatorValidator: new a.EnumValidator([0, 1, 2]), relativeDateFilterTimeUnitTypeValidator: new a.EnumValidator([0, 1, 2, 3, 4, 5, 6]), relativeDateFilterTypeValidator: new a.EnumValidator([4]), relativeDateFilterValidator: new l.RelativeDateFilterValidator(), reportCreateValidator: new p.ReportCreateValidator(), reportLoadValidator: new u.ReportLoadValidator(), saveAsParametersValidator: new y.SaveAsParametersValidator(), settingsValidator: new o.SettingsValidator(), singleCommandSettingsValidator: new S.SingleCommandSettingsValidator(), slicerSelectorValidator: new d.AnyOfValidator([new w.VisualSelectorValidator(), new w.SlicerTargetSelectorValidator()]), slicerStateValidator: new b.SlicerStateValidator(), slicerTargetValidator: new d.AnyOfValidator([new l.FilterColumnTargetValidator(), new l.FilterHierarchyTargetValidator(), new l.FilterMeasureTargetValidator(), new l.FilterKeyColumnsTargetValidator(), new l.FilterKeyHierarchyTargetValidator()]), slicerValidator: new b.SlicerValidator(), stringArrayValidator: new a.StringArrayValidator(), stringValidator: new a.StringValidator(), tileLoadValidator: new f.TileLoadValidator(), tokenTypeValidator: new a.EnumValidator([0, 1]), topNFilterTypeValidator: new a.EnumValidator([5]), topNFilterValidator: new l.TopNFilterValidator(), viewModeValidator: new a.EnumValidator([0, 1]), visualCommandSelectorValidator: new d.AnyOfValidator([new w.VisualSelectorValidator(), new w.VisualTypeSelectorValidator()]), visualHeaderSelectorValidator: new d.AnyOfValidator([new w.VisualSelectorValidator(), new w.VisualTypeSelectorValidator()]), visualHeaderSettingsValidator: new E.VisualHeaderSettingsValidator(), visualHeaderValidator: new E.VisualHeaderValidator(), visualHeadersValidator: new a.ArrayValidator([new E.VisualHeaderValidator()]), visualLayoutValidator: new g.VisualLayoutValidator(), visualSelectorValidator: new w.VisualSelectorValidator(), visualSettingsValidator: new E.VisualSettingsValidator(), visualTypeSelectorValidator: new w.VisualTypeSelectorValidator() };
	      }, function (t, e) {
	        var r = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var a = function () {
	          function t() {}return t.prototype.validate = function (t, e, r) {
	            return null == t ? null : "object" != (typeof t === "undefined" ? "undefined" : _typeof(t)) || Array.isArray(t) ? [{ message: void 0 !== r ? r + " must be an object" : "input must be an object", path: e, keyword: "type" }] : null;
	          }, t;
	        }();e.ObjectValidator = a;var i = function () {
	          function t(t) {
	            this.itemValidators = t;
	          }return t.prototype.validate = function (t, e, r) {
	            if (null == t) return null;if (!Array.isArray(t)) return [{ message: r + " property is invalid", path: (e ? e + "." : "") + r, keyword: "type" }];for (var a = 0; a < t.length; a++) {
	              for (var i = (e ? e + "." : "") + r + "." + a, o = 0, n = this.itemValidators; o < n.length; o++) {
	                var l = n[o],
	                    s = l.validate(t[a], i, r);if (s) return [{ message: r + " property is invalid", path: (e ? e + "." : "") + r, keyword: "type" }];
	              }
	            }return null;
	          }, t;
	        }();e.ArrayValidator = i;var o = function () {
	          function t(t) {
	            this.expectedType = t;
	          }return t.prototype.validate = function (t, e, r) {
	            return null == t ? null : (typeof t === "undefined" ? "undefined" : _typeof(t)) !== this.expectedType ? [{ message: r + " must be a " + this.expectedType, path: (e ? e + "." : "") + r, keyword: "type" }] : null;
	          }, t;
	        }();e.TypeValidator = o;var n = function (t) {
	          function e() {
	            return t.call(this, "string") || this;
	          }return r(e, t), e;
	        }(o);e.StringValidator = n;var l = function (t) {
	          function e() {
	            return t.call(this, "boolean") || this;
	          }return r(e, t), e;
	        }(o);e.BooleanValidator = l;var s = function (t) {
	          function e() {
	            return t.call(this, "number") || this;
	          }return r(e, t), e;
	        }(o);e.NumberValidator = s;var d = function () {
	          function t(t) {
	            this.possibleValues = t;
	          }return t.prototype.validate = function (t, e, r) {
	            return null == t ? null : this.possibleValues.indexOf(t) < 0 ? [{ message: r + " property is invalid", path: (e ? e + "." : "") + r, keyword: "invalid" }] : null;
	          }, t;
	        }();e.ValueValidator = d;var u = function (t) {
	          function e(e) {
	            var r = t.call(this, [e]) || this;return r.schemaValue = e, r;
	          }return r(e, t), e.prototype.validate = function (e, r, a) {
	            return t.prototype.validate.call(this, e, r, a);
	          }, e;
	        }(d);e.SchemaValidator = u;var p = function (t) {
	          function e(e) {
	            var r = t.call(this) || this;return r.possibleValues = e, r;
	          }return r(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var i = t.prototype.validate.call(this, e, r, a);if (i) return i;var o = new d(this.possibleValues);return o.validate(e, r, a);
	          }, e;
	        }(s);e.EnumValidator = p;var c = function (t) {
	          function e() {
	            return t.call(this, [new n()]) || this;
	          }return r(e, t), e.prototype.validate = function (e, r, a) {
	            var i = t.prototype.validate.call(this, e, r, a);return i ? [{ message: a + " must be an array of strings", path: (r ? r + "." : "") + a, keyword: "type" }] : null;
	          }, e;
	        }(i);e.StringArrayValidator = c;var f = function (t) {
	          function e() {
	            return t.call(this, [new l()]) || this;
	          }return r(e, t), e.prototype.validate = function (e, r, a) {
	            var i = t.prototype.validate.call(this, e, r, a);return i ? [{ message: a + " must be an array of booleans", path: (r ? r + "." : "") + a, keyword: "type" }] : null;
	          }, e;
	        }(i);e.BooleanArrayValidator = f;var h = function (t) {
	          function e() {
	            return t.call(this, [new s()]) || this;
	          }return r(e, t), e.prototype.validate = function (e, r, a) {
	            var i = t.prototype.validate.call(this, e, r, a);return i ? [{ message: a + " must be an array of numbers", path: (r ? r + "." : "") + a, keyword: "type" }] : null;
	          }, e;
	        }(i);e.NumberArrayValidator = h;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "title", validators: [i.Validators.stringValidator] }, { field: "icon", validators: [i.Validators.stringValidator] }, { field: "menuLocation", validators: [i.Validators.menuLocationValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.MenuExtensionValidator = l;var s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "visualContextMenu", validators: [i.Validators.menuExtensionValidator] }, { field: "visualOptionsMenu", validators: [i.Validators.menuExtensionValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.ExtensionPointsValidator = s;var d = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "name", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "extend", validators: [i.Validators.fieldRequiredValidator, i.Validators.extensionPointsValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.ExtensionItemValidator = d;var u = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "title", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "icon", validators: [i.Validators.stringValidator] }, { field: "selector", validators: [i.Validators.commandExtensionSelectorValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(d);e.CommandExtensionValidator = u;var p = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "command", validators: [i.Validators.commandExtensionValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.ExtensionValidator = p;
	      }, function (t, e) {
	        Object.defineProperty(e, "__esModule", { value: !0 });var r = function () {
	          function t(t) {
	            this.fieldValidatorsPairs = t;
	          }return t.prototype.validate = function (t, e, r) {
	            if (!this.fieldValidatorsPairs) return null;for (var a = e ? e + "." + r : r, i = 0, o = this.fieldValidatorsPairs; i < o.length; i++) {
	              for (var n = o[i], l = 0, s = n.validators; l < s.length; l++) {
	                var d = s[l],
	                    u = d.validate(t[n.field], a, n.field);if (u) return u;
	              }
	            }return null;
	          }, t;
	        }();e.MultipleFieldsValidator = r;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "filterPaneEnabled", validators: [i.Validators.booleanValidator] }, { field: "navContentPaneEnabled", validators: [i.Validators.booleanValidator] }, { field: "bookmarksPaneEnabled", validators: [i.Validators.booleanValidator] }, { field: "useCustomSaveAsDialog", validators: [i.Validators.booleanValidator] }, { field: "extensions", validators: [i.Validators.extensionArrayValidator] }, { field: "layoutType", validators: [i.Validators.layoutTypeValidator] }, { field: "customLayout", validators: [i.Validators.customLayoutValidator] }, { field: "background", validators: [i.Validators.backgroundValidator] }, { field: "visualSettings", validators: [i.Validators.visualSettingsValidator] }, { field: "hideErrors", validators: [i.Validators.booleanValidator] }, { field: "commands", validators: [i.Validators.commandsSettingsArrayValidator] }, { field: "hyperlinkClickBehavior", validators: [i.Validators.hyperlinkClickBehaviorValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.SettingsValidator = l;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var l = t.prototype.validate.call(this, e, r, a);if (l) return l;var s = [{ field: "playMode", validators: [i.Validators.fieldRequiredValidator, new n.EnumValidator([0, 1])] }],
	                d = new o.MultipleFieldsValidator(s);return d.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.PlayBookmarkRequestValidator = l;var s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "state", validators: [i.Validators.stringValidator] }, { field: "displayName", validators: [i.Validators.stringValidator] }, { field: "apply", validators: [i.Validators.booleanValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.AddBookmarkRequestValidator = s;var d = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "name", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.ApplyBookmarkByNameRequestValidator = d;var u = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "state", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.ApplyBookmarkStateRequestValidator = u;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "table", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "column", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.FilterColumnTargetValidator = l;var s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "keys", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringArrayValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(l);e.FilterKeyColumnsTargetValidator = s;var d = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "table", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "hierarchy", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "hierarchyLevel", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.FilterHierarchyTargetValidator = d;var u = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "keys", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringArrayValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(d);e.FilterKeyHierarchyTargetValidator = u;var p = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "table", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "measure", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.FilterMeasureTargetValidator = p;var c = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "target", validators: [i.Validators.fieldRequiredValidator, i.Validators.filterTargetValidator] }, { field: "operator", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "values", validators: [i.Validators.fieldRequiredValidator, i.Validators.anyArrayValidator] }, { field: "filterType", validators: [i.Validators.basicFilterTypeValidator] }, { field: "requiresSingleSelect", validators: [i.Validators.fieldRequiredValidator, i.Validators.booleanValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.BasicFilterValidator = c;var f = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "target", validators: [i.Validators.fieldRequiredValidator, i.Validators.filterTargetValidator] }, { field: "logicalOperator", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "conditions", validators: [i.Validators.fieldRequiredValidator, i.Validators.filterConditionsValidator] }, { field: "filterType", validators: [i.Validators.advancedFilterTypeValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.AdvancedFilterValidator = f;var h = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "target", validators: [i.Validators.fieldRequiredValidator, i.Validators.filterTargetValidator] }, { field: "operator", validators: [i.Validators.fieldRequiredValidator, i.Validators.relativeDateFilterOperatorValidator] }, { field: "timeUnitsCount", validators: [i.Validators.fieldRequiredValidator, i.Validators.numberValidator] }, { field: "timeUnitType", validators: [i.Validators.fieldRequiredValidator, i.Validators.relativeDateFilterTimeUnitTypeValidator] }, { field: "includeToday", validators: [i.Validators.fieldRequiredValidator, i.Validators.booleanValidator] }, { field: "filterType", validators: [i.Validators.relativeDateFilterTypeValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.RelativeDateFilterValidator = h;var v = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "target", validators: [i.Validators.fieldRequiredValidator, i.Validators.filterTargetValidator] }, { field: "operator", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "itemCount", validators: [i.Validators.fieldRequiredValidator, i.Validators.numberValidator] }, { field: "filterType", validators: [i.Validators.topNFilterTypeValidator] }, { field: "orderBy", validators: [i.Validators.fieldRequiredValidator, i.Validators.filterTargetValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.TopNFilterValidator = v;var y = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "target", validators: [i.Validators.filterTargetValidator] }, { field: "message", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "notSupportedTypeName", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "filterType", validators: [i.Validators.notSupportedFilterTypeValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.NotSupportedFilterValidator = y;var m = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "target", validators: [i.Validators.fieldRequiredValidator, i.Validators.filterTargetValidator] }, { field: "isExclude", validators: [i.Validators.fieldRequiredValidator, i.Validators.booleanValidator] }, { field: "values", validators: [i.Validators.fieldRequiredValidator, i.Validators.anyArrayValidator] }, { field: "filterType", validators: [i.Validators.includeExludeFilterTypeValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.IncludeExcludeFilterValidator = m;var g = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (t, e, r) {
	            return null == t ? null : i.Validators.anyFilterValidator.validate(t, e, r);
	          }, e;
	        }(n.ObjectValidator);e.FilterValidator = g;var V = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "value", validators: [i.Validators.anyValueValidator] }, { field: "operator", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.ConditionItemValidator = V;
	      }, function (t, e) {
	        Object.defineProperty(e, "__esModule", { value: !0 });var r = function () {
	          function t() {}return t.prototype.validate = function (t, e, r) {
	            return null == t ? [{ message: r + " is required", path: (e ? e + "." : "") + r, keyword: "required" }] : null;
	          }, t;
	        }();e.FieldRequiredValidator = r;
	      }, function (t, e) {
	        Object.defineProperty(e, "__esModule", { value: !0 });var r = function () {
	          function t(t) {
	            this.validators = t;
	          }return t.prototype.validate = function (t, e, r) {
	            if (null == t) return null;for (var a = !1, i = 0, o = this.validators; i < o.length; i++) {
	              var n = o[i],
	                  l = n.validate(t, e, r);if (!l) {
	                a = !0;break;
	              }
	            }return a ? null : [{ message: r + " property is invalid", path: (e ? e + "." : "") + r, keyword: "invalid" }];
	          }, t;
	        }();e.AnyOfValidator = r;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "accessToken", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "id", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "groupId", validators: [i.Validators.stringValidator] }, { field: "settings", validators: [i.Validators.settingsValidator] }, { field: "pageName", validators: [i.Validators.stringValidator] }, { field: "filters", validators: [i.Validators.filtersArrayValidator] }, { field: "permissions", validators: [i.Validators.permissionsValidator] }, { field: "viewMode", validators: [i.Validators.viewModeValidator] }, { field: "tokenType", validators: [i.Validators.tokenTypeValidator] }, { field: "bookmark", validators: [i.Validators.applyBookmarkValidator] }, { field: "theme", validators: [i.Validators.customThemeValidator] }, { field: "embedUrl", validators: [i.Validators.stringValidator] }, { field: "datasetBinding", validators: [i.Validators.datasetBindingValidator] }, { field: "contrastMode", validators: [i.Validators.contrastModeValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.ReportLoadValidator = l;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "accessToken", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "datasetId", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "groupId", validators: [i.Validators.stringValidator] }, { field: "tokenType", validators: [i.Validators.tokenTypeValidator] }, { field: "theme", validators: [i.Validators.customThemeValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.ReportCreateValidator = l;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "accessToken", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "id", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "groupId", validators: [i.Validators.stringValidator] }, { field: "pageView", validators: [i.Validators.pageViewFieldValidator] }, { field: "tokenType", validators: [i.Validators.tokenTypeValidator] }, { field: "embedUrl", validators: [i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.DashboardLoadValidator = l;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "accessToken", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "id", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "dashboardId", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "groupId", validators: [i.Validators.stringValidator] }, { field: "pageView", validators: [i.Validators.stringValidator] }, { field: "tokenType", validators: [i.Validators.tokenTypeValidator] }, { field: "width", validators: [i.Validators.numberValidator] }, { field: "height", validators: [i.Validators.numberValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.TileLoadValidator = l;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "type", validators: [i.Validators.fieldRequiredValidator, i.Validators.pageSizeTypeValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.PageSizeValidator = l;var s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "width", validators: [i.Validators.numberValidator] }, { field: "height", validators: [i.Validators.numberValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(l);e.CustomPageSizeValidator = s;var d = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "name", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.PageValidator = d;var u = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var i = t.prototype.validate.call(this, e, r, a);if (i) return i;var o = ["actualSize", "fitToWidth", "oneColumn"];return o.indexOf(e) < 0 ? [{ message: 'pageView must be a string with one of the following values: "actualSize", "fitToWidth", "oneColumn"' }] : null;
	          }, e;
	        }(n.StringValidator);e.PageViewFieldValidator = u;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "accessToken", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }, { field: "datasetIds", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringArrayValidator] }, { field: "question", validators: [i.Validators.stringValidator] }, { field: "viewMode", validators: [i.Validators.viewModeValidator] }, { field: "settings", validators: [i.Validators.qnaSettingValidator] }, { field: "tokenType", validators: [i.Validators.tokenTypeValidator] }, { field: "groupId", validators: [i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.LoadQnaValidator = l;var s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "filterPaneEnabled", validators: [i.Validators.booleanValidator] }, { field: "hideErrors", validators: [i.Validators.booleanValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.QnaSettingsValidator = s;var d = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "datasetIds", validators: [i.Validators.stringArrayValidator] }, { field: "question", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.QnaInterpretInputDataValidator = d;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "name", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.SaveAsParametersValidator = l;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(2),
	            o = function (t) {
	          function e(e, r) {
	            var a = t.call(this) || this;return a.keyValidators = e, a.valueValidators = r, a;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var i = t.prototype.validate.call(this, e, r, a);if (i) return i;for (var o in e) {
	              if (e.hasOwnProperty(o)) {
	                for (var n = (r ? r + "." : "") + a + "." + o, l = 0, s = this.keyValidators; l < s.length; l++) {
	                  var d = s[l];if (i = d.validate(o, n, a)) return i;
	                }for (var u = 0, p = this.valueValidators; u < p.length; u++) {
	                  var c = p[u];if (i = c.validate(e[o], n, a)) return i;
	                }
	              }
	            }return null;
	          }, e;
	        }(i.ObjectValidator);e.MapValidator = o;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "pageSize", validators: [i.Validators.pageSizeValidator] }, { field: "displayOption", validators: [i.Validators.customLayoutDisplayOptionValidator] }, { field: "pagesLayout", validators: [i.Validators.pagesLayoutValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.CustomLayoutValidator = l;var s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "x", validators: [i.Validators.numberValidator] }, { field: "y", validators: [i.Validators.numberValidator] }, { field: "z", validators: [i.Validators.numberValidator] }, { field: "width", validators: [i.Validators.numberValidator] }, { field: "height", validators: [i.Validators.numberValidator] }, { field: "displayState", validators: [i.Validators.displayStateValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.VisualLayoutValidator = s;var d = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "mode", validators: [i.Validators.displayStateModeValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.DisplayStateValidator = d;var u = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "visualsLayout", validators: [i.Validators.fieldRequiredValidator, i.Validators.pageLayoutValidator] }, { field: "defaultLayout", validators: [i.Validators.visualLayoutValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.PageLayoutValidator = u;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(4),
	            o = r(2),
	            n = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "rows", validators: [new o.NumberValidator()] }, { field: "exportDataType", validators: [new o.EnumValidator([0, 1])] }],
	                s = new i.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(o.ObjectValidator);e.ExportDataRequestValidator = n;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = r(2),
	            s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var s = [{ field: "$schema", validators: [i.Validators.stringValidator, new l.SchemaValidator("http://powerbi.com/product/schema#visualSelector")] }, { field: "visualName", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                d = new o.MultipleFieldsValidator(s);return d.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.VisualSelectorValidator = s;var d = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var s = [{ field: "$schema", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator, new l.SchemaValidator("http://powerbi.com/product/schema#visualTypeSelector")] }, { field: "visualType", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                d = new o.MultipleFieldsValidator(s);return d.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.VisualTypeSelectorValidator = d;var u = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var s = [{ field: "$schema", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator, new l.SchemaValidator("http://powerbi.com/product/schema#slicerTargetSelector")] }, { field: "target", validators: [i.Validators.fieldRequiredValidator, i.Validators.slicerTargetValidator] }],
	                d = new o.MultipleFieldsValidator(s);return d.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.SlicerTargetSelectorValidator = u;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "selector", validators: [i.Validators.fieldRequiredValidator, i.Validators.slicerSelectorValidator] }, { field: "state", validators: [i.Validators.fieldRequiredValidator, i.Validators.slicerStateValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.SlicerValidator = l;var s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "filters", validators: [i.Validators.filtersArrayValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.SlicerStateValidator = s;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "visualHeaders", validators: [i.Validators.visualHeadersValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.VisualSettingsValidator = l;var s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "visible", validators: [i.Validators.booleanValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.VisualHeaderSettingsValidator = s;var d = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "settings", validators: [i.Validators.fieldRequiredValidator, i.Validators.visualHeaderSettingsValidator] }, { field: "selector", validators: [i.Validators.visualHeaderSelectorValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.VisualHeaderValidator = d;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "copy", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "drill", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "drillthrough", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "expandCollapse", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "exportData", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "includeExclude", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "removeVisual", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "search", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "seeData", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "sort", validators: [i.Validators.singleCommandSettingsValidator] }, { field: "spotlight", validators: [i.Validators.singleCommandSettingsValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.CommandsSettingsValidator = l;var s = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "displayOption", validators: [i.Validators.fieldRequiredValidator, i.Validators.commandDisplayOptionValidator] }, { field: "selector", validators: [i.Validators.visualCommandSelectorValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.SingleCommandSettingsValidator = s;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(4),
	            o = r(2),
	            n = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "themeJson", validators: [new o.ObjectValidator()] }],
	                s = new i.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(o.ObjectValidator);e.CustomThemeValidator = n;
	      }, function (t, e, r) {
	        var a = this && this.__extends || function () {
	          var t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (t, e) {
	            t.__proto__ = e;
	          } || function (t, e) {
	            for (var r in e) {
	              e.hasOwnProperty(r) && (t[r] = e[r]);
	            }
	          };return function (e, r) {
	            function a() {
	              this.constructor = e;
	            }t(e, r), e.prototype = null === r ? Object.create(r) : (a.prototype = r.prototype, new a());
	          };
	        }();Object.defineProperty(e, "__esModule", { value: !0 });var i = r(1),
	            o = r(4),
	            n = r(2),
	            l = function (t) {
	          function e() {
	            return null !== t && t.apply(this, arguments) || this;
	          }return a(e, t), e.prototype.validate = function (e, r, a) {
	            if (null == e) return null;var n = t.prototype.validate.call(this, e, r, a);if (n) return n;var l = [{ field: "datasetId", validators: [i.Validators.fieldRequiredValidator, i.Validators.stringValidator] }],
	                s = new o.MultipleFieldsValidator(l);return s.validate(e, r, a);
	          }, e;
	        }(n.ObjectValidator);e.DatasetBindingValidator = l;
	      }]);
	    });
	  }, function (t, e, r) {
	    var a = this && this.__extends || function (t, e) {
	      function r() {
	        this.constructor = t;
	      }for (var a in e) {
	        e.hasOwnProperty(a) && (t[a] = e[a]);
	      }t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
	    },
	        i = r(2),
	        o = r(5),
	        n = r(3),
	        l = r(7),
	        s = r(8),
	        d = r(10),
	        u = r(11),
	        p = function (t) {
	      function e(r, a, i, o, n, l) {
	        var s = i;t.call(this, r, a, s, l, o, n), this.loadPath = "/report/load", this.phasedLoadPath = "/report/prepare", Array.prototype.push.apply(this.allowedEvents, e.allowedEvents), this.bookmarksManager = new u.BookmarksManager(r, s, this.iframe);
	      }return a(e, t), e.findIdFromEmbedUrl = function (t) {
	        var e,
	            r = /reportId="?([^&]+)"?/,
	            a = t.match(r);return a && (e = a[1]), e;
	      }, e.prototype.render = function (t) {
	        return this.service.hpm.post("/report/render", t, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        })["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.getFilters = function () {
	        return n.isRDLEmbed(this.config.embedUrl) ? Promise.reject(l.APINotSupportedForRDLError) : this.service.hpm.get("/report/filters", { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, e.prototype.getId = function () {
	        var t = this.config,
	            r = t.id || this.element.getAttribute(e.reportIdAttribute) || e.findIdFromEmbedUrl(t.embedUrl);if ("string" != typeof r || 0 === r.length) throw new Error("Report id is required, but it was not found. You must provide an id either as part of embed configuration or as attribute '" + e.reportIdAttribute + "'.");return r;
	      }, e.prototype.getPages = function () {
	        var t = this;return n.isRDLEmbed(this.config.embedUrl) ? Promise.reject(l.APINotSupportedForRDLError) : this.service.hpm.get("/report/pages", { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (e) {
	          return e.body.map(function (e) {
	            return new s.Page(t, e.name, e.displayName, e.isActive, e.visibility, e.defaultSize, e.defaultDisplayOption);
	          });
	        }, function (t) {
	          throw t.body;
	        });
	      }, e.prototype.page = function (t, e, r, a) {
	        return new s.Page(this, t, e, r, a);
	      }, e.prototype.print = function () {
	        return n.isRDLEmbed(this.config.embedUrl) ? Promise.reject(l.APINotSupportedForRDLError) : this.service.hpm.post("/report/print", null, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        })["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.removeFilters = function () {
	        return n.isRDLEmbed(this.config.embedUrl) ? Promise.reject(l.APINotSupportedForRDLError) : this.setFilters([]);
	      }, e.prototype.setPage = function (t) {
	        if (n.isRDLEmbed(this.config.embedUrl)) return Promise.reject(l.APINotSupportedForRDLError);var e = { name: t, displayName: null, isActive: !0 };return this.service.hpm.put("/report/pages/active", e, { uid: this.config.uniqueId }, this.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.setFilters = function (t) {
	        return n.isRDLEmbed(this.config.embedUrl) ? Promise.reject(l.APINotSupportedForRDLError) : this.service.hpm.put("/report/filters", t, { uid: this.config.uniqueId }, this.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.updateSettings = function (t) {
	        return n.isRDLEmbed(this.config.embedUrl) && null != t.customLayout ? Promise.reject(l.APINotSupportedForRDLError) : this.service.hpm.patch("/report/settings", t, { uid: this.config.uniqueId }, this.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.validate = function (t) {
	        return o.validateReportLoad(t);
	      }, e.prototype.configChanged = function (t) {
	        var r = this.config;this.isMobileSettings(r.settings) && (r.embedUrl = n.addParamToUrl(r.embedUrl, "isMobile", "true"));var a = this.element.getAttribute(e.filterPaneEnabledAttribute),
	            i = this.element.getAttribute(e.navContentPaneEnabledAttribute),
	            o = { filterPaneEnabled: null == a ? d.Defaults.defaultSettings.filterPaneEnabled : "false" !== a, navContentPaneEnabled: null == i ? d.Defaults.defaultSettings.navContentPaneEnabled : "false" !== i };this.config.settings = n.assign({}, o, r.settings), t || (r.id = this.getId());
	      }, e.prototype.getDefaultEmbedUrlEndpoint = function () {
	        return "reportEmbed";
	      }, e.prototype.switchMode = function (t) {
	        var e;e = "string" == typeof t ? t : this.viewModeToString(t);var r = "/report/switchMode/" + e;return this.service.hpm.post(r, null, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        })["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.refresh = function () {
	        return this.service.hpm.post("/report/refresh", null, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        })["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.isSaved = function () {
	        return n.isRDLEmbed(this.config.embedUrl) ? Promise.reject(l.APINotSupportedForRDLError) : n.isSavedInternal(this.service.hpm, this.config.uniqueId, this.iframe.contentWindow);
	      }, e.prototype.applyTheme = function (t) {
	        return n.isRDLEmbed(this.config.embedUrl) ? Promise.reject(l.APINotSupportedForRDLError) : this.applyThemeInternal(t);
	      }, e.prototype.resetTheme = function () {
	        return n.isRDLEmbed(this.config.embedUrl) ? Promise.reject(l.APINotSupportedForRDLError) : this.applyThemeInternal({});
	      }, e.prototype.applyThemeInternal = function (t) {
	        return this.service.hpm.put("/report/theme", t, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        })["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.viewModeToString = function (t) {
	        var e;switch (t) {case o.ViewMode.Edit:
	            e = "edit";break;case o.ViewMode.View:
	            e = "view";}return e;
	      }, e.prototype.isMobileSettings = function (t) {
	        return t && (t.layoutType === o.LayoutType.MobileLandscape || t.layoutType === o.LayoutType.MobilePortrait);
	      }, e.allowedEvents = ["filtersApplied", "pageChanged", "commandTriggered", "swipeStart", "swipeEnd", "bookmarkApplied", "dataHyperlinkClicked"], e.reportIdAttribute = "powerbi-report-id", e.filterPaneEnabledAttribute = "powerbi-settings-filter-pane-enabled", e.navContentPaneEnabledAttribute = "powerbi-settings-nav-content-pane-enabled", e.typeAttribute = "powerbi-type", e.type = "Report", e;
	    }(i.Embed);e.Report = p;
	  }, function (t, e) {
	    e.APINotSupportedForRDLError = "This API is currently not supported for RDL reports";
	  }, function (t, e, r) {
	    var a = r(9),
	        i = r(5),
	        o = r(3),
	        n = r(7),
	        l = function () {
	      function t(t, e, r, a, i, o, n) {
	        this.report = t, this.name = e, this.displayName = r, this.isActive = a, this.visibility = i, this.defaultSize = o, this.defaultDisplayOption = n;
	      }return t.prototype.getFilters = function () {
	        return this.report.service.hpm.get("/report/pages/" + this.name + "/filters", { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, t.prototype.removeFilters = function () {
	        return this.setFilters([]);
	      }, t.prototype.setActive = function () {
	        var t = { name: this.name, displayName: null, isActive: !0 };return this.report.service.hpm.put("/report/pages/active", t, { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, t.prototype.setFilters = function (t) {
	        return this.report.service.hpm.put("/report/pages/" + this.name + "/filters", t, { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, t.prototype.getVisuals = function () {
	        var t = this;return o.isRDLEmbed(this.report.config.embedUrl) ? Promise.reject(n.APINotSupportedForRDLError) : this.report.service.hpm.get("/report/pages/" + this.name + "/visuals", { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow).then(function (e) {
	          return e.body.map(function (e) {
	            return new a.VisualDescriptor(t, e.name, e.title, e.type, e.layout);
	          });
	        }, function (t) {
	          throw t.body;
	        });
	      }, t.prototype.hasLayout = function (t) {
	        if (o.isRDLEmbed(this.report.config.embedUrl)) return Promise.reject(n.APINotSupportedForRDLError);var e = i.LayoutType[t];return this.report.service.hpm.get("/report/pages/" + this.name + "/layoutTypes/" + e, { uid: this.report.config.uniqueId }, this.report.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, t;
	    }();e.Page = l;
	  }, function (t, e) {
	    var r = function () {
	      function t(t, e, r, a, i) {
	        this.name = e, this.title = r, this.type = a, this.layout = i, this.page = t;
	      }return t.prototype.getFilters = function () {
	        return this.page.report.service.hpm.get("/report/pages/" + this.page.name + "/visuals/" + this.name + "/filters", { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, t.prototype.removeFilters = function () {
	        return this.setFilters([]);
	      }, t.prototype.setFilters = function (t) {
	        return this.page.report.service.hpm.put("/report/pages/" + this.page.name + "/visuals/" + this.name + "/filters", t, { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, t.prototype.exportData = function (t, e) {
	        var r = { rows: e, exportDataType: t };return this.page.report.service.hpm.post("/report/pages/" + this.page.name + "/visuals/" + this.name + "/exportData", r, { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, t.prototype.setSlicerState = function (t) {
	        return this.page.report.service.hpm.put("/report/pages/" + this.page.name + "/visuals/" + this.name + "/slicer", t, { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, t.prototype.getSlicerState = function () {
	        return this.page.report.service.hpm.get("/report/pages/" + this.page.name + "/visuals/" + this.name + "/slicer", { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, t.prototype.clone = function (t) {
	        return void 0 === t && (t = {}), this.page.report.service.hpm.post("/report/pages/" + this.page.name + "/visuals/" + this.name + "/clone", t, { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, t.prototype.sortBy = function (t) {
	        return this.page.report.service.hpm.put("/report/pages/" + this.page.name + "/visuals/" + this.name + "/sortBy", t, { uid: this.page.report.config.uniqueId }, this.page.report.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, t;
	    }();e.VisualDescriptor = r;
	  }, function (t, e) {
	    var r = function () {
	      function t() {}return t.defaultSettings = { filterPaneEnabled: !0 }, t.defaultQnaSettings = { filterPaneEnabled: !1 }, t;
	    }();e.Defaults = r;
	  }, function (t, e, r) {
	    var a = r(3),
	        i = r(7),
	        o = function () {
	      function t(t, e, r) {
	        this.service = t, this.config = e, this.iframe = r;
	      }return t.prototype.getBookmarks = function () {
	        return a.isRDLEmbed(this.config.embedUrl) ? Promise.reject(i.APINotSupportedForRDLError) : this.service.hpm.get("/report/bookmarks", { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, t.prototype.apply = function (t) {
	        if (a.isRDLEmbed(this.config.embedUrl)) return Promise.reject(i.APINotSupportedForRDLError);var e = { name: t };return this.service.hpm.post("/report/bookmarks/applyByName", e, { uid: this.config.uniqueId }, this.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, t.prototype.play = function (t) {
	        if (a.isRDLEmbed(this.config.embedUrl)) return Promise.reject(i.APINotSupportedForRDLError);var e = { playMode: t };return this.service.hpm.post("/report/bookmarks/play", e, { uid: this.config.uniqueId }, this.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, t.prototype.capture = function () {
	        return a.isRDLEmbed(this.config.embedUrl) ? Promise.reject(i.APINotSupportedForRDLError) : this.service.hpm.post("/report/bookmarks/capture", null, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, t.prototype.applyState = function (t) {
	        if (a.isRDLEmbed(this.config.embedUrl)) return Promise.reject(i.APINotSupportedForRDLError);var e = { state: t };return this.service.hpm.post("/report/bookmarks/applyState", e, { uid: this.config.uniqueId }, this.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, t;
	    }();e.BookmarksManager = o;
	  }, function (t, e, r) {
	    var a = this && this.__extends || function (t, e) {
	      function r() {
	        this.constructor = t;
	      }for (var a in e) {
	        e.hasOwnProperty(a) && (t[a] = e[a]);
	      }t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
	    },
	        i = r(5),
	        o = r(2),
	        n = r(3),
	        l = function (t) {
	      function e(e, r, a, i, o) {
	        t.call(this, e, r, a, void 0, i, o);
	      }return a(e, t), e.prototype.getId = function () {
	        var t = this.createConfig && this.createConfig.datasetId ? this.createConfig.datasetId : e.findIdFromEmbedUrl(this.config.embedUrl);if ("string" != typeof t || 0 === t.length) throw new Error("Dataset id is required, but it was not found. You must provide an id either as part of embed configuration.");return t;
	      }, e.prototype.validate = function (t) {
	        return i.validateCreateReport(t);
	      }, e.prototype.configChanged = function (t) {
	        if (!t) {
	          var e = this.config;this.createConfig = { accessToken: e.accessToken, datasetId: e.datasetId || this.getId(), groupId: e.groupId, settings: e.settings, tokenType: e.tokenType, theme: e.theme };
	        }
	      }, e.prototype.getDefaultEmbedUrlEndpoint = function () {
	        return "reportEmbed";
	      }, e.prototype.isSaved = function () {
	        return n.isSavedInternal(this.service.hpm, this.config.uniqueId, this.iframe.contentWindow);
	      }, e.findIdFromEmbedUrl = function (t) {
	        var e,
	            r = /datasetId="?([^&]+)"?/,
	            a = t.match(r);return a && (e = a[1]), e;
	      }, e;
	    }(o.Embed);e.Create = l;
	  }, function (t, e, r) {
	    var a = this && this.__extends || function (t, e) {
	      function r() {
	        this.constructor = t;
	      }for (var a in e) {
	        e.hasOwnProperty(a) && (t[a] = e[a]);
	      }t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
	    },
	        i = r(2),
	        o = r(5),
	        n = function (t) {
	      function e(r, a, i, o, n) {
	        t.call(this, r, a, i, void 0, o, n), this.loadPath = "/dashboard/load", this.phasedLoadPath = "/dashboard/prepare", Array.prototype.push.apply(this.allowedEvents, e.allowedEvents);
	      }return a(e, t), e.findIdFromEmbedUrl = function (t) {
	        var e,
	            r = /dashboardId="?([^&]+)"?/,
	            a = t.match(r);return a && (e = a[1]), e;
	      }, e.prototype.getId = function () {
	        var t = this.config,
	            r = t.id || this.element.getAttribute(e.dashboardIdAttribute) || e.findIdFromEmbedUrl(t.embedUrl);if ("string" != typeof r || 0 === r.length) throw new Error("Dashboard id is required, but it was not found. You must provide an id either as part of embed configuration or as attribute '" + e.dashboardIdAttribute + "'.");return r;
	      }, e.prototype.validate = function (t) {
	        var e = t,
	            r = o.validateDashboardLoad(e);return r ? r : this.ValidatePageView(e.pageView);
	      }, e.prototype.configChanged = function (t) {
	        t || (this.config.id = this.getId());
	      }, e.prototype.getDefaultEmbedUrlEndpoint = function () {
	        return "dashboardEmbed";
	      }, e.prototype.ValidatePageView = function (t) {
	        if (t && "fitToWidth" !== t && "oneColumn" !== t && "actualSize" !== t) return [{ message: "pageView must be one of the followings: fitToWidth, oneColumn, actualSize" }];
	      }, e.allowedEvents = ["tileClicked", "error"], e.dashboardIdAttribute = "powerbi-dashboard-id", e.typeAttribute = "powerbi-type", e.type = "Dashboard", e;
	    }(i.Embed);e.Dashboard = n;
	  }, function (t, e, r) {
	    var a = this && this.__extends || function (t, e) {
	      function r() {
	        this.constructor = t;
	      }for (var a in e) {
	        e.hasOwnProperty(a) && (t[a] = e[a]);
	      }t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
	    },
	        i = r(5),
	        o = r(2),
	        n = function (t) {
	      function e(r, a, i, o, n) {
	        var l = i;t.call(this, r, a, l, void 0, o, n), this.loadPath = "/tile/load", Array.prototype.push.apply(this.allowedEvents, e.allowedEvents);
	      }return a(e, t), e.prototype.getId = function () {
	        var t = this.config,
	            r = t.id || e.findIdFromEmbedUrl(this.config.embedUrl);if ("string" != typeof r || 0 === r.length) throw new Error("Tile id is required, but it was not found. You must provide an id either as part of embed configuration.");return r;
	      }, e.prototype.validate = function (t) {
	        var e = t;return i.validateTileLoad(e);
	      }, e.prototype.configChanged = function (t) {
	        t || (this.config.id = this.getId());
	      }, e.prototype.getDefaultEmbedUrlEndpoint = function () {
	        return "tileEmbed";
	      }, e.findIdFromEmbedUrl = function (t) {
	        var e,
	            r = /tileId="?([^&]+)"?/,
	            a = t.match(r);return a && (e = a[1]), e;
	      }, e.type = "Tile", e.allowedEvents = ["tileClicked", "tileLoaded"], e;
	    }(o.Embed);e.Tile = n;
	  }, function (t, e, r) {
	    var a = this && this.__extends || function (t, e) {
	      function r() {
	        this.constructor = t;
	      }for (var a in e) {
	        e.hasOwnProperty(a) && (t[a] = e[a]);
	      }t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
	    },
	        i = r(5),
	        o = r(2),
	        n = function (t) {
	      function e(r, a, i, o, n) {
	        t.call(this, r, a, i, void 0, o, n), this.loadPath = "/qna/load", this.phasedLoadPath = "/qna/prepare", Array.prototype.push.apply(this.allowedEvents, e.allowedEvents);
	      }return a(e, t), e.prototype.getId = function () {
	        return null;
	      }, e.prototype.setQuestion = function (t) {
	        var e = { question: t };return this.service.hpm.post("/qna/interpret", e, { uid: this.config.uniqueId }, this.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.configChanged = function (t) {}, e.prototype.getDefaultEmbedUrlEndpoint = function () {
	        return "qnaEmbed";
	      }, e.prototype.validate = function (t) {
	        return i.validateLoadQnaConfiguration(t);
	      }, e.type = "Qna", e.allowedEvents = ["loaded", "visualRendered"], e;
	    }(o.Embed);e.Qna = n;
	  }, function (t, e, r) {
	    var a = this && this.__extends || function (t, e) {
	      function r() {
	        this.constructor = t;
	      }for (var a in e) {
	        e.hasOwnProperty(a) && (t[a] = e[a]);
	      }t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
	    },
	        i = r(5),
	        o = r(6),
	        n = function (t) {
	      function e(e, r, a, i, o, n) {
	        t.call(this, e, r, a, i, o, n);
	      }return a(e, t), e.prototype.load = function (e, r) {
	        var a = e;if (a.accessToken) {
	          if ("string" != typeof a.pageName || 0 === a.pageName.length) throw new Error("Page name is required when embedding a visual.");if ("string" != typeof a.visualName || 0 === a.visualName.length) throw new Error("Visual name is required, but it was not found. You must provide a visual name as part of embed configuration.");var o = a.width ? a.width : this.iframe.offsetWidth,
	              n = a.height ? a.height : this.iframe.offsetHeight,
	              l = { type: i.PageSizeType.Custom, width: o, height: n },
	              s = {};return s[a.pageName] = { defaultLayout: { displayState: { mode: i.VisualContainerDisplayMode.Hidden } }, visualsLayout: {} }, s[a.pageName].visualsLayout[a.visualName] = { displayState: { mode: i.VisualContainerDisplayMode.Visible }, x: 1, y: 1, z: 1, width: l.width, height: l.height }, a.settings = a.settings || {}, a.settings.filterPaneEnabled = !1, a.settings.navContentPaneEnabled = !1, a.settings.layoutType = i.LayoutType.Custom, a.settings.customLayout = { displayOption: i.DisplayOption.FitToPage, pageSize: l, pagesLayout: s }, t.prototype.load.call(this, a, r);
	        }
	      }, e.prototype.getPages = function () {
	        throw e.GetPagesNotSupportedError;
	      }, e.prototype.setPage = function (t) {
	        throw e.SetPageNotSupportedError;
	      }, e.prototype.getFilters = function (t) {
	        var e = this.getFiltersLevelUrl(t);return this.service.hpm.get(e, { uid: this.config.uniqueId }, this.iframe.contentWindow).then(function (t) {
	          return t.body;
	        }, function (t) {
	          throw t.body;
	        });
	      }, e.prototype.setFilters = function (t, e) {
	        var r = this.getFiltersLevelUrl(e);return this.service.hpm.put(r, t, { uid: this.config.uniqueId }, this.iframe.contentWindow)["catch"](function (t) {
	          throw t.body;
	        });
	      }, e.prototype.removeFilters = function (t) {
	        return this.setFilters([], t);
	      }, e.prototype.getFiltersLevelUrl = function (t) {
	        var e = this.config;switch (t) {case i.FiltersLevel.Report:
	            return "/report/filters";case i.FiltersLevel.Page:
	            return "/report/pages/" + e.pageName + "/filters";default:
	            return "/report/pages/" + e.pageName + "/visuals/" + e.visualName + "/filters";}
	      }, e.type = "visual", e.GetPagesNotSupportedError = "Get pages is not supported while embedding a visual.", e.SetPageNotSupportedError = "Set page is not supported while embedding a visual.", e;
	    }(o.Report);e.Visual = n;
	  }, function (t, e, r) {
	    var a = r(4),
	        i = r(18),
	        o = r(19),
	        n = r(20);e.hpmFactory = function (t, e, r, i) {
	      return void 0 === r && (r = a["default"].version), void 0 === i && (i = a["default"].type), new o.HttpPostMessage(t, { "x-sdk-type": i, "x-sdk-version": r }, e);
	    }, e.wpmpFactory = function (t, e, r) {
	      return new i.WindowPostMessageProxy({ processTrackingProperties: { addTrackingProperties: o.HttpPostMessage.addTrackingProperties, getTrackingProperties: o.HttpPostMessage.getTrackingProperties }, isErrorMessage: o.HttpPostMessage.isErrorMessage, suppressWarnings: !0, name: t, logMessages: e, eventSourceOverrideWindow: r });
	    }, e.routerFactory = function (t) {
	      return new n.Router(t);
	    };
	  }, function (t, e, r) {
	    /*! window-post-message-proxy v0.2.6 | (c) 2016 Microsoft Corporation MIT */
	    !function (e, r) {
	      t.exports = r();
	    }(this, function () {
	      return function (t) {
	        function e(a) {
	          if (r[a]) return r[a].exports;var i = r[a] = { exports: {}, id: a, loaded: !1 };return t[a].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
	        }var r = {};return e.m = t, e.c = r, e.p = "", e(0);
	      }([function (t, e) {
	        "use strict";
	        var r = function () {
	          function t(e) {
	            var r = this;void 0 === e && (e = { processTrackingProperties: { addTrackingProperties: t.defaultAddTrackingProperties, getTrackingProperties: t.defaultGetTrackingProperties }, isErrorMessage: t.defaultIsErrorMessage, receiveWindow: window, name: t.createRandomString() }), this.pendingRequestPromises = {}, this.addTrackingProperties = e.processTrackingProperties && e.processTrackingProperties.addTrackingProperties || t.defaultAddTrackingProperties, this.getTrackingProperties = e.processTrackingProperties && e.processTrackingProperties.getTrackingProperties || t.defaultGetTrackingProperties, this.isErrorMessage = e.isErrorMessage || t.defaultIsErrorMessage, this.receiveWindow = e.receiveWindow || window, this.name = e.name || t.createRandomString(), this.logMessages = e.logMessages || !1, this.eventSourceOverrideWindow = e.eventSourceOverrideWindow, this.suppressWarnings = e.suppressWarnings || !1, this.logMessages && console.log("new WindowPostMessageProxy created with name: " + this.name + " receiving on window: " + this.receiveWindow.document.title), this.handlers = [], this.windowMessageHandler = function (t) {
	              return r.onMessageReceived(t);
	            }, this.start();
	          }return t.defaultAddTrackingProperties = function (e, r) {
	            return e[t.messagePropertyName] = r, e;
	          }, t.defaultGetTrackingProperties = function (e) {
	            return e[t.messagePropertyName];
	          }, t.defaultIsErrorMessage = function (t) {
	            return !!t.error;
	          }, t.createDeferred = function () {
	            var t = { resolve: null, reject: null, promise: null },
	                e = new Promise(function (e, r) {
	              t.resolve = e, t.reject = r;
	            });return t.promise = e, t;
	          }, t.createRandomString = function () {
	            var t = window.crypto || window.msCrypto,
	                e = new Uint32Array(1);return t.getRandomValues(e), e[0].toString(36).substring(1);
	          }, t.prototype.addHandler = function (t) {
	            this.handlers.push(t);
	          }, t.prototype.removeHandler = function (t) {
	            var e = this.handlers.indexOf(t);if (e === -1) throw new Error("You attempted to remove a handler but no matching handler was found.");this.handlers.splice(e, 1);
	          }, t.prototype.start = function () {
	            this.receiveWindow.addEventListener("message", this.windowMessageHandler);
	          }, t.prototype.stop = function () {
	            this.receiveWindow.removeEventListener("message", this.windowMessageHandler);
	          }, t.prototype.postMessage = function (e, r) {
	            var a = { id: t.createRandomString() };this.addTrackingProperties(r, a), this.logMessages && (console.log(this.name + " Posting message:"), console.log(JSON.stringify(r, null, "  "))), e.postMessage(r, "*");var i = t.createDeferred();return this.pendingRequestPromises[a.id] = i, i.promise;
	          }, t.prototype.sendResponse = function (t, e, r) {
	            this.addTrackingProperties(e, r), this.logMessages && (console.log(this.name + " Sending response:"), console.log(JSON.stringify(e, null, "  "))), t.postMessage(e, "*");
	          }, t.prototype.onMessageReceived = function (t) {
	            var e = this;this.logMessages && (console.log(this.name + " Received message:"), console.log("type: " + t.type), console.log(JSON.stringify(t.data, null, "  ")));var r = this.eventSourceOverrideWindow || t.source,
	                a = t.data;if ("object" != (typeof a === "undefined" ? "undefined" : _typeof(a))) return void (this.suppressWarnings || console.warn("Proxy(" + this.name + "): Received message that was not an object. Discarding message"));var i;try {
	              i = this.getTrackingProperties(a);
	            } catch (o) {
	              this.suppressWarnings || console.warn("Proxy(" + this.name + "): Error occurred when attempting to get tracking properties from incoming message:", JSON.stringify(a, null, "  "), "Error: ", o);
	            }var n;if (i && (n = this.pendingRequestPromises[i.id]), n) {
	              var l = !0;try {
	                l = this.isErrorMessage(a);
	              } catch (o) {
	                console.warn("Proxy(" + this.name + ") Error occurred when trying to determine if message is consider an error response. Message: ", JSON.stringify(a, null, ""), "Error: ", o);
	              }l ? n.reject(a) : n.resolve(a), delete this.pendingRequestPromises[i.id];
	            } else {
	              var s = this.handlers.some(function (t) {
	                var o = !1;try {
	                  o = t.test(a);
	                } catch (n) {
	                  e.suppressWarnings || console.warn("Proxy(" + e.name + "): Error occurred when handler was testing incoming message:", JSON.stringify(a, null, "  "), "Error: ", n);
	                }if (o) {
	                  var l = void 0;try {
	                    l = Promise.resolve(t.handle(a));
	                  } catch (n) {
	                    e.suppressWarnings || console.warn("Proxy(" + e.name + "): Error occurred when handler was processing incoming message:", JSON.stringify(a, null, "  "), "Error: ", n), l = Promise.resolve();
	                  }return l.then(function (t) {
	                    if (!t) {
	                      var o = "Handler for message: " + JSON.stringify(a, null, "  ") + " did not return a response message. The default response message will be returned instead.";e.suppressWarnings || console.warn("Proxy(" + e.name + "): " + o), t = { warning: o };
	                    }e.sendResponse(r, t, i);
	                  }), !0;
	                }
	              });s || this.suppressWarnings || console.warn("Proxy(" + this.name + ") did not handle message. Handlers: " + this.handlers.length + "  Message: " + JSON.stringify(a, null, "") + ".");
	            }
	          }, t.messagePropertyName = "windowPostMessageProxy", t;
	        }();e.WindowPostMessageProxy = r;
	      }]);
	    });
	  }, function (t, e, r) {
	    /*! http-post-message v0.2.3 | (c) 2016 Microsoft Corporation MIT */
	    !function (e, r) {
	      t.exports = r();
	    }(this, function () {
	      return function (t) {
	        function e(a) {
	          if (r[a]) return r[a].exports;var i = r[a] = { exports: {}, id: a, loaded: !1 };return t[a].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
	        }var r = {};return e.m = t, e.c = r, e.p = "", e(0);
	      }([function (t, e) {
	        "use strict";
	        var r = function () {
	          function t(t, e, r) {
	            void 0 === e && (e = {}), this.defaultHeaders = e, this.defaultTargetWindow = r, this.windowPostMessageProxy = t;
	          }return t.addTrackingProperties = function (t, e) {
	            return t.headers = t.headers || {}, e && e.id && (t.headers.id = e.id), t;
	          }, t.getTrackingProperties = function (t) {
	            return { id: t.headers && t.headers.id };
	          }, t.isErrorMessage = function (t) {
	            return "number" == typeof (t && t.statusCode) && !(200 <= t.statusCode && t.statusCode < 300);
	          }, t.prototype.get = function (t, e, r) {
	            return void 0 === e && (e = {}), void 0 === r && (r = this.defaultTargetWindow), this.send({ method: "GET", url: t, headers: e }, r);
	          }, t.prototype.post = function (t, e, r, a) {
	            return void 0 === r && (r = {}), void 0 === a && (a = this.defaultTargetWindow), this.send({ method: "POST", url: t, headers: r, body: e }, a);
	          }, t.prototype.put = function (t, e, r, a) {
	            return void 0 === r && (r = {}), void 0 === a && (a = this.defaultTargetWindow), this.send({ method: "PUT", url: t, headers: r, body: e }, a);
	          }, t.prototype.patch = function (t, e, r, a) {
	            return void 0 === r && (r = {}), void 0 === a && (a = this.defaultTargetWindow), this.send({ method: "PATCH", url: t, headers: r, body: e }, a);
	          }, t.prototype["delete"] = function (t, e, r, a) {
	            return void 0 === e && (e = null), void 0 === r && (r = {}), void 0 === a && (a = this.defaultTargetWindow), this.send({ method: "DELETE", url: t, headers: r, body: e }, a);
	          }, t.prototype.send = function (t, e) {
	            if (void 0 === e && (e = this.defaultTargetWindow), t.headers = this.assign({}, this.defaultHeaders, t.headers), !e) throw new Error("target window is not provided.  You must either provide the target window explicitly as argument to request, or specify default target window when constructing instance of this class.");return this.windowPostMessageProxy.postMessage(e, t);
	          }, t.prototype.assign = function (t) {
	            for (var e = [], r = 1; r < arguments.length; r++) {
	              e[r - 1] = arguments[r];
	            }if (void 0 === t || null === t) throw new TypeError("Cannot convert undefined or null to object");var a = Object(t);return e.forEach(function (t) {
	              if (void 0 !== t && null !== t) for (var e in t) {
	                Object.prototype.hasOwnProperty.call(t, e) && (a[e] = t[e]);
	              }
	            }), a;
	          }, t;
	        }();e.HttpPostMessage = r;
	      }]);
	    });
	  }, function (t, e, r) {
	    /*! powerbi-router v0.1.5 | (c) 2016 Microsoft Corporation MIT */
	    !function (e, r) {
	      t.exports = r();
	    }(this, function () {
	      return function (t) {
	        function e(a) {
	          if (r[a]) return r[a].exports;var i = r[a] = { exports: {}, id: a, loaded: !1 };return t[a].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
	        }var r = {};return e.m = t, e.c = r, e.p = "", e(0);
	      }([function (t, e, r) {
	        "use strict";
	        var a = r(1),
	            i = function () {
	          function t(t) {
	            this.handlers = t, this.getRouteRecognizer = new a(), this.patchRouteRecognizer = new a(), this.postRouteRecognizer = new a(), this.putRouteRecognizer = new a(), this.deleteRouteRecognizer = new a();
	          }return t.prototype.get = function (t, e) {
	            return this.registerHandler(this.getRouteRecognizer, "GET", t, e), this;
	          }, t.prototype.patch = function (t, e) {
	            return this.registerHandler(this.patchRouteRecognizer, "PATCH", t, e), this;
	          }, t.prototype.post = function (t, e) {
	            return this.registerHandler(this.postRouteRecognizer, "POST", t, e), this;
	          }, t.prototype.put = function (t, e) {
	            return this.registerHandler(this.putRouteRecognizer, "PUT", t, e), this;
	          }, t.prototype["delete"] = function (t, e) {
	            return this.registerHandler(this.deleteRouteRecognizer, "DELETE", t, e), this;
	          }, t.prototype.registerHandler = function (t, e, r, a) {
	            var i = function i(t) {
	              var e = new o();return Promise.resolve(a(t, e)).then(function (t) {
	                return e;
	              });
	            };t.add([{ path: r, handler: i }]);var n = { test: function test(r) {
	                if (r.method !== e) return !1;var a = t.recognize(r.url);if (void 0 === a) return !1;var i = a[0];return r.params = i.params, r.queryParams = a.queryParams, r.handler = i.handler, !0;
	              }, handle: function handle(t) {
	                return t.handler(t);
	              } };this.handlers.addHandler(n);
	          }, t;
	        }();e.Router = i;var o = function () {
	          function t() {
	            this.statusCode = 200, this.headers = {}, this.body = null;
	          }return t.prototype.send = function (t, e) {
	            this.statusCode = t, this.body = e;
	          }, t;
	        }();e.Response = o;
	      }, function (t, e, r) {
	        var a;(function (t) {
	          (function () {
	            "use strict";
	            function i(t, e, r) {
	              this.path = t, this.matcher = e, this.delegate = r;
	            }function o(t) {
	              this.routes = {}, this.children = {}, this.target = t;
	            }function n(t, e, r) {
	              return function (a, o) {
	                var l = t + a;return o ? void o(n(l, e, r)) : new i(t + a, e, r);
	              };
	            }function l(t, e, r) {
	              for (var a = 0, i = 0; i < t.length; i++) {
	                a += t[i].path.length;
	              }e = e.substr(a);var o = { path: e, handler: r };t.push(o);
	            }function s(t, e, r, a) {
	              var i = e.routes;for (var o in i) {
	                if (i.hasOwnProperty(o)) {
	                  var n = t.slice();l(n, o, i[o]), e.children[o] ? s(n, e.children[o], r, a) : r.call(a, n);
	                }
	              }
	            }function d(t) {
	              return "[object Array]" === Object.prototype.toString.call(t);
	            }function u(t) {
	              this.string = t;
	            }function p(t) {
	              this.name = t;
	            }function c(t) {
	              this.name = t;
	            }function f() {}function h(t, e, r) {
	              "/" === t.charAt(0) && (t = t.substr(1));var a = t.split("/"),
	                  i = new Array(a.length);r.val = "";for (var o = 0; o < a.length; o++) {
	                var n,
	                    l = a[o];(n = l.match(/^:([^\/]+)$/)) ? (i[o] = new p(n[1]), e.push(n[1]), r.val += "3") : (n = l.match(/^\*([^\/]+)$/)) ? (i[o] = new c(n[1]), r.val += "1", e.push(n[1])) : "" === l ? (i[o] = new f(), r.val += "2") : (i[o] = new u(l), r.val += "4");
	              }return r.val = +r.val, i;
	            }function v(t) {
	              this.charSpec = t, this.nextStates = [], this.charSpecs = {}, this.regex = void 0, this.handlers = void 0, this.specificity = void 0;
	            }function y(t) {
	              return t.sort(function (t, e) {
	                return e.specificity.val - t.specificity.val;
	              });
	            }function m(t, e) {
	              for (var r = [], a = 0, i = t.length; a < i; a++) {
	                var o = t[a];r = r.concat(o.match(e));
	              }return r;
	            }function g(t) {
	              this.queryParams = t || {};
	            }function V(t, e, r) {
	              var a = t.handlers,
	                  i = t.regex,
	                  o = e.match(i),
	                  n = 1,
	                  l = new g(r);l.length = a.length;for (var s = 0; s < a.length; s++) {
	                for (var d = a[s], u = d.names, p = {}, c = 0; c < u.length; c++) {
	                  p[u[c]] = o[n++];
	                }l[s] = { handler: d.handler, params: p, isDynamic: !!u.length };
	              }return l;
	            }function w(t) {
	              t = t.replace(/\+/gm, "%20");var e;try {
	                e = decodeURIComponent(t);
	              } catch (r) {
	                e = "";
	              }return e;
	            }i.prototype = { to: function to(t, e) {
	                var r = this.delegate;if (r && r.willAddRoute && (t = r.willAddRoute(this.matcher.target, t)), this.matcher.add(this.path, t), e) {
	                  if (0 === e.length) throw new Error("You must have an argument in the function passed to `to`");this.matcher.addChild(this.path, t, e, this.delegate);
	                }return this;
	              } }, o.prototype = { add: function add(t, e) {
	                this.routes[t] = e;
	              }, addChild: function addChild(t, e, r, a) {
	                var i = new o(e);this.children[t] = i;var l = n(t, i, a);a && a.contextEntered && a.contextEntered(e, l), r(l);
	              } };var b = function b(t, e) {
	              var r = new o();t(n("", r, this.delegate)), s([], r, function (t) {
	                e ? e(this, t) : this.add(t);
	              }, this);
	            },
	                E = ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\"],
	                S = new RegExp("(\\" + E.join("|\\") + ")", "g");u.prototype = { eachChar: function eachChar(t) {
	                for (var e, r = this.string, a = 0; a < r.length; a++) {
	                  e = r.charAt(a), t = t.put({ invalidChars: void 0, repeat: !1, validChars: e });
	                }return t;
	              }, regex: function regex() {
	                return this.string.replace(S, "\\$1");
	              }, generate: function generate() {
	                return this.string;
	              } }, p.prototype = { eachChar: function eachChar(t) {
	                return t.put({ invalidChars: "/", repeat: !0, validChars: void 0 });
	              }, regex: function regex() {
	                return "([^/]+)";
	              }, generate: function generate(t) {
	                return t[this.name];
	              } }, c.prototype = { eachChar: function eachChar(t) {
	                return t.put({ invalidChars: "", repeat: !0, validChars: void 0 });
	              }, regex: function regex() {
	                return "(.+)";
	              }, generate: function generate(t) {
	                return t[this.name];
	              } }, f.prototype = { eachChar: function eachChar(t) {
	                return t;
	              }, regex: function regex() {
	                return "";
	              }, generate: function generate() {
	                return "";
	              } }, v.prototype = { get: function get(t) {
	                if (this.charSpecs[t.validChars]) return this.charSpecs[t.validChars];for (var e = this.nextStates, r = 0; r < e.length; r++) {
	                  var a = e[r],
	                      i = a.charSpec.validChars === t.validChars;if (i = i && a.charSpec.invalidChars === t.invalidChars) return this.charSpecs[t.validChars] = a, a;
	                }
	              }, put: function put(t) {
	                var e;return (e = this.get(t)) ? e : (e = new v(t), this.nextStates.push(e), t.repeat && e.nextStates.push(e), e);
	              }, match: function match(t) {
	                for (var e, r, a, i = this.nextStates, o = [], n = 0; n < i.length; n++) {
	                  e = i[n], r = e.charSpec, "undefined" != typeof (a = r.validChars) ? a.indexOf(t) !== -1 && o.push(e) : "undefined" != typeof (a = r.invalidChars) && a.indexOf(t) === -1 && o.push(e);
	                }return o;
	              } };var T = Object.create || function (t) {
	              function e() {}return e.prototype = t, new e();
	            };g.prototype = T({ splice: Array.prototype.splice, slice: Array.prototype.slice, push: Array.prototype.push, length: 0, queryParams: null });var O = function O() {
	              this.rootState = new v(), this.names = {};
	            };O.prototype = { add: function add(t, e) {
	                for (var r, a = this.rootState, i = "^", o = {}, n = new Array(t.length), l = [], s = !0, d = 0; d < t.length; d++) {
	                  var u = t[d],
	                      p = [],
	                      c = h(u.path, p, o);l = l.concat(c);for (var v = 0; v < c.length; v++) {
	                    var y = c[v];y instanceof f || (s = !1, a = a.put({ invalidChars: void 0, repeat: !1, validChars: "/" }), i += "/", a = y.eachChar(a), i += y.regex());
	                  }var m = { handler: u.handler, names: p };n[d] = m;
	                }s && (a = a.put({ invalidChars: void 0, repeat: !1, validChars: "/" }), i += "/"), a.handlers = n, a.regex = new RegExp(i + "$"), a.specificity = o, (r = e && e.as) && (this.names[r] = { segments: l, handlers: n });
	              }, handlersFor: function handlersFor(t) {
	                var e = this.names[t];if (!e) throw new Error("There is no route named " + t);for (var r = new Array(e.handlers.length), a = 0; a < e.handlers.length; a++) {
	                  r[a] = e.handlers[a];
	                }return r;
	              }, hasRoute: function hasRoute(t) {
	                return !!this.names[t];
	              }, generate: function generate(t, e) {
	                var r = this.names[t],
	                    a = "";if (!r) throw new Error("There is no route named " + t);for (var i = r.segments, o = 0; o < i.length; o++) {
	                  var n = i[o];n instanceof f || (a += "/", a += n.generate(e));
	                }return "/" !== a.charAt(0) && (a = "/" + a), e && e.queryParams && (a += this.generateQueryString(e.queryParams, r.handlers)), a;
	              }, generateQueryString: function generateQueryString(t, e) {
	                var r = [],
	                    a = [];for (var i in t) {
	                  t.hasOwnProperty(i) && a.push(i);
	                }a.sort();for (var o = 0; o < a.length; o++) {
	                  i = a[o];var n = t[i];if (null != n) {
	                    var l = encodeURIComponent(i);if (d(n)) for (var s = 0; s < n.length; s++) {
	                      var u = i + "[]=" + encodeURIComponent(n[s]);r.push(u);
	                    } else l += "=" + encodeURIComponent(n), r.push(l);
	                  }
	                }return 0 === r.length ? "" : "?" + r.join("&");
	              }, parseQueryString: function parseQueryString(t) {
	                for (var e = t.split("&"), r = {}, a = 0; a < e.length; a++) {
	                  var i,
	                      o = e[a].split("="),
	                      n = w(o[0]),
	                      l = n.length,
	                      s = !1;1 === o.length ? i = "true" : (l > 2 && "[]" === n.slice(l - 2) && (s = !0, n = n.slice(0, l - 2), r[n] || (r[n] = [])), i = o[1] ? w(o[1]) : ""), s ? r[n].push(i) : r[n] = i;
	                }return r;
	              }, recognize: function recognize(t) {
	                var e,
	                    r,
	                    a,
	                    i = [this.rootState],
	                    o = {},
	                    n = !1;if (a = t.indexOf("?"), a !== -1) {
	                  var l = t.substr(a + 1, t.length);t = t.substr(0, a), o = this.parseQueryString(l);
	                }for (t = decodeURI(t), "/" !== t.charAt(0) && (t = "/" + t), e = t.length, e > 1 && "/" === t.charAt(e - 1) && (t = t.substr(0, e - 1), n = !0), r = 0; r < t.length && (i = m(i, t.charAt(r)), i.length); r++) {}var s = [];for (r = 0; r < i.length; r++) {
	                  i[r].handlers && s.push(i[r]);
	                }i = y(s);var d = s[0];if (d && d.handlers) return n && "(.+)$" === d.regex.source.slice(-5) && (t += "/"), V(d, t, o);
	              } }, O.prototype.map = b, O.VERSION = "0.1.11";var P = O;r(3).amd ? (a = function () {
	              return P;
	            }.call(e, r, e, t), !(void 0 !== a && (t.exports = a))) : "undefined" != typeof t && t.exports ? t.exports = P : "undefined" != typeof this && (this.RouteRecognizer = P);
	          }).call(this);
	        }).call(e, r(2)(t));
	      }, function (t, e) {
	        t.exports = function (t) {
	          return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children = [], t.webpackPolyfill = 1), t;
	        };
	      }, function (t, e) {
	        t.exports = function () {
	          throw new Error("define cannot be used indirect");
	        };
	      }]);
	    });
	  }]);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)(module)))

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	__webpack_require__(1075);
	
	// NOTE:
	// This file has been edited because
	// of issues with requiring fastclick
	// and npm not providing a new switchery
	// versions that actually works
	
	
	;(function () {
	
	  /**
	   * Require the module at `name`.
	   *
	   * @param {String} name
	   * @return {Object} exports
	   * @api public
	   */
	
	  function require(name) {
	    var module = require.modules[name];
	    if (!module) throw new Error('failed to require "' + name + '"');
	
	    if (!('exports' in module) && typeof module.definition === 'function') {
	      module.client = module.component = true;
	      module.definition.call(this, module.exports = {}, module);
	      delete module.definition;
	    }
	
	    return module.exports;
	  }
	
	  /**
	   * Meta info, accessible in the global scope unless you use AMD option.
	   */
	
	  require.loader = 'component';
	
	  /**
	   * Internal helper object, contains a sorting function for semantiv versioning
	   */
	  require.helper = {};
	  require.helper.semVerSort = function (a, b) {
	    var aArray = a.version.split('.');
	    var bArray = b.version.split('.');
	    for (var i = 0; i < aArray.length; ++i) {
	      var aInt = parseInt(aArray[i], 10);
	      var bInt = parseInt(bArray[i], 10);
	      if (aInt === bInt) {
	        var aLex = aArray[i].substr(("" + aInt).length);
	        var bLex = bArray[i].substr(("" + bInt).length);
	        if (aLex === '' && bLex !== '') return 1;
	        if (aLex !== '' && bLex === '') return -1;
	        if (aLex !== '' && bLex !== '') return aLex > bLex ? 1 : -1;
	        continue;
	      } else if (aInt > bInt) {
	        return 1;
	      } else {
	        return -1;
	      }
	    }
	    return 0;
	  };
	
	  /**
	   * Find and require a module which name starts with the provided name.
	   * If multiple modules exists, the highest semver is used. 
	   * This function can only be used for remote dependencies.
	  
	   * @param {String} name - module name: `user~repo`
	   * @param {Boolean} returnPath - returns the canonical require path if true, 
	   *                               otherwise it returns the epxorted module
	   */
	  require.latest = function (name, returnPath) {
	    function showError(name) {
	      throw new Error('failed to find latest module of "' + name + '"');
	    }
	    // only remotes with semvers, ignore local files conataining a '/'
	    var versionRegexp = /(.*)~(.*)@v?(\d+\.\d+\.\d+[^\/]*)$/;
	    var remoteRegexp = /(.*)~(.*)/;
	    if (!remoteRegexp.test(name)) showError(name);
	    var moduleNames = Object.keys(require.modules);
	    var semVerCandidates = [];
	    var otherCandidates = []; // for instance: name of the git branch
	    for (var i = 0; i < moduleNames.length; i++) {
	      var moduleName = moduleNames[i];
	      if (new RegExp(name + '@').test(moduleName)) {
	        var version = moduleName.substr(name.length + 1);
	        var semVerMatch = versionRegexp.exec(moduleName);
	        if (semVerMatch != null) {
	          semVerCandidates.push({ version: version, name: moduleName });
	        } else {
	          otherCandidates.push({ version: version, name: moduleName });
	        }
	      }
	    }
	    if (semVerCandidates.concat(otherCandidates).length === 0) {
	      showError(name);
	    }
	    if (semVerCandidates.length > 0) {
	      var module = semVerCandidates.sort(require.helper.semVerSort).pop().name;
	      if (returnPath === true) {
	        return module;
	      }
	      return require(module);
	    }
	    // if the build contains more than one branch of the same module
	    // you should not use this funciton
	    var module = otherCandidates.sort(function (a, b) {
	      return a.name > b.name;
	    })[0].name;
	    if (returnPath === true) {
	      return module;
	    }
	    return require(module);
	  };
	
	  /**
	   * Registered modules.
	   */
	
	  require.modules = {};
	
	  /**
	   * Register module at `name` with callback `definition`.
	   *
	   * @param {String} name
	   * @param {Function} definition
	   * @api private
	   */
	
	  require.register = function (name, definition) {
	    require.modules[name] = {
	      definition: definition
	    };
	  };
	
	  /**
	   * Define a module's exports immediately with `exports`.
	   *
	   * @param {String} name
	   * @param {Generic} exports
	   * @api private
	   */
	
	  require.define = function (name, exports) {
	    require.modules[name] = {
	      exports: exports
	    };
	  };
	  require.register("abpetkov~transitionize@0.0.3", function (exports, module) {
	
	    /**
	     * Transitionize 0.0.2
	     * https://github.com/abpetkov/transitionize
	     *
	     * Authored by Alexander Petkov
	     * https://github.com/abpetkov
	     *
	     * Copyright 2013, Alexander Petkov
	     * License: The MIT License (MIT)
	     * http://opensource.org/licenses/MIT
	     *
	     */
	
	    /**
	     * Expose `Transitionize`.
	     */
	
	    module.exports = Transitionize;
	
	    /**
	     * Initialize new Transitionize.
	     *
	     * @param {Object} element
	     * @param {Object} props
	     * @api public
	     */
	
	    function Transitionize(element, props) {
	      if (!(this instanceof Transitionize)) return new Transitionize(element, props);
	
	      this.element = element;
	      this.props = props || {};
	      this.init();
	    }
	
	    /**
	     * Detect if Safari.
	     *
	     * @returns {Boolean}
	     * @api private
	     */
	
	    Transitionize.prototype.isSafari = function () {
	      return (/Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)
	      );
	    };
	
	    /**
	     * Loop though the object and push the keys and values in an array.
	     * Apply the CSS3 transition to the element and prefix with -webkit- for Safari.
	     *
	     * @api private
	     */
	
	    Transitionize.prototype.init = function () {
	      var transitions = [];
	
	      for (var key in this.props) {
	        transitions.push(key + ' ' + this.props[key]);
	      }
	
	      this.element.style.transition = transitions.join(', ');
	      if (this.isSafari()) this.element.style.webkitTransition = transitions.join(', ');
	    };
	  });
	
	  require.register("ftlabs~fastclick@v0.6.11", function (exports, module) {
	    /**
	     * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	     *
	     * @version 0.6.11
	     * @codingstandard ftlabs-jsv2
	     * @copyright The Financial Times Limited [All Rights Reserved]
	     * @license MIT License (see LICENSE.txt)
	     */
	
	    /*jslint browser:true, node:true*/
	    /*global define, Event, Node*/
	
	    /**
	     * Instantiate fast-clicking listeners on the specificed layer.
	     *
	     * @constructor
	     * @param {Element} layer The layer to listen on
	     */
	    function FastClick(layer) {
	      'use strict';
	
	      var oldOnClick,
	          self = this;
	
	      /**
	       * Whether a click is currently being tracked.
	       *
	       * @type boolean
	       */
	      this.trackingClick = false;
	
	      /**
	       * Timestamp for when when click tracking started.
	       *
	       * @type number
	       */
	      this.trackingClickStart = 0;
	
	      /**
	       * The element being tracked for a click.
	       *
	       * @type EventTarget
	       */
	      this.targetElement = null;
	
	      /**
	       * X-coordinate of touch start event.
	       *
	       * @type number
	       */
	      this.touchStartX = 0;
	
	      /**
	       * Y-coordinate of touch start event.
	       *
	       * @type number
	       */
	      this.touchStartY = 0;
	
	      /**
	       * ID of the last touch, retrieved from Touch.identifier.
	       *
	       * @type number
	       */
	      this.lastTouchIdentifier = 0;
	
	      /**
	       * Touchmove boundary, beyond which a click will be cancelled.
	       *
	       * @type number
	       */
	      this.touchBoundary = 10;
	
	      /**
	       * The FastClick layer.
	       *
	       * @type Element
	       */
	      this.layer = layer;
	
	      if (!layer || !layer.nodeType) {
	        throw new TypeError('Layer must be a document node');
	      }
	
	      /** @type function() */
	      this.onClick = function () {
	        return FastClick.prototype.onClick.apply(self, arguments);
	      };
	
	      /** @type function() */
	      this.onMouse = function () {
	        return FastClick.prototype.onMouse.apply(self, arguments);
	      };
	
	      /** @type function() */
	      this.onTouchStart = function () {
	        return FastClick.prototype.onTouchStart.apply(self, arguments);
	      };
	
	      /** @type function() */
	      this.onTouchMove = function () {
	        return FastClick.prototype.onTouchMove.apply(self, arguments);
	      };
	
	      /** @type function() */
	      this.onTouchEnd = function () {
	        return FastClick.prototype.onTouchEnd.apply(self, arguments);
	      };
	
	      /** @type function() */
	      this.onTouchCancel = function () {
	        return FastClick.prototype.onTouchCancel.apply(self, arguments);
	      };
	
	      if (FastClick.notNeeded(layer)) {
	        return;
	      }
	
	      // Set up event handlers as required
	      if (this.deviceIsAndroid) {
	        layer.addEventListener('mouseover', this.onMouse, true);
	        layer.addEventListener('mousedown', this.onMouse, true);
	        layer.addEventListener('mouseup', this.onMouse, true);
	      }
	
	      layer.addEventListener('click', this.onClick, true);
	      layer.addEventListener('touchstart', this.onTouchStart, false);
	      layer.addEventListener('touchmove', this.onTouchMove, false);
	      layer.addEventListener('touchend', this.onTouchEnd, false);
	      layer.addEventListener('touchcancel', this.onTouchCancel, false);
	
	      // Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
	      // which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
	      // layer when they are cancelled.
	      if (!Event.prototype.stopImmediatePropagation) {
	        layer.removeEventListener = function (type, callback, capture) {
	          var rmv = Node.prototype.removeEventListener;
	          if (type === 'click') {
	            rmv.call(layer, type, callback.hijacked || callback, capture);
	          } else {
	            rmv.call(layer, type, callback, capture);
	          }
	        };
	
	        layer.addEventListener = function (type, callback, capture) {
	          var adv = Node.prototype.addEventListener;
	          if (type === 'click') {
	            adv.call(layer, type, callback.hijacked || (callback.hijacked = function (event) {
	              if (!event.propagationStopped) {
	                callback(event);
	              }
	            }), capture);
	          } else {
	            adv.call(layer, type, callback, capture);
	          }
	        };
	      }
	
	      // If a handler is already declared in the element's onclick attribute, it will be fired before
	      // FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
	      // adding it as listener.
	      if (typeof layer.onclick === 'function') {
	
	        // Android browser on at least 3.2 requires a new reference to the function in layer.onclick
	        // - the old one won't work if passed to addEventListener directly.
	        oldOnClick = layer.onclick;
	        layer.addEventListener('click', function (event) {
	          oldOnClick(event);
	        }, false);
	        layer.onclick = null;
	      }
	    }
	
	    /**
	     * Android requires exceptions.
	     *
	     * @type boolean
	     */
	    FastClick.prototype.deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0;
	
	    /**
	     * iOS requires exceptions.
	     *
	     * @type boolean
	     */
	    FastClick.prototype.deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent);
	
	    /**
	     * iOS 4 requires an exception for select elements.
	     *
	     * @type boolean
	     */
	    FastClick.prototype.deviceIsIOS4 = FastClick.prototype.deviceIsIOS && /OS 4_\d(_\d)?/.test(navigator.userAgent);
	
	    /**
	     * iOS 6.0(+?) requires the target element to be manually derived
	     *
	     * @type boolean
	     */
	    FastClick.prototype.deviceIsIOSWithBadTarget = FastClick.prototype.deviceIsIOS && /OS ([6-9]|\d{2})_\d/.test(navigator.userAgent);
	
	    /**
	     * Determine whether a given element requires a native click.
	     *
	     * @param {EventTarget|Element} target Target DOM element
	     * @returns {boolean} Returns true if the element needs a native click
	     */
	    FastClick.prototype.needsClick = function (target) {
	      'use strict';
	
	      switch (target.nodeName.toLowerCase()) {
	
	        // Don't send a synthetic click to disabled inputs (issue #62)
	        case 'button':
	        case 'select':
	        case 'textarea':
	          if (target.disabled) {
	            return true;
	          }
	
	          break;
	        case 'input':
	
	          // File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
	          if (this.deviceIsIOS && target.type === 'file' || target.disabled) {
	            return true;
	          }
	
	          break;
	        case 'label':
	        case 'video':
	          return true;
	      }
	
	      return (/\bneedsclick\b/.test(target.className)
	      );
	    };
	
	    /**
	     * Determine whether a given element requires a call to focus to simulate click into element.
	     *
	     * @param {EventTarget|Element} target Target DOM element
	     * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	     */
	    FastClick.prototype.needsFocus = function (target) {
	      'use strict';
	
	      switch (target.nodeName.toLowerCase()) {
	        case 'textarea':
	          return true;
	        case 'select':
	          return !this.deviceIsAndroid;
	        case 'input':
	          switch (target.type) {
	            case 'button':
	            case 'checkbox':
	            case 'file':
	            case 'image':
	            case 'radio':
	            case 'submit':
	              return false;
	          }
	
	          // No point in attempting to focus disabled inputs
	          return !target.disabled && !target.readOnly;
	        default:
	          return (/\bneedsfocus\b/.test(target.className)
	          );
	      }
	    };
	
	    /**
	     * Send a click event to the specified element.
	     *
	     * @param {EventTarget|Element} targetElement
	     * @param {Event} event
	     */
	    FastClick.prototype.sendClick = function (targetElement, event) {
	      'use strict';
	
	      var clickEvent, touch;
	
	      // On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
	      if (document.activeElement && document.activeElement !== targetElement) {
	        document.activeElement.blur();
	      }
	
	      touch = event.changedTouches[0];
	
	      // Synthesise a click event, with an extra attribute so it can be tracked
	      clickEvent = document.createEvent('MouseEvents');
	      clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
	      clickEvent.forwardedTouchEvent = true;
	      targetElement.dispatchEvent(clickEvent);
	    };
	
	    FastClick.prototype.determineEventType = function (targetElement) {
	      'use strict';
	
	      //Issue #159: Android Chrome Select Box does not open with a synthetic click event
	
	      if (this.deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
	        return 'mousedown';
	      }
	
	      return 'click';
	    };
	
	    /**
	     * @param {EventTarget|Element} targetElement
	     */
	    FastClick.prototype.focus = function (targetElement) {
	      'use strict';
	
	      var length;
	
	      // Issue #160: on iOS 7, some input elements (e.g. date datetime) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
	      if (this.deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time') {
	        length = targetElement.value.length;
	        targetElement.setSelectionRange(length, length);
	      } else {
	        targetElement.focus();
	      }
	    };
	
	    /**
	     * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	     *
	     * @param {EventTarget|Element} targetElement
	     */
	    FastClick.prototype.updateScrollParent = function (targetElement) {
	      'use strict';
	
	      var scrollParent, parentElement;
	
	      scrollParent = targetElement.fastClickScrollParent;
	
	      // Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
	      // target element was moved to another parent.
	      if (!scrollParent || !scrollParent.contains(targetElement)) {
	        parentElement = targetElement;
	        do {
	          if (parentElement.scrollHeight > parentElement.offsetHeight) {
	            scrollParent = parentElement;
	            targetElement.fastClickScrollParent = parentElement;
	            break;
	          }
	
	          parentElement = parentElement.parentElement;
	        } while (parentElement);
	      }
	
	      // Always update the scroll top tracker if possible.
	      if (scrollParent) {
	        scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
	      }
	    };
	
	    /**
	     * @param {EventTarget} targetElement
	     * @returns {Element|EventTarget}
	     */
	    FastClick.prototype.getTargetElementFromEventTarget = function (eventTarget) {
	      'use strict';
	
	      // On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
	
	      if (eventTarget.nodeType === Node.TEXT_NODE) {
	        return eventTarget.parentNode;
	      }
	
	      return eventTarget;
	    };
	
	    /**
	     * On touch start, record the position and scroll offset.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onTouchStart = function (event) {
	      'use strict';
	
	      var targetElement, touch, selection;
	
	      // Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
	      if (event.targetTouches.length > 1) {
	        return true;
	      }
	
	      targetElement = this.getTargetElementFromEventTarget(event.target);
	      touch = event.targetTouches[0];
	
	      if (this.deviceIsIOS) {
	
	        // Only trusted events will deselect text on iOS (issue #49)
	        selection = window.getSelection();
	        if (selection.rangeCount && !selection.isCollapsed) {
	          return true;
	        }
	
	        if (!this.deviceIsIOS4) {
	
	          // Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
	          // when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
	          // with the same identifier as the touch event that previously triggered the click that triggered the alert.
	          // Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
	          // immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
	          if (touch.identifier === this.lastTouchIdentifier) {
	            event.preventDefault();
	            return false;
	          }
	
	          this.lastTouchIdentifier = touch.identifier;
	
	          // If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
	          // 1) the user does a fling scroll on the scrollable layer
	          // 2) the user stops the fling scroll with another tap
	          // then the event.target of the last 'touchend' event will be the element that was under the user's finger
	          // when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
	          // is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
	          this.updateScrollParent(targetElement);
	        }
	      }
	
	      this.trackingClick = true;
	      this.trackingClickStart = event.timeStamp;
	      this.targetElement = targetElement;
	
	      this.touchStartX = touch.pageX;
	      this.touchStartY = touch.pageY;
	
	      // Prevent phantom clicks on fast double-tap (issue #36)
	      if (event.timeStamp - this.lastClickTime < 200) {
	        event.preventDefault();
	      }
	
	      return true;
	    };
	
	    /**
	     * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.touchHasMoved = function (event) {
	      'use strict';
	
	      var touch = event.changedTouches[0],
	          boundary = this.touchBoundary;
	
	      if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
	        return true;
	      }
	
	      return false;
	    };
	
	    /**
	     * Update the last position.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onTouchMove = function (event) {
	      'use strict';
	
	      if (!this.trackingClick) {
	        return true;
	      }
	
	      // If the touch has moved, cancel the click tracking
	      if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
	        this.trackingClick = false;
	        this.targetElement = null;
	      }
	
	      return true;
	    };
	
	    /**
	     * Attempt to find the labelled control for the given label element.
	     *
	     * @param {EventTarget|HTMLLabelElement} labelElement
	     * @returns {Element|null}
	     */
	    FastClick.prototype.findControl = function (labelElement) {
	      'use strict';
	
	      // Fast path for newer browsers supporting the HTML5 control attribute
	
	      if (labelElement.control !== undefined) {
	        return labelElement.control;
	      }
	
	      // All browsers under test that support touch events also support the HTML5 htmlFor attribute
	      if (labelElement.htmlFor) {
	        return document.getElementById(labelElement.htmlFor);
	      }
	
	      // If no for attribute exists, attempt to retrieve the first labellable descendant element
	      // the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
	      return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	    };
	
	    /**
	     * On touch end, determine whether to send a click event at once.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onTouchEnd = function (event) {
	      'use strict';
	
	      var forElement,
	          trackingClickStart,
	          targetTagName,
	          scrollParent,
	          touch,
	          targetElement = this.targetElement;
	
	      if (!this.trackingClick) {
	        return true;
	      }
	
	      // Prevent phantom clicks on fast double-tap (issue #36)
	      if (event.timeStamp - this.lastClickTime < 200) {
	        this.cancelNextClick = true;
	        return true;
	      }
	
	      // Reset to prevent wrong click cancel on input (issue #156).
	      this.cancelNextClick = false;
	
	      this.lastClickTime = event.timeStamp;
	
	      trackingClickStart = this.trackingClickStart;
	      this.trackingClick = false;
	      this.trackingClickStart = 0;
	
	      // On some iOS devices, the targetElement supplied with the event is invalid if the layer
	      // is performing a transition or scroll, and has to be re-detected manually. Note that
	      // for this to function correctly, it must be called *after* the event target is checked!
	      // See issue #57; also filed as rdar://13048589 .
	      if (this.deviceIsIOSWithBadTarget) {
	        touch = event.changedTouches[0];
	
	        // In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
	        targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
	        targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
	      }
	
	      targetTagName = targetElement.tagName.toLowerCase();
	      if (targetTagName === 'label') {
	        forElement = this.findControl(targetElement);
	        if (forElement) {
	          this.focus(targetElement);
	          if (this.deviceIsAndroid) {
	            return false;
	          }
	
	          targetElement = forElement;
	        }
	      } else if (this.needsFocus(targetElement)) {
	
	        // Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
	        // Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
	        if (event.timeStamp - trackingClickStart > 100 || this.deviceIsIOS && window.top !== window && targetTagName === 'input') {
	          this.targetElement = null;
	          return false;
	        }
	
	        this.focus(targetElement);
	
	        // Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
	        if (!this.deviceIsIOS4 || targetTagName !== 'select') {
	          this.targetElement = null;
	          event.preventDefault();
	        }
	
	        return false;
	      }
	
	      if (this.deviceIsIOS && !this.deviceIsIOS4) {
	
	        // Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
	        // and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
	        scrollParent = targetElement.fastClickScrollParent;
	        if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
	          return true;
	        }
	      }
	
	      // Prevent the actual click from going though - unless the target node is marked as requiring
	      // real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
	      if (!this.needsClick(targetElement)) {
	        event.preventDefault();
	        this.sendClick(targetElement, event);
	      }
	
	      return false;
	    };
	
	    /**
	     * On touch cancel, stop tracking the click.
	     *
	     * @returns {void}
	     */
	    FastClick.prototype.onTouchCancel = function () {
	      'use strict';
	
	      this.trackingClick = false;
	      this.targetElement = null;
	    };
	
	    /**
	     * Determine mouse events which should be permitted.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onMouse = function (event) {
	      'use strict';
	
	      // If a target element was never set (because a touch event was never fired) allow the event
	
	      if (!this.targetElement) {
	        return true;
	      }
	
	      if (event.forwardedTouchEvent) {
	        return true;
	      }
	
	      // Programmatically generated events targeting a specific element should be permitted
	      if (!event.cancelable) {
	        return true;
	      }
	
	      // Derive and check the target element to see whether the mouse event needs to be permitted;
	      // unless explicitly enabled, prevent non-touch click events from triggering actions,
	      // to prevent ghost/doubleclicks.
	      if (!this.needsClick(this.targetElement) || this.cancelNextClick) {
	
	        // Prevent any user-added listeners declared on FastClick element from being fired.
	        if (event.stopImmediatePropagation) {
	          event.stopImmediatePropagation();
	        } else {
	
	          // Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
	          event.propagationStopped = true;
	        }
	
	        // Cancel the event
	        event.stopPropagation();
	        event.preventDefault();
	
	        return false;
	      }
	
	      // If the mouse event is permitted, return true for the action to go through.
	      return true;
	    };
	
	    /**
	     * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	     * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	     * an actual click which should be permitted.
	     *
	     * @param {Event} event
	     * @returns {boolean}
	     */
	    FastClick.prototype.onClick = function (event) {
	      'use strict';
	
	      var permitted;
	
	      // It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
	      if (this.trackingClick) {
	        this.targetElement = null;
	        this.trackingClick = false;
	        return true;
	      }
	
	      // Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
	      if (event.target.type === 'submit' && event.detail === 0) {
	        return true;
	      }
	
	      permitted = this.onMouse(event);
	
	      // Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
	      if (!permitted) {
	        this.targetElement = null;
	      }
	
	      // If clicks are permitted, return true for the action to go through.
	      return permitted;
	    };
	
	    /**
	     * Remove all FastClick's event listeners.
	     *
	     * @returns {void}
	     */
	    FastClick.prototype.destroy = function () {
	      'use strict';
	
	      var layer = this.layer;
	
	      if (this.deviceIsAndroid) {
	        layer.removeEventListener('mouseover', this.onMouse, true);
	        layer.removeEventListener('mousedown', this.onMouse, true);
	        layer.removeEventListener('mouseup', this.onMouse, true);
	      }
	
	      layer.removeEventListener('click', this.onClick, true);
	      layer.removeEventListener('touchstart', this.onTouchStart, false);
	      layer.removeEventListener('touchmove', this.onTouchMove, false);
	      layer.removeEventListener('touchend', this.onTouchEnd, false);
	      layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	    };
	
	    /**
	     * Check whether FastClick is needed.
	     *
	     * @param {Element} layer The layer to listen on
	     */
	    FastClick.notNeeded = function (layer) {
	      'use strict';
	
	      var metaViewport;
	      var chromeVersion;
	
	      // Devices that don't support touch don't need FastClick
	      if (typeof window.ontouchstart === 'undefined') {
	        return true;
	      }
	
	      // Chrome version - zero for other browsers
	      chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1];
	
	      if (chromeVersion) {
	
	        if (FastClick.prototype.deviceIsAndroid) {
	          metaViewport = document.querySelector('meta[name=viewport]');
	
	          if (metaViewport) {
	            // Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
	            if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
	              return true;
	            }
	            // Chrome 32 and above with width=device-width or less don't need FastClick
	            if (chromeVersion > 31 && window.innerWidth <= window.screen.width) {
	              return true;
	            }
	          }
	
	          // Chrome desktop doesn't need FastClick (issue #15)
	        } else {
	          return true;
	        }
	      }
	
	      // IE10 with -ms-touch-action: none, which disables double-tap-to-zoom (issue #97)
	      if (layer.style.msTouchAction === 'none') {
	        return true;
	      }
	
	      return false;
	    };
	
	    /**
	     * Factory method for creating a FastClick object
	     *
	     * @param {Element} layer The layer to listen on
	     */
	    FastClick.attach = function (layer) {
	      'use strict';
	
	      return new FastClick(layer);
	    };
	
	    // NOTE:
	    // This file has been edited because
	    // of issues with requiring fastclick
	    // and npm not providing a new switchery
	    // versions that actually works
	    if (true) {
	
	      // AMD. Register as an anonymous module.
	      module.exports = FastClick.attach;
	      module.exports.FastClick = FastClick;
	    }
	
	    // if (typeof define !== 'undefined' && define.amd) {
	
	    //   // AMD. Register as an anonymous module.
	    //   define(function() {
	    //     'use strict';
	    //     return FastClick;
	    //   });
	    // } else if (typeof module !== 'undefined' && module.exports) {
	    //   module.exports = FastClick.attach;
	    //   module.exports.FastClick = FastClick;
	    // } else {
	    //   window.FastClick = FastClick;
	    // }
	  });
	
	  require.register("component~indexof@0.0.3", function (exports, module) {
	    module.exports = function (arr, obj) {
	      if (arr.indexOf) return arr.indexOf(obj);
	      for (var i = 0; i < arr.length; ++i) {
	        if (arr[i] === obj) return i;
	      }
	      return -1;
	    };
	  });
	
	  require.register("component~classes@1.2.1", function (exports, module) {
	    /**
	     * Module dependencies.
	     */
	
	    var index = require('component~indexof@0.0.3');
	
	    /**
	     * Whitespace regexp.
	     */
	
	    var re = /\s+/;
	
	    /**
	     * toString reference.
	     */
	
	    var toString = Object.prototype.toString;
	
	    /**
	     * Wrap `el` in a `ClassList`.
	     *
	     * @param {Element} el
	     * @return {ClassList}
	     * @api public
	     */
	
	    module.exports = function (el) {
	      return new ClassList(el);
	    };
	
	    /**
	     * Initialize a new ClassList for `el`.
	     *
	     * @param {Element} el
	     * @api private
	     */
	
	    function ClassList(el) {
	      if (!el) throw new Error('A DOM element reference is required');
	      this.el = el;
	      this.list = el.classList;
	    }
	
	    /**
	     * Add class `name` if not already present.
	     *
	     * @param {String} name
	     * @return {ClassList}
	     * @api public
	     */
	
	    ClassList.prototype.add = function (name) {
	      // classList
	      if (this.list) {
	        this.list.add(name);
	        return this;
	      }
	
	      // fallback
	      var arr = this.array();
	      var i = index(arr, name);
	      if (!~i) arr.push(name);
	      this.el.className = arr.join(' ');
	      return this;
	    };
	
	    /**
	     * Remove class `name` when present, or
	     * pass a regular expression to remove
	     * any which match.
	     *
	     * @param {String|RegExp} name
	     * @return {ClassList}
	     * @api public
	     */
	
	    ClassList.prototype.remove = function (name) {
	      if ('[object RegExp]' == toString.call(name)) {
	        return this.removeMatching(name);
	      }
	
	      // classList
	      if (this.list) {
	        this.list.remove(name);
	        return this;
	      }
	
	      // fallback
	      var arr = this.array();
	      var i = index(arr, name);
	      if (~i) arr.splice(i, 1);
	      this.el.className = arr.join(' ');
	      return this;
	    };
	
	    /**
	     * Remove all classes matching `re`.
	     *
	     * @param {RegExp} re
	     * @return {ClassList}
	     * @api private
	     */
	
	    ClassList.prototype.removeMatching = function (re) {
	      var arr = this.array();
	      for (var i = 0; i < arr.length; i++) {
	        if (re.test(arr[i])) {
	          this.remove(arr[i]);
	        }
	      }
	      return this;
	    };
	
	    /**
	     * Toggle class `name`, can force state via `force`.
	     *
	     * For browsers that support classList, but do not support `force` yet,
	     * the mistake will be detected and corrected.
	     *
	     * @param {String} name
	     * @param {Boolean} force
	     * @return {ClassList}
	     * @api public
	     */
	
	    ClassList.prototype.toggle = function (name, force) {
	      // classList
	      if (this.list) {
	        if ("undefined" !== typeof force) {
	          if (force !== this.list.toggle(name, force)) {
	            this.list.toggle(name); // toggle again to correct
	          }
	        } else {
	          this.list.toggle(name);
	        }
	        return this;
	      }
	
	      // fallback
	      if ("undefined" !== typeof force) {
	        if (!force) {
	          this.remove(name);
	        } else {
	          this.add(name);
	        }
	      } else {
	        if (this.has(name)) {
	          this.remove(name);
	        } else {
	          this.add(name);
	        }
	      }
	
	      return this;
	    };
	
	    /**
	     * Return an array of classes.
	     *
	     * @return {Array}
	     * @api public
	     */
	
	    ClassList.prototype.array = function () {
	      var str = this.el.className.replace(/^\s+|\s+$/g, '');
	      var arr = str.split(re);
	      if ('' === arr[0]) arr.shift();
	      return arr;
	    };
	
	    /**
	     * Check if class `name` is present.
	     *
	     * @param {String} name
	     * @return {ClassList}
	     * @api public
	     */
	
	    ClassList.prototype.has = ClassList.prototype.contains = function (name) {
	      return this.list ? this.list.contains(name) : !!~index(this.array(), name);
	    };
	  });
	
	  require.register("component~event@0.1.4", function (exports, module) {
	    var bind = window.addEventListener ? 'addEventListener' : 'attachEvent',
	        unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent',
	        prefix = bind !== 'addEventListener' ? 'on' : '';
	
	    /**
	     * Bind `el` event `type` to `fn`.
	     *
	     * @param {Element} el
	     * @param {String} type
	     * @param {Function} fn
	     * @param {Boolean} capture
	     * @return {Function}
	     * @api public
	     */
	
	    exports.bind = function (el, type, fn, capture) {
	      el[bind](prefix + type, fn, capture || false);
	      return fn;
	    };
	
	    /**
	     * Unbind `el` event `type`'s callback `fn`.
	     *
	     * @param {Element} el
	     * @param {String} type
	     * @param {Function} fn
	     * @param {Boolean} capture
	     * @return {Function}
	     * @api public
	     */
	
	    exports.unbind = function (el, type, fn, capture) {
	      el[unbind](prefix + type, fn, capture || false);
	      return fn;
	    };
	  });
	
	  require.register("component~query@0.0.3", function (exports, module) {
	    function one(selector, el) {
	      return el.querySelector(selector);
	    }
	
	    exports = module.exports = function (selector, el) {
	      el = el || document;
	      return one(selector, el);
	    };
	
	    exports.all = function (selector, el) {
	      el = el || document;
	      return el.querySelectorAll(selector);
	    };
	
	    exports.engine = function (obj) {
	      if (!obj.one) throw new Error('.one callback required');
	      if (!obj.all) throw new Error('.all callback required');
	      one = obj.one;
	      exports.all = obj.all;
	      return exports;
	    };
	  });
	
	  require.register("component~matches-selector@0.1.5", function (exports, module) {
	    /**
	     * Module dependencies.
	     */
	
	    var query = require('component~query@0.0.3');
	
	    /**
	     * Element prototype.
	     */
	
	    var proto = Element.prototype;
	
	    /**
	     * Vendor function.
	     */
	
	    var vendor = proto.matches || proto.webkitMatchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector;
	
	    /**
	     * Expose `match()`.
	     */
	
	    module.exports = match;
	
	    /**
	     * Match `el` to `selector`.
	     *
	     * @param {Element} el
	     * @param {String} selector
	     * @return {Boolean}
	     * @api public
	     */
	
	    function match(el, selector) {
	      if (!el || el.nodeType !== 1) return false;
	      if (vendor) return vendor.call(el, selector);
	      var nodes = query.all(selector, el.parentNode);
	      for (var i = 0; i < nodes.length; ++i) {
	        if (nodes[i] == el) return true;
	      }
	      return false;
	    }
	  });
	
	  require.register("component~closest@0.1.4", function (exports, module) {
	    var matches = require('component~matches-selector@0.1.5');
	
	    module.exports = function (element, selector, checkYoSelf, root) {
	      element = checkYoSelf ? { parentNode: element } : element;
	
	      root = root || document;
	
	      // Make sure `element !== document` and `element != null`
	      // otherwise we get an illegal invocation
	      while ((element = element.parentNode) && element !== document) {
	        if (matches(element, selector)) return element;
	        // After `matches` on the edge case that
	        // the selector matches the root
	        // (when the root is not the document)
	        if (element === root) return;
	      }
	    };
	  });
	
	  require.register("component~delegate@0.2.3", function (exports, module) {
	    /**
	     * Module dependencies.
	     */
	
	    var closest = require('component~closest@0.1.4'),
	        event = require('component~event@0.1.4');
	
	    /**
	     * Delegate event `type` to `selector`
	     * and invoke `fn(e)`. A callback function
	     * is returned which may be passed to `.unbind()`.
	     *
	     * @param {Element} el
	     * @param {String} selector
	     * @param {String} type
	     * @param {Function} fn
	     * @param {Boolean} capture
	     * @return {Function}
	     * @api public
	     */
	
	    exports.bind = function (el, selector, type, fn, capture) {
	      return event.bind(el, type, function (e) {
	        var target = e.target || e.srcElement;
	        e.delegateTarget = closest(target, selector, true, el);
	        if (e.delegateTarget) fn.call(el, e);
	      }, capture);
	    };
	
	    /**
	     * Unbind event `type`'s callback `fn`.
	     *
	     * @param {Element} el
	     * @param {String} type
	     * @param {Function} fn
	     * @param {Boolean} capture
	     * @api public
	     */
	
	    exports.unbind = function (el, type, fn, capture) {
	      event.unbind(el, type, fn, capture);
	    };
	  });
	
	  require.register("component~events@1.0.9", function (exports, module) {
	
	    /**
	     * Module dependencies.
	     */
	
	    var events = require('component~event@0.1.4');
	    var delegate = require('component~delegate@0.2.3');
	
	    /**
	     * Expose `Events`.
	     */
	
	    module.exports = Events;
	
	    /**
	     * Initialize an `Events` with the given
	     * `el` object which events will be bound to,
	     * and the `obj` which will receive method calls.
	     *
	     * @param {Object} el
	     * @param {Object} obj
	     * @api public
	     */
	
	    function Events(el, obj) {
	      if (!(this instanceof Events)) return new Events(el, obj);
	      if (!el) throw new Error('element required');
	      if (!obj) throw new Error('object required');
	      this.el = el;
	      this.obj = obj;
	      this._events = {};
	    }
	
	    /**
	     * Subscription helper.
	     */
	
	    Events.prototype.sub = function (event, method, cb) {
	      this._events[event] = this._events[event] || {};
	      this._events[event][method] = cb;
	    };
	
	    /**
	     * Bind to `event` with optional `method` name.
	     * When `method` is undefined it becomes `event`
	     * with the "on" prefix.
	     *
	     * Examples:
	     *
	     *  Direct event handling:
	     *
	     *    events.bind('click') // implies "onclick"
	     *    events.bind('click', 'remove')
	     *    events.bind('click', 'sort', 'asc')
	     *
	     *  Delegated event handling:
	     *
	     *    events.bind('click li > a')
	     *    events.bind('click li > a', 'remove')
	     *    events.bind('click a.sort-ascending', 'sort', 'asc')
	     *    events.bind('click a.sort-descending', 'sort', 'desc')
	     *
	     * @param {String} event
	     * @param {String|function} [method]
	     * @return {Function} callback
	     * @api public
	     */
	
	    Events.prototype.bind = function (event, method) {
	      var e = parse(event);
	      var el = this.el;
	      var obj = this.obj;
	      var name = e.name;
	      var method = method || 'on' + name;
	      var args = [].slice.call(arguments, 2);
	
	      // callback
	      function cb() {
	        var a = [].slice.call(arguments).concat(args);
	        obj[method].apply(obj, a);
	      }
	
	      // bind
	      if (e.selector) {
	        cb = delegate.bind(el, e.selector, name, cb);
	      } else {
	        events.bind(el, name, cb);
	      }
	
	      // subscription for unbinding
	      this.sub(name, method, cb);
	
	      return cb;
	    };
	
	    /**
	     * Unbind a single binding, all bindings for `event`,
	     * or all bindings within the manager.
	     *
	     * Examples:
	     *
	     *  Unbind direct handlers:
	     *
	     *     events.unbind('click', 'remove')
	     *     events.unbind('click')
	     *     events.unbind()
	     *
	     * Unbind delegate handlers:
	     *
	     *     events.unbind('click', 'remove')
	     *     events.unbind('click')
	     *     events.unbind()
	     *
	     * @param {String|Function} [event]
	     * @param {String|Function} [method]
	     * @api public
	     */
	
	    Events.prototype.unbind = function (event, method) {
	      if (0 == arguments.length) return this.unbindAll();
	      if (1 == arguments.length) return this.unbindAllOf(event);
	
	      // no bindings for this event
	      var bindings = this._events[event];
	      if (!bindings) return;
	
	      // no bindings for this method
	      var cb = bindings[method];
	      if (!cb) return;
	
	      events.unbind(this.el, event, cb);
	    };
	
	    /**
	     * Unbind all events.
	     *
	     * @api private
	     */
	
	    Events.prototype.unbindAll = function () {
	      for (var event in this._events) {
	        this.unbindAllOf(event);
	      }
	    };
	
	    /**
	     * Unbind all events for `event`.
	     *
	     * @param {String} event
	     * @api private
	     */
	
	    Events.prototype.unbindAllOf = function (event) {
	      var bindings = this._events[event];
	      if (!bindings) return;
	
	      for (var method in bindings) {
	        this.unbind(event, method);
	      }
	    };
	
	    /**
	     * Parse `event`.
	     *
	     * @param {String} event
	     * @return {Object}
	     * @api private
	     */
	
	    function parse(event) {
	      var parts = event.split(/ +/);
	      return {
	        name: parts.shift(),
	        selector: parts.join(' ')
	      };
	    }
	  });
	
	  require.register("switchery", function (exports, module) {
	    /**
	     * Switchery 0.8.1
	     * http://abpetkov.github.io/switchery/
	     *
	     * Authored by Alexander Petkov
	     * https://github.com/abpetkov
	     *
	     * Copyright 2013-2015, Alexander Petkov
	     * License: The MIT License (MIT)
	     * http://opensource.org/licenses/MIT
	     *
	     */
	
	    /**
	     * External dependencies.
	     */
	
	    var transitionize = require('abpetkov~transitionize@0.0.3'),
	        fastclick = require('ftlabs~fastclick@v0.6.11'),
	        classes = require('component~classes@1.2.1'),
	        events = require('component~events@1.0.9');
	
	    /**
	     * Expose `Switchery`.
	     */
	
	    module.exports = Switchery;
	
	    /**
	     * Set Switchery default values.
	     *
	     * @api public
	     */
	
	    var defaults = {
	      color: '#64bd63',
	      secondaryColor: '#dfdfdf',
	      jackColor: '#fff',
	      jackSecondaryColor: null,
	      className: 'switchery',
	      disabled: false,
	      disabledOpacity: 0.5,
	      speed: '0.4s',
	      size: 'default'
	    };
	
	    /**
	     * Create Switchery object.
	     *
	     * @param {Object} element
	     * @param {Object} options
	     * @api public
	     */
	
	    function Switchery(element, options) {
	      if (!(this instanceof Switchery)) return new Switchery(element, options);
	
	      this.element = element;
	      this.options = options || {};
	
	      for (var i in defaults) {
	        if (this.options[i] == null) {
	          this.options[i] = defaults[i];
	        }
	      }
	
	      if (this.element != null && this.element.type == 'checkbox') this.init();
	      if (this.isDisabled() === true) this.disable();
	    }
	
	    /**
	     * Hide the target element.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.hide = function () {
	      this.element.style.display = 'none';
	    };
	
	    /**
	     * Show custom switch after the target element.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.show = function () {
	      var switcher = this.create();
	      this.insertAfter(this.element, switcher);
	    };
	
	    /**
	     * Create custom switch.
	     *
	     * @returns {Object} this.switcher
	     * @api private
	     */
	
	    Switchery.prototype.create = function () {
	      this.switcher = document.createElement('span');
	      this.jack = document.createElement('small');
	      this.switcher.appendChild(this.jack);
	      this.switcher.className = this.options.className;
	      this.events = events(this.switcher, this);
	
	      return this.switcher;
	    };
	
	    /**
	     * Insert after element after another element.
	     *
	     * @param {Object} reference
	     * @param {Object} target
	     * @api private
	     */
	
	    Switchery.prototype.insertAfter = function (reference, target) {
	      reference.parentNode.insertBefore(target, reference.nextSibling);
	    };
	
	    /**
	     * Set switch jack proper position.
	     *
	     * @param {Boolean} clicked - we need this in order to uncheck the input when the switch is clicked
	     * @api private
	     */
	
	    Switchery.prototype.setPosition = function (clicked) {
	      var checked = this.isChecked(),
	          switcher = this.switcher,
	          jack = this.jack;
	
	      if (clicked && checked) checked = false;else if (clicked && !checked) checked = true;
	
	      if (checked === true) {
	        this.element.checked = true;
	
	        if (window.getComputedStyle) jack.style.left = parseInt(window.getComputedStyle(switcher).width) - parseInt(window.getComputedStyle(jack).width) + 'px';else jack.style.left = parseInt(switcher.currentStyle['width']) - parseInt(jack.currentStyle['width']) + 'px';
	
	        if (this.options.color) this.colorize();
	        this.setSpeed();
	      } else {
	        jack.style.left = 0;
	        this.element.checked = false;
	        this.switcher.style.boxShadow = 'inset 0 0 0 0 ' + this.options.secondaryColor;
	        this.switcher.style.borderColor = this.options.secondaryColor;
	        this.switcher.style.backgroundColor = this.options.secondaryColor !== defaults.secondaryColor ? this.options.secondaryColor : '#fff';
	        this.jack.style.backgroundColor = this.options.jackSecondaryColor !== this.options.jackColor ? this.options.jackSecondaryColor : this.options.jackColor;
	        this.setSpeed();
	      }
	    };
	
	    /**
	     * Set speed.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.setSpeed = function () {
	      var switcherProp = {},
	          jackProp = {
	        'background-color': this.options.speed,
	        'left': this.options.speed.replace(/[a-z]/, '') / 2 + 's'
	      };
	
	      if (this.isChecked()) {
	        switcherProp = {
	          'border': this.options.speed,
	          'box-shadow': this.options.speed,
	          'background-color': this.options.speed.replace(/[a-z]/, '') * 3 + 's'
	        };
	      } else {
	        switcherProp = {
	          'border': this.options.speed,
	          'box-shadow': this.options.speed
	        };
	      }
	
	      transitionize(this.switcher, switcherProp);
	      transitionize(this.jack, jackProp);
	    };
	
	    /**
	     * Set switch size.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.setSize = function () {
	      var small = 'switchery-small',
	          normal = 'switchery-default',
	          large = 'switchery-large';
	
	      switch (this.options.size) {
	        case 'small':
	          classes(this.switcher).add(small);
	          break;
	        case 'large':
	          classes(this.switcher).add(large);
	          break;
	        default:
	          classes(this.switcher).add(normal);
	          break;
	      }
	    };
	
	    /**
	     * Set switch color.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.colorize = function () {
	      var switcherHeight = this.switcher.offsetHeight / 2;
	
	      this.switcher.style.backgroundColor = this.options.color;
	      this.switcher.style.borderColor = this.options.color;
	      this.switcher.style.boxShadow = 'inset 0 0 0 ' + switcherHeight + 'px ' + this.options.color;
	      this.jack.style.backgroundColor = this.options.jackColor;
	    };
	
	    /**
	     * Handle the onchange event.
	     *
	     * @param {Boolean} state
	     * @api private
	     */
	
	    Switchery.prototype.handleOnchange = function (state) {
	      if (document.dispatchEvent) {
	        var event = document.createEvent('HTMLEvents');
	        event.initEvent('change', true, true);
	        this.element.dispatchEvent(event);
	      } else {
	        this.element.fireEvent('onchange');
	      }
	    };
	
	    /**
	     * Handle the native input element state change.
	     * A `change` event must be fired in order to detect the change.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.handleChange = function () {
	      var self = this,
	          el = this.element;
	
	      if (el.addEventListener) {
	        el.addEventListener('change', function () {
	          self.setPosition();
	        });
	      } else {
	        el.attachEvent('onchange', function () {
	          self.setPosition();
	        });
	      }
	    };
	
	    /**
	     * Handle the switch click event.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.handleClick = function () {
	      var switcher = this.switcher;
	
	      fastclick(switcher);
	      this.events.bind('click', 'bindClick');
	    };
	
	    /**
	     * Attach all methods that need to happen on switcher click.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.bindClick = function () {
	      var parent = this.element.parentNode.tagName.toLowerCase(),
	          labelParent = parent === 'label' ? false : true;
	
	      this.setPosition(labelParent);
	      this.handleOnchange(this.element.checked);
	    };
	
	    /**
	     * Mark an individual switch as already handled.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.markAsSwitched = function () {
	      this.element.setAttribute('data-switchery', true);
	    };
	
	    /**
	     * Check if an individual switch is already handled.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.markedAsSwitched = function () {
	      return this.element.getAttribute('data-switchery');
	    };
	
	    /**
	     * Initialize Switchery.
	     *
	     * @api private
	     */
	
	    Switchery.prototype.init = function () {
	      this.hide();
	      this.show();
	      this.setSize();
	      this.setPosition();
	      this.markAsSwitched();
	      this.handleChange();
	      this.handleClick();
	    };
	
	    /**
	     * See if input is checked.
	     *
	     * @returns {Boolean}
	     * @api public
	     */
	
	    Switchery.prototype.isChecked = function () {
	      return this.element.checked;
	    };
	
	    /**
	     * See if switcher should be disabled.
	     *
	     * @returns {Boolean}
	     * @api public
	     */
	
	    Switchery.prototype.isDisabled = function () {
	      return this.options.disabled || this.element.disabled || this.element.readOnly;
	    };
	
	    /**
	     * Destroy all event handlers attached to the switch.
	     *
	     * @api public
	     */
	
	    Switchery.prototype.destroy = function () {
	      this.events.unbind();
	    };
	
	    /**
	     * Enable disabled switch element.
	     *
	     * @api public
	     */
	
	    Switchery.prototype.enable = function () {
	      if (this.options.disabled) this.options.disabled = false;
	      if (this.element.disabled) this.element.disabled = false;
	      if (this.element.readOnly) this.element.readOnly = false;
	      this.switcher.style.opacity = 1;
	      this.events.bind('click', 'bindClick');
	    };
	
	    /**
	     * Disable switch element.
	     *
	     * @api public
	     */
	
	    Switchery.prototype.disable = function () {
	      if (!this.options.disabled) this.options.disabled = true;
	      if (!this.element.disabled) this.element.disabled = true;
	      if (!this.element.readOnly) this.element.readOnly = true;
	      this.switcher.style.opacity = this.options.disabledOpacity;
	      this.destroy();
	    };
	  });
	
	  if (( false ? 'undefined' : _typeof(exports)) == "object") {
	    module.exports = require("switchery");
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return require("switchery");
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    (this || window)["Switchery"] = require("switchery");
	  }
	})();

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_jquery2.default.base64 = function ($) {
	
	  var _PADCHAR = "=",
	      _ALPHA = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
	      _VERSION = "1.0";
	
	  function _getbyte64(s, i) {
	    // This is oddly fast, except on Chrome/V8.
	    // Minimal or no improvement in performance by using a
	    // object with properties mapping chars to value (eg. 'A': 0)
	
	    var idx = _ALPHA.indexOf(s.charAt(i));
	
	    if (idx === -1) {
	      throw "Cannot decode base64";
	    }
	
	    return idx;
	  }
	
	  function _decode(s) {
	    var pads = 0,
	        i,
	        b10,
	        imax = s.length,
	        x = [];
	
	    s = String(s);
	
	    if (imax === 0) {
	      return s;
	    }
	
	    if (imax % 4 !== 0) {
	      throw "Cannot decode base64";
	    }
	
	    if (s.charAt(imax - 1) === _PADCHAR) {
	      pads = 1;
	
	      if (s.charAt(imax - 2) === _PADCHAR) {
	        pads = 2;
	      }
	
	      // either way, we want to ignore this last block
	      imax -= 4;
	    }
	
	    for (i = 0; i < imax; i += 4) {
	      b10 = _getbyte64(s, i) << 18 | _getbyte64(s, i + 1) << 12 | _getbyte64(s, i + 2) << 6 | _getbyte64(s, i + 3);
	      x.push(String.fromCharCode(b10 >> 16, b10 >> 8 & 0xff, b10 & 0xff));
	    }
	
	    switch (pads) {
	      case 1:
	        b10 = _getbyte64(s, i) << 18 | _getbyte64(s, i + 1) << 12 | _getbyte64(s, i + 2) << 6;
	        x.push(String.fromCharCode(b10 >> 16, b10 >> 8 & 0xff));
	        break;
	
	      case 2:
	        b10 = _getbyte64(s, i) << 18 | _getbyte64(s, i + 1) << 12;
	        x.push(String.fromCharCode(b10 >> 16));
	        break;
	    }
	
	    return x.join("");
	  }
	
	  function _getbyte(s, i) {
	    var x = s.charCodeAt(i);
	
	    if (x > 255) {
	      throw "INVALID_CHARACTER_ERR: DOM Exception 5";
	    }
	
	    return x;
	  }
	
	  function _encode(s) {
	    if (arguments.length !== 1) {
	      throw "SyntaxError: exactly one argument required";
	    }
	
	    s = String(s);
	
	    var i,
	        b10,
	        x = [],
	        imax = s.length - s.length % 3;
	
	    if (s.length === 0) {
	      return s;
	    }
	
	    for (i = 0; i < imax; i += 3) {
	      b10 = _getbyte(s, i) << 16 | _getbyte(s, i + 1) << 8 | _getbyte(s, i + 2);
	      x.push(_ALPHA.charAt(b10 >> 18));
	      x.push(_ALPHA.charAt(b10 >> 12 & 0x3F));
	      x.push(_ALPHA.charAt(b10 >> 6 & 0x3f));
	      x.push(_ALPHA.charAt(b10 & 0x3f));
	    }
	
	    switch (s.length - imax) {
	      case 1:
	        b10 = _getbyte(s, i) << 16;
	        x.push(_ALPHA.charAt(b10 >> 18) + _ALPHA.charAt(b10 >> 12 & 0x3F) + _PADCHAR + _PADCHAR);
	        break;
	
	      case 2:
	        b10 = _getbyte(s, i) << 16 | _getbyte(s, i + 1) << 8;
	        x.push(_ALPHA.charAt(b10 >> 18) + _ALPHA.charAt(b10 >> 12 & 0x3F) + _ALPHA.charAt(b10 >> 6 & 0x3f) + _PADCHAR);
	        break;
	    }
	
	    return x.join("");
	  }
	
	  return {
	    decode: _decode,
	    encode: _encode,
	    VERSION: _VERSION
	  };
	}(_jquery2.default); /*jslint adsafe: false, bitwise: true, browser: true, cap: false, css: false,
	                       debug: false, devel: true, eqeqeq: true, es5: false, evil: false,
	                       forin: false, fragment: false, immed: true, laxbreak: false, newcap: true,
	                       nomen: false, on: false, onevar: true, passfail: false, plusplus: true,
	                       regexp: false, rhino: true, safe: false, strict: false, sub: false,
	                       undef: true, white: false, widget: false, windows: false */
	/*global jQuery: false, window: false */
	//"use strict";
	
	/*
	 * Original code (c) 2010 Nick Galbreath
	 * http://code.google.com/p/stringencoders/source/browse/#svn/trunk/javascript
	 *
	 * jQuery port (c) 2010 Carlo Zottmann
	 * http://github.com/carlo/jquery-base64
	 *
	 * Permission is hereby granted, free of charge, to any person
	 * obtaining a copy of this software and associated documentation
	 * files (the "Software"), to deal in the Software without
	 * restriction, including without limitation the rights to use,
	 * copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the
	 * Software is furnished to do so, subject to the following
	 * conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	 * OTHER DEALINGS IN THE SOFTWARE.
	*/
	
	/* base64 encode/decode compatible with window.btoa/atob
	 *
	 * window.atob/btoa is a Firefox extension to convert binary data (the "b")
	 * to base64 (ascii, the "a").
	 *
	 * It is also found in Safari and Chrome.  It is not available in IE.
	 *
	 * if (!window.btoa) window.btoa = $.base64.encode
	 * if (!window.atob) window.atob = $.base64.decode
	 *
	 * The original spec's for atob/btoa are a bit lacking
	 * https://developer.mozilla.org/en/DOM/window.atob
	 * https://developer.mozilla.org/en/DOM/window.btoa
	 *
	 * window.btoa and $.base64.encode takes a string where charCodeAt is [0,255]
	 * If any character is not [0,255], then an exception is thrown.
	 *
	 * window.atob and $.base64.decode take a base64-encoded string
	 * If the input length is not a multiple of 4, or contains invalid characters
	 *   then an exception is thrown.
	 */

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = jsPDF;
	
	var _base = __webpack_require__(484);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _sprintf = __webpack_require__(485);
	
	var _sprintf2 = _interopRequireDefault(_sprintf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * jsPDF
	 * (c) 2009 James Hall
	 * 
	 * Some parts based on FPDF.
	 */
	function jsPDF() {
	
	  // Private properties
	  var version = '20090504';
	  var buffer = '';
	
	  var pdfVersion = '1.3'; // PDF Version
	  var defaultPageFormat = 'a4';
	  var pageFormats = { // Size in mm of various paper formats
	    'a3': [841.89, 1190.55],
	    'a4': [595.28, 841.89],
	    'a5': [420.94, 595.28],
	    'letter': [612, 792],
	    'legal': [612, 1008]
	  };
	  var textColor = '0 g';
	  var page = 0;
	  var objectNumber = 2; // 'n' Current object number
	  var state = 0; // Current document state
	  var pages = new Array();
	  var offsets = new Array(); // List of offsets
	  var lineWidth = 0.200025; // 2mm
	  var pageHeight;
	  var k; // Scale factor
	  var unit = 'mm'; // Default to mm for units
	  var fontNumber; // TODO: This is temp, replace with real font handling
	  var documentProperties = {};
	  var fontSize = 16; // Default font size
	  var pageFontSize = 16;
	
	  // Initilisation 
	  if (unit == 'pt') {
	    k = 1;
	  } else if (unit == 'mm') {
	    k = 72 / 25.4;
	  } else if (unit == 'cm') {
	    k = 72 / 2.54;
	  } else if (unit == 'in') {
	    k = 72;
	  }
	
	  // Private functions
	  var newObject = function newObject() {
	    //Begin a new object
	    objectNumber++;
	    offsets[objectNumber] = buffer.length;
	    out(objectNumber + ' 0 obj');
	  };
	
	  var putHeader = function putHeader() {
	    out('%PDF-' + pdfVersion);
	  };
	
	  var putPages = function putPages() {
	
	    // TODO: Fix, hardcoded to a4 portrait
	    var wPt = pageWidth * k;
	    var hPt = pageHeight * k;
	
	    for (n = 1; n <= page; n++) {
	      newObject();
	      out('<</Type /Page');
	      out('/Parent 1 0 R');
	      out('/Resources 2 0 R');
	      out('/Contents ' + (objectNumber + 1) + ' 0 R>>');
	      out('endobj');
	
	      //Page content
	      p = pages[n];
	      newObject();
	      out('<</Length ' + p.length + '>>');
	      putStream(p);
	      out('endobj');
	    }
	    offsets[1] = buffer.length;
	    out('1 0 obj');
	    out('<</Type /Pages');
	    var kids = '/Kids [';
	    for (i = 0; i < page; i++) {
	      kids += 3 + 2 * i + ' 0 R ';
	    }
	    out(kids + ']');
	    out('/Count ' + page);
	    out((0, _sprintf2.default)('/MediaBox [0 0 %.2f %.2f]', wPt, hPt));
	    out('>>');
	    out('endobj');
	  };
	
	  var putStream = function putStream(str) {
	    out('stream');
	    out(str);
	    out('endstream');
	  };
	
	  var putResources = function putResources() {
	    putFonts();
	    putImages();
	
	    //Resource dictionary
	    offsets[2] = buffer.length;
	    out('2 0 obj');
	    out('<<');
	    putResourceDictionary();
	    out('>>');
	    out('endobj');
	  };
	
	  var putFonts = function putFonts() {
	    // TODO: Only supports core font hardcoded to Helvetica
	    newObject();
	    fontNumber = objectNumber;
	    name = 'Helvetica';
	    out('<</Type /Font');
	    out('/BaseFont /' + name);
	    out('/Subtype /Type1');
	    out('/Encoding /WinAnsiEncoding');
	    out('>>');
	    out('endobj');
	  };
	
	  var putImages = function putImages() {
	    // TODO
	  };
	
	  var putResourceDictionary = function putResourceDictionary() {
	    out('/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]');
	    out('/Font <<');
	    // Do this for each font, the '1' bit is the index of the font
	    // fontNumber is currently the object number related to 'putFonts'
	    out('/F1 ' + fontNumber + ' 0 R');
	    out('>>');
	    out('/XObject <<');
	    putXobjectDict();
	    out('>>');
	  };
	
	  var putXobjectDict = function putXobjectDict() {
	    // TODO
	    // Loop through images
	  };
	
	  var putInfo = function putInfo() {
	    out('/Producer (jsPDF ' + version + ')');
	    if (documentProperties.title != undefined) {
	      out('/Title (' + pdfEscape(documentProperties.title) + ')');
	    }
	    if (documentProperties.subject != undefined) {
	      out('/Subject (' + pdfEscape(documentProperties.subject) + ')');
	    }
	    if (documentProperties.author != undefined) {
	      out('/Author (' + pdfEscape(documentProperties.author) + ')');
	    }
	    if (documentProperties.keywords != undefined) {
	      out('/Keywords (' + pdfEscape(documentProperties.keywords) + ')');
	    }
	    if (documentProperties.creator != undefined) {
	      out('/Creator (' + pdfEscape(documentProperties.creator) + ')');
	    }
	    var created = new Date();
	    var year = created.getFullYear();
	    var month = created.getMonth() + 1;
	    var day = created.getDate();
	    var hour = created.getHours();
	    var minute = created.getMinutes();
	    var second = created.getSeconds();
	    out('/CreationDate (D:' + (0, _sprintf2.default)('%02d%02d%02d%02d%02d%02d', year, month, day, hour, minute, second) + ')');
	  };
	
	  var putCatalog = function putCatalog() {
	    out('/Type /Catalog');
	    out('/Pages 1 0 R');
	    // TODO: Add zoom and layout modes
	    out('/OpenAction [3 0 R /FitH null]');
	    out('/PageLayout /OneColumn');
	  };
	
	  function putTrailer() {
	    out('/Size ' + (objectNumber + 1));
	    out('/Root ' + objectNumber + ' 0 R');
	    out('/Info ' + (objectNumber - 1) + ' 0 R');
	  }
	
	  var endDocument = function endDocument() {
	    state = 1;
	    putHeader();
	    putPages();
	
	    putResources();
	    //Info
	    newObject();
	    out('<<');
	    putInfo();
	    out('>>');
	    out('endobj');
	
	    //Catalog
	    newObject();
	    out('<<');
	    putCatalog();
	    out('>>');
	    out('endobj');
	
	    //Cross-ref
	    var o = buffer.length;
	    out('xref');
	    out('0 ' + (objectNumber + 1));
	    out('0000000000 65535 f ');
	    for (var i = 1; i <= objectNumber; i++) {
	      out((0, _sprintf2.default)('%010d 00000 n ', offsets[i]));
	    }
	    //Trailer
	    out('trailer');
	    out('<<');
	    putTrailer();
	    out('>>');
	    out('startxref');
	    out(o);
	    out('%%EOF');
	    state = 3;
	  };
	
	  var beginPage = function beginPage() {
	    page++;
	    // Do dimension stuff
	    state = 2;
	    pages[page] = '';
	
	    // TODO: Hardcoded at A4 and portrait
	    pageHeight = pageFormats['a4'][1] / k;
	    pageWidth = pageFormats['a4'][0] / k;
	  };
	
	  var out = function out(string) {
	    if (state == 2) {
	      pages[page] += string + '\n';
	    } else {
	      buffer += string + '\n';
	    }
	  };
	
	  var _addPage = function _addPage() {
	    beginPage();
	    // Set line width
	    out((0, _sprintf2.default)('%.2f w', lineWidth * k));
	
	    // Set font - TODO
	    // 16 is the font size
	    pageFontSize = fontSize;
	    out('BT /F1 ' + parseInt(fontSize) + '.00 Tf ET');
	  };
	
	  // Add the first page automatically
	  _addPage();
	
	  // Escape text
	  var pdfEscape = function pdfEscape(text) {
	    return text.replace(/\\/g, '\\\\').replace(/\(/g, '\\(').replace(/\)/g, '\\)');
	  };
	
	  return {
	    addPage: function addPage() {
	      _addPage();
	    },
	    text: function text(x, y, _text) {
	      // need page height
	      if (pageFontSize != fontSize) {
	        out('BT /F1 ' + parseInt(fontSize) + '.00 Tf ET');
	        pageFontSize = fontSize;
	      }
	      var str = (0, _sprintf2.default)('BT %.2f %.2f Td (%s) Tj ET', x * k, (pageHeight - y) * k, pdfEscape(_text));
	      out(str);
	    },
	    setProperties: function setProperties(properties) {
	      documentProperties = properties;
	    },
	    addImage: function addImage(imageData, format, x, y, w, h) {},
	    output: function output(type, options) {
	      endDocument();
	      if (type == undefined) {
	        return buffer;
	      }
	      if (type == 'datauri') {
	        document.location.href = 'data:application/pdf;base64,' + _base2.default.encode(buffer);
	      }
	      // @TODO: Add different output options
	    },
	    setFontSize: function setFontSize(size) {
	      fontSize = size;
	    }
	  };
	};

/***/ },
/* 484 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	/**
	*
	*  Base64 encode / decode
	*  http://www.webtoolkit.info/
	*
	**/
	
	var Base64 = {
	
	  // private property
	  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
	
	  // public method for encoding
	  encode: function encode(input) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = Base64._utf8_encode(input);
	
	    while (i < input.length) {
	
	      chr1 = input.charCodeAt(i++);
	      chr2 = input.charCodeAt(i++);
	      chr3 = input.charCodeAt(i++);
	
	      enc1 = chr1 >> 2;
	      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
	      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
	      enc4 = chr3 & 63;
	
	      if (isNaN(chr2)) {
	        enc3 = enc4 = 64;
	      } else if (isNaN(chr3)) {
	        enc4 = 64;
	      }
	
	      output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
	    }
	
	    return output;
	  },
	
	  // public method for decoding
	  decode: function decode(input) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    while (i < input.length) {
	
	      enc1 = this._keyStr.indexOf(input.charAt(i++));
	      enc2 = this._keyStr.indexOf(input.charAt(i++));
	      enc3 = this._keyStr.indexOf(input.charAt(i++));
	      enc4 = this._keyStr.indexOf(input.charAt(i++));
	
	      chr1 = enc1 << 2 | enc2 >> 4;
	      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
	      chr3 = (enc3 & 3) << 6 | enc4;
	
	      output = output + String.fromCharCode(chr1);
	
	      if (enc3 != 64) {
	        output = output + String.fromCharCode(chr2);
	      }
	      if (enc4 != 64) {
	        output = output + String.fromCharCode(chr3);
	      }
	    }
	
	    output = Base64._utf8_decode(output);
	
	    return output;
	  },
	
	  // private method for UTF-8 encoding
	  _utf8_encode: function _utf8_encode(string) {
	    string = string.replace(/\r\n/g, "\n");
	    var utftext = "";
	
	    for (var n = 0; n < string.length; n++) {
	
	      var c = string.charCodeAt(n);
	
	      if (c < 128) {
	        utftext += String.fromCharCode(c);
	      } else if (c > 127 && c < 2048) {
	        utftext += String.fromCharCode(c >> 6 | 192);
	        utftext += String.fromCharCode(c & 63 | 128);
	      } else {
	        utftext += String.fromCharCode(c >> 12 | 224);
	        utftext += String.fromCharCode(c >> 6 & 63 | 128);
	        utftext += String.fromCharCode(c & 63 | 128);
	      }
	    }
	
	    return utftext;
	  },
	
	  // private method for UTF-8 decoding
	  _utf8_decode: function _utf8_decode(utftext) {
	    var string = "";
	    var i = 0;
	    var c = c1 = c2 = 0;
	
	    while (i < utftext.length) {
	
	      c = utftext.charCodeAt(i);
	
	      if (c < 128) {
	        string += String.fromCharCode(c);
	        i++;
	      } else if (c > 191 && c < 224) {
	        c2 = utftext.charCodeAt(i + 1);
	        string += String.fromCharCode((c & 31) << 6 | c2 & 63);
	        i += 2;
	      } else {
	        c2 = utftext.charCodeAt(i + 1);
	        c3 = utftext.charCodeAt(i + 2);
	        string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
	        i += 3;
	      }
	    }
	
	    return string;
	  }
	
	};
	
	exports.default = Base64;

/***/ },
/* 485 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = sprintf;
	function sprintf() {
	    // Return a formatted string  
	    // 
	    // version: 903.3016
	    // discuss at: http://phpjs.org/functions/sprintf
	    // +   original by: Ash Searle (http://hexmen.com/blog/)
	    // + namespaced by: Michael White (http://getsprink.com)
	    // +    tweaked by: Jack
	    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	    // +      input by: Paulo Ricardo F. Santos
	    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	    // +      input by: Brett Zamir (http://brettz9.blogspot.com)
	    // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
	    // *     example 1: sprintf("%01.2f", 123.1);
	    // *     returns 1: 123.10
	    // *     example 2: sprintf("[%10s]", 'monkey');
	    // *     returns 2: '[    monkey]'
	    // *     example 3: sprintf("[%'#10s]", 'monkey');
	    // *     returns 3: '[####monkey]'
	    var regex = /%%|%(\d+\$)?([-+\'#0 ]*)(\*\d+\$|\*|\d+)?(\.(\*\d+\$|\*|\d+))?([scboxXuidfegEG])/g;
	    var a = arguments,
	        i = 0,
	        format = a[i++];
	
	    // pad()
	    var pad = function pad(str, len, chr, leftJustify) {
	        if (!chr) chr = ' ';
	        var padding = str.length >= len ? '' : Array(1 + len - str.length >>> 0).join(chr);
	        return leftJustify ? str + padding : padding + str;
	    };
	
	    // justify()
	    var justify = function justify(value, prefix, leftJustify, minWidth, zeroPad, customPadChar) {
	        var diff = minWidth - value.length;
	        if (diff > 0) {
	            if (leftJustify || !zeroPad) {
	                value = pad(value, minWidth, customPadChar, leftJustify);
	            } else {
	                value = value.slice(0, prefix.length) + pad('', diff, '0', true) + value.slice(prefix.length);
	            }
	        }
	        return value;
	    };
	
	    // formatBaseX()
	    var formatBaseX = function formatBaseX(value, base, prefix, leftJustify, minWidth, precision, zeroPad) {
	        // Note: casts negative numbers to positive ones
	        var number = value >>> 0;
	        prefix = prefix && number && { '2': '0b', '8': '0', '16': '0x' }[base] || '';
	        value = prefix + pad(number.toString(base), precision || 0, '0', false);
	        return justify(value, prefix, leftJustify, minWidth, zeroPad);
	    };
	
	    // formatString()
	    var formatString = function formatString(value, leftJustify, minWidth, precision, zeroPad, customPadChar) {
	        if (precision != null) {
	            value = value.slice(0, precision);
	        }
	        return justify(value, '', leftJustify, minWidth, zeroPad, customPadChar);
	    };
	
	    // doFormat()
	    var doFormat = function doFormat(substring, valueIndex, flags, minWidth, _, precision, type) {
	        var number;
	        var prefix;
	        var method;
	        var textTransform;
	        var value;
	
	        if (substring == '%%') return '%';
	
	        // parse flags
	        var leftJustify = false,
	            positivePrefix = '',
	            zeroPad = false,
	            prefixBaseX = false,
	            customPadChar = ' ';
	        var flagsl = flags.length;
	        for (var j = 0; flags && j < flagsl; j++) {
	            switch (flags.charAt(j)) {
	                case ' ':
	                    positivePrefix = ' ';break;
	                case '+':
	                    positivePrefix = '+';break;
	                case '-':
	                    leftJustify = true;break;
	                case "'":
	                    customPadChar = flags.charAt(j + 1);break;
	                case '0':
	                    zeroPad = true;break;
	                case '#':
	                    prefixBaseX = true;break;
	            }
	        } // parameters may be null, undefined, empty-string or real valued
	        // we want to ignore null, undefined and empty-string values
	        if (!minWidth) {
	            minWidth = 0;
	        } else if (minWidth == '*') {
	            minWidth = +a[i++];
	        } else if (minWidth.charAt(0) == '*') {
	            minWidth = +a[minWidth.slice(1, -1)];
	        } else {
	            minWidth = +minWidth;
	        }
	
	        // Note: undocumented perl feature:
	        if (minWidth < 0) {
	            minWidth = -minWidth;
	            leftJustify = true;
	        }
	
	        if (!isFinite(minWidth)) {
	            throw new Error('sprintf: (minimum-)width must be finite');
	        }
	
	        if (!precision) {
	            precision = 'fFeE'.indexOf(type) > -1 ? 6 : type == 'd' ? 0 : void 0;
	        } else if (precision == '*') {
	            precision = +a[i++];
	        } else if (precision.charAt(0) == '*') {
	            precision = +a[precision.slice(1, -1)];
	        } else {
	            precision = +precision;
	        }
	
	        // grab value using valueIndex if required?
	        value = valueIndex ? a[valueIndex.slice(0, -1)] : a[i++];
	
	        switch (type) {
	            case 's':
	                return formatString(String(value), leftJustify, minWidth, precision, zeroPad, customPadChar);
	            case 'c':
	                return formatString(String.fromCharCode(+value), leftJustify, minWidth, precision, zeroPad);
	            case 'b':
	                return formatBaseX(value, 2, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
	            case 'o':
	                return formatBaseX(value, 8, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
	            case 'x':
	                return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
	            case 'X':
	                return formatBaseX(value, 16, prefixBaseX, leftJustify, minWidth, precision, zeroPad).toUpperCase();
	            case 'u':
	                return formatBaseX(value, 10, prefixBaseX, leftJustify, minWidth, precision, zeroPad);
	            case 'i':
	            case 'd':
	                {
	                    number = parseInt(+value);
	                    prefix = number < 0 ? '-' : positivePrefix;
	                    value = prefix + pad(String(Math.abs(number)), precision, '0', false);
	                    return justify(value, prefix, leftJustify, minWidth, zeroPad);
	                }
	            case 'e':
	            case 'E':
	            case 'f':
	            case 'F':
	            case 'g':
	            case 'G':
	                {
	                    number = +value;
	                    prefix = number < 0 ? '-' : positivePrefix;
	                    method = ['toExponential', 'toFixed', 'toPrecision']['efg'.indexOf(type.toLowerCase())];
	                    textTransform = ['toString', 'toUpperCase']['eEfFgG'.indexOf(type) % 2];
	                    value = prefix + Math.abs(number)[method](precision);
	                    return justify(value, prefix, leftJustify, minWidth, zeroPad)[textTransform]();
	                }
	            default:
	                return substring;
	        }
	    };
	
	    return format.replace(regex, doFormat);
	}

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _jspdf = __webpack_require__(483);
	
	var _jspdf2 = _interopRequireDefault(_jspdf);
	
	__webpack_require__(482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*The MIT License (MIT)
	Copyright (c) 2014 https://github.com/kayalshri/
	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:
	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.
	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.*/
	
	(function ($) {
	  $.fn.extend({
	    tableExport: function tableExport(options) {
	      var defaults = {
	        separator: ',',
	        ignoreColumn: [],
	        tableName: 'yourTableName',
	        type: 'csv',
	        pdfFontSize: 14,
	        pdfLeftMargin: 20,
	        escape: 'true',
	        htmlContent: 'false',
	        consoleLog: 'false'
	      };
	
	      var options = $.extend(defaults, options);
	      var el = this;
	
	      if (defaults.type == 'csv' || defaults.type == 'txt') {
	
	        // Header
	        var tdData = "";
	        $(el).find('thead').find('tr').each(function () {
	          tdData += "\n";
	          $(this).filter(':visible').find('th').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                tdData += '"' + parseString($(this)) + '"' + defaults.separator;
	              }
	            }
	          });
	          tdData = $.trim(tdData);
	          tdData = $.trim(tdData).substring(0, tdData.length - 1);
	        });
	
	        // Row vs Column
	        $(el).find('tbody').find('tr').each(function () {
	          tdData += "\n";
	          $(this).filter(':visible').find('td').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                tdData += parseString($(this)) + defaults.separator;
	              }
	            }
	          });
	          //tdData = $.trim(tdData);
	          tdData = $.trim(tdData).substring(0, tdData.length - 1);
	        });
	
	        //output
	        if (defaults.consoleLog == 'true') {
	          console.log(tdData);
	        }
	
	        var base64data = "base64," + $.base64.encode(tdData);
	        //window.open('data:application/'+defaults.type+';filename=exportData;' + base64data);
	        $('<a style="display:none" href="data:application/' + defaults.type + ';filename=exportData;' + base64data + '" download="' + defaults.tableName.toString() + '.' + defaults.type + '"><span></span></a>').appendTo(document.body).find('span').trigger("click").parent().remove();
	      } else if (defaults.type == 'sql') {
	
	        // Header
	        var tdData = "INSERT INTO `" + defaults.tableName + "` (";
	        $(el).find('thead').find('tr').each(function () {
	
	          $(this).filter(':visible').find('th').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                tdData += '`' + parseString($(this)) + '`,';
	              }
	            }
	          });
	          tdData = $.trim(tdData);
	          tdData = $.trim(tdData).substring(0, tdData.length - 1);
	        });
	        tdData += ") VALUES ";
	        // Row vs Column
	        $(el).find('tbody').find('tr').each(function () {
	          tdData += "(";
	          $(this).filter(':visible').find('td').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                tdData += '"' + parseString($(this)) + '",';
	              }
	            }
	          });
	
	          tdData = $.trim(tdData).substring(0, tdData.length - 1);
	          tdData += "),";
	        });
	        tdData = $.trim(tdData).substring(0, tdData.length - 1);
	        tdData += ";";
	
	        //output
	        //console.log(tdData);
	
	        if (defaults.consoleLog == 'true') {
	          console.log(tdData);
	        }
	
	        var base64data = "base64," + $.base64.encode(tdData);
	        //window.open('data:application/sql;filename=exportData;' + base64data);
	        $('<a style="display:none" href="data:application/' + defaults.type + ';filename=exportData;' + base64data + '" download="' + defaults.tableName.toString() + '.' + defaults.type + '"><span></span></a>').appendTo(document.body).find('span').trigger("click").parent().remove();;
	      } else if (defaults.type == 'json') {
	
	        var jsonHeaderArray = [];
	        $(el).find('thead').find('tr').each(function () {
	          var tdData = "";
	          var jsonArrayTd = [];
	
	          $(this).filter(':visible').find('th').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                jsonArrayTd.push(parseString($(this)));
	              }
	            }
	          });
	          jsonHeaderArray.push(jsonArrayTd);
	        });
	
	        var jsonArray = [];
	        $(el).find('tbody').find('tr').each(function () {
	          var tdData = "";
	          var jsonArrayTd = [];
	
	          $(this).filter(':visible').find('td').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                jsonArrayTd.push(parseString($(this)));
	              }
	            }
	          });
	          jsonArray.push(jsonArrayTd);
	        });
	
	        var jsonExportArray = [];
	        jsonExportArray.push({ header: jsonHeaderArray, data: jsonArray });
	
	        //Return as JSON
	        //console.log(JSON.stringify(jsonExportArray));
	
	        //Return as Array
	        //console.log(jsonExportArray);
	        if (defaults.consoleLog == 'true') {
	          console.log(JSON.stringify(jsonExportArray));
	        }
	        var base64data = "base64," + $.base64.encode(JSON.stringify(jsonExportArray));
	        //window.open('data:application/json;filename=exportData;' + base64data);
	        $('<a style="display:none" href="data:application/' + defaults.type + ';filename=exportData;' + base64data + '" download="' + defaults.tableName.toString() + '.' + defaults.type + '"><span></span></a>').appendTo(document.body).find('span').trigger("click").parent().remove();
	      } else if (defaults.type == 'xml') {
	
	        var xml = '<?xml version="1.0" encoding="utf-8"?>';
	        xml += '<tabledata><fields>';
	
	        // Header
	        $(el).find('thead').find('tr').each(function () {
	          $(this).filter(':visible').find('th').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                xml += "<field>" + parseString($(this)) + "</field>";
	              }
	            }
	          });
	        });
	        xml += '</fields><data>';
	
	        // Row Vs Column
	        var rowCount = 1;
	        $(el).find('tbody').find('tr').each(function () {
	          xml += '<row id="' + rowCount + '">';
	          var colCount = 0;
	          $(this).filter(':visible').find('td').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                xml += "<column-" + colCount + ">" + parseString($(this)) + "</column-" + colCount + ">";
	              }
	            }
	            colCount++;
	          });
	          rowCount++;
	          xml += '</row>';
	        });
	        xml += '</data></tabledata>';
	
	        if (defaults.consoleLog == 'true') {
	          console.log(xml);
	        }
	
	        var base64data = "base64," + $.base64.encode(xml);
	        //window.open('data:application/xml;filename=exportData;' + base64data);
	        $('<a style="display:none" href="data:application/' + defaults.type + ';filename=exportData;' + base64data + '" download="' + defaults.tableName.toString() + '.' + defaults.type + '"><span></span></a>').appendTo(document.body).find('span').trigger("click").parent().remove();
	      } else if (defaults.type == 'excel' || defaults.type == 'doc' || defaults.type == 'powerpoint') {
	        //console.log($(this).html());
	        var excel = "<table>";
	        // Header
	        $(el).find('thead').find('tr').each(function () {
	          excel += "<tr>";
	          $(this).filter(':visible').find('th').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                excel += "<td>" + parseString($(this)) + "</td>";
	              }
	            }
	          });
	          excel += '</tr>';
	        });
	
	        // Row Vs Column
	        var rowCount = 1;
	        $(el).find('tbody').find('tr').each(function () {
	          excel += "<tr>";
	          var colCount = 0;
	          $(this).filter(':visible').find('td').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                excel += "<td>" + parseString($(this)) + "</td>";
	              }
	            }
	            colCount++;
	          });
	          rowCount++;
	          excel += '</tr>';
	        });
	        excel += '</table>';
	
	        if (defaults.consoleLog == 'true') {
	          console.log(excel);
	        }
	
	        var excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:" + defaults.type + "' xmlns='http://www.w3.org/TR/REC-html40'>";
	        excelFile += "<head>";
	        excelFile += "<!--[if gte mso 9]>";
	        excelFile += "<xml>";
	        excelFile += "<x:ExcelWorkbook>";
	        excelFile += "<x:ExcelWorksheets>";
	        excelFile += "<x:ExcelWorksheet>";
	        excelFile += "<x:Name>";
	        excelFile += "{worksheet}";
	        excelFile += "</x:Name>";
	        excelFile += "<x:WorksheetOptions>";
	        excelFile += "<x:DisplayGridlines/>";
	        excelFile += "</x:WorksheetOptions>";
	        excelFile += "</x:ExcelWorksheet>";
	        excelFile += "</x:ExcelWorksheets>";
	        excelFile += "</x:ExcelWorkbook>";
	        excelFile += "</xml>";
	        excelFile += "<![endif]-->";
	        excelFile += "</head>";
	        excelFile += "<body>";
	        excelFile += excel;
	        excelFile += "</body>";
	        excelFile += "</html>";
	
	        var base64data = "base64," + $.base64.encode(excelFile);
	        //window.open('data:application/vnd.ms-'+defaults.type+';filename=exportData.doc;' + base64data);
	        switch (defaults.type) {
	          case 'excel':
	            $('<a style="display:none" href="data:application/vnd.ms-' + defaults.type + ';filename=exportData.xlsx;' + base64data + '" download="' + defaults.tableName.toString() + '.xlsx"><span></span></a>').appendTo(document.body).find('span').trigger("click").parent().remove();
	            break;
	          case 'doc':
	            $('<a style="display:none" href="data:application/vnd.ms-' + defaults.type + ';filename=exportData.docx;' + base64data + '" download="' + defaults.tableName.toString() + '.docx"><span></span></a>').appendTo(document.body).find('span').trigger("click").parent().remove();
	            break;
	          case 'powerpoint':
	            $('<a style="display:none" href="data:application/vnd.ms-' + defaults.type + ';filename=exportData.pptx;' + base64data + '" download="' + defaults.tableName.toString() + '.pptx"><span></span></a>').appendTo(document.body).find('span').trigger("click").parent().remove();
	            break;
	        }
	      } else if (defaults.type == 'png') {
	        html2canvas($(el), {
	          onrendered: function onrendered(canvas) {
	            var img = canvas.toDataURL("image/png");
	            window.open(img);
	          }
	        });
	      } else if (defaults.type == 'pdf') {
	
	        var doc = new _jspdf2.default('p', 'pt', 'a4', true);
	        doc.setFontSize(defaults.pdfFontSize);
	
	        // Header
	        var startColPosition = defaults.pdfLeftMargin;
	        $(el).find('thead').find('tr').each(function () {
	          $(this).filter(':visible').find('th').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                var colPosition = startColPosition + index * 50;
	                doc.text(colPosition, 20, parseString($(this)));
	              }
	            }
	          });
	        });
	
	        // Row Vs Column
	        var startRowPosition = 20;var page = 1;var rowPosition = 0;
	        $(el).find('tbody').find('tr').each(function (index, data) {
	          rowCalc = index + 1;
	
	          if (rowCalc % 26 == 0) {
	            doc.addPage();
	            page++;
	            startRowPosition = startRowPosition + 10;
	          }
	          rowPosition = startRowPosition + rowCalc * 10 - (page - 1) * 280;
	
	          $(this).filter(':visible').find('td').each(function (index, data) {
	            if ($(this).css('display') != 'none') {
	              if (defaults.ignoreColumn.indexOf(index) == -1) {
	                var colPosition = startColPosition + index * 50;
	                doc.text(colPosition, rowPosition, parseString($(this)));
	              }
	            }
	          });
	        });
	
	        // Output as Data URI
	        doc.output('datauri');
	      }
	
	      function parseString(data) {
	        // glaring error in library? content_data was the original variable...
	        // and it was never defined
	        if (defaults.htmlContent == 'true') {
	          data = data.html().trim();
	        } else {
	          data = data.text().trim();
	        }
	
	        if (defaults.escape == 'true') {
	          data = escape(data);
	        }
	
	        return data;
	      }
	    }
	  });
	})(_jquery2.default); // NOTE: THIS FILE HAS BEEN MODIFIED FOR USE WITH WEBPACK

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _filtersutil = __webpack_require__(16);
	
	var _organizationActionOptions = __webpack_require__(492);
	
	var _organizationLookupFieldDropdown = __webpack_require__(493);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	var modalHtml = __webpack_require__(11);
	var _ = __webpack_require__(2);
	var detailLinkHTML = __webpack_require__(84);
	var targetSelector = "#organization-lookup";
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  var dataTableComponentData = mainEl.data("organization-lookup-data");
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  var deactivateOrgURL = mainEl.data("deactivate-org-url");
	  submitModalFlow.init();
	  var savedViews = mainEl.data("saved-views");
	  var portletNamespace = mainEl.data("portlet-namespace");
	  var filterURL = mainEl.data("filter-url");
	  var saveViewURL = mainEl.data("save-view-url");
	  var deleteViewURL = mainEl.data("delete-view-url");
	  var editOrganizationUrl = mainEl.data("edit-organization-url");
	  var viewOrganizationUrl = mainEl.data("organization-detail-url");
	  var viewBrokerOrganizationUrl = mainEl.data("broker-organization-detail-url");
	  var viewCarrierOrganizationUrl = mainEl.data("carrier-organization-detail-url");
	
	  var generateExportUrl = mainEl.data("export-url");
	  var pageRefreshUrl = mainEl.data("page-refresh-url");
	  var bulkActivateDeactivateBtnUrl = mainEl.data("bulk-activate-organization-url");
	  var selectedRows = "";
	  var targetObject = "";
	  var exportModal = new _filtersutil.buildExport();
	  var facilityTypes = mainEl.data("facility-types");
	  var inboundClassification = mainEl.data("inbound-classification");
	  var editOrgUrl = mainEl.data("edit-url");
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	  var editPermission = mainEl.data("organization-edit-permission");
	
	  var activateOrg = mainEl.data("activate-org-msg");
	  var deactivateOrg = mainEl.data("deactivate-org-msg");
	  var activateOrgModelTitle = mainEl.data("activate-org-model-title");
	  var deactivateOrgModelTitle = mainEl.data("deactivate-org-model-title");
	
	  var activateDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
	    activateMsg: mainEl.data("activate-org-text")
	  });
	
	  var deactivateDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
	    deactivateMsg: mainEl.data("deactivate-org-text")
	  });
	
	  var organizationLookup = new _index2.default({
	
	    target: $("#organization-lookup-wrapper"),
	
	    minWidthClass: "q-min-width-sm-til-md",
	
	    mobileColumns: [{
	      data: "orgActive",
	      title: "Status",
	      render: renderStatusPill
	    }, {
	      data: "orgName",
	      title: "Organization Name",
	      render: createDetailLink
	    }, {
	      data: "orgType",
	      title: "Organization Type",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "orgActive",
	      title: "Status",
	      render: renderStatusPill,
	      class: 'dtc-min-width-sm'
	    }, {
	      data: "cmrAddress[].cadContactName",
	      title: "Contact",
	      render: renderCmrAddress,
	      class: "dtc-min-width-sm"
	    }, {
	      data: "cmrAddress[].cadContactEmail",
	      title: "Email",
	      render: renderCmrAddress,
	      class: "dtc-min-width-sm"
	    }, {
	      data: "cmrAddress[].cadContactPhone",
	      title: "Phone",
	      render: renderCmrAddress,
	      class: "dtc-min-width-sm"
	    }, {
	      data: "cmrAddress[].cadAddress1",
	      title: "Address",
	      render: renderCmrAddress,
	      class: "dtc-min-width-sm"
	    }, {
	      data: "orgCreatedBy",
	      title: "Created By",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "orgCreatedTime",
	      title: "Created On",
	      render: formateDate,
	      class: "dtc-min-width-sm"
	    }],
	
	    // REQUIRED: search input info
	    tableSearchInput: {
	      value: targetObject != "" ? targetObject.value[0] : ""
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _organizationLookupFieldDropdown.orgLookupFieldDropdown
	    },
	
	    // OPTIONAL: Set Saved View Array
	    savedViews: savedViews,
	    bulkSelect: true,
	
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      // Not required, just to show you can
	      columnDefs: [],
	      order: [[10, 'desc']],
	
	      columns: [{
	        data: "orgActive",
	        render: renderActionWrap,
	        orderable: false,
	        class: "dtc-action-column"
	      }, {
	        data: "orgName",
	        title: "Organization Name",
	        render: createDetailLink,
	        class: "dtc-min-width-sm"
	      }, {
	        data: "orgType",
	        title: "Organization Type",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "orgActive",
	        title: "Status",
	        render: renderStatusPill,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "cmrAddress[].cadContactName",
	        title: "Contact",
	        render: renderCmrAddress,
	        class: "dtc-min-width-sm"
	      }, {
	        data: "cmrAddress[].cadContactEmail",
	        title: "Email",
	        render: renderCmrAddress,
	        class: "dtc-min-width-sm"
	      }, {
	        data: "cmrAddress[].cadContactPhone",
	        title: "Phone",
	        render: renderCmrAddress,
	        class: "dtc-min-width-sm"
	      }, {
	        data: "cmrAddress[].cadAddress1",
	        title: "Address",
	        render: renderCmrAddress,
	        class: "dtc-min-width-sm"
	      }, {
	        data: "orgCreatedBy",
	        title: "Created By",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "orgCreatedTime",
	        title: "Created On",
	        render: formateDate,
	        class: "dtc-min-width-sm"
	      }]
	    },
	
	    paginationData: dataTableComponentData.page,
	
	    filterModal: {
	      title: "Filter Organizations",
	      tableType: "organization"
	    },
	
	    onBulkSelectChange: function onBulkSelectChange() {
	      selectedRows = organizationLookup.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass('disabled');
	      } else {
	        $(".action-header-btn .base-btn").addClass('disabled');
	      }
	    },
	
	    onFetch: function onFetch() {
	      var currentData = organizationLookup.generateData();
	      organizationLookup.showLoadingOverlay();
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterURL, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  function filterSuccessFun(data) {
	    var organization = data.content;
	    var page = data.page;
	    organizationLookup.setNewData(organization);
	    organizationLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    organizationLookup.hideLoadingOverlay();
	    setExportData(organizationLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var organization = data.lookupOrgJSON.content;
	    var page = data.lookupOrgJSON.page;
	    organizationLookup.setNewData(organization);
	    organizationLookup.setPaginationData(page);
	    organizationLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    organizationLookup.hideLoadingOverlay();
	    setExportData(organizationLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var organization = data.lookupOrgJSON.content;
	    var page = data.lookupOrgJSON.page;
	    organizationLookup.setNewData(organization);
	    organizationLookup.setPaginationData(page);
	    organizationLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    organizationLookup.hideLoadingOverlay();
	    setExportData(organizationLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var organization = data.lookupOrgJSON.content;
	    var page = data.lookupOrgJSON.page;
	    organizationLookup.removeSavedView(data.target);
	    organizationLookup.setNewData(organization);
	    organizationLookup.setPaginationData(page);
	    organizationLookup.hideLoadingOverlay();
	    setExportData(organizationLookup.generateData());
	  }
	
	  function errorFun(data) {
	    organizationLookup.hideLoadingOverlay();
	  }
	
	  organizationLookup.init();
	
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = _organizationActionOptions.actionOptions["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    var statusTarget = _organizationActionOptions.actionOptions['all'];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, item));
	    });
	    return renderedList.join('');
	  }
	
	  function neededActions(data, row, item) {
	    var action = {};
	    if (editPermission && item.title === 'Activate/Deactivate') {
	      if (data === true) {
	        action = {
	          icon: 'toggle-off',
	          title: 'Deactivate',
	          cls: "deactivate-organization",
	          disabled: false
	        };
	      } else {
	        action = {
	          icon: 'toggle-on',
	          title: 'Activate',
	          cls: "activate-organization",
	          disabled: false
	        };
	      }
	    } else if (editPermission && item.title === 'Edit') {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: false
	      };
	    } else if (editPermission && item.title === 'Activate Selected Organizations') {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: checkDisableForGivenAction(data, row, item.title)
	      };
	    } else if (editPermission && item.title === 'Deactivate Selected Organizations') {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: checkDisableForGivenAction(data, row, item.title)
	      };
	    } else {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: item.disabled
	      };
	    }
	    return action;
	  }
	
	  function checkDisableForGivenAction(data, row, actionName) {
	    var isTrue = false;
	    _(selectedRows).map(function (item) {
	      if (callBusinessLogicToDisableAction(item.data.orgActive, item.data, actionName)) {
	        if (!isTrue) {
	          isTrue = true;
	        }
	      }
	    });
	    return isTrue;
	  }
	
	  function callBusinessLogicToDisableAction(data, row, actionName) {
	    if ((0, _general.isPresent)(data)) {
	      if (actionName === "Activate Selected Organizations") {
	        if (data === true) {
	          return true;
	        } else {
	          return false;
	        }
	      } else if (actionName === "Deactivate Selected Organizations") {
	        if (data === false) {
	          return true;
	        } else {
	          return false;
	        }
	      }
	    }
	  }
	
	  function renderCmrAddress(data) {
	    if (data == null || data == "") {
	      return null;
	    }
	    return data[0];
	  }
	
	  function formateDate(createdDate, type, data) {
	    if (createdDate != null && createdDate != "") {
	      var date = new Date(createdDate); //createdDate is long time format
	      var month = date.getMonth() + 1;
	      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear();
	    } else {
	      return "";
	    }
	  }
	
	  function renderStatusPill(data, type, row) {
	    if (data === true) {
	      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
	    } else {
	      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
	    }
	  }
	
	  function createDetailLink(data, type, row) {
	    var detailPageHTML = (0, _render2.default)(detailLinkHTML, {
	      renderURL: getOrgDetailsURL(row),
	      portletNamespace: portletNamespace,
	      id: row.orgId,
	      idName: "orgId",
	      displayVal: data
	    });
	    return detailPageHTML;
	  }
	  // Export component integration.
	  function initExport() {
	    var exportObj = {
	      title: mainEl.data("export-popup-title"),
	      exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
	      exportMaxLimitLang: mainEl.data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent();
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(generateExportUrl, currentData);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	  initExport();
	  setExportData(organizationLookup.generateData());
	
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  function getOrgDetailsURL(org) {
	    if (org.orgType == 'Transportation Broker') {
	      return viewBrokerOrganizationUrl;
	    } else if (org.orgType == 'Carrier') {
	      return viewCarrierOrganizationUrl;
	    } else {
	      return viewOrganizationUrl;
	    }
	  }
	
	  $('body').on('click', '.bulk-activate-organization', function () {
	    if (shallAllowClick(this)) {
	      $("#bulkActivateOrg").modal("show");
	    }
	  });
	
	  $('#modalBulkActivateOrg').click(function () {
	    submitModalFlow.showLoadingModal();
	    bulkActivateDeativateOrg(true);
	  });
	
	  $('body').on('click', '.bulk-deactivate-organization', function () {
	    if (shallAllowClick(this)) {
	      $("#bulkDeActivateOrg").modal("show");
	    }
	  });
	
	  $('#modalBulkDeActivateOrg').click(function () {
	    submitModalFlow.showLoadingModal();
	    bulkActivateDeativateOrg(false);
	  });
	
	  function bulkActivateDeativateOrg(val) {
	    var _data;
	
	    $.ajax({
	      url: bulkActivateDeactivateBtnUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: (_data = {}, _defineProperty(_data, portletNamespace + 'orgId', getAllSelectedOrgIds()), _defineProperty(_data, 'activeDeativeFlag', val), _data),
	      success: function success(data) {
	        if (data.response === "success") {
	          _(selectedRows).map(function (item) {
	            var currentRow = $(".data-table-component").dataTable().api().row(item.rowIndex);
	            var d = currentRow.data();
	            d.orgActive = val;
	            currentRow.data(d).draw();
	          });
	          setTimeout(function () {
	            submitModalFlow.hideAllModals();
	          }, _constants.SUCCESS_MODAL_TIMEOUT);
	        }
	      },
	      error: function error() {
	        submitModalFlow.hideAllModals();
	      }
	    });
	  }
	
	  function getAllSelectedOrgIds() {
	    var orgIds = new Array();
	    _(selectedRows).map(function (item) {
	      orgIds.push(item.data.orgId);
	    });
	    return JSON.stringify(orgIds);
	  }
	
	  $('body').on('click', '.edit-organization', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      var organization = row.data();
	      var orgId = '' + organization.orgId;
	      editOrganizationCall(orgId);
	    }
	  });
	
	  function editOrganizationCall(orgId) {
	    location.href = editOrgUrl + "&orgId=" + orgId;
	  }
	
	  $('body').on('click', '.activate-organization', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      var organization = row.data();
	      var orgId = '' + organization.orgId;
	      activateOrganizationCall(orgId);
	    }
	  });
	
	  function activateOrganizationCall(orgId) {
	    var activateOrgModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: activateOrgModelTitle,
	      confirmModalBody: activateDiv,
	      confirmModalBtnText: activateOrg,
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        activateOrgModal.showLoadingModal();
	        activateOrg({ url: deactivateOrgURL, success: activateSuccess, error: activateFailure });
	        function activateOrg(_ref) {
	          var url = _ref.url,
	              success = _ref.success,
	              error = _ref.error;
	
	          $.ajax({
	            data: {
	              orgId: orgId
	            },
	            url: url,
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	          });
	        }
	        function activateSuccess() {
	          activateOrgModal.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, 3000);
	        }
	        function activateFailure() {
	          setTimeout(function () {
	            activateOrgModal.hideAllModals();
	          }, 6000);
	        }
	      }
	    });
	    activateOrgModal.init();
	    activateOrgModal.showConfirmModal();
	  }
	
	  $('body').on('click', '.deactivate-organization', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      var organization = row.data();
	      var orgId = '' + organization.orgId;
	      deactivateOrganizationCall(orgId);
	    }
	  });
	
	  function deactivateOrganizationCall(orgId) {
	    var deactivateOrgModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: deactivateOrgModelTitle,
	      confirmModalBody: deactivateDiv,
	      confirmModalBtnText: deactivateOrg,
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        deactivateOrgModal.showLoadingModal();
	        deactivateOrg({ url: deactivateOrgURL, success: deactivateSuccess, error: deactivateFailure });
	        function deactivateOrg(_ref2) {
	          var url = _ref2.url,
	              success = _ref2.success,
	              error = _ref2.error;
	
	          $.ajax({
	            url: url,
	            data: {
	              orgId: orgId
	            },
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	          });
	        }
	        function deactivateSuccess() {
	          deactivateOrgModal.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, 3000);
	        }
	        function deactivateFailure() {
	          setTimeout(function () {
	            deactivateOrgModal.hideAllModals();
	          }, 6000);
	        }
	      }
	    });
	    deactivateOrgModal.init();
	    deactivateOrgModal.showConfirmModal();
	  }
	});

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _select2able = __webpack_require__(22);
	
	var _constants = __webpack_require__(10);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _util = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	// Additional Imports...
	
	var facilityWrapperTemplate = __webpack_require__(1205);
	var facilityTypeHtml = __webpack_require__(1204);
	var inboundClassificationHtml = __webpack_require__(1206);
	var facilityDetailsHtml = __webpack_require__(1203);
	var facilityAddressHtml = __webpack_require__(1201);
	var facilityContactHtml = __webpack_require__(1202);
	var sharedModalHtml = __webpack_require__(11);
	var selectOrgModalBodyHtml = __webpack_require__(1197);
	
	var searchCarrierByScacWrapperTemplate = __webpack_require__(1192);
	var carrierTeamMemberDetailsWrapperTemplate = __webpack_require__(1193);
	var addCarrierTeamMemberWrapperTemplate = __webpack_require__(1190);
	var addCarrierTeamMemberDetailsWrapperTemplate = __webpack_require__(1198);
	var validateScacCodeWrapperTemplate = __webpack_require__(1200);
	var transportationBrokerSectionWrapperTemplate = __webpack_require__(1199);
	var optionTemplateHtml = __webpack_require__(135);
	var createCarrierOrBrokerModalBodyHtml = __webpack_require__(1195);
	var modalHtml = __webpack_require__(11);
	var newCarrierWrapperTemplate = __webpack_require__(1194);
	
	var targetSelector = "#add-organization-form";
	var carData = {};
	var scacDetails = {};
	var teamMemberArray = [];
	var valScac = '';
	var btnClicked = void 0;
	(0, _run2.default)(targetSelector, function (mainEl) {
	  attachOrgForm(mainEl);
	});
	
	function attachOrgForm(mainEl) {
	  var _elsMap;
	
	  var validator = void 0;
	  var validationOpts = {
	    debug: true,
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  };
	  var activeFormElement = void 0;
	  var carrierBrokerModal = void 0;
	  var modalOpts = { backdrop: 'static', show: false };
	  var editForm = mainEl.data("edit-form");
	  var portletNamespace = mainEl.data('portlet-namespace');
	  var organizations = mainEl.data('organizations');
	  var facilityArray = organizations.cmrAddress || [];
	  var editFlag = false;
	  var organizationId = 0;
	  if (editForm) {
	    organizationId = organizations.orgId;
	  }
	
	  var isHoneyComb = mainEl.data('is-honeycomb');
	  var countries = mainEl.data('countries');
	  var usaStates = mainEl.data('usa-states');
	  var caProvinces = mainEl.data('ca-provinces');
	  var phoneCodes = mainEl.data('country-phone-code-list');
	  var defaultCountry = mainEl.data('default-country');
	  var facilityTypes = mainEl.data('facility-types');
	  var inboundClassificationTypes = mainEl.data('inbound-classification-types');
	  var retailerFedexAccounts = mainEl.data('retailer-fedex-accounts');
	  var retailerCasAccounts = mainEl.data('retailer-cas-accounts');
	  var retailerFacilityForRMS = mainEl.data('retailer-facility-for-rms');
	  var detailsPageUrl = mainEl.data("details-url");
	  var carrierDetailsPageUrl = mainEl.data("carrier-details-url");
	  var brokerOrgDetailsUrl = mainEl.data("broker-org-details-url");
	  var brokerCreateUrl = mainEl.data("broker-create-url");
	  var addressEl = $('#edit-address-verification');
	  var validateOrgNameUrl = mainEl.data("validate-org-url");
	  var validateCadLocationNameUrl = mainEl.data("validate-cad-location-name-url");
	  var validateCadAddressIdUrl = mainEl.data("validate-cad-address-id-url");
	  var addressValidationUrl = mainEl.data("address-validation-url");
	  var organizationList = mainEl.data("retailer-organization-list");
	  var submitURL = mainEl.data("submit-url");
	  var carrierSubmitURL = mainEl.data("carriersubmit-url");
	  var orgFacilityForm = $('#org-facility-form');
	  var cancelBtnUrl = mainEl.data("cancel-url");
	  var duplicateCadLocationNameMessage = mainEl.data("duplicate-location-name-message");
	  var duplicateAddressIdMessage = mainEl.data("duplicate-address-id-message");
	
	  var duplicateCarrerOrgNameMessage = mainEl.data("duplicate-carrer-org-name-message");
	  var duplicateAddressMessage = mainEl.data("duplicate-address-message");
	  var checkDuplicateAddressUrl = mainEl.data("validate-duplicate-address-url");
	  var retailerOrgtype = mainEl.data('retailer-orgtype');
	  var getScacDetailsUrl = mainEl.data('scac-details-url');
	  var searchByScacUrl = mainEl.data('search-by-scac-url');
	  var carrierSectionHtml = $('#carrier-section-div');
	  var addCarrierTeamMemberDivSec = $('#addCarrierTeamMemberDivSec');
	  var carrierListByMerchant = mainEl.data('carrier-by-merchant-list');
	  var continueCarrierOrgType = mainEl.data('continue-carrier-orgtype-url');
	  var continueBrokerOrgType = mainEl.data('continue-broker-orgtype-url');
	  var checkUserNameValidation = mainEl.data('check-user-name-url');
	  var affiliatedCarrierOrgs = mainEl.data("affiliated-carrier-orgs");
	  var teamMemberDetailsForEdit = mainEl.data("teammember-details");
	  var checkSCACExistsForCarrierUrl = mainEl.data('check-scac-exists-for-carrier-url');
	  var checkSCACExistsForRetailerUrl = mainEl.data('check-scac-exists-for-retailer-url');
	  var cmrCarrier = mainEl.data("cmr-carrier");
	  var createButton = $('.create-carrier-btn').text();
	  var useFoundButton = $('.use-found-carrier-btn').text();
	  var cmrCarrierScacList = mainEl.data('carrier-scac-list');
	  var validationReqdCountries = mainEl.data("validation-reqd-countries");
	  var orgName = "";
	  var orgId = "";
	  var addValResponse = {};
	  var btnClickedEdit = void 0;
	  var selectFromOrgModal = void 0;
	  var continueModal = void 0;
	  var orgNameDuplicateModal = void 0;
	  var elsPage = {};
	  var elsModal = {};
	  var oldCadId = void 0;
	  var oldCadStatus = void 0;
	  var isOrgDuplicate = false;
	  var isAddressDuplicate = false;
	  var isUseFoundCarrierFlow = false;
	  var saveBtnClicked = false;
	  var saveTeamMemberModel = void 0;
	
	  var elsMap = (_elsMap = {
	    addFacilitySection: ".add-facility-section",
	    organizationName: "#org-address-name",
	    addFirstFacilityBtn: ".first-add-facility-btn",
	    saveVendorOrgAddressBtn: ".save-vendor-org-address-btn",
	    masterFormCancelBtn: ".master-facility-cancel-section-btn",
	    facilityEditSectionBtn: ".facility-edit-section-btn",
	    facilityUpdateSectionBtn: ".facility-update-section-btn",
	    facilityCancelSectionBtn: ".facility-cancel-section-btn",
	    masterFormSectionParent: ".master-form-section",
	    customExpanderParent: ".custom-expander-parent",
	    customExpanderTarget: ".custom-expander-target",
	    nextAddfacilityBtn: ".next-add-facility-btn",
	    facilityFormDiv: ".facility-information-container",
	    selectOrgPopupBtn: "#selectOrg",
	    inboundClassification: ".inboundClassification",
	    facilityType: ".rms-facility-type",
	    cancelMainFormBtn: ".cancel-mainform-btn",
	    orgType: "#orgType",
	    config: "#config",
	    orgNameSection: "#orgNameSection",
	    orgAddressname: "#orgAddressname",
	    carrierSection: ".carrier-section",
	    brokerSection: "#broker-section",
	    searchCarrier: ".search-carrier",
	    carrierScacTypeAhead: "#find-by-carrier-scac",
	    carrierDetailsDiv: ".carrier-info-div",
	    facilityNwSection: "#facility-nw-section",
	    useFoundCarrierBtn: ".use-found-carrier-btn",
	
	    carrierContactInfo: ".carrier-contact-info",
	    teamCarrierSection: ".team-carrier-section",
	    teamMemberDetails: "#team-member-details",
	    teamMemberBtn: ".team-member-btn",
	
	    organizationType: "organization-type",
	    organizationForm: '#organization-form',
	    transportationBrokerSection: ".transportation-broker-section",
	    organizationCarrierForm: '#organization-carrier-form',
	
	    scacCode: '.scac-code',
	    cancelTeamMemberBtn: '.cancel-team-member-btn',
	    saveTeamMemberBtn: '.save-team-member-btn'
	  }, _defineProperty(_elsMap, 'organizationCarrierForm', '#organization-carrier-form'), _defineProperty(_elsMap, 'createCarrierBtn', '.create-carrier-btn'), _defineProperty(_elsMap, 'teamMemberSectionDetails', '.team-member-section-details'), _defineProperty(_elsMap, 'carrierListForBroker', '#find-carriers-for-broker'), _elsMap);
	
	  var elsModalMap = {
	    orgnSelectBtn: '.organization-select-btn',
	    dropDownOption: "#organizationDropdown",
	    abandonFormBtn: "#abandon-form-btn",
	    saveTeamMemberDialogBtn: ".save-team-member-dialog-btn",
	    carrierContinueBtn: '.continue-btn'
	  };
	
	  var carrierElementsMap = {
	    carrierScacCode: "#carrierScacCode",
	    carrierName: "#carrierName",
	    carrierGln: "#carrierGln",
	    carrierContactName: "#carrierContactName",
	    carrierContactEmail: "#carrierContactEmail",
	    carrierContactPhone: "#carrierContactPhone",
	    carrierAddLine1: "#carrierAddLine1",
	    carrierAddLine2: "#carrierAddLine2",
	    carrierCountry: "#carrierCountry",
	    carrierInfoButton: ".carrier-info-button"
	  };
	
	  var addressElementsMap = {
	    submitThisAddressBtn: '#submit-edit-returned-address',
	    addressEntered: '#div-address-enetered',
	    enteredAddressRadio: '#radio-use-entered-address',
	    enteredAddressText: '#edit-ret-address-entered',
	    addressReturned: '#div-address-returned',
	    returnedAddressRadio: '#radio-returned-address',
	    returnedAddressText: '#edit-ret-address-returned',
	    invalidAddress: '#div-address-returned-empty',
	    invalidAddressText: '#edit-ret-address-returned-not-found',
	    modifyAddressBtn: '#modify-edit-returned-address'
	
	  };
	
	  var carrierTeamMemberElementsMap = {
	    carTeamMemberUsername: "car-team-member-username",
	    manageTeamMemberUserName: ".username-team",
	    manageTeamMemberUserEmail: ".email-team"
	  };
	
	  function init() {
	    setValidator();
	    setElements();
	    getRenderedOrgType();
	    hideAllExpandableSectionsOnPageLoad();
	    generateModals();
	    buildModalHtml();
	    setElementsOnModal();
	    bindElements();
	    createStaticForm();
	    if (elsPage.orgType.val() == "Facility Network") {
	      populateEdit();
	    }
	    setupEditChecker();
	    setInitialState();
	    if (elsPage.orgType.val() == "Carrier") {
	      validateScacCode();
	    }
	    $('.vmoFacilityType').click(function () {
	      $(".errorMsgForFacilityTypeCheckbox").hide();
	    });
	    handleSwitchingBrokerStateInput();
	  }
	
	  function setInitialState() {
	    instantiateScacTypeAhead();
	    var scacIdLookup = elsPage.carrierScacTypeAhead;
	    scacIdLookup.on("select2:select", function () {
	      var scacId = scacIdLookup.select2('data')[0].id;
	
	      $.ajax({
	        async: false,
	        data: {
	          scacId: scacId
	        },
	        url: getScacDetailsUrl,
	        dataType: "JSON",
	        type: 'POST',
	        success: function success(data) {
	          displayCarrierDetails(data);
	          carData = data;
	        }
	      });
	    });
	  }
	  function displayCarrierDetails(data) {
	    var countryName = "";
	    elsPage.carrierDetailsDiv.removeClass('hidden');
	    elsPage.carrierInfoButton.removeClass('hidden');
	    elsPage.createCarrierBtn.removeAttr('disabled');
	    elsPage.useFoundCarrierBtn.removeAttr('disabled');
	    elsPage.carrierName.text(data[0].carName);
	    elsPage.carrierScacCode.text(data[0].carScac);
	    elsPage.carrierGln.text(data[0].carGln);
	    elsPage.carrierContactName.text(data[0].carContactName);
	    elsPage.carrierContactEmail.text(data[0].cmrAddress.cadContactEmail);
	    elsPage.carrierContactPhone.text(data[0].carPhoneCountryCode + " " + data[0].carContactPhone);
	    elsPage.carrierAddLine1.text(data[0].cmrAddress.cadAddress1 + (data[0].cmrAddress.cadAddress2 == null ? "" : ", " + data[0].cmrAddress.cadAddress2));
	    elsPage.carrierAddLine2.text(data[0].cmrAddress.cadCity + ", " + data[0].cmrAddress.cadState + " " + data[0].cmrAddress.cadZipcode);
	    if (data[0].cmrAddress.cadCountry == 'US') {
	      countryName = "United States of America";
	    } else if (data[0].cmrAddress.cadCountry == 'CA') {
	      countryName = "Canada";
	    } else {
	      countryName = data[0].cmrAddress.cadCountry;
	    }
	    elsPage.carrierCountry.text(countryName);
	  }
	
	  function buildModalHtml() {}
	
	  function showCarrierOrgModal(e) {
	    e.preventDefault();
	    carrierBrokerModal.modal('show');
	  }
	
	  function instantiateScacTypeAhead() {
	    var select2AjaxDefaults = {
	      dataType: 'json',
	      delay: 250,
	      async: false,
	      processResults: function processResults(data, params) {
	        if ($.isEmptyObject(data)) {
	          elsPage.carrierInfoButton.removeClass('hidden');
	          elsPage.useFoundCarrierBtn.attr('disabled', 'disabled');
	          elsPage.createCarrierBtn.removeAttr('disabled');
	        }
	        params.page = params.page || 1;
	        return {
	          results: data,
	          pagination: {
	            more: params.page * 20 < data.total_count
	          }
	        };
	      },
	      cache: true
	    };
	
	    function configureDataCallback(_ref) {
	      var paramKey = _ref.paramKey;
	
	      return function (params) {
	        return _defineProperty({}, paramKey, params.term);
	      };
	    }
	
	    elsPage.carrierScacTypeAhead.select2({
	      placeholder: "Start typing carrier SCAC code",
	      allowClear: true,
	      ajax: _extends({}, select2AjaxDefaults, {
	        url: elsPage.carrierScacTypeAhead.data('get-scac-list'),
	        data: configureDataCallback({ paramKey: 'cmrCarrierByScac' }),
	        templateResult: function templateResult(result) {
	          return result.text;
	        }
	      }),
	      minimumInputLength: 2
	
	    });
	  }
	
	  //Set the validator for the Main Form with the Organization Name 
	  function setValidator() {
	    validator = mainEl.find(".organizationForm").validate(validationOpts);
	    validator.settings.ignore = ":disabled, :hidden";
	    // HB-12744 add jquery custom validation for duplicate broker org name
	    $.validator.addMethod("checkDuplicateOrgName", validateOrgName, 'Organization name already exists');
	
	    $(".broker-org-name").rules("add", {
	      checkDuplicateOrgName: true
	    });
	
	    $.validator.addMethod( //override email with django email validator regex - fringe cases: "user@admin.state.in..us" or "name@website.a"
	    'email', function (value, element) {
	      return this.optional(element) || /(^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*|^"([\001-\010\013\014\016-\037!#-\[\]-\177]|\\[\001-\011\013\014\016-\177])*")@((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+(?:[A-Z]{2,6}\.?|[A-Z0-9-]{2,}\.?)$)|\[(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}\]$/i.test(value);
	    }, 'Please enter a valid email address.');
	  }
	
	  function setElements() {
	    //Tie the scope of the elements on the page 
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elsMap, orgFacilityForm);
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, addressElementsMap, addressEl);
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, carrierElementsMap, orgFacilityForm);
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, carrierTeamMemberElementsMap, orgFacilityForm);
	    //HB-12085
	    //setElementsFromScope(elsPage,carrierDetailsElementsMap,carrierSectionHtml);
	  }
	
	  function setElementsOnModal() {
	    var $body = $('body');
	    (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, $body);
	  }
	
	  function setupEditChecker() {
	    _EditChecker2.default.bindNavigation();
	    _EditChecker2.default.bindChangeListener("#add-organization-form");
	    _EditChecker2.default.bindChangeListener(".child-form-edit");
	    _EditChecker2.default.bindChangeListener("span.select2");
	    //EditChecker.bindCancelButton("#cancel-vendor-org-address-btn");
	    _EditChecker2.default.bindCancelButton(".cancel-mainform-btn");
	  }
	
	  function bindElements() {
	    mainEl.find(elsMap.masterFormSectionParent).hide();
	
	    if (editForm) {
	      elsPage.organizationName.val(organizations.orgName);
	    }
	
	    if (editForm && organizations.orgType == "Transportation Broker") {
	      $('.master-form-section').hide();
	      elsPage.addFacilitySection.hide();
	      elsPage.nextAddfacilityBtn.hide();
	      elsPage.selectOrgPopupBtn.hide();
	      elsPage.facilityNwSection.hide();
	      setTeamMembersForEdit("broker");
	      setAffiliatedCarrierOrgsForEdit();
	    } else if (editForm && organizations.orgType == "Carrier") {
	      editCarrierAndTeamMember();
	    } else if (editForm && facilityArray.length) {
	      elsPage.addFacilitySection.hide();
	      elsPage.nextAddfacilityBtn.show();
	      elsPage.selectOrgPopupBtn.show();
	      elsPage.facilityNwSection.hide();
	    } else {
	      //elsPage.addFacilitySection.show();//HB-12202
	      elsPage.nextAddfacilityBtn.hide();
	      elsPage.selectOrgPopupBtn.hide();
	    }
	    elsPage.organizationName.on("blur", validateOrgName);
	    mainEl.on("blur", "#organization-new-name", validateOrgName);
	    //elsPage.carrierSection.find('[name=new-carrier-contact-state]').on('change', validateDuplicateAddress);
	    elsPage.addFirstFacilityBtn.click((0, _general.createPreventDefault)(showStaticForm));
	    elsPage.modifyAddressBtn.on('click', modifyFacilityAddress);
	    elsPage.submitThisAddressBtn.on('click', submitFacilityAddress);
	    elsPage.selectOrgPopupBtn.on('click', showOrganizationSelectModal);
	    elsModal.orgnSelectBtn.on('click', orgSelectBtnHandler);
	    elsModal.abandonFormBtn.on('click', abandonFormHandler);
	    elsPage.saveVendorOrgAddressBtn.on('click', orgSaveBtnHandler);
	    mainEl.on("click", '.next-add-facility-btn', addFacilityHandler);
	    mainEl.on("click", '.facility-edit-section-btn', expandFacilitySectionClickHandler);
	    mainEl.on("click", '.facility-update-section-btn', collapseFacilitySectionClickHandler);
	    mainEl.on("click", '.master-facility-cancel-section-btn', cancelFormClickHandler);
	    mainEl.on("click", '.facility-cancel-section-btn', cancelEditFacilityClickHandler);
	    mainEl.on("change", ".facilty-country", handleCountryChange);
	    mainEl.on("blur", ".facility-name", isDuplicateCadLocationName);
	    mainEl.on("blur", ".facility-id", isDuplicateCadAddressId);
	    mainEl.on("click", ".add-facility-cancel-btn", handleCancelAddFacility);
	    elsPage.orgType.on('change', orgTypesHandler);
	    mainEl.on("click", '.use-found-carrier-btn', addCarrierHandler);
	    mainEl.on("click", '.create-carrier-btn', addCarrierHandler);
	    mainEl.on("click", '.clear-carrier-btn', clearSearchScacHandler);
	    mainEl.on("click", ".team-member-btn", newTeamMemberAddHandler);
	    mainEl.on('click', '.save-team-member-btn', saveTeamMemberBtnHandler);
	    mainEl.on('change', '.carrier-phone-code-add-carrier-team-member', handleCarrierPhoneCodeTeamMember);
	    mainEl.on('click', '.cancel-team-member-btn', cancelTeamMemberBtnHandler);
	    mainEl.on('click', '.edit-team-member-btn', editTeamMemberBtn);
	    mainEl.on('click', '.remove-team-member-btn', removeTeamMemberBtn);
	    //mainEl.on("click",'.trans-broker-create-carrier-btn', onclickCreateCarrier);
	    mainEl.on("click", '.trans-broker-create-carrier-btn', showCarrierOrgModal);
	    //els.createCarrier.on("click", showCarrierOrgModal);
	    elsModal.saveTeamMemberDialogBtn.on('click', loadCarrierDetailsHandler);
	    mainEl.on("blur", "#scac-new-code", validateScacCode);
	    mainEl.on('click', '.val-use-found-carrier-btn', useCarrierScacCode);
	    elsModal.carrierContinueBtn.on('click', handleCarrierBrokerModalClose);
	    mainEl.on("blur", ".username-team", checkUserName);
	    mainEl.on("change", ".email-team", checkEmailId);
	    elsPage.brokerSection.find(".broker-org-country").on("change", handleSwitchingBrokerStateInput);
	    //elsPage.brokerSection.find('.broker-phone-number').inputmask({ mask: "(999) 999-9999" });
	    $('#carrier-org-edit-url').on('click', editCarrierAndTeamMember);
	    elsPage.brokerSection.find(".broker-phone-code").on("change", handleBrokerPhoneValidation);
	  }
	
	  function orgTypesHandler() {
	    if (elsPage.orgType.val() == 'Facility Network') {
	      elsPage.addFacilitySection.show();
	      elsPage.facilityNwSection.show();
	      elsPage.carrierSection.hide();
	      elsPage.transportationBrokerSection.hide();
	      elsPage.saveVendorOrgAddressBtn.removeAttr('disabled');
	      elsPage.facilityFormDiv.show();
	    } else if (elsPage.orgType.val() == 'Carrier') {
	      elsPage.organizationName.val('');
	      var closetForm = elsPage.organizationName.closest('form');
	      closetForm.validate().resetForm();
	      facilityArray = [];
	      $('.child-form-edit').empty();
	      $('.master-form-section').hide();
	      elsPage.facilityFormDiv.hide();
	      elsPage.nextAddfacilityBtn.hide();
	      elsPage.addFacilitySection.hide();
	      elsPage.facilityNwSection.hide();
	      elsPage.transportationBrokerSection.hide();
	      elsPage.saveVendorOrgAddressBtn.attr('disabled', 'disabled');
	      showCarrierSection();
	      $('.team-broker-section').hide();
	      $('.team-carrier-section').show();
	    } else if (elsPage.orgType.val() == 'Transportation Broker') {
	      elsPage.nextAddfacilityBtn.hide();
	      $('.master-form-section').hide();
	      elsPage.addFacilitySection.hide();
	      elsPage.facilityNwSection.hide();
	      elsPage.carrierSection.hide();
	      elsPage.transportationBrokerSection.show();
	      tranportationBrokerHandler();
	      $('.team-broker-section').show();
	      $('.team-carrier-section').hide();
	      elsPage.saveVendorOrgAddressBtn.removeAttr('disabled');
	    }
	  }
	
	  function showCarrierSection() {
	    elsPage.carrierSection.show();
	  }
	
	  function carrierContinueBtn() {
	    handleCarrierBrokerModalClose();
	  }
	
	  function handleCarrierBrokerModalClose(e) {
	    e.preventDefault();
	    carrierBrokerModal.modal("hide");
	    window.open(brokerCreateUrl + '&ContinueCarrierOrgType=true', '_blank');
	  }
	
	  //Hb-12202
	  function getRenderedOrgType() {
	    elsPage.saveVendorOrgAddressBtn.attr('disabled', 'disabled');
	    if (continueCarrierOrgType == '' && continueBrokerOrgType == '') {
	      var returnTypeList = "";
	      returnTypeList = retailerOrgtype.map(function (e1) {
	        return (0, _render2.default)("<option value = '{%-key %}'>{%-value %}</option>", {
	          key: e1.cdmMeaning,
	          value: e1.cdmMeaning
	        });
	      });
	      elsPage.orgType.append(returnTypeList.join(''));
	    } else if (continueCarrierOrgType != '' && continueBrokerOrgType == '') {
	      elsPage.orgType.append("<option value ='Carrier'>Carrier</option>");
	      elsPage.orgType.val('Carrier');
	      elsPage.orgType.trigger('change.select2');
	      orgTypesHandler();
	    } else if (continueCarrierOrgType == '' && continueBrokerOrgType != '') {
	      elsPage.orgType.append("<option value ='Transportation Broker'>Transportation Broker</option>");
	      elsPage.orgType.val('Transportation Broker');
	      elsPage.orgType.trigger('change.select2');
	      orgTypesHandler();
	    }
	    if (editForm) {
	      elsPage.orgType.val(organizations.orgType);
	      elsPage.orgType.attr('disabled', 'disabled');
	      elsPage.config.hide();
	      elsPage.orgNameSection.show();
	      elsPage.orgAddressname.val(organizations.orgName);
	      orgTypesHandler();
	    }
	  }
	  function handleCancelAddFacility() {
	    if (editForm) {
	      editFlag = false;
	      elsPage.nextAddfacilityBtn.show();
	    }
	
	    if (!facilityArray.length) {
	      elsPage.addFacilitySection.show();
	      elsPage.nextAddfacilityBtn.hide();
	      elsPage.facilityNwSection.show();
	    } else {
	      elsPage.addFacilitySection.hide();
	      elsPage.nextAddfacilityBtn.show();
	      elsPage.facilityNwSection.hide();
	    }
	
	    hideAllExpandableSectionsOnPageLoad();
	    resetMasterForm();
	  }
	
	  function abandonFormHandler(e) {
	    e.preventDefault();
	    editFlag = false;
	    hideAllExpandableSectionsOnPageLoad();
	    hideAbandonFormModal();
	    expandFacilitySection(btnClickedEdit);
	  }
	
	  function orgSaveBtnHandler(e) {
	    var isMainFormValid = mainEl.find(".organizationForm").valid();
	    if (elsPage.saveVendorOrgAddressBtn.hasClass("disabled")) {
	      e.preventDefault();
	    } else {
	      var orgFormEle = mainEl.find("#master-form");
	      if (isOrgDuplicate && elsPage.orgType.val() == 'Facility Network') {
	        showOrgNameDuplicateModal();
	      } else {
	        if (orgFormEle.is(':visible')) {
	          var isValidOrgForm = validateForm(orgFormEle);
	          if (isValidOrgForm && !isOrgDuplicate && checkFacilityTypesHC(orgFormEle) && isMainFormValid) {
	            saveBtnClicked = true;
	            validateAddressModal(orgFormEle);
	          }
	        } else if (isMainFormValid) {
	          if (elsPage.orgType.val() == 'Carrier') {
	            saveBtnClicked = true;
	            if (btnClicked === 'create' && !isUseFoundCarrierFlow) {
	              validateDuplicateAddress();
	              if (isAddressDuplicate == true) {
	                return;
	              }
	            }
	            validateCarrierAddress();
	          } else {
	            saveModalHandler();
	          }
	        }
	      }
	    }
	  }
	
	  function validateCarrierAddress() {
	
	    var orgFormEle = mainEl.find("#master-form");
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, {}, orgFormEle);
	    var carrierAddr = {};
	    var carrierContactCountry = '';
	    var carrierContactAddress1 = '';
	    var carrierContactAddress2 = '';
	    var carrierContactCity = '';
	    var carrierContactState = '';
	    var carrierContactPostalcode = '';
	    if (btnClicked === 'create') {
	      carrierContactCountry = elsPage.carrierSection.find('[name=new-carrier-contact-country]').val();
	      carrierContactAddress1 = elsPage.carrierSection.find('[name=new-carrier-contact-address1]').val();
	      carrierContactAddress2 = elsPage.carrierSection.find('[name=new-carrier-contact-address2]').val();
	      carrierContactCity = elsPage.carrierSection.find('[name=new-carrier-contact-city]').val();
	      carrierContactState = elsPage.carrierSection.find('[name=new-carrier-contact-state]').val();
	      carrierContactPostalcode = elsPage.carrierSection.find('[name=new-carrier-contact-postalcode]').val();
	    } else if (btnClicked === 'found') {
	      carrierContactCountry = elsPage.carrierSection.find('[name=carrier-contact-country]').val();
	      carrierContactAddress1 = elsPage.carrierSection.find('[name=carrier-contact-address1]').val();
	      carrierContactAddress2 = elsPage.carrierSection.find('[name=carrier-contact-address2]').val();
	      carrierContactCity = elsPage.carrierSection.find('[name=carrier-contact-city]').val();
	      carrierContactState = elsPage.carrierSection.find('[name=carrier-contact-state]').val();
	      carrierContactPostalcode = elsPage.carrierSection.find('[name=carrier-contact-postalcode]').val();
	    } else {
	      carrierContactCountry = $("#org-facility-form").find('[name=carrier-contact-country]').val();
	      carrierContactAddress1 = $("#org-facility-form").find('[name=carrier-contact-address1]').val();
	      carrierContactAddress2 = $("#org-facility-form").find('[name=carrier-contact-address2]').val();
	      carrierContactCity = $("#org-facility-form").find('[name=carrier-contact-city]').val();
	      carrierContactState = $("#org-facility-form").find('[name=carrier-contact-state]').val();
	      carrierContactPostalcode = $("#org-facility-form").find('[name=carrier-contact-postalcode]').val();
	    }
	    carrierAddr.cadAddress1 = carrierContactAddress1;
	    carrierAddr.cadAddress2 = carrierContactAddress2;
	    carrierAddr.cadCity = carrierContactCity;
	    carrierAddr.cadState = carrierContactState;
	    carrierAddr.cadZipcode = carrierContactPostalcode;
	    carrierAddr.cadCountry = carrierContactCountry;
	
	    var validateAddressForCountry = false;
	    $(validationReqdCountries).each(function () {
	      if (this.cdmMeaning.toString() === carrierAddr.cadCountry || this.cdmValue.toString() === carrierAddr.cadCountry) {
	        validateAddressForCountry = true;
	        return false;
	      }
	    });
	
	    if (validateAddressForCountry) {
	      $.ajax({
	        url: addressValidationUrl,
	        type: "POST",
	        data: carrierAddr,
	        beforeSend: function beforeSend() {
	          $.blockUI({ message: 'Validating Address, Please Wait..' });
	        },
	        complete: function complete() {
	          $.unblockUI();
	        },
	        success: function success(data, textStatus, jqXHR) {
	          addValResponse = $.parseJSON(data);
	          if (addValResponse.result == true) {
	            _EditChecker2.default.setPageClean();
	            elsPage.addressReturned.css("display", "");
	            elsPage.invalidAddress.css("display", "none");
	            elsPage.invalidAddressText.css("display", "none");
	            elsPage.returnedAddressRadio.prop('checked', false);
	            elsPage.enteredAddressRadio.prop('checked', true);
	            elsPage.returnedAddressRadio.show();
	            checkSubmitAddressForm(addValResponse);
	          } else {
	            elsPage.addressReturned.css("display", "none");
	            elsPage.invalidAddress.css("display", "");
	            elsPage.invalidAddressText.css("display", "");
	            elsPage.invalidAddressText.html('Unable to find a validated address');
	            elsPage.returnedAddressRadio.hide();
	            elsPage.returnedAddressRadio.prop('checked', false);
	            elsPage.enteredAddressRadio.prop('checked', true);
	            checkSubmitAddressForm(addValResponse);
	          }
	        }
	      });
	    } else {
	      submitFacilityAddress();
	    }
	  }
	
	  function saveCarrierModalHandler(cmrCarrierAddressObj) {
	
	    if (!isOrgDuplicate) {
	      var teamMembersObjForSubmit = prepareTeamMemberForSubmit("carrier");
	      var submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: "Save Carrier Organization",
	        confirmModalBody: '<div class="q-pad-all-xl">Once saved this carrier organization can be assigned to your ASNs and scheduled warehouse dock appointments. Carrier team members, if applicable, will also be able to sign in to view and edit scheduled appointments that are assigned to this carrier.</div>',
	        confirmModalBtnText: "Save",
	        onConfirmClick: function onConfirmClick(cmrCarrierAddressObj) {
	
	          var orgName = '';
	          var scacCode = '';
	          var carrierGln = '';
	          var carrierContactName = '';
	          var carrierContactEmail = '';
	          var carrierPhoneCountryCode = '';
	          var carrierPhoneContactNumer = '';
	          var carrierContactCountry = '';
	          var carrierContactAddress1 = '';
	          var carrierContactAddress2 = '';
	          var carrierContactCity = '';
	          var carrierContactState = '';
	          var carrierContactPostalcode = '';
	          if (btnClicked === 'create') {
	            orgName = elsPage.carrierSection.find('[name=new-carrier-section-org-name]').val();
	            scacCode = elsPage.carrierSection.find('[name=new-scac-code]').val();
	            carrierGln = elsPage.carrierSection.find('[name=new-carrier-gln]').val();
	            carrierContactName = elsPage.carrierSection.find('[name=new-carrier-contact-name]').val();
	            carrierContactEmail = elsPage.carrierSection.find('[name=new-carrier-contact-email]').val();
	            carrierPhoneCountryCode = elsPage.carrierSection.find('[name=new-phone-code]').val();
	            carrierPhoneContactNumer = elsPage.carrierSection.find('[name=new-phone-number]').val();
	            carrierContactCountry = elsPage.carrierSection.find('[name=new-carrier-contact-country]').val();
	            carrierContactAddress1 = elsPage.carrierSection.find('[name=new-carrier-contact-address1]').val();
	            carrierContactAddress2 = elsPage.carrierSection.find('[name=new-carrier-contact-address2]').val();
	            carrierContactCity = elsPage.carrierSection.find('[name=new-carrier-contact-city]').val();
	            carrierContactState = elsPage.carrierSection.find('[name=new-carrier-contact-state]').val();
	            carrierContactPostalcode = elsPage.carrierSection.find('[name=new-carrier-contact-postalcode]').val();
	          } else if (btnClicked === 'found') {
	            orgName = elsPage.carrierSection.find('[name=carrier-section-org-name]').val();
	            scacCode = elsPage.carrierSection.find('[name=scac-code]').val();
	            carrierGln = elsPage.carrierSection.find('[name=carrier-gln]').val();
	            carrierContactName = elsPage.carrierSection.find('[name=carrier-contact-name]').val();
	            carrierContactEmail = elsPage.carrierSection.find('[name=carrier-contact-email]').val();
	            carrierPhoneCountryCode = elsPage.carrierSection.find('[name=phone-code]').val();
	            carrierPhoneContactNumer = elsPage.carrierSection.find('[name=phone-number]').val();
	            carrierContactCountry = elsPage.carrierSection.find('[name=carrier-contact-country]').val();
	            carrierContactAddress1 = elsPage.carrierSection.find('[name=carrier-contact-address1]').val();
	            carrierContactAddress2 = elsPage.carrierSection.find('[name=carrier-contact-address2]').val();
	            carrierContactCity = elsPage.carrierSection.find('[name=carrier-contact-city]').val();
	            carrierContactState = elsPage.carrierSection.find('[name=carrier-contact-state]').val();
	            carrierContactPostalcode = elsPage.carrierSection.find('[name=carrier-contact-postalcode]').val();
	          } else {
	            orgName = $("#org-facility-form").find('[name=carrier-section-org-name]').val();
	            scacCode = $("#org-facility-form").find('[name=scac-code]').val();
	            carrierGln = $("#org-facility-form").find('[name=carrier-gln]').val();
	            carrierContactName = $("#org-facility-form").find('[name=carrier-contact-name]').val();
	            carrierContactEmail = $("#org-facility-form").find('[name=carrier-contact-email]').val();
	            carrierPhoneCountryCode = $("#org-facility-form").find('[name=phone-code]').val();
	            carrierPhoneContactNumer = $("#org-facility-form").find('[name=phone-number]').val();
	            carrierContactCountry = $("#org-facility-form").find('[name=carrier-contact-country]').val();
	            carrierContactAddress1 = $("#org-facility-form").find('[name=carrier-contact-address1]').val();
	            carrierContactAddress2 = $("#org-facility-form").find('[name=carrier-contact-address2]').val();
	            carrierContactCity = $("#org-facility-form").find('[name=carrier-contact-city]').val();
	            carrierContactState = $("#org-facility-form").find('[name=carrier-contact-state]').val();
	            carrierContactPostalcode = $("#org-facility-form").find('[name=carrier-contact-postalcode]').val();
	          }
	
	          var carrierAddr = {};
	          carrierAddr.orgName = orgName;
	          carrierAddr.scacCode = scacCode;
	
	          if (!(typeof cmrCarrierAddressObj === 'undefined')) {
	            carrierAddr = Object.assign(carrierAddr, cmrCarrierAddressObj);
	          } else {
	            carrierAddr.cadAddress1 = carrierContactAddress1;
	            carrierAddr.cadAddress2 = carrierContactAddress2;
	            carrierAddr.cadCity = carrierContactCity;
	            carrierAddr.cadState = carrierContactState;
	            carrierAddr.cadZipcode = carrierContactPostalcode;
	            carrierAddr.cadCountry = carrierContactCountry;
	          }
	
	          // const formEl = btnClicked.closest("form");
	          // let cadId = formEl.find(".cadId").val();
	          // let cadStatus = formEl.find('.cadStatus').val();
	          // formEl.get
	          var orgType = elsPage.orgType.val();
	          var saveOrgCarrierURL = carrierSubmitURL;
	          submitModalFlow.showLoadingModal();
	          $.ajax({
	            data: {
	              //carrierAddr: JSON.stringify([carrierAddr]),
	              orgName: orgName,
	              orgId: organizationId,
	              newOrgId: orgId,
	              orgType: orgType,
	              cmrCarrier: JSON.stringify({
	                carScac: scacCode,
	                carGln: carrierGln,
	                carContactName: carrierContactName,
	                carContactEmail: carrierContactEmail,
	                carPhoneCountryCode: carrierPhoneCountryCode,
	                carContactPhone: carrierPhoneContactNumer,
	                cmrAddress: {
	                  cadAddress1: carrierAddr.cadAddress1,
	                  cadAddress2: carrierAddr.cadAddress2,
	                  cadCity: carrierAddr.cadCity,
	                  cadState: carrierAddr.cadState,
	                  cadZipcode: carrierAddr.cadZipcode,
	                  cadCountry: carrierAddr.cadCountry
	                }
	              }),
	              carrierTeamMemberObj: JSON.stringify(teamMembersObjForSubmit)
	
	            },
	            url: saveOrgCarrierURL,
	            dataType: "JSON",
	            type: 'POST',
	            success: function success(data) {
	              _EditChecker2.default.setPageClean();
	              submitModalFlow.hideAllModals();
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = carrierDetailsPageUrl + "&orgId=" + data;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            },
	            error: function error(data) {
	              submitModalFlow.hideAllModals();
	              submitModalFlow.showFailureModal();
	            }
	          });
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  }
	
	  function checkFacilityTypesHC(orgFormEle) {
	    if (isHoneyComb) {
	      var checked = $("#" + orgFormEle[0].id + " input:checkbox:checked").length > 0;
	      if (!checked) {
	        $(".errorMsgForFacilityTypeCheckbox").show();
	        return false;
	      } else {
	        $(".errorMsgForFacilityTypeCheckbox").hide();
	        return true;
	      }
	    } else {
	      return true;
	    }
	  }
	
	  function prepareDataForBrokerSubmit() {
	    var brokerObjMap = {};
	    brokerObjMap = {
	      brokerOrgName: elsPage.brokerSection.find('[name=broker-org-name]').val(),
	      brokerOrgAddress1: elsPage.brokerSection.find('[name=broker-org-address1]').val(),
	      brokerOrgAddress2: elsPage.brokerSection.find('[name=broker-org-address2]').val(),
	      brokerOrgState: elsPage.brokerSection.find('[name=broker-org-state]').val(),
	      brokerOrgCity: elsPage.brokerSection.find('[name=broker-org-city]').val(),
	      brokerOrgZipcode: elsPage.brokerSection.find('[name=broker-org-zipcode]').val(),
	      brokerOrgCountry: elsPage.brokerSection.find('[name=broker-org-country]').val(),
	      brokerOrgContactName: elsPage.brokerSection.find('[name=broker-org-contact-name]').val(),
	      brokerOrgEmail: elsPage.brokerSection.find('[name=broker-org-email]').val(),
	      brokerOrgPhone: elsPage.brokerSection.find('[name=phone-number]').val(),
	      brokerOrgPhoneCode: elsPage.brokerSection.find('[name=phone-code]').val(),
	      affiliatedCarrierList: elsPage.brokerSection.find('[name=find-carriers-for-broker]').val()
	    };
	    if (editForm) {
	      brokerObjMap.brokerOrgId = organizations.orgId;
	      brokerObjMap.cadId = organizations.cmrAddress[0].cadId;
	    }
	    return brokerObjMap;
	  }
	
	  function prepareTeamMemberForSubmit(orgTypeVal) {
	    var teamMembersObjMap = [];
	    for (var i = 0; i < teamMemberArray.length; i++) {
	      var teamObj = {};
	      if ($("#team-member-org-type-" + i).val() == orgTypeVal) {
	        teamObj.userId = $('#team-member-user-id-' + i).val();
	        if ($("#team-member-edit-" + i).is(":visible") || !(0, _util.isNullOrUndefined)(teamObj.userId) && teamObj.userId !== "") {
	          teamObj.userName = $('#car-team-member-username-' + i).val();
	          teamObj.firstName = $("#car-team-member-first-name-" + i).val();
	          teamObj.lastName = $("#car-team-member-last-name-" + i).val();
	          teamObj.organizationTitle = $("#org-title-" + i).val();
	          teamObj.emailAddress = $("#car-team-member-email-" + i).val();
	          teamObj.phoneCode = $("#car-team-member-phone-code-" + i).val();
	          teamObj.phoneNumber = $("#car-team-member-phone-" + i).val();
	          if ($("#team-member-edit-" + i).is(":hidden")) {
	            teamObj.action = 'remove';
	          } else {
	            teamObj.action = 'save';
	          }
	          teamMembersObjMap.push(teamObj);
	        }
	      }
	    }
	    return teamMembersObjMap;
	  }
	
	  function saveModalHandler() {
	    if (!isOrgDuplicate) {
	      if (elsPage.orgType.val() != 'Transportation Broker') {
	        var submitModalFlow = new _SubmitModalFlow2.default({
	          confirmModalTitle: "Save Network Facility Organization",
	          confirmModalBody: '<div class="q-pad-all-xl">Once saved this network facility organization can be assigned to existing and new facilities. When you create a new or edit a facility in the facilities page, you may assign this network facility organization as the owner.</div>',
	          confirmModalBtnText: "Save",
	          onConfirmClick: function onConfirmClick() {
	            var orgName = elsPage.organizationName.val();
	            var orgType = elsPage.orgType.val();
	            var saveOrgFacURL = submitURL;
	            submitModalFlow.showLoadingModal();
	            $.ajax({
	              data: {
	                facilityArray: JSON.stringify(facilityArray),
	                orgName: orgName,
	                orgId: organizationId,
	                newOrgId: orgId,
	                orgType: orgType
	
	              },
	              url: saveOrgFacURL,
	              dataType: "JSON",
	              type: 'POST',
	              success: function success(data) {
	                _EditChecker2.default.setPageClean();
	                submitModalFlow.hideAllModals();
	                submitModalFlow.showSuccessModal();
	                setTimeout(function () {
	                  location.href = detailsPageUrl + "&orgId=" + data;
	                }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	              },
	              error: function error(data) {
	                submitModalFlow.hideAllModals();
	                submitModalFlow.showFailureModal();
	              }
	            });
	          }
	        });
	        submitModalFlow.init();
	        submitModalFlow.showConfirmModal();
	      } else {
	        var brokerControllerObj = prepareDataForBrokerSubmit();
	        var teamMembersObjForSubmit = prepareTeamMemberForSubmit("broker");
	        var _submitModalFlow = new _SubmitModalFlow2.default({
	          confirmModalTitle: "Save Transportation Broker Organization",
	          confirmModalBody: '<div class="q-pad-all-xl">Once saved, this transportation broker organization may be assigned to ASNs to handle the assignment of carriers for shipments. Any team members created under this organization may log in and begin assigning carriers to your scheduled appointments</div>',
	          confirmModalBtnText: "Save",
	          onConfirmClick: function onConfirmClick() {
	            var orgName = elsPage.organizationName.val();
	            var orgType = elsPage.orgType.val();
	            var saveOrgFacURL = submitURL;
	            _submitModalFlow.showLoadingModal();
	            $.ajax({
	              data: {
	                brokerOrgObj: JSON.stringify(brokerControllerObj),
	                brokerTeamMemberObj: JSON.stringify(teamMembersObjForSubmit),
	                orgName: orgName,
	                orgId: organizationId,
	                newOrgId: orgId,
	                orgType: orgType
	              },
	              url: saveOrgFacURL,
	              dataType: "JSON",
	              type: 'POST',
	              success: function success(data) {
	                _EditChecker2.default.setPageClean();
	                _submitModalFlow.hideAllModals();
	                _submitModalFlow.showSuccessModal();
	                setTimeout(function () {
	                  location.href = brokerOrgDetailsUrl + "&orgId=" + data;
	                }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	              },
	              error: function error(data) {
	                _submitModalFlow.hideAllModals();
	                _submitModalFlow.showFailureModal();
	              }
	            });
	          }
	        });
	        _submitModalFlow.init();
	        _submitModalFlow.showConfirmModal();
	      }
	    }
	  }
	
	  function generateModals() {
	    selectFromOrgModal = $((0, _render2.default)(sharedModalHtml, {
	      title: 'Select Organization',
	      subtitle: "Select an organization for this facility",
	      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn organization-select-btn">Save as Organization</a>',
	      body: (0, _render2.default)(selectOrgModalBodyHtml, {
	        dropdownList: renderOrganizationValues()
	      }),
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800"
	    }));
	    saveTeamMemberModel = $((0, _render2.default)(sharedModalHtml, {
	      title: 'Save Organization Team Member ',
	      body: "<div class='q-pad-all-xl'>Once saved this team member will receive log in credentials and can begin carrying out the roles and privileges they have been assigned.</div>",
	      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn save-team-member-dialog-btn">Save</a>',
	
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800"
	    }));
	    continueModal = $((0, _render2.default)(sharedModalHtml, {
	      title: 'Continue Editing',
	      footerBtns: '<a href="#" class="base-btn v2-btn" id="abandon-form-btn">Abandon Form</a><a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Continue Editing</a>',
	      body: "<div class='q-pad-all-xl'>You will lose information on the open facility form by editing another facility.Would you like to continue editing the form you are on ?</div>",
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800"
	    }));
	
	    orgNameDuplicateModal = $((0, _render2.default)(sharedModalHtml, {
	      title: 'Organization Already Exists',
	      footerBtns: '<a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Okay</a>',
	      body: '<div class="q-pad-all-xl">The organization you have entered already exists. To continue adding this organization, please update the name as entered. If your intent is to add a facility to this organization, you may do so within the existing detail page of the organization. If you believe this to be in error, please contact your dedicated customer support specialist</div>',
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800"
	    }));
	
	    carrierBrokerModal = $((0, _render2.default)(modalHtml, {
	      title: 'Create Organization',
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-500",
	      body: createCarrierOrBrokerModalBodyHtml,
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: '\n       <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" target="_blank" class="base-btn purple-btn \n       continue-btn">Continue</a>\n         '
	    }));
	
	    $('body').append(selectFromOrgModal, continueModal, orgNameDuplicateModal, saveTeamMemberModel, carrierBrokerModal);
	  }
	
	  function renderOrganizationValues() {
	    var returnTypeList = "";
	    returnTypeList = organizationList.map(function (el) {
	      return (0, _render2.default)("<option value = '{%-key %}'>{%-value %}</option>", {
	        key: el.orgId,
	        value: el.orgName
	      });
	    });
	    return returnTypeList.join('');
	  }
	
	  function orgSelectBtnHandler() {
	    selectFromOrgModal.modal('hide');
	    orgId = elsModal.dropDownOption.find('option:selected').val();
	    orgName = elsModal.dropDownOption.find('option:selected').text();
	    elsPage.organizationName.attr("value", orgId);
	    elsPage.organizationName.val(orgName);
	  }
	
	  // Function that hides expandable sections and Update btns on pge load
	  function hideAllExpandableSectionsOnPageLoad() {
	    mainEl.find(elsMap.customExpanderTarget).hide();
	    mainEl.find(elsMap.masterFormSectionParent).hide();
	    mainEl.find(elsMap.facilityUpdateSectionBtn).hide();
	    mainEl.find(elsMap.facilityCancelSectionBtn).hide();
	  }
	
	  function selectOrgBtnHandler() {
	    selectFromOrgModal.modal('hide');
	    elsPage.organizationName.val();
	  }
	
	  function showOrganizationSelectModal() {
	    selectFromOrgModal.modal('show');
	  }
	
	  function showAbandonFormModal() {
	    continueModal.modal('show');
	  }
	
	  function hideAbandonFormModal() {
	    continueModal.modal('hide');
	  }
	
	  function showOrgNameDuplicateModal() {
	    orgNameDuplicateModal.modal('show');
	  }
	
	  function validateOrgName() {
	    var isValid = true;
	    var orgType = elsPage.orgType.val();
	    var orgPrevious = organizations.orgName;
	    var orgName = "";
	    if (orgType == 'Transportation Broker') {
	      orgName = elsPage.brokerSection.find("[name=broker-org-name]").val();
	    } else if (orgType == 'Carrier') {
	      orgName = elsPage.carrierSection.find("[name=new-carrier-section-org-name]").val();
	    } else {
	      orgName = elsPage.organizationName.val();
	    }
	    if (orgName != orgPrevious) {
	      $.ajax({
	        async: false,
	        data: {
	          orgName: orgName
	        },
	        url: validateOrgNameUrl,
	        dataType: "JSON",
	        type: 'POST',
	        success: function success(data) {
	          isOrgDuplicate = data.response;
	          if (data.response == true) {
	            $(".dup-orgName").css("display", "");
	            if (elsPage.orgType.val() == 'Facility Network') {
	              showOrgNameDuplicateModal();
	            } else {
	              isValid = false;
	            }
	          }
	        }
	      });
	    }
	    if (isValid) $(".dup-orgName").css("display", "none");else $(".dup-orgName").css("display", "");
	    return isValid;
	  }
	
	  function getHcmbFacilityTypes(cmrAddressObj) {
	    if (isHoneyComb) {
	      return (0, _render2.default)(facilityTypeHtml, _extends({}, cmrAddressObj, {
	        facilityTypes: getRenderedFacilityTypes(facilityTypes)
	      }));
	    }
	  }
	
	  function showStaticForm() {
	    editFlag = true;
	    organizations.orgName = elsPage.organizationName.val();
	    //If Org Name is valid, hide the First Add facility button and Show the static Facility Form     
	    //elsPage.addFacilitySection.hide();//HB-12202
	    elsPage.nextAddfacilityBtn.show();
	    mainEl.find(elsMap.masterFormSectionParent).show();
	  }
	
	  function createStaticForm() {
	    var orgNewFormHtml = $((0, _render2.default)(facilityWrapperTemplate, {
	      masterForm: (0, _render2.default)("<form id='master-form'><div class='q-section master-form'>"),
	      facilityDetails: (0, _render2.default)(facilityDetailsHtml, {
	        dupFacName: duplicateCadLocationNameMessage,
	        dupFacId: duplicateAddressIdMessage,
	        rmsTypes: getRMSFacilityTypes()
	      }),
	      hcmbFacilityTypes: getHcmbFacilityTypes(),
	      rmsFacilityTypes: getRmsFacilityTypes(),
	      facilityAddress: (0, _render2.default)(facilityAddressHtml, {
	        countries: getRenderedCountries(countries)
	      }),
	      facilityContact: (0, _render2.default)(facilityContactHtml, {
	        phoneCodes: getRenderedPhoneCodes(phoneCodes)
	      }),
	      facilityName: "Facility Details",
	      masterFormClass: "master-form-section",
	      actionButtons: (0, _render2.default)(__webpack_require__(1191)),
	      sectionIsExpandable: '',
	      isHoneyComb: isHoneyComb
	    }));
	    elsPage.facilityFormDiv.append(orgNewFormHtml);
	    mainEl.find(elsMap.masterFormSectionParent).hide();
	    (0, _select2able.instantiateSelect2)(orgNewFormHtml.find('.select2-select'));
	    //orgNewFormHtml.find('.vendorSelectAuthorization').hide();
	    //orgNewFormHtml.find('.inboundClassification').hide();
	    //orgNewFormHtml.find('.phone-format').inputmask({mask: "(999) 999-9999"});
	
	    orgNewFormHtml.find(".rms-facility-type").on("change", handleRmsFacilityTypeChange);
	    orgNewFormHtml.find(".rms-facility-type").val("").trigger('change');
	    orgNewFormHtml.find(".facility-country").on("change", handleCountryChange);
	    orgNewFormHtml.find(".facility-country").val(defaultCountry).trigger('change');
	    var editForm = mainEl.data("edit-form");
	    if (!editForm) {
	      orgNewFormHtml.find(".facility-phone-code").val("+1").trigger('change');
	      orgNewFormHtml.find('.facility-phone-code').on("change", handleFacilityPhoneValidation);
	    }
	    (0, _instantiateSwitchery.instantiateSwitchery)(orgNewFormHtml.find("#return-auth-req"), {});
	    validator = $('#master-form').validate(validationOpts);
	    validator.settings.ignore = ":disabled, :hidden";
	
	    activeFormElement = $('#master-form');
	  }
	
	  function handleFacilityPhoneValidation() {
	    var facPhoneCode = $('.facility-phone-code').find(":selected").val();
	    var facPhoneContactNumber = $(".facility-phone-contact-number");
	    facPhoneContactNumber.val(''); //Reset the value
	    if (facPhoneCode === "+1") {
	      facPhoneContactNumber.addClass("phoneUS");
	      facPhoneContactNumber.removeClass("phoneNonUS");
	      facPhoneContactNumber.addClass("phone-format");
	      facPhoneContactNumber.attr("placeholder", "___-____");
	      facPhoneContactNumber.inputmask("(999) 999-9999");
	    } else {
	      facPhoneContactNumber.addClass("phoneNonUS");
	      facPhoneContactNumber.removeClass("phoneUS");
	      facPhoneContactNumber.removeClass("phone-format");
	      facPhoneContactNumber.removeAttr('placeholder');
	      facPhoneContactNumber.inputmask("");
	
	      var val = facPhoneContactNumber.val();
	      if (val) {
	        var v = val.replace(/[^0-9.]/g, "");
	        facPhoneContactNumber.val(v);
	      }
	    }
	  }
	
	  function handleFacilityPhoneValidationByIndex(index) {
	    var facPhoneCode = $('#phone-code' + index).find(":selected").val();
	    var facPhoneContactNumber = $("#phone-number" + index);
	    if (facPhoneCode === "+1") {
	      facPhoneContactNumber.addClass("phoneUS");
	      facPhoneContactNumber.removeClass("phoneNonUS");
	      facPhoneContactNumber.attr("placeholder", "___-____");
	      facPhoneContactNumber.inputmask("(999) 999-9999");
	    } else {
	      var facPhoneContactValue = facPhoneContactNumber.val();
	      facPhoneContactValue = facPhoneContactValue.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '');
	      facPhoneContactNumber.val(facPhoneContactValue);
	      facPhoneContactNumber.addClass("phoneNonUS");
	      facPhoneContactNumber.removeClass("phoneUS");
	      facPhoneContactNumber.removeAttr('placeholder');
	      facPhoneContactNumber.inputmask("");
	
	      var val = facPhoneContactNumber.val();
	      if (val) {
	        var v = val.replace(/[^0-9.]/g, "");
	        facPhoneContactNumber.val(v);
	      }
	    }
	  }
	
	  function getRMSFacilityTypes(arrayIndex) {
	    if (!isHoneyComb) {
	      return (0, _render2.default)(__webpack_require__(1196), {
	        arrayIndex: arrayIndex,
	        rmsFacilityTypes: getRenderedRmsFacility(retailerFacilityForRMS),
	        rmsFedexAccounts: getRenderedFedexAccounts(retailerFedexAccounts),
	        rmsCasAccounts: getRenderedCasAccounts(retailerCasAccounts)
	      });
	    }
	  }
	
	  function getRenderedCasAccounts(retailerCasAccounts) {
	    var retailerFacilityHtml = '<option value="{%- casAccount.ccaId %}">{%- casAccount.ccaCasAccountnNumber %}</option>';
	    var response = _underscore2.default.map(retailerCasAccounts, function (casAccount) {
	      return (0, _render2.default)(retailerFacilityHtml, {
	        casAccount: casAccount
	      });
	    });
	
	    return response.join("");
	  }
	
	  function handleCountryChange(e) {
	    var formEl = $(this).closest("form");
	    handleSwitchingStateInput(formEl);
	  }
	
	  function handleSwitchingStateInput(formEl) {
	    var countryVal = formEl.find('.facility-country').val();
	
	    var response = '';
	    $(countries).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        response = this.conPhoneCode.toString();
	      }
	    });
	
	    if (response != '') {
	      $(".facility-phone-code").val(response).change();
	    }
	    if (countryVal == "1" || countryVal == "2") {
	
	      formEl.find(".facility-stateText-wrapper").hide();
	      formEl.find(".facility-state-wrapper").show();
	      getRenderedStatesorProvince(countryVal, formEl);
	      $(".broker-org-state-required").text('State/Province/Region *');
	      $(".broker-org-state").addClass("required");
	
	      $(".facility-state-required").text('State/Province/Region *');
	      $(".facility-state").addClass("required");
	    } else {
	      formEl.find(".facility-stateText-wrapper").show();
	      formEl.find(".facility-state-wrapper").hide();
	      $(".broker-org-state-required").text('State/Province/Region');
	      $(".broker-org-state").removeClass("required");
	
	      $(".facility-state-required").text('State/Province/Region');
	      $(".facility-state").removeClass("required");
	      $(".facility-stateText").removeClass("required");
	    }
	
	    var checkZipCode = false;
	    $(countries).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	    if (checkZipCode) {
	      $(".broker-org-zipcode-required").text('Postal Code *');
	      $(".broker-org-zipcode").addClass("required");
	      $(".facility-zip-required").text('Postal Code *');
	      $(".facility-zip").addClass("required");
	    } else {
	      $(".broker-org-zipcode-required").text('Postal Code');
	      $(".broker-org-zipcode").removeClass("required");
	      $(".facility-zip-required").text('Postal Code');
	      $(".facility-zip").removeClass("required");
	    }
	
	    var validateAddressForCountry = false;
	    $(validationReqdCountries).each(function () {
	      if (this.cdmMeaning.toString() === countryVal.toString()) {
	        validateAddressForCountry = true;
	        return false;
	      }
	    });
	    if (validateAddressForCountry) {
	      $(".country_not_supported").hide();
	      $(".facility-country-not-supported").hide();
	    } else {
	      $(".country_not_supported").show();
	      $(".facility-country-not-supported").show();
	    }
	    var facilityContactPhoneCode = formEl.find('.facility-contact-phone-code').val();
	    var facilityPhoneContactNumber = $(".facility-phone-contact-number");
	    if (facilityContactPhoneCode === "+1") {
	      facilityPhoneContactNumber.addClass("phoneUS");
	      facilityPhoneContactNumber.removeClass("phoneNonUS");
	      facilityPhoneContactNumber.attr("placeholder", "___-____");
	      facilityPhoneContactNumber.addClass("phone-format");
	      facilityPhoneContactNumber.inputmask("(999) 999-9999");
	    } else {
	      facilityPhoneContactNumber.addClass("phoneNonUS");
	      facilityPhoneContactNumber.removeClass("phoneUS");
	      facilityPhoneContactNumber.removeClass("phone-format");
	      facilityPhoneContactNumber.removeAttr('placeholder');
	      facilityPhoneContactNumber.inputmask("");
	
	      var val = facilityPhoneContactNumber.val();
	      if (val) {
	        var v = val.replace(/[^0-9.]/g, "");
	        facilityPhoneContactNumber.val(v);
	      }
	    }
	  }
	  function handleRmsFacilityTypeChange(e) {
	    var formEl = $(this).closest("form");
	    if (formEl.find(".rms-facility-type").val() === "vendor") {
	      if (formEl.find(".return-auth-req").is(":checked")) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(formEl.find(".return-auth-req"), true);
	      } else {
	        (0, _instantiateSwitchery.instantiateSwitchery)(formEl.find(".return-auth-req"), false);
	      }
	
	      formEl.find('.vendorSelectAuthorization').show();
	      formEl.find('.inboundClassification').hide();
	    } else if (formEl.find(".rms-facility-type").val() === "return") {
	      formEl.find('.inboundClassification').show();
	      formEl.find('.vendorSelectAuthorization').hide();
	    } else {
	      formEl.find('.inboundClassification').hide();
	      formEl.find('.vendorSelectAuthorization').hide();
	    }
	  }
	
	  function getRenderedStatesorProvince(countryVal, formEl) {
	
	    var stateTypeSelect = formEl.find(".facility-state");
	    stateTypeSelect.html('');
	    var defaultSelectText = "";
	    if (countryVal == "1") {
	      defaultSelectText = "Select State";
	    } else {
	      defaultSelectText = "Select Province";
	    }
	    var option = $('<option />');
	    option.attr('value', "-1").text(defaultSelectText);
	    option.attr('selected', 'selected');
	    option.attr('disabled', 'disabled');
	    stateTypeSelect.append(option);
	    if (countryVal == "1") {
	      $(usaStates).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        stateTypeSelect.append(option);
	      });
	    } else if (countryVal == "2") {
	      $(caProvinces).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        stateTypeSelect.append(option);
	      });
	    }
	    stateTypeSelect.addClass("select2-select");
	    (0, _select2able.instantiateSelect2)(stateTypeSelect);
	  }
	
	  //Render functions for options to be displayed in the select drop downs 
	
	  function getRenderedRmsFacility(retailerFacilityForRMS) {
	    var retailerFacilityHtml = '<option value="{%- rmsFacilityType.cdmValue %}">{%- rmsFacilityType.cdmMeaning %}</option>';
	    var response = _underscore2.default.map(retailerFacilityForRMS, function (rmsFacilityType) {
	      return (0, _render2.default)(retailerFacilityHtml, {
	        rmsFacilityType: rmsFacilityType
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getRenderedFedexAccounts(retailerFacilityForRMS) {
	    var retailerFacilityHtml = '<option value="{%- rmsFacilityType.cmtId %}">{%- rmsFacilityType.cmtAccountNo %}</option>';
	    var response = _underscore2.default.map(retailerFacilityForRMS, function (rmsFacilityType) {
	      return (0, _render2.default)(retailerFacilityHtml, {
	        rmsFacilityType: rmsFacilityType
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getRenderedCountries(countries) {
	    var optionHtml = '<option value="{%- country.conId %}">{%- country.conName %}</option>';
	    var response = _underscore2.default.map(countries, function (country) {
	      return (0, _render2.default)(optionHtml, {
	        country: country
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getRenderedPhoneCodes(phoneCodes) {
	    var phoneCodeOptionHtml = '<option value="{%- phoneCode.conPhoneCode %}">{%- phoneCode.conPhoneText %}</option>';
	    var count = 0;
	    var response = _underscore2.default.map(phoneCodes, function (phoneCode) {
	      if (phoneCode.conPhoneCode === '+1' && count == 0) {
	        phoneCode.conPhoneText = "United States of America/Canada +1";
	        count++;
	        return (0, _render2.default)(phoneCodeOptionHtml, {
	          phoneCode: phoneCode
	        });
	      } else if (phoneCode.conPhoneCode !== '+1') {
	        return (0, _render2.default)(phoneCodeOptionHtml, {
	          phoneCode: phoneCode
	        });
	      }
	    });
	    return response.join("");
	  }
	  //Render functions for the Facility Type checkbox
	  function getRenderedFacilityTypes(facilityTypes) {
	    var facilityTypeHtml = __webpack_require__(284);
	    var response = _underscore2.default.map(facilityTypes, function (facility) {
	      return (0, _render2.default)(facilityTypeHtml, {
	        facility: facility
	      });
	    });
	
	    return response.join("");
	  }
	
	  //Render functions for the Inbound classification Types
	  function getRenderedInboundTypes(inboundClassificationTypes) {
	    var inboundClassificationHtml = __webpack_require__(285);
	    var response = _underscore2.default.map(inboundClassificationTypes, function (inboundClassificationItem) {
	      return (0, _render2.default)(inboundClassificationHtml, {
	        inboundClassificationItem: inboundClassificationItem
	      });
	    });
	
	    return response.join("");
	  }
	
	  function expandFacilitySectionClickHandler(e) {
	    btnClickedEdit = $(this);
	    e.preventDefault();
	    if ($(this).hasClass('disabled')) {
	      //Don't Do Anything
	    } else if (mainEl.find(elsMap.masterFormSectionParent).is(":visible")) {
	      showAbandonFormModal();
	    } else {
	      abandonFormHandler(e);
	    }
	  }
	
	  function expandFacilitySection(btnClicked) {
	    //Hide the static form when the facility is expanded, Need to disable the Edit button for other facilities 
	    mainEl.find(elsMap.masterFormSectionParent).hide();
	    var targetSection = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.customExpanderTarget);
	    //Disable all the other Edit Buttons for the collapsed facilities when one active 
	    $('.facility-edit-section-btn').not(this).each(function () {
	      $(this).addClass('disabled');
	    });
	    validator = targetSection.closest("form").validate(validationOpts);
	    validator.settings.ignore = ":disabled, :hidden";
	
	    elsPage.cancelMainFormBtn.addClass('disabled');
	    elsPage.nextAddfacilityBtn.addClass('disabled');
	    elsPage.saveVendorOrgAddressBtn.addClass('disabled');
	    var updateBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityUpdateSectionBtn);
	    var cancelBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityCancelSectionBtn);
	    btnClicked.hide();
	    updateBtn.show();
	    cancelBtn.show();
	    targetSection.slideDown();
	  }
	
	  function cancelFormClickHandler(e) {
	    showAbandonFormModal();
	  }
	
	  function cancelEditFacilityClickHandler(e) {
	
	    e.preventDefault();
	    //show the static master form again once we hit cancel on the collapsed facility editing 
	    var btnClicked = $(this);
	    var formEl = btnClicked.closest("form");
	    formEl.validate().resetForm();
	    //Enable the Edit Buttons for the other collapsed facilities when Cancel is clicked 
	    $('.facility-edit-section-btn').each(function () {
	      $(this).removeClass('disabled');
	    });
	    elsPage.nextAddfacilityBtn.removeClass('disabled');
	    elsPage.cancelMainFormBtn.removeClass('disabled');
	    elsPage.saveVendorOrgAddressBtn.removeClass('disabled');
	
	    var targetSection = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.customExpanderTarget);
	    var updateBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityUpdateSectionBtn);
	    var cancelBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityCancelSectionBtn);
	    var editBtn = btnClicked.closest(elsMap.customExpanderParent).find(elsMap.facilityEditSectionBtn);
	    btnClicked.hide();
	    updateBtn.hide();
	    editBtn.show();
	    targetSection.slideUp();
	  }
	
	  function collapseFacilitySectionClickHandler(e) {
	    e.preventDefault();
	    var btnClicked = $(this);
	    collapseFacilitySection(btnClicked);
	  }
	
	  function collapseFacilitySection(btnClicked) {
	    var formEl = btnClicked.closest("form");
	    activeFormElement = formEl;
	    //if (!formEl.find('.dup-facName').is(':visible') && !formEl.find('.dup-facId').is(':visible')) {
	    if (validateForm(formEl) && checkFacilityTypesHC(formEl)) {
	      var arrayIndex = formEl.data("obj-id");
	      var oldCmrAddressObj = facilityArray[arrayIndex];
	      var newCmrAddressObj = prepareDataForSubmit(formEl, false);
	      if (userChangedAddress(oldCmrAddressObj, newCmrAddressObj)) {
	        validateAddressModal(formEl);
	      } else {
	        addAddressToStore(newCmrAddressObj, arrayIndex);
	        hideEditForm(formEl);
	      }
	      $('.facility-edit-section-btn').each(function () {
	        $(this).removeClass('disabled');
	      });
	      elsPage.nextAddfacilityBtn.removeClass('disabled');
	      elsPage.saveVendorOrgAddressBtn.removeClass('disabled');
	      elsPage.cancelMainFormBtn.removeClass('disabled');
	    }
	  }
	
	  function userChangedAddress(oldAddress, newAddress) {
	    if (!_underscore2.default.isUndefined(oldAddress.cadAddress1) && !_underscore2.default.isUndefined(newAddress.cadAddress1) && oldAddress.cadAddress1 != newAddress.cadAddress1) {
	      return true;
	    } else if (!(oldAddress.cadAddress2 == null) && !(newAddress.cadAddress2 == "") && oldAddress.cadAddress2 != newAddress.cadAddress2) {
	      return true;
	    } else if (!_underscore2.default.isUndefined(oldAddress.cadState) && !_underscore2.default.isUndefined(newAddress.cadState) && oldAddress.cadState != newAddress.cadState) {
	      return true;
	    } else if (!_underscore2.default.isUndefined(oldAddress.cadCity) && !_underscore2.default.isUndefined(newAddress.cadCity) && oldAddress.cadCity != newAddress.cadCity) {
	      return true;
	    } else if (!_underscore2.default.isUndefined(oldAddress.cadCountry) && !_underscore2.default.isUndefined(newAddress.cadCountry) && oldAddress.cadCountry != newAddress.cadCountry) {
	      return true;
	    } else if (!_underscore2.default.isUndefined(oldAddress.cadZipcode) && !_underscore2.default.isUndefined(newAddress.cadZipcode) && oldAddress.cadZipcode != newAddress.cadZipcode) {
	      return true;
	    }
	    return false;
	  }
	
	  function hideEditForm(editFormEl) {
	    //Enable the Edit Buttons for the other collapsed facilities when Cancel is clicked 
	    $('.facility-edit-section-btn').each(function () {
	      $(this).removeClass('disabled');
	    });
	    //Update the facility name header text
	    var currentFacilityNameHeader = editFormEl.find(".facility-top-name").html(editFormEl.find(".facility-name").val());
	    var targetSection = editFormEl.find(elsMap.customExpanderTarget);
	    var updateBtn = editFormEl.find(elsMap.facilityUpdateSectionBtn);
	    var editBtn = editFormEl.find(elsMap.facilityEditSectionBtn);
	    var cancelBtn = editFormEl.find(elsMap.facilityCancelSectionBtn);
	    updateBtn.hide();
	    cancelBtn.hide();
	    editBtn.show();
	    targetSection.slideUp();
	  }
	
	  //Validate the current expanded form and create the section with both old and new contents here 
	  function addFacilityHandler(e) {
	    if ($('.next-add-facility-btn').hasClass('disabled')) {
	      e.preventDefault();
	    } else {
	      if (!editFlag) {
	        showStaticForm();
	      } else {
	        var orgFormEle = mainEl.find("#master-form");
	        var isValidOrgForm = validateForm(orgFormEle);
	        if (isValidOrgForm && checkFacilityTypesHC(orgFormEle)) {
	          validateAddressModal(orgFormEle);
	        }
	      }
	    }
	  }
	  //HB-12085
	  function addCarrierHandler(e) {
	    e.preventDefault();
	
	    elsPage.saveVendorOrgAddressBtn.removeAttr('disabled');
	    elsPage.carrierDetailsDiv.addClass('hidden');
	    elsPage.useFoundCarrierBtn.attr('disabled', 'disabled');
	
	    teamMemberObj = {};
	    teamMemberArray = [];
	
	    $('.team-member-edit').remove();
	    $('.team-member-section-details').remove();
	
	    if (this.id === 'use-found-carrier-btn') {
	      btnClicked = 'found';
	      elsPage.createCarrierBtn.removeAttr('disabled');
	      newCarrierHandler(carData, btnClicked);
	      elsPage.carrierSection.find('.carrier-by-scac-country').trigger('change');
	    } else if (this.id === 'create-carrier-btn') {
	      btnClicked = 'create';
	      elsPage.createCarrierBtn.attr('disabled', 'disabled');
	      elsPage.carrierDetailsDiv.addClass('hidden');
	      newCreateCarrierHandler(btnClicked);
	    }
	    newCarrierTeamMemberDetailsHandler();
	  }
	  function getRenderedScacListByMerchant(carrierListByMerchant) {
	
	    var affiliatedCarrrierOption = carrierListByMerchant.map(function (carrier) {
	      return (0, _render2.default)(optionTemplateHtml, {
	        targetKey: carrier.orgId,
	        text: carrier.orgName
	      });
	    });
	
	    return affiliatedCarrrierOption.join("");
	  }
	
	  var carrierScacCode = void 0;
	  function checkValue(scacCode) {
	    var i;
	    for (i = 0; i < cmrCarrierScacList.length; i++) {
	      if (scacCode === cmrCarrierScacList[i].carScac /* || scacCode.toUpperCase() === cmrCarrierScacList[i].carScac */) {
	          carrierScacCode = cmrCarrierScacList[i].carScac;
	          return true;
	        }
	    }
	  }
	
	  //duplicate scac code  check
	  function validateScacCode() {
	    $('.scac-error-page').remove();
	    var scacCode = elsPage.carrierSection.find('[name=new-scac-code]').val();
	    if (checkValue(scacCode)) {
	      var valScacCode;
	      $.ajax({
	        data: {
	          carrierScac: carrierScacCode
	        },
	        url: checkSCACExistsForRetailerUrl,
	        //async: false,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(dataResponse) {
	          if (dataResponse == true) {
	            //right one
	            //if (dataResponse === false) {
	            // display 2nd error
	            scacDetails = "";
	            valScacCode = 'retailer';
	            validateScacHandler(scacDetails, valScacCode);
	          } else {
	            ///make ajax call to get checkSCACExistsForCarrier
	            $.ajax({
	              data: {
	                //  orgId:orgId,
	                scacId: carrierScacCode
	              },
	              url: checkSCACExistsForCarrierUrl,
	              //async: false,
	              dataType: 'JSON',
	              type: 'POST',
	              success: function success(dataResponse) {
	                if (dataResponse != null) {
	                  // display 1st error
	                  scacDetails = dataResponse;
	                  valScacCode = 'carrier';
	                  validateScacHandler(scacDetails, valScacCode);
	                }
	              }
	            });
	          }
	        }
	      });
	    }
	  }
	
	  function validateScacHandler(scacDetails, valScacCode) {
	    var countryName = '';
	    if (!(0, _util.isNullOrUndefined)(scacDetails[0]) && !(0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadCountry)) {
	      if (scacDetails[0].cmrAddress.cadCountry == 'US') {
	        countryName = "United States of America";
	      } else if (scacDetails[0].cmrAddress.cadCountry == 'CA') {
	        countryName = "Canada";
	      } else {
	        countryName = scacDetails[0].cmrAddress.cadCountry;
	      }
	    }
	    var validateScacHandlerHtml = $((0, _render2.default)(validateScacCodeWrapperTemplate, {
	      carName: (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carName) ? "" : scacDetails[0].carName,
	      carScac: (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carScac) ? "" : scacDetails[0].carScac,
	      carGln: (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carGln) ? "" : scacDetails[0].carGln,
	      carContactName: (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carContactName) ? "" : scacDetails[0].carContactName,
	      carPhoneCountryCode: (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carPhoneCountryCode) ? "" : scacDetails[0].carPhoneCountryCode,
	      carContactPhone: (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carContactPhone) ? "" : scacDetails[0].carContactPhone,
	      // cadCountry: isNullOrUndefined(scacDetails[0]) ? "" : isNullOrUndefined(scacDetails[0].cadCountry) ? "" : scacDetails[0].cadCountry,
	      cadCountry: countryName,
	      cadContactEmail: (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadContactEmail) ? "" : scacDetails[0].cmrAddress.cadContactEmail,
	      cadAddress1: (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadAddress1) ? "" : scacDetails[0].cmrAddress.cadAddress1,
	      cadAddress2: (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadAddress2) ? "" : scacDetails[0].cmrAddress.cadAddress2
	
	    }));
	
	    $('#validate-scac-code').append(validateScacHandlerHtml);
	    if (valScacCode === 'carrier') {
	      $('.assigned-to-retailer').addClass('hidden');
	    } else if (valScacCode === 'retailer') {
	      $('.assigned-to-carrier').addClass('hidden');
	      $('.assigned-to-carrier-details').addClass('hidden');
	      $('.val-use-found-carrier-btn').addClass('hidden');
	    }
	  }
	
	  function useCarrierScacCode() {
	    isUseFoundCarrierFlow = true;
	    $('.scac-error-page').addClass('hidden');
	    var orgName = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carName) ? "" : scacDetails[0].carName;
	    var carScac = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carScac) ? "" : scacDetails[0].carScac;
	    var carGln = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carGln) ? "" : scacDetails[0].carGln;
	    var carContactName = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carContactName) ? "" : scacDetails[0].carContactName;
	    var carPhoneCountryCode = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carPhoneCountryCode) ? "" : scacDetails[0].carPhoneCountryCode;
	    var carContactPhone = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].carContactPhone) ? "" : scacDetails[0].carContactPhone;
	    var cadContactEmail = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadContactEmail) ? "" : scacDetails[0].cmrAddress.cadContactEmail;
	    var cadCountry = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadCountry) ? "" : scacDetails[0].cmrAddress.cadCountry;
	    var cadAddress1 = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadAddress1) ? "" : scacDetails[0].cmrAddress.cadAddress1;
	    var cadAddress2 = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadAddress2) ? "" : scacDetails[0].cmrAddress.cadAddress2;
	    var cadCity = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadCity) ? "" : scacDetails[0].cmrAddress.cadCity;
	    var cadState = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadState) ? "" : scacDetails[0].cmrAddress.cadState;
	    var cadZipcode = (0, _util.isNullOrUndefined)(scacDetails[0]) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(scacDetails[0].cmrAddress.cadZipcode) ? "" : scacDetails[0].cmrAddress.cadZipcode;
	    var phoneCodes = getRenderedPhoneCodes(phoneCodes);
	
	    (0, _select2able.instantiateSelect2)(elsPage.carrierSection.find('.select2-select'));
	
	    elsPage.carrierSection.find('[name=new-carrier-section-org-name]').val(orgName);
	    elsPage.carrierSection.find('[name=new-scac-code]').val(carScac);
	    elsPage.carrierSection.find('[name=new-carrier-gln]').val(carGln);
	    elsPage.carrierSection.find('[name=new-carrier-contact-name]').val(carContactName);
	
	    elsPage.carrierSection.find('[name=new-carrier-contact-email]').val(cadContactEmail);
	    //elsPage.carrierSection.find('[name=new-phone-code]').val(carPhoneCountryCode);
	    elsPage.carrierSection.find('[name=new-phone-number]').val(carContactPhone);
	    var facilityCountry = countries.find(function (obj) {
	      return obj.conCode == cadCountry;
	    });
	    elsPage.carrierSection.find('[name=new-carrier-contact-country]').val(facilityCountry.conId).trigger('change');
	    elsPage.carrierSection.find('[name=new-carrier-contact-address1]').val(cadAddress1);
	    elsPage.carrierSection.find('[name=new-carrier-contact-address2]').val(cadAddress2);
	    elsPage.carrierSection.find('[name=new-carrier-contact-city]').val(cadCity);
	    elsPage.carrierSection.find('[name=new-carrier-contact-postalcode]').val(cadZipcode);
	
	    elsPage.carrierSection.find('[name=new-carrier-contact-state]').val(cadState).trigger('change');
	    elsPage.carrierSection.find('[name=new-phone-code]').val(carPhoneCountryCode).trigger('change');
	    elsPage.carrierSection.find('[name=new-carrier-contact-country]').on("change", handleSwitchingCarrierStateInput);
	
	    $(".carrier-new-section-details :input").attr("disabled", 'disabled');
	  }
	
	  function onclickCreateCarrier(e) {
	    $("#broker-section").hide();
	    elsPage.carrierSection.show();
	    e.preventDefault();
	    elsPage.useFoundCarrierBtn.attr('disabled', 'disabled');
	    elsPage.carrierDetailsDiv.addClass('hidden');
	    var brokerData = [{ "cadOrganizationName": "", "carPhoneCountryCode": "", "carScac": "", "carName": "", "carContactPhone": "", "carContactName": "", "cmrAddress": { "cadOrganizationName": "", "cadAddress1": "", "cadAddress2": "", "cadZipcode": "", "cadCounty": "", "cadCity": "" } }];
	    newCarrierHandler(brokerData);
	    newCarrierTeamMemberDetailsHandler();
	  }
	
	  var brokerHtml = $((0, _render2.default)(transportationBrokerSectionWrapperTemplate, {
	    data: carData[0],
	    countries: getRenderedCountries(countries),
	    phoneCodes: getRenderedPhoneCodes(phoneCodes),
	    affiliatedCarrrier: getRenderedScacListByMerchant(carrierListByMerchant),
	    orgName: (0, _util.isNullOrUndefined)(organizations.orgName) ? "" : organizations.orgName,
	    cmrAddress: (0, _util.isNullOrUndefined)(organizations.cmrAddress) ? "" : organizations.cmrAddress[0]
	  }));
	
	  $("#broker-section").append(brokerHtml);
	  if (!(0, _util.isNullOrUndefined)(organizations) && !(0, _util.isNullOrUndefined)(organizations.cmrAddress)) {
	    $(".broker-phone-code").val(organizations.cmrAddress[0].cadContactCountryPhoneCode).trigger('change');
	    $(".broker-org-country").val(organizations.cmrAddress[0].cadCountry).trigger('change');
	  }
	
	  var orgCarrierTeamFormHtml = (0, _render2.default)(carrierTeamMemberDetailsWrapperTemplate, {
	    orgType: "broker"
	  });
	
	  $("#broker-section").append(orgCarrierTeamFormHtml);
	
	  function tranportationBrokerHandler() {
	    $("#broker-section").removeClass('q-display-none');
	  }
	
	  // validate the broker contact phoneNumber for "+1" phone code
	  $(".broker-phone-number").on('focusout', function (e) {
	    setPhoneCodeValidation($(this).val());
	  });
	
	  function setPhoneCodeValidation(data) {
	    var brokerPhoneCode = $(".broker-phone-code");
	    var brokerPhoneNumber = $(".broker-phone-number");
	    if (brokerPhoneCode.val() == "+1") {
	      brokerPhoneNumber.addClass("phoneUS");
	      brokerPhoneNumber.removeClass("phoneNonUS");
	    } else {
	      brokerPhoneNumber.addClass("phoneNonUS");
	      brokerPhoneNumber.removeClass("phoneUS");
	      var val = brokerPhoneNumber.val();
	      if (val) {
	        var v = val.replace(/[^0-9.]/g, "");
	        brokerPhoneNumber.val(v);
	      }
	    }
	  }
	
	  // validate email address for broker contact
	  $(".broker-org-email").on('focusout', function (e) {
	    $(".broker-org-email").addClass("pattern");
	  });
	
	  function handleBrokerPhoneValidation() {
	    var brokerPhoneCode = $(".broker-phone-code");
	    var brokerPhoneNumber = $(".broker-phone-number");
	    if (brokerPhoneCode.val() === "+1") {
	      brokerPhoneNumber.addClass("phoneUS");
	      brokerPhoneNumber.removeClass("phoneNonUS");
	      brokerPhoneNumber.attr("placeholder", "___-____");
	      brokerPhoneNumber.inputmask("(999) 999-9999");
	    } else {
	      brokerPhoneNumber.addClass("phoneNonUS");
	      brokerPhoneNumber.removeClass("phoneUS");
	      brokerPhoneNumber.removeAttr('placeholder');
	      brokerPhoneNumber.inputmask("");
	      var val = brokerPhoneNumber.val();
	      if (val) {
	        var v = val.replace(/[^0-9.]/g, "");
	        brokerPhoneNumber.val(v);
	      }
	    }
	  }
	
	  function handleSwitchingBrokerStateInput() {
	    var countryVal = $('.broker-org-country').find(":selected").val();
	
	    if (countryVal == "1" || countryVal == "2") {
	      $('.broker-org-stateText-wrapper').hide();
	      $('.broker-org-state-wrapper').show();
	      if (editForm) {
	        getRenderedStatesEdit(countryVal, organizations.cmrAddress[0].cadState);
	      } else {
	        setStatesForBrokerOrg(countryVal);
	      }
	      $(".broker-org-state-required").text('State/Province/Region *');
	      $(".broker-org-state").addClass("required");
	    } else {
	      $('.broker-org-stateText-wrapper').show();
	      $('.broker-org-state-wrapper').hide();
	      $(".broker-org-state-required").text('State/Province/Region');
	      $(".broker-org-state").removeClass("required");
	    }
	
	    var validateAddressForCountry = false;
	    $(validationReqdCountries).each(function () {
	      if (this.cdmMeaning.toString() === countryVal.toString()) {
	        validateAddressForCountry = true;
	        return false;
	      }
	    });
	    if (validateAddressForCountry) {
	      $(".country_not_supported").hide();
	    } else {
	      $(".country_not_supported").show();
	    }
	
	    var checkZipCode = false;
	    $(countries).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	    if (checkZipCode) {
	      $(".broker-org-zipcode-required").text('Postal Code *');
	      $(".broker-org-zipcode").addClass("required");
	    } else {
	      $(".broker-org-zipcode-required").text('Postal Code');
	      $(".broker-org-zipcode").removeClass("required");
	    }
	  }
	
	  function setStatesForBrokerOrg(countryVal) {
	    // re-initialize states dropdown on every call
	    $('.broker-org-state').html('');
	    if (countryVal == "1") {
	      (0, _selectorHelpers.setOptionsForSelect)({
	        selectElement: $('.broker-org-state'),
	        list: usaStates,
	        valueDataKey: "cdmValue",
	        textDataKey: "cdmMeaning"
	      });
	    } else if (countryVal == "2") {
	      (0, _selectorHelpers.setOptionsForSelect)({
	        selectElement: $('.broker-org-state'),
	        list: caProvinces,
	        valueDataKey: "cdmValue",
	        textDataKey: "cdmMeaning"
	      });
	    }
	  }
	
	  function getRenderedStatesEdit(countryVal, selectedState) {
	    $('.broker-org-state').html('');
	    var brokerStateOptionHtml = '<option value="{%- state.cdmValue %}" {%- selected %} >{%- state.cdmMeaning %}</option>';
	    var response = "";
	    if (countryVal == "1") {
	      response = _underscore2.default.map(usaStates, function (usaState) {
	        return (0, _render2.default)(brokerStateOptionHtml, {
	          state: usaState,
	          selected: selectedState == usaState.cdmValue ? "selected" : ""
	        });
	      });
	    } else if (countryVal == "2") {
	      response = _underscore2.default.map(caProvinces, function (caProvince) {
	        return (0, _render2.default)(brokerStateOptionHtml, {
	          state: caProvince,
	          selected: selectedState == caProvince.cdmValue ? "selected" : ""
	        });
	      });
	    }
	    $('.broker-org-state').append(response.join(""));
	  }
	
	  function clearSearchScacHandler(e) {
	    e.preventDefault();
	    if (elsPage.orgType.val() == 'Carrier') {
	      elsPage.carrierScacTypeAhead.text('');
	      elsPage.carrierDetailsDiv.addClass('hidden');
	      elsPage.carrierInfoButton.addClass('hidden');
	      elsPage.useFoundCarrierBtn.removeAttr('disabled');
	      elsPage.createCarrierBtn.removeAttr('disabled');
	      elsPage.saveVendorOrgAddressBtn.attr('disabled', 'disabled');
	      // $('.carrier-section-details').hide();
	      teamMemberObj = {};
	      teamMemberArray = [];
	      //  $('#carrier-section-div').hide();
	      //  $('#carrier-new-section-div').hide();
	      //  $('.team-member-section-details').hide();
	      // $('.organizationForm').resetForm();
	      $('#carrier-section-div').remove();
	      $('#carrier-new-section-div').remove();
	      $('.team-member-section-details').remove();
	      //$('.organizationForm').find$('#carrier-section-div').hide();
	    }
	  }
	
	  function newCreateCarrierHandler(btnClicked) {
	    $('#carrier-section-div').remove();
	    $('#carrier-new-section-div').remove();
	
	    var searchNewCarrierByScacHtml = $((0, _render2.default)(newCarrierWrapperTemplate, {
	      countries: getRenderedCountries(countries),
	      phoneCodes: getRenderedPhoneCodes(phoneCodes),
	      dupPrgName: duplicateCarrerOrgNameMessage,
	      dupAddress: duplicateAddressMessage
	    }));
	
	    elsPage.carrierSection.append(searchNewCarrierByScacHtml);
	    handleSwitchingCarrierStateInput();
	    (0, _select2able.instantiateSelect2)(searchNewCarrierByScacHtml.find('.select2-select'));
	
	    //Handle the change events in the form 
	    searchNewCarrierByScacHtml.find(".new-carrier-by-scac-country").on("change", handleSwitchingCarrierStateInput);
	    searchNewCarrierByScacHtml.find('.carrier-phone-code').on("change", handleSwitchingCarrierPhoneCountry);
	    handleSwitchingCarrierPhoneCountry();
	  }
	
	  function handleSwitchingCarrierPhoneCountry() {
	    var carrierPhoneCode = $(".carrier-phone-code");
	    var newPhoneFormat = $('.new-phone-format');
	    if (carrierPhoneCode.val() === "+1") {
	      newPhoneFormat.addClass("phoneUS");
	      newPhoneFormat.removeClass("phoneNonUS");
	      newPhoneFormat.attr("placeholder", "___-____");
	      newPhoneFormat.inputmask("(999) 999-9999");
	    } else {
	      newPhoneFormat.addClass("phoneNonUS");
	      newPhoneFormat.removeClass("phoneUS");
	      newPhoneFormat.removeAttr('placeholder');
	      newPhoneFormat.inputmask("");
	      var val = newPhoneFormat.val();
	      if (val) {
	        var v = val.replace(/[^0-9.]/g, "");
	        newPhoneFormat.val(v);
	      }
	    }
	  }
	
	  function handleSwitchingCarrierStateInput() {
	    var countryVal = $('.new-carrier-by-scac-country').find(":selected").val();
	    if (countryVal == "1" || countryVal == "2") {
	      $('.new-carrier-by-scac-stateText-wrapper').hide();
	      $('.new-carrier-by-scac-state-wrapper').show();
	      $(".new-carrier-by-scac-state-required").text('State/Province/Region *');
	      $(".new-carrier-by-scac-state").addClass("required");
	      setStates(countryVal);
	    } else {
	      $('.new-carrier-by-scac-stateText-wrapper').show();
	      $('.new-carrier-by-scac-state-wrapper').hide();
	      $(".new-carrier-by-scac-state-required").text('State/Province/Region');
	      $(".new-carrier-by-scac-state").removeClass("required");
	      $(".new-carrier-by-scac-stateText").removeClass("required");
	    }
	
	    var checkZipCode = false;
	    $(countries).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	
	    if (checkZipCode) {
	      $(".new-carrier-contact-postalcode-required").text('Postal Code *');
	      $(".new-carrier-contact-postalcode").addClass("required");
	    } else {
	      $(".new-carrier-contact-postalcode-required").text('Postal Code');
	      $(".new-carrier-contact-postalcode").removeClass("required");
	    }
	
	    var validateAddressForCountry = false;
	    $(validationReqdCountries).each(function () {
	      if (this.cdmMeaning.toString() === countryVal.toString()) {
	        validateAddressForCountry = true;
	        return false;
	      }
	    });
	
	    if (validateAddressForCountry) {
	      $(".new-carrier-by-scac-country-not-supported").hide();
	    } else {
	      $(".new-carrier-by-scac-country-not-supported").show();
	    }
	  }
	
	  function setStates(countryVal) {
	    // re-initialize states dropdown on every call
	    $('.new-carrier-by-scac-state').html('');
	    if (countryVal == "1") {
	      (0, _selectorHelpers.setOptionsForSelect)({
	        selectElement: $('.new-carrier-by-scac-state'),
	        list: usaStates,
	        valueDataKey: "cdmValue",
	        textDataKey: "cdmMeaning"
	      });
	    } else if (countryVal == "2") {
	      (0, _selectorHelpers.setOptionsForSelect)({
	        selectElement: $('.new-carrier-by-scac-state'),
	        list: caProvinces,
	        valueDataKey: "cdmValue",
	        textDataKey: "cdmMeaning"
	      });
	    }
	  }
	
	  function newCarrierHandler(carData, btnClicked) {
	
	    $('#carrier-section-div').remove();
	    $('#carrier-new-section-div').remove();
	
	    var searchCarrierByScacHtml = $((0, _render2.default)(searchCarrierByScacWrapperTemplate, {
	
	      carName: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].carName) ? "" : carData[0].carName,
	      carScac: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].carScac) ? "" : carData[0].carScac,
	      carGln: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].carGln) ? "" : carData[0].carGln,
	      carContactName: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].carContactName) ? "" : carData[0].carContactName,
	      carPhoneCountryCode: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].carPhoneCountryCode) ? "" : carData[0].carPhoneCountryCode,
	      carContactPhone: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].carContactPhone) ? "" : carData[0].carContactPhone,
	
	      cadContactEmail: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress.cadContactEmail) ? "" : carData[0].cmrAddress.cadContactEmail,
	      cadCountry: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress.cadCountry) ? "" : carData[0].cmrAddress.cadCountry,
	      cadAddress1: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress.cadAddress1) ? "" : carData[0].cmrAddress.cadAddress1,
	      cadAddress2: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress.cadAddress2) ? "" : carData[0].cmrAddress.cadAddress2,
	      cadCity: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress.cadCity) ? "" : carData[0].cmrAddress.cadCity,
	      cadState: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress.cadState) ? "" : carData[0].cmrAddress.cadState,
	      cadZipcode: (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress.cadZipcode) ? "" : carData[0].cmrAddress.cadZipcode,
	      countries: getRenderedCountriesforCarr(countries),
	      phoneCodes: getRenderedPhoneCodes(phoneCodes)
	
	    }));
	
	    (0, _select2able.instantiateSelect2)(searchCarrierByScacHtml.find('.select2-select'));
	
	    var phoneCodeIdSelected = "";
	    if (carData[0] != null && carData[0].carPhoneCountryCode != null) {
	      phoneCodeIdSelected = carData[0].carPhoneCountryCode;
	    }
	
	    var stateCodeIdSelected = "";
	    if (carData[0] != null && carData[0].cmrAddress.cadState != null) {
	      stateCodeIdSelected = carData[0].cmrAddress.cadState;
	    }
	
	    var countryCodeIdSelected = "";
	    if (carData[0] != null && carData[0].cmrAddress.cadCountry != null) {
	      countryCodeIdSelected = carData[0].cmrAddress.cadCountry;
	    }
	
	    searchCarrierByScacHtml.find('.carrier-by-scac-state').val(stateCodeIdSelected).trigger('change');
	    searchCarrierByScacHtml.find(".carrier-phone-code").val(phoneCodeIdSelected).trigger('change');
	
	    $(".carrier-section-details :input").attr("disabled", 'disabled');
	
	    searchCarrierByScacHtml.find(".carrier-by-scac-country").on("change", handleCarCountryChange);
	    searchCarrierByScacHtml.find('.phoneUS').inputmask({ mask: "(999) 999-9999" });
	    elsPage.carrierSection.append(searchCarrierByScacHtml);
	  }
	  function getRenderedCountriesforCarr(countries) {
	    var optionHtml = '<option value="{%- country.conCode %}">{%- country.conName %}</option>';
	    var response = _underscore2.default.map(countries, function (country) {
	      return (0, _render2.default)(optionHtml, {
	        country: country
	      });
	    });
	
	    return response.join("");
	  }
	
	  function handleCarCountryChange() {
	    handleSwitchingStateInputForCarrier();
	  }
	
	  function handleSwitchingStateInputForCarrier() {
	    var formEl = $('#carrier-contact-info');
	    (0, _select2able.instantiateSelect2)(formEl.find('.select2-select'));
	    var countryVal = formEl.find('.carrier-by-scac-country').val();
	    if ((0, _util.isNullOrUndefined)(countryVal)) {
	      //  countryVal = carData[0].cmrAddress.cadCountry;
	      countryVal = (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress.cadCountry) ? "" : carData[0].cmrAddress.cadCountry;
	    }
	    if (countryVal == "US" || countryVal == "CA") {
	      formEl.find(".carrier-by-scac-stateText-wrapper").hide();
	      formEl.find(".carrier-by-scac-state-wrapper").show();
	      $(".carrier-by-scac-state-required").text('State/Province/Region *');
	      $("carrier-by-scac-state").addClass("required");
	      $("carrier-by-scac-stateText").addClass("required");
	      getRenderedStatesorProvinceForCarr(countryVal, (0, _util.isNullOrUndefined)(carData[0]) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress) ? "" : (0, _util.isNullOrUndefined)(carData[0].cmrAddress.cadState) ? "" : carData[0].cmrAddress.cadState);
	    } else {
	      formEl.find(".carrier-by-scac-stateText-wrapper").show();
	      formEl.find(".carrier-by-scac-state-wrapper").hide();
	      $(".carrier-by-scac-state-required").text('State/Province/Region');
	      $(".carrier-by-scac-state").removeClass("required");
	      $(".carrier-by-scac-stateText").removeClass("required");
	    }
	
	    var checkZipCode = false;
	    $(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	    if (checkZipCode) {
	      $(".carrier-contact-postalcode-required").text('Postal Code *');
	      $(".carrier-contact-postalcode").addClass("required");
	    } else {
	      $(".carrier-contact-postalcode-required").text('Postal Code');
	      $(".carrier-contact-postalcode").removeClass("required");
	    }
	
	    var validateAddressForCountry = false;
	    $(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryVal.toString()) {
	        validateAddressForCountry = true;
	        return false;
	      }
	    });
	    if (validateAddressForCountry) {
	      $(".carrier-by-scac-country-required").hide();
	    } else {
	      $(".carrier-by-scac-country-required").show();
	    }
	
	    var phoneCodeVal = formEl.find('.carrier-phone-code').val();
	    var carrierPhoneNumber = $('.carrier-phone-number');
	    if (phoneCodeVal === "+1") {
	      carrierPhoneNumber.addClass("phoneUS");
	      carrierPhoneNumber.removeClass("phoneNonUS");
	      carrierPhoneNumber.attr("placeholder", "___-____");
	      carrierPhoneNumber.inputmask("(999) 999-9999");
	    } else {
	      carrierPhoneNumber.addClass("phoneNonUS");
	      carrierPhoneNumber.removeClass("phoneUS");
	      carrierPhoneNumber.removeAttr('placeholder');
	      carrierPhoneNumber.inputmask("");
	      var val = carrierPhoneNumber.val();
	      if (val) {
	        var v = val.replace(/[^0-9.]/g, "");
	        carrierPhoneNumber.val(v);
	      }
	    }
	  }
	
	  function getRenderedStatesorProvinceForCarr(countryVal, selectedState) {
	    $('.carrier-by-scac-state').html('');
	    var carrierStateOptionHtml = '<option value="{%- state.cdmValue %}" {%- selected %} >{%- state.cdmMeaning %}</option>';
	    var response = "";
	    if (countryVal == "US") {
	      response = _underscore2.default.map(usaStates, function (usaState) {
	        return (0, _render2.default)(carrierStateOptionHtml, {
	          state: usaState,
	          selected: selectedState == usaState.cdmValue ? "selected" : ""
	        });
	      });
	    } else if (countryVal == "CA") {
	      response = _underscore2.default.map(caProvinces, function (caProvince) {
	        return (0, _render2.default)(carrierStateOptionHtml, {
	          state: caProvince,
	          selected: selectedState == caProvince.cdmValue ? "selected" : ""
	        });
	      });
	    }
	    $('.carrier-by-scac-state').append(response.join(""));
	  }
	
	  function newCarrierTeamMemberDetailsHandler() {
	
	    //$('.team-member-section-details').show();
	    var orgCarrierTeamFormHtml = $((0, _render2.default)(carrierTeamMemberDetailsWrapperTemplate, {
	      orgType: "carrier"
	    }));
	    if (editForm) {
	      $('.carrierFormEdit').append(orgCarrierTeamFormHtml);
	    } else {
	      elsPage.carrierSection.append(orgCarrierTeamFormHtml);
	    }
	    $('.team-broker-section').hide();
	  }
	
	  function newTeamMemberAddHandler() {
	    $("#org-facility-form").hide();
	    var arrayIndex = teamMemberArray.length;
	    if (removeArryIndex == 0) {
	      arrayIndex = teamMemberArray.length;
	    } else {
	      arrayIndex = removeArryIndex + 1;
	    }
	    if (elsPage.orgType.val() == 'Transportation Broker') {
	      var orgAddCarrierTeamMemberHtml = $((0, _render2.default)(addCarrierTeamMemberWrapperTemplate, {
	        newEdit: "New",
	        phoneCodes: getRenderedPhoneCodes(phoneCodes),
	        orgName: elsPage.brokerSection.find('[name=broker-org-name]').val(),
	        orgType: "broker",
	        arrayIndex: arrayIndex
	      }));
	      orgAddCarrierTeamMemberHtml.find('.phoneUS').inputmask({
	        mask: "(999) 999-9999"
	      });
	      (0, _select2able.instantiateSelect2)(orgAddCarrierTeamMemberHtml.find('.select2-select'));
	      $('.organizationForm').append(orgAddCarrierTeamMemberHtml);
	    } else {
	      var _orgAddCarrierTeamMemberHtml = $((0, _render2.default)(addCarrierTeamMemberWrapperTemplate, {
	        newEdit: "New",
	        phoneCodes: getRenderedPhoneCodes(phoneCodes),
	        orgName: elsPage.carrierSection.find('[name=carrier-section-org-name]').val() ? elsPage.carrierSection.find('[name=carrier-section-org-name]').val() : elsPage.carrierSection.find('[name=new-carrier-section-org-name]').val(),
	        orgType: "carrier",
	        arrayIndex: arrayIndex
	      }));
	      _orgAddCarrierTeamMemberHtml.find('.phoneUS').inputmask({
	        mask: "(999) 999-9999"
	      });
	      (0, _select2able.instantiateSelect2)(_orgAddCarrierTeamMemberHtml.find('.select2-select'));
	      $('.organizationForm').append(_orgAddCarrierTeamMemberHtml);
	    }
	  }
	
	  var checkUserName = function checkUserName() {
	    var arrayIndex = '';
	    if (_underscore2.default.isUndefined(teamMemberObj.editIndexId)) {
	      //new flow
	      arrayIndex = teamMemberArray.length;
	    } else {
	      // edit flow
	      arrayIndex = teamMemberObj.editIndexId;
	    }
	    $("#user-name-exist-error-" + arrayIndex).hide();
	    var inputValue = $("#car-team-member-username-" + arrayIndex).val();
	    checkDuplicateUserDetails('UserName', inputValue, arrayIndex);
	    checkDuplicateUserTeamMember('UserName', teamMemberArray, inputValue, arrayIndex);
	  };
	  var checkEmailId = function checkEmailId() {
	    var arrayIndex = '';
	    if (_underscore2.default.isUndefined(teamMemberObj.editIndexId)) {
	      //new flow
	      arrayIndex = teamMemberArray.length;
	    } else {
	      // edit flow
	      arrayIndex = teamMemberObj.editIndexId;
	    }
	    var inputValue = $("#car-team-member-email-" + arrayIndex).val();
	    $("#user-email-exist-error-" + arrayIndex).hide();
	    checkDuplicateUserDetails('EmailId', inputValue, arrayIndex);
	    checkDuplicateUserTeamMember('EmailId', teamMemberArray, inputValue, arrayIndex);
	  };
	
	  //check duplicate teamMember in array
	  function checkDuplicateUserTeamMember(inputType, teamMemberArray, inputValue, arrayIndex) {
	    for (var i = 0; i < teamMemberArray.length; i++) {
	      if (inputType == 'UserName') {
	        if (teamMemberArray[i].userName == inputValue) {
	          $("#user-name-exist-error-" + arrayIndex).show();
	        }
	      } else if (inputType == 'EmailId') {
	        if (teamMemberArray[i].email == inputValue) {
	          $("#user-email-exist-error-" + arrayIndex).show();
	        }
	      }
	    }
	  }
	
	  //Check duplicate user name
	  var checkDuplicateUserDetails = function checkDuplicateUserDetails(inputType, inputValue, arrayIndex) {
	    if (inputType.length > 0 && inputValue.length > 0) {
	      $.ajax({
	        url: checkUserNameValidation,
	        type: "GET",
	        data: { inputValue: inputValue, inputType: inputType },
	        beforeSend: function beforeSend() {
	          $.blockUI({ message: 'Checking User Name, Please Wait..' });
	        },
	        complete: function complete() {
	          $.unblockUI();
	        },
	        success: function success(data) {
	          if (data.trim() == 'true') {
	            if (inputType == 'UserName') {
	              $("#user-name-exist-error-" + arrayIndex).show();
	            } else if (inputType == 'EmailId') {
	              $("#user-email-exist-error-" + arrayIndex).show();
	            }
	          }
	        }
	      });
	    }
	  };
	
	  function setTeamMembersForEdit(orgTypeVal) {
	    (0, _underscore2.default)(teamMemberDetailsForEdit).map(function (teammember) {
	      var arrayIndex = teamMemberArray.length;
	      var orgAddBrokerTeamMemberForEditHtml = $((0, _render2.default)(addCarrierTeamMemberWrapperTemplate, {
	        newEdit: "Edit",
	        phoneCodes: orgTypeVal == 'broker' ? getRenderedPhoneCodesEdit(phoneCodes, organizations.cmrAddress[0].cadContactCountryPhoneCode) : getRenderedPhoneCodes(phoneCodes),
	        orgName: orgTypeVal == 'broker' ? elsPage.brokerSection.find('[name=broker-org-name]').val() : elsPage.carrierSection.find('[name=carrier-section-org-name]').val(),
	        orgType: orgTypeVal,
	        userId: teammember.userId,
	        firstName: teammember.firstName,
	        lastName: teammember.lastName,
	        emailAddress: teammember.emailAddress,
	        userName: teammember.userName,
	        phoneNumber: teammember.phoneNumber,
	        phoneCode: teammember.phoneCode,
	        title: teammember.organizationTitle,
	        arrayIndex: arrayIndex
	        //activateUser: teammember.status==0? "q-display-none": "",
	        //inactivateUser: teammember.status==0? "": "q-display-none"
	      }));
	      $('.organizationForm').append(orgAddBrokerTeamMemberForEditHtml);
	      orgAddBrokerTeamMemberForEditHtml.find("#car-team-member-phone-code-" + arrayIndex).val(teammember.phoneCode).trigger('change');
	      $('#addCarrierTeamMemberDivSec-' + arrayIndex).hide();
	      var brokerTeamMemberDetails = setTeamMemberDetailsHtml(arrayIndex);
	      teamMemberArray.push(teamMemberObj);
	      if (orgTypeVal == 'broker') {
	        $('#access-to-team-members-broker').append(brokerTeamMemberDetails);
	      } else {
	        $('#access-to-team-members-carrier').append(brokerTeamMemberDetails);
	      }
	    });
	  }
	
	  function setAffiliatedCarrierOrgsForEdit() {
	    (0, _underscore2.default)(affiliatedCarrierOrgs).map(function (carrierOrg) {
	      $("#find-carriers-for-broker option[value='" + carrierOrg.orgId + "']").attr("selected", 1);
	    });
	  }
	
	  function handleCarrierPhoneCodeTeamMember(e) {
	    var carrierPhoneCodeTeamMemberCode = $('.organizationForm').find('.carrier-phone-code-add-carrier-team-member');
	    var carrierPhoneNumberTeamMember = $('.organizationForm').find('.carrier-phone-number-add-carrier-team-member');
	    var val = carrierPhoneNumberTeamMember.val();
	    if (carrierPhoneCodeTeamMemberCode.val() === "+1") {
	
	      var v = val.replace(/[^0-9.]/g, "");
	      if (v.length > 10) {
	        v = val.substring(0, 10);
	        carrierPhoneNumberTeamMember.val(v);
	      }
	      carrierPhoneNumberTeamMember.addClass("phoneUS");
	      carrierPhoneNumberTeamMember.removeClass("phoneNonUS");
	      carrierPhoneNumberTeamMember.attr("placeholder", "___-____");
	      carrierPhoneNumberTeamMember.inputmask("(999) 999-9999");
	    } else {
	      carrierPhoneNumberTeamMember.addClass("phoneNonUS");
	      carrierPhoneNumberTeamMember.removeClass("phoneUS");
	      carrierPhoneNumberTeamMember.removeAttr('placeholder');
	      carrierPhoneNumberTeamMember.inputmask("");
	      if (val) {
	        var _v = val.replace(/[^0-9.]/g, "");
	        carrierPhoneNumberTeamMember.val(_v);
	      }
	    }
	  }
	
	  function saveTeamMemberBtnHandler(e) {
	    e.preventDefault();
	    var arrayIndex = '';
	    if (_underscore2.default.isUndefined(teamMemberObj.editIndexId)) {
	      //new flow
	      arrayIndex = teamMemberArray.length;
	    } else {
	      // edit flow
	      arrayIndex = teamMemberObj.editIndexId;
	    }
	
	    var isMainFormValid = mainEl.find(".organizationForm").valid();
	    if (!$("#user-name-exist-error-" + arrayIndex).is(":visible") && !$("#user-email-exist-error-" + arrayIndex).is(":visible")) {
	      if (isMainFormValid) {
	        showTeamMemberSaveModal();
	      }
	    }
	  }
	
	  function showTeamMemberSaveModal() {
	    saveTeamMemberModel.modal('show');
	  }
	
	  function loadCarrierDetailsHandler() {
	    var arrayIndex = '';
	    saveTeamMemberModel.modal('hide');
	    addTeamMemberDetails();
	    $('.carrier-teamMember-section').hide();
	    orgFacilityForm.show();
	    $('.remove-check-' + removeArryIndex).removeClass('disabled');
	  }
	
	  function cancelTeamMemberBtnHandler() {
	    $('.carrier-teamMember-section').hide();
	    orgFacilityForm.show();
	  }
	
	  var teamMemberObj = {};
	  var removeArryIndex = 0;
	  function addTeamMemberDetails() {
	    var arrayIndex = "";
	    if (_underscore2.default.isUndefined(teamMemberObj.editIndexId)) {
	      // new flow
	      arrayIndex = teamMemberArray.length;
	      if (removeArryIndex == 0) {
	        arrayIndex = teamMemberArray.length;
	      } else {
	        arrayIndex = removeArryIndex + 1;
	      }
	      var carrierTeamMemberDetails = setTeamMemberDetailsHtml(arrayIndex);
	      teamMemberArray.push(teamMemberObj);
	      if (elsPage.orgType.val() == 'Transportation Broker') {
	        $('#access-to-team-members-broker').append(carrierTeamMemberDetails);
	      } else {
	        $('#access-to-team-members-carrier').append(carrierTeamMemberDetails);
	      }
	    } else {
	      // edit flow
	      arrayIndex = teamMemberObj.editIndexId;
	      var _carrierTeamMemberDetails = setTeamMemberDetailsHtml(arrayIndex);
	      $('#team-member-edit-' + arrayIndex).html(_carrierTeamMemberDetails);
	      teamMemberObj = {};
	    }
	    removeArryIndex = arrayIndex;
	  }
	
	  function setTeamMemberDetailsHtml(arrayIndex) {
	    teamMemberObj.userName = $('#car-team-member-username-' + arrayIndex).val();
	    teamMemberObj.firstName = $("#car-team-member-first-name-" + arrayIndex).val();
	    teamMemberObj.lastName = $("#car-team-member-last-name-" + arrayIndex).val();
	    teamMemberObj.title = $("#org-title-" + arrayIndex).val();
	    teamMemberObj.email = $("#car-team-member-email-" + arrayIndex).val();
	    teamMemberObj.phoneCode = $("#car-team-member-phone-code-" + arrayIndex).val();
	    teamMemberObj.phone = $("#car-team-member-phone-" + arrayIndex).val();
	
	    var carrierTeamMemberDetails = $((0, _render2.default)(addCarrierTeamMemberDetailsWrapperTemplate, {
	      userName: teamMemberObj.userName,
	      title: teamMemberObj.title,
	      email: teamMemberObj.email,
	      phoneCode: teamMemberObj.phoneCode,
	      phone: teamMemberObj.phone,
	      firstName: teamMemberObj.firstName,
	      lastName: teamMemberObj.lastName,
	      arrayIndex: arrayIndex
	    }));
	
	    return carrierTeamMemberDetails;
	  }
	
	  function editTeamMemberBtn(e) {
	    e.preventDefault();
	    $("#org-facility-form").hide();
	    var indexId = $(this).closest('.edit-team-member-btn').data('index-id');
	    removeArryIndex = indexId;
	    // just show the team member for which you want to edit
	    for (var i = 0; i <= removeArryIndex; i++) {
	      if (i == indexId) {
	        $('#addCarrierTeamMemberDivSec-' + i).show();
	        $("#car-team-member-username-" + i).attr("disabled", "disabled");
	        teamMemberObj = {};
	        teamMemberObj.editIndexId = i;
	      } else {
	        $('#addCarrierTeamMemberDivSec-' + i).hide();
	      }
	    }
	    handleCarrierPhoneCodeTeamMember();
	  }
	
	  function removeTeamMemberBtn(e) {
	    e.preventDefault();
	    var arrayIndex = "";
	    if (_underscore2.default.isUndefined(teamMemberObj.editIndexId)) {
	      //new flow
	      arrayIndex = teamMemberArray.length;
	    } else {
	      // edit flow
	      arrayIndex = teamMemberObj.editIndexId;
	    }
	    var indexId = $(this).closest('.remove-team-member-btn').data('index-id');
	    $('.team-check-' + indexId).remove();
	    for (var i = 0; i < teamMemberArray.length; i++) {
	      if (i == indexId) {
	        teamMemberArray.pop(i);
	        $('#addCarrierTeamMemberDivSec-' + i).remove();
	      }
	    }
	  }
	
	  //Validate the Form 
	  function validateForm(formElement) {
	    if (formElement.valid() && !formElement.find('.dup-facName').is(':visible') && !formElement.find('.dup-facId').is(':visible')) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  //Validate the Address section 
	  function validateAddressModal(formElement) {
	    var addressSectionMap = {
	      //Address fields
	      addFacilityCountrySelect: '.facility-country',
	      facilityAddress1: '.facility-address1',
	      facilityAddress2: '.facility-address2',
	      facilityCity: '.facility-city',
	      facilityZipCode: '.facility-zip',
	      facilityStateDropDown: '.facility-state',
	      facilityStateText: '.facility-stateText'
	    };
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, addressSectionMap, formElement);
	    var state = '';
	
	    var validateAddressForCountry = false;
	    $(validationReqdCountries).each(function () {
	      if (this.cdmMeaning.toString() === elsPage.addFacilityCountrySelect.val() || this.cdmValue.toString() === elsPage.addFacilityCountrySelect.val()) {
	        validateAddressForCountry = true;
	        return false;
	      }
	    });
	    if (validateAddressForCountry) {
	      var _data;
	
	      state = elsPage.facilityStateDropDown.val();
	      $.ajax({
	        url: addressValidationUrl,
	        type: "POST",
	        data: (_data = {}, _defineProperty(_data, portletNamespace + 'cadAddress1', elsPage.facilityAddress1.val()), _defineProperty(_data, portletNamespace + 'cadAddress2', elsPage.facilityAddress2.val()), _defineProperty(_data, portletNamespace + 'cadCity', elsPage.facilityCity.val()), _defineProperty(_data, portletNamespace + 'cadState', state), _defineProperty(_data, portletNamespace + 'cadZipcode', elsPage.facilityZipCode.val()), _defineProperty(_data, portletNamespace + 'cadCountry', elsPage.addFacilityCountrySelect.val()), _data),
	        beforeSend: function beforeSend() {
	          $.blockUI({ message: 'Validating Address, Please Wait..' });
	        },
	        complete: function complete() {
	          $.unblockUI();
	        },
	        success: function success(data, textStatus, jqXHR) {
	          addValResponse = $.parseJSON(data);
	          if (addValResponse.result == true) {
	            _EditChecker2.default.setPageClean();
	            elsPage.addressReturned.css("display", "");
	            elsPage.invalidAddress.css("display", "none");
	            elsPage.invalidAddressText.css("display", "none");
	            elsPage.returnedAddressRadio.prop('checked', false);
	            elsPage.enteredAddressRadio.prop('checked', true);
	            elsPage.returnedAddressRadio.show();
	            checkSubmitAddressForm(addValResponse);
	          } else {
	            elsPage.addressReturned.css("display", "none");
	            elsPage.invalidAddress.css("display", "");
	            elsPage.invalidAddressText.css("display", "");
	            elsPage.invalidAddressText.html('Unable to find a validated address');
	            elsPage.returnedAddressRadio.hide();
	            elsPage.returnedAddressRadio.prop('checked', false);
	            elsPage.enteredAddressRadio.prop('checked', true);
	            checkSubmitAddressForm(addValResponse);
	          }
	        }
	      });
	    } else {
	      submitFacilityAddress();
	    }
	  }
	
	  function checkSubmitAddressForm(addValResponse) {
	    elsPage.enteredAddressText.html(addValResponse.enteredAdd);
	    elsPage.returnedAddressText.html(addValResponse.returnedAdd);
	    elsPage.returnedAddressRadio.prop('checked', true);
	    addressEl.modal('show');
	  }
	
	  //If the user chooses to stay on the static form to modify the address 
	  function modifyFacilityAddress() {
	    addressEl.modal('hide');
	  }
	
	  //User chooses to submit the address whether the entered one or the returned one 
	  function submitFacilityAddress(cadId) {
	    var cmrCarrierAddressObj = {};
	
	    cmrCarrierAddressObj.cadId = addValResponse.cadId;
	    if (elsPage.orgType.val() == 'Carrier') {
	
	      //  if (elsPage.returnedAddressRadio.is(":checked") && doAddressValidation) {
	      if (btnClicked === 'create') {
	        cmrCarrierAddressObj.cadCountry = elsPage.carrierSection.find('[name=new-carrier-contact-country]').val();
	        var countryVal = $('.new-carrier-by-scac-country').val();
	      } else if (btnClicked === 'found') {
	        cmrCarrierAddressObj.cadCountry = elsPage.carrierSection.find('[name=carrier-contact-country]').val();
	      } else {
	        cmrCarrierAddressObj.cadCountry = orgFacilityForm.find('[name=new-carrier-contact-country]').val();
	      }
	      cmrCarrierAddressObj.cadState = addValResponse.returnedState;
	      cmrCarrierAddressObj.cadAddress1 = addValResponse.returnedAddress1;
	      cmrCarrierAddressObj.cadAddress2 = addValResponse.returnedAddress2;
	      cmrCarrierAddressObj.cadCity = addValResponse.returnedCity;
	      cmrCarrierAddressObj.cadZipcode = addValResponse.returnedZip;
	      cmrCarrierAddressObj.cadUseStdAddress = '1';
	
	      // }
	
	      addressEl.modal('hide');
	      saveCarrierModalHandler(cmrCarrierAddressObj);
	      return;
	    }
	
	    var formHTML = "<form id='facility-form-{%-arrayIndex%}' data-obj-id='{%- arrayIndex%}' class='child-form-edit'><div class='q-section custom-expander-parent'>";
	    //If active form element has data-org-id store at that index, else push 
	    var dataObjId = activeFormElement.data("obj-id");
	    var cmrAddressObj = prepareDataForSubmit(activeFormElement);
	
	    if (_underscore2.default.isNumber(dataObjId)) {
	      addAddressToStore(cmrAddressObj, dataObjId);
	    } else {
	      addAddressToStore(cmrAddressObj);
	    }
	
	    var arrayIndex = facilityArray.length - 1;
	    if (saveBtnClicked) {
	      saveModalHandler();
	    } else if (activeFormElement.attr("id") != 'master-form') {
	      hideEditForm(activeFormElement);
	      activeFormElement = $("#master-form");
	    } else {
	      var orgAddedHtml = $((0, _render2.default)(facilityWrapperTemplate, {
	        masterForm: (0, _render2.default)(formHTML, _extends({
	          arrayIndex: arrayIndex
	        }, cmrAddressObj)),
	        facilityDetails: (0, _render2.default)(facilityDetailsHtml, _extends({
	          arrayIndex: arrayIndex
	        }, cmrAddressObj, {
	          dupFacName: duplicateCadLocationNameMessage,
	          dupFacId: duplicateAddressIdMessage,
	          rmsTypes: getRMSFacilityTypes(arrayIndex)
	        })),
	        hcmbFacilityTypes: getHcmbFacilityTypesEdit(cmrAddressObj, arrayIndex),
	        rmsFacilityTypes: getRmsFacilityTypesEdit(cmrAddressObj, arrayIndex),
	        facilityAddress: (0, _render2.default)(facilityAddressHtml, _extends({
	          arrayIndex: arrayIndex
	        }, cmrAddressObj, {
	          countries: getRenderedCountries(countries)
	        })),
	        facilityContact: (0, _render2.default)(facilityContactHtml, _extends({
	          arrayIndex: arrayIndex
	        }, cmrAddressObj, {
	          phoneCodes: getRenderedPhoneCodes(phoneCodes)
	
	        })),
	        facilityName: cmrAddressObj.cadLocationName,
	        sectionIsExpandable: (0, _render2.default)(__webpack_require__(283)),
	        isHoneyComb: isHoneyComb
	      }));
	      elsPage.facilityFormDiv.append(orgAddedHtml);
	      ///Trigger on the default values
	      (0, _select2able.instantiateSelect2)(orgAddedHtml.find('.select2-select'));
	      //Mask the Phone number 
	      orgAddedHtml.find('.phone-format').inputmask({
	        mask: "(999) 999-9999"
	      });
	
	      //Handle the change events in the form 
	      orgAddedHtml.find(".facility-country").on("change", handleCountryChange);
	      orgAddedHtml.find(".facility-country").val(cmrAddressObj.cadCountry).trigger('change');
	      if (cmrAddressObj.cadCountry === "1" || cmrAddressObj.cadCountry === "2") {
	        orgAddedHtml.find(".facility-state").val(cmrAddressObj.cadState).trigger('change');
	      } else {
	        orgAddedHtml.find(".facility-stateText").val(cmrAddressObj.cadState);
	      }
	      if (!isHoneyComb) {
	        orgAddedHtml.find(".rms-facility-type").on("change", handleRmsFacilityTypeChange);
	        orgAddedHtml.find(".fedex-acct-num-location").val(cmrAddressObj.cadCmtId).trigger("change");
	        orgAddedHtml.find(".retailer-cas-acct").val(cmrAddressObj.cadCcaId).trigger("change");
	        var attrArray = cmrAddressObj.cmrAddressAttributes;
	        var facType = "";
	        for (var i = 0; i < attrArray.length; i++) {
	          if (attrArray[i].caaValue === "VR") {
	            facType = "vendor";
	          } else if (attrArray[i].caaValue === "RC") {
	            facType = "return";
	          }
	        }
	        if (facType === "vendor") {
	          var vrRequired = false;
	          for (var _i = 0; _i < attrArray.length; _i++) {
	            if (attrArray[_i].caaKey === "vendor_ra_required") {
	              vrRequired = true;
	            }
	          }
	          if (vrRequired) {
	            (0, _instantiateSwitchery.instantiateSwitchery)(orgAddedHtml.find(".ra-auth-switch"), true);
	            (0, _instantiateSwitchery.setSwitchery)(orgAddedHtml.find(".ra-auth-switch"), true);
	            for (var _i2 = 0; _i2 < attrArray.length; _i2++) {
	              if (attrArray[_i2].caaKey === "vendor_standing_ra") {
	                orgAddedHtml.find(".stndNumber").show();
	                orgAddedHtml.find(".stndNumber").val(attrArray[_i2].caaValue);
	              }
	            }
	          } else {
	            (0, _instantiateSwitchery.instantiateSwitchery)(orgAddedHtml.find(".ra-auth-switch"), false);
	            (0, _instantiateSwitchery.setSwitchery)(orgAddedHtml.find(".ra-auth-switch"), false);
	            orgAddedHtml.find(".stndNumber").hide();
	          }
	          orgAddedHtml.find(".rms-facility-type").val(facType).trigger('change');
	          orgAddedHtml.find('.inboundClassification').hide();
	        } else {
	          orgAddedHtml.find(".rms-facility-type").val(facType).trigger('change');
	          orgAddedHtml.find('.inboundClassification').show();
	          orgAddedHtml.find('.vendorSelectAuthorization').hide();
	        }
	      }
	
	      orgAddedHtml.find(".facility-phone-code").val(cmrAddressObj.cadContactCountryPhoneCode).trigger('change');
	      hideAllExpandableSectionsOnPageLoad();
	      resetMasterForm();
	      mainEl.find(elsMap.masterFormSectionParent).show();
	    }
	  }
	
	  function getRmsFacilityTypes(cmrAddressObj, arrayIndex) {
	    if (!isHoneyComb) {
	      return (0, _render2.default)(inboundClassificationHtml, _extends({
	        arrayIndex: arrayIndex
	      }, cmrAddressObj, {
	        inboundClassificationTypes: getRenderedInboundTypes(inboundClassificationTypes),
	        isHoneyComb: isHoneyComb
	      }));
	    }
	  }
	
	  function prepareDataForSubmit(formElement) {
	    var doAddressValidation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var arrayIndex = formElement.data("obj-id");
	    if (_underscore2.default.isUndefined(arrayIndex)) {
	      arrayIndex = "";
	    }
	    //Values of Facility Object that need to be stored 
	    var facilityObjMap = {
	      facilityName: ".facility-name",
	      facilityId: ".facility-id",
	      contactName: ".contact-name",
	      phoneCode: ".facility-phone-code",
	      phoneNumber: ".contact-number",
	      emailId: ".contact-email",
	      returnCenter: "#return" + arrayIndex,
	      manualReturn: "#manual_return" + arrayIndex,
	      partnerFacility: "#partner_facility" + arrayIndex,
	      facilityType: ".rms-facility-type",
	      fedExAccount: ".fedex-acct-num-location",
	      rmsCharity: "#CHA" + arrayIndex,
	      rmsDestroy: "#DES" + arrayIndex,
	      rmsRecall: "#RCL" + arrayIndex,
	      rmsRecycle: "#REC" + arrayIndex,
	      rmsRefurbish: "#REF" + arrayIndex,
	      rmsReturnable: "#RET" + arrayIndex,
	      rmsReturnToStock: "#RTS" + arrayIndex,
	      rmsSalvage: "#SAL" + arrayIndex,
	      addFacilityCountrySelect: ".facility-country",
	      facilityStateDropDown: ".facility-state",
	      facilityAddress1: ".facility-address1",
	      facilityAddress2: ".facility-address2",
	      facilityCity: ".facility-city",
	      facilityZipCode: ".facility-zip",
	      facilityStateText: ".facility-stateText",
	      returnAuthReq: ".ra-auth-switch",
	      stndNumber: ".stndNumber",
	      casAccount: ".retailer-cas-acct"
	
	    };
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, facilityObjMap, formElement);
	    //On Submit address, create the CmrAddressObj and Store the values in it 
	    var cmrAddressObj = {};
	    var cmrAddressAttributes = [];
	    var state = '';
	    var cadId = formElement.find(".cadId").val();
	    var cadStatus = formElement.find('.cadStatus').val();
	    if (elsPage.addFacilityCountrySelect.val() == '1' || elsPage.addFacilityCountrySelect.val() == '2') {
	      state = elsPage.facilityStateDropDown.val();
	    } else {
	      state = elsPage.facilityStateText.val();
	    }
	
	    cmrAddressObj.cadId = cadId;
	    cmrAddressObj.cadActive = cadStatus;
	    //Facility Details
	    if (!isHoneyComb) {
	      cmrAddressObj.cadAddressType = elsPage.facilityType.val();
	      cmrAddressObj.cadCmtId = elsPage.fedExAccount.val();
	      cmrAddressObj.cadCcaId = elsPage.casAccount.val();
	      if (cmrAddressObj.cadAddressType === 'vendor') {
	        var cmrObj = {};
	        cmrObj.caaKey = "vendor";
	        cmrObj.caaValue = "VR";
	        cmrAddressAttributes.push(cmrObj);
	        if (elsPage.returnAuthReq.is(":checked")) {
	          var cmrAttributeobj = {};
	          cmrAttributeobj.caaKey = "vendor_ra_required";
	          cmrAttributeobj.caaValue = "true";
	          cmrAddressAttributes.push(cmrAttributeobj);
	        }
	        if (elsPage.stndNumber.val() != "") {
	          var _cmrAttributeobj = {};
	          _cmrAttributeobj.caaKey = "vendor_standing_ra";
	          _cmrAttributeobj.caaValue = elsPage.stndNumber.val();
	          cmrAddressAttributes.push(_cmrAttributeobj);
	        }
	        cmrAddressObj.cmrAddressAttributes = cmrAddressAttributes;
	      }
	
	      if (cmrAddressObj.cadAddressType === 'return') {
	        var _cmrObj = {};
	        _cmrObj.caaKey = "return";
	        _cmrObj.caaValue = "RC";
	        cmrAddressAttributes.push(_cmrObj);
	        if (elsPage.rmsCharity.is(":checked")) {
	          var _cmrAttributeobj2 = {};
	          _cmrAttributeobj2.caaKey = "inbound_classification";
	          _cmrAttributeobj2.caaValue = "CHA";
	          cmrAddressAttributes.push(_cmrAttributeobj2);
	        }
	        if (elsPage.rmsDestroy.is(":checked")) {
	          var _cmrAttributeobj3 = {};
	          _cmrAttributeobj3.caaKey = "inbound_classification";
	          _cmrAttributeobj3.caaValue = "DES";
	          cmrAddressAttributes.push(_cmrAttributeobj3);
	        }
	        if (elsPage.rmsRecall.is(":checked")) {
	          var _cmrAttributeobj4 = {};
	          _cmrAttributeobj4.caaKey = "inbound_classification";
	          _cmrAttributeobj4.caaValue = "RCL";
	          cmrAddressAttributes.push(_cmrAttributeobj4);
	        }
	        if (elsPage.rmsRecycle.is(":checked")) {
	          var _cmrAttributeobj5 = {};
	          _cmrAttributeobj5.caaKey = "inbound_classification";
	          _cmrAttributeobj5.caaValue = "REC";
	          cmrAddressAttributes.push(_cmrAttributeobj5);
	        }
	        if (elsPage.rmsRefurbish.is(":checked")) {
	          var _cmrAttributeobj6 = {};
	          _cmrAttributeobj6.caaKey = "inbound_classification";
	          _cmrAttributeobj6.caaValue = "REF";
	          cmrAddressAttributes.push(_cmrAttributeobj6);
	        }
	        if (elsPage.rmsReturnable.is(":checked")) {
	          var _cmrAttributeobj7 = {};
	          _cmrAttributeobj7.caaKey = "inbound_classification";
	          _cmrAttributeobj7.caaValue = "RET";
	          cmrAddressAttributes.push(_cmrAttributeobj7);
	        }
	        if (elsPage.rmsReturnToStock.is(":checked")) {
	          var _cmrAttributeobj8 = {};
	          _cmrAttributeobj8.caaKey = "inbound_classification";
	          _cmrAttributeobj8.caaValue = "RTS";
	          cmrAddressAttributes.push(_cmrAttributeobj8);
	        }
	        if (elsPage.rmsSalvage.is(":checked")) {
	          var _cmrAttributeobj9 = {};
	          _cmrAttributeobj9.caaKey = "inbound_classification";
	          _cmrAttributeobj9.caaValue = "SAL";
	          cmrAddressAttributes.push(_cmrAttributeobj9);
	        }
	        cmrAddressObj.cmrAddressAttributes = cmrAddressAttributes;
	      }
	    } else {
	      if (elsPage.returnCenter.is(":checked")) {
	        var _cmrAttributeobj10 = {};
	        _cmrAttributeobj10.caaKey = "return";
	        _cmrAttributeobj10.caaValue = "RC";
	        cmrAddressAttributes.push(_cmrAttributeobj10);
	      }
	      if (elsPage.manualReturn.is(":checked")) {
	        var _cmrAttributeobj11 = {};
	        _cmrAttributeobj11.caaKey = "manual_return";
	        _cmrAttributeobj11.caaValue = "MR";
	        cmrAddressAttributes.push(_cmrAttributeobj11);
	      }
	      if (elsPage.partnerFacility.is(":checked")) {
	        var _cmrAttributeobj12 = {};
	        _cmrAttributeobj12.caaKey = "partner_facility";
	        _cmrAttributeobj12.caaValue = "PF";
	        cmrAddressAttributes.push(_cmrAttributeobj12);
	      }
	
	      cmrAddressObj.cmrAddressAttributes = cmrAddressAttributes;
	    }
	    //Set the common fields on the static form to the cmrAddressObj 
	    // cmrAddressObj.cadLocationName = elsPage.facilityName.val();
	    cmrAddressObj.cadLocationName = elsPage.facilityName.val();
	    cmrAddressObj.cadAddressId = elsPage.facilityId.val();
	    cmrAddressObj.cadContactName = elsPage.contactName.val();
	    cmrAddressObj.cadContactEmail = elsPage.emailId.val();
	    cmrAddressObj.cadContactCountryPhoneCode = elsPage.phoneCode.val();
	    cmrAddressObj.cadContactPhone = elsPage.phoneNumber.val();
	    cmrAddressObj.cadCommercialAddrFlag = addValResponse.returnedIsCommercial;
	    cmrAddressObj.cadState = state;
	
	    //If the user selects the Return address populate the Address validation response to the CMRObject 
	    //Else If the user selects the Entered address populate the same values as mentioned in the Address section 
	    if (elsPage.returnedAddressRadio.is(":checked") && doAddressValidation) {
	      cmrAddressObj.cadCountry = elsPage.addFacilityCountrySelect.val();
	      cmrAddressObj.cadState = addValResponse.returnedState;
	      cmrAddressObj.cadAddress1 = addValResponse.returnedAddress1;
	      cmrAddressObj.cadAddress2 = addValResponse.returnedAddress2;
	      cmrAddressObj.cadCity = addValResponse.returnedCity;
	      cmrAddressObj.cadZipcode = addValResponse.returnedZip;
	      cmrAddressObj.cadUseStdAddress = '1';
	    } else {
	      cmrAddressObj.cadCountry = elsPage.addFacilityCountrySelect.val();
	      cmrAddressObj.cadAddress1 = elsPage.facilityAddress1.val();
	      cmrAddressObj.cadAddress2 = elsPage.facilityAddress2.val();
	      cmrAddressObj.cadCity = elsPage.facilityCity.val();
	      cmrAddressObj.cadZipcode = elsPage.facilityZipCode.val();
	      cmrAddressObj.cadUseStdAddress = '0';
	    }
	    addressEl.modal('hide');
	
	    return cmrAddressObj;
	  }
	
	  function addAddressToStore(cmrAddressObj, index) {
	    if (_underscore2.default.isNumber(index)) {
	      facilityArray[index] = cmrAddressObj;
	    } else {
	      facilityArray.push(cmrAddressObj);
	    }
	  }
	
	  function populateEditForm(cmrAddressObj, arrayIndex) {
	    var formHTML = "<form id='facility-form-{%-arrayIndex%}' data-obj-id='{%- arrayIndex%}' class='child-form-edit'><div class='q-section custom-expander-parent'>";
	
	    var orgAddedHtml = $((0, _render2.default)(facilityWrapperTemplate, _extends({
	
	      masterForm: (0, _render2.default)(formHTML, {
	        arrayIndex: arrayIndex
	      })
	    }, cmrAddressObj, {
	      facilityDetails: (0, _render2.default)(facilityDetailsHtml, _extends({
	        arrayIndex: arrayIndex
	      }, cmrAddressObj, {
	        isHoneyComb: isHoneyComb,
	        cadAddressId: cmrAddressObj.cadAddressId,
	        dupFacName: duplicateCadLocationNameMessage,
	        dupFacId: duplicateAddressIdMessage,
	        rmsTypes: getRMSFacilityTypes(arrayIndex)
	      })),
	      hcmbFacilityTypes: getHcmbFacilityTypesEdit(cmrAddressObj, arrayIndex),
	      rmsFacilityTypes: getRmsFacilityTypesEdit(cmrAddressObj, arrayIndex),
	      facilityAddress: (0, _render2.default)(facilityAddressHtml, _extends({
	        arrayIndex: arrayIndex
	      }, cmrAddressObj, {
	        countries: getRenderedCountries(countries)
	      })),
	      facilityContact: (0, _render2.default)(facilityContactHtml, _extends({
	        arrayIndex: arrayIndex
	      }, cmrAddressObj, {
	        phoneCodes: getRenderedPhoneCodesEdit(phoneCodes, cmrAddressObj.cadContactCountryPhoneCode)
	
	      })),
	      facilityName: cmrAddressObj.cadLocationName,
	      sectionIsExpandable: (0, _render2.default)(__webpack_require__(283)),
	      isHoneyComb: isHoneyComb
	    })));
	
	    elsPage.facilityFormDiv.append(orgAddedHtml);
	    //Mask the Phone number 
	    orgAddedHtml.find('.phone-format').inputmask({ mask: "(999) 999-9999" });
	    orgAddedHtml.find('.inboundClassification').hide();
	    orgAddedHtml.find(".facility-country").on("change", handleCountryChange);
	    orgAddedHtml.find(".facility-country").val(cmrAddressObj.cadCountry).trigger('change');
	    if (cmrAddressObj.cadCountry === "1" || cmrAddressObj.cadCountry === "2") {
	      orgAddedHtml.find(".facility-state").val(cmrAddressObj.cadState).trigger('change');
	    } else {
	      orgAddedHtml.find(".facility-stateText").val(cmrAddressObj.cadState);
	    }
	
	    hideAllExpandableSectionsOnPageLoad();
	    if (!isHoneyComb) {
	      orgAddedHtml.find(".rms-facility-type").on("change", handleRmsFacilityTypeChange);
	      orgAddedHtml.find(".fedex-acct-num-location").val(cmrAddressObj.cadCmtId).trigger("change");
	      orgAddedHtml.find(".retailer-cas-acct").val(cmrAddressObj.cadCcaId).trigger("change");
	      var attrArray = cmrAddressObj.cmrAddressAttributes;
	      var facType = "";
	      for (var i = 0; i < attrArray.length; i++) {
	        if (attrArray[i].caaValue === "VR") {
	          facType = "vendor";
	        } else if (attrArray[i].caaValue === "RC") {
	          facType = "return";
	        }
	      }
	      if (facType === "vendor") {
	        var vrRequired = false;
	        for (var _i3 = 0; _i3 < attrArray.length; _i3++) {
	          if (attrArray[_i3].caaKey === "vendor_ra_required") {
	            vrRequired = true;
	          }
	        }
	        if (vrRequired) {
	          orgAddedHtml.find("#return-auth-req" + arrayIndex).prop('checked', true);
	          for (var _i4 = 0; _i4 < attrArray.length; _i4++) {
	            if (attrArray[_i4].caaKey === "vendor_standing_ra") {
	              orgAddedHtml.find("#stndNumber" + arrayIndex).show();
	              orgAddedHtml.find("#stndNumber" + arrayIndex).val(attrArray[_i4].caaValue);
	            }
	          }
	        }
	        orgAddedHtml.find(".rms-facility-type").val(facType).trigger('change');
	        orgAddedHtml.find('.inboundClassification').hide();
	      } else {
	        orgAddedHtml.find(".rms-facility-type").val(facType).trigger('change');
	        orgAddedHtml.find('.inboundClassification').show();
	        orgAddedHtml.find('.vendorSelectAuthorization').hide();
	      }
	    }
	  }
	
	  function getRmsFacilityTypesEdit(cmrAddressObj, arrayIndex) {
	    if (!isHoneyComb) {
	      return (0, _render2.default)(inboundClassificationHtml, _extends({
	        arrayIndex: arrayIndex
	      }, cmrAddressObj, {
	        inboundClassificationTypes: getRenderedInboundTypesEdit(inboundClassificationTypes, cmrAddressObj.cmrAddressAttributes, cmrAddressObj.cadCity, arrayIndex),
	        isHoneyComb: isHoneyComb
	      }));
	    }
	  }
	
	  function getHcmbFacilityTypesEdit(cmrAddressObj, arrayIndex) {
	    if (isHoneyComb) {
	      return (0, _render2.default)(facilityTypeHtml, _extends({
	        arrayIndex: arrayIndex
	      }, cmrAddressObj, {
	        facilityTypes: getRenderedFacilityTypesEdit(facilityTypes, cmrAddressObj.cmrAddressAttributes, cmrAddressObj.cadCity, arrayIndex)
	      }));
	    }
	  }
	
	  function populateEdit() {
	    for (var i = 0; i < facilityArray.length; i++) {
	      populateEditForm(facilityArray[i], i);
	      var phoneCode = $('#phone-code' + i);
	      phoneCode.val(facilityArray[i].cadContactCountryPhoneCode).trigger('change');
	      phoneCode.change({ index: i }, function (event) {
	        handleFacilityPhoneValidationByIndex(event.data.index);
	      });
	    }
	  }
	
	  function resetMasterForm() {
	    editFlag = false;
	
	    var masterForm = mainEl.find("#master-form");
	    masterForm[0].reset();
	    masterForm.validate().resetForm();
	    //Select 2 needs to be handled here 
	    masterForm.find('.select2-select').val('');
	    (0, _select2able.instantiateSelect2)(masterForm.find('.select2-select'));
	    //Handle the change events in the form 
	    masterForm.find(".rms-facility-type").on("change", handleRmsFacilityTypeChange);
	    masterForm.find(".rms-facility-type").val("").trigger('change');
	    masterForm.find(".facility-country").on("change", handleCountryChange);
	    masterForm.find(".facility-country").val(defaultCountry).trigger('change');
	    masterForm.find(".facility-phone-code").val("+1").trigger('change');
	    activeFormElement = masterForm;
	  }
	
	  function getRenderedFacilityTypesEdit(facilityTypes, cmrAddressAttributes, cadCity, arrayIndex) {
	    var facilityTypeHtml = __webpack_require__(284);
	    var response = _underscore2.default.map(facilityTypes, function (facility) {
	      return (0, _render2.default)(facilityTypeHtml, {
	        arrayIndex: arrayIndex,
	        facility: facility,
	        cadCity: cadCity,
	        isChecked: getValuesForTypes(cmrAddressAttributes, facility)
	      });
	    });
	    return response.join("");
	  }
	
	  function getValuesForTypes(cmrAddressAttributes, facility) {
	    var checked = "";
	    for (var i = 0; i < cmrAddressAttributes.length; i++) {
	      if (facility.cdmMeaning === cmrAddressAttributes[i].caaKey) {
	        checked = "checked";
	      }
	    }
	    return checked;
	  }
	
	  function getRenderedInboundTypesEdit(inboundClassificationTypes, cmrAddressAttributes, cadCity, arrayIndex) {
	    var inboundClassificationHtml = __webpack_require__(285);
	    var response = _underscore2.default.map(inboundClassificationTypes, function (inboundClassificationItem) {
	      return (0, _render2.default)(inboundClassificationHtml, {
	        arrayIndex: arrayIndex,
	        inboundClassificationItem: inboundClassificationItem,
	        cadCity: cadCity,
	        isChecked: getValuesForInbound(cmrAddressAttributes, inboundClassificationItem)
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getValuesForInbound(cmrAddressAttributes, inbound) {
	    var checked = "";
	    for (var i = 0; i < cmrAddressAttributes.length; i++) {
	      if (inbound.cdmValue === cmrAddressAttributes[i].caaValue) {
	        checked = "checked";
	      }
	    }
	    return checked;
	  }
	
	  function getRenderedPhoneCodesEdit(phoneCodes, selectedCode) {
	    var phoneCodeOptionHtml = '<option value="{%- phoneCode.conPhoneCode %}" {%- selected %} >{%- phoneCode.conPhoneText %}</option>';
	    var count = 0;
	    var response = _underscore2.default.map(phoneCodes, function (phoneCode) {
	      if (phoneCode.conPhoneCode === '+1' && count == 0) {
	        phoneCode.conPhoneText = "United States of America/Canada +1";
	        count++;
	        return (0, _render2.default)(phoneCodeOptionHtml, {
	          phoneCode: phoneCode,
	          selected: getselectedPhoneCode(selectedCode, phoneCode)
	        });
	      } else if (phoneCode.conPhoneCode !== '+1') {
	        return (0, _render2.default)(phoneCodeOptionHtml, {
	          phoneCode: phoneCode,
	          selected: getselectedPhoneCode(selectedCode, phoneCode)
	        });
	      }
	    });
	
	    return response.join("");
	  }
	
	  function getselectedPhoneCode(selectedCode, phoneCode) {
	    if (selectedCode == phoneCode.conPhoneCode) {
	      return "selected";
	    } else {
	      return "";
	    }
	  }
	
	  function isDuplicateCadLocationName(e) {
	    //Get the corresponding form element, fetch the obj-id and compare 
	    //if the object at this facility array is same as the value entered 
	    var currentForm = $(this).closest('form');
	    var currentIndex = currentForm.data("obj-id");
	    var currentCadLocationName = $(this).closest('input').val();
	    var isDuplicateCheckRequired = true;
	    //If Index is undefined its the master form do the check, else value did not change 
	    if (_underscore2.default.isUndefined(currentIndex)) {
	      isDuplicateCheckRequired = true;
	    } else if (currentCadLocationName === facilityArray[currentIndex].cadLocationName) {
	      isDuplicateCheckRequired = false;
	    }
	    if (isDuplicateCheckRequired) {
	      var searchFacilitiesOnPage = (0, _underscore2.default)(facilityArray).findWhere({ cadLocationName: currentCadLocationName });
	      //Not Found on the Page, Check on Server if the facility name exists 
	      if (_underscore2.default.isUndefined(searchFacilitiesOnPage)) {
	        $.ajax({
	          async: false,
	          data: {
	            cadLocationName: currentCadLocationName
	          },
	          url: validateCadLocationNameUrl,
	          dataType: "JSON",
	          type: 'POST',
	          success: function success(data) {
	            if (data.response == true) {
	              currentForm.find('.dup-facName').show();
	            } else {
	              currentForm.find('.dup-facName').hide();
	            }
	          }
	        });
	      } else {
	        currentForm.find('.dup-facName').show();
	      }
	    } else {
	      currentForm.find('.dup-facName').hide();
	    }
	  }
	
	  function isDuplicateCadAddressId(e) {
	    var currentForm = $(this).closest('form');
	    var currentIndex = currentForm.data("obj-id");
	    var currentAddressId = $(this).closest('input').val();
	    var isDuplicateCheckRequired = true;
	    //If Index is undefined its the master form do the check, else value did not change 
	    if (_underscore2.default.isUndefined(currentIndex)) {
	      isDuplicateCheckRequired = true;
	    } else if (currentAddressId === facilityArray[currentIndex].cadAddressId) {
	      isDuplicateCheckRequired = false;
	    }
	    if (isDuplicateCheckRequired && !_underscore2.default.isEmpty(currentAddressId)) {
	      var searchAddressIdOnPage = (0, _underscore2.default)(facilityArray).findWhere({ cadAddressId: currentAddressId });
	      //Not Found on the Page, Check on Server if the facility name exists 
	      if (_underscore2.default.isUndefined(searchAddressIdOnPage)) {
	        $.ajax({
	          async: false,
	          data: {
	            cadAddressId: currentAddressId
	          },
	          url: validateCadAddressIdUrl,
	          dataType: "JSON",
	          type: 'POST',
	          success: function success(data) {
	            if (data.response == true) {
	              currentForm.find('.dup-facId').show();
	            } else {
	              currentForm.find('.dup-facId').hide();
	            }
	          }
	        });
	      } else {
	        currentForm.find('.dup-facId').show();
	      }
	    } else {
	      currentForm.find('.dup-facId').hide();
	    }
	  }
	
	  function setCarrierOrgsForEdit(organizations, affiliatedCarrierOrg, cmrCarrier) {
	    var searchCarrierByScacHtml = $((0, _render2.default)(searchCarrierByScacWrapperTemplate, {
	
	      carName: (0, _util.isNullOrUndefined)(organizations) ? "" : (0, _util.isNullOrUndefined)(organizations.orgName) ? "" : organizations.orgName,
	      carScac: (0, _util.isNullOrUndefined)(cmrCarrier) ? "" : (0, _util.isNullOrUndefined)(cmrCarrier.carScac) ? "" : cmrCarrier.carScac,
	      carGln: (0, _util.isNullOrUndefined)(cmrCarrier) ? "" : (0, _util.isNullOrUndefined)(cmrCarrier.carGln) ? "" : cmrCarrier.carGln,
	      carContactName: (0, _util.isNullOrUndefined)(organizations) ? "" : (0, _util.isNullOrUndefined)(cmrCarrier.carContactName) ? "" : cmrCarrier.carContactName,
	      carPhoneCountryCode: (0, _util.isNullOrUndefined)(cmrCarrier) ? "" : (0, _util.isNullOrUndefined)(cmrCarrier.carPhoneCountryCode) ? "" : cmrCarrier.carPhoneCountryCode,
	      carContactPhone: (0, _util.isNullOrUndefined)(cmrCarrier) ? "" : (0, _util.isNullOrUndefined)(cmrCarrier.carContactPhone) ? "" : cmrCarrier.carContactPhone,
	      cadContactEmail: (0, _util.isNullOrUndefined)(organizations) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0]) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0].cadContactEmail) ? "" : organizations.cmrAddress[0].cadContactEmail,
	      cadCountry: (0, _util.isNullOrUndefined)(organizations) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0]) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0].cadCountry) ? "" : organizations.cmrAddress[0].cadCountry,
	      cadAddress1: (0, _util.isNullOrUndefined)(organizations) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0]) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0].cadAddress1) ? "" : organizations.cmrAddress[0].cadAddress1,
	      cadAddress2: (0, _util.isNullOrUndefined)(organizations) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0]) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0].cadAddress2) ? "" : organizations.cmrAddress[0].cadAddress2,
	      cadCity: (0, _util.isNullOrUndefined)(organizations) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0]) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0].cadCity) ? "" : organizations.cmrAddress[0].cadCity,
	      cadState: (0, _util.isNullOrUndefined)(organizations) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0]) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0].cadState) ? "" : organizations.cmrAddress[0].cadState,
	      cadZipcode: (0, _util.isNullOrUndefined)(organizations) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0]) ? "" : (0, _util.isNullOrUndefined)(organizations.cmrAddress[0].cadZipcode) ? "" : organizations.cmrAddress[0].cadZipcode,
	      countries: getRenderedCountriesforCarr(countries),
	      phoneCodes: getRenderedPhoneCodes(phoneCodes)
	
	    }));
	    (0, _select2able.instantiateSelect2)(searchCarrierByScacHtml.find('.select2-select'));
	    var phoneCodeIdSelected = "";
	    if (cmrCarrier != null) {
	      phoneCodeIdSelected = cmrCarrier.carPhoneCountryCode;
	    }
	
	    var stateCodeIdSelected = "";
	    if (organizations != null && organizations.cmrAddress[0] != null && organizations.cmrAddress[0].cadState != null) {
	      stateCodeIdSelected = organizations.cmrAddress[0].cadState;
	    }
	    var countryCodeIdSelected = "";
	    if (organizations != null && organizations.cmrAddress[0] != null && organizations.cmrAddress[0].cadCountry != null) {
	      countryCodeIdSelected = organizations.cmrAddress[0].cadCountry;
	    }
	
	    var countryCodeValue = '';
	    $(countries).each(function () {
	      if (this.conId.toString() === countryCodeIdSelected) {
	        countryCodeValue = this.conCode.toString();
	      }
	    });
	    if (countryCodeValue != '') {
	      searchCarrierByScacHtml.find(".carrier-by-scac-country").val(countryCodeValue).prop('selected', true);
	    }
	    searchCarrierByScacHtml.find('.carrier-by-scac-state').val(stateCodeIdSelected).trigger('change');
	    searchCarrierByScacHtml.find(".carrier-phone-code").val(phoneCodeIdSelected).trigger('change');
	    searchCarrierByScacHtml.find(".carrier-by-scac-country").on("change", handleCarCountryChange);
	    var carrierPhone = $('.carrier-phone-number');
	
	    if (phoneCodeIdSelected === "+1") {
	      carrierPhone.addClass("phoneUS");
	      carrierPhone.removeClass("phoneNonUS");
	      carrierPhone.attr("placeholder", "___-____");
	      carrierPhone.addClass("phone-format");
	      carrierPhone.inputmask("(999) 999-9999");
	    } else {
	      carrierPhone.addClass("phoneNonUS");
	      carrierPhone.removeClass("phoneUS");
	      carrierPhone.removeClass("phone-format");
	      carrierPhone.removeAttr('placeholder');
	      carrierPhone.inputmask("");
	
	      var val = carrierPhone.val();
	      if (val) {
	        var v = val.replace(/[^0-9.]/g, "");
	        carrierPhone.val(v);
	      }
	    }
	
	    $('.carrierFormEdit').append(searchCarrierByScacHtml);
	
	    searchCarrierByScacHtml.find('.carrier-by-scac-country').trigger('change');
	    searchCarrierByScacHtml.find("#carrier-section-div :input").prop("disabled", true);
	    searchCarrierByScacHtml.find('.phoneUS').inputmask({ mask: "(999) 999-9999" });
	    newCarrierTeamMemberDetailsHandler();
	  }
	
	  function getCmrCarrierDetails(organizations, affiliatedCarrierOrgs) {
	    var i;
	    for (i = 0; i < affiliatedCarrierOrgs.length; i++) {
	
	      if (affiliatedCarrierOrgs[i].orgId === organizations.orgId) {
	        return affiliatedCarrierOrgs[i];
	      }
	    }
	  }
	
	  function addTeamMemberForEditCarrierDetails(teammember) {
	    var arrayIndex = "";
	    if (_underscore2.default.isUndefined(teamMemberObj.editIndexId)) {
	      // new flow
	      arrayIndex = teamMemberArray.length;
	      var carrierTeamMemberDetails = setTeamMemberDetailsForEditCarrierHtml(teammember, arrayIndex);
	      teamMemberArray.push(teamMemberObj);
	      if (elsPage.orgType.val() == 'Transportation Broker') {
	        $('#access-to-team-members-broker').append(carrierTeamMemberDetails);
	      } else {
	        $('#access-to-team-members-carrier').append(carrierTeamMemberDetails);
	      }
	    } else {
	      // edit flow
	      arrayIndex = teamMemberObj.editIndexId;
	      var _carrierTeamMemberDetails2 = setTeamMemberDetailsForEditCarrierHtml(teammember, arrayIndex);
	      $('#team-member-edit-' + arrayIndex).html(_carrierTeamMemberDetails2);
	      teamMemberObj = {};
	    }
	  }
	
	  function setTeamMemberDetailsForEditCarrierHtml(teammember, arrayIndex) {
	    teamMemberObj.userName = teammember.userName;
	    teamMemberObj.firstName = teammember.firstName;
	    teamMemberObj.lastName = teammember.lastName;
	    teamMemberObj.status = teammember.status == 0 ? "Active" : "Inactive";
	    teamMemberObj.title = $("#org-title-" + arrayIndex).val();
	    teamMemberObj.email = teammember.emailAddress;
	    teamMemberObj.phoneCode = teammember.phoneCode;
	    teamMemberObj.phone = (0, _general.formatPhone)(teammember.phoneNumber);
	    teamMemberObj.activateUser = teammember.status == 0 ? "q-display-none" : "";
	    teamMemberObj.inactivateUser = teammember.status == 0 ? "" : "q-display-none";
	
	    var carrierTeamMemberDetails = $((0, _render2.default)(__webpack_require__(286), {
	      username: teamMemberObj.userName,
	      title: teamMemberObj.title,
	      email: teamMemberObj.email,
	      phoneCode: teamMemberObj.phoneCode,
	      phone: teamMemberObj.phone,
	      firstname: teamMemberObj.firstName,
	      lastname: teamMemberObj.lastName,
	      status: teamMemberObj.status,
	      activateUser: teamMemberObj.activateUser,
	      inactivateUser: teamMemberObj.inactivateUser,
	      userid: teammember.userId,
	      arrayIndex: arrayIndex
	    }));
	    return carrierTeamMemberDetails;
	  }
	
	  //duplicate address check
	  function validateDuplicateAddress() {
	    var isValid = true;
	    var carrierContactAddress1 = "";
	    var carrierContactAddress2 = "";
	    var carrierContactCity = "";
	    var carrierContactState = "";
	    carrierContactAddress1 = elsPage.carrierSection.find('[name=new-carrier-contact-address1]').val();
	    carrierContactAddress2 = elsPage.carrierSection.find('[name=new-carrier-contact-address2]').val();
	    carrierContactCity = elsPage.carrierSection.find('[name=new-carrier-contact-city]').val();
	    carrierContactState = elsPage.carrierSection.find('[name=new-carrier-contact-state]').val();
	
	    if (carrierContactAddress1 != null && carrierContactCity != null && carrierContactState != null) {
	      $.ajax({
	        async: false,
	        data: {
	          carrierContactAddress1: carrierContactAddress1,
	          carrierContactAddress2: carrierContactAddress2,
	          carrierContactCity: carrierContactCity,
	          carrierContactState: carrierContactState
	        },
	        url: checkDuplicateAddressUrl,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(response) {
	          if (response == true) {
	            isAddressDuplicate = true;
	            $(".dup-address").css("display", "");
	            isValid = false;
	          } else {
	            isAddressDuplicate = false;
	          }
	        }
	      });
	    }
	    if (isValid) $(".dup-address").css("display", "none");else $(".dup-address").css("display", "");
	    return isValid;
	  }
	
	  function editCarrierAndTeamMember() {
	    if (editForm && organizations.orgType == "Carrier") {
	      $('.master-form-section').hide();
	      elsPage.addFacilitySection.hide();
	      elsPage.nextAddfacilityBtn.hide();
	      elsPage.selectOrgPopupBtn.hide();
	      elsPage.facilityNwSection.hide();
	      elsPage.carrierSection.hide();
	      var affiliatedCarrierOrg = getCmrCarrierDetails(organizations, affiliatedCarrierOrgs);
	      setCarrierOrgsForEdit(organizations, affiliatedCarrierOrg, cmrCarrier);
	      if ($.isEmptyObject(teamMemberDetailsForEdit)) {
	        var i;
	        for (i = 0; i < teamMemberDetailsForEdit.length; i++) {
	
	          addTeamMemberForEditCarrierDetails(teamMemberDetailsForEdit[0]);
	        }
	      }
	      setTeamMembersForEdit("carrier");
	      elsPage.saveVendorOrgAddressBtn.removeAttr('disabled');
	    }
	  }
	  init();
	}

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _orgInfoDetails = __webpack_require__(183);
	
	var _orgInfoDetails2 = _interopRequireDefault(_orgInfoDetails);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _index = __webpack_require__(86);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(10);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _filtersutil = __webpack_require__(16);
	
	var _util = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	
	var targetSelector = "#broker-org-details-page";
	
	
	(0, _run2.default)(targetSelector, function () {
	    var orgDetailsTemplate = __webpack_require__(183);
	    var affiliatedCarriersDetailsTemplate = __webpack_require__(1207);
	    var noAffiliatedCarrierTemplate = __webpack_require__(1210);
	    var teamMembersDetailsTemplate = __webpack_require__(286);
	    var noTeamMembersTemplate = __webpack_require__(1209);
	    var historyDetails = __webpack_require__(1208);
	    var organizationDetails = $(targetSelector).data("organization-details");
	    var carrierDetails = $(targetSelector).data("carrier-details");
	    var teamMembersDetails = $(targetSelector).data("teammember-details");
	    var backToList = $(targetSelector).data("back-to-list");
	    var brokerOrgEditUrl = $(targetSelector).data("broker-org-edit-url");
	    var orgId = $(targetSelector).data("org-id");
	    var carrierOrgUrl = $(targetSelector).data('carrier-org-url');
	
	    var datTimeFormat = "MM/DD/YYYY hh:mm A";
	
	    var elementsMap = {
	        activestatuspill: ".active-status-pill",
	        inactivestatuspill: ".inactive-status-pill",
	        activateorgbtn: ".activate-org-btn",
	        deactivateorgbtn: ".deactivate-org-btn",
	        activateteammemberbtn: ".activate-org-team-member-btn",
	        deactivateteammemberbtn: ".deactivate-org-team-member-btn",
	        carrierdetailsmainarea: "#carrier-details-main-area",
	        carrierdetailspagingarea: "#carrier-details-paging-area"
	
	    };
	
	    var els = {};
	
	    var deactivateOrgURL = $(targetSelector).data("deactivate-org-url");
	    var activateOrg = $(targetSelector).data("activate-org-msg");
	    var deactivateOrg = $(targetSelector).data("deactivate-org-msg");
	    var activateDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
	        activateMsg: $(targetSelector).data("activate-org-text")
	    });
	
	    var deactivateDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
	        deactivateMsg: $(targetSelector).data("deactivate-org-text")
	    });
	
	    var deactivateTeamMemberURL = $(targetSelector).data("deactivate-teammember-url");
	    var activateTeamMember = $(targetSelector).data("activate-teammember-msg");
	    var deactivateTeamMember = $(targetSelector).data("deactivate-teammember-msg");
	    var deactivateBtnTxt = $(targetSelector).data("deactivate-teammember-btn-text");
	    var activateBtnTxt = $(targetSelector).data("activate-teammember-btn-text");
	
	    var activateTeamMemberDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-activateTeamMemberMsg %}</div>', {
	        activateTeamMemberMsg: $(targetSelector).data("activate-teammember-text")
	    });
	
	    var deactivateTeamMemberDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-deactivateTeamMemberMsg %}</div>', {
	        deactivateTeamMemberMsg: $(targetSelector).data("deactivate-teammember-text")
	    });
	
	    var pageRefreshUrl = $(targetSelector).data("page-refresh-url");
	    var loadMoreAffliatedCarriersUrl = $(targetSelector).data("loadmore-afflidated-carriers-url");
	
	    var mainEl = $((0, _render2.default)(__webpack_require__(183), {
	        organizationDetails: organizationDetails,
	        orgCreateDateTime: (0, _moment2.default)(organizationDetails.orgCreatedTime).format(datTimeFormat) + " ET",
	        orgModifiedDateTime: (0, _moment2.default)(organizationDetails.orgModifiedTime).format(datTimeFormat) + " ET",
	        orgFormattedPhone: (0, _general.formatPhone)(organizationDetails.cmrAddress[0].cadContactCountryPhoneCode + organizationDetails.cmrAddress[0].cadContactPhone),
	        teamMembers: getTeamMembers(),
	        history: historyDetails,
	        orgEditUrl: brokerOrgEditUrl
	    }));
	    $(targetSelector).append(mainEl);
	
	    function init() {
	        setElements();
	        setDefaults();
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	        els.activateorgbtn.on('click', activateOrganization);
	        els.deactivateorgbtn.on('click', deActivateOrganization);
	        els.activateteammemberbtn.on('click', activateTeamMembr);
	        els.deactivateteammemberbtn.on('click', deActivateTeamMember);
	    }
	
	    function setDefaults() {
	        if (organizationDetails.orgActive) {
	            els.activestatuspill.show();
	            els.inactivestatuspill.hide();
	            els.deactivateorgbtn.show();
	            els.activateorgbtn.hide();
	        } else {
	            els.activestatuspill.hide();
	            els.inactivestatuspill.show();
	            els.activateorgbtn.show();
	            els.deactivateorgbtn.hide();
	
	            //disable all team members if organization is inactive
	            els.activateteammemberbtn.attr('disabled', 'disabled');
	        }
	    }
	
	    function getTeamMembers() {
	        if (teamMembersDetails.length > 0) {
	
	            var teamMembersArray = teamMembersDetails.map(function (teammember) {
	                return (0, _render2.default)(teamMembersDetailsTemplate, {
	                    firstname: teammember.firstName,
	                    lastname: teammember.lastName,
	                    status: teammember.status == 0 ? "Active" : "Inactive",
	                    email: teammember.emailAddress,
	                    username: teammember.userName,
	                    phone: (0, _general.formatPhone)(teammember.phoneCode + teammember.phoneNumber),
	                    userid: teammember.userId,
	                    activateUser: teammember.status == 0 ? "q-display-none" : "",
	                    inactivateUser: teammember.status == 0 ? "" : "q-display-none"
	                });
	            });
	
	            return teamMembersArray.join("");
	        } else {
	            return noTeamMembersTemplate;
	        }
	    }
	
	    function activateOrganization(e) {
	        e.preventDefault();
	        var activateOrgModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: activateOrg,
	            confirmModalBody: activateDiv,
	            confirmModalBtnText: activateOrg,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                activateOrgModal.showLoadingModal();
	                activateOrg({ url: deactivateOrgURL, success: activateSuccess, error: activateFailure });
	                function activateOrg(_ref) {
	                    var url = _ref.url,
	                        success = _ref.success,
	                        error = _ref.error;
	
	                    $.ajax({
	                        data: {
	                            organizationId: orgId,
	                            orgType: organizationDetails.orgType,
	                            orgRetailerId: organizationDetails.orgRetailerId
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function activateSuccess() {
	                    activateOrgModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function activateFailure() {
	                    activateOrgModal.showFailureModal();
	                }
	            }
	        });
	        activateOrgModal.init();
	        activateOrgModal.showConfirmModal();
	    }
	
	    function deActivateOrganization(e) {
	        e.preventDefault();
	        var deactivateOrgModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: deactivateOrg,
	            confirmModalBody: deactivateDiv,
	            confirmModalBtnText: deactivateOrg,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                deactivateOrgModal.showLoadingModal();
	                deactivateOrg({ url: deactivateOrgURL, success: deactivateSuccess, error: deactivateFailure });
	                function deactivateOrg(_ref2) {
	                    var url = _ref2.url,
	                        success = _ref2.success,
	                        error = _ref2.error;
	
	                    $.ajax({
	                        data: {
	                            organizationId: orgId,
	                            orgType: organizationDetails.orgType,
	                            orgRetailerId: organizationDetails.orgRetailerId
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function deactivateSuccess() {
	                    deactivateOrgModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function deactivateFailure() {
	                    deactivateOrgModal.showFailureModal();
	                }
	            }
	        });
	        deactivateOrgModal.init();
	        deactivateOrgModal.showConfirmModal();
	    }
	
	    function deActivateTeamMember(e) {
	        e.preventDefault();
	        var userId = $(this).closest('.deactivate-org-team-member-btn').data('index-id');
	
	        var deactivateTeamMemberModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: deactivateTeamMember,
	            confirmModalBody: deactivateTeamMemberDiv,
	            confirmModalBtnText: deactivateBtnTxt,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                deactivateTeamMemberModal.showLoadingModal();
	                deactivateTeamMember({ url: deactivateTeamMemberURL, success: deactivateSuccess, error: deactivateFailure });
	                function deactivateTeamMember(_ref3) {
	                    var url = _ref3.url,
	                        success = _ref3.success,
	                        error = _ref3.error;
	
	                    $.ajax({
	                        data: {
	                            userId: userId,
	                            status: "false"
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function deactivateSuccess() {
	                    deactivateTeamMemberModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function deactivateFailure() {
	                    deactivateTeamMemberModal.showFailureModal();
	                }
	            }
	        });
	        deactivateTeamMemberModal.init();
	        deactivateTeamMemberModal.showConfirmModal();
	    }
	
	    function activateTeamMembr(e) {
	        e.preventDefault();
	        var userId = $(this).closest('.activate-org-team-member-btn').data('index-id');
	        var activateTeamMemberModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: activateTeamMember,
	            confirmModalBody: activateTeamMemberDiv,
	            confirmModalBtnText: activateBtnTxt,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                activateTeamMemberModal.showLoadingModal();
	                activateTeamMember({ url: deactivateTeamMemberURL, success: activateSuccess, error: activateFailure });
	                function activateTeamMember(_ref4) {
	                    var url = _ref4.url,
	                        success = _ref4.success,
	                        error = _ref4.error;
	
	                    $.ajax({
	                        data: {
	                            userId: userId,
	                            status: "true"
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function activateSuccess() {
	                    activateTeamMemberModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function activateFailure() {
	                    activateTeamMemberModal.showFailureModal();
	                }
	            }
	        });
	        activateTeamMemberModal.init();
	        activateTeamMemberModal.showConfirmModal();
	    }
	
	    init();
	
	    var carrierDetailsSection = new _index2.default({
	        dataContainer: $('.carrier-details-main-area'),
	        pagingContainer: $('.carrier-details-paging-area'),
	        data: carrierDetails,
	        showData: function showData(carrier) {
	            return (0, _render2.default)(affiliatedCarriersDetailsTemplate, {
	                carrierName: !(0, _util.isNullOrUndefined)(carrier.orgName) & carrier.orgName != "null" ? carrier.orgName : "",
	                carrierContactName: !(0, _util.isNullOrUndefined)(carrier.carrierContactName) & carrier.carrierContactName != "null" ? carrier.carrierContactName : "",
	                carrierEmail: !(0, _util.isNullOrUndefined)(carrier.carrierContactEmail) & carrier.carrierContactEmail != "null" ? carrier.carrierContactEmail : "",
	                carrierPhone: !(0, _util.isNullOrUndefined)(carrier.carrierPhone) & carrier.carrierPhone != "null" ? (0, _general.formatPhone)(carrier.carrierPhone) : "",
	                carrierScac: !(0, _util.isNullOrUndefined)(carrier.carrierScac) & carrier.carrierScac != "null" ? carrier.carrierScac : "",
	                carrierGln: !(0, _util.isNullOrUndefined)(carrier.carrierGln) & carrier.carrierGln != "null" ? carrier.carrierGln : "",
	                carrierStatus: !(0, _util.isNullOrUndefined)(carrier.orgActive) & carrier.orgActive != "null" ? carrier.orgActive == 1 ? "Active" : "Inactive" : "",
	                carrierContactEmail: !(0, _util.isNullOrUndefined)(carrier.carrierContactEmail) & carrier.carrierContactEmail != "null" ? carrier.carrierContactEmail : "",
	                carrierAddress1: !(0, _util.isNullOrUndefined)(carrier.carrierAddress1) & carrier.carrierAddress1 != "null" ? carrier.carrierAddress1 : "",
	                carrierAddress2: !(0, _util.isNullOrUndefined)(carrier.carrierAddress2) & carrier.carrierAddress2 != "null" ? carrier.carrierAddress2 : "",
	                carrierCity: !(0, _util.isNullOrUndefined)(carrier.carrierCity) & carrier.carrierCity != "null" ? carrier.carrierCity : "",
	                carrierState: !(0, _util.isNullOrUndefined)(carrier.carrierState) & carrier.carrierState != "null" ? carrier.carrierState : "",
	                carrierZipcode: !(0, _util.isNullOrUndefined)(carrier.carrierZipcode) & carrier.carrierZipcode != "null" ? carrier.carrierZipcode : "",
	                carrierCountry: !(0, _util.isNullOrUndefined)(carrier.carrierCountry) & carrier.carrierCountry != "null" ? carrier.carrierCountry : "",
	                carrierOrgId: !(0, _util.isNullOrUndefined)(carrier.orgId) & carrier.orgId != "null" ? carrier.orgId : ""
	
	            });
	        },
	
	        onFetch: function onFetch(page, pageSize) {
	            carrierDetailsSection.showLoadingOverlay();
	            setTimeout(function () {
	                (0, _filtersutil.doAjax)({ url: loadMoreAffliatedCarriersUrl, success: loadMoreAffliatedCarriers, error: errorFun, data: prepareDataToSendController(orgId, page, pageSize) });
	            }, _index4.default);
	        }
	
	    });
	
	    function loadMoreAffliatedCarriers(data) {
	        var affliatedCarriers = data.content;
	        carrierDetailsSection.setData(affliatedCarriers);
	        carrierDetailsSection.hideLoadingOverlay();
	    }
	
	    function errorFun(data) {
	        carrierDetailsSection.hideLoadingOverlay();
	    }
	
	    if (carrierDetails.totalElements > 0) {
	        carrierDetailsSection.init();
	    } else {
	        $('.carrier-details-main-area').append((0, _render2.default)(noAffiliatedCarrierTemplate));
	    }
	
	    function prepareDataToSendController(orgId, page, pageSize) {
	        var data = {
	            page: page,
	            pageSize: pageSize,
	            orgId: orgId
	        };
	        return data;
	    }
	
	    $("#backToListBtn").on("click", function () {
	        window.open(backToList, "_self");
	    });
	
	    $('.carrier-org-details-btn').on("click", function (e) {
	        e.preventDefault();
	        var carrierOrgId = $(this).closest('.carrier-org-details-btn').data('index-id');
	        window.open(carrierOrgUrl + '&orgId=' + carrierOrgId, '_blank');
	    });
	});

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	
	var targetSelector = "#carrier-org-details-page";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	
	    var deactivateOrgURL = mainEl.data("deactivate-org-url");
	    var orgId = mainEl.data("org-id");
	    var organizationDetails = mainEl.data("organization-details");
	    var activateOrg = mainEl.data("activate-org-msg");
	    var deactivateOrg = mainEl.data("deactivate-org-msg");
	    var activateOrgBtn = mainEl.data("activate-carrier-btn-txt");
	    var deactivateOrgBtn = mainEl.data("deactivate-carrier-btn-txt");
	    var editOrgUrl = mainEl.data("edit-url");
	
	    var activateDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
	        activateMsg: mainEl.data("activate-org-text")
	    });
	    var deactivateDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
	        deactivateMsg: mainEl.data("deactivate-org-text")
	    });
	
	    var deactivateTeamMemberURL = mainEl.data("deactivate-teammember-url");
	    var activateTeamMember = mainEl.data("activate-teammember-msg");
	    var deactivateTeamMember = mainEl.data("deactivate-teammember-msg");
	    var deactivateBtnTxt = mainEl.data("deactivate-teammember-btn-text");
	    var activateBtnTxt = mainEl.data("activate-teammember-btn-text");
	
	    var activateTeamMemberDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-activateTeamMemberMsg %}</div>', {
	        activateTeamMemberMsg: mainEl.data("activate-teammember-text")
	    });
	
	    var deactivateTeamMemberDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-deactivateTeamMemberMsg %}</div>', {
	        deactivateTeamMemberMsg: mainEl.data("deactivate-teammember-text")
	    });
	
	    var pageRefreshUrl = mainEl.data("page-refresh-url");
	
	    $('body').on('click', '#carrier-org-edit-url', function (e) {
	        e.preventDefault();
	        if (shallAllowClick(this)) {
	            editOrganizationCall(orgId);
	        }
	    });
	
	    $('body').on('click', '#edit-carrier-org-details', function (e) {
	        e.preventDefault();
	        if (shallAllowClick(this)) {
	            editOrganizationCall(orgId);
	        }
	    });
	
	    $('body').on('click', '#edit-carrier-org-contact', function (e) {
	        e.preventDefault();
	        if (shallAllowClick(this)) {
	            editOrganizationCall(orgId);
	        }
	    });
	
	    $('body').on('click', '#edit-carrier-team-details', function (e) {
	        e.preventDefault();
	        if (shallAllowClick(this)) {
	            editOrganizationCall(orgId);
	        }
	    });
	
	    function editOrganizationCall(orgId) {
	        location.href = editOrgUrl + "&orgId=" + orgId;
	    }
	    function shallAllowClick(currentObj) {
	        return !$(currentObj).hasClass("disabled");
	    }
	    $('#deactivate-org-btn-carrier-details').on("click", function (e) {
	        var deactivateOrgModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: deactivateOrg,
	            confirmModalBody: deactivateDiv,
	            confirmModalBtnText: deactivateOrgBtn,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                deactivateOrgModal.showLoadingModal();
	                deactivateOrg({ url: deactivateOrgURL, success: deactivateSuccess, error: deactivateFailure });
	                function deactivateOrg(_ref) {
	                    var url = _ref.url,
	                        success = _ref.success,
	                        error = _ref.error;
	
	                    $.ajax({
	                        data: {
	                            organizationId: orgId,
	                            orgType: organizationDetails.orgType,
	                            orgRetailerId: organizationDetails.orgRetailerId
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function deactivateSuccess() {
	                    deactivateOrgModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function deactivateFailure() {
	                    deactivateOrgModal.showFailureModal();
	                }
	            }
	        });
	        deactivateOrgModal.init();
	        deactivateOrgModal.showConfirmModal();
	    });
	
	    $('#activate-org-btn-carrier-details').on("click", function (e) {
	        e.preventDefault();
	        var activateOrgModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: activateOrg,
	            confirmModalBody: activateDiv,
	            confirmModalBtnText: activateOrgBtn,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                activateOrgModal.showLoadingModal();
	                activateOrg({ url: deactivateOrgURL, success: activateSuccess, error: activateFailure });
	                function activateOrg(_ref2) {
	                    var url = _ref2.url,
	                        success = _ref2.success,
	                        error = _ref2.error;
	
	                    $.ajax({
	                        data: {
	                            organizationId: orgId,
	                            orgType: organizationDetails.orgType,
	                            orgRetailerId: organizationDetails.orgRetailerId
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function activateSuccess() {
	                    activateOrgModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function activateFailure() {
	                    activateOrgModal.showFailureModal();
	                }
	            }
	        });
	        activateOrgModal.init();
	        activateOrgModal.showConfirmModal();
	    });
	
	    $('.deactivate-org-team-member-btn').on("click", function (e) {
	        e.preventDefault();
	        var userId = $(this).data('index-id');
	
	        var deactivateTeamMemberModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: deactivateTeamMember,
	            confirmModalBody: deactivateTeamMemberDiv,
	            confirmModalBtnText: deactivateBtnTxt,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                deactivateTeamMemberModal.showLoadingModal();
	                deactivateTeamMember({ url: deactivateTeamMemberURL, success: deactivateSuccess, error: deactivateFailure });
	                function deactivateTeamMember(_ref3) {
	                    var url = _ref3.url,
	                        success = _ref3.success,
	                        error = _ref3.error;
	
	                    $.ajax({
	                        data: {
	                            userId: userId,
	                            status: "false"
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function deactivateSuccess() {
	                    deactivateTeamMemberModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function deactivateFailure() {
	                    deactivateTeamMemberModal.showFailureModal();
	                }
	            }
	        });
	        deactivateTeamMemberModal.init();
	        deactivateTeamMemberModal.showConfirmModal();
	    });
	
	    $('.activate-org-team-member-btn').on("click", function (e) {
	        e.preventDefault();
	        var userId = $(this).data('index-id');
	        var activateTeamMemberModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: activateTeamMember,
	            confirmModalBody: activateTeamMemberDiv,
	            confirmModalBtnText: activateBtnTxt,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                activateTeamMemberModal.showLoadingModal();
	                activateTeamMember({ url: deactivateTeamMemberURL, success: activateSuccess, error: activateFailure });
	                function activateTeamMember(_ref4) {
	                    var url = _ref4.url,
	                        success = _ref4.success,
	                        error = _ref4.error;
	
	                    $.ajax({
	                        data: {
	                            userId: userId,
	                            status: "true"
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function activateSuccess() {
	                    activateTeamMemberModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function activateFailure() {
	                    activateTeamMemberModal.showFailureModal();
	                }
	            }
	        });
	        activateTeamMemberModal.init();
	        activateTeamMemberModal.showConfirmModal();
	    });
	});

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	
	var targetSelector = "#org-details-page";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	    var deactivateOrgURL = mainEl.data("deactivate-org-url");
	    var orgId = mainEl.data("org-id");
	    var deactivateFacilityURL = mainEl.data("deactivate-facility-url");
	    var pageRefreshUrl = mainEl.data("page-refresh-url");
	
	    var activateOrg = mainEl.data("activate-org-msg");
	    var deactivateOrg = mainEl.data("deactivate-org-msg");
	    var activateDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
	        activateMsg: mainEl.data("activate-org-text")
	    });
	
	    var deactivateDiv = (0, _render2.default)('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
	        deactivateMsg: mainEl.data("deactivate-org-text")
	    });
	
	    $('.deactivate-organization-btn').on("click", function (e) {
	        e.preventDefault();
	        var deactivateOrgModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: deactivateOrg,
	            confirmModalBody: deactivateDiv,
	            confirmModalBtnText: deactivateOrg,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                deactivateOrgModal.showLoadingModal();
	                deactivateOrg({ url: deactivateOrgURL, success: deactivateSuccess, error: deactivateFailure });
	                function deactivateOrg(_ref) {
	                    var url = _ref.url,
	                        success = _ref.success,
	                        error = _ref.error;
	
	                    $.ajax({
	                        data: orgId,
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function deactivateSuccess() {
	                    deactivateOrgModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function deactivateFailure() {
	                    deactivateOrgModal.showFailureModal();
	                }
	            }
	        });
	        deactivateOrgModal.init();
	        deactivateOrgModal.showConfirmModal();
	    });
	    $('.activate-organization-btn').on("click", function (e) {
	        e.preventDefault();
	        var activateOrgModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: activateOrg,
	            confirmModalBody: activateDiv,
	            confirmModalBtnText: activateOrg,
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                activateOrgModal.showLoadingModal();
	                activateOrg({ url: deactivateOrgURL, success: activateSuccess, error: activateFailure });
	                function activateOrg(_ref2) {
	                    var url = _ref2.url,
	                        success = _ref2.success,
	                        error = _ref2.error;
	
	                    $.ajax({
	                        data: orgId,
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function activateSuccess() {
	                    activateOrgModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function activateFailure() {
	                    activateOrgModal.showFailureModal();
	                }
	            }
	        });
	        activateOrgModal.init();
	        activateOrgModal.showConfirmModal();
	    });
	    $('.deactivate-facility-btn').on("click", function (e) {
	        e.preventDefault();
	        //const facId=$(".facilityAction").attr("id");
	        var facId = $(this).data("fac-id");
	        var deactivateFacilityModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: 'Deactivate Facility',
	            confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
	            confirmModalBtnText: 'Deactivate Facility',
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	
	                deactivateFacilityModal.showLoadingModal();
	                deactivateFacility({ url: deactivateFacilityURL, success: deactivateSuccess, error: deactivateFailure });
	                function deactivateFacility(_ref3) {
	                    var url = _ref3.url,
	                        success = _ref3.success,
	                        error = _ref3.error;
	
	                    $.ajax({
	                        data: {
	                            facId: facId
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function deactivateSuccess() {
	                    deactivateFacilityModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function deactivateFailure() {
	                    deactivateFacilityModal.showFailureModal();
	                }
	            }
	        });
	        deactivateFacilityModal.init();
	        deactivateFacilityModal.showConfirmModal();
	    });
	    $('.activate-facility-btn').on("click", function (e) {
	        e.preventDefault();
	        var facId = $(this).data("fac-id");
	        var activateFacilityModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: 'Activate Facility',
	            confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
	            confirmModalBtnText: 'Activate Facility',
	            modalDialogClass: "q-modal-dialog-500",
	            onConfirmClick: function onConfirmClick() {
	                activateFacilityModal.showLoadingModal();
	                activateFacility({ url: deactivateFacilityURL, success: activateSuccess, error: activateFailure });
	                function activateFacility(_ref4) {
	                    var url = _ref4.url,
	                        success = _ref4.success,
	                        error = _ref4.error;
	
	                    $.ajax({
	                        data: {
	                            facId: facId
	                        },
	                        url: url,
	                        dataType: "JSON",
	                        type: 'POST',
	                        success: success,
	                        error: error
	                    });
	                }
	                function activateSuccess() {
	                    activateFacilityModal.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageRefreshUrl;
	                    }, 3000);
	                }
	                function activateFailure() {
	                    activateFacilityModal.showFailureModal();
	                }
	            }
	        });
	        activateFacilityModal.init();
	        activateFacilityModal.showConfirmModal();
	    });
	});

/***/ },
/* 492 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    icon: 'toggle-on',
	    title: 'Activate Selected Organizations',
	    cls: "bulk-activate-organization",
	    disabled: true
	  }, {
	    icon: 'toggle-off',
	    title: 'Deactivate Selected Organizations',
	    cls: "bulk-deactivate-organization",
	    disabled: true
	  }],
	  "actions": [{
	    title: "Edit",
	    cls: "edit-organization",
	    icon: "pencil",
	    disabled: true
	  }, {
	    title: "Activate/Deactivate",
	    cls: "deactivate-organization",
	    icon: "toggle-off",
	    disabled: true
	  }]
	};

/***/ },
/* 493 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var orgLookupFieldDropdown = exports.orgLookupFieldDropdown = [{
	  title: "Organization Name",
	  value: "organizationName"
	}, {
	  title: "Contact",
	  value: "contactName"
	}, {
	  title: "Email",
	  value: "contactEmail"
	}];

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.merge = undefined;
	exports.isPresent = isPresent;
	exports.isBlank = isBlank;
	
	__webpack_require__(487);
	
	__webpack_require__(488);
	
	__webpack_require__(491);
	
	__webpack_require__(489);
	
	__webpack_require__(490);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _deepmerge = __webpack_require__(268);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.merge = _deepmerge2.default;
	function isPresent(val) {
	  return !_underscore2.default.isUndefined(val) && !_underscore2.default.isNull(val) && val !== "";
	}
	
	function isBlank(val) {
	  return _underscore2.default.isUndefined(val) || _underscore2.default.isNull(val) || val === "";
	}

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	var _select2able = __webpack_require__(22);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _jumboNav = __webpack_require__(837);
	
	var _select2MultiSelectResize = __webpack_require__(844);
	
	var _datePicker = __webpack_require__(114);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function () {
	
	  _jquery2.default.fn.select2.amd.require(['select2/selection/search'], function (Search) {
	    var oldRemoveChoice = Search.prototype.searchRemoveChoice;
	
	    Search.prototype.searchRemoveChoice = function () {
	      oldRemoveChoice.apply(this, arguments);
	      this.$search.val('');
	    };
	
	    (0, _select2able.instantiateSelect2)((0, _jquery2.default)('.select2-select'));
	  });
	
	  (0, _instantiateSwitchery.instantiateSwitchery)((0, _jquery2.default)('.js-switchery'));
	
	  (0, _datePicker2.default)((0, _jquery2.default)('.datepicker'));
	
	  (0, _jquery2.default)(document).on("focus", "input", function (e) {
	    // add focus class to parent element of any possible input
	    // to handle wrapper class styling
	    (0, _jquery2.default)(e.target).parent().addClass('focus');
	  });
	
	  (0, _jquery2.default)(document).on("blur", "input", function (e) {
	    (0, _jquery2.default)(e.target).parent().removeClass('focus');
	  });
	
	  //Common Error modal
	  (0, _jquery2.default)(document).ajaxError(function (event, response, settings, thrownError) {
	    if (response.status == 500) {
	      (0, _jquery2.default)('#commerce-error-wrapper').html(response.responseText);
	      (0, _jquery2.default)('#commerce-error-wrapper .modal.commerce-error-modal ').modal("show");
	      (0, _jquery2.default)('#commerce-error-wrapper .modal.commerce-error-modal ').css({ 'z-index': '99999999' });
	      (0, _jquery2.default)(".modal").not(".commerce-error-modal").modal("hide");
	    }
	  });
	
	  (0, _select2able.bindDocSelect2CloseRefocus)();
	
	  (0, _jumboNav.bindTopNavHamburger)((0, _jquery2.default)('.top-nav-burger'));
	
	  (0, _select2MultiSelectResize.triggerSelectResize)();
	  (0, _select2able.bindSelect2OnTypeForDesktop)();
	});

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetSelector = "#amazon-fba-search-pallet";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  searchAmazonPallet(mainEl);
	});
	
	function searchAmazonPallet(mainEl) {
	
	  var elsPage = {};
	
	  var elementsPageMap = {
	    caseId: "#caseId1",
	    palletId: "#palletId1",
	    palletBtn: "#pallet",
	    caseBtn: "#case",
	    shippingTypeBtnGroupEl: ".shipping-type-toggler"
	  };
	
	  function init() {
	    setElements();
	    bindElements();
	  }
	
	  function bindElements() {
	    elsPage.palletBtn.on("click", function () {
	      amazonPallet();
	    });
	
	    elsPage.caseBtn.on("click", function () {
	      amazonCase();
	    });
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, mainEl);
	    elsPage.caseId.hide();
	    elsPage.palletId.show();
	    quickButton();
	  }
	
	  function quickButton() {
	    var shippingTypeBtnGroup = new _QuickBtnGroup2.default(elsPage.shippingTypeBtnGroupEl, {
	      distributeWidth: true
	    });
	    shippingTypeBtnGroup.init();
	  }
	
	  function amazonCase() {
	    elsPage.palletId.show();
	    elsPage.caseId.hide();
	    elsPage.palletId.val("");
	    elsPage.palletBtn.removeClass('active');
	    elsPage.caseBtn.addClass('active');
	  }
	
	  function amazonPallet() {
	    elsPage.palletId.hide();
	    elsPage.caseId.show();
	    elsPage.caseId.val("");
	    elsPage.caseBtn.removeClass('active');
	    elsPage.palletBtn.addClass('active');
	  }
	  init();
	}

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _timePicker = __webpack_require__(144);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _currency = __webpack_require__(66);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapperHTML = __webpack_require__(1213);
	var quoteResponsePage = __webpack_require__(287);
	var quoteHtml = __webpack_require__(287);
	var quoteErrorHtml = __webpack_require__(1215);
	
	var targetSelector = "#amazon-fba-pallet-shipping";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  amazonFbaPalletShipping(mainEl);
	});
	
	function amazonFbaPalletShipping(mainEl) {
	
	  var palletCount = 0;
	  var palletInfo = mainEl.data("pallet-info");
	  var viewQuoteURL = mainEl.data("view-quote-url");
	  var saveQuoteUrl = mainEl.data("save-quote-url");
	  var lowestQuote = null;
	  var cancelProcessUrl = mainEl.data("cancel-process");
	  var cancelBtnUrl = mainEl.data("cancel-btn");
	  var quotes = void 0;
	  var viewQuoteRequest = {};
	  var orderId = mainEl.data("order-id");
	  var pkgNumber = mainEl.data("shipment-id");
	  var palletId = mainEl.data("pallet-id");
	  var pickupStartTimePicker = void 0;
	  var pickupEndTimePicker = void 0;
	
	  var mainHtml = (0, _jquery2.default)((0, _render2.default)(wrapperHTML, {
	    pallets: (0, _render2.default)(" {%= palletID %} ", {
	      palletID: getRenderPallets(palletInfo),
	      quoteResponsePage: quoteResponsePage
	    })
	  }));
	  function getRenderPallets(palletInfo) {
	    var html = __webpack_require__(1214);
	    var resp = "";
	    resp = _underscore2.default.map(palletInfo.pallet, function (pallet) {
	      return (0, _render2.default)(html, {
	        palletId: pallet.orderPalletId,
	        LPNS: getRenderLpns(pallet)
	      });
	    });
	    return resp.join("");
	  }
	  function getRenderLpns(pallet) {
	
	    var html = __webpack_require__(1212);
	    var resp = "";
	    resp = _underscore2.default.map(pallet.LPN, function (LPNS) {
	      return (0, _render2.default)(html, {
	        lpnsName: LPNS.olmLPNNumber,
	        product: getRenderProduct(LPNS)
	      });
	    });
	    return resp.join("");
	  }
	  function getRenderProduct(LPNS) {
	
	    var html = __webpack_require__(1211);
	    var resp = "";
	    resp = _underscore2.default.map(LPNS.lineItems, function (LPNS) {
	      return (0, _render2.default)(html, {
	
	        lineitem: LPNS.olmItmSku,
	        lineitem2: LPNS.olmPackedQty
	      });
	    });
	
	    return resp.join("");
	  }
	
	  var entryEl = (0, _jquery2.default)("<div class='entry-point'></div>");
	  var mainElement = (0, _jquery2.default)(mainHtml);
	
	  var elsPage = {};
	
	  var elementsPageMap = {
	    loading: "#loading",
	    viewQuote: "#viewQuote",
	    pickupTable: "#pickupTable",
	    nullResponse: "#nullResponse",
	    copyBtn: "#copyBtn",
	    quoteResponse: "#quoteResponse",
	    submitQuote: "#submitQuote",
	    pickupDate: "#pickupDate",
	    cancelBtn: "#cancelBtn",
	    cancelProcess: "#cancelProcess",
	    stackable: ".stackable",
	    pickUpDat: ".pickup-date",
	    pickUpTimeStart: ".pickup-time-start",
	    pickUpTimeEnd: ".pickup-time-end",
	    formId: "#master-form",
	    lngth: ".length",
	    wdth: ".width",
	    heght: ".height",
	    weght: ".weight",
	    fromHours: "#fromhours",
	    fromMinutes: "#fromminutes",
	    fromSeconds: "#fromseconds",
	    toHours: "#tohours",
	    toMinutes: "#tominutes",
	    toSeconds: "#toseconds",
	    parentDivPanel: ".parent-div-panel",
	    pickupTimeRangeMessage: ".pickup-time-range-error-message"
	  };
	
	  function init() {
	    setElements();
	    bindElements();
	  }
	
	  function bindElements() {
	    elsPage.viewQuote.on("click", function (e) {
	      e.preventDefault();
	      viewQuoteFlow();
	    });
	    elsPage.copyBtn.on("click", function () {
	      copyBtnFlow();
	    });
	    elsPage.cancelBtn.on("click", function () {
	      cancelBtnFlow();
	    });
	    elsPage.cancelProcess.on("click", function () {
	      cancelProcessFlow();
	    });
	    elsPage.submitQuote.on("click", function () {
	      submitQuoteFlow();
	    });
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, entryEl);
	    timePickerComp();
	  };
	
	  mainEl.html(entryEl);
	  entryEl.append(mainElement);
	  setElements();
	
	  function timePickerComp() {
	    var date = new Date();
	    var singleDatepickerEl = elsPage.pickUpDat;
	    singleDatepickerEl.datepicker({
	      startDate: date,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	    pickupStartTimePicker = (0, _timePicker2.default)(elsPage.pickUpTimeStart);
	    pickupStartTimePicker.setTimeFromMilitary("09:00");
	    pickupEndTimePicker = (0, _timePicker2.default)(elsPage.pickUpTimeEnd);
	    pickupEndTimePicker.setTimeFromMilitary("18:00");
	    (0, _selectorHelpers.handleDisplayForV2)(elsPage.pickupTimeRangeMessage, !isPickupTimeRangeValid());
	  }
	
	  elsPage.nullResponse.hide();
	  elsPage.loading.hide();
	
	  function viewQuoteFlow() {
	    var isValid = validateForm(elsPage.formId);
	    if (isValid) {
	      elsPage.viewQuote.hide();
	      elsPage.loading.show();
	      var amazon = validateFormDetails();
	      _jquery2.default.ajax({
	        url: viewQuoteURL,
	        type: "POST",
	        dataType: "json",
	        data: {
	          amazon: "{ \"carrierQuote\":" + JSON.stringify(amazon) + "}"
	        },
	        success: function success(data) {
	          quotes = data;
	          elsPage.loading.hide();
	          elsPage.viewQuote.show();
	
	          if (data.quotes.length > 0) {
	            var cost = data.quotes[0].cost;
	            var transit = parseInt(data.quotes[0].transitTime);
	            elsPage.quoteResponse.html((0, _render2.default)(quoteHtml, {
	              transit: transit,
	              quote: (0, _currency.toCurrency)(cost),
	              pickUpDate: data.pickupDate
	            }));
	          } else {
	            elsPage.quoteResponse.html((0, _render2.default)(quoteErrorHtml));
	          }
	        },
	        error: function error(data) {
	          elsPage.loading.hide();
	          elsPage.viewQuote.show();
	          elsPage.quoteResponse.html((0, _render2.default)(quoteErrorHtml));
	        }
	
	      });
	    }
	  }
	
	  function validateForm(formElement) {
	    (0, _selectorHelpers.handleDisplayForV2)(elsPage.pickupTimeRangeMessage, !isPickupTimeRangeValid());
	    var validator = void 0,
	        validationOpts = void 0;
	    validationOpts = {
	      debug: true,
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          (0, _jquery2.default)(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    };
	    validator = formElement.validate(validationOpts);
	    validator.settings.ignore = ":disabled,:hidden";
	    if (formElement.valid() && isPickupTimeRangeValid()) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  function isPickupTimeRangeValid() {
	    return (0, _general.convertMilitaryToInt)(pickupStartTimePicker.getMilitaryTime()) < (0, _general.convertMilitaryToInt)(pickupEndTimePicker.getMilitaryTime());
	  }
	
	  function validateFormDetails() {
	    var dimensionArray = [];
	    var amazon = [];
	    var requestObj = {};
	    var fromTime = pickupStartTimePicker.getMilitaryTime();
	    var toTime = pickupEndTimePicker.getMilitaryTime();
	    for (var i = 0; i < palletInfo.pallet.length; i++) {
	      var dimensionObj = {};
	      dimensionObj.length = elsPage.lngth.eq(i).val();
	      dimensionObj.width = elsPage.wdth.eq(i).val();
	      dimensionObj.height = elsPage.heght.eq(i).val();
	      dimensionObj.weight = elsPage.weght.eq(i).val();
	      dimensionObj.stackable = elsPage.stackable.eq(i).val();
	      dimensionArray.push(dimensionObj);
	    }
	    requestObj.pickupDate = elsPage.pickupDate.val();
	    requestObj.pickupTimeFrom = fromTime;
	    requestObj.pickupTimeTo = toTime;
	    requestObj.packageDetails = dimensionArray;
	    amazon.push(requestObj);
	
	    return amazon;
	  }
	
	  //For showing the first button & hiding the rest
	  elsPage.parentDivPanel.hide();
	  // mainEl.find(elsPage.parentDivPanel).eq(0).show();
	  elsPage.parentDivPanel.eq(0).show();
	
	  //Apply Weight and Dimesions Button
	  function copyBtnFlow() {
	    var dimensionObj = {};
	    dimensionObj.length = elsPage.lngth.val();
	    dimensionObj.width = elsPage.wdth.val();
	    dimensionObj.height = elsPage.heght.val();
	    dimensionObj.weight = elsPage.weght.val();
	    dimensionObj.stackable = elsPage.stackable;
	    copyData(dimensionObj);
	  }
	
	  function copyData(dimensionObj) {
	    for (var i = 1; i < palletInfo.pallet.length; i++) {
	      elsPage.lngth.eq(i).val(dimensionObj.length);
	      elsPage.heght.eq(i).val(dimensionObj.height);
	      elsPage.wdth.eq(i).val(dimensionObj.width);
	      elsPage.weght.eq(i).val(dimensionObj.weight);
	      elsPage.stackable.eq(i).prop("checked", dimensionObj.stackable.prop("checked"));
	    }
	  }
	
	  function cancelBtnFlow() {
	    window.open(cancelBtnUrl.concat('&shipmentNumber=').concat(pkgNumber).concat("&shippingType=LTL"), "_self");
	  }
	
	  function submitQuoteFlow() {
	    var url = saveQuoteUrl.concat("&quotes=").concat(JSON.stringify(quotes)).concat("&orderId=").concat(orderId).concat("&pkgNumber=").concat(pkgNumber).concat("&palletId=" + palletId);
	    var labelWindow = window.open(url, "_self");
	  }
	
	  function cancelProcessFlow() {
	    window.open(cancelProcessUrl, "_self");
	  }
	
	  init();
	}

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(277);
	
	(0, _run2.default)("#amazon-fba-carton-info", function () {
	  main("#amazon-fba-carton-info");
	});
	
	function main(targetSelector) {
	  var mainEl = (0, _jquery2.default)(targetSelector);
	  var approveOverrideBtn = mainEl.find('.approve-override-btn');
	  var modal = (0, _jquery2.default)('#supervisor-approval-override-modal');
	  var override = false;
	  var errorFlow = new _SubmitModalFlow2.default();
	  errorFlow.init();
	  modal.modal({
	    show: false
	  });
	
	  (0, _jquery2.default)('#overide-success-msg').hide();
	
	  if ((0, _jquery2.default)('#send-carton-mismatch-msg').length > 0) {
	    (0, _jquery2.default)('#no-problems-msg-section').hide();
	    (0, _jquery2.default)('#send-carton-to-amazon').hide();
	    (0, _jquery2.default)('#qty-all-match-badge').hide();
	  }
	
	  approveOverrideBtn.on('click', function (e) {
	    e.preventDefault();
	    showSupervisorModal();
	  });
	
	  function showSupervisorModal() {
	    modal.modal("show");
	  }
	
	  (0, _jquery2.default)('#send-carton-to-amazon a').click(function (e) {
	    e.preventDefault();
	    (0, _jquery2.default)('#loading-screen-mask').removeClass('hide');
	
	    if (!(0, _jquery2.default)("#resend-carton-to-amazon").hasClass("hide")) {
	      (0, _jquery2.default)("#resend-carton-to-amazon").addClass('hide');
	    }
	
	    (0, _jquery2.default)(this).parent().addClass('hide');
	    _jquery2.default.ajax({
	      url: mainEl.data("send-carton-url"),
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        palletNumber: mainEl.data("pallet-number"),
	        orderId: mainEl.data("order-id"),
	        shipmentId: mainEl.data("shipment-id"),
	        doNumber: mainEl.data("do-number"),
	        feedSubmissionId: (0, _jquery2.default)('#feedSubmissionId').val(),
	        override: override
	      },
	      success: function success(response) {
	        (0, _jquery2.default)('#loading-screen-mask').addClass('hide');
	        (0, _jquery2.default)('#feedSubmissionId').val(response.feedSubmissionId);
	        if (response.status == 'success') {
	          window.location = mainEl.data("scan-lpn-url");
	        } else if (response.status == 'ERROR') {
	          (0, _jquery2.default)('#no-problems-msg-section').hide();
	          (0, _jquery2.default)('#connection-timeout-message').removeClass('hide');
	          (0, _jquery2.default)("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
	          (0, _jquery2.default)('#resend-carton-to-amazon').removeClass('hide');
	        } else {
	          (0, _jquery2.default)('#no-problems-msg-section').hide();
	          (0, _jquery2.default)('#send-carton-error-response').removeClass('hide');
	          (0, _jquery2.default)('#connection-timeout-message').addClass('hide');
	          (0, _jquery2.default)("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
	          (0, _jquery2.default)('#resend-carton-to-amazon').removeClass('hide');
	        }
	      },
	      error: function error() {
	        (0, _jquery2.default)('#no-problems-msg-section').hide();
	        (0, _jquery2.default)('#loading-screen-mask').addClass('hide');
	        (0, _jquery2.default)('#send-carton-error-response').removeClass('hide');
	        (0, _jquery2.default)("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
	        (0, _jquery2.default)('#resend-carton-to-amazon').removeClass('hide');
	      }
	    });
	  });
	
	  (0, _jquery2.default)('#resend-carton-to-amazon a').click(function (e) {
	    e.preventDefault();
	    (0, _jquery2.default)('#send-carton-to-amazon a').trigger('click');
	  });
	
	  (0, _jquery2.default)('#approve-override-submit-btn').click(function (e) {
	    e.preventDefault();
	    (0, _jquery2.default)('#invalid-credentials-message').addClass('hide');
	    (0, _jquery2.default)('#no-permission-override-message').addClass('hide');
	    _jquery2.default.ajax({
	      url: mainEl.data("approve-override-url"),
	      type: 'POST',
	      dataType: 'html',
	      data: {
	        palletNumber: mainEl.data("pallet-number"),
	        orderId: mainEl.data("order-id"),
	        overrideLoginUser: (0, _jquery2.default)('#overrideLoginUser').val(),
	        overrideLoginPwd: (0, _jquery2.default)('#overrideLoginPwd').val()
	      },
	      success: function success(data) {
	        if (data == 'success') {
	          modal.modal("hide");
	          (0, _jquery2.default)('#mismatch-error-msg').hide();
	          (0, _jquery2.default)('.approve-override-btn').hide();
	          (0, _jquery2.default)('#send-carton-mismatch-msg').hide();
	          (0, _jquery2.default)('#qty-mismatch-badge').hide();
	          (0, _jquery2.default)('#no-problems-msg-section').show();
	          (0, _jquery2.default)('#qty-all-match-badge').show();
	          (0, _jquery2.default)('#overide-success-msg').show();
	          (0, _jquery2.default)('#send-carton-to-amazon').show();
	          (0, _jquery2.default)('.q-pill-red').each(function (i, obj) {
	            (0, _jquery2.default)(this).removeClass();
	          });
	          override = true;
	        } else if (data == 'Authentication failed') {
	          (0, _jquery2.default)('#invalid-credentials-message').removeClass('hide');
	        } else if (data == 'No supervisor role is assigned') {
	          (0, _jquery2.default)('#no-permission-override-message').removeClass('hide');
	        } else {
	          errorFlow.showFailureModal();
	        }
	      },
	      error: function error() {
	        errorFlow.showFailureModal();
	      }
	    });
	  });
	};

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(277);
	
	var targetSelector = "#amazon-fba-shipment-carton-info";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
		amazonShipmentInfo(mainEl);
	});
	
	function amazonShipmentInfo(mainEl) {
		//modals
		var supervisorModal = void 0;
		var errorFlow = new _SubmitModalFlow2.default();
		var elsPage = {};
		errorFlow.init();
	
		var elementsPageMap = {
			approveOverrideBtn: ".approve-override-btn",
			sendCartonMismatch: "#send-carton-mismatch-msg",
			noProblemsMessageSection: "#no-problems-msg-section",
			sendCartonToAmazon: "#send-carton-to-amazon",
			quantityAllMatchBadge: "#qty-all-match-badge",
			resendCartonToAmazon: "#resend-carton-to-amazon",
			loadingScreenMask: "#loading-screen-mask",
			feedSubmissionId: "#feedSubmissionId",
			connectionTimeoutMsg: "#connection-timeout-message",
			approveOverrideSubmitBtn: "#approve-override-submit-btn",
			invalidCredentialsMsg: "#invalid-credentials-message",
			noPermissionOverrideMsg: "#no-permission-override-message",
			overrideLoginUser: "#overrideLoginUser",
			overrideLoginPwd: "#overrideLoginPwd",
			misMatchErrorMsg: "#mismatch-error-msg",
			quantityMisMatchBadge: "#qty-mismatch-badge",
			overrideSuccessMsg: "#overide-success-msg",
			sendCartonErrorResponse: "#send-carton-error-response",
			qpillRed: ".q-pill-red"
	
			// Modal Options/Creation
		};var modalOpts = { backdrop: 'static', show: false };
	
		function init() {
			setElements();
			bindElements();
			//miscSetup();
		}
	
		/*function miscSetup() {
	 	facilityModal.modal(modalOpts);
	 } */
	
		function bindElements() {
	
			//approverBtn clicked
			elsPage.approveOverrideBtn.on("click", function (e) {
				e.preventDefault();
				showSupervisorModal();
			});
	
			//first function
			elsPage.sendCartonToAmazon.on("click", function (e) {
				e.preventDefault();
				sendCartonToAmazonFlow();
			});
	
			//last function
			elsPage.approveOverrideSubmitBtn.on("click", function (e) {
				e.preventDefault();
				approveOverrideSubmitFlow();
			});
		}
	
		function setElements() {
			(0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, mainEl);
			elsPage.overrideSuccessMsg.hide(); //hide override success msg on page load
		}
	
		//modal show
		function showSupervisorModal() {
			supervisorModal.modal("show");
		}
	
		//on page load
		/*if ((elsPage.sendCartonMismatch).length > 0) {
	 	elsPage.noProblemsMessageSection.hide();
	 	elsPage.sendCartonToAmazon.hide();
	 	elsPage.quantityAllMatchBadge.hide();
	 } */
	
		//first function
		function sendCartonToAmazonFlow() {
			elsPage.loadingScreenMask.removeClass('hide');
	
			//doubt on this snippet of code
			if (!elsPage.resendCartonToAmazon.hasClass("hide")) {
				elsPage.resendCartonToAmazon.addClass('hide');
			}
	
			(0, _jquery2.default)('#send-carton-to-amazon').hide();
			_jquery2.default.ajax({
				url: mainEl.data("send-carton-url"),
				type: 'POST',
				dataType: 'JSON',
				data: {
					palletNumber: mainEl.data("pallet-number"),
					orderId: mainEl.data("order-id"),
					shipmentId: mainEl.data("shipment-id"),
					shippingType: mainEl.data("shipping-type"),
					doNumber: mainEl.data("do-number"),
					feedSubmissionId: elsPage.feedSubmissionId.val(),
					override: false
				},
				success: function success(response) {
					elsPage.loadingScreenMask.addClass('hide');
					elsPage.feedSubmissionId.val(response.feedSubmissionId);
					if (response.status == 'success') {
						window.location = mainEl.data("scan-lpn-url");
					} else if (response.status == 'ERROR') {
						elsPage.noProblemsMessageSection.hide();
						elsPage.connectionTimeoutMsg.removeClass('hide');
						(0, _jquery2.default)("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
						elsPage.resendCartonToAmazon.removeClass('hide');
					} else {
						elsPage.noProblemsMessageSection.hide();
						elsPage.sendCartonErrorResponse.removeClass('hide');
						elsPage.connectionTimeoutMsg.addClass('hide');
						(0, _jquery2.default)("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
						elsPage.resendCartonToAmazon.removeClass('hide');
					}
				},
				error: function error() {
					elsPage.noProblemsMessageSection.hide();
					elsPage.loadingScreenMask.addClass('hide');
					elsPage.sendCartonErrorResponse.removeClass('hide');
					(0, _jquery2.default)("html, body").animate({ scrollTop: 0 }, "slow"); //to view the error message in the top
					elsPage.resendCartonToAmazon.removeClass('hide');
				}
			});
		}
	
		(0, _jquery2.default)('#resend-carton-to-amazon a').click(function (e) {
			e.preventDefault();
			(0, _jquery2.default)('#send-carton-to-amazon a').trigger('click');
		});
	
		//last function
		function approveOverrideSubmitFlow() {
			elsPage.invalidCredentialsMsg.addClass('hide');
			elsPage.noPermissionOverrideMsg.addClass('hide');
			_jquery2.default.ajax({
				url: mainEl.data("approve-override-url"),
				type: 'POST',
				dataType: 'html',
				data: {
					palletNumber: mainEl.data("pallet-number"),
					orderId: mainEl.data("order-id"),
					overrideLoginUser: elsPage.overrideLoginUser.val(),
					overrideLoginPwd: elsPage.overrideLoginPwd.val()
				},
				success: function success(data) {
					if (data == 'success') {
						//modal.modal("hide");
						supervisorModal.modal("hide");
						elsPage.misMatchErrorMsg.hide();
						elsPage.approveOverrideBtn.hide();
						elsPage.sendCartonMismatch.hide();
						elsPage.quantityMisMatchBadge.hide();
						elsPage.noProblemsMessageSection.show();
						elsPage.quantityAllMatchBadge.show();
						elsPage.overrideSuccessMsg.show();
						elsPage.sendCartonToAmazon.show();
						elsPage.qpillRed.each(function (i, obj) {
							(0, _jquery2.default)(this).removeClass();
						});
						override = true;
					} else if (data == 'Authentication failed') {
						elsPage.invalidCredentialsMsg.removeClass('hide');
					} else if (data == 'No supervisor role is assigned') {
						elsPage.noPermissionOverrideMsg.removeClass('hide');
					}
				},
				error: function error() {
					errorFlow.showFailureModal();
				}
			});
		}
	
		//$('#resend-carton-to-amazon a').click(function(e){
		/*elsPage.resendCartonToAmazon.click(function(e){
	 	  e.preventDefault();
	 	  elsPage.sendCartonToAmazon.trigger('click');  
	 }); */
		(0, _jquery2.default)('#resend-carton-to-amazon a').click(function (e) {
			e.preventDefault();
			(0, _jquery2.default)('#send-carton-to-amazon a').trigger('click');
		});
		init();
	}

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(496);
	
	__webpack_require__(498);
	
	__webpack_require__(497);
	
	__webpack_require__(499);

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(502);
	
	__webpack_require__(503);

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var previouslyScannedLpnHtml = __webpack_require__(290);
	var lpnSkuHtml = __webpack_require__(288);
	var lpnsToScanMessageHtml = __webpack_require__(289);
	
	__webpack_require__(272);
	
	(0, _run2.default)("#scan-lpns-page", function () {
	  var scanLpnsPage = (0, _jquery2.default)("#scan-lpns-page");
	  var scanLpnSection = (0, _jquery2.default)("#scan-lpn-section");
	  var getPackageLabelSection = (0, _jquery2.default)("#get-package-label-section");
	  var markShipWarning = (0, _jquery2.default)("#mark-ship-warning");
	  var markShipButtonSection = (0, _jquery2.default)("#mark-ship-button-section");
	  var lpnDetailsSection = (0, _jquery2.default)("#lpn-details-section");
	  var amazonConnectionError = (0, _jquery2.default)("#amazon-connection-error");
	  var getLabelFromAmazonButton = (0, _jquery2.default)("#get-label-from-amazon-btn");
	  var gettingLabelFromAmazonBar = (0, _jquery2.default)("#getting-label-from-amazon-bar");
	  var returnToPalletSearchSection = (0, _jquery2.default)("#return-to-pallet-search-section");
	  var previouslyScannedSection = (0, _jquery2.default)("#previously-scanned-section");
	  var lpnsToScanFirstMessage = (0, _jquery2.default)("#lpns-to-scan-first-message");
	  var lpnsToScanNextMessage = (0, _jquery2.default)("#lpns-to-scan-next-message");
	  var lpnAlreadyScannedWarning = (0, _jquery2.default)("#lpn-already-scanned-warning");
	  var lpnNotInPalletWarning = (0, _jquery2.default)("#lpn-not-in-pallet-warning");
	  var lpnScanningError = (0, _jquery2.default)("#error-scanning-lpn");
	  var noLPNsProcessedWarning = (0, _jquery2.default)("#no-lpns-processed-warning");
	  var lpnToScan = (0, _jquery2.default)("#lpn-to-scan");
	  var scanLpnButton = (0, _jquery2.default)("#scan-lpn-btn");
	  var displayLpnNumber = (0, _jquery2.default)("#lpn-number-display");
	  var shippingType = scanLpnsPage.data('shipping-type');
	  var scanLpnUrl = scanLpnsPage.data("scan-lpn-url");
	  var getLabelFromAmazonUrl = scanLpnsPage.data("get-label-from-amazon-url");
	  var getAmazonLabelUrl = scanLpnsPage.data("get-amazon-label-url");
	
	  var orderId = scanLpnsPage.data("order-id");
	  var palletNumber = scanLpnsPage.data("pallet-number");
	  var lpns = scanLpnsPage.data("lpns");
	  var readyToShip = scanLpnsPage.data("ready-to-ship");
	  var totalLpns = scanLpnsPage.data("number-of-lpns");
	  var numberOfLpnsToScan = totalLpns;
	
	  initializePage();
	
	  function initializePage() {
	    checkForPreviouslyScannedLpns(lpns);
	    if (totalLpns === numberOfLpnsToScan) {
	      setDisplayForNoScannedLpns();
	    } else if (numberOfLpnsToScan == 0) {
	      setDisplayForAllScannedLpns();
	    } else {
	      setDisplayForSomeScannedLpns();
	    }
	  }
	
	  function checkForPreviouslyScannedLpns(lpns) {
	    _underscore2.default.each(lpns, processPreviouslyScannedLpn);
	  }
	
	  function processPreviouslyScannedLpn(lpn, index, list) {
	    if (lpn.hasLabel === true) {
	      numberOfLpnsToScan = numberOfLpnsToScan - 1;
	      addLpnToPreviouslyScannedSection(lpn.olmLpnNumber);
	    }
	  }
	
	  function setDisplayForNoScannedLpns() {
	    (0, _selectorHelpers.show)(scanLpnSection);
	    (0, _selectorHelpers.hide)(getPackageLabelSection);
	    (0, _selectorHelpers.hide)(markShipWarning);
	    (0, _selectorHelpers.hide)(markShipButtonSection);
	    (0, _selectorHelpers.hide)(returnToPalletSearchSection);
	    (0, _selectorHelpers.hide)(lpnsToScanNextMessage);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.hide)(lpnScanningError);
	  }
	
	  function setDisplayForSomeScannedLpns() {
	    (0, _selectorHelpers.show)(scanLpnSection);
	    setLpnsToScanMessageHtml();
	    (0, _selectorHelpers.hide)(getPackageLabelSection);
	    (0, _selectorHelpers.hide)(markShipWarning);
	    (0, _selectorHelpers.hide)(markShipButtonSection);
	    (0, _selectorHelpers.hide)(returnToPalletSearchSection);
	    (0, _selectorHelpers.hide)(lpnsToScanFirstMessage);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.hide)(lpnScanningError);
	    (0, _selectorHelpers.hide)(noLPNsProcessedWarning);
	  }
	
	  function setDisplayForAllScannedLpns() {
	    (0, _selectorHelpers.hide)(scanLpnSection);
	    (0, _selectorHelpers.hide)(getPackageLabelSection);
	    (0, _selectorHelpers.hide)(lpnsToScanFirstMessage);
	    (0, _selectorHelpers.hide)(lpnsToScanNextMessage);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.hide)(lpnScanningError);
	    (0, _selectorHelpers.hide)(noLPNsProcessedWarning);
	    if (readyToShip == true) {
	      (0, _selectorHelpers.hide)(markShipWarning);
	      (0, _selectorHelpers.hide)(markShipButtonSection);
	      (0, _selectorHelpers.show)(returnToPalletSearchSection);
	    } else {
	      (0, _selectorHelpers.hide)(returnToPalletSearchSection);
	      (0, _selectorHelpers.show)(markShipWarning);
	      (0, _selectorHelpers.show)(markShipButtonSection);
	    }
	  }
	
	  scanLpnButton.click(function () {
	    scanLpn(lpnToScan.val());
	  });
	
	  function scanLpn(lpnNumber) {
	    var lpnIsValid = validateLpnToScan(lpnNumber);
	    if (lpnIsValid) {
	      displayLpnNumber.text(lpnNumber);
	      callScanLpn(lpnNumber);
	    }
	  }
	
	  function validateLpnToScan(lpnNumber) {
	    if (checkLpnIsInPallet(lpnNumber)) {
	      if (checkLpnIsNotScanned(lpnNumber)) {
	        return true;
	      } else {
	        showScanLpnError(lpnAlreadyScannedWarning);
	      }
	    } else {
	      showScanLpnError(lpnNotInPalletWarning);
	    }
	    return false;
	  }
	
	  function checkLpnIsInPallet(lpnNumber) {
	    return _underscore2.default.contains(_underscore2.default.pluck(lpns, 'olmLpnNumber'), lpnNumber);
	  }
	
	  function checkLpnIsNotScanned(lpnNumber) {
	    var index = _underscore2.default.indexOf(_underscore2.default.pluck(lpns, 'olmLpnNumber'), lpnNumber);
	    return lpns[index].hasLabel === false;
	  }
	
	  function showScanLpnError(el) {
	    (0, _selectorHelpers.hide)(lpnsToScanFirstMessage);
	    (0, _selectorHelpers.hide)(lpnsToScanNextMessage);
	    (0, _selectorHelpers.hide)(lpnScanningError);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.show)(el);
	  }
	
	  function callScanLpn(lpnNumber) {
	    _jquery2.default.ajax({
	      url: scanLpnUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        palletNumber: palletNumber,
	        lpnNumber: lpnNumber,
	        shippingType: shippingType
	      },
	      success: processScanLpnResponse,
	      error: handleScanLpnError
	    });
	  }
	
	  function processScanLpnResponse(data) {
	    if (data.response === 'failed') {
	      handleScanLpnError();
	    } else {
	      handleScanLpnSuccess(data);
	    }
	  }
	
	  function handleScanLpnSuccess(data) {
	    lpnDetailsSection.html('');
	    _underscore2.default.each(data, processLpnDetail);
	    (0, _selectorHelpers.hide)(scanLpnSection);
	    (0, _selectorHelpers.show)(getPackageLabelSection);
	    (0, _selectorHelpers.show)(getLabelFromAmazonButton);
	    (0, _selectorHelpers.hide)(amazonConnectionError);
	    (0, _selectorHelpers.hide)(gettingLabelFromAmazonBar);
	  }
	
	  function processLpnDetail(lpnDetail, index, list) {
	    addSkuToLpnDetailsSection(lpnDetail.olmItmSku, lpnDetail.olmPackedQty);
	  }
	
	  function handleScanLpnError() {
	    (0, _selectorHelpers.hide)(lpnsToScanFirstMessage);
	    (0, _selectorHelpers.hide)(lpnsToScanNextMessage);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.show)(lpnScanningError);
	  }
	
	  getLabelFromAmazonButton.click(function () {
	    getLabelFromAmazon(displayLpnNumber.text());
	  });
	
	  function getLabelFromAmazon(lpnNumber) {
	    (0, _selectorHelpers.hide)(getLabelFromAmazonButton);
	    (0, _selectorHelpers.show)(gettingLabelFromAmazonBar);
	    callGetLabelFromAmazon(lpnNumber);
	  }
	
	  function callGetLabelFromAmazon(lpnNumber) {
	    _jquery2.default.ajax({
	      url: getLabelFromAmazonUrl,
	      type: 'POST',
	      dataType: 'TEXT',
	      data: {
	        palletNumber: palletNumber,
	        lpnNumber: lpnNumber,
	        orderId: orderId
	      },
	      success: processGetLabelFromAmazonResponse,
	      error: handleGetLabelFromAmazonError
	    });
	  }
	
	  function processGetLabelFromAmazonResponse(data) {
	    if (data === 'success') {
	      handleGetLabelFromAmazonSuccess(displayLpnNumber.text());
	    } else {
	      handleGetLabelFromAmazonError();
	    }
	  }
	
	  function handleGetLabelFromAmazonSuccess(lpnNumber) {
	    flagLpnAsScanned(lpnNumber);
	    addLpnToPreviouslyScannedSection(lpnNumber);
	    numberOfLpnsToScan = numberOfLpnsToScan - 1;
	    if (numberOfLpnsToScan == 0) {
	      setDisplayForAllScannedLpns();
	    } else {
	      lpnToScan.val('');
	      (0, _selectorHelpers.show)(lpnsToScanNextMessage);
	      setDisplayForSomeScannedLpns();
	    }
	  }
	
	  function flagLpnAsScanned(lpnNumber) {
	    var index = _underscore2.default.indexOf(_underscore2.default.pluck(lpns, 'olmLpnNumber'), lpnNumber);
	    lpns[index].hasLabel = true;
	  }
	
	  function handleGetLabelFromAmazonError() {
	    (0, _selectorHelpers.show)(amazonConnectionError);
	    (0, _selectorHelpers.show)(getLabelFromAmazonButton);
	    (0, _selectorHelpers.hide)(gettingLabelFromAmazonBar);
	    (0, _selectorHelpers.hide)(lpnDetailsSection);
	  }
	
	  (0, _jquery2.default)(document).on("click", '.print-pkg-label-btn', function (e) {
	    e.preventDefault();
	    var lpn = (0, _jquery2.default)(this).data('lpn-number');
	    printPackageLabel(lpn);
	  });
	
	  function printPackageLabel(lpnNumber) {
	    var url = getAmazonLabelUrl.concat('&fileName=label.pdf&lpnNumber=').concat(lpnNumber);
	    var labelWindow = window.open(url, 'label-'.concat(lpnNumber));
	    labelWindow.document.title = 'Package Label';
	  }
	
	  function setLpnsToScanMessageHtml() {
	    var htmlTemplate = _underscore2.default.template(lpnsToScanMessageHtml);
	    lpnsToScanNextMessage.html(htmlTemplate({ numberOfLpns: numberOfLpnsToScan }));
	  }
	
	  function addLpnToPreviouslyScannedSection(lpnNumber) {
	    var htmlTemplate = _underscore2.default.template(previouslyScannedLpnHtml);
	    previouslyScannedSection.append(htmlTemplate({ lpnNumber: lpnNumber }));
	  }
	
	  function addSkuToLpnDetailsSection(sku, quantityPacked) {
	    var htmlTemplate = _underscore2.default.template(lpnSkuHtml);
	    lpnDetailsSection.append(htmlTemplate({ productSku: sku, quantityPacked: quantityPacked }));
	  }
	});

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var previouslyScannedLpnHtml = __webpack_require__(290);
	var lpnSkuHtml = __webpack_require__(288);
	var lpnsToScanMessageHtml = __webpack_require__(289);
	
	__webpack_require__(272);
	
	(0, _run2.default)("#shipment-scan-lpns-page", function () {
	  var scanLpnsPage = (0, _jquery2.default)("#shipment-scan-lpns-page");
	  var scanLpnSection = (0, _jquery2.default)("#scan-lpn-section");
	  var continueshippingBtn = (0, _jquery2.default)("#continue-shipping-section");
	  var getPackageLabelSection = (0, _jquery2.default)("#get-package-label-section");
	  var markShipWarning = (0, _jquery2.default)("#mark-ship-warning");
	  var markShipButtonSection = (0, _jquery2.default)("#mark-ship-button-section");
	  var lpnDetailsSection = (0, _jquery2.default)("#lpn-details-section");
	  var amazonConnectionError = (0, _jquery2.default)("#amazon-connection-error");
	  var getLabelFromAmazonButton = (0, _jquery2.default)("#get-label-from-amazon-btn");
	  var gettingLabelFromAmazonBar = (0, _jquery2.default)("#getting-label-from-amazon-bar");
	  var returnToPalletSearchSection = (0, _jquery2.default)("#return-to-pallet-search-section");
	  var previouslyScannedSection = (0, _jquery2.default)("#previously-scanned-section");
	  var lpnsToScanFirstMessage = (0, _jquery2.default)("#lpns-to-scan-first-message");
	  var lpnsToScanNextMessage = (0, _jquery2.default)("#lpns-to-scan-next-message");
	  var lpnAlreadyScannedWarning = (0, _jquery2.default)("#lpn-already-scanned-warning");
	  var lpnNotInPalletWarning = (0, _jquery2.default)("#lpn-not-in-pallet-warning");
	  var lpnScanningError = (0, _jquery2.default)("#error-scanning-lpn");
	  var noLPNsProcessedWarning = (0, _jquery2.default)("#no-lpns-processed-warning");
	  var lpnToScan = (0, _jquery2.default)("#lpn-to-scan");
	  var scanLpnButton = (0, _jquery2.default)("#scan-lpn-btn");
	  var displayLpnNumber = (0, _jquery2.default)("#lpn-number-display");
	  //new consts
	  var scanLpnHide = (0, _jquery2.default)("#scan-lpn");
	  var bolAvailable = (0, _jquery2.default)("#bol-available");
	  var quoteWarning = (0, _jquery2.default)("#quote-warning");
	  var bolWarning = (0, _jquery2.default)("#bol-warning");
	  var bolSection = (0, _jquery2.default)("#bol-section");
	  var quoteAvailable = (0, _jquery2.default)("#quote-available");
	  var viewQuote = (0, _jquery2.default)("#view-quote");
	  var bolDocAvailable = scanLpnsPage.data("bol-available");
	  var scanLpnUrl = scanLpnsPage.data("scan-lpn-url");
	  var getLabelFromAmazonUrl = scanLpnsPage.data("get-label-from-amazon-url");
	  var getAmazonLabelUrl = scanLpnsPage.data("get-amazon-label-url");
	  var getAmazonPalletLabelUrl = scanLpnsPage.data("get-amazon-pallet-label-url");
	  var generateBolUrl = scanLpnsPage.data("generate-bol-document"); //URL For BOL Document
	  var orderId = scanLpnsPage.data("order-id");
	  var palletNumber = (0, _jquery2.default)("#shipment-scan-lpns-page").data("pallet-number");
	  var lpns = (0, _jquery2.default)("#shipment-scan-lpns-page").data("lpns");
	  var readyToShip = scanLpnsPage.data("ready-to-ship");
	  var totalLpns = scanLpnsPage.data("number-of-lpns");
	  var numberOfLpnsToScan = totalLpns;
	  var flag = scanLpnsPage.data("quote-response-true");
	  var orderLpnsQuote = scanLpnsPage.data("order-lpn-array");
	
	  (0, _selectorHelpers.hide)(continueshippingBtn);
	  (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	  (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	  (0, _selectorHelpers.hide)(lpnScanningError);
	  (0, _selectorHelpers.hide)(markShipWarning);
	  (0, _selectorHelpers.hide)(gettingLabelFromAmazonBar);
	
	  viewQuote.hide();
	  quoteAvailable.hide();
	  bolSection.hide();
	  quoteWarning.hide();
	
	  lpnsToScanNextMessage.hide();
	  initializePage();
	
	  function initializePage() {
	    checkForPreviouslyScannedLpns(lpns);
	    if (totalLpns === numberOfLpnsToScan) {
	      setDisplayForNoScannedLpns();
	    } else if (numberOfLpnsToScan == 0) {
	      setDisplayForAllScannedLpns();
	    } else {
	      setDisplayForSomeScannedLpns();
	    }
	  }
	
	  function checkForPreviouslyScannedLpns(lpns) {
	    _underscore2.default.each(lpns, processPreviouslyScannedLpn);
	  }
	
	  function processPreviouslyScannedLpn(lpn, index, list) {
	    if (lpn.hasLabel === true) {
	      numberOfLpnsToScan = numberOfLpnsToScan - 1;
	      addLpnToPreviouslyScannedSection(lpn.olmLpnNumber);
	    }
	  }
	
	  function setDisplayForNoScannedLpns() {
	    (0, _selectorHelpers.show)(scanLpnSection);
	    (0, _selectorHelpers.show)(lpnsToScanFirstMessage);
	    (0, _selectorHelpers.hide)(getPackageLabelSection);
	    (0, _selectorHelpers.hide)(markShipWarning);
	    (0, _selectorHelpers.hide)(markShipButtonSection);
	    (0, _selectorHelpers.hide)(returnToPalletSearchSection);
	    (0, _selectorHelpers.hide)(lpnsToScanNextMessage);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.hide)(lpnScanningError);
	  }
	
	  function setDisplayForSomeScannedLpns() {
	    (0, _selectorHelpers.show)(scanLpnSection);
	    (0, _selectorHelpers.show)(lpnsToScanNextMessage);
	    setLpnsToScanMessageHtml();
	    (0, _selectorHelpers.hide)(getPackageLabelSection);
	    (0, _selectorHelpers.hide)(markShipWarning);
	    (0, _selectorHelpers.hide)(markShipButtonSection);
	    (0, _selectorHelpers.hide)(returnToPalletSearchSection);
	    (0, _selectorHelpers.hide)(lpnsToScanFirstMessage);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.hide)(lpnScanningError);
	    (0, _selectorHelpers.hide)(noLPNsProcessedWarning);
	  }
	
	  function setDisplayForAllScannedLpns() {
	    (0, _selectorHelpers.show)(continueshippingBtn);
	    (0, _selectorHelpers.hide)(scanLpnSection);
	    (0, _selectorHelpers.hide)(getPackageLabelSection);
	    (0, _selectorHelpers.hide)(lpnsToScanFirstMessage);
	    (0, _selectorHelpers.hide)(lpnsToScanNextMessage);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.hide)(lpnScanningError);
	    (0, _selectorHelpers.hide)(noLPNsProcessedWarning);
	    if (readyToShip == true) {
	      (0, _selectorHelpers.hide)(markShipWarning);
	      (0, _selectorHelpers.hide)(markShipButtonSection);
	      (0, _selectorHelpers.show)(returnToPalletSearchSection);
	    } else {
	      (0, _selectorHelpers.hide)(returnToPalletSearchSection);
	      (0, _selectorHelpers.show)(markShipWarning);
	      (0, _selectorHelpers.show)(markShipButtonSection);
	    }
	  }
	
	  scanLpnButton.click(function () {
	    scanLpn(lpnToScan.val());
	  });
	
	  function scanLpn(lpnNumber) {
	    var lpnIsValid = validateLpnToScan(lpnNumber);
	    if (lpnIsValid) {
	      displayLpnNumber.text(lpnNumber);
	      callScanLpn(lpnNumber);
	    }
	  }
	
	  function validateLpnToScan(lpnNumber) {
	    if (checkLpnIsInPallet(lpnNumber)) {
	      if (checkLpnIsNotScanned(lpnNumber)) {
	        return true;
	      } else {
	
	        showScanLpnError(lpnAlreadyScannedWarning);
	      }
	    } else {
	
	      showScanLpnError(lpnNotInPalletWarning);
	    }
	    return false;
	  }
	
	  function checkLpnIsInPallet(lpnNumber) {
	
	    return _underscore2.default.contains(_underscore2.default.pluck(lpns, 'olmLpnNumber'), lpnNumber);
	  }
	
	  function checkLpnIsNotScanned(lpnNumber) {
	    var index = _underscore2.default.indexOf(_underscore2.default.pluck(lpns, 'olmLpnNumber'), lpnNumber);
	    return lpns[index].hasLabel === false;
	  }
	
	  function showScanLpnError(el) {
	    (0, _selectorHelpers.hide)(lpnsToScanFirstMessage);
	    (0, _selectorHelpers.hide)(lpnsToScanNextMessage);
	    (0, _selectorHelpers.hide)(lpnScanningError);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.show)(el);
	  }
	
	  function callScanLpn(lpnNumber) {
	    (0, _selectorHelpers.hide)(getLabelFromAmazonButton);
	    (0, _selectorHelpers.show)(gettingLabelFromAmazonBar);
	    _jquery2.default.ajax({
	      url: scanLpnUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        palletNumber: palletNumber,
	        lpnNumber: lpnNumber
	      },
	      success: processScanLpnResponse,
	      error: handleScanLpnError
	    });
	  }
	
	  function processScanLpnResponse(data) {
	    if (data.response === 'failed') {
	      handleScanLpnError();
	    } else {
	      handleScanLpnSuccess(data);
	    }
	  }
	
	  function handleScanLpnSuccess(data) {
	    lpnDetailsSection.html('');
	    _underscore2.default.each(data, processLpnDetail);
	    (0, _selectorHelpers.hide)(scanLpnSection);
	    (0, _selectorHelpers.show)(getPackageLabelSection);
	    (0, _selectorHelpers.show)(getLabelFromAmazonButton);
	    (0, _selectorHelpers.hide)(amazonConnectionError);
	    (0, _selectorHelpers.hide)(gettingLabelFromAmazonBar);
	  }
	
	  function processLpnDetail(lpnDetail, index, list) {
	    addSkuToLpnDetailsSection(lpnDetail.olmItmSku, lpnDetail.olmPackedQty);
	  }
	
	  function handleScanLpnError() {
	    (0, _selectorHelpers.hide)(lpnsToScanFirstMessage);
	    (0, _selectorHelpers.hide)(lpnsToScanNextMessage);
	    (0, _selectorHelpers.hide)(lpnAlreadyScannedWarning);
	    (0, _selectorHelpers.hide)(lpnNotInPalletWarning);
	    (0, _selectorHelpers.show)(lpnScanningError);
	  }
	
	  getLabelFromAmazonButton.click(function () {
	    getLabelFromAmazon(displayLpnNumber.text());
	  });
	
	  function getLabelFromAmazon(lpnNumber) {
	    (0, _selectorHelpers.hide)(getLabelFromAmazonButton);
	    (0, _selectorHelpers.show)(gettingLabelFromAmazonBar);
	    callGetLabelFromAmazon(lpnNumber);
	  }
	
	  function callGetLabelFromAmazon(lpnNumber) {
	    _jquery2.default.ajax({
	      url: getLabelFromAmazonUrl,
	      type: 'POST',
	      dataType: 'TEXT',
	      data: {
	        palletNumber: palletNumber,
	        lpnNumber: lpnNumber,
	        orderId: orderId
	      },
	      success: processGetLabelFromAmazonResponse,
	      error: handleGetLabelFromAmazonError
	    });
	  }
	
	  function processGetLabelFromAmazonResponse(data) {
	    if (data === 'success') {
	      handleGetLabelFromAmazonSuccess(displayLpnNumber.text());
	    } else {
	      handleGetLabelFromAmazonError();
	    }
	  }
	
	  function handleGetLabelFromAmazonSuccess(lpnNumber) {
	
	    flagLpnAsScanned(lpnNumber);
	    addLpnToPreviouslyScannedSection(lpnNumber);
	    numberOfLpnsToScan = numberOfLpnsToScan - 1;
	    if (numberOfLpnsToScan == 0) {
	
	      setDisplayForAllScannedLpns();
	    } else {
	      lpnToScan.val('');
	      (0, _selectorHelpers.show)(lpnsToScanNextMessage);
	      setDisplayForSomeScannedLpns();
	    }
	  }
	
	  function flagLpnAsScanned(lpnNumber) {
	    var index = _underscore2.default.indexOf(_underscore2.default.pluck(lpns, 'olmLpnNumber'), lpnNumber);
	    lpns[index].hasLabel = true;
	  }
	
	  function handleGetLabelFromAmazonError() {
	    (0, _selectorHelpers.hide)(continueshippingBtn);
	    (0, _selectorHelpers.show)(amazonConnectionError);
	    (0, _selectorHelpers.show)(getLabelFromAmazonButton);
	    (0, _selectorHelpers.hide)(gettingLabelFromAmazonBar);
	    (0, _selectorHelpers.hide)(lpnDetailsSection);
	  }
	
	  (0, _jquery2.default)(document).on("click", '.print-pkg-label-btn', function (e) {
	    e.preventDefault();
	    var lpn = (0, _jquery2.default)(this).data('lpn-number');
	    printPackageLabel(lpn);
	  });
	
	  function printPackageLabel(lpnNumber) {
	    var url = getAmazonLabelUrl.concat('&fileName=label.pdf&lpnNumber=').concat(lpnNumber);
	    var labelWindow = window.open(url, 'label-'.concat(lpnNumber));
	    labelWindow.document.title = 'Package Label';
	  }
	
	  (0, _jquery2.default)(document).on("click", '.print-pallet-label-btn', function (e) {
	    e.preventDefault();
	    var palletNumber = (0, _jquery2.default)(this).data('pallet-number');
	    var orderId = (0, _jquery2.default)(this).data('order-id');
	    var shipType = (0, _jquery2.default)(this).data('shipping-type');
	    printPalletLabel(palletNumber, orderId, shipType);
	  });
	
	  function printPalletLabel(palletNumber, orderId, shipType) {
	    var url = getAmazonPalletLabelUrl.concat('&fileName=label.pdf&palletNumber=').concat(palletNumber).concat('&orderId=' + orderId + '&shipType=' + shipType);
	    var labelWindow = window.open(url, 'label-'.concat(palletNumber));
	    labelWindow.document.title = 'Package Label';
	  }
	
	  function setLpnsToScanMessageHtml() {
	    var htmlTemplate = _underscore2.default.template(lpnsToScanMessageHtml);
	    lpnsToScanNextMessage.html(htmlTemplate({ numberOfLpns: numberOfLpnsToScan }));
	  }
	
	  function addLpnToPreviouslyScannedSection(lpnNumber) {
	    var htmlTemplate = _underscore2.default.template(previouslyScannedLpnHtml);
	    previouslyScannedSection.append(htmlTemplate({ lpnNumber: lpnNumber }));
	  }
	
	  function processPreviouslyScannedLpnQuote(LPN, index, list) {
	
	    addLpnToPreviouslyScannedSection(LPN.olmLpnNumber);
	  }
	
	  if (scanLpnsPage.data("last-page")) {
	    if (flag) {
	      viewQuote.show();
	      quoteAvailable.show();
	      bolSection.show();
	      if (bolDocAvailable) {
	        bolWarning.hide();
	      } else {
	        bolWarning.show();
	        bolAvailable.hide();
	      }
	      (0, _jquery2.default)(document).on("click", '.print-bol-btn', function (e) {
	        e.preventDefault();
	        var quoteId = (0, _jquery2.default)(this).data('quote-id');
	        printBol(quoteId);
	      });
	    } else {
	      bolAvailable.hide();
	      quoteWarning.show();
	      bolWarning.show();
	      bolSection.hide();
	    }
	    noLPNsProcessedWarning.hide();
	    scanLpnHide.hide();
	    getPackageLabelSection.hide();
	    for (var i = 0; i < orderLpnsQuote.length; i++) {
	
	      for (var j = 0; j < orderLpnsQuote[i].LPN.length; j++) {
	
	        addLpnToPreviouslyScannedSection(orderLpnsQuote[i].LPN[j].olmLPNNumber);
	      }
	    }
	  }
	
	  function addSkuToLpnDetailsSection(sku, quantityPacked) {
	    var htmlTemplate = _underscore2.default.template(lpnSkuHtml);
	    lpnDetailsSection.append(htmlTemplate({ productSku: sku, quantityPacked: quantityPacked }));
	  }
	
	  function printBol(quoteId) {
	
	    var url = generateBolUrl.concat('&fileName=BolDoc.pdf&quoteId=').concat(quoteId);
	    var labelWindow = window.open(url, 'label-'.concat(quoteId));
	    labelWindow.document.title = 'Bol Document';
	  }
	});

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _constants = __webpack_require__(10);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _select2able = __webpack_require__(22);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _scheduler = __webpack_require__(472);
	
	var _scheduler2 = _interopRequireDefault(_scheduler);
	
	var _elementsBindMap = __webpack_require__(506);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _util = __webpack_require__(34);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	var inventory = __webpack_require__(1216);
	
	var optionTemplateHtml = __webpack_require__(135);
	
	(0, _run2.default)("#appointment-form", function (el) {
		var portletNamespace = el.data("portlet-namespace");
		var appointmentDuration = el.data("appointment-duration-url");
		var asnDetailsUrl = el.data("asn-details-url");
		var appointmentSlotUrl = el.data("appointment-slots-url");
		var asnDetailScreenUrl = el.data("asn-details-screen-url");
		var facilityUser = el.data("is-facility-user");
		var brokerUser = el.data("is-broker-user");
		var carrierUser = el.data("is-carrier-user");
		var asnPortlet = el.data("asn-portlet");
		var getCarriersDetailsUrl = el.data("carriers-details-url");
		var isEdit = el.data("edit-flag");
		var editAppointmentData = el.data("edit-appointment-data");
		var cancelBtnUrl = el.data("cancel-url");
		var merchantName = el.data("merchant-name");
		var elementsPageMap = (0, _elementsBindMap.getMap)();
		var submitModalFlow = new _SubmitModalFlow2.default();
	
		submitModalFlow.init();
	
		var retailersList = [],
		    existingList = [],
		    elsPage = {},
		    appointmentScheduler = void 0,
		    duration = void 0,
		    appDate = void 0,
		    appTime = void 0,
		    dock = void 0,
		    doorNum = void 0,
		    appStatus = void 0,
		    aptId = void 0,
		    facilityName = void 0,
		    appDuration = void 0,
		    slotSelected = void 0,
		    btnClick = void 0,
		    loadTypeBtnToggle = void 0,
		    inventorySkuBtnToggle = void 0;
	
		var validator = void 0;
		slotSelected = false;
		var validationOpts = {
			debug: true,
			errorPlacement: function errorPlacement(error, element) {
				var appendClosest = $(element).data('error-placement-append-closest');
				if (appendClosest) {
					$(element).closest(appendClosest).append(error);
				} else {
					error.insertAfter(element);
				}
			}
		};
	
		init();
	
		var appointmentTypesList = elsPage.appointmentTypes.data('options');
		var heightsList = elsPage.heights.data('options');
		var facilitiesList = elsPage.facilities.data('options');
		var trailerTypesList = elsPage.trailerTypes.data('options');
		var retailers = elsPage.retailerList.data('options');
		var carriersList = elsPage.carrierOrganizations.data('options');
	
		loadDropDowns();
	
		function init() {
			setElements();
			bindElements();
			generateBtnToggle();
			setupEditChecker();
			setValidator();
		}
	
		function setValidator() {
			validator = el.validate(validationOpts);
			validator.settings.ignore = ":disabled, :hidden";
		}
	
		if (isEdit) {
			populateValuesForEdit();
			elsPage.submitBtn.removeAttr('disabled');
			elsPage.editMessage.addClass('hidden');
		}
	
		function setElements() {
			(0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, el);
			initDatePickerComp();
		}
	
		function initDatePickerComp() {
			var today = new Date();
			var nextDay = new Date();
			nextDay.setDate(today.getDate() + 1);
			var singleDatepickerEl = elsPage.appointmentDate;
			singleDatepickerEl.datepicker({
				startDate: nextDay,
				keyboardNavigation: false,
				autoclose: true
			});
		}
	
		function setupEditChecker() {
			_EditChecker2.default.bindNavigation();
			_EditChecker2.default.bindChangeListener("#appointment-form");
			_EditChecker2.default.bindChangeListener("span.select2");
			_EditChecker2.default.bindCancelButton(".cancel-url");
		}
	
		function bindElements() {
			if (!isEdit) {
				elsPage.submitBtn.attr('disabled', 'disabled');
			}
			elsPage.appointmentTypes.on("change.select2", appointmentTypesHandler);
			elsPage.trailerTypes.on("change", trailerTypesHandler);
			elsPage.facilities.on("change", facilitySection);
			elsPage.pallets.on("click", palletHandler);
			elsPage.floorLoaded.on("click", floorLoadedHandler);
			elsPage.heights.on("change", availabilitySection);
			elsPage.numberOfPallets.on("change", availabilitySection);
	
			elsPage.singleSku.on("click", function (e) {
				e.preventDefault();
				elsPage.inventorySection.val(true);
			});
	
			elsPage.mixedSkus.on("click", function (e) {
				e.preventDefault();
				elsPage.inventorySection.val(false);
			});
	
			elsPage.checkAppointmentBtn.on("click", loadAppointmentSlot);
			elsPage.addAsnBtn.on("click", asnDetailSection);
			elsPage.submitBtn.on("click", submitAppointmentHandler);
			elsPage.retailerList.on("change.select2", function () {
				if (facilityUser) {
					carrierSelect();
				}
			});
		}
	
		function carrierSelect() {
			var retailerSelected = elsPage.retailerList.val();
			var retailersObj = [];
			retailerSelected.map(function (retailer) {
				retailersObj.push({ retailerIds: retailer });
			});
	
			$.ajax({
				data: _defineProperty({}, portletNamespace + 'retailersObj', JSON.stringify(retailersObj)),
				url: getCarriersDetailsUrl,
				dataType: "JSON",
				type: 'POST',
				success: function success(data) {
					elsPage.carrierOrganizations.empty().trigger('change');
					var CarrierOptions = data.map(function (carr) {
						return (0, _render2.default)(optionTemplateHtml, {
							targetKey: carr.carScac,
							text: carr.carScac + " - " + carr.carName
						});
					});
					elsPage.carrierOrganizations.append(CarrierOptions.join(''));
				}
			});
		}
	
		function generateBtnToggle() {
			loadTypeBtnToggle = new _QuickBtnGroup2.default(elsPage.loadTypeBtnToggleEl, {
				distributeWidth: true
			});
			loadTypeBtnToggle.init();
	
			inventorySkuBtnToggle = new _QuickBtnGroup2.default(elsPage.inventorySkuBtnToggleEl, {
				distributeWidth: true
			});
			inventorySkuBtnToggle.init();
		}
	
		function floorLoadedHandler() {
			defaultValues();
			elsPage.loadType.val("Floor Loaded");
			elsPage.floorLoaded.addClass("active");
			elsPage.pallets.removeClass("active");
			elsPage.cases.val('');
			elsPage.casesSection.removeClass("hidden");
			elsPage.palletsSection.addClass("hidden");
			btnClick = true;
			elsPage.trailerNumber.removeClass("hidden");
			elsPage.skuSection.removeClass("hidden");
		}
		function trailerTypesHandler() {
			defaultValues();
			commonForTrailerType();
			if (elsPage.trailerTypes.val() === "LTL") {
				elsPage.loadType.addClass("hidden");
				elsPage.trailerNumber.removeClass("hidden");
			} else {
				elsPage.loadType.removeClass("hidden");
				elsPage.floorLoaded.removeClass("active");
				elsPage.pallets.removeClass("active");
				elsPage.singleSku.removeClass("active");
				elsPage.mixedSkus.removeClass("active");
				elsPage.trailerNumber.addClass("hidden");
			}
		}
	
		function appointmentTypesHandler() {
			commonSections();
	
			if (elsPage.appointmentTypes.val() === "Live Unload") {
				elsPage.liveUnload.removeClass("hidden");
				elsPage.dropUnload.addClass("hidden");
				elsPage.pickupEmpty.addClass("hidden");
				elsPage.shippingSection.removeClass("hidden");
				elsPage.trailerNumber.addClass("hidden");
				elsPage.inventorySection.removeClass("hidden");
				if (carrierUser) {
					elsPage.merchant.removeClass("hidden");
					loadMerchantName();
				} else {
					elsPage.merchant.addClass("hidden");
				}
			} else if (elsPage.appointmentTypes.val() === "Drop Unload") {
				elsPage.shippingSection.addClass("hidden");
				elsPage.liveUnload.addClass("hidden");
				elsPage.pickupEmpty.addClass("hidden");
				elsPage.dropUnload.removeClass("hidden");
				elsPage.trailerNumber.removeClass("hidden");
				if (carrierUser) {
					elsPage.merchant.removeClass("hidden");
					loadMerchantName();
				} else {
					elsPage.merchant.addClass("hidden");
				}
				elsPage.inventorySection.removeClass("hidden");
			} else if (elsPage.appointmentTypes.val() === "Pickup Empty") {
				appointmentTypeSections();
				elsPage.trailerRequired.removeClass("hidden");
				elsPage.trailer.addClass("required");
				elsPage.pickupEmpty.removeClass("hidden");
				if (facilityUser) {
					elsPage.merchant.removeClass("hidden");
				}
				if (brokerUser || carrierUser) {
					elsPage.merchant.removeClass("hidden");
					loadMerchantName();
				}
			} else {
				appointmentTypeSections();
				elsPage.pickupEmpty.addClass("hidden");
				elsPage.merchant.removeClass("hidden");
				if (brokerUser || carrierUser) {
					loadMerchantName();
				}
			}
		}
	
		function loadMerchantName() {
			elsPage.retailerList.val(merchantName);
			elsPage.retailerList.trigger('change.select2');
			elsPage.retailerList.attr('disabled', 'disabled');
			var select2TargetEl = elsPage.retailerList.data('target-closest');
			var parentEl = elsPage.retailerList.closest(select2TargetEl);
			parentEl.find('.select2-container').css('pointer-events', 'none');
		}
	
		function palletHandler() {
			elsPage.loadType.val("Pallets");
			elsPage.pallets.addClass("active");
			defaultValues();
			elsPage.floorLoaded.removeClass("active");
			elsPage.numberOfPallets.val('');
			elsPage.palletsSection.removeClass("hidden");
			elsPage.casesSection.addClass("hidden");
			elsPage.trailerNumber.removeClass("hidden");
			elsPage.skuSection.removeClass("hidden");
			btnClick = true;
		}
	
		function loadAppointmentSlot() {
			elsPage.submitBtn.attr('disabled', 'disabled');
			elsPage.slotError.hide();
			if (!btnClick && elsPage.appointmentTypes.val() === "Live Unload" && elsPage.trailerTypes.val() && elsPage.trailerTypes.val() != "LTL") {
				elsPage.loadTypeError.removeClass('hidden');
				return;
			}
			var isFormValid = el.valid();
			if (isFormValid) {
				var datePicked = elsPage.appointmentDate.val();
				if (datePicked) {
					var appointmentResponse = null;
					var appointmentTypeObj = getAppointentTime();
					$.ajax({
						url: appointmentDuration,
						dataType: "JSON",
						type: 'POST',
						data: _defineProperty({}, portletNamespace + 'appointmentType', JSON.stringify(appointmentTypeObj)), success: function success(data) {
							appointmentResponse = data.appointmentType;
							duration = appointmentResponse.aptAppointmentDuration;
							var facId = appointmentResponse.aptFacId;
							aptId = appointmentResponse.aptId;
							elsPage.appDurationTime.text(duration);
							loadAppointmentSlots(duration, facId);
						}
					});
				}
			}
		}
	
		function loadAppointmentSlots(appDuration, facId) {
			var datePicked = elsPage.appointmentDate.val();
			var slotRequest = {};
			slotRequest.appointmentDate = datePicked;
			slotRequest.appointmentDuration = appDuration;
			slotRequest.appointmentFacId = facId;
			submitModalFlow.showLoadingModal();
			$.ajax({
				url: appointmentSlotUrl,
				dataType: "JSON",
				type: 'POST',
				data: _defineProperty({}, portletNamespace + 'slotRequest', JSON.stringify(slotRequest)),
				success: function success(data) {
					submitModalFlow.hideAllModals();
					if (data.success) {
						elsPage.appointmentSchedulerContainer.removeClass('hidden');
						showSchedular(data.slots);
					}
				},
				error: function error(data) {
					submitModalFlow.hideAllModals();
					submitModalFlow.showFailureModal();
				}
			});
		}
	
		function showSchedular(slotResponse) {
			var datePicked = elsPage.appointmentDate.val();
			var today = new Date();
			var pickedDate = new Date(datePicked);
			var nextDay = new Date();
			nextDay.setDate(today.getDate() + 1);
			if (pickedDate.getDate() == nextDay.getDate() || pickedDate.getDate() == today.getDate()) {
				elsPage.nxtDayMsg.removeClass('hidden');
			} else {
				elsPage.nxtDayMsg.addClass('hidden');
			}
			elsPage.availableMsg.removeClass('hidden');
			elsPage.oneHrMsg.removeClass('hidden');
			appointmentScheduler = new _scheduler2.default({
				target: '.appointment-scheduler',
				data: slotResponse,
				activeIndex: 1
			});
			appointmentScheduler.init();
			elsPage.disclaimerMsg.removeClass('hidden');
	
			$('.time-block-div input[type=radio]').click(submitBtnEnable);
		}
	
		function submitBtnEnable() {
			elsPage.submitBtn.removeAttr('disabled');
			elsPage.slotError.hide();
			slotSelected = true;
			elsPage.editMessage.addClass('hidden');
		}
	
		function asnDetailSection(e) {
			var _data4;
	
			elsPage.asnRequiredError.addClass('hidden');
			var facId = elsPage.facilities.val();
			var selectedShipmentId = elsPage.asn.val();
			elsPage.asnError.hide();
			if (null == selectedShipmentId || selectedShipmentId == "") {
				elsPage.asn.val('');
				elsPage.asnInvalidError.show();
				return;
			} else if (existingList.indexOf(selectedShipmentId) > -1) {
				elsPage.asn.val('');
				elsPage.asnDuplicateError.show();
				return;
			}
	
			var existingListStr = "";
			$.each(existingList, function (index, item) {
				if (existingListStr.length > 0) {
					existingListStr = existingListStr + "," + item;
				} else {
					existingListStr = existingListStr + item;
				}
			});
			e.preventDefault();
			elsPage.asnDetails.removeClass("hidden");
			$.ajax({
				data: (_data4 = {}, _defineProperty(_data4, portletNamespace + 'shipmentId', selectedShipmentId), _defineProperty(_data4, portletNamespace + 'existingList', existingListStr), _defineProperty(_data4, portletNamespace + 'facId', facId), _data4),
				url: asnDetailsUrl,
				async: false,
				dataType: "JSON",
				type: 'POST',
				success: function success(data) {
					elsPage.asn.val('');
					if (data.status == 'success') {
						var asnData = data.asn[0];
						var facilityData = data.facility;
						var retailerData = data.retailer[0];
						var palletCount = data.palletCount;
						var cmrAddressData = data.cmrAddress;
						existingList.push(asnData.asnShipmentId);
	
						var index = retailersList.indexOf(asnData.asnRtlId);
						if (index < 0) {
							retailersList.push(asnData.asnRtlId);
						}
	
						buildInvetorySection(asnData, palletCount, retailerData, facilityData, cmrAddressData);
					} else {
						elsPage.asnGenericErrorLabel.text(data.errorMessage);
						elsPage.asnGenericError.show();
					}
				},
				error: function error(data) {
					elsPage.asn.val('');
					submitModalFlow.hideAllModals();
					submitModalFlow.showFailureModal();
				}
	
			});
		}
	
		function removeAsn(e) {
			e.preventDefault();
			var asnData = e.data;
			var index = existingList.indexOf(asnData.asnShipmentId);
			if (index > -1) {
				existingList.splice(index, 1);
				$('#asn-section-' + asnData.asnShipmentId).remove();
			}
	
			index = retailersList.indexOf(asnData.asnRtlId);
			if (index > -1) {
				retailersList.splice(index, 1);
			}
		}
	
		function viewAsnDetails(e) {
			e.preventDefault();
			var asnData = e.data;
			var asnDetailsFinalUrl = asnDetailScreenUrl + '&' + asnPortlet + 'asnId=' + asnData.asnId;
			window.open(asnDetailsFinalUrl);
		}
	
		function loadDropDowns() {
	
			var appointmentTypeOptions = appointmentTypesList.map(function (item) {
				return (0, _render2.default)(optionTemplateHtml, {
					targetKey: item.cdmValue,
					text: item.cdmMeaning
				});
			});
			elsPage.appointmentTypes.append(appointmentTypeOptions.join(''));
	
			var palletHeightOptions = heightsList.map(function (item) {
				return (0, _render2.default)(optionTemplateHtml, {
					targetKey: item.cdmValue,
					text: item.cdmMeaning
				});
			});
			elsPage.heights.append(palletHeightOptions.join(''));
	
			var trailerTypeOptions = trailerTypesList.map(function (item) {
				return (0, _render2.default)(optionTemplateHtml, {
					targetKey: item.cdmValue,
					text: item.cdmMeaning
				});
			});
			elsPage.trailerTypes.append(trailerTypeOptions.join(''));
	
			var retailerOptions = retailers.map(function (item) {
				return (0, _render2.default)(optionTemplateHtml, {
					targetKey: item.rtlId,
					text: item.rtlName
				});
			});
			elsPage.retailerList.append(retailerOptions.join(''));
	
			var facilityOptions = facilitiesList.map(function (item) {
				return (0, _render2.default)(optionTemplateHtml, {
					targetKey: item.facId,
					text: item.facName
				});
			});
			elsPage.facilities.append(facilityOptions.join(''));
			if (!facilityUser) {
				var CarrierOptions = (0, _underscore2.default)(carriersList).map(function (carr) {
					return (0, _render2.default)(optionTemplateHtml, {
						targetKey: carr.carScac,
						text: carr.carScac + " - " + carr.carName
					});
				});
	
				elsPage.carrierOrganizations.append(CarrierOptions.join(''));
				if (carrierUser) {
					elsPage.carrierOrganizations.prop('selectedIndex', '1').trigger('change.select2');
					elsPage.carrierOrganizations.attr('disabled', 'disabled');
				}
			}
			if (facilityUser) {
				elsPage.facilities.prop('selectedIndex', '1').trigger('change.select2');
				elsPage.facilities.attr('disabled', 'disabled');
			}
		}
	
		function commonSections() {
			retailersList = [];
			elsPage.arrivalTime.removeClass("hidden");
			elsPage.additionalInfo.removeClass("hidden");
			elsPage.destinationSection.removeClass("hidden");
			elsPage.loadType.addClass("hidden");
			elsPage.retailerList.val([]).change();
			elsPage.trailerTypes.val('').trigger('change.select2');
			elsPage.notes.val('');
			elsPage.trailerRequired.addClass("hidden");
			elsPage.trailer.removeClass("required");
			defaultValues();
			commonForTrailerType();
		}
	
		function defaultValues() {
			availabilitySection();
			btnClick = false;
			elsPage.loadTypeError.addClass('hidden');
			elsPage.trailer.val('');
			elsPage.numberOfPallets.val('');
			elsPage.cases.val('');
			elsPage.heights.val('').trigger('change.select2');
			elsPage.mixedSkus.removeClass("active");
			elsPage.singleSku.removeClass("active");
			elsPage.inventorySection.val('');
		}
	
		function availabilitySection() {
			if (isEdit) {
				elsPage.asnAlert.removeClass('hidden');
				elsPage.shippingAlert.removeClass('hidden');
				elsPage.editMessage.removeClass('hidden');
			}
			elsPage.submitBtn.attr('disabled', 'disabled');
			elsPage.oneHrMsg.addClass('hidden');
			elsPage.nxtDayMsg.addClass('hidden');
			elsPage.slotError.hide();
			elsPage.appointmentSchedulerContainer.addClass('hidden');
			elsPage.availableMsg.addClass('hidden');
			elsPage.disclaimerMsg.addClass('hidden');
		}
	
		function facilitySection() {
			availabilitySection();
			existingList = [];
			elsPage.asnDetails.empty();
		}
	
		function appointmentTypeSections() {
			elsPage.trailerNumber.removeClass("hidden");
			elsPage.liveUnload.addClass("hidden");
			elsPage.dropUnload.addClass("hidden");
			elsPage.shippingSection.addClass("hidden");
			elsPage.inventorySection.addClass("hidden");
		}
	
		function commonForTrailerType() {
			elsPage.palletsSection.addClass("hidden");
			elsPage.casesSection.addClass("hidden");
			elsPage.skuSection.addClass("hidden");
		}
	
		function getAppointentTime() {
			var appointmentTypeObj = {};
			appointmentTypeObj.appointmentType = elsPage.appointmentTypes.val();
			appointmentTypeObj.facility = elsPage.facilities.val();
			if (elsPage.appointmentTypes.val() === "Live Unload") {
				if (elsPage.trailerTypes.val() === "LTL") {
					appointmentTypeObj.trailerType = elsPage.trailerTypes.val();
				} else {
					appointmentTypeObj.loadType = elsPage.loadType.val();
					appointmentTypeObj.trailerType = elsPage.trailerTypes.val();
					if (elsPage.loadType.val() != "Floor Loaded") {
						appointmentTypeObj.numberOfPallets = elsPage.numberOfPallets.val();
						appointmentTypeObj.palletHeight = elsPage.heights.val();
					} else {
						appointmentTypeObj.numberofCases = elsPage.cases.val();
					}
				}
			}
			return appointmentTypeObj;
		}
	
		function submitAppointmentHandler() {
			var isFormValid = el.valid();
			if ((elsPage.appointmentTypes.val() === "Live Unload" || elsPage.appointmentTypes.val() === "Drop Unload") && $('.asn-section').length == 0) {
				elsPage.asnRequiredError.removeClass('hidden');
				return;
			}
			if (isFormValid) {
				var viewDetailUrl = elsPage.submitBtn.data("view-detail");
				var saveAppointmentUrl = elsPage.submitBtn.data("save-appointment-url");
				var _submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: "Submitting Appointment",
					confirmModalBody: '<div class="q-pad-all-xl">Once submitted this scheduled appointment time will be sent to the facility destination and held for this organization. The appointment may be changed or canceled up till 24 hrs. before the scheduled arrival.</div>',
					confirmModalBtnText: "Submit",
					onConfirmClick: function onConfirmClick() {
						var appointmentObj = prepareDataForSubmit();
						_submitModalFlow.showLoadingModal();
						$.ajax({
							data: _defineProperty({}, portletNamespace + 'appointment', JSON.stringify(appointmentObj)),
							url: saveAppointmentUrl,
							dataType: "JSON",
							type: 'POST',
							success: function success(data) {
								_EditChecker2.default.setPageClean();
								_submitModalFlow.hideAllModals();
								if (data.status == 'success') {
									var appointment = data.appointment;
									var appId = appointment.appId;
									_submitModalFlow.showSuccessModal();
									setTimeout(function () {
										location.href = viewDetailUrl + '&appId=' + appId;
									}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
								} else {
									elsPage.slotError.show();
									elsPage.slotErrorMessage.text(data.errorMessage);
								}
							},
							error: function error() {
								_submitModalFlow.hideAllModals();
								_submitModalFlow.showFailureModal();
							}
						});
					}
				});
	
				_submitModalFlow.init();
				_submitModalFlow.showConfirmModal();
			}
		}
	
		function prepareDataForSubmit() {
			var appointmentObj = {};
			if (isEdit) {
				appointmentObj.appId = editAppointmentData.appointment.appId;
				appointmentObj.status = appStatus;
			}
			var selectedmerchantIds = elsPage.retailerList.val();
			appointmentObj.appointmentType = elsPage.appointmentTypes.val();
			appointmentObj.carrierOrganizations = elsPage.carrierOrganizations.val();
	
			if (slotSelected) {
				var slotsDetails = appointmentScheduler.getSelection();
				var availTime = slotsDetails[0].availTime;
				appointmentObj.appDateAndTime = slotsDetails[0].date + " " + availTime.startTime;
				appointmentObj.appDockId = availTime.dockId;
				appointmentObj.appDoorNumber = availTime.doorNumber;
			} else {
				appointmentObj.appDateAndTime = appDate + " " + appTime;
				appointmentObj.appDockId = dock;
				appointmentObj.appDoorNumber = doorNum;
			}
			appointmentObj.facility = elsPage.facilities.val();
			appointmentObj.duration = duration;
			appointmentObj.aptId = aptId;
			appointmentObj.appointmentNotes = elsPage.notes.val();
			appointmentObj.trailerNumber = elsPage.trailer.val();
			appointmentObj.facilityName = facilityName;
			appointmentObj.preferredDate = elsPage.appointmentDate.val();
			appointmentObj.appDuration = appDuration;
	
			if (elsPage.appointmentTypes.val() === "Live Unload" || elsPage.appointmentTypes.val() === "Drop Unload") {
				appointmentObj.objectIds = existingList;
				appointmentObj.objectType = "ASN";
				appointmentObj.retailers = retailersList;
			} else {
				appointmentObj.retailers = selectedmerchantIds;
			}
	
			if (elsPage.trailerTypes.val() === "LTL") {
				appointmentObj.trailerType = elsPage.trailerTypes.val();
			} else {
				appointmentObj.loadType = elsPage.loadType.val();
				appointmentObj.trailerType = elsPage.trailerTypes.val();
				appointmentObj.skuFlag = elsPage.inventorySection.val();
				if (elsPage.loadType.val() != "Floor Loaded") {
					appointmentObj.numberOfPallets = elsPage.numberOfPallets.val();
					appointmentObj.palletHeight = elsPage.heights.val();
				} else {
					appointmentObj.numberofCases = elsPage.cases.val();
				}
			}
	
			return appointmentObj;
		}
	
		function populateValuesForEdit() {
			var appointment = editAppointmentData.appointment;
			if (!(0, _util.isNullOrUndefined)(appointment.appointmentType)) {
				elsPage.appointmentTypes.val(appointment.appointmentType).trigger('change');
			}
			if (!(0, _util.isNullOrUndefined)(appointment.facility)) {
				elsPage.facilities.val(appointment.facility).trigger('change');
			}
			if (!(0, _util.isNullOrUndefined)(appointment.trailerType)) {
				elsPage.trailerTypes.val(appointment.trailerType).trigger('change');
			}
	
			if (!(0, _util.isNullOrUndefined)(appointment.loadType)) {
				if (appointment.loadType === "Floor Loaded") {
					elsPage.floorLoaded.trigger('click');
				} else {
					elsPage.pallets.trigger('click');
				}
			}
			if (!(0, _util.isNullOrUndefined)(appointment.trailerNumber)) {
				elsPage.trailer.val(appointment.trailerNumber);
			}
			if (!(0, _util.isNullOrUndefined)(appointment.appointmentNotes)) {
				elsPage.notes.val(appointment.appointmentNotes);
			}
			if (!(0, _util.isNullOrUndefined)(appointment.numberOfPallets)) {
				elsPage.numberOfPallets.val(appointment.numberOfPallets);
			}
			if (!(0, _util.isNullOrUndefined)(appointment.numberOfCases)) {
				elsPage.cases.val(appointment.numberOfCases);
			}
			if (!(0, _util.isNullOrUndefined)(appointment.palletHeight)) {
				elsPage.heights.val(appointment.palletHeight);
			}
			if (!(0, _util.isNullOrUndefined)(appointment.duration)) {
				appDuration = appointment.duration;
			}
			if (!(0, _util.isNullOrUndefined)(appointment.status)) {
				appStatus = appointment.status;
			}
	
			if (!(0, _util.isNullOrUndefined)(appointment.singleSkuFlag)) {
				if (appointment.singleSkuFlag) {
					elsPage.singleSku.trigger('click');
				} else {
					elsPage.mixedSkus.trigger('click');
				}
			}
			if (!(0, _util.isNullOrUndefined)(editAppointmentData.appointmentDate)) {
				appDate = editAppointmentData.appointmentDate;
			}
	
			if (!(0, _util.isNullOrUndefined)(editAppointmentData.appointmentTime)) {
				appTime = editAppointmentData.appointmentTime;
			}
			if (!(0, _util.isNullOrUndefined)(appointment.dockId)) {
				dock = appointment.dockId;
			}
			if (!(0, _util.isNullOrUndefined)(appointment.doorNumber)) {
				doorNum = appointment.doorNumber;
			}
			if (!(0, _util.isNullOrUndefined)(appointment.appAptId)) {
				aptId = appointment.appAptId;
			}
	
			if (!(0, _util.isNullOrUndefined)(appointment.appointmentRetailers) && facilityUser) {
				var merchantList = [];
				$.each(appointment.appointmentRetailers, function (index, item) {
					merchantList.push(item.retailerId);
				});
				elsPage.retailerList.val(merchantList);
			}
	
			if (appointment.asns && appointment.asns.length > 0) {
				elsPage.asnDetails.removeClass("hidden");
				$.each(appointment.asns, function (index, asnData) {
					existingList.push(asnData.asnShipmentId);
					retailersList.push(asnData.asnRtlId);
					var retailerData = editAppointmentData.retailerData[0];
					buildInvetorySection(asnData, editAppointmentData.palletCount, retailerData, editAppointmentData.facilityData, editAppointmentData.cmrAddressData);
				});
			}
		}
	
		function buildInvetorySection(asnData, palletCount, retailerData, facilityData, cmrAddressData) {
			var inventoryData = {};
			if (facilityUser || brokerUser || carrierUser) {
				inventoryData.hidden = "hidden";
			} else {
				inventoryData.hidden = "";
			}
			inventoryData.asnData = asnData;
			inventoryData.palletCount = palletCount;
			inventoryData.retailerData = retailerData;
			inventoryData.facilityData = facilityData;
			inventoryData.cmrAddressData = cmrAddressData;
			var inventoryHtml = $((0, _render2.default)(inventory, inventoryData));
			elsPage.asnDetails.append(inventoryHtml);
			$('#asn-section-' + asnData.asnShipmentId + ' #remove-asn-btn').bind('click', asnData, removeAsn);
	
			$('#asn-section-' + asnData.asnShipmentId + ' #view-asn-btn').bind('click', asnData, viewAsnDetails);
		}
	});

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	var modalHtml = __webpack_require__(11);
	var cancelAppointmentModalBodyHtml = __webpack_require__(291);
	var targetSelector = "#appointment-details";
	
	(0, _run2.default)(targetSelector, function (el) {
	  var mainEl = $(el);
	  var els = {};
	  var cancelAppointmentModal = void 0;
	  var modalOpts = { backdrop: 'static', show: false };
	  var cancelReasons = el.data("cancel-reasons");
	  var appointment = el.data("appointment");
	  var editAppointmentUrl = el.data("edit-appointment-url");
	  var cancelAppointmentUrl = el.data("cancel-appointment-url");
	  var elementsMap = {
	    cancelBtn: ".cancel-appointment-btn",
	    modalCancelBtn: ".cancel-appointment-btn-on-modal",
	    cancelReasonSelect: "#cancel-reason-select",
	    cancelNotes: "#cancel-notes",
	    pencilIcon: ".fa-pencil",
	    editBtn: ".app-edit-btn"
	  };
	
	  init();
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  function init() {
	    generateModal();
	    setElements();
	    loadCancelReasons();
	    showHideButtons();
	  }
	
	  function generateModal() {
	    cancelAppointmentModal = $((0, _render2.default)(modalHtml, {
	      title: 'Cancel Appointment',
	      modalDialogClass: 'q-modal-dialog-800',
	      leftAlignTitle: true,
	      topCloseBtn: true,
	      autoHideTop: true,
	      body: cancelAppointmentModalBodyHtml,
	      footerBtns: '\n                    <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>\n                    <a href="#" class="base-btn purple-btn cancel-appointment-btn-on-modal">Cancel Appointment</a>\n                  '
	    }));
	
	    mainEl.append(cancelAppointmentModal);
	    cancelAppointmentModal.modal(modalOpts);
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	  }
	
	  function loadCancelReasons() {
	    _.each(cancelReasons, function (data) {
	      var option = $('<option />');
	      option.attr('value', data.cdmValue).text(data.cdmMeaning);
	      els.cancelReasonSelect.append(option);
	    });
	  }
	
	  function showHideButtons() {
	    var status = appointment.status;
	    var hasMultipleRetailers = appointment.hasMultipleRetailers;
	    var isFacilityUser = appointment.isFacilityUser;
	    if ((0, _general.isFalsey)(isFacilityUser) && (0, _general.isTruthy)(hasMultipleRetailers) || status !== "Scheduled") {
	      els.editBtn.hide();
	      els.cancelBtn.hide();
	      els.pencilIcon.addClass("disabled");
	    }
	    els.modalCancelBtn.attr("disabled", true);
	  }
	
	  els.cancelBtn.on("click", showCancelAppointmentModal);
	  els.modalCancelBtn.on("click", cancelAppointment);
	  els.editBtn.on("click", editAppointment);
	  els.pencilIcon.on("click", onClickPencil);
	  els.cancelReasonSelect.on("change", onChangeCancelReason);
	
	  function showCancelAppointmentModal(e) {
	    e.preventDefault();
	    cancelAppointmentModal.modal('show');
	  }
	
	  function cancelAppointment() {
	    var _data;
	
	    cancelAppointmentModal.modal('hide');
	    submitModalFlow.showLoadingModal();
	    $.ajax({
	      url: cancelAppointmentUrl,
	      type: "POST",
	      data: (_data = {}, _defineProperty(_data, 'cancelReason', els.cancelReasonSelect.val()), _defineProperty(_data, 'cancelNotes', els.cancelNotes.val()), _data),
	      success: onCancelSuccess,
	      error: onCancelError
	    });
	  }
	
	  function onCancelSuccess(data) {
	    submitModalFlow.hideAllModals();
	    if (data.match("success")) {
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        location.reload();
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function onCancelError() {
	    submitModalFlow.hideAllModals();
	    submitModalFlow.showFailureModal();
	  }
	
	  function onClickPencil() {
	    if (!els.pencilIcon.hasClass("disabled")) {
	      editAppointment();
	    }
	  }
	
	  function onChangeCancelReason() {
	    els.modalCancelBtn.attr("disabled", false);
	  }
	
	  function editAppointment() {
	    location.href = editAppointmentUrl;
	  }
	});

/***/ },
/* 506 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getMap = getMap;
	function getMap() {
	    return elementsPageMap;
	}
	
	var elementsPageMap = {
	    appointmentTypes: "#appointment-types",
	    carrierOrganizations: "#carrierorganizations",
	    shippingSection: ".shipping-section",
	    loadType: ".load-type",
	    floorLoaded: ".floor-loaded",
	    loadTypeError: "#load-type-error",
	    cases: ".cases",
	    numberOfPallets: ".number-of-pallets",
	    pallets: ".pallets",
	    liveUnload: ".live-unload-message",
	    dropUnload: ".drop-unload-message",
	    pickupEmpty: ".pickup-message",
	    palletsSection: ".pallets-section",
	    merchant: ".merchant",
	    casesSection: ".cases-section",
	    asnRequiredError: "#asn-required-error",
	    notes: ".notes",
	    appDurationTime: "#app-duration",
	    asnInvalidError: ".invalid-asn-error",
	    asnDuplicateError: ".duplicate-asn-error",
	    asnError: ".asn-error",
	    asnGenericError: ".generic-asn-error",
	    asnGenericErrorLabel: ".generic-asn-error-label",
	    skuSection: ".sku-section",
	    singleSku: ".single-sku",
	    asn: ".asn",
	    facSection: ".fac-section",
	    asnDetails: ".asn-details",
	    slotError: ".duplicate-slot-error",
	    mixedSkus: ".mixed-skus",
	    slotErrorMessage: ".slot-error-message",
	    addAsnBtn: ".add-asn-btn",
	    duplicateMessage: ".duplicate-error-message",
	    differentType: ".different-type",
	    arrivalTime: ".arrival-time-section",
	    destinationSection: ".destination-section",
	    additionalInfo: ".additional-info-section",
	    inventorySection: ".inventory-section",
	    heights: "#pallet-heights",
	    cancelBtn: ".cancel-url",
	    facilities: "#facilities",
	    editMessage: ".edit-message",
	    asnAlert: ".asn-alert",
	    shippingAlert: ".shipping-alert",
	    trailerTypes: "#trailerTypes",
	    retailerList: "#retailerList",
	    trailerNumber: ".trailer-number",
	    trailerRequired: ".trailer-mandatory-sign",
	    trailer: ".trailer",
	    checkAppointmentBtn: "#check-appointment-btn",
	    appointmentDate: "#appointment-date",
	    nxtDayMsg: "#next-day-appointment-msg",
	    oneHrMsg: "#appointment-time-1hr-msg",
	    availableMsg: "#available-appointment-msg",
	    disclaimerMsg: "#appointment-disclaimer-msg",
	    asnId: ".asn-id",
	    asnCarrier: ".asn-carrier",
	    submitBtn: ".submit-appointment-btn",
	    asnStatus: ".status",
	    loadTypeBtnToggleEl: '.load-type-btn-toggle',
	    inventorySkuBtnToggleEl: '.inventory-sku-btn-toggle',
	    appointmentSchedulerContainer: '.appointment-scheduler'
	};

/***/ },
/* 507 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    icon: 'toggle-on',
	    title: 'Cancel Selected Appointments',
	    cls: "bulk-cancel-appointment",
	    disabled: false
	  }],
	  "actions": [{
	    title: "Edit Appointment",
	    cls: "edit-appointment",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Cancel Appointment",
	    cls: "cancel-appointment",
	    icon: "ban",
	    disabled: false
	  }]
	};

/***/ },
/* 508 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var searchDropdown = exports.searchDropdown = [{
		title: "Appointment ID",
		value: "appointmentId"
	}, {
		title: "Appointment Type",
		value: "appointmentType"
	}, {
		title: "Shipment Id",
		value: "shipmentId"
	}, {
		title: "Carrier",
		value: "carrierName"
	}];

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(504);
	
	__webpack_require__(510);
	
	__webpack_require__(505);

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _actionOptions = __webpack_require__(507);
	
	var _searchDropdown = __webpack_require__(508);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _filtersutil = __webpack_require__(16);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var actionList = _actionOptions.actionOptions;
	var targerSelector = "#appointments-lookup";
	var detailLinkHTML = __webpack_require__(84);
	var statusPillRenderTemplate = __webpack_require__(1217);
	
	var modalHtml = __webpack_require__(11);
	var cancelAppointmentModalBodyHtml = __webpack_require__(291);
	var optionTemplateHtml = __webpack_require__(135);
	
	(0, _run2.default)(targerSelector, function (mainEl) {
	    var lookupData = mainEl.data("lookup-data");
	    var lookupTable = mainEl.find("#lookup-wrapper");
	    var targetObject = "";
	    var modalOpts = { backdrop: 'static', show: false };
	    var savedViews = mainEl.data("saved-view");
	    var generateExportUrl = mainEl.data("export-url");
	    var saveViewURL = mainEl.data("save-view-url");
	    var exportModal = new _filtersutil.buildExport();
	    var deleteViewURL = mainEl.data("delete-view-url");
	    var shouldCheckCache = mainEl.data("should-check-cache");
	    var extraDetailForCacheFromServer = mainEl.data("extra-detail-for-cache-from-server");
	    var criteriaObjectFromServer = mainEl.data("filter-criteria-from-server");
	    var portletNamespace = mainEl.data("portlet-namespace");
	    var filterAppointmentUrl = mainEl.data("appointment-filter-url");
	    var viewDetailUrl = mainEl.data("view-detail");
	    var cancelAppointmentUrl = mainEl.data("cancel-appointment");
	    var cancelResonList = mainEl.data("cancel-reasons");
	    var editAppointmentUrl = mainEl.data("edit-appointment");
	    var isFacilityUser = mainEl.data("isfacility-user");
	    var loggedInUser = mainEl.data("logged-in-user");
	    var isBrokerUser = mainEl.data("is-broker-user");
	    var isCarrierUser = mainEl.data("is-carrier-user");
	    var lookupColumns = void 0;
	
	    var merchantCloumns = [{
	        render: renderActionWrap,
	        orderable: false,
	        class: 'dtc-action-column',
	        title: "Actions"
	    }, {
	        data: "appointmentId",
	        title: "Appointment ID",
	        class: 'dtc-min-width-md',
	        render: createDetailLink,
	        orderable: false
	    }, {
	        data: "appointmentType",
	        title: "Appointment Type",
	        class: 'dtc-min-width-sm'
	    }, {
	        data: "scheduledArrival",
	        title: "Scheduled Arrival",
	        class: 'dtc-min-width-md'
	    }, {
	        data: "status",
	        title: "Status",
	        render: statusPillRender,
	        class: 'dtc-min-width-sm'
	    }, {
	        data: "facility",
	        title: "Facility",
	        class: 'dtc-min-width-sm'
	    }, {
	        data: "createdDate",
	        title: "Created On",
	        class: 'dtc-min-width-md',
	        render: _general.formateDateUtil
	    }, {
	        data: "createdBy",
	        title: "Created By",
	        class: 'dtc-min-width-sm'
	    }];
	
	    var facilityColumns = [{
	        render: renderActionWrap,
	        orderable: false,
	        class: 'dtc-action-column',
	        title: "Actions"
	    }, {
	        data: "appointmentId",
	        title: "Appointment ID",
	        class: 'dtc-min-width-md',
	        render: createDetailLink,
	        orderable: false
	    }, {
	        data: "appAppointmentType",
	        title: "Appointment Type",
	        class: 'dtc-min-width-sm'
	    }, {
	        data: "appPreferredArrivalDate",
	        title: "Scheduled Arrival",
	        class: 'dtc-min-width-md'
	    }, {
	        data: "appStatus",
	        title: "Status",
	        render: statusPillRender,
	        class: 'dtc-min-width-sm'
	    }, {
	        data: "appRtlId",
	        title: "Merchant(s)",
	        class: 'dtc-min-width-sm'
	    }];
	
	    if (isFacilityUser) {
	        lookupColumns = facilityColumns;
	    } else {
	        lookupColumns = merchantCloumns;
	    }
	
	    if (shouldCheckCache) {
	        targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	    }
	
	    var submitModalFlow = new _SubmitModalFlow2.default();
	    submitModalFlow.init();
	
	    function createDetailLink(data, type, row) {
	        var detailPageHTML = (0, _render2.default)(detailLinkHTML, {
	            renderURL: viewDetailUrl,
	            portletNamespace: portletNamespace,
	            id: row.appId,
	            idName: "appId",
	            displayVal: row.appointmentId
	        });
	        return detailPageHTML;
	    }
	
	    var appointmentLookup = new _index2.default({
	        target: lookupTable,
	        minWidthClass: "q-min-width-sm-til-md",
	        mobileColumns: [{
	            data: "appointmentId",
	            title: "Appointment ID",
	            render: createDetailLink
	        }, {
	            data: "appointmentType",
	            title: "Appointment Type",
	            orderable: false
	        }, {
	            data: "createdDate",
	            title: "Created On",
	            orderable: false
	        }, {
	            data: "status",
	            title: "Status",
	            orderable: false,
	            render: statusPillRender
	        }],
	
	        tableSearchInput: {
	            // Not required
	            // placeholder: 'Custom Search Text'
	            value: targetObject != "" ? targetObject.value[0] : ""
	
	        },
	        tableSearchDropdown: {
	            selected: targetObject == "" ? "" : targetObject.key,
	            columns: _searchDropdown.searchDropdown
	        },
	        savedViews: savedViews,
	        bulkSelect: false,
	        dataTable: {
	            data: lookupData.content,
	            columnDefs: [{
	                className: "custom-class", targets: [1]
	            }],
	
	            order: [[4, 'desc']],
	            columns: lookupColumns
	        },
	        paginationData: lookupData.page,
	        filterModal: {
	            // REQUIRED: Sets title of modal
	            title: "Filter Appointment",
	            // REQUIRED: Sets unique part of subtitle string.
	            tableType: "appointment"
	        },
	        onBulkSelectChange: function onBulkSelectChange() {
	            selectedRows = appointmentLookup.getBulkSelectedData();
	            $("th.dtc-action-column").html(renderActionHeaderWrap());
	            if (selectedRows.length >= 2) {
	                $(".action-header-btn .base-btn").removeClass('disabled');
	            } else {
	                $(".action-header-btn .base-btn").addClass('disabled');
	            };
	        },
	        onFetch: function onFetch() {
	            var currentData = appointmentLookup.generateData();
	            appointmentLookup.showLoadingOverlay();
	            //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	            if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	                setTimeout(function () {
	                    (0, _filtersutil.doAjax)({ url: filterAppointmentUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	                }, _constants.SUCCESS_MODAL_TIMEOUT);
	            } else if ((0, _filtersutil.isNew)(currentData)) {
	                setTimeout(function () {
	                    (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	                }, _constants.SUCCESS_MODAL_TIMEOUT);
	            } else if ((0, _filtersutil.isEdit)(currentData)) {
	                setTimeout(function () {
	                    (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	                }, _constants.SUCCESS_MODAL_TIMEOUT);
	            } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	                setTimeout(function () {
	                    (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	                }, _constants.SUCCESS_MODAL_TIMEOUT);
	            }
	        }
	    });
	
	    appointmentLookup.init();
	    var table = $("#lookup-wrapper .data-table-component").DataTable();
	
	    function renderActionWrap(data, type, row, meta) {
	        var newRender = void 0;
	        var statusTarget = actionList["actions"];
	        newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	            list: renderActionCellList(statusTarget, data, row),
	            index: meta.row
	        });
	        return newRender;
	    };
	
	    function renderActionCellList(list, data, row) {
	        var renderedList = _(list).map(function (appointments) {
	            return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, appointments));
	        });
	        return renderedList.join('');
	    };
	
	    function neededActions(data, row, appointments) {
	        var action = {};
	        var modifiyAppointment = "";
	
	        if (loggedInUser == row.userName) {
	            modifiyAppointment = "true";
	        }
	        if (appointments.title === 'Edit Appointment') {
	            if (row.status === "Canceled" || row.appointmentRetailers.length > 1 && !isFacilityUser || isBrokerUser && modifiyAppointment === "" || isCarrierUser && modifiyAppointment === "") {
	                action = {
	                    icon: appointments.icon,
	                    title: appointments.title,
	                    cls: appointments.cls,
	                    disabled: true
	                };
	            } else {
	                action = {
	                    icon: appointments.icon,
	                    title: appointments.title,
	                    cls: appointments.cls,
	                    disabled: false
	                };
	            }
	        } else if (appointments.title === 'Cancel Appointment') {
	            if (row.status === "Canceled" || row.asns.length > 1 || row.appointmentRetailers.length > 1 && !isFacilityUser || isBrokerUser && modifiyAppointment === "" || isCarrierUser && modifiyAppointment === "") {
	                action = {
	                    icon: appointments.icon,
	                    title: appointments.title,
	                    cls: appointments.cls,
	                    disabled: true
	                };
	            } else {
	                action = {
	                    icon: appointments.icon,
	                    title: appointments.title,
	                    cls: appointments.cls,
	                    disabled: false
	                };
	            }
	        } else {
	            action = {
	                icon: appointments.icon,
	                title: appointments.title,
	                cls: appointments.cls,
	                disabled: appointments.disabled
	            };
	        }
	        return action;
	    };
	
	    function statusPillRender(data, type, row) {
	        var newRender = void 0;
	        var pillClass = void 0;
	        if (data == "Scheduled") {
	            pillClass = "q-pill-white-and-blue";
	        } else {
	            pillClass = "q-pill-light-grey";
	        }
	        return newRender = (0, _render2.default)(statusPillRenderTemplate, {
	            data: data,
	            pillClass: pillClass
	        });
	    }
	
	    function renderActionHeaderWrap() {
	        var statusTarget = actionList['all'];
	        var newRender = void 0;
	        var data = "";
	        var row = "";
	        newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	            list: renderActionCellList(statusTarget, data, row)
	        });
	        return newRender;
	    };
	
	    function filterSuccessFun(data) {
	        var appointment = data.content;
	        var page = data.page;
	        appointmentLookup.setNewData(appointment);
	        appointmentLookup.setPaginationData(page);
	        (0, _filtersutil.pushFilterSessionCacheState)();
	        appointmentLookup.hideLoadingOverlay();
	        setExportData(appointmentLookup.generateData());
	    }
	
	    function errorFun(data) {
	        appointmentLookup.hideLoadingOverlay();
	    }
	
	    function savedViewSuccess(data) {
	        var appointment = data.appointmentLookup.content;
	        var page = data.appointmentLookup.page;
	        appointmentLookup.setNewData(appointment);
	        appointmentLookup.setPaginationData(page);
	        appointmentLookup.setNewSavedViewData(data.savedView, "newSavedView");
	        (0, _filtersutil.pushFilterSessionCacheState)();
	        appointmentLookup.hideLoadingOverlay();
	        setExportData(appointmentLookup.generateData());
	    }
	
	    function savedEditViewSuccess(data) {
	        var appointment = data.appointmentLookup.content;
	        var page = data.appointmentLookup.page;
	        appointmentLookup.setNewData(appointment);
	        appointmentLookup.setPaginationData(page);
	        appointmentLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	        (0, _filtersutil.pushFilterSessionCacheState)();
	        appointmentLookup.hideLoadingOverlay();
	        setExportData(appointmentLookup.generateData());
	    }
	
	    function delteViewScussFun(data) {
	        var appointment = data.appointmentLookup.content;
	        var page = data.appointmentLookup.page;
	        appointmentLookup.removeSavedView(data.target);
	        appointmentLookup.setNewData(appointment);
	        appointmentLookup.setPaginationData(page);
	        appointmentLookup.hideLoadingOverlay();
	        setExportData(appointmentLookup.generateData());
	    }
	
	    function initExport() {
	        var exportObj = {
	            title: mainEl.data("export-popup-title"),
	            exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
	            exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
	            exportMaxLimitLang: mainEl.data("export-max-row-limit")
	        };
	        exportModal.init(exportObj);
	        exportModal.bindExportEvent();
	    }
	
	    function setExportData(currentData) {
	        exportModal.buildExportBasicURL(generateExportUrl, currentData);
	        exportModal.setExportCount(currentData.totalElements);
	    }
	
	    initExport();
	    setExportData(appointmentLookup.generateData());
	
	    (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	    var cancelAppointmentModal = $((0, _render2.default)(modalHtml, {
	        title: 'Cancel Appointment',
	        modalDialogClass: 'q-modal-dialog-800',
	        leftAlignTitle: true,
	        topCloseBtn: true,
	        autoHideTop: true,
	        body: cancelAppointmentModalBodyHtml,
	        footerBtns: "<a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a><a href=\"#\" class=\"base-btn purple-btn cancel-appointment-btn-on-modal\">Cancel Appointment</a>"
	    }));
	
	    function renderReasonList() {
	        var cancelReasonOptions = cancelResonList.map(function (item) {
	            return (0, _render2.default)(optionTemplateHtml, {
	                targetKey: item.cdmValue,
	                text: item.cdmMeaning
	            });
	        });
	        return $("#cancel-reason-select").append(cancelReasonOptions.join(''));
	    }
	    $('body').append(cancelAppointmentModal);
	    cancelAppointmentModal.modal(modalOpts);
	    renderReasonList();
	
	    function showCancelModal() {
	        cancelAppointmentModal.modal('show');
	        $("#cancel-reason-select").val("").trigger('change');
	        $("#cancel-notes").val("").trigger('change');
	        $('.cancel-appointment-btn-on-modal').attr("disabled", true);
	    }
	
	    function hideCancelModal() {
	        cancelAppointmentModal.modal('hide');
	    }
	
	    function shallAllowClick(currentObj) {
	        return !$(currentObj).hasClass("disabled");
	    }
	    var appointmentIdForCancel = void 0;
	    $('body').on('click', '.cancel-appointment', function (e) {
	        e.preventDefault();
	        if (shallAllowClick(this)) {
	            var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	            var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	            row = $(".data-table-component").dataTable().api().row(parent);
	            var appointment = row.data();
	            appointmentIdForCancel = appointment.appId;
	            showCancelModal();
	        }
	    });
	
	    var row = void 0;
	    $('body').on('click', '.edit-appointment', function (e) {
	        e.preventDefault();
	        if (shallAllowClick(this)) {
	            var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	            var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	            var rowEdit = $(".data-table-component").dataTable().api().row(parent);
	            var appointment = rowEdit.data();
	            location.href = editAppointmentUrl + "&" + portletNamespace + "appId=" + appointment.appId;
	        }
	    });
	
	    $('body').on('click', '.cancel-appointment-btn-on-modal', function (e) {
	        var _data;
	
	        e.preventDefault();
	        hideCancelModal();
	        submitModalFlow.showLoadingModal();
	        var cancelReason = $("#cancel-reason-select").val();
	        var cancelNotes = $("#cancel-notes").val();
	        $.ajax({
	            url: cancelAppointmentUrl,
	            type: 'POST',
	            data: (_data = {}, _defineProperty(_data, portletNamespace + "appId", appointmentIdForCancel), _defineProperty(_data, portletNamespace + "cancelReason", cancelReason), _defineProperty(_data, portletNamespace + "cancelNotes", cancelNotes), _data),
	            success: function success(data) {
	                if (data.match("success")) {
	                    var d = row.data();
	                    d.status = "Cancelled";
	                    row.data(d).draw();
	                    submitModalFlow.hideAllModals();
	                    submitModalFlow.showSuccessModal();
	                    setTimeout(function () {
	                        submitModalFlow.hideAllModals();
	                    }, _constants.SUCCESS_MODAL_TIMEOUT);
	                } else {
	                    submitModalFlow.hideAllModals();
	                    submitModalFlow.showFailureModal();
	                }
	            },
	            error: function error(data) {
	                submitModalFlow.hideAllModals();
	            }
	        });
	    });
	
	    $('body').on('change', '#cancel-reason-select', function (e) {
	        e.preventDefault();
	        $('.cancel-appointment-btn-on-modal').attr("disabled", false);
	    });
	});

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = NewFacility;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AbilityStore = __webpack_require__(97);
	
	var _AbilityStore2 = _interopRequireDefault(_AbilityStore);
	
	var _AddressEventBus = __webpack_require__(111);
	
	var _AddressEventBus2 = _interopRequireDefault(_AddressEventBus);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _select2able = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function NewFacility() {
	  var self = this;
	  var els = {};
	  var portletNamespace = (0, _jquery2.default)("#asn-portlet-namespace").data("namespace").trim();
	  var facilityEl = (0, _jquery2.default)('#add-facility-form');
	  var addressEl = (0, _jquery2.default)('#edit-address-verification');
	  var conId = facilityEl.attr("data-conId");
	  var hc = facilityEl.attr("data-hc");
	  var countryFacList = JSON.parse(facilityEl.attr("data-countryList"));
	  var validationReqdCountries = JSON.parse(facilityEl.attr("data-validation-reqd-countries"));
	  var retState = '' + facilityEl.attr("data-ret-state");
	  var selectedPhoneCode = facilityEl.attr("data-selected-phone-code");
	  var getPhoneCodesURL = facilityEl.attr("data-phone-codes-url");
	  var countriesPhoneCodeList = JSON.parse(facilityEl.attr("data-countries-phonecode-list"));
	  var addressValidationUrl = facilityEl.attr("data-validate-address-url");
	  var addFacilityUrl = facilityEl.attr("data-add-facility-url");
	  var createAsnUrl = facilityEl.attr("data-create-asn-url");
	  var organizations = facilityEl.data("organizations");
	  var savedLocationsSelect = (0, _jquery2.default)("#" + portletNamespace + "cmrAddresses");
	  var facNameCheckUrl = facilityEl.attr("data-fac-name-check-url");
	  var facIdCheckUrl = facilityEl.attr("data-fac-id-check-url");
	  var duplicateCadLocationNameMessage = facilityEl.attr("data-duplicate-location-name-message");
	  var duplicateAddressIdMessage = facilityEl.attr("data-duplicate-address-id-message");
	  var submitModal = new _SubmitModalFlow2.default();
	
	  var addValResponse = {};
	
	  var elementsMap = {
	    facilityModal: '#asn-wizard-add-facility-Modal',
	    submitThisAddressBtn: '#submit-edit-returned-address',
	    addFacilityCountrySelect: '#countryOrigin',
	    facilityAddress1: '#rad-address-1',
	    facilityAddress2: '#rad-address-2',
	    facilityCity: '#rad-city',
	    facilityZipCode: '#rad-zip-code',
	    addFacilityCancelBtn: '#facility-cancel-btn',
	    facilityContactName: '#rma-first-name',
	    facilityPhoneCode: '#rad-country-code',
	    facilityPhone: '#rad-phone',
	    facilityEmail: '#rad-email-address',
	    facilityName: '#rad-facility-name',
	    facilityId: '#rad-return-address-id',
	    facilityStateDropDown: '#edit-retailer-basic-state',
	    facilityStateText: '#edit-retailer-basic-stateText',
	    facilityStateTextWrapper: '.edit-retailer-basic-stateText-wrapper',
	    facilityStateWrapper: '.edit-retailer-basic-state-wrapper',
	    orgNameSelect: "#orgName",
	    proximityReturnCenter: "#proximity-return-center",
	    manualReturnCenter: "#manual-return",
	    partnerFacility: "#partner-facility",
	    redAlert: ".q-alert-red",
	    stateLabel: '#state-label',
	    postalCodeLabel: ".asn-dest-facility-postal-code_required"
	  };
	
	  var addressElementsMap = {
	    addressEntered: '#div-address-enetered',
	    enteredAddressRadio: '#radio-use-entered-address',
	    enteredAddressText: '#edit-ret-address-entered',
	    addressReturned: '#div-address-returned',
	    returnedAddressRadio: '#radio-returned-address',
	    returnedAddressText: '#edit-ret-address-returned',
	    invalidAddress: '#div-address-returned-empty',
	    invalidAddressText: '#edit-ret-address-returned-not-found',
	    modifyAddressBtn: '#modify-edit-returned-address'
	  };
	
	  var domVarsEditRetAdd = {
	    form: (0, _jquery2.default)("#add-facility-form"),
	    validateAddress: (0, _jquery2.default)("#edit-ret-address-verification")
	  };
	
	  var validationCustomMessages = {
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        (0, _jquery2.default)(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  };
	
	  var EditRetAddressObj = {
	    init: function init() {
	      domVarsEditRetAdd.form.validate(validationCustomMessages);
	    }
	  };
	
	  self.init = function () {
	    //Handle focus issue on Select2 in bootstrap modal
	    //https://stackoverflow.com/questions/18487056/select2-doesnt-work-when-embedded-in-a-bootstrap-modal/19574076#19574076
	    _jquery2.default.fn.modal.Constructor.prototype.enforceFocus = function () {};
	
	    EditRetAddressObj.init();
	    setElements();
	    setMasks();
	    bindElements();
	    onLoad();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, facilityEl);
	    (0, _selectorHelpers.setElementsFromScope)(els, addressElementsMap, addressEl);
	  }
	
	  function bindElements() {
	
	    els.modifyAddressBtn.click(function (e) {
	      e.preventDefault();
	      addressEl.modal('hide');
	      (0, _jquery2.default)(elementsMap.facilityModal).modal('show');
	    });
	
	    domVarsEditRetAdd.validateAddress.click(function (e) {
	      e.preventDefault();
	      var form = facilityEl;
	      if (form.valid() && !form.find('.dup-facName').is(':visible') && !form.find('.dup-facId').is(':visible')) {
	        if (checkAsnFacilityTypes()) {
	          validateAddressModal();
	        } else {
	          els.redAlert.show();
	          window.location.hash = "facility-type-section";
	        }
	      }
	    });
	
	    (0, _jquery2.default)(elementsMap.submitThisAddressBtn).click(function (e) {
	      e.preventDefault();
	      submitAddFacility();
	    });
	
	    els.addFacilityCancelBtn.click(function (e) {
	      e.preventDefault();
	      resetNewFacilityForm();
	      (0, _jquery2.default)(elementsMap.facilityModal).modal('hide');
	    });
	
	    els.addFacilityCountrySelect.on("change", countryChange);
	    els.facilityPhoneCode.on("change", phoneCodeChange);
	    els.partnerFacility.on("change", handleChangeForRedAlert);
	    facilityEl.on("blur", ".facility-name", validateFacilityName);
	    facilityEl.on("blur", ".facility-id", validateFacilityId);
	  }
	  //duplicate facility name check
	  function validateFacilityName() {
	    var facName = facilityEl.find(".facility-name").val();
	    _jquery2.default.ajax({
	      async: false,
	      data: _defineProperty({}, portletNamespace + 'facName', facName),
	      url: facNameCheckUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        if (data.response == true) {
	          facilityEl.find('.dup-facName').show();
	        } else {
	          facilityEl.find('.dup-facName').hide();
	        }
	      }
	    });
	  }
	
	  function validateFacilityId() {
	    var facId = facilityEl.find(".facility-id").val();
	    _jquery2.default.ajax({
	      async: false,
	      data: _defineProperty({}, portletNamespace + 'facId', facId),
	      url: facIdCheckUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        if (data.response == true) {
	          facilityEl.find('.dup-facId').show();
	        } else {
	          facilityEl.find('.dup-facId').hide();
	        }
	      }
	    });
	  }
	
	  function setMasks() {
	    (0, _jquery2.default)('.phone-number').attr("placeholder", "(___) ___-____");
	    (0, _jquery2.default)('.phone-number').inputmask({
	      mask: "(999) 999-9999"
	    });
	  }
	
	  function setUnMasks() {
	    (0, _jquery2.default)('.phone-number').attr("placeholder", "");
	    (0, _jquery2.default)('.phone-number').inputmask({
	      mask: ""
	    });
	  }
	
	  function onLoad() {
	    els.redAlert.hide();
	    (0, _jquery2.default)(organizations).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.orgId).text(this.orgName);
	      els.orgNameSelect.append(option);
	    });
	
	    els.partnerFacility.prop('checked', true);
	
	    (0, _jquery2.default)(countryFacList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conId).text(this.conName);
	      els.addFacilityCountrySelect.append(option);
	    });
	
	    (0, _jquery2.default)(countriesPhoneCodeList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      if (this.conPhoneCode === '+1') {
	        if (els.facilityPhoneCode.find('option[value="' + this.conPhoneCode + '"]').length == 0) {
	          option.attr('value', this.conPhoneCode).text("United States of America/Canada +1");
	        }
	      } else {
	        option.attr('value', this.conPhoneCode).text(this.conPhoneText);
	      }
	      els.facilityPhoneCode.append(option);
	    });
	
	    els.addFacilityCountrySelect.find('option[value=' + conId + ']').prop('selected', 'selected').trigger('change');
	    print_state('edit-retailer-basic-state', conId);
	    if (retState != null && retState != '' && (conId == "1" || conId == "2")) {
	      els.facilityStateTextWrapper.hide();
	      els.facilityStateDropDown.attr('name', 'cadState');
	      els.facilityStateDropDown.find('option[value=' + retState + ']').prop('selected', 'selected').trigger('change');
	      els.facilityStateDropDown.addClass("required");
	    } else if ((retState == null || retState == '') && (conId == "1" || conId == "2")) {
	      els.facilityStateTextWrapper.hide();
	      els.facilityStateDropDown.attr('name', 'cadState');
	      els.facilityStateDropDown.addClass("required");
	    } else if (conId != "1" || conId != "2") {
	      els.facilityStateTextWrapper.show();
	      els.facilityStateWrapper.hide();
	      els.facilityStateText.val(retState);
	      els.facilityStateDropDown.attr('name', 'notrequiredradState');
	      els.facilityStateText.attr('name', 'cadState');
	      els.facilityStateDropDown.removeClass("required");
	      els.facilityStateText.addClass("required");
	      /*$(".edit-retailer-basic-stateText").val(retState);*/
	    }
	
	    (0, _select2able.instantiateSelect2)(facilityEl.find('.select2-select'));
	
	    var countryVal = els.addFacilityCountrySelect.find('option:selected').val();
	    var isValidCountry = false;
	    var countryValue = '';
	    (0, _jquery2.default)(countryFacList).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        countryValue = this.conCode;
	        return false;
	      }
	    });
	    (0, _jquery2.default)(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryValue.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (isValidCountry) {
	      (0, _jquery2.default)(".country_not_supported").hide();
	    } else {
	      (0, _jquery2.default)(".country_not_supported").show();
	    }
	  }
	
	  function validateAddressModal() {
	    (0, _jquery2.default)(elementsMap.facilityModal).modal('hide');
	    var form = facilityEl;
	    var state = '';
	    var countryVal = els.addFacilityCountrySelect.find('option:selected').val();
	    if (els.addFacilityCountrySelect.val() == '1' || els.addFacilityCountrySelect.val() == '2') {
	      state = els.facilityStateDropDown.val();
	    } else {
	      state = els.facilityStateText.val();
	    }
	    var isValidCountry = false;
	    var countryValue = '';
	    (0, _jquery2.default)(countryFacList).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        countryValue = this.conCode;
	        return false;
	      }
	    });
	    (0, _jquery2.default)(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryValue.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    // Call if address details has been changed
	    if (form.valid()) {
	      if (isValidCountry) {
	        var _data3;
	
	        _jquery2.default.ajax({
	          url: addressValidationUrl,
	          type: "POST",
	          data: (_data3 = {}, _defineProperty(_data3, portletNamespace + 'cadAddress1', els.facilityAddress1.val()), _defineProperty(_data3, portletNamespace + 'cadAddress2', els.facilityAddress2.val()), _defineProperty(_data3, portletNamespace + 'cadCity', els.facilityCity.val()), _defineProperty(_data3, portletNamespace + 'cadState', state), _defineProperty(_data3, portletNamespace + 'cadZipcode', els.facilityZipCode.val()), _defineProperty(_data3, portletNamespace + 'cadCountry', countryValue), _data3),
	          beforeSend: function beforeSend() {
	            _jquery2.default.blockUI({ message: 'Validating Address, Please Wait..' });
	          },
	          complete: function complete() {
	            _jquery2.default.unblockUI();
	          },
	          success: function success(data, textStatus, jqXHR) {
	            addValResponse = _jquery2.default.parseJSON(data);
	            if (addValResponse.result == true) {
	              EditChecker.setPageClean();
	              els.addressReturned.css("display", "");
	              els.invalidAddress.css("display", "none");
	              els.invalidAddressText.css("display", "none");
	              els.returnedAddressRadio.prop('checked', true);
	              els.enteredAddressRadio.prop('checked', false);
	              els.returnedAddressRadio.show();
	              checkSubmitAddressForm(addValResponse);
	            } else {
	              els.addressReturned.css("display", "none");
	              els.invalidAddress.css("display", "");
	              els.invalidAddressText.css("display", "");
	              els.invalidAddressText.html('Unable to find a validated address');
	              els.returnedAddressRadio.hide();
	              els.returnedAddressRadio.prop('checked', true);
	              els.enteredAddressRadio.prop('checked', false);
	              checkSubmitAddressForm(addValResponse);
	            }
	          }
	        });
	      } else {
	        submitAddFacility(false);
	      }
	    }
	  }
	
	  function checkSubmitAddressForm(addValResponse) {
	    els.enteredAddressText.html(addValResponse.enteredAdd);
	    els.returnedAddressText.html(addValResponse.returnedAdd);
	    addressEl.modal('show');
	  }
	
	  function phoneCodeChange() {
	    var phonecode = els.facilityPhoneCode.val().toString();
	    if (phonecode === '+1') {
	      setMasks();
	    } else {
	      setUnMasks();
	      (0, _jquery2.default)('.phone-number').val('');
	    }
	  }
	
	  function countryChange() {
	    var countryVal = els.addFacilityCountrySelect.find('option:selected').val();
	    if (countryVal != null && countryVal != '' && countryVal != '0') {
	      _jquery2.default.ajax({
	        url: getPhoneCodesURL,
	        type: "POST",
	        //dataType: "json",
	        data: _defineProperty({}, portletNamespace + 'countryVal', countryVal),
	        success: function success(data) {
	          var jsonData = JSON.parse(data);
	          if (jsonData.response == "success") {
	            var phoneCodesList = jsonData.phoneCodes;
	            (0, _jquery2.default)(phoneCodesList).each(function () {
	              if (this.conPhoneCode === '+1') {
	                els.facilityPhoneCode.find('option[value="' + this.conPhoneCode + '"]').prop('selected', 'selected').trigger('change');
	              } else {
	                els.facilityPhoneCode.find('option:contains(' + this.conPhoneText + ')').prop('selected', 'selected').trigger('change');
	              }
	              return;
	            });
	          }
	        }
	      });
	    }
	
	    var isValidCountry = false;
	    var countryValue = '';
	    (0, _jquery2.default)(countryFacList).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        countryValue = this.conCode;
	        return false;
	      }
	    });
	
	    var checkZipCode = false;
	    (0, _jquery2.default)(countryFacList).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired === 'Y') {
	          checkZipCode = true;
	        }
	      }
	    });
	
	    if (checkZipCode) {
	      els.facilityZipCode.prop('required', true);
	      els.postalCodeLabel.text('Postal Code *');
	      els.facilityZipCode.addClass("required");
	    } else {
	      els.facilityZipCode.removeClass("zipcodeUS");
	      els.facilityZipCode.removeClass("required");
	      els.facilityZipCode.prop('required', false);
	      els.postalCodeLabel.text('Postal Code');
	    }
	    (0, _jquery2.default)(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryValue.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (isValidCountry) {
	      (0, _jquery2.default)(".country_not_supported").hide();
	    } else {
	      (0, _jquery2.default)(".country_not_supported").show();
	    }
	
	    if (countryVal == "1" || countryVal == "2") {
	      setMasks();
	      els.stateLabel.text('State/Province/Region *');
	      els.facilityStateTextWrapper.hide();
	      els.facilityStateText.attr('name', 'notrequiredradState');
	      els.facilityStateText.val("");
	      els.facilityStateWrapper.show();
	      els.facilityStateDropDown.attr('name', 'cadState');
	      print_state('edit-retailer-basic-state', this.selectedIndex);
	      if (countryVal == "1") {
	        els.facilityZipCode.addClass("zipcodeUS");
	      } else {
	        els.facilityZipCode.removeClass("zipcodeUS");
	      }
	    } else {
	      setUnMasks();
	      (0, _jquery2.default)('.phone-number').val('');
	      els.stateLabel.text('State/Province/Region');
	      els.facilityStateTextWrapper.show();
	      els.facilityStateText.attr('name', 'cadState');
	      els.facilityStateWrapper.hide();
	      els.facilityStateDropDown.attr('name', 'notrequiredradState');
	      els.facilityStateDropDown.val("");
	      els.facilityZipCode.removeClass("zipcodeUS");
	    }
	  };
	
	  function submitAddFacility() {
	    var _dataObj;
	
	    var validationReqdCountries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    addressEl.modal('hide');
	    var state = '';
	    var index = 0;
	
	    if (els.addFacilityCountrySelect.val() == '1' || els.addFacilityCountrySelect.val() == '2') {
	      state = els.facilityStateDropDown.find('option:selected').val();
	    } else {
	      state = els.facilityStateText.val();
	    }
	
	    if (els.returnedAddressRadio.is(":checked") && validationReqdCountries) {
	      els.facilityAddress1.val(addValResponse.returnedAddress1);
	      els.facilityAddress2.val(addValResponse.returnedAddress2);
	      els.facilityCity.val(addValResponse.returnedCity);
	      els.facilityZipCode.val(addValResponse.returnedZip);
	    }
	
	    var dataObj = (_dataObj = {}, _defineProperty(_dataObj, portletNamespace + 'cadId', 0), _defineProperty(_dataObj, portletNamespace + 'cadLocationName', els.facilityName.val()), _defineProperty(_dataObj, portletNamespace + 'cadAddressId', els.facilityId.val()), _defineProperty(_dataObj, portletNamespace + 'cadAddress1', els.facilityAddress1.val()), _defineProperty(_dataObj, portletNamespace + 'cadAddress2', els.facilityAddress2.val()), _defineProperty(_dataObj, portletNamespace + 'cadCity', els.facilityCity.val()), _defineProperty(_dataObj, portletNamespace + 'cadState', state), _defineProperty(_dataObj, portletNamespace + 'cadZipcode', els.facilityZipCode.val()), _defineProperty(_dataObj, portletNamespace + 'cadCountry', els.addFacilityCountrySelect.val()), _defineProperty(_dataObj, portletNamespace + 'cadContactName', els.facilityContactName.val()), _defineProperty(_dataObj, portletNamespace + 'cadContactCountryPhoneCode', els.facilityPhoneCode.val()), _defineProperty(_dataObj, portletNamespace + 'cadContactPhone', els.facilityPhone.val()), _defineProperty(_dataObj, portletNamespace + 'cadContactEmail', els.facilityEmail.val()), _defineProperty(_dataObj, portletNamespace + 'organization.orgId', els.orgNameSelect.val()), _dataObj);
	
	    if (!els.orgNameSelect.val()) {
	      dataObj[portletNamespace + 'organization.orgId'] = '0';
	    }
	
	    if (els.proximityReturnCenter.prop('checked')) {
	      dataObj[portletNamespace + 'cmrAddressAttributes[' + index + '].caaKey'] = els.proximityReturnCenter.val();
	      dataObj[portletNamespace + 'cmrAddressAttributes[' + index + '].caaValue'] = "RC";
	      index = index + 1;
	    }
	
	    if (els.manualReturnCenter.prop('checked')) {
	      dataObj[portletNamespace + 'cmrAddressAttributes[' + index + '].caaKey'] = els.manualReturnCenter.val();
	      dataObj[portletNamespace + 'cmrAddressAttributes[' + index + '].caaValue'] = "MR";
	      index = index + 1;
	    }
	
	    if (els.partnerFacility.prop('checked')) {
	      dataObj[portletNamespace + 'cmrAddressAttributes[' + index + '].caaKey'] = els.partnerFacility.val();
	      dataObj[portletNamespace + 'cmrAddressAttributes[' + index + '].caaValue'] = "PF";
	    }
	
	    _jquery2.default.ajax({
	      url: addFacilityUrl,
	      type: "POST",
	      data: dataObj,
	      beforeSend: function beforeSend() {
	        submitModal.init();
	        submitModal.showLoadingModal();
	      },
	      success: function success(data, textStatus, jqXHR) {
	        var response = _jquery2.default.parseJSON(data);
	        EditChecker.setPageClean();
	        submitModal.showSuccessModal();
	
	        var savedLocationsList = response.cmrAddresses;
	        //let cmrAddresses = data;
	        savedLocationsSelect.empty();
	        (0, _jquery2.default)(savedLocationsList).each(function () {
	          var option = (0, _jquery2.default)('<option />');
	          option.attr('value', this.cadId).text(this.cadLocationName);
	          savedLocationsSelect.append(option);
	        });
	        var senderAddress = savedLocationsList.filter(function (obj) {
	          return obj.cadId == response.facilityId;
	        })[0];
	        (0, _jquery2.default)('#' + portletNamespace + 'cadId').val(response.facilityId);
	        savedLocationsSelect.data('options', savedLocationsList);
	        savedLocationsSelect.val(response.facilityId).trigger('change');
	
	        setTimeout(function () {
	          submitModal.hideAllModals();
	        }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	
	        resetNewFacilityForm();
	      },
	      error: function error() {
	        submitModal.showFailureModal();
	      }
	    });
	  }
	
	  function handleChangeForRedAlert() {
	    if (checkAsnFacilityTypes()) {
	      els.redAlert.hide();
	    }
	  }
	
	  function checkAsnFacilityTypes() {
	    var asnFacilityTypeFlag = false;
	    if (els.partnerFacility.prop('checked')) {
	      asnFacilityTypeFlag = true;
	    }
	    return asnFacilityTypeFlag;
	  }
	
	  function resetNewFacilityForm() {
	    //reset input values
	    facilityEl.find('input:text').val('');
	    facilityEl.find('label.error').hide();
	    facilityEl.find('.dup-facName').hide();
	    facilityEl.find('.dup-facId').hide();
	    //reset checkbox values
	    els.proximityReturnCenter.prop('checked', false);
	    els.manualReturnCenter.prop('checked', false);
	    els.partnerFacility.prop('checked', true);
	    //reset the drop down values
	    els.orgNameSelect.val("").trigger('change');
	    els.addFacilityCountrySelect.val("1").trigger('change');
	  }
	}

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LocationTab;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AbilityStore = __webpack_require__(97);
	
	var _AbilityStore2 = _interopRequireDefault(_AbilityStore);
	
	var _AddressEventBus = __webpack_require__(111);
	
	var _AddressEventBus2 = _interopRequireDefault(_AddressEventBus);
	
	var _Facility = __webpack_require__(511);
	
	var _Facility2 = _interopRequireDefault(_Facility);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function LocationTab(wizard) {
	  var self = this;
	  var portletNamespace = (0, _jquery2.default)("#asn-portlet-namespace").data("namespace").trim();
	  var savedLocationsSelect = (0, _jquery2.default)("#" + portletNamespace + "cmrAddresses");
	  var savedLocationsList = savedLocationsSelect.data('options');
	  var saveLocationUrl = (0, _jquery2.default)("#create-asn-form").data("save-location-url");
	  var asnId = (0, _jquery2.default)("#create-asn-form").data("asn-id");
	  var asnCadId = (0, _jquery2.default)("#create-asn-form").data("asn-cad-id");
	  var asnFacId = (0, _jquery2.default)("#create-asn-form").data("asn-fac-id");
	  var wizardEl = (0, _jquery2.default)("#create-asn-form");
	  var tab = wizardEl.find(".location-tab");
	  var originFacAddress = tab.find("#origin-fac-address");
	  var originFacAddressWrapper = tab.find("#origin-fac-address-wrapper");
	  var destFacAddressWrapper = tab.find("#dest-fac-address-wrapper");
	  var destFacAddress = tab.find("#dest-fac-address");
	  var facUsesList = tab.find("#fac-uses-list");
	  var allSelects = tab.find("select");
	  var addNewFacility = tab.find("#add-new-facility");
	  var countries = (0, _jquery2.default)("#create-asn-form").data("countries");
	  var isManufacturerUser = wizardEl.data("is-manufacturer-user");
	
	  var facilitiesSelect = (0, _jquery2.default)("#" + portletNamespace + "facilities");
	  var facilitiesList = facilitiesSelect.data('options');
	
	  self.init = function () {
	    var MyNewFacility = new _Facility2.default();
	    MyNewFacility.init();
	  };
	
	  if (isManufacturerUser) {
	    addNewFacility.hide();
	  }
	
	  (0, _jquery2.default)(savedLocationsList).each(function () {
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', this.cadId).text(this.cadLocationName);
	    savedLocationsSelect.append(option);
	  });
	
	  (0, _jquery2.default)(facilitiesList).each(function () {
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', this.facId).text(this.facName);
	    facilitiesSelect.append(option);
	  });
	
	  (0, _jquery2.default)(savedLocationsSelect).change(function () {
	    var selectedValue = this.value;
	    var senderAddress = savedLocationsSelect.data('options').filter(function (obj) {
	      return obj.cadId == selectedValue;
	    })[0];
	    //show address
	    var asnWithPallet = _AsnStore2.default.getOrCreateAsnWithShippingMethod("pallet");
	    var asnWithParcel = _AsnStore2.default.getOrCreateAsnWithShippingMethod("parcel");
	    originFacAddressWrapper.hide();
	    originFacAddress.html('');
	    if (senderAddress != null) {
	      (0, _jquery2.default)("#" + portletNamespace + "cadId").val(senderAddress.cadId);
	      originFacAddress.append("<div>" + senderAddress.cadAddress1 + "</div>");
	      if (senderAddress.cadAddress2 != null) {
	        originFacAddress.append("<div>" + senderAddress.cadAddress2 + "</div>");
	      }
	      originFacAddress.append("<div>");
	      if (senderAddress.cadCity != null) {
	        originFacAddress.append(senderAddress.cadCity);
	      }
	      if (senderAddress.cadState != null) {
	        originFacAddress.append("," + senderAddress.cadState);
	      }
	      if (senderAddress.cadZipcode != null) {
	        originFacAddress.append("," + senderAddress.cadZipcode);
	      }
	      originFacAddress.append("</div>");
	
	      var asn = getAsn();
	      if (senderAddress.cadCountry != "US") {
	        asn.isInternaltional = true;
	      } else {
	        asn.isInternaltional = false;
	      }
	      _AsnStore2.default.updateObjectAndEmit(asn.id, asn);
	
	      (0, _jquery2.default)(countries).each(function () {
	        if (this.conCode == senderAddress.cadCountry) {
	          originFacAddress.append("<div data-concode='" + this.conCode + "'>" + this.conName + "</div>");
	          return;
	        }
	      });
	      originFacAddressWrapper.show();
	    }
	  });
	
	  (0, _jquery2.default)(facilitiesSelect).change(function () {
	    var selectedFacility = this.value;
	    var facility = facilitiesList.filter(function (obj) {
	      return obj.facId == selectedFacility;
	    })[0];
	    //show address
	    destFacAddressWrapper.hide();
	    destFacAddress.html('');
	    if (facility != null) {
	      (0, _jquery2.default)("#" + portletNamespace + "facId").val(facility.facId);
	      destFacAddress.append("<div>" + facility.facAddressLine1 + "</div>");
	      if (facility.facAddressLine2 != null) {
	        destFacAddress.append("<div>" + facility.facAddressLine2 + "</div>");
	      }
	
	      //destFacAddress.append("<div>"+facility.facCity+", "+facility.facState+" "+facility.facZipcode+"</div>");
	
	      destFacAddress.append("<div>");
	
	      if (facility.facCity != null) {
	        destFacAddress.append(facility.facCity);
	      }
	
	      if (facility.facState != null) {
	        destFacAddress.append("," + facility.facState);
	      }
	
	      if (facility.facZipcode != null) {
	        destFacAddress.append("," + facility.facZipcode);
	      }
	      destFacAddress.append("</div>");
	      //show facility/fulfillment uses
	      facUsesList.html("");
	      facUsesList.append("<div class='q-boldest'>Facility Uses:</div>");
	      var facilityUses = false;
	      if (facility.attributes != null && facility.attributes.length > 0) {
	        _jquery2.default.each(facility.attributes[0], function (key, value) {
	          if (key == "IN" && value == true) {
	            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>International Fulfillment Center</span> ");
	            facilityUses = true;
	          } else if (key == "FC" && value == true) {
	            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Fulfillment Center</span> ");
	            facilityUses = true;
	          } else if (key == "DC" && value == true) {
	            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Distribution Center</span> ");
	            facilityUses = true;
	          } else if (key == "RC" && value == true) {
	            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Returns Center</span> ");
	            facilityUses = true;
	          }
	        });
	        if (!facilityUses) {
	          facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
	        }
	      } else {
	        facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
	      }
	      destFacAddressWrapper.show();
	    }
	  });
	
	  addNewFacility.click(function () {
	    (0, _jquery2.default)("#asn-wizard-add-facility-Modal").modal('show');
	  });
	
	  if (asnId != null && asnId > 0) {
	    savedLocationsSelect.val(asnCadId);
	    savedLocationsSelect.trigger('change');
	    determineDisabledInputs();
	    facilitiesSelect.prop('disabled', true);
	    facilitiesSelect.val(asnFacId).trigger('change');
	  } else {
	    facilitiesSelect.trigger('change');
	  }
	
	  function determineDisabledInputs() {
	    var disabled = !_AbilityStore2.default.ask("canEditGtlAsn");
	    var inputs = (0, _selectorHelpers.combineElements)([savedLocationsSelect, facilitiesSelect, addNewFacility]);
	    inputs.attr('disabled', disabled);
	    allSelects.trigger("change.select2");
	    if (disabled) {
	      addNewFacility.unbind('click');
	    }
	  }
	
	  function getAsn() {
	    if (isPallet()) return _AsnStore2.default.getOrCreateAsnWithShippingMethod("pallet");else return _AsnStore2.default.getOrCreateAsnWithShippingMethod("parcel");
	  }
	
	  function getShippingMethod() {
	    return _AsnStore2.default.getShippingMethod();
	  }
	
	  function isParcel() {
	    return getShippingMethod() === 'parcel';
	  }
	
	  function isPallet() {
	    return getShippingMethod() === 'pallet';
	  }
	}

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CsvErrors;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	  Base file for stub.
	  This is where all the actual stub code will go.
	*/
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	function CsvErrors(targetSelector, data) {
	  var self = this;
	  var errorData = data;
	  var entryEl = $("<div class='entry-point'></div>");
	  var mainHtml = (0, _render2.default)(__webpack_require__(1218));
	  var mainEl = $(mainHtml);
	  entryEl.append(mainEl);
	  // END: REQUIRED TO LOAD STUB
	
	  var elTable = mainEl.find(".csv-error-list");
	  var csvErrorDataTable = void 0;
	
	  self.init = function () {
	    initTable();
	  };
	
	  function initTable() {
	    csvErrorDataTable = elTable.dataTable({
	      data: getTableData(),
	      searching: false,
	      paging: false,
	      info: false,
	      ordering: false,
	      columnDefs: [{ "targets": [0], "width": "10%" }, { "targets": [1], "width": "20%" }, { "targets": [2], "width": "25%" }, { "targets": [3], "width": "45%" }],
	      columns: [{
	        data: "line"
	      }, {
	        data: "column"
	      }, {
	        data: "valueEntered"
	      }, {
	        data: "errorDetails"
	      }]
	    });
	  }
	
	  function getTableData() {
	    return errorData;
	  }
	
	  self.getErrorHtml = function () {
	    return entryEl;
	  };
	};

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = PackingTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _AbilityStore = __webpack_require__(97);
	
	var _AbilityStore2 = _interopRequireDefault(_AbilityStore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _QuickFileUploader = __webpack_require__(85);
	
	var _CsvErrors = __webpack_require__(513);
	
	var _CsvErrors2 = _interopRequireDefault(_CsvErrors);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _ProductItemStore = __webpack_require__(65);
	
	var _ProductItemStore2 = _interopRequireDefault(_ProductItemStore);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	var modalHtml = __webpack_require__(11);
	var uploadPackingInfoModalBodyHtml = __webpack_require__(1223);
	var packingDetailsInfoModalBodyHtml = __webpack_require__(1219);
	var packingDetailsTemplateHtml = __webpack_require__(1222);
	var packingDetailsListTemplateHtml = __webpack_require__(1221);
	var packingDetailsInfoModalProdList = __webpack_require__(1220);
	
	var elementsMap = {
	  uploadPackingDetailsBtn: ".upload-packing-details-btn",
	  managePackingDetailsBtn: ".manage-packing-details-btn",
	  downloadCsvBtn: '.download-template-btn',
	  editOneBtn: ".asn-packing-details-container .edit-one-btn",
	  removeOneBtn: ".asn-packing-details-container .remove-one-btn",
	  removeAllBtn: ".remove-all-btn",
	  removeOneConfirmOnModalBtn: ".remove-one-confirm-on-modal-btn",
	  removeAllConfirmOnModalBtn: ".remove-all-confirm-on-modal-btn",
	  asnPackingMethod: ".shipping-method-toggler",
	  packingDetailsContainer: ".asn-packing-details-container",
	  packingExpDate: ".packing-exp-date",
	  packingDetailsInfoModalProdList: ".packing-details-info-modal-prod-list",
	  packingMethod: '#asn-packing-method',
	  uploadPackingDetailsSection: '.upload-csv-section',
	  noPackingTypeSection: ".if-no-packing-type-chosen",
	  parcelPrompt: ".if-case-packing-type-chosen",
	  palletPrompt: ".if-pallet-packing-type-chosen",
	  addNewCaseBtn: ".add-new-case-button",
	  addNewPalletBtn: ".add-new-pallet-button",
	  parcelCasesSection: ".parcel-cases-section",
	  palletCasesSection: ".pallet-cases-section",
	  savePackingInfoBtn: ".save-packing-info-btn",
	  packingTypeName: ".packing-type-name",
	  numberOfCasesOrPallets: ".number-of-cases-or-pallets",
	  customCaseOrPalletIdsFlag: ".custom-case-or-pallet-ids-flag",
	  customCaseOrPalletIdsList: ".custom-case-or-pallet-ids-list",
	  //skuTypeAhead: ".sku-typeahead",
	  beforeUserAddsProduct: ".before-user-adds-product",
	  productRowNumber: ".product-row-number",
	  asnDetailRowId: ".asn-detail-row-id",
	  closeBtn: ".close-btn",
	  unitsPerCase: ".units-per-case",
	  warningCaseOrPalletIdsSizeSection: ".warning-case-ids-size-section",
	  customCaseOrPalletIdsListSection: ".custom-case-or-pallet-ids-list-section",
	  expDateInput: ".packing-exp-date",
	  lotNumber: ".lot-number",
	  caseOrPalletModalForm: ".case-or-pallet-modal-form",
	  productItemLookup: "#product-item-lookup",
	  printPackingSlipFlag: ".print-packing-slip-flag",
	  duplicateLpnFlag: ".warning-lpn-dulicate-section",
	  lengthLpnFlag: ".warning-lpn-length-section"
	};
	
	var elsFileModalMap = {
	  loadingSpinner: '.loading-btn',
	  uploadSuccessMessage: '.upload-success',
	  uploadInvalidFileExtMessage: '.upload-file-ext-error',
	  uploadOverwriteMessage: '.upload-overwrite-data',
	  uploadIncorrectMessage: '.upload-incorrect-template',
	  uploadFileError: '.upload-file-errors',
	  uploadFileErrorListBtn: '.upload-file-errors-btn',
	  uploadApplybtn: '.confirm-btn',
	  uploadFileBtn: '.upload-file-btn',
	  uploadFileInput: '.qfu-file-input',
	  uploadFileTextInput: ".qfu-file-text-input",
	  fileUploader: ".file-uploader",
	  fileUploadForm: ".lpn-csv-upload-form"
	};
	
	function PackingTab(wizard) {
	  var self = this;
	  var els = {};
	  var wizardElement = wizard.getWizardElement();
	  var packingTabElement = wizardElement.find('.packing-tab');
	  var uploadCsvUrl = wizardElement.data("upload-csv-url");
	  var errorListPageUrl = wizardElement.data("error-list-page-url");
	  var asnValue = wizardElement.data("asn-id");
	  var submitModal = new _SubmitModalFlow2.default();
	  var productLookUpURL = wizardElement.data('product-lookup-url');
	  var searchItemURL = wizardElement.data('search-item-url');
	  var getItemsBySkusUrl = wizardElement.data('get-items-by-skus-url');
	  var packingEntryPointElement = packingTabElement.find('.packing-tab-inner-entry-point');
	  var validateLpnUrl = wizardElement.data("validate-lpn-url");
	
	  var fileUploaderEl = void 0;
	  var quickFileUploaderInstance = void 0;
	  var csvErrors = void 0,
	      errorData = void 0,
	      validatedData = void 0;
	  var fileValidator = void 0,
	      caseOrPalletFormValidator = void 0;
	  var editCaseOrPallet = false;
	
	  var packingDetailsContainer = packingEntryPointElement.find(elementsMap.packingDetailsContainer);
	  var packingDetailsInfoModalProdListContainer = void 0;
	  var currentCaseOrPalletIds = void 0,
	      currentViewingCaseOrPalletLineNumber = void 0;
	  var currentProducts = void 0;
	  //let skuTypeAhead = $();
	  // modal definitions
	  var removeOneModal = void 0,
	      removeAllModal = void 0,
	      uploadPackingDetailsModal = void 0,
	      packingDetailsInfoModal = void 0;
	
	  var upperCasePacking = void 0,
	      lowerCasePacking = void 0;
	
	  self.init = function () {
	    // set default store information, if not available
	    var shouldSelectPallet = !!getDefaultShippingMethod("pallet");
	    if (shouldSelectPallet) {
	      upperCasePacking = "Pallet";
	      lowerCasePacking = "pallet";
	    } else {
	      upperCasePacking = "Case";
	      lowerCasePacking = "case";
	    }
	
	    attachWidgets();
	    setElements();
	    if (canEditGtlAsn()) {
	      bindElements();
	    }
	    bindStores();
	    setValidator();
	
	    //Trigger the shipping method change in store to generate all the tab views
	    if (shouldSelectPallet) {
	      _AsnStore2.default.selectPallet();
	    } else {
	      _AsnStore2.default.selectParcel();
	    }
	    buildProductItemStore();
	    assignDefualtPrintPackingSlip();
	  };
	
	  function assignDefualtPrintPackingSlip() {
	    var asn = _AsnStore2.default.getAsnWithShippingMethod();
	    if (asn.status == "New") {
	      asn.printPackingSlipFlag = true;
	    } else {
	      (0, _instantiateSwitchery.instantiateSwitchery)(els.printPackingSlipFlag, {});
	      (0, _instantiateSwitchery.setSwitchery)(els.printPackingSlipFlag, asn.printPackingSlipFlag);
	    }
	  }
	
	  function getDefaultShippingMethod(shippingMethod) {
	    var asns = _AsnStore2.default.getAsns();
	    return _underscore2.default.chain(asns).values().find(function (asn) {
	      if (asn.status != "New") {
	        //edit
	        return asn.shippingMethod === shippingMethod;
	      }
	    }).value();
	  }
	
	  self.isValid = function () {
	    var asn = _AsnStore2.default.getAsnWithShippingMethod();
	    return _AsnStore2.default.getAsnDetails(asn).length;
	  };
	
	  function buildProductItemStore() {
	    var asnDetails = getAsnDetails();
	    var skus = [];
	    (0, _underscore2.default)(asnDetails).map(function (asnDetail, rowIdx) {
	      skus.push(asnDetail.sku);
	    });
	    if (skus.length > 0) {
	      _ProductItemStore2.default.addSkusArrayToStore(skus, getItemsBySkusUrl);
	    }
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, packingEntryPointElement);
	    (0, _selectorHelpers.setElementsFromScope)(els, elsFileModalMap, wizardElement);
	  }
	
	  function attachWidgets() {
	    generateStaticModals();
	    generateDynamicModals();
	  }
	
	  function bindElements() {
	    (0, _instantiateSwitchery.instantiateSwitchery)(els.printPackingSlipFlag);
	    els.printPackingSlipFlag.on("change", onChangeofPrintPackingSlipFlag);
	    els.uploadFileInput.on("change", handleFileInputChange);
	    els.uploadFileBtn.on("click", (0, _general.createPreventDefault)(handleUploadFileBtn));
	    els.uploadApplybtn.on("click", (0, _general.createPreventDefault)(handleApplyBtn));
	    els.uploadFileErrorListBtn.on("click", (0, _general.createPreventDefault)(handleViewErrorListBtn));
	
	    els.uploadPackingDetailsBtn.click((0, _general.createPreventDefault)(showUploadPackingDetailModal));
	    els.managePackingDetailsBtn.on('click', addNewPackingDetailsInfoModal);
	    els.removeAllBtn.on('click', (0, _general.createPreventDefault)(showRemoveAllModal));
	    els.asnPackingMethod.change((0, _general.createPreventDefault)(setPackingTypes));
	
	    // NOTE: these elements are targeted through the document on load because they're dynamically added to page after page load
	    $(document).on("click", elementsMap.editOneBtn, showPackingDetailsInfoModal);
	    $(document).on("click", elementsMap.removeOneBtn, showRemoveOneModal);
	    $(document).on("click", elementsMap.removeOneConfirmOnModalBtn, (0, _general.createPreventDefault)(removeOneCaseOrPallet));
	    $(document).on("click", elementsMap.removeAllConfirmOnModalBtn, (0, _general.createPreventDefault)(removeAllCaseOrPallet));
	    $(document).on("click", elementsMap.savePackingInfoBtn, addOrUpdateCaseOrParcelHandler);
	    $(document).on("click", elementsMap.closeBtn, onCloseBtnClick);
	    $(document).on("change", elementsMap.unitsPerCase, onUnitsPerCaseInput);
	    $(document).on("change", elementsMap.lotNumber, onLotNumberInput);
	    $(document).on("change", elementsMap.expDateInput, onExpDateInput);
	    $(document).on("change", elementsMap.customCaseOrPalletIdsFlag, showHideCustomCaseOrPalletIdsList);
	  };
	
	  function bindDynamicElements() {
	    //skuTypeAhead.on('typeahead:selected', createNewAsnDetail);
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", handleShippingChangeRerender);
	    _AsnDetailStore2.default.bindListener("asn_details:add", handleAddNewAsnDetail);
	    _AsnDetailStore2.default.bindListener("asn_details:remove", handleRemoveAsnDetail);
	    _AsnDetailStore2.default.bindListener("asn_details:change", updateSelf);
	  }
	
	  function handleShippingMethodActivation(value) {
	    (0, _selectorHelpers.hide)(els.noPackingTypeSection);
	    if (value === "parcel") {
	      _AsnStore2.default.selectParcel();
	    } else {
	      _AsnStore2.default.selectPallet();
	    }
	  }
	
	  function handleRemoveAsnDetail() {
	    updateSelf();
	  }
	
	  function handleAddNewAsnDetail() {
	    updateSelf();
	  }
	
	  function handleShippingChangeRerender(shippingMethod) {
	    updateSelf();
	  }
	
	  function updateSelf() {
	    selectShippingMethod();
	    toggleSubViews();
	    getPackingDetails();
	    handleDisabled();
	  }
	
	  function selectShippingMethod() {
	    if (getAsnDetails().length > 0) {
	      if (isPallet()) {
	        els.asnPackingMethod.val(2); //Pallet
	      } else {
	        els.asnPackingMethod.val(1); //Case
	      }
	
	      els.uploadPackingDetailsSection.show();
	    }
	
	    if (els.asnPackingMethod.val() > 0) {
	      (0, _selectorHelpers.hide)(els.noPackingTypeSection);
	    } else {
	      (0, _selectorHelpers.show)(els.noPackingTypeSection);
	    }
	  }
	
	  function toggleSubViews() {
	    if (isParcel()) {
	      upperCasePacking = "Case";
	      lowerCasePacking = "case";
	      showParcelRelatedViews();
	    } else if (isPallet()) {
	      upperCasePacking = "Pallet";
	      lowerCasePacking = "pallet";
	      showPalletRelatedViews();
	    }
	  }
	
	  function showParcelRelatedViews() {
	    els.palletPrompt.hide();
	    els.palletCasesSection.hide();
	    els.addNewPalletBtn.hide();
	    if (getAsnDetails().length) {
	      // we need to hide the prompt,
	      // they've already started adding
	      // cases to the parcel section
	      els.parcelPrompt.hide();
	      els.parcelCasesSection.show();
	      els.addNewCaseBtn.show();
	      els.removeAllBtn.show();
	    } else {
	      els.parcelCasesSection.hide();
	      if (els.asnPackingMethod.val() > 0) {
	        els.parcelPrompt.show();
	      }
	      els.addNewCaseBtn.hide();
	      els.removeAllBtn.hide();
	    }
	  }
	
	  function showPalletRelatedViews() {
	    els.parcelPrompt.hide();
	    els.parcelCasesSection.hide();
	    els.addNewCaseBtn.hide();
	    if (getAsnDetails().length) {
	      // we need to hide the prompt,
	      // they've already started adding
	      // cases to the pallet section
	      els.palletPrompt.hide();
	      els.palletCasesSection.show();
	      els.addNewPalletBtn.show();
	      els.removeAllBtn.show();
	    } else {
	      els.palletCasesSection.hide();
	      if (els.asnPackingMethod.val() > 0) {
	        els.palletPrompt.show();
	      }
	      els.addNewPalletBtn.hide();
	      els.removeAllBtn.hide();
	    }
	  }
	
	  function handleDisabled() {
	    if (!canEditGtlAsn()) {
	      (0, _selectorHelpers.setDisabled)([els.asnPackingMethod]);
	      (0, _selectorHelpers.setDisabledClass)([els.uploadPackingDetailsBtn, els.managePackingDetailsBtn, els.removeAllBtn]);
	      $(document).find(elementsMap.editOneBtn).attr('disabled', 'disabled');
	      $(document).find(elementsMap.removeOneBtn).attr('disabled', 'disabled');
	      $(document).find(elementsMap.lotNumber).attr('disabled', 'disabled');
	      $(document).find(elementsMap.expDateInput).attr('disabled', 'disabled');
	    }
	  }
	
	  function hasAnyMixedSkuCases(details) {
	    return _AsnDetailStore2.default.hasAnyMixedSkuCases(details);
	  }
	
	  function hasAnyMixedSkuCasesInAnyPallets(details) {
	    return _AsnDetailStore2.default.hasAnyMixedSkuCasesInAnyPallets(details);
	  }
	
	  function setPackingTypes() {
	    var sourceAsn = getAsn();
	    if (els.asnPackingMethod.val() == 1) {
	      handleShippingMethodActivation('parcel');
	    } else {
	      handleShippingMethodActivation('pallet');
	    }
	    var targetAsn = getAsn();
	    targetAsn.isInternaltional = sourceAsn.isInternaltional;
	    targetAsn.printPackingSlipFlag = sourceAsn.printPackingSlipFlag;
	    targetAsn.printShippingLabelFlag = sourceAsn.printShippingLabelFlag;
	    _AsnStore2.default.updateObjectAndEmit(targetAsn.id, targetAsn);
	
	    generateDynamicModals();
	    els.uploadPackingDetailsSection.show();
	  }
	
	  function addNewPackingDetailsInfoModal(e) {
	    e.preventDefault();
	    currentProducts = [];
	    currentCaseOrPalletIds = [];
	    var lineNumber = 1;
	    if (isParcel()) {
	      lineNumber = _AsnDetailStore2.default.getNextCaseNumber();
	    } else {
	      lineNumber = _AsnDetailStore2.default.getNextPalletNumber();
	    }
	    //currentViewingCaseOrPalletLineNumber = lineNumber;
	    if (isParcel()) {
	      packingDetailsInfoModal.find(elementsMap.packingTypeName).val("Case " + lineNumber);
	    } else {
	      packingDetailsInfoModal.find(elementsMap.packingTypeName).val("Pallet " + lineNumber);
	    }
	    packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val('1');
	    packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val('1');
	    //packingDetailsInfoModal.find(elementsMap.skuTypeAhead).val('');
	    packingDetailsInfoModalProdListContainer.html('');
	    var element = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsFlag);
	    (0, _instantiateSwitchery.instantiateSwitchery)(element, {});
	    (0, _instantiateSwitchery.setSwitchery)(element, false);
	    packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val('');
	    packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).show();
	    packingDetailsInfoModal.modal("show");
	  }
	
	  function showPackingDetailsInfoModal(e) {
	    editCaseOrPallet = true;
	    e.preventDefault();
	    packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).hide();
	    packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).hide();
	    packingDetailsInfoModal.find(elementsMap.lengthLpnFlag).hide();
	
	    var caseOrPalletLineNumber = e.target.dataset.caseOrPalletLineNumber;
	    currentViewingCaseOrPalletLineNumber = caseOrPalletLineNumber;
	    currentCaseOrPalletIds = pickCaseOrPalletItems(caseOrPalletLineNumber);
	    currentProducts = getProducts(currentCaseOrPalletIds).map(function (a) {
	      return Object.assign({}, a);
	    });
	    var product = getFirstProduct(currentCaseOrPalletIds);
	    packingDetailsInfoModal.find(elementsMap.packingTypeName).val(product.packingTypeName);
	    if (isParcel()) {
	      packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val(product.numberOfCases);
	    } else {
	      packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val(product.numberOfPallets);
	    }
	    var element = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsFlag);
	    if (product.hasCustomIds) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(element, {});
	      (0, _instantiateSwitchery.setSwitchery)(element, true);
	      packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val(product.customCaseOrPalletIds);
	    } else {
	      (0, _instantiateSwitchery.instantiateSwitchery)(element, {});
	      (0, _instantiateSwitchery.setSwitchery)(element, false);
	      packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val('');
	    }
	    showHideCustomCaseOrPalletIdsList();
	    getPackageInfoModalProdList();
	    if (currentProducts.length > 0) {
	      packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).hide();
	    } else {
	      packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).show();
	    }
	    packingDetailsInfoModal.modal("show");
	  }
	
	  function pickCaseOrPalletItems(caseOrPalletLineNumber) {
	    var viewCaseOrPalletIds = [];
	    (0, _underscore2.default)(getCasesOrPallets()).map(function (asnDetail) {
	      var ids = (0, _underscore2.default)(asnDetail).pluck("id");
	      var lineNumber = 1;
	      if (isParcel()) {
	        lineNumber = getFirstProduct(ids).caseLineNumber;
	      } else {
	        lineNumber = getFirstProduct(ids).palletLineNumber;
	      }
	      if (lineNumber == caseOrPalletLineNumber) {
	        viewCaseOrPalletIds = ids;
	        return;
	      }
	    });
	    return viewCaseOrPalletIds;
	  }
	
	  function getPackageInfoModalProdList() {
	    packingDetailsInfoModalProdListContainer.html('');
	    (0, _underscore2.default)(currentProducts).map(function (asnDetail, rowIdx) {
	      var prodList = buildPackageInfoModalProdList(asnDetail, rowIdx);
	      packingDetailsInfoModalProdListContainer.append(prodList);
	    });
	  }
	
	  function buildPackageInfoModalProdList(asnDetail, rowIdx) {
	    var prodListItem = $((0, _render2.default)(packingDetailsInfoModalProdList, {
	      asnDetailRowNumber: rowIdx,
	      skuName: asnDetail.sku,
	      skuDesc: getProductItem(asnDetail).prdDescription || "no description",
	      unitsPerCase: asnDetail.unitsPerCase
	    }));
	    return prodListItem;
	  }
	
	  function onUnitsPerCaseInput(e) {
	    var asnDetail = currentProducts[$(e.target).closest(elementsMap.productRowNumber)[0].dataset.asnDetailRowNumber];
	    asnDetail.unitsPerCase = $(e.target).val();
	  }
	
	  function onCloseBtnClick(e) {
	    e.preventDefault();
	    var asnDetail = currentProducts[$(e.target).closest(elementsMap.productRowNumber)[0].dataset.asnDetailRowNumber];
	    handleRemoveProductRows(asnDetail.id);
	    getPackageInfoModalProdList();
	    if (currentProducts.length > 0) {
	      packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).hide();
	    } else {
	      packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).show();
	    }
	  }
	
	  function handleRemoveProductRows(id) {
	    currentProducts = currentProducts.filter(function (el) {
	      return el.id != id;
	    });
	    //currentCaseOrPalletIds = currentCaseOrPalletIds.filter(function(el){ return el != id; });
	  }
	
	  function showHideCustomCaseOrPalletIdsList() {
	    var customCaseOrPalletIdsFlagElement = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsFlag);
	    var customCaseOrPalletIdsFlag = customCaseOrPalletIdsFlagElement.prop("checked");
	    if (customCaseOrPalletIdsFlag) {
	      packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsListSection).show();
	    } else {
	      packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsListSection).hide();
	      packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).hide();
	      packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).hide();
	      packingDetailsInfoModal.find(elementsMap.lengthLpnFlag).hide();
	    }
	  }
	
	  function setCaseOrPalletModalValidator() {
	    caseOrPalletFormValidator = packingDetailsInfoModal.find(elementsMap.caseOrPalletModalForm).validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	    caseOrPalletFormValidator.settings.ignore = ":disabled,:hidden";
	  }
	
	  function addOrUpdateCaseOrParcelHandler(e) {
	    e.preventDefault();
	    packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).hide();
	    packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).hide();
	    packingDetailsInfoModal.find(elementsMap.lengthLpnFlag).hide();
	    if (!caseOrPalletFormValidator.elements().valid()) {
	      return;
	    }
	    //mulitple array of inputs like units-per-case
	    var unitsElements = packingDetailsInfoModalProdListContainer.find(elementsMap.unitsPerCase);
	    if (unitsElements.length > 0 && !unitsElements.valid()) {
	      return;
	    }
	    if (currentProducts.length <= 0) {
	      //Need atleast one product
	      return;
	    }
	
	    var numberOfCasesOrPallets = packingDetailsInfoModal.find(elementsMap.numberOfCasesOrPallets).val();
	    var customCaseOrPalletIdsList = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val();
	    var packingTypeName = packingDetailsInfoModal.find(elementsMap.packingTypeName).val();
	    var customCaseOrPalletIdsFlagElement = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsFlag);
	    var customCaseOrPalletIdsFlag = customCaseOrPalletIdsFlagElement.prop("checked");
	
	    if (customCaseOrPalletIdsFlag) {
	      var idslist = customCaseOrPalletIdsList.length > 0 ? customCaseOrPalletIdsList.split(",") : [];
	      var uniqlist = _underscore2.default.uniq(idslist);
	      var lengthError = false;
	      if (uniqlist.length > 0) {
	        (0, _underscore2.default)(uniqlist).map(function (lpnId) {
	          if (lpnId.length > 0 && !(lpnId.length >= 16 && lpnId.length <= 20)) {
	            lengthError = true;
	          }
	        });
	        if (lengthError == true) {
	          packingDetailsInfoModal.find(elementsMap.lengthLpnFlag).show();
	          return;
	        }
	      }
	      if (uniqlist.length != numberOfCasesOrPallets) {
	        packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).show();
	        return;
	      } else {
	        packingDetailsInfoModal.find(elementsMap.warningCaseOrPalletIdsSizeSection).hide();
	      }
	
	      var asnDet = getAsnDetails();
	      var caseOrPallets = _AsnDetailStore2.default.organizeIntoCases(asnDet);
	      var savedcustomCaseOrPalletIdsList = [];
	
	      if (_underscore2.default.isNull(asnValue) || _underscore2.default.isUndefined(asnValue) || asnValue === "") {
	        //LPN validation is not required for Edit Flow.
	        var errt = validateLpn();
	        if (errt == true) {
	          packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).show();
	          return;
	        }
	      }
	    }
	
	    //Remove asn detail from store
	    var asnDetailEdited = [];
	
	    (0, _underscore2.default)(currentCaseOrPalletIds).map(function (currentCaseOrPalletId, id) {
	      asnDetailEdited[id] = _AsnDetailStore2.default.getAsnDetail(currentCaseOrPalletId);
	    });
	
	    _AsnDetailStore2.default.removeAsnDetailsByIds(currentCaseOrPalletIds);
	    //Add new asn detail to store
	    var declaredValue = 0;
	    var asnDetailId = void 0;
	    (0, _underscore2.default)(currentProducts).map(function (item) {
	      if (isParcel()) {
	        item.numberOfCases = numberOfCasesOrPallets;
	      } else {
	        item.numberOfPallets = numberOfCasesOrPallets;
	      }
	      item.packingTypeName = packingTypeName;
	      if (customCaseOrPalletIdsFlag) {
	        item.hasCustomIds = true;
	        item.customCaseOrPalletIds = customCaseOrPalletIdsList;
	      } else {
	        item.hasCustomIds = false;
	        item.customCaseOrPalletIds = "";
	      }
	
	      var productData = _ProductItemStore2.default.getDataViaAsnDetail(item);
	      if (productData.length > 0) {
	        declaredValue += item.unitsPerCase * productData[0].itmCost;
	      }
	
	      if (_AsnDetailStore2.default.getAsnDetail(item.id)) {
	        handleAsnDetailChange(item.id, item);
	      } else {
	        asnDetailId = _AsnDetailStore2.default.createNewAsnDetail(_extends({ asnId: getAsn().id }, item));
	      }
	    });
	
	    if (customCaseOrPalletIdsFlag) {
	      var asnDet = getAsnDetails();
	      var _caseOrPallets = void 0;
	      var savedcustomCaseOrPalletIdsList = [];
	
	      if (isPallet()) {
	        _caseOrPallets = _AsnDetailStore2.default.organizeIntoPallets(asnDet);
	      } else {
	        _caseOrPallets = _AsnDetailStore2.default.organizeIntoCases(asnDet);
	      }
	      //    savedcustomCaseOrPalletIdsList = customCaseOrPalletIdsList.length > 0 ? customCaseOrPalletIdsList.split(","):[];
	
	      var isValid = true;
	      (0, _underscore2.default)(_caseOrPallets).each(function (asnDetailSubset, caseIdx) {
	        var firstAsnDetail = asnDetailSubset[0];
	        var caseIdList = firstAsnDetail.customCaseOrPalletIds.length > 0 ? firstAsnDetail.customCaseOrPalletIds.split(",") : [];
	        savedcustomCaseOrPalletIdsList = savedcustomCaseOrPalletIdsList.concat(caseIdList);
	        var uniqlist = _underscore2.default.uniq(savedcustomCaseOrPalletIdsList);
	        if (uniqlist.length < savedcustomCaseOrPalletIdsList.length) {
	          packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).show();
	          isValid = false;
	        } else {
	          packingDetailsInfoModal.find(elementsMap.duplicateLpnFlag).hide();
	        }
	      });
	
	      if (isValid == false && _underscore2.default.isEmpty(currentCaseOrPalletIds)) {
	        //for new cases 
	        _AsnDetailStore2.default.removeAsnDetailsByIds(pickCaseOrPalletItems(asnDetailId.caseLineNumber));
	        return;
	      }if (isValid == false && !_underscore2.default.isEmpty(currentCaseOrPalletIds) && !_underscore2.default.isEmpty(asnDetailEdited)) {
	        (0, _underscore2.default)(asnDetailEdited).map(function (asnDetail, id) {
	          _AsnDetailStore2.default.update(asnDetail.id, asnDetail);
	        });
	        return;
	      } else if (isValid == false) {
	        return;
	      }
	    }
	
	    if (declaredValue > 50000) {
	      declaredValue = 50000;
	    }
	
	    (0, _underscore2.default)(currentProducts).map(function (item) {
	      item.declaredValue = declaredValue;
	      item.dvlCalculatedValue = declaredValue;
	      handleAsnDetailChange(item.id, item);
	    });
	    packingDetailsInfoModal.modal("hide");
	  }
	
	  function showRemoveOneModal(e) {
	    var caseOrPalletLineNumber = e.target.dataset.caseOrPalletLineNumber;
	    currentCaseOrPalletIds = pickCaseOrPalletItems(caseOrPalletLineNumber);
	    removeOneModal.modal("show");
	  }
	
	  function removeOneCaseOrPallet(e) {
	    _AsnDetailStore2.default.removeAsnDetailsByIds(currentCaseOrPalletIds);
	    removeOneModal.modal("hide");
	  }
	
	  function showRemoveAllModal() {
	    removeAllModal.modal("show");
	  }
	
	  function removeAllCaseOrPallet(e) {
	    (0, _underscore2.default)(getCasesOrPallets()).map(function (asnDetail, rowIdx) {
	      var ids = (0, _underscore2.default)(asnDetail).pluck("id");
	      _AsnDetailStore2.default.removeAsnDetailsByIds(ids);
	    });
	    removeAllModal.modal("hide");
	  }
	
	  function getPackingDetails() {
	    packingDetailsContainer.html('');
	    (0, _underscore2.default)(getCasesOrPallets()).map(function (asnDetail, rowIdx) {
	      rowIdx = rowIdx + 1;
	      var ids = (0, _underscore2.default)(asnDetail).pluck("id");
	      var packingDetail = buildPackingDetail(ids);
	      packingDetailsContainer.append(packingDetail);
	    });
	    initPackingDetailExpDates();
	  }
	
	  function buildPackingDetail(ids) {
	    var numberOfCasesOrPallets = 1;
	    var caseOrPalletLineNumber = 1;
	    var asnDetail = getFirstProduct(ids);
	    if (!asnDetail.packingTypeName) {
	      // if name is not exist
	      if (isParcel()) {
	        asnDetail.packingTypeName = "Case " + asnDetail.caseLineNumber;
	      } else {
	        asnDetail.packingTypeName = "Pallet " + asnDetail.palletLineNumber;
	      }
	    }
	
	    var hasMixedSkus = false;
	    if (isParcel()) {
	      numberOfCasesOrPallets = getFirstProductNumberOfCases(ids);
	      caseOrPalletLineNumber = asnDetail.caseLineNumber;
	      hasMixedSkus = hasAnyMixedSkuCases(ids);
	    } else {
	      numberOfCasesOrPallets = getFirstProductNumberOfPallets(ids);
	      caseOrPalletLineNumber = asnDetail.palletLineNumber;
	      hasMixedSkus = hasAnyMixedSkuCasesInAnyPallets(ids);
	    }
	    var customCaseOrPalletIds = "";
	    if (asnDetail.hasCustomIds) {
	      customCaseOrPalletIds = asnDetail.customCaseOrPalletIds;
	    }
	    var packingDetailsEl = (0, _render2.default)(packingDetailsTemplateHtml, {
	      packingTypeUpperCase: getPackingType(upperCasePacking),
	      packingType: getPackingType(lowerCasePacking),
	      packingTypeName: asnDetail.packingTypeName,
	      numberOfCasesOrPallets: numberOfCasesOrPallets,
	      packingProductsList: getPackingDetailProducts(ids),
	      caseOrPalletLineNumber: caseOrPalletLineNumber,
	      hasCustomIds: asnDetail.hasCustomIds,
	      customCaseOrPalletIds: customCaseOrPalletIds,
	      hasMultipleProducts: hasMixedSkus
	    });
	    return packingDetailsEl;
	  }
	
	  function getPackingDetailProducts(ids) {
	    var html = "";
	    (0, _underscore2.default)(getProducts(ids)).map(function (asnDetail, rowIdx) {
	      rowIdx = rowIdx + 1;
	      html = html.concat(buildPackingDetailList(asnDetail, rowIdx));
	    });
	    return html;
	  }
	
	  function buildPackingDetailList(asnDetail, rowIdx) {
	    var totalUnits = 1;
	    if (isParcel()) {
	      totalUnits = asnDetail.unitsPerCase * asnDetail.numberOfCases;
	    } else {
	      totalUnits = asnDetail.unitsPerCase * asnDetail.numberOfPallets;
	    }
	
	    var listItem = (0, _render2.default)(packingDetailsListTemplateHtml, {
	      uuid: _underscore2.default.uuid(),
	      packingType: getPackingType(lowerCasePacking),
	      asnDetailRowId: asnDetail.id,
	      skuName: asnDetail.sku,
	      skuDesc: getProductItem(asnDetail).prdDescription || "no description",
	      unitsPerCase: asnDetail.unitsPerCase,
	      totalUnits: totalUnits,
	      packingExpDate: asnDetail.expirationDate,
	      lotNumber: asnDetail.batchLotNumber,
	      hasExpDateField: hasExpDate(asnDetail.sku),
	      hasLotNumberField: hasLotNumber(asnDetail.sku)
	    });
	    return listItem;
	  }
	
	  function onExpDateInput(e) {
	    var target = $(e.target);
	    var asnDetail = getAsnDetail(target.data("asn-detail-row-id"));
	    var val = target.val();
	    if (target.val() === asnDetail.expirationDate) {
	      return;
	    }
	    handleAsnDetailChange(asnDetail.id, { expirationDate: val });
	  }
	
	  function onLotNumberInput(e) {
	    var target = $(e.target);
	    var asnDetail = getAsnDetail(target.data("asn-detail-row-id"));
	    var val = target.val();
	    handleAsnDetailChange(asnDetail.id, { batchLotNumber: val });
	  }
	
	  function createNewAsnDetail(sku) {
	    //const sku = skuTypeAhead.typeahead('val');
	    if (sku.length == 0) return;
	    var newAsnDetail = {};
	    if (currentCaseOrPalletIds.length) {
	      newAsnDetail = handleAddProduct();
	      if (isParcel()) {
	        newAsnDetail.caseLineNumber = currentViewingCaseOrPalletLineNumber;
	      } else {
	        newAsnDetail.palletLineNumber = currentViewingCaseOrPalletLineNumber;
	      }
	    } else {
	      if (isParcel()) {
	        newAsnDetail = _AsnDetailStore2.default.createNewCaseSkeletonIncrementedAsnDetail({ asnId: getAsn().id });
	      } else {
	        newAsnDetail = _AsnDetailStore2.default.createNewPalletSkeletonIncrementedAsnDetail({ asnId: getAsn().id });
	      }
	    }
	    newAsnDetail.sku = sku;
	    currentProducts.push(newAsnDetail);
	    //currentCaseOrPalletIds.push(newAsnDetail.id);
	    packingDetailsInfoModal.find(elementsMap.beforeUserAddsProduct).hide();
	    getPackageInfoModalProdList();
	    //skuTypeAhead.typeahead('val', '');
	  }
	
	  function handleAddProduct() {
	    var attrs = (0, _underscore2.default)(getFirstProduct(currentCaseOrPalletIds)).pick("caseLineNumber", "palletLineNumber", "numberOfCases", "numberOfPallets", "asd_package_length", "asd_package_width", "asd_package_height", "asd_package_weight", "stackablePallet", "declaredValueInput", "useCalculatedVal", "dvlInsideCase");
	    return _AsnDetailStore2.default.createSkeletonAsnDetail(attrs);
	    //return AsnDetailStore.createNewAsnDetail({asnId: getAsn().id, ...attrs});
	  }
	
	  function instantiateSkuTypeAhead() {
	    /*skuTypeAhead = packingDetailsInfoModal.find(elementsMap.skuTypeAhead).typeahead({
	      highlight: true
	    },
	    {
	      name: 'sku',
	      source: typeAheadSource(
	        ProductItemStore.getSkus()
	      )
	    });*/
	
	    var select2AjaxDefaults = {
	      dataType: 'json',
	      delay: 250,
	      async: false,
	      processResults: function processResults(data, params) {
	        params.page = params.page || 1;
	        return {
	          results: data,
	          pagination: {
	            more: params.page * 20 < data.total_count
	          }
	        };
	      },
	      cache: true
	    };
	
	    function configureDataCallback(_ref) {
	      var paramKey = _ref.paramKey;
	
	      return function (params) {
	        return _defineProperty({}, paramKey, params.term);
	      };
	    }
	
	    var productItemLookup = packingDetailsInfoModal.find(elementsMap.productItemLookup);
	    productItemLookup.select2({
	      placeholder: "Type product name (SKU)",
	      dropdownParent: packingDetailsInfoModal,
	      allowClear: true,
	      ajax: _extends({}, select2AjaxDefaults, {
	        url: productLookUpURL,
	        data: configureDataCallback({ paramKey: '_asn_WAR_hcportlet_likeSku' })
	      }),
	      minimumInputLength: 3
	    });
	
	    productItemLookup.on("select2:select", function (e) {
	      lookupFromStore(this.value);
	      productItemLookup.val(null).trigger('change');
	    });
	  }
	
	  function lookupFromStore(itemSku) {
	    if (itemSku == "") {
	      return;
	    }
	    if (_ProductItemStore2.default.doesSkuExist(itemSku)) {
	      createNewAsnDetail(itemSku);
	    } else {
	      var createNewAsnDetailFlag = true;
	      _ProductItemStore2.default.addSkuToStore(itemSku, searchItemURL);
	      createNewAsnDetail(itemSku);
	    }
	  }
	
	  function handleAsnDetailChange(id, newData) {
	    _AsnDetailStore2.default.update(id, newData);
	  }
	
	  function initPackingDetailExpDates() {
	    var date = new Date();
	    packingEntryPointElement.find(elementsMap.packingExpDate).datepicker({
	      startDate: date,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	    packingEntryPointElement.find(elementsMap.packingExpDate).keypress(function (event) {
	      event.preventDefault();
	    }); //make non-typeable/readonly texbox
	  }
	
	  // here we are updating the range allowed
	  // for the expiration date,
	  // as well as the default value if necessary
	  function updateExpDateRange() {
	    var input = els.expDateInput;
	
	    if (!hasProductItemForSku()) {
	      return;
	    }
	    var shelfLife = parseInt(getProductItemForSku().shelfLife || 0, 10);
	
	    if (!shelfLife) {
	      return;
	    }
	
	    var date = new Date();
	    date.setDate(date.getDate() + shelfLife);
	
	    input.datepicker("setStartDate", date);
	
	    var asnDetail = getAsnDetail();
	    if (typeaheadSelectAttempted) {
	      typeaheadSelectAttempted = false;
	      input.datepicker("update", date);
	    }
	  }
	
	  function hasLotNumber(sku) {
	    return doesProductForSkuRequireLotNumber(sku);
	  }
	
	  function hasExpDate(sku) {
	    return isProductForSkuPerishable(sku);
	  }
	
	  function doesProductForSkuRequireLotNumber(sku) {
	    var productItem = getProductItemForSku(sku);
	    return productItem && _ProductItemStore2.default.doesRequireLotNumber(productItem);
	  }
	
	  function isProductForSkuPerishable(sku) {
	    var productItem = getProductItemForSku(sku);
	    return productItem && _ProductItemStore2.default.isPerishable(productItem);
	  }
	
	  function hasProductItemForSku(sku) {
	    return !!getProductItemForSku(sku);
	  }
	
	  function getProductItemForSku(sku) {
	    return _ProductItemStore2.default.findWhere({ itmSku: sku });
	  }
	
	  function getPackingType(packingType) {
	    return packingType;
	  }
	
	  function generateStaticModals() {
	    uploadPackingDetailsModal = $((0, _render2.default)(modalHtml, {
	      title: 'Upload Packing Information',
	      leftAlignTitle: true,
	      body: (0, _render2.default)(uploadPackingInfoModalBodyHtml),
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800",
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a> <a href=\"#\" class=\"base-btn purple-btn confirm-btn\">Apply</a>\n        "
	    }));
	
	    wizardElement.append(uploadPackingDetailsModal);
	    fileUploaderEl = uploadPackingDetailsModal.find(elsFileModalMap.fileUploader);
	    quickFileUploaderInstance = (0, _QuickFileUploader.quickFileUploader)(fileUploaderEl);
	  }
	
	  function getPackingDetailsInfoModal() {
	    packingDetailsInfoModal = $((0, _render2.default)(modalHtml, {
	      title: getPackingType(upperCasePacking) + " Information",
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-800",
	      body: (0, _render2.default)(packingDetailsInfoModalBodyHtml, {
	        packingTypeUpperCase: getPackingType(upperCasePacking),
	        packingType: getPackingType(lowerCasePacking)
	      }),
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a> <a href=\"#\" class=\"base-btn purple-btn save-packing-info-btn\">Save " + getPackingType(upperCasePacking) + "</a>\n        "
	    }));
	    return packingDetailsInfoModal;
	  }
	
	  function getPackingDetailsInfoModalProdList() {
	    packingDetailsInfoModal = $((0, _render2.default)(modalHtml, {
	      title: getPackingType(upperCasePacking) + " Information",
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-800",
	      body: (0, _render2.default)(packingDetailsInfoModalBodyHtml, {
	        packingTypeUpperCase: getPackingType(upperCasePacking),
	        packingType: getPackingType(lowerCasePacking)
	      }),
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a> <a href=\"#\" class=\"base-btn purple-btn save-packing-info-btn\">Save " + getPackingType(upperCasePacking) + "</a>\n        "
	    }));
	    return packingDetailsInfoModal;
	  }
	
	  function getRemoveOneModal() {
	    removeOneModal = $((0, _render2.default)(modalHtml, {
	      title: "Remove " + getPackingType(upperCasePacking),
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-500",
	      body: "<div class='q-marg-all-xl'>Are you sure you want to remove this " + getPackingType(lowerCasePacking) + "?</div>",
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a> <a href=\"#\" class=\"base-btn purple-btn remove-one-confirm-on-modal-btn\">Remove " + getPackingType(upperCasePacking) + "</a>\n        "
	    }));
	    return removeOneModal;
	  }
	
	  function getRemoveAllModal() {
	    removeAllModal = $((0, _render2.default)(modalHtml, {
	      title: "Remove All " + getPackingType(upperCasePacking) + "s",
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-500",
	      body: "<div class='q-marg-all-xl'>Are you sure you want to remove all " + getPackingType(lowerCasePacking) + "s?</div>",
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a> <a href=\"#\" class=\"base-btn purple-btn remove-all-confirm-on-modal-btn\">Remove " + getPackingType(upperCasePacking) + "s</a>\n        "
	    }));
	    return removeAllModal;
	  }
	
	  function generateDynamicModals() {
	    // NOTE: to make btn dynamic with text variable for case vs. pallet, put btns in separate html file and render
	    if (packingDetailsInfoModal) {
	      packingDetailsInfoModal.remove('.modal');
	    }
	    if (removeOneModal) {
	      removeOneModal.remove('.modal');
	    }
	    if (removeAllModal) {
	      removeAllModal.remove('.modal');
	    }
	
	    wizardElement.append(getPackingDetailsInfoModal(), getRemoveOneModal(), getRemoveAllModal());
	    instantiateSkuTypeAhead();
	    bindDynamicElements();
	    setCaseOrPalletModalValidator();
	    packingDetailsInfoModalProdListContainer = wizardElement.find(elementsMap.packingDetailsInfoModalProdList);
	  }
	
	  function showUploadPackingDetailModal() {
	    hideAllUploadMessages();
	    uploadPackingDetailsModal.modal("show");
	    els.uploadApplybtn.attr('disabled', true);
	    els.uploadFileBtn.attr('disabled', false);
	    els.uploadFileInput.val("");
	    els.uploadFileTextInput.val("");
	    if (isAsnDetailsPresent()) {
	      els.uploadOverwriteMessage.show();
	    }
	  }
	
	  function handleViewErrorListBtn() {
	    csvErrors = new _CsvErrors2.default(wizardElement, errorData);
	    csvErrors.init();
	    var w = window.open(errorListPageUrl);
	
	    $(w).on('load', function () {
	      $(w.document.body).find(".error-list").html(csvErrors.getErrorHtml());
	    });
	  }
	
	  function setValidator() {
	    fileValidator = els.fileUploadForm.validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	
	    fileValidator.settings.ignore = ":disabled,:hidden";
	  }
	
	  function onChangeofPrintPackingSlipFlag() {
	    var asn = _AsnStore2.default.getAsnWithShippingMethod();
	    asn.printPackingSlipFlag = els.printPackingSlipFlag.is(":checked");
	  }
	
	  function handleFileInputChange(event) {
	    hideAllUploadMessages();
	
	    var fileName = quickFileUploaderInstance.getFile().name.split(".");
	    var ext = fileName[1].toLowerCase();
	    if (ext != "csv") {
	      els.uploadInvalidFileExtMessage.show();
	      els.uploadFileInput.val();
	      els.uploadApplybtn.attr('disabled', true);
	      els.uploadFileBtn.attr('disabled', true);
	    } else {
	      els.uploadInvalidFileExtMessage.hide();
	      els.uploadApplybtn.attr('disabled', true);
	      els.uploadFileBtn.show();
	      els.uploadFileBtn.attr('disabled', false);
	    }
	  }
	
	  function handleApplyBtn() {
	
	    if (!isElementDisabled(els.uploadApplybtn)) {
	      uploadPackingDetailsModal.modal("hide");
	
	      _AsnDetailStore2.default.storeFromUploadJson(validatedData);
	      buildProductItemStore();
	      _AsnDetailStore2.default.emitEvent('add');
	    }
	  }
	
	  function handleUploadFileBtn(e) {
	    var formData = new FormData();
	    var asnId = void 0;
	    // if Upload file button is disabled due to incorrect file extension, then dont do anything
	    if (isElementDisabled(els.uploadFileBtn)) {
	      return;
	    }
	
	    if (fileValidator.elements().valid()) {
	      formData.append('packingMethod', els.packingMethod.val());
	      formData.append('csvFile', els.uploadFileInput[0].files[0]);
	
	      if (els.packingMethod.val() == "1") {
	        asnId = _AsnStore2.default.getAsnWithShippingMethod("parcel").id;
	      } else {
	        asnId = _AsnStore2.default.getAsnWithShippingMethod("pallet").id;
	      }
	      formData.append('asnStoreId', asnId);
	      //alert(uploadCsvUrl);
	      $.ajax({
	        url: uploadCsvUrl,
	        type: "POST",
	        enctype: "multipart/form-data",
	        processData: false,
	        contentType: false,
	        dataType: "json",
	        data: formData,
	        beforeSend: function beforeSend() {
	          hideAllUploadMessages();
	          els.uploadFileBtn.hide();
	          els.loadingSpinner.show();
	        },
	        complete: function complete() {
	          els.loadingSpinner.hide();
	        },
	        success: function success(data, textStatus, jqXHR) {
	          if (data.result == 'success') {
	            els.uploadSuccessMessage.show();
	            els.uploadFileBtn.show();
	            els.uploadApplybtn.attr('disabled', false);
	            els.uploadFileBtn.attr('disabled', false);
	            validatedData = data.dataList;
	          } else if (data.result == 'validationErrors') {
	            els.uploadApplybtn.attr('disabled', true);
	            els.uploadFileBtn.hide();
	            els.uploadFileBtn.attr('disabled', false);
	            els.uploadFileError.show();
	            els.uploadFileErrorListBtn.show();
	            errorData = data.errorList;
	          } else {
	            els.uploadFileBtn.attr('disabled', false);
	            els.uploadApplybtn.attr('disabled', true);
	            els.uploadIncorrectMessage.show();
	          }
	        },
	        error: function error() {
	          els.uploadFileBtn.attr('disabled', false);
	          els.uploadApplybtn.attr('disabled', true);
	          els.uploadIncorrectMessage.show();
	        }
	      });
	    }
	  }
	
	  function isAsnDetailsPresent() {
	    return _underscore2.default.size(_AsnDetailStore2.default.asnDetailsAsArray()) > 0;
	  }
	
	  function isElementDisabled(element) {
	    return $(element).is('[disabled=disabled]');
	  }
	
	  function hideAllUploadMessages() {
	    (0, _selectorHelpers.hide)(els.uploadSuccessMessage);
	    (0, _selectorHelpers.hide)(els.uploadInvalidFileExtMessage);
	    (0, _selectorHelpers.hide)(els.uploadOverwriteMessage);
	    (0, _selectorHelpers.hide)(els.uploadIncorrectMessage);
	    (0, _selectorHelpers.hide)(els.uploadFileError);
	    (0, _selectorHelpers.hide)(els.uploadFileErrorListBtn);
	  }
	
	  function getCasesOrPallets() {
	    if (isPallet()) return _AsnDetailStore2.default.organizeIntoPallets(getAsnDetails());else if (isParcel()) return _AsnDetailStore2.default.organizeIntoCases(getAsnDetails());
	  }
	
	  function getAsnDetails() {
	    return _AsnStore2.default.getAsnDetails(getAsn());
	  }
	
	  function getAsnDetail(id) {
	    return _AsnDetailStore2.default.getAsnDetail(id);
	  }
	
	  function getAsn() {
	    if (isPallet()) return _AsnStore2.default.getOrCreateAsnWithShippingMethod("pallet");else return _AsnStore2.default.getOrCreateAsnWithShippingMethod("parcel");
	  }
	
	  function getProducts(ids) {
	    return _AsnDetailStore2.default.getAsnDetails(ids);
	  }
	
	  function getShippingMethod() {
	    return _AsnStore2.default.getShippingMethod();
	  }
	
	  function isParcel() {
	    return getShippingMethod() === 'parcel';
	  }
	
	  function isPallet() {
	    return getShippingMethod() === 'pallet';
	  }
	
	  function canEditGtlAsn() {
	    return _AbilityStore2.default.ask("canEditGtlAsn");
	  }
	
	  function getFirstProductNumberOfCases(ids) {
	    return parseInt(getFirstProduct(ids).numberOfCases, 10) || 1;
	  }
	
	  function getFirstProductNumberOfPallets(ids) {
	    return parseInt(getFirstProduct(ids).numberOfPallets, 10) || 1;
	  }
	
	  function getFirstProduct(ids) {
	    return getProducts(ids)[0];
	  }
	
	  function getProductItem(asnDetail) {
	    return _ProductItemStore2.default.getDataViaAsnDetail(asnDetail)[0] || {};
	  }
	
	  var hasAsnDetailsWithoutPallets = _AsnDetailStore2.default.hasAsnDetailsWithoutPallets;
	  var hasAsnDetailsWithoutCases = _AsnDetailStore2.default.hasAsnDetailsWithoutCases;
	
	  function validateLpn() {
	    var customCaseOrPalletIds = packingDetailsInfoModal.find(elementsMap.customCaseOrPalletIdsList).val();
	    var result = "";
	    $.ajax({
	      async: false,
	      data: _defineProperty({}, portletNamespace + "customCaseOrPalletIds", customCaseOrPalletIds),
	      url: validateLpnUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        result = data.response;
	      }
	    });
	
	    return result;
	  }
	}

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AsnDetailRowReviewView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(292);
	
	
	var elementsMap = {
	  asnDetailLength: ".asn-detail-length",
	  asnDetailWidth: ".asn-detail-width",
	  asnDetailHeight: ".asn-detail-height",
	  asnDetailWeight: ".asn-detail-weight",
	  palletCaseIdx: ".pallet-case-idx",
	  palletCaseLabel: ".pallet-case-label",
	  stackablePalletOuter: ".stackable-pallet-outer",
	  stackablePalletVal: ".stackable-pallet-val"
	};
	
	var yesClassName = "q-ppt-purple";
	var noClassName = "q-ppt-grey";
	
	function AsnDetailRowReviewView(asnDetail, options) {
	  var asnDetailId = asnDetail.id;
	
	  var rowIdx = options.rowIdx,
	      isPallet = options.isPallet;
	
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  self.init = function () {
	    render();
	  };
	
	  function bindElements() {}
	
	  function bindStores() {
	    _AsnDetailStore2.default.bindListener("asn_details:change:" + asnDetailId, updateSelf);
	  }
	
	  self.unbindListeners = function () {
	    _AsnDetailStore2.default.unbindListener("asn_details:change:" + asnDetailId, updateSelf);
	  };
	
	  function setWidgets() {}
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    // handle rendering children
	    updateSelf();
	  }
	
	  function updateSelf() {
	    // handle updating values;
	    updateValues();
	    updatePalletCaseIdx();
	    updatePalletCaseLabel();
	    updatePalletSpecificFields();
	  }
	
	  function updatePalletSpecificFields() {
	    var isPlt = isPallet();
	    var asnDetail = getAsnDetail();
	    (0, _selectorHelpers.handleDisplayFor)(els.stackablePalletOuter, isPlt);
	    if (isPlt) {
	      (0, _selectorHelpers.swapClassesViaBool)(els.stackablePalletVal, yesClassName, noClassName, asnDetail.stackablePallet);
	    }
	  }
	
	  function updateValues() {
	    var asnDetail = getAsnDetail();
	    (0, _selectorHelpers.insertTextAndClean)(els.asnDetailLength, asnDetail.asd_package_length);
	    (0, _selectorHelpers.insertTextAndClean)(els.asnDetailWidth, asnDetail.asd_package_width);
	    (0, _selectorHelpers.insertTextAndClean)(els.asnDetailHeight, asnDetail.asd_package_height);
	    (0, _selectorHelpers.insertTextAndClean)(els.asnDetailWeight, asnDetail.asd_package_weight);
	    (0, _selectorHelpers.insertTextAndClean)(els.stackablePalletVal, (0, _selectorHelpers.boolToHuman)(asnDetail.stackablePallet));
	  }
	
	  function updatePalletCaseIdx() {
	    els.palletCaseIdx.text(rowIdx + 1);
	  }
	
	  function updatePalletCaseLabel() {
	    var text = "Case";
	    if (isPallet()) {
	      text = "Pallet";
	    }
	    els.palletCaseLabel.text(text);
	  }
	
	  function defaultToOne(numb) {
	    return numb || 1;
	  }
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    bindElements();
	    bindStores();
	    update();
	  }
	
	  function getAsnDetail() {
	    return _AsnDetailStore2.default.getAsnDetail(asnDetailId);
	  }
	}

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AsnDetailRowsView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnDetailRowReviewView = __webpack_require__(515);
	
	var _AsnDetailRowReviewView2 = _interopRequireDefault(_AsnDetailRowReviewView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1224);
	
	
	var elementsMap = {
	  asnDetailRowsChildrenReviewEntry: ".shipping-asn-details-rows-children-review-entry-point",
	  casePalletTitle: ".case-pallet-title"
	};
	
	function AsnDetailRowsView(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      getAsnDetailGroups = _ref.getAsnDetailGroups,
	      isPallet = _ref.isPallet;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var asnDetailRowReviewViews = [];
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {}
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateSelf();
	    updateChildren();
	  }
	
	  function updateSelf() {
	    // No self inputs
	    updateCasePalletLabel();
	  }
	
	  function updateChildren() {
	    (0, _viewHelpers.unbindAll)(asnDetailRowReviewViews);
	    asnDetailRowReviewViews = renderAsnDetailRowReviewViews();
	    els.asnDetailRowsChildrenReviewEntry.html((0, _viewHelpers.extractElements)(asnDetailRowReviewViews));
	  }
	
	  function updateCasePalletLabel() {
	    var text = "Case";
	    if (isPallet()) {
	      text = "Pallet";
	    }
	    els.casePalletTitle.text(text);
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", update);
	    _AsnDetailStore2.default.bindListener("asn_details:add", update);
	    _AsnDetailStore2.default.bindListener("asn_details:remove", update);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	  }
	
	  self.unbindListeners = function () {};
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindStores();
	  }
	
	  function renderAsnDetailRowReviewViews() {
	    return (0, _underscore2.default)(getAsnDetailGroups()).map(function (asnDetailGroup, rowIdx) {
	      // get the first asnDetail in the Pallet/case,
	      // as all these values should be the same for the given
	      // AsnDetailRowView
	      var asnDetail = asnDetailGroup[0];
	      var asnDetailRowReviewView = new _AsnDetailRowReviewView2.default(asnDetail, {
	        rowIdx: rowIdx,
	        isPallet: isPallet
	      });
	      asnDetailRowReviewView.init();
	      return asnDetailRowReviewView;
	    });
	  }
	}

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AsnShippingPalletView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(292);
	
	
	var elementsMap = {
	  asnDetailLength: ".asn-detail-length",
	  asnDetailWidth: ".asn-detail-width",
	  asnDetailHeight: ".asn-detail-height",
	  asnDetailWeight: ".asn-detail-weight",
	  palletCaseIdx: ".pallet-case-idx",
	  palletCaseLabel: ".pallet-case-label",
	  stackablePalletOuter: ".stackable-pallet-outer",
	  stackablePalletVal: ".stackable-pallet-val"
	};
	
	var yesClassName = "q-ppt-purple";
	var noClassName = "q-ppt-grey";
	
	function AsnShippingPalletView(asnShippingPallet, options) {
	
	  var asnShippingPalletId = asnShippingPallet.id;
	
	  var rowIdx = options.rowIdx;
	
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  self.init = function () {
	    render();
	  };
	
	  function bindStores() {
	
	    _AsnShippingPalletStore2.default.bindListener("asn_shipping_pallet:change:" + asnShippingPalletId, updateSelf);
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    // handle rendering children
	    updateSelf();
	  }
	
	  function updateSelf() {
	    console.log("review asn shipping pallet ");
	    // handle updating values;
	    updateValues();
	    updatePalletCaseIdx();
	    updatePalletCaseLabel();
	    updatePalletSpecificFields();
	  }
	
	  function updatePalletSpecificFields() {
	    var isPlt = isPallet();
	    var asnDetail = getAsnDetail();
	    (0, _selectorHelpers.handleDisplayFor)(els.stackablePalletOuter, isPlt);
	    (0, _selectorHelpers.swapClassesViaBool)(els.stackablePalletVal, yesClassName, noClassName, asnDetail.stackablePallet);
	  }
	
	  function updateValues() {
	    var asnDetail = getAsnDetail();
	    (0, _selectorHelpers.insertTextAndClean)(els.asnDetailLength, asnDetail.asd_package_length);
	    (0, _selectorHelpers.insertTextAndClean)(els.asnDetailWidth, asnDetail.asd_package_width);
	    (0, _selectorHelpers.insertTextAndClean)(els.asnDetailHeight, asnDetail.asd_package_height);
	    (0, _selectorHelpers.insertTextAndClean)(els.asnDetailWeight, asnDetail.asd_package_weight);
	    (0, _selectorHelpers.insertTextAndClean)(els.stackablePalletVal, (0, _selectorHelpers.boolToHuman)(asnDetail.stackablePallet));
	  }
	
	  function updatePalletCaseIdx() {
	    els.palletCaseIdx.text(rowIdx + 1);
	  }
	
	  function updatePalletCaseLabel() {
	    var text = "Case";
	    if (isPallet()) {
	      text = "Pallet";
	    }
	    els.palletCaseLabel.text(text);
	  }
	
	  function defaultToOne(numb) {
	    return numb || 1;
	  }
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    bindStores();
	    update();
	  }
	
	  function getAsnShipppingPallet() {
	    return _AsnShippingPalletStore2.default.getAsnDetail(asnShippingPalletId);
	  }
	}

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AsnShippingPalletRowsReview;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnShippingPalletRowReview = __webpack_require__(517);
	
	var _AsnShippingPalletRowReview2 = _interopRequireDefault(_AsnShippingPalletRowReview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1225);
	
	
	var elementsMap = {
	  asnShipppingPalletRowsChildrenReviewEntry: ".asn-shipping-pallet-rows-children-review-entry-point",
	  casePalletTitle: ".case-pallet-title"
	};
	
	function AsnShippingPalletRowsReview(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      getAsnShipppingPallets = _ref.getAsnShipppingPallets;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var asnShippingPalletRowReviews = [];
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {}
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateSelf();
	    updateChildren();
	  }
	
	  function updateSelf() {
	    // No self inputs
	    updateCasePalletLabel();
	  }
	
	  function updateChildren() {
	    console.log("Calling updateChildren");
	    (0, _viewHelpers.unbindAll)(asnShippingPalletRowReview);
	    asnShippingPalletRowReviews = renderasnShippingPalletRowReviews();
	    els.asnDetailRowsChildrenReviewEntry.html((0, _viewHelpers.extractElements)(asnShippingPalletRowReviews));
	  }
	
	  function updateCasePalletLabel() {
	    var text = "Case";
	    if (isPallet()) {
	      text = "Pallet";
	    }
	    els.casePalletTitle.text(text);
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", update);
	    AsnDetailStore.bindListener("asn_shipping_pallet:add", update);
	    AsnDetailStore.bindListener("asn_shipping_pallet:remove", update);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	  }
	
	  self.unbindListeners = function () {};
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindStores();
	  }
	
	  function renderasnShippingPalletRowReviews() {
	    return (0, _underscore2.default)(getAsnShipppingPallets()).map(function (asnShippingPallet, rowIdx) {
	      // get the first asnDetail in the Pallet/case,
	      // as all these values should be the same for the given
	      // AsnDetailRowView
	
	      var asnShippingPalletRowReview = new AsnShippingPalletView(asnShippingPallet, {
	        rowIdx: rowIdx
	      });
	      asnShippingPalletRowReview.init();
	      return asnShippingPalletRowReview;
	    });
	  }
	}

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PackingReviewView;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var packingDetailHtml = __webpack_require__(1228);
	
	var packingProductListHtml = __webpack_require__(1229);
	
	function PackingReviewView(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var packingDetailsContainer = wizardElement.find('.review-packing-details-container');
	
	  var upperCasePacking = void 0,
	      lowerCasePacking = void 0;
	
	  self.init = function () {
	    var shouldSelectPallet = !!_AsnStore2.default.getAsnWithShippingMethod("pallet");
	    var shouldSelectPallet2 = _AsnStore2.default.getAsnWithShippingMethod().shippingMethod;
	
	    if (shouldSelectPallet2 === "pallet") {
	      upperCasePacking = "Pallet";
	      lowerCasePacking = "pallet";
	    } else {
	      upperCasePacking = "Case";
	      lowerCasePacking = "case";
	    }
	    bindStores();
	    populatePackingDetails();
	    //populateAsnShippingPallets();
	  };
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", populatePackingDetails);
	
	    _AsnStore2.default.bindListener("asns:shipping_partner_changed", populatePackingDetails);
	    _AsnDetailStore2.default.bindListener("asn_details:add", populatePackingDetails);
	    _AsnDetailStore2.default.bindListener("asn_details:remove", populatePackingDetails);
	    _AsnDetailStore2.default.bindListener("asn_details:change", populatePackingDetails);
	  }
	
	  function populatePackingDetails() {
	    packingDetailsContainer.html('');
	    (0, _underscore2.default)(getCasesOrPallets()).map(function (asnDetail, rowIdx) {
	      rowIdx = rowIdx + 1;
	      var ids = (0, _underscore2.default)(asnDetail).pluck("id");
	      var packingDetail = buildPackingDetail(ids);
	      packingDetailsContainer.append(packingDetail);
	    });
	  }
	
	  function getCasesOrPallets() {
	    if (isPallet()) {
	      return _AsnDetailStore2.default.organizeIntoPallets(getAsnDetails());
	    } else if (isParcel()) {
	      return _AsnDetailStore2.default.organizeIntoCases(getAsnDetails());
	    }
	  }
	
	  function buildPackingDetail(ids) {
	    var numberOfCasesOrPallets = 1;
	    var caseOrPalletLineNumber = 1;
	    var asnDetail = getFirstProduct(ids);
	    if (!asnDetail.packingTypeName) {
	      // if name is not exist
	      if (isParcel()) {
	        asnDetail.packingTypeName = "Case " + asnDetail.caseLineNumber;
	      } else {
	        asnDetail.packingTypeName = "Pallet " + asnDetail.palletLineNumber;
	      }
	    }
	
	    if (isParcel()) {
	      numberOfCasesOrPallets = getFirstProductNumberOfCases(ids);
	      caseOrPalletLineNumber = asnDetail.caseLineNumber;
	    } else {
	      numberOfCasesOrPallets = getFirstProductNumberOfPallets(ids);
	      caseOrPalletLineNumber = asnDetail.palletLineNumber;
	    }
	
	    var customCaseOrPalletIds = "";
	    if (asnDetail.hasCustomIds) {
	      customCaseOrPalletIds = asnDetail.customCaseOrPalletIds;
	    }
	
	    var packingDetailsEl = (0, _render2.default)(packingDetailHtml, {
	      packingTypeUpperCase: getPackingType(upperCasePacking),
	      packingType: getPackingType(lowerCasePacking),
	      packingTypeName: asnDetail.packingTypeName,
	      numberOfCasesOrPallets: numberOfCasesOrPallets,
	      revPackingProductsList: getPackingDetailProducts(ids),
	      caseOrPalletLineNumber: caseOrPalletLineNumber,
	      hasMultipleProducts: true,
	      isFedex: hasShippingPartner(),
	      isPalletShipping: _AsnStore2.default.hasFreigthSelected(getAsn().id),
	      length: asnDetail.asd_package_length,
	      width: asnDetail.asd_package_width,
	      height: asnDetail.asd_package_height,
	      weight: asnDetail.asd_package_weight,
	      declaredValue: (0, _general.isTruthy)(asnDetail.dvlInsideCase) ? asnDetail.declaredValue : 0,
	      hasCustomIds: asnDetail.hasCustomIds,
	      customCaseOrPalletIds: customCaseOrPalletIds
	    });
	    return packingDetailsEl;
	  }
	
	  function hasShippingPartner() {
	    return _AsnStore2.default.hasShippingPartner(getAsn());
	  }
	
	  function getFirstProductNumberOfCases(ids) {
	    return parseInt(getFirstProduct(ids).numberOfCases, 10) || 1;
	  }
	
	  function getFirstProductNumberOfPallets(ids) {
	    return parseInt(getFirstProduct(ids).numberOfPallets, 10) || 1;
	  }
	
	  function getFirstProduct(ids) {
	    return getProducts(ids)[0];
	  }
	
	  function getFirstAsnShippingPallet(ids) {
	    return getAsnShippingPalletsView(ids)[0];
	  }
	
	  function getPackingType(packingType) {
	    return packingType;
	  }
	
	  function getPackingDetailProducts(ids) {
	    var html = "";
	    (0, _underscore2.default)(getProducts(ids)).map(function (asnDetail, rowIdx) {
	      rowIdx = rowIdx + 1;
	      html = html.concat(buildPackingDetailList(asnDetail, rowIdx));
	    });
	    return html;
	  }
	
	  function getProducts(ids) {
	    return _AsnDetailStore2.default.getAsnDetails(ids);
	  }
	
	  function getAsnShippingPalletsView(ids) {
	    return _AsnShippingPalletStore2.default.getAsnShippingPallets(ids);
	  }
	
	  function buildPackingDetailList(asnDetail, rowIdx) {
	    var totalUnits = 1;
	    if (isParcel()) {
	      totalUnits = asnDetail.unitsPerCase * asnDetail.numberOfCases;
	    } else {
	      totalUnits = asnDetail.unitsPerCase * asnDetail.numberOfPallets;
	    }
	
	    var listItem = (0, _render2.default)(packingProductListHtml, {
	      packingType: getPackingType(lowerCasePacking),
	      asnDetailRowId: asnDetail.id,
	      skuName: asnDetail.sku,
	      skuDesc: asnDetail.sku,
	      unitsPerCase: asnDetail.unitsPerCase,
	      totalUnits: totalUnits,
	      packingExpDate: asnDetail.expirationDate,
	      lotNumber: asnDetail.batchLotNumber,
	      hasExpDateField: hasExpDate(asnDetail.sku),
	      hasLotNumberField: hasLotNumber(asnDetail.sku)
	    });
	    return listItem;
	  }
	
	  function hasLotNumber(sku) {
	    return doesProductForSkuRequireLotNumber(sku);
	  }
	
	  function doesProductForSkuRequireLotNumber(sku) {
	    var productItem = getProductItemForSku(sku);
	    return productItem && ProductItemStore.doesRequireLotNumber(productItem);
	  }
	
	  function hasExpDate(sku) {
	    return isProductForSkuPerishable(sku);
	  }
	
	  function isProductForSkuPerishable(sku) {
	    var productItem = getProductItemForSku(sku);
	    return productItem && ProductItemStore.isPerishable(productItem);
	  }
	
	  function getProductItemForSku(sku) {
	    return ProductItemStore.findWhere({ itmSku: sku });
	  }
	
	  function getShippingMethod() {
	    return _AsnStore2.default.getShippingMethod();
	  }
	
	  function isParcel() {
	    return getShippingMethod() === 'parcel';
	  }
	
	  function isPallet() {
	    return getShippingMethod() === 'pallet';
	  }
	
	  function getAsnDetails() {
	    return _AsnStore2.default.getAsnDetails(getAsn());
	  }
	
	  function getAsnShippingPallets() {
	    return _AsnStore2.default.getAsnShipppingPallets(getAsn());
	  }
	
	  function getAsn() {
	    if (isPallet()) return _AsnStore2.default.getOrCreateAsnWithShippingMethod("pallet");else if (isParcel()) return _AsnStore2.default.getOrCreateAsnWithShippingMethod("parcel");
	  }
	
	  function hasFreigthSelected(asnId) {
	    return _AsnStore2.default.hasFreigthSelected(asnId);
	  }
	}

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PickupSchedulingReviewView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1226);
	
	
	var elementsMap = {
	  pickupDate: ".pickup-date-val",
	  pickupTime: ".pickup-time-val",
	  insidePickup: ".inside-pickup-val",
	  liftGatePickup: ".lift-gate-pickup-val",
	  limitedAccess: ".limited-access-val",
	  lumperPickup: ".lumper-pickup-val",
	  driverLoad: ".driver-load-val",
	
	  insidePickupMessage: ".inside-pickup-message",
	  liftGatePickupMessage: ".lift-gate-pickup-message",
	  limitedAccessMessage: ".limited-acess-message",
	  lumperPickupMessage: ".lumper-pickup-message",
	  driverLoadMessage: ".driver-load-message"
	};
	
	var yesClassName = "q-ppt-purple";
	var noClassName = "q-ppt-blue-border";
	
	function PickupSchedulingReviewView(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      isPallet = _ref.isPallet;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {}
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateSelf();
	  }
	
	  function updateSelf() {
	    updateValues();
	    updateClasses();
	    updateMessages();
	  }
	
	  function updateValues() {
	    var asn = getAsn();
	    (0, _selectorHelpers.insertTextAndClean)(els.pickupDate, (0, _general.toWeekDayMonthAndDay)(asn.pickupDate));
	    (0, _selectorHelpers.insertTextAndClean)(els.pickupTime, getPickupTimeRange(asn));
	    (0, _selectorHelpers.insertTextAndClean)(els.insidePickup, (0, _selectorHelpers.boolToHuman)(asn.insidePickup));
	    (0, _selectorHelpers.insertTextAndClean)(els.liftGatePickup, (0, _selectorHelpers.boolToHuman)(asn.liftGatePickup));
	    (0, _selectorHelpers.insertTextAndClean)(els.limitedAccess, (0, _selectorHelpers.boolToHuman)(asn.limitedAccess));
	    (0, _selectorHelpers.insertTextAndClean)(els.lumperPickup, (0, _selectorHelpers.boolToHuman)(asn.lumperPickup));
	    (0, _selectorHelpers.insertTextAndClean)(els.driverLoad, (0, _selectorHelpers.boolToHuman)(asn.driverLoad));
	  }
	
	  function getPickupTimeRange(asn) {
	    var ptf = (0, _general.militaryToPeriodTime)(asn.pickupTimeFrom);
	    var ptt = (0, _general.militaryToPeriodTime)(asn.pickupTimeTo);
	    return ptf + " - " + ptt;
	  }
	
	  function updateClasses() {
	    var asn = getAsn();
	    (0, _selectorHelpers.swapClassesViaBool)(els.insidePickup, yesClassName, noClassName, asn.insidePickup);
	    (0, _selectorHelpers.swapClassesViaBool)(els.liftGatePickup, yesClassName, noClassName, asn.liftGatePickup);
	    (0, _selectorHelpers.swapClassesViaBool)(els.limitedAccess, yesClassName, noClassName, asn.limitedAccess);
	    (0, _selectorHelpers.swapClassesViaBool)(els.lumperPickup, yesClassName, noClassName, asn.lumperPickup);
	    (0, _selectorHelpers.swapClassesViaBool)(els.driverLoad, yesClassName, noClassName, asn.driverLoad);
	  }
	
	  function updateMessages() {
	    var asn = getAsn();
	    (0, _selectorHelpers.handleDisplayForV2)(els.insidePickupMessage, asn.insidePickup);
	    (0, _selectorHelpers.handleDisplayForV2)(els.liftGatePickupMessage, asn.liftGatePickup);
	    (0, _selectorHelpers.handleDisplayForV2)(els.limitedAccessMessage, asn.limitedAccess);
	    (0, _selectorHelpers.handleDisplayForV2)(els.lumperPickupMessage, asn.lumperPickup);
	    (0, _selectorHelpers.handleDisplayForV2)(els.driverLoadMessage, asn.driverLoad);
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	  }
	
	  self.unbindListeners = function () {
	    _AsnStore2.default.unbindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.unbindListener("asns:change", updateSelf);
	  };
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindStores();
	  }
	}

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReviewTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	var _ServicesTab = __webpack_require__(196);
	
	var _ServicesTab2 = _interopRequireDefault(_ServicesTab);
	
	var _ShippingReviewView = __webpack_require__(523);
	
	var _ShippingReviewView2 = _interopRequireDefault(_ShippingReviewView);
	
	var _PackingReviewView = __webpack_require__(519);
	
	var _PackingReviewView2 = _interopRequireDefault(_PackingReviewView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*import PalletShippingView from "../ContentsTab/PalletShippingView";
	import ParcelShippingView from "../ContentsTab/ParcelShippingView";*/
	var elementsMap = {
	  sectionTitlesReviewTab: ".section-step-title-inner",
	
	  reviewTabShippingOriginFacVal: ".review-tab-shipping-origin-fac-val",
	  originFacilityName: ".origin-facility-name",
	  reviewTabShippingOriginAddressVal: ".review-tab-shipping-origin-address-val",
	  originFacilityAddress: "#origin-fac-address",
	
	  reviewTabShippingDestinationFacVal: ".review-tab-shipping-dest-fac-val",
	  destinationFacilityName: ".destination-facility-name",
	  reviewTabShippingDestinationAddressVal: ".review-tab-shipping-dest-address-val",
	  destinationFacilityAddress: "#dest-fac-address",
	
	  reviewTabPhoneNumberVal: ".review-tab-phone-number-val",
	  contactPhoneInput: ".cad-contact-phone-input",
	
	  reviewTabShippingFromAddressVal: ".review-tab-shipping-from-address-val",
	
	  countrySelect: ".cad-country-select",
	  address1Input: ".cad-address-1-input",
	  address2Input: ".cad-address-2-input",
	  cityInput: ".cad-city-input",
	  stateSelect: ".cad-state-select",
	  stateTextInput: ".cad-state-text-input",
	  zipInput: ".cad-zip-input",
	
	  reviewTabShippingToVal: ".review-tab-shipping-to-val",
	  shippingToSelect: ".shipping-to-select",
	
	  // reviewTabShippingToAddressVal: ".review-tab-shipping-to-address-val"
	
	  shippingReviewEntryPoint: ".shipping-review-entry-point",
	  printPackingSlipDiv: ".print-packing-slip-div"
	};
	//import _ from 'underscore';
	
	
	var widgetElementsMap = {
	  palletCasesSection: ".pallet-cases-section",
	  parcelCasesSection: ".parcel-cases-section",
	  servicesEntryPoint: ".review-tab-services-entry-point"
	};
	
	function ReviewTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var reviewTabElement = wizardElement.find(".review-tab");
	  var defaultCarriers = wizardElement.data('default-carrier');
	  var els = {};
	  //let palletShippingView;
	  //let parcelShippingView;
	  var packingReviewView = void 0;
	  var servicesTabView = void 0;
	  var shippingReviewView = void 0;
	
	  self.init = function () {
	    setElements();
	    bindElements();
	    initWidgets();
	    //bindStores();
	  };
	
	  self.didNavigateToForm = function () {
	    fillElementsWithVals();
	    initWidgets();
	    printPackinglabelchange();
	  };
	
	  /*  function bindStores(){
	      AsnStore.bindListener("asns:shipping_method_changed", toggleCasePalletSubviewsViews);
	      AsnDetailStore.bindListener("asn_details:add", toggleCasePalletSubviewsViews);
	      AsnDetailStore.bindListener("asn_details:remove", toggleCasePalletSubviewsViews);
	    }
	  */
	
	  function bindElements() {
	    els.sectionTitlesReviewTab.bind('click', function () {
	      var form = wizardElement.find((0, _jquery2.default)(this).data("target-form"));
	      wizard.gotToForm(form);
	    });
	  }
	
	  function initWidgets() {
	    var readOnly = true;
	
	    packingReviewView = new _PackingReviewView2.default(wizard);
	    packingReviewView.init();
	
	    // Services Tab Component
	
	    servicesTabView = new _ServicesTab2.default(wizard, { scopeElement: els.servicesEntryPoint, readOnly: readOnly });
	    servicesTabView.init();
	
	    // Shipping Review Component
	    shippingReviewView = new _ShippingReviewView2.default(null, {
	      getAsn: getAsn,
	      getAsnDetailGroups: getOrganizedAsnDetails,
	      getSelectedQuoteForAsn: getSelectedQuoteForAsn,
	      hasShippingPartner: hasShippingPartner,
	      isInboundCarrierOther: isInboundCarrierOther,
	      isPallet: isPallet,
	      getAsnShipppingPallets: getAsnShipppingPallets
	    });
	    shippingReviewView.init();
	    els.shippingReviewEntryPoint.html(shippingReviewView.getElement());
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardElement);
	    (0, _selectorHelpers.setElementsFromScope)(els, widgetElementsMap, reviewTabElement);
	  }
	
	  function fillElementsWithVals() {
	
	    fillLocationsArea();
	  }
	
	  function fillLocationsArea() {
	
	    //els.reviewTabShippingFromVal.text(els.locationNameInput.val());
	    //els.reviewTabContactNameVal.text(els.contactNameInput.val());
	    //els.reviewTabPhoneNumberVal.text(els.contactPhoneInput.val());
	
	    //const fromAddress = formatFromAddress();
	    //els.reviewTabShippingFromAddressVal.text(fromAddress);
	
	    //els.reviewTabShippingToVal.text(els.shippingToSelect.find(":selected").text());
	
	    els.reviewTabShippingOriginFacVal.text(els.originFacilityName.find(":selected").text());
	    els.reviewTabShippingOriginAddressVal.html(els.originFacilityAddress.html());
	    els.reviewTabShippingDestinationFacVal.text(els.destinationFacilityName.find(":selected").text());
	    els.reviewTabShippingDestinationAddressVal.html(els.destinationFacilityAddress.html());
	
	    // els.orderReferenceNumberReviewTab.html(els.orderReferenceNumber.val());
	    // els.shippingTypeReviewTab.html(selectVal(els.shippingTypeSelect));
	    // els.customerEmailReviewTab.html(els.customerEmail.val());
	    // els.sendTrackingInfoReviewTab.html(trackingInfoBoolToHtml());
	    // els.addressReviewTab.html(addressFormatted());
	
	    // const showable = combineElements([
	    //   els.shippingTypeOuterReviewTab,
	    //   els.orderReferenceNumberOuterReviewTab,
	    //   els.customerEmailOuterReviewTab,
	    //   els.sendTrackingInfoOuterReviewTab,
	    //   els.addressOuterReviewTab
	    // ]);
	    // show(showable);
	  }
	  function printPackinglabelchange() {
	    if (getAsn().printPackingSlipFlag) {
	      els.printPackingSlipDiv.html("<span class='q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg'>Yes</span>");
	    } else {
	      els.printPackingSlipDiv.html("<span class='q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg'>No</span>");
	    }
	  }
	
	  /*  function formatFromAddress(){
	      return formatAddress({
	        address1: els.address1Input.val(),
	        address2: els.address2Input.val(),
	        city: els.cityInput.val(),
	        state: getState(),
	        zip: els.zipInput.val(),
	        country: els.countrySelect.find(":selected").text()
	      });
	    }
	  */
	  function getState() {
	    var state = els.stateSelect.val();
	    if (!state || state === "-1") {
	      state = els.stateTextInput.val();
	    }
	    return state;
	  }
	
	  /* function toggleCasePalletSubviewsViews(){
	     if(isParcel()){
	       showParcelRelatedViews();
	     }
	     else if(isPallet()){
	       showPalletRelatedViews();
	     }
	   }
	  
	   function showParcelRelatedViews(){
	     hide(els.palletCasesSection);
	     let asn = AsnStore.getOrCreateAsnWithShippingMethod("parcel");
	  
	     if(AsnStore.getAsnDetails(asn).length){
	       show(els.parcelCasesSection);
	     }
	     else{
	       hide(els.parcelCasesSection);
	     }
	   }
	  
	  
	   function showPalletRelatedViews(){
	     hide(els.parcelCasesSection);
	     let asn = AsnStore.getOrCreateAsnWithShippingMethod("pallet");
	  
	     if(AsnStore.getAsnDetails(asn).length){
	       show(els.palletCasesSection);
	     }
	     else{
	       hide(els.palletCasesSection);
	     }
	   }
	  */
	  function getAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	
	  /*  function getAsnId(){
	      return getAsn().id;
	    }
	  */
	
	  function getAsnDetails() {
	    return _AsnStore2.default.getAsnDetails(getAsn());
	  }
	
	  function getAsnShippingPallet() {
	    return _AsnStore2.default.getAsnShippingPallet(getAsn());
	  }
	
	  function hasShippingPartner() {
	    return _AsnStore2.default.hasShippingPartner(getAsn());
	  }
	
	  // store function wrappers
	  function getShippingMethod() {
	    return _AsnStore2.default.getShippingMethod();
	  }
	
	  function getSelectedQuoteForAsn() {
	    return _AsnStore2.default.getSelectedQuoteForAsn(getAsn());
	  }
	
	  function isInboundCarrierOther() {
	    var inboundCarrierVal = getAsn().inboundCarrier;
	    if (inboundCarrierVal !== null) {
	      for (var keyValue in defaultCarriers) {
	        if (inboundCarrierVal === defaultCarriers[keyValue].cdmValue) {
	          return false;
	        } else if (inboundCarrierVal === "Other") {
	          return true;
	        }
	      }
	      return true;
	    }
	  }
	
	  /*  function isParcel(){
	      return getShippingMethod() === 'parcel';
	    }
	    */
	  function isPallet() {
	    return getShippingMethod() === 'pallet';
	  }
	
	  function getOrganizedAsnDetails() {
	    if (isPallet()) {
	      return _AsnDetailStore2.default.organizeIntoPallets(getAsnDetails());
	    } else {
	      return _AsnDetailStore2.default.organizeIntoCases(getAsnDetails());
	    }
	  }
	
	  function getAsnShipppingPallets() {
	    return _AsnStore2.default.getAsnShipppingPallets(getAsn());
	  }
	}

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShippingQuoteReviewView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _general = __webpack_require__(5);
	
	var _currency = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1230);
	
	
	var elementsMap = {
	  estimatedPickupDate: ".estimated-pickup-date-val",
	  estimatedTransitTime: ".estimated-transit-time-val",
	  estimatedCost: ".estimated-cost-val"
	};
	
	function ShippingQuoteReviewView(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      getQuote = _ref.getQuote,
	      isPallet = _ref.isPallet;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {}
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateSelf();
	  }
	
	  function updateSelf() {
	    updateValues();
	  }
	
	  function updateValues() {
	    var quote = getQuote();
	    if (quote) {
	      (0, _selectorHelpers.insertTextAndClean)(els.estimatedPickupDate, (0, _general.toWeekDayMonthAndDay)(quote.estimatedPickupDate));
	      (0, _selectorHelpers.insertTextAndClean)(els.estimatedTransitTime, quote.estimatedTransitTime);
	      (0, _selectorHelpers.insertTextAndClean)(els.estimatedCost, (0, _currency.toCurrency)(quote.estimatedCost));
	    }
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	  }
	
	  self.unbindListeners = function () {
	    _AsnStore2.default.unbindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.unbindListener("asns:change", updateSelf);
	  };
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindStores();
	  }
	}

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShippingReviewView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _ShippingMethodStore = __webpack_require__(113);
	
	var _ShippingMethodStore2 = _interopRequireDefault(_ShippingMethodStore);
	
	var _CaseArrivalAndTrackingRowView = __webpack_require__(537);
	
	var _CaseArrivalAndTrackingRowView2 = _interopRequireDefault(_CaseArrivalAndTrackingRowView);
	
	var _AsnDetailRowsReviewView = __webpack_require__(516);
	
	var _AsnDetailRowsReviewView2 = _interopRequireDefault(_AsnDetailRowsReviewView);
	
	var _AsnShippingPalletRowsReview = __webpack_require__(518);
	
	var _AsnShippingPalletRowsReview2 = _interopRequireDefault(_AsnShippingPalletRowsReview);
	
	var _PickupSchedulingReviewView = __webpack_require__(520);
	
	var _PickupSchedulingReviewView2 = _interopRequireDefault(_PickupSchedulingReviewView);
	
	var _ShippingQuoteReviewView = __webpack_require__(522);
	
	var _ShippingQuoteReviewView2 = _interopRequireDefault(_ShippingQuoteReviewView);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1232);
	var carrBrokerhtml = __webpack_require__(1231);
	
	var asnShippingPalletHtml = __webpack_require__(1227);
	
	var elementsMap = {
	  inboundCarrierOuter: ".inbound-carrier-outer",
	  asnDetailRowsReviewViewEntryPoint: ".asn-details-rows-view-entry-point",
	  asnShippingPalletViewEntryPoint: ".asn-shipping-pallet-view-entry-point",
	  caseArrivalAndTrackingRows: ".case-exp-arrival-tracking-rows",
	
	  inboundCarrierText: ".inbound-carrier-text",
	  inboundBrokerText: ".inbound-broker-text",
	
	  inboundCarrierContainer: ".inbound-carrier",
	  inboundBrokerContainer: ".inbound-broker",
	
	  parcelPalletNoOtherContainers: ".parcel-pallet-no-other",
	  contactNameText: ".contact-name-text",
	  contactPhoneNumberText: ".contact-phone-number-text",
	
	  estimatedArrivalDateContainer: '.estimated-arrival-date',
	  estimatedArrivalDateText: '.estimated-arrival-date-text',
	
	  trackingNumbersContainer: '.tracking-numbers',
	  trackingNumbersText: '.tracking-numbers-text',
	
	  palletNoContainers: ".pallet-no",
	  bolProOuter: ".bol-pro-outer",
	  bolProNumberText: ".bol-pro-number-text",
	  expArrivalDateText: ".exp-arrival-date-text",
	
	  pickupSchedulingReviewViewEntryPoint: ".pickup-scheduling-review-view-entry-point",
	  shippingQuoteReviewViewEntryPoint: ".shipping-quote-review-view-entry-point",
	
	  asnShippingPalletsContainer: ".review-asn-shipping-pallets-container",
	
	  printShippingLabelYes: ".print-shipping-label-yes",
	  printShippingLabelNo: ".print-shipping-label-no"
	};
	
	function ShippingReviewView(_unused) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      getAsn = _ref.getAsn,
	      getAsnDetailGroups = _ref.getAsnDetailGroups,
	      isPallet = _ref.isPallet,
	      hasShippingPartner = _ref.hasShippingPartner,
	      isInboundCarrierOther = _ref.isInboundCarrierOther,
	      getSelectedQuoteForAsn = _ref.getSelectedQuoteForAsn,
	      getAsnShipppingPallets = _ref.getAsnShipppingPallets;
	
	  var self = this;
	
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var caseArrivalAndTrackingRowViews = [];
	  var asn = void 0;
	
	  self.init = function () {
	    renderElements();
	    populateAsnShippingPallets();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {
	    // this only needs to be rendered ONCE,
	    // It has it's own Store bindings to
	    // rerender itself
	    //renderAsnDetailRowsView();
	    renderPickupSchedulingReviewView();
	    renderShippingQuoteReviewView();
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function renderElements() {
	
	    asn = getAsn();
	    if (asn != null && asn.asn_org_id !== "" && asn.asn_org_id != null && !hasShippingPartner() && (asn.asn_org_id == undefined || asn.asn_org_id != 0)) {
	      self._element = (0, _jquery2.default)(carrBrokerhtml);
	    } else {
	      self._element = (0, _jquery2.default)(html);
	      asn.asn_org_id = null;
	    }
	
	    setElements();
	    setWidgets();
	    update();
	    bindElements();
	    bindStores();
	  }
	
	  function update() {
	    updateSelf();
	    //updateChildren();
	  }
	
	  function updateChildren() {
	    if (!isPallet()) {
	      (0, _viewHelpers.unbindAll)(caseArrivalAndTrackingRowViews);
	      caseArrivalAndTrackingRowViews = renderCaseArrivalAndTrackingRowViews();
	      els.caseArrivalAndTrackingRows.html((0, _viewHelpers.extractElements)(caseArrivalAndTrackingRowViews));
	    }
	  }
	
	  function updateSelf() {
	    updateValues();
	    var asn = getAsn();
	    var isPlt = isPallet();
	    var hasPartner = hasShippingPartner();
	    var isInboundOther = isInboundCarrierOther();
	    var freightShipping = asn.freightShipping;
	    // For:
	    // Parcel OR Pallet with NO shipping partner AND "Other" Selected
	    (0, _selectorHelpers.handleDisplayFor)(els.parcelPalletNoOtherContainers, !hasPartner && isInboundOther);
	
	    // If not a partner, then show estimated arrival 
	    (0, _selectorHelpers.handleDisplayFor)(els.estimatedArrivalDateContainer, !hasPartner);
	
	    // If it is case and not partner and freight shipping not selected, then show tracking number
	    (0, _selectorHelpers.handleDisplayFor)(els.trackingNumbersContainer, !isPlt && !hasPartner && !freightShipping);
	
	    // For Case specific arrival and tracking rows
	    // Not pallet, and No partner
	    (0, _selectorHelpers.handleDisplayFor)(els.caseArrivalAndTrackingRows, !isPlt && !hasPartner);
	    (0, _selectorHelpers.handleDisplayFor)(els.inboundCarrierContainer, _AsnStore2.default.getCarrierBroker() == 'carrier');
	    (0, _selectorHelpers.handleDisplayFor)(els.inboundBrokerContainer, _AsnStore2.default.getCarrierBroker() == 'broker');
	
	    // WITH partner, WITH pallet OR parcel
	    // need to show dimensions and weight
	
	    (0, _selectorHelpers.handleDisplayFor)(els.asnDetailRowsReviewViewEntryPoint, hasPartner);
	
	    (0, _selectorHelpers.handleDisplayFor)(els.palletNoContainers, isPlt && !hasPartner);
	    // If it is not partner AND (pallet OR case and not partner and freight shipping) is selected, then show BOL
	    (0, _selectorHelpers.handleDisplayFor)(els.bolProOuter, !hasPartner && (isPlt || !isPlt && freightShipping));
	
	    // is Pallet, AND has partner YES
	    var hasAsnShippingPallets = _AsnShippingPalletStore2.default.getAllAsnShippingPallets();
	    //const isPltAndHasPartner =  && hasPartner;
	
	    var hasShippingPalletsAndHasPartner = (checkForPalletShipping(hasAsnShippingPallets) || isPlt) && hasPartner;
	    var hasShippingPalletsAndHasPartnerAndQuote = asn.requestQuoteSuccess && hasPartner;
	    (0, _selectorHelpers.handleDisplayFor)(els.pickupSchedulingReviewViewEntryPoint, hasShippingPalletsAndHasPartner);
	    (0, _selectorHelpers.handleDisplayFor)(els.shippingQuoteReviewViewEntryPoint, hasShippingPalletsAndHasPartnerAndQuote);
	    (0, _selectorHelpers.handleDisplayFor)(els.asnShippingPalletsContainer, checkForPalletShipping(hasAsnShippingPallets));
	    if (asn.printShippingLabelFlag) {
	      (0, _selectorHelpers.handleDisplayFor)(els.printShippingLabelYes, true);
	      (0, _selectorHelpers.handleDisplayFor)(els.printShippingLabelNo, false);
	    } else {
	      (0, _selectorHelpers.handleDisplayFor)(els.printShippingLabelYes, false);
	      (0, _selectorHelpers.handleDisplayFor)(els.printShippingLabelNo, true);
	    }
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", update);
	    _AsnStore2.default.bindListener("asns:shipping_partner_changed", updateSelf);
	
	    _AsnDetailStore2.default.bindListener("asn_details:add", update);
	    _AsnDetailStore2.default.bindListener("asn_details:change", update);
	    _AsnDetailStore2.default.bindListener("asn_details:remove", update);
	    _AsnShippingPalletStore2.default.bindListener("asn_details:change", update);
	    _AsnShippingPalletStore2.default.bindListener("asn_details:add", update);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	  }
	
	  self.unbindListeners = function () {};
	
	  function bindElements() {}
	
	  function updateValues() {
	    var asn = getAsn();
	    var isPlt = isPallet();
	    var isInboundOther = isInboundCarrierOther();
	    var hasPartner = hasShippingPartner();
	    var inboundCarrierText = asn.asn_carrier_name;
	    var inboundBrokerText = asn.asn_carrier_name;
	    var freightShipping = asn.freightShipping;
	
	    if (isInboundOther) {
	      // if inbound carrier is "Other",
	      // then use the actual name they typed in
	      // the additional text box
	      inboundCarrierText = asn.asn_carrier_name;
	    }
	    if (_AsnStore2.default.getCarrierBroker() == 'broker' && !hasPartner) {
	      (0, _selectorHelpers.insertTextAndClean)(els.inboundBrokerText, inboundCarrierText);
	    } else if (_AsnStore2.default.getCarrierBroker() == 'carrier' && !hasPartner) {
	      (0, _selectorHelpers.insertTextAndClean)(els.inboundCarrierText, inboundCarrierText);
	    } else {
	      (0, _selectorHelpers.insertTextAndClean)(els.inboundCarrierText, getAsn().inboundCarrier);
	    }
	    (0, _selectorHelpers.insertTextAndClean)(els.estimatedArrivalDateText, asn.asn_expected_arrival_date);
	
	    if (isInboundOther) {
	      (0, _selectorHelpers.insertTextAndClean)(els.contactNameText, asn.asn_carrier_contact_name);
	      (0, _selectorHelpers.insertTextAndClean)(els.contactPhoneNumberText, asn.asn_carrier_phone_code + ' ' + asn.asn_carrier_phone);
	    }
	
	    if (!isPlt && !freightShipping && !hasPartner && _AsnStore2.default.getAsnDetails(asn).length > 0) {
	      (0, _selectorHelpers.insertTextAndClean)(els.trackingNumbersText, _AsnStore2.default.getAsnDetails(asn)[0].asd_tracking_number);
	    }
	
	    if (!hasPartner && (isPlt || !isPlt && freightShipping)) {
	      (0, _selectorHelpers.insertTextAndClean)(els.bolProNumberText, asn.asn_bol_pro_number);
	    }
	  }
	
	  function getShippingMethods() {
	    return _ShippingMethodStore2.default.dataAsArray();
	  }
	
	  function renderAsnDetailRowsView() {
	    var asnDetailRowsReviewView = new _AsnDetailRowsReviewView2.default(null, {
	      readOnly: true,
	      getAsn: getAsn,
	      getAsnDetailGroups: getAsnDetailGroups,
	      isPallet: isPallet
	    });
	    asnDetailRowsReviewView.init();
	    els.asnDetailRowsReviewViewEntryPoint.html(asnDetailRowsReviewView.getElement());
	  }
	
	  function renderAsnShipppingPalletRowsView() {
	    var asnShippingPalletRowsReview = new _AsnShippingPalletRowsReview2.default(null, {
	      readOnly: true,
	      getAsn: getAsn,
	      getAsnShipppingPallets: getAsnShipppingPallets
	    });
	    asnShippingPalletRowsReview.init();
	    els.asnShippingPalletReviewEntryPoint.html(asnDetailRowsReviewView.getElement());
	  }
	
	  function renderShippingQuoteReviewView() {
	    var shippingQuoteReviewView = new _ShippingQuoteReviewView2.default(null, {
	      getAsn: getAsn,
	      isPallet: isPallet,
	      getQuote: getSelectedQuoteForAsn
	    });
	    shippingQuoteReviewView.init();
	    els.shippingQuoteReviewViewEntryPoint.html(shippingQuoteReviewView.getElement());
	  }
	
	  function renderPickupSchedulingReviewView() {
	    var pickupSchedulingReviewView = new _PickupSchedulingReviewView2.default(null, {
	      getAsn: getAsn,
	      isPallet: isPallet
	    });
	    pickupSchedulingReviewView.init();
	    els.pickupSchedulingReviewViewEntryPoint.html(pickupSchedulingReviewView.getElement());
	  }
	
	  function renderCaseArrivalAndTrackingRowViews() {
	    return (0, _underscore2.default)(getAsnDetailGroups()).map(function (asnDetailGroup, rowIdx) {
	      // get the first asnDetail in the case,
	      // as all these values should be the same for the given
	      // CaseArrivalAndTrackingRowView
	      var asnDetail = asnDetailGroup[0];
	      var caseArrivalAndTrackingRowView = new _CaseArrivalAndTrackingRowView2.default(asnDetail, {
	        readOnly: true,
	        rowIdx: rowIdx
	      });
	      caseArrivalAndTrackingRowView.init();
	      return caseArrivalAndTrackingRowView;
	    });
	  }
	
	  function checkForPalletShipping(hasAsnShippingPalletsData) {
	    var hasAsnShippingPalletsLength = false;
	
	    if (_underscore2.default.isEmpty(hasAsnShippingPalletsData)) {
	      hasAsnShippingPalletsLength = false;
	    } else {
	      hasAsnShippingPalletsLength = true;
	    }
	
	    return hasAsnShippingPalletsLength;
	  }
	
	  function populateAsnShippingPallets() {
	    els.asnShippingPalletsContainer.html('');
	    (0, _underscore2.default)(getAsnShippingPallets()).map(function (asnShippingPallet, rowIdx) {
	      rowIdx = rowIdx + 1;
	      //let ids = _(asnShippingPallet).pluck("id");
	      var detailHtml = buildAsnShippingPallets(asnShippingPallet, rowIdx);
	      els.asnShippingPalletsContainer.append(detailHtml);
	    });
	  }
	
	  function buildAsnShippingPallets(asnShippingPallet, palletId) {
	    var numberOfPallets = 1;
	    var palletLineNumber = 1;
	    //const asnShippingPallet = getFirstAsnShippingPallet(ids);
	
	    var asnShippingPalletEL = (0, _render2.default)(asnShippingPalletHtml, {
	      packingTypeUpperCase: "Pallet",
	      numberOfCasesOrPallets: "2",
	      caseOrPalletLineNumber: palletId,
	      length: asnShippingPallet.asp_pallet_length,
	      width: asnShippingPallet.asp_pallet_width,
	      height: asnShippingPallet.asp_pallet_height,
	      weight: asnShippingPallet.asp_pallet_weight,
	      stackable: asnShippingPallet.asp_pallet_stackable
	    });
	    return asnShippingPalletEL;
	  }
	
	  function getAsnShippingPallets() {
	    return _AsnStore2.default.getAsnShipppingPallets(getAsn());
	  }
	}

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SaveAsn;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _AsnSerializer = __webpack_require__(222);
	
	var _AsnSerializer2 = _interopRequireDefault(_AsnSerializer);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _ShippingMethodStore = __webpack_require__(113);
	
	var _ShippingMethodStore2 = _interopRequireDefault(_ShippingMethodStore);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _asnInitialSnapshotChangedFactory = __webpack_require__(546);
	
	var _asnInitialSnapshotChangedFactory2 = _interopRequireDefault(_asnInitialSnapshotChangedFactory);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function SaveAsn(wizard) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      canSave = _ref.canSave;
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	  // make var name shorter
	  var namespace = void 0,
	      nameMap = void 0,
	      elementsMap = void 0;
	  var addressValidationModalEl = (0, _jquery2.default)("#add-validation-model");
	  var asnId = wizardElement.data("asn-id");
	  var asnInitialSnapshotChangedChecker = (0, _asnInitialSnapshotChangedFactory2.default)();
	
	  var addressValidation = (0, _AddressValidation2.default)(addressValidationModalEl, wizardElement, {
	    isAlreadyValid: !!asnId
	  });
	
	  self.init = function () {
	    setMappings();
	    setElements();
	    bindElements();
	  };
	
	  function determineSave() {
	    return canSave && canSave();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardElement);
	    // this modal is outside the scope of the wizard...
	    // We should be re-using an html template in this frontend
	    // project and FILLING it with the appropriate data & bindings
	    els.saveDecisionModal = (0, _jquery2.default)("#asn-wizard-saveModal");
	    els.saveModalConfirm = (0, _jquery2.default)("#asn-wizard-modalSaveAndClosePage");
	    els.errorModalAsnSave = (0, _jquery2.default)("#asn-wizard-errorModal");
	
	    //submit
	    els.submitDecisionModal = (0, _jquery2.default)("#create-ans-confirm-modal");
	    els.submitModalConfirm = (0, _jquery2.default)("#createASNConfirmButton");
	    els.createASNSuccessAnchor = (0, _jquery2.default)(".create-asn-success-anchor");
	    els.createASNSuccessModal = (0, _jquery2.default)("#createASNSuccessModal");
	  }
	
	  function bindElements() {
	    els.saveBtn.on("click", function (e) {
	      e.preventDefault();
	      if (determineSave()) {
	        showSaveModal();
	      }
	    });
	
	    els.submitBtn.on("click", function (e) {
	      e.preventDefault();
	      showConfirmSubmitModal();
	    });
	
	    els.saveModalConfirm.on("click", function (e) {
	      e.preventDefault();
	      var saveUrl = wizardElement.data("save-url");
	      saveNow({ url: saveUrl, success: saveAsnSuccess, error: saveAsnError });
	    });
	
	    els.submitModalConfirm.on("click", function (e) {
	      e.preventDefault();
	      var submitUrl = wizardElement.data("submit-url");
	      saveNow({ url: submitUrl, success: submitAsnSuccess, error: submitAsnError });
	    });
	
	    // $(document).on("click", ".request-quote-btn", function(e){
	    //   e.preventDefault();
	    //   const csrEmailUrl = wizardElement.data("csr-email-url");
	    //   saveNow({url: csrEmailUrl, success: emailSuccess, error: emailError});
	    // });
	  }
	
	  function saveNow(_ref2) {
	    var _data;
	
	    var url = _ref2.url,
	        success = _ref2.success,
	        error = _ref2.error;
	
	    console.log('saving asn...');
	    var data = (_data = {}, _defineProperty(_data, nameMap.asnId, els.asnId.val()), _defineProperty(_data, nameMap.facId, els.facId.val()), _defineProperty(_data, nameMap.cadId, els.cadId.val()), _defineProperty(_data, nameMap.locationName, els.locationName.val()), _defineProperty(_data, nameMap.contactPhone, els.contactPhone.val()), _defineProperty(_data, nameMap.contactName, els.contactName.val()), _defineProperty(_data, nameMap.address1, els.address1.val()), _defineProperty(_data, nameMap.address2, els.address2.val()), _defineProperty(_data, nameMap.country, els.country.val()), _defineProperty(_data, nameMap.city, els.city.val()), _defineProperty(_data, nameMap.state, els.state.val()), _defineProperty(_data, nameMap.zip, els.zip.val()), _defineProperty(_data, nameMap.cadStateText, els.cadStateText.val()), _data);
	
	    var asn = getAsn();
	    /** This logic has been newly added to manage switching cases vs pallet while edit the ASN. We use ASN's status to identify
	    the newly created cases or pallet ASN **/
	    var asns = _AsnStore2.default.getAsns();
	    var tempAsn = (0, _underscore2.default)(asns).find(function (asn2) {
	      return asn2.status !== "New";
	    });
	    if (tempAsn && asn != tempAsn) {
	      /** copy the necessary information in case we miss from original ASN while switching case or pallet **/
	      asn.asnId = tempAsn.id;
	      asn.shippingPartner = tempAsn.shippingPartner;
	    }
	    /** end **/
	    var asnSerializer = new _AsnSerializer2.default(asn, { includeServices: true });
	    data[namespace + "asn"] = asnSerializer.toJsonNestedIntoPalletsAndCases();
	    data[namespace + "isShipmentChange"] = isEditingAndDataChangedSinceLoad();
	    var addressResponse = addressValidation.getAddressResponse();
	    data[namespace + "validatedAddress"] = JSON.stringify(addressResponse);
	
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      data: data,
	      url: url,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function showSaveModal() {
	    handleGTLMessage();
	    els.saveDecisionModal.modal("show");
	  }
	
	  function handleGTLMessage() {
	    var asn = _AsnStore2.default.getAsnWithShippingMethod();
	    var isGTL = _AsnStore2.default.isGTL(asn);
	    if (isGTL) {
	      // show message
	    } else {
	        // hide message
	      }
	  }
	
	  function showConfirmSubmitModal() {
	    console.log("determine if is editing and data has changed since load: ", isEditingAndDataChangedSinceLoad());
	    els.submitDecisionModal.modal("show");
	  }
	
	  function saveAsnSuccess(asnId) {
	    if (asnId > 0) {
	      EditChecker.setPageClean();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        var asnDetailUrl = wizardElement.data("asn-detail-url");
	        location.href = asnDetailUrl + "&" + namespace + "asnId=" + asnId;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function saveAsnError() {
	    submitModalFlow.showFailureModal();
	  }
	
	  // function emailSuccess(asnId){
	  //  if(asnId>0) {
	  //   AsnStore.updateAllObjectsAndEmit({requestQuote: true ,asnId: asnId});
	  //  }
	  // }
	
	  // function emailError(){
	  //   console.log('email failed');
	  //   AsnStore.updateAllObjectsAndEmit({requestQuoteFailed: true});
	  // }
	
	  function submitAsnSuccess(asnId) {
	    if (asnId > 0) {
	      EditChecker.setPageClean();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        var asnDetailUrl = wizardElement.data("asn-detail-url");
	        var asnDetailFullURL = asnDetailUrl + "&" + namespace + "asnId=" + asnId + "&" + namespace + "isShipmentChange=" + isEditingAndDataChangedSinceLoad();
	        location.href = asnDetailFullURL;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function submitAsnError() {
	    submitModalFlow.showFailureModal();
	  }
	
	  function setMappings() {
	    namespace = wizardElement.data('namespace');
	
	    nameMap = {
	      asnId: namespace + "asnId",
	      facId: namespace + "facilities",
	      cadId: namespace + "cadId",
	      locationName: namespace + "cadLocationName",
	      contactPhone: namespace + "cadContactPhone",
	      contactName: namespace + "cadContactName",
	      address1: namespace + "cadAddress1",
	      address2: namespace + "cadAddress2",
	      country: namespace + "cadCountry",
	      city: namespace + "cadCity",
	      state: namespace + "states",
	      zip: namespace + "cadZipcode",
	      cadStateText: namespace + "cadStateText"
	    };
	
	    elementsMap = (0, _underscore2.default)(nameMap).mapObject(function (name, k) {
	      return "#" + name;
	    });
	
	    _underscore2.default.extend(elementsMap, {
	      saveBtn: ".ship-later-btn",
	      submitBtn: "#submit-asn",
	      requestQuote: "#request-quote-btn"
	    });
	  }
	
	  function getAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	
	  function isEditingAndDataChangedSinceLoad() {
	    return !!(isEditing() && hasDataChangedSinceLoad());
	  }
	
	  function isEditing() {
	    return (0, _general.isPresent)(asnId);
	  }
	
	  function hasDataChangedSinceLoad() {
	    return !!asnInitialSnapshotChangedChecker.didStoresDataChange();
	  }
	}

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ProductLevelServicesView;
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _ProductItemStore = __webpack_require__(65);
	
	var _ProductItemStore2 = _interopRequireDefault(_ProductItemStore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _ProductView = __webpack_require__(526);
	
	var _ProductView2 = _interopRequireDefault(_ProductView);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  productServicesOuter: ".product-services-outer"
	};
	
	function ProductLevelServicesView(el) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      readOnly = _ref.readOnly;
	
	  var self = this;
	  var els = {};
	  var productViews = [];
	
	  self.init = function () {
	    setElements();
	    attachWidgets();
	    bindElements();
	    bindStores();
	    renderChildren();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	  }
	
	  function attachWidgets() {}
	
	  function bindElements() {}
	
	  function renderChildren() {
	    (0, _viewHelpers.unbindAll)(productViews);
	    productViews = renderProductViews();
	    els.productServicesOuter.html((0, _viewHelpers.extractElements)(productViews));
	  }
	
	  function renderProductViews() {
	    return (0, _underscore2.default)(groupBySku()).map(function (asnDetails, sku) {
	      var productView = new _ProductView2.default(asnDetails, { readOnly: readOnly });
	      productView.init();
	      return productView;
	    });
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", renderChildren);
	    _AsnDetailStore2.default.bindListener("asn_details:add", renderChildren);
	    _AsnDetailStore2.default.bindListener("asn_details:remove", renderChildren);
	    // we need a generic change event to be listenable here
	    // because we are 'grouping' asn_details which inherently
	    // requires a full children reRender
	    _AsnDetailStore2.default.bindListener("asn_details:change", renderChildren);
	  }
	
	  function groupBySku() {
	    return _AsnDetailStore2.default.groupBySku(getAsnDetails());
	  }
	
	  function getAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	
	  function getAsnDetails() {
	    return _AsnStore2.default.getAsnDetails(getAsn());
	  }
	}

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Product;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AdditionalServicesView = __webpack_require__(195);
	
	var _AdditionalServicesView2 = _interopRequireDefault(_AdditionalServicesView);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _MandatoryServiceProcessor = __webpack_require__(545);
	
	var _MandatoryServiceProcessor2 = _interopRequireDefault(_MandatoryServiceProcessor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1234);
	
	var elementsMap = {
	  additionalServicesEntryPoint: ".additional-services-entry-point",
	  productSku: ".product-main-sku",
	  productDesc: ".product-desc",
	  prepItemFragile: ".prep-item-fragile",
	  prepItemBarcode: ".prep-item-barcode",
	  noPrepNeeded: ".prep-item-no-prep",
	  productQuantity: ".product-agg-quantity",
	  servicesSelect: ".additional-services-select"
	};
	
	function Product(asnDetails) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      readOnly = _ref.readOnly;
	
	  var asnDetailIds = (0, _underscore2.default)(asnDetails).pluck("id");
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var additionalServicesView = void 0;
	  self.init = function () {
	    render();
	  };
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	  self.getElement = function () {
	    return self._element;
	  };
	  function setWidgets() {
	    if (!readOnly) {
	      els.servicesSelect.select2({
	        placeholder: 'Select an option',
	        data: getServiceSelectDataArray()
	      });
	    }
	  }
	  function update() {
	    // console.log("updating product view");
	    // optimization for reuse implementation,
	    // when read only, obviously we don't need,
	    // to mutate state/rerender views,
	    // this is handled by the non-read only configuration
	    if (!readOnly) {
	      var mandatoryServiceProcessor = new _MandatoryServiceProcessor2.default(getAsnDetailIds());
	      mandatoryServiceProcessor.forceAddMandatoryServices();
	      mandatoryServiceProcessor.forceRemoveUnneededMandatoryServices();
	    }
	    if (getFirstAsnDetail()) {
	      updateValues();
	      updatePrep();
	    }
	    additionalServicesView = renderAdditionalServicesView();
	    els.additionalServicesEntryPoint.html((0, _viewHelpers.extractElements)([additionalServicesView]));
	  }
	  function updatePrep() {
	    // example item sku for fragile: "23432"
	    (0, _selectorHelpers.handleDisplayFor)(els.prepItemFragile, isFragile());
	    // example item sku for fragile: "unknown"
	    (0, _selectorHelpers.handleDisplayFor)(els.prepItemBarcode, needsBarcode());
	    (0, _selectorHelpers.handleDisplayFor)(els.noPrepNeeded, !isFragile() && !needsBarcode());
	  }
	  function bindStores() {
	    // AsnDetailStore.bindListenersForSubsetOfDataViaIds(asnDetailIds, "asn_details:change", update);
	    _CmrServiceStore2.default.bindListener("cmr_services:add", update);
	    _CmrServiceStore2.default.bindListener("cmr_services:remove", update);
	    _CmrServiceStore2.default.bindListener("cmr_services:change", update);
	  }
	  self.unbindListeners = function () {
	    _CmrServiceStore2.default.unbindListener("cmr_services:add", update);
	    _CmrServiceStore2.default.unbindListener("cmr_services:remove", update);
	    _CmrServiceStore2.default.unbindListener("cmr_services:change", update);
	  };
	  function bindElements() {
	    els.servicesSelect.on("change", onAddServiceChanged);
	  }
	  function onAddServiceChanged() {
	    onAddService({ domainId: els.servicesSelect.val() });
	  }
	  function updateValues() {
	    var asnDetail = getFirstAsnDetail();
	    els.productSku.text(asnDetail.sku);
	    els.productDesc.text("(" + (getProductItem().prdDescription || "no description") + ")");
	    els.productQuantity.text(calcProductsQuantity());
	  }
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindElements();
	    bindStores();
	  }
	  function renderAdditionalServicesView() {
	    var additionalServicesView = new _AdditionalServicesView2.default(getFirstAsnDetail(), {
	      readOnly: readOnly,
	      getDomains: getDomains,
	      getServices: getDeduppedServices,
	      onAddService: onAddService,
	      getAggregateCurrencyTotalViaCurrencyPerUnits: getAggregateCurrencyTotalViaCurrencyPerUnits,
	      shouldShowServiceCloseBtn: shouldShowServiceCloseBtn,
	      onRemoveServiceRow: onRemoveServiceRow
	    });
	    additionalServicesView.init();
	    return additionalServicesView;
	  }
	  function onRemoveServiceRow(serviceId) {
	    // console.log(`removing: ${serviceId}`);
	    _CmrServiceStore2.default.removeServicesByIds([serviceId]);
	  }
	  function onAddService(_ref2) {
	    var domainId = _ref2.domainId;
	
	    _CmrServiceStore2.default.createOrUpdateServicesForAsnDetailIds(getAsnDetailIds(), {
	      cdm_id: domainId
	    });
	  }
	  function shouldShowServiceCloseBtn(_ref3) {
	    var domain = _ref3.domain;
	
	    return !isMandatoryDomain(domain);
	  }
	  function getDomains() {
	    return _CmrDomainStore2.default.getOnlyProductServiceLevels();
	  }
	  function getServices() {
	    return _CmrServiceStore2.default.getServicesViaAsnDetailIds(getAsnDetailIds());
	  }
	  function getDeduppedServices() {
	    // NOTE:
	    // all asn details within this bundle
	    // should have the same sku at the point
	    // and we only care about services on a
	    // per sku basis VISUALLY, so just use first one
	    return _CmrServiceStore2.default.getServicesViaAsnDetailIds([getAsnDetailIds()[0]]);
	  }
	  function isFragile() {
	    return ProductItemStore.isFragile(getProductItem());
	  }
	  function needsBarcode() {
	    return ProductItemStore.needsBarcode(getProductItem());
	  }
	  function getAggregateCurrencyTotalViaCurrencyPerUnits(numb) {
	    return calcProductsQuantity() * numb;
	  }
	  function calcProductsQuantity() {
	    var total = 0;
	    (0, _underscore2.default)(getAsnDetails()).map(function (detail) {
	      total += _AsnDetailStore2.default.calcTotalQuantityFor(detail);
	    });
	    return total;
	  }
	  function isMandatoryDomain(domain) {
	    // check if service is pointing to ANY manditory domain
	    return _CmrDomainStore2.default.isMandatoryDomain(domain);
	  }
	  // function forceAddMandatoryServices(){
	  //   forceAddMandatoryServicesViaAsnDetailIds(getAsnDetailIds());
	  // }
	  // function forceRemoveUnneededMandatoryServices(){
	  //   forceRemoveUnneededMandatoryServicesViaAsnDetailIds(getAsnDetails());
	  // }
	  function getProductItem() {
	    return ProductItemStore.getDataViaAsnDetail(getFirstAsnDetail())[0] || {};
	  }
	  function getAsnDetailIds() {
	    return asnDetailIds;
	  }
	  function getAsnDetails() {
	    return _AsnDetailStore2.default.getAsnDetails(asnDetailIds);
	  }
	  function getServiceSelectDataArray() {
	    return (0, _underscore2.default)(getDomains()).map(function (domain) {
	      return { id: domain.id.toString(), text: domainToSelectOptionText(domain) };
	    });
	  }
	  function domainToSelectOptionText(domain) {
	    return domain.cdm_meaning + " (" + CmrDomainStore.currencyToHtml(domain) + ")";
	  }
	  function getFirstAsnDetail() {
	    return getAsnDetails()[0];
	  }
	}

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReviewView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	var _currency = __webpack_require__(66);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1235);
	
	
	var noop = function noop() {};
	
	var elementsMap = {
	  reviewTabView: ".review-tab-service-inner",
	  reviewSkuName: ".review-sku-name",
	  reviewServiceName: ".review-service-name",
	  reviewQuantity: ".review-quantity",
	  reviewEstimatedCost: ".review-estimated-cost"
	};
	
	function ReviewView(services, asnDetail) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$asnDetails = _ref.asnDetails,
	      asnDetails = _ref$asnDetails === undefined ? [] : _ref$asnDetails;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  self.init = function () {
	    render();
	  };
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    bindElements();
	    bindStores();
	    update();
	  }
	
	  function bindElements() {}
	
	  function bindStores() {}
	
	  self.unbindListeners = function () {};
	
	  function setWidgets() {}
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateReviewText();
	  }
	
	  function updateReviewText() {
	    //Shipment Level
	    if ((0, _general.isBlank)(asnDetail)) {
	      updateShipmentLevelReviewText();
	    }
	    //Product Level
	    if ((0, _general.isPresent)(asnDetail)) {
	      updateProductLevelReviewText();
	    }
	  }
	
	  function updateShipmentLevelReviewText() {
	    if (services.length) {
	      els.reviewSkuName.html("All Units in Shipment");
	      els.reviewQuantity.html("All Units");
	      els.reviewServiceName.html('');
	      els.reviewEstimatedCost.html('');
	
	      (0, _underscore2.default)(services).map(function (service, rowIdx) {
	        var domain = getDomain(service.id);
	        if (_CmrDomainStore2.default.currencyToHtml(domain) == 'FREE') {
	          els.reviewServiceName.append(_CmrDomainStore2.default.getTitle(domain) + " (FREE)<br>");
	          els.reviewEstimatedCost.append("FREE<br>");
	        } else {
	          els.reviewServiceName.append(_CmrDomainStore2.default.getTitle(domain) + " (" + _CmrDomainStore2.default.currencyToHtml(domain) + ")<br>");
	          els.reviewEstimatedCost.append((0, _currency.toCurrency)(_CmrDomainStore2.default.getValue(domain)) + "<br>");
	        }
	      });
	    }
	  }
	
	  function updateProductLevelReviewText() {
	    if (services.length) {
	      els.reviewSkuName.html(asnDetail.sku);
	      els.reviewQuantity.html(_AsnDetailStore2.default.calcTotalQuantityFor(asnDetail));
	      els.reviewServiceName.html('');
	      els.reviewEstimatedCost.html('');
	      (0, _underscore2.default)(services).map(function (service, rowIdx) {
	        var domain = getDomain(service.id);
	        if (_CmrDomainStore2.default.currencyToHtml(domain) == 'FREE') {
	          els.reviewServiceName.append(_CmrDomainStore2.default.getTitle(domain) + " (FREE)<br>");
	          els.reviewEstimatedCost.append("FREE<br>");
	        } else {
	          els.reviewServiceName.append(_CmrDomainStore2.default.getTitle(domain) + " (" + _CmrDomainStore2.default.currencyToHtml(domain) + "/unit)<br>");
	          els.reviewEstimatedCost.append((0, _currency.toCurrency)(getAggregateCurrencyTotalViaCurrencyPerUnits(_CmrDomainStore2.default.getValue(domain))) + "<br>");
	        }
	      });
	    }
	  }
	
	  function getAggregateCurrencyTotalViaCurrencyPerUnits(numb) {
	    return calcProductsQuantity() * numb;
	  }
	
	  function calcProductsQuantity() {
	    return _AsnDetailStore2.default.calcTotalQuantityFor(asnDetail);
	  }
	
	  function getService(serviceId) {
	    return _CmrServiceStore2.default.getData()[serviceId];
	  }
	
	  function getDomain(serviceId) {
	    return _CmrDomainStore2.default.getData()[getService(serviceId).cdm_id];
	  }
	}

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReviewServicesView;
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _ReviewDetailRowView = __webpack_require__(527);
	
	var _ReviewDetailRowView2 = _interopRequireDefault(_ReviewDetailRowView);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subTotalRowHtml = __webpack_require__(1236);
	
	var elementsMap = {
	  reviewTabServiceInner: ".review-tab-service-inner"
	};
	
	function ReviewServicesView(el) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      calcSubTotal = _ref.calcSubTotal,
	      readOnly = _ref.readOnly;
	
	  var self = this;
	  var els = {};
	  var reviewDetailRowViews = [];
	
	  self.init = function () {
	    setElements();
	    attachWidgets();
	    bindElements();
	    bindStores();
	    renderChildren();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	  }
	
	  function attachWidgets() {}
	
	  function bindElements() {}
	
	  function onAddServiceChanged() {}
	
	  function renderChildren() {
	    (0, _viewHelpers.unbindAll)(reviewDetailRowViews);
	    el.html('');
	    renderServices();
	    renderProducts();
	    el.append(renderSubTotalRow());
	  }
	
	  function renderSubTotalRow() {
	    return (0, _render2.default)(subTotalRowHtml, {
	      subtotal: calcSubTotal()
	    });
	  }
	
	  function renderServices() {
	    if (getServices().length) {
	      var reviewDetailRowView = new _ReviewDetailRowView2.default(getServices(), null, {});
	      reviewDetailRowView.init();
	      el.append((0, _viewHelpers.extractElements)([reviewDetailRowView]));
	    }
	  }
	
	  function renderProducts() {
	    (0, _underscore2.default)(groupBySku()).chain().map(function (asnDetails, sku) {
	      if (getDeduppedServices(asnDetails).length) {
	        var asnDetail = asnDetails[0];
	        var reviewDetailRowView = new _ReviewDetailRowView2.default(getDeduppedServices(asnDetails), asnDetail, {
	          asnDetails: asnDetails
	        });
	        reviewDetailRowView.init();
	        el.append((0, _viewHelpers.extractElements)([reviewDetailRowView]));
	      }
	    });
	  }
	
	  function getDeduppedServices(asnDetails) {
	    var asnDetailIds = getAsnDetailIds(asnDetails);
	    return _CmrServiceStore2.default.getServicesViaAsnDetailIds([asnDetailIds[0]]);
	  }
	
	  function getAsnDetailIds(asnDetails) {
	    return (0, _underscore2.default)(asnDetails).pluck("id");
	  }
	
	  function getServices() {
	    return _CmrServiceStore2.default.getServicesViaAsnId(getAsnId());
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", renderChildren);
	    _CmrServiceStore2.default.bindListener("cmr_services:add", renderChildren);
	    _CmrServiceStore2.default.bindListener("cmr_services:remove", renderChildren);
	    _CmrServiceStore2.default.bindListener("cmr_services:change", renderChildren);
	    _AsnDetailStore2.default.bindListener("asn_details:add", renderChildren);
	    _AsnDetailStore2.default.bindListener("asn_details:remove", renderChildren);
	    _AsnDetailStore2.default.bindListener("asn_details:change", renderChildren);
	  }
	
	  self.unbindListeners = function () {
	    _AsnStore2.default.unbindListener("asns:shipping_method_changed", renderChildren);
	    _CmrServiceStore2.default.unbindListener("cmr_services:add", renderChildren);
	    _CmrServiceStore2.default.unbindListener("cmr_services:remove", renderChildren);
	    _CmrServiceStore2.default.unbindListener("cmr_services:change", renderChildren);
	    _AsnDetailStore2.default.unbindListener("asn_details:add", renderChildren);
	    _AsnDetailStore2.default.unbindListener("asn_details:remove", renderChildren);
	    _AsnDetailStore2.default.unbindListener("asn_details:change", renderChildren);
	  };
	
	  function getAsnId() {
	    return getAsn().id;
	  }
	
	  function groupBySku() {
	    return _AsnDetailStore2.default.groupBySku(getAsnDetails());
	  }
	
	  function getAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	
	  function getAsnDetails() {
	    return _AsnStore2.default.getAsnDetails(getAsn());
	  }
	}

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ServiceView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _ProductItemStore = __webpack_require__(65);
	
	var _ProductItemStore2 = _interopRequireDefault(_ProductItemStore);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	var _currency = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1237);
	
	
	var noop = function noop() {};
	
	var elementsMap = {
	  serviceName: ".service-name",
	  serviceCurrencyPerUnit: ".service-currency-per-unit",
	  serviceCurrentTotal: ".service-currency-total",
	  closeBtn: ".service-remove-btn"
	};
	
	function ServiceView(service) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      onRemoveServiceRow = _ref.onRemoveServiceRow,
	      getAggregateCurrencyTotalViaCurrencyPerUnits = _ref.getAggregateCurrencyTotalViaCurrencyPerUnits,
	      shouldShowServiceCloseBtn = _ref.shouldShowServiceCloseBtn,
	      shouldShowCurrencyPerUnits = _ref.shouldShowCurrencyPerUnits,
	      readOnly = _ref.readOnly;
	
	  var serviceId = service.id;
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  shouldShowServiceCloseBtn = shouldShowServiceCloseBtn || defaultShouldShowCloseBtn;
	  shouldShowCurrencyPerUnits = shouldShowCurrencyPerUnits || defaultShouldShowCurrencyPerUnits;
	  getAggregateCurrencyTotalViaCurrencyPerUnits = getAggregateCurrencyTotalViaCurrencyPerUnits || noop;
	
	  self.init = function () {
	    render();
	  };
	
	  function bindElements() {
	    els.closeBtn.on("click", handleRemoveRowClick);
	  }
	
	  function handleRemoveRowClick(e) {
	    e.preventDefault();
	    onRemoveServiceRow(serviceId);
	  }
	
	  function bindStores() {
	    // AsnDetailStore.bindListener(`asn_details:change:${productId}`, update);
	  }
	
	  self.unbindListeners = function () {
	    // AsnDetailStore.bindListener(`asn_details:change:${productId}`, update);
	  };
	
	  function setWidgets() {}
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateGlobalText();
	    updateGlobalValues();
	  }
	
	  function updateGlobalText() {
	    var domain = getDomain();
	    els.serviceName.text(_CmrDomainStore2.default.getTitle(domain));
	    els.serviceCurrencyPerUnit.text(_CmrDomainStore2.default.currencyToHtml(domain) + "/unit");
	    (0, _selectorHelpers.handleDisplayFor)(els.serviceCurrencyPerUnit, shouldShowCurrencyPerUnits());
	    if (_CmrDomainStore2.default.currencyToHtml(domain) == 'FREE') {
	      els.serviceCurrentTotal.text('FREE');
	    } else {
	      els.serviceCurrentTotal.text((0, _currency.toCurrency)(getAggregateCurrencyTotalViaCurrencyPerUnits(_CmrDomainStore2.default.getValue(domain))));
	    }
	    (0, _selectorHelpers.handleDisplayFor)(els.closeBtn, !readOnly && shouldShowServiceCloseBtn({ service: getService(), domain: getDomain() }));
	  }
	
	  function defaultShouldShowCurrencyPerUnits() {
	    return true;
	  }
	
	  function defaultShouldShowCloseBtn() {
	    return true;
	  }
	
	  function updateGlobalValues() {}
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    bindElements();
	    bindStores();
	    update();
	  }
	
	  function getAsnDetail() {
	    return _AsnDetailStore2.default.getAsnDetail(productId);
	  }
	
	  function getService() {
	    return _CmrServiceStore2.default.getData()[serviceId];
	  }
	
	  function getDomain() {
	    return _CmrDomainStore2.default.getData()[getService().cdm_id];
	  }
	}

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShipmentLevelServicesView;
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AdditionalServicesView = __webpack_require__(195);
	
	var _AdditionalServicesView2 = _interopRequireDefault(_AdditionalServicesView);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  shipmentServicesOuter: ".shipment-services-outer",
	  servicesSelect: ".additional-services-select"
	};
	
	function ShipmentLevelServicesView(el) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      readOnly = _ref.readOnly;
	
	  var self = this;
	  var els = {};
	  var additionalServicesView = void 0;
	
	  self.init = function () {
	    setElements();
	    attachWidgets();
	    bindElements();
	    bindStores();
	    renderChildren();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	  }
	
	  function attachWidgets() {
	    if (!readOnly) {
	      els.servicesSelect.select2({
	        placeholder: 'Select an option',
	        data: getServiceSelectDataArray()
	      });
	    }
	  }
	
	  function bindElements() {
	    els.servicesSelect.on("change", onAddServiceChanged);
	  }
	
	  function onAddServiceChanged() {
	    onAddService({ domainId: els.servicesSelect.val() });
	  }
	  function getServiceSelectDataArray() {
	    return (0, _underscore2.default)(getDomains()).map(function (domain) {
	      return { id: domain.id.toString(), text: domainToSelectOptionText(domain) };
	    });
	  }
	
	  function domainToSelectOptionText(domain) {
	    return domain.cdm_meaning + " (" + CmrDomainStore.currencyToHtml(domain) + ")";
	  }
	
	  function renderChildren() {
	    // no need to call unbind, this view has no listeners
	    // aka, it is pure
	    // unbindAll([additionalServicesView]);
	    additionalServicesView = renderAdditionalServicesView();
	    els.shipmentServicesOuter.html((0, _viewHelpers.extractElements)([additionalServicesView]));
	  }
	
	  function renderAdditionalServicesView() {
	    var additionalServicesView = new _AdditionalServicesView2.default(null, {
	      getDomains: getDomains,
	      getServices: getServices,
	      onAddService: onAddService,
	      getAggregateCurrencyTotalViaCurrencyPerUnits: getAggregateCurrencyTotalViaCurrencyPerUnits,
	      shouldShowServiceCloseBtn: shouldShowServiceCloseBtn,
	      shouldShowCurrencyPerUnits: shouldShowCurrencyPerUnits,
	      onRemoveServiceRow: onRemoveServiceRow,
	      readOnly: readOnly
	    });
	    additionalServicesView.init();
	    return additionalServicesView;
	  }
	
	  function onRemoveServiceRow(serviceId) {
	    // console.log(`removing asn service: ${serviceId}`);
	    _CmrServiceStore2.default.removeServicesByIds([serviceId]);
	  }
	
	  function onAddService(_ref2) {
	    var domainId = _ref2.domainId;
	
	    // console.log(`service added, domainId: ${domainId}`);
	
	    _CmrServiceStore2.default.createOrUpdateServicesForAsnId(getAsnId(), {
	      cdm_id: domainId
	    });
	  }
	
	  function getAggregateCurrencyTotalViaCurrencyPerUnits(numb) {
	    return numb;
	  }
	
	  function shouldShowCurrencyPerUnits() {
	    return false;
	  }
	
	  function shouldShowServiceCloseBtn() {
	    return true;
	  }
	
	  function getDomains() {
	    return _CmrDomainStore2.default.getOnlyShipmentServiceLevels();
	  }
	
	  function getServices() {
	    return _CmrServiceStore2.default.getServicesViaAsnId(getAsnId());
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", renderChildren);
	    _CmrServiceStore2.default.bindListener("cmr_services:add", renderChildren);
	    _CmrServiceStore2.default.bindListener("cmr_services:remove", renderChildren);
	    _CmrServiceStore2.default.bindListener("cmr_services:change", renderChildren);
	  }
	
	  self.unbindListeners = function () {
	    _AsnStore2.default.unbindListener("asns:shipping_method_changed", renderChildren);
	    _CmrServiceStore2.default.unbindListener("cmr_services:add", renderChildren);
	    _CmrServiceStore2.default.unbindListener("cmr_services:remove", renderChildren);
	    _CmrServiceStore2.default.unbindListener("cmr_services:change", renderChildren);
	  };
	
	  function getAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	
	  function getAsnId() {
	    return getAsn().id;
	  }
	}

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AsnDetailRow;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _ProductItemStore = __webpack_require__(65);
	
	var _ProductItemStore2 = _interopRequireDefault(_ProductItemStore);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1239);
	
	// product shape:
	
	//   {
	//     id: 1,
	//     unitsPerCase: 1,
	//     caseLineNumber: 1
	//   }
	
	var elementsMap = {
	  asnDetailLength: ".asn-detail-length",
	  asnDetailWidth: ".asn-detail-width",
	  asnDetailHeight: ".asn-detail-height",
	  asnDetailWeight: ".asn-detail-weight",
	  palletCaseIdx: ".pallet-case-idx",
	  palletCaseLabel: ".pallet-case-label",
	  stackablePalletOuter: ".stackable-pallet-outer",
	  stackablePalletCheckbox: ".stackable-pallet-checkbox",
	  shippingTabSkus: ".shipping-tab-prd-skus",
	  prdLevelPalletCaseLabel: ".prd-level-pallet-case-label",
	  palletCaseNumber: ".pallet-case-number",
	  applyDimensionWeightOuter: ".apply-dimension-weight-to-all-outer",
	  applyDimensionToAllBtn: ".apply-to-all-btn",
	  declaredValueInput: ".declared-value-input",
	  useCalculatedVal: ".use-calculated-val",
	  dvlInsideCase: ".dvl-inside-case"
	};
	
	function AsnDetailRow(asnDetail, options) {
	  var asnDetailId = asnDetail.id;
	
	  var rowIdx = options.rowIdx,
	      isPallet = options.isPallet,
	      readOnly = options.readOnly,
	      onAsnDetailGroupFieldChange = options.onAsnDetailGroupFieldChange,
	      getAsnDetailGroups = options.getAsnDetailGroups;
	
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  self.init = function () {
	    renderInit();
	  };
	
	  function bindElements() {
	    bindApplyDimensionAndWeight();
	    els.asnDetailLength.on("input", handleAsnDetailGroupFieldChange("asd_package_length"));
	    els.asnDetailWidth.on("input", handleAsnDetailGroupFieldChange("asd_package_width"));
	    els.asnDetailHeight.on("input", handleAsnDetailGroupFieldChange("asd_package_height"));
	    els.asnDetailWeight.on("input", handleAsnDetailGroupFieldChange("asd_package_weight"));
	    els.declaredValueInput.on("input", handleDeclaredValueInput);
	    els.stackablePalletCheckbox.on("click", handleAsnFieldCheckboxChange("stackablePallet"));
	    els.useCalculatedVal.on("click", handleUseCalculatedVal);
	    els.dvlInsideCase.on("click", handleDvlInsideCaseChange);
	  }
	
	  function handleDeclaredValueInput() {
	    var val = (0, _jquery2.default)(this).val();
	    if (_underscore2.default.isNumber(val)) {
	      val = parseInt(val, 10);
	    }
	    if (val > 50000) {
	      val = 50000;
	    }
	    els.declaredValueInput.val(val);
	    onAsnDetailGroupFieldChange(rowIdx, "declaredValue", val);
	    onAsnDetailGroupFieldChange(rowIdx, "declaredValueCustomVal", val);
	  }
	
	  function handleUseCalculatedVal() {
	    var asnDetail = getAsnDetail();
	    if ((0, _jquery2.default)(this).is(":checked")) {
	      els.declaredValueInput.val(asnDetail.dvlCalculatedValue);
	      els.declaredValueInput.prop('readonly', true);
	    } else {
	      els.declaredValueInput.val(asnDetail.declaredValueCustomVal);
	      els.declaredValueInput.prop('readonly', false);
	    }
	    onAsnDetailGroupFieldChange(rowIdx, "useCalculatedVal", !!(0, _jquery2.default)(this).is(":checked"));
	    onAsnDetailGroupFieldChange(rowIdx, "declaredValue", els.declaredValueInput.val());
	  }
	
	  function handleDvlInsideCaseChange() {
	    var asnDetails = getAsnDetail();
	    var dvl = (0, _jquery2.default)(els.declaredValueInput).val();
	    var dvlflag = (0, _jquery2.default)(this).is(":checked");
	    if (dvlflag === true && !(0, _general.isPresent)(dvl)) {
	      (0, _jquery2.default)(els.declaredValueInput).val(asnDetails.dvlCalculatedValue);
	    }
	    onAsnDetailGroupFieldChange(rowIdx, "dvlInsideCase", !!(0, _jquery2.default)(this).is(":checked"));
	  }
	
	  function handleAsnFieldCheckboxChange(key) {
	    return function (e) {
	      onAsnDetailGroupFieldChange(rowIdx, key, !!(0, _jquery2.default)(this).is(":checked"));
	    };
	  }
	
	  function handleAsnDetailGroupFieldChange(key) {
	    return function (e) {
	      var val = (0, _jquery2.default)(this).val();
	      // only parseInt if it's a number,
	      // otherwise this field will end up
	      // as a NaN
	      if (_underscore2.default.isNumber(val)) {
	        val = parseInt(val, 10);
	      }
	      onAsnDetailGroupFieldChange(rowIdx, key, val);
	      // options[funcName](rowIdx, val);
	    };
	  }
	
	  function bindStores() {
	    _AsnDetailStore2.default.bindListener("asn_details:change", updateSelf);
	    _AsnDetailStore2.default.bindListener("asn_details:change", updateChildren);
	    _AsnDetailStore2.default.bindListener("asn_details:change", updateChildren);
	    _AsnStore2.default.bindListener("asns:dvl-inside-case", updateDvl);
	  }
	
	  self.unbindListeners = function () {
	    _AsnDetailStore2.default.unbindListener("asn_details:change", updateSelf);
	    _AsnDetailStore2.default.unbindListener("asn_details:change", updateChildren);
	    _AsnDetailStore2.default.bindListener("asn_details:change", updateChildren);
	    _AsnStore2.default.unbindListener("asns:dvl-inside-case", updateDvl);
	  };
	
	  function updateDvl() {
	    var asn = getAsn(asnDetail.asnId);
	    (0, _selectorHelpers.setCheckboxState)(els.dvlInsideCase, asn.applyDvl);
	    els.dvlInsideCase.trigger('change');
	    onAsnDetailGroupFieldChange(rowIdx, "dvlInsideCase", asn.applyDvl);
	    (0, _selectorHelpers.setCheckboxState)(els.useCalculatedVal, true);
	    els.useCalculatedVal.trigger('change');
	    onAsnDetailGroupFieldChange(rowIdx, "useCalculatedVal", true);
	    els.declaredValueInput.prop('readonly', true);
	    onAsnDetailGroupFieldChange(rowIdx, "declaredValue", els.declaredValueInput.val());
	  }
	
	  function setWidgets() {}
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    // handle rendering children
	    updateSelf();
	    updateChildren();
	  }
	
	  function updateSelf() {
	    // handle updating values;
	    updateValues();
	    updatePalletCaseIdx();
	    updatePalletCaseLabel();
	    updatePalletSpecificFields();
	    updateNumberOfCasePallet();
	    setApplyDimensionWeightBtn();
	  }
	
	  function updateChildren() {
	    updateProductList();
	  }
	
	  function setApplyDimensionWeightBtn() {
	    if (rowIdx == 0) {
	      (0, _selectorHelpers.show)(els.applyDimensionWeightOuter);
	    } else {
	      (0, _selectorHelpers.hide)(els.applyDimensionWeightOuter);
	    }
	  }
	
	  function getAsnDetailGroup() {
	    return getAsnDetailGroups()[rowIdx];
	  }
	
	  function updateNumberOfCasePallet() {
	    _jquery2.default.each(getAsnDetailGroup(), function (index, object) {
	      if (isPallet()) {
	        (0, _jquery2.default)(els.palletCaseNumber).html(object.numberOfPallets);
	      } else {
	        (0, _jquery2.default)(els.palletCaseNumber).html(object.numberOfCases);
	      }
	    });
	  }
	
	  function updatePalletSpecificFields() {
	    (0, _selectorHelpers.handleDisplayFor)(els.stackablePalletOuter, isPallet());
	  }
	
	  function updateValues() {
	    var asnDetail = getAsnDetail();
	    if (asnDetail) {
	      (0, _selectorHelpers.insertValAndManageFocus)(els.asnDetailLength, asnDetail.asd_package_length);
	      (0, _selectorHelpers.insertValAndManageFocus)(els.asnDetailWidth, asnDetail.asd_package_width);
	      (0, _selectorHelpers.insertValAndManageFocus)(els.asnDetailHeight, asnDetail.asd_package_height);
	      (0, _selectorHelpers.insertValAndManageFocus)(els.asnDetailWeight, asnDetail.asd_package_weight);
	      (0, _selectorHelpers.setCheckboxState)(els.stackablePalletCheckbox, asnDetail.stackablePallet);
	      if ((0, _general.isPresent)(asnDetail.dvlInsideCase)) {
	        (0, _selectorHelpers.setCheckboxState)(els.dvlInsideCase, asnDetail.dvlInsideCase);
	        els.dvlInsideCase.trigger('change');
	      }
	      if ((0, _general.isPresent)(asnDetail.useCalculatedVal)) {
	        (0, _selectorHelpers.setCheckboxState)(els.useCalculatedVal, asnDetail.useCalculatedVal);
	        if (els.useCalculatedVal.is(":checked")) {
	          (0, _selectorHelpers.insertValAndManageFocus)(els.declaredValueInput, asnDetail.dvlCalculatedValue);
	          els.declaredValueInput.prop('readonly', true);
	        } else {
	          var newVal = asnDetail.declaredValueCustomVal || asnDetail.declaredValue;
	          (0, _selectorHelpers.insertValAndManageFocus)(els.declaredValueInput, newVal);
	          els.declaredValueInput.prop('readonly', false);
	        }
	      }
	    }
	  }
	
	  //Need to revist this piece with _map.
	  function updateProductList() {
	    var productListHtml = "";
	    //let declaredCost = 0;
	    _jquery2.default.each(getAsnDetailGroup(), function (index, object) {
	      var palletCaseNumber = 0;
	      if (isPallet()) {
	        palletCaseNumber = object.numberOfPallets;
	      } else {
	        palletCaseNumber = object.numberOfCases;
	      }
	
	      var item = _ProductItemStore2.default.getDataViaAsnDetail(object);
	      if (item.length > 0) {
	        productListHtml += "<div class='row'> <div class='col-md-3 col-xs-12'><span class='q-tag'>" + object.sku + "</span></div><div class='col-md-6 col-xs-12'>" + item[0].prdName + "</div><div class='col-md-3 col-xs-12'>Quantity Packed:" + object.unitsPerCase + "</div></div>";
	        //declaredCost = object.declaredValue;
	      }
	    });
	
	    (0, _jquery2.default)(els.shippingTabSkus).html(productListHtml);
	    //$(els.declaredValueInput).val(declaredCost);
	  }
	
	  function updatePalletCaseIdx() {
	    els.palletCaseIdx.text(rowIdx + 1);
	  }
	
	  function updatePalletCaseLabel() {
	    var text = "Case";
	    if (isPallet()) {
	      text = "Pallet";
	    }
	    els.palletCaseLabel.text(text);
	    (0, _jquery2.default)(els.prdLevelPalletCaseLabel).html(text);
	  }
	
	  function defaultToOne(numb) {
	    return numb || 1;
	  }
	
	  function renderInit() {
	    var asnDetail = getAsnDetail();
	    var startDvlInsideCaseStyle = "display:none;";
	    var calculatedValueNoteCaseStyle = "";
	
	    if (asnDetail && asnDetail.dvlInsideCase) {
	      startDvlInsideCaseStyle = "";
	      if (asnDetail.useCalculatedVal) {
	        calculatedValueNoteCaseStyle = "display:none;";
	      }
	    }
	    self._element = (0, _jquery2.default)((0, _render2.default)(html, {
	      isPallet: isPallet(),
	      startDvlInsideCaseStyle: startDvlInsideCaseStyle,
	      calculatedValueNoteCaseStyle: calculatedValueNoteCaseStyle
	    }));
	    setElements();
	    setUniqueIdForStackble();
	    (0, _selectorHelpers.setUniqNamesAndIds)([els.asnDetailWidth, els.asnDetailLength, els.asnDetailHeight, els.asnDetailWeight]);
	    // make sure to set required AFTER setting uniq names, because jquery-validation sucks
	    (0, _selectorHelpers.setRequired)([els.asnDetailWidth, els.asnDetailLength, els.asnDetailHeight, els.asnDetailWeight]);
	    handleReadOnly();
	    setWidgets();
	    bindElements();
	    bindStores();
	    update();
	  }
	
	  function setUniqueIdForStackble() {
	    var checkBox = self._element.find(".stackable-pallet-checkbox-container");
	    checkBox.find("input").attr("id", "shipping-pallet-stackable" + rowIdx);
	    checkBox.find("input").attr("name", "shipping-pallet-stackable" + rowIdx);
	    checkBox.find("label").attr("for", "shipping-pallet-stackable" + rowIdx);
	  }
	
	  function handleReadOnly() {
	    if (readOnly) {
	      (0, _selectorHelpers.setDisabled)([els.asnDetailWidth, els.asnDetailLength, els.asnDetailHeight, els.asnDetailWeight, els.stackablePalletCheckbox]);
	    }
	  }
	
	  function getAsnDetail() {
	    return _AsnDetailStore2.default.getAsnDetail(asnDetailId);
	  }
	
	  function getAsn(id) {
	    return _AsnStore2.default.getAsn(id);
	  }
	
	  function bindApplyDimensionAndWeight() {
	    (0, _jquery2.default)(els.applyDimensionToAllBtn).on("click", function (e) {
	      _AsnDetailStore2.default.copyDimensionsToAllCasesForSameAsn(asnDetailId);
	    });
	  }
	}

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AsnDetailRowsView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnDetailRowView = __webpack_require__(531);
	
	var _AsnDetailRowView2 = _interopRequireDefault(_AsnDetailRowView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(293);
	
	
	var elementsMap = {
	  asnDetailRowsOuter: ".shipping-asn-details-rows-outer",
	  casePalletTitle: ".case-pallet-title"
	};
	
	function AsnDetailRowsView(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      getAsnDetailGroups = _ref.getAsnDetailGroups,
	      onLengthChange = _ref.onLengthChange,
	      onWidthChange = _ref.onWidthChange,
	      onHeightChange = _ref.onHeightChange,
	      onWeightChange = _ref.onWeightChange,
	      onAsnDetailGroupFieldChange = _ref.onAsnDetailGroupFieldChange,
	      onAsnFieldChange = _ref.onAsnFieldChange,
	      readOnly = _ref.readOnly,
	      isPallet = _ref.isPallet;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var asnDetailRowViews = [];
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {}
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateSelf();
	    updateChildren();
	  }
	
	  function updateSelf() {
	    updateCasePalletLabel();
	  }
	
	  function updateCasePalletLabel() {
	    var text = "Case";
	    if (isPallet()) {
	      text = "Pallet";
	    }
	    els.casePalletTitle.text(text);
	  }
	
	  function updateChildren() {
	    (0, _viewHelpers.unbindAll)(asnDetailRowViews);
	    asnDetailRowViews = renderAsnDetailRowViews();
	    els.asnDetailRowsOuter.html((0, _viewHelpers.extractElements)(asnDetailRowViews));
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", update);
	    _AsnDetailStore2.default.bindListener("asn_details:add", update);
	    _AsnDetailStore2.default.bindListener("asn_details:remove", update);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	  }
	
	  self.unbindListeners = function () {};
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindStores();
	  }
	
	  function renderAsnDetailRowViews() {
	    return (0, _underscore2.default)(getAsnDetailGroups()).map(function (asnDetailGroup, rowIdx) {
	      // get the first asnDetail in the Pallet/case,
	      // as all these values should be the same for the given
	      // AsnDetailRowView
	      var asnDetail = asnDetailGroup[0];
	      var asnDetailRowView = new _AsnDetailRowView2.default(asnDetail, {
	        readOnly: readOnly,
	        // onLengthChange, 
	        // onWidthChange,
	        // onHeightChange,
	        // onWeightChange,
	        onAsnDetailGroupFieldChange: onAsnDetailGroupFieldChange,
	        rowIdx: rowIdx,
	        isPallet: isPallet,
	        getAsnDetailGroups: getAsnDetailGroups
	      });
	      asnDetailRowView.init();
	      return asnDetailRowView;
	    });
	  }
	}

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AsnShippingPalletRowView;
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1240);
	
	
	var elementsMap = {
	  asnDetailLength: ".asn-detail-length",
	  asnDetailWidth: ".asn-detail-width",
	  asnDetailHeight: ".asn-detail-height",
	  asnDetailWeight: ".asn-detail-weight",
	  palletCaseIdx: ".pallet-case-idx",
	  palletCaseLabel: ".pallet-case-label",
	  stackablePalletOuter: ".stackable-pallet-outer",
	  stackablePalletCheckbox: ".stackable-pallet-checkbox",
	  shippingTabSkus: ".shipping-tab-prd-skus",
	  prdLevelPalletCaseLabel: ".prd-level-pallet-case-label",
	  palletCaseNumber: ".pallet-case-number",
	  applyDimensionWeightOuter: ".apply-dimension-weight-to-all-outer",
	  applyDimensionToAllBtn: ".apply-to-all-btn",
	  asnDetailRowsOuter: ".shipping-asn-details-rows-outer"
	};
	
	function AsnShippingPalletRowView(asnShippingPallet, options) {
	  var rowIdx = options.rowIdx,
	      onAsnShippingPalletFieldChange = options.onAsnShippingPalletFieldChange,
	      onAsnShippingPalletsGroupFieldChange = options.onAsnShippingPalletsGroupFieldChange,
	      getAsnShipppingPallets = options.getAsnShipppingPallets;
	
	
	  var asnShippingPalletId = asnShippingPallet.id;
	  var self = this;
	  self._element = $();
	  var els = {};
	
	  self.init = function () {
	    renderEl();
	  };
	
	  function bindStores() {
	    _AsnShippingPalletStore2.default.bindListener("asn_shipping_pallet:change", updateSelf);
	  }
	
	  self.unbindListeners = function () {
	    _AsnShippingPalletStore2.default.unbindListener("asn_shipping_pallet:change", updateSelf);
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setUniqueIdForStackble() {
	    var checkBox = self._element.find(".stackable-pallet-checkbox-container");
	    checkBox.find("input").attr("id", "shipping-pallet-stackable" + rowIdx);
	    checkBox.find("input").attr("name", "shipping-pallet-stackable" + rowIdx);
	    checkBox.find("label").attr("for", "shipping-pallet-stackable" + rowIdx);
	  }
	
	  function renderEl() {
	    //self._element = $(html);
	    var asnShippingPallet = getAsnShippingPallet(asnShippingPalletId);
	    self._element = $((0, _render2.default)(html, { rowIdx: rowIdx, asnShippingPalletId: asnShippingPalletId, palletData: asnShippingPallet }));
	
	    setElements();
	    setUniqueIdForStackble();
	    (0, _selectorHelpers.setUniqNamesAndIds)([els.asnDetailWidth, els.asnDetailLength, els.asnDetailHeight, els.asnDetailWeight]);
	    // make sure to set required AFTER setting uniq names, because jquery-validation sucks
	    (0, _selectorHelpers.setRequired)([els.asnDetailWidth, els.asnDetailLength, els.asnDetailHeight, els.asnDetailWeight]);
	
	    //bindElements();
	    bindStores();
	    update();
	  }
	
	  function update() {
	    // handle rendering children
	    updateSelf();
	  }
	
	  function updateSelf() {
	    // handle updating values;
	    updateValues();
	    updatePalletCaseIdx();
	    updatePalletCaseLabel();
	    updatePalletSpecificFields();
	    updateNumberOfCasePallet();
	    setApplyDimensionWeightBtn();
	  }
	
	  function updatePalletCaseIdx() {
	    els.palletCaseIdx.text(rowIdx + 1);
	  }
	
	  function updatePalletCaseLabel() {
	    els.palletCaseLabel.text("Pallet");
	    $(els.prdLevelPalletCaseLabel).html("Pallet");
	  }
	
	  function updatePalletSpecificFields() {
	    (0, _selectorHelpers.handleDisplayFor)(els.stackablePalletOuter, true);
	  }
	
	  function updateNumberOfCasePallet() {
	    $.each(getAsnShipppingPallets(), function (index, object) {
	      $(els.palletCaseNumber).html(object.numberOfPallets);
	    });
	  }
	
	  function getAsnShippingPallet(asnShippingPalletId) {
	    return _AsnShippingPalletStore2.default.getAsnShippingPallet(asnShippingPalletId);
	  }
	
	  function setApplyDimensionWeightBtn() {
	    if (rowIdx == 0) {
	      (0, _selectorHelpers.show)(els.applyDimensionWeightOuter);
	    } else {
	      (0, _selectorHelpers.hide)(els.applyDimensionWeightOuter);
	    }
	  }
	
	  function updateValues() {
	    var asnShippingPallet = getAsnShippingPallet(asnShippingPalletId);
	    (0, _selectorHelpers.insertValAndManageFocus)(els.asnDetailLength, asnShippingPallet.asp_pallet_length);
	    (0, _selectorHelpers.insertValAndManageFocus)(els.asnDetailWidth, asnShippingPallet.asp_pallet_width);
	    (0, _selectorHelpers.insertValAndManageFocus)(els.asnDetailHeight, asnShippingPallet.asp_pallet_height);
	    (0, _selectorHelpers.insertValAndManageFocus)(els.asnDetailWeight, asnShippingPallet.asp_pallet_weight);
	    (0, _selectorHelpers.setCheckboxState)(els.stackablePalletCheckbox, asnShippingPallet.asp_pallet_stackable);
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	}

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AsnShippingPalletRowsView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnShippingPalletRowView = __webpack_require__(533);
	
	var _AsnShippingPalletRowView2 = _interopRequireDefault(_AsnShippingPalletRowView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(293);
	
	
	var elementsMap = {
	  asnDetailRowsOuter: ".shipping-asn-details-rows-outer",
	  casePalletTitle: ".case-pallet-title",
	  asnDetailLength: ".asn-detail-length",
	  asnDetailWidth: ".asn-detail-width",
	  asnDetailHeight: ".asn-detail-height",
	  asnDetailWeight: ".asn-detail-weight",
	  applyDimensionToAllBtn: ".apply-to-all-btn",
	  stackablePalletCheckbox: ".stackable-pallet-checkbox"
	};
	
	function AsnShippingPalletRowsView(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      getAsnShipppingPallets = _ref.getAsnShipppingPallets,
	      onAsnShippingPalletFieldsChange = _ref.onAsnShippingPalletFieldsChange,
	      onAsnShippingPalletFieldChange = _ref.onAsnShippingPalletFieldChange,
	      onAsnShippingPalletsGroupFieldChange = _ref.onAsnShippingPalletsGroupFieldChange,
	      totalNewPallets = _ref.totalNewPallets;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var asnShippingPallets = [];
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function bindElements() {
	    bindApplyDimensionAndWeight();
	    (0, _jquery2.default)(document).on("input", elementsMap.asnDetailLength, handleAsnDetailGroupFieldChange("asp_pallet_length"));
	    (0, _jquery2.default)(document).on("input", elementsMap.asnDetailWidth, handleAsnDetailGroupFieldChange("asp_pallet_width"));
	    (0, _jquery2.default)(document).on("input", elementsMap.asnDetailHeight, handleAsnDetailGroupFieldChange("asp_pallet_height"));
	    (0, _jquery2.default)(document).on("input", elementsMap.asnDetailWeight, handleAsnDetailGroupFieldChange("asp_pallet_weight"));
	    (0, _jquery2.default)(document).on("click", elementsMap.stackablePalletCheckbox, handleAsnFieldCheckboxChange("asp_pallet_stackable"));
	  }
	
	  function bindApplyDimensionAndWeight() {
	    (0, _jquery2.default)(document).on("click", elementsMap.applyDimensionToAllBtn, function (e) {
	      var asnShippingPalletId = (0, _jquery2.default)(this).closest('.shipping-asn-detail-row').data('current-pallet-id');
	      _AsnShippingPalletStore2.default.copyDimensionsToAllCasesForSameAsn(asnShippingPalletId);
	    });
	  }
	  function handleAsnFieldCheckboxChange(key) {
	    return function (e) {
	      //onAsnShippingPalletFieldChange(rowIdx, key, !!$(this).is(":checked"));
	      var rowIdx = (0, _jquery2.default)(this).closest('.shipping-asn-detail-row').data('current-row-idx');
	      onAsnShippingPalletsGroupFieldChange(rowIdx, key, !!(0, _jquery2.default)(this).is(":checked"));
	    };
	  }
	  function setWidgets() {}
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateSelf();
	    updateChildren();
	  }
	
	  function updateSelf() {
	    updateCasePalletLabel();
	  }
	
	  function updateCasePalletLabel() {
	    els.casePalletTitle.text('Pallet');
	  }
	
	  function updateChildren() {
	    (0, _viewHelpers.unbindAll)(asnShippingPallets);
	    asnShippingPallets = renderAsnShippingPallets();
	    els.asnDetailRowsOuter.html((0, _viewHelpers.extractElements)(asnShippingPallets));
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", update);
	  }
	
	  self.unbindListeners = function () {};
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindStores();
	    bindElements();
	  }
	
	  function handleAsnDetailGroupFieldChange(key) {
	    return function (e) {
	
	      var val = (0, _jquery2.default)(this).val();
	      // only parseInt if it's a number,
	      // otherwise this field will end up
	      // as a NaN
	      if (_underscore2.default.isNumber(val)) {
	        val = parseInt(val, 10);
	      }
	      var rowIdx = (0, _jquery2.default)(this).closest('.shipping-asn-detail-row').data('current-row-idx');
	      onAsnShippingPalletsGroupFieldChange(rowIdx, key, val);
	      // options[funcName](rowIdx, val);
	    };
	  }
	
	  function renderAsnShippingPallets() {
	
	    return (0, _underscore2.default)(getAsnShipppingPallets()).map(function (asnShippingPalletGroup, rowIdx) {
	      // get the first asnDetail in the Pallet/case,
	      // as all these values should be the same for the given
	      // AsnDetailRowView
	      // rowIdx = rowIdx + 1;
	      // const asnShippingPallet = asnShippingPalletGroup[0];
	      var asnShippingPalletRowView = new _AsnShippingPalletRowView2.default(asnShippingPalletGroup, {
	        onAsnShippingPalletFieldChange: onAsnShippingPalletFieldChange,
	        rowIdx: rowIdx,
	        getAsnShipppingPallets: getAsnShipppingPallets,
	        onAsnShippingPalletsGroupFieldChange: onAsnShippingPalletsGroupFieldChange
	      });
	      asnShippingPalletRowView.init();
	      return asnShippingPalletRowView;
	    });
	  }
	}

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AvailableQuoteView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _currency = __webpack_require__(66);
	
	var _general = __webpack_require__(5);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1241);
	
	
	var elementsMap = {
	  quoteRadio: ".quote-radio",
	  estimatedPickupDate: ".estimated-pickup-date",
	  estimatedTransitTime: ".estimated-transit-time",
	  estimatedCost: ".estimated-cost"
	};
	
	function AvailableQuoteView(compositeQuoteId, _ref) {
	  var getSelectedQuote = _ref.getSelectedQuote,
	      onAsnFieldsChange = _ref.onAsnFieldsChange,
	      getAsn = _ref.getAsn;
	
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  self.init = function () {
	    render();
	  };
	
	  function bindElements() {
	    els.quoteRadio.on("click", onQuoteRadioClick);
	  }
	
	  function onQuoteRadioClick(e) {
	    var attrs = (0, _underscore2.default)(getQuote()).pick("quoteId", "optionId");
	    // console.log(attrs);
	    onAsnFieldsChange(attrs);
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:change:" + getAsnId(), updateSelf);
	  }
	
	  self.unbindListeners = function () {
	    _AsnStore2.default.unbindListener("asns:change:" + getAsnId(), updateSelf);
	  };
	
	  function setWidgets() {}
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    // handle rendering children
	    updateSelf();
	  }
	
	  function updateSelf() {
	    // handle updating values;
	    updateClasses();
	    updateValues();
	    updateText();
	  }
	
	  function updateClasses() {
	    (0, _selectorHelpers.toggleClassViaBool)(self.getElement(), "divider-group-selected", isSelectedQuote());
	  }
	
	  function updateValues() {
	    (0, _selectorHelpers.setRadioState)(els.quoteRadio, isSelectedQuote());
	  }
	
	  function updateText() {
	    var quote = getQuote();
	    if (!!quote) {
	      (0, _selectorHelpers.insertTextAndClean)(els.estimatedPickupDate, (0, _general.toWeekDayMonthAndDay)(quote.estimatedPickupDate));
	      (0, _selectorHelpers.insertTextAndClean)(els.estimatedTransitTime, quote.estimatedTransitTime);
	      (0, _selectorHelpers.insertTextAndClean)(els.estimatedCost, (0, _currency.toCurrency)(quote.estimatedCost));
	    }
	  }
	
	  function getAsnId() {
	    return getAsn().id;
	  }
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    bindElements();
	    bindStores();
	    update();
	  }
	
	  function isSelectedQuote() {
	    return _underscore2.default.isEqual(getSelectedQuote(), getQuote());
	  }
	
	  function getQuote() {
	    return QuoteStore.getDataViaId(compositeQuoteId);
	  }
	}

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AvailableQuotesListView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AvailableQuoteView = __webpack_require__(535);
	
	var _AvailableQuoteView2 = _interopRequireDefault(_AvailableQuoteView);
	
	var _QuoteStore = __webpack_require__(98);
	
	var _QuoteStore2 = _interopRequireDefault(_QuoteStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1238);
	
	
	var elementsMap = {
	  availableQuoteViewsEntryPoint: ".available-quote-views-entry-point"
	};
	
	function AvailableQuotesListView(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      onAsnFieldsChange = _ref.onAsnFieldsChange,
	      isPallet = _ref.isPallet;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var availableQuoteViews = [];
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {}
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateSelf();
	    updateChildren();
	  }
	
	  function updateSelf() {
	    // No self inputs
	  }
	
	  function updateChildren() {
	    (0, _viewHelpers.unbindAll)(availableQuoteViews);
	    availableQuoteViews = renderAvailableQuoteViews();
	    els.availableQuoteViewsEntryPoint.html((0, _viewHelpers.extractElements)(availableQuoteViews));
	  }
	
	  function bindStores() {
	    // NOTE: we don't need to bind to anything asn related
	    // because the parent view should handle hiding this one
	    // if anything asn related changes
	    _QuoteStore2.default.bindListener("quotes:change", updateChildren);
	    _QuoteStore2.default.bindListener("quotes:remove", updateChildren);
	  }
	
	  self.unbindListeners = function () {
	    _QuoteStore2.default.unbindListener("quotes:change", updateChildren);
	    _QuoteStore2.default.unbindListener("quotes:remove", updateChildren);
	  };
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindStores();
	  }
	
	  function getAvailableQuotes() {
	    return AsnStore.getAvailableAndSelectedQuotesForAsn(getAsn());
	  }
	
	  function getSelectedQuote() {
	    return AsnStore.getSelectedQuoteForAsn(getAsn());
	  }
	
	  function renderAvailableQuoteViews() {
	    return (0, _underscore2.default)(getAvailableQuotes()).map(function (availableQuote, rowIdx) {
	      var id = _QuoteStore2.default.idAttribute(availableQuote);
	      var availableQuoteView = new _AvailableQuoteView2.default(id, {
	        getSelectedQuote: getSelectedQuote,
	        onAsnFieldsChange: onAsnFieldsChange,
	        getAsn: getAsn
	      });
	      availableQuoteView.init();
	      return availableQuoteView;
	    });
	  }
	}

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CaseArrivalAndTrackingRowView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1242);
	
	
	var elementsMap = {
	  trackingNumberInput: ".case-tracking-number-input",
	  expectedArrivalDateInput: ".case-expected-arrival-date-input",
	  palletCaseIdx: ".pallet-case-idx"
	};
	
	function CaseArrivalAndTrackingRowView(asnDetail, _ref) {
	  var readOnly = _ref.readOnly,
	      onAsnDetailGroupFieldChange = _ref.onAsnDetailGroupFieldChange,
	      rowIdx = _ref.rowIdx;
	
	  var asnDetailId = asnDetail.id;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  self.init = function () {
	    render();
	  };
	
	  function bindElements() {
	    els.trackingNumberInput.on("blur", onAsnDetailGroupFieldChangeFunc("asd_tracking_number"));
	    els.expectedArrivalDateInput.on("input change", onAsnDetailGroupFieldChangeFunc("asd_expected_arrival_date"));
	  }
	
	  function onAsnDetailGroupFieldChangeFunc(asnKeyName) {
	    return function (e) {
	      var val = (0, _jquery2.default)(e.target).val();
	      onAsnDetailGroupFieldChange(rowIdx, asnKeyName, val);
	    };
	  }
	
	  function setWidgets() {
	    instantiateExpArrivalDatePicker();
	  }
	
	  function instantiateExpArrivalDatePicker() {
	    var date = new Date();
	    var enddate = new Date();
	    enddate.setDate(enddate.getDate() + 30);
	    els.expectedArrivalDateInput.datepicker({
	      startDate: date,
	      endDate: enddate,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      forceParse: false,
	      calendarWeeks: true,
	      autoclose: true
	    });
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    // handle rendering children
	    updateSelf();
	  }
	
	  function updateSelf() {
	    // handle updating values;
	    updateValues();
	    updatePalletCaseIdx();
	  }
	
	  function updateValues() {
	    (0, _selectorHelpers.insertValAndManageFocus)(els.trackingNumberInput, getAsnDetail().asd_tracking_number);
	    (0, _selectorHelpers.insertValAndManageFocus)(els.expectedArrivalDateInput, getAsnDetail().asd_expected_arrival_date);
	  }
	
	  function bindStores() {
	    AsnDetailStore.bindListener("asn_details:change:" + asnDetailId, updateSelf);
	  }
	
	  self.unbindListeners = function () {
	    AsnDetailStore.unbindListener("asn_details:change:" + asnDetailId, updateSelf);
	  };
	
	  function updatePalletCaseIdx() {
	    els.palletCaseIdx.text(rowIdx + 1);
	  }
	
	  function defaultToOne(numb) {
	    return numb || 1;
	  }
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    (0, _selectorHelpers.setUniqNamesAndIds)([els.trackingNumberInput, els.expectedArrivalDateInput]);
	    // make sure to set required AFTER setting uniq names, because jquery-validation sucks
	    (0, _selectorHelpers.setRequired)([els.expectedArrivalDateInput]);
	    handleReadOnly();
	    setWidgets();
	    bindElements();
	    bindStores();
	    update();
	  }
	
	  function handleReadOnly() {
	    if (readOnly) {
	      (0, _selectorHelpers.setDisabled)([els.trackingNumberInput, els.expectedArrivalDateInput]);
	    }
	  }
	
	  function getAsnDetail() {
	    return AsnDetailStore.getAsnDetail(asnDetailId);
	  }
	}

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DetailPickupQuoteView;
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailRowsView = __webpack_require__(532);
	
	var _AsnDetailRowsView2 = _interopRequireDefault(_AsnDetailRowsView);
	
	var _PickupSchedulingView = __webpack_require__(540);
	
	var _PickupSchedulingView2 = _interopRequireDefault(_PickupSchedulingView);
	
	var _RequestQuoteView = __webpack_require__(541);
	
	var _RequestQuoteView2 = _interopRequireDefault(_RequestQuoteView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1244);
	
	
	var elementsMap = {
	  asnDetailRowsViewEntryPoint: ".asn-detail-rows-view-entry-point",
	  pickupSchedulingEntryPoint: ".pickup-scheduling-entry-point",
	  requestQuoteEntryPoint: ".request-quote-entry-point",
	
	  asnDetailRowsSection: ".asn-detail-rows-section",
	  asnShippingPalletRowsSection: ".asn-shipping-pallets-rows-section",
	  pickupSchedulingSection: ".pickup-scheduling-section",
	  requestQuoteSection: ".request-qoute-section",
	  moreInfoShippingMessage: ".more-info-shipping-outer"
	};
	
	function DetailPickupQuoteView(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      getAsnDetailGroups = _ref.getAsnDetailGroups,
	      csrEmailUrl = _ref.csrEmailUrl,
	      onAsnDetailGroupFieldChange = _ref.onAsnDetailGroupFieldChange,
	      hasShippingPartnerSelected = _ref.hasShippingPartnerSelected,
	      hasShippingPartner = _ref.hasShippingPartner,
	      onAsnFieldChange = _ref.onAsnFieldChange,
	      onAsnFieldsChange = _ref.onAsnFieldsChange,
	      onRequestQuoteClicked = _ref.onRequestQuoteClicked,
	      isPallet = _ref.isPallet,
	      readOnly = _ref.readOnly,
	      didAttemptToNavigateAwayFromCurrentForm = _ref.didAttemptToNavigateAwayFromCurrentForm;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  self.init = function () {
	    render();
	  };
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    bindStores();
	    updateSelf();
	  }
	
	  function updateSelf() {
	    toggleSubViews();
	  }
	
	  function toggleSubViews() {
	    // if nothing selected, show no subview
	    hideAllSubviews();
	    if (hasShippingPartnerSelected()) {
	      if (hasShippingPartner()) {
	        if (isPallet()) {
	          (0, _selectorHelpers.show)(els.asnDetailRowsSection);
	          (0, _selectorHelpers.show)(els.pickupSchedulingSection);
	          (0, _selectorHelpers.show)(els.requestQuoteSection);
	        } else if (!isPallet()) {
	          var freightShipping = hasFreigthSelected(getAsn());
	          if ((0, _general.isPresent)(freightShipping)) {
	            if (freightShipping) {
	              (0, _selectorHelpers.show)(els.asnShippingPalletRowsSection);
	              (0, _selectorHelpers.show)(els.pickupSchedulingSection);
	              (0, _selectorHelpers.show)(els.requestQuoteSection);
	            } else {
	              (0, _selectorHelpers.show)(els.asnDetailRowsSection);
	              (0, _selectorHelpers.show)(els.moreInfoShippingMessage);
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function hideAllSubviews() {
	    (0, _selectorHelpers.hide)(els.moreInfoShippingMessage);
	    (0, _selectorHelpers.hide)(els.asnDetailRowsSection);
	    (0, _selectorHelpers.hide)(els.pickupSchedulingSection);
	    (0, _selectorHelpers.hide)(els.requestQuoteSection);
	    (0, _selectorHelpers.hide)(els.asnShippingPalletRowsSection);
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.bindListener("asns:shipping_partner_changed", updateSelf);
	    _AsnStore2.default.bindListener("asns:freight_shipping_change", updateSelf);
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {
	    var asnDetailRowsView = new _AsnDetailRowsView2.default(null, {
	      getAsn: getAsn,
	      getAsnDetailGroups: getAsnDetailGroups,
	      onAsnDetailGroupFieldChange: onAsnDetailGroupFieldChange,
	      isPallet: isPallet,
	      readOnly: readOnly
	    });
	    asnDetailRowsView.init();
	
	    els.asnDetailRowsViewEntryPoint.html(asnDetailRowsView.getElement());
	
	    var pickupSchedulingView = new _PickupSchedulingView2.default(null, {
	      getAsn: getAsn,
	      isPallet: isPallet,
	      onAsnFieldChange: onAsnFieldChange,
	      onAsnFieldsChange: onAsnFieldsChange,
	      readOnly: readOnly
	    });
	    pickupSchedulingView.init();
	    els.pickupSchedulingEntryPoint.html(pickupSchedulingView.getElement());
	
	    var requestQuoteView = new _RequestQuoteView2.default(null, {
	      onRequestQuoteClicked: onRequestQuoteClicked,
	      getAsn: getAsn,
	      isPallet: isPallet,
	      onAsnFieldsChange: onAsnFieldsChange,
	      csrEmailUrl: csrEmailUrl,
	      didAttemptToNavigateAwayFromCurrentForm: didAttemptToNavigateAwayFromCurrentForm,
	      readOnly: readOnly
	    });
	    requestQuoteView.init();
	    els.requestQuoteEntryPoint.html(requestQuoteView.getElement());
	  }
	
	  function hasFreigthSelected(asn) {
	    return _AsnStore2.default.hasFreigthSelected(asn.id);
	  }
	}

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = InboundCarrierView;
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _ShippingMethodStore = __webpack_require__(113);
	
	var _ShippingMethodStore2 = _interopRequireDefault(_ShippingMethodStore);
	
	var _BrokerStore = __webpack_require__(223);
	
	var _BrokerStore2 = _interopRequireDefault(_BrokerStore);
	
	var _general = __webpack_require__(5);
	
	var _domain = __webpack_require__(1054);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1246);
	var carrBrokerhtml = __webpack_require__(1245);
	var createCarrierOrBrokerModalBodyHtml = __webpack_require__(1243);
	var modalHtml = __webpack_require__(11);
	
	/*import CaseArrivalAndTrackingRowView from "./CaseArrivalAndTrackingRowView";*/
	
	var elementsMap = {
	  inboundCarrierOuter: ".inbound-carrier-outer",
	  caseArrivalAndTrackingRows: ".case-exp-arrival-tracking-rows",
	  shippingSelectOuter: ".shipping-select-outer",
	  brokerSelectOuter: ".broker-select-outer",
	  shippingPhoneCodeSelectOuter: ".shipping-phone-code-select-outer",
	  otherFieldsOuter: ".other-fields-outer",
	  palletSpecificInboundCarrierFields: ".pallet-specific-inbound-carrier-fields",
	  otherCarrierInput: "#other-carrier-input",
	  carrierContactNameInput: "#carrier-contact-name-input",
	  carrierContactPhoneInput: "#carrier-contact-phone-input",
	  carrierBolProNumberInput: "#carrier-bol-pro-number-input",
	  carrierExpectedArrivalDateInput: "#carrier-expected-arrival-date-input",
	  bolNumbersInput: ".carrier-bol-pro-number-input",
	  trackingNumberInput: ".case-tracking-number-input",
	  saveCarrier: "#save-carrier",
	  createCarrier: ".create-carrier-btn",
	  carrierBrokerBtnInputVal: ".carrier-broker-val",
	  carrierBrokerToggler: ".carrier-broker-toggler",
	  carrierBrokerOrgType: "carrier-broker-org-type",
	  carrierContinueBtn: ".continue-btn"
	
	};
	
	var elsModal = {};
	
	var elsModalMap = {
	  carrierContinueBtn: '.continue-btn'
	};
	
	function InboundCarrierView(_unused) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var self = this;
	  var isUpdateVal = void 0;
	  var carrierBrokerModal = void 0;
	  var asn = void 0;
	  var getAsn = options.getAsn,
	      getAsnDetailGroups = options.getAsnDetailGroups,
	      isPallet = options.isPallet,
	      onShippingMethodChange = options.onShippingMethodChange,
	      onAsnFieldChange = options.onAsnFieldChange,
	      onAsnDetailGroupFieldChange = options.onAsnDetailGroupFieldChange,
	      onFieldCloneToAsnDetailsChange = options.onFieldCloneToAsnDetailsChange,
	      getAllCountriesPhoneCode = options.getAllCountriesPhoneCode,
	      onCountryPhoneCodeChange = options.onCountryPhoneCodeChange,
	      getDefaultCarriers = options.getDefaultCarriers,
	      getCarrierCreateUrl = options.getCarrierCreateUrl;
	
	
	  self._element = (0, _jquery2.default)();
	  var els = {};
	
	  var modalOpts = { backdrop: 'static', show: false };
	  /* let caseArrivalAndTrackingRowViews = [];*/
	
	  self.init = function () {
	    renderscreen();
	  };
	
	  self.getCarrierPhoneCode = function () {
	    return els.carrierContactPhoneInput;
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	    els.shippingSelect = generateShippingSelect();
	    els.brokerSelect = generateBrokerSelect();
	    els.phoneCodeSelect = generatePhoneCodeSelect();
	    els.shippingPhoneCodeSelectOuter.html(els.phoneCodeSelect);
	    els.shippingSelectOuter.html(els.shippingSelect);
	    els.brokerSelectOuter.html(els.brokerSelect);
	  }
	
	  function generateShippingSelect() {
	    var shippingMethodObject = getShippingMethods();
	    var defaultCarriersJsonArray = getDefaultCarriers();
	    var select = (0, _jquery2.default)("<select class='shipping-select' style='width:100%' data-error-placement-append-closest='div'></select>");
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', "").text("Select Inbound Carrier");
	    select.append(option);
	
	    if (asn != null && asn.asn_org_id !== null && asn.asn_org_id !== "" && (asn.asn_org_id === undefined || asn.asn_org_id !== 0)) {
	
	      for (var keyValue in shippingMethodObject) {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', shippingMethodObject[keyValue].orgId).text(shippingMethodObject[keyValue].orgName);
	        select.append(option);
	      }
	    } else {
	
	      for (var _keyValue in shippingMethodObject) {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', shippingMethodObject[_keyValue].cdmValue).text(shippingMethodObject[_keyValue].cdmValue);
	        select.append(option);
	      }
	
	      for (var _keyValue2 in defaultCarriersJsonArray) {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', defaultCarriersJsonArray[_keyValue2].cdmValue).text(defaultCarriersJsonArray[_keyValue2].cdmValue);
	        select.append(option);
	      }
	    }
	
	    return select;
	  }
	
	  function generateBrokerSelect() {
	    var brokerObject = getBrokers();
	    var select = (0, _jquery2.default)("<select class='shipping-select' style='width:100%' data-error-placement-append-closest='div'></select>");
	
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', "").text("Select Broker");
	    select.append(option);
	    for (var keyValue in brokerObject) {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', brokerObject[keyValue].orgId).text(brokerObject[keyValue].orgName);
	      select.append(option);
	    }
	
	    return select;
	  }
	
	  function generatePhoneCodeSelect() {
	    var select = (0, _jquery2.default)("<select name='countryCode' id='asn-carrier-country-phone-code' class='select2-select q-input' style='width:100%' data-error-placement-append-closest='div' data-s2-placeholder='Country Code' data-s2-minimum-results-for-search='5'></select>");
	    var usaCanadaPhoneCodeExists = false;
	    (0, _jquery2.default)(getAllCountriesPhoneCode()).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      if (this.conPhoneCode === '+1') {
	        if (!usaCanadaPhoneCodeExists) {
	          option.attr('value', this.conPhoneCode).text("United States of America/Canada +1");
	          usaCanadaPhoneCodeExists = true;
	        }
	      } else {
	        option.attr('value', this.conPhoneCode).text(this.conPhoneText);
	      }
	      select.append(option);
	    });
	    return select;
	  }
	
	  function setWidgets() {
	    els.shippingSelect.select2({
	      placeholder: "Select Inbound Carrier",
	      minimumResultsForSearch: "Infinity"
	    });
	    els.brokerSelect.select2({
	      placeholder: "Select Broker",
	      minimumResultsForSearch: "Infinity"
	    });
	
	    els.carrierContactPhoneInput.inputmask({
	      mask: "(999) 999-9999"
	    });
	    instantiateExpArrivalDatePicker();
	  }
	
	  function instantiateExpArrivalDatePicker() {
	    var date = new Date();
	    var enddate = new Date();
	    enddate.setDate(enddate.getDate() + 90);
	    els.carrierExpectedArrivalDateInput.datepicker({
	      startDate: date,
	      endDate: enddate,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      forceParse: false,
	      autoclose: true
	    });
	    els.carrierExpectedArrivalDateInput.keypress(function (event) {
	      event.preventDefault();
	    }); //make non-typeable/readonly texbox
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  self.isCarrierNameValid = function () {
	    return isCarrierNameValid();
	  };
	
	  function isCarrierNameValid() {
	    var valid = true;
	    if (els.shippingSelect.val() == "Other") {
	      valid = validateCarrierName(els.otherCarrierInput.val());
	    }
	
	    if (valid) {
	      (0, _jquery2.default)("#duplicate-default-carrier-error-message").hide();
	    } else {
	      (0, _jquery2.default)("#duplicate-default-carrier-error-message").show();
	    }
	
	    return valid;
	  }
	
	  function renderscreen() {
	    asn = getAsn();
	    if (asn != null && asn.asn_org_id !== "" && (asn.asn_org_id === undefined || asn.asn_org_id !== 0)) {
	      self._element = (0, _jquery2.default)(carrBrokerhtml);
	    } else {
	      self._element = (0, _jquery2.default)(carrBrokerhtml);
	      asn.asn_org_id = null;
	    }
	    buildModalHtml();
	    setElementsOnModal();
	    setElements();
	    (0, _selectorHelpers.setUniqNames)([els.otherCarrierInput, els.phoneCodeSelect, els.shippingSelect, els.brokerSelect, els.carrierContactNameInput, els.carrierContactNameInput, els.carrierContactPhoneInput, els.carrierBolProNumberInput, els.carrierExpectedArrivalDateInput, els.saveCarrier]);
	    // make sure to set required AFTER setting uniq names, because jquery-validation sucks
	    (0, _selectorHelpers.setRequired)([els.otherCarrierInput, els.phoneCodeSelect, els.shippingSelect, els.brokerSelect, els.carrierContactNameInput, els.carrierContactNameInput, els.carrierContactPhoneInput, els.carrierExpectedArrivalDateInput]);
	    setWidgets();
	    update();
	    bindElements();
	    bindStores();
	  }
	
	  function setElementsOnModal() {
	    var $body = (0, _jquery2.default)('body');
	    (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, $body);
	  }
	
	  function update() {
	    updateSelf();
	    updateChildren();
	    els.otherFieldsOuter.hide();
	  }
	
	  function updateChildren() {
	    if (!isPallet()) {
	      /*      unbindAll(caseArrivalAndTrackingRowViews);
	            caseArrivalAndTrackingRowViews = renderCaseArrivalAndTrackingRowViews();
	            els.caseArrivalAndTrackingRows.html(extractElements(caseArrivalAndTrackingRowViews));*/
	    }
	  }
	
	  function updateSelf() {
	    //Update carrier values from AsnStore
	    updateCarrierValues();
	
	    (0, _selectorHelpers.handleDisplayFor)(els.otherFieldsOuter, isInboundCarrierOther());
	    (0, _selectorHelpers.handleDisplayFor)(els.palletSpecificInboundCarrierFields, isPallet());
	    // handle children insertion container display:
	    // hide for pallet (these rows are case specific)
	    (0, _selectorHelpers.handleDisplayFor)(els.caseArrivalAndTrackingRows, !isPallet());
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", update);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	    _AsnDetailStore2.default.bindListener("asn_details:add", update);
	    _AsnDetailStore2.default.bindListener("asn_details:remove", update);
	  }
	
	  function bindElements() {
	    els.shippingSelect.on("change", onShippingSelectChangeCb);
	    els.brokerSelect.on("change", onBrokerSelectChangeCb);
	    els.phoneCodeSelect.on("change", onCountryPhoneCodeChangeCb);
	    els.otherCarrierInput.on("change", isCarrierNameValid);
	    els.otherCarrierInput.on("blur", onAsnFieldChangeFunc("asn_carrier_name"));
	    els.carrierContactNameInput.on("blur", onAsnFieldChangeFunc("asn_carrier_contact_name"));
	    els.carrierContactPhoneInput.on("blur", onAsnFieldChangeFunc("asn_carrier_phone"));
	    els.carrierBolProNumberInput.on("blur", onAsnFieldChangeFunc("asn_bol_pro_number"));
	    els.carrierExpectedArrivalDateInput.on("input change", onAsnFieldChangeFunc("asn_expected_arrival_date"));
	    els.trackingNumberInput.on("blur", onFieldCloneToAsnDetailsChangeFunc("asd_tracking_number"));
	    els.carrierExpectedArrivalDateInput.on("input change", onFieldCloneToAsnDetailsChangeFunc("asd_expected_arrival_date"));
	    els.saveCarrier.on("click", onAsnFieldChangeFunc("asn_save_carrier"));
	    els.createCarrier.on("click", showCarrierOrgModal);
	    elsModal.carrierContinueBtn.on("click", handleCarrierBrokerModalClose);
	  }
	
	  function handleCarrierBrokerModalClose(e) {
	    e.preventDefault();
	    carrierBrokerModal.modal("hide");
	
	    console.log('carrierCreateUrl' + getCarrierCreateUrl());
	    if (_AsnStore2.default.getCarrierBroker() === 'broker') {
	      window.open(getCarrierCreateUrl() + '&ContinueBrokerOrgType=true', '_blank');
	    } else {
	      window.open(getCarrierCreateUrl() + '&ContinueCarrierOrgType=true', '_blank');
	    }
	  }
	
	  function updateCarrierValues() {
	    var asn = getAsn();
	
	    if (asn != null && asn.asn_org_id !== null && asn.asn_org_id !== "" && asn.asn_org_id !== undefined && asn.asn_org_id !== 0) {
	      var carrierBrokerTogglerGroup = new _QuickBtnGroup2.default(els.carrierBrokerToggler, { distributeWidth: true });
	      carrierBrokerTogglerGroup.init();
	      //    if(getCarrierBrokerOrgType() ==='Carrier'){
	      if (_AsnStore2.default.getCarrierBroker() == 'broker' || _AsnStore2.default.getCarrierBroker() == 'transportation broker') {
	        els.brokerSelect.val(asn.asn_org_id).trigger('change.select2');
	        els.carrierBrokerBtnInputVal.val("broker");
	        carrierBrokerTogglerGroup.activateBtnViaKey("broker");
	        _AsnStore2.default.selectCarrierBroker('broker');
	      } else if (_AsnStore2.default.getCarrierBroker() == 'carrier') {
	        els.shippingSelect.val(asn.asn_org_id).trigger('change.select2');
	        els.carrierBrokerBtnInputVal.val("carrier");
	        carrierBrokerTogglerGroup.activateBtnViaKey("carrier");
	        _AsnStore2.default.selectCarrierBroker('carrier');
	      }
	    } else {
	      els.shippingSelect.val(asn.inboundCarrier).trigger('change.select2');
	    }
	    (0, _selectorHelpers.insertValAndManageFocus)(els.otherCarrierInput, asn.asn_carrier_name);
	    els.phoneCodeSelect.val(asn.asn_carrier_phone_code).trigger('change.select2');
	    (0, _selectorHelpers.insertValAndManageFocus)(els.carrierContactNameInput, asn.asn_carrier_contact_name);
	    (0, _selectorHelpers.insertValAndManageFocus)(els.carrierContactPhoneInput, asn.asn_carrier_phone);
	    (0, _selectorHelpers.insertValAndManageFocus)(els.carrierBolProNumberInput, asn.asn_bol_pro_number);
	    (0, _selectorHelpers.insertValAndManageFocus)(els.carrierExpectedArrivalDateInput, asn.asn_expected_arrival_date);
	    if (!(0, _general.isBlank)(getFirstAsnDetail())) {
	      (0, _selectorHelpers.insertValAndManageFocus)(els.trackingNumberInput, getFirstAsnDetail()[0].asd_tracking_number);
	    }
	  }
	
	  function onAsnFieldChangeFunc(asnKeyName) {
	    var val = void 0;
	    return function (e) {
	      if (asnKeyName == "asn_save_carrier") {
	        onAsnFieldChange(asnKeyName, (0, _jquery2.default)(e.target).is(":checked"));
	      } else {
	        val = (0, _jquery2.default)(e.target).val();
	        onAsnFieldChange(asnKeyName, val);
	      }
	    };
	  }
	
	  function onFieldCloneToAsnDetailsChangeFunc(key) {
	    return function (e) {
	      var val = (0, _jquery2.default)(e.target).val();
	      onFieldCloneToAsnDetailsChange(key, val);
	    };
	  }
	
	  function onShippingSelectChangeCb() {
	    els.carrierBrokerOrgType = 'Carrier';
	    var val = els.shippingSelect.val();
	    populateCarrierValuesFromStore(val);
	  }
	
	  function onBrokerSelectChangeCb() {
	    els.carrierBrokerOrgType = 'Broker';
	    var val = els.brokerSelect.val();
	    populateBrokerValuesFromStore(val);
	  }
	
	  function onCountryPhoneCodeChangeCb() {
	    var val = els.phoneCodeSelect.val();
	    onCountryPhoneCodeChange(val);
	  }
	
	  function isInboundCarrierOther() {
	    var inboundCarrierVal = getAsn().inboundCarrier;
	    var defaultCarriersJsonArray = getDefaultCarriers();
	    if (inboundCarrierVal !== null) {
	      if (inboundCarrierVal === "Other") {
	        return true;
	      }
	      for (var keyValue in defaultCarriersJsonArray) {
	        if (inboundCarrierVal === defaultCarriersJsonArray[keyValue].cdmValue) {
	          return false;
	        }
	      }
	      return true;
	    }
	  }
	
	  function validateCarrierName(name) {
	    if (name == "Other") {
	      return true;
	    } else if (getDefaultShippingMethod(name)) {
	      return false;
	    }
	    return true;
	  }
	
	  function populateBrokerValuesFromStore(newBroker) {
	    var asn = {
	      //inboundCarrier: newCarrier
	      inboundBroker: newBroker
	    };
	
	    var brokerMethodObject = getBrokerMethod(newBroker);
	    if (brokerMethodObject) {
	      asn.asn_org_id = brokerMethodObject.orgId;
	      asn.asn_carrier_name = brokerMethodObject.orgName;
	      asn.asn_carrier_contact_name = brokerMethodObject.carContactName;
	      asn.asn_carrier_phone_code = brokerMethodObject.carPhoneCountryCode;
	      asn.asn_carrier_phone = brokerMethodObject.carContactPhone;
	    }
	    _AsnStore2.default.updateObjectAndEmit(getAsn().id, asn);
	  }
	
	  function populateCarrierValuesFromStore(newCarrier) {
	    var asn = {
	      inboundCarrier: newCarrier
	    };
	
	    var shippingMethodObject = getShippingMethod(newCarrier);
	    if (shippingMethodObject) {
	      asn.asn_org_id = shippingMethodObject.orgId;
	      if (asn.asn_org_id === null) {
	        asn.asn_carrier_name = shippingMethodObject.carName;
	      } else {
	        asn.asn_carrier_name = shippingMethodObject.orgName;
	      }
	      asn.asn_carrier_contact_name = shippingMethodObject.carContactName;
	      asn.asn_carrier_phone_code = shippingMethodObject.carPhoneCountryCode;
	      asn.asn_carrier_phone = shippingMethodObject.carContactPhone;
	    } else {
	      shippingMethodObject = getDefaultShippingMethod(newCarrier);
	      if (shippingMethodObject && shippingMethodObject.cdmValue != 'Other') {
	        asn.asn_carrier_name = shippingMethodObject.cdmValue;
	        asn.asn_carrier_contact_name = "";
	        asn.asn_carrier_phone_code = "";
	        asn.asn_carrier_phone = "";
	      } else {
	        asn.asn_carrier_name = "";
	        asn.asn_carrier_contact_name = "";
	        asn.asn_carrier_phone_code = "";
	        asn.asn_carrier_phone = "";
	      }
	    }
	
	    _AsnStore2.default.updateObjectAndEmit(getAsn().id, asn);
	  }
	
	  function getDefaultShippingMethod(search) {
	    var defaultCarriersJsonArray = getDefaultCarriers();
	    return (0, _underscore2.default)(defaultCarriersJsonArray).findWhere({ cdmValue: search });
	  }
	
	  function getShippingMethod(name) {
	    return _ShippingMethodStore2.default.getShippingMethod(name);
	  }
	
	  function getShippingMethods() {
	    return _ShippingMethodStore2.default.getShippingMethods();
	  }
	  function getBrokerMethod(name) {
	    return _BrokerStore2.default.getBroker(name);
	  }
	
	  function getBrokers() {
	    return _BrokerStore2.default.getBrokers();
	  }
	
	  function getFirstAsnDetail() {
	    return getAsnDetailGroups()[0];
	  }
	
	  function buildModalHtml() {
	    carrierBrokerModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	      title: 'Create Organization',
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-500",
	      body: createCarrierOrBrokerModalBodyHtml,
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: "\n        <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a> <a href=\"#\" class=\"base-btn purple-btn continue-btn\">Continue</a>\n          "
	    }));
	    carrierBrokerModal.modal(modalOpts);
	
	    (0, _jquery2.default)('body').append(carrierBrokerModal);
	  }
	
	  function showCarrierOrgModal(e) {
	    e.preventDefault();
	    carrierBrokerModal.modal('show');
	  }
	}

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PickupSchedulingView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _timePicker = __webpack_require__(144);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1247);
	
	
	var elementsMap = {
	  pickupDateInput: ".pickup-date-input",
	  pickupDateMessage: ".pickup-date-message",
	  insidePickupCheckbox: ".inside-pickup-checkbox",
	  liftGatePickupCheckbox: ".lift-gate-pickup-checkbox",
	  limitedAccessCheckbox: ".limited-access-checkbox",
	  lumperPickupCheckbox: ".lumper-pickup-checkbox",
	  driverLoadCheckbox: ".driver-load-checkbox",
	
	  pickupTimeRangeMessage: ".shipping-tab-pickup-time-range-error-message",
	
	  insidePickupMessageOuter: ".inside-pickup-message-outer",
	  liftGatePickupMessageOuter: ".lift-gate-pickup-message-outer",
	  limitedAccessMessageOuter: ".limited-access-message-outer",
	  lumperPickupMessageOuter: ".lumper-pickup-message-outer",
	  driverLoadMessageOuter: ".driver-load-message-outer",
	
	  timePickerFrom: ".time-picker-from",
	  timePickerTo: ".time-picker-to"
	
	  //   pickupTimeFromHoursInput: ".pickup-time-from-hours-input",
	  //   pickupTimeFromMinutesInput: ".pickup-time-from-minutes-input",
	  //   pickupTimeFromPeriodInput: ".pickup-time-from-period-input",
	
	  //   pickupTimeToHoursInput: ".pickup-time-to-hours-input",
	  //   pickupTimeToMinutesInput: ".pickup-time-to-minutes-input",
	  //   pickupTimeToPeriodInput: ".pickup-time-to-period-input", 
	};
	
	var PICKUP_DATE_MESSAGE_STUB = " pick-ups will incur additional expense in your shipping quote.";
	
	function PickupSchedulingView(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      onAsnFieldChange = _ref.onAsnFieldChange,
	      onAsnFieldsChange = _ref.onAsnFieldsChange,
	      isPallet = _ref.isPallet,
	      readOnly = _ref.readOnly;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var asnDetailRowViews = [];
	  var timePickerFrom = void 0,
	      timePickerTo = void 0;
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {
	    instantiatePickupDatePicker();
	  }
	
	  function instantiatePickupDatePicker() {
	    var date = new Date();
	    date.setDate(date.getDate() + 1);
	    els.pickupDateInput.datepicker({
	      startDate: date,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	
	    var timePickerOptions = { disableAll: readOnly };
	
	    timePickerFrom = (0, _timePicker2.default)(els.timePickerFrom, timePickerOptions);
	    timePickerTo = (0, _timePicker2.default)(els.timePickerTo, timePickerOptions);
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateSelf();
	  }
	
	  function updateSelf() {
	    updateVals();
	    updateMessages();
	  }
	
	  function updateTimeFor(timePicker, obj, keyExt) {
	    timePicker.setTimeFromMilitary(obj["pickupTime" + keyExt]);
	  }
	
	  function updateVals() {
	    // update all inputs
	    var asn = getAsn();
	    (0, _selectorHelpers.insertValAndManageFocus)(els.pickupDateInput, asn.pickupDate);
	
	    updateTimeFor(timePickerFrom, asn, "From");
	    updateTimeFor(timePickerTo, asn, "To");
	
	    (0, _selectorHelpers.setCheckboxState)(els.insidePickupCheckbox, asn.insidePickup);
	    (0, _selectorHelpers.setCheckboxState)(els.liftGatePickupCheckbox, asn.liftGatePickup);
	    (0, _selectorHelpers.setCheckboxState)(els.limitedAccessCheckbox, asn.limitedAccess);
	    (0, _selectorHelpers.setCheckboxState)(els.lumperPickupCheckbox, asn.lumperPickup);
	    (0, _selectorHelpers.setCheckboxState)(els.driverLoadCheckbox, asn.driverLoad);
	  }
	
	  function updateMessages() {
	    var asn = getAsn();
	    // one pickup date message at a time
	    var pickupMessage = getHolidayPickupDateMessage(asn) || getWeekendPickupDateMessage(asn);
	    (0, _selectorHelpers.insertTextAndClean)(els.pickupDateMessage, pickupMessage);
	    (0, _selectorHelpers.handleDisplayForV2)(els.pickupTimeRangeMessage, !isPickupTimeRangeValid(asn));
	    (0, _selectorHelpers.handleDisplayForV2)(els.insidePickupMessageOuter, asn.insidePickup);
	    (0, _selectorHelpers.handleDisplayForV2)(els.liftGatePickupMessageOuter, asn.liftGatePickup);
	    (0, _selectorHelpers.handleDisplayForV2)(els.limitedAccessMessageOuter, asn.limitedAccess);
	    (0, _selectorHelpers.handleDisplayForV2)(els.lumperPickupMessageOuter, asn.lumperPickup);
	    (0, _selectorHelpers.handleDisplayForV2)(els.driverLoadMessageOuter, asn.driverLoad);
	  }
	
	  function isPickupTimeRangeValid(asn) {
	    return _AsnStore2.default.isPickupTimeRangeValid(asn);
	  }
	
	  function getHolidayPickupDateMessage(asn) {
	    var isHoliday = !!_AsnStore2.default.getPickupDateHoliday(asn);
	    var message = "";
	    if (isHoliday) {
	      message = "Holiday" + PICKUP_DATE_MESSAGE_STUB;
	    }
	    return message;
	  }
	
	  function getWeekendPickupDateMessage(asn) {
	    var isWeekend = !!_AsnStore2.default.getPickupDateWeekend(asn);
	    var message = "";
	    if (isWeekend) {
	      message = "Weekend" + PICKUP_DATE_MESSAGE_STUB;
	    }
	    return message;
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	  }
	
	  self.unbindListeners = function () {
	    _AsnStore2.default.unbindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.unbindListener("asns:change", updateSelf);
	    (0, _selectorHelpers.allElements)(els).off();
	  };
	
	  function bindElements() {
	    els.pickupDateInput.on("input change", handleAsnFieldChange("pickupDate"));
	    els.insidePickupCheckbox.on("click", handleAsnFieldCheckboxChange("insidePickup"));
	    els.liftGatePickupCheckbox.on("click", handleAsnFieldCheckboxChange("liftGatePickup"));
	    els.limitedAccessCheckbox.on("click", handleAsnFieldCheckboxChange("limitedAccess"));
	    els.lumperPickupCheckbox.on("click", handleAsnFieldCheckboxChange("lumperPickup"));
	    els.driverLoadCheckbox.on("click", handleAsnFieldCheckboxChange("driverLoad"));
	
	    els.timePickerFrom.on("change", handleTimeChangeFor(timePickerFrom, "pickupTimeFrom"));
	    els.timePickerTo.on("change", handleTimeChangeFor(timePickerTo, "pickupTimeTo"));
	  }
	
	  function handleTimeChangeFor(tPicker, key) {
	    return function (e) {
	      var time = tPicker.getMilitaryTime();
	      onAsnFieldChange(key, time);
	    };
	  }
	
	  function handleAsnFieldChange(key) {
	    return function (e) {
	      onAsnFieldChange(key, (0, _jquery2.default)(this).val());
	    };
	  }
	
	  function handleAsnFieldsChange(key) {
	    return function (e) {
	      onAsnFieldsChange(key, (0, _jquery2.default)(this).val());
	    };
	  }
	
	  function handleAsnFieldCheckboxChange(key) {
	    return function (e) {
	      onAsnFieldChange(key, !!(0, _jquery2.default)(this).is(":checked"));
	    };
	  }
	
	  function handleReadOnly() {
	    if (readOnly) {
	      (0, _selectorHelpers.setDisabled)([els.pickupDateInput, els.insidePickupCheckbox, els.liftGatePickupCheckbox, els.limitedAccessCheckbox, els.lumperPickupCheckbox, els.driverLoadCheckbox]);
	    }
	  }
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    handleReadOnly();
	    bindElements();
	    bindStores();
	  }
	}

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = RequestQuoteView;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _viewHelpers = __webpack_require__(35);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _QuoteStore = __webpack_require__(98);
	
	var _QuoteStore2 = _interopRequireDefault(_QuoteStore);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AvailableQuotesListView = __webpack_require__(536);
	
	var _AvailableQuotesListView2 = _interopRequireDefault(_AvailableQuotesListView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var html = __webpack_require__(1248);
	
	
	var elementsMap = {
	  requestQuoteBtn: ".request-quote-btn",
	  requestQuoteNotice: ".request-quote-notice",
	  requestQuoteFailedNotice: ".request-quote-notice-failed",
	  requestQuoteOuter: ".request-quote-outer",
	  loaderOuter: ".loader-outer",
	  requestQuoteSpecialNotice: ".request-quote-special-notice",
	  requestQuoteRemovedNotice: ".request-quote-removed-notice",
	  requestQuoteNotClickedNotice: ".shipping-tab-request-quote-not-clicked-error-message",
	  requestQuoteNoSelectedQuote: ".shipping-tab-request-quote-no-selected-quote-error-message",
	  quotesEntryPoint: ".quotes-entry-point"
	};
	
	function RequestQuoteView(_unused, _ref) {
	  var getAsn = _ref.getAsn,
	      onAsnFieldsChange = _ref.onAsnFieldsChange,
	      csrEmailUrl = _ref.csrEmailUrl,
	      onRequestQuoteClicked = _ref.onRequestQuoteClicked,
	      isPallet = _ref.isPallet,
	      didAttemptToNavigateAwayFromCurrentForm = _ref.didAttemptToNavigateAwayFromCurrentForm;
	
	  var self = this;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var asnDetailRowViews = [];
	
	  self.init = function () {
	    render();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	
	  function setWidgets() {
	    renderAvailableQuotesListView();
	  }
	
	  self.getElement = function () {
	    return self._element;
	  };
	
	  function update() {
	    updateSelf();
	  }
	
	  function updateSelf() {
	    updateDisplay();
	    updateRequestQuoteBtn();
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	    _AsnDetailStore2.default.bindListener("asn_details:change", updateSelf);
	    _QuoteStore2.default.bindListener("quotes:changed", updateSelf);
	  }
	
	  self.unbindListeners = function () {
	    _AsnStore2.default.unbindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.unbindListener("asns:change", updateSelf);
	    _AsnDetailStore2.default.unbindListener("asn_details:change", updateSelf);
	    _QuoteStore2.default.unbindListener("quotes:changed", updateSelf);
	  };
	
	  function bindElements() {
	    els.requestQuoteBtn.on("click", onRequestQuoteClickCb);
	  }
	
	  function onRequestQuoteClickCb(e) {
	    e.preventDefault();
	    if (canRequestQuote()) {
	      onRequestQuoteClicked(e);
	    }
	  }
	
	  function updateRequestQuoteBtn() {
	    var canReqQuote = canRequestQuote();
	    (0, _selectorHelpers.toggleClassViaBool)(els.requestQuoteBtn, "disabled", !canReqQuote);
	  }
	
	  function canRequestQuote() {
	    var asn = getAsn();
	
	    // if we are currently fetching quotes,
	    // obviously we can't beginning fetching another
	    if (isFetchingQuotes(asn)) {
	      return false;
	    }
	
	    /* if(!isPallet(asn)){
	       return true;
	     }*/
	    if (!isPallet(asn)) {
	      var freightShipping = hasFreigthSelected(getAsn());
	      if ((0, _general.isPresent)(freightShipping)) {
	        if (freightShipping && !(0, _general.isPresent)(asn.pickupDate)) {
	          return false;
	        }
	      }
	    }
	
	    // null or not there
	    // const isNew = AsnStore.statusIsNew(asn);
	    // "in progress" is saved but not submitted
	    // const isInProgress = AsnStore.isInProgress(asn);
	    // status is not null and not inprogress;
	    return AbilityStore.ask("canEditGtlAsn") && isPickupTimeRangeValid(asn) && (0, _general.isPresent)(asn.pickupDate) && _AsnStore2.default.hasAllPickupTimeFields(asn) && areDimensionsAndWeightValid();
	  }
	
	  function areDimensionsAndWeightValid() {
	    var asn = getAsn();
	    if (!isPallet(asn)) {
	      var freightShipping = hasFreigthSelected(asn);
	      if ((0, _general.isPresent)(freightShipping)) {
	        if (freightShipping) {
	          return _AsnStore2.default.allAsnShippingPalletsHaveDimensionsAndWeight(asn);
	        }
	      }
	    } else {
	      return _AsnStore2.default.allAsnDetailsHaveDimensionsAndWeight(asn);
	    }
	  }
	
	  function isPickupTimeRangeValid(asn) {
	    return _AsnStore2.default.isPickupTimeRangeValid(asn);
	  }
	
	  function updateDisplay() {
	    var asn = getAsn();
	    var isReqQuotes = isFetchingQuotes(asn);
	    var quoteRequestSuccess = didQuoteRequestSucceed(asn);
	    var quoteRequestFail = didAsnRequestQuoteFail(asn);
	    var isPlt = isPallet(asn);
	    var availableQuotes = _AsnStore2.default.getAvailableAndSelectedQuotesForAsn(asn);
	    var specialQuote = isQuoteForAsnSpecial(asn);
	    var didReqQuotes = didRequestQuotes(asn);
	    var hasSelQuote = hasSelectedQuote(asn);
	    var attemptedTraversalPassedShippingTab = alreadyAttempted(asn, "attemptedTraversalPassedShippingTab");
	    var showQRemovedMessage = shouldShowQuotesRemovedBecauseInfoChangedMessage(asn);
	    var hasAsnShippingPalletsData = _AsnShippingPalletStore2.default.getAllAsnShippingPallets();
	    var hasAsnShippingPallets = false;
	    if (!_jquery2.default.isEmptyObject(hasAsnShippingPalletsData)) {
	      hasAsnShippingPallets = true;
	    }
	    (0, _selectorHelpers.handleDisplayForV2)(els.quotesEntryPoint, !isReqQuotes && !!availableQuotes.length);
	
	    (0, _selectorHelpers.handleDisplayForV2)(els.loaderOuter, isReqQuotes);
	    (0, _selectorHelpers.handleDisplayForV2)(els.requestQuoteNotice, !isPlt && quoteRequestSuccess && !hasAsnShippingPallets);
	    (0, _selectorHelpers.handleDisplayForV2)(els.requestQuoteFailedNotice, quoteRequestFail);
	    (0, _selectorHelpers.handleDisplayForV2)(els.requestQuoteSpecialNotice, (isPlt || hasAsnShippingPallets) && specialQuote);
	    (0, _selectorHelpers.handleDisplayForV2)(els.requestQuoteRemovedNotice, (isPlt || hasAsnShippingPallets) && showQRemovedMessage);
	
	    (0, _selectorHelpers.handleDisplayForV2)(els.requestQuoteNotClickedNotice, (isPlt || hasAsnShippingPallets) && !showQRemovedMessage && !isReqQuotes && !didReqQuotes && !hasSelQuote && attemptedTraversalPassedShippingTab && !quoteRequestFail && !specialQuote);
	    // make sure Request Quote Button WAS clicked before showing error regarding not making a selection
	    (0, _selectorHelpers.handleDisplayForV2)(els.requestQuoteNoSelectedQuote, (isPlt || hasAsnShippingPallets) && !showQRemovedMessage && !isReqQuotes && didReqQuotes && attemptedTraversalPassedShippingTab && !hasSelQuote && !quoteRequestFail && !specialQuote);
	  }
	
	  function renderAvailableQuotesListView() {
	    var availableQuotesListView = new _AvailableQuotesListView2.default(null, {
	      getAsn: getAsn,
	      onAsnFieldsChange: onAsnFieldsChange,
	      isPallet: isPallet
	    });
	    availableQuotesListView.init();
	    els.quotesEntryPoint.html(availableQuotesListView.getElement());
	  }
	
	  function isFetchingQuotes(asn) {
	    return asn.isFetchingQuotes;
	  }
	
	  function areQuotesInvalidated(asn) {
	    return _AsnStore2.default.areQuotesInvalid(asn);
	  }
	
	  function didQuoteRequestSucceed(asn) {
	    return _AsnStore2.default.requestQuoteSucceeded(asn);
	  }
	
	  function didAsnRequestQuoteFail(asn) {
	    return _AsnStore2.default.requestQuoteFailed(asn);
	  }
	
	  function isQuoteForAsnSpecial(asn) {
	    return _AsnStore2.default.hasSpecialQuote(asn);
	  }
	
	  function hasSelectedQuote(asn) {
	    return _AsnStore2.default.hasSelectedQuote(asn);
	  }
	
	  function didRequestQuotes(asn) {
	    return _AsnStore2.default.didRequestQuotes(asn);
	  }
	
	  function shouldShowQuotesRemovedBecauseInfoChangedMessage(asn) {
	    return _AsnStore2.default.shouldShowQuotesRemovedBecauseInfoChangedMessage(asn);
	  }
	
	  function alreadyAttempted(asn, key) {
	    return !!asn[key];
	  }
	
	  function render() {
	    self._element = (0, _jquery2.default)(html);
	    setElements();
	    setWidgets();
	    update();
	    bindElements();
	    bindStores();
	  }
	
	  function hasFreigthSelected(asn) {
	    return _AsnStore2.default.hasFreigthSelected(asn.id);
	  }
	}

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShippingTab;
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _AsnShippingPalletStore = __webpack_require__(53);
	
	var _AsnShippingPalletStore2 = _interopRequireDefault(_AsnShippingPalletStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AbilityStore = __webpack_require__(97);
	
	var _AbilityStore2 = _interopRequireDefault(_AbilityStore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _DetailPickupQuoteView = __webpack_require__(538);
	
	var _DetailPickupQuoteView2 = _interopRequireDefault(_DetailPickupQuoteView);
	
	var _AsnShippingPalletRowsView = __webpack_require__(534);
	
	var _AsnShippingPalletRowsView2 = _interopRequireDefault(_AsnShippingPalletRowsView);
	
	var _InboundCarrierView = __webpack_require__(539);
	
	var _InboundCarrierView2 = _interopRequireDefault(_InboundCarrierView);
	
	var _quotes = __webpack_require__(462);
	
	var _AsnSerializer = __webpack_require__(222);
	
	var _AsnSerializer2 = _interopRequireDefault(_AsnSerializer);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _general = __webpack_require__(5);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	__webpack_require__(1078);
	
	
	var elementsMap = {
	  shippingEntryPoint: '.shipping-tab-entry-point',
	  hasShippingPartnerEntryPoint: ".has-shipping-partner-entry-point",
	  noShippingPartnerEntryPoint: ".no-shipping-partner-entry-point",
	  shippingPartnerRadioYes: ".shipping-partner-radio-yes",
	  shippingPartnerRadioNo: ".shipping-partner-radio-no",
	  shippingQuestion: ".inbound-shipping-question",
	  shippingChoiceLabel1: ".inbound-shipping-choice-label-1",
	  shippingChoiceLabel2: ".inbound-shipping-choice-label-2",
	  fedExGroundMsg: ".fedex-grnd-msg",
	  dvlSwitchery: "#declared-value-switchery",
	  ifShippingCaseInternationally: ".if-shipping-case-internationally",
	  shppingPartnerInputVal: ".shipping-partner-val",
	  shippingFreightChk: ".freight-shipping",
	  asnShipmentPalletEntryPoint: "#pallet-for-case-container",
	  asnDetailsRowSection: ".asn-detail-rows-section",
	  asnDetailRows: ".shipping-asn-details-rows-outer",
	  dvlForAll: ".declared-val-for-all",
	  printShippingLabelFlag: ".print-shipping-label-flag"
	};
	
	function ShippingTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var shippingTab = wizardElement.find('.shipping-tab');
	  var csrEmailUrl = wizardElement.data("csr-email-url");
	  var requestQuoteUrl = wizardElement.data('request-quote-url');
	  var namespace = wizardElement.data('namespace');
	  var areYouReadyToShipSection = wizardElement.find(".shipping-tab-are-you-ready-to-ship-section");
	  var shippingInformationSection = wizardElement.find(".shipping-tab-shipping-information-section");
	  var shipLaterBtn = wizardElement.find(".shipping-tab-ship-later");
	  var shipNowBtn = wizardElement.find(".shipping-tab-ship-now");
	  var inboundShipmentToggler = wizardElement.find(".inbound-shipment-toggler");
	  var frieghtShippingToggler = wizardElement.find(".frieght-shipping-toggler");
	  var freightShippingPalletInfo = wizardElement.find("#freight-shipping-pallet-info");
	  var numberOfPallateInputForCase = wizardElement.find("#number-of-pallate-input-for-case");
	  var shippingFreightSection = wizardElement.find(".shipping-tab-freight-shipping");
	  var frieghtShippingOptionRadioYes = wizardElement.find(".frieght-shipping-option-radio-yes");
	  var frieghtShippingOptionRadioNo = wizardElement.find(".frieght-shipping-option-radio-no");
	  var numberOfPallets = wizardElement.find("#num-of-pallets");
	  var numberOfPalletsBtn = wizardElement.find("#num-of-pallets-btn");
	  var detailPickupQuoteView = wizardElement.find(".detail-pickup-quote-view-outer");
	  var freightShippingOption = wizardElement.find("#frieght-shipping-option");
	  var caseShippingOption = wizardElement.find("#case-shipping-option");
	  var asnDetailRowsViewEntryPoint = wizardElement.find(".asn-detail-rows-view-entry-point");
	
	  var tab = wizardElement.find(".location-tab");
	  var countriesPhoneCode = (0, _jquery2.default)(".shipping-tab-entry-point").data('country-phone-code-list');
	  var defaultCarrier = wizardElement.data('default-carrier');
	  var carrierBrokerOrgType = wizardElement.data('carrier-broker-org-type');
	  var carrierCreateUrl = wizardElement.data('create-carrier-org-url');
	
	  var SHIPPING_TEXT = {
	    shippingQuestionPallet: wizardElement.data("inbound-shipping-question-pallet"),
	    shippingQuestionParcel: wizardElement.data("inbound-shipping-question-parcel"),
	    shippingChoiceLabelYesPallet: wizardElement.data("inbound-shipping-choice-label-yes-pallet"),
	    shippingChoiceLabelNoPallet: wizardElement.data("inbound-shipping-choice-label-no-pallet"),
	    shippingChoiceLabelYesParcel: wizardElement.data("inbound-shipping-choice-label-yes-parcel"),
	    shippingChoiceLabelNoParcel: wizardElement.data("inbound-shipping-choice-label-no-parcel")
	  };
	
	  var inboundCarrierView = void 0;
	
	  var els = {};
	
	  var isOnTab = false;
	
	  self.init = function () {
	    render();
	  };
	
	  function render() {
	    setElements();
	    attachWidgets();
	    bindElements();
	    bindStores();
	    updateSelf();
	    generateBtnGroup();
	    assignDefualtPrintShippingLabelFlag();
	  }
	
	  function assignDefualtPrintShippingLabelFlag() {
	    if (getAsn().status == "New") {
	      _AsnStore2.default.updateObjectAndEmit(getAsnId(), _defineProperty({}, "printShippingLabelFlag", true));
	    } else {
	      (0, _instantiateSwitchery.instantiateSwitchery)(els.printShippingLabelFlag, {});
	      (0, _instantiateSwitchery.setSwitcheryWithoutChange)((0, _jquery2.default)(els.printShippingLabelFlag), getAsn().printShippingLabelFlag);
	    }
	  }
	
	  function generateBtnGroup() {
	
	    var costRetailBtnGroup = new _QuickBtnGroup2.default(inboundShipmentToggler, {
	      distributeWidth: true
	    });
	    costRetailBtnGroup.init();
	
	    var frieghtShippingGroup = new _QuickBtnGroup2.default(frieghtShippingToggler, {
	      distributeWidth: true
	    });
	    frieghtShippingGroup.init();
	
	    var carrierBrokerTogglerGroup = new _QuickBtnGroup2.default(wizardElement.find(".carrier-broker-toggler"), {
	      distributeWidth: true
	    });
	    carrierBrokerTogglerGroup.init();
	  }
	
	  function updateSelf() {
	    //AsnStore.updateObjectAndEmit(getAsnId(), {"applyDvl": true});
	    setValues();
	    setShippingValue();
	    handleDisable();
	    handleDisableNew();
	    setText();
	    toggleSubViews();
	  }
	
	  // We can delete this method later.
	  function handleDisable() {
	    var radios = (0, _selectorHelpers.combineElements)([els.shippingPartnerRadioYes, els.shippingPartnerRadioNo]);
	    radios.attr("disabled", !canEditGtlAsn());
	    if (_AsnStore2.default.getCarrierBroker() == undefined || _AsnStore2.default.getCarrierBroker() == "") {
	      _AsnStore2.default.selectCarrierBroker('carrier');
	    }
	
	    if (_AsnStore2.default.getCarrierBroker() == 'broker') {
	      (0, _selectorHelpers.show)(wizardElement.find(".show-broker-feilds"));
	      (0, _selectorHelpers.hide)(wizardElement.find(".show-carrier-feilds"));
	    } else {
	      (0, _selectorHelpers.show)(wizardElement.find(".show-carrier-feilds"));
	      (0, _selectorHelpers.hide)(wizardElement.find(".show-broker-feilds"));
	    }
	    //hide(wizardElement.find(".show-broker-feilds"));
	  }
	
	  function handleDisableNew() {
	    var shippingChoices = (0, _selectorHelpers.combineElements)([els.shippingPartnerRadioYes, els.shippingPartnerRadioNo]);
	    shippingChoices.attr("disabled", !canEditGtlAsn());
	  }
	
	  function setShippingValue() {
	
	    if (hasShippingPartnerSelected()) {
	      if (hasShippingPartner()) {
	        (0, _jquery2.default)(els.shppingPartnerInputVal).val("true");
	        (0, _jquery2.default)(els.shippingPartnerRadioNo).removeClass("active");
	        (0, _jquery2.default)(els.shippingPartnerRadioYes).addClass("active");
	      } else {
	        (0, _jquery2.default)(els.shippingPartnerRadioNo).addClass("active");
	        (0, _jquery2.default)(els.shippingPartnerRadioYes).removeClass("active");
	        (0, _jquery2.default)(els.shppingPartnerInputVal).val("false");
	      }
	    } else {
	      (0, _jquery2.default)(els.shippingPartnerRadioYes).removeClass("active");
	      (0, _jquery2.default)(els.shippingPartnerRadioNo).removeClass("active");
	    }
	  }
	
	  function setValues() {
	    els.shippingPartnerRadioYes.prop('checked', hasShippingPartner());
	    els.shippingPartnerRadioNo.prop('checked', hasShippingPartnerSelected() && !hasShippingPartner());
	    if (hasFreigthSelected(getAsnId())) {
	      els.shippingFreightChk.prop('checked', true);
	    } else {
	      els.shippingFreightChk.prop('checked', false);
	    }
	
	    if (getAsn().applyDvl) {
	      (0, _instantiateSwitchery.setSwitcheryWithoutChange)((0, _jquery2.default)(elementsMap.dvlForAll), true);
	      //$(elementsMap.dvlForAll).prop("checked", getAsn().applyDvl);
	    } else {
	      (0, _instantiateSwitchery.setSwitcheryWithoutChange)((0, _jquery2.default)(elementsMap.dvlForAll), false);
	      //$(elementsMap.dvlForAll).prop("checked", false);
	    }
	
	    handleShowHideFields(getAsnId());
	  }
	
	  function setText() {
	    if (isPallet()) {
	      (0, _selectorHelpers.insertTextAndClean)(els.shippingQuestion, SHIPPING_TEXT.shipingQuestionPallet);
	      (0, _selectorHelpers.insertTextAndClean)(els.shippingChoiceLabel1, SHIPPING_TEXT.shippingChoiceLabelYesPallet);
	      (0, _selectorHelpers.insertTextAndClean)(els.shippingChoiceLabel2, SHIPPING_TEXT.shippingChoiceLabelNoPallet);
	    } else {
	      (0, _selectorHelpers.insertTextAndClean)(els.shippingQuestion, SHIPPING_TEXT.shippingQuestionParcel);
	      (0, _selectorHelpers.insertTextAndClean)(els.shippingChoiceLabel1, SHIPPING_TEXT.shippingChoiceLabelYesParcel);
	      (0, _selectorHelpers.insertTextAndClean)(els.shippingChoiceLabel2, SHIPPING_TEXT.shippingChoiceLabelNoParcel);
	    }
	  }
	
	  function toggleSubViews() {
	    // if nothing selected, show no subview
	    hideAllSubviews();
	    if (hasShippingPartnerSelected()) {
	      (0, _selectorHelpers.show)(shippingInformationSection);
	      (0, _selectorHelpers.hide)(areYouReadyToShipSection);
	
	      if (hasShippingPartner()) {
	        if (isInternational()) {
	          (0, _selectorHelpers.show)(els.ifShippingCaseInternationally);
	        } else {
	
	          if (getAsnDetails().length > 0 && !isPallet()) {
	            (0, _selectorHelpers.show)(freightShippingPalletInfo);
	            if (hasFreigthSelected(getAsnId()) != undefined) {
	              if (hasFreigthSelected(getAsnId()) == true) {
	                (0, _selectorHelpers.show)(numberOfPallateInputForCase);
	                var shippingPalletsData = _AsnShippingPalletStore2.default.getAllAsnShippingPallets();
	                var shippingPallets = Object.keys(shippingPalletsData).length;
	                if (!_jquery2.default.isEmptyObject(shippingPalletsData)) {
	                  freightShippingOption.addClass("active");
	                  caseShippingOption.removeClass("active");
	                  numberOfPallets.val(shippingPallets);
	                  populateAsnShippingPalletsData(shippingPallets);
	                  (0, _selectorHelpers.show)(els.hasShippingPartnerEntryPoint);
	                } else {
	                  freightShippingOption.removeClass("active");
	                  caseShippingOption.addClass("active");
	                }
	              } else {
	                if (getAsn().shippingMethod === "parcel") {
	                  freightShippingOption.removeClass("active");
	                  caseShippingOption.addClass("active");
	                }
	                (0, _selectorHelpers.show)(els.hasShippingPartnerEntryPoint);
	                (0, _selectorHelpers.show)(els.dvlSwitchery);
	                (0, _selectorHelpers.show)(els.fedExGroundMsg);
	              }
	            } else {
	              (0, _selectorHelpers.show)(els.hasShippingPartnerEntryPoint);
	              (0, _selectorHelpers.show)(els.fedExGroundMsg);
	            }
	          } else if (isPallet()) {
	            (0, _selectorHelpers.show)(els.hasShippingPartnerEntryPoint);
	            (0, _selectorHelpers.show)(els.fedExGroundMsg);
	          }
	        }
	        /*  if(isPallet()){
	            hide(freightShippingPalletInfo);
	            show(els.hasShippingPartnerEntryPoint);
	            show(els.fedExGroundMsg);
	          }*/
	      } else {
	        if (!hasFreigthSelected(getAsnId())) {
	          defualtViews();
	        }
	        (0, _selectorHelpers.show)(els.noShippingPartnerEntryPoint);
	        if (!isPallet()) {
	          (0, _selectorHelpers.show)(shippingFreightSection);
	        }
	      }
	    }
	    if (!hasFreigthSelected(getAsnId())) {
	      if (getAsnDetails().length > 0 && !isPallet()) {
	        toggleCaseInformationSection();
	      }
	    }
	  }
	
	  function getDefaultCarriers() {
	    return defaultCarrier;
	  }
	
	  function getCarrierCreateUrl() {
	    return carrierCreateUrl;
	  }
	
	  function defualtViews() {
	    var bolNumberOuter = wizardElement.find(".bol-number-outer");
	    var trackingNumberOuter = wizardElement.find(".tracking-number-outer");
	    (0, _selectorHelpers.hide)(bolNumberOuter);
	    (0, _selectorHelpers.hide)(trackingNumberOuter);
	    if (isPallet()) {
	      (0, _selectorHelpers.show)(bolNumberOuter);
	    } else {
	      (0, _selectorHelpers.show)(trackingNumberOuter);
	    }
	  }
	
	  function isInternational() {
	
	    return getAsn().isInternaltional;
	  }
	
	  self.isInternational = isInternational;
	
	  function hideAllSubviews() {
	    (0, _selectorHelpers.hide)(els.hasShippingPartnerEntryPoint);
	    (0, _selectorHelpers.hide)(els.noShippingPartnerEntryPoint);
	    (0, _selectorHelpers.hide)(shippingFreightSection);
	    (0, _selectorHelpers.hide)(els.dvlSwitchery);
	    (0, _selectorHelpers.hide)(els.fedExGroundMsg);
	    (0, _selectorHelpers.hide)(els.ifShippingCaseInternationally);
	    (0, _selectorHelpers.hide)(freightShippingPalletInfo);
	    (0, _selectorHelpers.hide)(numberOfPallateInputForCase);
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, shippingTab);
	    if (carrierBrokerOrgType != undefined) {
	      _AsnStore2.default.selectCarrierBroker(carrierBrokerOrgType.toLowerCase());
	    }
	  }
	
	  function attachWidgets() {
	    var detailPickupQuoteView = new _DetailPickupQuoteView2.default(null, {
	      getAsn: getAsn,
	      getAsnDetailGroups: getOrganizedAsnDetails,
	      // onLengthChange: onDimChangeFunc("setLengthForIds"),
	      // onWidthChange: onDimChangeFunc("setWidthForIds"),
	      // onHeightChange: onDimChangeFunc("setHeightForIds"),
	      // onWeightChange: onDimChangeFunc("setWeightForIds"),
	      onAsnDetailGroupFieldChange: onAsnDetailGroupFieldChange,
	      hasShippingPartnerSelected: hasShippingPartnerSelected,
	      hasShippingPartner: hasShippingPartner,
	      onAsnFieldsChange: onAsnFieldsChange,
	      onAsnFieldChange: onAsnFieldChange,
	      csrEmailUrl: csrEmailUrl,
	      onRequestQuoteClicked: onRequestQuoteClicked,
	      isPallet: isPallet,
	      readOnly: !canEditGtlAsn(),
	      didAttemptToNavigateAwayFromCurrentForm: didAttemptToNavigateAwayFromCurrentForm
	    });
	    detailPickupQuoteView.init();
	    els.hasShippingPartnerEntryPoint.html(detailPickupQuoteView.getElement());
	
	    inboundCarrierView = new _InboundCarrierView2.default(null, {
	      getAsn: getAsn,
	      getAsnDetailGroups: getOrganizedAsnDetails,
	      isPallet: isPallet,
	      onShippingMethodChange: onShippingMethodChange,
	      onAsnFieldChange: onAsnFieldChange,
	      readOnly: !canEditGtlAsn(),
	      onAsnDetailGroupFieldChange: onAsnDetailGroupFieldChange,
	      onFieldCloneToAsnDetailsChange: onFieldCloneToAsnDetailsChange,
	      getAllCountriesPhoneCode: getAllCountriesPhoneCode,
	      onCountryPhoneCodeChange: onCountryPhoneCodeChange,
	      getDefaultCarriers: getDefaultCarriers,
	      setPhoneUsClass: setPhoneUsClass,
	      getCarrierCreateUrl: getCarrierCreateUrl
	    });
	    inboundCarrierView.init();
	    els.noShippingPartnerEntryPoint.html(inboundCarrierView.getElement());
	    (0, _jquery2.default)("#asn-carrier-country-phone-code").val(getAsn().asn_carrier_phone_code).trigger("change");
	  }
	
	  function getAllCountriesPhoneCode() {
	    return countriesPhoneCode;
	  }
	
	  function onFieldCloneToAsnDetailsChange(key, value) {
	    if (!(0, _general.isBlank)(key)) {
	      _AsnDetailStore2.default.copyObjectToAllCasesViaAsnId(getAsnId(), _defineProperty({}, key, value));
	    }
	  }
	
	  function onAsnShippingPalletFieldChange(key, val) {
	    // we must handle auto invalidation here,
	    // because the user will be on the actual shipping tab,
	    // at this point
	    _AsnStore2.default.updateObjectAndEmit(getAsnId(), _defineProperty({}, key, val));
	  }
	
	  function onAsnFieldsChange(obj) {
	    // we must handle auto invalidation here,
	    // because the user will be on the actual shipping tab,
	    // at this point
	    _AsnStore2.default.updateObjectAndEmit(getAsnId(), obj);
	  }
	
	  function onAsnShippingPalletFieldsChange(obj) {
	    // we must handle auto invalidation here,
	    // because the user will be on the actual shipping tab,
	    // at this point
	    _AsnShippingPalletStore2.default.updateObjectAndEmit(getAsnId(), obj);
	  }
	
	  function onAsnFieldChange(key, val) {
	    // we must handle auto invalidation here,
	    // because the user will be on the actual shipping tab,
	    // at this point
	    if (key === "pickupDate" || key === "insidePickup" || key === "pickupTimeFrom" || key === "pickupTimeTo" || key === "liftGatePickup" || key === "limitedAccess" || key === "asn_expected_arrival_date" || key === "asn_carrier_name" || key === "asn_carrier_contact_name" || key === "asn_carrier_contact_name" || key === "asn_carrier_phone" || key === "asn_bol_pro_number" || key === "freightShipping" || key === "asn_save_carrier") {
	      _AsnStore2.default.updateObjectAndEmit(getAsnId(), _defineProperty({}, key, val));
	    } else {
	      _AsnShippingPalletStore2.default.updateObjectAndEmit(getAsnId(), _defineProperty({}, key, val));
	    }
	  }
	
	  function onAsnDetailGroupFieldChange(rowIdx, key, val) {
	    var ids = (0, _underscore2.default)(getGroupAtIdx(rowIdx)).pluck("id");
	    _AsnDetailStore2.default.setAttrsForIds(ids, _defineProperty({}, key, val));
	  }
	
	  function onAsnShippingPalletsGroupFieldChange(rowIdx, key, val) {
	    var ids = (0, _underscore2.default)(getAsnShippingPalletsGroupAtIdx(rowIdx)).pluck("id");
	    _AsnShippingPalletStore2.default.setAttrsForIds(ids, _defineProperty({}, key, val));
	  }
	
	  function bindElements() {
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(els.dvlForAll);
	    (0, _instantiateSwitchery.instantiateSwitchery)(els.printShippingLabelFlag);
	
	    if (canEditGtlAsn()) {
	      els.shippingPartnerRadioYes.on("click", handleRadioFunc(true));
	      els.shippingPartnerRadioNo.on("click", handleRadioFunc(false));
	    }
	
	    els.shippingFreightChk.on("click", handleAsnFieldCheckboxChange("freightShipping"));
	
	    frieghtShippingOptionRadioYes.on("click", function (e) {
	      e.preventDefault();
	      caseShippingOption.removeClass("active");
	      _AsnStore2.default.updateObjectAndEmit(getAsnId(), { freightShipping: true });
	      _AsnStore2.default.emitEvent("freight_shipping_change");
	    });
	
	    frieghtShippingOptionRadioNo.on("click", function (e) {
	      e.preventDefault();
	      caseShippingOption.addClass("active");
	      _AsnStore2.default.updateObjectAndEmit(getAsnId(), { freightShipping: false });
	      _AsnStore2.default.emitEvent("freight_shipping_change");
	      toggleCaseInformationSection(e);
	    });
	
	    numberOfPalletsBtn.on('click', function () {
	      createPalletRows();
	    });
	
	    numberOfPallets.on('blur', function () {
	      createPalletRows();
	    });
	
	    els.dvlForAll.on("change", onChangeofDvlForAll);
	    els.printShippingLabelFlag.on("change", onChangeofPrintShippingLabelFlag);
	    //AsnStore.updateObjectAndEmit(getAsnId(), {["applyDvl"]: els.dvlForAll.is(":checked")});
	
	    wizardElement.find(".carrier-broker-toggler").on('click', toggleCarrierBroker);
	  }
	
	  function onChangeofDvlForAll() {
	    _AsnStore2.default.updateObjectAndEmit(getAsnId(), _defineProperty({}, "applyDvl", els.dvlForAll.is(":checked")));
	    _AsnStore2.default.emitEvent("dvl-inside-case");
	  }
	
	  function onChangeofPrintShippingLabelFlag() {
	    _AsnStore2.default.updateObjectAndEmit(getAsnId(), _defineProperty({}, "printShippingLabelFlag", els.printShippingLabelFlag.is(":checked")));
	  }
	
	  function toggleCarrierBroker(e) {
	
	    var btn = (0, _jquery2.default)(e.target);
	    var btnKey = btn.data('qb-key');
	    if (btnKey === 'broker') {
	      (0, _selectorHelpers.show)(wizardElement.find(".show-broker-feilds"));
	      (0, _selectorHelpers.hide)(wizardElement.find(".show-carrier-feilds"));
	      _AsnStore2.default.selectCarrierBroker('broker');
	    } else {
	      (0, _selectorHelpers.hide)(wizardElement.find(".show-broker-feilds"));
	      (0, _selectorHelpers.show)(wizardElement.find(".show-carrier-feilds"));
	      _AsnStore2.default.selectCarrierBroker('carrier');
	    }
	  }
	
	  function createPalletRows() {
	    _AsnShippingPalletStore2.default.removeAllAsnShippingPallets();
	    els.asnShipmentPalletEntryPoint.html('');
	    var totalNewPallets = numberOfPallets.val();
	    for (var i = 0; i < totalNewPallets; i++) {
	      var newAsnShippingPallet = { asnId: getAsn().id, rowIdx: i, asp_pallet_length: "", asp_pallet_width: "", asp_pallet_height: "", asp_pallet_weight: "", asp_pallet_stackable: false };
	      _AsnShippingPalletStore2.default.createNewAsnShippingPalletDetail(newAsnShippingPallet);
	    }
	    _AsnShippingPalletStore2.default.emitEvent('shipping_pallets_change');
	  }
	
	  function populateAsnShippingPalletsData(numberOfPallets) {
	    var asnShippingPalletRowsView = new _AsnShippingPalletRowsView2.default(null, {
	      getAsn: getAsn,
	      getAsnShipppingPallets: getAsnShipppingPallets,
	      onAsnShippingPalletFieldsChange: onAsnShippingPalletFieldsChange,
	      onAsnShippingPalletFieldChange: onAsnShippingPalletFieldChange,
	      onAsnShippingPalletsGroupFieldChange: onAsnShippingPalletsGroupFieldChange,
	      numberOfPallets: numberOfPallets
	    });
	    asnShippingPalletRowsView.init();
	    (0, _jquery2.default)(elementsMap.asnShipmentPalletEntryPoint).html((0, _jquery2.default)(asnShippingPalletRowsView.getElement()[0]).html());
	  }
	
	  function removeAllAsnShippingPallets(e) {
	    _AsnShippingPalletStore2.default.removeAllAsnShippingPallets();
	  }
	
	  function handleAsnFieldCheckboxChange(key) {
	    return function (e) {
	      onAsnFieldChange(key, (0, _jquery2.default)(this).is(":checked"));
	    };
	  }
	
	  function handleRadioFunc(type) {
	    return function () {
	      if (type) {
	        // force FedEx because "yes, please provide me an inbound shipping quote"
	        // implicitly means they are selecting FedEx
	        _AsnStore2.default.updateObjectAndEmit(getAsnId(), { inboundCarrier: "FedEx" });
	      }
	      _AsnStore2.default.selectShippingPartner(getAsn(), type);
	    };
	  }
	
	  /* function handleFreihtShipping(defaultVal)
	   {
	     return ()=>{
	        AsnStore.selectFreightShipping(getAsn(), defaultVal);
	     }
	   }*/
	
	  function handleShowHideFields(asnId) {
	    var bolNumberOuter = wizardElement.find(".bol-number-outer");
	    var trackingNumberOuter = wizardElement.find(".tracking-number-outer");
	    (0, _selectorHelpers.hide)(bolNumberOuter);
	    (0, _selectorHelpers.hide)(trackingNumberOuter);
	    if (hasFreigthSelected(asnId)) {
	      (0, _selectorHelpers.show)(bolNumberOuter);
	    } else {
	      (0, _selectorHelpers.show)(trackingNumberOuter);
	    }
	
	    if (_AsnStore2.default.getCarrierBroker() == 'carrier') {
	      (0, _selectorHelpers.show)(wizardElement.find(".show-carrier-feilds"));
	    } else {
	      (0, _selectorHelpers.show)(wizardElement.find(".show-broker-feilds"));
	    }
	  }
	
	  function hasFreigthSelected(asnId) {
	    return _AsnStore2.default.hasFreigthSelected(asnId);
	  }
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:shipping_method_changed", updateSelf);
	    _AsnStore2.default.bindListener("asns:shipping_partner_changed", updateSelf);
	    //    AsnStore.bindListener("asns:carrier_broker_method_changed", updateSelf);
	    //AsnStore.bindListener("asns:freight_shipping_changed", updateSelf);
	    _AsnStore2.default.bindListener("asns:change", updateSelf);
	    _AsnShippingPalletStore2.default.bindListener("asn_shipping_pallet:shipping_pallets_change", updateSelf);
	    // only listen on asns:change here, because although we need to
	    // invalidate quotes on asn_details change, we are specifically
	    // setting a flag on the given asn quotesAreValid when anything
	    // regarding that asn or it's asn_details change, followed by a
	    // reset of all those flags, including quotesAreValid
	    _AsnStore2.default.bindListener("asns:change", determineQuotesInvalidation);
	  }
	
	  function determineQuotesInvalidation() {
	    // if we currently are on the Shipping Tab, AND
	    // the quotes are set to be invalidated,
	    // automatically force-remove quotes and reset flags
	    if (self.isOnTab() && _AsnStore2.default.areQuotesInvalid(getAsn())) {
	      _AsnStore2.default.resetQuotesRelatedFlags(getAsn(), { showQuotesRemovedBecauseInfoChangedMessage: true });
	    }
	  }
	
	  function hasShippingPartnerSelected() {
	    return _AsnStore2.default.hasShippingPartnerSelected(getAsn());
	  }
	
	  self.hasShippingPartnerSelected = hasShippingPartnerSelected;
	
	  function hasShippingPartner() {
	    return _AsnStore2.default.hasShippingPartner(getAsn());
	  }
	
	  self.hasShippingPartner = hasShippingPartner;
	
	  self.isParcel = function () {
	    return _AsnStore2.default.isParcel(getAsn());
	  };
	
	  self.didRequestQuotes = function () {
	    return _AsnStore2.default.didRequestQuotes(getAsn());
	  };
	
	  self.isFetchingQuotes = function () {
	    return _AsnStore2.default.isFetchingQuotes(getAsn());
	  };
	
	  self.hasSelectedQuote = function () {
	    return _AsnStore2.default.hasSelectedQuote(getAsn());
	  };
	
	  self.hasSpecialQuote = function () {
	    return _AsnStore2.default.hasSpecialQuote(getAsn());
	  };
	
	  self.isGTL = function () {
	    return _AsnStore2.default.isGTL(getAsn());
	  };
	
	  self.isPickupTimeRangeValid = function () {
	    return _AsnStore2.default.isPickupTimeRangeValid(getAsn());
	  };
	
	  self.setIsOnTab = function (val) {
	    isOnTab = val;
	  };
	
	  self.isOnTab = function () {
	    return isOnTab;
	  };
	
	  self.isCarrierNameValid = function () {
	    return inboundCarrierView.isCarrierNameValid();
	  };
	
	  self.hasCasePackingPalletShipping = function () {
	    var hasAsnShippingPalletsData = _AsnShippingPalletStore2.default.getAllAsnShippingPallets();
	    var hasAsnShippingPallets = false;
	    if (!_jquery2.default.isEmptyObject(hasAsnShippingPalletsData)) {
	      hasAsnShippingPallets = true;
	    }
	    return hasAsnShippingPallets;
	  };
	
	  function hasCasePackingPalletShippingData() {
	    var hasAsnShippingPalletsData = _AsnShippingPalletStore2.default.getAllAsnShippingPallets();
	    var hasAsnShippingPallets = false;
	    if (!_jquery2.default.isEmptyObject(hasAsnShippingPalletsData)) {
	      hasAsnShippingPallets = true;
	    }
	    return hasAsnShippingPallets;
	  }
	
	  function canEditGtlAsn() {
	    return _AbilityStore2.default.ask("canEditGtlAsn");
	  }
	
	  function getAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	
	  function getOrganizedAsnShippingPallets() {
	    return _AsnShippingPalletStore2.default.organizeIntoPallets(getAsnShipppingPallets());
	  }
	
	  function getAsnShipppingPallets() {
	    return _AsnStore2.default.getAsnShipppingPallets(getAsn());
	  }
	
	  function getAsnId() {
	    return getAsn().id;
	  }
	
	  function getAsnDetails() {
	    return _AsnStore2.default.getAsnDetails(getAsn());
	  }
	
	  function getAsnShippingPallets() {
	    return _AsnStore2.default.getAsnShipppingPallets(getAsn());
	  }
	
	  function getOrganizedAsnDetails() {
	    if (isPallet()) {
	      return _AsnDetailStore2.default.organizeIntoPallets(getAsnDetails());
	    } else {
	      return _AsnDetailStore2.default.organizeIntoCases(getAsnDetails());
	    }
	  }
	
	  function getGroupAtIdx(idx) {
	    return getOrganizedAsnDetails()[idx];
	  }
	
	  function getAsnShippingPalletsGroupAtIdx(idx) {
	    return getOrganizedAsnShippingPallets()[idx];
	  }
	
	  function onShippingMethodChange(val) {
	    _AsnStore2.default.updateObjectAndEmit(getAsnId(), { inboundCarrier: val });
	  }
	
	  function onCountryPhoneCodeChange(val) {
	    _AsnStore2.default.updateObjectAndEmit(getAsnId(), { asn_carrier_phone_code: val });
	    setPhoneUsClass(inboundCarrierView.getCarrierPhoneCode(), val);
	  }
	
	  function setPhoneUsClass(element, val) {
	    (0, _selectorHelpers.setPhoneUs)([element], val);
	  }
	
	  function onDimChangeFunc(asnDetailAttrSetFuncName) {
	    return function (rowIdx, val) {
	      var ids = (0, _underscore2.default)(getGroupAtIdx(rowIdx)).pluck("id");
	      _AsnDetailStore2.default[asnDetailAttrSetFuncName](ids, val);
	    };
	  }
	
	  function onRequestQuoteClicked() {
	    handleFetchingShippingQuoteForCurrentAsn();
	    shippingTab.trigger("wizard:reconcileHeight");
	  }
	
	  function handleFetchingShippingQuoteForCurrentAsn() {
	    var data = {};
	    var asn = getAsn();
	    data[namespace + "asn"] = getSerializedAsn(asn);
	    data[namespace + "cadId"] = (0, _jquery2.default)("#" + namespace + "cadId").val();
	    data[namespace + "facilities"] = (0, _jquery2.default)("#" + namespace + "facilities").val();
	
	    var url = void 0;
	    if (isPallet()) {
	      // Quote url for sagar
	      url = requestQuoteUrl;
	    } else if (!isPallet()) {
	      if (hasFreigthSelected(getAsnId()) != undefined) {
	        if (hasFreigthSelected(getAsnId()) == true) {
	          (0, _selectorHelpers.show)(numberOfPallateInputForCase);
	          var shippingPallets = getAsnShipppingPallets();
	          if (shippingPallets && shippingPallets.length > 0) {
	            url = requestQuoteUrl;
	          }
	        }
	      }
	    } else {
	      url = csrEmailUrl;
	    }
	
	    (0, _quotes.fetchShippingQuotesForAsnData)(asn.id, data, url);
	  }
	
	  function getSerializedAsn(asn) {
	    var asnSerializer = new _AsnSerializer2.default(asn);
	    return asnSerializer.toJsonNestedIntoPalletsAndCases();
	  }
	
	  function didAttemptToNavigateAwayFromCurrentForm() {
	    return wizard.didAttemptToNavigateAwayFromCurrentForm();
	  }
	
	  function isPallet() {
	    return _AsnStore2.default.isPallet(getAsn());
	  }
	
	  (0, _jquery2.default)(shipNowBtn).on("click", function (e) {
	    e.preventDefault();
	    (0, _selectorHelpers.show)(shippingInformationSection);
	    (0, _selectorHelpers.hide)(areYouReadyToShipSection);
	  });
	
	  function toggleCaseInformationSection(event) {
	    if (caseShippingOption.hasClass("active")) {
	      (0, _selectorHelpers.show)(els.hasShippingPartnerEntryPoint);
	    } else {
	      //show(els.hasShippingPartnerEntryPoint);
	      //hide($(elementsMap.asnDetailsRowSection));
	      (0, _selectorHelpers.hide)(els.fedExGroundMsg);
	    }
	  }
	}

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _select2able = __webpack_require__(22);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _PackingTab = __webpack_require__(514);
	
	var _PackingTab2 = _interopRequireDefault(_PackingTab);
	
	var _ServicesTab = __webpack_require__(196);
	
	var _ServicesTab2 = _interopRequireDefault(_ServicesTab);
	
	var _ShippingTab = __webpack_require__(542);
	
	var _ShippingTab2 = _interopRequireDefault(_ShippingTab);
	
	var _ReviewTab = __webpack_require__(521);
	
	var _ReviewTab2 = _interopRequireDefault(_ReviewTab);
	
	var _LocationTab = __webpack_require__(512);
	
	var _LocationTab2 = _interopRequireDefault(_LocationTab);
	
	var _LocationInfoForCurrentAsn = __webpack_require__(544);
	
	var _LocationInfoForCurrentAsn2 = _interopRequireDefault(_LocationInfoForCurrentAsn);
	
	var _ProductItemStore = __webpack_require__(65);
	
	var _ProductItemStore2 = _interopRequireDefault(_ProductItemStore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _SaveAsn = __webpack_require__(524);
	
	var _SaveAsn2 = _interopRequireDefault(_SaveAsn);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _asnQuoteSnapshotWatcherFactory = __webpack_require__(548);
	
	var _asnQuoteSnapshotWatcherFactory2 = _interopRequireDefault(_asnQuoteSnapshotWatcherFactory);
	
	var _shippingQuotesInvalidatorFactory = __webpack_require__(550);
	
	var _shippingQuotesInvalidatorFactory2 = _interopRequireDefault(_shippingQuotesInvalidatorFactory);
	
	var _quotesInvalidationFactory = __webpack_require__(551);
	
	var _quotesInvalidationFactory2 = _interopRequireDefault(_quotesInvalidationFactory);
	
	var _asnInitialSnapshotFactory = __webpack_require__(547);
	
	var _asnInitialSnapshotFactory2 = _interopRequireDefault(_asnInitialSnapshotFactory);
	
	var _general = __webpack_require__(5);
	
	var _jumpToWizardLogic = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	// NOTE: referencing styles directly from stub folder so there's a single source of truth
	__webpack_require__(1105);
	//import ContentsTab from './ContentsTab/ContentsTab';
	
	
	// Live form from jsp
	(0, _run2.default)("#create-asn-form", function () {
	  var el = $("#create-asn-form");
	  attachWizard(el);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  _EditChecker2.default.bindNavigation();
	  _EditChecker2.default.bindChangeListener("#create-asn-form");
	  _EditChecker2.default.bindChangeListener("span.select2");
	  _EditChecker2.default.bindCancelButton("#asn-cancel-btn");
	
	  $(".product-sku-input-outer input").on("change", function (e) {
	    _EditChecker2.default.setPageDirty();
	  });
	}
	
	function attachWizard(el) {
	  var destTab = el.find('.destination-tab');
	
	  var addressValidationModalEl = $("#add-validation-model");
	  var asnId = el.data("asn-id");
	  var addressValidation = (0, _AddressValidation2.default)(addressValidationModalEl, el, {
	    isAlreadyValid: !!asnId
	  });
	  var quotesInvalidation = (0, _quotesInvalidationFactory2.default)();
	
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	    // onkeyup: false,
	    // onfocusout: false
	  });
	
	  $.validator.addMethod('skuMustMatchProduct', function (val, element, param) {
	    return _ProductItemStore2.default.doesSkuExist(val);
	  }, "The sku must match an actual product's sku.");
	
	  $.validator.addClassRules("sku-must-match-product", { skuMustMatchProduct: true });
	
	  validator.settings.ignore = ":disabled,:hidden,.tt-hint";
	
	  var quickWizard = new _QuickWizard2.default(el, {
	    tabletWidthNavStep: 937,
	    mobileWidthNavStep: 550,
	    customRules: {
	      ".packing-tab-asn-details-main-error-message": {
	        errorMessageSelector: ".packing-tab-asn-details-main-error-message",
	        isValid: function isValid() {
	          return packingTab.isValid();
	        }
	      },
	      ".shipping-tab-radio-btn-main-error-message": {
	        errorMessageSelector: ".shipping-tab-radio-btn-main-error-message",
	        isValid: function isValid() {
	          return shippingTab.hasShippingPartnerSelected();
	        }
	      },
	      ".shipping-tab-request-quote-not-clicked-error-message": {
	        // leave errorMessageSelector Off and let given sub view handle hiding/showing it,
	        // while allowing the wizard to still probe the given tab for any errors on next btn click.
	        isValid: function isValid() {
	          // if we do not have a shipping partner ("No, I will handle Inbound shipping"),
	          // then we don't care about this error.
	          // if it is parcel, then we also don't care about this error.
	          return !shippingTab.hasShippingPartner() || shippingTab.isParcel() && !shippingTab.hasCasePackingPalletShipping() || !shippingTab.isFetchingQuotes() && (shippingTab.didRequestQuotes() || shippingTab.hasSpecialQuote() || shippingTab.hasSelectedQuote());
	        }
	      },
	      ".shipping-tab-request-quote-no-selected-quote-error-message": {
	        // leave errorMessageSelector Off and let given sub view handle hiding/showing it,
	        // while allowing the wizard to still probe the given tab for any errors on next btn click.
	        isValid: function isValid() {
	          // if we do not have a shipping partner ("No, I will handle Inbound shipping"),
	          // then we don't care about this error.
	          // if it is parcel, then we also don't care about this error.
	          return !shippingTab.hasShippingPartner() || shippingTab.isParcel() && !shippingTab.hasCasePackingPalletShipping() || !shippingTab.isFetchingQuotes() && (shippingTab.hasSpecialQuote() || shippingTab.hasSelectedQuote());
	        }
	      },
	      ".shipping-tab-pickup-time-range-error-message": {
	        isValid: function isValid() {
	          return !shippingTab.isGTL() || shippingTab.isPickupTimeRangeValid();
	        }
	      }
	    },
	
	    shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	      var targetForm = _ref.targetForm,
	          direction = _ref.direction,
	          currentForm = _ref.currentForm,
	          done = _ref.done;
	
	      // return true;
	      // Any time we go traverse backwards, just let us
	      if (direction === "BACKWARDS") {
	        return true;
	      }
	
	      if (!targetForm.hasClass('shipping-tab') && !targetForm.nextAll('.shipping-tab').length) {
	        _AsnStore2.default.updateObjectAndEmit(getCurrentAsnId(), { attemptedTraversalPassedShippingTab: true });
	        if (shippingTab.hasShippingPartnerSelected()) {
	          if (shippingTab.hasShippingPartner() && shippingTab.isInternational()) {
	            return false;
	          }
	
	          if (!shippingTab.isCarrierNameValid()) {
	            runValidation();
	            return false;
	          }
	        } else {
	          return false;
	        }
	      }
	
	      if (currentForm.filter(".location-tab").length) {
	        var completeQuotesModalFunc = _underscore2.default.partial(handleDetermineInvalidateQuotesModal, _underscore2.default, done);
	        var completeAddressModalFunc = _underscore2.default.partial(handleDetermineAddressModal, _underscore2.default, completeQuotesModalFunc);
	        var completeValidatingFormFunc = _underscore2.default.partial(areInputsValid, completeAddressModalFunc);
	        completeValidatingFormFunc();
	      } else if (currentForm.filter(".packing-tab").length) {
	        var _completeQuotesModalFunc = _underscore2.default.partial(handleDetermineInvalidateQuotesModal, _underscore2.default, done);
	        var _completeValidatingFormFunc = _underscore2.default.partial(areInputsValid, _completeQuotesModalFunc);
	        _completeValidatingFormFunc();
	      } else {
	        areInputsValid(done);
	      }
	
	      function isCarrierNameValid() {
	        return shippingTab.isCarrierNameValid();
	      }
	
	      function runValidation() {
	        var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	        var notValid = !quickWizard.areInputsValid(allPrevInputs, { displayErrors: true });
	        if (notValid) {
	          quickWizard.goToFirstIncompleteForm();
	        }
	      }
	
	      function areInputsValid(cb) {
	        var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	        var notValid = !quickWizard.areInputsValid(allPrevInputs, { displayErrors: true });
	        if (notValid) {
	          quickWizard.goToFirstIncompleteForm();
	
	          cb(false);
	        } else {
	          cb(true);
	        }
	      }
	
	      function handleDetermineAddressModal(canContinueToNextForm, cb) {
	        // if canContinueToNextForm is true at this point,
	        // the flow to continue to the next form is
	        // has not stopped, so we should determine
	        // whether or not to show the address validation modal
	        if (canContinueToNextForm) {
	          addressValidation.determineAddressValidity(cb);
	        } else {
	          cb(canContinueToNextForm);
	        }
	      }
	
	      function handleDetermineInvalidateQuotesModal(canContinueToNextForm, cb) {
	        console.log("determining whether or not to show quotes invalidated modal...");
	        // if canContinueToNextForm is true at this point,
	        // the flow to continue to the next form is
	        // has not stopped, so we should determine
	        // whether or not to show the quote invalidation modal
	        if (canContinueToNextForm) {
	          quotesInvalidation.determineQuoteInvalidPrompt(cb);
	        } else {
	          cb(canContinueToNextForm);
	        }
	      }
	
	      return done;
	    },
	
	    didNavigateToForm: function didNavigateToForm(_ref2) {
	      var currentForm = _ref2.currentForm;
	
	      if (currentForm.filter(".review-tab").length) {
	        reviewTab.didNavigateToForm();
	      }
	
	      shippingTab.setIsOnTab(!!currentForm.filter(".shipping-tab").length);
	    }
	  });
	
	  quickWizard.init();
	
	  // The Class below is migration from
	  // the incorrectly architected LocationTab Class,
	  // in favor of the better Evented Architecture
	  var locationInfoForCurrentAsn = new _LocationInfoForCurrentAsn2.default(quickWizard);
	  locationInfoForCurrentAsn.init();
	
	  var locationTab = new _LocationTab2.default(quickWizard);
	  locationTab.init();
	
	  var packingTab = new _PackingTab2.default(quickWizard);
	  packingTab.init();
	
	  //const contentsTab = new ContentsTab(quickWizard);
	  //contentsTab.init();
	
	  var savAsn = new _SaveAsn2.default(quickWizard, {
	    canSave: function canSave() {
	      var currentForm = quickWizard.getActiveTargetForm();
	      var isValid = true;
	
	      if (currentForm.filter(".location-tab").length) {
	        isValid = areInputsValidForForm(currentForm);
	      }
	
	      return isValid;
	    }
	  });
	  savAsn.init();
	
	  var servicesTab = new _ServicesTab2.default(quickWizard);
	  servicesTab.init();
	
	  var shippingTab = new _ShippingTab2.default(quickWizard);
	  shippingTab.init();
	
	  var reviewTab = new _ReviewTab2.default(quickWizard);
	  reviewTab.init();
	
	  var asnQuoteSnapshotWatcher = (0, _asnQuoteSnapshotWatcherFactory2.default)();
	  var shippingQuotesInvalidator = (0, _shippingQuotesInvalidatorFactory2.default)();
	
	  var asnInitialSnapshotter = (0, _asnInitialSnapshotFactory2.default)();
	
	  asnInitialSnapshotter.createSnapshots();
	  asnQuoteSnapshotWatcher.generateInitialSnapshotsOnLoad();
	
	  (0, _select2able.validateOnAllSelectChanges)();
	
	  // helper functions
	  function getCurrentAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	
	  function getCurrentAsnId() {
	    return getCurrentAsn().id;
	  }
	
	  function areInputsValidForForm(form) {
	    var inputs = quickWizard.findValidatableElementsForScope(form);
	    var valid = quickWizard.areInputsValid(inputs, { displayErrors: true });
	    // For now, this function is only applicable to saving an
	    // Asn while on location tab to facility if all inputs
	    // for that given tab are valid, so we don't need
	    // to traverse anywhere.
	    // if(notValid){
	    //   quickWizard.goToFirstIncompleteForm();
	    // }
	    return valid;
	  }
	
	  (0, _jumpToWizardLogic.handleQueryParamTraversalToWizardTab)(quickWizard);
	}

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = LocationInfoForCurrentAsn;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AddressEventBus = __webpack_require__(111);
	
	var _AddressEventBus2 = _interopRequireDefault(_AddressEventBus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	// NOTE: as much as I don't think this logic
	// should not be needed and should not be here,
	// I have no choice due to the fact that the
	// LocationTab did not follow the
	// Evented Architecture.
	function LocationInfoForCurrentAsn(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var namespace = wizardElement.data('namespace');
	  var els = {};
	  self._element = $();
	
	  var nameMap = void 0,
	      elementsMap = void 0;
	
	  self.init = function () {
	    self._element = wizardElement.find(".location-tab");
	    setElements();
	    bindElements();
	  };
	
	  function bindElements() {
	    (0, _underscore2.default)(els).mapObject(function (el, k) {
	      el.on("change", onInputFunc(k));
	    });
	    _AddressEventBus2.default.addChangeListener(onAddressDataChange);
	  }
	
	  function onAddressDataChange() {
	    var inputsData = collectAllDataFromInputs();
	    // console.log("bulk change of inputs from address bus...");
	    // console.log(inputsData);
	    // debugger;
	    _AsnStore2.default.updateAllObjectsAndEmit(inputsData);
	  }
	
	  function collectAllDataFromInputs() {
	    var inputsData = {};
	    (0, _underscore2.default)(nameMap).mapObject(function (portletInputRelatedName, k) {
	      var input = els[k];
	      var val = input.val();
	      // store both generic key name, and portlet
	      // specific name within the Store,
	      // so we can make sure we are not breaking
	      // old code
	
	      inputsData[k] = val;
	      inputsData[portletInputRelatedName] = val;
	    });
	
	    return inputsData;
	  }
	
	  function onInputFunc(nmKey) {
	    return function (e) {
	      var _AsnStore$updateAllOb;
	
	      var val = $(this).val();
	      var key = nameMap[nmKey];
	      _AsnStore2.default.updateAllObjectsAndEmit((_AsnStore$updateAllOb = {}, _defineProperty(_AsnStore$updateAllOb, key, val), _defineProperty(_AsnStore$updateAllOb, nmKey, val), _AsnStore$updateAllOb));
	    };
	  }
	
	  function setElements() {
	    nameMap = {
	      asnId: namespace + "asnId",
	      facilities: namespace + "facilities",
	      cadId: namespace + "cadId",
	      cadLocationName: namespace + "cadLocationName",
	      cadContactPhone: namespace + "cadContactPhone",
	      cadContactName: namespace + "cadContactName",
	      cadAddress1: namespace + "cadAddress1",
	      cadAddress2: namespace + "cadAddress2",
	      cadCountry: namespace + "cadCountry",
	      cadCity: namespace + "cadCity",
	      state: namespace + "states",
	      cadZipcode: namespace + "cadZipcode",
	      cadStateText: namespace + "cadStateText"
	    };
	
	    elementsMap = (0, _underscore2.default)(nameMap).mapObject(function (name, k) {
	      return "#" + name;
	    });
	
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, self._element);
	  }
	}

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = MandatoryServiceProcessor;
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _ProductItemStore = __webpack_require__(65);
	
	var _ProductItemStore2 = _interopRequireDefault(_ProductItemStore);
	
	var _general = __webpack_require__(5);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productItemKeyToManditoryDomainStrMapping = {
	  prdBarcodeRequired: {
	    checkIfNeedsManditoryService: function checkIfNeedsManditoryService(productItem) {
	      return _ProductItemStore2.default.needsBarcode(productItem);
	    },
	    mandatoryStr: "barcode_item_level_mandatory_services"
	  }
	  // prdFragile: {
	  //   mandatoryStr: "fragile_item_level_mandatory_services"
	  // }
	};
	
	function MandatoryServiceProcessor(asnDetailIds) {
	  var self = this;
	  var domainsByMandatoryStr = _CmrDomainStore2.default.groupByCdmDomain();
	
	  self.forceAddMandatoryServices = function () {
	    (0, _underscore2.default)(asnDetailIds).map(handleAsnDetailMandatoriesFunc("_mandatoryMappingFunc"));
	  };
	
	  self.forceRemoveUnneededMandatoryServices = function () {
	    (0, _underscore2.default)(asnDetailIds).map(handleAsnDetailMandatoriesFunc("_removalMandatoryMappingFunc"));
	  };
	
	  function handleAsnDetailMandatoriesFunc(funcName) {
	    return function (asnDetailId) {
	      handleAsnDetailMandatories(asnDetailId, funcName);
	    };
	  }
	
	  function handleAsnDetailMandatories(asnDetailId, mappingFunc) {
	    var asnDetail = _AsnDetailStore2.default.getData()[asnDetailId];
	    var productItem = _ProductItemStore2.default.getDataViaAsnDetail(asnDetail)[0];
	    if (productItem) {
	      (0, _underscore2.default)(productItemKeyToManditoryDomainStrMapping).mapObject(self[mappingFunc](asnDetail, productItem));
	    }
	  }
	
	  self._removalMandatoryMappingFunc = function (asnDetail, productItem) {
	    return function (_ref, productItemKey) {
	      var mandatoryStr = _ref.mandatoryStr,
	          checkIfNeedsManditoryService = _ref.checkIfNeedsManditoryService;
	
	      var requiresService = doesRequireService({ checkIfNeedsManditoryService: checkIfNeedsManditoryService, productItem: productItem, productItemKey: productItemKey });
	
	      // if the product does not require a mandatory service,
	      // make sure it doesn't have that mandatory service by removing it
	      // if it exists
	      if (!requiresService) {
	        var domain = domainsByMandatoryStr[mandatoryStr];
	        domain = domain && domain[0];
	        if (domain) {
	          // find service linking this domain to the asnDetail
	          var service = _CmrServiceStore2.default.findWhere({ csv_entity_id: asnDetail.id, csv_entity_type: "asn_detail", cdm_id: domain.id });
	          if (service) {
	            removeService(service);
	          }
	        }
	      }
	    };
	  };
	
	  function removeService(service) {
	    _CmrServiceStore2.default.removeServicesByIds([service.id]);
	  }
	
	  self._mandatoryMappingFunc = function (asnDetail, productItem) {
	    return function (_ref2, productItemKey) {
	      var mandatoryStr = _ref2.mandatoryStr,
	          checkIfNeedsManditoryService = _ref2.checkIfNeedsManditoryService;
	
	      var requiresService = doesRequireService({ checkIfNeedsManditoryService: checkIfNeedsManditoryService, productItem: productItem, productItemKey: productItemKey });
	      // check if a service exists connecting asnDetail to the given manditory domain
	      if (requiresService) {
	        var domain = domainsByMandatoryStr[mandatoryStr];
	        // it's was an object organized by str point to array, and we only care about the first of each
	        domain = domain && domain[0];
	        if (domain) {
	          var service = _CmrServiceStore2.default.findWhere({ csv_entity_id: asnDetail.id, csv_entity_type: "asn_detail", cdm_id: domain.id });
	          if (!service) {
	            createMandatoryServiceFor(asnDetail, domain);
	          }
	        }
	      }
	    };
	  };
	
	  function createMandatoryServiceFor(asnDetail, domain) {
	    _CmrServiceStore2.default.createOrUpdateServicesForAsnDetailIds([asnDetail.id], {
	      cdm_id: domain.id
	    });
	  }
	}
	
	function doesRequireService(_ref3) {
	  var checkIfNeedsManditoryService = _ref3.checkIfNeedsManditoryService,
	      productItem = _ref3.productItem,
	      productItemKey = _ref3.productItemKey;
	
	  var requiresService = void 0;
	  // if the config object at top of file has a productItemStoreFuncName,
	  // use this as the discerning factor of whether or not the given 
	  // product item needs a service
	  if (checkIfNeedsManditoryService) {
	    requiresService = checkIfNeedsManditoryService(productItem);
	  } else {
	    // otherwise, just use the productItemKey itself to determine
	    // if the given product needs a service
	    requiresService = (0, _general.isTruthy)(productItem[productItemKey]);
	  }
	
	  return requiresService;
	}

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = asnInitialSnapshotChangedFactory;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _stores = __webpack_require__(99);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	var _constants = __webpack_require__(110);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INITIAL_ASN_RELATED_SNAPSHOT = _constants2.default.INITIAL_ASN_RELATED_SNAPSHOT;
	
	
	var singleton = void 0;
	
	var storeConfig = {
	  AsnStore: {
	    only: [
	    // Location Tab Info 
	    "facilities", "cadId", "cadAddress1", "cadAddress2", "cadCountry", "cadCity", "state", "cadZipcode", "cadStateText",
	    // Shipping Tab Info
	    "shippingPartner",
	    // don't need inbound carrier
	    // "inboundCarrier",
	    "insidePickup", "liftGatePickup", "limitedAccess", "lumperPickup", "driverLoad", "pickupDate", "pickupTimeFrom", "pickupTimeTo", "shippingMethod", "freightShipping", "caseShipping"]
	  },
	  AsnDetailStore: {
	    // just compare everything in this store,
	    // technically it doesn't matter
	  }
	};
	
	function asnInitialSnapshotChangedFactory(options) {
	  if (singleton) {
	    // singleton.setOptions(options);
	    return singleton;
	  } else {
	    singleton = new AsnInitialSnapshotChanged(options);
	    singleton.init();
	    return singleton;
	  }
	}
	
	function AsnInitialSnapshotChanged() {
	  var self = this;
	
	  this.init = function () {};
	
	  self.didStoresDataChange = didStoresDataChange;
	
	  function didStoresDataChange() {
	    return didAsnStoreChange() || didAsnDetailStoreChange();
	  }
	
	  function didAsnStoreChange() {
	    var only = storeConfig.AsnStore.only;
	
	    var asn = getCurrentAsn();
	    var asnId = asn.id;
	
	    // check if quote are not already invalidated, AND (that we actually have quotes OR specialQuote flag is true), AND we have a snapshot, and that there are changes since the last snapshot
	    return AsnStore.getDataSnapshotViaTag(INITIAL_ASN_RELATED_SNAPSHOT) && AsnStore.hasDataChangesSinceSnapshotViaTag(INITIAL_ASN_RELATED_SNAPSHOT, { id: asnId, only: only });
	  }
	
	  function didAsnDetailStoreChange() {
	    return AsnDetailStore.getDataSnapshotViaTag(INITIAL_ASN_RELATED_SNAPSHOT) && AsnDetailStore.hasDataChangesSinceSnapshotViaTag(INITIAL_ASN_RELATED_SNAPSHOT);
	  }
	
	  function getCurrentAsnId() {
	    return getCurrentAsn().id;
	  }
	
	  function getCurrentAsn() {
	    return AsnStore.getAsnWithShippingMethod();
	  }
	}

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = asnInitialSnapshotFactory;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _stores = __webpack_require__(99);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	var _constants = __webpack_require__(110);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var INITIAL_ASN_RELATED_SNAPSHOT = _constants2.default.INITIAL_ASN_RELATED_SNAPSHOT;
	
	
	var singleton = void 0;
	
	function asnInitialSnapshotFactory(options) {
	  if (singleton) {
	    singleton.setOptions(options);
	    return singleton;
	  } else {
	    singleton = new AsnInitialSnapshot(options);
	    singleton.init();
	    return singleton;
	  }
	}
	
	function AsnInitialSnapshot(options) {
	  var self = this;
	  var opts = {};
	  setOptions(options);
	
	  var storesSnapshotConfig = [{
	    storeName: "AsnStore"
	  }, {
	    storeName: "AsnDetailStore"
	  }];
	
	  self.setOptions = setOptions;
	
	  function setOptions() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _underscore2.default.extend(opts, options);
	  }
	
	  self.init = function () {};
	
	  self.createSnapshots = createSnapshots;
	
	  function createSnapshots() {
	    (0, _underscore2.default)(storesSnapshotConfig).map(createSnapshotForStoreName);
	    // logAllSnapshots();
	  }
	
	  function createSnapshotForStoreName(_ref) {
	    var storeName = _ref.storeName;
	
	    _stores2.default[storeName].createDataSnapshot(INITIAL_ASN_RELATED_SNAPSHOT);
	  }
	
	  // function logAllSnapshots(){
	  //   _(storesSnapshotConfig).map(({storeName})=>{
	  //     console.log(`${storeName} snapshots:`);
	  //     console.log(stores[storeName].getDataSnapshots());
	  //   });
	  // }
	}

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = asnQuoteSnapshotWatcherFactory;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _stores = __webpack_require__(99);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	var _constants = __webpack_require__(110);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QUOTES_RELATED_SNAPSHOT = _constants2.default.QUOTES_RELATED_SNAPSHOT;
	
	
	var singleton = void 0;
	
	function asnQuoteSnapshotWatcherFactory(options) {
	  if (singleton) {
	    singleton.setOptions(options);
	    return singleton;
	  } else {
	    singleton = new AsnQuoteSnapshotWatcher(options);
	    singleton.init();
	    return singleton;
	  }
	}
	
	function AsnQuoteSnapshotWatcher(options) {
	  var self = this;
	  var opts = {};
	  setOptions(options);
	
	  var storesSnapshotConfig = [{
	    storeName: "AsnStore"
	  }, {
	    storeName: "AsnDetailStore"
	  }];
	
	  self.setOptions = setOptions;
	
	  function setOptions() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _underscore2.default.extend(opts, options);
	  }
	
	  self.init = function () {
	    bindStores();
	  };
	
	  function bindStores() {
	    _AsnStore2.default.bindListener("asns:fetchingQuotes", onFetchingStarted);
	  }
	
	  function onFetchingStarted() {
	    generateSnapshots();
	  }
	
	  self.generateSnapshots = generateSnapshots;
	  // This is the public function
	  // to handle the entire lifecycle
	  // of removing existing snapshots,
	  // and creating a new snapshot
	  function generateSnapshots() {
	    // asn = getCurrentAsn();
	    removeExistingSnapshots();
	    createSnapshots();
	    // logAllSnapshots();
	  }
	
	  self.generateInitialSnapshotsOnLoad = generateInitialSnapshotsOnLoad;
	  // this function is a smart generator
	  // for snapshots based on whether 
	  // quotes exist on load or not.
	  // It should be called ONCE in the main
	  // loaded file for the given page 
	  // at the very end (asnWizard.js)
	  function generateInitialSnapshotsOnLoad() {
	    var asn = getCurrentAsn();
	    if (hasQuotesForAsn(asn) || hasSpecialQuote(asn)) {
	      // console.log("generating initial snapshots for quote related stores...");
	      generateSnapshots();
	    }
	  }
	
	  function removeExistingSnapshots() {
	    (0, _underscore2.default)(storesSnapshotConfig).map(removeExistingSnapshotForStoreName);
	  }
	
	  function removeExistingSnapshotForStoreName(_ref) {
	    var storeName = _ref.storeName;
	
	    _stores2.default[storeName].removeDataSnapshotViaTag(QUOTES_RELATED_SNAPSHOT);
	  }
	
	  function createSnapshots() {
	    (0, _underscore2.default)(storesSnapshotConfig).map(createSnapshotForStoreName);
	  }
	
	  function createSnapshotForStoreName(_ref2) {
	    var storeName = _ref2.storeName;
	
	    _stores2.default[storeName].createDataSnapshot(QUOTES_RELATED_SNAPSHOT);
	  }
	
	  // function logAllSnapshots(){
	  //   _(storesSnapshotConfig).map(({storeName})=>{
	  //     console.log(`${storeName} snapshots:`);
	  //     console.log(stores[storeName].getDataSnapshots());
	  //   });
	  // }
	  function hasQuotesForAsn(asn) {
	    var q = _AsnStore2.default.getAvailableAndSelectedQuotesForAsn(asn);
	    return q && q.length;
	  }
	
	  function hasSpecialQuote(asn) {
	    return _AsnStore2.default.hasSpecialQuote(asn);
	  }
	
	  function getCurrentAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	}

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calcSubTotalServicesForAsnId;
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	var _AsnDetailStore = __webpack_require__(20);
	
	var _AsnDetailStore2 = _interopRequireDefault(_AsnDetailStore);
	
	var _CmrDomainStore = __webpack_require__(54);
	
	var _CmrDomainStore2 = _interopRequireDefault(_CmrDomainStore);
	
	var _CmrServiceStore = __webpack_require__(46);
	
	var _CmrServiceStore2 = _interopRequireDefault(_CmrServiceStore);
	
	var _ProductItemStore = __webpack_require__(65);
	
	var _ProductItemStore2 = _interopRequireDefault(_ProductItemStore);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcSubTotalServicesForAsnId(asnId) {
	  var total = 0;
	  var asn = _AsnStore2.default.getData()[asnId];
	  var asnDetailGroups = _AsnDetailStore2.default.groupBySku(_AsnStore2.default.getAsnDetails(asn));
	
	  (0, _underscore2.default)(asnDetailGroups).map(calcForEachAsnDetailGroup);
	
	  var services = _CmrServiceStore2.default.getServicesViaAsnId(asnId);
	
	  (0, _underscore2.default)(services).map(calcForServiceFunc(1));
	
	  function calcForEachAsnDetailGroup(asnDetailGroup) {
	    var firstDupSkuAsnDetail = asnDetailGroup[0];
	    var services = _CmrServiceStore2.default.getServicesViaAsnDetailId(firstDupSkuAsnDetail.id);
	    var quantity = _AsnDetailStore2.default.calcTotalQuantityForDetails(asnDetailGroup);
	    (0, _underscore2.default)(services).map(calcForServiceFunc(quantity));
	  }
	  function calcForServiceFunc(quantity) {
	    return function (service) {
	      var domain = _CmrDomainStore2.default.getData()[service.cdm_id];
	      if (domain) {
	        total += _CmrDomainStore2.default.getValue(domain) * quantity;
	      } else {
	        console.log("missing domain!");
	      }
	    };
	  }
	
	  return total;
	}

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shippingQuotesInvalidatorFactory;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _stores = __webpack_require__(99);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	var _constants = __webpack_require__(110);
	
	var _constants2 = _interopRequireDefault(_constants);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QUOTES_RELATED_SNAPSHOT = _constants2.default.QUOTES_RELATED_SNAPSHOT;
	
	
	var singleton = void 0;
	
	var storesAndImportantAttrsMap = [{
	  storeName: "AsnStore",
	  listenables: ["asns:change"],
	  callOnEvent: "asnStoreChanged",
	  only: [
	  // Location Tab Info 
	  "facilities", "cadId", "cadAddress1", "cadAddress2", "cadCountry", "cadCity", "state", "cadZipcode", "cadStateText",
	  // Shipping Tab Info
	  "shippingPartner",
	  // don't need inbound carrier
	  // "inboundCarrier",
	  "insidePickup", "liftGatePickup", "limitedAccess", "lumperPickup", "driverLoad", "pickupDate", "pickupTimeFrom", "pickupTimeTo", "shippingMethod"]
	}, {
	  storeName: "AsnDetailStore",
	  listenables: ["asn_details:change", "asn_details:add", "asn_details:remove"],
	  callOnEvent: "asnDetailStoreChanged"
	}];
	
	function shippingQuotesInvalidatorFactory(options) {
	  if (singleton) {
	    // singleton.setOptions(options);
	    return singleton;
	  } else {
	    singleton = new ShippingQuotesInvalidator(options);
	    singleton.init();
	    return singleton;
	  }
	}
	
	function ShippingQuotesInvalidator() {
	  var self = this;
	
	  this.init = function () {
	    bindStores();
	  };
	
	  var eventCallables = {
	    asnStoreChanged: asnStoreChanged,
	    asnDetailStoreChanged: asnDetailStoreChanged
	  };
	
	  function bindStores() {
	    (0, _underscore2.default)(storesAndImportantAttrsMap).map(bindStoreViaMap);
	  }
	
	  function bindStoreViaMap(storeConfig) {
	    var storeName = storeConfig.storeName,
	        listenables = storeConfig.listenables,
	        callOnEvent = storeConfig.callOnEvent;
	
	    (0, _underscore2.default)(listenables).map(function (listenable) {
	      _stores2.default[storeName].bindListener(listenable, _underscore2.default.partial(eventCallables[callOnEvent], storeConfig));
	    });
	  }
	
	  function asnStoreChanged(storeConfig) {
	    // console.log('asn store changed');
	    var only = storeConfig.only;
	
	    var asn = getCurrentAsn();
	    var asnId = asn.id;
	
	    // check if quote are not already invalidated, AND (that we actually have quotes OR specialQuote flag is true), AND we have a snapshot, and that there are changes since the last snapshot
	    if (!AsnStore.areQuotesInvalid(asn) && (hasQuotes(asn) || hasSpecialQuote(asn)) && AsnStore.getDataSnapshotViaTag(QUOTES_RELATED_SNAPSHOT) && AsnStore.hasDataChangesSinceSnapshotViaTag(QUOTES_RELATED_SNAPSHOT, { id: asnId, only: only })) {
	      console.log("invalidating quotes flag set");
	      AsnStore.updateObjectAndEmit(asnId, { quotesAreValid: false, showQuotesRemovedBecauseInfoChangedMessage: true });
	    }
	  }
	
	  function asnDetailStoreChanged(storeConfig) {
	    // console.log('asn detail store changed');
	    var asn = getCurrentAsn();
	    var asnId = asn.id;
	
	    if (!AsnStore.areQuotesInvalid(asn) && (hasQuotes(asn) || hasSpecialQuote(asn)) && AsnDetailStore.getDataSnapshotViaTag(QUOTES_RELATED_SNAPSHOT) && AsnDetailStore.hasDataChangesSinceSnapshotViaTag(QUOTES_RELATED_SNAPSHOT)) {
	      console.log("invalidating quotes flag set");
	      AsnStore.updateObjectAndEmit(asnId, { quotesAreValid: false, showQuotesRemovedBecauseInfoChangedMessage: true });
	    }
	  }
	
	  function hasSpecialQuote(asn) {
	    return AsnStore.hasSpecialQuote(asn);
	  }
	
	  function hasQuotes(asn) {
	    var q = AsnStore.getAvailableAndSelectedQuotesForAsn(asn);
	    if (q && q.length) {
	      return true;
	    }
	    q = AsnStore.getSelectedQuoteForAsn(asn);
	    if (!_underscore2.default.isNull(q) && !_underscore2.default.isUndefined(q)) {
	      return true;
	    }
	
	    return false;
	  }
	
	  function getCurrentAsnId() {
	    return getCurrentAsn().id;
	  }
	
	  function getCurrentAsn() {
	    return AsnStore.getAsnWithShippingMethod();
	  }
	}

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quotesInvalidationFactory;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalHtml = __webpack_require__(11);
	var modalBodyHtml = __webpack_require__(1249);
	
	var singleton = void 0;
	
	function quotesInvalidationFactory(options) {
	  if (singleton) {
	    // singleton.setOptions(options);
	    return singleton;
	  } else {
	    singleton = new QuotesInvalidation(options);
	    singleton.init();
	    return singleton;
	  }
	}
	
	var noop = function noop() {};
	
	var elementsMap = {
	  undoChangesBtn: ".undo-changes-btn",
	  understandBtn: ".understand-btn"
	};
	
	function QuotesInvalidation() {
	  var self = this;
	  var done = void 0;
	  self._element = $();
	  var els = {};
	
	  self.init = function () {
	    setHtml();
	    setElements();
	    setWidgets();
	    bindElements();
	  };
	
	  function getElement() {
	    return self._element;
	  }
	
	  function setHtml() {
	    self._element = $((0, _render2.default)(modalHtml, {
	      title: "Shipment Information Changed - Quote Removed",
	      body: (0, _render2.default)(modalBodyHtml),
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn purple-btn understand-btn\">I Understand</a>\n        "
	    }));
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, getElement());
	  }
	
	  function setWidgets() {
	    getElement().modal({ backdrop: 'static', show: false });
	  }
	
	  function bindElements() {
	    els.undoChangesBtn.on("click", onUndoChangesClick);
	    els.understandBtn.on("click", onUnderstandClick);
	  }
	
	  function onUndoChangesClick() {
	    console.log("undoing changes...and calling done");
	    handleAfterQuoteSelectUndoChanges();
	    hideModal();
	    done(false);
	  }
	
	  function onUnderstandClick() {
	    console.log("I understand...and calling done");
	    resetQuotesNow();
	
	    hideModal();
	    done(true);
	  }
	
	  function resetQuotesNow() {
	    _AsnStore2.default.resetQuotesRelatedFlags(getCurrentAsn(), { showQuotesRemovedBecauseInfoChangedMessage: true });
	  }
	
	  self.determineQuoteInvalidPrompt = function (doneFunc) {
	    done = doneFunc || noop;
	    if (_AsnStore2.default.areQuotesInvalid(getCurrentAsn())) {
	      console.log("showing quote modal");
	
	      // setTimeout(()=>{
	      //   console.log("showed quote modal...now done and resetting stores");
	      //   done(true);
	      // },1000);
	      showModal();
	    } else {
	      console.log('quotes are valid still.');
	      done(true);
	    }
	  };
	
	  function showModal() {
	    getElement().modal("show");
	  }
	
	  function hideModal() {
	    getElement().modal("hide");
	  }
	
	  function getCurrentAsn() {
	    return _AsnStore2.default.getAsnWithShippingMethod();
	  }
	}

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _AsnStore = __webpack_require__(14);
	
	var _AsnStore2 = _interopRequireDefault(_AsnStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	(0, _run2.default)("#asn-detail-page", function () {
	
		var validator = (0, _jquery2.default)(".address-validation-form").validate({
			errorPlacement: function errorPlacement(error, element) {
				var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
				if (appendClosest) {
					(0, _jquery2.default)(element).closest(appendClosest).append(error);
				} else {
					error.insertAfter(element);
				}
			}
		});
	
		validator.settings.ignore = ":disabled,:hidden";
	
		var el = (0, _jquery2.default)("#asn-detail-page");
		var els = {};
		var fixAddressBtn = "#order-detail-fix-add-btn";
		var asn = (0, _jquery2.default)("#asn-detail-page").data("asn");
		var cmrAddress = (0, _jquery2.default)("#asn-detail-page").data("facility-info");
		var cmrAddresses = (0, _jquery2.default)("#asn-detail-page").data("addresses");
		var validateAddressUrl = (0, _jquery2.default)("#asn-detail-page").data("validate-address-url");
		var pageReloadUrl = (0, _jquery2.default)("#asn-detail-page").data("asn-detail-page-reload-url");
		var generalErrorMessage = (0, _jquery2.default)("#asn-detail-page").data("general-error-message");
		var addressOriginSubTitleText = (0, _jquery2.default)("#asn-detail-page").data("add-validation-origin-fac-title-text");
	
		var elementsMap = {
			destinationSectionPencil: ".destination-section-pecil",
			contentSectionPencil: ".contents-section-pencil",
			servicesSectionPencil: ".services-section-pencil",
			shippingSectionPencil: ".shipping-section-pencil",
			packingSectionPencil: ".packing-section-pencil",
			cancelShipmentBtn: "#asn-detail-cancel-shipment",
			editShipmentBtn: "#asn-detail-edit-shipment",
			pencilIcon: ".fa-pencil",
			returnToShipmentsBtn: "#asn-detail-return-to-shipments",
			printLabelsBtn: "#asn-detail-print-labels",
			printFedExLabelsBtn: "#asn-detail-print-fedex-label",
			printBolBtn: "#asn-detail-print-bol",
			asnServiceLookupPagingArea: "#asn-detail-service-paging-area",
			asnServiceLookupMainArea: "#asn-detail-service-main-area tbody",
			asnPackingLookupPagingArea: "#asn-detail-packing-paging-area",
			asnPackingLookupMainArea: "#asn-detail-packing-main-area",
			asnProductLookupMainArea: "#asn-detail-product-main-area",
			asnProductLookupPagingArea: "#asn-detail-product-paging-area",
			modifyAddressSection: "modify-address-section"
		};
	
		(0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	
		var originFacAddress = (0, _jquery2.default)("#origin-fac-address");
		var originFacAddressWrapper = (0, _jquery2.default)("#origin-fac-address-wrapper");
		var countries = (0, _jquery2.default)("#asn-detail-page").data("countries");
		var senderSelecedAddress = "";
	
		(0, _jquery2.default)(fixAddressBtn).click(function () {
			showModal();
			showLoadingModal();
			if (asn.asnStatus == "Error") {
				addressValidation();
				(0, _jquery2.default)(".origin-enter-address-item").show();
				(0, _jquery2.default)(".origin-modified-address-item").hide();
				(0, _jquery2.default)(".origin-validated-address-item").hide();
				(0, _jquery2.default)(".modified-invalid-address-section").hide();
			}
		});
	
		function addressValidation() {
			var namespace = "";
			namespace = (0, _jquery2.default)("#asn-detail-page").data('namespace');
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: _defineProperty({
					asnId: asn.asnId
				}, namespace + 'callType', "addressValidation"),
				success: function success(data) {
					if (data.response == "success") {
						addressFoundModalOrg(data, cmrAddress, "validated");
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		}
	
		function addressFoundModalOrg(data, cmrAddress, action) {
			var userAddHtml = "";
			if (data == null) {
				userAddHtml += cmrAddress.cadLocationName + ", " + asn.asnAddressLine1;
				if (!empty(asn.asnAddressLine2)) {
					userAddHtml += ", " + asn.asnAddressLine2 + ", " + asn.asnCity + ", " + asn.asnState + ", " + asn.asnZipcode + ", " + asn.asnCountry;
				} else {
					userAddHtml += ", " + asn.asnCity + ", " + asn.asnState + ", " + asn.asnZipcode + ", " + asn.asnCountry;
				}
			} else {
				userAddHtml += cmrAddress.cadLocationName + ", " + data.asnAddressLine1;
				if (!empty(data.asnAddressLine2)) {
					userAddHtml += ", " + data.asnAddressLine2 + ", " + data.asnCity + ", " + data.asnState + ", " + data.asnZipcode + ", " + data.asnCountry;
				} else {
					userAddHtml += ", " + data.asnCity + ", " + data.asnState + ", " + data.asnZipcode + ", " + data.asnCountry;
				}
			}
	
			if (action == "validated") {
				(0, _jquery2.default)("#add-validation-origin-user-entered-add").html(userAddHtml);
			} else {
				(0, _jquery2.default)("#add-validation-origin-system-modified-add").html(userAddHtml);
			}
			var sysAddHtml = cmrAddress.cadLocationName.toUpperCase() + ", " + cmrAddress.cadAddress1;
			if (!empty(cmrAddress.cadAddress2)) {
				sysAddHtml += ", " + cmrAddress.cadAddress2 + ", " + cmrAddress.cadCity + ", " + cmrAddress.cadState + ", " + cmrAddress.cadZipcode + ", " + cmrAddress.cadCountry;
			} else {
				sysAddHtml += ", " + cmrAddress.cadCity + ", " + cmrAddress.cadState + ", " + cmrAddress.cadZipcode + ", " + cmrAddress.cadCountry;
			}
	
			(0, _jquery2.default)("#add-validation-origin-system-found-add").html(sysAddHtml);
			showAddressFoundModal();
		}
	
		function addressFoundModal(stdAddress1, stdAddress2, stdCity, stdState, stdZip, stdCountry, data) {
	
			var userAddHtml = "";
	
			if (data == null) {
				userAddHtml += cmrAddress.cadLocationName + "," + asn.asnAddressLine1;
	
				if (!empty(asn.asnAddressLine2)) {
					userAddHtml += "," + asn.asnAddressLine2 + "," + asn.asnCity + "," + asn.asnState + "," + asn.asnZipcode;
				} else {
					userAddHtml += "," + asn.asnCity + "," + asn.asnState + "," + asn.asnZipcode;
				}
			} else {
				userAddHtml += cmrAddress.cadLocationName + "," + data.address1;
				if (!empty(data.address2)) {
					userAddHtml += "," + data.address2 + "," + data.city + "," + data.state + "," + data.zip;
				} else {
					userAddHtml += "," + data.city + "," + data.state + "," + data.zip;
				}
			}
	
			(0, _jquery2.default)("#add-validation-origin-user-entered-add").html(userAddHtml);
	
			var sysAddHtml = cmrAddress.cadLocationName.toUpperCase() + "," + stdAddress1;
	
			if (!empty(stdAddress2)) {
				sysAddHtml += "," + stdAddress2 + "," + stdCity + "," + stdState + "," + stdZip;
			} else {
				sysAddHtml += "," + stdCity + "," + stdState + "," + stdZip;
			}
	
			(0, _jquery2.default)("#add-validation-origin-system-found-add").html(sysAddHtml);
			showAddressFoundModal();
		}
	
		function addressNotFoundModal(data) {
	
			var userAddHtml = cmrAddress.cadLocationName + "," + data.address1;
			if (!empty(data.address2)) {
				userAddHtml += "," + data.address2 + "," + data.city + "," + data.state + "," + data.zip;
			} else {
				userAddHtml += "," + data.city + "," + data.state + "," + data.zip;
			}
	
			(0, _jquery2.default)("#add-validation-user-entered-add").html(userAddHtml);
			showAddressNotFoundModal();
		}
	
		(0, _jquery2.default)('.mod-address-btn').click(function () {
			var namespace = "";
			namespace = (0, _jquery2.default)("#asn-detail-page").data('namespace');
			showLoadingModal();
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: _defineProperty({
					asnId: asn.asnId
				}, namespace + 'callType', "modifyAddress"),
				success: function success(data) {
					if (data.response == "success") {
						var _countries = data.countries;
	
						(0, _jquery2.default)('#validate-address-country').empty();
						var option = (0, _jquery2.default)('<option />');
						option.attr('value', '').text("Select Country");
						(0, _jquery2.default)('#validate-address-country').append(option);
						(0, _jquery2.default)(_countries).each(function () {
							option = (0, _jquery2.default)('<option />');
							option.attr('value', this.conCode).text(this.conName);
							(0, _jquery2.default)('#validate-address-country').append(option);
						});
	
						var userAddHtml = data.asnAddressLine1;
						if (!empty(data.asnAddressLine2)) {
							userAddHtml += "," + data.asnAddressLine2 + "," + data.asnCity + "," + data.asnState + "," + data.asnZipcode + ", " + data.asnCountry;
						} else {
							userAddHtml += "," + data.asnCity + "," + data.asnState + "," + data.asnZipcode + ", " + data.asnCountry;
						}
	
						(0, _jquery2.default)("#add-validation-origin-user-entered-add-modified").html(userAddHtml);
						showModifyAddressModal();
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		});
	
		(0, _jquery2.default)('.select-saved-address-btn').click(function () {
			var namespace = "";
			namespace = (0, _jquery2.default)("#asn-detail-page").data('namespace');
			showLoadingModal();
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: _defineProperty({
					asnId: asn.asnId
				}, namespace + 'callType', "selectFromSavedFacility"),
				success: function success(data) {
					if (data.response == "success") {
						var facilities = data.orgFacilities;
	
						(0, _jquery2.default)('#validate-origin-facility').empty();
						var option = (0, _jquery2.default)('<option />');
						option.attr('value', '').text("Select origin facility");
						(0, _jquery2.default)('#validate-origin-facility').append(option);
						(0, _jquery2.default)(facilities).each(function () {
							option = (0, _jquery2.default)('<option />');
							option.attr('value', this.cadId).text(this.cadLocationName);
							(0, _jquery2.default)('#validate-origin-facility').append(option);
						});
	
						showSelectFromSavedFacilitiesModal();
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		});
	
		(0, _jquery2.default)('#validate-address-country').change(function () {
			var countryVal = (0, _jquery2.default)("#validate-address-country :selected").val();
			setStatesFromCountry(countryVal, this.selectedIndex);
		});
	
		function setStatesFromCountry(countryVal, selectedIndex) {
			if (countryVal == "US" || countryVal == "CA") {
				(0, _jquery2.default)(".validate-address-state-text-wrapper").hide();
				(0, _jquery2.default)(".validate-address-state-wrapper").show();
				window.print_state("validate-address-state", selectedIndex);
			} else {
				(0, _jquery2.default)(".validate-address-state-text-wrapper").show();
				(0, _jquery2.default)(".validate-address-state-wrapper").hide();
			}
		}
	
		(0, _jquery2.default)('#validate-origin-facility').change(function () {
			var selectedValue = this.value;
			var senderAddress = cmrAddresses.filter(function (obj) {
				return obj.cadId == selectedValue;
			})[0];
			senderSelecedAddress = senderAddress;
			originFacAddressWrapper.hide();
			originFacAddress.html('');
			if (senderAddress != null) {
				originFacAddress.append("<div>" + senderAddress.cadAddress1 + "</div>");
				if (senderAddress.cadAddress2 != null) {
					originFacAddress.append("<div>" + senderAddress.cadAddress2 + "</div>");
				}
				if (senderAddress.cadCity == null) {
					originFacAddress.append("<div>" + senderAddress.cadState + " " + senderAddress.cadZipcode + "</div>");
				} else {
					originFacAddress.append("<div>" + senderAddress.cadCity + ", " + senderAddress.cadState + " " + senderAddress.cadZipcode + "</div>");
				}
	
				(0, _jquery2.default)(countries).each(function () {
					if (this.conCode == senderAddress.cadCountry) {
						originFacAddress.append("<div data-concode='" + this.conCode + "'>" + this.conName + "</div>");
						return;
					}
				});
				originFacAddressWrapper.show();
			}
		});
	
		(0, _jquery2.default)('.use-selected-address-btn').click(function () {
			var namespace = "";
			namespace = (0, _jquery2.default)("#asn-detail-page").data('namespace');
			showLoadingModal();
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: _defineProperty({
					asnId: asn.asnId,
					userSelectedAdd: (0, _jquery2.default)('[name=originRadioAddressChoice]:checked').val()
				}, namespace + 'callType', "usethisAddress"),
				success: function success(data) {
					if (data.response == "success" && data.isAddFixed) {
						location.href = pageReloadUrl;
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		});
	
		(0, _jquery2.default)('.set-origin-fac-address-btn').click(function () {
			var _data5;
	
			var selectFromSavedFacilityId = "";
			var namespace = "";
			namespace = (0, _jquery2.default)("#asn-detail-page").data('namespace');
			showLoadingModal();
			var addressString = "";
			if ((0, _jquery2.default)('[name=originRadioAddressChoice]:checked').val() == "0") {
				addressString = (0, _jquery2.default)('#add-validation-origin-user-entered-add').text();
			} else if ((0, _jquery2.default)('[name=originRadioAddressChoice]:checked').val() == "2") {
				addressString = (0, _jquery2.default)('#add-validation-origin-system-modified-add').text();
			} else if ((0, _jquery2.default)('[name=originRadioAddressChoice]:checked').val() == "3") {
				addressString = (0, _jquery2.default)('#add-validation-origin-system-validated-add').text();
			} else if ((0, _jquery2.default)('[name=originRadioAddressChoice]:checked').val() == "4") {
				addressString = (0, _jquery2.default)('#add-validation-origin-system-found-add').text();
			}
	
			if (senderSelecedAddress.cadAddress1 != null) {
				addressString = senderSelecedAddress.cadLocationName + ", " + senderSelecedAddress.cadAddress1;
				if (senderSelecedAddress.cadAddress2 != null) {
					addressString += ", " + senderSelecedAddress.cadAddress2;
				}
				addressString += ", " + senderSelecedAddress.cadCity + ", " + senderSelecedAddress.cadState + ", " + senderSelecedAddress.cadZipcode + ", " + senderSelecedAddress.cadCountry;
				selectFromSavedFacilityId = senderSelecedAddress.cadId;
			}
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: (_data5 = {
					asnId: asn.asnId
				}, _defineProperty(_data5, namespace + 'userSelectedAdd', (0, _jquery2.default)('[name=originRadioAddressChoice]:checked').val()), _defineProperty(_data5, namespace + 'callType', "setOriginFacAddress"), _defineProperty(_data5, namespace + 'addressString', addressString), _defineProperty(_data5, namespace + 'selectFromSavedFacilityId', selectFromSavedFacilityId), _data5),
				success: function success(data) {
					if (data.response == "success") {
						hideModal();
						location.href = pageReloadUrl;
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		});
	
		(0, _jquery2.default)('.validate-address-btn').click(function () {
			var _data6;
	
			var namespace = "";
			namespace = (0, _jquery2.default)("#asn-detail-page").data('namespace');
	
			if (!validator.elements().valid()) {
				return;
			}
			showLoadingModal();
			var conCode = (0, _jquery2.default)("#validate-address-country :selected").val();
			var stateValue = "";
			if (conCode == "US" || conCode == "CA") {
				stateValue = (0, _jquery2.default)("#validate-address-state :selected").val();
			} else {
				stateValue = (0, _jquery2.default)("#validate-address-state-text").val();
			}
	
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: (_data6 = {}, _defineProperty(_data6, namespace + 'asnId', (0, _jquery2.default)('#asnId').val()), _defineProperty(_data6, namespace + 'country', conCode), _defineProperty(_data6, namespace + 'address1', (0, _jquery2.default)("#validate-address-address1").val()), _defineProperty(_data6, namespace + 'address2', (0, _jquery2.default)("#validate-address-address2").val()), _defineProperty(_data6, namespace + 'city', (0, _jquery2.default)("#validate-address-city").val()), _defineProperty(_data6, namespace + 'state', stateValue), _defineProperty(_data6, namespace + 'zip', (0, _jquery2.default)("#validate-address-zip").val()), _defineProperty(_data6, namespace + 'callType', "validateThisAddress"), _data6),
				success: function success(data) {
					if (data.response == "success") {
						var userModAddHtml = "";
						showModal();
						userModAddHtml += cmrAddress.cadLocationName + ", " + (0, _jquery2.default)("#validate-address-address1").val();
						if (!empty((0, _jquery2.default)("#validate-address-address2").val())) {
							userModAddHtml += ", " + (0, _jquery2.default)("#validate-address-address2").val() + ", " + (0, _jquery2.default)("#validate-address-city").val() + ", " + stateValue + ", " + (0, _jquery2.default)("#validate-address-zip").val() + ", " + (0, _jquery2.default)("#validate-address-country").val();
						} else {
							userModAddHtml += ", " + (0, _jquery2.default)("#validate-address-city").val() + ", " + stateValue + ", " + (0, _jquery2.default)("#validate-address-zip").val() + ", " + (0, _jquery2.default)("#validate-address-country").val();
						}
						(0, _jquery2.default)("#add-validation-origin-system-modified-add").html(userModAddHtml);
						showAddressFoundModal();
						if (conCode == "US") {
							if (data.validateUsAddress.validateResult) {
								(0, _jquery2.default)(".origin-enter-address-item").hide();
								(0, _jquery2.default)(".origin-modified-address-item").show();
								(0, _jquery2.default)(".origin-validated-address-item").show();
								var userValidatedAddHtml = "";
								userValidatedAddHtml += cmrAddress.cadLocationName + ", " + data.validateUsAddress.stdAddress1;
								if (!empty(data.validateUsAddress.stdAddress2)) {
									userValidatedAddHtml += ", " + data.validateUsAddress.stdAddress2 + ", " + data.validateUsAddress.stdCity + ", " + data.validateUsAddress.stdState + ", " + data.validateUsAddress.stdZip + ", " + data.validateUsAddress.stdCountry;
								} else {
									userValidatedAddHtml += ", " + data.validateUsAddress.stdCity + ", " + data.validateUsAddress.stdState + ", " + data.validateUsAddress.stdZip + ", " + data.validateUsAddress.stdCountry;
								}
								(0, _jquery2.default)("#add-validation-origin-system-validated-add").html(userValidatedAddHtml);
								(0, _jquery2.default)(".modified-invalid-address-section").hide();
							} else {
								(0, _jquery2.default)(".modified-invalid-address-section").show();
								(0, _jquery2.default)(".origin-enter-address-item").hide();
								(0, _jquery2.default)(".origin-modified-address-item").show();
							}
						} else {
							(0, _jquery2.default)(".origin-enter-address-item").hide();
							(0, _jquery2.default)(".origin-modified-address-item").show();
						}
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		});
	
		function showLoadingModal() {
			(0, _jquery2.default)("#address-found-or-not-text").html("");
			(0, _jquery2.default)(".add-validation").hide();
			(0, _jquery2.default)(".origin-add-validation").show();
			(0, _jquery2.default)(".address-select-choices-outer").hide();
			(0, _jquery2.default)(".address-validation-loading-outer").show();
			(0, _jquery2.default)(".cancel-btn").show();
			(0, _jquery2.default)(".mod-address-btn").show();
			(0, _jquery2.default)(".select-saved-address-btn").show();
			(0, _jquery2.default)(".set-origin-fac-address-btn").show();
			(0, _jquery2.default)(".use-selected-address-btn").hide();
			(0, _jquery2.default)(".validate-address-btn").hide();
		}
	
		function showModal() {
			(0, _jquery2.default)("#add-validation-model").modal("show");
		}
	
		function hideModal() {
			(0, _jquery2.default)("#add-validation-model").modal("hide");
		}
	
		function showAddressFoundModal() {
	
			(0, _jquery2.default)("#address-found-or-not-text").html(addressOriginSubTitleText);
			if ((0, _jquery2.default)("#radio-entered-address").hasClass("q-radio-hide")) {
				(0, _jquery2.default)("#radio-entered-address").removeClass("q-radio-hide");
			}
			if ((0, _jquery2.default)("#origin-radio-entered-address").hasClass("q-radio-hide")) {
				(0, _jquery2.default)("#origin-radio-entered-address").removeClass("q-radio-hide");
			}
			(0, _jquery2.default)(".address-select-choices-outer").show();
			(0, _jquery2.default)(".found-address-item").hide();
			(0, _jquery2.default)(".origin-found-address-item").show();
			(0, _jquery2.default)(".enter-address-item").hide();
			(0, _jquery2.default)(".origin-enter-address-item").show();
			(0, _jquery2.default)(".modify-address-section").hide();
			(0, _jquery2.default)(".select-from-facility-state").hide();
			(0, _jquery2.default)(".no-address-found-section").hide();
			(0, _jquery2.default)(".address-validation-loading-outer").hide();
			(0, _jquery2.default)(".mod-address-btn").show();
			(0, _jquery2.default)(".use-selected-address-btn").hide();
			(0, _jquery2.default)(".validate-address-btn").hide();
		}
	
		function showAddressNotFoundModal() {
			(0, _jquery2.default)("#address-found-or-not-text").html(addressOriginSubTitleText);
			if ((0, _jquery2.default)("#radio-entered-address").hasClass("q-radio-hide")) {
				(0, _jquery2.default)("#radio-entered-address").removeClass("q-radio-hide");
			}
			if ((0, _jquery2.default)("#origin-radio-entered-address").hasClass("q-radio-hide")) {
				(0, _jquery2.default)("#origin-radio-entered-address").removeClass("q-radio-hide");
			}
			(0, _jquery2.default)(".address-select-choices-outer").show();
			(0, _jquery2.default)(".found-address-item").hide();
			(0, _jquery2.default)(".origin-found-address-item").hide();
			(0, _jquery2.default)(".enter-address-item").hide();
			(0, _jquery2.default)(".origin-enter-address-item").hide();
			(0, _jquery2.default)(".modify-address-section").hide();
			(0, _jquery2.default)(".select-from-facility-state").hide();
			(0, _jquery2.default)(".no-address-found-section").show();
			(0, _jquery2.default)(".address-validation-loading-outer").hide();
			(0, _jquery2.default)(".mod-address-btn").show();
			(0, _jquery2.default)(".use-selected-address-btn").hide();
			(0, _jquery2.default)(".validate-address-btn").hide();
		}
	
		function showModifyAddressModal() {
			(0, _jquery2.default)("#address-found-or-not-text").html(addressOriginSubTitleText);
			(0, _jquery2.default)("#radio-entered-address").addClass("q-radio-hide");
			(0, _jquery2.default)("#origin-radio-entered-address").addClass("q-radio-hide");
			(0, _jquery2.default)(".address-select-choices-outer").show();
			(0, _jquery2.default)(".found-address-item").hide();
			(0, _jquery2.default)(".origin-found-address-item").hide();
			(0, _jquery2.default)(".enter-address-item").hide();
			(0, _jquery2.default)(".origin-enter-address-item").hide();
			(0, _jquery2.default)(".modify-address-section").show();
			(0, _jquery2.default)(".select-from-facility-state").hide();
			(0, _jquery2.default)(".no-address-found-section").hide();
			(0, _jquery2.default)(".address-validation-loading-outer").hide();
			(0, _jquery2.default)(".mod-address-btn").hide();
			(0, _jquery2.default)(".use-selected-address-btn").hide();
			(0, _jquery2.default)(".validate-address-btn").show();
			(0, _jquery2.default)(".set-origin-fac-address-btn").hide();
			(0, _jquery2.default)(".origin-modified-address-item").hide();
			(0, _jquery2.default)(".origin-validated-address-item").hide();
			(0, _jquery2.default)(".modified-invalid-address-section").hide();
		}
		function showSelectFromSavedFacilitiesModal() {
			(0, _jquery2.default)("#address-found-or-not-text").html(addressOriginSubTitleText);
			(0, _jquery2.default)("#radio-entered-address").addClass("q-radio-hide");
			(0, _jquery2.default)(".address-select-choices-outer").show();
			(0, _jquery2.default)(".found-address-item").hide();
			(0, _jquery2.default)(".origin-found-address-item").hide();
			(0, _jquery2.default)(".enter-address-item").hide();
			(0, _jquery2.default)(".origin-enter-address-item").hide();
			(0, _jquery2.default)(".modify-address-section").hide();
			(0, _jquery2.default)(".select-saved-address-btn").hide();
			(0, _jquery2.default)(".select-from-facility-state").show();
			(0, _jquery2.default)(".no-address-found-section").hide();
			(0, _jquery2.default)(".address-validation-loading-outer").hide();
			(0, _jquery2.default)(".mod-address-btn").show();
			(0, _jquery2.default)(".use-selected-address-btn").hide();
			(0, _jquery2.default)(".validate-address-btn").hide();
			(0, _jquery2.default)(".origin-modified-address-item").hide();
			(0, _jquery2.default)(".origin-validated-address-item").hide();
			(0, _jquery2.default)(".modified-invalid-address-section").hide();
			originFacAddressWrapper.hide();
			originFacAddress.html('');
		}
	
		function empty(str) {
			if (typeof str == 'undefined' || !str || str.length === 0 || str === "" || !/[^\s]/.test(str) || /^\s*$/.test(str) || str.replace(/\s/g, "") === "") {
				return true;
			} else {
				return false;
			}
		}
	});

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _jumpToWizardLogic = __webpack_require__(70);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _detailAddressValidation = __webpack_require__(552);
	
	var _detailAddressValidation2 = _interopRequireDefault(_detailAddressValidation);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _general = __webpack_require__(5);
	
	var _index = __webpack_require__(86);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	
	var serviceLookupBody = __webpack_require__(1256);
	var serviceLookupMultiRowsColumns = __webpack_require__(1257);
	var packageLookupItem = __webpack_require__(1253);
	var packageLookupBody = __webpack_require__(1252);
	var productLookupBody = __webpack_require__(1254);
	var modalBodyForPackingDetailHtml = __webpack_require__(1250);
	var modalFooterForPackingDetailHtml = __webpack_require__(1251);
	var renderTemplateForPackingSubRowHtml = __webpack_require__(1255);
	var modalHtml = __webpack_require__(11);
	var loaderHtml = __webpack_require__(317);
	__webpack_require__(1079);
	
	(0, _run2.default)("#asn-detail-page", function () {
	  var el = $("#asn-detail-page");
	  asnDetail(el);
	});
	
	function asnDetail(el) {
	
	  var isShipmentChange = el.data("shipment-info-change-flag");
	  var understandBtnUrl = el.data("understand-btn-url");
	  var asn = el.data("asn");
	  var asnPortletEditPerm = el.data("asn-edit-param");
	  var shouldCheckCache = el.data("should-check-cache");
	  var canEditGtlAsn = el.data("canEditGtlAsn");
	  var editAsnUrl = el.data("edit-asn-url");
	  var namespace = el.data("namespace");
	  var generalErrorMessage = el.data("general-error-message");
	  var cancelAsnUrl = el.data("cancel-asn-url");
	  var viewAsnUrl = el.data("view-asn-url");
	  var cancelConfirmMsg1 = el.data("cancel-confirm-msg1");
	  var cancelConfirmMsg2 = el.data("cancel-confirm-msg2");
	  var cancelErrorMsg1 = el.data("cancel-error-msg1");
	  var cancelErrorMsg2 = el.data("cancel-error-msg2");
	  var generateAsnLabelsUrl = el.data("asn-label-url");
	  var isPallet = el.data("is-pallet");
	  var generateFedExShippingLabelsUrl = el.data("asn-fedex-shipping-label-url");
	  var generateBOLLabelUrl = el.data("asn-bol-label-url");
	  var els = {};
	  var initialDataForServicesLookup = el.data("initial-data-for-services-lookup");
	  var asnDetailProductLookupURL = el.data("asn-detail-product-lookup-url");
	  var asnDetailPackingLookupURL = el.data("asn-detail-packing-lookup-url");
	  var asnDetailServiceLookupURL = el.data("asn-detail-service-lookup-url");
	  var getPackageProductsURL = el.data("get-package-products-url");
	
	  var portletNamespace = el.data("portlet-namespace");
	  var pageSizeOptionsArray = [10, 25, 50, 100];
	  var items = el.data("items");
	  var services = el.data("services");
	  var packages = el.data("packages");
	  var asnShippingPallets = asn.asnShippingPallets;
	  var checkIfAsnShippingPalletsExists = false;
	
	  (0, _jumpToWizardLogic.bindJumpToWizardLinks)();
	
	  var elementsMap = {
	    destinationSectionPencil: ".destination-section-pecil",
	    contentSectionPencil: ".contents-section-pencil",
	    servicesSectionPencil: ".services-section-pencil",
	    shippingSectionPencil: ".shipping-section-pencil",
	    packingSectionPencil: ".packing-section-pencil",
	    cancelShipmentBtn: "#asn-detail-cancel-shipment",
	    editShipmentBtn: "#asn-detail-edit-shipment",
	    pencilIcon: ".fa-pencil",
	    returnToShipmentsBtn: "#asn-detail-return-to-shipments",
	    printLabelsBtn: "#asn-detail-print-labels",
	    printFedExLabelsBtn: "#asn-detail-print-fedex-label",
	    printBolBtn: "#asn-detail-print-bol",
	    asnServiceLookupPagingArea: "#asn-detail-service-paging-area",
	    asnServiceLookupMainArea: "#asn-detail-service-main-area tbody",
	    asnPackingLookupPagingArea: "#asn-detail-packing-paging-area",
	    asnPackingLookupMainArea: "#asn-detail-packing-main-area",
	    asnProductLookupMainArea: "#asn-detail-product-main-area",
	    asnProductLookupPagingArea: "#asn-detail-product-paging-area"
	  };
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  // elements at document scope
	  var docElementsMap = {
	    errorModal: "#errorModal",
	    confirmationModal: "#confirmationModal",
	    cancelModal: "#cancelModal",
	    shippingChangeModal: "#fedex-shipment-change",
	    iUnderstandBtn: ".understand-btn",
	    modalCancelAsnBtn: "#modalCancelAsn"
	  };
	
	  setElements();
	  onLoad();
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	    (0, _selectorHelpers.setElementsFromScope)(els, docElementsMap, $(document));
	  }
	
	  function onLoad() {
	
	    var asnStatus = asn.asnStatus;
	    var asnShippingPartner = asn.asnShippingPartner;
	
	    if ((0, _general.isPresent)(asnShippingPallets) && asnShippingPallets.length > 0) {
	      checkIfAsnShippingPalletsExists = true;
	    }
	
	    if (asn.asnType === "R" && asnPortletEditPerm === true) {
	      if (canEditGtlAsn === true) {
	        showCancelShipmentBtn();
	      }
	    } else if (asnPortletEditPerm === true) {
	      showEditShipmentBtn();
	      if (canEditGtlAsn === true) {
	        showCancelShipmentBtn();
	      }
	      els.destinationSectionPencil.show();
	      els.contentSectionPencil.show();
	      els.servicesSectionPencil.show();
	      els.shippingSectionPencil.show();
	      els.packingSectionPencil.show();
	    }
	    if (asnStatus === "In Transit") {
	      hideEditShipmentBtn();
	      els.destinationSectionPencil.hide();
	      els.contentSectionPencil.hide();
	      els.servicesSectionPencil.hide();
	      els.shippingSectionPencil.hide();
	      els.packingSectionPencil.hide();
	    }
	
	    if (asnStatus === "Canceled" || asnStatus === "Complete" || asnStatus === "Receiving") {
	      hideCancelShipmentBtn();
	      hideEditShipmentBtn();
	      els.destinationSectionPencil.hide();
	      els.contentSectionPencil.hide();
	      els.servicesSectionPencil.hide();
	      els.shippingSectionPencil.hide();
	      els.packingSectionPencil.hide();
	    }
	
	    if (isShipmentChange === true) {
	      els.shippingChangeModal.modal("show");
	    }
	
	    //### Common method for lookup of detail page ####//
	
	
	    function prepareDataToSendController(page, pageSize, portletNamespace) {
	      var _data;
	
	      portletNamespace = (0, _general.isPresent)(portletNamespace) ? portletNamespace : "";
	      var data = (_data = {}, _defineProperty(_data, portletNamespace + "pageSize", pageSize), _defineProperty(_data, portletNamespace + "page", page), _data);
	      return data;
	    }
	
	    var serviceTotalCount = services.totalElements;
	    var pacakgeTotalCount = packages.totalElements;
	    var productTotalCount = items.totalElements;
	    var packagePrductCount = void 0;
	
	    // ########## Services lookup screen start ########## /
	    var serviceLookup = new _index2.default({
	      dataContainer: els.asnServiceLookupMainArea, // area in example.html where data rows will go.
	      pagingContainer: els.asnServiceLookupPagingArea, // area in example.html where paging tab will go.
	      pageSizeOptions: pageSizeOptionsArray, // optional default:[10,25,50,100].
	      pageSize: 10, // optional default: 10.
	      data: services,
	      showData: function showData(row) {
	        return (0, _render2.default)(serviceLookupBody, {
	          sku: row.sku,
	          service: renderService(row.service),
	          quantity: row.quantity,
	          cost: renderCost(row.service)
	        });
	      },
	      // onFetch function from line 70 to 78 is strictly for example only and should not be used anywhere. For real world scenario just pass response data to pagable.setData()
	      onFetch: function onFetch(page, pageSize) {
	        serviceLookup.showLoadingOverlay();
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: asnDetailServiceLookupURL, success: serviceLookupSuccess, error: errorFun, data: prepareDataToSendController(page, pageSize, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	        // serviceLookup.setData(tempData);
	      }
	    });
	
	    serviceLookup.init();
	
	    function renderService(service) {
	      var temp = "";
	      _(service).map(function (item) {
	        var service = (0, _render2.default)(serviceLookupMultiRowsColumns, { value: item.serviceName });
	        temp = temp + service;
	      });
	      return temp;
	    }
	
	    function renderCost(service) {
	      var temp = "";
	      _(service).map(function (item) {
	        var cost = (0, _render2.default)(serviceLookupMultiRowsColumns, { value: item.estimatedCost });
	        temp = temp + cost;
	      });
	      return temp;
	    }
	
	    function serviceLookupSuccess(data) {
	      var asn = data.content;
	      serviceLookup.setData(asn);
	      serviceLookup.hideLoadingOverlay();
	    }
	
	    function errorFun(data) {
	      serviceLookup.hideLoadingOverlay();
	    }
	
	    // ############### Services lookup screen END ################## //
	
	
	    // ############### Packing lookup screen START ################## //
	    var packingLookup = new _index2.default({
	      dataContainer: els.asnPackingLookupMainArea, // area in example.html where data rows will go.
	      pagingContainer: els.asnPackingLookupPagingArea, // area in example.html where paging tab will go.
	      pageSizeOptions: pageSizeOptionsArray, // optional default:[10,25,50,100].
	      pageSize: 10, // optional default: 10.
	      data: packages,
	      showData: function showData(row) {
	        return (0, _render2.default)(packageLookupBody, {
	          packageName: row.packageName,
	          noOfPackages: row.noOfPackages,
	          dimensions: row.dimensions,
	          weight: row.weight,
	          lpns: row.lpns,
	          isPallet: isPallet,
	          isCustomCaseId: row.isCustomCaseId,
	          shippingPartner: asnShippingPartner,
	          dvlCalculatedValue: row.dvlCalculatedValue,
	          checkIfAsnShippingPalletsExists: checkIfAsnShippingPalletsExists
	        });
	      },
	      // onFetch function from line 42 to 50 is strictly for example only and should not be used anywhere. For real world scenario just pass response data to pagable.setData(). Line 51 to 54 needs to be there to add loading overlay effect to any page change and per page select change.
	      onFetch: function onFetch(page, pageSize) {
	        packingLookup.showLoadingOverlay();
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: asnDetailPackingLookupURL, success: packingLookupSuccess, error: errorFun, data: prepareDataToSendController(page, pageSize, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	
	    });
	
	    packingLookup.init();
	
	    function packingLookupSuccess(data) {
	      var asn = data.content;
	      // let page = data.page;
	      packingLookup.setData(asn);
	      packingLookup.hideLoadingOverlay();
	    }
	
	    function errorFun(data) {
	      packingLookup.hideLoadingOverlay();
	    }
	
	    function preparePackageProducts(page, pageSize, portletNamespace, packageName) {
	      var _data2;
	
	      portletNamespace = (0, _general.isPresent)(portletNamespace) ? portletNamespace : "";
	      var data = (_data2 = {}, _defineProperty(_data2, portletNamespace + "pageSize", pageSize), _defineProperty(_data2, portletNamespace + "page", page), _defineProperty(_data2, portletNamespace + "packageName", packageName), _data2);
	      return data;
	    }
	
	    function renderProducList(product) {
	      var productList = _(product).map(function (item) {
	        var productItem = (0, _render2.default)(packageLookupItem, {
	          sku: item.sku,
	          isPallet: isPallet,
	          prdName: item.prdName,
	          unitspercase: item.unitspercase,
	          totalUnits: item.totalUnits,
	          expirationDate: item.expirationDate,
	          lotNumber: item.lotNumber
	        });
	        return productItem;
	      });
	      return productList;
	    }
	
	    $('.packing').on('click', '.view-detail-btn-for-packing', function (e) {
	      e.preventDefault();
	      packingLookup.showLoadingOverlay();
	      var packageName = $(this).data('pallet-num');
	      setTimeout(function () {
	        (0, _filtersutil.doAjax)({ url: getPackageProductsURL, success: getPackageProductsSuccess, error: updatePackageProductsErrorFun(packingLookup), data: preparePackageProducts(0, 10, portletNamespace, packageName) });
	      }, _constants.SUCCESS_MODAL_TIMEOUT);
	
	      var modalForPackingDetail = $((0, _render2.default)(modalHtml, {
	        modalDialogClass: 'q-modal-dialog-800',
	        title: "" + packageName,
	        topCloseBtn: true,
	        autoHideTop: true,
	        leftAlignTitle: true,
	        body: renderModalBody(),
	        footerBtns: modalFooterForPackingDetailHtml
	      }));
	
	      function renderModalBody() {
	        return (0, _render2.default)(modalBodyForPackingDetailHtml, {
	          isPallet: isPallet,
	          lpns: getLpns()
	        });
	      }
	
	      function getLpns() {
	        var searchQuery = { "packageName": packageName, "isCustomCaseId": true };
	        var searchObj = _.where(packages.content, searchQuery)[0];
	        var returnVal = "";
	        if ((0, _general.isPresent)(searchObj)) {
	          returnVal = searchObj.lpns;
	        }
	        return returnVal;
	      }
	
	      var pagablePackingRow = void 0;
	      function getPackageProductsSuccess(data) {
	        packagePrductCount = data.totalElements;
	        $('body').append(modalForPackingDetail);
	        modalForPackingDetail.modal("show");
	        modalForPackingDetail.on('hidden.bs.modal', function (e) {
	          modalForPackingDetail.remove();
	        });
	        packingLookup.hideLoadingOverlay();
	        setPackingProductExportData(currentData, packageName);
	        pagablePackingRow = new _index2.default({
	          dataContainer: '.main-area-for-sub-row',
	          pagingContainer: '.paging-area-for-sub-row',
	          pageSizeOptions: pageSizeOptionsArray,
	          pageSize: 10,
	          data: data,
	          showData: function showData(row) {
	            return (0, _render2.default)(renderTemplateForPackingSubRowHtml, {
	              productName: row.sku,
	              description: row.prdName,
	              unitsInPallet: row.sentUnits,
	              totalUnits: row.totalUnits
	            });
	          },
	          onFetch: function onFetch(page, pageSize) {
	            pagablePackingRow.showLoadingOverlay();
	            setTimeout(function () {
	              (0, _filtersutil.doAjax)({ url: getPackageProductsURL, success: updatePackageProducts, error: updatePackageProductsErrorFun(pagablePackingRow), data: preparePackageProducts(page, pageSize, portletNamespace, packageName) });
	            }, _constants.SUCCESS_MODAL_TIMEOUT);
	          }
	        });
	        pagablePackingRow.init();
	      }
	
	      function updatePackageProducts(data) {
	        pagablePackingRow.setData(data.content);
	        pagablePackingRow.hideLoadingOverlay();
	      }
	
	      function updatePackageProductsErrorFun(componentEle) {
	        componentEle.hideLoadingOverlay();
	      }
	    });
	    // ############### Packing lookup screen END ################## //
	
	    // ############### Product lookup screen START ################## //
	    var productLookup = new _index2.default({
	      dataContainer: els.asnProductLookupMainArea, // area in example.html where data rows will go.
	      pagingContainer: els.asnProductLookupPagingArea, // area in example.html where paging tab will go.
	      pageSizeOptions: pageSizeOptionsArray, // optional default:[10,25,50,100].
	      pageSize: 10, // optional default: 10.
	      data: items,
	      showData: function showData(row) {
	        return (0, _render2.default)(productLookupBody, {
	          sku: row.sku,
	          noOfPackages: row.noOfPackages,
	          sentUnits: row.sentUnits,
	          prdName: row.prdName,
	          receivedUnits: row.receivedUnits,
	          upc: row.upc,
	          prdDesc: row.prdDesc
	        });
	      },
	      onFetch: function onFetch(page, pageSize) {
	        productLookup.showLoadingOverlay();
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: asnDetailProductLookupURL, success: productLookupSuccess, error: errorFun, data: prepareDataToSendController(page, pageSize, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	
	    });
	
	    productLookup.init();
	
	    function productLookupSuccess(data) {
	      var asn = data.content;
	      //let page = data.page;
	      productLookup.setData(asn);
	      productLookup.hideLoadingOverlay();
	    }
	
	    function errorFun(data) {
	      productLookup.hideLoadingOverlay();
	    }
	
	    // ############### Product lookup screen END ################## //
	
	    var productExportModal = new _filtersutil.buildExport();
	    var packingExportModal = new _filtersutil.buildExport();
	    var serviceExportModal = new _filtersutil.buildExport();
	    var packingProductExportModal = new _filtersutil.buildExport();
	
	    function initPackingProductExport() {
	      var cssClassNameForExportButtonOnPage = "packingPrdExportDataModal";
	      var cssClassNameForExportButtonOnPopup = "packingPrdExportBtn";
	      var cssClassNameForSelectFileTypeOnPopup = "packingPrdFileTypeClass";
	      var cssClassNameForCount = "packingPrdExportCountCSS";
	
	      var exportObj = {
	        title: "Products",
	        exportAttemptTextPart1Lang: el.data("export-attempt-text-part1"),
	        exportAttemptTextPart2Lang: el.data("export-attempt-text-part2"),
	        exportMaxLimitLang: el.data("export-max-row-limit"),
	        cssClassNameForExportButtonOnPage: cssClassNameForExportButtonOnPage,
	        cssClassNameForExportButtonOnPopup: cssClassNameForExportButtonOnPopup,
	        cssClassNameForSelectFileTypeOnPopup: cssClassNameForSelectFileTypeOnPopup,
	        cssClassNameForCount: cssClassNameForCount
	      };
	      packingProductExportModal.init(exportObj);
	      packingProductExportModal.bindExportEvent(portletNamespace, cssClassNameForExportButtonOnPopup, cssClassNameForSelectFileTypeOnPopup);
	    }
	
	    function initPackingExport() {
	      var cssClassNameForExportButtonOnPage = "packingExportDataModal";
	      var cssClassNameForExportButtonOnPopup = "packingExportBtn";
	      var cssClassNameForSelectFileTypeOnPopup = "packingFileTypeClass";
	      var cssClassNameForCount = "packingExportCountCSS";
	
	      var exportObj = {
	        title: "Packing",
	        exportAttemptTextPart1Lang: el.data("export-attempt-text-part1"),
	        exportAttemptTextPart2Lang: el.data("export-attempt-text-part2"),
	        exportMaxLimitLang: el.data("export-max-row-limit"),
	        cssClassNameForExportButtonOnPage: cssClassNameForExportButtonOnPage,
	        cssClassNameForExportButtonOnPopup: cssClassNameForExportButtonOnPopup,
	        cssClassNameForSelectFileTypeOnPopup: cssClassNameForSelectFileTypeOnPopup,
	        cssClassNameForCount: cssClassNameForCount
	      };
	      packingExportModal.init(exportObj);
	      packingExportModal.bindExportEvent(portletNamespace, cssClassNameForExportButtonOnPopup, cssClassNameForSelectFileTypeOnPopup);
	    }
	
	    function initProductExport() {
	      var cssClassNameForExportButtonOnPage = "productExportDataModal";
	      var cssClassNameForExportButtonOnPopup = "productExportBtn";
	      var cssClassNameForSelectFileTypeOnPopup = "productFileTypeClass";
	      var cssClassNameForCount = "productExportCountCSS";
	      var exportObj = {
	        title: "Products",
	        exportAttemptTextPart1Lang: el.data("export-attempt-text-part1"),
	        exportAttemptTextPart2Lang: el.data("export-attempt-text-part2"),
	        exportMaxLimitLang: el.data("export-max-row-limit"),
	        cssClassNameForExportButtonOnPage: cssClassNameForExportButtonOnPage,
	        cssClassNameForExportButtonOnPopup: cssClassNameForExportButtonOnPopup,
	        cssClassNameForSelectFileTypeOnPopup: cssClassNameForSelectFileTypeOnPopup,
	        cssClassNameForCount: cssClassNameForCount
	      };
	      productExportModal.init(exportObj);
	      productExportModal.bindExportEvent(portletNamespace, cssClassNameForExportButtonOnPopup, cssClassNameForSelectFileTypeOnPopup);
	    }
	
	    function initServiceExport() {
	      var cssClassNameForExportButtonOnPage = "serviceExportDataModal";
	      var cssClassNameForExportButtonOnPopup = "serviceExportBtn";
	      var cssClassNameForSelectFileTypeOnPopup = "serviceFileTypeClass";
	      var cssClassNameForCount = "serviceExportCountCSS";
	      var exportObj = {
	        title: "Services",
	        exportAttemptTextPart1Lang: el.data("export-attempt-text-part1"),
	        exportAttemptTextPart2Lang: el.data("export-attempt-text-part2"),
	        exportMaxLimitLang: el.data("export-max-row-limit"),
	        cssClassNameForExportButtonOnPage: cssClassNameForExportButtonOnPage,
	        cssClassNameForExportButtonOnPopup: cssClassNameForExportButtonOnPopup,
	        cssClassNameForSelectFileTypeOnPopup: cssClassNameForSelectFileTypeOnPopup,
	        cssClassNameForCount: cssClassNameForCount
	      };
	      serviceExportModal.init(exportObj);
	      serviceExportModal.bindExportEvent(portletNamespace, cssClassNameForExportButtonOnPopup, cssClassNameForSelectFileTypeOnPopup);
	    }
	
	    var productExportURL = el.data("product-export-url");
	    var serviceExportURL = el.data("service-export-url");
	    var packingExportURL = el.data("packing-export-url");
	    var packingProductExportURL = el.data("packing-product-export-url");
	
	    function setPackingProductExportData(currentData, packageName) {
	      packingProductExportModal.buildExportBasicURL(packingProductExportURL, currentData);
	      var url = packingProductExportModal.getCurrentUrl();
	      url = url + ["&" + portletNamespace + "asnShipmentId="] + asn.asnShipmentId + ["&" + portletNamespace + "packageName="] + packageName + ["&" + portletNamespace + "isPallet="] + isPallet;
	      packingProductExportModal.buildExportBasicURL(url, currentData, portletNamespace);
	      packingExportModal.setExportCount(packagePrductCount, "packingPrdExportCountCSS");
	    }
	
	    function setPackingExportData(currentData) {
	      packingExportModal.buildExportBasicURL(packingExportURL, currentData);
	      var url = packingExportModal.getCurrentUrl();
	      url = url + ["&" + portletNamespace + "asnShipmentId="] + asn.asnShipmentId;
	      packingExportModal.buildExportBasicURL(url, currentData, portletNamespace);
	      packingExportModal.setExportCount(pacakgeTotalCount, "packingExportCountCSS");
	    }
	
	    function setProductExportData(currentData) {
	      productExportModal.buildExportBasicURL(productExportURL, currentData);
	      var url = productExportModal.getCurrentUrl();
	      url = url + ["&" + portletNamespace + "asnShipmentId="] + asn.asnShipmentId;
	      productExportModal.buildExportBasicURL(url, currentData, portletNamespace);
	      productExportModal.setExportCount(productTotalCount, "productExportCountCSS");
	    }
	
	    function setServiceExportData(currentData) {
	      serviceExportModal.buildExportBasicURL(serviceExportURL, currentData);
	      var url = serviceExportModal.getCurrentUrl();
	      url = url + ["&" + portletNamespace + "asnShipmentId="] + asn.asnShipmentId;
	      serviceExportModal.buildExportBasicURL(url, currentData, portletNamespace);
	      serviceExportModal.setExportCount(serviceTotalCount, "serviceExportCountCSS");
	    }
	
	    var currentData = {};
	    initPackingExport();
	    setPackingExportData(currentData);
	
	    initServiceExport();
	    setServiceExportData(currentData);
	
	    initProductExport();
	    setProductExportData(currentData);
	
	    initPackingProductExport();
	  }
	
	  els.iUnderstandBtn.click(function () {
	    location.href = understandBtnUrl;
	  });
	
	  function showCancelShipmentBtn() {
	    els.cancelShipmentBtn.show();
	  }
	
	  function showEditShipmentBtn() {
	    els.editShipmentBtn.show();
	  }
	
	  function hideCancelShipmentBtn() {
	    els.cancelShipmentBtn.hide();
	  }
	
	  function hideEditShipmentBtn() {
	    els.editShipmentBtn.hide();
	  }
	
	  els.editShipmentBtn.click(function () {
	    editAsn();
	  });
	
	  els.pencilIcon.on('click', function () {
	    editAsn();
	  });
	
	  els.returnToShipmentsBtn.click(function () {
	    if (shouldCheckCache === true) {
	      window.history.go(-1);
	      return false;
	    } else {
	      location.href = viewAsnUrl;
	    }
	  });
	
	  function editAsn() {
	    location.href = "" + editAsnUrl;
	  }
	
	  els.cancelShipmentBtn.on("click", function () {
	    els.cancelModal.modal("show");
	  });
	
	  els.modalCancelAsnBtn.click(function () {
	    cancelAsn();
	  });
	
	  function cancelAsn() {
	    submitModalFlow.showLoadingModal();
	    $.ajax({
	      url: cancelAsnUrl,
	      type: "POST",
	      data: _defineProperty({}, namespace + "asnId", asn.asnId),
	      success: onCancelSuccess,
	      error: onCancelError
	    });
	  }
	
	  function onCancelSuccess(data) {
	    if (data.match("success")) {
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        location.reload();
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else if (data.match("Receiving") || data.match("Complete")) {
	      $("#modalTextLine1").html(cancelErrorMsg1 + " <b class=\"text-info\"> " + _.escape(asn.asnShipmentId) + " </b> " + cancelErrorMsg2);
	      els.errorModal.modal("show");
	    } else {
	      alert(generalErrorMessage);
	    }
	  }
	
	  function onCancelError(data) {
	    alert(generalErrorMessage);
	  }
	
	  els.printLabelsBtn.click(function () {
	    window.open(generateAsnLabelsUrl + "&" + namespace + "fileName=packages.pdf", 'window1');
	  });
	
	  els.printFedExLabelsBtn.click(function () {
	    var fedexShippingLables = window.open(generateFedExShippingLabelsUrl + "&" + namespace + "fileName=fedexShippingLables.pdf", 'fedexShippingLables');
	    fedexShippingLables.document.title = 'FedEx Shipping Labels';
	  });
	
	  els.printBolBtn.click(function () {
	    var bolWindow = window.open(generateBOLLabelUrl + "&" + namespace + "fileName=bol.pdf", 'bolWindow');
	    bolWindow.document.title = 'Bill of Lading (BOL)';
	  });
	}

/***/ },
/* 554 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    title: "Cancel",
	    cls: "bulk-cancel-asn",
	    icon: "paper-plane-o",
	    disabled: true
	  }],
	  "actions": [{
	    title: "Cancel",
	    cls: "cancel-asn",
	    icon: "ban",
	    disabled: false
	  }, {
	    title: "Edit",
	    cls: "edit-asn",
	    icon: "pencil",
	    disabled: false
	  }]
	};

/***/ },
/* 555 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var asnLookupFieldDropdown = exports.asnLookupFieldDropdown = [{
	  title: "Shipment ID",
	  value: "shipmentId"
	}, {
	  title: "Tracking Number",
	  value: "trackingNumber"
	}, {
	  title: "BOL",
	  value: "bol"
	}, {
	  title: "Product Name (SKU)",
	  value: "productName"
	}, {
	  title: "Origin Location Name",
	  value: "originLocationName"
	}, {
	  title: "Quote ID",
	  value: "quoteId"
	}];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(543);
	
	__webpack_require__(553);
	
	__webpack_require__(557);

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _lookupFieldDropdown = __webpack_require__(555);
	
	var _actionOptions = __webpack_require__(554);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	var detailLinkHTML = __webpack_require__(84);
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	
	var targetSelector = "#asn-lookup-outer";
	(0, _run2.default)(targetSelector, function () {
	  var dataTableComponentData = $(targetSelector).data("asn-lookup-data");
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var savedViews = $(targetSelector).data("saved-views");
	  var asnPortletEditPerm = $(targetSelector).data("asn-portlet-edit-perm");
	  var viewAsnRenderUrl = $(targetSelector).data("asn-detail-url");
	  var portletNamespace = $(targetSelector).data("portlet-namespace");
	  var filterURL = $(targetSelector).data("filter-url");
	  var saveViewURL = $(targetSelector).data("save-view-url");
	  var deleteViewURL = $(targetSelector).data("delete-view-url");
	  var targetObject = "";
	  var selectedRows = "";
	  var exportModal = new _filtersutil.buildExport();
	  var exportUrl = $(targetSelector).data("export-url");
	  var editASNUrl = $(targetSelector).data("edit-asn-url");
	  var cancelASNUrl = $(targetSelector).data("cancel-asn-url");
	  var bulkCancelASNUrl = $(targetSelector).data("bulk-cancel-asn-url");
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	
	  var asnLookup = new _index2.default({
	
	    target: $("#asn-lookup-wrapper"),
	
	    minWidthClass: "q-min-width-sm-til-md",
	
	    mobileColumns: [{
	      data: "asnShipmentId",
	      title: "Shipment ID",
	      render: createDetailLink
	    }, {
	      data: "asnType",
	      title: "Shipment Type"
	    }, {
	      data: "asnStatus",
	      title: "Shipment Status"
	    }, {
	      data: "destination",
	      title: "Destination"
	    }],
	
	    // REQUIRED: search input info
	    tableSearchInput: {
	      value: targetObject != "" ? targetObject.value[0] : ""
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _lookupFieldDropdown.asnLookupFieldDropdown
	    },
	    // OPTIONAL: Set Saved View Array
	    savedViews: savedViews,
	    bulkSelect: true,
	
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      // Not required, just to show you can
	      columnDefs: [{ className: "custom-class", targets: [1] }],
	      // Not required, just to show you can
	      order: [[6, 'desc']],
	      columns: [{
	        data: "asnStatus",
	        render: renderActionWrap,
	        orderable: false,
	        class: "dtc-action-column"
	      }, {
	        data: "asnShipmentId",
	        title: "Shipment ID",
	        render: createDetailLink,
	        class: "dtc-min-width-sm"
	      }, {
	        data: "skuCount",
	        title: "Total SKUs/Units",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "asnType",
	        title: "Shipment Type",
	        render: renderAsnType,
	        class: "dtc-min-width-md"
	      }, {
	        data: "asnStatus",
	        title: "Shipment Status",
	        class: 'dtc-min-width-sm',
	        render: _filtersutil.statusPillRender
	      }, {
	        data: "asnCreatedDate",
	        title: "Date Created",
	        render: formateDate,
	        class: "dtc-min-width-md"
	      }, {
	        data: "destination",
	        title: "Destination",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }]
	    },
	
	    paginationData: dataTableComponentData.page,
	
	    filterModal: {
	      title: "Filter Shipments",
	      tableType: "asn"
	    },
	
	    onBulkSelectChange: function onBulkSelectChange() {
	      selectedRows = asnLookup.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass('disabled');
	      } else {
	        $(".action-header-btn .base-btn").addClass('disabled');
	      }
	    },
	
	    onFetch: function onFetch() {
	      var currentData = asnLookup.generateData();
	      asnLookup.showLoadingOverlay();
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterURL, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  function filterSuccessFun(data) {
	
	    var asn = data.content;
	    var page = data.page;
	    asnLookup.setNewData(asn);
	    asnLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    asnLookup.hideLoadingOverlay();
	    setExportData(asnLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var asn = data.lookupASNJSON.content;
	    var page = data.lookupASNJSON.page;
	    asnLookup.setNewData(asn);
	    asnLookup.setPaginationData(page);
	    asnLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    asnLookup.hideLoadingOverlay();
	    setExportData(asnLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var asn = data.lookupASNJSON.content;
	    var page = data.lookupASNJSON.page;
	    asnLookup.setNewData(asn);
	    asnLookup.setPaginationData(page);
	    asnLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    asnLookup.hideLoadingOverlay();
	    setExportData(asnLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var asn = data.lookupASNJSON.content;
	    var page = data.lookupASNJSON.page;
	    asnLookup.removeSavedView(data.target);
	    asnLookup.setNewData(asn);
	    asnLookup.setPaginationData(page);
	    asnLookup.hideLoadingOverlay();
	    setExportData(asnLookup.generateData());
	  }
	
	  function errorFun(data) {
	    asnLookup.hideLoadingOverlay();
	  }
	
	  asnLookup.init();
	
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = _actionOptions.actionOptions["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    var statusTarget = _actionOptions.actionOptions['all'];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = void 0;
	    renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: checkDisableForGivenAction(data, row, item.title)
	      });
	    });
	    return renderedList.join('');
	  }
	
	  function checkDisableForGivenAction(data, row, actionName) {
	    if (isRowLevelActionCheck(data)) {
	      return callBusinessLogicToDisableAction(data, row, actionName);
	    } else {
	      var isTrue = false;
	      _(selectedRows).map(function (item) {
	        if (callBusinessLogicToDisableAction(item.data.asnStatus, item.data, actionName)) {
	          if (!isTrue) {
	            isTrue = true;
	          }
	        }
	      });
	      return isTrue;
	    }
	  }
	
	  function isRowLevelActionCheck(data) {
	    return (0, _general.isPresent)(data);
	  }
	
	  function callBusinessLogicToDisableAction(data, row, actionName) {
	    if (row.asnType === "T") {
	      //No edit for warehouse transfer
	      return true;
	    } else if (row.asnType === "R") {
	      if (actionName == "Edit") {
	        return true;
	      } else if (data === "Canceled" || data === "Complete" || data === "Receiving") {
	        return true;
	      } else if (actionName == "Cancel") {
	        return false;
	      }
	    } else {
	      if (asnPortletEditPerm === false) {
	        return true;
	      } else if (data === "Planned" || data === "In Transit") {
	        if (data === "In Transit" && actionName == "Edit") {
	          return true;
	        } else if (row.canEditGtlAsn) {
	          return false;
	        } else if (actionName == "Cancel") {
	          return true;
	        }
	      } else {
	        return true;
	      }
	    }
	  }
	
	  function formateDate(createdDate, type, data) {
	    if (createdDate != null && createdDate != "") {
	      var date = new Date(createdDate); //createdDate is long time format
	      var month = date.getMonth() + 1;
	      var today = new Date();
	      var oneDay = 24 * 60 * 60 * 1000;
	      today.setHours(0, 0, 0, 0);
	      date.setHours(0, 0, 0, 0);
	      var diffDays = Math.round(Math.abs((today.getTime() - date.getTime()) / oneDay));
	      var friendlyText = "";
	      var datePillHTML = "";
	      if (diffDays < 100) {
	        friendlyText = diffDays.toString() + ' Days Ago';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      }
	      if (diffDays == 0) {
	        friendlyText = 'Today';
	      } else if (diffDays == 1) {
	        friendlyText = 'Yesterday';
	      }
	      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
	    } else {
	      return "";
	    }
	  }
	
	  function createDetailLink(data, type, row) {
	    var detailPageHTML = (0, _render2.default)(detailLinkHTML, {
	      renderURL: viewAsnRenderUrl,
	      portletNamespace: portletNamespace,
	      id: row.asnId,
	      idName: "asnId",
	      displayVal: row.asnShipmentId
	    });
	    return detailPageHTML;
	  }
	
	  function renderAsnType(data, type, row) {
	    if (row.asnType === "R") {
	      return "Return";
	    } else if (row.asnType === "P") {
	      return "Inbound";
	    } else if (row.asnType === "T") {
	      return "Transfer";
	    } else {
	      return "";
	    }
	  }
	
	  function initExport() {
	    var exportObj = {
	      title: $(targetSelector).data("export-popup-title"),
	      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
	      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent(portletNamespace);
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(exportUrl, currentData, portletNamespace);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  $('body').on('click', '.edit-asn', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      var asn = row.data();
	      location.href = editASNUrl + '&' + portletNamespace + 'asnId=' + asn.asnId;
	    }
	  });
	
	  $('body').on('click', '.cancel-asn ', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      $("#cancelModal").appendTo("body").data('row', row).modal("show");
	    }
	  });
	
	  $('#modalCancelAsn').click(function () {
	    var row = $('#cancelModal').data('row');
	    submitModalFlow.showLoadingModal();
	    cancelAsn(row, row.data());
	  });
	
	  function cancelAsn(row, asn) {
	    $.ajax({
	      url: cancelASNUrl,
	      type: 'POST',
	      data: _defineProperty({}, portletNamespace + 'asnId', asn.asnId),
	      success: function success(data) {
	        if (data.match("success")) {
	          var d = row.data();
	          d.asnStatus = "Canceled";
	          row.data(d).draw();
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            submitModalFlow.hideAllModals();
	          }, _constants.SUCCESS_MODAL_TIMEOUT);
	        }
	      },
	      error: function error(data) {
	        submitModalFlow.hideAllModals();
	      }
	    });
	  }
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  $('body').on('click', '.bulk-cancel-asn', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      $("#bulkCancelModal").modal("show");
	    }
	  });
	
	  $('#modalBulkCancelAsn').click(function () {
	    submitModalFlow.showLoadingModal();
	    bulkCancelASN();
	  });
	
	  function bulkCancelASN(row, asn) {
	    $.ajax({
	      url: bulkCancelASNUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: _defineProperty({}, portletNamespace + 'asnId', getAllSelectedAsnIds()),
	      success: function success(data) {
	        if (data.response === "success") {
	          _(selectedRows).map(function (item) {
	            var currentRow = $(".data-table-component").dataTable().api().row(item.rowIndex);
	            var d = currentRow.data();
	            d.asnStatus = "Canceled";
	            currentRow.data(d).draw();
	          });
	          setTimeout(function () {
	            submitModalFlow.hideAllModals();
	          }, _constants.SUCCESS_MODAL_TIMEOUT);
	        }
	      },
	      error: function error(data) {
	        submitModalFlow.hideAllModals();
	      }
	    });
	  }
	
	  function getAllSelectedAsnIds() {
	    var asnIds = new Array();
	    _(selectedRows).map(function (item) {
	      asnIds.push(item.data.asnId);
	    });
	    return JSON.stringify(asnIds);
	  }
	
	  initExport();
	  setExportData(asnLookup.generateData());
	
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	__webpack_require__(1106);
	
	var invoiceRowHtml = __webpack_require__(1259);
	var noInvoicesRowHtml = __webpack_require__(1260);
	var emailLineHtml = __webpack_require__(1258);
	
	(0, _run2.default)("#billing-management-page", function () {
	  var INITIAL_NUMBER_OF_ROWS = 5;
	  var LOAD_MORE_INCREMENT = 5;
	  var MAX_DISPLAY = 15;
	  var MAX_CC_EMAILS = 3;
	
	  var billingManagementPage = (0, _jquery2.default)("#billing-management-page");
	  var invoicesTableBody = (0, _jquery2.default)("#invoices-table-body");
	  var loadMoreBtn = (0, _jquery2.default)("#load-more-btn");
	  var allLoadedMessage = (0, _jquery2.default)("#all-loaded-message");
	  var invoiceInquiryModal = (0, _jquery2.default)("#invoice-inquiry-modal");
	  var invoiceContent = (0, _jquery2.default)("#invoiceText");
	  var emailContainer = (0, _jquery2.default)(".email-rows-container");
	  var addRecipientBtn = (0, _jquery2.default)("#add-recipient-btn");
	  var inquirySubmitBtn = (0, _jquery2.default)("#inquiry-modal-submit-btn");
	
	  var getInvoiceUrl = billingManagementPage.data("get-invoice-url");
	  var sendInvoiceInquiryUrl = billingManagementPage.data("send-invoice-inquiry-url");
	  var invoices = billingManagementPage.data("invoices");
	
	  var numberOfInvoices = invoices.length;
	  var numberOfDisplayedInvoices = 0;
	  var numberOfEmailRows = 0;
	  var inquiryInvoiceNumber = void 0;
	  var inquiryInvoiceDate = void 0;
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  initializePage();
	
	  function initializePage() {
	    if (numberOfInvoices === 0) {
	      invoicesTableBody.append(noInvoicesRowHtml);
	    } else {
	      buildInvoiceTableRows(0, getEndIndex(0, INITIAL_NUMBER_OF_ROWS));
	    }
	    setLoadMoreBtnDisplay();
	  }
	
	  function getEndIndex(start, offset) {
	    var end = start + offset;
	    return numberOfInvoices < end ? numberOfInvoices : end;
	  }
	
	  function buildInvoiceTableRows(start, end) {
	    var invoiceRange = _underscore2.default.range(start, end);
	    _underscore2.default.each(invoiceRange, addInvoiceRow);
	  }
	
	  function addInvoiceRow(invoiceIndex) {
	    var invoice = invoices[invoiceIndex];
	    var htmlTemplate = _underscore2.default.template(invoiceRowHtml);
	    var pillColor = getPillColor(invoice.status);
	    var params = {
	      invoiceId: invoice.invoiceId,
	      invoiceNumber: invoice.invoiceNumber,
	      invoiceDate: invoice.invoiceDate,
	      dueDate: invoice.dueDate,
	      amountDue: invoice.amountDue,
	      remaining: invoice.balance,
	      status: invoice.status,
	      pdfUrl: invoice.pdfFileUrl,
	      pillColor: pillColor
	    };
	    invoicesTableBody.append(htmlTemplate(params));
	    numberOfDisplayedInvoices++;
	  }
	
	  function getPillColor(status) {
	    if (status === "Paid") {
	      return "q-pill-blue";
	    } else {
	      return "q-pill-white-and-blue";
	    }
	  }
	
	  function getInvoicePdf(invoiceId, pdfUrl) {
	    var url = getInvoiceUrl.concat("&fileName=Invoice.pdf&invoiceId=" + invoiceId + "&pdfUrl=" + pdfUrl);
	    var labelWindow = window.open(url, 'labelWindow');
	    labelWindow.document.title = 'Invoice';
	  }
	
	  function getEmailRecipients() {
	    var emailRecipients = [];
	    (0, _jquery2.default)(".email-recipient").each(function () {
	      emailRecipients.push((0, _jquery2.default)(this).val());
	    });
	    return emailRecipients;
	  }
	
	  function setLoadMoreBtnDisplay() {
	    numberOfDisplayedInvoices < MAX_DISPLAY && numberOfDisplayedInvoices < numberOfInvoices ? loadMoreBtn.show() : loadMoreBtn.hide();
	  }
	
	  function setAllLoadedMessageDisplay() {
	    numberOfDisplayedInvoices === MAX_DISPLAY ? allLoadedMessage.show() : allLoadedMessage.hide();
	  }
	
	  function setAddRecipientBtnDisplay() {
	    numberOfEmailRows === MAX_CC_EMAILS ? addRecipientBtn.hide() : addRecipientBtn.show();
	  }
	
	  loadMoreBtn.click(function (e) {
	    e.preventDefault();
	    buildInvoiceTableRows(numberOfDisplayedInvoices, getEndIndex(numberOfDisplayedInvoices, LOAD_MORE_INCREMENT));
	    setLoadMoreBtnDisplay();
	    setAllLoadedMessageDisplay();
	  });
	
	  addRecipientBtn.click(function (e) {
	    e.preventDefault();
	    emailContainer.append(emailLineHtml);
	    numberOfEmailRows++;
	    setAddRecipientBtnDisplay();
	  });
	
	  inquirySubmitBtn.click(function (e) {
	    e.preventDefault();
	    invoiceInquiryModal.modal('hide');
	    submitModalFlow.showLoadingModal();
	    submitInquiry();
	  });
	
	  (0, _jquery2.default)(document).on("click", '.get-invoice-link', function (e) {
	    e.preventDefault();
	    var invoiceId = (0, _jquery2.default)(this).data('invoice-id');
	    var pdfUrl = (0, _jquery2.default)(this).data('pdf-url');
	    getInvoicePdf(invoiceId, pdfUrl);
	  });
	
	  (0, _jquery2.default)(document).on('click', '.send-inquiry-link', function (e) {
	    e.preventDefault();
	    inquiryInvoiceNumber = (0, _jquery2.default)(this).data('invoice-number');
	    inquiryInvoiceDate = (0, _jquery2.default)(this).data('invoice-date');
	    invoiceInquiryModal.modal('show');
	    emailContainer.empty();
	    invoiceContent.val('');
	    numberOfEmailRows = 0;
	    addRecipientBtn.show();
	  });
	
	  (0, _jquery2.default)(document).on('click', '.remove-email-row', function (e) {
	    e.preventDefault();
	    (0, _jquery2.default)(this).parent().closest('div').remove();
	    numberOfEmailRows--;
	    setAddRecipientBtnDisplay();
	  });
	
	  function submitInquiry() {
	    var emailRecipients = getEmailRecipients();
	    _jquery2.default.ajax({
	      global: false,
	      url: sendInvoiceInquiryUrl,
	      type: 'POST',
	      data: {
	        inquiryContent: invoiceContent.val(),
	        invoiceNumber: inquiryInvoiceNumber,
	        invoiceDate: inquiryInvoiceDate,
	        extraRecipients: emailRecipients
	      },
	      success: submitInquirySuccess,
	      error: submitInquiryError
	    });
	  }
	
	  function submitInquirySuccess() {
	    submitModalFlow.showSuccessModal();
	    setTimeout(function () {
	      submitModalFlow.hideAllModals();
	    }, _constants.SUCCESS_MODAL_TIMEOUT);
	  }
	
	  function submitInquiryError() {
	    submitModalFlow.setErrors({
	      errorTitle: "Err-System-001",
	      errorDescription: "There was a system error while processing the request."
	    });
	    submitModalFlow.showFailureModal();
	  }
	});

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(558);

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1080);

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = bulkUploadCsvFiles;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _QuickFileUploader = __webpack_require__(85);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var modalHtml = __webpack_require__(11);
	function bulkUploadCsvFiles(targetSelector) {
	
	  var outerEl = $(targetSelector);
	  var bulkUploadCsvForm = outerEl.find("#bulk-upload-csv-form");
	  var uploadFileButton = outerEl.find(".upload-file");
	  var selectFileButton = outerEl.find(".select-file-btn");
	  var csvFileUpload = outerEl.find(".file-uploader");
	  var uploadFileUrl = outerEl.data("upload-csv-url");
	  var viewBulkUploadDetailUrl = outerEl.data("bulk-upload-details-url");
	  var serviceCenterHelpUrl = outerEl.data("service-center-url");
	  var bulkUploadId = outerEl.find("#bulk-upload-id");
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  var quickFile = (0, _QuickFileUploader.quickFileUploader)(csvFileUpload, {
	    afterReadFile: function afterReadFile(e, result) {
	      uploadFileButton.removeClass("disabled");
	    }
	  });
	
	  var csvUploadSuccessModal = $((0, _render2.default)(modalHtml, {
	    title: ' About Your Upload',
	    leftAlignTitle: true,
	    body: '<div class="q-pad-all-xl">  Your bulk upload has been submitted. Go to the detail summary for this upload where you will be able to view its statuses and manage error files that may occur. You may also close this modal to upload additional files. </div>',
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: "\n        <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Close</a>\n        <a href=\"#\" class=\"base-btn purple-btn custom-submit-btn bulk-upload-details\">Go to Details</a>\n      "
	  }));
	
	  var fileFormatErrorModal = $((0, _render2.default)(modalHtml, {
	    title: 'File Format Error',
	    leftAlignTitle: true,
	    body: '<div class="q-pad-all-xl"> The file you have uploaded is an invalid file format and only .CSV files are currently accepted. You may download the approved CSV template above.</div>',
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: "\n        <a href=\"#\" class=\"base-btn purple-btn modal-auto-hide\">Close</a>\n      "
	  }));
	
	  var fileSizeErrorModal = $((0, _render2.default)(modalHtml, {
	    title: 'File Size Error',
	    leftAlignTitle: true,
	    body: '<div class="q-pad-all-xl">The file selected exceeds the required file size. Please limit your file to be no larger than 5 MB and try uploading again.</div>',
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: "\n        <a href=\"#\" class=\"base-btn purple-btn modal-auto-hide\">Close</a>\n      "
	  }));
	
	  var duplicateFileErrorModal = $((0, _render2.default)(modalHtml, {
	    title: 'Duplicate File Warning',
	    leftAlignTitle: true,
	    body: '<div class="q-pad-all-xl"> A file with the same name has been previously uploaded. Please check that this is not in error as you may be creating duplicate entries within in your system.</div>',
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: "\n        <a href=\"#\" class=\"base-btn purple-btn custom-submit-btn continue-upload\">Continue Upload</a>\n        <a href=\"#\" class=\"base-btn purple-btn purple-btn modal-auto-hide\">Cancel Upload</a>\n      "
	  }));
	
	  uploadFileButton.on('click', function (e) {
	    var fileName = quickFile.getFile().name;
	    var file = $("#info-img-hidden")[0].files[0];
	    var formData = new FormData();
	    formData.append("fileName", file);
	    var fileExtension = fileName.split('.').pop().toLowerCase();
	    if (fileExtension != 'csv') {
	      fileFormatErrorModal.modal("show");
	    } else if (file.size > _constants.MAX_FILE_SIZE) {
	      fileSizeErrorModal.modal("show");
	    } else {
	      $.ajax({
	        url: uploadFileUrl,
	        type: 'POST',
	        data: formData,
	        enctype: "multipart/form-data",
	        processData: false,
	        contentType: false,
	        dataType: "json",
	        success: function success(resp) {
	          if (resp.data && resp.data != null && resp.data != 'null') {
	            if (resp.data == 'Y') {
	              duplicateFileErrorModal.modal("show");
	            } else {
	              bulkUploadId.val(resp.data);
	              csvUploadSuccessModal.modal("show");
	            }
	          }
	        },
	        error: function error(xhr, status, _error) {
	          submitModalFlow.showFailureModal();
	        }
	      });
	    }
	  });
	
	  $(document).on("click", '.continue-upload', function (e) {
	    var fileName = quickFile.getFile();
	    var formData = new FormData();
	    formData.append("fileName", $("#info-img-hidden")[0].files[0]);
	    $.ajax({
	      url: uploadFileUrl + "&duplicateFile=Y",
	      type: 'POST',
	      data: formData,
	      enctype: "multipart/form-data",
	      processData: false,
	      contentType: false,
	      dataType: 'json',
	      success: function success(resp) {
	        if (resp.data && resp.data != null && resp.data != 'null') {
	          bulkUploadId.val(resp.data);
	          csvUploadSuccessModal.modal("show");
	          duplicateFileErrorModal.modal("hide");
	        }
	      },
	      error: function error(xhr, status, _error2) {
	        submitModalFlow.showFailureModal();
	      }
	    });
	  });
	
	  $(document).on("click", '.bulk-upload-details', function (e) {
	    var bupUuid = bulkUploadId.val();
	    location.href = viewBulkUploadDetailUrl + "&bupId=" + bupUuid;
	  });
	
	  $(document).on("click", '#redirectInstructionspage', function (e) {
	    window.open(serviceCenterHelpUrl);
	  });
	}

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = attachBulkUploadDataTable;
	
	var _initialData = __webpack_require__(566);
	
	var _lookupTable = __webpack_require__(19);
	
	var _lookupTable2 = _interopRequireDefault(_lookupTable);
	
	var _general = __webpack_require__(5);
	
	var _modal = __webpack_require__(11);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _exportBody = __webpack_require__(1262);
	
	var _exportBody2 = _interopRequireDefault(_exportBody);
	
	var _exportFooter = __webpack_require__(1263);
	
	var _exportFooter2 = _interopRequireDefault(_exportFooter);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	function attachBulkUploadDataTable(targetSelector) {
	  // START: REQUIRED TO LOAD STUB
	  var outerEl = $(targetSelector);
	  var exportBtn = outerEl.find('.btn-export');
	  //const exportModal = $("#exportModal");
	
	
	  // const entryEl = $("<div class='entry-point'></div>");
	  var mainEl = outerEl.find('.bulk-upload-datatable');
	  // outerEl.html(entryEl);
	  // entryEl.append(mainEl);
	  var itemData = mainEl.data('bulkupload-records');
	  var filterData = mainEl.data('filter-dta');
	
	  var generateExportUrl = mainEl.data("export-url");
	  var onFetchUrl = mainEl.data('onfetch-url');
	  var exportModal = $((0, _render2.default)(_modal2.default, {
	    title: 'Export bulk upload',
	    leftAlignTitle: true,
	    modalDialogClass: "q-modal-dialog-500",
	    body: (0, _render2.default)(_exportBody2.default),
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: (0, _render2.default)(_exportFooter2.default)
	
	  }));
	
	  outerEl.append(exportModal);
	  var exportModalButton = exportModal.find(".modalExportData");
	  var dataFileType = exportModal.find("#dataFileType");
	  var bulkLookupTable = new _lookupTable2.default({
	    target: $(".bulk-upload-table"),
	    minWidthClass: "q-min-width-md-til-md",
	    mobileColumns: [{
	      data: "bupDisplayId",
	      title: "Upload ID",
	      linkKey: "lookupTableActionLink"
	    }, {
	      data: "type",
	      title: "Upload Type"
	    }, {
	      data: "status",
	      title: "Status",
	      render: _initialData.statusPillRender
	    }],
	    tableFilters: {
	      data: filterData
	    },
	    tableSearchInput: {
	      placeholder: 'Search Upload ID or Upload Type or Bulk Display Id'
	    },
	    tableSearchDropdown: {
	      columns: [{
	        data: "bupDisplayId",
	        title: "Upload ID",
	        value: "bupDisplayId"
	      }, {
	        data: "type",
	        title: "Upload Type",
	        value: "type"
	      }]
	    },
	    dataTable: {
	      order: [[3, 'desc']],
	      data: itemData.bulkUpload,
	      columns: _initialData.columnData
	
	    },
	    tableColumnModal: {
	      data: _initialData.columnData
	    },
	    paginationData: {
	      size: itemData.bulkUpload.length,
	      number: itemData.pageNumber,
	      totalElements: itemData.totalElements,
	      totalPages: itemData.totalPages
	    },
	    filterModal: {
	      title: "Filter Bulk Uploads",
	      tableType: "inbound shipments"
	    },
	    onFetch: function onFetch() {
	
	      bulkLookupTable.showLoadingOverlay();
	      var currentData = bulkLookupTable.generateData();
	      var size = 10;
	      if (!isNaN(currentData["size"])) {
	        size = currentData["size"];
	      }
	      var tempUrl = onFetchUrl + "&size=" + size;
	
	      setTimeout(function () {
	        $.ajax({
	          url: buildUrl(currentData, tempUrl),
	          success: function success(data) {
	            data = JSON.parse(data);
	            bulkLookupTable.setNewData(data.bulkUpload);
	            bulkLookupTable.setPaginationData({
	              number: data.pageNumber,
	              totalElements: data.totalElements,
	              totalPages: data.totalPages,
	              size: size
	            });
	            bulkLookupTable.hideLoadingOverlay();
	            (0, _filtersutil.pushFilterSessionCacheState)();
	          },
	          error: function error(_error) {
	            bulkLookupTable.hideLoadingOverlay();
	          }
	        });
	      }, _constants.SUCCESS_MODAL_TIMEOUT);
	    }
	
	  });
	  bulkLookupTable.init();
	
	  function buildUrl(currentData, baseUrl) {
	    var startDate = (0, _filtersutil.readSpecificKeyFromSearchCriteria)(currentData["searchCriteria"], 'startDate');
	    var endDate = (0, _filtersutil.readSpecificKeyFromSearchCriteria)(currentData["searchCriteria"], 'endDate');
	    var fixedRangeDate = (0, _filtersutil.readSpecificKeyFromSearchCriteria)(currentData["searchCriteria"], 'fixedRange');
	    var revisedSearchCriteria = (0, _filtersutil.alterSearchCriteriForController)(currentData["searchCriteria"]);
	    var orderBy = currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"];
	    var pageNumber = (0, _general.isPresent)(currentData["number"]) ? currentData["number"] : 0;
	    var dateRange = "";
	    var searchCriteria = _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);
	
	    if ((0, _general.isPresent)(startDate)) {
	      dateRange = dateRange + "&startDate=" + startDate;
	    }
	    if ((0, _general.isPresent)(endDate)) {
	      dateRange = dateRange + "&endDate=" + endDate;
	    }
	    if (orderBy == 'type') {
	      orderBy = 'bupUploadType';
	    }
	
	    if (orderBy == 'status') {
	      orderBy = 'bupStatus';
	    }
	
	    if (orderBy == 'createdTimeStamp') {
	      orderBy = 'bupCreatedDate';
	    }
	
	    if (orderBy == 'bulkUploadId') {
	      orderBy = 'bupId';
	    }
	
	    return baseUrl + dateRange + "&fixedRange=" + fixedRangeDate + "&orderBy=" + orderBy + "&orderByType=" + currentData["sortType"] + "&searchCriteria=" + searchCriteria + "&page=" + pageNumber;
	  }
	
	  exportBtn.on('click', function (e) {
	    e.preventDefault();
	    exportModal.modal("show");
	  });
	
	  exportModalButton.click(function () {
	    exportModal.modal("hide");
	    var fileType = dataFileType.val();
	    exportToFile(fileType);
	  });
	
	  dataFileType.change(function () {
	    exportModalButton.attr('disabled', false);
	  });
	
	  var exportToFile = function exportToFile(fileType) {
	    var currentData = bulkLookupTable.generateData();
	    var tempUrl = generateExportUrl + "&fileType=" + fileType + "&size=1000";
	
	    var url = buildUrl(currentData, tempUrl);
	    window.open(url);
	  };
	}

/***/ },
/* 563 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = attachBulkUploadDeailview;
	function attachBulkUploadDeailview(targetSelector) {}

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _index = __webpack_require__(86);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _index3 = __webpack_require__(10);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderTemplateForProductsHtml = __webpack_require__(1267);
	var renderTemplateForOrdersHtml = __webpack_require__(1266);
	var renderTemplateForBundlesHtml = __webpack_require__(1265);
	var renderTemplateForAMLHtml = __webpack_require__(1264);
	var renderTemplateForRMAHtml = __webpack_require__(1268);
	var renderTemplateForRulesHtml = __webpack_require__(1269);
	//import {initialDataForProducts} from "./initialDetails";
	
	(0, _run2.default)("#bulkUpload-details-page", function () {
		var outerEl = (0, _jquery2.default)("#bulkUpload-details-page");
		var downloadBtn = (0, _jquery2.default)("#download_error-btn");
		var downloadBtnUrl = outerEl.data("download-error-url");
		var filterURL = outerEl.data("filter-url");
		var filterOrderURL = outerEl.data("filter-order-url");
		var filterAmlURL = outerEl.data("filter-aml-url");
		var filterRMAURL = outerEl.data("filter-rmas-url");
		var filterRuleURL = outerEl.data("filter-rule-url");
		var downloadForm = (0, _jquery2.default)("#bulk-details-form");
		var loadMoreBtn = (0, _jquery2.default)("#load_more-btn");
		var loadItemUrl = outerEl.data("load-more-item-url");
		var viewItemUrl = outerEl.data("view-item-url");
		var viewOrderReleaseRuleUrl = outerEl.data("view-release-rule-url");
		var viewBundleUrl = outerEl.data("view-bundle-url");
		var viewOrderRenderUrl = outerEl.data("view-order-render-url");
		var viewRMAUrl = outerEl.data("view-rma-url");
		var nextPage = outerEl.data("next-page-value");
		var bulkproductuuidjson = outerEl.data("bulkproductuuidjson");
		var bulkorderuuidjson = outerEl.data("bulkorderuuidjson");
		var bulkamluuidjson = outerEl.data("bulkamluuidjson");
		var bulkruleuuidjson = outerEl.data("bulkruleuuidjson");
		var bulkrmauuidjson = outerEl.data("bulkrmauuidjson");
		var bupuuid = outerEl.data("bupUuId");
		//Changes for 7674
		var exportModal = new _filtersutil.buildExport();
		var generateExportProductsUrl = outerEl.data("export-products-url");
		var portletNamespace = outerEl.data("portlet-namespace");
		var entityType = outerEl.data("entity-type");
		//integration for order export
		var generateExportOrdersUrl = outerEl.data("export-orders-url");
		var generateExportAMLUrl = outerEl.data("export-aml-url");
		var generateExportOrderRelaseRulesUrl = outerEl.data("export-order-relese-rule-url");
		var generateExportRMAUrl = outerEl.data("export-rma-url");
		var totalCount = void 0;
		var generateExportUrl = void 0;
		var title = void 0;
		if (entityType === "Products") {
			generateExportUrl = generateExportProductsUrl;
			title = "Products Export";
		} else if (entityType === "Orders") {
			generateExportUrl = generateExportOrdersUrl;
			title = "Order Export";
		} else if (entityType === "Bundles") {
			generateExportUrl = generateExportProductsUrl;
			title = "Bundles Export";
		} else if (entityType === "AML") {
			generateExportUrl = generateExportAMLUrl;
			title = "AML Export";
		} else if (entityType === "RMA") {
			generateExportUrl = generateExportRMAUrl;
			title = "RMA Export";
		} else if (entityType === "Order Release Rules") {
			generateExportUrl = generateExportOrderRelaseRulesUrl;
			title = "Order Release Rules Export";
		}
		showHideLoadButton(nextPage);
		function showHideLoadButton(nextPage) {
			if (!nextPage) {
				loadMoreBtn.hide();
			} else {
				loadMoreBtn.show();
			}
		}
	
		downloadBtn.click(function () {
			//outerEl.preventDefault();
			downloadForm.attr('method', 'post');
			downloadForm.attr('action', downloadBtnUrl);
			downloadForm.attr('target', 'bulk-details-error');
			downloadForm.submit();
		});
	
		if (entityType == 'AML') {
			var getAuthorizedStatus = function getAuthorizedStatus(amlStatus) {
				if (amlStatus == 'A') {
					return "Authorized";
				} else {
					return "Unauthorized";
				}
			};
	
			var filterSuccess = function filterSuccess(data) {
				var aml = data.content;
				pagableAML.setData(aml);
				pagableAML.hideLoadingOverlay();
			};
	
			var error = function error(data) {
				pagableAML.hideLoadingOverlay();
			};
	
			var prepareDataToSendController = function prepareDataToSendController(bupuuid, page, pageSize) {
				var data = {
					page: page,
					pageSize: pageSize,
					buid: bupuuid
				};
				return data;
			};
	
			var pagableAML = new _index2.default({
				dataContainer: '.aml-list',
				pagingContainer: '.paging-area-for-aml',
				data: bulkamluuidjson,
				showData: function showData(row) {
					return (0, _render2.default)(renderTemplateForAMLHtml, {
						itemSku: row.amlItemSku,
						soldToParty: row.amlCustomerId,
						amlStatus: getAuthorizedStatus(row.amlStatus)
					});
				},
				onFetch: function onFetch(page, pageSize) {
					pagableAML.showLoadingOverlay();
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterAmlURL, success: filterSuccess, error: error, data: prepareDataToSendController(bupuuid, page, pageSize) });
					}, _index4.default);
				}
			});
			pagableAML.init();
		}
	
		if (entityType == 'Order Release Rules') {
			var _filterSuccess = function _filterSuccess(data) {
				var rule = data.content;
				pagableRules.setData(rule);
				pagableRules.hideLoadingOverlay();
			};
	
			var _error = function _error(data) {
				pagableRules.hideLoadingOverlay();
			};
	
			var _prepareDataToSendController = function _prepareDataToSendController(bupuuid, page, pageSize) {
				var data = {
					page: page,
					pageSize: pageSize,
					buid: bupuuid
				};
				return data;
			};
	
			var pagableRules = new _index2.default({
				dataContainer: '.rules-list',
				pagingContainer: '.paging-area-for-rules',
				data: bulkruleuuidjson,
				showData: function showData(row) {
					return (0, _render2.default)(renderTemplateForRulesHtml, {
	
						itemSku: row.sku,
						ruleId: row.ruleId,
						viewItemUrl: viewOrderReleaseRuleUrl
					});
				},
				onFetch: function onFetch(page, pageSize) {
					pagableRules.showLoadingOverlay();
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterRuleURL, success: _filterSuccess, error: _error, data: _prepareDataToSendController(bupuuid, page, pageSize) });
					}, _index4.default);
				}
			});
			pagableRules.init();
		}
	
		if (entityType == 'Products') {
			var filterSuccessFun = function filterSuccessFun(data) {
				var product = data.content;
				pagableProducts.setData(product);
				pagableProducts.hideLoadingOverlay();
			};
	
			var errorFun = function errorFun(data) {
				pagableProducts.hideLoadingOverlay();
			};
	
			var _prepareDataToSendController2 = function _prepareDataToSendController2(bupuuid, page, pageSize) {
				var data = {
					page: page,
					pageSize: pageSize,
					buid: bupuuid
				};
				return data;
			};
	
			totalCount = bulkproductuuidjson.totalElements;
			var pageSizeOptions = [10, 25, 50, 100];
			var pagableProducts = new _index2.default({
				dataContainer: '.product-list',
				pagingContainer: '.paging-area-for-products',
				pageSizeOptions: pageSizeOptions,
				pageSize: 10,
				data: bulkproductuuidjson,
				showData: function showData(row) {
					return (0, _render2.default)(renderTemplateForProductsHtml, {
						sku: row.itmSku,
						prdsku: row.itmSku,
						prdactive: row.itmActive,
						itmid: row.itmId,
						viewItemUrl: viewItemUrl
					});
				},
				onFetch: function onFetch(page, pageSize) {
					pagableProducts.showLoadingOverlay();
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterURL, success: filterSuccessFun, error: errorFun, data: _prepareDataToSendController2(bupuuid, page, pageSize) });
					}, _index4.default);
				}
			});
			pagableProducts.init();
		}
	
		if (entityType == 'Bundles') {
			var _filterSuccessFun = function _filterSuccessFun(data) {
				var product = data.content;
				_pagableProducts.setData(product);
				_pagableProducts.hideLoadingOverlay();
			};
	
			var _errorFun = function _errorFun(data) {
				_pagableProducts.hideLoadingOverlay();
			};
	
			var _prepareDataToSendController3 = function _prepareDataToSendController3(bupuuid, page, pageSize) {
				var data = {
					page: page,
					pageSize: pageSize,
					buid: bupuuid
				};
				return data;
			};
	
			totalCount = bulkproductuuidjson.totalElements;
			var _pageSizeOptions = [10, 25, 50, 100];
			var _pagableProducts = new _index2.default({
				dataContainer: '.bundles-list',
				pagingContainer: '.paging-area-for-products',
				pageSizeOptions: _pageSizeOptions,
				pageSize: 10,
				data: bulkproductuuidjson,
				showData: function showData(row) {
					return (0, _render2.default)(renderTemplateForBundlesHtml, {
						sku: row.itmSku,
						prdsku: row.itmSku,
						prdactive: renderStatusPill(row.itmActive),
						itmid: row.itmId,
						viewItemUrl: viewBundleUrl
					});
				},
				onFetch: function onFetch(page, pageSize) {
					_pagableProducts.showLoadingOverlay();
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterURL, success: _filterSuccessFun, error: _errorFun, data: _prepareDataToSendController3(bupuuid, page, pageSize) });
					}, _index4.default);
				}
			});
			_pagableProducts.init();
		}
	
		if (entityType == 'Orders') {
			var getOrderStatusPillColor = function getOrderStatusPillColor(status) {
				if (status === "Error") {
					return "q-pill-red";
				} else if (status === "Shipped") {
					return "q-pill-blue";
				} else if (status === "In Process") {
					return "q-pill-blue-border";
				} else if (status === "Released") {
					return "q-pill-blue-border";
				} else if (status === "Partially Shipped") {
					return "q-pill-blue-border";
				} else if (status === "Pending") {
					return "q-pill-blue-border";
				} else if (status === "Backordered") {
					return "q-pill-red";
				} else if (status === "Partially Released") {
					return "q-pill-blue-border";
				} else if (status === "Self Fulfill") {
					return "q-pill-blue";
				} else if (status === "Held") {
					return "q-pill-blue-border";
				} else if (status === "Hold Pending") {
					return "q-pill-blue-border";
				} else if (status === "Canceled") {
					return "q-pill-light-grey";
				} else if (status === "Cancel Pending") {
					return "q-pill-light-grey";
				}
			};
	
			var filterorderSuccessFun = function filterorderSuccessFun(data) {
				var order = data.orders;
				pagableOrder.setData(order);
				pagableOrder.hideLoadingOverlay();
			};
	
			var ordererrorFun = function ordererrorFun(data) {
				pagableOrder.hideLoadingOverlay();
			};
	
			var prepareDataToSendOrderController = function prepareDataToSendOrderController(bupuuid, page, pageSize) {
				var data = {
					page: page,
					pageSize: pageSize,
					buid: bupuuid
				};
				return data;
			};
	
			//HB-7939-pagination for bulk-upload-orders
	
			var orderBulkData = {
				totalElements: bulkorderuuidjson.pagination.totalElements,
				totalPages: bulkorderuuidjson.pagination.totalPages,
				size: bulkorderuuidjson.pagination.size,
				page: bulkorderuuidjson.pagination.number,
				content: bulkorderuuidjson.orders
			};
			totalCount = orderBulkData.totalElements;
			var _pageSizeOptions2 = [10, 25, 50, 100];
			var pagableOrder = new _index2.default({
				dataContainer: '.orders-list',
				pagingContainer: '.paging-area-for-orders',
				pageSizeOptions: _pageSizeOptions2,
				pageSize: 10,
				data: orderBulkData,
				showData: function showData(row) {
					var pillColor = getOrderStatusPillColor(row.ordStatus);
					return (0, _render2.default)(renderTemplateForOrdersHtml, {
						externalOID: row.externalOrderId,
						fedexOId: row.fedexOrderId,
						pillColor: pillColor,
						status: row.ordStatus,
						viewOrderRenderUrl: viewOrderRenderUrl
	
					});
				},
				onFetch: function onFetch(page, pageSize) {
					pagableOrder.showLoadingOverlay();
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterOrderURL, success: filterorderSuccessFun, error: ordererrorFun, data: prepareDataToSendOrderController(bupuuid, page, pageSize) });
					}, _index4.default);
				}
			});
			pagableOrder.init();
		}
	
		if (entityType == 'RMA') {
			var filterRmaSuccessFun = function filterRmaSuccessFun(data) {
				var rma = data.content;
				pagableRmas.setData(rma);
				pagableRmas.hideLoadingOverlay();
			};
	
			var rmaerrorFun = function rmaerrorFun(data) {
				pagableRmas.hideLoadingOverlay();
			};
	
			var prepareDataToSendRmaController = function prepareDataToSendRmaController(bupuuid, page, pageSize) {
				var data = {
					page: page,
					pageSize: pageSize,
					buid: bupuuid
				};
				return data;
			};
	
			totalCount = bulkrmauuidjson.totalElements;
			var _pageSizeOptions3 = [10, 25, 50, 100];
			var pagableRmas = new _index2.default({
				dataContainer: '.rma-list',
				pagingContainer: '.paging-area-for-rma',
				pageSizeOptions: _pageSizeOptions3,
				pageSize: 10,
				data: bulkrmauuidjson,
				showData: function showData(row) {
					return (0, _render2.default)(renderTemplateForRMAHtml, {
						selectedRmaId: row.rmaId,
						rmaNumber: row.rmaNumber,
						status: row.rmaStatus,
						viewRmaRenderUrl: viewRMAUrl
					});
				},
				onFetch: function onFetch(page, pageSize) {
					pagableRmas.showLoadingOverlay();
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterRMAURL, success: filterRmaSuccessFun, error: rmaerrorFun, data: prepareDataToSendRmaController(bupuuid, page, pageSize) });
					}, _index4.default);
				}
			});
			pagableRmas.init();
		}
		//Export button integration functionality
		function initExport() {
			var cssClassNameForCount = "exportCountCSS";
			var exportObj = {
				title: title,
				exportAttemptTextPart1Lang: outerEl.data("export-attempt-text-part1"),
				exportAttemptTextPart2Lang: outerEl.data("export-attempt-text-part2"),
				exportMaxLimitLang: outerEl.data("export-max-row-limit"),
				cssClassNameForCount: cssClassNameForCount
			};
			exportModal.init(exportObj);
			exportModal.bindExportEvent();
		}
	
		function setExportData(currentData) {
			exportModal.buildExportCustomBasicURL(generateExportUrl, currentData, portletNamespace);
			var url = exportModal.getCurrentUrl();
			url = url + bupuuid;
			exportModal.buildExportCustomBasicURL(url, currentData, portletNamespace);
			exportModal.setExportCount(totalCount, "exportCountCSS");
		}
	
		var currentData = {};
		initExport();
		setExportData(currentData);
	
		function renderStatusPill(status) {
			if (status = true) {
				return "Active";
			} else {
				return "Deactive";
			}
		}
	});

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _bulkUploadDataTable = __webpack_require__(562);
	
	var _bulkUploadDataTable2 = _interopRequireDefault(_bulkUploadDataTable);
	
	var _bulkUploadDetailView = __webpack_require__(563);
	
	var _bulkUploadDetailView2 = _interopRequireDefault(_bulkUploadDetailView);
	
	var _bulkLoadUpload = __webpack_require__(561);
	
	var _bulkLoadUpload2 = _interopRequireDefault(_bulkLoadUpload);
	
	__webpack_require__(564);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//const targetSelector = "#p_p_id_channels_WAR_hcportlet_";
	var bulkUploadRecordsTargetSelector = ".bulk-upload-datatable-container";
	var bulkUploadDetailViewTargetSelector = ".bulk-upload-deail-view-container";
	var bulkUploadCsvFilesTargetSelector = ".bulk-upload-csv-files-container";
	
	// to render bulk upload records
	(0, _run2.default)(bulkUploadRecordsTargetSelector, function () {
	  (0, _bulkUploadDataTable2.default)(bulkUploadRecordsTargetSelector);
	});
	
	// to render bulk upload record details
	(0, _run2.default)(bulkUploadDetailViewTargetSelector, function () {
	  (0, _bulkUploadDetailView2.default)(bulkUploadDetailViewTargetSelector);
	});
	
	//to render bulk upload csv page
	(0, _run2.default)(bulkUploadCsvFilesTargetSelector, function () {
	  (0, _bulkLoadUpload2.default)(bulkUploadCsvFilesTargetSelector);
	});

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.columnData = exports.filterData = undefined;
	exports.statusPillRender = statusPillRender;
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var statusPillRenderTemplate = __webpack_require__(1270);
	var createdOnRenderTemplate = __webpack_require__(1261);
	//Changes for Date and Time Display in bulkupload landing page
	
	var datTimeFormat = "MM/DD/YYYY hh:mm A";
	
	var date = new Date();
	var pillStatusClasses = {
	  "Complete": "q-pill-green",
	  "Partially Complete": "q-pill-blue-border",
	  "Processing": "q-pill-blue-border",
	  "Failed": "q-pill-red"
	};
	var filterData = exports.filterData = [{
	  "filterGroup": "Upload Status",
	  "filterGroupType": "checkbox",
	  "filterGroupName": "status",
	  "filterGroupInputs": [{
	    "filterTitle": "Processing",
	    "filterValue": "Received",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterTitle": "Partially Complete",
	    "filterValue": "PartiallyProcessed",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterTitle": "Complete",
	    "filterValue": "Processed",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterTitle": "Failed",
	    "filterValue": "Failed",
	    "filterOperator": "equal",
	    "active": false
	  }]
	}, {
	  "filterGroup": "Upload Type",
	  "filterGroupType": "checkbox",
	  "filterGroupName": "type",
	  "filterGroupInputs": [{
	    "filterTitle": "Orders",
	    "filterValue": "ORDER",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterTitle": "Items",
	    "filterValue": "ITEMS",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterTitle": "Products",
	    "filterValue": "PRODUCT",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterTitle": "Inbound Shipments",
	    "filterValue": "ASN",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterTitle": "Facilities",
	    "filterValue": "FACILITIY",
	    "filterOperator": "equal",
	    "active": false
	  }]
	}, {
	  "filterGroup": "Date Range",
	  "filterGroupType": "radio",
	  "filterGroupName": "createdTimeStamp",
	  "filterGroupInputs": [{
	    "filterName": "fixedRange",
	    "filterTitle": "Today",
	    "filterValue": "today",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterName": "fixedRange",
	    "filterTitle": "Yesterday",
	    "filterValue": "yesterday",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterName": "fixedRange",
	    "filterTitle": "Last 7 Days",
	    "filterValue": "lastSevenDays",
	    "filterOperator": "equal",
	    "active": false
	  }, {
	    "filterName": "fixedRange",
	    "filterTitle": "Last 60 Days (Default)",
	    "filterValue": "lastSixtyDays",
	    "filterOperator": "equal",
	    "active": true
	  }, {
	    "filterName": "fixedRange",
	    "filterTitle": "Custom Date Range",
	    "filterValue": "customRange",
	    "filterOperator": "equal",
	    "active": false,
	    "childFilters": [{
	      "filterGroup": "Date Range",
	      "filterGroupType": "dateRange",
	      "filterGroupName": "createdTimeStamp",
	      "dateRangeNameStart": "startDate",
	      "dateRangeNameEnd": "endDate"
	    }]
	  }]
	}];
	
	var columnData = exports.columnData = [{
	  data: "bupDisplayId",
	  title: "Upload ID",
	  linkKey: "lookupTableActionLink",
	  canToggle: false
	}, {
	  data: "type",
	  title: "Upload Type"
	}, {
	  data: "records",
	  title: "Records",
	  render: renderSetDash
	}, {
	  data: "createdTimeStamp",
	  title: "Created On",
	  render: createdOnRender
	}, {
	  data: "status",
	  title: "Status",
	  render: statusPillRender
	}];
	
	function renderSetDash(data, type, row) {
	  if (data === 0 || data === "0" || typeof data === "undefined") {
	    return "-";
	  };
	  return data;
	}
	
	function createdOnRender(data, type, row) {
	  var checkDate = new Date(data);
	  var newDate = dateDiff(date, checkDate);
	  var pillDate = void 0;
	  if (newDate >= 0) {
	    if (newDate === 0) {
	      pillDate = 'Today';
	    } else if (newDate === 1) {
	      pillDate = 'Yesterday';
	    } else {
	      pillDate = newDate + ' days ago';
	    }
	    data = (0, _moment2.default)(data).format(datTimeFormat) + " ET";
	  }
	  var newRender = void 0;
	  return newRender = (0, _render2.default)(createdOnRenderTemplate, {
	    data: data,
	    pillDate: pillDate
	  });
	}
	
	function statusPillRender(data, type, row) {
	  var newRender = void 0;
	  var pillClass = pillStatusClasses[data];
	  return newRender = (0, _render2.default)(statusPillRenderTemplate, {
	    data: data,
	    pillClass: pillClass
	  });
	}
	
	function dateDiff(date1, date2) {
	  date1.setHours(0);
	  date1.setMinutes(0, 0, 0);
	  date2.setHours(0);
	  date2.setMinutes(0, 0, 0);
	  var datediff = Math.abs(date1.getTime() - date2.getTime());
	  return parseInt(datediff / (24 * 60 * 60 * 1000), 10);
	}

/***/ },
/* 567 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    title: "Activate Rule",
	    cls: "bulk-activate-rule",
	    icon: "toggle-off",
	    disabled: true
	  }, {
	    title: "Deactivate Rule",
	    cls: "bulk-deactivate-rule",
	    icon: "toggle-on",
	    disabled: true
	  }],
	  "actions": [{
	    title: "Edit Rule",
	    cls: "edit-rule",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Activate Rule",
	    cls: "activate-rule",
	    icon: "toggle-off",
	    disabled: false
	  }, {
	    title: "Deactivate Rule",
	    cls: "inactivate-rule",
	    icon: "toggle-on",
	    disabled: false
	  }]
	};

/***/ },
/* 568 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var rulesLookupFieldDropdown = exports.rulesLookupFieldDropdown = [];

/***/ },
/* 569 */
[1582, 570],
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _rulesLookupFieldDropdown = __webpack_require__(568);
	
	var _actionOptions = __webpack_require__(567);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var detailLinkTemplate = __webpack_require__(1271);
	var actionList = _actionOptions.actionOptions;
	
	var targetSelector = "#lookup-collateral-rules";
	
	(0, _run2.default)(targetSelector, function () {
		var entryElement = $(targetSelector);
		var dataTableComponentData = entryElement.data("rules-data");
	
		var viewRulesDetailURL = entryElement.data("view-details-url");
		var filterSearchUrl = entryElement.data("filter-search-url");
		var activateUrl = entryElement.data("activate-url");
		var inactivateUrl = entryElement.data("inactivate-url");
		var updateRuleUrl = entryElement.data("update-url");
		var bulkActivateDeactivateRuleUrl = entryElement.data("bulk-activate-deactivate-rule-url");
	
		var portletNamespace = entryElement.data("portlet-namespace");
		var shouldCheckCache = entryElement.data("should-check-cache");
	
		var savedViews = entryElement.data("saved-views");
		var saveViewURL = entryElement.data("save-view-url");
		var deleteViewURL = entryElement.data("delete-view-url");
	
		var submitModalFlow = new _SubmitModalFlow2.default();
		submitModalFlow.init();
	
		var extraDetailForCacheFromServer = entryElement.data("extra-detail-for-cache-from-server");
		var criteriaObjectFromServer = entryElement.data("filter-criteria-from-server");
	
		var targetObject = "";
		var totalRecordCount = 0;
		var lookupFieldDropdown = _rulesLookupFieldDropdown.rulesLookupFieldDropdown;
	
		var selectedRows = "";
	
		if (shouldCheckCache) {
			targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
		}
	
		if (_.has(dataTableComponentData, "page")) {
			totalRecordCount = dataTableComponentData.page.totalElements;
		}
	
		function createDetailLink(data, type, row) {
			var newRender = void 0;
	
			newRender = (0, _render2.default)(detailLinkTemplate, {
				id: row.cbrId,
				name: row.cbrName,
				url: viewRulesDetailURL
			});
			return newRender;
		}
	
		function renderStatusPill(data, type, row) {
			var status = data;
			if (status === false) {
				return "<div class='q-pill q-block q-pill-blue-border q-marg-all-xs-at-md q-pill-table'>Inactive</div>";
			} else {
				return "<div class='q-pill q-block q-pill-blue q-marg-all-xs-at-md q-pill-table'>Active</div>";
			}
			return "";
		}
	
		function formateDate(createdDate, type, data) {
			if (createdDate != null && createdDate != "") {
				var date = new Date(createdDate); //createdDate is long time format
				var month = date.getMonth() + 1;
				var today = new Date();
				today.setHours(0, 0, 0, 0);
				var oneDay = 24 * 60 * 60 * 1000;
				var diffDays = Math.round(Math.abs((today.getTime() - date.getTime()) / oneDay));
				var friendlyText = "";
				var datePillHTML = "";
				if (diffDays < 100) {
					friendlyText = diffDays.toString() + ' Days Ago';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				}
				if (diffDays == 0) {
					friendlyText = 'Today';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				} else if (diffDays == 1) {
					friendlyText = 'Yesterday';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				}
				return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
			} else {
				return "";
			}
		}
	
		var ruleLookup = new _index2.default({
			// REQUIRED - Set a target element
			target: $("#collateral-rules-table-wrapper"),
			// REQUIRED - Set which data should be visible for mobile
			mobileColumns: [{
				data: "cbrName",
				title: "Rule",
				render: createDetailLink
			}, {
				data: "cbrDescription",
				title: "Rule Description"
			}, {
				data: "cbrActive",
				title: "Status",
				render: renderStatusPill
			}],
			// tableFilters: {
			//    data: orderFilterData,
			//  },
			tableSearch: false,
			// REQUIRED: search input info
			tableSearchInput: {
				// Not required
				// placeholder: 'Custom Search Text'
				value: targetObject != "" ? targetObject.value[0] : ""
	
			},
			// REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
			tableSearchDropdown: {
				selected: targetObject == "" ? "" : targetObject.key,
				columns: lookupFieldDropdown
			},
			// OPTIONAL: Set Saved View Array
			savedViews: savedViews,
			bulkSelect: true,
			// REQUIRED - Data Table specific settings
			dataTable: {
				// use same settings you would if you were just calling a dataTable normally
				data: dataTableComponentData.content,
				// Not required, just to show you can
				columnDefs: [{}],
				// Not required, just to show you can
				order: [[6, 'desc']],
				columns: [{
					data: "cbrActive",
					render: renderActionWrap,
					orderable: false,
					class: 'dtc-action-column',
					title: "Actions"
				}, {
					data: "cbrName",
					title: "Rule",
					render: createDetailLink,
					class: 'dtc-min-width-md'
				}, {
					data: "cbrDescription",
					title: "Rule Description",
					class: 'dtc-min-width-md'
	
				}, {
					data: "cbrActive",
					title: "Status",
					render: renderStatusPill,
					class: 'dtc-min-width-md'
				}, {
					data: "cbrEffectiveEndDate",
					title: "Effective Until",
					class: 'dtc-min-width-sm'
				}, {
					data: "cbrCreatedDate",
					title: "Created Date",
					render: formateDate,
					class: 'dtc-min-width-sm'
				}]
			},
			//  tableColumnModal: {
			//	data: ruleLookupColumnsPopup
			//},
			paginationData: dataTableComponentData.page,
			filterModal: {
				// REQUIRED: Sets title of modal
				title: "Filter Collateral Rules",
				// REQUIRED: Sets unique part of subtitle string.
				tableType: "collateral"
			},
			onBulkSelectChange: function onBulkSelectChange() {
				selectedRows = ruleLookup.getBulkSelectedData();
				$("th.dtc-action-column").html(renderActionHeaderWrap());
				if (selectedRows.length >= 2) {
					$(".action-header-btn .base-btn").removeClass('disabled');
				} else {
					$(".action-header-btn .base-btn").addClass('disabled');
				};
			},
			onFetch: function onFetch() {
				var currentData = ruleLookup.generateData();
				ruleLookup.showLoadingOverlay();
	
				//Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
				if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterSearchUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isNew)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isEdit)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isDeleteView)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				}
			}
		});
	
		function filterSuccessFun(data) {
			var rules = data.content;
			var page = data.page;
			ruleLookup.setNewData(rules);
			ruleLookup.setPaginationData(page);
			(0, _filtersutil.pushFilterSessionCacheState)();
			totalRecordCount = page.totalElements;
			ruleLookup.hideLoadingOverlay();
			//$(".data-table-component").DataTable().columns('.status-column').visible( false );
		}
	
		function savedViewSuccess(data) {
			var rules = data.lookupRuleJSON.content;
			var page = data.lookupRuleJSON.page;
			ruleLookup.setNewData(rules);
			ruleLookup.setPaginationData(page);
			ruleLookup.setNewSavedViewData(data.savedView, "newSavedView");
			(0, _filtersutil.pushFilterSessionCacheState)();
			totalRecordCount = page.totalElements;
			ruleLookup.hideLoadingOverlay();
		}
	
		function savedEditViewSuccess(data) {
			var rules = data.lookupRuleJSON.content;
			var page = data.lookupRuleJSON.page;
			ruleLookup.setNewData(rules);
			ruleLookup.setPaginationData(page);
			ruleLookup.setNewSavedViewData(data.savedView, data.savedView.target);
			(0, _filtersutil.pushFilterSessionCacheState)();
			totalRecordCount = page.totalElements;
			ruleLookup.hideLoadingOverlay();
		}
	
		function delteViewScussFun(data) {
			var rules = data.lookupRuleJSON.content;
			var page = data.lookupRuleJSON.page;
			ruleLookup.removeSavedView(data.target);
			ruleLookup.setNewData(rules);
			ruleLookup.setPaginationData(page);
			totalRecordCount = page.totalElements;
			ruleLookup.hideLoadingOverlay();
		}
	
		function errorFun(data) {
			ruleLookup.hideLoadingOverlay();
		}
	
		ruleLookup.init();
	
		//const ordersDataTableObj = $("#lookup-order-wrapper .data-table-component").dataTable();
		function renderActionWrap(data, type, row, meta) {
			var newRender = void 0;
			var statusTarget = actionList["actions"];
			newRender = (0, _render2.default)(actionCellDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row),
				index: meta.row
			});
			return newRender;
		};
	
		function renderActionHeaderWrap() {
			var statusTarget = actionList['all'];
			var newRender = void 0;
			var data = "";
			var row = "";
			newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row)
			});
			return newRender;
		};
	
		function renderActionCellList(list, data, row) {
			var renderedList = void 0;
			renderedList = _(list).map(function (item) {
				return (0, _render2.default)(actionCellDropdownItemTemplate, {
					icon: item.icon,
					title: item.title,
					cls: item.cls,
					disabled: checkDisableForGivenAction(data, row, item.title)
				});
			});
			return renderedList.join('');
		};
	
		function checkDisableForGivenAction(data, row, actionName) {
			if (isRowLevelActionCheck(data)) {
				return callBusinessLogicToDisableAction(data, row, actionName);
			} else {
				var isTrue = false;
				_(selectedRows).map(function (item) {
					if (callBusinessLogicToDisableAction(item.data.cbrActive, item.data, actionName)) {
						if (!isTrue) {
							isTrue = true;
						}
					}
				});
				return isTrue;
			}
		};
	
		function isRowLevelActionCheck(data) {
			return (0, _general.isPresent)(data);
		}
	
		// Note this method will return true if we want to disable action, else return false if we want to enable
		function callBusinessLogicToDisableAction(status, row, actionName) {
			if ((0, _general.isPresent)(status)) {
				if (actionName === "Deactivate Rule") {
					if (row.cbrActive === true) {
						return false;
					} else {
						return true;
					}
				} else if (actionName === "Activate Rule") {
					if (row.cbrActive === false) {
						if (moment().isAfter(row.cbrEffectiveEndDate)) {
							return true;
						} else {
							return false;
						}
					} else {
						return true;
					}
				} else {
					return false;
				}
			}
		}
	
		function shallAllowClick(currentObj) {
			return !$(currentObj).hasClass("disabled");
		}
	
		$('body').on('click', '.edit-rule, .activate-rule, .inactivate-rule', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
				var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				// Get the row based on the parent...
				var parent = $(".dropdown-parent-" + pIndex).parents('tr');
				// Get the row data
				var row = $(".data-table-component").dataTable().api().row(parent);
	
				if ($(this).hasClass('edit-rule')) {
					processEditRule(row);
				} else if ($(this).hasClass('activate-rule')) {
					processActivateRule(row);
				} else if ($(this).hasClass('inactivate-rule')) {
					processInactivateRule(row);
				}
			}
		});
	
		function processEditRule(row) {
			location.href = updateRuleUrl + "&cbrId=" + row.data().cbrId;
		}
	
		function processActivateRule(row) {
			var submitModal = new _SubmitModalFlow2.default({
				confirmModalTitle: 'Activate',
				confirmModalBody: '<div class="q-pad-all-xl">Are you sure you want to activate this rule?</div>',
				confirmModalBtnText: 'Activate Rule',
				onConfirmClick: function onConfirmClick() {
					submitModal.showLoadingModal();
					var data = row.data();
					activateRule(row, data);
	
					function activateRule(row, rule) {
						$.ajax({
							url: activateUrl,
							type: 'POST',
							dataType: 'JSON',
							data: {
								cbrId: rule.cbrId
							},
							success: function success(data) {
								if (data.response == "success") {
									var d = row.data();
									d.cbrActive = data.cbrActive;
									d.cbrEffectiveEndDate = $.trim(data.cbrEffectiveEndDate);
									d.cbrId = $.trim(data.cbrId);
									row.data(d).draw();
									submitModal.showSuccessModal();
									setTimeout(function () {
										submitModal.hideAllModals();
									}, window.constants.SUCCESS_MODAL_TIMEOUT);
								} else {
									submitModal.showFailureModal();
								}
							},
							error: function error(data) {
								submitModal.hideAllModals();
							}
						});
					};
				}
			});
			submitModal.init();
			submitModal.showConfirmModal();
		}
	
		function processInactivateRule(row) {
			var submitModal = new _SubmitModalFlow2.default({
				confirmModalTitle: 'Deactivate',
				confirmModalBody: '<div class="q-pad-all-xl">Are you sure you want to inactivate this rule?</div>',
				confirmModalBtnText: 'Deactivate Rule',
				onConfirmClick: function onConfirmClick() {
					submitModal.showLoadingModal();
					var data = row.data();
					inactivateRule(row, data);
	
					function inactivateRule(row, rule) {
						$.ajax({
							url: inactivateUrl,
							type: 'POST',
							dataType: 'JSON',
							data: {
								cbrId: rule.cbrId
							},
							success: function success(data) {
								if (data.response == "success") {
									var d = row.data();
									d.cbrActive = data.cbrActive;
									d.cbrEffectiveEndDate = $.trim(data.cbrEffectiveEndDate);
									d.cbrId = $.trim(data.cbrId);
									row.data(d).draw();
									submitModal.showSuccessModal();
									setTimeout(function () {
										submitModal.hideAllModals();
									}, window.constants.SUCCESS_MODAL_TIMEOUT);
								} else {
									submitModal.showFailureModal();
								}
							},
							error: function error(data) {
								submitModal.hideAllModals();
							}
						});
					};
				}
			});
			submitModal.init();
			submitModal.showConfirmModal();
		}
	
		$('body').on('click', '.bulk-activate-rule', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				var submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: 'Activate Rules',
					confirmModalBody: '<div class="q-pad-all-xl">Once these products are activated, orders can be fulfilled with these products and inbound shipments can contain these products.</div>',
					confirmModalBtnText: 'Activate Rules',
					onConfirmClick: function onConfirmClick() {
						submitModalFlow.showLoadingModal();
						activateRules();
						function activateRules() {
							var _data;
	
							$.ajax({
								url: bulkActivateDeactivateRuleUrl,
								type: 'POST',
								dataType: 'JSON',
								data: (_data = {}, _defineProperty(_data, 'cbrIds', getAllSelectedCbrIds()), _defineProperty(_data, 'action', 'Activate'), _data),
								success: function success(data) {
									if (data.response == "success") {
										_(selectedRows).map(function (item) {
											var currentRow = $(".data-table-component").DataTable().row(item.rowIndex);
											var d = currentRow.data();
											d.cbrActive = true;
											currentRow.data(d).draw();
										});
										ruleLookup.uncheckAllSelected();
										submitModalFlow.showSuccessModal();
										setTimeout(function () {
											submitModalFlow.hideAllModals();
										}, window.constants.SUCCESS_MODAL_TIMEOUT);
									} else {
										submitModalFlow.showFailureModal();
									}
								},
								error: function error(data) {
									submitModalFlow.hideAllModals();
								}
							});
						}
					}
				});
				submitModalFlow.init();
				submitModalFlow.showConfirmModal();
			}
		});
	
		$('body').on('click', '.bulk-deactivate-rule', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				var submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: 'Deactivate Rules',
					confirmModalBody: '<div class="q-pad-all-xl">Once these products are deactivated, orders containing these products won’t be fulfilled and these products cannot be added to inbound shipments.</div>',
					confirmModalBtnText: 'Deactivate Rules',
					onConfirmClick: function onConfirmClick() {
						submitModalFlow.showLoadingModal();
						deactivateRules();
						function deactivateRules() {
							var _data2;
	
							$.ajax({
								url: bulkActivateDeactivateRuleUrl,
								type: 'POST',
								dataType: 'JSON',
								data: (_data2 = {}, _defineProperty(_data2, 'cbrIds', getAllSelectedCbrIds()), _defineProperty(_data2, 'action', 'Deactivate'), _data2),
								success: function success(data) {
									if (data.response == "success") {
										_(selectedRows).map(function (item) {
											var currentRow = $(".data-table-component").DataTable().row(item.rowIndex);
											var d = currentRow.data();
											d.cbrActive = false;
											currentRow.data(d).draw();
										});
										ruleLookup.uncheckAllSelected();
										submitModalFlow.showSuccessModal();
										setTimeout(function () {
											submitModalFlow.hideAllModals();
										}, window.constants.SUCCESS_MODAL_TIMEOUT);
									} else {
										submitModalFlow.showFailureModal();
									}
								},
								error: function error(data) {
									submitModalFlow.hideAllModals();
								}
							});
						}
					}
				});
				submitModalFlow.init();
				submitModalFlow.showConfirmModal();
			}
		});
	
		function getAllSelectedCbrIds() {
			var cbrIds = new Array();
			_(selectedRows).map(function (item) {
				cbrIds.push(item.data.cbrId);
			});
			return cbrIds;
		}
	
		// Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information...
		(0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
		$("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _submitHelpers = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	__webpack_require__(1107);
	
	var $ = __webpack_require__(1);
	
	// For quick dev prototyping
	(0, _run2.default)("#p_p_id_helpdrawerportlet_WAR_commerceuportlet_", function () {
	  attachCommerceDrawer();
	});
	
	function attachCommerceDrawer() {
	  var commerceDrawerOpen = $('.commerce-drawer');
	  var commerceDrawerOverlay = $('.commerce-overlay');
	
	  // if you click on "open drawer" button the overlay
	  // appears and drawer opens
	  $('.commerce-drawer-btn').click(function (e) {
	    e.preventDefault();
	    commerceDrawerOpen.addClass('drawer-open');
	    commerceDrawerOverlay.toggle();
	    $('body').addClass('commerce-drawer-open');
	  });
	
	  // X button in drawer or clicking out of
	  // drawer closes drawer and hides overlay
	  $('.commerce-drawer-header .q-drawer-close-x, .commerce-overlay').click(function (e) {
	    e.preventDefault();
	    commerceDrawerOpen.removeClass('drawer-open');
	    commerceDrawerOverlay.toggle();
	    $('body').removeClass('commerce-drawer-open');
	  });
	
	  // to flip the expand compress icons within drawer
	  $('.commerce-drawer-title-expander').click(function (e) {
	    e.preventDefault();
	    var currentCompress = commerceDrawerOpen.find(".fa-compress");
	
	    $(this).next('.commerce-drawer-wrapper').toggle();
	
	    var icon = $(this).find('.expand-icon');
	    var isOpen = !icon.hasClass('fa-expand');
	    (0, _selectorHelpers.swapClassesViaBool)(icon, "fa-expand", "fa-compress", isOpen);
	    (0, _selectorHelpers.swapClassesViaBool)(currentCompress, "fa-expand", "fa-compress", true);
	    currentCompress.closest(".commerce-drawer-title").next().hide();
	  });
	
	  //Submit search 
	  (0, _submitHelpers.bindHardSubmit)({
	    form: $('.commerce-drawer-search-form'),
	    links: $('.commerce-drawer-search')
	  });
	}

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(571);

/***/ },
/* 573 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lookupFilterElements;
	function lookupFilterElements(namespace) {
	  var self = this;
	
	  self.getElementsMap = function () {
	    var elementsMap = {
	      searchTextInput: "#" + namespace + "searchText",
	      showAdditionalFilterInput: "#" + namespace + "showAdditionalFilter",
	      showDateRangeFilterInput: "#" + namespace + "showDateRange",
	      additionalFilterOuter: "#" + namespace + "additionalFilter",
	      itemsPerPageSelect: "#" + namespace + "itemsPerPage",
	      sortFieldHiddenInput: "#" + namespace + "sortField",
	      sortTypeHiddenInput: "#" + namespace + "sortType",
	      form: "#" + namespace + "filter-form",
	      clearFilters: "#" + namespace + "clearFilters",
	      tableHeaderItems: ".table-header-item",
	      dateRangeFilter: "#" + namespace + "date-range",
	      filterFieldsSelect: "#" + namespace + "filterFields",
	      filterStatusCheckboxes: "#" + namespace + "filter-status a input[type=\"checkbox\"]",
	      filterTypeCheckboxes: "#" + namespace + "filter-type a input[type=\"checkbox\"]",
	      searchFilters: "#" + namespace + "searchFilters",
	      searchCriteria: "#" + namespace + "searchCriteria"
	    };
	    return elementsMap;
	  };
	
	  self.getDocElementsMap = function () {
	    var docElementsMap = {
	      modalFilterType: "#" + namespace + "filter-type",
	      modalFilterStatus: "#" + namespace + "filter-status",
	      modalFilterCancel: '#additional-filter-cancel',
	      applyAddtionalFiltersModalBtn: "#additional-filter-apply",
	      additionalFilterModal: "#" + namespace + "additional-filter-modal",
	      dateRangeModal: "#" + namespace + "date-range-modal",
	      dateRangeModalTitle: "#" + namespace + "date-range-title"
	    };
	    return docElementsMap;
	  };
	}

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.applySessionCachingLogic = applySessionCachingLogic;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function applySessionCachingLogic(els) {
	  els.searchCriteria.val(JSON.stringify(els.searchCriteriaHiddenInput));
	  populateDateFilterDate(els);
	  populateAdditionalFilterData(els);
	}
	
	function populateAdditionalFilterData(els) {
	  if ((0, _general.isPresent)(els.savedFilterCriteria)) {
	    _underscore2.default.each(els.savedFilterCriteria, function (criteria) {
	      if (_underscore2.default.contains(els.additionalFilterkeyArr, criteria.key)) {
	        _underscore2.default.each(criteria.value, function (value) {
	          var currentCheckBox = $(document).find("#" + els.namespace + "additional-filter-modal .filter-list a input[type=\"checkbox\"][value=\"" + value + "\"]");
	          currentCheckBox.prop('checked', true);
	          currentCheckBox.parent().addClass("additional-filter-selected");
	        });
	      }
	    });
	  }
	}
	
	function populateDateFilterDate(els) {
	  /*
	  	for now we are clling filter.js function.
	  	we need refactor this.
	  */
	  window.setCacheCustomDateRange(els.savedFilterCriteria, els.extraDetailForCache.selectedRangeType);
	  window.setCacheFixDateRange(els.extraDetailForCache.selectedRangeType);
	}

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	
	(0, _run2.default)(".amazon-connection-detail", function () {
		var el = (0, _jquery2.default)(".amazon-connection-detail");
		var editPartnerUrl = el.data("amazon-edit-channel-connection-url");
		var inactivateRetPartnerUrl = el.data("amazon-inactivate-channel-url");
		var activateChannelUrl = el.data("amazon-activate-channel-url");
		var viewConnectionDetailUrl = el.data("amazon-view-channel-connection-detail-url");
		var retpartnerJson = el.data("retailer-partners-info");
		var viewChannelDetailUrl = el.data("view-channel-detail-url");
		var modalInactivateChannel = (0, _jquery2.default)("#modalInactivateChannel");
		var modalActivateChannel = (0, _jquery2.default)("#modalActivateChannel");
	
		(0, _jquery2.default)(".inactivate").on("click", function () {
			(0, _jquery2.default)("#deleteModal").appendTo("body").modal("show");
		});
	
		(0, _jquery2.default)(".activate").on("click", function () {
			(0, _jquery2.default)("#activateModal").appendTo("body").modal("show");
		});
	
		modalInactivateChannel.on("click", function () {
			inactivateRetPartner();
		});
	
		modalActivateChannel.on("click", function () {
			activateRetailerPartner();
		});
	
		function inactivateRetPartner() {
			_jquery2.default.ajax({
				url: inactivateRetPartnerUrl,
				success: function success(data) {
					if (data.match("success")) {
						location.href = viewChannelDetailUrl;
					} else {
						alert('<liferay-ui:message key="general-error-message"/>');
					}
				},
				error: function error(data) {
					alert('<liferay-ui:message key="general-error-message"/>');
				}
			});
		}
	
		function activateRetailerPartner() {
			_jquery2.default.ajax({
				url: activateChannelUrl,
				success: function success(data) {
					if (data.match("success")) {
						location.href = viewChannelDetailUrl;
					} else {
						alert('<liferay-ui:message key="general-error-message"/>');
					}
				},
				error: function error(data) {
					alert('<liferay-ui:message key="general-error-message"/>');
				}
			});
		}
	});

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#create-api-channel-form", function () {
	  var createApiChannel = (0, _jquery2.default)("#create-api-channel-form");
	  var viewChannelsUrl = createApiChannel.data("view-channel-url");
	  var apiChannelcancelBtn = (0, _jquery2.default)("#create-api-channel-cancel-btn");
	  var openApiChannelBtn = (0, _jquery2.default)("#open-api-channel-button");
	  var apiUrl = createApiChannel.data("api-url");
	  var helpCenterUrl = createApiChannel.data("help-center-url");
	  var helpCenterBtn = (0, _jquery2.default)("#help-center-button");
	
	  apiChannelcancelBtn.click(function (e) {
	    location.href = viewChannelsUrl;
	  });
	
	  openApiChannelBtn.click(function (e) {
	    window.open(apiUrl);
	    location.href = viewChannelsUrl;
	  });
	  //Help Center URL calling
	  helpCenterBtn.click(function (e) {
	    window.open(helpCenterUrl);
	    location.href = viewChannelsUrl;
	  });
	});

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _reviewTab = __webpack_require__(202);
	
	var _reviewTab2 = _interopRequireDefault(_reviewTab);
	
	var _connectionTab = __webpack_require__(198);
	
	var _connectionTab2 = _interopRequireDefault(_connectionTab);
	
	var _configurationTab = __webpack_require__(197);
	
	var _configurationTab2 = _interopRequireDefault(_configurationTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	__webpack_require__(178);
	
	var wizardTargetSelector = "#p_p_id_channels_WAR_hcportlet_";
	// Live form from jsp
	(0, _run2.default)("#create-channel-form", function () {
	  var el = $("#create-channel-form");
	  attachWizard(el);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  EditChecker.bindNavigation();
	  EditChecker.bindChangeListener("#create-channel-form");
	  EditChecker.bindCancelButton("#create-channel-cancel-btn");
	}
	
	function attachWizard(el) {
	  var wizardElement = el;
	  var amazonCmrDomainConfigData = wizardElement.data("amazon-connection-setup");
	  var realTimeApiRetailerPartnerData = wizardElement.data("retailer-realtime-api-details");
	  var amazonParId = wizardElement.data("amazon-par-id");
	  var amazonMktPlcParId = el.data("amazon-market-palce-par-id");
	  var realTimeApiParId = el.data("realtime-api-par-id");
	  var parId = el.data("partner-id");
	
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  var quickWizard = new _QuickWizard2.default(el, {
	    tabletWidthNavStep: 902,
	    mobileWidthNavStep: 502,
	
	    shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	      var targetForm = _ref.targetForm,
	          direction = _ref.direction;
	
	      // Any time we go traverse backwards, just let us
	      if (direction === "BACKWARDS") {
	        return true;
	      }
	      // handle general validations on forward traversal
	      var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	
	      if (!quickWizard.areInputsValid(allPrevInputs, { displayErrors: true })) {
	        quickWizard.goToFirstIncompleteForm();
	        return false;
	      }
	    },
	    didNavigateToForm: function didNavigateToForm(_ref2) {
	      var currentForm = _ref2.currentForm;
	
	      if (currentForm.filter('.connections-tab').length) {
	        connectionTab.didNavigateToForm();
	      } else if (currentForm.filter('.configuration-tab').length) {
	        configurationTab.didNavigateToForm();
	      } else if (currentForm.filter('.review-tab').length) {
	        reviewTab.didNavigateToForm();
	      }
	    }
	
	  });
	  quickWizard.init();
	  var targetTab = getTargetInitialTab(amazonCmrDomainConfigData);
	
	  if (targetTab) {
	    quickWizard.gotToForm(targetTab);
	  }
	
	  function getTargetInitialTab(amazonCmrDomainConfigData) {
	    if (realTimeApiRetailerPartnerData != "") {
	      return $('.connection-tab');
	    } else {
	      return $('.instructions-tab');
	    }
	  }
	
	  function canSave(quickWizard) {
	    var currentForm = quickWizard.getActiveTargetForm();
	    var isValid = true;
	    if (currentForm.filter(".connection-tab").length) {
	      isValid = areInputsValidForForm(currentForm);
	    }
	    return isValid;
	  }
	
	  var connectionTab = new _connectionTab2.default(quickWizard);
	  connectionTab.init();
	
	  var configurationTab = "";
	  if (amazonMktPlcParId == parId) {
	    configurationTab = new _configurationTab2.default(quickWizard);
	    configurationTab.init();
	  }
	
	  var reviewTab = new _reviewTab2.default(quickWizard);
	  reviewTab.init();
	}

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _ebayReviewTab = __webpack_require__(201);
	
	var _ebayReviewTab2 = _interopRequireDefault(_ebayReviewTab);
	
	var _ebayConnectionsTab = __webpack_require__(200);
	
	var _ebayConnectionsTab2 = _interopRequireDefault(_ebayConnectionsTab);
	
	var _ebayConfigurationsTab = __webpack_require__(199);
	
	var _ebayConfigurationsTab2 = _interopRequireDefault(_ebayConfigurationsTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#create-ebay-channel-form", function () {
	  var el = (0, _jquery2.default)("#create-ebay-channel-form");
	  attachWizard(el);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  EditChecker.bindNavigation();
	  EditChecker.bindChangeListener("#create-ebay-channel-form");
	  EditChecker.bindCancelButton("#create-ebay-channel-cancel-btn");
	}
	
	function attachWizard(el) {
	  var wizardElement = el;
	
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        (0, _jquery2.default)(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	    // Place all your validation rules here!!!
	    // rules: {
	
	    // }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  var quickWizard = new _QuickWizard2.default(el, {
	    tabletWidthNavStep: 902,
	    mobileWidthNavStep: 502,
	
	    // customRules: {
	
	    // },
	    shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	      var targetForm = _ref.targetForm,
	          direction = _ref.direction,
	          currentForm = _ref.currentForm,
	          done = _ref.done;
	
	      //return true;
	      // Any time we go traverse backwards, just let us
	      if (direction === "BACKWARDS") {
	        return true;
	      }
	
	      // handle general validations on forward traversal
	      var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	      if (targetForm.filter('.configurations-tab').length || targetForm.filter('.review-tab').length) {
	        return connectionTab.areInputsValidForForm();
	      } else if (!quickWizard.areInputsValid(allPrevInputs, { displayErrors: true })) {
	        quickWizard.goToFirstIncompleteForm();
	        return false;
	      }
	    },
	    didNavigateToForm: function didNavigateToForm(_ref2) {
	      var currentForm = _ref2.currentForm;
	
	      if (currentForm.filter('.connections-tab').length) {
	        connectionTab.didNavigateToForm();
	      } else if (currentForm.filter('.configurations-tab').length) {
	        configurationTab.didNavigateToForm();
	      } else if (currentForm.filter('.review-tab').length) {
	        reviewTab.didNavigateToForm();
	      }
	    }
	
	  });
	
	  quickWizard.init();
	
	  function canSave(quickWizard) {
	    var currentForm = quickWizard.getActiveTargetForm();
	    var isValid = true;
	    if (currentForm.filter(".connection-tab").length) {
	      isValid = areInputsValidForForm(currentForm);
	    }
	    return isValid;
	  }
	
	  var connectionTab = new _ebayConnectionsTab2.default(quickWizard);
	  connectionTab.init();
	
	  var configurationTab = new _ebayConfigurationsTab2.default(quickWizard);
	  configurationTab.init();
	
	  var reviewTab = new _ebayReviewTab2.default(quickWizard);
	  reviewTab.init();
	}

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _walmartReviewTab = __webpack_require__(205);
	
	var _walmartReviewTab2 = _interopRequireDefault(_walmartReviewTab);
	
	var _walmartConnectionTab = __webpack_require__(204);
	
	var _walmartConnectionTab2 = _interopRequireDefault(_walmartConnectionTab);
	
	var _walmartConfigurationTab = __webpack_require__(203);
	
	var _walmartConfigurationTab2 = _interopRequireDefault(_walmartConfigurationTab);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#create-walmart-channel-form", function (el) {
	  attachWizard(el);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  EditChecker.bindNavigation();
	  EditChecker.bindChangeListener("#create-walmart-channel-form");
	  EditChecker.bindCancelButton("#create-walmart-channel-cancel-btn");
	}
	
	function attachWizard(el) {
	  var wizardElement = el;
	  var retpartner = wizardElement.data("retailer-partners-info");
	
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        (0, _jquery2.default)(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  var quickWizard = new _QuickWizard2.default(el, {
	    tabletWidthNavStep: 902,
	    mobileWidthNavStep: 502,
	
	    shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	      var targetForm = _ref.targetForm,
	          direction = _ref.direction,
	          currentForm = _ref.currentForm,
	          done = _ref.done;
	
	      // Any time we go traverse backwards, just let us
	      if (direction === "BACKWARDS") {
	        return true;
	      }
	
	      // handle general validations on forward traversal
	      var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	      if (currentForm.filter('.configurations-tab').length) {
	        return configTab.didNavigateToForm();
	      }
	
	      if (targetForm.filter('.configurations-tab').length || targetForm.filter('.review-tab').length) {
	        return connectionTab.areInputsValidForForm();
	      } else if (!quickWizard.areInputsValid(allPrevInputs, { displayErrors: true })) {
	        quickWizard.goToFirstIncompleteForm();
	        return false;
	      }
	    },
	    didNavigateToForm: function didNavigateToForm(_ref2) {
	      var currentForm = _ref2.currentForm;
	
	      if (currentForm.filter('.connections-tab').length) {
	        connectionTab.didNavigateToForm();
	      } else if (currentForm.filter('.configurations-tab').length) {
	        configTab.didNavigateToForm();
	      } else if (currentForm.filter('.review-tab').length) {
	        reviewTab.didNavigateToForm();
	      }
	    }
	  });
	
	  quickWizard.init();
	
	  function canSave(quickWizard) {
	    var currentForm = quickWizard.getActiveTargetForm();
	    var isValid = true;
	    if (currentForm.filter(".connection-tab").length) {
	      isValid = areInputsValidForForm(currentForm);
	    }
	    return isValid;
	  }
	
	  var connectionTab = new _walmartConnectionTab2.default(quickWizard);
	  connectionTab.init();
	
	  var configTab = new _walmartConfigurationTab2.default(quickWizard);
	  configTab.init();
	
	  var reviewTab = new _walmartReviewTab2.default(quickWizard);
	  reviewTab.init();
	}

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	
	
	(0, _run2.default)(".retailers_partner-details-page", function () {
		var el = (0, _jquery2.default)(".retailers_partner-details-page");
	
		var editPartnerUrl = el.data("edit-channel-connection-url");
		var inactivateRetPartnerUrl = el.data("inactivate-channel-url");
		var activateChannelUrl = el.data("activate-channel-url");
		var viewConnectionDetailUrl = el.data("view-channel-connection-detail-url");
		var retpartnerJson = el.data("retailer-partners-detail-info");
		var viewChannelDetailUrl = el.data("view-channel-detail-url");
		var modalInactivateChannel = (0, _jquery2.default)("#modalInactivateChannel");
		var modalActivateChannel = (0, _jquery2.default)("#modalActivateChannel");
		var ftpINB = el.data("ftp-inb-details");
		var ftpInboundFoldersTable = el.find('#inb_records_table');
		var ftpOUB = el.data("ftp-oub-details");
		var ftpOutboundFoldersTable = el.find('#oub_records_table');
		var retailerPartnerFileFormat = el.data("retailer-partner-file-format");
		var retailerSelectedFileFormat = retailerPartnerFileFormat.fileFormat;
		var submitModalFlow = new _SubmitModalFlow2.default();
		submitModalFlow.init();
	
		onLoad();
	
		function onLoad() {
			fillInboundFoldersData(ftpINB);
			fillOutboundFoldersData(ftpOUB);
			(0, _jquery2.default)('#channel-file-format').text(retailerSelectedFileFormat);
		}
	
		(0, _jquery2.default)(".inactivate").on("click", function () {
			(0, _jquery2.default)("#deleteModal").appendTo("body").modal("show");
		});
	
		(0, _jquery2.default)(".activate").on("click", function () {
			(0, _jquery2.default)("#activateModal").appendTo("body").modal("show");
		});
	
		modalInactivateChannel.on("click", function () {
			inactivateRetPartner();
		});
	
		modalActivateChannel.on("click", function () {
			activateRetailerPartner();
		});
	
		function inactivateRetPartner() {
			submitModalFlow.showLoadingModal();
			_jquery2.default.ajax({
				url: inactivateRetPartnerUrl,
				success: function success(data) {
					if (data.match("success")) {
						submitModalFlow.showSuccessModal();
						setTimeout(function () {
							location.href = viewChannelDetailUrl;
						}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
					} else {
						submitModalFlow.showFailureModal();
					}
				},
				error: function error(data) {
					submitModalFlow.showFailureModal();
				}
			});
		}
	
		function activateRetailerPartner() {
			submitModalFlow.showLoadingModal();
			_jquery2.default.ajax({
				url: activateChannelUrl,
				success: function success(data) {
					if (data.match("success")) {
						submitModalFlow.showSuccessModal();
						setTimeout(function () {
							location.href = viewChannelDetailUrl;
						}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
					} else {
						submitModalFlow.showFailureModal();
					}
				},
				error: function error(data) {
					submitModalFlow.showFailureModal();
				}
			});
		}
	
		function fillInboundFoldersData(ftpINB) {
			ftpINB.forEach(function (ftpINB) {
				var ftp_inb_folders = ftpINB.cdmValue;
				var trHTML = '';
				trHTML += '<tr><td>' + ftpINB.cdmValue + '</td></tr>';
				ftpInboundFoldersTable.append(trHTML);
			});
		}
	
		function fillOutboundFoldersData(ftpOUB) {
			ftpOUB.forEach(function (ftpOUB) {
				var ftp_oub_folders = ftpOUB.cdmValue;
				var trHTML = '';
				trHTML += '<tr><td>' + ftpOUB.cdmValue + '</td></tr>';
				ftpOutboundFoldersTable.append(trHTML);
			});
		}
	});

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	
	
	(0, _run2.default)(".retailers_partner-ebay-details-page", function () {
		var el = (0, _jquery2.default)(".retailers_partner-ebay-details-page");
	
		var editPartnerUrl = el.data("edit-channel-connection-url");
		var inactivateRetPartnerUrl = el.data("inactivate-channel-url");
		var activateChannelUrl = el.data("activate-channel-url");
		var viewConnectionDetailUrl = el.data("view-channel-connection-detail-url");
		var retpartnerJson = el.data("retailer-partners-detail-info");
		var viewChannelDetailUrl = el.data("view-channel-detail-url");
		var modalInactivateChannel = (0, _jquery2.default)("#modalInactivateChannel");
		var modalActivateChannel = (0, _jquery2.default)("#modalActivateChannel");
		var ebayConnStatusVal = (0, _jquery2.default)("#ebay-conn-status-val");
		var ebayConnAuthMsg = (0, _jquery2.default)(".ebay-conn-auth");
		var ebayConnNotAuthMsg = (0, _jquery2.default)(".ebay-conn-not-auth");
		var ebayOrderProcessStatusVal = (0, _jquery2.default)("#ebay-order-process-status-val");
		var ebayOrdProcessYes = (0, _jquery2.default)(".ord-process-yes");
		var ebayOrdProcessNo = (0, _jquery2.default)(".ord-process-no");
		var ebayOrdprocessToggleMsg = (0, _jquery2.default)(".order-process-yes-no-toggle");
		var ebayOrdProcessStartDateTime = (0, _jquery2.default)(".order-process-start-date-time");
		var ebayConnAuthStatusVal = (0, _jquery2.default)("#ebay-conn-auth-status-val");
		var ebayActiveInactiveBtn = (0, _jquery2.default)("#active-inactive-button");
		var submitModalFlow = new _SubmitModalFlow2.default();
		submitModalFlow.init();
	
		onLoad();
	
		function onLoad() {
			checkEbayConnStatus();
			checkOrderProcessStatus();
		}
	
		function checkEbayConnStatus() {
			if (ebayConnStatusVal.val() == 'true' && ebayConnAuthStatusVal.val() == '1') {
				ebayConnAuthMsg.show();
				ebayConnNotAuthMsg.hide();
			} else if (ebayConnStatusVal.val() == 'false' && ebayConnAuthStatusVal.val() == '1') {
				ebayConnAuthMsg.show();
				ebayConnNotAuthMsg.hide();
			} else {
				ebayConnAuthMsg.hide();
				ebayConnNotAuthMsg.show();
				ebayActiveInactiveBtn.hide();
			}
		}
	
		function checkOrderProcessStatus() {
			if (ebayOrderProcessStatusVal.val() == 'true') {
				ebayOrdProcessYes.show();
				ebayOrdprocessToggleMsg.show();
				ebayOrdProcessStartDateTime.show();
				ebayOrdProcessNo.hide();
			} else {
				ebayOrdProcessYes.hide();
				ebayOrdprocessToggleMsg.hide();
				ebayOrdProcessStartDateTime.hide();
				ebayOrdProcessNo.show();
			}
		}
	
		(0, _jquery2.default)(".inactivate").on("click", function () {
			(0, _jquery2.default)("#deleteModal").appendTo("body").modal("show");
		});
	
		(0, _jquery2.default)(".activate").on("click", function () {
			(0, _jquery2.default)("#activateModal").appendTo("body").modal("show");
		});
	
		modalInactivateChannel.on("click", function () {
			inactivateRetPartner();
		});
	
		modalActivateChannel.on("click", function () {
			activateRetailerPartner();
		});
	
		function inactivateRetPartner() {
			submitModalFlow.showLoadingModal();
			_jquery2.default.ajax({
				url: inactivateRetPartnerUrl,
				success: function success(data) {
					if (data.match("success")) {
						submitModalFlow.showSuccessModal();
						setTimeout(function () {
							location.href = viewChannelDetailUrl;
						}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
					} else {
						submitModalFlow.showFailureModal();
					}
				},
				error: function error(data) {
					submitModalFlow.showFailureModal();
				}
			});
		}
	
		function activateRetailerPartner() {
			submitModalFlow.showLoadingModal();
			_jquery2.default.ajax({
				url: activateChannelUrl,
				success: function success(data) {
					if (data.match("success")) {
						submitModalFlow.showSuccessModal();
						setTimeout(function () {
							location.href = viewChannelDetailUrl;
						}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
					} else {
						submitModalFlow.showFailureModal();
					}
				},
				error: function error(data) {
					submitModalFlow.showFailureModal();
				}
			});
		}
	});

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(577);
	
	__webpack_require__(198);
	
	__webpack_require__(202);
	
	__webpack_require__(575);
	
	__webpack_require__(580);
	
	__webpack_require__(197);
	
	__webpack_require__(576);
	
	__webpack_require__(578);
	
	__webpack_require__(200);
	
	__webpack_require__(199);
	
	__webpack_require__(201);
	
	__webpack_require__(581);
	
	__webpack_require__(583);
	
	__webpack_require__(579);
	
	__webpack_require__(204);
	
	__webpack_require__(203);
	
	__webpack_require__(205);

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)(".walmart-connection-details", function (mainEl) {
	  var editPartnerUrl = mainEl.data("wmt-edit-channel-connection-url");
	  var inactivateChannelUrl = mainEl.data("wmt-inactivate-channel-url");
	  var activateChannelUrl = mainEl.data("wmt-activate-channel-url");
	  var viewChannelDetailUrl = mainEl.data("wmt-view-channel-detail-url");
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  var els = {};
	  var elementsMap = {
	    inactivateBtn: ".inactivate-walmart-connection",
	    activateBtn: ".activate-walmart-connection",
	    pencilIcon: ".fa-pencil",
	    editBtn: ".wmt-edit-partner-url"
	  };
	  // elements at document scope
	  var docElementsMap = {
	    inactivateModal: "#wmtInactivateModal",
	    activateModal: "#wmtActivateModal",
	    inactivateModalBtn: "#wmtInactivateChannel",
	    activateModalBtn: "#wmtActivateChannel"
	  };
	
	  onLoad();
	
	  function onLoad() {
	    setElements();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	    (0, _selectorHelpers.setElementsFromScope)(els, docElementsMap, (0, _jquery2.default)(document));
	  }
	
	  els.editBtn.on('click', function () {
	    editWmtConnection();
	  });
	
	  els.pencilIcon.on('click', function () {
	    editWmtConnection();
	  });
	
	  els.inactivateBtn.on("click", function () {
	    els.inactivateModal.modal("show");
	  });
	
	  els.activateBtn.on("click", function () {
	    els.activateModal.modal("show");
	  });
	
	  function editWmtConnection() {
	    location.href = '' + editPartnerUrl;
	  }
	
	  els.inactivateModalBtn.on('click', function () {
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      url: inactivateChannelUrl,
	      success: onSuccess,
	      error: onError
	    });
	  });
	
	  els.activateModalBtn.on('click', function () {
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      url: activateChannelUrl,
	      success: onSuccess,
	      error: onError
	    });
	  });
	
	  function onSuccess(data) {
	    if (data.match("success")) {
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        location.href = viewChannelDetailUrl;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function onError(data) {
	    submitModalFlow.showFailureModal();
	  }
	});

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _typeAheadSource = __webpack_require__(71);
	
	var _typeAheadSource2 = _interopRequireDefault(_typeAheadSource);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _select2able = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	var attributeRowHtml = __webpack_require__(1272);
	var conditionRowHtml = __webpack_require__(1273);
	
	(0, _run2.default)("#rule-disp-merch-config-div", function () {
	  var mainEl = $("#rule-disp-merch-config-div");
	  var productLookUpURL = mainEl.data('product-lookup-url');
	  var productSkuTypeAhead = mainEl.find("#product-sku-typeahead");
	  var attribMaxReachedError = mainEl.find(".attrib-max-reached-error");
	  var conditionMaxReachedError = mainEl.find(".condition-max-reached-error");
	  var rule = mainEl.data("rule");
	  var ruleOutputs = mainEl.data("rule-outputs");
	  var evaluator = mainEl.find('#select-an-evaluator');
	  var evaluatorValue = mainEl.find('#select-an-evaluator-value');
	  var isDuplicate = mainEl.data("duplicate-flag");
	  var costRetailBtnGroupEl = mainEl.find(".cost-retail-toggler");
	  var costRetailBtnGroup = new _QuickBtnGroup2.default(costRetailBtnGroupEl, { distributeWidth: true });
	  costRetailBtnGroup.init();
	  var isEdit = false;
	
	  attachWizard(mainEl);
	  setupEditChecker();
	  setWidgets();
	  if (rule != "" && rule.cbrId > 0) {
	    isEdit = true;
	  }
	
	  function setWidgets() {
	    instantiateSkuTypeAhead();
	  }
	
	  function getSelectedValuesOfSelect2ById(id) {
	    var dataText = "";
	    $('#' + id + ' option:selected').each(function () {
	      var $this = $(this);
	      if ($.inArray($this.text(), listBuild) == -1) {
	        listBuild.push($this.text());
	      }
	    });
	
	    for (var i = 0; i < listBuild.length; i++) {
	      if (!dataText.includes(listBuild[i]) && i < listBuild.length - 1) {
	        dataText = dataText.concat(listBuild[i].concat(", "));
	      } else {
	        dataText = dataText.concat(listBuild[i].concat(" "));
	      }
	    }
	    return dataText;
	  }
	
	  function instantiateSkuTypeAhead() {
	    var select2AjaxDefaults = {
	      dataType: 'json',
	      delay: 250,
	      processResults: function processResults(data, params) {
	        params.page = params.page || 1;
	        return {
	          results: data,
	          pagination: {
	            more: params.page * 20 < data.total_count
	          }
	        };
	      },
	      cache: true
	    };
	
	    productSkuTypeAhead.select2({
	      placeholder: "Begin typing a SKU to add to this order",
	      allowClear: true,
	      ajax: _extends({}, select2AjaxDefaults, {
	        url: productLookUpURL,
	        cache: false,
	        data: configureDataCallback({
	          paramKey: 'likeSku'
	        })
	      }),
	      minimumInputLength: 3
	    });
	
	    function configureDataCallback(_ref) {
	      var paramKey = _ref.paramKey;
	
	      return function (params) {
	        return _defineProperty({}, paramKey, params.term);
	      };
	    }
	  }
	
	  $(document).on('change', 'select', function (e) {
	    var attr = this.id;
	    var indexId = attr.substring(attr.length - 1);
	    if (attr.startsWith('attributeName_')) {
	      if (this.value == '') {
	        $(".attribute-row").find("#attributeValue_" + indexId).val("");
	      }
	    }
	  });
	
	  $(".addAttribButton").on("click", function (e, key, value, rowIdx) {
	    e.preventDefault();
	    var numOfAttribRows = $(".attribute-row").length;
	    if (numOfAttribRows < 8) {
	      var ruleInclAttributesRowClass = mainEl.find(".rule-attrib-row-div");
	      var ruleInclAttributes = mainEl.data("rule-incl-attribues-from-server");
	      var attributeRow = (0, _render2.default)(attributeRowHtml, {
	        index: rowIdx ? rowIdx : numOfAttribRows + 1,
	        attributesHtml: renderAttributesHTML(ruleInclAttributes, key)
	      });
	      ruleInclAttributesRowClass.append(attributeRow);
	    } else {
	      attribMaxReachedError.show();
	    }
	    (0, _select2able.instantiateSelect2)($('.select2-select'));
	  });
	
	  function renderAttributesHTML(ruleInclAttributes, key) {
	    if (ruleInclAttributes != null) {
	      var html = '<option></option><option value="{%-value%}" {%- selected %} >{%-display%}</option>';
	      var optionHtml = ruleInclAttributes.map(function (row) {
	        return (0, _render2.default)(html, {
	          value: row.cdmValue,
	          selected: getselectedValue(row.cdmValue, key),
	          display: row.cdmMeaning
	        });
	      });
	      return optionHtml.join('');
	    }
	  }
	
	  function getselectedValue(value, key) {
	    if (value == key) {
	      return "selected";
	    } else {
	      return "";
	    }
	  }
	  $(".addConditionButton").on("click", function (e, condition, disposition, vas) {
	    e.preventDefault();
	    var numOfConditionRows = $(".condition-row").length;
	    var ruleInclConditions = mainEl.data("rule-incl-conditions-from-server");
	    var ruleIncConditionRowClass = mainEl.find(".rule-condition-row-div");
	    var ruleInclDispositions = mainEl.data("rule-incl-dispositions-from-server");
	    var ruleInclVas = mainEl.data("rule-incl-vas-from-server");
	
	    if (numOfConditionRows < ruleInclConditions.length) {
	      var conditionRow = (0, _render2.default)(conditionRowHtml, {
	        output: numOfConditionRows + 1 == 1 ? numOfConditionRows + 1 + '*' : numOfConditionRows + 1,
	        index: numOfConditionRows + 1,
	        conditionHtml: renderConditionHTML(ruleInclConditions, condition),
	        dispositionHtml: renderDispositionHTML(ruleInclDispositions, disposition),
	        vasHtml: renderVasHTML(ruleInclVas, vas)
	      });
	      ruleIncConditionRowClass.append(conditionRow);
	    } else {
	      conditionMaxReachedError.text('No more conditions can be added.');
	      conditionMaxReachedError.show();
	    }
	    (0, _select2able.instantiateSelect2)($('.select2-select'));
	  });
	
	  function renderConditionHTML(ruleInclConditions, condition) {
	    if (ruleInclConditions != null) {
	      var html = '<option></option><option value="{%-value%}" {%- selected %} >{%-display%}</option>';
	      return ruleInclConditions.map(function (row) {
	        return (0, _render2.default)(html, {
	          value: row.cdmValue,
	          selected: getselectedValue(row.cdmValue, condition),
	          display: row.cdmMeaning
	        });
	      }).join('');
	    }
	  }
	
	  function renderDispositionHTML(ruleInclDispositions, disposition) {
	    if (ruleInclDispositions != null) {
	      var html = '<option></option><option value="{%-value%}" {%- selected %} >{%-display%}</option>';
	      return ruleInclDispositions.map(function (row) {
	        return (0, _render2.default)(html, {
	          value: row.cdmValue,
	          selected: getselectedValue(row.cdmValue, disposition),
	          display: row.cdmMeaning
	        });
	      }).join('');
	    }
	  }
	
	  function renderVasHTML(ruleInclVas, vas) {
	    if (ruleInclVas != null) {
	      var html = '<option></option><option value="{%-value%}" {%- selected %} >{%-display%}</option>';
	      return ruleInclVas.map(function (row) {
	        return (0, _render2.default)(html, {
	          value: row.cdmValue,
	          selected: getselectedValue(row.cdmValue, vas),
	          display: row.cdmMeaning
	        });
	      }).join('');
	    }
	  }
	  if (!isEdit) {
	    $(".addConditionButton").trigger("click");
	  }
	  populateEditDuplicateForm();
	  function populateEditDuplicateForm() {
	    if (isEdit) {
	      if (!isDuplicate) {
	        $("#return-rule-name").val(rule.cbrName);
	        $("#return-rule-description").val(rule.cbrDescription);
	        $("#cbrId").val(rule.cbrId);
	      }
	      var conditions = rule.cmrRuleConditions;
	      var attributeIndex = 0;
	      for (var i = 0; i < conditions.length; i++) {
	        if (conditions[i].crcName === "SKU") {
	          var params = conditions[i].cmrRuleParams;
	          if (params) {
	            var selectedValues = new Array();
	            for (var j = 0; j < params.length; j++) {
	              selectedValues[j] = params[j].crpValue;
	            }
	            $("#productsInOrder").val(selectedValues);
	            var relatedSelectPillsArray = (0, _underscore2.default)(params).pluck("crpValue");
	            (0, _selectorHelpers.setOptionsForSelect)({
	              selectElement: productSkuTypeAhead,
	              list: params,
	              valueDataKey: "crpValue",
	              textDataKey: "crpValue",
	              initialSelectValue: relatedSelectPillsArray
	            });
	          }
	        } else if (conditions[i].crcName === "Item Cost" || conditions[i].crcName === "Item Retail") {
	          var _params = conditions[i].cmrRuleParams;
	          if (_params) {
	            for (var _j = 0; _j < _params.length; _j++) {
	              costRetailBtnGroup.activateBtnViaKey(_params[_j].crpKey);
	              evaluator.val(conditions[i].crcOperator);
	              evaluatorValue.val(_params[_j].crpValue);
	            }
	          }
	        } else {
	          var _params2 = conditions[i].cmrRuleParams;
	          if (_params2) {
	            attributeIndex = attributeIndex + 1;
	            for (var _j2 = 0; _j2 < _params2.length; _j2++) {
	              $(".addAttribButton").trigger("click", [conditions[i].crcName, _params2[_j2].crpValue, attributeIndex]);
	              $("#attributeValue_" + attributeIndex).val(_params2[_j2].crpValue);
	            }
	          }
	        }
	      }
	      if (ruleOutputs) {
	        for (var _i = 0; _i < ruleOutputs.length; _i++) {
	          $(".addConditionButton").trigger("click", [ruleOutputs[_i].condition, ruleOutputs[_i].disposition, ruleOutputs[_i].vas]);
	        }
	      }
	    }
	  }
	  $(document).ready(function () {
	    if (isEdit) {
	      var dateRangeStart = $("#rule-disp-merch-config-div").find(".date-range-datepicker-start");
	      var dateRangeEnd = $("#rule-disp-merch-config-div").find(".date-range-datepicker-end");
	      dateRangeStart.val(rule.cbrEffectiveStartDate);
	      dateRangeEnd.val(rule.cbrEffectiveEndDate);
	    }
	  });
	}); // end run
	
	function setupEditChecker() {
	  _EditChecker2.default.bindNavigation();
	  _EditChecker2.default.bindChangeListener("#rule-disp-merch-config-div");
	  _EditChecker2.default.bindCancelButton(".return-rule-cancel-btn");
	}
	
	function attachWizard(mainEl) {
	  var submitRuleURL = mainEl.data("submit-return-rule");
	
	  var submitModalTitleTxt = mainEl.data("submit-modal-title-txt");
	  var submitModalBodyTxt = mainEl.data("submit-modal-body-txt");
	  var submitModalBtnTxt = mainEl.data("submit-modal-btn-txt");
	
	  var doc = $(document);
	
	  var validator = $("#rule-disp-merch-config-div").validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	  $(".save-new-return-rule-btn").on("click", function (e) {
	    e.preventDefault();
	    mainEl.find(".attrib-max-reached-error").hide();
	    mainEl.find(".condition-max-reached-error").hide();
	
	    var isValid = false;
	
	    var prodSku = mainEl.find("#product-sku-typeahead");
	    var attribNameArr = getArr(".attribute-row", "#attributeName_");
	    var attribValArr = getArr(".attribute-row", "#attributeValue_");
	
	    if (prodSku.val().length == 0 && _underscore2.default.compact(attribNameArr).length == 0) {
	      mainEl.find(".incl-error").show();
	      isValid = true;
	    } else {
	      mainEl.find(".incl-error").hide();
	    }
	
	    attribValArr.forEach(function nullCheck(item, index) {
	      var j = index + 1;
	
	      if (item == '' && mainEl.find("#attributeName_" + j).val() != '') {
	        mainEl.find(".attrib-val-error_" + j).show();
	        isValid = true;
	      } else if (item != '' && mainEl.find("#attributeName_" + j).val() == '') {
	        mainEl.find(".attrib-name-error_" + j).show();
	        isValid = true;
	      } else {
	        mainEl.find(".attrib-name-error_" + j).hide();
	        mainEl.find(".attrib-val-error_" + j).hide();
	      }
	    });
	
	    if (hasDup(attribNameArr)) {
	      mainEl.find(".attrib-max-reached-error").text("Please fix the duplicate attributes.");
	      mainEl.find(".attrib-max-reached-error").show();
	      isValid = true;
	    }
	
	    var evalId = mainEl.find("#select-an-evaluator");
	    var evalValue = mainEl.find("#select-an-evaluator-value");
	
	    if (evalId.val() != '' && evalValue.val() == '') {
	      mainEl.find(".eval-error").show();
	      isValid = true;
	    } else {
	      mainEl.find(".eval-error").hide();
	    }
	
	    var conditionArr = getArr(".condition-row", "#condition_");
	    var dispositionArr = getArr(".condition-row", "#disposition_");
	    var vasArr = getArr(".condition-row", "#vas_");
	
	    conditionArr.forEach(function firstCondCheck(item, index) {
	      if (index + 1 == 1) {
	        if (item == '') {
	          mainEl.find(".cond-sel-error_1").show();
	          mainEl.find(".disp-sel-error_1").show();
	          isValid = true;
	        } else {
	          mainEl.find(".cond-sel-error_1").hide();
	          mainEl.find(".disp-sel-error_1").hide();
	        }
	      }
	    });
	
	    if (hasDup(conditionArr)) {
	      mainEl.find(".condition-max-reached-error").text("Please fix the duplicate Conditions.");
	      mainEl.find(".condition-max-reached-error").show();
	      isValid = true;
	    }
	
	    dispositionArr.forEach(function nullCheck(item, index) {
	      var k = index + 1;
	      if (k == 1 && item == '') {
	        mainEl.find(".disp-sel-error_" + k).show();
	        isValid = true;
	      } else {
	        if (item == '' && mainEl.find("#condition_" + k).val() != '') {
	          mainEl.find(".disp-sel-error_" + k).show();
	          isValid = true;
	        } else {
	          mainEl.find(".disp-sel-error_" + k).hide();
	        }
	      }
	    });
	
	    if (validator.elements().valid()) {
	      var startDate = $("#rule-disp-merch-config-div").find(".date-range-datepicker-start").val();
	      var endDate = $("#rule-disp-merch-config-div").find(".date-range-datepicker-end").val();
	
	      if (startDate != null && endDate != null) {
	        if (endDate < startDate) {
	          mainEl.find(".date-error").text("End Date should be greater than Start Date.");
	          mainEl.find(".date-error").show();
	          isValid = true;
	        }
	      }
	
	      if (isValid) {
	        return false;
	      }
	
	      var submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: submitModalTitleTxt,
	        confirmModalBody: '<div class="q-pad-all-xl">' + submitModalBodyTxt + '</div>',
	        confirmModalBtnText: submitModalBtnTxt,
	
	        onConfirmClick: function onConfirmClick() {
	          submitModalFlow.showLoadingModal();
	          submitRule({ url: submitRuleURL, success: submitRuleSuccess, error: submitRuleError });
	
	          function submitRule(_ref3) {
	            var url = _ref3.url,
	                success = _ref3.success,
	                error = _ref3.error;
	
	            $.ajax({
	              data: $('#rule-disp-merch-config-div').serialize() + "&startDate=" + startDate + "&endDate=" + endDate + "&attribNameArr=" + attribNameArr + "&attribValArr=" + attribValArr + "&conditionArr=" + conditionArr + "&dispositionArr=" + dispositionArr + "&vasArr=" + vasArr,
	              url: url,
	              dataType: 'JSON',
	              type: 'POST',
	              success: success,
	              error: error
	            });
	          }
	
	          function submitRuleSuccess(cbrId) {
	            if (cbrId > 0) {
	              _EditChecker2.default.setPageClean();
	              var ruleDetailUrl = mainEl.data("rule-details-url");
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = ruleDetailUrl + '&cbrId=' + cbrId;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            } else {
	              submitModalFlow.showFailureModal();
	            }
	          }
	
	          function submitRuleError() {
	            submitModalFlow.hideAllModals();
	          }
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	
	    function getArr(div, element) {
	      var len = $(div).length;
	      var arr = [];
	      for (var i = 1; i <= len; i++) {
	        arr.push($(element + i).val());
	      }
	      return arr;
	    }
	
	    function hasDup(srcArr) {
	      var remDup = function remDup(arrArg) {
	        return arrArg.filter(function (elem, pos, arr) {
	          return arr.indexOf(elem) == pos;
	        });
	      };
	      var tempArr = remDup(srcArr);
	
	      if (_underscore2.default.compact(srcArr).length == 0) {
	        return false;
	      }
	      if (_underscore2.default.compact(srcArr).length == tempArr.length) {
	        if (srcArr.includes('')) {
	          return true;
	        } else {
	          return false;
	        }
	      } else if (_underscore2.default.compact(srcArr).length > tempArr.length) {
	        return true;
	      }
	    }
	  });
	
	  doc.on('click', '#rule-disp-merch-config-div', handleClick);
	  function handleClick(e) {
	    _EditChecker2.default.setPageDirty();
	    e.preventDefault();
	  }
	} // end attachwizard

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(584);

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _typeAheadSource = __webpack_require__(71);
	
	var _typeAheadSource2 = _interopRequireDefault(_typeAheadSource);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	// Live form from jsp
	(0, _run2.default)("#collateral-rule-form", function () {
	  var el = $("#collateral-rule-form");
	  attachWizard(el);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  _EditChecker2.default.bindNavigation();
	  _EditChecker2.default.bindChangeListener("#collateral-rule-form");
	  _EditChecker2.default.bindCancelButton(".collateral-rule-cancel-btn");
	}
	
	function attachWizard(el) {
	  var productSkus = el.data("rule-product-skus");
	  var channels = el.data("rule-channels");
	  var submitRuleURL = el.data("submit-collateral-rule");
	  var collateralSkus = el.data("rule-collateral-skus");
	  var submitModalTitleTxt = el.data("submit-modal-title-txt");
	  var submitModalBodyTxt = el.data("submit-modal-body-txt");
	  var submitModalBtnTxt = el.data("submit-modal-btn-txt");
	  var date = new Date();
	  var doc = $(document);
	
	  var defaultInclusionFrequency = el.data("collateral-inclusion-frequency-defaults");
	  var inclusionFrequencySelect = el.find("#inclusion-frequency");
	
	  var defaultOutOfStockHandling = el.data("collateral-out-of-stock-handling");
	  var outOfStockHandlingSelect = el.find("#out-of-stock-handling");
	
	  var defaultInclusionCondition = el.data("collateral-inclusion-condition");
	  var inclusionConditionSelect = el.find("#inclusion-condition");
	
	  var ruleSummarySection = el.find(".rule-summary-section");
	  var orderValueInSummary = el.find(".order-value");
	
	  var summaryEffectiveEndDate = el.find(".summaryEffectiveEndDate");
	  var summaryEffectiveStartDate = el.find(".summaryEffectiveStartDate");
	
	  var dateRangeInputs = el.find(".func-date-range-input");
	  var existingRule = el.data("collateral-existing-rule");
	
	  var typeAheadItems = el.data("rule-collateral-typeahead-skus");
	  var existingCollateralSkus = el.data("existing-collateral-skus");
	
	  var ruleSummaryInclusionCondition = el.find(".rule-summary-inclusion-condition");
	  var ruleSummaryInclusionFrequency = el.find(".rule-summary-inclusion-frequency");
	  var ruleSummaryOrderConditions = el.find('.order-conditions');
	  var ruleSummaryOrderQuantity = el.find('.order-quantity');
	  var ruleSummaryOrderQuantityValue = el.find('.order-quantity-value');
	  var ruleSummaryOrderType = el.find('.order-type');
	  var ruleSummaryOrderTypeValue = el.find('.order-type-value');
	  var ruleSummaryOrderChannel = el.find('.order-channel');
	  var ruleSummaryOrderChannelValue = el.find('.order-channel-value');
	  var ruleSummaryConjunction = el.find('.order-conditions-conjunction');
	  var ruleSummaryOrderSkuValue = el.find('.order-sku-value');
	
	  var productsInOrderSelect2 = el.find("#productsInOrder");
	
	  var collateralRuleConditionsDiv = el.find(".collateral-rule-conditions");
	
	  var byValOfOrderToggler = el.find('#byValOfOrder');
	  var byQuantityOfOrder = el.find('#byQuantityOfOrder');
	  var byTypeOfOrder = el.find('#byTypeOfOrder');
	  var byChannel = el.find('#byChannel');
	  var productLookUpURL = el.data('product-lookup-url');
	
	  var listBuild = "";
	
	  dateRangeInputs.datepicker({
	    startDate: date,
	    todayBtn: "linked",
	    keyboardNavigation: false,
	    autoclose: true
	  });
	  dateRangeInputs.datepicker().on("changeDate", function () {
	    // THIS IS IMPORTANT, YOU MUST VALIDATE
	    var dateInput = $(this);
	    var otherDateInput = dateRangeInputs.not(dateInput);
	    dateInput.valid();
	
	    if ((0, _general.isPresent)(validator.invalid[otherDateInput.attr("id")])) {
	      // always attempt to validate the opposite of the range if
	      // other field has already been invalidated,
	      // because jquery validation forces us to check
	      // due to the fact that all validations
	      // don't fire on change of one, so make sure
	      // the range validation runs on change of either
	      dateRangeInputs.not(dateInput).valid();
	    }
	  });
	
	  $(".select2-select").on("change", function () {
	    $(this).valid();
	  });
	
	  var select2AjaxDefaults = {
	    dataType: 'json',
	    delay: 250,
	    processResults: function processResults(data, params) {
	      params.page = params.page || 1;
	      return {
	        results: data,
	        pagination: {
	          more: params.page * 20 < data.total_count
	        }
	      };
	    },
	    cache: true
	  };
	
	  function configureDataCallback(_ref) {
	    var paramKey = _ref.paramKey;
	
	    return function (params) {
	      return _defineProperty({}, paramKey, params.term);
	    };
	  }
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: inclusionFrequencySelect,
	    list: defaultInclusionFrequency,
	    valueDataKey: "cdmValue",
	    textDataKey: "cdmDescription",
	    initialSelectValue: function initialSelectValue() {
	      return existingRule.cbrInclusionFrequency || /per-order/i;
	    }
	  });
	
	  if (existingRule.cbrInclusionFrequency != null) {
	    inclusionFrequencySetup(inclusionFrequencySelect, existingRule.cbrInclusionFrequency);
	  } else {
	    inclusionFrequencySetup(inclusionFrequencySelect, "per-order");
	  }
	
	  inclusionFrequencySelect.on("change", function () {
	    inclusionFrequencySetup(this.id, this.value);
	  });
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: outOfStockHandlingSelect,
	    list: defaultOutOfStockHandling,
	    valueDataKey: "cdmValue",
	    textDataKey: "cdmDescription",
	    initialSelectValue: function initialSelectValue() {
	      return existingRule.cbrOutOfStockHandling || /release/i;
	    }
	  });
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: inclusionConditionSelect,
	    list: defaultInclusionCondition,
	    valueDataKey: "cdmValue",
	    textDataKey: "cdmDescription",
	    initialSelectValue: function initialSelectValue() {
	      return existingRule.cbrInclusionCondition || /all-orders/i;
	    }
	  });
	
	  if (existingRule.cbrInclusionCondition != null) {
	    inclusionConditionSetup(inclusionConditionSelect, existingRule.cbrInclusionCondition);
	  } else {
	    inclusionConditionSetup(inclusionConditionSelect, "all-orders");
	  }
	
	  inclusionConditionSelect.on("change", function () {
	    clearSummarySections();
	    inclusionConditionSetup(this.id, this.value);
	  });
	
	  if (existingRule.cbrEffectiveStartDate != null) {
	    summaryEffectiveStartDate.text("from " + existingRule.cbrEffectiveStartDate);
	  } else {
	    summaryEffectiveStartDate.text("from " + $("#effectiveStartDate").val());
	  }
	
	  if (existingRule.cbrEffectiveEndDate != null) {
	    summaryEffectiveEndDate.text("- " + existingRule.cbrEffectiveEndDate);
	  } else {
	    summaryEffectiveEndDate.text("- " + $("#effectiveEndDate").val());
	  }
	
	  $("#effectiveEndDate").on("change", function () {
	    summaryEffectiveEndDate.text("- " + $("#effectiveEndDate").val());
	  });
	
	  $("#effectiveStartDate").on("change", function () {
	    summaryEffectiveStartDate.text("from " + $("#effectiveStartDate").val());
	  });
	
	  var dateRangeValidationObject = {
	    dateRange: [{
	      dateStart: function dateStart() {
	        return $("#effectiveStartDate");
	      },
	      dateEnd: function dateEnd() {
	        return $("#effectiveEndDate");
	      }
	    }]
	  };
	
	  var validator = $("#collateral-rule-form").validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    },
	    rules: {
	      effectiveEndDate: dateRangeValidationObject,
	      valOfOrder: {
	        currencyDollarsCents: true
	      },
	      quantityOfOrderVal: {
	        min: 1,
	        wholeNumber: true
	      }
	    }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  var costRetailBtnGroupEl = el.find(".cost-retail-toggler");
	  var costRetailBtnGroup = new _QuickBtnGroup2.default(costRetailBtnGroupEl, { distributeWidth: true });
	  costRetailBtnGroup.init();
	
	  var orderTypeBtnGroupEl = el.find(".order-type-toggler");
	  var orderTypeBtnGroup = new _QuickBtnGroup2.default(orderTypeBtnGroupEl, { distributeWidth: true });
	  orderTypeBtnGroup.init();
	
	  var collateralRuleLogicEl = el.find(".collateral-rule-logic-toggler");
	  var collateralRuleLogicBtnGroup = new _QuickBtnGroup2.default(collateralRuleLogicEl, { distributeWidth: true });
	  collateralRuleLogicBtnGroup.init();
	
	  // $(productSkus).each(function(){
	  //   const option = $('<option />');
	  //   option.attr('value', this.itmSku).text(this.itmSku);
	  //   $("#productsInOrder").append(option);
	  // });
	
	  $(channels).each(function () {
	    var option = $('<option />');
	    option.attr('value', this.channelName).text(this.channelName);
	    $("#channelInput").append(option);
	  });
	
	  isEdit();
	
	  function isEdit() {
	
	    if (!existingCollateralSkus || existingCollateralSkus.length <= 0) {
	      $(".apply-to-collateral-empty").show();
	      $(".apply-to-collateral-exists").hide();
	    }
	
	    if (existingRule) {
	      $("#rule-name").val(existingRule.cbrName);
	      $("#rule-description").val(existingRule.cbrDescription);
	      $("#effectiveStartDate").val(existingRule.cbrEffectiveStartDate);
	      $("#effectiveEndDate").val(existingRule.cbrEffectiveEndDate);
	      collateralRuleLogicBtnGroup.activateBtnViaKey(existingRule.ruleLogic);
	      var conditions = existingRule.cmrRuleConditions;
	      if (conditions && "Specific Conditions" === existingRule.ruleLogic) {
	        for (var i = 0; i < conditions.length; i++) {
	          if (conditions[i].byValOfOrder) {
	            $('#byValOfOrder').prop('checked', true);
	            var params = conditions[i].cmrRuleParams;
	            if (params) {
	              for (var j = 0; j < params.length; j++) {
	                $("#gte-dollars-1").val(params[j].crpValue);
	                costRetailBtnGroup.activateBtnViaKey(params[j].crpKey);
	              }
	            }
	          } else if (conditions[i].byProductsInOrder) {
	            $('#byProductsInOrder').prop('checked', true);
	            var _params = conditions[i].cmrRuleParams;
	
	            if (_params) {
	              var selectedValues = new Array();
	              for (var _j = 0; _j < _params.length; _j++) {
	                selectedValues[_j] = _params[_j].crpValue;
	              }
	
	              $("#productsInOrder").val(selectedValues);
	              var relatedSelectPillsArray = (0, _underscore2.default)(_params).pluck("crpValue");
	              (0, _selectorHelpers.setOptionsForSelect)({
	                selectElement: productsInOrderSelect2,
	                list: _params,
	                valueDataKey: "crpValue",
	                textDataKey: "crpValue",
	                initialSelectValue: relatedSelectPillsArray
	              });
	
	              listBuild = [];
	              listBuild = selectedValues;
	              ruleSummaryOrderSkuValue.text(getSelectedValuesOfSelect2ById('productsInOrder'));
	            }
	          } else if (conditions[i].byQuantityOfOrder) {
	            $('#byQuantityOfOrder').prop('checked', true);
	            var _params2 = conditions[i].cmrRuleParams;
	            if (_params2) {
	              for (var _j2 = 0; _j2 < _params2.length; _j2++) {
	                $("#quantityOfOrderVal").val(_params2[_j2].crpValue);
	              }
	            }
	          } else if (conditions[i].byTypeOfOrder) {
	            $('#byTypeOfOrder').prop('checked', true);
	            var _params3 = conditions[i].cmrRuleParams;
	            if (_params3) {
	              for (var _j3 = 0; _j3 < _params3.length; _j3++) {
	                orderTypeBtnGroup.activateBtnViaKey(_params3[_j3].crpValue);
	              }
	            }
	          } else if (conditions[i].byChannel) {
	            $('#byChannel').prop('checked', true);
	            var _params4 = conditions[i].cmrRuleParams;
	            if (_params4) {
	              var _selectedValues = new Array();
	              for (var _j4 = 0; _j4 < _params4.length; _j4++) {
	                _selectedValues[_j4] = _params4[_j4].crpValue;
	              }
	              $("#channelInput").val(_selectedValues);
	              listBuild = [];
	              listBuild = _selectedValues;
	              ruleSummaryOrderChannelValue.text(getSelectedValuesOfSelect2ById('channelInput'));
	            }
	          }
	        }
	        prepareSummaryForOrderConditions();
	      }
	    }
	
	    if (existingCollateralSkus && existingCollateralSkus.length > 0) {
	      for (var _j5 = 0; _j5 < existingCollateralSkus.length; _j5++) {
	        addProducts(existingCollateralSkus[_j5].itmSku, existingCollateralSkus[_j5].prdName, existingCollateralSkus[_j5].clrQtyPerRule);
	      }
	    }
	  }
	
	  $(".bundle-new-submit-link").on("click", function (e) {
	    e.preventDefault();
	    if (validator.elements().valid()) {
	      var submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: submitModalTitleTxt,
	        confirmModalBody: '<div class="q-pad-all-xl">' + submitModalBodyTxt + '</div>',
	        confirmModalBtnText: submitModalBtnTxt,
	        onConfirmClick: function onConfirmClick() {
	          submitModalFlow.showLoadingModal();
	          submitRule({ url: submitRuleURL, success: submitRuleSuccess, error: submitRuleError });
	
	          function submitRule(_ref3) {
	            var url = _ref3.url,
	                success = _ref3.success,
	                error = _ref3.error;
	
	            $.ajax({
	              data: $('#collateral-rule-form').serialize(),
	              url: url,
	              dataType: "JSON",
	              type: 'POST',
	              success: success,
	              error: error
	            });
	          }
	
	          function submitRuleSuccess(cbrId) {
	            if (cbrId > 0) {
	              _EditChecker2.default.setPageClean();
	              var ruleDetailUrl = el.data("rule-details-url");
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = ruleDetailUrl + '&cbrId=' + cbrId;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            } else {
	              submitModalFlow.showFailureModal();
	            }
	          }
	
	          function submitRuleError() {
	            submitModalFlow.hideAllModals();
	          }
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  });
	
	  function inclusionConditionSetup(id, val) {
	    if (val === "all-orders") {
	      collateralRuleConditionsDiv.hide();
	      $(".collateral-product-rule-conditions").hide();
	      ruleSummaryInclusionCondition.text("on ALL ORDERS ");
	    } else if (val === "order-conditions") {
	      collateralRuleConditionsDiv.show();
	      $(".collateral-product-rule-conditions").hide();
	      ruleSummaryInclusionCondition.text("in ORDERS WITH");
	      prepareSummaryForOrderConditions();
	    } else if (val === "order-products") {
	      collateralRuleConditionsDiv.hide();
	      $(".collateral-product-rule-conditions").show();
	      ruleSummaryInclusionCondition.text("for SKUs");
	      ruleSummaryOrderSkuValue.text(getSelectedValuesOfSelect2ById('productsInOrder'));
	    }
	  }
	
	  function inclusionFrequencySetup(id, val) {
	    ruleSummarySection.show();
	    if (val === "per-order") {
	
	      ruleSummaryInclusionFrequency.text("ONCE PER ORDER ");
	    } else if (val === "per-sku") {
	      ruleSummaryInclusionFrequency.text("WITH EACH ORDERED LINE ITEM ");
	    } else if (val === "per-unit") {
	      ruleSummaryInclusionFrequency.text("WITH EACH ORDERED UNIT ");
	    } else {
	      ruleSummarySection.hide();
	    }
	  }
	
	  productsInOrderSelect2.on('change', function () {
	    ruleSummaryOrderSkuValue.text(getSelectedValuesOfSelect2ById('productsInOrder'));
	  });
	
	  collateralRuleConditionsDiv.on('change', function () {
	    prepareSummaryForOrderConditions();
	  });
	
	  function prepareSummaryForOrderConditions() {
	    var rlecnt = 0;
	    ruleSummaryOrderSkuValue.text();
	    if (byValOfOrderToggler.prop('checked')) {
	      ruleSummaryOrderConditions.text("value greater than or equal to ");
	      orderValueInSummary.text("$" + $("#gte-dollars-1").val());
	      rlecnt = rlecnt + 1;
	    } else if (!byValOfOrderToggler.prop('checked')) {
	      ruleSummaryOrderConditions.text("");
	      orderValueInSummary.text("");
	      rlecnt = rlecnt - 1;
	    }
	
	    if (byQuantityOfOrder.prop('checked')) {
	      ruleSummaryOrderQuantity.text("order quantity greater than or equal to ");
	      ruleSummaryOrderQuantityValue.text($("#quantityOfOrderVal").val());
	    } else if (!byQuantityOfOrder.prop('checked')) {
	      ruleSummaryOrderQuantity.text("");
	      ruleSummaryOrderQuantityValue.text("");
	    }
	
	    if (byTypeOfOrder.prop('checked')) {
	      ruleSummaryOrderType.text("order type ");
	      ruleSummaryOrderTypeValue.text($("#orderTypeOption").val());
	    } else if (!byTypeOfOrder.prop('checked')) {
	      ruleSummaryOrderType.text("");
	      ruleSummaryOrderTypeValue.text("");
	    }
	
	    if (byChannel.prop('checked')) {
	      ruleSummaryOrderChannel.text("channels ");
	      ruleSummaryOrderChannelValue.text(getSelectedValuesOfSelect2ById('channelInput'));
	    } else if (!byChannel.prop('checked')) {
	      ruleSummaryOrderChannel.text("");
	      ruleSummaryOrderChannelValue.text("");
	    }
	  }
	
	  var typeAhead = $('.associated-collateral-typeahead.typeahead');
	  typeAhead.typeahead(null, {
	    name: 'typeAheadItems',
	    limit: 5,
	    source: (0, _typeAheadSource2.default)(typeAheadItems)
	  }).on('typeahead:selected', function () {
	    var str = this.value;
	    var res = str.split("--");
	    $(".apply-to-collateral-empty").hide();
	    $(".apply-to-collateral-exists").show();
	    addProducts(res[0], res[1], res[2]);
	    typeAhead.typeahead('val', '');
	    // triggerAddProductsEvent();
	  });
	
	  function addProducts(itmSku, productName, qtyPerRule) {
	    var highestId = parseInt($("#collateral-rule-table tbody tr:last").attr("id"));
	    if (isNaN(highestId)) {
	      highestId = 0;
	    } else {
	      ++highestId;
	    }
	
	    if (qtyPerRule === undefined || qtyPerRule == 0) {
	      qtyPerRule = 1;
	    }
	
	    var itmId = "";
	    itmId = findCollateralItemId(itmSku);
	    var qty = '<td><div class="wrapper-helper"><input min="1" type="number" value="' + qtyPerRule + '"class="q-input stretch q-text-right collateral-qty-per-rule" name="collateral-qty-per-rule_row_' + highestId + '" data-error-placement-append-closest=".wrapper-helper" placeholder=""/></div></td>';
	    var removeIcon = '<td><div class="q-text-right"><a href="#" class="remove-collateral" aria-label="Remove"><i class="fa fa-close fa-lg q-pad-horz-md" aria-hidden="true"></i></a></div></td>';
	    var productRow = "<tr id='" + highestId + "'> <td><div><input name='associatedCollateral' value='" + itmId + '_row_' + highestId + "' type='hidden'/> <input name='associatedCollateral_row_" + highestId + "' type='hidden' value='" + itmId + "'/>" + itmSku + " </div></td> <td><div>" + productName + " </div></td>" + qty + " " + removeIcon + "</tr>";
	
	    $("#collateral-rule-table").find('tbody').append(productRow);
	  }
	
	  function findCollateralItemId(itmSku) {
	    var itmId = "";
	    _underscore2.default.each(collateralSkus, function (item) {
	      if (item.itmSku === itmSku) {
	        itmId = item.itmId;
	        return;
	      }
	    });
	    return itmId;
	  }
	
	  doc.on('click', '#collateral-rule-form .remove-collateral', handleItemRemove);
	
	  function handleItemRemove(e) {
	    _EditChecker2.default.setPageDirty();
	
	    //change the method name to remove product related rows.
	    e.preventDefault();
	    removeClosestRow($(e.target));
	  }
	
	  function removeClosestRow(el) {
	    el.closest('tr').remove();
	    $(".associated-collateral-typeahead").focus();
	    var rowCount = $('#collateral-rule-table tr').length;
	    if (rowCount == 1) {
	      $(".apply-to-collateral-empty").show();
	      $(".apply-to-collateral-exists").hide();
	    }
	  }
	
	  function getSelectedValuesOfSelect2ById(id) {
	    var dataText = "";
	    $('#' + id + ' option:selected').each(function () {
	      var $this = $(this);
	      if ($.inArray($this.text(), listBuild) == -1) {
	        listBuild.push($this.text());
	      }
	    });
	
	    for (var i = 0; i < listBuild.length; i++) {
	      if (!dataText.includes(listBuild[i]) && i < listBuild.length - 1) {
	        dataText = dataText.concat(listBuild[i].concat(", "));
	      } else {
	        dataText = dataText.concat(listBuild[i].concat(" "));
	      }
	    }
	    return dataText;
	  }
	
	  function clearSummarySections() {
	    listBuild = [];
	    ruleSummaryInclusionCondition.text("");
	    ruleSummaryInclusionFrequency.text("");
	    ruleSummaryOrderConditions.text("");
	    ruleSummaryOrderQuantity.text("");
	    ruleSummaryOrderQuantityValue.text("");
	    ruleSummaryOrderType.text("");
	    ruleSummaryOrderTypeValue.text("");
	    ruleSummaryOrderChannel.text("");
	    ruleSummaryOrderChannelValue.text("");
	    ruleSummaryConjunction.text("");
	    ruleSummaryOrderSkuValue.text("");
	    orderValueInSummary.text("");
	  }
	
	  productsInOrderSelect2.select2({
	    ajax: _extends({}, select2AjaxDefaults, {
	      url: productLookUpURL,
	      data: configureDataCallback({ paramKey: 'likeSku' })
	    }),
	    minimumInputLength: 3
	  });
	}

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#collateral-rule-details-page", function () {
	  var activateBtn = ".activate";
	  var inactivateBtn = ".delete";
	  var collateralRuleDetailsPage = (0, _jquery2.default)("#collateral-rule-details-page");
	  var activateUrl = collateralRuleDetailsPage.data("activate-rule-url");
	  var inactivateUrl = collateralRuleDetailsPage.data("inactivate-rule-url");
	  var pageRefreshUrl = collateralRuleDetailsPage.data("page-refresh-url");
	  var collateralProducts = collateralRuleDetailsPage.data("mapped-collateral-products");
	  var rule = collateralRuleDetailsPage.data("rule");
	  var activateModalTitleTxt = collateralRuleDetailsPage.data("activate-modal-title-txt");
	  var activateModalBodyTxt = collateralRuleDetailsPage.data("activate-modal-body-txt");
	  var activateModalBtnTxt = collateralRuleDetailsPage.data("activate-modal-btn-txt");
	  var inactivateModalTitleTxt = collateralRuleDetailsPage.data("inactivate-modal-title-txt");
	  var inactivateModalBodyTxt = collateralRuleDetailsPage.data("inactivate-modal-body-txt");
	  var inactivateModalBtnTxt = collateralRuleDetailsPage.data("inactivate-modal-btn-txt");
	
	  init();
	
	  function init() {
	    if (!collateralProducts && collateralProducts.length <= 0) {
	      (0, _jquery2.default)(".add-collateral-btn-outer").show();
	      (0, _jquery2.default)(".collateral-rule-text").hide();
	      (0, _jquery2.default)(".collateral-rules-table-outer").hide();
	    }
	
	    if (rule.isRuleExpired) {
	      (0, _jquery2.default)(".rule-expired-on-message").show();
	    }
	  }
	
	  (0, _jquery2.default)(activateBtn).click(function () {
	    var button = (0, _jquery2.default)(this);
	    if (button.hasClass("disabled")) {
	      return;
	    }
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: activateModalTitleTxt,
	      confirmModalBody: '<div class="q-pad-all-xl">' + activateModalBodyTxt + '</div>',
	      confirmModalBtnText: activateModalBtnTxt,
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        _jquery2.default.ajax({
	          url: activateUrl,
	          dataType: "JSON",
	          type: 'POST',
	          success: onSuccessActivate,
	          error: onErrorActivate
	        });
	
	        function onSuccessActivate() {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	
	        function onErrorActivate() {
	          submitModalFlow.hideAllModals();
	        }
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  });
	
	  (0, _jquery2.default)(inactivateBtn).click(function () {
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: inactivateModalTitleTxt,
	      confirmModalBody: '<div class="q-pad-all-xl">' + inactivateModalBodyTxt + '</div>',
	      confirmModalBtnText: inactivateModalBtnTxt,
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        _jquery2.default.ajax({
	          url: inactivateUrl,
	          dataType: "JSON",
	          type: 'POST',
	          success: onSuccessInactivate,
	          error: onErrorInactivate
	        });
	
	        function onSuccessInactivate() {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	
	        function onErrorInactivate() {
	          submitModalFlow.hideAllModals();
	        }
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  });
	});

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(586);
	
	__webpack_require__(587);

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetSelector = "#received-inbound-form";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	    attachOrgForm(mainEl);
	});
	
	function attachOrgForm(mainEl) {
	    var facilityData = mainEl.data("facility-data");
	    var viewUrl = mainEl.data("view-url");
	    var prevfacId = mainEl.data("facid-data");
	    var viewInboundRenderUrl = mainEl.data("view-inbound-render-url");
	
	    var els = {};
	    var elementsMap = {
	        addFacilitySelect: '#ibfacility-select'
	    };
	
	    function init() {
	        setElements();
	        bindElements();
	        renderFacilityList();
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	    }
	
	    function bindElements() {
	        els.addFacilitySelect.on('change', facilityChangeRequest);
	    }
	
	    function renderFacilityList() {
	        (0, _jquery2.default)(facilityData).each(function () {
	            var option = (0, _jquery2.default)('<option />');
	            option.attr('value', this.facId).text(this.facName);
	            els.addFacilitySelect.append(option);
	        });
	    }
	
	    function facilityChangeRequest() {
	        var facId = els.addFacilitySelect.val();
	        var newviewUrl = viewUrl + '&facId=' + facId;
	        _jquery2.default.ajax({
	            url: newviewUrl,
	            type: 'POST',
	            dataType: "JSON",
	            data: {
	                facId: facId
	            },
	            success: function success(response) {
	                (0, _jquery2.default)('#progress').html(response.Planned != null ? response.Planned : "0");
	                (0, _jquery2.default)('#transit').html(response["In Transit"] != null ? response["In Transit"] : "0");
	                (0, _jquery2.default)('#received').html(response.Receiving != null ? response.Receiving : "0");
	                (0, _jquery2.default)('#progressLink').attr('href', viewInboundRenderUrl + "&filterFlag=Planned&facId=" + facId);
	                (0, _jquery2.default)('#transitLink').attr('href', viewInboundRenderUrl + "&filterFlag=In Transit&facId=" + facId);
	                (0, _jquery2.default)('#receivedLink').attr('href', viewInboundRenderUrl + "&filterFlag=Received&facId=" + facId);
	            },
	            error: function error(response) {
	                console.log("error" + JSON.stringify(response));
	            }
	        });
	    }
	
	    init();
	}

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(593);
	
	__webpack_require__(592);
	
	__webpack_require__(589);
	
	__webpack_require__(591);

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetSelector = "#product-by-inventory-dashboard";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  attachOrgForm(mainEl);
	});
	
	function attachOrgForm(mainEl) {
	  var facilityData = mainEl.data("facility-data");
	  var viewUrl = mainEl.data("facility-url");
	  var inventoryLookupUrl = mainEl.data("inventory-lookup-url");
	
	  var els = {};
	  var elementsMap = {
	    addFacilitySelect: '#facility-select'
	  };
	
	  function init() {
	    setElements();
	    bindElements();
	    renderFacilityList();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	  }
	
	  function bindElements() {
	    els.addFacilitySelect.on('change', facilityChangeRequest);
	  }
	
	  function renderFacilityList() {
	    (0, _jquery2.default)(facilityData).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.facCode).text(this.facName);
	      els.addFacilitySelect.append(option);
	    });
	  }
	
	  function facilityChangeRequest() {
	
	    var facCode = els.addFacilitySelect.val();
	    if (facCode == "All Facilities") {
	      facCode = "All";
	    }
	    var newviewUrl = viewUrl + '&facCode=' + facCode;
	    _jquery2.default.ajax({
	      url: newviewUrl,
	      type: 'POST',
	      dataType: "JSON",
	      data: {
	        facCode: facCode
	      },
	      success: function success(response) {
	        (0, _jquery2.default)('#outOfStockProducts').html(response.outStockCount);
	        (0, _jquery2.default)('#lowStockProducts').html(response.lowStockCount);
	        (0, _jquery2.default)('#inStockProducts').html(response.inStockCount);
	        (0, _jquery2.default)('#outofstockLink').attr('href', inventoryLookupUrl + "&filterFlag=outofstock&facCode=" + facCode);
	        (0, _jquery2.default)('#lowstockLink').attr('href', inventoryLookupUrl + "&filterFlag=lowstock&facCode=" + facCode);
	        (0, _jquery2.default)('#instockLink').attr('href', inventoryLookupUrl + "&filterFlag=instock&facCode=" + facCode);
	      },
	      error: function error(response) {
	        console.log("error" + JSON.stringify(response));
	      }
	    });
	  }
	
	  init();
	}

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetSelector = "#received-order-form";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  attachOrgForm(mainEl);
	});
	
	function attachOrgForm(mainEl) {
	  var facilityData = mainEl.data("facility-data");
	  var viewUrl = mainEl.data("facility-url");
	  var viewOrderRenderUrl = mainEl.data("view-order-render-url");
	
	  var els = {};
	  var elementsMap = {
	    addFacilitySelect: '#facility-select'
	  };
	
	  function init() {
	    setElements();
	    bindElements();
	    renderFacilityList();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	  }
	
	  function bindElements() {
	    els.addFacilitySelect.on('change', facilityChangeRequest);
	  }
	
	  function renderFacilityList() {
	    (0, _jquery2.default)(facilityData).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.facId).text(this.facName);
	      els.addFacilitySelect.append(option);
	    });
	  }
	
	  function facilityChangeRequest() {
	    var facId = els.addFacilitySelect.val();
	    var newviewUrl = viewUrl + '&facId=' + facId;
	    _jquery2.default.ajax({
	      url: newviewUrl,
	      type: 'POST',
	      dataType: "JSON",
	      data: {
	        facId: facId
	      },
	      success: function success(response) {
	        (0, _jquery2.default)('#yesterdayorders').html(response.yesterday);
	        (0, _jquery2.default)('#sevendays').html(response.last7days);
	        (0, _jquery2.default)('#forteendays').html(response.last14days);
	        (0, _jquery2.default)('#yesterdayorderLink').attr('href', viewOrderRenderUrl + "&filterFlag=yesterday&facId=" + facId);
	        (0, _jquery2.default)('#sevendaysorderLink').attr('href', viewOrderRenderUrl + "&filterFlag=sevendays&facId=" + facId);
	        (0, _jquery2.default)('#forteendaysorderLink').attr('href', viewOrderRenderUrl + "&filterFlag=fourteendays&facId=" + facId);
	      },
	      error: function error(response) {
	        console.log("error" + JSON.stringify(response));
	      }
	    });
	  }
	
	  init();
	}

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#facilities-lookup", function (mainEl) {
	  var facilityData = mainEl.data("facility-data");
	  var facilityFilteredSummaryUrl = mainEl.data("facility-filtered-summary-url");
	  var viewOrderRenderUrl = mainEl.data("view-order-render-url");
	  var viewInboundRenderUrl = mainEl.data("view-inbound-render-url");
	  var els = {};
	  var elementsMap = {
	    addFacilitySelect: '#facility-select',
	    ordersShippedPill: '#orders-shipped-pill',
	    shipmentsReceivedPill: '#shipments-received-pill'
	  };
	
	  function init() {
	    setElements();
	    bindElements();
	    renderFacilityList();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	  }
	
	  function bindElements() {
	    els.addFacilitySelect.on('change', loadFacilityFilteredData);
	  }
	
	  function renderFacilityList() {
	    (0, _jquery2.default)(facilityData).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.facId).text(this.facName);
	      els.addFacilitySelect.append(option);
	    });
	  }
	
	  function loadFacilityFilteredData() {
	    var facId = els.addFacilitySelect.val();
	    var newviewUrl = facilityFilteredSummaryUrl + '&facId=' + facId;
	    _jquery2.default.ajax({
	      url: newviewUrl,
	      type: 'POST',
	      dataType: "JSON",
	      data: {
	        facId: facId
	      },
	      success: function success(response) {
	
	        (0, _jquery2.default)('#orders-shipped-pill').attr('href', viewOrderRenderUrl + "&filterSummary=Shipped&filterFlag=fourteendays&facId=" + facId);
	        (0, _jquery2.default)('#shipments-received-pill').attr('href', viewInboundRenderUrl + "&filterSummary=Complete&filterFlag=fourteendays&facId=" + facId);
	        var orderShippedIsOver = response.orderShippedPercentage >= 0;
	
	        var orderShippedPercentageText = orderShippedIsOver ? response.orderShippedPercentage + '% over previous period' : Math.abs(response.orderShippedPercentage) + '% under previous period';
	
	        var shipmentReceivedIsOver = response.shipmentReceivedPercentage >= 0;
	
	        var shipmentReceivedPercentageText = shipmentReceivedIsOver ? response.shipmentReceivedPercentage + '% over previous period' : Math.abs(response.shipmentReceivedPercentage) + '% under previous period';
	
	        (0, _jquery2.default)('#orders-shipped-pill').html(response.orderShippedNewCount);
	
	        if (orderShippedIsOver) {
	          (0, _jquery2.default)('#orders-shipped-increase-true').css('display', 'block');
	          (0, _jquery2.default)('#orders-shipped-increase-true-text').html(orderShippedPercentageText);
	          (0, _jquery2.default)('#orders-shipped-increase-false').css('display', 'none');
	        } else {
	          (0, _jquery2.default)('#orders-shipped-increase-false').css('display', 'block');
	          (0, _jquery2.default)('#orders-shipped-increase-false-text').html(orderShippedPercentageText);
	          (0, _jquery2.default)('#orders-shipped-increase-true').css('display', 'none');
	        }
	
	        (0, _jquery2.default)('#shipments-received-pill').html(response.shipmentReceivedNewCount);
	
	        if (shipmentReceivedIsOver) {
	          (0, _jquery2.default)('#shipment-received-increase-true').css('display', 'block');
	          (0, _jquery2.default)('#shipment-received-increase-true-text').html(shipmentReceivedPercentageText);
	          (0, _jquery2.default)('#shipment-received-increase-false').css('display', 'none');
	        } else {
	          (0, _jquery2.default)('#shipment-received-increase-false').css('display', 'block');
	          (0, _jquery2.default)('#shipment-received-increase-false-text').html(shipmentReceivedPercentageText);
	          (0, _jquery2.default)('#shipment-received-increase-true').css('display', 'none');
	        }
	      },
	      error: function error(e, ajaxOptions, thrownError) {
	        console.log(e);
	      }
	    });
	  }
	
	  init();
	});

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _util = __webpack_require__(34);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	
	var els = {};
	var elsModal = {};
	var elsModalMap = {};
	var elsMap = {
	    dimName: "#dimdivisor-name",
	    dimMerchants: "#retailerList",
	    dimSaveBtn: ".dim-save-btn",
	    dimFormElement: "#dimdivisor-create-edit",
	    dimValidateClass: ".dim-validate",
	    retailersdropdown: ".retailer-list-select",
	    merchantTierDropDown: ".merchant-tier-select",
	    merchantDiv: "#merchant-exists",
	    tierExistDiv: "#tier-exists",
	    dimCancelBtn: "#dim-cancel-btn",
	    dimNameExists: "#dim-name-exists",
	    dimNameError: "#dim-name-error",
	    selectMerchantSwitch: ".select-merchant-switch",
	    merchantSection: ".merchant-section",
	    merchantTierSection: ".merchant-tier-section"
	};
	
	var customValidateProps = {
	    errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	            $(element).closest(appendClosest).append(error);
	        } else {
	            error.insertAfter(element);
	        }
	    }
	};
	
	var defDimName = "Default - All Merchants";
	var defMerchant = "0";
	var targetSelector = "#dimdivisor-createedit";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	
	    var defaultDim = mainEl.data("defaultdim");
	    var editDimMerchantTier = mainEl.data("edit-dim-merchant-tier");
	    var retailerCheckUrl = mainEl.data("retailer-code-check-url");
	    var marchantTierValuesUrl = mainEl.data("merchant-tier-values-url");
	    var portletNamespace = mainEl.data("portlet-namespace");
	    var dimNameCheckUrl = mainEl.data("dim-name-check-url");
	    var saveDimDivisorUrl = mainEl.data("url");
	    var editForm = mainEl.data("edit-form");
	
	    function init() {
	        generateModals();
	        setElementsInModals();
	        setElements();
	        loadDropDowns();
	        bindElements();
	        renderDefaultDimUI();
	        setupEditChecker();
	        setInitialState();
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	    }
	
	    function setElementsInModals() {
	        var body = $('body');
	        (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, body);
	    }
	
	    function setInitialState() {
	        els.dimFormElement.validate(customValidateProps);
	        if (editForm) {
	            if (editDimMerchantTier == "") {
	                els.selectMerchantSwitch.prop("checked", true);
	                els.selectMerchantSwitch.prop("disabled", true);
	                els.merchantTierSection.hide();
	                els.merchantSection.show();
	            } else {
	                els.selectMerchantSwitch.prop("checked", false);
	                els.selectMerchantSwitch.prop("disabled", true);
	                els.merchantTierDropDown.prop("disabled", true);
	                els.merchantSection.hide();
	            }
	        } else {
	            els.selectMerchantSwitch.prop("checked", true);
	            els.merchantTierSection.hide();
	        }
	    }
	
	    function bindElements() {
	        els.selectMerchantSwitch.on("change", changeSelectMerchantSwitch);
	        var existingDimName = els.dimName.val();
	        els.dimValidateClass.on('change', checkDimValidation);
	        els.dimValidateClass.on("keydown", validateDimValue);
	        //Method called on Click of Save
	        els.dimSaveBtn.click((0, _general.createPreventDefault)(saveDimDivisor));
	        els.retailersdropdown.on('blur', validateRetailer);
	        els.merchantTierDropDown.on('change', getDimMerchantTierValues);
	        els.dimName.on('change', function (e) {
	            if ($(this).val() != existingDimName) {
	                validateDimName();
	            } else {
	                $(els.dimNameExists.hide());
	                $(els.dimNameError.hide());
	            }
	        });
	        els.dimName.on('keyup', function (e) {
	            if ($(this).val() == '') {
	                els.dimNameError.hide();
	            }
	        });
	    }
	
	    function setupEditChecker() {
	        _EditChecker2.default.bindNavigation();
	        //Set the listeners for change on main form element
	        _EditChecker2.default.bindChangeListener(els.dimFormElement);
	        _EditChecker2.default.bindCancelButton(els.dimCancelBtn);
	    }
	
	    function changeSelectMerchantSwitch() {
	        if ($(this).prop("checked") == true) {
	            els.merchantTierDropDown.prop('selectedIndex', -1).trigger("change");
	            els.merchantSection.show();
	            els.merchantTierSection.hide();
	            els.merchantDiv.hide();
	            els.dimNameExists.hide();
	
	            $("#dimdivisor-name").val('');
	            $(".dim-validate").each(function () {
	                $(this).val('');
	            });
	        } else {
	            els.retailersdropdown.prop('selectedIndex', -1).trigger("change");
	            els.merchantTierSection.show();
	            els.merchantSection.hide();
	            els.tierExistDiv.hide();
	            els.dimNameExists.hide();
	
	            $("#dimdivisor-name").val('');
	            $(".dim-validate").each(function () {
	                $(this).val('');
	            });
	        }
	    }
	
	    function checkDimValidation(e) {
	        e.preventDefault();
	        var dimInputEle = $(this);
	        var closetErrorEle = dimInputEle.parent().find('label');
	        validateServiceLevelInput(closetErrorEle, dimInputEle.val());
	    }
	
	    function validateDimValue(e) {
	        var charCode = e.which || e.keyCode;
	        if (charCode >= 48 && charCode <= 57 || charCode == 8 || charCode == 46 || charCode == 9 || charCode == 11 || charCode >= 96 && charCode <= 105) return true;
	        e.preventDefault();
	    }
	
	    function validateServiceLevelInput(closetErrorEle, inputValue) {
	        var pattern = /^[0-9]+$/;
	        if (inputValue == '') {
	            closetErrorEle.hide();
	        } else if (!inputValue.match(pattern)) {
	            closetErrorEle.show();
	        } else if (inputValue < 100 || inputValue > 300) {
	            closetErrorEle.show();
	        } else {
	            closetErrorEle.hide();
	        }
	    }
	
	    function loadDropDowns() {}
	
	    function generateModals() {}
	
	    function renderDefaultDimUI() {
	        //Logic to customize createEdit UI for default flow starts
	
	        if (defaultDim != "" && defaultDim == "Y") {
	            els.dimName.val(defDimName);
	            els.dimName.prop('readonly', true);
	        } else {
	            els.dimName.prop('disabled', false);
	        }
	        //Logic to customize createEdit UI for default flow ends
	    }
	
	    function saveDimDivisor() {
	        els.merchantTierDropDown.prop("disabled", false);
	        if (els.dimFormElement.valid() == true && !els.dimFormElement.find('.q-sim-error').is(':visible') && !els.dimFormElement.find('.q-alert-red').is(':visible')) {
	            var submitModalFlow = new _SubmitModalFlow2.default({
	                confirmModalTitle: "Submit Dim Divisor",
	                confirmModalBody: '<div class="q-pad-all-xl">Once submitted, the information provided will be used to update billing and accounting for selected merchants. </div>',
	                confirmModalBtnText: "Submit",
	                onConfirmClick: function onConfirmClick() {
	                    _EditChecker2.default.setPageClean();
	                    submitModalFlow.showLoadingModal();
	                    saveDimDivisor({ url: saveDimDivisorUrl, success: success, error: error });
	
	                    function saveDimDivisor(_ref) {
	                        var url = _ref.url,
	                            success = _ref.success,
	                            error = _ref.error;
	
	                        $.ajax({
	                            data: els.dimFormElement.serialize(),
	                            url: url,
	                            dataType: "JSON",
	                            type: 'POST',
	                            success: success,
	                            error: error
	                        });
	                    }
	                    function success(response) {
	                        _EditChecker2.default.setPageClean();
	                        submitModalFlow.showSuccessModal();
	                        setTimeout(function () {
	                            $('#dim-divisor-id').val(response.data);
	                            els.dimFormElement.submit();
	                        }, 3000);
	                    }
	                    function error() {
	                        submitModalFlow.showFailureModal();
	                    }
	                }
	            });
	            submitModalFlow.init();
	            submitModalFlow.showConfirmModal();
	        }
	    };
	
	    function validateRetailer() {
	        var selectedRetailerId = els.retailersdropdown.val();
	        var data = _defineProperty({}, portletNamespace + 'selectedRetailerId', JSON.stringify(selectedRetailerId));
	
	        if (!(0, _util.isNullOrUndefined)(selectedRetailerId) && !(0, _general.isBlank)(selectedRetailerId)) {
	            $.ajax({
	                url: retailerCheckUrl,
	                dataType: "JSON",
	                type: 'POST',
	                data: data,
	                success: function success(data) {
	                    if (data.response == true) {
	                        $(els.merchantDiv.show());
	                        els.dimFormElement.find('.merchant-names').empty();
	                        els.dimFormElement.find('.merchant-names').append(data.merchantList);
	                    } else {
	                        $(els.merchantDiv.hide());
	                    }
	                }
	            });
	        }
	    }
	
	    function getDimMerchantTierValues() {
	        var selectedMerchantTier = els.merchantTierDropDown.val();
	        var data = _defineProperty({}, portletNamespace + 'selectedMerchantTier', selectedMerchantTier);
	
	        if (!(0, _util.isNullOrUndefined)(selectedMerchantTier) && !(0, _general.isBlank)(selectedMerchantTier)) {
	            $.ajax({
	                url: marchantTierValuesUrl,
	                dataType: "JSON",
	                type: 'POST',
	                data: data,
	                success: function success(data) {
	                    if (data.response == true) {
	                        $(els.tierExistDiv.show());
	                        els.dimFormElement.find('.tier-names').html(data.dimDivisorMechantValues.dimMerchantTier);
	                        if (data.dimDivisorMechantValues != null) {
	                            $("#merchant-tier-flag").val("true");
	                            $("#tier-dim-id").val(data.dimDivisorMechantValues.dimId);
	                            setMerchantTierValuesTOJSP(data);
	                        }
	                    } else {
	                        $(els.tierExistDiv.hide());
	                        $("#merchant-tier-flag").val("false");
	                        $("#dimdivisor-name").val('');
	                        $(".dim-validate").each(function () {
	                            $(this).val('');
	                        });
	                    }
	                }
	            });
	        }
	    }
	
	    function setMerchantTierValuesTOJSP(data) {
	        $("#dimdivisor-name").val(data.dimDivisorMechantValues.dimName);
	        if (data.dimDivisorMechantValues.usServiceLevels != null) {
	            data.dimDivisorMechantValues.usServiceLevels.forEach(function (marchantTierValue, index) {
	                $("#usServiceLevels" + index).val(marchantTierValue.dmdDimValue);
	            });
	        }
	        if (data.dimDivisorMechantValues.canadaServiceLevels != null) {
	            data.dimDivisorMechantValues.canadaServiceLevels.forEach(function (marchantTierValue, index) {
	                $("#canadaServiceLevels" + index).val(marchantTierValue.dmdDimValue);
	            });
	        }
	        if (data.dimDivisorMechantValues.otherServiceLevels != null) {
	            data.dimDivisorMechantValues.otherServiceLevels.forEach(function (marchantTierValue, index) {
	                $("#otherServiceLevels" + index).val(marchantTierValue.dmdDimValue);
	            });
	        }
	    }
	
	    function clearValues() {}
	
	    function validateDimName() {
	        var dimName = els.dimName.val();
	        var pattern = /^[a-zA-Z0-9\u00C0-\u00ff\s-_',`~!@+=#$%^&*";<>.?:\?\/\[\]!\./\\\(\)\{\}]+$/;
	        els.dimNameError.hide();
	        if (!dimName.match(pattern) && !dimName == '') {
	            els.dimNameError.show();
	            return false;
	        }
	        var data = _defineProperty({}, portletNamespace + 'dimName', dimName);
	
	        if (!(0, _util.isNullOrUndefined)(dimName) && !(0, _general.isBlank)(dimName)) {
	            $.ajax({
	                url: dimNameCheckUrl,
	                dataType: "JSON",
	                type: 'POST',
	                data: data,
	                success: function success(data) {
	                    if (data.response == true) {
	                        $(els.dimNameExists.show());
	                        return false;
	                    } else {
	                        $(els.dimNameExists.hide());
	                        return true;
	                    }
	                }
	            });
	        }
	    }
	
	    init();
	});

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	
	var els = {};
	var elsMap = {
	    detailsDimName: "#dtls-dim-name",
	    editDimBtn: ".dtls-edit-btn"
	};
	var elsModal = {};
	var elsModalMap = {};
	var targetSelector = "#dimdivisor-details";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	    var targetObject = "";
	    var deActivateDimModal = null;
	    var dimDivisorDetailsJson = mainEl.data("dimdivisor-details-json");
	    var activateDimBtn = mainEl.find(".activate-dim-divisor");
	    var deactivateDimBtn = mainEl.find(".deactivate-dim-divisor");
	    var changeDimStatusUrl = mainEl.data("change-status-url");
	    var pageReloadUrl = mainEl.data("detail-page-reload-url");
	    var editDimDivisorUrl = mainEl.data("edit-dim-divisor-url");
	    var portletNamespace = mainEl.data("portlet-namespace");
	
	    function init() {
	        setElementsInModals();
	        setElements();
	        bindElements();
	        loadDataOnUI();
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	    }
	
	    function setElementsInModals() {
	        var body = $('body');
	        (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, body);
	    }
	
	    function bindElements() {
	
	        deactivateDimBtn.on("click", function (e) {
	            e.preventDefault();
	            deActivateDimModal = new SubmitModalFlow({
	                confirmModalTitle: 'Deactivate Dim Divisor',
	                confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this dim divisor will no longer be available for selected merchants. This dim divisor can be reactivated at any time.</div>',
	                confirmModalBtnText: 'Deactivate Dim Divisor',
	                modalDialogClass: "q-modal-dialog-500",
	                onConfirmClick: function onConfirmClick() {
	                    deActivateDimModal.showLoadingModal();
	                    handleDimActivateDeactivate({ url: changeDimStatusUrl, input: 'N', success: deactiveDimSuccess, error: deactiveDimError });
	                }
	            });
	            deActivateDimModal.init();
	            deActivateDimModal.showConfirmModal();
	        });
	
	        activateDimBtn.on("click", function (e) {
	            e.preventDefault();
	            deActivateDimModal = new SubmitModalFlow({
	                confirmModalTitle: 'Activate Dim Divisor',
	                confirmModalBody: '<div class="q-pad-all-xl">Once activated, this dim divisor will be available for selected merchants. This dim divisor can be deactivated at any time.</div>',
	                confirmModalBtnText: 'Activate Dim Divisor',
	                modalDialogClass: "q-modal-dialog-500",
	                onConfirmClick: function onConfirmClick() {
	                    deActivateDimModal.showLoadingModal();
	                    handleDimActivateDeactivate({ url: changeDimStatusUrl, input: 'Y', success: deactiveDimSuccess, error: deactiveDimError });
	                }
	            });
	            deActivateDimModal.init();
	            deActivateDimModal.showConfirmModal();
	        });
	        els.editDimBtn.click((0, _general.createPreventDefault)(editDimDivisor));
	    }
	
	    function loadDataOnUI() {
	        var serviceValues = [];
	        var dimDivisorInfoJson = dimDivisorDetailsJson.dimDivisorInfo;
	        serviceValues = dimDivisorInfoJson.usServiceLevels;
	        loadServiceValues(serviceValues);
	        serviceValues = dimDivisorInfoJson.canadaServiceLevels;
	        loadServiceValues(serviceValues);
	        serviceValues = dimDivisorInfoJson.otherServiceLevels;
	        loadServiceValues(serviceValues);
	    }
	
	    function loadServiceValues(serviceValues) {
	        _.each(serviceValues, function (el) {
	            var id = "#" + el.dmdShipmentMethodId;
	            $(id).text(el.dmdDimValue);
	        });
	    }
	
	    function deactiveDimSuccess(data) {
	        if (data.responseStatus === "Success") {
	            var detailUrlFullURL = pageReloadUrl;
	            deActivateDimModal.showSuccessModal();
	            setTimeout(function () {
	                location.href = detailUrlFullURL;
	            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        } else {
	            deActivateDimModal.showFailureModal();
	        }
	    }
	    function editDimDivisor() {
	        window.location.href = editDimDivisorUrl + '&' + portletNamespace + 'dimId=' + dimDivisorDetailsJson.dimDivisorInfo.dimId + '&' + portletNamespace + 'flow=edit';
	    };
	
	    function handleDimActivateDeactivate(_ref) {
	        var url = _ref.url,
	            input = _ref.input,
	            success = _ref.success,
	            error = _ref.error;
	
	        $.ajax({
	            url: url,
	            data: { "dimStatus": input },
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	        });
	    }
	
	    function deactiveDimError() {
	        deActivateDimModal.hideAllModals();
	    }
	
	    init();
	});

/***/ },
/* 596 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "Y": [{
	    title: "Edit",
	    cls: "edit-dimdivisor",
	    icon: "wrench",
	    disabled: false
	  }, {
	    title: "Deactivate",
	    cls: "deactivate-dimdivisor",
	    icon: "toggle-off",
	    disabled: false
	  }],
	  "N": [{
	    title: "Activate",
	    cls: "activate-dimdivisor",
	    icon: "toggle-on",
	    disabled: false
	  }],
	  "D": [{
	    title: "Edit",
	    cls: "edit-dimdivisor",
	    icon: "wrench",
	    disabled: false
	  }]
	};

/***/ },
/* 597 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var searchDropdown = exports.searchDropdown = [{
		title: "Dim Divisor Name",
		value: "dimName"
	}, {
		title: "Retailer Name",
		value: "rtlName"
	}];

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(599);
	
	__webpack_require__(594);
	
	__webpack_require__(595);

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _actionOptions = __webpack_require__(596);
	
	var _searchDropdown = __webpack_require__(597);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _filtersutil = __webpack_require__(16);
	
	var _constants = __webpack_require__(10);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	__webpack_require__(1081);
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var loadDimDivisorDetailsLinkHtml = __webpack_require__(1274);
	
	var els = {};
	var elsMap = {
	    exportBtn: ".export-btn"
	};
	var actionList = _actionOptions.actionOptions;
	var targetSelector = "#dimdivisor-lookup";
	
	var savedViews = [{
	    title: "Default View",
	    target: "allDimdivisors",
	    active: true,
	    canRemove: false,
	    canEdit: false,
	    filters: [],
	    columns: [{
	        data: "dimStatus",
	        title: "Actions",
	        active: true,
	        canToggle: false
	    }, {
	        data: "dimName",
	        title: "Name",
	        active: true,
	        canToggle: false
	    }, {
	        data: "dimStatus",
	        title: "Status",
	        active: true,
	        canToggle: true
	    }, {
	        data: "dimMerchant",
	        title: "Merchant",
	        active: true,
	        canToggle: true
	    }, {
	        data: "modifiedDate",
	        title: "Date Modified",
	        active: true,
	        canToggle: true
	    }, {
	        data: "modifiedBy",
	        title: "Modified By",
	        active: true,
	        canToggle: true
	    }, {
	        data: "dimId",
	        title: "ID",
	        active: true,
	        canToggle: true
	    }]
	}];
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	    var targetObject = "";
	    var dataTableComponentData = mainEl.data("dimdivisors");
	    var viewDimDetailsPageUrl = mainEl.data("view-dim-details-url");
	    var portletNamespace = mainEl.data("portlet-namespace");
	    var changeDimStatusUrl = mainEl.data("change-status-url");
	    var filterDimDivisorsUrl = mainEl.data("filter-dimdivisor-url");
	    var editDimDivisorUrl = mainEl.data("edit-dimdivisor-url");
	    var isfinanceadmin = mainEl.data("isfinanceadmin");
	    var deActivateDimModal = null;
	    var activateDimModal = null;
	
	    //Copy the render functions for reference in the lookup table from any other lookup.js
	
	    function renderDescription(data, type, item) {
	        var result = void 0;
	        var html = void 0;
	        if (item.itmActive) {
	            html = "<div class='q-marg-all-xs-at-md'>{%- data %}</div>";
	            result = (0, _render2.default)(html, {
	                data: data
	            });
	        } else {
	            html = "<div class='q-marg-all-xs-at-md inactive-items'>{%- data %}</div>";
	            result = (0, _render2.default)(html, {
	                data: data
	            });
	        }
	        return result;
	    }
	
	    function renderStatusPill(data, type, row) {
	        if (data === 'Y') {
	            return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
	        } else {
	            return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
	        }
	    }
	
	    function renderActionWrap(data, type, row, meta) {
	        var newRender = void 0;
	        if (row.dimName == 'Default - All Merchants') {
	            data = 'D';
	        }
	
	        //This logic is to hide the actions for user with CSS role
	        if (isfinanceadmin == false) {
	            data = 'Z';
	        }
	
	        var statusTarget = actionList[data];
	
	        newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	            list: renderActionCellList(statusTarget),
	            index: meta.row
	        });
	
	        return newRender;
	    };
	
	    function renderActionCellList(list, data, row) {
	        var renderedList = void 0;
	        renderedList = _(list).map(function (item) {
	            return (0, _render2.default)(actionCellDropdownItemTemplate, {
	                icon: item.icon,
	                title: item.title,
	                cls: item.cls,
	                disabled: false
	            });
	        });
	        return renderedList.join('');
	    }
	
	    function renderDetailLink(data, type, row, meta) {
	        return (0, _render2.default)(loadDimDivisorDetailsLinkHtml, {
	            dimDivisorClassName: data,
	            dimId: row.dimId,
	            dimParam: 'dimId',
	            detailsPageUrl: viewDimDetailsPageUrl,
	            portletNameSpace: portletNamespace
	        });
	    }
	
	    var dimdivisorLookup = new _index2.default({
	        // REQUIRED - Set a target element
	        target: $("#dimdivisor-lookup-wrapper"),
	        // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
	        minWidthClass: "q-min-width-sm-til-md",
	        // REQUIRED - Set which data should be visible for mobile
	        mobileColumns: [{
	            data: "dimName",
	            title: "Dim Divisor Name",
	            render: renderDescription,
	            orderable: true
	        }, {
	            data: "dimMerchant",
	            title: "Merchants"
	        }],
	        tableSearch: true,
	        newSavedViews: true,
	        tableSearchInput: {
	            value: targetObject != "" ? targetObject.value[0] : ""
	        },
	        // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	        tableSearchDropdown: {
	            selected: targetObject == "" ? "" : targetObject.key,
	            columns: _searchDropdown.searchDropdown
	        },
	        // OPTIONAL: Set Saved View Array
	        savedViews: savedViews,
	        bulkSelect: false,
	        // REQUIRED - Data Table specific settings
	        dataTable: {
	            // use same settings you would if you were just calling a dataTable normally
	            data: dataTableComponentData.content,
	            // Not required, just to show you can
	            columnDefs: [{ className: "custom-class", targets: [1] }],
	            // Not required, just to show you can
	            order: [[2, 'asc']],
	            columns: [{
	                data: "dimStatus",
	                render: renderActionWrap,
	                orderable: false,
	                class: 'dtc-action-column'
	            }, {
	                data: "dimName",
	                title: "Name",
	                render: renderDetailLink,
	                class: 'dtc-min-width-md'
	            }, {
	                data: "dimStatus",
	                title: "Status",
	                render: renderStatusPill,
	                class: 'dtc-min-width-sm'
	            }, {
	                data: "dimMerchant",
	                title: "Merchant",
	                orderable: false,
	                class: 'dtc-min-width-md'
	            }, {
	                data: "modifiedDate",
	                title: "Date Modified",
	                class: 'dtc-min-width-sm'
	            }, {
	                data: "modifiedBy",
	                title: "Modified By",
	                class: 'dtc-min-width-sm'
	            }, {
	                data: "dimId",
	                title: "ID",
	                class: 'dtc-min-width-sm lookupDimId'
	            }]
	        },
	        paginationData: dataTableComponentData.page,
	        filterModal: {
	            // REQUIRED: Sets title of modal
	            title: "Filter DimDivisor",
	            // REQUIRED: Sets unique part of subtitle string.
	            tableType: "dimdivisors"
	        },
	        onFetch: function onFetch() {
	            var currentData = dimdivisorLookup.generateData();
	            dimdivisorLookup.showLoadingOverlay();
	            //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	            if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	                setTimeout(function () {
	                    (0, _filtersutil.doAjax)({ url: filterDimDivisorsUrl, success: filterSuccess, error: error, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	                }, _constants.SUCCESS_MODAL_TIMEOUT);
	            }
	        }
	    });
	
	    $('body').on('click', '.deactivate-dimdivisor', function (e) {
	
	        e.preventDefault();
	        var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	
	        // Get the row based on the parent...
	        var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	        // Get the row data
	        var row = table.row(parent);
	        var deActivateDimModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: 'Deactivate Dim Divisor',
	            modalDialogClass: "q-modal-dialog-500",
	            confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this dim divisor will no longer be available for selected merchants. This dim divisor can be reactivated at any time.</div>',
	            confirmModalBtnText: 'Deactivate Dim Divisor',
	            onConfirmClick: function onConfirmClick() {
	                deActivateDimModal.showLoadingModal();
	                deactivatedimdivisor(row, row.data());
	                function deactivatedimdivisor(row, dimdivisor) {
	                    $.ajax({
	                        url: changeDimStatusUrl,
	                        type: 'POST',
	                        dataType: 'JSON',
	                        data: {
	                            dimId: dimdivisor.dimId,
	                            dimStatus: 'N'
	                        },
	                        success: function success(data) {
	                            if (data.responseStatus === "Success") {
	                                var d = row.data();
	                                d.dimId = $.trim(data.dimId);
	                                d.dimStatus = $.trim(data.dimStatus);
	                                d.dimName = $.trim(data.dimName);
	                                d.dimStatus = $.trim(data.dimStatus);
	                                d.modifiedDate = $.trim(data.modifiedDate);
	                                d.modifiedBy = $.trim(data.modifiedBy);
	                                row.data(d).draw();
	                                deActivateDimModal.showSuccessModal();
	                                setTimeout(function () {
	                                    deActivateDimModal.hideAllModals();
	                                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                            } else {
	                                deActivateDimModal.showFailureModal();
	                            }
	                        },
	                        error: function error(data) {
	                            deActivateDimModal.hideAllModals();
	                        }
	                    });
	                };
	            }
	        });
	        deActivateDimModal.init();
	        deActivateDimModal.showConfirmModal();
	    });
	
	    $('body').on('click', '.activate-dimdivisor', function (e) {
	        e.preventDefault();
	        var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	        // Get the row based on the parent...
	        var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	        // Get the row data
	        var row = table.row(parent);
	        var activateDimModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: 'Activate Dim Divisor',
	            modalDialogClass: "q-modal-dialog-500",
	            confirmModalBody: '<div class="q-pad-all-xl">Once activated, this dim divisor will be available for selected merchants. This dim divisor can be deactivated at any time.</div>',
	            confirmModalBtnText: 'Activate Dim Divisor',
	            onConfirmClick: function onConfirmClick() {
	                activateDimModal.showLoadingModal();
	                activatedimdivisor(row, row.data());
	                function activatedimdivisor(row, dimdivisor) {
	                    $.ajax({
	                        url: changeDimStatusUrl,
	                        type: 'POST',
	                        dataType: 'JSON',
	                        data: {
	                            dimId: dimdivisor.dimId,
	                            dimStatus: 'Y'
	                        },
	                        success: function success(data) {
	                            if (data.responseStatus === "Success") {
	                                var d = row.data();
	                                d.dimId = $.trim(data.dimId);
	                                d.dimStatus = $.trim(data.dimStatus);
	                                d.dimName = $.trim(data.dimName);
	                                d.dimStatus = $.trim(data.dimStatus);
	                                d.modifiedDate = $.trim(data.modifiedDate);
	                                d.modifiedBy = $.trim(data.modifiedBy);
	                                row.data(d).draw();
	                                activateDimModal.showSuccessModal();
	                                setTimeout(function () {
	                                    activateDimModal.hideAllModals();
	                                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                            } else {
	                                activateDimModal.showFailureModal();
	                            }
	                        },
	                        error: function error(data) {
	                            activateDimModal.hideAllModals();
	                        }
	                    });
	                };
	            }
	        });
	        activateDimModal.init();
	        activateDimModal.showConfirmModal();
	    });
	
	    function init() {
	        $(".lookupDimId").hide();
	        //generateModals();
	        //setElementsInModals();
	        setElements();
	        //loadDropDowns();
	        bindElements();
	        els.exportBtn.hide();
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	    }
	
	    function bindElements() {
	        //On clicking the Edit on lookup, show edit form 
	        $('body').on('click', '.edit-dimdivisor', function (e) {
	            e.preventDefault();
	            var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	            // Get the row based on the parent...
	            var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	            // Get the row data
	            var row = table.row(parent);
	            var dimData = row.data();
	            window.location.href = editDimDivisorUrl + '&' + portletNamespace + 'dimId=' + dimData.dimId + '&' + portletNamespace + 'flow=edit';
	        });
	    }
	
	    function filterSuccess(data) {
	        var dimdivisors = data.content;
	        var page = data.page;
	        dimdivisorLookup.setNewData(dimdivisors);
	        dimdivisorLookup.setPaginationData(page);
	        dimdivisorLookup.hideLoadingOverlay();
	        $(".lookupDimId").hide();
	    }
	
	    function error() {
	        dimdivisorLookup.hideLoadingOverlay();
	        $(".lookupDimId").hide();
	    }
	
	    dimdivisorLookup.init();
	    var table = $("#dimdivisor-lookup-wrapper .data-table-component").DataTable();
	    // Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information;
	    (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	    init();
	});

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _util = __webpack_require__(34);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	  Base file for stub.
	  This is where all the actual stub code will go.
	*/
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	__webpack_require__(1084);
	
	var els = {};
	var elsModal = {};
	var elsModalMap = {};
	var elsMap = {
	  discountsName: "#discounts-name",
	  discountsMerchants: "#retailerList",
	  discountsSaveBtn: ".discounts-save-btn",
	  discountsFormElement: "#discounts-create-edit",
	  discountsValidateClass: ".discounts-validate",
	  retailersdropdown: ".retailer-list-select",
	  merchantDiv: "#merchant-exists",
	  discountsCancelBtn: "#discounts-cancel-btn",
	  discountsNameExists: "#discounts-name-exists",
	  selectSwitch: "#select-switch",
	  selectMerchants: "#select-merchants",
	  selectTier: "#select-tier",
	  saveBtn: ".save-btn"
	
	};
	
	function validateForm(formElement) {
	  var validator = void 0,
	      validationOpts = void 0;
	  validationOpts = {
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  };
	  validator = formElement.validate(validationOpts);
	  validator.settings.ignore = ":disabled,:hidden";
	  if (formElement.valid()) {
	    return true;
	  } else {
	    return false;
	  }
	}
	
	var defdiscountsName = "Default - All Merchants";
	var defMerchant = "0";
	var targetSelector = "#discounts-createedit";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  var discountCreateEditValuesdiv = mainEl.find("#discounts-create-edit-page-values-div");
	  var portletNamespace = mainEl.data("portlet-namespace");
	  var retailerCheckUrl = mainEl.data("retailer-code-check-url");
	  var discountsNameCheckUrl = mainEl.data("discounts-name-check-url");
	  var defaultdiscounts = mainEl.data("defaultdiscounts");
	  var rtdDefault = mainEl.data("rtd-default");
	  var discounts = JSON.stringify(mainEl.data("discounts"));
	  var savediscountsUrl = mainEl.data("discount-save-url");
	  var viewDiscountDetailURL = mainEl.data("view-discount-detail-url");
	  var flow = mainEl.data("edit-form");
	  function init() {
	    generateModals();
	    setElementsInModals();
	    setElements();
	    loadDataOnUI();
	    bindElements();
	    switchMerchants();
	    setupEditChecker();
	    setInitialState();
	  }
	
	  function setInitialState() {
	    els.discountsFormElement.validate(customValidateProps);
	  }
	
	  function setupEditChecker() {
	    _EditChecker2.default.bindNavigation();
	    _EditChecker2.default.bindChangeListener(els.discountsFormElement);
	    _EditChecker2.default.bindCancelButton(els.discountsCancelBtn);
	  }
	
	  function loadDataOnUI() {
	    var serviceValues = [];
	    var divid = void 0;
	
	    getDiscountValuesSectionHtml();
	
	    $("div[id^='US-']").each(function () {
	      divid = "#" + this.id;
	    });
	
	    $("div[id^='CA-']").each(function () {
	      //divid = "#" + this.id;     
	    });
	
	    $("div[id^='OTH-']").each(function () {
	      // divid = "#" + this.id;      
	    });
	  }
	
	  function setElementsInModals() {
	    var body = $('body');
	    (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, body);
	  }
	
	  var counter = 0;
	  function getDiscountValuesSectionHtml() {
	    discountCreateEditValuesdiv.append(valuesHtml);
	    var usSurchargesObj = JSON.parse(discounts).discounts.usSurchargesMap;
	    var caSurchargesObj = JSON.parse(discounts).discounts.caSurcharges;
	    var otherSurchargesObj = JSON.parse(discounts).discounts.otherSurcharges;
	    shippingMethodRendering(usSurchargesObj, '#usShippingMethodCId', 'fedEx-smart-post-expand', 'toggler-target-united-states', 'US');
	    shippingMethodRendering(caSurchargesObj, '#caShippingMethodCId', 'fedex-international-economy-expand', 'toggler-target-canada', 'CA');
	    shippingMethodRendering(otherSurchargesObj, '#otherShippingMethodId', 'fedex-international-economy-outside-expand', 'toggler-target-outside', 'CA');
	  }
	
	  function shippingMethodRendering(surchargeobj, idVal, expandval, togglerVal, countryCode) {
	    for (var i = 0; i < Object.keys(surchargeobj).length; i++) {
	      var valuesContentHtml = __webpack_require__(294);
	      var shippingMethods = $((0, _render2.default)(valuesContentHtml, {
	        usSurchargesValue: Object.keys(surchargeobj)[i],
	        expandableTarget: expandval,
	        btnExpandableTarget: togglerVal,
	        code: countryCode,
	        counter: counter
	      }));
	      $(idVal).append(shippingMethods);
	      surchargesRendering(i, surchargeobj);
	    }
	  }
	
	  function surchargesRendering(i, surchargeobj) {
	    for (var j = 0; j < Object.values(surchargeobj)[i].length; j++) {
	      var surchargeHtml = __webpack_require__(1279);
	      var surcharges = $((0, _render2.default)(surchargeHtml, {
	        surchargeLabel: Object.values(surchargeobj)[i][j].dmdMeaning,
	        surchargeValue: Object.values(surchargeobj)[i][j].rddShipmentMethodId,
	        j: j,
	        surchargeDiscountValue: Object.values(surchargeobj)[i][j].rddDiscountValues
	      }));
	      $('#discount-values-' + counter).append(surcharges);
	    }
	    counter = counter + 1;
	  }
	
	  var discountCreateEditContentDisplay = function discountCreateEditContentDisplay(discountCreateEditValues, expandableTarget, btnExpandableTarget, countryCode) {
	    var init = (0, _render2.default)(__webpack_require__(294), {
	      discountCreateEditValues: discountCreateEditValues,
	      expandableTarget: expandableTarget,
	      btnExpandableTarget: btnExpandableTarget,
	      code: countryCode
	    });
	    return init;
	  };
	
	  var valuesHtml = function valuesHtml() {
	    var valuesContent = (0, _render2.default)(__webpack_require__(1275), {
	      discountName: JSON.parse(discounts).discounts.rtdName
	
	    });
	    return valuesContent;
	  };
	
	  var SaveModal = void 0;
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	  }
	
	  function bindElements() {
	
	    var existingDiscountsName = $('#discounts-name').val();
	    els.retailersdropdown.on('blur', validateRetailer);
	    $('#discounts-name').on('blur', function (e) {
	      if ($(this).val() != existingDiscountsName) {
	        validateDiscountsName();
	      } else {
	        $('#discounts-name-exists').hide();
	      }
	    });
	
	    $('.discounts-validate').on('change', checkdiscountsValidation);
	
	    $('body').on('click', '.discount-section-collapse-expand-btn', function (e) {
	      var target = this.getAttribute('data-q-expander-target');
	      $('div' + target).find('i.fa-angle-up').click();
	      if ($(this).hasClass('active')) {
	        $('div' + target).find('i.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
	      } else {
	        $('div' + target).find('i.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-up');
	      }
	
	      $(this).toggleClass("active");
	    });
	
	    if (rtdDefault === "Y" && flow != "duplicate") {
	      $("#discounts-name").val("Default - All Merchants");
	      $("#discounts-name").attr("disabled", "true");
	    }
	    els.saveBtn.click((0, _general.createPreventDefault)(savediscounts));
	
	    $('#switch-merchants').on('click', switchMerchants);
	  }
	
	  function generateModals() {
	    SaveModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Submit Discount Information',
	      modalDialogClass: "q-modal-dialog-500",
	      confirmModalBody: '<div class="q-pad-all-xl">Once submitted, the information provided will be used to update billing and accounting for selected merchants.</div>',
	      confirmModalBtnText: 'Submit',
	
	      onConfirmClick: function onConfirmClick() {
	        SaveModal.showLoadingModal();
	        setTimeout(function () {
	          SaveModal.showSuccessModal();
	        }, 3000);
	        setTimeout(function () {
	          SaveModal.hideAllModals();
	        }, 6000);
	      }
	    });
	    SaveModal.init();
	  }
	
	  function initConfigPanel() {
	    // Instantiate config panel here. Component has already been imported at the top.
	  }
	
	  function showSaveModal() {
	    SaveModal.showConfirmModal();
	  }
	
	  function checkdiscountsValidation(e) {
	    e.preventDefault();
	    var discountsInputEle = $(this);
	    var closetErrorEle = discountsInputEle.parent().find('label');
	    var closetRequiredErrorElw = discountsInputEle.hasClass('error');
	    validateInput(closetErrorEle, discountsInputEle.val());
	  }
	
	  function validateInput(closetErrorEle, inputValue) {
	    var pattern = /^[0-9]+$/;
	    if (inputValue == '') {
	      closetErrorEle.hide();
	    } else if (!inputValue.match(pattern)) {
	      closetErrorEle.show();
	    } else if (inputValue < 0 || inputValue > 100) {
	      closetErrorEle.show();
	    } else {
	      closetErrorEle.hide();
	    }
	  }
	
	  function savediscounts() {
	    var isValid = validateForm(els.discountsFormElement);
	    var submitdiscountsUrl = savediscountsUrl + '&flow=' + flow;
	    if (isValid && !els.discountsFormElement.find('.q-sim-error').is(':visible')) {
	      var submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: "Submit Discounts ",
	        confirmModalBody: '<div class="q-pad-all-xl">Once submitted, the information provided will be used to update billing and accounting for selected merchants. </div>',
	        confirmModalBtnText: "Submit",
	        onConfirmClick: function onConfirmClick() {
	          submitModalFlow.showLoadingModal();
	          $.ajax({
	            data: els.discountsFormElement.serialize(),
	            url: submitdiscountsUrl,
	            dataType: "JSON",
	            type: 'POST',
	            success: function success(data) {
	              _EditChecker2.default.setPageClean();
	              submitModalFlow.hideAllModals();
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                var discountDetailUrlFullURL = viewDiscountDetailURL + '&discId=' + data.data;
	                window.location.href = discountDetailUrlFullURL;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            },
	            error: function error(data) {
	              submitModalFlow.hideAllModals();
	              submitModalFlow.showFailureModal();
	            }
	          });
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  };
	
	  function validateRetailer() {
	    var selectedRetailerId = els.retailersdropdown.val();
	    var data = _defineProperty({}, portletNamespace + 'selectedRetailerId', JSON.stringify(selectedRetailerId));
	
	    if (!(0, _util.isNullOrUndefined)(selectedRetailerId) && !(0, _general.isBlank)(selectedRetailerId)) {
	      $.ajax({
	        url: retailerCheckUrl,
	        dataType: "JSON",
	        type: 'POST',
	        data: data,
	        success: function success(data) {
	          if (data.response == true) {
	            $(els.merchantDiv.show());
	            els.discountsFormElement.find('.merchant-names').empty();
	            els.discountsFormElement.find('.merchant-names').append(data.merchantList);
	          } else {
	            $(els.merchantDiv.hide());
	          }
	        }
	      });
	    }
	  }
	
	  function switchMerchants() {
	    var selectSwitch = $('#select-switch')[0].checked;
	    if (selectSwitch) {
	      $('#select-merchants').show();
	      $('#select-tier').hide();
	    } else {
	      $('#select-merchants').hide();
	      $('#select-tier').show();
	    }
	  }
	
	  function validateDiscountsName() {
	    var discountsNameVal = $('#discounts-name').val();
	    var data = _defineProperty({}, portletNamespace + 'discountsName', discountsNameVal);
	
	    if (!(0, _util.isNullOrUndefined)(discountsNameVal) && !(0, _general.isBlank)(discountsNameVal)) {
	      $.ajax({
	        url: discountsNameCheckUrl,
	        dataType: "JSON",
	        type: 'POST',
	        data: data,
	        success: function success(data) {
	          if (data.response == true) {
	            $('#discounts-name-exists').show();
	            return false;
	          } else {
	            $('#discounts-name-exists').hide();
	            return true;
	          }
	        }
	      });
	    }
	  }
	
	  init();
	});

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	
	__webpack_require__(1082);
	
	var els = {};
	var elsMap = {
	    detailsdiscountsName: "#dtls-discount-name",
	    editdiscountsBtn: ".dtls-edit-btn",
	    duplicateDiscountsBtn: ".dtls-duplicate-btn"
	};
	var elsModal = {};
	var elsModalMap = {};
	var targetSelector = "#discounts-details";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	    var targetObject = "";
	    var deActivatediscountsModal = null;
	    var discountsDetailsJson = JSON.stringify(mainEl.data("discounts-details-json"));
	    var activatediscountsBtn = mainEl.find(".activate-discounts");
	    var deactivatediscountsBtn = mainEl.find(".deactivate-discounts");
	    var changediscountsStatusUrl = mainEl.data("change-status-url");
	    var pageReloadUrl = mainEl.data("detail-page-reload-url");
	    var editdiscountsUrl = mainEl.data("edit-discounts-url");
	    var portletNamespace = mainEl.data("portlet-namespace");
	    var discountValuesdiv = mainEl.find("#detailspage-values-div");
	
	    function init() {
	        setElementsInModals();
	        setElements();
	        bindElements();
	        loadDataOnUI();
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	    }
	
	    function setElementsInModals() {
	        var body = $('body');
	        (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, body);
	    }
	
	    function bindElements() {
	
	        deactivatediscountsBtn.on("click", function (e) {
	            e.preventDefault();
	            deActivatediscountsModal = new SubmitModalFlow({
	                confirmModalTitle: 'Deactivate discounts',
	                confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this discount will no longer be available for selected merchants. This discount can be reactivated at any time.</div>',
	                confirmModalBtnText: 'Deactivate discounts',
	                modalDialogClass: "q-modal-dialog-500",
	                onConfirmClick: function onConfirmClick() {
	                    deActivatediscountsModal.showLoadingModal();
	                    handlediscountsActivateDeactivate({ url: changediscountsStatusUrl, input: 'N', success: deactivediscountsSuccess, error: deactivediscountsError });
	                }
	            });
	            deActivatediscountsModal.init();
	            deActivatediscountsModal.showConfirmModal();
	        });
	
	        activatediscountsBtn.on("click", function (e) {
	            e.preventDefault();
	            deActivatediscountsModal = new SubmitModalFlow({
	                confirmModalTitle: 'Activate discounts',
	                confirmModalBody: '<div class="q-pad-all-xl">Once activated, this discount will be available for selected merchants. This discount can be deactivated at any time.</div>',
	                confirmModalBtnText: 'Activate discounts',
	                modalDialogClass: "q-modal-dialog-500",
	                onConfirmClick: function onConfirmClick() {
	                    deActivatediscountsModal.showLoadingModal();
	                    handlediscountsActivateDeactivate({ url: changediscountsStatusUrl, input: 'Y', success: deactivediscountsSuccess, error: deactivediscountsError });
	                }
	            });
	            deActivatediscountsModal.init();
	            deActivatediscountsModal.showConfirmModal();
	        });
	
	        els.editdiscountsBtn.click((0, _general.createPreventDefault)(editDiscounts));
	
	        els.duplicateDiscountsBtn.click((0, _general.createPreventDefault)(duplicateDiscounts));
	
	        $('body').on('click', '.discount-section-collapse-expand-btn', function (e) {
	            var target = this.getAttribute('data-q-expander-target');
	            $('div' + target).find('i.fa-angle-up').click();
	            if ($(this).hasClass('active')) {
	                $('div' + target).find('i.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
	            } else {
	                $('div' + target).find('i.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-up');
	            }
	
	            $(this).toggleClass("active");
	        });
	    }
	
	    function loadDataOnUI() {
	        var serviceValues = [];
	        var divid = void 0;
	        getDiscountValuesSectionHtml();
	        $("div[id^='US-']").each(function () {
	            divid = "#" + this.id;
	        });
	
	        $("div[id^='CA-']").each(function () {
	            divid = "#" + this.id;
	        });
	
	        $("div[id^='OTH-']").each(function () {
	            divid = "#" + this.id;
	        });
	    }
	
	    function loadServiceValues(serviceValues) {
	        _.each(serviceValues, function (el) {
	            var id = "#" + el.dmdShipmentMethodId;
	            $(id).text(el.dmddiscountsValue);
	        });
	    }
	
	    function deactivediscountsSuccess(data) {
	        if (data.responseStatus === "Success") {
	            var detailUrlFullURL = pageReloadUrl;
	            deActivatediscountsModal.showSuccessModal();
	            setTimeout(function () {
	                location.href = detailUrlFullURL;
	            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        } else {
	            deActivatediscountsModal.showFailureModal();
	        }
	    }
	    function editDiscounts() {
	        window.location.href = editdiscountsUrl + '&' + portletNamespace + 'discountsId=' + JSON.parse(discountsDetailsJson).discountInfo.rtdId + '&' + portletNamespace + 'flow=edit';
	    };
	
	    function duplicateDiscounts() {
	        window.location.href = editdiscountsUrl + '&' + portletNamespace + 'discountsId=' + JSON.parse(discountsDetailsJson).discountInfo.rtdId + '&' + portletNamespace + 'flow=duplicate';
	    };
	
	    function handlediscountsActivateDeactivate(_ref) {
	        var url = _ref.url,
	            input = _ref.input,
	            success = _ref.success,
	            error = _ref.error;
	
	        $.ajax({
	            url: url,
	            data: { "discountsStatus": input },
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	        });
	    }
	
	    function deactivediscountsError() {
	        deActivatediscountsModal.hideAllModals();
	    }
	
	    var discountInfoDisplay = function discountInfoDisplay(discountValue, expandableTarget, btnExpandableTarget, countryCode) {
	        var init = (0, _render2.default)(__webpack_require__(1276), {
	            discountValue: discountValue,
	            expandableTarget: expandableTarget,
	            btnExpandableTarget: btnExpandableTarget,
	            code: countryCode
	        });
	        return init;
	    };
	
	    var valuesHtml = function valuesHtml() {
	        var valuesContent = (0, _render2.default)(__webpack_require__(1277), {
	            fedExSmartPost: discountInfoDisplay("FedEx Smart Post", "fedEx-smart-post-expand", "toggler-target-united-states", "US"),
	            fedExSmartPostLightWeight: discountInfoDisplay("FedEx Smart Post Light Weight", "fedEx-smart-post-light-weight-expand", "toggler-target-united-states", "US"),
	            fedexHomeDelivery: discountInfoDisplay("Fedex Home Delivery", "fedex-home-delivery-expand", "toggler-target-united-states", "US"),
	            fedExGround: discountInfoDisplay("FedEx Ground", "fedEx-ground-expand", "toggler-target-united-states", "US"),
	            fedExExpressSaver: discountInfoDisplay("FedEx Express Saver", "fedEx-express-saver-expand", "toggler-target-united-states", "US"),
	            fedEx2Day: discountInfoDisplay("FedEx 2 Day", "fedEx-2-day-expand", "toggler-target-united-states", "US"),
	            fedExPriorityOvernight: discountInfoDisplay("FedEx Priority Overnight", "fedEx-priority-overnight-expand", "toggler-target-united-states", "US"),
	            fedExStandardOvernight: discountInfoDisplay("FedEx Standard Overnight", "fedEx-standard-overnight-expand", "toggler-target-united-states", "US"),
	            amazonSellerFulfilledPrime: discountInfoDisplay("Amazon Seller Fulfilled Prime", "amazon-seller-fulfilled-prime-expand", "toggler-target-united-states", "US"),
	            USPS: discountInfoDisplay("USPS", "USPS-expand", "toggler-target-united-states", "US"),
	            fedExInternationalPriority: discountInfoDisplay("FedEx International Priority", "fedEx-international-priority-expand", "toggler-target-canada", "CA"),
	            fedExInternationalGround: discountInfoDisplay("FedEx International Ground", "fedEx-international-ground-expand", "toggler-target-canada", "CA"),
	            fedexInternationalEconomy: discountInfoDisplay("Fedex International Economy", "fedex-international-economy-expand", "toggler-target-canada", "CA"),
	            fedExInternationalPriorityOutSide: discountInfoDisplay("FedEx International Priority", "fedEx-international-priority-outside-expand", "toggler-target-outside", "OT"),
	            fedexInternationalEconomyOutSide: discountInfoDisplay("Fedex International Economy", "fedex-international-economy-outside-expand", "toggler-target-outside", "OT")
	        });
	        return valuesContent;
	    };
	
	    function getDiscountValuesSectionHtml() {
	        discountValuesdiv.append(valuesHtml);
	    }
	
	    init();
	});

/***/ },
/* 602 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "Y": [{
	    title: "Edit",
	    cls: "edit-discounts",
	    icon: "wrench",
	    disabled: false
	  }, {
	    title: "Deactivate",
	    cls: "deactivate-discounts",
	    icon: "toggle-off",
	    disabled: false
	  }],
	  "N": [{
	    title: "Activate",
	    cls: "activate-discounts",
	    icon: "toggle-on",
	    disabled: false
	  }],
	  "D": [{
	    title: "Edit",
	    cls: "edit-discounts",
	    icon: "wrench",
	    disabled: false
	  }, {
	    title: "Duplicate",
	    cls: "duplicate-discounts",
	    icon: "clone",
	    disabled: false
	  }]
	};

/***/ },
/* 603 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var searchDropdown = exports.searchDropdown = [{
		title: "Discounts Name",
		value: "discounts.name"
	}];

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(605);
	
	__webpack_require__(600);
	
	__webpack_require__(601);

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _actionOptions = __webpack_require__(602);
	
	var _searchDropdown = __webpack_require__(603);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _filtersutil = __webpack_require__(16);
	
	var _constants = __webpack_require__(10);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	__webpack_require__(1083);
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var loaddiscountsDetailsLinkHtml = __webpack_require__(1278);
	
	var els = {};
	var elsMap = {
	    exportBtn: ".export-btn"
	};
	var actionList = _actionOptions.actionOptions;
	var targetSelector = "#discounts-lookup";
	
	var savedViews = [{
	    title: "Default View",
	    target: "alldiscounts",
	    active: true,
	    canRemove: false,
	    canEdit: false,
	    filters: [],
	    columns: [{
	        data: "discountsStatus",
	        title: "Actions",
	        active: true,
	        canToggle: false
	    }, {
	        data: "discountsName",
	        title: "Name",
	        active: true,
	        canToggle: false
	    }, {
	        data: "discountsStatus",
	        title: "Status",
	        active: true,
	        canToggle: true
	    }, {
	        data: "rtdMerchant",
	        title: "Merchant",
	        active: true,
	        canToggle: true
	    }, {
	        data: "modifiedDate",
	        title: "Date Modified",
	        active: true,
	        canToggle: true
	    }, {
	        data: "modifiedBy",
	        title: "Modified By",
	        active: true,
	        canToggle: true
	    }, {
	        data: "discountsId",
	        title: "ID",
	        active: true,
	        canToggle: true
	    }]
	}];
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	    var targetObject = "";
	    var dataTableComponentData = mainEl.data("discounts");
	    var viewdiscountsDetailsPageUrl = mainEl.data("view-discounts-details-url");
	    var portletNamespace = mainEl.data("portlet-namespace");
	    var changediscountsStatusUrl = mainEl.data("change-status-url");
	    var filterdiscountsUrl = mainEl.data("filter-discounts-url");
	    var editdiscountsUrl = mainEl.data("edit-discounts-url");
	    var isfinanceadmin = mainEl.data("isfinanceadmin");
	    var deActivatediscountsModal = null;
	    var activatediscountsModal = null;
	    function renderDescription(data, type, item) {
	        var result = void 0;
	        var html = void 0;
	        if (item.itmActive) {
	            html = "<div class='q-marg-all-xs-at-md'>{%- data %}</div>";
	            result = (0, _render2.default)(html, {
	                data: data
	            });
	        } else {
	            html = "<div class='q-marg-all-xs-at-md inactive-items'>{%- data %}</div>";
	            result = (0, _render2.default)(html, {
	                data: data
	            });
	        }
	        return result;
	    }
	
	    function renderStatusPill(data, type, row) {
	        if (data === 'Y') {
	            return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
	        } else {
	            return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
	        }
	    }
	
	    function renderActionWrap(data, type, row, meta) {
	        if (row.discountsName == 'Default - All Merchants') {
	            data = 'D';
	        }
	
	        //This logic is to hide the actions for user with CSS role
	        if (isfinanceadmin == false) {
	            data = 'Z';
	        }
	
	        var newRender = void 0;
	        var statusTarget = actionList[data];
	
	        newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	            list: renderActionCellList(statusTarget),
	            index: meta.row
	        });
	        return newRender;
	    };
	
	    function renderActionCellList(list, data, row) {
	        var renderedList = void 0;
	        renderedList = _(list).map(function (item) {
	            return (0, _render2.default)(actionCellDropdownItemTemplate, {
	                icon: item.icon,
	                title: item.title,
	                cls: item.cls,
	                disabled: false
	            });
	        });
	        return renderedList.join('');
	    }
	
	    function renderDetailLink(data, type, row, meta) {
	        return (0, _render2.default)(loaddiscountsDetailsLinkHtml, {
	            discountsClassName: data,
	            discountsId: row.discountsId,
	            discountsParam: 'discId',
	            detailsPageUrl: viewdiscountsDetailsPageUrl,
	            portletNameSpace: portletNamespace
	        });
	    }
	
	    var discountsLookup = new _index2.default({
	
	        target: $("#discounts-lookup-wrapper"),
	        minWidthClass: "q-min-width-sm-til-md",
	        mobileColumns: [{
	            data: "discountsName",
	            title: "discounts  Name",
	            render: renderDescription,
	            orderable: true
	        }, {
	            data: "discountsMerchant",
	            title: "Merchants"
	        }],
	        tableSearch: true,
	        newSavedViews: true,
	        tableSearchInput: {
	            value: targetObject != "" ? targetObject.value[0] : ""
	        },
	        tableSearchDropdown: {
	            selected: targetObject == "" ? "" : targetObject.key,
	            columns: _searchDropdown.searchDropdown
	        },
	        savedViews: savedViews,
	        bulkSelect: false,
	        dataTable: {
	
	            data: dataTableComponentData.content,
	            columnDefs: [{ className: "custom-class", targets: [1] }],
	            order: [[2, 'asc']],
	            columns: [{
	                data: "discountsStatus",
	                title: "Actions",
	                render: renderActionWrap,
	                orderable: false,
	                class: 'dtc-action-column'
	            }, {
	                data: "discountsName",
	                title: "Name",
	                render: renderDetailLink,
	                class: 'dtc-min-width-md'
	            }, {
	                data: "discountsStatus",
	                title: "Status",
	                render: renderStatusPill,
	                class: 'dtc-min-width-sm'
	            }, {
	                data: "rtdMerchant",
	                title: "Merchant",
	                orderable: false,
	                class: 'dtc-min-width-md'
	            }, {
	                data: "modifiedDate",
	                title: "Date Modified",
	                class: 'dtc-min-width-sm'
	            }, {
	                data: "modifiedBy",
	                title: "Modified By",
	                class: 'dtc-min-width-sm'
	            }, {
	                data: "discountsId",
	                title: "ID",
	                class: 'dtc-min-width-sm lookupdiscountsId'
	            }]
	        },
	        paginationData: dataTableComponentData.page,
	        filterModal: {
	            title: "Filter discounts",
	            tableType: "discounts"
	        },
	        onFetch: function onFetch() {
	            var currentData = discountsLookup.generateData();
	            discountsLookup.showLoadingOverlay();
	            if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	                setTimeout(function () {
	                    (0, _filtersutil.doAjax)({ url: filterdiscountsUrl, success: filterSuccess, error: error, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	                }, _constants.SUCCESS_MODAL_TIMEOUT);
	            }
	        }
	    });
	
	    (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	    $('body').on('click', '.deactivate-discounts', function (e) {
	
	        e.preventDefault();
	        var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	        var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	
	        var row = table.row(parent);
	        var deActivatediscountsModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: 'Deactivate Discounts',
	            modalDialogClass: "q-modal-dialog-500",
	            confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this discount will no longer be available for selected merchants. This discount can be reactivated at any time.</div>',
	            confirmModalBtnText: 'Deactivate Discounts',
	            onConfirmClick: function onConfirmClick() {
	                deActivatediscountsModal.showLoadingModal();
	                deactivatediscounts(row, row.data());
	                function deactivatediscounts(row, discounts) {
	                    $.ajax({
	                        url: changediscountsStatusUrl,
	                        type: 'POST',
	                        dataType: 'JSON',
	                        data: {
	                            discountsId: discounts.discountsId,
	                            discountsStatus: 'N'
	                        },
	                        success: function success(data) {
	                            if (data.responseStatus === "Success") {
	                                var d = row.data();
	                                d.discountsId = $.trim(data.discountsId);
	                                d.discountsStatus = $.trim(data.discountsStatus);
	                                d.discountsName = $.trim(data.discountsName);
	                                d.modifiedDate = $.trim(data.modifiedDate);
	                                d.modifiedBy = $.trim(data.modifiedBy);
	                                row.data(d).draw();
	                                deActivatediscountsModal.showSuccessModal();
	                                setTimeout(function () {
	                                    deActivatediscountsModal.hideAllModals();
	                                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                            } else {
	                                deActivatediscountsModal.showFailureModal();
	                            }
	                        },
	                        error: function error(data) {
	                            deActivatediscountsModal.hideAllModals();
	                        }
	                    });
	                };
	            }
	        });
	        deActivatediscountsModal.init();
	        deActivatediscountsModal.showConfirmModal();
	    });
	
	    $('body').on('click', '.activate-discounts', function (e) {
	        e.preventDefault();
	        var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	        var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	
	        var row = table.row(parent);
	        var activatediscountsModal = new _SubmitModalFlow2.default({
	            confirmModalTitle: 'Activate Discounts',
	            modalDialogClass: "q-modal-dialog-500",
	            confirmModalBody: '<div class="q-pad-all-xl">Once activated, this discount will be available for selected merchants. This discount can be deactivated at any time.</div>',
	            confirmModalBtnText: 'Activate Discounts',
	            onConfirmClick: function onConfirmClick() {
	                activatediscountsModal.showLoadingModal();
	                activatediscounts(row, row.data());
	                function activatediscounts(row, discounts) {
	                    $.ajax({
	                        url: changediscountsStatusUrl,
	                        type: 'POST',
	                        dataType: 'JSON',
	                        data: {
	                            discountsId: discounts.discountsId,
	                            discountsStatus: 'Y'
	                        },
	                        success: function success(data) {
	                            if (data.responseStatus === "Success") {
	                                var d = row.data();
	                                d.discountsId = $.trim(data.discountsId);
	                                d.discountsStatus = $.trim(data.discountsStatus);
	                                d.discountsName = $.trim(data.discountsName);
	                                d.modifiedDate = $.trim(data.modifiedDate);
	                                d.modifiedBy = $.trim(data.modifiedBy);
	                                row.data(d).draw();
	                                activatediscountsModal.showSuccessModal();
	                                setTimeout(function () {
	                                    activatediscountsModal.hideAllModals();
	                                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                            } else {
	                                activatediscountsModal.showFailureModal();
	                            }
	                        },
	                        error: function error(data) {
	                            activatediscountsModal.hideAllModals();
	                        }
	                    });
	                };
	            }
	        });
	        activatediscountsModal.init();
	        activatediscountsModal.showConfirmModal();
	    });
	
	    function init() {
	        $(".lookupdiscountsId").hide();
	        setElements();
	        bindElements();
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	    }
	
	    function bindElements() {
	
	        $('body').on('click', '.edit-discounts', function (e) {
	            e.preventDefault();
	            var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	            var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	            var row = table.row(parent);
	            var discountsData = row.data();
	            window.location.href = editdiscountsUrl + '&' + portletNamespace + 'discountsId=' + discountsData.discountsId + '&' + portletNamespace + 'flow=edit';
	        });
	
	        $('body').on('click', '.duplicate-discounts', function (e) {
	            e.preventDefault();
	            var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	            var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	            var row = table.row(parent);
	            var discountsData = row.data();
	            window.location.href = editdiscountsUrl + '&' + portletNamespace + 'discountsId=' + discountsData.discountsId + '&' + portletNamespace + 'flow=duplicate';
	        });
	    }
	
	    function filterSuccess(data) {
	        var discounts = data.content;
	        var page = data.page;
	        discountsLookup.setNewData(discounts);
	        discountsLookup.setPaginationData(page);
	        discountsLookup.hideLoadingOverlay();
	        $(".lookupdiscountsId").hide();
	    }
	
	    function error() {
	        discountsLookup.hideLoadingOverlay();
	        $(".lookupdiscountsId").hide();
	    }
	
	    discountsLookup.init();
	    var table = $("#discounts-lookup-wrapper .data-table-component").DataTable();
	    init();
	});

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render2 = __webpack_require__(6);
	
	var _render3 = _interopRequireDefault(_render2);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _select2able = __webpack_require__(22);
	
	var _constants = __webpack_require__(10);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _util = __webpack_require__(34);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _index = __webpack_require__(114);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	var modalHtml = __webpack_require__(11);
	__webpack_require__(273);
	
	// Additional Imports...
	
	//const dayShiftRowHtml = require('./html/dayShiftRow.html');
	var newShiftHtml = __webpack_require__(296);
	var newAddDoorHtml = __webpack_require__(1287);
	var dockNewEditHtml = __webpack_require__(185);
	var dockEditHtml = __webpack_require__(1288);
	
	var targetSelector = "#dock-details";
	
	//const mainEl = $(mainHtml);
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  dockConfigDetails(mainEl);
	});
	
	function dockConfigDetails(mainEl) {
	
	  var activateDock = mainEl.data("activate-dock-msg");
	  var activateDockBtn = mainEl.data("activate-dock-msg");
	  var deactivateDockBtn = mainEl.data("deactivate-dock-msg");
	  var deactivateDock = mainEl.data("deactivate-dock-msg");
	  var pageRefreshUrl = mainEl.data("page-refresh-url");
	  var dockId = mainEl.data("dock-id");
	  var deleteItemUrl = mainEl.data("delete-item-url");
	
	  var activateDiv = (0, _render3.default)('<div class="q-pad-all-xl">{%-activateMsg %}</div>', {
	    activateMsg: mainEl.data("activate-dock-txt-msg")
	  });
	  var deactivateDiv = (0, _render3.default)('<div class="q-pad-all-xl">{%-deactivateMsg %}</div>', {
	    deactivateMsg: mainEl.data("deactivate-dock-txt-msg")
	  });
	
	  //Validate the Form 
	  function validateForm(formElement) {
	    var validator = void 0,
	        validationOpts = void 0;
	    validationOpts = {
	      debug: true,
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    };
	    validator = formElement.validate(validationOpts);
	    validator.settings.ignore = ":disabled,:hidden";
	
	    if (formElement.valid()) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  var saveURL = mainEl.data("save-url");
	  var dockDetailsPageUrl = mainEl.data("dock-details-url");
	
	  var els = {};
	
	  var elsModal = {};
	
	  var removeDockModal = void 0,
	      submitDocConfigModalFlow = void 0;
	  var toggleForClosure = 1;
	
	  var doorDetailsArray = [];
	
	  var monthArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	  var dockConfiguration = mainEl.data('dock-configuration-json');
	
	  var elementsMap = {
	    addShiftBtn: '.add-shift-btn',
	    dayShiftRow: '.day-shift-row',
	    submitDockBtn: '.submit-dock-btn',
	    submitEditDockBtn: '.submit-edit-dock-btn',
	    cancelDockBtn: '.cancel-dock-btn',
	
	    dayOfWeekCheckbox: '.day-of-week-checkbox',
	    addDoorBtn: '.add-door-btn',
	    removeDockBtn: '.remove-dock-btn',
	    //saveDockConfigBtn: '.save-dock-config-btn',
	    removeDockHtmlSec: '.dock-details',
	    cancelEditDockBtn: '.cancel-edit-dock-btn',
	    dockDetailsFormElement: '#dock-details-form-element',
	    addDateBtn: '.add-date-btn',
	    addNewFacilityDockBtn: "#add-new-facility-dock-btn"
	  };
	
	  var elsModalMap = {
	    removeDockDialogBtn: '.remove-btn-on-modal'
	  };
	  var dockConfigsToSave = {
	    dockDetails: [],
	    plannedOperationClosures: {},
	    history: {}
	  };
	  var shiftTimes = {
	    monday: [],
	    tuesday: [],
	    wednesday: [],
	    thursday: [],
	    friday: [],
	    saturday: [],
	    sunday: []
	  };
	  var toggle = 1;
	  var initialized = false;
	  var numberOfPlannedClosureDates = 0;
	  var savedShiftTimes = {
	    //Sample data for saved shift times
	    monday: [],
	    // monday: [],
	    tuesday: [],
	    wednesday: [],
	    thursday: [],
	    friday: [],
	    saturday: [],
	    sunday: []
	  };
	  function init() {
	    setElement();
	    generateModals();
	    setElementsOnModal();
	    bindElement();
	    initiateTimePickers();
	    initiateDoorAppointmentType();
	    handleSwitchingTypeInput();
	  }
	  function initiateDoorAppointmentType() {
	    (0, _select2able.instantiateSelect2)(mainEl.find('.select2-select'));
	  }
	  function setElement() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	  }
	  function setElementsOnModal() {
	    var $body = $('body');
	    (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, $body);
	  }
	  function unbindElement() {
	    mainEl.off('click', '.add-shift-btn');
	    mainEl.off('click', '.remove-shift-btn');
	    mainEl.off('click', '.cancel-dock-config-btn');
	    mainEl.off('click', '.remove-dock-btn');
	    mainEl.off('click', '.remove-door-btn');
	    mainEl.off('click', '.edit-dock-btn');
	    mainEl.off('click', '.add-date-btn');
	    mainEl.off('click', '.save-dock-config-btn');
	  }
	  function bindElement() {
	    unbindElement();
	    mainEl.on('click', '.add-shift-btn', onAddShiftBtnClick);
	    mainEl.on('click', '.remove-shift-btn', onRemoveShiftBtnClick);
	    mainEl.on('click', '.cancel-dock-config-btn', onCancelDockBtnClick);
	    mainEl.on('click', '.cancel-edit-config-btn', onCancelEditConfigBtnClick);
	    els.submitDockBtn.on('click', onSubmitBtnClick);
	    els.submitEditDockBtn.on('click', onEditSubmitBtnClick);
	    els.cancelDockBtn.on('click', onCancelBtnClick);
	    els.dayOfWeekCheckbox.on('change', handleCheckboxChange);
	    els.addDoorBtn.on('click', onAddDoorBtnClick);
	    mainEl.on('click', '.remove-dock-btn', onRemoveDockbtnClick);
	    //els.saveDockConfigBtn.on('click', onSaveDockConfigBtnClick);
	    mainEl.on('click', '.remove-door-btn', onRemoveDoorBtnClick);
	    mainEl.on('click', '.remove-date-btn', onRemoveDateBtnClick);
	    elsModal.removeDockDialogBtn.on('click', removeDockModalFunc);
	    mainEl.on('click', '.edit-dock-btn', onEditDockBtnClick);
	    mainEl.on('click', '.save-dock-config-btn', onSaveBtnClick);
	    els.cancelEditDockBtn.on('click', onCancelEditDockBtnClick);
	    mainEl.on('click', '.add-date-btn', addDateBtnClick);
	  }
	
	  function onCancelDockBtnClick() {
	    $('#edit-dock-details').show();
	    $('#dock-config-new-edit').hide();
	  }
	
	  function generateModals() {
	    removeDockModal = $((0, _render3.default)(modalHtml, {
	      title: 'Dock Removal',
	      leftAlignTitle: true,
	      modalDialogClass: 'q-modal-dialog-500',
	      topCloseBtn: true,
	      autoHideTop: true,
	      body: ' <div class="q-marg-all-xl">\n                  Are you sure you want to remove the dock from the facility?\n                </div>',
	      footerBtns: '\n                    <a href="#" class="base-btn purple-btn v2-btn modal-auto-hide">Cancel</a>\n                    <a href="#" class="base-btn purple-btn remove-btn-on-modal">Remove</a>\n                    '
	    }));
	
	    $('body').append(removeDockModal);
	
	    submitDocConfigModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTile: 'Submit Dock Information',
	      confirmModalBody: ' <div class="q-marg-all-xl">\n                            Once submitted, the information provided will be \n                            used to accurately display available appointment \n                            slots for dock scheduling.\n                          </div>',
	      confirmModalBtnText: 'Submit',
	      modalDialogClass: 'q-modal-dialog-500',
	      onConfirmClick: function onConfirmClick() {
	        submitDocConfigModalFlow.showLoadingModal();
	        setTimeout(function () {
	          submitDocConfigModalFlow.showSuccessModal();
	        }, 3000);
	        setTimeout(function () {
	          submitDocConfigModalFlow.showFailureModal();
	        }, 6000);
	        setTimeout(function () {
	          submitDocConfigModalFlow.hideAllModals();
	        }, 9000);
	      }
	    });
	
	    submitDocConfigModalFlow.init();
	  }
	
	  var removeIndex = void 0;
	  function onRemoveDockbtnClick(e) {
	    e.preventDefault();
	    removeIndex = $(this).closest('.remove-dock-btn').data('index-id');
	    removeDockModal.modal('show');
	  }
	
	  function removeDockModalFunc() {
	    var removeDockHtml = $('.dock-details-' + removeIndex);
	    removeDockHtml.remove();
	    removeDockModal.modal('hide');
	  }
	  function fillEditForm(dockeditformarea, docDetails) {
	    dockeditformarea.find("[name='dock-edit-name']").val(docDetails.dockName);
	    var door = docDetails.doorDetails[0];
	    dockeditformarea.find("[name='door-edit-name']").val(door.doorName);
	    dockeditformarea.find("[name='door-edit-uses']").val(door.doorUses);
	    dockeditformarea.find("[name='door-edit-appointment-types']").val(door.doorAppts);
	
	    dockeditformarea.show();
	  }
	  function onEditDockBtnClick(e) {
	    e.preventDefault();
	
	    $('#dock-config-new-edit').hide();
	    var docDetails;
	    var editDockIndex = $(this).closest('.edit-dock-btn').data('index-id');
	    console.log("dockDetailsArray " + dockConfigsToSave.dockDetails.length);
	
	    for (var i = 1; i <= dockConfigsToSave.dockDetails.length; i++) {
	      if (i == editDockIndex) docDetails = dockConfigsToSave.dockDetails[i - 1];
	      //console.log("dockDetailsArray111 "+JSON.stringify(dockConfigsToSave.dockDetails[i-1]));
	      //Do something
	    }
	    console.log("docDet.dockDetails.dockName " + docDetails.dockName);
	    var dockeditformarea = $('#dock-details').find('#edit-dock-area');
	    if (dockeditformarea.length) {
	      fillEditForm(dockeditformarea, docDetails);
	      return;
	    }
	
	    var dockName = docDetails.dockName;
	
	    var doorEditHtml = __webpack_require__(1289);
	    var dayShiftRow = __webpack_require__(184);
	
	    var doorsHtml = (0, _render3.default)(doorEditHtml, _extends({}, docDetails.doorDetails[0]));
	
	    var mainHtml = (0, _render3.default)(dockEditHtml, {
	      dockName: dockName,
	      doorEditDetails: doorsHtml,
	      shiftEditRows: renderShiftRows(),
	      dataEditIndex: editDockIndex
	    });
	
	    $('#dock-details').append(mainHtml);
	
	    $('#door-edit-details-section').find('[name=door-edit-uses]').val(docDetails.doorDetails[0].doorUses);
	    $('#door-edit-details-section').find('[name=door-edit-appointment-types]').val(docDetails.doorDetails[0].doorAppts);
	    // instantiateSwitchery($('.js-switchery'));
	
	    init();
	
	    fillEditTimes(docDetails.dosDays);
	  }
	
	  function fillEditTimes(dosDays) {
	    var dayshiftrows = $('#edit-dock-area').find('.day-shift-row');
	    for (var i = 0; i < 6; i++) {
	      if (!(typeof dosDays[i].dosTime[0] === 'undefined')) {
	        if (dosDays[i].dosTime[0].dosStartTime != null) {
	          var dayshiftrow = $(dayshiftrows[i]);
	          dayshiftrow.find('.day-of-week-checkbox').prop('checked', 'true');
	          dayshiftrow.trigger("change");
	          var timePickerArea = dayshiftrow.find('.time-picker-area');
	          var dayOfWeek = timePickerArea.data('day-of-week');
	          var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	          timeFrom.enableTimePicker();
	          timeFrom.setTimeFromMilitary(dosDays[i].dosTime[0].dosStartTime);
	          var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	          timeTo.enableTimePicker();
	          timeTo.setTimeFromMilitary(dosDays[i].dosTime[0].dosEndTime);
	          dayshiftrow.find('.add-shift-btn').removeClass('disabled');
	          dayshiftrow.find('.default-add-shift-btn').show();
	          dayshiftrow.find('.q-alert').hide();
	        }
	        if (dosDays[i].dosTime.length > 1) {
	          for (var j = 1; j < dosDays[i].dosTime.length; j++) {
	            if (dosDays[i].dosTime[j].dosStartTime != null && dosDays[i].dosTime[j].dosStartTime != undefined) {
	              var _dayshiftrow = $(dayshiftrows[i]);
	              _dayshiftrow.find('.day-of-week-checkbox').prop('checked', 'true');
	              _dayshiftrow.trigger("change");
	              var timePickerAreaShift = _dayshiftrow.find('.time-picker-area');
	              var _dayOfWeek = timePickerAreaShift.data('day-of-week');
	              var $newShiftHtml = $(newShiftHtml);
	              var _timeFrom = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-from'));
	              _timeFrom.enableTimePicker();
	              _timeFrom.setTimeFromMilitary(dosDays[i].dosTime[j].dosStartTime);
	              var _timeTo = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-to'));
	              _timeTo.enableTimePicker();
	              _timeTo.setTimeFromMilitary(dosDays[i].dosTime[j].dosEndTime);
	              timePickerAreaShift.append($newShiftHtml);
	              shiftTimes[_dayOfWeek].push({ timeFrom: _timeFrom, timeTo: _timeTo });
	              if (shiftTimes[_dayOfWeek].length > 1 && shiftTimes[_dayOfWeek].length <= 25) {
	                timePickerAreaShift.find('.add-shift-btn').removeClass('disabled');
	                timePickerAreaShift.find('.default-add-shift-btn').hide();
	                var dayShiftRow = $(this).closest('.day-shift-row');
	                dayShiftRow.find('.q-alert').hide();
	              }
	              if (shiftTimes[_dayOfWeek].length && shiftTimes[_dayOfWeek].length === 25) {
	                timePickerAreaShift.find('.add-shift-btn').hide();
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function onSaveDockConfigBtnClick(e) {
	    e.preventDefault();
	    submitDocConfigModalFlow.showConfirmModal();
	  }
	
	  // let timePickerFromEl = mainEl.find('.time-picker-from');
	  // let timePickerToEl = mainEl.find('.time-picker-to');
	
	  // let timePickerFrom = timePicker(timePickerFromEl);
	  // let timePickerTo = timePicker(timePickerToEl);
	
	
	  function onAddDoorBtnClick(e) {
	    e.preventDefault();
	    var dockIndex = void 0;
	    dockIndex = $(this).closest('.new-dock-form').data('index-id');
	    var dockAreaFormEle = mainEl.find('#new-dock-form-' + dockIndex);
	    var isValidOrgForm = validateForm(dockAreaFormEle);
	
	    if (isValidOrgForm) {
	      var $newAddDoorHtml = $(newAddDoorHtml);
	      (0, _select2able.instantiateSelect2)($newAddDoorHtml.find('.select2-select'));
	      $('.add-door-details').append($newAddDoorHtml);
	    }
	  }
	
	  function onRemoveDoorBtnClick(e) {
	    e.preventDefault();
	    var removeDoorHtml = $(this).closest('.remove-door-details');
	    removeDoorHtml.remove();
	  }
	
	  function onRemoveDateBtnClick(e) {
	    e.preventDefault();
	    var removeDateHtml = $(this).closest('.remove-date-details');
	    removeDateHtml.remove();
	    //var closureDates= getClosureDates(dockConfiguration.plannedOperationClosures.closureDates);
	    numberOfPlannedClosureDates--;
	    if (numberOfPlannedClosureDates == 0) {
	      $('#dock-config-new-edit').find("div[name='closure-details']").find(".q-alert").show();
	    }
	    // if(closureDates.length==0){
	    //   $('#dock-config-new-edit').find("div[name='closure-details']").find(".q-alert").show();
	    // }
	  }
	
	  function nthDay(d) {
	    if (d > 3 && d < 21) return 'th';
	    switch (d % 10) {
	      case 1:
	        return "st";
	      case 2:
	        return "nd";
	      case 3:
	        return "rd";
	      default:
	        return "th";
	    }
	  }
	
	  function addDateBtnClick(e) {
	    e.preventDefault();
	    var closureDateHtml = __webpack_require__(295);
	    var plannedClosures = $("#planned-closure-details");
	    var plannedClosureDate = plannedClosures.find("input[name='add-date-text']").val();
	    var date = new Date(plannedClosureDate);
	    var dateTextToShow = monthArr[date.getMonth()] + ' ' + date.getDate() + nthDay(date.getDate()) + ', ' + date.getFullYear() + ' :';
	    var closurename = "closure-date-" + toggleForClosure;
	    var closureDt = (0, _render3.default)(closureDateHtml, {
	      plannedClosureDate: dateTextToShow,
	      closureDate: closurename,
	      toggleForClosure: toggleForClosure
	    });
	    toggleForClosure++;
	    $('#dock-config-new-edit').find("div[name='closure-details']").find(".q-alert").hide();
	    numberOfPlannedClosureDates++;
	    $('#dock-config-new-edit').find("div[name='closure-details']").append(closureDt);
	    (0, _instantiateSwitchery.instantiateSwitchery)($('.js-switchery'));
	
	    //const timePickerArea=$(closureDt).find('.time-picker-area');
	    var timePickerArea = $('#dock-config-new-edit').find("." + closurename).find('.time-picker-area');
	    var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	    var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	    timeFrom.enableTimePicker();
	    timeTo.enableTimePicker();
	  }
	
	  function onAddShiftBtnClick(e) {
	    e.preventDefault();
	    var timePickerArea = $(this).closest('.time-picker-area');
	    var dayOfWeek = timePickerArea.data('day-of-week');
	    var $newShiftHtml = $(newShiftHtml);
	    var timeFrom = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-from'));
	    var timeTo = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-to'));
	    //const prevAddShiftBtn = timePickerArea.find('.add-shift-btn');
	
	
	    shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	    var timeFromVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	    var timeToVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	    if (timeFromVal.getMilitaryTime(shiftTimes[dayOfWeek][0].timeFrom) != "Invalid date" && timeToVal.getMilitaryTime(shiftTimes[dayOfWeek][0].timeTo) != "Invalid date") {
	      if (timeFromVal.getMilitaryTime(shiftTimes[dayOfWeek].timeFrom) < timeToVal.getMilitaryTime(shiftTimes[dayOfWeek].timeTo)) {
	        timePickerArea.append($newShiftHtml);
	        if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 25) {
	
	          timePickerArea.find('.add-shift-btn').removeClass('disabled');
	          timePickerArea.find('.default-add-shift-btn').hide();
	          var dayShiftRow = $(this).closest('.day-shift-row');
	          //let dayOfWeekShift = dayShiftRow.data('day-of-week');
	          dayShiftRow.find('.q-alert').hide();
	        }
	        if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 25) {
	          timePickerArea.find('.add-shift-btn').hide();
	        }
	        $(this).hide();
	      } else {
	        var _dayShiftRow = $(this).closest('.day-shift-row');
	        _dayShiftRow.find('.q-alert-t').show();
	      }
	    } else {
	      var _dayShiftRow2 = $(this).closest('.day-shift-row');
	      _dayShiftRow2.find('.q-alert').show();
	    }
	  }
	
	  function onRemoveShiftBtnClick(e) {
	    e.preventDefault();
	    var timePickerArea = $(this).closest('.time-picker-area');
	    var dayOfWeek = timePickerArea.data('day-of-week');
	    var shiftToRemove = $(this).closest('.new-shift');
	    var indexToRemove = shiftToRemove.index();
	    var prevAddShift = $(timePickerArea.find('.new-shift').get(indexToRemove - 2)).find('.add-shift-btn');
	    $(shiftToRemove).remove();
	    shiftTimes[dayOfWeek].splice(indexToRemove, 1);
	    if (shiftTimes[dayOfWeek].length < 25) {
	      timePickerArea.find('.add-shift-btn').removeClass('disabled');
	    }
	    if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 25) {
	      //timePickerArea.find('.add-shift-btn').show();
	      prevAddShift.show();
	      timePickerArea.find('.default-add-shift-btn').hide();
	    }
	    if (shiftTimes[dayOfWeek].length == 1) {
	      timePickerArea.find('.default-add-shift-btn').show();
	    }
	  }
	
	  //validator = mainEl.validate(validationOpts);
	  //validator.settings.ignore = ":disabled,:hidden";
	  function onSaveBtnClick(e) {
	    console.log(dockConfigsToSave);
	
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: "Save Dock Configuration",
	      confirmModalBody: '<div class="q-pad-all-xl">Once saved this dock scheduled warehouse dock Configuration are assigned to this warehouse.</div>',
	      confirmModalBtnText: "Save",
	      onConfirmClick: function onConfirmClick() {
	        var saveDockConfigURL = saveDockURL;
	        submitModalFlow.showLoadingModal();
	        $.ajax({
	          data: {
	            dockConfiguration: JSON.stringify(dockConfigsToSave)
	          },
	          url: saveDockConfigURL,
	          dataType: "JSON",
	          type: 'POST',
	          success: function success(data) {
	            _EditChecker2.default.setPageClean();
	            submitModalFlow.hideAllModals();
	            submitModalFlow.showSuccessModal();
	            setTimeout(function () {
	              location.href = dockDetailsPageUrl; // + "&retailerId=" + data;
	            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	          },
	          error: function error(data) {
	            submitModalFlow.hideAllModals();
	            submitModalFlow.showFailureModal();
	          }
	        });
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	  function timeConverter(miltaryTime) {
	    if (miltaryTime == "Invalid date") return miltaryTime;
	    var hourAndMinute = miltaryTime.split(":");
	    var hours = hourAndMinute[0],
	        minutes = hourAndMinute[1];
	    var AmOrPm = hours >= 12 ? 'PM' : 'AM';
	    hours = hours % 12 || 12;
	    return hours + ":" + minutes + " " + AmOrPm;
	  }
	
	  function onEditSubmitBtnClick(e) {
	    var editDockIndex = void 0;
	    editDockIndex = $(this).closest('.edit-dock-form').data('edit-index-id');
	    var editDockAreaFormEle = mainEl.find('#edit-dock-form-' + editDockIndex);
	    var isValideditDockForm = validateForm(editDockAreaFormEle);
	    if (isValideditDockForm) {
	      var editDockArea = $('#edit-dock-area');
	      var editIndex = editDockArea.data('edit-index');
	      //const dockAreaFormEle  = mainEl.find('#edit-dock-form-'+editIndex);
	      var newDockName = editDockArea.find("input[name='dock-edit-name']").val();
	      var newDoorName = editDockArea.find("input[name='door-edit-name']").val();
	      var newDoorUses = editDockArea.find("select[name='door-edit-uses']").val();
	      var newDoorApptTypes = editDockArea.find("select[name='door-edit-appointment-types']").val();
	
	      var newDosDays = getShiftTimes();
	
	      dockConfigsToSave.dockDetails[editIndex - 1] = {
	        dockName: newDockName,
	        doorDetails: [{ doorName: newDoorName, doorUses: newDoorUses, doorAppts: newDoorApptTypes }],
	        dosDays: newDosDays.dosDays
	      };
	      var docDisplayDetails = $('#docDisplayDetails-' + editIndex);
	      docDisplayDetails.find('[name=dock-name]').text(newDockName);
	      docDisplayDetails.find('[name=doordetails-doorname]').text(newDoorName);
	      docDisplayDetails.find('[name=doordetails-dooruses]').text(newDoorUses);
	      docDisplayDetails.find('[name=doordetails-doorappts]').text(newDoorApptTypes);
	      docDisplayDetails.find('[name=operational-shift-times-summary]').remove();
	      docDisplayDetails.find('[name=operational-times-area]').append(renderoptimes(newDosDays.shiftTimesToSave));
	      editDockArea.hide();
	      $('#dock-config-new-edit').show();
	    }
	  }
	  function onSubmitBtnClick(e) {
	    e.preventDefault();
	    var dockIndex = void 0;
	    dockIndex = $(this).closest('.new-dock-form').data('index-id');
	    var dockAreaFormEle = mainEl.find('#new-dock-form-' + dockIndex);
	    var isValidOrgForm = validateForm(dockAreaFormEle);
	    if (isValidOrgForm) {
	
	      var dock = $("#new-edit-dock-area");
	      var _dockNewEditHtml = dock.find("div[name='door-details-section']");
	      var dockName = dock.find("input[name='dock-name']").val();
	
	      var i;
	      var _doorDetailsArray = [];
	      for (i = 0; i < _dockNewEditHtml.length; i++) {
	        var door = $(_dockNewEditHtml.get(i));
	        var doorDetails = {};
	        doorDetails.doorName = door.find("input[name=door-name]").val();
	        doorDetails.doorUses = door.find("select[name=door-uses]").val();
	        doorDetails.doorAppts = door.find("select[name=door-appointment-types]").val();
	        _doorDetailsArray[i] = doorDetails;
	      }
	
	      var shiftTimes = getShiftTimes();
	      dockConfigsToSave.dockDetails.push({
	        dockName: dockName,
	        doorDetails: _doorDetailsArray,
	        dosDays: shiftTimes.dosDays
	      });
	
	      // const doorDetailsSection = dockNewEditHtml;
	
	      // doorDetailsSection.each( obj, function( index, value ) {
	      //   console.log( index + ": " + value );
	      // });
	
	      addSubmittedDocks(dockName, _doorDetailsArray, shiftTimes.shiftTimesToSave);
	      onCancelBtnClick(e);
	    }
	  }
	
	  function getShiftTimes() {
	    var shiftTimesToSave = {};
	
	    Object.keys(shiftTimes).forEach(function (key) {
	      shiftTimesToSave[key] = shiftTimes[key].map(function (el) {
	        return {
	          from: timeConverter(el.timeFrom.getMilitaryTime()),
	          to: timeConverter(el.timeTo.getMilitaryTime()),
	          fromTime: el.timeFrom.getMilitaryTime(),
	          toTime: el.timeTo.getMilitaryTime()
	        };
	      });
	    });
	
	    var dosDays = [],
	        p = 0;
	    Object.keys(shiftTimesToSave).forEach(function (key) {
	      dosDays[p] = {};
	      dosDays[p].dosDay = key;
	      dosDays[p].dosTime = [];
	      dosDays[p].dosTime = shiftTimesToSave[key].map(function (el) {
	        if (el.from != "Invalid date") {
	          return { dosStartTime: el.fromTime, dosEndTime: el.toTime };
	        }
	      });
	      p++;
	    });
	    return { dosDays: dosDays, shiftTimesToSave: shiftTimesToSave };
	  }
	  function addSubmittedDocks(dockName, doorDetailsArray, shiftTimesToSave) {
	    var toggleDoor = 1;
	    var mydoorsHtml = __webpack_require__(1291);
	    var doordetailsHtml = __webpack_require__(1290);
	
	    var doorrows = doorDetailsArray.map(function (doorDetails) {
	
	      return (0, _render3.default)(doordetailsHtml, {
	        doorDetails: doorDetails,
	        toggle: toggleDoor++
	      });
	    });
	    toggleDoor = 1;
	    var a = doorrows.join('');
	
	    var opdiv = renderoptimes(shiftTimesToSave);
	
	    var mydoors = (0, _render3.default)(mydoorsHtml, {
	      dockName: dockName,
	      doordetailshtml: a,
	      timehtml: opdiv,
	      togglerTarget: "toggler-target-" + toggle,
	      dockDetails: "dock-details-" + toggle,
	      toggle: toggle
	    });
	    toggle++;
	    $('#dock-config-new-edit').find("div[name='dock-details-area']").append(mydoors);
	    // $('#dock-config-new-edit').find("div[name='operational-times-area']").append(optimes);
	    $('#dock-config-new-edit').find("div[name='add-facility-dock-btn-section']").hide();
	    $('#dock-config-new-edit').find("div[name='add-new-facility-dock-btn']").show();
	  }
	
	  function renderoptimes(shiftTimesToSave) {
	    var optimes = [],
	        optimeIndex = 0;
	    var toggleshift = 1;
	    var opertionalshifttimesHtml = __webpack_require__(1292);
	
	    Object.keys(shiftTimesToSave).forEach(function (key) {
	
	      var mytimes = shiftTimesToSave[key].map(function (el) {
	        if (el.from == 'Invalid date') return;
	        return '<span id="edit-operational-shift-{%-toggleshift%}">' + el.from + ' - ' + el.to + '</span> <br />';
	      });
	      if (mytimes.length > 0) optimes.push((0, _render3.default)(opertionalshifttimesHtml, {
	        day: key,
	        time: mytimes.join('')
	      }));
	      toggleshift++;
	      // shiftTimesToSave[key]=[];
	    });
	
	    return optimes.join('');
	  }
	  function onCancelBtnClick(e) {
	    e.preventDefault();
	    Object.keys(shiftTimes).forEach(function (key) {
	      shiftTimes[key] = [];
	    });
	    var newEditDockArea = $('.new-dock-form');
	    newEditDockArea.remove();
	    $('#dock-config-new-edit').show();
	  }
	
	  function onCancelEditConfigBtnClick(e) {
	    var newEditDockArea = $('#dock-config-new-edit');
	    newEditDockArea.remove();
	    $('#edit-dock-details').show();
	  }
	
	  function onCancelEditDockBtnClick(e) {
	    e.preventDefault();
	    Object.keys(shiftTimes).forEach(function (key) {
	      shiftTimes[key] = [];
	    });
	
	    var editDockArea = $('#edit-dock-area');
	    editDockArea.remove();
	    $('#dock-config-new-edit').show();
	  }
	
	  function initiateDatePickers() {
	    var plannedClosures = $("#planned-closure-details");
	    var plannedClosureDate = plannedClosures.find("input[name='add-date-text']");
	    var today = new Date();
	    plannedClosureDate.datepicker({
	      startDate: today,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	  }
	
	  function initiateTimePickers() {
	    els.dayShiftRow.each(function (index, el) {
	      var $el = $(el);
	      var dayOfWeek = $el.data('day-of-week');
	      var timePickerArea = $el.find('.time-picker-area');
	      var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	      var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	      var dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
	      timeFrom.disableTimePicker();
	      timeTo.disableTimePicker();
	      shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	      if (savedShiftTimes[dayOfWeek].length == 1) {
	        dayOfWeekCheckbox.prop('checked', 'true');
	        timePickerArea.find('.add-shift-btn').removeClass('disabled');
	        timeFrom.enableTimePicker();
	        timeTo.enableTimePicker();
	        timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
	        timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
	      } else if (savedShiftTimes[dayOfWeek].length > 1 && savedShiftTimes[dayOfWeek].length <= 3) {
	        dayOfWeekCheckbox.prop('checked', 'true');
	        timePickerArea.find('.add-shift-btn').removeClass('disabled');
	        timeFrom.enableTimePicker();
	        timeTo.enableTimePicker();
	        timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
	        timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
	        savedShiftTimes[dayOfWeek].shift();
	        savedShiftTimes[dayOfWeek].map(function (shift) {
	          var $newShiftHtml = $(newShiftHtml);
	          var timeFrom = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-from'));
	          var timeTo = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-to'));
	          timePickerArea.append($newShiftHtml);
	          timeFrom.setTimeFromMilitary(shift.from);
	          timeTo.setTimeFromMilitary(shift.to);
	          shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	        });
	      }
	      if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 3) {
	        timePickerArea.find('.add-shift-btn').addClass('disabled');
	      }
	    });
	  }
	  function handleCheckboxChange() {
	    var isChecked = $(this).is(':checked');
	    var dayShiftRow = $(this).closest('.day-shift-row');
	    var dayOfWeek = dayShiftRow.data('day-of-week');
	    if (isChecked) {
	      shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
	      shiftTimes[dayOfWeek][0].timeTo.enableTimePicker();
	      dayShiftRow.find('.add-shift-btn').removeClass('disabled');
	      dayShiftRow.find('.default-add-shift-btn').show();
	    } else {
	      dayShiftRow.find('.new-shift').remove();
	      shiftTimes[dayOfWeek].length = 1;
	      shiftTimes[dayOfWeek][0].timeFrom.disableTimePicker();
	      shiftTimes[dayOfWeek][0].timeTo.disableTimePicker();
	      shiftTimes[dayOfWeek][0].timeFrom.resetTime();
	      shiftTimes[dayOfWeek][0].timeTo.resetTime();
	      dayShiftRow.find('.add-shift-btn').addClass('disabled');
	      dayShiftRow.find('.default-add-shift-btn').show();
	    }
	  }
	
	  //const editDockBtn = mainEl.data('data-edit-dock-url');
	  var saveDockURL = mainEl.data('save-dock-url');
	
	  mainEl.on("click", '.edit-dock-configurations-purple-btn', editDockHandler);
	  mainEl.on("click", '.add-facility-dock-btn', addFacilityDockHandler);
	  mainEl.on("click", '#add-new-facility-dock-btn', addFacilityDockHandler);
	
	  var dockConfigNewEditHtml = __webpack_require__(1280);
	  var dockNewEditHtml = __webpack_require__(185);
	
	  // function editDockHandler(e){
	  //   e.preventDefault();
	  //   $('#edit-dock-details').hide();
	  //   const dockConfigNewEdit = $(render(dockConfigNewEditHtml, {
	  //         facilityDocks: require('./html/dockConfigNewEdit/html/facilityDocks.html'),
	  //         plannedOperationClosure: require('./html/dockConfigNewEdit/html/plannedOperationClosure.html')
	  //   }));
	
	  //   $('#dock-details').append(dockConfigNewEdit);
	  //   }
	
	  function addFacilityDockHandler(e) {
	    e.preventDefault();
	    $('#dock-config-new-edit').hide();
	    // const dockNewEdit = $(render(dockNewEditHtml, {
	    //    day:"Monday",
	    //       shiftRows: require('./html/dockNewEdit/html/dayShiftRow.html')
	
	    // }));
	    var mainHtml1 = (0, _render3.default)(dockNewEditHtml, {
	      shiftRows: renderShiftRows(),
	      toggle: toggle
	    });
	    $('#dock-details').append(mainHtml1);
	    (0, _select2able.instantiateSelect2)($('.new-dock-form').find('.select2-select'));
	    $('.new-dock-form').find('.doorUses').on("change", handleDoorUsesChange);
	    init();
	  }
	
	  function handleDoorUsesChange() {
	    handleSwitchingTypeInput();
	  }
	
	  function handleSwitchingTypeInput() {
	    var doorUsesVal = $('.doorUses  :selected').val();
	    if (doorUsesVal == "Inbound and Outbound") {
	      renderapmtTypeIAO(doorUsesVal);
	    } else {
	      renderapmtTypeIAO(doorUsesVal);
	    }
	  }
	
	  var aptTypesIAO = [{
	    key: 'Live Load',
	    value: 'Live Load'
	  }, {
	    Key: 'Pickup Empty',
	    value: 'Pickup Empty'
	  }, {
	    key: 'Pickup Load',
	    value: 'Pickup Load'
	  }, {
	    key: 'Live Unload',
	    value: 'Live Unload'
	  }, {
	    key: 'Drop Unload',
	    value: 'Drop Unload'
	  }, {
	    key: 'Drop Load',
	    value: 'Drop Load'
	  }];
	
	  var aptTypesO = [{
	    key: 'Live Load',
	    value: 'Live Load'
	  }, {
	    Key: 'Pickup Empty',
	    value: 'Pickup Empty'
	  }, {
	    key: 'Pickup Load',
	    value: 'Pickup Load'
	  }];
	
	  var doorUses = {
	    'Inbound and Outbound': 'Inbound and Outbound',
	    'Outbound only': 'Outbound only'
	  };
	
	  function renderapmtTypeIAO(doorUsesVal) {
	    var aptTypeSelect = $(".doorAppointmentTypes");
	    aptTypeSelect.html('');
	    if (doorUsesVal == "Inbound and Outbound") {
	      $(aptTypesIAO).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.key).text(this.value);
	        aptTypeSelect.append(option);
	      });
	    } else if (doorUsesVal == "Outbound only") {
	      $(aptTypesO).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.key).text(this.value);
	        aptTypeSelect.append(option);
	      });
	    }
	    aptTypeSelect.addClass("select2 select");
	    (0, _select2able.instantiateSelect2)(aptTypeSelect);
	  }
	
	  function editDockHandler(e) {
	    e.preventDefault();
	    $('#edit-dock-details').hide();
	    var dockConfigNewEdit = $((0, _render3.default)(dockConfigNewEditHtml, {
	      facilityDocks: (0, _render3.default)(__webpack_require__(1284), {
	        dockTypes: getRenderedDockTypes(dockConfiguration.dockDetails)
	      }),
	      plannedOperationClosure: (0, _render3.default)(__webpack_require__(1286), {
	        closureDates: getClosureDates(dockConfiguration.plannedOperationClosures.closureDates)
	      })
	    }));
	    dockConfigNewEdit.find('#add-new-facility-dock-btn').hide();
	    $('#dock-details').append(dockConfigNewEdit);
	    (0, _select2able.instantiateSelect2)($('.edit-dock-form').find('.select2-select'));
	    $('.edit-dock-form').find('.editDoorUses').on("change", handleDoorUsesChange);
	    initiateDatePickers();
	  }
	
	  function renderShiftRows() {
	    var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
	    //let days = ['Monday', 'Tuesday'];
	    var dayShiftRowHtml = __webpack_require__(184);
	    //const rawTemplateHtml = require('./html/timePickerTemplate.html');
	    var shiftRow = days.map(function (day) {
	      return (0, _render3.default)(dayShiftRowHtml, {
	        day: day
	      });
	    });
	
	    return shiftRow.join('');
	  }
	
	  //Iterating JSON data
	  function getRenderedDockTypes(dockTypes) {
	    var dockTypeHtml = __webpack_require__(1285);
	    var response = _underscore2.default.map(dockTypes, function (docks) {
	      return (0, _render3.default)(dockTypeHtml, {
	        docks: docks,
	        dosDays: getDosDays(docks.dosDays),
	        doorDetails: getDoorDetails(docks.doorDetails)
	      });
	    });
	    return response.join("");
	  }
	  function getDosDays(dosDays) {
	    var dosDaysHtml = __webpack_require__(1281);
	    var response = _underscore2.default.map(dosDays, function (dosDay) {
	      return (0, _render3.default)(dosDaysHtml, {
	        dosDay: dosDay,
	        dosTimes: getDosTimes(dosDay.dosTime)
	      });
	    });
	    return response.join("");
	  }
	  function getDosTimes(dosTimes) {
	    var dosTimesHtml = __webpack_require__(1282);
	    var response = _underscore2.default.map(dosTimes, function (dosTime) {
	      return (0, _render3.default)(dosTimesHtml, {
	        dosTime: dosTime
	      });
	    });
	    return response.join("");
	  }
	  function getDoorDetails(doorDetails) {
	    var doorDetailsHtml = __webpack_require__(1283);
	    var response = _underscore2.default.map(doorDetails, function (doorDetail) {
	      return (0, _render3.default)(doorDetailsHtml, {
	        doorDetail: doorDetail
	      });
	    });
	    return response.join("");
	  }
	
	  function getClosureDates(closureDates) {
	    if (!closureDates) return [];
	    var closureDatesHtml = __webpack_require__(295);
	    var response = _underscore2.default.map(closureDates, function (closureDate) {
	      var _render;
	
	      return (0, _render3.default)(closureDatesHtml, (_render = {
	        closureDate: closureDate
	      }, _defineProperty(_render, 'closureDate', "closure-date-" + toggleForClosure), _defineProperty(_render, 'toggleForClosure', toggleForClosure), _render));
	      toggleForClosure++;
	    });
	    return response.join("");
	  }
	
	  $('#deactivate-dock-btn-details').on("click", function (e) {
	    var deactivateDockModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: deactivateDock,
	      confirmModalBody: deactivateDiv,
	      confirmModalBtnText: deactivateDockBtn,
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	
	        deactivateDockModal.showLoadingModal();
	        deactivateDock({ url: deleteItemUrl, success: deactivateSuccess, error: deactivateFailure });
	        function deactivateDock(_ref) {
	          var url = _ref.url,
	              success = _ref.success,
	              error = _ref.error;
	
	          $.ajax({
	            data: {
	              docId: dockId,
	              activeDeativeFlag: "N"
	            },
	            url: url,
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	          });
	        }
	        function deactivateSuccess() {
	          deactivateDockModal.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, 3000);
	        }
	        function deactivateFailure() {
	          deactivateDockModal.showFailureModal();
	        }
	      }
	    });
	    deactivateDockModal.init();
	    deactivateDockModal.showConfirmModal();
	  });
	
	  $('#activate-dock-btn-details').on("click", function (e) {
	    e.preventDefault();
	    var activateDockModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: activateDock,
	      confirmModalBody: activateDiv,
	      confirmModalBtnText: activateDockBtn,
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	
	        activateDockModal.showLoadingModal();
	        activateDock({ url: deleteItemUrl, success: activateSuccess, error: activateFailure });
	        function activateDock(_ref2) {
	          var url = _ref2.url,
	              success = _ref2.success,
	              error = _ref2.error;
	
	          $.ajax({
	            data: {
	              docId: dockId,
	              activeDeativeFlag: "Y"
	            },
	            url: url,
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	          });
	        }
	        function activateSuccess() {
	          activateDockModal.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, 3000);
	        }
	        function activateFailure() {
	          activateDockModal.showFailureModal();
	        }
	      }
	    });
	    activateDockModal.init();
	    activateDockModal.showConfirmModal();
	  });
	  //END Iterating JSON data
	
	
	  //   function onEditDockBtnClick(e){
	  //   e.preventDefault();
	  //   const editDockHtml = $(this).closest('.remove-door-details');
	  //   editDockHtml.remove();
	  // }
	
	  init();
	}

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _ConfigPanel = __webpack_require__(109);
	
	var _ConfigPanel2 = _interopRequireDefault(_ConfigPanel);
	
	var _general = __webpack_require__(5);
	
	var _docLookupFieldDropdown = __webpack_require__(609);
	
	var _actionOptions = __webpack_require__(608);
	
	var _filtersutil = __webpack_require__(16);
	
	var _pagableComponent = __webpack_require__(86);
	
	var _pagableComponent2 = _interopRequireDefault(_pagableComponent);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _testFilterData = __webpack_require__(614);
	
	var _testColumnModalData = __webpack_require__(612);
	
	var _testData = __webpack_require__(613);
	
	var _statusOptions = __webpack_require__(611);
	
	var _savedViews = __webpack_require__(610);
	
	var _renderers = __webpack_require__(615);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/*
	  Base file for stub.
	  This is where all the actual stub code will go.
	*/
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	__webpack_require__(1085);
	// Additional Imports...
	
	var detailLinkHTML = __webpack_require__(84);
	
	var targetSelector = "#dock-lookup";
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	
	// Modal Html to use
	var modalHtml = __webpack_require__(11);
	var modalAlertHtml = __webpack_require__(182);
	var _ = __webpack_require__(2);
	
	var dockDetails = __webpack_require__(1293);
	var statusPillRenderTemplate = __webpack_require__(1294);
	
	// Action List Rendering Functions...
	
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  var lookupData = mainEl.data("dock-lookup-data");
	  var lookupTable = mainEl.find("#lookup-wrapper");
	  //const shouldCheckCache = mainEl.data("should-check-cache");
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	  //const criteriaObjectFromServer  =  mainEl.data("filter-criteria-from-server");
	  var filterItemsUrl = mainEl.data("filter-items-url");
	  var editUrl = mainEl.data("edit-url");
	  var savedViews = mainEl.data("saved-view");
	  var saveViewURL = mainEl.data("save-view-url");
	  var deleteViewURL = mainEl.data("delete-view-url");
	  var editPermission = mainEl.data("dock-edit-permission");
	  var viewDockDetailUrl = mainEl.data("dock-details-url");
	  var portletNamespace = mainEl.data("portlet-namespace");
	  var deleteItemUrl = mainEl.data("delete-item-url");
	  var generateExportUrl = mainEl.data("export-url");
	  var activateItemUrl = $(targetSelector).data("activate-item-url");
	  var bulkActivateDeactivateBtnUrl = mainEl.data("bulk-activate-dock-url");
	  var pageRefreshUrl = mainEl.data("page-refresh-url");
	  var lookupColumns = void 0;
	  var targetObject = "";
	  var exportModal = new _filtersutil.buildExport();
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var selectedRows = "";
	  // END: REQUIRED TO LOAD STUB
	
	  // START: REAL CODE
	
	  var els = {};
	  var elsModal = {};
	
	  //for rendering the status pills
	  var pillStatusClasses = {
	    "Active": "q-pill-blue",
	    "Inactive": "q-pill-blue-border"
	  };
	
	  var actionList = _statusOptions.statusOptionsExample;
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	  // START: Actual Code
	  function renderPill(data, type, row) {
	    return data;
	  }
	
	  var deActivateModal = void 0,
	      activateModal = void 0;
	
	  // Create Constants based on functions required for action lists.
	
	  var _createDropdownRender = (0, _renderers.createDropdownRenderers)(actionList),
	      renderActionWrap = _createDropdownRender.renderActionWrap;
	
	  var elsMap = {
	    copydockdoorBtn: ".copy-dock-door",
	    editdockdoorBtn: ".edit-dock-door",
	    activatedockdoorBtn: ".activate-dock-door",
	    deactivatedockdoorBtn: ".deactivate-dock-door"
	  };
	
	  var elsModalMap = {};
	
	  var dockLookupTable = new _index2.default({
	    target: $("#lookup-wrapper"),
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: [{
	      data: "docDeactiveActive",
	      title: "Actions",
	      orderable: false,
	      render: renderActionWrap1,
	      class: 'dtc-action-column'
	    },
	    // END: Example Actions Column
	    {
	      data: "docName",
	      title: "Dock Door Name",
	      render: dockDoorActionBtns,
	      class: 'dtc-min-width-sm'
	    }, {
	      data: "docUse",
	      title: "Door Uses",
	      class: 'dtc-min-width-sm'
	    }, {
	      data: "docAppointmentTypes",
	      title: "Appointment Types",
	      render: customAppointmentTypes,
	      class: 'dtc-min-width-lg'
	    }, {
	      data: "docDeactiveActive",
	      title: "Status",
	      render: statusPillRender,
	      class: 'dtc-min-width-sm'
	    }, {
	      data: "docUseFacilitiesSchedule",
	      title: "Schedule Type",
	      render: scheduleTypeRender,
	      class: 'dtc-min-width-sm'
	    }, {
	      data: "docModifiedDate",
	      title: "Date Modified",
	      render: formateDate,
	      class: 'dtc-min-width-sm'
	    }, {
	      data: "docModifiedBy",
	      title: "Modified By",
	      class: 'dtc-min-width-sm'
	    }],
	
	    // OPTIONAL: Set whether users can create new views
	    // newSavedViews: false,
	    // OPTIONAL: Set Saved View Array
	    savedViews: savedViews,
	    // OPTIONAL: Set whether search bar will display
	    tableSearch: true,
	    tableSearchInput: {
	      value: targetObject != "" ? targetObject.value[0] : "",
	      // Not required
	      //optional value to prefill input
	      //value: "Search",
	      placeholder: 'Search'
	    },
	    // CONDITIONALLY OPTIONAL: search input info, has to be used with tableSearchInput
	    tableSearchDropdown: {
	      // selected property is optional
	      columns: _docLookupFieldDropdown.docLookupFieldDropdown
	    },
	    //OPTIONAL, defaults to false: set this to true if you need column with select boxes for bulk select
	    bulkSelect: true,
	    // REQUIRED - Data Table specific settings
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: lookupData.content,
	      // REQUIRED: Even if empty, needs to be here.
	      columnDefs: [{
	        className: "custom-class", targets: [1]
	      }],
	      // CONDITIONAL REQUIREMENT: If using bulk select, this needs to be defined so the table doesn't try to order the checkbox column.
	      order: [[8, 'desc']],
	      columns: [
	      // START: Example Actions Column
	      {
	        data: "docDeactiveActive",
	        title: "Actions",
	        orderable: false,
	        render: renderActionWrap1,
	        class: 'dtc-action-column'
	      },
	      // END: Example Actions Column
	      {
	        data: "docName",
	        title: "Dock Door Name",
	        render: dockDoorActionBtns,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "docUse",
	        title: "Door Uses",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "docAppointmentTypes",
	        title: "Appointment Types",
	        render: customAppointmentTypes,
	        class: 'dtc-min-width-lg'
	      }, {
	        data: "docDeactiveActive",
	        title: "Status",
	        render: statusPillRender,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "docUseFacilitiesSchedule",
	        title: "Schedule Type",
	        render: scheduleTypeRender,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "docModifiedDate",
	        title: "Date Modified",
	        render: formateDate,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "docModifiedBy",
	        title: "Modified By",
	        class: 'dtc-min-width-sm'
	      }]
	    },
	    paginationData: lookupData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Orders",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "orders"
	    },
	    onBulkSelectChange: function onBulkSelectChange() {
	      selectedRows = dockLookupTable.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      // console.log(selectedRows.length);
	      // console.log(selectedRows);
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass('disabled');
	      } else {
	        $(".action-header-btn .base-btn").addClass('disabled');
	      };
	    },
	    onFetch: function onFetch() {
	      var currentData = dockLookupTable.generateData();
	      dockLookupTable.showLoadingOverlay();
	
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterItemsUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	  dockLookupTable.init();
	  var table = $("#lookup-wrapper .data-table-component").DataTable();
	
	  function filterSuccessFun(data) {
	    var items = data.content;
	    var page = data.page;
	    dockLookupTable.setNewData(items);
	    dockLookupTable.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    dockLookupTable.hideLoadingOverlay();
	    setExportData(dockLookupTable.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var items = data.lookupItems.content;
	    var page = data.lookupItems.page;
	    dockLookupTable.setNewData(items);
	    dockLookupTable.setPaginationData(page);
	    dockLookupTable.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    dockLookupTable.hideLoadingOverlay();
	    setExportData(dockLookupTable.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var items = data.lookupItems.content;
	    var page = data.lookupItems.page;
	    dockLookupTable.setNewData(items);
	    dockLookupTable.setPaginationData(page);
	    dockLookupTable.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    dockLookupTable.hideLoadingOverlay();
	    setExportData(dockLookupTable.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var items = data.lookupItems.content;
	    var page = data.lookupItems.page;
	    dockLookupTable.removeSavedView(data.target);
	    dockLookupTable.setNewData(items);
	    dockLookupTable.setPaginationData(page);
	    dockLookupTable.hideLoadingOverlay();
	    setExportData(dockLookupTable.generateData());
	  }
	
	  function errorFun(data) {
	    dockLookupTable.hideLoadingOverlay();
	  }
	
	  function init() {
	    setElements();
	    setElementsInModals();
	    bindElements();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	  }
	
	  function setElementsInModals() {
	    var body = $('body');
	    (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, body);
	  }
	
	  function bindElements() {}
	
	  $('body').on('click', '.deactivate-dock', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = table.row(parent);
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Deactivate Dock Door',
	      modalDialogClass: "q-modal-dialog-500",
	      confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this dock door will no longer be available for appointments. This dock door can be reactivated at any time.</div>',
	      confirmModalBtnText: 'Deactivate Dock Door',
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        deleteProduct(row, row.data());
	        function deleteProduct(row, dock) {
	          $.ajax({
	            url: deleteItemUrl,
	            type: 'POST',
	            dataType: 'JSON',
	            data: {
	              docId: dock.docId,
	              activeDeativeFlag: "N"
	            },
	            success: function success(data) {
	              if (data.response == "success") {
	                var d = row.data();
	                d.docDeactiveActive = $.trim(data.docDeactiveActive);
	                location.href = pageRefreshUrl;
	                row.data(d).draw();
	                submitModalFlow.showSuccessModal();
	                setTimeout(function () {
	                  submitModalFlow.hideAllModals();
	                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	              } else {
	                submitModalFlow.showFailureModal();
	              }
	            },
	            error: function error(data) {
	              submitModalFlow.hideAllModals();
	            }
	          });
	        };
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  });
	
	  $('body').on('click', '.activate-dock', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = table.row(parent);
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Activate Dock Door',
	      modalDialogClass: "q-modal-dialog-500",
	      confirmModalBody: '<div class="q-pad-all-xl">Once activated, this dock door will no longer be available for appointments. This dock door can be deactivated at any time.</div>',
	      confirmModalBtnText: 'Activate Dock Door',
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        activateProduct(row, row.data());
	        function activateProduct(row, dock) {
	          $.ajax({
	            url: deleteItemUrl,
	            type: 'POST',
	            dataType: 'JSON',
	            data: {
	              docId: dock.docId,
	              activeDeativeFlag: "Y"
	            },
	            success: function success(data) {
	              if (data.response == "success") {
	                var d = row.data();
	                d.docDeactiveActive = "Y";
	                location.href = pageRefreshUrl;
	                row.data(d).draw();
	                submitModalFlow.showSuccessModal();
	                setTimeout(function () {
	                  submitModalFlow.hideAllModals();
	                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	              } else {
	                submitModalFlow.showFailureModal();
	              }
	            },
	            error: function error(data) {
	              submitModalFlow.hideAllModals();
	            }
	          });
	        };
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  });
	
	  $('body').on('click', '.edit-dock', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = table.row(parent);
	    var mydocId = row.data().docId;
	    location.href = editUrl + "&docId=" + mydocId;
	  });
	
	  $('body').on('click', '.copy-dock', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = table.row(parent);
	    var mydocId = row.data().docId;
	    location.href = editUrl + "&docId=" + mydocId + "&copy=true";
	  });
	
	  //Actions
	  function renderActionWrap1(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = _actionOptions.actionOptions["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    var statusTarget = _actionOptions.actionOptions['all'];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, item));
	    });
	    return renderedList.join('');
	  }
	
	  function neededActions(data, row, item) {
	    var action = {};
	    if (item.title === 'Activate/Deactivate') {
	      if (data === "Y") {
	        action = {
	          icon: 'toggle-off',
	          title: 'Deactivate',
	          cls: "deactivate-dock",
	          disabled: false
	        };
	      } else {
	        action = {
	          icon: 'toggle-on',
	          title: 'Activate',
	          cls: "activate-dock",
	          disabled: false
	        };
	      }
	    } else if (item.title === 'Copy') {
	      if (row.product != null && row.product.prdHazardMaterial) {
	        action = {
	          icon: 'clone',
	          title: 'Copy',
	          cls: "",
	          disabled: true
	        };
	      } else {
	        action = {
	          icon: 'clone',
	          title: 'Copy',
	          cls: "copy-dock",
	          disabled: false
	        };
	      }
	    } else if (item.title === 'Activate Selected Docks') {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: checkDisableForGivenAction(data, row, item.title)
	      };
	    } else if (item.title === 'Deactivate Selected Docks') {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: checkDisableForGivenAction(data, row, item.title)
	      };
	    } else {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: item.disabled
	      };
	    }
	    return action;
	  }
	
	  function checkDisableForGivenAction(data, row, actionName) {
	    var isTrue = false;
	    _(selectedRows).map(function (item) {
	      if (callBusinessLogicToDisableAction(item.data.docDeactiveActive, item.data, actionName)) {
	        if (!isTrue) {
	          isTrue = true;
	        }
	      }
	    });
	    return isTrue;
	  };
	
	  function callBusinessLogicToDisableAction(data, row, actionName) {
	    if ( /*editPermission &&*/(0, _general.isPresent)(data)) {
	      if (actionName === "Activate Selected Docks") {
	        if (data === "Y") {
	          return true;
	        } else {
	          return false;
	        }
	      } else if (actionName === "Deactivate Selected Docks") {
	        if (data === "N") {
	          return true;
	        } else {
	          return false;
	        }
	      }
	    }
	  }
	
	  //Bulk Activate and Deactivate
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  $('body').on('click', '.bulk-activate-dock', function () {
	    if (shallAllowClick(this)) {
	      $("#bulkActivatedock").modal("show");
	    }
	  });
	
	  $('#modalBulkActivateDock').click(function () {
	    submitModalFlow.showLoadingModal();
	    bulkActivateDeativateOrg('Y');
	  });
	
	  $('body').on('click', '.bulk-deactivate-dock', function () {
	    if (shallAllowClick(this)) {
	      $("#bulkDeActivateDock").modal("show");
	    }
	  });
	
	  $('#modalBulkDeActivateDock').click(function () {
	    submitModalFlow.showLoadingModal();
	    bulkActivateDeativateOrg('N');
	  });
	
	  function bulkActivateDeativateOrg(val) {
	    var _data;
	
	    $.ajax({
	      url: bulkActivateDeactivateBtnUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: (_data = {}, _defineProperty(_data, portletNamespace + 'docId', getAllSelectedDockIds()), _defineProperty(_data, 'activeDeativeFlag', val), _data),
	      success: function success(data) {
	        if (data.response === "success") {
	          _(selectedRows).map(function (item) {
	            var currentRow = $(".data-table-component").dataTable().api().row(item.rowIndex);
	            var d = currentRow.data();
	            d.docDeactiveActive = val;
	            currentRow.data(d).draw();
	          });
	          dockLookupTable.uncheckAllSelected();
	          $(".action-header-btn .base-btn").addClass('disabled');
	          setTimeout(function () {
	            submitModalFlow.hideAllModals();
	          }, _constants.SUCCESS_MODAL_TIMEOUT);
	        }
	      },
	      error: function error() {
	        submitModalFlow.hideAllModals();
	      }
	    });
	  }
	
	  function getAllSelectedDockIds() {
	    var docIds = new Array();
	    _(selectedRows).map(function (item) {
	      docIds.push(item.data.docId);
	    });
	    return JSON.stringify(docIds);
	  }
	
	  //for enabling the modal for subscription
	  function dockDoorActionBtns(data, type, row) {
	    var detailPageHTML = (0, _render2.default)(detailLinkHTML, {
	      renderURL: viewDockDetailUrl,
	      portletNamespace: portletNamespace,
	      id: row.docId,
	      idName: "docId",
	      displayVal: data
	    });
	    return detailPageHTML;
	  }
	
	  function statusPillRender(data, type, row) {
	    if (data === 'Y') {
	      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
	    } else {
	      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
	    }
	  }
	
	  function scheduleTypeRender(data, type, row) {
	    if (data === 'Y') {
	      return "Master";
	    } else {
	      return "Individual";
	    }
	  }
	
	  function customAppointmentTypes(data) {
	    if (data != null) {
	      return data.split(',').join(', ');
	    } else {
	      return "";
	    }
	  }
	
	  function formateDate(createdDate, type, data) {
	    if (createdDate != null && createdDate != "") {
	      var date = new Date(createdDate); //createdDate is long time format
	      var month = date.getMonth() + 1;
	      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear();
	    } else {
	      return "";
	    }
	  }
	
	  function initExport() {
	    var exportObj = {
	      title: mainEl.data("export-popup-title"),
	      exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
	      exportMaxLimitLang: mainEl.data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent();
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(generateExportUrl, currentData);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  initExport();
	  setExportData(dockLookupTable.generateData());
	
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	
	  init();
	  // END: REAL CODE
	});

/***/ },
/* 608 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    icon: 'toggle-on',
	    title: 'Activate Selected Docks',
	    cls: "bulk-activate-dock",
	    disabled: true
	  }, {
	    icon: 'toggle-off',
	    title: 'Deactivate Selected Docks',
	    cls: "bulk-deactivate-dock",
	    disabled: true
	  }],
	  "actions": [{
	    title: "Edit",
	    cls: "edit-dock",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Copy",
	    cls: "copy-dock",
	    icon: "clone",
	    disabled: false
	  }, {
	    title: "Activate/Deactivate",
	    cls: "",
	    icon: "",
	    disabled: false
	  }]
	};

/***/ },
/* 609 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var docLookupFieldDropdown = exports.docLookupFieldDropdown = [{
	  title: "Door Name",
	  value: "docName"
	}, {
	  title: "Modified By",
	  value: "docModifiedBy"
	}];

/***/ },
/* 610 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var testSavedViews = exports.testSavedViews = [{
	  title: "All Orders",
	  target: "allOrders",
	  active: true,
	  canRemove: false,
	  canEdit: false,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": false
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": true,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate",
	        "dateRangeEndVal": "05/31/2017",
	        "dateRangeStartVal": "05/30/2017"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "doorStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "dockDoorName",
	    title: "Dock Door Name",
	    active: true,
	    canToggle: true
	  }, {
	    data: "doorUses",
	    title: "Door Uses",
	    active: true,
	    canToggle: true
	  }, {
	    data: "appointmentTypes",
	    title: "Appointment Types",
	    active: true,
	    canToggle: true
	  }, {
	    data: "dockStatus",
	    title: "Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "scheduleType",
	    title: "Schedule Type",
	    active: true,
	    canToggle: true
	  }, {
	    data: "dateModified",
	    title: "Date Modified",
	    active: true,
	    canToggle: false
	  }, {
	    data: "modifiedBy",
	    title: "Modified By",
	    active: true,
	    canToggle: true
	  }]
	}, {
	  title: "Saved Search 1",
	  target: "savedSearchOne",
	  active: false,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "doorStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "dockDoorName",
	    title: "Dock Door Name",
	    active: true,
	    canToggle: true
	  }, {
	    data: "doorUses",
	    title: "Door Uses",
	    active: true,
	    canToggle: true
	  }, {
	    data: "appointmentTypes",
	    title: "Appointment Types",
	    active: true,
	    canToggle: true
	  }, {
	    data: "dockStatus",
	    title: "Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "scheduleType",
	    title: "Schedule Type",
	    active: true,
	    canToggle: true
	  }, {
	    data: "dateModified",
	    title: "Date Modified",
	    active: true,
	    canToggle: false
	  }, {
	    data: "modifiedBy",
	    title: "Modified By",
	    active: true,
	    canToggle: true
	  }]
	}];
	
	var testNewSavedView = exports.testNewSavedView = {
	  title: "New Saved Search",
	  target: "savedViewUpdatedTarget",
	  active: true,
	  canRemove: true,
	  canEdit: true,
	  filters: [{
	    "filterGroup": "Inventory Status",
	    "filterGroupType": "checkbox",
	    "filterGroupName": "status",
	    "filterGroupInputs": [{
	      "filterTitle": "In Stock",
	      "filterValue": "inStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Low Stock",
	      "filterValue": "lowStock",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterTitle": "Out of Stock",
	      "filterValue": "outOfStock",
	      "filterOperator": "equal",
	      "active": true
	    }]
	  }, {
	    "filterGroup": "Date Range",
	    "filterGroupType": "radio",
	    "filterGroupName": "fixedRange",
	    "filterGroupInputs": [{
	      "filterName": "fixedRange",
	      "filterTitle": "Today",
	      "filterValue": "today",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Yesterday",
	      "filterValue": "yesterday",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 7 Days",
	      "filterValue": "lastSevenDays",
	      "filterOperator": "equal",
	      "active": false
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Last 60 Days (Default)",
	      "filterValue": "lastSixtyDays",
	      "filterOperator": "equal",
	      "active": true
	    }, {
	      "filterName": "fixedRange",
	      "filterTitle": "Custom Date Range",
	      "filterValue": "customRange",
	      "filterOperator": "equal",
	      "active": false,
	      "childFilters": [{
	        "filterGroup": "Date Range",
	        "filterGroupType": "dateRange",
	        "filterGroupName": "dateRange",
	        "dateRangeNameStart": "startDate",
	        "dateRangeNameEnd": "endDate"
	      }]
	    }]
	  }],
	  columns: [{
	    data: "doorStatus",
	    title: "Actions",
	    active: true,
	    canToggle: false
	  }, {
	    data: "dockDoorName",
	    title: "Dock Door Name",
	    active: true,
	    canToggle: true
	  }, {
	    data: "doorUses",
	    title: "Door Uses",
	    active: true,
	    canToggle: true
	  }, {
	    data: "appointmentTypes",
	    title: "Appointment Types",
	    active: true,
	    canToggle: true
	  }, {
	    data: "dockStatus",
	    title: "Status",
	    active: true,
	    canToggle: true
	  }, {
	    data: "scheduleType",
	    title: "Schedule Type",
	    active: true,
	    canToggle: true
	  }, {
	    data: "dateModified",
	    title: "Date Modified",
	    active: true,
	    canToggle: false
	  }, {
	    data: "modifiedBy",
	    title: "Modified By",
	    active: true,
	    canToggle: true
	  }]
	};

/***/ },
/* 611 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var statusOptionsExample = exports.statusOptionsExample = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "Active": [{
	    title: "Edit",
	    cls: "edit-dock-door",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Copy",
	    cls: "copy-dock-door",
	    icon: "copy",
	    disabled: false
	  }, {
	    title: "Deactivate",
	    cls: "deactivate-dock-door",
	    icon: "toggle-off",
	    disabled: false
	  }],
	  "Inactive": [{
	    title: "Edit",
	    cls: "edit-dock-door",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Copy",
	    cls: "copy-dock-door",
	    icon: "copy",
	    disabled: false
	  }, {
	    title: "Activate",
	    cls: "activate-dock-door",
	    icon: "toggle-on",
	    disabled: false
	  }]
	};

/***/ },
/* 612 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var testColumns = exports.testColumns = [{
	  data: "doorStatus",
	  title: "Actions",
	  active: true,
	  canToggle: false
	}, {
	  data: "dockDoorName",
	  title: "Dock Door Name",
	  active: true,
	  canToggle: true
	}, {
	  data: "doorUses",
	  title: "Door Uses",
	  active: true,
	  canToggle: true
	}, {
	  data: "appointmentTypes",
	  title: "Appointment Types",
	  active: true,
	  canToggle: true
	}, {
	  data: "dockStatus",
	  title: "Status",
	  active: true,
	  canToggle: true
	}, {
	  data: "scheduleType",
	  title: "Schedule Type",
	  active: true,
	  canToggle: true
	}, {
	  data: "dateModified",
	  title: "Date Modified",
	  active: true,
	  canToggle: false
	}, {
	  data: "modifiedBy",
	  title: "Modified By",
	  active: true,
	  canToggle: true
	}];

/***/ },
/* 613 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataTableComponentData = exports.dataTableComponentData = [{
	  "dockDoorName": "Door 1",
	  "doorUses": "Inbound Only",
	  "appointmentTypes": "Live Unload, Drop Unload",
	  "dockStatus": "Inactive",
	  "scheduleType": "Master",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Door 2",
	  "doorUses": "Inbound and Outbount",
	  "appointmentTypes": "All Appointment Types",
	  "dockStatus": "Active",
	  "scheduleType": "Individual",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Door 3",
	  "doorUses": "Inbound and Outbount",
	  "appointmentTypes": "All Appointment Types",
	  "dockStatus": "Inactive",
	  "scheduleType": "Master",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Warehouse 2",
	  "doorUses": "Inbound and Outbount",
	  "appointmentTypes": "All Appointment Types",
	  "dockStatus": "Active",
	  "scheduleType": "Individual",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Warehouse 3",
	  "doorUses": "Inbound and Outbount",
	  "appointmentTypes": "Live Unload, Live Load, Drop Unload,Drop, Empty, Pickup Load",
	  "dockStatus": "Inactive",
	  "scheduleType": "Master",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Warehouse 4",
	  "doorUses": "Order Shipped",
	  "appointmentTypes": "Pickup Load",
	  "dockStatus": "Active",
	  "scheduleType": "Individual",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Warehouse 8",
	  "doorUses": "Outbount Only",
	  "appointmentTypes": "Live Unload, Drop Unload",
	  "dockStatus": "Inactive",
	  "scheduleType": "Individual",
	  "dateModified": "SEATTLE",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Warehouse 9",
	  "doorUses": "Inbound Only",
	  "appointmentTypes": "All Appointment Types",
	  "dockStatus": "Active",
	  "scheduleType": "Individual",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Warehouse 11",
	  "doorUses": "Inbound and Outbount",
	  "appointmentTypes": "All Appointment Types",
	  "dockStatus": "Active",
	  "scheduleType": "Master",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Warehouse 12",
	  "doorUses": "Inbound and Outbount",
	  "appointmentTypes": "All Appointment Types",
	  "dockStatus": "Active",
	  "scheduleType": "Master",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}];
	
	var dataTableNewData = exports.dataTableNewData = [{
	  "dockDoorName": "Door 1",
	  "doorUses": "Inbound Only",
	  "appointmentTypes": "Live Unload, Drop Unload",
	  "dockStatus": "Inactive",
	  "scheduleType": "Master",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}, {
	  "dockDoorName": "Door 2",
	  "doorUses": "Inbound and Outbount",
	  "appointmentTypes": "All Appointment Types",
	  "dockStatus": "Active",
	  "scheduleType": "Individual",
	  "dateModified": "09/01/2019",
	  "modifiedBy": "Pat Jones"
	}];

/***/ },
/* 614 */
470,
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createDropdownRenderers = createDropdownRenderers;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionCellDropdownTemplate = __webpack_require__(1295);
	var actionCellDropdownItemTemplate = __webpack_require__(1296);
	var actionHeaderDropdownTemplate = __webpack_require__(1297);
	
	function createDropdownRenderers(dataList) {
	
	  function renderActionCellList(list) {
	    var renderedList = void 0;
	    renderedList = (0, _underscore2.default)(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: (0, _general.keyDefaultFalseOption)(item, "disabled")
	      });
	    });
	    return renderedList.join('');
	  };
	
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = dataList[data];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget),
	      index: meta.row
	    });
	    return newRender;
	  };
	
	  function renderActionHeaderWrap() {
	    var statusTarget = dataList['all'];
	    var newRender = void 0;
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget)
	    });
	    return newRender;
	  };
	
	  return {
	    renderActionWrap: renderActionWrap,
	    renderActionHeaderWrap: renderActionHeaderWrap
	  };
	}

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(606);
	
	__webpack_require__(607);
	
	__webpack_require__(617);

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _select2able = __webpack_require__(22);
	
	var _constants = __webpack_require__(10);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _util = __webpack_require__(34);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _index = __webpack_require__(114);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	var modalHtml = __webpack_require__(11);
	__webpack_require__(273);
	var dockNewEditHtml = __webpack_require__(185);
	var newShiftHtml = __webpack_require__(296);
	var targetSelector = "#new-edit-dock";
	(0, _run2.default)(targetSelector, function (mainEl) {
	
	  attachNewEditDock(mainEl);
	});
	
	function attachNewEditDock(mainEl) {
	  var editForm = mainEl.data("edit-form");
	  var copyForm = mainEl.data("copy-form");
	  var dockdata = mainEl.data("dock-edit-data");
	  var saveDockURL = mainEl.data('save-dock-url');
	  var dockDetailsPageUrl = mainEl.data("dock-details-url");
	  var els = {};
	  var elementsMap = {
	    addShiftBtn: '.add-shift-btn',
	    dayShiftRow: '.day-shift-row',
	    submitDockBtn: '.submit-dock-btn',
	    copyDockBtn: '.copy-details-btn',
	    submitEditDockBtn: '.submit-edit-dock-btn',
	    cancelDockBtn: '.cancel-dock-btn',
	
	    dayOfWeekCheckbox: '.day-of-week-checkbox',
	    addDoorBtn: '.add-door-btn',
	    removeDockBtn: '.remove-dock-btn',
	    //saveDockConfigBtn: '.save-dock-config-btn',
	    removeDockHtmlSec: '.dock-details',
	    cancelEditDockBtn: '.cancel-edit-dock-btn',
	    dockDetailsFormElement: '#dock-details-form-element',
	    addDateBtn: '.add-date-btn',
	    addNewFacilityDockBtn: "#add-new-facility-dock-btn"
	  };
	
	  function init() {
	    setElement();
	
	    //initiateTimePickers();
	
	    bindEditData();
	    bindElement();
	    handleSwitchingTypeInput();
	  }
	  function bindEditData() {
	    if (!(editForm || copyForm)) {
	      initiateTimePickers();
	      return;
	    }
	    if (copyForm) {
	      mainEl.find('.door-name').val(dockdata.dock.docName + "-Copy");
	    } else {
	      mainEl.find('.door-name').val(dockdata.dock.docName);
	    }
	    var docUseArray = dockdata.dock.docUse.split(',');
	    mainEl.find('.door-uses').val(docUseArray);
	    var docAppointmentTypesArray = dockdata.dock.docAppointmentTypes.split(',');
	    mainEl.find('.doorAppointmentTypes').val(docAppointmentTypesArray);
	    var x = dockdata.dock.docUseFacilitiesSchedule == "Y" ? true : false;
	    mainEl.find('.use-master-toggle').prop('checked', x);
	    var arr = dockdata.dock.dockShifts;
	    var shifts = _underscore2.default.groupBy(_underscore2.default.sortBy(arr, "dosStartTime"), 'dosDay');
	
	    for (var day in shifts) {
	      var e = shifts[day];
	      var i;
	      for (i = 0; i < e.length; i++) {
	        savedShiftTimes[day.toLowerCase()].push({ from: e[i].dosStartTime, to: e[i].dosEndTime });
	      }
	    }
	
	    initiateTimePickers();
	
	    // Object.keys(shifts).forEach((key,index) => {
	    //   shiftTimes[key.toLowerCase()][0].timeFrom.setTimeFromMilitary(shifts[key][0].dosStartTime);
	    //   shiftTimes[key.toLowerCase()][0].timeTo.setTimeFromMilitary(shifts[key][0].dosEndTime);
	    // });
	  }
	  function setElement() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	  }
	  function bindElement() {
	    //els.addShiftBtn.on('click', onAddShiftBtnClick);
	    mainEl.on('click', '.remove-shift-btn', onRemoveShiftBtnClick);
	    els.dayOfWeekCheckbox.on('change', handleCheckboxChange);
	    mainEl.on('click', '.new-shift-add-shift-btn', onAddNewShiftBtnClick);
	    mainEl.on('click', '.default-add-shift-btn', onAddShiftBtnClick);
	    mainEl.on('click', '.submit-dock-btn', onSubmitDockBtnClick);
	    mainEl.on('click', '.copy-details-btn', onCopyDockBtnClick);
	  }
	  var dockHtml = (0, _render2.default)(dockNewEditHtml, {
	    shiftRows: renderShiftRows()
	  });
	
	  mainEl.find(".new-edit-dock-configuration").append(dockHtml);
	  (0, _select2able.instantiateSelect2)($('.new-dock-form').find('.select2-select'));
	  $('.new-dock-form').find('.door-uses').on("change", handleDoorUsesChange);
	
	  function handleDoorUsesChange() {
	    handleSwitchingTypeInput();
	  }
	
	  if (!(editForm || copyForm)) {
	    var _handleSwitchingTypeInput = function _handleSwitchingTypeInput() {
	      var doorUsesVal = $('.door-uses  :selected').val();
	
	      if (doorUsesVal !== "undefined") {
	        renderapmtTypeIAO(doorUsesVal);
	      }
	    };
	  }
	
	  var aptTypesIAO = [{
	    key: 'Live Load',
	    value: 'Live Load'
	  }, {
	    Key: 'Pickup Empty',
	    value: 'Pickup Empty'
	  }, {
	    key: 'Pickup Load',
	    value: 'Pickup Load'
	  }, {
	    key: 'Live Unload',
	    value: 'Live Unload'
	  }, {
	    key: 'Drop Unload',
	    value: 'Drop Unload'
	  }, {
	    key: 'Drop Empty',
	    value: 'Drop Empty'
	  }];
	
	  var aptTypesO = [{
	    key: 'Live Load',
	    value: 'Live Load'
	  }, {
	    Key: 'Pickup Empty',
	    value: 'Pickup Empty'
	  }, {
	    key: 'Pickup Load',
	    value: 'Pickup Load'
	  }];
	
	  var aptTypesI = [{
	    key: 'Live Unload',
	    value: 'Live Unload'
	  }, {
	    key: 'Drop Unload',
	    value: 'Drop Unload'
	  }, {
	    key: 'Drop Empty',
	    value: 'Drop Empty'
	  }];
	
	  var doorUses = {
	    'Inbound and Outbound': 'Inbound and Outbound',
	    'Outbound only': 'Outbound only'
	  };
	
	  function renderapmtTypeIAO(doorUsesVal) {
	    var aptTypeSelect = $(".doorAppointmentTypes");
	    aptTypeSelect.html('');
	    if (doorUsesVal == "Inbound and Outbound") {
	      $(aptTypesIAO).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.key).text(this.value);
	        aptTypeSelect.append(option);
	      });
	    } else if (doorUsesVal == "Outbound only") {
	      $(aptTypesO).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.key).text(this.value);
	        aptTypeSelect.append(option);
	      });
	    } else {
	      $(aptTypesI).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.key).text(this.value);
	        aptTypeSelect.append(option);
	      });
	    }
	    aptTypeSelect.addClass("select2 select");
	    (0, _select2able.instantiateSelect2)(aptTypeSelect);
	  }
	
	  function validateForm(formElement) {
	    var validator = void 0,
	        validationOpts = void 0;
	    validationOpts = {
	      ignore: '*:not([name])',
	      rules: {
	        // simple rule, converted to {required:true}
	        doorname: "required",
	        appointmenttype: "required"
	
	      },
	      debug: true,
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    };
	    validator = formElement.validate(validationOpts);
	    validator.settings.ignore = ":disabled,:hidden";
	
	    if (formElement.valid()) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	  function onSubmitDockBtnClick(e) {
	    e.preventDefault();
	    var doorName = mainEl.find('.door-name').val();
	    var doorUses = mainEl.find('.door-uses').val();
	    var apptTypes = mainEl.find('.doorAppointmentTypes').val();
	    var useMasteToggle = mainEl.find('.use-master-toggle').is(":checked");
	    var shiftTimes = getShiftTimes();
	    var docId;
	    if (editForm) docId = dockdata.dock.docId;
	    var dockConfigToSave = {
	      docId: docId,
	      docName: doorName,
	      docUse: doorUses,
	      docAppointmentTypes: JSON.stringify(apptTypes).replace(/[\[\]"]/g, ''),
	      docUseFacilitiesSchedule: useMasteToggle ? 'Y' : 'N',
	      dockShifts: shiftTimes
	    };
	    var dockAreaFormEle = mainEl.find('.new-dock-form');
	    var isValidOrgForm = validateForm(dockAreaFormEle);
	    var isTimesValid = validateCheckbox(dockAreaFormEle, shiftTimes);
	    //const isValidTime = validateTimeBlocks();
	    var isValidTime = true;
	    if (isValidOrgForm && isTimesValid && isValidTime) {
	      var submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: "Save Dock Configuration",
	        confirmModalBody: '<div class="q-pad-all-xl">Once saved this dock scheduled warehouse dock Configuration are assigned to this warehouse.</div>',
	        confirmModalBtnText: "Save",
	        onConfirmClick: function onConfirmClick() {
	          var saveDockConfigURL = saveDockURL;
	          submitModalFlow.showLoadingModal();
	          $.ajax({
	            data: {
	              dockConfiguration: JSON.stringify(dockConfigToSave)
	            },
	            url: saveDockConfigURL,
	            dataType: "JSON",
	            type: 'POST',
	            success: function success(data) {
	              _EditChecker2.default.setPageClean();
	              submitModalFlow.hideAllModals();
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = dockDetailsPageUrl + "&docId=" + data;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            },
	            error: function error(data) {
	              submitModalFlow.hideAllModals();
	              submitModalFlow.showFailureModal();
	            }
	          });
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  }
	  function validateCheckbox() {
	    var isDisplayed = true;
	    els.dayShiftRow.each(function (index, el) {
	      var $el = $(el);
	      var dayOfWeek = $el.data('day-of-week');
	      var timePickerArea = $el.find('.time-picker-area');
	      var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	      var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	      var dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
	      var isChecked = dayOfWeekCheckbox.is(':checked');
	      var dayShiftRow = $(el).closest('.day-shift-row');
	      var timeValidAlert = dayShiftRow.find('.q-alert');
	      var timeCheckObj = vaidateDefaultTimeRange(timeFrom.getMilitaryTime(), timeTo.getMilitaryTime());
	      if (isChecked && !timeCheckObj.isValid) {
	        timeValidAlert.show();
	        timeValidAlert.html(timeCheckObj.message);
	        isDisplayed = false;
	      }
	      var newShifts = timePickerArea.find('.new-shift');
	      if (newShifts.length) {
	
	        if (newShifts.length == 1) {
	          var element = $(newShifts[0]);
	          var x = (0, _timePicker2.default)(element.find('.time-picker-from'));
	          var y = (0, _timePicker2.default)(element.find('.time-picker-to'));
	          var newShifttimeCheckObj = vaidateTimeRange(x.getMilitaryTime(), y.getMilitaryTime(), timeTo.getMilitaryTime());
	          if (!newShifttimeCheckObj.isValid) {
	            timeValidAlert.show();
	            timeValidAlert.html(newShifttimeCheckObj.message);
	            isDisplayed = false;
	          }
	        } else if (newShifts.length == 2) {
	          var prevelement = $(newShifts[0]);
	          var prevx = (0, _timePicker2.default)(prevelement.find('.time-picker-to'));
	          var _element = $(newShifts[1]);
	          var _x = (0, _timePicker2.default)(_element.find('.time-picker-from'));
	          var _y = (0, _timePicker2.default)(_element.find('.time-picker-to'));
	          var newShifttimeCheckObj = vaidateTimeRange(_x.getMilitaryTime(), _y.getMilitaryTime(), prevx.getMilitaryTime());
	          if (!newShifttimeCheckObj.isValid) {
	            timeValidAlert.show();
	            timeValidAlert.html(newShifttimeCheckObj.message);
	            isDisplayed = false;
	          }
	        }
	      }
	      //$(timePickerArea.find('.new-shift').get(indexToRemove-2)).find('.new-shift-add-shift-btn');
	    });
	    return isDisplayed;
	  }
	
	  function validateTimeBlocks() {
	    var timeCheckObj = true;
	    Object.keys(shiftTimes).forEach(function (key) {
	      var a = shiftTimes[key];
	      if (a.length == 2) {
	        timeCheckObj = vaidateTimeRange(a[1].timeFrom.getMilitaryTime(), a[1].timeTo.getMilitaryTime(), a[0].timeTo.getMilitaryTime());
	        //els.dayShiftRow;
	      }
	    });
	    return timeCheckObj.isValid;
	  }
	
	  function getShiftTimes() {
	    var shiftTimesToSave = {};
	
	    Object.keys(shiftTimes).forEach(function (key) {
	      shiftTimesToSave[key] = shiftTimes[key].map(function (el) {
	        return {
	          from: el.timeFrom.getMilitaryTime(),
	          to: el.timeTo.getMilitaryTime()
	        };
	      });
	    });
	
	    var dosDays = [],
	        p = 0;
	    Object.keys(shiftTimesToSave).forEach(function (key) {
	      dosDays[p] = {};
	      dosDays[p].dosDay = key;
	      dosDays[p].dosTime = [];
	      dosDays[p].dosTime = shiftTimesToSave[key].map(function (el) {
	        if (el.from != "Invalid date") {
	          return { dosStartTime: el.from, dosEndTime: el.to };
	        }
	      });
	      p++;
	    });
	
	    var capitalize = function capitalize(s) {
	      if (typeof s !== 'string') return '';
	      return s.charAt(0).toUpperCase() + s.slice(1);
	    };
	    var dockShifts = [];
	    for (var index = 0; index < dosDays.length; index++) {
	      var element = dosDays[index];
	
	      var array = element.dosTime;
	      if (!(typeof array[0] == 'undefined' || array[0] === null)) {
	        for (var j = 0; j < array.length; j++) {
	          var dtime = array[j];
	          dockShifts.push({ dosDay: capitalize(element.dosDay), dosStartTime: dtime.dosStartTime, dosEndTime: dtime.dosEndTime });
	        }
	      }
	    }
	    return dockShifts;
	  }
	  function renderShiftRows() {
	    var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
	    //let days = ['Monday', 'Tuesday'];
	    var dayShiftRowHtml = __webpack_require__(184);
	    //const rawTemplateHtml = require('./html/timePickerTemplate.html');
	    var shiftRow = days.map(function (day) {
	      return (0, _render2.default)(dayShiftRowHtml, {
	        day: day
	      });
	    });
	
	    return shiftRow.join('');
	  }
	  var shiftTimes = {
	    monday: [],
	    tuesday: [],
	    wednesday: [],
	    thursday: [],
	    friday: [],
	    saturday: [],
	    sunday: []
	  };
	  var savedShiftTimes = {
	    //Sample data for saved shift times
	    monday: [],
	    // monday: [],
	    tuesday: [],
	    wednesday: [],
	    thursday: [],
	    friday: [],
	    saturday: [],
	    sunday: []
	  };
	  function initiateTimePickers() {
	    els.dayShiftRow.each(function (index, el) {
	      var $el = $(el);
	      var dayOfWeek = $el.data('day-of-week');
	      var timePickerArea = $el.find('.time-picker-area');
	      var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	      var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	      var dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
	      timeFrom.disableTimePicker();
	      timeTo.disableTimePicker();
	      shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	      if (savedShiftTimes[dayOfWeek].length == 1) {
	        dayOfWeekCheckbox.prop('checked', 'true');
	        timePickerArea.find('.add-shift-btn').removeClass('disabled');
	        timeFrom.enableTimePicker();
	        timeTo.enableTimePicker();
	        timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
	        timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
	      } else if (savedShiftTimes[dayOfWeek].length > 1 && savedShiftTimes[dayOfWeek].length <= 3) {
	        dayOfWeekCheckbox.prop('checked', 'true');
	        timePickerArea.find('.default-add-shift-btn').hide();
	        timePickerArea.find('.add-shift-btn').removeClass('disabled');
	        timeFrom.enableTimePicker();
	        timeTo.enableTimePicker();
	        timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
	        timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
	        savedShiftTimes[dayOfWeek].shift();
	        savedShiftTimes[dayOfWeek].map(function (shift) {
	          var $newShiftHtml = $(newShiftHtml);
	          var timeFrom = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-from'));
	          var timeTo = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-to'));
	          timePickerArea.append($newShiftHtml);
	          timeFrom.setTimeFromMilitary(shift.from);
	          timeTo.setTimeFromMilitary(shift.to);
	          shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	        });
	      }
	      if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 3) {
	        timePickerArea.find('.add-shift-btn').addClass('disabled');
	      }
	    });
	  }
	
	  function handleCheckboxChange() {
	    var isChecked = $(this).is(':checked');
	    var dayShiftRow = $(this).closest('.day-shift-row');
	    var dayOfWeek = dayShiftRow.data('day-of-week');
	    var timeValidAlert = dayShiftRow.find('.q-alert');
	    if (isChecked) {
	      shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
	      shiftTimes[dayOfWeek][0].timeTo.enableTimePicker();
	      dayShiftRow.find('.add-shift-btn').removeClass('disabled');
	      dayShiftRow.find('.default-add-shift-btn').show();
	    } else {
	      dayShiftRow.find('.new-shift').remove();
	      shiftTimes[dayOfWeek].length = 1;
	      shiftTimes[dayOfWeek][0].timeFrom.disableTimePicker();
	      shiftTimes[dayOfWeek][0].timeTo.disableTimePicker();
	      shiftTimes[dayOfWeek][0].timeFrom.resetTime();
	      shiftTimes[dayOfWeek][0].timeTo.resetTime();
	      dayShiftRow.find('.add-shift-btn').addClass('disabled');
	      dayShiftRow.find('.default-add-shift-btn').show();
	      timeValidAlert.hide();
	    }
	  }
	
	  function onAddShiftBtnClick(e) {
	    e.preventDefault();
	    var timePickerArea = $(this).closest('.time-picker-area');
	    var dayOfWeek = timePickerArea.data('day-of-week');
	    var timeFromVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	    var timeToVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	    var dayShiftRow = $(this).closest('.day-shift-row');
	    var timeValidAlert = dayShiftRow.find('.q-alert');
	    var timeCheckObj = vaidateDefaultTimeRange(timeFromVal.getMilitaryTime(), timeToVal.getMilitaryTime());
	    if (timeCheckObj.isValid) {
	      timePickerArea.find('.add-shift-btn').removeClass('disabled');
	      timePickerArea.find('.default-add-shift-btn').hide();
	      timeValidAlert.hide();
	      addNewShifRow(timePickerArea, dayOfWeek);
	    } else {
	      timeValidAlert.show();
	      timeValidAlert.html(timeCheckObj.message);
	    }
	  }
	
	  function onAddNewShiftBtnClick(e) {
	    e.preventDefault();
	    var btn = $(this);
	    var timePickerArea = btn.closest('.time-picker-area');
	    var dayOfWeek = timePickerArea.data('day-of-week');
	    var shiftToValidate = btn.closest('.new-shift');
	    var dayShiftRow = $(this).closest('.day-shift-row');
	    var timeValidAlert = dayShiftRow.find('.q-alert');
	    var timeFromPreviousVal = void 0;
	    var timeToPreviousVal = void 0;
	    // if(shiftTimes[dayOfWeek].length > 1){
	    //     timeFromPreviousVal = shiftTimes[dayOfWeek][1].timeFrom;
	    //     timeToPreviousVal = shiftTimes[dayOfWeek][1].timeTo;
	    // }
	    timeFromPreviousVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	    timeToPreviousVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	
	    var timeFrom = (0, _timePicker2.default)(shiftToValidate.find('.time-picker-from'));
	    var timeTo = (0, _timePicker2.default)(shiftToValidate.find('.time-picker-to'));
	    var timeCheckObj = vaidateTimeRange(timeFrom.getMilitaryTime(), timeTo.getMilitaryTime(), timeToPreviousVal.getMilitaryTime());
	    if (timeCheckObj.isValid) {
	      //btn.closest('.new-shift').find('.remove-shift-btn').hide();
	      timeValidAlert.hide();
	      btn.hide();
	      addNewShifRow(timePickerArea, dayOfWeek);
	    } else {
	      if (timeCheckObj.message) {
	        timeValidAlert.show();
	        timeValidAlert.html(timeCheckObj.message);
	      }
	    }
	  }
	
	  function addNewShifRow(timePickerArea, dayOfWeek) {
	    var $newShiftHtml = $(newShiftHtml);
	    var timeFrom = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-from'));
	    var timeTo = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-to'));
	    shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	
	    timePickerArea.append($newShiftHtml);
	    if (shiftTimes[dayOfWeek].length > 2) {
	      $newShiftHtml.find('.new-shift-add-shift-btn').hide();
	    }
	  }
	
	  function vaidateDefaultTimeRange(timeFromValue, timeToValue, previousShiftEndTimeValue) {
	    var validTimeMsg = {};
	    if (timeFromValue == "Invalid date" || timeToValue == "Invalid date") {
	      validTimeMsg.isValid = false;
	      validTimeMsg.message = "Each selected day requires at least one time block.";
	    } else if (timeFromValue >= timeToValue) {
	      validTimeMsg.isValid = false;
	      validTimeMsg.message = "End time cannot be before start time.";
	    } else {
	      validTimeMsg.isValid = true;
	    }
	    return validTimeMsg;
	  }
	
	  function vaidateTimeRange(timeFromValue, timeToValue, previousShiftEndTimeValue) {
	    var validTimeMsg = {};
	    if (timeFromValue == "Invalid date" || timeToValue == "Invalid date") {
	      validTimeMsg.isValid = false;
	      //validTimeMsg.message = "Each selected day requires at least one time block.";
	    } else if (timeFromValue > timeToValue) {
	      validTimeMsg.isValid = false;
	      validTimeMsg.message = "End time cannot be before start time.";
	    } else if (!(typeof previousShiftEndTimeValue === "undefined")) {
	      if (previousShiftEndTimeValue >= timeFromValue) {
	        validTimeMsg.isValid = false;
	        validTimeMsg.message = "Current shift time must be greater than previous shift End time.";
	      } else {
	        validTimeMsg.isValid = true;
	      }
	    } else {
	      validTimeMsg.isValid = true;
	    }
	    return validTimeMsg;
	  }
	
	  function onRemoveShiftBtnClick(e) {
	    e.preventDefault();
	    var qalert = $(this).closest('.day-shift-row').find('.q-alert');
	    var timePickerArea = $(this).closest('.time-picker-area');
	    var dayOfWeek = timePickerArea.data('day-of-week');
	    var shiftToRemove = $(this).closest('.new-shift');
	    var indexToRemove = shiftToRemove.index();
	    var prevAddShift = $(timePickerArea.find('.new-shift').get(indexToRemove - 2)).find('.new-shift-add-shift-btn');
	    $(shiftToRemove).remove();
	    shiftTimes[dayOfWeek].splice(indexToRemove, 1);
	    if (shiftTimes[dayOfWeek].length < 25) {
	      timePickerArea.find('.add-shift-btn').removeClass('disabled');
	    }
	    if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 25) {
	      //timePickerArea.find('.add-shift-btn').show();
	      prevAddShift.show();
	      timePickerArea.find('.default-add-shift-btn').hide();
	    }
	    if (shiftTimes[dayOfWeek].length == 1) {
	      timePickerArea.find('.default-add-shift-btn').show();
	    }
	    qalert.hide();
	  }
	
	  function onCopyDockBtnClick(e) {
	    e.preventDefault();
	
	    var mydocId = mainEl.data("dock-id");
	    location.href = editUrl + "&docId=" + mydocId + "&copy=true";
	  }
	
	  init();
	}

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _select2able = __webpack_require__(22);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	__webpack_require__(1086);
	// Additional Imports...
	
	var dayShiftRowHtml = __webpack_require__(1301);
	var newShiftHtml = __webpack_require__(1305);
	var plannedOperationClosureHtml = __webpack_require__(297);
	var targetSelector = "#master-appointment-schedule-edit";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  var editAppointmentScheduling = mainEl.data('master-edit-data');
	  var saveAppSchedulingURL = mainEl.data('save-appscheduling-url');
	  var mainHtml = (0, _render2.default)(__webpack_require__(1304), {
	    shiftRows: renderShiftRows(editAppointmentScheduling[0].masterAppointmentConfig.scheduleDetails),
	    plannedOperationClosure: (0, _render2.default)(__webpack_require__(297), {
	      closureDates: getClosureDates(editAppointmentScheduling[0].masterAppointmentConfig.plannedOperationClosures.closureDates)
	      //isClosureFullDay : getTargetSelector(closureDate.isClosureFullDay),
	    })
	  });
	  var el = $(mainHtml);
	  mainEl.append(el);
	  initiateDatePickers();
	
	  // END: REQUIRED TO LOAD STUB
	
	  // START: REAL CODE
	
	  var els = {};
	  var elsPage = {};
	
	  var $body = $('body');
	
	  var submitModalFlow = void 0;
	
	  var toggleForClosure = 1;
	
	  var numberOfPlannedClosureDates = 0;
	
	  var monthArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	
	  var elementsMap = {
	    addTimeBlockBtn: '.addTime-block-btn',
	    dayShiftRow: '.day-shift-row',
	    submitScheduleBtn: '.submit-schedule-btn',
	    cancelScheduleBtn: '.cancel-schedule-btn',
	    dayOfWeekCheckbox: '.day-of-week-checkbox'
	
	  };
	
	  var elsPageMap = {
	    closureFullDay: '#closure-full-day',
	    editMasterToggle: '.edit-master-toggle'
	  };
	
	  var shiftTimes = {
	    monday: [],
	    tuesday: [],
	    wednesday: [],
	    thursday: [],
	    friday: [],
	    saturday: [],
	    sunday: []
	  };
	
	  var savedShiftTimes = {
	    //Sample data for saved shift times
	    /* monday: [
	       {
	         from: '10:05',
	         to: '12:05'
	       },
	       {
	         from: '12:06',
	         to: '14:05'
	       },
	       {
	         from: '14:06',
	         to: '16:05'
	       }
	      ],*/
	    monday: [],
	    tuesday: [],
	    wednesday: [],
	    thursday: [],
	    friday: [],
	    saturday: [],
	    sunday: []
	  };
	
	  function init() {
	    setElement();
	    bindElement();
	    initiateTimePickers();
	    testSwitchery();
	    fillClosureEditTimes();
	  }
	
	  function testSwitchery() {
	    var map = editAppointmentScheduling[0].masterAppointmentConfig.plannedOperationClosures.closureDates;
	    var k = 0;
	    for (var i = 1; i <= map.length; i++) {
	      if (map[k].isClosureFullDay) {
	        (0, _instantiateSwitchery.instantiateSwitchery)($('#closure-full-day-' + i), {});
	        (0, _instantiateSwitchery.setSwitchery)($('#closure-full-day-' + i), true);
	      }
	      k++;
	    }
	  }
	
	  function fillClosureEditTimes() {
	    var closureEditTimes = editAppointmentScheduling[0].masterAppointmentConfig.plannedOperationClosures.closureDates;
	    for (var i = 0; i <= closureEditTimes.length; i++) {
	      if (!(typeof closureEditTimes[i].closureTime[0] === 'undefined')) {
	        if (closureEditTimes[i].closureTime[0].closureShiftStartTime != null) {
	          var closureTimes = $('#closure-edit-time-' + i);
	          var timePickerArea = closureTimes.find('.time-picker-area');
	          var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	          timeFrom.enableTimePicker();
	          timeFrom.setTimeFromMilitary(closureEditTimes[i].closureTime[0].closureShiftStartTime);
	          var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	          timeTo.enableTimePicker();
	          timeTo.setTimeFromMilitary(closureEditTimes[i].closureTime[0].closureShiftEndTime);
	        }
	      }
	    }
	  }
	
	  function setElement() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, $body);
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elsPageMap, $body);
	  }
	
	  function bindElement() {
	
	    mainEl.on('click', '.addTime-block-btn', onAddShiftBtnClick);
	    mainEl.on('click', '.new-shift-add-shift-btn', onAddNewShiftBtnClick);
	    mainEl.on('click', '.remove-shift-btn', onRemoveShiftBtnClick);
	    els.submitScheduleBtn.on('click', onSubmitBtnClick);
	    els.cancelScheduleBtn.on('click', onCancelBtnClick);
	    els.dayOfWeekCheckbox.on('change', handleCheckboxChange);
	    mainEl.on('click', '.remove-date-btn', onRemoveDateBtnClick);
	    mainEl.on('click', '.add-date-btn', addDateBtnClick);
	
	    var arr = editAppointmentScheduling[0].masterAppointmentConfig.scheduleDetails.dosDays;
	    var shifts = _underscore2.default.groupBy(_underscore2.default.sortBy(arr, "dosStartTime"), 'dosDay');
	
	    for (var day in shifts) {
	
	      var e = shifts[day];
	      var i;
	      for (i = 0; i < e[0].dosTime.length; i++) {
	        savedShiftTimes[day.toLowerCase()].push({ from: e[0].dosTime[i].dosStartTime, to: e[0].dosTime[i].dosEndTime });
	      }
	    }
	  }
	
	  // function generateModals() {
	  //   submitSchedulModal = new SubmitModalFlow({
	  //     confirmModalTitle: 'Submit Schedule Information',
	  //     confirmModalBody: '<div class="q-pad-all-xl">Once submitted, the information provided will be used to accurately display available appointment slots for dock scheduling.</div>',
	  //     confirmModalBtnText: 'Submit',
	  //     modalDialogClass: "q-modal-dialog-500",
	  //     onConfirmClick: function () {
	  //       // Show Loading Modal
	  //       submitSchedulModal.showLoadingModal();
	
	  //       // Success
	  //       setTimeout(function () {
	  //         submitSchedulModal.showSuccessModal();
	  //       }, 3000);
	
	  //       // Hide All Modals
	  //       setTimeout(function () {
	  //         submitSchedulModal.hideAllModals();
	  //       }, 6000);
	  //     }
	  //   });
	  //   submitSchedulModal.init();
	  // }
	
	
	  function onRemoveDateBtnClick(e) {
	    e.preventDefault();
	    var removeDateHtml = $(this).closest('.remove-date-details');
	    removeDateHtml.remove();
	  }
	
	  function onAddShiftBtnClick(e) {
	    e.preventDefault();
	    var timePickerArea = $(this).closest('.time-picker-area');
	    var dayOfWeek = timePickerArea.data('day-of-week');
	    var timeFromVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	    var timeToVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	    var dayShiftRow = $(this).closest('.day-shift-row');
	    var timeValidAlert = dayShiftRow.find('.q-alert');
	    var timeCheckObj = vaidateDefaultTimeRange(timeFromVal.getMilitaryTime(), timeToVal.getMilitaryTime());
	    if (timeCheckObj.isValid) {
	      timePickerArea.find('.addTime-block-btn').removeClass('disabled');
	      timePickerArea.find('.default-add-shift-btn').hide();
	      timeValidAlert.hide();
	      addNewShifRow(timePickerArea, dayOfWeek);
	    } else {
	      timeValidAlert.show();
	      timeValidAlert.html(timeCheckObj.message);
	    }
	  }
	
	  function onAddNewShiftBtnClick(e) {
	    e.preventDefault();
	    var btn = $(this);
	    var timePickerArea = btn.closest('.time-picker-area');
	    var dayOfWeek = timePickerArea.data('day-of-week');
	    var shiftToValidate = btn.closest('.new-shift');
	    var dayShiftRow = $(this).closest('.day-shift-row');
	    var timeValidAlert = dayShiftRow.find('.q-alert');
	    var timeFromPreviousVal = void 0;
	    var timeToPreviousVal = void 0;
	    // if(shiftTimes[dayOfWeek].length > 1){
	    //     timeFromPreviousVal = shiftTimes[dayOfWeek][1].timeFrom;
	    //     timeToPreviousVal = shiftTimes[dayOfWeek][1].timeTo;
	    // }
	    timeFromPreviousVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	    timeToPreviousVal = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	
	    var timeFrom = (0, _timePicker2.default)(shiftToValidate.find('.time-picker-from'));
	    var timeTo = (0, _timePicker2.default)(shiftToValidate.find('.time-picker-to'));
	    var timeCheckObj = vaidateTimeRange(timeFrom.getMilitaryTime(), timeTo.getMilitaryTime(), timeToPreviousVal.getMilitaryTime());
	    if (timeCheckObj.isValid) {
	      //btn.closest('.new-shift').find('.remove-shift-btn').hide();
	      timeValidAlert.hide();
	      btn.hide();
	      addNewShifRow(timePickerArea, dayOfWeek);
	    } else {
	      if (timeCheckObj.message) {
	        timeValidAlert.show();
	        timeValidAlert.html(timeCheckObj.message);
	      }
	    }
	  }
	
	  function addNewShifRow(timePickerArea, dayOfWeek) {
	    var $newShiftHtml = $(newShiftHtml);
	    var timeFrom = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-from'));
	    var timeTo = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-to'));
	    shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	
	    timePickerArea.append($newShiftHtml);
	    if (shiftTimes[dayOfWeek].length > 2) {
	      $newShiftHtml.find('.new-shift-add-shift-btn').hide();
	    }
	  }
	
	  function vaidateDefaultTimeRange(timeFromValue, timeToValue, previousShiftEndTimeValue) {
	    var validTimeMsg = {};
	    if (timeFromValue == "Invalid date" || timeToValue == "Invalid date") {
	      validTimeMsg.isValid = false;
	      validTimeMsg.message = "Each selected day requires at least one time block.";
	    } else if (timeFromValue > timeToValue) {
	      validTimeMsg.isValid = false;
	      validTimeMsg.message = "End time cannot be before start time.";
	    } else {
	      validTimeMsg.isValid = true;
	    }
	    return validTimeMsg;
	  }
	
	  function vaidateTimeRange(timeFromValue, timeToValue, previousShiftEndTimeValue) {
	    var validTimeMsg = {};
	    if (timeFromValue == "Invalid date" || timeToValue == "Invalid date") {
	      validTimeMsg.isValid = false;
	      //validTimeMsg.message = "Each selected day requires at least one time block.";
	    } else if (timeFromValue > timeToValue) {
	      validTimeMsg.isValid = false;
	      validTimeMsg.message = "End time cannot be before start time.";
	    } else if (!(typeof previousShiftEndTimeValue === "undefined")) {
	      if (previousShiftEndTimeValue > timeFromValue) {
	        validTimeMsg.isValid = false;
	        validTimeMsg.message = "Current shift time must be greater than previous shift End time.";
	      } else {
	        validTimeMsg.isValid = true;
	      }
	    } else {
	      validTimeMsg.isValid = true;
	    }
	    return validTimeMsg;
	  }
	
	  function onRemoveShiftBtnClick(e) {
	    e.preventDefault();
	    var timePickerArea = $(this).closest('.time-picker-area');
	    var dayOfWeek = timePickerArea.data('day-of-week');
	    var shiftToRemove = $(this).closest('.new-shift');
	    var indexToRemove = shiftToRemove.index();
	    $(shiftToRemove).remove();
	    shiftTimes[dayOfWeek].splice(indexToRemove, 1);
	    if (shiftTimes[dayOfWeek].length < 3) {
	      timePickerArea.find('.addTime-block-btn').removeClass('disabled');
	    }
	    if (shiftTimes[dayOfWeek].length > 1 && shiftTimes[dayOfWeek].length <= 3) {
	      timePickerArea.find('.addTime-block-btn').show();
	      timePickerArea.find('.default-addTime-block-btn').hide();
	    }
	    if (shiftTimes[dayOfWeek].length == 1) {
	      timePickerArea.find('.default-addTime-block-btn').show();
	    }
	  }
	
	  function validateForm(formElement) {
	    var validator = void 0,
	        validationOpts = void 0;
	    validationOpts = {
	      ignore: '*:not([name])',
	      rules: {
	        // simple rule, converted to {required:true}
	      },
	      debug: true,
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    };
	    validator = formElement.validate(validationOpts);
	    validator.settings.ignore = ":disabled,:hidden";
	
	    if (formElement.valid()) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  function validateCheckbox() {
	    var isDisplayed = true;
	    els.dayShiftRow.each(function (index, el) {
	      var $el = $(el);
	      var dayOfWeek = $el.data('day-of-week');
	      var timePickerArea = $el.find('.time-picker-area');
	      var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	      var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	      var dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
	      var isChecked = dayOfWeekCheckbox.is(':checked');
	      var dayShiftRow = $(el).closest('.day-shift-row');
	      var timeValidAlert = dayShiftRow.find('.q-alert');
	      var timeCheckObj = vaidateDefaultTimeRange(timeFrom.getMilitaryTime(), timeTo.getMilitaryTime());
	      if (isChecked && !timeCheckObj.isValid) {
	        timeValidAlert.show();
	        timeValidAlert.html(timeCheckObj.message);
	        isDisplayed = false;
	      }
	    });
	    return isDisplayed;
	  }
	
	  function getShiftTimes() {
	
	    var shiftTimesToSave = {};
	
	    Object.keys(shiftTimes).forEach(function (key) {
	      shiftTimesToSave[key] = shiftTimes[key].map(function (el) {
	        return {
	          from: el.timeFrom.getMilitaryTime(),
	          to: el.timeTo.getMilitaryTime()
	        };
	      });
	    });
	
	    var dosDays = [],
	        p = 0;
	    Object.keys(shiftTimesToSave).forEach(function (key) {
	      dosDays[p] = {};
	      dosDays[p].dosDay = key;
	      dosDays[p].dosTime = [];
	      dosDays[p].dosTime = shiftTimesToSave[key].map(function (el) {
	        if (el.from != "Invalid date") {
	          return { dosStartTime: el.from, dosEndTime: el.to };
	        }
	      });
	      p++;
	    });
	
	    var capitalize = function capitalize(s) {
	      if (typeof s !== 'string') return '';
	      return s.charAt(0).toUpperCase() + s.slice(1);
	    };
	    var dockShifts = [];
	    for (var index = 0; index < dosDays.length; index++) {
	      var element = dosDays[index];
	
	      var array = element.dosTime;
	      if (!(typeof array[0] == 'undefined' || array[0] === null)) {
	        for (var j = 0; j < array.length; j++) {
	          var dtime = array[j];
	          dockShifts.push({ dosDay: capitalize(element.dosDay), dosStartTime: dtime.dosStartTime, dosEndTime: dtime.dosEndTime });
	        }
	      }
	    }
	    return dockShifts;
	  }
	
	  function getPlannedOperationClosures() {
	
	    var plannedOperationClosuresToSave = {};
	  }
	
	  function onSubmitBtnClick(e) {
	    e.preventDefault();
	    var shiftTimes = getShiftTimes();
	    var plannedOperationClosures = getPlannedOperationClosures();
	    var appSchedulingToSave = {
	      appShifts: shiftTimes
	    };
	    var submitModalFlow = new SubmitModalFlow({
	      confirmModalTitle: "Submit Schedule Information",
	      confirmModalBody: '<div class="q-pad-all-xl">Once submitted, the information provided will be used to accurately display available appointment slots for dock scheduling.</div>',
	      confirmModalBtnText: "Submit",
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        $.ajax({
	          data: {
	            appointmentSchedule: JSON.stringify($("#edit-appointment-scheduling-form").serialize())
	          },
	          //   {
	
	          //   appointmentSchedule: JSON.stringify(appSchedulingToSave)
	          // },
	          url: saveAppSchedulingURL,
	          dataType: "JSON",
	          type: 'POST',
	          success: function success(data) {
	            EditChecker.setPageClean();
	            submitModalFlow.hideAllModals();
	            submitModalFlow.showSuccessModal();
	            setTimeout(function () {}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	          },
	          error: function error(data) {
	            submitModalFlow.hideAllModals();
	            submitModalFlow.showFailureModal();
	          }
	        });
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	
	  function onCancelBtnClick(e) {
	    e.preventDefault();
	    $('#master-appointment-schedule-edit').hide();
	    $('#master-appointment-schedule').show();
	  }
	  function getTimeInMilitaryTime(time) {
	    var x = time.split(":");
	    x[1] = x[1].replace(/\s\s+/g, ' ');
	    var y = x[1].split(" ");
	
	    return moment(x[0] + ":" + y[0] + " " + y[1], 'h:mm A').format('HH:mm');
	  }
	  function initiateTimePickers() {
	    els.dayShiftRow.each(function (index, el) {
	      var $el = $(el);
	      var dayOfWeek = $el.data('day-of-week');
	      var timePickerArea = $el.find('.time-picker-area');
	      var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	      var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	      var dayOfWeekCheckbox = $el.find('.day-of-week-checkbox');
	      timeFrom.disableTimePicker();
	      timeTo.disableTimePicker();
	      shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	      if (savedShiftTimes[dayOfWeek].length == 1) {
	        dayOfWeekCheckbox.prop('checked', 'true');
	        timePickerArea.find('.default-addTime-block-btn').removeClass('disabled');
	        timeFrom.enableTimePicker();
	        timeTo.enableTimePicker();
	        timeFrom.setTimeFromMilitary(getTimeInMilitaryTime(savedShiftTimes[dayOfWeek][0].from));
	        timeTo.setTimeFromMilitary(getTimeInMilitaryTime(savedShiftTimes[dayOfWeek][0].to));
	      } else if (savedShiftTimes[dayOfWeek].length > 1 && savedShiftTimes[dayOfWeek].length <= 3) {
	        dayOfWeekCheckbox.prop('checked', 'true');
	        timePickerArea.find('.default-addTime-block-btn').hide();
	        timePickerArea.find('.new-shift-add-shift-btn').removeClass('disabled');
	        timeFrom.enableTimePicker();
	        timeTo.enableTimePicker();
	        timeFrom.setTimeFromMilitary(getTimeInMilitaryTime(savedShiftTimes[dayOfWeek][0].from));
	        timeTo.setTimeFromMilitary(getTimeInMilitaryTime(savedShiftTimes[dayOfWeek][0].to));
	        //timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
	        //timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
	        savedShiftTimes[dayOfWeek].shift();
	        savedShiftTimes[dayOfWeek].map(function (shift) {
	          var $newShiftHtml = $(newShiftHtml);
	          var timeFrom = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-from'));
	          var timeTo = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-to'));
	          timePickerArea.append($newShiftHtml);
	
	          timePickerArea.find('.new-shift-add-shift-btn').removeClass('disabled');
	          timeFrom.setTimeFromMilitary(getTimeInMilitaryTime(shift.from));
	          timeTo.setTimeFromMilitary(getTimeInMilitaryTime(shift.to));
	          //timeFrom.setTimeFromMilitary(shift.from);
	          //timeTo.setTimeFromMilitary(shift.to);
	          shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	        });
	      }
	      if (shiftTimes[dayOfWeek].length && shiftTimes[dayOfWeek].length === 3) {
	        timePickerArea.find('.new-shift-add-shift-btn').addClass('disabled');
	      }
	    });
	  }
	
	  function renderShiftRows(scheduleDetails) {
	    var days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
	    //let days = ['Monday', 'Tuesday'];
	    var shiftRow = days.map(function (day) {
	      return (0, _render2.default)(dayShiftRowHtml, {
	        day: day
	      });
	    });
	
	    return shiftRow.join('');
	  }
	
	  function handleCheckboxChange() {
	    var isChecked = $(this).is(':checked');
	    var dayShiftRow = $(this).closest('.day-shift-row');
	    var dayOfWeek = dayShiftRow.data('day-of-week');
	    if (isChecked) {
	      shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
	      shiftTimes[dayOfWeek][0].timeTo.enableTimePicker();
	      dayShiftRow.find('.addTime-block-btn').removeClass('disabled');
	      dayShiftRow.find('.default-addTime-block-btn').show();
	    } else {
	      dayShiftRow.find('.new-shift').remove();
	      shiftTimes[dayOfWeek].length = 1;
	      shiftTimes[dayOfWeek][0].timeFrom.disableTimePicker();
	      shiftTimes[dayOfWeek][0].timeTo.disableTimePicker();
	      shiftTimes[dayOfWeek][0].timeFrom.resetTime();
	      shiftTimes[dayOfWeek][0].timeTo.resetTime();
	      dayShiftRow.find('.addTime-block-btn').addClass('disabled');
	      dayShiftRow.find('.default-addTime-block-btn').show();
	    }
	  }
	
	  function initiateDatePickers() {
	    var plannedClosures = $("#planned-closure-details");
	    var plannedClosureDate = plannedClosures.find("input[name='add-date-text']");
	    var today = new Date();
	    plannedClosureDate.datepicker({
	      startDate: today,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	  }
	
	  function addDateBtnClick(e) {
	    e.preventDefault();
	    var closureDateHtml = __webpack_require__(1298);
	    var plannedClosures = $("#planned-closure-details");
	    var plannedClosureDate = plannedClosures.find("input[name='add-date-text']").val();
	    var date = new Date(plannedClosureDate);
	    var dateTextToShow = monthArr[date.getMonth()] + ' ' + date.getDate() + nthDay(date.getDate()) + ', ' + date.getFullYear() + ' :';
	    var closurename = "closure-date-" + toggleForClosure;
	    var closureDt = (0, _render2.default)(closureDateHtml, {
	      plannedClosureDate: dateTextToShow,
	      closureDate: closurename,
	      toggleForClosure: toggleForClosure
	    });
	    toggleForClosure++;
	    $('#master-appointment-schedule-edit').find("div[name='closure-details']").find(".q-alert").hide();
	    numberOfPlannedClosureDates++;
	    $('#master-appointment-schedule-edit').find("div[name='closure-details']").append(closureDt);
	    (0, _instantiateSwitchery.instantiateSwitchery)($('.js-switchery'));
	
	    //const timePickerArea=$(closureDt).find('.time-picker-area');
	    var timePickerArea = $('#master-appointment-schedule-edit').find("." + closurename).find('.time-picker-area');
	    var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	    var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	    timeFrom.enableTimePicker();
	    timeTo.enableTimePicker();
	  }
	
	  function getDosDays(dosDays) {
	    var dosDaysHtml = __webpack_require__(1302);
	    var response = _underscore2.default.map(dosDays, function (dosDay) {
	      return (0, _render2.default)(dosDaysHtml, {
	        dosDay: dosDay,
	        dosTimes: getDosTimes(dosDay.dosTime)
	      });
	    });
	    return response.join("");
	  }
	  function getDosTimes(dosTimes) {
	    var dosTimesHtml = __webpack_require__(1303);
	    var response = _underscore2.default.map(dosTimes, function (dosTime) {
	      return (0, _render2.default)(dosTimesHtml, {
	        dosTime: dosTime
	      });
	    });
	    return response.join("");
	  }
	
	  function getClosureDates(closureDates) {
	    var closureDatesHtml = __webpack_require__(1299);
	    var arrayIndex = 0;
	    var response = _underscore2.default.map(closureDates, function (closureDate, closureTime) {
	      arrayIndex = arrayIndex + 1;
	      return (0, _render2.default)(closureDatesHtml, {
	        plannedClosureDate: closureDate.closureDate,
	        isClosureFullDay: getTargetSelector(closureDate.isClosureFullDay),
	        closureTimes: getClosureTimes(closureDate.closureTime, arrayIndex - 1),
	        // closureShiftStartTime: closureDate.closureTime[0].closureShiftStartTime,
	        // closureShiftEndTime : closureDate.closureTime[0].closureShiftEndTime,
	        closureDate: "closure-date-" + toggleForClosure,
	        toggleForClosure: toggleForClosure,
	        arrayIndex: arrayIndex
	      });
	      toggleForClosure++;
	    });
	    return response.join("");
	  }
	
	  function getTargetSelector(isClosureFullDay) {
	    if (isClosureFullDay) {
	      mainEl.find('#closure-full-day').prop('checked', true);
	      return ".large-text-toggle-target";
	    } else {
	      return "";
	    }
	  }
	
	  function getClosureTimes(closureTime, closureIndex) {
	    var closureTimeHtml = __webpack_require__(1300);
	    var response = _underscore2.default.map(closureTime, function (closureTime) {
	      return (0, _render2.default)(closureTimeHtml, {
	        closureTime: closureTime,
	        closureIndex: closureIndex
	      });
	    });
	    return response.join("");
	  }
	
	  function nthDay(d) {
	    if (d > 3 && d < 21) return 'th';
	    switch (d % 10) {
	      case 1:
	        return "st";
	      case 2:
	        return "nd";
	      case 3:
	        return "rd";
	      default:
	        return "th";
	    }
	  }
	
	  var timePickerFromEl = mainEl.find('.time-picker-from');
	  var timePickerToEl = mainEl.find('.time-picker-to');
	
	  var timePickerFrom = (0, _timePicker2.default)(timePickerFromEl);
	  var timePickerTo = (0, _timePicker2.default)(timePickerToEl);
	
	  function fillEditTimes(dosDays) {
	    var dayshiftrows = $('#edit-dock-area').find('.day-shift-row');
	    for (var i = 0; i < 6; i++) {
	      if (!(typeof dosDays[i].dosTime[0] === 'undefined')) {
	        if (dosDays[i].dosTime[0].dosStartTime != null) {
	          var dayshiftrow = $(dayshiftrows[i]);
	          dayshiftrow.find('.day-of-week-checkbox').prop('checked', 'true');
	          dayshiftrow.trigger("change");
	          var timePickerArea = dayshiftrow.find('.time-picker-area');
	          var dayOfWeek = timePickerArea.data('day-of-week');
	          var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	          timeFrom.enableTimePicker();
	          timeFrom.setTimeFromMilitary(dosDays[i].dosTime[0].dosStartTime);
	          var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	          timeTo.enableTimePicker();
	          timeTo.setTimeFromMilitary(dosDays[i].dosTime[0].dosEndTime);
	          dayshiftrow.find('.add-shift-btn').removeClass('disabled');
	          dayshiftrow.find('.default-add-shift-btn').show();
	          dayshiftrow.find('.q-alert').hide();
	        }
	        if (dosDays[i].dosTime.length > 1) {
	          for (var j = 1; j < dosDays[i].dosTime.length; j++) {
	            if (dosDays[i].dosTime[j].dosStartTime != null && dosDays[i].dosTime[j].dosStartTime != undefined) {
	              var _dayshiftrow = $(dayshiftrows[i]);
	              _dayshiftrow.find('.day-of-week-checkbox').prop('checked', 'true');
	              _dayshiftrow.trigger("change");
	              var timePickerAreaShift = _dayshiftrow.find('.time-picker-area');
	              var _dayOfWeek = timePickerAreaShift.data('day-of-week');
	              var $newShiftHtml = $(newShiftHtml);
	              var _timeFrom = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-from'));
	              _timeFrom.enableTimePicker();
	              _timeFrom.setTimeFromMilitary(dosDays[i].dosTime[j].dosStartTime);
	              var _timeTo = (0, _timePicker2.default)($newShiftHtml.find('.time-picker-to'));
	              _timeTo.enableTimePicker();
	              _timeTo.setTimeFromMilitary(dosDays[i].dosTime[j].dosEndTime);
	              timePickerAreaShift.append($newShiftHtml);
	              shiftTimes[_dayOfWeek].push({ timeFrom: _timeFrom, timeTo: _timeTo });
	              if (shiftTimes[_dayOfWeek].length > 1 && shiftTimes[_dayOfWeek].length <= 25) {
	                timePickerAreaShift.find('.add-shift-btn').removeClass('disabled');
	                timePickerAreaShift.find('.default-add-shift-btn').hide();
	                var dayShiftRow = $(this).closest('.day-shift-row');
	                dayShiftRow.find('.q-alert').hide();
	              }
	              if (shiftTimes[_dayOfWeek].length && shiftTimes[_dayOfWeek].length === 25) {
	                timePickerAreaShift.find('.add-shift-btn').hide();
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  init();
	
	  // END: REAL CODE
	});

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(618);

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _select2able = __webpack_require__(22);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	// Additional Imports...
	
	var facilityWrapperTemplate = __webpack_require__(1314);
	var facilityTypeHtml = __webpack_require__(1313);
	var inboundClassificationHtml = __webpack_require__(1315);
	var facilityDetailsHtml = __webpack_require__(1312);
	var facilityAddressHtml = __webpack_require__(1310);
	var facilityContactHtml = __webpack_require__(1311);
	var sharedModalHtml = __webpack_require__(11);
	
	var targetSelector = "#facility-form";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  attachOrgForm(mainEl);
	});
	
	function attachOrgForm(mainEl) {
	  var editForm = mainEl.data("edit-form");
	  var portletNamespace = mainEl.data('portlet-namespace');
	  var organizations = mainEl.data('organizations');
	  var isHoneyComb = mainEl.data('is-honeycomb');
	  var countries = mainEl.data('countries');
	  var usaStates = mainEl.data('usa-states');
	  var caProvinces = mainEl.data('ca-provinces');
	  var phoneCodes = mainEl.data('country-phone-code-list');
	  var defaultCountry = mainEl.data('default-country');
	  var facilityTypes = mainEl.data('facility-types');
	  var inboundClassificationTypes = mainEl.data('inbound-classification-types');
	  var retailerFedexAccounts = mainEl.data('retailer-fedex-accounts');
	  var retailerFacilityForRMS = mainEl.data('retailer-facility-for-rms');
	  var addressEl = $('#edit-address-verification');
	  var validateOrgNameUrl = mainEl.data("validate-org-url");
	  var addressValidationUrl = mainEl.data("address-validation-url");
	  var organizationList = mainEl.data("retailer-organization-list");
	  var submitURL = mainEl.data("submit-url");
	  var detailScreenUrl = mainEl.data("detail-url");
	  var cancelBtnUrl = mainEl.data("cancel-url");
	  var facNameCheckUrl = mainEl.data("fac-name-check-url");
	  var facIdCheckUrl = mainEl.data("fac-id-check-url");
	  var duplicateCadLocationNameMessage = mainEl.data("duplicate-location-name-message");
	  var duplicateAddressIdMessage = mainEl.data("duplicate-address-id-message");
	  var casAccountNumbers = mainEl.data("cas-acccount-numbers");
	  var shipToAddress = mainEl.data("ship-to-address"); //HB-11508 Starts, Ends.
	  var validationReqdCountries = mainEl.data("validation-reqd-countries");
	  var organizationSelectionCheck = "";
	  var facilityCount = 0;
	  var facilityArray = [];
	  var orgFacilityForm = $('#org-facility-form');
	  var orgName = "";
	  var facName = "";
	  var facId = "";
	  var cadEditId = "";
	  var conPhoneCode = "";
	  //Variable to store the response from the address validation service 
	  var addValResponse = {};
	
	  var selectFromOrgModal = void 0;
	
	  var elsPage = {};
	  //let elsModal = {};
	
	
	  var elsMap = {
	    addFacilitySection: ".add-facility-section",
	    organizationName: "#org-address-name",
	    addFirstFacilityBtn: ".first-add-facility-btn",
	    saveVendorOrgAddressBtn: ".save-vendor-org-address-btn",
	    masterFormCancelBtn: ".master-facility-cancel-section-btn",
	    facilityEditSectionBtn: ".facility-edit-section-btn",
	    facilityUpdateSectionBtn: ".facility-update-section-btn",
	    facilityCancelSectionBtn: ".facility-cancel-section-btn",
	    masterFormSectionParent: ".master-form",
	    customExpanderParent: ".custom-expander-parent",
	    customExpanderTarget: ".custom-expander-target",
	    staticFacilityFormDiv: ".facility-information-container",
	    selectOrgName: "#selectOrgName",
	    orgName: "#selectOrgName",
	    inboundClassification: "#inboundClassification",
	    facilityType: "#rms-facility-type",
	    cancelBtn: ".cancel-url"
	
	    /*const elsModalMap = {
	      orgnSelectBtn: '.organization-select-btn',
	      dropDownOption :"#organizationDropdown"
	    }*/
	
	  };var addressElementsMap = {
	    submitThisAddressBtn: '#submit-edit-returned-address',
	    addressEntered: '#div-address-enetered',
	    enteredAddressRadio: '#radio-use-entered-address',
	    enteredAddressText: '#edit-ret-address-entered',
	    addressReturned: '#div-address-returned',
	    returnedAddressRadio: '#radio-returned-address',
	    returnedAddressText: '#edit-ret-address-returned',
	    invalidAddress: '#div-address-returned-empty',
	    invalidAddressText: '#edit-ret-address-returned-not-found',
	    modifyAddressBtn: '#modify-edit-returned-address'
	  };
	
	  function init() {
	    setElements();
	    //setElementsOnModal();
	    bindElements();
	    if (editForm) {
	      populateEditForm(organizations);
	    } else {
	      showStaticForm();
	    }
	    renderOrganizationValues();
	    $("#errorMessageForCheckbox").hide();
	    $('.facilityType').click(function () {
	      $("#errorMessageForCheckbox").hide();
	    });
	    setupEditChecker();
	  }
	
	  function setElements() {
	    //Tie the scope of the elements on the page 
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elsMap, orgFacilityForm);
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, addressElementsMap, addressEl);
	  }
	
	  /*function setElementsOnModal(){
	    // since modals are appended to the body, they are scopped differnetly
	    const body = $('body');
	    setElementsFromScope(elsModal, elsModalMap, body);
	  }*/
	
	  function setupEditChecker() {
	    _EditChecker2.default.bindNavigation();
	    _EditChecker2.default.bindChangeListener("#facility-form");
	    _EditChecker2.default.bindChangeListener("span.select2");
	    //EditChecker.bindCancelButton("#cancel-vendor-org-address-btn");
	    _EditChecker2.default.bindCancelButton(".cancel-url");
	  }
	
	  function bindElements() {
	    //Bind the events of the Button here 
	    elsPage.modifyAddressBtn.on('click', modifyFacilityAddress);
	    elsPage.submitThisAddressBtn.on('click', submitFacilityAddress);
	    elsPage.saveVendorOrgAddressBtn.on('click', orgSaveBtnHandler);
	    mainEl.on("blur", ".facility-name", validateFacilityName);
	    mainEl.on("blur", ".facility-id", validateFacilityId);
	    mainEl.on("change", ".facility-phone-code", phoneCodeChange);
	  }
	
	  function orgSaveBtnHandler() {
	    var orgFormEle = mainEl.find("#master-form");
	    var isValidOrgForm = validateForm(orgFormEle);
	    if (isValidOrgForm) {
	      if (isHoneyComb) {
	        var checked = $("#org-facility-form input:checkbox:checked").length > 0;
	        if (!checked) {
	          $("#errorMessageForCheckbox").show();
	          return false;
	        }
	        $("#errorMessageForCheckbox").hide();
	      }
	      validateAddressModal();
	    }
	  }
	  //duplicate facility name check
	  function validateFacilityName() {
	    var facName = mainEl.find(".facility-name").val();
	    var localFacName = organizations.cadLocationName;
	    if (localFacName != facName) {
	      $.ajax({
	        async: false,
	        data: {
	          facName: facName
	        },
	        url: facNameCheckUrl,
	        dataType: "JSON",
	        type: 'POST',
	        success: function success(data) {
	          //isFacNameDuplicate = data.response;
	          if (data.response == true) {
	            mainEl.find('.dup-facName').show();
	          } else {
	            mainEl.find('.dup-facName').hide();
	          }
	        }
	      });
	    } else {
	      mainEl.find('.dup-facName').hide();
	    }
	  }
	
	  function validateFacilityId() {
	    var facId = mainEl.find(".facility-id").val();
	    var localFacId = organizations.cadAddressId;
	    if (localFacId != facId) {
	      $.ajax({
	        async: false,
	        data: {
	          facId: facId
	        },
	        url: facIdCheckUrl,
	        dataType: "JSON",
	        type: 'POST',
	        success: function success(data) {
	          //isFacIdDuplicate = data.response;
	          if (data.response == true) {
	            mainEl.find('.dup-facId').show();
	          } else {
	            mainEl.find('.dup-facId').hide();
	          }
	        }
	      });
	    } else {
	      mainEl.find('.dup-facId').hide();
	    }
	  }
	
	  function saveFacility() {
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: "Save Facility",
	      confirmModalBody: '<div class="q-pad-all-xl">Once you have saved this Facility, it can be referenced throughout the application.</div>',
	      confirmModalBtnText: "Save",
	      onConfirmClick: function onConfirmClick() {
	        var orgFlagCheck = true;
	        for (var i = 0; i < organizationList.length; i++) {
	          if (organizationList[i].orgId == elsPage.orgName.val() && organizationList[i].orgActive == false && organizations.cadActive === "Y") {
	            submitModalFlow.hideAllModals();
	            saveInActiveOrg();
	            orgFlagCheck = false;
	          } else if (organizationList[i].orgId == elsPage.orgName.val() && organizationList[i].orgActive == false && !editForm) {
	            submitModalFlow.hideAllModals();
	            saveInActiveOrg();
	            orgFlagCheck = false;
	          } else if (organizationList[i].orgId == elsPage.orgName.val() && organizationList[i].orgActive == false && organizations.cadActive === "N" && organizationSelectionCheck != elsPage.orgName.val()) {
	            submitModalFlow.hideAllModals();
	            saveInActiveOrg();
	            orgFlagCheck = false;
	          }
	        }
	        if (orgFlagCheck) {
	          var submitOrg = function submitOrg(_ref) {
	            var url = _ref.url,
	                success = _ref.success,
	                error = _ref.error;
	
	            $.ajax({
	              data: {
	                facilityArray: JSON.stringify(facilityArray)
	              },
	              url: url,
	              dataType: "JSON",
	              type: 'POST',
	              success: success,
	              error: error
	            });
	          };
	
	          var orgId = elsPage.orgName.val() || '';
	          var saveOrgFacURL = submitURL + "&orgId=" + orgId;
	          submitModalFlow.showLoadingModal();
	          submitOrg({ url: saveOrgFacURL, success: saveOrgSuccess, error: saveOrgFailure });
	        }
	        function saveOrgSuccess(data) {
	          _EditChecker2.default.setPageClean();
	          submitModalFlow.hideAllModals();
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            window.open(detailScreenUrl + "&cadId=" + data, "_self");
	          }, 3000);
	        }
	        function saveOrgFailure() {
	          //submitModalFlow.hide();
	          submitModalFlow.hideAllModals();
	        }
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	
	  function saveInActiveOrg() {
	
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: "Save Facility",
	      confirmModalBody: '<div class="q-alert q-marg-all-xl q-alert-red"> The organization assigned to this facility is currently in an inactive status.</div><div class="q-marg-all-xl">Once saved, this facility will present and maintain an inactive status until it\'s assigned organization is active.</div>',
	      confirmModalBtnText: "Save",
	      onConfirmClick: function onConfirmClick() {
	        var orgId = elsPage.orgName.val() || '';
	        var saveOrgFacURL = submitURL + "&orgId=" + orgId;
	        submitModalFlow.showLoadingModal();
	        submitOrg({ url: saveOrgFacURL, success: saveOrgSuccess, error: saveOrgFailure });
	        function submitOrg(_ref2) {
	          var url = _ref2.url,
	              success = _ref2.success,
	              error = _ref2.error;
	
	          $.ajax({
	            data: {
	              facilityArray: JSON.stringify(facilityArray)
	            },
	            url: url,
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	          });
	        }
	        function saveOrgSuccess(data) {
	          _EditChecker2.default.setPageClean();
	          submitModalFlow.hideAllModals();
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            window.open(detailScreenUrl + "&cadId=" + data, "_self");
	          }, 3000);
	        }
	        function saveOrgFailure() {
	          //submitModalFlow.hide();
	          submitModalFlow.hideAllModals();
	        }
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	
	  function renderOrganizationValues() {
	    var orgIdToBeSelected = "";
	    for (var i = 0; i < organizationList.length; i++) {
	      if (organizationList[i].orgName === organizations.cadOrganizationName) {
	        orgIdToBeSelected = organizationList[i].orgId;
	      }
	    }
	
	    var returnTypeList = "";
	    returnTypeList = organizationList.map(function (el) {
	      return (0, _render2.default)("<option value = '{%-key %}'>{%-value %}</option>", {
	        key: el.orgId,
	        value: el.orgName
	      });
	    });
	
	    elsPage.selectOrgName.append(returnTypeList);
	    elsPage.selectOrgName.val(orgIdToBeSelected);
	    organizationSelectionCheck = orgIdToBeSelected;
	    elsPage.selectOrgName.trigger('change');
	  }
	
	  function getRmsFacilityTypes() {
	    if (!isHoneyComb) {
	      return (0, _render2.default)(__webpack_require__(1309), {
	        rmsFacilityTypes: getRenderedRmsFacility(retailerFacilityForRMS),
	        rmsFedexAccounts: getRenderedFedexAccounts(retailerFedexAccounts),
	        rmsCasAccountDetails: renderCasAccount(),
	        shipToAddress: getRenderedShipToAddress(shipToAddress)
	      });
	    }
	  }
	
	  function renderCasAccount() {
	    if (casAccountNumbers.length > 0) {
	      return (0, _render2.default)(__webpack_require__(1308), {
	        rmsCasAccountDetails: getRenderedCasAccounts(casAccountNumbers)
	      });
	    }
	  }
	
	  function getHcmbFacilityTypes(cmrAddressObj) {
	    if (isHoneyComb) {
	      return (0, _render2.default)(facilityTypeHtml, _extends({}, cmrAddressObj, {
	        facilityTypes: getRenderedFacilityTypes(facilityTypes)
	      }));
	    }
	  }
	
	  function getHcmbFacilityTypesEdit(cmrAddressObj) {
	    if (isHoneyComb) {
	      return (0, _render2.default)(facilityTypeHtml, _extends({}, cmrAddressObj, {
	        facilityTypes: getRenderedFacilityTypesEdit(facilityTypes, cmrAddressObj.cmrAddressAttributes)
	      }));
	    }
	  }
	
	  function showStaticForm() {
	    organizations.orgName = "elsPage.organizationName.val()";
	    var orgNewFormHtml = $((0, _render2.default)(facilityWrapperTemplate, {
	      masterForm: true,
	      facilityDetails: (0, _render2.default)(facilityDetailsHtml, {
	        rmsFacilityTypes: getRmsFacilityTypes(),
	        dupFacName: duplicateCadLocationNameMessage,
	        dupFacId: duplicateAddressIdMessage
	      }),
	      facilityType: getHcmbFacilityTypes(),
	      inboundClassification: getRMSTypes(),
	      facilityAddress: (0, _render2.default)(facilityAddressHtml, {
	        countries: getRenderedCountries(countries)
	      }),
	      facilityContact: (0, _render2.default)(facilityContactHtml, {
	        phoneCodes: getRenderedPhoneCodes(phoneCodes)
	      }),
	      facilityName: "Facility Details",
	      sectionIsExpandable: false,
	      isHoneyComb: isHoneyComb
	    }));
	
	    elsPage.staticFacilityFormDiv.append(orgNewFormHtml);
	    $('.vendorSelectAuthorization').hide();
	    $('#inboundClassification').hide();
	    $('.ship-to-address-row').hide();
	
	    ///Trigger on the default values
	    (0, _select2able.instantiateSelect2)(orgNewFormHtml.find('.select2-select'));
	
	    //Handle the change events in the form 
	    orgNewFormHtml.find(".facility-country").on("change", handleCountryChange);
	    $('#rms-facility-type').on('change', showInboundClassification);
	    orgNewFormHtml.find(".facility-country").val(defaultCountry).trigger('change');
	    orgNewFormHtml.find(".facility-phone-code").val("+1").trigger('change');
	    orgNewFormHtml.find('.phone-number').inputmask({
	      mask: "(999) 999-9999"
	    });
	  }
	
	  function getRMSTypes() {
	    if (!isHoneyComb) {
	      return (0, _render2.default)(inboundClassificationHtml, {
	        inboundClassificationTypes: getRenderedInboundTypes(inboundClassificationTypes)
	      });
	    }
	  }
	
	  function getRMSTypesEdit(cmrAddressObj) {
	    if (!isHoneyComb) {
	      return (0, _render2.default)(inboundClassificationHtml, _extends({}, cmrAddressObj, {
	        inboundClassificationTypes: getRenderedInboundTypesEdit(inboundClassificationTypes, cmrAddressObj.cmrAddressAttributes)
	      }));
	    }
	  }
	
	  function showInboundClassification() {
	    if ($("#rms-facility-type").val() == "vendor") {
	      $('.vendorSelectAuthorization').show();
	      $('#stndRaLabel').show();
	      $('#stndNumber').show();
	      $('#inboundClassification').hide();
	      $('.ship-to-address-row').hide();
	    } else {
	      if ($("#rms-facility-type").val() == "return") {
	        $('.vendorSelectAuthorization').show();
	        $('#stndRaLabel').hide();
	        $('#stndNumber').hide();
	      }
	      //Updated below line by Dhans for Story B-1237968-Enable Return Authorization for Return Center flow in Facilities
	      $('.vendorSelectAuthorization').show();
	      $('#inboundClassification').show();
	      if ($("#rms-facility-type").val() == "inbound") {
	        //Added below line by Dhans for Story B-1237968-Enable Return Authorization for Return Center flow in Facilities  
	        $('.vendorSelectAuthorization').hide();
	        $('.ship-to-address-row').show();
	      } else {
	        $('.ship-to-address-row').hide();
	      }
	    }
	  }
	
	  function handleCountryChange() {
	    handleSwitchingStateInput();
	  }
	
	  function setMasks() {
	    var phoneCode = $('.phone-number');
	    phoneCode.addClass("phoneUS");
	    phoneCode.removeClass("phoneNonUS");
	    phoneCode.attr("placeholder", "(___) ___-____");
	    phoneCode.inputmask({
	      mask: "(999) 999-9999"
	    });
	  }
	
	  function setUnMasks() {
	    var phoneCode = $('.phone-number');
	    phoneCode.addClass("phoneNonUS");
	    phoneCode.removeClass("phoneUS");
	    phoneCode.attr("placeholder", "");
	    phoneCode.inputmask({
	      mask: ""
	    });
	
	    var val = phoneCode.val();
	    if (val) {
	      var v = val.replace(/[- )(]/g, '');
	      v = v.replace(/[^0-9.]/g, "");
	      phoneCode.val(v);
	    }
	  }
	
	  function phoneCodeChange() {
	    var phonecode = mainEl.find(".facility-phone-code").val().toString();
	    if (phonecode === '+1') {
	      setMasks();
	    } else {
	      setUnMasks();
	    }
	  }
	
	  function handleSwitchingStateInput() {
	    var countryVal = $('.facility-country  :selected').val();
	    var isValidCountry = false;
	    var countryValue = '';
	    var checkZipCode = false;
	    $(countries).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        conPhoneCode = this.conPhoneCode.toString();
	        countryValue = this.conCode;
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	        return false;
	      }
	    });
	    $(phoneCodes).each(function () {
	      if (this.conPhoneCode === conPhoneCode) {
	        mainEl.find(".facility-phone-code").find('option[value="' + this.conPhoneCode + '"]').prop('selected', 'selected').trigger('change');
	        return false;
	      }
	    });
	
	    if (countryVal == "1" || countryVal == "2") {
	      $(".facility-stateText-wrapper").hide();
	      $(".facility-state-wrapper").show();
	      $(".state-label").text("State/Province/Region *");
	      getRenderedStatesorProvince(countryVal);
	    } else {
	      $(".facility-stateText-wrapper").show();
	      $(".facility-state-wrapper").hide();
	      $(".state-label").text("State/Province/Region");
	    }
	    $(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryValue.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (isValidCountry) {
	      $(".country-not-supported-primary").hide();
	    } else {
	      $(".country-not-supported-primary").show();
	    }
	    var postalCode = $("#facility-zip");
	    var postalCodeLabel = $(".facility-zip-label");
	    if (checkZipCode) {
	      postalCodeLabel.text('Postal Code *');
	      postalCode.addClass('required');
	      postalCode.prop('required', true);
	    } else {
	      postalCodeLabel.text('Postal Code');
	      postalCode.removeClass('required');
	      postalCode.prop('required', false);
	    }
	  }
	
	  function getRenderedStatesorProvince(countryVal) {
	    var stateTypeSelect = $(".facility-state");
	    stateTypeSelect.html('');
	    var defaultSelectText = "";
	    if (countryVal == "1") {
	      defaultSelectText = "Select State";
	    } else {
	      defaultSelectText = "Select Province";
	    }
	    var option = $('<option />');
	    option.attr('value', "-1").text(defaultSelectText);
	    option.attr('selected', 'selected');
	    option.attr('disabled', 'disabled');
	    stateTypeSelect.append(option);
	    if (countryVal == "1") {
	      $(usaStates).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        stateTypeSelect.append(option);
	      });
	    } else if (countryVal == "2") {
	      $(caProvinces).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        stateTypeSelect.append(option);
	      });
	    }
	    stateTypeSelect.addClass("select2 select");
	    (0, _select2able.instantiateSelect2)(stateTypeSelect);
	  }
	
	  //Render functions for options to be displayed in the select drop downs 
	
	  function getRenderedShipToAddress(shipToAddress) {
	    var rmsFacilityTypesHtml = '<option value="{%- shipToAddress.cadAddressId %}">{%- shipToAddress.cadAddressId %} - {%- shipToAddress.cadLocationName %}</option>';
	    var response = _underscore2.default.map(shipToAddress, function (shipToAddress) {
	      return (0, _render2.default)(rmsFacilityTypesHtml, {
	        shipToAddress: shipToAddress
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getRenderedRmsFacility(retailerFacilityForRMS) {
	    var retailerFacilityHtml = '<option value="{%- rmsFacilityType.cdmValue %}">{%- rmsFacilityType.cdmMeaning %}</option>';
	    var response = _underscore2.default.map(retailerFacilityForRMS, function (rmsFacilityType) {
	      return (0, _render2.default)(retailerFacilityHtml, {
	        rmsFacilityType: rmsFacilityType
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getRenderedFedexAccounts(retailerFedexAccounts) {
	    var retailerFacilityHtml = '<option value="{%- fedexAccounts.cmtId %}">{%- fedexAccounts.cmtAccountNo %}</option>';
	    var response = _underscore2.default.map(retailerFedexAccounts, function (fedexAccounts) {
	      return (0, _render2.default)(retailerFacilityHtml, {
	        fedexAccounts: fedexAccounts
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getRenderedCasAccounts(casAccountNumbers) {
	    var retailerFacilityHtml = '<option value="{%-  casAccounts.ccaId %}">{%- casAccounts.ccaCasAccountnNumber %}</option>';
	    var response = _underscore2.default.map(casAccountNumbers, function (casAccounts) {
	      return (0, _render2.default)(retailerFacilityHtml, {
	        casAccounts: casAccounts
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getRenderedCountries(countries) {
	    var optionHtml = '<option value="{%- country.conId %}">{%- country.conName %}</option>';
	    var response = _underscore2.default.map(countries, function (country) {
	      return (0, _render2.default)(optionHtml, {
	        country: country
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getRenderedPhoneCodes(phoneCodes) {
	    var phoneCodeOptionHtml = '<option value="{%- phoneCode.conPhoneCode %}">{%- phoneCode.conPhoneText %}</option>';
	    var count = 0;
	    var response = _underscore2.default.map(phoneCodes, function (phoneCode) {
	      if (phoneCode.conPhoneCode === '+1' && count == 0) {
	        phoneCode.conPhoneText = "United States of America/Canada +1";
	        count++;
	        return (0, _render2.default)(phoneCodeOptionHtml, {
	          phoneCode: phoneCode
	        });
	      } else if (phoneCode.conPhoneCode !== '+1') {
	        return (0, _render2.default)(phoneCodeOptionHtml, {
	          phoneCode: phoneCode
	        });
	      }
	    });
	    return response.join("");
	  }
	
	  //Render functions for the Facility Type checkbox
	  function getRenderedFacilityTypes(facilityTypes) {
	    var facilityTypeHtml = __webpack_require__(298);
	    var response = _underscore2.default.map(facilityTypes, function (facility) {
	      return (0, _render2.default)(facilityTypeHtml, {
	        facility: facility
	      });
	    });
	
	    return response.join("");
	  }
	
	  //Render functions for the Inbound classification Types
	  function getRenderedInboundTypes(inboundClassificationTypes) {
	
	    var inboundClassificationHtml = __webpack_require__(299);
	    var response = _underscore2.default.map(inboundClassificationTypes, function (inboundClassificationItem) {
	      return (0, _render2.default)(inboundClassificationHtml, {
	        inboundClassificationItem: inboundClassificationItem
	      });
	    });
	
	    return response.join("");
	  }
	
	  //Validate the Form 
	  function validateForm(formElement) {
	    var validator = void 0,
	        validationOpts = void 0;
	    validationOpts = {
	      debug: true,
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    };
	    validator = formElement.validate(validationOpts);
	    validator.settings.ignore = ":disabled,:hidden";
	
	    if (formElement.valid() && !formElement.find('.dup-facName').is(':visible') && !formElement.find('.dup-facId').is(':visible')) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	
	  //Validate the Address section 
	  function validateAddressModal() {
	    var addressSectionMap = {
	      addFacilityCountrySelect: '#facility-country',
	      facilityAddress1: '#facility-address1',
	      facilityAddress2: '#facility-address2',
	      facilityCity: '#facility-city',
	      facilityZipCode: '#facility-zip',
	      facilityStateDropDown: '#facility-state',
	      facilityStateText: '#facility-stateText'
	    };
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, addressSectionMap, orgFacilityForm);
	    var state = '';
	    var isValidCountry = false;
	    var countryValue = '';
	    $(countries).each(function () {
	      if (this.conId.toString() === elsPage.addFacilityCountrySelect.val().toString()) {
	        countryValue = this.conCode;
	        return false;
	      }
	    });
	    $(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryValue.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	
	    if (isValidCountry) {
	      var _data;
	
	      state = elsPage.facilityStateDropDown.val();
	      $.ajax({
	        url: addressValidationUrl,
	        type: "POST",
	        data: (_data = {}, _defineProperty(_data, portletNamespace + 'cadAddress1', elsPage.facilityAddress1.val()), _defineProperty(_data, portletNamespace + 'cadAddress2', elsPage.facilityAddress2.val()), _defineProperty(_data, portletNamespace + 'cadCity', elsPage.facilityCity.val()), _defineProperty(_data, portletNamespace + 'cadState', state), _defineProperty(_data, portletNamespace + 'cadZipcode', elsPage.facilityZipCode.val()), _defineProperty(_data, portletNamespace + 'cadCountry', countryValue), _data),
	        beforeSend: function beforeSend() {
	          $.blockUI({ message: 'Validating Address, Please Wait..' });
	        },
	        complete: function complete() {
	          $.unblockUI();
	        },
	        success: function success(data, textStatus, jqXHR) {
	          addValResponse = $.parseJSON(data);
	          if (addValResponse.result == true) {
	            _EditChecker2.default.setPageClean();
	            elsPage.addressReturned.css("display", "");
	            elsPage.invalidAddress.css("display", "none");
	            elsPage.invalidAddressText.css("display", "none");
	            elsPage.returnedAddressRadio.prop('checked', false);
	            elsPage.enteredAddressRadio.prop('checked', true);
	            elsPage.returnedAddressRadio.show();
	            checkSubmitAddressForm(addValResponse);
	          } else {
	            elsPage.addressReturned.css("display", "none");
	            elsPage.invalidAddress.css("display", "");
	            elsPage.invalidAddressText.css("display", "");
	            elsPage.invalidAddressText.html('Unable to find a validated address');
	            elsPage.returnedAddressRadio.hide();
	            elsPage.returnedAddressRadio.prop('checked', false);
	            elsPage.enteredAddressRadio.prop('checked', true);
	            checkSubmitAddressForm(addValResponse);
	          }
	        }
	      });
	    } else {
	      state = elsPage.facilityStateText.val();
	      submitFacilityAddress(false);
	    }
	  }
	
	  function checkSubmitAddressForm(addValResponse) {
	    elsPage.enteredAddressText.html(addValResponse.enteredAdd);
	    elsPage.returnedAddressText.html(addValResponse.returnedAdd);
	    elsPage.returnedAddressRadio.prop('checked', true);
	    addressEl.modal('show');
	  }
	
	  //If the user chooses to stay on the static form to modify the address 
	  function modifyFacilityAddress() {
	    addressEl.modal('hide');
	  }
	
	  //User chooses to submit the address whether the entered one or the returned one 
	  function submitFacilityAddress() {
	    var validationReqCountry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	    var facilityObjMap = {
	      facilityName: "#facility-name",
	      facilityId: "#facility-id",
	      contactName: "#contact-name",
	      phoneCode: "#phone-code",
	      phoneNumber: "#phone-number",
	      emailId: "#email-id",
	      state: "#facility-State",
	      returnCenter: "#return",
	      manualReturn: "#manual_return",
	      partnerFacility: "#partner_facility",
	      facilityType: "#rms-facility-type",
	      fedExAccount: "#rms-fedex-account",
	      rmsCharity: "#CHA",
	      rmsDestroy: "#DES",
	      rmsRecall: "#RCL",
	      rmsRecycle: "#REC",
	      rmsRefurbish: "#REF",
	      rmsReturnable: "#RET",
	      rmsReturnToStock: "#RTS",
	      rmsSalvage: "#SAL",
	      rmsMmc: "#MMC",
	      returnAuthReq: "#return-auth-req",
	      stndRaLabel: "#stndRaLabel",
	      stndNumber: "#stndNumber",
	      casAccountNo: "#rms-cas-account",
	      shipToAddress: "#ship-to-address"
	    };
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, facilityObjMap, orgFacilityForm);
	    //On Submit address, create the CmrAddressObj and Store the values in it 
	    var cmrAddressObj = {};
	    var state = '';
	    if (elsPage.addFacilityCountrySelect.val() == '1' || elsPage.addFacilityCountrySelect.val() == '2') {
	      state = elsPage.facilityStateDropDown.val();
	    } else {
	      state = elsPage.facilityStateText.val();
	    }
	
	    //Facility Details
	    if (!isHoneyComb) {
	      cmrAddressObj.facilityType = elsPage.facilityType.val();
	      cmrAddressObj.fedExAccount = elsPage.fedExAccount.val();
	      cmrAddressObj.cmrCasAccount = elsPage.casAccountNo.val();
	      //if condition updated by Dhans for Story B-1237968-Enable Return Authorization for Return Center flow in Facilities
	      if (cmrAddressObj.facilityType === 'vendor' || cmrAddressObj.facilityType === 'return') {
	        cmrAddressObj.returnAuthReq = elsPage.returnAuthReq.is(":checked");
	        cmrAddressObj.cadStndNumber = elsPage.stndNumber.val();
	      }
	      if (cmrAddressObj.facilityType === 'inbound') {
	        cmrAddressObj.shipToAddress = elsPage.shipToAddress.val();
	      }
	      cmrAddressObj.rmsCharity = elsPage.rmsCharity.is(":checked");
	      cmrAddressObj.rmsDestroy = elsPage.rmsDestroy.is(":checked");
	      cmrAddressObj.rmsRecall = elsPage.rmsRecall.is(":checked");
	      cmrAddressObj.rmsRecycle = elsPage.rmsRecycle.is(":checked");
	      cmrAddressObj.rmsRefurbish = elsPage.rmsRefurbish.is(":checked");
	      cmrAddressObj.rmsReturnable = elsPage.rmsReturnable.is(":checked");
	      cmrAddressObj.rmsReturnToStock = elsPage.rmsReturnToStock.is(":checked");
	      cmrAddressObj.rmsSalvage = elsPage.rmsSalvage.is(":checked");
	      //MMC E-181400
	      cmrAddressObj.rmsMmc = elsPage.rmsMmc.is(":checked");
	    } else {
	      cmrAddressObj.returnCenter = elsPage.returnCenter.is(":checked");
	      cmrAddressObj.manualReturn = elsPage.manualReturn.is(":checked");
	      cmrAddressObj.partnerFacility = elsPage.partnerFacility.is(":checked");
	    }
	
	    //Set the common fields on the static form to the cmrAddressObj 
	    cmrAddressObj.cadLocationName = elsPage.facilityName.val();
	    cmrAddressObj.cadFacId = elsPage.facilityId.val();
	    //edit Fix
	    cmrAddressObj.cadId = cadEditId;
	    cmrAddressObj.cadAddressId = elsPage.facilityId.val();
	    cmrAddressObj.cadContactName = elsPage.contactName.val();
	    cmrAddressObj.cadContactEmail = elsPage.emailId.val();
	    cmrAddressObj.cadContactCountryPhoneCode = elsPage.phoneCode.val();
	    cmrAddressObj.cadContactPhone = elsPage.phoneNumber.val();
	    cmrAddressObj.cadCommercialAddrFlag = addValResponse.returnedIsCommercial;
	    cmrAddressObj.cadState = state;
	
	    //If the user selects the Return address populate the Address validation response to the CMRObject 
	    //Else If the user selects the Entered address populate the same values as mentioned in the Address section 
	    if (elsPage.returnedAddressRadio.is(":checked") && validationReqCountry) {
	      cmrAddressObj.cadCountry = elsPage.addFacilityCountrySelect.val();
	      cmrAddressObj.cadState = addValResponse.returnedState;
	      cmrAddressObj.cadAddress1 = addValResponse.returnedAddress1;
	      cmrAddressObj.cadAddress2 = addValResponse.returnedAddress2;
	      cmrAddressObj.cadCity = addValResponse.returnedCity;
	      cmrAddressObj.cadZipcode = addValResponse.returnedZip;
	      cmrAddressObj.cadUseStdAddress = '1';
	    } else {
	      cmrAddressObj.cadCountry = elsPage.addFacilityCountrySelect.val();
	      cmrAddressObj.cadAddress1 = elsPage.facilityAddress1.val();
	      cmrAddressObj.cadAddress2 = elsPage.facilityAddress2.val();
	      cmrAddressObj.cadCity = elsPage.facilityCity.val();
	      cmrAddressObj.cadZipcode = elsPage.facilityZipCode.val();
	      cmrAddressObj.cadUseStdAddress = '0';
	    }
	    if (cmrAddressObj.cadActive !== null) {
	      cmrAddressObj.cadActive = organizations.cadActive;
	    }
	    addressEl.modal('hide');
	    facilityArray.push(cmrAddressObj);
	    saveFacility();
	  }
	
	  function generateOrganizationActiveCheckErrorModals() {
	    organizationActiveCheckErrorModal = $((0, _render2.default)(sharedModalHtml, {
	      title: 'Activate Facility Error',
	      footerBtns: '<a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Okay</a>',
	      body: "<div class=q-pad-all-xl>This facility is inactive due to it's organization being in an inactive status. In order to activate this facility you must first reactivate it's organization.</div>",
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800"
	    }));
	
	    $('body').append(organizationActiveCheckErrorModal);
	  }
	
	  function populateEditForm(cmrAddressObj) {
	    elsPage.orgName.val(cmrAddressObj.cadOrganizationName);
	    cadEditId = cmrAddressObj.cadId;
	    organizations.orgName = cmrAddressObj.cadOrganizationName;
	    var orgNewFormHtml = $((0, _render2.default)(facilityWrapperTemplate, _extends({
	      masterForm: false
	    }, cmrAddressObj, {
	      facilityDetails: (0, _render2.default)(facilityDetailsHtml, _extends({}, cmrAddressObj, {
	        rmsFacilityTypes: getRmsFacilityTypes(),
	        cadAddressId: cmrAddressObj.cadAddressId,
	        dupFacName: duplicateCadLocationNameMessage,
	        dupFacId: duplicateAddressIdMessage
	      })),
	      facilityType: getHcmbFacilityTypesEdit(cmrAddressObj),
	      inboundClassification: getRMSTypesEdit(cmrAddressObj),
	      facilityAddress: (0, _render2.default)(facilityAddressHtml, _extends({}, cmrAddressObj, {
	        countries: getRenderedCountries(countries)
	      })),
	      facilityContact: (0, _render2.default)(facilityContactHtml, _extends({}, cmrAddressObj, {
	        phoneCodes: getRenderedPhoneCodes(phoneCodes)
	
	      })),
	      facilityName: cmrAddressObj.cadLocationName,
	      sectionIsExpandable: true,
	      isHoneyComb: isHoneyComb
	    })));
	    elsPage.staticFacilityFormDiv.append(orgNewFormHtml);
	
	    ///Trigger on the default values
	    (0, _select2able.instantiateSelect2)(orgNewFormHtml.find('.select2-select'));
	
	    var phoneCodeIdSelected = "";
	    if (cmrAddressObj.cadContactCountryPhoneCode != null) {
	      phoneCodeIdSelected = cmrAddressObj.cadContactCountryPhoneCode;
	    }
	
	    var stateCodeIdSelected = "";
	    if (cmrAddressObj.cadState != null) {
	      stateCodeIdSelected = cmrAddressObj.cadState;
	    }
	
	    var countryCodeIdSelected = "";
	    if (cmrAddressObj.cadCountry != null) {
	      countryCodeIdSelected = cmrAddressObj.cadCountry;
	    }
	
	    var rmsFedExAccountSelected = "";
	    if (cmrAddressObj.cadCmtId != null) {
	      rmsFedExAccountSelected = cmrAddressObj.cadCmtId;
	    }
	
	    var casAccountSelected = "";
	    if (cmrAddressObj.cadCcaId != null) {
	      casAccountSelected = cmrAddressObj.cadCcaId;
	    }
	
	    var rmsShipToAddressSelected = "";
	    if (cmrAddressObj.cadShipAddressId != null) {
	      rmsShipToAddressSelected = cmrAddressObj.cadShipAddressId;
	    }
	
	    //Handle the change events in the form 
	    orgNewFormHtml.find(".facility-country").on("change", handleCountryChange);
	    $('#rms-facility-type').on('change', showInboundClassification);
	    orgNewFormHtml.find(".facility-country").val(countryCodeIdSelected).trigger('change');
	    if (cmrAddressObj.cadCountry === "1" || cmrAddressObj.cadCountry === "2") {
	      orgNewFormHtml.find(".facility-state").val(stateCodeIdSelected).trigger('change');
	    } else {
	      orgNewFormHtml.find("#facility-stateText").val(stateCodeIdSelected);
	    }
	    orgNewFormHtml.find(".facility-phone-code").val(phoneCodeIdSelected).trigger('change');
	    orgNewFormHtml.find("#rms-fedex-account").val(rmsFedExAccountSelected).trigger('change');
	    orgNewFormHtml.find("#rms-cas-account").val(casAccountSelected).trigger('change');
	
	    if (!isHoneyComb) {
	      var attrArray = cmrAddressObj.cmrAddressAttributes;
	      var facType = "";
	      for (var i = 0; i < attrArray.length; i++) {
	        if (attrArray[i].caaValue === "VR") {
	          facType = "vendor";
	        } else if (attrArray[i].caaValue === "RC") {
	          facType = "return";
	        } else if (attrArray[i].caaValue === "IS") {
	          facType = "inbound";
	        }
	      }
	      //if condition updated by Dhans for Story B-1237968-Enable Return Authorization for Return Center flow in Facilities
	      if (facType === "vendor") {
	        orgNewFormHtml.find(".rms-facility-type").val(facType).trigger('change');
	        orgNewFormHtml.find('#inboundClassification').hide();
	        var vrRequired = "false";
	        for (var _i = 0; _i < attrArray.length; _i++) {
	          if (attrArray[_i].caaKey === "vendor_ra_required") {
	            vrRequired = attrArray[_i].caaValue;
	          }
	        }
	        if (vrRequired === "true") {
	          orgNewFormHtml.find("#return-auth-req").prop('checked', true);
	          for (var _i2 = 0; _i2 < attrArray.length; _i2++) {
	            if (attrArray[_i2].caaKey === "vendor_standing_ra") {
	              orgNewFormHtml.find("#stndNumber").show();
	              orgNewFormHtml.find("#stndNumber").val(attrArray[_i2].caaValue);
	            }
	          }
	        }
	      } else if (facType === "return") {
	        orgNewFormHtml.find(".rms-facility-type").val(facType).trigger('change');
	        orgNewFormHtml.find('#inboundClassification').show();
	        var _vrRequired = "false";
	        for (var _i3 = 0; _i3 < attrArray.length; _i3++) {
	          if (attrArray[_i3].caaKey === "vendor_ra_required") {
	            _vrRequired = attrArray[_i3].caaValue;
	          }
	        }
	        if (_vrRequired === "true") {
	          orgNewFormHtml.find("#return-auth-req").prop('checked', true);
	          for (var _i4 = 0; _i4 < attrArray.length; _i4++) {
	            if (attrArray[_i4].caaKey === "vendor_standing_ra") {
	              orgNewFormHtml.find("#stndNumber").show();
	              orgNewFormHtml.find("#stndNumber").val(attrArray[_i4].caaValue);
	            }
	          }
	        }
	      } else {
	        orgNewFormHtml.find(".rms-facility-type").val(facType).trigger('change');
	        orgNewFormHtml.find('#inboundClassification').show();
	
	        if (facType === "inbound") {
	          orgNewFormHtml.find("#ship-to-address").val(rmsShipToAddressSelected);
	        }
	      }
	    }
	  }
	
	  function getRenderedFacilityTypesEdit(facilityTypes, cmrAddressAttributes) {
	    var facilityTypeHtml = __webpack_require__(298);
	    var response = _underscore2.default.map(facilityTypes, function (facility) {
	      return (0, _render2.default)(facilityTypeHtml, {
	        facility: facility,
	        isChecked: getValuesForTypes(cmrAddressAttributes, facility)
	      });
	    });
	    return response.join("");
	  }
	
	  function getValuesForTypes(cmrAddressAttributes, facility) {
	    var checked = "";
	    for (var i = 0; i < cmrAddressAttributes.length; i++) {
	      if (facility.cdmMeaning === cmrAddressAttributes[i].caaKey) {
	        checked = "checked";
	      }
	    }
	    return checked;
	  }
	
	  function getRenderedInboundTypesEdit(inboundClassificationTypes, cmrAddressAttributes) {
	    var inboundClassificationHtml = __webpack_require__(299);
	    var response = _underscore2.default.map(inboundClassificationTypes, function (inboundClassificationItem) {
	      return (0, _render2.default)(inboundClassificationHtml, {
	        inboundClassificationItem: inboundClassificationItem,
	        isChecked: getValuesForInbound(cmrAddressAttributes, inboundClassificationItem)
	      });
	    });
	
	    return response.join("");
	  }
	
	  function getValuesForInbound(cmrAddressAttributes, inbound) {
	    var checked = "";
	    for (var i = 0; i < cmrAddressAttributes.length; i++) {
	      if (cmrAddressAttributes[i].caaValue == inbound.cdmValue) {
	        checked = "checked";
	      }
	    }
	    return checked;
	  }
	
	  init();
	}

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	var sharedModalHtml = __webpack_require__(11);
	var targetSelector = "#facility-details-screen";
	var modalHtml = __webpack_require__(11);
	
	var inboundSectionHtml = __webpack_require__(1320);
	var rmsShipToAddressHtml = __webpack_require__(1322);
	var classificationTypesHtml = __webpack_require__(1307);
	var facilityfulfilmentHtml = __webpack_require__(1324);
	var facilitytypeHtml = __webpack_require__(1318);
	var returnSupplyChain = __webpack_require__(1326);
	var returnSupplyChainTypesHtml = __webpack_require__(1325);
	
	(0, _run2.default)(targetSelector, function (target) {
	  var countryList = target.data("country-list");
	  var orgStatus = target.data("org-status-url");
	  var usaStates = target.data('usa-states');
	  var caProvinces = target.data('ca-provinces');
	  var phoneCodes = target.data('country-phone-code-list');
	  var changeStatusURL = target.data("change-status-url");
	  var facilitiesDetailsJson = target.data("facility-details-json");
	  var isHoneyCombUser = target.data("is-honey-comb-user");
	  var defaultInboundClassificationList = target.data("default-inbound-classification");
	  var fedExAccountNo = target.data("fdx-account-number");
	  var hubId = target.data("hub-id");
	  var backToListUrl = target.data("back-to-list");
	  var editFacilityUrl = target.data("edit-url");
	  var pageRefreshUrl = target.data("page-refresh-url");
	  var defaultfacTypeList = target.data("default-facilty-Types-rms");
	  var facTypeListJson = target.data("facility-types-json");
	  var facTypeListJsonrms = target.data("facility-types-json-rms");
	  var facTypeSupplyChain = target.data("facility-types-supply");
	  var scFacilityTypes = target.data("supplychain-facility-types");
	  var supplyChainSaveConfigURL = target.data("supply-chain-config-save-url");
	  var scReturnTypes = target.data("supplychain-return-types");
	  var orderProcessGuideURL = target.data("order-proccess-guide-url");
	  var cacheCheck = target.data("cache-check");
	  var casAccountNumber = target.data("cas-account-number");
	  var isAddPermission = target.data("add-permission");
	  var isEditPermission = target.data("edit-permission");
	  var facilitiesUomConfig = target.data("facilities-uom-config");
	  var retailerFedexAccounts = target.data('retailer-fedex-accounts');
	  var retailerAccountNumber = target.data("retailer-hc-accountnumber");
	  var retailerHubId = target.data("retailer-hc-hubid");
	  var retailerCadCmtId = target.data("retailer-hc-hcadcmid");
	
	  var facilityStatus = facilitiesDetailsJson.cadActive;
	  var supplyChainId = facilitiesDetailsJson.cadFacId;
	  var facilityNameErrorModal = void 0;
	  var isSupplyChain = '';
	  var selectFromOrgModal = void 0;
	  var facilityFulfillmentList = '';
	
	  if (supplyChainId) {
	    isSupplyChain = 'supplychain';
	  }
	
	  var mainEl = getMainElHTML(isSupplyChain, {
	    details: getDetailsData(),
	    data: facilitiesDetailsJson,
	    facStatusForPill: getFacilityForStatusPill(),
	    statusPillClass: getStatusPill(),
	    iseditPersmission: getPermissionStatus()
	  });
	  target.append(mainEl);
	
	  function getMainElHTML(isSupplyChain, renderOptions) {
	    if (isSupplyChain) {
	      return $((0, _render2.default)(__webpack_require__(1316), renderOptions));
	    } else {
	      return $((0, _render2.default)(__webpack_require__(1317), renderOptions));
	    }
	  }
	
	  function getPermissionStatus() {
	    if (isEditPermission) {
	      return (0, _render2.default)(__webpack_require__(1306), {
	        facStatus: getFacilityStatus()
	      });
	    }
	  }
	
	  function getPencilEdit() {
	    var pencilStatus = "";
	    if (isEditPermission) {
	      pencilStatus = '<i class="fa fa-pencil q-icon-marg-left q-icon-md" aria-hidden="true"></i>';
	    }
	    return pencilStatus;
	  }
	
	  function getFacilityStatus() {
	    var facStatus = "Activate";
	    if (facilityStatus == 'Y') {
	      facStatus = "Deactivate";
	    }
	    return facStatus;
	  }
	
	  function getStatusPill() {
	    var statusPillClass = "q-pill-blue";
	    if (facilityStatus == 'N' || facilityStatus == null) {
	      statusPillClass = "q-pill-blue-border";
	    }
	    return statusPillClass;
	  }
	
	  function getFacilityForStatusPill() {
	    var facStatus = "Active";
	    if (facilityStatus == 'N' || facilityStatus == null) {
	      facStatus = "Inactive";
	    }
	    return facStatus;
	  }
	
	  function getDetailsData() {
	    if (isHoneyCombUser) {
	      if (isSupplyChain) {
	        return (0, _render2.default)(__webpack_require__(1327), {
	          data: facilitiesDetailsJson,
	          country: getCountry(),
	          facilityTypesData: (0, _render2.default)(facilityfulfilmentHtml, {
	            facilityType: getFulFillmentTypes()
	          }),
	          returnTypesData: (0, _render2.default)(returnSupplyChain, {
	            returnType: getReturnTypes()
	          })
	        });
	      } else {
	        return (0, _render2.default)(__webpack_require__(1319), {
	          data: facilitiesDetailsJson,
	          country: getCountry(),
	          facilityTypeForHoneyComb: getFacilityTypeForHoneyComb(),
	          editPencil: getPencilEdit()
	        });
	      }
	    } else {
	      return (0, _render2.default)(__webpack_require__(1321), {
	        data: facilitiesDetailsJson,
	        hubId: hubId,
	        country: getCountry(),
	        facilityTypeForRMS: getFacilityTypeForRms(),
	        inboundClassificationTypes: (0, _render2.default)(inboundSectionHtml, {
	          classificationType: getInboundClassificationTypes()
	        }),
	        isAuthValueOn: getAuthorizationValue(),
	        stndRaNumber: getStndRaNumber(),
	        editPencil: getPencilEdit(),
	        fedExAccountNo: fedExAccountNo,
	        casAccountNumber: casAccountNumber,
	
	        rmsShipToAddress: getRmsShipToAddressVal()
	      });
	    }
	  }
	
	  function validateOrgStatus() {
	    var orgName = facilitiesDetailsJson.cadOrganizationName;
	    $.ajax({
	      url: verifyOrgStatusUrl,
	      data: {
	        orgName: orgName
	      },
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        if (data.status == true) {
	          return true;
	        } else {
	          return false;
	        }
	      }
	    });
	  }
	
	  function getCountry() {
	    var country = "";
	    _underscore2.default.each(countryList, function (el) {
	      if (facilitiesDetailsJson.cadCountry == el.conCode) {
	        country = el.conName;
	      }
	    });
	    return country;
	  }
	
	  var els = {};
	  var rmsFacilityType = getFacilityTypeForRms();
	
	  var elementsMap = {
	    //backToList:".backToList",
	    editButton: ".editButton",
	    changeStatus: "#changeStatus",
	    editPencilBtn: ".editPencilBtn",
	    configSupplyChainBtn: ".configSupplyChainBtn",
	    //saveConfigBtn:".save-changes-btn",
	    vendorAuthorizationSection: "#vendorAuthorizationSection",
	    inboundClassificationsSection: "#inboundClassificationsSection"
	  };
	
	  function init() {
	    setElements();
	    generateModals();
	    bindElements();
	    rmsFacilityTypeHandler();
	    generateErrorModals();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, target);
	  }
	
	  function bindElements() {
	    //els.backToList.on('click', backToListHandler);
	    els.editButton.on('click', editButtonHandler);
	    els.editPencilBtn.on('click', editButtonHandler);
	    els.changeStatus.on("click", changeStatusHandler);
	    els.configSupplyChainBtn.on('click', configSupplyChainHandle);
	    target.on("click", ".backToList", backToListHandler);
	    //target.saveConfigBtn.on('click',saveConfigBtnHandler)
	  }
	
	  function changeStatusHandler(e) {
	    e.preventDefault();
	    deactivateFacilitiesCall(facilitiesDetailsJson.cadId);
	  }
	
	  function rmsFacilityTypeHandler() {
	    if (rmsFacilityType === "Vendor Returns") {
	      els.vendorAuthorizationSection.show();
	      els.inboundClassificationsSection.hide();
	    } else if (rmsFacilityType === "Return Center") {
	      els.vendorAuthorizationSection.show();
	      els.inboundClassificationsSection.show();
	    } else {
	      els.vendorAuthorizationSection.hide();
	      els.inboundClassificationsSection.show();
	    }
	  }
	
	  function getFacilityTypeForHoneyComb() {
	    var facilityTypeArray = (0, _underscore2.default)(facilitiesDetailsJson.cmrAddressAttributes).map(facilityTypeArrayTemp);
	    var facilityTypeArrayResponse = void 0;
	    facilityTypeArrayResponse = _underscore2.default.filter(facilityTypeArray, function (entry) {
	      return entry && entry.trim() != '';
	    });
	    return facilityTypeArrayResponse.join(", ");
	  }
	
	  function facilityTypeArrayTemp(data) {
	    var returnValue = '';
	    if (data != null) {
	      var facData = facTypeListJson;
	      _underscore2.default.each(facData, function (el) {
	        if (el.cdmMeaning == data.caaKey) {
	          returnValue = el.cdmValue;
	        }
	      });
	    }
	    return returnValue;
	  }
	
	  function getFacilityTypeForRms() {
	    var facilityTypeArray = (0, _underscore2.default)(facilitiesDetailsJson.cmrAddressAttributes).map(facilityTypeArrayRms);
	    var facilityTypeArrayResponse = void 0;
	    facilityTypeArrayResponse = _underscore2.default.filter(facilityTypeArray, function (entry) {
	      return entry && entry.trim() != '';
	    });
	    return facilityTypeArrayResponse.join(", ");
	  }
	
	  function facilityTypeArrayRms(data) {
	    var returnValue = '';
	    if (data.caaValue != '' && data.caaKey != 'inbound_classification' && data.caaKey != 'vendor_ra_required' && data.caaKey != 'vendor_standing_ra') {
	      var facData = facTypeListJsonrms;
	      _underscore2.default.each(facData, function (el) {
	        if (el.cdmMeaning == data.caaKey) {
	          returnValue = el.cdmValue;
	        }
	      });
	    }
	    return returnValue;
	  }
	
	  function getAuthorizationValue() {
	    var getcmrAddressAttributesData = facilitiesDetailsJson.cmrAddressAttributes;
	    var isAuthOn = "";
	    var response = "";
	    _underscore2.default.each(getcmrAddressAttributesData, function (el) {
	      if (el.caaKey == "vendor_ra_required") {
	        isAuthOn = el.caaValue;
	      }
	    });
	    if (isAuthOn == "true") {
	      response = '<span class="q-pretty-pill-tag q-ppt-pad-lg q-ppt-blue">Yes</span>';
	    } else {
	      response = '<span class="q-pretty-pill-tag q-ppt-pad-lg q-ppt-blue-border">No</span>';
	    }
	    return response;
	  }
	
	  function getStndRaNumber() {
	    var getcmrAddressAttributesData = facilitiesDetailsJson.cmrAddressAttributes;
	    var stndRaNumber = "Not Set";
	    for (var i = 0; i < getcmrAddressAttributesData.length; i++) {
	      if (getcmrAddressAttributesData[i].caaKey === "vendor_standing_ra") {
	        stndRaNumber = getcmrAddressAttributesData[i].caaValue;
	      }
	    }
	    return stndRaNumber;
	  }
	
	  function getRmsShipToAddressVal() {
	    if (facilitiesDetailsJson.cadAddressType == "inbound") {
	      return (0, _render2.default)(rmsShipToAddressHtml, {
	        cadShipAddressId: facilitiesDetailsJson.cadShipAddressId
	      });
	    }
	  }
	
	  function getInboundClassificationTypes() {
	    var response = _underscore2.default.map(defaultInboundClassificationList, function (inboundClassificationItem) {
	      return (0, _render2.default)(classificationTypesHtml, {
	        item: inboundClassificationItem,
	        isOn: getInboundSelectedValue(inboundClassificationItem)
	      });
	    });
	    return response.join("");
	  }
	
	  function getInboundSelectedValue(inboundClassificationItem) {
	    var getInboundClassificationData = facilitiesDetailsJson.cmrAddressAttributes;
	    var isOn = "<span class='q-pretty-pill-tag q-ppt-pad-lg q-ppt-blue-border'>Off</span>";
	    _underscore2.default.each(getInboundClassificationData, function (el) {
	      if (inboundClassificationItem.cdmValue == el.caaValue) {
	        isOn = "<span class='q-pretty-pill-tag q-ppt-pad-lg q-ppt-blue'>On</span>";
	      }
	    });
	    return isOn;
	  }
	
	  function getFulFillmentTypes() {
	    var response = _underscore2.default.map(scFacilityTypes, function (fulfillmentTypesList) {
	      return (0, _render2.default)(facilitytypeHtml, {
	        fTypes: fulfillmentTypesList,
	        isOn: getFacilitySelectedValue(fulfillmentTypesList)
	      });
	    });
	    return response.join("");
	  }
	
	  function getFacilitySelectedValue(fulfillmentTypesList) {
	    var getFacilitySelectedData = facilitiesDetailsJson.cmrAddressAttributes;
	    var isOn = "<span class='q-pretty-pill-tag q-ppt-grey q-pad-horz-xxs q-marg-horz-md'>Off</span>";
	    _underscore2.default.each(getFacilitySelectedData, function (el) {
	      if (fulfillmentTypesList.cdmValue == el.caaValue && fulfillmentTypesList.cdmValue != 'RC') {
	        isOn = "<span class='q-pretty-pill-tag q-ppt-purple q-pad-horz-xxs q-marg-horz-md'>On</span>";
	      }
	    });
	    return isOn;
	  }
	
	  function getReturnTypes() {
	    var response = _underscore2.default.map(scReturnTypes, function (returnTypeList) {
	      return (0, _render2.default)(returnSupplyChainTypesHtml, {
	        rTypes: returnTypeList,
	        isOn: getReturnSelectedValue(returnTypeList),
	        isFedexAccountOn: getFedexAccountValues(returnTypeList),
	        fedExAccountNumber: retailerAccountNumber,
	        fedExHubID: retailerHubId
	      });
	    });
	    return response.join("");
	  }
	
	  function getFedexAccountValues(returnTypeList) {
	    var getReturnSelectedData = facilitiesDetailsJson.cmrAddressAttributes;
	    var isOn = "<span class='q-pretty-pill-tag q-ppt-grey q-pad-horz-xxs q-marg-horz-md'>Off</span>";
	    _underscore2.default.each(getReturnSelectedData, function (el) {
	      if (returnTypeList.cdmValue == el.caaValue && returnTypeList.cdmValue == 'RC' && retailerHubId != null && retailerHubId != "" && retailerAccountNumber != null && retailerAccountNumber != "") {
	        isOn = "<span class='q-pretty-pill-tag q-ppt-purple q-pad-horz-xxs q-marg-horz-md'>On</span>";
	      }
	    });
	    return isOn;
	  }
	
	  function getReturnSelectedValue(returnTypeList) {
	    var getReturnSelectedData = facilitiesDetailsJson.cmrAddressAttributes;
	    var isOn = "<span class='q-pretty-pill-tag q-ppt-grey q-pad-horz-xxs q-marg-horz-md'>Off</span>";
	    _underscore2.default.each(getReturnSelectedData, function (el) {
	      if (returnTypeList.cdmValue == el.caaValue && returnTypeList.cdmValue == 'RC') {
	        isOn = "<span class='q-pretty-pill-tag q-ppt-purple q-pad-horz-xxs q-marg-horz-md'>On</span>";
	      }
	    });
	    return isOn;
	  }
	
	  function backToListHandler(e) {
	    e.preventDefault();
	    if (cacheCheck) {
	      window.history.go(-1);
	    } else {
	      window.location.href = backToListUrl;
	    }
	  }
	
	  function editButtonHandler(e) {
	    e.preventDefault();
	    window.open(editFacilityUrl + "&cadId=" + facilitiesDetailsJson.cadId, "_self");
	  }
	
	  function generateErrorModals() {
	
	    facilityNameErrorModal = $((0, _render2.default)(sharedModalHtml, {
	      title: 'Activate Facility Error',
	      footerBtns: '<a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Okay</a>',
	      body: "<div class=q-pad-all-xl>This facility is inactive due to it's organization being in an inactive status. In order to activate this facility you must first reactivate it's organization.</div>",
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800"
	    }));
	    $('body').append(facilityNameErrorModal);
	  }
	
	  function deactivateFacilitiesCall(cadId) {
	    //In future if requirement comes to change either to change only title or btn text,hence introduced separetely 
	    var confirmModalBtnText = "Activate Facility";
	    var confirmModalTitle = "Activate Facility";
	    if (facilityStatus == 'Y') {
	      confirmModalBtnText = "Deactivate Facility";
	      confirmModalTitle = "Deactivate Facility";
	    }
	    if (confirmModalBtnText === "Activate Facility") {
	      if (!orgStatus && !(0, _underscore2.default)(orgStatus).isString()) {
	        showFacilityNameErrorModal();
	      } else {
	        changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId);
	      }
	    } else {
	      changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId);
	    }
	  }
	
	  function showFacilityNameErrorModal() {
	    facilityNameErrorModal.modal('show');
	  }
	  //Supply config start
	
	
	  //$('body').on('click', '.supply-tab-active', function (e)
	
	  function configSupplyChainHandle(e) {
	    e.preventDefault();
	
	    //let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // let parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // let row = $(".data-table-component").dataTable().api().row(parent);
	    var facilities = facilitiesDetailsJson;
	
	    facId = facilities.cadFacId;
	    facName = facilities.cadLocationName;
	
	    getFacilitiesUomConfig(facilitiesUomConfig, facId); //Need to get facility config first since retailer config can override default facility UOM config once it is editable
	    populateSupplychainConfigurationModal(facilities);
	
	    showOrganizationSelectModal();
	    //generateModals(facName);
	
	    $(function () {
	      $("#fedex-account").click(function () {
	        if ($(this).is(':checked')) {
	          $("#fedexAcntChecked").show();
	        } else {
	          $("#fedexAcntChecked").hide();
	        }
	      });
	    });
	  }
	
	  $(function () {
	    $("#returns-center").click(function () {
	      if ($(this).is(':checked')) {
	        if ($("#fedex-account").is(":checked")) {
	          $("#fedex-account1").show();
	          $("#fedexAcntChecked").show();
	        } else {
	          $("#fedex-account1").show();
	        }
	      } else {
	        $("#fedex-account1").hide();
	        $("#fedexAcntChecked").hide();
	      }
	      $("#fedex-account").click(function () {
	        if ($(this).is(':checked')) {
	          $("#fedexAcntChecked").show();
	        } else {
	          $("#fedexAcntChecked").hide();
	        }
	      });
	    });
	  });
	
	  var facName = "";
	  var facId = "";
	  //generateModals(facName);
	
	  function generateModals(facName) {
	    selectFromOrgModal = $((0, _render2.default)(sharedModalHtml, {
	      title: 'Configure Supply Chain Facility',
	      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn save-changes-btn">Save Changes</a>',
	      body: (0, _render2.default)(__webpack_require__(300), {
	        facilityName: facName,
	        link: orderProcessGuideURL,
	        rmsFedexAccounts: getRenderedFedexAccounts(retailerFedexAccounts)
	      }),
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800"
	    }));
	    $('body').append(selectFromOrgModal);
	  }
	
	  function getRenderedFedexAccounts(retailerFedexAccountsList) {
	    var retailerFacilityHtml = '<option value="{%- retailerFedexAccountsListVal.cmtId %}">{%- retailerFedexAccountsListVal.cmtAccountNo %}</option>';
	    var response = _underscore2.default.map(retailerFedexAccountsList, function (retailerFedexAccountsListVal) {
	      return (0, _render2.default)(retailerFacilityHtml, {
	        retailerFedexAccountsListVal: retailerFedexAccountsListVal
	      });
	    });
	
	    return response.join("");
	  }
	
	  function populateSupplychainConfigurationModal(data) {
	    $(".facName").text(data.cadLocationName);
	    $(".facId").text(data.cadFacId);
	
	    $.each(data.cmrAddressAttributes, function (i, attribute) {
	      if (attribute.caaValue == 'FC') {
	        $('#fulfillment-center').attr('checked', true);
	      }
	      if (attribute.caaValue == 'DC') {
	        $('#distribution-center').attr('checked', true);
	      }
	      if (attribute.caaValue == 'RC') {
	        $('#returns-center').attr('checked', true);
	        if (retailerHubId != null && retailerHubId != "" && retailerAccountNumber != null && retailerAccountNumber != "" && $('#returns-center').is(':checked')) {
	          $("#fedex-account1").show();
	          $('#fedex-account').attr('checked', true);
	        }
	        if ($('#fedex-account').is(':checked') && retailerHubId != null && retailerHubId != "" && retailerAccountNumber != null && retailerAccountNumber != "") {
	          $("#fedexAcntChecked").show();
	          $("#fedex-account-numbers").val(retailerCadCmtId).trigger("change");
	        }
	      } else {
	
	        if ($('#returns-center').is(':checked')) {
	          $("#fedex-account1").show();
	        }
	        if ($('#fedex-account1').is(':checked')) {
	          $("#fedexAcntChecked").show();
	        }
	      }
	
	      if (attribute.caaValue == 'IN') {
	        $('#international-fulfillment-center').attr('checked', true);
	      }
	      if (attribute.caaValue == 'UOM') {
	        $("#additional-units-of-measure").attr('checked', true);
	      }
	    });
	  }
	
	  function showOrganizationSelectModal() {
	    selectFromOrgModal.modal('show');
	  }
	
	  function hideOrganizationSelectModal() {
	    selectFromOrgModal.modal('hide');
	  }
	
	  $(document).on('click', '.save-changes-btn', saveSupplyChainConfig);
	
	  function saveSupplyChainConfig() {
	    hideOrganizationSelectModal();
	    var submitModal = new _SubmitModalFlow2.default();
	    submitModal.init();
	    submitModal.showLoadingModal();
	    $.ajax({
	      url: supplyChainSaveConfigURL,
	      data: {
	        facId: facId,
	        fulfillmentCenter: $("#fulfillment-center").is(":checked"),
	        distributionCenter: $("#distribution-center").is(":checked"),
	        internationalFulfillmentCenter: $("#international-fulfillment-center").is(":checked"),
	        returnsCenter: $("#returns-center").is(":checked"),
	        fedexAccount: $("#fedex-account").is(":checked"),
	        additionalUnitsOfMeasure: $("#additional-units-of-measure").is(":checked"),
	        cmtId: getFedexAccountNumber($("#fedex-account-numbers").val(), $("#returns-center").is(":checked"), $("#fedex-account").is(":checked"))
	      },
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        if (data.success == "Success") {
	          submitModal.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, 3000);
	        } else {
	          submitModal.showFailureModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, 3000);
	        }
	      }
	    });
	  };
	
	  function getFedexAccountNumber(fedexAccountValue, returnsCenterFlag, fedexAccountFlag) {
	    if (returnsCenterFlag && fedexAccountValue != null && fedexAccountFlag) {
	      return fedexAccountValue;
	    } else {
	      return "";
	    }
	  }
	
	  //supply chain end
	  function changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId) {
	    var deactivateFacilityModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: confirmModalTitle,
	      confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
	      confirmModalBtnText: confirmModalBtnText,
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        deactivateFacilityModal.showLoadingModal();
	        deactivateFacility({ url: changeStatusURL, success: deactivateSuccess, error: deactivateFailure });
	        function deactivateFacility(_ref) {
	          var url = _ref.url,
	              success = _ref.success,
	              error = _ref.error;
	
	          $.ajax({
	            url: url,
	            data: {
	              cadIds: cadId
	            },
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	          });
	        }
	        function deactivateSuccess() {
	          deactivateFacilityModal.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, 3000);
	        }
	        function deactivateFailure() {
	          setTimeout(function () {
	            deactivateFacilityModal.hideAllModals();
	          }, 6000);
	        }
	      }
	    });
	    deactivateFacilityModal.init();
	    deactivateFacilityModal.showConfirmModal();
	  }
	
	  function getFacilitiesUomConfig(data, facId) {
	    _underscore2.default.each(data, function (facConfig) {
	      if (facConfig.facId == facId) {
	        if (facConfig.facUomEditable == 1) {
	          $("#additional-units-of-measure").prop('disabled', false);
	        } else {
	          $("#additional-units-of-measure").prop('disabled', true);
	        }
	      }
	    });
	  }
	
	  init();
	});
	
	// WEBPACK FOOTER //
	// ./src/pages/facilities/details.js

/***/ },
/* 622 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all-supplyTab": [{
	    title: "Config Supply Chain",
	    cls: "bulk-supply-tab-active",
	    icon: "sliders",
	    disabled: true
	  }],
	  "all": [{
	    title: "Activate/Deactivate",
	    cls: "bulk-activate-rule",
	    icon: "toggle-off",
	    disabled: false
	  }],
	  "actions": [{
	    title: "Edit",
	    cls: "edit-location",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Activate/Deactivate",
	    cls: "activate-rule",
	    icon: "toggle-off",
	    disabled: false
	  }],
	  "supplyTab": [{
	    title: "Config Supply Chain",
	    cls: "supply-tab-active",
	    icon: "sliders",
	    disabled: false
	  }],
	  "splSupplyTab": [{
	    title: "Config Supply Chain",
	    cls: "supply-tab-active",
	    icon: "sliders",
	    disabled: true
	  }]
	
	};

/***/ },
/* 623 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var searchDropdown = exports.searchDropdown = [{
		title: "Facility Name",
		value: "cadLocationName"
	}, {
		title: "Organization Name",
		value: "cadOrganizationName"
	}, {
		title: "Facility Type",
		value: "cadFacilityType"
	}];

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(625);
	
	__webpack_require__(620);
	
	__webpack_require__(621);

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _testFilterData = __webpack_require__(470);
	
	var _testColumnModalData = __webpack_require__(469);
	
	var _savedViews = __webpack_require__(468);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _searchDropdown = __webpack_require__(623);
	
	var _filtersutil = __webpack_require__(16);
	
	var _actionOptions = __webpack_require__(622);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	var modalHtml = __webpack_require__(11);
	var targetSelector = "#location-facilities-lookup";
	
	//for table data. filters,saved views
	
	var sharedModalHtml = __webpack_require__(11);
	
	
	var actionList = _actionOptions.actionOptions;
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var statusPillRenderTemplate = __webpack_require__(1323);
	
	var pillStatusClasses = {
	  "N": "q-pill-blue-border",
	  "null": "q-pill-blue-border", // Has to be removed later
	  "Y": "q-pill-blue"
	};
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  var dataTableComponentData = mainEl.data("supplychain-lookup");
	  var portletNamespace = mainEl.data("portlet-namespace");
	  var filterLocationUrl = mainEl.data("location-filter-url");
	  //For the search drop down in lookup need to get the filter Criteria from Server
	  var shouldCheckCache = mainEl.data("should-check-cache");
	  var criteriaObjectFromServer = mainEl.data("filter-criteria-from-server");
	  //For the views - add/save/delete
	  var selectFromOrgModal = void 0;
	  var savedViews = mainEl.data("facility-saved-view");
	  var pageReloadUrl = mainEl.data("reload-url");
	  var saveViewURL = mainEl.data("save-view-url");
	  var deleteViewURL = mainEl.data("delete-view-url");
	  var exportUrl = mainEl.data("export-url");
	  var splExportUrl = mainEl.data("spl-export-url");
	  var deleteActionUrl = mainEl.data("delete-action-url");
	  var newMappingUrl = mainEl.data("new-mapping-url");
	  var returnTypes = mainEl.data("return-types-dropdown");
	  var classificationArray = mainEl.data("classification-dropdown");
	  var states = mainEl.data("states-dropdown");
	  var cmrAddresses = mainEl.data("ship-addresses-dropdown");
	  var bulkDeleteMappings = mainEl.data("bulk-delete-url");
	  var displayColumns = mainEl.data("display-columns");
	  var userInfo = mainEl.data("user-info");
	  var changeStatusURL = mainEl.data("change-status");
	  var editFacilityUrl = mainEl.data("edit-url");
	  var supplyChainConfig = mainEl.data("supply-chain-config");
	  var viewfacilityRenderUrl = mainEl.data("view-detail-url");
	  var viewSplfacilityRenderUrl = mainEl.data("view-spl-detail-url");
	  var pageRefreshUrl = mainEl.data("page-refresh-url");
	  var changeStatusBulkURL = mainEl.data("change-status-bulk");
	  var supplyChainConfigURL = mainEl.data("supply-chain-config-url");
	  var orderProcessGuideURL = mainEl.data("order-proccess-guide-url");
	  var inboundClassifcaionlist = mainEl.data("inbound-classfications");
	  var defaultFacTypeRms = mainEl.data("default-facilty-Types-rms");
	  var facilityTypeJson = mainEl.data("facility-types-json");
	  var facilityTypeJsonRms = mainEl.data("facility-types-json-rms");
	  var facilityTypeJsonHc = mainEl.data("facility-types-json-hc");
	  var facilityTypeJsonHcRms = mainEl.data("facility-types-json-hc-rms");
	  var tabName = mainEl.data("intial-tab-name");
	  var orgList = mainEl.data("org-list-url");
	  var orgStatus = mainEl.data("org-status-url");
	  var isAddPermission = mainEl.data("add-permission");
	  var isEditPermission = mainEl.data("edit-permission");
	  var facilitiesUomConfig = mainEl.data("facilities-uom-config");
	  var isSplUser = mainEl.data("is-spl-user");
	  var retailerFedexAccounts = mainEl.data("retailer-fedex-accounts");
	
	  var targetObject = "";
	  var selectedRows = "";
	  var rsaId = "";
	  var rsaIdDelete = "";
	  var loadDropDowns = "";
	  var organizationActiveCheckErrorModal = void 0;
	  var exportModal = new _filtersutil.buildExport();
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  generateOrganizationActiveCheckErrorModals();
	
	  $(".save-mapping-btn").on('click', onSaveMappingClick);
	  function onSaveMappingClick(e) {
	    newLocationModal.modal('hide');
	    submitModalFlow.showLoadingModal();
	    e.preventDefault();
	    $.ajax({
	      url: newMappingUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        rsaId: rsaId,
	        rsaType: $('#returnType').val(),
	        rsaState: $('#originalState').val(),
	        rsaShipToAddressId: $('#shipToAddress').val(),
	        rsaInboundClassification: $('#inboundClassification').val()
	      },
	      success: function success(data) {
	        if (data.response == "success") {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	        if (data.response == "error") {
	          submitModalFlow.hideAllModals();
	          newLocationModal.modal('show');
	          $(".show-on-error").show();
	        }
	      }
	    });
	  }
	
	  function getIndexValue() {
	    if (userInfo == "HONEYCOMB_RMS") {
	      return 1;
	    } else {
	      return 0;
	    }
	  }
	
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	
	  var facilityMappingLookup = new _index2.default({
	    // REQUIRED - Set a target element
	    target: $("#lookup-facilities-wrapper"),
	    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
	    minWidthClass: "q-min-width-sm-til-md",
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: [{
	      data: "cadLocationName",
	      title: "Facility Name",
	      render: createDetailLink
	    }, {
	      data: "cadActive",
	      title: "Status",
	      render: statusPillRender
	    }],
	    tableSearchInput: {
	      value: targetObject != "" ? targetObject.value[0] : ""
	    },
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _searchDropdown.searchDropdown
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    //tableSearchDropdown: true,
	    //savedViews: savedViews,
	    savedViews: savedViews,
	    newSavedViews: dataTableComponentData.newSavedViews !== undefined ? dataTableComponentData.newSavedViews : "",
	    newViewIndexOverride: getIndexValue(),
	    bulkSelect: false,
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      // scrollX: true, // Added scroll feature - HB-11056 - table header not working after adding this - check with Mike
	      data: dataTableComponentData.content,
	      columnDefs: [{ className: "custom-class", targets: [1] }],
	      order: [[8, 'desc']],
	      columns: [{
	        data: "cadId",
	        title: "Actions",
	        render: renderActionWrap,
	        orderable: false,
	        class: 'dtc-action-column'
	      }, {
	        data: "cadLocationName",
	        title: "Facility Name",
	        render: createDetailLink,
	        class: 'dtc-min-width-md'
	      }, {
	        data: "facilities.facBuildingType",
	        title: "Building Type",
	        orderable: false,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "cmrAddressAttributes",
	        title: "Facility Uses",
	        render: renderInboundClassificationSp,
	        orderable: false,
	        class: 'dtc-min-width-lg'
	      }, {
	        data: "cadOrganizationName",
	        title: "Organization Name",
	        class: 'dtc-min-width-md'
	      }, {
	        data: "cadAddressId",
	        title: "Facility ID",
	        orderable: false,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "cmrAddressAttributes",
	        title: "Facility Type",
	        render: renderInboundClassificationSp,
	        orderable: false,
	        class: 'dtc-min-width-lg'
	      }, {
	        data: "cadActive",
	        title: "Status",
	        render: statusPillRender,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "cadContactName",
	        title: "Contact Name",
	        orderable: false,
	        class: 'dtc-min-width-md'
	      }, {
	        data: "cadContactPhone",
	        title: "Contact Phone",
	        orderable: false,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "cadContactEmail",
	        title: "Contact Email",
	        orderable: false,
	        class: 'dtc-min-width-md'
	      }, {
	        data: "cadAddress1",
	        title: "Address",
	        orderable: false,
	        class: 'dtc-min-width-md'
	      }, {
	        data: "cadCity",
	        title: "City",
	        orderable: false,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "cadState",
	        title: "State",
	        orderable: false,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "cadZipcode",
	        title: "Postal Code",
	        orderable: false,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "cadCountry",
	        title: "Country",
	        orderable: false,
	        class: 'dtc-min-width-md'
	      }, {
	        data: "cadCreatedDate",
	        "visible": false
	      }]
	    },
	    paginationData: dataTableComponentData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Facilities",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "facilities"
	    },
	    onBulkSelectChange: function onBulkSelectChange() {
	      selectedRows = facilityMappingLookup.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass('disabled');
	      } else {
	        $(".action-header-btn .base-btn").addClass('disabled');
	      }
	    },
	
	    onFetch: function onFetch() {
	      var currentData = facilityMappingLookup.generateData();
	      tabName = currentData.savedViewTitle;
	      facilityMappingLookup.showLoadingOverlay();
	
	      handleToggleLookupSearchField(currentData.savedViewTitle);
	
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterLocationUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: deleteViewSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  function getCurrentActiveTab() {
	    return _(savedViews).findWhere({ active: true });
	  }
	
	  function handleToggleLookupSearchField(tabTitle) {
	    if (tabTitle && tabTitle != "Supply Chain") {
	      mainEl.find("#exportData").show();
	      showLookupSearchField();
	    } else {
	      if (isSplUser) {
	        mainEl.find("#exportData").show();
	      } else {
	        mainEl.find("#exportData").hide();
	      }
	      hideLookupSearchField();
	    }
	  }
	
	  function showLookupSearchField() {
	    mainEl.find(".table-top").show();
	  }
	
	  function hideLookupSearchField() {
	    mainEl.find(".table-top").hide();
	  }
	
	  // for the bulk select
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    // Changes for Supply Chain Config dropdown - Start
	    for (var i = 0; i < savedViews.length; i++) {
	      if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab" && !isSplUser) {
	        statusTarget = actionList["supplyTab"];
	      } else if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab" && isSplUser) {
	        statusTarget = actionList["splSupplyTab"];
	      } else if (savedViews[i].active == true && savedViews[i].tabtype == "FaciilitiesTab") {
	        statusTarget = actionList["actions"];
	      }
	    } // Changes for Supply Chain Config dropdown - End
	
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    //let statusTarget = actionList['all'];
	
	    var statusTarget = actionList["all"];
	    for (var i = 0; i < savedViews.length; i++) {
	      if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab") {
	        statusTarget = actionList["all-supplyTab"];
	        break;
	      }
	    }
	
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    var col = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row, col)
	    });
	    return newRender;
	  }
	
	  function createDetailLink(data, type, row) {
	    var returnString = "";
	    var tabType = "";
	    for (var i = 0; i < savedViews.length; i++) {
	      if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab") {
	        tabType = savedViews[i].tabtype;
	      } else {
	        tabType = savedViews[i].tabtype;
	      }
	    }
	    var html = "<div class=\"q-marg-all-xs-at-md\"><a href={%= viewfacilityRenderUrl %}&{%- portletNamespace%}cadId={%- cadId %} class='details-control anchor-text'>{%- facName %}</a></div>";
	    var splhtml = "<div class=\"q-marg-all-xs-at-md\"><a href={%= viewfacilityRenderUrl %}&{%- portletNamespace%}facilityId={%- cadId %} class='details-control anchor-text'>{%- facName %}</a></div>";
	    if ((0, _general.isTruthy)(isSplUser)) {
	      returnString = (0, _render2.default)(splhtml, {
	        data: data,
	        facName: data,
	        cadId: row.cadFacId,
	        portletNamespace: portletNamespace,
	        viewfacilityRenderUrl: viewSplfacilityRenderUrl
	      });
	    } else {
	      returnString = (0, _render2.default)(html, {
	        data: data,
	        facName: data,
	        cadId: row.cadId,
	        portletNamespace: portletNamespace,
	        viewfacilityRenderUrl: viewfacilityRenderUrl
	      });
	    }
	
	    return returnString;
	  }
	
	  function renderActionCellList(list, data, row, col) {
	    var renderedList = void 0;
	    renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: checkDisableForGivenAction(data, row, item.title)
	      });
	    });
	    return renderedList.join('');
	  }
	
	  function checkDisableForGivenAction(data, row, actionName) {
	    var isSupplyChainTab = false;
	    for (var i = 0; i < savedViews.length; i++) {
	      if (savedViews[i].active == true && savedViews[i].tabtype == "SupplyChainTab" && !isSplUser) {
	        isSupplyChainTab = true;
	        break;
	      }
	    }
	
	    if (isRowLevelActionCheck(data)) {
	      if (isEditPermission && !isSplUser) {
	        return false;
	      } else if (isSplUser) {
	        return true;
	      } else {
	        return true;
	      }
	    } else {
	      if (isSupplyChainTab) {
	        return true;
	      } else {
	        var allMatch = true;
	        var firstStatus = void 0;
	        _(selectedRows).map(function (item) {
	          if (firstStatus && firstStatus !== item.data.cadActive) {
	            allMatch = false;
	          } else {
	            firstStatus = item.data.cadActive;
	          }
	        });
	        return !allMatch;
	      }
	    }
	  }
	
	  function isRowLevelActionCheck(data) {
	    return (0, _general.isPresent)(data);
	  }
	
	  //for the bulk select end
	
	  //Methods used for the Filter and Success
	  function filterSuccessFun(data) {
	    var shipToAddresses = data.content;
	    var page = data.page;
	    facilityMappingLookup.setNewData(shipToAddresses);
	    facilityMappingLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    facilityMappingLookup.hideLoadingOverlay();
	    setExportData(facilityMappingLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var shipToAddresses = data.lookupOrgJSON.content;
	    var page = data.lookupOrgJSON.page;
	    facilityMappingLookup.setNewData(shipToAddresses);
	    facilityMappingLookup.setPaginationData(page);
	    facilityMappingLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    facilityMappingLookup.hideLoadingOverlay();
	    setExportData(facilityMappingLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var shipToAddresses = data.lookupOrgJSON.content;
	    var page = data.lookupOrgJSON.page;
	    facilityMappingLookup.setNewData(shipToAddresses);
	    facilityMappingLookup.setPaginationData(page);
	    facilityMappingLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    facilityMappingLookup.hideLoadingOverlay();
	    setExportData(facilityMappingLookup.generateData());
	  }
	
	  function deleteViewSuccessFun(data) {
	    var shipToAddresses = data.lookupOrgJSON.content;
	    var page = data.lookupOrgJSON.page;
	    facilityMappingLookup.removeSavedView(data.target);
	    facilityMappingLookup.setNewData(shipToAddresses);
	    facilityMappingLookup.setPaginationData(page);
	    facilityMappingLookup.hideLoadingOverlay();
	    setExportData(facilityMappingLookup.generateData());
	  }
	
	  function errorFun() {
	    //facilityMappingLookup.hideLoadingOverlay();
	    window.location.reload(true);
	  }
	  facilityMappingLookup.init();
	
	  var currentTab = getCurrentActiveTab();
	  if (currentTab) {
	    handleToggleLookupSearchField(currentTab.title);
	  }
	
	  //Method used for rendering the whole Inbound classification Text
	  /*function renderInboundClassification(row) {
	    return render("<span>{%- inboundClassificationText %} </span>", {
	      inboundClassificationText: fetchInboundText(classificationArray, row)
	    });
	  }
	    function fetchInboundText(classificationArray, row) {
	    const searchInbound = _.find(classificationArray, function (object) {
	      return (object.cdmValue == row);
	    });
	    return (searchInbound != null ? searchInbound.cdmMeaning : "");
	  }*/
	
	  function renderInboundClassificationSp(row) {
	    var facilityTypeArray = _(row).map(facilityTypeArrayTempSp);
	    var facilityTypeArrayResponse = void 0;
	    facilityTypeArrayResponse = _.filter(facilityTypeArray, function (entry) {
	      return entry && entry.trim() != '';
	    });
	    return facilityTypeArrayResponse.join(", ");
	  }
	
	  // HB-11056 - Merge Fulfillment Uses and Return Uses into one column - Facility Uses
	  function facilityTypeArrayTempSp(row) {
	    var data = row;
	    if (data.caaValue != null) {
	      var facData = facilityTypeJson;
	      var facHcRmsData = facilityTypeJsonHcRms;
	      var returnValue = '';
	      switch (data.caaKey) {
	        case 'standard_platform':
	          for (var i = 0; facData != null && i < facData.length; i++) {
	            if (data.caaValue != '' && facData[i].cdmValue == data.caaValue) {
	              returnValue = facData[i].cdmMeaning;
	            }
	          }
	        case 'fulfillment':
	          for (var _i = 0; facData != null && _i < facData.length; _i++) {
	            if (data.caaValue != '' && facData[_i].cdmValue == data.caaValue) {
	              returnValue = facData[_i].cdmMeaning;
	            }
	          }
	          break;
	        default:
	          for (var _i2 = 0; facHcRmsData != null && _i2 < facHcRmsData.length; _i2++) {
	            if (data.caaKey != '' && facHcRmsData[_i2].cdmMeaning == data.caaKey) {
	              returnValue = facHcRmsData[_i2].cdmValue;
	            }
	          }
	      }
	      return returnValue;
	    }
	  }
	
	  function facilityTypeArrayTempRC(data, facilityUse) {
	    if (data.caaValue != null) {
	      var facData = facilityTypeJson;
	      var facInData = facilityTypeJsonRms;
	      var returnValue = '';
	      var facHcData = facilityTypeJsonHc;
	      if (userInfo == "HONEYCOMB_RMS") {
	        for (var i = 0; i < facData.length; i++) {
	          if (data.caaValue != '' && data.caaKey == 'return' && facData[i].cdmValue == data.caaValue) {
	            returnValue = facData[i].cdmMeaning;
	          }
	        }
	      } else {
	        for (var _i3 = 0; _i3 < facInData.length; _i3++) {
	          if (data.caaValue == "true" && facInData[_i3].cdmMeaning == data.caaKey) {
	            returnValue = facInData[_i3].cdmValue;
	          }
	        }
	
	        for (var _i4 = 0; _i4 < facHcData.length; _i4++) {
	          if (data.caaKey != '' && facHcData[_i4].cdmMeaning == data.caaKey) {
	            returnValue = facHcData[_i4].cdmValue;
	          }
	        }
	      }
	
	      return returnValue;
	    }
	  }
	
	  function renderCityAndState(data, type, row) {
	    var cityAndStateHTML = "<span>{%- cityAndStateText %}</span>";
	
	    var cityAndStateHtnlRender = (0, _render2.default)(cityAndStateHTML, {
	      cityAndStateText: row.cadCity + "," + row.cadState
	    });
	    return cityAndStateHtnlRender;
	  }
	
	  //Render pill
	  function statusPillRender(data, type, row) {
	    var newRender = void 0;
	    var pillClass = pillStatusClasses[data];
	    if (data == "Y") {
	      data = "Active";
	    } else {
	      data = "Inactive";
	    }
	    return newRender = (0, _render2.default)(statusPillRenderTemplate, {
	      data: data,
	      pillClass: pillClass
	    });
	  }
	
	  // Export component integration.
	  function initExport() {
	    var exportObj = {
	      title: mainEl.data("export-popup-title"),
	      exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
	      exportMaxLimitLang: mainEl.data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent();
	  }
	
	  function setExportData(currentData) {
	    if (isSplUser) {
	      exportModal.buildExportBasicURL(splExportUrl, currentData);
	    } else {
	      exportModal.buildExportBasicURL(exportUrl, currentData);
	    }
	
	    exportModal.setExportCount(currentData.totalElements);
	  }
	  initExport();
	  setExportData(facilityMappingLookup.generateData());
	
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	  $('body').on('click', '.edit-location', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      var _location = row.data();
	      var cadId = "" + _location.cadId;
	      editFacilityCall(cadId);
	    }
	  });
	
	  function editFacilityCall(cadId) {
	    location.href = editFacilityUrl + "&cadId=" + cadId;
	  }
	
	  $('body').on('click', '.bulk-activate-rule', function (e) {
	    e.preventDefault();
	    if (!$(this).hasClass("disabled")) {
	      deactivateFacilitiesBulkCall(getAllSelectedOrgIds());
	    }
	  });
	
	  function getAllSelectedOrgIds() {
	    var cadIds = [];
	    _(selectedRows).map(function (item) {
	      var obj = {};
	      obj.cadId = item.data.cadId;
	      cadIds.push(obj);
	    });
	    return JSON.stringify(cadIds);
	  }
	
	  $('body').on('click', '.activate-rule', function (e) {
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      var facilities = row.data();
	      var cadId = "" + facilities.cadId;
	      var cadActive = "" + facilities.cadActive;
	      var cadOrganization = "" + facilities.cadOrganizationName;
	      deactivateFacilitiesCall(cadId, cadActive, cadOrganization);
	    }
	  });
	
	  function deactivateFacilitiesCall(cadId, cadActive, cadOrganization) {
	    var currentData = facilityMappingLookup.generateData();
	    var confirmModalBtnText = "Activate Facility";
	    var confirmModalTitle = "Activate Facility";
	    if (cadActive == 'Y') {
	      confirmModalBtnText = "Deactivate Facility";
	      confirmModalTitle = "Deactivate Facility";
	    }
	
	    if ("null" !== cadOrganization) {
	      validateOrgStatus(cadOrganization, confirmModalTitle, confirmModalBtnText, cadId);
	    } else {
	      changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId);
	    }
	  }
	
	  function validateOrgStatus(cadOrganization, confirmModalTitle, confirmModalBtnText, cadId) {
	    var orgStatus = void 0;
	    for (var i = 0; i < orgList.length; i++) {
	      if (orgList[i].orgName === cadOrganization) {
	        orgStatus = orgList[i].orgActive;
	      }
	    }
	    if (orgStatus && !_(orgStatus).isString()) {
	      changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId);
	    } else {
	      showOrganizationActiveErrorModal();
	    }
	  }
	  //end
	
	  function changeStatusCall(confirmModalTitle, confirmModalBtnText, cadId) {
	    var deactivateFacilityModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: confirmModalTitle,
	      confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
	      confirmModalBtnText: confirmModalTitle,
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        deactivateFacilityModal.showLoadingModal();
	        deactivateFacility({ url: changeStatusURL, success: deactivateSuccess, error: deactivateFailure });
	        function deactivateFacility(_ref) {
	          var url = _ref.url,
	              success = _ref.success,
	              error = _ref.error;
	
	          $.ajax({
	            url: url,
	            data: {
	              cadIds: cadId
	            },
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	          });
	        }
	        function deactivateSuccess() {
	          deactivateFacilityModal.showSuccessModal();
	          setTimeout(function () {
	            location.reload();
	          }, 3000);
	        }
	        function deactivateFailure() {
	          setTimeout(function () {
	            deactivateFacilityModal.hideAllModals();
	          }, 6000);
	        }
	      }
	    });
	    deactivateFacilityModal.init();
	    deactivateFacilityModal.showConfirmModal();
	  }
	
	  function deactivateFacilitiesBulkCall(cadId) {
	    var deactivateFacilityModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Deactivate Facility',
	      confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
	      confirmModalBtnText: 'Deactivate Facility',
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        deactivateFacilityModal.showLoadingModal();
	        deactivateFacility({ url: changeStatusBulkURL, success: deactivateSuccess, error: deactivateFailure });
	        function deactivateFacility(_ref2) {
	          var url = _ref2.url,
	              success = _ref2.success,
	              error = _ref2.error;
	
	          $.ajax({
	            url: url,
	            data: {
	              cadIds: cadId
	            },
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	          });
	        }
	        function deactivateSuccess() {
	          deactivateFacilityModal.showSuccessModal();
	          setTimeout(function () {
	            location.reload();
	          }, 3000);
	        }
	        function deactivateFailure() {
	          setTimeout(function () {
	            deactivateFacilityModal.hideAllModals();
	          }, 6000);
	        }
	      }
	    });
	    deactivateFacilityModal.init();
	    deactivateFacilityModal.showConfirmModal();
	  }
	
	  $('body').on('click', '.supply-tab-active', function (e) {
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      var facilities = row.data();
	      facId = "" + facilities.cadFacId;
	      facName = "" + facilities.cadLocationName;
	      getFacilitiesUomConfig(facilitiesUomConfig, facId); //Need to get facility UOM config first since retailer config can override default facility UOM config later
	      populateSupplychainConfigurationModal(facilities);
	
	      showOrganizationSelectModal();
	
	      $(function () {
	        $("#fedex-account").click(function () {
	          if ($(this).is(':checked')) {
	            $("#fedexAcntChecked").show();
	          } else {
	            $("#fedexAcntChecked").hide();
	          }
	        });
	      });
	    }
	  });
	
	  $(function () {
	    $("#returns-center").click(function () {
	      if ($(this).is(':checked')) {
	        if ($("#fedex-account").is(":checked")) {
	          $("#fedex-account1").show();
	          $("#fedexAcntChecked").show();
	        } else {
	          $("#fedex-account1").show();
	        }
	      } else {
	        $("#fedex-account1").hide();
	        $("#fedexAcntChecked").hide();
	      }
	      $("#fedex-account").click(function () {
	        if ($(this).is(':checked')) {
	          $("#fedexAcntChecked").show();
	        } else {
	          $("#fedexAcntChecked").hide();
	        }
	      });
	    });
	  });
	
	  var facName = "";
	  var facId = "";
	  generateModals(facName);
	
	  function generateModals(facName) {
	    selectFromOrgModal = $((0, _render2.default)(sharedModalHtml, {
	      title: 'Configure Supply Chain Facility',
	      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn save-changes-btn">Save Changes</a>',
	      body: (0, _render2.default)(__webpack_require__(300), {
	        facilityName: facName,
	        link: orderProcessGuideURL,
	        rmsFedexAccounts: getRenderedFedexAccounts(retailerFedexAccounts)
	      }),
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800"
	    }));
	    $('body').append(selectFromOrgModal);
	  }
	
	  function getRenderedFedexAccounts(retailerFedexAccountsList) {
	    var retailerFacilityHtml = '<option value="{%- retailerFedexAccountsListVal.cmtId %}">{%- retailerFedexAccountsListVal.cmtAccountNo %}</option>';
	    var response = _.map(retailerFedexAccountsList, function (retailerFedexAccountsListVal) {
	      return (0, _render2.default)(retailerFacilityHtml, {
	        retailerFedexAccountsListVal: retailerFedexAccountsListVal
	      });
	    });
	    return response.join("");
	  }
	
	  function uncheckAllCheckboxes() {
	    $('#fulfillment-center').prop('checked', false);
	    $('#distribution-center').prop('checked', false);
	    $('#returns-center').prop('checked', false);
	    $('#international-fulfillment-center').prop('checked', false);
	    $("#additional-units-of-measure").prop('checked', false);
	  }
	
	  function populateSupplychainConfigurationModal(data) {
	    var retailerAccountNumber = "";
	    var retailerHubId = "";
	    var retailerCadCmtId = "";
	
	    uncheckAllCheckboxes();
	    $(".facName").text(data.cadLocationName);
	    $(".facId").text(data.cadFacId);
	    $.each(data.cmrAddressAttributes, function (i, attribute) {
	      if (attribute.caaValue == 'FC') {
	        $('#fulfillment-center').prop('checked', true);
	      }
	      if (attribute.caaValue == 'DC') {
	        $('#distribution-center').prop('checked', true);
	      }
	      if (attribute.caaValue == 'RC') {
	        $('#returns-center').prop('checked', true);
	
	        for (var j = 0; j < retailerFedexAccounts.length; j++) {
	          if (data.cadCmtId == retailerFedexAccounts[j].cmtId) {
	            retailerAccountNumber = retailerFedexAccounts[j].fdxAccountNo;
	            retailerHubId = retailerFedexAccounts[j].cmtHubId;
	            retailerCadCmtId = retailerFedexAccounts[j].cmtId;
	          }
	        }
	
	        if (retailerHubId != null && retailerHubId != "" && retailerAccountNumber != null && retailerAccountNumber != "" && $('#returns-center').is(':checked')) {
	          $("#fedex-account1").show();
	          $('#fedex-account').attr('checked', true);
	        }
	        if ($('#fedex-account').is(':checked') && retailerHubId != null && retailerHubId != "" && retailerAccountNumber != null && retailerAccountNumber != "") {
	          $("#fedexAcntChecked").show();
	          $("#fedex-account-numbers").val(retailerCadCmtId).trigger("change");
	        }
	      } else {
	
	        if ($('#returns-center').is(':checked')) {
	          $("#fedex-account1").show();
	        }
	        if ($('#fedex-account1').is(':checked')) {
	          $("#fedexAcntChecked").show();
	        }
	      }
	      if (attribute.caaValue == 'IN') {
	        $('#international-fulfillment-center').prop('checked', true);
	      }
	      if (attribute.caaValue == 'UOM') {
	        $("#additional-units-of-measure").prop('checked', true);
	      }
	    });
	  }
	
	  function showOrganizationSelectModal() {
	    selectFromOrgModal.modal('show');
	  }
	
	  function hideOrganizationSelectModal() {
	    selectFromOrgModal.modal('hide');
	  }
	
	  $(document).on('click', '.save-changes-btn', saveSupplyChainConfig);
	
	  function saveSupplyChainConfig(e) {
	    e.preventDefault();
	    hideOrganizationSelectModal();
	    var submitModal = new _SubmitModalFlow2.default();
	    submitModal.init();
	    submitModal.showLoadingModal();
	    $.ajax({
	      url: supplyChainConfigURL,
	      data: {
	        facId: facId,
	        fulfillmentCenter: $("#fulfillment-center").is(":checked"),
	        distributionCenter: $("#distribution-center").is(":checked"),
	        internationalFulfillmentCenter: $("#international-fulfillment-center").is(":checked"),
	        returnsCenter: $("#returns-center").is(":checked"),
	        additionalUnitsOfMeasure: $("#additional-units-of-measure").is(":checked"),
	        cmtId: getFedexAccountNumber($("#fedex-account-numbers").val(), $("#returns-center").is(":checked"), $("#fedex-account").is(":checked"))
	      },
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        if (data.success == "Success") {
	          submitModal.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, 3000);
	        } else {
	          submitModal.showFailureModal();
	          setTimeout(function () {
	            location.href = pageRefreshUrl;
	          }, 3000);
	        }
	      }
	    });
	  }
	
	  function getFedexAccountNumber(fedexAccountValue, returnsCenterFlag, fedexAccountFlag) {
	    if (returnsCenterFlag && fedexAccountValue != null && fedexAccountFlag) {
	      return fedexAccountValue;
	    } else {
	      return "";
	    }
	  }
	
	  function generateOrganizationActiveCheckErrorModals() {
	    organizationActiveCheckErrorModal = $((0, _render2.default)(sharedModalHtml, {
	      title: 'Activate Facility Error',
	      footerBtns: '<a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Okay</a>',
	      body: "<div class=q-pad-all-xl>This facility is inactive due to it's organization being in an inactive status. In order to activate this facility you must first reactivate it's organization.</div>",
	      topCloseBtn: true,
	      autoHideTop: true,
	      modalDialogClass: "q-modal-dialog-800"
	    }));
	
	    $('body').append(organizationActiveCheckErrorModal);
	  }
	
	  function showOrganizationActiveErrorModal() {
	    organizationActiveCheckErrorModal.modal('show');
	  }
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  function getFacilitiesUomConfig(data, facId) {
	    _.each(data, function (facConfig) {
	      if (facConfig.facId == facId) {
	        if (facConfig.facUomEditable == 1) {
	          $("#additional-units-of-measure").prop('disabled', false);
	        } else {
	          $("#additional-units-of-measure").prop('disabled', true);
	        }
	      }
	    });
	  }
	});

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _famfLogic = __webpack_require__(206);
	
	var _famfLogic2 = _interopRequireDefault(_famfLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetSelector = "#fedex-accounts-management-form";
	
	// For quick dev prototyping
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachHtml(outerEl);
	});
	
	function attachHtml(outerEl) {
	  var famfLogicVar = new _famfLogic2.default(outerEl);
	  famfLogicVar.init();
	};

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(626);
	
	__webpack_require__(206);
	
	__webpack_require__(1087);

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _constants = __webpack_require__(10);
	
	var _filtersutil = __webpack_require__(16);
	
	var _fixitOrderLookupFieldDropdown = __webpack_require__(208);
	
	var _actionOptions = __webpack_require__(207);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	//import {SUCCESS_MODAL_TIMEOUT} from "../../constants";
	
	var _ = __webpack_require__(2);
	
	var modalHtml = __webpack_require__(11);
	
	var els = {};
	var elsModal = {};
	var elsModalMap = {};
	var elsMap = {
	  addOrderFormElement: ".manage-fixitorder-form",
	  submitOrderForm: ".submit-order-form",
	  cancelOrderForm: ".add-order-cancel-btn",
	  updateOrderForm: ".update-order-form",
	  oreStatus: "#oreStatus"
	};
	
	var targetAddOrderSelector = "#manage-fixit-orders";
	var customValidateProps = {
	  errorPlacement: function errorPlacement(error, element) {
	    var appendClosest = $(element).data('error-placement-append-closest');
	    if (appendClosest) {
	      $(element).closest(appendClosest).append(error);
	    } else {
	      error.insertAfter(element);
	    }
	  }
	};
	(0, _run2.default)(targetAddOrderSelector, function (outerEl) {
	  var $ = __webpack_require__(1);
	  var date = new Date();
	  var saveOrderUrl = outerEl.data("saveorder-url");
	  var cancelOrderUrl = outerEl.data("canceladdorder-url");
	  var editOrderFlag = outerEl.data("editorder");
	  var orderstatus = outerEl.data("orderstatus");
	  var checkVzwOrdNumIsDuplicateUrl = outerEl.data('check-vzwordnum-isduplicate-url');
	
	  function init() {
	    setElements();
	    bindElements();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elsMap, outerEl);
	  }
	
	  function bindElements() {
	    els.submitOrderForm.click(submitCreateOrderForm);
	    setDefaultValues();
	    els.updateOrderForm.click(submitCreateOrderForm);
	  }
	
	  function submitCreateOrderForm() {
	    var duplicateOrd = "false";
	    $(".manage-fixitorder-form").valid();
	
	    //validate vzworder already exists only for new order. true indicates vzworder already exists
	    if (editOrderFlag != undefined && editOrderFlag == "") {
	      $.ajax({
	        data: {
	          vzwOrderNum: $("#oreVzwOrder").val(),
	          vzwLocation: $("#oreVzwLocation").val(),
	          vzwSapDeliveryNum: $("#oreSapDeliveryNum").val(),
	          vzwSku: $("#oreSku").val()
	        },
	        url: checkVzwOrdNumIsDuplicateUrl,
	        async: false,
	        dataType: 'text',
	        type: 'POST',
	        success: function success(dataResponse) {
	          if (dataResponse != null) {
	            duplicateOrd = dataResponse;
	            if (dataResponse == "true") {
	              $("#oreDupOrder-exists-error").show();
	              return false;
	            } else if (dataResponse == "false") {
	              $("#oreDupOrder-exists-error").hide();
	            }
	          }
	        }
	      });
	    }
	
	    if ($("#oreOrderDateString").val().length == 0) {
	      $("#oreOrderDateString-error").show();
	      return;
	    } else {
	      //validate order date format.
	      var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
	      if (!date_regex.test($("#oreOrderDateString").val())) {
	        $("#oreOrderDateStringformat-error").show();
	        return false;
	      } else {
	        $("#oreOrderDateString-error").hide();
	        $("#oreOrderDateStringformat-error").hide();
	      }
	    }
	
	    //validate Error date
	    if ($("#oreErrorDateString").val().length == 0) {
	      $("#oreErrorDateString-error").hide();
	    } else {
	      //validate error date format.
	      var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
	      if (!date_regex.test($("#oreErrorDateString").val())) {
	        $("#oreErrorDateString-error").show();
	        return false;
	      } else {
	        $("#oreErrorDateString-error").hide();
	      }
	    }
	
	    //validate Shipped Date
	
	    if ($("#oreShippedDateString").val().length == 0) {
	      $("#oreShippedDateString-error").hide();
	    } else {
	      //validate shipped date format.
	      var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
	      if (!date_regex.test($("#oreShippedDateString").val())) {
	        $("#oreShippedDateString-error").show();
	        return false;
	      } else {
	        $("#oreShippedDateString-error").hide();
	      }
	    }
	
	    if ($(".manage-fixitorder-form").valid() && duplicateOrd == "false") {
	      $("#fixitOrderForm").submit();
	      var submitModalFlow = new _SubmitModalFlow2.default();
	      submitModalFlow.init();
	      submitModalFlow.showLoadingModal();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        submitModalFlow.hideAllModals();
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    }
	  }
	
	  function setDefaultValues() {
	    //By default set status to OPEN and disable the dropdown for new order.
	
	    if (editOrderFlag != undefined && editOrderFlag != "" && orderstatus != undefined && orderstatus != "") {
	      $("#oreStatus option").each(function () {
	        if (this.value == orderstatus) {
	          $(this).attr("selected", "selected");
	          return;
	        }
	      });
	    } else {
	      $("#oreStatus option").each(function () {
	        if (this.value == 'OPEN') {
	          $(this).attr("selected", "selected");
	          return;
	        }
	      });
	    }
	  }
	
	  $("#oreOrderDateString").on("change", function () {
	    if ($("#oreOrderDateString").val().length == 0) {
	      $("#oreOrderDateStringformat-error").hide();
	      $("#oreOrderDateString-error").show();
	      return;
	    } else {
	      $("#oreOrderDateString-error").hide();
	      //validate order date format.
	      var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
	      if (!date_regex.test($("#oreOrderDateString").val())) {
	        //$("#oreOrderDateString-error").show();
	        $("#oreOrderDateStringformat-error").show();
	        return false;
	      } else {
	        $("#oreOrderDateString-error").hide();
	        $("#oreOrderDateStringformat-error").hide();
	      }
	    }
	  });
	
	  $("#oreErrorDateString").on("change", function () {
	    if ($("#oreErrorDateString").val().length == 0) {
	      $("#oreErrorDateString-error").hide();
	    } else {
	      //validate error date format.
	      var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
	      if (!date_regex.test($("#oreErrorDateString").val())) {
	        $("#oreErrorDateString-error").show();
	        return false;
	      } else {
	        $("#oreErrorDateString-error").hide();
	      }
	    }
	  });
	
	  $("#oreShippedDateString").on("change", function () {
	    if ($("#oreShippedDateString").val().length == 0) {
	      $("#oreShippedDateString-error").hide();
	    } else {
	      //validate shipped date format.
	      var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
	      if (!date_regex.test($("#oreShippedDateString").val())) {
	        $("#oreShippedDateString-error").show();
	        return false;
	      } else {
	        $("#oreShippedDateString-error").hide();
	      }
	    }
	  });
	
	  $("#oreSku").on("change", function () {
	    if ($.trim($("#oreVzwOrder").val()).length != 0) {
	      //Make ajax call
	      isDuplicateVzOrder();
	    } else {
	      $("#oreDupOrder-exists-error").hide();
	    }
	  });
	
	  function isDuplicateVzOrder() {
	    $.ajax({
	      data: {
	        vzwOrderNum: $("#oreVzwOrder").val(),
	        vzwLocation: $("#oreVzwLocation").val(),
	        vzwSapDeliveryNum: $("#oreSapDeliveryNum").val(),
	        vzwSku: $("#oreSku").val()
	      },
	      url: checkVzwOrdNumIsDuplicateUrl,
	      async: false,
	      dataType: 'text',
	      type: 'POST',
	      success: function success(dataResponse) {
	        if (dataResponse != null) {
	          if (dataResponse == "true") {
	            $("#oreDupOrder-exists-error").show();
	            return false;
	          } else if (dataResponse == "false") {
	            $("#oreDupOrder-exists-error").hide();
	          }
	        }
	      }
	    });
	  }
	
	  init();
	
	  //check if class is disabled
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	});

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _constants = __webpack_require__(10);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	var _filtersutil = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var urllib = __webpack_require__(1576);
	
	var _ = __webpack_require__(2);
	var modalHtml = __webpack_require__(11);
	var targetSelector = "#fixitorder-details";
	var els = {};
	var elsModal = {};
	var elsModalMap = {};
	var elsMap = {
		createNewListModalCall: $("#create-new-list-modal-call"),
		maintainNewErrorModal: $("#maintain-add-new-error-modal"),
		errCodeField: $("#errCode"),
		errTypeField: $("#errtype")
	};
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	
		//Use this url to submit "New error" form data info to controller when user clicks on submit button on modal form.
		var saveNewErrorUrl = mainEl.data("savenewerror-url");
		var reqfieldsForErrorUrl = mainEl.data("reqfieldsurl-url"); //use this only to get the mandatory param values
		var getErrHistoryUrl = mainEl.data("errorhistory-url");
	
		//parse url to get mandatory param values
		var queryObject = urllib.parse(reqfieldsForErrorUrl, true).query;
	
		//capture details page url so that it can be used to reload after saving the error.
		var outerLocationUrl = location.href;
	
		var submitModalFlow = new _SubmitModalFlow2.default();
		submitModalFlow.init();
	
		//when user clicks on "Add error" button on details page, this function will be called and loads form to add new error
		$(".create-new-error-modal-call").click(function (event) {
			event.preventDefault();
	
			clearErrorOnSave();
	
			$("#errorModalTitle").text("Add Error");
			$("#currentevent").val("adderror");
			$("#oreId").val(queryObject._fixit_WAR_releaseorderportlet_oreId);
			$("#oreVzwOrder").val(queryObject._fixit_WAR_releaseorderportlet_oreVzwOrder);
			$("#errHdrId").val(queryObject._fixit_WAR_releaseorderportlet_errHdrId);
	
			//clear values and enable fields.
			$("#errCode").attr('disabled', false);
			$("#errtype").attr('disabled', false);
			$("#errNote").val("");
			$("#status option").each(function () {
				if (this.value == 'OPEN') {
					$(this).attr("selected", "selected");
					return;
				}
			});
			$("#status").val('OPEN');
			$("#status").attr('disabled', true);
	
			$("#rslCode option").each(function () {
				if (this.value == 'DEFAULT') {
					$(this).attr("selected", "selected");
					return;
				}
			});
	
			$("#rslCode").val("DEFAULT");
			$("#errtype").val("INTERFACE");
			$("#errCode").val("I0001");
	
			$("#maintain-add-new-error-modal").modal("show");
		});
	
		//when user clicks on submit button on "Add error" popup form, this function will be called to save the data to ufix
		$(".submit-add-error-btn").click(function (event) {
			event.preventDefault();
			var proceed = "true";
			var errTypeSel = $("#errtype").val();
			var errCodeSel = $("#errCode").val();
	
			//Only for new error, Validate user input for errorCode and errorType
			if ($("#currentevent").val() != undefined && $("#currentevent").val() == "adderror") {
				if (errTypeSel == "INTERFACE" && errCodeSel.indexOf('W') > -1) {
					proceed = "false";
					showErrorOnSave("Please select an Interface type Error");
				} else if (errTypeSel == "WMS" && errCodeSel.indexOf('I') > -1) {
					proceed = "false";
					showErrorOnSave("Please select an WMS type Error");
				} else {
					proceed = "true";
					clearErrorOnSave();
				}
			}
	
			//capture screen data
			var reqData = {
				"errtype": $("#errtype").val(),
				"errCode": $("#errCode").val(),
				"errCodeDesc": $("#errCode option:selected").text(),
				"rslCode": $("#rslCode").val(),
				"rslCodeDesc": $("#rslCode option:selected").text(),
				"errNote": $("#errNote").val(),
				"errStatus": $("#status").val(),
				"currentevent": $("#currentevent").val(),
				"oreId": $("#oreId").val(),
				"oreVzwOrder": $("#oreVzwOrder").val(),
				"errHdrId": $("#errHdrId").val()
			};
	
			if (proceed == "true") {
				$.ajax({
					url: saveNewErrorUrl,
					type: 'POST',
					data: reqData,
					dataType: 'JSON',
					async: true,
					success: function success(response) {
						if (response.status == "SUCCESS") {
							$("#maintain-add-new-error-modal").modal("hide");
							submitModalFlow.showLoadingModal();
	
							location.href = outerLocationUrl;
							location.reload(); //load the details page to display latest added error
							setTimeout(function () {
								submitModalFlow.hideAllModals();
							}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	
							submitModalFlow.showSuccessModal();
						} else {
							showErrorOnSave(response.errorMessage);
						}
					}, error: function error(response) {
						submitModalFlow.hideAllModals();
					}
				});
			}
		});
	
		//when user clicks on "Cancel" button on "Add Error" form of Details page.
		$(".cancel-adderror-modal-btn-with-inputs").click(function (event) {
			event.preventDefault();
			$("#maintain-add-new-error-modal").modal("hide");
		});
	
		//when user clicks on "Edit error" button on details page inrow with specific error, this function will be called and loads form prepopulated with error info.
		$(".edit-error-modal-call").click(function () {
			var dtlErrorCnt = $(this).attr('id').replace("edit-error-modal-call", "");
	
			$("#currentevent").val("editerror");
			$("#oreId").val(queryObject._fixit_WAR_releaseorderportlet_oreId);
			$("#oreVzwOrder").val(queryObject._fixit_WAR_releaseorderportlet_oreVzwOrder);
			$("#errHdrId").val(queryObject._fixit_WAR_releaseorderportlet_errHdrId);
	
			var errTypeId = "#dtlerrType" + dtlErrorCnt;
			var errTypeDivValue = $(errTypeId).html().trim();
	
			var divValue;
			var id = "#dtlerrCode" + dtlErrorCnt;
			var selectedErrCode = $(id).html().trim(); //ErrorCode with respect to editerror button selected by user.  
	
			//set ErrorType,ErrCode value and make them readonly
			if (selectedErrCode != "") {
	
				$("#errCode option").each(function () {
					if (this.value === selectedErrCode) {
						$(this).attr("selected", "selected");
						return;
					}
				});
				$("#errCode").attr('disabled', true);
				$("#errCode").val(selectedErrCode);
	
				//have the attribute selected.
				$("#errtype option").each(function () {
					if (this.value == errTypeDivValue) {
						$(this).attr("selected", "selected");
						return;
					}
				});
	
				if (errTypeDivValue == "INTERFACE") {
					$("#errtype").val("INTERFACE");
				} else if (errTypeDivValue == "WMS") {
					$("#errtype").val("WMS");
				}
	
				$("#errtype").attr('disabled', true);
			}
	
			id = "#dtlerrRsldesc" + dtlErrorCnt;
			divValue = $(id).html();
			//get the rslcode and set it
			if (divValue == " ") {
				//set to default.
				$("#rslCode").val("DEFAULT");
			} else {
				//set resolution to dropdown value
				id = "#dtlerrRslcode" + dtlErrorCnt;
				divValue = $(id).prop("class");
				$("#rslCode").val(divValue);
			}
	
			//set comment value
			id = "#dtlerrComment" + dtlErrorCnt;
			divValue = $(id).html();
			$("#errNote").val(divValue.trim()); //trimmed value populate.
	
	
			//set status value
			id = "#dtlerrStatus" + dtlErrorCnt;
			divValue = $(id).html().trim();
	
			$("#status").attr('disabled', false);
			$("#status").val(divValue);
			$("#status option").each(function () {
				if (this.value == divValue) {
					$(this).attr("selected", "selected");
					return;
				}
			});
	
			$("#errorModalTitle").text("Edit Error");
	
			//now show the adderror modal window
			$("#maintain-add-new-error-modal").modal("show");
		});
	
		//when use clicks on details button with respect to an error, display comments and resolution history info.
		$(".error-history-modal-call").click(function () {
			var dtlErrorHisCnt = $(this).attr('id').replace("error-history-modal-call", "");
		});
	
		function init() {
			setElements();
			//bindElements();
		}
	
		function setElements() {
			(0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
		}
	
		function showErrorOnSave(message) {
			$("#save-error-div-text").text(message);
			$("#save-error-div").removeClass('hidden');
		}
	
		function clearErrorOnSave() {
			$("#save-error-div-text").text("");
			$("#save-error-div").addClass('hidden');
		}
	
		function showErrorOnHistory(message) {
			$("#save-errorhis-div-text").text(message);
			$("#save-errorhis-div").removeClass('hidden');
		}
		function clearErrorOnHistory() {
			$("#save-errorhis-div-text").text("");
			$("#save-errorhis-div").addClass('hidden');
		}
	
		//when user clicks on "Details" button on details page inrow with specific error, this function will be called and loads form prepopulated with error history info.
		$(".error-history-modal-call").click(function () {
			var dtlErrorCnt = $(this).attr('id').replace("error-history-modal-call", "");
			var oreId = queryObject._fixit_WAR_releaseorderportlet_oreId;
			var errHdrId = queryObject._fixit_WAR_releaseorderportlet_errHdrId;
	
			//Get errorType from details page
			var errTypeId = "#dtlerrType" + dtlErrorCnt;
			var globalErrType = $(errTypeId).html();
	
			//Get errorCode from details page
			var id = "#dtlerrCode" + dtlErrorCnt;
			var globalErrCode = $(id).html().trim(); //Get ErrorCode from Details page with respect to editerror button selected by user. 
	
			id = "#dtlerrDesc" + dtlErrorCnt;
			var globalErrDesc = $(id).html().trim();
	
			//capture screen data
			var reqData = {
				"oreId": $("#oreId").val(),
				"oreVzwOrder": $("#oreVzwOrder").val(),
				"errHdrId": $("#errHdrId").val(),
				"errCode": globalErrCode,
				"errType": globalErrType
			};
	
			//make ajax call to get the history from UFIX service.
	
			$.ajax({
				url: getErrHistoryUrl,
				type: 'POST',
				data: reqData,
				dataType: 'JSON',
				async: true,
				success: function success(response) {
					if (response.status == "SUCCESS") {
						var globalRslDesc = "";
						var bodyHtml = "";
						var uFixResponse = jQuery.parseJSON(JSON.stringify(response.data));
						$("#errorHisCode").text(globalErrType + "-" + globalErrDesc);
	
						//build body starts
						//if details array has errnotes array it means there are comments without resolution. display them first.
	
						if (uFixResponse.errorDetails != undefined && uFixResponse.errorDetails.length > 0) {
							uFixResponse.errorDetails.forEach(function (errorinfo) {
								//outer notes without resolution
								if (errorinfo.errNotes != undefined) {
									errorinfo.errNotes.forEach(function (errorNote) {
										bodyHtml = bodyHtml + "<tr>";
										bodyHtml = bodyHtml + "<td>" + globalErrType + "</td>";
										bodyHtml = bodyHtml + "<td>" + globalErrDesc + "</td>";
										bodyHtml = bodyHtml + "<td></td>"; //ignore resolution
										bodyHtml = bodyHtml + "<td>" + errorNote.errNote + "</td>";
										bodyHtml = bodyHtml + "<td>" + errorNote.createdBy + "</td>";
										bodyHtml = bodyHtml + "<td>" + errorNote.createdTime + "</td>";
										bodyHtml = bodyHtml + "</tr>";
									});
								}
	
								//in the outer section if resolution array exists prepare those rows also.
								if (errorinfo.errResolution != undefined) {
									errorinfo.errResolution.forEach(function (resolution) {
										globalRslDesc = resolution.rslDesc;
										//iterate through notes and form remaining html
										if (resolution.errNotes != undefined) {
											resolution.errNotes.forEach(function (rslErrorNote) {
												bodyHtml = bodyHtml + "<tr>";
												bodyHtml = bodyHtml + "<td>" + globalErrType + "</td>";
												bodyHtml = bodyHtml + "<td>" + globalErrDesc + "</td>";
												bodyHtml = bodyHtml + "<td>" + globalRslDesc + "</td>"; //ignore resolution
												bodyHtml = bodyHtml + "<td>" + rslErrorNote.errNote + "</td>";
	
												if (rslErrorNote.createdBy != undefined) {
													bodyHtml = bodyHtml + "<td>" + rslErrorNote.createdBy + "</td>";
												} else {
													bodyHtml = bodyHtml + "<td></td>";
												}
												if (rslErrorNote.createdTime != undefined) {
													bodyHtml = bodyHtml + "<td>" + rslErrorNote.createdTime + "</td>";
												} else {
													bodyHtml = bodyHtml + "</tr>";
												}
											});
										}
									});
								}
							});
						} else {
							//no data to display
							showErrorOnHistory("No data found");
						}
	
						//build body ends
	
						$(".domain-table-tbody").empty().append(bodyHtml);
					} else {
						showErrorOnHistory(response.errorMessage);
					}
				}, error: function error(response) {
					showErrorOnHistory(response.errorMessage);
				}
			});
	
			$("#maintain-error-history-modal").modal("show");
		});
	
		//when user clicks on "Cancel" button on "Add Error" form of Details page.
		$(".cancel-error-history-modal-btn").click(function (event) {
			event.preventDefault();
			clearErrorOnHistory();
			$(".domain-table-tbody").empty();
			$("#maintain-error-history-modal").modal("hide");
		});
	
		//Validate user selection to make sure error type and error match
		$(document).on('change', '#errtype', function () {
			var errCodeSelected = $("#errCode option:selected").val();
			if (errCodeSelected != undefined) {
				if (this.value == "INTERFACE" && errCodeSelected.indexOf('W') > -1) {
					showErrorOnSave("Please select an Interface type Error");
				} else if (this.value == "WMS" && errCodeSelected.indexOf('I') > -1) {
					showErrorOnSave("Please select an WMS type Error");
				} else {
					clearErrorOnSave();
				}
			}
		});
	
		//Validate user selection to make sure error type and error match
		$(document).on('change', '#errCode', function () {
			var errTypeSelected = $("#errtype option:selected").val();
	
			if (errTypeSelected == "INTERFACE" && this.value.indexOf('W') > -1) {
				showErrorOnSave("Please select an Interface type Error");
			} else if (errTypeSelected == "WMS" && this.value.indexOf('I') > -1) {
				showErrorOnSave("Please select an WMS type Error");
			} else {
				clearErrorOnSave();
			}
		});
	
		init();
	});

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(628);
	
	__webpack_require__(631);
	
	__webpack_require__(629);

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _fixitOrderLookupFieldDropdown = __webpack_require__(208);
	
	var _actionOptions = __webpack_require__(207);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var loadOrderDetailsLinkHtml = __webpack_require__(1329);
	
	var actionList = _actionOptions.actionOptions;
	
	var targetSelector = "#fixit-order-lookup-outer";
	var addOrderBtn = "#fixit-add-order";
	var selectedErrDetRows = [];
	var selectedData = void 0;
	
	(0, _run2.default)(targetSelector, function () {
	  var entryElement = $(targetSelector);
	  var dataTableComponentData = entryElement.data("fixit-order-lookup-data");
	  var portletNamespace = $(targetSelector).data("portlet-namespace");
	  var savedViews = entryElement.data("saved-views");
	  var filterSearchUrl = $(targetSelector).data("filter-search-url");
	  var saveViewURL = $(targetSelector).data("save-view-url");
	  var deleteViewURL = $(targetSelector).data("delete-view-url");
	  var detailURL = $(targetSelector).data("fixit-order-detail-url");
	  var fixitOrderUrl = entryElement.data("fixit-order-url");
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	  var backToFormUrl = $(targetSelector).data("reload-addOrderform-url");
	
	  //Use this url to submit "Bulk Updare" form data info to controller when user clicks on submit button on modal form.
	  var bulkUpdateErrorRslUrl = $(targetSelector).data("bulkupdateerrorrslurl-url");
	  //capture details page url so that it can be used to reload after saving the error.
	  var outerLookupLocationUrl = location.href;
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var exportModal = new _filtersutil.buildExport();
	  var exportUrl = $(targetSelector).data("export-url");
	  var targetObject = "";
	
	  if (shouldCheckCache) {
	    //targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer, "like");
	    targetObject = retriveFixitCriteriaObjectByOperation(criteriaObjectFromServer, "like");
	
	    if (targetObject == null || targetObject == "") {
	      //search by IN
	      targetObject = retriveFixitCriteriaObjectByOperation(criteriaObjectFromServer, "in");
	    }
	  }
	
	  //Note: lookup row with empty ReasonCode indicates its header record which does not have any ufix errors yet
	  var fixitOrderLookup = new _index2.default({
	
	    target: $("#fixit-order-lookup-wrapper"),
	    minWidthClass: "q-min-width-sm-til-md",
	    mobileColumns: [{
	      data: "oreSiteIdDisplay",
	      title: "Site ID"
	    }, {
	      data: "oreVzwOrder",
	      title: "VZW Order Number",
	      render: createDetailLink
	    }, {
	      data: "oreSapDeliveryNum",
	      title: "SAP Delivery Number"
	    }, {
	      data: "errStatus",
	      title: "Status"
	    }, {
	      data: "oreCreatedDate",
	      title: "Date Recieved",
	      render: formatCreateDate
	    }],
	
	    tableSearch: true,
	    // REQUIRED: search input info
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: targetObject != "" ? targetObject.value : ""
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _fixitOrderLookupFieldDropdown.fixitOrderLookupFieldDropdown
	    },
	    // OPTIONAL: Set Saved View Array
	    savedViews: savedViews,
	    bulkSelect: true,
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      // Not required, just to show you can
	      columnDefs: [{}],
	      // Not required, just to show you can
	      order: [[3, 'desc']],
	      columns: [{
	        data: "oreId",
	        render: renderActionWrap,
	        orderable: false,
	        title: "Actions",
	        class: "dtc-action-column"
	        //"visible": false
	      },
	      // {
	      //   data: "oreSiteId",
	      //   title: "Site ID",
	      //   class: "dtc-min-width-sm",
	      // },
	      {
	        data: "oreSiteIdDisplay",
	        title: "Site ID",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreVzwLocation",
	        title: "VZW Location",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreVzwOrder",
	        title: "VZW Order",
	        class: "dtc-min-width-sm",
	        render: createDetailLink,
	        orderable: false
	      }, {
	        data: "oreFscOrder",
	        title: "FSC Order",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreSapDeliveryNum",
	        title: "SAP Delivery Number",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "errDesc",
	        title: "Reason Code",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreSku",
	        title: "SKU",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreQty",
	        title: "QTY",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreOrderDate",
	        title: "Order Date",
	        class: "dtc-min-width-sm",
	        render: formatCreateDate,
	        orderable: false
	      }, {
	        data: "oreShipMethod",
	        title: "Orig Ship Method",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreAddress1",
	        title: "Address1",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreAddress2",
	        title: "Address2",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreCity",
	        title: "City",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreState",
	        title: "ST",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreZip",
	        title: "Zip Code",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreMdn",
	        title: "MDN",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "vzwResolveDate",
	        title: "VZW Resolve Date",
	        class: "dtc-min-width-sm",
	        orderable: false
	        //,render: formatCreateDate
	      }, {
	        data: "vzwResolutionDisplay",
	        title: "VZW Resolution",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "lastVzwReslnComment",
	        title: "Last VZW Comment",
	        class: "dtc-min-width-lg q-break-word",
	        orderable: false
	      }, {
	        data: "lastVzwReslnCommentOn",
	        title: "Last Comment On",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "lastVzwReslnCommentBy",
	        title: "Last Comment By",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreCollateral",
	        title: "Collateral Only",
	        class: "dtc-min-width-sm",
	        render: formatCollateral,
	        orderable: false
	      }, {
	        data: "oreHoldRelease",
	        title: "Hold/Release",
	        class: "dtc-min-width-sm",
	        render: formatHR,
	        orderable: false
	      }, {
	        data: "oreAtp",
	        title: "ATP",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "FscResolutionDisplay",
	        title: "FSC Resolution",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "lastFscComment",
	        title: "Last FSC Comment",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "lastFscCommentOn",
	        title: "Last Comment On",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "lastFscCommentBy",
	        title: "Last Comment By",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "orePhoneService",
	        title: "Phone Service",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreMin",
	        title: "Min",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreErrorDate",
	        title: "Error Date",
	        class: "dtc-min-width-sm",
	        render: formatCreateDate,
	        orderable: false
	      }, {
	        data: "oreShippedDate",
	        title: "Shipped Date",
	        class: "dtc-min-width-sm",
	        render: formatCreateDate,
	        orderable: false
	      }, {
	        data: "oreArea",
	        title: "Area",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreTypeCode",
	        title: "TypeCode",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreSalesId",
	        title: "Sales ID",
	        class: "dtc-min-width-sm",
	        orderable: false
	      }, {
	        data: "oreAppleOrder",
	        title: "Apple Ordder",
	        class: "dtc-min-width-sm",
	        orderable: false
	      },
	
	      // {
	      //       data: "oreCreatedDate",
	      //       title: "Date Received",
	      //       render: formatCreateDate,
	      //       class: 'dtc-min-width-sm'
	      //     },
	      {
	        data: "errStatus",
	        title: "Status",
	        class: 'dtc-min-width-sm',
	        orderable: false
	      }]
	    },
	    paginationData: dataTableComponentData.page,
	
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Fixit Orders ",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "fixitOrder"
	    },
	
	    onBulkSelectChange: function onBulkSelectChange() {
	      var selectedRows = fixitOrderLookup.getBulkSelectedData();
	
	      //When user selects two rows, Actions header is enabled and highlighted
	      /* $("th.dtc-action-column").html(renderActionHeaderWrap());
	       if (selectedRows.length >= 2) {
	         $(".action-header-btn .base-btn").removeClass('disabled');        
	       } else {
	         $(".action-header-btn .base-btn").addClass('disabled');        
	       }*/
	    },
	
	    onFetch: function onFetch() {
	      var currentData = fixitOrderLookup.generateData();
	      fixitOrderLookup.showLoadingOverlay();
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterSearchUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  function formateDate(createdDate, type, data) {
	    if (createdDate != null && createdDate != "") {
	      var date = moment(createdDate).toDate(); // format yyyy-MM-DD
	      var month = date.getMonth() + 1;
	      var today = new Date();
	      today.setHours(0, 0, 0, 0);
	      date.setHours(0, 0, 0, 0);
	      var oneDay = 24 * 60 * 60 * 1000;
	      var diffDays = Math.round(Math.abs((today.getTime() - date.getTime()) / oneDay));
	      var friendlyText = "";
	      var datePillHTML = "";
	      if (diffDays < 100) {
	        friendlyText = diffDays.toString() + ' Days Ago';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      }
	      if (diffDays == 0) {
	        friendlyText = 'Today';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      } else if (diffDays == 1) {
	        friendlyText = 'Yesterday';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      }
	      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
	    } else {
	      return "";
	    }
	  }
	
	  function formatCreateDate(createdDate, type, data) {
	    if (createdDate != null && createdDate != "") {
	      var d = new Date(createdDate);
	      return d.toLocaleString();
	    } else {
	      return "";
	    }
	  }
	
	  function formatCollateral(collertal, type, data) {
	    if (collertal != null && collertal == '1') {
	      return "Yes";
	    } else {
	      return "No";
	    }
	  }
	
	  function formatHR(rowvalue, type, data) {
	    if (rowvalue == 'R') {
	      return "Release";
	    } else {
	      return "Hold";
	    }
	  }
	
	  function createDetailLink(data, type, row) {
	    var detailPageHTML = '<div class="q-marg-all-xs-at-md">\n                        <a href="' + detailURL + '&' + portletNamespace + 'oreId=' + row.oreId + '">\n                        ' + row.oreVzwOrder + ' </a> </div>';
	    return detailPageHTML;
	  }
	
	  function formateDate(dateReceived, type, data) {
	    if (dateReceived != null && dateReceived != "") {
	      var date = new Date(dateReceived);
	      var month = date.getMonth() + 1;
	      var today = new Date();
	      var oneDay = 24 * 60 * 60 * 1000;
	      today.setHours(0, 0, 0, 0);
	      date.setHours(0, 0, 0, 0);
	      var diffDays = Math.round(Math.abs((today.getTime() - date.getTime()) / oneDay));
	      var friendlyText = "";
	      var datePillHTML = "";
	      if (diffDays < 100) {
	        friendlyText = diffDays.toString() + ' Days Ago';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      }
	      if (diffDays == 0) {
	        friendlyText = 'Today';
	      } else if (diffDays == 1) {
	        friendlyText = 'Yesterday';
	      }
	      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
	    } else {
	      return "";
	    }
	  }
	
	  function filterSuccessFun(data) {
	    var fixitOrders = data.content;
	    var page = data.page;
	    fixitOrderLookup.setNewData(fixitOrders);
	    fixitOrderLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    fixitOrderLookup.hideLoadingOverlay();
	    setExportData(fixitOrderLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var fixitOrders = data.lookupReleaseOrderJSON.content;
	    var page = data.lookupReleaseOrderJSON.page;
	    fixitOrderLookup.setNewData(fixitOrders);
	    fixitOrderLookup.setPaginationData(page);
	    fixitOrderLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    fixitOrderLookup.hideLoadingOverlay();
	    setExportData(fixitOrderLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var fixitOrders = data.lookupReleaseOrderJSON.content;
	    var page = data.lookupReleaseOrderJSON.page;
	    fixitOrderLookup.setNewData(fixitOrders);
	    fixitOrderLookup.setPaginationData(page);
	    fixitOrderLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    fixitOrderLookup.hideLoadingOverlay();
	    setExportData(fixitOrderLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var fixitOrders = data.lookupReleaseOrderJSON.content;
	    var page = data.lookupReleaseOrderJSON.page;
	    fixitOrderLookup.removeSavedView(data.target);
	    fixitOrderLookup.setNewData(fixitOrders);
	    fixitOrderLookup.setPaginationData(page);
	    fixitOrderLookup.hideLoadingOverlay();
	    setExportData(fixitOrderLookup.generateData());
	  }
	
	  function errorFun(data) {
	    fixitOrderLookup.hideLoadingOverlay();
	  }
	
	  fixitOrderLookup.init();
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  $("body").on("click", ".fixit-order", function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      // Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
	      var pIndex = $(this).closest(".dropdown-menu").data("parent-index");
	      // Get the row based on the parent...
	      var parent = $(".dropdown-parent-" + pIndex).parents("tr");
	
	      // Get the row data
	      var row = $(".data-table-component").dataTable().api().row(parent);
	
	      if ($(this).hasClass("fixit-order")) {
	        processFixitOrder(row);
	      }
	    }
	  });
	
	  function processFixitOrder(row) {
	    var submitModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: "Fixit Order(s)",
	      confirmModalBody: '<div class="q-marg-all-xl">\n                          <div class="q-marg-vert-md">\n                            Confirming the manual release of this Order(s) will trigger it\'s original release process.\n                          </div>\n                          <div class="q-marg-vert-md">\n                            Once released, order status will be updated.\n                          </div>\n                        </div>',
	      confirmModalBtnText: "Release",
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        submitModal.showLoadingModal();
	        var data = row.data();
	        releaseOrder(row, data);
	
	        function releaseOrder(row, releaseOrder) {
	          $.ajax({
	            url: releaseOrderUrl,
	            type: "POST",
	            dataType: "JSON",
	            data: {
	              oreId: releaseOrder.oreId
	            },
	            success: function success(data) {
	              if (data.response === "success") {
	                submitModal.showSuccessModal();
	                setTimeout(function () {
	                  location.reload();
	                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	              } else {
	                submitModal.showFailureModal();
	              }
	            },
	            error: function error(data) {
	              submitModal.showFailureModal();
	            }
	          });
	        }
	      }
	    });
	    submitModal.init();
	    submitModal.showConfirmModal();
	  }
	
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    var statusTarget = actionList["all"];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, item));
	    });
	    return renderedList.join("");
	  }
	
	  function neededActions(data, row, item) {
	    var action = {
	      icon: item.icon,
	      title: item.title,
	      cls: item.cls,
	      disabled: item.disabled
	    };
	    return action;
	  }
	
	  function initExport() {
	    var exportObj = {
	      title: $(targetSelector).data("export-popup-title"),
	      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
	      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent(portletNamespace);
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(exportUrl, currentData, portletNamespace);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  initExport();
	  setExportData(fixitOrderLookup.generateData());
	
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	
	  function showAddOrderModal() {
	    $("#add-validation-model").modal("show");
	  }
	
	  function hideAddOrderModal() {
	    $("#add-validation-model").modal("hide");
	  }
	
	  // when user clicks on "Bulk Update" button on lookup page after selecting ufix errors,
	  // this function will be called and loads bulk resolution update form for user submission.
	  $(".btn-bulk-update-modal-call").click(function () {
	
	    //make sure atleast one row is selected on lookup table.
	    var selectedRows = fixitOrderLookup.getBulkSelectedData();
	    selectedData = [];
	
	    //prepare update request json
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = selectedRows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var ordDetRow = _step.value;
	
	        //push only the selected rows which has error associated with it.
	        if (ordDetRow.data.errDetId != undefined) {
	          selectedData = {
	            ufixErrHdrId: ordDetRow.data.ufixErrHdrId,
	            ufixErrDetId: ordDetRow.data.errDetId
	          };
	          selectedErrDetRows.push(selectedData);
	        }
	      }
	
	      //show bulk update modal window
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    if (selectedErrDetRows.length > 0) {
	      $("#errNote").val("");
	      $("#maintain-bulk-update-error-modal").modal("show");
	    } else {
	      alert("Select atleast one valid row and retry.");
	    }
	  });
	
	  //when user clicks on "Cancel" button on "Bulk Update" form of Lookup page.
	  $(".cancel-bulkupdate-modal-btn-with-inputs").click(function (event) {
	    event.preventDefault();
	    $("#maintain-bulk-update-error-modal").modal("hide");
	
	    //Clear fields
	    $("#rslCode").val("DEFAULT");
	    $("#errNote").val("");
	  });
	
	  //when user clicks on submit button on "Bulk Update" popup form, this function will be called to update the data to ufix
	  $(".submit-bulkupdate-btn").click(function (event) {
	    var proceed = "true";
	    var errResolutionCodeSel = $("#rslCode").val();
	    var errResolutionDescSel = $("#rslCode option:selected").text();
	    var errResolutionNote = $("#errNote").val().trim();
	
	    if (errResolutionCodeSel != undefined && errResolutionCodeSel != "DEFAULT" && errResolutionNote != undefined && errResolutionNote != "") {
	      proceed = "true";
	      clearErrorOnBulkupdate();
	    } else {
	      proceed = "false";
	      showErrorOnBulkupdate("Please select Resolution Code and provide Resolution comment and try again.");
	    }
	
	    if (proceed == "true") {
	      var reqData = {
	        "rslCode": errResolutionCodeSel,
	        "rslDesc": errResolutionDescSel,
	        "rslNote": errResolutionNote,
	        "bulkErrDetList": selectedErrDetRows
	      };
	
	      $.ajax({
	        url: bulkUpdateErrorRslUrl,
	        type: 'POST',
	        data: {
	          bulkUpdateData: JSON.stringify(reqData)
	        },
	        // beforeSend: function () {
	        //   $.blockUI({ message: 'Submitting, Please Wait..' });
	        // },
	        // complete: function () {
	        //   $.unblockUI();
	        // },
	        dataType: 'JSON',
	        async: true,
	        success: function success(response) {
	          if (response.status == "SUCCESS" || response.status == "Success") {
	            $("#maintain-bulk-update-error-modal").modal("hide");
	            submitModalFlow.showLoadingModal();
	
	            location.href = outerLookupLocationUrl;
	            location.reload(); //load the lookup page to display latest data
	
	            setTimeout(function () {
	              submitModalFlow.hideAllModals();
	            }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	
	            submitModalFlow.showSuccessModal();
	          } else {
	            showErrorOnBulkupdate(response.errorMessage);
	          }
	        }, error: function error(response) {
	          submitModalFlow.hideAllModals();
	        }
	      });
	    }
	  });
	
	  function clearErrorOnBulkupdate() {
	    $("#bulkupdate-error-div-text").text("");
	    $("#bulkupdate-error-div").addClass('hidden');
	  }
	
	  function showErrorOnBulkupdate(message) {
	    $("#bulkupdate-error-div-text").text(message);
	    $("#bulkupdate-error-div").removeClass('hidden');
	  }
	
	  function retriveFixitCriteriaObjectByOperation(searchCriteria, operationName) {
	    var targetObj = "";
	    var val = "";
	    $.each(searchCriteria, function (i, item) {
	      if (item.operation == operationName && item.key != "attrValue") {
	        //remove square braces. they cause issue when page refreshed.
	        if (item.value.indexOf('[') > -1) {
	          val = item.value.replace('[', '');
	          item.value = val;
	          if (item.value.indexOf(']') > -1) {
	            val = val.replace(']', '');
	            item.value = val;
	          }
	        }
	        targetObj = item;
	      }
	    });
	    return targetObj;
	  }
	});

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _fxoConfigurationWizardLogic = __webpack_require__(209);
	
	var _fxoConfigurationWizardLogic2 = _interopRequireDefault(_fxoConfigurationWizardLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: make the target selector a place on the webpage where you want to import this
	var targetSelector = "#fxo-config-form";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachHtml(outerEl);
	});
	
	function attachHtml(outerEl) {
	  var fxoConfigurationWizardLogicVar = new _fxoConfigurationWizardLogic2.default(outerEl);
	  fxoConfigurationWizardLogicVar.init();
	};

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(632);
	
	__webpack_require__(209);
	
	__webpack_require__(1108);

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _fxoReceivingHomePageLogic = __webpack_require__(210);
	
	var _fxoReceivingHomePageLogic2 = _interopRequireDefault(_fxoReceivingHomePageLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var targetSelector = "#fxo-search-retailer-name";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachHtml(outerEl);
	});
	
	function attachHtml(outerEl) {
	  var fxoReceivingHomePageLogic = new _fxoReceivingHomePageLogic2.default(outerEl);
	  fxoReceivingHomePageLogic.init();
	};

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _fxoReceivingScreenLogic = __webpack_require__(211);
	
	var _fxoReceivingScreenLogic2 = _interopRequireDefault(_fxoReceivingScreenLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: make the target selector a place on the webpage where you want to import this
	var targetSelector = "#fxo-receiving-screen";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachHtml(outerEl);
	});
	
	function attachHtml(outerEl) {
	  var fxoReceivingScreenLogic = new _fxoReceivingScreenLogic2.default(outerEl);
	  fxoReceivingScreenLogic.init();
	};

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(635);
	
	__webpack_require__(211);
	
	__webpack_require__(179);
	
	__webpack_require__(634);
	
	__webpack_require__(210);

/***/ },
/* 637 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "actions": [{
	    title: "Reprint Label",
	    cls: "view-label",
	    icon: "file-text-o",
	    disabled: false
	  }, {
	    title: "Customer Receipt & OTP",
	    cls: "receipt-tacking",
	    icon: "file-text-o",
	    disabled: false
	  }]
	};

/***/ },
/* 638 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var receiptsLookupFieldDropdown = exports.receiptsLookupFieldDropdown = [{
		title: "By RMA Number",
		value: "rmaNumber"
	}, {
		title: "By Serial Number",
		value: "serialNumber"
	}];

/***/ },
/* 639 */
[1582, 640],
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _rmaLookupFieldDropdown = __webpack_require__(638);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	var _actionOptions = __webpack_require__(637);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	var targetSelector = "#lookup-receipts";
	//import {dataTableComponentData, dataTableNewData} from "../../components/lookupTable/stores/testData.js";
	
	var actionList = _actionOptions.actionOptions;
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var statusPillRenderTemplate = __webpack_require__(187);
	var detailLinkHTML = __webpack_require__(84);
	
	(0, _run2.default)(targetSelector, function () {
		var entryElement = $(targetSelector);
		var savedViews = $(targetSelector).data("saved-views");
		var saveViewURL = $(targetSelector).data("save-view-url");
		var deleteViewURL = $(targetSelector).data("delete-view-url");
		var portletNamespace = $(targetSelector).data("portlet-namespace");
		var dataTableComponentData = $(targetSelector).data("receipts");
		var filterReceiptsURL = $(targetSelector).data("filter-receipts-url");
		var generateLabelURL = $(targetSelector).data("generate-label-url");
		var generateFxoReceiptURL = $(targetSelector).data("generate-fxo-receipt-url");
	
		var targetObject = "";
		var totalRecordCount = 0;
		var rmaMobileColumns = "";
	
		var selectedRows = "";
	
		function createCustomerName(data, type, row) {
			var newRender = void 0;
			newRender = (0, _render2.default)(customerNameTemplate, {
				firstname: row.rmaFromFirstName,
				lastname: row.rmaFromLastName
			});
			return newRender;
		}
	
		function formateDate(createdDate, type, data) {
			if (createdDate != null && createdDate != "") {
				var date = moment(createdDate).toDate(); // format yyyy-MM-DD
				var month = date.getMonth() + 1;
				var today = new Date();
				today.setHours(0, 0, 0, 0);
				date.setHours(0, 0, 0, 0);
				var oneDay = 24 * 60 * 60 * 1000;
				var diffDays = Math.round(Math.abs((today.getTime() - date.getTime()) / oneDay));
				var friendlyText = "";
				var datePillHTML = "";
				if (diffDays < 100) {
					friendlyText = diffDays.toString() + ' Days Ago';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				}
				if (diffDays == 0) {
					friendlyText = 'Today';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				} else if (diffDays == 1) {
					friendlyText = 'Yesterday';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				}
				return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
			} else {
				return "";
			}
		}
	
		var defaultMobileColumns = [{
			data: "rmaNumber",
			title: "RMA Number",
			class: 'dtc-min-width-sm'
		}, {
			data: "customerName",
			title: "Customer",
			class: 'dtc-min-width-md'
	
		}, {
			data: "itemsReturned",
			title: "Total Pieces Returned",
			class: 'dtc-min-width-md'
		}, {
			data: "returnDate",
			title: "Created on",
			class: 'dtc-min-width-md'
		}];
	
		var receiptsLookup = new _index2.default({
			// REQUIRED - Set a target element
			target: $("#lookup-receipts-wrapper"),
			// REQUIRED - Set which data should be visible for mobile
			mobileColumns: defaultMobileColumns,
			tableSearchInput: {
				// placeholder: 'Custom Search Text'
				value: targetObject != "" ? targetObject.value[0] : ""
			},
			tableSearchDropdown: {
				selected: targetObject == "" ? "" : targetObject.key,
				columns: _rmaLookupFieldDropdown.receiptsLookupFieldDropdown
			},
			newSavedViews: false,
			bulkSelect: false,
			savedViews: savedViews,
			dataTable: {
	
				data: dataTableComponentData.receipts,
				columnDefs: [],
				order: [[4, 'desc']],
				columns: [{
					data: "rmaNumber",
					render: renderActionWrap,
					title: "Actions",
					orderable: false,
					class: 'dtc-action-column'
				}, {
					data: "rmaNumber",
					title: "RMA Number",
					orderable: false,
					class: 'dtc-min-width-sm'
				}, {
					data: "customerName",
					title: "Customer",
					orderable: false,
					class: 'dtc-min-width-md'
	
				}, {
					data: "itemsReturned",
					title: "Total Pieces Returned",
					orderable: false,
					class: 'dtc-min-width-md'
	
				}, {
					data: "returnDate",
					title: "Created on",
					orderable: false,
					class: 'dtc-min-width-md',
					render: formateDate
	
				}]
			},
			paginationData: dataTableComponentData.pagination,
			filterModal: {
				// REQUIRED: Sets title of modal
				title: "Filter Returns",
				// REQUIRED: Sets unique part of subtitle string.
				tableType: "rma"
			},
			onFetch: function onFetch() {
				var currentData = receiptsLookup.generateData();
				receiptsLookup.showLoadingOverlay();
				if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterReceiptsURL, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				}
			}
		});
	
		function filterSuccessFun(data) {
			var receipts = data.receipts;
			var page = data.pagination;
			receiptsLookup.setNewData(receipts);
			receiptsLookup.setPaginationData(page);
			receiptsLookup.hideLoadingOverlay();
		}
	
		function errorFun(data) {
			receiptsLookup.hideLoadingOverlay();
		}
	
		receiptsLookup.init();
	
		function renderActionWrap(data, type, row, meta) {
			var newRender = void 0;
			var statusTarget = actionList["actions"];
			newRender = (0, _render2.default)(actionCellDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row),
				index: meta.row
			});
			return newRender;
		};
	
		function renderActionCellList(list, data, row) {
			var renderedList = void 0;
			renderedList = _(list).map(function (item) {
				return (0, _render2.default)(actionCellDropdownItemTemplate, {
					icon: item.icon,
					title: item.title,
					cls: item.cls,
					disabled: false
				});
			});
			return renderedList.join('');
		};
	
		$('body').on('click', '.view-label ', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				var parent = $(".dropdown-parent-" + pIndex).parents('tr');
				var row = $(".data-table-component").dataTable().api().row(parent);
				var url = generateLabelURL + "&rmaIdForShipping=" + row.data().recrmaIds + "&rmaReceivingType=" + row.data().rmaReceivingType;
				window.open(url);
			}
		});
	
		$('body').on('click', '.receipt-tacking ', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				var parent = $(".dropdown-parent-" + pIndex).parents('tr');
				var row = $(".data-table-component").dataTable().api().row(parent);
				var url = generateFxoReceiptURL + "&rmaId=" + row.data().recrmaIds;
				window.open(url);
			}
		});
	
		function shallAllowClick(currentObj) {
			return !$(currentObj).hasClass("disabled");
		}
	
		// Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information...
		(0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
		//  $("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _general = __webpack_require__(5);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	var guidesRatingSelector = ".guide-article-outer-container";
	
	(0, _run2.default)(guidesRatingSelector, function (guideRatingEl) {
	  attachGuideRating(guideRatingEl);
	});
	
	function attachGuideRating(guideRatingEl) {
	
	  var guideRatingsEl = guideRatingEl.find('.guides-ratings-content');
	  var guideRatings = new _QuickBtnGroup2.default(guideRatingsEl);
	  var guideRatingsBtn = guideRatingEl.find('.guide-ratings-btn a');
	  guideRatingEl.find('#guide-rating-select-message').hide();
	  guideRatings.init();
	
	  // RESET AVERAGE RATINGS MODAL
	  var ratingSubmitModalFlow = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Reset Average Rating',
	    // confirmModalSubtitle: "Optional Subtitle",
	    confirmModalBody: '<div class="q-pad-all-xl">Are you sure you want to reset this guides Average Rating?</div>',
	    confirmModalBtnText: 'Reset Rating',
	    onConfirmClick: function onConfirmClick() {
	      // Show Loading Modal      
	      ratingSubmitModalFlow.showLoadingModal();
	
	      $.ajax({
	        url: $("#displayContent").data("reset-rating-url"),
	        datatype: 'json',
	        data: {
	          classPK: guideRatingEl.data("class-pk")
	        },
	        success: function success() {
	          ratingSubmitModalFlow.showSuccessModal();
	          guideRatingEl.find("#guide-avarage-rating").text("0.0");
	          guideRatingEl.find("#guide-total-entries").text("0");
	          // Hide All Modals
	          setTimeout(function () {
	            ratingSubmitModalFlow.hideAllModals();
	          }, 3000);
	        },
	        error: function error(_error) {
	          ratingSubmitModalFlow.showErrorModal();
	        }
	      });
	    }
	  });
	
	  // INIT MODAL FLOW!
	  ratingSubmitModalFlow.init();
	
	  // RESET RATINGS CONFIRM MODAL
	  $('.reset-rating-modal-btn').on('click', function () {
	    ratingSubmitModalFlow.showConfirmModal();
	  });
	
	  guideRatingsBtn.on('click', function (e) {
	    e.preventDefault();
	
	    var score = guideRatings.getActiveBtnKey();
	    //Check if user has realy select Rating
	
	    if ((0, _general.isPresent)(score)) {
	      guideRatingEl.find('.guide-ratings-fail').hide();
	      guideRatingsBtn.text('Submitting...');
	
	      $.ajax({
	        type: 'post',
	        url: "/c/portal/rate_entry",
	        datatype: 'json',
	        data: {
	          classPK: guideRatingEl.data("class-pk"),
	          score: score,
	          className: guideRatingEl.data("class-name"),
	          p_auth: Liferay.authToken
	        },
	        success: function success() {
	          guideRatingEl.find('.guide-ratings-wrapper').hide();
	          guideRatingEl.find('.guide-ratings-success').show();
	        },
	        error: function error(_error2) {
	          ratingSubmitModalFlow.showFailureModal();
	        }
	      });
	    } else {
	      guideRatingEl.find('.guide-ratings-fail').show();
	    }
	  });
	}

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1112);
	__webpack_require__(1114);
	
	
	var guidesOuterSelector = "#p_p_id_navigationportlet_WAR_commerceuportlet_ #guidesContents";
	
	(0, _run2.default)(guidesOuterSelector, function () {
		attachGuides();
	});
	
	function attachGuides() {
	
		/** Script to expand and make active currnet url link on guides page **/
	
		var currentUrl = window.location.href.split('-/')[1];
		if (currentUrl !== undefined) {
			var questionIndex = currentUrl.indexOf("?");
			if (questionIndex > -1) {
				currentUrl = currentUrl.substring(0, questionIndex);
			}
	
			(0, _jquery2.default)("#guidesContents a.active").each(function () {
				var activeUrl = (0, _jquery2.default)(this).attr('id');
				if (currentUrl === activeUrl) {
					var parentEL = (0, _jquery2.default)(this).parent();
					parentEL.addClass("active");
					parentEL.parent().addClass("in");
					parentEL.closest(".hcu-second-level").addClass("active");
				}
			});
		}
	
		/** click on guide folder on left navigation should expand folder and how the articles in it **/
	
		(0, _jquery2.default)('.hcu-nav .q-sidebar-link').click(function (event) {
			event.preventDefault();
			if ((0, _jquery2.default)(this).parent().hasClass('active')) {
				(0, _jquery2.default)(this).next('.collapse').toggleClass('in');
				(0, _jquery2.default)(this).parent().toggleClass('active');
			} else {
				(0, _jquery2.default)(".collapse.in").removeClass("in");
				(0, _jquery2.default)("li.active").removeClass("active");
				(0, _jquery2.default)(this).next('.collapse').toggleClass('in');
				(0, _jquery2.default)(this).parent().toggleClass('active');
			}
		});
	
		/** load glossary term on guides contents
	 	Loop through each element, see if there are duplicate glossary term within one body section
	 	if multiple glossary section is found then remove duplicate and get data only for one unique glossary term **/
	
		(0, _jquery2.default)(".termTracker").each(function () {
			var found = {};
			(0, _jquery2.default)(this).find(".dupTracker").each(function () {
				var $this = (0, _jquery2.default)(this);
				/** must use attribute and iterate through the all elements because we need 
	   	to track duplicate based on data in attribute "termtitle" which is very dynamic in nature **/
				var termtitle = $this.attr("termtitle");
				if (found[termtitle]) {
					$this.hide();
				} else {
					found[termtitle] = true;
					findGlossaryTerm($this.text(), (0, _jquery2.default)(this));
				}
			});
		});
		var icon = (0, _jquery2.default)('.hcu-toggle-icon');
		(0, _jquery2.default)(".hcu-guide-menu").click(function (event) {
			event.preventDefault();
			toggleNavBarIcons();
		});
	
		(0, _jquery2.default)(".hcu-side-nav-icon").click(function (event) {
			event.preventDefault();
			//const icon = $(this).parent().find('.hcu-toggle-icon');
			toggleNavBarIcons();
		});
	
		var hcuList = (0, _jquery2.default)(".hcu-list-txt");
		var hcuSidebarLayout = (0, _jquery2.default)('.hcu-sidebar-layout');
		var $window = (0, _jquery2.default)(window);
	
		function toggleNavBarIcons() {
			if (isSidebarOpen(icon)) {
				hideSidebar();
			} else {
				showSidebar();
			}
		}
	
		function isSidebarOpen(icon) {
			return icon.hasClass('fa-chevron-left');
		}
	
		function showSidebar() {
			(0, _selectorHelpers.swapClassesViaBool)(icon, "fa-chevron-left", "fa-chevron-right", true);
			hcuList.text("Hide List");
			hcuSidebarLayout.removeClass("hcu-list-toggle");
		}
	
		function hideSidebar() {
			(0, _selectorHelpers.swapClassesViaBool)(icon, "fa-chevron-left", "fa-chevron-right", false);
			hcuList.text("Show List");
			hcuSidebarLayout.addClass("hcu-list-toggle");
		}
	
		//handle side nav breadcrumb
		var isResizedToMobile = false;
		handleSiteBreadcrumbForMobile();
	
		function handleSiteBreadcrumbForMobile() {
			var width = $window.width();
			if (!isResizedToMobile && width < 768) {
				hideSidebar();
				isResizedToMobile = true;
			} else if (isResizedToMobile && width >= 768) {
				// we also want to check going FROM mobile TO desktop
				// whether or not it was ORIGINALLY open in mobile
				if (isSidebarOpen(icon)) {
					showSidebar();
				} else {
					hideSidebar();
				}
				isResizedToMobile = false;
			}
		}
		var lazyResize = _underscore2.default.debounce(handleSiteBreadcrumbForMobile, 100);
		$window.resize(lazyResize);
	}
	
	function findGlossaryTerm(glossaryTitle, el) {
		_jquery2.default.ajax({
			url: (0, _jquery2.default)("#displayContent").data("find-glossary-term-url"),
			datatype: 'json',
			data: {
				glossaryTitle: glossaryTitle
			},
			success: function success(data) {
				el.html(''); // to clear the previous option
				el.append(data);
				el.show("fast");
			}
		});
	}

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(642);
	
	__webpack_require__(641);

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	__webpack_require__(1109);
	
	var faqOuterSelector = "#p_p_id_navigationportlet_WAR_commerceuportlet_";
	
	(0, _run2.default)(faqOuterSelector, function () {
		attachGlossary();
	});
	
	function attachGlossary() {
	
		deepLinkURL();
	
		/* this function works for both title plus icon (expand/collaps) **/
		(0, _jquery2.default)('.hcu-title').click(function (event) {
			event.preventDefault();
			var elId = (0, _jquery2.default)(this).find("a").attr("href");
			//location.hash = elId;		
			history.replaceState({}, "", elId);
			(0, _jquery2.default)(this).next('.hcu-faq-wrapper').toggle();
			var icon = (0, _jquery2.default)(this).find('.expand-icon');
			var isOpen = !icon.hasClass('fa-expand');
			(0, _selectorHelpers.swapClassesViaBool)(icon, "fa-expand", "fa-compress", isOpen);
			(0, _jquery2.default)('.hcu-faq-wrapper').hide();
			(0, _jquery2.default)(".hcu-faq-container").removeClass("active q-marg-vert-xs");
	
			if (isOpen) {
				(0, _jquery2.default)(this).next('.hcu-faq-wrapper').hide();
			} else {
				(0, _jquery2.default)(this).next('.hcu-faq-wrapper').show();
			}
		});
		/** expand/collaps FAQs question **/
		(0, _jquery2.default)('.hcu-question').click(function (event) {
			event.preventDefault();
			var elId = (0, _jquery2.default)(this).closest("a").attr("href");
			history.replaceState({}, "", elId);
			var container = (0, _jquery2.default)(this).closest('.hcu-faq-container');
			container.toggleClass('active');
			container.toggleClass('q-marg-vert-xs');
		});
	
		/** Expand the FAQs page based on anchor value **/
	
		function deepLinkURL() {
			var currentUrl = window.location.href;
	
			if (typeof currentUrl !== "undefined") {
				openFAQSecionById(currentUrl);
			}
		}
	
		function openFAQSecionById(currentUrl) {
	
			if (currentUrl.indexOf("#question") > -1) {
				openQuestion(currentUrl);
			} else if (currentUrl.indexOf("#folder") > -1) {
				openFolder(currentUrl);
			}
		}
	
		function openFolder(currentUrl) {
			var questionFolder = getIdAfterHash(currentUrl, "#folder");
			var targetFolderId = '#displayContent ' + questionFolder;
			var afterToggle = scrollToOffsetFunc(questionFolder);
			(0, _jquery2.default)(targetFolderId).children(".hcu-faq-wrapper").show(afterToggle);
		}
	
		function openQuestion(currentUrl) {
			var questionId = getIdAfterHash(currentUrl, "#question");
			var targetQuestion = '#displayContent ' + questionId;
			var hcuFAQ = (0, _jquery2.default)(targetQuestion);
			hcuFAQ.closest('.hcu-faq-wrapper').show();
			hcuFAQ.closest('.hcu-faq-container').addClass("active");
			scrollToOffsetFunc(questionId)();
		}
	
		function getIdAfterHash(currentUrl, hashIdentifier) {
	
			var hashId = currentUrl.substring(currentUrl.indexOf(hashIdentifier), currentUrl.length);
			var urlMatcher = new RegExp("[\\?\&\\\/\\*\\$]");
			var matcher = urlMatcher.exec(hashId);
			if (matcher !== null) {
				var matcherIndex = matcher.index;
				if (matcherIndex > 0) {
					hashId = hashId.substring(0, matcherIndex);
				}
			}
			return hashId;
		}
	
		function scrollToOffsetFunc(id) {
			return function () {
				(0, _jquery2.default)('html,body').animate({ scrollTop: (0, _jquery2.default)(id).offset().top - 60 });
			};
		}
	}

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(644);

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	// Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	__webpack_require__(1110);

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(646);

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1111); // Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	
	
	var glossaryOuterSelector = "#p_p_id_navigationportlet_WAR_commerceuportlet_";
	
	(0, _run2.default)(glossaryOuterSelector, function () {
		attachGlossary();
	});
	
	function attachGlossary() {}

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(648);

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1113);

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(650);

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _submitHelpers = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	__webpack_require__(1115);
	
	var commerceSearchSelector = "#p_p_id_searchportlet_WAR_commerceuportlet_";
	
	(0, _run2.default)(commerceSearchSelector, function () {
	  attachSearch();
	});
	
	function attachSearch() {
	  (0, _submitHelpers.bindHardSubmit)({
	    form: $('.commerce-u-search-form'),
	    links: $('.commerce-u-search')
	  });
	}

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(652);

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	__webpack_require__(1117);

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(654);

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1116);

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(658);

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1088);
	
	(0, _run2.default)(".branding-login", function () {
	  setupLoginForm();
	});
	
	function setupLoginForm() {
	  (0, _jquery2.default)(".footer").addClass("q-pad-vert-lg q-pad-horz-xl");
	}

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(660);

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1089);

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(663);

/***/ },
/* 662 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var inventoryLookupFieldDropdown = exports.inventoryLookupFieldDropdown = [{
		title: "Product Name (SKU)",
		value: "productName"
	}, {
		title: "Product Description",
		value: "productDescription"
	}, {
		title: "Product UPC",
		value: "productUpc"
	}, {
		title: "Variant Attribute Type",
		value: "variantAttributeType"
	}, {
		title: "Variant Attribute Value",
		value: "variantAttributeValue"
	}];

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _additionalFilterLogic = __webpack_require__(146);
	
	var _filtersLegacy = __webpack_require__(147);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	var _jqueryDataTableChildren = __webpack_require__(226);
	
	var _inventoryLookupFieldDropdown = __webpack_require__(662);
	
	var _fontAwesomeHelpers = __webpack_require__(224);
	
	var _constants = __webpack_require__(10);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _filtersutil = __webpack_require__(16);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var statusHtml = __webpack_require__(1343);
	var allWarehousesHtml = __webpack_require__(1342);
	var warehouseChildRowHtml = __webpack_require__(1344);
	// const setDash = require("./html/setToDash.html");
	
	__webpack_require__(1090);
	//import pagination from "../../../components/pagination/pagination";
	
	
	var targetSelector = "#lookup-item-inventory-outer";
	var lookupSelector = "#lookup-item-inventory-wrapper";
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	
	(0, _run2.default)(targetSelector, function () {
	
	  var statusClassMap = {
	    "Out of Stock": "q-pill-red",
	    "Low Stock": "q-pill-orange",
	    "_available": "q-pill-white-and-grey"
	  };
	  var savedViews = (0, _jquery2.default)(targetSelector).data("saved-views");
	  var saveViewURL = (0, _jquery2.default)(targetSelector).data("save-view-url");
	  var deleteViewURL = (0, _jquery2.default)(targetSelector).data("delete-view-url");
	  var dataTableComponentData = (0, _jquery2.default)(targetSelector).data("inventory-lookup-data");
	  var filterURL = (0, _jquery2.default)(targetSelector).data("filter-item-inventory-url");
	  var exportItemInventoryUrl = (0, _jquery2.default)(targetSelector).data("export-item-inventory-url");
	  var filterFlag = (0, _jquery2.default)(targetSelector).data("filter-flag");
	  var facCode = (0, _jquery2.default)(targetSelector).data("fac-code");
	
	  var exportModal = new _filtersutil.buildExport();
	
	  var inventoryLookup = new _index2.default({
	
	    target: (0, _jquery2.default)("#lookup-item-inventory-wrapper"),
	    minWidthClass: "q-min-width-sm-til-md",
	    mobileColumns: [{
	      data: "itemSku",
	      title: "Product Name (SKU)",
	      class: "dtc-min-width-md"
	    }, {
	      data: "productName",
	      title: "Product Description",
	      class: "dtc-min-width-lg"
	    }, {
	      data: "facilityLocation",
	      title: "Facility",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "available",
	      title: "Available",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "allocated",
	      title: "Committed",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "blocked",
	      title: "Blocked",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "inboundInventory",
	      title: "Inbound Inventor",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "inboundReturns",
	      title: "Inbound Returns",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "backordered",
	      title: "Backordered",
	      class: "dtc-min-width-sm"
	    }],
	    tableSearchInput: {
	      placeholder: 'Search',
	      value: ""
	    },
	    tableSearchDropdown: {
	      selected: "",
	      columns: _inventoryLookupFieldDropdown.inventoryLookupFieldDropdown
	    },
	    savedViews: savedViews,
	    bulkSelect: false,
	    dataTable: {
	      data: dataTableComponentData.content,
	      columnDefs: [{ className: "custom-class", targets: [1] }],
	      order: [[3, 'desc']],
	      columns: [{
	        data: "itemSku",
	        title: "Product Name (SKU)",
	        class: "dtc-min-width-md"
	      }, {
	        data: "productName",
	        title: "Product Description",
	        class: "dtc-min-width-lg"
	      }, {
	        data: "facilityLocation",
	        title: "Facility",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "available",
	        title: "Available",
	        class: "dtc-min-width-sm",
	        render: renderAvailableStatus
	      }, {
	        data: "allocated",
	        title: "Committed",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "blocked",
	        title: "Blocked",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "inboundInventory",
	        title: "Inbound Inventory",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "inboundReturns",
	        title: "Inbound Returns",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "backordered",
	        title: "Backordered",
	        class: "dtc-min-width-sm"
	      }]
	    },
	    paginationData: dataTableComponentData.page,
	    filterModal: {
	      title: "Filter Inventory:",
	      tableType: "Inventory"
	    },
	    onFetch: function onFetch() {
	      inventoryLookup.showLoadingOverlay();
	      var currentData = inventoryLookup.generateData();
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterURL, success: filterSuccessFun, error: errorFun, data: getInventoryData(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: getInventoryData(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: getInventoryData(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: getInventoryData(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  inventoryLookup.init();
	
	  function getInventoryData(currentData) {
	    var sourceData = (0, _filtersutil.prepareDataToSendController)(currentData);
	    var revisedSearchCriteria = (0, _filtersutil.alterSearchCriteriForController)(currentData["searchCriteria"]);
	    var warehouseObj = (0, _filtersutil.retriveCriteriaObjectByKey)(revisedSearchCriteria, "warehouse");
	    var prepareInventoryData = _extends({}, sourceData, {
	      warehouse: (0, _general.isPresent)(warehouseObj) ? warehouseObj.value[0] : "all warehouses"
	    });
	    return prepareInventoryData;
	  }
	
	  function filterSuccessFun(data) {
	    var inventory = data.content;
	    var page = data.page;
	    inventoryLookup.setNewData(inventory);
	    inventoryLookup.setPaginationData(page);
	    inventoryLookup.hideLoadingOverlay();
	    setExportData(inventoryLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var inventory = data.lookupOrderJSON.content;
	    var page = data.lookupOrderJSON.page;
	    inventoryLookup.setNewData(inventory);
	    inventoryLookup.setPaginationData(page);
	    inventoryLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    inventoryLookup.hideLoadingOverlay();
	    setExportData(inventoryLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var inventory = data.lookupOrderJSON.content;
	    var page = data.lookupOrderJSON.page;
	    inventoryLookup.setNewData(inventory);
	    inventoryLookup.setPaginationData(page);
	    inventoryLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    inventoryLookup.hideLoadingOverlay();
	    setExportData(inventoryLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var inventory = data.lookupOrderJSON.content;
	    var page = data.lookupOrderJSON.page;
	    inventoryLookup.removeSavedView(data.target);
	    inventoryLookup.setNewData(inventory);
	    inventoryLookup.setPaginationData(page);
	    inventoryLookup.hideLoadingOverlay();
	    setExportData(inventoryLookup.generateData());
	  }
	
	  function errorFun(data) {
	    inventoryLookup.hideLoadingOverlay();
	  }
	
	  function renderAvailableStatus(data, type, row) {
	    return (0, _render2.default)(statusHtml, {
	      statusText: data,
	      statusClass: getStatusClass(row.invStatus)
	    });
	  }
	
	  function getStatusClass(val) {
	    return statusClassMap[val] || statusClassMap._available;
	  }
	
	  function initExport() {
	    var exportObj = {
	      title: (0, _jquery2.default)(targetSelector).data("export-popup-title"),
	      exportAttemptTextPart1Lang: (0, _jquery2.default)(targetSelector).data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: (0, _jquery2.default)(targetSelector).data("export-attempt-text-part2"),
	      exportMaxLimitLang: (0, _jquery2.default)(targetSelector).data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent();
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(exportItemInventoryUrl, currentData);
	    var url = exportModal.getCurrentUrl();
	    var revisedSearchCriteria = (0, _filtersutil.alterSearchCriteriForController)(currentData["searchCriteria"]);
	    var warehouseObj = (0, _filtersutil.retriveCriteriaObjectByKey)(revisedSearchCriteria, "warehouse");
	    var warehouse = (0, _general.isPresent)(warehouseObj) ? warehouseObj.value[0] : "all warehouses";
	    url = url + "&warehouse=" + warehouse;
	    exportModal.buildExportBasicURL(url, currentData);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  initExport();
	  setExportData(inventoryLookup.generateData());
	});

/***/ },
/* 664 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    title: "Edit",
	    cls: "bulk-edit-location",
	    icon: "pencil",
	    disabled: true
	  }, {
	    title: "Delete",
	    cls: "bulk-delete-location",
	    icon: "trash",
	    disabled: false
	  }],
	  "actions": [{
	    title: "Edit",
	    cls: "edit-location",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Delete",
	    cls: "delete-location",
	    icon: "trash",
	    disabled: false
	  }]
	};

/***/ },
/* 665 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var searchDropdown = exports.searchDropdown = [{
		title: "Return Type",
		value: "rsaType"
	}, {
		title: "State",
		value: "rsaState"
	}, {
		title: "Address ID ",
		value: "rsaShipToAddressId"
	}, {
		title: "Inbound Class",
		value: "rsaInboundClassification"
	}];

/***/ },
/* 666 */
[1582, 667],
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _searchDropdown = __webpack_require__(665);
	
	var _filtersutil = __webpack_require__(16);
	
	var _actionOptions = __webpack_require__(664);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	var modalHtml = __webpack_require__(11);
	var targetSelector = "#location-mapping-lookup";
	var newLocationModalHtml = __webpack_require__(1345);
	
	var actionList = _actionOptions.actionOptions;
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	
	(0, _run2.default)(targetSelector, function () {
	  var dataTableComponentData = $(targetSelector).data("location-mapping");
	  var portletNamespace = $(targetSelector).data("portlet-namespace");
	  var filterLocationUrl = $(targetSelector).data("location-filter-url");
	  //For the search drop down in lookup need to get the filter Criteria from Server
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	  //For the views - add/save/delete
	  var savedViews = $(targetSelector).data("saved-views");
	  var pageReloadUrl = $(targetSelector).data("reload-url");
	  var saveViewURL = $(targetSelector).data("save-view-url");
	  var deleteViewURL = $(targetSelector).data("delete-view-url");
	  var exportUrl = $(targetSelector).data("export-url");
	  var deleteActionUrl = $(targetSelector).data("delete-action-url");
	  var newMappingUrl = $(targetSelector).data("new-mapping-url");
	  var returnTypes = $(targetSelector).data("return-types-dropdown");
	  var classificationArray = $(targetSelector).data("classification-dropdown");
	  var states = $(targetSelector).data("states-dropdown");
	  var cmrAddresses = $(targetSelector).data("ship-addresses-dropdown");
	  var bulkDeleteMappings = $(targetSelector).data("bulk-delete-url");
	  var targetObject = "";
	  var selectedRows = "";
	  var rsaId = "";
	  var rsaIdDelete = "";
	  var exportModal = new _filtersutil.buildExport();
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  var validationOpts = {
	    debug: true,
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	
	    /*-- new modal --*/
	  };var newLocationModal = $((0, _render2.default)(modalHtml, {
	    modalDialogClass: "q-modal-dialog-800",
	    title: 'State to Location Mapping',
	    subtitle: 'Use the following values to create or edit a state to location mapping for returns processing.',
	    leftAlignTitle: false,
	    body: newLocationModalHtml,
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide cancel-btn">Cancel</a>\
	      <a href="#" class="base-btn purple-btn save-mapping-btn">Save Mapping</a>'
	  }));
	  var validator = newLocationModal.find(".edit-location-form").validate(validationOpts);
	  validator.settings.ignore = ":disabled, :hidden";
	
	  $('body').append(newLocationModal);
	
	  $("#newMapping").on('click', function (e) {
	    e.preventDefault();
	    $(".show-on-error").hide();
	    newLocationModal.modal('show');
	    loadDropDowns();
	  });
	
	  $(".save-mapping-btn").on('click', onSaveMappingClick);
	  function onSaveMappingClick(e) {
	    if (isModalValid()) {
	      newLocationModal.modal('hide');
	      submitModalFlow.showLoadingModal();
	      e.preventDefault();
	      $.ajax({
	        url: newMappingUrl,
	        type: 'POST',
	        dataType: 'JSON',
	        data: {
	          rsaId: rsaId,
	          rsaType: $('#returnType').val(),
	          rsaState: $('#originalState').val(),
	          rsaShipToAddressId: $('#shipToAddress').val(),
	          rsaInboundClassification: $('#inboundClassification').val()
	        },
	        success: function success(data) {
	          if (data.response == "success") {
	            submitModalFlow.showSuccessModal();
	            setTimeout(function () {
	              location.href = pageReloadUrl;
	            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	          }
	          if (data.response == "error") {
	            submitModalFlow.hideAllModals();
	            newLocationModal.modal('show');
	            $(".show-on-error").show();
	          }
	        }
	      });
	    }
	  }
	
	  function isModalValid() {
	    var isValid = false;
	    if (newLocationModal.find(".edit-location-form").valid()) {
	      isValid = true;
	    }
	    return isValid;
	  }
	
	  function loadDropDowns() {
	
	    //const returnType =  $('#returnType');
	    var inboundClass = $('#inboundClassification');
	    var originalState = $('#originalState');
	    var shipToAddress = $('#shipToAddress');
	
	    /*const returnTypeList = returnTypes.map((el) => {
	      return render("<option value = {%-key %}>{%-value %}</option>", {
	        key: el.cdmValue,
	        value: el.cdmMeaning
	      });
	    }).join('');
	    
	    formDropDown(returnType,'Select a return type', returnTypeList);*/
	
	    var inboundList = classificationArray.map(function (el) {
	      return (0, _render2.default)("<option value = {%-key %}>{%-value %}</option>", {
	        key: el.cdmValue,
	        value: el.cdmMeaning
	      });
	    }).join('');
	    formDropDown(inboundClass, 'Select an inbound classification', inboundList);
	
	    var stateList = states.map(function (el) {
	      return (0, _render2.default)("<option value = {%-key %}>{%-value %}</option>", {
	        key: el.cdmValue,
	        value: el.cdmMeaning
	      });
	    }).join('');
	
	    formDropDown(originalState, 'Select a state where a return can be created', stateList);
	
	    var addressList = cmrAddresses.map(function (el) {
	
	      return (0, _render2.default)("<option value = {%-key %}>{%-value %}</option>", {
	        key: el.cadAddressId,
	        value: el.cadAddressId + " - " + el.cadAddress1
	      });
	    }).join('');
	
	    formDropDown(shipToAddress, 'Select the address ID in which to send the return', addressList);
	  }
	
	  function formDropDown(dropdown, text, dropList) {
	    dropdown.empty();
	    var option = $('<option /\>');
	    option.attr('value', "-1").text(text);
	    option.attr('disabled', 'disabled');
	    option.attr('selected', 'selected');
	    dropdown.append(option);
	    dropdown.append(dropList);
	  }
	
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	
	  var locationMappingLookup = new _index2.default({
	    // REQUIRED - Set a target element
	    target: $("#lookup-location-wrapper"),
	    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
	    minWidthClass: "q-min-width-sm-til-md",
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: [{
	      data: "rsaType",
	      title: "Return Type"
	    }, {
	      data: "rsaInboundClassification",
	      title: "Inbound Classifications"
	    }, {
	      data: "rsaState",
	      title: "State"
	    }, {
	      data: "rsaShipToAddressId",
	      title: "Ship to Address ID"
	    }],
	    paginationData: dataTableComponentData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Location",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "location"
	    },
	    tableSearchInput: {
	      value: targetObject != "" ? targetObject.value[0] : ""
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _searchDropdown.searchDropdown
	    },
	    savedViews: savedViews,
	    bulkSelect: true,
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      columnDefs: [],
	      order: [[2, 'desc']],
	      columns: [{
	        data: "rsaId",
	        title: "Actions",
	        render: renderActionWrap,
	        orderable: false,
	        class: 'dtc-action-column'
	      }, {
	        data: "rsaType",
	        title: "Return Type"
	      }, {
	        data: "rsaInboundClassification",
	        title: "Inbound Classifications",
	        render: renderInboundClassification
	      }, {
	        data: "rsaState",
	        title: "State"
	      }, {
	        data: "rsaShipToAddressId",
	        title: "Ship to Address ID"
	      }]
	    },
	
	    onBulkSelectChange: function onBulkSelectChange() {
	      selectedRows = locationMappingLookup.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass('disabled');
	      } else {
	        $(".action-header-btn .base-btn").addClass('disabled');
	      }
	    },
	
	    onFetch: function onFetch() {
	      var currentData = locationMappingLookup.generateData();
	      locationMappingLookup.showLoadingOverlay();
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterLocationUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: deleteViewSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  locationMappingLookup.init();
	
	  // for the bulk select
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    var statusTarget = actionList['all'];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list) {
	    var renderedList = void 0;
	    renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: (0, _general.keyDefaultFalseOption)(item, "disabled")
	      });
	    });
	    return renderedList.join('');
	  }
	
	  //for the bulk select end
	
	  //Methods used for the Filter and Success
	  function filterSuccessFun(data) {
	    var shipToAddresses = data.content;
	    var page = data.page;
	    locationMappingLookup.setNewData(shipToAddresses);
	    locationMappingLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    locationMappingLookup.hideLoadingOverlay();
	    setExportData(locationMappingLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var shipToAddresses = data.locationLookupJSON.content;
	    var page = data.locationLookupJSON.page;
	    locationMappingLookup.setNewData(shipToAddresses);
	    locationMappingLookup.setPaginationData(page);
	    locationMappingLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    locationMappingLookup.hideLoadingOverlay();
	    setExportData(locationMappingLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var shipToAddresses = data.locationLookupJSON.content;
	    var page = data.locationLookupJSON.page;
	    locationMappingLookup.setNewData(shipToAddresses);
	    locationMappingLookup.setPaginationData(page);
	    locationMappingLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    locationMappingLookup.hideLoadingOverlay();
	    setExportData(locationMappingLookup.generateData());
	  }
	
	  function deleteViewSuccessFun(data) {
	    var shipToAddresses = data.locationLookupJSON.content;
	    var page = data.locationLookupJSON.page;
	    locationMappingLookup.removeSavedView(data.target);
	    locationMappingLookup.setNewData(shipToAddresses);
	    locationMappingLookup.setPaginationData(page);
	    locationMappingLookup.hideLoadingOverlay();
	    setExportData(locationMappingLookup.generateData());
	  }
	
	  function errorFun() {
	    locationMappingLookup.hideLoadingOverlay();
	  }
	
	  //Method used for rendering the whole Inbound classification Text
	  function renderInboundClassification(row) {
	    return (0, _render2.default)("<span>{%- inboundClassificationText %} </span>", {
	      inboundClassificationText: fetchInboundText(classificationArray, row)
	    });
	  }
	
	  function fetchInboundText(classificationArray, row) {
	    var searchInbound = _.find(classificationArray, function (object) {
	      return object.cdmValue == row;
	    });
	    return searchInbound != null ? searchInbound.cdmMeaning : "";
	  }
	
	  // Export component integration.
	  function initExport() {
	    var exportObj = {
	      title: $(targetSelector).data("export-popup-title"),
	      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
	      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent();
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(exportUrl, currentData);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	  initExport();
	  setExportData(locationMappingLookup.generateData());
	
	  /*-- /new modal --*/
	  //Action Buttons Delete
	
	  $('body').on('click', '.delete-location', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = $(".data-table-component").dataTable().api().row(parent);
	    var locationMapping = row.data();
	    rsaIdDelete = "" + locationMapping.rsaId;
	    var submitDeleteModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Delete Location Mapping',
	      confirmModalBody: '<div class="q-pad-all-xl">Are You Sure You Want To Delete this Locatin Mapping.</div>',
	      confirmModalBtnText: 'Delete Location Mapping',
	      onConfirmClick: function onConfirmClick() {
	        submitDeleteModalFlow.showLoadingModal();
	        deleteLocation(rsaIdDelete);
	        function deleteLocation(rsaIdDelete) {
	          $.ajax({
	            url: deleteActionUrl,
	            type: 'POST',
	            dataType: 'JSON',
	            data: {
	              rsaId: rsaIdDelete
	            },
	            success: function success(data) {
	              if (data.response == "success") {
	                submitDeleteModalFlow.showSuccessModal();
	                setTimeout(function () {
	                  submitDeleteModalFlow.hideAllModals();
	                  location.href = pageReloadUrl;
	                }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	              } else {
	                submitDeleteModalFlow.showFailureModal();
	              }
	            },
	            error: function error() {
	              $(".show-on-error").show();
	              submitDeleteModalFlow.hideAllModals();
	            }
	          });
	        }
	      }
	    });
	    submitDeleteModalFlow.init();
	    submitDeleteModalFlow.showConfirmModal();
	  });
	
	  $('body').on('click', '.edit-location', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    var row = $(".data-table-component").dataTable().api().row(parent);
	    var location = row.data();
	    rsaId = "" + location.rsaId;
	    var rsaState = "" + location.rsaState;
	    var rsaInboundClassification = "" + location.rsaInboundClassification;
	    var rsaType = "" + location.rsaType;
	    var rsaShipToAddressId = "" + location.rsaShipToAddressId;
	    e.preventDefault();
	    $(".show-on-error").hide();
	    newLocationModal.modal('show');
	    loadDropDowns();
	    $("#originalState").val(rsaState);
	    $("#inboundClassification").val(rsaInboundClassification);
	    $("#returnType").val(rsaType);
	    $("#shipToAddress").val(rsaShipToAddressId);
	  });
	
	  $('body').on('click', '.bulk-delete-location', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var _submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: 'Delete Mappings',
	        confirmModalBody: '<div class="q-pad-all-xl">Are You Sure You want To Delete these Locations Mappings ?</div>',
	        confirmModalBtnText: 'Delete Mappings',
	        onConfirmClick: function onConfirmClick() {
	          _submitModalFlow.showLoadingModal();
	          deleteMappings();
	          function deleteMappings() {
	            $.ajax({
	              url: bulkDeleteMappings,
	              type: 'POST',
	              dataType: 'JSON',
	              data: _defineProperty({}, portletNamespace + "rsaIds", getAllSelectedRsaIds()),
	              success: function success(data) {
	                if (data.response == "success") {
	                  _submitModalFlow.showSuccessModal();
	                  setTimeout(function () {
	                    _submitModalFlow.hideAllModals();
	                    location.href = pageReloadUrl;
	                  }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	                } else {
	                  _submitModalFlow.showFailureModal();
	                }
	              },
	              error: function error() {
	                _submitModalFlow.hideAllModals();
	              }
	            });
	          }
	        }
	      });
	      _submitModalFlow.init();
	      _submitModalFlow.showConfirmModal();
	    }
	  });
	
	  function getAllSelectedRsaIds() {
	    var rsaIds = new Array();
	    _(selectedRows).map(function (rsa) {
	      rsaIds.push(rsa.data.rsaId);
	    });
	    return rsaIds;
	  }
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	});

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(669);
	
	__webpack_require__(1091);

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _QuickFileUploader = __webpack_require__(85);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	var _constants = __webpack_require__(10);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	var targetSelector = "#location-bulk-upload-section";
	(0, _run2.default)(targetSelector, function (outerEl) {
	  var data = outerEl.data();
	  var lang = (0, _collectDataAttributesFor2.default)(outerEl.get(0), { prefix: "lang", camelize: false });
	  var csvFileUpload = outerEl.find(".logo-uploader");
	  var bulkLocationTable = outerEl.find("#bulk-location");
	  //const errorMsgLocation = outerEl.find("#error-msg-bulk-location");
	  var uploadButton = outerEl.find("#upload-btn");
	  var uploadProgressBar = outerEl.find("#uploadProgressBar");
	  var sucessMsgBulkLocation = outerEl.find("#sucess-msg-bulk-location");
	  var invalidErrorLocation = outerEl.find("#invalid-error-msg-bulk-location");
	  var bulkLocationSubmit = outerEl.find("#bulk-location-submit");
	  var preUpload = outerEl.find(".pre-upload");
	  var rowUploaded = outerEl.find("#rowuploaded");
	  var uploadFileUrl = data.uploadCsvUrl;
	  var progressBarEl = data.uploadProgressId;
	  var csvJSONInput = outerEl.find('#' + data.namespace + 'csvJSON');
	  var locationSubmitValidationError = outerEl.find('#' + data.namespace + 'bulk-location-validat-error-msg');
	  var successModel = $("#bulk-location-success-modal"); // have to use id as modals are pushed at the end of body (implemented in theme )and will not be about to find by outerEl
	  var bulkUploadLocationForm = outerEl.find("#bulk-upload-location-form");
	  var bulklocationLookupURL = outerEl.data("bulk-location-lookup-url");
	  bulkLocationTable.hide();
	
	  var quickFile = (0, _QuickFileUploader.quickFileUploader)(csvFileUpload, {
	    afterReadFile: function afterReadFile(e, result) {
	      uploadButton.removeClass("disabled");
	    }
	  });
	
	  var locationsUploadSuccessModal = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Are you sure you want to Upload this file ?',
	    // confirmModalSubtitle: "Optional Subtitle",
	    confirmModalBody: '<div class="q-pad-all-xl">Once the file is uploaded, the location(s) will be saved and made active. They can be edited using the locations screen</div>',
	    confirmModalBtnText: 'Save',
	    onConfirmClick: function onConfirmClick() {
	      bulkUploadLocationForm.submit();
	      locationsUploadSuccessModal.showLoadingModal();
	    }
	  });
	  locationsUploadSuccessModal.init();
	
	  uploadButton.on('click', function () {
	    var formData = new FormData();
	
	    formData.append("fileName", quickFile.getFile());
	    preUpload.hide();
	    window[progressBarEl].startProgress();
	    $.ajax({
	      url: uploadFileUrl,
	      type: "POST",
	      data: formData,
	      enctype: "multipart/form-data",
	      processData: false,
	      contentType: false,
	      dataType: "json",
	      success: function success(csvData) {
	        delete data.errorlist;
	        setInterval(function () {
	          bulkLocationTable.show();
	          uploadProgressBar.hide();
	          sucessMsgBulkLocation.show();
	          bulkLocationSubmit.removeAttr("disabled");
	          bulkLocationSubmit.removeClass("disabled");
	          outerEl.find(".bulk-location").show();
	          invalidErrorLocation.hide();
	          locationSubmitValidationError.hide();
	        }, 3000);
	
	        buildDataTable(csvData);
	
	        csvJSONInput.val(JSON.stringify(csvData));
	      },
	      error: function error() {
	        uploadProgressBar.hide();
	        invalidErrorLocation.show();
	      }
	    });
	  });
	
	  if ((0, _general.isPresent)(data.csvjson)) {
	    preUpload.hide();
	    sucessMsgBulkLocation.hide();
	    bulkLocationTable.show();
	    buildDataTable(data.csvjson);
	
	    if ((0, _general.isPresent)(data.isFormSubmit)) {
	      if (data.errorlist && data.errorlist.length > 0) {
	        locationSubmitValidationError.show();
	      } else {
	        locationSubmitValidationError.hide();
	        locationsUploadSuccessModal.showSuccessModal();
	        location.href = '' + bulklocationLookupURL;
	        setTimeout(function () {
	          locationsUploadSuccessModal.hideAllModals();
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  }
	
	  bulkLocationSubmit.on('click', function () {
	    locationsUploadSuccessModal.showConfirmModal();
	  });
	
	  /* bindHardSubmit({
	     form: bulkUploadLocationForm,
	     links: bulkLocationSubmit
	   });*/
	
	  function buildDataTable(csvjson) {
	
	    bulkLocationTable.dataTable({
	      data: csvjson,
	      scrollX: true,
	      "bPaginate": true,
	      "bDestroy": true,
	      "pageLength": 100,
	      "columns": [{ data: 'locationId', title: lang['bulk-location-table-header-external-location-id'] }, { data: 'active', title: lang['bulk-location-table-header-active'] }, { data: 'locationName', title: lang['bulk-location-table-header-location-name'] }, { data: 'contactName', title: lang['bulk-location-table-header-contact-name'] }, { data: 'contactCountryCode', title: lang['bulk-location-table-header-country-code'] }, { data: 'contactPhone', title: lang['bulk-location-table-header-phone'] }, { data: 'email', title: lang['bulk-location-table-header-email'] }, { data: 'address1', title: lang['bulk-location-table-header-address1'] }, { data: 'address2', title: lang['bulk-location-table-header-address2'] }, { data: 'city', title: lang['bulk-location-table-header-city'] }, { data: 'state', title: lang['bulk-location-table-header-state'] }, { data: 'zip', title: lang['bulk-location-table-header-zip'] }, { data: 'country', title: lang['bulk-location-table-header-country'] }, { data: 'inboundClassification', title: lang['bulk-location-table-header-inbound-classification'] }, { data: 'fedexAccountNumber', title: lang['bulk-location-table-header-fedex-account-number'] }, { data: 'hubId', title: lang['bulk-location-table-header-hub-id'] }, { data: 'organizationName', title: lang['bulk-location-table-header-organization-name'] }, { data: 'facilityType', title: lang['bulk-location-table-header-facility-type'] }, { data: 'raRequired', title: lang['bulk-location-table-header-ra-required'] }, { data: 'standingRaNumber', title: lang['bulk-location-table-header-standing-ra-number'] }],
	      fnCreatedRow: function fnCreatedRow(nRow, aData, iDisplayIndex) {
	
	        if (data.errorlist) {
	          if (data.errorlist.indexOf(iDisplayIndex) >= 0) {
	            nRow.className = "alert-danger";
	          }
	        } else {
	          rowUploaded.html(iDisplayIndex + 1);
	        }
	      }
	    });
	  }
	});

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = BillingTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  sharePrimarySwitch: '.switch-share-primary',
	  prefix: '.ret-prefix',
	  firstName: '.ret-first-name',
	  lastName: '.ret-last-name',
	  email: '.ret-email',
	  addMobileBtn: '.add-mobile-number-btn',
	  removeMobileBtn: '.remove-mobile-btn',
	  addressSection: '.address-section',
	  contactSection: '.contact-section',
	  phoneSection: '.phone-section'
	};
	
	var addressElementsMap = {
	  country: '.ret-country',
	  address1: '.ret-address1',
	  address2: '.ret-address2',
	  city: '.ret-city',
	  state: '.ret-state',
	  zipCode: '.ret-zip-code',
	  postalCodeLabel: '#postalcode-label',
	  stateLabel: '#state-label',
	  county: '.ret-county',
	  countyMandatoryLabel: '.county-mandatory-label',
	  stateSelectContainer: '.state-wrapper',
	  stateTextContainer: '.state-text-wrapper',
	  stateTextInput: '.ret-state-text',
	  commercialAddressFlag: '.commercial-addr-flag'
	};
	
	var phoneElementsMap = {
	  officeCountryCodeBill: '.ret-office-country-code-bill',
	  officePhoneBill: '.ret-office-phone-bill',
	  officeAreaCodeBill: '.ret-office-area-code-bill',
	  mobileCountryCodeBill: '.ret-mobile-country-code-bill',
	  mobilePhoneBill: '.ret-mobile-phone-bill',
	  mobileAreaCodeBill: '.ret-mobile-area-code-bill',
	  mobilePhoneSection: '.ret-mobile-number-section',
	  officeExt: '.ret-office-ext',
	  officeCountryCode: '.ret-office-country-code',
	  officePhone: '.ret-office-phone',
	  officeAreaCode: '.ret-office-area-code',
	  mobileCountryCode: '.ret-mobile-country-code',
	  mobilePhone: '.ret-mobile-phone',
	  mobileAreaCode: '.ret-mobile-area-code'
	};
	
	function BillingTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	  var primaryEls = {};
	  var retailerWizard = (0, _jquery2.default)('#retailer-wizard');
	  var validationReqdCountries = JSON.parse(retailerWizard.attr("data-validation-reqd-countries"));
	  var billingTab = wizardElement.find('.billing-information-tab');
	  var primaryTab = wizardElement.find('.primary-information-tab');
	  var defaultContry = wizardElement.data('default-country');
	  var usaStates = wizardElement.data('usa-states');
	  var caProvinces = wizardElement.data('ca-provinces');
	  var countriesPhoneCodeList = wizardElement.data('country-phone-code-list');
	  var countries = wizardElement.data('countries');
	  var prefixes = wizardElement.data('prefixes');
	  var retailerJsonString = wizardElement.data('retailer-obj');
	  var rtlType = wizardElement.data('rtl-type');
	  var elementSelector = "input, select";
	  var isDataModified = false;
	  var countryId = void 0;
	
	  self.init = function () {
	    render();
	  };
	
	  function render() {
	    setElements();
	    (0, _selectorHelpers.setUniqNamesAndIds)(els); // jquery validator needs that all "name" attribute are unique
	    loadDropDowns();
	    setStates(defaultContry);
	    els.country.on("change", countryChange); // due to an issue in country triggering, moving it up
	    renderViewWithData();
	    bindElements();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, addressElementsMap, billingTab);
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, billingTab);
	    (0, _selectorHelpers.setElementsFromScope)(els, phoneElementsMap, billingTab);
	
	    (0, _selectorHelpers.setElementsFromScope)(primaryEls, addressElementsMap, primaryTab);
	    (0, _selectorHelpers.setElementsFromScope)(primaryEls, elementsMap, primaryTab);
	    (0, _selectorHelpers.setElementsFromScope)(primaryEls, phoneElementsMap, primaryTab);
	  }
	
	  function bindElements() {
	    els.officeCountryCodeBill.on("change", officeCountryCodeChange);
	    els.mobileCountryCodeBill.on("change", mobileCountryCodeChange);
	    (0, _jquery2.default)(document).on("click", '.billing-information-tab .add-mobile-number-btn', handleAddMobileBtn);
	    (0, _jquery2.default)(document).on("click", '.billing-information-tab .remove-mobile-btn', handleRemoveMobileBtn);
	    // for share primary address switch
	    (0, _jquery2.default)('.billing-information-tab .switch-share-primary').on("change", handleSharePrimarySwitch);
	    // To check if some information is modified. require to replace primary info if user modified something on tab
	    _underscore2.default.map(billingTab.find((0, _jquery2.default)(elementSelector)), function (element) {
	      if (!(0, _jquery2.default)(element).is(":checkbox")) {
	        (0, _jquery2.default)(element).on("change", handleInputChange);
	      }
	    });
	  }
	
	  function loadDropDowns() {
	    (0, _jquery2.default)(countries).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conCode).text(this.conName);
	      els.country.append(option);
	    });
	
	    (0, _jquery2.default)(countriesPhoneCodeList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
	      els.officeCountryCodeBill.append(option);
	    });
	
	    (0, _jquery2.default)(countriesPhoneCodeList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
	      els.mobileCountryCodeBill.append(option);
	    });
	
	    (0, _jquery2.default)(prefixes).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmMeaning);
	      els.prefix.append(option);
	    });
	  }
	
	  function setStates(countryVal) {
	    els.state.html('');
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', "-1").text('Select State/Province/Region');
	    option.attr('selected', 'selected');
	    option.attr('disabled', 'disabled');
	    var checkZipCode = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	
	    if (countryVal == "US" && checkZipCode) {
	      (0, _selectorHelpers.show)(els.stateSelectContainer);
	      (0, _selectorHelpers.hide)(els.stateTextContainer);
	      //els.countyMandatoryLabel.show();
	
	      els.state.prop('required', true);
	      els.stateTextInput.prop('required', false);
	      els.zipCode.addClass("zipcodeUS");
	      els.zipCode.prop('required', true);
	      els.stateLabel.text('State/Province/Region *');
	      els.postalCodeLabel.text('Postal Code *');
	      els.state.append(option);
	      (0, _jquery2.default)(usaStates).each(function () {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        els.state.append(option);
	      });
	    } else if (countryVal == "CA" && checkZipCode) {
	      (0, _selectorHelpers.show)(els.stateSelectContainer);
	      (0, _selectorHelpers.hide)(els.stateTextContainer);
	      //els.countyMandatoryLabel.hide();
	
	      els.state.prop('required', true);
	      els.stateTextInput.prop('required', false);
	      els.zipCode.removeClass("zipcodeUS");
	      els.zipCode.prop('required', true);
	      els.stateLabel.text('State/Province/Region *');
	      els.postalCodeLabel.text('Postal Code *');
	      els.state.append(option);
	      (0, _jquery2.default)(caProvinces).each(function () {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        els.state.append(option);
	      });
	    } else {
	      if (checkZipCode) {
	        els.stateLabel.text('State/Province/Region');
	        els.postalCodeLabel.text('Postal Code *');
	        els.state.prop('required', false);
	        els.stateTextInput.prop('required', false);
	        els.zipCode.removeClass("zipcodeUS");
	        els.zipCode.prop('required', true);
	        //els.zipCode.valid();
	
	        //els.countyMandatoryLabel.hide();
	        (0, _selectorHelpers.hide)(els.stateSelectContainer);
	        (0, _selectorHelpers.show)(els.stateTextContainer);
	      } else {
	        els.stateLabel.text('State/Province/Region');
	        els.postalCodeLabel.text('Postal Code');
	        els.state.prop('required', false);
	        els.stateTextInput.prop('required', false);
	        els.zipCode.removeClass("zipcodeUS");
	        els.zipCode.prop('required', false);
	        els.zipCode.valid();
	
	        //els.countyMandatoryLabel.hide();
	        (0, _selectorHelpers.hide)(els.stateSelectContainer);
	        (0, _selectorHelpers.show)(els.stateTextContainer);
	      }
	    }
	  }
	
	  function renderViewWithData() {
	    var retailer = getRetailer();
	    if (_underscore2.default.isObject(retailer)) {
	      // During edit, pre populate data
	      setSwithcery(els.sharePrimarySwitch, retailer.rtlBillAccEqPrimary);
	      if (retailer.rtlBillAccEqPrimary) {
	        // If billing tab shared from primary
	        hideAllSections();
	      } else {
	        showAllSections();
	      }
	      var billingAddress = getBillingAddress(retailer);
	      if (_underscore2.default.isObject(billingAddress)) {
	        setData(billingAddress);
	      } else {
	        (0, _selectorHelpers.hide)(els.mobilePhoneSection); // blank form shown with no mobile section
	      }
	    } else {
	      // New retailer
	      (0, _selectorHelpers.hide)(els.mobilePhoneSection); // Not shown on initial load while creating new
	      setSwithcery(els.sharePrimarySwitch, true);
	      // since be default, share primary is Yes, hide all sections
	      hideAllSections();
	    }
	  }
	
	  function setData(billingAddress) {
	    els.country.val(billingAddress.cadCountry).trigger("change");
	    els.address1.val(billingAddress.cadAddress1);
	    els.address2.val(billingAddress.cadAddress2);
	    els.city.val(billingAddress.cadCity);
	
	    if (billingAddress.cadCountry != "US" && billingAddress.cadCountry != "CA") {
	      // Set state text input
	      els.stateTextInput.val(billingAddress.cadState);
	    } else {
	      els.state.val(billingAddress.cadState).trigger("change");
	    }
	
	    els.zipCode.val(billingAddress.cadZipcode);
	    els.county.val(billingAddress.cadCounty);
	
	    els.prefix.val(billingAddress.cadContactNamePrefix).trigger("change");
	    els.firstName.val(billingAddress.cadContactName);
	    els.lastName.val(billingAddress.cadContactLastName);
	    els.email.val(billingAddress.cadContactEmail);
	
	    els.officeCountryCodeBill.val(billingAddress.cadOfficePhoneCountryCode).trigger("change");
	    els.officePhoneBill.val(billingAddress.cadOfficePhone);
	
	    if (els.officeAreaCodeBill) {
	      els.officeAreaCodeBill.val(billingAddress.cadOfficePhoneAreaCode);
	      els.officeAreaCodeBill.addClass('phoneNonUS');
	    }
	    // start
	    if (billingAddress.cadOfficePhoneAreaCode === '+1') {
	
	      els.officePhoneBill.attr("placeholder", "___-____");
	      els.officePhoneBill.addClass('ret-phone-number-jqv');
	      els.officePhoneBill.removeClass('phoneNonUS');
	      els.officePhoneBill.val(billingAddress.cadOfficePhone);
	
	      els.cadOfficePhoneAreaCode.removeClass('phoneNonUS');
	      els.cadOfficePhoneAreaCode.val(billingAddress.cadOfficePhoneAreaCode);
	
	      addmasks();
	    } else {
	      els.officePhoneBill.addClass('phoneNonUS');
	      els.officePhoneBill.removeClass('ret-phone-number-jqv');
	      els.officePhoneBill.removeAttr('placeholder');
	      els.officePhoneBill.inputmask({ mask: "" });
	
	      //cadOfficePhoneAreaCode validation start
	
	      if (els.officeAreaCodeBill) {
	        els.officeAreaCodeBill.addClass('phoneNonUS');
	        els.officeAreaCodeBill.removeAttr('placeholder');
	        els.officeAreaCodeBill.inputmask({ mask: "" });
	      }
	
	      if (billingAddress.cadOfficePhoneAreaCode) {
	        var val = billingAddress.cadOfficePhoneAreaCode;
	        var v = val.replace(/[^0-9.]/g, "");
	        billingAddress.cadOfficePhoneAreaCode = v;
	        els.officeAreaCodeBill.val(v);
	      }
	      //cadOfficePhoneAreaCode validation end
	
	      //cadOfficePhone validation start
	      if (billingAddress.cadOfficePhone) {
	        var _val = billingAddress.cadOfficePhone;
	        var _v = _val.replace(/[^0-9.]/g, "");
	        billingAddress.cadOfficePhone = _v;
	        els.officePhoneBill.val(_v);
	      }
	      if (els.officeAreaCodeBill) {
	        (0, _selectorHelpers.hide)(els.officeAreaCodeBill);
	      }
	      //cadOfficePhone validation end
	    }
	    // End
	
	    els.officeExt.val(billingAddress.cadOfficePhoneExt);
	
	    if (!isMobileInformationPresent(billingAddress)) {
	      els.mobileCountryCodeBill.val(billingAddress.cadMobilePhoneCountryCode).trigger("change");
	
	      if (billingAddress.cadMobilePhoneCountryCode === '+1') {
	
	        els.mobilePhoneBill.removeClass('phoneNonUS');
	        if (els.mobileAreaCodeBill) {
	          els.mobileAreaCodeBill.removeClass('phoneNonUS');
	        }
	        els.mobilePhoneBill.addClass('ret-phone-number-jqv');
	        els.mobilePhoneBill.attr("placeholder", "___-____");
	        addMasksMobilePhone();
	        els.mobilePhoneBill.val(billingAddress.cadMobilePhone);
	
	        if (billingAddress.cadMobilePhoneAreaCode != null) {
	          els.mobileAreaCodeBill.val(billingAddress.cadMobilePhoneAreaCode);
	        } else {
	          (0, _selectorHelpers.hide)(els.mobileAreaCodeBill);
	        }
	      } else {
	
	        /* Start Phone number changes */
	        els.mobilePhoneBill.addClass('phoneNonUS');
	        els.mobilePhoneBill.removeClass('ret-phone-number-jqv');
	        els.mobilePhoneBill.removeAttr('placeholder');
	        els.mobilePhoneBill.inputmask({ mask: "" });
	
	        if (billingAddress.cadMobilePhone) {
	          var _val2 = billingAddress.cadMobilePhone;
	          var _v2 = _val2.replace(/[^0-9.]/g, "");
	          billingAddress.cadMobilePhone = _v2;
	          els.mobilePhoneBill.val(_v2);
	        }
	        /* End Phone number changes */
	
	        /* Start Mobile code number changes */
	        if (els.mobileAreaCodeBill) {
	          els.mobileAreaCodeBill.inputmask({ mask: "" });
	          els.mobileAreaCodeBill.addClass('phoneNonUS');
	          els.mobileAreaCodeBill.removeAttr('placeholder');
	        }
	
	        if (billingAddress.cadMobilePhoneAreaCode) {
	          var _val3 = billingAddress.cadMobilePhoneAreaCode;
	          var _v3 = _val3.replace(/[^0-9.]/g, "");
	          billingAddress.cadMobilePhoneAreaCode = _v3;
	          els.mobileAreaCodeBill.val(_v3);
	          (0, _jquery2.default)('.ret-mobile-area-code-bill').val(_v3);
	        }
	
	        (0, _selectorHelpers.hide)(els.mobileAreaCodeBill);
	      }
	
	      els.mobilePhoneBill.val(billingAddress.cadMobilePhone);
	      if (billingAddress.cadMobilePhoneAreaCode !== null) {
	        els.mobileAreaCodeBill.val(billingAddress.cadMobilePhoneAreaCode);
	      } else {
	        (0, _selectorHelpers.hide)(els.mobileAreaCodeBill);
	      }
	      (0, _selectorHelpers.hide)(els.addMobileBtn);
	    } else {
	      (0, _selectorHelpers.hide)(els.mobilePhoneSection);
	      (0, _selectorHelpers.show)(els.addMobileBtn);
	    }
	  }
	
	  function setPrimaryInfoData() {
	    els.country.val(primaryEls.country.val()).trigger("change");
	    els.address1.val(primaryEls.address1.val());
	    els.address2.val(primaryEls.address2.val());
	    els.city.val(primaryEls.city.val());
	
	    if (primaryEls.country.val() != "US" && primaryEls.country.val() != "CA") {
	      // Set state text input
	      els.stateTextInput.val(primaryEls.stateTextInput.val());
	    } else {
	      els.state.val(primaryEls.state.val()).trigger("change");
	    }
	
	    els.zipCode.val(primaryEls.zipCode.val());
	    els.county.val(primaryEls.county.val());
	
	    els.prefix.val(primaryEls.prefix.val()).trigger("change");
	    els.firstName.val(primaryEls.firstName.val());
	    els.lastName.val(primaryEls.lastName.val());
	    els.email.val(primaryEls.email.val());
	
	    els.officeCountryCodeBill.val(primaryEls.officeCountryCode.val()).trigger("change");
	    els.officePhoneBill.val(primaryEls.officePhone.val());
	    els.officeAreaCodeBill.val(primaryEls.officeAreaCode.val());
	    els.officeExt.val(primaryEls.officeExt.val());
	
	    if (primaryEls.mobilePhoneSection.is(":visible")) {
	      (0, _selectorHelpers.show)(els.mobilePhoneSection);
	      els.mobileCountryCodeBill.val(primaryEls.mobileCountryCode.val()).trigger("change");
	      els.mobilePhoneBill.val(primaryEls.mobilePhone.val());
	      els.mobileAreaCodeBill.val(primaryEls.mobileAreaCode.val());
	      (0, _selectorHelpers.hide)(els.addMobileBtn);
	    } else {
	      (0, _selectorHelpers.hide)(els.mobilePhoneSection);
	      (0, _selectorHelpers.show)(els.addMobileBtn);
	    }
	  }
	
	  function setSwithcery(checkbox, bool) {
	    (0, _instantiateSwitchery.instantiateSwitchery)(checkbox);
	    (0, _instantiateSwitchery.setSwitchery)(checkbox, bool);
	  }
	
	  function handleAddMobileBtn() {
	    (0, _selectorHelpers.show)(els.mobilePhoneSection);
	    (0, _selectorHelpers.hide)(els.addMobileBtn);
	  }
	
	  function handleRemoveMobileBtn() {
	    (0, _selectorHelpers.hide)(els.mobilePhoneSection);
	    (0, _selectorHelpers.show)(els.addMobileBtn);
	    els.mobileCountryCodeBill.val('');
	    els.mobilePhoneBill.val('');
	    els.mobileAreaCodeBill.val('');
	
	    var retailer = getRetailer();
	    if (_underscore2.default.isObject(retailer)) {
	      var billingAddress = getBillingAddress(retailer);
	      billingAddress.cadMobilePhoneCountryCode = '';
	      billingAddress.cadMobilePhone = '';
	      billingAddress.cadMobilePhoneAreaCode = '';
	    }
	  }
	
	  function isMobileInformationPresent(billingAddress) {
	    return (0, _general.isBlank)(billingAddress.cadMobilePhoneCountryCode) && (0, _general.isBlank)(billingAddress.cadMobilePhone) && (0, _general.isBlank)(billingAddress.cadMobilePhoneAreaCode);
	  }
	
	  function handleSharePrimarySwitch() {
	    if (isWizardOnBillingTab()) {
	      if (this.checked) {
	        hideAllSections();
	      } else {
	        showAllSections();
	        if (!isEdit() && !isDataModified) {
	          setPrimaryInfoData();
	        }
	      }
	    }
	  }
	
	  function handleInputChange(e) {
	    e.preventDefault();
	    if (isWizardOnBillingTab() && !self.isPrimarySwitchOn()) {
	      isDataModified = true;
	    }
	  }
	
	  function isWizardOnBillingTab() {
	    return (0, _jquery2.default)(wizard.getActiveTargetForm()).filter(".billing-information-tab").length > 0;
	  }
	
	  self.isPrimarySwitchOn = function () {
	    return (0, _jquery2.default)('.billing-information-tab .switch-share-primary').is(":checked");
	  };
	
	  function showAllSections() {
	    (0, _selectorHelpers.show)(els.addressSection);
	    (0, _selectorHelpers.show)(els.contactSection);
	    (0, _selectorHelpers.show)(els.phoneSection);
	  }
	
	  function hideAllSections() {
	    (0, _selectorHelpers.hide)(els.addressSection);
	    (0, _selectorHelpers.hide)(els.contactSection);
	    (0, _selectorHelpers.hide)(els.phoneSection);
	  }
	
	  function countryChange() {
	    var countryVal = els.country.find('option:selected').val();
	    var isValidCountry = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        countryId = this.conPhoneCode.toString();
	        return false;
	      }
	    });
	    (0, _jquery2.default)(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryVal.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (isValidCountry) {
	      (0, _jquery2.default)(".country_not_supported_billing").hide();
	    } else {
	      (0, _jquery2.default)(".country_not_supported_billing").show();
	    }
	    setStates(countryVal);if (countryVal === "US") {
	      (0, _jquery2.default)(".ret-office-country-code-bill option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States of America +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "CA") {
	      (0, _jquery2.default)(".ret-office-country-code-bill option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "Canada +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "UM") {
	      (0, _jquery2.default)(".ret-office-country-code-bill option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States Minor Outlying Islands +1";
	      }).prop("selected", true).trigger("change");
	    } else {
	      (0, _jquery2.default)(".ret-office-country-code-bill option").filter(function () {
	        var text = (0, _jquery2.default)(this).val().toString();
	        return text === countryId.toString();
	      }).prop("selected", true).trigger("change");
	      //$(".ret-office-country-code option:contains("+countryId+")").attr('selected', 'selected').trigger("change");
	    }
	    if (countryVal === "US" || countryVal === "CA") {
	      (0, _selectorHelpers.show)(els.officeAreaCodeBill);
	      els.officePhoneBill.attr("placeholder", "___-____");
	      els.officePhoneBill.addClass('ret-phone-number-jqv');
	      els.officePhoneBill.removeClass('phoneNonUS');
	      addmasks();
	    } else {
	      els.officeAreaCodeBill.val('');
	      if (els.officeAreaCodeBill) {
	        (0, _selectorHelpers.hide)(els.officeAreaCodeBill);
	      }
	      els.officePhoneBill.val('');
	      els.officePhoneBill.addClass('phoneNonUS');
	      els.officePhoneBill.removeClass('ret-phone-number-jqv');
	      els.officePhoneBill.removeAttr('placeholder');
	      els.officePhoneBill.inputmask({
	        mask: ""
	      });
	    }
	  }
	
	  function addmasks() {
	    (0, _jquery2.default)('.ret-office-area-code-bill').inputmask({
	      mask: "(999)"
	    });
	
	    (0, _jquery2.default)('.ret-office-phone-bill').inputmask({
	      mask: "999-9999"
	    });
	  }
	
	  function addMasksMobilePhone() {
	    (0, _jquery2.default)('.ret-mobile-area-code-bill').inputmask({
	      mask: "(999)"
	    });
	
	    (0, _jquery2.default)('.ret-mobile-phone-bill').inputmask({
	      mask: "999-9999"
	    });
	  }
	
	  function mobileCountryCodeChange() {
	    var mobilecode = els.mobileCountryCodeBill.find('option:selected').val().toString();
	    els.mobilePhoneBill.val('');
	    if (els.mobileAreaCodeBill) {
	      els.mobileAreaCodeBill.val('');
	    }
	    if (mobilecode === '+1') {
	      (0, _selectorHelpers.show)(els.mobileAreaCodeBill);
	      els.mobilePhoneBill.attr("placeholder", "___-____");
	      els.mobilePhoneBill.addClass('ret-phone-number-jqv');
	      els.mobilePhoneBill.removeClass('phoneNonUS');
	      if (els.mobileAreaCodeBill) {
	        els.mobileAreaCodeBill.removeClass('phoneNonUS');
	      }
	      addMasksMobilePhone();
	    } else {
	      (0, _selectorHelpers.hide)(els.mobileAreaCodeBill);
	      els.mobilePhoneBill.addClass('phoneNonUS');
	      els.mobilePhoneBill.removeClass('ret-phone-number-jqv');
	      els.mobilePhoneBill.removeAttr('placeholder');
	      els.mobilePhoneBill.inputmask({ mask: "" });
	    }
	  }
	
	  function officeCountryCodeChange() {
	    var phoneCode = els.officeCountryCodeBill.find('option:selected').val().toString();
	    els.officePhoneBill.val('');
	    if (els.officeAreaCodeBill) {
	      els.officeAreaCodeBill.val('');
	    }
	    if (phoneCode === '+1') {
	      (0, _selectorHelpers.show)(els.officeAreaCodeBill);
	      els.officePhoneBill.attr("placeholder", "___-____");
	      els.officePhoneBill.addClass('ret-phone-number-jqv');
	      els.officePhoneBill.removeClass('phoneNonUS');
	      if (els.officeAreaCodeBill) {
	        els.officeAreaCodeBill.removeClass('phoneNonUS');
	      }
	      addmasks();
	    } else {
	      (0, _selectorHelpers.hide)(els.officeAreaCodeBill);
	      els.officePhoneBill.addClass('phoneNonUS');
	      els.officePhoneBill.removeClass('ret-phone-number-jqv');
	      els.officePhoneBill.removeAttr('placeholder');
	      els.officePhoneBill.inputmask({
	        mask: ""
	      });
	    }
	  }
	
	  function getRetailer() {
	    if (!(0, _general.isBlank)(retailerJsonString)) {
	      return retailerJsonString;
	    } else {
	      return null;
	    }
	  }
	
	  function getBillingAddress(retailer) {
	    var billingAddress = (0, _underscore2.default)(retailer.retailerAddresses).find(function (address, k) {
	      return address.cadAddressType == "Billing";
	    });
	
	    return billingAddress;
	  }
	
	  function existingRetailerHasBillingAddress() {
	    return isEdit() && _underscore2.default.isObject(getBillingAddress(getRetailer()));
	  }
	
	  function isEdit() {
	    return _underscore2.default.isObject(getRetailer());
	  }
	}

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DetailsTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  companyName: '#companyName',
	  taxId: '#taxId'
	};
	var businessInformationElementsMap = {
	  fscbusinessunit: '.fsc-business-unit',
	  customerbusinessunit: 'customer-business-unit',
	  contractstartandenddate: '.contract-start-and-end-date',
	  contracttype: '.contract-type'
	};
	var additionalInformationElementsMap = {
	  primaryurl: '.primary-url',
	  hostsystem: "#host-system",
	  requireforwardstockinglocations: '.require-forward-stocking-locations'
	
	};
	var affiliatedInformationElementsMap = {
	  affMerchantName: '#aff-merchant-name',
	  addMerchantBtn: '.add-merchant-btn',
	  addAffMerchant: '.add-aff-merchant',
	  duplicateMessage: '#duplicate-message'
	};
	function DetailsTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var fscbusinessunits = wizardElement.data('fscbusinessunits');
	  var contracttype = wizardElement.data('contracttype');
	  var els = {};
	
	  var detailsTab = wizardElement.find('.details-tab');
	  self.init = function () {
	    renderDetailsTab();
	  };
	
	  function renderDetailsTab() {
	    setElements();
	    (0, _selectorHelpers.setUniqNamesAndIds)(els);
	    loadDropDowns();
	    els.addMerchantBtn.on('click', function (e) {
	      e.preventDefault();
	      var affMerchantNameValue = els.affMerchantName.val().trim();
	      var addedAffiliatedMerchantHtml = " <div class=\"col-xs-12 aff-merchant-text q-marg-top-md\">\n             <input class=\"q-input q-stretch affMerchantNameValue\" maxlength=\"50\"\n             type=\"text\" id=\"" + affMerchantNameValue + "\" value=\"" + affMerchantNameValue + "\"/>\n             </div>";
	      if (affMerchantNameValue && affMerchantNameValue.trim() != '') {
	        var valuesExists = false;
	        _jquery2.default.each((0, _jquery2.default)('.affMerchantNameValue'), function (ind, element) {
	          var existingVal = (0, _jquery2.default)(element).val();
	          if (affMerchantNameValue.toString().toUpperCase() === existingVal.toString().toUpperCase()) {
	            valuesExists = true;
	            els.duplicateMessage.show();
	          }
	        });
	        if (!valuesExists) {
	          els.duplicateMessage.hide();
	          els.addAffMerchant.append(addedAffiliatedMerchantHtml);
	        }
	      }
	      els.affMerchantName.val('');
	      (0, _jquery2.default)('#one-affiliated-message').hide();
	    });
	  }
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, detailsTab);
	    (0, _selectorHelpers.setElementsFromScope)(els, businessInformationElementsMap, detailsTab);
	    (0, _selectorHelpers.setElementsFromScope)(els, additionalInformationElementsMap, detailsTab);
	    (0, _selectorHelpers.setElementsFromScope)(els, affiliatedInformationElementsMap, detailsTab);
	  }
	  function loadDropDowns() {
	    (0, _jquery2.default)(fscbusinessunits).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmMeaning);
	      els.fscbusinessunit.append(option);
	    });
	    (0, _jquery2.default)(contracttype).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmMeaning);
	      els.contracttype.append(option);
	    });
	  }
	}

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FscFacilitiesTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  facilitieslist: '#facilitieslist',
	  fscfacilitesuses: '#fscfacilitesuses',
	  fscFacilityType: '.fscFacilityType',
	  fscBussinesUnitMsg: '.fsc-bussines-unit-msg',
	  savedFacilities: '#savedfacilities'
	};
	
	function FscFacilitiesTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	  var fscFacilitiesTab = wizardElement.find('.fscFacilities-tab');
	  var facilities = wizardElement.data('facilities');
	  var facilityTypes = wizardElement.data('facility-types');
	  var getfacilitesconfigurations = wizardElement.data('getfacilitesconfigurations');
	  var savedFacilitiesArray = [];
	  var savedFacilityBussinessUnit = void 0;
	  self.init = function () {
	    renderFscFacilitiesTab();
	  };
	  function renderFscFacilitiesTab() {
	    setElements();
	    (0, _selectorHelpers.setUniqNamesAndIds)(els);
	    loadDropDowns();
	    bindElements();
	    (0, _selectorHelpers.hide)(els.fscBussinesUnitMsg);
	  }
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, fscFacilitiesTab);
	  }
	  function loadDropDowns() {
	    (0, _jquery2.default)(facilities).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      var optionvalue = this.facCode + "-" + this.facName;
	      option.attr('value', this.facId).text(optionvalue);
	      els.facilitieslist.append(option);
	    });
	  }
	
	  function bindElements() {
	    els.facilitieslist.on("change", facilitiesConfigure);
	    (0, _jquery2.default)(document).on("click", '.fscFacilities-tab .fscFacilityType', handleAddFacilityBtn);
	    (0, _jquery2.default)(document).on("click", '.fscFacilities-tab .remove-facility-btn', handleRemoveFacilityBtn);
	    (0, _jquery2.default)(document).on("click", '.fscFacilities-tab .add-facility-btn', handleSavedAddFacilityBtn);
	    (0, _jquery2.default)(document).on("click", '.fscFacilities-tab .saved-facility-remove-btn', handleRemoveSavedFacilityBtn);
	  }
	  function handleAddFacilityBtn() {
	    var value = (0, _jquery2.default)('[name="facilityType"]:checked').length;
	    var atLeastOneFacUse = wizardElement.find('.fscFacilities-tab .select-atleastone-facuse');
	    var addFacilityBtn = wizardElement.find('.fscFacilities-tab .add-facility-btn');
	    if (value > 0) {
	      addFacilityBtn.attr("disabled", false);
	      (0, _selectorHelpers.hide)(atLeastOneFacUse);
	    } else {
	      addFacilityBtn.attr("disabled", true);
	      (0, _selectorHelpers.show)(atLeastOneFacUse);
	    }
	  }
	  function handleRemoveFacilityBtn() {
	    els.facilitieslist.val('').trigger('change');
	    (0, _selectorHelpers.hide)(els.fscBussinesUnitMsg);
	    (0, _selectorHelpers.hide)(els.fscfacilitesuses);
	  }
	  function facilitiesConfigure() {
	    var facid = els.facilitieslist.find('option:selected').val();
	    if (facid) {
	      _jquery2.default.ajax({
	        url: getfacilitesconfigurations,
	        data: {
	          facid: facid
	        },
	        type: 'GET',
	        success: function success(data) {
	          getRenderedFSCFacility(data);
	        }
	      });
	      (0, _selectorHelpers.show)(els.fscfacilitesuses);
	    }
	  }
	  function getRenderedFSCFacility(data) {
	    data = JSON.parse(data);
	    var facilities = data[0].facilityaddress;
	    var bussunit = (0, _jquery2.default)('.fsc-business-unit').find('option:selected').val();
	    savedFacilityBussinessUnit = facilities.facBusinessUnit;
	    if (facilities.facBusinessUnit !== bussunit) {
	      (0, _selectorHelpers.show)(els.fscBussinesUnitMsg);
	    } else {
	      (0, _selectorHelpers.hide)(els.fscBussinesUnitMsg);
	    }
	    var fscFacilitiesConfigurationHtml = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(1351), {
	      facilitiesConfig: facilities,
	      facilityTypes: getRenderedFacilityTypes(facilityTypes)
	    }));
	    els.fscfacilitesuses.html(fscFacilitiesConfigurationHtml);
	    loadOperationsandSqrtFootValues(facilities);
	    handleAddFacilityBtn();
	  }
	  function getRenderedFacilityTypes(facilityTypes) {
	    var facilityTypeHtml = __webpack_require__(1350);
	    var response = _underscore2.default.map(facilityTypes, function (facility) {
	      return (0, _render2.default)(facilityTypeHtml, {
	        facility: facility
	      });
	    });
	    return response.join("");
	  }
	
	  function handleSavedAddFacilityBtn(e) {
	    e.preventDefault();
	    var checkedfacilitiesuses = [];
	    _jquery2.default.each((0, _jquery2.default)('[name="facilityType"]:checked'), function () {
	      checkedfacilitiesuses.push((0, _jquery2.default)(this).val());
	    });
	    var facid = els.facilitieslist.find('option:selected').val();
	    var facilityname = els.facilitieslist.find('option:selected').text();
	    // let selectedbussinessunit=$('.fsc-business-unit').find('option:selected').val();
	    var facilitiesuses = checkedfacilitiesuses.join(", ");
	    var objexist = true;
	    var savedfacilityobj = {
	      facid: facid,
	      facilityname: facilityname,
	      selectedbussinessunit: savedFacilityBussinessUnit,
	      facilitiesuses: facilitiesuses
	    };
	    if (savedFacilitiesArray.length == 0) savedFacilitiesArray.push(savedfacilityobj);
	    for (var i in savedFacilitiesArray) {
	      if (savedFacilitiesArray[i].facid == facid) {
	        //savedFacilitiesArray[i].selectedbussinessunit = selectedbussinessunit;
	        savedFacilitiesArray[i].facilitiesuses = facilitiesuses;
	        objexist = false;
	        break;
	      }
	    }
	    if (objexist) {
	      savedFacilitiesArray.push(savedfacilityobj);
	    }
	    var savedFacilitiesHtml = getRenderedSavedFacilities(savedFacilitiesArray);
	    els.savedFacilities.html(savedFacilitiesHtml);
	    //handleRemoveFacilityBtn();
	  }
	  function getRenderedSavedFacilities(savedFacilitiesArray) {
	    var savedFacilitiesHtml = __webpack_require__(1359);
	    var response = _underscore2.default.map(savedFacilitiesArray, function (obj, index) {
	      return (0, _render2.default)(savedFacilitiesHtml, {
	        savedobject: obj,
	        index: index
	      });
	    });
	    return response.join("");
	  }
	  function handleRemoveSavedFacilityBtn(e) {
	    e.preventDefault();
	    var index = (0, _jquery2.default)(this).attr('id');
	    savedFacilitiesArray.splice(index, 1);
	    var savedFacilitiesHtml = getRenderedSavedFacilities(savedFacilitiesArray);
	    els.savedFacilities.html(savedFacilitiesHtml);
	  }
	  function loadOperationsandSqrtFootValues(facData) {
	
	    if (facData != null && facData != '') {
	      var facAttributesData = new Set(facData.facilitiesAttributesSet);
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = facAttributesData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var keyval = _step.value;
	
	          var arr_names = new Array(keyval);
	
	          var _loop = function _loop(j) {
	            var attrName = void 0;
	            var attrValue = void 0;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = Object.keys(arr_names[j])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var k = _step2.value;
	
	                if (k == "faaKey") {
	                  attrName = arr_names[j][k];
	                } else if (k == "faaValue") {
	                  attrValue = arr_names[j][k];
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	
	            if (attrName != null && attrValue != null) {
	              if (attrName == "FAC_USE_ATTR") {
	                var fcyuseselement = wizardElement.find('.fscFacilities-tab .fscFacilityType');
	                _underscore2.default.each(fcyuseselement, function (el) {
	                  var ele = (0, _jquery2.default)(el);
	                  if (ele.val() == attrValue) {
	                    ele.prop('checked', true);
	                  }
	                });
	              }
	            }
	          };
	
	          for (var j = 0; j < arr_names.length; j++) {
	            _loop(j);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }
	}

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = PrimaryTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _general = __webpack_require__(5);
	
	var _util = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  companyName: '.company-name',
	  taxId: '.tax-id',
	  url: '.primary-url',
	  prefix: '.ret-prefix',
	  firstName: '.ret-first-name',
	  lastName: '.ret-last-name',
	  email: '.ret-email',
	  duplicateMessage: '#duplicate-message',
	  affMerchantText: '.aff-merchant-text',
	  affMerchantName: '#aff-merchant-name',
	  addMerchantBtn: '.add-merchant-btn',
	  fedexCanCall: '.fedex-can-call',
	  addMobileBtn: '.add-mobile-number-btn',
	  removeMobileBtn: '.remove-mobile-btn',
	  addressSection: '.address-section',
	  contactSection: '.contact-section',
	  phoneSection: '.phone-section',
	  addAffMerchant: '.add-aff-merchant',
	  masterAccountSection: '.master-account-section',
	  masterAccountToggleCheckbox: '.master-account-toggle-checkbox',
	  managedByMasterAccountSection: '.managed-by-master-account-section',
	  managedByMasteraccountToggleCheckbox: '.managed-by-masteraccount-toggle-checkbox',
	  masteraccountDropdown: '.masteraccount-dropdown',
	  supplyChainFacilitySection: '.supplychain-facility-section',
	  //addressValidSwitch:'.address-valid-switch',
	  insightFeedSwitch: '.insight-feed-switch',
	  merchantTiers: '.merchant-tier',
	  fontanaFedExId: ".Fontana-fedex-id",
	  greenwoodFedexId: ".Greenwood-fedex-id",
	  fuelSurchrgSwitch: '.fuel-Surchrg-switch',
	  directBillSwitch: '.direct-bill-switch'
	};
	
	var addressElementsMap = {
	  country: '.ret-country',
	  address1: '.ret-address1',
	  address2: '.ret-address2',
	  city: '.ret-city',
	  state: '.ret-state',
	  zipCode: '.ret-zip-code',
	  postalCodeLabel: '#postalcode-label',
	  stateLabel: '#state-label',
	  county: '.ret-county',
	  countyMandatoryLabel: '.county-mandatory-label',
	  stateSelectContainer: '.state-wrapper',
	  stateTextContainer: '.state-text-wrapper',
	  stateTextInput: '.ret-state-text',
	  commercialAddressFlag: '.commercial-addr-flag'
	};
	
	var phoneElementsMap = {
	  officeCountryCode: '.ret-office-country-code',
	  officePhone: '.ret-office-phone',
	  officeAreaCode: '.ret-office-area-code',
	  officeExt: '.ret-office-ext',
	  mobileCountryCode: '.ret-mobile-country-code',
	  mobilePhone: '.ret-mobile-phone',
	  mobileAreaCode: '.ret-mobile-area-code',
	  mobilePhoneSection: '.ret-mobile-number-section'
	};
	
	function PrimaryTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	  var retailerWizard = (0, _jquery2.default)('#retailer-wizard');
	  var validationReqdCountries = JSON.parse(retailerWizard.attr("data-validation-reqd-countries"));
	  var primaryTab = wizardElement.find('.primary-information-tab');
	  var defaultContry = wizardElement.data('default-country');
	  var usaStates = wizardElement.data('usa-states');
	  var caProvinces = wizardElement.data('ca-provinces');
	  var countriesPhoneCodeList = wizardElement.data('country-phone-code-list');
	  var countries = wizardElement.data('countries');
	  var prefixes = wizardElement.data('prefixes');
	  var retailerJsonString = wizardElement.data('retailer-obj');
	  var rtlType = wizardElement.data('rtl-type');
	  var parentRetailersList = wizardElement.data('parent-retailers').data;
	  var merchantTier = wizardElement.data('merchant-tiers');
	  var countryId = void 0;
	  self.init = function () {
	    renderPrimaryTab();
	  };
	
	  function renderPrimaryTab() {
	    setElements();
	    // jquery validator needs that all "name" attribute are unique and we are usinng same phone and address template on each tab.
	    (0, _selectorHelpers.setUniqNamesAndIds)(els);
	    // SInce we are adding dynamic uuid to id and name for each element and since the "for" attribute
	    // needs same string as id of element, fedexCanCall checkbox was not getting clicked.
	    (0, _jquery2.default)("label[for=fedex-can-call]").attr("for", els.fedexCanCall.attr("id"));
	    bindElements();
	    loadDropDowns();
	    setStates(defaultContry);
	    renderViewWithData();
	    els.masterAccountToggleCheckbox.on('change', masterAccountToggleChange);
	
	    function masterAccountToggleChange() {
	      var isChecked = (0, _jquery2.default)(this).is(':checked');
	      if (isChecked) {
	        els.managedByMasterAccountSection.addClass('q-display-none');
	      } else {
	        els.managedByMasterAccountSection.removeClass('q-display-none');
	      }
	
	      els.masterAccountToggleCheckbox.checked = isChecked;
	      els.managedByMasteraccountToggleCheckbox.checked = !isChecked;
	    }
	
	    els.managedByMasteraccountToggleCheckbox.on('change', managedByMasterAccountToggleChange);
	
	    function managedByMasterAccountToggleChange() {
	      var isChecked = (0, _jquery2.default)(this).is(':checked');
	      if (isChecked) {
	        els.masterAccountSection.addClass('q-display-none');
	      } else {
	        els.masterAccountSection.removeClass('q-display-none');
	      }
	
	      els.managedByMasteraccountToggleCheckbox.checked = isChecked;
	      els.masterAccountToggleCheckbox.checked = !isChecked;
	    }
	    els.addMerchantBtn.on('click', function (e) {
	      e.preventDefault();
	      var affMerchantNameValue = els.affMerchantName.val().trim();
	      var addedAffiliatedMerchantHtml = " <div class=\"col-xs-12 aff-merchant-text q-marg-top-md\">\n              <input class=\"q-input q-stretch affMerchantNameValue\" \n              type=\"text\" id=\"" + affMerchantNameValue + "\" value=\"" + affMerchantNameValue + "\"/>\n              </div>";
	      if (affMerchantNameValue && affMerchantNameValue.trim() != '') {
	        var valuesExists = false;
	        _jquery2.default.each((0, _jquery2.default)('.affMerchantNameValue'), function (ind, element) {
	          var existingVal = (0, _jquery2.default)(element).val();
	          if (affMerchantNameValue.toString().toUpperCase() === existingVal.toString().toUpperCase()) {
	            valuesExists = true;
	            els.duplicateMessage.show();
	          }
	        });
	        if (!valuesExists) {
	          els.duplicateMessage.hide();
	          els.addAffMerchant.append(addedAffiliatedMerchantHtml);
	        }
	      }
	      els.affMerchantName.val('');
	    });
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, primaryTab);
	    (0, _selectorHelpers.setElementsFromScope)(els, addressElementsMap, primaryTab);
	    (0, _selectorHelpers.setElementsFromScope)(els, phoneElementsMap, primaryTab);
	  }
	
	  function bindElements() {
	    els.country.on("change", countryChange);
	    els.officeCountryCode.on("change", officeCountryCodeChange);
	    els.mobileCountryCode.on("change", mobileCountryCodeChange);
	    (0, _jquery2.default)(document).on("click", '.primary-information-tab .add-mobile-number-btn', handleAddMobileBtn);
	    (0, _jquery2.default)(document).on("click", '.primary-information-tab .remove-mobile-btn', handleRemoveMobileBtn);
	    els.directBillSwitch.on("change", validateDirectBillField);
	    els.fuelSurchrgSwitch.on("change", validateFuelSurchargeField);
	  }
	
	  function loadDropDowns() {
	    (0, _jquery2.default)(countries).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conCode).text(this.conName);
	      els.country.append(option);
	    });
	
	    (0, _jquery2.default)(countriesPhoneCodeList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
	      els.officeCountryCode.append(option);
	    });
	
	    (0, _jquery2.default)(countriesPhoneCodeList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
	      els.mobileCountryCode.append(option);
	    });
	
	    (0, _jquery2.default)(prefixes).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmMeaning);
	      els.prefix.append(option);
	    });
	
	    var retailerObj = getRetailer();
	
	    (0, _jquery2.default)(parentRetailersList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.rtlId).text(this.rtlName);
	      if (_underscore2.default.isObject(retailerObj)) {
	        if (this.rtlId == retailerObj.rtlMasterAccountId) {
	          option.attr('selected', 'true');
	        }
	      }
	      els.masteraccountDropdown.append(option);
	    });
	
	    // E-111737  commented for Enable ability to update individual merchant to parent/child START
	    // if(_.isObject(retailerObj)) {
	    //  els.masteraccountDropdown.attr('disabled', 'disabled');
	    // }
	    // E-111737 Enable ability to update individual merchant to parent/child END
	
	    (0, _jquery2.default)(merchantTier).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmMeaning);
	      els.merchantTiers.append(option);
	    });
	  }
	
	  function setStates(countryVal) {
	    els.state.html('');
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', "-1").text('Select State/Province/Region');
	    option.attr('selected', 'selected');
	    option.attr('disabled', 'disabled');
	    var checkZipCode = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	    if (countryVal == "US" && checkZipCode) {
	      (0, _selectorHelpers.show)(els.stateSelectContainer);
	      (0, _selectorHelpers.hide)(els.stateTextContainer);
	      //els.countyMandatoryLabel.show();
	      //els.county.prop('required',false);
	
	      els.state.prop('required', true);
	      els.stateTextInput.prop('required', false);
	      els.zipCode.addClass("zipcodeUS");
	      els.zipCode.prop('required', true);
	
	      els.state.append(option);
	      els.stateLabel.text('State/Province/Region *');
	      els.postalCodeLabel.text('Postal Code *');
	      (0, _jquery2.default)(usaStates).each(function () {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        els.state.append(option);
	      });
	    } else if (countryVal == "CA" && checkZipCode) {
	      (0, _selectorHelpers.show)(els.stateSelectContainer);
	      (0, _selectorHelpers.hide)(els.stateTextContainer);
	      //els.countyMandatoryLabel.hide();
	      //  els.county.prop('required',false);
	
	      els.state.prop('required', true);
	      els.stateTextInput.prop('required', false);
	      els.zipCode.removeClass("zipcodeUS");
	      els.zipCode.prop('required', true);
	      els.state.append(option);
	      els.stateLabel.text('State/Province/Region *');
	      els.postalCodeLabel.text('Postal Code *');
	      (0, _jquery2.default)(caProvinces).each(function () {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        els.state.append(option);
	      });
	    } else {
	      if (checkZipCode) {
	        els.stateLabel.text('State/Province/Region');
	        els.postalCodeLabel.text('Postal Code *');
	        els.state.prop('required', false);
	        els.stateTextInput.prop('required', false);
	        els.zipCode.removeClass("zipcodeUS");
	        els.zipCode.prop('required', true);
	        //els.zipCode.valid();
	        //els.countyMandatoryLabel.hide();
	
	        //els.county.prop('required',false);
	        (0, _selectorHelpers.hide)(els.stateSelectContainer);
	        (0, _selectorHelpers.show)(els.stateTextContainer);
	      } else {
	        els.stateLabel.text('State/Province/Region');
	        els.postalCodeLabel.text('Postal Code');
	        els.state.prop('required', false);
	        els.stateTextInput.prop('required', false);
	        els.zipCode.removeClass("zipcodeUS");
	        els.zipCode.prop('required', false);
	        els.zipCode.valid();
	        //els.countyMandatoryLabel.hide();
	
	        //els.county.prop('required',false);
	        (0, _selectorHelpers.hide)(els.stateSelectContainer);
	        (0, _selectorHelpers.show)(els.stateTextContainer);
	      }
	    }
	  }
	
	  function setSwithcery(checkbox, bool) {
	    (0, _instantiateSwitchery.instantiateSwitchery)(checkbox);
	    (0, _instantiateSwitchery.setSwitchery)(checkbox, bool);
	  }
	
	  function renderViewWithData() {
	    showAllSections();
	    var retailer = getRetailer();
	    var insightFeedSwitchEl = els.insightFeedSwitch;
	    var fuelSurchrgSwitchEl = els.fuelSurchrgSwitch;
	    var directBillEl = els.directBillSwitch;
	
	    if (_underscore2.default.isObject(retailer)) {
	      // During edit, pre populate data
	      if (!(0, _util.isNullOrUndefined)(retailer.rtlInsightFeedFlag) && insightFeedSwitchEl.length > 0) {
	        setSwithcery(els.insightFeedSwitch, retailer.rtlInsightFeedFlag);
	      }
	      if (!(0, _util.isNullOrUndefined)(retailer.rtlFuelSurchrgDiscFlag) && fuelSurchrgSwitchEl.length > 0) {
	        setSwithcery(els.fuelSurchrgSwitch, retailer.rtlFuelSurchrgDiscFlag);
	      }
	      if (!(0, _util.isNullOrUndefined)(retailer.directBillCustomerFlag) && directBillEl.length > 0) {
	        setSwithcery(els.directBillSwitch, retailer.directBillCustomerFlag);
	      }
	    }
	    var primaryAddress = getPrimaryAddress();
	    if (_underscore2.default.isObject(primaryAddress)) {
	      // During edit, pre populate data
	      setData(primaryAddress);
	    } else {
	      // New retailer
	      (0, _selectorHelpers.hide)(els.mobilePhoneSection); // Not shown on initial load while creating new
	    }
	  }
	
	  function setData(primaryAddress) {
	
	    els.masterAccountToggleCheckbox.attr('checked', primaryAddress.rtlMasterFlag);
	
	    els.managedByMasteraccountToggleCheckbox.attr('checked', primaryAddress.rtlVirtualFlag);
	
	    els.masterAccountToggleCheckbox.checked = primaryAddress.rtlMasterFlag;
	    els.managedByMasteraccountToggleCheckbox.checked = primaryAddress.rtlVirtualFlag;
	
	    // E-111737 Enable ability to update individual merchant to parent/child START
	    var retailerObj = getRetailer();
	    if (_underscore2.default.isObject(retailerObj)) {
	      if (retailerObj.rtlMasterFlag || retailerObj.rtlVirtualFlag) {
	        els.masterAccountToggleCheckbox.prop('readonly', true);
	        els.managedByMasteraccountToggleCheckbox.prop('readonly', true);
	        els.masteraccountDropdown.attr('disabled', 'disabled');
	        els.masteraccountDropdown.prop('readonly', true);
	      }
	    }
	    // E-111737 Enable ability to update individual merchant to parent/child END
	
	    if (primaryAddress.rtlMasterFlag) {
	      els.managedByMasterAccountSection.addClass('q-display-none');
	    } else {
	      els.managedByMasterAccountSection.removeClass('q-display-none');
	    }
	
	    if (primaryAddress.rtlVirtualFlag) {
	      els.masterAccountSection.addClass('q-display-none');
	    } else {
	      els.masterAccountSection.removeClass('q-display-none');
	    }
	
	    els.companyName.val(primaryAddress.rtlName);
	    //els.companyName.prop('readonly', true);
	    if (!(0, _general.isBlank)(primaryAddress.rtlTaxId)) {
	      els.taxId.val(primaryAddress.rtlTaxId);
	      els.taxId.prop('readonly', true);
	    }
	    /*if(primaryAddress.retailerFedExIds!=null){
	    if (!isBlank(primaryAddress.retailerFedExIds.fontanaFedExId)) {
	      els.fontanaFedExId.val(primaryAddress.retailerFedExIds.fontanaFedExId);
	    }
	    if (!isBlank(primaryAddress.retailerFedExIds.greenwoodFedExId)) {
	      els.greenwoodFedexId.val(primaryAddress.retailerFedExIds.greenwoodFedExId);
	    }
	    }*/
	    els.url.val(primaryAddress.rtlWebUrl);
	    els.merchantTiers.val(primaryAddress.rtlTier).trigger("change");
	    els.country.val(primaryAddress.rtlConCode).trigger("change");
	    els.address1.val(primaryAddress.rtlAddress1);
	    els.address2.val(primaryAddress.rtlAddress2);
	    els.city.val(primaryAddress.rtlCity);
	
	    if (primaryAddress.rtlConCode != "US" && primaryAddress.rtlConCode != "CA") {
	      // Set state text input
	      els.stateTextInput.val(primaryAddress.rtlState);
	    } else {
	      els.state.val(primaryAddress.rtlState).trigger("change");
	    }
	
	    els.zipCode.val(primaryAddress.rtlZip);
	    els.county.val(primaryAddress.rtlCounty);
	
	    els.prefix.val(primaryAddress.rtlContactNamePrefix).trigger("change");
	    els.firstName.val(primaryAddress.rtlContactFirstName);
	    els.lastName.val(primaryAddress.rtlContactLastName);
	    els.email.val(primaryAddress.rtlEmail);
	
	    els.fedexCanCall.prop("checked", primaryAddress.rtlOkToCall);
	
	    els.officeCountryCode.val(primaryAddress.rtlOfficePhoneCountryCode).trigger("change");
	
	    if (primaryAddress.rtlOfficePhoneCountryCode === '+1') {
	
	      els.officePhone.attr("placeholder", "___-____");
	      els.officePhone.addClass('ret-phone-number-jqv');
	      els.officePhone.removeClass('phoneNonUS');
	      els.officePhone.val(primaryAddress.rtlOfficePhone);
	      if (els.officeAreaCode) {
	        els.officeAreaCode.removeClass('phoneNonUS');
	        els.officeAreaCode.val(primaryAddress.rtlOfficePhoneAreaCode);
	      }
	      addmasks();
	    } else {
	
	      els.officePhone.addClass('phoneNonUS');
	      els.officePhone.removeClass('ret-phone-number-jqv');
	      els.officePhone.removeAttr('placeholder');
	      els.officePhone.inputmask({ mask: "" });
	
	      if (primaryAddress.rtlOfficePhoneAreaCode) {
	
	        var val = primaryAddress.rtlOfficePhoneAreaCode;
	        var v = val.replace(/[^0-9.]/g, "");
	        primaryAddress.rtlOfficePhoneAreaCode = v;
	        if (els.officeAreaCode) {
	          els.officeAreaCode.inputmask({ mask: "" });
	          els.officeAreaCode.addClass('phoneNonUS');
	          els.officeAreaCode.val(v);
	        }
	      }
	
	      if (primaryAddress.rtlOfficePhone) {
	        var _val = primaryAddress.rtlOfficePhone;
	        var _v = _val.replace(/[^0-9.]/g, "");
	        primaryAddress.rtlOfficePhone = _v;
	        els.officePhone.val(_v);
	      }
	
	      els.officeAreaCode.removeAttr('placeholder');
	      els.officeAreaCode.inputmask({ mask: "" });
	      if (els.officeAreaCode) {
	        (0, _selectorHelpers.hide)(els.officeAreaCode);
	      }
	    }
	
	    els.officeExt.val(primaryAddress.rtlOfficePhoneExt);
	
	    if (!isMobileInformationPresent(primaryAddress)) {
	      els.mobileCountryCode.val(primaryAddress.rtlMobilePhoneCountryCode).trigger("change");
	
	      if (primaryAddress.rtlMobilePhoneCountryCode === '+1') {
	        els.mobilePhone.removeClass('phoneNonUS');
	        if (els.mobileAreaCode) {
	          els.mobileAreaCode.removeClass('phoneNonUS');
	        }
	        els.mobilePhone.addClass('ret-phone-number-jqv');
	        els.mobilePhone.attr("placeholder", "___-____");
	
	        addMasksMobilePhone();
	        els.mobilePhone.val(primaryAddress.rtlMobilePhone);
	
	        if (primaryAddress.rtlMobilePhoneAreaCode != null) {
	          els.mobileAreaCode.val(primaryAddress.rtlMobilePhoneAreaCode);
	        } else {
	          (0, _selectorHelpers.hide)(els.mobileAreaCode);
	        }
	      } else {
	
	        els.mobilePhone.addClass('phoneNonUS');
	        els.mobilePhone.removeClass('ret-phone-number-jqv');
	        els.mobilePhone.removeAttr('placeholder');
	        els.mobilePhone.inputmask({ mask: "" });
	
	        if (primaryAddress.rtlMobilePhone) {
	          var _val2 = primaryAddress.rtlMobilePhone;
	          var _v2 = _val2.replace(/[^0-9.]/g, "");
	          primaryAddress.rtlMobilePhone = _v2;
	          els.mobilePhone.val(_v2);
	        }
	
	        if (els.mobileAreaCode) {
	          els.mobileAreaCode.inputmask({ mask: "" });
	          els.mobileAreaCode.addClass('phoneNonUS');
	          els.mobileAreaCode.removeAttr('placeholder');
	        }
	
	        if (primaryAddress.rtlMobilePhoneAreaCode) {
	          var _val3 = primaryAddress.rtlMobilePhoneAreaCode;
	          var _v3 = _val3.replace(/[^0-9.]/g, "");
	          primaryAddress.rtlMobilePhoneAreaCode = _v3;
	          els.mobileAreaCode.val(_v3);
	        }
	        if (els.mobileAreaCode) {
	          (0, _selectorHelpers.hide)(els.mobileAreaCode);
	        }
	      }
	
	      (0, _selectorHelpers.hide)(els.addMobileBtn);
	    } else {
	      (0, _selectorHelpers.hide)(els.mobilePhoneSection);
	      (0, _selectorHelpers.show)(els.addMobileBtn);
	    }
	
	    if (primaryAddress.childRetailers && primaryAddress.childRetailers.length > 0) {
	      (0, _jquery2.default)('#affMerchantSwitchery').attr('checked', true);
	      _jquery2.default.each(primaryAddress.childRetailers, function (ind, child) {
	        var affMerchantNameValue = child.chrName;
	        var addedAffiliatedMerchantHtml = " <div class=\"col-xs-12 aff-merchant-text q-marg-top-md\">\n            <input class=\"q-input q-stretch affMerchantNameValue\" disabled\n              type=\"text\" id=\"" + affMerchantNameValue + "\" value=\"" + affMerchantNameValue + "\"/>\n          </div>";
	        els.addAffMerchant.append(addedAffiliatedMerchantHtml);
	      });
	    }
	  }
	
	  function handleAddMobileBtn() {
	    (0, _selectorHelpers.show)(els.mobilePhoneSection);
	    (0, _selectorHelpers.hide)(els.addMobileBtn);
	  }
	
	  function handleRemoveMobileBtn() {
	    (0, _selectorHelpers.hide)(els.mobilePhoneSection);
	    (0, _selectorHelpers.show)(els.addMobileBtn);
	    els.mobileCountryCode.val('');
	    els.mobileAreaCode.val('');
	    els.mobilePhone.val('');
	    var primaryAddress = getPrimaryAddress();
	
	    if (primaryAddress) {
	      primaryAddress.rtlMobilePhoneCountryCode = '';
	      primaryAddress.rtlMobilePhone = '';
	      primaryAddress.rtlMobilePhoneAreaCode = '';
	    }
	  }
	
	  function isMobileInformationPresent(primaryAddress) {
	    return (0, _general.isBlank)(primaryAddress.rtlMobilePhoneCountryCode) && (0, _general.isBlank)(primaryAddress.rtlMobilePhone) && (0, _general.isBlank)(primaryAddress.rtlMobilePhoneAreaCode);
	  }
	
	  function showAllSections() {
	    (0, _selectorHelpers.show)(els.addressSection);
	    (0, _selectorHelpers.show)(els.contactSection);
	    (0, _selectorHelpers.show)(els.phoneSection);
	  }
	
	  function countryChange() {
	    var countryVal = els.country.find('option:selected').val();
	    var isValidCountry = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        countryId = this.conPhoneCode.toString();
	        return false;
	      }
	    });
	    (0, _jquery2.default)(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryVal.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (isValidCountry) {
	      (0, _jquery2.default)(".country-not-supported-primary").hide();
	    } else {
	      (0, _jquery2.default)(".country-not-supported-primary").show();
	    }
	    setStates(countryVal);
	    if (countryVal === "US") {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States of America +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "CA") {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "Canada +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "UM") {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States Minor Outlying Islands +1";
	      }).prop("selected", true).trigger("change");
	    } else {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).val().toString();
	        return text === countryId.toString();
	      }).prop("selected", true).trigger("change");
	    }
	    if (countryVal === "US" || countryVal === "CA") {
	      (0, _selectorHelpers.show)(els.officeAreaCode);
	      els.officePhone.attr("placeholder", "___-____");
	      els.officePhone.addClass('ret-phone-number-jqv');
	      els.officePhone.removeClass('phoneNonUS');
	      addmasks();
	    } else {
	      els.officeAreaCode.val('');
	      if (els.officeAreaCode) {
	        (0, _selectorHelpers.hide)(els.officeAreaCode);
	      }
	      els.officePhone.val('');
	      els.officePhone.addClass('phoneNonUS');
	      els.officePhone.removeClass('ret-phone-number-jqv');
	      els.officePhone.removeAttr('placeholder');
	      els.officePhone.inputmask({
	        mask: ""
	      });
	    }
	  }
	
	  function addmasks() {
	    (0, _jquery2.default)('.ret-office-area-code').inputmask({
	      mask: "(999)"
	    });
	
	    (0, _jquery2.default)('.ret-office-phone').inputmask({
	      mask: "999-9999"
	    });
	  }
	
	  function addMasksMobilePhone() {
	    (0, _jquery2.default)('.ret-mobile-area-code').inputmask({
	      mask: "(999)"
	    });
	
	    (0, _jquery2.default)('.ret-mobile-phone').inputmask({
	      mask: "999-9999"
	    });
	  }
	
	  function mobileCountryCodeChange() {
	    var mobilecode = els.mobileCountryCode.find('option:selected').val().toString();
	    els.mobilePhone.val('');
	    if (els.mobileAreaCode) {
	      els.mobileAreaCode.val('');
	    }
	    if (els.mobileAreaCode) {
	      els.mobileAreaCode.val('');
	    }
	    if (mobilecode === '+1') {
	      (0, _selectorHelpers.show)(els.mobileAreaCode);
	      els.mobilePhone.attr("placeholder", "___-____");
	      els.mobilePhone.addClass('ret-phone-number-jqv');
	      els.mobilePhone.removeClass('phoneNonUS');
	      if (els.mobileAreaCode) {
	        els.mobileAreaCode.removeClass('phoneNonUS');
	      }
	      addMasksMobilePhone();
	    } else {
	      els.mobileAreaCode.removeClass('phoneNonUS');
	      els.mobileAreaCode.val('');
	      (0, _selectorHelpers.hide)(els.mobileAreaCode);
	      els.mobilePhone.addClass('phoneNonUS');
	      els.mobilePhone.removeClass('ret-phone-number-jqv');
	      els.mobilePhone.removeAttr('placeholder');
	      els.mobilePhone.inputmask({ mask: "" });
	    }
	  }
	
	  function officeCountryCodeChange() {
	    var phoneCode = els.officeCountryCode.find('option:selected').val().toString();
	    els.officePhone.val('');
	    if (els.officeAreaCode) {
	      els.officeAreaCode.val('');
	    }
	    if (phoneCode === '+1') {
	      (0, _selectorHelpers.show)(els.officeAreaCode);
	      els.officePhone.attr("placeholder", "___-____");
	      els.officePhone.addClass('ret-phone-number-jqv');
	      els.officePhone.removeClass('phoneNonUS');
	      if (els.officeAreaCode) {
	        els.officeAreaCode.removeClass('phoneNonUS');
	      }
	      addmasks();
	    } else {
	      (0, _selectorHelpers.hide)(els.officeAreaCode);
	      els.officePhone.addClass('phoneNonUS');
	      els.officePhone.removeClass('ret-phone-number-jqv');
	      els.officePhone.removeAttr('placeholder');
	      els.officePhone.inputmask({ mask: "" });
	    }
	  }
	
	  function getRetailer() {
	    if (!(0, _general.isBlank)(retailerJsonString)) {
	      return retailerJsonString;
	    } else {
	      return null;
	    }
	  }
	
	  function getPrimaryAddress() {
	    return getRetailer();
	  }
	
	  function existingRetailerHasPrimaryAddress() {
	    return _underscore2.default.isObject(getRetailer());
	  }
	
	  function isEdit() {
	    return _underscore2.default.isObject(getRetailer());
	  }
	
	  function validateDirectBillField() {
	
	    if ((0, _jquery2.default)(this).prop("checked") == true) {
	      if ((0, _jquery2.default)('.primary-information-tab .fuel-Surchrg-switch').is(":checked")) {
	        var retailer = getRetailer();
	        var directBillEl = els.directBillSwitch;
	        if (!(0, _util.isNullOrUndefined)(retailer.directBillCustomerFlag) && directBillEl.length > 0) {
	          setSwithcery(els.directBillSwitch, false);
	        }
	      }
	    }
	  }
	
	  function validateFuelSurchargeField() {
	    if ((0, _jquery2.default)(this).prop("checked") == true) {
	      if ((0, _jquery2.default)('.primary-information-tab .direct-bill-switch').is(":checked")) {
	        var retailer = getRetailer();
	        var fuelSurchrgSwitchEl = els.fuelSurchrgSwitch;
	        if (!(0, _util.isNullOrUndefined)(retailer.rtlFuelSurchrgDiscFlag) && fuelSurchrgSwitchEl.length > 0) {
	          setSwithcery(els.fuelSurchrgSwitch, false);
	        }
	      }
	    }
	  }
	}

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReviewTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var confirmationModalHtml = __webpack_require__(1348);
	
	var scopeElementsMap = {
	  retPrefix: '.ret-prefix',
	  retFirstName: '.ret-first-name',
	  retLastName: '.ret-last-name',
	  retEmail: '.ret-email',
	  affMerchantSwitchery: '#affMerchantSwitchery',
	  insightFeedSwitchery: '#insightFeedSwitchery',
	  affMerchantName: '#aff-merchant-name',
	  country: '.ret-country',
	  address1: '.ret-address1',
	  address2: '.ret-address2',
	  city: '.ret-city',
	  state: '.ret-state',
	  nonUSCAstate: '.ret-state-text',
	  zipCode: '.ret-zip-code',
	  county: '.ret-county',
	
	  officeCounryCode: ".ret-office-country-code",
	  officeAreaCode: ".ret-office-area-code",
	  officePhone: ".ret-office-phone",
	  officeExt: ".ret-office-ext",
	
	  mobileCounryCode: ".ret-mobile-country-code",
	  mobileAreaCode: ".ret-mobile-area-code",
	  mobilePhone: ".ret-mobile-phone",
	
	  commercialAddrFlag: "commercial-addr-flag",
	  masterAccountSection: '.master-account-section',
	  masterAccountToggleCheckbox: '.master-account-toggle-checkbox',
	  managedByMasterAccountSection: '.managed-by-master-account-section',
	  managedByMasteraccountToggleCheckbox: '.managed-by-masteraccount-toggle-checkbox',
	  masteraccountDropdown: '.masteraccount-dropdown',
	
	  officeCountryCodeBill: '.ret-office-country-code-bill',
	  officePhoneBill: '.ret-office-phone-bill',
	  officeAreaCodeBill: '.ret-office-area-code-bill',
	  mobileCountryCodeBill: '.ret-mobile-country-code-bill',
	  mobilePhoneBill: '.ret-mobile-phone-bill',
	  mobileAreaCodeBill: '.ret-mobile-area-code-bill',
	
	  officeCountryCodeShip: '.ret-office-country-code-ship',
	  officePhoneShip: '.ret-office-phone-ship',
	  officeAreaCodeShip: '.ret-office-area-code-ship',
	  mobileCountryCodeShip: '.ret-mobile-country-code-ship',
	  mobilePhoneShip: '.ret-mobile-phone-ship',
	  mobileAreaCodeShip: '.ret-mobile-area-code-ship'
	};
	
	var elementsMap = {
	  companyName: '.company-name',
	  taxId: '.tax-id',
	  fontanaFedExId: ".Fontana-fedex-id",
	  greenwoodFedexId: ".Greenwood-fedex-id",
	  facId1: ".facId-1",
	  facId2: ".facId-2",
	  primaryUrl: '.primary-url',
	  fedexCanCall: '.fedex-can-call',
	  sharePrimarySwitch: '.switch-share-primary',
	  revCompanyName: '.revCompanyName',
	  revFontanaFedExId: ".revFontanaFedExId",
	  revGreenwoodFedExId: ".revGreenwoodFedExId",
	  revTaxId: '.revTaxId',
	  revPrimaryUrl: '.revPrimaryUrl',
	  revContactPersonName: '.revContactPersonName',
	  revEmailAddress: '.revEmailAddress',
	  revMobileNumber: '.revMobileNumber',
	  revOfficeNumber: '.revOfficeNumber',
	  merchantName: '.merchantName',
	  merchantNames: '.merchantNames',
	  //addressValidationDiv:'.address-toggler',
	  insightTogglerDiv: '.insight-toggler',
	  submitBtn: '.submit-btn',
	  submitConfirmationBtn: '.submit-confirmation-btn',
	  revSupplychainfacilities: '.revSupplychainfacilities',
	  revShippingServices: '.revShippingServices',
	  revTier: '.revTier',
	  merchantTier: '.merchant-tier',
	  directBillTogglerDiv: '.directbill-toggler',
	  fuelSurchrgDiscTogglerDiv: '.fuelsurchrg-toggler'
	
	};
	
	function ReviewTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var primaryTab = wizardElement.find('.primary-information-tab');
	  var shippingTab = wizardElement.find('.shipping-information-tab');
	  var billingTab = wizardElement.find('.billing-information-tab');
	  var reviewTab = wizardElement.find('.review-tab');
	  var reviewPrimarySection = reviewTab.find('.primary-info-section');
	  var reviewShippingSection = reviewTab.find('.shipping-info-section');
	  var reviewBillingSection = reviewTab.find('.billing-info-section');
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var retailerObj = wizardElement.data("retailer-obj");
	  var renderUrl = wizardElement.data("render-url");
	  var submitUrl = wizardElement.data("submit-url");
	  var supplychainFacilities = wizardElement.data('supplychain-facilities');
	  var shippingServices = wizardElement.data('shipping-services');
	  var isExistingRetailer = _underscore2.default.isObject(retailerObj);
	  var els = {};
	  var elsPrimarySection = {};
	  var elsBillingSection = {};
	  var elsShippingSection = {};
	  var elsReviewPrimarySection = {};
	  var elsReviewShippingSection = {};
	  var elsReviewBillingSection = {};
	
	  var confirmationModal = (0, _jquery2.default)(confirmationModalHtml);
	  var contactName = void 0,
	      mobileNumber = void 0,
	      officeNumber = void 0;
	  var retailer = {};
	
	  self.init = function () {
	    render();
	  };
	
	  self.didNavigateToForm = function () {
	    updateSelf();
	  };
	
	  function render() {
	    setElements();
	    bindElements();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardElement);
	    (0, _selectorHelpers.setElementsFromScope)(elsPrimarySection, scopeElementsMap, primaryTab);
	    (0, _selectorHelpers.setElementsFromScope)(elsShippingSection, scopeElementsMap, shippingTab);
	    (0, _selectorHelpers.setElementsFromScope)(elsBillingSection, scopeElementsMap, billingTab);
	
	    (0, _selectorHelpers.setElementsFromScope)(elsReviewPrimarySection, elementsMap, reviewPrimarySection);
	    (0, _selectorHelpers.setElementsFromScope)(elsReviewPrimarySection, scopeElementsMap, reviewPrimarySection);
	
	    (0, _selectorHelpers.setElementsFromScope)(elsReviewShippingSection, elementsMap, reviewShippingSection);
	    (0, _selectorHelpers.setElementsFromScope)(elsReviewShippingSection, scopeElementsMap, reviewShippingSection);
	
	    (0, _selectorHelpers.setElementsFromScope)(elsReviewBillingSection, elementsMap, reviewBillingSection);
	    (0, _selectorHelpers.setElementsFromScope)(elsReviewBillingSection, scopeElementsMap, reviewBillingSection);
	    wizardElement.append(confirmationModalHtml);
	  }
	
	  function bindElements() {
	    els.submitBtn.on("click", showConfirmationModal);
	    confirmationModal.find(elementsMap.submitConfirmationBtn).on("click", onSubmit);
	  }
	
	  function updateSelf() {
	    if (isExistingRetailer) {
	      //deep copy
	      retailer = jQuery.extend(true, {}, retailerObj);
	    }
	
	    retailer.retailerAddresses = [];
	    retailer.retailerShipping = [];
	
	    //Primary
	    updatePrimaryUniqueInfo(elsPrimarySection);
	    updateOtherInfo(elsReviewPrimarySection, elsPrimarySection, 'Primary');
	
	    //Shipping
	    var shippingTabSwitchElement = shippingTab.find(elementsMap.sharePrimarySwitch);
	    var shippingTabSwitchElementFlag = shippingTabSwitchElement.prop("checked");
	    if (shippingTabSwitchElementFlag) {
	      updateOtherInfo(elsReviewShippingSection, elsPrimarySection, 'Shipping');
	    } else {
	      updateOtherInfo(elsReviewShippingSection, elsShippingSection, 'Shipping');
	    }
	
	    //Billing
	    var billingTabSwitchElement = billingTab.find(elementsMap.sharePrimarySwitch);
	    var billingTabSwitchElementFlag = billingTabSwitchElement.prop("checked");
	    if (billingTabSwitchElementFlag) {
	      updateOtherInfo(elsReviewBillingSection, elsPrimarySection, 'Billing');
	    } else {
	      updateOtherInfo(elsReviewBillingSection, elsBillingSection, 'Billing');
	    }
	  }
	
	  function updatePrimaryUniqueInfo(elsPrimarySection) {
	    elsReviewPrimarySection.revCompanyName.html(els.companyName.val());
	    elsReviewPrimarySection.revTaxId.html(els.taxId.val());
	    elsReviewPrimarySection.revFontanaFedExId.html(els.fontanaFedExId.val());
	    elsReviewPrimarySection.revGreenwoodFedExId.html(els.greenwoodFedexId.val());
	    elsReviewPrimarySection.revPrimaryUrl.html(els.primaryUrl.val());
	    elsReviewPrimarySection.revPrimaryUrl.prop('href', els.primaryUrl.val());
	    elsReviewPrimarySection.revSupplychainfacilities.empty();
	    elsReviewPrimarySection.revShippingServices.empty();
	    elsReviewPrimarySection.revTier.html(els.merchantTier.find("option:selected").text());
	
	    _jquery2.default.each((0, _jquery2.default)(".supply-chain-fac"), function (ind, elem) {
	      var facilityNameDiv = void 0;
	      if ((0, _jquery2.default)(elem).prop("checked")) {
	        var mVal = (0, _jquery2.default)(elem).val();
	        facilityNameDiv = " \n        <div>\n            " + mVal + "\n        </div>";
	      }
	
	      elsReviewPrimarySection.revSupplychainfacilities.append(facilityNameDiv);
	
	      var response = _underscore2.default.map(supplychainFacilities, function (supplychainFacilityItem) {
	        if (supplychainFacilityItem.facName == (0, _jquery2.default)(elem).val() && (0, _jquery2.default)(elem).prop("checked")) {
	          addFacilityAddressDetails(supplychainFacilityItem, 'Y');
	        } else if (supplychainFacilityItem.facName == (0, _jquery2.default)(elem).val() && !(0, _jquery2.default)(elem).prop("checked")) {
	          addFacilityAddressDetails(supplychainFacilityItem, 'N');
	        }
	      });
	    });
	
	    _jquery2.default.each((0, _jquery2.default)(".shipping-serv"), function (ind, elem) {
	      var facilityNameDiv = void 0;
	      if ((0, _jquery2.default)(elem).prop("checked")) {
	        var mVal = (0, _jquery2.default)(elem).val();
	        facilityNameDiv = " \n        <div>\n            " + mVal + "\n        </div>";
	      }
	
	      elsReviewPrimarySection.revShippingServices.append(facilityNameDiv);
	
	      var response = _underscore2.default.map(shippingServices, function (shippingServicesItem) {
	        if (shippingServicesItem.cdmMeaning == (0, _jquery2.default)(elem).val() && (0, _jquery2.default)(elem).prop("checked")) {
	          addShippingAddressDetails(shippingServicesItem, 'Y');
	        } else if (shippingServicesItem.cdmMeaning == (0, _jquery2.default)(elem).val() && !(0, _jquery2.default)(elem).prop("checked")) {
	          addShippingAddressDetails(shippingServicesItem, 'N');
	        }
	      });
	    });
	    els.merchantNames.empty();
	    _jquery2.default.each((0, _jquery2.default)(".affMerchantNameValue"), function (ind, elem) {
	      var mVal = (0, _jquery2.default)(elem).val();
	      var merchantNameDiv = " <div class=\"divider-group\">\n                  <div class=\"row\">\n                <div class=\"col-xs-3\">\n                  <div class=\"merchantName\">\n                    " + mVal + "\n                  </div>\n                </div>\n                </div>\n              </div>";
	      els.merchantNames.append(merchantNameDiv);
	    });
	    els.insightTogglerDiv.empty();
	    var insightYesSpan = "<span class=\"q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg\">Yes</span>";
	    var insightNoSpan = "<span class=\"q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg\">No</span>";
	    if ((0, _jquery2.default)('.primary-information-tab .insight-feed-switch').is(":checked")) {
	      els.insightTogglerDiv.append(insightYesSpan);
	    } else {
	      els.insightTogglerDiv.append(insightNoSpan);
	    }
	
	    els.directBillTogglerDiv.empty();
	    var directBillYesSpan = "<span class=\"q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg\">Yes</span>";
	    var directBillNoSpan = "<span class=\"q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg\">No</span>";
	
	    if ((0, _jquery2.default)('.primary-information-tab .direct-bill-switch').is(":checked")) {
	      els.directBillTogglerDiv.append(directBillYesSpan);
	    } else {
	      els.directBillTogglerDiv.append(directBillNoSpan);
	    }
	
	    els.fuelSurchrgDiscTogglerDiv.empty();
	    var fuelSurchrgDiscYesSpan = "<span class=\"q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg\">Yes</span>";
	    var fuelSurchrgDiscNoSpan = "<span class=\"q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg\">No</span>";
	
	    if ((0, _jquery2.default)('.primary-information-tab .fuel-Surchrg-switch').is(":checked")) {
	      els.fuelSurchrgDiscTogglerDiv.append(fuelSurchrgDiscYesSpan);
	    } else {
	      els.fuelSurchrgDiscTogglerDiv.append(fuelSurchrgDiscNoSpan);
	    }
	
	    createOrUpdateRetailerJson1();
	  }
	
	  function addFacilityAddressDetails(supplyChainfacility, isActive) {
	    var cmrAddress = {};
	    cmrAddress.cadAddressType = '';
	    cmrAddress.cadContactNamePrefix = '';
	    cmrAddress.cadLocationName = supplyChainfacility.facName;
	    cmrAddress.cadAddressId = supplyChainfacility.facCode;
	    cmrAddress.cadFacId = supplyChainfacility.facId;
	    cmrAddress.cadContactName = supplyChainfacility.facContactName;
	    cmrAddress.cadContactLastName = '';
	    cmrAddress.cadContactEmail = supplyChainfacility.facContactEmail;
	    cmrAddress.cadMobilePhoneCountryCode = '';
	    cmrAddress.cadMobilePhoneAreaCode = '';
	    cmrAddress.cadMobilePhone = '';
	    cmrAddress.cadOfficePhoneCountryCode = '';
	    cmrAddress.cadOfficePhoneAreaCode = '';
	    cmrAddress.cadOfficePhone = supplyChainfacility.facContactPhone;
	    cmrAddress.cadOfficePhoneExt = '';
	    cmrAddress.cadAddress1 = supplyChainfacility.facAddressLine1;
	    cmrAddress.cadAddress2 = supplyChainfacility.facAddressLine2;
	    cmrAddress.cadCity = supplyChainfacility.facCity;
	    cmrAddress.cadState = supplyChainfacility.facState;
	    cmrAddress.cadCountry = supplyChainfacility.facCountry;
	    cmrAddress.cadZipcode = supplyChainfacility.facZipcode;
	    cmrAddress.cadStdAddress1 = cmrAddress.cadAddress1;
	    cmrAddress.cadStdAddress2 = cmrAddress.cadAddress2;
	    cmrAddress.cadStdCity = cmrAddress.cadCity;
	    cmrAddress.cadStdState = cmrAddress.cadState;
	    cmrAddress.cadStdCountry = cmrAddress.cadCountry;
	    cmrAddress.cadStdZipcode = cmrAddress.cadZipcode;
	    cmrAddress.cadAddressValidated = 1;
	    cmrAddress.cadUseStdAddress = 1;
	    cmrAddress.cadCommercialAddrFlag = '';
	    cmrAddress.cadActive = isActive;
	
	    retailer.retailerAddresses.push(cmrAddress);
	  }
	
	  function addShippingAddressDetails(shippingService, isActive) {
	    var rtlShippingAddress = {};
	
	    rtlShippingAddress.cdmId = shippingService.cdmId;
	    rtlShippingAddress.cdmDomain = shippingService.cdmDomain;
	    rtlShippingAddress.cdmValue = shippingService.cdmMeaning;
	    rtlShippingAddress.cdmMeaning = shippingService.cdmMeaning;
	    rtlShippingAddress.cdmDescription = isActive;
	    rtlShippingAddress.cdmCreatedDate = shippingService.cdmCreatedDate;
	    rtlShippingAddress.cdmCreatedTime = shippingService.cdmCreatedTime;
	    rtlShippingAddress.cdmCreatedBy = shippingService.cdmCreatedBy;
	    rtlShippingAddress.cdmModifiedDate = shippingService.cdmModifiedDate;
	    rtlShippingAddress.cdmModifiedTime = shippingService.cdmModifiedTime;
	    rtlShippingAddress.cdmModifiedBy = shippingService.cdmModifiedBy;
	    rtlShippingAddress.cdmVersionNo = shippingService.cdmVersionNo;
	    rtlShippingAddress.cdmSortOrder = shippingService.cdmSortOrder;
	    rtlShippingAddress.cdmRetailerId = shippingService.cdmRetailerId;
	    rtlShippingAddress.cdmPartnerId = shippingService.cdmPartnerId;
	    rtlShippingAddress.cdmFacilityId = shippingService.cdmFacilityId;
	    retailer.retailerShipping.push(rtlShippingAddress);
	  }
	
	  function updateOtherInfo(reviewSection, elsScope, addressType) {
	    if (elsScope.retPrefix.val()) {
	      contactName = elsScope.retPrefix.val() + " " + elsScope.retFirstName.val() + " " + elsScope.retLastName.val();
	    } else {
	      contactName = elsScope.retFirstName.val() + " " + elsScope.retLastName.val();
	    }
	    reviewSection.revContactPersonName.html(contactName);
	    reviewSection.revEmailAddress.html(elsScope.retEmail.val());
	
	    if (addressType === 'Primary') {
	      if (elsScope.mobilePhone.val()) {
	        mobileNumber = "M: ";
	        mobileNumber = mobileNumber.concat(elsScope.mobileCounryCode.val());
	        if (elsScope.country.val() == 'US' || elsScope.country.val() == 'CA') {
	          mobileNumber = mobileNumber.concat(" " + elsScope.mobileAreaCode.val() + " ");
	        }
	        mobileNumber = mobileNumber.concat(elsScope.mobilePhone.val());
	        reviewSection.revMobileNumber.html(mobileNumber);
	      } else {
	        reviewSection.revMobileNumber.html('');
	      }
	
	      officeNumber = "O: ";
	      officeNumber = officeNumber.concat(elsScope.officeCounryCode.val());
	      if (elsScope.country.val() == 'US' || elsScope.country.val() == 'CA') {
	        officeNumber = officeNumber.concat(" " + elsScope.officeAreaCode.val() + " ");
	      }
	      officeNumber = officeNumber.concat(elsScope.officePhone.val());
	      if (elsScope.officeExt.val()) {
	        officeNumber = officeNumber.concat(" Ext: " + elsScope.officeExt.val());
	      }
	      reviewSection.revOfficeNumber.html(officeNumber);
	    }
	    if (addressType === 'Shipping') {
	      var shippingTabSwitchElement = shippingTab.find(elementsMap.sharePrimarySwitch);
	      var shippingTabSwitchElementFlag = shippingTabSwitchElement.prop("checked");
	      if (shippingTabSwitchElementFlag) {
	        if (elsScope.mobilePhone.val()) {
	          mobileNumber = "M: ";
	          mobileNumber = mobileNumber.concat(elsScope.mobileCounryCode.val());
	          if (elsScope.mobileCounryCode.val() === '+1') {
	            mobileNumber = mobileNumber.concat(" " + elsScope.mobileAreaCode.val() + " ");
	          }
	          mobileNumber = mobileNumber.concat(elsScope.mobilePhone.val());
	          reviewSection.revMobileNumber.html(mobileNumber);
	        } else {
	          reviewSection.revMobileNumber.html('');
	        }
	
	        officeNumber = "O: ";
	        officeNumber = officeNumber.concat(elsScope.officeCounryCode.val());
	        if (elsScope.officeCounryCode.val() == '+1') {
	          officeNumber = officeNumber.concat(" " + elsScope.officeAreaCode.val() + " ");
	        }
	        officeNumber = officeNumber.concat(elsScope.officePhone.val());
	        if (elsScope.officeExt.val()) {
	          officeNumber = officeNumber.concat(" Ext: " + elsScope.officeExt.val());
	        }
	        reviewSection.revOfficeNumber.html(officeNumber);
	      } else {
	        if (elsScope.mobilePhoneShip.val()) {
	          mobileNumber = "M: ";
	          mobileNumber = mobileNumber.concat(elsScope.mobileCountryCodeShip.val());
	          if (elsScope.mobileCountryCodeShip.val() === '+1') {
	            mobileNumber = mobileNumber.concat(" " + elsScope.mobileAreaCodeShip.val() + " ");
	          }
	          mobileNumber = mobileNumber.concat(elsScope.mobilePhoneShip.val());
	          reviewSection.revMobileNumber.html(mobileNumber);
	        } else {
	          reviewSection.revMobileNumber.html('');
	        }
	
	        officeNumber = "O: ";
	        officeNumber = officeNumber.concat(elsScope.officeCountryCodeShip.val());
	        if (elsScope.officeCountryCodeShip.val() == '+1') {
	          officeNumber = officeNumber.concat(" " + elsScope.officeAreaCodeShip.val() + " ");
	        }
	        officeNumber = officeNumber.concat(elsScope.officePhoneShip.val());
	        if (elsScope.officeExt.val()) {
	          officeNumber = officeNumber.concat(" Ext: " + elsScope.officeExt.val());
	        }
	        reviewSection.revOfficeNumber.html(officeNumber);
	      }
	    }
	    if (addressType === 'Billing') {
	      var billingTabSwitchElement = billingTab.find(elementsMap.sharePrimarySwitch);
	      var billingTabSwitchElementFlag = billingTabSwitchElement.prop("checked");
	      if (billingTabSwitchElementFlag) {
	        if (elsScope.mobilePhone.val()) {
	          mobileNumber = "M: ";
	          mobileNumber = mobileNumber.concat(elsScope.mobileCounryCode.val());
	          if (elsScope.mobileCounryCode.val() === '+1') {
	            mobileNumber = mobileNumber.concat(" " + elsScope.mobileAreaCode.val() + " ");
	          }
	          mobileNumber = mobileNumber.concat(elsScope.mobilePhone.val());
	          reviewSection.revMobileNumber.html(mobileNumber);
	        } else {
	          reviewSection.revMobileNumber.html('');
	        }
	
	        officeNumber = "O: ";
	        officeNumber = officeNumber.concat(elsScope.officeCounryCode.val());
	        if (elsScope.officeCounryCode.val() === '+1') {
	          officeNumber = officeNumber.concat(" " + elsScope.officeAreaCode.val() + " ");
	        }
	        officeNumber = officeNumber.concat(elsScope.officePhone.val());
	        if (elsScope.officeExt.val()) {
	          officeNumber = officeNumber.concat(" Ext: " + elsScope.officeExt.val());
	        }
	        reviewSection.revOfficeNumber.html(officeNumber);
	      } else {
	        if (elsScope.mobilePhoneBill.val()) {
	          mobileNumber = "M: ";
	          mobileNumber = mobileNumber.concat(elsScope.mobileCountryCodeBill.val());
	          if (elsScope.mobileCountryCodeBill.val() === '+1') {
	            mobileNumber = mobileNumber.concat(" " + elsScope.mobileAreaCodeBill.val() + " ");
	          }
	          mobileNumber = mobileNumber.concat(elsScope.mobilePhoneBill.val());
	          reviewSection.revMobileNumber.html(mobileNumber);
	        } else {
	          reviewSection.revMobileNumber.html('');
	        }
	
	        officeNumber = "O: ";
	        officeNumber = officeNumber.concat(elsScope.officeCountryCodeBill.val());
	        if (elsScope.officeCountryCodeBill.val() === '+1') {
	          officeNumber = officeNumber.concat(" " + elsScope.officeAreaCodeBill.val() + " ");
	        }
	        officeNumber = officeNumber.concat(elsScope.officePhoneBill.val());
	        if (elsScope.officeExt.val()) {
	          officeNumber = officeNumber.concat(" Ext: " + elsScope.officeExt.val());
	        }
	        reviewSection.revOfficeNumber.html(officeNumber);
	      }
	    }
	
	    reviewSection.address1.html(elsScope.address1.val());
	    reviewSection.address2.html(elsScope.address2.val());
	    reviewSection.city.html(elsScope.city.val());
	    if (elsScope.country.val() == 'US' || elsScope.country.val() == 'CA') {
	      reviewSection.state.html(elsScope.state.val());
	    } else {
	      reviewSection.state.html(elsScope.nonUSCAstate.val());
	    }
	    reviewSection.zipCode.html(elsScope.zipCode.val());
	    reviewSection.county.html(elsScope.county.val());
	    reviewSection.country.html(elsScope.country.find("option:selected").text());
	
	    createOrUpdateRetailerJson2(addressType, elsScope);
	  }
	
	  function createOrUpdateRetailerJson1() {
	    //create or update retailer JSON
	    if (!isExistingRetailer) {
	      retailer.rtlType = "C";
	      retailer.rtlStatus = "A";
	      retailer.enrollmentConfigs = {
	        enrollments: wizardElement.data("rtl-type")
	      };
	    }
	    retailer.rtlName = els.companyName.val();
	    retailer.rtlTaxId = els.taxId.val();
	    /*retailer.retailerFedExIds = {
	      greenwoodFedExId: els.greenwoodFedexId.val(),
	      fontanaFedExId: els.fontanaFedExId.val(),
	      greenwoodFacId:els.facId1.val(),
	      fontanaFacId:els.facId2.val()
	    };*/
	    retailer.rtlWebUrl = els.primaryUrl.val();
	    var fedexCanCallElement = primaryTab.find(elementsMap.fedexCanCall);
	    retailer.rtlOkToCall = fedexCanCallElement.prop("checked");
	    var shippingTabSwitchElement = shippingTab.find(elementsMap.sharePrimarySwitch);
	    retailer.rtlShipAccEqPrimary = shippingTabSwitchElement.prop("checked");
	    var billingTabSwitchElement = billingTab.find(elementsMap.sharePrimarySwitch);
	    retailer.rtlBillAccEqPrimary = billingTabSwitchElement.prop("checked");
	    retailer.rtlTier = parseInt(els.merchantTier.val());
	    //   retailer.retailerAddresses = [];
	    var masterAccountToggleCheckboxElement = primaryTab.find(elsPrimarySection.masterAccountToggleCheckbox);
	    var managedByMasteraccountToggleCheckboxElement = primaryTab.find(elsPrimarySection.managedByMasteraccountToggleCheckbox);
	    var masteraccountDropdownElement = primaryTab.find(elsPrimarySection.masteraccountDropdown);
	
	    if (masterAccountToggleCheckboxElement.prop("checked")) {
	      retailer.rtlMasterFlag = true;
	      retailer.rtlVirtualFlag = false;
	      retailer.rtlMasterAccountId = null;
	    }
	
	    if (managedByMasteraccountToggleCheckboxElement.prop("checked")) {
	      retailer.rtlMasterFlag = false;
	      retailer.rtlVirtualFlag = true;
	      retailer.rtlMasterAccountId = masteraccountDropdownElement.val();
	    }
	    //retailer.rtlMasterFlag=masterAccountToggleCheckboxElement.prop("checked");
	    //retailer.rtlVirtualFlag=managedByMasteraccountToggleCheckboxElement.prop("checked");
	    //retailer.rtlMasterAccountId=masteraccountDropdownElement.val();
	    //alert(masterAccountToggleCheckboxElement.prop("checked"));
	    //alert(managedByMasteraccountToggleCheckboxElement.prop("checked"));
	    //alert(masteraccountDropdownElement.val());
	  }
	
	  function createOrUpdateRetailerJson2(addressType, elsScope) {
	    if (addressType == 'Primary') {
	      retailer.rtlContactNamePrefix = elsScope.retPrefix.val();
	      retailer.rtlContactFirstName = elsScope.retFirstName.val();
	      retailer.rtlContactLastName = elsScope.retLastName.val();
	      retailer.rtlEmail = elsScope.retEmail.val();
	      retailer.rtlMobilePhoneCountryCode = elsScope.mobileCounryCode.val();
	      retailer.rtlMobilePhoneAreaCode = elsScope.mobileAreaCode.val();
	      retailer.rtlMobilePhone = elsScope.mobilePhone.val();
	      retailer.rtlOfficePhoneCountryCode = elsScope.officeCounryCode.val();
	      retailer.rtlOfficePhoneAreaCode = elsScope.officeAreaCode.val();
	      retailer.rtlOfficePhone = elsScope.officePhone.val();
	      retailer.rtlOfficePhoneExt = elsScope.officeExt.val();
	
	      retailer.rtlAddress1 = elsScope.address1.val();
	      retailer.rtlAddress2 = elsScope.address2.val();
	      retailer.rtlCity = elsScope.city.val();
	      if (elsScope.country.val() == 'US' || elsScope.country.val() == 'CA') {
	        retailer.rtlState = elsScope.state.val();
	      } else {
	        retailer.rtlState = elsScope.nonUSCAstate.val();
	      }
	      retailer.rtlConCode = elsScope.country.val();
	      retailer.rtlZip = elsScope.zipCode.val();
	      retailer.rtlCounty = elsScope.county.val();
	
	      if ((0, _jquery2.default)('.primary-information-tab .insight-feed-switch').is(":checked")) {
	        retailer.rtlInsightFeedFlag = true;
	      } else {
	        retailer.rtlInsightFeedFlag = false;
	      }
	
	      if ((0, _jquery2.default)('.primary-information-tab .fuel-Surchrg-switch').is(":checked")) {
	        retailer.rtlFuelSurchrgDiscFlag = true;
	      } else {
	        retailer.rtlFuelSurchrgDiscFlag = false;
	      }
	
	      if ((0, _jquery2.default)('.primary-information-tab .direct-bill-switch').is(":checked")) {
	        retailer.directBillCustomerFlag = true;
	      } else {
	        retailer.directBillCustomerFlag = false;
	      }
	
	      retailer.childRetailers = [];
	      if (elsScope.affMerchantSwitchery.is(":checked")) {
	        if ((0, _jquery2.default)(".affMerchantNameValue").length == 0) {
	          (0, _jquery2.default)('.merchants-target-section').hide();
	        } else {
	          (0, _jquery2.default)('.merchants-target-section').show();
	        }
	        _jquery2.default.each((0, _jquery2.default)(".affMerchantNameValue"), function (ind, e) {
	          var childRtlr = {};
	          childRtlr.chrName = (0, _jquery2.default)(e).val();
	          retailer.childRetailers.push(childRtlr);
	        });
	      } else {
	        (0, _jquery2.default)('.merchants-target-section').hide();
	      }
	    } else {
	      //create cmrAddress and set to JSON
	      var cmrAddress = {};
	      var retailerAddresses = retailerObj.retailerAddresses;
	      if (_underscore2.default.isObject(retailerAddresses) && retailerAddresses.length > 0) {
	        cmrAddress = (0, _underscore2.default)(retailerAddresses).findWhere({ cadAddressType: addressType });
	        if (!_underscore2.default.isObject(cmrAddress)) {
	          cmrAddress = {};
	        }
	      }
	      cmrAddress.cadAddressType = addressType;
	      cmrAddress.cadContactNamePrefix = elsScope.retPrefix.val();
	      cmrAddress.cadContactName = elsScope.retFirstName.val();
	      cmrAddress.cadContactLastName = elsScope.retLastName.val();
	      cmrAddress.cadContactEmail = elsScope.retEmail.val();
	
	      if (addressType == 'Shipping') {
	        var shippingTabSwitchElement = shippingTab.find(elementsMap.sharePrimarySwitch);
	        var shippingTabSwitchElementFlag = shippingTabSwitchElement.prop("checked");
	        if (shippingTabSwitchElementFlag) {
	          if (elsScope.country.val() == 'US' || elsScope.country.val() == 'CA') {
	            cmrAddress.cadMobilePhoneAreaCode = elsScope.mobileAreaCode.val();
	            cmrAddress.cadOfficePhoneAreaCode = elsScope.officeAreaCode.val();
	          } else {
	            cmrAddress.cadMobilePhoneAreaCode = '';
	            cmrAddress.cadOfficePhoneAreaCode = '';
	          }
	          cmrAddress.cadMobilePhoneCountryCode = elsScope.mobileCounryCode.val();
	          cmrAddress.cadMobilePhone = elsScope.mobilePhone.val();
	          cmrAddress.cadOfficePhoneCountryCode = elsScope.officeCounryCode.val();
	          cmrAddress.cadOfficePhone = elsScope.officePhone.val();
	        } else {
	          if (elsScope.country.val() == 'US' || elsScope.country.val() == 'CA') {
	            cmrAddress.cadMobilePhoneAreaCode = elsScope.mobileAreaCodeShip.val();
	            cmrAddress.cadOfficePhoneAreaCode = elsScope.officeAreaCodeShip.val();
	          } else {
	            cmrAddress.cadMobilePhoneAreaCode = '';
	            cmrAddress.cadOfficePhoneAreaCode = '';
	          }
	          cmrAddress.cadMobilePhoneCountryCode = elsScope.mobileCountryCodeShip.val();
	          cmrAddress.cadMobilePhone = elsScope.mobilePhoneShip.val();
	          cmrAddress.cadOfficePhoneCountryCode = elsScope.officeCountryCodeShip.val();
	          cmrAddress.cadOfficePhone = elsScope.officePhoneShip.val();
	        }
	
	        cmrAddress.cadOfficePhoneExt = elsScope.officeExt.val();
	      }
	
	      if (addressType == 'Billing') {
	        var billingTabSwitchElement = billingTab.find(elementsMap.sharePrimarySwitch);
	        var billingTabSwitchElementFlag = billingTabSwitchElement.prop("checked");
	        if (billingTabSwitchElementFlag) {
	          if (elsScope.country.val() == 'US' || elsScope.country.val() == 'CA') {
	            cmrAddress.cadMobilePhoneAreaCode = elsScope.mobileAreaCode.val();
	            cmrAddress.cadOfficePhoneAreaCode = elsScope.officeAreaCode.val();
	          } else {
	            cmrAddress.cadMobilePhoneAreaCode = '';
	            cmrAddress.cadOfficePhoneAreaCode = '';
	          }
	          cmrAddress.cadMobilePhoneCountryCode = elsScope.mobileCounryCode.val();
	          cmrAddress.cadMobilePhone = elsScope.mobilePhone.val();
	          cmrAddress.cadOfficePhoneCountryCode = elsScope.officeCounryCode.val();
	          cmrAddress.cadOfficePhone = elsScope.officePhone.val();
	        } else {
	          if (elsScope.country.val() == 'US' || elsScope.country.val() == 'CA') {
	            cmrAddress.cadMobilePhoneAreaCode = elsScope.mobileAreaCodeBill.val();
	            cmrAddress.cadOfficePhoneAreaCode = elsScope.officeAreaCodeBill.val();
	          } else {
	            cmrAddress.cadMobilePhoneAreaCode = '';
	            cmrAddress.cadOfficePhoneAreaCode = '';
	          }
	          cmrAddress.cadMobilePhoneCountryCode = elsScope.mobileCountryCodeBill.val();
	          cmrAddress.cadMobilePhone = elsScope.mobilePhoneBill.val();
	          cmrAddress.cadOfficePhoneCountryCode = elsScope.officeCountryCodeBill.val();
	          cmrAddress.cadOfficePhone = elsScope.officePhoneBill.val();
	        }
	
	        cmrAddress.cadOfficePhoneExt = elsScope.officeExt.val();
	      }
	      cmrAddress.cadAddress1 = elsScope.address1.val();
	      cmrAddress.cadAddress2 = elsScope.address2.val();
	      cmrAddress.cadCity = elsScope.city.val();
	      if (elsScope.country.val() == 'US' || elsScope.country.val() == 'CA') {
	        cmrAddress.cadState = elsScope.state.val();
	      } else {
	        cmrAddress.cadState = elsScope.nonUSCAstate.val();
	      }
	      cmrAddress.cadCountry = elsScope.country.val();
	      cmrAddress.cadZipcode = elsScope.zipCode.val();
	      cmrAddress.cadCounty = elsScope.county.val();
	
	      //hard code values
	      cmrAddress.cadStdAddress1 = cmrAddress.cadAddress1;
	      cmrAddress.cadStdAddress2 = cmrAddress.cadAddress2;
	      cmrAddress.cadStdCity = cmrAddress.cadCity;
	      cmrAddress.cadStdState = cmrAddress.cadState;
	      cmrAddress.cadStdCountry = cmrAddress.cadCountry;
	      cmrAddress.cadStdZipcode = cmrAddress.cadZipcode;
	      cmrAddress.cadAddressValidated = 1;
	      cmrAddress.cadUseStdAddress = 1;
	      cmrAddress.cadCommercialAddrFlag = elsScope.commercialAddrFlag.val();
	
	      retailer.retailerAddresses.push(cmrAddress);
	    }
	  }
	
	  function showConfirmationModal(e) {
	    e.preventDefault();
	    confirmationModal.modal("show");
	  }
	
	  function onSubmit(e) {
	    e.preventDefault();
	    saveNow({ url: submitUrl, success: onSuccess, error: onError });
	  }
	
	  function saveNow(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error;
	
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      data: {
	        '_retailer_WAR_retailerportlet_retailerJson': JSON.stringify(retailer)
	      },
	      url: url,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function onSuccess(response) {
	    if (response && response.status == 'Success') {
	      EditChecker.setPageClean();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        //const asnDetailUrl = wizardElement.data("asn-detail-url");
	        location.href = renderUrl;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function onError() {
	    submitModalFlow.showFailureModal();
	  }
	}

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShippingTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  sharePrimarySwitch: '.switch-share-primary',
	  prefix: '.ret-prefix',
	  firstName: '.ret-first-name',
	  lastName: '.ret-last-name',
	  email: '.ret-email',
	  addMobileBtn: '.add-mobile-number-btn',
	  removeMobileBtn: '.remove-mobile-btn',
	  addressSection: '.address-section',
	  contactSection: '.contact-section',
	  phoneSection: '.phone-section'
	};
	
	var addressElementsMap = {
	  country: '.ret-country',
	  address1: '.ret-address1',
	  address2: '.ret-address2',
	  city: '.ret-city',
	  state: '.ret-state',
	  zipCode: '.ret-zip-code',
	  postalCodeLabel: '#postalcode-label',
	  stateLabel: '#state-label',
	  county: '.ret-county',
	  countyMandatoryLabel: '.county-mandatory-label',
	  stateSelectContainer: '.state-wrapper',
	  stateTextContainer: '.state-text-wrapper',
	  stateTextInput: '.ret-state-text',
	  commercialAddressFlag: '.commercial-addr-flag'
	};
	
	var phoneElementsMap = {
	  officeCountryCodeShip: '.ret-office-country-code-ship',
	  officePhoneShip: '.ret-office-phone-ship',
	  officeAreaCodeShip: '.ret-office-area-code-ship',
	  mobileCountryCodeShip: '.ret-mobile-country-code-ship',
	  mobilePhoneShip: '.ret-mobile-phone-ship',
	  mobileAreaCodeShip: '.ret-mobile-area-code-ship',
	  mobilePhoneSection: '.ret-mobile-number-section',
	  officeExt: '.ret-office-ext',
	  officeCountryCode: '.ret-office-country-code',
	  officePhone: '.ret-office-phone',
	  officeAreaCode: '.ret-office-area-code',
	  mobileCountryCode: '.ret-mobile-country-code',
	  mobilePhone: '.ret-mobile-phone',
	  mobileAreaCode: '.ret-mobile-area-code'
	};
	
	function ShippingTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	  var primaryEls = {};
	  var retailerWizard = (0, _jquery2.default)('#retailer-wizard');
	  var validationReqdCountries = JSON.parse(retailerWizard.attr("data-validation-reqd-countries"));
	  var shippingTab = wizardElement.find('.shipping-information-tab');
	  var primaryTab = wizardElement.find('.primary-information-tab');
	  var defaultContry = wizardElement.data('default-country');
	  var usaStates = wizardElement.data('usa-states');
	  var caProvinces = wizardElement.data('ca-provinces');
	  var countriesPhoneCodeList = wizardElement.data('country-phone-code-list');
	  var countries = wizardElement.data('countries');
	  var prefixes = wizardElement.data('prefixes');
	  var retailerJsonString = wizardElement.data('retailer-obj');
	  var rtlType = wizardElement.data('rtl-type');
	  var elementSelector = "input, select";
	  var isDataModified = false;
	  var countryId = void 0;
	
	  self.init = function () {
	    render();
	  };
	
	  function render() {
	    setElements();
	    (0, _selectorHelpers.setUniqNamesAndIds)(els); // jquery validator needs that all "name" attribute are unique
	    loadDropDowns();
	    setStates(defaultContry);
	    els.country.on("change", countryChange); // due to an issue in country triggering, moving it up
	    renderViewWithData();
	    bindElements();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, addressElementsMap, shippingTab);
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, shippingTab);
	    (0, _selectorHelpers.setElementsFromScope)(els, phoneElementsMap, shippingTab);
	
	    (0, _selectorHelpers.setElementsFromScope)(primaryEls, addressElementsMap, primaryTab);
	    (0, _selectorHelpers.setElementsFromScope)(primaryEls, elementsMap, primaryTab);
	    (0, _selectorHelpers.setElementsFromScope)(primaryEls, phoneElementsMap, primaryTab);
	  }
	
	  function bindElements() {
	    els.officeCountryCodeShip.on("change", officeCountryCodeChange);
	    els.mobileCountryCodeShip.on("change", mobileCountryCodeChange);
	    (0, _jquery2.default)(document).on("click", '.shipping-information-tab .add-mobile-number-btn', handleAddMobileBtn);
	    (0, _jquery2.default)(document).on("click", '.shipping-information-tab .remove-mobile-btn', handleRemoveMobileBtn);
	    // for share primary address switch
	    (0, _jquery2.default)('.shipping-information-tab .switch-share-primary').on("change", handleSharePrimarySwitch);
	    // To check if some information is modified. require to replace primary info if user modified something on tab
	    _underscore2.default.map(shippingTab.find((0, _jquery2.default)(elementSelector)), function (element) {
	      if (!(0, _jquery2.default)(element).is(":checkbox")) {
	        (0, _jquery2.default)(element).on("change", handleInputChange);
	      }
	    });
	  }
	
	  function loadDropDowns() {
	    (0, _jquery2.default)(countries).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conCode).text(this.conName);
	      els.country.append(option);
	    });
	
	    (0, _jquery2.default)(countriesPhoneCodeList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
	      els.officeCountryCodeShip.append(option);
	    });
	
	    (0, _jquery2.default)(countriesPhoneCodeList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.conPhoneCode).text(this.conPhoneText);
	      els.mobileCountryCodeShip.append(option);
	    });
	
	    (0, _jquery2.default)(prefixes).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmMeaning);
	      els.prefix.append(option);
	    });
	  }
	
	  function setStates(countryVal) {
	    els.state.html('');
	    var option = (0, _jquery2.default)('<option />'); // This is the default option
	    option.attr('value', "-1").text('Select State/Province/Region');
	    option.attr('selected', 'selected');
	    option.attr('disabled', 'disabled');
	    var checkZipCode = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	
	    if (countryVal == "US" && checkZipCode) {
	      (0, _selectorHelpers.show)(els.stateSelectContainer);
	      (0, _selectorHelpers.hide)(els.stateTextContainer);
	      //els.countyMandatoryLabel.show();
	
	      els.state.prop('required', true);
	      els.stateTextInput.prop('required', false);
	      els.zipCode.addClass("zipcodeUS");
	      els.zipCode.prop('required', true);
	      els.stateLabel.text('State/Province/Region *');
	      els.postalCodeLabel.text('Postal Code *');
	      els.state.append(option);
	      (0, _jquery2.default)(usaStates).each(function () {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        els.state.append(option);
	      });
	    } else if (countryVal == "CA" && checkZipCode) {
	      (0, _selectorHelpers.show)(els.stateSelectContainer);
	      (0, _selectorHelpers.hide)(els.stateTextContainer);
	      //els.countyMandatoryLabel.hide();
	
	      els.state.prop('required', true);
	      els.stateTextInput.prop('required', false);
	      els.zipCode.removeClass("zipcodeUS");
	      els.zipCode.prop('required', true);
	      els.state.append(option);
	      els.stateLabel.text('State/Province/Region *');
	      els.postalCodeLabel.text('Postal Code *');
	      (0, _jquery2.default)(caProvinces).each(function () {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        els.state.append(option);
	      });
	    } else {
	      if (checkZipCode) {
	        els.stateLabel.text('State/Province/Region');
	        els.postalCodeLabel.text('Postal Code *');
	        els.state.prop('required', false);
	        els.stateTextInput.prop('required', false);
	        els.zipCode.removeClass("zipcodeUS");
	        els.zipCode.prop('required', true);
	        //els.zipCode.valid();
	
	        //els.countyMandatoryLabel.hide();
	        (0, _selectorHelpers.hide)(els.stateSelectContainer);
	        (0, _selectorHelpers.show)(els.stateTextContainer);
	      } else {
	        els.stateLabel.text('State/Province/Region');
	        els.postalCodeLabel.text('Postal Code');
	        els.state.prop('required', false);
	        els.stateTextInput.prop('required', false);
	        els.zipCode.removeClass("zipcodeUS");
	        els.zipCode.prop('required', false);
	        els.zipCode.valid();
	
	        //els.countyMandatoryLabel.hide();
	        (0, _selectorHelpers.hide)(els.stateSelectContainer);
	        (0, _selectorHelpers.show)(els.stateTextContainer);
	      }
	    }
	  }
	
	  function renderViewWithData() {
	    var retailer = getRetailer();
	    if (_underscore2.default.isObject(retailer)) {
	      // During edit, pre populate data
	      setSwithcery(els.sharePrimarySwitch, retailer.rtlShipAccEqPrimary);
	      if (retailer.rtlShipAccEqPrimary) {
	        // If shipping tab shared from primary
	        hideAllSections();
	      } else {
	        showAllSections();
	      }
	      var shippingAddress = getShippingAddress(retailer);
	      if (_underscore2.default.isObject(shippingAddress)) {
	        setData(shippingAddress);
	      } else {
	        (0, _selectorHelpers.hide)(els.mobilePhoneSection); // blank form shown with no mobile section
	      }
	    } else {
	      // New retailer
	      (0, _selectorHelpers.hide)(els.mobilePhoneSection); // Not shown on initial load while creating new
	      setSwithcery(els.sharePrimarySwitch, true);
	      // since be default, share primary is Yes, hide all sections
	      hideAllSections();
	    }
	  }
	
	  function setData(shippingAddress) {
	    els.country.val(shippingAddress.cadCountry).trigger("change");
	    els.address1.val(shippingAddress.cadAddress1);
	    els.address2.val(shippingAddress.cadAddress2);
	    els.city.val(shippingAddress.cadCity);
	
	    if (shippingAddress.cadCountry != "US" && shippingAddress.cadCountry != "CA") {
	      // Set state text box
	      els.stateTextInput.val(shippingAddress.cadState);
	    } else {
	      els.state.val(shippingAddress.cadState).trigger("change");
	    }
	
	    els.zipCode.val(shippingAddress.cadZipcode);
	    els.county.val(shippingAddress.cadCounty);
	
	    els.prefix.val(shippingAddress.cadContactNamePrefix).trigger("change");
	    els.firstName.val(shippingAddress.cadContactName);
	    els.lastName.val(shippingAddress.cadContactLastName);
	    els.email.val(shippingAddress.cadContactEmail);
	
	    els.officeCountryCodeShip.val(shippingAddress.cadOfficePhoneCountryCode).trigger("change");
	
	    if (shippingAddress.cadOfficePhoneCountryCode === '+1') {
	
	      els.officePhoneShip.attr("placeholder", "___-____");
	      els.officePhoneShip.addClass('ret-phone-number-jqv');
	      els.officePhoneShip.removeClass('phoneNonUS');
	      els.officePhoneShip.val(shippingAddress.cadOfficePhone);
	      if (els.officeAreaCodeShip) {
	        els.officeAreaCodeShip.removeClass('phoneNonUS');
	        els.officeAreaCodeShip.val(shippingAddress.cadOfficePhoneAreaCode);
	      }
	      addmasks();
	    } else {
	
	      els.officePhoneShip.addClass('phoneNonUS');
	      els.officePhoneShip.removeClass('ret-phone-number-jqv');
	      els.officePhoneShip.removeAttr('placeholder');
	      els.officePhoneShip.inputmask({ mask: "" });
	
	      //cadOfficePhoneAreaCode validation start
	      els.officeAreaCodeShip.addClass('phoneNonUS');
	      els.officeAreaCodeShip.removeAttr('placeholder');
	      els.officeAreaCodeShip.inputmask({ mask: "" });
	
	      if (shippingAddress.cadOfficePhoneAreaCode) {
	        var val = shippingAddress.cadOfficePhoneAreaCode;
	        var v = val.replace(/[^0-9.]/g, "");
	        shippingAddress.cadOfficePhoneAreaCode = v;
	
	        if (els.officeAreaCodeShip) {
	          els.officeAreaCodeShip.inputmask({ mask: "" });
	          els.officeAreaCodeShip.addClass('phoneNonUS');
	          els.officeAreaCodeShip.val(v);
	        }
	      }
	      if (els.officeAreaCodeShip) {
	        (0, _selectorHelpers.hide)(els.officeAreaCodeShip);
	      }
	      //cadOfficePhoneAreaCode validation end
	
	      //cadOfficePhone validation start
	      if (shippingAddress.cadOfficePhone) {
	        var _val = shippingAddress.cadOfficePhone;
	        var _v = _val.replace(/[^0-9.]/g, "");
	        shippingAddress.cadOfficePhone = _v;
	        els.officePhoneShip.val(_v);
	      }
	      //cadOfficePhone validation end
	
	    }
	
	    els.officeExt.val(shippingAddress.cadOfficePhoneExt);
	
	    if (!isMobileInformationPresent(shippingAddress)) {
	      els.mobileCountryCodeShip.val(shippingAddress.cadMobilePhoneCountryCode).trigger("change");
	
	      if (shippingAddress.cadMobilePhoneCountryCode === '+1') {
	
	        els.mobilePhoneShip.removeClass('phoneNonUS');
	        if (els.cadMobilePhoneAreaCode) {
	          els.cadMobilePhoneAreaCode.removeClass('phoneNonUS');
	        }
	        els.mobilePhoneShip.addClass('ret-phone-number-jqv');
	        els.mobilePhoneShip.attr("placeholder", "___-____");
	        addMasksMobilePhone();
	        els.mobilePhoneShip.val(shippingAddress.cadMobilePhone);
	
	        if (shippingAddress.cadMobilePhoneAreaCode != null) {
	          els.mobileAreaCodeShip.val(shippingAddress.cadMobilePhoneAreaCode);
	        } else {
	          (0, _selectorHelpers.hide)(els.mobileAreaCodeShip);
	        }
	      } else {
	
	        /* Start Phone number changes */
	        els.mobilePhoneShip.addClass('phoneNonUS');
	        els.mobilePhoneShip.removeClass('ret-phone-number-jqv');
	        els.mobilePhoneShip.removeAttr('placeholder');
	        els.mobilePhoneShip.inputmask({ mask: "" });
	
	        if (shippingAddress.cadMobilePhone) {
	          var _val2 = shippingAddress.cadMobilePhone;
	          var _v2 = _val2.replace(/[^0-9.]/g, "");
	          shippingAddress.cadMobilePhone = _v2;
	          els.mobilePhoneShip.val(_v2);
	        }
	        /* End Phone number changes */
	
	        /* Start Mobile code number changes */
	
	        if (els.cadMobilePhoneAreaCode) {
	          els.mobileAreaCodeShip.inputmask({ mask: "" });
	          els.mobileAreaCodeShip.addClass('phoneNonUS');
	          els.mobileAreaCodeShip.removeAttr('placeholder');
	        }
	
	        if (shippingAddress.cadMobilePhoneAreaCode) {
	          var _val3 = shippingAddress.cadMobilePhoneAreaCode;
	          var _v3 = _val3.replace(/[^0-9.]/g, "");
	          shippingAddress.cadMobilePhoneAreaCode = _v3;
	          els.mobileAreaCodeShip.val(_v3);
	        } else {
	          (0, _selectorHelpers.hide)(els.mobileAreaCodeShip);
	        }
	      }
	
	      (0, _selectorHelpers.hide)(els.addMobileBtn);
	    } else {
	      (0, _selectorHelpers.hide)(els.mobilePhoneSection);
	      (0, _selectorHelpers.show)(els.addMobileBtn);
	    }
	  }
	
	  function setPrimaryInfoData() {
	    els.country.val(primaryEls.country.val()).trigger("change");
	    els.address1.val(primaryEls.address1.val());
	    els.address2.val(primaryEls.address2.val());
	    els.city.val(primaryEls.city.val());
	
	    if (primaryEls.country.val() != "US" && primaryEls.country.val() != "CA") {
	      // Set state text input
	      els.stateTextInput.val(primaryEls.stateTextInput.val());
	    } else {
	      els.state.val(primaryEls.state.val()).trigger("change");
	    }
	
	    els.zipCode.val(primaryEls.zipCode.val());
	    els.county.val(primaryEls.county.val());
	
	    els.prefix.val(primaryEls.prefix.val()).trigger("change");
	    els.firstName.val(primaryEls.firstName.val());
	    els.lastName.val(primaryEls.lastName.val());
	    els.email.val(primaryEls.email.val());
	    els.officeCountryCodeShip.val(primaryEls.officeCountryCode.val()).trigger("change");
	    els.officePhoneShip.val(primaryEls.officePhone.val());
	    els.officeAreaCodeShip.val(primaryEls.officeAreaCode.val());
	    els.officeExt.val(primaryEls.officeExt.val());
	
	    if (primaryEls.mobilePhoneSection.is(":visible")) {
	      (0, _selectorHelpers.show)(els.mobilePhoneSection);
	      els.mobileCountryCodeShip.val(primaryEls.mobileCountryCode.val()).trigger("change");
	      els.mobilePhoneShip.val(primaryEls.mobilePhone.val());
	      els.mobileAreaCodeShip.val(primaryEls.mobileAreaCode.val());
	      (0, _selectorHelpers.hide)(els.addMobileBtn);
	    } else {
	      (0, _selectorHelpers.hide)(els.mobilePhoneSection);
	      (0, _selectorHelpers.show)(els.addMobileBtn);
	    }
	  }
	
	  function setSwithcery(checkbox, bool) {
	    (0, _instantiateSwitchery.instantiateSwitchery)(checkbox);
	    (0, _instantiateSwitchery.setSwitchery)(checkbox, bool);
	  }
	
	  function handleAddMobileBtn() {
	    (0, _selectorHelpers.show)(els.mobilePhoneSection);
	    (0, _selectorHelpers.hide)(els.addMobileBtn);
	  }
	
	  function handleRemoveMobileBtn() {
	    (0, _selectorHelpers.hide)(els.mobilePhoneSection);
	    (0, _selectorHelpers.show)(els.addMobileBtn);
	    els.mobileCountryCodeShip.val('');
	    els.mobileAreaCodeShip.val('');
	    els.mobilePhoneShip.val('');
	
	    var retailer = getRetailer();
	    if (_underscore2.default.isObject(retailer)) {
	      var shippingAddress = getShippingAddress(retailer);
	      shippingAddress.cadMobilePhoneCountryCode = '';
	      shippingAddress.cadMobilePhone = '';
	      shippingAddress.cadMobilePhoneAreaCode = '';
	    }
	  }
	
	  function isMobileInformationPresent(shippingAddress) {
	    return (0, _general.isBlank)(shippingAddress.cadMobilePhoneCountryCode) && (0, _general.isBlank)(shippingAddress.cadMobilePhone) && (0, _general.isBlank)(shippingAddress.cadMobilePhoneAreaCode);
	  }
	
	  function handleSharePrimarySwitch() {
	    if (isWizardOnShippingTab()) {
	      if (this.checked) {
	        hideAllSections();
	      } else {
	        showAllSections();
	        if (!isEdit() && !isDataModified) {
	          setPrimaryInfoData();
	        }
	      }
	    }
	  }
	
	  function handleInputChange(e) {
	    e.preventDefault();
	    if (isWizardOnShippingTab() && !self.isPrimarySwitchOn()) {
	      isDataModified = true;
	    }
	  }
	
	  function isWizardOnShippingTab() {
	    return (0, _jquery2.default)(wizard.getActiveTargetForm()).filter(".shipping-information-tab").length > 0;
	  }
	
	  self.isPrimarySwitchOn = function () {
	    return (0, _jquery2.default)('.shipping-information-tab .switch-share-primary').is(":checked");;
	  };
	
	  function showAllSections() {
	    (0, _selectorHelpers.show)(els.addressSection);
	    (0, _selectorHelpers.show)(els.contactSection);
	    (0, _selectorHelpers.show)(els.phoneSection);
	  }
	
	  function hideAllSections() {
	    (0, _selectorHelpers.hide)(els.addressSection);
	    (0, _selectorHelpers.hide)(els.contactSection);
	    (0, _selectorHelpers.hide)(els.phoneSection);
	  }
	
	  function countryChange() {
	    var countryVal = els.country.find('option:selected').val();
	    var isValidCountry = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        countryId = this.conPhoneCode.toString();
	        return false;
	      }
	    });
	    (0, _jquery2.default)(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryVal.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (isValidCountry) {
	      (0, _jquery2.default)(".country_not_supported_shipping").hide();
	    } else {
	      (0, _jquery2.default)(".country_not_supported_shipping").show();
	    }
	    setStates(countryVal);
	    if (countryVal === "US") {
	      (0, _jquery2.default)(".ret-office-country-code-ship option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States of America +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "CA") {
	      (0, _jquery2.default)(".ret-office-country-code-ship option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "Canada +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "UM") {
	      (0, _jquery2.default)(".ret-office-country-code-ship option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States Minor Outlying Islands +1";
	      }).prop("selected", true).trigger("change");
	    } else {
	      (0, _jquery2.default)(".ret-office-country-code-ship option").filter(function () {
	        var text = (0, _jquery2.default)(this).val().toString();
	        return text === countryId.toString();
	      }).prop("selected", true).trigger("change");
	    }
	    if (countryVal === "US" || countryVal === "CA") {
	      (0, _selectorHelpers.show)(els.officeAreaCodeShip);
	      els.officePhoneShip.attr("placeholder", "___-____");
	      els.officePhoneShip.addClass('ret-phone-number-jqv');
	      els.officePhoneShip.removeClass('phoneNonUS');
	      addmasks();
	    } else {
	      els.officeAreaCodeShip.val('');
	      if (els.officeAreaCodeShip) {
	        (0, _selectorHelpers.hide)(els.officeAreaCodeShip);
	      }
	      els.officePhoneShip.val('');
	      els.officePhoneShip.addClass('phoneNonUS');
	      els.officePhoneShip.removeClass('ret-phone-number-jqv');
	      els.officePhoneShip.removeAttr('placeholder');
	      els.officePhoneShip.inputmask({
	        mask: ""
	      });
	    }
	  }
	
	  function addmasks() {
	    (0, _jquery2.default)('.ret-office-area-code-ship').inputmask({
	      mask: "(999)"
	    });
	
	    (0, _jquery2.default)('.ret-office-phone-ship').inputmask({
	      mask: "999-9999"
	    });
	  }
	
	  function addMasksMobilePhone() {
	    (0, _jquery2.default)('.ret-mobile-area-code-ship').inputmask({
	      mask: "(999)"
	    });
	
	    (0, _jquery2.default)('.ret-mobile-phone-ship').inputmask({
	      mask: "999-9999"
	    });
	  }
	
	  function mobileCountryCodeChange() {
	    var mobilecode = els.mobileCountryCodeShip.find('option:selected').val().toString();
	    els.mobilePhoneShip.val('');
	    if (els.mobileAreaCodeShip) {
	      els.mobileAreaCodeShip.val('');
	    }
	    if (mobilecode === '+1') {
	      (0, _selectorHelpers.show)(els.mobileAreaCodeShip);
	      els.mobilePhoneShip.attr("placeholder", "___-____");
	      els.mobilePhoneShip.addClass('ret-phone-number-jqv');
	      els.mobilePhoneShip.removeClass('phoneNonUS');
	      if (els.mobileAreaCodeShip) {
	        els.mobileAreaCodeShip.removeClass('phoneNonUS');
	      }
	      addMasksMobilePhone();
	    } else {
	      (0, _selectorHelpers.hide)(els.mobileAreaCodeShip);
	      els.mobilePhoneShip.addClass('phoneNonUS');
	      els.mobilePhoneShip.removeClass('ret-phone-number-jqv');
	      els.mobilePhoneShip.removeAttr('placeholder');
	      els.mobilePhoneShip.inputmask({ mask: "" });
	    }
	  }
	
	  function officeCountryCodeChange() {
	    var phoneCode = els.officeCountryCodeShip.find('option:selected').val().toString();
	    els.officePhoneShip.val('');
	    if (els.officeAreaCodeShip) {
	      els.officeAreaCodeShip.val('');
	    }
	    if (phoneCode === '+1') {
	      (0, _selectorHelpers.show)(els.officeAreaCodeShip);
	      els.officePhoneShip.attr("placeholder", "___-____");
	      els.officePhoneShip.addClass('ret-phone-number-jqv');
	      els.officePhoneShip.removeClass('phoneNonUS');
	      if (els.officeAreaCodeShip) {
	        els.officeAreaCodeShip.removeClass('phoneNonUS');
	      }
	      addmasks();
	    } else {
	      (0, _selectorHelpers.hide)(els.officeAreaCodeShip);
	      els.officePhoneShip.addClass('phoneNonUS');
	      els.officePhoneShip.removeClass('ret-phone-number-jqv');
	      els.officePhoneShip.removeAttr('placeholder');
	      els.officePhoneShip.inputmask({ mask: "" });
	    }
	  }
	
	  function getRetailer() {
	    if (!(0, _general.isBlank)(retailerJsonString)) {
	      return retailerJsonString;
	    } else {
	      return null;
	    }
	  }
	
	  function getShippingAddress(retailer) {
	    var shippingAddress = (0, _underscore2.default)(retailer.retailerAddresses).find(function (address, k) {
	      return address.cadAddressType == "Shipping";
	    });
	
	    return shippingAddress;
	  }
	
	  function existingRetailerHasShippingAddress() {
	    return isEdit() && _underscore2.default.isObject(getShippingAddress(getRetailer()));
	  }
	
	  function isEdit() {
	    return _underscore2.default.isObject(getRetailer());
	  }
	}

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _typeAheadSource = __webpack_require__(71);
	
	var _typeAheadSource2 = _interopRequireDefault(_typeAheadSource);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _DetailsTab = __webpack_require__(671);
	
	var _DetailsTab2 = _interopRequireDefault(_DetailsTab);
	
	var _PrimaryTab = __webpack_require__(673);
	
	var _PrimaryTab2 = _interopRequireDefault(_PrimaryTab);
	
	var _ShippingTab = __webpack_require__(675);
	
	var _ShippingTab2 = _interopRequireDefault(_ShippingTab);
	
	var _BillingTab = __webpack_require__(670);
	
	var _BillingTab2 = _interopRequireDefault(_BillingTab);
	
	var _FscFacilitiesTab = __webpack_require__(672);
	
	var _FscFacilitiesTab2 = _interopRequireDefault(_FscFacilitiesTab);
	
	var _ReviewTab = __webpack_require__(674);
	
	var _ReviewTab2 = _interopRequireDefault(_ReviewTab);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _escapeStringRegexp = __webpack_require__(271);
	
	var _escapeStringRegexp2 = _interopRequireDefault(_escapeStringRegexp);
	
	var _jumpToWizardLogic = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	// Templates
	var addressFormTemplate = __webpack_require__(1346);
	var phoneFormTemplate = __webpack_require__(1353);
	__webpack_require__(1092);
	
	// Live form from jsp
	var targetSelector = "#retailer-wizard";
	var isMerchant = false;
	var isCSR = false;
	var rltType = void 0;
	var supplychainFacilities = void 0;
	var shippingServices = void 0;
	var enableUserEnteredAddressRadioForSPL = true;
	var disableSubmitAddressBtnIfInvalidAddressForSPL = true;
	
	(0, _run2.default)(targetSelector, function () {
	  var el = $(targetSelector);
	  isCSR = el.data("is-csr");
	  rltType = el.data('rtl-type');
	  supplychainFacilities = el.data('supplychain-facilities');
	  shippingServices = el.data('shipping-services');
	  if (el.data('rtl-type') === "SPL") {
	    isMerchant = true;
	    enableUserEnteredAddressRadioForSPL = false;
	    disableSubmitAddressBtnIfInvalidAddressForSPL = false;
	  }
	  createUpdate(el);
	  setupEditChecker(el);
	});
	
	function getRenderedSCFacilities() {
	  var splFacilityHtml = __webpack_require__(1362);
	  var response = _underscore2.default.map(supplychainFacilities, function (supplychainFacilityItem) {
	    return (0, _render2.default)(splFacilityHtml, {
	      supplyChainFac: supplychainFacilityItem
	    });
	  });
	  return response.join("");
	}
	
	function getShippingServices() {
	  var shippingServicesHtml = __webpack_require__(1361);
	  var response = _underscore2.default.map(shippingServices, function (shippingServicesItem) {
	    return (0, _render2.default)(shippingServicesHtml, {
	      shippingServ: shippingServicesItem
	    });
	  });
	  return response.join("");
	}
	
	function getRenderRetailerFedExIdSec() {
	  var RetailerFedExIdHtml = __webpack_require__(1355);
	  var response = _underscore2.default.map(supplychainFacilities, function (supplychainFacilityItem) {
	    if (supplychainFacilityItem.facId == 1 || supplychainFacilityItem.facId == 2) {
	      return (0, _render2.default)(RetailerFedExIdHtml, {
	        supplyChainFac: supplychainFacilityItem
	
	      });
	    }
	  });
	  return response.join("");
	}
	
	function setupEditChecker(el) {
	  _EditChecker2.default.bindNavigation();
	  _EditChecker2.default.bindChangeListener("#retailer-wizard");
	  _EditChecker2.default.bindChangeListener("span.select2");
	  $("#retailer-cancel-btn").data("edit-checker-redirect", el.data("cancel-redirect-url")); // cancel url set from jsp
	  _EditChecker2.default.bindCancelButton("#retailer-cancel-btn");
	}
	
	function createUpdate(el) {
	
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	    // Place all your validation rules here!!!
	    // rules: {
	
	    // }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  var sharedFormCreator = function sharedFormCreator(template, sectionTitle, hasSwitchery, canAllowFedexToCall, primaryphone, shippingphone, billingphone) {
	    var init = (0, _render2.default)(template, {
	      sectionTitle: sectionTitle,
	      hasSwitchery: hasSwitchery,
	      canAllowFedexToCall: canAllowFedexToCall,
	      isMerchant: isMerchant,
	      primaryphone: primaryphone,
	      shippingphone: shippingphone,
	      billingphone: billingphone
	    });
	    return init;
	  };
	  var reviewContentDisplay = function reviewContentDisplay(hasPrimaryFields, contactType, sectionWrapper, targetTab, expandableTarget) {
	    var init = (0, _render2.default)(__webpack_require__(1357), {
	      hasPrimaryFields: hasPrimaryFields,
	      isCSR: isCSR,
	      contactType: contactType,
	      sectionWrapper: sectionWrapper,
	      targetTab: targetTab,
	      expandableTarget: expandableTarget,
	      rltType: rltType
	    });
	    return init;
	  };
	
	  var wizardHtml = $((0, _render2.default)(__webpack_require__(1356), {
	    hasMerchent: isMerchant,
	    detailsTab: (0, _render2.default)(__webpack_require__(1349), {
	      //addressForm1: sharedFormCreator(addressFormTemplate, "Primary Account Address", false),
	      // addressForm2: sharedFormCreator(addressFormTemplate, "Primary Contact Address", true, "Primary Contact Address shares Primary Account Address"),
	      //multiPhoneForm1: sharedFormCreator(phoneFormTemplate, "Primary Contact Phone", false, true),
	      // multiPhoneForm2: sharedFormCreator(phoneFormTemplate, "Primary Contact Form", true, "Primary Contact Phone shares Primary Account Phone"),
	    }),
	    primaryInformationTab: (0, _render2.default)(__webpack_require__(1354), {
	      hasMerchent: isMerchant,
	      isCSR: isCSR,
	      rltType: rltType,
	      supplyChainFac: getRenderedSCFacilities(),
	      shippingServ: getShippingServices(),
	      addressForm1: sharedFormCreator(addressFormTemplate, "Primary Account Address", false, true, true, false, false),
	      // addressForm2: sharedFormCreator(addressFormTemplate, "Primary Contact Address", true, "Primary Contact Address shares Primary Account Address"),
	      multiPhoneForm1: sharedFormCreator(phoneFormTemplate, "Primary Contact Phone", false, true, true, false, false)
	      // multiPhoneForm2: sharedFormCreator(phoneFormTemplate, "Primary Contact Form", true, "Primary Contact Phone shares Primary Account Phone"),
	      //retailerFedExId : getRenderRetailerFedExIdSec()
	    }),
	    shippingInformationTab: (0, _render2.default)(__webpack_require__(1360), {
	      hasMerchent: isMerchant,
	      shippingAccountAddressForm: sharedFormCreator(addressFormTemplate, "Shipping Account Information", true, false, false, true, false),
	      // shippingAccountPhoneForm: sharedFormCreator(phoneFormTemplate, "Shipping Account Phone", false, false),
	      // shippingContactAddressForm: sharedFormCreator(addressFormTemplate, "Shipping Contact Address", true, "Shipping Contact Address shares Shipping Account Address"),
	      shippingContactPhoneForm: sharedFormCreator(phoneFormTemplate, "Shipping Contact Phone", false, false, false, true, false)
	    }),
	    billingInformationTab: (0, _render2.default)(__webpack_require__(1347), {
	      hasMerchent: isMerchant,
	      billingAccountAddressForm: sharedFormCreator(addressFormTemplate, "Billing Account Information", true, false, false, false, true),
	      billingAccountPhoneForm: sharedFormCreator(phoneFormTemplate, "Billing Contact Phone", false, false, false, false, true)
	      // billingContactAddressForm: sharedFormCreator(addressFormTemplate, "Billing Contact Address", true, "Billing Contact Address shares Billing Account Address"),
	      // billingContactPhoneForm: sharedFormCreator(phoneFormTemplate, "Billing Contact Phone", true, "Billing Contact Phone shares Billing Account Phone"),
	    }),
	    fscFacilitiesTab: (0, _render2.default)(__webpack_require__(1352), {}),
	    reviewTab: (0, _render2.default)(__webpack_require__(1358), {
	      primaryAccountInformation: reviewContentDisplay(true, "Primary", "primary-info-section", ".primary-information-tab"),
	      shippingAccountInformation: reviewContentDisplay(false, "Shipping", "shipping-info-section", ".shipping-information-tab", "shipping-account-review"),
	      billingAccountInformation: reviewContentDisplay(false, "Billing", "billing-info-section", ".billing-information-tab", "billing-account-review")
	    })
	  }));
	  el.html(wizardHtml);
	
	  var addressValidationModalEl = $("#add-validation-model");
	
	  var quickWizard = new _QuickWizard2.default(el, {
	    tabletWidthNavStep: 1048,
	    mobileWidthNavStep: 886,
	    shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	      var targetForm = _ref.targetForm,
	          direction = _ref.direction,
	          currentForm = _ref.currentForm,
	          done = _ref.done;
	
	
	      if (direction === "BACKWARDS") {
	        return true;
	      }
	      if (currentForm.filter(".details-tab").length) {
	        var addressValidationForDetailsTab = (0, _AddressValidation2.default)(null, el, {
	          isAlreadyValid: false,
	          currentTab: ".details-tab",
	          disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	          disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	        });
	        var addMerchantChecked = $('#addMerchantCheckbox')[0].checked;
	        if (addMerchantChecked) {
	          if (!affiliatedMerchantHandler(el)) return false;
	        }
	        areInputsValid(true, function (validResult) {
	          handleInputsFinishedValidatingForDestinationTab(false, validResult, done, addressValidationForDetailsTab);
	        });
	      } else if (currentForm.filter(".primary-information-tab").length) {
	        var addressValidationForPrimaryTab = (0, _AddressValidation2.default)(null, el, {
	          isAlreadyValid: false,
	          currentTab: ".primary-information-tab",
	          disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	          disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	        });
	        if (el.data('rtl-type') === "HONEYCOMB_RMS") {
	          if (supplyChainFacilitiesChecked()) {
	            return false;
	          }
	          if (shippingServicesChecked()) {
	            return false;
	          }
	        }
	        areInputsValid(true, function (validResult) {
	          handleInputsFinishedValidatingForDestinationTab(false, validResult, done, addressValidationForPrimaryTab);
	        });
	      } else if (currentForm.filter(".shipping-information-tab").length) {
	        var addressValidationForShippingTab = (0, _AddressValidation2.default)(null, el, {
	          isAlreadyValid: false,
	          currentTab: ".shipping-information-tab",
	          disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	          disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	        });
	
	        areInputsValid(true, function (validResult) {
	          handleInputsFinishedValidatingForDestinationTab(shippingTab.isPrimarySwitchOn(), validResult, done, addressValidationForShippingTab);
	        });
	      } else if (currentForm.filter(".billing-information-tab").length) {
	        var addressValidationForBillingTab = (0, _AddressValidation2.default)(null, el, {
	          isAlreadyValid: false,
	          currentTab: ".billing-information-tab",
	          disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	          disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	        });
	        areInputsValid(true, function (validResult) {
	          handleInputsFinishedValidatingForDestinationTab(billingTab.isPrimarySwitchOn(), validResult, done, addressValidationForBillingTab);
	        });
	      } else if (currentForm.filter(".fscFacilities-tab").length && targetForm.filter(".review-tab").length) {
	        var addressValidationForFacilitiesTab = (0, _AddressValidation2.default)(null, el, {
	          isAlreadyValid: false,
	          currentTab: ".fscFacilities-tab",
	          disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	          disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	        });
	        areInputsValid(true, function (validResult) {
	          handleInputsFinishedValidatingForDestinationTab(false, validResult, done, addressValidationForFacilitiesTab);
	        });
	      } else {
	        areInputsValid(true, done);
	      }
	
	      function areInputsValid(shouldContinue, cb) {
	        var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	        var notValid = !quickWizard.areInputsValid(allPrevInputs, { displayErrors: true });
	        if (notValid) {
	          quickWizard.goToFirstIncompleteForm();
	          cb(false);
	        } else {
	          cb(true);
	        }
	      }
	
	      function handleInputsFinishedValidatingForDestinationTab(primarySwitchOn, validResult, cb, tabAddressValidation) {
	        if (validResult && !primarySwitchOn) {
	          tabAddressValidation.determineAddressValidity(cb);
	        } else {
	          cb(validResult);
	        }
	      }
	
	      function affiliatedMerchantHandler(el) {
	        var merchantExists = false;
	
	        var affMerchantName = $('.aff-merchant-name-val');
	        if (affMerchantName != null && affMerchantName.length > 0 && affMerchantName[0].value != '') merchantExists = true;
	        var affMerchantValue = el.find('.affMerchantNameValue');
	        $.each(affMerchantValue, function () {
	          if ($(this).val() != null && $(this).val() != '') {
	            merchantExists = true;
	          }
	        });
	        if (!merchantExists) {
	          el.find('#one-affiliated-message').show();
	          return false;
	        } else {
	          el.find('#one-affiliated-message').hide();
	          return true;
	        }
	      }
	
	      function supplyChainFacilitiesChecked() {
	        var errorAalertMsg = $('body').find('.supply-chain-fac');
	        if ($('.checkboxTest input:checkbox:checked').length > 0) {
	          errorAalertMsg.hide();
	          return false;
	        } else {
	          errorAalertMsg.show();
	          return true;
	        }
	      }
	
	      function shippingServicesChecked() {
	        var errorAalertMsg = $('body').find('.shipping-serv');
	        if ($('.checkboxTes input:checkbox:checked').length > 0) {
	          errorAalertMsg.hide();
	          return false;
	        } else {
	          errorAalertMsg.show();
	          return true;
	        }
	      }
	      return done;
	      // going foward at this point
	
	      // handle general validations on forward traversal - Comment out this part as below validation is taken care on address validation stuff.
	      // let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	
	      //if(!quickWizard.areInputsValid(allPrevInputs, {displayErrors: true})){
	      // quickWizard.goToFirstIncompleteForm();
	      //return false;
	      //} else {
	      // check if each tab address validated, except for international address or if review tab.
	      //}
	    },
	    didNavigateToForm: function didNavigateToForm(_ref2) {
	      var currentForm = _ref2.currentForm;
	
	      if (currentForm.filter(".review-tab").length) {
	        reviewTab.didNavigateToForm();
	      }
	      return true;
	    }
	  });
	
	  quickWizard.init();
	
	  $(document).on('click', "[data-target-form]", function () {
	    var form = el.find($(this).data("target-form"));
	    quickWizard.gotToForm(form);
	  });
	
	  var fedexCustomerButtonEl = el.find(".fedex-customer-toggler");
	  var fedexCustomerButton = new _QuickBtnGroup2.default(fedexCustomerButtonEl, { distributeWidth: false });
	  fedexCustomerButton.init();
	
	  instantiateNameTypeAhead($('.account-search-typeahead'));
	
	  function instantiateNameTypeAhead(el) {
	    var nameTypeAhead = el.typeahead({
	      highlight: true
	    }, {
	      name: 'retailerName',
	      source: (0, _typeAheadSource2.default)(["Jerry Thompson", "Alan Wrench", "Dennis Jones"])
	    });
	  }
	
	  addMasks();
	  addValidators();
	  setWizardTitle();
	
	  var detailsTab = new _DetailsTab2.default(quickWizard);
	  detailsTab.init();
	
	  var primaryTab = new _PrimaryTab2.default(quickWizard);
	  primaryTab.init();
	
	  var shippingTab = new _ShippingTab2.default(quickWizard);
	  shippingTab.init();
	
	  var billingTab = new _BillingTab2.default(quickWizard);
	  billingTab.init();
	
	  var fscFacilitiesTab = new _FscFacilitiesTab2.default(quickWizard);
	  fscFacilitiesTab.init();
	
	  var reviewTab = new _ReviewTab2.default(quickWizard);
	  reviewTab.init();
	
	  function addMasks() {
	    $('.ret-mobile-area-code, .ret-office-area-code').inputmask({
	      mask: "(999)"
	    });
	
	    $('.ret-mobile-phone').inputmask({
	      mask: "999-9999"
	    });
	  }
	
	  function setWizardTitle() {
	    if (isMerchant) {
	      (0, _selectorHelpers.handleDisplayFor)(el.find('.new-merchant-text'), true);
	      (0, _selectorHelpers.handleDisplayFor)(el.find('.new-retailer-text'), false);
	      (0, _selectorHelpers.handleDisplayFor)(el.find('.edit-retailer-text'), false);
	    } else {
	      (0, _selectorHelpers.handleDisplayFor)(el.find('.new-merchant-text'), false);
	      (0, _selectorHelpers.handleDisplayFor)(el.find('.new-retailer-text'), !_underscore2.default.isObject(el.data('retailer-obj')));
	      (0, _selectorHelpers.handleDisplayFor)(el.find('.edit-retailer-text'), _underscore2.default.isObject(el.data('retailer-obj')));
	    }
	  }
	
	  (0, _jumpToWizardLogic.handleQueryParamTraversalToWizardTab)(quickWizard);
	
	  function addValidators() {
	    $.validator.addClassRules("ret-phone-number-jqv", { validPhoneDigits: 7 });
	  }
	
	  // phone number should haev minimum 7 digits
	  $.validator.addMethod("validPhoneDigits", function (value, element, params) {
	    if (value.length == 0) return true;
	    var str = value.replace(/[_-]/g, ''); // replace the mask hyphen and underscore with blank as they are counted in length
	    if (str.length < params) {
	      return false;
	    } else {
	      return true;
	    }
	  }, "Please enter {0} numeric values.");
	
	  $('input[type="checkbox"]').click(function () {
	    errorAlertSupplyChain();
	    errorAlertShippingService();
	  });
	
	  function errorAlertSupplyChain() {
	    var errorAalertMsg = $('body').find('.error-alert-msg');
	    if ($('.checkboxTest input:checkbox:checked').length > 0) {
	      errorAalertMsg.hide();
	    } else {
	      errorAalertMsg.show();
	    }
	  }
	
	  function errorAlertShippingService() {
	    var errorAalertMsg = $('body').find('.error-alert-msgg');
	    if ($('.checkboxTes input:checkbox:checked').length > 0) {
	      errorAalertMsg.hide();
	    } else {
	      errorAalertMsg.show();
	    }
	  }
	
	  errorAlertSupplyChain();
	  errorAlertShippingService();
	}

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	(0, _run2.default)(".retailer-detail-outer-section", function () {
		var el = $(".retailer-detail-outer-section");
		var changeStatusUrl = el.data("change-status-url");
		var changeSubMerchantStatusUrl = el.data("change-child-status-url");
		var pageReloadUrl = el.data("retailer-detail-page-reload-url");
		var resubmitMerchantUrl = el.data("generate-retailer-ean-number-url");
	
		var els = {};
		var elementsMap = {
			activateBtn: ".retailer-activate-btn",
			editBtn: ".retailer-edit-btn",
			deactivateBtn: ".retailer-deactivate-btn",
			generateEanNumberDiv: ".generate-ean-number",
			generateEanBtn: ".generate-ean-btn",
			rtlEanNumber: ".rtl-ean-number",
			activateChildBtn: ".activate-merchant-btn",
			deactivateChildBtn: ".deactivate-merchant-btn"
		};
	
		setElements();
		onLoad();
	
		function setElements() {
			(0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
		}
	
		function onLoad() {
			checkEanNumber();
		}
	
		function checkEanNumber() {
			if (els.rtlEanNumber.text().length > 1) {
				els.generateEanNumberDiv.hide();
			} else {
				els.generateEanNumberDiv.show();
			}
		}
		var activateRetailerModal = new _SubmitModalFlow2.default({
			confirmModalTitle: 'Activate Retailer',
			confirmModalBody: '<div class="q-pad-all-xl">\n\t\t\t\t              <p>By reactivating this retailer, they will resume their previous privileges with the service.</p>\n                      <p>Do you wish to continue?</p>\n\t\t\t\t\t\t  </div>',
			confirmModalBtnText: 'Activate Rule',
			onConfirmClick: function onConfirmClick() {
				activateRetailerModal.showLoadingModal();
				handleActivateDeactivate({ url: changeStatusUrl, input: "A", success: activeSuccess, error: activeError });
			}
		});
	
		activateRetailerModal.init();
	
		var deactiveRetailerModal = new _SubmitModalFlow2.default({
			confirmModalTitle: 'Deactive Retailer',
			confirmModalBody: '<div class="q-pad-all-xl">\n\t\t\t\t\t\t\t<p>By deactivating this retailer, they will no longer have privileges to use this service.</p>\n              <p>Do you wish to continue?</p>\n\t\t\t\t\t\t  </div>',
			confirmModalBtnText: 'Deactive Retailer',
			onConfirmClick: function onConfirmClick() {
				deactiveRetailerModal.showLoadingModal();
				handleActivateDeactivate({ url: changeStatusUrl, input: "I", success: deactiveSuccess, error: deactiveError });
			}
		});
	
		deactiveRetailerModal.init();
	
		els.activateBtn.on("click", function (e) {
			e.preventDefault();
			activateRetailerModal.showConfirmModal();
		});
	
		els.deactivateBtn.on("click", function (e) {
			e.preventDefault();
			deactiveRetailerModal.showConfirmModal();
		});
	
		function handleActivateDeactivate(_ref) {
			var url = _ref.url,
			    input = _ref.input,
			    success = _ref.success,
			    error = _ref.error;
	
			$.ajax({
				url: url,
				data: { "status": input },
				dataType: "JSON",
				type: 'POST',
				success: success,
				error: error
			});
		}
	
		function activeSuccess(data) {
			if (data.response === "success") {
				EditChecker.setPageClean();
				var detailUrlFullURL = pageReloadUrl;
				activateRetailerModal.showSuccessModal();
				setTimeout(function () {
					location.href = detailUrlFullURL;
				}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			} else {
				activateRetailerModal.showFailureModal();
			}
		}
	
		function activeError() {
			activateRetailerModal.hideAllModals();
		}
	
		function deactiveSuccess(data) {
			if (data.response === "success") {
				EditChecker.setPageClean();
				var detailUrlFullURL = pageReloadUrl;
				deactiveRetailerModal.showSuccessModal();
				setTimeout(function () {
					location.href = detailUrlFullURL;
				}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			} else {
				deactiveRetailerModal.showFailureModal();
			}
		}
	
		function deactiveError() {
			deactiveRetailerModal.hideAllModals();
		}
	
		var deActivateSubRetailerModal = null;
		els.deactivateChildBtn.on("click", function (e) {
	
			e.preventDefault();
			var chrId = $(e.target).attr('data-chrId');
			deActivateSubRetailerModal = new _SubmitModalFlow2.default({
				confirmModalTitle: 'Deactivate Merchant',
				confirmModalBody: '<div class="q-pad-all-xl">\n\t\t\t\t\t\t\t<p>This will remove the affiliated merchant. The merchant will no longer able to select this affiliated merchant for returns. Please confirm you wish to do this.</p>\n\t\t\t\t\t\t  </div>',
				confirmModalBtnText: 'Confirm',
				onConfirmClick: function onConfirmClick() {
					deActivateSubRetailerModal.showLoadingModal();
					handleChildActivateDeactivate({ url: changeSubMerchantStatusUrl, input: chrId, success: deactiveChildSuccess, error: deactiveChildError });
				}
			});
			deActivateSubRetailerModal.init();
	
			deActivateSubRetailerModal.showConfirmModal();
		});
		var activateSubRetailerModal = null;
		els.activateChildBtn.on("click", function (e) {
	
			e.preventDefault();
			var chrId = $(e.target).attr('data-chrId');
			activateSubRetailerModal = new _SubmitModalFlow2.default({
				confirmModalTitle: 'Activate Merchant',
				confirmModalBody: '<div class="q-pad-all-xl">\n\t\t\t\t\t              <p>This will show this affiliated merchant for this merchant to select for returns.Please confirm you wish to do this.</p>\n\t\t\t\t\t\t\t  </div>',
				confirmModalBtnText: 'Confirm',
				onConfirmClick: function onConfirmClick() {
					activateSubRetailerModal.showLoadingModal();
					handleChildActivateDeactivate({ url: changeSubMerchantStatusUrl, input: chrId, success: activeChildSuccess, error: activeChildError });
				}
			});
			activateSubRetailerModal.init();
	
			activateSubRetailerModal.showConfirmModal();
		});
	
		function handleChildActivateDeactivate(_ref2) {
			var url = _ref2.url,
			    input = _ref2.input,
			    success = _ref2.success,
			    error = _ref2.error;
	
			$.ajax({
				url: url,
				data: { "chrId": input },
				dataType: "JSON",
				type: 'POST',
				success: success,
				error: error
			});
		}
	
		function activeChildSuccess(data) {
			if (data.response === "success") {
				EditChecker.setPageClean();
				var detailUrlFullURL = pageReloadUrl;
				activateSubRetailerModal.showSuccessModal();
				setTimeout(function () {
					location.href = detailUrlFullURL;
				}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			} else {
				activateSubRetailerModal.showFailureModal();
			}
		}
	
		function activeChildError() {
			activateSubRetailerModal.hideAllModals();
		}
	
		function deactiveChildSuccess(data) {
			if (data.response === "success") {
				EditChecker.setPageClean();
				var detailUrlFullURL = pageReloadUrl;
				deActivateSubRetailerModal.showSuccessModal();
				setTimeout(function () {
					location.href = detailUrlFullURL;
				}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			} else {
				deActivateSubRetailerModal.showFailureModal();
			}
		}
	
		function deactiveChildError() {
			deActivateSubRetailerModal.hideAllModals();
		}
	
		els.generateEanBtn.on('click', function () {
			$.ajax({
				url: resubmitMerchantUrl,
				type: 'POST',
				dataType: 'json',
				data: [],
				success: function success(resp) {
					if (resp.data && resp.data != null && resp.data != 'null') {
						els.rtlEanNumber.text(resp.data);
						els.generateEanNumberDiv.hide();
					} else {
						els.generateEanNumberDiv.show();
					}
				},
				error: function error(xhr, status, _error) {
					els.generateEanNumberDiv.show();
				}
			});
		});
	});

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(676);
	
	__webpack_require__(677);

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(680);
	
	__webpack_require__(1093);
	
	__webpack_require__(274);

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _submitHelpers = __webpack_require__(115);
	
	var _QuickFileUploader = __webpack_require__(85);
	
	var _constants = __webpack_require__(10);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	// const targetSelector = "#p_p_id_rmsui_WAR_rmsuiportlet_";
	var targetSelector = ".merchant-config-outer";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachPages(outerEl);
	});
	
	function attachPages(outerEl) {
	
	  var fileUploaderEl = outerEl.find(".logo-uploader");
	  var colorPickerLink = outerEl.find(".color-picker-link");
	  var swatchInput = outerEl.find("#sc-swatch-input");
	  var swatchEl = outerEl.find(".mc-swatch");
	  var bannerEl = outerEl.find(".mc-banner-preview");
	  var retailerBannerConfigSection = outerEl.find('.retailer-banner-config');
	  var retailerBannerPreview = outerEl.find('.mc-banner-example');
	  var scRmaService = outerEl.find('.sc-rma-service');
	  //HB-11879 START
	
	  var sgrPrefixPredefined = outerEl.find('.sgr-prefix-predefined');
	  var sgrPrefix = outerEl.find('#sgr-prefix');
	  var customRmaPrefixField = outerEl.find('.custom-rma-prefix');
	  var customRmaPredefinedField = outerEl.find('.predefined-rma-prefix');
	  var customBtn = $(".custom-btn");
	  var predefinedBtn = $(".predefined-btn");
	
	  var customBtnValueCheck = $("#custom-btn-value-check");
	  var predefinedBtnValueCheck = $("#predefined-btn-value-check");
	  //deactivateBtns();
	  //HB-11879 END
	  var scShippingService = outerEl.find('.sc-shipping-service');
	  var serviceConfigSaveBtn = outerEl.find(".save-service-config-edits");
	  var serviceConfiguration = outerEl.data("service-configuration-uri");
	  var systemGeneratedRmaConfig = outerEl.find('.if-system-generated-rma');
	  var retailerSuppliedRmaConfig = outerEl.find('.if-retailer-supplied-rma');
	  var startNumberLength = outerEl.find("#sgr-number-length");
	
	  var currentEntityNumber = outerEl.data('current-rma-number');
	  var generateAuthTokenBtn = outerEl.find("#get-ext-auth-token");
	  var generateHCAuthTokenBtn = outerEl.find("#get-ext-auth-token-hc");
	  var accessTokenVal = outerEl.find("#accessToken");
	  var loadAuthTokenBtn = outerEl.find("#load-auth-token");
	  var regenerateAuthTokenBtn = outerEl.find("#reget-ext-auth-token");
	  var regenerateHCAuthTokenBtn = outerEl.find("#reget-ext-auth-token-hc");
	  var copyTokenBtn = outerEl.find("#copy-auth-token");
	  var authFailedMsg = outerEl.find("#auth-failed");
	  var addAnthChannelBtn = outerEl.find("#add-another-channel");
	  var duplicateTokenAuthDiv = outerEl.find(".channel-token-auth-div");
	  var channelEmptyMsg = outerEl.find("#channel-empty");
	  var returnChannelName = outerEl.find("#returnChannelName");
	  var accessTokenDisplayDiv = outerEl.find(".acess-token-display-div");
	  var rmsAuthTokenAvl = outerEl.find('#rms-auth-token-avl');
	  var hcAuthTokenAvl = outerEl.find('#hc-auth-token-avl');
	
	  var retailerReturnsConfiguration = outerEl.data("retailer-returns-configuration");
	
	  var orderNumberVisible = outerEl.find(".prp-order-number-visible");
	  var orderNumberMandatory = outerEl.find(".prp-order-number-mandatory");
	  var orderNumberMandatoryDiv = outerEl.find(".prp-order-number-mandatory-div");
	
	  //E-67370 
	  var rmaLiteReturnReasonField = outerEl.find(".pgp-show-rma-lite-return-reason");
	  var rmaLiteAllowMultipleLabels = outerEl.find("#pgp-allow-multiple-labels");
	  var rmaLiteMaxNumberOfLabels = outerEl.find("#pgp-max-labels-allowed");
	
	  var maxLabelsAllowed = outerEl.find(".max-labels-alwd");
	
	  //showFieldSwitchery
	  var referenceShowFieldSwitchery = outerEl.find(".reference-show-field-switchery");
	  var departmentShowFieldSwitchery = outerEl.find(".department-show-field-switchery");
	  var poShowFieldSwitchery = outerEl.find(".po-show-field-switchery");
	  var invoiceShowFieldSwitchery = outerEl.find(".invoice-show-field-switchery");
	
	  //requiredFieldSwitchery
	  var referenceRequiredFieldSwitchery = outerEl.find(".reference-required-field-switchery");
	  var departmentRequiredFieldSwitchery = outerEl.find(".department-required-field-switchery");
	  var poRequiredFieldSwitchery = outerEl.find(".po-required-field-switchery");
	  var invoiceRequiredFieldSwitchery = outerEl.find(".invoice-required-field-switchery");
	
	  //toggleTargets  
	  var referenceConfigToggleTarget = outerEl.find(".reference-config-toggle-target");
	  var departmentConfigToggleTarget = outerEl.find(".department-config-toggle-target");
	  var poConfigToggleTarget = outerEl.find(".po-config-toggle-target");
	  var invoiceConfigToggleTarget = outerEl.find(".invoice-config-toggle-target");
	  var referenceCustomeFieldTarget = outerEl.find(".reference-custom-field-target");
	  var departmentCustomeFieldTarget = outerEl.find(".department-custom-field-target");
	  var poCustomeFieldTarget = outerEl.find(".po-custom-field-target");
	  var invoiceCustomeFieldTarget = outerEl.find(".invoice-custom-field-target");
	
	  //customFieldSwitchery
	  var referenceCustomFieldSwitchery = outerEl.find(".reference-custom-label-switchery");
	  var departmentCustomFieldSwitchery = outerEl.find(".department-custom-label-switchery");
	  var poCustomFieldSwitchery = outerEl.find(".po-custom-label-switchery");
	  var invoiceCustomFieldSwitchery = outerEl.find(".invoice-custom-label-switchery");
	
	  //inputfields
	  var referenceCustomLabelField = outerEl.find(".reference-custom-field-input");
	  var departmentCustomLabelField = outerEl.find(".department-custom-field-input");
	  var poCustomLabelField = outerEl.find(".po-custom-field-input");
	  var invoiceCustomLabelField = outerEl.find(".invoice-custom-field-input");
	
	  var defaultItemAllReturns = outerEl.find(".pgp-default-item-all-returns");
	  var rmaLiteReferenceDiv = outerEl.find(".pgp-show-rma-lite-reference-div");
	  var rmaLiteReference = outerEl.find(".pgp-show-rma-lite-reference");
	  var rmaLiteReferenceFieldRequired = outerEl.find(".pgp-rma-lite-reference-required");
	  var customizeReferenceLabel = outerEl.find(".pgp-customize-reference-label");
	  var customReferenceLabel = $("#pgp-custom-reference-label");
	  var rmaLiteReferenceFieldValidation = outerEl.find(".pgp-reference-field-validation");
	  var rmaLiteEndPointUrl = $("#pgp-end-point-url");
	  var rmaLiteReferenceKey = $("#pgp-name-or-key");
	  var rmaLiteReferencePassword = $("#pgp-password");
	
	  var hwmrefGroup_1 = outerEl.find(".hwm-ref-group-1");
	  var hwmrefGroup_2 = outerEl.find(".hwm-ref-group-2");
	
	  var rscLabelSetting = outerEl.find('.rsc-label-setting');
	
	  //HB-11513
	  var warehouseLevelShipmentVisible = outerEl.find(".prp-wl-shipment-visible");
	  var warehouseLevelReturnReasonVisible = outerEl.find(".prp-wl-return-reason");
	  var prepaidCollectVisible = outerEl.find(".prp-prepaid-collect");
	  var billOfLadenVisible = outerEl.find(".prp-bol-entry");
	  var rmaNotesVisible = outerEl.find(".prp-rma-notes");
	  var warehouseLevelShipmentDiv = outerEl.find(".prp-warehouse-level-shipment-div");
	  //HB-11513
	
	  var sendRmaCreationEmailToggler = outerEl.find(".cen-customer-email-notification");
	  var sendRmaCreationEmailConfig = outerEl.data("rma-creation-email-config");
	
	  var isRmsOnly = outerEl.data("retailer-is-rms-only");
	  var defaultItemAllReturnsDiv = outerEl.find(".pgp-default-item-all-returns-div");
	
	  var returnReasonVisible = outerEl.find(".prp-return-reason");
	  var finalSaleFlagVisible = outerEl.find(".prp-final-sale");
	  var productWeightVisible = outerEl.find(".prp-product-weight");
	  var notesVisible = outerEl.find(".prp-notes");
	
	  //9043 Shipping and Processing fields integration
	  var complimentaryReturnShippingVisible = outerEl.find(".sap-complimentary-shipping");
	  var overrideShipAddressVisible = outerEl.find(".sap-override-ship-address");
	  var overrideShipServiceVisible = outerEl.find(".sap-override-default-ship-address");
	
	  //E-82367 Priority Alert Shipping 
	  var priorityAlertShippments = outerEl.find(".sap-priority-alert-shipments");
	  // Saturday Delivery
	  var expressShipmentsforSaturday = outerEl.find(".sap-express-shipments-saturday");
	  var referenceNumberVisible = outerEl.find(".sap-add-ref-number");
	  var departmentNumberVisible = outerEl.find(".sap-add-dept-number");
	  var invoiceNumberVisible = outerEl.find(".sap-add-invoice-number");
	  var poNumberVisible = outerEl.find(".sap-add-po-number");
	  var declaredValueVisible = outerEl.find(".sap-add-declared-value");
	  var specialCreditProcessingVisible = outerEl.find(".sap-special-credit-processing");
	  var display4x4 = outerEl.find(".sap-display-4x4");
	  var showPackingSlip = outerEl.find(".sap-show-packing-slip");
	  var doNotShowForDefaultItemMerchants = outerEl.find(".do-not-show-for-default-item-merchants");
	  var prefedinedRmaPrefixValues = outerEl.data("retailer-predefined-prefix-values");
	
	  var customPredefinedBtnGrpEl = outerEl.find('.custom-predefined-toggler');
	  var maxLabelsAllowedEl = outerEl.find('.pgp-max-labels-allowed');
	
	  //E-89401 start
	  var useRtWindowForRmas = outerEl.find(".pgp-use-rt-window-for-rmas");
	  var rtWindowUsageConfigurationsDiv = outerEl.find(".pgp-return-technology-window-usage-configurations-div");
	  var rtWindowReturnReasonField = outerEl.find(".pgp-rt-window-show-return-reason");
	  var rtWindowAllowPreprintedLabelsField = outerEl.find(".pgp-rt-window-allow-preprinted-labels");
	  var rtWindowSerialNumberCaptureField = outerEl.find(".pgp-rt-window-serial-number-capture");
	  var rtWindowSerialNumberValidationField = outerEl.find(".pgp-rt-window-serial-number-validation");
	  var rtWindowAllowMultipleLabels = outerEl.find("#pgp-rt-window-allow-multiple-labels");
	  var rtWindowMaxLabelsAllowed = outerEl.find(".rt-window-max-labels-alwd");
	  var rtWindowMaxNumberOfLabels = outerEl.find("#pgp-rt-window-max-labels-allowed");
	  var rtWindowPreferencesDiv = outerEl.find(".pgp-show-rt-window-preferences-div");
	  //E-89401 end
	  var file = void 0;
	  onLoad();
	
	  function onLoad() {
	    if (rmsAuthTokenAvl.length > 0 || hcAuthTokenAvl.length > 0) {
	      regenerateAuthTokenBtn.show();
	      generateAuthTokenBtn.hide();
	      regenerateHCAuthTokenBtn.show();
	      generateHCAuthTokenBtn.hide();
	    } else {
	      regenerateAuthTokenBtn.hide();
	      generateAuthTokenBtn.show();
	      regenerateHCAuthTokenBtn.hide();
	      generateHCAuthTokenBtn.show();
	    }
	    copyTokenBtn.hide();
	    authFailedMsg.hide();
	    channelEmptyMsg.hide();
	    loadAuthTokenBtn.hide();
	    accessTokenDisplayDiv.hide();
	    maxLabelsAllowed.hide();
	    rtWindowMaxLabelsAllowed.hide(); //E-89401
	
	
	    referenceConfigToggleTarget.hide();
	    referenceCustomeFieldTarget.hide();
	    departmentConfigToggleTarget.hide();
	    departmentCustomeFieldTarget.hide();
	    poCustomeFieldTarget.hide();
	    poConfigToggleTarget.hide();
	    invoiceConfigToggleTarget.hide();
	    invoiceCustomeFieldTarget.hide();
	
	    hideAndShowBasedOnSubscription();
	    loadOrderNumberConfiguration();
	    //HB-11513
	    loadWarehouseLevelRmaConfiguration();
	
	    var isSwitcheryInstantiated = false;
	
	    if (isRmsOnly) {
	      loadDefaultItemForReturnsConfig();
	      isSwitcheryInstantiated = true;
	    }
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(referenceShowFieldSwitchery);
	    (0, _instantiateSwitchery.instantiateSwitchery)(departmentShowFieldSwitchery);
	    (0, _instantiateSwitchery.instantiateSwitchery)(poShowFieldSwitchery);
	    (0, _instantiateSwitchery.instantiateSwitchery)(invoiceShowFieldSwitchery);
	
	    if (retailerReturnsConfiguration.isFCR == 'On') {
	      // for referenceShow
	      if (retailerReturnsConfiguration.referenceShowField) {
	        referenceShowFieldSwitchery.next(".switchery-default").trigger("click");
	        (0, _instantiateSwitchery.instantiateSwitchery)(referenceRequiredFieldSwitchery);
	        (0, _instantiateSwitchery.instantiateSwitchery)(referenceCustomFieldSwitchery);
	        referenceConfigToggleTarget.show();
	        (0, _instantiateSwitchery.disableSwitchery)(departmentShowFieldSwitchery);
	        (0, _instantiateSwitchery.disableSwitchery)(poShowFieldSwitchery);
	        (0, _instantiateSwitchery.disableSwitchery)(invoiceShowFieldSwitchery);
	      }
	
	      // for departmentShow
	      if (retailerReturnsConfiguration.departmentShowField) {
	        departmentShowFieldSwitchery.next(".switchery-default").trigger("click");
	        (0, _instantiateSwitchery.instantiateSwitchery)(departmentRequiredFieldSwitchery);
	        (0, _instantiateSwitchery.instantiateSwitchery)(departmentCustomFieldSwitchery);
	        departmentConfigToggleTarget.show();
	        (0, _instantiateSwitchery.disableSwitchery)(referenceShowFieldSwitchery);
	        (0, _instantiateSwitchery.disableSwitchery)(poShowFieldSwitchery);
	        (0, _instantiateSwitchery.disableSwitchery)(invoiceShowFieldSwitchery);
	      }
	
	      // for po show
	      if (retailerReturnsConfiguration.poShowField) {
	        poShowFieldSwitchery.next(".switchery-default").trigger("click");
	        (0, _instantiateSwitchery.instantiateSwitchery)(poRequiredFieldSwitchery);
	        (0, _instantiateSwitchery.instantiateSwitchery)(poCustomFieldSwitchery);
	        poConfigToggleTarget.show();
	        (0, _instantiateSwitchery.disableSwitchery)(referenceShowFieldSwitchery);
	        (0, _instantiateSwitchery.disableSwitchery)(departmentShowFieldSwitchery);
	        (0, _instantiateSwitchery.disableSwitchery)(invoiceShowFieldSwitchery);
	      }
	
	      // for Invoice show
	      if (retailerReturnsConfiguration.invoiceShowField) {
	        invoiceShowFieldSwitchery.next(".switchery-default").trigger("click");
	        (0, _instantiateSwitchery.instantiateSwitchery)(invoiceRequiredFieldSwitchery);
	        (0, _instantiateSwitchery.instantiateSwitchery)(invoiceCustomFieldSwitchery);
	        invoiceConfigToggleTarget.show();
	        (0, _instantiateSwitchery.disableSwitchery)(referenceShowFieldSwitchery);
	        (0, _instantiateSwitchery.disableSwitchery)(departmentShowFieldSwitchery);
	        (0, _instantiateSwitchery.disableSwitchery)(poShowFieldSwitchery);
	      }
	      // referencefield
	      referenceShowFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(referenceRequiredFieldSwitchery);
	          (0, _instantiateSwitchery.instantiateSwitchery)(referenceCustomFieldSwitchery);
	          referenceConfigToggleTarget.show();
	          (0, _instantiateSwitchery.disableSwitchery)(departmentShowFieldSwitchery);
	          (0, _instantiateSwitchery.disableSwitchery)(poShowFieldSwitchery);
	          (0, _instantiateSwitchery.disableSwitchery)(invoiceShowFieldSwitchery);
	        } else {
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(referenceRequiredFieldSwitchery, false);
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(referenceCustomFieldSwitchery, false);
	          referenceCustomLabelField.val("");
	          referenceCustomeFieldTarget.hide();
	          referenceConfigToggleTarget.hide();
	          (0, _instantiateSwitchery.enableSwitchery)(departmentShowFieldSwitchery);
	          (0, _instantiateSwitchery.enableSwitchery)(poShowFieldSwitchery);
	          (0, _instantiateSwitchery.enableSwitchery)(invoiceShowFieldSwitchery);
	        }
	      });
	
	      // departmentShowField
	      departmentShowFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(departmentRequiredFieldSwitchery);
	          (0, _instantiateSwitchery.instantiateSwitchery)(departmentCustomFieldSwitchery);
	          departmentConfigToggleTarget.show();
	          (0, _instantiateSwitchery.disableSwitchery)(referenceShowFieldSwitchery);
	          (0, _instantiateSwitchery.disableSwitchery)(poShowFieldSwitchery);
	          (0, _instantiateSwitchery.disableSwitchery)(invoiceShowFieldSwitchery);
	        } else {
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(departmentRequiredFieldSwitchery, false);
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(departmentCustomFieldSwitchery, false);
	          departmentCustomLabelField.val("");
	          departmentCustomeFieldTarget.hide();
	          departmentConfigToggleTarget.hide();
	          (0, _instantiateSwitchery.enableSwitchery)(referenceShowFieldSwitchery);
	          (0, _instantiateSwitchery.enableSwitchery)(poShowFieldSwitchery);
	          (0, _instantiateSwitchery.enableSwitchery)(invoiceShowFieldSwitchery);
	        }
	      });
	      // po show field
	      poShowFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(poRequiredFieldSwitchery);
	          (0, _instantiateSwitchery.instantiateSwitchery)(poCustomFieldSwitchery);
	          poConfigToggleTarget.show();
	          (0, _instantiateSwitchery.disableSwitchery)(referenceShowFieldSwitchery);
	          (0, _instantiateSwitchery.disableSwitchery)(departmentShowFieldSwitchery);
	          (0, _instantiateSwitchery.disableSwitchery)(invoiceShowFieldSwitchery);
	        } else {
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(poRequiredFieldSwitchery, false);
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(poCustomFieldSwitchery, false);
	          poCustomLabelField.val("");
	          poCustomeFieldTarget.hide();
	          poConfigToggleTarget.hide();
	          (0, _instantiateSwitchery.enableSwitchery)(referenceShowFieldSwitchery);
	          (0, _instantiateSwitchery.enableSwitchery)(departmentShowFieldSwitchery);
	          (0, _instantiateSwitchery.enableSwitchery)(invoiceShowFieldSwitchery);
	        }
	      });
	
	      // invoice show field
	      invoiceShowFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(invoiceRequiredFieldSwitchery);
	          (0, _instantiateSwitchery.instantiateSwitchery)(invoiceCustomFieldSwitchery);
	          invoiceConfigToggleTarget.show();
	          (0, _instantiateSwitchery.disableSwitchery)(referenceShowFieldSwitchery);
	          (0, _instantiateSwitchery.disableSwitchery)(departmentShowFieldSwitchery);
	          (0, _instantiateSwitchery.disableSwitchery)(poShowFieldSwitchery);
	        } else {
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(invoiceRequiredFieldSwitchery, false);
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(invoiceCustomFieldSwitchery, false);
	          invoiceCustomLabelField.val("");
	          invoiceCustomeFieldTarget.hide();
	          invoiceConfigToggleTarget.hide();
	          (0, _instantiateSwitchery.enableSwitchery)(referenceShowFieldSwitchery);
	          (0, _instantiateSwitchery.enableSwitchery)(departmentShowFieldSwitchery);
	          (0, _instantiateSwitchery.enableSwitchery)(poShowFieldSwitchery);
	        }
	      });
	      // referenceCustomLabel
	      referenceCustomFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          referenceCustomeFieldTarget.show();
	        } else {
	          referenceCustomLabelField.val("");
	          referenceCustomeFieldTarget.hide();
	        }
	      });
	      // departmentCustomLabel
	      departmentCustomFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          departmentCustomeFieldTarget.show();
	        } else {
	          departmentCustomLabelField.val("");
	          departmentCustomeFieldTarget.hide();
	        }
	      });
	      // poCustomLabel
	      poCustomFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          poCustomeFieldTarget.show();
	        } else {
	          poCustomLabelField.val("");
	          poCustomeFieldTarget.hide();
	        }
	      });
	      // invoiceCustomLabel
	      invoiceCustomFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          invoiceCustomeFieldTarget.show();
	        } else {
	          invoiceCustomLabelField.val("");
	          invoiceCustomeFieldTarget.hide();
	        }
	      });
	    } else {
	
	      // for referenceShow
	      if (retailerReturnsConfiguration.referenceShowField) {
	        referenceShowFieldSwitchery.next(".switchery-default").trigger("click");
	        (0, _instantiateSwitchery.instantiateSwitchery)(referenceRequiredFieldSwitchery);
	        (0, _instantiateSwitchery.instantiateSwitchery)(referenceCustomFieldSwitchery);
	        referenceConfigToggleTarget.show();
	      }
	      // for departmentShow
	      if (retailerReturnsConfiguration.departmentShowField) {
	        departmentShowFieldSwitchery.next(".switchery-default").trigger("click");
	        (0, _instantiateSwitchery.instantiateSwitchery)(departmentRequiredFieldSwitchery);
	        (0, _instantiateSwitchery.instantiateSwitchery)(departmentCustomFieldSwitchery);
	        departmentConfigToggleTarget.show();
	      }
	
	      // for po show
	      if (retailerReturnsConfiguration.poShowField) {
	        poShowFieldSwitchery.next(".switchery-default").trigger("click");
	        (0, _instantiateSwitchery.instantiateSwitchery)(poRequiredFieldSwitchery);
	        (0, _instantiateSwitchery.instantiateSwitchery)(poCustomFieldSwitchery);
	        poConfigToggleTarget.show();
	      }
	
	      // for Invoice show
	      if (retailerReturnsConfiguration.invoiceShowField) {
	        invoiceShowFieldSwitchery.next(".switchery-default").trigger("click");
	        (0, _instantiateSwitchery.instantiateSwitchery)(invoiceRequiredFieldSwitchery);
	        (0, _instantiateSwitchery.instantiateSwitchery)(invoiceCustomFieldSwitchery);
	        invoiceConfigToggleTarget.show();
	      }
	
	      // referencefield
	      referenceShowFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(referenceRequiredFieldSwitchery);
	          (0, _instantiateSwitchery.instantiateSwitchery)(referenceCustomFieldSwitchery);
	          referenceConfigToggleTarget.show();
	        } else {
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(referenceRequiredFieldSwitchery, false);
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(referenceCustomFieldSwitchery, false);
	          referenceCustomLabelField.val("");
	          referenceCustomeFieldTarget.hide();
	          referenceConfigToggleTarget.hide();
	        }
	      });
	
	      // departmentShowField
	      departmentShowFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(departmentRequiredFieldSwitchery);
	          (0, _instantiateSwitchery.instantiateSwitchery)(departmentCustomFieldSwitchery);
	          departmentConfigToggleTarget.show();
	        } else {
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(departmentRequiredFieldSwitchery, false);
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(departmentCustomFieldSwitchery, false);
	          departmentCustomLabelField.val("");
	          departmentCustomeFieldTarget.hide();
	          departmentConfigToggleTarget.hide();
	        }
	      });
	
	      // po show field
	      poShowFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(poRequiredFieldSwitchery);
	          (0, _instantiateSwitchery.instantiateSwitchery)(poCustomFieldSwitchery);
	          poConfigToggleTarget.show();
	        } else {
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(poRequiredFieldSwitchery, false);
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(poCustomFieldSwitchery, false);
	          poCustomLabelField.val("");
	          poCustomeFieldTarget.hide();
	          poConfigToggleTarget.hide();
	        }
	      });
	
	      // invoice show field
	      invoiceShowFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(invoiceRequiredFieldSwitchery);
	          (0, _instantiateSwitchery.instantiateSwitchery)(invoiceCustomFieldSwitchery);
	          invoiceConfigToggleTarget.show();
	        } else {
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(invoiceRequiredFieldSwitchery, false);
	          (0, _instantiateSwitchery.setSwitcheryWithoutChange)(invoiceCustomFieldSwitchery, false);
	          invoiceCustomLabelField.val("");
	          invoiceCustomeFieldTarget.hide();
	          invoiceConfigToggleTarget.hide();
	        }
	      });
	
	      // referenceCustomLabel
	      referenceCustomFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          referenceCustomeFieldTarget.show();
	        } else {
	          referenceCustomLabelField.val("");
	          referenceCustomeFieldTarget.hide();
	        }
	      });
	      // departmentCustomLabel
	      departmentCustomFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          departmentCustomeFieldTarget.show();
	        } else {
	          departmentCustomLabelField.val("");
	          departmentCustomeFieldTarget.hide();
	        }
	      });
	      // poCustomLabel
	      poCustomFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          poCustomeFieldTarget.show();
	        } else {
	          poCustomLabelField.val("");
	          poCustomeFieldTarget.hide();
	        }
	      });
	      // invoiceCustomLabel
	      invoiceCustomFieldSwitchery.on('change', function () {
	        if ($(this).is(":checked")) {
	          invoiceCustomeFieldTarget.show();
	        } else {
	          invoiceCustomLabelField.val("");
	          invoiceCustomeFieldTarget.hide();
	        }
	      });
	    }
	    if (retailerReturnsConfiguration.referenceRequiredField) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(referenceRequiredFieldSwitchery);
	      (0, _instantiateSwitchery.setSwitchery)(referenceRequiredFieldSwitchery, retailerReturnsConfiguration.referenceRequiredField);
	    }
	    if (retailerReturnsConfiguration.departmentRequiredField) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(departmentRequiredFieldSwitchery);
	      (0, _instantiateSwitchery.setSwitchery)(departmentRequiredFieldSwitchery, retailerReturnsConfiguration.departmentRequiredField);
	    }
	    if (retailerReturnsConfiguration.poRequiredField) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(poRequiredFieldSwitchery);
	      (0, _instantiateSwitchery.setSwitchery)(poRequiredFieldSwitchery, retailerReturnsConfiguration.poRequiredField);
	    }
	    if (retailerReturnsConfiguration.invoiceRequiredField) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(invoiceRequiredFieldSwitchery);
	      (0, _instantiateSwitchery.setSwitchery)(invoiceRequiredFieldSwitchery, retailerReturnsConfiguration.invoiceRequiredField);
	    }
	    //for referenceCustom
	    if (retailerReturnsConfiguration.referenceCustomLabel) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(referenceCustomFieldSwitchery);
	      referenceCustomFieldSwitchery.next(".switchery-default").trigger("click");
	      referenceCustomeFieldTarget.show();
	    }
	    //for departmentCustom
	    if (retailerReturnsConfiguration.departmentCustomLabel) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(departmentCustomFieldSwitchery);
	      departmentCustomFieldSwitchery.next(".switchery-default").trigger("click");
	      departmentCustomeFieldTarget.show();
	    }
	    //for pocustom
	    if (retailerReturnsConfiguration.poCustomLabel) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(poCustomFieldSwitchery);
	      poCustomFieldSwitchery.next(".switchery-default").trigger("click");
	      poCustomeFieldTarget.show();
	    }
	    //for invoicecustom
	    if (retailerReturnsConfiguration.invoiceCustomLabel) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(invoiceCustomFieldSwitchery);
	      invoiceCustomFieldSwitchery.next(".switchery-default").trigger("click");
	      invoiceCustomeFieldTarget.show();
	    }
	    //labels
	    referenceCustomLabelField.val(retailerReturnsConfiguration.referenceCustomLabelField);
	    departmentCustomLabelField.val(retailerReturnsConfiguration.departmentCustomLabelField);
	    poCustomLabelField.val(retailerReturnsConfiguration.poCustomLabelField);
	    invoiceCustomLabelField.val(retailerReturnsConfiguration.invoiceCustomLabelField);
	
	    // 10634 start
	    if (retailerReturnsConfiguration.defaultItemConfig) {
	      hideAndShowBasedOnDefaultItemConfig();
	      if (!isSwitcheryInstantiated) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(defaultItemAllReturns);
	        defaultItemAllReturns.next(".switchery-default").trigger("click");
	      }
	      //for return reason
	      if (retailerReturnsConfiguration.rmaLiteAllowMultipleLabels) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(rmaLiteAllowMultipleLabels);
	        rmaLiteAllowMultipleLabels.next(".switchery-default").trigger("click");
	        maxLabelsAllowed.show();
	      }
	
	      if (retailerReturnsConfiguration.showRmaLiteReturnReason) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(rmaLiteReturnReasonField);
	        (0, _instantiateSwitchery.setSwitchery)(rmaLiteReturnReasonField, retailerReturnsConfiguration.showRmaLiteReturnReason);
	      }
	
	      //department end       
	
	      rmaLiteReferenceDiv.show();
	
	      if (retailerReturnsConfiguration.showRmaLiteReferenceField) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(rmaLiteReference);
	        rmaLiteReference.next(".switchery-default").trigger("click");
	        hwmrefGroup_1.show();
	
	        if (retailerReturnsConfiguration.showCustomReferenceField) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(customizeReferenceLabel);
	          customizeReferenceLabel.next(".switchery-default").trigger("click");
	          hwmrefGroup_2.show();
	        }
	        if (retailerReturnsConfiguration.rmaLiteReferenceFieldRequired) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(rmaLiteReferenceFieldRequired);
	          rmaLiteReferenceFieldRequired.next(".switchery-default").trigger("click");
	        }
	
	        if (retailerReturnsConfiguration.rmaLiteReferenceFieldValidation) {
	          (0, _instantiateSwitchery.instantiateSwitchery)(rmaLiteReferenceFieldValidation);
	          rmaLiteReferenceFieldValidation.next(".switchery-default").trigger("click");
	          rmaLiteEndPointUrl.attr("required", "true");
	          rmaLiteReferenceKey.attr("required", "true");
	          rmaLiteReferencePassword.attr("required", "true");
	        }
	      }
	      customReferenceLabel.val(retailerReturnsConfiguration.rmaLiteReferenceLabel);
	      rmaLiteEndPointUrl.val(retailerReturnsConfiguration.rmaLiteReferenceEndPoint);
	      rmaLiteReferenceKey.val(retailerReturnsConfiguration.rmaLiteReferenceKey);
	      rmaLiteReferencePassword.val(retailerReturnsConfiguration.rmaLiteReferencePassword);
	
	      rmaLiteMaxNumberOfLabels.val(retailerReturnsConfiguration.rmaLiteNumberOfLabels);
	      //maxnumber
	
	    } else {
	      rmaLiteReferenceDiv.hide();
	    }
	
	    rmaLiteReferenceFieldValidation.on("change", function () {
	      if ($(this).prop("checked")) {
	        if (!rmaLiteReferenceFieldRequired.prop("checked")) {
	          rmaLiteReferenceFieldRequired.next(".switchery-default").trigger("click");
	        }
	      }
	    });
	
	    defaultItemAllReturns.on("change", function (e) {
	      var display = rmaLiteReferenceDiv.css("display") == "none" ? false : true;
	      rmaLiteReferenceDiv.toggle(!display);
	    });
	
	    rmaLiteReference.on("change", function (e) {
	      var display = hwmrefGroup_1.css("display") == "none" ? false : true;
	      hwmrefGroup_1.toggle(!display);
	    });
	
	    customizeReferenceLabel.on("change", function (e) {
	      var display = hwmrefGroup_2.css("display") == "none" ? false : true;
	      hwmrefGroup_2.toggle(!display);
	    });
	
	    //for maxLabels allowed - E-67370
	    rmaLiteAllowMultipleLabels.on('change', function () {
	      if ($(this).is(":checked")) {
	        maxLabelsAllowed.show();
	      } else {
	        maxLabelsAllowed.hide();
	      }
	    });
	
	    rmaLiteReferenceFieldValidation.on("change", function (e) {
	
	      var required = $(this).prop("checked");
	
	      if (required) {
	        rmaLiteEndPointUrl.attr("required", required);
	        rmaLiteReferenceKey.attr("required", required);
	        rmaLiteReferencePassword.attr("required", required);
	      } else {
	        rmaLiteEndPointUrl.removeAttr("required");
	        rmaLiteReferenceKey.removeAttr("required");
	        rmaLiteReferencePassword.removeAttr("required");
	      }
	    });
	    // 10634 end
	
	    //E-89401 start
	    rtWindowUsageConfigurationsDiv.show();
	    if (retailerReturnsConfiguration.useRtWindowForRmas) {
	      (0, _instantiateSwitchery.instantiateSwitchery)(useRtWindowForRmas);
	      (0, _instantiateSwitchery.setSwitchery)(useRtWindowForRmas, retailerReturnsConfiguration.useRtWindowForRmas);
	
	      if (retailerReturnsConfiguration.rtWindowShowReturnReason) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(rtWindowReturnReasonField);
	        (0, _instantiateSwitchery.setSwitchery)(rtWindowReturnReasonField, retailerReturnsConfiguration.rtWindowShowReturnReason);
	      }
	      if (retailerReturnsConfiguration.rtWindowAllowPreprintedLabels) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(rtWindowAllowPreprintedLabelsField);
	        (0, _instantiateSwitchery.setSwitchery)(rtWindowAllowPreprintedLabelsField, retailerReturnsConfiguration.rtWindowAllowPreprintedLabels);
	      }
	      if (retailerReturnsConfiguration.rtWindowSerialNumberCapture) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(rtWindowSerialNumberCaptureField);
	        (0, _instantiateSwitchery.setSwitchery)(rtWindowSerialNumberCaptureField, retailerReturnsConfiguration.rtWindowSerialNumberCapture);
	      }
	      if (retailerReturnsConfiguration.rtWindowSerialNumberValidation) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(rtWindowSerialNumberValidationField);
	        (0, _instantiateSwitchery.setSwitchery)(rtWindowSerialNumberValidationField, retailerReturnsConfiguration.rtWindowSerialNumberValidation);
	      }
	      if (retailerReturnsConfiguration.rtWindowAllowMultipleLabels) {
	        (0, _instantiateSwitchery.instantiateSwitchery)(rtWindowAllowMultipleLabels);
	        rtWindowAllowMultipleLabels.next(".switchery-default").trigger("click");
	        rtWindowMaxLabelsAllowed.show();
	      }
	
	      rtWindowMaxNumberOfLabels.val(retailerReturnsConfiguration.rtWindowNumberOfLabels);
	    } else {
	      rtWindowPreferencesDiv.hide();
	    }
	    useRtWindowForRmas.on('change', function (e) {
	      if ($(this).is(":checked")) {
	        rtWindowPreferencesDiv.show();
	      } else {
	        rtWindowPreferencesDiv.hide();
	      }
	    });
	
	    rtWindowAllowMultipleLabels.on('change', function () {
	      if ($(this).is(":checked")) {
	        rtWindowMaxLabelsAllowed.show();
	      } else {
	        rtWindowMaxLabelsAllowed.hide();
	      }
	    });
	    rtWindowSerialNumberCaptureField.on('change', function () {
	      if ($(this).is(":checked")) {
	        (0, _instantiateSwitchery.setSwitchery)(rtWindowSerialNumberValidationField, false);
	      }
	    });
	    rtWindowSerialNumberValidationField.on('change', function () {
	      if ($(this).is(":checked")) {
	        (0, _instantiateSwitchery.setSwitchery)(rtWindowSerialNumberCaptureField, false);
	      }
	    });
	    //E-89401 end
	
	    loadRmaCreationEmailConfig();
	    loadManualRmaProductCaptures();
	    loadShippingAndProcessingCaptures();
	    loadRmaPredefinedPrefixConfigs();
	
	    customRmaPrefixField.hide();
	    customRmaPredefinedField.hide();
	    initializeRmaPrefixBtns();
	  }
	
	  function initializeRmaPrefixBtns() {
	    var customPredefinedBtnGrp = new _QuickBtnGroup2.default(customPredefinedBtnGrpEl, {
	      distributeWidth: true,
	      onBtnClick: function onBtnClick(_ref) {
	        var btn = _ref.btn,
	            btnKey = _ref.btnKey;
	
	        if (btnKey == 'custom') {
	          customRmaPrefixField.show();
	          customRmaPredefinedField.hide();
	        } else {
	          customRmaPredefinedField.show();
	          customRmaPrefixField.hide();
	        }
	      }
	    });
	    customPredefinedBtnGrp.init();
	
	    setRmaPrefixData(customPredefinedBtnGrp);
	  }
	
	  function setRmaPrefixData(customPredefinedBtnGrp) {
	    if (retailerReturnsConfiguration.rmaPrefixType == 'predefined') {
	      customRmaPredefinedField.show();
	      customRmaPrefixField.hide();
	      customPredefinedBtnGrp.activateBtnViaKey('predefined');
	      $("#sgr-prefix-predefined option").each(function () {
	        if ($(this).html() == retailerReturnsConfiguration.rmaPrefix) {
	          $(this).attr("selected", "selected");
	          return;
	        }
	      });
	    } else {
	      customRmaPrefixField.show();
	      customRmaPredefinedField.hide();
	      customPredefinedBtnGrp.activateBtnViaKey('custom');
	      sgrPrefix.val(retailerReturnsConfiguration.rmaPrefix);
	    }
	  }
	
	  // Define color picker params
	  var colorPickerObj = {
	    input: swatchInput,
	    format: 'hex',
	    customClass: "q-color-picker"
	  };
	
	  // var for color picker, defined on page load
	  var colorPicker = void 0;
	
	  var previewImage = $('.banner-preview-image');
	  function init() {
	    colorPicker = colorPickerLink.colorpicker(colorPickerObj);
	    bindEvents();
	    enforceInputMasks();
	
	    file = (0, _QuickFileUploader.quickFileUploader)(fileUploaderEl, {
	      afterReadFile: function afterReadFile(e, result) {
	        previewImage.attr('src', e.target.result).addClass("banner-preview-image");
	        hideShowPreview();
	      },
	      afterRemoveFile: function afterRemoveFile() {
	        previewImage.attr('src', '');
	        hideShowPreview();
	      }
	    });
	    if (scRmaService.val() == "S") {
	      systemGeneratedRmaConfig.show();
	      retailerSuppliedRmaConfig.hide();
	    } else if (scRmaService.val() == "R") {
	      systemGeneratedRmaConfig.hide();
	      retailerSuppliedRmaConfig.show();
	    }
	  }
	  function enforceInputMasks() {
	    // NOTE: jasny bootstrap docs say that "w" is for alphanumaeric characters, but in application here, "*" somehow acts as alphanumeric
	    swatchInput.inputmask({
	      mask: "#******"
	    });
	  }
	
	  function bindEvents() {
	    colorPicker.on('changeColor', editSwatchInputVal);
	    swatchInput.on('change', editColorPickerVal);
	  }
	
	  function editSwatchInputVal(e) {
	    var hexValue = e.color.toString('hex');
	    swatchInput.val(hexValue);
	    hideShowPreview();
	
	    // NOTE: color picker val will change either way, so this function only needs to be called once from here
	    editSampleColorEls(hexValue);
	  }
	
	  // NOTE: this doesn't quite work yet as the color picker defaults to #000000 hex instead of empty
	  function editColorPickerVal() {
	    var swatchColor = swatchInput.val();
	    colorPicker.colorpicker('setValue', swatchColor);
	    hideShowPreview();
	  }
	
	  function hideShowPreview() {
	    if ((0, _general.isPresent)(swatchInput.val()) || (0, _general.isPresent)($(previewImage).attr('src'))) {
	      retailerBannerPreview.hide();
	      bannerEl.show();
	    } else {
	      retailerBannerPreview.show();
	      bannerEl.hide();
	    }
	  }
	
	  function editSampleColorEls(color) {
	    swatchEl.css({ backgroundColor: color });
	    bannerEl.css({ backgroundColor: color });
	  }
	
	  var bannerDefault = outerEl.find(".sc-default-fedex-banner");
	  var bannerConfigSection = outerEl.find(".retailer-banner-config");
	  bannerDefault.on('change', function () {
	    if ($(this).is(":checked")) {
	      retailerBannerConfigSection.hide();
	    } else {
	      retailerBannerConfigSection.show();
	    }
	  });
	
	  var logiOrientation = $(".sc-logo-orientation");
	
	  logiOrientation.on('change', function () {
	    bannerEl.attr('align', this.value);
	    retailerBannerPreview.hide();
	    bannerEl.show();
	  });
	
	  scRmaService.on('change', function () {
	
	    var helpText = $(this).closest('div').siblings('div').find('.dropdown-hint-target');
	
	    if (this.value == 'S') {
	      helpText.text('We\'ll generate the RMA Number.');
	      systemGeneratedRmaConfig.show();
	      retailerSuppliedRmaConfig.hide();
	    } else {
	      helpText.text('Retailer will supply the RMA number.');
	      systemGeneratedRmaConfig.hide();
	      retailerSuppliedRmaConfig.show();
	    }
	  });
	
	  scShippingService.on('change', function () {
	    var helpText = $(this).closest('div').siblings('div').find('.dropdown-hint-target');
	
	    if (this.value == 'EX') {
	      helpText.html('<div>All returns will be shipping via Express Shipping.</div>');
	    } else {
	      helpText.html('<div class=\'q-marg-vert-xs\'>We\'ll calculate the shipping service.</div>');
	    }
	  });
	
	  rscLabelSetting.on('change', function () {
	
	    var helpText = $(this).closest('div').siblings('div').find('.dropdown-hint-target');
	
	    if (this.value == 'OPSB') {
	      helpText.html('<div>When returning multiple products at time, each box and label will only contain a single product.</div>');
	    } else {
	      helpText.html('<div class=\'q-marg-vert-xs\'>Each return can only contain a single box that can hold multiple products.</div>');
	    }
	  });
	
	  copyTokenBtn.on('click', function () {
	    accessTokenVal.select();
	    document.execCommand('copy');
	  });
	
	  regenerateAuthTokenBtn.on('click', function () {
	    if (returnChannelName.val() == 0) {
	      channelEmptyMsg.show();
	      return;
	    }
	    channelEmptyMsg.hide();
	    regenerateAuthTokenBtn.hide();
	    copyTokenBtn.hide();
	    loadAuthTokenBtn.show();
	    $.ajax({
	      url: regenerateAuthTokenBtn.data('token-url'),
	      type: 'POST',
	      dataType: 'json',
	      data: [],
	      success: function success(resp) {
	        if (resp.data && resp.data != null && resp.data != 'null') {
	          accessTokenDisplayDiv.show();
	          accessTokenVal.text(resp.data);
	          accessTokenVal.prop('readonly', true);
	          regenerateAuthTokenBtn.show();
	          copyTokenBtn.show();
	          loadAuthTokenBtn.hide();
	          generateAuthTokenBtn.hide();
	        } else {
	          authFailedMsg.show();
	          regenerateAuthTokenBtn.hide();
	          copyTokenBtn.hide();
	          loadAuthTokenBtn.hide();
	          generateAuthTokenBtn.show();
	        }
	      },
	      error: function error(xhr, status, _error) {
	        authFailedMsg.show();
	        regenerateAuthTokenBtn.hide();
	        copyTokenBtn.hide();
	        loadAuthTokenBtn.hide();
	        generateAuthTokenBtn.show();
	      }
	    });
	  });
	
	  //addAnthChannelBtn.on('click', function(){
	  //  duplicateTokenAuthDiv.clone().insertAfter(duplicateTokenAuthDiv);
	
	  //});
	
	  generateAuthTokenBtn.on('click', function () {
	    if (returnChannelName.val() == 0) {
	      channelEmptyMsg.show();
	      return;
	    }
	    channelEmptyMsg.hide();
	    generateAuthTokenBtn.hide();
	    loadAuthTokenBtn.show();
	    $.ajax({
	      url: generateAuthTokenBtn.data('token-url'),
	      type: 'POST',
	      dataType: 'json',
	      data: [],
	      success: function success(resp) {
	        if (resp.data && resp.data != null && resp.data != 'null') {
	          accessTokenDisplayDiv.show();
	          accessTokenVal.text(resp.data);
	          accessTokenVal.prop('readonly', true);
	          regenerateAuthTokenBtn.show();
	          copyTokenBtn.show();
	          loadAuthTokenBtn.hide();
	          generateAuthTokenBtn.hide();
	        } else {
	          authFailedMsg.show();
	          //regenerateAuthTokenBtn.hide();
	          //  copyTokenBtn.hide();
	          loadAuthTokenBtn.hide();
	          //generateAuthTokenBtn.show();
	        }
	      },
	      error: function error(xhr, status, _error2) {
	        authFailedMsg.show();
	        //regenerateAuthTokenBtn.hide();
	        //copyTokenBtn.hide();
	        loadAuthTokenBtn.hide();
	        //generateAuthTokenBtn.show();
	      }
	    });
	  });
	
	  regenerateHCAuthTokenBtn.on('click', function () {
	    if (returnChannelName.val() == 0) {
	      channelEmptyMsg.show();
	      return;
	    }
	    var partnerId = $('#returnChannelName :selected').val();
	    channelEmptyMsg.hide();
	    regenerateHCAuthTokenBtn.hide();
	    copyTokenBtn.hide();
	    loadAuthTokenBtn.show();
	    $.ajax({
	      url: regenerateHCAuthTokenBtn.data('token-url'),
	      type: 'POST',
	      dataType: 'json',
	      data: {
	        partnerId: partnerId
	      },
	      success: function success(resp) {
	        if (resp.data && resp.data != null && resp.data != 'null') {
	          accessTokenDisplayDiv.show();
	          accessTokenVal.text(resp.data);
	          accessTokenVal.prop('readonly', true);
	          regenerateHCAuthTokenBtn.show();
	          copyTokenBtn.show();
	          loadAuthTokenBtn.hide();
	          generateHCAuthTokenBtn.hide();
	        } else {
	          authFailedMsg.show();
	          regenerateHCAuthTokenBtn.hide();
	          copyTokenBtn.hide();
	          loadAuthTokenBtn.hide();
	          generateHCAuthTokenBtn.show();
	        }
	      },
	      error: function error(xhr, status, _error3) {
	        authFailedMsg.show();
	        regenerateHCAuthTokenBtn.hide();
	        copyTokenBtn.hide();
	        loadAuthTokenBtn.hide();
	        generateHCAuthTokenBtn.show();
	      }
	    });
	  });
	
	  //addAnthChannelBtn.on('click', function(){
	  //  duplicateTokenAuthDiv.clone().insertAfter(duplicateTokenAuthDiv);
	
	  //});
	
	  generateHCAuthTokenBtn.on('click', function () {
	    if (returnChannelName.val() == 0) {
	      channelEmptyMsg.show();
	      return;
	    }
	    var partnerId = $('#returnChannelName :selected').val();
	    channelEmptyMsg.hide();
	    generateHCAuthTokenBtn.hide();
	    loadAuthTokenBtn.show();
	    $.ajax({
	      url: generateHCAuthTokenBtn.data('token-url'),
	      type: 'POST',
	      dataType: 'json',
	      data: {
	        partnerId: partnerId
	      },
	      success: function success(resp) {
	        if (resp.data && resp.data != null && resp.data != 'null') {
	          accessTokenDisplayDiv.show();
	          accessTokenVal.text(resp.data);
	          accessTokenVal.prop('readonly', true);
	          regenerateHCAuthTokenBtn.show();
	          copyTokenBtn.show();
	          loadAuthTokenBtn.hide();
	          generateHCAuthTokenBtn.hide();
	        } else {
	          authFailedMsg.show();
	          //  regenerateHCAuthTokenBtn.hide();
	          //  copyTokenBtn.hide();
	          loadAuthTokenBtn.hide();
	          //  generateHCAuthTokenBtn.show();
	        }
	      },
	      error: function error(xhr, status, _error4) {
	        authFailedMsg.show();
	        //  regenerateHCAuthTokenBtn.hide();
	        //  copyTokenBtn.hide();
	        loadAuthTokenBtn.hide();
	        //  generateHCAuthTokenBtn.show();
	      }
	    });
	  });
	
	  var retailerServiceConfigForm = outerEl.find(".retailer-service-configuration-form");
	  var retailerServiceConfigSubmitLink = outerEl.find(".save-service-config-edits");
	
	  (0, _submitHelpers.bindHardSubmit)({
	    form: retailerServiceConfigForm,
	    links: retailerServiceConfigSubmitLink
	  });
	
	  if (!$(bannerConfigSection).data("default-value") || $(bannerConfigSection).data("default-value") == "on") {
	    bannerConfigSection.hide();
	  } else {
	    bannerConfigSection.show();
	  }
	
	  retailerServiceConfigForm.validate({
	    errorPlacement: function errorPlacement(error, element) {
	
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    },
	
	    // Place all your validation rules here!!!
	    rules: {
	      "sc-logo-img-hidden": {
	        maxFileSizeBytes: 200000000
	      },
	      "sgr-prefix": {
	        regex: "^[a-zA-Z0-9_-]*$"
	      },
	      "rsa-prefix": {
	        regex: "^[a-zA-Z0-9_-]*$"
	      },
	      "sgr-number-length": {
	        max: 10,
	        min: 5
	      },
	      "sgr-starting-number": {
	        startNumberLimit: true,
	        min: currentEntityNumber
	      },
	      "pgp-max-labels-allowed": { //E-67370
	        max: 5,
	        min: 1
	      },
	      "pgp-rt-window-max-labels-allowed": { //E-89401
	        max: 5,
	        min: 1
	      }
	    },
	    messages: {
	      "sgr-number-length": {
	        min: "Length must be longer than 5 and less than 10.",
	        max: "Length must be longer than 5 and less than 10."
	      },
	      "pgp-max-labels-allowed": { //E-67370
	        max: "Number must be between 1 and 5.",
	        min: "0 cannot be entered."
	      },
	      "pgp-rt-window-max-labels-allowed": { //E-89401
	        max: "Number must be between 1 and 5.",
	        min: "0 cannot be entered."
	      }
	    }
	  });
	
	  $.validator.addMethod("regex", function (value, element, regexp) {
	
	    var check = false;
	    var re = new RegExp(regexp);
	    return this.optional(element) || re.test(value);
	  }, "A character has been added that is not valid.");
	
	  $.validator.addMethod("startNumberLimit", function (value, element) {
	    var startNumberValue = startNumberLength.val();
	    if ((0, _general.isPresent)(startNumberValue)) {
	      return startNumberValue >= value.length;
	    } else {
	      return true;
	    }
	  }, "Starting number length must not exceed rma number length.");
	
	  // NOTE: when instantiating this init function from a separate js file, please see consumerReturnsView stub for example, or ask a UI dev for an example
	
	  init();
	  hideShowPreview();
	
	  retailerServiceConfigForm.on('submit', function (e) {
	    e.preventDefault();
	    if (retailerServiceConfigForm.valid()) {
	      var submitModalFlow = new SubmitModalFlow({
	        confirmModalTitle: 'Submit Retailer Configuration',
	        confirmModalBody: '<div class="q-pad-all-xl">By submitting this configuration, the service configuration information will be saved for current retailer.</div>',
	        confirmModalBtnText: 'Submit',
	        onConfirmClick: function onConfirmClick() {
	          submitModalFlow.showLoadingModal();
	          var formData = new FormData(retailerServiceConfigForm[0]);
	          $.ajax({
	            url: retailerServiceConfigForm.attr('action'),
	            type: 'POST',
	            processData: false,
	            contentType: false,
	            data: formData,
	            success: function success(resp) {
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = serviceConfiguration;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            },
	            error: function error(_error5) {
	              submitModalFlow.showFailureModal();
	            }
	          });
	        }
	
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  });
	
	  function loadOrderNumberConfiguration() {
	    (0, _instantiateSwitchery.instantiateSwitchery)(orderNumberVisible);
	    (0, _instantiateSwitchery.setSwitchery)(orderNumberVisible, retailerReturnsConfiguration.originalOrderNumberVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(orderNumberMandatory);
	    (0, _instantiateSwitchery.setSwitchery)(orderNumberMandatory, retailerReturnsConfiguration.originalOrderNumberMandatory);
	
	    if (retailerReturnsConfiguration.originalOrderNumberVisible) {
	      orderNumberMandatoryDiv.show();
	    } else {
	      (0, _instantiateSwitchery.setSwitchery)(orderNumberVisible, false);
	      orderNumberMandatoryDiv.hide();
	    }
	  }
	
	  //HB-11513
	  function loadWarehouseLevelRmaConfiguration() {
	    (0, _instantiateSwitchery.instantiateSwitchery)(warehouseLevelShipmentVisible);
	    (0, _instantiateSwitchery.setSwitchery)(warehouseLevelShipmentVisible, retailerReturnsConfiguration.warehouseLevelRmasVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(warehouseLevelReturnReasonVisible);
	    (0, _instantiateSwitchery.setSwitchery)(warehouseLevelReturnReasonVisible, retailerReturnsConfiguration.reasonForReturnVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(prepaidCollectVisible);
	    (0, _instantiateSwitchery.setSwitchery)(prepaidCollectVisible, retailerReturnsConfiguration.prepaidCollectVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(billOfLadenVisible);
	    (0, _instantiateSwitchery.setSwitchery)(billOfLadenVisible, retailerReturnsConfiguration.billOfLadenVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(rmaNotesVisible);
	    (0, _instantiateSwitchery.setSwitchery)(rmaNotesVisible, retailerReturnsConfiguration.rmaNotesVisible);
	
	    if (retailerReturnsConfiguration.warehouseLevelRmasVisible) {
	      warehouseLevelShipmentDiv.show();
	    } else {
	      (0, _instantiateSwitchery.setSwitchery)(warehouseLevelShipmentVisible, false);
	      warehouseLevelShipmentDiv.hide();
	    }
	  }
	
	  function loadDefaultItemForReturnsConfig() {
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(defaultItemAllReturns);
	    (0, _instantiateSwitchery.setSwitchery)(defaultItemAllReturns, retailerReturnsConfiguration.defaultItemConfig);
	  }
	
	  function loadRmaCreationEmailConfig() {
	    (0, _instantiateSwitchery.instantiateSwitchery)(sendRmaCreationEmailToggler);
	    (0, _instantiateSwitchery.setSwitchery)(sendRmaCreationEmailToggler, sendRmaCreationEmailConfig);
	  }
	
	  function hideAndShowBasedOnSubscription() {
	    if (isRmsOnly) {
	      defaultItemAllReturnsDiv.show();
	    } else {
	      defaultItemAllReturnsDiv.hide();
	    }
	  }
	
	  function hideAndShowBasedOnDefaultItemConfig() {
	
	    if (retailerReturnsConfiguration.defaultItemConfig) {
	      doNotShowForDefaultItemMerchants.show();
	    } else {
	      doNotShowForDefaultItemMerchants.show();
	    }
	  }
	
	  function loadManualRmaProductCaptures() {
	    (0, _instantiateSwitchery.instantiateSwitchery)(returnReasonVisible);
	    (0, _instantiateSwitchery.setSwitchery)(returnReasonVisible, retailerReturnsConfiguration.returnReasonVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(finalSaleFlagVisible);
	    (0, _instantiateSwitchery.setSwitchery)(finalSaleFlagVisible, retailerReturnsConfiguration.finalSaleFlagVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(productWeightVisible);
	    (0, _instantiateSwitchery.setSwitchery)(productWeightVisible, retailerReturnsConfiguration.productWeightVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(notesVisible);
	    (0, _instantiateSwitchery.setSwitchery)(notesVisible, retailerReturnsConfiguration.notesVisible);
	  }
	
	  //9043 Shipping and Processing Fields integration post Edit
	  function loadShippingAndProcessingCaptures() {
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(complimentaryReturnShippingVisible);
	    (0, _instantiateSwitchery.setSwitchery)(complimentaryReturnShippingVisible, retailerReturnsConfiguration.complimentaryReturnShippingVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(overrideShipAddressVisible);
	    (0, _instantiateSwitchery.setSwitchery)(overrideShipAddressVisible, retailerReturnsConfiguration.overrideShipAddressVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(overrideShipServiceVisible);
	    (0, _instantiateSwitchery.setSwitchery)(overrideShipServiceVisible, retailerReturnsConfiguration.overrideShipServiceVisible);
	
	    //E-82367 Priority Alert Shipping
	    (0, _instantiateSwitchery.instantiateSwitchery)(priorityAlertShippments);
	    (0, _instantiateSwitchery.setSwitchery)(priorityAlertShippments, retailerReturnsConfiguration.priorityAlertShippments);
	    // Saturday Delivery
	    (0, _instantiateSwitchery.instantiateSwitchery)(expressShipmentsforSaturday);
	    (0, _instantiateSwitchery.setSwitchery)(expressShipmentsforSaturday, retailerReturnsConfiguration.expressShipmentsforSaturday);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(declaredValueVisible);
	    (0, _instantiateSwitchery.setSwitchery)(declaredValueVisible, retailerReturnsConfiguration.declaredValueVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(specialCreditProcessingVisible);
	    (0, _instantiateSwitchery.setSwitchery)(specialCreditProcessingVisible, retailerReturnsConfiguration.specialCreditProcessingVisible);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(display4x4);
	    (0, _instantiateSwitchery.setSwitchery)(display4x4, retailerReturnsConfiguration.display4x4);
	
	    (0, _instantiateSwitchery.instantiateSwitchery)(showPackingSlip);
	    (0, _instantiateSwitchery.setSwitchery)(showPackingSlip, retailerReturnsConfiguration.showPackingSlip);
	  }
	
	  function loadRmaPredefinedPrefixConfigs() {
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: sgrPrefixPredefined,
	      list: prefedinedRmaPrefixValues,
	      valueDataKey: "cdmValue",
	      textDataKey: "cdmMeaning"
	    });
	  }
	}

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(682);
	
	__webpack_require__(274);

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	// const targetSelector = "#p_p_id_rmsui_WAR_rmsuiportlet_";
	var targetSelector = "#replace-with-your-unique-selector";
	
	// For quick dev prototyping
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachPages(outerEl);
	});
	
	function attachPages(outerEl) {}

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(684);

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _index = __webpack_require__(466);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _sampleFilterData = __webpack_require__(685);
	
	var _statusOptions = __webpack_require__(686);
	
	var _notifications = __webpack_require__(1364);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
	                                                                                                                                                                                                                    Base file for example file in component.
	                                                                                                                                                                                                                    Meant to show what the component is used for
	                                                                                                                                                                                                                    in conjunction with the './html'
	                                                                                                                                                                                                                  
	                                                                                                                                                                                                                    add path to the src/index.js to be able to see it:
	                                                                                                                                                                                                                    ex. 'import "./components/notificationsView";'
	                                                                                                                                                                                                                  */
	
	var modalHtml = __webpack_require__(11);
	
	var viewTogglerHtml = __webpack_require__(1365);
	var exportModalBodyHtml = __webpack_require__(1363);
	
	var iconColTemplateHtml = __webpack_require__(1150);
	var descripColTemplateHtml = __webpack_require__(1148);
	var dateColTemplateHtml = __webpack_require__(1147);
	var channelColTemplateHtml = __webpack_require__(1146);
	var pillColTemplateHtml = __webpack_require__(1151);
	var actionColTemplateHtml = __webpack_require__(1144);
	var actionLinkTemplateHtml = __webpack_require__(1145);
	
	var targetSelector = "#view-notification-form";
	// const targetSelector = "#p_p_id_channels_WAR_hcportlet_";
	
	var pillsMap = {
	  "Action Needed": "q-pill-blue",
	  "In Progress": "q-pill-white-and-blue",
	  "Dismissed": "q-pill-white-and-grey"
	};
	
	var iconsMap = {
	  Order: "fa-shopping-basket",
	  ASN: "fa-exchange",
	  RMA: "fa-reply",
	  WorkOrder: "fa-reply",
	  Product: "fa-reply",
	  Inventory: "fa-reply",
	  Facilities: "fa-reply"
	
	  // use this to render description link with sku link to details based on status type
	};var descriptionStringsMap = {
	  Order: "Order {%= detailsLink %}.",
	  ASN: "ASN {%= detailsLink %}.",
	  RMA: "RMA {%= detailsLink %}.",
	  WorkOrder: "Item {%= detailsLink %}.",
	  Product: "Item {%= detailsLink %}.",
	  Inventory: "Item {%= detailsLink %}.",
	  Facilities: "Item {%= detailsLink %}."
	};
	
	var elementsMap = {
	  exportBtn: ".export-widgets",
	  manageBtn: ".manage-btn",
	  markInProgressBtn: '.markInProgress',
	  markDismissedBtn: '.markDismissed',
	  viewDetailsBtn: '.viewDetails'
	};
	
	var elementsModalMap = {
	  exportTypeToggler: ".export-type-toggler",
	  exportDateRangeStart: ".export-date-range-start",
	  exportDateRangeEnd: ".export-date-range-end",
	  exportSubmitBtn: ".export-btn"
	};
	
	function getNotificationOnPageLoad() {
	  //Show Notification bell on the portal header
	  var element = (0, _jquery2.default)('.top-notification-section');
	  if (element.length) {
	    AUI().use('aui-base', 'liferay-portlet-url', 'aui-node', function (A) {
	      var plid = element.find("a").data("plid");
	      var notificationURL = Liferay.PortletURL.createResourceURL();
	      notificationURL.setResourceId('getNotificationCount');
	      notificationURL.setPortletId('notificationsubscription_WAR_commerceportlet');
	      notificationURL.setPlid(plid);
	      _jquery2.default.ajax({
	        url: notificationURL.toString(),
	        type: "POST",
	        dataType: "json",
	        success: function success(data) {
	          var response = data.notificationObject;
	          if (_underscore2.default.has(response, "paging")) {
	            element.show();
	            element.find(".notification-count").text(response.paging.count);
	            if (response.paging.count > 0) {
	              element.find(".notification-count").addClass("q-pretty-pill-tag q-ppt-green");
	            }
	            var notificationDetailURL = Liferay.PortletURL.createRenderURL();
	            notificationDetailURL.setPortletId('notificationsubscription_WAR_commerceportlet');
	            notificationDetailURL.setParameter('action', 'viewNotification');
	            notificationDetailURL.setPlid(plid);
	            element.find("a").attr("href", notificationDetailURL);
	          }
	        },
	        error: function error(data) {}
	      });
	    });
	  }
	}
	
	(0, _jquery2.default)(document).ready(function () {
	  //Invoke this function on page load
	  getNotificationOnPageLoad();
	});
	
	(0, _run2.default)(targetSelector, function () {
	  var form = (0, _jquery2.default)(targetSelector);
	  var PAGE_LIMIT = 10;
	  var getNotificationsUrl = form.data('get-notifications-url');
	  var getManageNotificationsUrl = form.data('manage-notification-preference-url');
	  var updateDisplayStatusUrl = form.data('update-status-url');
	  var generateExportUrl = form.data('generate-export-url');
	  var notificationObject = form.data('notification-list');
	  var newNotificationObject = form.data('new-notification-list');
	  var subscribedObjectTypes = form.data('object-type-list');
	  var filterData = form.data('filter-data');
	  var moreData = notificationObject.paging.count > PAGE_LIMIT;
	  var fromDateTime = form.data('from-date');
	  var toDateTime = form.data('to-date');
	  var lastToDateTime = notificationObject.paging.lastToDateTime;
	  var notificationsAlertList = {};
	  notificationsAlertList.data = notificationObject.exceptionLog; // this is required as widget engine needs data attribute for list
	
	  var orderDetailsPageUrl = form.data('order-page-url');
	  var asnDetailsPageUrl = form.data('asn-page-url'); // For future use
	
	  var urlMap = {
	    Order: orderDetailsPageUrl
	
	    // Required to Load Stub
	  };var outerEl = (0, _jquery2.default)(_notifications2.default);
	  (0, _jquery2.default)(targetSelector).html(outerEl);
	
	  // START: Actual Code
	  var els = {};
	  var elsModal = {};
	  var exportModal = void 0;
	
	  // general setup for notifications view page here
	  function init() {
	    exampleWidgetEngine.init();
	
	    generateModals();
	    setElements();
	    exportModalComponentsInit();
	    bindElements();
	    setLinks();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, outerEl);
	    (0, _selectorHelpers.setElementsFromScope)(elsModal, elementsModalMap, exportModal);
	  }
	
	  function bindElements() {
	    els.exportBtn.click((0, _general.createPreventDefault)(showExportModal));
	    (0, _jquery2.default)(document).on("click", elementsMap.markInProgressBtn, markInProgressAction);
	    (0, _jquery2.default)(document).on("click", elementsMap.markDismissedBtn, markDismissedAction);
	    (0, _jquery2.default)(document).on("click", elementsMap.viewDetailsBtn, viewDetailsBtnAction);
	    (0, _jquery2.default)(document).on("click", elementsModalMap.exportSubmitBtn, exportSubmitBtnAction);
	  }
	
	  function showExportModal() {
	    exportModal.modal("show");
	  }
	
	  function markInProgressAction(e) {
	    e.preventDefault();
	    if (!(0, _jquery2.default)(this).hasClass('disabled')) {
	      updateDisplayStatus("In Progress", "", (0, _jquery2.default)(this).data("id"), (0, _jquery2.default)(this).data("url"));
	    }
	  }
	
	  function markDismissedAction(e) {
	    e.preventDefault();
	    if (!(0, _jquery2.default)(this).hasClass('disabled')) {
	      updateDisplayStatus("Dismissed", "Viewed", (0, _jquery2.default)(this).data("id"), (0, _jquery2.default)(this).data("url"));
	    }
	  }
	
	  function viewDetailsBtnAction(e) {
	    e.preventDefault();
	    (0, _jquery2.default)(this).attr('target', '_blank');
	    window.open((0, _jquery2.default)(this).data('url'));
	  }
	
	  function exportSubmitBtnAction(e) {
	    e.preventDefault();
	    var filterRequest = {};
	    filterRequest.displayStatus = ["Action Needed", "In Progress", "Dismissed"]; // to be converted to array for service
	    if (elsModal.exportDateRangeStart.val().length > 0) {
	      filterRequest.fromDateTime = elsModal.exportDateRangeStart.val();
	    }
	    if (elsModal.exportDateRangeEnd.val().length > 0) {
	      filterRequest.toDateTime = elsModal.exportDateRangeEnd.val();
	    }
	    filterRequest.objectType = subscribedObjectTypes;
	    var url = generateExportUrl + "&notificationType=Alerts&filterRequest=" + JSON.stringify(filterRequest);
	    window.open(url);
	    exportModal.modal("hide");
	  }
	
	  function updateDisplayStatus(displayStatus, status, id, url) {
	    var _exceptionLogData;
	
	    var submitModal = new _SubmitModalFlow2.default();
	    submitModal.init();
	    var exceptionLogData = (_exceptionLogData = {}, _defineProperty(_exceptionLogData, "exceptionLogId", id + ""), _defineProperty(_exceptionLogData, "displayStatus", displayStatus), _exceptionLogData);
	
	    if (!(0, _general.isBlank)(status)) {
	      exceptionLogData.status = status;
	    }
	
	    _jquery2.default.ajax({
	      url: url,
	      type: "POST",
	      dataType: "json",
	      data: exceptionLogData,
	      beforeSend: function beforeSend() {
	        submitModal.showLoadingModal();
	      },
	      complete: function complete() {
	        submitModal.hideAllModals();
	      },
	      success: function success(data, textStatus, jqXHR) {
	        exampleWidgetEngine.refreshAfterActionClicked();
	      },
	      error: function error() {
	        // server will show an error modal on exceptions
	      }
	    });
	  }
	
	  function setLinks() {
	    els.manageBtn.prop("href", getManageNotificationsUrl);
	  }
	
	  function generateModals() {
	    exportModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	      title: 'Export Notifications',
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-500",
	      body: (0, _render2.default)(exportModalBodyHtml),
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a> <a href=\"#\" class=\"base-btn purple-btn export-btn\">Export</a>\n        "
	    }));
	
	    outerEl.append(exportModal);
	  }
	
	  function exportModalComponentsInit() {
	    var date = new Date();
	
	    elsModal.exportDateRangeStart.datepicker({
	      endDate: date,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    }).on('changeDate', function (selected) {
	      var minDate = new Date(selected.date.valueOf());
	      elsModal.exportDateRangeEnd.datepicker('setStartDate', minDate);
	    });
	
	    elsModal.exportDateRangeEnd.datepicker({
	      endDate: date,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    }).on('changeDate', function (selected) {
	      var maxDate = new Date(selected.date.valueOf());
	      elsModal.exportDateRangeStart.datepicker('setEndDate', maxDate);
	    });
	
	    var exportTypeBtnGroup = new _QuickBtnGroup2.default(elsModal.exportTypeToggler, {
	      distributeWidth: true
	    });
	    exportTypeBtnGroup.init();
	  }
	  // end of general setup for notifications view page here
	
	  // begin component initialization here - portal dev will need to pass render functions to component to render columns
	  var exampleWidgetEngine = new _index2.default({
	    // REQUIRED - Set a target element
	    target: (0, _jquery2.default)(".widget-engine-target"),
	    data: notificationsAlertList,
	    hasViewToggler: true,
	    viewToggler: renderViewToggler(),
	    viewTogglerDataCountTarget: ".notifications-count",
	    filterList: _sampleFilterData.sampleFilterList,
	    // groupBy: "status",
	    header: "Notifications Alerts",
	    filterBy: "",
	
	    // NOTE: set this to whichever on page load
	    filterListActive: "all",
	
	    widgetFilters: {
	      data: filterData
	      // NOTE: these paramas are optional, if you need more properties on dropdown that appears on responsive view
	      // filterDropdownName: "",
	      // filterDropdownId: "",
	      // filterDropdownPlaceholder: ""
	    },
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Alerts",
	      // REQUIRED: Sets unique part of subtitle string.
	      widgetType: "alerts"
	    },
	
	    columns: [{
	      data: "icon",
	      render: renderAlertIconCol
	    }, {
	      data: "title",
	      render: renderAlertDescriptCol
	    }, {
	      data: "exceptionTime",
	      render: renderAlertDateCol
	    }, {
	      data: "displayStatus",
	      render: renderAlertPillCol
	    }, {
	      data: "displayStatus",
	      render: renderAlertActionsCol
	    }],
	
	    // boolean to check whether there's still data to load from database
	    moreData: moreData,
	
	    onFetch: function onFetch() {
	      var _data;
	
	      var filters = exampleWidgetEngine.generateData();
	      var filterRequest = {};
	      if (filters.filterLinkData === "all") {
	        filterRequest.displayStatus = ["Action Needed", "In Progress"]; // to be converted to array for service
	      } else {
	        filterRequest.displayStatus = [filters.filterLinkData]; // to be converted to array for service
	      }
	      filterRequest.fromDateTime = fromDateTime;
	      filterRequest.toDateTime = lastToDateTime;
	      filterRequest.objectType = subscribedObjectTypes; // if user selected alert types from filter, these values will be replaced in controller
	
	      var data = (_data = {}, _defineProperty(_data, "filterRequest", JSON.stringify(filterRequest)), _defineProperty(_data, "searchCriteria", JSON.stringify(filters.searchCriteria)), _defineProperty(_data, "loadMore", true), _data);
	
	      _jquery2.default.ajax({
	        url: getNotificationsUrl,
	        type: "POST",
	        dataType: "json",
	        data: data,
	        beforeSend: function beforeSend() {
	          exampleWidgetEngine.showLoadingBtn();
	        },
	        complete: function complete() {
	          exampleWidgetEngine.hideLoadingBtn();
	        },
	        success: function success(data, textStatus, jqXHR) {
	          var response = data.notificationObject;
	          if (_underscore2.default.has(data.notificationObject, "exceptionLog") && response.exceptionLog.length > 0) {
	            exampleWidgetEngine.appendNewData(response.exceptionLog);
	            exampleWidgetEngine.filterListActive = filters.filterLinkData;
	            exampleWidgetEngine.setFilterLinkActive(exampleWidgetEngine.filterListActive);
	            exampleWidgetEngine.validateForMoreData(response.paging.count > PAGE_LIMIT);
	            lastToDateTime = response.paging.lastToDateTime;
	          } else {
	            exampleWidgetEngine.filterListActive = filters.filterLinkData;
	            exampleWidgetEngine.setFilterLinkActive(exampleWidgetEngine.filterListActive);
	            exampleWidgetEngine.validateForMoreData(false);
	          }
	        },
	        error: function error() {
	          // server will show an error modal on exceptions
	        }
	      });
	    },
	
	    // NOTE: different from onFetch because fetch just appends to bottom of page. Filter needs to replace data
	    onFilter: function onFilter() {
	      var _data2;
	
	      var submitModal = new _SubmitModalFlow2.default();
	      submitModal.init();
	      var filters = exampleWidgetEngine.generateData();
	      var filterRequest = {};
	      if (filters.filterLinkData === "all") {
	        filterRequest.displayStatus = ["Action Needed", "In Progress"]; // to be converted to array for service
	      } else {
	        filterRequest.displayStatus = [filters.filterLinkData]; // to be converted to array for service
	      }
	      filterRequest.fromDateTime = fromDateTime;
	      filterRequest.toDateTime = toDateTime;
	      filterRequest.objectType = subscribedObjectTypes; // if user selected alert types from filter, these values will be replaced in controller
	
	      var data = (_data2 = {}, _defineProperty(_data2, "filterRequest", JSON.stringify(filterRequest)), _defineProperty(_data2, "searchCriteria", JSON.stringify(filters.searchCriteria)), _defineProperty(_data2, "loadMore", false), _data2);
	
	      _jquery2.default.ajax({
	        url: getNotificationsUrl,
	        type: "POST",
	        dataType: "json",
	        data: data,
	        beforeSend: function beforeSend() {
	          submitModal.showLoadingModal();
	        },
	        complete: function complete() {
	          submitModal.hideAllModals();
	        },
	        success: function success(data, textStatus, jqXHR) {
	          var response = data.notificationObject;
	          if (_underscore2.default.has(data.notificationObject, "exceptionLog") && response.exceptionLog.length > 0) {
	            fromDateTime = data.fromDateTime;
	            toDateTime = data.toDateTime;
	            exampleWidgetEngine.setNewData(response.exceptionLog);
	            exampleWidgetEngine.filterListActive = filters.filterLinkData;
	            exampleWidgetEngine.setFilterLinkActive(exampleWidgetEngine.filterListActive);
	            exampleWidgetEngine.validateForMoreData(response.paging.count > PAGE_LIMIT);
	            lastToDateTime = response.paging.lastToDateTime;
	          } else {
	            fromDateTime = data.fromDateTime;
	            toDateTime = data.toDateTime;
	            exampleWidgetEngine.setNewData([]); //set empty data
	            exampleWidgetEngine.filterListActive = filters.filterLinkData;
	            exampleWidgetEngine.setFilterLinkActive(exampleWidgetEngine.filterListActive);
	            exampleWidgetEngine.validateForMoreData(false);
	          }
	        },
	        error: function error() {
	          // server will show an error modal on exceptions
	        }
	      });
	    }
	
	    // onViewToggleCallback: function(){
	    //   //NOTE: this is for an upcoming story. I will add more here when implementing upcoming story
	    // }
	  });
	
	  // NOTE: start of render functions portal dev will need to pass to component for columns, links, and filter
	  function renderViewToggler() {
	    var newAlertCount = 0;
	    if (_underscore2.default.has(newNotificationObject, "paging")) {
	      newAlertCount = newNotificationObject.paging.count;
	    }
	    return (0, _render2.default)(viewTogglerHtml, {
	      alertNumber: newAlertCount + ' New'
	    });
	  }
	
	  function renderAlertIconCol(data, key, rowData) {
	    return (0, _render2.default)(iconColTemplateHtml, {
	      icon: iconsMap[rowData.objectType],
	      classWidth: "q-col-fix-40"
	    });
	  }
	
	  function renderAlertDescriptCol(data, key, rowData) {
	    return (0, _render2.default)(descripColTemplateHtml, {
	      title: rowData.title,
	      description: getDescriptionString(rowData),
	      classWidth: "q-col-6"
	    });
	  }
	
	  function getDescriptionString(rowInfo) {
	    // NOTE: no reason to create new variables, since we just need to return the one after manipulating and rendering it
	    var description = descriptionStringsMap[rowInfo.objectType];
	    var url = getDetailsUrl(rowInfo);
	    description = (0, _render2.default)(description, {
	      detailsLink: "<a target=\"_blank\" href=\"" + url + "\" target=\"_blank\">" + rowInfo.objectId + "</a>" || ""
	    });
	
	    return description + "<br>" + getDescription(rowInfo.description);
	  }
	
	  function getDescription(description) {
	    if ((0, _general.isBlank)(description) || description == 'null') {
	      return "";
	    } else {
	      return description;
	    }
	  }
	
	  function renderAlertDateCol(data, key, rowData) {
	    return (0, _render2.default)(dateColTemplateHtml, {
	      date: moment(rowData.exceptionTime).format('MM/DD/YYYY'),
	      status: rowData.status,
	      classWidth: "q-col-2"
	    });
	  }
	
	  function renderAlertPillCol(data, key, rowData) {
	    return (0, _render2.default)(pillColTemplateHtml, {
	      pillColor: pillsMap[rowData.displayStatus],
	      pillText: getPillText(rowData),
	      classWidth: "q-col-fix-155"
	    });
	  }
	
	  function getPillText(rowInfo) {
	    if (rowInfo.displayStatus === "In Progress") {
	      return rowInfo.displayStatus + ": " + rowInfo.exceptionOwnerId;
	    } else {
	      return rowInfo.displayStatus;
	    }
	  }
	
	  function renderAlertActionsCol(data, key, rowData) {
	    return (0, _render2.default)(actionColTemplateHtml, {
	      alertActionList: getActionList(rowData),
	      classWidth: "q-col-fix-80"
	    });
	  }
	
	  function getActionList(rowData) {
	    // NOTE: Mike K recommended that I add default set of actions in callback in case they pass something in that doesn't exist
	    // But since portal dev will be rendering this for time being, perhaps they can handle the clicks for these action links?
	    var statusObj = _statusOptions.statusOptions[rowData.displayStatus];
	    _jquery2.default.each(statusObj, function (i, v) {
	      v.id = rowData.exceptionLogId;
	      v.url = getActionUrl(v, rowData);
	    });
	    var linksArray = (0, _underscore2.default)(statusObj).map(renderAlertActionsLink).join("");
	    return linksArray;
	  }
	
	  function renderAlertActionsLink(actionLinkObj) {
	    return (0, _render2.default)(actionLinkTemplateHtml,
	    //  NOTE: you can add more params here if you need, such as href
	    {
	      title: actionLinkObj.title,
	      cls: actionLinkObj.cls,
	      icon: actionLinkObj.icon,
	      disabled: actionLinkObj.disabled,
	      id: actionLinkObj.id,
	      url: actionLinkObj.url
	    });
	  }
	
	  function getActionUrl(actionLinkObj, rowData) {
	    var url = "";
	
	    if (actionLinkObj.cls === 'viewDetails') {
	      // create details page url
	      url = getDetailsUrl(rowData);
	    } else {
	      // use update display status url for mark InPorgres and Dismissed
	      url = updateDisplayStatusUrl;
	    }
	
	    return url;
	  }
	
	  function getDetailsUrl(rowData) {
	    var url = urlMap[rowData.objectType];
	
	    if (rowData.objectType === 'Order') {
	      url = url + '&orderId=' + rowData.objectId;
	    } else if (rowData.objectType === 'ASN') {
	      url = url + '&asnId=' + rowData.objectId;
	    }
	
	    return url;
	  }
	
	  // NOTE: call functon to initialize component and page here
	  init();
	});

/***/ },
/* 685 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var sampleFilterList = exports.sampleFilterList = [{
	  name: "Active Alerts",
	  filterBy: "all"
	  // href: "",
	  // uniqueClass: ""
	}, {
	  name: "Action Needed",
	  filterBy: "Action Needed"
	  // NOTE: optional parameters
	  // href: "",
	  // uniqueClass: ""
	}, {
	  name: "In Progress",
	  filterBy: "In Progress"
	  // NOTE: optional parameters
	  // href: "",
	  // uniqueClass: ""
	}, {
	  name: "Dismissed",
	  filterBy: "Dismissed"
	  // NOTE: optional parameters
	  // href: "",
	  // uniqueClass: ""
	}];

/***/ },
/* 686 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var statusOptions = exports.statusOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "Action Needed": [{
	    title: "View Details",
	    cls: "viewDetails",
	    icon: "chevron-right",
	    disabled: false
	  }, {
	    title: "Mark as In Progress",
	    cls: "markInProgress",
	    icon: "chevron-right",
	    disabled: false
	  }, {
	    title: "Mark as Dismissed",
	    cls: "markDismissed",
	    icon: "chevron-right",
	    disabled: false
	  }],
	  "In Progress": [{
	    title: "View Details",
	    cls: "viewDetails",
	    icon: "chevron-right",
	    disabled: false
	  }, {
	    title: "Mark as In Progress",
	    cls: "markInProgress",
	    icon: "chevron-right",
	    disabled: true
	  }, {
	    title: "Mark as Dismissed",
	    cls: "markInProgress",
	    icon: "chevron-right",
	    disabled: true
	  }],
	  "Dismissed": [{
	    title: "View Details",
	    cls: "viewDetails",
	    icon: "chevron-right",
	    disabled: false
	  }, {
	    title: "Mark as In Progress",
	    cls: "markInProgress",
	    icon: "chevron-right",
	    disabled: false
	  }, {
	    title: "Mark as Dismissed",
	    cls: "markDismissed",
	    icon: "chevron-right",
	    disabled: true
	  }]
	};

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(689);
	
	__webpack_require__(688);
	
	// Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	__webpack_require__(1118);

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#notification-preferences-detail", function () {
	  var el = (0, _jquery2.default)("#notification-preferences-detail");
	  notificationPreferenceDetail(el);
	});
	
	function notificationPreferenceDetail(el) {
	  var editPageUrl = el.data("edit-notification-preference-url");
	  var workOrderNotifcationConfig = el.data("workorder-notification-config");
	  var orderErrorNotifcationConfig = el.data("order-error-notification-config");
	
	  var els = {};
	  var elementsMap = {};
	}

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#notification-preferences-config-form", function () {
	  var el = (0, _jquery2.default)("#notification-preferences-config-form");
	  notificationPreferenceConfig(el);
	});
	
	function notificationPreferenceConfig(el) {
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var els = {};
	  var elementsMap = {
	    workOrderNotification: "#workOrderNotification",
	    orderErrorNotification: "#orderErrorNotification",
	    saveNotificationConfig: ".save-notification-preference",
	    saveNotificationModal: "#save-confirmation-modal",
	    inboundReceivingNotification: "#inboundReceivingNotifications",
	    inboundStatusCompleteNotification: "#inboundStatusCompleteNotification",
	    inboundAgingNotification: "#inboundAgingNotification",
	    bulkOrderUploadFailsNotification: "#bulkOrderUploadFailsNotification",
	    addressValidationFailureNotification: '#addressValidationFailureNotification',
	    transferOrderShippedNotification: "#transferOrderShippedNotification",
	    transferOrderReceivedNotification: '#transferOrderReceivedNotification',
	    saveNotificationConfigConfirmed: ".save-notification-preference-cofirmed",
	    inboundDiscrepanciesNotification: "#inboundDiscrepanciesNotification"
	  };
	  var saveURL = el.data("save-notification-preference-url");
	  var detailPageUrl = el.data("notification-preference-detail-url");
	  var workOrderNotifcationConfig = el.data("workorder-notification-config");
	  var orderErrorNotifcationConfig = el.data("order-error-notification-config");
	  var inboundReceivingNotificationConfig = el.data("inbound-receiving-notification-config");
	  var inboundCompleteNotifcationConfig = el.data("inbound-complete-notification-config");
	  var inboundAgingNotificationConfig = el.data("inbound-aging-notification-config");
	  var bulkOrderUploadFailsNotificationConfig = el.data("bulk-order-upload-fails-notification-config");
	  var orderAddressValidationFailureNotificationConfig = el.data("order-address-validation-failure-notification-config");
	  var transferOrderShippedNotificationConfig = el.data("transfer-order-shipped-notification-config");
	  var transferOrderReceivedNotificationConfig = el.data("transfer-order-received-notification-config");
	  var setWorkOrderToggleOn = el.data("workorder-notification-toggle-on-config");
	  var inboundDiscrepanciesNotificationConfig = el.data("inbound-discrepancies-notification-config");
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	  }
	
	  onLoad();
	
	  function onLoad() {
	    setElements();
	    setElementValue();
	  }
	
	  function setElementValue() {
	    els.orderErrorNotification.prop("checked", orderErrorNotifcationConfig);
	    els.inboundReceivingNotification.prop("checked", inboundReceivingNotificationConfig);
	    els.inboundStatusCompleteNotification.prop("checked", inboundCompleteNotifcationConfig);
	    els.inboundAgingNotification.prop("checked", inboundAgingNotificationConfig);
	    els.bulkOrderUploadFailsNotification.prop("checked", bulkOrderUploadFailsNotificationConfig);
	    els.addressValidationFailureNotification.prop("checked", orderAddressValidationFailureNotificationConfig);
	    els.transferOrderShippedNotification.prop("checked", transferOrderShippedNotificationConfig);
	    els.transferOrderReceivedNotification.prop("checked", transferOrderReceivedNotificationConfig);
	    els.inboundDiscrepanciesNotification.prop("checked", inboundDiscrepanciesNotificationConfig);
	    if (setWorkOrderToggleOn) {
	      els.workOrderNotification.prop("checked", true);
	      els.workOrderNotification.prop("disabled", true);
	    } else {
	      els.workOrderNotification.prop("checked", workOrderNotifcationConfig);
	    }
	  }
	
	  /*els.workOrderNotification.on("change", function(){
	  	console.log("workOrderNotification value " + els.workOrderNotification.prop("checked"));
	  });
	  
	  els.orderErrorNotification.on("change", function(){
	  	console.log("orderErrorNotification value " + els.orderErrorNotification.is(":checked"));
	  });*/
	
	  els.saveNotificationConfig.on("click", function (e) {
	    e.preventDefault();
	    (0, _jquery2.default)("#save-confirmation-modal").appendTo("body").modal("show");
	  });
	
	  (0, _jquery2.default)(".save-notification-preference-cofirmed").on("click", function (e) {
	    save({ url: saveURL, success: saveSuccess, error: saveError });
	  });
	
	  function save(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error;
	
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      data: new FormData((0, _jquery2.default)('#notification-preferences-config-form').get(0)),
	      url: url,
	      processData: false,
	      contentType: false,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function saveSuccess(data) {
	    if (data.response == "success") {
	      _EditChecker2.default.setPageClean();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        location.href = '' + detailPageUrl;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function saveError() {
	    submitModalFlow.hideAllModals();
	  }
	}

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(691);

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#oauth-redirect-page", function () {
	  var oAuthRedirectPage = (0, _jquery2.default)("#oauth-redirect-page");
	  var success = oAuthRedirectPage.data("success");
	
	  localStorage.setItem("connectionStatus", success);
	});

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(693);
	
	__webpack_require__(694);

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _utilities = __webpack_require__(212);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#order-config", function () {
	  var el = (0, _jquery2.default)("#order-config");
	  orderConfiguration(el);
	}); // Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	//require("../stubs/orderConfiguration/orderConfiguration.less");
	
	function orderConfiguration(el) {
	  var internalOrderGracePeriod = el.data("detail-internal-order-domain");
	  var channelOrderGracePeriod = el.data("detail-channel-order-domain");
	  var defaultAddressValidationLevelsList = el.data("detail-default-address-validation-levels");
	  var defaultDomesticShippingMethodsList = el.data("detail-default-domestic-shipping-methods");
	  var internationalOrdersSectionData = el.data("international-orders-domain");
	  var productValuesList = el.data("product-values");
	  var rtlAddressValidationLevel = el.data("retailer-address-validation-level");
	  var rtlDefaultShippingMethod = el.data("retailer-default-shipping-method");
	  var orderSplit = el.data("order-split");
	  var orderInsufficientInventory = el.data("order-insufficient-inventory");
	  var saveURL = el.data("save-order-configuration-url");
	  var detailPageUrl = el.data("order-configuration-detail-url");
	  var orderDeclaredValue = el.data("order-declared-value");
	
	  var els = {};
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var elementsMap = {
	
	    defaultShippingMethodSelect: "#default-shipping-method-select",
	    defaultAddressValidationLevelSelect: "#address-validation-level-select",
	    addresslevel1text: "#addresslevel1text",
	    addresslevel2text: "#addresslevel2text",
	    addresslevel0text: "#addresslevel0text",
	
	    orderSplitting: "#orderSplitting",
	    insufficientInventory: "#insufficientInventory",
	    internalGracePeriodHours: ".internalGracePeriodHours",
	    internalGracePeriodMinutes: ".internalGracePeriodMinutes",
	    interalOrderCutOffTime: "#interalOrderCutOffTime",
	
	    channelGracePeriodHours: ".channelGracePeriodHours",
	    channelGracePeriodMinutes: ".channelGracePeriodMinutes",
	    channelOrderCutOffTime: "#channelOrderCutOffTime",
	
	    internalGracePeriodContainer: ".internalGracePeriodContainer",
	    channelGracePeriodContainer: ".channelGracePeriodContainer",
	
	    saveOrderConfigModalShow: ".save-order-config",
	    saveConfirmationModal: ".save-confirmation-modal",
	    saveOrderConfig: ".save-order-config-cofirmed",
	
	    errorModal: ".errorModal",
	
	    addressValidationValueHidden: "#display-address-validation-text",
	    addressValidationTextHidden: "#display-address-validation-text-meaning",
	    shippingMethodValueHidden: "#display-shipping-method-text",
	    shippingMethodTextHidden: "#display-shipping-method-text-meaning",
	
	    internationalShipping: "#internationalShipping",
	    einNumber: "#einNumber",
	    productValueSelect: "#productValue",
	
	    orderDeclaredValueToggleSwitch: "#order-declared-value-switch",
	    declaredValue: ".declared-value"
	
	  };
	
	  el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        (0, _jquery2.default)(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    },
	    rules: {
	      einNumber: {
	        minlength: 10
	      }
	    },
	    messages: {
	      einNumber: {
	        minlength: "Please enter at least 9 characters."
	      }
	    }
	  });
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	  }
	
	  onLoad();
	
	  function onLoad() {
	    setElements();
	    setOrderSplittingConfig();
	    setOrderInsufficientInventoryConfig();
	    setInternalGracePeriod();
	    setChannelOrderGracePeriod();
	    setInternationalOrderConfig();
	    setDeclaredValueOrderConfig();
	  }
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: els.defaultShippingMethodSelect,
	    list: defaultDomesticShippingMethodsList,
	    valueDataKey: "cdmValue",
	    textDataKey: "cdmMeaning",
	    initialSelectValue: function initialSelectValue() {
	      return rtlDefaultShippingMethod.cdmValue || /fdx_ground_home_delivery/i;
	    }
	  });
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: els.defaultAddressValidationLevelSelect,
	    list: defaultAddressValidationLevelsList,
	    valueDataKey: "cdmValue",
	    textDataKey: "cdmMeaning",
	    initialSelectValue: function initialSelectValue() {
	      return rtlAddressValidationLevel.cdmValue || /level2/i;
	    }
	  });
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: els.productValueSelect,
	    list: productValuesList,
	    valueDataKey: "cdmValue",
	    textDataKey: "cdmMeaning",
	    initialSelectValue: function initialSelectValue() {
	      return internationalOrdersSectionData.productValue || /""/i;
	    }
	  });
	
	  setAddressValidationTextOnChange(els.defaultAddressValidationLevelSelect.val());
	  setShippingMethodTextOnChange(els.defaultShippingMethodSelect.val(), els.defaultShippingMethodSelect.text());
	
	  els.defaultAddressValidationLevelSelect.on('change', function () {
	    setAddressValidationTextOnChange(this.value);
	  });
	
	  function setAddressValidationTextOnChange(val) {
	    /* alert(val);
	     if(rgxTest(/level1/i, val)){
	       els.addresslevel1text.show();
	       els.addresslevel2text.hide();
	     }else{
	       els.addresslevel1text.hide();
	       els.addresslevel2text.show();
	     }*/
	    if (val == 'Level1') {
	      els.addresslevel1text.show();
	      els.addresslevel2text.hide();
	      els.addresslevel0text.hide();
	    } else if (val == 'Level2') {
	      els.addresslevel1text.hide();
	      els.addresslevel2text.show();
	      els.addresslevel0text.hide();
	    } else {
	      els.addresslevel1text.hide();
	      els.addresslevel0text.show();
	      els.addresslevel2text.hide();
	    }
	  }
	
	  els.defaultShippingMethodSelect.on('change', function () {
	    setShippingMethodTextOnChange(this.value, (0, _jquery2.default)('option:selected', (0, _jquery2.default)(this)).text());
	  });
	
	  function setShippingMethodTextOnChange(val, text) {
	    els.shippingMethodValueHidden.val(val);
	    els.shippingMethodTextHidden.val(text);
	  }
	
	  function setOrderSplittingConfig() {
	    if (orderSplit.cdmValue == 1) {
	      els.orderSplitting.val("1");
	    } else {
	      els.orderSplitting.val("0");
	    }
	  }
	
	  function setInternationalOrderConfig() {
	    els.einNumber.val(internationalOrdersSectionData.einNumber);
	    if (internationalOrdersSectionData.shippingFlag === true) {
	      els.internationalShipping.prop('checked', true);
	    }
	  }
	
	  function setOrderInsufficientInventoryConfig() {
	    if (orderInsufficientInventory.cdmValue == 1) {
	      els.insufficientInventory.val("1");
	    } else {
	      els.insufficientInventory.val("0");
	    }
	  }
	
	  function setInternalGracePeriod() {
	    var hours = "";
	    var minutes = "";
	    if (!(typeof internalOrderGracePeriod.cdmValue === "undefined") || !internalOrderGracePeriod.cdmValue === "") {
	      hours = parseInt(internalOrderGracePeriod.cdmValue / 60);
	      minutes = internalOrderGracePeriod.cdmValue % 60;
	      els.internalGracePeriodHours.val(hours);
	      els.internalGracePeriodMinutes.val(minutes);
	      els.interalOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
	      if (hours == 18) {
	        minutes = 0;
	        els.internalGracePeriodMinutes.val(minutes);
	        els.interalOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
	      }
	
	      if (minutes > 0 && hours == 18) {
	        hours = 17;
	        els.internalGracePeriodHours.val(hours);
	        els.interalOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
	      }
	    } else {
	      hours = 0;
	      minutes = 0;
	      els.internalGracePeriodHours.val(hours);
	      els.internalGracePeriodMinutes.val(minutes);
	      els.interalOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
	    }
	  }
	
	  function setChannelOrderGracePeriod() {
	    var hours = "";
	    var minutes = "";
	    if (!(typeof channelOrderGracePeriod.cdmValue === "undefined") || !channelOrderGracePeriod.cdmValue === "") {
	      hours = parseInt(channelOrderGracePeriod.cdmValue / 60);
	      minutes = channelOrderGracePeriod.cdmValue % 60;
	      els.channelGracePeriodHours.val(hours);
	      els.channelGracePeriodMinutes.val(minutes);
	      els.channelOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
	
	      if (hours == 18) {
	        minutes = 0;
	        els.channelGracePeriodMinutes.val(minutes);
	        els.channelOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
	      }
	
	      if (minutes > 0 && hours == 18) {
	        hours = 17;
	        els.channelGracePeriodMinutes.val(minutes);
	        els.channelOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
	      }
	    } else {
	      hours = 0;
	      minutes = 0;
	      els.channelGracePeriodHours.val(hours);
	      els.channelGracePeriodMinutes.val(minutes);
	      els.channelOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
	    }
	  }
	
	  els.saveOrderConfigModalShow.on("click", function (e) {
	    e.preventDefault();
	    if (!el.valid()) {
	      return;
	    } else {
	      setValueForHiddenVariables();
	      (0, _jquery2.default)("#save-confirmation-modal").appendTo("body").modal("show");
	    }
	  });
	
	  function setValueForHiddenVariables() {
	    els.addressValidationValueHidden.val("");
	    els.addressValidationTextHidden.val("");
	    els.shippingMethodValueHidden.val("");
	    els.shippingMethodTextHidden.val("");
	
	    els.addressValidationValueHidden.val(els.defaultAddressValidationLevelSelect.find("option:selected").val());
	    els.addressValidationTextHidden.val(els.defaultAddressValidationLevelSelect.find("option:selected").text());
	    els.shippingMethodValueHidden.val(els.defaultShippingMethodSelect.find("option:selected").val());
	    els.shippingMethodTextHidden.val(els.defaultShippingMethodSelect.find("option:selected").text());
	  }
	
	  els.einNumber.inputmask({ mask: '99-9999999', jitMasking: true });
	
	  (0, _jquery2.default)(".save-order-config-cofirmed").on("click", function (e) {
	    e.preventDefault();
	    save({ url: saveURL, success: saveSuccess, error: saveError });
	  });
	
	  function save(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error;
	
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      data: new FormData((0, _jquery2.default)('#order-config').get(0)),
	      url: url,
	      processData: false,
	      contentType: false,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function saveSuccess(data) {
	    if (data.response == "success") {
	      _EditChecker2.default.setPageClean();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        location.href = '' + detailPageUrl;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function saveError() {
	    submitModalFlow.hideAllModals();
	  }
	
	  els.internalGracePeriodContainer.on('change', function (e) {
	    e.preventDefault();
	    setInternalCutOffTimeDynamically();
	  });
	
	  function setInternalCutOffTimeDynamically() {
	    els.interalOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(els.internalGracePeriodHours.val(), els.internalGracePeriodMinutes.val()));
	  }
	
	  els.channelGracePeriodContainer.on('change', function (e) {
	    e.preventDefault();
	    setChannelCutOffTimeDynamically();
	  });
	
	  function setChannelCutOffTimeDynamically() {
	    els.channelOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(els.channelGracePeriodHours.val(), els.channelGracePeriodMinutes.val()));
	  }
	
	  function setDeclaredValueOrderConfig() {
	    (0, _instantiateSwitchery.instantiateSwitchery)(els.orderDeclaredValueToggleSwitch);
	    if (orderDeclaredValue.cdmValue === "1") {
	      (0, _instantiateSwitchery.setSwitchery)(els.orderDeclaredValueToggleSwitch, true);
	    } else {
	      (0, _instantiateSwitchery.setSwitchery)(els.orderDeclaredValueToggleSwitch, false);
	    }
	  }
	}

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _utilities = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Directly reference and pull in styling from stub,
	// that is commented out in production to elimited 'fake'
	// stub javascript while having single source of truth for LESS
	//require("../stubs/orderConfigurationDetail/orderConfigurationDetail.less");
	
	(0, _run2.default)("#order-config-detail", function () {
		var el = (0, _jquery2.default)("#order-config-detail");
		orderConfigurationDetail(el);
	});
	
	function orderConfigurationDetail(el) {
		var internalOrderGracePeriod = el.data("detail-internal-order-domain");
		var channelOrderGracePeriod = el.data("detail-channel-order-domain");
		var defaultAddressValidationLevels = el.data("detail-default-address-validation-levels");
		var defaultDomesticShippingMethods = el.data("detail-default-domestic-shipping-methods");
		var rtlAddressValidationLevel = el.data("retailer-address-validation-level");
		var rtlDefaultShippingMethod = el.data("retailer-default-shipping-method");
		var orderSplit = el.data("order-split");
		var orderInsufficientInventory = el.data("order-insufficient-inventory");
		var els = {};
	
		var elementsMap = {
			internalGracePeriodHours: ".internalGracePeriodHours",
			internalGracePeriodMinutes: ".internalGracePeriodMinutes",
			interalOrderCutOffTime: "#interalOrderCutOffTime",
	
			channelGracePeriodHours: ".channelGracePeriodHours",
			channelGracePeriodMinutes: ".channelGracePeriodMinutes",
			channelOrderCutOffTime: "#channelOrderCutOffTime"
	
		};
	
		function setElements() {
			(0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
		}
	
		onLoad();
	
		function onLoad() {
			setElements();
			setInternalGracePeriod();
			setChannelOrderGracePeriod();
		}
	
		function setInternalGracePeriod() {
			var hours = "";
			var minutes = "";
			if (!(typeof internalOrderGracePeriod.cdmValue === "undefined") || !internalOrderGracePeriod.cdmValue === "") {
				hours = parseInt(internalOrderGracePeriod.cdmValue / 60);
				minutes = internalOrderGracePeriod.cdmValue % 60;
				els.internalGracePeriodHours.text(hours);
				els.internalGracePeriodMinutes.text(minutes);
				els.interalOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
				if (hours == 18) {
					minutes = 0;
					els.internalGracePeriodMinutes.text(minutes);
					els.interalOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
				}
	
				if (minutes > 0 && hours == 18) {
					hours = 17;
					els.internalGracePeriodHours.text(hours);
					els.interalOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
				}
			} else {
				hours = 0;
				minutes = 0;
				els.internalGracePeriodHours.text(hours);
				els.internalGracePeriodMinutes.text(minutes);
				els.interalOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
			}
		}
	
		function setChannelOrderGracePeriod() {
			var hours = "";
			var minutes = "";
			if (!(typeof channelOrderGracePeriod.cdmValue === "undefined") || !channelOrderGracePeriod.cdmValue === "") {
				hours = parseInt(channelOrderGracePeriod.cdmValue / 60);
				minutes = channelOrderGracePeriod.cdmValue % 60;
				els.channelGracePeriodHours.text(hours);
				els.channelGracePeriodMinutes.text(minutes);
				els.channelOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
	
				if (hours == 18) {
					minutes = 0;
					els.channelGracePeriodMinutes.text(minutes);
					els.channelOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
				}
	
				if (minutes > 0 && hours == 18) {
					hours = 17;
					els.channelGracePeriodMinutes.text(minutes);
					els.channelOrderCutOffTime.text((0, _utilities.calculateCutOffTime)(hours, minutes));
				}
			}
		}
	}

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	__webpack_require__(1094);
	
	var targetSelector = ".order-hold-rule-detail";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  var els = {};
	
	  var posLocations = mainEl.data("pos-locations");
	
	  var releaseRuleUrl = mainEl.data("release-rule-url");
	
	  var elsMap = {
	    releaseRuleBtn: ".release-rule-btn",
	    posLocationDiv: ".pos-location-codes"
	  };
	
	  function init() {
	    setElements();
	    bindElements();
	    setValues();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	  }
	
	  function bindElements() {
	    els.releaseRuleBtn.on("click", releaseRule);
	  }
	
	  function setValues() {
	    if (posLocations) {
	      var posValues = posLocations.toString().split(",");
	
	      var htmlOutput = posValues.map(function (val) {
	        return "<div>" + val.trim() + "</div>";
	      }).join("");
	
	      els.posLocationDiv.html(htmlOutput);
	    }
	  }
	
	  function releaseRule(e) {
	    e.preventDefault();
	    releaseRuleModalFlow.showConfirmModal();
	  }
	
	  var releaseRuleModalFlow = new _SubmitModalFlow2.default({
	    confirmModalTitle: "Release Rule(s)",
	    modalDialogClass: "q-modal-dialog-500",
	    confirmModalBody: "<div class=\"q-marg-all-xl\">\n                             <div class=\"q-marg-vert-md\">\n                               Confirming the manual release of this rule(s) will trigger it's original release schedule, if applicable, to reset and to be released at the current time.\n                             </div>\n                             <div class=\"q-marg-vert-md\">\n                               Once released, all orders impacted by this rule(s) will begin to be processed. \n                             </div>\n                           </div>",
	    confirmModalBtnText: "Release",
	    onConfirmClick: function onConfirmClick() {
	      releaseRuleModalFlow.showLoadingModal();
	      releaseRules();
	      function releaseRules() {
	        $.ajax({
	          url: releaseRuleUrl,
	          type: "POST",
	          dataType: "JSON",
	          success: function success(data) {
	            if (data.response == "success") {
	              releaseRuleModalFlow.showSuccessModal();
	              location.reload();
	            } else {
	              releaseRuleModalFlow.showFailureModal();
	            }
	          },
	          error: function error(data) {
	            releaseRuleModalFlow.hideAllModals();
	          }
	        });
	      }
	    }
	  });
	
	  releaseRuleModalFlow.init();
	
	  init();
	});

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _datePicker = __webpack_require__(114);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _select2able = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	var targetSelector = ".order-hold-rule-new-edit";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  var els = {};
	  var elsMap = {
	    ruleIdEl: ".rule-id",
	    ruleSkuEl: ".rule-sku",
	    ruleOrderTypeEl: ".rule-order-type",
	    rulePosLocationEl: ".rule-pos-location",
	    ruleReleaseDateEl: ".rule-release-date",
	    ruleReleaseTimeEl: ".rule-release-time",
	    saveReleaseRuleBtn: ".save-release-rule-btn",
	    cancelReleaseRuleBtn: ".cancel-release-rule-btn",
	    duplicateRuleAlert: ".duplicate-rule-alert",
	    duplicateRuleAlertLink: ".duplicate-rule-alert-link"
	  };
	
	  var submitRuleUrl = mainEl.data("submit-rule-url");
	  var cancelRuleLookupUrl = mainEl.data("cancel-rule-lookup-url");
	  var cancelRuleDetailsUrl = mainEl.data("cancel-rule-details-url");
	  var ruleData = mainEl.data("rule-data");
	  var ruleReleaseTimePickerEl = void 0;
	  var formValidator = void 0;
	
	  function init() {
	    (0, _datePicker2.default)($('.rules-datepicker'));
	    setElements();
	    bindElements();
	    initTimePicker();
	    setValuesIfEdit();
	    setValidator();
	  }
	
	  function setValuesIfEdit() {
	    if (ruleData) {
	      els.ruleSkuEl.val(ruleData.sku);
	      els.ruleOrderTypeEl.val(ruleData.orderType).trigger('change');
	      els.ruleReleaseDateEl.val(ruleData.releaseDate);
	
	      if (ruleData.posLocation) {
	        var values = ruleData.posLocation.split(",");
	        var optionsHtml = values.map(function (value) {
	          return "<option value=\"" + value + "\">" + value + "</option>";
	        }).join("");
	        els.rulePosLocationEl.html(optionsHtml);
	
	        els.rulePosLocationEl.val(values);
	      }
	
	      var releaseDateTime = (0, _moment2.default)(ruleData.releaseDate + " " + ruleData.releaseTime, 'MM/DD/YYYY hh:mm A');
	      ruleReleaseTimePickerEl.setTimeFromMilitary(releaseDateTime.format("HH:mm"));
	    }
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	  }
	
	  function bindElements() {
	    els.saveReleaseRuleBtn.on("click", saveReleaseRule);
	    els.cancelReleaseRuleBtn.on("click", cancelReleaseRule);
	  }
	
	  function setValidator() {
	    formValidator = mainEl.find('#rule-form').validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	    formValidator.settings.ignore = ":disabled,:hidden";
	  }
	
	  function cancelReleaseRule(e) {
	    e.preventDefault();
	    if (ruleData) {
	      window.location.href = cancelRuleDetailsUrl + "&cbrId=" + ruleData.ruleId;
	    } else {
	      window.location.href = cancelRuleLookupUrl;
	    }
	  }
	
	  function saveReleaseRule(e) {
	    e.preventDefault();
	    if (mainEl.find('#rule-form').valid()) {
	      saveReleaseRuleModalFlow.showConfirmModal();
	    }
	  }
	
	  var saveReleaseRuleModalFlow = new _SubmitModalFlow2.default({
	    confirmModalTitle: "Save Rule",
	    modalDialogClass: "q-modal-dialog-500",
	    confirmModalBody: "<div class=\"q-marg-all-xl\">\n                         Once this rule is saved it will be held until the rule meets it's specified release time, or is manually released.\n                       </div>",
	    confirmModalBtnText: "Save",
	    onConfirmClick: function onConfirmClick() {
	      saveReleaseRuleModalFlow.showLoadingModal();
	      els.duplicateRuleAlert.hide();
	
	      var data = generateSubmitData();
	      submitRule(data);
	
	      function submitRule(data, rule) {
	        $.ajax({
	          url: submitRuleUrl,
	          type: "POST",
	          dataType: "JSON",
	          data: data,
	          success: function success(data) {
	            if (data.response == "success") {
	              saveReleaseRuleModalFlow.showSuccessModal();
	              window.location.href = cancelRuleDetailsUrl + "&cbrId=" + data.ruleId;
	            } else if (data.response == "exists") {
	              saveReleaseRuleModalFlow.hideAllModals();
	              els.duplicateRuleAlert.show();
	              els.duplicateRuleAlertLink.attr("href", cancelRuleDetailsUrl + "&cbrId=" + data.ruleId);
	            } else {
	              saveReleaseRuleModalFlow.showFailureModal();
	            }
	          },
	          error: function error(data) {
	            saveReleaseRuleModalFlow.hideAllModals();
	          }
	        });
	      }
	    }
	  });
	
	  function generateSubmitData() {
	    var data = {};
	
	    data.ruleId = els.ruleIdEl.val();
	    data.sku = els.ruleSkuEl.val();
	    data.orderType = els.ruleOrderTypeEl.val();
	    data.posLocation = els.rulePosLocationEl.val().join(",");
	    data.releaseDate = els.ruleReleaseDateEl.val();
	
	    var time = ruleReleaseTimePickerEl.getMilitaryTime();
	    if (time != "Invalid date") {
	      data.releaseTime = time;
	    }
	
	    return data;
	  }
	
	  saveReleaseRuleModalFlow.init();
	
	  function initTimePicker() {
	    ruleReleaseTimePickerEl = new _timePicker2.default(els.ruleReleaseTimeEl);
	  }
	
	  init();
	});

/***/ },
/* 697 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  "all": [{
	    title: "Release Rule",
	    cls: "bulk-release-rule",
	    icon: "hourglass",
	    disabled: false
	  }],
	  "actions": [{
	    title: "Release Rule",
	    cls: "release-rule",
	    icon: "hourglass",
	    disabled: false
	  }]
	};

/***/ },
/* 698 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var rulesLookupFieldDropdown = exports.rulesLookupFieldDropdown = [{
		title: "By Product Sku",
		value: "Sku"
	}, {
		title: "By Channel",
		value: "OrderType"
	}, {
		title: "By POS Location",
		value: "PosLocation"
	}];

/***/ },
/* 699 */
[1582, 700],
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _rulesLookupFieldDropdown = __webpack_require__(698);
	
	var _actionOptions = __webpack_require__(697);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var detailLinkTemplate = __webpack_require__(1366);
	var actionList = _actionOptions.actionOptions;
	
	var targetSelector = "#lookup-order-hold-rules";
	
	(0, _run2.default)(targetSelector, function () {
	  var entryElement = $(targetSelector);
	  var dataTableComponentData = entryElement.data("rules-data");
	
	  var viewRulesDetailURL = entryElement.data("view-details-url");
	  var filterSearchUrl = entryElement.data("filter-search-url");
	  var releaseUrl = entryElement.data("release-url");
	  var updateRuleUrl = entryElement.data("update-url");
	  var generateExportUrl = entryElement.data("export-url");
	  var bulkReleaseRuleUrl = entryElement.data("bulk-release-rule-url");
	
	  var shouldCheckCache = entryElement.data("should-check-cache");
	
	  var savedViews = entryElement.data("saved-views");
	  var saveViewURL = entryElement.data("save-view-url");
	  var deleteViewURL = entryElement.data("delete-view-url");
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  var exportModal = new _filtersutil.buildExport();
	
	  var criteriaObjectFromServer = entryElement.data("filter-criteria-from-server");
	  var targetObject = "";
	  var totalRecordCount = 0;
	  var lookupFieldDropdown = _rulesLookupFieldDropdown.rulesLookupFieldDropdown;
	  var selectedRows = "";
	
	  //Need to map back from ruleAttr to specific key
	  if (shouldCheckCache) {
	    var key = (0, _filtersutil.retriveCriteriaObjectByKey)(criteriaObjectFromServer, "ruleAttrKey");
	    var value = (0, _filtersutil.retriveCriteriaObjectByKey)(criteriaObjectFromServer, "ruleAttrVal");
	
	    if (key && value) {
	      targetObject = {
	        key: key.value[0],
	        value: value.value,
	        operation: value.operation
	      };
	    }
	  }
	
	  if (_.has(dataTableComponentData, "page")) {
	    totalRecordCount = dataTableComponentData.page.totalElements;
	  }
	
	  function createDetailLink(data, type, row) {
	    var newRender = void 0;
	
	    newRender = (0, _render2.default)(detailLinkTemplate, {
	      id: row.ruleId,
	      name: row.ruleId,
	      url: viewRulesDetailURL
	    });
	    return newRender;
	  }
	
	  var ruleLookup = new _index2.default({
	    // REQUIRED - Set a target element
	    target: $("#order-hold-rules-table-wrapper"),
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: [{
	      data: "ruleId",
	      title: "Release Rule ID",
	      render: createDetailLink
	    }, {
	      data: "sku",
	      title: "Product SKU"
	    }, {
	      data: "orderType",
	      title: "Channel"
	    }, {
	      data: "posLocation",
	      title: "POS Location"
	    }, {
	      data: "releaseDate",
	      title: "Release Schedule"
	    }],
	    // tableFilters: {
	    //    data: orderFilterData,
	    //  },
	    tableSearch: true,
	    // REQUIRED: search input info
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: targetObject != "" ? targetObject.value[0] : ""
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: lookupFieldDropdown
	    },
	    newSavedViews: false,
	    // OPTIONAL: Set Saved View Array
	    savedViews: savedViews,
	    bulkSelect: true,
	    // REQUIRED - Data Table specific settings
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      // Not required, just to show you can
	      columnDefs: [{}],
	      // Not required, just to show you can
	      order: [[2, "desc"]],
	      columns: [{
	        data: "ruleId",
	        render: renderActionWrap,
	        orderable: false,
	        class: "dtc-action-column",
	        title: "Actions"
	      }, {
	        data: "ruleId",
	        title: "Release Rule ID",
	        render: createDetailLink,
	        class: "dtc-min-width-sm"
	      }, {
	        data: "sku",
	        orderable: false,
	        title: "Product SKU",
	        class: "dtc-min-width-md"
	      }, {
	        data: "orderType",
	        orderable: false,
	        title: "Channel",
	        class: "dtc-min-width-md"
	      }, {
	        data: "posLocation",
	        orderable: false,
	        title: "POS Location",
	        class: "dtc-min-width-md"
	      }, {
	        data: "releaseDate",
	        title: "Release Schedule",
	        class: "dtc-min-width-md"
	      }]
	    },
	    //  tableColumnModal: {
	    //	data: ruleLookupColumnsPopup
	    //},
	    paginationData: dataTableComponentData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Order Hold Rules",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "orderHold"
	    },
	    onBulkSelectChange: function onBulkSelectChange() {
	      selectedRows = ruleLookup.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass("disabled");
	      } else {
	        $(".action-header-btn .base-btn").addClass("disabled");
	      }
	    },
	    onFetch: function onFetch() {
	      var currentData = ruleLookup.generateData();
	      ruleLookup.showLoadingOverlay();
	
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({
	            url: filterSearchUrl,
	            success: filterSuccessFun,
	            error: errorFun,
	            data: (0, _filtersutil.prepareDataToSendController)(currentData)
	          });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({
	            url: saveViewURL,
	            success: savedViewSuccess,
	            error: errorFun,
	            data: (0, _filtersutil.prepareDataToSendController)(currentData)
	          });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({
	            url: saveViewURL,
	            success: savedEditViewSuccess,
	            error: errorFun,
	            data: (0, _filtersutil.prepareDataToSendController)(currentData)
	          });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({
	            url: deleteViewURL,
	            success: delteViewScussFun,
	            error: errorFun,
	            data: (0, _filtersutil.prepareDataToSendController)(currentData)
	          });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  function filterSuccessFun(data) {
	    var rules = data.content;
	    var page = data.page;
	    ruleLookup.setNewData(rules);
	    ruleLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    totalRecordCount = page.totalElements;
	    ruleLookup.hideLoadingOverlay();
	    setExportData(ruleLookup.generateData());
	    //$(".data-table-component").DataTable().columns('.status-column').visible( false );
	  }
	
	  function savedViewSuccess(data) {
	    var rules = data.lookupRuleJSON.content;
	    var page = data.lookupRuleJSON.page;
	    ruleLookup.setNewData(rules);
	    ruleLookup.setPaginationData(page);
	    ruleLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    totalRecordCount = page.totalElements;
	    ruleLookup.hideLoadingOverlay();
	    setExportData(ruleLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var rules = data.lookupRuleJSON.content;
	    var page = data.lookupRuleJSON.page;
	    ruleLookup.setNewData(rules);
	    ruleLookup.setPaginationData(page);
	    ruleLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    totalRecordCount = page.totalElements;
	    ruleLookup.hideLoadingOverlay();
	    setExportData(ruleLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var rules = data.lookupRuleJSON.content;
	    var page = data.lookupRuleJSON.page;
	    ruleLookup.removeSavedView(data.target);
	    ruleLookup.setNewData(rules);
	    ruleLookup.setPaginationData(page);
	    totalRecordCount = page.totalElements;
	    ruleLookup.hideLoadingOverlay();
	    setExportData(ruleLookup.generateData());
	  }
	
	  function errorFun(data) {
	    ruleLookup.hideLoadingOverlay();
	  }
	
	  ruleLookup.init();
	
	  //const ordersDataTableObj = $("#lookup-order-wrapper .data-table-component").dataTable();
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    var statusTarget = actionList["all"];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, item));
	    });
	    return renderedList.join("");
	  }
	
	  function neededActions(data, row, item) {
	    var action = {
	      icon: item.icon,
	      title: item.title,
	      cls: item.cls,
	      disabled: item.disabled
	    };
	    return action;
	  }
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  $("body").on("click", ".release-rule", function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      // Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
	      var pIndex = $(this).closest(".dropdown-menu").data("parent-index");
	      // Get the row based on the parent...
	      var parent = $(".dropdown-parent-" + pIndex).parents("tr");
	      // Get the row data
	      var row = $(".data-table-component").dataTable().api().row(parent);
	
	      if ($(this).hasClass("release-rule")) {
	        processReleaseRule(row);
	      }
	    }
	  });
	
	  function processReleaseRule(row) {
	    var submitModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: "Release Rule(s)",
	      confirmModalBody: "<div class=\"q-marg-all-xl\">\n                          <div class=\"q-marg-vert-md\">\n                            Confirming the manual release of this rule(s) will trigger it's original release schedule, if applicable, to reset and to be released at the current time.\n                          </div>\n                          <div class=\"q-marg-vert-md\">\n                            Once released, all orders impacted by this rule(s) will begin to be processed. \n                          </div>\n                        </div>",
	      confirmModalBtnText: "Release",
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        submitModal.showLoadingModal();
	        var data = row.data();
	        releaseRule(row, data);
	
	        function releaseRule(row, rule) {
	          $.ajax({
	            url: releaseUrl,
	            type: "POST",
	            dataType: "JSON",
	            data: {
	              ruleId: rule.ruleId
	            },
	            success: function success(data) {
	              if (data.response == "success") {
	                var d = row.data();
	                d.releaseDate = data.cbrEffectiveEndDate;
	                row.data(d).draw();
	                submitModal.showSuccessModal();
	                setTimeout(function () {
	                  submitModal.hideAllModals();
	                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	              } else {
	                submitModal.showFailureModal();
	              }
	            },
	            error: function error(data) {
	              submitModal.hideAllModals();
	            }
	          });
	        }
	      }
	    });
	    submitModal.init();
	    submitModal.showConfirmModal();
	  }
	
	  $("body").on("click", ".bulk-release-rule", function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: "Release Rule(s)",
	        confirmModalBody: "<div class=\"q-marg-all-xl\">\n                            <div class=\"q-marg-vert-md\">\n                              Confirming the manual release of this rule(s) will trigger it's original release schedule, if applicable, to reset and to be released at the current time.\n                            </div>\n                            <div class=\"q-marg-vert-md\">\n                              Once released, all orders impacted by this rule(s) will begin to be processed. \n                            </div>\n                          </div>",
	        confirmModalBtnText: "Release",
	        onConfirmClick: function onConfirmClick() {
	          submitModalFlow.showLoadingModal();
	          releaseRules();
	          function releaseRules() {
	            $.ajax({
	              url: bulkReleaseRuleUrl,
	              type: "POST",
	              dataType: "JSON",
	              data: _defineProperty({}, "ruleIds", getAllSelectedRuleIds()),
	              success: function success(data) {
	                if (data.response == "success") {
	                  _(selectedRows).map(function (item) {
	                    var currentRow = $(".data-table-component").DataTable().row(item.rowIndex);
	                    var d = currentRow.data();
	                    d.releaseDate = data.releaseDate;
	                    currentRow.data(d).draw();
	                  });
	                  ruleLookup.uncheckAllSelected();
	                  submitModalFlow.showSuccessModal();
	                  setTimeout(function () {
	                    submitModalFlow.hideAllModals();
	                  }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                } else {
	                  submitModalFlow.showFailureModal();
	                }
	              },
	              error: function error(data) {
	                submitModalFlow.hideAllModals();
	              }
	            });
	          }
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  });
	
	  function getAllSelectedRuleIds() {
	    var ruleIds = new Array();
	    _(selectedRows).map(function (item) {
	      ruleIds.push(item.data.ruleId);
	    });
	
	    return ruleIds;
	  }
	
	  function initExport() {
	    var exportObj = {
	      title: $(targetSelector).data("export-popup-title"),
	      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
	      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
	    };
	
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent();
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(generateExportUrl, currentData);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  initExport();
	  setExportData(ruleLookup.generateData());
	
	  // Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information...
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jumpToWizardLogic = __webpack_require__(70);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var targetSelector = "#orderType-detail-page";
	
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	    var updateOrderTypeStatusUrl = mainEl.data("updateOrderTypeStatusUrl");
	    var orderTypeDetailsUrl = mainEl.data("orderTypeDetailsUrl");
	    var duplicaterOrderTypeUrl = mainEl.data("duplicate-ordertype-url");
	
	    (0, _jumpToWizardLogic.bindJumpToWizardLinks)();
	
	    $("body").on("click", "#duplicate-btn", function (e) {
	        window.location.href = duplicaterOrderTypeUrl + "&isDup=true";
	    });
	
	    $('body').on('click', '#activate-deactivate-btn', function (e) {
	
	        e.preventDefault();
	        if ((0, _general.shallAllowClick)(this)) {
	            var submitModalFlow = null;
	            var orderTypeStatus = $(this).data('orderTypeStatus');
	            if (orderTypeStatus == 'active') {
	                submitModalFlow = new SubmitModalFlow({
	                    confirmModalTitle: 'Deactivate Order Type',
	                    confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this order type will no longer be available when creating orders. It can be activated at any time.</div>',
	                    confirmModalBtnText: 'Deactivate',
	                    onConfirmClick: function onConfirmClick() {
	                        submitModalFlow.showLoadingModal();
	                        updateOrderTypeStatus(submitModalFlow);
	                    }
	                });
	            } else {
	                submitModalFlow = new SubmitModalFlow({
	                    confirmModalTitle: 'Activate Order Type',
	                    confirmModalBody: '<div class="q-pad-all-xl">Once activated, this order type will continue to be available when creating orders. It can be deactivated at any time.</div>',
	                    confirmModalBtnText: 'Activate',
	                    onConfirmClick: function onConfirmClick() {
	                        submitModalFlow.showLoadingModal();
	                        updateOrderTypeStatus(submitModalFlow);
	                    }
	                });
	            }
	            submitModalFlow.init();
	            submitModalFlow.showConfirmModal();
	        }
	    });
	
	    function updateOrderTypeStatus(submitModalFlow) {
	        $.ajax({
	            url: updateOrderTypeStatusUrl,
	            type: 'POST',
	            dataType: 'JSON',
	            data: {},
	            success: function success(data) {
	                if (data.responseStatus === "success") {
	
	                    submitModalFlow.showSuccessModal();
	                    setTimeout(function () {
	                        submitModalFlow.hideAllModals();
	                        location.href = orderTypeDetailsUrl;
	                    }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                } else {
	                    submitModalFlow.showFailureModal();
	                }
	            },
	            error: function error(data) {
	                submitModalFlow.hideAllModals();
	            }
	        });
	    }
	});

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.loadEditValues = loadEditValues;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _elementsbindMap = __webpack_require__(112);
	
	var _util = __webpack_require__(34);
	
	var _select2able = __webpack_require__(22);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsPageMap = (0, _elementsbindMap.getMap)();
	var additionalCarrierElementsMap = (0, _elementsbindMap.getAdditionalCarrierMap)();
	var elsPage = {};
	var entryEl = (0, _jquery2.default)("<div class='entry-point'></div>");
	var targetSelector = "#create-order-type-form";
	var additionalCarrierHtml = __webpack_require__(186);
	
	function loadEditValues(mainEl) {
	    var editOrderType = mainEl.data("edit-order-type-data");
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, mainEl);
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, additionalCarrierElementsMap, mainEl);
	    fillForDetailsTab(editOrderType, mainEl);
	    fillForPackagingTab(editOrderType, mainEl);
	}
	
	function fillForDetailsTab(orderTypeObj, el) {
	
	    if (!(0, _util.isNullOrUndefined)(orderTypeObj.fulfillmentCenter)) elsPage.orderTypeFullfillmentCenter.val(orderTypeObj.fulfillmentCenter).trigger('change');
	
	    if (!(0, _util.isNullOrUndefined)(orderTypeObj.billing)) elsPage.orderTypeBillingMethod.val(orderTypeObj.billing.billingMethod).trigger('change');
	    if (orderTypeObj.billing.billingMethod.toUpperCase() != "PREPAID") {
	        if (!(0, _util.isNullOrUndefined)(orderTypeObj.billing.carriers[0])) {
	            if (orderTypeObj.billing.carriers[0].carrierName.toUpperCase() == 'FEDEX') {
	                elsPage.orderTypeCarrier.val(orderTypeObj.billing.carriers[0].carrierName).trigger('change');
	                elsPage.orderTypeFedexAccountNumber.val(orderTypeObj.billing.carriers[0].accountNumber);
	            } else {
	                elsPage.orderTypeCarrier.val(orderTypeObj.billing.carriers[0].carrierName).trigger('change');
	                elsPage.orderTypeUpsAccountNumber.val(orderTypeObj.billing.carriers[0].accountNumber);
	                elsPage.orderTypeBillto.val(orderTypeObj.billing.carriers[0].billToAddress.name);
	
	                if (!(0, _util.isNullOrUndefined)(orderTypeObj.billing.carriers[0].billToAddress)) elsPage.orderTypeDetailCountry.val(orderTypeObj.billing.carriers[0].billToAddress.country).trigger('change');
	
	                elsPage.orderTypeDetailAddress.val(orderTypeObj.billing.carriers[0].billToAddress.addressLine1);
	                if (!(0, _util.isNullOrUndefined)(orderTypeObj.billing.carriers[0].billToAddress.addressLine2)) {
	                    elsPage.orderTypeDetailAddress2.val(orderTypeObj.billing.carriers[0].billToAddress.addressLine2);
	                }
	                elsPage.orderTypeDetailCity.val(orderTypeObj.billing.carriers[0].billToAddress.city);
	
	                if (!(0, _util.isNullOrUndefined)(orderTypeObj.billing.carriers[0].billToAddress)) elsPage.orderTypeDetailState.val(orderTypeObj.billing.carriers[0].billToAddress.state).trigger('change');
	
	                elsPage.orderTypeDetailStateInput.val(orderTypeObj.billing.carriers[0].billToAddress.state);
	                elsPage.orderTypeDetailPostalcode.val(orderTypeObj.billing.carriers[0].billToAddress.postalCode);
	            }
	        }
	
	        if (!(0, _util.isNullOrUndefined)(orderTypeObj.billing.carriers[1])) {
	            var arrayIndex = 0;
	            var carrierList = elsPage.orderTypeCarrier.data('options');
	            var countryList = elsPage.orderTypeDetailCountry.data('options');
	            var AdditonalCarriersAdd = (0, _jquery2.default)((0, _render2.default)(additionalCarrierHtml, {
	                additionalCarrierDropdown: getRenderedCarrierDropDown(carrierList, orderTypeObj.billing.carriers[0].carrierName),
	                countryList: renderCountryList(countryList),
	                arrayIndex: arrayIndex
	            }));
	            elsPage.orderTypedetailAddcarrierDiv.append(AdditonalCarriersAdd);
	            (0, _select2able.instantiateSelect2)(elsPage.orderTypedetailAddcarrierDiv.find('.select2-select'));
	            fillForAdditionalCarrier(orderTypeObj.billing.carriers[1], el);
	        }
	    }
	}
	
	function getRenderedCarrierDropDown(addtionalCarrierDropValue, valueForMainCarrier) {
	    var carrierValue = elsPage.orderTypeCarrier.val();
	    var addtionalCarrierDropHtml = '<option value="{%- addtionalCarrier.cdmValue %}">{%- addtionalCarrier.cdmValue %}</option>';
	    var response = _underscore2.default.map(addtionalCarrierDropValue, function (addtionalCarrier) {
	        if (valueForMainCarrier != addtionalCarrier.cdmValue) {
	            return (0, _render2.default)(addtionalCarrierDropHtml, {
	                addtionalCarrier: addtionalCarrier
	            });
	        }
	    });
	    return response.join("");
	}
	
	function renderCountryList(countryList) {
	    var addtionalCarrierCountryDropHtml = '<option value="{%- addtionalCarrierCountry.conCode %}">{%- addtionalCarrierCountry.conName %}</option>';
	    var response = _underscore2.default.map(countryList, function (addtionalCarrierCountry) {
	        return (0, _render2.default)(addtionalCarrierCountryDropHtml, {
	            addtionalCarrierCountry: addtionalCarrierCountry
	        });
	    });
	
	    return response.join("");
	}
	
	function fillForAdditionalCarrier(billing, el) {
	    handleSwitchingStateAddtionaCarrier();
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, additionalCarrierElementsMap, el);
	    if (billing.carrierName.toUpperCase() == 'FEDEX') {
	        elsPage.additionalCarrierDrop.val(billing.carrierName).trigger('change');
	        elsPage.additionalCarrierFedexNumber.val(billing.accountNumber);
	    } else {
	        elsPage.additionalCarrierDrop.val(billing.carrierName).trigger('change');
	        elsPage.additionalCarrierUPSNumber.val(billing.accountNumber);
	        elsPage.additionalCarrierBillTo.val(billing.billToAddress.name);
	        elsPage.additionalCarrierCountry.val(billing.billToAddress.country).trigger('change');
	        elsPage.additionalCarrierAddress1.val(billing.billToAddress.addressLine1);
	        if (!(0, _util.isNullOrUndefined)(billing.billToAddress.addressLine2)) {
	            elsPage.additionalCarrierAddress2.val(billing.billToAddress.addressLine2);
	        }
	        elsPage.additionalCarrierCity.val(billing.billToAddress.city);
	        elsPage.additionalCarrierDetailState.val(billing.billToAddress.state).trigger('change');
	        elsPage.additionalCarrierDetailStateText.val(billing.billToAddress.state);
	        elsPage.additionalCarrierPostalCode.val(billing.billToAddress.postalCode);
	    }
	}
	
	function handleSwitchingStateAddtionaCarrier() {
	
	    var countryVal = (0, _jquery2.default)('.additional-carrier-country  :selected').val();
	    if (countryVal == "US" || countryVal == "CA") {
	        elsPage.additionalCarrierDetailStateWrapper.removeClass("hidden");
	        elsPage.additionalCarrierDetailStateTextWrapper.addClass("hidden");
	        getRenderedStatesorProvince(countryVal, elsPage.additionalCarrierDetailState);
	    } else {
	        elsPage.additionalCarrierDetailStateWrapper.addClass("hidden");
	        elsPage.additionalCarrierDetailStateTextWrapper.removeClass("hidden");
	    }
	}
	
	function getRenderedStatesorProvince(countryVal, stateComponent) {
	    var stateTypeSelect = stateComponent;
	    stateTypeSelect.html('');
	    var defaultSelectText = "";
	    if (countryVal == "US") {
	        defaultSelectText = "Select State";
	    } else {
	        defaultSelectText = "Select Province";
	    }
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', "-1").text(defaultSelectText);
	    option.attr('selected', 'selected');
	    option.attr('disabled', 'disabled');
	    stateTypeSelect.append(option);
	    if (countryVal == "US") {
	        (0, _jquery2.default)(usaStates).each(function () {
	            var option = (0, _jquery2.default)('<option />');
	            option.attr('value', this.cdmValue).text(this.cdmMeaning);
	            stateTypeSelect.append(option);
	        });
	    } else if (countryVal == "CA") {
	        (0, _jquery2.default)(caProvinces).each(function () {
	            var option = (0, _jquery2.default)('<option />');
	            option.attr('value', this.cdmValue).text(this.cdmMeaning);
	            stateTypeSelect.append(option);
	        });
	    }
	    stateTypeSelect.addClass("select2 select");
	    (0, _select2able.instantiateSelect2)(stateTypeSelect);
	}
	
	function fillForPackagingTab(editOrderType, el) {
	
	    elsPage.orderTypeBoxType.val(editOrderType.boxType).trigger('change');
	    elsPage.orderTypeTissuePaper.val(editOrderType.tissuePaper).trigger('change');
	    (0, _instantiateSwitchery.instantiateSwitchery)(elsPage.includePackageLabel, {});
	    (0, _instantiateSwitchery.instantiateSwitchery)(elsPage.packagePackingSlip, {});
	    (0, _instantiateSwitchery.instantiateSwitchery)(elsPage.orderPackingSlip, {});
	    (0, _instantiateSwitchery.setSwitchery)(elsPage.includePackageLabel, editOrderType.includingPackageLabel);
	    if (editOrderType.packingSlipCI.includingPackingSlip) {
	        (0, _instantiateSwitchery.setSwitchery)(elsPage.packagePackingSlip, true);
	        elsPage.packageSlip.val(editOrderType.packingSlipCI.packingSlipTemplate).trigger('change');
	    } else {
	        (0, _instantiateSwitchery.setSwitchery)(elsPage.packagePackingSlip, false);
	    }
	
	    if (editOrderType.packingSlipCI.includingCI) {
	        (0, _instantiateSwitchery.setSwitchery)(elsPage.orderPackingSlip, true);
	        elsPage.orderSlip.val(editOrderType.packingSlipCI.citemplate).trigger('change');
	    } else {
	        (0, _instantiateSwitchery.setSwitchery)(elsPage.orderPackingSlip, false);
	    }
	
	    if (editOrderType.packingSlipCI.includingCI || editOrderType.packingSlipCI.includingPackingSlip) elsPage.customizeSection.show();
	
	    elsPage.companyNameInput.val(editOrderType.packingSlipCI.customizedDocument.companyName);
	    elsPage.customDocEmail.val(editOrderType.packingSlipCI.customizedDocument.contactEmail);
	    elsPage.customHeader.val(editOrderType.packingSlipCI.customizedDocument.customNoteHeader);
	    elsPage.customBody.val(editOrderType.packingSlipCI.customizedDocument.customNoteBody);
	    elsPage.customDocPhoneNumber.val(editOrderType.packingSlipCI.customizedDocument.phoneNumber);
	    elsPage.orderTypeCountryCode.val(editOrderType.packingSlipCI.customizedDocument.countryCode).trigger('change');
	    if (!(0, _util.isNullOrUndefined)(editOrderType.packingSlipCI.customizedDocument.facility)) {
	        elsPage.facilityAddress.val(editOrderType.packingSlipCI.customizedDocument.facility.facilityName).trigger('change');
	    }
	}

/***/ },
/* 703 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    icon: 'toggle-on',
	    title: 'Activate Selected Order Types',
	    cls: "bulk-activate-order-types",
	    disabled: false
	  }, {
	    icon: 'toggle-off',
	    title: 'Deactivate Selected Order Types',
	    cls: "bulk-deactivate-order-types",
	    disabled: false
	  }],
	  "actions": [{
	    title: "Edit Order Type",
	    cls: "edit-order-type",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Activate/Deactivate",
	    cls: "",
	    icon: "",
	    disabled: false
	  }, {
	    title: "Duplicate Order Type",
	    cls: "duplicate-order-type",
	    icon: "clone",
	    disabled: false
	  }],
	  "actionActiveDeactive": [{
	    title: "Activate/Deactivate",
	    cls: "",
	    icon: "",
	    disabled: false
	  }]
	};

/***/ },
/* 704 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var searchDropdown = exports.searchDropdown = [{
		title: "Order Type Name",
		value: "name"
	}, {
		title: "Order Type Code",
		value: "code"
	}];

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(706);
	
	__webpack_require__(707);
	
	__webpack_require__(213);
	
	__webpack_require__(701);
	
	__webpack_require__(214);
	
	__webpack_require__(215);

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _filtersutil = __webpack_require__(16);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _actionOptions = __webpack_require__(703);
	
	var _searchDropdown = __webpack_require__(704);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	var modalHtml = __webpack_require__(11);
	var _ = __webpack_require__(2);
	var detailLinkHTML = __webpack_require__(84);
	var targetSelector = "#order-type-lookup";
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var actionList = _actionOptions.actionOptions;
	
	(0, _run2.default)(targetSelector, function (mainEl) {
		var viewOrderTypeDetailUrl = mainEl.data("order-type-detail-url");
		var orderTypeLookupTable = mainEl.find("#order-type-lookup-wrapper");
		var targetObject = "";
		var selectedRows = "";
		var editPermission = true;
		var shouldCheckCache = mainEl.data("should-check-cache");
		var generateExportUrl = mainEl.data("export-url");
		var savedViews = mainEl.data("saved-views");
		var dataTableComponentData = mainEl.data("order-type-lookup-json");
		var filterOrderTypesUrl = mainEl.data("order-types-filter-url");
		var saveViewURL = mainEl.data("save-view-url");
		var exportModal = new _filtersutil.buildExport();
		var deleteViewURL = mainEl.data("delete-view-url");
		var extraDetailForCacheFromServer = mainEl.data("extra-detail-for-cache-from-server");
		var criteriaObjectFromServer = mainEl.data("filter-criteria-from-server");
		var updateOrderTypeStatusUrl = mainEl.data("updateOrderTypeStatusUrl");
		var portletNamespace = mainEl.data("portlet-namespace");
		var bulkActivateOrderTypesUrl = mainEl.data("bulk-activate-order-types-url");
		var bulkDeactivateOrderTypesUrl = mainEl.data("bulk-deactivate-order-types-url");
		var defaultOrderTypesList = mainEl.data("default-order-types-list");
		var orderTypeEditURL = mainEl.data("edit-order-type-url");
	
		if (shouldCheckCache) {
			targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
		}
	
		function createDetailLink(data, type, row) {
			var detailPageHTML = (0, _render2.default)(detailLinkHTML, {
				renderURL: viewOrderTypeDetailUrl,
				portletNamespace: portletNamespace,
				id: row.customOrderTypeId,
				idName: "ortId",
				displayVal: row.name
			});
			return detailPageHTML;
		}
	
		var orderTypeLookup = new _index2.default({
			target: orderTypeLookupTable,
			minWidthClass: "q-min-width-sm-til-md",
			mobileColumns: [{
				data: "name",
				title: "Order Type Name",
				render: createDetailLink
			}, {
				data: "code",
				title: "Order Code",
				orderable: false
			}, {
				data: "createdDate",
				title: "Created On",
				orderable: false
			}, {
				data: "status",
				title: "Status",
				render: _filtersutil.statusPillRender,
				orderable: false
			}],
	
			tableSearchInput: {
				// Not required
				// placeholder: 'Custom Search Text'
				value: targetObject != "" ? targetObject.value[0] : ""
	
			},
			tableSearchDropdown: {
				selected: targetObject == "" ? "" : targetObject.key,
				columns: _searchDropdown.searchDropdown
			},
			savedViews: savedViews,
			bulkSelect: true,
	
			dataTable: {
				data: dataTableComponentData.content,
				columnDefs: [{
					className: "custom-class", targets: [1]
				}],
	
				order: [[4, 'desc']],
	
				columns: [{
					data: "customOrderTypeId",
					render: renderActionWrap,
					orderable: false,
					class: 'dtc-action-column'
				}, {
					data: "name",
					title: "Order Type Name",
					render: createDetailLink,
					class: 'dtc-min-width-md'
				}, {
					data: "code",
					title: "Order Type Code",
					class: 'dtc-min-width-sm'
				}, {
					data: "createdDate",
					title: "Created On",
					render: _general.formateDateUtil,
					class: 'dtc-min-width-sm'
				}, {
					data: "status",
					title: "Status",
					render: _filtersutil.statusPillRender,
					class: 'dtc-min-width-sm'
				}, {
					data: "fulfillmentCenter",
					title: "Fulfillment Center",
					class: 'dtc-min-width-md'
				}, {
					data: "billing.billingMethod",
					title: "Billing Method",
					class: 'dtc-min-width-sm'
				}]
			},
			paginationData: dataTableComponentData.page,
			filterModal: {
				// REQUIRED: Sets title of modal
				title: "Filter Order Types",
				// REQUIRED: Sets unique part of subtitle string.
				tableType: "orderTypes"
			},
			onBulkSelectChange: function onBulkSelectChange() {
				selectedRows = orderTypeLookup.getBulkSelectedData();
				$("th.dtc-action-column").html(renderActionHeaderWrap());
				if (selectedRows.length >= 2) {
					$(".action-header-btn .base-btn").removeClass('disabled');
				} else {
					$(".action-header-btn .base-btn").addClass('disabled');
				};
			},
			onFetch: function onFetch() {
				var currentData = orderTypeLookup.generateData();
				orderTypeLookup.showLoadingOverlay();
				//Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
				if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterOrderTypesUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isNew)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isEdit)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isDeleteView)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				}
			}
		});
	
		orderTypeLookup.init();
		var table = $("#order-type-lookup-wrapper .data-table-component").DataTable();
	
		/* function renderActionWrap(data, type, row, meta) {
	   let newRender;
	   let statusTarget = actionList["actions"];
	   newRender = render(
	     actionCellDropdownTemplate, {
	       list: renderActionCellList(statusTarget,data,row),
	       index: meta.row
	     }
	   );
	   return newRender;
	 };*/
	
		function renderActionWrap(data, type, row, meta) {
			if (row.retailerId == "0" && row.code !== "B2B" && row.code !== "B2C") {
				data = "actionActiveDeactive";
			} else {
				data = "actions";
			}
			var newRender = void 0;
			var statusTarget = actionList[data];
			newRender = (0, _render2.default)(actionCellDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row),
				index: meta.row
			});
			return newRender;
		};
	
		function renderActionHeaderWrap() {
			var statusTarget = actionList['all'];
			if (!editPermission) {
				statusTarget = []; //make empty
			}
			var newRender = void 0;
			var data = "";
			var row = "";
			newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row)
			});
			return newRender;
		};
	
		function renderActionCellList(list, data, row) {
			var renderedList = _(list).map(function (orderType) {
				return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, orderType));
			});
			return renderedList.join('');
		};
	
		function neededActions(data, row, orderType) {
			var action = {};
			if (orderType.title === 'Activate/Deactivate') {
				if (row.status === "Active") {
					action = {
						icon: 'toggle-off',
						title: 'Deactivate',
						cls: "deactivate-order-type",
						disabled: callBusinessLogicToDisableAction(data, row, orderType.title)
					};
				} else {
					action = {
						icon: 'toggle-on',
						title: 'Activate',
						cls: "activate-order-type",
						disabled: callBusinessLogicToDisableAction(data, row, orderType.title)
					};
				}
			} else if (orderType.title === 'Activate Selected Order Types') {
				action = {
					icon: orderType.icon,
					title: orderType.title,
					cls: orderType.cls,
					disabled: checkDisableForGivenAction(data, row, orderType.title)
				};
			} else if (orderType.title === 'Deactivate Selected Order Types') {
				action = {
					icon: orderType.icon,
					title: orderType.title,
					cls: orderType.cls,
					disabled: checkDisableForGivenAction(data, row, orderType.title)
				};
			} else {
				action = {
					icon: orderType.icon,
					title: orderType.title,
					cls: orderType.cls,
					disabled: orderType.disabled
				};
			}
			return action;
		};
	
		function checkDisableForGivenAction(data, row, actionName) {
			var isTrue = false;
			_(selectedRows).map(function (orderType) {
				if (callBusinessLogicToDisableAction(orderType.data.status, orderType.data, actionName)) {
					if (!isTrue) {
						isTrue = true;
					}
				}
			});
			return isTrue;
		};
	
		function callBusinessLogicToDisableAction(data, row, actionName) {
			if (editPermission && (0, _general.isPresent)(data)) {
				if (row.retailerId == "0" || row.code == "B2B" || row.code == "B2C") {
					return true;
				}
				if (actionName === "Activate Selected Order Types") {
					if (data === "Active") {
						return true;
					} else {
						return false;
					}
				} else if (actionName === "Deactivate Selected Order Types") {
					if (data === "Inactive") {
						return true;
					} else {
						return false;
					}
				}
			}
		}
	
		function filterSuccessFun(data) {
			var orderTypes = data.content;
			var page = data.page;
			orderTypeLookup.setNewData(orderTypes);
			orderTypeLookup.setPaginationData(page);
			(0, _filtersutil.pushFilterSessionCacheState)();
			orderTypeLookup.hideLoadingOverlay();
			setExportData(orderTypeLookup.generateData());
		}
	
		function errorFun(data) {
			orderTypeLookup.hideLoadingOverlay();
		}
	
		function savedViewSuccess(data) {
			var orderTypes = data.orderTypeLookupJSON.content;
			var page = data.orderTypeLookupJSON.page;
			orderTypeLookup.setNewData(orderTypes);
			orderTypeLookup.setPaginationData(page);
			orderTypeLookup.setNewSavedViewData(data.savedView, "newSavedView");
			(0, _filtersutil.pushFilterSessionCacheState)();
			orderTypeLookup.hideLoadingOverlay();
			setExportData(orderTypeLookup.generateData());
		}
	
		function savedEditViewSuccess(data) {
			var orderTypes = data.orderTypeLookupJSON.content;
			var page = data.orderTypeLookupJSON.page;
			orderTypeLookup.setNewData(orderTypes);
			orderTypeLookup.setPaginationData(page);
			orderTypeLookup.setNewSavedViewData(data.savedView, data.savedView.target);
			(0, _filtersutil.pushFilterSessionCacheState)();
			orderTypeLookup.hideLoadingOverlay();
			setExportData(orderTypeLookup.generateData());
		}
	
		function delteViewScussFun(data) {
			var orderTypes = data.orderTypeLookupJSON.content;
			var page = data.orderTypeLookupJSON.page;
			orderTypeLookup.removeSavedView(data.target);
			orderTypeLookup.setNewData(orderTypes);
			orderTypeLookup.setPaginationData(page);
			orderTypeLookup.hideLoadingOverlay();
			setExportData(orderTypeLookup.generateData());
		}
	
		$('body').on('click', '.edit-order-type', function (e) {
			e.preventDefault();
			var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
			var parent = $(".dropdown-parent-" + pIndex).parents('tr');
			var row = table.row(parent);
			var cotId = row.data().customOrderTypeId;
			window.location.href = orderTypeEditURL + "&cotId=" + cotId;
		});
	
		$('body').on('click', ".duplicate-order-type", function (e) {
	
			e.preventDefault();
			var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
			var parent = $(".dropdown-parent-" + pIndex).parents('tr');
			var row = table.row(parent);
			var cotId = row.data().customOrderTypeId;
			window.location.href = orderTypeEditURL + "&cotId=" + cotId + "&isDup=true";
		});
	
		$('body').on('click', '.deactivate-order-type', function (e) {
			e.preventDefault();
			if ((0, _general.shallAllowClick)(this)) {
				var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				// Get the row based on the parent...
				var parent = $(".dropdown-parent-" + pIndex).parents('tr');
				// Get the row data
				var row = table.row(parent);
				var submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: 'Deactivate Order Type',
					confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this order type will no longer be available when creating orders. It can be activated at any time.</div>',
					confirmModalBtnText: 'Deactivate',
					onConfirmClick: function onConfirmClick() {
						submitModalFlow.showLoadingModal();
						deactivateOrderType(row, row.data());
						function deactivateOrderType(row, orderType) {
							$.ajax({
								url: updateOrderTypeStatusUrl,
								type: 'POST',
								dataType: 'JSON',
								data: _defineProperty({}, portletNamespace + 'customOrderTypeId', orderType.customOrderTypeId),
								success: function success(data) {
									if (data.responseStatus === "success") {
										var d = row.data();
										d.status = "Inactive";
										row.data(d).draw();
										submitModalFlow.showSuccessModal();
										setTimeout(function () {
											submitModalFlow.hideAllModals();
										}, window.constants.SUCCESS_MODAL_TIMEOUT);
									} else {
										submitModalFlow.showFailureModal();
									}
								},
								error: function error(data) {
									submitModalFlow.hideAllModals();
								}
							});
						};
					}
				});
				submitModalFlow.init();
				submitModalFlow.showConfirmModal();
			}
		});
	
		$('body').on('click', '.activate-order-type', function (e) {
			e.preventDefault();
			if ((0, _general.shallAllowClick)(this)) {
				var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				// Get the row based on the parent...
				var parent = $(".dropdown-parent-" + pIndex).parents('tr');
				// Get the row data
				var row = table.row(parent);
				var submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: 'Activate Order Type',
					confirmModalBody: '<div class="q-pad-all-xl">Once activated, this order type will continue to be available when creating orders. It can be deactivated at any time</div>',
					confirmModalBtnText: 'Activate',
					onConfirmClick: function onConfirmClick() {
						submitModalFlow.showLoadingModal();
						activateOrderType(row, row.data());
						function activateOrderType(row, orderType) {
							$.ajax({
								url: updateOrderTypeStatusUrl,
								type: 'POST',
								dataType: 'JSON',
								data: _defineProperty({}, portletNamespace + 'customOrderTypeId', orderType.customOrderTypeId),
								success: function success(data) {
									if (data.responseStatus === "success") {
										var d = row.data();
										d.status = "Active";
										row.data(d).draw();
										submitModalFlow.showSuccessModal();
										setTimeout(function () {
											submitModalFlow.hideAllModals();
										}, _constants.SUCCESS_MODAL_TIMEOUT);
									}
								},
								error: function error(data) {
									submitModalFlow.hideAllModals();
								}
							});
						};
					}
				});
				submitModalFlow.init();
				submitModalFlow.showConfirmModal();
			}
		});
	
		$('body').on('click', '.bulk-activate-order-types', function (e) {
			e.preventDefault();
			if ((0, _general.shallAllowClick)(this)) {
				var submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: 'Activate Order Types',
					confirmModalBody: '<div class="q-pad-all-xl">Once activated, this order type will continue to be available when creating orders. It can be deactivated at any time.</div>',
					confirmModalBtnText: 'Activate',
					onConfirmClick: function onConfirmClick() {
						submitModalFlow.showLoadingModal();
						bulkActivateOrderTypes();
						function bulkActivateOrderTypes() {
							$.ajax({
								url: bulkActivateOrderTypesUrl,
								type: 'POST',
								dataType: 'JSON',
								data: _defineProperty({}, portletNamespace + 'orderTypeIds', getAllSelectedOrderTypeIds()),
								success: function success(data) {
									if (data.response == "success") {
										_(selectedRows).map(function (orderType) {
											var currentRow = table.row(orderType.rowIndex);
											var d = currentRow.data();
											d.status = "Active";
											currentRow.data(d).draw();
										});
										orderTypeLookup.uncheckAllSelected();
										submitModalFlow.showSuccessModal();
										setTimeout(function () {
											submitModalFlow.hideAllModals();
										}, window.constants.SUCCESS_MODAL_TIMEOUT);
									} else {
										submitModalFlow.showFailureModal();
									}
								},
								error: function error(data) {
									submitModalFlow.hideAllModals();
								}
							});
						}
					}
				});
				submitModalFlow.init();
				submitModalFlow.showConfirmModal();
			}
		});
	
		$('body').on('click', '.bulk-deactivate-order-types', function (e) {
			e.preventDefault();
			if ((0, _general.shallAllowClick)(this)) {
				var submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: 'Deactivate Order Types',
					confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this order type will no longer be available when creating orders. It can be activated at any time.</div>',
					confirmModalBtnText: 'Deactivate',
					onConfirmClick: function onConfirmClick() {
						submitModalFlow.showLoadingModal();
						bulkActivateOrderTypes();
						function bulkActivateOrderTypes() {
							$.ajax({
								url: bulkDeactivateOrderTypesUrl,
								type: 'POST',
								dataType: 'JSON',
								data: _defineProperty({}, portletNamespace + 'orderTypeIds', getAllSelectedOrderTypeIds()),
								success: function success(data) {
									if (data.response == "success") {
										_(selectedRows).map(function (orderType) {
											var currentRow = table.row(orderType.rowIndex);
											var d = currentRow.data();
											d.status = "Inactive";
											currentRow.data(d).draw();
										});
										orderTypeLookup.uncheckAllSelected();
										submitModalFlow.showSuccessModal();
										setTimeout(function () {
											submitModalFlow.hideAllModals();
										}, window.constants.SUCCESS_MODAL_TIMEOUT);
									} else {
										submitModalFlow.showFailureModal();
									}
								},
								error: function error(data) {
									submitModalFlow.hideAllModals();
								}
							});
						}
					}
				});
				submitModalFlow.init();
				submitModalFlow.showConfirmModal();
			}
		});
	
		function getAllSelectedOrderTypeIds() {
			var orderTypeIds = new Array();
			_(selectedRows).map(function (orderType) {
				orderTypeIds.push(orderType.data.customOrderTypeId);
			});
			return orderTypeIds;
		}
	
		// Export component integration.
		function initExport() {
			var exportObj = {
				title: mainEl.data("export-popup-title"),
				exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
				exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
				exportMaxLimitLang: mainEl.data("export-max-row-limit")
			};
			exportModal.init(exportObj);
			exportModal.bindExportEvent();
		}
	
		function setExportData(currentData) {
			exportModal.buildExportBasicURL(generateExportUrl, currentData);
			exportModal.setExportCount(currentData.totalElements);
		}
		initExport();
		setExportData(orderTypeLookup.generateData());
		(0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
		//Export Component 
	});

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _select2able = __webpack_require__(22);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _detailsTab = __webpack_require__(213);
	
	var _detailsTab2 = _interopRequireDefault(_detailsTab);
	
	var _packagingTab = __webpack_require__(214);
	
	var _packagingTab2 = _interopRequireDefault(_packagingTab);
	
	var _reviewTab = __webpack_require__(215);
	
	var _reviewTab2 = _interopRequireDefault(_reviewTab);
	
	var _editOrderTypeWizard = __webpack_require__(702);
	
	var _jumpToWizardLogic = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	var targetSelector = "#create-order-type-form";
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	
	  var editFlag = mainEl.data("edit-flag");
	  if (editFlag) {
	    (0, _editOrderTypeWizard.loadEditValues)(mainEl);
	  }
	  attachWizard(mainEl);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  _EditChecker2.default.bindNavigation();
	  _EditChecker2.default.bindChangeListener(targetSelector);
	  _EditChecker2.default.bindChangeListener("span.select2");
	  _EditChecker2.default.bindCancelButton("#create-order-type-cancel-btn");
	}
	
	function attachWizard(el) {
	  var hiddenAddressInput = $(".ot-details-tab");
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	  var quickWizard = new _QuickWizard2.default(el, {
	    tabletWidthNavStep: 844,
	    mobileWidthNavStep: 502,
	    customRules: {
	      ".orderTypeCodeInput": {
	        errorMessageSelector: "#create-order-type-duplicate",
	        isValid: function isValid(_ref) {
	          var input = _ref.input,
	              done = _ref.done;
	
	          return orderTypeDuplicateCheck(input, done);
	        }
	      }
	    },
	    shouldNavigateToForm: function shouldNavigateToForm(_ref2) {
	      var targetForm = _ref2.targetForm,
	          direction = _ref2.direction,
	          currentForm = _ref2.currentForm,
	          done = _ref2.done;
	
	      // Any time we go traverse backwards, just let us
	      if (direction === "BACKWARDS") {
	        return true;
	      }
	
	      if (currentForm.filter('.ot-review-tab').length) {
	        reviewTab.didNavigateToForm();
	      }
	
	      //Handle general validations on forward traversal
	      var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	      if (!quickWizard.areInputsValid(allPrevInputs, { displayErrors: true })) {
	        quickWizard.goToFirstIncompleteForm();
	        return false;
	      }
	    },
	    didNavigateToForm: function didNavigateToForm(_ref3) {
	      var currentForm = _ref3.currentForm;
	
	      if (currentForm.filter('.ot-review-tab').length) {
	        reviewTab.didNavigateToForm();
	      }
	    }
	  });
	
	  quickWizard.init();
	
	  var detailsTab = new _detailsTab2.default(quickWizard);
	  var packagingTab = new _packagingTab2.default(quickWizard);
	  var reviewTab = new _reviewTab2.default(quickWizard);
	
	  function orderTypeDuplicateCheck(input, done) {
	    var orderTypeCodeValue = input.val();
	    var orderTypeList = el.data("dup-chck-list");
	    var editFlag = el.data("edit-flag");
	    var isDup = el.data("dup-flag");
	    var orderTypeObj = el.data("edit-order-type-data");
	    var dupCheck = _underscore2.default.find(orderTypeList, function (obj) {
	      return obj.ortTypeCode == orderTypeCodeValue.toUpperCase() && obj.ortRtlId != 0;
	    });
	    var requiredErrorMsg = el.find("#create-order-type-required");
	    var notEmptyChck = void 0;
	    if (!input.attr('disabled')) {
	      if (orderTypeCodeValue != "") {
	        notEmptyChck = true;
	        requiredErrorMsg.hide();
	      } else {
	        requiredErrorMsg.show();
	        notEmptyChck = false;
	      }
	      var isValid = orderTypeCodeValidation(orderTypeCodeValue);
	      if (!notEmptyChck) {
	        el.find("#create-order-type-duplicate").hide();
	        done(false, { displayErrors: false });
	      } else if (!isValid) {
	        el.find("#create-order-type-duplicate").hide();
	        done(false, { displayErrors: false });
	      } else if (dupCheck) {
	        if (editFlag && orderTypeObj.code.toUpperCase() === orderTypeCodeValue.toUpperCase() && !isDup) {
	          done(true, { displayErrors: false });
	        } else {
	          done(false, { displayErrors: true });
	        }
	      } else if (orderTypeCodeValue.toUpperCase() == "B2B" || orderTypeCodeValue.toUpperCase() == "B2C") {
	        done(false, { displayErrors: true });
	      } else {
	        done(true, { displayErrors: true });
	      }
	    } else {
	      var qSimErrorEle = el.find("#create-order-type-duplicate");
	      if (qSimErrorEle.find('label').is(':visible')) {
	        done(false, { displayErrors: true });
	      } else {
	        done(true, { displayErrors: false });
	        requiredErrorMsg.hide();
	      }
	    }
	    return done;
	  }
	
	  function orderTypeCodeValidation(orderTypeCodeValue) {
	    var errorMsgEl = el.find("#create-order-type-invalid");
	    if (orderTypeCodeValue == "") {
	      errorMsgEl.hide();
	      return true;
	    } else if (!/[a-zA-Z]/.test(orderTypeCodeValue) || orderTypeCodeValue.length < 3) {
	      errorMsgEl.show();
	      return false;
	    } else {
	      errorMsgEl.hide();
	      return true;
	    }
	  }
	  function orderTypeValidation(input, currentDropShip) {
	    var orderTypeCodeValue = input.val();
	    var orderTypeList = el.data("dup-chck-list");
	    var orderTypeObj = el.data("edit-order-type-data");
	    var dupCheck = _underscore2.default.find(orderTypeList, function (obj) {
	      return obj.ortTypeCode == orderTypeCodeValue.toUpperCase() && obj.ortDropShip == currentDropShip && obj.ortRtlId != 0;
	    });
	    if (dupCheck) {
	      el.find("#create-order-type-duplicate").show();
	    } else {
	      el.find("#create-order-type-duplicate").hide();
	    }
	  }
	  el.find('.order-type-retailer-list').on("change", function () {
	    orderTypeValidation(el.find('.orderTypeCodeInput'), el.find('.order-type-dropShip-switch').is(":checked"));
	  });
	  el.find('.order-type-dropShip-switch').on("change", function () {
	    orderTypeValidation(el.find('.orderTypeCodeInput'), el.find('.order-type-dropShip-switch').is(":checked"));
	  });
	  (0, _select2able.validateOnAllSelectChanges)();
	  (0, _jumpToWizardLogic.handleQueryParamTraversalToWizardTab)(quickWizard);
	}

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ProductsTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var productRowHtml = __webpack_require__(1384);
	var unitOfMeasureHtml = __webpack_require__(1388);
	var productIdHtml = __webpack_require__(1382);
	var unitPillHtml = __webpack_require__(309);
	var bundleChildBodyHtml = __webpack_require__(1371);
	var uomDropdownOption = __webpack_require__(1389);
	var modalHtml = __webpack_require__(11);
	var removeProductModalBodyHtml = __webpack_require__(1385);
	var skuInvalidErrorHtml = __webpack_require__(1387);
	var missingHsCodeHtml = __webpack_require__(1378);
	var skuInactiveHtml = __webpack_require__(1386);
	
	var elementsPageMap = {
	  orderFulfillmentCenter: '#order-fulfillment-center',
	  productItemLookup: "#product-item-lookup",
	  productsTabValidatorElement: "#products-empty-table-validator",
	  createOrderTableWrapper: ".create-order-table-wrapper",
	  productsEmpty: ".products-empty",
	  productOrBundleRow: "#product-bundle-row",
	  autoFulfillToggle: ".auto-fulfill",
	  prodcutTabAvailableUnits: ".product-tab-available-units",
	  orderTypeSelect: "#destination-tab-order-type-select",
	  dropShipFlag: "#dropShipFlag",
	  collateralInfoMsg: ".edit-order-collateral-info-message",
	  channelInfoMag: ".edit-channel-order-info-message"
	};
	
	function ProductsTab(wizard) {
	  var self = this;
	  var elsPage = {};
	  var wizardElement = wizard.getWizardElement();
	  var typeAheadUrl = wizardElement.data("get-product-names-and-items-url");
	  var portletNamespace = wizardElement.data("portlet-namespace");
	  var facilityToggleTargetArray = [".auto-fulfill", ".indianapolis", ".fontana", ".greenwoodeast"];
	  var orderDetailsForEdit = wizardElement.data("edit-order-details");
	  var prevOrderTypeVal = void 0,
	      prevDropShipVal = void 0,
	      partnerId = void 0,
	      removeId = void 0,
	      removeProductModal = null;
	  var nonChannelParIds = [3, 5, 7];
	  var businessExceptionsExist = false;
	  self.productItems = {};
	  self.productNameArr = {};
	  var currentItemList = [];
	  var detailsForItemOnOrder = wizardElement.data("item-detail-info");
	
	  self.init = function () {
	    setElements();
	    setWidgets();
	    bindElements();
	    populateProductsForEdit();
	  };
	
	  self.didNavigateToForm = function () {
	    configureUOMDropdownBasedonOrderTypeAndDropShip();
	    handleDisplayOfCreateOrderTable();
	  };
	
	  self.isValid = function () {
	    return getItemsInCreateOrderTable().length;
	  };
	
	  function handleDisplayOfCreateOrderTable() {
	    if (getItemsInCreateOrderTable().length) {
	      hide(elsPage.productsEmpty);
	      show(elsPage.productOrBundleRow);
	    } else {
	      hide(elsPage.productOrBundleRow);
	      show(elsPage.productsEmpty);
	    }
	  }
	
	  function getItemsInCreateOrderTable() {
	    return elsPage.productOrBundleRow.find('.product-data-row');
	  }
	
	  function hide(el) {
	    el.css({ display: "none" });
	  }
	
	  function show(el) {
	    el.css({ display: "block" });
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, wizardElement);
	  }
	
	  function setWidgets() {
	    loadFulfillmentDropdown();
	    instantiateSkuTypeAhead();
	    var productItemLookup = elsPage.productItemLookup;
	    productItemLookup.on("select2:select", function (e) {
	      var res = e.params.data.text.split("--");
	      addProducts(res[0], '', res[1], res[2], res[3], '');
	      triggerAddProductsEvent();
	      productItemLookup.val(null).trigger('change');
	    });
	  }
	
	  function loadFulfillmentDropdown() {
	    var facilities = elsPage.orderFulfillmentCenter.data('options');
	    (0, _jquery2.default)(facilities).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.cadFacId).text(this.cadLocationName);
	      option.data('quick-toggler-target', facilityToggleTargetArray[this.cadFacId]);
	      elsPage.orderFulfillmentCenter.append(option);
	    });
	  }
	
	  function bindElements() {
	    elsPage.productOrBundleRow.on('addedproducts', handleAddProducts);
	    elsPage.orderFulfillmentCenter.on("change", handleFacilityOnChange);
	    wizardElement.on('click', '#product-bundle-row .product-data-row .product-remove-btn', handleItemRemove);
	    wizardElement.on('change', '#product-bundle-row .product-data-row .products-tab-uom', handleUOMChange);
	    (0, _jquery2.default)('body').on('click', '.channel-remove-product-btn', handleChannelProductRemovalModal);
	  }
	
	  function populateProductsForEdit() {
	    if ((0, _general.isPresent)(orderDetailsForEdit)) {
	      var facId = orderDetailsForEdit.orderDetails.ordFacId;
	      partnerId = orderDetailsForEdit.orderDetails.ordParId;
	      prevOrderTypeVal = orderDetailsForEdit.orderDetails.ordOrderType;
	      prevDropShipVal = (0, _general.isPresent)(orderDetailsForEdit.orderDetails.ordDropShip) ? orderDetailsForEdit.orderDetails.ordDropShip : false;
	
	      show(elsPage.collateralInfoMsg);
	      if (!nonChannelParIds.includes(partnerId)) {
	        show(elsPage.channelInfoMag);
	      }
	
	      if ((0, _general.isPresent)(facId)) {
	        elsPage.orderFulfillmentCenter.val(facId).trigger("change");
	      }
	
	      //let products = orderDetailsForEdit.orderDetails.orderItems;
	      var groupedProducts = groupTheProducts(orderDetailsForEdit.orderDetails.orderItems);
	      var productKeys = _underscore2.default.keys(groupedProducts);
	      var skus = [];
	      _underscore2.default.each(productKeys, function (item) {
	        if ((0, _general.isPresent)(groupedProducts[item][0].oriKitSku)) {
	          skus.push(groupedProducts[item][0].oriKitSku);
	        } else {
	          skus.push(groupedProducts[item][0].oriItmSku);
	        }
	      });
	
	      if (skus.length > 0) {
	        _jquery2.default.ajax({
	          url: typeAheadUrl,
	          type: 'POST',
	          data: {
	            'facId': facId,
	            'skuList': skus
	          },
	          dataType: 'JSON',
	          success: function success(data) {
	            getProductNamesAndItems(data);
	            //let items = data.items;
	            var counter = 0;
	            _underscore2.default.each(productKeys, function (item) {
	              var currentSku = void 0,
	                  qty = void 0,
	                  uom = void 0,
	                  oriStatus = void 0,
	                  parItmId = void 0,
	                  parOriId = null;
	              if ((0, _general.isPresent)(groupedProducts[item][0].oriKitSku)) {
	                currentSku = groupedProducts[item][0].oriKitSku;
	                for (var i = 0; i < groupedProducts[item].length; i++) {
	                  if (parOriId != null) parOriId = parOriId + groupedProducts[item][i].oriItmSku + ":" + groupedProducts[item][i].oriId + ",";else parOriId = groupedProducts[item][i].oriItmSku + ":" + groupedProducts[item][i].oriId + ",";
	                }
	              } else {
	                currentSku = groupedProducts[item][0].oriItmSku;
	                parOriId = groupedProducts[item][0].oriId;
	              }
	              qty = groupedProducts[item][0].oriOrderedUomQty;
	              uom = groupedProducts[item][0].oriOrderedQtyUoM;
	              oriStatus = groupedProducts[item][0].oriStatus;
	              parItmId = groupedProducts[item][0].oriParItmId;
	              var currentProduct = filterItem(currentSku);
	              if (currentProduct.length > 0) {
	                addProducts(currentProduct[0].itmSku, parItmId, currentProduct[0].product.prdName, currentProduct[0].availUnit, currentProduct[0].type, parOriId);
	              } else {
	                addProducts(currentSku, parItmId, "Invalid Sku", "0", oriStatus, parOriId);
	              }
	
	              triggerAddProductsEvent();
	              var productsRows = getItemsInCreateOrderTable();
	
	              (0, _jquery2.default)(productsRows[counter]).find(".products-tab-quantity-input").val(qty);
	              if (uom === "EA") {
	                (0, _jquery2.default)(productsRows[counter]).find(".products-tab-uom").val("Units").trigger("change");
	              } else if (uom === "CA") {
	                (0, _jquery2.default)(productsRows[counter]).find(".products-tab-uom").val("Cases").trigger("change");
	              } else {
	                (0, _jquery2.default)(productsRows[counter]).find(".products-tab-uom").val("Pallets").trigger("change");
	              }
	              //$(productsRows[counter]).find(".products-tab-uom").attr("readonly", true);
	              //$("#product-item-lookup").prop("readonly", true);
	              /*if it's channel order make add products search button, qty and uom readonly*/
	              if (!nonChannelParIds.includes(partnerId)) {
	                (0, _jquery2.default)(productsRows[counter]).find(".products-tab-quantity-input").prop("readonly", true);
	                (0, _jquery2.default)(".product-item-lookup-div").hide();
	              }
	
	              counter++;
	            });
	          }
	        });
	      }
	    }
	  }
	
	  function groupTheProducts(orderLineItems) {
	    var groupedProducts = _underscore2.default.groupBy(orderLineItems, 'oriLineId');
	    /**
	      For collateral skus we are going to have null as a key and we shouldn't
	      show the collaterals as part of edit. so remove the null key from
	      grouped products.
	    **/
	    if (_underscore2.default.has(groupedProducts, "null")) {
	      groupedProducts = _underscore2.default.omit(groupedProducts, "null");
	    }
	    return groupedProducts;
	  }
	
	  function handleUOMChange(e) {
	    var uomEl = (0, _jquery2.default)(e.target);
	    var currentRow = uomEl.closest(".product-data-row");
	    calculateAvailabilityBasedonUOM(currentRow, uomEl.val());
	  }
	
	  function calculateAvailabilityBasedonUOM(currentRow, uom) {
	    //let skuEl = currentRow.find(".products-tab-sku");
	    //let sku = $(skuEl).val();
	    var availUnitsEl = currentRow.find(".products-tab-avail-units");
	    var availUnits = currentRow.find(".availableUnitsOfProduct").text();
	    var unitsperuom = 0;
	    if (uom === "Cases") {
	      var unitsPerCaseEl = currentRow.find(".prod-tab-unitsPerCase");
	      unitsperuom = (0, _jquery2.default)(unitsPerCaseEl).val();
	    } else if (uom === "Pallets") {
	      var unitsPerPalletEl = currentRow.find(".prod-tab-unitsPerPallet");
	      unitsperuom = (0, _jquery2.default)(unitsPerPalletEl).val();
	    } else {
	      unitsperuom = 1;
	    }
	    var availUnitsperUOM = Math.floor(availUnits / unitsperuom);
	    if (isNaN(availUnitsperUOM)) {
	      availUnitsperUOM = 0;
	    }
	    (0, _jquery2.default)(availUnitsEl).html(renderUnitPill(availUnitsperUOM, uom));
	  }
	
	  function calculateAvailabilityForChildRow(currentRow, kitItems, uom) {
	    var childRows = currentRow.find(".bundle-child-product-row");
	    var rowsLength = (0, _jquery2.default)(childRows).length;
	    _underscore2.default.each(kitItems, function (kitItem) {
	      for (var i = 0; i < rowsLength; i++) {
	        var skuEl = (0, _jquery2.default)(childRows[i]).find(".products-tab-child-product-name");
	        var sku = (0, _jquery2.default)(skuEl).text();
	        if (sku === kitItem.kitChildItmSku) {
	          var childAvailUnitsEl = (0, _jquery2.default)(childRows[i]).find(".products-tab-child-available-units");
	          (0, _jquery2.default)(childAvailUnitsEl).html(renderUnitPill(kitItem.availUnit, uom));
	          break;
	        }
	      }
	    });
	  }
	
	  function handleItemRemove(e) {
	    if ((0, _general.isPresent)(orderDetailsForEdit) && !nonChannelParIds.includes(partnerId)) {
	      removeId = (0, _jquery2.default)(this).data("id");
	      removeProductModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	        title: 'Channel Product Removal',
	        topCloseBtn: true,
	        autoHideTop: true,
	        leftAlignTitle: true,
	        modalDialogClass: 'q-modal-dialog-500',
	        body: removeProductModalBodyHtml,
	        footerBtns: "\n          <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a>\n          <a href=\"#\" class=\"base-btn purple-btn channel-remove-product-btn\">Remove Product</a>\n        "
	      }));
	      //add the modal to boday
	      (0, _jquery2.default)('body').append(removeProductModal);
	      removeProductModal.modal("show");
	    } else {
	      EditChecker.setPageDirty();
	      removeProductRow((0, _jquery2.default)(e.target));
	      handleDisplayOfCreateOrderTable();
	    }
	  }
	
	  function handleChannelProductRemovalModal() {
	    EditChecker.setPageDirty();
	    (0, _jquery2.default)("#" + removeId).remove();
	    removeProductModal.modal("hide");
	    handleDisplayOfCreateOrderTable();
	  }
	
	  function removeProductRow(el) {
	    var coreProduct = el.closest(".product-data-row");
	    coreProduct.remove();
	  }
	
	  function handleFacilityOnChange() {
	    var facId = elsPage.orderFulfillmentCenter.val();
	    //const facName = $('#order-fulfillment-center :selected').text();
	    if ((0, _general.isPresent)(facId)) {
	      hide(elsPage.autoFulfillToggle);
	      //elsPage.prodcutTabAvailableUnits.html(`Available</br>(${facName})`);
	      loadInventoryForFacility(facId);
	    } else {
	      show(elsPage.autoFulfillToggle);
	      //elsPage.prodcutTabAvailableUnits.html('Available');
	      loadInventoryForFacility(null);
	    }
	  }
	
	  function configureUOMDropdownBasedonOrderTypeAndDropShip() {
	    var productsRows = getItemsInCreateOrderTable();
	    var noOfRows = getItemsInCreateOrderTable().length;
	    if (noOfRows > 0 && doesOrderTypeorDropShipChanged()) {
	      for (var i = 0; i < noOfRows; i++) {
	        var skuEl = (0, _jquery2.default)(productsRows[i]).find(".products-tab-sku");
	        var sku = (0, _jquery2.default)(skuEl).val();
	        if ((0, _general.isPresent)(sku)) {
	          var item = filterItem(sku);
	          if (item != null && (0, _general.isPresent)(item[0])) {
	            var flag = evaluateUOMDropDown(item[0].itemsCaseDetails, item[0].type);
	            var uomEl = (0, _jquery2.default)(productsRows[i]).find(".products-tab-uom");
	            var uomDisable = (0, _jquery2.default)(uomEl).is(":disabled");
	            /** set the uom dropdown value to units*/
	            (0, _jquery2.default)(uomEl).val("Units").trigger("change");
	            if (uomDisable && flag) {
	              (0, _jquery2.default)(uomEl).prop("disabled", false);
	            } else if (!uomDisable && !flag) {
	              (0, _jquery2.default)(uomEl).prop('disabled', true);
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function doesOrderTypeorDropShipChanged() {
	    var currentOrderTypeVal = elsPage.orderTypeSelect.val();
	    var currentDropShipVal = elsPage.dropShipFlag.is(":checked");
	    var isChanged = false;
	    /*check for order type and drop ship change*/
	    if (currentOrderTypeVal !== prevOrderTypeVal || currentDropShipVal !== prevDropShipVal) {
	      isChanged = true;
	      /* update the previous values with current
	        values for next check*/
	      prevOrderTypeVal = currentOrderTypeVal;
	      prevDropShipVal = currentDropShipVal;
	    }
	    return isChanged;
	  }
	
	  function loadInventoryForFacility(facId) {
	    var skus = [];
	    var productsRows = getItemsInCreateOrderTable();
	    var noOfRows = getItemsInCreateOrderTable().length;
	
	    for (var i = 0; i < noOfRows; i++) {
	      var skuEl = (0, _jquery2.default)(productsRows[i]).find(".products-tab-sku");
	      var sku = (0, _jquery2.default)(skuEl).val();
	      if ((0, _general.isPresent)(sku)) {
	        skus.push(sku);
	      }
	    }
	
	    if (skus.length > 0) {
	      _jquery2.default.ajax({
	        url: typeAheadUrl,
	        type: 'POST',
	        data: {
	          'facId': facId,
	          'skuList': skus
	        },
	        dataType: 'JSON',
	        success: function success(data) {
	          getProductNamesAndItems(data);
	          var items = data.items;
	
	          var _loop = function _loop(_i) {
	            var skuEl = (0, _jquery2.default)(productsRows[_i]).find(".products-tab-sku");
	            var sku = (0, _jquery2.default)(skuEl).val();
	            if ((0, _general.isPresent)(sku)) {
	              var item = jQuery.map(items, function (obj) {
	                if (obj.itmSku === sku) return obj;
	              });
	
	              if (item != null && (0, _general.isPresent)(item[0])) {
	                (0, _jquery2.default)(productsRows[_i]).find(".availableUnitsOfProduct").text(item[0].availUnit);
	                var flag = evaluateUOMDropDown(item[0].itemsCaseDetails, item[0].type);
	                var uomEl = (0, _jquery2.default)(productsRows[_i]).find(".products-tab-uom");
	                var uomDisable = (0, _jquery2.default)(uomEl).is(":disabled");
	                /** set the uom dropdown value to units*/
	                (0, _jquery2.default)(uomEl).val("Units").trigger("change");
	                if (uomDisable && flag) {
	                  (0, _jquery2.default)(uomEl).prop("disabled", false);
	                } else if (!uomDisable && !flag) {
	                  (0, _jquery2.default)(uomEl).prop('disabled', true);
	                }
	                calculateAvailabilityBasedonUOM((0, _jquery2.default)(productsRows[_i]), (0, _jquery2.default)(uomEl).val());
	                var kitItems = item[0].kitItems;
	                if ((0, _general.isPresent)(kitItems) && kitItems.length > 0) {
	                  calculateAvailabilityForChildRow((0, _jquery2.default)(productsRows[_i]), kitItems, "Units");
	                }
	              }
	            }
	          };
	
	          for (var _i = 0; _i < noOfRows; _i++) {
	            _loop(_i);
	          }
	        }
	      });
	    }
	  }
	
	  function handleAddProducts() {
	    EditChecker.setPageDirty();
	    handleDisplayOfCreateOrderTable();
	  }
	
	  function instantiateSkuTypeAhead() {
	    var select2AjaxDefaults = {
	      dataType: 'json',
	      delay: 250,
	      processResults: function processResults(data, params) {
	        params.page = params.page || 1;
	        return {
	          results: getProductNamesAndItems(data),
	          pagination: {
	            more: params.page * 20 < data.total_count
	          }
	        };
	      },
	      cache: true
	    };
	
	    function configureDataCallback(_ref) {
	      var paramKey = _ref.paramKey;
	
	      return function (params) {
	        var _ref2;
	
	        return _ref2 = {}, _defineProperty(_ref2, paramKey, params.term), _defineProperty(_ref2, "facId", elsPage.orderFulfillmentCenter.val()), _ref2;
	      };
	    }
	
	    elsPage.productItemLookup.select2({
	      placeholder: "Begin typing a SKU to add to this order",
	      allowClear: true,
	      ajax: _extends({}, select2AjaxDefaults, {
	        url: typeAheadUrl,
	        cache: false,
	        data: configureDataCallback({
	          paramKey: 'likeSku'
	        })
	      }),
	      minimumInputLength: 3
	    });
	  }
	
	  var triggerAddProductsEvent = function triggerAddProductsEvent() {
	    elsPage.productOrBundleRow.trigger('addedproducts');
	  };
	
	  function getProductNamesAndItems(response) {
	    var items = response.items;
	    self.productItems.regularItems = items;
	    var productNameArr = response.productNameArr;
	    self.productNameArr.regularItems = productNameArr;
	    currentItemList = items;
	
	    var intrnlItems = _underscore2.default.filter(response.items, filterInternationalItem);
	    self.productItems.internationalItems = intrnlItems;
	
	    var intrnlProductNameArr = _underscore2.default.filter(response.productNameArr, filterInternationalProductName);
	    self.productNameArr.internationalItems = intrnlProductNameArr;
	
	    var countryVal = (0, _jquery2.default)('#destination-tab-country  :selected').val();
	    if (countryVal == 1) {
	      // USA
	      return productNameArr;
	    } else {
	      return intrnlProductNameArr;
	    }
	  }
	
	  function filterInternationalItem(item) {
	    if (item.itmInternationalShipping) return true;
	    return false;
	  }
	
	  function filterInternationalProductName(item) {
	    for (var i = 0; i < self.productItems.internationalItems.length; i++) {
	      var itemObj = self.productItems.internationalItems[i];
	      if (item.id == itemObj.itmSku) return true;
	    }
	    return false;
	  }
	
	  var addProducts = function addProducts(productName, parItmId, prodDescription, availUnit, prdType, parOriId) {
	    var highestId = parseInt((0, _jquery2.default)("#product-bundle-row .product-data-row:last").attr("id"));
	    if (isNaN(highestId)) {
	      highestId = 0;
	    } else {
	      ++highestId;
	    }
	
	    var currentItem = filterItem(productName);
	    var showErrorIconOnProductRow = showErrorIcon(productName, orderDetailsForEdit);
	    var productRow = (0, _render2.default)(productRowHtml, {
	      highestId: highestId,
	      portletNamespace: portletNamespace,
	      error: '',
	      unitOfMeasure: renderUnitOfMeasure(prdType, currentItem[0], highestId),
	      productId: renderProductId(productName, parItmId, prdType, showErrorIconOnProductRow, highestId, parOriId, portletNamespace),
	      productDescription: prodDescription,
	      productUnitsAvail: renderUnitPill(availUnit, "Units"),
	      availProdUnits: availUnit,
	      skuInvalid: renderSkuInvalidErrorHtml(productName, detailsForItemOnOrder, prdType),
	      missingCode: renderMissingHsCodeHtml((0, _jquery2.default)('#destination-tab-country  :selected').val(), productName, detailsForItemOnOrder),
	      skuInactive: renderSkuInactive(productName, detailsForItemOnOrder),
	      children: renderBundleChildren(productName, currentItem[0])
	    });
	    elsPage.productOrBundleRow.append(productRow);
	  };
	
	  function renderUnitPill(unit, measure) {
	    var pillClass = unit > 0 ? 'q-pill-white-and-grey' : 'q-pill-red';
	    return (0, _render2.default)(unitPillHtml, {
	      pillClass: pillClass,
	      unit: unit,
	      measure: measure
	    });
	  }
	
	  function renderUnitOfMeasure(prdType, currentItem, highestId) {
	    var itemCaseDtls = void 0;
	    if (currentItem != null) {
	      itemCaseDtls = currentItem.itemsCaseDetails;
	    } else {
	      itemCaseDtls = [{ "icdCaseType": "Master Case", "icdNumberOfUnits": "0" }];
	    }
	    var options = [{ "id": "Units", "text": "Units" }];
	    var unitsPerCase = 0;
	    var unitsPerPallet = 0;
	    if ((0, _general.isPresent)(itemCaseDtls)) {
	      _underscore2.default.each(itemCaseDtls, function (itemCase) {
	        var option = {};
	        if ((0, _general.isPresent)(itemCase.icdCaseType) && itemCase.icdCaseType === "Pallet") {
	          unitsPerPallet = itemCase.icdNumberOfUnits;
	          option["id"] = "Pallets";
	          option["text"] = "Pallets (" + itemCase.icdNumberOfUnits + " per Pallet)";
	          options.push(option);
	        } else if ((0, _general.isPresent)(itemCase.icdCaseType) && itemCase.icdCaseType === "Master Case") {
	          unitsPerCase = itemCase.icdNumberOfUnits;
	          option["id"] = "Cases";
	          option["text"] = "Cases (" + itemCase.icdNumberOfUnits + " per Case)";
	          options.push(option);
	        }
	      });
	    }
	
	    var dropDownOptions = (0, _underscore2.default)(options).map(function (item) {
	      var option = (0, _render2.default)(uomDropdownOption, {
	        id: item.id,
	        text: item.text
	      });
	      return option;
	    });
	
	    var isDisabled = evaluateUOMDropDown(itemCaseDtls, prdType) ? '' : 'disabled';
	    return (0, _render2.default)(unitOfMeasureHtml, {
	      highestId: highestId,
	      isDisabled: isDisabled,
	      dropDownOptions: dropDownOptions,
	      unitsPerCase: unitsPerCase,
	      unitsPerPallet: unitsPerPallet
	    });
	  }
	
	  function evaluateUOMDropDown(itemCaseDtls, prdType) {
	    var count = 0;
	    var facId = elsPage.orderFulfillmentCenter.val();
	    if ((0, _general.isPresent)(facId)) {
	      var currentFacility = filterFacility(parseInt(facId));
	      if ((0, _general.isPresent)(currentFacility[0]) && (0, _general.isPresent)(currentFacility[0].cmrAddressAttributes)) {
	        var attributes = currentFacility[0].cmrAddressAttributes;
	        var uomAttribute = filterAttribute(attributes);
	        if ((0, _general.isPresent)(uomAttribute[0])) {
	          count++;
	        }
	      }
	    }
	
	    if ((0, _general.isPresent)(itemCaseDtls)) {
	      count++;
	    }
	
	    var orderType = elsPage.orderTypeSelect.val();
	    if (orderType === "B2B") {
	      count++;
	    } else if (orderType != "B2C" && !elsPage.dropShipFlag.is(":checked")) {
	      count++;
	    }
	
	    if (prdType != 'Bundle') {
	      count++;
	    }
	    return count === 4;
	  }
	
	  function filterFacility(facId) {
	    var facilities = elsPage.orderFulfillmentCenter.data('options');
	    return _underscore2.default.filter(facilities, function (item) {
	      var cadFacId = parseInt(item.cadFacId);
	      if (cadFacId === facId) {
	        return true;
	      }
	    });
	  }
	
	  function filterAttribute(attributes) {
	    return _underscore2.default.filter(attributes, function (item) {
	      if ("UOM" === item.caaValue) {
	        return true;
	      }
	    });
	  }
	
	  function renderProductId(prodId, parItmId, prdType, error, highestId, parOriId, portletNamespace) {
	    var bundleIcon = void 0,
	        errorIcon = void 0;
	    if (prdType === 'Bundle') {
	      bundleIcon = "<i class=\"fa fa-cubes q-icon-lg q-icon-marg-right\" aria-hidden=\"true\"></i>";
	    }
	    if (error) {
	      errorIcon = "<i class=\"fa fa-exclamation-circle q-icon-md q-icon-marg-right txt-c-red\" aria-hidden=\"true\"></i>";
	    }
	    //prodId = `${prodId}`;
	    return (0, _render2.default)(productIdHtml, {
	      prodId: prodId,
	      parItmId: parItmId,
	      errorIcon: errorIcon,
	      bundleIcon: bundleIcon,
	      highestId: highestId,
	      parOriId: parOriId,
	      portletNamespace: portletNamespace
	    });
	  }
	
	  function renderBundleChildren(productName, currentItem) {
	    if (currentItem != null) {
	      var lineItem = currentItem.kitItems.map(function (item) {
	        return (0, _render2.default)(bundleChildBodyHtml, {
	          productSku: item.kitChildItmSku,
	          prodDesc: item.prdName,
	          productUnitsAvail: renderUnitPill(item.availUnit, "Units")
	        });
	      });
	      return lineItem.join('');
	    }
	  }
	
	  function filterItem(productName) {
	    return _underscore2.default.filter(currentItemList, function (item) {
	      if (item.itmSku === productName) {
	        return true;
	      }
	    });
	  }
	
	  function renderSkuInvalidErrorHtml(item, detailsForItemOnOrder, prdType) {
	    if (prdType === "Invalid") {
	      return (0, _render2.default)(skuInvalidErrorHtml, {});
	    }
	  }
	
	  function renderMissingHsCodeHtml(country, item, detailsForItemOnOrder) {
	    if ((0, _general.isPresent)(orderDetailsForEdit) && (0, _general.isPresent)(detailsForItemOnOrder)) {
	      var currentSku = _underscore2.default.findWhere(detailsForItemOnOrder, { itmSku: item });
	      if (country != 1) {
	        if ((0, _general.isPresent)(currentSku) && item.length > 0 && currentSku.itmHsCode == null) {
	          return (0, _render2.default)(missingHsCodeHtml, {});
	        } else {
	          return '';
	        }
	      } else {
	        return '';
	      }
	    } else {
	      return '';
	    }
	  }
	
	  function renderSkuInactive(item, detailsForItemOnOrder) {
	    if ((0, _general.isPresent)(detailsForItemOnOrder)) {
	      var currentSku = _underscore2.default.findWhere(detailsForItemOnOrder, { itmSku: item });
	      if ((0, _general.isPresent)(currentSku) && !currentSku.itmActive) {
	        return (0, _render2.default)(skuInactiveHtml, {});
	      } else {
	        return '';
	      }
	    }
	  }
	
	  self.checkIfBusinessExceptionsExist = function () {
	    var businessExceptionsExist = false;
	    var productRows = getItemsInCreateOrderTable();
	    _underscore2.default.each(productRows, function (productRow) {
	      if ((0, _jquery2.default)(productRow).find(".sku-invalid-error").length > 0 || (0, _jquery2.default)(productRow).find(".hs-code-missing").length > 0 || (0, _jquery2.default)(productRow).find(".sku-inactive-error").length > 0) {
	        businessExceptionsExist = true;
	      }
	    });
	    return businessExceptionsExist;
	  };
	
	  function showErrorIcon(currentItem, orderDetailsForEdit) {
	    var currentSku = "";
	    var showErrorIconForErrors = new Array("Invalid", "NotIntlSku", "Inactive");
	    if ((0, _general.isPresent)(orderDetailsForEdit)) {
	      currentSku = _underscore2.default.findWhere(orderDetailsForEdit.orderDetails.orderItems, { oriItmSku: currentItem });
	    }
	    if ((0, _general.isPresent)(currentSku) && _underscore2.default.contains(showErrorIconForErrors, currentSku.oriStatus)) {
	      return true;
	    } else {
	      return false;
	    }
	  }
	}

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReviewTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _general = __webpack_require__(5);
	
	var _util = __webpack_require__(34);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var productRowReviewTabHtml = __webpack_require__(1383);
	var unitPillHtml = __webpack_require__(309);
	var bundleChildBodyOnReviewTabHtml = __webpack_require__(1372);
	
	var elementsMap = {
	  allDestinationAreas: ".review-tab-customer-group",
	
	  palletMessage: ".pallet-message",
	
	  orderReferenceNumberOuterReviewTab: ".review-tab-order-reference-number-outer",
	  orderReferenceNumber: "#orderReferenceNumber",
	  orderReferenceNumberReviewTab: ".review-tab-order-reference-number-val",
	
	  dropShipSectionDiv: ".review-tab-dropship-section",
	  dropShipSectionVal: ".review-tab-dropship-val",
	  dropshipFlag: "#dropShipFlag",
	
	  reviewTabOrderTypeVal: ".review-tab-order-type-val",
	  reviewTabOrderFulfillmentCenterVal: ".review-tab-order-fulfillment-center-val",
	  destinationTabOrderType: "#destination-tab-order-type-select",
	  destinationTabOrderFulfillmentCenter: "#order-fulfillment-center",
	
	  shippingTypeOuterReviewTab: ".review-tab-shipping-type-outer",
	  shippingTypeSelect: "#shipping-tab-shipping-type-select",
	  shippingTypeReviewTab: ".review-tab-shipping-type-val",
	
	  // LTL ONLY
	  // allow for 'other' box
	  facilityOuterReviewTab: ".review-tab-facility-outer",
	  businessName: "#destination-tab-business-name",
	  retailerType: "#destinationTab-typeahead",
	  facilityReviewTab: ".review-tab-facility-val",
	
	  // BOTH
	  customerEmailOuterReviewTab: ".review-tab-shipping-email-outer",
	  customerEmailBtoB: "#destination-tab-btob-customerEmail",
	  customerEmail: "#destination-tab-customerEmail",
	  customerEmailReviewTab: ".review-tab-shipping-email-val",
	
	  // PARCEL ONLY
	  customerNameOuterReviewTab: ".review-tab-customer-name-outer",
	  customerName: "#customerName",
	  customerNameReviewTab: ".review-tab-customer-name-val",
	
	  // LTL ONLY
	  contactNameOuterReviewTab: ".review-tab-contact-name-outer",
	  contactName: "#destination-tab-contactName",
	  contactNameReviewTab: ".review-tab-contact-name-val",
	
	  // PARCEL ONLY
	  companyNameOuterReviewTab: ".review-tab-company-outer",
	  companyName: "#company",
	  companyNameReviewTab: ".review-tab-company-val",
	
	  // LTL ONLY
	  destinationNameOuterReveiewTab: ".review-tab-destination-name-outer",
	  destinationName: "#destination-tab-destination-name",
	  destinationNameReviewTab: ".review-tab-destination-name-val",
	
	  // BOTH
	  sendTrackingInfoOuterReviewTab: ".review-tab-notifiction-email-outer",
	  sendTrackingInfo: "#destination-tab-sendTrackingInfo",
	  sendTrackingInfoBtoB: "#destination-tab-btob-sendTrackingInfo",
	  sendTrackingInfoReviewTab: ".review-tab-shipping-notifiction-email-val",
	
	  // BOTH
	  customerPhoneNumberReviewTab: ".review-tab-phone-number-val",
	  customerPhoneNumber: "#destination-tab-customerPhoneNumber",
	  customerPhoneNumberBtoB: "#destination-tab-btob-customerPhoneNumber",
	  customerCountryPhoneCode: "#destination-tab-country-phone-code",
	  customerCountryPhoneCodeBtoB: "#destination-tab-b2b-country-phone-code",
	
	  // BOTH
	  address1: "#destination-tab-address1",
	  address2: "#destination-tab-address2",
	  city: "#destination-tab-city",
	  state: "#destination-tab-state",
	  stateOther: "#destination-tab-stateText",
	  zip: "#destination-tab-zipCode",
	  country: "#destination-tab-country",
	  addressReviewTab: ".review-tab-address-val",
	  addressOuterReviewTab: ".review-tab-address-outer",
	  phoneNumberReviewTab: ".review-tab-phone-number-outer",
	
	  shippingReleaseReviewTab: ".review-tab-order-release-val",
	  shippingRelease: "#shipping-tab-order-release-type",
	
	  shippingReleaseDateReviewTab: ".review-tab-order-release-date-val",
	  shippingReleaseDate: "#scheduleReleaseDate",
	  shippingDateAndTime: "#standardDateAndTime",
	
	  shippingMethodReviewTab: ".review-tab-shipping-method-val",
	  shippingTabUsa: "#shipping-tab-shipping-method-with-usa",
	  shippingTabCanada: "#shipping-tab-shipping-method-with-canada",
	  shippingTabOther: "#shipping-tab-shipping-method-other",
	  shippingTabAkHw: "#shipping-tab-shipping-method-with-ak-hw",
	  productsTableProductsTab: "#product-bundle-row",
	  productsTableBodyReviewTab: ".review-tab-products-table-body",
	  sectionTitlesReviewTab: ".section-step-title-inner",
	  reviewTabFreightCostsOuter: ".review-tab-freight-costs-outer",
	  reviewTabFreightCosts: ".review-tab-freight-costs-val",
	  freightCosts: "#freight-costs",
	  reviewTabInsuranceCostsOuter: ".review-tab-insurance-costs-outer",
	  reviewTabInsuranceCosts: ".review-tab-insurance-costs-val",
	  insuranceCosts: "#insurance-costs",
	  reviewTabDutiesTaxesOuter: ".review-tab-duties-taxes-outer",
	  reviewTabDutiesTaxes: ".review-tab-duties-taxes-val",
	  dutiesTaxes: "#duties-taxes",
	
	  shippingTabIsAGiftCheckbox: "#gift-checkbox",
	  ordExcludeCollateralCheckbox: "#exclude-collateral",
	  ordBulkPackagingCheckbox: "#bulk-packaging",
	  shippingTabGiftTextArea: "#gift-textarea",
	  reviewTabIsAGiftVal: ".review-tab-order-is-a-gift-val",
	  reviewTabGiftMessageVal: ".review-tab-gift-message-val",
	  reviewTabOrderIsAGiftOuter: ".review-tab-order-is-a-gift-outer",
	  reviewTabGiftMessageOuter: ".review-tab-gift-message-outer",
	  createOrderSubmitBtn: ".create-button",
	  giftPackagingValOn: ".gift-packaging-val-on",
	  giftPackagingValOff: ".gift-packaging-val-off",
	  reviewOrdBulkPackagingValOn: ".review-ord-bulk-packaging-val-on",
	  reviewOrdBulkPackagingValOff: ".review-ord-bulk-packaging-val-off",
	  reviewOrdExcludeCollateralValOn: ".review-ord-ex-coll-val-on",
	  reviewOrdExcludeCollateralValOff: ".review-ord-ex-coll-val-off",
	  reviewOrdBulkPackagingMsg: ".review-ord-bulk-packaging-msg",
	  reviewOrdExcludeCollateralMsg: ".review-ord-ex-coll-val-msg",
	
	  shippingTabServiceLevelUsa: "#shipping-tab-shipping-service-level-with-usa",
	  reviewTabServiceLevelUsa: ".review-tab-shipping-method-with-usa-rate-shopping",
	  reviewTabServiceLevelUsaWrapper: ".review-tab-shipping-method-with-usa-rate-shopping-wrapper",
	
	  shippingTabEstimatedDeliveryDate: ".estimated-delivery-date-picker",
	  reviewTabEstimatedDeliveryDate: ".review-tab-estimated-delivery-date",
	  reviewTabEstimatedDeliveryDateWrapper: ".review-tab-estimated-delivery-date-wrapper",
	
	  shippingTabFedExShippingMethodValueCheck: "#fedex-shipping-method-btn-value-check",
	  shippingTabServiceLevelsValueCheck: "#service-levels-btn-value-check",
	
	  reviewTabShippingMethodWrapper: ".review-tab-shipping-method-with-usa-wrapper",
	  reviewTabServiceLevelWrapper: ".review-tab-shipping-method-with-usa-rate-shopping-wrapper",
	
	  reviewTabShippingMethod: ".review-tab-shipping-method-with-usa",
	
	  //7775 changes for Accessorial declarations
	  reviewOrdSignatureOptionSelect: "#signature-options-select",
	  reviewOrdSignatureOptionVal: ".review-tab-signature-options-val",
	  reviewOrdSaturdayDeliveryCheckebox: "#saturday-delivery-checkbox",
	  reviewOrdSaturdayDeliveryVal: ".review-tab-sat-delivery-val",
	  reviewOrdSaturdayDeliveryLabel: ".review-tab-satural-label",
	  reviewOrdAccessorialDiv: ".review-accessorial-section",
	  declaredValueCheckbox: "#declared-value-checkbox",
	  reviewDeclaredValueDiv: "#review-tab-dvl-div",
	  reviewDeclaredValue: "#review-tab-dvl-value",
	
	  productsSectionOnReviewTab: ".product-row-on-review-tab",
	  productRowOnReviewTab: ".review-tab-products-row",
	
	  childProductRowOnReviewTab: "review-tab-child-products-row",
	
	  retainChannelShipmentMethodSwitch: "#channelShippingMethodCheck",
	  channelShippingMethod: "#channel-shipping-method"
	
	};
	
	var productItemsMap = {
	  quantityInput: ".products-tab-quantity-input",
	  name: ".products-tab-product-name",
	  body: ".products-tab-product-description",
	  available: ".products-tab-parent-avail-units",
	  productUom: ".products-tab-uom",
	  availqty: ".products-tab-available-qty"
	};
	
	var childProductMap = {
	  name: ".products-tab-child-product-name",
	  body: ".products-tab-child-product-description",
	  available: ".products-tab-child-available-units",
	  availqty: ".products-tab-available-qty"
	};
	
	function ReviewTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	
	  self.didNavigateToForm = function () {
	    fillElementsWithVals();
	    fillProductsInReviewTab();
	  };
	
	  self.init = function () {
	    setElements();
	    bindElements();
	  };
	
	  function bindElements() {
	    els.sectionTitlesReviewTab.bind('click', function () {
	      var form = wizardElement.find((0, _jquery2.default)(this).data("target-form"));
	      wizard.gotToForm(form);
	    });
	  }
	
	  function setElementsFromScope(targetObj, elementsDict, scope) {
	    (0, _underscore2.default)(elementsDict).each(function (v, k) {
	      targetObj[k] = scope.find(v);
	    });
	  }
	
	  function setElements() {
	    setElementsFromScope(els, elementsMap, wizardElement);
	    els.giftPackagingValOn.hide();
	    els.giftPackagingValOff.hide();
	    els.reviewOrdBulkPackagingValOn.hide();
	    els.reviewOrdBulkPackagingValOff.hide();
	    els.reviewOrdExcludeCollateralValOn.hide();
	    els.reviewOrdExcludeCollateralValOff.hide();
	    els.reviewOrdBulkPackagingMsg.hide();
	    els.reviewOrdExcludeCollateralMsg.hide();
	  }
	
	  function fillProductsInReviewTab() {
	    els.productsSectionOnReviewTab.text("");
	    var products = els.productsTableProductsTab.find('.product-data-row');
	    products.each(function () {
	      var product = (0, _jquery2.default)(this);
	      var productDetailEls = {};
	      var bundleIcon = '<i class="fa fa-cubes q-icon-marg-left" aria-hidden="true"></i>';
	      setElementsFromScope(productDetailEls, productItemsMap, product);
	
	      var childProducts = product.find(".bundle-child-product-row");
	      if (childProducts && childProducts.length) {
	        var childProductsRows = "";
	        childProducts.each(function () {
	          var childProduct = (0, _jquery2.default)(this);
	          var childProductEls = {};
	          setElementsFromScope(childProductEls, childProductMap, childProduct);
	          if (childProductsRows == "") {
	            childProductsRows = fillChildProducts(childProductEls);
	          } else {
	            childProductsRows = childProductsRows + fillChildProducts(childProductEls);
	          }
	        });
	
	        fillProductInReviewTab(productDetailEls, bundleIcon, childProductsRows);
	      } else {
	        fillProductInReviewTab(productDetailEls, "", "");
	      }
	    });
	  }
	
	  function fillProductInReviewTab(pEls, bundleIcon, childProducts) {
	    var productRow = (0, _render2.default)(productRowReviewTabHtml, {
	      orderedQty: renderOrderQty(pEls.quantityInput.val(), pEls.productUom.find(":selected").text()),
	      unitOfMeasure: renderUnitsOfMeasureQty(pEls.productUom.find(":selected").text()),
	      productId: pEls.name.text(),
	      productDescription: pEls.body.text(),
	      productUnitsAvail: renderUnitPill(pEls.availqty.val(), pEls.productUom.find(":selected").val()),
	      bundleIcon: bundleIcon,
	      children: childProducts
	    });
	    els.productsSectionOnReviewTab.append(productRow);
	  }
	
	  function renderOrderQty(orderQty, orderUom) {
	    if (orderQty == "1") {
	      if (orderUom.indexOf("Pallet") != -1) {
	        return orderQty + " " + "Pallet";
	      } else if (orderUom.indexOf("Case") != -1) {
	        return orderQty + " " + "Case";
	      } else if (orderUom.indexOf("Unit") != -1) {
	        return orderQty + " " + "Unit";
	      }
	    } else {
	      if (orderUom.indexOf("Pallet") != -1) {
	        return orderQty + " " + "Pallets";
	      } else if (orderUom.indexOf("Case") != -1) {
	        return orderQty + " " + "Cases";
	      } else if (orderUom.indexOf("Unit") != -1) {
	        return orderQty + " " + "Units";
	      }
	    }
	  }
	
	  function renderUnitsOfMeasureQty(orderUom) {
	    var unitsPerUom = " ";
	    if (orderUom.indexOf("Units") == -1) {
	      var uomqtyBegin = orderUom.indexOf("(");
	      var uomqtyEnd = orderUom.indexOf(")");
	      unitsPerUom = orderUom.substring(uomqtyBegin, uomqtyEnd + 1);
	    }
	    return unitsPerUom;
	  }
	
	  function fillChildProducts(pEls) {
	    var childProducts = (0, _render2.default)(bundleChildBodyOnReviewTabHtml, {
	      productSku: pEls.name.text(),
	      prodDesc: pEls.body.text(),
	      productUnitsAvail: renderUnitPill(pEls.availqty.val(), "Units")
	    });
	
	    return childProducts;
	  }
	
	  function renderUnitPill(unit, measure) {
	    var pillClass = unit > 0 ? 'q-pill-white-and-grey' : 'q-pill-red';
	    return (0, _render2.default)(unitPillHtml, {
	      pillClass: pillClass,
	      unit: unit,
	      measure: measure
	    });
	  }
	
	  function fillElementsWithVals() {
	    hideAllDesinationAreas();
	    fillGlobal();
	    if (isB2B()) {
	      fillB2B();
	    } else {
	      fillB2C();
	    }
	
	    fillShippingAreas();
	  }
	
	  function hideAllDesinationAreas() {
	    hide(els.allDestinationAreas);
	  }
	
	  function hide(el) {
	    el.css({ display: "none" });
	  }
	
	  function show(el) {
	    el.css({ display: "block" });
	  }
	
	  function showHideDropFlag(cotCode) {
	    var consolidatedOrderTypeList = els.destinationTabOrderType.data("consolidated-order-type-list");
	    var groupedOrderTypeList = _underscore2.default.groupBy(consolidatedOrderTypeList, 'ortTypeCode');
	    var orderTypeList = groupedOrderTypeList[cotCode] || [];
	
	    var found = _underscore2.default.findIndex(orderTypeList, function (value) {
	      return !(0, _util.isNull)(value.ortDropShip);
	    });
	
	    els.dropShipSectionDiv.addClass('hidden');
	    if (found >= 0) {
	      els.dropShipSectionDiv.removeClass('hidden');
	      var dropShipFlagVal = els.dropshipFlag.is(":checked");
	      if (dropShipFlagVal) {
	        els.dropShipSectionVal.text("Yes");
	        els.dropshipFlag.attr("value", "true");
	      } else {
	        els.dropShipSectionVal.text("No");
	        els.dropshipFlag.attr("value", "false");
	      }
	    }
	  }
	
	  function fillGlobal() {
	    els.orderReferenceNumberReviewTab.text(els.orderReferenceNumber.val());
	    els.shippingTypeReviewTab.text(selectShippingType(els.shippingTypeSelect));
	    els.customerEmailReviewTab.text(getCustomerEmail());
	    els.sendTrackingInfoReviewTab.text(trackingInfoBoolToHtml());
	    els.addressReviewTab.text(addressFormatted());
	    els.customerPhoneNumberReviewTab.text(getPhoneNumber());
	    els.reviewTabOrderTypeVal.text((0, _jquery2.default)("#destination-tab-order-type-select option:selected").text());
	    showHideDropFlag(els.destinationTabOrderType.val());
	
	    var reviewTabOrderFulfillmentCenterVar = (0, _jquery2.default)('#order-fulfillment-center :selected').text();
	    //7775  changes for Accessorial START
	    var ordSignatureOpt = (0, _jquery2.default)("#signature-options-select option:selected").text();
	    //If accessorial values are not selected or are disabled,do not show accessorial section on the review tab
	    if ((ordSignatureOpt == 'Select signature option' || ordSignatureOpt == '') && !els.reviewOrdSaturdayDeliveryCheckebox.is(":checked") && !els.declaredValueCheckbox.is(":checked")) {
	      els.reviewOrdAccessorialDiv.hide();
	    } else {
	      els.reviewOrdAccessorialDiv.show();
	    }
	
	    if (ordSignatureOpt == 'Select signature option' || ordSignatureOpt == '') {
	      els.reviewOrdSignatureOptionVal.text("");
	    } else {
	      els.reviewOrdSignatureOptionVal.text(ordSignatureOpt);
	    }
	    if (els.declaredValueCheckbox.is(":checked")) {
	      els.reviewDeclaredValueDiv.show();
	      els.reviewDeclaredValue.text("Yes");
	    } else {
	      els.reviewDeclaredValueDiv.hide();
	      els.reviewDeclaredValue.text("");
	    }
	    if (els.reviewOrdSaturdayDeliveryCheckebox.is(":checked")) {
	      els.reviewOrdSaturdayDeliveryLabel.show();
	      els.reviewOrdSaturdayDeliveryVal.text("Yes");
	    } else {
	      els.reviewOrdSaturdayDeliveryLabel.hide();
	      els.reviewOrdSaturdayDeliveryVal.text("");
	    }
	
	    //7775 changes for Accessorial END
	
	    if (reviewTabOrderFulfillmentCenterVar === '') {
	      els.reviewTabOrderFulfillmentCenterVal.text('Automated Fulfillment');
	    } else {
	      els.reviewTabOrderFulfillmentCenterVal.text('Force Fulfill (' + (0, _jquery2.default)('#order-fulfillment-center :selected').text() + ')');
	    }
	
	    var showable = combineElements([els.shippingTypeOuterReviewTab, els.orderReferenceNumberOuterReviewTab, els.customerEmailOuterReviewTab, els.sendTrackingInfoOuterReviewTab, els.addressOuterReviewTab, els.phoneNumberReviewTab]);
	    show(showable);
	  }
	
	  function combineElements(arr) {
	    var output = (0, _jquery2.default)();
	    (0, _underscore2.default)(arr).each(function (el) {
	      output = output.add((0, _jquery2.default)(el));
	    });
	    return output;
	  }
	
	  function selectVal(el) {
	    var val = el.val();
	    if (val === "-1") {
	      val = "";
	    }
	    return val;
	  }
	
	  function selectShippingType(el) {
	    var val = el.find(":selected").text();
	    if (val === "-1") {
	      val = "";
	    }
	    return val;
	  }
	
	  function fillB2B() {
	    els.facilityReviewTab.text((0, _jquery2.default)("#destinationTab-typeahead option:selected").text());
	    els.contactNameReviewTab.text(els.contactName.val());
	    els.destinationNameReviewTab.text(els.destinationName.val());
	
	    var showable = combineElements([els.facilityOuterReviewTab, els.contactNameOuterReviewTab, els.destinationNameOuterReveiewTab]);
	
	    show(showable);
	  }
	
	  function fillB2C() {
	    els.customerNameReviewTab.text(els.customerName.val());
	    els.companyNameReviewTab.text(els.companyName.val());
	
	    var showable = combineElements([els.customerNameOuterReviewTab, els.companyNameOuterReviewTab]);
	    show(showable);
	  }
	
	  function fillShippingAreas() {
	    hide(els.palletMessage);
	    hide(els.reviewTabGiftMessageOuter);
	    hideCostInfo();
	    var isAGiftChecked = els.shippingTabIsAGiftCheckbox.is(":checked");
	    var isAExCollChecked = els.ordExcludeCollateralCheckbox.is(":checked");
	    var isABulkPackChecked = els.ordBulkPackagingCheckbox.is(":checked");
	    var giftMesssage = els.shippingTabGiftTextArea.val();
	    var shippingReleaseVal = selectVal(els.shippingRelease);
	    els.shippingReleaseReviewTab.text(shippingReleaseVal);
	
	    var shippingReleaseDateVal = "";
	
	    if (shippingReleaseVal === "Scheduled Release") {
	      shippingReleaseDateVal = els.shippingDateAndTime.val() + ' ET';
	    }
	
	    els.shippingReleaseDateReviewTab.text(shippingReleaseDateVal);
	
	    var shippingMethodVal = "";
	    var shippingServiceLevelVal = "";
	    var estimatedDlvyDateVal = "";
	    var shippingTabEstimatedDeliveryDateVal = "";
	    var shippingTabFedExShippingMethodValueCheckVal = "";
	    var shippingTabServiceLevelsValueCheckVal = "";
	    if (!isLTL()) {
	      if (isUsa()) {
	        if (isAkHw()) {
	          shippingMethodVal = els.shippingTabAkHw.val();
	        } else {
	          shippingMethodVal = els.shippingTabUsa.val();
	          shippingServiceLevelVal = els.shippingTabServiceLevelUsa.find('option:selected').text();
	          shippingTabEstimatedDeliveryDateVal = els.shippingTabEstimatedDeliveryDate.val();
	          shippingTabFedExShippingMethodValueCheckVal = els.shippingTabFedExShippingMethodValueCheck.val();
	          shippingTabServiceLevelsValueCheckVal = els.shippingTabServiceLevelsValueCheck.val();
	
	          if (shippingTabFedExShippingMethodValueCheckVal == "true") {
	            els.reviewTabShippingMethod.text(els.shippingTabUsa.find('option:selected').text());
	            els.reviewTabEstimatedDeliveryDateWrapper.hide();
	            els.reviewTabServiceLevelUsaWrapper.hide();
	            els.reviewTabShippingMethodWrapper.show();
	          }
	
	          if (shippingTabServiceLevelsValueCheckVal == "true") {
	            els.reviewTabShippingMethod.text(shippingServiceLevelVal);
	            els.reviewTabEstimatedDeliveryDateWrapper.show();
	            els.reviewTabServiceLevelUsaWrapper.show();
	            els.reviewTabServiceLevelUsa.text(shippingServiceLevelVal);
	            els.reviewTabEstimatedDeliveryDate.text(shippingTabEstimatedDeliveryDateVal);
	            els.reviewTabShippingMethodWrapper.hide();
	          }
	        }
	      } else if (isCanada()) {
	        shippingMethodVal = els.shippingTabCanada.val();
	        // hide rating and estimate delivery date for international orders
	        els.reviewTabShippingMethod.text(shippingMethodVal);
	        els.reviewTabServiceLevelUsaWrapper.hide();
	        els.reviewTabEstimatedDeliveryDateWrapper.hide();
	        showCostInfo();
	      } else {
	        shippingMethodVal = els.shippingTabOther.val();
	        // hide rating and estimate delivery date for international orders
	        els.reviewTabShippingMethod.text(shippingMethodVal);
	        els.reviewTabServiceLevelUsaWrapper.hide();
	        els.reviewTabEstimatedDeliveryDateWrapper.hide();
	        showCostInfo();
	      }
	    } else {
	      shippingMethodVal = "LTL";
	      show(els.palletMessage);
	      els.reviewTabEstimatedDeliveryDateWrapper.hide();
	      els.reviewTabShippingMethodWrapper.hide();
	      els.reviewTabServiceLevelUsaWrapper.hide();
	    }
	
	    //If the Channel order retain flag is selected, set the value from the text box 
	    if (els.retainChannelShipmentMethodSwitch.is(":checked")) {
	      els.reviewTabShippingMethod.text(els.channelShippingMethod.val());
	      els.reviewTabServiceLevelUsaWrapper.hide();
	      els.reviewTabEstimatedDeliveryDateWrapper.hide();
	    }
	
	    // copy gift checkbox value to review tab
	    if ((0, _general.isPresent)(giftMesssage)) {
	      els.reviewTabGiftMessageVal.text(giftMesssage);
	    }
	
	    // copy Bulk Packaging checkbox value to review tab
	    if (isABulkPackChecked) {
	      els.reviewOrdBulkPackagingValOn.show();
	      els.reviewOrdBulkPackagingValOff.hide();
	      els.reviewOrdBulkPackagingMsg.show();
	    } else {
	      els.reviewOrdBulkPackagingValOn.hide();
	      els.reviewOrdBulkPackagingValOff.show();
	      els.reviewOrdBulkPackagingMsg.hide();
	    }
	
	    // copy Exclude Collateral checkbox value to review tab
	    if (isAExCollChecked) {
	      els.reviewOrdExcludeCollateralValOn.show();
	      els.reviewOrdExcludeCollateralValOff.hide();
	      els.reviewOrdExcludeCollateralMsg.show();
	    } else {
	      els.reviewOrdExcludeCollateralValOn.hide();
	      els.reviewOrdExcludeCollateralValOff.show();
	      els.reviewOrdExcludeCollateralMsg.hide();
	    }
	    els.shippingMethodReviewTab.text(shippingMethodVal);
	    els.reviewTabServiceLevelUsa.text(shippingServiceLevelVal);
	    els.reviewTabEstimatedDeliveryDate.text(shippingTabEstimatedDeliveryDateVal);
	  }
	
	  function showCostInfo() {
	    els.reviewTabFreightCosts.text(els.freightCosts.val());
	    els.reviewTabInsuranceCosts.text(els.insuranceCosts.val());
	    els.reviewTabDutiesTaxes.text(els.dutiesTaxes.val());
	
	    var showable = combineElements([els.reviewTabFreightCostsOuter, els.reviewTabInsuranceCostsOuter, els.reviewTabDutiesTaxesOuter]);
	    show(showable);
	  }
	
	  function hideCostInfo() {
	    var hideable = combineElements([els.reviewTabFreightCostsOuter, els.reviewTabInsuranceCostsOuter, els.reviewTabDutiesTaxesOuter]);
	    hide(hideable);
	  }
	
	  function trackingInfoBoolToHtml() {
	    var checked = false;
	    if (isB2B()) {
	      checked = els.sendTrackingInfoBtoB.is(":checked");
	    } else {
	      checked = els.sendTrackingInfo.is(":checked");
	    }
	
	    if (checked) {
	      return "Yes";
	    } else {
	      return "No";
	    }
	  }
	
	  function addressFormatted() {
	    var output = (els.address1.val() + '\n          ' + els.address2.val() + '\n          ' + els.city.val() + ',\n          ' + (els.state.val() == null ? '' : els.state.val()) + '\n          ' + els.zip.val() + '\n          ' + els.country.find(":selected").text()).replace(/ +(?= )/g, '');
	    return output;
	  }
	
	  function getPhoneNumber() {
	    var phoneNumber = "";
	    if (isB2B()) {
	      phoneNumber = els.customerCountryPhoneCodeBtoB.val() + " " + els.customerPhoneNumberBtoB.val();
	    } else {
	      phoneNumber = els.customerCountryPhoneCode.val() + " " + els.customerPhoneNumber.val();
	    }
	    return phoneNumber;
	  }
	
	  function getCustomerEmail() {
	    var customerEmail = "";
	    if (isB2B()) {
	      customerEmail = els.customerEmailBtoB.val();
	    } else {
	      customerEmail = els.customerEmail.val();
	    }
	    return customerEmail;
	  }
	
	  function isB2C() {
	    return !!(els.shippingTypeSelect.val() === "B2C");
	  }
	
	  function isLTL() {
	    return !!(els.shippingTypeSelect.val() === "LTL");
	  }
	
	  function isB2B() {
	    return !!(els.destinationTabOrderType.val() === "B2B");
	  }
	
	  function isUsa() {
	    var countryVal = els.country.val();
	
	    return countryVal === "1";
	  }
	
	  function isCanada() {
	    var countryVal = els.country.val();
	
	    return countryVal === "2";
	  }
	
	  function isAkHw() {
	    var stateVal = els.state.val();
	    return stateVal === "HI" || stateVal === "AK";
	  }
	}

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ProductsTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var elementsPageMap = {
	  productItemLookup: "#product-item-lookup"
	};
	
	function ProductsTab(wizard) {
	  var self = this;
	  var elsPage = {};
	  var wizardElement = wizard.getWizardElement();
	  var items = wizardElement.data("items");
	  var productArryJSON = wizardElement.data("product-name-arr");
	  var portletNamespace = wizardElement.data("portlet-namespace");
	
	  self.init = function () {
	    setElements();
	    setWidgets();
	    bindElements();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, wizardElement);
	  };
	
	  function setWidgets() {
	    instantiateSkuTypeAhead();
	    var productItemLookup = elsPage.productItemLookup;
	    productItemLookup.on("select2:select", function () {
	      (0, _jquery2.default)(".no-products-added-error-msg").hide();
	      var res = productItemLookup.select2('data')[0].text.split("--");
	      addProducts(res[0], res[1], res[2], res[3]);
	      productItemLookup.val(null).trigger('change');
	    });
	  }
	
	  function bindElements() {
	    (0, _jquery2.default)(document).on('click', '#product-tab-create-ord .icon-remove', removeProductRelatedRows);
	  }
	
	  function instantiateSkuTypeAhead() {
	
	    var select2AjaxDefaults = {
	      dataType: 'json',
	      delay: 250,
	      processResults: function processResults(data, params) {
	        params.page = params.page || 1;
	        return {
	          results: getProductNamesAndItems(data),
	          pagination: {
	            more: params.page * 20 < data.total_count
	          }
	        };
	      },
	      cache: true
	    };
	
	    function configureDataCallback(_ref) {
	      var paramKey = _ref.paramKey;
	
	      return function (params) {
	        return _defineProperty({}, paramKey, params.term);
	      };
	    }
	
	    elsPage.productItemLookup.select2({
	      placeholder: "Type product name (SKU)",
	      allowClear: true,
	      ajax: _extends({}, select2AjaxDefaults, {
	        url: wizardElement.data("get-product-names-and-items-url"),
	        data: configureDataCallback({
	          paramKey: 'likeSku'
	        })
	      }),
	      minimumInputLength: 3
	    });
	  }
	
	  function getProductNamesAndItems(response) {
	    items = response.items;
	    return response.productNameArr;
	  }
	
	  var addProducts = function addProducts(productName, prodDescription, availUnit, prdType) {
	    if ((0, _jquery2.default)("#product-tab-create-ord tbody tr").length >= 10) {
	      (0, _jquery2.default)('#maxProductErrorModal').modal("show");
	      return;
	    }
	    var highestId = parseInt((0, _jquery2.default)("#product-tab-create-ord tbody tr:last").attr("id"));
	    if (isNaN(highestId)) {
	      highestId = 0;
	    } else {
	      ++highestId;
	    }
	
	    var productRow = (0, _jquery2.default)('<tr id=' + highestId + ' class="product-item">').append((0, _jquery2.default)('<td class="vert-middle">').append((0, _jquery2.default)('<input type="number">').attr('id', portletNamespace + 'quantity' + highestId).attr('name', 'quantity' + '_row_' + highestId).attr('min', '1').attr('class', 'form-control required ' + portletNamespace + 'quantity q-input text-center products-tab-quantity-input jqv-whole-number').attr('placeholder', "Quantity").attr('value', "1")).append((0, _jquery2.default)('<input type="hidden">').attr('name', 'prodTabSku').attr('value', productName + "_row_" + highestId))).append((0, _jquery2.default)('<td class="vert-middle">').append((0, _jquery2.default)('<span class="text-purple products-tab-product-name">').attr('id', productName + '_row_' + highestId).text(productName)).append((0, _jquery2.default)('<input type="hidden">').attr('name', 'prodTabProductName' + '_row_' + highestId).attr('value', productName))
	    //.append(determineBundleIcon(prdType))
	    ).append((0, _jquery2.default)('<td class="vert-middle">').append((0, _jquery2.default)('<span class="products-tab-product-description">').attr('name', portletNamespace + 'prodDescription').attr('id', portletNamespace + 'prodDescription').text(prodDescription)).append((0, _jquery2.default)('<input type="hidden">').attr('name', 'prodTabProdDescription' + '_row_' + highestId).attr('value', prodDescription))).append((0, _jquery2.default)('<td class="text-center vert-middle">').append((0, _jquery2.default)('<span>').attr('id', 'delete_row' + highestId).attr('class', 'icon-remove').attr('style', 'cursor: pointer;')
	    // .attr('onclick', 'removeRow('+ 'delete_row' + highestId +')')
	    ));
	
	    (0, _jquery2.default)("#product-tab-create-ord").find('tbody').append(productRow);
	
	    if (prdType === "Bundle") {
	      //append child products
	      _underscore2.default.each(items, function (item) {
	        var childRows = [];
	        if (item.itmSku === productName) {
	          var kitItems = item.kitItems;
	          var idVal = 0;
	          _underscore2.default.each(kitItems, function (kitItem) {
	            idVal++;
	            var childRow = (0, _jquery2.default)('<tr id=' + idVal + ' class="product-item-child">').append((0, _jquery2.default)('<td class="vert-middle">')).append((0, _jquery2.default)('<td class="vert-middle">').append((0, _jquery2.default)('<i class="fa fa-level-down q-icon-marg-right q-icon-marg-left" aria-hidden="true"></i>')).append((0, _jquery2.default)('<span class="text-purple products-tab-child-product-name">').attr('id', kitItem.kitChildItmSku + '_row_' + idVal).text(kitItem.kitChildItmSku))).append((0, _jquery2.default)('<td class="vert-middle">').append((0, _jquery2.default)('<span class="products-tab-child-product-description">').attr('name', portletNamespace + 'prodDescription').attr('id', portletNamespace + 'prodDescription').text(kitItem.prdName))).append((0, _jquery2.default)('<td class="vert-middle">'));
	
	            productRow.after(childRow);
	            childRows.push(childRow);
	          });
	
	          productRow.data("childProducts", childRows);
	        }
	      });
	    }
	  };
	
	  self.loadProductsOnLoad = function () {
	    (0, _jquery2.default)(items).each(function () {
	      loadProducts(this.itmSku, this.prdNameAndAttributes);
	    });
	  };
	
	  var loadProducts = function loadProducts(productName, prodDescription) {
	    var highestId = parseInt((0, _jquery2.default)("#listOfProducts tbody tr:last").attr("id"));
	    if (isNaN(highestId)) {
	      highestId = 0;
	    } else {
	      ++highestId;
	    }
	    var productRow = (0, _jquery2.default)('<tr id=' + highestId + ' class="">').append((0, _jquery2.default)('<td class="">').append((0, _jquery2.default)('<div class="checkbox checkbox-success cb-large">').append((0, _jquery2.default)('<input type="checkbox">').attr('id', 'prodTabSku' + "_row_" + highestId).attr('name', 'prodSkuFromModal').attr('value', productName)).append((0, _jquery2.default)('<label for="prodTabSku_row_' + highestId + '">')))).append((0, _jquery2.default)('<td class="">').append((0, _jquery2.default)('<span class="products-tab-product-name">').attr('id', productName + '_row_' + highestId).text(productName)).append((0, _jquery2.default)('<input type="hidden">').attr('name', 'prodTabProductName' + '_row_' + highestId).attr('value', productName))).append((0, _jquery2.default)('<td class="">').append((0, _jquery2.default)('<span class="products-tab-product-description">').attr('name', portletNamespace + 'prodDescription').attr('id', portletNamespace + 'prodDescription').text(prodDescription)).append((0, _jquery2.default)('<input type="hidden">').attr('name', 'prodTabProdDescription' + '_row_' + highestId).attr('value', prodDescription)));
	    (0, _jquery2.default)("#listOfProducts").find('tbody').append(productRow);
	  };
	
	  (0, _jquery2.default)('#addProductsLink').click(function () {
	    (0, _jquery2.default)('#listOfProductsModal div input').prop('checked', false);
	  });
	
	  function removeProductRelatedRows(e) {
	    var el = (0, _jquery2.default)(e.target);
	    var coreProduct = el.closest('tr');
	    var childProducts = coreProduct.data("childProducts");
	    if (childProducts && childProducts.length) {
	      (0, _underscore2.default)(childProducts).map(function (childProduct) {
	        childProduct.remove();
	      });
	    }
	    coreProduct.remove();
	  }
	
	  (0, _jquery2.default)('#search-product-name').on('keyup', function () {
	    var keyword = this.value;
	    (0, _jquery2.default)("#listOfProducts > tbody").html("");
	    (0, _jquery2.default)(items).each(function () {
	      if (this.itmSku.toLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
	        loadProducts(this.itmSku, this.prdNameAndAttributes);
	      } else if (this.prdNameAndAttributes.toLowerCase().indexOf(keyword.toLowerCase()) >= 0) {
	        loadProducts(this.itmSku, this.prdNameAndAttributes);
	      }
	    });
	  });
	
	  (0, _jquery2.default)('#add-product-from-modal').on('click', function () {
	    (0, _jquery2.default)(".no-products-added-error-msg").hide();
	    var boxes = (0, _jquery2.default)('input[name=prodSkuFromModal]:checked');
	    boxes.each(function () {
	      var sku = this.value;
	      (0, _jquery2.default)(items).each(function () {
	        if (this.itmSku === sku) {
	          addProducts(this.itmSku, this.prdNameAndAttributes, 0, this.type);
	        }
	      });
	    });
	    (0, _jquery2.default)('#listOfProductsModal').modal('toggle');
	  });
	}

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _addProductsAmazon = __webpack_require__(710);
	
	var _addProductsAmazon2 = _interopRequireDefault(_addProductsAmazon);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	__webpack_require__(1095);
	var targetSelector = "#amazon-fba-order-wizard";
	
	
	// For quick dev prototyping
	
	(0, _run2.default)(targetSelector, function () {
	  var orderFulfillmentCenterSelect = $("#order-fulfillment-center");
	  var orderFulfillmentCenterList = orderFulfillmentCenterSelect.data('options');
	  var destFacAddressWrapper = $("#dest-fac-address-wrapper");
	  var destFacAddress = $("#dest-fac-address");
	  var facUsesList = $("#fac-uses-list");
	  var shipmentTypeval = ".shipment-type-value";
	  var btnKey = void 0;
	
	  $(orderFulfillmentCenterList).each(function () {
	    var option = $('<option />');
	    option.attr('value', this.facId).text(this.facName);
	    orderFulfillmentCenterSelect.append(option);
	  });
	
	  orderFulfillmentCenterSelect.change(function () {
	    var selectedFacility = this.value;
	    var facility = orderFulfillmentCenterList.filter(function (obj) {
	      return obj.facId == selectedFacility;
	    })[0];
	    //show address
	    destFacAddressWrapper.hide();
	    destFacAddress.html('');
	    if (facility != null) {
	      //$("#"+portletNamespace+"facId").val(facility.facId);
	      destFacAddress.append("<div>" + facility.facAddressLine1 + "</div>");
	      if (facility.facAddressLine2 != null) {
	        destFacAddress.append("<div>" + facility.facAddressLine2 + "</div>");
	      }
	      destFacAddress.append("<div>" + facility.facCity + ", " + facility.facState + " " + facility.facZipcode + "</div>");
	      //show facility/fulfillment uses
	      facUsesList.html("");
	      facUsesList.append("<div class='q-boldest'>Facility Uses:</div>");
	      var facilityUses = false;
	      if (facility.attributes != null && facility.attributes.length > 0) {
	        $.each(facility.attributes[0], function (key, value) {
	          if (key == "IN" && value == true) {
	            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>International Fulfillment Center</span> ");
	            facilityUses = true;
	          } else if (key == "FC" && value == true) {
	            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Fulfillment Center</span> ");
	            facilityUses = true;
	          } else if (key == "DC" && value == true) {
	            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Distribution Center</span> ");
	            facilityUses = true;
	          } else if (key == "RC" && value == true) {
	            facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Returns Center</span> ");
	            facilityUses = true;
	          }
	        });
	        if (!facilityUses) {
	          facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
	        }
	      } else {
	        facUsesList.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
	      }
	      destFacAddressWrapper.show();
	    }
	  });
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var form = $(targetSelector);
	  // MOVE TO ReviewTab.js
	  var validator = form.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  });
	
	  //Call this submission modal if single shipment, have to export this funtion to window cause, jsp build in response of ajax function.
	  function submissionModalForSingleShipment(viewDetailPageURL) {
	    submitModalFlow.showSuccessModal();
	    setTimeout(function () {
	      location.href = viewDetailPageURL;
	    }, 1500);
	  }
	
	  window.submissionModalForSingleShipment = submissionModalForSingleShipment;
	
	  var noProductsErrorMsg = $(".no-products-added-error-msg");
	  noProductsErrorMsg.hide();
	  setCancelBtnURL();
	  validator.settings.ignore = ":disabled,:hidden";
	  var productForm = void 0;
	  var canGoToProductTab = true;
	  var canGoToShipmentTab = false;
	  var quickWizard = new _QuickWizard2.default(form, {
	    tabletWidthNavStep: 844,
	    mobileWidthNavStep: 502,
	    shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	      var targetForm = _ref.targetForm,
	          direction = _ref.direction,
	          currentForm = _ref.currentForm,
	          done = _ref.done;
	
	      if (currentForm.filter(".add-products-tab").length) {
	        var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	        var valid = quickWizard.areInputsValid(allPrevInputs, { displayErrors: true });
	        if (direction == "FORWARDS") {
	          if (targetForm[0].className == "qw-form review") {
	            return false;
	          } else if (valid) {
	            productForm = currentForm;
	            return productsTabIsValid();
	          } else {
	            return valid;
	          }
	        }
	      } else if (currentForm.filter(".review-tab").length) {
	        if (canGoToProductTab) {
	          return true;
	        }
	        if (direction == "FORWARDS") {
	          var selectedShipmentsTypes = 0;
	          $('.shipping-type-toggler').each(function () {
	            if ($(this).find('.active').length) {
	              selectedShipmentsTypes = selectedShipmentsTypes + 1;
	            } else {
	              $(this).closest('.shipmentType-container').find('.shippingType-error').removeClass('hide');
	            }
	          });
	          if (selectedShipmentsTypes < $('.shipping-type-toggler').length) {
	            return false;
	          }
	        } else if (direction == "BACKWARDS") {
	          showPrevConfirmationModal();
	          return false;
	        } else {}
	      } else if (currentForm.filter(".review").length) {
	        if (canGoToProductTab) {
	          return true;
	        } else if (direction == "BACKWARDS") {
	          if (targetForm[0].className == "qw-form add-products-tab") {
	            showPrevConfirmationModal();
	            return false;
	          }
	        } else {
	          return true;
	        }
	      } else {
	        return false;
	      }
	    },
	    didNavigateToForm: function didNavigateToForm(_ref2) {
	      var currentForm = _ref2.currentForm;
	
	      if (currentForm.filter(".review-tab").length) {
	        canGoToProductTab = true;
	        canGoToShipmentTab = true;
	        submitFailedMsg.hide();
	        getShipmentPlan();
	      } else if (currentForm.filter(".review").length) {
	        canGoToProductTab = false;
	        canGoToShipmentTab = true;
	        submitFailedMsg.hide();
	        getReviewShipmentPlan();
	      } else {
	        removeCurentShipmentPlan();
	      }
	      return true;
	    }
	  });
	  quickWizard.init();
	
	  var productsTab = new _addProductsAmazon2.default(quickWizard);
	  productsTab.init();
	  //productsTab.loadProductsOnLoad();
	
	
	  // END: Real Code
	  var showSubmitOrderModalBtn = $('.submit-order-btn');
	  var addProductsPanelBtn = $('.add-products-btn');
	  var goBackToAddProductsBtn = $('#go-back-to-add-products');
	  var closePreviousModalBtn = $('#close-previous-modal-btn');
	
	  var addProductsBtn = $(".add-products-from-list-link");
	  var submitOrderBtn = $("#submit-order-over-modal");
	
	  var prevConfirmationModal = $('#previousButtonModal');
	  var addProductsModal = $('#listOfProductsModal');
	  var submitOrderModal = $('#submitOrderModal');
	  var submitModalText = $("#submit-modal-text");
	  var submitModalProcessingSection = $("#submit-modal-processing-section");
	  var submitModalButtons = $("#submit-modal-buttons");
	
	  var submitFailedMsg = $("#submit-failure-msg");
	
	  // START: IMPORTANT: REAL CODE
	  var modalOpts = { backdrop: 'static', show: false };
	  prevConfirmationModal.modal(modalOpts);
	  addProductsModal.modal(modalOpts);
	  submitOrderModal.modal(modalOpts);
	  //orderResultsModal.modal(modalOpts);
	  // END: IMPORTANT: REAL CODE
	
	
	  (0, _selectorHelpers.combineElements)([addProductsBtn, addProductsPanelBtn]).on("click", function (e) {
	    e.preventDefault();
	    showAddProductsModal();
	  });
	
	  showSubmitOrderModalBtn.on("click", function (e) {
	    e.preventDefault();
	    showSubmitOrderModal();
	    //submitModalProcessingBar.hide();
	  });
	
	  (0, _selectorHelpers.combineElements)([submitOrderBtn]).on("click", function (e) {
	    e.preventDefault();
	    //showSubmitOrderModalBtn.hide();
	    //submitModalText.hide();
	    //submitModalButtons.hide();
	    //submitModalProcessingSection.show();
	
	    submitOrderModal.modal("hide");
	    submitModalFlow.showLoadingModal();
	    $.ajax({
	      url: form.data("submit-fba-order-url"),
	      type: 'POST',
	      data: form.serialize(),
	      success: function success(resp) {
	        if (resp) {
	          submitModalFlow.hideAllModals();
	          $('#amazon-fba-order-loader').hide();
	          $('#order-result-modal-section').html(resp);
	          showOrderResultsModal();
	        } else {
	          //submitOrderModal.modal("hide");
	          removeCurentShipmentPlan();
	          // submitFailedMsg.show();
	        }
	      },
	      error: function error(xhr, status, _error) {
	        submitOrderModal.modal("hide");
	        removeCurentShipmentPlan();
	        submitFailedMsg.show();
	      }
	    });
	  });
	
	  function showAddProductsModal() {
	    addProductsModal.modal("show");
	  }
	
	  function productsTabIsValid() {
	    var numberOfProducts = $("#product-tab-create-ord >tbody >tr").length;
	    if (numberOfProducts > 0) {
	      noProductsErrorMsg.hide();
	      return true;
	    } else {
	      noProductsErrorMsg.show();
	      return false;
	    }
	  }
	
	  function showPrevConfirmationModal() {
	    prevConfirmationModal.modal("show");
	  }
	
	  goBackToAddProductsBtn.click(function () {
	    canGoToProductTab = true;
	    quickWizard.gotToForm(productForm);
	  });
	
	  function showSubmitOrderModal() {
	    submitOrderModal.modal("show");
	  }
	
	  function showOrderResultsModal() {
	    var orderResultsModal = $('#orderResultsModal');
	    orderResultsModal.modal(modalOpts);
	    orderResultsModal.modal("show");
	  }
	
	  function removeCurentShipmentPlan() {
	    $("#shipment-plan-response").hide();
	  }
	  var response = void 0;
	
	  function getShipmentPlan() {
	    $("#shipment-plan-response").hide();
	    var form = $(targetSelector);
	    $('#amazon-fba-order-loader').show();
	    $.ajax({
	      url: form.data("shipment-plan-url"),
	      type: 'POST',
	      dataType: 'html',
	      data: form.serialize(),
	      success: function success(resp) {
	        if (resp) {
	          if ($('#get-shipment-plan-error').length > 0) {
	            canGoToProductTab = true;
	          } else {
	            canGoToProductTab = false;
	          }
	          $('#amazon-fba-order-loader').hide();
	          $("#shipment-plan-response").html(resp);
	          $("#shipment-plan-response").find(".review-origin-facility").html($("#order-fulfillment-center option:selected").text());
	          $("#shipment-plan-response").show();
	          generateBtnGroupForShippingType();
	          $("#shipment-plan-response").find(".shipping-type-toggler").on('click', onClickOfShippingType);
	
	          setRemoveDiscrepancySkuCall();
	          setCancelBtnURL();
	        } else {
	          $('#amazon-fba-order-loader').hide();
	          $("#shipment-plan-response").show();
	        }
	      },
	      error: function error(xhr, status, _error2) {
	        canGoToProductTab = true;
	        $('#amazon-fba-order-loader').hide();
	        $("#shipment-plan-response").show();
	      }
	    });
	  }
	  function getReviewShipmentPlan() {
	    $("#review-response").hide();
	    $('#amazon-fba-review-loader').show();
	    $('.submit-order-btn').hide();
	    var form = $(targetSelector);
	    $.ajax({
	      url: form.data("shipment-review-url"),
	      type: 'POST',
	      dataType: 'html',
	      data: form.serialize(),
	      success: function success(response) {
	        if (response) {
	          if ($('#get-shipment-plan-error').length > 0) {
	            canGoToShipmentTab = true;
	          }
	          $('#amazon-fba-review-loader').hide();
	          $("#review-response").html(response);
	          $("#review-response").find(".review-origin-facility").html($("#order-fulfillment-center option:selected").text());
	          $("#review-response").show();
	          $('.submit-order-btn').show();
	          var orderstr = $('[name="orderDetailStr"]').val();
	          var ordobj = JSON.parse(orderstr);
	          var sType;
	          Object.keys(selectedShipmets).forEach(function (si) {
	            if (selectedShipmets[si] == "LTL") {
	              sType = "Frieght Shipping";
	            } else {
	              sType = "Case Shipping";
	            }
	            $("#review-response").find('.shipment-type-' + si).text(sType);
	            ordobj.order[si - 1].shippingType = selectedShipmets[si];
	          });
	          $('[name="orderDetailStr"]').val(JSON.stringify(ordobj));
	          setRemoveDiscrepancySkuCall();
	          setCancelBtnURL();
	        } else {
	          $('#amazon-fba-review-loader').hide();
	          $("#review-response").show();
	        }
	      },
	      error: function error(xhr, status, _error3) {
	        canGoToProductTab = true;
	        $('#amazon-fba-review-loader').hide();
	        $("#review-response").show();
	      }
	    });
	  }
	  function setRemoveDiscrepancySkuCall() {
	    $('#sku-discr-remove-missing-sku-btn').on("click", function (e) {
	      e.preventDefault();
	      var discrepancySkus = $.parseJSON($("#discrepancy-skus").val());
	      $.each(discrepancySkus, function (i, item) {
	        var productTabRow = $("#amazon-fba-order-wizard input[value='" + item + "'] ");
	        removeProductRelatedRows(productTabRow);
	      });
	
	      getShipmentPlan();
	    });
	  }
	
	  function removeProductRelatedRows(curr) {
	    var el = curr;
	    var coreProduct = el.closest('tr');
	    var childProducts = coreProduct.data("childProducts");
	    if (childProducts && childProducts.length) {
	      (0, _underscore2.default)(childProducts).map(function (childProduct) {
	        childProduct.remove();
	      });
	    }
	    coreProduct.remove();
	  }
	
	  function setCancelBtnURL() {
	    var wizardCancelBtn = $('.qw-cancel');
	    wizardCancelBtn.on('click', function () {
	      var redirectToLookupPageURL = wizardCancelBtn.data('redirect-to-lookup-page-url');
	      location.href = redirectToLookupPageURL;
	    });
	  }
	  var selectedShipmets = {};
	  var shippingTypeBtnGroupEl = void 0,
	      shippingTypeBtnGroup = void 0;
	  function generateBtnGroupForShippingType() {
	    shippingTypeBtnGroupEl = $('.shipping-type-toggler');
	    $('.shipping-type-toggler').each(function () {
	      var options = {
	        distributeWidth: true
	      };
	      if (selectedShipmets[$(this).find('.q-btn:first').data('shipmentid')]) {
	        options.initialActiveKey = selectedShipmets[$(this).find('.q-btn:first').data('shipmentid')];
	      }
	      shippingTypeBtnGroup = new _QuickBtnGroup2.default($(this), options);
	      shippingTypeBtnGroup.init();
	    });
	  }
	
	  function onClickOfShippingType(e) {
	    var shipment = $("#shipmentMethod").data('row-shipment');
	    e.preventDefault();
	    var btn = $(e.target);
	    btnKey = btn.data('qb-key');
	    selectedShipmets[btn.data('shipmentid')] = btnKey;
	  }
	});

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = shipFedExModalFactory;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalHtml = __webpack_require__(11);
	var modalBodyHtml = __webpack_require__(1368);
	var boxDimRowHtml = __webpack_require__(1367);
	
	__webpack_require__(1096);
	
	var singleton = void 0;
	
	function shipFedExModalFactory(options) {
	  if (singleton) {
	    // singleton.setOptions(options);
	    return singleton;
	  } else {
	    singleton = new ShipFedExModal(options);
	    singleton.init();
	    return singleton;
	  }
	}
	
	var noop = function noop() {};
	
	var elementsMap = {
	  closeBtn: ".close-btn",
	  topCloseBtn: ".top-close-btn",
	  shipFedExBtn: ".ship-fedex-btn",
	  boxDimRowsOuter: ".box-dim-rows-outer",
	  addBoxBtn: ".sf-add-box-btn",
	  shareShipCheckbox: ".share-ship-info-checkbox",
	  form: ".modal-form",
	  shipFedexAddressDropdown: ".ship-fedex-addr-dropdown"
	};
	
	function ShipFedExModal() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var self = this;
	  var done = void 0;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var validator = void 0;
	
	  self.init = function () {
	    setHtml();
	    setElements();
	    pouplateAddressDropdown();
	    attachToBody();
	    setValidator();
	    setWidgets();
	    bindElements();
	    renderUpdate();
	  };
	
	  self.getElement = getElement;
	  self.showModal = showModal;
	  self.getAllFormData = getAllFormData;
	
	  function getElement() {
	    return self._element;
	  }
	
	  function pouplateAddressDropdown() {
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: els.shipFedexAddressDropdown,
	      list: (0, _jquery2.default)("#order-detail-page").data("addresses"),
	      initialSelectValue: "",
	      valueDataKey: "cadId",
	      textDataKey: "cadLocationName"
	    });
	  }
	
	  function setValidator() {
	    validator = els.form.validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          (0, _jquery2.default)(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	  }
	
	  function setHtml() {
	    self._element = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	      modalDialogClass: "modal-lg",
	      topCloseBtn: true,
	      title: "Shipping with FedEx",
	      subtitle: "Provide box dimensions and weight to generate a shipping label.",
	      body: (0, _render2.default)(modalBodyHtml),
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn purple-btn v2-btn close-btn\">Cancel</a>\n          <a href=\"#\" class=\"base-btn purple-btn ship-fedex-btn\">Ship With FedEx</a>\n        "
	    }));
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, getElement());
	  }
	
	  function attachToBody() {
	    (0, _jquery2.default)('body').append(getElement());
	  }
	
	  function renderUpdate() {
	    renderChildren();
	    updateSelf();
	  }
	
	  function updateSelf() {
	    updateIdxs();
	    updateRemoveBtns();
	  }
	
	  function renderChildren() {
	    var bdrsHtml = (0, _underscore2.default)([{ length: 5, width: 10, height: 20, weight: 30 }]).map(renderBoxDimRow);
	    els.boxDimRowsOuter.html(bdrsHtml);
	  }
	
	  function updateRemoveBtns() {
	    var allRemoveBtns = getBoxDimRows().find(".remove-btn");
	    (0, _selectorHelpers.handleDisplayForV2)(allRemoveBtns, true);
	
	    (0, _selectorHelpers.handleDisplayForV2)(allRemoveBtns.first(), allRemoveBtns.length > 1);
	  }
	
	  function updateIdxs() {
	    getBoxDimRows().each(updateRowIdx);
	  }
	
	  function updateRowIdx(idx) {
	    var row = (0, _jquery2.default)(this);
	    var idxEl = row.find(".bdr-idx");
	    idxEl.text(idx + 1);
	  }
	
	  function renderBoxDimRow() {
	    var bdrData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _render2.default)(boxDimRowHtml, _extends({}, bdrData, {
	      lengthId: _underscore2.default.uuid(),
	      widthId: _underscore2.default.uuid(),
	      heightId: _underscore2.default.uuid(),
	      weightId: _underscore2.default.uuid()
	    }));
	  }
	
	  function addBoxDimRow() {
	    var bdrData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var bdrHtml = renderBoxDimRow(bdrData);
	    els.boxDimRowsOuter.append(bdrHtml);
	  }
	
	  function setWidgets() {
	    getElement().modal({ backdrop: 'static', show: false });
	  }
	
	  function bindElements() {
	    (0, _selectorHelpers.combineElements)([els.closeBtn, els.topCloseBtn]).on("click", onCloseBtnClick);
	    els.shipFedExBtn.on("click", onShipFedExBtnClick);
	    els.addBoxBtn.on("click", onAddBoxClick);
	    els.boxDimRowsOuter.on("click", ".remove-btn", onRemoveRowClick);
	  }
	
	  function onRemoveRowClick(e) {
	    e.preventDefault();
	    var row = (0, _jquery2.default)(this).closest(".box-dim-row");
	    removeRow(row);
	    updateSelf();
	  }
	
	  function removeRow(row) {
	    row.remove();
	  }
	
	  function onAddBoxClick(e) {
	    e.preventDefault();
	    addBoxDimRow();
	    updateSelf();
	  }
	
	  function onCloseBtnClick(e) {
	    e.preventDefault();
	    console.log("close clicked");
	    hideModal();
	  }
	
	  function onShipFedExBtnClick(e) {
	    e.preventDefault();
	    console.log("ship with fed btn clicked");
	    if (isModalValid()) {
	      options.onShipFedExBtnValidClick && options.onShipFedExBtnValidClick();
	      hideModal();
	    }
	  }
	
	  function getAllFormData() {
	    var data = {};
	    data.addressId = els.shipFedexAddressDropdown.val();
	    data.boxes = (0, _underscore2.default)(getBoxDimRows().toArray()).map(collectRowData);
	    data.shareShippingInfoWithChannel = els.shareShipCheckbox.is(":checked");
	    return data;
	  }
	
	  function collectRowData(row) {
	    row = (0, _jquery2.default)(row);
	    var data = {};
	    data.length = row.find(".box-length").val();
	    data.width = row.find(".box-width").val();
	    data.height = row.find(".box-height").val();
	    data.weight = row.find(".box-weight").val();
	    return data;
	  }
	
	  function isModalValid() {
	    return els.form.valid();
	  }
	
	  function getAllRowInputs() {
	    return els.boxDimRowsOuter.find("input");
	  }
	
	  function getBoxDimRows() {
	    return els.boxDimRowsOuter.find(".box-dim-row");
	  }
	
	  function showModal() {
	    getElement().modal("show");
	  }
	
	  function hideModal() {
	    getElement().modal("hide");
	  }
	}

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = shipThirdPartyModalFactory;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalHtml = __webpack_require__(11);
	var modalBodyHtml = __webpack_require__(1369);
	var trackingRowHtml = __webpack_require__(1370);
	
	__webpack_require__(1097);
	
	var singleton = void 0;
	
	function shipThirdPartyModalFactory(options) {
	  if (singleton) {
	    // singleton.setOptions(options);
	    return singleton;
	  } else {
	    singleton = new ShipThirdPartyModal(options);
	    singleton.init();
	    return singleton;
	  }
	}
	
	var noop = function noop() {};
	
	var elementsMap = {
	  closeBtn: ".close-btn",
	  topCloseBtn: ".top-close-btn",
	  shipThirdPartyBtn: ".ship-third-party-btn",
	  trackingRowsOuter: ".tracking-rows-outer",
	  addTrackingBtn: ".st-add-tracking-btn",
	  shareShipCheckbox: ".share-ship-info-checkbox",
	  carrierSelect: ".carrier-select",
	  form: ".modal-form"
	};
	
	function ShipThirdPartyModal() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var self = this;
	  var done = void 0;
	  self._element = (0, _jquery2.default)();
	  var els = {};
	  var validator = void 0;
	
	  self.init = function () {
	    setHtml();
	    setElements();
	    attachToBody();
	    setValidator();
	    setWidgets();
	    bindElements();
	    renderUpdate();
	  };
	
	  self.getElement = getElement;
	  self.showModal = showModal;
	  self.getAllFormData = getAllFormData;
	
	  function getElement() {
	    return self._element;
	  }
	
	  function setValidator() {
	    validator = els.form.validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          (0, _jquery2.default)(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	  }
	
	  function setHtml() {
	    self._element = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	      topCloseBtn: true,
	      title: "Shipping with 3rd Party Carrier",
	      subtitle: "Please provide the shipment information so we can communicate it to your customer.",
	      body: (0, _render2.default)(modalBodyHtml),
	      footerBtns: "\n          <a href=\"#\" class=\"base-btn purple-btn v2-btn close-btn\">Cancel</a>\n          <a href=\"#\" class=\"base-btn purple-btn ship-third-party-btn\">Ship with 3rd Party</a>\n        "
	    }));
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, getElement());
	  }
	
	  function attachToBody() {
	    (0, _jquery2.default)('body').append(getElement());
	  }
	
	  function renderUpdate() {
	    renderChildren();
	    updateSelf();
	  }
	
	  function updateSelf() {
	    updateIdxs();
	    updateRemoveBtns();
	  }
	
	  function renderChildren() {
	    var bdrsHtml = (0, _underscore2.default)([{ length: 5, width: 10, height: 20, weight: 30 }]).map(renderTrackingRow);
	    els.trackingRowsOuter.html(bdrsHtml);
	  }
	
	  function updateRemoveBtns() {
	    var allRemoveBtns = getTrackingRows().find(".remove-btn");
	    (0, _selectorHelpers.handleDisplayForV2)(allRemoveBtns, true);
	
	    (0, _selectorHelpers.handleDisplayForV2)(allRemoveBtns.first(), allRemoveBtns.length > 1);
	  }
	
	  function updateIdxs() {
	    getTrackingRows().each(updateRowIdx);
	  }
	
	  function updateRowIdx(idx) {
	    var row = (0, _jquery2.default)(this);
	    var idxEl = row.find(".bdr-idx");
	    idxEl.text(idx + 1);
	  }
	
	  function renderTrackingRow() {
	    var bdrData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _render2.default)(trackingRowHtml, _extends({}, bdrData, {
	      trackingId: _underscore2.default.uuid()
	    }));
	  }
	
	  function addTrackingRow() {
	    var bdrData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var bdrHtml = renderTrackingRow(bdrData);
	    els.trackingRowsOuter.append(bdrHtml);
	  }
	
	  function setWidgets() {
	    getElement().modal({ backdrop: 'static', show: false });
	  }
	
	  function bindElements() {
	    (0, _selectorHelpers.combineElements)([els.closeBtn, els.topCloseBtn]).on("click", onCloseBtnClick);
	    els.shipThirdPartyBtn.on("click", onShipThirdPartyBtnClick);
	    els.addTrackingBtn.on("click", onAddBoxClick);
	    els.trackingRowsOuter.on("click", ".remove-btn", onRemoveRowClick);
	  }
	
	  function onRemoveRowClick(e) {
	    e.preventDefault();
	    var row = (0, _jquery2.default)(this).closest(".tracking-row");
	    removeRow(row);
	    updateSelf();
	  }
	
	  function removeRow(row) {
	    row.remove();
	  }
	
	  function onAddBoxClick(e) {
	    e.preventDefault();
	    addTrackingRow();
	    updateSelf();
	  }
	
	  function onCloseBtnClick(e) {
	    e.preventDefault();
	    console.log("close clicked");
	    hideModal();
	  }
	
	  function onShipThirdPartyBtnClick(e) {
	    e.preventDefault();
	    console.log("ship with fed btn clicked");
	    if (isModalValid()) {
	      options.onShipThirdPartyBtnValidClick && options.onShipThirdPartyBtnValidClick();
	      hideModal();
	    }
	  }
	
	  function getAllFormData() {
	    var data = {};
	    data.trackingNumbers = (0, _underscore2.default)(getTrackingRows().toArray()).map(collectRowData);
	    data.shareShippingInfoWithChannel = els.shareShipCheckbox.is(":checked");
	    data.carrier = els.carrierSelect.val();
	    return data;
	  }
	
	  function collectRowData(row) {
	    row = (0, _jquery2.default)(row);
	    var data = {};
	    data.trackingNumber = row.find(".tracking-number").val();
	    return data;
	  }
	
	  function isModalValid() {
	    return els.form.valid();
	  }
	
	  function getAllRowInputs() {
	    return els.trackingRowsOuter.find("input");
	  }
	
	  function getTrackingRows() {
	    return els.trackingRowsOuter.find(".tracking-row");
	  }
	
	  function showModal() {
	    getElement().modal("show");
	  }
	
	  function hideModal() {
	    getElement().modal("hide");
	  }
	}

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _select2able = __webpack_require__(22);
	
	var _general = __webpack_require__(5);
	
	var _preparationTab = __webpack_require__(145);
	
	var _preparationTab2 = _interopRequireDefault(_preparationTab);
	
	var _destinationTab = __webpack_require__(216);
	
	var _destinationTab2 = _interopRequireDefault(_destinationTab);
	
	var _ProductsTab = __webpack_require__(708);
	
	var _ProductsTab2 = _interopRequireDefault(_ProductsTab);
	
	var _ReviewTab = __webpack_require__(709);
	
	var _ReviewTab2 = _interopRequireDefault(_ReviewTab);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	__webpack_require__(1120);
	
	var editSubmissionFailModalBodyHtml = __webpack_require__(1377);
	var modalHtml = __webpack_require__(11);
	
	// Live form from jsp
	(0, _run2.default)("#create-order-form", function () {
	  var el = $("#create-order-form");
	  attachWizard(el);
	  setupEditChecker();
	});
	
	function showHideDropFlag(cotCode) {
	  var consolidatedOrderTypeList = $("#destination-tab-order-type-select").data("consolidated-order-type-list");
	  var groupedOrderTypeList = _underscore2.default.groupBy(consolidatedOrderTypeList, 'ortTypeCode');
	  var orderTypeList = groupedOrderTypeList[cotCode] || [];
	  var dropShipValue = void 0;
	  var found = _underscore2.default.findIndex(orderTypeList, function (value) {
	    return !_underscore2.default.isNull(value.ortDropShip);
	  });
	  if (found >= 0) {
	    var dropShipFlagVal = $("#dropShipFlag").is(":checked");
	    if (dropShipFlagVal) {
	      dropShipValue = true;
	    } else {
	      dropShipValue = false;
	    }
	  } else {
	    dropShipValue = null;
	  }
	  return dropShipValue;
	}
	
	function setupEditChecker() {
	  _EditChecker2.default.bindNavigation();
	  _EditChecker2.default.bindChangeListener("#create-order-form");
	  _EditChecker2.default.bindChangeListener("span.select2");
	  _EditChecker2.default.bindCancelButton("#create-order-cancel-btn");
	}
	
	function attachWizard(el) {
	  var hiddenAddressInput = $("#order-validated-address");
	  var viewOrderDetailURL = el.data("view-order-detail-url");
	  var submitOrderURL = el.data("submit-order-url");
	  var countryVal = $('#destination-tab-country  :selected').val();
	  var orderDetailsForEdit = el.data("edit-order-details");
	  if (!$.isEmptyObject(orderDetailsForEdit)) {
	    var order = orderDetailsForEdit.orderDetails;
	    var error = orderDetailsForEdit.error;
	  }
	  var isChannelOrder = el.data("is-channel-order");
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	    // Place all your validation rules here!!!
	    // rules: {
	
	    // }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  var editSubmissionFailModal = $((0, _render2.default)(modalHtml, {
	    title: 'Edit Submission Failed',
	    leftAlignTitle: true,
	    topCloseBtn: true,
	    modalDialogClass: 'q-modal-dialog-500',
	    body: editSubmissionFailModalBodyHtml,
	    footerBtns: '\n        <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>\n        <a href="#" class="base-btn purple-btn modal-auto-hide redirect-order-detail">Order Details</a>\n      '
	  }));
	
	  var submitModalFlow = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Submit Order',
	    // confirmModalSubtitle: "Optional Subtitle",
	    confirmModalBody: '<div class="q-pad-all-xl">Once submitted, this order will be processed and set to held or released. Once this order has been released, it cannot be canceled.</div>',
	    onConfirmClick: function onConfirmClick() {
	      // Show Loading Modal
	      submitModalFlow.showLoadingModal();
	
	      // call ajax funtion here.
	      submitOrder({ url: submitOrderURL, success: submitOrderSuccess, error: submitOrderError });
	    }
	  });
	
	  submitModalFlow.init();
	
	  function submitOrder(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error;
	
	    var dropShipValue = showHideDropFlag($("#destination-tab-order-type-select").val());
	    var declaredValue = $("#declared-value-checkbox").is(":checked");
	    var satDeliveryValue = $("#saturday-delivery-checkbox").val();
	    $.ajax({
	      data: $("#create-order-form").serialize() + "&dropShipFlagValue=" + dropShipValue + "&declaredValue=" + declaredValue + "&satDeliveryValue=" + satDeliveryValue,
	      url: url,
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function submitOrderSuccess(orderId) {
	    if (orderId.indexOf("edit-unavailable") > -1) {
	      submitModalFlow.hideAllModals();
	      showEditunavailableModal();
	    } else if (orderId) {
	      _EditChecker2.default.setPageClean();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        var orderDetailUrlFullURL = viewOrderDetailURL + '&orderId=' + orderId;
	        window.location.href = orderDetailUrlFullURL;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    }
	  }
	
	  function submitOrderError() {
	    submitModalFlow.showFailureModal();
	  }
	
	  $(".create-button").on('click', function () {
	    submitModalFlow.showConfirmModal();
	  });
	
	  function showEditunavailableModal() {
	    el.append(editSubmissionFailModal);
	    editSubmissionFailModal.modal('show');
	  }
	
	  el.on("click", '.redirect-order-detail', redirectToDetailsPage);
	
	  function redirectToDetailsPage() {
	    _EditChecker2.default.setPageClean();
	    editSubmissionFailModal.modal('hide');
	    var orderDetailUrlFullURL = viewOrderDetailURL + '&orderId=' + orderDetailsForEdit.orderDetails.ordOrderId;
	    window.location.href = orderDetailUrlFullURL;
	  }
	
	  var btnClickVar = false;
	  var fedexShipping = false;
	  var serviceLevels = false;
	  var fedexShippingMethodBtnValueCheck = el.find("#fedex-shipping-method-btn-value-check");
	  var serviceLevelsBtnValueCheck = el.find("#service-levels-btn-value-check");
	  var fedexShippingMethodBtn = el.find(".fedex-shipping-method-btn");
	  var serviceLevelsBtn = el.find(".service-levels-btn");
	  var serviceLevelsMessage = el.find(".estimated-delivery-date-message");
	
	  el.on('click', '.fedex-shipping-method-btn, .service-levels-btn', function (e) {
	    btnClickVar = true;
	  });
	
	  el.on('click', '.fedex-shipping-method-btn', function (e) {
	    fedexShippingMethodBtn.addClass("active");
	    serviceLevelsBtn.removeClass("active");
	    fedexShipping = true;
	    serviceLevels = false;
	    fedexShippingMethodBtnValueCheck.val(true);
	    serviceLevelsBtnValueCheck.val(false);
	    serviceLevelsMessage.hide();
	  });
	
	  el.on('click', '.service-levels-btn', function (e) {
	    fedexShippingMethodBtn.removeClass("active");
	    serviceLevelsBtn.addClass("active");
	    serviceLevels = true;
	    fedexShipping = false;
	    serviceLevelsBtnValueCheck.val(true);
	    fedexShippingMethodBtnValueCheck.val(false);
	    serviceLevelsMessage.show();
	  });
	
	  $('#shipping-tab-shipping-type-select').on('change', function (e) {
	    if ($('#shipping-tab-shipping-type-select').val() == "LTL") {
	      btnClickVar = true;
	      fedexShipping = false;
	      serviceLevels = false;
	    }
	
	    if ($('#shipping-tab-shipping-type-select').val() == "PCL") {
	      if (fedexShipping || serviceLevels) {
	        btnClickVar = true;
	      } else {
	        btnClickVar = false;
	      }
	
	      var countryVal = $('#destination-tab-country  :selected').val();
	      if (countryVal != "1") {
	        btnClickVar = true;
	      }
	    }
	  });
	
	  var quickWizard = new _QuickWizard2.default(el, {
	    tabletWidthNavStep: 844,
	    mobileWidthNavStep: 502,
	
	    customRules: {
	      "#products-empty-table-validator": {
	        errorMessageSelector: ".products-tab-products-table-error-message",
	        isValid: function isValid() {
	          return productsTab.isValid();
	        }
	      },
	      "#destination-tab-customerEmail": {
	        errorMessageSelector: "#create-order-invalid-email",
	        isValid: function isValid(_ref2) {
	          var input = _ref2.input,
	              done = _ref2.done;
	
	          var curVal = input.val();
	          if ((0, _general.isPresent)(curVal)) {
	            var atpos = curVal.indexOf("@");
	            var dotpos = curVal.lastIndexOf(".");
	            if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= curVal.length) {
	              done(false, { displayErrors: true });
	            } else {
	              done(true, { displayErrors: true });
	            }
	          } else {
	            done(true, { displayErrors: true });
	          }
	          return done;
	        }
	      },
	      "#business-exception-validator": {
	        errorMessageSelector: ".products-tab-business-exception-error-message",
	        isValid: function isValid() {
	          ;
	          return !productsTab.checkIfBusinessExceptionsExist();
	        }
	      },
	      "#schedule-release-time": {
	        errorMessageSelector: ".time-picker-error",
	        isValid: function isValid() {
	          return !preparationTab.checkIfDateTimeInPast();
	        }
	      }
	    },
	
	    shouldNavigateToForm: function shouldNavigateToForm(_ref3) {
	      var targetForm = _ref3.targetForm,
	          direction = _ref3.direction,
	          currentForm = _ref3.currentForm,
	          done = _ref3.done;
	
	      // Any time we go traverse backwards, just let us
	      if (currentForm.filter(".shipping-tab").length) {
	        if (targetForm.filter(".products-tab").length) {
	          direction = "BACKWARDS";
	        }
	      }
	
	      if (direction === "BACKWARDS") {
	        return true;
	      }
	
	      if (currentForm.filter(".destination-tab").length) {
	        areInputsValid(true, function (validResult) {
	          handleInputsFinishedValidatingForDestinationTab(validResult, done);
	        });
	      } else if (currentForm.filter('.shipping-tab').length) {
	        var isShippingOrServiceLevelSelected = false;
	        var _countryVal = $('#destination-tab-country  :selected').val();
	        var shippingTypeSelected = $('#shipping-tab-shipping-type-select').val();
	        var fedexShippingSelected = !fedexShippingMethodBtn.is("hidden") && fedexShippingMethodBtn.hasClass("active");
	        var serviceLevelSelected = !serviceLevelsBtn.is("hidden") && serviceLevelsBtn.hasClass("active");
	        if (shippingTypeSelected == "LTL") {
	          btnClickVar = true;
	        } else {
	          if (fedexShippingSelected || serviceLevelSelected) {
	            isShippingOrServiceLevelSelected = true;
	          }
	          if (isShippingOrServiceLevelSelected) {
	            btnClickVar = true;
	          } else {
	            //Check if is a channel custom shipping method 
	            //Toggle turned to YES,set to TRUE else set to FALSE, For non US set to True  
	            var retainChannelShipmentCheck = el.find("#channelShippingMethodCheck");
	            if (retainChannelShipmentCheck.length > 0) {
	              if (isChannelOrder && retainChannelShipmentCheck.is(":checked") && _countryVal == 1) {
	                btnClickVar = true;
	              } else if (isChannelOrder && _countryVal != 1) {
	                btnClickVar = true;
	              } else {
	                btnClickVar = false;
	              }
	            } else {
	              if ($('#shipping-tab-shipping-type-select').val() == "PCL") {
	                var _countryVal2 = $('#destination-tab-country  :selected').val();
	                if (_countryVal2 != "1") {
	                  btnClickVar = true;
	                }
	              }
	            }
	          }
	        }
	
	        areInputsValid(btnClickVar, done);
	      } else {
	        areInputsValid(true, done);
	      }
	
	      function areInputsValid(shouldContinue, cb) {
	        var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	        var notValid = !quickWizard.areInputsValid(allPrevInputs, { displayErrors: true });
	        if (notValid || !shouldContinue) {
	          if (notValid) {
	            quickWizard.goToFirstIncompleteForm();
	          }
	          cb(false);
	        } else {
	          cb(true);
	        }
	      }
	
	      function handleInputsFinishedValidatingForDestinationTab(validResult, cb) {
	        if (validResult) {
	          addressValidation.determineAddressValidity(function (useAddress) {
	            if (useAddress) {
	              var validatedAddress = addressValidation.getAddressResponse();
	              hiddenAddressInput.val(JSON.stringify(validatedAddress));
	              cb(true);
	            } else {
	              cb(false);
	            }
	          });
	        } else {
	          cb(validResult);
	        }
	      }
	
	      return done;
	    },
	
	    didNavigateToForm: function didNavigateToForm(_ref4) {
	      var currentForm = _ref4.currentForm,
	          currentDirection = _ref4.currentDirection;
	
	      if (currentForm.filter('.review-tab').length) {
	        preparationTab.getScheduleReleaseTimeAndDate();
	        reviewTab.didNavigateToForm();
	      } else if (currentForm.filter('.shipping-tab').length) {
	        if (currentDirection == "FORWARDS") {
	          preparationTab.handleDestTabOrderTypeLoad();
	          (0, _preparationTab.calcShippingMethod)();
	        }
	      } else if (currentForm.filter('.products-tab').length) {
	        productsTab.didNavigateToForm();
	        var _countryVal3 = $('#destination-tab-country  :selected').val();
	        if (_countryVal3 == "-1" || _countryVal3 == "1") {
	          $("#product-tab-internation-msg-id").hide();
	          //productsTab.setProductLookupAndModal(productsTab.productItems.regularItems , productsTab.productNameArr.regularItems);
	          $("#products-list").show();
	          $("#international-products-list").hide();
	          $(".qw-products-intl-order").hide();
	        } else {
	          $("#product-tab-internation-msg-id").show();
	          //productsTab.setProductLookupAndModal(productsTab.productItems.internationalItems, productsTab.productNameArr.internationalItems);
	          $("#products-list").hide();
	          $("#international-products-list").show();
	          $(".qw-products-intl-order").show();
	        }
	      }
	    }
	  });
	
	  quickWizard.init();
	
	  var destinationTab = new _destinationTab2.default(quickWizard);
	  destinationTab.init();
	
	  var productsTab = new _ProductsTab2.default(quickWizard);
	  productsTab.init();
	
	  var preparationTab = new _preparationTab2.default(quickWizard);
	  preparationTab.init();
	
	  var reviewTab = new _ReviewTab2.default(quickWizard);
	  reviewTab.init();
	
	  var addressValidationModalEl = $("#add-validation-model");
	  var isAddressValidationRequired = destinationTab.checkForAddressValidationBusinessException(orderDetailsForEdit);
	  var addressValidation = (0, _AddressValidation2.default)(addressValidationModalEl, el, {
	    isAlreadyValid: !isAddressValidationRequired
	  });
	  (0, _select2able.validateOnAllSelectChanges)();
	}

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#order-detail-page", function () {
	
		var validator = (0, _jquery2.default)(".address-validation-form").validate({
			errorPlacement: function errorPlacement(error, element) {
				var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
				if (appendClosest) {
					(0, _jquery2.default)(element).closest(appendClosest).append(error);
				} else {
					error.insertAfter(element);
				}
			}
		});
	
		validator.settings.ignore = ":disabled,:hidden";
	
		var fixAddressBtn = "#order-detail-fix-add-btn";
		var order = (0, _jquery2.default)("#order-detail-page").data("order");
		var validateAddressUrl = (0, _jquery2.default)("#order-detail-page").data("validate-address-url");
		var pageReloadUrl = (0, _jquery2.default)("#order-detail-page").data("order-detail-page-reload-url");
		var generalErrorMessage = (0, _jquery2.default)("#order-detail-page").data("general-error-message");
		var addressFoundTitleText = (0, _jquery2.default)("#order-detail-page").data("add-validation-add-found-title-text");
		var addressNotFoundText = (0, _jquery2.default)("#order-detail-page").data("add-validation-system-not-found-add-text");
		var addressRevalidateTitle = (0, _jquery2.default)("#order-detail-page").data("add-val-modify-address-revalidate-title");
	
		(0, _jquery2.default)(fixAddressBtn).click(function () {
			showModal();
			showLoadingModal();
			if (order.ordValidAddressFlag != "1") {
				addressValidation();
			} else {
				addressFoundModal(order.ordStdAddressLine1, order.ordStdAddressLine2, order.ordStdCity, order.ordStdState, order.ordStdZip, order.ordStdCountry, null);
			}
		});
	
		function addressValidation() {
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: {
					orderId: order.ordOrderId,
					callType: "addressValidation"
				},
				success: function success(data) {
					if (data.response == "success") {
						if (data.ordValidAddressFlag == '1') {
							addressFoundModal(data.ordStdAddressLine1, data.ordStdAddressLine2, data.ordStdCity, data.ordStdState, data.ordStdZip, data.ordStdCountry, data);
						} else {
							addressNotFoundModal(data);
							var isChecked = (0, _jquery2.default)('body').find('.radio-entered-address').is(':checked');
							if (!isChecked) {
								(0, _jquery2.default)(".use-selected-address-btn").attr("disabled", true);
							} else {
								(0, _jquery2.default)(".use-selected-address-btn").attr("disabled", false);
							}
						}
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		}
	
		function addressFoundModal(stdAddress1, stdAddress2, stdCity, stdState, stdZip, stdCountry, data) {
	
			var userAddHtml = "";
	
			if (data == null) {
				userAddHtml += order.ordShipToAddress1;
	
				if (!empty(order.ordShipToAddress2)) {
					userAddHtml += "," + order.ordShipToAddress2 + "," + order.ordShipToCity + "," + order.ordShipToState + "," + order.ordShipToZip;
				} else {
					userAddHtml += "," + order.ordShipToCity + "," + order.ordShipToState + "," + order.ordShipToZip;
				}
			} else {
				userAddHtml = data.ordShipToAddress1;
	
				if (!empty(data.ordShipToAddress2)) {
					userAddHtml += "," + data.ordShipToAddress2 + "," + data.ordShipToCity + "," + data.ordShipToState + "," + data.ordShipToZip;
				} else {
					userAddHtml += "," + data.ordShipToCity + "," + data.ordShipToState + "," + data.ordShipToZip;
				}
			}
	
			(0, _jquery2.default)("#add-validation-user-entered-add").html(userAddHtml);
	
			var sysAddHtml = stdAddress1;
			if (!empty(stdAddress2)) {
				sysAddHtml += "," + stdAddress2 + "," + stdCity + "," + stdState + "," + stdZip;
			} else {
				sysAddHtml += "," + stdCity + "," + stdState + "," + stdZip;
			}
	
			(0, _jquery2.default)("#add-validation-system-found-add").html(sysAddHtml);
			showAddressFoundModal();
		}
	
		function addressNotFoundModal(data) {
	
			var userAddHtml = data.ordShipToAddress1;
			if (!empty(data.ordShipToAddress2)) {
				userAddHtml += "," + data.ordShipToAddress2 + "," + data.ordShipToCity + "," + data.ordShipToState + "," + data.ordShipToZip;
			} else {
				userAddHtml += "," + data.ordShipToCity + "," + data.ordShipToState + "," + data.ordShipToZip;
			}
	
			(0, _jquery2.default)("#add-validation-user-entered-add").html(userAddHtml);
			showAddressNotFoundModal();
		}
	
		(0, _jquery2.default)('.mod-address-btn').click(function () {
			showLoadingModal();
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: {
					orderId: order.ordOrderId,
					callType: "modifyAddress"
				},
				success: function success(data) {
					if (data.response == "success") {
						var countries = data.countries;
	
						(0, _jquery2.default)('#validate-address-country').empty();
						var option = (0, _jquery2.default)('<option />');
						option.attr('value', '').text("Select Country");
						(0, _jquery2.default)('#validate-address-country').append(option);
						(0, _jquery2.default)(countries).each(function () {
							option = (0, _jquery2.default)('<option />');
							option.attr('value', this.conCode).text(this.conName);
							(0, _jquery2.default)('#validate-address-country').append(option);
						});
	
						var userAddHtml = data.ordShipToAddress1;
	
						if (!empty(data.ordShipToAddress2)) {
							userAddHtml += "," + data.ordShipToAddress2 + "," + data.ordShipToCity + "," + data.ordShipToState + "," + data.ordShipToZip;
						} else {
							userAddHtml += "," + data.ordShipToCity + "," + data.ordShipToState + "," + data.ordShipToZip;
						}
						(0, _jquery2.default)("#add-validation-user-entered-add").html(userAddHtml);
						(0, _jquery2.default)(".origin-modify-enter-address-item").hide();
						showModifyAddressModal();
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		});
	
		(0, _jquery2.default)('#validate-address-country').change(function () {
			var countryVal = (0, _jquery2.default)("#validate-address-country :selected").val();
			setStatesFromCountry(countryVal, this.selectedIndex);
		});
	
		function setStatesFromCountry(countryVal, selectedIndex) {
	
			if (countryVal == "US" || countryVal == "CA") {
				(0, _jquery2.default)(".validate-address-state-text-wrapper").hide();
				(0, _jquery2.default)(".validate-address-state-wrapper").show();
				window.print_state("validate-address-state", selectedIndex);
			} else {
				(0, _jquery2.default)(".validate-address-state-text-wrapper").show();
				(0, _jquery2.default)(".validate-address-state-wrapper").hide();
			}
		}
	
		(0, _jquery2.default)('.use-selected-address-btn').click(function () {
			showLoadingModal();
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: {
					orderId: order.ordOrderId,
					userSelectedAdd: (0, _jquery2.default)('[name=radioAddressChoice]:checked').val(),
					callType: "usethisAddress"
				},
				success: function success(data) {
					if (data.response == "success" && data.isAddFixed) {
						location.href = pageReloadUrl;
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		});
	
		(0, _jquery2.default)('.validate-address-btn').click(function () {
	
			if (!validator.elements().valid()) {
				return;
			}
	
			showLoadingModal();
	
			var conCode = (0, _jquery2.default)("#validate-address-country :selected").val();
			var stateValue = "";
			if (conCode == "US" || conCode == "CA") {
				stateValue = (0, _jquery2.default)("#validate-address-state :selected").val();
			} else {
				stateValue = (0, _jquery2.default)("#validate-address-state-text").val();
			}
	
			_jquery2.default.ajax({
				url: validateAddressUrl,
				type: 'POST',
				dataType: 'JSON',
				data: {
					orderId: (0, _jquery2.default)('#orderId').val(),
					country: conCode,
					address1: (0, _jquery2.default)("#validate-address-address1").val(),
					address2: (0, _jquery2.default)("#validate-address-address2").val(),
					city: (0, _jquery2.default)("#validate-address-city").val(),
					state: stateValue,
					zip: (0, _jquery2.default)("#validate-address-zip").val(),
					callType: "validateThisAddress"
				},
				success: function success(data) {
					if (data.response == "success") {
						if (data.isAddFixed) {
							location.href = pageReloadUrl;
						} else if (data.ordValidAddressFlag == "1") {
							addressFoundModal(data.ordStdAddressLine1, data.ordStdAddressLine2, data.ordStdCity, data.ordStdState, data.ordStdZip, data.ordStdCountry, data);
						} else {
							addressNotFoundModal(data);
						}
					}
				},
				error: function error() {
					hideModal();
					alert(generalErrorMessage);
				}
			});
		});
	
		function showLoadingModal() {
			(0, _jquery2.default)("#address-found-or-not-text").html("");
			(0, _jquery2.default)(".add-validation").show();
			(0, _jquery2.default)(".origin-add-validation").hide();
			(0, _jquery2.default)(".address-select-choices-outer").hide();
			(0, _jquery2.default)(".address-validation-loading-outer").show();
			(0, _jquery2.default)(".cancel-btn").hide();
			(0, _jquery2.default)(".mod-address-btn").show();
			(0, _jquery2.default)(".select-saved-address-btn").hide();
			(0, _jquery2.default)(".use-selected-address-btn").hide();
			(0, _jquery2.default)(".validate-address-btn").hide();
		}
	
		function showModal() {
			(0, _jquery2.default)("#add-validation-model").modal("show");
		}
	
		function hideModal() {
			(0, _jquery2.default)("#add-validation-model").modal("hide");
		}
	
		function showAddressFoundModal() {
			(0, _jquery2.default)("#address-found-or-not-text").html(addressFoundTitleText);
			if ((0, _jquery2.default)("#radio-entered-address").hasClass("q-radio-hide")) {
				(0, _jquery2.default)("#radio-entered-address").removeClass("q-radio-hide");
			}
			(0, _jquery2.default)(".add-validation").show();
			(0, _jquery2.default)(".address-select-choices-outer").show();
			(0, _jquery2.default)(".found-address-item").show();
			(0, _jquery2.default)(".enter-address-item").show();
			(0, _jquery2.default)(".modify-address-section").hide();
			(0, _jquery2.default)(".no-address-found-section").hide();
			(0, _jquery2.default)(".address-validation-loading-outer").hide();
			(0, _jquery2.default)(".mod-address-btn").show();
			(0, _jquery2.default)(".use-selected-address-btn").show();
			(0, _jquery2.default)(".validate-address-btn").hide();
		}
	
		function showAddressNotFoundModal() {
			(0, _jquery2.default)("#address-found-or-not-text").html(addressNotFoundText);
			if ((0, _jquery2.default)("#radio-entered-address").hasClass("q-radio-hide")) {
				(0, _jquery2.default)("#radio-entered-address").removeClass("q-radio-hide");
			}
			(0, _jquery2.default)(".add-validation").show();
			(0, _jquery2.default)(".address-select-choices-outer").show();
			(0, _jquery2.default)(".found-address-item").hide();
			(0, _jquery2.default)(".enter-address-item").show();
			(0, _jquery2.default)(".modify-address-section").hide();
			(0, _jquery2.default)(".no-address-found-section").show();
			(0, _jquery2.default)(".address-validation-loading-outer").hide();
			(0, _jquery2.default)(".mod-address-btn").show();
			(0, _jquery2.default)(".use-selected-address-btn").show();
			(0, _jquery2.default)(".validate-address-btn").hide();
		}
	
		function showModifyAddressModal() {
			(0, _jquery2.default)("#address-found-or-not-text").html(addressRevalidateTitle);
			(0, _jquery2.default)("#radio-entered-address").addClass("q-radio-hide");
			(0, _jquery2.default)(".address-select-choices-outer").show();
			(0, _jquery2.default)(".add-validation").show();
			(0, _jquery2.default)(".found-address-item").hide();
			(0, _jquery2.default)(".enter-address-item").show();
			(0, _jquery2.default)(".modify-address-section").show();
			(0, _jquery2.default)(".no-address-found-section").hide();
			(0, _jquery2.default)(".address-validation-loading-outer").hide();
			(0, _jquery2.default)(".mod-address-btn").hide();
			(0, _jquery2.default)(".use-selected-address-btn").hide();
			(0, _jquery2.default)(".validate-address-btn").show();
		}
	
		function empty(str) {
			if (typeof str == 'undefined' || !str || str.length === 0 || str === "" || !/[^\s]/.test(str) || /^\s*$/.test(str) || str.replace(/\s/g, "") === "") {
				return true;
			} else {
				return false;
			}
		}
	
		(0, _jquery2.default)(document).on('click', '.radio-entered-address', function (e) {
			addressNotFoundValidationModal();
		});
	
		function addressNotFoundValidationModal() {
			var isChecked = (0, _jquery2.default)('body').find('.radio-entered-address').is(':checked');
			var stubmitBtn = (0, _jquery2.default)('body').find('.use-selected-address-btn');
	
			if (isChecked) {
				stubmitBtn.attr("disabled", false);
			} else {
				stubmitBtn.attr("disabled", true);
			}
		}
	
		addressNotFoundValidationModal();
	});

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _detailAddressValidation = __webpack_require__(715);
	
	var _detailAddressValidation2 = _interopRequireDefault(_detailAddressValidation);
	
	var _shipFedExModal = __webpack_require__(712);
	
	var _shipFedExModal2 = _interopRequireDefault(_shipFedExModal);
	
	var _shipThirdPartyModal = __webpack_require__(713);
	
	var _shipThirdPartyModal2 = _interopRequireDefault(_shipThirdPartyModal);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _filtersutil = __webpack_require__(16);
	
	var _pagableComponent = __webpack_require__(86);
	
	var _pagableComponent2 = _interopRequireDefault(_pagableComponent);
	
	var _index = __webpack_require__(10);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cssNotesModalBodyHtml = __webpack_require__(1373);
	var cssReadNotesModalBodyHtml = __webpack_require__(1374);
	var editErrorOrderModal = __webpack_require__(305);
	var editBackOrderedOrderModal = __webpack_require__(302);
	var editHeldOrderModal = __webpack_require__(306);
	var editCustomHeldOrderModal = __webpack_require__(304);
	var editChannelHeldOrderModal = __webpack_require__(303);
	var editPortalHeldOrderModal = __webpack_require__(307);
	var modalHtml = __webpack_require__(11);
	
	__webpack_require__(1119);
	var _ = __webpack_require__(2);
	
	var orderHistoryRowHtml = __webpack_require__(1380);
	
	var statusPillBodyHtml = __webpack_require__(308);
	
	(0, _run2.default)("#order-detail-page", function () {
	  var orderDetailPage = (0, _jquery2.default)("#order-detail-page");
	  var order = orderDetailPage.data("order");
	  var pageReloadUrl = orderDetailPage.data("order-detail-page-reload-url");
	  var generalErrorMessage = orderDetailPage.data("general-error-message");
	  var packingSlipBtn = ".packing-slip-btn";
	  var commercialInvoiceBtn = ".commercial-invoice-btn";
	  var packingSlipUrl = orderDetailPage.data("package-slip-url");
	  var commercialInvoiceUrl = orderDetailPage.data("commercial-invoice-url");
	  var cancelBackorderUrl = orderDetailPage.data("cancel-backorder-url");
	  var isCancelEnable = orderDetailPage.data("is-cancel-enable");
	  var schedulerInterval = orderDetailPage.data("scheduler-interval");
	  var releasedDate = orderDetailPage.data("ord-released-date");
	  var holdDate = orderDetailPage.data("ord-hold-date");
	  var selfFulfillUrl = orderDetailPage.data("self-fulfill-url");
	  var selfFulfillShipWithFedExUrl = orderDetailPage.data("self-fulfill-shipwithfedex-url");
	  var selfFulfillShipWith3rdPartyUrl = orderDetailPage.data("self-fulfill-shipwith3rdparty-url");
	  var cancelReasonUrl = orderDetailPage.data("get-cancel-reason-url");
	  var cancelOrderUrl = orderDetailPage.data("cancel-order-url");
	  var releaseOrderUrl = orderDetailPage.data("release-order-url");
	  var createRmaReturnUrl = orderDetailPage.data("create-rma-return-url");
	  var selfFulfillDate = orderDetailPage.data("self-fulfill-date");
	  var downloadFedexShippingLabelUrl = orderDetailPage.data("download-fedex-shipping-label-url");
	  var targetCancelOriId = null;
	  var datTimeFormat = "MM/DD/YYYY hh:mm A";
	  var dateFormat = "MM/DD/YYYY";
	  var resubmitUrl = orderDetailPage.data("resubmit-url");
	  var oriItemIds = [];
	  var markExceptionClosedUrl = orderDetailPage.data("mark-exception-closed-url");
	  var resolveExceptionUrl = orderDetailPage.data("resolve-exception-url");
	  var cssNotesModalTitle = orderDetailPage.data("css-notes-modal-title");
	  var cssNotesModalBtnTxt = orderDetailPage.data("css-notes-modal-btn-txt");
	  var resolutionNotesEl = (0, _jquery2.default)('.resolution-notes');
	  var activateProductModalCall = (0, _jquery2.default)(".activate-product-business-exception-modal-call");
	  var activateProductModal = (0, _jquery2.default)("#activate-product-business-exception-modal");
	  var activateProductConfirm = activateProductModal.find(".confirm-btn");
	  var productDetailPageUrl = orderDetailPage.data("product-detail-page-url");
	  var updateProductDetailPageUrl = orderDetailPage.data("update-product-detail-page-url");
	  var updateProductModalCall = (0, _jquery2.default)(".update-product-business-exception-modal-call");
	  var updateProductModal = (0, _jquery2.default)("#update-product-business-exception-modal");
	  var updateProductConfirm = updateProductModal.find(".confirm-btn");
	
	  var setInternationalShippingModal = (0, _jquery2.default)("#set-international-shipping-for-retailer-modal");
	  var setInternationalShippingConfirm = setInternationalShippingModal.find(".confirm-btn");
	
	  var viewOrderDetailURL = orderDetailPage.data("order-detail-url");
	  var portletNamespace = orderDetailPage.data("portlet-namespace");
	  var editOrderUrl = orderDetailPage.data("edit-order-url");
	  var editOrderBtn = orderDetailPage.find(".edit-order");
	  var orderActions = orderDetailPage.data("order-actions");
	  var loadMoreOrderActionsUrl = orderDetailPage.data("loadmore-actions-url");
	  var orderLastEditedDate = orderDetailPage.data("order-last-edited-date");
	  var shipOrderUrl = orderDetailPage.data("shiporder-url");
	  var downloadFileByDocIdUrl = orderDetailPage.data("download-by-doc-url");
	  var downloadFileUrl = orderDetailPage.data("download-file-url");
	
	  var resolveExceptionModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	    title: cssNotesModalTitle,
	    leftAlignTitle: true,
	    body: cssNotesModalBodyHtml,
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn resolve-exception-modal-confirm">' + cssNotesModalBtnTxt + '</a>'
	  }));
	
	  var editErrorModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	    title: "Edit Order",
	    leftAlignTitle: true,
	    body: renderErrorModalPill(),
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
	  }));
	
	  var editBackOrderedModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	    title: "Edit Order",
	    leftAlignTitle: true,
	    body: renderBackOrderedModal(),
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
	  }));
	
	  var editManualHoldModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	    title: "Edit Order",
	    leftAlignTitle: true,
	    body: renderOrderHeldModal(),
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
	  }));
	
	  var editCustomHeldModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	    title: "Edit Order",
	    leftAlignTitle: true,
	    body: renderCustomHeldModal(),
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
	  }));
	
	  var editChannelHeldModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	    title: "Edit Order",
	    leftAlignTitle: true,
	    body: renderChannelHeldModal(),
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
	  }));
	
	  var editPortalHeldModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	    title: "Edit Order",
	    leftAlignTitle: true,
	    body: renderPortalHeldModal(),
	    topCloseBtn: true,
	    autoHideTop: true,
	    footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
	  }));
	
	  function renderPortalHeldModal() {
	    return (0, _render2.default)(editPortalHeldOrderModal, {
	      statusPill: renderPillForModal(order.ordStatus)
	    });
	  }
	
	  function renderChannelHeldModal() {
	    return (0, _render2.default)(editChannelHeldOrderModal, {
	      statusPill: renderPillForModal(order.ordStatus)
	    });
	  }
	
	  function renderCustomHeldModal() {
	    return (0, _render2.default)(editCustomHeldOrderModal, {
	      statusPill: renderPillForModal(order.ordStatus)
	    });
	  }
	
	  function renderOrderHeldModal() {
	    return (0, _render2.default)(editHeldOrderModal, {
	      statusPill: renderPillForModal(order.ordStatus)
	    });
	  }
	
	  function renderBackOrderedModal() {
	    return (0, _render2.default)(editBackOrderedOrderModal, {
	      statusPill: renderPillForModal(order.ordStatus)
	    });
	  }
	
	  function renderErrorModalPill() {
	    return (0, _render2.default)(editErrorOrderModal, {
	      statusPill: renderPillForModal(order.ordStatus)
	    });
	  }
	
	  function renderPillForModal(status) {
	    var newRender = void 0;
	    var statusPillClass = _filtersutil.pillStatusClasses[status] || _filtersutil.pillStatusClasses.default;
	    var statusText = "Order " + status;
	    return newRender = (0, _render2.default)(statusPillBodyHtml, {
	      statusText: statusText,
	      statusPillClass: statusPillClass
	    });
	  }
	
	  (0, _jquery2.default)('body').append(resolveExceptionModal, editErrorModal, editBackOrderedModal, editCustomHeldModal, editPortalHeldModal, editChannelHeldModal, editManualHoldModal);
	
	  (0, _jquery2.default)(".resolve-exception-modal-confirm").on('click', onResolveExceptionClick);
	
	  function onResolveExceptionClick(e) {
	    e.preventDefault();
	    if ((0, _jquery2.default)("form#cssNotesInputForm").valid()) {
	      submitModalFlow.showLoadingModal();
	      _jquery2.default.ajax({
	        url: resolveExceptionUrl,
	        type: 'POST',
	        dataType: 'TEXT',
	        data: {
	          notes: (0, _jquery2.default)(".resolution-notes").val(),
	          exceptionId: resolveExceptionModal.data("currentExceptionId")
	        },
	        success: function success(data) {
	          if (data.match("Success")) {
	            submitModalFlow.showSuccessModal();
	            setTimeout(function () {
	              location.href = pageReloadUrl;
	            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	          } else {
	            submitModalFlow.showFailureModal();
	          }
	        },
	        error: function error() {
	          submitModalFlow.hideAllModals();
	        }
	      });
	    }
	  }
	  var cssNotesValidator = (0, _jquery2.default)("form#cssNotesInputForm").validate();
	
	  (0, _jquery2.default)(document).on('click', '.close-exception', function (e) {
	    e.preventDefault();
	    var exceptionId = (0, _jquery2.default)(this).data('exception-id');
	    (0, _jquery2.default)(this).closest('.exception-row').hide();
	    closeException(exceptionId);
	  });
	
	  function closeException(exceptionId) {
	    _jquery2.default.ajax({
	      url: markExceptionClosedUrl,
	      type: 'POST',
	      dataType: 'TEXT',
	      data: {
	        exceptionId: exceptionId
	      }
	    });
	  }
	
	  (0, _jquery2.default)(document).on('click', '.resolve-exception-btn', function (e) {
	    e.preventDefault();
	    var exceptionId = (0, _jquery2.default)(this).data('exception-id');
	    resolveException(exceptionId);
	  });
	
	  (0, _jquery2.default)(document).on('click', '.download-doc-row-btn', function (e) {
	    e.preventDefault();
	    var documentId = (0, _jquery2.default)(this).data('document-id');
	
	    if (shallAllowClick(this)) {
	      downloadFiles([documentId], 'downloadByDocId');
	    }
	  });
	
	  (0, _jquery2.default)('body').on('click', '.download-shipping-doc-btn', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      downloadFiles([order.ordOrderId], 'downloadByShpInfo');
	    }
	  });
	
	  function downloadFiles(item, downloadSrc) {
	    var downloadFileUri = void 0;
	    var encodeDocId = void 0;
	    if (downloadSrc == 'downloadByDocId') {
	      encodeDocId = encodeURIComponent(item);
	      downloadFileUri = downloadFileByDocIdUrl + "&documentId=" + encodeDocId;
	    } else {
	      encodeDocId = encodeURIComponent(item);
	      downloadFileUri = downloadFileUrl + "&orderId=" + encodeDocId;
	    }
	
	    var formData = new FormData();
	    formData.append("shpShipmentRow", "");
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      url: downloadFileUri,
	      type: 'POST',
	      data: formData,
	      enctype: 'multipart/form-data',
	      processData: false,
	      contentType: false,
	      cache: false,
	      success: downloadFileSuccess,
	      error: downloadFileError
	    });
	  }
	
	  function shallAllowClick(currentObj) {
	    return !(0, _jquery2.default)(currentObj).hasClass("disabled");
	  }
	
	  function downloadFileSuccess(data) {
	    if ((0, _general.isPresent)(data)) {
	      _jquery2.default.each(JSON.parse(data), function (key, value) {
	        if (value.contentType == "atd") {
	          value.contentType = "txt";
	        }
	        downloadFile(value.contentType, value.fileName, value.content);
	      });
	    } else {
	      setTimeout(function () {
	        submitModalFlow.hideAllModals();
	        submitModalFlow.showFailureModal();
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    }
	  }
	
	  function downloadFileError() {
	    submitModalFlow.showFailureModal();
	    setTimeout(function () {
	      submitModalFlow.hideAllModals();
	      submitModalFlow.showFailureModal();
	    }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	  }
	
	  function downloadFile(mimeType, fileName, data) {
	    var a = document.createElement('a');
	    if (window.URL && window.Blob && 'download' in a && window.atob) {
	      // Do it the HTML5 compliant way
	      var blob = base64ToBlob(data, mimeType);
	      var url = window.URL.createObjectURL(blob);
	      a.href = url;
	      a.download = fileName;
	      a.click();
	      window.URL.revokeObjectURL(url);
	    }
	    submitModalFlow.hideAllModals();
	  }
	
	  function base64ToBlob(base64, mimetype, slicesize) {
	    if (!window.atob || !window.Uint8Array) {
	      // The current browser doesn't have the atob function. Cannot continue
	      return null;
	    }
	    mimetype = "application/" + mimetype || '';
	    slicesize = slicesize || 512;
	    var bytechars = atob(base64);
	    var bytearrays = [];
	    for (var offset = 0; offset < bytechars.length; offset += slicesize) {
	      var slice = bytechars.slice(offset, offset + slicesize);
	      var bytenums = new Array(slice.length);
	      for (var i = 0; i < slice.length; i++) {
	        bytenums[i] = slice.charCodeAt(i);
	      }
	      var bytearray = new Uint8Array(bytenums);
	      bytearrays[bytearrays.length] = bytearray;
	    }
	    return new Blob(bytearrays, { type: mimetype });
	  }
	
	  (0, _jquery2.default)(document).on('click', '.activate-product-business-exception-modal-call', function (e) {
	    var itemId = (0, _jquery2.default)(this).data("item-id");
	    var productDetailUrl = productDetailPageUrl + "&itemId=" + itemId;
	    activateProductConfirm.attr("href", productDetailUrl);
	    activateProductModal.modal("show");
	  });
	
	  (0, _jquery2.default)(document).on('click', '.update-product-business-exception-modal-call', function (e) {
	    var itemId = (0, _jquery2.default)(this).data("item-id");
	    var productDetailUrl = updateProductDetailPageUrl + "&itemId=" + itemId;
	    updateProductConfirm.attr("href", productDetailUrl);
	    updateProductModal.modal("show");
	  });
	
	  updateProductConfirm.on('click', function (e) {
	    (0, _jquery2.default)("#update-product-business-exception-modal").modal("close");
	  });
	
	  activateProductConfirm.on('click', function (e) {
	    (0, _jquery2.default)("#activate-product-business-exception-modal").modal("close");
	  });
	
	  function createDetailLink(ordOrderId) {
	    return viewOrderDetailURL + "&" + portletNamespace + "orderId=" + ordOrderId;
	  }
	
	  function resolveException(exceptionId) {
	    resolveExceptionModal.modal('show');
	    resolveExceptionModal.data("currentExceptionId", exceptionId);
	    // resolveExceptionFlow.showConfirmModal();
	  }
	
	  (0, _jquery2.default)(document).on('click', '.view-notes', function (e) {
	    e.preventDefault();
	    var notes = (0, _jquery2.default)(this).data('resolution-notes');
	    var resolvedTime = (0, _jquery2.default)(this).data('resolution-time');
	    var resolvedBy = (0, _jquery2.default)(this).data('resolved-by');
	    openNotesModal(notes, resolvedTime, resolvedBy);
	  });
	
	  function openNotesModal(notes, resolvedTime, resolvedBy) {
	
	    var modalBody = (0, _render2.default)(cssReadNotesModalBodyHtml, {
	      date: resolvedTime,
	      css: resolvedBy,
	      notes: notes
	    });
	
	    var notesModal = (0, _jquery2.default)((0, _render2.default)(modalHtml, {
	      title: 'Notes',
	      leftAlignTitle: true,
	      body: modalBody,
	      topCloseBtn: true,
	      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Close</a>'
	    }));
	    notesModal.modal("show");
	  }
	
	  (0, _jquery2.default)(".ord-detail-remove-item-btn").on('click', function (e) {
	    e.preventDefault();
	    var targetOriId = (0, _jquery2.default)(this).closest(".product-sku-container").data("ori-id");
	    (0, _jquery2.default)("#prd-does-not-exit-msg-" + targetOriId).hide();
	    (0, _jquery2.default)("#mark-deletion-msg-" + targetOriId).show();
	    oriItemIds.push(targetOriId);
	  });
	
	  var markDeletionSubmit = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Remove Product From Order',
	    // confirmModalSubtitle: "Optional Subtitle",
	    confirmModalBody: "<div class=\"q-pad-all-xl\">\n\t\t\t\t\t\tAre you sure you want to remove this product from the order? Please resubmit this order once you remove this product.\n\t\t\t\t\t  </div>",
	    onConfirmClick: function onConfirmClick() {
	      // Show Loading Modal
	
	
	      setTimeout(function () {
	        markDeletionSubmit.showLoadingModal();
	        markDeletionSubmit.showSuccessModal();
	        markDeletionSubmit.hideAllModals();
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	      // call ajax funtion here.
	    }
	  });
	
	  markDeletionSubmit.init();
	
	  var resubmitModal = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Resubmit Order',
	    // confirmModalSubtitle: "Optional Subtitle",
	    confirmModalBody: "<div class=\"q-pad-all-xl\">\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<p class=\"q-marg-bottom-md\">The order wil be resubmitted to the fulfilment network. If successful, the order being processing. if unsuccessful, the order will remain in an error status until the error has been resolved.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"q-marg-top-md\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"pretty-well pw-border-rad pw-pad-md\">\n\t\t\t\t\t\t\t\t\t\t\tIf resubmitting doesnt work, contact your dedicated customer sucess specialist\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>",
	    confirmModalBtnText: 'Resubmit Order',
	    onConfirmClick: function onConfirmClick() {
	      // Show Loading Modal
	      resubmitModal.showLoadingModal();
	      // call ajax funtion here.
	      (0, _jquery2.default)("#removeOriIdText").val(JSON.stringify(oriItemIds));
	      reSubmitOrder({ url: resubmitUrl, success: submitOrderSuccess, error: submitOrderError });
	    }
	  });
	
	  resubmitModal.init();
	
	  function reSubmitOrder(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error;
	
	    _jquery2.default.ajax({
	      data: (0, _jquery2.default)("#resubmit-order").serialize(),
	      url: url,
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function submitOrderSuccess(orderId) {
	    if (orderId) {
	      EditChecker.setPageClean();
	      resubmitModal.showSuccessModal();
	      setTimeout(function () {
	        location.href = createDetailLink(orderId);
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    }
	  }
	
	  function submitOrderError() {
	    resubmitModal.showFailureModal();
	  }
	
	  (0, _jquery2.default)("#resubmit-ord-btn").on('click', function () {
	    resubmitModal.showConfirmModal();
	  });
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  onLoad();
	
	  /*
	  onload functionality
	  */
	  function onLoad() {
	    var ordStatus = order.ordStatus;
	    var gracePeriod = order.ordGracePeriod;
	    var orderCreatedDate = "";
	
	    if (isCancelEnable !== true) {
	      hideCancelOrderBtn();
	    }
	
	    if ((0, _general.isPresent)(order.ordCreatedDate)) {
	
	      //var date = new Date(order.ordCreatedDate); // date object will not work with IE need to manipulate manually.
	      //let orderDate =  new Date(Date.parse(order.ordCreatedDate));
	      (0, _jquery2.default)("#order-details-datereceived").text(order.ordCreatedDate + " ET");
	    }
	
	    if ((0, _general.isPresent)(order.ordTargetCompletionDate)) {
	      //var date = new Date(order.ordCreatedDate); // date object will not work with IE need to manipulate manually.
	      var orderDate = new Date(order.ordTargetCompletionDate); //timestamp
	      (0, _jquery2.default)("#target-completion-date").text((0, _moment2.default)(orderDate).format(dateFormat));
	    }
	
	    if ((ordStatus === "Held" || ordStatus === "Released" && order.ordReleasedBy === "hc-scheduler") && (0, _general.isPresent)(gracePeriod) && gracePeriod > 0 && order.ordHoldBy == null) {
	      populateGraceperiod(order.ordCreatedDate, ordStatus, gracePeriod, orderLastEditedDate);
	    }
	
	    if (ordStatus === "Released") {
	      populateReleaseDate();
	    }
	
	    if (ordStatus === "Held" && (0, _general.isPresent)(order.ordHoldBy)) {
	      populateHoldDate();
	    }
	
	    if (ordStatus === "Hold Pending") {
	      populateHoldPendingMsg();
	    }
	
	    if (ordStatus === "Pending") {
	      populatePendingStatusMsg();
	    }
	
	    if (ordStatus === "Self Fulfill") {
	      populateSelfFulfillDate();
	    }
	
	    if (ordStatus === "Partially Released") {
	      populateReleaseDate();
	    }
	
	    //self ful-fill
	    (0, _jquery2.default)('#self-fulfilled-shipped-by-fedex').hide();
	    (0, _jquery2.default)('#self-fulfilled-shipped-by-3rdparty').hide();
	    if (order.ordSelfFulfilled && order.ordStatus == "Shipped") {
	
	      var _orderDate = new Date(Date.parse(order.ordCreatedDate));
	      (0, _jquery2.default)(".self-fulfilled-date").text((0, _moment2.default)(_orderDate.toUTCString()).format(datTimeFormat) + " ET");
	      if (order.orderShipments != null && order.orderShipments.length > 0) {
	        if (order.orderShipments[0].orsCarrier.toLowerCase() == 'fedex') {
	          //Shipped  by Fedex
	          (0, _jquery2.default)('#self-fulfilled-shipped-by-fedex').show();
	          (0, _jquery2.default)('#self-fulfilled-shipped-by-3rdparty').hide();
	        } else {
	          //Shipped  by 3rd Party
	          (0, _jquery2.default)('#self-fulfilled-shipped-by-fedex').hide();
	          (0, _jquery2.default)('#self-fulfilled-shipped-by-3rdparty').show();
	          (0, _jquery2.default)('#packages-section').hide();
	          (0, _jquery2.default)('#tracking-information').hide();
	        }
	      }
	
	      _jquery2.default.each(order.orderShipments, function (index, orderShipment) {
	        if (orderShipment.orsCarrier.toLowerCase() != 'fedex') {
	          (0, _jquery2.default)('#list-tracking-numbers').append((0, _jquery2.default)('<p class="q-no-marg-bottom">').html((0, _jquery2.default)('<a href="' + orderShipment.orsUrl + '" target="_new">').text(orderShipment.orsTrackingNumber)));
	        }
	      });
	    }
	  }
	
	  function populateSelfFulfillDate() {
	    (0, _jquery2.default)("#order-status-message").html("Self-Fulfilled:");
	    (0, _jquery2.default)("#order-status-message-time").html(selfFulfillDate);
	  }
	
	  function populatePendingStatusMsg() {
	    (0, _jquery2.default)("#order-status-message-time").html("Refresh this page in a few moments to get an updated status.");
	  }
	
	  function populateHoldPendingMsg() {
	    (0, _jquery2.default)("#order-status-message").html("Awaiting Fulfillment Center Confirmation");
	  }
	
	  function populateReleaseDate() {
	    (0, _jquery2.default)("#order-status-message").html("Released:");
	    (0, _jquery2.default)("#order-status-message-time").html(releasedDate);
	  }
	
	  function populateHoldDate() {
	    (0, _jquery2.default)("#order-status-message").html("Held:");
	    (0, _jquery2.default)("#order-status-message-time").html(holdDate);
	  }
	
	  function populateGraceperiod(orderCreatedDate, ordStatus, gracePeriod, orderLastEditedDate) {
	    var gpHours = parseInt(gracePeriod / 60);
	    var gpMinutes = gracePeriod % 60;
	    var dateToUseForScheduledReleaseCalculation = void 0;
	    if ((0, _general.isPresent)(orderLastEditedDate)) {
	      dateToUseForScheduledReleaseCalculation = orderLastEditedDate;
	    } else {
	      dateToUseForScheduledReleaseCalculation = orderCreatedDate;
	    }
	    var scheduledReleaseDate = (0, _moment2.default)(dateToUseForScheduledReleaseCalculation, datTimeFormat).add(gracePeriod, 'm');
	    var scheduledRelease = scheduledReleaseDate.format(datTimeFormat) + " ET";
	    var t = scheduledReleaseDate - new Date();
	    (0, _jquery2.default)("#actualGracePeriod-wrapper i").removeClass('hide');
	
	    if (t > 0 && ordStatus === "Held") {
	
	      if (order.ordChannelType.match("Manual")) {
	        (0, _jquery2.default)("#actualGracePeriod").html("<strong>Grace Period:</strong> Portal Orders (" + _.escape(gpHours) + " hr " + _.escape(gpMinutes) + "  mins)");
	      } else {
	
	        (0, _jquery2.default)("#actualGracePeriod").html("<strong>Grace Period:</strong> Channel Orders (" + _.escape(gpHours) + " hr " + _.escape(gpMinutes) + " mins)");
	      }
	
	      (0, _jquery2.default)("#order-status-message").html("Scheduled Release:");
	      (0, _jquery2.default)("#order-status-message-time").html(scheduledRelease);
	
	      (0, _jquery2.default)("#countdown-time-wrapper").show();
	      var timeinterval = setInterval(function () {
	        var timeObj = getTimeRemaining(scheduledReleaseDate);
	
	        if (timeObj.total > 0) {
	          var countDownTime = "";
	          if (timeObj.days > 0) {
	            countDownTime = _.escape(formatTime(timeObj.days)) + " Days " + _.escape(formatTime(timeObj.hours)) + " : " + _.escape(formatTime(timeObj.minutes)) + " : " + _.escape(formatTime(timeObj.seconds));
	          } else {
	            countDownTime = _.escape(formatTime(timeObj.hours)) + " : " + _.escape(formatTime(timeObj.minutes)) + " : " + _.escape(formatTime(timeObj.seconds));
	          }
	          (0, _jquery2.default)("#countdown-time").html(countDownTime);
	          (0, _jquery2.default)(".countdown-time-modal").html(countDownTime);
	        } else {
	          clearInterval(timeinterval);
	          location.href = pageReloadUrl; //refresh current page
	        }
	      }, 1000);
	    } else if (ordStatus === 'Released' && order.ordReleasedBy == 'hc-scheduler') {
	      (0, _jquery2.default)("#actualGracePeriod").html("<strong>Grace Period: Expiration</strong>");
	    } else if (order.ordStatus === 'Held' && order.ordReleasedBy == null) {
	      (0, _jquery2.default)("#actualGracePeriod").html("<strong>Grace Period: Expired, this order will be released shortly.</strong>");
	    }
	  }
	
	  /*
	  onload functionality emd.
	  */
	
	  function hideReleaseOrderBtn() {
	    (0, _jquery2.default)(".order-detail-release-order-btn").hide();
	  }
	
	  function hideSelfFulfillBtn() {
	    (0, _jquery2.default)(".order-self-fulfill").hide();
	  }
	
	  function hideCancelOrderBtn() {
	    (0, _jquery2.default)(".order-detail-cancel-order-btn").hide();
	  }
	
	  /*
	  *cancel order button functionality
	  */
	  (0, _jquery2.default)(".order-detail-cancel-order-btn").click(function () {
	    _jquery2.default.ajax({
	      url: cancelReasonUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        orderId: order.ordOrderId
	      },
	      success: function success(data) {
	        if (data.response === "success") {
	          (0, _jquery2.default)("#modalCancelOrder").attr("disabled", true);
	          (0, _jquery2.default)("#order-detail-cancel-reason").val('0');
	          (0, _jquery2.default)("#cancelModal").modal("show");
	          emptyCurrentResonList();
	          fillReasonList(data.reasonList);
	        }
	      }
	    });
	  });
	
	  (0, _jquery2.default)(".ship-order-btn").click(function () {
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      url: shipOrderUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        orderId: order.ordOrderId
	      },
	      success: function success(data) {
	        if (data.response === "Success") {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageReloadUrl;
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        } else {
	          submitModalFlow.showFailureModal();
	        }
	      }
	    });
	  });
	
	  function emptyCurrentResonList() {
	    var reasonOptions = (0, _jquery2.default)("#order-detail-cancel-reason").find("option");
	    _.each(reasonOptions, function (val, key) {
	      if (key != 0) {
	        val.remove();
	      }
	    });
	  }
	
	  function fillReasonList(data) {
	    _.each(data, function (val, key) {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', key).text(val);
	      (0, _jquery2.default)("#order-detail-cancel-reason").append(option);
	    });
	  }
	
	  (0, _jquery2.default)("#order-detail-cancel-reason").change(function () {
	    (0, _jquery2.default)("#modalCancelOrder").attr("disabled", false);
	  });
	
	  (0, _jquery2.default)("#modalCancelOrder").click(function () {
	    var reason = (0, _jquery2.default)('#order-detail-cancel-reason :selected').text();
	    var value = (0, _jquery2.default)('#order-detail-cancel-reason :selected').val();
	    cancelOrder(reason, value);
	  });
	
	  function cancelOrder(reason, value) {
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      url: cancelOrderUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        orderId: order.ordOrderId,
	        reason: reason,
	        value: value
	      },
	      success: function success(data) {
	        if (data.response === "success") {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageReloadUrl;
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	      }
	    });
	  }
	
	  /**
	  *cancel order button functionality end
	  */
	
	  (0, _jquery2.default)("#confirmModalClose").click(function () {
	    location.href = pageReloadUrl;
	  });
	
	  /**
	  *release order button functionality
	  */
	  (0, _jquery2.default)('.order-detail-release-order-btn').click(function () {
	    (0, _jquery2.default)("#releaseModal").modal("show");
	  });
	
	  (0, _jquery2.default)('#releaseModalSubmitBtn').click(function () {
	    releaseOrder();
	  });
	
	  function releaseOrder() {
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      url: releaseOrderUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        orderId: order.ordOrderId
	      },
	      success: function success(data) {
	        if (data.response === "success") {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageReloadUrl;
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	      }
	    });
	  }
	
	  /**
	  *release order button functionality end
	  */
	
	  /**
	  *create rma return functionality
	  */
	
	  (0, _jquery2.default)(".create-a-return-rma").click(function () {
	    _jquery2.default.ajax({
	      url: createRmaReturnUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        orderId: order.ordOrderId
	      },
	      success: onSuccessCreateRmaReturn,
	      error: function error() {}
	    });
	  });
	
	  function onSuccessCreateRmaReturn(data) {
	    var formwithRmaDetails = (0, _jquery2.default)('<form></form>');
	    formwithRmaDetails.attr("method", "post");
	    formwithRmaDetails.attr("action", data.requestUrl);
	
	    var returnRequestJson = (0, _jquery2.default)('<input></input>');
	    returnRequestJson.attr("type", "hidden");
	    returnRequestJson.attr("name", "returnRequest");
	    returnRequestJson.attr("value", JSON.stringify(data));
	
	    formwithRmaDetails.append(returnRequestJson);
	
	    (0, _jquery2.default)(document.body).append(formwithRmaDetails);
	    formwithRmaDetails.submit();
	  }
	
	  /**
	  *create rma return functionality end
	  */
	
	  /**
	  *cancel backorder functionality
	  */
	
	  (0, _jquery2.default)(".order-bundle-cancel-backorder").click(function (e) {
	    e.preventDefault();
	    targetCancelOriId = (0, _jquery2.default)(this).closest(".product-sku-container").data("ori-id");
	    (0, _jquery2.default)("#cancelBundleBackorderModal").modal("show");
	  });
	
	  (0, _jquery2.default)(".order-cancel-backorder").click(function (e) {
	    e.preventDefault();
	    targetCancelOriId = (0, _jquery2.default)(this).closest(".product-sku-container").data("ori-id");
	    (0, _jquery2.default)("#cancelBackorderModal").modal("show");
	  });
	
	  (0, _jquery2.default)("#cancelBackorderSubmitBtn").click(function () {
	    cancelBackorderItems();
	  });
	
	  (0, _jquery2.default)("#cancelBundleBackorderSubmitBtn").click(function () {
	    cancelBackorderItems();
	  });
	
	  function cancelBackorderItems() {
	    _jquery2.default.ajax({
	      url: cancelBackorderUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        orderId: order.ordOrderId,
	        oriId: targetCancelOriId
	      },
	      success: function success(data) {
	        if (data.status === "Success") {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageReloadUrl;
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        } else {}
	      },
	      error: function error() {}
	    });
	  }
	  /**
	  *cancel backorder functionality end.
	  */
	
	  (0, _jquery2.default)(packingSlipBtn).click(function (e) {
	    e.preventDefault();
	    var packingSlipWindow = window.open(packingSlipUrl, 'packingSlipWindow');
	    packingSlipWindow.document.title = "packing-slip";
	  });
	
	  (0, _jquery2.default)(commercialInvoiceBtn).click(function (e) {
	    e.preventDefault();
	    var commercialSlipWindow = window.open(commercialInvoiceUrl, 'commercialInvoiceWindow');
	    commercialSlipWindow.document.title = "commercial-invoice";
	  });
	
	  (0, _jquery2.default)(".tracking-url").click(function (e) {
	    e.preventDefault();
	    var trackingUrl = (0, _jquery2.default)(this).closest(".package-tracking-link").data("package-tracking-url");
	    window.open(trackingUrl, '_blank');
	  });
	
	  function getTimeRemaining(scheduledReleaseDate) {
	    var today = (0, _general.getESTDate)(new Date());
	    var t = scheduledReleaseDate - today;
	    var seconds = Math.floor(t / 1000 % 60);
	    var minutes = Math.floor(t / 1000 / 60 % 60);
	    var hours = Math.floor(t / (1000 * 60 * 60) % 24);
	    var days = Math.floor(t / (1000 * 60 * 60 * 24));
	    return {
	      'total': t,
	      'days': days,
	      'hours': hours,
	      'minutes': minutes,
	      'seconds': seconds
	    };
	  }
	
	  function formatTime(i) {
	    if (i < 10) {
	      i = "0" + i;
	    }
	    return i;
	  }
	
	  /**
	  *Self Ful-fillment functionality start.
	  */
	
	  (0, _jquery2.default)(".order-self-fulfill").click(function (e) {
	    e.preventDefault();
	    if ((0, _jquery2.default)(this).hasClass('disabled')) return;
	    (0, _jquery2.default)("#selfFulfillModal").modal("show");
	  });
	
	  (0, _jquery2.default)("#selfFulfillSubmitBtn").click(function (e) {
	    submitModalFlow.showLoadingModal();
	    e.preventDefault();
	    _jquery2.default.ajax({
	      url: selfFulfillUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        orderId: order.ordOrderId
	      },
	      success: function success(data) {
	        if (data.response === "success") {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageReloadUrl;
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	      },
	      error: function error() {}
	    });
	  });
	
	  (0, _jquery2.default)("#fedExShippingLabel").click(function (e) {
	    e.preventDefault();
	    window.open(downloadFedexShippingLabelUrl, 'labelWindow');
	  });
	
	  // Ship With Fedex
	  var shipFedExOpenBtn = (0, _jquery2.default)(".ship-fedex-open-btn");
	  shipFedExOpenBtn.click(onShipFedExOpenBtnClick);
	
	  var shipFedExModal = (0, _shipFedExModal2.default)({
	    onShipFedExBtnValidClick: function onShipFedExBtnValidClick() {
	      var data = shipFedExModal.getAllFormData();
	      postShipWithFedEx(data);
	    }
	  });
	  var shipFedExModalFactoryEl = shipFedExModal.getElement();
	
	  function postShipWithFedEx(data) {
	    submitModalFlow.showLoadingModal();
	    data.orderId = order.ordOrderId;
	    data["boxes"] = JSON.stringify(data.boxes);
	    _jquery2.default.ajax({
	      url: selfFulfillShipWithFedExUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: data,
	      success: function success(data) {
	        if (data.response === "success") {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageReloadUrl;
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	      },
	      error: function error() {}
	    });
	  }
	
	  function onShipFedExOpenBtnClick(e) {
	    e.preventDefault();
	    shipFedExModal.showModal();
	  }
	  // END
	
	  // Ship with Fedex - Third Party
	  var shipThirdPartyOpenBtn = (0, _jquery2.default)(".ship-third-party-open-btn");
	  shipThirdPartyOpenBtn.click(onShipThirdPartyOpenBtnClick);
	
	  var shipThirdPartyModal = (0, _shipThirdPartyModal2.default)({
	    onShipThirdPartyBtnValidClick: function onShipThirdPartyBtnValidClick() {
	      var data = shipThirdPartyModal.getAllFormData();
	      postShipWithThirdParty(data);
	    }
	  });
	
	  function postShipWithThirdParty(data) {
	    submitModalFlow.showLoadingModal();
	    data.orderId = order.ordOrderId;
	    data["trackingNumbers"] = JSON.stringify(data.trackingNumbers);
	    _jquery2.default.ajax({
	      url: selfFulfillShipWith3rdPartyUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: data,
	      success: function success(data) {
	        if (data.response === "success") {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = pageReloadUrl;
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	      },
	      error: function error() {}
	    });
	  }
	
	  function onShipThirdPartyOpenBtnClick(e) {
	    e.preventDefault();
	    shipThirdPartyModal.showModal();
	  }
	
	  //validateOnAllSelectChanges();
	  // END: Real Code
	
	  /**
	  *Self Ful-fillment functionality end.
	  */
	  var pagableOrderHistory = new _pagableComponent2.default({
	    dataContainer: '.data-container-for-order-history',
	    pagingContainer: '.paging-container-for-order-history',
	    data: orderActions,
	    showData: function showData(row) {
	      return (0, _render2.default)(orderHistoryRowHtml, {
	        updatedOn: row.cmaActionDate,
	        updatedBy: row.cmaActionBy,
	        statusPill: statusPillRender(row.cmaAction),
	        description: row.cmaStatus
	      });
	    },
	    onFetch: function onFetch(page, pageSize) {
	      pagableOrderHistory.showLoadingOverlay();
	      setTimeout(function () {
	        (0, _filtersutil.doAjax)({ url: loadMoreOrderActionsUrl, success: loadMoreOrders, error: errorFun, data: prepareDataToSendController(order.ordOrderId, page, pageSize) });
	      }, _index2.default);
	    }
	  });
	
	  function loadMoreOrders(data) {
	    var orders = data.content;
	    pagableOrderHistory.setData(orders);
	    pagableOrderHistory.hideLoadingOverlay();
	  }
	
	  function errorFun(data) {
	    pagableOrderHistory.hideLoadingOverlay();
	  }
	
	  function prepareDataToSendController(orderId, page, pageSize) {
	    var data = {
	      page: page,
	      pageSize: pageSize,
	      orderId: orderId
	    };
	    return data;
	  }
	  pagableOrderHistory.init();
	
	  function statusPillRender(statusText) {
	    var newRender = void 0;
	    var statusPillClass = _filtersutil.pillStatusClasses[statusText] || _filtersutil.pillStatusClasses.default;
	    return newRender = (0, _render2.default)(statusPillBodyHtml, {
	      statusText: statusText,
	      statusPillClass: statusPillClass
	    });
	  }
	
	  editOrderBtn.on("click", function (e) {
	    e.preventDefault();
	    if (order.ordStatus == "Error") {
	      showEditOrderModalError();
	    }
	    if (order.ordStatus == "Backordered") {
	      showEditOrderModalBackordered();
	    }
	    if (order.ordStatus == "Held") {
	      if (order.ordChannelType != "Manual" && order.ordChannelType != "Manual (Bulk)" && order.ordChannelType != "API" && order.ordChannelType != "BigCommerce") {
	        showEditChannelHeldModal();
	      } else {
	        if (order.ordReleaseType == "Hold Indefinitely") {
	          showEditOrderManualHeldModal();
	        } else if (order.ordReleaseType == "Scheduled Release") {
	          showEditCustomHeldModal();
	        } else if (order.ordReleaseType == "Internal Order Grace Period" || order.ordReleaseType == "Channel Order Grace Period") {
	          showEditPortalHeldModal();
	        }
	      }
	    }
	  });
	
	  (0, _jquery2.default)('.edit-order-modal').on("click", function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var orderIdForEdit = order.ordOrderId;
	      location.href = editOrderUrl + "&" + portletNamespace + "orderIdForEdit=" + orderIdForEdit;
	    }
	  });
	
	  function showEditOrderModalError() {
	    editErrorModal.modal('show');
	  }
	
	  function showEditOrderModalBackordered() {
	    editBackOrderedModal.modal('show');
	  }
	
	  function showEditOrderManualHeldModal() {
	    editManualHoldModal.modal('show');
	  }
	
	  function showEditCustomHeldModal() {
	    editCustomHeldModal.modal('show');
	  }
	
	  function showEditChannelHeldModal() {
	    editChannelHeldModal.modal('show');
	  }
	
	  function showEditPortalHeldModal() {
	    editPortalHeldModal.modal('show');
	  }
	});

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _index = __webpack_require__(96);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sharedModalHtml = __webpack_require__(11);
	var documentationModalBodyHtml = __webpack_require__(1376);
	var fileNameRowHtml = __webpack_require__(1375);
	
	(0, _run2.default)("#order-detail-page", function () {
	    var order = (0, _jquery2.default)("#order-detail-page").data("order");
	    var submitdocumentationURL = (0, _jquery2.default)("#order-detail-page").data("submit-document-url");
	    var documentationFiles = (0, _jquery2.default)("#order-detail-page").data('document-files');
	    var shippingDocumentUploadedFiles = (0, _jquery2.default)("#order-detail-page").data('shipping-document-uploaded');
	    var fixDocumentBtn = "#order-detail-fix-doc-btn";
	    var orderSubmitUrl = (0, _jquery2.default)("#order-detail-page").data("order-submit-url");;
	    var pageReloadUrl = (0, _jquery2.default)("#order-detail-page").data("order-detail-page-reload-url");
	    var fetchUploadedFilesURL = (0, _jquery2.default)("#order-detail-page").data("fetch-uploaded-files-url");
	    var fetchUploadedFiles = [];
	
	    var submitModalFlow = new _SubmitModalFlow2.default();
	    submitModalFlow.init();
	    var documentationModal = (0, _jquery2.default)((0, _render2.default)(sharedModalHtml, {
	        title: 'International Documentation Error',
	        footerBtns: '<a href="#" class="base-btn purple-btn confirm-btn">Proceed</a><a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> ',
	        body: (0, _render2.default)(documentationModalBodyHtml, {
	            documentationFiles: renderDocumentFileNameValues()
	        }),
	        topCloseBtn: true,
	        autoHideTop: true,
	        modalDialogClass: "q-modal-dialog-1000"
	    }));
	    (0, _jquery2.default)('body').append(documentationModal);
	
	    var confirmationTradeToolsModal = (0, _jquery2.default)((0, _render2.default)(sharedModalHtml, {
	        title: 'No Document(s) Uploaded',
	        footerBtns: '<a href="#" class="base-btn purple-btn submit-btn">Next</a><a href="#" class="base-btn v2-btn purple-btn modal-auto-hide cancel-tradetool-btn">Cancel</a> ',
	        body: '<div class="q-pad-all-xl">Document was not uploaded. Press ‘Cancel’ to go back and upload or press ‘Next’ to skip and proceed.</div>',
	        topCloseBtn: true,
	        autoHideTop: true,
	        modalDialogClass: "q-modal-dialog-500"
	    }));
	    (0, _jquery2.default)('body').append(confirmationTradeToolsModal);
	
	    var documentationFileUploader = new _index2.default({
	        target: (0, _jquery2.default)(".documnet-uploader"),
	        multiple: true,
	        maxFileSize: 5,
	        fileFormat: [".XLS", ".XLSX", ".DOC", ".DOCX", ".PDF", ".TIFF", ".TIF", ".JPG", ".JPEG", ".GIF", ".TXT", ".CSV"],
	        accept: [".XLS", ".XLSX", ".DOC", ".DOCX", ".PDF", ".TIFF", ".TIF", ".JPG", ".JPEG", ".GIF", ".TXT", ".CSV"],
	        afterValidSelection: function afterValidSelection() {
	            (0, _jquery2.default)(".select-files-btn").removeClass("disabled");
	            renderSelectedFilesInRow(shippingDocumentUploadedFiles);
	            validateFileLength();
	        },
	        afterInvalidSelection: function afterInvalidSelection() {
	            renderSelectedFilesInRow(shippingDocumentUploadedFiles);
	        }
	    });
	
	    documentationFileUploader.init();
	    function renderSelectedFilesInRow(items) {
	        var fileListHtml = items.map(function (item, index) {
	            return (0, _render2.default)(fileNameRowHtml, {
	                fileName: item.fileName,
	                cisId: item.documentId
	            });
	        });
	        (0, _jquery2.default)('.file-name-render-area').append(fileListHtml.join(""));
	    }
	
	    (0, _jquery2.default)(fixDocumentBtn).click(function () {
	        buildFixBtnPopUp(documentationFileUploader, fetchUploadedFiles);
	        showDocumentModal();
	    });
	
	    function showDocumentModal() {
	        documentationModal.modal('show');
	    }
	
	    function hideDocumentModal() {
	        documentationModal.modal('hide');
	    }
	
	    function renderDocumentFileNameValues() {
	        var returnTypeList = "";
	        returnTypeList = documentationFiles.map(function (el) {
	            return (0, _render2.default)("<li>{%- key %}</li>", {
	                key: el.fileName
	            });
	        });
	        return returnTypeList.join('');
	    }
	
	    function validateFileLength() {
	        (0, _jquery2.default)(".erroruploadMsg").hide();
	        var files = documentationFileUploader.getFiles();
	        if (files != null && files.length >= 11) {
	            (0, _jquery2.default)(".select-files-btn").addClass("disabled");
	            (0, _jquery2.default)(".upload-file").addClass("disabled");
	            (0, _jquery2.default)(".maxFileError").show();
	        } else {
	            (0, _jquery2.default)(".select-files-btn").removeClass("disabled");
	            (0, _jquery2.default)(".upload-file").removeClass("disabled");
	            (0, _jquery2.default)(".maxFileError").hide();
	        }
	    }
	
	    (0, _jquery2.default)('body').find(".mfu-file-input").on('change', validateFileLength);
	    (0, _jquery2.default)('body').find(".file-remove-btn").on('click', validateFileLength);
	
	    (0, _jquery2.default)('body').find('.file-remove-btn-edit').on('click', function (e) {
	        e.preventDefault();
	        var cisIdRemoved = (0, _jquery2.default)(this).children('#wo-cis-id').val();
	        console.log(cisIdRemoved);
	        for (var i = 0; i < editFileList.length; i++) {
	            if (cisIdRemoved == editFileList[i]) editFileList.splice(i, 1);
	        }
	        for (var _i = 0; _i < woFiles.length; _i++) {
	            if (cisIdRemoved == woFiles[_i].cisId) woFiles.splice(_i, 1);
	        }
	        (0, _jquery2.default)(this).closest(".file-name-row").remove();
	        validateFileLength();
	    });
	
	    (0, _jquery2.default)(".upload-file").on("click", function (e) {
	        var formData = new FormData();
	        var uploaderFiles = documentationFileUploader.getFiles();
	        var itnNumVal = (0, _jquery2.default)("#itnNumberInput").val();
	        formData.append("ITNValue", itnNumVal);
	        if (typeof uploaderFiles != "undefined") {
	            uploaderFiles.forEach(function (file) {
	                formData.append("files[]", file);
	            });
	        }
	        (0, _jquery2.default)(".document-validation-loading-outer").show();
	        _jquery2.default.ajax({
	            data: formData,
	            url: submitdocumentationURL,
	            dataType: "JSON",
	            type: 'POST',
	            processData: false, // tell jQuery not to process the data
	            contentType: false, // tell jQuery not to set contentType
	            success: function success(data) {
	                if (data.response == "success") {
	                    buildFixBtnPopUp(documentationFileUploader, fetchUploadedFiles);
	                    (0, _jquery2.default)(".document-validation-loading-outer").hide();
	                    (0, _jquery2.default)(".successUploadMsg").show();
	                    (0, _jquery2.default)(".select-files-btn").addClass("disabled");
	                    (0, _jquery2.default)("#wo-cis-id").addClass("disabled");
	                    (0, _jquery2.default)(".file-remove-btn").addClass("disabled");
	                    (0, _jquery2.default)(".upload-file").addClass("disabled");
	                } else {
	                    (0, _jquery2.default)(".document-validation-loading-outer").hide();
	                    (0, _jquery2.default)(".erroruploadMsg").show();
	                }
	            },
	            error: function error(data) {
	                (0, _jquery2.default)(".document-validation-loading-outer").hide();
	                (0, _jquery2.default)(".erroruploadMsg").show();
	            }
	        });
	    });
	
	    (0, _jquery2.default)(".confirm-btn").on("click", function (e) {
	        hideDocumentModal();
	        if (!(0, _jquery2.default)(".upload-file").hasClass("disabled")) {
	            confirmationTradeToolsModal.modal('show');
	        } else {
	            confirmationTradeToolsModal.modal('hide');
	            submitModalFlow.showLoadingModal();
	            orderSubmit(orderSubmitUrl, order, submitModalFlow, pageReloadUrl);
	        }
	    });
	
	    (0, _jquery2.default)(".cancel-tradetool-btn").on("click", function (e) {
	        buildFixBtnPopUp(documentationFileUploader, fetchUploadedFiles);
	        showDocumentModal();
	    });
	
	    (0, _jquery2.default)(".submit-btn").on("click", function (e) {
	        hideDocumentModal();
	        confirmationTradeToolsModal.modal('hide');
	        submitModalFlow.showLoadingModal();
	        orderSubmit(orderSubmitUrl, order, submitModalFlow, pageReloadUrl);
	    });
	
	    function buildFixBtnPopUp(documentationFileUploader, fetchUploadedFile) {
	        (0, _jquery2.default)(".erroruploadMsg").hide();
	        (0, _jquery2.default)("#itnNumberInput").val("");
	        (0, _jquery2.default)(".maxFileError").hide();
	        (0, _jquery2.default)(".successUploadMsg").hide();
	        (0, _jquery2.default)(".document-validation-loading-outer").hide();
	        var uploadedFiles = documentationFileUploader.getFiles();
	        (0, _jquery2.default)('.file-name-render-area').empty();
	        _jquery2.default.ajax({
	            data: {
	                orderId: order.ordOrderId
	            },
	            url: fetchUploadedFilesURL,
	            dataType: "JSON",
	            type: 'POST',
	            processData: false, // tell jQuery not to process the data
	            contentType: false, // tell jQuery not to set contentType
	            success: function success(data) {
	                if (data != "") {
	                    fetchUploadedFiles = data;
	                    if (fetchUploadedFiles.length > 0) {
	                        (0, _jquery2.default)(".select-files-btn").addClass("disabled");
	                        (0, _jquery2.default)("#wo-cis-id").addClass("disabled");
	                        (0, _jquery2.default)(".upload-file").addClass("disabled");
	                        (0, _jquery2.default)(".file-remove-btn-edit").addClass("disabled");
	                        renderSelectedFilesInRow(fetchUploadedFiles);
	                    } else {
	                        (0, _jquery2.default)(".upload-file").removeClass("disabled");
	                        (0, _jquery2.default)(".select-files-btn").removeClass("disabled");
	                        (0, _jquery2.default)("#wo-cis-id").addClass("disabled");
	                    }
	                }
	                showDocumentModal();
	            },
	            error: function error(data) {
	                showDocumentModal();
	            }
	        });
	    }
	
	    function orderSubmit(orderSubmitUrl, order, submitModalFlow, pageReloadUrl) {
	        _jquery2.default.ajax({
	            url: orderSubmitUrl,
	            type: 'POST',
	            dataType: 'JSON',
	            data: {
	                orderId: order.ordOrderId,
	                callType: "documentValidation"
	            },
	            success: function success(data) {
	                if (data.response == "success") {
	                    submitModalFlow.showSuccessModal();
	                    setTimeout(function () {
	                        location.href = pageReloadUrl;
	                    }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	                }
	            },
	            error: function error(data) {
	                hideDocumentModal();
	            }
	        });
	    }
	});

/***/ },
/* 718 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    title: "Release",
	    cls: "bulk-release-order",
	    icon: "paper-plane-o",
	    disabled: true
	  }],
	  "actions": [{
	    title: "Cancel",
	    cls: "cancel-order",
	    icon: "ban",
	    disabled: false
	  }, {
	    title: "Release",
	    cls: "release-order",
	    icon: "paper-plane-o",
	    disabled: false
	  }, {
	    title: "Edit",
	    cls: "edit-order",
	    icon: "pencil",
	    disabled: false
	  }]
	};

/***/ },
/* 719 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var orderLookupFieldDropdown = exports.orderLookupFieldDropdown = [{
		title: "FedEx Order ID",
		value: "fedExOrderId"
	}, {
		title: "Channel Order ID",
		value: "channelOrderId"
	}, {
		title: "Channel",
		value: "channel"
	}, {
		title: "Customer Name",
		value: "customerName"
	}, {
		title: "Tracking Number",
		value: "trackingNumber"
	}, {
		title: "State",
		value: "state"
	}, {
		title: "City",
		value: "city"
	}, {
		title: "Country",
		value: "country"
	}, {
		title: "Product Name (SKU)",
		value: "productName"
	}, {
		title: "RMA Number",
		value: "rmaId"
	}, {
		title: "Shipping Method",
		value: "shippingMethod"
	}];

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(714);
	
	__webpack_require__(216);
	
	__webpack_require__(145);
	
	__webpack_require__(716);
	
	__webpack_require__(717);
	
	__webpack_require__(711);
	
	__webpack_require__(721);

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _orderLookupFieldDropdown = __webpack_require__(719);
	
	var _actionOptions = __webpack_require__(718);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	var actionList = _actionOptions.actionOptions;
	var targetSelector = "#order-lookup";
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var statusPillRenderTemplate = __webpack_require__(187);
	var detailLinkHTML = __webpack_require__(84);
	var editErrorOrderModal = __webpack_require__(305);
	var editBackOrderedOrderModal = __webpack_require__(302);
	var editHeldOrderModal = __webpack_require__(306);
	var editCustomHeldOrderModal = __webpack_require__(304);
	var editChannelHeldOrderModal = __webpack_require__(303);
	var editPortalHeldOrderModal = __webpack_require__(307);
	var modalHtml = __webpack_require__(11);
	
	var statusPillBodyHtml = __webpack_require__(308);
	var datTimeFormat = "MM/DD/YYYY hh:mm A";
	
	(0, _run2.default)(targetSelector, function () {
		var dataTableComponentData = $(targetSelector).data("order-lookup-data");
		var viewOrderDetailURL = $(targetSelector).data("order-detail-url");
		var portletNamespace = $(targetSelector).data("portlet-namespace");
		var filterOrderUrl = $(targetSelector).data("order-filter-url");
		var orderFilterData = $(targetSelector).data("table-filter-data");
		var cancelOrderUrl = $(targetSelector).data("cancel-url");
		var releaseOrderUrl = $(targetSelector).data("release-url");
		var getCancelReasonUrl = $(targetSelector).data("cancel-reasons-list-url");
		var generateExportUrl = $(targetSelector).data("export-url");
		var shouldCheckCache = $(targetSelector).data("should-check-cache");
		var bulkCancelOrderUrl = $(targetSelector).data("bulk-cancel-url");
		var bulkReleaseOrderUrl = $(targetSelector).data("bulk-release-url");
		var savedViews = $(targetSelector).data("saved-views");
		var saveViewURL = $(targetSelector).data("save-view-url");
		var deleteViewURL = $(targetSelector).data("delete-view-url");
		var disableCancel = dataTableComponentData.disableCancel;
		var disableEdit = $(targetSelector).data("order-lookup-disable-edit");
		var editOrderUrl = $(targetSelector).data("edit-order-url");
		var filterFlag = $(targetSelector).data("filter-flag");
		var facId = $(targetSelector).data("fac-id");
	
		var exportModal = new _filtersutil.buildExport();
		var submitModalFlow = new _SubmitModalFlow2.default();
		submitModalFlow.init();
		var extraDetailForCacheFromServer = $(targetSelector).data("extra-detail-for-cache-from-server");
		var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
		var targetObject = "";
		var orderPortletEditPerm = $(targetSelector).data("order-portlet-edit-perm");
		var selectedRows = "";
	
		if (shouldCheckCache) {
			targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
		}
	
		function renderPill(data, type, row) {
			return data;
		}
	
		function createDetailLink(data, type, row) {
			var detailPageHTML = (0, _render2.default)(detailLinkHTML, {
				renderURL: viewOrderDetailURL,
				portletNamespace: portletNamespace,
				id: row.ordOrderId,
				idName: "orderId",
				displayVal: row.ordOrderId
			});
			return detailPageHTML;
		}
	
		function createOrderTypeText(data, type, row) {
			if ((0, _general.isPresent)(data)) {
				if (data == "B2C") {
					return "B2C-Business to customer";
				} else if (data == "B2B") {
					return "B2B-Business to business";
				} else if (data == "TRF") {
					return "TRF-Transfer Order";
				} else if (row.ordOrtName != "") {
					return data + "-" + row.ordOrtName;
				}
			}
			return "";
		}
	
		function formateDate(createdDate, type, data) {
			if (createdDate != null && createdDate != "") {
				var date = new Date(createdDate); //createdDate is long time format
				var month = date.getMonth() + 1;
				var today = new Date();
				var oneDay = 24 * 60 * 60 * 1000;
				today.setHours(0, 0, 0, 0);
				date.setHours(0, 0, 0, 0);
				var diffDays = Math.floor(Math.abs((today.getTime() - date.getTime()) / oneDay));
				var friendlyText = "";
				var datePillHTML = "";
				if (diffDays < 100) {
					friendlyText = diffDays.toString() + ' Days Ago';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				}
				if (diffDays == 0) {
					friendlyText = 'Today';
				} else if (diffDays == 1) {
					friendlyText = 'Yesterday';
				}
				return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
			} else {
				return "";
			}
		}
	
		var orderLookup = new _index2.default({
			// REQUIRED - Set a target element
			target: $("#lookup-order-wrapper"),
			// Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
			minWidthClass: "q-min-width-sm-til-md",
			// REQUIRED - Set which data should be visible for mobile
			mobileColumns: [{
				data: "ordOrderId",
				title: "FedEx Order ID",
				render: createDetailLink
			}, {
				data: "ordShipToName",
				title: "Customer Name",
				orderable: false
			}, {
				data: "ordChannelType",
				title: "Channel"
			}, {
				data: "ordParOrderNumber",
				title: "Channel Order ID"
			}, {
				data: "ordStatus",
				title: "Status",
				render: _filtersutil.statusPillRender
			}, {
				data: "ordShipmentTrkStatus",
				title: "Shipping Status",
				render: _filtersutil.statusPillRender
			}],
			// tableFilters: {
			//    data: orderFilterData,
			//  },
	
			// REQUIRED: search input info
			tableSearchInput: {
				// Not required
				// placeholder: 'Custom Search Text'
				value: targetObject != "" ? targetObject.value[0] : ""
	
			},
			// REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
			tableSearchDropdown: {
				selected: targetObject == "" ? "" : targetObject.key,
				columns: _orderLookupFieldDropdown.orderLookupFieldDropdown
			},
			// OPTIONAL: Set Saved View Array
			savedViews: savedViews,
			bulkSelect: true,
			// REQUIRED - Data Table specific settings
			dataTable: {
				// use same settings you would if you were just calling a dataTable normally
				data: dataTableComponentData.content,
				// Not required, just to show you can
				columnDefs: [{ className: "custom-class", targets: [1] }],
				// Not required, just to show you can
				order: [[7, 'asc']],
				columns: [{
					data: "ordStatus",
					render: renderActionWrap,
					orderable: false,
					class: 'dtc-action-column'
				}, {
					data: "ordOrderId",
					title: "FedEx Order ID",
					render: createDetailLink,
					class: 'dtc-min-width-md'
				}, {
					data: "ordShipToName",
					title: "Customer Name",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordChannelType",
					title: "Channel",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordOrderType",
					title: "Order Type",
					render: createOrderTypeText,
					class: 'dtc-min-width-sm'
				}, {
					data: "ordParOrderNumber",
					title: "Channel Order ID",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordStatus",
					title: "Status",
					render: _filtersutil.statusPillRender,
					class: 'dtc-min-width-sm'
				}, {
					data: "ordCreatedDate",
					title: "Date Received",
					render: formateDate,
					class: 'dtc-min-width-md'
				}, {
					data: "ordShipToEmail",
					title: "Customer Email",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordShipToPhone",
					title: "Customer Phone",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordShipToAddress1",
					title: "Address1",
					class: 'dtc-min-width-md'
				}, {
					data: "ordShipToAddress2",
					title: "Address2",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordShipToCity",
					title: "City",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordShipToState",
					title: "State/Province/Region",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordShipToZip",
					title: "Postal Code",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordShippingType",
					title: "Shipping Type",
					render: getShippingType,
					class: 'dtc-min-width-sm'
				}, {
					data: "orsShipDate",
					title: "Date Shipped",
					class: 'dtc-min-width-md'
				}, {
					data: "ordShippingMethod",
					title: "Shipping Method",
					class: 'dtc-min-width-sm'
				}, {
					data: "ordShipmentTrkStatus",
					title: "Shipping Status",
					render: _filtersutil.statusPillRender,
					class: 'dtc-min-width-sm'
				}]
			},
			//  tableColumnModal: {
			//	data: orderLookupColumnsPopup
			//},
			paginationData: dataTableComponentData.page,
			filterModal: {
				// REQUIRED: Sets title of modal
				title: "Filter Orders",
				// REQUIRED: Sets unique part of subtitle string.
				tableType: "orders"
			},
			onBulkSelectChange: function onBulkSelectChange() {
				selectedRows = orderLookup.getBulkSelectedData();
				$("th.dtc-action-column").html(renderActionHeaderWrap());
				if (selectedRows.length >= 2) {
					$(".action-header-btn .base-btn").removeClass('disabled');
				} else {
					$(".action-header-btn .base-btn").addClass('disabled');
				};
			},
			onFetch: function onFetch() {
				var currentData = orderLookup.generateData();
				orderLookup.showLoadingOverlay();
				//Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
				if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterOrderUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isNew)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isEdit)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isDeleteView)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				}
			}
		});
	
		function filterSuccessFun(data) {
			var orders = data.content;
			var page = data.page;
			orderLookup.setNewData(orders);
			orderLookup.setPaginationData(page);
			(0, _filtersutil.pushFilterSessionCacheState)();
			orderLookup.hideLoadingOverlay();
			setExportData(orderLookup.generateData());
		}
	
		function savedViewSuccess(data) {
			var orders = data.lookupOrderJSON.content;
			var page = data.lookupOrderJSON.page;
			orderLookup.setNewData(orders);
			orderLookup.setPaginationData(page);
			orderLookup.setNewSavedViewData(data.savedView, "newSavedView");
			(0, _filtersutil.pushFilterSessionCacheState)();
			orderLookup.hideLoadingOverlay();
			setExportData(orderLookup.generateData());
		}
	
		function getShippingType(data) {
			if (data === "PCL") {
				return "Case";
			} else if (data === "LTL") {
				return "Freight";
			} else {
				return "-";
			}
		}
	
		function savedEditViewSuccess(data) {
			var orders = data.lookupOrderJSON.content;
			var page = data.lookupOrderJSON.page;
			orderLookup.setNewData(orders);
			orderLookup.setPaginationData(page);
			orderLookup.setNewSavedViewData(data.savedView, data.savedView.target);
			(0, _filtersutil.pushFilterSessionCacheState)();
			orderLookup.hideLoadingOverlay();
			setExportData(orderLookup.generateData());
		}
	
		function delteViewScussFun(data) {
			var orders = data.lookupOrderJSON.content;
			var page = data.lookupOrderJSON.page;
			orderLookup.removeSavedView(data.target);
			orderLookup.setNewData(orders);
			orderLookup.setPaginationData(page);
			orderLookup.hideLoadingOverlay();
			setExportData(orderLookup.generateData());
		}
	
		function errorFun(data) {
			orderLookup.hideLoadingOverlay();
		}
	
		orderLookup.init();
		//const ordersDataTableObj = $("#lookup-order-wrapper .data-table-component").dataTable();
		function renderActionWrap(data, type, row, meta) {
			var newRender = void 0;
			var statusTarget = actionList["actions"];
			newRender = (0, _render2.default)(actionCellDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row),
				index: meta.row
			});
			return newRender;
		};
	
		function renderActionHeaderWrap() {
			var statusTarget = actionList['all'];
			var newRender = void 0;
			var data = "";
			var row = "";
			newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row)
			});
			return newRender;
		};
	
		function renderActionCellList(list, data, row) {
			var renderedList = void 0;
			renderedList = _(list).map(function (item) {
				return (0, _render2.default)(actionCellDropdownItemTemplate, {
					icon: item.icon,
					title: item.title,
					cls: item.cls,
					disabled: checkDisableForGivenAction(data, row, item.title)
				});
			});
			return renderedList.join('');
		};
	
		function checkDisableForGivenAction(data, row, actionName) {
			if (isRowLevelActionCheck(data)) {
				return callBusinessLogicToDisableAction(data, row, actionName);
			} else {
				var isTrue = false;
				_(selectedRows).map(function (item) {
					if (callBusinessLogicToDisableAction(item.data.ordStatus, item.data, actionName)) {
						if (!isTrue) {
							isTrue = true;
						}
					}
				});
				return isTrue;
			}
		};
	
		function isRowLevelActionCheck(data) {
			return (0, _general.isPresent)(data);
		}
	
		function callBusinessLogicToDisableAction(data, row, actionName) {
			if (orderPortletEditPerm && (0, _general.isPresent)(data)) {
				if (actionName == "Cancel") {
					if (row.partner.parId == disableCancel || !(data === "Error" || data === "Held" || data === "Backordered")) {
						return true;
					} else {
						return false;
					}
				} else if (actionName == "Release") {
					if (data === "Held" || data === "Hold Pending") {
						return false;
					} else {
						return true;
					}
				} else if (actionName == "Edit") {
					if (isRowLevelActionCheck(row) && disableEditingOfOrders(data, row)) {
						return true;
					} else {
						return false;
					}
				}
			}
		}
	
		function disableEditingOfOrders(data, row) {
			var shouldDisableEdit = false;
			_.each(disableEdit, function (domain) {
				if (domain.cdmValue === row.partner.parId || domain.cdmValue === row.ordOrderType || domain.cdmValue === row.ordShippingMethod) {
					shouldDisableEdit = true;
				}
			});
			if (!shouldDisableEdit) {
				if (!(data === "Error" || data === "Held" || data === "Backordered")) {
					shouldDisableEdit = true;
				}
			}
			return shouldDisableEdit;
		}
		// Cancel order button click at row level.
		$('body').on('click', '.cancel-order', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
				var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				// Get the row based on the parent...
				var parent = $(".dropdown-parent-" + pIndex).parents('tr');
				// Get the row data
				var row = $(".data-table-component").dataTable().api().row(parent);
				submitModalFlow.showLoadingModal();
				$.ajax({
					url: getCancelReasonUrl,
					type: 'POST',
					dataType: 'JSON',
					data: {
						orderId: row.data().ordOrderId
					},
					success: function success(data) {
						submitModalFlow.hideAllModals();
						if (data.response == "success") {
							$('#modalCancelOrder').attr('disabled', true);
							$('#orderCancelReason').val('0');
							$("#cancelModal").appendTo("body").data('row', row).modal("show");
							emptyCurrentResonList("orderCancelReason");
							fillReasonList(data.reasonList, "orderCancelReason");
						}
					},
					error: function error(data) {
						submitModalFlow.hideAllModals();
					}
				});
			}
		});
		// Release order button click at row level
		$('body').on('click', '.release-order', function (e) {
			e.preventDefault();
			// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
			var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
			// Get the row based on the parent...
			var parent = $(".dropdown-parent-" + pIndex).parents('tr');
			// Get the row data
			var row = $(".data-table-component").dataTable().api().row(parent);
	
			if (shallAllowClick(this)) {
				$("#releaseModal").appendTo("body").data('row', row).modal("show");
			}
		});
		// Release orders button click - Header level.
		$('body').on('click', '.bulk-release-order', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				$("#bulkReleaseModal").modal("show");
			}
		});
	
		function shallAllowClick(currentObj) {
			return !$(currentObj).hasClass("disabled");
		}
	
		// Cancel orders button click at Header level - This functionality is needs to be taken out for time being but will use below code in future release - this is not being called from anywhere as of now.
		$('body').on('click', '.bulk-cancel-order', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
				var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				// Get the row based on the parent...
				var parent = $(".dropdown-parent-" + pIndex).parents('tr');
				// Get the row data
				var row = $(".data-table-component").dataTable().api().row(parent);
				$.ajax({
					url: getCancelReasonUrl,
					type: 'POST',
					dataType: 'JSON',
					data: {
						//orderId: row.data().ordOrderId,
					},
					success: function success(data) {
						submitModalFlow.hideAllModals();
						if (data.response == "success") {
							$('#modalBulkCancelOrder').attr('disabled', true);
							$("#orderBulkCancelReason").val('0');
							$("#bulkCancelModal").appendTo("body").data('row', row).modal("show");
							emptyCurrentResonList("orderBulkCancelReason");
							fillReasonList(data.reasonList, "orderBulkCancelReason");
						}
					},
					error: function error(data) {
						submitModalFlow.hideAllModals();
					}
				});
			}
		});
	
		var emptyCurrentResonList = function emptyCurrentResonList(element) {
			var options = $("#" + element).find("option");
			$.each(options, function (key, item) {
				if (key != 0) {
					item.remove();
				}
			});
		};
	
		var fillReasonList = function fillReasonList(data, element) {
			$.each(data, function (key, item) {
				var option = $('<option /\>');
				option.attr('value', key).text(item);
				$("#" + element).append(option);
			});
		};
	
		$(".orderCancelReason").change(function () {
			$('#modalCancelOrder').attr('disabled', false);
			$('#modalBulkCancelOrder').attr('disabled', false);
		});
	
		$('#modalCancelOrder').click(function () {
			var row = $('#cancelModal').data('row');
			var reason = $('.orderCancelReason :selected').text();
			var value = $('.orderCancelReason :selected').val();
			submitModalFlow.showLoadingModal();
			cancelOrder(row, reason, value);
		});
	
		$('#modalBulkCancelOrder').click(function () {
			var reason = $('.orderCancelReason :selected').text();
			var value = $('.orderCancelReason :selected').val();
			submitModalFlow.showLoadingModal();
			bulkCancelOrder(reason, value);
		});
	
		function bulkCancelOrder(reason, value) {
			$.ajax({
				url: cancelOrderUrl,
				type: 'POST',
				dataType: 'JSON',
				data: {
					reason: reason,
					value: value
				},
				success: function success(data) {
					if (data.response == "success") {
						submitModalFlow.showSuccessModal();
						_(selectedRows).map(function (item) {
							var currentRow = $(".data-table-component").dataTable().api().row(item.rowIndex);
							var d = currentRow.data();
							d.ordStatus = $.trim(data.ordStatusCd);
							currentRow.data(d).draw();
						});
						orderLookup.uncheckAllSelected();
						setTimeout(function () {
							location.reload();
						}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
					}
				},
				error: function error(data) {
					submitModalFlow.hideAllModals();
				}
			});
		}
	
		function cancelOrder(row, reason, value) {
			$.ajax({
				url: cancelOrderUrl,
				type: 'POST',
				dataType: 'JSON',
				data: {
					orderId: row.data().ordOrderId,
					reason: reason,
					value: value
				},
				success: function success(data) {
					if (data.response == "success") {
						var d = row.data();
						d.ordStatus = $.trim(data.ordStatusCd);
						row.data(d).draw();
						submitModalFlow.showSuccessModal();
						setTimeout(function () {
							submitModalFlow.hideAllModals();
						}, _constants.SUCCESS_MODAL_TIMEOUT);
					}
				},
				error: function error(data) {
					submitModalFlow.hideAllModals();
				}
			});
		}
	
		$('#bulkReleaseModalSubmitBtn').click(function () {
			submitModalFlow.showLoadingModal();
			bulkRelease();
		});
	
		function bulkRelease() {
			$.ajax({
				url: bulkReleaseOrderUrl,
				type: 'POST',
				dataType: 'JSON',
				data: {
					orderId: getAllSelectedOrderIds()
				},
				success: function success(data) {
					if (data.response == "success") {
						_(selectedRows).map(function (item) {
							var currentRow = $(".data-table-component").dataTable().api().row(item.rowIndex);
							var d = currentRow.data();
							d.ordStatus = $.trim(data.ordStatusCd);
							currentRow.data(d).draw();
						});
						orderLookup.uncheckAllSelected();
						setTimeout(function () {
							submitModalFlow.hideAllModals();
						}, _constants.SUCCESS_MODAL_TIMEOUT);
					}
				},
				error: function error(data) {
					submitModalFlow.hideAllModals();
				}
			});
		};
	
		function getAllSelectedOrderIds() {
			var OrderIds = new Array();
			_(selectedRows).map(function (item) {
				OrderIds.push(item.data.ordOrderId);
			});
			return JSON.stringify(OrderIds);
		}
	
		$('#releaseModalSubmitBtn').click(function () {
			var row = $('#releaseModal').data('row');
			submitModalFlow.showLoadingModal();
			release(row);
		});
	
		function release(row) {
			$.ajax({
				url: releaseOrderUrl,
				type: 'POST',
				dataType: 'JSON',
				data: {
					orderId: row.data().ordOrderId
				},
				success: function success(data) {
					if (data.response == "success") {
						var d = row.data();
						d.ordStatus = $.trim(data.ordStatusCd);
						row.data(d).draw();
						submitModalFlow.showSuccessModal();
						setTimeout(function () {
							submitModalFlow.hideAllModals();
						}, _constants.SUCCESS_MODAL_TIMEOUT);
					}
				},
				error: function error(data) {
					submitModalFlow.hideAllModals();
				}
			});
		};
	
		//    $("#exportData").click(function() {
		// 	var totRowCount = $('#totalRows').val();
		// 	$('#modalExportData').attr('disabled', true);
		// 	$('#dataFileType').val('0');
		// 	$('#row-count').html(" " + totRowCount + " ");
		// 	$("#exportModal").appendTo("body").modal("show");
		// });
	
	
		// $('#modalExportData').click(function() {
		// 	var fileType = $('#dataFileType :selected').val();
		// 	exportToFile(fileType);
		// 	$("#exportModal").modal("hide");
		// });
	
	
		// $('#dataFileType').change(function() {
		// 	$('#modalExportData').attr('disabled', false);
		// });
	
		// var exportToFile = function(fileType) {
		// 	let currentData = orderLookup.generateData();
		// 	var startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'startDate');
		// 	var endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'endDate');
		// 	var fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'fixedRange');
		// 	var revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"])
		// 	var orderBy =  currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"]
		// 	var searchCriteria =   _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);
		// 	var url = generateExportUrl+"&endDate="+endDate+"&startDate="+startDate+"&fixedRange="+fixedRangeDate+"&page=0"+"&size=1000"+"&orderBy="+orderBy+"&orderByType="+currentData["sortType"]+"&searchCriteria="+searchCriteria+"&fileType="+fileType;
		// 	window.open(url);
		// };
	
		// Export component integration.
		function initExport() {
			var exportObj = {
				title: $(targetSelector).data("export-popup-title"),
				exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
				exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
				exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
			};
			exportModal.init(exportObj);
			exportModal.bindExportEvent();
		}
	
		function setExportData(currentData) {
			exportModal.buildExportBasicURL(generateExportUrl, currentData);
			exportModal.setExportCount(currentData.totalElements);
		}
		initExport();
		setExportData(orderLookup.generateData());
		// Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information;
		(0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
		$("th.dtc-action-column").html(renderActionHeaderWrap());
	
		var editErrorModal = $((0, _render2.default)(modalHtml, {
			title: "Edit Order",
			leftAlignTitle: true,
			body: renderErrorModalPill(),
			topCloseBtn: true,
			autoHideTop: true,
			footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
		}));
	
		var editBackOrderedModal = $((0, _render2.default)(modalHtml, {
			title: "Edit Order",
			leftAlignTitle: true,
			body: renderBackOrderedModal(),
			topCloseBtn: true,
			autoHideTop: true,
			footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
		}));
	
		var editManualHoldModal = $((0, _render2.default)(modalHtml, {
			title: "Edit Order",
			leftAlignTitle: true,
			body: renderOrderHeldModal(),
			topCloseBtn: true,
			autoHideTop: true,
			footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
		}));
	
		var editCustomHeldModal = $((0, _render2.default)(modalHtml, {
			title: "Edit Order",
			leftAlignTitle: true,
			body: renderCustomHeldModal(),
			topCloseBtn: true,
			autoHideTop: true,
			footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
		}));
	
		var editChannelHeldModal = $((0, _render2.default)(modalHtml, {
			title: "Edit Order",
			leftAlignTitle: true,
			body: renderChannelHeldModal(),
			topCloseBtn: true,
			autoHideTop: true,
			footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
		}));
	
		var editPortalHeldModal = $((0, _render2.default)(modalHtml, {
			title: "Edit Order",
			leftAlignTitle: true,
			body: renderPortalHeldModal(),
			topCloseBtn: true,
			autoHideTop: true,
			footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a><a href="#" class="base-btn purple-btn edit-order-modal"> Edit Order </a>'
		}));
	
		function renderPortalHeldModal() {
			return (0, _render2.default)(editPortalHeldOrderModal, {
				statusPill: renderPillForModal("Held")
			});
		}
	
		function renderChannelHeldModal() {
			return (0, _render2.default)(editChannelHeldOrderModal, {
				statusPill: renderPillForModal("Held")
			});
		}
	
		function renderCustomHeldModal() {
			return (0, _render2.default)(editCustomHeldOrderModal, {
				statusPill: renderPillForModal("Held")
			});
		}
	
		function renderOrderHeldModal() {
			return (0, _render2.default)(editHeldOrderModal, {
				statusPill: renderPillForModal("Held")
			});
		}
	
		function renderBackOrderedModal() {
			return (0, _render2.default)(editBackOrderedOrderModal, {
				statusPill: renderPillForModal("Backordered")
			});
		}
	
		function renderErrorModalPill() {
			return (0, _render2.default)(editErrorOrderModal, {
				statusPill: renderPillForModal("Error")
			});
		}
	
		$('body').append(editErrorModal, editBackOrderedModal, editCustomHeldModal, editPortalHeldModal, editChannelHeldModal, editManualHoldModal);
	
		function renderPillForModal(status) {
			var newRender = void 0;
			var statusPillClass = _filtersutil.pillStatusClasses[status] || _filtersutil.pillStatusClasses.default;
			var statusText = "Order " + status;
			return newRender = (0, _render2.default)(statusPillBodyHtml, {
				statusText: statusText,
				statusPillClass: statusPillClass
			});
		}
	
		var timeinterval = void 0;
		function populateGraceperiod(orderCreatedDate, gracePeriod) {
			var dateToUseForScheduledReleaseCalculation = orderCreatedDate;
			var scheduledReleaseDate = moment(dateToUseForScheduledReleaseCalculation, datTimeFormat).add(gracePeriod, 'm');
			var t = scheduledReleaseDate - new Date();
			if (t > 0) {
				if (timeinterval) {
					clearInterval(timeinterval);
				}
				timeinterval = setInterval(function () {
					var timeObj = getTimeRemaining(scheduledReleaseDate);
					if (timeObj.total > 0) {
						var countDownTime = "";
						if (timeObj.days > 0) {
							countDownTime = _.escape(formatTime(timeObj.days)) + ' Days ' + _.escape(formatTime(timeObj.hours)) + ' : ' + _.escape(formatTime(timeObj.minutes)) + ' : ' + _.escape(formatTime(timeObj.seconds));
						} else {
							countDownTime = _.escape(formatTime(timeObj.hours)) + ' : ' + _.escape(formatTime(timeObj.minutes)) + ' : ' + _.escape(formatTime(timeObj.seconds));
						}
						$(".countdown-time-modal").html(countDownTime);
					} else {
						clearInterval(timeinterval);
					}
				}, 1000);
			}
		}
	
		function getTimeRemaining(scheduledReleaseDate) {
			var today = (0, _general.getESTDate)(new Date());
			var t = scheduledReleaseDate - today;
			var seconds = Math.floor(t / 1000 % 60);
			var minutes = Math.floor(t / 1000 / 60 % 60);
			var hours = Math.floor(t / (1000 * 60 * 60) % 24);
			var days = Math.floor(t / (1000 * 60 * 60 * 24));
			return {
				'total': t,
				'days': days,
				'hours': hours,
				'minutes': minutes,
				'seconds': seconds
			};
		}
	
		function formatTime(i) {
			if (i < 10) {
				i = "0" + i;
			}
			return i;
		}
	
		var orderIdForEdit = void 0;
	
		$('body').on('click', '.edit-order-modal', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				location.href = editOrderUrl + '&' + portletNamespace + 'orderIdForEdit=' + orderIdForEdit;
			}
		});
	
		$('body').on('click', '.edit-order', function (e) {
			e.preventDefault();
			// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
			var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
			// Get the row based on the parent...
			var parent = $(".dropdown-parent-" + pIndex).parents('tr');
			// Get the row data
			var row = $(".data-table-component").dataTable().api().row(parent);
			orderIdForEdit = row.data().ordOrderId;
			if (row.data().ordStatus == "Error") {
				showEditOrderModalError();
			}
			if (row.data().ordStatus == "Backordered") {
				showEditOrderModalBackordered();
			}
			if (row.data().ordStatus == "Held") {
				populateGraceperiod(row.data().ordCreatedDate, row.data().ordGracePeriod);
				if (row.data().ordChannelType != "Manual" && row.data().ordChannelType != "Manual (Bulk)" && row.data().ordChannelType != "API" && row.data().ordChannelType != "BigCommerce") {
					showEditChannelHeldModal();
				} else {
					if (row.data().ordReleaseType == "Hold Indefinitely") {
						showEditOrderManualHeldModal();
					} else if (row.data().ordReleaseType == "Scheduled Release") {
						showEditCustomHeldModal();
					} else if (row.data().ordReleaseType == "Internal Order Grace Period" || row.data().ordReleaseType == "Channel Order Grace Period") {
						showEditPortalHeldModal();
					}
				}
			}
		});
	
		function showEditOrderModalError() {
			editErrorModal.modal('show');
		}
	
		function showEditOrderModalBackordered() {
			editBackOrderedModal.modal('show');
		}
	
		function showEditOrderManualHeldModal() {
			editManualHoldModal.modal('show');
		}
	
		function showEditCustomHeldModal() {
			editCustomHeldModal.modal('show');
		}
	
		function showEditChannelHeldModal() {
			editChannelHeldModal.modal('show');
		}
	
		function showEditPortalHeldModal() {
			editPortalHeldModal.modal('show');
		}
	});

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#order-packaging-details", function () {
		var el = (0, _jquery2.default)("#order-packaging-details");
		attachFunctionality(el);
	});
	
	function attachFunctionality(el) {
		var pkgSlipPreviewBtn = el.find(".package-slip-preview");
		var cmlInvPreviewBtn = el.find(".commercial-invoice-preview");
		var imageLogoPreviewBtn = el.find(".imageLogoPreview");
		var rtlBrandImageLogo = el.find("#rtlBrandImageLogo");
		var rtlBrandLogoModalClose = el.find("#rtlBrandLogoModalClose");
	
		var pkgSlipPreviewUrl = el.data("package-slip-preview-url");
		var cmlInvPreviewUrl = el.data("commercial-invoice-preview-url");
		var imageLogoPreviewUrl = el.data("brand-logo-image-url");
	
		var orderPackagingDetails = el.data("order-package-details");
	
		(0, _jquery2.default)(pkgSlipPreviewBtn).on("click", function (e) {
			e.preventDefault();
			window.open(pkgSlipPreviewUrl, 'window1');
		});
	
		(0, _jquery2.default)(cmlInvPreviewBtn).on("click", function (e) {
			e.preventDefault();
			window.open(cmlInvPreviewUrl, 'window1');
		});
	
		(0, _jquery2.default)(rtlBrandImageLogo).on("click", function (e) {
			e.preventDefault();
			(0, _jquery2.default)("#rtlBrandLogoModal").modal("show");
		});
	
		(0, _jquery2.default)(rtlBrandLogoModalClose).on("click", function (e) {
			e.preventDefault();
			(0, _jquery2.default)("#rtlBrandLogoModal").modal("hide");
		});
	}

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(722);
	
	__webpack_require__(724);

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _jqueryValidationMethods = __webpack_require__(227);
	
	var _QuickFileUploader = __webpack_require__(85);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	
	// Live form from jsp
	(0, _run2.default)("#update-order-packaging", function () {
	  var el = $("#update-order-packaging");
	  attachFunctionality(el);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  EditChecker.bindNavigation();
	  EditChecker.bindChangeListener("#update-order-packaging");
	  EditChecker.bindCancelButton(".order-packaging-cancel");
	}
	
	function attachFunctionality(el) {
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  /*
	   * START: Packing Materials Section
	   *
	   *
	   */
	  var BG_CLASS_MAP = {
	    white: "q-tw-white",
	    grey: "q-tw-lightest-grey"
	  };
	
	  console.log('update-order-packaging is running...');
	  var updateOrderPackagingForm = el;
	  var logoUploaderEl = el.find(".logo-uploader");
	  var togglers = el.find(".b2b-b2c-togglers");
	  var docDetailForm = el.find(".document-detail-form");
	  var docMessage = el.find(".document-message");
	  var addressSelect = $("#companyAddressLocation");
	  var addressList = addressSelect.data('options');
	  var orderPackage = el.data("order-package");
	  var saveURL = el.data("save-url");
	  var detailPageURL = el.data("detail-url");
	
	  var packingTogglers = el.find(".packing-toggler");
	  var vasBoxArr = el.data("vas-box");
	  var vasTsArr = el.data("vas-ts");
	  var vasGiftWrapColorArr = el.data("vas-gift-wrap-color");
	  var vasGiftOptionsArr = el.data("vas-gift-options");
	  var vasRtlImage = el.data("rtl-brand-logo");
	
	  var rtllogoFileNameId = el.find("#rtlBrandLogoFile");
	  var rtllogoImageId = el.find("#rtllogoImage");
	  var rtlLogoFileNameTextInput = el.find(".qfu-file-text-input");
	
	  var boxTypeSelect = $("#boxTypeId");
	  var boxTypeSelectList = boxTypeSelect.data('options');
	
	  var tsPaperSelect = $("#tissuePaperId");
	  var tsPaperSelectList = tsPaperSelect.data('options');
	
	  var giftOptionsSelect = $("#giftOptionsId");
	  var giftOptionsSelectList = giftOptionsSelect.data('options');
	
	  var giftBagWrappingColorSelect = $("#giftBagWrappingColorId");
	  var giftBagWrappingColorSelectList = giftBagWrappingColorSelect.data('options');
	
	  var brandLogoOnBoxSelect = $("#brandLogoOnBoxId");
	  var brandLogoOnBoxSelectList = brandLogoOnBoxSelect.data('options');
	
	  rtllogoFileNameId.val(orderPackage.rtlBrandLogoFile || "");
	  rtllogoImageId.val(orderPackage.rtlBrandLogoIamge || "");
	  // set text input value here, and the quickFileUploader
	  // component will recognize this, and render with remove btn,
	  // even though a file has not been selected via edit on this page
	  rtlLogoFileNameTextInput.val(orderPackage.rtlBrandLogoFile || "");
	
	  (0, _QuickFileUploader.quickFileUploader)(logoUploaderEl);
	
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    },
	    rules: {
	      logoImg: {
	        maxFileSizeBytes: 200000000,
	        permittedFileTypes: ["image/png", "image/jpeg"],
	        required: function required(element) {
	          return !(0, _general.isPresent)(rtlLogoFileNameTextInput.val());
	        }
	      }
	
	    }
	  });
	
	  // This is a helper function that can be reused
	  // specifically for packing material related selects
	  function setGenericDataInOptionForPackingSelect(_ref) {
	    var option = _ref.option,
	        data = _ref.data;
	
	    option.data('note', data.opcCost);
	    if ((0, _general.rgxTest)(/Default/i, data.opcValue)) {
	      option.data('bg-well-color', "white");
	    } else {
	      option.data('bg-well-color', "grey");
	    }
	    return { option: option, data: data };
	  }
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: boxTypeSelect,
	    list: boxTypeSelectList,
	    valueDataKey: "opcValue",
	    textDataKey: "opcValue",
	    afterOptionCreate: setGenericDataInOptionForPackingSelect,
	    initialSelectValue: function initialSelectValue() {
	      return orderPackage.rtlBoxType || /default/i;
	    }
	  });
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: brandLogoOnBoxSelect,
	    list: brandLogoOnBoxSelectList,
	    valueDataKey: "opcValue",
	    textDataKey: "opcValue",
	    afterOptionCreate: _.compose(setGenericDataInOptionForPackingSelect, setDataForBrandLogoOnBoxSelect),
	    initialSelectValue: function initialSelectValue() {
	      return orderPackage.rtlBrandLogoColor || /default/i;
	    }
	  });
	
	  function setDataForBrandLogoOnBoxSelect(_ref2) {
	    var option = _ref2.option,
	        data = _ref2.data;
	
	    if (!(0, _general.rgxTest)(/Default/i, data.opcValue)) {
	      option.data('quick-toggler-target', ".packing-logo-upload-area");
	    }
	    return { option: option, data: data };
	  }
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: tsPaperSelect,
	    list: tsPaperSelectList,
	    valueDataKey: "opcValue",
	    textDataKey: "opcValue",
	    afterOptionCreate: setGenericDataInOptionForPackingSelect,
	    initialSelectValue: function initialSelectValue() {
	      return orderPackage.rtlTsPaper || /default/i;
	    }
	  });
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: giftOptionsSelect,
	    list: giftOptionsSelectList,
	    valueDataKey: "opcValue",
	    textDataKey: "opcValue",
	    afterOptionCreate: setGenericDataInOptionForPackingSelect,
	    initialSelectValue: function initialSelectValue() {
	      return orderPackage.rtlGo || /default/i;
	    }
	  });
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    selectElement: giftBagWrappingColorSelect,
	    list: giftBagWrappingColorSelectList,
	    valueDataKey: "opcValue",
	    textDataKey: "opcValue",
	    afterOptionCreate: setGenericDataInOptionForPackingSelect,
	    initialSelectValue: function initialSelectValue() {
	      return orderPackage.rtlGoColor || /default/i;
	    }
	  });
	
	  packingTogglers.each(function () {
	    var toggler = $(this);
	    handleWellBgForToggler(toggler);
	    handleNoteForToggler(toggler);
	  });
	
	  packingTogglers.on("change", function (e) {
	    var toggler = $(this);
	    handleWellBgForToggler(toggler);
	    handleNoteForToggler(toggler);
	  });
	
	  function handleNoteForToggler(toggler) {
	    var noteText = toggler.find("option:selected").data("note");
	    var noteEl = toggler.closest(".packing-row").find(".packing-toggler-note-target");
	    noteEl.text(noteText);
	  }
	
	  function handleWellBgForToggler(toggler) {
	    var bgEl = toggler.closest(".packing-well");
	    var bgClassKey = toggler.find("option:selected").data("bg-well-color");
	    removeClassesViaKeys(bgEl, BG_CLASS_MAP);
	    bgEl.addClass(BG_CLASS_MAP[bgClassKey]);
	  }
	
	  function removeClassesViaKeys(el, dict) {
	    var classStr = "";
	    _(dict).mapObject(function (cls, k) {
	      classStr += cls + " ";
	    });
	    el.removeClass(classStr);
	  }
	
	  function setDivColor(selectId) {
	    var option = $('#' + selectId + ' option:contains(Default)');
	    console.log("option " + option);
	    var val = option.val();
	    $("'#" + selectId + "'").val(val);
	    $("'#" + selectId + "'").trigger('change.select2');
	  }
	
	  (0, _jqueryValidationMethods.bindFileInputChangeValidation)();
	
	  /*
	   * END
	   */
	
	  /*
	   * START: Order Documents Section
	   *
	   *
	   */
	
	  toggleBottomForm();
	
	  togglers.on("change", function (e) {
	    e.preventDefault();
	    toggleBottomForm();
	  });
	
	  $(addressList).each(function () {
	    var option = $('<option />');
	    option.attr('value', this.cadId).text(this.cadLocationName);
	    addressSelect.append(option);
	  });
	
	  function toggleBottomForm() {
	    var anyAreON = _(togglers.toArray()).any(function (item) {
	      return $(item).is(":checked");
	    });
	
	    docDetailForm.hide();
	    docMessage.hide();
	
	    if (anyAreON) {
	      docDetailForm.show();
	      docMessage.hide();
	    } else {
	      docDetailForm.hide();
	      docMessage.show();
	    }
	  }
	
	  setData();
	
	  function setData() {
	    addressSelect.val(orderPackage.address);
	    fillTheAddressSection(orderPackage.address);
	    if (orderPackage.packingslipb2c == "Y") {
	      $("#packing-slip-b2c").prop('checked', true);
	    }
	
	    if (orderPackage.packingslipb2b == "Y") {
	      $("#packing-slip-b2b").prop('checked', true);
	    }
	
	    if (orderPackage.commercialinvoiceb2b == "Y") {
	      $("#commercial-invoice-b2b").prop('checked', true);
	    }
	
	    toggleBottomForm();
	
	    $("#ps-b2c-opcId").val(orderPackage.psb2copcId);
	    $("#ps-b2b-opcId").val(orderPackage.psb2bopcId);
	    $("#ci-b2b-opcId").val(orderPackage.cib2bopcId);
	    $("#address-opcId").val(orderPackage.addressopcId);
	    $("#cn-opcId").val(orderPackage.cnopcId);
	    $("#em-opcId").val(orderPackage.emopcId);
	    $("#ph-opcId").val(orderPackage.phopcId);
	    $("#cnh-opcId").val(orderPackage.cnhopcId);
	    $("#cnb-opcId").val(orderPackage.cnbopcId);
	    $("#companyName").val(orderPackage.companyName);
	    $("#contactEmail").val(orderPackage.contactEmail);
	    $("#phoneNumber").val(orderPackage.phoneNumber);
	    $("#customNoteHeader").val(orderPackage.customNoteHeader);
	    $("#customNoteBody").val(orderPackage.customNoteBody);
	    $("#rtlGiftMsgId").html(orderPackage.rtlGm);
	    $("#rtlGiftMsgCostId").html(orderPackage.rtlGmCost);
	  }
	
	  $(addressSelect).change(onAddressSelectChange);
	
	  var prevLocSelVal = $(addressSelect);
	
	  function onAddressSelectChange(e) {
	    e.preventDefault();
	    var val = $(this).val();
	    if (prevLocSelVal != val) {
	      fillTheAddressSection(val);
	    }
	    prevLocSelVal = val;
	  }
	
	  function fillTheAddressSection(val) {
	    var selectedAddress = addressList.filter(function (obj) {
	      return obj.cadId == val;
	    })[0];
	    if ((0, _general.isPresent)(selectedAddress)) {
	      $("#order-package-address1").html(selectedAddress.cadAddress1);
	      $("#order-package-address2").html(selectedAddress.cadAddress2);
	      $("#city-state-zip").html(selectedAddress.cadCity + ',' + selectedAddress.cadState + ',' + selectedAddress.cadZipcode);
	    }
	  }
	
	  /*Removed for EditChecker above
	  $(".order-packaging-cancel").on("click", function(e) {
	    e.preventDefault();
	    $("#order-packaging-cancel-modal").modal("show");
	  });
	  */
	
	  $(".removeBrandLogo").on("click", function (e) {
	    e.preventDefault();
	    rtllogoFileNameId.val("");
	    rtllogoImageId.val("");
	    rtlLogoFileNameTextInput.val("");
	  });
	
	  $(".order-packaging-save").on("click", function (e) {
	    e.preventDefault();
	    if (!updateOrderPackagingForm.valid()) {
	      return;
	    }
	    // console.log($('#update-order-packaging').serialize());
	    save({
	      url: saveURL,
	      success: saveSuccess,
	      error: saveError
	    });
	  });
	
	  /*function save({url, success, error}) {
	    $.ajax({
	      enctype: 'multipart/form-data',
	      processData: false,
	      data:  $('#update-order-packaging').serialize(),
	      url: url,
	      dataType:"JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }*/
	
	  function save(_ref3) {
	    var url = _ref3.url,
	        success = _ref3.success,
	        error = _ref3.error;
	
	    submitModalFlow.showLoadingModal();
	    $.ajax({
	      data: new FormData($('#update-order-packaging').get(0)),
	      url: url,
	      processData: false,
	      contentType: false,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function saveSuccess(data) {
	    if (data.respose == "success") {
	      EditChecker.setPageClean();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        location.href = '' + detailPageURL;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function saveError() {
	    submitModalFlow.showFailureModal();
	  }
	  /*
	   * END
	   */
	}

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _changePasswordLogic = __webpack_require__(217);
	
	var _changePasswordLogic2 = _interopRequireDefault(_changePasswordLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: make the target selector a place on the webpage where you want to import this
	var targetSelector = "#change-password-container";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	    attachHtml(outerEl);
	});
	
	function attachHtml(outerEl) {
	    var changePasswordLogic = new _changePasswordLogic2.default(outerEl);
	    changePasswordLogic.init();
	};

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(727);
	
	__webpack_require__(218);
	
	__webpack_require__(217);
	
	__webpack_require__(725);
	
	__webpack_require__(180);

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _passwordGuidelinesLogic = __webpack_require__(218);
	
	var _passwordGuidelinesLogic2 = _interopRequireDefault(_passwordGuidelinesLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: make the target selector a place on the webpage where you want to import this
	var targetSelector = "#update-password-container";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachHtml(outerEl);
	});
	
	function attachHtml(outerEl) {
	  var passwordGuidelinesLogic = new _passwordGuidelinesLogic2.default(outerEl);
	  passwordGuidelinesLogic.init();
	};

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CollateralDetailsTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CollateralDetailsTab(wizard) {
	  var self = this;
	  var elementsMap = void 0;
	  var els = {};
	  var wizardElement = wizard.getWizardElement();
	  var namespace = wizardElement.data("namespace").trim();
	  var itemObj = wizardElement.data("collateral-existing-item");
	  var productObj = wizardElement.data("collateral-existing-product");
	  var collateralBarcodedBtnGroupEl = wizardElement.find(".collateral-barcoded-toggler");
	  var collateralBarcodedBtnGroup = new _QuickBtnGroup2.default(collateralBarcodedBtnGroupEl, { distributeWidth: true });
	  collateralBarcodedBtnGroup.init();
	
	  self.init = function () {
	    setMappings();
	    setElements();
	    fillCollateralData();
	  };
	
	  function fillCollateralData() {
	    if (itemObj != null && itemObj != "") {
	      els.collateralName.val(itemObj.itmSku);
	      els.collateralDescription.val(productObj.prdName);
	      els.collateralLongDescription.val(productObj.prdDescription);
	      els.collateralType.val(productObj.prdCollateralType);
	      if (productObj.prdBarcodeMarked) {
	        collateralBarcodedBtnGroup.activateBtnViaKey("yes");
	      } else {
	        collateralBarcodedBtnGroup.activateBtnViaKey("no");
	      }
	      els.collateralUPC.val(itemObj.itmUpc);
	      els.collateralLength.val(itemObj.itmDimnLength);
	      els.collateralWidth.val(itemObj.itmDimnWidth);
	      els.collateralHeight.val(itemObj.itmDimnHeight);
	      els.collateralWeight.val(itemObj.itmDimnWeight);
	      els.hiddenItemId.val(itemObj.itmId);
	      els.hiddenPrdId.val(productObj.prdId);
	      if (productObj.prdHandlingInstr === "Y") {
	        els.excludePkgProducts.prop('checked', true);
	      }
	    }
	  }
	
	  function setMappings() {
	    elementsMap = {
	      collateralName: '#' + namespace + 'collateralName',
	      collateralDescription: '#' + namespace + 'collateralDescription',
	      collateralLongDescription: '#' + namespace + 'collateralLongDescription',
	      collateralType: '#' + namespace + 'collateralType',
	      collateralBarcoded: '#' + namespace + 'collateralBarcoded',
	      collateralUPC: '#' + namespace + 'collateralUPC',
	      collateralLength: '#' + namespace + 'collateralLength',
	      collateralWidth: '#' + namespace + 'collateralWidth',
	      collateralHeight: '#' + namespace + 'collateralHeight',
	      collateralWeight: '#' + namespace + 'collateralWeight',
	      excludePkgProducts: '#excludePrepackagedProducts',
	      hiddenItemId: '#collateral-itemId',
	      hiddenPrdId: '#collateral-prdId'
	    };
	  }
	
	  function setElements() {
	    setElementsFromScope(els, elementsMap, wizardElement);
	  }
	
	  function setElementsFromScope(targetObj, elementsDict, scope) {
	    (0, _underscore2.default)(elementsDict).each(function (v, k) {
	      targetObj[k] = scope.find(v);
	    });
	  }
	}

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CollateralReviewTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	
	  //Review tab
	  collateralNameVal: ".collateral-name-val",
	  collateralDescVal: ".collateral-desc-val",
	  collateralLongDescVal: ".collateral-long-desc-val",
	  collateralTypeVal: ".collateral-type-val",
	  collateralBarcodedVal: ".collateral-barcoded-val",
	  reviewTabLengthVal: ".review-tab-length-val",
	  reviewTabWidthVal: ".review-tab-width-val",
	  reviewTabHeightVal: ".review-tab-height-val",
	  reviewTabWeightVal: ".review-tab-weight-val",
	  reviewNoRulesAlert: ".review-no-rules-alert",
	  reviewRulesAlert: ".review-rules-alert",
	  submitBtn: ".collateral-submit-btn"
	
	};
	
	function CollateralReviewTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	  var namespace = wizardElement.data("namespace").trim();
	  var submitURL = wizardElement.data("submit-collateral-url");
	  var submitModalTitleTxt = wizardElement.data("submit-modal-title-txt");
	  var submitModalBodyTxt = wizardElement.data("submit-modal-body-txt");
	  var submitModalBtnTxt = wizardElement.data("submit-modal-btn-txt");
	
	  self.init = function () {
	    setMappings();
	    setElements();
	    bindElements();
	  };
	
	  self.didNavigateToForm = function () {
	    fillCollateralAttributes();
	    fillCollateralRules();
	  };
	
	  function bindElements() {
	    els.submitBtn.on("click", function (e) {
	      e.preventDefault();
	      showSubmitModal();
	    });
	  }
	
	  function showSubmitModal() {
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: submitModalTitleTxt,
	      confirmModalBody: '<div class="q-pad-all-xl">' + submitModalBodyTxt + '</div>',
	      confirmModalBtnText: submitModalBtnTxt,
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        saveNow();
	
	        function saveNow() {
	          _jquery2.default.ajax({
	            data: (0, _jquery2.default)('#new-collateral-wizard').serialize(),
	            url: submitURL,
	            dataType: "JSON",
	            type: 'POST',
	            success: submitCollateralSucess,
	            error: submitCollateralError
	          });
	        }
	
	        function submitCollateralSucess(itemId) {
	          if (itemId > 0) {
	            _EditChecker2.default.setPageClean();
	            submitModalFlow.showSuccessModal();
	            var collateralDetailUrl = wizardElement.data("collateral-detail-url");
	            setTimeout(function () {
	              location.href = collateralDetailUrl + '&' + namespace + 'itemId=' + itemId;
	            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	          } else {
	            submitModalFlow.showFailureModal();
	          }
	        }
	
	        function submitCollateralError() {
	          submitModalFlow.hideAllModals();
	        }
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	
	  function fillCollateralAttributes() {
	    els.collateralNameVal.html(els.collateralName.val());
	    els.collateralDescVal.html(els.collateralDescription.val());
	    els.collateralLongDescVal.html(els.collateralLongDescription.val());
	    els.collateralTypeVal.html((0, _jquery2.default)('#' + namespace + 'collateralType option:selected').text());
	    els.collateralBarcodedVal.html(els.collateralBarcoded.val());
	    els.reviewTabLengthVal.html(els.collateralLength.val() + " <strong>Inches</strong>");
	    els.reviewTabWidthVal.html(els.collateralWidth.val() + " <strong>Inches</strong>");
	    els.reviewTabHeightVal.html(els.collateralHeight.val() + " <strong>Inches</strong>");
	    els.reviewTabWeightVal.html(els.collateralWeight.val() + " <strong>lbs</strong>");
	    var handlingCheckBox = (0, _jquery2.default)('#excludePrepackagedProducts').is(':checked');
	    if (handlingCheckBox) {
	      (0, _jquery2.default)(".q-ppt-purple").show();
	      (0, _jquery2.default)(".q-ppt-grey").hide();
	    } else {
	      (0, _jquery2.default)(".q-ppt-purple").hide();
	      (0, _jquery2.default)(".q-ppt-grey").show();
	    }
	  }
	
	  function fillCollateralRules() {
	    (0, _jquery2.default)("#collateral-rules-review-table-body").empty();
	    var collateralRulesCheckbox = (0, _jquery2.default)('input[name="collateralRules"]:checked');
	    if (collateralRulesCheckbox.length > 0) {
	      (0, _jquery2.default)(".review-rules-alert").show();
	      (0, _jquery2.default)(".no-rules-alert").hide();
	      collateralRulesCheckbox.each(function () {
	        var checkbox = (0, _jquery2.default)(this);
	        var data = getCheckboxRowDataFromCheckbox(checkbox);
	        fillReviewTabTableNextRowWithData(data);
	      });
	    } else {
	      els.reviewNoRulesAlert.show();
	      (0, _jquery2.default)(".no-rules-alert").show();
	      els.reviewRulesAlert.hide();
	    }
	  }
	
	  (0, _jquery2.default)(document).on('click', "[data-target-form]", function () {
	    var form = wizardElement.find((0, _jquery2.default)(this).data("target-form"));
	    wizard.gotToForm(form);
	  });
	
	  function setElements() {
	    setElementsFromScope(els, elementsMap, wizardElement);
	  }
	
	  function setElementsFromScope(targetObj, elementsDict, scope) {
	    (0, _underscore2.default)(elementsDict).each(function (v, k) {
	      targetObj[k] = scope.find(v);
	    });
	  }
	
	  function setMappings() {
	    _underscore2.default.extend(elementsMap, {
	      collateralName: '#' + namespace + 'collateralName',
	      collateralDescription: '#' + namespace + 'collateralDescription',
	      collateralLongDescription: '#' + namespace + 'collateralLongDescription',
	      collateralType: '#' + namespace + 'collateralType',
	      collateralBarcoded: '#' + namespace + 'collateralBarcoded',
	      collateralUPC: '#' + namespace + 'collateralUPC',
	      collateralLength: '#' + namespace + 'collateralLength',
	      collateralWidth: '#' + namespace + 'collateralWidth',
	      collateralHeight: '#' + namespace + 'collateralHeight',
	      collateralWeight: '#' + namespace + 'collateralWeight',
	      excludePkgProducts: '#excludePrepackagedProducts'
	    });
	  }
	
	  function getCheckboxRowDataFromCheckbox(checkbox) {
	    var data = {};
	    var row = checkbox.closest("tr");
	    data.firstDataText = row.find('.first-element-containing-data').text();
	    data.secondDataText = row.find('.second-element-containing-data');
	    data.thirdDataText = row.find('.third-element-containing-data').val();
	    data.forthDataText = row.find('.forth-element-containing-data');
	    return data;
	  }
	
	  function fillReviewTabTableNextRowWithData(data) {
	    (0, _jquery2.default)(".collateral-rules-review-table").find('tbody').append((0, _jquery2.default)('<tr><td> <div class="rule-name"><label for="rule-1" class="q-td-label">' + data.firstDataText + '</label></div></td>').append('<td><div class="rule-desc"><label for="rule-1" class="q-td-label">' + data.secondDataText[0].innerHTML).append('</label></div></td>').append('<td><div class="rule-desc"><label for="rule-1" class="q-td-label">' + data.thirdDataText).append('</label></div></td>').append('<td><div class="rule-desc"><label for="rule-1" class="q-td-label">' + data.forthDataText[0].innerHTML).append('</label></div></td></tr>'));
	
	    (0, _jquery2.default)('.target-filling-element-1').text();
	    (0, _jquery2.default)('.target-filling-element-2').text(data.secondDataText[0].innerHTML);
	    (0, _jquery2.default)('.target-filling-element-3').text(data.thirdDataText[0].innerHTML);
	    (0, _jquery2.default)('.target-filling-element-4').text(data.forthDataText[0].innerHTML);
	  }
	}

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CollateralRulesTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var elementsMap = {
	
	  //Rules tab
	  rulesSatisfiesAnyAlert: ".rules-satisfies-any-alert",
	  noRulesAlert: ".no-rules-alert",
	  rulesTabRulesAlert: ".rules-tab-rules-alert"
	
	};
	
	function CollateralRulesTab(wizard) {
	  var self = this;
	  var els = {};
	  var wizardElement = wizard.getWizardElement();
	  var namespace = wizardElement.data("namespace").trim();
	  var collateralRules = wizardElement.data("collateral-rules");
	  var collateralRuleConditionsUrl = wizardElement.data("get-collateral-rule-conditions");
	  var collateralDetailItmRules = wizardElement.data("collateral-detail-itm-rule-mapping");
	  var collateralRulesTable;
	
	  self.init = function () {
	    setElements();
	    checkRulesInUse();
	  };
	
	  self.didNavigateToForm = function () {
	    checkForRules();
	  };
	
	  function setElements() {
	    setElementsFromScope(els, elementsMap, wizardElement);
	  }
	
	  function setElementsFromScope(targetObj, elementsDict, scope) {
	    (0, _underscore2.default)(elementsDict).each(function (v, k) {
	      targetObj[k] = scope.find(v);
	    });
	  }
	
	  function checkForRules() {
	
	    if (collateralRules == null || collateralRules.length == 0) {
	      els.rulesSatisfiesAnyAlert.hide();
	      els.rulesTabRulesAlert.hide();
	      els.noRulesAlert.show();
	    } else {
	      els.rulesSatisfiesAnyAlert.show();
	      els.rulesTabRulesAlert.show();
	      els.noRulesAlert.hide();
	    }
	  }
	
	  function checkRulesInUse() {
	    if (collateralDetailItmRules != null && collateralDetailItmRules.length > 0) {
	      _jquery2.default.each(collateralDetailItmRules, function (key, value) {
	        (0, _jquery2.default)("#cbrId-" + value.clrCbrId).prop('checked', true);
	        (0, _jquery2.default)("#qtyPerRule-" + value.clrCbrId).val(value.clrQtyPerRule);
	        (0, _jquery2.default)("#qtyPerRule-" + value.clrCbrId).prop('disabled', false);
	      });
	    }
	  }
	
	  collateralRulesTable = (0, _jquery2.default)('#collateral-rules-table-id').dataTable({
	    select: {
	      style: 'os',
	      selector: 'td:first-child'
	    },
	    data: collateralRules,
	    "bPaginate": false,
	    "searchable": false,
	    "order": [[1, "asc"]],
	    columns: [{ data: "cbrId", "orderable": false,
	      render: function render(data, type, row) {
	        if (type === 'display') {
	          var html = '<div class="checkbox checkbox-success cb-large collateralRulesCheckbox">' + '<input type="checkbox" id="cbrId-' + row.cbrId + '" value="' + row.cbrId + '" name="collateralRules" class="collateralRulesLookup"/>' + '<label for="cbrId-' + row.cbrId + '"></label>' + '</div>';
	          return html;
	        }
	        return data;
	      },
	      className: "select-checkbox", width: "45px" }, { data: "cbrName", "class": "details-control rule-name first-element-containing-data" }, { data: "cbrActive", "class": "details-control second-element-containing-data",
	      render: function render(data, type, row) {
	        if (row.cbrActive) {
	          var html = '<div class="rule-status">' + '<div class="q-pill q-pill-blue q-pad-vert-xxs q-pill-stretch">Active</div>' + '</div>';
	          return html;
	        } else {
	          var _html = '<div class="rule-status">' + '<div class="q-pill q-pill-light-grey q-pad-vert-xxs q-pill-stretch">Inactive</div>' + '</div>';
	          return _html;
	        }
	      }
	    }, { data: "cbrId", "orderable": false, "class": "details-control rule-number",
	      render: function render(data, type, row) {
	        if (type === 'display') {
	          var html = '<div>' + '<input type="number" id="qtyPerRule-' + row.cbrId + '" name="qtyPerRule-' + row.cbrId + '" disabled min="1" step="1" class="q-input stretch required third-element-containing-data"/>' + '<label for="clrId-' + row.cbrId + '"></label>' + '</div>';
	          return html;
	        }
	        return data;
	      }
	    }, { data: "cbrId", "orderable": false,
	      render: function render(data, type, row) {
	        if (type === 'display') {
	          var html = '<div class="rule-details forth-element-containing-data">' + '<a href="#" class="rule-details-link" id="' + row.cbrId + '" name="cbrIdDetailsLink" value="' + row.cbrId + '">' + '<i class="fa fa-eye" aria-hidden="true"></i> View Rule Details' + '</a></div>';
	          return html;
	        }
	        return data;
	      }
	    }]
	
	  });
	
	  (0, _jquery2.default)('input[name="collateralRules"]').change(function (e) {
	    if ((0, _jquery2.default)(this).prop('checked')) {
	      (0, _jquery2.default)('#qtyPerRule-' + (0, _jquery2.default)(this).val()).prop('disabled', false);
	    } else {
	      (0, _jquery2.default)('#qtyPerRule-' + (0, _jquery2.default)(this).val()).prop('disabled', true);
	    }
	  });
	
	  function getBusinessRuleConitions(_ref) {
	    var data = _ref.data,
	        success = _ref.success,
	        error = _ref.error;
	
	
	    _jquery2.default.ajax({
	      data: _defineProperty({}, namespace + 'cbrId', data),
	      url: collateralRuleConditionsUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  (0, _jquery2.default)(document).on("click", ".rule-details-link", function (e) {
	    e.preventDefault();
	    var businessRuleId = this.id;
	    getBusinessRuleConitions({ data: businessRuleId, success: findCollateralRuleConditionSucess, error: findCollateralRuleConditionError });
	  });
	
	  function findCollateralRuleConditionSucess(response) {
	    //const rule = JSON.stringify(response);
	    (0, _jquery2.default)("#rule-effective-dates").html("Effective from " + timestampToDate(response.cbrEffectiveStartDate) + " until " + timestampToDate(response.cbrEffectiveEndDate));
	    (0, _jquery2.default)("#rule-conditions-and-params").html(response.displayCmrRuleConditions);
	    (0, _jquery2.default)("#collateral-rulesTab-modal").modal("show");
	  }
	
	  function findCollateralRuleConditionError() {
	    console.log("Error");
	  }
	
	  function timestampToDate(createdDate) {
	    var date = new Date(createdDate); //createdDate is long time format
	    var month = date.getMonth() + 1;
	    return (month > 9 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear();
	  }
	}

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#bundle-detail", function () {
	  var bundleDetailsPage = (0, _jquery2.default)("#bundle-detail");
	  var activateBtn = (0, _jquery2.default)("#activate-btn");
	  var activateItemUrl = bundleDetailsPage.data("activate-item-url");
	  var deleteItemUrl = bundleDetailsPage.data("delete-item-url");
	  var currentUrl = bundleDetailsPage.data("current-url");
	  var itemStatus = bundleDetailsPage.data("item-status");
	  var activateModalTitleTxt = bundleDetailsPage.data("activate-modal-title-txt");
	  var activateModalBodyTxt = bundleDetailsPage.data("activate-modal-body-txt");
	  var activateModalBtnTxt = bundleDetailsPage.data("activate-modal-btn-txt");
	  var inactivateModalTitelTxt = bundleDetailsPage.data("inactivate-modal-title-txt");
	  var inactivateModalBodyTxt = bundleDetailsPage.data("inactivate-modal-body-txt");
	  var inactivateModalBtnTxt = bundleDetailsPage.data("inactivate-modal-btn-txt");
	
	  activateBtn.click(function (e) {
	    e.preventDefault();
	    if (itemStatus.includes("Active")) {
	      updateItem(inactivateModalTitelTxt, inactivateModalBodyTxt, inactivateModalBtnTxt, deleteItemUrl);
	    } else {
	      updateItem(activateModalTitleTxt, activateModalBodyTxt, activateModalBtnTxt, activateItemUrl);
	    }
	  });
	
	  function updateItem(title, body, btn, url) {
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: title,
	      confirmModalBody: '<div class="q-pad-all-xl">' + body + '</div>',
	      confirmModalBtnText: btn,
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        _jquery2.default.ajax({
	          url: url,
	          success: function success(data) {
	            if (data.match("success")) {
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = currentUrl;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            } else {
	              submitModalFlow.showFailureModal();
	            }
	          },
	          error: function error() {
	            submitModalFlow.hideAllModals();
	          }
	        });
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	});

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jumpToWizardLogic = __webpack_require__(70);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	(0, _run2.default)("#collateral-details-page", function () {
	  var collateralDetailsPage = (0, _jquery2.default)("#collateral-details-page");
	  var activateBtn = ".activate";
	  var inactivateBtn = ".delete";
	  var activateUrl = collateralDetailsPage.data("activate-url");
	  var inactivateUrl = collateralDetailsPage.data("inactivate-url");
	  var pageRefreshUrl = collateralDetailsPage.data("page-refresh-url");
	  var collateralRules = collateralDetailsPage.data("collateral-rules");
	  var collateralDetailItmRules = collateralDetailsPage.data("collateral-detail-itm-rule-mapping");
	  var collateralRuleConditionsUrl = collateralDetailsPage.data("get-collateral-rule-conditions");
	  var namespace = collateralDetailsPage.data("namespace");
	  var activateModalTitleTxt = collateralDetailsPage.data("activate-modal-title-txt");
	  var activateModalBodyTxt = collateralDetailsPage.data("activate-modal-body-txt");
	  var activateModalBtnTxt = collateralDetailsPage.data("activate-modal-btn-txt");
	  var inactivateModalTitelTxt = collateralDetailsPage.data("inactivate-modal-title-txt");
	  var inactivateModalBodyTxt = collateralDetailsPage.data("inactivate-modal-body-txt");
	  var inactivateModalBtnTxt = collateralDetailsPage.data("inactivate-modal-btn-txt");
	
	  (0, _jumpToWizardLogic.bindJumpToWizardLinks)();
	
	  (0, _jquery2.default)(activateBtn).click(function (e) {
	    e.preventDefault();
	    updateItem(activateModalTitleTxt, activateModalBodyTxt, activateModalBtnTxt, activateUrl);
	  });
	
	  (0, _jquery2.default)(inactivateBtn).click(function (e) {
	    e.preventDefault();
	    updateItem(inactivateModalTitelTxt, inactivateModalBodyTxt, inactivateModalBtnTxt, inactivateUrl);
	  });
	
	  function updateItem(title, body, btn, url) {
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: title,
	      confirmModalBody: '<div class="q-pad-all-xl">' + body + '</div>',
	      confirmModalBtnText: btn,
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        _jquery2.default.ajax({
	          url: url,
	          success: function success(data) {
	            if (data.match("success")) {
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = pageRefreshUrl;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            } else {
	              submitModalFlow.showFailureModal();
	            }
	          },
	          error: function error() {
	            submitModalFlow.hideAllModals();
	          }
	        });
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	
	  function checkForRules() {
	    if (collateralDetailItmRules === null || collateralDetailItmRules.length == 0) {
	      (0, _jquery2.default)(".no-rules-well").show();
	      (0, _jquery2.default)(".collateral-details-rules-tab-rules-alert").hide();
	    } else {
	      (0, _jquery2.default)(".no-rules-well").hide();
	      (0, _jquery2.default)(".no-rules-div").hide();
	      _jquery2.default.each(collateralDetailItmRules, function (key, value) {
	        (0, _jquery2.default)("#qtyPerRule-" + value.clrCbrId).text(value.clrQtyPerRule);
	      });
	      (0, _jquery2.default)(".collateral-details-rules-tab-rules-alert").show();
	    }
	  }
	
	  (0, _jquery2.default)('#collateral-details-rules-table-id').dataTable({
	    data: collateralRules,
	    "bPaginate": false,
	    "bSearchable": false,
	    "bInfo": false,
	    "bFilter": false,
	    "bSortable": false,
	    columns: [{ data: "cbrId", "orderable": false, "searchable": false, "bSortable": false,
	      render: function render(data, type, row) {
	        if (type === 'display') {
	          var html = '<div class="checkbox checkbox-success cb-large collateralRulesCheckbox disabled">' + '<input type="checkbox" disabled readonly checked id="cbrId-' + row.cbrId + '" value="' + row.cbrId + '" name="collateralRules" class="collateralRulesLookup"/>' + '<label for="cbrId-' + row.cbrId + '"></label>' + '</div>';
	          return html;
	        }
	        return data;
	      },
	      className: "select-checkbox", width: "45px" }, { data: "cbrName", "orderable": false, "searchable": false, "bSortable": false, "class": "details-control first-element-containing-data", width: "126px" }, { data: "cbrDescription", "orderable": false, "searchable": false, "class": "details-control second-element-containing-data" }, { data: "cbrId", "orderable": false, "searchable": false, "class": "details-control rule-number",
	      render: function render(data, type, row) {
	        if (type === 'display') {
	          var html = '<div id="qtyPerRule-' + row.cbrId + '" class="third-element-containing-data""></div>';
	          return html;
	        }
	        return data;
	      }
	    }, { data: "cbrId", "orderable": false, "searchable": false,
	      render: function render(data, type, row) {
	        if (type === 'display') {
	          var html = '<div class="rule-details fourth-element-containing-data">' + '<a href="#" class="rule-details-link" id="' + row.cbrId + '" name="cbrIdDetailsLink" value="' + row.cbrId + '">' + '<i class="fa fa-eye" aria-hidden="true"></i> View Rule Details' + '</a></div>';
	          return html;
	        }
	        return data;
	      }
	    }],
	    "initComplete": function initComplete() {
	      checkForRules();
	    }
	  });
	
	  (0, _jquery2.default)(document).on("click", ".rule-details-link", function (e) {
	    e.preventDefault();
	    var businessRuleId = this.id;
	    getBusinessRuleConitions({ data: businessRuleId, success: findCollateralRuleConditionSucess, error: findCollateralRuleConditionError });
	  });
	
	  function getBusinessRuleConitions(_ref) {
	    var data = _ref.data,
	        success = _ref.success,
	        error = _ref.error;
	
	
	    _jquery2.default.ajax({
	      data: _defineProperty({}, namespace + 'cbrId', data),
	      url: collateralRuleConditionsUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function findCollateralRuleConditionSucess(response) {
	    //const rule = JSON.stringify(response);
	    (0, _jquery2.default)("#rule-effective-dates").html("Effective from " + timestampToDate(response.cbrEffectiveStartDate) + " until " + timestampToDate(response.cbrEffectiveEndDate));
	    (0, _jquery2.default)("#rule-conditions-and-params").html(response.displayCmrRuleConditions);
	    (0, _jquery2.default)("#collateral-detail-rules-modal").modal("show");
	  }
	
	  function findCollateralRuleConditionError() {}
	
	  function timestampToDate(createdDate) {
	    var date = new Date(createdDate); //createdDate is long time format
	    var month = date.getMonth() + 1;
	    return (month > 9 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear();
	  }
	});

/***/ },
/* 733 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    icon: 'toggle-on',
	    title: 'Activate Selected Products',
	    cls: "bulk-activate-product",
	    disabled: false
	  }, {
	    icon: 'toggle-off',
	    title: 'Deactivate Selected Products',
	    cls: "bulk-deactivate-product",
	    disabled: false
	  }],
	  "actions": [{
	    title: "Edit",
	    cls: "edit-product",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Activate/Deactivate",
	    cls: "",
	    icon: "",
	    disabled: false
	  }, {
	    title: "Duplicate",
	    cls: "duplicate-product",
	    icon: "clone",
	    disabled: false
	  }]
	};

/***/ },
/* 734 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var searchDropdown = exports.searchDropdown = [{
		title: "Product Name (SKU)",
		value: "productName"
	}, {
		title: "Description",
		value: "productDescription"
	}, {
		title: "UPC",
		value: "upc"
	}, {
		title: "Classification",
		value: "itmProductClass"
	}, {
		title: "Variant Type",
		value: "variantAttributeType"
	}, {
		title: "Variant Value",
		value: "variantAttributeValue"
	}, {
		title: "Sub Category",
		value: "itmSubCategory"
	}, {
		title: "Model Number",
		value: "itmModel"
	}, {
		title: "Size",
		value: "itmSize"
	}, {
		title: "Color",
		value: "itmColor"
	}, {
		title: "Style",
		value: "itmStyle"
	}];

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(736);
	
	__webpack_require__(737);
	
	__webpack_require__(731);
	
	__webpack_require__(738);
	
	__webpack_require__(732);

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _searchDropdown = __webpack_require__(734);
	
	var _actionOptions = __webpack_require__(733);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	var actionList = _actionOptions.actionOptions;
	var targetSelector = "#product-catalog-lookup";
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	
	(0, _run2.default)(targetSelector, function () {
	  var dataTableComponentData = $(targetSelector).data("items-data");
	  var enrollmentType = $(targetSelector).data("enrollment-type");
	  var editPermission = $(targetSelector).data("edit-permission");
	  var viewItemRenderUrl = $(targetSelector).data("view-item-render-url");
	  var collateralDetailRenderUrl = $(targetSelector).data("collateral-detail-render-url");
	  var bundleDetailRenderUrl = $(targetSelector).data("bundle-detail-render-url");
	  var editItemRenderUrl = $(targetSelector).data("edit-item-render-url");
	  var addUpdateBundleURL = $(targetSelector).data("edit-bundle-render-url");
	  var addUpdateCollateralURL = $(targetSelector).data("edit-collateral-render-url");
	  var duplicateProductRenderUrl = $(targetSelector).data("duplicate-product-render-url");
	  var duplicateCollateralRenderUrl = $(targetSelector).data("duplicate-collateral-render-url");
	  var duplicateBundleRenderUrl = $(targetSelector).data("duplicate-bundle-render-url");
	  var deleteItemUrl = $(targetSelector).data("delete-item-url");
	  var activateItemUrl = $(targetSelector).data("activate-item-url");
	  var portletNamespace = $(targetSelector).data("portlet-namespace");
	  var filterItemsUrl = $(targetSelector).data("filter-items-url");
	
	  var generateExportUrl = $(targetSelector).data("generate-export-url");
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var bulkActivateItemsUrl = $(targetSelector).data("bulk-activate-product-url");
	  var bulkDeactivateItemsUrl = $(targetSelector).data("bulk-deactivate-product-url");
	  var savedViews = $(targetSelector).data("saved-views");
	  var saveViewURL = $(targetSelector).data("save-view-url");
	  var deleteViewURL = $(targetSelector).data("delete-view-url");
	  var disableCancel = "";
	
	  var exportModal = new _filtersutil.buildExport();
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var extraDetailForCacheFromServer = $(targetSelector).data("extra-detail-for-cache-from-server");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	  var targetObject = "";
	  var selectedRows = "";
	
	  function createDetailLink(data, type, row) {
	    var returnString = "";
	    var lowerPrdType = "";
	    var prdType = "";
	    if (row.product && row.product.prdType != null && row.product.prdType != 'null') {
	      lowerPrdType = row.product.prdType.toLowerCase();
	    } else {
	      lowerPrdType = prdType;
	    }
	    var html = '<div class="q-marg-all-xs-at-md"><a href={%= bundleDetailRenderUrl %}&{%- portletNamespace%}itemId={%- itmId %} class=\'details-control anchor-text\'>{%- data %}</a></div>';
	    if (lowerPrdType == "bundle") {
	      returnString = (0, _render2.default)(html, {
	        data: data,
	        itmId: row.itmId,
	        portletNamespace: portletNamespace,
	        bundleDetailRenderUrl: bundleDetailRenderUrl
	      });
	    } else if (lowerPrdType == "collateral") {
	      returnString = (0, _render2.default)(html, {
	        data: data,
	        itmId: row.itmId,
	        portletNamespace: portletNamespace,
	        bundleDetailRenderUrl: collateralDetailRenderUrl
	      });
	    } else {
	      returnString = (0, _render2.default)(html, {
	        data: data,
	        itmId: row.itmId,
	        portletNamespace: portletNamespace,
	        bundleDetailRenderUrl: viewItemRenderUrl
	      });
	    }
	    return returnString;
	  }
	
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	
	  function renderDescription(data, type, item) {
	    var result = void 0;
	    var html = void 0;
	    if (item.itmActive) {
	      html = "<div class='q-marg-all-xs-at-md'>{%- data %}</div>";
	      result = (0, _render2.default)(html, {
	        data: data
	      });
	    } else {
	      html = "<div class='q-marg-all-xs-at-md inactive-items'>{%- data %}</div>";
	      result = (0, _render2.default)(html, {
	        data: data
	      });
	    }
	    return result;
	  }
	
	  function renderStatusPill(data, type, row) {
	    if (data === 'Active') {
	      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
	    } else {
	      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
	    }
	  }
	
	  var productLookup = new _index2.default({
	    // REQUIRED - Set a target element
	    target: $("#product-catalog-wrapper"),
	    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
	    minWidthClass: "q-min-width-sm-til-md",
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: [{
	      data: "itmSku",
	      title: "Product (SKU)",
	      render: createDetailLink
	    }, {
	      data: "product.prdName",
	      title: "Description",
	      render: renderDescription,
	      orderable: true
	    }, {
	      data: "itmStatus",
	      title: "Status",
	      render: renderStatusPill
	    }],
	    // tableFilters: {
	    //    data: orderFilterData,
	    //  },
	
	    // REQUIRED: search input info
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: targetObject != "" ? targetObject.value[0] : ""
	
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _searchDropdown.searchDropdown
	    },
	    // OPTIONAL: Set Saved View Array
	    savedViews: savedViews,
	    bulkSelect: true,
	    // REQUIRED - Data Table specific settings
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      // Not required, just to show you can
	      columnDefs: [{ className: "custom-class", targets: [1] }],
	      // Not required, just to show you can
	      order: [[7, 'asc']],
	      columns: [{
	        data: "itmStatus",
	        render: renderActionWrap,
	        orderable: false,
	        class: 'dtc-action-column'
	      }, {
	        data: "itmSku",
	        title: "Product Name (SKU)",
	        render: createDetailLink,
	        class: 'dtc-min-width-md'
	      }, {
	        data: "product.prdName",
	        title: "Description",
	        render: renderDescription,
	        class: 'dtc-min-width-lg'
	      }, {
	        data: "itmUpc",
	        title: "UPC",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "product.category.catName",
	        title: "Product Category",
	        class: 'dtc-min-width-md'
	      }, {
	        data: "product.prdType",
	        title: "Product Type",
	        class: 'dtc-min-width-sm product-type'
	      }, {
	        data: "itmStatus",
	        title: "Product Status",
	        render: renderStatusPill,
	        class: 'dtc-min-width-md'
	      }]
	    },
	    //  tableColumnModal: {
	    //	data: orderLookupColumnsPopup
	    //},
	    paginationData: dataTableComponentData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Products",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "products"
	    },
	    onBulkSelectChange: function onBulkSelectChange() {
	      selectedRows = productLookup.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass('disabled');
	      } else {
	        $(".action-header-btn .base-btn").addClass('disabled');
	      };
	    },
	    onFetch: function onFetch() {
	      var currentData = productLookup.generateData();
	      productLookup.showLoadingOverlay();
	
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterItemsUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	  productLookup.init();
	  var table = $("#product-catalog-wrapper .data-table-component").DataTable();
	  /*if(table != null && enrollmentType === 'RMS'){
	    table.columns('.product-type').visible( false );
	    table.columns.adjust().draw( false ); // adjust column sizing and redraw
	  }*/
	
	  function filterSuccessFun(data) {
	    var items = data.content;
	    var page = data.page;
	    productLookup.setNewData(items);
	    productLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    productLookup.hideLoadingOverlay();
	    setExportData(productLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var items = data.lookupItems.content;
	    var page = data.lookupItems.page;
	    productLookup.setNewData(items);
	    productLookup.setPaginationData(page);
	    productLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    productLookup.hideLoadingOverlay();
	    setExportData(productLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var items = data.lookupItems.content;
	    var page = data.lookupItems.page;
	    productLookup.setNewData(items);
	    productLookup.setPaginationData(page);
	    productLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    productLookup.hideLoadingOverlay();
	    setExportData(productLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var items = data.lookupItems.content;
	    var page = data.lookupItems.page;
	    productLookup.removeSavedView(data.target);
	    productLookup.setNewData(items);
	    productLookup.setPaginationData(page);
	    productLookup.hideLoadingOverlay();
	    setExportData(productLookup.generateData());
	  }
	
	  function errorFun(data) {
	    productLookup.hideLoadingOverlay();
	  }
	
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    if (!editPermission) {
	      statusTarget = []; //make empty
	    }
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  };
	
	  function renderActionHeaderWrap() {
	    var statusTarget = actionList['all'];
	    if (!editPermission) {
	      statusTarget = []; //make empty
	    }
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  };
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, item));
	    });
	    return renderedList.join('');
	  };
	
	  function neededActions(data, row, item) {
	    var action = {};
	    if (item.title === 'Activate/Deactivate') {
	      if (data === "Active") {
	        action = {
	          icon: 'toggle-off',
	          title: 'Deactivate',
	          cls: "deactivate-product",
	          disabled: false
	        };
	      } else {
	        action = {
	          icon: 'toggle-on',
	          title: 'Activate',
	          cls: "activate-product",
	          disabled: false
	        };
	      }
	    } else if (item.title === 'Duplicate') {
	      if (row.product != null && row.product.prdHazardMaterial) {
	        action = {
	          icon: 'clone',
	          title: 'Duplicate',
	          cls: "",
	          disabled: true
	        };
	      } else {
	        action = {
	          icon: 'clone',
	          title: 'Duplicate',
	          cls: "duplicate-product",
	          disabled: false
	        };
	      }
	    } else if (item.title === 'Activate Selected Products') {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: checkDisableForGivenAction(data, row, item.title)
	      };
	    } else if (item.title === 'Deactivate Selected Products') {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: checkDisableForGivenAction(data, row, item.title)
	      };
	    } else {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: item.disabled
	      };
	    }
	    return action;
	  }
	
	  function checkDisableForGivenAction(data, row, actionName) {
	    var isTrue = false;
	    _(selectedRows).map(function (item) {
	      if (callBusinessLogicToDisableAction(item.data.itmStatus, item.data, actionName)) {
	        if (!isTrue) {
	          isTrue = true;
	        }
	      }
	    });
	    return isTrue;
	  };
	
	  function callBusinessLogicToDisableAction(data, row, actionName) {
	    if (editPermission && (0, _general.isPresent)(data)) {
	      if (actionName === "Activate Selected Products") {
	        if (data === "Active") {
	          return true;
	        } else {
	          return false;
	        }
	      } else if (actionName === "Deactivate Selected Products") {
	        if (data === "Inactive") {
	          return true;
	        } else {
	          return false;
	        }
	      }
	    }
	  }
	
	  $('body').on('click', '.edit-product', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = table.row(parent);
	    var item = row.data();
	    var productdType = item.product.prdType;
	    if (productdType != 'undefined' && productdType != null && productdType != 'null') {
	      if (productdType.toLowerCase() == "bundle") {
	        location.href = addUpdateBundleURL + '&' + portletNamespace + 'itemId=' + item.itmId;
	      } else if (productdType.toLowerCase() == "collateral") {
	        location.href = addUpdateCollateralURL + '&' + portletNamespace + 'itemId=' + item.itmId;
	      } else {
	        location.href = editItemRenderUrl + '&' + portletNamespace + 'itemId=' + item.itmId;
	      }
	    } else {
	      location.href = editItemRenderUrl + '&' + portletNamespace + 'itemId=' + item.itmId;
	    }
	  });
	
	  $('body').on('click', '.duplicate-product', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = table.row(parent);
	    var item = row.data();
	    var productdType = item.product.prdType;
	    if (productdType != 'undefined' && productdType != null && productdType != 'null') {
	      if (productdType.toLowerCase() == "bundle") {
	        location.href = duplicateBundleRenderUrl + '&' + portletNamespace + 'itemId=' + item.itmId;
	      } else if (productdType.toLowerCase() == "collateral") {
	        location.href = duplicateCollateralRenderUrl + '&' + portletNamespace + 'itemId=' + item.itmId;
	      } else {
	        location.href = duplicateProductRenderUrl + '&' + portletNamespace + 'itemId=' + item.itmId;
	      }
	    } else {
	      location.href = duplicateProductRenderUrl + '&' + portletNamespace + 'itemId=' + item.itmId;
	    }
	  });
	
	  $('body').on('click', '.deactivate-product', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = table.row(parent);
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Deactivate Product',
	      confirmModalBody: '<div class="q-pad-all-xl">Once this product is deactivated, orders containing this product won’t be fulfilled and this product cannot be added to inbound shipments.</div>',
	      confirmModalBtnText: 'Deactivate Product',
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        deleteProduct(row, row.data());
	        function deleteProduct(row, item) {
	          $.ajax({
	            url: deleteItemUrl,
	            type: 'POST',
	            dataType: 'JSON',
	            data: _defineProperty({}, portletNamespace + 'itemId', item.itmId),
	            success: function success(data) {
	              if (data.response == "success") {
	                var d = row.data();
	                d.itmSku = $.trim(data.itmSku);
	                d.itemAttributes = $.trim(data.itemAttributes);
	                d.itmActive = data.itmActive;
	                d.itmStatus = $.trim(data.itmStatus);
	                row.data(d).draw();
	                submitModalFlow.showSuccessModal();
	                setTimeout(function () {
	                  submitModalFlow.hideAllModals();
	                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	              } else {
	                submitModalFlow.showFailureModal();
	              }
	            },
	            error: function error(data) {
	              submitModalFlow.hideAllModals();
	            }
	          });
	        };
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  });
	
	  $('body').on('click', '.activate-product', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = table.row(parent);
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Activate Product',
	      confirmModalBody: '<div class="q-pad-all-xl">Once this product is activated, orders can be fulfilled with this product and inbound shipments can contain this product.</div>',
	      confirmModalBtnText: 'Activate Product',
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        activateProduct(row, row.data());
	        function activateProduct(row, item) {
	          $.ajax({
	            url: activateItemUrl,
	            type: 'POST',
	            dataType: 'JSON',
	            data: _defineProperty({}, portletNamespace + 'itemId', item.itmId),
	            success: function success(data) {
	              if (data.response == "success") {
	                var d = row.data();
	                d.itmSku = $.trim(data.itmSku);
	                d.itemAttributes = $.trim(data.itemAttributes);
	                d.itmActive = data.itmActive;
	                d.itmStatus = $.trim(data.itmStatus);
	                row.data(d).draw();
	                submitModalFlow.showSuccessModal();
	                setTimeout(function () {
	                  submitModalFlow.hideAllModals();
	                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	              } else {
	                submitModalFlow.showFailureModal();
	              }
	            },
	            error: function error(data) {
	              submitModalFlow.hideAllModals();
	            }
	          });
	        };
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  });
	
	  $('body').on('click', '.bulk-activate-product', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: 'Activate Products',
	        confirmModalBody: '<div class="q-pad-all-xl">Once these products are activated, orders can be fulfilled with these products and inbound shipments can contain these products.</div>',
	        confirmModalBtnText: 'Activate Products',
	        onConfirmClick: function onConfirmClick() {
	          submitModalFlow.showLoadingModal();
	          activateProducts();
	          function activateProducts() {
	            $.ajax({
	              url: bulkActivateItemsUrl,
	              type: 'POST',
	              dataType: 'JSON',
	              data: _defineProperty({}, portletNamespace + 'itemIds', getAllSelectedItemIds()),
	              success: function success(data) {
	                if (data.response == "success") {
	                  _(selectedRows).map(function (item) {
	                    var currentRow = table.row(item.rowIndex);
	                    var d = currentRow.data();
	                    d.itmActive = true;
	                    d.itmStatus = "Active";
	                    d.itmArchived = false;
	                    currentRow.data(d).draw();
	                  });
	                  productLookup.uncheckAllSelected();
	                  submitModalFlow.showSuccessModal();
	                  setTimeout(function () {
	                    submitModalFlow.hideAllModals();
	                  }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                } else {
	                  submitModalFlow.showFailureModal();
	                }
	              },
	              error: function error(data) {
	                submitModalFlow.hideAllModals();
	              }
	            });
	          }
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  });
	
	  $('body').on('click', '.bulk-deactivate-product', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: 'Deactivate Products',
	        confirmModalBody: '<div class="q-pad-all-xl">Once these products are deactivated, orders containing these products won’t be fulfilled and these products cannot be added to inbound shipments.</div>',
	        confirmModalBtnText: 'Deactivate Products',
	        onConfirmClick: function onConfirmClick() {
	          submitModalFlow.showLoadingModal();
	          deactivateProducts();
	          function deactivateProducts() {
	            $.ajax({
	              url: bulkDeactivateItemsUrl,
	              type: 'POST',
	              dataType: 'JSON',
	              data: _defineProperty({}, portletNamespace + 'itemIds', getAllSelectedItemIds()),
	              success: function success(data) {
	                if (data.response == "success") {
	                  _(selectedRows).map(function (item) {
	                    var currentRow = table.row(item.rowIndex);
	                    var d = currentRow.data();
	                    d.itmActive = false;
	                    d.itmStatus = "Inactive";
	                    d.itmArchived = true;
	                    currentRow.data(d).draw();
	                  });
	                  productLookup.uncheckAllSelected();
	                  submitModalFlow.showSuccessModal();
	                  setTimeout(function () {
	                    submitModalFlow.hideAllModals();
	                  }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                } else {
	                  submitModalFlow.showFailureModal();
	                }
	              },
	              error: function error(data) {
	                submitModalFlow.hideAllModals();
	              }
	            });
	          }
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  });
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  function getAllSelectedItemIds() {
	    var itemIds = new Array();
	    _(selectedRows).map(function (item) {
	      itemIds.push(item.data.itmId);
	    });
	    return itemIds;
	  }
	
	  function initExport() {
	    var exportObj = {
	      title: 'Export Product Catalog',
	      exportAttemptTextPart1Lang: 'You\'re attempting to export',
	      exportAttemptTextPart2Lang: 'row(s). Please select a file format below.',
	      exportMaxLimitLang: 'A maximum of 1000 rows can be exported.'
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent();
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(generateExportUrl, currentData);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  initExport();
	  setExportData(productLookup.generateData());
	
	  // Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information;
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	// Live form from jsp
	(0, _run2.default)("#create-bundle-form, #bundle-detail", function () {
	  var el = $("#create-bundle-form");
	  attachWizard(el);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  _EditChecker2.default.bindNavigation();
	  _EditChecker2.default.bindChangeListener("#create-bundle-form");
	  _EditChecker2.default.bindCancelButton(".bundle-cancel-btn");
	}
	
	function attachWizard(el) {
	  var typeAheadItems = el.data("type-ahead-items");
	  var submitBundleURL = el.data("submit-bundle-url");
	  var submitModalTitleTxt = el.data("submit-modal-title-txt");
	  var submitModalBodyTxt = el.data("submit-modal-body-txt");
	  var submitModalBtnTxt = el.data("submit-modal-btn-txt");
	  var editModalTitleTxt = el.data("edit-modal-title-txt");
	  var editModalBodyTxt = el.data("edit-modal-body-txt");
	  var skuCheckUrl = el.data("validate-sku-url");
	  var duplicateSkuMessage = el.data("duplicate-sku-error-message");
	  var portletNamespace = el.data("namespace");
	  var items = el.data("items");
	  var form = el;
	  isDup();
	  isEdit();
	  shouldEnableSubmit();
	
	  function isDup() {
	    var dupFlag = el.data("isdup");
	    if (dupFlag) {
	      var catId = el.data("product-cat-id");
	      el.find("#bundle-category").val(catId).trigger("change");
	    }
	  }
	
	  function isEdit() {
	
	    var kitItems = el.data("kit-items");
	    if (kitItems) {
	      for (var i = 0; i < kitItems.length; i++) {
	        addProducts(kitItems[i].kitChildItmSku, kitItems[i].prdName, kitItems[i].kitId, kitItems[i].kitChildItmQty);
	      }
	      var existingItemId = el.data("existing-item-id");
	
	      var productId = el.data("product-id");
	
	      var catId = el.data("product-cat-id");
	
	      if (existingItemId) {
	        el.find("#bundle-category").val(catId).trigger("change");
	        el.find("#budnle-itmId").val(existingItemId);
	        el.find("#budnle-prdId").val(productId);
	      }
	    }
	  }
	
	  form.on("blur", ".bundle-sku-name", validateDuplicateBundle);
	  form.on("change", "#bundle-category", shouldEnableSubmit);
	
	  function validateDuplicateBundle() {
	    var skuVal = el.find(".bundle-sku-name").val();
	    $.ajax({
	      async: false,
	      data: _defineProperty({}, 'sku', skuVal),
	      url: skuCheckUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        if (data == true) {
	          el.find('.dup-sku').hide();
	        } else {
	          el.find('.dup-sku').show();
	        }
	      }
	    });
	  }
	
	  function removeRow() {
	    $($(this).closest("tr")).remove();
	    shouldEnableSubmit();
	    shouldEnableMessageOnPage();
	  }
	
	  var select2AjaxDefaults = {
	    dataType: 'json',
	    delay: 250,
	    processResults: function processResults(data, params) {
	      params.page = params.page || 1;
	      return {
	        results: data.items,
	        pagination: {
	          more: params.page * 20 < data.total_count
	        }
	      };
	    },
	    cache: true
	  };
	
	  var typeAhead = $('.product-name-typeahead');
	  typeAhead.select2({
	    placeholder: "Type product name (SKU)",
	    allowClear: true,
	    ajax: _extends({}, select2AjaxDefaults, {
	      url: el.data("get-product-names-and-items-url"),
	      cache: false,
	      data: configureDataCallback({
	        paramKey: 'likeSku'
	      })
	    }),
	    minimumInputLength: 3
	  });
	
	  typeAhead.on("select2:select", function (e) {
	    var res = e.params.data.text.split("--");
	    addProducts(res[0], res[1], null, null);
	    typeAhead.typeahead('val', '');
	    shouldEnableSubmit();
	    typeAhead.val(null).trigger('change');
	  });
	
	  function configureDataCallback(_ref) {
	    var paramKey = _ref.paramKey;
	
	    return function (params) {
	      return _defineProperty({}, paramKey, params.term);
	    };
	  }
	
	  /*typeAhead.typeahead(null, {
	    name: 'typeAheadItemsJSON',
	    limit: 5,
	    source: substringMatcher(typeAheadItems)
	  }).on('typeahead:selected', function() {
	    const str = this.value;
	    const res = str.split("--");
	    addProducts(res[0],res[1],null,null);
	    typeAhead.typeahead('val', '');
	    shouldEnableSubmit();
	  });*/
	
	  function shouldEnableMessageOnPage() {
	    var numberOfQauntity = $(".bundle-quantity").length;
	    if (numberOfQauntity == 0) {
	      $("#selected-prd-table").hide();
	      $("#no-prd-selected-text").show();
	    }
	  }
	
	  function shouldEnableSubmit() {
	
	    var skuValid = !form.find('.dup-sku').is(':visible');
	    if (skuValid == false) {
	      $(".bundle-submit-btn").addClass("disabled");
	      $(".edit-bundle").addClass("disabled");
	      return false;
	    }
	
	    var bundleCat = $("#bundle-category").val();
	    if (!bundleCat) {
	      $(".bundle-submit-btn").addClass("disabled");
	      $(".edit-bundle").addClass("disabled");
	      return false;
	    }
	
	    var numberOfQauntity = $(".bundle-quantity").length;
	    if (numberOfQauntity == 0) {
	      $(".bundle-submit-btn").addClass("disabled");
	      $(".edit-bundle").addClass("disabled");
	      return false;
	    } else if (numberOfQauntity == 1) {
	      var valueOfQauntity = $(".bundle-quantity").val();
	      if (valueOfQauntity != "" && valueOfQauntity != "1") {
	        $(".bundle-submit-btn").removeClass("disabled");
	        $(".edit-bundle").removeClass("disabled");
	        return true;
	      } else {
	        $(".bundle-submit-btn").addClass("disabled");
	        $(".edit-bundle").addClass("disabled");
	        return false;
	      }
	    } else if (numberOfQauntity > 1) {
	      $(".bundle-submit-btn").removeClass("disabled");
	      $(".edit-bundle").removeClass("disabled");
	      return true;
	    }
	  }
	
	  $('#budnle-listOfProducts').dataTable({
	    select: {
	      style: 'os',
	      selector: 'td:first-child'
	    },
	    data: items,
	    "bPaginate": false,
	    "order": [[1, "asc"]],
	    columns: [{ data: "itmId", "orderable": false,
	      render: function render(data, type, row) {
	        if (type === 'display') {
	          var html = '<div class="checkbox checkbox-success cb-large">' + '<input type="checkbox" id="itmId-' + row.itmId + '" value="option1" checked="" name="prod2" />' + '<label for="itmId-' + row.itmId + '"></label>' + '</div>';
	          return html;
	        }
	        return data;
	      },
	      className: "select-checkbox", width: "45px" }, { data: "itmSku", "class": "details-control", width: "126px" }, { data: "prdName", "class": "details-control" }]
	
	  });
	
	  function setQuantityVal(kitChildItmQty) {
	    if (kitChildItmQty != null) {
	      return kitChildItmQty;
	    } else {
	      return "1";
	    }
	  }
	
	  function addProducts(itemSku, prdName, kitId, kitChildItmQty) {
	    $("#selected-prd-table").show();
	    $("#no-prd-selected-text").hide();
	    var highestId = parseInt($("#bundle-prd-table tbody tr:last").attr("id"));
	    if (isNaN(highestId)) {
	      highestId = 0;
	    } else {
	      ++highestId;
	    }
	
	    $("#bundle-prd-table").find('tbody').append($('<tr id=' + highestId + ' class="product-item">').append($('<td class="vert-middle">').append($('<input type="number">').attr('id', portletNamespace + 'quantity_row_' + highestId).attr('name', portletNamespace + 'quantity' + '_row_' + highestId).attr('min', '1').attr('class', 'form-control required q-input text-center products-tab-quantity-input bundle-quantity').attr('placeholder', "Quantity").attr('value', setQuantityVal(kitChildItmQty)).on("change", shouldEnableSubmit)).append($('<input type="hidden">').attr('name', portletNamespace + 'prodTabSku').attr('value', itemSku + "_row_" + highestId)).append($('<input type="hidden">').attr('name', portletNamespace + 'kitId' + '_row_' + highestId).attr('value', kitId))).append($('<td class="vert-middle">').append($('<span class="text-purple products-tab-product-name">').attr('id', itemSku + '_row_' + highestId).text(itemSku)).append($('<input type="hidden">').attr('name', portletNamespace + 'itemSku' + '_row_' + highestId).attr('value', itemSku))).append($('<td class="vert-middle">').append($('<span class="products-tab-product-description">').attr('name', portletNamespace + 'prodDescription').attr('id', portletNamespace + 'prodDescription_row_' + highestId).text(prdName)).append($('<input type="hidden">').attr('name', portletNamespace + 'prodTabProdDescription' + '_row_' + highestId).attr('value', prdName))).append($('<td class="text-center vert-middle">').append($('<span>').attr('id', 'delete_row' + highestId).attr('class', 'icon-remove').attr('style', 'cursor: pointer;').on('click', removeRow))));
	    $("#" + portletNamespace + "products-list").val("");
	  }
	
	  function substringMatcher(strs) {
	    return function findMatches(q, cb) {
	      var matches = void 0,
	          substringRegex = void 0;
	      // an array that will be populated with substring matches
	      matches = [];
	
	      // regex used to determine if a string contains the substring `q`
	      substringRegex = new RegExp(q, 'i');
	
	      // iterate through the pool of strings and for any string that
	      // contains the substring `q`, add it to the `matches` array
	      $.each(strs, function (i, str) {
	        if (substringRegex.test(str)) {
	          matches.push(str);
	        }
	      });
	      cb(matches);
	    };
	  }
	
	  $('#bundle-addProductsLink').click(function () {
	    $("#bundle-listOfProductsModal").modal("show");
	  });
	
	  $('#checkall').click(function () {
	    if ($(this).is(':checked')) {
	      $('#bundle-listOfProductsModal div input').prop('checked', true);
	    } else {
	      $('#bundle-listOfProductsModal div input').prop('checked', false);
	    }
	  });
	
	  $('#bundle-addProductsLink').click(function () {
	    $('#bundle-listOfProductsModal div input').prop('checked', false);
	    $('#bundle-listOfProductsModal #checkall').prop('checked', false);
	    $('#bundle-numberSelected').html("<p><b>0 Products Selected</b></p>");
	  });
	
	  $('#budnle-listOfProducts').mousemove(function () {
	    var selectCount = document.querySelectorAll('#bundle-listOfProductsModal input[type="checkbox"]:checked').length - $('#checkall:checked').length;
	    $('#bundle-numberSelected').html("<p><b>" + selectCount + " Products Selected</b></p>");
	  });
	
	  $('#bundle-add-product-select-btn').click(function () {
	
	    var skus = $('#bundle-listOfProductsModal table tr td :checkbox:checked').map(function () {
	      return $(this).closest('tr').find("td").eq(2).text();
	    }).get();
	
	    var productNames = $('#bundle-listOfProductsModal table tr td :checkbox:checked').map(function () {
	      return $(this).closest('tr').find("td").eq(1).text();
	    }).get();
	
	    for (var i = 0; i < skus.length; i++) {
	      addProducts(productNames[i], skus[i], null, null);
	    }
	
	    shouldEnableSubmit();
	  });
	
	  $('.edit-bundle').click(function (e) {
	    e.preventDefault();
	    submitBundle(editModalTitleTxt, editModalBodyTxt);
	  });
	
	  $(document).on("click", ".bundle-submit-btn", function (e) {
	    e.preventDefault();
	    submitBundle(submitModalTitleTxt, submitModalBodyTxt);
	  });
	
	  function submitBundle(title, body) {
	    if (!shouldEnableSubmit() || !form.valid()) {
	      return false;
	    }
	    var submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: title,
	      confirmModalBody: '<div class="q-pad-all-xl">' + body + '</div>',
	      confirmModalBtnText: submitModalBtnTxt,
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        saveNow();
	
	        function saveNow() {
	          $.ajax({
	            data: $('#create-bundle-form').serialize(),
	            url: submitBundleURL,
	            dataType: "JSON",
	            type: 'POST',
	            success: submitBundleSucess,
	            error: submitBundleError
	          });
	        }
	
	        function submitBundleSucess() {
	          _EditChecker2.default.setPageClean();
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.href = $('#create-bundle-form').data('view-product-lookup-page-url');
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	
	        function submitBundleError() {
	          submitModalFlow.hideAllModals();
	        }
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  }
	}

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _CollateralDetailsTab = __webpack_require__(728);
	
	var _CollateralDetailsTab2 = _interopRequireDefault(_CollateralDetailsTab);
	
	var _CollateralReviewTab = __webpack_require__(729);
	
	var _CollateralReviewTab2 = _interopRequireDefault(_CollateralReviewTab);
	
	var _CollateralRulesTab = __webpack_require__(730);
	
	var _CollateralRulesTab2 = _interopRequireDefault(_CollateralRulesTab);
	
	var _jumpToWizardLogic = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	// Live form from jsp
	(0, _run2.default)("#new-collateral-wizard", function () {
	  var el = $("#new-collateral-wizard");
	  attachWizard(el);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  EditChecker.bindNavigation();
	  EditChecker.bindChangeListener("#new-collateral-wizard");
	  EditChecker.bindCancelButton(".collateral-cancel-btn");
	}
	
	function attachWizard(el) {
	  var namespace = el.data('namespace');
	  var validSkuUrl = el.data('validate-sku-url');
	  var collateralNameStr = [namespace + 'collateralName'];
	
	  var validator = el.validate({
	    // onkeyup: false,
	    //   onfocusout: false,
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	    // rules: {
	    // 	[collateralNameStr]: {
	    // 		remote: {
	    // 			url: validSkuUrl,
	    // 			type: "post",
	    // 			data: {
	    // 				[collateralNameStr]: function() {
	    // 					return $(`#${collateralNameStr}`).val();
	    // 				}
	    // 			}
	    // 		}
	    // 	}
	    // },
	    // messages:{
	    // 	[collateralNameStr]: {
	    // 		remote: '<liferay-ui:message key="product-duplicate-sku-error-message"/>'
	    // 	}
	    // }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  // create a cache to prevent round-trips to server
	  var quickWizard = new _QuickWizard2.default(el, {
	    tabletWidthNavStep: 844,
	    mobileWidthNavStep: 502,
	    customRules: _defineProperty({}, '#' + collateralNameStr, {
	      errorMessageSelector: "#collateral-duplicate-sku-error-message",
	      isValid: function isValid(_ref) {
	        var input = _ref.input,
	            done = _ref.done;
	
	        var curVal = input.val();
	        // check cache to see if it's busted
	        if (curVal !== skuValAtLastValidation) {
	          $.post(validSkuUrl, _defineProperty({}, collateralNameStr, curVal), function (data) {
	            // set cache to last-validated-value
	            skuValAtLastValidation = curVal;
	            if (data === "true") {
	              console.log("server validation returned: 'true'");
	              prevSkuErrorRes = true;
	              done(true, { displayErrors: true });
	            } else {
	              prevSkuErrorRes = false;
	              console.log("server validation returned: not true");
	              done(false, { displayErrors: true });
	            }
	          });
	          return done;
	        }
	        console.log("sku cache is same");
	        return prevSkuErrorRes;
	      }
	    }),
	
	    shouldNavigateToForm: function shouldNavigateToForm(_ref2) {
	      var targetForm = _ref2.targetForm,
	          direction = _ref2.direction,
	          currentForm = _ref2.currentForm,
	          done = _ref2.done;
	
	      var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	
	      quickWizard.areInputsValid(allPrevInputs, {
	        displayErrors: true,
	        validationsComplete: function validationsComplete(isValid) {
	          if (!isValid) {
	            quickWizard.goToFirstIncompleteForm();
	          }
	          // manually call done when
	          // ajax is done
	          done(isValid);
	        }
	      });
	
	      return done;
	    },
	    didNavigateToForm: function didNavigateToForm(_ref3) {
	      var currentForm = _ref3.currentForm;
	
	      //rulesConfigPanel.hide();
	      if (currentForm.filter(".collateral-rules-tab").length) {
	        collateralRulesTab.didNavigateToForm();
	      } else if (currentForm.filter('.collateral-review-tab').length) {
	        collateralReviewTab.didNavigateToForm();
	      }
	    }
	  });
	
	  quickWizard.init();
	
	  /*Removed for EditChecker above
	  $(document).on("click", ".collateral-cancel-btn", function(e){
	  $("#collateral-cancel-modal").modal("show");
	    });
	    */
	
	  var collateralDetailsTab = new _CollateralDetailsTab2.default(quickWizard);
	  collateralDetailsTab.init();
	
	  var collateralReviewTab = new _CollateralReviewTab2.default(quickWizard);
	  collateralReviewTab.init();
	
	  var collateralRulesTab = new _CollateralRulesTab2.default(quickWizard);
	  collateralRulesTab.init();
	
	  var skuValAtLastValidation = $('#' + collateralNameStr).val();
	  var prevSkuErrorRes = true;
	
	  (0, _jumpToWizardLogic.handleQueryParamTraversalToWizardTab)(quickWizard);
	}

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(744);
	
	__webpack_require__(741);
	
	__webpack_require__(740);

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(1098);
	
	var targetSelector = "#searchShipment";
	
	(0, _run2.default)(targetSelector, function () {
	  var $ = __webpack_require__(1);
	  var search_url = $(targetSelector).data("search-url");
	  var errorflag = $(targetSelector).data("errorflag");
	  var status = $(targetSelector).data("status");
	  var carrier = $(targetSelector).data("carrier");
	  var shipper = $(targetSelector).data("shipper");
	  var country = $(targetSelector).data("country");
	  var model_data = $(targetSelector).data("model");
	  var result_size = $(targetSelector).data("result-size");
	
	  var elementsMap = {
	    advancedSearchBtn: ".advanced-search-btn",
	    shpCarrier: "#shpCarrier",
	    shpStatus: "#shpStatus",
	    ShipperOptions: "#shpMerchantBuId",
	    shpShipToCountry: "#shpShipToCountry"
	  };
	
	  var els = {};
	
	  var entryEl = $("<div class='entry-point'></div>");
	
	  var mainHtml = (0, _render2.default)(__webpack_require__(1391));
	
	  var mainEl = $(mainHtml);
	  $(targetSelector).html(entryEl);
	  entryEl.append(mainEl);
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  function init() {
	    setElements();
	    generateDatePickers();
	    loadDropDowns();
	    setValues();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	  }
	
	  function generateDatePickers() {
	
	    var date = new Date();
	    var shipFromDate = $("#shpShipFromDate");
	    var shipToDate = $("#shpShipToDate");
	    var dueFromDate = $("#shpDueFromDate");
	    var dueToDate = $("#shpDueToDate");
	
	    shipFromDate.datepicker({
	      endDate: date,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	
	    shipToDate.datepicker({
	      endDate: date,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	
	    dueFromDate.datepicker({
	      endDate: date,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	
	    dueToDate.datepicker({
	      endDate: date,
	      todayBtn: "linked",
	      keyboardNavigation: false,
	      autoclose: true
	    });
	  }
	  function loadDropDowns() {
	    var shpCarrier = carrier.map(function (val) {
	      return $("<option></option>").html(val.carrier);
	    });
	    els.shpCarrier.append(shpCarrier);
	
	    var shpStatus = status.map(function (val) {
	      return $("<option></option>").html(val.status);
	    });
	    els.shpStatus.append(shpStatus);
	
	    var ShipperOptions = shipper.map(function (val) {
	      return $("<option></option>").html(val.shipper);
	    });
	    els.ShipperOptions.append(ShipperOptions);
	
	    var shpShipToCountry = country.map(function (val) {
	      return $("<option></option>").html(val.conCode);
	    });
	    els.shpShipToCountry.append(shpShipToCountry);
	  }
	
	  function setValues() {}
	
	  $(targetSelector).validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  });
	
	  $("#searchBtn").on("click", function () {
	    if ($("#shpShipFromDate").val() !== "" && $("#shpShipToDate").val() === "") {
	      if ($(targetSelector).valid()) {
	        var sendShipToDate = (0, _moment2.default)(new Date()).format("MM/DD/YYYY");
	        $("#shpShipToDate").val(sendShipToDate);
	        $(targetSelector).submit();
	        submitModalFlow.showLoadingModal();
	      }
	    } else if ($("#shpShipFromDate").val() === "" && $("#shpShipToDate").val() !== "") {
	      if ($(targetSelector).valid()) {
	        var sendShipFromDate = (0, _moment2.default)($("#shpShipToDate").val()).subtract(1, 'months').format("MM/DD/YYYY");
	        $("#shpShipFromDate").val(sendShipFromDate);
	        $(targetSelector).submit();
	        submitModalFlow.showLoadingModal();
	      }
	    } else if ($("#shpDueFromDate").val() !== "" && $("#shpDueToDate").val() === "") {
	      if ($(targetSelector).valid()) {
	        var sendDueToDate = (0, _moment2.default)(new Date()).format("MM/DD/YYYY");
	        $("#shpDueToDate").val(sendDueToDate);
	        $(targetSelector).submit();
	        submitModalFlow.showLoadingModal();
	      }
	    } else if ($("#shpDueFromDate").val() === "" && $("#shpDueToDate").val() !== "") {
	      if ($(targetSelector).valid()) {
	        var sendDueFromDate = (0, _moment2.default)($("#shpDueToDate").val()).subtract(1, 'months').format("MM/DD/YYYY");
	        $("#shpDueFromDate").val(sendDueFromDate);
	        $(targetSelector).submit();
	        submitModalFlow.showLoadingModal();
	      }
	    } else {
	      if ($(targetSelector).valid()) {
	        $(targetSelector).submit();
	        submitModalFlow.showLoadingModal();
	      }
	    }
	  });
	
	  //Error message Loading
	  if (result_size == 0 && errorflag) {
	    var ErrorHtml = __webpack_require__(1390);
	    $("#errordisplay").html((0, _render2.default)(ErrorHtml));
	  }
	
	  init();
	});

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _general = __webpack_require__(5);
	
	var _constants = __webpack_require__(10);
	
	var _index = __webpack_require__(96);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var targetSelector = "#packageDetailsForm";
	
	(0, _run2.default)(targetSelector, function () {
	    var sharedModalHtml = __webpack_require__(11);
	    var statusHistoryRowTemplate = __webpack_require__(1400);
	    var statusRowTemplate = __webpack_require__(1401);
	    var shipmentDetailsRowTemplate = __webpack_require__(1397);
	    var shippingDocSectionRowTemplate = __webpack_require__(1399);
	    var shippingDocFileNameRowTemplate = __webpack_require__(1393);
	    var deliveryDetailsRowTemplate = __webpack_require__(1392);
	    var modalOrderBody = __webpack_require__(1395);
	    var shipmentHistoryMissingTemplate = __webpack_require__(1398);
	    var fileNameRowMissingTemplate = __webpack_require__(1394);
	    var uploadShippingDocsModalBodyHtml = __webpack_require__(1402);
	    var modalHtml = __webpack_require__(11);
	
	    var goToSummaryPageURL = $(targetSelector).data("search-summary-by-oder-url");
	    var backToList = $(targetSelector).data("back-to-list");
	    var backTosearch = $(targetSelector).data("back-to-search");
	    var userRoles = $(targetSelector).data("user-roles");
	    var getShippingDocuments = $(targetSelector).data("pod-url");
	    var uploadFileUrl = $(targetSelector).data("upload-file-url");
	
	    var elementsMap = {
	        orderIdNumberBtn: ".order-id-number"
	    };
	    var elementsMapModal = {
	        goToSummaryPageBtn: ".go-to-summary-btn"
	    };
	
	    var packageDetailsForm = $(targetSelector).data("package-details");
	    var flag = $(targetSelector).data("flag");
	    var packageCount = $(targetSelector).data("package-count");
	    var shpDocDetails = $(targetSelector).data("shipping-doc-details");
	    var downloadFileByDocIdUrl = $(targetSelector).data("download-by-doc-url");
	    var downloadFileUrl = $(targetSelector).data("download-file-url");
	    var deleteFileByDocIdUrl = $(targetSelector).data("delete-by-doc-url");
	    var frightFlag = $(targetSelector).data("fright-flag");
	    var facilityNo = packageDetailsForm.merchantBuId;
	    var wmOrderNo = packageDetailsForm.shipment[0].OrderId;
	
	    var orderIdNumberModal = void 0;
	    var dummyData = null;
	    var shipmentDocsFileUploadModal = "";
	
	    var els = {};
	    var elsModal = {};
	    var mainEl = $((0, _render2.default)(__webpack_require__(1396), {
	        statusHistoryWrap: getStatusHistoryData(),
	        flag: flag,
	        shipDate: shipmentShipDate(),
	        trackingNumber: shipmentTrackingNumber(),
	        shipmentStatusrenderRow: shipmentStatusrenderRow(),
	        shipmentDetailsRow: shipmentDetailsRow(),
	        deliveryDetailsRow: deliveryDetailsRow(),
	        shippingDocSection: shippingDocSectionRow()
	    }));
	
	    $(targetSelector).append(mainEl);
	
	    var submitModalFlow = new _SubmitModalFlow2.default();
	    submitModalFlow.init();
	
	    function init() {
	        generateModals();
	        setElements();
	        setElementsInModals();
	        bindElements();
	        getStatusHistoryData();
	        shipmentStatusrenderRow();
	        shipmentDetailsRow();
	        deliveryDetailsRow();
	        shippingDocSectionRow();
	        shipmentTrackingNumber();
	        shipmentBol();
	        shipShipmentNumber();
	        shipperCarrier();
	        handleButtons();
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	    }
	
	    function setElementsInModals() {
	        (0, _selectorHelpers.setElementsFromScope)(elsModal, elementsMapModal, orderIdNumberModal);
	    }
	
	    function bindElements() {
	        els.orderIdNumberBtn.click((0, _general.createPreventDefault)(showOrderIdNumberModel));
	        elsModal.goToSummaryPageBtn.click((0, _general.createPreventDefault)(goToSummaryPage));
	    }
	
	    function handleButtons() {
	        if ((_underscore2.default.contains(userRoles, "POD Admin") || _underscore2.default.contains(userRoles, "POD User")) && !_underscore2.default.contains(userRoles, "System Admin")) {
	            $(".upload-shipping-doc-btn").attr('disabled', true);
	            $(".remove-doc-row-btn").hide();
	        } else {
	            $(".upload-shipping-doc-btn").attr('disabled', false);
	            $(".remove-doc-row-btn").show();
	        }
	    }
	
	    function shallAllowClick(currentObj) {
	        return !$(currentObj).hasClass("disabled");
	    }
	
	    $(".upload-shipping-doc-btn").on("click", function () {
	        generateSharedModal();
	    });
	
	    $("#podBtn").on("click", function () {
	        var url = getShippingDocuments + '&shipmentBOL=' + shipmentBol() + '&trackingNumber=' + shipmentTrackingNumber() + '\n          &shipperCarrier=' + shipperCarrier();
	        submitModalFlow.showLoadingModal();
	        $.ajax({
	            url: url,
	            type: 'POST',
	            dataType: "JSON",
	            data: "",
	            success: onSuccessDisplay,
	            error: onFailureDisplay
	        });
	    });
	
	    //Modal to display when no POD available.
	
	    var noPODAvailableErrorModal = $((0, _render2.default)(modalHtml, {
	        title: 'Proof Of Delivery',
	        leftAlignTitle: true,
	        body: '<div class="q-pad-all-xl">The signed Proof Of Delivery document is not available.</div>',
	        topCloseBtn: true,
	        autoHideTop: true,
	        footerBtns: '\n            <a href="#" class="base-btn purple-btn modal-auto-hide">Close</a>\n          '
	    }));
	
	    function onSuccessDisplay(data) {
	        if (data.response === "Success") {
	            if (data.links.length > 0) {
	                var i = 1;
	                _underscore2.default.each(data.links, function (value) {
	                    window.open(value, 'document' + i);
	                    i++;
	                });
	            } else {
	                var blob = base64ToBlob(data.base64Pod, "pdf");
	                var url = window.URL.createObjectURL(blob);
	                window.open(url);
	            }
	            submitModalFlow.hideAllModals();
	        } else if (data.response === "Failure") {
	            submitModalFlow.showFailureModal();
	        } else {
	            //Display no POD popup window
	            noPODAvailableErrorModal.modal("show");
	            submitModalFlow.hideAllModals();
	        }
	    }
	
	    function onFailureDisplay(data) {
	        submitModalFlow.showFailureModal();
	    }
	
	    function generateModals() {
	        orderIdNumberModal = $((0, _render2.default)(sharedModalHtml, {
	            modalDialogClass: "q-modal-dialog-500",
	            title: 'Order ID Number',
	            leftAlignTitle: false,
	            body: (0, _render2.default)(modalOrderBody, {
	                shpPackageCount: packageCount
	            }),
	            topCloseBtn: true,
	            autoHideTop: true,
	            footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-deactivate-rule modal-auto-hide">Cancel</a>\n          <a href="#" class="base-btn purple-btn go-to-summary-btn">Go to Summary</a>'
	        }));
	        $("body").append(orderIdNumberModal);
	    }
	
	    function showOrderIdNumberModel() {
	        orderIdNumberModal.modal("show");
	    }
	
	    function goToSummaryPage() {
	        submitModalFlow.showLoadingModal();
	        orderIdNumberModal.modal("hide");
	        window.open(goToSummaryPageURL, "_self");
	    }
	
	    $('body').on('click', '.download-doc-row-btn', function (e) {
	        e.preventDefault();
	        var docId = $(this).closest('.download-doc-row-btn').data('document-id');
	        if (shallAllowClick(this)) {
	            downloadFiles([docId], 'downloadByDocId');
	        }
	    });
	
	    $('body').on('click', '.remove-doc-row-btn', function (e) {
	        e.preventDefault();
	        var docId = $(this).closest('.remove-doc-row-btn').data('document-id');
	        if (shallAllowClick(this)) {
	            deleteFileByDocId([docId, shipShipmentNumber(), shipmentTrackingNumber(), shipmentBol(), facilityNo, wmOrderNo]);
	        }
	    });
	
	    function deleteFileByDocId(item) {
	        var encodeDocId = encodeURIComponent(item[0]);
	        var deleteFileUri = deleteFileByDocIdUrl + '&documentId=' + encodeDocId + '&shpShipmentNumber=' + item[1] + '&shpTrackingNumber=' + item[2] + '&frightFlag=' + frightFlag + '&shpBol=' + item[3] + '&facilityNo=' + item[4] + '&wmOrderNo=' + item[5];
	        submitModalFlow.showLoadingModal();
	        $.ajax({
	            url: deleteFileUri,
	            type: 'POST',
	            enctype: 'multipart/form-data',
	            processData: false,
	            contentType: false,
	            cache: false,
	            success: deleteFileSuccess,
	            error: deleteFileError
	        });
	    }
	
	    function deleteFileSuccess(resp) {
	        if ($.trim(resp) == "true") {
	            submitModalFlow.showSuccessModal();
	            setTimeout(function () {
	                location.reload();
	            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        } else {
	            deleteFileError();
	        }
	    }
	
	    function deleteFileError() {
	        submitModalFlow.showFailureModal();
	        setTimeout(function () {
	            submitModalFlow.hideAllModals();
	            submitModalFlow.showFailureModal();
	        }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    }
	
	    $('body').on('click', '.download-shipping-doc-btn', function (e) {
	        e.preventDefault();
	        if (shallAllowClick(this)) {
	            if (shipmentTrackingNumber() == 'Not Available' && frightFlag == '1') {
	                downloadFiles([shipShipmentNumber(), shipmentBol()], 'downloadByShpInfo');
	            } else {
	                downloadFiles([shipShipmentNumber(), shipmentTrackingNumber()], 'downloadByShpInfo');
	            }
	        }
	    });
	
	    function downloadFiles(item, downloadSrc) {
	        var downloadFileUri = void 0;
	        var encodeDocId = void 0;
	        if (downloadSrc == 'downloadByDocId') {
	            encodeDocId = encodeURIComponent(item);
	            downloadFileUri = downloadFileByDocIdUrl + '&documentId=' + encodeDocId;
	        } else {
	            encodeDocId = encodeURIComponent(item[0]);
	            downloadFileUri = downloadFileUrl + '&shpShipmentNumber=' + encodeDocId + '&shpTrackingNumber=' + item[1] + '&frightFlag=' + frightFlag + '&facilityNo=' + facilityNo + '&wmOrderNo=' + wmOrderNo;
	        }
	
	        var formData = new FormData();
	        formData.append("shpShipmentRow", "");
	        submitModalFlow.showLoadingModal();
	        $.ajax({
	            url: downloadFileUri,
	            type: 'POST',
	            data: formData,
	            enctype: 'multipart/form-data',
	            processData: false,
	            contentType: false,
	            cache: false,
	            success: downloadFileSuccess,
	            error: downloadFileError
	        });
	    }
	
	    function downloadFileSuccess(data) {
	        if ((0, _general.isPresent)(data)) {
	            $.each(JSON.parse(data), function (key, value) {
	                if (value.contentType == "atd") {
	                    value.contentType = "txt";
	                }
	                downloadFile(value.contentType, value.fileName, value.content);
	            });
	        } else {
	            setTimeout(function () {
	                submitModalFlow.hideAllModals();
	                submitModalFlow.showFailureModal();
	            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	    }
	
	    function downloadFileError() {
	        submitModalFlow.showFailureModal();
	        setTimeout(function () {
	            submitModalFlow.hideAllModals();
	            submitModalFlow.showFailureModal();
	        }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    }
	
	    function downloadFile(mimeType, fileName, data) {
	        var a = document.createElement('a');
	        if (window.URL && window.Blob && 'download' in a && window.atob) {
	            // Do it the HTML5 compliant way
	            var blob = base64ToBlob(data, mimeType);
	            var url = window.URL.createObjectURL(blob);
	            a.href = url;
	            a.download = fileName;
	            a.click();
	            window.URL.revokeObjectURL(url);
	        }
	        submitModalFlow.hideAllModals();
	    }
	
	    function base64ToBlob(base64, mimetype, slicesize) {
	        if (!window.atob || !window.Uint8Array) {
	            // The current browser doesn't have the atob function. Cannot continue
	            return null;
	        }
	        mimetype = "application/" + mimetype || '';
	        slicesize = slicesize || 512;
	        var bytechars = atob(base64);
	        var bytearrays = [];
	        for (var offset = 0; offset < bytechars.length; offset += slicesize) {
	            var slice = bytechars.slice(offset, offset + slicesize);
	            var bytenums = new Array(slice.length);
	            for (var i = 0; i < slice.length; i++) {
	                bytenums[i] = slice.charCodeAt(i);
	            }
	            var bytearray = new Uint8Array(bytenums);
	            bytearrays[bytearrays.length] = bytearray;
	        }
	        return new Blob(bytearrays, { type: mimetype });
	    }
	
	    function getStatusHistoryData() {
	        var eventHistoryData = packageDetailsForm.shipment[0].evntHistory;
	        var statusHistoryArray = (0, _underscore2.default)(eventHistoryData).map(buildStatusHistoryRow).join("");
	        if ((0, _general.isPresent)(statusHistoryArray)) {
	            return statusHistoryArray;
	        } else {
	            return (0, _render2.default)(shipmentHistoryMissingTemplate, "");
	        }
	    }
	
	    function buildStatusHistoryRow(item) {
	        return (0, _render2.default)(statusHistoryRowTemplate, {
	            icon: getIcons(item.eventActivity),
	            statusColor: getStatusColor(item.eventActivity),
	            status: item.eventActivity,
	            date: (0, _moment2.default)(item.eventDate).format("MM/DD/YYYY hh:mm A"),
	            city: item.eventCity
	        });
	    }
	
	    function shipmentTrackingNumber() {
	        var shipmentData = packageDetailsForm.shipment;
	        if ((0, _general.isPresent)(shipmentData)) {
	            var shipmentTrackingNum = packageDetailsForm.shipment[0].trackingNumber;
	            return shipmentTrackingNum;
	        }
	    }
	
	    function shipmentBol() {
	        var shipmentData = packageDetailsForm.shipment;
	        if ((0, _general.isPresent)(shipmentData)) {
	            var _shipmentBol = packageDetailsForm.shipment[0].shipBol;
	            return _shipmentBol;
	        }
	    }
	
	    function shipShipmentNumber() {
	        var shipmentData = packageDetailsForm.shipment;
	        if ((0, _general.isPresent)(shipmentData)) {
	            var shipmentNumber = packageDetailsForm.shipment[0].shipShipmentNumber;
	            return shipmentNumber;
	        }
	    }
	
	    function shipperCarrier() {
	        var shipmentData = packageDetailsForm.shipment;
	        if ((0, _general.isPresent)(shipmentData)) {
	            var _shipperCarrier = packageDetailsForm.shipment[0].shipperCarrier;
	            return _shipperCarrier;
	        }
	    }
	
	    function shipmentShipDate() {
	        var shipmentData = packageDetailsForm.shipment;
	        if ((0, _general.isPresent)(shipmentData)) {
	            var shipDate = (0, _moment2.default)(packageDetailsForm.shipment[0].shipDate).format("MM/DD/YYYY hh:mm A");
	            return shipDate;
	        }
	    }
	
	    function shipmentStatusrenderRow() {
	        var shipmentStatusrenderData = packageDetailsForm.shipment;
	        if ((0, _general.isPresent)(shipmentStatusrenderData)) {
	            var shipmentStatusrenderArray = (0, _underscore2.default)(shipmentStatusrenderData).map(shipmentStatusrenderRowTemp);
	            return shipmentStatusrenderArray;
	        }
	    }
	
	    function getStatus(shipStatus) {
	        var str = new Array();
	        if (shipStatus == null) {
	            str[0] = "Voided";
	        } else if (shipStatus.startsWith("Delivered")) {
	            str = shipStatus.split("-");
	        } else {
	            str[0] = shipStatus;
	        }
	        return str;
	    }
	
	    function shipmentStatusrenderRowTemp(shipmentStatusdata) {
	        var str = getStatus(shipmentStatusdata.shpStatus);
	        var latestEventDate = "";
	
	        //Get the latest date from event history array.If not show shpmodifieddate else show shpcreateddate
	        if (!(shipmentStatusdata.evntHistory === undefined) && shipmentStatusdata.evntHistory.length > 0) {
	            latestEventDate = getLatestEventDateTime(shipmentStatusdata.evntHistory);
	        }
	        if ((0, _general.isBlank)(latestEventDate)) {
	            if (shipmentStatusdata.shipModifiedDate != null) {
	                latestEventDate = shipmentStatusdata.shipModifiedDate;
	            } else {
	                latestEventDate = shipmentStatusdata.shipCreatedDate;
	            }
	        }
	        return (0, _render2.default)(statusRowTemplate, {
	            icon: getIcons(str[0].trim()),
	            statusColor: getStatusColor(str[0].trim()),
	            status: str[0].trim(),
	            status2: str[1] != null ? str[1] : " ",
	            date: (0, _moment2.default)(latestEventDate).format("MM/DD/YYYY hh:mm A"),
	            city: shipmentStatusdata.recipientCity,
	            recipientName: shipmentStatusdata.recipientName,
	            podBtnStatus: str[0].trim() === "Delivered" ? '' : 'disabled'
	        });
	    }
	
	    function getLatestEvent(eventArray) {
	        return _underscore2.default.max(eventArray, function (eachEvent) {
	            return eachEvent.eventTime;
	        });
	    }
	
	    function getLatestEventDateTime(eventHistoryArray) {
	        var eventDateArray = [];
	        //Get each event date and prepare list
	        eventHistoryArray.forEach(function (element, index) {
	            eventDateArray.push(new Date(element.eventTime));
	        });
	
	        //return the latest datetime from the list
	        if (!(eventDateArray === undefined) && eventDateArray.length != 0) {
	            return _underscore2.default.max(eventDateArray);
	        }
	    }
	
	    function shipmentDetailsRow() {
	        var shipmentDetailsRowData = packageDetailsForm.shipment;
	        if ((0, _general.isPresent)(shipmentDetailsRowData)) {
	            var shipmentDetailsRowArray = (0, _underscore2.default)(shipmentDetailsRowData).map(shipmentDetailsRowTemp);
	            return shipmentDetailsRowArray;
	        }
	    }
	
	    function shipmentDetailsRowTemp(shpDetailsRow) {
	        return (0, _render2.default)(shipmentDetailsRowTemplate, {
	            trackingNumber: shpDetailsRow.trackingNumber,
	            shipperOrderId: shpDetailsRow.OrderId,
	            shpPackageCount: packageCount,
	            shipperCarrier: shpDetailsRow.shipperCarrier
	        });
	    }
	
	    function shippingDocSectionRow() {
	        return (0, _render2.default)(shippingDocSectionRowTemplate, {
	            fileNameArea: getShpDocFilesData()
	        });
	    }
	
	    function getShpDocFilesData() {
	        var shpDocFilesArray = (0, _underscore2.default)(shpDocDetails).map(buildShpDocFilesRow).join("");
	        if ((0, _general.isPresent)(shpDocFilesArray)) {
	            $(".download-shipping-doc-btn").removeClass('disabled');
	            return shpDocFilesArray;
	        } else {
	            $(".download-shipping-doc-btn").addClass('disabled');
	            return (0, _render2.default)(fileNameRowMissingTemplate, "");
	        }
	    }
	
	    function buildShpDocFilesRow(item) {
	        return (0, _render2.default)(shippingDocFileNameRowTemplate, {
	            fileName: item.fileName,
	            fileUploadDate: (0, _moment2.default)(item.uploadDate).format("MM/DD/YYYY hh:mm A"),
	            documentId: item.documentId
	        });
	    }
	
	    function deliveryDetailsRow() {
	        var deliveryDetailsRowData = packageDetailsForm.shipment;
	        if ((0, _general.isPresent)(deliveryDetailsRowData)) {
	            var deliveryDetailsRowArray = (0, _underscore2.default)(deliveryDetailsRowData).map(deliveryDetailsRowTemp);
	            return deliveryDetailsRowArray;
	        }
	    }
	
	    function deliveryDetailsRowTemp(delryDetailsRow) {
	        return (0, _render2.default)(deliveryDetailsRowTemplate, {
	            shipper: delryDetailsRow.shipper,
	            shipperName: delryDetailsRow.shipperName,
	            shipperAddressLine1: delryDetailsRow.shipperAddressLine1,
	            shipperAddressLine2: delryDetailsRow.shipperAddressLine2,
	            shipperCity: delryDetailsRow.shipperCity,
	            shipperState: delryDetailsRow.shipperState,
	            shipperCountry: delryDetailsRow.shipperCountry,
	            shipperPostalCode: delryDetailsRow.shipperPostalCode,
	            recipientName: delryDetailsRow.recipientName,
	            recipientAddressLine1: delryDetailsRow.recipientAddressLine1,
	            recipientAddressLine2: delryDetailsRow.recipientAddressLine2,
	            recipientCity: delryDetailsRow.recipientCity,
	            recipientState: delryDetailsRow.recipientState,
	            recipientCountry: delryDetailsRow.recipientCountry,
	            recipientPostalCode: delryDetailsRow.recipientPostalCode
	        });
	    }
	
	    function getIcons(shpStatus) {
	        if (shpStatus === "Delivered") {
	            return "check";
	        } else if (shpStatus === "Pre-Pickup") {
	            return "cube";
	        } else if (shpStatus === "InTransit") {
	            return "truck";
	        } else if (shpStatus === "Out for Delivery") {
	            return "truck";
	        } else if (shpStatus === "Voided") {
	            return "close";
	        } else if (shpStatus === "Shipment Exception") {
	            return "truck";
	        } else if (shpStatus === "Delivery Exception") {
	            return "exclamation";
	        } else if (shpStatus === "Return Exception") {
	            return "reply";
	        } else if (shpStatus === "Shipped") {
	            return "truck";
	        } else {
	            return "cube";
	        }
	    }
	
	    function getStatusColor(shpStatus) {
	        if (shpStatus == "Delivered") {
	            return "green";
	        } else if (shpStatus == "Pre-Pickup") {
	            return "more-light-grey";
	        } else if (shpStatus == "InTransit") {
	            return "more-light-grey";
	        } else if (shpStatus == "Out for Delivery") {
	            return "blue";
	        } else if (shpStatus == "Voided") {
	            return "more-light-grey";
	        } else if (shpStatus == "Shipment Exception") {
	            return "red";
	        } else if (shpStatus == "Delivery Exception") {
	            return "red";
	        } else if (shpStatus == "Return Exception") {
	            return "red";
	        } else if (shpStatus == "Shipped") {
	            return "blue";
	        } else {
	            return "blue";
	        }
	    }
	
	    function generateSharedModal() {
	        shipmentDocsFileUploadModal = $((0, _render2.default)(modalHtml, {
	            title: ' Upload Shipping Documents',
	            leftAlignTitle: true,
	            body: uploadShippingDocsModalBodyHtml,
	            modalDialogClass: "q-modal-dialog-800",
	            topCloseBtn: true,
	            autoHideTop: true,
	            footerBtns: '\n            <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>\n            <a  href="#" class="base-btn purple-btn custom-submit-btn upload-selected-files disabled">Upload Selected</a>\n            '
	        }));
	        $("body").append(shipmentDocsFileUploadModal);
	
	        var shipDocsFileUploader = new _index2.default({
	            target: '.ship-docs-file-uploader-body',
	            accept: ['.xls', '.xlsx', '.doc', '.docx', '.pdf', '.tiff', '.tif', '.jpg', '.jpeg', '.gif', '.txt', '.csv'],
	            multiple: true,
	            maxFileSize: 10,
	            afterValidSelection: function afterValidSelection() {
	                shipmentDocsFileUploadModal.find(".upload-selected-files").removeClass("disabled");
	            },
	            afterInvalidSelection: function afterInvalidSelection() {
	                shipmentDocsFileUploadModal.find(".upload-selected-files").addClass("disabled");
	            }
	        });
	
	        shipDocsFileUploader.init();
	        shipmentDocsFileUploadModal.modal("show");
	
	        if (shallAllowClick(this)) {
	            $(".upload-selected-files").on('click', function () {
	                submitModalFlow.showLoadingModal();
	                sendFiles(shipDocsFileUploader.getFiles());
	            });
	        }
	        shipmentDocsFileUploadModal.on('hidden.bs.modal', function (e) {
	            shipmentDocsFileUploadModal.remove();
	        });
	    }
	
	    function sendFiles(fileList) {
	        shipmentDocsFileUploadModal.modal("hide");
	        var formData = new FormData();
	        fileList.forEach(function (file) {
	            formData.append("files[]", file);
	        });
	        formData.append("shpShipmentRow", "");
	        var uploadUri = uploadFileUrl + '&shpTrackingNumber=' + shipmentTrackingNumber() + '&shpShipmentNumber=' + shipShipmentNumber() + '&frightFlag=' + frightFlag + '&shipmentBol=' + shipmentBol();
	
	        $.ajax({
	            url: uploadUri,
	            type: 'POST',
	            data: formData,
	            enctype: 'multipart/form-data',
	            processData: false,
	            contentType: false,
	            cache: false,
	            success: sendFileSuccess,
	            error: sendFileError
	        });
	    }
	
	    function sendFileSuccess(resp) {
	        if ($.trim(resp) == "true") {
	            shipmentDocsFileUploadModal.modal("hide");
	            submitModalFlow.showSuccessModal();
	            setTimeout(function () {
	                location.reload();
	            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        } else {
	            sendFileError();
	        }
	    }
	
	    function sendFileError() {
	        submitModalFlow.hideAllModals();
	        shipmentDocsFileUploadModal.find(".upload-error").show();
	    }
	
	    $("#backToListBtn").on("click", function () {
	        window.open(backToList, "_self");
	    });
	
	    $("#searchAgainBtn").on("click", function () {
	        window.open(backTosearch, "_self");
	    });
	
	    init();
	});

/***/ },
/* 742 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  "all": [{
	    title: "Upload Documents",
	    cls: "bulk-upload-documents",
	    icon: "upload",
	    disabled: true
	  }],
	  "actions": [{
	    icon: "upload",
	    title: "Upload Documents",
	    cls: "upload-documents",
	    disabled: false
	  }, {
	    icon: "download",
	    title: "Download Documents",
	    cls: "download-documents",
	    disabled: false
	  }]
	};

/***/ },
/* 743 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var shipmentLookupFieldDropdown = exports.shipmentLookupFieldDropdown = [{
		title: "Search by Tracking / PRO Number",
		value: "shpTrackingNumber"
	}, {
		title: "Search by Order ID Number",
		value: "shpEntityId"
	}, {
		title: "Search by Sales Order Number",
		value: "salesOrderNbr"
	}, {
		title: "Search by Purchase Order Number",
		value: "purchaseOrderNbr"
	}, {
		title: "Search by Shipment Number",
		value: "shpShipmentNumber"
	}, {
		title: "Search by BOL",
		value: "shpBol"
	}];

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _shipmentLookupFields = __webpack_require__(743);
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _actionOptions = __webpack_require__(742);
	
	var _general = __webpack_require__(5);
	
	var _index3 = __webpack_require__(96);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	var statusRowHtml = __webpack_require__(1403);
	var modalHtml = __webpack_require__(11);
	var uploadShippingDocsModalBodyHtml = __webpack_require__(1404);
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	
	var actionList = _actionOptions.actionOptions;
	
	var targetSelector = "#shipment-lookup";
	
	(0, _run2.default)(targetSelector, function () {
	  var dataTableComponentData = $(targetSelector).data("shipment-lookup-data");
	  var packageDetailURL = $(targetSelector).data("package-detail-url");
	  var portletNamespace = $(targetSelector).data("portlet-namespace");
	  var orderFilterData = $(targetSelector).data("table-filter-data");
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	  var filtershipmentUrl = $(targetSelector).data("shipment-filter-url");
	  var searchPageReloadUrl = $(targetSelector).data("search-page-reload");
	  var userRoles = $(targetSelector).data("user-roles");
	  var uploadFileUrl = $(targetSelector).data("upload-file-url");
	  var downloadFileUrl = $(targetSelector).data("downloadFileUrl");
	  var shipmentLookupUrl = $(targetSelector).data("get-shipment-summary-url");
	  var generateExportUrl = $(targetSelector).data("export-url-shipment");
	
	  var selectedRows = "";
	  //for the views - add/save/delete
	  var savedViews = $(targetSelector).data("saved-views");
	  var saveViewURL = $(targetSelector).data("save-view-url");
	  var deleteViewURL = $(targetSelector).data("delete-view-url");
	  var disableCancel = "";
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  var shipmentDocsFileUploadModal = "";
	  var targetObject = "";
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	  _EditChecker2.default.setPageClean();
	  //let shipmentLookup = new LookupTable({
	  var shipmentLookup = new _index2.default({
	    // REQUIRED - Set a target element
	    target: $("#lookup-shipment-wrapper"),
	    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
	    minWidthClass: "q-min-width-sm-til-md",
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: [{
	      data: "shpTrackingNumber",
	      title: "Tracking Number",
	      render: renderShipmentDetailLink
	    }, {
	      data: "shpEntityId",
	      title: "Order ID Number"
	    }, {
	      data: "shpAttrVal2",
	      title: "Sales Order Number"
	    }, {
	      data: "shpAttrVal1",
	      title: "Purchase Order"
	    }, {
	      data: "shpCarrier",
	      title: "Carrier"
	    }, {
	      data: "shpShipToName",
	      title: "Receiver"
	    }, {
	      data: "shpShipToPostalCode",
	      title: "Postal Code"
	    }, {
	      data: "shpShipToCity",
	      title: "City"
	    }, {
	      data: "shpShipToCountry",
	      title: "Country"
	    }, {
	      data: "shpStatus",
	      title: "Carrier Status",
	      render: renderStatusRow
	    }],
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: targetObject != "" ? targetObject.value[0] : ""
	
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _shipmentLookupFields.shipmentLookupFieldDropdown
	    },
	    savedViews: savedViews,
	    bulkSelect: true,
	    // REQUIRED - Data Table specific settings
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      columnDefs: [{ className: "custom-class", targets: [1] }],
	      // Not required, just to show you can
	      order: [[17, 'desc']],
	      columns: [{
	        data: "shpShipmentNumber",
	        render: renderActionWrap,
	        orderable: false,
	        class: 'dtc-action-column'
	      }, {
	        data: "shpTrackingNumber",
	        title: "Tracking / PRO Number",
	        render: renderShipmentDetailLink,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpDocsUploaded",
	        title: "Shipping Docs",
	        render: renderShippingDocs,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpShipmentNumber",
	        title: "Shipment Number",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpEntityId",
	        title: "Order ID Number",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpBol",
	        title: "BOL",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpMasterBol",
	        title: "MBOL",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpAttrVal2",
	        title: "Sales Order Number",
	        class: 'dtc-min-width-md'
	      }, {
	        data: "shpAttrVal1",
	        title: "Purchase Order",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpShippedDate",
	        title: "Ship Date",
	        class: 'dtc-min-width-sm',
	        render: timeStampToDate
	      }, {
	        data: "shpCarrier",
	        title: "Carrier",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpStatus",
	        title: "Carrier Status",
	        class: 'dtc-min-width-sm',
	        render: renderStatusRow
	      }, {
	        data: "shpShipToName",
	        title: "Receiver",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpShipToPostalCode",
	        title: "Postal Code",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpShipToCity",
	        title: "City",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpShipToCountry",
	        title: "Country",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "shpCreatedDate",
	        "visible": false
	      }]
	    },
	    paginationData: dataTableComponentData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Shipments",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "shipment"
	    },
	    onBulkSelectChange: function onBulkSelectChange() {
	      selectedRows = shipmentLookup.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass('disabled');
	      } else {
	        $(".action-header-btn .base-btn").addClass('disabled');
	      };
	    },
	    onFetch: function onFetch() {
	      var currentData = shipmentLookup.generateData();
	      shipmentLookup.showLoadingOverlay();
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filtershipmentUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  $("#advancedSearch").on("click", function () {
	    window.open(searchPageReloadUrl, "_self");
	  });
	
	  var table = $("#lookup-shipment-wrapper .data-table-component").DataTable();
	  //Methods used for the Actions/Bulk Actions
	  function renderActionCellList(list, data, row) {
	    var renderedList = void 0;
	    renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: checkDisableForGivenAction(data, row, item.cls)
	      });
	    });
	    return renderedList.join('');
	  }
	
	  function checkDisableForGivenAction(data, row, actionName) {
	    if (isRowLevelActionCheck(data)) {
	      return callBusinessLogicToDisableAction(data, row, actionName);
	    } else {
	      var isTrue = false;
	      _(selectedRows).map(function (item) {
	        if ((0, _general.isPresent)(item) && (0, _general.isPresent)(item.data)) {
	          if (callBusinessLogicToDisableAction(item.data.shpShipmentNumber, item.data, actionName)) {
	            if (!isTrue) {
	              isTrue = true;
	            }
	          }
	        } else if ((0, _general.isPresent)(item) && !(0, _general.isPresent)(item.data)) {
	          if (callBusinessLogicToDisableAction(item.shpShipmentNumber, item, actionName)) {
	            if (!isTrue) {
	              isTrue = true;
	            }
	          }
	        }
	      });
	      return isTrue;
	    }
	  };
	
	  function isRowLevelActionCheck(data) {
	    return (0, _general.isPresent)(data);
	  }
	
	  function callBusinessLogicToDisableAction(data, row, actionName) {
	    if ((0, _general.isPresent)(data) && actionName == "upload-documents") {
	      if (_.contains(userRoles, "POD Admin") || _.contains(userRoles, "POD User")) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	
	    if ((0, _general.isPresent)(data) && actionName == "download-documents") {
	      if (row.shpDocsUploaded == 1) {
	        return false;
	      } else {
	        return true;
	      }
	    }
	
	    if (actionName == "bulk-upload-documents") {
	      if (checkForUniqueSelectedShipmets()) {
	        if (_.contains(userRoles, "POD Admin") || _.contains(userRoles, "POD User")) {
	          return true;
	        } else {
	          return false;
	        }
	      }{
	        return true;
	      }
	    }
	  }
	
	  function checkForUniqueSelectedShipmets() {
	    selectedRows = getAllSelectedRows();
	    var selectedUniqueShipments = [];
	    _(selectedRows).map(function (shipmentRow) {
	      if ((0, _general.isPresent)(shipmentRow)) {
	        selectedUniqueShipments.push(shipmentRow.shpShipmentNumber);
	      }
	    });
	    if (_.uniq(selectedUniqueShipments).length > 1) {
	      return false;
	    } else {
	      return true;
	    }
	  }
	
	  //Methods used for the Filter and Success
	  function filterSuccessFun(data) {
	    var shipments = data.content;
	    var page = data.page;
	    shipmentLookup.setNewData(shipments);
	    shipmentLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    shipmentLookup.hideLoadingOverlay();
	    setExportData(shipmentLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var shipments = data.lookupItems.content;
	    var page = data.lookupItems.page;
	    shipmentLookup.setNewData(shipments);
	    shipmentLookup.setPaginationData(page);
	    shipmentLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    shipmentLookup.hideLoadingOverlay();
	    setExportData(shipmentLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var shipments = data.lookupItems.content;
	    var page = data.lookupItems.page;
	    shipmentLookup.setNewData(shipments);
	    shipmentLookup.setPaginationData(page);
	    shipmentLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    shipmentLookup.hideLoadingOverlay();
	    setExportData(shipmentLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var shipments = data.lookupItems.content;
	    var page = data.lookupItems.page;
	    shipmentLookup.removeSavedView(data.target);
	    shipmentLookup.setNewData(shipments);
	    shipmentLookup.setPaginationData(page);
	    shipmentLookup.hideLoadingOverlay();
	    setExportData(shipmentLookup.generateData());
	  }
	
	  function errorFun(data) {
	    shipmentLookup.hideLoadingOverlay();
	  }
	
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  };
	
	  function renderActionHeaderWrap() {
	    var statusTarget = actionList['all'];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  };
	
	  $('body').on('click', '.upload-documents', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      //let row = table.row(parent);
	      generateSharedModal([row.data()]);
	    }
	  });
	
	  $('body').on('click', '.bulk-upload-documents', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      generateSharedModal(getAllSelectedRows());
	    }
	  });
	
	  function getAllSelectedRows() {
	    var shipmentRows = new Array();
	    _(selectedRows).map(function (shipmentRow) {
	      if ((0, _general.isPresent)(shipmentRow.data)) {
	        shipmentRows.push(shipmentRow.data);
	      } else if ((0, _general.isPresent)(shipmentRow) && !(0, _general.isPresent)(shipmentRow.data)) {
	        shipmentRows.push(shipmentRow);
	      }
	    });
	    return shipmentRows;
	  }
	
	  $('body').on('click', '.download-documents', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      // Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      //let row = table.row(parent);
	      downloadFiles([row.data()]);
	    }
	  });
	
	  $('body').on('click', '.bulk-download-documents', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      downloadFiles(getAllSelectedRows());
	    }
	  });
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  //Method to pouplate the tracking number as link
	  function renderShipmentDetailLink(data, type, row) {
	    var linkHTML = void 0;
	    if (data == 'Not Available' && row.shpFreight == 0) {
	      linkHTML = "<div class=\"q-marg-all-xs-at-md\">{%- data %}</div>";
	    } else {
	      linkHTML = "<div class=\"q-marg-all-xs-at-md\"><a href={%= shipmentDetailURL %}&shpTrackingNumber={%- shpTrackingId %}&shpShipmentNumber={%- shipmentNumber %}&frightFlag={%- frightFlag %}&shipmentBol={%- shipmentBol %}&facilityNo={%- facilityNo %}&wmOrderNo={%- wmOrderNo %} class='details-control anchor-text'>{%- data %}</a></div>";
	    }
	
	    var shipmentTrackingID = row.shpTrackingNumber;
	    if (shipmentTrackingID == 'Not Available') {
	      shipmentTrackingID = 'NotAvaliable';
	    }
	
	    var shipmentInfoLink = (0, _render2.default)(linkHTML, {
	      data: data,
	      row: row,
	      shipmentDetailURL: packageDetailURL,
	      shpTrackingId: shipmentTrackingID,
	      shipmentNumber: row.shpShipmentNumber,
	      frightFlag: row.shpFreight,
	      shipmentBol: row.shpBol,
	      facilityNo: row.shpMerchantBuId,
	      wmOrderNo: row.shpEntityId
	    });
	    return shipmentInfoLink;
	  }
	
	  function timeStampToDate(data, type, row) {
	    return (0, _moment2.default)(row.shpShippedDate).format("YYYY/MM/DD");
	  }
	
	  //Method to pouplate the Status with a Pill Fill
	  function renderStatusPill(data, type, row) {
	    var renderStatus = void 0;
	    var statusHTML = void 0;
	    if (data == "Active") {
	      statusHTML = "<div class='q-pill q-pill-blue q-pill-detail'>{%-data%}</div>";
	    } else {
	      statusHTML = "<div class='q-pill q-pill-blue-border q-pill-detail'>{%-data%}</div>";
	    }
	    renderStatus = (0, _render2.default)(statusHTML, {
	      data: data
	    });
	    return renderStatus;
	  }
	
	  //to call new html for the last column/country
	  function renderStatusRow(data, type, row) {
	    return (0, _render2.default)(statusRowHtml, {
	      icon: row.icon,
	      ordStatus: row.shpStatus,
	      statusColor: row.statusColor
	    });
	  }
	
	  function renderShippingDocs(data, type, row) {
	    if (data != null && data == 1) {
	      return (0, _render2.default)("<center><span class='q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-md'>Yes</span></center>");
	    } else {
	      return (0, _render2.default)("<center><span class='q-pretty-pill-tag q-ppt-white q-ppt-pad-md'>No</span></center>");
	    }
	  }
	
	  function generateSharedModal(rowData) {
	    shipmentDocsFileUploadModal = $((0, _render2.default)(modalHtml, {
	      title: ' Upload Shipping Documents',
	      leftAlignTitle: true,
	      body: uploadShippingDocsModalBodyHtml,
	      modalDialogClass: "q-modal-dialog-800",
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: "\n        <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a>\n        <a  href=\"#\" class=\"base-btn purple-btn custom-submit-btn upload-selected-files disabled\">Upload Selected</a>\n        "
	    }));
	    $("body").append(shipmentDocsFileUploadModal);
	
	    var shipDocsFileUploader = new _index4.default({
	      target: '.ship-docs-file-uploader-body',
	      accept: ['.xls', '.xlsx', '.doc', '.docx', '.pdf', '.tiff', '.tif', '.jpg', '.jpeg', '.gif', '.txt', '.csv'],
	      multiple: true,
	      maxFileSize: 10,
	      afterValidSelection: function afterValidSelection() {
	        shipmentDocsFileUploadModal.find(".upload-selected-files").removeClass("disabled");
	      },
	      afterInvalidSelection: function afterInvalidSelection() {
	        shipmentDocsFileUploadModal.find(".upload-selected-files").addClass("disabled");
	      }
	    });
	
	    shipDocsFileUploader.init();
	    shipmentDocsFileUploadModal.modal("show");
	
	    if (shallAllowClick(this)) {
	      $(".upload-selected-files").on('click', function () {
	        submitModalFlow.showLoadingModal();
	        sendFiles(shipDocsFileUploader.getFiles(), rowData);
	      });
	    }
	    shipmentDocsFileUploadModal.on('hidden.bs.modal', function (e) {
	      shipmentDocsFileUploadModal.remove();
	    });
	  }
	
	  function sendFiles(fileList, rowData) {
	    shipmentDocsFileUploadModal.modal("hide");
	    var formData = new FormData();
	    fileList.forEach(function (file) {
	      formData.append("files[]", file);
	    });
	    formData.append("shpShipmentRow", JSON.stringify(rowData));
	    var uploadUri = uploadFileUrl + "&shpShipmentNumber=" + _.uniq(rowData);
	    $.ajax({
	      url: uploadUri,
	      type: 'POST',
	      data: formData,
	      enctype: 'multipart/form-data',
	      processData: false,
	      contentType: false,
	      cache: false,
	      success: sendFileSuccess,
	      error: sendFileError
	    });
	  }
	
	  function downloadFiles(rowData) {
	    var downloadFileUri = downloadFileUrl + "&shpShipmentNumber=" + rowData;
	    var formData = new FormData();
	    formData.append("shpShipmentRow", JSON.stringify(rowData));
	    submitModalFlow.showLoadingModal();
	    $.ajax({
	      url: downloadFileUri,
	      type: 'POST',
	      data: formData,
	      enctype: 'multipart/form-data',
	      processData: false,
	      contentType: false,
	      cache: false,
	      success: downloadFileSuccess,
	      error: downloadFileError
	    });
	  }
	
	  function sendFileSuccess(resp) {
	    if ($.trim(resp) == "true") {
	      shipmentDocsFileUploadModal.modal("hide");
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        location.href = shipmentLookupUrl;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      sendFileError();
	    }
	  }
	
	  function sendFileError() {
	    submitModalFlow.hideAllModals();
	    shipmentDocsFileUploadModal.find(".upload-error").show();
	  }
	
	  function downloadFileSuccess(data) {
	    if ((0, _general.isPresent)(data)) {
	      $.each(JSON.parse(data), function (key, value) {
	        if (value.contentType == "atd") {
	          value.contentType = "txt";
	        }
	        downloadFile(value.contentType, value.fileName, value.content);
	      });
	    } else {
	      setTimeout(function () {
	        submitModalFlow.hideAllModals();
	        submitModalFlow.showFailureModal();
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    }
	  }
	
	  function downloadFileError() {
	    submitModalFlow.showFailureModal();
	    setTimeout(function () {
	      submitModalFlow.hideAllModals();
	      submitModalFlow.showFailureModal();
	    }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	  }
	
	  function downloadFile(mimeType, fileName, data) {
	    var a = document.createElement('a');
	    if (window.URL && window.Blob && 'download' in a && window.atob) {
	      // Do it the HTML5 compliant way
	      var blob = base64ToBlob(data, mimeType);
	      var url = window.URL.createObjectURL(blob);
	      a.href = url;
	      a.download = fileName;
	      a.click();
	      window.URL.revokeObjectURL(url);
	    }
	    submitModalFlow.hideAllModals();
	  }
	
	  function base64ToBlob(base64, mimetype, slicesize) {
	    if (!window.atob || !window.Uint8Array) {
	      // The current browser doesn't have the atob function. Cannot continue
	      return null;
	    }
	    mimetype = "application/" + mimetype || '';
	    slicesize = slicesize || 512;
	    var bytechars = atob(base64);
	    var bytearrays = [];
	    for (var offset = 0; offset < bytechars.length; offset += slicesize) {
	      var slice = bytechars.slice(offset, offset + slicesize);
	      var bytenums = new Array(slice.length);
	      for (var i = 0; i < slice.length; i++) {
	        bytenums[i] = slice.charCodeAt(i);
	      }
	      var bytearray = new Uint8Array(bytenums);
	      bytearrays[bytearrays.length] = bytearray;
	    }
	    return new Blob(bytearrays, { type: mimetype });
	  };
	
	  shipmentLookup.init();
	
	  // Export component integration.
	  var exportUrl = "";
	
	  function setExportData(currentData) {
	    exportUrl = exportURl(generateExportUrl, currentData);
	  }
	
	  setExportData(shipmentLookup.generateData());
	
	  $("#exportData").on("click", function () {
	    window.open(exportUrl, "_self");
	  });
	
	  function exportURl(resourceURL, currentData, portletNamespace) {
	    var url = "";
	    var startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"], 'startDate');
	    var endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"], 'endDate');
	    var fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"], 'fixedRange');
	    var revisedSearchCriteria = alterSearchCriteriForController(currentData["searchCriteria"]);
	    var orderBy = currentData["orderBy"] == 'ordStatus' ? "ordStatusCode" : currentData["orderBy"];
	    var searchCriteria = _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);
	
	    searchCriteria = encodeURIComponent(searchCriteria);
	
	    portletNamespace = (0, _general.isPresent)(portletNamespace) ? portletNamespace : "";
	    //url = resourceURL+"&endDate="+endDate+"&startDate="+startDate+"&fixedRange="+fixedRangeDate+"&page=0"+"&size=1000"+"&orderBy="+orderBy+"&orderByType="+currentData["sortType"]+"&searchCriteria="+searchCriteria;
	    url = resourceURL + ["&" + portletNamespace + "endDate="] + endDate + ["&" + portletNamespace + "startDate="] + startDate + ["&" + portletNamespace + "fixedRange="] + fixedRangeDate + ["&" + portletNamespace + "page=0&" + portletNamespace + "size=1000&" + portletNamespace + "orderBy"] + orderBy + ["&" + portletNamespace + "orderByType="] + currentData["sortType"] + ["&" + portletNamespace + "searchCriteria="] + searchCriteria;
	    return url;
	  }
	
	  function readSpecificKeyFromSearchCriteria(searchCriteria, key) {
	    var value = "";
	    $.each(searchCriteria, function (i, item) {
	      if (item.key == key) {
	        value = item.value[0];
	      }
	    });
	    return value;
	  }
	
	  function alterSearchCriteriForController(searchCriteria) {
	    // This omit is require cause, lookup component is adding below information in searchCriteria which was not the case earlier,
	    // so instead change controller side code beeter to send what contrller is expecting.
	    var revisedSearchCriteria = _.omit(searchCriteria, function (value, key, object) {
	      return value.key == 'fixedRange' || value.key == 'startDate' || value.key == 'endDate';
	    });
	    return _.toArray(revisedSearchCriteria);
	  }
	
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	});

/***/ },
/* 745 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  "actions": [{
	    title: "Upload Photos",
	    cls: "upload-photos",
	    icon: "hourglass",
	    disabled: false
	  }, {
	    title: "Edit Record",
	    cls: "edit-discrepancy",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Delete Record",
	    cls: "delete-record",
	    icon: "pencil",
	    disabled: false
	  }]
	};

/***/ },
/* 746 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var receivingDiscrepanciesLookupFieldDropdown = exports.receivingDiscrepanciesLookupFieldDropdown = [{
		title: "PO number",
		value: "poNumber"
	}, {
		title: "Ship Id",
		value: "shipmentId"
	}, {
		title: "SKU",
		value: "sku"
	}, {
		title: "Tracking#",
		value: "tackingNumber"
	}];

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalHtml = __webpack_require__(11);
	var duplicateDiscrepanciesModalBodyHtml = __webpack_require__(1406);
	
	var elsPage = {};
	
	var addDiscrepancyBlockHtml = __webpack_require__(1408);
	var customValidateProps = {
	  errorPlacement: function errorPlacement(error, element) {
	    var appendClosest = $(element).data('error-placement-append-closest');
	    if (appendClosest) {
	      $(element).closest(appendClosest).append(error);
	    } else {
	      error.insertAfter(element);
	    }
	  }
	};
	
	var targetSelector = "#manage-receiving-discrepencies";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  var duplicateDiscrepanciesModal = "";
	  var $ = __webpack_require__(1);
	  var lookupUrl = $(targetSelector).data("lookup-url");
	  var discrepancyCodesList = $(targetSelector).data("discrepancy-list");
	  var fieldValidationUrl = $(targetSelector).data("validatiion-form-field-url");
	  var duplicaterecordCheckUrl = $(targetSelector).data("duplicate_record-check-url");
	  var date = new Date();
	
	  //enabled readonly and disabled field , when failed checbox is selected
	  $("#failedRecord").on('change', function () {
	    if ($(this).is(':checked')) {
	      $("#shippedFrom").attr('readonly', false);
	      $("#carrierBolTrackingNum").attr('readonly', false);
	      $("#poTrfNum").attr('readonly', false);
	      $("#shipmentNumber").attr('readonly', false);
	      $("#itemNumber").attr('readonly', false);
	      $("#totalPallets").attr('readonly', false);
	      $("#discrepantPallets").attr('readonly', false);
	      $("#discrepancyQty").attr('readonly', false);
	
	      $("#discrepancyComment").attr('readonly', false);
	      $("#status").attr('readonly', false);
	      $("#disabledEditCodes").attr('disabled', false);
	
	      $("#photo").attr('disabled', false);
	      $("#dateSent").attr('disabled', false);
	      $("#dateReceived").attr('disabled', false);
	    } else {
	      $("#shippedFrom").attr('readonly', true);
	      $("#carrierBolTrackingNum").attr('readonly', true);
	      $("#poTrfNum").attr('readonly', true);
	      $("#shipmentNumber").attr('readonly', true);
	      $("#itemNumber").attr('readonly', true);
	      $("#totalPallets").attr('readonly', true);
	      $("#discrepantPallets").attr('readonly', true);
	      $("#discrepancyQty").attr('readonly', true);
	
	      $("#discrepancyComment").attr('readonly', true);
	      $("#status").attr('readonly', true);
	      $("#disabledEditCodes").attr('disabled', true);
	
	      $("#photo").attr('disabled', true);
	      $("#dateSent").attr('disabled', true);
	      $("#dateReceived").attr('disabled', true);
	    }
	  });
	
	  //datepicker event on resolved date click
	  $("#resolvedDate").datepicker({
	    endDate: date,
	    dateFormat: "mm /dd / yyyy",
	    todayBtn: "linked",
	    keyboardNavigation: false,
	    autoclose: true
	  });
	
	  //date picker , cage date should always be equal to lesser than current date
	  $("#dateSent").datepicker({
	    endDate: date,
	    startDate: getCageStartDate(),
	    dateFormat: "mm /dd / yyyy",
	    todayBtn: "linked",
	    keyboardNavigation: false,
	    autoclose: true
	  }).on('changeDate', function (selected) {
	    $("#dateReceived").datepicker('update', '');
	    $("#mandatory-date-cage-error").hide();
	    var maxReceivedDate = $("#dateSent").datepicker("getDate");
	    $('#dateReceived').datepicker('setEndDate', maxReceivedDate);
	    var minReceivedDate = new Date(selected.date.valueOf() - 1000 * 60 * 60 * 24 * 30);
	    $('#dateReceived').datepicker('setStartDate', minReceivedDate);
	  });
	
	  function getCageStartDate() {
	    var date = new Date();
	    var day = date.getDay();
	    var startDate = new Date();
	
	    if (day != 6) {
	      startDate.setDate(date.getDate() - (day + 1));
	    } else {
	      startDate.setDate(date.getDate());
	    }
	
	    if (startDate.getMonth() < date.getMonth()) {
	      var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
	      startDate = new Date(firstDayOfMonth);
	    }
	    return startDate;
	  }
	
	  //date picker , receieved date should always be equal to lesser than current date
	  $("#dateReceived").datepicker({
	    dateFormat: "mm /dd / yyyy",
	    todayBtn: "linked",
	    keyboardNavigation: false,
	    autoclose: true,
	    forceParse: false
	  }).on('click', function (date) {
	    if ($("#dateSent").datepicker("getDate") === null) {
	      $("#mandatory-date-cage-error").show();
	      $(this).datepicker('update', '');
	      $(this).datepicker('hide');
	      return;
	    }
	  });
	
	  //hide hidden fields on change event
	  $("#resolved-comments").on("change", function () {
	    if ($("#resolved-comments").is('[readonly]')) {
	      return;
	    }
	
	    $("#mandatory-resolution-comments").hide();
	  });
	
	  //hide hidden fields on change event
	  $(".validate-po").on("change", function () {
	    $(".submit-verizon-form").attr('disabled', false);
	    $("#po-number-do-not-exist-error").hide();
	    $("#po-number-is-not-valid").hide();
	    $("#po-number-not-provided").hide();
	    $("#order-number-do-not-exist-error").hide();
	    $("#ship-number-is-not-valid").hide();
	
	    if (!(0, _general.isPresent)($(".validate-po").val())) {
	      return;
	    }
	    //empty out shipId and Item#
	    $("#shipmentNumber").val('');
	    $("#itemNumber").val('');
	
	    var validateValues = {
	      "po": $(".validate-po").val()
	    };
	    validatePo(validateValues);
	  });
	
	  //hide hidden fields on change event
	  $("#shipmentNumber").on("change", function () {
	    $(".submit-verizon-form").attr('disabled', false);
	    $("#order-number-do-not-exist-error").hide();
	    $("#ship-number-is-not-valid").hide();
	    $("#sku-number-do-not-exist-error").hide();
	
	    if (!(0, _general.isPresent)($("#shipmentNumber").val())) {
	      return;
	    }
	
	    if ($("#shipmentNumber").val().length == 0) {
	      $("#po-number-do-not-exist-error").show();
	      $(".submit-verizon-form").attr('disabled', true);
	      return;
	    }
	
	    if ($(".validate-po").val().length == 0) {
	      $("#po-number-do-not-exist-error").show();
	      $(".submit-verizon-form").attr('disabled', true);
	      return;
	    }
	
	    $("#itemNumber").val('');
	
	    var validateValues = {
	      "po": $(".validate-po").val(), "shipId": $("#shipmentNumber").val()
	    };
	
	    validateShipId(validateValues);
	  });
	
	  //asynchronous validation before submit, PO and shipId field is mandatory 
	  $("#itemNumber").on("change", function () {
	    $("#po-number-is-not-valid").hide();
	    $("#ship-number-is-not-valid").hide();
	    $("#po-number-do-not-exist-error").hide();
	    $("#sku-number-do-not-exist-error").hide();
	    $("#order-number-do-not-exist-error").hide();
	    $(".submit-verizon-form").attr('disabled', false);
	
	    if (!(0, _general.isPresent)($("#itemNumber").val())) {
	      return;
	    }
	
	    if ($(".validate-po").val().length == 0) {
	      $("#po-number-do-not-exist-error").show();
	      $(".submit-verizon-form").attr('disabled', true);
	      return;
	    }
	
	    if ($("#po-number-is-not-valid").is(":visible")) {
	      $(".submit-verizon-form").attr('disabled', true);
	      return;
	    }
	
	    if ($("#shipmentNumber").val().length == 0) {
	      $("#order-number-do-not-exist-error").show();
	      $(".submit-verizon-form").attr('disabled', true);
	      return;
	    }
	
	    if ($("#ship-number-is-not-valid").is(":visible")) {
	      $(".submit-verizon-form").attr('disabled', true);
	      return;
	    }
	
	    var validateValues = {
	      "po": $(".validate-po").val(), "shipId": $("#shipmentNumber").val(),
	      "itemName": this.value
	    };
	
	    validateItem(validateValues);
	  });
	
	  //Validate required fields before form submit
	  $(".manage-vsigma-form").validate(customValidateProps);
	
	  //submit button click event in form
	  $(".submit-verizon-form").click(function (event) {
	    event.preventDefault();
	
	    if ($(".manage-vsigma-form").valid()) {
	      checkIfRecordIsDuplicate();
	    }
	  });
	
	  //click event on lookup page update button
	  $(".update-verizon-form").click(function (event) {
	    $("#mandatory-resolution-comments").hide();
	    event.preventDefault();
	
	    //enable disabled discrepancyCodes for edit
	    if ($("#disabledEditCodes").is(':disabled')) {
	      $("#disabledEditCodes").removeAttr('disabled');
	    }
	
	    if ($("#dateSent").is(':disabled')) {
	      $("#dateSent").removeAttr('disabled');
	    }
	
	    if ($("#dateReceived").is(':disabled')) {
	      $("#dateReceived").removeAttr('disabled');
	    }
	
	    if ($("#photo").is(':disabled')) {
	      $("#photo").removeAttr('disabled');
	    }
	
	    //resolution comments must be provided if resolution date is provided
	    if (!$("#resolvedDate").val().length == 0) {
	      if ($("#resolved-comments").val().length == 0) {
	        $("#mandatory-resolution-comments").show();
	        return;
	      }
	    }
	
	    if ($(".manage-vsigma-form").valid()) {
	      $("#receivingDiscrepenciesForm").submit();
	      var submitModalFlow = new _SubmitModalFlow2.default();
	      submitModalFlow.init();
	      _EditChecker2.default.setPageClean();
	      submitModalFlow.showLoadingModal();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        submitModalFlow.hideAllModals();
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    }
	  });
	
	  //check if class is disabled
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  //Generate popup if user trying to enter duplicate record
	  function generateWarningModal() {
	    duplicateDiscrepanciesModal = $((0, _render2.default)(modalHtml, {
	      title: 'Discrepancy already exist , click continue if you want to create same record again',
	      leftAlignTitle: true,
	      body: duplicateDiscrepanciesModalBodyHtml,
	      modalDialogClass: "q-modal-dialog-800",
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: "\n        <a href=\"#\" class=\"base-btn v2-btn purple-btn modal-auto-hide\">Cancel</a>\n        <a  href=\"#\" class=\"base-btn purple-btn custom-submit-btn submit-duplicate-record\">Continue</a>\n        "
	    }));
	
	    $("body").append(duplicateDiscrepanciesModal);
	
	    duplicateDiscrepanciesModal.modal("show");
	    duplicateDiscrepanciesModal.on('hidden.bs.modal', function (e) {
	      duplicateDiscrepanciesModal.remove();
	    });
	  }
	
	  //ajax call to check if discrepancy provided already exists
	  function checkIfRecordIsDuplicate() {
	    var submitModalFlow = new _SubmitModalFlow2.default();
	    submitModalFlow.init();
	
	    $.ajax({
	      url: duplicaterecordCheckUrl,
	      dataType: 'text',
	      async: false,
	      data: $("#receivingDiscrepenciesForm").serialize(),
	      success: function success(resp) {
	        if (resp == "true") {
	          //create warning modal;
	          generateWarningModal();
	
	          if (shallAllowClick(this)) {
	            $(".submit-duplicate-record").on('click', function () {
	              $("#receivingDiscrepenciesForm").submit();
	              submitModalFlow.showLoadingModal();
	              setTimeout(function () {
	                submitModalFlow.hideAllModals();
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            });
	          }
	        } else {
	          $("#receivingDiscrepenciesForm").submit();
	          _EditChecker2.default.setPageClean();
	          submitModalFlow.showLoadingModal();
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            submitModalFlow.hideAllModals();
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        }
	      },
	      error: function error(xhr, status, _error) {
	        submitModalFlow.hideAllModals();
	      }
	    });
	  }
	
	  //ajax call to check if PO/Ship#/Item# combination is valid
	  function validatePo(requestParameters) {
	    $.ajax({
	      url: fieldValidationUrl,
	      data: requestParameters,
	      beforeSend: function beforeSend() {
	        $.blockUI({ message: "Validating PO, Please Wait.." });
	      },
	      complete: function complete() {
	        $.unblockUI();
	      },
	      success: function success(response) {
	        var responseObj = JSON.parse(response);
	        if ((0, _general.isPresent)(responseObj.errorMessage)) {
	          var errorMessage = responseObj.errorMessage.split(":", 2)[0];
	          var errorElementId = responseObj.errorMessage.split(":", 2)[1];
	          document.getElementById(errorElementId).innerHTML = errorMessage;
	          $(".validate-po").focus();
	          $("#".concat(errorElementId)).show();
	          $(".submit-verizon-form").attr('disabled', true);
	          return false;
	        }
	      }
	    });
	  }
	
	  //ajax call to check if PO/Ship#/Item# combination is valid
	  function validateShipId(requestParameters) {
	    $.ajax({
	      url: fieldValidationUrl,
	      data: requestParameters,
	      beforeSend: function beforeSend() {
	        $.blockUI({ message: "Validating shipId, Please Wait.." });
	      },
	      complete: function complete() {
	        ;
	        $.unblockUI();
	      },
	      success: function success(response) {
	        var responseObj = JSON.parse(response);
	        if ((0, _general.isPresent)(responseObj.errorMessage)) {
	          var errorMessage = responseObj.errorMessage.split(":", 2)[0];
	          var errorElementId = responseObj.errorMessage.split(":", 2)[1];
	          $("#shipmentNumber").focus();
	          document.getElementById(errorElementId).innerHTML = errorMessage;
	          $("#".concat(errorElementId)).show();
	          $(".submit-verizon-form").attr('disabled', true);
	          return false;
	        }
	      }
	    });
	  }
	  //ajax call to check if PO/Ship#/Item# combination is valid
	  function validateItem(requestParameters) {
	    $.ajax({
	      url: fieldValidationUrl,
	      data: requestParameters,
	      beforeSend: function beforeSend() {
	        $.blockUI({ message: "Validating item, Please Wait.." });
	      },
	      complete: function complete() {
	        $.unblockUI();
	      },
	      success: function success(response) {
	        var responseObj = JSON.parse(response);
	        if (!(0, _general.isPresent)(responseObj.errorMessage)) {
	          $("#packingListQty").val(responseObj.packageQty);
	          $("#vendorSupplier").val(responseObj.vendorSupplier);
	          $("#skuDesc").val(responseObj.itemDesc);
	          $("#itemExistsOnPo").val(responseObj.itemExistsOnPO);
	        } else {
	          var errorMessage = responseObj.errorMessage.split(":", 2)[0];
	          var errorElementId = responseObj.errorMessage.split(":", 2)[1];
	          $("#itemNumber").focus();
	          document.getElementById(errorElementId).innerHTML = errorMessage;
	          $("#".concat(errorElementId)).show();
	          $(".submit-verizon-form").attr('disabled', true);
	          return false;
	        }
	      }
	    });
	  }
	});

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(747);
	
	__webpack_require__(749);

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _receivingDiscrepanciesLookupFieldDropdown = __webpack_require__(746);
	
	var _actionOptions = __webpack_require__(745);
	
	var _constants = __webpack_require__(10);
	
	var _index3 = __webpack_require__(96);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var modalHtml = __webpack_require__(11);
	
	var _ = __webpack_require__(2);
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var actionList = _actionOptions.actionOptions;
	var uploadDiscrepanciesPhotoModalBodyHtml = __webpack_require__(1410);
	var editDiscrepanciesRecordModalBodyHtml = __webpack_require__(1407);
	var resolvedDiscrepanciesModalBodyHtml = __webpack_require__(1409);
	var deleteDiscrepanciesModalBodyHtml = __webpack_require__(1405);
	
	var targetSelector = "#receiving-discrepancies-lookup-outer";
	(0, _run2.default)(targetSelector, function () {
	  var discrepanciesPhotoUploadModal = "";
	  var resolvedDiscrepanciesModal = "";
	  var deleteDiscrepanciesModal = "";
	  var entryElement = $(targetSelector);
	  var dataTableComponentData = entryElement.data("receiving-discrepancies-lookup-data");
	  var getEditRecordURL = $(targetSelector).data("update-form-field-url");
	  var uploadPhotosUrl = $(targetSelector).data("upload-photos-url");
	  var deleteDiscrepancyUrl = $(targetSelector).data("delete-discrepancy-url");
	  var portletNamespace = $(targetSelector).data("portlet-namespace");
	  var savedViews = entryElement.data("saved-views");
	  var filterSearchUrl = $(targetSelector).data("filter-search-url");
	  var saveViewURL = $(targetSelector).data("save-view-url");
	  var deleteViewURL = $(targetSelector).data("delete-view-url");
	  var backToFormUrl = $(targetSelector).data("reload-form-url");
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	
	  var disabledDeleteMessage = "Cannot delete record, as discrepancy is deleted";
	  var disabledDeleteCutOffMessage = "Cannot delete record , as cutoff date is passed";
	  var disabledDeleteResolvedMessage = "Cannot delete record , as discrepancy is marked resolved";
	  var editDisabledResolvedMessage = "Cannot edit record, as discrepancy is marked resolved";
	  var editDisabledDeleteMessage = "Cannot edit record, as discrepancy is deleted";
	  var disabledImageResolvedMessage = "Cannot upload image, as discrepancy is marked resolved";
	  var disabledImageCutOffMessage = "Cannot upload image, as cutOff date is passed";
	  var disabledImageDeletedMessage = "Cannot upload image, as discrepancy is deleted";
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var exportModal = new _filtersutil.buildExport();
	  var exportUrl = $(targetSelector).data("export-url");
	  var targetObject = "";
	
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	
	  var receivingDiscrepanciesLookup = new _index2.default({
	
	    target: $("#receiving-discrepancies-lookup-wrapper"),
	    minWidthClass: "q-min-width-sm-til-md",
	    mobileColumns: [{
	      data: "redId",
	      render: renderActionWrap,
	      orderable: false,
	      title: "Actions",
	      class: "dtc-action-column"
	    }, {
	      data: "redPhoto",
	      title: "Photo Reqd",
	      class: "dtc-min-width-smbn"
	    }, {
	      data: "redTrackingNum",
	      title: "Tracking#",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "redPoTrfNum",
	      title: "PO/TRF#",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "redShipidOrderNum",
	      title: "ShipId Order#",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "redSku",
	      title: "sku",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "redItemExistsOnPo",
	      title: "Item exists on PO",
	      class: "dtc-min-width-smbn"
	    }, {
	      data: "redDiscrepancyQty",
	      title: "Discrepancy_Qty",
	      class: "dtc-min-width-smbn"
	    }, {
	      data: "rddDiscrepancyCodeWithDescription",
	      title: "DiscrepancyDescription",
	      class: "dtc-min-width-md"
	    }, {
	      data: "redTransactionDate",
	      title: "Transaction Date",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "redVendorSupplier",
	      title: "Vendor-Supplier",
	      class: "dtc-min-width-sm"
	    }, {
	      data: "redRecordType",
	      title: "Record Type",
	      class: "dtc-min-width-smbn"
	    }, {
	      data: "rddImageUploaded",
	      title: "Image Uploaded",
	      class: "dtc-min-width-smbn"
	    }],
	
	    tableSearch: true,
	    // REQUIRED: search input info
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: targetObject != "" ? targetObject.value[0] : ""
	
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _receivingDiscrepanciesLookupFieldDropdown.receivingDiscrepanciesLookupFieldDropdown
	    },
	    // OPTIONAL: Set Saved View Array
	    savedViews: savedViews,
	    bulkSelect: false,
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      // Not required, just to show you can
	      columnDefs: [{}],
	      // Not required, just to show you can
	      order: [[5, 'desc']],
	      columns: [{
	        data: "redId",
	        render: renderActionWrap,
	        orderable: false,
	        title: "Actions",
	        class: "dtc-action-column"
	      }, {
	        data: "redPhoto",
	        title: "Photo Reqd",
	        class: "dtc-min-width-smbn"
	      }, {
	        data: "redTrackingNum",
	        title: "Tracking#",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "redPoTrfNum",
	        title: "PO/TRF#",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "redShipidOrderNum",
	        title: "ShipId Order#",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "redSku",
	        title: "SKU",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "redItemExistsOnPo",
	        title: "Item exists on PO",
	        class: "dtc-min-width-smbn"
	      }, {
	        data: "redDiscrepancyQty",
	        title: "Discrepancy Qty",
	        class: "dtc-min-width-smbn"
	      }, {
	        data: "rddDiscrepancyCodeWithDescription",
	        title: "Discrepancy Code/Description",
	        class: "dtc-min-width-md"
	      }, {
	        data: "redTransactionDate",
	        title: "Transaction Date",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "redVendorSupplier",
	        title: "Vendor-Supplier",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "redRecordType",
	        title: "Record Type",
	        class: "dtc-min-width-smbn"
	      }, {
	        data: "rddImageUploaded",
	        title: "Image Uploaded",
	        class: "dtc-min-width-smbn"
	      }]
	    },
	    paginationData: dataTableComponentData.page,
	
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Receiving Discrepancies ",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "receivingDiscrepancies"
	    },
	
	    onBulkSelectChange: function onBulkSelectChange() {
	      var selectedRows = receivingDiscrepanciesLookup.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass('disabled');
	      } else {
	        $(".action-header-btn .base-btn").addClass('disabled');
	      }
	    },
	
	    onFetch: function onFetch() {
	      var currentData = receivingDiscrepanciesLookup.generateData();
	      receivingDiscrepanciesLookup.showLoadingOverlay();
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterSearchUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  $("#back-to-form").on("click", function () {
	    window.open(backToFormUrl, "_self");
	  });
	
	  function filterSuccessFun(data) {
	    var receivingDiscrepancies = data.content;
	    var page = data.page;
	    receivingDiscrepanciesLookup.setNewData(receivingDiscrepancies);
	    receivingDiscrepanciesLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    receivingDiscrepanciesLookup.hideLoadingOverlay();
	    setExportData(receivingDiscrepanciesLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var receivingDiscrepancies = data.lookupRecevingDiscrepancyJSON.content;
	    var page = data.lookupRecevingDiscrepancyJSON.page;
	    receivingDiscrepanciesLookup.setNewData(receivingDiscrepancies);
	    receivingDiscrepanciesLookup.setPaginationData(page);
	    receivingDiscrepanciesLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    receivingDiscrepanciesLookup.hideLoadingOverlay();
	    setExportData(receivingDiscrepanciesLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var receivingDiscrepancies = data.lookupRecevingDiscrepancyJSON.content;
	    var page = data.lookupRecevingDiscrepancyJSON.page;
	    receivingDiscrepanciesLookup.setNewData(receivingDiscrepancies);
	    receivingDiscrepanciesLookup.setPaginationData(page);
	    receivingDiscrepanciesLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    receivingDiscrepanciesLookup.hideLoadingOverlay();
	    setExportData(receivingDiscrepanciesLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var receivingDiscrepancies = data.lookupRecevingDiscrepancyJSON.content;
	    var page = data.lookupRecevingDiscrepancyJSON.page;
	    receivingDiscrepanciesLookup.removeSavedView(data.target);
	    receivingDiscrepanciesLookup.setNewData(receivingDiscrepancies);
	    receivingDiscrepanciesLookup.setPaginationData(page);
	    receivingDiscrepanciesLookup.hideLoadingOverlay();
	    setExportData(receivingDiscrepanciesLookup.generateData());
	  }
	
	  function errorFun(data) {
	    receivingDiscrepanciesLookup.hideLoadingOverlay();
	  }
	
	  receivingDiscrepanciesLookup.init();
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  function generateSharedModal(discrepancy) {
	    discrepanciesPhotoUploadModal = $((0, _render2.default)(modalHtml, {
	      title: ' Upload Photo',
	      leftAlignTitle: true,
	      body: uploadDiscrepanciesPhotoModalBodyHtml,
	      modalDialogClass: "q-modal-dialog-800",
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: '\n        <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>\n        <a  href="#" class="base-btn purple-btn custom-submit-btn upload-selected-photos disabled">Upload Selected</a>\n        '
	    }));
	    $("body").append(discrepanciesPhotoUploadModal);
	
	    var photosUploader = new _index3.photoUploader({
	      target: '.discrepancies-photos-uploader-body',
	      accept: ['.jpg', '.jpeg'],
	      multiple: true,
	      maxFileSize: 0.5,
	      afterValidSelection: function afterValidSelection() {
	        discrepanciesPhotoUploadModal.find(".upload-selected-photos").removeClass("disabled");
	      },
	      afterInvalidSelection: function afterInvalidSelection() {
	        discrepanciesPhotoUploadModal.find(".upload-selected-photos").addClass("disabled");
	      }
	    });
	
	    photosUploader.init();
	    discrepanciesPhotoUploadModal.modal("show");
	
	    if (shallAllowClick(this)) {
	      $(".upload-selected-photos").on('click', function () {
	        submitModalFlow.showLoadingModal();
	        uploadPhotos(photosUploader.getFiles(), discrepancy);
	      });
	    }
	    discrepanciesPhotoUploadModal.on('hidden.bs.modal', function (e) {
	      discrepanciesPhotoUploadModal.remove();
	    });
	  }
	
	  function uploadPhotosuccess(resp) {
	    if ($.trim(resp) == "true") {
	      discrepanciesPhotoUploadModal.modal("hide");
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        location.href = "";
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      uploadPhotosError();
	    }
	  }
	
	  function uploadPhotosError() {
	    submitModalFlow.hideAllModals();
	    discrepanciesPhotoUploadModal.find(".upload-error").show();
	  }
	
	  function uploadPhotos(photosList, discrepancy) {
	
	    var trackingNumber = discrepancy.redTrackingNum;
	    var discrepancyCode = discrepancy.rddDiscrepancyCode;
	    var redId = discrepancy.redId;
	    var rddId = discrepancy.rddId;
	    discrepanciesPhotoUploadModal.modal("hide");
	    var formData = new FormData();
	    photosList.forEach(function (file) {
	      formData.append("files[]", file);
	    });
	    var photosuploadUrl = uploadPhotosUrl + '&trackingNumber=' + trackingNumber + '&discrepancyCode=' + discrepancyCode + '&redId=' + redId + '&rddId=' + rddId;
	    $.ajax({
	      url: photosuploadUrl,
	      type: 'POST',
	      data: formData,
	      enctype: 'multipart/form-data',
	      processData: false,
	      contentType: false,
	      cache: false,
	      success: uploadPhotosuccess,
	      error: uploadPhotosError
	    });
	  }
	
	  //Generate popup if user trying to delete record
	  function generateDeleteWarningModal(redId, discrepancyCode) {
	    deleteDiscrepanciesModal = $((0, _render2.default)(modalHtml, {
	      title: 'Are you sure you want to delete this discrepancy record',
	      body: deleteDiscrepanciesModalBodyHtml,
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-800",
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: '\n          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a>\n          <a  href="#" class="base-btn purple-btn custom-submit-btn delete-selected-discrepancy">Delete</a>\n          '
	    }));
	
	    $("body").append(deleteDiscrepanciesModal);
	
	    deleteDiscrepanciesModal.modal("show");
	    deleteDiscrepanciesModal.on('hidden.bs.modal', function (e) {
	      deleteDiscrepanciesModal.remove();
	    });
	
	    //click on delete action in lookup event
	    $('body').on('click', '.delete-selected-discrepancy', function (e) {
	      e.preventDefault();
	      location.href = deleteDiscrepancyUrl + '&' + portletNamespace + 'redId=' + redId + '&discrepancyCode=' + discrepancyCode;
	    });
	  }
	
	  //Generate popup if user trying to update record, which is already resolved
	  function generateWarningModal(displayMessage) {
	    resolvedDiscrepanciesModal = $((0, _render2.default)(modalHtml, {
	      title: displayMessage,
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-800",
	      topCloseBtn: true,
	      autoHideTop: true,
	      footerBtns: '\n          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Ok</a>\n          '
	    }));
	
	    $("body").append(resolvedDiscrepanciesModal);
	
	    resolvedDiscrepanciesModal.modal("show");
	    resolvedDiscrepanciesModal.on('hidden.bs.modal', function (e) {
	      resolvedDiscrepanciesModal.remove();
	    });
	  }
	
	  //click on upload photo action in lookup event
	  $('body').on('click', '.upload-photos', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var row = $(".data-table-component").dataTable().api().row(parent);
	      var discrepancy = row.data();
	      //let row = table.row(parent);
	
	      if ((0, _general.isPresent)(discrepancy.redDateResolved)) {
	        $(".upload-photos").prop("disabled", true);
	        generateWarningModal(disabledImageResolvedMessage);
	        $(".upload-photos").prop("disabled", false);
	        return;
	      }
	
	      if (discrepancy.redRecordType === 'D') {
	        $(".upload-photos").prop("disabled", true);
	        generateWarningModal(disabledImageDeletedMessage);
	        $(".upload-photos").prop("disabled", false);
	        return;
	      }
	
	      generateSharedModal(discrepancy);
	    }
	  });
	
	  //On click of Edit from the table view directly 
	  $('body').on('click', '.edit-discrepancy', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = $(".data-table-component").dataTable().api().row(parent);
	    var discrepancy = row.data();
	
	    if ((0, _general.isPresent)(discrepancy.redDateResolved)) {
	      $(".edit-discrepancy").prop("disabled", true);
	      generateWarningModal(editDisabledResolvedMessage);
	      $(".edit-discrepancy").prop("disabled", false);
	      return;
	    }
	
	    if (discrepancy.redRecordType === 'D') {
	      $(".edit-discrepancy").prop("disabled", true);
	      generateWarningModal(editDisabledDeleteMessage);
	      $(".edit-discrepancy").prop("disabled", false);
	      return;
	    }
	
	    var disabledFlag = 0;
	    var createdDate = new Date(discrepancy.redCreatedTime);
	    var currentDate = new Date();
	    var cutOffDate = getCutOffDate(createdDate);
	
	    if (discrepancy.redDataFtp && (currentDate.getTime() >= cutOffDate.getTime() || currentDate.getTime() < createdDate.getTime())) {
	      disabledFlag = 1;
	    }
	
	    location.href = getEditRecordURL + '&' + portletNamespace + 'redId=' + discrepancy.redId + '&disabledFlag=' + disabledFlag;
	  });
	
	  //On click of Edit from the table view directly 
	  $('body').on('click', '.delete-record', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    var row = $(".data-table-component").dataTable().api().row(parent);
	    var discrepancy = row.data();
	
	    if ((0, _general.isPresent)(discrepancy.redDateResolved)) {
	      $(".delete-discrepancy").prop("disabled", true);
	      generateWarningModal(disabledDeleteResolvedMessage);
	      $(".delete-discrepancy").prop("disabled", false);
	      return;
	    }
	
	    if (discrepancy.redRecordType === 'D') {
	      $(".delete-discrepancy").prop("disabled", true);
	      generateWarningModal(disabledDeleteMessage);
	      $(".delete-discrepancy").prop("disabled", false);
	      return;
	    }
	
	    var createdDate = new Date(discrepancy.redCreatedTime);
	    var currentDate = new Date();
	    var cutOffDate = getCutOffDate(createdDate);
	
	    if (currentDate.getTime() >= cutOffDate.getTime() || currentDate.getTime() < createdDate.getTime()) {
	      $(".delete-discrepancy").prop("disabled", true);
	      generateWarningModal(disabledDeleteCutOffMessage);
	      $(".delete-discrepancy").prop("disabled", false);
	      return;
	    }
	
	    generateDeleteWarningModal(discrepancy.redId, discrepancy.rddDiscrepancyCode);
	  });
	
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    var statusTarget = actionList["all"];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, item));
	    });
	    return renderedList.join("");
	  }
	
	  function neededActions(data, row, item) {
	    var action = {
	      icon: item.icon,
	      title: item.title,
	      cls: item.cls,
	      disabled: item.disabled
	    };
	    return action;
	  }
	
	  function getCutOffDate(date) {
	    date.setHours(0);
	    date.setMinutes(0);
	    date.setSeconds(0);
	    var createdDay = new Date(date).getDay();
	    var createdDate = new Date(date).getDate();
	    var createdTime = new Date(date).getTime();
	    var cutOffDate;
	
	    //for saturday , it should go in else loop
	    if (createdDay !== 6) {
	      cutOffDate = new Date(createdTime + (6 - createdDay) * 1000 * 60 * 60 * 24 + 1000 * 60 * 60 * 11);
	    } else {
	      cutOffDate = new Date(createdTime + (13 - createdDay) * 1000 * 60 * 60 * 24 + 1000 * 60 * 60 * 11);
	    }
	
	    if (cutOffDate.getMonth() > date.getMonth()) {
	      var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getTime();
	      cutOffDate = new Date(lastDayOfMonth + 1000 * 60 * 60 * 11);
	    }
	
	    return cutOffDate;
	  }
	
	  function initExport() {
	    var exportObj = {
	      title: $(targetSelector).data("export-popup-title"),
	      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
	      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent(portletNamespace);
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(exportUrl, currentData, portletNamespace);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  initExport();
	  setExportData(receivingDiscrepanciesLookup.generateData());
	
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var targetSelector = "#relese-order-detail";
	
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	  var orderReleaseUrl = mainEl.data("order-release-url");
	  var detailPageUrl = mainEl.data("page-refresh-url");
	  var releaseBtn = mainEl.find(".release-order-btn");
	
	  var releaseModal = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Release Order(s)',
	    confirmModalBody: '<div class="q-marg-all-xl">\n                          <div class="q-marg-vert-md">\n                            Confirming the manual release of this Order(s) will trigger it\'s original release process.\n                          </div>\n                          <div class="q-marg-vert-md">\n                            Once released, order status will be updated.\n                          </div>\n                        </div>',
	    confirmModalBtnText: 'Release',
	    modalDialogClass: "q-modal-dialog-500",
	    onConfirmClick: function onConfirmClick() {
	      releaseModal.showLoadingModal();
	      releaseOrder({ url: orderReleaseUrl, success: releaseSuccess, error: releaseError });
	    }
	  });
	
	  releaseModal.init();
	
	  $(releaseBtn).on("click", function (e) {
	    e.preventDefault();
	    releaseModal.showConfirmModal();
	  });
	
	  function releaseOrder(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error;
	
	    $.ajax({
	      url: url,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function releaseSuccess(data) {
	    if (data.response === "success") {
	      _EditChecker2.default.setPageClean();
	      releaseModal.showSuccessModal();
	      setTimeout(function () {
	        location.href = detailPageUrl;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      releaseModal.showFailureModal();
	    }
	  }
	
	  function releaseError() {
	    releaseModal.showFailureModal();
	  }
	});

/***/ },
/* 751 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  "actions": [{
	    title: "Release Order",
	    cls: "release-order",
	    icon: "hourglass",
	    disabled: false
	  }]
	};

/***/ },
/* 752 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var releaseOrderLookupFieldDropdown = exports.releaseOrderLookupFieldDropdown = [{
		title: "POS Location Number",
		value: "posLocation"
	}, {
		title: "VZW Order Number",
		value: "vzOrderNumber"
	}, {
		title: "SAP Delivery Number",
		value: "sapNumber"
	}, {
		title: "Order Type",
		value: "type"
	}, {
		title: "Order Status",
		value: "status"
	}];

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(754);
	
	__webpack_require__(750);

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _releaseOrderLookupFieldDropdown = __webpack_require__(752);
	
	var _actionOptions = __webpack_require__(751);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var actionList = _actionOptions.actionOptions;
	
	var targetSelector = "#release-order-lookup-outer";
	(0, _run2.default)(targetSelector, function () {
	  var entryElement = $(targetSelector);
	  var dataTableComponentData = entryElement.data("release-order-lookup-data");
	  var portletNamespace = $(targetSelector).data("portlet-namespace");
	  var savedViews = entryElement.data("saved-views");
	  var filterSearchUrl = $(targetSelector).data("filter-search-url");
	  var saveViewURL = $(targetSelector).data("save-view-url");
	  var deleteViewURL = $(targetSelector).data("delete-view-url");
	  var detailURL = $(targetSelector).data("release-order-detail-url");
	  var releaseOrderUrl = entryElement.data("release-order-url");
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var exportModal = new _filtersutil.buildExport();
	  var exportUrl = $(targetSelector).data("export-url");
	  var targetObject = "";
	
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	
	  var releaseOrderLookup = new _index2.default({
	
	    target: $("#release-order-lookup-wrapper"),
	    minWidthClass: "q-min-width-sm-til-md",
	    mobileColumns: [{
	      data: "ordParOrderNumber",
	      title: "VZW Order Number",
	      render: createDetailLink
	    }, {
	      data: "ordParOrderId",
	      title: "SAP Delivery Number"
	    }, {
	      data: "ordOrderType",
	      title: "Order Type"
	    }, {
	      data: "ordStatus",
	      title: "Order Status"
	    }, {
	      data: "ordPosLocation",
	      title: "POS Location Number"
	    }, {
	      data: "ordCreatedDate",
	      title: "Date Recieved",
	      render: formatCreateDate
	    }],
	
	    tableSearch: true,
	    // REQUIRED: search input info
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: targetObject != "" ? targetObject.value[0] : ""
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _releaseOrderLookupFieldDropdown.releaseOrderLookupFieldDropdown
	    },
	    // OPTIONAL: Set Saved View Array
	    savedViews: savedViews,
	    bulkSelect: false,
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      // Not required, just to show you can
	      columnDefs: [{}],
	      // Not required, just to show you can
	      order: [[5, 'desc']],
	      columns: [{
	        data: "ordParOrderNumber",
	        render: renderActionWrap,
	        orderable: false,
	        title: "Actions",
	        class: "dtc-action-column"
	      }, {
	        data: "ordParOrderNumber",
	        title: "VZW Order Num",
	        class: "dtc-min-width-sm",
	        render: createDetailLink
	      }, {
	        data: "ordParOrderId",
	        title: "SAP Delivery Num",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "ordPosLocation",
	        title: "POS Location",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "ordOrderType",
	        title: "Order Type",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "ordConsolidatedCount",
	        title: "Consolidated Count",
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "ordCreatedDate",
	        title: "Date Received",
	        render: formatCreateDate,
	        class: 'dtc-min-width-sm'
	      }, {
	        data: "ordStatus",
	        title: "Order Status",
	        class: 'dtc-min-width-sm'
	      }]
	    },
	    paginationData: dataTableComponentData.page,
	
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Release Orders ",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "releaseOrder"
	    },
	
	    onBulkSelectChange: function onBulkSelectChange() {
	      var selectedRows = releaseOrderLookup.getBulkSelectedData();
	      $("th.dtc-action-column").html(renderActionHeaderWrap());
	      if (selectedRows.length >= 2) {
	        $(".action-header-btn .base-btn").removeClass('disabled');
	      } else {
	        $(".action-header-btn .base-btn").addClass('disabled');
	      }
	    },
	
	    onFetch: function onFetch() {
	      var currentData = releaseOrderLookup.generateData();
	      releaseOrderLookup.showLoadingOverlay();
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterSearchUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData, portletNamespace) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  function formateDate(createdDate, type, data) {
	    if (createdDate != null && createdDate != "") {
	      var date = moment(createdDate).toDate(); // format yyyy-MM-DD
	      var month = date.getMonth() + 1;
	      var today = new Date();
	      today.setHours(0, 0, 0, 0);
	      date.setHours(0, 0, 0, 0);
	      var oneDay = 24 * 60 * 60 * 1000;
	      var diffDays = Math.round(Math.abs((today.getTime() - date.getTime()) / oneDay));
	      var friendlyText = "";
	      var datePillHTML = "";
	      if (diffDays < 100) {
	        friendlyText = diffDays.toString() + ' Days Ago';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      }
	      if (diffDays == 0) {
	        friendlyText = 'Today';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      } else if (diffDays == 1) {
	        friendlyText = 'Yesterday';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      }
	      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
	    } else {
	      return "";
	    }
	  }
	
	  function formatCreateDate(createdDate, type, data) {
	    var d = new Date(createdDate);
	    return d.toLocaleString();
	  }
	
	  function createDetailLink(data, type, row) {
	    var detailPageHTML = '<div class="q-marg-all-xs-at-md">\n                        <a href="' + detailURL + '&' + portletNamespace + 'ordId=' + row.ordId + '&' + portletNamespace + 'masterId=' + row.ordMasterId + '">\n                        ' + row.ordParOrderNumber + ' </a> </div>';
	    return detailPageHTML;
	  }
	
	  function formateDate(dateReceived, type, data) {
	    if (dateReceived != null && dateReceived != "") {
	      var date = new Date(dateReceived);
	      var month = date.getMonth() + 1;
	      var today = new Date();
	      var oneDay = 24 * 60 * 60 * 1000;
	      today.setHours(0, 0, 0, 0);
	      date.setHours(0, 0, 0, 0);
	      var diffDays = Math.round(Math.abs((today.getTime() - date.getTime()) / oneDay));
	      var friendlyText = "";
	      var datePillHTML = "";
	      if (diffDays < 100) {
	        friendlyText = diffDays.toString() + ' Days Ago';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      }
	      if (diffDays == 0) {
	        friendlyText = 'Today';
	      } else if (diffDays == 1) {
	        friendlyText = 'Yesterday';
	      }
	      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
	    } else {
	      return "";
	    }
	  }
	
	  function filterSuccessFun(data) {
	    var releaseOrders = data.content;
	    var page = data.page;
	    releaseOrderLookup.setNewData(releaseOrders);
	    releaseOrderLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    releaseOrderLookup.hideLoadingOverlay();
	    setExportData(releaseOrderLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var releaseOrders = data.lookupReleaseOrderJSON.content;
	    var page = data.lookupReleaseOrderJSON.page;
	    releaseOrderLookup.setNewData(releaseOrders);
	    releaseOrderLookup.setPaginationData(page);
	    releaseOrderLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    releaseOrderLookup.hideLoadingOverlay();
	    setExportData(releaseOrderLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var releaseOrders = data.lookupReleaseOrderJSON.content;
	    var page = data.lookupReleaseOrderJSON.page;
	    releaseOrderLookup.setNewData(releaseOrders);
	    releaseOrderLookup.setPaginationData(page);
	    releaseOrderLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    releaseOrderLookup.hideLoadingOverlay();
	    setExportData(releaseOrderLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var releaseOrders = data.lookupReleaseOrderJSON.content;
	    var page = data.lookupReleaseOrderJSON.page;
	    releaseOrderLookup.removeSavedView(data.target);
	    releaseOrderLookup.setNewData(releaseOrders);
	    releaseOrderLookup.setPaginationData(page);
	    releaseOrderLookup.hideLoadingOverlay();
	    setExportData(releaseOrderLookup.generateData());
	  }
	
	  function errorFun(data) {
	    releaseOrderLookup.hideLoadingOverlay();
	  }
	
	  releaseOrderLookup.init();
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  $("body").on("click", ".release-order", function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      // Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
	      var pIndex = $(this).closest(".dropdown-menu").data("parent-index");
	      // Get the row based on the parent...
	      var parent = $(".dropdown-parent-" + pIndex).parents("tr");
	      // Get the row data
	      var row = $(".data-table-component").dataTable().api().row(parent);
	
	      if ($(this).hasClass("release-order")) {
	        processReleaseOrder(row);
	      }
	    }
	  });
	
	  function processReleaseOrder(row) {
	    var submitModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: "Release Order(s)",
	      confirmModalBody: '<div class="q-marg-all-xl">\n                          <div class="q-marg-vert-md">\n                            Confirming the manual release of this Order(s) will trigger it\'s original release process.\n                          </div>\n                          <div class="q-marg-vert-md">\n                            Once released, order status will be updated.\n                          </div>\n                        </div>',
	      confirmModalBtnText: "Release",
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        submitModal.showLoadingModal();
	        var data = row.data();
	        releaseOrder(row, data);
	
	        function releaseOrder(row, releaseOrder) {
	          $.ajax({
	            url: releaseOrderUrl,
	            type: "POST",
	            dataType: "JSON",
	            data: {
	              ordId: releaseOrder.ordId,
	              masterId: releaseOrder.ordMasterId
	            },
	            success: function success(data) {
	              if (data.response === "success") {
	                submitModal.showSuccessModal();
	                setTimeout(function () {
	                  location.reload();
	                }, window.constants.SUCCESS_MODAL_TIMEOUT);
	              } else {
	                submitModal.showFailureModal();
	              }
	            },
	            error: function error(data) {
	              submitModal.showFailureModal();
	            }
	          });
	        }
	      }
	    });
	    submitModal.init();
	    submitModal.showConfirmModal();
	  }
	
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    var statusTarget = actionList["all"];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, item));
	    });
	    return renderedList.join("");
	  }
	
	  function neededActions(data, row, item) {
	    var action = {
	      icon: item.icon,
	      title: item.title,
	      cls: item.cls,
	      disabled: item.disabled
	    };
	    return action;
	  }
	
	  function initExport() {
	    var exportObj = {
	      title: $(targetSelector).data("export-popup-title"),
	      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
	      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent(portletNamespace);
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(exportUrl, currentData, portletNamespace);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  initExport();
	  setExportData(releaseOrderLookup.generateData());
	
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(756);
	
	__webpack_require__(757);

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _scheduleReportModal = __webpack_require__(220);
	
	var _scheduleReportModal2 = _interopRequireDefault(_scheduleReportModal);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _additionalFilterLogic = __webpack_require__(146);
	
	var _filtersLegacy = __webpack_require__(147);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	var _jqueryDataTableChildren = __webpack_require__(226);
	
	var _fontAwesomeHelpers = __webpack_require__(224);
	
	var _pagination = __webpack_require__(143);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var statusHtml = __webpack_require__(1420);
	var actionsHtml = __webpack_require__(1411);
	
	
	__webpack_require__(1099);
	
	// This was developed using inventory as an example, there may be
	// unnecessary pieces carried over that were missed in cleanup
	(0, _run2.default)("#lookup-reports-outer", function (lookupOuter) {
	  window.migrateLookupFrontend = true;
	  var data = {};
	
	  // set namespace data up-front...cause of namespace garbage
	  data.namespace = lookupOuter.data("namespace");
	  var noop = function noop() {};
	
	  var elementsMap = {
	    table: '.lookup-table',
	    paginationOuter: ".pagination",
	    searchTextInput: '#' + data.namespace + 'searchText',
	    showAdditionalFilterInput: '#' + data.namespace + 'showAdditionalFilter',
	    additionalFilterOuter: '#' + data.namespace + 'additionalFilter',
	    itemsPerPageSelect: '#' + data.namespace + 'itemsPerPage',
	    sortFieldHiddenInput: '#' + data.namespace + 'sortField',
	    sortTypeHiddenInput: '#' + data.namespace + 'sortType',
	    form: '#' + data.namespace + 'filter-form',
	    emptyDiv: '#' + data.namespace + 'lookup-reports-table .dataTables_empty',
	    clearFilters: '#' + data.namespace + 'clearFilters',
	    tableHeaderItems: ".table-header-item",
	    warehouseSelect: "#warehouse-location-id",
	    crtIdInp: '.modal-crt-id',
	    // Below is dynamically searched through document because they are dynamically added
	    filterStatusCheckboxes: '#' + data.namespace + 'filter-status a input[type="checkbox"]',
	    scheduleReportTableBody: '#' + data.namespace + 'lookup-reports-table'
	  };
	
	  // elements at document scope
	  var docElementsMap = {};
	
	  var defaultLookupDataTableOptions = {
	    "searching": false,
	    "paging": false,
	    "ordering": false,
	    "info": false
	  };
	
	  var els = {};
	  // Should Be Using Store Pattern,
	  // but don't have time to fully overhaul,
	  // so we will just store all data in const data
	
	  setElements();
	  setData();
	
	  els.sortFieldHiddenInput.val('crtName');
	  els.sortTypeHiddenInput.val('asc');
	  els.itemsPerPageSelect.val(els.table.data("reports").page.size);
	
	  var paginator = (0, _pagination2.default)(els.lookupOuter, {
	    tableData: data.reports,
	    lang: data.lang
	  });
	
	  var statusClassMap = {
	    "Scheduled": "q-pill-blue q-pill-stretch",
	    "Not Scheduled": "q-pill-light-grey q-pill-stretch"
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, lookupOuter);
	    (0, _selectorHelpers.setElementsFromScope)(els, docElementsMap, (0, _jquery2.default)(document));
	    els.lookupOuter = lookupOuter;
	  }
	
	  function setData() {
	    setReportsData(els.table.data("reports"));
	    data.filterReportsUrl = els.lookupOuter.data("filter-reports-url");
	    data.exportReportsUrl = els.lookupOuter.data("export-reports-url");
	    data.viewReportUrl = els.lookupOuter.data("view-report-url");
	    data.getReportParamsUrl = els.lookupOuter.data("get-report-params-url");
	    data.scheduleReportUrl = els.lookupOuter.data("schedule-report-url");
	
	    data.lang = (0, _collectDataAttributesFor2.default)(els.lookupOuter.get(0), { prefix: "lang", camelize: false });
	  }
	
	  function setReportsData(d) {
	    data.reports = d;
	  }
	
	  var lookUpdateDataTable = els.table.dataTable(_extends({}, defaultLookupDataTableOptions, {
	    data: data.reports.content,
	    "columnDefs": [],
	    columns: [{
	      data: "crtName",
	      render: renderCrtName
	    }, {
	      data: "crtDescription"
	    }, {
	      data: "schedulingStatus",
	      render: renderSchedulingStatus /*,
	                                     {
	                                      data: "actions",
	                                      render: renderActions
	                                     }*/
	    }]
	  }));
	
	  function renderCrtName(crtName, type, row) {
	    var url = data.viewReportUrl + "&crtId=" + row.crtId;
	    return "<a href='" + url + "'>" + crtName + "</a>";
	  }
	
	  function getStatusClass(val) {
	    return statusClassMap[val];
	  }
	
	  function renderSchedulingStatus(data, type, row) {
	    return (0, _render2.default)(statusHtml, {
	      statusText: data,
	      statusClass: getStatusClass(row.schedulingStatus)
	    });
	  }
	
	  function renderActions(data, type, row) {
	    return "<a class='ri-link-icon schedule-report' href='#'><i class='fa fa-history fa-lg'/></a>";
	    //onClick='onScheduleReportButtonClick(" + row.crtId + ")'
	  }
	
	  els.tableHeaderItems.on("click", onTableHeaderItemClick);
	
	  function onTableHeaderItemClick() {
	    var headerElement = (0, _jquery2.default)(this);
	    (0, _filtersLegacy.applySortingRelatedIconsAndSetHiddenFields)({
	      headerElement: headerElement,
	      elements: els,
	      sortField: headerElement.data('sort-field'),
	      callback: postLookupSearchHelper
	    });
	  }
	
	  els.scheduleReportTableBody.on('click', '.schedule-report', onScheduleReportButtonClick);
	
	  function onScheduleReportButtonClick() {
	    var rowData = lookUpdateDataTable.api().row((0, _jquery2.default)(this).closest('tr')).data();
	    //console.log('lookup.data.getReportParamsUrl - ', data.getReportParamsUrl);
	    //console.log('rowData.crtId - ', rowData.crtId);
	    (0, _scheduleReportModal2.default)(data.getReportParamsUrl, data.scheduleReportUrl, rowData.crtId);
	  }
	
	  var debouncedColWidthMatcher = _underscore2.default.debounce(function () {
	    (0, _jqueryDataTableChildren.matchChildrenWidthsToParentCols)({ table: els.table });
	  }, 50);
	
	  // Make sure all child row td's match the parent table
	  // header col width's on resize (jquery dataTable
	  // plugin is using some computation other than percent
	  // to set the col widths on resize, so we must compensate)
	  (0, _jquery2.default)(window).resize(debouncedColWidthMatcher);
	
	  // This event notably comes from the backend js file,
	  // this is a work-around for now to allow the abundance of
	  // triggerSearch calls to be ported to the front
	  els.lookupOuter.on('exec-search', handleExecSearchEvent);
	
	  function handleExecSearchEvent(e, pageNumber) {
	    postLookupSearchHelper({ pageNumber: pageNumber });
	  }
	
	  function postLookupSearchHelper() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$pageNumber = _ref.pageNumber,
	        pageNumber = _ref$pageNumber === undefined ? 0 : _ref$pageNumber;
	
	    postLookupSearch({ pageNumber: pageNumber, elements: els, success: receivePostLookupSearch });
	  }
	
	  function collectStatusValues() {
	    return (0, _underscore2.default)((0, _jquery2.default)(elementsMap.filterStatusCheckboxes).filter(":checked").toArray()).map(function (el) {
	      return (0, _jquery2.default)(el).val();
	    });
	  }
	
	  var searchRequest = void 0;
	
	  function postLookupSearch() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    //console.log("postLookupSearch - start");
	    //console.log(data.filterReportsUrl);
	    var elements = options.elements,
	        pageNumber = options.pageNumber,
	        size = options.size,
	        orderBy = options.orderBy,
	        orderByType = options.orderByType,
	        url = options.url,
	        _options$success = options.success,
	        _success = _options$success === undefined ? noop : _options$success,
	        _options$error = options.error,
	        error = _options$error === undefined ? noop : _options$error;
	    // Show loading overlay
	
	
	    if (searchRequest) {
	      searchRequest.abort();
	    }
	
	    searchRequest = _jquery2.default.ajax({
	      url: url || data.filterReportsUrl,
	      type: 'POST',
	      data: getCurrentPageDataForSearch(options),
	      dataType: 'JSON',
	      // DONT DO THIS
	      // async: false,
	      success: function success(data) {
	        //console.log("postLookupSearch.ajaxSuccess - start");
	        // hide loading overlay
	        searchRequest = null;
	        _success(data);
	        //console.log("postLookupSearch.ajaxSuccess - finish");
	      },
	      error: error
	    });
	    //console.log("postLookupSearch - finish");
	  };
	
	  function receivePostLookupSearch(newData) {
	    //console.log("receivePostLookupSearch");
	    lookUpdateDataTable.fnClearTable();
	    setReportsData(newData);
	    if (data.reports.content.length > 0) {
	      lookUpdateDataTable.fnAddData(data.reports.content);
	    } else {
	      els.emptyDiv.text(data.lang['lookup-filter-no-results-found']);
	    }
	    paginator.setTableData(data.reports);
	  }
	
	  function getCurrentPageDataForSearch(_ref2) {
	    var _$$param;
	
	    var _ref2$elements = _ref2.elements,
	        elements = _ref2$elements === undefined ? els : _ref2$elements,
	        pageNumber = _ref2.pageNumber,
	        size = _ref2.size,
	        orderBy = _ref2.orderBy,
	        orderByType = _ref2.orderByType;
	
	    var dataStr = elements.form.serialize();
	    var additionalDataStr = _jquery2.default.param((_$$param = {}, _defineProperty(_$$param, data.namespace + 'page', (0, _general.isPresent)(pageNumber) ? pageNumber : 0), _defineProperty(_$$param, data.namespace + 'size', (0, _general.isPresent)(size) ? size : elements.itemsPerPageSelect.val()), _defineProperty(_$$param, data.namespace + 'orderBy', (0, _general.isPresent)(orderBy) ? orderBy : elements.sortFieldHiddenInput.val()), _defineProperty(_$$param, data.namespace + 'orderByType', orderByType || elements.sortTypeHiddenInput.val()), _$$param));
	
	    //console.log("getCurrentPageDataForSearch - finish");
	    return dataStr + "&" + additionalDataStr;
	  }
	
	  var filterFields = [{
	    value: "crtName",
	    text: "Report Name"
	  }, {
	    value: "crtDescription",
	    text: "Description"
	  }, {
	    value: "schedulingStatus",
	    text: "Status"
	  }];
	
	  // setOptionsForSelect({
	  //   selectElement: els.filterFieldsSelect,
	  //   list: filterFields,
	  //   initialSelectValue: "crtName"
	  // });
	});

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _typeAheadSource = __webpack_require__(71);
	
	var _typeAheadSource2 = _interopRequireDefault(_typeAheadSource);
	
	var _scheduleReportModal = __webpack_require__(220);
	
	var _scheduleReportModal2 = _interopRequireDefault(_scheduleReportModal);
	
	var _reportsUtil = __webpack_require__(219);
	
	var _general = __webpack_require__(5);
	
	var _ConfigPanel = __webpack_require__(109);
	
	var _ConfigPanel2 = _interopRequireDefault(_ConfigPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//PowerBI Client v2.10.3
	__webpack_require__(480);
	__webpack_require__(275);
	
	// const targetSelector = "#p_p_id_fxobulkshipment_WAR_rmsportlet_";
	var targetSelector = ".reports-outer";
	// const targetSelector = "#p_p_id_productnew_WAR_productportlet_";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  var mainEl = (0, _jquery2.default)(targetSelector);
	
	  var cancelModal = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(11), {
	    topCloseBtn: true,
	    title: 'Are you sure you want to cancel this schedule',
	    footerBtns: '<a href="#" class="base-btn v2-btn purple-btn m-close-btn">Cancel</a>\
	      <a href="#" class="base-btn purple-btn cancel-report-btn">Submit</a>',
	    body: "<div class='q-pad-vert-xl q-marg-horz-xl'>Once you cancel this schedule, this report will no longer be sent to the previous recipients.</div>"
	  }));
	
	  (0, _jquery2.default)('body').append(cancelModal);
	
	  var data = {};
	  setData();
	  function setData() {
	    data.getReportParamsUrl = outerEl.data("get-report-params-url");
	    data.scheduleReportUrl = outerEl.data("schedule-report-url");
	    data.cancelScheduleUrl = outerEl.data("cancel-schedule-url");
	    data.getReportUrl = outerEl.data("get-report-url");
	    data.reportId = outerEl.data("report-id");
	    data.report = outerEl.data("report");
	    data.params = outerEl.data("params");
	    data.paramDetails = outerEl.data("param-details");
	    data.schedules = outerEl.data("schedules");
	    data.scheduleRows = [];
	
	    //console.log("data.report", data.report);
	    //console.log("data.params", data.params);
	    //console.log("data.paramDetails", data.paramDetails);
	    //console.log("data.schedules", data.schedules);
	  }
	
	  var noScheduledReportsEl = mainEl.find('.no-scheduled-reports-notification');
	  var scheduleCountPill = mainEl.find('#scheduleCountPill');
	  var reportParamsInputAnchor = mainEl.find('#reportParamsInputAnchor');
	  var reportScheduleListOuter = mainEl.find('.report-schedule-list-outer');
	  var customReportingForm = mainEl.find('#customReportingForm');
	  var crtId = mainEl.find('#crtId');
	  var expandIcon = mainEl.find('#expandScheduleIcon');
	  var createScheduleBtn = mainEl.find('.create-schedule-btn');
	  var createScheduleBtnParams = mainEl.find('.create-schedule-btn-w-params');
	  var createSechduleBtn2 = mainEl.find('.scheduled-reports-create-new-btn-div');
	  var extraDetailForCacheFromServer = mainEl.data("extra-detail-for-cache-from-server");
	
	  //$('#reportFrame').hide();
	
	  //START: Page JS
	  (0, _jquery2.default)('.top-close-btn').click(function (e) {
	    cancelModal.modal("hide");
	  });
	
	  (0, _jquery2.default)('#expandScheduleIcon').click(function (e) {
	    e.preventDefault();
	    (0, _jquery2.default)('#scheduleCountPill').toggleClass("hidden");
	  });
	
	  (0, _jquery2.default)('.expand-icon').click(function (e) {
	    e.preventDefault();
	    (0, _jquery2.default)(this).toggleClass("fa-compress fa-expand");
	  });
	
	  (0, _jquery2.default)('#runReportBtn').click(function (e) {
	    e.preventDefault();
	
	    if (!(0, _jquery2.default)("#customReportingForm").valid()) {
	      return false;
	    }
	    getReportUrl();
	  });
	
	  _jquery2.default.validator.addMethod('validCustomDateRate', function validCustomDateRate() {
	    var date1 = (0, _jquery2.default)('#DATE_RANGE1').val();
	    var date2 = (0, _jquery2.default)('#DATE_RANGE2').val();
	    var dateRange = (0, _jquery2.default)('#DATE_RANGE').val();
	    if (dateRange != 'customDate') {
	      return true;
	    }
	    if ((0, _general.isPresent)(date1) && (0, _general.isPresent)(date2)) {
	      var dateRange1 = new Date(date1);
	      var dateRange2 = new Date(date2);
	
	      return dateRange1 <= dateRange2;
	    } else if (!(0, _general.isPresent)(date1) || !(0, _general.isPresent)(date2)) {
	      return true;
	    }
	  }, 'Please enter dates in order.');
	
	  _jquery2.default.validator.addMethod('bothDatesExists', function bothDatesExists() {
	    var date1 = (0, _jquery2.default)('#DATE_RANGE1').val();
	    var date2 = (0, _jquery2.default)('#DATE_RANGE2').val();
	    return (0, _general.isPresent)(date1) && (0, _general.isPresent)(date2);
	  }, 'Both start and end dates are required.');
	
	  (0, _jquery2.default)("#customReportingForm").validate({
	    errorPlacement: function errorPlacement(error, element) {
	
	      var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        (0, _jquery2.default)(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    },
	
	    // Place all your validation rules here!!!
	    rules: {
	      "DATE_RANGE1": {
	        validCustomDateRate: true,
	        bothDatesExists: true
	      }
	    }
	  });
	
	  function serializeForm(form) {
	    var o = {};
	    var a = form.serializeArray();
	
	    _jquery2.default.each(a, function () {
	      var el = (0, _jquery2.default)("#" + this.name);
	      if (el.hasClass('split-button')) {
	        this.value = (0, _jquery2.default)("#" + this.name + "-values").val().join(",");
	      }
	
	      if (o[this.name] !== undefined) {
	        if (!o[this.name].push) {
	          o[this.name] = [o[this.name]];
	        }
	        o[this.name].push(this.value || '');
	      } else {
	        o[this.name] = this.value || '';
	      }
	    });
	    return o;
	  };
	
	  createScheduleBtn.click(function (e) {
	    createScheduleModal([]);
	  });
	
	  createScheduleBtnParams.click(function (e) {
	    e.preventDefault();
	    var isDisabled = (0, _jquery2.default)(this).attr("disabled") == "disabled";
	    if (!isDisabled) {
	      var reportParamInput = serializeForm(customReportingForm);
	      createScheduleModal(reportParamInput);
	    }
	  });
	
	  function createScheduleModal(reportParamInput) {
	    (0, _scheduleReportModal2.default)(data.getReportParamsUrl, data.scheduleReportUrl, data.reportId, reportParamInput, { jobId: 0 }, function (response) {
	
	      data.schedules.scheduledJobsList.push(response.data);
	      checkDisplayNoScheduledReports();
	      updateScheduleCountPill();
	      displaySchedules();
	    });
	  }
	
	  checkDisplayNoScheduledReports();
	  updateScheduleCountPill();
	  (0, _reportsUtil.displayCustomReporting)(mainEl, reportParamsInputAnchor, data.params, data.paramDetails, false);
	  displaySchedules();
	
	  function displaySchedules() {
	    //console.log("data.schedules.scheduledJobsList", data.schedules.scheduledJobsList);
	    reportScheduleListOuter.empty();
	    if (data.schedules.scheduledJobsList == null) {
	      data.schedules.scheduledJobsList = [];
	    }
	
	    data.schedules.scheduledJobsList.forEach(function (schedule, index) {
	      var recipients = [];
	      if (schedule.email) {
	        recipients = schedule.email.split(';');
	      }
	
	      schedule.reportParams.forEach(function (param, index) {
	        param.displayValue = (0, _reportsUtil.getDropDownDisplayValue)(mainEl, param.cspKey, data.paramDetails, param.cspValue);
	      });
	
	      var scheduleRow = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(1418), {
	        scheduleName: schedule.jobName,
	        jobId: schedule.jobId,
	        jobName: schedule.jobName,
	        nextScheduledRun: schedule.nextRunTime,
	        endRun: schedule.jobEndDate,
	        reportParams: schedule.reportParams,
	        paramDetails: data.paramDetails,
	        runFrequency: schedule.runFrequency,
	        recipients: recipients
	      }));
	      scheduleRow.find(".delete-report-schedule").on("click", onCancelScheduleClick);
	      scheduleRow.find(".edit-report-schedule").on("click", onEditScheduleClick);
	      scheduleRow.appendTo(reportScheduleListOuter);
	      data.scheduleRows[schedule.jobId] = scheduleRow;
	    });
	  }
	
	  function onCancelScheduleClick() {
	    //console.log(data.cancelScheduleUrl);
	    var cancelButton = (0, _jquery2.default)(this);
	
	    cancelModal.data("jobId", cancelButton.data("jobId"));
	    cancelModal.data("jobName", cancelButton.data("jobName"));
	    cancelModal.modal("show");
	    cancelModal.on("click", ".m-close-btn", function () {
	      cancelModal.modal("hide");
	    });
	  }
	
	  cancelModal.on("click", ".cancel-report-btn", function () {
	    cancelSchedule(cancelModal.data("jobId"), cancelModal.data("jobName"), function (response) {
	      var removeId = null;
	      //console.log('cancelModal.data("jobId")', cancelModal.data("jobId"));
	      data.schedules.scheduledJobsList = _jquery2.default.grep(data.schedules.scheduledJobsList, function (schedule) {
	        return schedule.jobId != cancelModal.data("jobId");
	      });
	      checkDisplayNoScheduledReports();
	      updateScheduleCountPill();
	      displaySchedules();
	      data.scheduleRows[cancelModal.data("jobId")].hide();
	      cancelModal.modal("hide");
	    });
	  });
	
	  function cancelSchedule(jobId, jobName, successCallback) {
	    _jquery2.default.ajax({
	      url: data.cancelScheduleUrl,
	      type: 'POST',
	      data: { jobId: jobId, jobName: jobName },
	      dataType: 'JSON',
	      // DONT DO THIS
	      // async: false,
	      success: successCallback,
	      error: function error(_error) {
	        //console.log('Error Returned: ', error);
	      }
	    });
	  }
	
	  function onEditScheduleClick() {
	    //console.log(data.cancelScheduleUrl);
	    var reportParamInput = [];
	    var scheduleParams = {};
	    var jobId = (0, _jquery2.default)(this).data("jobId");
	
	    data.schedules.scheduledJobsList.forEach(function (curSched, index) {
	      if (curSched.jobId == jobId) {
	        scheduleParams.jobName = curSched.jobName;
	        scheduleParams.dayOfMonth = curSched.dayOfMonth;
	        scheduleParams.commaSepDays = curSched.commaSepDays;
	        scheduleParams.jobEndDate = curSched.jobEndDate;
	        scheduleParams.runTime = curSched.runTime;
	        scheduleParams.runFrequency = curSched.runFrequency;
	        scheduleParams.specificDay = curSched.specificDay;
	        scheduleParams.email = curSched.email;
	        scheduleParams.jobId = curSched.jobId;
	
	        curSched.reportParams.forEach(function (param, index) {
	          reportParamInput[param.cspKey] = param.cspValue;
	        });
	      }
	    });
	
	    (0, _scheduleReportModal2.default)(data.getReportParamsUrl, data.scheduleReportUrl, data.reportId, reportParamInput, scheduleParams, function (response) {
	      replaceSchedule(response.data);
	      checkDisplayNoScheduledReports();
	      updateScheduleCountPill();
	      displaySchedules();
	    });
	  }
	
	  function replaceSchedule(schedule) {
	    var replaceIndex = -1;
	
	    data.schedules.scheduledJobsList.forEach(function (curSchedule, index) {
	      if (curSchedule.jobId == schedule.jobId) {
	        replaceIndex = index;
	      }
	    });
	
	    if (replaceIndex >= 0) {
	      data.schedules.scheduledJobsList[replaceIndex] = schedule;
	    }
	  }
	
	  function updateScheduleCountPill() {
	    if (data.schedules.scheduledJobsList == null || data.schedules.scheduledJobsList.length === 0) {
	      scheduleCountPill.text('No Schedules Saved');
	      expandIcon.hide();
	    } else if (data.schedules.scheduledJobsList.length > 1) {
	      scheduleCountPill.text(data.schedules.scheduledJobsList.length + ' Schedules Saved');
	      expandIcon.show();
	    } else {
	      scheduleCountPill.text('1 Schedule Saved');
	      expandIcon.show();
	    }
	  }
	
	  function checkDisplayNoScheduledReports() {
	    if (data.schedules.scheduledJobsList == null || data.schedules.scheduledJobsList.length === 0) {
	      noScheduledReportsEl.show();
	      createSechduleBtn2.hide();
	    } else {
	      noScheduledReportsEl.hide();
	      createSechduleBtn2.show();
	    }
	  }
	
	  function getReportUrl() {
	    var reqData = customReportingForm.serialize();
	    reqData += "&reportId=" + data.reportId;
	
	    var popupWindow = void 0;
	    //Incase of Cognos report, open window
	    if (data.report.crtReportType == null || data.report.crtReportType != null && data.report.crtReportType != "PBI") {
	      popupWindow = window.open('about:blank', '_blank');
	    }
	
	    var searchRequest = _jquery2.default.ajax({
	      url: data.getReportUrl,
	      type: 'POST',
	      data: reqData,
	      dataType: 'JSON',
	      // DONT DO THIS
	      // async: false,
	      success: function success(urlResponse) {
	        /*if($("#expandCustomIcon").hasClass('fa-compress')){
	          $("#expandCustomIcon").trigger('click');
	        }*/
	
	        //$("#reportFrame").show();
	        //$("#reportIFrame").attr("src", urlResponse.url);
	
	        //If cognos report, open cognos report url in new window. ...
	        if (urlResponse != null && urlResponse.reportType != null && urlResponse.reportType != "PBI") {
	          popupWindow.location.href = urlResponse.url;
	        }
	
	        if (urlResponse != null && urlResponse.reportType != null && urlResponse.reportType == "PBI") {
	
	          //let models = powerbi.models;
	          var winmodels = window['powerbi-client'].models;
	          //console.log("powerbi models: ", models);
	          //console.log("powerbi winmodels: ", winmodels);
	          console.log("pbi winmodels: ");
	
	          var pbiReportContainer = (0, _jquery2.default)("#pbiReportContainer");
	          var pbiReportContainerDV = (0, _jquery2.default)("#pbiReportContainer").get(0);
	
	          //console.log("pbiReportContainerDV: ", pbiReportContainerDV);
	
	          var pbiReportLoadConfig = {
	            type: "report",
	            tokenType: winmodels.TokenType.Embed,
	            //tokenType: models.TokenType.Embed,
	            accessToken: urlResponse.accessToken,
	            embedUrl: urlResponse.url
	          };
	          //console.log("pbiReportLoadConfig: ", pbiReportLoadConfig);
	
	          var pbiReport = powerbi.embed(pbiReportContainerDV, pbiReportLoadConfig);
	          console.log("Call to pwerbi.embed() completed.");
	          //console.log("pbiReport: ", pbiReport);
	          //hide other form and button panels after pbi report loads successfully.
	          if (pbiReport != null) {
	            (0, _jquery2.default)("#rptRptSchldsDispDiv").hide(); //Hide Report Schedules section
	            (0, _jquery2.default)("#rptCustRptDispDiv").hide(); //Hide Custom Reporting section
	            (0, _jquery2.default)("#rptRunrBtnsDiv").hide(); //Hide Report Buttons
	            (0, _jquery2.default)("#rptRunrMsgDiv").hide(); //Hide info Msg after Buttons
	            //resize div to display full report
	            (0, _jquery2.default)("#pbiReportContainer").height(1000);
	          }
	
	          // PBI Embedding Events - START.
	          // callbacks are not executed.
	          // Triggers when a report schema is successfully loaded:
	          pbiReport.on("loaded", function () {
	            //console.log("Report loaded successfullly.");
	            // let iframe = $("#reportContainer").find("iframe")[0];
	            var reportIframe = pbiReportContainer.querySelector("iframe");
	            //console.log("iframe after report loaded:", reportIframe);
	          });
	
	          // Triggers when a report is successfully embedded in UI:
	          pbiReport.on("rendered", function () {
	            //console.log("Report rendered successfully.");
	            // let iframe = $("#reportContainer").find("iframe")[0];
	            var reportIframe = pbiReportContainer.querySelector("iframe");
	            //console.log("iframe after report rendered:", reportIframe);
	          });
	
	          // Clear any other error handler event:
	          pbiReport.off("error");
	
	          // Below patch of code is for handling errors that occur during embedding:
	          pbiReport.on("error", function (event) {
	            //console.log("Error while embedding the report: ", event);
	            // let iframe = $("#report-container").find("iframe")[0];
	            var reportIframe = pbiReportContainer.querySelector("iframe");
	            //console.log("iframe after embedding error:", reportIframe);
	          });
	          // PBI Embedding Events - END
	        }
	      },
	      error: function error(_error2) {
	        //console.log('Error Returned: ', error);
	        //Close Cognos window
	        if (popupWindow != undefined) {
	          popupWindow.close();
	        }
	      }
	    });
	  }
	});

/***/ },
/* 758 */
[1583, 1100],
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1101);

/***/ },
/* 760 */
[1583, 1102],
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(762);
	
	__webpack_require__(1103);

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	
	(0, _run2.default)("#edit-return-address-outer-div", function () {
		var el = (0, _jquery2.default)("#edit-return-address-outer-div");
		editRetailerReturnLocations(el);
	});
	
	function editRetailerReturnLocations(el) {
	
		var facilityType = el.find("#cad-retailer-address-type");
		var vendorAuthRequiredSection = el.find(".if-vendor-returned");
		var inboundClassificationSection = el.find("#inbound-classfication-div");
		var returnAuthFlag = el.find("#return-auth-req");
		var standingRaNumber = el.find("#standing-ra-number");
	
		//const defaultEntityAddressTypes = el.data("default-entity-address-types");
		var retailerAddress = el.data("retailer-address");
		var retailerAddressAttributes = el.data("retailer-address-attributes");
	
		// setOptionsForSelect({
		//   selectElement: facilityType,
		//   list: defaultEntityAddressTypes,
		//   valueDataKey: "cdmValue",
		//   textDataKey: "cdmMeaning",
		//   initialSelectValue: ()=>{
		//     return retailerAddress.cadAddressType || "return";
		//   }
		// });
	
	
		facilityType.on("change", function (e) {
			showOrHideVendorAuth();
			showOrHideInboundClassification();
		});
	
		returnAuthFlag.on("change", function (e) {
			if ((0, _jquery2.default)(this).prop("checked") == false) {
				clearRaNumber();
			}
		});
	
		function showOrHideVendorAuth() {
			if (facilityType.val() == "vendor") {
				vendorAuthRequiredSection.show();
			} else {
				vendorAuthRequiredSection.hide();
			}
		}
	
		function showOrHideInboundClassification() {
			if (facilityType.val() == "return") {
				inboundClassificationSection.show();
			} else {
				inboundClassificationSection.hide();
			}
		}
	
		function clearRaNumber() {
			if (returnAuthFlag.prop("checked") == false) {
				standingRaNumber.val("");
			}
		}
	
		function retailerAddressAttributesCheck() {
			if (retailerAddressAttributes != null && retailerAddressAttributes.length > 0) {
				(0, _jquery2.default)(retailerAddressAttributes).each(function () {
					if (this.caaKey == 'vendor_ra_required') {
						if (this.caaValue == "true") {
							returnAuthFlag.prop('checked', true);
						} else {
							returnAuthFlag.prop('checked', false);
						}
					}
	
					if (this.caaKey == 'vendor_standing_ra') {
						standingRaNumber.val(this.caaValue);
					}
				});
			}
		}
	
		retailerAddressAttributesCheck();
		showOrHideVendorAuth();
		showOrHideInboundClassification();
	}

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(764);

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _run2.default)("#return-disposition-rule-details-page", function () {
	  var returnDispRuleDetailsPage = (0, _jquery2.default)("#return-disposition-rule-details-page");
	  var activeRuleBtn = returnDispRuleDetailsPage.find(".activate-rule-btn");
	  var inActiveRuleBtn = returnDispRuleDetailsPage.find(".deactivate-rule-btn");
	  var activateUrl = returnDispRuleDetailsPage.data("activate-rule-url");
	  var inactivateUrl = returnDispRuleDetailsPage.data("inactivate-rule-url");
	  var detailPageUrl = returnDispRuleDetailsPage.data("detail-url");
	  var duplicateRuleUrl = returnDispRuleDetailsPage.data("duplicate-rule-url");
	
	  (0, _jquery2.default)("body").on("click", "#duplicate-btn", function (e) {
	    window.location.href = duplicateRuleUrl + "&isDuplicate=true";
	  });
	
	  (0, _jquery2.default)(activeRuleBtn).on("click", function (e) {
	    e.preventDefault();
	    activateRuleModal.showConfirmModal();
	  });
	
	  (0, _jquery2.default)(inActiveRuleBtn).on("click", function (e) {
	    e.preventDefault();
	    deactivateRuleModal.showConfirmModal();
	  });
	
	  var deactivateRuleModal = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Deactivate Rule',
	    confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this rule will no longer be checking any product attributes. It can be activated at any time.</div>',
	    confirmModalBtnText: 'Deactivate Rule',
	    modalDialogClass: "q-modal-dialog-500",
	    onConfirmClick: function onConfirmClick() {
	      // Show Loading Modal
	      deactivateRuleModal.showLoadingModal();
	      _jquery2.default.ajax({
	        url: inactivateUrl,
	        dataType: "JSON",
	        type: 'POST',
	        success: onSuccessInactivate,
	        error: onErrorInactivate
	      });
	      function onSuccessInactivate() {
	        deactivateRuleModal.showSuccessModal();
	        setTimeout(function () {
	          location.href = detailPageUrl;
	        }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	      }
	
	      function onErrorInactivate() {
	        deactivateRuleModal.hideAllModals();
	      }
	    }
	  });
	
	  deactivateRuleModal.init();
	
	  var activateRuleModal = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Activate Rule',
	    confirmModalBody: '<div class="q-pad-all-xl">Once activated, this rule will begin checking any product attributes. It can be deactivated at any time.</div>',
	    confirmModalBtnText: 'Activate Rule',
	    modalDialogClass: "q-modal-dialog-500",
	    onConfirmClick: function onConfirmClick() {
	      // Show Loading Modal
	      activateRuleModal.showLoadingModal();
	      _jquery2.default.ajax({
	        url: activateUrl,
	        dataType: "JSON",
	        type: 'POST',
	        success: onSuccessActivate,
	        error: onErrorActivate
	      });
	
	      function onSuccessActivate() {
	        activateRuleModal.showSuccessModal();
	        setTimeout(function () {
	          location.href = detailPageUrl;
	        }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	      }
	
	      function onErrorActivate() {
	        activateRuleModal.hideAllModals();
	      }
	    }
	  });
	
	  activateRuleModal.init();
	});

/***/ },
/* 765 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  "all": [{
	    title: "Activate Rule",
	    cls: "bulk-activate-rule",
	    icon: "toggle-off",
	    disabled: true
	  }, {
	    title: "Deactivate Rule",
	    cls: "bulk-deactivate-rule",
	    icon: "toggle-on",
	    disabled: true
	  }],
	  "actions": [{
	    title: "Edit Rule",
	    cls: "edit-rule",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Activate/Deactivate",
	    cls: "",
	    icon: "",
	    disabled: false
	  }, {
	    title: "Duplicate Rule",
	    cls: "duplicate-rule",
	    icon: "clone",
	    disabled: false
	  }]
	};

/***/ },
/* 766 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var rulesLookupFieldDropdown = exports.rulesLookupFieldDropdown = [{
		title: "By Rule Number",
		value: "ruleNum"
	}, {
		title: "By Rule Description",
		value: "ruleDesc"
	}, {
		title: "By Rule Attribute Value",
		value: "ruleAttrVal"
	}, {
		title: "By Rule Output Value",
		value: "ruleOutVal"
	}];

/***/ },
/* 767 */
[1582, 768],
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _rulesLookupFieldDropdown = __webpack_require__(766);
	
	var _actionOptions = __webpack_require__(765);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var detailLinkTemplate = __webpack_require__(1421);
	var actionList = _actionOptions.actionOptions;
	
	var targetSelector = "#lookup-return-disposition-rules";
	
	(0, _run2.default)(targetSelector, function () {
		var entryElement = $(targetSelector);
		var dataTableComponentData = entryElement.data("rules-data");
	
		var viewRulesDetailURL = entryElement.data("view-details-url");
		var filterSearchUrl = entryElement.data("filter-search-url");
		var activateUrl = entryElement.data("activate-url");
		var inactivateUrl = entryElement.data("inactivate-url");
		var updateRuleUrl = entryElement.data("update-url");
		var bulkActivateDeactivateRuleUrl = entryElement.data("bulk-activate-deactivate-rule-url");
	
		var shouldCheckCache = entryElement.data("should-check-cache");
	
		var savedViews = entryElement.data("saved-views");
		var saveViewURL = entryElement.data("save-view-url");
		var deleteViewURL = entryElement.data("delete-view-url");
	
		var submitModalFlow = new _SubmitModalFlow2.default();
		submitModalFlow.init();
	
		var criteriaObjectFromServer = entryElement.data("filter-criteria-from-server");
	
		var targetObject = "";
		var totalRecordCount = 0;
		var lookupFieldDropdown = _rulesLookupFieldDropdown.rulesLookupFieldDropdown;
		var selectedRows = "";
	
		if (shouldCheckCache) {
			targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
		}
	
		if (_.has(dataTableComponentData, "page")) {
			totalRecordCount = dataTableComponentData.page.totalElements;
		}
	
		function createDetailLink(data, type, row) {
			var newRender = void 0;
	
			newRender = (0, _render2.default)(detailLinkTemplate, {
				id: row.cbrId,
				name: row.cbrId,
				url: viewRulesDetailURL
			});
			return newRender;
		}
	
		function renderStatusPill(data, type, row) {
			var status = data;
			if (status === false) {
				return "<div class='q-pill q-block q-pill-blue-border q-marg-all-xs-at-md q-pill-table'>Inactive</div>";
			} else {
				return "<div class='q-pill q-block q-pill-blue q-marg-all-xs-at-md q-pill-table'>Active</div>";
			}
			return "";
		}
	
		var ruleLookup = new _index2.default({
			// REQUIRED - Set a target element
			target: $("#return-disposition-rules-table-wrapper"),
			// REQUIRED - Set which data should be visible for mobile
			mobileColumns: [{
				data: "cbrId",
				title: "Rule ID",
				render: createDetailLink
			}, {
				data: "cbrName",
				title: "Rule Name"
			}, {
				data: "cbrActive",
				title: "Status",
				render: renderStatusPill
			}],
			// tableFilters: {
			//    data: orderFilterData,
			//  },
			tableSearch: true,
			// REQUIRED: search input info
			tableSearchInput: {
				// Not required
				// placeholder: 'Custom Search Text'
				value: targetObject != "" ? targetObject.value[0] : ""
	
			},
			// REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
			tableSearchDropdown: {
				selected: targetObject == "" ? "" : targetObject.key,
				columns: lookupFieldDropdown
			},
			// OPTIONAL: Set Saved View Array
			savedViews: savedViews,
			bulkSelect: true,
			// REQUIRED - Data Table specific settings
			dataTable: {
				// use same settings you would if you were just calling a dataTable normally
				data: dataTableComponentData.content,
				// Not required, just to show you can
				columnDefs: [{}],
				// Not required, just to show you can
				order: [[2, 'desc']],
				columns: [{
					data: "cbrActive",
					render: renderActionWrap,
					orderable: false,
					class: 'dtc-action-column',
					title: "Actions"
				}, {
					data: "cbrId",
					title: "Rule ID",
					render: createDetailLink,
					class: 'dtc-min-width-sm'
				}, {
					data: "cbrName",
					title: "Rule Name",
					class: 'dtc-min-width-md'
				}, {
					data: "cbrDescription",
					title: "Rule Description",
					orderable: false,
					class: 'dtc-min-width-lg'
	
				}, {
					data: "cbrActive",
					title: "Status",
					render: renderStatusPill,
					class: 'dtc-min-width-sm'
				}]
			},
			//  tableColumnModal: {
			//	data: ruleLookupColumnsPopup
			//},
			paginationData: dataTableComponentData.page,
			filterModal: {
				// REQUIRED: Sets title of modal
				title: "Filter Return Disposition Rules",
				// REQUIRED: Sets unique part of subtitle string.
				tableType: "returnDisposition"
			},
			onBulkSelectChange: function onBulkSelectChange() {
				selectedRows = ruleLookup.getBulkSelectedData();
				$("th.dtc-action-column").html(renderActionHeaderWrap());
				if (selectedRows.length >= 2) {
					$(".action-header-btn .base-btn").removeClass('disabled');
				} else {
					$(".action-header-btn .base-btn").addClass('disabled');
				};
			},
			onFetch: function onFetch() {
				var currentData = ruleLookup.generateData();
				ruleLookup.showLoadingOverlay();
	
				//Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
				if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterSearchUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isNew)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isEdit)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isDeleteView)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				}
			}
		});
	
		function filterSuccessFun(data) {
			var rules = data.content;
			var page = data.page;
			ruleLookup.setNewData(rules);
			ruleLookup.setPaginationData(page);
			(0, _filtersutil.pushFilterSessionCacheState)();
			totalRecordCount = page.totalElements;
			ruleLookup.hideLoadingOverlay();
			//$(".data-table-component").DataTable().columns('.status-column').visible( false );
		}
	
		function savedViewSuccess(data) {
			var rules = data.lookupRuleJSON.content;
			var page = data.lookupRuleJSON.page;
			ruleLookup.setNewData(rules);
			ruleLookup.setPaginationData(page);
			ruleLookup.setNewSavedViewData(data.savedView, "newSavedView");
			(0, _filtersutil.pushFilterSessionCacheState)();
			totalRecordCount = page.totalElements;
			ruleLookup.hideLoadingOverlay();
		}
	
		function savedEditViewSuccess(data) {
			var rules = data.lookupRuleJSON.content;
			var page = data.lookupRuleJSON.page;
			ruleLookup.setNewData(rules);
			ruleLookup.setPaginationData(page);
			ruleLookup.setNewSavedViewData(data.savedView, data.savedView.target);
			(0, _filtersutil.pushFilterSessionCacheState)();
			totalRecordCount = page.totalElements;
			ruleLookup.hideLoadingOverlay();
		}
	
		function delteViewScussFun(data) {
			var rules = data.lookupRuleJSON.content;
			var page = data.lookupRuleJSON.page;
			ruleLookup.removeSavedView(data.target);
			ruleLookup.setNewData(rules);
			ruleLookup.setPaginationData(page);
			totalRecordCount = page.totalElements;
			ruleLookup.hideLoadingOverlay();
		}
	
		function errorFun(data) {
			ruleLookup.hideLoadingOverlay();
		}
	
		ruleLookup.init();
	
		//const ordersDataTableObj = $("#lookup-order-wrapper .data-table-component").dataTable();
		function renderActionWrap(data, type, row, meta) {
			var newRender = void 0;
			var statusTarget = actionList["actions"];
			newRender = (0, _render2.default)(actionCellDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row),
				index: meta.row
			});
			return newRender;
		};
	
		function renderActionHeaderWrap() {
			var statusTarget = actionList['all'];
			var newRender = void 0;
			var data = "";
			var row = "";
			newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row)
			});
			return newRender;
		};
	
		/*  function renderActionCellList(list,data,row) {
	    let renderedList;
	    renderedList = _(list).map((item)=>{
	      return render(
	        actionCellDropdownItemTemplate, {
	          icon: item.icon,
	          title: item.title,
	          cls: item.cls,
	          disabled:checkDisableForGivenAction(data,row,item.title)
	        }
	      )
	  		 });
	    return renderedList.join('');
	   };*/
		//
	
		function renderActionCellList(list, data, row) {
			var renderedList = _(list).map(function (item) {
				return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, item));
			});
			return renderedList.join('');
		};
	
		function neededActions(data, row, item) {
			var action = {};
			if (item.title === 'Activate/Deactivate') {
				if (row.cbrActive === true) {
					action = {
						icon: 'toggle-off',
						title: 'Deactivate Rule',
						cls: "inactivate-rule",
						disabled: callBusinessLogicToDisableAction(data, row, item.title)
					};
				} else {
					action = {
						icon: 'toggle-on',
						title: 'Activate Rule',
						cls: "activate-rule",
						disabled: callBusinessLogicToDisableAction(data, row, item.title)
					};
				}
			} else if (item.title === 'Activate Rule') {
				action = {
					icon: item.icon,
					title: item.title,
					cls: item.cls,
					disabled: checkDisableForGivenAction(data, row, item.title)
				};
			} else if (item.title === 'Deactivate Rule') {
				action = {
					icon: item.icon,
					title: item.title,
					cls: item.cls,
					disabled: checkDisableForGivenAction(data, row, item.title)
				};
			} else {
				action = {
					icon: item.icon,
					title: item.title,
					cls: item.cls,
					disabled: item.disabled
				};
			}
			return action;
		};
	
		function checkDisableForGivenAction(data, row, actionName) {
			var isTrue = false;
			_(selectedRows).map(function (item) {
				if (callBusinessLogicToDisableAction(item.data.cbrActive, item.data, actionName)) {
					if (!isTrue) {
						isTrue = true;
					}
				}
			});
			return isTrue;
		};
	
		function isRowLevelActionCheck(data) {
			return (0, _general.isPresent)(data);
		}
	
		// Note this method will return true if we want to disable action, else return false if we want to enable
		function callBusinessLogicToDisableAction(status, row, actionName) {
			//alert('actionName' +actionName);
			if ((0, _general.isPresent)(status)) {
				if (actionName === "Deactivate Rule") {
					if (row.cbrActive === true) {
						return false;
					} else {
						return true;
					}
				} else if (actionName === "Activate Rule") {
					if (row.cbrActive === false) {
						if (moment().isAfter(row.cbrEffectiveEndDate)) {
							return true;
						} else {
							return false;
						}
					} else {
						return true;
					}
				} else {
					return false;
				}
			}
		}
	
		function shallAllowClick(currentObj) {
			return !$(currentObj).hasClass("disabled");
		}
	
		$('body').on('click', '.edit-rule, .activate-rule, .inactivate-rule, .duplicate-rule', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
				var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				// Get the row based on the parent...
				var parent = $(".dropdown-parent-" + pIndex).parents('tr');
				// Get the row data
				var row = $(".data-table-component").dataTable().api().row(parent);
	
				if ($(this).hasClass('edit-rule')) {
					processEditRule(row);
				} else if ($(this).hasClass('activate-rule')) {
					processActivateRule(row);
				} else if ($(this).hasClass('inactivate-rule')) {
					processInactivateRule(row);
				} else if ($(this).hasClass('duplicate-rule')) {
					processDuplicateRule(row);
				}
			}
		});
	
		function processEditRule(row) {
			location.href = updateRuleUrl + "&cbrId=" + row.data().cbrId;
		}
	
		function processDuplicateRule(row) {
			location.href = updateRuleUrl + "&cbrId=" + row.data().cbrId + "&isDuplicate=true";;
		}
	
		function processActivateRule(row) {
			var submitModal = new _SubmitModalFlow2.default({
				confirmModalTitle: 'Activate Rule',
				confirmModalBody: '<div class="q-pad-all-xl">Once activated, this rule will begin checking any product attributes. It can be deactivated at any time.</div>',
				confirmModalBtnText: 'Activate Rule',
				modalDialogClass: "q-modal-dialog-500",
				onConfirmClick: function onConfirmClick() {
					submitModal.showLoadingModal();
					var data = row.data();
					activateRule(row, data);
	
					function activateRule(row, rule) {
						$.ajax({
							url: activateUrl,
							type: 'POST',
							dataType: 'JSON',
							data: {
								cbrId: rule.cbrId
							},
							success: function success(data) {
								if (data.response == "success") {
									var d = row.data();
									d.cbrActive = data.cbrActive;
									d.cbrId = $.trim(data.cbrId);
									row.data(d).draw();
									submitModal.showSuccessModal();
									setTimeout(function () {
										submitModal.hideAllModals();
									}, window.constants.SUCCESS_MODAL_TIMEOUT);
								} else {
									submitModal.showFailureModal();
								}
							},
							error: function error(data) {
								submitModal.hideAllModals();
							}
						});
					};
				}
			});
			submitModal.init();
			submitModal.showConfirmModal();
		}
	
		function processInactivateRule(row) {
			var submitModal = new _SubmitModalFlow2.default({
				confirmModalTitle: 'Deactivate Rule',
				confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, this rule will no longer be checking any product attributes. It can be activated at any time.</div>',
				confirmModalBtnText: 'Deactivate Rule',
				modalDialogClass: "q-modal-dialog-500",
				onConfirmClick: function onConfirmClick() {
					submitModal.showLoadingModal();
					var data = row.data();
					inactivateRule(row, data);
	
					function inactivateRule(row, rule) {
						$.ajax({
							url: inactivateUrl,
							type: 'POST',
							dataType: 'JSON',
							data: {
								cbrId: rule.cbrId
							},
							success: function success(data) {
								if (data.response == "success") {
									var d = row.data();
									d.cbrActive = data.cbrActive;
									d.cbrId = $.trim(data.cbrId);
									row.data(d).draw();
									submitModal.showSuccessModal();
									setTimeout(function () {
										submitModal.hideAllModals();
									}, window.constants.SUCCESS_MODAL_TIMEOUT);
								} else {
									submitModal.showFailureModal();
								}
							},
							error: function error(data) {
								submitModal.hideAllModals();
							}
						});
					};
				}
			});
			submitModal.init();
			submitModal.showConfirmModal();
		}
	
		$('body').on('click', '.bulk-activate-rule', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				var submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: 'Activate Rules',
					confirmModalBody: '<div class="q-pad-all-xl">Once activated, these rules will begin checking any product attributes. They can be deactivated at any time.</div>',
					confirmModalBtnText: 'Activate Rules',
					onConfirmClick: function onConfirmClick() {
						submitModalFlow.showLoadingModal();
						activateRules();
						function activateRules() {
							var _data;
	
							$.ajax({
								url: bulkActivateDeactivateRuleUrl,
								type: 'POST',
								dataType: 'JSON',
								data: (_data = {}, _defineProperty(_data, 'cbrIds', getAllSelectedCbrIds()), _defineProperty(_data, 'action', 'Activate'), _data),
								success: function success(data) {
									if (data.response == "success") {
										_(selectedRows).map(function (item) {
											var currentRow = $(".data-table-component").DataTable().row(item.rowIndex);
											var d = currentRow.data();
											d.cbrActive = true;
											currentRow.data(d).draw();
										});
										ruleLookup.uncheckAllSelected();
										submitModalFlow.showSuccessModal();
										setTimeout(function () {
											submitModalFlow.hideAllModals();
										}, window.constants.SUCCESS_MODAL_TIMEOUT);
									} else {
										submitModalFlow.showFailureModal();
									}
								},
								error: function error(data) {
									submitModalFlow.hideAllModals();
								}
							});
						}
					}
				});
				submitModalFlow.init();
				submitModalFlow.showConfirmModal();
			}
		});
	
		$('body').on('click', '.bulk-deactivate-rule', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				var submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: 'Deactivate Rules',
					confirmModalBody: '<div class="q-pad-all-xl">Once deactivated, these rules will no longer be checking any product attributes. They can be activated at any time.</div>',
					confirmModalBtnText: 'Deactivate Rules',
					onConfirmClick: function onConfirmClick() {
						submitModalFlow.showLoadingModal();
						deactivateRules();
						function deactivateRules() {
							var _data2;
	
							$.ajax({
								url: bulkActivateDeactivateRuleUrl,
								type: 'POST',
								dataType: 'JSON',
								data: (_data2 = {}, _defineProperty(_data2, 'cbrIds', getAllSelectedCbrIds()), _defineProperty(_data2, 'action', 'Deactivate'), _data2),
								success: function success(data) {
									if (data.response == "success") {
										_(selectedRows).map(function (item) {
											var currentRow = $(".data-table-component").DataTable().row(item.rowIndex);
											var d = currentRow.data();
											d.cbrActive = false;
											currentRow.data(d).draw();
										});
										ruleLookup.uncheckAllSelected();
										submitModalFlow.showSuccessModal();
										setTimeout(function () {
											submitModalFlow.hideAllModals();
										}, window.constants.SUCCESS_MODAL_TIMEOUT);
									} else {
										submitModalFlow.showFailureModal();
									}
								},
								error: function error(data) {
									submitModalFlow.hideAllModals();
								}
							});
						}
					}
				});
				submitModalFlow.init();
				submitModalFlow.showConfirmModal();
			}
		});
	
		function getAllSelectedCbrIds() {
			var cbrIds = new Array();
			_(selectedRows).map(function (item) {
				cbrIds.push(item.data.cbrId);
			});
			return cbrIds;
		}
	
		// Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information...
		(0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
		$("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(770);
	
	__webpack_require__(221);
	
	__webpack_require__(1121);

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _returnRequestsWizardLogic = __webpack_require__(221);
	
	var _returnRequestsWizardLogic2 = _interopRequireDefault(_returnRequestsWizardLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: make the target selector a place on the webpage where you want to import this
	var targetSelector = "#add-rma";
	
	var customValidateProps = {
	  errorPlacement: function errorPlacement(error, element) {
	    var appendClosest = $(element).data('error-placement-append-closest');
	    if (appendClosest) {
	      $(element).closest(appendClosest).append(error);
	    } else {
	      error.insertAfter(element);
	    }
	  }
	};
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachHtml(outerEl);
	});
	
	function attachHtml(outerEl) {
	  var returnRequestWizardLogicVar = new _returnRequestsWizardLogic2.default(outerEl);
	  returnRequestWizardLogicVar.init();
	};

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(772);

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _select2able = __webpack_require__(22);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	// Live form from jsp
	(0, _run2.default)("#return-revamp", function () {
		var el = $("#return-revamp");
		returnRevamp(el);
	});
	
	function returnRevamp(el) {
		var toOrderPageURL = el.data('to-order-page-url');
		var toAsnPageURL = el.data('to-asn-page-url');
		var toRmaPageURL = el.data('to-rma-page-url');
		var els = {};
	
		$(".to-asn-page").on("click", function () {
			window.open(toAsnPageURL);
		});
	
		$(".to-order-page").on("click", function () {
			var url = $(this).closest('.rma-order-row').data('rma-to-order-url');
			window.open(url ? url : toOrderPageURL);
		});
	
		$(".to-rma-page").on("click", function () {
			window.open($(this).data("to-rma-page-url"));
		});
	}

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _select2able = __webpack_require__(22);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	var targetSelector = "#create-update-return-rules-outer";
	
	(0, _run2.default)(targetSelector, function () {
		var el = $(targetSelector);
		createUpdateReturnsRules(el);
		setupEditChecker();
	});
	
	function setupEditChecker() {
		_EditChecker2.default.bindNavigation();
		_EditChecker2.default.bindChangeListener("#create-update-return-rules-outer");
		_EditChecker2.default.bindCancelButton("#returs-rules-cancel-btn");
	}
	
	function createUpdateReturnsRules(el) {
		var modalOrderTable = void 0;
		var modalFindProdFromList = void 0,
		    submitModalFlowSave = void 0;
		var rangeStartDatePicker = void 0,
		    rangeEndDatePicker = void 0;
		var cancelBtn = el.find("#returns-rules-save-btn");
		var saveBtn = el.find("#returns-rules-save-btn");
		var submitURL = el.data("submit-url");
		var detailURL = el.data("detail-url");
		var productLookUpURL = el.data('product-lookup-url');
		var overrideConditions = el.data('overriding-conditions');
		var catList = el.data('cat-list');
		var inboundClassification = el.data('inbound-classification');
		var facilities = el.data('facilities');
		var inclusionConditions = el.data('inclusion-conditions');
		var rangeValId = el.find('#retuns-rules-range-val-id');
		var exactValId = el.find('#retuns-rules-exact-val-id');
		var rangeValBtn = el.find('#retuns-rules-range-val-btn');
		var exactValBtn = el.find('#retuns-rules-exact-val-btn');
		var catListSelect = el.find('#returns-rules-categories-select');
		var facilitiesSelect = el.find('#returs-rules-return-facility-select');
		var overrideConditionsSelect = el.find("#returs-rules-override-condition-select");
		var inclusionConditionsSelect = el.find("#returns-rules-inclusion-select");
		var inboundClassificationSelect = el.find("#returs-rules-inbound-classification-select");
		var rule = el.data("rule");
		var isEdit = false;
		var skuSelect = $("#return-rule-sku");
		var returnTypesSelect = $("#return-rule-returntypes");
		var brandSelect = $("#return-rule-brands");
		var modelNumberSelect = $("#return-rule-model-num");
		var departmentSelect = $("#return-rule-departments");
		var productClassificationSelect = $("#return-rule-prod");
		var costRetailOptionId = $("#cost-retail-option-id");
		var costOptionId = $("#cost-option-id");
		var retailOptionId = $("#retail-option-id");
		var returnsRulesMaxValId = $("#returns-rules-max-val-id");
		var returnsRulesMinValId = $("#returns-rules-min-val-id");
	
		if (rule != "" && rule.cbrId > 0) {
			isEdit = true;
		}
	
		$(catList).each(function () {
			var option = $('<option />');
			option.attr('value', this.catId).text(this.catName);
			catListSelect.append(option);
		});
	
		rangeValBtn.on("click", function (e) {
			e.preventDefault();
			rangeValId.show();
			exactValId.hide();
		});
	
		exactValBtn.on("click", function (e) {
			e.preventDefault();
			exactValId.show();
			rangeValId.hide();
		});
	
		function init() {
			generateBtnGroup();
			generateDatePickers();
		}
	
		var select2AjaxDefaults = {
			dataType: 'json',
			delay: 250,
			processResults: function processResults(data, params) {
				params.page = params.page || 1;
				return {
					results: data,
					pagination: {
						more: params.page * 20 < data.total_count
					}
				};
			},
			cache: true
		};
	
		var validator = el.validate({
			errorPlacement: function errorPlacement(error, element) {
				var appendClosest = $(element).data('error-placement-append-closest');
				if (appendClosest) {
					$(element).closest(appendClosest).append(error);
				} else {
					error.insertAfter(element);
				}
			}
		});
	
		validator.settings.ignore = ":disabled,:hidden";
		if (isEdit) {
			var groupedRelatedSelectData = (0, _underscore2.default)(rule.cmrRuleConditions).groupBy(function (obj) {
				return obj.crcName;
			});
	
			if (_underscore2.default.toArray(groupedRelatedSelectData.ByValue).length > 0) {
				var operator = groupedRelatedSelectData.ByValue[0].crcOperator;
				var crpKey = groupedRelatedSelectData.ByValue[0].cmrRuleParams[0].crpKey;
				costRetailOptionId.val(crpKey);
				var costType = "cost";
	
				if (crpKey.indexOf("retail") != -1) {
					costOptionId.removeClass("active");
					retailOptionId.addClass("active");
					costType = "retail";
				} else {
					costOptionId.addClass("active");
					retailOptionId.removeClass("active");
				}
	
				if (operator == ">=") {
					$("#returns-rules-exact-val").val(groupedRelatedSelectData.ByValue[0].cmrRuleParams[0].crpValue);
				} else if (operator == "between") {
					rangeValId.show();
					exactValId.hide();
	
					var minMaxMap = (0, _underscore2.default)(groupedRelatedSelectData.ByValue[0].cmrRuleParams).groupBy(function (obj) {
						return obj.crpKey;
					});
	
					if (costType == "retail") {
						returnsRulesMaxValId.val(minMaxMap.max_retail[0].crpValue);
						returnsRulesMinValId.val(minMaxMap.min_retail[0].crpValue);
					} else {
						returnsRulesMaxValId.val(minMaxMap.max_cost[0].crpValue);
						returnsRulesMinValId.val(minMaxMap.min_cost[0].crpValue);
					}
				}
			}
	
			if (_underscore2.default.toArray(groupedRelatedSelectData.ByProduct).length > 0) {
				var getCmrRuleParams = groupedRelatedSelectData.ByProduct[0].cmrRuleParams;
				var relatedSelectPillsArray = (0, _underscore2.default)(getCmrRuleParams).pluck("crpValue");
				(0, _selectorHelpers.setOptionsForSelect)({
					list: getCmrRuleParams,
					valueDataKey: "crpValue",
					textDataKey: "crpValue",
					selectElement: skuSelect,
					initialSelectValue: relatedSelectPillsArray
				});
			}
	
			if (_underscore2.default.toArray(groupedRelatedSelectData.Brand).length > 0) {
				var _getCmrRuleParams = groupedRelatedSelectData.Brand[0].cmrRuleParams;
				var _relatedSelectPillsArray = (0, _underscore2.default)(_getCmrRuleParams).pluck("crpValue");
				(0, _selectorHelpers.setOptionsForSelect)({
					list: _getCmrRuleParams,
					valueDataKey: "crpValue",
					textDataKey: "crpValue",
					selectElement: brandSelect,
					initialSelectValue: _relatedSelectPillsArray
				});
			}
	
			if (_underscore2.default.toArray(groupedRelatedSelectData.ModelNumber).length > 0) {
				var _getCmrRuleParams2 = groupedRelatedSelectData.ModelNumber[0].cmrRuleParams;
				var _relatedSelectPillsArray2 = (0, _underscore2.default)(_getCmrRuleParams2).pluck("crpValue");
				(0, _selectorHelpers.setOptionsForSelect)({
					list: _getCmrRuleParams2,
					valueDataKey: "crpValue",
					textDataKey: "crpValue",
					selectElement: modelNumberSelect,
					initialSelectValue: _relatedSelectPillsArray2
				});
			}
	
			if (_underscore2.default.toArray(groupedRelatedSelectData.Category).length > 0) {
				var _getCmrRuleParams3 = groupedRelatedSelectData.Category[0].cmrRuleParams;
				var _relatedSelectPillsArray3 = (0, _underscore2.default)(_getCmrRuleParams3).pluck("crpValue");
				(0, _selectorHelpers.setOptionsForSelect)({
					list: _getCmrRuleParams3,
					valueDataKey: "crpId",
					textDataKey: "crpId",
					selectElement: catListSelect,
					initialSelectValue: _relatedSelectPillsArray3
				});
			}
	
			if (_underscore2.default.toArray(groupedRelatedSelectData.Department).length > 0) {
				var _getCmrRuleParams4 = groupedRelatedSelectData.Department[0].cmrRuleParams;
				var _relatedSelectPillsArray4 = (0, _underscore2.default)(_getCmrRuleParams4).pluck("crpValue");
				(0, _selectorHelpers.setOptionsForSelect)({
					list: _getCmrRuleParams4,
					valueDataKey: "crpValue",
					textDataKey: "crpValue",
					selectElement: departmentSelect,
					initialSelectValue: _relatedSelectPillsArray4
				});
			}
	
			if (_underscore2.default.toArray(groupedRelatedSelectData.ReturnType).length > 0) {
				var _getCmrRuleParams5 = groupedRelatedSelectData.ReturnType[0].cmrRuleParams;
				var _relatedSelectPillsArray5 = (0, _underscore2.default)(_getCmrRuleParams5).pluck("crpValue");
				(0, _selectorHelpers.setOptionsForSelect)({
					list: _getCmrRuleParams5,
					valueDataKey: "crpValue",
					textDataKey: "crpValue",
					selectElement: returnTypesSelect,
					initialSelectValue: _relatedSelectPillsArray5
				});
			}
	
			if (_underscore2.default.toArray(groupedRelatedSelectData.ProductType).length > 0) {
				var _getCmrRuleParams6 = groupedRelatedSelectData.ProductType[0].cmrRuleParams;
				var _relatedSelectPillsArray6 = (0, _underscore2.default)(_getCmrRuleParams6).pluck("crpValue");
				(0, _selectorHelpers.setOptionsForSelect)({
					list: _getCmrRuleParams6,
					valueDataKey: "crpValue",
					textDataKey: "crpValue",
					selectElement: productClassificationSelect,
					initialSelectValue: _relatedSelectPillsArray6
				});
			}
		}
	
		skuSelect.select2({
			ajax: _extends({}, select2AjaxDefaults, {
				url: productLookUpURL,
				data: configureDataCallback({ paramKey: 'likeSku' })
			}),
			minimumInputLength: 3
		});
	
		function configureDataCallback(_ref) {
			var paramKey = _ref.paramKey;
	
			return function (params) {
				return _defineProperty({}, paramKey, params.term);
			};
		}
	
		returnTypesSelect.select2({
			tags: true,
			placeholder: "Add a Return Type(s) to include"
		});
	
		brandSelect.select2({
			tags: true,
			placeholder: "Add a Brand(s) to include"
		});
	
		modelNumberSelect.select2({
			tags: true,
			placeholder: "Add a Model Number(s) to include"
		});
	
		departmentSelect.select2({
			tags: true,
			placeholder: "Add a Department(s) to include"
		});
	
		productClassificationSelect.select2({
			tags: true,
			placeholder: "Add a Product Classification(s) to include"
		});
	
		$(facilities).each(function () {
			var option = $('<option />');
			option.attr('value', this.facId).text(this.facName);
			facilitiesSelect.append(option);
		});
	
		$(overrideConditions).each(function () {
			var option = $('<option />');
			option.attr('value', this.cdmValue).text(this.cdmMeaning);
			overrideConditionsSelect.append(option);
		});
	
		$(inclusionConditions).each(function () {
			var option = $('<option />');
			option.attr('value', this.cdmValue).text(this.cdmMeaning);
			inclusionConditionsSelect.append(option);
		});
	
		$(inboundClassification).each(function () {
			var option = $('<option />');
			option.attr('value', this.cdmValue).text(this.cdmMeaning);
			inboundClassificationSelect.append(option);
		});
	
		$(saveBtn).on("click", function (e) {
			e.preventDefault();
			if (validator.elements().valid()) {
				var submitModalFlow = new _SubmitModalFlow2.default({
					confirmModalTitle: "Save Rule",
					confirmModalBody: '<div class="q-pad-all-xl">Once saved, this rule will become active immediately.</div>',
					confirmModalBtnText: "Confirm",
					onConfirmClick: function onConfirmClick() {
						submitModalFlow.showLoadingModal();
						submitReturnRule({ url: submitURL, success: returnsRulesSucess, error: returnsRulesError });
						function submitReturnRule(_ref3) {
							var url = _ref3.url,
							    success = _ref3.success,
							    error = _ref3.error;
	
							$.ajax({
								data: $('#create-update-return-rules-outer').serialize(),
								url: url,
								dataType: "JSON",
								type: 'POST',
								success: success,
								error: error
							});
						}
						function returnsRulesSucess(returnRuleId) {
							if (returnRuleId > 0) {
								_EditChecker2.default.setPageClean();
								var detailUrlFullURL = detailURL + '&returnRuleId=' + returnRuleId;
								submitModalFlow.showSuccessModal();
								setTimeout(function () {
									location.href = detailUrlFullURL;
								}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
							} else {
								submitModalFlow.showFailureModal();
							}
						}
						function returnsRulesError() {
							submitModalFlow.hideAllModals();
						}
					}
				});
				submitModalFlow.init();
				submitModalFlow.showConfirmModal();
			}
		});
	
		function generateDatePickers() {
			rangeStartDatePicker = el.find('.return-rule-range-start');
			rangeEndDatePicker = el.find('.return-rule-range-end');
			var date = new Date();
			rangeStartDatePicker.datepicker({
				startDate: date,
				todayBtn: "linked",
				keyboardNavigation: false,
				autoclose: true
			});
			rangeEndDatePicker.datepicker({
				startDate: date,
				todayBtn: "linked",
				keyboardNavigation: false,
				autoclose: true
			});
		};
	
		function generateBtnGroup() {
			var costRetailBtnGroupEl = el.find(".cost-retail-toggler");
			var costRetailBtnGroup = new _QuickBtnGroup2.default(costRetailBtnGroupEl, {
				distributeWidth: true
			});
			costRetailBtnGroup.init();
		};
	
		inclusionConditionsSelect.change(handleInclusionConditionChange);
	
		function handleInclusionConditionChange() {
			var inclusionOpt = $('#returns-rules-inclusion-select :selected').val();
			if (inclusionOpt == "SKU") {
				el.find("#returns-rules-sku-inclusion-id").show();
				el.find("#returns-rules-categories-inclusion-id").hide();
			} else if (inclusionOpt == "GAC") {
				el.find("#returns-rules-categories-inclusion-id").show();
				el.find("#returns-rules-sku-inclusion-id").hide();
			}
		};
	
		overrideConditionsSelect.change(handleOverrideConditionChange);
	
		function handleOverrideConditionChange() {
			var overrideOpt = $('#returs-rules-override-condition-select :selected').val();
			if (overrideOpt == "return_facility") {
				el.find("#returs-rules-return-facility").show();
				el.find("#returs-rules-inbound-classification").hide();
			} else if (overrideOpt == "inbound_classification") {
				el.find("#returs-rules-inbound-classification").show();
				el.find("#returs-rules-return-facility").hide();
			}
		};
	
		init();
	
		if (isEdit) {
			inclusionConditionsSelect.val(rule.cbrInclusionCondition).trigger('change');
			overrideConditionsSelect.val(rule.returnRules[0].rtrOverrideType).trigger('change');
			inboundClassificationSelect.val(rule.returnRules[0].rtrOverrideValue).trigger('change');
			facilitiesSelect.val(rule.returnRules[0].rtrOverrideValue).trigger('change');
		} else {
			inclusionConditionsSelect.val("SKU").trigger('change');
			overrideConditionsSelect.val("inbound_classification").trigger('change');
		}
	}

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _select2able = __webpack_require__(22);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	var targetSelector = "#returns-rules-detail-id";
	// Live form from jsp
	(0, _run2.default)(targetSelector, function () {
		var el = $(targetSelector);
		returnsRulesDetail(el);
	});
	
	function returnsRulesDetail(el) {
		var activeRuleURL = el.data("activate-rule-url");
		var inActiveRuleURL = el.data("inactivate-rule-url");
		var activeRuleBtn = el.find(".activate-rule-btn");
		var inActiveRuleBtn = el.find(".deactivate-rule-btn");
		var detailURL = el.data("detail-url");
		var editBtn = el.find(".edit-rule-btn");
	
		var activateRuleModal = new _SubmitModalFlow2.default({
			confirmModalTitle: 'Activate Rule',
			confirmModalBody: '<div class="q-pad-all-xl">\n\t\t\t\t\t\t\tOnce updated, these changes will be reflected throughout the application.\n\t\t\t\t\t\t  </div>',
			confirmModalBtnText: 'Activate Rule',
			onConfirmClick: function onConfirmClick() {
				activateRuleModal.showLoadingModal();
				activeReturnRule({ url: activeRuleURL, success: activeRuleSuccess, error: activeRuleError });
			}
		});
	
		activateRuleModal.init();
	
		var deactiveRuleModal = new _SubmitModalFlow2.default({
			confirmModalTitle: 'Deactive Rule',
			confirmModalBody: '<div class="q-pad-all-xl">\n\t\t\t\t\t\t\tOnce updated, these changes will be reflected throughout the application.\n\t\t\t\t\t\t  </div>',
			confirmModalBtnText: 'Deactive Rule',
			onConfirmClick: function onConfirmClick() {
				deactiveRuleModal.showLoadingModal();
				activeReturnRule({ url: inActiveRuleURL, success: activeRuleSuccess, error: activeRuleError });
			}
		});
	
		deactiveRuleModal.init();
	
		$(activeRuleBtn).on("click", function (e) {
			e.preventDefault();
			activateRuleModal.showConfirmModal();
		});
	
		$(inActiveRuleBtn).on("click", function (e) {
			e.preventDefault();
			deactiveRuleModal.showConfirmModal();
		});
	
		function activeReturnRule(_ref) {
			var url = _ref.url,
			    success = _ref.success,
			    error = _ref.error;
	
			$.ajax({
				url: url,
				dataType: "TEXT",
				type: 'POST',
				success: success,
				error: error
			});
		}
	
		function activeRuleSuccess(returnRuleId) {
			if (returnRuleId > 0) {
				EditChecker.setPageClean();
				var detailUrlFullURL = detailURL + '&returnRuleId=' + returnRuleId;
				activateRuleModal.showSuccessModal();
				setTimeout(function () {
					location.href = detailUrlFullURL;
				}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			} else {
				activateRuleModal.showFailureModal();
			}
		}
	
		function activeRuleError() {
			activateRuleModal.hideAllModals();
		}
	
		function inActiveRuleSuccess(returnRuleId) {
			if (returnRuleId > 0) {
				EditChecker.setPageClean();
				var detailUrlFullURL = detailURL + '&returnRuleId=' + returnRuleId;
				deactiveRuleModal.showSuccessModal();
				setTimeout(function () {
					location.href = detailUrlFullURL;
				}, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
			} else {
				deactiveRuleModal.showFailureModal();
			}
		}
	
		function inActiveRuleError() {
			deactiveRuleModal.hideAllModals();
		}
	}

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(776);
	
	__webpack_require__(774);
	
	__webpack_require__(773);

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _select2able = __webpack_require__(22);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	var _pagination = __webpack_require__(143);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	var tableStatusPill = __webpack_require__(1430);
	var tableActionBtns = __webpack_require__(1429);
	var tableRuleLink = __webpack_require__(1428);
	var sharedModalHtml = __webpack_require__(11);
	var targetSelector = "#returns-rules-lookup-id";
	
	(0, _run2.default)(targetSelector, function () {
	  var el = $("#returns-rules-lookup-id");
	  returnsRulesLookup(el);
	});
	
	function returnsRulesLookup(el) {
	  var deactivateModalEl = void 0,
	      activateModalEl = void 0,
	      returnRulesDataTable = void 0;
	  var createUpdateURL = el.data("create-update-url");
	  var detailURL = el.data("detail-url");
	  var elTable = el.find(".return-rules-table");
	  var elTableBody = el.find(".return-rules-engine-tbody");
	  var rules = el.data("rules");
	  var currentReturnRuleRow = void 0;
	  var activeRuleURL = el.data("activate-rule-url");
	  var inActiveRuleURL = el.data("inactivate-rule-url");
	
	  var activateRuleModal = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Activate Rule',
	    confirmModalBody: '<div class="q-pad-all-xl">\n\t\t\t\t\t\t\tOnce updated, these changes will be reflected throughout the application.\n\t\t\t\t\t\t  </div>',
	    confirmModalBtnText: 'Activate Rule',
	    onConfirmClick: function onConfirmClick() {
	      activateRuleModal.showLoadingModal();
	      activateInactiveAjax({ url: activeRuleURL, success: activeRuleSuccess, error: activeRuleError });
	    }
	  });
	  activateRuleModal.init();
	
	  var deactiveRuleModal = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Deactive Rule',
	    confirmModalBody: '<div class="q-pad-all-xl">\n\t\t\t\t\t\t\tOnce updated, these changes will be reflected throughout the application.\n\t\t\t\t\t\t  </div>',
	    confirmModalBtnText: 'Deactive Rule',
	    onConfirmClick: function onConfirmClick() {
	      deactiveRuleModal.showLoadingModal();
	      activateInactiveAjax({ url: inActiveRuleURL, success: inActiveRuleSuccess, error: inActiveRuleError });
	    }
	  });
	  deactiveRuleModal.init();
	
	  function activateInactiveAjax(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error;
	
	    $.ajax({
	      data: { returnRuleId: currentReturnRuleRow.data().returnRuleId },
	      url: url,
	      dataType: "TEXT",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function activeRuleSuccess(returnRuleId) {
	    if (returnRuleId > 0) {
	      EditChecker.setPageClean();
	      activateRuleModal.showSuccessModal();
	      var updateRow = currentReturnRuleRow.data();
	      updateRow.returnRuleId = currentReturnRuleRow.data().returnRuleId;
	      updateRow.returnRule = currentReturnRuleRow.data().returnRule;
	      updateRow.returnDesc = currentReturnRuleRow.data().returnDesc;
	      updateRow.returnEffectiveUntil = currentReturnRuleRow.data().returnEffectiveUntil;
	      updateRow.returnStatus = true;
	      currentReturnRuleRow.data(updateRow).draw();
	      setTimeout(function () {
	        activateRuleModal.hideAllModals();
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      activateRuleModal.showFailureModal();
	    }
	  }
	
	  function activeRuleError() {
	    activateRuleModal.hideAllModals();
	  }
	
	  function inActiveRuleSuccess(returnRuleId) {
	    if (returnRuleId > 0) {
	      EditChecker.setPageClean();
	      deactiveRuleModal.showSuccessModal();
	      var updateRow = currentReturnRuleRow.data();
	      updateRow.returnRuleId = currentReturnRuleRow.data().returnRuleId;
	      updateRow.returnRule = currentReturnRuleRow.data().returnRule;
	      updateRow.returnDesc = currentReturnRuleRow.data().returnDesc;
	      updateRow.returnEffectiveUntil = currentReturnRuleRow.data().returnEffectiveUntil;
	      updateRow.returnStatus = false;
	      currentReturnRuleRow.data(updateRow).draw();
	      setTimeout(function () {
	        deactiveRuleModal.hideAllModals();
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      deactiveRuleModal.showFailureModal();
	    }
	  }
	
	  function inActiveRuleError() {
	    deactiveRuleModal.hideAllModals();
	  }
	
	  var defaultLookupDataTableOptions = {
	    "searching": false,
	    "paging": false,
	    "ordering": false,
	    "info": false,
	    "columnDefs": [{ "targets": [1], "orderable": false }, { className: "q-text-center", "targets": [4], "orderable": false }]
	  };
	
	  var returnsRulesLookupEl = elTable.dataTable(_extends({}, defaultLookupDataTableOptions, {
	    data: rules.content,
	    columns: [{
	      data: "returnRule",
	      "class": "anchor-text",
	      render: renderReturnsRulesDetailLink
	    }, {
	      data: "returnDesc"
	    }, {
	      data: "returnEffectiveUntil"
	    }, {
	      data: "returnStatus",
	      render: renderStatusPill
	
	    }, {
	      data: "returnStatus",
	      render: renderRowActionBtns
	    }]
	  }));
	
	  function renderReturnsRulesDetailLink(data, type, row) {
	    return '<a href=' + detailURL + '&returnRuleId=' + row.returnRuleId + '> ' + data + ' </a>';
	  }
	
	  function renderStatusPill(data, type, row) {
	    return (0, _render2.default)(tableStatusPill, {
	      value: getStatusPillText(data),
	      pillClassName: getStatusPillColor(data)
	    });
	  }
	
	  function getStatusPillColor(status) {
	    return isStatusActive(status) ? "q-pill-blue" : "q-pill-white-and-blue";
	  }
	
	  function getStatusPillText(status) {
	    return isStatusActive(status) ? "Active" : "Inactive";
	  }
	
	  function getToggleIconClass(status) {
	    return isStatusActive(status) ? "deactivate-rule-btn fa-toggle-on" : "activate-rule-btn fa-toggle-off";
	  }
	
	  function isStatusActive(status) {
	    return !!status;
	  }
	
	  function getTableData() {
	    return returnRules.data;
	  }
	
	  function renderRowActionBtns(data, type, row) {
	    return (0, _render2.default)(tableActionBtns, {
	      toggleStatusIconClassName: getToggleIconClass(data)
	    });
	  }
	  // These const should define after dataTable is render otherwise it will be assigned  "Undefined"
	  var activeRuleBtn = $(".activate-rule-btn");
	  var deactiveRuleBtn = $(".deactivate-rule-btn");
	  var returnRuleEditBtn = $(".return-rule-edit-btn");
	
	  activeRuleBtn.on('click', function (e) {
	    e.preventDefault();
	    currentReturnRuleRow = elTable.api().row($(this).closest('tr'));
	    activateRuleModal.showConfirmModal();
	  });
	
	  deactiveRuleBtn.on('click', function (e) {
	    e.preventDefault();
	    currentReturnRuleRow = elTable.api().row($(this).closest('tr'));
	    deactiveRuleModal.showConfirmModal();
	  });
	
	  returnRuleEditBtn.on('click', function (e) {
	    e.preventDefault();
	    var row = elTable.api().row($(this).closest('tr'));
	    location.href = createUpdateURL + '&returnRuleId=' + row.data().returnRuleId;
	  });
	
	  /* pagination at frontend  START */
	  var filterURL = el.data("filter-returns-rules-url");
	  window.migrateLookupFrontend = true;
	  var els = {};
	  var noop = function noop() {};
	  var namespace = el.data("namespace");
	  var elementsMap = {
	    emptyDiv: '.' + namespace + 'return-rules-table .dataTables_empty',
	    table: ".return-rules-table",
	    sortFieldHiddenInput: '#' + namespace + 'sortField',
	    sortTypeHiddenInput: '#' + namespace + 'sortType',
	    form: '#' + namespace + 'filter-form',
	    itemsPerPageSelect: '#' + namespace + 'itemsPerPage',
	    searchCriteria: '#' + namespace + 'searchCriteria'
	  };
	  setElements();
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	    els.lookupOuter = el;
	    els.rules = rules;
	    els.namespace = namespace;
	    els.generalErrorMessage = el.data("general-error-message");
	    els.lang = (0, _collectDataAttributesFor2.default)(els.lookupOuter.get(0), { prefix: "lang", camelize: false });
	  }
	  els.sortFieldHiddenInput.val("cbrCreatedDate");
	  els.sortTypeHiddenInput.val("asc");
	  els.itemsPerPageSelect.val(els.rules.page.size);
	
	  var paginator = (0, _pagination2.default)(els.lookupOuter, {
	    tableData: els.rules,
	    lang: els.lang
	  });
	
	  function postLookupSearchHelper() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$pageNumber = _ref2.pageNumber,
	        pageNumber = _ref2$pageNumber === undefined ? 0 : _ref2$pageNumber;
	
	    postLookupSearch({ pageNumber: pageNumber, elements: els, success: receivePostLookupSearch });
	  }
	
	  var searchRequest = void 0;
	
	  function postLookupSearch() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var elements = options.elements,
	        pageNumber = options.pageNumber,
	        size = options.size,
	        orderBy = options.orderBy,
	        orderByType = options.orderByType,
	        url = options.url,
	        _options$success = options.success,
	        _success = _options$success === undefined ? noop : _options$success,
	        _options$error = options.error,
	        error = _options$error === undefined ? noop : _options$error;
	    // Show loading overlay
	
	
	    if (searchRequest) {
	      // console.log("aborting");
	      searchRequest.abort();
	    }
	
	    searchRequest = $.ajax({
	      url: filterURL,
	      type: 'POST',
	      data: getCurrentPageDataForSearch(options),
	      dataType: 'JSON',
	      // DONT DO THIS
	      // async: false,
	      success: function success(data) {
	        // hide loading overlay
	        searchRequest = null;
	        _success(data);
	      },
	      error: error
	    });
	  }
	
	  function receivePostLookupSearch(newData) {
	    returnsRulesLookupEl.fnClearTable();
	    els.rules = newData;
	    if (els.rules.content.length > 0) {
	      returnsRulesLookupEl.fnAddData(els.rules.content);
	    } else {
	      els.emptyDiv.text(els.lang['lookup-filter-no-results-found']);
	    }
	    paginator.setTableData(els.rules);
	  }
	
	  function getCurrentPageDataForSearch(_ref3) {
	    var _$$param;
	
	    var _ref3$elements = _ref3.elements,
	        elements = _ref3$elements === undefined ? els : _ref3$elements,
	        pageNumber = _ref3.pageNumber,
	        size = _ref3.size,
	        orderBy = _ref3.orderBy,
	        orderByType = _ref3.orderByType;
	
	    var dataStr = elements.form.serialize();
	    var additionalDataStr = $.param((_$$param = {}, _defineProperty(_$$param, namespace + 'page', (0, _general.isPresent)(pageNumber) ? pageNumber : 0), _defineProperty(_$$param, namespace + 'size', (0, _general.isPresent)(size) ? size : elements.itemsPerPageSelect.val()), _defineProperty(_$$param, namespace + 'orderBy', (0, _general.isPresent)(orderBy) ? orderBy : elements.sortFieldHiddenInput.val()), _defineProperty(_$$param, namespace + 'orderByType', orderByType || elements.sortTypeHiddenInput.val()), _$$param));
	
	    return dataStr + "&" + additionalDataStr;
	  }
	
	  // This event notably comes from the backend js file,
	  // this is a work-around for now to allow the abundance of
	  // triggerSearch calls to be ported to the front
	  els.lookupOuter.on('exec-search', handleExecSearchEvent);
	
	  function handleExecSearchEvent(e, pageNumber) {
	    postLookupSearchHelper({ pageNumber: pageNumber });
	  }
	
	  /* pagination at frontend  END */
	}

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(780);
	
	__webpack_require__(781);
	
	__webpack_require__(779);
	
	__webpack_require__(778);
	
	__webpack_require__(783);
	
	__webpack_require__(782);

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = attachStubExample;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _general = __webpack_require__(5);
	
	var _underscore = __webpack_require__(2);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _jquery = __webpack_require__(1);
	
	var _util = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1); // REQUIRED IMPORTS
	
	__webpack_require__(276);
	// Additional Imports...
	var done = void 0;
	var enableUserEnteredAddressRadioForSPL = true;
	var disableSubmitAddressBtnIfInvalidAddressForSPL = true;
	
	var modalHtml = __webpack_require__(11);
	
	
	var elementsMap = {
	  configDoneBtn: ".submit-facility-setup-wizard",
	  createBtn: ".create-btn",
	  addReasonBtn: ".add-reason-btn",
	  defaultProductBtn: ".default-prodct-btn",
	  emailShippingAddressBtn: ".email-shipping-address-btn",
	  editAccountAddressSection: ".edit-account-address-section",
	  saveAccountAddressBtn: ".save-account-address-btn",
	  saveAccountAddressContinueBtn: ".save-account-address-continue",
	  copyTextLink: ".copy-text",
	  address1: ".ret-address1",
	  address2: ".ret-address2",
	  city: ".ret-city",
	  zipcode: ".ret-zip-code",
	  state: ".ret-state",
	  country: ".ret-country"
	};
	
	var elsModalMap = {
	  editAddressBtn: ".edit-address-btn"
	};
	
	var targetSelector = "#fedex-accounts-configuration-production";
	// Modal Html to use
	
	(0, _run2.default)(targetSelector, function (el) {
	  attachStubExample(el);
	  setupEditChecker(el);
	});
	
	function setupEditChecker(el) {
	  var alertTab = true;
	
	  $('.qw-nav-step').each(function () {
	    var tabValue = $(this).attr('data-qw-form-target');
	    if (tabValue === '.so-summary-tab') {
	      alertTab = false;
	    }
	  });
	  if (alertTab) {
	    $(window).on('beforeunload', function () {
	      return 'Are you sure you want to leave?';
	    });
	  }
	}
	
	function attachStubExample(el) {
	  var facilitySetupWizard = void 0,
	      addressErrorModal = void 0,
	      saveAccountAddressModal = void 0;
	  var submitModalFlow = void 0;
	
	  var els = {};
	  var elsModal = {};
	
	  // START: REQUIRED TO LOAD STUB
	  var entryEl = $("<div class='entry-point'></div>");
	  var mainHtml = (0, _render2.default)(__webpack_require__(313), {
	    accounts: __webpack_require__(1431),
	    locations: __webpack_require__(1435),
	    products: __webpack_require__(311),
	    returnConfigurations: __webpack_require__(312),
	    summary: __webpack_require__(314)
	  });
	
	  var mainEl = $(mainHtml);
	  $(el).html(entryEl);
	  entryEl.append(mainEl);
	  var saveFedexAccountUrl = el.data("save-fedex-account-url");
	  var saveAccountAddressUrl = el.data("save-account-address-url");
	  var addressValidationUrl = el.data("address-validation-url");
	  var saveFacilityDetailsUrl = el.data("save-facility-details-url");
	  var facNameCheckUrl = el.data("fac-name-check-url");
	  var facIdCheckUrl = el.data("fac-id-check-url");
	  var retailerName = el.data("retailer-name");
	  var retailerWebUrl = el.data("retailer-web-url");
	  var retailerAddress1 = el.data("retailer-address1");
	  var retailerAddress2 = el.data("retailer-address2");
	  var retailerCity = el.data("retailer-city");
	  var retailerState = el.data("retailer-state");
	  var retailerZipCode = el.data("retailer-zip-code");
	  var countryCode = el.data("retailer-country-code");
	  var usaStates = el.data('usa-states');
	  var caProvinces = el.data('ca-provinces');
	  var addressStateSelect = $("#address-state");
	  var addressValidationFor = el.data('address-validation-for');
	  var addValidationAddFoundTitleText = el.data('add-validation-add-found-title-text');
	  var addValidationSystemNotFoundAddText = el.data('add-validation-system-not-found-add-text');
	  var validationReqdCountries = el.data('validation-reqd-countries');
	  var defaultCountry = el.data('default-country');
	  var CountryList = el.data('countries');
	  var namespace = el.data('namespace');
	  var retailerLandingPage = el.data('retailer-landing-tab');
	  var activeSelfOnbaordTab = el.data("active-selfonbaordtab");
	  // var visitedTab = new arrayOf();
	  var allTabs = ["so-accounts-tab", "so-locations-tab", "so-products-tab", "so-returnConfigurations-tab", "so-summary-tab"];
	  var visitedTabs = [];
	  //let activeSelfOnbaordTab = "so-products-tab";
	  var visitedSelfOnboardTab = ["so-accounts-tab", "so-locations-tab"];
	  //Config Step 3 & 4 for prod
	  var cdmShortValue = $(".return-reason-short-value").val();
	  var cdmLongValue = $(".retunr-reason-display-value").val();
	
	  var defaultProductsSwitchery = $('#international-shipping');
	  var useDefaultItemFlagforProd = false;
	  var defaultProductsUrl = el.data("default-products-url");
	
	  var fedexBrandEmailSwitchery = $('#fedEx-branded-email');
	  var prodEmailFlag = false;
	  var emailShippingAddressUrl = el.data("email-shipping-address-url");
	
	  var overrideShippingSwitchery = $('#show-ability-override');
	  var prodOverrideShippingFlag = false;
	
	  var overrideShippingAddressSwitchery = $('#show-ability-override-address');
	  var prodShippingAddress = false;
	
	  var returnReasonsUrl = el.data("return-reasons-url");
	  var responseData = void 0;
	
	  var sobConfigDoneEmailUrl = el.data("sob-config-done-url");
	  var configComplete = true;
	
	  // END: REQUIRED TO LOAD STUB
	
	  // START: REAL CODE
	
	  function init() {
	    initQuickWizard();
	    generateModals();
	    setElementsInModals();
	    setElements();
	    bindElements();
	    renderMerchantAddress();
	    ActiveTabFarward();
	  }
	  /*$( document ).ready(function() {
	   ActiveTabFarward();
	   console.log("Prodect elememt id" +document.getElementById("productTab"));
	   console.log("prodct elemt html visisbilty" +document.getElementById("productTab").style.visibility);
	    document.getElementById("productTab").style.visibility = "visible";
	    }); */
	  /*   window.onload = function(e){ 
	       ActiveTabFarward();
	    console.log("Prodect elememt id" +document.getElementById("productTab"));
	    console.log("prodct elemt html visisbilty" +document.getElementById("productTab").style.visibility);
	     document.getElementById("productTab").style.visibility = "visible";
	    // document.getElementById("productTab").innerHTML = "New text!";
	       
	   } */
	  function determineInActiveTab(activeSelfOnbaordTab, visitedTabs) {
	    var index;
	    console.log("before active self onbaord activeSelfOnbaordTab tabs!" + activeSelfOnbaordTab);
	    console.log("before active self onbaord visitedTabs tabs!" + visitedTabs);
	    for (index = 0; index < visitedTabs.length; ++index) {
	      if (visitedTabs[index] === activeSelfOnbaordTab) {
	        // visitedTabs.splice(index, 1);
	        console.log("inside index valuse id!!!!!!" + index);
	        visitedTabs.splice(index + 1, 9e9);
	        console.log("all visited tabs after!!!!" + visitedTabs);
	        break;
	      }
	    }
	  }
	  function ActiveTabFarward(e) {
	    console.log("Inside new activetab farward function");
	    console.log("activeSelfOnbaordTab" + activeSelfOnbaordTab);
	    if (!(0, _util.isNullOrUndefined)(activeSelfOnbaordTab) && !(0, _general.isBlank)(activeSelfOnbaordTab)) {
	
	      visitedTabs = [].concat(allTabs);
	      var inActiveTabs = determineInActiveTab(activeSelfOnbaordTab, visitedTabs);
	      //var inActiveTabs = allTabs.filter(determineInActiveTab(activeSelfOnbaordTab, allTabs ))
	
	      $('.qw-nav-step').each(function (index) {
	        console.log("index" + index);
	
	        document.getElementById("accountsTab").style.visibility = "hidden";
	        var tabCssValue = $(this).attr('data-qw-form-target');
	        console.log('this is inside tabs list ' + tabValue);
	        // $(this).removeClass('active');
	        /*if (tabValue === '.so-accounts-tab') {
	          $(this).removeClass('active');
	          $(this).addClass('visited');
	        }*/
	
	        var tabValue = tabCssValue.replace(".", "");
	        if (activeSelfOnbaordTab == tabValue) {
	          console.log("Inside locationtab active inside");
	          //$(activeSelfOnbaordTab).add
	          //$('.so-accounts-tab').addClass('visited'); 
	          // document.getElementById("accountsTabForm").classList.remove('active');
	          // document.getElementById("accountsTabForm").classList.add('visited');
	          // document.getElementById("accountsTab").style.visibility = "hidden";
	          // document.getElementById("locationTab").style.visibility = "visible";
	          //e.preventDefault();
	          $(this).addClass('active');
	          var href = $(this).attr('href');
	          console.log("href" + href);
	          // $('#container').load(href);
	          $('section').empty().load(href);
	          //document.getElementById("accountsTabForm").classList.add('visited');
	          //activeSelfOnbaordTab = '';
	        } else if ($.inArray(tabValue, visitedTabs) != -1) {
	
	          $(this).addClass('visited');
	          $(this).removeClass('active');
	        } else {
	          $(this).removeClass('active');
	        }
	      });
	      /* try {
	       $(".self-tab").each(function(){
	         debugger;
	           console.log("Check has class :  "+$(this).hasClass(activeSelfOnbaordTab));
	           console.log("class Info:  "+$(this).attr('class'));
	           document.getElementById("accountsTab").style.visibility = "hidden";
	           if($(this).hasClass(activeSelfOnbaordTab)){
	             console.log("Inside if  Info:  "+$(this).attr('class'));
	              $(this).css("visibility", "visible");
	            $(this).css("transform", "none");
	            throw BreakException;
	           }else{
	             console.log("Inside else Info:  "+$(this).attr('class'));
	             $(this).css("visibility", "hidden");
	           }
	       }); } catch (e) {
	         if (e !== BreakException) throw e;
	       } */
	    }
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	  }
	
	  function setElementsInModals() {
	    var body = $('body');
	    (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, body);
	  }
	
	  function bindElements() {
	    //els.doneBtn.click(createPreventDefault(showSubmitModal));  
	    els.createBtn.click(function (e) {
	      e.preventDefault();
	      saveFedexAccount({ url: saveFedexAccountUrl, success: successOnSaveFedexAccount, error: errorOnSaveFedexAccount });
	    });
	    //Production Return reason list button function
	    els.addReasonBtn.click(function (e) {
	      e.preventDefault();
	      console.log('Short value -->>' + $(".return-reason-short-value").val());
	      console.log('display value-->>' + $(".retunr-reason-display-value").val());
	      addReason({ url: returnReasonsUrl });
	    });
	
	    //production defult item swithch save 
	    els.defaultProductBtn.click(function (e) {
	      e.preventDefault();
	      console.log('default switch -->>');
	      saveDefaultProducts({ urlDf: defaultProductsUrl });
	    });
	
	    // send email once config is done 
	    els.configDoneBtn.click(function (e) {
	      e.preventDefault();
	      console.log('config done -->>');
	      sendConfigDoneEmail({ configDoneurl: sobConfigDoneEmailUrl });
	    });
	
	    // branded email, default shipping override and address 
	    els.emailShippingAddressBtn.click(function (e) {
	      e.preventDefault();
	      console.log('emailShippingAddressBtn -->>');
	      saveEmailShippingAddress({ urlEsa: emailShippingAddressUrl });
	    });
	
	    els.copyTextLink.click((0, _general.createPreventDefault)(copyToClipboard));
	    els.saveAccountAddressBtn.click((0, _general.createPreventDefault)(validateAddress));
	    els.saveAccountAddressContinueBtn.click((0, _general.createPreventDefault)(saveAccountAddress));
	    elsModal.editAddressBtn.click((0, _general.createPreventDefault)(showAccountInfoModal));
	  }
	
	  // production: prevent previous button navigation
	  function initQuickWizard() {
	    facilitySetupWizard = new _QuickWizard2.default(mainEl, {
	      tabletWidthNavStep: 1090,
	      mobileWidthNavStep: 950,
	      shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	        var targetForm = _ref.targetForm,
	            direction = _ref.direction,
	            currentForm = _ref.currentForm,
	            done = _ref.done;
	
	        // Any time we go traverse backwards, just let us  
	        console.log('-->2 ' + currentForm.filter(".so-products-tab").length);
	        if (currentForm.filter(".so-products-tab").length) {
	          if (targetForm.filter(".so-accounts-tab").length || targetForm.filter(".so-locations-tab").length) {
	            direction = "BACKWARDS";
	          }
	        }
	
	        if (currentForm.filter(".so-returnConfigurations-tab").length) {
	          if (targetForm.filter(".so-accounts-tab").length || targetForm.filter(".so-locations-tab").length || targetForm.filter(".so-products-tab").length) {
	            direction = "BACKWARDS";
	          }
	        }
	
	        if (currentForm.filter(".so-summary-tab").length) {
	          if (targetForm.filter(".so-accounts-tab").length || targetForm.filter(".so-locations-tab").length || targetForm.filter(".so-products-tab").length || targetForm.filter(".so-returnConfigurations-tab").length) {
	            direction = "BACKWARDS";
	          }
	        }
	
	        if (direction === "BACKWARDS") {
	          return false;
	        }
	
	        // if (direction === "FORWARDS") {  
	        //   console.log(currentForm.filter(".accounts-prod-btn").length);
	        //   if (currentForm.filter(".accounts-prod-btn").length !== 0) {
	        //     return false;
	        //   } else{ 
	        //     return true;
	        //   }
	
	        // }
	        return true;
	      },
	
	      didNavigateToForm: function didNavigateToForm(_ref2) {
	        var currentForm = _ref2.currentForm;
	
	        return true;
	      }
	    });
	
	    facilitySetupWizard.init();
	
	    $(document).on('click', "[data-target-form]", function () {
	      var form = mainEl.find($(this).data("target-form"));
	      facilitySetupWizard.gotToForm(form);
	    });
	  }
	
	  function generateModals() {
	
	    submitModalFlow = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Save Facility',
	      confirmModalBody: '<div class="q-pad-all-xl">Once you have saved this facility, it can be referenced throughout the application.</div>',
	      confirmModalBtnText: 'Save',
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        // Show Loading Modal
	        submitModalFlow.showLoadingModal();
	
	        // Success
	        setTimeout(function () {
	          submitModalFlow.showSuccessModal();
	        }, 3000);
	
	        // Hide All Modals
	        setTimeout(function () {
	          submitModalFlow.hideAllModals();
	        }, 6000);
	      }
	    });
	
	    submitModalFlow.init();
	
	    addressErrorModal = $((0, _render2.default)(modalHtml, {
	      title: 'Registration Error Details',
	      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-activate-rule modal-auto-hide">Cancel</a>\
	          <a href="#" class="base-btn purple-btn edit-address-btn">Edit Address</a>',
	      body: "<div class='q-marg-all-xl'>There appears to be an issue with FedEx Meter services while registering the given Fedex Account Number. <div><br/>Validate the Account Number, Registered Address match, and if they do not match click the edit address button to correct the issue.</div></div>",
	      topCloseBtn: true,
	      autoHideTop: true,
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-500"
	    }));
	
	    saveAccountAddressModal = $((0, _render2.default)(modalHtml, {
	      title: 'Save Account Address',
	      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn modal-auto-hide">Cancel</a>\
	          <a href="#" class="base-btn purple-btn save-account-address-continue">Continue</a>',
	      body: "<div class='q-marg-all-xl'>Please continue to save the account address.</div></div>",
	      topCloseBtn: true,
	      autoHideTop: true,
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-500"
	    }));
	
	    $('body').append(addressErrorModal, saveAccountAddressModal);
	  };
	
	  function showSubmitModal() {
	    submitModal.showConfirmModal();
	  }
	  function sendConfigDoneEmail(_ref3) {
	    var configDoneurl = _ref3.configDoneurl;
	
	    {
	      $.ajax({
	        data: {
	          "configComplete": configComplete
	        },
	        url: configDoneurl,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(data) {
	          console.log('config done ' + data.status);
	          console.log('config done email ajax ' + JSON.stringify(data));
	
	          console.log('in show submit');
	          var myUrl = "/c/portal/logout";
	          window.open(myUrl, '_self', '');
	          console.log('in show submit-- ' + myUrl);
	        }
	      });
	    }
	  }
	
	  //Send email once the config is done
	
	
	  function showAccountInfoModal() {
	    submitModalFlow.hideAllModals();
	    addressErrorModal.modal("hide");
	    els.editAccountAddressSection.show();
	  }
	
	  function showAddressErrorModal() {
	    //submitModalFlow.hideAllModals();
	    addressErrorModal.modal("show");
	  }
	
	  $("#save-account-address-cancel").click(function () {
	    $("#confirmationBoxToSaveAccountAddress").modal("hide");
	  });
	  $("#save-account-address-continue").click(function () {
	    $("#confirmationBoxToSaveAccountAddress").modal("hide");
	    saveAccountAddress();
	  });
	
	  function renderStates(retailerState) {
	    $(usaStates).each(function () {
	      var option = $('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmMeaning);
	      if (retailerState === this.cdmValue) {
	        option.attr('selected', 'selected');
	      }
	      $('#address-state').append(option);
	    });
	  }
	
	  function renderCountry(countryCode) {
	    console.log("countryCode" + countryCode);
	    $(CountryList).each(function () {
	      var option = $('<option />');
	      option.attr('value', this.conCode).text(this.conName);
	      if (countryCode === this.conCode) {
	        option.attr('selected', 'selected');
	      }
	      $('#selfAccountCountry').append(option);
	    });
	  }
	
	  $(CountryList).each(function () {
	    var option = $('<option />');
	    option.attr('value', this.conCode).text(this.conName);
	    //option.attr('value', this.cdmValue).text(this.cdmMeaning);
	    $('#selfLocationCountry').append(option);
	  });
	
	  $('#selfLocationCountry').change(function () {
	    var countryVal = $('#selfLocationCountry option:selected').val();
	    setStates(countryVal);
	  });
	
	  function setStates(countryVal) {
	    $('#selfLocationState').html('');
	    var option = $('<option />');
	    option.attr('value', "-1").text('Select State/Province/Region');
	    option.attr('selected', 'selected');
	    option.attr('disabled', 'disabled');
	    var checkZipCode = false;
	    $(CountryList).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	    if (countryVal == "US" && checkZipCode) {
	      $('#selfLocationStateContainer').css("display", "block");
	      $('#facstateTextContainer').css("display", "none");
	      $('#facstateText').prop('required', false);
	      $('#selfLocationState').prop('required', true);
	      $('#selfLocationState').append(option);
	      $(usaStates).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	
	        $('#selfLocationState').append(option);
	      });
	    } else if (countryVal == "CA" && checkZipCode) {
	      $('#selfLocationStateContainer').css("display", "block");
	      $('#facstateTextContainer').css("display", "none");
	      $('#facstateText').prop('required', false);
	      $('#selfLocationState').prop('required', true);
	      $('#selfLocationState').append(option);
	      $(caProvinces).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        $('#selfLocationState').append(option);
	      });
	    } else {
	      $('#facstateText').prop('required', false);
	      $('#selfLocationState').prop('required', false);
	      $('#selfLocationStateContainer').css("display", "none");
	      $('#facstateTextContainer').css("display", "block");
	    }
	  }
	
	  $(".fac-loc-id").change(function () {
	    console.log("inside duplicate fac id check ");
	    validateFacilityId();
	  });
	  $(".fac-loc-name").change(function () {
	    validateFacilityName();
	  });
	
	  $('.add-location-btn').click(function (event) {
	    event.preventDefault();
	    console.log("Inside acoount add button func");
	
	    var requiredFields = $('#saveLocationSection input, select').filter('[required]:visible');
	    var allRequired = true;
	    requiredFields.each(function () {
	      $("#requriedFieldError").each(function () {
	        $(this).remove();
	      });
	    });
	    requiredFields.each(function () {
	      if ($(this).val() == '') {
	        allRequired = false;
	        var error = '<label id="requriedFieldError" class="help-block" style="color: red;">The field is required !!</label>';
	        $(this).after(error);
	      }
	    });
	    console.log("allRequired is :" + allRequired);
	    if (allRequired) {
	      var _addressValidationModalEl = $("#add-validation-model");
	      var addressValidationForSelfFacilityTab = (0, _AddressValidation2.default)(null, el, {
	        isAlreadyValid: false,
	        currentTab: ".so-locations-tab",
	        disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	        disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	      });
	      console.log("address value " + JSON.stringify(addressValidationForSelfFacilityTab.determineAddressValidity(done)));
	      console.log("Address Validation :  " + document.getElementById("addLocationFlagForAddressValidation").value + "     " + $("#addLocationFlagForAddressValidation").val());
	      if (document.getElementById("addLocationFlagForAddressValidation").value == 'Validated') {
	        //saveFacilityDetails();
	      }
	
	      $("#shipToLocations").css("display", "none");
	      $("#shipToLocationsEdit").css("display", "none");
	      viewFacilityDetails();
	
	      $('.qw-nav-step').each(function () {
	
	        var tabValue = $(this).attr('data-qw-form-target');
	        console.log('this is inside tabs list ' + tabValue);
	        if (tabValue === '.so-accounts-tab') {
	          console.log('accounts tab hide');
	          $(this).removeClass('active');
	          $(this).addClass('visited');
	        }
	        if (tabValue === '.so-locations-tab') {
	          console.log('location tab show');
	          $(".loc-next-btn").removeClass('disabled');
	          $(this).addClass('active');
	        }
	      });
	    }
	  });
	
	  $('.loc-next-btn').click(function (event) {
	    console.log("Inside Next Button loc screen");
	    $(".loc-next-btn").removeClass('disabled');
	    saveFacilityDetails();
	  });
	  $("#self-save-loc-cancel").click(function () {
	    $("#saveSelfLocation").modal("hide");
	  });
	  $("#self-save-loc-continue").click(function () {
	    saveFacilityDetails();
	    $("#saveSelfLocation").modal("hide");
	  });
	  function saveFacilityDetails() {
	    $('.fac-id-view').text($(".fac-loc-id").val());
	    if ($(".fac-country").val() == 'US' || $(".fac-country").val() == 'CA') {
	      var facState = $(".fac-state").val();
	    } else {
	      var _facState = $(".fac-state-text").val();
	    }
	    $.ajax({
	      data: {
	        "facilityid": $(".fac-loc-id").val(),
	        "facilityname": $(".fac-loc-name").val(),
	        "facAddress1": $(".fac-address1").val(),
	        "facAddress2": $(".fac-address2").val(),
	        "facCity": $(".fac-city").val(),
	        "facState": $(".fac-state").val(),
	        "facZipcode": $(".fac-zip-code").val(),
	        "facCountry": $(".fac-country").val(),
	        "facContactname": $(".fac-contactname").val(),
	        "facEmail": $(".fac-contact-email").val(),
	        "facPhone": $(".loc-contact-phone").val(),
	        "facFedexAccount": $(".fac-ship-acc-number").val()
	      },
	      url: saveFacilityDetailsUrl,
	      dataType: "JSON",
	      type: 'POST',
	
	      success: function success(response) {
	        //var activeTab = $(".tabs").tabs( "option", "active" );
	        submitModalFlow.showSuccessModal();
	        setTimeout(function () {
	          submitModalFlow.hideAllModals();
	        }, 100);
	        $(".loc-next-btn").removeClass('enabled');
	        // $("#shipToLocations").css("display","block");
	        //$("#shipToLocationsEdit").css("display","block");
	        $("#saveLocationSection").children().prop("disabled", true);
	        // $("#saveLocationSection").css("dsiplay", "none");
	        // $('.add-location-btn').attr('disabled','disabled');
	        //$("#saveLocationSection").hide();
	        //$(".loc-next-btn").removeAttr('disabled');
	        document.getElementById("locNextBtn").disabled = false;
	        console.log("insid sucess add fac function");
	        //viewFacilityDetails();
	      },
	      error: function error() {
	        $(".loc-next-btn").removeClass('disabled');
	        submitModalFlow.showFailureModal();
	      }
	    });
	  }
	
	  $('.loc-edit').click(function (event) {
	    console.log("Inside edit butto loca screen");
	    //showFacility();
	    event.preventDefault();
	    //$("#saveLocationSection").css("dsiplay", "block");
	    //$("#saveLocationSection").show();
	    //document.getElementById("saveLocationSection").style.visibility = "visible";
	    document.getElementById("saveLocationSection").style.display = "block";
	    $('.add-location-btn').removeAttr('disabled');
	    $('.fac-loc-id').prop("disabled", false);
	    $('.fac-loc-name').prop("disabled", false);
	    $('.fac-address1').prop("disabled", false);
	    $('.fac-address2').prop("disabled", false);
	    $('.fac-city').prop("disabled", false);
	    $('.fac-state').prop("disabled", false);
	    $('.fac-zip-code').prop("disabled", false);
	    $('.fac-country').prop("disabled", false);
	    $('.fac-contactname').prop("disabled", false);
	    $('.fac-contact-email').prop("disabled", false);
	    $('.loc-contact-phone').prop("disabled", false);
	    $('.fac-ship-acc-number').prop("disabled", false);
	  });
	
	  function viewFacilityDetails() {
	    //hideFacilty();
	    //$("#saveLocationSection").css("dsiplay", "none");
	    document.getElementById("noneAddedMsg").style.visibility = "hidden";
	    $('.add-location-btn').attr('disabled', 'disabled');
	    $('.fac-loc-id').prop("disabled", true);
	    $('.fac-loc-name').prop("disabled", true);
	    $('.fac-address1').prop("disabled", true);
	    $('.fac-address2').prop("disabled", true);
	    $('.fac-city').prop("disabled", true);
	    $('.fac-state').prop("disabled", true);
	    $('.fac-zip-code').prop("disabled", true);
	    $('.fac-country').prop("disabled", true);
	    $('.fac-contactname').prop("disabled", true);
	    $('.fac-contact-email').prop("disabled", true);
	    $('.loc-contact-phone').prop("disabled", true);
	    $('.fac-ship-acc-number').prop("disabled", true);
	
	    $('.fac-id-view').text($(".fac-loc-id").val());
	    $('.fac-name-view').text($(".fac-loc-name").val());
	    $('.fac-address1-view').text($(".fac-address1").val());
	    $('.fac-address2-view').text($(".fac-address2").val());
	    $('.fac-city-view').text($(".fac-city").val());
	    $('.fac-state-view').text($(".fac-state").val());
	    $('.fac-zipcode-view').text($(".fac-zip-code").val());
	    $('.fac-country-view').text($(".fac-country").val());
	    $('.fac-contactname-view').text($(".fac-contactname").val());
	    $('.fac-contact-email-view').text($(".fac-contact-email").val());
	    $('.fac-phone-view').text($(".loc-contact-phone").val());
	    $('.fac-shipping-account-view').text($(".fac-ship-acc-number").val());
	  }
	
	  //collapse after save locations
	  function showFacility() {
	    //debugger;
	    console.log("in collapse");
	    var x = document.getElementById("saveLocationSection");
	    x.style.display = "block";
	  }
	
	  function hideFacilty() {
	    //debugger;
	    console.log("in collapse");
	    var x = document.getElementById("saveLocationSection");
	    x.style.display = "none";
	  }
	
	  //duplicate facility name check
	  function validateFacilityName() {
	    var facName = $(".fac-loc-name").val();
	    $.ajax({
	      async: false,
	      data: {
	        facName: facName
	      },
	      url: facNameCheckUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        if (data.response == true) {
	          $(".dup-facName").show();
	        } else {
	          $(".dup-facName").hide();
	        }
	      }
	    });
	  }
	
	  function validateFacilityId() {
	    console.log("inside check fac id ajax call");
	    console.log("facIdCheckUrl is :" + facIdCheckUrl);
	    var facId = $(".fac-loc-id").val();
	    $.ajax({
	      async: false,
	      data: {
	        facId: facId
	      },
	      url: facIdCheckUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        console.log("inside sucess go fac id " + data.response);
	        if (data.response == true) {
	          $(".dup-facId").show();
	        } else {
	          $(".dup-facId").hide();
	        }
	      }
	    });
	  }
	  //for copying text
	  function copyToClipboard() {
	    CopyToClipbrd("https://fulfillment.fedex.com", true, "URL copied");
	  }
	
	  function CopyToClipbrd(value, showNotification, notificationText) {
	    var $temp = $("<input>");
	    $("body").append($temp);
	    $temp.val(value).select();
	    document.execCommand("copy");
	    $temp.remove();
	
	    if (typeof showNotification === 'undefined') {
	      showNotification = true;
	    }
	    if (typeof notificationText === 'undefined') {
	      notificationText = "Copied to clipboard";
	    }
	
	    var notificationTag = $("div.copy-url-notification");
	    if (showNotification && notificationTag.length == 0) {
	      notificationTag = $("<div/>", { "class": "copy-url-notification", text: notificationText });
	      $("body").append(notificationTag);
	
	      notificationTag.fadeIn("slow", function () {
	        setTimeout(function () {
	          notificationTag.fadeOut("slow", function () {
	            notificationTag.remove();
	          });
	        }, 1000);
	      });
	    }
	  }
	
	  //let done;
	  var addressValidationModalEl = $("#add-validation-model");
	  function validateAddress() {
	    var accountRequiredFields = $('#editAddressSection input, select').filter('[required]:visible');
	    var allRqd = true;
	
	    accountRequiredFields.each(function () {
	      $("#requriedFieldaccountError").each(function () {
	        $(this).remove();
	      });
	    });
	    accountRequiredFields.each(function () {
	      if ($(this).val() == '') {
	        allRqd = false;
	        var error = '<label id="requriedFieldaccountError" class="help-block" style="color: red;">The field is required !!</label>';
	        $(this).after(error);
	      }
	    });
	    if (allRqd) {
	      // $("#requriedFieldError").remove();
	      var addressValidationForAccountConfigurationTab = (0, _AddressValidation2.default)(null, el, {
	        isAlreadyValid: false,
	        currentTab: ".so-accounts-tab",
	        disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	        disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	      });
	
	      console.log("address value" + JSON.stringify(addressValidationForAccountConfigurationTab.determineAddressValidity(done)));
	      //$("#confirmationBoxToSaveAccountAddress").modal("show");
	    }
	  }
	
	  /*$(".use-selected-address-btn").click(function(){
	    saveAccountAddressModal.modal("show");
	  });*/
	
	  function saveAccountAddress() {
	    submitModalFlow.showLoadingModal();
	    $.ajax({
	      data: {
	        "address1": els.address1.val(),
	        "address2": els.address2.val(),
	        "city": els.city.val(),
	        "state": els.state.val(),
	        "zipcode": els.zipcode.val()
	      },
	      url: saveAccountAddressUrl,
	      dataType: 'JSON',
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function success(response) {
	    console.log('response.status  --' + response.status);
	    if (response.status == "Success") {
	      $(".accounts-prod-btn").removeClass('enabled');
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        submitModalFlow.hideAllModals();
	      }, 3000);
	    } else {
	      //$(".accounts-prod-btn").removeClass('disabled');
	      submitModalFlow.showFailureModal();
	    }
	  }
	
	  function error() {
	    //$(".accounts-prod-btn").removeClass('disabled');
	    submitModalFlow.showFailureModal();
	  }
	
	  function saveFedexAccount(_ref4) {
	    var url = _ref4.url,
	        success = _ref4.success,
	        error = _ref4.error;
	
	
	    var accNumGiven = true;
	    $("#requriedAccountFieldError").each(function () {
	      $(this).remove();
	    });
	    if ($(".fedex-shipping-account-num").val() === '') {
	      accNumGiven = false;
	      var error = '<label id="requriedAccountFieldError" class="help-block" style="color: red;">The field is required !!</label>';
	      $('.fedex-shipping-account-num').after(error);
	    }
	
	    if (accNumGiven) {
	      $("#requriedFieldError").remove();
	      submitModalFlow.showLoadingModal();
	      $.ajax({
	        data: {
	          "fedExShippingAccountNumber": $(".fedex-shipping-account-num").val(),
	          "smartPostHubId": $(".smart-post-hub-id").val()
	        },
	        url: url,
	        dataType: 'JSON',
	        type: 'POST',
	        success: successOnSaveFedexAccount,
	        error: errorOnSaveFedexAccount
	      });
	    }
	  }
	  function successOnSaveFedexAccount(response) {
	    setTimeout(function () {
	      submitModalFlow.hideAllModals();
	    }, 3000);
	    if (response.status == "Success") {
	      document.getElementById("createBtnAccount").setAttribute("disabled", "disabled");
	      $(".accounts-prod-btn").removeClass('disabled');
	      $(".fac-ship-acc-number").val($(".fedex-shipping-account-num").val());
	      submitModalFlow.showSuccessModal();
	    } else {
	      showAddressErrorModal();
	    }
	  }
	  function errorOnSaveFedexAccount() {
	    showAddressErrorModal();
	    $(".accounts-prod-btn").removeClass('enabled');
	  }
	
	  $(".accounts-prod-btn").click(function (event) {
	    document.getElementById("saveLocationSection").style.display = "block";
	    $("#completeFieldsMsg").css("display", "block");
	    $("#shipToLocations").css("display", "none");
	    $("#shipToLocationsEdit").css("display", "none");
	  });
	  //Production Config step 3 default product 
	  defaultProductsSwitchery.on('change', function (e) {
	    if (defaultProductsSwitchery.is(":checked")) {
	      useDefaultItemFlagforProd = true;
	      console.log('useDefaultItemFlagforProd ' + useDefaultItemFlagforProd);
	    } else {
	      useDefaultItemFlagforProd = false;
	      console.log('useDefaultItemFlagforProd ' + useDefaultItemFlagforProd);
	    }
	  });
	
	  //Production Config step 3  save default product
	  function saveDefaultProducts(_ref5) {
	    var urlDf = _ref5.urlDf;
	
	    debugger;
	    {
	      $.ajax({
	        data: {
	          "defaultProduct": useDefaultItemFlagforProd
	        },
	        url: urlDf,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(data) {
	          console.log('res1 ' + data.status);
	          console.log('prod in defautl products ajax ' + JSON.stringify(data));
	        }
	      });
	    }
	  }
	
	  //Production Config step 4 Fedex Branded email swich 
	  fedexBrandEmailSwitchery.on('change', function (e) {
	    if (fedexBrandEmailSwitchery.is(":checked")) {
	      prodEmailFlag = true;
	      console.log('prodEmailFlag ' + prodEmailFlag);
	    } else {
	      prodEmailFlag = false;
	      console.log('prodEmailFlag ' + prodEmailFlag);
	    }
	  });
	
	  //Production Config step 4 override default shipping swich 
	  overrideShippingSwitchery.on('change', function (e) {
	    if (overrideShippingSwitchery.is(":checked")) {
	      prodOverrideShippingFlag = true;
	      console.log('prodOverrideShippingFlag ' + prodOverrideShippingFlag);
	    } else {
	      prodOverrideShippingFlag = false;
	      console.log('prodOverrideShippingFlag ' + prodOverrideShippingFlag);
	    }
	  });
	
	  //Production Config step 4 override ship to address swich 
	  overrideShippingAddressSwitchery.on('change', function (e) {
	    if (overrideShippingAddressSwitchery.is(":checked")) {
	      prodShippingAddress = true;
	      console.log('prodShippingAddress ' + prodShippingAddress);
	    } else {
	      prodShippingAddress = false;
	      console.log('prodShippingAddress ' + prodShippingAddress);
	    }
	  });
	
	  //step 4 email ,default shipping and address ajax production
	  function saveEmailShippingAddress(_ref6) {
	    var urlEsa = _ref6.urlEsa;
	
	    debugger;
	    {
	      $.ajax({
	        data: {
	          "fedexBrandedEmail": prodEmailFlag,
	          "defaultShippingOverride": prodOverrideShippingFlag,
	          "shippingAddressOverride": prodShippingAddress,
	          "defaultProduct": useDefaultItemFlagforProd
	        },
	        url: urlEsa,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(data) {
	          console.log('in success ' + data.status);
	          console.log('prod email,orverride shipping,address ajax ' + JSON.stringify(data));
	        }
	      });
	    }
	  }
	
	  //Production Config step 4 adding return reason list
	  function addReason(_ref7) {
	    var url = _ref7.url;
	
	    {
	      $.ajax({
	        data: {
	          "cdmValue": $(".return-reason-short-value").val(),
	          "cdmMeaning": $(".retunr-reason-display-value").val()
	        },
	        url: url,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(response) {
	          responseData = response.data;
	          console.log('prod in reason ajax ' + JSON.stringify(response.data));
	
	          console.log("cdmValue --> " + responseData.cdmValue);
	          console.log("cdmMeaning --> " + responseData.cdmMeaning);
	          if (responseData.cdmValue !== null && responseData.cdmMeaning !== null) {
	            document.getElementById('responseData').innerHTML += '<li>' + responseData.cdmValue + '    ' + responseData.cdmMeaning + '</li>';
	          }
	
	          $(".return-reason-short-value").val('');
	          $(".retunr-reason-display-value").val('');
	        }
	
	      });
	    }
	  }
	
	  // success: function (response) {
	  //   debugger;
	  //   responseData = response.data;
	  //   console.log('prod in reason ajax ' + JSON.stringify(response.data));  
	
	  //  // response.data.forEach((obj, i) => {
	  //    // debugger;
	  //    // if (  response.data.length < 4 ){
	
	  //       document.getElementById('responseData').innerHTML += '<li>' + responseData.cdmValue +'    '+ responseData.cdmMeaning + '</li>';            
	  //   //  }         
	  //     console.log("cdmValue --> "+ responseData.cdmValue);
	  //     console.log("cdmMeaning --> "+ responseData.cdmMeaning);
	  // });
	  // data.messages.map((obj, i) => {
	  //   console.log("msgFrom", obj.msgFrom);
	  //   console.log("msgBody", obj.msgBody);
	  // });
	
	  // function renderReturnReasons(retailerState){
	  //   $(usaStates).each(function(){
	  //     var option = $('<option />');
	  //     option.attr('value', this.cdmValue).text(this.cdmMeaning);
	  //     if(retailerState===this.cdmValue)
	  //     {
	  //       option.attr('selected','selected');
	  //     }
	  //     console.log(option);
	  //     $('#address-state').append(option);
	  //   });
	  //}
	
	  function renderMerchantAddress() {
	    els.editAccountAddressSection.hide();
	    els.address1.val(retailerAddress1);
	    els.address2.val(retailerAddress2);
	    els.city.val(retailerCity);
	    els.zipcode.val(retailerZipCode);
	    $('.ret-country').val(countryCode);
	    $('.merchant-name').val(retailerName);
	    $('.merchant-name').prop("disabled", true);
	    $('.merchant-web-url').val(retailerWebUrl);
	    $('.merchant-web-url').prop("disabled", true);
	    renderStates(retailerState);
	    renderCountry(countryCode);
	  }
	  init();
	
	  // END: REAL CODE
	};

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = attachStubExample;
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _general = __webpack_require__(5);
	
	var _underscore = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	__webpack_require__(276);
	// Additional Imports...
	
	var done = void 0;
	var enableUserEnteredAddressRadioForSPL = true;
	var disableSubmitAddressBtnIfInvalidAddressForSPL = true;
	
	var modalHtml = __webpack_require__(11);
	
	
	var elementsMap = {
	  configDoneBtn: ".submit-facility-setup-wizard",
	  smartPostBtn: ".smart-post-btn",
	  defaultProductBtn: ".default-prodct-btn",
	  emailShippingAddressBtn: ".email-shipping-address-btn",
	  addReasonBtn: ".add-reason-btn",
	  editAccountAddressSection: ".edit-account-address-section",
	  copyTextLink: ".copy-text"
	};
	
	var elsModalMap = {
	  editAddressBtn: ".edit-address-btn"
	};
	
	var targetSelector = "#fedex-accounts-configuration-sandbox";
	
	// Modal Html to use
	
	(0, _run2.default)(targetSelector, function (el) {
	  attachStubExample(el);
	});
	
	function attachStubExample(el) {
	  var facilitySetupWizard = void 0,
	      addressErrorModal = void 0;
	  var submitModal = void 0;
	
	  var els = {};
	  var elsModal = {};
	
	  // START: REQUIRED TO LOAD STUB
	  var entryEl = $("<div class='entry-point'></div>");
	  var mainHtml = (0, _render2.default)(__webpack_require__(313), {
	    accounts: __webpack_require__(1432),
	    locations: __webpack_require__(1438),
	    products: __webpack_require__(311),
	    returnConfigurations: __webpack_require__(312),
	    summary: __webpack_require__(314)
	  });
	
	  var mainEl = $(mainHtml);
	  //$(targetSelector).html(entryEl);
	  $(el).html(entryEl);
	  entryEl.append(mainEl);
	  var saveFedexAccountUrl = el.data("save-fedex-account-url");
	  var saveAccountAddressUrl = el.data("save-account-address-url");
	  var addressValidationUrl = el.data("address-validation-url");
	  var saveFacilityDetailsUrl = el.data("save-facility-details-url");
	  var facNameCheckUrl = el.data("fac-name-check-url");
	  var facIdCheckUrl = el.data("fac-id-check-url");
	  var retailerName = el.data("retailer-name");
	  var retailerWebUrl = el.data("retailer-web-url");
	  var retailerAddress1 = el.data("retailer-address1");
	  var retailerAddress2 = el.data("retailer-address2");
	  var retailerCity = el.data("retailer-city");
	  var retailerState = el.data("retailer-state");
	  var retailerZipCode = el.data("retailer-zip-code");
	  var countryCode = el.data("retailer-country-code");
	  var usaStates = el.data('usa-states');
	  var caProvinces = el.data('ca-provinces');
	  var addressStateSelect = $("#address-state");
	  var addressValidationFor = el.data('address-validation-for');
	  var addValidationAddFoundTitleText = el.data('add-validation-add-found-title-text');
	  var addValidationSystemNotFoundAddText = el.data('add-validation-system-not-found-add-text');
	  var validationReqdCountries = el.data('validation-reqd-countries');
	  var defaultCountry = el.data('default-country');
	  var CountryList = el.data('countries');
	  var namespace = el.data('namespace');
	  var sandboxflag = true;
	  //const saveFedexAccountUrl = el.data("save-sandbox-fedex-account-url");
	
	  //Sandbox config sterp1 smart psot flag
	  var smartPostSwitchery = $('#international-shipping-sps');
	  var sandboxSmartPostFlag = true;
	  var sandboxAccountNumber = void 0;
	
	  //Sandbox Default item switch & Return reasons list
	  var defaultProductsSwitchery = $('#international-shipping');
	  var useDefaultItemFlagforSB = false;
	  var defaultProductsUrl = el.data("default-products-url");
	
	  var fedexBrandEmailSwitchery = $('#fedEx-branded-email');
	  var sandBoxEmailFlag = false;
	  var emailShippingAddressUrl = el.data("email-shipping-address-url");
	
	  var overrideShippingSwitchery = $('#show-ability-override');
	  var SandboxOverrideShippingFlag = false;
	
	  var overrideAddressSwitchery = $('#show-ability-override-address');
	  var sandboxShippingAddressFlag = false;
	
	  var returnReasonsUrl = el.data("return-reasons-url");
	  var responseData = void 0;
	
	  var sobConfigDoneEmailUrl = el.data("sob-config-done-url");
	  var configComplete = true;
	  // END: REQUIRED TO LOAD STUB
	
	  // START: REAL CODE
	
	  function init() {
	    initQuickWizard();
	    generateModals();
	    setElementsInModals();
	    setElements();
	    bindElements();
	
	    els.editAccountAddressSection.hide();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, mainEl);
	  }
	
	  function setElementsInModals() {
	    var body = $('body');
	    (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, body);
	  }
	
	  function bindElements() {
	    //els.submitBtn.click(createPreventDefault(showSubmitModal));
	    //els.createBtn.click(createPreventDefault(showAccountInfoModal));
	    els.copyTextLink.click((0, _general.createPreventDefault)(copyToClipboard));
	    els.smartPostBtn.on("click", createFedexAccount);
	    //sandbox defult item swithch save
	    els.defaultProductBtn.click(function (e) {
	      e.preventDefault();
	      console.log('default switch -->>');
	      saveDefaultProducts({ urlDf: defaultProductsUrl });
	    });
	    // send email once config is done 
	    els.configDoneBtn.click(function (e) {
	      e.preventDefault();
	      console.log('Sand box config done -->>');
	      sendConfigDoneEmail({ configDoneurl: sobConfigDoneEmailUrl });
	    });
	    // branded email, default shipping override and address 
	    els.emailShippingAddressBtn.click(function (e) {
	      e.preventDefault();
	      console.log('default switch -->>');
	      saveEmailShippingAddress({ urlEsa: emailShippingAddressUrl });
	    });
	    //Sandbox Return reason list button function
	    els.addReasonBtn.click(function (e) {
	      e.preventDefault();
	      addReason({ url: returnReasonsUrl });
	    });
	    //for modal edit button
	    elsModal.editAddressBtn.click((0, _general.createPreventDefault)(showAddressErrorModal));
	  }
	
	  // production: prevent previous button navigation
	  function initQuickWizard() {
	    facilitySetupWizard = new QuickWizard(mainEl, {
	      tabletWidthNavStep: 1090,
	      mobileWidthNavStep: 950,
	      shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	        var targetForm = _ref.targetForm,
	            direction = _ref.direction,
	            currentForm = _ref.currentForm,
	            done = _ref.done;
	
	        // Any time we go traverse backwards, just let us
	        if (currentForm.filter(".so-products-tab").length) {
	          if (targetForm.filter(".so-accounts-tab").length || targetForm.filter(".so-locations-tab").length) {
	            direction = "BACKWARDS";
	          }
	        }
	
	        if (currentForm.filter(".so-returnConfigurations-tab").length) {
	          if (targetForm.filter(".so-accounts-tab").length || targetForm.filter(".so-locations-tab").length || targetForm.filter(".so-products-tab").length) {
	            direction = "BACKWARDS";
	          }
	        }
	
	        if (currentForm.filter(".so-summary-tab").length) {
	          if (targetForm.filter(".so-accounts-tab").length || targetForm.filter(".so-locations-tab").length || targetForm.filter(".so-products-tab").length || targetForm.filter(".so-returnConfigurations-tab").length) {
	            direction = "BACKWARDS";
	          }
	        }
	
	        if (direction === "BACKWARDS") {
	          return false;
	        }
	        console.log("inside backwards -->>3");
	        return true;
	      },
	
	      didNavigateToForm: function didNavigateToForm(_ref2) {
	        var currentForm = _ref2.currentForm;
	
	        return true;
	      }
	    });
	
	    facilitySetupWizard.init();
	
	    $(document).on('click', "[data-target-form]", function () {
	      var form = mainEl.find($(this).data("target-form"));
	      facilitySetupWizard.gotToForm(form);
	    });
	  }
	  //sandbox-account-id sandbox-hub-id
	  function createFedexAccount() {
	    $.ajax({
	      data: {
	        "fedExShippingAccountNumber": $(".fedex-shipping-account-num").val(),
	        "smartPostHubId": $(".smart-post-hub-id").val(),
	        "sandboxflag": sandboxflag
	      },
	      url: saveFedexAccountUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        console.log('in success' + data.data);
	        sandboxAccountNumber = data.data;
	        if (null !== data.data) {
	          $(".fac-ship-acc-number").val(data.data);
	        }
	      }
	    });
	  }
	
	  function generateModals() {
	    submitModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Save Facility',
	      confirmModalBody: '<div class="q-pad-all-xl">Once you have saved this facility, it can be referenced throughout the application.</div>',
	      confirmModalBtnText: 'Save',
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        // Show Loading Modal
	        submitModal.showLoadingModal();
	
	        // Success
	        setTimeout(function () {
	          submitModal.showSuccessModal();
	        }, 3000);
	
	        // Hide All Modals
	        setTimeout(function () {
	          submitModal.hideAllModals();
	        }, 6000);
	      }
	    });
	
	    submitModal.init();
	
	    addressErrorModal = $((0, _render2.default)(modalHtml, {
	      title: 'Registration Error Details',
	      footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-activate-rule modal-auto-hide">Cancel</a>\
	          <a href="#" class="base-btn purple-btn edit-address-btn">Edit Address</a>',
	      body: "<div class='q-marg-all-xl'>There appears to be an issue with FedEx Meter services while registering the given Fedex Account Number. <div><br/>Validate the Account Number, Registered Address match, and if they do not match click the edit address button to correct the issue.</div></div>",
	      topCloseBtn: true,
	      autoHideTop: true,
	      leftAlignTitle: true,
	      modalDialogClass: "q-modal-dialog-500"
	    }));
	
	    mainEl.append([addressErrorModal]);
	  };
	
	  function showSubmitModal() {
	    submitModal.showConfirmModal();
	  }
	
	  console.log('before email ajax');
	  function sendConfigDoneEmail(_ref3) {
	    var configDoneurl = _ref3.configDoneurl;
	
	    {
	      $.ajax({
	        data: {
	          "configComplete": configComplete
	        },
	        url: configDoneurl,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(data) {
	          console.log('config done ' + data.status);
	          console.log('config done email ajax ' + JSON.stringify(data));
	
	          console.log('in show submit');
	          var myUrl = "/c/portal/logout";
	          window.open(myUrl, '_self', '');
	          console.log('in show submit-- ' + myUrl);
	        }
	      });
	    }
	  }
	
	  function showAccountInfoModal() {
	    addressErrorModal.modal("show");
	  }
	
	  function showAddressErrorModal() {
	    addressErrorModal.modal("hide");
	    els.editAccountAddressSection.show();
	  }
	
	  /* //Sandbox Config step 1 smart post switch 
	  smartPostSwitchery.on('change', function (e) {
	    if (smartPostSwitchery.is(":checked")) {
	      sandboxSmartPostFlag = true;
	      console.log('sandboxSmartPostFlag in sbv-->' + sandboxSmartPostFlag);
	    } else {
	      sandboxSmartPostFlag = true;
	      console.log('sandboxSmartPostFlag in sb--> ' + sandboxSmartPostFlag);
	    }
	  }); */
	
	  $(CountryList).each(function () {
	    var option = $('<option />');
	    option.attr('value', this.conCode).text(this.conName);
	    //option.attr('value', this.cdmValue).text(this.cdmMeaning);
	    $('#selfLocationCountry').append(option);
	  });
	
	  $('#selfLocationCountry').change(function () {
	    var countryVal = $('#selfLocationCountry option:selected').val();
	    setStates(countryVal);
	  });
	
	  function setStates(countryVal) {
	    $('#selfLocationState').html('');
	    var option = $('<option />');
	    option.attr('value', "-1").text('Select State/Province/Region');
	    option.attr('selected', 'selected');
	    option.attr('disabled', 'disabled');
	    var checkZipCode = false;
	    $(CountryList).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	    if (countryVal == "US" && checkZipCode) {
	      $('#selfLocationStateContainer').css("display", "block");
	      $('#facstateTextContainer').css("display", "none");
	      $('#facstateText').prop('required', false);
	      $('#selfLocationState').prop('required', true);
	      $('#selfLocationState').append(option);
	      $(usaStates).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	
	        $('#selfLocationState').append(option);
	      });
	    } else if (countryVal == "CA" && checkZipCode) {
	      $('#selfLocationStateContainer').css("display", "block");
	      $('#facstateTextContainer').css("display", "none");
	      $('#facstateText').prop('required', false);
	      $('#selfLocationState').prop('required', true);
	      $('#selfLocationState').append(option);
	      $(caProvinces).each(function () {
	        var option = $('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        $('#selfLocationState').append(option);
	      });
	    } else {
	      $('#facstateText').prop('required', false);
	      $('#selfLocationState').prop('required', false);
	      $('#selfLocationStateContainer').css("display", "none");
	      $('#facstateTextContainer').css("display", "block");
	    }
	  }
	
	  $(".fac-loc-id").change(function () {
	    console.log("inside duplicate fac id check ");
	    validateFacilityId();
	  });
	  $(".fac-loc-name").change(function () {
	    validateFacilityName();
	  });
	
	  $('.add-location-btn').click(function (event) {
	    event.preventDefault();
	    console.log("Inside acoount add button func");
	
	    var requiredFields = $('#saveLocationSection input, select').filter('[required]:visible');
	    var allRequired = true;
	    requiredFields.each(function () {
	      $("#requriedFieldError").each(function () {
	        $(this).remove();
	      });
	    });
	    requiredFields.each(function () {
	      if ($(this).val() == '') {
	        allRequired = false;
	        var error = '<label id="requriedFieldError" class="help-block" style="color: red;">The field is required !!</label>';
	        $(this).after(error);
	      }
	    });
	    console.log("allRequired is :" + allRequired);
	    if (allRequired) {
	      var addressValidationModalEl = $("#add-validation-model");
	      var addressValidationForSelfFacilityTabSbox = (0, _AddressValidation2.default)(null, el, {
	        isAlreadyValid: false,
	        currentTab: ".so-locations-tab",
	        disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	        disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	      });
	      console.log("address value " + JSON.stringify(addressValidationForSelfFacilityTabSbox.determineAddressValidity(done)));
	      console.log("Address Validation :  " + document.getElementById("addLocationFlagForAddressValidation").value + "     " + $("#addLocationFlagForAddressValidation").val());
	      if (document.getElementById("addLocationFlagForAddressValidation").value == 'Validated') {}
	      //saveFacilityDetails();
	
	
	      /*$("#shipToLocations").css("display","block");
	      $("#shipToLocationsEdit").css("display","block");*/
	      viewFacilityDetails();
	
	      $('.qw-nav-step').each(function () {
	
	        var tabValue = $(this).attr('data-qw-form-target');
	        console.log('this is inside tabs list ' + tabValue);
	        if (tabValue === '.so-accounts-tab') {
	          console.log('accounts tab hide');
	          $(this).removeClass('active');
	          $(this).addClass('visited');
	        }
	        if (tabValue === '.so-locations-tab') {
	          console.log('Sand box location tab show');
	          $(".loc-next-btn").removeClass('disabled');
	          $(this).addClass('active');
	        }
	      });
	    }
	  });
	
	  $('.loc-next-btn').click(function (event) {
	    console.log("Inside Next Button loc screen");
	    saveFacilityDetails();
	  });
	  $("#self-save-loc-cancel").click(function () {
	    $("#saveSelfLocation").modal("hide");
	  });
	  $("#self-save-loc-continue").click(function () {
	    saveFacilityDetails();
	    $("#saveSelfLocation").modal("hide");
	  });
	  function saveFacilityDetails() {
	    $('.fac-id-view').text($(".fac-loc-id").val());
	    if ($(".fac-country").val() == 'US' || $(".fac-country").val() == 'CA') {
	      var facState = $(".fac-state").val();
	    } else {
	      var _facState = $(".fac-state-text").val();
	    }
	    $.ajax({
	      data: {
	        "facilityid": $(".fac-loc-id").val(),
	        "facilityname": $(".fac-loc-name").val(),
	        "facAddress1": $(".fac-address1").val(),
	        "facAddress2": $(".fac-address2").val(),
	        "facCity": $(".fac-city").val(),
	        "facState": $(".fac-state").val(),
	        "facZipcode": $(".fac-zip-code").val(),
	        "facCountry": $(".fac-country").val(),
	        "facContactname": $(".fac-contactname").val(),
	        "facEmail": $(".fac-contact-email").val(),
	        "facPhone": $(".loc-contact-phone").val()
	      },
	      url: saveFacilityDetailsUrl,
	      dataType: "JSON",
	      type: 'POST',
	
	      success: function success(response) {
	        //var activeTab = $(".tabs").tabs( "option", "active" );
	        submitModal.showSuccessModal();
	        setTimeout(function () {
	          submitModal.hideAllModals();
	        }, 100);
	        $(".loc-next-btn").removeClass('disabled');
	        // $("#shipToLocations").css("display","block");
	        //$("#shipToLocationsEdit").css("display","block");
	        $("#saveLocationSection").children().prop("disabled", true);
	        // $("#saveLocationSection").css("dsiplay", "none");
	        // $('.add-location-btn').attr('disabled','disabled');
	        //$("#saveLocationSection").hide();
	        //$(".loc-next-btn").removeAttr('disabled');
	        document.getElementById("locNextBtn").disabled = false;
	        console.log("insid sucess add fac function");
	        //viewFacilityDetails();
	      },
	      error: function error() {
	        $(".loc-next-btn").removeClass('enabled');
	        submitModal.showFailureModal();
	      }
	    });
	  }
	
	  $('.loc-edit').click(function (event) {
	    showFacility();
	    console.log("Inside edit butto loca screen");
	    event.preventDefault();
	    //$("#saveLocationSection").css("dsiplay", "block");
	    //$("#saveLocationSection").show();
	    $('.add-location-btn').removeAttr('disabled');
	
	    $('.fac-loc-id').prop("disabled", false);
	    $('.fac-loc-name').prop("disabled", false);
	    $('.fac-address1').prop("disabled", false);
	    $('.fac-address2').prop("disabled", false);
	    $('.fac-city').prop("disabled", false);
	    $('.fac-state').prop("disabled", false);
	    $('.fac-zip-code').prop("disabled", false);
	    $('.fac-country').prop("disabled", false);
	    $('.fac-contactname').prop("disabled", false);
	    $('.fac-contact-email').prop("disabled", false);
	    $('.loc-contact-phone').prop("disabled", false);
	    $('.fac-ship-acc-number').prop("disabled", false);
	  });
	
	  function viewFacilityDetails() {
	    console.log("inside view facilyty details test ");
	    // hideFacilty();
	    //$("#saveLocationSection").css("dsiplay", "none");
	    $('.add-location-btn').attr('disabled', 'disabled');
	
	    $('.fac-loc-id').prop("disabled", true);
	    $('.fac-loc-name').prop("disabled", true);
	    $('.fac-address1').prop("disabled", true);
	    $('.fac-address2').prop("disabled", true);
	    $('.fac-city').prop("disabled", true);
	    $('.fac-state').prop("disabled", true);
	    $('.fac-zip-code').prop("disabled", true);
	    $('.fac-country').prop("disabled", true);
	    $('.fac-contactname').prop("disabled", true);
	    $('.fac-contact-email').prop("disabled", true);
	    $('.loc-contact-phone').prop("disabled", true);
	    $('.fac-ship-acc-number').prop("disabled", true);
	
	    $('.fac-id-view').text($(".fac-loc-id").val());
	    $('.fac-name-view').text($(".fac-loc-name").val());
	    $('.fac-address1-view').text($(".fac-address1").val());
	    $('.fac-address2-view').text($(".fac-address2").val());
	    $('.fac-city-view').text($(".fac-city").val());
	    $('.fac-state-view').text($(".fac-state").val());
	    $('.fac-zipcode-view').text($(".fac-zip-code").val());
	    $('.fac-country-view').text($(".fac-country").val());
	    $('.fac-contactname-view').text($(".fac-contactname").val());
	    $('.fac-contact-email-view').text($(".fac-contact-email").val());
	    $('.fac-phone-view').text($(".loc-contact-phone").val());
	    $('.fac-shipping-account-view').text($(".fac-ship-acc-number").val());
	  }
	
	  //sandbox collapse after save locations
	  function showFacility() {
	    debugger;
	    console.log("in collapse");
	    var x = document.getElementById("saveLocationSection");
	    x.style.display = "block";
	  }
	
	  function hideFacilty() {
	    debugger;
	    console.log("in collapse");
	    var x = document.getElementById("saveLocationSection");
	    x.style.display = "none";
	  }
	
	  //duplicate facility name check
	  function validateFacilityName() {
	    var facName = $(".fac-loc-name").val();
	    $.ajax({
	      async: false,
	      data: {
	        facName: facName
	      },
	      url: facNameCheckUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        if (data.response == true) {
	          $(".dup-facName").show();
	        } else {
	          $(".dup-facName").hide();
	        }
	      }
	    });
	  }
	
	  function validateFacilityId() {
	    console.log("inside check fac id ajax call");
	    console.log("facIdCheckUrl is :" + facIdCheckUrl);
	    var facId = $(".fac-loc-id").val();
	    $.ajax({
	      async: false,
	      data: {
	        facId: facId
	      },
	      url: facIdCheckUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        console.log("inside sucess go fac id " + data.response);
	        if (data.response == true) {
	          $(".dup-facId").show();
	        } else {
	          $(".dup-facId").hide();
	        }
	      }
	    });
	  }
	  //Sandbox Config step 3 default product 
	  defaultProductsSwitchery.on('change', function (e) {
	    if (defaultProductsSwitchery.is(":checked")) {
	      useDefaultItemFlagforSB = true;
	      console.log('useDefaultItemFlagforSB in sbv-->' + useDefaultItemFlagforSB);
	    } else {
	      useDefaultItemFlagforSB = false;
	      console.log('useDefaultItemFlagforSB in sb--> ' + useDefaultItemFlagforSB);
	    }
	  });
	
	  //Production Config step 3  save default product
	  function saveDefaultProducts(_ref4) {
	    var urlDf = _ref4.urlDf;
	
	    {
	      $.ajax({
	        data: {
	          "defaultProduct": useDefaultItemFlagforSB
	        },
	        url: urlDf,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(data) {
	          console.log('res1 ' + data.status);
	          console.log('prod in defautl products ajax ' + JSON.stringify(data));
	        }
	      });
	    }
	  }
	
	  //Sandbox Config step 4 Fedex Branded email swich 
	  fedexBrandEmailSwitchery.on('change', function (e) {
	    if (fedexBrandEmailSwitchery.is(":checked")) {
	      sandBoxEmailFlag = true;
	      console.log('sandBoxEmailFlag ' + sandBoxEmailFlag);
	    } else {
	      sandBoxEmailFlag = false;
	      console.log('sandBoxEmailFlag ' + sandBoxEmailFlag);
	    }
	  });
	
	  //Sandbox Config step 4 override default shipping swich 
	  overrideShippingSwitchery.on('change', function (e) {
	    if (overrideShippingSwitchery.is(":checked")) {
	      SandboxOverrideShippingFlag = true;
	      console.log('SandboxOverrideShippingFlag ' + SandboxOverrideShippingFlag);
	    } else {
	      SandboxOverrideShippingFlag = false;
	      console.log('SandboxOverrideShippingFlag ' + SandboxOverrideShippingFlag);
	    }
	  });
	
	  //Sandbox Config step 4 override ship to address swich 
	  overrideAddressSwitchery.on('change', function (e) {
	    if (overrideAddressSwitchery.is(":checked")) {
	      sandboxShippingAddressFlag = true;
	      console.log('sandboxShippingAddressFlag ' + sandboxShippingAddressFlag);
	    } else {
	      sandboxShippingAddressFlag = false;
	      console.log('sandboxShippingAddressFlag ' + sandboxShippingAddressFlag);
	    }
	  });
	
	  //step 4 email ,default shipping and address ajax sandbox
	  function saveEmailShippingAddress(_ref5) {
	    var urlEsa = _ref5.urlEsa;
	
	    {
	      $.ajax({
	        data: {
	          "fedexBrandedEmail": sandBoxEmailFlag,
	          "defaultShippingOverride": SandboxOverrideShippingFlag,
	          "shippingAddressOverride": sandboxShippingAddressFlag,
	          "defaultProduct": useDefaultItemFlagforSB
	        },
	        url: urlEsa,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(data) {
	          console.log('res1 ' + data.status);
	          console.log('prod email,orverride shipping,address ajax ' + JSON.stringify(data));
	        }
	      });
	    }
	  }
	
	  function addReason(_ref6) {
	    var url = _ref6.url;
	
	    {
	      $.ajax({
	        data: {
	          "cdmValue": $(".return-reason-short-value").val(),
	          "cdmMeaning": $(".retunr-reason-display-value").val()
	        },
	        url: url,
	        dataType: 'JSON',
	        type: 'POST',
	        success: function success(response) {
	          debugger;
	          responseData = response.data;
	          console.log('prod in reason ajax ' + JSON.stringify(response.data));
	
	          console.log("cdmValue --> " + responseData.cdmValue);
	          console.log("cdmMeaning --> " + responseData.cdmMeaning);
	          if (responseData.cdmValue !== null && responseData.cdmMeaning !== null) {
	            document.getElementById('responseData').innerHTML += '<li>' + responseData.cdmValue + '    ' + responseData.cdmMeaning + '</li>';
	          }
	
	          $(".return-reason-short-value").val('');
	          $(".retunr-reason-display-value").val('');
	        }
	
	      });
	    }
	  }
	
	  //for copying text
	  function copyToClipboard() {
	    CopyToClipbrd("https://fulfillment.fedex.com", true, "URL copied");
	  }
	
	  function CopyToClipbrd(value, showNotification, notificationText) {
	    var $temp = $("<input>");
	    $("body").append($temp);
	    $temp.val(value).select();
	    document.execCommand("copy");
	    $temp.remove();
	
	    if (typeof showNotification === 'undefined') {
	      showNotification = true;
	    }
	    if (typeof notificationText === 'undefined') {
	      notificationText = "Copied to clipboard";
	    }
	
	    var notificationTag = $("div.copy-url-notification");
	    if (showNotification && notificationTag.length == 0) {
	      notificationTag = $("<div/>", { "class": "copy-url-notification", text: notificationText });
	      $("body").append(notificationTag);
	
	      notificationTag.fadeIn("slow", function () {
	        setTimeout(function () {
	          notificationTag.fadeOut("slow", function () {
	            notificationTag.remove();
	          });
	        }, 1000);
	      });
	    }
	  }
	
	  init();
	
	  // END: REAL CODE
	};

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	// @grant window.close
	
	
	var targetSelector = "#merchantOnboardingWrapper";
	
	// Modal Html to use
	__webpack_require__(132);
	(0, _run2.default)(targetSelector, function (el) {
	  attachStubExample(el);
	});
	
	function attachStubExample(el) {
	  // START: REQUIRED TO LOAD STUB
	  var mainHtml = (0, _render2.default)(__webpack_require__(1436), {});
	  var mainEl = $(mainHtml);
	  var entryEl = $("<div class='entry-point'></div>");
	
	  $(el).html(entryEl);
	  entryEl.append(mainEl);
	  // END: REQUIRED TO LOAD STUB
	
	  // START: REAL CODE
	  console.log('before START');
	  var els = {};
	  var elsMap = {
	    viewArticlesAcceptanceBtn: '.view-articles-acceptance',
	    acceptBtn: '.accept-btn',
	    userAcceptanceSection: '.user-acceptance-section',
	    getStartedSection: '.get-started-section',
	    notAcceptBtn: '.not-accept-btn',
	    nextBtn: '.self-initial-reg-next-btn'
	  };
	
	  function init() {
	    setElements();
	    bindElements();
	    els.userAcceptanceSection.hide();
	    // Stack function calls here.
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	    // Can call multiple setElementsFromScope for multiple elsMap.
	  }
	
	  function bindElements() {
	    els.viewArticlesAcceptanceBtn.on("click", function () {
	      els.userAcceptanceSection.show();
	      els.getStartedSection.hide();
	    });
	
	    els.acceptBtn.on("click", function () {
	      els.getStartedSection.hide();
	      $(".self-initial-reg-next-btn").removeClass('disabled');
	      els.userAcceptanceSection.hide();
	      els.getStartedSection.show();
	      els.viewArticlesAcceptanceBtn.hide();
	    });
	
	    els.notAcceptBtn.on("click", function () {
	      //els.userAcceptanceSection.hide();
	      //els.getStartedSection.show();
	      // els.viewArticlesAcceptanceBtn.show();
	      window.close();
	    });
	
	    els.nextBtn.on("click", function (e) {
	      processNextButton();
	    });
	
	    var initialRegistrationPage = $("#merchantOnboardingWrapper").data("initial-registration-page-url");
	    function processNextButton() {
	      //location.href = initialRegistrationPage;
	      var newwindow = window.open(initialRegistrationPage, '_self', 'height=20,width=15');
	      if (window.focus) {
	        newwindow.focus();
	      }
	    }
	  }
	
	  init();
	
	  // END: REAL CODE
	};

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	var targetSelector = "#merchantOnboardingSandboxWrapper";
	
	// Modal Html to use
	__webpack_require__(132);
	(0, _run2.default)(targetSelector, function (el) {
	  attachStubExample(el);
	});
	
	function attachStubExample(el) {
	  // START: REQUIRED TO LOAD STUB
	  var mainHtml = (0, _render2.default)(__webpack_require__(1437), {});
	  var mainEl = $(mainHtml);
	  var entryEl = $("<div class='entry-point'></div>");
	
	  $(el).html(entryEl);
	  entryEl.append(mainEl);
	  // END: REQUIRED TO LOAD STUB
	
	  // START: REAL CODE
	
	  var els = {};
	  var elsMap = {
	    viewArticlesAcceptanceBtn: '.view-articles-acceptance',
	    acceptBtn: '.accept-btn',
	    userAcceptanceSection: '.user-acceptance-section',
	    getStartedSection: '.get-started-section',
	    notAcceptBtn: '.not-accept-btn',
	    nextBtn: '.self-initial-reg-next-btn'
	  };
	
	  function init() {
	    setElements();
	    bindElements();
	    els.userAcceptanceSection.hide();
	    // Stack function calls here.
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	    // Can call multiple setElementsFromScope for multiple elsMap.
	  }
	
	  function bindElements() {
	    els.viewArticlesAcceptanceBtn.on("click", function () {
	      els.userAcceptanceSection.show();
	      els.getStartedSection.hide();
	    });
	
	    els.acceptBtn.on("click", function () {
	      els.getStartedSection.hide();
	      $(".self-initial-reg-next-btn").removeClass('disabled');
	      els.userAcceptanceSection.hide();
	      els.getStartedSection.show();
	      els.viewArticlesAcceptanceBtn.hide();
	    });
	
	    els.notAcceptBtn.on("click", function () {
	      //els.userAcceptanceSection.hide();
	      //els.getStartedSection.show();
	      // els.viewArticlesAcceptanceBtn.show();
	      window.close();
	    });
	
	    els.nextBtn.on("click", function (e) {
	      processNextButton();
	    });
	
	    var initialRegistrationPage = $("#merchantOnboardingSandboxWrapper").data("initial-sandbox-registration-page-url");
	
	    function processNextButton() {
	      //location.href = initialRegistrationPage;
	      var newwindow = window.open(initialRegistrationPage, '_self', 'height=20,width=15');
	      if (window.focus) {
	        newwindow.focus();
	      }
	    }
	  }
	
	  init();
	
	  // END: REAL CODE
	};

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { createPreventDefault } from '../../utilities/general';
	//import { setElementsFromScope } from '../../utilities/selectorHelpers';
	var enableUserEnteredAddressRadioForSPL = true;
	var disableSubmitAddressBtnIfInvalidAddressForSPL = true;
	
	var _ = __webpack_require__(2);
	var targetSelector = "#selfOnboard-sandbox-retailer-wizard";
	var addressElementsMap = {
	  country: '.ret-country',
	  address1: '.ret-address1',
	  address2: '.ret-address2',
	  city: '.ret-city',
	  state: '.ret-state',
	  zipCode: '.ret-zip-code',
	  postalCodeLabel: '#postalcode-label',
	  stateLabel: '#state-label',
	  county: '.ret-county',
	  countyMandatoryLabel: '.county-mandatory-label',
	  stateSelectContainer: '.state-wrapper',
	  stateTextContainer: '.state-text-wrapper',
	  stateTextInput: '.ret-state-text',
	  commercialAddressFlag: '.commercial-addr-flag'
	
	};
	// Modal Html to use
	__webpack_require__(132);
	
	(0, _run2.default)(targetSelector, function (el) {
	  attachStubExample(el);
	});
	
	function attachStubExample(el) {
	  var mainHtml = (0, _render2.default)(__webpack_require__(1434), {});
	
	  var mainEl = (0, _jquery2.default)(mainHtml);
	  var entryEl = (0, _jquery2.default)("<div class='entry-point'></div>");
	  (0, _jquery2.default)(el).html(entryEl);
	  entryEl.append(mainEl);
	
	  var countries = el.data('countries');
	  var defaultCountry = el.data('default-country');
	  var usaStates = el.data('usa-states');
	  var caProvinces = el.data('ca-provinces');
	  var countryPhoneCodeList = el.data('country-phone-code-list');
	  var UsercountryPhoneCodeList = el.data('country-phone-code-list');
	  var facilityTypes = el.data('facility-types');
	  var validationReqdCountries = el.data('validation-reqd-countries');
	  var addressValidationFor = el.data('address-validation-for');
	  var prefixes = el.data('prefixes');
	  var addressValidationUrl = el.data('address-validation-url');
	  var generalErrorMessage = el.data('general-error-message');
	  var addValidationAddFoundTitleText = el.data('add-validation-add-found-title-text');
	  var addValidationSystemNotFoundAddText = el.data('add-validation-system-not-found-add-text');
	  var redirectWelcomePageUrl = el.data('Redirect-Welcome-PageUrl');
	  var checkUserNameValidation = el.data('check-user-name-url');
	  var checkRetailerNameValidation = el.data('check-retailer-name-exist-url');
	  var sandboxRegistarionSubmitUrl = el.data('sandbox-registration-submit-url');
	  var submitUrl = el.data('submit-url');
	  var namespace = el.data('namespace');
	  //const submitModalFlow = new SubmitModalFlow();
	  //const initialRegistrationPage = e1.data("initial-registration-page-url");
	
	  var retailer = {};
	
	  //form validation
	  var validator = (0, _jquery2.default)(".initialSandboxRegistrationForm").validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        (0, _jquery2.default)(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  (0, _jquery2.default)(countries).each(function () {
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', this.conCode).text(this.conName);
	    //option.attr('value', this.cdmValue).text(this.cdmMeaning);
	    (0, _jquery2.default)('#selfMerchantCountry').append(option);
	  });
	
	  (0, _jquery2.default)('#selfMerchantCountry').change(function () {
	    var countryVal = (0, _jquery2.default)('#selfMerchantCountry option:selected').val();
	    setStates(countryVal);
	  });
	
	  var els = {};
	  var elsMap = {
	    submitBtn: '.submit-account-btn'
	  };
	
	  (0, _jquery2.default)(countryPhoneCodeList).each(function () {
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', this.conPhoneCode).text(this.conCode);
	    (0, _jquery2.default)('#selfMerchantPhoneCode').append(option);
	  });
	
	  (0, _jquery2.default)(countryPhoneCodeList).each(function () {
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', this.conPhoneCode).text(this.conCode);
	    (0, _jquery2.default)('#selfUserCountryCode').append(option);
	  });
	  var done = void 0;
	  var addressValidationModalEl = (0, _jquery2.default)("#add-validation-model");
	  (0, _jquery2.default)('.submit-account-btn').click(function () {
	    //event.preventDefault();
	    var requiredFields = (0, _jquery2.default)('input, select').filter('[required]:visible');
	    var allRequired = true;
	
	    requiredFields.each(function () {
	      (0, _jquery2.default)("#requriedFieldError").each(function () {
	        (0, _jquery2.default)(this).remove();
	      });
	    });
	    requiredFields.each(function () {
	      if ((0, _jquery2.default)(this).val() == '') {
	        //event.preventDefault();
	
	        allRequired = false;
	        var error = '<label id="requriedFieldError" class="help-block" style="color: #b50303;">The field is required !!</label>';
	        (0, _jquery2.default)(this).after(error);
	        // $('form').unbind('submit').submit();
	      }
	    });
	    if (allRequired) {
	      var addressValidationForSelfRegistrationTab = (0, _AddressValidation2.default)(null, el, {
	        isAlreadyValid: true,
	        currentTab: ".Self-Registration-Tab",
	        disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	        disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	      });
	      console.log("address value" + JSON.stringify(addressValidationForSelfRegistrationTab.determineAddressValidity(done)));
	    }
	  });
	
	  (0, _jquery2.default)("#initail-reg-modal-cancel").click(function () {
	    (0, _jquery2.default)("#confirmationBox").modal("hide");
	  });
	  (0, _jquery2.default)("#initail-reg-modal-continue").click(function () {
	    processSubmitButton();
	    (0, _jquery2.default)("#confirmationBox").modal("hide");
	  });
	
	  (0, _jquery2.default)(".ret-MerchantName").change(function () {
	    (0, _jquery2.default)('#merchant-name-exist-error').css('display', 'none');
	    var selfMerchantName = (0, _jquery2.default)("#selfMerchantName").val();
	    validateRetailerName(selfMerchantName);
	  });
	
	  function validateRetailerName(selfMerchantName) {
	    _jquery2.default.ajax({
	      url: checkRetailerNameValidation,
	      type: "GET",
	      data: { inputValue: selfMerchantName },
	
	      success: function success(data) {
	        if (data.trim() == 'true') {
	          (0, _jquery2.default)('.submit-account-btn').attr('disabled', 'disabled');
	          (0, _jquery2.default)('#merchant-name-exist-error').css('display', 'inline-block');
	        } else {
	          (0, _jquery2.default)('.submit-account-btn').removeAttr('disabled');
	        }
	      }
	    });
	  }
	  (0, _jquery2.default)(".ret-MerchantUrl").change(function () {
	    (0, _jquery2.default)('#merchant-invalid-error').css('display', 'none');
	    var selfMerchantUrl = (0, _jquery2.default)("#selfMerchantUrl").val();
	    var isvalidUrl = validateURL(selfMerchantUrl);
	    if (!isvalidUrl) {
	      (0, _jquery2.default)('#merchant-invalid-error').css('display', 'inline-block');
	    }
	  });
	
	  function validateURL(selfMerchantUrl) {
	    var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
	    return urlregex.test(selfMerchantUrl);
	  }
	
	  (0, _jquery2.default)(".screenName").change(function () {
	    (0, _jquery2.default)('#user-exist-error').css('display', 'none');
	    var inputValue = (0, _jquery2.default)("#selfUserId").val();
	    checkDuplicateUserDetails('UserName', inputValue);
	  });
	
	  (0, _jquery2.default)(".emailAddress").change(function () {
	    (0, _jquery2.default)('#user-email-exist-error').css('display', 'none');
	    var inputValue = (0, _jquery2.default)("#selfUserEmail").val();
	    checkDuplicateUserDetails('EmailId', inputValue);
	  });
	
	  //Check duplicate user name
	  var checkDuplicateUserDetails = function checkDuplicateUserDetails(inputType, inputValue) {
	    if (inputType == 'UserName') {
	      var pattern = /^[0-9a-zA-Z]+$/;
	      if (!inputValue.match(pattern) && !inputValue == '') {
	        // elsPage.userNameValidationError.show();
	        (0, _jquery2.default)('.submit-account-btn').attr('disabled', 'disabled');
	        (0, _jquery2.default)('#user-exist-error').css('display', 'inline-block');
	      }
	    } else if (inputType == 'EmailId') {}
	
	    if (inputType.length > 0 && inputValue.length > 0) {
	      _jquery2.default.ajax({
	        url: checkUserNameValidation,
	        type: "GET",
	        data: { inputValue: inputValue, inputType: inputType },
	        beforeSend: function beforeSend() {
	          // $.blockUI({ message: 'Checking User Name, Please Wait..' });
	        },
	        complete: function complete() {
	          //$.unblockUI();
	        },
	        success: function success(data) {
	          if (data.trim() == 'true') {
	            if (inputType == 'UserName') {
	              (0, _jquery2.default)('.submit-account-btn').attr('disabled', 'disabled');
	              (0, _jquery2.default)('#user-exist-error').css('display', 'inline-block');
	            } else if (inputType == 'EmailId') {
	              (0, _jquery2.default)('.submit-account-btn').attr('disabled', 'disabled');
	              (0, _jquery2.default)('#user-email-exist-error').css('display', 'inline-block');
	            } else {
	              console.log("dont know what is valid");
	            }
	          } else {
	            (0, _jquery2.default)('.submit-account-btn').removeAttr('disabled');
	
	            //if (elsPage.userNameExistError.is(":visible") || elsPage.userEmailExistError.is(":visible") || elsPage.userNameValidationError.is(":visible")) {
	            console.log("username Invalid");
	            //}else{
	            //  console.log("dont know what is Invalid");
	            //}
	          }
	        }
	      });
	    }
	  };
	
	  function countryChange() {
	    var countryVal = (0, _jquery2.default)('#selfMerchantCountry').find('option:selected').val();
	    var isValidCountry = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        countryId = this.conPhoneCode.toString();
	        return false;
	      }
	    });
	    (0, _jquery2.default)(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryVal.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (isValidCountry) {
	      (0, _jquery2.default)(".country-not-supported-primary").hide();
	    } else {
	      (0, _jquery2.default)(".country-not-supported-primary").show();
	    }
	    setStates(countryVal);
	    if (countryVal === "US") {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States of America +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "CA") {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "Canada +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "UM") {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States Minor Outlying Islands +1";
	      }).prop("selected", true).trigger("change");
	    } else {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).val().toString();
	        return text === countryId.toString();
	      }).prop("selected", true).trigger("change");
	    }
	    if (countryVal === "US" || countryVal === "CA") {
	      (0, _selectorHelpers.show)(els.officeAreaCode);
	      els.officePhone.attr("placeholder", "___-____");
	      els.officePhone.addClass('ret-phone-number-jqv');
	      els.officePhone.removeClass('phoneNonUS');
	      addmasks();
	    } else {
	      els.officeAreaCode.val('');
	      if (els.officeAreaCode) {
	        (0, _selectorHelpers.hide)(els.officeAreaCode);
	      }
	      els.officePhone.val('');
	      els.officePhone.addClass('phoneNonUS');
	      els.officePhone.removeClass('ret-phone-number-jqv');
	      els.officePhone.removeAttr('placeholder');
	      els.officePhone.inputmask({
	        mask: ""
	      });
	    }
	  }
	
	  function createRetailerJson() {
	    //create retailer JSON
	    retailer.rtlType = "C";
	    retailer.rtlStatus = "A";
	    retailer.enrollmentConfigs = {
	      enrollments: "RMS"
	    };
	    retailer.rtlName = (0, _jquery2.default)("#selfMerchantName").val();
	    retailer.rtlWebUrl = (0, _jquery2.default)("#selfMerchantUrl").val();
	    retailer.rtlContactFirstName = (0, _jquery2.default)("#selfMerchantContactFirstName").val();
	    retailer.rtlContactLastName = (0, _jquery2.default)("#selfMerchantContactLastName").val();
	
	    retailer.rtlEmail = (0, _jquery2.default)("#selfMerchantEmail").val();
	    retailer.rtlAddress1 = "60 FED EX PKWY";
	    retailer.rtlAddress2 = "";
	    retailer.rtlCity = "Collierville";
	    retailer.rtlState = "TENNESSEE";
	    retailer.rtlConCode = "US";
	    retailer.rtlZip = "38017";
	    retailer.rtlOfficePhoneCountryCode = (0, _jquery2.default)("#selfMerchantPhoneCode").val();
	    retailer.rtlOfficePhone = (0, _jquery2.default)("#selfMerchantPhone").val();
	    retailer.userFirstName = (0, _jquery2.default)("#selfUserFirstName").val();
	    retailer.userLastName = (0, _jquery2.default)("#selfUserLastName").val();
	    retailer.userOrgTitle = (0, _jquery2.default)("#selfUserOrgTitle").val();
	    retailer.userPhoneCountryCode = (0, _jquery2.default)("#selfUserCountryCode").val();
	    retailer.userPhone = (0, _jquery2.default)("#selfUserPhone").val();
	    retailer.userEmail = (0, _jquery2.default)("#selfUserEmail").val();
	    retailer.userId = (0, _jquery2.default)("#selfUserId").val();
	  }
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  //submitModalFlow.showLoadingModal(); 
	
	  var initialRegistrationPage = (0, _jquery2.default)("#selfOnboard-sandbox-retailer-wizard").data("initial-sandbox-registration-page-url");
	  function processSubmitButton() {
	    console.log("inside submit controller button function");
	    AUI().use('liferay-portlet-url', function (A) {
	      createRetailerJson();
	      _jquery2.default.ajax({
	        url: sandboxRegistarionSubmitUrl,
	        data: {
	          '_merchantselfonboarding_WAR_retailerportlet_retailerJson': JSON.stringify(retailer)
	        },
	        dataType: "JSON",
	        type: 'POST',
	        cache: false,
	        success: function success(response) {
	          console.log("Sandbox submit function sucess");
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            submitModalFlow.hideAllModals();
	          }, 100);
	
	          // window.close();
	          location.reload(true);
	          var myUrl = "/c/portal/logout";
	          window.open(myUrl, '_self', '');
	          // console.log("initialRegistrationPage" +initialRegistrationPage);
	          // location.href = initialRegistrationPag
	        },
	        error: function error() {
	          submitModalFlow.hideAllModals();
	          submitModalFlow.showFailureModal();
	        }
	      });
	    });
	  }
	};

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//import { createPreventDefault } from '../../utilities/general';
	//import { setElementsFromScope } from '../../utilities/selectorHelpers';
	var enableUserEnteredAddressRadioForSPL = true;
	var disableSubmitAddressBtnIfInvalidAddressForSPL = true;
	console.log('we should get this page');
	var _ = __webpack_require__(2);
	var targetSelector = "#selfOnboard-retailer-wizard";
	var addressElementsMap = {
	  country: '.ret-country',
	  address1: '.ret-address1',
	  address2: '.ret-address2',
	  city: '.ret-city',
	  state: '.ret-state',
	  zipCode: '.ret-zip-code',
	  postalCodeLabel: '#postalcode-label',
	  stateLabel: '#state-label',
	  county: '.ret-county',
	  countyMandatoryLabel: '.county-mandatory-label',
	  stateSelectContainer: '.state-wrapper',
	  stateTextContainer: '.state-text-wrapper',
	  stateTextInput: '.ret-state-text',
	  commercialAddressFlag: '.commercial-addr-flag'
	
	};
	// Modal Html to use
	__webpack_require__(132);
	
	(0, _run2.default)(targetSelector, function (el) {
	  attachStubExample(el);
	});
	
	function attachStubExample(el) {
	  var mainHtml = (0, _render2.default)(__webpack_require__(1433), {});
	
	  var mainEl = (0, _jquery2.default)(mainHtml);
	  var entryEl = (0, _jquery2.default)("<div class='entry-point'></div>");
	  (0, _jquery2.default)(el).html(entryEl);
	  entryEl.append(mainEl);
	
	  var countries = el.data('countries');
	  var defaultCountry = el.data('default-country');
	  var usaStates = el.data('usa-states');
	  var caProvinces = el.data('ca-provinces');
	  var countryPhoneCodeList = el.data('country-phone-code-list');
	  var UsercountryPhoneCodeList = el.data('country-phone-code-list');
	  var facilityTypes = el.data('facility-types');
	  var validationReqdCountries = el.data('validation-reqd-countries');
	  var addressValidationFor = el.data('address-validation-for');
	  var prefixes = el.data('prefixes');
	  var addressValidationUrl = el.data('address-validation-url');
	  var generalErrorMessage = el.data('general-error-message');
	  var addValidationAddFoundTitleText = el.data('add-validation-add-found-title-text');
	  var addValidationSystemNotFoundAddText = el.data('add-validation-system-not-found-add-text');
	  var redirectWelcomePageUrl = el.data('Redirect-Welcome-PageUrl');
	  var checkUserNameValidation = el.data('check-user-name-url');
	  var checkRetailerNameValidation = el.data('check-retailer-name-exist-url');
	  var registarionSubmitUrl = el.data('registration-submit-url');
	  var submitUrl = el.data('submit-url');
	  var namespace = el.data('namespace');
	  //const submitModalFlow = new SubmitModalFlow();
	  //const initialRegistrationPage = e1.data("initial-registration-page-url");
	
	  var retailer = {};
	
	  //form validation
	  var validator = (0, _jquery2.default)(".initialRegistrationForm").validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        (0, _jquery2.default)(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  (0, _jquery2.default)(countries).each(function () {
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', this.conCode).text(this.conName);
	    //option.attr('value', this.cdmValue).text(this.cdmMeaning);
	    (0, _jquery2.default)('#selfMerchantCountry').append(option);
	  });
	
	  (0, _jquery2.default)('#selfMerchantCountry').change(function () {
	    var countryVal = (0, _jquery2.default)('#selfMerchantCountry option:selected').val();
	    setStates(countryVal);
	  });
	
	  function setStates(countryVal) {
	    (0, _jquery2.default)('#selfMerchantState').html('');
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', "-1").text('Select State/Province/Region');
	    option.attr('selected', 'selected');
	    option.attr('disabled', 'disabled');
	    var checkZipCode = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	      }
	    });
	    if (countryVal == "US" && checkZipCode) {
	      (0, _jquery2.default)('#selfMerchantStateContainer').css("display", "block");
	      (0, _jquery2.default)('#stateTextContainer').css("display", "none");
	      (0, _jquery2.default)('#stateText').prop('required', false);
	      (0, _jquery2.default)('#selfMerchantState').prop('required', true);
	      (0, _jquery2.default)('#selfMerchantState').append(option);
	      (0, _jquery2.default)(usaStates).each(function () {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	
	        (0, _jquery2.default)('#selfMerchantState').append(option);
	      });
	    } else if (countryVal == "CA" && checkZipCode) {
	      (0, _jquery2.default)('#selfMerchantStateContainer').css("display", "block");
	      (0, _jquery2.default)('#stateTextContainer').css("display", "none");
	      (0, _jquery2.default)('#stateText').prop('required', false);
	      (0, _jquery2.default)('#selfMerchantState').prop('required', true);
	      (0, _jquery2.default)('#selfMerchantState').append(option);
	      (0, _jquery2.default)(caProvinces).each(function () {
	        var option = (0, _jquery2.default)('<option />');
	        option.attr('value', this.cdmValue).text(this.cdmMeaning);
	        (0, _jquery2.default)('#selfMerchantState').append(option);
	      });
	    } else {
	      (0, _jquery2.default)('#stateText').prop('required', false);
	      (0, _jquery2.default)('#selfMerchantState').prop('required', false);
	      (0, _jquery2.default)('#selfMerchantStateContainer').css("display", "none");
	      (0, _jquery2.default)('#stateTextContainer').css("display", "block");
	    }
	  }
	
	  /* $(el).html(entryEl);
	   entryEl.append(mainEl);*/
	
	  var els = {};
	  var elsMap = {
	    submitBtn: '.submit-account-btn'
	  };
	
	  (0, _jquery2.default)(countryPhoneCodeList).each(function () {
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', this.conPhoneCode).text(this.conCode);
	    (0, _jquery2.default)('#selfMerchantPhoneCode').append(option);
	  });
	
	  (0, _jquery2.default)(countryPhoneCodeList).each(function () {
	    var option = (0, _jquery2.default)('<option />');
	    option.attr('value', this.conPhoneCode).text(this.conCode);
	    (0, _jquery2.default)('#selfUserCountryCode').append(option);
	  });
	  var done = void 0;
	  var addressValidationModalEl = (0, _jquery2.default)("#add-validation-model");
	  (0, _jquery2.default)('.submit-account-btn').click(function () {
	    //event.preventDefault();
	    var requiredFields = (0, _jquery2.default)('input, select').filter('[required]:visible');
	    var allRequired = true;
	
	    requiredFields.each(function () {
	      (0, _jquery2.default)("#requriedFieldError").each(function () {
	        (0, _jquery2.default)(this).remove();
	      });
	    });
	    requiredFields.each(function () {
	      if ((0, _jquery2.default)(this).val() == '') {
	        //event.preventDefault();
	
	        allRequired = false;
	        var error = '<label id="requriedFieldError" class="help-block" style="color: #b50303;">The field is required !!</label>';
	        (0, _jquery2.default)(this).after(error);
	        // $('form').unbind('submit').submit();
	      }
	    });
	    if (allRequired) {
	      var addressValidationForSelfRegistrationTab = (0, _AddressValidation2.default)(null, el, {
	        isAlreadyValid: false,
	        currentTab: ".Self-Registration-Tab",
	        disableUserEnteredAddressRadio: enableUserEnteredAddressRadioForSPL,
	        disableSubmitAddressBtnIfInvalidAddress: disableSubmitAddressBtnIfInvalidAddressForSPL
	      });
	      console.log("address value" + JSON.stringify(addressValidationForSelfRegistrationTab.determineAddressValidity(done)));
	    }
	  });
	
	  (0, _jquery2.default)("#initail-reg-modal-cancel").click(function () {
	    (0, _jquery2.default)("#confirmationBox").modal("hide");
	  });
	  (0, _jquery2.default)("#initail-reg-modal-continue").click(function () {
	    processSubmitButton();
	    (0, _jquery2.default)("#confirmationBox").modal("hide");
	  });
	
	  (0, _jquery2.default)(".ret-MerchantName").change(function () {
	    (0, _jquery2.default)('#merchant-name-exist-error').css('display', 'none');
	    var selfMerchantName = (0, _jquery2.default)("#selfMerchantName").val();
	    validateRetailerName(selfMerchantName);
	  });
	
	  function validateRetailerName(selfMerchantName) {
	    _jquery2.default.ajax({
	      url: checkRetailerNameValidation,
	      type: "GET",
	      data: { inputValue: selfMerchantName },
	
	      success: function success(data) {
	        if (data.trim() == 'true') {
	          (0, _jquery2.default)('.submit-account-btn').attr('disabled', 'disabled');
	          (0, _jquery2.default)('#merchant-name-exist-error').css('display', 'inline-block');
	        } else {
	          (0, _jquery2.default)('.submit-account-btn').removeAttr('disabled');
	        }
	      }
	    });
	  }
	  (0, _jquery2.default)(".ret-MerchantUrl").change(function () {
	    (0, _jquery2.default)('#merchant-invalid-error').css('display', 'none');
	    var selfMerchantUrl = (0, _jquery2.default)("#selfMerchantUrl").val();
	    var isvalidUrl = validateURL(selfMerchantUrl);
	    if (!isvalidUrl) {
	      (0, _jquery2.default)('#merchant-invalid-error').css('display', 'inline-block');
	    }
	  });
	
	  function validateURL(selfMerchantUrl) {
	    var urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
	    return urlregex.test(selfMerchantUrl);
	  }
	
	  (0, _jquery2.default)(".screenName").change(function () {
	    (0, _jquery2.default)('#user-exist-error').css('display', 'none');
	    //elsPage.userNameExistError.hide();
	    //elsPage.userNameValidationError.hide();
	    var inputValue = (0, _jquery2.default)("#selfUserId").val();
	    checkDuplicateUserDetails('UserName', inputValue);
	  });
	
	  (0, _jquery2.default)(".emailAddress").change(function () {
	    (0, _jquery2.default)('#user-email-exist-error').css('display', 'none');
	    //elsPage.userNameExistError.hide();
	    //elsPage.userNameValidationError.hide();
	    var inputValue = (0, _jquery2.default)("#selfUserEmail").val();
	    checkDuplicateUserDetails('EmailId', inputValue);
	  });
	
	  //Check duplicate user name
	  var checkDuplicateUserDetails = function checkDuplicateUserDetails(inputType, inputValue) {
	    if (inputType == 'UserName') {
	      var pattern = /^[0-9a-zA-Z]+$/;
	      if (!inputValue.match(pattern) && !inputValue == '') {
	        // elsPage.userNameValidationError.show();
	        (0, _jquery2.default)('.submit-account-btn').attr('disabled', 'disabled');
	        (0, _jquery2.default)('#user-exist-error').css('display', 'inline-block');
	      }
	    } else if (inputType == 'EmailId') {}
	
	    if (inputType.length > 0 && inputValue.length > 0) {
	      _jquery2.default.ajax({
	        url: checkUserNameValidation,
	        type: "GET",
	        data: { inputValue: inputValue, inputType: inputType },
	        beforeSend: function beforeSend() {
	          // $.blockUI({ message: 'Checking User Name, Please Wait..' });
	        },
	        complete: function complete() {
	          //$.unblockUI();
	        },
	        success: function success(data) {
	          if (data.trim() == 'true') {
	            if (inputType == 'UserName') {
	              (0, _jquery2.default)('.submit-account-btn').attr('disabled', 'disabled');
	              (0, _jquery2.default)('#user-exist-error').css('display', 'inline-block');
	            } else if (inputType == 'EmailId') {
	              (0, _jquery2.default)('.submit-account-btn').attr('disabled', 'disabled');
	              (0, _jquery2.default)('#user-email-exist-error').css('display', 'inline-block');
	            } else {
	              console.log("dont know what is valid");
	            }
	          } else {
	            (0, _jquery2.default)('.submit-account-btn').removeAttr('disabled');
	
	            //if (elsPage.userNameExistError.is(":visible") || elsPage.userEmailExistError.is(":visible") || elsPage.userNameValidationError.is(":visible")) {
	            console.log("username Invalid");
	            //}else{
	            //  console.log("dont know what is Invalid");
	            //}
	          }
	        }
	      });
	    }
	  };
	
	  /*els.submitBtn.on("click", function(e){
	   processSubmitButton();
	  });*/
	
	  function countryChange() {
	    var countryVal = (0, _jquery2.default)('#selfMerchantCountry').find('option:selected').val();
	    var isValidCountry = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conCode.toString() === countryVal.toString()) {
	        countryId = this.conPhoneCode.toString();
	        return false;
	      }
	    });
	    (0, _jquery2.default)(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryVal.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (isValidCountry) {
	      (0, _jquery2.default)(".country-not-supported-primary").hide();
	    } else {
	      (0, _jquery2.default)(".country-not-supported-primary").show();
	    }
	    setStates(countryVal);
	    if (countryVal === "US") {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States of America +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "CA") {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "Canada +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "UM") {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States Minor Outlying Islands +1";
	      }).prop("selected", true).trigger("change");
	    } else {
	      (0, _jquery2.default)(".ret-office-country-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).val().toString();
	        return text === countryId.toString();
	      }).prop("selected", true).trigger("change");
	    }
	    if (countryVal === "US" || countryVal === "CA") {
	      (0, _selectorHelpers.show)(els.officeAreaCode);
	      els.officePhone.attr("placeholder", "___-____");
	      els.officePhone.addClass('ret-phone-number-jqv');
	      els.officePhone.removeClass('phoneNonUS');
	      addmasks();
	    } else {
	      els.officeAreaCode.val('');
	      if (els.officeAreaCode) {
	        (0, _selectorHelpers.hide)(els.officeAreaCode);
	      }
	      els.officePhone.val('');
	      els.officePhone.addClass('phoneNonUS');
	      els.officePhone.removeClass('ret-phone-number-jqv');
	      els.officePhone.removeAttr('placeholder');
	      els.officePhone.inputmask({
	        mask: ""
	      });
	    }
	  }
	
	  function createRetailerJson() {
	    //create retailer JSON
	    retailer.rtlType = "C";
	    retailer.rtlStatus = "A";
	    retailer.enrollmentConfigs = {
	      enrollments: "RMS"
	    };
	    retailer.rtlName = (0, _jquery2.default)("#selfMerchantName").val();
	    retailer.rtlWebUrl = (0, _jquery2.default)("#selfMerchantUrl").val();
	    retailer.rtlContactFirstName = (0, _jquery2.default)("#selfMerchantContactFirstName").val();
	    retailer.rtlContactLastName = (0, _jquery2.default)("#selfMerchantContactLastName").val();
	
	    retailer.rtlEmail = (0, _jquery2.default)("#selfMerchantEmail").val();
	    retailer.rtlAddress1 = (0, _jquery2.default)("#selfMerchantAddress1").val();
	    retailer.rtlAddress2 = (0, _jquery2.default)("#selfMerchantAddress2").val();
	    retailer.rtlCity = (0, _jquery2.default)("#selfMerchantCity").val();
	    if ((0, _jquery2.default)("#selfMerchantCountry").val() == 'US' || (0, _jquery2.default)("#selfMerchantCountry").val() == 'CA') {
	      retailer.rtlState = (0, _jquery2.default)("#selfMerchantState").val();
	    } else {
	      retailer.rtlState = (0, _jquery2.default)("#stateText").val();
	    }
	    retailer.rtlConCode = (0, _jquery2.default)("#selfMerchantCountry").val();
	    retailer.rtlZip = (0, _jquery2.default)("#selfMerchantZip").val();
	    retailer.rtlOfficePhoneCountryCode = (0, _jquery2.default)("#selfMerchantPhoneCode").val();
	    retailer.rtlOfficePhone = (0, _jquery2.default)("#selfMerchantPhone").val();
	    retailer.userFirstName = (0, _jquery2.default)("#selfUserFirstName").val();
	    retailer.userLastName = (0, _jquery2.default)("#selfUserLastName").val();
	    retailer.userOrgTitle = (0, _jquery2.default)("#selfUserOrgTitle").val();
	    retailer.userPhoneCountryCode = (0, _jquery2.default)("#selfUserCountryCode").val();
	    retailer.userPhone = (0, _jquery2.default)("#selfUserPhone").val();
	    retailer.userEmail = (0, _jquery2.default)("#selfUserEmail").val();
	    retailer.userId = (0, _jquery2.default)("#selfUserId").val();
	  }
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  //submitModalFlow.showLoadingModal(); 
	
	  var initialRegistrationPage = (0, _jquery2.default)("#selfOnboard-retailer-wizard").data("initial-registration-page-url");
	  function processSubmitButton() {
	    console.log("inside submit controller button function");
	    AUI().use('liferay-portlet-url', function (A) {
	      createRetailerJson();
	      _jquery2.default.ajax({
	        url: registarionSubmitUrl,
	        data: {
	          '_merchantselfonboarding_WAR_retailerportlet_retailerJson': JSON.stringify(retailer)
	        },
	        dataType: "JSON",
	        type: 'POST',
	        cache: false,
	        success: function success(response) {
	          console.log("submit function sucess");
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            submitModalFlow.hideAllModals();
	          }, 100);
	          location.reload(true);
	          var myUrl = "/c/portal/logout";
	          window.open(myUrl, '_self', '');
	        },
	        error: function error() {
	          submitModalFlow.hideAllModals();
	          submitModalFlow.showFailureModal();
	        }
	      });
	    });
	  }
	};

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(785);

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _ = __webpack_require__(2);
	
	
	(0, _run2.default)(".rma-web-lite-main-div", function (mainEl) {
	  var rmaWebLiteFormDiv = mainEl.find(".rma-web-lite-form-div");
	  var requestValidationFailed = mainEl.data("validation-failed");
	  var usaStates = mainEl.data('usa-states');
	  var returnReasonDomainList = mainEl.data('rma-web-lite-return-reasons-domain-list');
	  var rmaWebLiteReturnReasonsSelect = mainEl.find("#rmaWebLiteReturnReasonSelect");
	  var rmaWebLiteStateSelect = mainEl.find("#rmaWebLiteState");
	  var rmaWebLiteState = mainEl.find("#rmaWebLiteState");
	  var rmaWebLiteFirstName = mainEl.find("#rmaWebLiteFirstName");
	  var rmaWebLiteLastName = mainEl.find("#rmaWebLiteLastName");
	  var rmaWebLiteEmail = mainEl.find("#rmaWebLiteEmail");
	  var rmaWebLiteRmaNumber = mainEl.find("#rmaWebLiteRmaNumber");
	  var rmaWebLitePhoneNumber = mainEl.find("#rmaWebLitePhoneNumber");
	  var rmaWebLiteAddressLine1 = mainEl.find("#rmaWebLiteAddressLine1");
	  var rmaWebLiteAddressLine2 = mainEl.find("#rmaWebLiteAddressLine2");
	  var rmaWebLiteCity = mainEl.find("#rmaWebLiteCity");
	  var rmaWebLitePostalCode = mainEl.find("#rmaWebLitePostalCode");
	  var rmaWebLiteNumberOfLabels = mainEl.find("#rmaWebLiteNumberOfLabels");
	  var rmaWebLiteReferenceNumber = mainEl.find("#rmaWebLiteReferenceNumber");
	  var rmaWebLiteDepartmentNumber = mainEl.find("#rmaWebLiteDepartmentNumber");
	  var rmaWebLitePurchaseOrder = mainEl.find("#rmaWebLitePoNumber");
	  var rmaWebLiteInvoiceNumber = mainEl.find("#rmaWebLiteInvoiceNumber");
	
	  var rmaWebLitShowReviewSectionBtn = mainEl.find(".rma-web-lite-review-section-btn");
	  var rmaWebLiteReviewSectionDiv = mainEl.find(".rma-web-lite-review-section-div");
	  var rmaWebLiteShowFormSectionBtn = mainEl.find(".rma-web-lite-form-section-btn");
	
	  var rmaWebLiteNameReview = mainEl.find("#rmaWebLiteNameReview");
	  var rmaWebLiteEmailReview = mainEl.find("#rmaWebLiteEmailReview");
	  var rmaWebLiteRmaNumberReview = mainEl.find("#rmaWebLiteRmaNumberReview");
	  var rmaWebLitePhoneNumberReview = mainEl.find("#rmaWebLitePhoneNumberReview");
	  var rmaWebLiteAddressLine1Review = mainEl.find("#rmaWebLiteAddressLine1Review");
	  var rmaWebLiteAddressLine2Review = mainEl.find("#rmaWebLiteAddressLine2Review");
	  var rmaWebLiteCityStatePostalCodeReview = mainEl.find("#rmaWebLiteCityStatePostalCodeReview");
	  var rmaWebLiteReturnReasonReview = mainEl.find("#rmaWebLiteReturnReasonReview");
	  var rmaWebLiteNumberOfLabelsReview = mainEl.find("#rmaWebLiteNumberOfLabelsReview");
	  var rmaWebLiteDepReview = mainEl.find("#rmaWebLiteDepReview");
	  var rmaWebLitePoReview = mainEl.find("#rmaWebLitePoReview");
	  var rmaWebLiteInvReview = mainEl.find("#rmaWebLiteInvReview");
	  var rmaWebLiteReferenceNumberReview = mainEl.find("#rmaWebLiteReferenceNumberReview");
	
	  var createReturnRmaWebLiteUrl = mainEl.data("create-rma-url");
	  var createWebLiteRma = mainEl.find("#create-web-lite-rma");
	  var generateLabelBtn = mainEl.find("#generate-rma-web-lite-label");
	  var submitModalFlow = new _SubmitModalFlow2.default();
	
	  var rmaWebLiteAuthDetails = mainEl.data("rma-web-lite-auth-details");
	  var accessToken = mainEl.find(".accessToken");
	  var retailerId = mainEl.find(".retailerId");
	  var partnerId = mainEl.find(".partnerId");
	  var rmaId = mainEl.find(".rmaIdForShipping");
	
	  var editSaveSection = mainEl.find(".edit-save-section");
	  var generateLabelSection = mainEl.find(".generate-label-section");
	  var returnLabelUrl = mainEl.data("return-label-url");
	  var pendingRaLabelSection = mainEl.find(".pending-ra-label-section");
	  var rmaSubmitError = mainEl.find(".create-web-lite-rma-error");
	  var rmaWebLiteDefaultError = mainEl.data("rma-web-lite-default-error");
	
	  load();
	
	  function setFormValidation() {
	    var validator = void 0,
	        validationOpts = void 0;
	    validationOpts = {
	      debug: true,
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          (0, _jquery2.default)(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    };
	    validator = rmaWebLiteFormDiv.validate(validationOpts);
	    validator.settings.ignore = ":disabled,:hidden";
	  }
	
	  function load() {
	    setInitialDisplay();
	    submitModalFlow.init();
	    rmaWebLiteReviewSectionDiv.hide();
	    setFormValidation();
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: rmaWebLiteStateSelect,
	      list: usaStates,
	      valueDataKey: "cdmValue",
	      textDataKey: "cdmMeaning"
	    });
	    //E-67372 RMA Web Lite
	    setInitialDisplay();
	    submitModalFlow.init();
	    rmaWebLiteReviewSectionDiv.hide();
	    setFormValidation();
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: rmaWebLiteReturnReasonsSelect,
	      list: returnReasonDomainList,
	      valueDataKey: "cdmValue",
	      textDataKey: "cdmMeaning"
	    });
	  }
	
	  function setInitialDisplay() {
	    if (requestValidationFailed) {
	      rmaWebLiteFormDiv.hide();
	    } else {
	      rmaWebLiteFormDiv.show();
	    }
	  }
	
	  rmaWebLitShowReviewSectionBtn.on('click', function (e) {
	    e.preventDefault();
	    if (rmaWebLiteFormDiv.valid()) {
	      rmaWebLiteReviewSectionDiv.show();
	      loadReviewPage();
	      rmaWebLiteFormDiv.hide();
	    }
	  });
	
	  rmaWebLiteShowFormSectionBtn.on('click', function () {
	    rmaWebLiteFormDiv.show();
	    rmaWebLiteReviewSectionDiv.hide();
	  });
	
	  function loadReviewPage() {
	    rmaWebLiteNameReview.text(rmaWebLiteFirstName.val() + ' ' + rmaWebLiteLastName.val());
	    rmaWebLiteEmailReview.text(rmaWebLiteEmail.val());
	    rmaWebLiteRmaNumberReview.text(rmaWebLiteRmaNumber.val());
	    rmaWebLitePhoneNumberReview.text(rmaWebLitePhoneNumber.val());
	    rmaWebLiteAddressLine1Review.text(rmaWebLiteAddressLine1.val());
	    rmaWebLiteAddressLine2Review.text(rmaWebLiteAddressLine2.val());
	    rmaWebLiteCityStatePostalCodeReview.text(rmaWebLiteCity.val() + ',' + rmaWebLiteState.val() + ' ' + rmaWebLitePostalCode.val());
	    rmaWebLiteReturnReasonReview.text(rmaWebLiteReturnReasonsSelect.find(":selected").text());
	    rmaWebLiteNumberOfLabelsReview.text(rmaWebLiteNumberOfLabels.val());
	    rmaWebLiteReferenceNumberReview.text(rmaWebLiteReferenceNumber.val());
	    rmaWebLiteDepReview.text(rmaWebLiteDepartmentNumber.val());
	    rmaWebLitePoReview.text(rmaWebLitePurchaseOrder.val());
	    rmaWebLiteInvReview.text(rmaWebLiteInvoiceNumber.val());
	  }
	
	  function setRmaWebLiteAuthDetails() {
	    accessToken.val(rmaWebLiteAuthDetails.accessToken);
	    retailerId.val(rmaWebLiteAuthDetails.retailerId);
	    partnerId.val(rmaWebLiteAuthDetails.partnerId);
	  }
	
	  createWebLiteRma.on("click", function (e) {
	    e.preventDefault();
	    save({ url: createReturnRmaWebLiteUrl, success: saveSuccess, error: saveError });
	  });
	
	  function save(_ref) {
	    var url = _ref.url,
	        success = _ref.success,
	        error = _ref.error;
	
	    setRmaWebLiteAuthDetails();
	    submitModalFlow.showLoadingModal();
	    _jquery2.default.ajax({
	      data: new FormData((0, _jquery2.default)('.rma-web-lite-form-div').get(0)),
	      url: url,
	      processData: false,
	      contentType: false,
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function saveSuccess(data) {
	    if (data.status == "Success") {
	      rmaSubmitError.hide();
	      rmaId.val(data.data);
	      EditChecker.setPageClean();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        submitModalFlow.hideAllModals();
	      }, _constants.SUCCESS_MODAL_TIMEOUT);
	      // START B-1355197 Replace Print label Verbiage
	      if (data.retAuthReq == "Approved") {
	        showGetLabelBtn();
	      } else if (data.retAuthReq == "Pending - RA Required") {
	        showGetPendigLabelBtn();
	      }
	      // END B-1355197 Replace Print label Verbiage
	    } else {
	      saveError(data);
	    }
	  }
	
	  function saveError(data) {
	    submitModalFlow.hideAllModals();
	    rmaSubmitError.show();
	    if (data.errorMessage != null) {
	      rmaSubmitError.text(data.errorMessage);
	    } else {
	      rmaSubmitError.text(rmaWebLiteDefaultError);
	    }
	  }
	
	  function showGetLabelBtn() {
	    editSaveSection.hide();
	    generateLabelSection.show();
	  }
	
	  // START B-1355197 Replace Print label Verbiage
	  function showGetPendigLabelBtn() {
	    editSaveSection.hide();
	    pendingRaLabelSection.show();
	  }
	  // END B-1355197 Replace Print label Verbiage
	  generateLabelBtn.on("click", function () {
	    var url = returnLabelUrl + '&rmaIdForShipping=' + rmaId.val() + '&accessToken=' + accessToken.val() + '&retailerId=' + retailerId.val();
	    window.open(url);
	  });
	});

/***/ },
/* 786 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [{
	    title: "Cancel Return",
	    cls: "cancel-return",
	    icon: "ban",
	    disabled: true
	  }],
	  "actions": [{
	    title: "View Label",
	    cls: "view-label",
	    icon: "file-text-o",
	    disabled: false
	  },
	  /*    {
	        title: "Approve Return",
	        cls: "approve-return",
	        icon: "check",
	        disabled:false
	      },
	      {
	        title: "Reject Return",
	        cls: "reject-return",
	        icon: "times",
	        disabled:false
	      },
	      {
	        title: "Track Return",
	        cls: "track-return",
	        icon: "truck",
	        disabled:false
	      },*/
	  {
	    title: "Cancel Return",
	    cls: "cancel-return",
	    icon: "ban",
	    disabled: false
	  }, {
	    title: "Start Return",
	    cls: "start-return",
	    icon: "mail-reply",
	    disabled: false
	  }]
	};

/***/ },
/* 787 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var rmaLookupFieldDropdown = exports.rmaLookupFieldDropdown = [{
		title: "By RMA Number",
		value: "rmaNumber"
	}, {
		title: "By Customer Name",
		value: "customerName"
	}, {
		title: "By Customer Email",
		value: "customerEmail"
	}];
	
	var rmaLookupFXOFieldDropdown = exports.rmaLookupFXOFieldDropdown = [{
		title: "By Customer Email",
		value: "customerEmail"
	}, {
		title: "By Phone Number",
		value: "fxoPhoneNumber"
	}];

/***/ },
/* 788 */
[1582, 789],
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _filtersutil = __webpack_require__(16);
	
	var _rmaLookupFieldDropdown = __webpack_require__(787);
	
	var _actionOptions = __webpack_require__(786);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	var actionList = _actionOptions.actionOptions;
	var targetSelector = "#lookup-rma";
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var detailLinkTemplate = __webpack_require__(1440);
	var customerNameTemplate = __webpack_require__(1439);
	
	(0, _run2.default)(targetSelector, function () {
		var entryElement = $(targetSelector);
		var dataTableComponentData = entryElement.data("rma-data");
		var statusList = entryElement.data("status-list");
		var rmaPortletFXOPerm = entryElement.data("fxo-perm");
		var rmaPortletAddPerm = entryElement.data("add-perm");
		var rmaPortletEditPerm = entryElement.data("edit-perm");
		var rmaCasAccountExists = entryElement.data("rma-cas-account");
		var retailerName = entryElement.data("retailer-name");
	
		var viewRmaDetailURL = entryElement.data("view-details-url");
		var fxoReturnsURL = entryElement.data("fxo-returns-url");
		var changeRmsStatusUrl = entryElement.data("change-status-url");
		var generateReturnLabelUrlForDownload = entryElement.data("return-label-url");
		var downloadReturnLabelUrlForDownload = entryElement.data("download-return-label-url");
		var filterSearchUrl = entryElement.data("filter-search-url");
		var generateExportUrl = entryElement.data("export-url");
	
		var portletNamespace = entryElement.data("portlet-namespace");
		var shouldCheckCache = entryElement.data("should-check-cache");
	
		var orderFilterData = entryElement.data("table-filter-data");
	
		var savedViews = getSavedViews(entryElement);
		var saveViewURL = entryElement.data("save-view-url");
		var deleteViewURL = entryElement.data("delete-view-url");
		var hasSubRetailers = entryElement.data("rma-has-subretailer");
		var fxoLabelReprintUpdateUrl = entryElement.data("fxo-label-reprint-update-url");
		var fxoGeneratelabelUrl = entryElement.data("fxo-generate-label-url");
		//  E-99299 Poly Mailer Attention Message START 
		var polyMailerDescMsg = entryElement.data("poly-mailer-desc-msg");
		var ployMailerTitleMsg = entryElement.data("ploy-mailer-title-msg");
		var enrolledInPolyMailer = entryElement.data("enrolled-in-poly-mailer");
		var roleAllowed = entryElement.data("role-allowed");
		//  E-99299 Poly Mailer Attention Message END 
		//MMC E-181400
		var rmaMmcFlag = entryElement.data("rma-mmc-flag");
		var rmaMmcReceiptType = entryElement.data("rma-mmc-receitp-type");
		//MMC
		var desktopColumns = void 0;
		if (hasSubRetailers) {
			desktopColumns = [{
				data: "rmaStatus",
				render: renderActionWrap,
				orderable: false,
				class: 'dtc-action-column',
				title: "Actions"
			}, {
				data: "rmaNumber",
				title: "RMA Number",
				render: createDetailLink,
				class: 'dtc-min-width-sm'
			}, {
				data: "rmaFromLastName",
				title: "Customer",
				render: createCustomerName,
				class: 'dtc-min-width-md'
	
			}, {
				data: "rmaFromEmail",
				title: "Email",
				class: 'dtc-min-width-md'
			}, {
				data: "rmaChrId",
				title: "Merchant",
				class: 'dtc-min-width-md',
				orderable: false
			}, {
				data: "rmaStatus",
				title: "Status",
				render: renderStatusPill,
				class: 'dtc-min-width-md'
			}, {
				data: "rmaCreatedDate",
				title: "Created on",
				render: formateDate,
				class: 'dtc-min-width-md'
			}, {
				data: "rmaCreatedDate", //or rmaCreatedTime if need by timestamp
				"visible": false // hidden column used to sort/order rmaCreatedDate formatted visible column
			}];
		} else {
			desktopColumns = [{
				data: "rmaStatus",
				render: renderActionWrap,
				orderable: false,
				class: 'dtc-action-column',
				title: "Actions"
			}, {
				data: "rmaNumber",
				title: "RMA Number",
				render: createDetailLink,
				class: 'dtc-min-width-sm'
			}, {
				data: "rmaFromLastName",
				title: "Customer",
				render: createCustomerName,
				class: 'dtc-min-width-md'
	
			}, {
				data: "rmaFromEmail",
				title: "Email",
				class: 'dtc-min-width-md'
			}, {
				data: "rmaStatus",
				title: "Status",
				render: renderStatusPill,
				class: 'dtc-min-width-md'
			}, {
				data: "rmaCreatedDate",
				title: "Created on",
				render: formateDate,
				class: 'dtc-min-width-md'
			}, {
				data: "rmaCreatedDate", //or rmaCreatedTime if need by timestamp
				"visible": false // hidden column used to sort/order rmaCreatedDate formatted visible column
			}];
		}
	
		var disableCancel = dataTableComponentData.disableCancel;
	
		var submitModalFlow = new _SubmitModalFlow2.default();
		submitModalFlow.init();
	
		var exportModal = new _filtersutil.buildExport();
	
		var extraDetailForCacheFromServer = entryElement.data("extra-detail-for-cache-from-server");
		var criteriaObjectFromServer = entryElement.data("filter-criteria-from-server");
	
		var targetObject = "";
		var totalRecordCount = 0;
		var lookupFieldDropdown = _rmaLookupFieldDropdown.rmaLookupFieldDropdown;
		var rmaMobileColumns = "";
	
		var selectedRows = "";
	
		if (rmaPortletFXOPerm) {
			lookupFieldDropdown = _rmaLookupFieldDropdown.rmaLookupFXOFieldDropdown;
		}
	
		if (shouldCheckCache) {
			targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
		}
	
		if (_.has(dataTableComponentData, "page")) {
			totalRecordCount = dataTableComponentData.page.totalElements;
		}
	
		function getSavedViews(entryElement) {
			var views = entryElement.data("saved-views");
			if (rmaPortletFXOPerm) {
				_(views[0].columns).map(function (viewColumn, rowIdx) {
					if (viewColumn.title === "Status") {
						viewColumn.active = false; // This is to hide status column for FXO user
						return viewColumn;
					} else {
						return viewColumn;
					}
				});
			}
	
			return views;
		}
	
		function renderPill(data, type, row) {
			return data;
		}
	
		function createDetailLink(data, type, row) {
			var newRender = void 0;
	
			newRender = (0, _render2.default)(detailLinkTemplate, {
				id: row.rmaId,
				name: row.rmaNumber,
				url: viewRmaDetailURL,
				portletnamespace: portletNamespace
			});
			return newRender;
		}
	
		function createCustomerName(data, type, row) {
			var newRender = void 0;
	
			newRender = (0, _render2.default)(customerNameTemplate, {
				firstname: row.rmaFromFirstName,
				lastname: row.rmaFromLastName
			});
			return newRender;
		}
	
		function renderStatusPill(data, type, row) {
			var status = data;
			if (status === "Pending - Address ID Missing") {
				return "<div class='q-pill q-block q-pill-red q-marg-all-xs-at-md q-pill-table'>Pending</div>";
			} else if (status === "Pending - RA Required") {
				return "<div class='q-pill q-block q-pill-red q-marg-all-xs-at-md q-pill-table'>Pending</div>";
			} else if (status === "Received") {
				return "<div class='q-pill q-block q-pill-blue-border q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
			} else if (status === "Canceled") {
				return "<div class='q-pill q-block q-pill-light-grey q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
			} else if (status === "Approved") {
				return "<div class='q-pill q-block q-pill-blue q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
			} else if (status === "ASN Sent") {
				return "<div class='q-pill q-block q-pill-white-and-grey q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
			} else if (status === "Partially Received") {
				return "<div class='q-pill q-block q-pill-blue-border q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
			} else if (status === "Pending - Unauthorized Items") {
				return "<div class='q-pill q-block q-pill-red q-marg-all-xs-at-md q-pill-table'>Pending</div>";
			} else if (status === "RMA Sent To SAP") {
				return "<div class='q-pill q-block q-pill-white-and-grey q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
			} else if (status === "Pending") {
				return "<div class='q-pill q-block q-pill-red q-marg-all-xs-at-md q-pill-table'>Pending</div>";
			} else if (status === "Closed to Returns") {
				return "<div class='q-pill q-block q-pill-blue q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
			} else if (status === "RMA Rejected") {
				return "<div class='q-pill q-block q-pill-light-grey q-marg-all-xs-at-md q-pill-table'>" + status + "</div>";
			}
			return "";
		}
	
		function formateDate(createdDate, type, data) {
			if (createdDate != null && createdDate != "") {
				var date = moment(createdDate).toDate(); // format yyyy-MM-DD
				var month = date.getMonth() + 1;
				var today = new Date();
				today.setHours(0, 0, 0, 0);
				date.setHours(0, 0, 0, 0);
				var oneDay = 24 * 60 * 60 * 1000;
				var diffDays = Math.round(Math.abs((today.getTime() - date.getTime()) / oneDay));
				var friendlyText = "";
				var datePillHTML = "";
				if (diffDays < 100) {
					friendlyText = diffDays.toString() + ' Days Ago';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				}
				if (diffDays == 0) {
					friendlyText = 'Today';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				} else if (diffDays == 1) {
					friendlyText = 'Yesterday';
					datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
				}
				return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
			} else {
				return "";
			}
		}
	
		var defaultMobileColumns = [{
			data: "rmaNumber",
			title: "RMA Number",
			render: createDetailLink
		}, {
			data: "rmaFromLastName",
			title: "Customer",
			render: createCustomerName
		}, {
			data: "rmaFromEmail",
			title: "Email"
		}, {
			data: "rmaStatus",
			title: "Status",
			render: renderStatusPill
		}];
	
		rmaMobileColumns = defaultMobileColumns;
	
		if (rmaPortletFXOPerm) {
			rmaMobileColumns.splice(-1); // remove last status column for mobile as status should not be shown to FXO
		}
	
		var rmaLookup = new _index2.default({
			// REQUIRED - Set a target element
			target: $("#lookup-rma-wrapper"),
			// REQUIRED - Set which data should be visible for mobile
			mobileColumns: rmaMobileColumns,
			// tableFilters: {
			//    data: orderFilterData,
			//  },
	
			// REQUIRED: search input info
			tableSearchInput: {
				// Not required
				// placeholder: 'Custom Search Text'
				value: targetObject != "" ? targetObject.value[0] : ""
	
			},
			// REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
			tableSearchDropdown: {
				selected: targetObject == "" ? "" : targetObject.key,
				columns: lookupFieldDropdown
			},
			// OPTIONAL: Set Saved View Array
			savedViews: savedViews,
			bulkSelect: false,
			// REQUIRED - Data Table specific settings
			dataTable: {
				// use same settings you would if you were just calling a dataTable normally
				data: dataTableComponentData.content,
				columnDefs: [{
					// Sort column 4 (formatted date) by column 6 (hidden column)
					"orderData": [6], // hidden column used to sort/order rmaCreatedDate formatted visible column
					"targets": [5]
				}],
				order: [[5, 'desc']],
				columns: desktopColumns
			},
			//  tableColumnModal: {
			//	data: rmaLookupColumnsPopup
			//},
			paginationData: dataTableComponentData.page,
			filterModal: {
				// REQUIRED: Sets title of modal
				title: "Filter Returns",
				// REQUIRED: Sets unique part of subtitle string.
				tableType: "rma"
			},
			onBulkSelectChange: function onBulkSelectChange() {
				selectedRows = rmaLookup.getBulkSelectedData();
				$("th.dtc-action-column").html(renderActionHeaderWrap());
				if (selectedRows.length >= 2) {
					$(".action-header-btn .base-btn").removeClass('disabled');
				} else {
					$(".action-header-btn .base-btn").addClass('disabled');
				};
			},
			onFetch: function onFetch() {
				var currentData = rmaLookup.generateData();
				rmaLookup.showLoadingOverlay();
				//Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
				if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: filterSearchUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isNew)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isEdit)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				} else if ((0, _filtersutil.isDeleteView)(currentData)) {
					setTimeout(function () {
						(0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
					}, _constants.SUCCESS_MODAL_TIMEOUT);
				}
			}
		});
	
		function filterSuccessFun(data) {
			var rmas = data.content;
			var page = data.page;
			rmaLookup.setNewData(rmas);
			rmaLookup.setPaginationData(page);
			(0, _filtersutil.pushFilterSessionCacheState)();
			totalRecordCount = page.totalElements;
			rmaLookup.hideLoadingOverlay();
			setExportData(rmaLookup.generateData());
			//$(".data-table-component").DataTable().columns('.status-column').visible( false );
		}
	
		function savedViewSuccess(data) {
			var rmas = data.lookupRmaJSON.content;
			var page = data.lookupRmaJSON.page;
			rmaLookup.setNewData(rmas);
			rmaLookup.setPaginationData(page);
			rmaLookup.setNewSavedViewData(data.savedView, "newSavedView");
			(0, _filtersutil.pushFilterSessionCacheState)();
			totalRecordCount = page.totalElements;
			rmaLookup.hideLoadingOverlay();
			setExportData(rmaLookup.generateData());
		}
	
		function savedEditViewSuccess(data) {
			var rmas = data.lookupRmaJSON.content;
			var page = data.lookupRmaJSON.page;
			rmaLookup.setNewData(rmas);
			rmaLookup.setPaginationData(page);
			rmaLookup.setNewSavedViewData(data.savedView, data.savedView.target);
			(0, _filtersutil.pushFilterSessionCacheState)();
			totalRecordCount = page.totalElements;
			rmaLookup.hideLoadingOverlay();
			setExportData(rmaLookup.generateData());
		}
	
		function delteViewScussFun(data) {
			var rmas = data.lookupRmaJSON.content;
			var page = data.lookupRmaJSON.page;
			rmaLookup.removeSavedView(data.target);
			rmaLookup.setNewData(rmas);
			rmaLookup.setPaginationData(page);
			totalRecordCount = page.totalElements;
			rmaLookup.hideLoadingOverlay();
			setExportData(rmaLookup.generateData());
		}
	
		function errorFun(data) {
			rmaLookup.hideLoadingOverlay();
		}
	
		rmaLookup.init();
	
		if (rmaPortletFXOPerm) {
			$('.new-saved-view-btn').remove(); // Hide the Add View button so that FXO user cannot create new filters.
		}
	
		//const ordersDataTableObj = $("#lookup-order-wrapper .data-table-component").dataTable();
		function renderActionWrap(data, type, row, meta) {
			var newRender = void 0;
			var statusTarget = actionList["actions"];
			newRender = (0, _render2.default)(actionCellDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row),
				index: meta.row
			});
			return newRender;
		};
	
		function renderActionHeaderWrap() {
			var statusTarget = actionList['all'];
			var newRender = void 0;
			var data = "";
			var row = "";
			newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
				list: renderActionCellList(statusTarget, data, row)
			});
			return newRender;
		};
	
		function renderActionCellList(list, data, row) {
			var renderedList = void 0;
			renderedList = _(list).map(function (item) {
				return (0, _render2.default)(actionCellDropdownItemTemplate, {
					icon: item.icon,
					title: item.title,
					cls: item.cls,
					disabled: checkDisableForGivenAction(data, row, item.title)
				});
			});
			return renderedList.join('');
		};
	
		function checkDisableForGivenAction(data, row, actionName) {
			if (isRowLevelActionCheck(data)) {
				return callBusinessLogicToDisableAction(data, row, actionName);
			} else {
				var isTrue = false;
				_(selectedRows).map(function (item) {
					if (callBusinessLogicToDisableAction(item.data.rmaStatus, item.data, actionName)) {
						if (!isTrue) {
							isTrue = true;
						}
					}
				});
				return isTrue;
			}
		};
	
		function isRowLevelActionCheck(data) {
			return (0, _general.isPresent)(data);
		}
	
		// Note this method will return true if we want to disable action, else return false if we want to enable
		function callBusinessLogicToDisableAction(status, row, actionName) {
			if ((0, _general.isPresent)(status)) {
				//HB-7753, Overriding Condition, If Not Recieved and Does not have a CAS account for
				if (row.rmaStatus != "Received" && !rmaCasAccountExists) {
					if (actionName === "View Label") {
						if (rmaPortletFXOPerm === true) {
							return false;
						}
					}
				}
				//HB-7753, Remaining Conditions for the View Actions same as before, except for Recieved, FXO show the view Label
	
				if (row.rmaStatus === "Received") {
					if (actionName === "View Label") {
						return false;
					} else if (actionName === "Track Return") {
						if (rmaPortletFXOPerm === true) {
							return true;
						} else {
							return false;
						}
					}
				} else if (row.rmaStatus === "Canceled") {
					if (actionName === "Approve Return") {
						if (rmaPortletEditPerm === true) {
							return false;
						}
					}
				} else if (row.rmaStatus === "Approved") {
					if (actionName === "View Label" || actionName === "Track Return") {
						if (!rmaPortletFXOPerm === true) {
							return false;
						}
					} else if (actionName === "Cancel Return") {
						if (rmaPortletEditPerm === true) {
							if ((0, _general.isPresent)(row.asnStatus)) {
								if (row.asnStatus != "Receiving" && row.ansStatus != "Complete") {
									return false;
								}
							} else {
								return false;
							}
						} else if (rmaPortletFXOPerm === true) {
							return true;
						}
					} else if (actionName === "Start Return") {
						if (rmaPortletFXOPerm === true) {
							return false;
						}
					}
				} else if (row.rmaStatus === "Pending - RA Required" || row.rmaStatus === "Pending - Address ID Missing") {
					if (rmaPortletEditPerm === true) {
						if (actionName === "Cancel Return") {
							return false;
						}
					}
				}
				return true;
			}
		}
	
		function shallAllowClick(currentObj) {
			return !$(currentObj).hasClass("disabled");
		}
	
		$('body').on('click', '.view-label, .cancel-return, .approve-return, .track-return, .start-return', function (e) {
			e.preventDefault();
			if (shallAllowClick(this)) {
				// Since the menu ends up in the body when this lookup is happening, have to carry the index of the parent dropdown
				var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
				// Get the row based on the parent...
				var parent = $(".dropdown-parent-" + pIndex).parents('tr');
				// Get the row data
				var row = $(".data-table-component").dataTable().api().row(parent);
	
				if ($(this).hasClass('view-label')) {
					processViewLabel(row);
				} else if ($(this).hasClass('cancel-return')) {
					processCancelReturn(row);
				} else if ($(this).hasClass('approve-return')) {
					processApproveReturn(row);
				} else if ($(this).hasClass('track-return')) {
					processReturnTracking(row);
				} else if ($(this).hasClass('start-return')) {
					processFxoReturn(row);
				}
			}
		});
	
		function processViewLabel(row) {
			$("#labelModal .title").html('&nbsp;-&nbsp;RMA: ' + row.data().rmaNumber);
			$("#labelModal").modal("show");
	
			$('#' + portletNamespace + 'printLabel').click(function () {
				window.open(generateReturnLabelUrlForDownload + '&rmaIdForShipping=' + row.data().rmaId, 'window1');
			});
	
			$('#' + portletNamespace + 'saveLabel').click(function () {
				window.open(downloadReturnLabelUrlForDownload + '&rmaIdForShipping=' + row.data().rmaId, 'window1');
			});
		}
	
		function processCancelReturn(row) {
			$("#cancelModal").data('row', row).modal("show");
	
			$('#' + portletNamespace + 'cancelReturn').click(function () {
				cancelReturn(row);
			});
		}
	
		function processApproveReturn(row) {
			$("#approveModal").data('row', row).modal("show");
	
			$('#' + portletNamespace + 'approveReturn').click(function () {
				cancelReturn(row);
			});
		}
	
		function cancelReturn(row) {
			// OLD: in controller, if current status is Canceled, it set to Approved. If current status is Approved, it changes to Canceled
			// Controller code has changed, now it will only set to status given
	
			submitModalFlow.showLoadingModal();
			$.ajax({
				url: changeRmsStatusUrl,
				type: 'POST',
				data: "selectedRmaId=" + row.data().rmaId + "&rmaStatus=Canceled",
				dataType: 'text',
				success: function success(data) {
					submitModalFlow.showSuccessModal();
					setTimeout(function () {
						submitModalFlow.hideAllModals();
					}, _constants.SUCCESS_MODAL_TIMEOUT);
					row.data().rmaStatus = $.trim(data);
					row.data(row.data()).draw();
				}
			});
		}
	
		function processReturnTracking(row) {
			AUI().use('liferay-portlet-url', function (A) {
				var renderURL = Liferay.PortletURL.createRenderURL();
				renderURL.setName("shipmentTracking");
				renderURL.setWindowState("exclusive");
				renderURL.setPortletId("shipmenttracking_WAR_commerceportlet");
				renderURL.setParameter("tracking-number", row.data().rmaTrackingNumber);
				renderURL.setParameter("carrier", "Fedex");
				renderURL.setParameter("retailerId", row.data().rmaRetId);
				var url = renderURL.toString();
	
				$('#' + portletNamespace + 'trackingLoading').show();
				$('#' + portletNamespace + 'trackingError').hide();
				$('#' + portletNamespace + 'trackingDiv').html("");
				$("#trackingModal").modal("show");
	
				$.ajax({
					url: url,
					cache: false,
					type: "POST",
					success: function success(response) {
						$('#' + portletNamespace + 'trackingLoading').hide();
						$('#' + portletNamespace + 'trackingDiv').html(response);
					},
					error: function error() {
						$('#' + portletNamespace + 'trackingError').show();
					}
				});
			});
		}
	
		function processFxoReturn(row) {
			if (rmaCasAccountExists || rmaMmcFlag == true && rmaMmcReceiptType == true) {
				$('#multipleRmaSelectionHidden').val(row.data().rmaId);
				$("#fxo-rma-return-form").submit();
			} else {
				$("#no-cas-participation-modal").modal("show");
				if (enrolledInPolyMailer == true && roleAllowed == true) {
					$("#fxo_nonpolymailer").hide();
					$("#fxo_polymailer").show();
					$("#polyMailerTitleMsg").html(ployMailerTitleMsg);
					$("#polyMailerDescMsg").html(polyMailerDescMsg);
					if (row.data().rmaChrId == null || row.data().rmaChrId == '') {
						$("#fxo-merchant-name-poly").html(retailerName);
					} else {
						$("#fxo-merchant-name-poly").html(row.data().rmaChrId);
					}
					$("#poly-mailer-used-radio-opt1").prop("checked", false);
					$("#poly-mailer-used-radio-opt2").prop("checked", false);
					if (row.data().rmaChrId == null || row.data().rmaChrId == '') {
						$("#fxo-merchant-name-nonpoly").html(retailerName);
					} else {
						$("#fxo-merchant-name-nonpoly").html(row.data().rmaChrId);
					}
					$("#print-label-btn").addClass("disabled");
				} else {
					$("#fxo_nonpolymailer").show();
					$("#fxo_polymailer").hide();
					$("#fxo_polymailer").hide();
					if (row.data().rmaChrId == null || row.data().rmaChrId == '') {
						$("#fxo-merchant-name-nonpoly").html(retailerName);
					} else {
						$("#fxo-merchant-name-nonpoly").html(row.data().rmaChrId);
					}
				}
			}
			$("#print-label-btn").on("click", function () {
				var resizeLabel = false;
				var rmaReceivingType = row.data().rmaReceivingType;
	
				$("#no-cas-participation-modal").modal("hide");
				if (rmaReceivingType == 'single_ship') {
					resizeLabel = true;
				}
				window.open(fxoGeneratelabelUrl + '&rmaIdForShipping=' + row.data().rmaId + '&resizeLabel=' + resizeLabel + '&rmaReceivingType=' + rmaReceivingType, 'window1');
	
				submitFxoLabelReprintUpdate(row);
			});
		}
	
		$(".poly-mailer-radio").on('change', function (e) {
			$("#print-label-btn").removeClass("disabled");
			return true;
		});
	
		function submitFxoLabelReprintUpdate(row) {
			var radioValue = $("input[name='poly-mailer-used-radio']:checked").val();
			var url = fxoLabelReprintUpdateUrl + "&rma-number-capture=" + row.data().rmaNumber + "&poly-mailer-used-radio=" + radioValue;
	
			$.ajax({
				url: url,
				type: 'POST',
				beforeSend: function beforeSend() {
					$.blockUI({
						message: 'Please Wait...'
					});
				},
				complete: function complete() {
					$.unblockUI();
				},
				success: function success(resp) {},
				error: function error(xhr, status, _error) {}
			});
		}
	
		function initExport() {
			var exportObj = {
				title: $(targetSelector).data("export-popup-title"),
				exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
				exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
				exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
			};
	
			exportModal.init(exportObj);
			exportModal.bindExportEvent();
		}
	
		function setExportData(currentData) {
			exportModal.buildExportBasicURL(generateExportUrl, currentData);
			exportModal.setExportCount(currentData.totalElements);
		}
	
		initExport();
		setExportData(rmaLookup.generateData());
	
		// Allow custom dropdowns to work (based on class 'overflow-dropdown'), check the template for more information...
		(0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
		$("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(791);

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _resourceProgress = __webpack_require__(471);
	
	var _resourceProgress2 = _interopRequireDefault(_resourceProgress);
	
	var _constants = __webpack_require__(10);
	
	var _index = __webpack_require__(10);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _filtersutil = __webpack_require__(16);
	
	var _index3 = __webpack_require__(86);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reviewWarehouseProductTemplate = __webpack_require__(1441);
	
	(0, _run2.default)("#rma-details", function (mainEl) {
	    var resourceProgressTargetEl = mainEl.find('.resource-progress-target');
	    var resourceStatusDemo = resourceProgressTargetEl.data('resource-progress-config');
	    (0, _resourceProgress2.default)(resourceProgressTargetEl, { data: resourceStatusDemo });
	    var portletNamespace = mainEl.data("portlet-namespace");
	    var vendorAuthorizationBtn = mainEl.find(".vendor-authorization-btn");
	    var updateVendorAuthModal = (0, _jquery2.default)("#vendor-rma-auth-number");
	    var vendorAuthButton = updateVendorAuthModal.find("#vendor-auth-button");
	    var updateVendorAuthForm = updateVendorAuthModal.find("#update-vendor-auth-numbers-frm");
	    mainEl.on("click", '.address-id-missing-resubmit', resubmitRma);
	    var addressIdMissingResubmit = (0, _jquery2.default)('.address-id-missing-resubmit');
	    var missingAddressIdResubmitForm = (0, _jquery2.default)('#missing-address-id-resubmit-form');
	    var trackShipmentbtn = mainEl.find(".track-shipment-btn");
	    var rmaRetailerId = mainEl.data("rma-retailer-id");
	    var rmaStatus = mainEl.data("rma-status");
	    var rmaId = mainEl.data("rma-id");
	    var reapproveRmaBtn = mainEl.find('#reapprove-rma');
	    var changeRmsStatusUrl = mainEl.data("change-rms-status");
	    var showCancelRmaModal = mainEl.find('#cancel-rma');
	    var cancelRmaModal = (0, _jquery2.default)("#rma-cancel-modal");
	    var rmaCancelBtn = cancelRmaModal.find("#cancel-rma-btn");
	    var loadMoreItemsUrl = mainEl.data("load-more-items-url");
	    var rmaItems = mainEl.data("rma-items");
	
	    //show Reject Return modal for WB2 Pending RMA
	    var showRejectReturnRmaModal = mainEl.find('#rejectreturn-rma'); //WB2
	    var rejectReturnRmaModal = (0, _jquery2.default)("#rma-rejectreturn-modal");
	    var rmaRejectReturnBtn = rejectReturnRmaModal.find("#rejectreturn-rma-btn"); //WB2 modal reject button
	
	    //show Approve modal for WB2 pending RMA    
	    var showApproveReturnRmaModal = mainEl.find('#approvereturn-rma'); //WB2
	    var approveReturnRmaModal = (0, _jquery2.default)("#rma-approvereturn-modal");
	    var rmaApproveReturnBtn = approveReturnRmaModal.find("#submitapprovereturn-rma-btn"); //WB2 modal approve submit button
	
	    //Used by Reject Return button on details page WB2
	    showRejectReturnRmaModal.on('click', function (e) {
	        rejectReturnRmaModal.show();
	    });
	
	    //Used by Reject Return button on modal popup WB2
	    rmaRejectReturnBtn.on('click', function (e) {
	        changeRmaStatus("RMA Rejected");
	    });
	
	    //Used by Approve button on details page WB2
	    showApproveReturnRmaModal.on('click', function (e) {
	        approveReturnRmaModal.show();
	    });
	
	    //Used by Approve button on modal popup WB2
	    rmaApproveReturnBtn.on('click', function (e) {
	        changeRmaStatus("Approved");
	    });
	
	    showCancelRmaModal.on('click', function (e) {
	        cancelRmaModal.show();
	    });
	
	    reapproveRmaBtn.on('click', function (e) {
	        changeRmaStatus("Approved");
	    });
	
	    rmaCancelBtn.on('click', function (e) {
	        changeRmaStatus("Canceled");
	    });
	
	    function changeRmaStatus(newRmaStatus) {
	        var submitModalFlow = new SubmitModalFlow();
	        submitModalFlow.init();
	        submitModalFlow.showLoadingModal();
	        _jquery2.default.ajax({
	            url: changeRmsStatusUrl,
	            type: 'POST',
	            dataType: 'text',
	            data: {
	                rmaStatus: newRmaStatus,
	                selectedRmaId: rmaId
	            },
	            success: function success(data) {
	                if (data.trim() == "Approved") {
	                    (0, _jquery2.default)('#rma-status').text('Approved');
	                    submitModalFlow.showSuccessModal();
	                    setTimeout(function () {
	                        location.reload();
	                    }, window.constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	                } else {
	                    (0, _jquery2.default)('#rma-status').text('Canceled');
	                    submitModalFlow.showSuccessModal();
	                    setTimeout(function () {
	                        location.reload();
	                    }, window.constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	                }
	            }
	        });
	    };
	
	    trackShipmentbtn.on("click", function (e) {
	        //processReturnTracking($(this).attr('box-tracking-number'), rmaRetailerId);
	        processReturnTracking((0, _jquery2.default)(this).data('box-tracking-number'), rmaRetailerId);
	    });
	
	    updateVendorAuthForm.validate({
	        errorPlacement: function errorPlacement(error, element) {
	
	            var appendClosest = (0, _jquery2.default)(element).data('error-placement-append-closest');
	            if (appendClosest) {
	                (0, _jquery2.default)(element).closest(appendClosest).append(error);
	            } else {
	                error.insertAfter(element);
	            }
	        }
	    });
	
	    vendorAuthorizationBtn.on('click', function () {
	        updateVendorAuthModal.modal('show');
	    });
	
	    vendorAuthButton.on('click', function (e) {
	        e.preventDefault();
	        if (updateVendorAuthForm.valid()) {
	            updateVendorAuthModal.modal('hide');
	            var updateActionUrl = (0, _jquery2.default)(this).attr("href");
	
	            //console.log("will invoke ajax : " + updateActionUrl);
	
	            var submitModalFlow = new SubmitModalFlow({
	                confirmModalTitle: 'Submit Vendor Authorization Numbers',
	                confirmModalBody: '<div class="q-pad-all-xl">Submitting this Vendor Authorization Number will update the status of this RMA to approved and the customer will receive their return shipping label.</div>',
	                confirmModalBtnText: 'Submit',
	                onConfirmClick: function onConfirmClick() {
	                    submitModalFlow.hideAllModals();
	                    submitModalFlow.showLoadingModal();
	                    var formData = (0, _jquery2.default)(updateVendorAuthForm).serialize();
	                    _jquery2.default.ajax({
	                        url: updateActionUrl,
	                        type: 'POST',
	                        data: formData,
	                        success: function success(resp) {
	                            submitModalFlow.showSuccessModal();
	                            setTimeout(function () {
	                                window.location.reload();
	                            }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	                        },
	                        error: function error(_error) {
	                            //submitModalFlow.showFailureModal();
	                        }
	                    });
	                }
	            });
	            submitModalFlow.init();
	            submitModalFlow.showConfirmModal();
	        }
	    });
	
	    function resubmitRma() {
	        //e.preventDefault();
	        var url = addressIdMissingResubmit.data('url');
	        var submitModalFlow = new SubmitModalFlow({
	            confirmModalTitle: 'Resubmit RMA',
	            confirmModalBody: '<div class="q-pad-all-xl">Resubmitting this RMA will check missing address id in system and change rma status accordingly.</div>',
	            confirmModalBtnText: 'Submit',
	            onConfirmClick: function onConfirmClick() {
	                submitModalFlow.hideAllModals();
	                submitModalFlow.showLoadingModal();
	                var formData = (0, _jquery2.default)(missingAddressIdResubmitForm).serialize();
	                _jquery2.default.ajax({
	                    url: url,
	                    type: 'POST',
	                    data: { 'rmaId': (0, _jquery2.default)('.missing-add-id-form-rmaid').val() },
	                    success: function success(resp) {
	                        submitModalFlow.showSuccessModal();
	                        setTimeout(function () {
	                            window.location.reload();
	                        }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	                    },
	                    error: function error(_error2) {
	                        //submitModalFlow.showFailureModal();
	                    }
	                });
	            }
	        });
	        submitModalFlow.init();
	        submitModalFlow.showConfirmModal();
	    }
	
	    function processReturnTracking(trackingNumber, retailerId) {
	        AUI().use('liferay-portlet-url', function (A) {
	            var renderURL = Liferay.PortletURL.createRenderURL();
	            renderURL.setName("shipmentTracking");
	            renderURL.setWindowState("exclusive");
	            renderURL.setPortletId("shipmenttracking_WAR_commerceportlet");
	            renderURL.setParameter("tracking-number", trackingNumber);
	            renderURL.setParameter("carrier", "Fedex");
	            renderURL.setParameter("retailerId", retailerId);
	            var url = renderURL.toString();
	
	            (0, _jquery2.default)('#' + portletNamespace + 'trackingLoading').show();
	            (0, _jquery2.default)('#' + portletNamespace + 'trackingError').hide();
	            (0, _jquery2.default)('#' + portletNamespace + 'trackingDiv').html("");
	            (0, _jquery2.default)("#trackingModal").modal("show");
	
	            _jquery2.default.ajax({
	                url: url,
	                cache: false,
	                type: "POST",
	                success: function success(response) {
	                    (0, _jquery2.default)('#' + portletNamespace + 'trackingLoading').hide();
	                    (0, _jquery2.default)('#' + portletNamespace + 'trackingDiv').html(response);
	                },
	                error: function error() {
	                    (0, _jquery2.default)('#' + portletNamespace + 'trackingError').show();
	                }
	            });
	        });
	    }
	    var pageSizeOptionsArray = [25, 50, 100];
	    var pageSize = 25; //default to 25 for the RMA Items 
	    var pagableRmaItems = new _index4.default({
	        dataContainer: '.render-area-for-product-with-rtv',
	        pagingContainer: '.paging-area-for-product-with-rtv',
	        pageSizeOptions: pageSizeOptionsArray,
	        pageSize: pageSize,
	        data: rmaItems,
	        showData: function showData(row) {
	            return (0, _render2.default)(reviewWarehouseProductTemplate, {
	                sku: row.rmaItemSku,
	                upc: row.rmaItemUpc,
	                modal: row.rmaItemModel,
	                qty: row.rmaItemQty,
	                rtv: row.rmaItemRtvNumber
	            });
	        },
	        onFetch: function onFetch(page, pageSize) {
	            pagableRmaItems.showLoadingOverlay();
	            setTimeout(function () {
	                (0, _filtersutil.doAjax)({ url: loadMoreItemsUrl, success: loadMoreItems, error: errorFun, data: prepareDataToSendController(rmaId, page, pageSize) });
	            }, _index2.default);
	        }
	    });
	
	    function loadMoreItems(data) {
	        var rmaItems = data.content;
	        pagableRmaItems.setData(rmaItems);
	        pagableRmaItems.hideLoadingOverlay();
	    }
	
	    function errorFun(data) {
	        pagableRmaItems.hideLoadingOverlay();
	    }
	
	    function prepareDataToSendController(rmaId, page, pageSize) {
	        var data = {
	            page: page,
	            pageSize: pageSize,
	            rmaId: rmaId
	        };
	        return data;
	    }
	    pagableRmaItems.init();
	});

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(793);
	
	__webpack_require__(1104); /*NOTE - all index.js files in each page directory is the "entry point" for the
	                        page and its styles and functionality. This index.js page will be included in
	                        the main src/index.js file to load it into the portlet*/

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _viewAltAddressValidationLogic = __webpack_require__(794);
	
	var _viewAltAddressValidationLogic2 = _interopRequireDefault(_viewAltAddressValidationLogic);
	
	var _viewSchedPickupDisplayLogic = __webpack_require__(795);
	
	var _viewSchedPickupDisplayLogic2 = _interopRequireDefault(_viewSchedPickupDisplayLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	// NOTE - choose target (id or unique class) where you want this to
	var targetSelector = "#schedule-pickup-target";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachViewPage(outerEl);
	});
	
	function attachViewPage(outerEl) {
	  var isExternal = outerEl.data('is-external');
	  var availablePickupTimesContainer = outerEl.find(".available-pickup-times-container");
	
	  $(".time-option").on("click", function () {
	    var selectedTimeRow = $(this);
	    var selectedCheckbox = $(this).find(".schedPickUpTimes");
	
	    availablePickupTimesContainer.find(".time-option").removeClass("highlight-row");
	    selectedTimeRow.addClass("highlight-row");
	
	    if (!selectedCheckbox.is(":checked")) {
	      selectedCheckbox.prop("checked", true);
	    }
	  });
	
	  var altAddressTarg = outerEl.find(".alt-address-target");
	
	  var altAddress = new _viewAltAddressValidationLogic2.default(altAddressTarg, { isExternal: isExternal });
	  altAddress.init();
	
	  var schedPickupDisplay = new _viewSchedPickupDisplayLogic2.default(outerEl, { isExternal: isExternal });
	  schedPickupDisplay.init();
	}

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AltAddressValidation;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//NOTE: business logic example. Incomplete, please refer to requirements for further needed logic
	
	var $ = __webpack_require__(1);
	
	
	var customValidateProps = {
	  errorPlacement: function errorPlacement(error, element) {
	    var appendClosest = $(element).data('error-placement-append-closest');
	    if (appendClosest) {
	      $(element).closest(appendClosest).append(error);
	    } else {
	      error.insertAfter(element);
	    }
	  }
	};
	
	var elementsPageMap = {
	  useAltAddressBtn: ".use-alt-address-btn",
	  pageAltAddress: ".pickupAddress"
	};
	
	var elementsModalMap = {
	  useAltBtn: ".use-alt-address-modal-btn",
	  closeModalBtn: ".alt-address-modal-close-btn",
	  addressForm: ".schedulePickUpAltAddress",
	
	  modalSelects: ".select2-select",
	  modalFields: "input",
	
	  address1: ".scheduleReportAddress1",
	  address2: ".scheduleReportAddress2",
	  city: ".scheduleReportCity",
	  state: ".scheduleReportState",
	  zipcode: ".scheduleReportPostalCode"
	};
	
	var elementsFillableAreaMap = {
	  pageAddress1: ".alt-address-st1",
	  pageAddress2: ".alt-address-st2",
	  pageCity: ".alt-address-city",
	  pageState: ".alt-address-state",
	  pageZipcode: ".alt-address-zip"
	};
	
	function AltAddressValidation(fillableAddressArea) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$isExternal = _ref.isExternal,
	      isExternal = _ref$isExternal === undefined ? false : _ref$isExternal;
	
	  var self = this;
	  var schedPickupAddressOuter = $(".view-sched-pickup-address-outer");
	
	  var modalEl = void 0;
	  var elsPage = {};
	  var elsModal = {};
	  var elsFillablePage = {};
	
	  self.init = function () {
	    generateModal();
	    setElements();
	    bindElements();
	
	    setupValidationForForm();
	  };
	
	  function generateModal() {
	    var consumerClass = '';
	    var btnClass = 'purple-btn';
	    if (isExternal) {
	      consumerClass = 'consumer';
	      btnClass = 'consumer-grey-btn';
	    }
	    var footerBtns = "<a href=\"#\" class=\"base-btn v2-btn " + btnClass + " alt-address-modal-close-btn\">Cancel</a>    <a href=\"#\" class=\"base-btn " + btnClass + " use-alt-address-modal-btn\">Use This Address</a>";
	
	    var bodyEl = (0, _render2.default)(__webpack_require__(1442), {
	      consumerClass: consumerClass
	    });
	
	    modalEl = $((0, _render2.default)(__webpack_require__(11), {
	      title: 'Use Alternative Address',
	      subtitle: 'Add an alternative address to be the pickup destination.',
	      footerBtns: footerBtns,
	      body: bodyEl,
	      modalBodyClass: 'q-bg-c-lightest-grey'
	    }));
	
	    $("body").append(modalEl);
	  };
	
	  function bindElements() {
	    elsPage.useAltAddressBtn.click(useAltAddressBtnClick);
	    elsModal.useAltBtn.click(altAddressValidateClick);
	    elsModal.closeModalBtn.click(closeModalClick);
	
	    elsModal.modalSelects.change(validateIndividualSelects);
	  };
	
	  function setElements() {
	    // set for page scope of general els
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, schedPickupAddressOuter);
	    // set for modal scope
	    (0, _selectorHelpers.setElementsFromScope)(elsModal, elementsModalMap, modalEl);
	    // set for page level scope of fillable area
	    (0, _selectorHelpers.setElementsFromScope)(elsFillablePage, elementsFillableAreaMap, fillableAddressArea);
	  };
	
	  function setupValidationForForm() {
	    elsModal.addressForm.validate(customValidateProps);
	  };
	
	  function altAddressValidateClick(e) {
	    e.preventDefault();
	    altAddressValidate();
	  };
	
	  function useAltAddressBtnClick(e) {
	    e.preventDefault();
	
	    handleModalShow();
	  };
	
	  function handleModalShow() {
	    elsModal.addressForm.validate().resetForm();
	
	    clearModalForm();
	
	    modalEl.modal("show");
	  };
	
	  function altAddressValidate() {
	    if (elsModal.addressForm.valid()) {
	      modalEl.modal("hide");
	      populateAlternateAddress();
	      $("#pickup-availability").hide();
	    }
	  };
	
	  function populateAlternateAddress() {
	    var fillConfig = [{
	      fromElement: elsModal.address1,
	      toElement: elsFillablePage.pageAddress1
	    }, {
	      fromElement: elsModal.address2,
	      toElement: elsFillablePage.pageAddress2
	    }, {
	      fromElement: elsModal.city,
	      toElement: elsFillablePage.pageCity
	    }, {
	      fromElement: elsModal.state.find("option:selected"),
	      toElement: elsFillablePage.pageState
	    }, {
	      fromElement: elsModal.zipcode,
	      toElement: elsFillablePage.pageZipcode
	    }];
	    updateSelectedPickupAddress();
	    populateTextsFromElVals(fillConfig);
	    fillableAddressArea.show();
	    elsPage.pageAltAddress.prop("checked", true);
	  };
	
	  function populateTextsFromElVals(config) {
	    (0, _underscore2.default)(config).map(populateTextFromElVal);
	  };
	
	  function updateSelectedPickupAddress() {
	    $('#selected-pickup-address1').val(elsModal.address1.val());
	    $('#selected-pickup-address2').val(elsModal.address2.val());
	    $('#selected-pickup-city').val(elsModal.city.val());
	    $('#selected-pickup-state').val(elsModal.state.find("option:selected").val());
	    $('#selected-pickup-zip').val(elsModal.zipcode.val());
	    $('#selected-pickup-country').val("US");
	  }
	
	  function populateTextFromElVal(_ref2) {
	    var toElement = _ref2.toElement,
	        fromElement = _ref2.fromElement;
	
	    // if the from element is type option, then do our new code (text), otherwise use val
	    var text = void 0;
	    if (fromElement.is('option')) {
	      text = fromElement.text();
	    } else {
	      text = fromElement.val();
	    }
	
	    toElement.text(text);
	  };
	
	  function validateIndividualSelects() {
	    $(this).valid();
	  };
	
	  function clearModalForm() {
	    elsModal.modalFields.val("");
	    elsModal.modalSelects.val("").trigger("change.select2");
	  };
	
	  function closeModalClick(e) {
	    e.preventDefault();
	
	    modalEl.modal("hide");
	  };
	};

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = SchedPickupDisplayLogic;
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	var _constants = __webpack_require__(10);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// NOTE: this is some simple business logic to demonstrate how the page could work, but validation isn't included on the main pages in the stub
	
	var elementsPageMap = {
	  checkSched: ".check-pickup-sched",
	  closeSched: ".close-pickup-sched",
	  viewSchedCard: ".view-schedule-pickup",
	  viewSchedConfirmation: ".confirm-schedule-pickup",
	  schedPickupBtnFinal: ".sched-pickup-btn-final",
	  findAvailabilityBtn: "#find-availability-btn",
	  pickupAvailability: "#pickup-availability",
	  schedulePickupForm: "#schedule-pickup-form",
	  schedulePickupOptions: "#schedule-pickup-options",
	  selectPicupAddressRadio: '.select-pickup-address',
	  pickupAddressClosingTime: '#pickup-address-closing-time',
	  pickupCutoffTime: '#pickup-cutoff-time',
	  genericPgSelects: ".select2-select"
	};
	
	var customValidateProps = {
	  errorPlacement: function errorPlacement(error, element) {
	    var appendClosest = $(element).data('error-placement-append-closest');
	    if (appendClosest) {
	      $(element).closest(appendClosest).append(error);
	    } else {
	      error.insertAfter(element);
	    }
	  }
	};
	
	function SchedPickupDisplayLogic(mainEl) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$isExternal = _ref.isExternal,
	      isExternal = _ref$isExternal === undefined ? false : _ref$isExternal;
	
	  var self = this;
	  var elsPage = {};
	  var closingTimePickerEl = mainEl.find('.time-picker-closing-time');
	
	  var opts = {};
	  if (isExternal) {
	    opts = { addSelect2Class: 'consumer' };
	  }
	  var closingTimePicker = (0, _timePicker2.default)(closingTimePickerEl, opts);
	  closingTimePicker.setTimeFromMilitary("18:00");
	
	  var submitModalFlow = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Schedule Pick Up',
	    // confirmModalSubtitle: "Optional Subtitle",
	    confirmModalBody: '<div class="q-pad-all-xl">By confirming this scheduled pick up, you agree to leave your package(s) at the location within the time frame available on the date that is specified in this form.</div>',
	    confirmModalBtnText: 'Confirm',
	    onConfirmClick: function onConfirmClick() {
	      schedPickupFinalHandle();
	    }
	  });
	  submitModalFlow.init();
	
	  self.init = function () {
	    setElements();
	    setInitialState();
	    bindElements();
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, mainEl);
	  };
	
	  function setInitialState() {
	    elsPage.viewSchedCard.hide();
	    elsPage.viewSchedConfirmation.hide();
	    elsPage.closeSched.hide();
	
	    elsPage.schedulePickupForm.validate(customValidateProps);
	  };
	
	  function bindElements() {
	    elsPage.checkSched.click(checkSchedClick);
	    elsPage.closeSched.click(closeSchedClick);
	    elsPage.schedPickupBtnFinal.click(schedPickupFinalClick);
	    elsPage.findAvailabilityBtn.click(findAvailability);
	    elsPage.selectPicupAddressRadio.click(updateSelectedPickupAddress1);
	    // elsPage.genericPgSelects.change(validateIndividualSelects);
	  };
	
	  function updateSelectedPickupAddress1() {
	    elsPage.pickupAvailability.hide();
	    if (elsPage.selectPicupAddressRadio.val() == 'alternate') {
	      $('#selected-pickup-address1').val($('.alt-address-st1').text());
	      $('#selected-pickup-address2').val($('.alt-address-st2').text());
	      $('#selected-pickup-city').val($('.alt-address-city').text());
	      $('#selected-pickup-state').val($('.alt-address-state').text());
	      $('#selected-pickup-zip').val($('.alt-address-zip').text());
	      $('#selected-pickup-country').val("US");
	    } else {
	      $('#selected-pickup-address1').val($('.default-address-st1').text());
	      $('#selected-pickup-address2').val($('.default-address-st2').text());
	      $('#selected-pickup-city').val($('.default-address-city').text());
	      $('#selected-pickup-state').val($('.default-address-state').text());
	      $('#selected-pickup-zip').val($('.default-address-zip').text());
	      $('#selected-pickup-country').val("US");
	    }
	  };
	
	  // NOTE: not working correctly here, even though it works all right in modal validation. Look into this later
	  function validateIndividualSelects() {
	    $(this).valid();
	  };
	
	  function checkSchedClick(e) {
	    e.preventDefault();
	
	    if ($(this).hasClass("disabled")) {
	      return;
	    }
	
	    checkSchedHandle();
	  };
	
	  function closeSchedClick(e) {
	    e.preventDefault();
	
	    closeSchedHandle();
	  };
	
	  function schedPickupFinalClick(e) {
	    e.preventDefault();
	
	    // schedPickupFinalHandle();
	    submitModalFlow.showConfirmModal();
	  };
	
	  function findAvailability(e) {
	    e.preventDefault();
	
	    elsPage.pickupAvailability.hide();
	    elsPage.pickupAddressClosingTime.val(closingTimePicker.getMilitaryTime() + ':00');
	
	    var pickupDate = elsPage.schedulePickupForm.find(".date-of-pickup").val();
	
	    if (elsPage.schedulePickupForm.valid()) {
	      $.ajax({
	        url: elsPage.findAvailabilityBtn.data("url") + "&pickupDate=" + pickupDate,
	        type: 'POST',
	        dataType: 'html',
	        data: elsPage.schedulePickupForm.serialize(),
	        beforeSend: function beforeSend() {
	          //$.blockUI({message : 'Please Wait..'}); // TODO like previouslyShippedLoader.show();
	          submitModalFlow.showLoadingModal();
	        },
	        complete: function complete() {
	          //$.unblockUI(); //TODO like previouslyShippedLoader.hide();
	
	        },
	        success: function success(resp) {
	          elsPage.pickupAvailability.html(resp);
	          elsPage.pickupAvailability.show();
	          $(".sched-pickup-btn-final").click(schedPickupFinalClick);
	          submitModalFlow.hideAllModals();
	        },
	        error: function error(xhr, status, _error) {
	          submitModalFlow.hideAllModals();
	        }
	      });
	    }
	  };
	
	  function checkSchedHandle() {
	    elsPage.checkSched.hide();
	    elsPage.closeSched.show();
	
	    elsPage.viewSchedCard.slideDown();
	  };
	
	  function closeSchedHandle() {
	    elsPage.checkSched.show();
	    elsPage.closeSched.hide();
	
	    elsPage.viewSchedCard.slideUp();
	  };
	
	  function schedPickupFinalHandle() {
	    elsPage.pickupAddressClosingTime.val(closingTimePicker.getMilitaryTime() + ":00");
	    elsPage.pickupCutoffTime.val($('input[name=pickupDate]:checked').closest('tr').find(".cutoff-time").text().trim());
	    if (elsPage.schedulePickupForm.valid()) {
	      $.ajax({
	        url: $(".sched-pickup-btn-final").data("url"),
	        type: 'POST',
	        dataType: 'html',
	        data: elsPage.schedulePickupForm.serialize(),
	        beforeSend: function beforeSend() {
	          //$.blockUI({message : 'Please Wait..'}); // TODO like previouslyShippedLoader.show();
	          submitModalFlow.showLoadingModal();
	        },
	        complete: function complete() {
	          //$.unblockUI(); //TODO like previouslyShippedLoader.hide();
	        },
	        success: function success(resp) {
	          elsPage.viewSchedConfirmation.html(resp);
	          $("#retry-schedule-pickup").click(retrySchedulePickup);
	          //elsPage.viewSchedCard.slideUp(viewConfirmationSlideDown);
	          elsPage.viewSchedConfirmation.slideDown();
	          elsPage.schedulePickupOptions.hide();
	          if (!resp.includes('Error')) {
	            submitModalFlow.showSuccessModal();
	          }
	          setTimeout(function () {
	            submitModalFlow.hideAllModals();
	          }, _constants.SUCCESS_MODAL_TIMEOUT);
	        },
	        error: function error(xhr, status, _error2) {
	          //TODO when error give the proper response
	          submitModalFlow.hideAllModals();
	        }
	      });
	    }
	  };
	
	  function disableBtn(btn) {
	    btn.addClass("disabled");
	  };
	
	  //Putting this in separate function so event occurs at proper time
	  function viewConfirmationSlideDown() {
	    elsPage.viewSchedConfirmation.slideDown();
	  };
	
	  function retrySchedulePickup() {
	    elsPage.schedulePickupOptions.show();
	    elsPage.viewSchedConfirmation.hide();
	    elsPage.pickupAvailability.show();
	    elsPage.checkSched.hide();
	    elsPage.closeSched.show();
	  };
	};

/***/ },
/* 796 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	
	  "actions": [{
	    title: "Edit",
	    cls: "edit-shipment-method",
	    icon: "pencil",
	    disabled: false
	  }, {
	    title: "Delete",
	    cls: "delete-location",
	    icon: "trash",
	    disabled: false
	  }]
	};

/***/ },
/* 797 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var searchDropdown = exports.searchDropdown = [{
		title: "Custom Shipping String Name",
		value: "shmShipmentMethod"
	}, {
		title: "Shipping Method/Service Level",
		value: "shmShipmentMethodCode"
	}];

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(799);
	
	__webpack_require__(800);

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _filtersutil = __webpack_require__(16);
	
	var _actionOptions = __webpack_require__(796);
	
	var _searchDropdown = __webpack_require__(797);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	var _ = __webpack_require__(2);
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	var actionList = _actionOptions.actionOptions;
	
	var targetSelector = "#CustomShippings-lookup";
	(0, _run2.default)(targetSelector, function () {
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  var lookupTable = $(targetSelector).find("#stringMapping-lookup-wrapper");
	  var dataTableComponentData = $(targetSelector).data("lookup-data");
	  var savedViews = $(targetSelector).data("saved-view");
	  var filterSearchUrl = $(targetSelector).data("filter-search-url");
	  var portletNamespace = $(targetSelector).data("portlet-namespace");
	  var shipmentMethodList = $(targetSelector).data("shipment-method-list");
	  var deleteShipmentMethodUrl = $(targetSelector).data("delete-shipment-method-url");
	  var editShipmentMethodUrl = $(targetSelector).data("new-shipment-method-url");
	  //submitModalFlow.init(); 
	  var exportModal = new _filtersutil.buildExport();
	  var generateExportUrl = $(targetSelector).data("export-url");
	  var targetObject = "";
	
	  var CustomShippingsLookup = new _index2.default({
	
	    target: lookupTable,
	    minWidthClass: "q-min-width-sm-til-md",
	    mobileColumns: [{
	      render: renderActionWrap,
	      orderable: false,
	      class: 'dtc-action-column',
	      title: "Actions"
	    }, {
	      data: "shmShipmentMethod",
	      title: "Custom Shipping String Name"
	    }, {
	
	      data: "shmShipmentMethodCode",
	      render: formatCodeToName,
	      title: "Shipping Method/Service Level"
	    }, {
	      data: "shmAddressType",
	      title: "Address Type"
	    }, {
	      render: formateDate,
	      data: "shmCreatedDate",
	      title: "Created Date"
	    }],
	
	    tableSearch: true,
	    // REQUIRED: search input info
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: targetObject != "" ? targetObject.value[0] : ""
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _searchDropdown.searchDropdown
	    },
	    // OPTIONAL: Set Saved View Array
	    savedViews: savedViews,
	    bulkSelect: false,
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	      // Not required, just to show you can
	      columnDefs: [{}],
	      // Not required, just to show you can
	      order: [[4, 'desc']],
	      columns: [{
	        render: renderActionWrap,
	        orderable: false,
	        class: 'dtc-action-column',
	        title: "Actions",
	        data: "shmId"
	      }, {
	        data: "shmShipmentMethod",
	        title: "Custom Shipping String Name",
	        class: "dtc-min-width-sm"
	      }, {
	        render: formatCodeToName,
	        data: "shmShipmentMethodCode",
	        title: "Shipping Method/Service Level",
	        class: "dtc-min-width-sm"
	      }, {
	        data: "shmAddressType",
	        title: "Address Type",
	        class: "dtc-min-width-sm"
	      }, {
	        render: formateDate,
	        data: "shmCreatedDate",
	        title: "Created Date",
	        class: 'dtc-min-width-sm'
	      }]
	    },
	    paginationData: dataTableComponentData.page,
	
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Custom Shipping String Mapping",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "shippingString"
	    },
	
	    /*	onBulkSelectChange: function() {
	         const selectedRows = releaseOrderLookup.getBulkSelectedData();
	         $("th.dtc-action-column").html(renderActionHeaderWrap());
	         if (selectedRows.length >= 2) {
	           $(".action-header-btn .base-btn").removeClass('disabled');
	         } else {
	           $(".action-header-btn .base-btn").addClass('disabled');
	         }
	       },*/
	
	    onFetch: function onFetch() {
	      var currentData = CustomShippingsLookup.generateData();
	      CustomShippingsLookup.showLoadingOverlay();
	      //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterSearchUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  CustomShippingsLookup.init();
	
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionHeaderWrap() {
	    var statusTarget = actionList["all"];
	    var newRender = void 0;
	    var data = "";
	    var row = "";
	    newRender = (0, _render2.default)(actionHeaderDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row)
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, neededActions(data, row, item));
	    });
	    return renderedList.join("");
	  }
	
	  function neededActions(data, row, item) {
	    console.log(item);
	    var action = {};
	    if (item.title === 'Delete') {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: item.disabled
	      };
	    } else if (item.title === 'Edit') {
	      action = {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: item.disabled
	      };
	    }
	    return action;
	  }
	
	  $('body').on('click', '.delete-location', function (e) {
	    e.preventDefault();
	    if (shallAllowClick(this)) {
	      var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	      var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	      var rowEdit = $(".data-table-component").dataTable().api().row(parent);
	      var submitDeleteModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: 'Delete Shipping String Mapping',
	        confirmModalBody: '\n      <div class="q-pad-all-xl">\n        You have selected to delete this record from your list of active Shipping String Mappings.<br><br>\n        Please select \'Submit\' if you wish to proceed with deleting this record.<br><br>\n        If you wish to keep this record, please select \'Cancel\'.\n      </div>\n      ',
	        confirmModalBtnText: 'Submit',
	        onConfirmClick: function onConfirmClick() {
	          submitDeleteModalFlow.showLoadingModal();
	          deleteShippingString(rowEdit);
	          function deleteShippingString(rowEdit) {
	            var shipmentString = rowEdit.data();
	            location.href = deleteShipmentMethodUrl + '&' + portletNamespace + 'shmShipmentMethod=' + shipmentString.shmShipmentMethod;
	          };
	        }
	      });
	      submitDeleteModalFlow.init();
	      submitDeleteModalFlow.showConfirmModal();
	    }
	  });
	
	  $('body').on('click', '.edit-shipment-method', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    var rowEdit = $(".data-table-component").dataTable().api().row(parent);
	    var shmShipmentMethod = rowEdit.data().shmShipmentMethod;
	    location.href = editShipmentMethodUrl + '&' + portletNamespace + 'shmShipmentMethod=' + shmShipmentMethod;
	  });
	
	  function shallAllowClick(currentObj) {
	    return !$(currentObj).hasClass("disabled");
	  }
	
	  function initExport() {
	    var exportObj = {
	      title: $(targetSelector).data("export-popup-title"),
	      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
	      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent(portletNamespace);
	  }
	  CustomShippingsLookup.init();
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	  function filterSuccessFun(data) {
	    var shipmentMethod = data.content;
	    var page = data.page;
	    CustomShippingsLookup.setNewData(shipmentMethod);
	    CustomShippingsLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    CustomShippingsLookup.hideLoadingOverlay();
	    setExportData(CustomShippingsLookup.generateData());
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(generateExportUrl, currentData);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  initExport();
	  setExportData(CustomShippingsLookup.generateData());
	
	  function errorFun(data) {
	    CustomShippingsLookup.hideLoadingOverlay();
	  }
	
	  function formatCodeToName(data, type, row) {
	    var shipmentMethodName = void 0;
	    if ((0, _general.isPresent)(data)) {
	      shipmentMethodList.forEach(function (shipmentMethod) {
	        if (data == shipmentMethod.cdmValue) shipmentMethodName = shipmentMethod.cdmMeaning;
	      });
	    } else {
	      shipmentMethodName = '-';
	    }
	    return shipmentMethodName;
	  }
	
	  function formateDate(createdDate, type, data) {
	    if (createdDate != null && createdDate != "") {
	      var date = new Date(createdDate); //createdDate is long time format
	      var month = date.getMonth() + 1;
	      var today = new Date();
	      var oneDay = 24 * 60 * 60 * 1000;
	      today.setHours(0, 0, 0, 0);
	      date.setHours(0, 0, 0, 0);
	      var diffDays = Math.floor(Math.abs((today.getTime() - date.getTime()) / oneDay));
	      var friendlyText = "";
	      var datePillHTML = "";
	      if (diffDays < 100) {
	        friendlyText = diffDays.toString() + ' Days Ago';
	        datePillHTML = "<span class='q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md'>" + friendlyText + "</span>";
	      }
	      if (diffDays == 0) {
	        friendlyText = 'Today';
	      } else if (diffDays == 1) {
	        friendlyText = 'Yesterday';
	      }
	      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear() + datePillHTML;
	    } else {
	      return "";
	    }
	  }
	
	  //handleCustomDropdownEvents();
	
	  $("th.dtc-action-column").html(renderActionHeaderWrap());
	});

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _ConfigPanel = __webpack_require__(109);
	
	var _ConfigPanel2 = _interopRequireDefault(_ConfigPanel);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _QuickBtnGroup = __webpack_require__(33);
	
	var _QuickBtnGroup2 = _interopRequireDefault(_QuickBtnGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	//require("./shipmentStringMapping.less");
	// Additional Imports...
	
	//import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
	
	var methodNameHtml = __webpack_require__(1444);
	var mapToShippingTypeHtml = __webpack_require__(1443);
	var targetSelector = "#create-string-form";
	// Modal Html to use
	
	(0, _run2.default)(targetSelector, function (el) {
	  attachStubExample(el);
	});
	
	function attachStubExample(el) {
	  // START: REQUIRED TO LOAD STUB
	  var entryEl = $("<div class='entry-point'></div>");
	  var text = void 0;
	  if (el.data("edit-id") != '') text = 'Edit';else text = 'New';
	  var mainHtml = (0, _render2.default)(__webpack_require__(1445), {
	    methodName: methodNameHtml,
	    mapToShippingType: mapToShippingTypeHtml,
	    text: text,
	    editCheckerRedirect: el.data('cancel-url')
	  });
	  var mainEl = $(mainHtml);
	  $(el).html(entryEl);
	  entryEl.append(mainEl);
	  // END: REQUIRED TO LOAD STUB
	
	  // START: REAL CODE
	  var shipmentMethods = el.data('shipment-methods-list');
	  var serviceLevels = el.data('service-level-list');
	  var saveShippingStringMapping = el.data("url");
	  var lookupLoadUrl = el.data("view-lookup-url");
	  var customEditString = el.data("custom-edit-string");
	  var editCode = el.data("edit-code");
	  var editedShipmentMethod = el.data("edited-shipment-method");
	  var shipmentMethodFlag = el.data("shipment-method-flag");
	  var validateDuplicateCustomShippingStringUrl = el.data("validate-duplicate-custom-string-mapping-url");
	  var isCustomStringDuplicate = void 0;
	  var isCustomStringValid = false;
	  var shipmentMethodBtnFlag = true;
	  var els = {};
	  var elsMap = {
	    shippingMethodBtn: '.shipping-method-btn',
	    serviceLevelsBtn: '.service-levels-btn',
	    shippingMethodSection: '.shipping-method-section',
	    serviceLevelSection: '.service-level-section',
	    saveShippingMethodBtn: '.save-shipping-method-btn',
	    shipmentMethodSelect: '#shipment-method-select',
	    serviceLevelSelect: '#service-level-select'
	  };
	
	  function init() {
	    setElements();
	    bindElements();
	    initConfigPanel();
	    setupEditChecker();
	    // Stack function calls here.
	    renderShipmentMethods();
	    renderServiceLevels();
	    setFieldsForEdit();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	    // Can call multiple setElementsFromScope for multiple elsMap.
	  }
	
	  function bindElements() {
	    els.shippingMethodBtn.on("click", function () {
	      shipmentMethodBtnFlag = true;
	      shippingMethod();
	    });
	
	    els.serviceLevelsBtn.on("click", function () {
	      shipmentMethodBtnFlag = false;
	      serviceLevel();
	    });
	    mainEl.on('blur', '.customeShippingString', valdateCustomShippingString);
	    els.saveShippingMethodBtn.click(saveCustomeStringMappingAfterValidate);
	    els.serviceLevelSection.hide();
	  }
	
	  function setupEditChecker() {
	    _EditChecker2.default.bindCancelButton(".cancel-shipping-method-btn");
	  }
	
	  function saveCustomeStringMappingAfterValidate() {
	    if (isCustomStringValid) {
	      saveCustomeStringMapping();
	    }
	  }
	
	  function valdateCustomShippingString() {
	
	    var customShippingString = $(".customeShippingString").val();
	    var errorMsgEl = el.find("#custom-string-mapping-invalid");
	    var dupMsgEl = el.find("#custom-string-mapping-already-exist");
	    var predefinedShmFScMsgEl = el.find("#custom-string-mapping-predefined-shm-exist");
	    var patternMatcher = new RegExp('[a-zA-Z0-9_\\-\\.,(){}[\\] \]', 'g');
	    var arrmatch = void 0;
	    var charCount = 0;
	    $.ajax({
	      data: {
	        customStringName: customShippingString
	      },
	      url: validateDuplicateCustomShippingStringUrl,
	      dataType: "JSON",
	      type: 'POST',
	      success: function success(data) {
	        isCustomStringDuplicate = data.response;
	        var fscShipmentMethod = data.responseFsc;
	        while ((arrmatch = patternMatcher.exec(customShippingString)) !== null) {
	          charCount++;
	        }
	        if (customShippingString.trim() == "" || customShippingString.length != charCount || customShippingString.length > 100) {
	          isCustomStringValid = false;
	          errorMsgEl.show();
	          dupMsgEl.hide();
	          predefinedShmFScMsgEl.hide();
	          return false;
	        } else if (editedShipmentMethod == "" && isCustomStringDuplicate != "" || editedShipmentMethod != "" && isCustomStringDuplicate != "" && editedShipmentMethod != isCustomStringDuplicate) {
	          isCustomStringValid = false;
	          dupMsgEl.show();
	          errorMsgEl.hide();
	          predefinedShmFScMsgEl.hide();
	          return false;
	        } else if (fscShipmentMethod != "") {
	          isCustomStringValid = false;
	          errorMsgEl.hide();
	          dupMsgEl.hide();
	          predefinedShmFScMsgEl.show();
	          return false;
	        } else {
	          isCustomStringValid = true;
	          errorMsgEl.hide();
	          dupMsgEl.hide();
	          predefinedShmFScMsgEl.hide();
	          return true;
	        }
	      }
	    });
	  }
	
	  function setFieldsForEdit() {
	    if (editedShipmentMethod != "") {
	      $(".customeShippingString").val(customEditString);
	      if (shipmentMethodFlag == true) {
	        els.shippingMethodBtn.addClass('active');
	        shippingMethod();
	        els.shipmentMethodSelect.val(editCode).trigger("change");
	      } else {
	        els.shippingMethodBtn.removeClass('active');
	        els.serviceLevelsBtn.addClass('active');
	        serviceLevel();
	        els.serviceLevelSelect.val(editCode).trigger("change");
	      }
	      $('.shipping-method-btn-toggler-section').hide();
	      els.shipmentMethodSelect.prop("disabled", true);
	      els.serviceLevelSelect.prop("disabled", true);
	    }
	  }
	  function saveCustomeStringMapping() {
	    var submitModalFlow = new SubmitModalFlow({
	      confirmModalTitle: "Save Shipment Method",
	      confirmModalBody: '<div class="q-pad-all-xl">Once this custom shipping method is saved it will be availabe to use for orders. </div>',
	      confirmModalBtnText: "Save",
	      onConfirmClick: function onConfirmClick() {
	        submitModalFlow.showLoadingModal();
	        saveCustomString({ url: saveShippingStringMapping, success: success, error: error });
	
	        function saveCustomString(_ref) {
	          var url = _ref.url,
	              success = _ref.success,
	              error = _ref.error;
	
	          var shippingMethodCode = void 0,
	              shippingMethod = void 0;
	          if (shipmentMethodBtnFlag) {
	            shippingMethodCode = els.shipmentMethodSelect.val();
	            shippingMethod = $("#shipment-method-select option:selected").text();
	          } else {
	            shippingMethodCode = els.serviceLevelSelect.val();
	            shippingMethod = $("#service-level-select option:selected").text();
	          }
	          $.ajax({
	            data: {
	              "shipmentMethodBtnFlag": shipmentMethodBtnFlag,
	              "shippingMethodCode": shippingMethodCode,
	              "customStringName": $(".customeShippingString").val(),
	              "shippingMethod": shippingMethod,
	              "editedShipmentMethod": editedShipmentMethod
	            },
	            url: url,
	            dataType: "JSON",
	            type: 'POST',
	            success: success,
	            error: error
	          });
	        }
	        function success(response) {
	          _EditChecker2.default.setPageClean();
	          if (response.status == "Success") {
	            submitModalFlow.showSuccessModal();
	          } else {
	            submitModalFlow.showFailureModal();
	          }
	          setTimeout(function () {}, 3000);
	          //Redirect to lookup page
	          location.href = lookupLoadUrl;
	        }
	        function error() {
	          submitModalFlow.showFailureModal();
	        }
	      }
	    });
	    submitModalFlow.init();
	    submitModalFlow.showConfirmModal();
	  };
	
	  function renderShipmentMethods() {
	    shipmentMethods.forEach(function (shipmentMethod) {
	      var option = $('<option />');
	      option.attr('value', shipmentMethod.cdmValue).text(shipmentMethod.cdmMeaning);
	      els.shipmentMethodSelect.append(option);
	    });
	  }
	
	  function renderServiceLevels() {
	    $(serviceLevels).each(function () {
	      var option = $('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmMeaning);
	      els.serviceLevelSelect.append(option);
	    });
	  }
	
	  function initConfigPanel() {}
	  // Instantiate config panel here. Component has already been imported at the top.
	
	  //for the quickbtnGroup
	  var shippingMethodBtnGrp = mainEl.find('.shipping-method-btn-toggler');
	  var shippingMethodBtnToggler = new _QuickBtnGroup2.default(shippingMethodBtnGrp, {
	    distributeWidth: true
	  });
	  shippingMethodBtnToggler.init();
	
	  function shippingMethod() {
	    els.shippingMethodSection.show();
	    els.serviceLevelSection.hide();
	  };
	
	  function serviceLevel() {
	    els.serviceLevelSection.show();
	    els.shippingMethodSection.hide();
	  };
	
	  init();
	
	  // END: REAL CODE
	};

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(802);

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _select2able = __webpack_require__(22);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	// Live form from jsp
	(0, _run2.default)("#shippment-tracking-number", function () {
		var el = $("#shippment-tracking-number");
		shipmentTracking(el);
	});
	
	function shipmentTracking(el) {
		$("#tracking-number-select").change(function () {
			var url = el.data("trackinginfo-url");
			var trackingNumber = $('#tracking-number-select :selected').val();
			var retailerId = $('#tracking-info-retailer-id').val();
			var carrier = $('#tracking-info-carrier-name').val();
			$('#shipment-tracking-loader').show();
			$("#tracking-info-div").hide();
	
			$.ajax({
				url: url,
				type: 'POST',
				dataType: 'html',
				data: {
					selectedTrackingNumber: trackingNumber,
					carrier: carrier,
					retailerId: retailerId
				},
				success: function success(resp) {
					if (resp) {
						$('#shipment-tracking-loader').hide();
						console.log('success: ');
						$("#tracking-info-div").html(resp);
						$("#tracking-info-div").show();
					} else {
						$('#shipment-tracking-loader').hide();
						console.log('error: ');
						$("#tracking-info-div").show();
					}
				},
				error: function error(xhr, status, _error) {
					console.log('error 1: ');
					$('#shipment-tracking-loader').hide();
					$("#tracking-info-div").show();
				}
			});
		});
	}

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AdrressTab;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(92);
	// Additional Imports...
	
	var modalHtml = __webpack_require__(11);
	
	
	var elementsMap = {
	  addresstabfaccountry: "#fac-address-tab-country",
	  addresstabfacaddress1: "#fac-address-tab-address1",
	  addresstabfacaddress2: "#fac-address-tab-address2",
	  addresstabfaccity: "#fac-address-tab-city",
	  addresstabfacstate: "#fac-address-tab-state",
	  addresstabfacstatetext: "#fac-address-tab-stateText",
	  addresstabfaczipcode: "#fac-address-tab-zip",
	  addresstabfactimezone: "#fac-address-tab-timezone",
	  addresstabfaccontactname: "#fac-address-tab-contact-name",
	  addresstabfacphonecode: "#fac-address-tab-phone-code",
	  addresstabfacphonenumber: "#fac-address-tab-phone"
	};
	var els = {};
	
	function AdrressTab(wizard) {
	  var self = this;
	  var wizardEl = wizard.getWizardElement();
	
	  var addressTabCountrySelect = (0, _jquery2.default)("#fac-address-tab-country");
	  var countries = wizardEl.data("countries");
	  var defaultCountry = addressTabCountrySelect.data("default-country");
	  var addressTabStatesSelect = (0, _jquery2.default)("#fac-address-tab-state");
	  var mandatoryLabel = wizardEl.find(".mandatory-label");
	  var usaStates = wizardEl.data("us-states");
	  var caProvinces = wizardEl.data("ca-provinces");
	  var countriesPhoneCodeSelect = (0, _jquery2.default)("#fac-address-tab-phone-code");
	  var countriesPhoneCodeList = wizardEl.data("phone-code-list");
	  var phoneNumber = (0, _jquery2.default)("#fac-address-tab-phone");
	  var addressTabTimeZonesSelect = (0, _jquery2.default)("#fac-address-tab-timezone");
	  var timeZones = wizardEl.data("time-zones");
	  var addressTabStateTextDiv = wizardEl.find(".address-tab-stateText-wrapper");
	  var addressTabStateDiv = wizardEl.find(".address-tab-state-wrapper");
	  var addressTabZipCode = wizardEl.find("#fac-address-tab-zip");
	  var addressTabTimeZoneDiv = wizardEl.find(".address-tab-timezone-wrapper");
	  var addressTabEmail = wizardEl.find("#fac-address-tab-email");
	  var facData = wizardEl.data("load-edit-facility");
	  var validationReqdCountries = wizardEl.data("validation-reqd-countries");
	  var countryId = void 0;
	
	  self.init = function () {
	    setElements();
	    loadCountriesList();
	    handleSwitchingStateInput();
	    loadCountriesPhoneCodeList();
	    setPhoneNumberInputMask();
	    addressTabCountrySelect.on('change', handleSwitchingStateInput);
	    countriesPhoneCodeSelect.on('change', phoneCodeChange);
	    loadTimeZones();
	    loadAddressEditForm();
	  };
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardEl);
	  }
	
	  function loadCountriesList() {
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: addressTabCountrySelect,
	      list: countries,
	      valueDataKey: "conId",
	      textDataKey: "conName"
	    });
	    // set default as USA from defaultCountry value
	    addressTabCountrySelect.val(defaultCountry);
	  }
	
	  function handleSwitchingStateInput() {
	    var countryVal = addressTabCountrySelect.find(":selected").val();
	    var isValidCountry = false;
	    var countryValue = '';
	    var checkZipCode = false;
	    (0, _jquery2.default)(countries).each(function () {
	      if (this.conId.toString() === countryVal.toString()) {
	        countryId = this.conPhoneCode.toString();
	        countryValue = this.conCode;
	        if (this.conPostalCodeRequired.toString() === "Y") {
	          checkZipCode = true;
	        }
	        return false;
	      }
	    });
	    if (countryVal === "1") {
	      (0, _jquery2.default)(".fac-address-tab-phone-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States of America +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "2") {
	      (0, _jquery2.default)(".fac-address-tab-phone-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "Canada +1";
	      }).prop("selected", true).trigger("change");
	    } else if (countryVal === "3") {
	      (0, _jquery2.default)(".fac-address-tab-phone-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).text().toString();
	        return text === "United States Minor Outlying Islands +1";
	      }).prop("selected", true).trigger("change");
	    } else {
	      (0, _jquery2.default)(".fac-address-tab-phone-code option").filter(function () {
	        var text = (0, _jquery2.default)(this).val().toString();
	        return text === countryId.toString();
	      }).prop("selected", true).trigger("change");
	    }
	    if (countryVal == "1" || countryVal == "2") {
	      addressTabStateTextDiv.hide();
	      addressTabStateDiv.show();
	      setStates(countryVal);
	      mandatoryLabel.show();
	      // show timeZones only if US or Canada
	      addressTabTimeZoneDiv.show();
	      addressTabZipCode.prop('required', true);
	      setMasks();
	    } else {
	      addressTabStateTextDiv.show();
	      addressTabStateDiv.hide();
	      addressTabTimeZoneDiv.hide();
	      mandatoryLabel.hide();
	      addressTabZipCode.prop('required', false);
	      setUnMasks();
	    }
	
	    (0, _jquery2.default)(validationReqdCountries).each(function () {
	      if (this.cdmValue.toString() === countryValue.toString()) {
	        isValidCountry = true;
	        return false;
	      }
	    });
	    if (isValidCountry) {
	      (0, _jquery2.default)(".country-not-supported-facility").hide();
	    } else {
	      (0, _jquery2.default)(".country-not-supported-facility").show();
	    }
	    var postalCode = (0, _jquery2.default)(".fac-address-tab-zip");
	    var postalCodeLabel = (0, _jquery2.default)(".facility-zip-label");
	    if (checkZipCode) {
	      postalCodeLabel.text('Postal Code *');
	      postalCode.addClass('required');
	      postalCode.prop('required', true);
	    } else {
	      postalCodeLabel.text('Postal Code');
	      postalCode.removeClass('required');
	      postalCode.prop('required', false);
	    }
	  }
	
	  function setMasks() {
	    (0, _jquery2.default)('.fac-address-tab-phone').attr("placeholder", "(999) 999-9999");
	    (0, _jquery2.default)('.fac-address-tab-phone').inputmask({
	      mask: "(999) 999-9999"
	    });
	  }
	
	  function setUnMasks() {
	    (0, _jquery2.default)('.fac-address-tab-phone').removeClass("phoneUS");
	    (0, _jquery2.default)('.fac-address-tab-phone').attr("placeholder", "");
	    (0, _jquery2.default)('.fac-address-tab-phone').inputmask({
	      mask: ""
	    });
	    var val = (0, _jquery2.default)('.fac-address-tab-phone').val();
	    if (val) {
	      var v = val.replace(/[- )(]/g, '');
	      (0, _jquery2.default)('.fac-address-tab-phone').val(v);
	    }
	  }
	
	  function phoneCodeChange() {
	    var phonecode = (0, _jquery2.default)(".fac-address-tab-phone-code").val().toString();
	    if (phonecode === '+1') {
	      setMasks();
	    } else {
	      setUnMasks();
	    }
	  }
	
	  function setStates(countryVal) {
	    // re-initialize states dropdown on every call
	    addressTabStatesSelect.html('');
	    if (countryVal == "1") {
	      (0, _selectorHelpers.setOptionsForSelect)({
	        selectElement: addressTabStatesSelect,
	        list: usaStates,
	        valueDataKey: "cdmValue",
	        textDataKey: "cdmMeaning"
	      });
	    } else if (countryVal == "2") {
	      (0, _selectorHelpers.setOptionsForSelect)({
	        selectElement: addressTabStatesSelect,
	        list: caProvinces,
	        valueDataKey: "cdmValue",
	        textDataKey: "cdmMeaning"
	      });
	    }
	  }
	
	  function loadCountriesPhoneCodeList() {
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: countriesPhoneCodeSelect,
	      list: countriesPhoneCodeList,
	      valueDataKey: "conPhoneCode",
	      textDataKey: "conPhoneText"
	    });
	    // set US Phone code as default
	    countriesPhoneCodeSelect.val("+1");
	  }
	
	  // validate the phoneNumber for "+1" phone code
	  //phoneNumber.on('focusout', function(e){
	  //setPhoneCodeValidation($(this).val());
	  //});
	
	  function setPhoneCodeValidation(data) {
	    if (countriesPhoneCodeSelect.val() == "+1") {
	      phoneNumber.addClass("phoneUS");
	    } else {
	      phoneNumber.removeClass("phoneUS");
	    }
	  }
	
	  // add the mask to phoneNumber
	  function setPhoneNumberInputMask() {
	    phoneNumber.inputmask({
	      mask: "(999) 999-9999"
	    });
	  }
	
	  // validate email address
	  addressTabEmail.on('focusout', function (e) {
	    addressTabEmail.addClass("pattern");
	  });
	
	  function loadTimeZones() {
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: addressTabTimeZonesSelect,
	      list: timeZones,
	      valueDataKey: "cdmValue",
	      textDataKey: "cdmMeaning"
	    });
	  }
	
	  function loadAddressEditForm() {
	    if (facData != null && facData != '') {
	      if (facData.facAddressLine1 != null) {
	        els.addresstabfacaddress1.val(facData.facAddressLine1);
	      }
	      if (facData.facAddressLine2 != null) {
	        els.addresstabfacaddress2.val(facData.facAddressLine2);
	      }
	      if (facData.facCity != null) {
	        els.addresstabfaccity.val(facData.facCity);
	      }
	      if (facData.facZipcode != null) {
	        els.addresstabfaczipcode.val(facData.facZipcode);
	      }
	      if (facData.facPhoneCode != null) {
	        els.addresstabfacphonecode.val(facData.facPhoneCode);
	      }
	      if (facData.facContactPhone != null) {
	        els.addresstabfacphonenumber.val(facData.facContactPhone);
	      }
	      if (facData.facContactName != null) {
	        els.addresstabfaccontactname.val(facData.facContactName);
	      }
	      if (facData.facContactEmail != null) {
	        addressTabEmail.val(facData.facContactEmail);
	      }
	
	      addressTabCountrySelect.find('option[value=' + facData.facCountry + ']').prop('selected', 'selected').trigger('change');
	      if (facData.facCountry == "1" || facData.facCountry == "2" || facData.facCountry == "US" || facData.facCountry == "CA") {
	        els.addresstabfacstate.find('option[value=' + facData.facState + ']').prop('selected', 'selected').trigger('change');
	      } else {
	        els.addresstabfacstatetext.val(facData.facState);
	      }
	
	      if (facData.facTimeZone != null) {
	        addressTabTimeZonesSelect.val(facData.facTimeZone).trigger('change');
	      }
	
	      if (facData.facPhoneCode != null) {
	        countriesPhoneCodeSelect.val(facData.facPhoneCode);
	      }
	    }
	  }
	}

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = CalendarTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	__webpack_require__(92);
	// Additional Imports...
	
	var elementsMap = {
	  dayShift: ".day-shift",
	  dayShiftCheckbox: ".day-shift-checkbox"
	};
	var els = {};
	
	function CalendarTab(wizard) {
	  var self = this;
	  var wizardEl = wizard.getWizardElement();
	  var facData = wizardEl.data("load-edit-facility"); //get the facility data from DB to load edit form
	  var calendarTimes = [];
	  if (!(0, _underscore2.default)(facData).isEmpty()) {
	    calendarTimes = facData.facilitiesCalendarSet;
	  }
	
	  var shiftTimes = {
	    monday: [],
	    tuesday: [],
	    wednesday: [],
	    thursday: [],
	    friday: [],
	    saturday: [],
	    sunday: []
	  };
	  var selectedShiftTimes = {};
	  var selectedDays = {};
	  // Enable it when we have the Edit flow 
	  var savedShiftTimes = {};
	
	  calendarTimes.map(function (day) {
	    savedShiftTimes["" + day.facCalendarDay.toLowerCase()] = [{
	      from: "" + day.facCalendarStartTime,
	      to: "" + day.facCalendarEndTime
	    }];
	  });
	
	  self.init = function () {
	    setElements();
	    bindElements();
	    instantiateCalendarArea();
	  };
	
	  function instantiateCalendarArea() {
	    els.dayShift.each(function (index, el) {
	      var $el = $(el);
	      var checkBox = $el.find('.day-shift-checkbox');
	      var dayOfWeek = $el.data('day-of-week');
	      var timePickerArea = $el.find('.time-picker-area');
	      var timeFrom = (0, _timePicker2.default)(timePickerArea.find('.time-picker-from'));
	      var timeTo = (0, _timePicker2.default)(timePickerArea.find('.time-picker-to'));
	      shiftTimes[dayOfWeek].push({ timeFrom: timeFrom, timeTo: timeTo });
	      if (!savedShiftTimes.hasOwnProperty(dayOfWeek)) {
	        timeFrom.disableTimePicker();
	        timeTo.disableTimePicker();
	      }
	
	      if (savedShiftTimes[dayOfWeek] && savedShiftTimes[dayOfWeek].length > 0) {
	        shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
	        timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
	        timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
	        checkBox.trigger('click');
	      }
	    });
	  }
	
	  self.getCalendarShiftTimes = function () {
	    Object.keys(shiftTimes).forEach(function (key) {
	      if (selectedDays[key]) {
	        selectedShiftTimes[key] = shiftTimes[key].map(function (el) {
	          return {
	            from: el.timeFrom.getMilitaryTime(),
	            to: el.timeTo.getMilitaryTime()
	          };
	        });
	      } else {
	        delete selectedShiftTimes[key];
	      }
	    });
	    return selectedShiftTimes;
	  };
	
	  self.showInvalidShiftError = function (dayArr) {
	    els.dayShift.each(function (index, el) {
	      var $el = $(el);
	      var dayOfWeek = $el.data('day-of-week');
	      var error = $el.find('.time-picker-error');
	      if ((0, _underscore2.default)(dayArr).contains(dayOfWeek)) {
	        error.css('display', 'block');
	      } else {
	        error.css('display', 'none');
	      }
	    });
	  };
	
	  function setElements() {
	    // set Elements for time picker objects
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardEl);
	  }
	
	  function bindElements() {
	    els.dayShiftCheckbox.on("click", handleDayShiftCheckboxChange);
	  }
	
	  function handleDayShiftCheckboxChange() {
	    var isChecked = $(this).is(':checked');
	    var dayOfWeek = $(this).closest('.day-shift').data('day-of-week');
	    if (isChecked) {
	      shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
	      shiftTimes[dayOfWeek][0].timeTo.enableTimePicker();
	      selectedDays[dayOfWeek] = isChecked;
	    } else {
	      shiftTimes[dayOfWeek][0].timeFrom.resetTime();
	      shiftTimes[dayOfWeek][0].timeTo.resetTime();
	      shiftTimes[dayOfWeek][0].timeFrom.disableTimePicker();
	      shiftTimes[dayOfWeek][0].timeTo.disableTimePicker();
	      $(this).closest('.day-shift').find('.time-picker-error').css('display', 'none');
	      delete selectedDays[dayOfWeek];
	    }
	  }
	}

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _general = __webpack_require__(5);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var _ = __webpack_require__(2);
	var reviewCalendarRows = __webpack_require__(315);
	var facCertNamesTemplateHtml = __webpack_require__(316);
	var reviewSquareFootageHtml = __webpack_require__(1447);
	var utilizationPillTemplateHtml = __webpack_require__(1448);
	
	(0, _run2.default)("#spl-facilities-detailinfo-page", function (mainEl) {
	  var editSPLFacilityId = mainEl.data("facility");
	  var editSplFacilityUrl = mainEl.data("edit-splfacility-url");
	  var portletNamespace = mainEl.data("portlet-namespace");
	  var editSplFacilityBtn = mainEl.find(".edit-splfacility");
	  var facViewJsonData = mainEl.data("facilityviewjson");
	  var sqFtArea = mainEl.find("#facility-square-footage");
	  var sfFtNotSetMsg = mainEl.find("#square-footage-not-set");
	  var calendarNotSetMsg = mainEl.find(".calendar-view-not-set-msg");
	  var calendarSetDiv = mainEl.find("#view-calendar-shift-times");
	  var certNotSetMsg = mainEl.find("#detailsinfo-fac-no-cert-names");
	  var certSetdiv = mainEl.find("#detailsinfo-fac-cert-names");
	  var activateSplFacilityBtn = mainEl.find(".activate-facility-btn");
	  var deactivateSplFacilityBtn = mainEl.find(".deactivate-facility-btn");
	  var changeFacilityStatusUrl = mainEl.data("change-status-url");
	  var pageReloadUrl = mainEl.data("detail-page-reload-url");
	  var facilityAttributes = [];
	
	  editSplFacilityBtn.on("click", function (e) {
	    e.preventDefault();
	    location.href = editSplFacilityUrl + '&' + portletNamespace + 'facilityIdForEdit=' + editSPLFacilityId;
	  });
	
	  //Display calendar on details page in 12hrs format.
	  if (facViewJsonData != null && facViewJsonData != "" && facViewJsonData.facilitiesCalendarSet != null && facViewJsonData.facilitiesCalendarSet != "") {
	    var viewcalendarRowHtml = [];
	    var viewcalendarTimes = [];
	    var savedCalendarForDetails = new Map();
	
	    viewcalendarTimes = facViewJsonData.facilitiesCalendarSet;
	    viewcalendarTimes.map(function (day) {
	      savedCalendarForDetails.set(day.facCalendarSequenceId, day.facCalendarDay);
	    });
	
	    var sortedCalMapAsc = new Map([].concat(_toConsumableArray(savedCalendarForDetails.entries())).sort()); //holds sorted calendar days
	    sortedCalMapAsc.forEach(function (value, key) {
	      viewcalendarTimes.map(function (day) {
	        if (value == day.facCalendarDay) {
	          viewcalendarRowHtml.push((0, _render2.default)(reviewCalendarRows, {
	            key: _('' + day.facCalendarDay.toUpperCase()).capitalize(),
	            shiftTime: (0, _general.militaryToPeriodTime)('' + day.facCalendarStartTime) + ' - ' + (0, _general.militaryToPeriodTime)('' + day.facCalendarEndTime)
	          }));
	        }
	      });
	    });
	    calendarSetDiv.append(viewcalendarRowHtml.join(""));
	    calendarNotSetMsg.hide();
	  } else {
	    calendarNotSetMsg.show();
	    calendarSetDiv.hide();
	  }
	
	  //Display certificates on details page.
	
	  if (facViewJsonData != null && facViewJsonData != "" && facViewJsonData.facilitiesAttributesSet != null && facViewJsonData.facilitiesAttributesSet != "") {
	    var facAttributesData = new Set(facViewJsonData.facilitiesAttributesSet);
	    var savedCertificatesForDetails = []; //holds certificates in the order of insertion by user on ui.
	    var savedCertFromDBForDetails = new Map();
	    var savedCertSwitcheryVal = "no";
	    var savedFacUse = [];
	
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = facAttributesData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var keyval = _step.value;
	
	        var arr_names = new Array(keyval);
	        for (var j = 0; j < arr_names.length; j++) {
	          var attrName = void 0;
	          var attrValue = void 0;
	          var attrId = void 0;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = Object.keys(arr_names[j])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var k = _step2.value;
	
	              if (k == "faaKey") {
	                attrName = arr_names[j][k];
	              } else if (k == "faaValue") {
	                attrValue = arr_names[j][k];
	              } else if (k == "faaId") {
	                attrId = arr_names[j][k];
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          if (attrName != null && attrValue != null) {
	            if (attrName == "FAC_CERTIFICATES_FLAG_ATTR") {
	              if (attrValue == "yes") {
	                savedCertSwitcheryVal = attrValue;
	              }
	            } else if (attrName == "FAC_CERTIFICATE_ATTR") {
	              savedCertFromDBForDetails.set(attrId, attrValue);
	            } else if (attrName == "FAC_USE_ATTR") {
	              savedFacUse.push(attrValue);
	            }
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    if (savedCertSwitcheryVal == "yes") {
	      if (savedCertFromDBForDetails != null) {
	        var sortedCertMapAsc = new Map([].concat(_toConsumableArray(savedCertFromDBForDetails.entries())).sort());
	        sortedCertMapAsc.forEach(function (value, key) {
	          savedCertificatesForDetails.push(value);
	        });
	      }
	      var certificatesnames = savedCertificatesForDetails.map(function (certificatename) {
	        return (0, _render2.default)(facCertNamesTemplateHtml, {
	          text: certificatename
	        });
	      });
	
	      certSetdiv.append(certificatesnames.join(''));
	      certNotSetMsg.hide();
	    } else {
	      certNotSetMsg.show();
	    }
	
	    //facility uses logic to display on detailsinfo page.   
	    var detailsinfofcyusedivtags = [];
	    var hidefcyuses = [];
	    detailsinfofcyusedivtags = mainEl.find(".fcyuse-detailsinfo-div");
	    _.each(detailsinfofcyusedivtags, function (el) {
	      if (el.id.indexOf('-yes') > -1) {
	        (0, _jquery2.default)(el).hide();
	      }
	      if (el.id.indexOf('-no') > -1) {
	        (0, _jquery2.default)(el).show();
	      }
	    });
	
	    var expectedId = void 0;
	    _.each(savedFacUse, function (val) {
	      val = val.replace(" ", "");
	      expectedId = 'detailsinfo-facuse-' + val + '-yes';
	
	      _.each(detailsinfofcyusedivtags, function (el) {
	
	        if (expectedId == el.id) {
	          expectedId = expectedId.replace("yes", "no");
	          hidefcyuses.push(expectedId);
	          (0, _jquery2.default)(el).show();
	        }
	      });
	    });
	    _.each(hidefcyuses, function (val) {
	      val = val.replace(" ", "");
	      _.each(detailsinfofcyusedivtags, function (el) {
	        if (val == el.id) {
	          (0, _jquery2.default)(el).hide();
	        }
	      });
	    });
	  }
	
	  if (!_(facViewJsonData.facilitiesAttributesSet).isEmpty()) {
	    facilityAttributes = facViewJsonData.facilitiesAttributesSet;
	  }
	
	  var squareFootageAvailableData = facilityAttributes.filter(function (facility) {
	    return facility.faaKey.match(/FAC_AVAILABLE/g);
	  });
	  var squareFootageTotalData = facilityAttributes.filter(function (facility) {
	    return facility.faaKey.match(/FAC_TOTAL/g);
	  });
	  var squareFootageUtilizedData = facilityAttributes.filter(function (facility) {
	    return facility.faaKey.match(/FAC_UTILIZED/g);
	  });
	  var totalAvailable = squareFootageAvailableData.concat(squareFootageTotalData).concat(squareFootageUtilizedData);
	  var ambientList = totalAvailable.filter(function (facAttr) {
	    return facAttr.faaKey.match(/AMBIENT/g);
	  });
	  var coolerList = totalAvailable.filter(function (facAttr) {
	    return facAttr.faaKey.match(/COOLER/g);
	  });
	  var freezerList = totalAvailable.filter(function (facAttr) {
	    return facAttr.faaKey.match(/FREEZER/g);
	  });
	  var tempControlledList = totalAvailable.filter(function (facAttr) {
	    return facAttr.faaKey.match(/CONTROLLED_ROOM_TEMPERATURE/g);
	  });
	  var masterSqFootData = [ambientList, tempControlledList, coolerList, freezerList];
	  var sqFtMap = [];
	
	  masterSqFootData.map(function (data) {
	    if (data.length > 0) {
	      sqFtMap.push(normalizeSqFootageData(data));
	    }
	  });
	
	  var sqFtDataHtml = sqFtMap.map(function (sqFtRow) {
	    return (0, _render2.default)(reviewSquareFootageHtml, {
	      sqFtHeader: sqFtRow.sqFtHeader,
	      total: sqFtRow.total,
	      available: sqFtRow.available,
	      utilizationPill: renderUtilizationPill(sqFtRow.utilized)
	    });
	  });
	
	  if (sqFtMap.length) {
	    sqFtArea.html(sqFtDataHtml.join(""));
	    sfFtNotSetMsg.hide();
	  } else {
	    sfFtNotSetMsg.show();
	    sqFtArea.html("");
	  }
	
	  function normalizeSqFootageData(data) {
	    var sqFtRowData = [];
	    data.map(function (dataEl) {
	      var sqFtHeader = _(dataEl.faaKey.split('_').splice(2, 1).join("")).capitalize();
	      var category = dataEl.faaKey.split('_').splice(1, 1).join("");
	      if (sqFtHeader == 'Controlled') {
	        sqFtHeader = 'Controlled Room Temperature';
	      }
	      var sqFtObject = {};
	      sqFtObject.sqFtHeader = sqFtHeader;
	      sqFtObject[category.toLowerCase()] = dataEl.faaValue;
	      sqFtRowData.push(sqFtObject);
	    });
	    var finalNormalized = _extends({}, sqFtRowData[0], sqFtRowData[1], sqFtRowData[2]);
	    return finalNormalized;
	  }
	
	  function renderUtilizationPill(utilization) {
	    var pillClass = utilization > 100 ? 'q-pill-red' : 'q-pill-white-and-blue';
	    return (0, _render2.default)(utilizationPillTemplateHtml, {
	      pillClass: pillClass,
	      utilization: utilization
	    });
	  }
	
	  function deactiveFacilitySuccess(data) {
	    if (data.status === "Success") {
	      var detailUrlFullURL = pageReloadUrl;
	      deActivateFacilityModal.showSuccessModal();
	      setTimeout(function () {
	        location.href = detailUrlFullURL;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    } else {
	      deActivateFacilityModal.showFailureModal();
	    }
	  }
	
	  function deactiveFacilityError() {
	    deActivateFacilityModal.hideAllModals();
	  }
	
	  var deActivateFacilityModal = null;
	  deactivateSplFacilityBtn.on("click", function (e) {
	    e.preventDefault();
	    deActivateFacilityModal = new SubmitModalFlow({
	      confirmModalTitle: 'Deactivate Facility',
	      confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
	      confirmModalBtnText: 'Deactivate Facility',
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        deActivateFacilityModal.showLoadingModal();
	        handleFacilityActivateDeactivate({ url: changeFacilityStatusUrl, input: '0', success: deactiveFacilitySuccess, error: deactiveFacilityError });
	      }
	    });
	    deActivateFacilityModal.init();
	    deActivateFacilityModal.showConfirmModal();
	  });
	
	  activateSplFacilityBtn.on("click", function (e) {
	    e.preventDefault();
	    deActivateFacilityModal = new SubmitModalFlow({
	      confirmModalTitle: 'Activate Facility',
	      confirmModalBody: '<div class="q-pad-all-xl">Once updated, these changes will be reflected throughout the application.</div>',
	      confirmModalBtnText: 'Activate Facility',
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        deActivateFacilityModal.showLoadingModal();
	        handleFacilityActivateDeactivate({ url: changeFacilityStatusUrl, input: '1', success: deactiveFacilitySuccess, error: deactiveFacilityError });
	      }
	    });
	    deActivateFacilityModal.init();
	    deActivateFacilityModal.showConfirmModal();
	  });
	
	  function handleFacilityActivateDeactivate(_ref) {
	    var url = _ref.url,
	        input = _ref.input,
	        success = _ref.success,
	        error = _ref.error;
	
	    _jquery2.default.ajax({
	      url: url,
	      data: { "status": input },
	      dataType: "JSON",
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	});

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DetailsTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _util = __webpack_require__(34);
	
	var _general = __webpack_require__(5);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _timePicker = __webpack_require__(38);
	
	var _timePicker2 = _interopRequireDefault(_timePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/*
	  Base file for stub.
	  This is where all the actual stub code will go.
	*/
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	__webpack_require__(92);
	
	// Additional Imports...
	//import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
	
	//const modalHtml = require("../../sharedHtml/modal.html");
	var certificateRowHtml = __webpack_require__(1446);
	
	var elementsMap = {
	  detailsfacleasedropdown: ".fac-leased-select",
	  detailsfacowneddropdown: ".fac-owned-select",
	  facilityCode: "#fac-code",
	  detailsfacname: "#fac-name",
	  detailsfacbldgno: "#fac-bldgno",
	  detailsfacbusunit: "#fsc-business-unit",
	  detailsfacgolivedate: ".facility-go-live-date",
	  detailsfacleasedradio: ".leased",
	  detailsfacownedradio: ".owned",
	  detailsfacleasedselect: ".fac-leased-select",
	  detailsfacownedselect: ".fac-owned-select",
	  detailsfaccloseddate: "#facility-closed-date-parent",
	  detailsfacdefaultcert: ".first-certificate"
	
	};
	var els = {};
	
	function DetailsTab(wizard) {
	  var self = this;
	  var wizardEl = wizard.getWizardElement();
	  var addCertificateBtn = wizardEl.find("#add-certificate");
	
	  // HB-11242 - Load all data from controller
	  var fscBusinessUnits = wizardEl.data("fsc-businesss-units");
	  var facilityOwners = wizardEl.data("facility-owners");
	  var facilityLessee = wizardEl.data("facility-lessee");
	  var fscBusinessUnitSelect = wizardEl.find(".fsc-business-unit");
	  var fscFacilityLesseeSelect = wizardEl.find(".fac-leased-select");
	  var fscFacilityOwnerSelect = wizardEl.find(".fac-owned-select");
	  var fscOwenershipRadio = wizardEl.find(".ownership-radio");
	  var fscLeasedRadio = wizardEl.find(".leased");
	  var fscOwenedRadio = wizardEl.find(".owned");
	  var splFacilityEl = $('#standard-platform-facility-setup-wizard');
	  var facCodeCheckUrl = splFacilityEl.attr("data-fac-code-check-url");
	  var facCertificateSwitch = wizardEl.find("#fac-certificate-switch");
	  var facData = wizardEl.data("load-edit-facility"); //get the facility data from DB to load edit form
	  var facId = 0;
	
	  self.init = function () {
	    setElements();
	    load();
	    bindElements();
	    loadEditForm(); //load saved facilities back to form 
	  };
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardEl);
	  }
	
	  function load() {
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: fscBusinessUnitSelect,
	      list: fscBusinessUnits,
	      valueDataKey: "cdmMeaning",
	      textDataKey: "cdmDescription"
	    });
	
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: fscFacilityLesseeSelect,
	      list: facilityLessee,
	      valueDataKey: "cdmMeaning",
	      textDataKey: "cdmDescription"
	    });
	
	    (0, _selectorHelpers.setOptionsForSelect)({
	      selectElement: fscFacilityOwnerSelect,
	      list: facilityOwners,
	      valueDataKey: "cdmMeaning",
	      textDataKey: "cdmDescription"
	    });
	  }
	
	  function bindElements() {
	    els.facilityCode.on("keyup", hideErrorMsg);
	    els.facilityCode.on("blur", validateFacilityCode);
	  }
	
	  addCertificateBtn.on('click', function (e) {
	    addCertificates(e);
	  });
	
	  fscOwenershipRadio.on('change', function (e) {
	    e.preventDefault();
	
	    if (fscLeasedRadio.is(":checked")) {
	      fscFacilityLesseeSelect.prop('disabled', false);
	      fscFacilityOwnerSelect.prop('disabled', true);
	      els.detailsfacowneddropdown.val("").trigger('change');
	    } else if (fscOwenedRadio.is(":checked")) {
	      fscFacilityLesseeSelect.prop('disabled', true);
	      fscFacilityOwnerSelect.prop('disabled', false);
	      els.detailsfacleasedropdown.val("").trigger('change');
	    }
	    return true;
	  });
	
	  //added to hide certificate error message when switchery is OFF.
	  facCertificateSwitch.on('change', function (e) {
	    if (!facCertificateSwitch.is(":checked")) {
	      $("#facility-certifications-error").hide();
	    }
	  });
	
	  function addCertificates(e) {
	    e.preventDefault();
	
	    var countElement = $('#certificates').length || 0;
	    var certificateRow = (0, _render2.default)(certificateRowHtml, {
	      highestId: countElement
	    });
	    wizardEl.find("#certificate-div").append(certificateRow);
	  }
	
	  $('#certificate-div').on('click', '.remove_certficate_row', function (e) {
	    e.preventDefault();
	    if ($(this).hasClass('first-certificate-remove')) {
	      //clear value 
	      els.detailsfacdefaultcert.val("");
	    } else {
	      $(this).closest('.certificate').remove();
	    }
	  });
	
	  function hideErrorMsg() {
	    var facCode = els.facilityCode.val();
	    if ((0, _util.isNullOrUndefined)(facCode) || (0, _general.isBlank)(facCode)) {
	      splFacilityEl.find('#dup-facCode').hide();
	    }
	  }
	
	  function validateFacilityCode() {
	    var facCode = els.facilityCode.val();
	    if (!(0, _util.isNullOrUndefined)(facCode) && !(0, _general.isBlank)(facCode)) {
	      $.ajax({
	        data: {
	          splFacilityCode: facCode,
	          splFacilityId: facId
	        },
	        url: facCodeCheckUrl,
	        dataType: "JSON",
	        type: 'POST',
	        success: function success(data) {
	          if (data.response == true) {
	            splFacilityEl.find('#dup-facCode').show();
	            return false;
	          } else {
	            splFacilityEl.find('#dup-facCode').hide();
	            return true;
	          }
	        }
	      });
	    }
	  }
	
	  //Load saved facility DB values on form for edit purpose.
	
	  function loadEditForm() {
	    var ownership = void 0;
	    var owner = void 0;
	
	    if (facData != null && facData != '') {
	      facId = facData.facId;
	      els.detailsfacname.val(facData.facName);
	      els.facilityCode.val(facData.facCode);
	      els.detailsfacbldgno.val(facData.facBuildingNumber);
	      if (facData.facBusinessUnit != null) {
	        els.detailsfacbusunit.val(facData.facBusinessUnit);
	      }
	
	      //Iterate through attributes rows.
	
	      var facAttributesData = new Set(facData.facilitiesAttributesSet);
	      var savedCertificates = []; //holds certificates in the order of insertion by user on ui.
	      var savedCertFromDB = new Map(); //newresearch
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = facAttributesData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var keyval = _step.value;
	
	          var arr_names = new Array(keyval);
	          for (var j = 0; j < arr_names.length; j++) {
	            var attrName = void 0;
	            var attrValue = void 0;
	            var attrId = void 0; //newresearch
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = Object.keys(arr_names[j])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var k = _step2.value;
	
	                if (k == "faaKey") {
	                  attrName = arr_names[j][k];
	                } else if (k == "faaValue") {
	                  attrValue = arr_names[j][k];
	                } else if (k == "faaId") {
	                  //newresearch             
	                  attrId = arr_names[j][k];
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	
	            if (attrName != null && attrValue != null) {
	              if (attrName == "FAC_OWNERSHIP_ATTR") {
	                ownership = attrValue;
	                if (attrValue == "Leased") {
	                  els.detailsfacleasedradio.prop('checked', true);
	                  if (!(0, _general.isBlank)(owner)) {
	                    els.detailsfacleasedselect.val(owner);
	                    fscFacilityLesseeSelect.prop('disabled', false);
	                  }
	                } else if (attrValue == "Owned") {
	                  els.detailsfacownedradio.prop('checked', true);
	                  if (!(0, _general.isBlank)(owner)) {
	                    els.detailsfacownedselect.val(owner);
	                    fscFacilityOwnerSelect.prop('disabled', false);
	                  }
	                }
	              } else if (attrName == "FAC_OWNER_ATTR") {
	                owner = attrValue;
	                if (ownership == "Leased") {
	                  els.detailsfacleasedselect.val(attrValue);
	                  fscFacilityLesseeSelect.prop('disabled', false);
	                } else if (ownership == "Owned") {
	                  els.detailsfacownedselect.val(attrValue);
	                  fscFacilityOwnerSelect.prop('disabled', false);
	                }
	              } else if (attrName == "FAC_CERTIFICATES_FLAG_ATTR") {
	                if (attrValue == "yes") {
	                  (0, _instantiateSwitchery.instantiateSwitchery)(facCertificateSwitch, true);
	                  (0, _instantiateSwitchery.setSwitchery)(facCertificateSwitch, true);
	                }
	              } else if (attrName == "FAC_YARD_MANAGEMENT_ATTR") {
	                if (attrValue == "yes") {
	                  $('#yardmanagement').prop("checked", true);
	                }
	              } else if (attrName == "FAC_ACCEPT_INBOUND_APPOINTMENT_ATTR") {
	                if (attrValue == "yes") {
	                  $('#inboundappointment').prop("checked", true);
	                }
	              } else if (attrName == "FAC_CERTIFICATE_ATTR") {
	                //savedCertificates.push(attrValue);
	                savedCertFromDB.set(attrId, attrValue); //newresearch   
	              }
	            }
	          }
	        }
	
	        //newresearch   - starts
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      if (savedCertFromDB != null) {
	        var sortedCertMapAsc = new Map([].concat(_toConsumableArray(savedCertFromDB.entries())).sort());
	
	        sortedCertMapAsc.forEach(function (value, key) {
	          savedCertificates.push(value);
	        });
	      }
	
	      if (savedCertificates.length > 0) {
	        if (savedCertificates.length == 1) {
	          els.detailsfacdefaultcert.val(savedCertificates[0]);
	        } else {
	          var index = 0;
	          savedCertificates.forEach(function (value) {
	            if (index == 0) {
	              els.detailsfacdefaultcert.val(savedCertificates[index]);
	            } else {
	              addCertificateBtn.click();
	              $("input[name='certificate']").each(function () {
	                if ((0, _general.isBlank)($(this).val())) {
	                  $(this).val(savedCertificates[index]);
	                }
	              });
	            }
	            index++;
	          });
	        }
	      }
	    }
	  }
	}

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(810);
	
	__webpack_require__(92);
	
	__webpack_require__(805);

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = OperationsTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	__webpack_require__(92);
	// Additional Imports...
	
	var modalHtml = __webpack_require__(11);
	
	
	var elementsMap = {
	  operationsfacbldtype: ".fac-building-type",
	  operationsfacuses: ".fac-use-ops-section",
	  operatonsfacceilinght: "#ceiling-height",
	  operationsfacinshipdocks: "#ded-inbound-shipment",
	  operationsfacoutshipdocks: "#ded-outbound-shipment",
	  operationsfacshareddocks: "#shared-docks",
	  operationsfacambient: "#AMBIENT",
	  operationsfaccontrolled: "#CONTROLLED_ROOM_TEMPERATURE",
	  operationsfaccooler: "#COOLER",
	  operationsfacfreezer: "#FREEZER",
	  operationsfactotalambient: "#total-sqfoot-AMBIENT",
	  operationsfacsumtotal: "#sum-total-sqfoot",
	  operationsfacsumavail: "#sum-available-sqfoot",
	  operationsfacsumutilize: "#sum-utilized-space",
	  operationsfacavailambient: "#available-sqfoot-AMBIENT",
	  operationsfacutilizeambient: "#utilized-space-AMBIENT",
	  operationsfactotalcontrl: "#total-sqfoot-CONTROLLED_ROOM_TEMPERATURE",
	  operationsfacavailcontrl: "#available-sqfoot-CONTROLLED_ROOM_TEMPERATURE",
	  operationsfacutilizecontrl: "#utilized-space-CONTROLLED_ROOM_TEMPERATURE",
	  operationsfactotalcooler: "#total-sqfoot-COOLER",
	  operationsfacavailcooler: "#available-sqfoot-COOLER",
	  operationsfacutilizecooler: "#utilized-space-COOLER",
	  operationsfactotalfreezer: "#total-sqfoot-FREEZER",
	  operationsfacavailfreezer: "#available-sqfoot-FREEZER",
	  operationsfacutilizefreezer: "#utilized-space-FREEZER"
	};
	var els = {};
	
	function OperationsTab(wizard) {
	  var self = this;
	  var wizardEl = wizard.getWizardElement();
	  var totalSqFtElement = wizardEl.find(".total-sqfoot");
	  var sumOfTotalSqFtElement = wizardEl.find("#sum-total-sqfoot");
	  var facilitySpaceCheckBox = wizardEl.find(".fac-space-name");
	  var availableSqFtElement = wizardEl.find(".available-sqfoot");
	  var sumOfAvailableSqFtElement = wizardEl.find("#sum-available-sqfoot");
	  var sumUtilizationSpace = wizardEl.find("#sum-utilized-space");
	  var facData = wizardEl.data("load-edit-facility");
	
	  self.init = function () {
	    setElements();
	    load();
	    loadOperationsEditForm(); //load saved facilities back to form 
	  };
	
	  function load() {}
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardEl);
	  }
	
	  facilitySpaceCheckBox.on('change', function (e) {
	    e.preventDefault();
	
	    var totalSqFtEl = '#total-sqfoot-' + e.target.id;
	    var avlSqFtEl = '#available-sqfoot-' + e.target.id;
	    var errorEL = '#total-sqfoot-' + e.target.id + '-error';
	
	    if ($(this).is(":checked")) {
	      $(totalSqFtEl).prop('disabled', false);
	      $(totalSqFtEl).prop('required', true);
	    } else {
	      $(totalSqFtEl).prop('required', false);
	      $(errorEL).hide();
	      $(avlSqFtEl).val('');
	      $(totalSqFtEl).prop('disabled', true).val('');
	      $(totalSqFtEl).blur();
	      //calculateTotalSqFt(e);
	    }
	  });
	
	  totalSqFtElement.on('blur', function (e) {
	
	    var avlSqFtEl = '#' + e.target.id;
	    avlSqFtEl = avlSqFtEl.replace('total-sqfoot-', 'available-sqfoot-');
	    $(avlSqFtEl).val($(this).val());
	    calculateTotalSqFt(e);
	  });
	
	  function calculateTotalSqFt(e) {
	    e.preventDefault();
	    var totalSqFtVal = 0;
	    totalSqFtElement.each(function () {
	      totalSqFtVal += Number($(this).val());
	    });
	    if (totalSqFtVal == '0') {
	      sumOfTotalSqFtElement.val('');
	    } else {
	      sumOfTotalSqFtElement.val(totalSqFtVal);
	    }
	
	    calculateAvailableSqFt(e);
	    calculateSpaceUtilization(e);
	  }
	
	  function calculateAvailableSqFt(e) {
	    e.preventDefault();
	    var totalAvlSqFtVal = 0;
	    availableSqFtElement.each(function () {
	      totalAvlSqFtVal += Number($(this).val());
	    });
	
	    if (totalAvlSqFtVal == '0') {
	      sumOfAvailableSqFtElement.val('');
	    } else {
	      sumOfAvailableSqFtElement.val(totalAvlSqFtVal);
	    }
	  }
	  function calculateSpaceUtilization(e) {
	    e.preventDefault();
	
	    var totalSqFtEl = '#' + e.target.id;
	    var avlSqFtEl = totalSqFtEl.replace('total-sqfoot-', 'available-sqfoot-');
	    var utlSpacePerEl = totalSqFtEl.replace('total-sqfoot-', 'utilized-space-');
	    var utilizationSpace = void 0;
	    var utilizationPercent = void 0;
	
	    if (!(0, _general.isBlank)($(totalSqFtEl).val()) && !(0, _general.isBlank)($(avlSqFtEl).val()) && !isNaN($(totalSqFtEl).val()) && !isNaN($(avlSqFtEl).val())) {
	      utilizationSpace = Number($(totalSqFtEl).val()) - Number($(avlSqFtEl).val());
	    }
	    if (utilizationSpace === undefined) {} else if (!isNaN(utilizationSpace) && !(0, _general.isBlank)($(totalSqFtEl).val())) {
	      utilizationPercent = utilizationSpace / Number($(totalSqFtEl).val());
	    }
	
	    if (utilizationPercent === undefined || isNaN(utilizationPercent)) {
	      $(utlSpacePerEl).val('');
	    } else if (!isNaN(utilizationPercent)) {
	      $(utlSpacePerEl).val(utilizationPercent * 100);
	    }
	
	    if ((0, _general.isBlank)(sumOfTotalSqFtElement.val()) && (0, _general.isBlank)(sumOfAvailableSqFtElement.val())) {
	      sumUtilizationSpace.val('');
	    } else {
	      sumUtilizationSpace.val((Number(sumOfTotalSqFtElement.val()) - Number(sumOfAvailableSqFtElement.val())) / Number(sumOfTotalSqFtElement.val()) * 100);
	    }
	  }
	
	  function cancelSetupWizard() {
	    window.location.href = els.cancelBtnUrl.data('redirect-to-url');
	  }
	
	  function loadOperationsEditForm() {
	    if (facData != null && facData != '') {
	      var facAttributesData = new Set(facData.facilitiesAttributesSet);
	
	      if (facData.facBuildingType != null) {
	        _underscore2.default.each(els.operationsfacbldtype, function (el) {
	          var ele = $(el);
	          if (ele.val() == facData.facBuildingType) {
	            ele.prop('checked', true);
	          }
	        });
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = facAttributesData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var keyval = _step.value;
	
	          var arr_names = new Array(keyval);
	
	          var _loop = function _loop(j) {
	            var attrName = void 0;
	            var attrValue = void 0;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = Object.keys(arr_names[j])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var k = _step2.value;
	
	                if (k == "faaKey") {
	                  attrName = arr_names[j][k];
	                } else if (k == "faaValue") {
	                  attrValue = arr_names[j][k];
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	
	            if (attrName != null && attrValue != null) {
	              if (attrName == "FAC_USE_ATTR") {
	                var fcyuseselement = wizardEl.find('.fac-use-ops-box');
	                _underscore2.default.each(fcyuseselement, function (el) {
	                  var ele = $(el);
	                  if (ele.val() == attrValue) {
	                    ele.prop('checked', true);
	                  }
	                });
	              } else if (attrName == "FAC_CEILING_HEIGHT_ATTR") {
	                els.operatonsfacceilinght.val(attrValue);
	              } else if (attrName == "FAC_INBOUND_SHIP_DOCKS_ATTR") {
	                els.operationsfacinshipdocks.val(attrValue);
	              } else if (attrName == "FAC_OUTBOUND_SHIP_DOCKS_ATTR") {
	                els.operationsfacoutshipdocks.val(attrValue);
	              } else if (attrName == "FAC_SHARED_DOCKS_ATTR") {
	                els.operationsfacshareddocks.val(attrValue);
	              } else if (attrName == "FAC_TOTAL_AMBIENT_ATTR") {
	                els.operationsfacambient.prop('checked', true).trigger('change');
	                els.operationsfactotalambient.val(attrValue);
	              } else if (attrName == "FAC_AVAILABLE_AMBIENT_ATTR") {
	                els.operationsfacavailambient.val(attrValue);
	              } else if (attrName == "FAC_UTILIZED_AMBIENT_ATTR") {
	                els.operationsfacutilizeambient.val(attrValue);
	              } else if (attrName == "FAC_TOTAL_CONTROLLED_ROOM_TEMPERATURE_ATTR") {
	                els.operationsfaccontrolled.prop('checked', true).trigger('change');
	                els.operationsfactotalcontrl.val(attrValue);
	              } else if (attrName == "FAC_AVAILABLE_CONTROLLED_ROOM_TEMPERATURE_ATTR") {
	                els.operationsfacavailcontrl.val(attrValue);
	              } else if (attrName == "FAC_UTILIZED_CONTROLLED_ROOM_TEMPERATURE_ATTR") {
	                els.operationsfacutilizecontrl.val(attrValue);
	              } else if (attrName == "FAC_TOTAL_COOLER_ATTR") {
	                els.operationsfaccooler.prop('checked', true).trigger('change');
	                els.operationsfactotalcooler.val(attrValue);
	              } else if (attrName == "FAC_AVAILABLE_COOLER_ATTR") {
	                els.operationsfacavailcooler.val(attrValue);
	              } else if (attrName == "FAC_UTILIZED_COOLER_ATTR") {
	                els.operationsfacutilizecooler.val(attrValue);
	              } else if (attrName == "FAC_TOTAL_FREEZER_ATTR") {
	                els.operationsfacfreezer.prop('checked', true).trigger('change');
	                els.operationsfactotalfreezer.val(attrValue);
	              } else if (attrName == "FAC_AVAILABLE_FREEZER_ATTR") {
	                els.operationsfacavailfreezer.val(attrValue);
	              } else if (attrName == "FAC_UTILIZED_FREEZER_ATTR") {
	                els.operationsfacutilizefreezer.val(attrValue);
	              } else if (attrName == "FAC_SUM_TOTAL_ATTR") {
	                els.operationsfacsumtotal.val(attrValue);
	              } else if (attrName == "FAC_SUM_AVAILABLE_ATTR") {
	                els.operationsfacsumavail.val(attrValue);
	              } else if (attrName == "FAC_SUM_UTILIZED_ATTR") {
	                els.operationsfacsumutilize.val(attrValue);
	              }
	            }
	          };
	
	          for (var j = 0; j < arr_names.length; j++) {
	            _loop(j);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }
	}

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReviewTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	__webpack_require__(92);
	// Additional Imports...
	
	var facCertNamesTemplateHtml = __webpack_require__(316);
	var reviewCalendarRows = __webpack_require__(315);
	var submitModal = void 0;
	var facilityObj = {}; //preparedataforsubmit
	
	
	//HB-12294
	var elementsMap = {
	  srcDetTabFacName: "#fac-name",
	  destReviewTabFacName: "#destination-tab-fac-name",
	  srcDetTabFacCode: "#fac-code",
	  destReviewTabFacCode: "#destination-tab-fac-code",
	  srcDetTabFacBldgNo: "#fac-bldgno",
	  destReviewTabFacBldgNo: "#destination-tab-fac-bldgno",
	  srcDetTabFacBusUnit: "#fsc-business-unit",
	  destReviewTabFacBusUnit: "#destination-tab-fsc-business-unit",
	  srcDetTabFacOwn: "#facilitySharedAction",
	  destReviewTabFacOwnership: "#destination-tab-fsc-Ownership",
	  srcDetTabFacLeese: "#facility-lessee",
	  srcDetTabFacOwner: "#facility-owner",
	  destReviewTabFacOwnershipVal: "#destination-tab-fsc-OwnLbl",
	  destReviewTabFacOwner: "#destination-tab-fsc-Owner",
	  srcDetTabFacGoLiveDateParent: "#facility-go-live-date-parent",
	  destReviewTabFacGoLiveDate: "#destination-tab-fac-go-live-date",
	  srcDetTabFacClosedDateParent: "#facility-closed-date-parent",
	  destReviewTabFacClosedDate: "#destination-tab-fac-closed-date",
	  srcDetTabFacCertificationSwitch: "#fac-certificate-switch",
	  destReviewTabFacCertificates: "#destination-tab-fac-cert-names",
	  destReviewTabFacNoCertificates: "#destination-tab-fac-no-cert-names",
	  srcDetTabFacYrdMgmt: "#yardmanagement",
	  destReviewTabFacYrdMgmtYes: "#destination-tab-yard-management-yes",
	  destReviewTabFacYrdMgmtNo: "#destination-tab-yard-management-no",
	  srcDetTabFacInboundAppt: "#inboundappointment",
	  destReviewTabFacInboundApptYes: "#destination-tab-inbound-appointment-yes",
	  destReviewTabFacInboundApptNo: "#destination-tab-inbound-appointment-no",
	  srcAddTabFacCountry: "#fac-address-tab-country",
	  destReviewTabFacCountry: "#destination-tab-fac-country",
	  srcAddTabFacAddress1: "#fac-address-tab-address1",
	  destReviewTabFacAddress1: "#destination-tab-fac-address1",
	  srcAddTabFacAddress2: "#fac-address-tab-address2",
	  destReviewTabFacAddress2: "#destination-tab-fac-address2",
	  srcAddTabFacCity: "#fac-address-tab-city",
	  srcAddTabFacState: "#fac-address-tab-state",
	  srcAddTabFacStateText: "#fac-address-tab-stateText",
	  srcAddTabFacZipCode: "#fac-address-tab-zip",
	  destReviewTabFacCityStateZip: "#destination-tab-fac-citystatezip",
	  srcAddTabFacTimeZone: "#fac-address-tab-timezone",
	  destReviewTabFacTimeZone: "#destination-tab-fac-timezone",
	  srcAddTabFacContactName: "#fac-address-tab-contact-name",
	  destReviewTabFacContactName: "#destination-tab-fac-contactname",
	  srcAddTabFacPhonecode: "#fac-address-tab-phone-code",
	  srcAddTabFacPhoneNumber: "#fac-address-tab-phone",
	  destReviewTabFacPhoneNumber: "#destination-tab-fac-phonenumber",
	  srcAddTabFacEmail: "#fac-address-tab-email",
	  destReviewTabFacEmail: "#destination-tab-fac-email",
	  srcOpsTabFacBldType: ".fac-building-type",
	  destReviewTabFacBldgType: "#destination-tab-fac-bldg-type",
	  srcOpsTabFacUses: ".fac-use-ops-section",
	  destReviewTabFacUses: ".fcyuse-review-div",
	  srcOpsTabFacInShipDocks: "#ded-inbound-shipment",
	  destReviewTabFacInShipDocks: "#destination-tab-ded-inbound-ship-docks",
	  srcOpsTabFacOutShipDocks: "#ded-outbound-shipment",
	  destReviewTabFacOutShipDocks: "#destination-tab-ded-outound-ship-docks",
	  srcOpsTabFacSharedDocks: "#shared-docks",
	  destReviewTabFacSharedDocks: "#destination-tab-shared-docks",
	  srcOpsTabFacCeilingHt: "#ceiling-height",
	  destReviewTabFacCeilingHt: "#destination-tab-ceiling-height",
	  destReviewTabFacSqrfootage: ".fcy-sqr-footage",
	  srcOpsTabFcySqrFootage: ".fac-sqr-footage",
	  destReviewTabNoSqrFootage: "#destination-tab-no-sqr-footage",
	  destReviewTabSqrFootageSection: "#destination-tab-sqrfootsection",
	  reviewCalendarRowsDiv: "#review-calendar-shift-times",
	  reviewCalendarNotSetMsg: ".calendar-not-set-msg",
	  reviewCalendarHeader: ".review-calendar-header",
	  submitFacilityButton: ".submit-facility-setup-wizard"
	};
	var els = {};
	
	function ReviewTab(wizard) {
	  var self = this;
	  var wizardEl = wizard.getWizardElement();
	  var submitURL = wizardEl.data("submit-spl-facility");
	  var detailURL = wizardEl.data("facility-detail-url");
	  var facData = wizardEl.data("load-edit-facility"); //get the facility data from DB to load edit form
	  var shiftTimes = void 0;
	
	  //HB-12294 
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardEl);
	  }
	
	  self.init = function () {
	    setElements();
	    generateModals();
	    bindElements();
	  };
	
	  function bindElements() {
	    els.submitFacilityButton.on('click', showSubmitModal);
	  }
	
	  function generateModals() {
	    submitModal = new _SubmitModalFlow2.default({
	      confirmModalTitle: 'Save Facility',
	      confirmModalBody: '<div class="q-pad-all-xl">Once you have saved this facility, it can be referenced throughout the application.</div>',
	      confirmModalBtnText: 'Save',
	      modalDialogClass: "q-modal-dialog-500",
	      onConfirmClick: function onConfirmClick() {
	        submitModal.showLoadingModal();
	        $.ajax({
	          data: {
	            splFacilityData: JSON.stringify(facilityObj)
	          },
	          url: submitURL,
	          dataType: "JSON",
	          type: 'POST',
	          success: submitFacilitySuccess,
	          error: submitFacilityError
	        });
	      }
	
	    });
	    submitModal.init();
	  };
	
	  function submitFacilitySuccess(resp) {
	    var facilityId = resp.data;
	    _EditChecker2.default.setPageClean();
	    submitModal.showSuccessModal();
	    setTimeout(function () {
	      var facilityDetailURL = detailURL + "&facilityId=" + facilityId;
	      window.location.href = facilityDetailURL;
	    }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	  }
	
	  function submitFacilityError() {
	    submitModal.showFailureModal();
	  }
	
	  function showSubmitModal(e) {
	    e.preventDefault();
	    submitModal.showConfirmModal();
	  }
	  self.fillReviewCalendarArea = function (shiftsFromCalendarTab) {
	    shiftTimes = shiftsFromCalendarTab;
	    if (!(0, _underscore2.default)(shiftTimes).isEmpty()) {
	      renderCalenderRows(shiftTimes);
	      els.reviewCalendarNotSetMsg.hide();
	      els.reviewCalendarHeader.show();
	      els.reviewCalendarRowsDiv.show();
	    } else {
	      els.reviewCalendarRowsDiv.hide();
	      els.reviewCalendarHeader.hide();
	      els.reviewCalendarNotSetMsg.show();
	    }
	  };
	
	  self.fillReviewElementsWithVals = function () {
	    fillDetailsElementsWithVals(); //Populate review tab with details tab values
	    fillAddressElementsWithVals(); //Populate review tab with address tab values
	    fillOperationsElementsWithVals(); //Populate review tab with operations tab values
	  };
	
	  function renderCalenderRows() {
	    var calendarRowHtml = [];
	    var calendarMap = new Map();
	    var dayTimings = [];
	
	    Object.keys(shiftTimes).forEach(function (key) {
	
	      dayTimings = [];
	
	      dayTimings.push(shiftTimes[key][0].from);
	      dayTimings.push(shiftTimes[key][0].to);
	      calendarMap.set((0, _underscore2.default)(key), dayTimings);
	
	      calendarRowHtml.push((0, _render2.default)(reviewCalendarRows, {
	        key: (0, _underscore2.default)(key).capitalize(),
	        shiftTime: (0, _general.militaryToPeriodTime)(shiftTimes[key][0].from) + " - " + (0, _general.militaryToPeriodTime)(shiftTimes[key][0].to)
	      }));
	    });
	    els.reviewCalendarRowsDiv.html(calendarRowHtml.join(""));
	
	    facilityObj.facCalendar = calendarMap;
	  }
	
	  function fillDetailsElementsWithVals() {
	    var fscOwenershipRadio = wizardEl.find(".ownership-radio");
	    var fscLeasedRadio = wizardEl.find(".leased");
	    var fscOwenedRadio = wizardEl.find(".owned");
	
	    els.destReviewTabFacName.text(els.srcDetTabFacName.val());
	    els.destReviewTabFacCode.text(els.srcDetTabFacCode.val());
	    els.destReviewTabFacBldgNo.text(els.srcDetTabFacBldgNo.val());
	    els.destReviewTabFacBusUnit.text(els.srcDetTabFacBusUnit.val());
	
	    //preparedataforsubmit
	    facilityObj.facName = els.srcDetTabFacName.val();
	    facilityObj.facCode = els.srcDetTabFacCode.val();
	    facilityObj.facBldgNo = els.srcDetTabFacBldgNo.val();
	    facilityObj.facBusUnit = els.srcDetTabFacBusUnit.val();
	
	    //Set ownership value to label field and dropdown value to respective valueholder
	
	    if (fscOwenershipRadio.is(":checked")) {
	      if (fscLeasedRadio.is(":checked")) {
	        els.destReviewTabFacOwnership.text(fscLeasedRadio.val() + ":");
	        els.destReviewTabFacOwnershipVal.text("Lessee:");
	        els.destReviewTabFacOwner.text(els.srcDetTabFacLeese.val());
	        facilityObj.facOwnership = fscLeasedRadio.val();
	        facilityObj.facOwner = els.srcDetTabFacLeese.val();
	      } else if (fscOwenedRadio.is(":checked")) {
	        els.destReviewTabFacOwnership.text(fscOwenedRadio.val() + ":");
	        els.destReviewTabFacOwnershipVal.text("Owner:");
	        els.destReviewTabFacOwner.text(els.srcDetTabFacOwner.val());
	        facilityObj.facOwnership = fscOwenedRadio.val();
	        facilityObj.facOwner = els.srcDetTabFacOwner.val();
	      }
	    }
	
	    els.destReviewTabFacGoLiveDate.text(els.srcDetTabFacGoLiveDateParent.find(".facility-go-live-date").val());
	    els.destReviewTabFacClosedDate.text(els.srcDetTabFacClosedDateParent.find(".facility-closed-date").val());
	
	    facilityObj.facGoLiveDate = els.destReviewTabFacGoLiveDate.text();
	    facilityObj.facClosedDate = els.destReviewTabFacClosedDate.text();
	    facilityObj.facCertificateSwitch = "no";
	    facilityObj.facCertificates = "";
	
	    //If certificates switchery is selected, get all the certificate names and append to review tab as row
	
	    if (els.srcDetTabFacCertificationSwitch.is(":checked")) {
	      var certificates = [];
	      els.destReviewTabFacNoCertificates.hide();
	      els.destReviewTabFacCertificates.text("");
	
	      $("input[name='certificate']").each(function () {
	        certificates.push($(this).val());
	      });
	
	      facilityObj.facCertificateSwitch = "yes";
	      facilityObj.facCertificates = certificates;
	
	      var certificatesnames = certificates.map(function (certificatename) {
	        return (0, _render2.default)(facCertNamesTemplateHtml, {
	          text: certificatename
	        });
	      });
	      els.destReviewTabFacCertificates.append(certificatesnames.join(''));
	    } else {
	      els.destReviewTabFacNoCertificates.show();
	    }
	
	    //Additional information
	
	    if (els.srcDetTabFacYrdMgmt.is(":checked")) {
	      els.destReviewTabFacYrdMgmtYes.show();
	      els.destReviewTabFacYrdMgmtNo.hide();
	      facilityObj.facYrdMgmt = "yes";
	    } else {
	      els.destReviewTabFacYrdMgmtYes.hide();
	      els.destReviewTabFacYrdMgmtNo.show();
	      facilityObj.facYrdMgmt = "no";
	    }
	
	    if (els.srcDetTabFacInboundAppt.is(":checked")) {
	      els.destReviewTabFacInboundApptYes.show();
	      els.destReviewTabFacInboundApptNo.hide();
	      facilityObj.facInboundAppt = "yes";
	    } else {
	      els.destReviewTabFacInboundApptYes.hide();
	      els.destReviewTabFacInboundApptNo.show();
	      facilityObj.facInboundAppt = "no";
	    }
	  }
	
	  function fillAddressElementsWithVals() {
	    if (els.srcAddTabFacCountry.find(":selected").text() == "United States of America" || els.srcAddTabFacCountry.find(":selected").text() == "Canada") {
	      els.destReviewTabFacCityStateZip.text(els.srcAddTabFacCity.val() + " " + els.srcAddTabFacState.val() + " " + els.srcAddTabFacZipCode.val());
	
	      facilityObj.facCity = els.srcAddTabFacCity.val();
	      facilityObj.facState = els.srcAddTabFacState.val();
	      facilityObj.facZipCode = els.srcAddTabFacZipCode.val();
	    } else {
	      els.destReviewTabFacCityStateZip.text(els.srcAddTabFacCity.val() + " " + els.srcAddTabFacStateText.val() + " " + els.srcAddTabFacZipCode.val());
	
	      facilityObj.facCity = els.srcAddTabFacCity.val();
	      facilityObj.facState = els.srcAddTabFacStateText.val();
	      facilityObj.facZipCode = els.srcAddTabFacZipCode.val();
	    }
	    els.destReviewTabFacAddress1.text(els.srcAddTabFacAddress1.val());
	    els.destReviewTabFacAddress2.text(els.srcAddTabFacAddress2.val());
	    els.destReviewTabFacCountry.text(els.srcAddTabFacCountry.find(":selected").text());
	    els.destReviewTabFacTimeZone.text(els.srcAddTabFacTimeZone.val());
	    els.destReviewTabFacContactName.text(els.srcAddTabFacContactName.val());
	    els.destReviewTabFacPhoneNumber.text(els.srcAddTabFacPhonecode.val() + " " + els.srcAddTabFacPhoneNumber.val());
	    els.destReviewTabFacEmail.text(els.srcAddTabFacEmail.val());
	
	    facilityObj.facAddress1 = els.srcAddTabFacAddress1.val();
	    facilityObj.facAddress2 = els.srcAddTabFacAddress2.val();
	    facilityObj.facCountry = els.srcAddTabFacCountry.find(":selected").val();
	    facilityObj.facTimeZone = els.srcAddTabFacTimeZone.val();
	    facilityObj.facContactName = els.srcAddTabFacContactName.val();
	    facilityObj.facPhoneCode = els.srcAddTabFacPhonecode.val();
	    facilityObj.facPhone = els.srcAddTabFacPhoneNumber.val();
	    facilityObj.facEmail = els.srcAddTabFacEmail.val();
	  }
	
	  function fillOperationsElementsWithVals() {
	    var opsfcyusecheckboxes = [];
	    var reviewfcyusedivtags = [];
	    var srcId = void 0;
	    var showNoSqrfootage = true;
	    var sqrFootId = void 0;
	
	    //Populate Building type
	
	    _underscore2.default.each(els.srcOpsTabFacBldType, function (el) {
	      if ($(el).is(":checked")) {
	        els.destReviewTabFacBldgType.text($(el).val() + ":");
	        facilityObj.facBuildingType = $(el).val();
	      }
	    });
	
	    //Populate facility uses section on review tab
	
	    //By default on review page, hide div-yes and show div-no for all fcy use fields.
	
	    reviewfcyusedivtags = els.destReviewTabFacUses;
	    _underscore2.default.each(reviewfcyusedivtags, function (el) {
	      if (el.id.indexOf('-yes') > -1) {
	        $(el).hide();
	      }
	      if (el.id.indexOf('-no') > -1) {
	        $(el).show();
	      }
	    });
	
	    //get ops tab fcy uses objects to work with
	    opsfcyusecheckboxes = els.srcOpsTabFacUses.find('.fac-use-ops-box');
	
	    var selectedFacUse = [];
	    var index = 0;
	
	    //get review tab fcy uses objects to work with.  
	    _underscore2.default.each(opsfcyusecheckboxes, function (el) {
	
	      if ($(el).is(":checked")) {
	        var ele = $(el);
	        srcId = el.id;
	        selectedFacUse[index] = ele.val();
	        index++;
	        _underscore2.default.each(reviewfcyusedivtags, function (elr) {
	          var eler = $(elr);
	          if (elr.id.indexOf(srcId) > -1 && elr.id.indexOf('-yes') > -1) {
	            eler.show();
	          }
	          if (elr.id.indexOf(srcId) > -1 && elr.id.indexOf('-no') > -1) {
	            eler.hide();
	          }
	        });
	      }
	    });
	
	    facilityObj.facUse = selectedFacUse;
	
	    if (els.srcOpsTabFacCeilingHt.val() != '') {
	      els.destReviewTabFacCeilingHt.text(els.srcOpsTabFacCeilingHt.val() + " ft.");
	      facilityObj.facCeilingHt = els.srcOpsTabFacCeilingHt.val();
	    }
	    if (els.srcOpsTabFacInShipDocks.val() != '') {
	      els.destReviewTabFacInShipDocks.text(els.srcOpsTabFacInShipDocks.val());
	      facilityObj.facInShipDocks = els.srcOpsTabFacInShipDocks.val();
	    } else {
	      els.destReviewTabFacInShipDocks.text(0);
	      facilityObj.facInShipDocks = "0";
	    }
	
	    if (els.srcOpsTabFacOutShipDocks.val() != '') {
	      els.destReviewTabFacOutShipDocks.text(els.srcOpsTabFacOutShipDocks.val());
	      facilityObj.facOutShipDocks = els.srcOpsTabFacOutShipDocks.val();
	    } else {
	      els.destReviewTabFacOutShipDocks.text(0);
	      facilityObj.facOutShipDocks = "0";
	    }
	
	    if (els.srcOpsTabFacSharedDocks.val() != '') {
	      els.destReviewTabFacSharedDocks.text(els.srcOpsTabFacSharedDocks.val());
	      facilityObj.facSharedDocks = els.srcOpsTabFacSharedDocks.val();
	    } else {
	      els.destReviewTabFacSharedDocks.text(0);
	      facilityObj.facSharedDocks = "0";
	    }
	
	    //populate square footage section
	    var srqFootageMap = new Map();
	
	    //Check to see if any values are entered.
	    _underscore2.default.each(els.srcOpsTabFcySqrFootage, function (el) {
	      if ($(el).val() != '') {
	        showNoSqrfootage = false;
	      }
	    });
	
	    if (showNoSqrfootage) {
	      els.destReviewTabNoSqrFootage.show();
	      els.destReviewTabSqrFootageSection.hide();
	    } else {
	      els.destReviewTabNoSqrFootage.hide();
	      els.destReviewTabSqrFootageSection.show();
	      _underscore2.default.each(els.srcOpsTabFcySqrFootage, function (el) {
	        _underscore2.default.each(els.destReviewTabFacSqrfootage, function (elr) {
	          if (el.id == elr.id) {
	            if (el.id.indexOf('utilized-space-') < 0 && el.id.indexOf('sum-utilized-space') < 0) {
	              if ($(el).val() != '') {
	                $(elr).text($(el).val() + " " + "sq. ft.");
	              } else {
	                $(elr).text('');
	              }
	            } else {
	              if ($(el).val() != '') {
	                $(elr).text($(el).val() + "% Utilization");
	              } else {
	                $(elr).text('');
	              }
	            }
	            if ($(el).val() != '') {
	              sqrFootId = el.id;
	              sqrFootId = sqrFootId.replace("total-sqfoot-", "TOTAL_");
	              sqrFootId = sqrFootId.replace("available-sqfoot-", "AVAILABLE_");
	              sqrFootId = sqrFootId.replace("utilized-space-", "UTILIZED_");
	              sqrFootId = sqrFootId.replace("sum-available-sqfoot", "SUM_AVAILABLE");
	              sqrFootId = sqrFootId.replace("sum-total-sqfoot", "SUM_TOTAL");
	              sqrFootId = sqrFootId.replace("sum-utilized-space", "SUM_UTILIZED");
	              srqFootageMap.set(sqrFootId, $(el).val());
	            }
	          }
	        });
	      });
	    }
	
	    facilityObj.facSqrFootage = srqFootageMap;
	
	    if (facData != null && facData != '') {
	      if (facData.facDeactiveActive == null) {
	        facilityObj.facActive = "1";
	      } else {
	        facilityObj.facActive = facData.facDeactiveActive;
	      }
	    }
	  }
	}

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _detailsTab = __webpack_require__(806);
	
	var _detailsTab2 = _interopRequireDefault(_detailsTab);
	
	var _addressTab = __webpack_require__(803);
	
	var _addressTab2 = _interopRequireDefault(_addressTab);
	
	var _operationsTab = __webpack_require__(808);
	
	var _operationsTab2 = _interopRequireDefault(_operationsTab);
	
	var _reviewTab = __webpack_require__(809);
	
	var _reviewTab2 = _interopRequireDefault(_reviewTab);
	
	var _calendarTab = __webpack_require__(804);
	
	var _calendarTab2 = _interopRequireDefault(_calendarTab);
	
	var _QuickWizard = __webpack_require__(31);
	
	var _QuickWizard2 = _interopRequireDefault(_QuickWizard);
	
	var _AddressValidation = __webpack_require__(36);
	
	var _AddressValidation2 = _interopRequireDefault(_AddressValidation);
	
	var _general = __webpack_require__(5);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	// For quick dev prototyping
	(0, _run2.default)("#standard-platform-facility-setup-wizard", function (mainEl) {
	  attachWizard(mainEl);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  _EditChecker2.default.bindNavigation();
	  _EditChecker2.default.bindChangeListener("#standard-platform-facility-setup-wizard");
	  _EditChecker2.default.bindChangeListener("span.select2");
	  _EditChecker2.default.bindCancelButton("#spl-cancel-url");
	}
	
	function attachWizard(el) {
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      var appendTo = $(element).data('error-placement-append-to');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else if (appendTo) {
	        $(appendTo).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	    // Place all your validation rules here!!!
	    // rules: {
	    // }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	  var quickWizard = new _QuickWizard2.default(el, {
	    tabletWidthNavStep: 1090,
	    mobileWidthNavStep: 950,
	    customRules: {
	      ".facility-uses-section": {
	        errorMessageSelector: "#details-tab-fac-ownership-error",
	        isValid: function isValid(validSelection, done) {
	          if (validSelection) {
	            var checked = $(".facility-uses-section input:radio:checked").length > 0;
	
	            if (!checked) {
	              done(false, { displayErrors: true });
	            } else {
	              done(true, { displayErrors: true });
	            }
	          } else {
	            done(true, { displayErrors: true });
	          }
	          return done;
	        }
	      }
	    },
	    shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	      var targetForm = _ref.targetForm,
	          direction = _ref.direction,
	          currentForm = _ref.currentForm,
	          done = _ref.done;
	
	      // Any time we go traverse backwards, just let us
	      if (currentForm.filter(".sp-calendar-tab").length) {
	        if (targetForm.filter(".sp-details-tab").length) {
	          direction = "BACKWARDS";
	        }
	      }
	
	      if (direction === "BACKWARDS") {
	        return true;
	      }
	
	      if (currentForm.filter(".sp-details-tab").length) {
	        areInputsValid(true, function (validResult) {
	          handleInputsForDetailsTab(validResult, done);
	        });
	      } else if (currentForm.filter(".sp-address-tab").length) {
	        areInputsValid(true, function (validResult) {
	          handleInputsFinishedValidatingForAddressTab(validResult, done);
	        });
	      } else if (currentForm.filter(".sp-calendar-tab").length) {
	        areInputsValid(true, function (validResult) {
	          handleInputsForCalendarTab(validResult, done);
	        });
	      } else {
	        areInputsValid(true, done);
	      }
	
	      function handleInputsForCalendarTab(validResult, cb) {
	        if (validResult) {
	          var selectedRows = calendarTab.getCalendarShiftTimes();
	          var wrongDays = [];
	          Object.keys(selectedRows).forEach(function (key) {
	            var timeFrom = selectedRows[key][0].from;
	            var timeTo = selectedRows[key][0].to;
	            if (timeFrom == 'Invalid date' || timeTo == 'Invalid date') {
	              wrongDays.push(key);
	            }
	            if (timeFrom != 'Invalid date' && timeTo != 'Invalid date') {
	              var fromMoment = (0, _general.convertMilitaryToInt)(timeFrom);
	              var toMoment = (0, _general.convertMilitaryToInt)(timeTo);
	              if (toMoment < fromMoment) {
	                wrongDays.push(key);
	              }
	            }
	          });
	          if (wrongDays.length > 0) {
	            calendarTab.showInvalidShiftError(wrongDays);
	            cb(false);
	          } else {
	            $(".time-picker-error").css('display', 'none');
	            cb(true);
	          }
	        } else {
	          cb(validResult);
	        }
	      }
	
	      function areInputsValid(shouldContinue, cb) {
	        var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	        var notValid = !quickWizard.areInputsValid(allPrevInputs, { displayErrors: true });
	        if (notValid || !shouldContinue) {
	          if (notValid) {
	            quickWizard.goToFirstIncompleteForm();
	          }
	          cb(false);
	        } else {
	          cb(true);
	        }
	      }
	
	      function handleInputsFinishedValidatingForAddressTab(validResult, cb) {
	        if (validResult) {
	          addressValidation.determineAddressValidity(function (useAddress) {
	            if (useAddress) {
	              // need below logic for edit flow
	              //const validatedAddress = addressValidation.getAddressResponse();
	              //hiddenAddressInput.val(JSON.stringify(validatedAddress));
	              cb(true);
	            } else {
	              cb(false);
	            }
	          });
	        } else {
	          cb(validResult);
	        }
	      }
	      function handleInputsForDetailsTab(validResult, cb) {
	        if (validResult) {
	          var ownershipRadio = false;
	          var selectBoxAndRadioFlag = false;
	          var certificateSwitchEl = $(".certification-switch");
	
	          //If facCode is invalid, do not allow user to navigate to next tab.
	          if ($("#dup-facCode").is(":visible")) {
	            cb(false);
	            return false;
	          }
	
	          //Ownership radio Validations
	          $(".ownership-radio").each(function () {
	            if ($(this).is(":checked")) {
	              ownershipRadio = true;
	            }
	          });
	          if (!ownershipRadio) {
	            $("#details-tab-fac-ownership-error").show();
	            cb(false);
	          } else {
	            $("#details-tab-fac-ownership-error").hide();
	          }
	
	          //Ownership select box Validations
	          if ($(".leased").is(":checked")) {
	            if ($(".fac-leased-select").val()) {
	              selectBoxAndRadioFlag = true;
	            }
	          } else if ($(".owned").is(":checked")) {
	            if ($(".fac-owned-select").val()) {
	              selectBoxAndRadioFlag = true;
	            }
	          }
	          if (ownershipRadio && !selectBoxAndRadioFlag) {
	            $("#details-tab-fac-ownership-dropdown-error").show();
	            cb(false);
	          } else {
	            $("#details-tab-fac-ownership-dropdown-error").hide();
	          }
	
	          //Facility Certifications Validations
	          if (certificateSwitchEl.is(":checked")) {
	            var isvalid = true;
	            $("input[name='certificate']").each(function () {
	              if ($(this).val() == '') {
	                isvalid = false;
	              }
	            });
	            if (!isvalid) {
	              $("#facility-certifications-error").show();
	              cb(false);
	            } else {
	              $("#facility-certifications-error").hide();
	              cb(true);
	            }
	          } else if (selectBoxAndRadioFlag) {
	            cb(true);
	          }
	        } else {
	          cb(validResult);
	        }
	      }
	
	      return done;
	    },
	    didNavigateToForm: function didNavigateToForm(_ref2) {
	      var currentForm = _ref2.currentForm;
	
	      if (currentForm.filter('.sp-review-tab').length) {
	        reviewTab.fillReviewCalendarArea(calendarTab.getCalendarShiftTimes());
	        reviewTab.fillReviewElementsWithVals();
	      }
	      return true;
	    }
	
	  });
	
	  $("#cancel-url").on('click', function () {
	    window.location.href = $(this).data('redirect-to-url');
	  });
	
	  $(document).on('click', "[data-target-form]", function () {
	    var form = el.find($(this).data("target-form"));
	    quickWizard.gotToForm(form);
	  });
	
	  quickWizard.init();
	  var detailsTab = new _detailsTab2.default(quickWizard);
	  detailsTab.init();
	
	  var addressTab = new _addressTab2.default(quickWizard);
	  addressTab.init();
	
	  var operationsTab = new _operationsTab2.default(quickWizard);
	  operationsTab.init();
	
	  var calendarTab = new _calendarTab2.default(quickWizard);
	  calendarTab.init();
	
	  var reviewTab = new _reviewTab2.default(quickWizard);
	  reviewTab.init();
	
	  var addressValidationModalEl = $("#add-validation-model");
	  var addressValidation = (0, _AddressValidation2.default)(addressValidationModalEl, el, {
	    isAlreadyValid: false
	  });
	}

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _detailsBusinessLogic = __webpack_require__(812);
	
	var _detailsBusinessLogic2 = _interopRequireDefault(_detailsBusinessLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	// import DetailsBusinessLogic from "detailsBusinessLogic.js"
	
	
	// NOTE - choose target (id or unique class) where you want this to
	var targetSelector = "#user-details-page-id";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	    attachDetailsPage(outerEl);
	});
	
	function attachDetailsPage(outerEl) {
	    var teamMembersDetailsLogic = new _detailsBusinessLogic2.default(outerEl);
	    teamMembersDetailsLogic.init();
	};

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = DetailsBusinessLogic;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _constants = __webpack_require__(10);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	var elementsPageMap = {
	  headerBtnsContainer: ".team-details-header-btns",
	  deactivateMemberBtn: '.deactivate-member-btn',
	  activateMemberBtn: '.activate-member-btn',
	  teamMemberInactivePill: '.team-member-inactive-pill',
	  teamMemberActivePill: '.team-member-active-pill',
	  updatePassBtn: '.update-pass-btn',
	  editTeamMember: '.edit-team-member'
	
	  //teamBackButtonEditChecker: ".team-back-button-edit-checker"
	};
	
	var elementsModalsMap = {
	  continueUpdatePassBtn: '.continue-update-pass-btn',
	  cancelUpdatePassBtn: '.cancel-update-pass-btn',
	  deactivateContinueBtn: '.deactivate-continue-btn',
	  deactivateCancelBtn: '.deactivate-cancel-btn',
	  activateContinueBtn: '.activate-continue-btn',
	  activateCancelBtn: '.activate-cancel-btn',
	  topModalCloseBtn: '.top-close-btn'
	};
	
	function DetailsBusinessLogic(mainEl) {
	  var self = this;
	
	  var elsPage = {};
	  var elsModals = {};
	
	  var updatePasswordModal = void 0;
	  var deactivateModal = void 0;
	  var activateModal = void 0;
	
	  self.init = function () {
	    generateModals();
	    setElements();
	    bindElements();
	    setInitialState();
	  };
	
	  function setInitialState() {
	    var status = elsPage.headerBtnsContainer.data("commerce-user-status");
	
	    swapTeamStatusButton(status);
	  };
	
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	
	  function generateModals() {
	    updatePasswordModal = $((0, _render2.default)(__webpack_require__(11), {
	      title: 'Update Password',
	      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn m-close-btn cancel-update-pass-btn">Cancel</a>\
	        <a href="#" class="base-btn purple-btn continue-update-pass-btn">Continue</a>',
	      body: __webpack_require__(1451),
	      modalDialogClass: 'q-modal-dialog-500',
	      modalTitleClass: "q-text-left",
	      topCloseBtn: 'true'
	    }));
	
	    deactivateModal = $((0, _render2.default)(__webpack_require__(11), {
	      title: 'Deactivate Team Member?',
	      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn m-close-btn deactivate-cancel-btn">Cancel</a>\
	        <a href="#" class="base-btn purple-btn deactivate-continue-btn">Deactivate</a>',
	      body: __webpack_require__(1450),
	      modalDialogClass: 'q-modal-dialog-500',
	      modalTitleClass: "q-text-left",
	      topCloseBtn: 'true'
	    }));
	
	    activateModal = $((0, _render2.default)(__webpack_require__(11), {
	      title: 'Activate Team Member?',
	      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn m-close-btn activate-cancel-btn">Cancel</a>\
	        <a href="#" class="base-btn purple-btn activate-continue-btn">Activate</a>',
	      body: __webpack_require__(1449),
	      modalDialogClass: 'q-modal-dialog-500',
	      modalTitleClass: "q-text-left",
	      topCloseBtn: 'true'
	    }));
	
	    $("body").append(updatePasswordModal);
	    $("body").append(deactivateModal);
	    $("body").append(activateModal);
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, mainEl);
	    (0, _selectorHelpers.setElementsFromScope)(elsModals, elementsModalsMap, $("body"));
	  }
	
	  function bindElements() {
	    //events from btns on page
	    elsPage.deactivateMemberBtn.click((0, _general.createPreventDefault)(deactivateTeamMemberCallModal));
	    elsPage.activateMemberBtn.click((0, _general.createPreventDefault)(activateTeamMemberCallModal));
	    elsPage.updatePassBtn.click((0, _general.createPreventDefault)(updatePasswordCallModal));
	    elsPage.editTeamMember.click((0, _general.createPreventDefault)(editTeamMemberCall));
	
	    //events from btns in modals
	    elsModals.continueUpdatePassBtn.click((0, _general.createPreventDefault)(continueUpdatePassBtn));
	    elsModals.cancelUpdatePassBtn.click((0, _general.createPreventDefault)(cancelUpdatePassBtn));
	    elsModals.deactivateContinueBtn.click((0, _general.createPreventDefault)(deactivateContinueBtn));
	    elsModals.deactivateCancelBtn.click((0, _general.createPreventDefault)(deactivateCancelBtn));
	    elsModals.activateContinueBtn.click((0, _general.createPreventDefault)(activateContinueBtn));
	    elsModals.activateCancelBtn.click((0, _general.createPreventDefault)(activateCancelBtn));
	    elsModals.topModalCloseBtn.click((0, _general.createPreventDefault)(topModalClose));
	
	    //Why was edit checker on a details page?
	    //EditChecker.bindCancelButton(elsPage.teamBackButtonEditChecker);    
	  }
	
	  function editTeamMemberCall() {
	    $('#commerce-view-user-detail').submit();
	  }
	
	  function updatePasswordCallModal() {
	    updatePasswordModal.modal("show");
	  }
	
	  function deactivateTeamMemberCallModal() {
	    deactivateModal.modal("show");
	  }
	
	  function activateTeamMemberCallModal() {
	    activateModal.modal("show");
	  }
	
	  function continueUpdatePassBtn() {
	    $.ajax({
	      url: elsPage.updatePassBtn.data('url'),
	      type: "POST",
	      data: { userId: elsPage.updatePassBtn.data('userId') },
	      beforeSend: function beforeSend() {
	        //$.blockUI({message : 'Updating Password, Please Wait..'});
	        submitModalFlow.showLoadingModal();
	      },
	      complete: function complete() {
	        //$.unblockUI();
	      },
	      success: function success(data) {
	        handleUpdatePassModalClose();
	        submitModalFlow.showSuccessModal();
	        setTimeout(function () {
	          submitModalFlow.hideAllModals();
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    });
	  }
	
	  function deactivateContinueBtn() {
	    $.ajax({
	      url: elsPage.deactivateMemberBtn.data('url'),
	      type: "POST",
	      data: { status: elsPage.deactivateMemberBtn.data('status'), userId: elsPage.deactivateMemberBtn.data('userId') },
	      beforeSend: function beforeSend() {
	        //$.blockUI({message : 'Changing Status, Please Wait..'});
	        submitModalFlow.showLoadingModal();
	      },
	      complete: function complete() {
	        //$.unblockUI();
	      },
	      success: function success(data) {
	        submitModalFlow.showSuccessModal();
	        setTimeout(function () {
	          swapTeamStatus(elsPage.deactivateMemberBtn.data('status'));
	          swapTeamStatusButton(elsPage.deactivateMemberBtn.data('status'));
	          handleDeactivateModalClose();
	          submitModalFlow.hideAllModals();
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    });
	  }
	
	  function activateContinueBtn() {
	    $.ajax({
	      url: elsPage.activateMemberBtn.data('url'),
	      type: "POST",
	      data: { status: elsPage.activateMemberBtn.data('status'), userId: elsPage.activateMemberBtn.data('userId') },
	      beforeSend: function beforeSend() {
	        //$.blockUI({message : 'Changing Status, Please Wait..'});
	        submitModalFlow.showLoadingModal();
	      },
	      complete: function complete() {
	        //$.unblockUI();
	      },
	      success: function success(data) {
	        submitModalFlow.showSuccessModal();
	        setTimeout(function () {
	          swapTeamStatus(elsPage.activateMemberBtn.data('status'));
	          swapTeamStatusButton(elsPage.activateMemberBtn.data('status'));
	          handleActivateModalClose();
	          submitModalFlow.hideAllModals();
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    });
	  }
	
	  function cancelUpdatePassBtn() {
	    handleUpdatePassModalClose();
	  }
	
	  function deactivateCancelBtn() {
	    handleDeactivateModalClose();
	  }
	
	  function activateCancelBtn() {
	    handleActivateModalClose();
	  }
	
	  function topModalClose() {
	    handleUpdatePassModalClose();
	    handleDeactivateModalClose();
	    handleActivateModalClose();
	  }
	
	  function handleUpdatePassModalClose() {
	    updatePasswordModal.modal("hide");
	  }
	
	  function handleDeactivateModalClose() {
	    deactivateModal.modal("hide");
	  }
	
	  function handleActivateModalClose() {
	    activateModal.modal("hide");
	  }
	
	  function swapTeamStatus(status) {
	    if (status) {
	      $('#user-details-page-id .team-member-detail-status-pill').text('Active');
	      $('#user-details-page-id .team-member-detail-status-pill').removeClass("q-pill-white-and-blue");
	      $('#user-details-page-id .team-member-detail-status-pill').addClass("q-pill-blue");
	    } else {
	      $('#user-details-page-id .team-member-detail-status-pill').text('Inactive');
	      $('#user-details-page-id .team-member-detail-status-pill').removeClass("q-pill-blue");
	      $('#user-details-page-id .team-member-detail-status-pill').addClass("q-pill-white-and-blue");
	    }
	  }
	
	  function swapTeamStatusButton(status) {
	    //if(status || status == "Activate") {
	    if (status) {
	      elsPage.deactivateMemberBtn.show();
	      elsPage.activateMemberBtn.hide();
	    } else {
	      elsPage.deactivateMemberBtn.hide();
	      elsPage.activateMemberBtn.show();
	    }
	  }
	}

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(811);
	
	__webpack_require__(1123);

/***/ },
/* 814 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "all": [],
	  "actions": [{
	    title: "Edit",
	    cls: "edit-team",
	    icon: "pencil",
	    disabled: false
	  }]
	};

/***/ },
/* 815 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var teamLookupFieldDropdown = exports.teamLookupFieldDropdown = [{
		title: "Name",
		value: "greeting"
	}, {
		title: "Email",
		value: "emailAddress"
	}];

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(820);

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(818);
	
	__webpack_require__(1124);

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _manageBusinessLogic = __webpack_require__(819);
	
	var _manageBusinessLogic2 = _interopRequireDefault(_manageBusinessLogic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	
	// NOTE - choose target (id or unique class) where you want this to
	var targetSelector = "#user-manage-page-id";
	
	(0, _run2.default)(targetSelector, function (outerEl) {
	  attachManagePage(outerEl);
	});
	
	function attachManagePage(outerEl) {
	  var manageTeamMembersLogic = new _manageBusinessLogic2.default(outerEl);
	  manageTeamMembersLogic.init();
	};

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ManageBusinessLogic;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _constants = __webpack_require__(10);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _typeAheadSource = __webpack_require__(71);
	
	var _typeAheadSource2 = _interopRequireDefault(_typeAheadSource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	
	var customValidateProps = {
	  errorPlacement: function errorPlacement(error, element) {
	    var appendClosest = $(element).data('error-placement-append-closest');
	    if (appendClosest) {
	      $(element).closest(appendClosest).append(error);
	    } else {
	      error.insertAfter(element);
	    }
	  }
	};
	
	var elementsPageMap = {
	  errorMsgContainer: ".error-msg-container",
	
	  createTeamMemberModalBtn: ".create-team-member-launch-modal",
	  updateTeamMemberModalBtn: ".update-team-member-launch-modal",
	  cancelTeamMemberEditCheckerBtn: ".cancel-and-launch-edit-checker",
	  manageTeamMemberUserName: ".manage-team-member-user-name",
	  manageTeamMemberUserEmail: "#emailAddress",
	
	  manageTeamMembersForm: ".manage-team-members",
	  userNameExistError: "#user-name-exist-error",
	  userNameValidationError: "#user-name-validate-error",
	  userEmailExistError: "#user-email-exist-error",
	  phoneFormat: ".phone-format",
	
	  //generics
	  allSelect2Fields: ".select2-select",
	
	  manufactureAccess: ".manufactureAccess",
	  selectOrganization: ".select-organization-typeahead",
	  manufactureAccessTypeAhead: "#mfg-access-typeahead",
	  organizationTable: ".organization-list",
	  organizationSection: ".after-user-adds-organizations",
	  selectedOrgIdsPath: "#selected-org-ids",
	  helpCenterButton: ".manufacture-access-btn"
	
	  // NOTE: els within modals
	};var elementsModalsMap = {
	  finishedCreatingMemberSaveMBtn: ".finished-save-m-btn",
	  addAnotherMemberSaveMBtn: ".add-another-save-m-btn",
	  finishedUpdatingMemberUpdateMBtn: ".finished-update-m-btn",
	  genericModal: ".modal",
	  closeBtn: ".top-close-btn"
	};
	
	function ManageBusinessLogic(mainEl) {
	  var organizationsList = mainEl.data("organization-list");
	  var userId = mainEl.data("user-id");
	  var deleteOrgURL = mainEl.data("delete-org-url");
	  var organizationRolesArray = mainEl.data("organization-roles-array");
	  var manufactureAccessHelpCenterURL = mainEl.data("manufacture-access-help-url");
	  var submitModalFlow = new _SubmitModalFlow2.default();
	  submitModalFlow.init();
	  var self = this;
	
	  var elsPage = {};
	  var elsModals = {};
	
	  var saveTeamMemberSuccessfulModal = void 0;
	  var updateTeamMemberSuccessfulModal = void 0;
	
	  self.init = function () {
	    generateModals();
	    setElements();
	    setInitialState();
	    bindElements();
	    bindEditChecker();
	  };
	  // const updateModalFlow = new SubmitModalFlow({
	  //   confirmModalTitle: 'Confirm Team Member',
	  //   // confirmModalSubtitle: "Optional Subtitle",
	  //   confirmModalBody: '<div class="q-pad-all-xl">Once you have confirmed this team member, an email will be sent to them with instructions to log in and update their temporary password.</div>',
	  //   confirmModalBtnText: 'Update',
	  //   onConfirmClick: function(){
	  //     updateTeamMember();
	  //
	  //   }
	  // });
	  //
	  // const createModalFlow = new SubmitModalFlow({
	  //   confirmModalTitle: 'Confirm Team Member',
	  //   // confirmModalSubtitle: "Optional Subtitle",
	  //   confirmModalBody: '<div class="q-pad-all-xl">Once you have confirmed this team member, an email will be sent to them with instructions to log in and update their temporary password.</div>',
	  //   confirmModalBtnText: 'Save',
	  //   onConfirmClick: function(){
	  //     createTeamMember();
	  //
	  //   }
	  // });
	  //
	  // updateModalFlow.init();
	  // createModalFlow.init();
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsPage, elementsPageMap, mainEl);
	    (0, _selectorHelpers.setElementsFromScope)(elsModals, elementsModalsMap, mainEl);
	    elsPage.manufactureAccess.hide();
	  };
	
	  function setInitialState() {
	
	    elsPage.manageTeamMembersForm.validate(customValidateProps);
	    elsPage.phoneFormat.inputmask({
	      mask: "(999) 999-9999"
	    });
	
	    elsPage.errorMsgContainer.hide();
	
	    instantiateOrgTypeAhead();
	    if (userId != "") {
	      var selectedRoleValue = elsPage.allSelect2Fields.find('option:selected').val();
	      if (selectedRoleValue == organizationRolesArray[0].cdmValue || selectedRoleValue == organizationRolesArray[1].cdmValue) {
	        elsPage.manufactureAccess.show();
	      } else {
	        elsPage.manufactureAccess.hide();
	      }
	      populateOrganizationTable(organizationsList);
	    }
	    var orgNameLookup = elsPage.manufactureAccessTypeAhead;
	    orgNameLookup.on("select2:select", function () {
	      elsPage.organizationSection.removeClass("hidden");
	      var res = orgNameLookup.select2('data')[0].typeAheadStr.split("--");
	      addOrganizations(res[0], res[1], res[2], 0);
	      orgNameLookup.val(null).trigger('change');
	    });
	  };
	
	  function populateOrganizationTable(organizationsList) {
	    if (organizationsList.length > 0) {
	      elsPage.organizationSection.removeClass("hidden");
	      $.each(organizationsList, function (index, value) {
	        var res = value.typeAheadStr.split("--");
	        addOrganizations(res[0], res[1], res[2], res[3]);
	      });
	    }
	  }
	
	  function isOrganizationPresent(organizationList, orgId) {
	    var isPresent = $.map(organizationList, function (elem, index) {
	      if (elem == orgId || elem.id == orgId) {
	        return true;
	      }
	    });
	    return isPresent;
	  }
	
	  var addOrganizations = function addOrganizations(orgName, facilitiesCount, orgId, usoId) {
	    var addedOrgIds = [];
	    elsPage.organizationTable.find("a").each(function (index) {
	      addedOrgIds.push(this.id);
	    });
	    var isOrgPresent = isOrganizationPresent(addedOrgIds, orgId);
	    //If Org not added previosuly only then allow to add it 
	    if (isOrgPresent.length == 0) {
	      var orgRow = $((0, _render2.default)(__webpack_require__(1452), {
	        orgName: orgName,
	        facilitiesCount: facilitiesCount,
	        orgId: orgId,
	        usoId: usoId
	      }));
	      elsPage.organizationTable.append(orgRow);
	    }
	  };
	
	  function bindElements() {
	    //events from els on main page
	    elsPage.createTeamMemberModalBtn.click((0, _general.createPreventDefault)(showCreateConfirmationModal));
	    elsPage.updateTeamMemberModalBtn.click((0, _general.createPreventDefault)(showUpdateConfirmationModal));
	    elsPage.allSelect2Fields.change(select2FieldChange);
	    elsPage.manageTeamMemberUserName.change((0, _general.createPreventDefault)(checkUserName));
	    elsPage.manageTeamMemberUserName.on('keyup', function (e) {
	      if ($(this).val() == '') {
	        elsPage.userNameExistError.hide();
	        elsPage.userNameValidationError.hide();
	      }
	    });
	    elsPage.manageTeamMemberUserEmail.change((0, _general.createPreventDefault)(checkEmailId));
	    elsPage.manageTeamMemberUserEmail.on('keyup', function (e) {
	      if ($(this).val() == '') {
	        elsPage.userEmailExistError.hide();
	      }
	    });
	    elsPage.helpCenterButton.on('click', function () {
	      window.open(manufactureAccessHelpCenterURL);
	    });
	
	    //events from btns in modals
	    elsModals.finishedCreatingMemberSaveMBtn.click((0, _general.createPreventDefault)(finishCreatingTeamMemberSaveM));
	    elsModals.addAnotherMemberSaveMBtn.click((0, _general.createPreventDefault)(addAnotherTeamMemberSaveM));
	    elsModals.finishedUpdatingMemberUpdateMBtn.click((0, _general.createPreventDefault)(finishCreatingTeamMemberUpdateM));
	
	    elsModals.closeBtn.click((0, _general.createPreventDefault)(closeModalTopXBtnClick));
	  };
	
	  function bindEditChecker() {
	    _EditChecker2.default.bindNavigation();
	
	    //Set the listeners for change on main form element
	    _EditChecker2.default.bindChangeListener(elsPage.manageTeamMembersForm);
	
	    //Set listener for cancel button
	    _EditChecker2.default.bindCancelButton(elsPage.cancelTeamMemberEditCheckerBtn);
	  };
	
	  function generateModals() {
	    updateTeamMemberSuccessfulModal = $((0, _render2.default)(__webpack_require__(11), {
	      topCloseBtn: 'true',
	      title: 'Update Successful',
	      modalTitleClass: "q-text-left",
	      footerBtns: '<a href="#" class="base-btn purple-btn finished-update-m-btn">Finished</a>',
	      body: "<div class='q-marg-all-xl'>Your Team Member information has been updated and saved.</div>"
	    }));
	
	    saveTeamMemberSuccessfulModal = $((0, _render2.default)(__webpack_require__(11), {
	      topCloseBtn: 'true',
	      title: 'Save Successful',
	      modalTitleClass: "q-text-left",
	      footerBtns: '<a href="#" class="base-btn v2-btn purple-btn add-another-save-m-btn">Add Another Team Member</a>\
	        <a href="#" class="base-btn purple-btn finished-save-m-btn">Finished</a>',
	      body: "<div class='q-marg-all-xl'>Your Team Member has been saved and added. An email will be sent to the new member with instructions to log in and update their temporary password.</div>"
	    }));
	
	    mainEl.append(saveTeamMemberSuccessfulModal);
	    mainEl.append(updateTeamMemberSuccessfulModal);
	  };
	
	  function instantiateOrgTypeAhead() {
	    var select2AjaxDefaults = {
	      dataType: 'json',
	      delay: 250,
	      async: false,
	      processResults: function processResults(data, params) {
	        params.page = params.page || 1;
	        return {
	          results: data,
	          pagination: {
	            more: params.page * 20 < data.total_count
	          }
	        };
	      },
	      cache: true
	    };
	
	    function configureDataCallback(_ref) {
	      var paramKey = _ref.paramKey;
	
	      return function (params) {
	        return _defineProperty({}, paramKey, params.term);
	      };
	    }
	
	    elsPage.manufactureAccessTypeAhead.select2({
	      placeholder: "Begin typing organization",
	      allowClear: true,
	      ajax: _extends({}, select2AjaxDefaults, {
	        url: elsPage.manufactureAccessTypeAhead.data('get-org-list'),
	        data: configureDataCallback({ paramKey: 'likeOrg' }),
	        templateResult: function templateResult(result) {
	          return result.text;
	        }
	      }),
	      minimumInputLength: 3
	    });
	  }
	
	  //NOTE: change event, so making it send functional jobs to another function
	  function select2FieldChange() {
	    handleSelect2IndividualValidate($(this));
	  };
	
	  //NOTE - this only needs to close modals, so I put that functionality directly in here
	  function closeModalTopXBtnClick() {
	    elsModals.genericModal.modal("hide");
	  };
	
	  // NOTE: since select2 components are tricky, we specifically target them as well with the EditChecker component, and also have to validate them individually
	  function handleSelect2IndividualValidate(selectField) {
	    selectField.valid();
	    _EditChecker2.default.setPageDirty();
	    //9023 Select Role Changes
	    var selectedRoleValue = elsPage.allSelect2Fields.find('option:selected').val();
	    if (selectedRoleValue == organizationRolesArray[0].cdmValue || selectedRoleValue == organizationRolesArray[1].cdmValue) {
	      elsPage.manufactureAccess.show();
	    } else {
	      elsPage.manufactureAccess.hide();
	    }
	  };
	
	  function createTeamMember() {
	    var orgIdsList = [];
	    if (elsPage.manufactureAccess.is(':visible')) {
	      elsPage.organizationTable.find("a").each(function (index) {
	        orgIdsList.push(this.id);
	      });
	    }
	
	    if (elsPage.manageTeamMembersForm.valid()) {
	      elsPage.selectedOrgIdsPath.val(orgIdsList);
	      saveTeamMemberCall();
	    }
	  };
	
	  function updateTeamMember() {
	    var orgIdsList = [];
	    if (elsPage.manufactureAccess.is(':visible')) {
	      elsPage.organizationTable.find("a").each(function (index) {
	        orgIdsList.push(this.id);
	      });
	    }
	    if (elsPage.manageTeamMembersForm.valid()) {
	      elsPage.selectedOrgIdsPath.val(orgIdsList);
	      updateTeamMemberCall();
	    }
	  };
	
	  function showUpdateConfirmationModal() {
	    if (elsPage.updateTeamMemberModalBtn.attr("disabled") != "disabled") {
	      updateTeamMember();
	    }
	  }
	
	  function showCreateConfirmationModal() {
	    if (elsPage.createTeamMemberModalBtn.attr("disabled") != "disabled") {
	      createTeamMember();
	    }
	  }
	
	  //NOTE - functions that handle modal els' events
	  function finishCreatingTeamMemberSaveM() {
	    //$("#manage-team-members").submit();
	    elsPage.manageTeamMembersForm.submit();
	  };
	
	  function addAnotherTeamMemberSaveM() {
	    //code to allow user to add another team member
	  };
	
	  function finishCreatingTeamMemberUpdateM() {
	    elsPage.manageTeamMembersForm.submit();
	  };
	
	  //const submitModalFlow = new SubmitModalFlow();
	  //submitModalFlow.init();
	
	
	  // call this function on click of save button from manage team member screen
	  function saveTeamMemberCall() {
	    elsPage.errorMsgContainer.hide();
	    var submitModalFlowVar = new _SubmitModalFlow2.default();
	    submitModalFlowVar.init();
	    submitModalFlowVar.showLoadingModal();
	    $.ajax({
	      url: elsPage.createTeamMemberModalBtn.data('url'),
	      type: 'POST',
	      dataType: 'json',
	      data: elsPage.manageTeamMembersForm.serialize(),
	      success: function success(resp) {
	        _EditChecker2.default.setPageClean();
	        submitModalFlowVar.showSuccessModal();
	        $('#userId').val(resp.data);
	        setTimeout(function () {
	          finishCreatingTeamMemberUpdateM();
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      },
	      error: function error(xhr, status, _error) {
	        submitModalFlowVar.hide();
	        elsPage.errorMsgContainer.show();
	      }
	    });
	  }
	
	  // call this function on click of update button from manage team member screen
	
	
	  function updateTeamMemberCall() {
	    elsPage.errorMsgContainer.hide();
	    var submitModalFlowVar = new _SubmitModalFlow2.default();
	    submitModalFlowVar.init();
	    submitModalFlowVar.showLoadingModal();
	    $.ajax({
	      url: elsPage.updateTeamMemberModalBtn.data('url'),
	      type: 'POST',
	      dataType: 'json',
	      data: elsPage.manageTeamMembersForm.serialize(),
	      success: function success(resp) {
	        _EditChecker2.default.setPageClean();
	        submitModalFlowVar.showSuccessModal();
	        setTimeout(function () {
	          finishCreatingTeamMemberUpdateM();
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      },
	      error: function error(xhr, status, _error2) {
	        submitModalFlowVar.hide();
	        elsPage.errorMsgContainer.show();
	      }
	    });
	  }
	
	  var checkUserName = function checkUserName() {
	    elsPage.userNameExistError.hide();
	    elsPage.userNameValidationError.hide();
	    var inputValue = $("#screenName").val();
	    checkDuplicateUserDetails('UserName', inputValue);
	  };
	
	  var checkEmailId = function checkEmailId() {
	    var inputValue = $("#emailAddress").val();
	    elsPage.userEmailExistError.hide();
	    checkDuplicateUserDetails('EmailId', inputValue);
	  };
	
	  //Check duplicate user name
	  var checkDuplicateUserDetails = function checkDuplicateUserDetails(inputType, inputValue) {
	    if (inputType == 'UserName') {
	      var pattern = /^[0-9a-zA-Z]+$/;
	      if (!inputValue.match(pattern) && !inputValue == '') {
	        elsPage.userNameValidationError.show();
	      }
	    }
	
	    if (inputType.length > 0 && inputValue.length > 0) {
	      $.ajax({
	        url: elsPage.manageTeamMemberUserName.data('check-user-name-url'),
	        type: "GET",
	        data: { inputValue: inputValue, inputType: inputType },
	        beforeSend: function beforeSend() {
	          $.blockUI({ message: 'Checking User Name, Please Wait..' });
	        },
	        complete: function complete() {
	          $.unblockUI();
	        },
	        success: function success(data) {
	          if (data.trim() == 'true') {
	            if (inputType == 'UserName') {
	              elsPage.userNameExistError.show();
	              elsPage.createTeamMemberModalBtn.attr('disabled', true);
	              elsPage.updateTeamMemberModalBtn.attr('disabled', true);
	            } else if (inputType == 'EmailId') {
	              elsPage.userEmailExistError.show();
	              elsPage.createTeamMemberModalBtn.attr('disabled', true);
	              elsPage.updateTeamMemberModalBtn.attr('disabled', true);
	            } else {
	              elsPage.createTeamMemberModalBtn.attr('disabled', false);
	              elsPage.updateTeamMemberModalBtn.attr('disabled', false);
	            }
	          } else {
	            if (elsPage.userNameExistError.is(":visible") || elsPage.userEmailExistError.is(":visible") || elsPage.userNameValidationError.is(":visible")) {
	              elsPage.createTeamMemberModalBtn.attr('disabled', true);
	              elsPage.updateTeamMemberModalBtn.attr('disabled', true);
	            } else {
	              elsPage.createTeamMemberModalBtn.attr('disabled', false);
	              elsPage.updateTeamMemberModalBtn.attr('disabled', false);
	            }
	          }
	        }
	      });
	    }
	  };
	
	  $(document).on("click", '.remove-org', function (e) {
	    e.preventDefault();
	    var orgId = this.id;
	    var currentRow = $(this).closest(".org-row");
	    var usoId = currentRow.data("uso-id");
	    currentRow.remove();
	  });
	};

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _teamLookupFields = __webpack_require__(815);
	
	var _actionOptions = __webpack_require__(814);
	
	var _constants = __webpack_require__(10);
	
	var _filtersutil = __webpack_require__(16);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	
	var actionList = _actionOptions.actionOptions;
	var targetSelector = "#user-lookup";
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var actionHeaderDropdownTemplate = __webpack_require__(30);
	
	(0, _run2.default)(targetSelector, function () {
	  var dataTableComponentData = $(targetSelector).data("user-lookup-data");
	  var getUserDetailRowDataUrl = $(targetSelector).data("user-detail-url");
	  var getEditUserURL = $(targetSelector).data("user-edit-url");
	  var generateExportUrl = $(targetSelector).data("export-url");
	  var savedViews = $(targetSelector).data("saved-views");
	  var portletNamespace = $(targetSelector).data("portlet-namespace");
	  var shouldCheckCache = $(targetSelector).data("should-check-cache");
	  var criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
	  var filterTeamUrl = $(targetSelector).data("user-filter-url");
	  var saveViewURL = $(targetSelector).data("save-view-url");
	  var deleteViewURL = $(targetSelector).data("delete-view-url");
	
	  //POD logic, added to check in the current retailer is POD retailer
	  var hasSubOrganizations = $(targetSelector).data("has-sub-organizations");
	  var variableColumnData = "jobTitle";
	  var variableColumnLabel = "Title";
	
	  var exportModal = new _filtersutil.buildExport();
	  var targetObject = "";
	  if (shouldCheckCache) {
	    targetObject = (0, _filtersutil.retriveCriteriaObjectByOperation)(criteriaObjectFromServer, "like");
	  }
	  if (hasSubOrganizations) {
	    variableColumnData = "assignedSubOrg";
	    variableColumnLabel = "Business Unit";
	  } else {
	    variableColumnData = "jobTitle";
	    variableColumnLabel = "Title";
	  }
	
	  var userLookup = new _index2.default({
	    // REQUIRED - Set a target element
	    target: $("#lookup-user-wrapper"),
	    // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
	    minWidthClass: "q-min-width-sm-til-md",
	    // REQUIRED - Set which data should be visible for mobile
	    mobileColumns: [{
	      data: "fullName",
	      title: "Name",
	      render: renderUserDetailLink
	    }, {
	      data: "status",
	      title: "Status",
	      render: renderStatusPill
	    }, {
	      data: "emailAddress",
	      title: "Email"
	    }, {
	      data: "phone",
	      title: "Phone"
	    }, {
	      data: "selectedChildRetailersNames",
	      title: "Merchant"
	    }, {
	      data: "selectedRoleNames",
	      title: "Role"
	    }, {
	      data: variableColumnData,
	      title: variableColumnLabel
	    }],
	    paginationData: dataTableComponentData.page,
	    filterModal: {
	      // REQUIRED: Sets title of modal
	      title: "Filter Users",
	      // REQUIRED: Sets unique part of subtitle string.
	      tableType: "team"
	    },
	    tableSearchInput: {
	      // Not required
	      // placeholder: 'Custom Search Text'
	      value: targetObject != "" ? targetObject.value[0] : ""
	
	    },
	    // REQUIRED - THIS IS TEMPORARY, WILL BE DEPRECATED WHEN WE ENABLE SEARCH INPUT ONLY
	    tableSearchDropdown: {
	      selected: targetObject == "" ? "" : targetObject.key,
	      columns: _teamLookupFields.teamLookupFieldDropdown
	    },
	    savedViews: savedViews,
	    bulkSelect: false,
	    // REQUIRED - Data Table specific settings 
	    dataTable: {
	      // use same settings you would if you were just calling a dataTable normally
	      data: dataTableComponentData.content,
	
	      columns: [{
	        data: "userId",
	        title: "Actions",
	        render: renderActionWrap,
	        orderable: false,
	        class: 'dtc-action-column'
	      }, {
	        data: "fullName",
	        title: "Name",
	        render: renderUserDetailLink
	      }, {
	        data: "status",
	        title: "Status",
	        render: renderStatusPill
	      }, {
	        data: "emailAddress",
	        title: "Email"
	      }, {
	        data: "phone",
	        title: "Phone",
	        orderable: false
	      }, {
	        data: "selectedChildRetailersNames",
	        title: "Merchant"
	      }, {
	        data: "selectedRoleNames",
	        title: "Role",
	        orderable: false
	      }, {
	        data: variableColumnData,
	        title: variableColumnLabel
	      }]
	    },
	    onFetch: function onFetch() {
	      var currentData = userLookup.generateData();
	      userLookup.showLoadingOverlay();
	      if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: filterTeamUrl, success: filterSuccessFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isNew)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isEdit)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      } else if ((0, _filtersutil.isDeleteView)(currentData)) {
	        setTimeout(function () {
	          (0, _filtersutil.doAjax)({ url: deleteViewURL, success: delteViewScussFun, error: errorFun, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	        }, _constants.SUCCESS_MODAL_TIMEOUT);
	      }
	    }
	  });
	
	  userLookup.init();
	
	  //Methods used for the Actions/Bulk Actions 
	  function renderActionWrap(data, type, row, meta) {
	    var newRender = void 0;
	    var statusTarget = actionList["actions"];
	    newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	      list: renderActionCellList(statusTarget, data, row),
	      index: meta.row
	    });
	    return newRender;
	  }
	
	  function renderActionCellList(list, data, row) {
	    var renderedList = void 0;
	    renderedList = _(list).map(function (item) {
	      return (0, _render2.default)(actionCellDropdownItemTemplate, {
	        icon: item.icon,
	        title: item.title,
	        cls: item.cls,
	        disabled: false
	      });
	    });
	    return renderedList.join('');
	  }
	
	  //Methods used for the Filter and Success
	  function filterSuccessFun(data) {
	    var users = data.content;
	    var page = data.page;
	    userLookup.setNewData(users);
	    userLookup.setPaginationData(page);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    userLookup.hideLoadingOverlay();
	    setExportData(userLookup.generateData());
	  }
	
	  function savedViewSuccess(data) {
	    var jsonData = JSON.parse(data.commerceUsersJson);
	    var users = jsonData.content;
	    var page = jsonData.page;
	    userLookup.setNewData(users);
	    userLookup.setPaginationData(page);
	    userLookup.setNewSavedViewData(data.savedView, "newSavedView");
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    userLookup.hideLoadingOverlay();
	    setExportData(userLookup.generateData());
	  }
	
	  function savedEditViewSuccess(data) {
	    var jsonData = JSON.parse(data.commerceUsersJson);
	    var users = jsonData.content;
	    var page = jsonData.page;
	    userLookup.setNewData(users);
	    userLookup.setPaginationData(page);
	    userLookup.setNewSavedViewData(data.savedView, data.savedView.target);
	    (0, _filtersutil.pushFilterSessionCacheState)();
	    userLookup.hideLoadingOverlay();
	    setExportData(userLookup.generateData());
	  }
	
	  function delteViewScussFun(data) {
	    var jsonData = JSON.parse(data.commerceUsersJson);
	    var users = jsonData.content;
	    var page = jsonData.page;
	    userLookup.removeSavedView(data.target);
	    userLookup.setNewData(users);
	    userLookup.setPaginationData(page);
	    userLookup.hideLoadingOverlay();
	    setExportData(userLookup.generateData());
	  }
	
	  function errorFun(data) {
	    userLookup.hideLoadingOverlay();
	  }
	
	  //Method to pouplate the User name as link 
	  function renderUserDetailLink(data, type, row) {
	    var linkHTML = "<a href={%=userDetailURL%}&userId={%-row.userId%}> {%-data%} </a>";
	    var userInfoLink = (0, _render2.default)(linkHTML, {
	      userDetailURL: getUserDetailRowDataUrl,
	      data: data,
	      row: row
	    });
	    return userInfoLink;
	  }
	
	  //Method to pouplate the Status with a Pill Fill
	  function renderStatusPill(data, type, row) {
	    var renderStatus = void 0;
	    var statusHTML = void 0;
	    if (data == "Active") {
	      statusHTML = "<div class='q-pill q-pill-blue q-pill-detail'>{%-data%}</div>";
	    } else {
	      statusHTML = "<div class='q-pill q-pill-blue-border q-pill-detail'>{%-data%}</div>";
	    }
	    renderStatus = (0, _render2.default)(statusHTML, {
	      data: data
	    });
	    return renderStatus;
	  }
	
	  //On click of Edit from the table view directly 
	  $('body').on('click', '.edit-team', function (e) {
	    e.preventDefault();
	    var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	    // Get the row based on the parent...
	    var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	    // Get the row data
	    var row = $(".data-table-component").dataTable().api().row(parent);
	    var user = row.data();
	    location.href = getEditUserURL + '&' + portletNamespace + 'userId=' + user.userId;
	  });
	
	  //Methods driven for Export functionality 
	  //  $("#exportData").click(function() {
	  //      let totRowCount = $('#totalRows').val();
	  //      $('#modalExportData').attr('disabled', true);
	  //      $('#dataFileType').val('0');
	  //      $('#row-count').html(" " + totRowCount + " ");
	  //      $("#exportModal").appendTo("body").modal("show");
	  // });
	
	
	  // $('#modalExportData').click(function() {
	  //      let fileType = $('#dataFileType :selected').val();
	  //      exportToFile(fileType);
	  //      $("#exportModal").modal("hide");
	  // });
	
	
	  // $('#dataFileType').change(function() {
	  // 	  $('#modalExportData').attr('disabled', false);
	  // });
	
	  // let exportToFile = function(fileType) {
	  //    let currentData = userLookup.generateData();
	  //  	const startDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'startDate');
	  // 	const endDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'endDate');	
	  // 	const fixedRangeDate = readSpecificKeyFromSearchCriteria(currentData["searchCriteria"],'fixedRange');	
	  // 	const revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"]);
	  //    const orderBy = "emailAddress";
	  // 	const searchCriteria =   _.toArray(revisedSearchCriteria).length > 0 ? JSON.stringify(_.toArray(revisedSearchCriteria)) : _.toArray(revisedSearchCriteria);
	  // 	const url = generateExportUrl+"&endDate="+endDate+"&startDate="+startDate+"&fixedRange="+fixedRangeDate+"&page=0"+"&size=1000"+"&orderBy="+orderBy+"&orderByType="+currentData["sortType"]+"&searchCriteria="+searchCriteria+"&fileType="+fileType;
	  // 	window.open(url);
	  // }; 
	
	
	  // Export component integration.
	  function initExport() {
	    var exportObj = {
	      title: $(targetSelector).data("export-popup-title"),
	      exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"),
	      exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
	      exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
	    };
	    exportModal.init(exportObj);
	    exportModal.bindExportEvent();
	  }
	
	  function setExportData(currentData) {
	    exportModal.buildExportBasicURL(generateExportUrl, currentData);
	    exportModal.setExportCount(currentData.totalElements);
	  }
	
	  initExport();
	  setExportData(userLookup.generateData());
	  (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	});

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = FacilitiesTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  originFacilitySelect: '.origin-facility',
	  destinationFacilitySelect: '.destination-facility',
	  originFacAddress: '.origin-fac-address',
	  originFacilityWrapper: '.origin-fac-address-wrapper',
	  originFacilityUses: '.origin-fac-uses-list',
	  destFacAddress: '.dest-fac-address',
	  destFacAddressWrapper: '.dest-fac-address-wrapper',
	  destFacilityUses: '.dest-fac-uses-list'
	};
	
	function FacilitiesTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	  var facilitiesList = wizardElement.data('facilities');
	
	  self.init = function () {
	    render();
	  };
	
	  function render() {
	    setElements();
	    loadDropDowns();
	    bindElements();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardElement);
	  }
	
	  function bindElements() {
	    els.originFacilitySelect.on("change", handleOriginFacilityChangeEvent);
	    els.destinationFacilitySelect.on("change", handleDestinationFacilityChangeEvent);
	  }
	
	  function loadDropDowns() {
	    (0, _jquery2.default)(facilitiesList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.facId).text(this.facName);
	      els.originFacilitySelect.append(option);
	    });
	
	    (0, _jquery2.default)(facilitiesList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.facId).text(this.facName);
	      els.destinationFacilitySelect.append(option);
	    });
	  }
	
	  function handleOriginFacilityChangeEvent(e) {
	    e.preventDefault();
	    var selectedFacility = this.value;
	    var facility = facilitiesList.filter(function (obj) {
	      return obj.facId == selectedFacility;
	    })[0];
	    //show address
	    els.originFacilityWrapper.hide();
	    els.originFacAddress.html('');
	    if (facility != null) {
	      //$("#"+portletNamespace+"facId").val(facility.facId);
	      els.originFacAddress.append("<div>" + facility.facAddressLine1 + "</div>");
	      if (facility.facAddressLine2 != null) {
	        els.originFacAddress.append("<div>" + facility.facAddressLine2 + "</div>");
	      }
	      els.originFacAddress.append("<div>" + facility.facCity + ", " + facility.facState + " " + facility.facZipcode + "</div>");
	      //show facility/fulfillment uses
	      els.originFacilityUses.html("");
	      els.originFacilityUses.append("<div class='q-boldest'>Facility Uses:</div>");
	      var facilityUses = false;
	      if (facility.attributes != null && facility.attributes.length > 0) {
	        _jquery2.default.each(facility.attributes[0], function (key, value) {
	          if (key == "IN" && value == true) {
	            els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>International Fulfillment Center</span> ");
	            facilityUses = true;
	          } else if (key == "FC" && value == true) {
	            els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Fulfillment Center</span> ");
	            facilityUses = true;
	          } else if (key == "DC" && value == true) {
	            els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Distribution Center</span> ");
	            facilityUses = true;
	          } else if (key == "RC" && value == true) {
	            els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Returns Center</span> ");
	            facilityUses = true;
	          }
	        });
	        if (!facilityUses) {
	          els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
	        }
	      } else {
	        els.originFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
	      }
	      els.originFacilityWrapper.show();
	    }
	  }
	
	  function handleDestinationFacilityChangeEvent(e) {
	    e.preventDefault();
	    var selectedFacility = this.value;
	    var facility = facilitiesList.filter(function (obj) {
	      return obj.facId == selectedFacility;
	    })[0];
	    //show address
	    els.destFacAddressWrapper.hide();
	    els.destFacAddress.html('');
	    if (facility != null) {
	      //$("#"+portletNamespace+"facId").val(facility.facId);
	      els.destFacAddress.append("<div>" + facility.facAddressLine1 + "</div>");
	      if (facility.facAddressLine2 != null) {
	        els.destFacAddress.append("<div>" + facility.facAddressLine2 + "</div>");
	      }
	      els.destFacAddress.append("<div>" + facility.facCity + ", " + facility.facState + " " + facility.facZipcode + "</div>");
	      //show facility/fulfillment uses
	      els.destFacilityUses.html("");
	      els.destFacilityUses.append("<div class='q-boldest'>Facility Uses:</div>");
	      var facilityUses = false;
	      if (facility.attributes != null && facility.attributes.length > 0) {
	        _jquery2.default.each(facility.attributes[0], function (key, value) {
	          if (key == "IN" && value == true) {
	            els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>International Fulfillment Center</span> ");
	            facilityUses = true;
	          } else if (key == "FC" && value == true) {
	            els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Fulfillment Center</span> ");
	            facilityUses = true;
	          } else if (key == "DC" && value == true) {
	            els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Distribution Center</span> ");
	            facilityUses = true;
	          } else if (key == "RC" && value == true) {
	            els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue'>Returns Center</span> ");
	            facilityUses = true;
	          }
	        });
	        if (!facilityUses) {
	          els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
	        }
	      } else {
	        els.destFacilityUses.append("<span class='q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border'>No Facility Uses</span> ");
	      }
	      els.destFacAddressWrapper.show();
	    }
	  }
	}

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ProductsTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _productsModalUtilities = __webpack_require__(228);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var elementsMap = {
	  originFacility: '.origin-facility',
	  addProductsFromlistBtn: '.add-products-modal-btn',
	  selectedProductsTable: '.selected-products-table',
	  tableResponsiveCreateOrderTable: "#product-tab-transfer-ord-table",
	  productEmptyTableValidator: '#products-empty-table-validator',
	  addProductsBtn: '.add-products-btn',
	  productItemLookup: "#product-item-lookup"
	};
	
	function ProductsTab(wizard, addProductsModal) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var els = {};
	  var doc = (0, _jquery2.default)(document);
	  var modalCheckboxSelector = ".order-modal-checkbox";
	  var modalOrderTable = null;
	
	  self.productItems = {};
	  self.productNameArr = {};
	
	  self.init = function () {
	    updateSelf();
	  };
	
	  self.didNavigateToForm = function () {
	    handleDisplayOfCreateOrderTable();
	  };
	
	  self.isValid = function () {
	    return getItemsInCreateOrderTable().length;
	  };
	
	  function updateSelf() {
	    setElements();
	    setWidgets();
	    bindElements();
	  }
	
	  // Instantiate Modal Flow
	  var loadingProductListModal = new SubmitModalFlow({
	    confirmModalTitle: 'Loading Product List'
	  });
	  // Init Flow
	  loadingProductListModal.init();
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardElement);
	  }
	
	  function setWidgets() {
	    instantiateSkuTypeAhead();
	    var productItemLookup = els.productItemLookup;
	    productItemLookup.on("select2:select", function () {
	      var res = productItemLookup.select2('data')[0].text.split("--");
	      addProducts(res[0], res[1], res[2], res[3]);
	      triggerAddProductsEvent();
	      productItemLookup.val(null).trigger('change');
	    });
	  }
	
	  function instantiateSkuTypeAhead() {
	
	    var select2AjaxDefaults = {
	      dataType: 'json',
	      delay: 250,
	      processResults: function processResults(data, params) {
	        params.page = params.page || 1;
	        return {
	          results: getProductNamesAndItems(data),
	          pagination: {
	            more: params.page * 20 < data.total_count
	          }
	        };
	      },
	      cache: true
	    };
	
	    function configureDataCallback(_ref) {
	      var paramKey = _ref.paramKey;
	
	      return function (params) {
	        var _ref2;
	
	        return _ref2 = {}, _defineProperty(_ref2, paramKey, params.term), _defineProperty(_ref2, "facId", els.originFacility.val()), _ref2;
	      };
	    }
	
	    els.productItemLookup.select2({
	      placeholder: "Type product name (SKU)",
	      allowClear: true,
	      ajax: _extends({}, select2AjaxDefaults, {
	        url: wizardElement.data("get-product-names-and-items-url"),
	        data: configureDataCallback({
	          paramKey: 'likeSku'
	        })
	      }),
	      minimumInputLength: 3
	    });
	  }
	
	  function bindElements() {
	    /*els.originFacility.on("change", function(){
	      let facIdLocal = els.originFacility.val();
	      if(!isBlank(facIdLocal)) {
	        getProductNamesAndItems(facIdLocal);
	      }
	    });*/
	
	    els.addProductsFromlistBtn.on("click", showAddProductsModal);
	    els.selectedProductsTable.on('addedproducts', handleAddProducts);
	    els.addProductsBtn.on("click", handleAddProductsBtnFromModal);
	    doc.on('click', '#order-transfer-wizard .products-tab .icon-remove', handleItemRemove);
	  }
	
	  var triggerAddProductsEvent = function triggerAddProductsEvent() {
	    els.selectedProductsTable.trigger('addedproducts');
	  };
	
	  function showAddProductsModal(e) {
	    e.preventDefault();
	    showProductModal();
	  }
	
	  function showProductModal() {
	    addProductsModal.modal("show");
	    unCheckAllInModal();
	    (0, _productsModalUtilities.handleTotalChecked)(addProductsModal, modalOrderTable, modalCheckboxSelector);
	  }
	
	  function unCheckAllInModal() {
	    var checkBoxes = (0, _productsModalUtilities.getCheckedFromDataTable)(modalOrderTable, modalCheckboxSelector);
	    checkBoxes.prop("checked", false);
	  }
	
	  //add-up how many Checkboxes are checked!
	  (0, _jquery2.default)(document).on("change", modalCheckboxSelector, function () {
	    (0, _productsModalUtilities.handleTotalChecked)(addProductsModal, modalOrderTable, modalCheckboxSelector);
	  });
	
	  function handleAddProducts() {
	    EditChecker.setPageDirty();
	    handleDisplayOfCreateOrderTable();
	    (0, _jquery2.default)(els.productEmptyTableValidator).trigger("qwcustomchange");
	  }
	
	  function handleItemRemove(e) {
	    EditChecker.setPageDirty();
	    //removeClosestRow($(e.target));
	    //change the method name to remove product related rows.
	    removeProductRelatedRows((0, _jquery2.default)(e.target));
	    handleDisplayOfCreateOrderTable();
	    (0, _jquery2.default)(els.productEmptyTableValidator).trigger("qwcustomchange");
	  }
	
	  function removeProductRelatedRows(el) {
	    var coreProduct = el.closest('tr');
	    removeProductRelatedRowsFromTr(coreProduct);
	  }
	
	  function removeProductRelatedRowsFromTr(coreProduct) {
	    var childProducts = coreProduct.data("childProducts");
	    if (childProducts && childProducts.length) {
	      (0, _underscore2.default)(childProducts).map(function (childProduct) {
	        childProduct.remove();
	      });
	    }
	    coreProduct.remove();
	  }
	
	  function removeProductRelatedRowsFromTrs(coreProducts) {
	    coreProducts.each(function () {
	      removeProductRelatedRowsFromTr((0, _jquery2.default)(this));
	    });
	  }
	
	  function handleDisplayOfCreateOrderTable() {
	    if (getItemsInCreateOrderTable().length) {
	      show(els.selectedProductsTable);
	    } else {
	      hide(els.selectedProductsTable);
	    }
	  }
	
	  function hide(el) {
	    el.css({ display: "none" });
	  }
	  function show(el) {
	    el.css({ display: "block" });
	  }
	
	  function getItemsInCreateOrderTable() {
	    return els.selectedProductsTable.find('tbody tr');
	  }
	
	  function getProductNamesAndItems(response) {
	    //els.tableResponsiveCreateOrderTable.find('tbody > tr').remove();
	    // Show Loading Modal
	    //loadingProductListModal.showLoadingModal();
	    //loadingProductListModal.hideAllModals();
	    var productNameArr = response.productNameArr;
	    //self.productNameArr.regularItems = productNameArr;
	    //let items = response.items;
	    //self.productItems.regularItems = items;
	    return productNameArr;
	  }
	
	  self.setProductLookupAndModal = function (items, productNameArr) {
	    modalOrderTable = addProductsModal.find('.modal-order-table').dataTable();
	    modalOrderTable.fnClearTable();
	
	    if (items != null && items.length > 0) {
	      modalOrderTable.fnAddData(items);
	    }
	  };
	
	  function getCheckedRowsFromDataTable(dt, selector) {
	    var checkedRows = (0, _underscore2.default)((0, _jquery2.default)(dt.api().rows().nodes()).toArray()).filter(function (tr) {
	      return !!(0, _jquery2.default)(tr).find(selector + ":checked").length;
	    });
	    return (0, _jquery2.default)(checkedRows);
	  }
	
	  function handleAddProductsBtnFromModal() {
	    var allCheckedRows = getCheckedRowsFromDataTable(modalOrderTable, modalCheckboxSelector);
	    var skus = allCheckedRows.map(function () {
	      return (0, _jquery2.default)(this).find("td").eq(2).text();
	    }).get();
	
	    var productNames = allCheckedRows.map(function () {
	      return (0, _jquery2.default)(this).find("td").eq(1).text();
	    }).get();
	
	    var availUnit = allCheckedRows.map(function () {
	      return (0, _jquery2.default)(this).find("td").eq(3).text();
	    }).get();
	
	    var prdType = allCheckedRows.map(function () {
	      return (0, _jquery2.default)(this).find("td").eq(4).text();
	    }).get();
	
	    for (var i = 0; i < skus.length; i++) {
	      addProducts(productNames[i], skus[i], availUnit[i], prdType[i]);
	    }
	    triggerAddProductsEvent();
	
	    addProductsModal.modal("hide");
	  }
	
	  var addProducts = function addProducts(productName, prodDescription, availUnit, prdType) {
	    var highestId = parseInt((0, _jquery2.default)("#product-tab-transfer-ord-table tbody tr:last").attr("id"));
	    if (isNaN(highestId)) {
	      highestId = 0;
	    } else {
	      ++highestId;
	    }
	
	    var productRow = (0, _jquery2.default)((0, _render2.default)(__webpack_require__(1454), {
	      highestId: highestId,
	      productName: productName,
	      prodDescription: prodDescription,
	      availUnit: availUnit,
	      portletNamespace: portletNamespace
	    }));
	
	    (0, _jquery2.default)("#product-tab-transfer-ord-table").find('tbody').append(productRow);
	  };
	}

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ReviewTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsReviewMap = {
	  originFacilityName: '.origin-facility-name',
	  originFacilityAddress: '.origin-facility-address',
	  destFacilityName: '.dest-facility-name',
	  destFacilityAddress: '.dest-facility-address',
	  targetCompletionDate: '.rev-target-completion-date',
	  shippingType: '.rev-shipping-type',
	  productsTableBodyReviewTab: ".review-tab-products-table-body"
	};
	
	var elementsSourceMap = {
	  originFacilityName: ".origin-facility",
	  originFacilityAddress: ".origin-fac-address",
	  destFacilityName: ".destination-facility",
	  destFacilityAddress: ".dest-fac-address",
	  shippingType: '.shipping-type',
	  targetCompletionDate: '#targetCompletionDate',
	  productsTableProductsTab: "#product-tab-transfer-ord-table"
	};
	
	var productItemsMap = {
	  quantityInput: ".products-tab-quantity-input",
	  name: ".products-tab-product-name",
	  body: ".products-tab-product-description",
	  available: ".products-tab-available-units"
	};
	
	function ReviewTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var submitOrderURL = wizardElement.data("submit-order-url");
	  var viewOrderDetailURL = wizardElement.data("view-order-detail-url");
	  var elsReview = {};
	  var elsSource = {};
	
	  self.init = function () {
	    render();
	  };
	
	  self.didNavigateToForm = function () {
	    updateSelf();
	  };
	
	  function render() {
	    setElements();
	    bindElements();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(elsReview, elementsReviewMap, wizardElement);
	    (0, _selectorHelpers.setElementsFromScope)(elsSource, elementsSourceMap, wizardElement);
	  }
	
	  function bindElements() {}
	
	  function updateSelf() {
	    elsReview.originFacilityName.text(elsSource.originFacilityName.find(':selected').text());
	    elsReview.originFacilityAddress.html(elsSource.originFacilityAddress.html());
	
	    elsReview.destFacilityName.text(elsSource.destFacilityName.find(':selected').text());
	    elsReview.destFacilityAddress.html(elsSource.destFacilityAddress.html());
	
	    fillProductsInReviewTab();
	
	    elsReview.targetCompletionDate.text(elsSource.targetCompletionDate.val());
	    elsReview.shippingType.text(elsSource.shippingType.find(':selected').text());
	  }
	
	  function productsTableRowTemplate(_ref) {
	    var name = _ref.name,
	        body = _ref.body,
	        quantityInput = _ref.quantityInput;
	
	    return "\n      <tr id=\"0\" class=\"product-item\">\n        <td>\n            " + name + "\n        </td>\n        <td>\n            " + body + "\n        </td>\n        <td>\n            " + quantityInput + "\n        </td>\n      </tr>\n    ";
	  }
	
	  function fillProductsInReviewTab() {
	    elsReview.productsTableBodyReviewTab.text("");
	    var products = elsSource.productsTableProductsTab.find('.product-item');
	
	    products.each(function () {
	      var product = (0, _jquery2.default)(this);
	      var productDetailEls = {};
	      var bundleIcon = '<i class="fa fa-cubes q-icon-marg-left" aria-hidden="true"></i>';
	      (0, _selectorHelpers.setElementsFromScope)(productDetailEls, productItemsMap, product);
	
	      fillProductInReviewTab(productDetailEls);
	    });
	  }
	
	  function fillProductInReviewTab(pEls) {
	    var data = {
	      name: pEls.name.text(),
	      body: pEls.body.text(),
	      quantityInput: pEls.quantityInput.val()
	    };
	    elsReview.productsTableBodyReviewTab.append(productsTableRowTemplate(data));
	  }
	
	  var submitModalFlow = new _SubmitModalFlow2.default({
	    confirmModalTitle: 'Transfer Inventory',
	    // confirmModalSubtitle: "Optional Subtitle",
	    confirmModalBody: '<div class="q-pad-all-xl">Once you confirm this transfer, the inventory will be allocated and sent to the destination facility.</div>',
	    onConfirmClick: function onConfirmClick() {
	      // Show Loading Modal
	      submitModalFlow.showLoadingModal();
	
	      // call ajax funtion here.
	      submitOrder({ url: submitOrderURL, success: submitOrderSuccess, error: submitOrderError });
	    }
	  });
	
	  submitModalFlow.init();
	
	  function submitOrder(_ref2) {
	    var url = _ref2.url,
	        success = _ref2.success,
	        error = _ref2.error;
	
	    _jquery2.default.ajax({
	      data: (0, _jquery2.default)("#order-transfer-wizard").serialize(),
	      url: url,
	      type: 'POST',
	      success: success,
	      error: error
	    });
	  }
	
	  function submitOrderSuccess(orderId) {
	    if (orderId) {
	      EditChecker.setPageClean();
	      submitModalFlow.showSuccessModal();
	      setTimeout(function () {
	        var orderDetailUrlFullURL = viewOrderDetailURL + "&orderId=" + orderId;
	        window.location.href = orderDetailUrlFullURL;
	      }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	    }
	  }
	
	  function submitOrderError() {
	    submitModalFlow.showFailureModal();
	  }
	
	  (0, _jquery2.default)(".create-button").on('click', function () {
	    submitModalFlow.showConfirmModal();
	  });
	}

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ShippingTab;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elementsMap = {
	  shippingType: '.shipping-type',
	  freightShippingMessage: '.freight-shipping-message'
	};
	
	function ShippingTab(wizard) {
	  var self = this;
	  var wizardElement = wizard.getWizardElement();
	  var shippingTypesList = wizardElement.data('shipping-types');
	  var els = {};
	
	  self.init = function () {
	    render();
	  };
	
	  function render() {
	    setElements();
	    loadDropDowns();
	    bindElements();
	  }
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, wizardElement);
	  }
	
	  function loadDropDowns() {
	    (0, _jquery2.default)(shippingTypesList).each(function () {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', this.cdmValue).text(this.cdmMeaning);
	      els.shippingType.append(option);
	    });
	  }
	
	  function bindElements() {
	    els.shippingType.on("change", handleShippingTypeChange);
	  }
	
	  function handleShippingTypeChange(e) {
	    e.preventDefault();
	    if ((0, _jquery2.default)(this).val() === "LTL") {
	      els.freightShippingMessage.show();
	    } else {
	      els.freightShippingMessage.hide();
	    }
	  }
	}

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(826);
	
	__webpack_require__(1125);

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = TransferOrderWizard;
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _general = __webpack_require__(5);
	
	var _ConfigPanel = __webpack_require__(109);
	
	var _ConfigPanel2 = _interopRequireDefault(_ConfigPanel);
	
	var _FacilitiesTab = __webpack_require__(821);
	
	var _FacilitiesTab2 = _interopRequireDefault(_FacilitiesTab);
	
	var _ProductsTab = __webpack_require__(822);
	
	var _ProductsTab2 = _interopRequireDefault(_ProductsTab);
	
	var _ShippingTab = __webpack_require__(824);
	
	var _ShippingTab2 = _interopRequireDefault(_ShippingTab);
	
	var _ReviewTab = __webpack_require__(823);
	
	var _ReviewTab2 = _interopRequireDefault(_ReviewTab);
	
	var _orderDataExample = __webpack_require__(834);
	
	var _productsModalUtilities = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	  Base file for stub.
	  This is where all the actual stub code will go.
	*/
	
	// REQUIRED IMPORTS
	var $ = __webpack_require__(1);
	
	var modalHtml = __webpack_require__(11);
	
	// Product Modal
	
	var productModalFooterLeft = __webpack_require__(1472);
	var productModalFooterBtns = __webpack_require__(1471);
	var productModalOrderBody = __webpack_require__(1470);
	
	
	var targetSelector = "#order-transfer-wizard";
	// Additional Imports...
	// For quick dev prototyping
	(0, _run2.default)(targetSelector, function () {
	  var el = $(targetSelector);
	  TransferOrderWizard(el);
	  setupEditChecker(el);
	});
	
	function setupEditChecker(el) {
	  EditChecker.bindNavigation();
	  EditChecker.bindChangeListener(targetSelector);
	  EditChecker.bindChangeListener("span.select2");
	  $("#order-cancel-btn").data("edit-checker-redirect", el.data("cancel-redirect-url")); // cancel url set from jsp
	  EditChecker.bindCancelButton("#order-cancel-btn");
	}
	
	function TransferOrderWizard(el) {
	  // START: REQUIRED TO LOAD STUB
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    },
	    // Place all your validation rules here!!!
	    rules: {
	      "orderFulfillmentCenter": {
	        validFacility: ".destination-facility"
	      },
	      "destinationFulfillmentCenter": {
	        validFacility: ".origin-facility"
	      }
	    }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  $.validator.addMethod("validFacility", function (value, element, params) {
	    if (value === $(params).val()) {
	      return false;
	    } else {
	      return true;
	    }
	  }, "Please choose another facility.");
	
	  var wizardHtml = $((0, _render2.default)(__webpack_require__(1458), {
	    facilityTab: __webpack_require__(1453),
	    productsTab: __webpack_require__(1455),
	    shippingTab: __webpack_require__(1457),
	    reviewTab: __webpack_require__(1456)
	  }));
	
	  el.html(wizardHtml);
	
	  var quickWizard = new QuickWizard(el, {
	    tabletWidthNavStep: 1048,
	    mobileWidthNavStep: 886,
	
	    customRules: {
	      "#products-empty-table-validator": {
	        errorMessageSelector: ".products-tab-products-table-error-message",
	        isValid: function isValid() {
	          return productsTab.isValid();
	        }
	      }
	    },
	    shouldNavigateToForm: function shouldNavigateToForm(_ref) {
	      var targetForm = _ref.targetForm,
	          direction = _ref.direction,
	          currentForm = _ref.currentForm,
	          done = _ref.done;
	
	      // Any time we go traverse backwards, just let us
	      if (direction === "BACKWARDS") {
	        return true;
	      }
	
	      areInputsValid(true, done);
	
	      function areInputsValid(shouldContinue, cb) {
	        var allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
	        var notValid = !quickWizard.areInputsValid(allPrevInputs, { displayErrors: true });
	        if (notValid || !shouldContinue) {
	          if (notValid) {
	            quickWizard.goToFirstIncompleteForm();
	          }
	          cb(false);
	        } else {
	          cb(true);
	        }
	      }
	
	      return done;
	    },
	    didNavigateToForm: function didNavigateToForm(_ref2) {
	      var currentForm = _ref2.currentForm;
	
	      if (currentForm.filter('.products-tab').length) {
	        productsTab.didNavigateToForm();
	        //productsTab.setProductLookupAndModal(productsTab.productItems.regularItems , productsTab.productNameArr.regularItems);
	      } else if (currentForm.filter('.review-tab').length) {
	        reviewTab.didNavigateToForm();
	      }
	    }
	  });
	
	  quickWizard.init();
	
	  $(document).on('click', "[data-target-form]", function () {
	    var form = el.find($(this).data("target-form"));
	    quickWizard.gotToForm(form);
	  });
	
	  // Modal Options/Creation
	  var modalOpts = { backdrop: 'static', show: false };
	
	  //Add products Modal
	  var addProductsModal = $((0, _render2.default)(modalHtml, {
	    autoHideTop: true,
	    topCloseBtn: true,
	    title: 'Product Selection',
	    footerLeft: productModalFooterLeft,
	    footerBtns: productModalFooterBtns,
	    body: (0, _render2.default)(productModalOrderBody, {
	      originFacilityAlertBlock: true,
	      availableQuantityColumn: true,
	      typeColumn: true
	    }),
	    modalDialogClass: 'q-modal-dialog-800'
	  }));
	  addProductsModal.find('.product-search-modal-input').on('keyup', function () {
	    modalOrderTable.api().search(this.value).draw();
	    (0, _productsModalUtilities.handleTotalChecked)(addProductsModal, modalOrderTable, modalCheckboxSelector);
	  });
	  // DataTable
	  var defaultDataTableOptions = {
	    "dom": "t",
	    "paging": false,
	    "ordering": false,
	    "info": false
	    // NOTE: THIS DATA TABLE SHOULD BE INSTANTIATED VIA AJAX AS CURRENTLY DONE IN pages/orders/productsTab.js
	  };var modalOrderTable = addProductsModal.find('.modal-order-table').dataTable(_extends({}, defaultDataTableOptions, {
	    data: _orderDataExample.orderData,
	    "columnDefs": [
	      //{ className: "", "targets": [ 1, 2, 3, 4 ] }
	    ],
	    columns: [{
	      data: "itmId",
	      className: "order-checkbox-wrapper",
	      render: _productsModalUtilities.modalRenderCheckbox
	    }, {
	      data: "itmSku",
	      className: "order-modal-sku"
	    }, {
	      data: "prdNameAndAttributes"
	    }, {
	      data: "availUnit",
	      className: "q-text-center order-modal-pills",
	      render: _productsModalUtilities.modalRenderPillUnits
	    }, {
	      data: "type",
	      className: "q-text-center order-modal-type"
	    }]
	  }));
	  var modalCheckboxSelector = ".order-modal-checkbox";
	  //add-up how many Checkboxes are checked!
	  $(document).on("change", modalCheckboxSelector, function () {
	    (0, _productsModalUtilities.handleTotalChecked)(addProductsModal, modalOrderTable, modalCheckboxSelector);
	  });
	
	  // START: Date Picker (required)
	  var date = new Date();
	  date.setDate(date.getDate() + 1);
	  $(".func-date-range-input").datepicker({
	    startDate: date,
	    todayBtn: false,
	    keyboardNavigation: false,
	    autoclose: true
	  });
	  // END: Date Picker (required)
	
	  $(el).append(addProductsModal);
	
	  addProductsModal.modal(modalOpts);
	
	  // START: REAL CODE
	
	  var facilitiesTab = new _FacilitiesTab2.default(quickWizard);
	  facilitiesTab.init();
	
	  var productsTab = new _ProductsTab2.default(quickWizard, addProductsModal);
	  productsTab.init();
	
	  var shippingTab = new _ShippingTab2.default(quickWizard);
	  shippingTab.init();
	
	  var reviewTab = new _ReviewTab2.default(quickWizard);
	  reviewTab.init();
	
	  // END: REAL CODE
	};

/***/ },
/* 827 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionOptions = exports.actionOptions = {
	  // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
	  "true": [{
	    title: "Deactivate",
	    cls: "deactivate-webhook",
	    icon: "toggle-off",
	    disabled: false
	  }, {
	    title: "Test Connection",
	    cls: "test-connection-webhook",
	    icon: "wrench",
	    disabled: false
	  }],
	  "false": [{
	    title: "Activate",
	    cls: "activate-webhook",
	    icon: "toggle-on",
	    disabled: false
	  }]
	};

/***/ },
/* 828 */
[1582, 829],
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _actionOptions = __webpack_require__(827);
	
	var _constants = __webpack_require__(10);
	
	var _filtersutil = __webpack_require__(16);
	
	var _util = __webpack_require__(34);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _customBootstrapDropdowns = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	var _ = __webpack_require__(2);
	__webpack_require__(1126);
	
	var modalAlertHtml = __webpack_require__(182);
	
	
	var actionCellDropdownTemplate = __webpack_require__(26);
	var actionCellDropdownItemTemplate = __webpack_require__(27);
	var editWebhookLinkHtml = __webpack_require__(1460);
	var addWebhookModalHtml = __webpack_require__(1459);
	var modalHtml = __webpack_require__(11);
	
	var targetSelector = "#webhook-lookup";
	var notificationMode = "Webhook";
	var newWebhookIdMsg = "An ID will be generated after adding the webhook";
	var actionList = _actionOptions.actionOptions;
	var editedLookupRowIndex = void 0;
	
	var savedViews = [{
	    title: "All Webhooks",
	    target: "allWebhooks",
	    active: true,
	    canRemove: false,
	    canEdit: false,
	    filters: [],
	    columns: []
	}];
	
	var els = {};
	var elsModal = {};
	var elsMap = {
	    addWebhookBtn: ".add-webhook-btn",
	    editWebhookBtn: ".edit-webhook-btn"
	};
	var elsModalMap = {
	    addWebhookModalFlowBtn: ".add-webhook-modal-btn",
	    addWebhookEventType: "#webhook-event-type",
	    addWebhookId: "#webhook-unique-id",
	    addCallbackUrl: "#callbackUrl",
	    addSecretkey: "#secretkey",
	    webhookExistsMsg: "#dup-webhook",
	    webhookEventErrMsg: "#eventtype-dropdown-error",
	    webhookCallbackURlErrMsg: "#callbackurl-error",
	    editWebhookModalFlowBtn: ".edit-webhook-modal-btn",
	    webhookHelpCenterPage: "#redirectWebhookHelpcenterpage",
	    saveWebhookBtn: ".save-webhook-btn"
	};
	
	var addWebhookModal = void 0,
	    webhookModalSubmitFlow = void 0,
	    testSubmitModal = void 0,
	    failureAlertModal = void 0;
	
	(0, _run2.default)(targetSelector, function (mainEl) {
	
	    var dataTableComponentData = mainEl.data("webhooks");
	    var filterWebhooksUrl = mainEl.data("filter-webhooks-url");
	    var addWebhookSaveURL = mainEl.data("add-webhook-url");
	    var eventTypesList = mainEl.data('event-types');
	    var webhookHelpCenterUrl = mainEl.data("help-center-url");
	    var changeStatusURL = mainEl.data("update-webhook-status");
	    var webhookPingURL = mainEl.data("webhook-ping");
	    var editWebhookSaveURL = mainEl.data("editsave-webhook-url");
	
	    var webhookLookup = new _index2.default({
	        // REQUIRED - Set a target element
	        target: $("#webhook-lookup-wrapper"),
	        // Set a target class for min width, needs to be a "til-x" class so it doesn't interfere with mobile widths
	        minWidthClass: "q-min-width-sm-til-md",
	        // REQUIRED - Set which data should be visible for mobile
	        mobileColumns: [{
	            data: "id",
	            title: "Webhook ID",
	            orderable: true
	        }],
	        tableSearch: false,
	
	        newSavedViews: false,
	        // OPTIONAL: Set Saved View Array
	        savedViews: savedViews,
	        bulkSelect: false,
	        // REQUIRED - Data Table specific settings
	        dataTable: {
	            // use same settings you would if you were just calling a dataTable normally
	            data: dataTableComponentData.content,
	            // Not required, just to show you can
	            columnDefs: [{ className: "custom-class", targets: [1] }],
	            // Not required, just to show you can
	            order: [[2, 'asc']],
	            columns: [{
	                data: "status",
	                title: "Actions",
	                orderable: true,
	                render: renderActionWrap,
	                class: 'dtc-action-column'
	            }, {
	                data: "id",
	                title: "Webhook ID",
	                render: webhookIdActionBtns,
	                class: 'dtc-min-width-sm'
	            }, {
	                data: "eventName",
	                title: "Webhook Event",
	                class: 'dtc-min-width-sm'
	            }, {
	                data: "url",
	                title: "URL",
	                class: 'dtc-min-width-md'
	            }, {
	                data: "status",
	                title: "Status",
	                render: renderStatusPill,
	                class: 'dtc-min-width-sm'
	            }, {
	                data: "modifiedDate",
	                title: "Connection Status",
	                render: renderModifiedDate,
	                class: 'dtc-min-width-lg'
	            }]
	        },
	
	        paginationData: dataTableComponentData.page,
	        onFetch: function onFetch() {
	            var currentData = webhookLookup.generateData();
	            webhookLookup.showLoadingOverlay();
	            //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
	            if ((0, _filtersutil.isOnlyLookupDataUpdate)(currentData)) {
	                setTimeout(function () {
	                    (0, _filtersutil.doAjax)({ url: filterWebhooksUrl, success: filterSuccess, error: error, data: (0, _filtersutil.prepareDataToSendController)(currentData) });
	                }, _constants.SUCCESS_MODAL_TIMEOUT);
	            }
	        }
	    });
	    webhookLookup.init();
	    var table = $("#webhook-lookup-wrapper .data-table-component").DataTable();
	    (0, _customBootstrapDropdowns.handleCustomDropdownEvents)();
	
	    function filterSuccess(data) {
	        var webhooks = data.content;
	        var page = data.page;
	        webhookLookup.setNewData(webhooks);
	        webhookLookup.setPaginationData(page);
	        webhookLookup.hideLoadingOverlay();
	    }
	
	    function error() {
	        webhookLookup.hideLoadingOverlay();
	    }
	
	    function renderActionWrap(data, type, row, meta) {
	        var newRender = void 0;
	        var statusTarget = actionList[data];
	        newRender = (0, _render2.default)(actionCellDropdownTemplate, {
	            list: renderActionCellList(statusTarget),
	            index: meta.row
	        });
	        return newRender;
	    };
	    function renderActionCellList(list, data, row) {
	        var renderedList = void 0;
	        renderedList = _(list).map(function (item) {
	            return (0, _render2.default)(actionCellDropdownItemTemplate, {
	                icon: item.icon,
	                title: item.title,
	                cls: item.cls,
	                disabled: false
	            });
	        });
	        return renderedList.join('');
	    }
	
	    function renderStatusPill(data, type, row) {
	        if (data === 'true') {
	            return "<div class='q-marg-all-xs-at-md q-block q-pill q-pill-blue '>Active</div>";
	        } else {
	            return "<div class='q-marg-all-xs-at-md q-block q-pill q-pill-light-grey'>Inactive</div>";
	        }
	    }
	
	    function renderModifiedDate(data, type, row) {
	        if ((0, _util.isNullOrUndefined)(data)) {
	            return "";
	        } else if (data.includes("Successful") || data.includes("Failed")) {
	            return data;
	        } else {
	            return "Last Update:" + data;
	        }
	    }
	
	    function init() {
	        generateModals();
	        setElementsInModals();
	        setElements();
	        loadDropDowns();
	        bindElements();
	    }
	
	    function setElements() {
	        (0, _selectorHelpers.setElementsFromScope)(els, elsMap, mainEl);
	    }
	
	    function setElementsInModals() {
	        var body = $('body');
	        (0, _selectorHelpers.setElementsFromScope)(elsModal, elsModalMap, body);
	    }
	
	    function bindElements() {
	        //click btn on lookup
	        els.addWebhookBtn.click((0, _general.createPreventDefault)(showAddWebhookModal));
	
	        //click addwebhook btn on Modal
	        elsModal.addWebhookModalFlowBtn.click((0, _general.createPreventDefault)(webhookModalFlow));
	        //click save btn on Modal
	        elsModal.editWebhookModalFlowBtn.click((0, _general.createPreventDefault)(editWebhookModalFlow));
	        //click link on Modal
	        elsModal.webhookHelpCenterPage.click((0, _general.createPreventDefault)(openHelpCenterPage));
	        elsModal.addCallbackUrl.on("blur", hideErrorMsg);
	        elsModal.addWebhookEventType.on("change", hideEventErrMsg);
	
	        //On clicking the webhookID column link on lookup, show edit modal/popup 
	        $('body').on('click', '.edit-webhook-btn', function (e) {
	            e.preventDefault();
	
	            //Get index of row clicked 
	            editedLookupRowIndex = $(this).attr("id");
	            // Get the row based on the parent...
	            var parent = $(".dropdown-parent-" + editedLookupRowIndex).parents('tr');
	            // Get the row data
	            var row = $(".data-table-component").dataTable().api().row(parent);
	
	            showAddWebhookModal("EDIT", row.data());
	        });
	
	        $('body').on('click', '.deactivate-webhook', function (e) {
	            e.preventDefault();
	            var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	            // Get the row based on the parent...
	            var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	            // Get the row data
	            var row = table.row(parent);
	            var submitModalFlow = new SubmitModalFlow({
	                confirmModalTitle: 'Deactivate Webhook',
	                modalDialogClass: "q-modal-dialog-500",
	                confirmModalBody: "<div class=\"q-pad-all-xl\">Once deactivated, this connection will no longer be synced with your system. It can be activated at any time.</div>",
	                confirmModalBtnText: 'Deactivate Webhook',
	                onConfirmClick: function onConfirmClick() {
	                    submitModalFlow.showLoadingModal();
	                    deactivateWebhook(row, row.data());
	                    function deactivateWebhook(row, webhook) {
	                        $.ajax({
	                            url: changeStatusURL,
	                            type: 'POST',
	                            dataType: 'JSON',
	                            data: {
	                                webhookId: webhook.id,
	                                status: webhook.status
	                            },
	                            success: function success(data) {
	                                if (data.responseStatus === "Success") {
	                                    var d = row.data();
	                                    d.id = $.trim(data.id);
	                                    d.status = $.trim(data.status);
	                                    d.eventName = data.eventName;
	                                    d.modifiedDate = data.modifiedDate;
	                                    d.url = $.trim(data.url);
	                                    row.data(d).draw();
	                                    submitModalFlow.showSuccessModal();
	                                    setTimeout(function () {
	                                        submitModalFlow.hideAllModals();
	                                    }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                                } else {
	                                    submitModalFlow.showFailureModal();
	                                }
	                            },
	                            error: function error(data) {
	                                submitModalFlow.hideAllModals();
	                            }
	                        });
	                    };
	                }
	            });
	            submitModalFlow.init();
	            submitModalFlow.showConfirmModal();
	        });
	
	        //Activate Webhook 
	        $('body').on('click', '.activate-webhook', function (e) {
	            e.preventDefault();
	            var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	            // Get the row based on the parent...
	            var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	            // Get the row data
	            var row = table.row(parent);
	            var submitModalFlow = new SubmitModalFlow({
	                confirmModalTitle: 'Activate Webhook',
	                modalDialogClass: "q-modal-dialog-500",
	                confirmModalBody: "<div class=\"q-pad-all-xl\">Once activated, this connection will begin syncing with your system. It can be deactivated at any time.</div>",
	                confirmModalBtnText: 'Activate Webhook',
	                onConfirmClick: function onConfirmClick() {
	                    submitModalFlow.showLoadingModal();
	                    activateWebhook(row, row.data());
	                    function activateWebhook(row, webhook) {
	                        $.ajax({
	                            url: changeStatusURL,
	                            type: 'POST',
	                            dataType: 'JSON',
	                            data: {
	                                webhookId: webhook.id,
	                                status: webhook.status
	                            },
	                            success: function success(data) {
	                                if (data.responseStatus === "Success") {
	                                    var d = row.data();
	                                    d.id = $.trim(data.id);
	                                    d.status = $.trim(data.status);
	                                    d.eventName = data.eventName;
	                                    d.modifiedDate = data.modifiedDate;
	                                    d.url = $.trim(data.url);
	                                    row.data(d).draw();
	                                    submitModalFlow.showSuccessModal();
	                                    setTimeout(function () {
	                                        submitModalFlow.hideAllModals();
	                                    }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                                } else {
	                                    submitModalFlow.showFailureModal();
	                                }
	                            },
	                            error: function error(data) {
	                                submitModalFlow.hideAllModals();
	                            }
	                        });
	                    };
	                }
	            });
	            submitModalFlow.init();
	            submitModalFlow.showConfirmModal();
	        });
	
	        //Ping Webhook 
	        $('body').on('click', '.test-connection-webhook', function (e) {
	            e.preventDefault();
	            var pIndex = $(this).closest('.dropdown-menu').data('parent-index');
	            // Get the row based on the parent...
	            var parent = $(".dropdown-parent-" + pIndex).parents('tr');
	            // Get the row data
	            var row = table.row(parent);
	            testSubmitModal.showLoadingModal();
	            pingWebhook(row, row.data());
	            function pingWebhook(row, webhook) {
	                $.ajax({
	                    url: webhookPingURL,
	                    type: 'POST',
	                    dataType: 'JSON',
	                    data: {
	                        webhookId: webhook.id,
	                        status: webhook.status,
	                        webhookUrl: webhook.url
	                    },
	                    success: function success(data) {
	                        if (data.responseStatus === "Success") {
	                            var d = row.data();
	                            d.id = $.trim(data.id);
	                            d.status = $.trim(data.status);
	                            d.eventName = data.eventName;
	                            d.modifiedDate = "Successful. Last Update:" + data.modifiedDate;
	                            d.url = $.trim(data.url);
	                            row.data(d).draw();
	                            testSubmitModal.showSuccessModal();
	                            setTimeout(function () {
	                                testSubmitModal.hideAllModals();
	                            }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                        } else if (data.responseStatus === "Failed") {
	                            var d = row.data();
	                            d.url = $.trim(data.url);
	                            d.modifiedDate = "Failed. Last Update:" + data.modifiedDate;
	                            row.data(d).draw();
	                            setTimeout(function () {
	                                testSubmitModal.hideAllModals();
	                                failureAlertModal.modal("show");
	                            }, 2000);
	                            setTimeout(function () {
	                                failureAlertModal.modal("hide");
	                            }, 4000);
	                        }
	                    },
	                    error: function error(data) {
	                        testSubmitModal.showFailureModal();
	                        setTimeout(function () {
	                            testSubmitModal.hideAllModals();
	                        }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                    }
	                });
	            };
	        });
	    }
	
	    function openHelpCenterPage() {
	        window.open(webhookHelpCenterUrl);
	    }
	
	    function loadDropDowns() {
	        $(eventTypesList).each(function () {
	            var option = $('<option />');
	            option.attr('value', this.cdmValue).text(this.cdmValue);
	            elsModal.addWebhookEventType.append(option);
	        });
	    }
	
	    function hideErrorMsg() {
	        var callBackUrl = elsModal.addCallbackUrl.val();
	        elsModal.webhookExistsMsg.hide();
	
	        if (!(0, _util.isNullOrUndefined)(callBackUrl) || !(0, _general.isBlank)(callBackUrl)) {
	            elsModal.webhookCallbackURlErrMsg.hide();
	        }
	    }
	
	    function hideEventErrMsg() {
	        var eventtype = elsModal.addWebhookEventType.val();
	
	        if (!(0, _util.isNullOrUndefined)(eventtype) || !(0, _general.isBlank)(eventtype)) {
	            elsModal.webhookEventErrMsg.hide();
	        }
	    }
	
	    function generateModals() {
	
	        webhookModalSubmitFlow = new SubmitModalFlow();
	        webhookModalSubmitFlow.init();
	
	        testSubmitModal = new SubmitModalFlow();
	        testSubmitModal.init();
	
	        //addWebhook modal
	        addWebhookModal = $((0, _render2.default)(modalHtml, {
	            title: 'Add Webhook',
	            footerBtns: '<a href="#" class="base-btn purple-btn v2-btn cancel-add-webhook-btn modal-auto-hide">Cancel</a>\
	              <a href="#" class="base-btn purple-btn add-webhook-modal-btn">Add Webhook</a> <a href="#" class="base-btn purple-btn edit-webhook-modal-btn">Save</a>',
	            body: addWebhookModalHtml,
	            topCloseBtn: true,
	            autoHideTop: true,
	            leftAlignTitle: true,
	            modalDialogClass: "q-modal-dialog-800"
	        }));
	
	        //failureModal
	        failureAlertModal = $((0, _render2.default)(modalAlertHtml, {
	            title: 'Failure',
	            body: '<div class="q-pad-all-xl"><i class="fa fa-times-circle-o q-fa-fail fa-4x"></i></div>'
	        }));
	
	        $('body').append(addWebhookModal, failureAlertModal);
	    }
	
	    /**
	     * This function will show the add/edit webhook popup.
	     * Resets the fields, hides all errors on popup.
	     */
	    function showAddWebhookModal(modalaction, selectedrowdata) {
	        resetModalFields();
	        elsModal.webhookExistsMsg.hide();
	        elsModal.webhookEventErrMsg.hide();
	        elsModal.webhookCallbackURlErrMsg.hide();
	
	        if ((0, _general.isBlank)(modalaction)) {
	            $("h4.q-modal-title").text("Add Webhook");
	            $("div.webhook-unique-id").text(newWebhookIdMsg);
	            elsModal.addWebhookModalFlowBtn.show();
	            elsModal.editWebhookModalFlowBtn.hide();
	        } else if (!(0, _general.isBlank)(modalaction) && modalaction == 'EDIT') {
	            $("h4.q-modal-title").text("Edit Webhook");
	            elsModal.editWebhookModalFlowBtn.show();
	            elsModal.addWebhookModalFlowBtn.hide();
	            elsModal.addWebhookEventType.val(selectedrowdata.eventName).trigger('change');
	            elsModal.addCallbackUrl.val(selectedrowdata.url);
	            elsModal.addSecretkey.val(selectedrowdata.signature);
	            $("div.webhook-unique-id").text(selectedrowdata.id);
	            elsModal.addWebhookEventType.prop('disabled', true);
	        }
	        addWebhookModal.modal("show");
	    }
	
	    //for subscribe modal submitflow
	    function webhookModalFlow() {
	        validateAddUpdateInputs("ADD");
	    }
	
	    function editWebhookModalFlow() {
	        validateAddUpdateInputs("EDIT");
	    }
	
	    function validateAddUpdateInputs(action) {
	        var webhookId = $("div.webhook-unique-id").text();
	        var webhookEvent = elsModal.addWebhookEventType.val();
	        var webhookUrl = elsModal.addCallbackUrl.val();
	        var webhookSecretKey = elsModal.addSecretkey.val();
	
	        if (webhookId.length == 0 || action == "ADD") {
	            webhookId = null;
	        }
	
	        elsModal.webhookEventErrMsg.hide();
	        elsModal.webhookCallbackURlErrMsg.hide();
	
	        //Make sure required field values are provided.
	
	        if ((0, _util.isNullOrUndefined)(webhookEvent) || (0, _general.isBlank)(webhookEvent)) {
	            elsModal.webhookEventErrMsg.show();
	        }
	
	        if ((0, _util.isNullOrUndefined)(webhookUrl) || (0, _general.isBlank)(webhookUrl)) {
	            elsModal.webhookCallbackURlErrMsg.show();
	            return false;
	        } else {
	            webhookModalSubmitFlow.showLoadingModal();
	            subscribeNewWebHook(webhookId, webhookEvent, webhookUrl, webhookSecretKey, action);
	        }
	    }
	
	    function subscribeNewWebHook(webhookId, webhookEvent, webhookUrl, webhookSecretKey, modalAction) {
	        var saveURL = addWebhookSaveURL;
	        if (!(0, _general.isBlank)(modalAction) && modalAction == "EDIT") {
	            saveURL = editWebhookSaveURL;
	        }
	
	        $.ajax({
	            url: saveURL,
	            data: {
	                addNopId: webhookId,
	                addNopNotificationEvent: webhookEvent,
	                addNopNotificationTo: webhookUrl,
	                addNopNotificationMode: notificationMode,
	                addNopSecretKey: webhookSecretKey
	            },
	            dataType: "JSON",
	            type: 'POST',
	            success: function success(data) {
	                if (data.status.toLowerCase() == "success") {
	                    addWebhookModal.modal("hide");
	                    webhookModalSubmitFlow.hideAllModals();
	                    webhookModalSubmitFlow.showSuccessModal();
	                    if (modalAction == 'EDIT') {
	                        // Get the row based on the parent...
	                        var parent = $(".dropdown-parent-" + editedLookupRowIndex).parents('tr');
	
	                        // Get the row data
	                        var row = table.row(parent);
	
	                        //display updated data in lookup row
	                        var rowObj = row.data();
	                        rowObj.id = $.trim(webhookId);
	                        rowObj.url = $.trim(webhookUrl);
	                        rowObj.signature = $.trim(webhookSecretKey);
	                        row.data(rowObj).draw();
	
	                        setTimeout(function () {
	                            webhookModalSubmitFlow.hideAllModals();
	                        }, window.constants.SUCCESS_MODAL_TIMEOUT);
	                    } else {
	                        //for ADD reload screen
	                        webhookModalSubmitFlow.hideAllModals();
	                        setTimeout(function () {
	                            location.reload();
	                        }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	                    }
	                } else {
	                    webhookModalSubmitFlow.hideAllModals();
	                    if (data.errors != undefined && data.errors.length > 0 && data.errors[0].code == "ERR-WHK-0009") {
	                        addWebhookModal.modal("show");
	                        elsModal.webhookExistsMsg.show();
	                    } else if (data.errors != undefined) {
	                        //incase of any other errors show generic failure modal
	                        addWebhookModal.modal("show");
	                        if (data.errors != undefined && data.errors.length > 0) {
	                            webhookModalSubmitFlow.setErrors({
	                                errorDescription: data.errors[0].description
	                            });
	                        }
	                        webhookModalSubmitFlow.showFailureModal();
	                    }
	                }
	            }
	        });
	    }
	
	    //This function clears the field values on Add/Edit popup
	    function resetModalFields() {
	        elsModal.addWebhookEventType.prop('disabled', false);
	        elsModal.addWebhookEventType.val("").trigger('change');
	        elsModal.addCallbackUrl.val("");
	        $("div.webhook-unique-id").text(newWebhookIdMsg);
	        elsModal.addSecretkey.val("");
	    }
	
	    //for rendering WebhookID column as link on lookup table
	    function webhookIdActionBtns(data, type, row, meta) {
	        return (0, _render2.default)(editWebhookLinkHtml, {
	            webHookClassName: data,
	            index: meta.row
	        });
	    }
	
	    init();
	});

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(833);
	
	__webpack_require__(831);
	
	__webpack_require__(832);

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _general = __webpack_require__(5);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	var _additionalFilterLogic = __webpack_require__(146);
	
	var _pagination = __webpack_require__(143);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _filtersLegacy = __webpack_require__(147);
	
	var _lookupFilterElements = __webpack_require__(573);
	
	var _lookupFilterElements2 = _interopRequireDefault(_lookupFilterElements);
	
	var _lookupSessionCaching = __webpack_require__(574);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	(0, _run2.default)("#lookup-work-order-outer", function () {
	  var el = (0, _jquery2.default)("#lookup-work-order-outer");
	  workOrderLookup(el);
	});
	
	function workOrderLookup(el) {
	  var els = {};
	  var noop = function noop() {};
	  var namespace = el.data("namespace");
	  var workOrderFilterTypes = el.data("work-order-types");
	  var workOrderFilterStatuses = el.data("work-order-statuses");
	  var processingLabel = "Processing...";
	  var errorMessageLabel = el.find("#process-error-message");
	  window.migrateLookupFrontend = true;
	
	  var filterElements = new _lookupFilterElements2.default(namespace);
	
	  var elementsMap = filterElements.getElementsMap();
	  var docElementsMap = filterElements.getDocElementsMap();
	
	  _underscore2.default.extend(elementsMap, {
	    emptyDiv: '#' + namespace + 'lookup-work-order-table .dataTables_empty',
	    table: "#lookup-work-order-table"
	  });
	
	  _underscore2.default.extend(docElementsMap, {
	    cancelWorkOrderModal: '#cancel-work-order-modal',
	    cancelWorkOrder: ".cancel-work-order",
	    reasonForCancellation: "#cancelWOReason"
	  });
	
	  var defaultLookupDataTableOptions = {
	    "searching": false,
	    "paging": false,
	    "ordering": false,
	    "info": false
	  };
	
	  setElements();
	  onLoad();
	
	  var paginator = (0, _pagination2.default)(els.lookupOuter, {
	    tableData: els.workOrders,
	    lang: els.lang
	  });
	
	  function setElements() {
	    (0, _selectorHelpers.setElementsFromScope)(els, elementsMap, el);
	    (0, _selectorHelpers.setElementsFromScope)(els, docElementsMap, (0, _jquery2.default)(document));
	    els.lookupOuter = el;
	    els.filterUrl = el.data("filter-work-orders-url");
	    els.detailUrl = el.data("work-order-detail-page-url");
	    els.workOrders = els.table.data("work-orders");
	    els.namespace = namespace;
	    els.generalErrorMessage = el.data("general-error-message");
	    els.createUpdateUrl = el.data("work-order-create-update-url");
	    els.calcelUrl = el.data("work-order-cancel-url");
	    els.shouldCheckCache = el.data("should-check-cache");
	    els.savedFilterCriteria = el.data("saved-filter-criteria");
	    els.extraDetailForCache = el.data("extra-detail-for-cache");
	    els.searchCriteriaHiddenInput = el.data("hidden-input-search-criteria");
	    els.additionalFilterkeyArr = ['status', 'type'];
	  }
	
	  function onLoad() {
	    /* strip garbage attrs from additional-filter btn
	       so we can handle the js concerns from the js*/
	    els.additionalFilterOuter.removeAttr("data-toggle");
	    //els.dateRangeFilter.removeAttr("data-toggle");
	
	    els.sortFieldHiddenInput.val("worStatus");
	    els.sortTypeHiddenInput.val("asc");
	    els.itemsPerPageSelect.val(els.workOrders.page.size);
	
	    els.additionalFilterOuter.show();
	    els.dateRangeFilter.show();
	
	    els.lang = (0, _collectDataAttributesFor2.default)(els.lookupOuter.get(0), { prefix: "lang", camelize: false });
	
	    els.showAdditionalFilterInput.val(els.lang['work-order-additional-filter-text']);
	    els.showDateRangeFilterInput.val(els.lang['lookup-filter-date-range-last7days']);
	    els.dateRangeModalTitle.text(els.lang['lookup-filter-order-date-range-header']);
	
	    var filterFields = [{
	      value: "id",
	      text: els.lang['work-order-table-filter-id']
	    }, {
	      value: "subject",
	      text: els.lang['work-order-table-filter-subject']
	    }, {
	      value: "sku",
	      text: els.lang['work-order-table-filter-product-sku']
	    }];
	
	    if (els.workOrders.isCsrOrSysAdmin) {
	      var retailerFilter = {
	        value: "retailerName",
	        text: els.lang['work-order-table-filter-retailer']
	      };
	      filterFields.push(retailerFilter);
	    }
	
	    _underscore2.default.each(filterFields, function (filterObj) {
	      var option = (0, _jquery2.default)('<option />');
	      option.attr('value', filterObj.value).text(filterObj.text);
	      /*
	        The below if condition needs to be moved to 
	        lookupSessionCaching.js.
	      */
	      if (els.shouldCheckCache === true) {
	        window.setCacheFilterFields(option, els.savedFilterCriteria, filterObj.value, filterObj.text);
	      }
	      els.filterFieldsSelect.append(option);
	    });
	
	    var types = [];
	    _underscore2.default.each(workOrderFilterTypes, function (typeObj) {
	      var type = { value: typeObj.cdmValue };
	      types.push(type);
	    });
	
	    (0, _additionalFilterLogic.addSimpleCheckboxRows)(els.modalFilterType, types);
	
	    var statuses = [];
	    _underscore2.default.each(workOrderFilterStatuses, function (statusObj) {
	      var status = { value: statusObj.cdmValue };
	      statuses.push(status);
	    });
	
	    (0, _additionalFilterLogic.addSimpleCheckboxRows)(els.modalFilterStatus, statuses);
	
	    (0, _additionalFilterLogic.bindCheckboxRowItems)({ namespace: namespace });
	
	    /**
	      The below code is for to handle the session caching 
	      for lookup page.
	    */
	    if (els.shouldCheckCache === true) {
	      (0, _lookupSessionCaching.applySessionCachingLogic)(els);
	      setAdditionalFilterText();
	    }
	  }
	
	  els.additionalFilterOuter.on("click", showAdditionalFiltersModal);
	  els.applyAddtionalFiltersModalBtn.on("click", handleApplyFiltersModalBtn);
	  els.tableHeaderItems.on("click", onTableHeaderItemClick);
	
	  function showAdditionalFiltersModal() {
	    els.additionalFilterModal.modal("show");
	  }
	
	  function handleApplyFiltersModalBtn(e) {
	    e.preventDefault();
	    /* Status */
	    var statusValues = collectStatusValues();
	    var typeValues = collectTypeValues();
	
	    // DIRECT PORT :( No time to refactor
	    window.addToCriteria('status', statusValues, 'equal');
	    window.addToCriteria('type', typeValues, 'equal');
	
	    els.additionalFilterModal.modal('hide');
	
	    postLookupSearchHelper();
	
	    setAdditionalFilterText(statusValues, typeValues);
	  }
	
	  function setAdditionalFilterText(statuses, types) {
	    var statusValues = statuses || collectStatusValues();
	    var typeValues = types || collectTypeValues();
	
	    if (statusValues.length > 0 || typeValues.length > 0) {
	      var totalAppliedFilters = 0;
	      totalAppliedFilters = ((0, _general.isPresent)(statusValues) ? statusValues.length : 0) + ((0, _general.isPresent)(typeValues) ? typeValues.length : 0);
	      els.showAdditionalFilterInput.val(totalAppliedFilters + ' ' + els.lang['lookup-filter-additional-filter-filters-applied']);
	      els.clearFilters.show();
	    } else {
	      els.showAdditionalFilterInput.val(els.lang['work-order-additional-filter-text']);
	      els.clearFilters.hide();
	    }
	  }
	
	  function onTableHeaderItemClick() {
	    var headerElement = (0, _jquery2.default)(this);
	    (0, _filtersLegacy.applySortingRelatedIconsAndSetHiddenFields)({
	      headerElement: headerElement,
	      elements: els,
	      sortField: headerElement.data('sort-field'),
	      callback: postLookupSearchHelper
	    });
	  }
	
	  function postLookupSearchHelper() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$pageNumber = _ref.pageNumber,
	        pageNumber = _ref$pageNumber === undefined ? 0 : _ref$pageNumber;
	
	    postLookupSearch({ pageNumber: pageNumber, elements: els, success: receivePostLookupSearch });
	  }
	
	  function collectStatusValues() {
	    return (0, _underscore2.default)((0, _jquery2.default)(elementsMap.filterStatusCheckboxes).filter(":checked").toArray()).map(function (el) {
	      return (0, _jquery2.default)(el).val();
	    });
	  }
	
	  function collectTypeValues() {
	    return (0, _underscore2.default)((0, _jquery2.default)(elementsMap.filterTypeCheckboxes).filter(":checked").toArray()).map(function (el) {
	      return (0, _jquery2.default)(el).val();
	    });
	  }
	
	  var searchRequest = void 0;
	
	  function postLookupSearch() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var elements = options.elements,
	        pageNumber = options.pageNumber,
	        size = options.size,
	        orderBy = options.orderBy,
	        orderByType = options.orderByType,
	        url = options.url,
	        _options$success = options.success,
	        _success = _options$success === undefined ? noop : _options$success,
	        _options$error = options.error,
	        error = _options$error === undefined ? noop : _options$error;
	    // Show loading overlay
	
	
	    if (searchRequest) {
	      // console.log("aborting");
	      searchRequest.abort();
	    }
	
	    searchRequest = _jquery2.default.ajax({
	      url: url || els.filterUrl,
	      type: 'POST',
	      data: getCurrentPageDataForSearch(options),
	      dataType: 'JSON',
	      // DONT DO THIS
	      // async: false,
	      success: function success(data) {
	        // hide loading overlay
	        searchRequest = null;
	        _success(data);
	      },
	      error: error
	    });
	  }
	
	  function receivePostLookupSearch(newData) {
	    workOrdersDataTable.fnClearTable();
	    els.workOrders = newData;
	    if (els.workOrders.content.length > 0) {
	      workOrdersDataTable.fnAddData(els.workOrders.content);
	    } else {
	      els.emptyDiv.text(els.lang['lookup-filter-no-results-found']);
	    }
	    paginator.setTableData(els.workOrders);
	    window.pushFilterSessionCacheState(els.workOrders.page.size, els.workOrders.page.number);
	  }
	
	  function getCurrentPageDataForSearch(_ref2) {
	    var _$$param;
	
	    var _ref2$elements = _ref2.elements,
	        elements = _ref2$elements === undefined ? els : _ref2$elements,
	        pageNumber = _ref2.pageNumber,
	        size = _ref2.size,
	        orderBy = _ref2.orderBy,
	        orderByType = _ref2.orderByType;
	
	    var dataStr = elements.form.serialize();
	    var additionalDataStr = _jquery2.default.param((_$$param = {}, _defineProperty(_$$param, namespace + 'page', (0, _general.isPresent)(pageNumber) ? pageNumber : 0), _defineProperty(_$$param, namespace + 'size', (0, _general.isPresent)(size) ? size : elements.itemsPerPageSelect.val()), _defineProperty(_$$param, namespace + 'orderBy', (0, _general.isPresent)(orderBy) ? orderBy : elements.sortFieldHiddenInput.val()), _defineProperty(_$$param, namespace + 'orderByType', orderByType || elements.sortTypeHiddenInput.val()), _$$param));
	
	    return dataStr + "&" + additionalDataStr;
	  }
	
	  els.clearFilters.click(function (e) {
	    // DIRECT PORT :( No time
	    e.stopPropagation();
	
	    els.modalFilterStatus.find(':checkbox').each(function () {
	      (0, _jquery2.default)(this).prop('checked', false);
	      (0, _jquery2.default)(this).parent().removeClass("additional-filter-selected");
	    });
	
	    els.modalFilterType.find(':checkbox').each(function () {
	      (0, _jquery2.default)(this).prop('checked', false);
	      (0, _jquery2.default)(this).parent().removeClass("additional-filter-selected");
	    });
	
	    /* remove criteria */
	    window.addToCriteria('status', []);
	    window.addToCriteria('type', []);
	
	    els.showAdditionalFilterInput.val(els.lang['work-order-additional-filter-text']);
	    (0, _jquery2.default)(this).hide();
	    postLookupSearchHelper();
	  });
	
	  els.modalFilterCancel.click(function () {
	    // DIRECT PORT :( No time
	    els.modalFilterStatus.each(function () {
	      window.applyAdditionalFilterCancel('status', (0, _jquery2.default)(this));
	    });
	
	    els.modalFilterType.each(function () {
	      window.applyAdditionalFilterCancel('type', (0, _jquery2.default)(this));
	    });
	  });
	
	  // This event notably comes from the backend js file,
	  // this is a work-around for now to allow the abundance of
	  // triggerSearch calls to be ported to the front
	  els.lookupOuter.on('exec-search', handleExecSearchEvent);
	
	  function handleExecSearchEvent(e, pageNumber) {
	    postLookupSearchHelper({ pageNumber: pageNumber });
	  }
	
	  var workOrdersDataTable = els.table.dataTable(_extends({}, defaultLookupDataTableOptions, {
	    data: els.workOrders.content,
	    columns: [{
	      data: "worId",
	      "class": "anchor-text",
	      render: renderWorkOrderDetailLink
	    }, {
	      data: "worSubject"
	    }, {
	      data: "retailer.rtlName",
	      "visible": els.workOrders.isCsrOrSysAdmin
	    }, {
	      data: "worType"
	    }, {
	      data: "worReqCompletionDate",
	      "visible": els.workOrders.isCsrOrSysAdmin
	    }, {
	      data: "worEstiCompletionDate",
	      "visible": els.workOrders.isRetailer
	    }, {
	      data: "statusPill"
	    }, {
	      data: "worActionIcons"
	    }]
	  }));
	
	  function renderWorkOrderDetailLink(data, type, row) {
	    return '<a href=' + els.detailUrl + '&worId=' + data + '&retailerId=' + row.retailer.rtlId + '> ' + data + ' </a>';
	  }
	
	  els.table.on("click", "tbody td .cancel-work-order-icon", function () {
	    var row = workOrdersDataTable.api().row((0, _jquery2.default)(this).closest('tr'));
	    els.cancelWorkOrderModal.appendTo("body").data('row', row).modal("show");
	  });
	
	  els.table.on("click", "tbody td .edit-wo-icon", function () {
	    var row = workOrdersDataTable.api().row((0, _jquery2.default)(this).closest('tr'));
	    location.href = els.createUpdateUrl + '&worId=' + row.data().worId;
	  });
	
	  els.cancelWorkOrder.on("click", function () {
	    if (els.reasonForCancellation.val().length == 0) {
	      //validation
	      return false;
	    }
	
	    var submitModalFlow = new _SubmitModalFlow2.default();
	    submitModalFlow.init();
	    els.cancelWorkOrderModal.modal("hide");
	    submitModalFlow.showLoadingModal();
	
	    var $this = (0, _jquery2.default)(this);
	    $this.fadeTo(500, 0.3);
	    var label = $this.html();
	    $this.html(processingLabel);
	
	    var row = els.cancelWorkOrderModal.data('row');
	    _jquery2.default.ajax({
	      url: els.calcelUrl,
	      type: "POST",
	      data: {
	        worId: row.data().worId,
	        comment: els.reasonForCancellation.val()
	      },
	      dataType: "JSON",
	      success: function success(data) {
	        if (data.status === "Success") {
	          els.reasonForCancellation.val("");
	          $this.fadeTo(500, 1);
	          $this.html(label);
	          var d = row.data();
	          d.worId = row.data().worId;
	          d.worSubject = row.data().worSubject;
	          d.worType = row.data().worType;
	          d.worEstiCompletionDate = row.data().worEstiCompletionDate;
	          d.worActionIcons = '<div style=\'float:left\'> <i class=\'fa fa-ban fa-lg\' style=\'color:lightgrey; cursor:not-allowed;\'></i>\n                              &nbsp;&nbsp;&nbsp;<i class=\'fa fa-pencil fa-lg\' style=\'color:lightgrey; cursor:not-allowed;\'> </i> </div>';
	          d.statusPill = '<div class=\'q-pill q-pill-light-grey q-pill-table\'>Canceled</div>';
	          row.data(d).draw();
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            submitModalFlow.hideAllModals();
	          }, _constants.SUCCESS_MODAL_TIMEOUT);
	        } else {
	          submitModalFlow.showFailureModal();
	        }
	      },
	      error: function error() {
	        submitModalFlow.hideAllModals();
	      }
	    });
	  });
	}

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _QuickFileUploader = __webpack_require__(85);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(1);
	
	__webpack_require__(1122);
	
	// Live form from jsp
	(0, _run2.default)("#work-order-details", function () {
	  var el = $("#work-order-details");
	  workOrderDetails(el);
	});
	
	function workOrderDetails(el) {
	
	  //data from JSP
	  var workOrder = JSON.parse(JSON.stringify(el.data("work-order")));
	  var cancelWOUrl = el.data("cancel-wo-url");
	  var addQuoteUrl = el.data("add-quote-url");
	  var approveQuoteUrl = el.data("approve-quote-url");
	  var rejectQuoteUrl = el.data("reject-quote-url");
	  var rejectAndCancelQuoteUrl = el.data("reject-and-cancel-wo-url");
	  var postWorkOrderCommentUrl = el.data("post-work-order-comment-url");
	  var updateWOStatusUrl = el.data("update-wo-status-url");
	  var statusAssigned = el.data("status-assigned");
	  var statusInProcess = el.data("status-in-process");
	  var statusCompleted = el.data("status-completed");
	
	  //Find ids
	  var cancelWorkOrderBtn = el.find(".wo-cancel-work-order-btn");
	  var approveQuoteBtn = el.find(".wo-approve-quote-btn");
	  var rejectQuoteBtn = el.find(".wo-reject-quote-btn");
	  var addQuoteBtn = el.find(".wo-add-quote-btn");
	  var updateQuoteBtn = el.find(".wo-update-quote-btn");
	  var assignToFacilityBtn = el.find(".wo-assign-to-facility-btn");
	  var markAsInProcessBtn = el.find(".wo-mark-as-in-process-btn");
	  var markAsCompleteBtn = el.find(".wo-mark-as-complete-btn");
	
	  var cancelWorkOrderModal = $("#cancel-work-order-modal");
	  var cancelWorkOrder = cancelWorkOrderModal.find(".cancel-work-order");
	
	  var approveQuoteModal = $("#approve-quote-modal");
	  var approveQuote = approveQuoteModal.find(".approve-quote");
	
	  var rejectQuoteModal = $("#reject-quote-modal");
	  var rejectQuote = rejectQuoteModal.find(".reject-quote");
	  var rejectAndCancelQuote = rejectQuoteModal.find(".rejectandcancel-quote");
	
	  var addQuoteModal = $("#add-quote-modal");
	  var addQuote = addQuoteModal.find(".add-quote");
	  var cancelQuoteBtn = addQuoteModal.find(".cancel-quote");
	
	  var cancelQuoteModal = $("#cancel-quote-modal");
	  var cancelQuote = cancelQuoteModal.find(".no-btn");
	
	  var postCommentBtn = el.find(".post-comment");
	  var postCommentText = el.find("#postComment");
	
	  var modalOpts = { backdrop: 'static', show: false };
	  cancelWorkOrderModal.modal(modalOpts);
	  approveQuoteModal.modal(modalOpts);
	  rejectQuoteModal.modal(modalOpts);
	  addQuoteModal.modal(modalOpts);
	  cancelQuoteModal.modal(modalOpts);
	
	  var quoteUploaderEl = addQuoteModal.find(".quote-uploader");
	  (0, _QuickFileUploader.quickFileUploader)(quoteUploaderEl);
	
	  $('.quote-uploader input').on("change", function () {
	    var validator = $(".wo-add-quote-form").validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	    validator.elements().valid();
	  });
	
	  $(cancelWorkOrderBtn).on("click", function (e) {
	    e.preventDefault();
	    cancelWorkOrderModal.modal("show");
	  });
	
	  $(cancelWorkOrder).on("click", function () {
	    var validator = $(".wo-cancel-form").validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	    if (validator.elements().valid()) {
	      var submitModalFlow = new _SubmitModalFlow2.default();
	      submitModalFlow.init();
	      cancelWorkOrderModal.modal('hide');
	      submitModalFlow.showLoadingModal();
	      $.ajax({
	        url: cancelWOUrl,
	        type: 'POST',
	        dataType: 'JSON',
	        data: {
	          worId: workOrder.worId,
	          comment: $('#cancelWOReason').val()
	        },
	        success: function success() {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.reload();
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        },
	        error: function error() {
	          submitModalFlow.hideAllModals();
	        }
	      });
	    }
	  });
	
	  $(addQuote).on("click", function () {
	    var validator = $(".wo-add-quote-form").validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	    if (validator.elements().valid()) {
	      var submitModalFlow = new _SubmitModalFlow2.default();
	      submitModalFlow.init();
	      addQuoteModal.modal('hide');
	      submitModalFlow.showLoadingModal();
	      var formData = new FormData();
	      formData.append('worId', workOrder.worId);
	      formData.append('worCost', $('#worCost').val());
	      formData.append('worEstiDuration', $('#worEstiDuration').val());
	      formData.append('quoteFile', $('#quoteFile')[0].files[0]);
	      $.ajax({
	        url: addQuoteUrl,
	        type: 'POST',
	        dataType: 'JSON',
	        data: formData,
	        processData: false, // tell jQuery not to process the data
	        contentType: false, // tell jQuery not to set contentType
	        success: function success() {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.reload();
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        },
	        error: function error() {
	          submitModalFlow.hideAllModals();
	        }
	      });
	    }
	  });
	
	  $(cancelQuote).on("click", function () {
	    addQuoteModal.modal("show");
	  });
	
	  $(approveQuote).on("click", function () {
	    var submitModalFlow = new _SubmitModalFlow2.default();
	    submitModalFlow.init();
	    approveQuoteModal.modal('hide');
	    submitModalFlow.showLoadingModal();
	    $.ajax({
	      url: approveQuoteUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        worId: workOrder.worId
	      },
	      success: function success() {
	        submitModalFlow.showSuccessModal();
	        setTimeout(function () {
	          location.reload();
	        }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	      },
	      error: function error() {
	        submitModalFlow.hideAllModals();
	      }
	    });
	  });
	
	  $(rejectQuote).on("click", function () {
	    var validator = $(".wo-reject-quote-form").validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	    if (validator.elements().valid()) {
	      var submitModalFlow = new _SubmitModalFlow2.default();
	      submitModalFlow.init();
	      rejectQuoteModal.modal('hide');
	      submitModalFlow.showLoadingModal();
	      $.ajax({
	        url: rejectQuoteUrl,
	        type: 'POST',
	        dataType: 'JSON',
	        data: {
	          worId: workOrder.worId,
	          comment: $('#rejectQuoteComment').val()
	        },
	        success: function success() {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.reload();
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        },
	        error: function error() {
	          submitModalFlow.hideAllModals();
	        }
	      });
	    }
	  });
	
	  $(rejectAndCancelQuote).on("click", function () {
	    var validator = $(".wo-reject-quote-form").validate({
	      errorPlacement: function errorPlacement(error, element) {
	        var appendClosest = $(element).data('error-placement-append-closest');
	        if (appendClosest) {
	          $(element).closest(appendClosest).append(error);
	        } else {
	          error.insertAfter(element);
	        }
	      }
	    });
	    if (validator.elements().valid()) {
	      var submitModalFlow = new _SubmitModalFlow2.default();
	      submitModalFlow.init();
	      rejectQuoteModal.modal('hide');
	      submitModalFlow.showLoadingModal();
	      $.ajax({
	        url: rejectAndCancelQuoteUrl,
	        type: 'POST',
	        dataType: 'JSON',
	        data: {
	          worId: workOrder.worId,
	          comment: $('#rejectQuoteComment').val()
	        },
	        success: function success() {
	          submitModalFlow.showSuccessModal();
	          setTimeout(function () {
	            location.reload();
	          }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	        },
	        error: function error() {
	          submitModalFlow.hideAllModals();
	        }
	      });
	    }
	  });
	
	  function updateWOStatus(status) {
	    $.ajax({
	      url: updateWOStatusUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        worId: workOrder.worId,
	        worStatus: status
	      },
	      success: function success() {
	        location.reload();
	      }
	    });
	  }
	
	  approveQuoteBtn.on("click", function (e) {
	    e.preventDefault();
	    approveQuoteModal.modal("show");
	  });
	
	  rejectQuoteBtn.on("click", function (e) {
	    e.preventDefault();
	    rejectQuoteModal.modal("show");
	  });
	
	  addQuoteBtn.on("click", function (e) {
	    e.preventDefault();
	    addQuoteModal.modal("show");
	  });
	
	  cancelQuoteBtn.on("click", function (e) {
	    e.preventDefault();
	    addQuoteModal.modal("hide");
	    cancelQuoteModal.modal("show");
	  });
	
	  updateQuoteBtn.on("click", function (e) {
	    e.preventDefault();
	    addQuoteModal.modal("show");
	  });
	
	  postCommentBtn.on("click", function (e) {
	    e.preventDefault();
	    if ($.trim(postCommentText.val())) {
	      submitUserComment();
	    }
	  });
	
	  function submitUserComment() {
	    $.ajax({
	      url: postWorkOrderCommentUrl,
	      type: 'POST',
	      dataType: 'JSON',
	      data: {
	        worId: workOrder.worId,
	        postComment: postCommentText.val()
	      },
	      success: function success() {
	        location.reload();
	      }
	    });
	  }
	
	  assignToFacilityBtn.on("click", function (e) {
	    e.preventDefault();
	    updateWOStatus(statusAssigned);
	  });
	
	  markAsInProcessBtn.on("click", function (e) {
	    e.preventDefault();
	    updateWOStatus(statusInProcess);
	  });
	
	  markAsCompleteBtn.on("click", function (e) {
	    e.preventDefault();
	    updateWOStatus(statusCompleted);
	  });
	}

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _selectorHelpers = __webpack_require__(4);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _render = __webpack_require__(6);
	
	var _render2 = _interopRequireDefault(_render);
	
	var _instantiateSwitchery = __webpack_require__(24);
	
	var _EditChecker = __webpack_require__(15);
	
	var _EditChecker2 = _interopRequireDefault(_EditChecker);
	
	var _SubmitModalFlow = __webpack_require__(9);
	
	var _SubmitModalFlow2 = _interopRequireDefault(_SubmitModalFlow);
	
	var _constants = __webpack_require__(10);
	
	var _index = __webpack_require__(96);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var $ = __webpack_require__(1);
	
	var fileNameRowHtml = __webpack_require__(1461);
	
	// Live form from jsp
	(0, _run2.default)("#workorder-form-id", function () {
	  var el = $("#workorder-form-id");
	  workOrderForm(el);
	  setupEditChecker();
	});
	
	function setupEditChecker() {
	  _EditChecker2.default.bindNavigation();
	  _EditChecker2.default.bindChangeListener("#workorder-form-id");
	  _EditChecker2.default.bindChangeListener("span.select2");
	  _EditChecker2.default.bindCancelButton("#workorder-cancel-btn");
	}
	
	function workOrderForm(el) {
	  var namespace = el.data("namespace");
	  var submitURL = el.data("submit-wo-url");
	  var woDetailURL = el.data("wo-detail-url");
	  var workOrderTypeSelect = $("#create-update-wo-type");
	  var workOrderTypeList = workOrderTypeSelect.data('options');
	  var productLookUpURL = el.data('product-lookup-url');
	  var rmaLookUpURL = el.data('rma-lookup-url');
	  var orderLookUpURL = el.data('order-lookup-url');
	  var shipmentLookUpURL = el.data('shipment-lookup-url');
	  var worType = el.data('work-order-type');
	  var facId = el.data('fac-id');
	  var existingWOId = el.data('existing-wo-id');
	  var woFiles = _underscore2.default.toArray(el.data('work-order-files'));
	  var facilitiesSelect = $("#create-update-facilities");
	  var facilitiesList = facilitiesSelect.data('options');
	  var relatedEntities = el.data("related-entities");
	  var submitModalTitleTxt = el.data("submit-modal-title-txt");
	  var submitModalBodyTxt = el.data("submit-modal-body-txt");
	  var submitModalBtnTxt = el.data("submit-modal-btn-txt");
	  var relatedOrderSelectData = relatedEntities;
	
	  var editFileList = [];
	  for (var i = 0; i < woFiles.length; i++) {
	    editFileList.push(woFiles[i].cisId);
	  }
	
	  var woFileUploader = new _index2.default({
	    target: '.wo-uploader',
	    multiple: true,
	    maxFileSize: 5,
	    afterValidSelection: function afterValidSelection() {
	      $(".select-files-btn").removeClass("disabled");
	      renderSelectedFilesInRow(woFiles);
	      validateFileLength();
	    },
	    afterInvalidSelection: function afterInvalidSelection() {
	      renderSelectedFilesInRow(woFiles);
	    }
	  });
	
	  woFileUploader.init();
	
	  renderSelectedFilesInRow(woFiles);
	  function renderSelectedFilesInRow(items) {
	    var fileListHtml = items.map(function (item, index) {
	      return (0, _render2.default)(fileNameRowHtml, {
	        fileName: item.cisFileName,
	        cisId: item.cisId
	      });
	    });
	    $('.file-name-render-area').append(fileListHtml.join(""));
	  }
	
	  $('body').find(".mfu-file-input").on('change', validateFileLength);
	  $('body').find(".file-remove-btn").on('click', validateFileLength);
	  //$('.file-remove-btn').on('click',validateFileLength);
	
	  $('body').find('.file-remove-btn-edit').on('click', function (e) {
	    e.preventDefault();
	    var cisIdRemoved = $(this).children('#wo-cis-id').val();
	    console.log(cisIdRemoved);
	    for (var _i = 0; _i < editFileList.length; _i++) {
	      if (cisIdRemoved == editFileList[_i]) editFileList.splice(_i, 1);
	    }
	    for (var _i2 = 0; _i2 < woFiles.length; _i2++) {
	      if (cisIdRemoved == woFiles[_i2].cisId) woFiles.splice(_i2, 1);
	    }
	    $(this).closest(".file-name-row").remove();
	    validateFileLength();
	  });
	
	  function validateFileLength() {
	    var files = woFileUploader.getFiles();
	    if (files != null && files.length + editFileList.length >= 11) {
	      $(".select-files-btn").addClass("disabled");
	      $('#' + namespace + 'submit-wo-id').addClass("disabled");
	      $(".maxFileError").show();
	    } else {
	      $(".select-files-btn").removeClass("disabled");
	      $('#' + namespace + 'submit-wo-id').removeClass("disabled");
	      $(".maxFileError").hide();
	    }
	  }
	
	  $.each(workOrderTypeList, function (index, value) {
	    var option = $('<option /\>');
	    option.attr('value', value.cdmValue).text(value.cdmValue);
	    workOrderTypeSelect.append(option);
	  });
	
	  var validator = el.validate({
	    errorPlacement: function errorPlacement(error, element) {
	      var appendClosest = $(element).data('error-placement-append-closest');
	      if (appendClosest) {
	        $(element).closest(appendClosest).append(error);
	      } else {
	        error.insertAfter(element);
	      }
	    }
	  });
	
	  validator.settings.ignore = ":disabled,:hidden";
	
	  $.each(facilitiesList, function (index, value) {
	    var option = $('<option /\>');
	    option.attr('value', value.facId).text(value.facName);
	    facilitiesSelect.append(option);
	  });
	
	  if (existingWOId != "") {
	    workOrderTypeSelect.val(worType).trigger('change.select2');
	    facilitiesSelect.val(facId).trigger('change.select2');
	  }
	
	  var select2AjaxDefaults = {
	    dataType: 'json',
	    delay: 250,
	    processResults: function processResults(data, params) {
	      params.page = params.page || 1;
	      return {
	        results: data,
	        pagination: {
	          more: params.page * 20 < data.total_count
	        }
	      };
	    },
	    cache: true
	  };
	
	  function configureDataCallback(_ref) {
	    var paramKey = _ref.paramKey;
	
	    return function (params) {
	      return _defineProperty({}, paramKey, params.term);
	    };
	  }
	
	  var switcheryConfig = {
	    size: "small",
	    color: '#0D74E9'
	  };
	
	  var groupedRelatedSelectData = (0, _underscore2.default)(relatedOrderSelectData).groupBy(function (obj) {
	    return obj.creToEntityType;
	  });
	
	  if (_underscore2.default.toArray(groupedRelatedSelectData.product).length > 0) {
	    var relatedProductCheckEl = $('#woRelatedCheckbox');
	    (0, _instantiateSwitchery.instantiateSwitchery)(relatedProductCheckEl, switcheryConfig);
	    (0, _instantiateSwitchery.setSwitchery)(relatedProductCheckEl, true);
	  }
	
	  if (_underscore2.default.toArray(groupedRelatedSelectData.order).length > 0) {
	    var _relatedProductCheckEl = $('#woRelatedOrdersCheckbox');
	    (0, _instantiateSwitchery.instantiateSwitchery)(_relatedProductCheckEl, switcheryConfig);
	    (0, _instantiateSwitchery.setSwitchery)(_relatedProductCheckEl, true);
	  }
	
	  if (_underscore2.default.toArray(groupedRelatedSelectData.asn).length > 0) {
	
	    var _relatedProductCheckEl2 = $('#woInboundShipmentsCheckbox');
	    (0, _instantiateSwitchery.instantiateSwitchery)(_relatedProductCheckEl2, switcheryConfig);
	    (0, _instantiateSwitchery.setSwitchery)(_relatedProductCheckEl2, true);
	  }
	
	  if (_underscore2.default.toArray(groupedRelatedSelectData.rma).length > 0) {
	    var _relatedProductCheckEl3 = $('#woRelatedReturnsCheckbox');
	    (0, _instantiateSwitchery.instantiateSwitchery)(_relatedProductCheckEl3, switcheryConfig);
	    (0, _instantiateSwitchery.setSwitchery)(_relatedProductCheckEl3, true);
	  }
	
	  var relatedProductSelectArray = (0, _underscore2.default)(groupedRelatedSelectData.product).pluck("creToEntityId");
	  (0, _selectorHelpers.setOptionsForSelect)({
	    list: groupedRelatedSelectData.product,
	    valueDataKey: "creToEntityId",
	    textDataKey: "creToEntityId",
	    selectElement: $("#wo-product-look-id"),
	    initialSelectValue: relatedProductSelectArray
	  });
	
	  var relatedOrderSelectArray = (0, _underscore2.default)(groupedRelatedSelectData.order).pluck("creToEntityId");
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    list: groupedRelatedSelectData.order,
	    valueDataKey: "creToEntityId",
	    textDataKey: "creToEntityId",
	    selectElement: $("#wo-order-lookup-id"),
	    initialSelectValue: relatedOrderSelectArray
	  });
	
	  var relatedRMASelectArray = (0, _underscore2.default)(groupedRelatedSelectData.rma).pluck("creToEntityId");
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    list: groupedRelatedSelectData.rma,
	    valueDataKey: "creToEntityId",
	    textDataKey: "creToEntityId",
	    selectElement: $("#wo-rma-lookup-id"),
	    initialSelectValue: relatedRMASelectArray
	  });
	
	  var relatedASNSelectArray = (0, _underscore2.default)(groupedRelatedSelectData.asn).pluck("creToEntityId");
	
	  (0, _selectorHelpers.setOptionsForSelect)({
	    list: groupedRelatedSelectData.asn,
	    valueDataKey: "creToEntityId",
	    textDataKey: "creToEntityId",
	    selectElement: $("#wo-shipment-lookup-id"),
	    initialSelectValue: relatedASNSelectArray
	  });
	
	  $("#wo-product-look-id").select2({
	    ajax: _extends({}, select2AjaxDefaults, {
	      url: productLookUpURL,
	      data: configureDataCallback({ paramKey: 'likeSku' })
	    }),
	    minimumInputLength: 3
	  });
	
	  $("#wo-order-lookup-id").select2({
	    ajax: _extends({}, select2AjaxDefaults, {
	      url: orderLookUpURL,
	      data: configureDataCallback({ paramKey: 'likeOrderId' })
	    }),
	    minimumInputLength: 3
	  });
	
	  $("#wo-rma-lookup-id").select2({
	    ajax: _extends({}, select2AjaxDefaults, {
	      url: rmaLookUpURL,
	      data: configureDataCallback({ paramKey: 'likeRmaNumber' })
	    }),
	    minimumInputLength: 3
	  });
	  $("#wo-shipment-lookup-id").select2({
	    ajax: _extends({}, select2AjaxDefaults, {
	      url: shipmentLookUpURL,
	      data: configureDataCallback({ paramKey: 'likeShipmentId' })
	    }),
	    minimumInputLength: 3
	  });
	
	  var today = new Date();
	  var tomorrow = today.getDate() + 1;
	  today.setDate(tomorrow);
	  $('#' + namespace + 'workOrderRequested').datepicker({
	    startDate: today,
	    todayBtn: "linked",
	    keyboardNavigation: false,
	    autoclose: true
	  });
	
	  $('#' + namespace + 'submit-wo-id').on("click", function (e) {
	    e.preventDefault();
	    if (validator.elements().valid() && !$('.q-alert-red').is(':visible')) {
	      var submitModalFlow = new _SubmitModalFlow2.default({
	        confirmModalTitle: submitModalTitleTxt,
	        confirmModalBody: '<div class="q-pad-all-xl">' + submitModalBodyTxt + '</div>',
	        confirmModalBtnText: submitModalBtnTxt,
	        onConfirmClick: function onConfirmClick() {
	          submitModalFlow.showLoadingModal();
	          submitWO({ url: submitURL, success: submitWOSuccess, error: submitWOError }, woFileUploader.getFiles());
	
	          function submitWO(_ref3, fileList) {
	            var url = _ref3.url,
	                success = _ref3.success,
	                error = _ref3.error;
	
	            var formData = new FormData($('#workorder-form-id')[0]);
	            var editFileIds = "";
	            for (var _i3 = 0; _i3 < editFileList.length; _i3++) {
	              editFileIds = editFileIds.concat(editFileList[_i3] + ",");
	            }
	            if (typeof fileList != "undefined") {
	              fileList.forEach(function (file) {
	                formData.append("files[]", file);
	              });
	            }
	            formData.append("editFileIds", editFileIds);
	            formData.append("dummy", "test"); //IE needs at least one append after create FormData object, it is crazy.
	            $.ajax({
	              data: formData,
	              url: url,
	              dataType: "JSON",
	              type: 'POST',
	              processData: false, // tell jQuery not to process the data
	              contentType: false, // tell jQuery not to set contentType
	              success: success,
	              error: error
	            });
	          }
	
	          function submitWOSuccess(worId) {
	            if (worId > 0) {
	              _EditChecker2.default.setPageClean();
	              var woDetailUrlFullURL = woDetailURL + '&worId=' + worId;
	              $(".create-update-wo-success-anchor").attr("href", woDetailUrlFullURL);
	              submitModalFlow.showSuccessModal();
	              setTimeout(function () {
	                location.href = woDetailUrlFullURL;
	              }, _constants.SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
	            } else {
	              submitModalFlow.showFailureModal();
	            }
	          }
	
	          function submitWOError() {
	            submitModalFlow.hideAllModals();
	          }
	        }
	      });
	      submitModalFlow.init();
	      submitModalFlow.showConfirmModal();
	    }
	  });
	}

/***/ },
/* 834 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var orderData = exports.orderData = [{
	  "itmId": "SKU1234561",
	  "itmSku": "SKU123456",
	  "prdNameAndAttributes": "Rad Name",
	  "availUnit": "0",
	  "type": "Parcel"
	
	}, {
	  "itmId": "SKU1234562",
	  "itmSku": "SKU123456",
	  "prdNameAndAttributes": "No Name",
	  "availUnit": "500",
	  "type": "Parcel"
	}, {
	  "itmId": "SKU1234563",
	  "itmSku": "SKU123456",
	  "prdNameAndAttributes": "Queue Name",
	  "availUnit": "68",
	  "type": "Parcel"
	}];

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _events = __webpack_require__(131);
	
	var _objectAssign = __webpack_require__(107);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NormalizedEmitter = (0, _objectAssign2.default)({}, _events.EventEmitter.prototype);
	
	exports.default = NormalizedEmitter;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function () {
	  (0, _jquery2.default)(document).on("click", ".func-date-range-icon-focuser", function (e) {
	    e.preventDefault();
	    var toggler = (0, _jquery2.default)(this);
	    toggler.closest('.func-date-range-wrapper').find(".func-date-range-input").focus();
	  });
	});

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bindTopNavHamburger = bindTopNavHamburger;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function bindTopNavHamburger(topNavBurger) {
	  topNavBurger.on('click', onBurgerClick);
	
	  function onBurgerClick(e) {
	    e.preventDefault();
	    var link = (0, _jquery2.default)(this);
	    link.closest('.navbar').find('.top-nav-list-content').collapse('toggle');
	  }
	}

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _stores = __webpack_require__(99);
	
	var _stores2 = _interopRequireDefault(_stores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function () {
	  loadJsStoreDataFromDom();
	
	  function loadJsStoreDataFromDom() {
	    (0, _jquery2.default)(".js-store-data").each(function () {
	      var dataElement = (0, _jquery2.default)(this);
	      loadJsStoreDataFromElement(dataElement);
	    });
	  }
	
	  function loadJsStoreDataFromElement(el) {
	    var storeName = el.data('js-store-name');
	    var jsStoreData = el.data('js-store-data');
	    var store = _stores2.default[storeName];
	    if (store) {
	      store.normalizeAndStoreData(jsStoreData);
	    } else {
	      console.log("The store that was specified with name " + storeName + " is not an actual js store!");
	    }
	  }
	});

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _run = __webpack_require__(3);
	
	var _run2 = _interopRequireDefault(_run);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function () {
	  // create a new close helper so jquery/bootstrap versions don't conflict
	  (0, _jquery2.default)(document).on("click", '.modal-auto-hide', function (e) {
	    e.preventDefault();
	    var el = (0, _jquery2.default)(this);
	    el.closest('.modal').modal('hide');
	  });
	});

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(7);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// delivery holidays:
	// New Year's Day, Memorial Day, 4th of July, Labor Day, Thanksgiving Day and Christmas Day.
	var lookup = {
	  shippingHolidays: toKeyValuePair("New Year's Day", "Memorial Day", "Independence Day", "Labor Day", "Thanksgiving Day", "Christmas Day")
	
	  //Holiday definitions
	};var _holidays = {
	  'M': { //Month, Day
	    '01/01': "New Year's Day",
	    '07/04': "Independence Day",
	    '11/11': "Veteran's Day",
	    '11/28': "Thanksgiving Day",
	    '11/29': "Day after Thanksgiving",
	    '12/24': "Christmas Eve",
	    '12/25': "Christmas Day",
	    '12/31': "New Year's Eve"
	  },
	  'W': { //Month, Week of Month, Day of Week
	    '1/3/1': "Martin Luther King Jr. Day",
	    '2/3/1': "Washington's Birthday",
	    '5/5/1': "Memorial Day",
	    '9/1/1': "Labor Day",
	    '10/2/1': "Columbus Day",
	    '11/4/4': "Thanksgiving Day"
	  }
	};
	
	_moment2.default.fn.holiday = function () {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      includes = _ref.includes,
	      holidayLookup = _ref.holidayLookup;
	
	  var diff = 1 + (0 | (this._d.getDate() - 1) / 7),
	      memorial = this._d.getDay() === 1 && this._d.getDate() + 7 > 30 ? "5" : null;
	  var result = _holidays['M'][this.format('MM/DD')] || _holidays['W'][this.format('M/' + (memorial || diff) + '/d')];
	  if (holidayLookup && !_underscore2.default.isUndefined(lookup[holidayLookup])) {
	    return lookup[holidayLookup][result];
	  } else {
	    return result;
	  }
	};
	
	function toKeyValuePair() {
	  var obj = {};
	  (0, _underscore2.default)(arguments).map(function (arg) {
	    obj[arg] = arg;
	  });
	  return obj;
	}
	
	exports.default = _moment2.default;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(1128);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	__webpack_require__(1129);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// data attributes:
	// q-expander-closest
	// q-expander-open-icon
	// q-expander-close-icon
	var wind$ = window.$;
	
	(0, _jquery2.default)(function () {
	  (0, _jquery2.default)(document).on("click", ".q-expander, .quick-expander", function (e) {
	    e.preventDefault();
	    var el = (0, _jquery2.default)(this);
	    quickExpander(el);
	  });
	
	  function quickExpander(el) {
	    var rawEl = el.get(0);
	    // Note:
	    // Code Smell Ref 1: in order to accommodate
	    // ricochet window jQuery communication
	    // and bundle jQuery.
	    // once we are on the same build process
	    // and remove old window jQuery bindings,
	    // we can remove this
	    var windEl = wind$(rawEl);
	
	    var options = (0, _collectDataAttributesFor2.default)(rawEl, { prefix: "q-expander" });
	
	    var $iconTarget = (0, _jquery2.default)(el).find('.fa');
	
	    var target = (0, _jquery2.default)();
	
	    if (options.closest) {
	      target = el.closest(options.closest).find(options.target);
	    } else {
	      target = (0, _jquery2.default)(options.target);
	    }
	
	    if (isOpen(target)) {
	      quickExpanderCloseAll(target);
	      $iconTarget.removeClass(options.closeIcon).addClass(options.openIcon);
	      handleTrigger("quickExpander:expander:onClose");
	    } else {
	      quickExpanderOpenAll(target);
	      $iconTarget.removeClass(options.openIcon).addClass(options.closeIcon);
	      handleTrigger("quickExpander:expander:onOpen");
	    }
	
	    function handleTrigger(str) {
	      // Code Smell Ref 1
	      windEl.trigger(str);
	      el.trigger(str);
	    }
	
	    function quickExpanderCloseAll(target) {
	      target.each(function () {
	        quickExpanderCloseTarget((0, _jquery2.default)(this));
	      });
	    }
	
	    function quickExpanderOpenAll(target) {
	      target.each(function () {
	        quickExpanderOpenTarget((0, _jquery2.default)(this));
	      });
	    }
	
	    function quickExpanderCloseTarget(target) {
	      target.removeClass("q-expandee-open");
	      target.animate({
	        height: 0
	      }, 200);
	    }
	
	    function quickExpanderOpenTarget(target) {
	      target.addClass("q-expandee-open");
	      target.css({ height: "auto" });
	      var h = target.height();
	      target.css({ height: 0 });
	
	      target.animate({
	        height: h + "px"
	      }, 200, function () {
	        target.css({ height: "auto" });
	      });
	    }
	
	    function isOpen(target) {
	      return (0, _underscore2.default)(target.toArray()).any(function (curEl) {
	        curEl = (0, _jquery2.default)(curEl);
	        return curEl.hasClass('q-expandee-open');
	      });
	    }
	  }
	});
	
	// import "./quickExpanderTest";

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quickToggle;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _collectDataAttributesFor = __webpack_require__(47);
	
	var _collectDataAttributesFor2 = _interopRequireDefault(_collectDataAttributesFor);
	
	var _general = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _jquery2.default)(function () {
	  (0, _jquery2.default)(document).on("change", "select.quick-toggler", function (e) {
	    var el = (0, _jquery2.default)(e.target);
	    quickToggle(el);
	  });
	
	  // $("input.quick-toggler").get(0).onchange = function(){
	  //   console.log("ya");
	  // };
	
	  (0, _jquery2.default)(document).on("change", ".quick-toggler:checkbox, input[type='hidden'].quick-toggler", function (e) {
	    var el = (0, _jquery2.default)(e.target);
	    quickToggle(el);
	  });
	
	  (0, _jquery2.default)(".quick-toggler").each(function () {
	    quickToggle((0, _jquery2.default)(this), { initial: true });
	  });
	});
	
	function quickToggle(el) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      initial = _ref.initial;
	
	  var togglables = (0, _jquery2.default)();
	  var targetTogglable = (0, _jquery2.default)();
	  var options = (0, _collectDataAttributesFor2.default)(el.get(0), { prefix: "quick-toggler" });
	  if (el.is("select")) {
	    var optionEls = el.find("option");
	    var selectedOption = optionEls.filter(':selected');
	    togglables = collectTogglablesFor(optionEls);
	    togglables = collectVisible(togglables);
	    targetTogglable = collectTogglablesFor(selectedOption);
	    var speed = parseInt(options.speed, 10);
	    if (!_underscore2.default.isNumber(speed)) {
	      speed = 100;
	    }
	    animateOpacity(togglables, 0, speed, function () {
	      animateOpacity(targetTogglable, 1, speed);
	    });
	  } else if (el.is(":checkbox")) {
	    togglables = getTarget(el, options);
	    if ((0, _general.isTruthy)(options.showOnChecked)) {
	      if (el.is(":checked")) {
	        animateOpacity(togglables, 1);
	      } else {
	        animateOpacity(togglables, 0);
	      }
	    }
	    if ((0, _general.isTruthy)(options.showOnUnchecked)) {
	      if (el.is(":checked")) {
	        animateOpacity(togglables, 0);
	      } else {
	        animateOpacity(togglables, 1);
	      }
	    }
	  } else if (el.is("input[type='hidden']")) {
	    togglables = getTarget(el);
	
	    if (options.showWhenEq === el.val()) {
	      animateOpacity(togglables, 1);
	    } else {
	      animateOpacity(togglables, 0);
	    }
	  }
	}
	
	function getTarget(el) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var togglables = void 0;
	  if (options.closest) {
	    togglables = el.closest(options.closest).find(options.target);
	  } else {
	    togglables = collectTogglablesFor(el);
	  }
	  return togglables;
	}
	
	function collectTogglablesFor(els) {
	  var togglables = (0, _jquery2.default)();
	  els.each(function () {
	    var el = (0, _jquery2.default)(this);
	    var target = (0, _jquery2.default)(el.data("quick-toggler-target"));
	    togglables = togglables.add(target);
	  });
	  return togglables;
	}
	
	function collectVisible(els) {
	  var visibleEls = (0, _jquery2.default)();
	  els.each(function () {
	    var el = (0, _jquery2.default)(this);
	    if (el.is(":visible")) {
	      visibleEls = visibleEls.add(el);
	    }
	  });
	  return visibleEls;
	}
	
	// export function animateElementsOpacity([firstOptions, secondOptions], cb=()=>{}){
	//   const {element, speed, opacity} = firstOptions;
	
	//   animateOpacity(element, opacity, speed, ()=>{
	//     const {element, speed, opacity} = secondOptions;
	//       animateOpacity(element, opacity, speed, cb);
	//   });
	// }
	
	
	function animateOpacity(el) {
	  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var speed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
	  var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
	
	  if (el.length) {
	    var startCss = {};
	    var endCssDisplay = void 0;
	
	    if (opacity === 1) {
	      startCss = { display: "", opacity: 0 };
	      endCssDisplay = "";
	    } else {
	      startCss = { display: "" };
	      endCssDisplay = "none";
	    }
	
	    el.css(startCss);
	
	    el.animate({ opacity: opacity }, speed, function () {
	      el.css({ display: endCssDisplay });
	      cb();
	    });
	  } else {
	    cb();
	  }
	}

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.triggerSelectResize = triggerSelectResize;
	exports.selectResize = selectResize;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function triggerSelectResize() {
	  // Ensure the select2 has instantiated
	  (0, _jquery2.default)(document).ready(function () {
	    // Target all multi-selects
	    (0, _jquery2.default)('body').find('.select2-selection--multiple').each(function () {
	      selectResize(this);
	    });
	  });
	};
	
	function selectResize(el) {
	
	  // Stop if visible
	  if ((0, _jquery2.default)(el).is(":visible")) {
	    return;
	  }
	
	  var $self = (0, _jquery2.default)(el),
	      $inputEl = $self.find('.select2-search__field'),
	      $inputLineHeight = $inputEl.css('line-height'),
	      $inputFontSize = $inputEl.css('font-size'),
	      $inputWidth = void 0,
	      placeholderText = $inputEl.attr('placeholder'),
	      $innerSpanEl = (0, _jquery2.default)('<span class="select-copy-placeholder-text"></span>'),
	      $targetSelector = (0, _jquery2.default)('<div class="select-copy-element" style="z-index:-999999;position: absolute;top:-999999px;left:-999999px;"></div>');
	
	  // Append scratch HTML
	  (0, _jquery2.default)('body').append($targetSelector);
	
	  // Append span to scratch
	  $targetSelector.append($innerSpanEl);
	
	  // Apply CSS to new span
	  $innerSpanEl.css({
	    'font-size': $inputFontSize,
	    'line-height': $inputLineHeight
	  });
	  $innerSpanEl.text(placeholderText);
	
	  // get span placeholder text width and round it up
	  $inputWidth = Math.round($innerSpanEl.outerWidth()) + 5;
	
	  // Apply new width to original element
	  $inputEl.css('width', $inputWidth);
	
	  // remove element
	  $targetSelector.remove();
	}

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMobile = isMobile;
	exports.isTablet = isTablet;
	exports.isMobileOrTablet = isMobileOrTablet;
	exports.isDesktop = isDesktop;
	
	var _mobileDetect = __webpack_require__(1557);
	
	var _mobileDetect2 = _interopRequireDefault(_mobileDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var md = new _mobileDetect2.default(window.navigator.userAgent);
	
	function isMobile() {
	  return md.mobile();
	}
	
	function isTablet() {
	  return md.tablet();
	}
	
	function isMobileOrTablet() {
	  return isTablet() || isMobile();
	}
	
	function isDesktop() {
	  return !isMobileOrTablet();
	}

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _underscore = __webpack_require__(2);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UUID,
	    mix,
	    typeIsArray,
	    slice = [].slice;
	
	typeIsArray = Array.isArray || function (value) {
	  return {}.toString.call(value) === '[object Array]';
	};
	
	UUID = function () {
	  var i, lut, self;
	  self = {};
	  lut = [];
	  i = 0;
	  while (i < 256) {
	    lut[i] = (i < 16 ? '0' : '') + i.toString(16);
	    i++;
	  }
	  self.generate = function (options) {
	    var d0, d1, d2, d3, res;
	    if (options == null) {
	      options = {};
	    }
	    d0 = Math.random() * 0xffffffff | 0;
	    d1 = Math.random() * 0xffffffff | 0;
	    d2 = Math.random() * 0xffffffff | 0;
	    d3 = Math.random() * 0xffffffff | 0;
	    res = lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' + lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' + lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] + lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
	    if (options.noDashes) {
	      return res.replace(/-/g, '');
	    } else {
	      return res;
	    }
	  };
	  return self;
	}();
	
	mix = function mix() {
	  return _underscore2.default.mixin({
	    removeItem: function removeItem(array, item) {
	      var i, results;
	      i = array.length - 1;
	      results = [];
	      while (i >= 0) {
	        if (array[i] === item) {
	          array.splice(i, 1);
	        }
	        results.push(i--);
	      }
	      return results;
	    },
	    truncate: function truncate(str, options) {
	      if (options == null) {
	        options = {};
	      }
	      str = str || '';
	      options = _underscore2.default.defaults(options, {
	        omission: '...',
	        length: 10
	      });
	      if (str.length < options.length) {
	        return str;
	      }
	      str = str.substring(0, options.length);
	      return str + options.omission;
	    },
	    getURI: function getURI(href) {
	      var match;
	      match = href.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);
	      return match && {
	        protocol: match[1],
	        host: match[2],
	        hostname: match[3],
	        port: match[4],
	        pathname: match[5],
	        search: match[6],
	        hash: match[7]
	      };
	    },
	    smartQuotes: function smartQuotes(str) {
	      if (str == null) {
	        str = "";
	      }
	      return str.toString().replace(/(^|[-\u2014\s(\["])'/g, '$1‘').replace(/'/g, '’').replace(/(^|[-\u2014\/\[(\u2018\s])"/g, '$1“').replace(/"/g, '”').replace(/--/g, '—');
	    },
	    dasherize: function dasherize(s) {
	      return s.replace(/[A-Z]/g, function (char, index) {
	        return (index !== 0 ? '-' : '') + char.toLowerCase();
	      });
	    },
	    camelize: function camelize(s, type) {
	      var out;
	      if (type == null) {
	        type = 'lower';
	      }
	      out = s.replace(/(?:^|[-_])(\w)/g, function (_, c) {
	        if (c) {
	          return c.toUpperCase();
	        } else {
	          return '';
	        }
	      });
	      if (type === 'lower') {
	        return out.charAt(0).toLowerCase() + out.slice(1);
	      } else {
	        return out;
	      }
	    },
	    toUnderscore: function toUnderscore(s) {
	      return s.replace(/[A-Z]/g, function (char, index) {
	        return (index !== 0 ? '_' : '') + char.toLowerCase();
	      });
	    },
	    capitalize: function capitalize(s) {
	      return s[0].toUpperCase() + s.substring(1).toLowerCase();
	    },
	    pluralize: function pluralize(num, singular, plural) {
	      if (num <= 1) {
	        return num + " " + singular;
	      }
	      return num + " " + (plural != null ? plural : singular + 's');
	    },
	    image_tag: function image_tag(path, options) {
	      var el, height, width;
	      if (options == null) {
	        options = {};
	      }
	      el = (0, _jquery2.default)('<img>');
	      if (options.alt) {
	        el.attr('alt', options.alt);
	      }
	      el.attr('src', path);
	      width = options.width, height = options.height;
	      if (width != null) {
	        el.css({
	          width: width
	        });
	      }
	      if (height != null) {
	        el.css({
	          height: height
	        });
	      }
	      if (options.style != null) {
	        if (typeof options.style === 'string') {
	          el.attr('style', options.style);
	        } else if (_typeof(options.style) === 'object') {
	          el.css(options.style);
	        }
	      }
	      if (options.classList != null) {
	        el.attr('class', options.classList);
	      }
	      return (0, _jquery2.default)('<div>').html(el).html();
	    },
	    callOrReturn: function callOrReturn(obj, context) {
	      var ct;
	      ct = context || obj;
	      if (typeof obj === 'function') {
	        return obj.call(ct);
	      } else {
	        return obj;
	      }
	    },
	    wrap: function wrap(item) {
	      if (!typeIsArray(item)) {
	        item = [item];
	      }
	      return item;
	    },
	    wrapAsArray: function wrapAsArray(item) {
	      if (!typeIsArray(item)) {
	        item = [item];
	      }
	      return item;
	    },
	    only: function only(targ, arr) {
	      var out;
	      if (arr == null) {
	        arr = [];
	      }
	      out = _underscore2.default.wrap(targ).map(function (_this) {
	        return function (obj) {
	          obj = _jquery2.default.extend(true, {}, obj);
	          return (0, _underscore2.default)(arr).reduce(function (memo, attr) {
	            var key;
	            key = attr;
	            if ((typeof attr === "undefined" ? "undefined" : _typeof(attr)) === "object") {
	              key = (0, _underscore2.default)(attr).keys()[0];
	              memo[key] = (0, _underscore2.default)(obj[key]).only(attr[key]);
	            } else if (_underscore2.default.has(obj, key)) {
	              memo[key] = obj[key];
	            }
	            return memo;
	          }, {});
	        };
	      }(this));
	      if (_underscore2.default.isArray(targ)) {
	        return out;
	      } else {
	        return out[0];
	      }
	    },
	    except: function except(obj, arr) {
	      if (arr == null) {
	        arr = [];
	      }
	      obj = _jquery2.default.extend(true, {}, obj);
	      (0, _underscore2.default)(arr).each(function (_this) {
	        return function (attr) {
	          return delete obj[attr];
	        };
	      }(this));
	      return obj;
	    },
	    uuid: UUID.generate,
	    waitFor: function waitFor(promises, _deferred_, _fetchedData_) {
	      _deferred_ || (_deferred_ = _jquery2.default.Deferred());
	      _fetchedData_ || (_fetchedData_ = {});
	      promises = _underscore2.default.wrap(promises);
	      _jquery2.default.when.apply(_jquery2.default, promises).then(function (_this) {
	        return function () {
	          _fetchedData_ = _jquery2.default.extend.apply(_jquery2.default, [{}, _fetchedData_].concat(slice.call(_underscore2.default.toArray(arguments))));
	          _this._shiftDone(promises);
	          if (promises.length) {
	            return _underscore2.default.waitFor(promises, _deferred_, _fetchedData_);
	          } else {
	            return _deferred_.resolve(_fetchedData_);
	          }
	        };
	      }(this)).fail(function (_this) {
	        return function () {
	          return _deferred_.reject.apply(_this, arguments);
	        };
	      }(this));
	      return _deferred_.promise();
	    },
	    _shiftDone: function _shiftDone(promises) {
	      var promise, results;
	      if (promises == null) {
	        promises = [];
	      }
	      promises.sort(function (_this) {
	        return function (p1, p2) {
	          if (p1.state() === "resolved") {
	            return -1;
	          } else {
	            return 1;
	          }
	        };
	      }(this));
	      promise = promises[0];
	      results = [];
	      while (promise && promise.state() === "resolved") {
	        promises.shift();
	        results.push(promise = promises[0]);
	      }
	      return results;
	    },
	    collectFunctionClass: function collectFunctionClass(func, context) {
	      var classFunction, classNamespaces;
	      if (!func) {
	        return;
	      }
	      classNamespaces = func.split('.');
	      classFunction = context;
	      (0, _underscore2.default)(classNamespaces).each(function (_this) {
	        return function (classNamespace) {
	          return classFunction = classFunction != null ? classFunction[classNamespace] : void 0;
	        };
	      }(this));
	      return classFunction;
	    },
	    isArray: function isArray(value) {
	      if (Array.isArray) {
	        return Array.isArray(value);
	      } else {
	        return {}.toString.call(value) === '[object Array]';
	      }
	    },
	    addClassIfFirst: function addClassIfFirst(className, i) {
	      if (i === 0) {
	        return className;
	      }
	    }
	  });
	};
	
	module.exports = mix();

/***/ },
/* 847 */,
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Bootstrap Colorpicker v2.5.1
	 * https://itsjavi.com/bootstrap-colorpicker/
	 *
	 * Originally written by (c) 2012 Stefan Petre
	 * Licensed under the Apache License v2.0
	 * http://www.apache.org/licenses/LICENSE-2.0.txt
	 *
	 */
	
	(function(root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module unless amdModuleId is set
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(jq) {
	      return (factory(jq));
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory(require("jquery"));
	  } else if (jQuery && !jQuery.fn.colorpicker) {
	    factory(jQuery);
	  }
	}(this, function($) {
	  'use strict';
	  /**
	   * Color manipulation helper class
	   *
	   * @param {Object|String} [val]
	   * @param {Object} [predefinedColors]
	   * @param {String|null} [fallbackColor]
	   * @param {String|null} [fallbackFormat]
	   * @param {Boolean} [hexNumberSignPrefix]
	   * @constructor
	   */
	  var Color = function(
	    val, predefinedColors, fallbackColor, fallbackFormat, hexNumberSignPrefix) {
	    this.fallbackValue = fallbackColor ?
	      (
	        fallbackColor && (typeof fallbackColor.h !== 'undefined') ?
	        fallbackColor :
	        this.value = {
	          h: 0,
	          s: 0,
	          b: 0,
	          a: 1
	        }
	      ) :
	      null;
	
	    this.fallbackFormat = fallbackFormat ? fallbackFormat : 'rgba';
	
	    this.hexNumberSignPrefix = hexNumberSignPrefix === true;
	
	    this.value = this.fallbackValue;
	
	    this.origFormat = null; // original string format
	
	    this.predefinedColors = predefinedColors ? predefinedColors : {};
	
	    // We don't want to share aliases across instances so we extend new object
	    this.colors = $.extend({}, Color.webColors, this.predefinedColors);
	
	    if (val) {
	      if (typeof val.h !== 'undefined') {
	        this.value = val;
	      } else {
	        this.setColor(String(val));
	      }
	    }
	
	    if (!this.value) {
	      // Initial value is always black if no arguments are passed or val is empty
	      this.value = {
	        h: 0,
	        s: 0,
	        b: 0,
	        a: 1
	      };
	    }
	  };
	
	  Color.webColors = { // 140 predefined colors from the HTML Colors spec
	    "aliceblue": "f0f8ff",
	    "antiquewhite": "faebd7",
	    "aqua": "00ffff",
	    "aquamarine": "7fffd4",
	    "azure": "f0ffff",
	    "beige": "f5f5dc",
	    "bisque": "ffe4c4",
	    "black": "000000",
	    "blanchedalmond": "ffebcd",
	    "blue": "0000ff",
	    "blueviolet": "8a2be2",
	    "brown": "a52a2a",
	    "burlywood": "deb887",
	    "cadetblue": "5f9ea0",
	    "chartreuse": "7fff00",
	    "chocolate": "d2691e",
	    "coral": "ff7f50",
	    "cornflowerblue": "6495ed",
	    "cornsilk": "fff8dc",
	    "crimson": "dc143c",
	    "cyan": "00ffff",
	    "darkblue": "00008b",
	    "darkcyan": "008b8b",
	    "darkgoldenrod": "b8860b",
	    "darkgray": "a9a9a9",
	    "darkgreen": "006400",
	    "darkkhaki": "bdb76b",
	    "darkmagenta": "8b008b",
	    "darkolivegreen": "556b2f",
	    "darkorange": "ff8c00",
	    "darkorchid": "9932cc",
	    "darkred": "8b0000",
	    "darksalmon": "e9967a",
	    "darkseagreen": "8fbc8f",
	    "darkslateblue": "483d8b",
	    "darkslategray": "2f4f4f",
	    "darkturquoise": "00ced1",
	    "darkviolet": "9400d3",
	    "deeppink": "ff1493",
	    "deepskyblue": "00bfff",
	    "dimgray": "696969",
	    "dodgerblue": "1e90ff",
	    "firebrick": "b22222",
	    "floralwhite": "fffaf0",
	    "forestgreen": "228b22",
	    "fuchsia": "ff00ff",
	    "gainsboro": "dcdcdc",
	    "ghostwhite": "f8f8ff",
	    "gold": "ffd700",
	    "goldenrod": "daa520",
	    "gray": "808080",
	    "green": "008000",
	    "greenyellow": "adff2f",
	    "honeydew": "f0fff0",
	    "hotpink": "ff69b4",
	    "indianred": "cd5c5c",
	    "indigo": "4b0082",
	    "ivory": "fffff0",
	    "khaki": "f0e68c",
	    "lavender": "e6e6fa",
	    "lavenderblush": "fff0f5",
	    "lawngreen": "7cfc00",
	    "lemonchiffon": "fffacd",
	    "lightblue": "add8e6",
	    "lightcoral": "f08080",
	    "lightcyan": "e0ffff",
	    "lightgoldenrodyellow": "fafad2",
	    "lightgrey": "d3d3d3",
	    "lightgreen": "90ee90",
	    "lightpink": "ffb6c1",
	    "lightsalmon": "ffa07a",
	    "lightseagreen": "20b2aa",
	    "lightskyblue": "87cefa",
	    "lightslategray": "778899",
	    "lightsteelblue": "b0c4de",
	    "lightyellow": "ffffe0",
	    "lime": "00ff00",
	    "limegreen": "32cd32",
	    "linen": "faf0e6",
	    "magenta": "ff00ff",
	    "maroon": "800000",
	    "mediumaquamarine": "66cdaa",
	    "mediumblue": "0000cd",
	    "mediumorchid": "ba55d3",
	    "mediumpurple": "9370d8",
	    "mediumseagreen": "3cb371",
	    "mediumslateblue": "7b68ee",
	    "mediumspringgreen": "00fa9a",
	    "mediumturquoise": "48d1cc",
	    "mediumvioletred": "c71585",
	    "midnightblue": "191970",
	    "mintcream": "f5fffa",
	    "mistyrose": "ffe4e1",
	    "moccasin": "ffe4b5",
	    "navajowhite": "ffdead",
	    "navy": "000080",
	    "oldlace": "fdf5e6",
	    "olive": "808000",
	    "olivedrab": "6b8e23",
	    "orange": "ffa500",
	    "orangered": "ff4500",
	    "orchid": "da70d6",
	    "palegoldenrod": "eee8aa",
	    "palegreen": "98fb98",
	    "paleturquoise": "afeeee",
	    "palevioletred": "d87093",
	    "papayawhip": "ffefd5",
	    "peachpuff": "ffdab9",
	    "peru": "cd853f",
	    "pink": "ffc0cb",
	    "plum": "dda0dd",
	    "powderblue": "b0e0e6",
	    "purple": "800080",
	    "red": "ff0000",
	    "rosybrown": "bc8f8f",
	    "royalblue": "4169e1",
	    "saddlebrown": "8b4513",
	    "salmon": "fa8072",
	    "sandybrown": "f4a460",
	    "seagreen": "2e8b57",
	    "seashell": "fff5ee",
	    "sienna": "a0522d",
	    "silver": "c0c0c0",
	    "skyblue": "87ceeb",
	    "slateblue": "6a5acd",
	    "slategray": "708090",
	    "snow": "fffafa",
	    "springgreen": "00ff7f",
	    "steelblue": "4682b4",
	    "tan": "d2b48c",
	    "teal": "008080",
	    "thistle": "d8bfd8",
	    "tomato": "ff6347",
	    "turquoise": "40e0d0",
	    "violet": "ee82ee",
	    "wheat": "f5deb3",
	    "white": "ffffff",
	    "whitesmoke": "f5f5f5",
	    "yellow": "ffff00",
	    "yellowgreen": "9acd32",
	    "transparent": "transparent"
	  };
	
	  Color.prototype = {
	    constructor: Color,
	    colors: {}, // merged web and predefined colors
	    predefinedColors: {},
	    /**
	     * @return {Object}
	     */
	    getValue: function() {
	      return this.value;
	    },
	    /**
	     * @param {Object} val
	     */
	    setValue: function(val) {
	      this.value = val;
	    },
	    _sanitizeNumber: function(val) {
	      if (typeof val === 'number') {
	        return val;
	      }
	      if (isNaN(val) || (val === null) || (val === '') || (val === undefined)) {
	        return 1;
	      }
	      if (val === '') {
	        return 0;
	      }
	      if (typeof val.toLowerCase !== 'undefined') {
	        if (val.match(/^\./)) {
	          val = "0" + val;
	        }
	        return Math.ceil(parseFloat(val) * 100) / 100;
	      }
	      return 1;
	    },
	    isTransparent: function(strVal) {
	      if (!strVal || !(typeof strVal === 'string' || strVal instanceof String)) {
	        return false;
	      }
	      strVal = strVal.toLowerCase().trim();
	      return (strVal === 'transparent') || (strVal.match(/#?00000000/)) || (strVal.match(/(rgba|hsla)\(0,0,0,0?\.?0\)/));
	    },
	    rgbaIsTransparent: function(rgba) {
	      return ((rgba.r === 0) && (rgba.g === 0) && (rgba.b === 0) && (rgba.a === 0));
	    },
	    // parse a string to HSB
	    /**
	     * @protected
	     * @param {String} strVal
	     * @returns {boolean} Returns true if it could be parsed, false otherwise
	     */
	    setColor: function(strVal) {
	      strVal = strVal.toLowerCase().trim();
	      if (strVal) {
	        if (this.isTransparent(strVal)) {
	          this.value = {
	            h: 0,
	            s: 0,
	            b: 0,
	            a: 0
	          };
	          return true;
	        } else {
	          var parsedColor = this.parse(strVal);
	          if (parsedColor) {
	            this.value = this.value = {
	              h: parsedColor.h,
	              s: parsedColor.s,
	              b: parsedColor.b,
	              a: parsedColor.a
	            };
	            if (!this.origFormat) {
	              this.origFormat = parsedColor.format;
	            }
	          } else if (this.fallbackValue) {
	            // if parser fails, defaults to fallbackValue if defined, otherwise the value won't be changed
	            this.value = this.fallbackValue;
	          }
	        }
	      }
	      return false;
	    },
	    setHue: function(h) {
	      this.value.h = 1 - h;
	    },
	    setSaturation: function(s) {
	      this.value.s = s;
	    },
	    setBrightness: function(b) {
	      this.value.b = 1 - b;
	    },
	    setAlpha: function(a) {
	      this.value.a = Math.round((parseInt((1 - a) * 100, 10) / 100) * 100) / 100;
	    },
	    toRGB: function(h, s, b, a) {
	      if (arguments.length === 0) {
	        h = this.value.h;
	        s = this.value.s;
	        b = this.value.b;
	        a = this.value.a;
	      }
	
	      h *= 360;
	      var R, G, B, X, C;
	      h = (h % 360) / 60;
	      C = b * s;
	      X = C * (1 - Math.abs(h % 2 - 1));
	      R = G = B = b - C;
	
	      h = ~~h;
	      R += [C, X, 0, 0, X, C][h];
	      G += [X, C, C, X, 0, 0][h];
	      B += [0, 0, X, C, C, X][h];
	
	      return {
	        r: Math.round(R * 255),
	        g: Math.round(G * 255),
	        b: Math.round(B * 255),
	        a: a
	      };
	    },
	    toHex: function(h, s, b, a) {
	      if (arguments.length === 0) {
	        h = this.value.h;
	        s = this.value.s;
	        b = this.value.b;
	        a = this.value.a;
	      }
	
	      var rgb = this.toRGB(h, s, b, a);
	
	      if (this.rgbaIsTransparent(rgb)) {
	        return 'transparent';
	      }
	
	      var hexStr = (this.hexNumberSignPrefix ? '#' : '') + (
	          (1 << 24) +
	          (parseInt(rgb.r) << 16) +
	          (parseInt(rgb.g) << 8) +
	          parseInt(rgb.b))
	        .toString(16)
	        .slice(1);
	
	      return hexStr;
	    },
	    toHSL: function(h, s, b, a) {
	      if (arguments.length === 0) {
	        h = this.value.h;
	        s = this.value.s;
	        b = this.value.b;
	        a = this.value.a;
	      }
	
	      var H = h,
	        L = (2 - s) * b,
	        S = s * b;
	      if (L > 0 && L <= 1) {
	        S /= L;
	      } else {
	        S /= 2 - L;
	      }
	      L /= 2;
	      if (S > 1) {
	        S = 1;
	      }
	      return {
	        h: isNaN(H) ? 0 : H,
	        s: isNaN(S) ? 0 : S,
	        l: isNaN(L) ? 0 : L,
	        a: isNaN(a) ? 0 : a
	      };
	    },
	    toAlias: function(r, g, b, a) {
	      var c, rgb = (arguments.length === 0) ? this.toHex() : this.toHex(r, g, b, a);
	
	      // support predef. colors in non-hex format too, as defined in the alias itself
	      var original = this.origFormat === 'alias' ? rgb : this.toString(this.origFormat, false);
	
	      for (var alias in this.colors) {
	        c = this.colors[alias].toLowerCase().trim();
	        if ((c === rgb) || (c === original)) {
	          return alias;
	        }
	      }
	      return false;
	    },
	    RGBtoHSB: function(r, g, b, a) {
	      r /= 255;
	      g /= 255;
	      b /= 255;
	
	      var H, S, V, C;
	      V = Math.max(r, g, b);
	      C = V - Math.min(r, g, b);
	      H = (C === 0 ? null :
	        V === r ? (g - b) / C :
	        V === g ? (b - r) / C + 2 :
	        (r - g) / C + 4
	      );
	      H = ((H + 360) % 6) * 60 / 360;
	      S = C === 0 ? 0 : C / V;
	      return {
	        h: this._sanitizeNumber(H),
	        s: S,
	        b: V,
	        a: this._sanitizeNumber(a)
	      };
	    },
	    HueToRGB: function(p, q, h) {
	      if (h < 0) {
	        h += 1;
	      } else if (h > 1) {
	        h -= 1;
	      }
	      if ((h * 6) < 1) {
	        return p + (q - p) * h * 6;
	      } else if ((h * 2) < 1) {
	        return q;
	      } else if ((h * 3) < 2) {
	        return p + (q - p) * ((2 / 3) - h) * 6;
	      } else {
	        return p;
	      }
	    },
	    HSLtoRGB: function(h, s, l, a) {
	      if (s < 0) {
	        s = 0;
	      }
	      var q;
	      if (l <= 0.5) {
	        q = l * (1 + s);
	      } else {
	        q = l + s - (l * s);
	      }
	
	      var p = 2 * l - q;
	
	      var tr = h + (1 / 3);
	      var tg = h;
	      var tb = h - (1 / 3);
	
	      var r = Math.round(this.HueToRGB(p, q, tr) * 255);
	      var g = Math.round(this.HueToRGB(p, q, tg) * 255);
	      var b = Math.round(this.HueToRGB(p, q, tb) * 255);
	      return [r, g, b, this._sanitizeNumber(a)];
	    },
	    /**
	     * @param {String} strVal
	     * @returns {Object} Object containing h,s,b,a,format properties or FALSE if failed to parse
	     */
	    parse: function(strVal) {
	      if (arguments.length === 0) {
	        return false;
	      }
	
	      var that = this,
	        result = false,
	        isAlias = (typeof this.colors[strVal] !== 'undefined'),
	        values, format;
	
	      if (isAlias) {
	        strVal = this.colors[strVal].toLowerCase().trim();
	      }
	
	      $.each(this.stringParsers, function(i, parser) {
	        var match = parser.re.exec(strVal);
	        values = match && parser.parse.apply(that, [match]);
	        if (values) {
	          result = {};
	          format = (isAlias ? 'alias' : (parser.format ? parser.format : that.getValidFallbackFormat()));
	          if (format.match(/hsla?/)) {
	            result = that.RGBtoHSB.apply(that, that.HSLtoRGB.apply(that, values));
	          } else {
	            result = that.RGBtoHSB.apply(that, values);
	          }
	          if (result instanceof Object) {
	            result.format = format;
	          }
	          return false; // stop iterating
	        }
	        return true;
	      });
	      return result;
	    },
	    getValidFallbackFormat: function() {
	      var formats = [
	        'rgba', 'rgb', 'hex', 'hsla', 'hsl'
	      ];
	      if (this.origFormat && (formats.indexOf(this.origFormat) !== -1)) {
	        return this.origFormat;
	      }
	      if (this.fallbackFormat && (formats.indexOf(this.fallbackFormat) !== -1)) {
	        return this.fallbackFormat;
	      }
	
	      return 'rgba'; // By default, return a format that will not lose the alpha info
	    },
	    /**
	     *
	     * @param {string} [format] (default: rgba)
	     * @param {boolean} [translateAlias] Return real color for pre-defined (non-standard) aliases (default: false)
	     * @returns {String}
	     */
	    toString: function(format, translateAlias) {
	      format = format || this.origFormat || this.fallbackFormat;
	      translateAlias = translateAlias || false;
	
	      var c = false;
	
	      switch (format) {
	        case 'rgb':
	          {
	            c = this.toRGB();
	            if (this.rgbaIsTransparent(c)) {
	              return 'transparent';
	            }
	            return 'rgb(' + c.r + ',' + c.g + ',' + c.b + ')';
	          }
	          break;
	        case 'rgba':
	          {
	            c = this.toRGB();
	            return 'rgba(' + c.r + ',' + c.g + ',' + c.b + ',' + c.a + ')';
	          }
	          break;
	        case 'hsl':
	          {
	            c = this.toHSL();
	            return 'hsl(' + Math.round(c.h * 360) + ',' + Math.round(c.s * 100) + '%,' + Math.round(c.l * 100) + '%)';
	          }
	          break;
	        case 'hsla':
	          {
	            c = this.toHSL();
	            return 'hsla(' + Math.round(c.h * 360) + ',' + Math.round(c.s * 100) + '%,' + Math.round(c.l * 100) + '%,' + c.a + ')';
	          }
	          break;
	        case 'hex':
	          {
	            return this.toHex();
	          }
	          break;
	        case 'alias':
	          {
	            c = this.toAlias();
	
	            if (c === false) {
	              return this.toString(this.getValidFallbackFormat());
	            }
	
	            if (translateAlias && !(c in Color.webColors) && (c in this.predefinedColors)) {
	              return this.predefinedColors[c];
	            }
	
	            return c;
	          }
	        default:
	          {
	            return c;
	          }
	          break;
	      }
	    },
	    // a set of RE's that can match strings and generate color tuples.
	    // from John Resig color plugin
	    // https://github.com/jquery/jquery-color/
	    stringParsers: [{
	      re: /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*?\)/,
	      format: 'rgb',
	      parse: function(execResult) {
	        return [
	          execResult[1],
	          execResult[2],
	          execResult[3],
	          1
	        ];
	      }
	    }, {
	      re: /rgb\(\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*?\)/,
	      format: 'rgb',
	      parse: function(execResult) {
	        return [
	          2.55 * execResult[1],
	          2.55 * execResult[2],
	          2.55 * execResult[3],
	          1
	        ];
	      }
	    }, {
	      re: /rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,
	      format: 'rgba',
	      parse: function(execResult) {
	        return [
	          execResult[1],
	          execResult[2],
	          execResult[3],
	          execResult[4]
	        ];
	      }
	    }, {
	      re: /rgba\(\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,
	      format: 'rgba',
	      parse: function(execResult) {
	        return [
	          2.55 * execResult[1],
	          2.55 * execResult[2],
	          2.55 * execResult[3],
	          execResult[4]
	        ];
	      }
	    }, {
	      re: /hsl\(\s*(\d*(?:\.\d+)?)\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*?\)/,
	      format: 'hsl',
	      parse: function(execResult) {
	        return [
	          execResult[1] / 360,
	          execResult[2] / 100,
	          execResult[3] / 100,
	          execResult[4]
	        ];
	      }
	    }, {
	      re: /hsla\(\s*(\d*(?:\.\d+)?)\s*,\s*(\d*(?:\.\d+)?)\%\s*,\s*(\d*(?:\.\d+)?)\%\s*(?:,\s*(\d*(?:\.\d+)?)\s*)?\)/,
	      format: 'hsla',
	      parse: function(execResult) {
	        return [
	          execResult[1] / 360,
	          execResult[2] / 100,
	          execResult[3] / 100,
	          execResult[4]
	        ];
	      }
	    }, {
	      re: /#?([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
	      format: 'hex',
	      parse: function(execResult) {
	        return [
	          parseInt(execResult[1], 16),
	          parseInt(execResult[2], 16),
	          parseInt(execResult[3], 16),
	          1
	        ];
	      }
	    }, {
	      re: /#?([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
	      format: 'hex',
	      parse: function(execResult) {
	        return [
	          parseInt(execResult[1] + execResult[1], 16),
	          parseInt(execResult[2] + execResult[2], 16),
	          parseInt(execResult[3] + execResult[3], 16),
	          1
	        ];
	      }
	    }],
	    colorNameToHex: function(name) {
	      if (typeof this.colors[name.toLowerCase()] !== 'undefined') {
	        return this.colors[name.toLowerCase()];
	      }
	      return false;
	    }
	  };
	
	  /*
	   * Default plugin options
	   */
	  var defaults = {
	    horizontal: false, // horizontal mode layout ?
	    inline: false, //forces to show the colorpicker as an inline element
	    color: false, //forces a color
	    format: false, //forces a format
	    input: 'input', // children input selector
	    container: false, // container selector
	    component: '.add-on, .input-group-addon', // children component selector
	    fallbackColor: false, // fallback color value. null = keeps current color.
	    fallbackFormat: 'hex', // fallback color format
	    hexNumberSignPrefix: true, // put a '#' (number sign) before hex strings
	    sliders: {
	      saturation: {
	        maxLeft: 100,
	        maxTop: 100,
	        callLeft: 'setSaturation',
	        callTop: 'setBrightness'
	      },
	      hue: {
	        maxLeft: 0,
	        maxTop: 100,
	        callLeft: false,
	        callTop: 'setHue'
	      },
	      alpha: {
	        maxLeft: 0,
	        maxTop: 100,
	        callLeft: false,
	        callTop: 'setAlpha'
	      }
	    },
	    slidersHorz: {
	      saturation: {
	        maxLeft: 100,
	        maxTop: 100,
	        callLeft: 'setSaturation',
	        callTop: 'setBrightness'
	      },
	      hue: {
	        maxLeft: 100,
	        maxTop: 0,
	        callLeft: 'setHue',
	        callTop: false
	      },
	      alpha: {
	        maxLeft: 100,
	        maxTop: 0,
	        callLeft: 'setAlpha',
	        callTop: false
	      }
	    },
	    template: '<div class="colorpicker dropdown-menu">' +
	      '<div class="colorpicker-saturation"><i><b></b></i></div>' +
	      '<div class="colorpicker-hue"><i></i></div>' +
	      '<div class="colorpicker-alpha"><i></i></div>' +
	      '<div class="colorpicker-color"><div /></div>' +
	      '<div class="colorpicker-selectors"></div>' +
	      '</div>',
	    align: 'right',
	    customClass: null, // custom class added to the colorpicker element
	    colorSelectors: null // custom color aliases
	  };
	
	  /**
	   * Colorpicker component class
	   *
	   * @param {Object|String} element
	   * @param {Object} options
	   * @constructor
	   */
	  var Colorpicker = function(element, options) {
	    this.element = $(element).addClass('colorpicker-element');
	    this.options = $.extend(true, {}, defaults, this.element.data(), options);
	    this.component = this.options.component;
	    this.component = (this.component !== false) ? this.element.find(this.component) : false;
	    if (this.component && (this.component.length === 0)) {
	      this.component = false;
	    }
	    this.container = (this.options.container === true) ? this.element : this.options.container;
	    this.container = (this.container !== false) ? $(this.container) : false;
	
	    // Is the element an input? Should we search inside for any input?
	    this.input = this.element.is('input') ? this.element : (this.options.input ?
	      this.element.find(this.options.input) : false);
	    if (this.input && (this.input.length === 0)) {
	      this.input = false;
	    }
	    // Set HSB color
	    this.color = this.createColor(this.options.color !== false ? this.options.color : this.getValue());
	
	    this.format = this.options.format !== false ? this.options.format : this.color.origFormat;
	
	    if (this.options.color !== false) {
	      this.updateInput(this.color);
	      this.updateData(this.color);
	    }
	
	    // Setup picker
	    var $picker = this.picker = $(this.options.template);
	    if (this.options.customClass) {
	      $picker.addClass(this.options.customClass);
	    }
	    if (this.options.inline) {
	      $picker.addClass('colorpicker-inline colorpicker-visible');
	    } else {
	      $picker.addClass('colorpicker-hidden');
	    }
	    if (this.options.horizontal) {
	      $picker.addClass('colorpicker-horizontal');
	    }
	    if (
	      (['rgba', 'hsla', 'alias'].indexOf(this.format) !== -1) ||
	      this.options.format === false ||
	      this.getValue() === 'transparent'
	    ) {
	      $picker.addClass('colorpicker-with-alpha');
	    }
	    if (this.options.align === 'right') {
	      $picker.addClass('colorpicker-right');
	    }
	    if (this.options.inline === true) {
	      $picker.addClass('colorpicker-no-arrow');
	    }
	    if (this.options.colorSelectors) {
	      var colorpicker = this,
	        selectorsContainer = colorpicker.picker.find('.colorpicker-selectors');
	
	      if (selectorsContainer.length > 0) {
	        $.each(this.options.colorSelectors, function(name, color) {
	          var $btn = $('<i />')
	            .addClass('colorpicker-selectors-color')
	            .css('background-color', color)
	            .data('class', name).data('alias', name);
	
	          $btn.on('mousedown.colorpicker touchstart.colorpicker', function(event) {
	            event.preventDefault();
	            colorpicker.setValue(
	              colorpicker.format === 'alias' ? $(this).data('alias') : $(this).css('background-color')
	            );
	          });
	          selectorsContainer.append($btn);
	        });
	        selectorsContainer.show().addClass('colorpicker-visible');
	      }
	    }
	
	    // Prevent closing the colorpicker when clicking on itself
	    $picker.on('mousedown.colorpicker touchstart.colorpicker', $.proxy(function(e) {
	      if (e.target === e.currentTarget) {
	        e.preventDefault();
	      }
	    }, this));
	
	    // Bind click/tap events on the sliders
	    $picker.find('.colorpicker-saturation, .colorpicker-hue, .colorpicker-alpha')
	      .on('mousedown.colorpicker touchstart.colorpicker', $.proxy(this.mousedown, this));
	
	    $picker.appendTo(this.container ? this.container : $('body'));
	
	    // Bind other events
	    if (this.input !== false) {
	      this.input.on({
	        'keyup.colorpicker': $.proxy(this.keyup, this)
	      });
	      this.input.on({
	        'change.colorpicker': $.proxy(this.change, this)
	      });
	      if (this.component === false) {
	        this.element.on({
	          'focus.colorpicker': $.proxy(this.show, this)
	        });
	      }
	      if (this.options.inline === false) {
	        this.element.on({
	          'focusout.colorpicker': $.proxy(this.hide, this)
	        });
	      }
	    }
	
	    if (this.component !== false) {
	      this.component.on({
	        'click.colorpicker': $.proxy(this.show, this)
	      });
	    }
	
	    if ((this.input === false) && (this.component === false)) {
	      this.element.on({
	        'click.colorpicker': $.proxy(this.show, this)
	      });
	    }
	
	    // for HTML5 input[type='color']
	    if ((this.input !== false) && (this.component !== false) && (this.input.attr('type') === 'color')) {
	
	      this.input.on({
	        'click.colorpicker': $.proxy(this.show, this),
	        'focus.colorpicker': $.proxy(this.show, this)
	      });
	    }
	    this.update();
	
	    $($.proxy(function() {
	      this.element.trigger('create');
	    }, this));
	  };
	
	  Colorpicker.Color = Color;
	
	  Colorpicker.prototype = {
	    constructor: Colorpicker,
	    destroy: function() {
	      this.picker.remove();
	      this.element.removeData('colorpicker', 'color').off('.colorpicker');
	      if (this.input !== false) {
	        this.input.off('.colorpicker');
	      }
	      if (this.component !== false) {
	        this.component.off('.colorpicker');
	      }
	      this.element.removeClass('colorpicker-element');
	      this.element.trigger({
	        type: 'destroy'
	      });
	    },
	    reposition: function() {
	      if (this.options.inline !== false || this.options.container) {
	        return false;
	      }
	      var type = this.container && this.container[0] !== window.document.body ? 'position' : 'offset';
	      var element = this.component || this.element;
	      var offset = element[type]();
	      if (this.options.align === 'right') {
	        offset.left -= this.picker.outerWidth() - element.outerWidth();
	      }
	      this.picker.css({
	        top: offset.top + element.outerHeight(),
	        left: offset.left
	      });
	    },
	    show: function(e) {
	      if (this.isDisabled()) {
	        // Don't show the widget if it's disabled (the input)
	        return;
	      }
	      this.picker.addClass('colorpicker-visible').removeClass('colorpicker-hidden');
	      this.reposition();
	      $(window).on('resize.colorpicker', $.proxy(this.reposition, this));
	      if (e && (!this.hasInput() || this.input.attr('type') === 'color')) {
	        if (e.stopPropagation && e.preventDefault) {
	          e.stopPropagation();
	          e.preventDefault();
	        }
	      }
	      if ((this.component || !this.input) && (this.options.inline === false)) {
	        $(window.document).on({
	          'mousedown.colorpicker': $.proxy(this.hide, this)
	        });
	      }
	      this.element.trigger({
	        type: 'showPicker',
	        color: this.color
	      });
	    },
	    hide: function(e) {
	      if ((typeof e !== 'undefined') && e.target) {
	        // Prevent hide if triggered by an event and an element inside the colorpicker has been clicked/touched
	        if (
	          $(e.currentTarget).parents('.colorpicker').length > 0 ||
	          $(e.target).parents('.colorpicker').length > 0
	        ) {
	          return false;
	        }
	      }
	      this.picker.addClass('colorpicker-hidden').removeClass('colorpicker-visible');
	      $(window).off('resize.colorpicker', this.reposition);
	      $(window.document).off({
	        'mousedown.colorpicker': this.hide
	      });
	      this.update();
	      this.element.trigger({
	        type: 'hidePicker',
	        color: this.color
	      });
	    },
	    updateData: function(val) {
	      val = val || this.color.toString(this.format, false);
	      this.element.data('color', val);
	      return val;
	    },
	    updateInput: function(val) {
	      val = val || this.color.toString(this.format, false);
	      if (this.input !== false) {
	        this.input.prop('value', val);
	        this.input.trigger('change');
	      }
	      return val;
	    },
	    updatePicker: function(val) {
	      if (typeof val !== 'undefined') {
	        this.color = this.createColor(val);
	      }
	      var sl = (this.options.horizontal === false) ? this.options.sliders : this.options.slidersHorz;
	      var icns = this.picker.find('i');
	      if (icns.length === 0) {
	        return;
	      }
	      if (this.options.horizontal === false) {
	        sl = this.options.sliders;
	        icns.eq(1).css('top', sl.hue.maxTop * (1 - this.color.value.h)).end()
	          .eq(2).css('top', sl.alpha.maxTop * (1 - this.color.value.a));
	      } else {
	        sl = this.options.slidersHorz;
	        icns.eq(1).css('left', sl.hue.maxLeft * (1 - this.color.value.h)).end()
	          .eq(2).css('left', sl.alpha.maxLeft * (1 - this.color.value.a));
	      }
	      icns.eq(0).css({
	        'top': sl.saturation.maxTop - this.color.value.b * sl.saturation.maxTop,
	        'left': this.color.value.s * sl.saturation.maxLeft
	      });
	
	      this.picker.find('.colorpicker-saturation')
	        .css('backgroundColor', (this.options.hexNumberSignPrefix ? '' : '#') + this.color.toHex(this.color.value.h, 1, 1, 1));
	
	      this.picker.find('.colorpicker-alpha')
	        .css('backgroundColor', (this.options.hexNumberSignPrefix ? '' : '#') + this.color.toHex());
	
	      this.picker.find('.colorpicker-color, .colorpicker-color div')
	        .css('backgroundColor', this.color.toString(this.format, true));
	
	      return val;
	    },
	    updateComponent: function(val) {
	      var color;
	
	      if (typeof val !== 'undefined') {
	        color = this.createColor(val);
	      } else {
	        color = this.color;
	      }
	
	      if (this.component !== false) {
	        var icn = this.component.find('i').eq(0);
	        if (icn.length > 0) {
	          icn.css({
	            'backgroundColor': color.toString(this.format, true)
	          });
	        } else {
	          this.component.css({
	            'backgroundColor': color.toString(this.format, true)
	          });
	        }
	      }
	
	      return color.toString(this.format, false);
	    },
	    update: function(force) {
	      var val;
	      if ((this.getValue(false) !== false) || (force === true)) {
	        // Update input/data only if the current value is not empty
	        val = this.updateComponent();
	        this.updateInput(val);
	        this.updateData(val);
	        this.updatePicker(); // only update picker if value is not empty
	      }
	      return val;
	
	    },
	    setValue: function(val) { // set color manually
	      this.color = this.createColor(val);
	      this.update(true);
	      this.element.trigger({
	        type: 'changeColor',
	        color: this.color,
	        value: val
	      });
	    },
	    /**
	     * Creates a new color using the instance options
	     * @protected
	     * @param {String} val
	     * @returns {Color}
	     */
	    createColor: function(val) {
	      return new Color(
	        val ? val : null,
	        this.options.colorSelectors,
	        this.options.fallbackColor ? this.options.fallbackColor : this.color,
	        this.options.fallbackFormat,
	        this.options.hexNumberSignPrefix
	      );
	    },
	    getValue: function(defaultValue) {
	      defaultValue = (typeof defaultValue === 'undefined') ? this.options.fallbackColor : defaultValue;
	      var val;
	      if (this.hasInput()) {
	        val = this.input.val();
	      } else {
	        val = this.element.data('color');
	      }
	      if ((val === undefined) || (val === '') || (val === null)) {
	        // if not defined or empty, return default
	        val = defaultValue;
	      }
	      return val;
	    },
	    hasInput: function() {
	      return (this.input !== false);
	    },
	    isDisabled: function() {
	      if (this.hasInput()) {
	        return (this.input.prop('disabled') === true);
	      }
	      return false;
	    },
	    disable: function() {
	      if (this.hasInput()) {
	        this.input.prop('disabled', true);
	        this.element.trigger({
	          type: 'disable',
	          color: this.color,
	          value: this.getValue()
	        });
	        return true;
	      }
	      return false;
	    },
	    enable: function() {
	      if (this.hasInput()) {
	        this.input.prop('disabled', false);
	        this.element.trigger({
	          type: 'enable',
	          color: this.color,
	          value: this.getValue()
	        });
	        return true;
	      }
	      return false;
	    },
	    currentSlider: null,
	    mousePointer: {
	      left: 0,
	      top: 0
	    },
	    mousedown: function(e) {
	      if (!e.pageX && !e.pageY && e.originalEvent && e.originalEvent.touches) {
	        e.pageX = e.originalEvent.touches[0].pageX;
	        e.pageY = e.originalEvent.touches[0].pageY;
	      }
	      e.stopPropagation();
	      e.preventDefault();
	
	      var target = $(e.target);
	
	      //detect the slider and set the limits and callbacks
	      var zone = target.closest('div');
	      var sl = this.options.horizontal ? this.options.slidersHorz : this.options.sliders;
	      if (!zone.is('.colorpicker')) {
	        if (zone.is('.colorpicker-saturation')) {
	          this.currentSlider = $.extend({}, sl.saturation);
	        } else if (zone.is('.colorpicker-hue')) {
	          this.currentSlider = $.extend({}, sl.hue);
	        } else if (zone.is('.colorpicker-alpha')) {
	          this.currentSlider = $.extend({}, sl.alpha);
	        } else {
	          return false;
	        }
	        var offset = zone.offset();
	        //reference to guide's style
	        this.currentSlider.guide = zone.find('i')[0].style;
	        this.currentSlider.left = e.pageX - offset.left;
	        this.currentSlider.top = e.pageY - offset.top;
	        this.mousePointer = {
	          left: e.pageX,
	          top: e.pageY
	        };
	        //trigger mousemove to move the guide to the current position
	        $(window.document).on({
	          'mousemove.colorpicker': $.proxy(this.mousemove, this),
	          'touchmove.colorpicker': $.proxy(this.mousemove, this),
	          'mouseup.colorpicker': $.proxy(this.mouseup, this),
	          'touchend.colorpicker': $.proxy(this.mouseup, this)
	        }).trigger('mousemove');
	      }
	      return false;
	    },
	    mousemove: function(e) {
	      if (!e.pageX && !e.pageY && e.originalEvent && e.originalEvent.touches) {
	        e.pageX = e.originalEvent.touches[0].pageX;
	        e.pageY = e.originalEvent.touches[0].pageY;
	      }
	      e.stopPropagation();
	      e.preventDefault();
	      var left = Math.max(
	        0,
	        Math.min(
	          this.currentSlider.maxLeft,
	          this.currentSlider.left + ((e.pageX || this.mousePointer.left) - this.mousePointer.left)
	        )
	      );
	      var top = Math.max(
	        0,
	        Math.min(
	          this.currentSlider.maxTop,
	          this.currentSlider.top + ((e.pageY || this.mousePointer.top) - this.mousePointer.top)
	        )
	      );
	      this.currentSlider.guide.left = left + 'px';
	      this.currentSlider.guide.top = top + 'px';
	      if (this.currentSlider.callLeft) {
	        this.color[this.currentSlider.callLeft].call(this.color, left / this.currentSlider.maxLeft);
	      }
	      if (this.currentSlider.callTop) {
	        this.color[this.currentSlider.callTop].call(this.color, top / this.currentSlider.maxTop);
	      }
	      // Change format dynamically
	      // Only occurs if user choose the dynamic format by
	      // setting option format to false
	      if (
	        this.options.format === false &&
	        (this.currentSlider.callTop === 'setAlpha' ||
	          this.currentSlider.callLeft === 'setAlpha')
	      ) {
	
	        // Converting from hex / rgb to rgba
	        if (this.color.value.a !== 1) {
	          this.format = 'rgba';
	          this.color.origFormat = 'rgba';
	        }
	
	        // Converting from rgba to hex
	        else {
	          this.format = 'hex';
	          this.color.origFormat = 'hex';
	        }
	      }
	      this.update(true);
	
	      this.element.trigger({
	        type: 'changeColor',
	        color: this.color
	      });
	      return false;
	    },
	    mouseup: function(e) {
	      e.stopPropagation();
	      e.preventDefault();
	      $(window.document).off({
	        'mousemove.colorpicker': this.mousemove,
	        'touchmove.colorpicker': this.mousemove,
	        'mouseup.colorpicker': this.mouseup,
	        'touchend.colorpicker': this.mouseup
	      });
	      return false;
	    },
	    change: function(e) {
	      this.keyup(e);
	    },
	    keyup: function(e) {
	      if ((e.keyCode === 38)) {
	        if (this.color.value.a < 1) {
	          this.color.value.a = Math.round((this.color.value.a + 0.01) * 100) / 100;
	        }
	        this.update(true);
	      } else if ((e.keyCode === 40)) {
	        if (this.color.value.a > 0) {
	          this.color.value.a = Math.round((this.color.value.a - 0.01) * 100) / 100;
	        }
	        this.update(true);
	      } else {
	        this.color = this.createColor(this.input.val());
	        // Change format dynamically
	        // Only occurs if user choose the dynamic format by
	        // setting option format to false
	        if (this.color.origFormat && this.options.format === false) {
	          this.format = this.color.origFormat;
	        }
	        if (this.getValue(false) !== false) {
	          this.updateData();
	          this.updateComponent();
	          this.updatePicker();
	        }
	      }
	      this.element.trigger({
	        type: 'changeColor',
	        color: this.color,
	        value: this.input.val()
	      });
	    }
	  };
	
	  $.colorpicker = Colorpicker;
	
	  $.fn.colorpicker = function(option) {
	    var apiArgs = Array.prototype.slice.call(arguments, 1),
	      isSingleElement = (this.length === 1),
	      returnValue = null;
	
	    var $jq = this.each(function() {
	      var $this = $(this),
	        inst = $this.data('colorpicker'),
	        options = ((typeof option === 'object') ? option : {});
	
	      if (!inst) {
	        inst = new Colorpicker(this, options);
	        $this.data('colorpicker', inst);
	      }
	
	      if (typeof option === 'string') {
	        if ($.isFunction(inst[option])) {
	          returnValue = inst[option].apply(inst, apiArgs);
	        } else { // its a property ?
	          if (apiArgs.length) {
	            // set property
	            inst[option] = apiArgs[0];
	          }
	          returnValue = inst[option];
	        }
	      } else {
	        returnValue = $this;
	      }
	    });
	    return isSingleElement ? returnValue : $jq;
	  };
	
	  $.fn.colorpicker.constructor = Colorpicker;
	
	}));


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Datepicker for Bootstrap v1.6.1 (https://github.com/eternicode/bootstrap-datepicker)
	 *
	 * Copyright 2012 Stefan Petre
	 * Improvements by Andrew Rowls
	 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
	 */(function(factory){
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	}(function($, undefined){
	
		function UTCDate(){
			return new Date(Date.UTC.apply(Date, arguments));
		}
		function UTCToday(){
			var today = new Date();
			return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
		}
		function isUTCEquals(date1, date2) {
			return (
				date1.getUTCFullYear() === date2.getUTCFullYear() &&
				date1.getUTCMonth() === date2.getUTCMonth() &&
				date1.getUTCDate() === date2.getUTCDate()
			);
		}
		function alias(method){
			return function(){
				return this[method].apply(this, arguments);
			};
		}
		function isValidDate(d) {
			return d && !isNaN(d.getTime());
		}
	
		var DateArray = (function(){
			var extras = {
				get: function(i){
					return this.slice(i)[0];
				},
				contains: function(d){
					// Array.indexOf is not cross-browser;
					// $.inArray doesn't work with Dates
					var val = d && d.valueOf();
					for (var i=0, l=this.length; i < l; i++)
						if (this[i].valueOf() === val)
							return i;
					return -1;
				},
				remove: function(i){
					this.splice(i,1);
				},
				replace: function(new_array){
					if (!new_array)
						return;
					if (!$.isArray(new_array))
						new_array = [new_array];
					this.clear();
					this.push.apply(this, new_array);
				},
				clear: function(){
					this.length = 0;
				},
				copy: function(){
					var a = new DateArray();
					a.replace(this);
					return a;
				}
			};
	
			return function(){
				var a = [];
				a.push.apply(a, arguments);
				$.extend(a, extras);
				return a;
			};
		})();
	
	
		// Picker object
	
		var Datepicker = function(element, options){
			$(element).data('datepicker', this);
			this._process_options(options);
	
			this.dates = new DateArray();
			this.viewDate = this.o.defaultViewDate;
			this.focusDate = null;
	
			this.element = $(element);
			this.isInput = this.element.is('input');
			this.inputField = this.isInput ? this.element : this.element.find('input');
			this.component = this.element.hasClass('date') ? this.element.find('.add-on, .input-group-addon, .btn') : false;
			this.hasInput = this.component && this.inputField.length;
			if (this.component && this.component.length === 0)
				this.component = false;
			this.isInline = !this.component && this.element.is('div');
	
			this.picker = $(DPGlobal.template);
	
			// Checking templates and inserting
			if (this._check_template(this.o.templates.leftArrow)) {
				this.picker.find('.prev').html(this.o.templates.leftArrow);
			}
			if (this._check_template(this.o.templates.rightArrow)) {
				this.picker.find('.next').html(this.o.templates.rightArrow);
			}
	
			this._buildEvents();
			this._attachEvents();
	
			if (this.isInline){
				this.picker.addClass('datepicker-inline').appendTo(this.element);
			}
			else {
				this.picker.addClass('datepicker-dropdown dropdown-menu');
			}
	
			if (this.o.rtl){
				this.picker.addClass('datepicker-rtl');
			}
	
			this.viewMode = this.o.startView;
	
			if (this.o.calendarWeeks)
				this.picker.find('thead .datepicker-title, tfoot .today, tfoot .clear')
							.attr('colspan', function(i, val){
								return parseInt(val) + 1;
							});
	
			this._allow_update = false;
	
			this.setStartDate(this._o.startDate);
			this.setEndDate(this._o.endDate);
			this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled);
			this.setDaysOfWeekHighlighted(this.o.daysOfWeekHighlighted);
			this.setDatesDisabled(this.o.datesDisabled);
	
			this.fillDow();
			this.fillMonths();
	
			this._allow_update = true;
	
			this.update();
			this.showMode();
	
			if (this.isInline){
				this.show();
			}
		};
	
		Datepicker.prototype = {
			constructor: Datepicker,
	
			_resolveViewName: function(view, default_value){
				if (view === 0 || view === 'days' || view === 'month') {
					return 0;
				}
				if (view === 1 || view === 'months' || view === 'year') {
					return 1;
				}
				if (view === 2 || view === 'years' || view === 'decade') {
					return 2;
				}
				if (view === 3 || view === 'decades' || view === 'century') {
					return 3;
				}
				if (view === 4 || view === 'centuries' || view === 'millennium') {
					return 4;
				}
				return default_value === undefined ? false : default_value;
			},
	
			_check_template: function(tmp){
				try {
					// If empty
					if (tmp === undefined || tmp === "") {
						return false;
					}
					// If no html, everything ok
					if ((tmp.match(/[<>]/g) || []).length <= 0) {
						return true;
					}
					// Checking if html is fine
					var jDom = $(tmp);
					return jDom.length > 0;
				}
				catch (ex) {
					return false;
				}
			},
	
			_process_options: function(opts){
				// Store raw options for reference
				this._o = $.extend({}, this._o, opts);
				// Processed options
				var o = this.o = $.extend({}, this._o);
	
				// Check if "de-DE" style date is available, if not language should
				// fallback to 2 letter code eg "de"
				var lang = o.language;
				if (!dates[lang]){
					lang = lang.split('-')[0];
					if (!dates[lang])
						lang = defaults.language;
				}
				o.language = lang;
	
				// Retrieve view index from any aliases
				o.startView = this._resolveViewName(o.startView, 0);
				o.minViewMode = this._resolveViewName(o.minViewMode, 0);
				o.maxViewMode = this._resolveViewName(o.maxViewMode, 4);
	
				// Check that the start view is between min and max
				o.startView = Math.min(o.startView, o.maxViewMode);
				o.startView = Math.max(o.startView, o.minViewMode);
	
				// true, false, or Number > 0
				if (o.multidate !== true){
					o.multidate = Number(o.multidate) || false;
					if (o.multidate !== false)
						o.multidate = Math.max(0, o.multidate);
				}
				o.multidateSeparator = String(o.multidateSeparator);
	
				o.weekStart %= 7;
				o.weekEnd = (o.weekStart + 6) % 7;
	
				var format = DPGlobal.parseFormat(o.format);
				if (o.startDate !== -Infinity){
					if (!!o.startDate){
						if (o.startDate instanceof Date)
							o.startDate = this._local_to_utc(this._zero_time(o.startDate));
						else
							o.startDate = DPGlobal.parseDate(o.startDate, format, o.language, o.assumeNearbyYear);
					}
					else {
						o.startDate = -Infinity;
					}
				}
				if (o.endDate !== Infinity){
					if (!!o.endDate){
						if (o.endDate instanceof Date)
							o.endDate = this._local_to_utc(this._zero_time(o.endDate));
						else
							o.endDate = DPGlobal.parseDate(o.endDate, format, o.language, o.assumeNearbyYear);
					}
					else {
						o.endDate = Infinity;
					}
				}
	
				o.daysOfWeekDisabled = o.daysOfWeekDisabled||[];
				if (!$.isArray(o.daysOfWeekDisabled))
					o.daysOfWeekDisabled = o.daysOfWeekDisabled.split(/[,\s]*/);
				o.daysOfWeekDisabled = $.map(o.daysOfWeekDisabled, function(d){
					return parseInt(d, 10);
				});
	
				o.daysOfWeekHighlighted = o.daysOfWeekHighlighted||[];
				if (!$.isArray(o.daysOfWeekHighlighted))
					o.daysOfWeekHighlighted = o.daysOfWeekHighlighted.split(/[,\s]*/);
				o.daysOfWeekHighlighted = $.map(o.daysOfWeekHighlighted, function(d){
					return parseInt(d, 10);
				});
	
				o.datesDisabled = o.datesDisabled||[];
				if (!$.isArray(o.datesDisabled)) {
					o.datesDisabled = [
						o.datesDisabled
					];
				}
				o.datesDisabled = $.map(o.datesDisabled,function(d){
					return DPGlobal.parseDate(d, format, o.language, o.assumeNearbyYear);
				});
	
				var plc = String(o.orientation).toLowerCase().split(/\s+/g),
					_plc = o.orientation.toLowerCase();
				plc = $.grep(plc, function(word){
					return /^auto|left|right|top|bottom$/.test(word);
				});
				o.orientation = {x: 'auto', y: 'auto'};
				if (!_plc || _plc === 'auto')
					; // no action
				else if (plc.length === 1){
					switch (plc[0]){
						case 'top':
						case 'bottom':
							o.orientation.y = plc[0];
							break;
						case 'left':
						case 'right':
							o.orientation.x = plc[0];
							break;
					}
				}
				else {
					_plc = $.grep(plc, function(word){
						return /^left|right$/.test(word);
					});
					o.orientation.x = _plc[0] || 'auto';
	
					_plc = $.grep(plc, function(word){
						return /^top|bottom$/.test(word);
					});
					o.orientation.y = _plc[0] || 'auto';
				}
				if (o.defaultViewDate) {
					var year = o.defaultViewDate.year || new Date().getFullYear();
					var month = o.defaultViewDate.month || 0;
					var day = o.defaultViewDate.day || 1;
					o.defaultViewDate = UTCDate(year, month, day);
				} else {
					o.defaultViewDate = UTCToday();
				}
			},
			_events: [],
			_secondaryEvents: [],
			_applyEvents: function(evs){
				for (var i=0, el, ch, ev; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					}
					else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.on(ev, ch);
				}
			},
			_unapplyEvents: function(evs){
				for (var i=0, el, ev, ch; i < evs.length; i++){
					el = evs[i][0];
					if (evs[i].length === 2){
						ch = undefined;
						ev = evs[i][1];
					}
					else if (evs[i].length === 3){
						ch = evs[i][1];
						ev = evs[i][2];
					}
					el.off(ev, ch);
				}
			},
			_buildEvents: function(){
	            var events = {
	                keyup: $.proxy(function(e){
	                    if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1)
	                        this.update();
	                }, this),
	                keydown: $.proxy(this.keydown, this),
	                paste: $.proxy(this.paste, this)
	            };
	
	            if (this.o.showOnFocus === true) {
	                events.focus = $.proxy(this.show, this);
	            }
	
	            if (this.isInput) { // single input
	                this._events = [
	                    [this.element, events]
	                ];
	            }
	            else if (this.component && this.hasInput) { // component: input + button
	                this._events = [
	                    // For components that are not readonly, allow keyboard nav
	                    [this.inputField, events],
	                    [this.component, {
	                        click: $.proxy(this.show, this)
	                    }]
	                ];
	            }
				else {
					this._events = [
						[this.element, {
							click: $.proxy(this.show, this),
							keydown: $.proxy(this.keydown, this)
						}]
					];
				}
				this._events.push(
					// Component: listen for blur on element descendants
					[this.element, '*', {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}],
					// Input: listen for blur on element
					[this.element, {
						blur: $.proxy(function(e){
							this._focused_from = e.target;
						}, this)
					}]
				);
	
				if (this.o.immediateUpdates) {
					// Trigger input updates immediately on changed year/month
					this._events.push([this.element, {
						'changeYear changeMonth': $.proxy(function(e){
							this.update(e.date);
						}, this)
					}]);
				}
	
				this._secondaryEvents = [
					[this.picker, {
						click: $.proxy(this.click, this)
					}],
					[$(window), {
						resize: $.proxy(this.place, this)
					}],
					[$(document), {
						mousedown: $.proxy(function(e){
							// Clicked outside the datepicker, hide it
							if (!(
								this.element.is(e.target) ||
								this.element.find(e.target).length ||
								this.picker.is(e.target) ||
								this.picker.find(e.target).length ||
								this.isInline
							)){
								this.hide();
							}
						}, this)
					}]
				];
			},
			_attachEvents: function(){
				this._detachEvents();
				this._applyEvents(this._events);
			},
			_detachEvents: function(){
				this._unapplyEvents(this._events);
			},
			_attachSecondaryEvents: function(){
				this._detachSecondaryEvents();
				this._applyEvents(this._secondaryEvents);
			},
			_detachSecondaryEvents: function(){
				this._unapplyEvents(this._secondaryEvents);
			},
			_trigger: function(event, altdate){
				var date = altdate || this.dates.get(-1),
					local_date = this._utc_to_local(date);
	
				this.element.trigger({
					type: event,
					date: local_date,
					dates: $.map(this.dates, this._utc_to_local),
					format: $.proxy(function(ix, format){
						if (arguments.length === 0){
							ix = this.dates.length - 1;
							format = this.o.format;
						}
						else if (typeof ix === 'string'){
							format = ix;
							ix = this.dates.length - 1;
						}
						format = format || this.o.format;
						var date = this.dates.get(ix);
						return DPGlobal.formatDate(date, format, this.o.language);
					}, this)
				});
			},
	
			show: function(){
				if (this.inputField.prop('disabled') || (this.inputField.prop('readonly') && this.o.enableOnReadonly === false))
					return;
				if (!this.isInline)
					this.picker.appendTo(this.o.container);
				this.place();
				this.picker.show();
				this._attachSecondaryEvents();
				this._trigger('show');
				if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && this.o.disableTouchKeyboard) {
					$(this.element).blur();
				}
				return this;
			},
	
			hide: function(){
				if (this.isInline || !this.picker.is(':visible'))
					return this;
				this.focusDate = null;
				this.picker.hide().detach();
				this._detachSecondaryEvents();
				this.viewMode = this.o.startView;
				this.showMode();
	
				if (this.o.forceParse && this.inputField.val())
					this.setValue();
				this._trigger('hide');
				return this;
			},
	
			destroy: function(){
				this.hide();
				this._detachEvents();
				this._detachSecondaryEvents();
				this.picker.remove();
				delete this.element.data().datepicker;
				if (!this.isInput){
					delete this.element.data().date;
				}
				return this;
			},
	
			paste: function(evt){
				var dateString;
				if (evt.originalEvent.clipboardData && evt.originalEvent.clipboardData.types
					&& $.inArray('text/plain', evt.originalEvent.clipboardData.types) !== -1) {
					dateString = evt.originalEvent.clipboardData.getData('text/plain');
				}
				else if (window.clipboardData) {
					dateString = window.clipboardData.getData('Text');
				}
				else {
					return;
				}
				this.setDate(dateString);
				this.update();
				evt.preventDefault();
			},
	
			_utc_to_local: function(utc){
				return utc && new Date(utc.getTime() + (utc.getTimezoneOffset()*60000));
			},
			_local_to_utc: function(local){
				return local && new Date(local.getTime() - (local.getTimezoneOffset()*60000));
			},
			_zero_time: function(local){
				return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
			},
			_zero_utc_time: function(utc){
				return utc && new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate()));
			},
	
			getDates: function(){
				return $.map(this.dates, this._utc_to_local);
			},
	
			getUTCDates: function(){
				return $.map(this.dates, function(d){
					return new Date(d);
				});
			},
	
			getDate: function(){
				return this._utc_to_local(this.getUTCDate());
			},
	
			getUTCDate: function(){
				var selected_date = this.dates.get(-1);
				if (typeof selected_date !== 'undefined') {
					return new Date(selected_date);
				} else {
					return null;
				}
			},
	
			clearDates: function(){
				if (this.inputField) {
					this.inputField.val('');
				}
	
				this.update();
				this._trigger('changeDate');
	
				if (this.o.autoclose) {
					this.hide();
				}
			},
			setDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, args);
				this._trigger('changeDate');
				this.setValue();
				return this;
			},
	
			setUTCDates: function(){
				var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
				this.update.apply(this, $.map(args, this._utc_to_local));
				this._trigger('changeDate');
				this.setValue();
				return this;
			},
	
			setDate: alias('setDates'),
			setUTCDate: alias('setUTCDates'),
			remove: alias('destroy'),
	
			setValue: function(){
				var formatted = this.getFormattedDate();
				this.inputField.val(formatted);
				return this;
			},
	
			getFormattedDate: function(format){
				if (format === undefined)
					format = this.o.format;
	
				var lang = this.o.language;
				return $.map(this.dates, function(d){
					return DPGlobal.formatDate(d, format, lang);
				}).join(this.o.multidateSeparator);
			},
	
			getStartDate: function(){
				return this.o.startDate;
			},
	
			setStartDate: function(startDate){
				this._process_options({startDate: startDate});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			getEndDate: function(){
				return this.o.endDate;
			},
	
			setEndDate: function(endDate){
				this._process_options({endDate: endDate});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			setDaysOfWeekDisabled: function(daysOfWeekDisabled){
				this._process_options({daysOfWeekDisabled: daysOfWeekDisabled});
				this.update();
				this.updateNavArrows();
				return this;
			},
	
			setDaysOfWeekHighlighted: function(daysOfWeekHighlighted){
				this._process_options({daysOfWeekHighlighted: daysOfWeekHighlighted});
				this.update();
				return this;
			},
	
			setDatesDisabled: function(datesDisabled){
				this._process_options({datesDisabled: datesDisabled});
				this.update();
				this.updateNavArrows();
			},
	
			place: function(){
				if (this.isInline)
					return this;
				var calendarWidth = this.picker.outerWidth(),
					calendarHeight = this.picker.outerHeight(),
					visualPadding = 10,
					container = $(this.o.container),
					windowWidth = container.width(),
					scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(),
					appendOffset = container.offset();
	
				var parentsZindex = [];
				this.element.parents().each(function(){
					var itemZIndex = $(this).css('z-index');
					if (itemZIndex !== 'auto' && itemZIndex !== 0) parentsZindex.push(parseInt(itemZIndex));
				});
				var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
				var offset = this.component ? this.component.parent().offset() : this.element.offset();
				var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
				var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
				var left = offset.left - appendOffset.left,
					top = offset.top - appendOffset.top;
	
				if (this.o.container !== 'body') {
					top += scrollTop;
				}
	
				this.picker.removeClass(
					'datepicker-orient-top datepicker-orient-bottom '+
					'datepicker-orient-right datepicker-orient-left'
				);
	
				if (this.o.orientation.x !== 'auto'){
					this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
					if (this.o.orientation.x === 'right')
						left -= calendarWidth - width;
				}
				// auto x orientation is best-placement: if it crosses a window
				// edge, fudge it sideways
				else {
					if (offset.left < 0) {
						// component is outside the window on the left side. Move it into visible range
						this.picker.addClass('datepicker-orient-left');
						left -= offset.left - visualPadding;
					} else if (left + calendarWidth > windowWidth) {
						// the calendar passes the widow right edge. Align it to component right side
						this.picker.addClass('datepicker-orient-right');
						left += width - calendarWidth;
					} else {
						// Default to left
						this.picker.addClass('datepicker-orient-left');
					}
				}
	
				// auto y orientation is best-situation: top or bottom, no fudging,
				// decision based on which shows more of the calendar
				var yorient = this.o.orientation.y,
					top_overflow;
				if (yorient === 'auto'){
					top_overflow = -scrollTop + top - calendarHeight;
					yorient = top_overflow < 0 ? 'bottom' : 'top';
				}
	
				this.picker.addClass('datepicker-orient-' + yorient);
				if (yorient === 'top')
					top -= calendarHeight + parseInt(this.picker.css('padding-top'));
				else
					top += height;
	
				if (this.o.rtl) {
					var right = windowWidth - (left + width);
					this.picker.css({
						top: top,
						right: right,
						zIndex: zIndex
					});
				} else {
					this.picker.css({
						top: top,
						left: left,
						zIndex: zIndex
					});
				}
				return this;
			},
	
			_allow_update: true,
			update: function(){
				if (!this._allow_update)
					return this;
	
				var oldDates = this.dates.copy(),
					dates = [],
					fromArgs = false;
				if (arguments.length){
					$.each(arguments, $.proxy(function(i, date){
						if (date instanceof Date)
							date = this._local_to_utc(date);
						dates.push(date);
					}, this));
					fromArgs = true;
				}
				else {
					dates = this.isInput
							? this.element.val()
							: this.element.data('date') || this.inputField.val();
					if (dates && this.o.multidate)
						dates = dates.split(this.o.multidateSeparator);
					else
						dates = [dates];
					delete this.element.data().date;
				}
	
				dates = $.map(dates, $.proxy(function(date){
					return DPGlobal.parseDate(date, this.o.format, this.o.language, this.o.assumeNearbyYear);
				}, this));
				dates = $.grep(dates, $.proxy(function(date){
					return (
						!this.dateWithinRange(date) ||
						!date
					);
				}, this), true);
				this.dates.replace(dates);
	
				if (this.dates.length)
					this.viewDate = new Date(this.dates.get(-1));
				else if (this.viewDate < this.o.startDate)
					this.viewDate = new Date(this.o.startDate);
				else if (this.viewDate > this.o.endDate)
					this.viewDate = new Date(this.o.endDate);
				else
					this.viewDate = this.o.defaultViewDate;
	
				if (fromArgs){
					// setting date by clicking
					this.setValue();
				}
				else if (dates.length){
					// setting date by typing
					if (String(oldDates) !== String(this.dates))
						this._trigger('changeDate');
				}
				if (!this.dates.length && oldDates.length)
					this._trigger('clearDate');
	
				this.fill();
				this.element.change();
				return this;
			},
	
			fillDow: function(){
				var dowCnt = this.o.weekStart,
					html = '<tr>';
				if (this.o.calendarWeeks){
					this.picker.find('.datepicker-days .datepicker-switch')
						.attr('colspan', function(i, val){
							return parseInt(val) + 1;
						});
					html += '<th class="cw">&#160;</th>';
				}
				while (dowCnt < this.o.weekStart + 7){
					html += '<th class="dow';
	        if ($.inArray(dowCnt, this.o.daysOfWeekDisabled) > -1)
	          html += ' disabled';
	        html += '">'+dates[this.o.language].daysMin[(dowCnt++)%7]+'</th>';
				}
				html += '</tr>';
				this.picker.find('.datepicker-days thead').append(html);
			},
	
			fillMonths: function(){
	      var localDate = this._utc_to_local(this.viewDate);
				var html = '',
				i = 0;
				while (i < 12){
	        var focused = localDate && localDate.getMonth() === i ? ' focused' : '';
					html += '<span class="month' + focused + '">' + dates[this.o.language].monthsShort[i++]+'</span>';
				}
				this.picker.find('.datepicker-months td').html(html);
			},
	
			setRange: function(range){
				if (!range || !range.length)
					delete this.range;
				else
					this.range = $.map(range, function(d){
						return d.valueOf();
					});
				this.fill();
			},
	
			getClassNames: function(date){
				var cls = [],
					year = this.viewDate.getUTCFullYear(),
					month = this.viewDate.getUTCMonth(),
					today = new Date();
				if (date.getUTCFullYear() < year || (date.getUTCFullYear() === year && date.getUTCMonth() < month)){
					cls.push('old');
				}
				else if (date.getUTCFullYear() > year || (date.getUTCFullYear() === year && date.getUTCMonth() > month)){
					cls.push('new');
				}
				if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
					cls.push('focused');
				// Compare internal UTC date with local today, not UTC today
				if (this.o.todayHighlight &&
					date.getUTCFullYear() === today.getFullYear() &&
					date.getUTCMonth() === today.getMonth() &&
					date.getUTCDate() === today.getDate()){
					cls.push('today');
				}
				if (this.dates.contains(date) !== -1)
					cls.push('active');
				if (!this.dateWithinRange(date)){
					cls.push('disabled');
				}
				if (this.dateIsDisabled(date)){
					cls.push('disabled', 'disabled-date');	
				} 
				if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1){
					cls.push('highlighted');
				}
	
				if (this.range){
					if (date > this.range[0] && date < this.range[this.range.length-1]){
						cls.push('range');
					}
					if ($.inArray(date.valueOf(), this.range) !== -1){
						cls.push('selected');
					}
					if (date.valueOf() === this.range[0]){
	          cls.push('range-start');
	        }
	        if (date.valueOf() === this.range[this.range.length-1]){
	          cls.push('range-end');
	        }
				}
				return cls;
			},
	
			_fill_yearsView: function(selector, cssClass, factor, step, currentYear, startYear, endYear, callback){
				var html, view, year, steps, startStep, endStep, thisYear, i, classes, tooltip, before;
	
				html      = '';
				view      = this.picker.find(selector);
				year      = parseInt(currentYear / factor, 10) * factor;
				startStep = parseInt(startYear / step, 10) * step;
				endStep   = parseInt(endYear / step, 10) * step;
				steps     = $.map(this.dates, function(d){
					return parseInt(d.getUTCFullYear() / step, 10) * step;
				});
	
				view.find('.datepicker-switch').text(year + '-' + (year + step * 9));
	
				thisYear = year - step;
				for (i = -1; i < 11; i += 1) {
					classes = [cssClass];
					tooltip = null;
	
					if (i === -1) {
						classes.push('old');
					} else if (i === 10) {
						classes.push('new');
					}
					if ($.inArray(thisYear, steps) !== -1) {
						classes.push('active');
					}
					if (thisYear < startStep || thisYear > endStep) {
						classes.push('disabled');
					}
	        if (thisYear === this.viewDate.getFullYear()) {
					  classes.push('focused');
	        }
	
					if (callback !== $.noop) {
						before = callback(new Date(thisYear, 0, 1));
						if (before === undefined) {
							before = {};
						} else if (typeof(before) === 'boolean') {
							before = {enabled: before};
						} else if (typeof(before) === 'string') {
							before = {classes: before};
						}
						if (before.enabled === false) {
							classes.push('disabled');
						}
						if (before.classes) {
							classes = classes.concat(before.classes.split(/\s+/));
						}
						if (before.tooltip) {
							tooltip = before.tooltip;
						}
					}
	
					html += '<span class="' + classes.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + thisYear + '</span>';
					thisYear += step;
				}
				view.find('td').html(html);
			},
	
			fill: function(){
				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth(),
					startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
					startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
					endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
					endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
					todaytxt = dates[this.o.language].today || dates['en'].today || '',
					cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
					titleFormat = dates[this.o.language].titleFormat || dates['en'].titleFormat,
					tooltip,
					before;
				if (isNaN(year) || isNaN(month))
					return;
				this.picker.find('.datepicker-days .datepicker-switch')
							.text(DPGlobal.formatDate(d, titleFormat, this.o.language));
				this.picker.find('tfoot .today')
							.text(todaytxt)
							.toggle(this.o.todayBtn !== false);
				this.picker.find('tfoot .clear')
							.text(cleartxt)
							.toggle(this.o.clearBtn !== false);
				this.picker.find('thead .datepicker-title')
							.text(this.o.title)
							.toggle(this.o.title !== '');
				this.updateNavArrows();
				this.fillMonths();
				var prevMonth = UTCDate(year, month-1, 28),
					day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
				prevMonth.setUTCDate(day);
				prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7)%7);
				var nextMonth = new Date(prevMonth);
				if (prevMonth.getUTCFullYear() < 100){
	        nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
	      }
				nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
				nextMonth = nextMonth.valueOf();
				var html = [];
				var clsName;
				while (prevMonth.valueOf() < nextMonth){
					if (prevMonth.getUTCDay() === this.o.weekStart){
						html.push('<tr>');
						if (this.o.calendarWeeks){
							// ISO 8601: First week contains first thursday.
							// ISO also states week starts on Monday, but we can be more abstract here.
							var
								// Start of current week: based on weekstart/current date
								ws = new Date(+prevMonth + (this.o.weekStart - prevMonth.getUTCDay() - 7) % 7 * 864e5),
								// Thursday of this week
								th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
								// First Thursday of year, year from thursday
								yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay())%7*864e5),
								// Calendar week: ms between thursdays, div ms per day, div 7 days
								calWeek =  (th - yth) / 864e5 / 7 + 1;
							html.push('<td class="cw">'+ calWeek +'</td>');
						}
					}
					clsName = this.getClassNames(prevMonth);
					clsName.push('day');
	
					if (this.o.beforeShowDay !== $.noop){
						before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
						if (before === undefined)
							before = {};
						else if (typeof(before) === 'boolean')
							before = {enabled: before};
						else if (typeof(before) === 'string')
							before = {classes: before};
						if (before.enabled === false)
							clsName.push('disabled');
						if (before.classes)
							clsName = clsName.concat(before.classes.split(/\s+/));
						if (before.tooltip)
							tooltip = before.tooltip;
					}
	
					clsName = $.unique(clsName);
					html.push('<td class="'+clsName.join(' ')+'"' + (tooltip ? ' title="'+tooltip+'"' : '') + '>'+prevMonth.getUTCDate() + '</td>');
					tooltip = null;
					if (prevMonth.getUTCDay() === this.o.weekEnd){
						html.push('</tr>');
					}
					prevMonth.setUTCDate(prevMonth.getUTCDate()+1);
				}
				this.picker.find('.datepicker-days tbody').empty().append(html.join(''));
	
				var monthsTitle = dates[this.o.language].monthsTitle || dates['en'].monthsTitle || 'Months';
				var months = this.picker.find('.datepicker-months')
							.find('.datepicker-switch')
								.text(this.o.maxViewMode < 2 ? monthsTitle : year)
								.end()
							.find('span').removeClass('active');
	
				$.each(this.dates, function(i, d){
					if (d.getUTCFullYear() === year)
						months.eq(d.getUTCMonth()).addClass('active');
				});
	
				if (year < startYear || year > endYear){
					months.addClass('disabled');
				}
				if (year === startYear){
					months.slice(0, startMonth).addClass('disabled');
				}
				if (year === endYear){
					months.slice(endMonth+1).addClass('disabled');
				}
	
				if (this.o.beforeShowMonth !== $.noop){
					var that = this;
					$.each(months, function(i, month){
	          var moDate = new Date(year, i, 1);
	          var before = that.o.beforeShowMonth(moDate);
						if (before === undefined)
							before = {};
						else if (typeof(before) === 'boolean')
							before = {enabled: before};
						else if (typeof(before) === 'string')
							before = {classes: before};
						if (before.enabled === false && !$(month).hasClass('disabled'))
						    $(month).addClass('disabled');
						if (before.classes)
						    $(month).addClass(before.classes);
						if (before.tooltip)
						    $(month).prop('title', before.tooltip);
					});
				}
	
				// Generating decade/years picker
				this._fill_yearsView(
					'.datepicker-years',
					'year',
					10,
					1,
					year,
					startYear,
					endYear,
					this.o.beforeShowYear
				);
	
				// Generating century/decades picker
				this._fill_yearsView(
					'.datepicker-decades',
					'decade',
					100,
					10,
					year,
					startYear,
					endYear,
					this.o.beforeShowDecade
				);
	
				// Generating millennium/centuries picker
				this._fill_yearsView(
					'.datepicker-centuries',
					'century',
					1000,
					100,
					year,
					startYear,
					endYear,
					this.o.beforeShowCentury
				);
			},
	
			updateNavArrows: function(){
				if (!this._allow_update)
					return;
	
				var d = new Date(this.viewDate),
					year = d.getUTCFullYear(),
					month = d.getUTCMonth();
				switch (this.viewMode){
					case 0:
						if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() && month <= this.o.startDate.getUTCMonth()){
							this.picker.find('.prev').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.prev').css({visibility: 'visible'});
						}
						if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() && month >= this.o.endDate.getUTCMonth()){
							this.picker.find('.next').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.next').css({visibility: 'visible'});
						}
						break;
					case 1:
					case 2:
					case 3:
					case 4:
						if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() || this.o.maxViewMode < 2){
							this.picker.find('.prev').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.prev').css({visibility: 'visible'});
						}
						if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() || this.o.maxViewMode < 2){
							this.picker.find('.next').css({visibility: 'hidden'});
						}
						else {
							this.picker.find('.next').css({visibility: 'visible'});
						}
						break;
				}
			},
	
			click: function(e){
				e.preventDefault();
				e.stopPropagation();
	
				var target, dir, day, year, month, monthChanged, yearChanged;
				target = $(e.target);
	
				// Clicked on the switch
				if (target.hasClass('datepicker-switch')){
					this.showMode(1);
				}
	
				// Clicked on prev or next
				var navArrow = target.closest('.prev, .next');
				if (navArrow.length > 0) {
					dir = DPGlobal.modes[this.viewMode].navStep * (navArrow.hasClass('prev') ? -1 : 1);
					if (this.viewMode === 0){
						this.viewDate = this.moveMonth(this.viewDate, dir);
						this._trigger('changeMonth', this.viewDate);
					} else {
						this.viewDate = this.moveYear(this.viewDate, dir);
						if (this.viewMode === 1){
							this._trigger('changeYear', this.viewDate);
						}
					}
					this.fill();
				}
	
				// Clicked on today button
				if (target.hasClass('today') && !target.hasClass('day')){
					this.showMode(-2);
					this._setDate(UTCToday(), this.o.todayBtn === 'linked' ? null : 'view');
				}
	
				// Clicked on clear button
				if (target.hasClass('clear')){
					this.clearDates();
				}
	
				if (!target.hasClass('disabled')){
					// Clicked on a day
					if (target.hasClass('day')){
						day = parseInt(target.text(), 10) || 1;
						year = this.viewDate.getUTCFullYear();
						month = this.viewDate.getUTCMonth();
	
						// From last month
						if (target.hasClass('old')){
							if (month === 0) {
								month = 11;
								year = year - 1;
								monthChanged = true;
								yearChanged = true;
							} else {
								month = month - 1;
								monthChanged = true;
	 						}
	 					}
	
						// From next month
						if (target.hasClass('new')) {
							if (month === 11){
								month = 0;
								year = year + 1;
								monthChanged = true;
								yearChanged = true;
	 						} else {
								month = month + 1;
								monthChanged = true;
	 						}
						}
						this._setDate(UTCDate(year, month, day));
						if (yearChanged) {
							this._trigger('changeYear', this.viewDate);
						}
						if (monthChanged) {
							this._trigger('changeMonth', this.viewDate);
						}
					}
	
					// Clicked on a month
					if (target.hasClass('month')) {
						this.viewDate.setUTCDate(1);
						day = 1;
						month = target.parent().find('span').index(target);
						year = this.viewDate.getUTCFullYear();
						this.viewDate.setUTCMonth(month);
						this._trigger('changeMonth', this.viewDate);
						if (this.o.minViewMode === 1){
							this._setDate(UTCDate(year, month, day));
							this.showMode();
						} else {
							this.showMode(-1);
						}
						this.fill();
					}
	
					// Clicked on a year
					if (target.hasClass('year')
							|| target.hasClass('decade')
							|| target.hasClass('century')) {
						this.viewDate.setUTCDate(1);
	
						day = 1;
						month = 0;
						year = parseInt(target.text(), 10)||0;
						this.viewDate.setUTCFullYear(year);
	
						if (target.hasClass('year')){
							this._trigger('changeYear', this.viewDate);
							if (this.o.minViewMode === 2){
								this._setDate(UTCDate(year, month, day));
							}
						}
						if (target.hasClass('decade')){
							this._trigger('changeDecade', this.viewDate);
							if (this.o.minViewMode === 3){
								this._setDate(UTCDate(year, month, day));
							}
						}
						if (target.hasClass('century')){
							this._trigger('changeCentury', this.viewDate);
							if (this.o.minViewMode === 4){
								this._setDate(UTCDate(year, month, day));
							}
						}
	
						this.showMode(-1);
						this.fill();
					}
				}
	
				if (this.picker.is(':visible') && this._focused_from){
					$(this._focused_from).focus();
				}
				delete this._focused_from;
			},
	
			_toggle_multidate: function(date){
				var ix = this.dates.contains(date);
				if (!date){
					this.dates.clear();
				}
	
				if (ix !== -1){
					if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive){
						this.dates.remove(ix);
					}
				} else if (this.o.multidate === false) {
					this.dates.clear();
					this.dates.push(date);
				}
				else {
					this.dates.push(date);
				}
	
				if (typeof this.o.multidate === 'number')
					while (this.dates.length > this.o.multidate)
						this.dates.remove(0);
			},
	
			_setDate: function(date, which){
				if (!which || which === 'date')
					this._toggle_multidate(date && new Date(date));
				if (!which || which === 'view')
					this.viewDate = date && new Date(date);
	
				this.fill();
				this.setValue();
				if (!which || which !== 'view') {
					this._trigger('changeDate');
				}
				if (this.inputField){
					this.inputField.change();
				}
				if (this.o.autoclose && (!which || which === 'date')){
					this.hide();
				}
			},
	
			moveDay: function(date, dir){
				var newDate = new Date(date);
				newDate.setUTCDate(date.getUTCDate() + dir);
	
				return newDate;
			},
	
			moveWeek: function(date, dir){
				return this.moveDay(date, dir * 7);
			},
	
			moveMonth: function(date, dir){
				if (!isValidDate(date))
					return this.o.defaultViewDate;
				if (!dir)
					return date;
				var new_date = new Date(date.valueOf()),
					day = new_date.getUTCDate(),
					month = new_date.getUTCMonth(),
					mag = Math.abs(dir),
					new_month, test;
				dir = dir > 0 ? 1 : -1;
				if (mag === 1){
					test = dir === -1
						// If going back one month, make sure month is not current month
						// (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
						? function(){
							return new_date.getUTCMonth() === month;
						}
						// If going forward one month, make sure month is as expected
						// (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
						: function(){
							return new_date.getUTCMonth() !== new_month;
						};
					new_month = month + dir;
					new_date.setUTCMonth(new_month);
					// Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
					if (new_month < 0 || new_month > 11)
						new_month = (new_month + 12) % 12;
				}
				else {
					// For magnitudes >1, move one month at a time...
					for (var i=0; i < mag; i++)
						// ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
						new_date = this.moveMonth(new_date, dir);
					// ...then reset the day, keeping it in the new month
					new_month = new_date.getUTCMonth();
					new_date.setUTCDate(day);
					test = function(){
						return new_month !== new_date.getUTCMonth();
					};
				}
				// Common date-resetting loop -- if date is beyond end of month, make it
				// end of month
				while (test()){
					new_date.setUTCDate(--day);
					new_date.setUTCMonth(new_month);
				}
				return new_date;
			},
	
			moveYear: function(date, dir){
				return this.moveMonth(date, dir*12);
			},
	
			moveAvailableDate: function(date, dir, fn){
				do {
					date = this[fn](date, dir);
	
					if (!this.dateWithinRange(date))
						return false;
	
					fn = 'moveDay';
				}
				while (this.dateIsDisabled(date));
	
				return date;
			},
	
			weekOfDateIsDisabled: function(date){
				return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
			},
	
			dateIsDisabled: function(date){
				return (
					this.weekOfDateIsDisabled(date) ||
					$.grep(this.o.datesDisabled, function(d){
						return isUTCEquals(date, d);
					}).length > 0
				);
			},
	
			dateWithinRange: function(date){
				return date >= this.o.startDate && date <= this.o.endDate;
			},
	
			keydown: function(e){
				if (!this.picker.is(':visible')){
					if (e.keyCode === 40 || e.keyCode === 27) { // allow down to re-show picker
						this.show();
						e.stopPropagation();
	        }
					return;
				}
				var dateChanged = false,
					dir, newViewDate,
					focusDate = this.focusDate || this.viewDate;
				switch (e.keyCode){
					case 27: // escape
						if (this.focusDate){
							this.focusDate = null;
							this.viewDate = this.dates.get(-1) || this.viewDate;
							this.fill();
						}
						else
							this.hide();
						e.preventDefault();
						e.stopPropagation();
						break;
					case 37: // left
					case 38: // up
					case 39: // right
					case 40: // down
						if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7)
							break;
						dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
	          if (this.viewMode === 0) {
	  					if (e.ctrlKey){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
	
	  						if (newViewDate)
	  							this._trigger('changeYear', this.viewDate);
	  					}
	  					else if (e.shiftKey){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
	
	  						if (newViewDate)
	  							this._trigger('changeMonth', this.viewDate);
	  					}
	  					else if (e.keyCode === 37 || e.keyCode === 39){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveDay');
	  					}
	  					else if (!this.weekOfDateIsDisabled(focusDate)){
	  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveWeek');
	  					}
	          } else if (this.viewMode === 1) {
	            if (e.keyCode === 38 || e.keyCode === 40) {
	              dir = dir * 4;
	            }
	            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
	          } else if (this.viewMode === 2) {
	            if (e.keyCode === 38 || e.keyCode === 40) {
	              dir = dir * 4;
	            }
	            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
	          }
						if (newViewDate){
							this.focusDate = this.viewDate = newViewDate;
							this.setValue();
							this.fill();
							e.preventDefault();
						}
						break;
					case 13: // enter
						if (!this.o.forceParse)
							break;
						focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
						if (this.o.keyboardNavigation) {
							this._toggle_multidate(focusDate);
							dateChanged = true;
						}
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.setValue();
						this.fill();
						if (this.picker.is(':visible')){
							e.preventDefault();
							e.stopPropagation();
							if (this.o.autoclose)
								this.hide();
						}
						break;
					case 9: // tab
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
						this.hide();
						break;
				}
				if (dateChanged){
					if (this.dates.length)
						this._trigger('changeDate');
					else
						this._trigger('clearDate');
					if (this.inputField){
						this.inputField.change();
					}
				}
			},
	
			showMode: function(dir){
				if (dir){
					this.viewMode = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, this.viewMode + dir));
				}
				this.picker
					.children('div')
					.hide()
					.filter('.datepicker-' + DPGlobal.modes[this.viewMode].clsName)
						.show();
				this.updateNavArrows();
			}
		};
	
		var DateRangePicker = function(element, options){
			$(element).data('datepicker', this);
			this.element = $(element);
			this.inputs = $.map(options.inputs, function(i){
				return i.jquery ? i[0] : i;
			});
			delete options.inputs;
	
			datepickerPlugin.call($(this.inputs), options)
				.on('changeDate', $.proxy(this.dateUpdated, this));
	
			this.pickers = $.map(this.inputs, function(i){
				return $(i).data('datepicker');
			});
			this.updateDates();
		};
		DateRangePicker.prototype = {
			updateDates: function(){
				this.dates = $.map(this.pickers, function(i){
					return i.getUTCDate();
				});
				this.updateRanges();
			},
			updateRanges: function(){
				var range = $.map(this.dates, function(d){
					return d.valueOf();
				});
				$.each(this.pickers, function(i, p){
					p.setRange(range);
				});
			},
			dateUpdated: function(e){
				// `this.updating` is a workaround for preventing infinite recursion
				// between `changeDate` triggering and `setUTCDate` calling.  Until
				// there is a better mechanism.
				if (this.updating)
					return;
				this.updating = true;
	
				var dp = $(e.target).data('datepicker');
	
				if (typeof(dp) === "undefined") {
					return;
				}
	
				var new_date = dp.getUTCDate(),
					i = $.inArray(e.target, this.inputs),
					j = i - 1,
					k = i + 1,
					l = this.inputs.length;
				if (i === -1)
					return;
	
				$.each(this.pickers, function(i, p){
					if (!p.getUTCDate())
						p.setUTCDate(new_date);
				});
	
				if (new_date < this.dates[j]){
					// Date being moved earlier/left
					while (j >= 0 && new_date < this.dates[j]){
						this.pickers[j--].setUTCDate(new_date);
					}
				}
				else if (new_date > this.dates[k]){
					// Date being moved later/right
					while (k < l && new_date > this.dates[k]){
						this.pickers[k++].setUTCDate(new_date);
					}
				}
				this.updateDates();
	
				delete this.updating;
			},
			remove: function(){
				$.map(this.pickers, function(p){ p.remove(); });
				delete this.element.data().datepicker;
			}
		};
	
		function opts_from_el(el, prefix){
			// Derive options from element data-attrs
			var data = $(el).data(),
				out = {}, inkey,
				replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
			prefix = new RegExp('^' + prefix.toLowerCase());
			function re_lower(_,a){
				return a.toLowerCase();
			}
			for (var key in data)
				if (prefix.test(key)){
					inkey = key.replace(replace, re_lower);
					out[inkey] = data[key];
				}
			return out;
		}
	
		function opts_from_locale(lang){
			// Derive options from locale plugins
			var out = {};
			// Check if "de-DE" style date is available, if not language should
			// fallback to 2 letter code eg "de"
			if (!dates[lang]){
				lang = lang.split('-')[0];
				if (!dates[lang])
					return;
			}
			var d = dates[lang];
			$.each(locale_opts, function(i,k){
				if (k in d)
					out[k] = d[k];
			});
			return out;
		}
	
		var old = $.fn.datepicker;
		var datepickerPlugin = function(option){
			var args = Array.apply(null, arguments);
			args.shift();
			var internal_return;
			this.each(function(){
				var $this = $(this),
					data = $this.data('datepicker'),
					options = typeof option === 'object' && option;
				if (!data){
					var elopts = opts_from_el(this, 'date'),
						// Preliminary otions
						xopts = $.extend({}, defaults, elopts, options),
						locopts = opts_from_locale(xopts.language),
						// Options priority: js args, data-attrs, locales, defaults
						opts = $.extend({}, defaults, locopts, elopts, options);
					if ($this.hasClass('input-daterange') || opts.inputs){
						$.extend(opts, {
							inputs: opts.inputs || $this.find('input').toArray()
						});
						data = new DateRangePicker(this, opts);
					}
					else {
						data = new Datepicker(this, opts);
					}
					$this.data('datepicker', data);
				}
				if (typeof option === 'string' && typeof data[option] === 'function'){
					internal_return = data[option].apply(data, args);
				}
			});
	
			if (
				internal_return === undefined ||
				internal_return instanceof Datepicker ||
				internal_return instanceof DateRangePicker
			)
				return this;
	
			if (this.length > 1)
				throw new Error('Using only allowed for the collection of a single element (' + option + ' function)');
			else
				return internal_return;
		};
		$.fn.datepicker = datepickerPlugin;
	
		var defaults = $.fn.datepicker.defaults = {
			assumeNearbyYear: false,
			autoclose: false,
			beforeShowDay: $.noop,
			beforeShowMonth: $.noop,
			beforeShowYear: $.noop,
			beforeShowDecade: $.noop,
			beforeShowCentury: $.noop,
			calendarWeeks: false,
			clearBtn: false,
			toggleActive: false,
			daysOfWeekDisabled: [],
			daysOfWeekHighlighted: [],
			datesDisabled: [],
			endDate: Infinity,
			forceParse: true,
			format: 'mm/dd/yyyy',
			keyboardNavigation: true,
			language: 'en',
			minViewMode: 0,
			maxViewMode: 4,
			multidate: false,
			multidateSeparator: ',',
			orientation: "auto",
			rtl: false,
			startDate: -Infinity,
			startView: 0,
			todayBtn: false,
			todayHighlight: false,
			weekStart: 0,
			disableTouchKeyboard: false,
			enableOnReadonly: true,
			showOnFocus: true,
			zIndexOffset: 10,
			container: 'body',
			immediateUpdates: false,
			title: '',
			templates: {
				leftArrow: '&laquo;',
				rightArrow: '&raquo;'
			}
		};
		var locale_opts = $.fn.datepicker.locale_opts = [
			'format',
			'rtl',
			'weekStart'
		];
		$.fn.datepicker.Constructor = Datepicker;
		var dates = $.fn.datepicker.dates = {
			en: {
				days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
				daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
				daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
				months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
				monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
				today: "Today",
				clear: "Clear",
				titleFormat: "MM yyyy"
			}
		};
	
		var DPGlobal = {
			modes: [
				{
					clsName: 'days',
					navFnc: 'Month',
					navStep: 1
				},
				{
					clsName: 'months',
					navFnc: 'FullYear',
					navStep: 1
				},
				{
					clsName: 'years',
					navFnc: 'FullYear',
					navStep: 10
				},
				{
					clsName: 'decades',
					navFnc: 'FullDecade',
					navStep: 100
				},
				{
					clsName: 'centuries',
					navFnc: 'FullCentury',
					navStep: 1000
			}],
			isLeapYear: function(year){
				return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
			},
			getDaysInMonth: function(year, month){
				return [31, (DPGlobal.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
			},
			validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
			nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
			parseFormat: function(format){
				if (typeof format.toValue === 'function' && typeof format.toDisplay === 'function')
	                return format;
	            // IE treats \0 as a string end in inputs (truncating the value),
				// so it's a bad format delimiter, anyway
				var separators = format.replace(this.validParts, '\0').split('\0'),
					parts = format.match(this.validParts);
				if (!separators || !separators.length || !parts || parts.length === 0){
					throw new Error("Invalid date format.");
				}
				return {separators: separators, parts: parts};
			},
			parseDate: function(date, format, language, assumeNearby){
				if (!date)
					return undefined;
				if (date instanceof Date)
					return date;
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				if (format.toValue)
	                return format.toValue(date, format, language);
	            var part_re = /([\-+]\d+)([dmwy])/,
					parts = date.match(/([\-+]\d+)([dmwy])/g),
					fn_map = {
						d: 'moveDay',
						m: 'moveMonth',
						w: 'moveWeek',
						y: 'moveYear'
					},
					dateAliases = {
						yesterday: '-1d',
						today: '+0d',
						tomorrow: '+1d'
					},
					part, dir, i, fn;
				if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)){
					date = new Date();
					for (i=0; i < parts.length; i++){
						part = part_re.exec(parts[i]);
						dir = parseInt(part[1]);
						fn = fn_map[part[2]];
						date = Datepicker.prototype[fn](date, dir);
					}
					return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
				}
	
				if (typeof dateAliases[date] !== 'undefined') {
					date = dateAliases[date];
					parts = date.match(/([\-+]\d+)([dmwy])/g);
	
					if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)){
						date = new Date();
					  	for (i=0; i < parts.length; i++){
							part = part_re.exec(parts[i]);
							dir = parseInt(part[1]);
							fn = fn_map[part[2]];
							date = Datepicker.prototype[fn](date, dir);
					  	}
	
				  		return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
					}
				}
	
				parts = date && date.match(this.nonpunctuation) || [];
				date = new Date();
	
				function applyNearbyYear(year, threshold){
					if (threshold === true)
						threshold = 10;
	
					// if year is 2 digits or less, than the user most likely is trying to get a recent century
					if (year < 100){
						year += 2000;
						// if the new year is more than threshold years in advance, use last century
						if (year > ((new Date()).getFullYear()+threshold)){
							year -= 100;
						}
					}
	
					return year;
				}
	
				var parsed = {},
					setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
					setters_map = {
						yyyy: function(d,v){
							return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
						},
						yy: function(d,v){
							return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
						},
						m: function(d,v){
							if (isNaN(d))
								return d;
							v -= 1;
							while (v < 0) v += 12;
							v %= 12;
							d.setUTCMonth(v);
							while (d.getUTCMonth() !== v)
								d.setUTCDate(d.getUTCDate()-1);
							return d;
						},
						d: function(d,v){
							return d.setUTCDate(v);
						}
					},
					val, filtered;
				setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
				setters_map['dd'] = setters_map['d'];
				date = UTCToday();
				var fparts = format.parts.slice();
				// Remove noop parts
				if (parts.length !== fparts.length){
					fparts = $(fparts).filter(function(i,p){
						return $.inArray(p, setters_order) !== -1;
					}).toArray();
				}
				// Process remainder
				function match_part(){
					var m = this.slice(0, parts[i].length),
						p = parts[i].slice(0, m.length);
					return m.toLowerCase() === p.toLowerCase();
				}
				if (parts.length === fparts.length){
					var cnt;
					for (i=0, cnt = fparts.length; i < cnt; i++){
						val = parseInt(parts[i], 10);
						part = fparts[i];
						if (isNaN(val)){
							switch (part){
								case 'MM':
									filtered = $(dates[language].months).filter(match_part);
									val = $.inArray(filtered[0], dates[language].months) + 1;
									break;
								case 'M':
									filtered = $(dates[language].monthsShort).filter(match_part);
									val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
									break;
							}
						}
						parsed[part] = val;
					}
					var _date, s;
					for (i=0; i < setters_order.length; i++){
						s = setters_order[i];
						if (s in parsed && !isNaN(parsed[s])){
							_date = new Date(date);
							setters_map[s](_date, parsed[s]);
							if (!isNaN(_date))
								date = _date;
						}
					}
				}
				return date;
			},
			formatDate: function(date, format, language){
				if (!date)
					return '';
				if (typeof format === 'string')
					format = DPGlobal.parseFormat(format);
				if (format.toDisplay)
	                return format.toDisplay(date, format, language);
	            var val = {
					d: date.getUTCDate(),
					D: dates[language].daysShort[date.getUTCDay()],
					DD: dates[language].days[date.getUTCDay()],
					m: date.getUTCMonth() + 1,
					M: dates[language].monthsShort[date.getUTCMonth()],
					MM: dates[language].months[date.getUTCMonth()],
					yy: date.getUTCFullYear().toString().substring(2),
					yyyy: date.getUTCFullYear()
				};
				val.dd = (val.d < 10 ? '0' : '') + val.d;
				val.mm = (val.m < 10 ? '0' : '') + val.m;
				date = [];
				var seps = $.extend([], format.separators);
				for (var i=0, cnt = format.parts.length; i <= cnt; i++){
					if (seps.length)
						date.push(seps.shift());
					date.push(val[format.parts[i]]);
				}
				return date.join('');
			},
			headTemplate: '<thead>'+
				              '<tr>'+
				                '<th colspan="7" class="datepicker-title"></th>'+
				              '</tr>'+
								'<tr>'+
									'<th class="prev">&laquo;</th>'+
									'<th colspan="5" class="datepicker-switch"></th>'+
									'<th class="next">&raquo;</th>'+
								'</tr>'+
							'</thead>',
			contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
			footTemplate: '<tfoot>'+
								'<tr>'+
									'<th colspan="7" class="today"></th>'+
								'</tr>'+
								'<tr>'+
									'<th colspan="7" class="clear"></th>'+
								'</tr>'+
							'</tfoot>'
		};
		DPGlobal.template = '<div class="datepicker">'+
								'<div class="datepicker-days">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										'<tbody></tbody>'+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-months">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-years">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-decades">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
								'<div class="datepicker-centuries">'+
									'<table class="table-condensed">'+
										DPGlobal.headTemplate+
										DPGlobal.contTemplate+
										DPGlobal.footTemplate+
									'</table>'+
								'</div>'+
							'</div>';
	
		$.fn.datepicker.DPGlobal = DPGlobal;
	
	
		/* DATEPICKER NO CONFLICT
		* =================== */
	
		$.fn.datepicker.noConflict = function(){
			$.fn.datepicker = old;
			return this;
		};
	
		/* DATEPICKER VERSION
		 * =================== */
		$.fn.datepicker.version = '1.6.1';
	
		/* DATEPICKER DATA-API
		* ================== */
	
		$(document).on(
			'focus.datepicker.data-api click.datepicker.data-api',
			'[data-provide="datepicker"]',
			function(e){
				var $this = $(this);
				if ($this.data('datepicker'))
					return;
				e.preventDefault();
				// component click requires us to explicitly show it
				datepickerPlugin.call($this, 'show');
			}
		);
		$(function(){
			datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
		});
	
	}));


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(105);
	var $apply = __webpack_require__(148);
	var actualApply = __webpack_require__(231);
	
	/** @type {import('./applyBind')} */
	module.exports = function applyBind() {
		return actualApply(bind, $apply, arguments);
	};


/***/ },
/* 851 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./reflectApply')} */
	module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var setFunctionLength = __webpack_require__(1565);
	
	var $defineProperty = __webpack_require__(130);
	
	var callBindBasic = __webpack_require__(150);
	var applyBind = __webpack_require__(850);
	
	module.exports = function callBind(originalFunction) {
		var func = callBindBasic(arguments);
		var adjustedLength = originalFunction.length - (arguments.length - 1);
		return setFunctionLength(
			func,
			1 + (adjustedLength > 0 ? adjustedLength : 0),
			true
		);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(130);
	
	var $SyntaxError = __webpack_require__(269);
	var $TypeError = __webpack_require__(63);
	
	var gopd = __webpack_require__(93);
	
	/** @type {import('.')} */
	module.exports = function defineDataProperty(
		obj,
		property,
		value
	) {
		if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
			throw new $TypeError('`obj` must be an object or a function`');
		}
		if (typeof property !== 'string' && typeof property !== 'symbol') {
			throw new $TypeError('`property` must be a string or a symbol`');
		}
		if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
			throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
			throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
			throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
		}
		if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
			throw new $TypeError('`loose`, if provided, must be a boolean');
		}
	
		var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
		var nonWritable = arguments.length > 4 ? arguments[4] : null;
		var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
		var loose = arguments.length > 6 ? arguments[6] : false;
	
		/* @type {false | TypedPropertyDescriptor<unknown>} */
		var desc = !!gopd && gopd(obj, property);
	
		if ($defineProperty) {
			$defineProperty(obj, property, {
				configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
				enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
				value: value,
				writable: nonWritable === null && desc ? desc.writable : !nonWritable
			});
		} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
			// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
			obj[property] = value; // eslint-disable-line no-param-reassign
		} else {
			throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
		}
	};


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	// This file should be ES5 compatible
	/* eslint prefer-spread:0, no-var:0, prefer-reflect:0, no-magic-numbers:0 */
	'use strict'
	
	module.exports = (function () {
		// Import Events
		var events = __webpack_require__(131)
	
		// Export Domain
		var domain = {}
		domain.createDomain = domain.create = function () {
			var d = new events.EventEmitter()
	
			function emitError (e) {
				d.emit('error', e)
			}
	
			d.add = function (emitter) {
				emitter.on('error', emitError)
			}
			d.remove = function (emitter) {
				emitter.removeListener('error', emitError)
			}
			d.bind = function (fn) {
				return function () {
					var args = Array.prototype.slice.call(arguments)
					try {
						fn.apply(null, args)
					}
					catch (err) {
						emitError(err)
					}
				}
			}
			d.intercept = function (fn) {
				return function (err) {
					if ( err ) {
						emitError(err)
					}
					else {
						var args = Array.prototype.slice.call(arguments, 1)
						try {
							fn.apply(null, args)
						}
						catch (err) {
							emitError(err)
						}
					}
				}
			}
			d.run = function (fn) {
				try {
					fn()
				}
				catch (err) {
					emitError(err)
				}
				return this
			}
			d.dispose = function () {
				this.removeAllListeners()
				return this
			}
			d.enter = d.exit = function () {
				return this
			}
			return d
		}
		return domain
	}).call(this)


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBind = __webpack_require__(150);
	var gOPD = __webpack_require__(93);
	
	var hasProtoAccessor;
	try {
		// eslint-disable-next-line no-extra-parens, no-proto
		hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
			throw e;
		}
	}
	
	// eslint-disable-next-line no-extra-parens
	var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));
	
	var $Object = Object;
	var $getPrototypeOf = $Object.getPrototypeOf;
	
	/** @type {import('./get')} */
	module.exports = desc && typeof desc.get === 'function'
		? callBind([desc.get])
		: typeof $getPrototypeOf === 'function'
			? /** @type {import('./get')} */ function getDunder(value) {
				// eslint-disable-next-line eqeqeq
				return $getPrototypeOf(value == null ? value : $Object(value));
			}
			: false;


/***/ },
/* 1056 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ },
/* 1057 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ },
/* 1058 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ },
/* 1059 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ },
/* 1060 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ },
/* 1061 */
92,
/* 1062 */
92,
/* 1063 */
92,
/* 1064 */
92,
/* 1065 */
92,
/* 1066 */
92,
/* 1067 */
92,
/* 1068 */
92,
/* 1069 */
92,
/* 1070 */
92,
/* 1071 */
92,
/* 1072 */
92,
/* 1073 */
92,
/* 1074 */
92,
/* 1075 */
92,
/* 1076 */
92,
/* 1077 */
92,
/* 1078 */
92,
/* 1079 */
92,
/* 1080 */
92,
/* 1081 */
92,
/* 1082 */
92,
/* 1083 */
92,
/* 1084 */
92,
/* 1085 */
92,
/* 1086 */
92,
/* 1087 */
92,
/* 1088 */
92,
/* 1089 */
92,
/* 1090 */
92,
/* 1091 */
92,
/* 1092 */
92,
/* 1093 */
92,
/* 1094 */
92,
/* 1095 */
92,
/* 1096 */
92,
/* 1097 */
92,
/* 1098 */
92,
/* 1099 */
92,
/* 1100 */
92,
/* 1101 */
92,
/* 1102 */
92,
/* 1103 */
92,
/* 1104 */
92,
/* 1105 */
92,
/* 1106 */
92,
/* 1107 */
92,
/* 1108 */
92,
/* 1109 */
92,
/* 1110 */
92,
/* 1111 */
92,
/* 1112 */
92,
/* 1113 */
92,
/* 1114 */
92,
/* 1115 */
92,
/* 1116 */
92,
/* 1117 */
92,
/* 1118 */
92,
/* 1119 */
92,
/* 1120 */
92,
/* 1121 */
92,
/* 1122 */
92,
/* 1123 */
92,
/* 1124 */
92,
/* 1125 */
92,
/* 1126 */
92,
/* 1127 */
92,
/* 1128 */
92,
/* 1129 */
92,
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isCallable = __webpack_require__(1477);
	
	var toStr = Object.prototype.toString;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */
	var forEachArray = function forEachArray(array, iterator, receiver) {
	    for (var i = 0, len = array.length; i < len; i++) {
	        if (hasOwnProperty.call(array, i)) {
	            if (receiver == null) {
	                iterator(array[i], i, array);
	            } else {
	                iterator.call(receiver, array[i], i, array);
	            }
	        }
	    }
	};
	
	/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */
	var forEachString = function forEachString(string, iterator, receiver) {
	    for (var i = 0, len = string.length; i < len; i++) {
	        // no such thing as a sparse string.
	        if (receiver == null) {
	            iterator(string.charAt(i), i, string);
	        } else {
	            iterator.call(receiver, string.charAt(i), i, string);
	        }
	    }
	};
	
	/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */
	var forEachObject = function forEachObject(object, iterator, receiver) {
	    for (var k in object) {
	        if (hasOwnProperty.call(object, k)) {
	            if (receiver == null) {
	                iterator(object[k], k, object);
	            } else {
	                iterator.call(receiver, object[k], k, object);
	            }
	        }
	    }
	};
	
	/** @type {(x: unknown) => x is readonly unknown[]} */
	function isArray(x) {
	    return toStr.call(x) === '[object Array]';
	}
	
	/** @type {import('.')._internal} */
	module.exports = function forEach(list, iterator, thisArg) {
	    if (!isCallable(iterator)) {
	        throw new TypeError('iterator must be a function');
	    }
	
	    var receiver;
	    if (arguments.length >= 3) {
	        receiver = thisArg;
	    }
	
	    if (isArray(list)) {
	        forEachArray(list, iterator, receiver);
	    } else if (typeof list === 'string') {
	        forEachString(list, iterator, receiver);
	    } else {
	        forEachObject(list, iterator, receiver);
	    }
	};


/***/ },
/* 1131 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 1132 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {GeneratorFunctionConstructor | false} */
	var cached;
	
	/** @type {import('./index.js')} */
	module.exports = function getGeneratorFunction() {
		if (typeof cached === 'undefined') {
			try {
				// eslint-disable-next-line no-new-func
				cached = Function('return function* () {}')().constructor;
			} catch (e) {
				cached = false;
			}
		}
		return cached;
	};
	


/***/ },
/* 1133 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./gOPD')} */
	module.exports = Object.getOwnPropertyDescriptor;


/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $defineProperty = __webpack_require__(130);
	
	var hasPropertyDescriptors = function hasPropertyDescriptors() {
		return !!$defineProperty;
	};
	
	hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
		// node v0.6 has a bug where array lengths can be Set but not Defined
		if (!$defineProperty) {
			return null;
		}
		try {
			return $defineProperty([], 'length', { value: 1 }).length !== 1;
		} catch (e) {
			// In Firefox 4-22, defining length on an array throws an exception.
			return true;
		}
	};
	
	module.exports = hasPropertyDescriptors;


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(281);
	
	/** @type {import('.')} */
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 1136 */
/***/ function(module, exports) {

	module.exports = "<div> <div class=\"q-alert q-alert-yellow q-no-pad q-marg-all-xl q-text-center\"> <p class=q-marg-all-sm> Something went wrong on our end. Please try the solutions below. </p> </div> <div class=\"q-marg-horz-xl q-marg-vert-lg\"> <div class=\"divider-group q-no-pad\"> <div class=\"q-pretty-container q-pct-lightest-grey-borders toggler-parent\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=\"q-pad-vert q-pad-left-til-md q-pad-horz-at-md q-pct-header-group-title\"> <div class=q-pad-vert-xs> <span class=\"q-boldest q-marg-right-md\">View Error Details</span> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-marg-horz q-marg-bottom-xl\"> <p class=\"q-boldest q-marg-vert-sm\"> {%- errorTitle %} </p> <p class=q-marg-vert-sm> {%- errorDescription %} </p> </div> </div> </div> </div> </div> <div class=\"divider-group q-pad-vert q-pad-horz\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-vert-xxs> <i class=\"fa fa-wrench q-fs-lg q-marg-right-md q-boldest\" aria-hidden=true></i> Please close this modal and try again. </div> </div> <div class=\"col-md-6 col-xs-12\"> </div> </div> </div> <div class=\"divider-group q-pad-vert q-pad-horz\"> <div class=row> <div class=\"col-md-12 col-xs-12\"> <div class=q-marg-vert-xxs> <i class=\"fa fa-phone q-fs-lg q-marg-right-md q-boldest\" aria-hidden=true></i> Please contact your dedicated Customer Success Specialist if the issue persists </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1137 */
/***/ function(module, exports) {

	module.exports = "<div class=widget-engine-container> <div class=\"q-card q-card-white\"> {% if(hasViewToggler){ %} {%= viewToggler %} {% } %} <div class=q-section> <div class=\"q-marg-all-xl q-marg-top-md\"> <div class=we-items-container> <div class=\"we-filter-container clearfix\"> <div class=row> <div class=\"col-lg-8 col-md-9\"> {% if(hasLinkContainer){ %} <div class=\"q-pull-left-til-md filter-link-container\" data-filter-link=all> {%= filterLinkContainer %} </div> {% } %} </div> <div class=\"col-lg-4 col-md-3\"> <div class=\"q-pull-right-til-md q-marg-vert-md-at-md\"> <a class=\"base-btn purple-btn v2-btn we-page-refresh-trigger q-marg-right-md-til-md q-marg-bottom-md-at-md q-block-at-md q-text-center\"><i class=\"q-icon-marg-right fa fa-refresh\"></i>Refresh</a> <a class=\"base-btn purple-btn v2-btn we-filter-modal-open q-block-at-md q-text-center\"><i class=\"q-icon-marg-right fa fa-filter\"></i>Filter</a> </div> </div> </div> <div class=we-feed-container> {%= feedContainer %} </div> </div> <div class=\"q-marg-bottom-xl q-text-center\"> <a href=# class=\"base-btn purple-btn large-btn load-more-btn\">Load More</a> <a href=# class=\"base-btn purple-btn large-btn loading-in-progress\" style=display:none><i class=\"fa fa-spinner fa-pulse q-icon-marg-right\"></i>Loading</a> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1138 */
/***/ function(module, exports) {

	module.exports = "<div class=child-filters-wrap> <div>{%= filterList %}</div> </div>";

/***/ },
/* 1139 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group dg-lg\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox data-operator=\"{%- operator %}\" name=\"{%- name %}\" value=\"{%- value %}\" class=filter-modal-input {% if (active) { %} checked=checked {% } %}/> <span class=cb-label-inner> {%- title %} </span> </label> </div> <div class=child-filters-entry {% if (!active) { %} style=display:none {% } %}> {%= childFiltersHtml %} </div> </div>";

/***/ },
/* 1140 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-grid wrapper-helper\"> <div class=\"q-input-group q-input-group-connected no-pad-bottom q-row q-input-group-connected-break-at-sm\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-static-col-2 q-input-first func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input id=startDate class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input\" name=\"{%- dateRangeNameStart %}\" required type=text data-error-placement-append-closest=.wrapper-helper value=\"{%- dateRangeStartVal %}\" placeholder=\"   /   /   \"/> </div> <div class=\"q-input-group-connected-inner q-static-col\"> <div class=\"q-sim-input q-text-center\"> to </div> </div> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-last q-inner-text-right q-static-col-2 q-input-last func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input id=endDate class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input\" name=\"{%- dateRangeNameEnd %}\" required type=text data-error-placement-append-closest=.wrapper-helper value=\"{%- dateRangeEndVal %}\" placeholder=\"   /   /   \"/> </div> </div> </div>";

/***/ },
/* 1141 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group dg-lg\"> <div class=\"q-checkmark-radio q-cr-with-label\"> <label> <input type=radio data-operator=\"{%- operator %}\" name=\"{%- name %}\" value=\"{%- value %}\" class=filter-modal-input {% if (active) { %} checked=checked {% } %} /> <span class=q-checkmark-radio-label-inner></span> <span class=q-cr-label>{%- title %}</span> </label> </div> <div class=child-filters-entry {% if (!active) { %} style=display:none {% } %}> {%= childFiltersHtml %} </div> </div>";

/***/ },
/* 1142 */
/***/ function(module, exports) {

	module.exports = "<form class=tableFilterModal> {%= groupList %} </form>";

/***/ },
/* 1143 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-lg> <div class=\"q-expandable-header q-eh-block-with-bg q-no-pad\"> <a href=# class=\"q-block q-expander q-pad-all-lg\" data-q-expander-target=\".filter-expander-{%- index %}\" data-q-expander-open-icon=fa-angle-down data-q-expander-close-icon=fa-angle-up> <h2 class=\"q-expandable-title q-et-small\">{%- title %}</h2> <span class=q-pull-right> <i class=\"q-expandable-icon q-ei-large fa fa-angle-down q-icon-md\" aria-hidden=true></i></span></a>   </div> <div class=\"filter-expander-{%- index %} q-expandable-default\"> <div class=\"q-expandable-body input-list-section q-no-marg q-marg-all-lg\"> {%= filterList %} </div> </div> </div>";

/***/ },
/* 1144 */
/***/ function(module, exports) {

	module.exports = "<div class=\"{%- classWidth %} q-text-right\"> <div class=\"dropdown q-dropdown q-block-at-md\"> <a class=\"base-btn purple-btn v2-btn q-block-at-md q-text-center\" href=# data-toggle=dropdown role=button aria-haspopup=true aria-expanded=true> <div class=btn-text-wrap> <span class=btn-text> <i class=\"fa fa-chevron-down\"></i> </span> </div> </a> <ul class=\"dropdown-menu dropdown-menu-right q-dropdown-no-max q-dropdown-full-at-mid q-dropdown-right\" data-parent-index=header> {%= alertActionList%} </ul> </div> </div>";

/***/ },
/* 1145 */
/***/ function(module, exports) {

	module.exports = "<li><a class=\"q-pad-horz-sm action-link {%- cls %} {% if (disabled) { %} disabled {% } %}\" href=# data-id=\"{%- id %}\" data-url=\"{%- url %}\"><i class=\"fa fa-{%- icon %} q-icon-marg-right\"></i>{%- title %}</a></li>";

/***/ },
/* 1146 */
/***/ function(module, exports) {

	module.exports = "<div class={%- classWidth %}> <div class=q-marg-vert-md-at-md> {%- channel %} </div> </div>";

/***/ },
/* 1147 */
/***/ function(module, exports) {

	module.exports = "<div class={%- classWidth %}> <div class=q-marg-vert-md-at-md> {%- date %} {% if (status === 'New') { %} <span class=\"q-pretty-pill-tag q-ppt-pad-md q-ppt-green q-ppt-large-radius q-fs-xs q-marg-left-md\">NEW</span> {% } %} </div> </div>";

/***/ },
/* 1148 */
/***/ function(module, exports) {

	module.exports = "<div class={%- classWidth %}> <div class=q-marg-vert-md-at-md> <div class=q-boldest>{%- title %}</div> {%= description %} </div> </div>";

/***/ },
/* 1149 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-box pretty-box-border q-no-pad q-marg-bottom-xl\"> <div class=q-section> <div class=\"q-pad-all-md q-bg-c-lightest-grey\"> <h4 class=q-title>{%- header %}</h4> </div> </div> <div class=we-feed-data-display> {%= feedListOnload %} </div> </div>";

/***/ },
/* 1150 */
/***/ function(module, exports) {

	module.exports = "<div class={%- classWidth %}> <i class=\"fa {%- icon %} q-fs-md q-icon-marg-left\"></i> </div>";

/***/ },
/* 1151 */
/***/ function(module, exports) {

	module.exports = "<div class={%- classWidth %}> <div class=q-marg-vert-md-at-md> <div class=\"q-pill q-pill-table {%- pillColor %}\">{%- pillText %}</div> </div> </div>";

/***/ },
/* 1152 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section feed-row-item\"> <div class=q-marg-horz-md> <div class=\"q-tc-container q-min-height-65 q-pad-vert-xxs q-marg-vert-md-at-md\"> <div class=\"q-tc-row q-v-align-children-middle\"> {%= rowColumns %} </div> </div> </div> </div>";

/***/ },
/* 1153 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-top-md file-name-row {%- hasError %}\" data-file-list-index=\"{%- ndx %}\"> <div class=\"pretty-well pw-pad-xs q-pad-vert-xxs pw-border pw-white-bg\"> <div class=row> <div class=col-xs-10> <div class=\"q-marg-top-xs q-marg-bottom-xs-at-md q-text-left\"> <span class=q-boldest>{%- fileName %}</span> </div> </div> <div class=col-xs-2> <a href=# class=\"q-close-btn q-pull-right q-no-pad-horz file-remove-btn\"><i class=\"fa fa-times\"></i></a> </div> </div> {%= error %} </div> </div>";

/***/ },
/* 1154 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-box q-pretty-box-grey pretty-box-border\"> <div class=q-tc-container> <div class=\"q-tc-row q-v-align-children-middle\"> <div class=\"q-col-fix-130 q-no-pad\"> <a href=# class=\"base-btn purple-btn select-files-btn\"> Select Files </a> <input type=file class=mfu-file-input accept=\"{%- accept %}\" {%- (multiple) ? 'multiple' : '' %} /> </div> <div class=\"q-col-3 q-no-pad\"> <div class=q-marg-top-md-at-md> <span class=q-tag>Max File Size:</span> <span> {%- maxFileSize %} MB</span> </div> </div> <div class=\"q-col-7 q-no-pad\"> <div class=\"q-marg-top-md-at-md q-pull-right-til-md\"> <span class=q-tag>File Formats:</span> <span> {%- fileFormat %}</span> </div> </div> </div> </div> </div> <div class=file-name-render-area> </div>";

/***/ },
/* 1155 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-bottom-xl q-marg-top-xs-at-md q-marg-horz-xl q-pad-vert-xs\"> <div class=q-tc-container> <div class=\"q-tc-row q-v-align-children-middle\"> <div class=\"q-col-10 q-no-pad\"> Filters: <span class=applied-filter-pills></span> </div> {% if (canEdit === true) { %} <div class=\"q-col-2 q-no-pad-at-md q-no-pad-right\"> <a href=# class=\"base-btn v2-btn purple-btn q-pull-right-til-md q-block-at-md q-text-center-at-md q-marg-vert-md-at-md js-manage-view-modal-open\"> Manage View </a> </div> {% } %} </div> </div> </div>";

/***/ },
/* 1156 */
/***/ function(module, exports) {

	module.exports = "<div class=\"data-table-component-wrap clearfix\"> {% if (tableSearch) { %} <div class=\"table-top clearfix\"> <div class=q-tc-container> <div class=\"q-tc-row q-v-align-children-middle\"> {%= searchInput %} </div> </div> </div> {% } %} {% if (!appliedFilterBar) { %} {%= btnSectionHtml %} {% } %} <div class=\"saved-search-section q-marg-horz-xl {% if (!tableSearch) { %} q-marg-top-md {% } %}\"> {%= optional.savedSearchBar %} </div> <div class=applied-filter-section> {%= appliedFilterBar %} </div> <div class=table-content> <div class=q-overflow-x-auto> <div class=\"data-table-error-msg-wrap q-display-none\"></div> <table class=\"data-table-component table q-table\" width=100%></table> </div> </div> <div class=table-bottom> <div class=q-tc-container> <div class=\"q-tc-row q-v-align-children-middle\"> {%= perPageSelectHtml %} {%= pageDataInfo %} {%= pageNavigation %} </div> </div> </div> <div class=table-loading-overlay> <div class=tlo-content-wrap> <div class=tlo-content> <i class=\"fa fa-spinner fa-5x fa-pulse\"></i> <div class=q-marg-top-xl> <h2> Loading... </h2> </div> </div> </div> </div> </div>";

/***/ },
/* 1157 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-top-xs-at-md q-marg-horz-xl-til-md q-marg-bottom-xl-til-md\"> <div class=clearfix> <a href=# class=\"base-btn v2-btn purple-btn js-manage-view-modal-open q-pull-right-til-md q-block-at-md q-text-center-at-md\"> <i class=\"fa fa-filter q-icon-marg-right\" aria-hidden=true></i> Filters </a> </div> </div>";

/***/ },
/* 1158 */
/***/ function(module, exports) {

	module.exports = "<div class=\"checkbox lookup-bulk-select q-checkbox checkbox-purple cb-middle cb-unchecked-white\"> <label> <input type=checkbox value=\"lookup-bulk-select-{%- value %}\" id=\"lookup-bulk-select-{%- value %}\" name=\"lookup-bulk-select-{%- value %}\" class=\"lookup-bulk-select-{%- placement %}\"/> <span class=cb-label-inner> </span> </label> </div>";

/***/ },
/* 1159 */
1138,
/* 1160 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox name=\"{%- name %}\" value=\"{%- value %}\" data-column-index=\"{%- columnIndex %}\" class=column-modal-input {% if (!canToggle) { %} disabled=disabled {% } %}{% if (active) { %} checked=checked {% } %}/> <span class=cb-label-inner> {%- title %} </span> </label> </div> </div>";

/***/ },
/* 1161 */
/***/ function(module, exports) {

	module.exports = "<div> {% if (link) { %} <a href={%- link %} class=q-boldest><span>{%- content %}</span></a> {% } else { %} <span>{%- content %}</span> {% } %} </div>";

/***/ },
/* 1162 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox data-operator=\"{%- operator %}\" name=\"{%- name %}\" value=\"{%- value %}\" class=filter-modal-input {% if (active) { %} checked=checked {% } %}/> <span class=cb-label-inner> {%- title %} </span> </label> </div> <div class=child-filters-entry {% if (!active) { %} style=display:none {% } %}> {%= childFiltersHtml %} </div> </div>";

/***/ },
/* 1163 */
1140,
/* 1164 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=\"q-checkmark-radio q-cr-with-label\"> <label> <input type=radio data-operator=\"{%- operator %}\" name=\"{%- name %}\" value=\"{%- value %}\" class=filter-modal-input {% if (active) { %} checked=checked {% } %} /> <span class=q-checkmark-radio-label-inner></span> <span class=q-cr-label>{%- title %}</span> </label> </div> <div class=child-filters-entry {% if (!active) { %} style=display:none {% } %}> {%= childFiltersHtml %} </div> </div>";

/***/ },
/* 1165 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-lg> <div class=\"q-expandable-header q-eh-block-with-bg q-no-pad\"> <a href=# class=\"q-block q-expander q-pad-all-lg\" data-q-expander-target=\".filter-expander-{%- index %}\" data-q-expander-open-icon=fa-angle-down data-q-expander-close-icon=fa-angle-up> <h2 class=\"q-expandable-title q-et-small\">{%- title %}</h2> <span class=q-pull-right> <i class=\"q-expandable-icon q-ei-large fa fa-angle-down q-icon-md\" aria-hidden=true></i></span></a>   </div> <div class=\"filter-expander-{%- index %} q-expandable-default\"> <div class=\"q-expandable-body input-list-section q-no-marg q-marg-all-lg\"> {%= filterList %} </div> </div> </div>";

/***/ },
/* 1166 */
/***/ function(module, exports) {

	module.exports = "<span class=\"q-pill q-pill-detail q-pill-white-and-grey pill-filter {% if (!visible) { %} q-display-none {% } %}\" data-operator=\"{%- operator %}\" data-name=\"{%- name %}\" data-value=\"{%- value %}\"> <a href=# class=\"fa fa-close delete-pill-filter\"></a> {%- title %} </span>";

/***/ },
/* 1167 */
/***/ function(module, exports) {

	module.exports = "<form class=manageViewModalForm data-target-view=\"{%- targetView %}\"> <div class=q-marg-all-lg> {% if (targetView) { %} <p class=q-marg-vert-lg>Provide table view name below and then configure filters and columns for this specific view. This view will be saved for your convenience.</p> <input class=\"q-input q-stretch q-marg-vert-lg manage-view-name\" maxlength=30 name=\"{%- targetView %}\" type=text value=\"{%- inputValue %}\" required/> {% } else { %} <p class=q-marg-vert-lg>Configure filters and columns for this view.</p> {% } %} </div> <div class=btn-tab-wrapper> <div class=btn-tab-toggles> <a class=\"btn-tab-trigger active\" data-parent=btn-tab-wrapper data-target=manage-filter-list>Filters</a> <a class=btn-tab-trigger data-parent=btn-tab-wrapper data-target=manage-column-list>Columns</a> </div> <div class=q-marg-all-lg> <div class=\"btn-tab-section manage-filter-list active\"> {%= filterList %} </div> <div class=\"btn-tab-section manage-column-list\"> {%= columnList %} </div> </div> </div> </form>";

/***/ },
/* 1168 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-vert-xs q-marg-horz-xs\"> {% if (link) { %} <span>{%- label %}</span>: <a href={%- link %} class=q-boldest><span>{%- content %}</span></a> {% } else { %} <span>{%- label %}</span>: <span>{%- content %}</span> {% } %} </div>";

/***/ },
/* 1169 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-link-list-container {% if (newSavedViews) { %} q-llc-with-new-saved {% } %} q-display-none-at-md q-overflow-auto\"> <span class=\"qllc-wrap saved-links-container\"> {%= linkList %} </span> {% if (newSavedViews) { %} <a class=\"new-saved-view-btn qllc-link\"> <i class=\"fa fa-plus q-marg-right-xxs\"></i> View </a> {% } %} </div> <div class=\"q-display-none q-block-at-md\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select id=\"{%- dropdownId %}\" name=\"{%- dropdownName %}\" class=\"select2-select q-input saved-link-select\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"{%- dropdownPlaceholder %}\" data-s2-minimum-results-for-search=\"{%- dropdownMinResultsForSearch %}\"> {%= optionList %} </select> {% if (newSavedViews) { %} <span class=\"input-group-btn new-saved-btn-container\"> <a class=\"new-saved-view-btn base-btn purple-btn q-block q-text-center\"> <i class=\"fa fa-plus\"></i> </a> </span> {% } %} </div> </div> </div>";

/***/ },
/* 1170 */
/***/ function(module, exports) {

	module.exports = "<a data-link-info=\"{%- targetKey %}\" class=\"qllc-link filter-link {%- optional.uniqueClass %} {% if (optional.active === true) { %} active {% } %}\" href={%- linkHref %}>{%- text %}</a>";

/***/ },
/* 1171 */
135,
/* 1172 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-alert q-alert-grey q-text-center\"> <div>No results match your search. Please adjust your search and or filters to find the results you are looking for.</div> <div>If this problem persists, please call your dedicated Customer Success Specialist for help.</div> </div>";

/***/ },
/* 1173 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-col-6 q-no-pad q-text-center page-data-info\"> {%= pageData %} </div>";

/***/ },
/* 1174 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-col-3 q-no-pad q-text-right-til-md page-navigation\"> <div class=nav-btn-wrap> <a href=# class=\"nav-btn js-prev-page\" data-previous-page=\"{%- prevPage %}\"><i class=\"fa fa-angle-left q-icon-marg-right\"></i> Previous</a> <a href=# class=\"nav-btn js-next-page\" data-previous-page=\"{%- nextPage %}\">Next <i class=\"fa fa-angle-right q-icon-marg-left\"></i></a> </div> </div>";

/***/ },
/* 1175 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-col-3 q-no-pad per-page-select\"> <select name=totalPerPage class=\"total-per-page select2-select\" data-s2-minimum-results-for-search=Infinity> <option value=10>10 Per Page</option> <option value=25>25 Per Page</option> <option value=50>50 Per Page</option> <option value=100>100 Per Page</option> </select> </div>";

/***/ },
/* 1176 */
/***/ function(module, exports) {

	module.exports = "<option name=\"{%- name %}\" value=\"{%- value %}\">{%- title %}</option>";

/***/ },
/* 1177 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-col-6 q-no-pad\"> <div class=q-row> <div class=\"col-md-2 col-xs-12 q-no-pad\"> <div class=q-marg-vert-xxs-at-md> <select name=orderSearchDropdown style=width:100% class=\"search-input-dropdown select2-select\" data-s2-minimum-results-for-search=Infinity> {%= dropDownOptions %} </select> </div> </div> <div class=\"col-md-10 col-xs-12 q-no-pad-at-md q-no-pad-right\"> <div class=\"table-search-input-wrap q-marg-vert-xxs-at-md\"> <input type=text class=\"search-input q-input q-block\" style=width:100% name=orderSearch placeholder=\"{%- searchInputPlaceholder %}\" value=\"{%- searchInputValue %}\"/> <a href=# class=search-icon> <i class=\"fa fa-search\"></i> </a> </div> </div> </div> </div>";

/***/ },
/* 1178 */
/***/ function(module, exports) {

	module.exports = "<option value=\"{%- pageData %}\" {%- (pageData == pageSize) ? 'selected' : '' %}>{%- pageData %} per Page</option>";

/***/ },
/* 1179 */
/***/ function(module, exports) {

	module.exports = "{% if(link){ %} <a href=# class=\"page-num page-tray {%- (currentPage + 1 == pageNumber) ? 'active-page' : '' %}\" data-page-num=\"{%- pageNumber - 1 %}\">{%- pageNumber %}</a> {% } else { %} <i class=\"extra-space page-tray\">...</i> {% } %}";

/***/ },
/* 1180 */
/***/ function(module, exports) {

	module.exports = "<div class=\"paging-area q-marg-top-xl\"> <div class=row> <div class=\"col-md-2 col-xs-12\"> <select class=\"select2-select page-select\" style=width:100% data-minimum-results-for-search=Infinity> {%= pageSelect %} </select> </div> <div class=\"col-md-3 col-xs-12 q-text-center-at-md q-marg-top-md-at-md q-marg-top-xs-til-md page-info\"> {%- pageInfo %} </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-pull-right-til-md q-marg-top-md-at-md nav-btn-wrap\"> {%= pageButtons %} </div> </div> </div> </div> {%= loaderOverlay %}";

/***/ },
/* 1181 */
/***/ function(module, exports) {

	module.exports = "<a class=\"prev-btn nav-btn\"><i class=\"fa fa-angle-left q-icon-md q-marg-right-xs\" aria-hidden=true></i>Previous</a> {%= pageNumTray %} <a class=\"next-btn nav-btn q-pad-left-til-md\">Next<i class=\"fa fa-angle-right q-icon-md q-marg-left-xs\" aria-hidden=true></i></a>";

/***/ },
/* 1182 */
/***/ function(module, exports) {

	module.exports = "<div class=resource-progress-card> <div class=resource-background-color> <div class=q-text-center> <i class=\"fa resource-icon q-fs-lg\"> </i> </div> </div> <div class=resource-progress-content> <div class=resource-content-pad> <h4 class=resource-title> </h4> <span class=resource-timestamp> </span> </div> </div> </div>";

/***/ },
/* 1183 */
/***/ function(module, exports) {

	module.exports = "<div class=resource-progress-outer> <div class=resource-progress-container> <div class=resource-progress-inner> </div> </div> </div>";

/***/ },
/* 1184 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-overflow-auto clearfix\"> <div class=scheduler-component-wrapper> <table> <thead> <tr> {%= availDates %} </tr> </thead> <tbody> <tr> {%= availTimes %} </tr> </tbody> </table> </div> </div>";

/***/ },
/* 1185 */
/***/ function(module, exports) {

	module.exports = "<td valign=top data-day-index=\"{%- index %}\"> {%= timeBlock %} </td>";

/***/ },
/* 1186 */
/***/ function(module, exports) {

	module.exports = "<th> {%- date %} </th>";

/***/ },
/* 1187 */
/***/ function(module, exports) {

	module.exports = "<div class=\"time-block-wrapper q-marg-vert-md q-text-left\"> <div class=\"q-checkmark-radio q-cr-with-label time-block-div\" data-time-slot-index=\"{%- index %}\"> <label> <input type=radio name=avail-time-radio> <span class=q-checkmark-radio-label-inner></span> <span class=q-cr-label> <span class=q-boldest> {%- timeStamp %} </span> </span> </label> </div> </div>";

/***/ },
/* 1188 */
/***/ function(module, exports) {

	module.exports = "<div class=q-time-picker-default> <div class=time-picker-hours-select-outer> <select class=time-picker-hours-select> </select> </div> <span class=time-picker-seperater>:</span> <div class=time-picker-minutes-select-outer> <select class=time-picker-minutes-select> </select> </div> <div class=time-picker-period-select-outer> <select class=time-picker-period-select> </select> </div> </div>";

/***/ },
/* 1189 */
/***/ function(module, exports) {

	module.exports = "<div class=\"stub-config-panel q-card q-card-white\"> </div>";

/***/ },
/* 1190 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default-base q-max-page-width-md q-page-center-margin carrier-teamMember-section\" id=\"addCarrierTeamMemberDivSec-{%-arrayIndex%}\"> <input type=hidden id=\"team-member-org-type-{%-arrayIndex%}\" value=\"{%- orgType %}\"/> <input type=hidden id=\"team-member-user-id-{%-arrayIndex%}\" name=\"team-member-user-id-{%-arrayIndex%}\" value=\"{%- optional.userId %}\"/> <div class=\"q-card q-card-white\"> <div class=\"q-main-header clearfix\"> <div class=q-inline-block-til-md> <div class=\"q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"><i class=\"fa fa-user q-icon-marg-right\" aria-hidden=true></i>{%- newEdit %} {%- orgName %} Team Member</h2> </div> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Team Member Details </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Username *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=\"car-team-member-username-{%-arrayIndex%}\" class=\"q-input q-stretch username-team required\" name=team-member-username placeholder=\"Enter Username\" data-error-placement-append-closest=div value=\"{%- optional.userName %}\"/> <label class=\"userNameError q-sim-error\" id=\"user-name-exist-error-{%-arrayIndex%}\" hidden=true>Username is already taken.</label> </div> <div class=\"col-md-3 col-xs-12\"> <span>Must be unique and is not editable once created.</span> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Name *</label> </div> <div class=\"col-md-4_5 col-sm-6 col-xs-12\"> <input type=text id=\"car-team-member-first-name-{%-arrayIndex%}\" class=\"q-input q-stretch name-team required\" name=team-member-first-name placeholder=\"First name\" data-error-placement-append-closest=div value=\"{%- optional.firstName %}\"/> </div> <div class=\"col-md-4_5 col-sm-6 col-xs-12\"> <div class=q-marg-top-md-at-xs> <input type=text id=\"car-team-member-last-name-{%-arrayIndex%}\" class=\"q-input q-stretch required\" name=team-member-last-name placeholder=\"Last name\" data-error-placement-append-closest=div value=\"{%- optional.lastName %}\"/> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Title *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=\"org-title-{%-arrayIndex%}\" class=\"q-input q-stretch title-team required\" name=\"org-title-{%-arrayIndex%}\" placeholder=\"Enter organizational title\" data-error-placement-append-closest=div value=\"{%- optional.title %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Email *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=\"car-team-member-email-{%-arrayIndex%}\" class=\"q-input q-stretch email-team required email\" name=team-member-email placeholder=\"Enter organizational email\" data-error-placement-append-closest=div value=\"{%- optional.emailAddress %}\"/> <label class=\"userNameError q-sim-error\" id=\"user-email-exist-error-{%-arrayIndex%}\" hidden=true>Email is already taken.</label> </div> <div class=\"col-md-3 col-xs-12\"> <span>Email address must be unique for each user.</span> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select id=\"car-team-member-phone-code-{%-arrayIndex%}\" class=\"select2-select carrier-phone-code carrier-phone-code-add-carrier-team-member q-input required\" style=width:35% name=phone-code data-s2-full-width-list=true data-error-placement-append-closest=.col-md-6 data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=5> {%=phoneCodes%} </select> <input type=text id=\"car-team-member-phone-{%-arrayIndex%}\" class=\"q-input q-ig-flex-fill stretch contact-number carrier-phone-number-add-carrier-team-member phone-format phoneUS required\" data-error-placement-append-closest=.col-md-6 name=phone-number placeholder=\"Enter phone number\" value=\"{%- optional.phoneNumber %}\"/> </div> </div> </div> </div> </div> </div> </div> <div class=q-footer> <div class=\"q-footer-btn-group q-pull-right-til-md\"> <a href=# class=\"q-block-at-md q-text-center-at-md base-btn purple-btn v2-btn cancel-team-member-btn\">Cancel</a> <a href=# class=\"q-block-at-md q-text-center-at-md base-btn purple-btn save-team-member-btn\">Add Team Member</a> </div> </div> </div> </div>";

/***/ },
/* 1191 */
/***/ function(module, exports) {

	module.exports = "<div class=col-xs-4> <a href=# class=\"base-btn purple-btn v2-btn q-pull-right add-facility-cancel-btn\"> Cancel </a> </div>";

/***/ },
/* 1192 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section carrier-section-details\" id=carrier-section-div> <div class=\"q-section carrier-details-section\"> <div class=q-marg-all-xl> <h2 class=q-section-title>Carrier Details</h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Organization Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required organization-name\" name=carrier-section-org-name disabled=disabled id=organization-name value=\"{%- optional.carName %}\" placeholder=\"Enter the organization name\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md id=validate-scac-code> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>SCAC Code *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input class=\"q-input q-stretch required scac-code\" disabled=disabled id=scac-code name=scac-code type=text value=\"{%- optional.carScac %}\" placeholder=\"Enter the Standard Carrier Alpha Code (SCAC) code\" data-error-placement-append-closest=div maxlength=4 /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Carrier GLN</label> </div> <div class=\"col-md-6 col-xs-12\"> <input class=\"q-input q-stretch\" name=carrier-gln disabled=disabled id=carrier-gln type=text value=\"{%- optional.carGln %}\" placeholder=\"Enter the Global Location Number (GLN)\"/> </div> </div> </div> </div> </div> <div class=\"q-section carrier-contact-info\" id=carrier-contact-info> <div class=q-marg-all-xl> <h2 class=q-section-title>Carrier Contact</h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Contact Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required contact-name\" name=carrier-contact-name disabled=disabled id=contact-name value=\"{%- optional.carContactName %}\" placeholder=\"Enter contact first and last name\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Email *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required email\" name=carrier-contact-email disabled=disabled id=email placeholder=\"Enter contact email address\" value=\"{%- optional.cadContactEmail %}\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select class=\"select2-select carrier-phone-code carrier-phone-code-edit q-input required\" disabled=disabled id=phone-code style=width:35% name=phone-code data-s2-full-width-list=true data-error-placement-append-closest=.col-md-6 data-s2-placeholder=\"Select Country Code\" value=\"{%- optional.carPhoneCountryCode %}\" data-s2-minimum-results-for-search=5> {%=phoneCodes%} </select> <input type=text class=\"q-input q-ig-flex-fill stretch carrier-phone-number contact-number phone-format phoneUS required\" data-error-placement-append-closest=.col-md-6 disabled=disabled id=phone-number name=phone-number placeholder=\"Enter phone number\" value=\"{%- optional.carContactPhone %}\"/> </div> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Country *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select carrier-by-scac-country required\" name=carrier-contact-country disabled=disabled id=countries style=width:100% data-error-placement-append-closest=.col-md-6 data-s2-placeholder=\"Select a country\" value=\"{%- optional.cadCountry %}\" data-s2-minimum-results-for-search=7> {%=countries%} </select> </div> </div> </div> <div class=\"q-marg-vert-lg carrier-by-scac-country-required\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label></label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-yellow q-alert-pad-all-sm q-text-left\"> <p> Country not supported for Address Validation </p> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input type=text class=\"q-input q-stretch required address\" disabled=disabled id=address1 value=\"{%- optional.cadAddress1 %}\" name=carrier-contact-address1 placeholder=\"Enter Address\" data-error-placement-append-closest=div /> </div> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=q-marg-top-md> <input type=text class=\"q-input q-stretch\" disabled=disabled id=address2 value=\"{%- optional.cadAddress2 %}\" name=carrier-contact-address2 placeholder=\"Enter Address line 2 (optional)\"/> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required city\" name=carrier-contact-city disabled=disabled id=city value=\"{%- optional.cadCity %}\" placeholder=\"Enter City\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label carrier-by-scac-state-required\">State/Province/Region *</label> </div> <div class=\"col-md-6 col-xs-12 carrier-by-scac-state-wrapper\"> <select class=\"select2-select carrier-by-scac-state required\" style=width:100% disabled=disabled id=state data-error-placement-append-closest=.col-md-6 data-s2-placeholder=\"Select a state, province or region\" name=carrier-contact-state value=\"{%- optional.cadState %}\" data-s2-minimum-results-for-search=7> </select> </div> <div class=\"carrier-by-scac-stateText-wrapper col-md-6 col-xs-12\" style=display:none> <input class=\"qw-input carrier-by-scac-stateText stretch required\" maxlength=40 disabled=disabled name=carrier-by-scac-stateText data-s2-placeholder=\"Select State/Province/Region\" type=text value=\"{%- optional.cadState %}\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label carrier-contact-postalcode-required\">Postal Code *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required carrier-contact-postalcode\" name=carrier-contact-postalcode disabled=disabled id=postal-code value=\"{%- optional.cadZipcode %}\" placeholder=\"Enter postal code\" data-error-placement-append-closest=div /> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1193 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section team-member-section-details\" id=\"team-member-details-{%- orgType %}\"> <div class=q-marg-all-xl> <h2 class=q-section-title> Team Members </h2> <div class=q-marg-vert-md id=\"access-to-team-members-{%- orgType %}\"> <span class=team-carrier-section> Grant log in access to team members within this organization. Once granted, members within this carrier organization will receive log in credentials and will be able to view, edit and manage the scheduled appointments their carrier organization has been assigned. </span> <span class=team-broker-section> Grant log in access to team members within this organization. Once granted, members within this transportation broker organization will receive log in credentials and will be able to view, create and edit scheduled appointments. </span> </div> <div class=q-marg-vert-md> <div class=row> <div class=col-xs-12> <a href=# class=\"base-btn purple-btn q-text-center q-block-at-md team-member-btn\">Add Team Member</a> </div> </div> </div> </div> </div>";

/***/ },
/* 1194 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section carrier-new-section-details\" id=carrier-new-section-div> <div class=\"q-section carrier-details-section\"> <div class=q-marg-all-xl> <h2 class=q-section-title>Carrier Details</h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Organization Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required organization-name\" name=new-carrier-section-org-name id=organization-new-name value=\"{%- optional.carName %}\" oninput=\"this.value=this.value.toUpperCase()\" placeholder=\"Enter the organization name\" data-error-placement-append-closest=div /> <label class=\"q-sim-error dup-orgName\" style=display:none> {%- dupPrgName %} </label> </div> </div> </div> <div class=q-marg-vert-md id=validate-scac-code> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>SCAC Code *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input class=\"q-input q-stretch required scac-code\" id=scac-new-code name=new-scac-code type=text value=\"{%- optional.carScac %}\" oninput=\"this.value=this.value.toUpperCase()\" placeholder=\"Enter the Standard Carrier Alpha Code (SCAC) code\" data-error-placement-append-closest=div maxlength=4 minlength=2 /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Carrier GLN</label> </div> <div class=\"col-md-6 col-xs-12\"> <input class=\"q-input q-stretch\" name=new-carrier-gln id=carrier-new-gln type=text value=\"{%- optional.carGln %}\" placeholder=\"Enter the Global Location Number (GLN)\"/> </div> </div> </div> </div> </div> <div class=\"q-section carrier-contact-info\" id=carrier-contact-info> <div class=q-marg-all-xl> <h2 class=q-section-title>Carrier Contact</h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Contact Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required contact-name\" name=new-carrier-contact-name id=contact-new-name value=\"{%- optional.carContactName %}\" placeholder=\"Enter contact first and last name\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Email *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required email\" name=new-carrier-contact-email id=email-new placeholder=\"Enter contact email address\" value=\"{%- optional.cadContactEmail %}\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select class=\"select2-select carrier-phone-code q-input required\" id=phone-code-new style=width:35% name=new-phone-code data-s2-full-width-list=true data-error-placement-append-closest=.col-md-6 data-s2-placeholder=\"Select Country Code\" value=\"{%- optional.carPhoneCountryCode %}\" data-s2-minimum-results-for-search=5> {%=phoneCodes%} </select> <input type=text class=\"q-input q-ig-flex-fill stretch new-phone-number contact-number new-phone-format phoneUS required\" data-error-placement-append-closest=.col-md-6 id=phone-number name=new-phone-number placeholder=\"Enter phone number\" value=\"{%- optional.carContactPhone %}\"/> </div> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Country *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select new-carrier-by-scac-country required\" name=new-carrier-contact-country id=new-countries style=width:100% data-error-placement-append-closest=.col-md-6 data-s2-placeholder=\"Select a country\" value=\"{%- optional.cadCountry %}\" data-s2-minimum-results-for-search=7> {%=countries%} </select> </div> </div> </div> <div class=\"q-marg-vert-md new-carrier-by-scac-country-not-supported\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label></label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-yellow q-alert-pad-all-sm q-text-left\"> <p> Country not supported for Address Validation </p> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input type=text class=\"q-input q-stretch required address\" id=new-address1 value=\"{%- optional.cadAddress1 %}\" name=new-carrier-contact-address1 placeholder=\"Enter Address\" data-error-placement-append-closest=div /> <label class=\"q-sim-error dup-address\" style=display:none> {%- dupAddress %} </label> </div> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=q-marg-top-md> <input type=text class=\"q-input q-stretch\" id=new-address2 value=\"{%- optional.cadAddress2 %}\" name=new-carrier-contact-address2 placeholder=\"Enter Address line 2 (optional)\"/> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required city\" name=new-carrier-contact-city id=new-city value=\"{%- optional.cadCity %}\" placeholder=\"Enter City\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label new-carrier-by-scac-state-required\">State/Province/Region *</label> </div> <div class=\"col-md-6 col-xs-12 new-carrier-by-scac-state-wrapper\"> <select class=\"select2-select new-carrier-by-scac-state required\" style=width:100% id=new-state data-error-placement-append-closest=.col-md-6 data-s2-placeholder=\"Select a state, province or region\" name=new-carrier-contact-state value=\"{%- optional.cadState %}\" data-s2-minimum-results-for-search=7> </select> </div> <div class=\"new-carrier-by-scac-stateText-wrapper col-md-6 col-xs-12\" style=display:none> <input class=\"qw-input new-carrier-by-scac-stateText stretch required\" maxlength=40 name=new-carrier-by-scac-stateText data-s2-placeholder=\"Select State/Province/Region\" type=text value=\"{%- optional.cadState %}\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label new-carrier-contact-postalcode-required\">Postal Code *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required new-carrier-contact-postalcode\" name=new-carrier-contact-postalcode id=new-postal-code value=\"{%- optional.cadZipcode %}\" placeholder=\"Enter postal code\" data-error-placement-append-closest=div /> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1195 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-lg> <div class=q-marg-vert-md> <div class=\"q-alert q-alert-red\"> Progress will be lost if continuing. </div> </div> <div class=q-marg-bottom-md> Once this new organization has been created it will appear as an option to select within this list. PLEASE NOTE: By continuing to create a new organization you will be redirected to a new page and will lose all progress made on this form. </div> </div>";

/***/ },
/* 1196 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Facility Type *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select q-input rms-facility-type required\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select the type of facility\" data-s2-minimum-results-for-search=10 id=\"rms-facility-type{%- optional.arrayIndex %}\" name=facilityType> <option value=\"\"></option> {%= rmsFacilityTypes %} </select> </div> </div> </div> <div class=\"clearfix q-block-quote-row q-pad-horz-at-md if-vendor-returned q-no-pad-right q-marg-top-xl-at-md vendorSelectAuthorization\"> <div class=q-marg-bottom-xl> <div class=q-marg-vert-md> <div class=\"row togglable-parent\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Return Authorization Required</label> </div> <div class=\"col-md-2 col-xs-12 q-marg-bottom-md-at-md\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input id=\"return-auth-req{%- optional.arrayIndex %}\" type=checkbox name=return-auth-req class=\"js-switchery quick-toggler ra-auth-switch\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.togglable-parent data-quick-toggler-target=.togglable-target /> </div> </div> <div class=\"col-md-2 co-xs-12 if-return-auth-req togglable-target\"> <label class=q-label for=standing-ra-number>Standing RA Number</label> </div> <div class=\"col-md-5 co-xs-12 if-return-auth-req togglable-target\"> <input type=text id=\"stndNumber{%- optional.arrayIndex %}\" name=stndNumber class=\"q-input q-stretch stndNumber\" placeholder=\"Standing RA (Optional)\"/> </div> </div> </div> </div> </div> <div class=q-marg-vert-lg> <div class=row> <div class=col-md-3> <label class=\"q-label q-boldest q-fs-sm\">Facility FedEx Account *</label> </div> <div class=col-md-6> <select class=\"select2-select q-input fedex-acct-num-location required\" name=rmsFedexAccounts data-s2-minimum-results-for-search=10 data-error-placement-append-closest=div style=width:100% id=\"rms-fedex-account{%- optional.arrayIndex %}\" data-s2-placeholder=\"Select a FedEx account for this facility\"> <option value=\"\"></option> {%= rmsFedexAccounts %} <select> </select></select></div> </div> </div> <div class=q-marg-vert-lg> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=location-fedex-acct class=q-label>CAS Account Number</label> </div> <div class=\"col-md-6 col-xs-12\"> <select name=location-fedex-acct class=\"select2-select q-input retailer-cas-acct\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select a CAS account for this facility\" data-s2-minimum-results-for-search=10 data-s2-allow-clear=true id=\"rms-cas-account{%- optional.arrayIndex %}\"> <option value=\"\"></option> {%= rmsCasAccounts %} </select> </div> </div> </div>";

/***/ },
/* 1197 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h3 class=\"q-title q-fw-normal\">Organization</h3> </div> <div class=q-marg-vert-xl> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Select Organization</label> </div> <div class=\"col-md-9 col-xs-12\"> <select name=location class=\"select2-select q-input required\" id=organizationDropdown style=width:100% data-error-placement-append-closest=div data-error-placement-append-closest=div data-s2-placeholder=\"Select Organization\" data-s2-minimum-results-for-search=5> <option disabled=disabled selected=selected>Select Organization From List</option> {%= optional.dropdownList %} </select> </div> </div> </div> </div>";

/***/ },
/* 1198 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-vert-md team-member-edit team-check-{%-arrayIndex%}\" id=\"team-member-edit-{%-arrayIndex%}\"> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=\"q-pad-all-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\"> <i class=\"fa fa-user q-icon-marg-right\" aria-hidden=true></i> {%- firstName %} {%- lastName %} </span> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Username: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%-userName %} </span> </div> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Title: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- title %} </span> </div> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Email: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- email %} </span> </div> </div> </div> <div class=q-marg-top-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Phone: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%-phoneCode%}{%-phone%} </span> </div> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"row q-marg-top-md-at-md\"> <div class=col-xs-12> <a href=# class=\"base-btn purple-btn v2-btn q-text-center q-block-at-md q-pull-right-til-md remove-team-member-btn disabled remove-check-{%-arrayIndex%}\" data-index-id=\"{%- arrayIndex %}\" id=\"remove-team-member-btn-{%-arrayIndex%}\">Remove</a> </div> </div> <div class=\"row q-marg-top-md\"> <div class=col-xs-12> <a href=# class=\"base-btn purple-btn q-text-center q-block-at-md q-pull-right-til-md edit-team-member-btn\" data-index-id=\"{%- arrayIndex %}\" id=edit-team-member-btn>Edit</a> </div> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1199 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section transportation-broker-section\"> <div class=q-marg-all-xl> <h2 class=q-section-title> Transportation Broker Details </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Organization Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input class=\"q-input q-stretch required broker-org-name\" type=text data-error-append-closest=div name=broker-org-name value=\"{%- orgName %}\" placeholder=\"Organization Name\"/> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Affiliated Carriers </h2> <div class=q-marg-vert-md> <span> Search for and select carriers that are frequently used by this transportation broker. If a carrier does not exist, you may create the carrier to add to this list. </span> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Affiliated Carriers</label> </div> <div class=\"col-md-6 col-xs-12\"> <select id=find-carriers-for-broker class=select2-select name=find-carriers-for-broker style=width:100% data-s2-minimum-results-for-search=Infinity data-s2-placeholder=\"Start typing carrier names\" data-error-placement-append-closest=.col-md-6 multiple=multiple> {%=affiliatedCarrrier%} </select> </div> <div class=\"col-md-3 col-xs-12\"> <div class=q-marg-top-md-at-md> <a href=# class=\"base-btn purple-btn v2-btn q-text-center q-block-at-md trans-broker-create-carrier-btn\">Create Carrier</a> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title>Transportation Broker Contact</h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Contact Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required\" name=broker-org-contact-name value=\"{%- cmrAddress.cadContactName %}\" placeholder=\"Enter contact first and last name\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Email *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required broker-org-email\" name=broker-org-email value=\"{%- cmrAddress.cadContactEmail %}\" placeholder=\"Enter contact email address\" pattern=[\\w\\.-]+@([\\w-]+\\.)+[\\w-]{2,4} /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select class=\"select2-select broker-phone-code q-input required\" style=width:35% name=phone-code data-s2-full-width-list=true data-error-placement-append-closest=.col-md-6 data-s2-placeholder=\"Phone Code\" data-s2-minimum-results-for-search=7 value=\"{%- cmrAddress.cadContactCountryPhoneCode %}\"> {%=phoneCodes%} </select> <input type=text class=\"q-input q-ig-flex-fill required broker-phone-number\" value=\"{%- cmrAddress.cadContactPhone %}\" name=phone-number placeholder=\"(___) ___-____\" maxlength=14 data-error-placement-append-closest=.col-md-6 /> </div> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Country *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select required broker-org-country\" style=width:100% data-error-placement-append-closest=.col-md-6 name=broker-org-country data-s2-placeholder=\"Select a country\" data-s2-minimum-results-for-search=7 value=\"{%- cmrAddress.cadCountry %}\"> {%=countries%} </select> </div> </div> <div class=\"q-marg-vert-lg country_not_supported\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label></label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-yellow q-alert-pad-all-sm q-text-left\"> <p> Country not supported for Address Validation </p> </div> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input type=text class=\"q-input q-stretch required\" name=broker-org-address1 value=\"{%- cmrAddress.cadAddress1 %}\" placeholder=\"Enter Address\"/> </div> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=q-marg-top-md> <input type=text class=\"q-input q-stretch\" name=broker-org-address2 value=\"{%- cmrAddress.cadAddress2 %}\" placeholder=\"Enter Address line 2 (optional)\"/> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required\" name=broker-org-city value=\"{%- cmrAddress.cadCity %}\" placeholder=\"Enter City\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label broker-org-state-required\">State/Province/Region *</label> </div> <div class=\"col-md-6 col-xs-12 broker-org-state-wrapper\"> <select class=\"select2-select required broker-org-state\" style=width:100% data-error-placement-append-closest=.col-md-6 name=broker-org-state data-s2-placeholder=\"Select a state, province or region\" data-s2-minimum-results-for-search=7 value=\"{%- cmrAddress.cadState %}\"> </select> </div> <div class=\"broker-org-stateText-wrapper col-md-6 col-xs-12\" style=display:none> <input class=\"q-input q-stretch broker-org-stateText\" id=broker-org-stateText maxlength=40 name=stateText placeholder=\"Select a state, province or region\" type=text value=\"{%- cmrAddress.cadState %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label broker-org-zipcode-required\">Postal Code *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required\" name=broker-org-zipcode value=\"{%- cmrAddress.cadZipcode %}\" placeholder=\"Enter postal code\"/> </div> </div> </div> </div> </div>";

/***/ },
/* 1200 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-vert-md scac-error-page\"> <div class=row> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=\"q-marg-bottom-md assigned-to-retailer\"> <div class=\"q-alert q-alert-red\"> The SCAC code as entered belongs to a carrier that is already used within your operations. Please try another. </div> </div> <div class=\"q-marg-bottom-md assigned-to-carrier\"> <div class=\"q-alert q-alert-yellow\"> The SCAC code as entered is already assigned to another carrier organization. Please review the carrier found and if this was made in error, please update the SCAC code above. </div> </div> <div class=\"q-marg-vert-md assigned-to-carrier-details\"> <div class=row> <div class=col-xs-12> <div class=\"q-pretty-container q-pct-lightest-grey\"> <div class=q-pct-header> <div class=q-pad-all-md> <span class=\"q-tag q-fs-md\">{%- optional.carName %}</span> </div> </div> <div class=q-pct-body> <div class=\"q-pad-vert-lg q-pad-horz-md\"> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> SCAC Code: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- optional.carScac %} </span> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Carrier GLN: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- optional.carGln %} </span> </div> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Contact Name: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- optional.carContactName %} </span> </div> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Email: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- optional.cadContactEmail %} </span> </div> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Phone: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- optional.carPhoneCountryCode %}{%- optional.carContactPhone %} </span> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Address: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- optional.cadAddress1 %} </span> <br/> <span> {%- optional.cadAddress2 %} </span> <br/> <span> {%- optional.cadCountry %} </span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> </div> </div> </div> </div> </div> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=col-xs-12> <div class=q-pull-right-til-md> <a href=# class=\"base-btn purple-btn q-block-at-md q-text-center val-use-found-carrier-btn\">Use Found Carrier</a> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1201 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Country *</label> </div> <div class=\"col-md-3 col-xs-12\"> <select class=\"select2-select q-input facility-country required\" id=\"facility-country{%- optional.arrayIndex %}\" name=facility-country style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Country\" data-s2-minimum-results-for-search=5 value=\"{%- optional.cadCountry %}\"> {%=countries%} </select> </div> </div> </div> <div class=\"q-marg-vert-md facility-country-not-supported\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label></label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-yellow q-alert-pad-all-sm q-text-left\"> <p> Country not supported for Address Validation </p> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input type=text id=\"facility-address1{%- optional.arrayIndex %}\" name=facility-address1 data-error-placement-append-closest=div class=\"q-input q-stretch required facility-address1\" placeholder=Address value=\"{%- optional.cadAddress1 %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-offset-3 col-md-9 col-xs-12\"> <input type=text id=\"facility-address2{%- optional.arrayIndex %}\" name=facility-address2 class=\"q-input q-stretch facility-address2\" placeholder=\"Address Line 2 (Optional)\" value=\"{%- optional.cadAddress2 %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=\"facility-city{%- optional.arrayIndex %}\" name=facility-city data-error-placement-append-closest=div class=\"q-input q-stretch required facility-city\" placeholder=City value=\"{%- optional.cadCity %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label facility-state-required\">State/Province/Region *</label> </div> <div class=\"col-md-4_5 col-xs-12 facility-state-wrapper\"> <select class=\"quick-toggler facility-state required\" style=width:100% id=\"facility-state{%- optional.arrayIndex %}\" name=facility-state data-error-placement-append-closest=div data-s2-placeholder=\"Select State/Province/Region\" data-s2-minimum-results-for-search=5 value=\"{%- optional.cadState %}\"> </select> </div> <div class=\"facility-stateText-wrapper col-md-6 col-xs-12\" style=display:none> <input class=\"qw-input facility-stateText stretch required\" maxlength=40 id=\"facility-stateText{%- optional.arrayIndex %}\" name=stateText data-s2-placeholder=\"Select State/Province/Region\" type=text data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label facility-zip-required\">Postal Code *</label> </div> <div class=\"col-md-3 col-xs-12\"> <input type=text id=\"facility-zip{%- optional.arrayIndex %}\" name=facility-zip data-error-placement-append-closest=div class=\"q-input q-stretch facility-zip required\" placeholder=\"Postal Code\" value=\"{%- optional.cadZipcode %}\"/> </div> </div> </div>";

/***/ },
/* 1202 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Contact Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=\"contact-name{%- optional.arrayIndex %}\" data-error-placement-append-closest=div name=contact-name class=\"q-input q-stretch contact-name required\" placeholder=\"Contact Name\" value=\"{%- optional.cadContactName %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone Number *</label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <select class=\"select2-select facility-phone-code facility-contact-phone-code q-input required\" style=width:100% id=\"phone-code{%- optional.arrayIndex %}\" name=phone-code data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=5> {%=phoneCodes%} </select> </div> <div class=\"col-md-3 col-xs-12\"> <input type=text class=\"q-input stretch facility-phone-contact-number contact-number required\" id=\"phone-number{%- optional.arrayIndex %}\" data-error-placement-append-closest=div value=\"{%- optional.cadContactPhone %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Email Address *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=\"email-id{%- optional.arrayIndex %}\" name=email-id data-error-placement-append-closest=div class=\"q-input q-stretch contact-email required email\" placeholder=\"Email Address\" value=\"{%- optional.cadContactEmail %}\"/> </div> </div> </div>";

/***/ },
/* 1203 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Facility Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=hidden id=\"cad-id{%- optional.arrayIndex %}\" class=cadId name=cad-id value=\"{%- optional.cadId %}\"/> <input type=hidden id=\"cad-status{%- optional.arrayIndex %}\" class=cadStatus name=fac-status value=\"{%- optional.cadActive %}\"/> <input type=text id=\"facility-name{%- optional.arrayIndex %}\" name=facility-name class=\"q-input q-stretch required facility-name\" placeholder=\"Facility Name\" data-error-placement-append-closest=div value=\"{%- optional.cadLocationName %}\"/> <label class=\"q-sim-error dup-facName\" style=display:none> {%- dupFacName %} </label> </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Facility ID </label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=\"facility-id{%- optional.arrayIndex %}\" name=facility-id class=\"q-input q-stretch name digits facility-id\" placeholder=\"Facility ID\" value=\"{%- optional.cadAddressId %}\"/> <label class=\"q-sim-error dup-facId\" style=display:none> {%- dupFacId %} </label> </div> </div> </div> {%= optional.rmsTypes %}";

/***/ },
/* 1204 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=\"q-title q-fw-normal\">Facility Type *</h2> </div> <div class=q-marg-vert-md> <div class=\"q-marg-all-xl errorMsgForFacilityTypeCheckbox\" style=display:none> <div class=\"q-alert q-marg-bottom-xl q-alert-red\"> At least one facility type should be selected. </div> </div> <div class=\"divider-group divider-group-title dg-no-pad-horz\"> <h4 class=\"q-title q-skinnier\"> Please select all of the functions of this facility. This information will be used throughout the platform. </h4> </div> {%=facilityTypes%} </div> </div> </div>";

/***/ },
/* 1205 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section {%- optional.masterFormClass %}\"> {%= masterForm %} <div class=\"q-marg-horz-xl q-marg-vert-lg\"> <h2 class=\"q-title q-fw-normal\"> <div class=row> <div class=\"col-xs-8 q-marg-vert-xxxs facility-top-name\"> {%- facilityName %} </div> {%= optional.actionButtons %} {%= sectionIsExpandable %} </div> </h2> </div> <div {% if (sectionIsExpandable) { %} class=custom-expander-target {% } %}> <div class=q-section> <div class=\"q-marg-bottom-xl q-marg-horz-xl\"> {%= facilityDetails %} </div> </div> {%= optional.hcmbFacilityTypes %} <div class=\"q-section address-section\"> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=\"q-title q-fw-normal\">Facility Address</h2> </div> {%= facilityAddress %} </div> </div> <div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=\"q-title q-fw-normal\">Facility Contact</h2> </div> {%= facilityContact %} </div> </div> {%= optional.rmsFacilityTypes %} </div> </div>";

/***/ },
/* 1206 */
/***/ function(module, exports) {

	module.exports = "<div id=\"inboundClassification{%- optional.arrayIndex %}\" class=\"q-section inboundClassification\"> <div class=q-marg-all-xl> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h3 class=\"q-title q-fw-normal\">Inbound Classifications</h3> </div> <div class=q-marg-vert-xl> <div class=\"q-alert q-alert-grey\">Please specify the inbound classifications for this location. The classifications for this facility will be used for returns address steering.</div> </div> <div class=q-marg-vert-md> {%= inboundClassificationTypes %} </div> </div> </div> </div>";

/***/ },
/* 1207 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey affiliated-carrier-toggler-parent q-pad-top-md\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=\"q-pad-vert q-marg-left-md-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\"> {%- carrierName %} </span> </div> </div> <div class=\"col-md-3 col-xs-12 q-fs-lg q-text-center-at-md\"> <div class=\"q-marg-vert-xxs q-marg-horz q-pull-right-til-md q-marg-vert-md-at-md\"> <a class=\"base-btn purple-btn v2-btn q-text-center q-stretch-at-md carrier-org-details-btn\" data-index-id=\"{%- carrierOrgId %}\"> View Details </a> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.affiliated-carrier-toggler-target data-q-expander-closest=.affiliated-carrier-toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"affiliated-carrier-toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Status:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- carrierStatus %}</span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>SCAC Code:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- carrierScac %}</span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Carrier GLN:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- carrierGln %}</span> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"row q-marg-top-md-at-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Contact Name:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- carrierContactName %}</span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Email:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- carrierEmail %}</span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Phone:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- carrierPhone %}</span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Address:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- carrierAddress1 %}</span> <br/> <span>{%- carrierAddress2 %}</span> <br/> <span>{%- carrierCity %}</span>, <span>{%- carrierState %} </span> <span>{%- carrierZipcode %} </span><br/> <span>{%- carrierCountry %}</span> <br/> <br/> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1208 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> History </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.org-history data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"org-history q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Created On:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>MM/DD/YYYY 2:00PM ET</span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Created By:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>Leland Palmer</span> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"row q-marg-top-md-at-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Modified On:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>MM/DD/YYYY 2:00PM ET</span> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Modified By:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>Leland Palmer</span> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1209 */
/***/ function(module, exports) {

	module.exports = "<div class=\"org-team-member q-expandable-default\"> <div class=q-expandable-body> <div class=q-marg-vert-md> <div class=\"q-alert q-alert-grey\"> No team members have been created for this organization. </div> </div> </div> </div>";

/***/ },
/* 1210 */
/***/ function(module, exports) {

	module.exports = "<div class=q-expandable-body> <div class=q-marg-vert-md> <div class=\"q-alert q-alert-grey\"> No affiliated carriers have been set for this organization. </div> </div> <div class=drawer-area-for-affiliated-carrier></div> <div class=paging-area-for-affiliated-carrier></div> </div>";

/***/ },
/* 1211 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=\"q-flex-row qfr-vert-center-align\"> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest> Product SKU: </div> </div> <div class=\"col-md-3 col-xs-12\"> {%- lineitem %} </div> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest> Packed Quantity: </div> </div> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-pill q-pill-spacer q-pill-detail\"> {%- lineitem2 %} </span> </div> </div> </div>";

/***/ },
/* 1212 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey pallet-child-1-toggler-parent q-marg-vert-xl\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-pad-vert-md q-marg-left-md-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\">LPN {%- lpnsName %}</span> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.pallet-child-1-toggler-target data-q-expander-closest=.pallet-child-1-toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"pallet-child-1-toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=q-pad-all-lg> {%= product %} </div> </div> </div> </div>";

/***/ },
/* 1213 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default-base q-max-page-width-md q-page-center-margin\"> <div class=\"q-card q-card-white\"> <div class=\"q-main-header clearfix\"> <div class=q-inline-block-til-md> <div class=\"q-border-bottom-at-md q-main-header-title-container q-pad-right-sm-til-md\"> <h3 class=\"q-title q-boldest\"> Amazon FBA Package Label </h3> <p> </p> </div> </div> <div class=q-pull-right-til-md> <div class=\"q-main-header-actions-container q-text-right-til-md q-pad-left-sm-til-md\"> <a id=cancelProcess href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn v2-btn\"> Cancel Process </a> </div> </div> </div> <form name=viewQuoteForm id=master-form> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Pallet Information </h2> {%= pallets %} </div> </div> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Pickup Scheduling </h2> <div class=\"q-marg-vert-xl q-pad-horz-md\"> <div class=\"row q-marg-vert-lg\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Pickup Date *</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"wrapper-helper q-pad-left-til-md q-marg-top-md-at-md\"> <div class=\"q-input-with-inner-text q-inner-text-right func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input id=pickupDate name=pickupDate class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input pickup-date required\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"   /   /   \"/> </div> </div> </div> </div> <div class=\"row q-marg-vert-lg\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Pickup Time *</label> </div> <div class=\"col-md-8 col-xs-12\"> <div class=\"q-grid q-pad-left-til-md q-marg-top-md-at-md\"> <div class=\"q-input-group q-input-group-connected no-pad-bottom q-row q-input-group-connected-break-at-sm wrapper-helper\"> <div class=\"q-input-group-connected-inner q-input-first q-static-col-3\"> <div class=\"pickup-time-start q-time-picker-default\"> <div class=time-picker-hours-select-outer> <select id=fromhours name=fromhours class=time-picker-hours-select> </select> </div> <span class=time-picker-seperater>:</span> <div class=time-picker-minutes-select-outer> <select id=fromminutes name=fromminutes class=time-picker-minutes-select> </select> </div> <div class=time-picker-period-select-outer> <select id=fromseconds name=fromseconds class=time-picker-period-select> </select> </div> </div> </div> <div class=\"q-input-group-connected-inner q-static-col\"> <div class=\"q-sim-input q-text-center-til-md q-no-border\"> to </div> </div> <div class=\"q-input-group-connected-inner q-input-last q-static-col-3\"> <div class=\"pickup-time-end q-time-picker-default\"> <div class=time-picker-hours-select-outer> <select id=tohours name=tohours class=time-picker-hours-select> </select> </div> <span class=time-picker-seperater>:</span> <div class=time-picker-minutes-select-outer> <select id=tominutes name=tominutes class=time-picker-minutes-select> </select> </div> <div class=time-picker-period-select-outer> <select id=toseconds name=toseconds class=time-picker-period-select> </select> </div> </div> </div> </div> </div> <div class=\"pickup-time-range-error-message q-pad-left-til-md q-sim-error\" data-error-placement-append-closest=.wrapper-helper> The pickup time range is invalid. </div> </div> </div> </div> </div> </div> </form> <div class=q-section> <div class=q-marg-all-xl> <a id=viewQuote href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn middle-btn base-btn purple-btn\"> View Quote </a> <a href=# id=loading class=\"q-block-at-md q-text-center-at-md q-main-header-btn middle-btn base-btn purple-btn\"> <span class=\"fa fa-spinner fa-pulse q-marg-right-xxxs\"></span> Loading </a> </div> </div> <div id=quoteResponse class=\"q-marg-vert-xl q-pad-all-lg\"> </div> <div class=q-section> <div class=\"q-pad-horz-xl q-marg-vert-md\"> <div class=row> <div class=col-xs-12> <div class=q-text-right> <a id=cancelBtn class=\"base-btn v2-btn purple-btn q-marg-right-xs-til-md\" href=#> Cancel </a> <a class=\"base-btn purple-btn\" href=# id=submitQuote> Submit </a> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1214 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey pallet-toggler-parent q-marg-top-xl\" id=panel> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-2 col-xs-12\"> <div class=\"q-pad-vert-md q-marg-left-xl-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-xl\">Pallet:</span> </div> </div> <div class=\"col-md-5 col-xs-12\"> <div class=q-pad-vert-md q-marg-left-md-til-md q-pad-horz-at-md q-text-center-at-md> <span class=q-tag q-fs-xl> {%- palletId %} </span> </div> </div> <div class=\"col-md-5 col-xs-12\"> <div class=\"q-text-right-til-md q-marg-right-md-til-md q-marg-horz-xl-at-md parent-div-panel\"> <a id=copyBtn href=# class=\"q-marg-vert-sm q-block-at-md q-text-center-at-md base-btn purple-btn\"> Apply dimensions and weight to all </a> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.pallet-toggler-target data-q-expander-closest=.pallet-toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"pallet-toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=q-marg-all-xl> {%= LPNS %} </div> </div> </div> <div id=copy class=\"q-pct-footer q-pct-footer-bc-white\"> <div class=q-pad-all-xl> <div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Dimensions *</label> </div> <div class=\"col-md-3 col-xs-12 error-msg-wrapper\"> <div class=q-marg-top-md-at-md> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input id=\"length_{%-palletId %}\" name=\"length_{%-palletId %}\" type=number class=\"q-input q-stretch required length\" data-error-placement-append-closest=.error-msg-wrapper placeholder=\"Length (Inches)\"/> <span class=q-ig-units>in.</span> </div> </div> </div> </div> <div class=\"col-md-3 col-xs-12 error-msg-wrapper\"> <div class=q-marg-top-md-at-md> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input id=\"width_{%-palletId %}\" name=\"width_{%-palletId %}\" type=number class=\"q-input q-stretch required width\" data-error-placement-append-closest=.error-msg-wrapper placeholder=\"Width (Inches)\"/> <span class=q-ig-units>in.</span> </div> </div> </div> </div> <div class=\"col-md-3 col-xs-12 error-msg-wrapper\"> <div class=q-marg-top-md-at-md> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input id=\"height_{%-palletId %}\" name=\"height_{%-palletId %}\" type=number class=\"q-input q-stretch required height\" data-error-placement-append-closest=.error-msg-wrapper placeholder=\"Hength (Inches)\"/> <span class=q-ig-units>in.</span> </div> </div> </div> </div> </div> </div> <div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Weight *</label> </div> <div class=\"col-md-3 col-xs-12 error-msg-wrapper\"> <div class=q-marg-top-md-at-md> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input id=\"weight_{%-palletId %}\" name=\"weight_{%-palletId %}\" type=number class=\"q-input q-stretch required weight\" data-error-placement-append-closest=.error-msg-wrapper placeholder=\"Weight (Pounds)\"/> <span class=q-ig-units>lbs.</span> </div> </div> </div> </div> </div> </div> <div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Stackable</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=q-marg-top-md-at-md> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input name=\"stackable_{%-palletId %}\" id=\"stackable_{%-palletId %}\" class=stackable type=checkbox value=stackable /> <span class=cb-label-inner></span> </label> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1215 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-alert q-alert-grey q-no-pad q-marg-vert-xl\"> <p class=q-marg-all-sm> Estimated shipping cost cannot be provided. Please submit shipping information and contact your CSS to get your shipping estimate and BOL number. </p> </div>";

/***/ },
/* 1216 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row q-marg-top-md asn-section\" id=\"asn-section-{%- asnData.asnShipmentId %}\"> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=\"q-pad-all-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\"> ASN ID: </span> <span class=\"q-tag q-fs-md\"> {%- asnData.asnShipmentId %} </span> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Merchant: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span> {%- retailerData.rtlName %} </span> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Status: </span> </div> <div class=\"col-md-6 col-xs-12 status\"> <span> {%- asnData.asnStatus %} </span> </div> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Carrier: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span class=asn-carrier> {%- asnData.asnCarrierName %} </span> </div> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Pallets: </span> </div> <div class=\"col-md-6 col-xs-12 asn-pallets\"> <span> {%- palletCount %} </span> </div> </div> </div> <div class=q-marg-vert-sm> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Origin: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> {%- cmrAddressData.cadLocationName %} </span> <br/> <span> {%= cmrAddressData.cadAddress1 %} </span> <br/> <span> {%- cmrAddressData.cadCity %}, {%- cmrAddressData.cadState %} {%- cmrAddressData.cadZipcode%} {%- cmrAddressData.cadCountry %} </span> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Destination: </span> </div> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> {%- facilityData.facContactName %} </span> <br/> <span> {%- facilityData.facAddressLine1 %}, {%- facilityData.facAddressLine2 %} </span> <br/> <span> {%- facilityData.facCity %}, {%- facilityData.facState %} {%- facilityData.facZipcode %} {%- facilityData.facCountry %} </span> </div> </div> </div> <div class=\"col-md-3 col-xs-12 asn-details\"> <a href=# id=remove-asn-btn class=\"base-btn purple-btn q-text-center q-block-at-md q-pull-right-til-md q-marg-top-md-at-md\">Remove</a> <a href=# id=view-asn-btn class=\"base-btn purple-btn v2-btn q-text-center q-block-at-md q-marg-top-md q-pull-right-til-md {%- hidden %}\">View Details</a> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1217 */
187,
/* 1218 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default q-default-base q-max-page-width-md\"> <div class=\"q-card q-card-white\"> <div class=\"q-marg-top-xl q-marg-horz-xl\"> <div class=\"q-alert q-alert-grey q-marg-vert-md\"> Please review the errors below, update the CSV file and re-upload the CSV on the packing screen. </div> <div class=q-marg-top-md> <div class=q-overflow-x-auto> <div class=\"q-min-width-sm q-overflow-hidden\"> <table class=\"csv-error-list table q-table q-table-vert-middle q-table-rows-min-height q-table-pad-tds-md q-no-marg q-min-width-xs\" style=width:100%> <thead> <tr> <th> Line </th> <th> Column </th> <th> Value Entered </th> <th> Error Details </th> </tr> </thead> <tbody> </tbody> </table> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1219 */
/***/ function(module, exports) {

	module.exports = "<form class=case-or-pallet-modal-form> <div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label for=packing-type-name>{%= packingTypeUpperCase %} Type Name</label> </div> <div class=\"col-md-5 col-xs-12\"> <input id=packing-type-name class=\"q-input q-stretch packing-type-name\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label for=packing-number>Number of {%= packingTypeUpperCase %}s</label> </div> <div class=\"col-md-3 col-xs-12\"> <input type=number min=1 id=packing-number pattern=[0-9]* class=\"q-input q-stretch number-of-cases-or-pallets required\" value=1 /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label for=packing-lpn>Custom {%= packingTypeUpperCase %} ID (LPN)</label> </div> <div class=\"col-md-2 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-on q-switchery-af-text-off\"> <input id=packing-lpn name=packing-lpn type=checkbox class=\"js-switchery quick-toggler custom-case-or-pallet-ids-flag\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.togglable-parent data-quick-toggler-target=.togglable-target /> </div> </div> <div class=\"col-md-7 col-xs-12\"> <span class=\"q-fs-xs q-inline-block q-marg-top-xxxs\">Custom {%= packingTypeUpperCase %} IDs will appear on package labels. If not selected, a {%= packingTypeUpperCase %} ID will be auto-generated. Please create separate {%= packingType %}s for items that require a different expiration date and/or lot number.</span> </div> </div> </div> <div class=\"q-marg-vert-md if-lpn-on custom-case-or-pallet-ids-list-section\" style=display:none> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=\"q-label q-fs-xs q-alert q-alert-grey\">Custom Case IDs should be unique and contain 16-20 characters. For best results use industry standard GS1 SSCC-18 Barcodes. <a href=https://www.gs1-128.info/sscc-18/ target=_blank>Learn more</a></div> </div> </div> </div> <div class=row> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <textarea class=\"q-input q-stretch custom-case-or-pallet-ids-list\" placeholder=\"Add {%= packingType %} IDs and separate with commas\"></textarea> </div> </div> </div> <div class=\"q-marg-vert-xl amt-must-match-like-msg warning-case-ids-size-section\" style=display:none> <div class=\"q-alert q-alert-yellow\"> The number of unique {%= packingTypeUpperCase %} IDs must match the number of {%= packingType %}s. </div> </div> <div class=\"q-marg-vert-xl lpn-dulicate-msg warning-lpn-dulicate-section\" style=display:none> <div class=\"q-alert q-alert-yellow\"> The Custom Case IDs are not unique. Please enter a new Custom Case ID. </div> </div> <div class=\"q-marg-vert-xl lpn-length-msg warning-lpn-length-section\" style=display:none> <div class=\"q-alert q-alert-yellow\"> Custom Case IDs should be 16-20 characters long. </div> </div> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=q-section-title> {%= packingTypeUpperCase %} Contents </h2> </div> <div class=\"q-marg-top-xl q-marg-bottom-md\"> <div class=\"wrapper-helper q-typeahead-wrapper\"> <select name=selectSku id=product-item-lookup class=quick-toggler style=width:100% data-s2-placeholder=\"Type product name (SKU)\" data-s2-minimum-results-for-search=Infinity data-error-placement-append-closest=div> <option value=\"\"></option> </select> </div> </div> <div class=\"q-marg-top-xl q-marg-bottom-md before-user-adds-product\"> <div class=\"q-alert q-alert-grey\"> Select the product(s) you wish to add to this {%= packingType %}(s) above. </div> </div> <div class=after-user-adds-product> <div class=q-overflow-x-auto> <div class=\"q-overflow-x-hidden asn-modal-divider-min-width\"> <div class=\"divider-group divider-group-title\"> <div class=row> <div class=col-xs-3> <span class=q-tag>Product Name</span> </div> <div class=col-xs-5> <span class=q-tag>Description</span> </div> <div class=col-xs-2> <span class=q-tag>Units Per {%= packingTypeUpperCase %}</span> </div> <div class=\"col-xs-2 q-text-center\"> <span class=q-tag>Remove</span> </div> </div> </div> <div class=packing-details-info-modal-prod-list> </div> </div> </div> </div> </div> </div> </form>";

/***/ },
/* 1220 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group product-row-number\" data-asn-detail-row-number={%= asnDetailRowNumber %}> <div class=row> <div class=col-xs-3> <div class=\"q-marg-vert-xxs sku-name q-break-word\"> {%= skuName %} </div> </div> <div class=col-xs-5> <div class=\"q-marg-vert-xxs sku-desc q-break-word\"> {%= skuDesc %} </div> </div> <div class=col-xs-2> <input class=\"q-input units-per-case required\" name=unitsPerCase type=number pattern=[0-9]* min=1 value=\"{%= unitsPerCase %}\"/> </div> <div class=\"col-xs-2 q-text-center\"> <a class=\"q-close-btn close-btn\"><i class=\"fa fa-times\"></i></a> </div> </div> </div>";

/***/ },
/* 1221 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-vert-xxs q-break-word\"> <span class=q-tag>{%= skuName %}</span> </div> </div> <div class=\"col-md-3 col-xs-12 q-marg-vert-xxs q-break-word\"> {%= skuDesc %} </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-alert q-alert-grey q-alert-pad-all-sm q-inline-block q-marg-vert-xxs-at-md\"> {%= unitsPerCase %} units per {%= packingType %} </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-alert q-alert-grey q-alert-pad-all-sm q-inline-block q-marg-vert-xxs-at-md\"> {%= totalUnits %} units total </div> </div> </div> {% if (hasExpDateField) { %} <div class=q-marg-vert-xs> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-marg-left-md-til-md\">Exp Date*</label> </div> <div class=\"col-md-3 col-xs-12 wrapper-helper\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-static-col-1_5 q-input-first func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input name=\"expirationDate_{%=uuid %}\" class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input required packing-exp-date\" type=text value=\"{%= packingExpDate %}\" data-asn-detail-row-id=\"{%= asnDetailRowId %}\" data-error-placement-append-closest=.wrapper-helper placeholder=\"   /   /   \"/> </div> </div> <div class=\"col-md-6 col-xs-12 q-marg-top-xxs-til-md\"> <span class=q-fs-xs>If this item has more than one expiration date, please create a separate {%= packingType %} for each.</span> </div> </div> </div> {% } %} {% if (hasLotNumberField) { %} <div class=q-marg-vert-xs> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-marg-left-md-til-md\">Lot Number*</label> </div> <div class=\"col-md-3 col-xs-12\"> <input type=text name=\"lotNumber_{%=uuid %}\" class=\"q-input q-stretch lot-number required\" pattern=(^[a-zA-Z0-9]*$) maxlength=20 value=\"{%= lotNumber %}\" data-asn-detail-row-id=\"{%= asnDetailRowId %}\" placeholder=\"Enter Lot Number\"/> </div> <div class=\"col-md-6 col-xs-12 q-marg-top-xxs-til-md\"> <span class=q-fs-xs>If this item has more than one lot number, please create a separate {%= packingType %} for each.</span> </div> </div> </div> {% } %} </div>";

/***/ },
/* 1222 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-xl> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-md\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-pad-vert q-marg-left-xl-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\">{%= packingTypeName %}</span> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-marg-horz-lg q-marg-vert-md\"> <div class=q-text-center-at-md> <span class=q-pad-right-sm-til-md> Number of {%= packingTypeUpperCase %}s: </span> <span class=q-tag> {%=numberOfCasesOrPallets %} </span> </div> </div> </div> <div class=\"col-md-5 q-fs-lg q-text-center-at-md\"> <div class=\"q-marg-vert-xxs q-marg-horz q-pull-right-til-md q-marg-bottom-md-at-md\"> <a href=javascript:; class=\"base-btn purple-btn q-text-center q-stretch-at-md q-marg-bottom-sm-at-md remove-one-btn\" data-case-or-pallet-line-number=\"{%= caseOrPalletLineNumber %}\"> Remove </a> <a href=javascript:; class=\"base-btn purple-btn q-marg-left-xxs-til-md q-text-center q-stretch-at-md edit-one-btn\" data-case-or-pallet-line-number=\"{%= caseOrPalletLineNumber %}\"> Edit {%= packingTypeUpperCase %} </a> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> {% if (hasCustomIds) { %} <div class=q-pct-body> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=q-tag>Custom {%= packingTypeUpperCase %} ID (LPN):</span> </div> <div class=\"col-md-9 col-xs-12\"> <span class=q-break-word>{%= customCaseOrPalletIds %}</span> </div> </div> </div> </div> </div> {% } else { %} <div class=q-pct-body> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=q-tag>Custom {%= packingTypeUpperCase %} ID (LPN):</span> </div> <div class=\"col-md-9 col-xs-12\"> </div> </div> </div> </div> </div> {% } %} </div> <div class=\"q-pct-footer q-pct-footer-bc-white\"> <div class=q-pad-horz-md> <div class=q-pad-vert-lg> {%= packingProductsList %} </div> {% if (hasMultipleProducts) { %} <div class=q-pad-bottom-lg> <div class=\"q-alert q-alert-yellow\"> Multi SKU {%= packingType %}s will incur additional fees. </div> </div> {% } %} </div> </div> </div> </div>";

/***/ },
/* 1223 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <form class=lpn-csv-upload-form> <div class=q-marg-vert-xl> Please make sure you're packing details match the example in the packing CSV file. Select the file and then upload before applying. </div> <div class=q-marg-vert-xl> <div class=\"q-tight-well q-tw-lightest-grey\"> <div class=q-pad-all-xl> <div class=\"upload-outer csv-wrapper-helper\"> <div class=\"file-uploader qfu-default-styles\"> <input type=file id=csvFile required name=csvFile class=qfu-file-input data-error-placement-append-closest=.csv-wrapper-helper /> <input type=text class=\"qfu-file-text-input info-upload-input\" name=info-file id=info-file placeholder=\"Upload File\" disabled=disabled /> <a href=# class=qfu-select-file-btn>Select File</a> <a href=# class=qfu-remove-file-btn>Remove File</a> </div> </div> <div class=\"q-marg-vert-xs q-max-width-md\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=\"q-tag q-marg-right-md\"> Max File Size: </span> 200 MB </div> <div class=\"col-md-6 col-xs-12\"> <span class=\"q-tag q-marg-right-md\"> File Format: </span> CSV </div> </div> </div> </div> </div> </div> <div class=\"q-marg-vert-xl q-text-center\"> <a class=\"base-btn purple-btn middle-btn upload-file-btn\" href=#>Upload File</a> <a href=# class=\"base-btn purple-btn middle-btn loading-btn\" style=display:none> <i class=\"fa fa-spinner fa-pulse q-icon-marg-right\"></i> Loading </a> </div> <div class=\"q-marg-vert-xl upload-file-ext-error\" style=display:none> <div class=\"q-alert q-alert-red\"> Please upload a file with valid file extension (.csv) </div> </div> <div class=\"q-marg-vert-xl upload-success\" style=display:none> <div class=\"q-alert q-alert-green\"> File has succesfully uploaded. If a second file is uploaded, this one will be deleted. Please select 'Apply' to use this file. </div> </div> <div class=\"q-marg-vert-xl upload-overwrite-data\" style=display:none> <div class=\"q-alert q-alert-yellow\"> If a second file is uploaded, the original packing information will be lost. </div> </div> <div class=\"q-marg-vert-xl upload-incorrect-template\" style=display:none> <div class=\"q-alert q-alert-red\"> The CSV file uploaded is not the correct template. Please download the template, update the file and re-upload. </div> </div> <div class=\"q-marg-vert-xl upload-file-errors\" style=display:none> <div class=\"q-alert q-alert-red\"> The upload contains errors. Please review errors, update the CSV and re-upload. </div> </div> <div class=\"q-marg-vert-xl q-text-center upload-file-errors-btn\" style=display:none> <a class=\"base-btn purple-btn middle-btn\" href=#>View Error Details</a> </div> </form> </div>";

/***/ },
/* 1224 */
/***/ function(module, exports) {

	module.exports = "<div class=asn-detail-rows-review-view-outer> <div class=\"q-marg-vert-md xs-pad-bottom q-pad-horz\"> <h4 class=\"q-title q-skinnier case-pallet-title\"> Shipping Quote </h4> </div> <div class=\"shipping-asn-details-rows-children-review-entry-point q-section-border-top q-marg-vert-md\"> target </div> </div>";

/***/ },
/* 1225 */
/***/ function(module, exports) {

	module.exports = "<div class=asn-detail-rows-review-view-outer> <div class=\"q-marg-vert-md xs-pad-bottom q-pad-horz\"> <h4 class=\"q-title q-skinnier case-pallet-title\"> Shipping Quote </h4> </div> <div class=\"asn-shipping-pallet-rows-children-review-entry-point q-section-border-top q-marg-vert-md\"> target </div> </div>";

/***/ },
/* 1226 */
/***/ function(module, exports) {

	module.exports = "<div class=pickup-scheduling-review-view-outer> <div class=q-marg-vert-md> <div class=\"divider-group divider-group-title\"> <h4 class=\"q-title q-skinnier\"> Pickup Scheduling </h4> </div> <div class=\"divider-group dg-lg\"> <div class=row> <div class=\"col-md-6 col-xs-12 q-marg-bottom-md-at-md\"> <div class=row> <div class=\"col-md-6 col-xs-12 q-col-spacer\"> Pickup Date: </div> <div class=\"col-md-6 col-xs-12 q-col-spacer\"> <span class=\"q-boldest pickup-date-val\">Monday, August 22</span> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12 q-col-spacer\"> Pickup Time: </div> <div class=\"col-md-6 col-xs-12 q-col-spacer\"> <span class=\"q-boldest pickup-time-val\">9:00 AM – 5:00 PM</span> </div> </div> </div> </div> </div> <div class=\"divider-group dg-md\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-top-xxs-til-md q-col-spacer\"> Inside Pickup: </div> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> <span class=\"q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg inside-pickup-val\">Yes</span> </div> <div class=\"col-md-6 col-xs-12 q-marg-top-xxs-til-md q-col-spacer inside-pickup-message\"> Handling Frieight at positions not immediately adjacent to vehicle </div> </div> </div> <div class=\"divider-group dg-md\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-top-xxs-til-md q-col-spacer\"> Lift Gate at Pickup: </div> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> <span class=\"q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg lift-gate-pickup-val\">Yes</span> </div> <div class=\"col-md-6 col-xs-12 q-marg-top-xxs-til-md q-col-spacer lift-gate-pickup-message\"> Pick-up using liftgate equipment </div> </div> </div> <div class=\"divider-group dg-md\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-top-xxs-til-md q-col-spacer\"> Limited Access: </div> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> <span class=\"q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg limited-access-val\">Yes</span> </div> <div class=\"col-md-6 col-xs-12 q-marg-top-xxs-til-md q-col-spacer limited-acess-message\"> To include construction sites, schools, churches, military bases </div> </div> </div> </div> </div>";

/***/ },
/* 1227 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-marg-top-xl\"> <div class=q-pct-header> <div class=\"q-pct-header-group-main q-marg-left-xl-til-md q-pad-horz-at-md q-pad-vert\"> <div class=row> <div class=col-md-6> <div class=row> <div class=\"col-lg-6 col-xs-12\"> <div class=\"q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\">Pallet {%- caseOrPalletLineNumber %}</span> </div> </div> <div class=\"col-lg-6 col-xs-12\"> <div class=q-marg-vert-md-at-md> <div class=q-text-center-at-md> {% if(stackable) {%} <span class=q-pad-right-sm-til-md>Stackable</span> {% } %} </div> </div> </div> </div> </div> <div class=col-md-6> <div class=row> <div class=\"col-lg-6 col-xs-12 q-text-center-at-md\"> <span class=\"q-pad-right-sm-til-md q-tag\">Dimensions:</span> <span>{%- length %}\" x {%- width %}\" x {%- height %}\"</span> </div> <div class=\"col-lg-6 col-xs-12 q-text-center-at-md\"> <span class=\"q-pad-right-sm-til-md q-tag\">Weight:</span> <span>{%- weight %} lbs.</span> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1228 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-marg-top-xl\"> <div class=q-pct-header> <div class=\"q-pct-header-group-main q-marg-left-xl-til-md q-pad-horz-at-md q-pad-vert\"> <div class=row> <div class=col-md-6> <div class=row> <div class=\"col-lg-6 col-xs-12\"> <div class=\"q-pct-header-group-title q-text-center-at-md q-pct-description\"> <span class=\"q-tag q-fs-md\">{%- packingTypeName %}</span> </div> </div> <div class=\"col-lg-6 col-xs-12\"> <div class=q-marg-vert-md-at-md> <div class=q-text-center-at-md> <span class=q-pad-right-sm-til-md>Number of {%- packingTypeUpperCase %}s:</span> <span class=q-tag>{%- numberOfCasesOrPallets %}</span> </div> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-pad-right-sm-til-md>Declared Value:</span> <span class=q-tag>${%- declaredValue %}</span> </div> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=q-section> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=q-tag>Custom {%- packingTypeUpperCase %} ID (LPN):</span> </div> {% if (hasCustomIds) { %} <div class=\"col-md-9 col-xs-12\"> <span class=q-break-word>{%- customCaseOrPalletIds %}</span> </div> {% } else {%} <div class=\"col-md-9 col-xs-12\"> </div> {% } %} </div> </div> {% if (isFedex && !isPalletShipping) { %} <div class=divider-group> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Dimensions:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- length %}\" x {%- width %}\" x {%- height %}\"</span> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Weight:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- weight %} lbs.</span> </div> </div> </div> </div> </div> {% } %} </div> </div> <div class=q-section> <div class=\"q-pad-horz-md q-pad-vert-lg\"> {%= revPackingProductsList %} </div> </div> </div> </div> </div>";

/***/ },
/* 1229 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-vert-xxs\"> <span class=q-tag>{%= skuName %}</span> </div> <div class=\"col-md-3 col-xs-12 q-marg-vert-xxs\"> {%= skuDesc %} </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-alert q-alert-grey q-alert-pad-all-sm q-inline-block q-marg-vert-xxs-at-md\"> {%= unitsPerCase %} units per {%= packingType %} </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-alert q-alert-grey q-alert-pad-all-sm q-inline-block q-marg-vert-xxs-at-md\"> {%= totalUnits %} units total </div> </div> </div> {% if (hasExpDateField) { %} <div class=q-marg-vert-xs> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-marg-left-md-til-md\">Exp Date:</span> </div> <div class=\"col-md-3 col-xs-12\"> {%= packingExpDate %} </div> </div> </div> {% } %} {% if (hasLotNumberField) { %} <div class=q-marg-vert-xs> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-marg-left-md-til-md\">Lot Number:</span> </div> <div class=\"col-md-3 col-xs-12\"> {%= lotNumber %} </div> </div> </div> {% } %} </div>";

/***/ },
/* 1230 */
/***/ function(module, exports) {

	module.exports = "<div class=shipping-quote-review-view-outer> <div class=q-marg-top-xl> <div class=\"divider-group divider-group-title\"> <h4 class=\"q-title q-skinnier\"> Shipping Quote </h4> </div> <div class=\"divider-group dg-lg\"> <div class=row> <div class=\"col-md-6 col-xs-12 q-marg-bottom-md-at-md\"> <div class=row> <div class=\"col-md-6 col-xs-12 q-col-spacer\"> Estimated Pickup Date: </div> <div class=\"col-md-6 col-xs-12 q-col-spacer\"> <span class=\"q-boldest estimated-pickup-date-val\">Monday, August 22</span> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12 q-col-spacer\"> Estimated Transit Time: </div> <div class=\"col-md-6 col-xs-12 q-col-spacer\"> <span class=\"q-boldest estimated-transit-time-val\">2 Days</span> </div> </div> </div> </div> </div> <div class=\"divider-group dg-lg\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> Estimated Cost: </div> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> <span class=\"q-boldest estimated-cost-val\">$3,005.00</span> </div> </div> </div> </div> </div>";

/***/ },
/* 1231 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=inbound-carrier-outer> <div class=\"shipping q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-marg-bottom-md inbound-carrier\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Inbound Carrier:</div> </div> <div class=\"col-md-7 col-xs-12 inbound-carrier-text\"> </div> </div> </div> <div class=\"q-marg-bottom-md inbound-broker\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Transportation Broker:</div> </div> <div class=\"col-md-7 col-xs-12 inbound-broker-text\"> </div> </div> </div> <div class=\"q-marg-bottom-md estimated-arrival-date\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Estimated Arrival:</div> </div> <div class=\"col-md-7 col-xs-12 estimated-arrival-date-text\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-marg-bottom-md tracking-numbers\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Tracking Numbers:</div> </div> <div class=\"col-md-7 col-xs-12 tracking-numbers-text\"> <div></div> </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Print FedEx Shipping Label:</div> </div> <div class=\"col-md-2 col-xs-12\"> <span class=\"q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg print-shipping-label-yes\">Yes</span> <span class=\"q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg print-shipping-label-no\">No</span> </div> </div> </div> <div class=\"q-marg-bottom-md bol-pro-outer\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>BOL / PRO Number(s):</div> </div> <div class=\"col-md-7 col-xs-12 bol-pro-number-text\"> </div> </div> </div> </div> </div> </div> </div> <div class=\"q-marg-top-xl review-asn-shipping-pallets-container\"> </div> <div class=pickup-scheduling-review-view-entry-point> pickup scheduling entry point </div> <div class=shipping-quote-review-view-entry-point> shipping quote entry point </div> </div></div>";

/***/ },
/* 1232 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=inbound-carrier-outer> <div class=\"shipping q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Inbound Carrier:</div> </div> <div class=\"col-md-7 col-xs-12 inbound-carrier-text\"> </div> </div> </div> <div class=\"q-marg-vert-md parcel-pallet-no-other\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Contact Name:</div> </div> <div class=\"col-md-7 col-xs-12 contact-name-text\"> </div> </div> </div> <div class=\"q-marg-vert-md parcel-pallet-no-other\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Contact Phone Number:</div> </div> <div class=\"col-md-7 col-xs-12 contact-phone-number-text\"> </div> </div> </div> <div class=\"q-marg-vert-md bol-pro-outer\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>BOL / POR Number(s):</div> </div> <div class=\"col-md-7 col-xs-12 bol-pro-number-text\"> </div> </div> </div> <div class=\"q-marg-vert-md estimated-arrival-date\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Estimated Arrival Date:</div> </div> <div class=\"col-md-7 col-xs-12 estimated-arrival-date-text\"> </div> </div> </div> <div class=\"q-marg-vert-md tracking-numbers\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Tracking Number(s):</div> </div> <div class=\"col-md-7 col-xs-12 tracking-numbers-text\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Print FedEx Shipping Label:</div> </div> <div class=\"col-md-2 col-xs-12\"> <span class=\"q-pretty-pill-tag q-ppt-blue q-ppt-pad-lg print-shipping-label-yes\">Yes</span> <span class=\"q-pretty-pill-tag q-ppt-blue-border q-ppt-pad-lg print-shipping-label-no\">No</span> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"q-marg-top-xl review-asn-shipping-pallets-container\"> </div> <div class=pickup-scheduling-review-view-entry-point> pickup scheduling entry point </div> <div class=shipping-quote-review-view-entry-point> shipping quote entry point </div> </div>";

/***/ },
/* 1233 */
/***/ function(module, exports) {

	module.exports = "<div class=additional-services-view> <div class=additional-services-target> </div> <div class=\"no-services-added q-alert q-alert-grey q-marg-vert-lg\"> No added service. If desired, please select a service above. </div> </div>";

/***/ },
/* 1234 */
/***/ function(module, exports) {

	module.exports = "<div class=\"product-view q-pretty-container q-pct-lightest-grey toggler-parent q-marg-vert-xl\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-pad-vert-xxs q-pad-left-til-md q-pad-horz-at-md q-pct-header-group-title\"> <div class=\"product-main-sku q-boldest q-pct-description\"> </div> <div class=\"product-desc q-pct-description\"> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-pad-vert-xxs q-pad-left-til-md q-pad-horz-at-md\"> <div class=\"q-boldest q-pad-vert-xxs\"> Quantity: <span class=product-agg-quantity></span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-top-xxs q-marg-horz-md q-marg-bottom-xxs-at-md\"> <div> <select name=\"\" class=\"additional-services-select select2-select q-input\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Add a Service\" data-s2-minimum-results-for-search=Infinity> <option value=-1 disabled=disabled selected=selected>Add a Service</option> </select> </div> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=q-marg-horz-xl> <div class=q-marg-vert-lg> <div class=\"additional-services-entry-point q-pct-description\"> </div> <div> <div class=\"prep-item prep-item-fragile q-alert q-alert-grey q-marg-vert-lg\" style=display:none> <i class=\"fa fa-exclamation-triangle q-marg-right-xxxs\"></i> <span class=q-boldest>Fragile Item. Ensure item is shipment ready.</span> </div> <div class=\"prep-item prep-item-barcode q-alert q-alert-grey q-marg-vert-lg\" style=display:none> <i class=\"fa fa-barcode\" aria-hidden=true></i> Item does not have barcodes </div> <div class=\"prep-item prep-item-no-prep q-alert q-alert-grey q-marg-vert-lg\" style=display:none> No preperation required. </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1235 */
/***/ function(module, exports) {

	module.exports = "<tr class=review-tab-service-inner> <td class=review-sku-name> </td> <td class=review-service-name> </td> <td class=\"review-quantity q-text-right\"> </td> <td class=\"review-estimated-cost q-text-right\"> </td> </tr>";

/***/ },
/* 1236 */
/***/ function(module, exports) {

	module.exports = "<tr> <td> <span class=q-boldest>Estimated Sub-Total</span> </td> <td></td> <td></td> <td class=q-text-right> <span class=\"q-boldest sub-total-currency\">{%- subtotal %}</span> </td> </tr>";

/***/ },
/* 1237 */
/***/ function(module, exports) {

	module.exports = "<div class=\"service-outer divider-group dg-lg\"> <div class=q-pad-horz-xs> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest> Service: </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=service-name> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest> Estimated Cost: </div> </div> <div class=\"col-md-2 col-xs-12\"> <div class=service-currency-total> </div> </div> <div class=\"col-md-1 col-xs-12\"> <a href=# class=service-remove-btn> <i class=\"fa fa-close fa-lg\"></i> </a> </div> </div> </div> </div>";

/***/ },
/* 1238 */
/***/ function(module, exports) {

	module.exports = "<div class=available-quotes-list-view-outer> <div class=\"q-input-group q-marg-bottom-xl q-overflow-x-auto\"> <div class=\"q-min-width-sm q-overflow-hidden\"> <div class=\"divider-group divider-group-headers\"> <div class=row> <div class=col-xs-1> </div> <div class=col-xs-3> Estimated Pick Up </div> <div class=col-xs-3> Estimated Transit Time </div> <div class=col-xs-4> Estimated Cost </div> </div> </div> <div class=\"divider-group-body available-quote-views-entry-point\"> </div> </div> </div> </div>";

/***/ },
/* 1239 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-vert-xl shipping-asn-detail-row\"> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-pad-vert q-marg-left-xl-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <div class=pallet-case-label-and-idx> <div class=pallet-case-label> Pallet </div> <div class=pallet-case-idx> 1 </div> </div> </div> </div> <div class=\"col-md-5 col-xs-12\"> <div class=\"q-marg-horz-lg q-marg-vert-md\"> <div class=q-text-center-at-md> <span class=q-pad-right-sm-til-md>Number of <span class=prd-level-pallet-case-label> </span>s:</span> <span class=\"q-tag pallet-case-number\"></span> </div> </div> </div> <div class=\"col-md-4 q-fs-lg q-text-center-at-md apply-dimension-weight-to-all-outer\"> <div class=\"q-marg-vert-xxs q-marg-horz q-pull-right-til-md q-marg-bottom-md-at-md\"> <a class=\"base-btn purple-btn q-text-center q-stretch-at-md q-marg-bottom-sm-at-md apply-to-all-btn\">Apply Dimension and Weight to All</a> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-md q-pad-top-md q-pad-bottom-lg\"> <div class=\"divider-group divider-group-title\"> <span class=q-tag> Product in <span class=prd-level-pallet-case-label> </span> </span> </div> <div class=shipping-tab-prd-skus> </div> </div> </div> </div> <div class=\"q-pct-footer q-pct-footer-bc-white asn-detail-dimension-outer\"> <div class=\"q-pad-horz-md q-pad-vert-lg\"> {% if (!isPallet) { %} <div class=\"divider-group dg-no-top-border dg-lg asn-detail-dvl-outer\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <label class=q-label>Declared value</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox value=\"\" name=declaredValueFlagInsideCase class=\"quick-toggler dvl-inside-case\" data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.q-pct-footer data-quick-toggler-target=.declared-value-within-case /> <span class=cb-label-inner></span> </label> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12 declared-value-within-case\" style=\"{%= startDvlInsideCaseStyle %}\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large q-marg-vert-md-at-md\"> <label> <input type=checkbox value=\"\" name=useCalculatedVal class=\"quick-toggler use-calculated-val\" data-quick-toggler-show-on-unchecked=true data-quick-toggler-closest=.declared-value-within-case data-quick-toggler-target=.calculated-value-note checked=checked /> <span class=cb-label-inner> Use Calculated Value </span> </label> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <span class=q-ig-units>$</span> <input type=number class=\"q-input declared-value-input\" id=\"\" name=\"\" data-error-placement-append-closest=.col-md-6 placeholder=\"\" min=0 readonly=readonly /> </div> </div> </div> </div> <div class=\"q-marg-vert-md calculated-value-note\" style=\"{%= calculatedValueNoteCaseStyle %}\"> By turning off calculated value, you can change the amount. Increasing amount may result in a non-refundable charge. Decreasing may lower your coverage. </div> </div> </div> </div> {% } %} <div class=\"divider-group dimensions-outer\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Dimensions *</label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md error-msg-wrapper\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=\"q-input q-stretch dimension-input asn-detail-length\" min=0 data-dim-connect=1 id=asn-item-length name=asn-ITEM_LENGTH data-error-placement-append-closest=.error-msg-wrapper placeholder=Length /> <span class=q-ig-units>in.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md error-msg-wrapper\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=\"q-input q-stretch dimension-input asn-detail-width\" min=0 data-dim-connect=1 id=asn-item-width name=asn-ITEM_WIDTH data-error-placement-append-closest=.error-msg-wrapper placeholder=Width /> <span class=q-ig-units>in.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12 error-msg-wrapper\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=\"q-input q-stretch dimension-input asn-detail-height\" min=0 data-dim-connect=1 id=asn-item-height name=asn-ITEM_HEIGHT data-error-placement-append-closest=.error-msg-wrapper placeholder=Height /> <span class=q-ig-units>in.</span> </div> </div> </div> </div> </div> <div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Weight *</label> </div> <div class=\"col-md-3 col-xs-12 error-msg-wrapper\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number placeholder=Weight class=\"q-input required q-stretch weight-warning-target asn-detail-weight\" min=0 name=asn-ITEM_POUNDS data-error-placement-append-closest=.error-msg-wrapper id=asn-item-pounds /> <span class=q-ig-units>lb.</span> </div> </div> </div> </div> </div> <div class=\"divider-group stackable-pallet-outer\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Stackable</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large stackable-pallet-checkbox-container\"> <input type=checkbox class=stackable-pallet-checkbox value=1 name=\"\" id=\"\"/> <label for=\"\"></label> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1240 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-vert-xl shipping-asn-detail-row\" data-current-row-idx=\"{%- optional.rowIdx %}\" data-current-pallet-id=\"{%- optional.asnShippingPalletId %}\"> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-pad-vert q-marg-left-xl-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <div class=pallet-case-label-and-idx> <div class=pallet-case-label> Pallet </div> <div class=pallet-case-idx> 1 </div> </div> </div> </div> <div class=\"col-md-5 col-xs-12\"> <div class=\"q-marg-horz-lg q-marg-vert-md\"> <div class=q-text-center-at-md> <span class=q-pad-right-sm-til-md>Number of <span class=prd-level-pallet-case-label> </span>s:</span> <span class=\"q-tag pallet-case-number\"></span> </div> </div> </div> <div class=\"col-md-4 q-fs-lg q-text-center-at-md apply-dimension-weight-to-all-outer\"> <div class=\"q-marg-vert-xxs q-marg-horz q-pull-right-til-md q-marg-bottom-md-at-md\"> <a class=\"base-btn purple-btn q-text-center q-stretch-at-md q-marg-bottom-sm-at-md apply-to-all-btn\">Apply Dimension and Weight to All</a> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-md q-pad-top-md q-pad-bottom-lg\"> <div class=\"divider-group divider-group-title\"> <span class=q-tag> Product in <span class=prd-level-pallet-case-label> </span> </span> </div> <div class=shipping-tab-prd-skus> </div> </div> </div> </div> <div class=\"q-pct-footer q-pct-footer-bc-white asn-detail-dimension-outer\"> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=\"divider-group dimensions-outer\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Dimensions *</label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md error-msg-wrapper\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=\"q-stretch dimension-input asn-detail-length\" min=0 data-dim-connect=1 id=asn-item-length name=asn-ITEM_LENGTH data-error-placement-append-closest=.error-msg-wrapper placeholder=\"Length (Inches)\" value=\"{%- optional.palletData.asp_pallet_length%}\"/> <span class=q-ig-units>in.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md error-msg-wrapper\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=\"q-stretch dimension-input asn-detail-width\" min=0 data-dim-connect=1 id=asn-item-width name=asn-ITEM_WIDTH data-error-placement-append-closest=.error-msg-wrapper placeholder=\"Width (Inches)\" value=\"{%- optional.palletData.asp_pallet_width%}\"/> <span class=q-ig-units>in.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12 error-msg-wrapper\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=\"q-stretch dimension-input asn-detail-height\" min=0 data-dim-connect=1 id=asn-item-height name=asn-ITEM_HEIGHT data-error-placement-append-closest=.error-msg-wrapper placeholder=\"Height (Inches)\" value=\"{%- optional.palletData.asp_pallet_height%}\"/> <span class=q-ig-units>in.</span> </div> </div> </div> </div> </div> <div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Weight *</label> </div> <div class=\"col-md-3 col-xs-12 error-msg-wrapper\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number placeholder=\"Weight (Pounds)\" class=\"required q-stretch weight-warning-target asn-detail-weight\" min=0 name=asn-ITEM_POUNDS data-error-placement-append-closest=.error-msg-wrapper id=asn-item-pounds value=\"{%- optional.palletData.asp_pallet_weight%}\"/> <span class=q-ig-units>lb.</span> </div> </div> </div> </div> </div> <div class=\"divider-group stackable-pallet-outer\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Stackable</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large stackable-pallet-checkbox-container\"> <input type=checkbox class=stackable-pallet-checkbox value=\"\" name=\"\" id=\"\" {%- (optional.palletData.asp_pallet_stackable) ? 'checked' : '' %} /> <label for=\"\"></label> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1241 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group available-quote-view-outer\"> <div class=row> <div class=col-xs-1> <div class=q-checkmark-radio> <label> <input type=radio value=1 name=quoteRadio class=quote-radio /> <span class=q-checkmark-radio-label-inner></span> </label> </div> </div> <div class=col-xs-3> <div class=\"estimated-pickup-date q-marg-top-xxs q-text-purple\"> DATE </div> </div> <div class=col-xs-3> <div class=\"estimated-transit-time q-marg-top-xxs\"> DAYS </div> </div> <div class=col-xs-4> <div class=\"estimated-cost q-marg-top-xxs\"> COST </div> </div> </div> </div>";

/***/ },
/* 1242 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section q-section-include-border case-arrival-and-tracking-row-view\"> <div class=row> <div class=\"col-md-1 col-xs-2\"> <div class=\"q-marg-vert-md xs-pad-top xs-pad-bottom\"> <div class=pallet-case-label-and-idx> <div class=pallet-case-label> Case </div> <div class=pallet-case-idx> 1 </div> </div> </div> </div> <div class=\"col-md-1 col-xs-4\"> <div class=\"q-marg-vert-md sm-pad-top xs-pad-bottom\"> <div class=\"pallet-case-icon text-grey q-text-center\"> <i class=\"case-icon fa fa-cube\" aria-hidden=true></i> </div> </div> </div> <div class=col-md-4> <div class=\"q-marg-vert-md xs-pad-top xs-pad-bottom\"> <div> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div> <label class=q-label>Expected Arrival</label> </div> </div> <div class=\"col-md-7 col-xs-12 wrapper-helper\"> <input class=\"q-input q-stretch case-expected-arrival-date-input\" type=text name=\"\" data-error-placement-append-closest=.wrapper-helper /> </div> </div> </div> </div> </div> <div class=col-md-6> <div class=weight-outer> <div class=\"q-input-group xs-pad-top xs-pad-bottom\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <label class=q-label>Tracking Number</label> </div> <div class=\"col-md-7 col-xs-12 wrapper-helper\"> <input class=\"q-input q-stretch case-tracking-number-input\" type=text name=\"\" placeholder=\"Tracking Number\" data-error-placement-append-closest=.wrapper-helper /> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1243 */
1195,
/* 1244 */
/***/ function(module, exports) {

	module.exports = "<div class=detail-pickup-quote-view-outer> <div class=\"q-section asn-shipping-pallets-rows-section\"> <div class=q-pad-horz-xl> <div id=pallet-for-case-container> </div> </div> </div> <div class=\"q-section asn-detail-rows-section\"> <div class=q-pad-horz-xl> <div class=asn-detail-rows-view-entry-point> asn detail rows area </div> <div class=\"more-info-shipping-outer q-marg-vert-xl\"> <div class=\"q-tight-well q-tw-lightest-grey q-no-pad q-pad-horz-xl\"> <h2 class=\"q-title q-fw-normal q-marg-vert-xl\"> More Information </h2> <p class=\"q-no-pad-marg q-marg-vert-xl\"> Shipping provided by FedEx Ground normally within 1 - 5 days. Shipping charges will appear on your monthly billing statement after delivery. </p> <h2 class=\"q-title q-fw-normal q-marg-vert-xl\"> Next Steps </h2> <p class=\"q-no-pad-marg q-marg-vert-xl\"> Download your shipping label(s) after submitting this shipment. You can have your shipments picked up at your location or drop them off at a FedEx location near you, including FedEx Office locations. </p> </div> </div> </div> </div> <div class=\"q-section pickup-scheduling-section\"> <div class=q-pad-horz-xl> <div class=pickup-scheduling-entry-point> pickup scheduling area </div> </div> </div> <div class=\"q-section request-qoute-section\"> <div class=q-pad-horz-xl> <div class=request-quote-entry-point> request quote area </div> </div> </div> </div>";

/***/ },
/* 1245 */
/***/ function(module, exports) {

	module.exports = "<div class=\"inbound-carrier-view q-section\"> <div class=q-marg-all-xl> <h2 class=q-section-title>Carrier Information</h2> <div class=q-marg-vert-xl> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-marg-vert-xxxs-til-md\">Transportation Selection</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"quick-btn-group qb-default qb-purple-theme q-text-center carrier-broker-toggler\"> <a href=# class=\"q-btn first-child q-pad-horz-xs active\" data-qb-key=carrier>Carrier</a> <a href=# class=\"q-btn last-child q-center q-pad-horz-xs\" data-qb-key=broker>Broker</a> <input type=hidden class=quick-btn-group-hidden-input name=carrierBroker id=carrierBroker /> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=show-carrier-feilds> <div class=\"col-md-3 col-xs-12\"> <p class=q-label>Inbound Carrier *</p> </div> <div class=\"col-md-6 col-xs-12\"> <div class=shipping-select-outer></div> </div> <div class=\"col-md-3 col-xs-12\"> <a href=# class=\"base-btn q-marg-top-md-at-md create-carrier-btn q-text-center q-stretch-at-md\">Create Carrier</a> </div> </div> <div class=show-broker-feilds> <div class=\"col-md-3 col-xs-12\"> <p class=q-label>Transportation Broker *</p> </div> <div class=\"col-md-6 col-xs-12\"> <div class=broker-select-outer></div> </div> <div class=\"col-md-3 col-xs-12\"> <a href=# class=\"base-btn q-marg-top-md-at-md create-carrier-btn q-text-center q-stretch-at-md\">Create Broker</a> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=carrier-expected-arrival-date-input class=q-label>Estimated Arrival *</label> </div> <div class=\"col-md-3 col-xs-12 wrapper-helper\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-static-col-1_5 q-input-first func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input id=carrier-expected-arrival-date-input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input required estimated-arrival carrier-expected-arrival-date-input\" type=text name=\"\" data-error-placement-append-closest=.wrapper-helper placeholder=\"   /   /   \"/> </div> </div> </div> </div> <div class=\"q-marg-vert-md if-case-not-freight tracking-number-outer\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Tracking Numbers</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch case-tracking-number-input\" placeholder=\"Enter tracking numbers, separated by commas\"/> </div> </div> </div> <div class=\"q-marg-vert-md if-freight-shipping bol-number-outer\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=carrier-bol-pro-number-input class=q-label>BOL Numbers</label> </div> <div class=\"col-md-6 col-xs-12\"> <input id=carrier-bol-pro-number-input class=\"q-input q-stretch carrier-bol-pro-number-input\" type=text name=\"\" placeholder=\"BOL / PRO Number\" data-error-placement-append-closest=.wrapper-helper /> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1246 */
/***/ function(module, exports) {

	module.exports = "<div class=\"inbound-carrier-view q-section\"> <div class=q-marg-all-xl> <h2 class=q-section-title>Carrier Information</h2> <div class=\"q-marg-vert-xl inbound-carrier-outer\"> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Inbound Carrier *</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=shipping-select-outer> </div> </div> </div> </div> <div class=other-fields-outer> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=other-carrier-input class=q-label>Carrier Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input id=other-carrier-input class=\"q-input q-stretch\" type=text name=\"\" placeholder=\"Carrier Name\"/> <div id=duplicate-default-carrier-error-message style=display:none> <label class=q-sim-error>Carrier already exists</label> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=carrier-contact-name-input class=q-label>Contact Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input id=carrier-contact-name-input class=\"q-input q-stretch\" type=text name=\"\" placeholder=\"Enter Contact Name\" maxlength=50 /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <p class=q-label>Phone Number *</p> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <div class=shipping-phone-code-select-outer> </div> </div> <div class=\"col-md-3 col-xs-12\"> <input id=carrier-contact-phone-input class=\"q-input q-stretch\" type=text name=\"\" placeholder=(___)___-____ /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label for=save-carrier>Save Carrier</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=save-carrier class=save-carrier value=save-carrier name=save-carrier /> <label for=save-carrier>Checkbox to save carrier information for future use.</label> </div> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=carrier-expected-arrival-date-input class=q-label>Estimated Arrival *</label> </div> <div class=\"col-md-3 col-xs-12 wrapper-helper\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-static-col-1_5 q-input-first func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input id=carrier-expected-arrival-date-input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input required estimated-arrival carrier-expected-arrival-date-input\" type=text name=\"\" data-error-placement-append-closest=.wrapper-helper placeholder=\"   /   /   \"/> </div> </div> </div> </div> <div class=\"q-marg-vert-md if-case-not-freight tracking-number-outer\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Tracking Numbers</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch case-tracking-number-input\" placeholder=\"Enter tracking numbers, separated by commas\"/> </div> </div> </div> <div class=\"q-marg-vert-md if-freight-shipping bol-number-outer\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=carrier-bol-pro-number-input class=q-label>BOL Numbers</label> </div> <div class=\"col-md-6 col-xs-12\"> <input id=carrier-bol-pro-number-input class=\"q-input q-stretch carrier-bol-pro-number-input\" type=text name=\"\" placeholder=\"BOL / PRO Number\" data-error-placement-append-closest=.wrapper-helper /> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1247 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section pickup-scheduling-view-outer\"> <div class=q-marg-all-xl> <h2 class=q-title>Pickup Scheduling</h2> <div class=q-marg-vert-xl> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=pickup-date-input class=q-label>Pickup Date*</label> </div> <div class=\"col-md-3 col-xs-12\"> <input id=pickup-date-input required class=\"q-input stretch pickup-date-input\" type=text name=shipping-tab-pickup-date placeholder=\"   /   /   \"/> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"pickup-date-message q-marg-top-xxs\"> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=pickup-time-input class=q-label>Pickup Time*</label> </div> <div class=\"col-md-9 col-xs-12\"> <div class=\"time-range-outer q-v-align-children-top\"> <div class=\"inline-block tp-wrapper\"> <div class=\"time-picker q-time-picker-default time-picker-from\"> <div class=time-picker-hours-select-outer> <select class=time-picker-hours-select> </select> </div> <span class=time-picker-seperater>:</span> <div class=time-picker-minutes-select-outer> <select class=time-picker-minutes-select> </select> </div> <div class=time-picker-period-select-outer> <select class=time-picker-period-select> </select> </div> </div> </div> <span class=\"q-bold q-pad-horz inline-block q-marg-top-xs q-marg-bottom-xs-at-md q-block-at-md\"> To </span> <div class=\"inline-block tp-wrapper\"> <div class=\"time-picker q-time-picker-default time-picker-to\"> <div class=time-picker-hours-select-outer> <select class=time-picker-hours-select> </select> </div> <span class=time-picker-seperater>:</span> <div class=time-picker-minutes-select-outer> <select class=time-picker-minutes-select> </select> </div> <div class=time-picker-period-select-outer> <select class=time-picker-period-select> </select> </div> </div> </div> </div> <div class=\"shipping-tab-pickup-time-range-error-message q-sim-error\" data-qw-custom-validator=true> The pickup time range is invalid. </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-bottom-xs-at-md\"> <label for=inside-pickup-checkbox class=q-label>Inside Pickup</label> </div> <div class=\"col-md-1 col-xs-12 q-marg-bottom-xs-at-md\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=inside-pickup-checkbox class=inside-pickup-checkbox value=1 name=inside-pickup-checkbox /> <label for=inside-pickup-checkbox></label> </div> </div> <div class=\"col-md-8 col-xs-12 q-marg-top-xxs-til-md\"> <div class=inside-pickup-message-outer> Handling freight at positions not immediately adjacent to vehicle. </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-bottom-xs-at-md\"> <label for=lift-gate-pickup-checkbox class=q-label>Lift Gate at Pickup</label> </div> <div class=\"col-md-1 col-xs-12 q-marg-bottom-xs-at-md\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=lift-gate-pickup-checkbox class=lift-gate-pickup-checkbox value=1 name=lift-gate-pickup-checkbox /> <label for=lift-gate-pickup-checkbox></label> </div> </div> <div class=\"col-md-8 col-xs-12 q-marg-top-xxs-til-md\"> <div class=lift-gate-pickup-message-outer> Pick-up using liftgate equipment. </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-bottom-xs-at-md\"> <label for=limited-access-checkbox class=q-label>Limited Access</label> </div> <div class=\"col-md-1 col-xs-12 q-marg-bottom-xs-at-md\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=limited-access-checkbox class=limited-access-checkbox value=1 name=limited-access-checkbox /> <label for=limited-access-checkbox></label> </div> </div> <div class=\"col-md-8 col-xs-12\"> <div class=\"limited-access-message-outer q-marg-top-xxs-til-md\"> To include construction sites, schools, churches, military bases. </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1248 */
/***/ function(module, exports) {

	module.exports = "<div class=request-quote-view-outer> <div class=request-quote-outer> <div class=q-marg-vert-md> <a href=# class=\"base-btn purple-btn request-quote-btn\"> Request Quote </a> </div> <div class=quotes-entry-point> quotes entry point </div> <div class=\"loader-outer q-marg-vert-md\"> <div class=pretty-well> <p class=q-fs-md> We're shopping for the best shipping rates... </p> <div class=\"loader-outer clearfix\"> <div class=inline-dots-loader></div> </div> </div> </div> <div class=\"request-quote-special-notice q-marg-vert-md\"> <div class=\"q-alert q-alert-red\"> <b> Rates are currently not available, however we can still help you transport the shipment. Please contact your CSR for assistance. </b> </div> </div> <div class=\"shipping-tab-request-quote-not-clicked-error-message q-marg-vert-md\" data-qw-custom-validator=true> <div class=\"q-alert q-alert-yellow\"> <b> Please click Request Quote & select an inbound shipping quote, or you may choose to handle the inbound shipping yourself. </b> </div> </div> <div class=\"shipping-tab-request-quote-no-selected-quote-error-message q-marg-vert-md\" data-qw-custom-validator=true> <div class=\"q-alert q-alert-yellow\"> <b> Please select an inbound shipping quote, or you may choose to handle the inbound shipping yourself. </b> </div> </div> <div class=\"request-quote-notice q-marg-vert-md\"> <div class=\"q-alert q-alert-green\"> A customer service representative will contact you with a quote. </div> </div> <div class=\"request-quote-removed-notice q-marg-vert-md\"> <div class=\"q-alert q-alert-yellow\"> <b> Your inbound shipping quote was removed because the shipment information changed. Click Request New Quote above. </b> </div> </div> <div class=\"request-quote-notice-failed q-marg-vert-md\"> <div class=\"q-alert q-alert-red\"> <b> We're sorry! There was an issue generating your quote. Please save this shipment and contact your CSR. </b> </div> </div> </div> </div>";

/***/ },
/* 1249 */
/***/ function(module, exports) {

	module.exports = "<div class=modal-body-inner> <div class=q-pad-horz-xl> <div class=q-marg-vert-md> Your saved Inbound Shipping Quote will be removed because the shipment information changed. You can request a new quote on the Shipping tab. </div> </div> </div>";

/***/ },
/* 1250 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-overflow-x-auto> <div class=\"q-overflow-x-hidden q-min-width-xs\"> {% if (lpns != \"\") { %} <div class=q-section> <div class=q-marg-bottom-md> <div class=row> <div class=col-xs-3> <span class=q-boldest>Custom {% if (isPallet) { %} Pallet {% } else {%} Case {% } %} ID :</span> </div> <div class=col-xs-9> <div class=custom-lpn-overflow> <div class=q-break-word> {%-lpns %} </div> </div> </div> </div> </div> </div> {% } %} <table class=\"table q-table q-table-vert-middle q-table-rows-min-height q-table-pad-tds-md\"> <thead> <th> Product Name </th> <th> Description </th> <th class=q-text-right> Units in {% if (isPallet) { %} Pallet {% } else {%} Case {% } %} </th> <th class=q-text-right> Total Units </th> </thead> <tbody class=main-area-for-sub-row> </tbody> </table> </div> </div> <div class=paging-area-for-sub-row></div> </div>";

/***/ },
/* 1251 */
/***/ function(module, exports) {

	module.exports = "<a href=# class=\"base-btn purple-btn v2-btn modal-auto-hide cancel-btn\">Close</a><a href=# class=\"base-btn purple-btn modal-auto-hide packingPrdExportDataModal\">Export</a>";

/***/ },
/* 1252 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey pallet-drawer-parent q-marg-top-xl\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-pad-vert q-marg-left-xl-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\">{% if (isPallet) { %} Pallets {% } else {%} Cases {% } %} {%- packageName %}</span> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-marg-horz-lg q-marg-vert-md\"> <div class=\"row q-text-center-at-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-pad-right-sm-til-md> Number of {% if (isPallet) { %} Pallets {% } else {%} Cases {% } %}: </span> <span class=q-tag> {%-noOfPackages%} </span> </div> <div class=\"col-md-6 col-xs-12\"> {% if (shippingPartner == \"FedEx\") { %} <div class=q-marg-top-md-at-md> <span class=q-pad-right-sm-til-md> Declared Value: </span> <span class=q-tag> ${%-dvlCalculatedValue%} </span> </div> {% } %} </div> </div> </div> </div> <div class=\"col-md-3 q-fs-lg q-text-center-at-md\"> <div class=\"q-marg-vert-xxs q-marg-horz q-pull-right-til-md q-marg-bottom-md-at-md\"> <a href=# class=\"base-btn purple-btn v2-btn view-detail-btn-for-packing q-pull-right-til-md q-text-center q-stretch-at-md\" data-pallet-num=\"{%- packageName %}\">View Products</a> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.pallet-drawer-target data-q-expander-closest=.pallet-drawer-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> {% if (shippingPartner == \"FedEx\" && !checkIfAsnShippingPalletsExists) { %} <div class=\"pallet-drawer-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-xl q-pad-vert-lg\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Dimensions:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%-dimensions%}</span> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"row q-marg-top-md-at-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag>Weight:</span> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%-weight%} lbs.</span> </div> </div> </div> </div> </div> </div> </div> {% } %} </div>";

/***/ },
/* 1253 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-vert-xxs\"> <span class=q-tag>{%-sku%}</span> </div> <div class=\"col-md-3 col-xs-12 q-marg-vert-xxs\"> {%-prdName%} </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-alert q-alert-grey q-alert-pad-all-sm q-inline-block q-marg-vert-xxs-at-md\"> {%-unitspercase%} units per {% if (isPallet) { %} Pallet {% } else {%} Case {% } %} </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-alert q-alert-grey q-alert-pad-all-sm q-inline-block q-marg-vert-xxs-at-md\"> {%-totalUnits %} units total </div> </div> </div> {% if (expirationDate != \"\") { %} <div class=q-marg-vert-xs> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-marg-left-md-til-md\">Exp Date:</span> </div> <div class=\"col-md-3 col-xs-12\"> {%-expirationDate %} </div> </div> </div> {% } %} {% if (lotNumber > 0 ) { %} <div class=q-marg-vert-xs> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-marg-left-md-til-md\">Lot Number:</span> </div> <div class=\"col-md-3 col-xs-12\"> {%-lotNumber %} </div> </div> </div> {% } %} </div>";

/***/ },
/* 1254 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-marg-top-xl\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-pad-vert-xxs q-pad-left-til-md q-pad-horz-at-md q-pct-header-group-title\"> <div class=\"q-boldest q-pct-description\"> {%-sku%} </div> <div class=q-pct-description> {%-prdName%} </div> </div> </div> <div class=\"col-md-8 col-xs-12\"> <div class=\"q-marg-top-xxs q-marg-horz-md q-marg-bottom-xxs-at-md\"> <span class=\"q-pill q-pill-detail q-pill-white-and-grey\">Planned: {%-sentUnits%} </span> {% if (receivedUnits > 0) { %} <span class=\"q-marg-left-xxxs q-pill q-pill-detail q-pill-blue\">Received: {%-receivedUnits%}</span> {% }%} </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=q-marg-horz-xl> {% if (receivedUnits > 0) { %} <div class=q-marg-vert-lg> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-fs-sm\">UPC:</span> </div> <div class=\"col-md-9 col-xs-12 q-pct-description\"> {%-upc%} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12 q-pct-description\"> <span class=\"q-tag q-fs-sm\">Long Description:</span> </div> <div class=\"col-md-9 col-xs-12\"> {%-prdDesc%} </div> </div> </div> </div> {% } else {%} <div class=\"q-alert q-alert-grey q-marg-vert-lg\">Details for this product will be displayed here when shipment is received.</div> {% } %} </div> </div> </div> </div>";

/***/ },
/* 1255 */
/***/ function(module, exports) {

	module.exports = "<tr> <td style=width:25%>{%- productName %}</td> <td style=width:35%>{%- description %}</td> <td style=width:20% class=q-text-right>{%- unitsInPallet %}</td> <td style=width:20% class=q-text-right>{%- totalUnits %}</td> </tr>";

/***/ },
/* 1256 */
/***/ function(module, exports) {

	module.exports = "<tr> <td>{%- sku %}</td> <td>{%= service %}</td> <td class=q-text-right>{%- quantity %}</td> <td class=q-text-right>{%= cost %}</td> </tr>";

/***/ },
/* 1257 */
/***/ function(module, exports) {

	module.exports = "<div> {%- value %} </div>";

/***/ },
/* 1258 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-input-and-icon q-marg-bottom-md\"> <input type=email class=\"q-input q-stretch email-recipient\" placeholder=\"Enter email address\"/> <a class=q-text-center href=#> <i class=\"fa fa-times fa-lg q-link-icon remove-email-row\"></i> </a> </div>";

/***/ },
/* 1259 */
/***/ function(module, exports) {

	module.exports = "<tr> <td> <a href=# class=get-invoice-link data-invoice-id=\"{%- invoiceId %}\" data-pdf-url=\"{%- pdfUrl %}\">{%- invoiceNumber %}</a> </td> <td> {%- invoiceDate %} </td> <td> {%- dueDate %} </td> <td class=q-text-right> {%- amountDue %} </td> <td class=\"q-text-right q-pad-horz-xl\"> {%- remaining %} </td> <td> <div class=\"q-pill {%- pillColor %} q-pill-table\">{%- status %}</div> </td> <td> <a href=# class=get-invoice-link data-invoice-id=\"{%- invoiceId %}\" data-pdf-url=\"{%- pdfUrl %}\"><i class=\"fa fa-lg fa-download q-link-icon\"></i></a> <a href=# class=send-inquiry-link data-invoice-number=\"{%- invoiceNumber %}\" data-invoice-date=\"{%- invoiceDate %}\"><i class=\"fa fa-lg fa-comment q-marg-left-md q-link-icon\"></i></a> </td> </tr>";

/***/ },
/* 1260 */
/***/ function(module, exports) {

	module.exports = "<tr> <td> There are no invoices to display at this time. </td> <td/> <td/> <td/> <td/> <td/> <td/> </tr>";

/***/ },
/* 1261 */
/***/ function(module, exports) {

	module.exports = "<span>{%- data %}</span> {% if (pillDate) { %}<span class=\"q-pretty-pill-tag q-ppt-pad-md q-ppt-lighter-grey q-ppt-large-radius q-fs-xs q-marg-left-md\">{%- pillDate %}</span>{% } %}";

/***/ },
/* 1262 */
/***/ function(module, exports) {

	module.exports = "<div class=\"export-modal-body q-marg-all-xl\"> <div class=q-marg-vert-md> You're attempting to export Select file format </div> <div class=q-marg-vert-md> A maximum of 1000 rows can be exported. </div> <div class=q-marg-vert-md> <select class=\"form-control custom-select faux-placeholder dataFileType\" id=dataFileType name=dataFileType> <option class=defaultDropDnVal value=0 disabled=disabled selected=selected>Select file format</option> <option value=csv>CSV</option> <option value=pdf>PDF</option> </select> </div> </div>";

/***/ },
/* 1263 */
/***/ function(module, exports) {

	module.exports = "<button id=modalClose type=button class=\"base-btn purple-btn v2-btn\" data-dismiss=modal>Cancel</button> <button type=button disabled=true class=\"btn btn-primary modalExportData\">Export</button>";

/***/ },
/* 1264 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md q-marg-bottom-sm-at-md\"> <i class=\"fa fa-tag q-icon-marg-right\"></i> <span class=\"q-boldest q-marg-right-md\">Item Sku:</span> {%- itemSku %} </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md q-marg-bottom-sm-at-md\"> <span class=\"q-boldest q-marg-right-md\">Sold to:</span> {%- soldToParty %} </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md q-marg-bottom-sm-at-md\"> <span class=\"q-boldest q-marg-right-md\">Status:</span> {%- amlStatus %} </div> </div> </div>";

/***/ },
/* 1265 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md q-marg-bottom-sm-at-md\"> <i class=\"fa fa-tag q-icon-marg-right\"></i> <span class=\"q-boldest q-marg-right-md\">Bundle Name(SKU):</span> <div class=\"q-display-none q-inline-block-at-md\"> {%- sku %} </div> </div> <div class=\"col-md-3 q-marg-vert-xxs-til-md q-display-none-at-md\"> {%- prdsku %} </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-bottom-md-at-md\"> <span class=\"q-boldest q-marg-right-md\">Status:</span> <span class=\"q-pill q-pill-detail q-pill-blue\">{%- prdactive %}</span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> <a href=\"{%- viewItemUrl %}&itemId={%- itmid %}\" target=_blank class=\"base-btn purple-btn v2-btn q-pull-right-til-md q-block-at-md q-text-center\">View Details</a> </div> </div> </div>";

/***/ },
/* 1266 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=q-tc-container> <div class=\"q-tc-row q-v-align-children-middle\"> <div class=\"q-col-auto q-marg-vert-md-at-md\"> <i class=\"fa fa-shopping-basket q-icon-marg-right\"></i> <span class=\"q-boldest q-marg-right-md\">External ID:</span> <span class=q-display-none-at-md> {%- externalOID %} </span> </div> <div class=\"q-col-auto q-marg-bottom-md-at-md\"> <span class=\"q-boldest q-marg-right-md\">FedEx ID:</span> <span class=q-display-none-at-md> {%- fedexOId %} </span> </div> <div class=\"q-col-fix-40 q-marg-bottom-md-at-md\"> <span class=\"q-boldest q-marg-right-md\">Status:</span> <span class=\"q-display-none q-pill q-pill-detail {%- pillColor %} q-inline-block-at-md\">{%- status %}</span> </div> <div class=q-col-fix-145> <div class=q-display-none-at-md> <span class=\"q-pill q-pill-detail {%- pillColor %} q-pill-stretch\">{%- status %}</span> </div> </div> <div class=\"q-col-fix-130 q-marg-bottom-md-at-md\"> <a href=\"{%- viewOrderRenderUrl %}&orderId={%- fedexOId %}\" target=_blank class=\"base-btn purple-btn v2-btn q-pull-right-til-md q-block-at-md q-text-center\">View Details</a> </div> </div> </div> </div>";

/***/ },
/* 1267 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md q-marg-bottom-sm-at-md\"> <i class=\"fa fa-tag q-icon-marg-right\"></i> <span class=\"q-boldest q-marg-right-md\">Product Name(SKU):</span> <div class=\"q-display-none q-inline-block-at-md\"> {%- sku %} </div> </div> <div class=\"col-md-3 q-marg-vert-xxs-til-md q-display-none-at-md\"> {%- prdsku %} </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-bottom-md-at-md\"> <span class=\"q-boldest q-marg-right-md\">Status:</span> {% if (prdactive = true) { %} <span class=\"q-pill q-pill-detail q-pill-blue\">Active</span> {% } %} {% if (prdactive = false) { %} <span class=\"q-pill q-pill-detail q-pill-blue\">Deactive</span> {% } %} </div> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> <a href=\"{%- viewItemUrl %}&itemId={%- itmid %}\" target=_blank class=\"base-btn purple-btn v2-btn q-pull-right-til-md q-block-at-md q-text-center\">View Details</a> </div> </div> </div>";

/***/ },
/* 1268 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md q-marg-bottom-sm-at-md\"> <i class=q-icon-marg-right></i> <span class=\"q-boldest q-marg-right-md\">RMA #:</span> {%- rmaNumber %} </div> <div class=\"col-md-5 col-xs-12 q-col-spacer q-marg-bottom-sm-at-md\"> <span class=\"q-boldest q-marg-right-md\">Status:</span> {%- status %} </div> <div class=\"col-md-3 col-xs-12 q-col-spacer\"> <a href=\"{%- viewRmaRenderUrl %}&selectedRmaId={%- selectedRmaId %}\" target=_blank class=\"base-btn purple-btn v2-btn q-pull-right-til-md q-block-at-md q-text-center\">View Details</a> </div> </div> </div>";

/***/ },
/* 1269 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group dg-md\"> <div class=q-tc-container> <div class=\"q-tc-row q-v-align-children-middle\"> <div class=q-col-6> <span class=\"q-tag q-marg-right-md\"> <i class=\"fa fa-shopping-basket q-icon-marg-right\"></i> Product SKU: </span> <span class=q-display-none-at-md> {%- itemSku %} </span> <span class=\"q-display-none q-block-at-md q-valuable\"> {%- itemSku %} </span> </div> <div class=\"q-col-4 q-marg-vert-md-at-md\"> <span class=\"q-tag q-marg-right-md\">Release Rule ID:</span> <span class=q-display-none-at-md> {%- ruleId %} </span> <span class=\"q-display-none q-block-at-md q-valuable\"> {%- ruleId %} </span> </div> <div class=q-col-fix-130> <a href=\"{%- viewItemUrl %}&cbrId={%- ruleId %}\" target=_blank class=\"base-btn purple-btn v2-btn q-pull-right-til-md q-block-at-md q-text-center\">View Details</a> </div> </div> </div> </div>";

/***/ },
/* 1270 */
187,
/* 1271 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xs-at-md><a href=\"{%= url %}&cbrId={%- id %}\"> {%- name %} </a></div>";

/***/ },
/* 1272 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row attribute-row\"> <div class=\"col-md-9 col-xs-12\"> <div class=\"row q-marg-bottom-md-til-md q-marg-bottom-xl-at-md\"> <div class=\"col-md-6 col-xs-12\"> <div class=wrapper-helper> <select id=\"attributeName_{%- index %}\" name=\"attributeName_{%- index %}\" class=select2-select style=width:100% data-s2-placeholder=\"Select a Attribute\" data-error-placement-append-closest=div data-s2-allow-clear=true data-s2-minimum-results-for-search=7> {%=attributesHtml%} </select> </div> <div id=\"attributeNameErr_{%- index %}\" name=\"attributeNameErr_{%- index %}\" class=\"attrib-name-error_{%- index %}\" style=display:none> <label class=error style=margin-bottom:0>Select an attribute or delete the attribute value.</label> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-top-md-at-md> <input id=\"attributeValue_{%- index %}\" name=\"attributeValue_{%- index %}\" class=\"q-input q-stretch\" type=text placeholder=\"Enter attribute value\"/> </div> <div id=\"attributeValueErr_{%- index %}\" name=\"attributeValueErr_{%- index %}\" class=\"attrib-val-error_{%- index %}\" style=display:none> <label class=error style=margin-bottom:0>Please specify the attribute value.</label> </div> </div> </div> </div> </div>";

/***/ },
/* 1273 */
/***/ function(module, exports) {

	module.exports = "<div class=condition-row> <div class=q-marg-bottom-md> <div class=row> <div class=col-xs-12> <h4 class=\"q-title q-skinny\">Disposition Output {%=output%}</h4> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"col-xs-12 q-no-pad\"> <div class=\"row q-marg-top-sm\"> <div class=col-xs-12> <select id=\"condition_{%- index %}\" name=\"condition_{%- index %}\" class=\"select2-select q-input\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select a Condition\" data-s2-minimum-results-for-search=7 data-s2-allow-clear=true> {%=conditionHtml%} </select> </div> <div id=\"conditionErr_{%- index %}\" name=\"conditionErr_{%- index %}\" class=\"col-sm-10 cond-sel-error_{%- index %}\" style=display:none> <label class=error style=margin-bottom:0>Please specify a condition.</label> </div> </div> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"col-xs-12 q-no-pad\"> <div class=\"row q-marg-top-sm\"> <div class=col-xs-12> <select id=\"disposition_{%- index %}\" name=\"disposition_{%- index %}\" class=\"select2-select q-input\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select a Disposition\" data-s2-allow-clear=true data-s2-minimum-results-for-search=7> {%=dispositionHtml%} </select> </div> <div id=\"dispositionErr_{%- index %}\" name=\"dispositionErr_{%- index %}\" class=\"col-sm-10 disp-sel-error_{%- index %}\" style=display:none> <label class=error style=margin-bottom:0>Please specify a disposition.</label> </div> </div> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"col-xs-12 q-no-pad\"> <div class=\"row q-marg-top-sm\"> <div class=col-xs-12> <select id=\"vas_{%- index %}\" name=\"vas_{%- index %}\" class=\"select2-select q-input\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select a Value Added Service\" data-s2-allow-clear=true data-s2-minimum-results-for-search=7> {%=vasHtml%} </select> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1274 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xs-at-md> <a href=\"{%=detailsPageUrl %}&{%- portletNameSpace %}{%- dimParam %}={%- dimId %}\"> {%- dimDivisorClassName %} </a> </div>";

/***/ },
/* 1275 */
/***/ function(module, exports) {

	module.exports = "<div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> <span>Discount Details</span> </h2> </div> <div class=\"discounts-createedit q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=q-marg-vert-lg> <div class=row> <div class=\"col-md-3 col-xs-12\" style=right:15px> <span class=q-tag> Discount Name * </span> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch\" id=discounts-name placeholder=\"Enter discount name\" data-error-placement-append-closest=div name=discounts-name path=rtdName value=\"{%=discountName%}\" required/> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"></div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-red\" id=discounts-name-exists hidden=true>Discount Name already exists</div> </div> </div> </div> </div> <div class=\"q-marg-vert-lg q-border-top q-no-pad-horz\"> <div class=q-marg-vert-lg> <h4 class=\"q-title q-skinnier\"> Discount Values - United States <a href=# class=\"discount-section-collapse-expand-btn base-btn purple-btn v2-btn q-no-border-til-md q-neg-marg-vert-xs-til-md q-marg-top-md-at-md q-block-at-md q-pull-right-til-md q-text-center-at-md q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target-united-states></a> </h4> </div> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-xs\" id=usShippingMethodCId> </div> </div> <div class=\"q-marg-vert-lg q-border-top q-no-pad-horz\"> <div class=q-marg-vert-lg> <h4 class=\"q-title q-skinnier\"> Discount Values - Canada <a href=# class=\"discount-section-collapse-expand-btn base-btn purple-btn v2-btn q-no-border-til-md q-neg-marg-vert-xs-til-md q-marg-top-md-at-md q-block-at-md q-pull-right-til-md q-text-center-at-md q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target-canada></a> </h4> </div> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-xs\" id=caShippingMethodCId> </div> </div> <div class=\"q-marg-vert-lg q-border-top q-no-pad-horz\"> <div class=q-marg-vert-lg> <h4 class=\"q-title q-skinnier\"> Discount Values - Outside United States and Canada <a href=# class=\"discount-section-collapse-expand-btn base-btn purple-btn v2-btn q-no-border-til-md q-neg-marg-vert-xs-til-md q-marg-top-md-at-md q-block-at-md q-pull-right-til-md q-text-center-at-md q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target-outside></a> </h4> </div> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-xs\" id=otherShippingMethodId> </div> </div> </div> </div> </div>";

/***/ },
/* 1276 */
/***/ function(module, exports) {

	module.exports = "<div class=discount-values-1> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-pad-all-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\">{%= discountValue %}</span> </div> </div> </div> </div> <div class=\"q-pct-header-group-expander {%= btnExpandableTarget %}\"> {% if (expandableTarget) { %} <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=\".{%= expandableTarget %}\" data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> {% } %} </div> </div> <div class=\" {%= btnExpandableTarget %} {% if (expandableTarget) { %} {%= expandableTarget %} q-expandable-default {% } %} \"> <div class=\"q-pct-body q-no-border\"> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=q-overflow-hidden> <div class=\"q-row full-vertical-break-at-md\"> <div class=\"q-col-4 q-relfix q-marg-bottom-md\"> <div class=\"q-marg-vert-xs q-display-none-at-md q-marg-top-md\"> <div class=row> <label class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Surcharge</span> </label> <label class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Discount %</span> </label> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Accessorial Surcharge: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-as\"> 10 </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Additional Handling: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-addh\"> 40 </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Address Correction: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-addc\"> 25 </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Clearance Entry International: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-clr\"> - </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Dangerous Goods: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-dg\"> - </div> </div> </div> <div class=\"solo-divider ds-bottom-at-md ds-pulled-full-height ds-right-til-md ds-full-height ds-grey\"> </div> </div> <div class=\"q-col-4 q-relfix q-marg-bottom-md\"> <div class=q-marg-left-xl-til-md> <div class=\"q-marg-vert-xs q-display-none-at-md\"> <div class=row> <label class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Surcharge</span> </label> <label class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Discount %</span> </label> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Delivery Area: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-da\"> - </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Delivery Confirmation: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-dc\"> 25 </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Documentation Fee: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-df\"> - </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Email Labeling: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-el\"> - </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Fuel Surcharge: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-fs\"> 35 </div> </div> </div> <div class=\"solo-divider ds-bottom-at-md ds-pulled-full-height ds-right-til-md ds-full-height ds-grey\"> </div> </div> </div> <div class=\"q-col-4 q-relfix q-marg-left-xl-til-md q-marg-bottom-md\"> <div class=q-marg-left-xl-til-md> <div class=\"q-marg-vert-xs q-display-none-at-md\"> <div class=row> <label class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Surcharge</span> </label> <label class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Discount %</span> </label> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Home Delivery CDO: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-hdc\"> - </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Other Surcharges: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-os\"> 10 </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Reroute Surcharge: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-rs\"> - </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Residential Delivery: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-rd\"> - </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> Signature Option Surcharge: </div> <div class=\"col-md-4 col-xs-3\" id=\"{%=code%}-{%=discountValue%}-sos\"> 15 </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1277 */
/***/ function(module, exports) {

	module.exports = "<div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> Discount Details </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.discount-details data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"discount-details q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=q-marg-vert-lg> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=q-tag> Discount Name: </span> </div> <div class=\"col-md-9 col-xs-12\" id=dtls-discount-name> </div> </div> </div> <div class=\"q-marg-vert-lg q-border-top q-no-pad-horz\"> <div class=q-marg-vert-lg> <h4 class=\"q-title q-skinnier\"> Discount Values - United States <a href=# class=\"discount-section-collapse-expand-btn base-btn purple-btn v2-btn q-no-border-til-md q-neg-marg-vert-xs-til-md q-marg-top-md-at-md q-block-at-md q-pull-right-til-md q-text-center-at-md q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target-united-states></a> </h4> </div> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-xs\"> {%= fedExSmartPost %} {%= fedExSmartPostLightWeight %} {%= fedexHomeDelivery %} {%= fedExGround %} {%= fedExExpressSaver %} {%= fedEx2Day %} {%= fedExPriorityOvernight %} {%= fedExStandardOvernight %} {%= amazonSellerFulfilledPrime %} {%=  USPS %} </div> </div> <div class=\"q-marg-vert-lg q-border-top q-no-pad-horz\"> <div class=q-marg-vert-lg> <h4 class=\"q-title q-skinnier\"> Discount Values - Canada <a href=# class=\"discount-section-collapse-expand-btn base-btn purple-btn v2-btn q-no-border-til-md q-neg-marg-vert-xs-til-md q-marg-top-md-at-md q-block-at-md q-pull-right-til-md q-text-center-at-md q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target-canada></a> </h4> </div> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-xs\"> {%= fedExInternationalPriority %} {%= fedExInternationalGround %} {%= fedexInternationalEconomy %} </div> </div> <div class=\"q-marg-top-lg q-border-top q-no-pad-horz\"> <div class=q-marg-vert-lg> <h4 class=\"q-title q-skinnier\"> Discount Values - Outside United States and Canada <a href=# class=\"discount-section-collapse-expand-btn base-btn purple-btn v2-btn q-no-border-til-md q-neg-marg-vert-xs-til-md q-marg-top-md-at-md q-block-at-md q-pull-right-til-md q-text-center-at-md q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target-outside></a> </h4> </div> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-xs\"> {%= fedExInternationalPriorityOutSide %} {%= fedexInternationalEconomyOutSide %} </div> </div> </div> </div> </div>";

/***/ },
/* 1278 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xs-at-md> <a href=\"{%=detailsPageUrl %}&{%- portletNameSpace %}{%- discountsParam %}={%- discountsId %}\"> {%- discountsClassName %} </a> </div>";

/***/ },
/* 1279 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-md-4 col-xs-12\" style=height:40px;margin-top:12px;margin-bottom:30px> <div class=row> <div class=\"col-md-7 col-xs-12\"> <label class=\"q-label q-label-no-bold\">{%=surchargeLabel%}</label> </div> <div class=\"col-md-5 col-xs-3\"> <input type=text class=\"q-input q-stretch discounts-validate\" id=\"{%= surchargeLabel%}_{%=surchargeValue%}\" placeholder=\"\" data-error-placement-append-closest=div name=\"{%= surchargeLabel%}_{%=surchargeValue%}\" value=\"{%=surchargeDiscountValue%}\" maxlength=3 required {% if(surchargeLabel ==\"Fuel Surcharge\" || surchargeLabel ==\"Residential Delivery\") { %} disabled=disabled {% } %}/> <label class=q-sim-error style=display:none> Enter a value between 0-100 </label> </div> <div class=\"col-md-6 col-md-offset-6 clearfix\" id=\"\"> </div> </div> </div> <div class=\"solo-divider ds-bottom-at-md ds-grey\"></div> <div class=\"solo-divider ds-pulled-full-height ds-right-til-md ds-full-height ds-grey\" id=yui_patched_v3_11_0_1_1581952406674_781></div>";

/***/ },
/* 1280 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default-base q-max-page-width-md q-page-center-margin\" id=dock-config-new-edit> <div class=\"q-card q-card-white\"> <div class=q-main-header> <div class=row> <div class=col-xs-12> <div class=q-inline-block-til-md> <div class=\"q-border-bottom-at-md q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"> Edit Dock Configurations </h2> </div> </div> </div> </div> </div> <div class=q-section> {%= facilityDocks %} </div> <div class=\"q-section q-card q-card-white\"> {%= plannedOperationClosure %} </div> <div class=\"q-footer q-no-border-top q-card q-card-white\"> <div class=\"q-footer-btn-group q-pull-right-til-md\"> <a href=# class=\"base-btn purple-btn v2-btn q-text-center q-block-at-md cancel-edit-config-btn\">Cancel</a> <a href=# class=\"base-btn purple-btn q-text-center q-block-at-md save-dock-config-btn\">Save</a> </div> </div> </div> </div>";

/***/ },
/* 1281 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-md> <div class=row> <div class=\"col-md-4 col-xs-12\"> <span class=q-tag> {%= dosDay.dosDay %} </span> </div> {%= dosTimes %} </div> </div>";

/***/ },
/* 1282 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-md-8 col-xs-12\"> <span> {%= dosTime.dosStartTime %} - {%= dosTime.dosEndTime %} </span> <br/> </div>";

/***/ },
/* 1283 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pct-body q-pad-left-til-md\"> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <span class=q-tag> Door {%- doorDetail.doorNumber %} </span> </div> <div class=\"col-md-7 col-xs-12\"> {%- doorDetail.docUse %} </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <span class=q-tag> Appointments Accepted: </span> </div> <div class=\"col-md-7 col-xs-12\"> <span> {%- doorDetail.docAppointmentTypes %} </span> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1284 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <h2 class=q-section-title> Facility Docks </h2> <div class=q-marg-top-md> <div class=\"divider-group divider-group-title q-no-pad-left-til-md\"> <h4 class=\"q-fw-normal q-no-marg\"> Saved Docks </h4> <div class=q-marg-vert-md name=add-facility-dock-btn-section> <div class=\"q-pretty-box q-pretty-box-grey pretty-box-border q-text-center\"> Create and configure docks that are currently operational at this facility. <div class=q-marg-top-md> <a href=# class=\"base-btn add-facility-dock-btn purple-btn q-block-at-md\"> Add Facility Dock </a> </div> </div> </div> </div> </div> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-md\" name=dock-details-area> {%= dockTypes %} </div> <div class=q-marg-top-md id=add-new-facility-dock-btn name=add-new-facility-dock-btn> <a href=# class=\"base-btn purple-btn q-block-at-md\"> Add Facility Dock </a> </div> </div>";

/***/ },
/* 1285 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-md> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-pad-all-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\"> {%- docks.dockName %}</span> </div> </div> <div class=\"col-md-5 col-xs-12 q-fs-lg q-text-center-at-md\"> <div class=\"q-marg-vert-xxs q-marg-horz q-pull-right-til-md q-marg-vert-md-at-md\"> <a class=\"base-btn purple-btn v2-btn q-text-center q-stretch-at-md q-marg-bottom-sm-at-md remove-dock-btn\"> Remove </a> <a class=\"base-btn edit-dock-btn purple-btn q-marg-left-xxs-til-md q-text-center q-stretch-at-md\"> Edit </a> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=\"q-pct-body q-pad-left-til-md\"> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-marg-bottom-md q-marg-top-md-at-md\"> <div class=row> <div class=col-xs-12> <span class=q-tag> Operational Schedule (ET): </span> </div> </div> </div> {%= dosDays %} </div> </div> </div> </div> <div class=\"q-pct-body q-pad-left-til-md\"> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=\"q-marg-bottom-md q-marg-top-md-at-md\"> <div class=row> <div class=col-xs-12> <span class=q-tag> Dock Doors </span> </div> </div> </div> {%= doorDetails %} </div> </div> </div> </div>";

/***/ },
/* 1286 */
/***/ function(module, exports) {

	module.exports = "<div class=q-expandable-wrap id=planned-closure-details> <div class=q-expandable-header> <h2 class=q-expandable-title> Planned Operation Closures </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.planned-operation-closure data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"planned-operation-closure q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=q-marg-vert-md> Set all dates with planned exceptions to regular operation hours. All recorded times will be displayed in ET. </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Closed Date </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=wrapper-helper> <div class=\"q-input-with-inner-text q-inner-text-right func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input name=add-date-text class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input planned-date-area\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <a href=# class=\"base-btn add-date-btn purple-btn q-text-center q-block-at-md q-marg-top-md-at-md\"> Add Date </a> </div> </div> </div> <div class=q-marg-vert-md name=closure-details> <div class=\"divider-group divider-group-title q-no-pad-left-til-md\"> <h4 class=\"q-fw-normal q-no-marg\"> Planned Closure Dates </h4> </div> {% if(closureDates.length == 0) {%} <div class=q-marg-top-md> <div class=\"q-alert q-alert-grey\"> No planned closure dates or times. </div> </div> {% } %} {%= closureDates %} </div> </div> </div> </div>";

/***/ },
/* 1287 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group q-no-border-bottom q-no-pad-left-til-md remove-door-details\" name=door-details-section> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Door Name * </label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required\" placeholder=\"Enter door name\" data-error-placement-append-closest=div name=door-name /> </div> <div class=\"col-md-3 col-xs-12\"> <a class=\"base-btn purple-btn v2-btn q-text-center q-stretch-at-md q-marg-bottom-sm-at-md remove-door-btn\"> Remove Door </a> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Door Uses * </label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select required\" style=width:100% data-s2-minimum-results-for-search=Infinity data-error-placement-append-closest=div name=door-uses> <option value=\"Inbound and Outbound\">Inbound and Outbound</option> <option value=\"Outbound only\">Outbound only</option> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Appointment Types Accepted * </label> </div> <div class=\"col-md-9 col-xs-12\"> <div class=appointment-types-accepted> <select class=\"select2-select required\" style=width:100% multiple=multiple data-s2-minimum-results-for-search=Infinity data-s2-placeholder=\"Select all appointment types this dock is capable of processing\" data-error-placement-append-closest=div name=door-appointment-types id=doorAppointmentTypesdoor> <option value=\"\"></option> <option value=\"Live Load\">Live Load</option> <option value=\"Live Unload\">Live Unload</option> <option value=\"Pickup Load\">Pickup Load</option> <option value=\"Pickup Empty\">Pickup Empty</option> <option value=\"Drop Load\">Drop Load</option> </select> </div> </div> </div> </div> </div>";

/***/ },
/* 1288 */
/***/ function(module, exports) {

	module.exports = "<form class=edit-dock-form id=\"edit-dock-form-{%- dataEditIndex %}\" data-edit-index-id=\"{%- dataEditIndex %}\"> <div class=\"q-default-base q-max-page-width-md q-page-center-margin\" id=edit-dock-area name=edit-dock-area data-edit-index=\"{%- dataEditIndex %}\"> <div class=\"q-card q-card-white\"> <div class=q-main-header> <div class=row> <div class=col-xs-12> <div class=q-inline-block-til-md> <div class=\"q-border-bottom-at-md q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"> Edit Dock </h2> </div> </div> </div> </div> </div> <div class=q-section id=dock-edit-detail-section> <div class=q-marg-all-xl> <h2 class=q-section-title> <span>Dock Details</span> </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Dock Name * </label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch dockname-edit required\" placeholder=\"Enter dock name\" value=\"{%- optional.dockName %}\" data-error-placement-append-closest=div name=dock-edit-name id=dock-edit-name /> </div> </div> </div> </div> </div> <div class=q-section> {%= doorEditDetails %} </div> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Master Operational Schedule </h2> <div class=q-marg-vert-md> Select the days of the week that the facility door will be operational and add atleast one shift to each operational day.Please note that schedule times will be displayed in ET. All doors will follow the schedule unless they are edited individually. </div> <div class=q-marg-vert-md> <div class=\"divider-group divider-group-title dg-lg q-display-none-at-md\"> <div class=row> <div class=\"col-md-9 col-md-offset-3\"> <div class=row> <div class=col-md-3> <span class=q-tag> Start Time </span> </div> <div class=col-md-3> <span class=q-tag> End Time </span> </div> </div> </div> </div> </div> {%= shiftEditRows %} </div> </div> </div> <div class=\"q-footer q-no-border-top\"> <div class=\"q-footer-btn-group q-pull-right-til-md\"> <a href=# class=\"base-btn purple-btn v2-btn q-block-at-md q-text-center cancel-edit-dock-btn\">Cancel</a> <a href=# class=\"base-btn purple-btn q-block-at-md q-text-center submit-edit-dock-btn\">Save Dock</a> </div> </div> </div> </div> </form>";

/***/ },
/* 1289 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl id=door-edit-details-section> <h2 class=q-section-title> <span>Door Details</span> </h2> <div class=divider-group-title> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Door Name * </label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch required\" placeholder=\"Enter door name\" value=\"{%- optional.doorName %}\" data-error-placement-append-closest=div name=door-edit-name /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Door Uses * </label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select editDoorUses required\" style=width:100% data-s2-minimum-results-for-search=Infinity value=\"{%- optional.doorUses %}\" data-error-placement-append-closest=div name=door-edit-uses id=editDoorUses> <option value=\"Inbound and Outbound\">Inbound and Outbound</option> <option value=\"Outbound only\">Outbound only</option> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Appointment Types Accepted * </label> </div> <div class=\"col-md-9 col-xs-12\"> <div class=appointment-types-accepted> <select class=\"select2-select required\" style=width:100% multiple=multiple data-s2-minimum-results-for-search=Infinity value=\"{%- optional.doorAppts.join(',') %}\" data-s2-placeholder=\"Select all appointment types this dock is capable of processing\" data-error-placement-append-closest=div name=door-edit-appointment-types> </select> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1290 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pct-body q-pad-left-til-md\" id=\"doorDetails-{%-toggle%}\"> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-5 col-xs-12\" id=doorDetailsDoorName> <span class=q-tag name=doordetails-doorname> {%- doorDetails.doorName %} </span> <input type=text class=\"q-input q-stretch hidden\" id=doorDetailsDoorNameValue name=doorDetailsDoorNameValue value=\"{%- doorDetails.doorName %}\"/> </div> <div class=\"col-md-7 col-xs-12\"> <span class=q-tag name=doordetails-dooruses> {%- doorDetails.doorUses %}</span> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <span class=q-tag> Appointments Accepted: </span> </div> <div class=\"col-md-7 col-xs-12\"> <span class=q-tag name=doordetails-doorappts> {%- doorDetails.doorAppts %} </span> <input type=text class=\"q-input q-stretch hidden\" id=doorDetailsDoorApptsValue name=doorDetailsDoorApptsValue value=\"{%- doorDetails.doorAppts %}\"/> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1291 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-vert-md {%- dockDetails %} \" id=\"docDisplayDetails-{%-toggle%}\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-pad-all-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\" name=dock-name> {%- dockName %}</span> </div> </div> <div class=\"col-md-5 col-xs-12 q-fs-lg q-text-center-at-md\"> <div class=\"q-marg-vert-xxs q-marg-horz q-pull-right-til-md q-marg-vert-md-at-md dock-info\"> <a href=# id=\"remove-dock-btn-{%- toggle%}\" class=\"base-btn purple-btn v2-btn q-text-center q-stretch-at-md q-marg-bottom-sm-at-md remove-dock-btn\" data-index-id=\"{%- toggle %}\"> Remove </a> <a class=\"base-btn purple-btn q-marg-left-xxs-til-md q-text-center q-stretch-at-md edit-dock-btn\" data-index-id=\"{%- toggle %}\"> Edit </a> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=\".{%- togglerTarget %}\" data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"{%- togglerTarget %} q-expandable-default\"> <div class=\"q-pct-body q-pad-left-til-md\"> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-marg-bottom-md q-marg-top-md-at-md\"> <div class=row> <div class=col-xs-12> <span class=q-tag> Operational Schedule (ET): </span> </div> </div> </div> <div name=operational-times-area> {%= timehtml %} </div> </div> </div> </div> </div> <div class=\"q-pct-body q-pad-left-til-md\"> <div class=\"q-pad-horz-md q-pad-vert-lg\"> <div class=\"q-marg-bottom-md q-marg-top-md-at-md\"> <div class=row> <div class=col-xs-12> <span class=q-tag> Dock Doors </span> </div> </div> </div> </div> </div> {%= doordetailshtml %} </div> </div>";

/***/ },
/* 1292 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-md name=operational-shift-times-summary> <div class=row> <div class=\"col-md-4 col-xs-12\"> <span class=q-tag> {%- day%} : </span> </div> <div class=\"col-md-8 col-xs-12\"> {%= time %} </div> </div> </div>";

/***/ },
/* 1293 */
/***/ function(module, exports) {

	module.exports = "<a href=# class=dock-details>{%-  dockDoorEditName %} </a>";

/***/ },
/* 1294 */
187,
/* 1295 */
26,
/* 1296 */
27,
/* 1297 */
30,
/* 1298 */
295,
/* 1299 */
/***/ function(module, exports) {

	module.exports = "<form id=planned-operational-closures> <div class=\"divider-group dg-lg {%- closureDate %} remove-date-details\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=q-marg-top-xs> <span class=q-tag> {%= plannedClosureDate%} </span> </div> </div> <div class=\"col-md-9 col-xs-12 large-text-toggle-parent\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-top-xs q-boldest\"> <span class=\"\"> Closed full 24 hours </span> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no q-marg-top-xs-at-md\"> <input name=largeSwitcheryTextInputName id=\"closure-full-day-{%- arrayIndex%}\" name=edit-master-schedule type=checkbox class=\"js-switchery quick-toggler edit-master-toggle\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-unchecked=true data-quick-toggler-closest=.large-text-toggle-parent data-quick-toggler-target=.large-text-toggle-target value=\"{%- closureDate.isClosureFullDay%}\"/> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-top-md-at-md q-pull-right-til-md\"> <a href=# id=\"remove-date-btn-{%- toggleForClosure%}\" class=\"base-btn purple-btn v2-btn q-text-center q-stretch-at-md q-marg-bottom-sm-at-md remove-date-btn\" data-index-id=\"{%- toggleForClosure %}\"> Remove Date </a> </div> </div> </div> <div class=large-text-toggle-target> <div class=\"q-marg-vert-md q-alert q-alert-grey\"> Set hours within in normal operations hours which the dock will be close. </div> {%= closureTimes %} </div> </div> </div> </div> </form>";

/***/ },
/* 1300 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-top-md id=\"closure-edit-time-{%- closureIndex%}\" name=closure-edit-time> <div class=q-grid> <div class=\"q-input-group q-input-group-connected no-pad-bottom q-row q-input-group-connected-break-at-sm time-picker-area q-marg-top-xs-at-md\"> <div class=\"q-input-group-connected-inner q-input-first q-static-col-3 q-input-first time-picker-area\"> <div class=q-marg-all-md> <span class=q-tag> Close Start Time </span> </div> <div class=time-picker-from value=\"{%- closureTime.closureShiftStartTime%}\"> </div> </div> <div class=\"q-input-group-connected-inner q-static-col\"> <div class=\"q-sim-input q-no-border\"> </div> </div> <div class=\"q-input-group-connected-inner q-input-last q-static-col-3 q-input-last\"> <div class=q-marg-all-md> <span class=q-tag> Close End Time </span> </div> <div class=time-picker-to value=\"{%- closureTime.closureShiftEndTime%}\"> </div> </div> </div> </div> </div>";

/***/ },
/* 1301 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group dg-lg day-shift-row\" data-day-of-week=\"{%- day.toLowerCase() %}\"> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=\"q-alert-d q-alert-red q-display-none\"> Time blocks cannot overlap. </div> </div> </div> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox value=\"\" name=dayOfTheWeekCheck class=day-of-week-checkbox /> <span class=\"cb-label-inner q-boldest\"> {%- day %} </span> </label> </div> </div> <div class=\"col-md-9 col-xs-12\"> <div class=\"time-picker-area q-marg-top-xs-at-md\" data-day-of-week=\"{%- day.toLowerCase() %}\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-display-none q-block-at-md\">Start Time</span> <div class=time-picker-from> </div> </div> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-display-none q-block-at-md\">End Time</span> <div class=time-picker-to> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=q-marg-top-xs-at-md> <a href=# class=\"base-btn purple-btn addTime-block-btn disabled default-addTime-block-btn\">Add Time Block</a> </div> </div> </div> </div> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=\"q-alert q-alert-red q-display-none\"> End time cannot be before start time. </div> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=\"q-alert-t q-alert-red q-display-none\"> Each selected day requires at least one time block. </div> </div> </div> </div>";

/***/ },
/* 1302 */
1281,
/* 1303 */
1282,
/* 1304 */
/***/ function(module, exports) {

	module.exports = "<form class=edit-appointment-scheduling-form id=edit-appointment-scheduling-form> <div class=\"q-default-base q-max-page-width-md q-page-center-margin\"> <div class=\"q-card q-card-white\"> <div class=q-main-header> <div class=row> <div class=col-xs-12> <div class=q-inline-block-til-md> <div class=\"q-border-bottom-at-md q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"> <i class=\"fa fa-sliders q-icon-marg-right\" aria-hidden=true></i> Appointment Scheduling </h2> </div> </div> </div> </div> </div> <div class=\"q-section q-border-top master-togglable-target\"> <div class=q-marg-all-xl> <h2 class=q-section-title> Master Appointment Schedule </h2> <div class=q-marg-vert-md> Select the days of the week that the facility doors will be operational and open for appointments. All doors for this dock will follow the same schedule unless edited individually. </div> <div class=q-marg-vert-md> <div class=\"divider-group divider-group-title dg-lg q-display-none-at-md\"> <div class=row> <div class=\"col-md-9 col-md-offset-3\"> <div class=row> <div class=col-md-3> <span class=q-tag> Start Time </span> </div> <div class=col-md-3> <span class=q-tag> End Time </span> </div> </div> </div> </div> </div> {%= shiftRows %} </div> </div> </div> <div class=q-section> {%= plannedOperationClosure %} </div> <div class=\"q-footer q-no-border-top\"> <div class=\"q-footer-btn-group q-pull-right-til-md\"> <a href=# class=\"base-btn purple-btn v2-btn q-text-center q-block-at-md cancel-schedule-btn\">Cancel</a> <a href=# class=\"base-btn purple-btn q-text-center q-block-at-md submit-schedule-btn\">Save</a> </div> </div> </div> </div> </form>";

/***/ },
/* 1305 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row q-marg-top-md new-shift\"> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-display-none q-block-at-md\">Start Time</span> <div class=time-picker-from> </div> </div> <div class=\"col-md-3 col-xs-12\"> <span class=\"q-tag q-display-none q-block-at-md\">End Time</span> <div class=time-picker-to> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-top-xs-at-md> <a href=# class=\"base-btn purple-btn q-marg-right-xs new-shift-add-shift-btn disabled\">Add Time Block</a> <a href=# class=\"base-btn purple-btn v2-btn remove-shift-btn\">Remove</a> </div> </div> </div>";

/***/ },
/* 1306 */
/***/ function(module, exports) {

	module.exports = "<a id=changeStatus href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn\"> {%- facStatus %} </a> <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn editButton\"> <i class=\"fa fa-pencil q-icon-marg-right\"></i> Edit </a>";

/***/ },
/* 1307 */
/***/ function(module, exports) {

	module.exports = "<div> <div class=\"divider-group dg-no-top-border\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>{%- item.cdmMeaning %}</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12\"> <div class=row> <div class=col-md-2> {%= isOn %} </div> <div class=\"col-md-10 q-marg-top-xxxs\"> {%- item.cdmDescription %} </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1308 */
/***/ function(module, exports) {

	module.exports = "<div id=rmscasaccount class=q-marg-vert-lg> <div class=row> <div class=col-md-3> <label class=\"q-label q-boldest q-fs-sm\">CAS Account Number</label> </div> <div class=col-md-6> <select class=\"select2-select q-input fedex-cas-acct-num-location\" name=rmsCasAccountDetails data-minimum-results-for-search=Infinity data-error-placement-append-closest=div style=width:100% id=rms-cas-account value=\"{%- optional.ccaCasAccountnNumber %}\" data-placeholder=\"Select a Cas Account for this facility\"> <option></option> {%= rmsCasAccountDetails %} <select> </select></select></div> </div> </div>";

/***/ },
/* 1309 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Facility Type *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select q-input rms-facility-type required\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select the type of facility\" data-s2-minimum-results-for-search=5 id=rms-facility-type name=facilityType> <option></option> {%= rmsFacilityTypes %} </select> </div> </div> </div> <div class=\"clearfix q-block-quote-row q-pad-horz-at-md if-vendor-returned q-no-pad-right q-marg-top-xl-at-md vendorSelectAuthorization\"> <div class=q-marg-bottom-xl> <div class=q-marg-vert-md> <div class=\"row togglable-parent\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Return Authorization Required</label> </div> <div class=\"col-md-2 col-xs-12 q-marg-bottom-md-at-md\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input id=return-auth-req type=checkbox name=return-auth-req class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.togglable-parent data-quick-toggler-target=.togglable-target /> </div> </div> <div class=\"col-md-2 co-xs-12 if-return-auth-req togglable-target\"> <label class=q-label for=standing-ra-number id=stndRaLabel>Standing RA Number</label> </div> <div class=\"col-md-5 co-xs-12 if-return-auth-req togglable-target\"> <input type=text id=stndNumber class=\"q-input q-stretch\" name=stndNumber placeholder=\"Standing RA (Optional)\"/> </div> </div> </div> </div> </div> <div class=q-marg-vert-lg> <div class=row> <div class=col-md-3> <label class=\"q-label q-boldest q-fs-sm\">Facility FedEx Account *</label> </div> <div class=col-md-6> <select class=\"select2-select q-input fedex-acct-num-location required\" name=rmsFedexAccounts data-minimum-results-for-search=Infinity data-error-placement-append-closest=div style=width:100% id=rms-fedex-account value=\"{%- optional.cadCmtId %}\" data-placeholder=\"Select a FedEx Account for this facility\"> <option></option> {%= rmsFedexAccounts %} <select> </select></select></div> </div> </div> <div class=q-marg-vert-lg> <div class=\"row ship-to-address-row\"> <div class=col-md-3> <label class=\"q-label q-boldest q-fs-sm\">Ship to Address *</label> </div> <div class=col-md-6> <select class=\"select2-select q-input ship-to-address required\" name=shipToAddress data-minimum-results-for-search=Infinity data-error-placement-append-closest=div style=width:100% id=ship-to-address value=\"\" data-placeholder=\"Select a Ship to Address\"> <option></option> {%= shipToAddress %} <select> </select></select></div> </div> </div> {%= rmsCasAccountDetails %}";

/***/ },
/* 1310 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Country *</label> </div> <div class=\"col-md-3 col-xs-12\"> <select class=\"select2-select q-input facility-country required\" id=facility-country name=facility-country style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Country\" data-s2-minimum-results-for-search=5 value=\"{%- optional.cadCountry %}\"> {%=countries%} </select> </div> </div> </div> <div class=\"q-marg-vert-lg country-not-supported-primary\" style=display:none> <div class=row> <div class=\"col-md-3 col-xs-12\"> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-yellow q-alert-pad-all-sm q-text-left\"> <p> Country not supported for Address Validation </p> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input type=text id=facility-address1 name=facility-address1 data-error-placement-append-closest=div class=\"q-input q-stretch required\" placeholder=Address value=\"{%- optional.cadAddress1 %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-offset-3 col-md-9 col-xs-12\"> <input type=text id=facility-address2 name=facility-address2 class=\"q-input q-stretch\" placeholder=\"Address Line 2 (Optional)\" value=\"{%- optional.cadAddress2 %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=facility-city name=facility-city data-error-placement-append-closest=div class=\"q-input q-stretch required\" placeholder=City value=\"{%- optional.cadCity %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label state-label\">State/Province/Region *</label> </div> <div class=\"col-md-4_5 col-xs-12 facility-state-wrapper\"> <select class=\"quick-toggler facility-state required\" style=width:100% id=facility-state name=facility-state data-error-placement-append-closest=.facility-state-wrapper data-s2-placeholder=\"Select State/Province/Region\" data-s2-minimum-results-for-search=5 value=\"{%- optional.cadState %}\"><option disabled=disabled selected=selected value=\"\">Select State/Province</option> </select> </div> <div class=\"facility-stateText-wrapper col-md-6 col-xs-12\" style=display:none> <input class=\"q-input q-stretch\" maxlength=40 id=facility-stateText name=stateText data-s2-placeholder=\"Select State/Province/Region\" type=text data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label facility-zip-label\">Postal Code *</label> </div> <div class=\"col-md-3 col-xs-12\"> <input type=text id=facility-zip name=facility-zip data-error-placement-append-closest=div class=\"q-input q-stretch\" placeholder=\"Postal Code\" value=\"{%- optional.cadZipcode %}\"/> </div> </div> </div>";

/***/ },
/* 1311 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Contact Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=contact-name data-error-placement-append-closest=div name=contact-name class=\"q-input q-stretch required\" placeholder=\"Contact Name\" value=\"{%- optional.cadContactName %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone Number *</label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <select class=\"select2-select facility-phone-code q-input required\" style=width:100% id=phone-code name=phone-code data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" value=\"{%- optional.cadContactCountryPhoneCode %}\" data-s2-minimum-results-for-search=5> {%=phoneCodes%} </select> </div> <div class=\"col-md-3 col-xs-12\"> <input type=text class=\"q-input stretch phone-number phoneUS required\" id=phone-number data-error-placement-append-closest=div name=phone-number value=\"{%- optional.cadContactPhone %}\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Email Address *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=email-id name=email-id data-error-placement-append-closest=div class=\"q-input q-stretch required email\" placeholder=\"Email Address\" value=\"{%- optional.cadContactEmail %}\"/> </div> </div> </div>";

/***/ },
/* 1312 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Facility Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=facility-name name=facility-name class=\"q-input q-stretch required facility-name\" placeholder=\"Facility Name\" data-error-placement-append-closest=div value=\"{%- optional.cadLocationName %}\"/> <label class=\"q-sim-error dup-facName\" style=display:none> {%- dupFacName %} </label> </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Facility ID</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text id=facility-id name=facility-id class=\"q-input q-stretch name facility-id\" placeholder=\"Facility ID\" data-error-placement-append-closest=div value=\"{%- optional.cadAddressId%}\"/> <label class=\"q-sim-error dup-facId\" style=display:none> {%- dupFacId %} </label> </div> </div> </div> {%= optional.rmsFacilityTypes %}";

/***/ },
/* 1313 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=\"q-title q-fw-normal\">Facility Type *</h2> </div> <div class=q-marg-vert-md> <div class=q-marg-vert-xl id=errorMessageForCheckbox> <div class=\"q-alert q-marg-bottom-xl q-alert-red\"> At least one facility type should be selected. </div> </div> <div class=\"divider-group divider-group-title dg-no-pad-horz\"> <h4 class=\"q-title q-skinnier\"> Please select all of the functions of this facility. This information will be used throughout the platform. </h4> </div> {%=facilityTypes%} </div> </div> </div>";

/***/ },
/* 1314 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <form id=master-form> <div class=\"q-section master-form\"> <div class=\"q-marg-horz-xl q-marg-vert-lg\"> <h2 class=\"q-title q-fw-normal\"> <div class=row> <div class=\"col-xs-8 q-marg-vert-xxxs\"> {%- facilityName %} </div> </div> </h2> </div> <div class=q-section> <div class=\"q-marg-bottom-xl q-marg-horz-xl\"> {%= facilityDetails %} </div> </div> {%= optional.facilityType %} <div class=\"q-section address-section\"> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=\"q-title q-fw-normal\">Facility Address</h2> </div> {%= facilityAddress %} </div> </div> <div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=\"q-title q-fw-normal\">Facility Contact</h2> </div> {%= facilityContact %} </div> </div> {%= optional.inboundClassification %} </div> </form> </div>";

/***/ },
/* 1315 */
/***/ function(module, exports) {

	module.exports = "<div id=inboundClassification class=q-section> <div class=q-marg-all-xl> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h3 class=\"q-title q-fw-normal\">Inbound Classifications</h3> </div> <div class=q-marg-vert-xl> <div class=\"q-alert q-alert-grey\">Please specify the inbound classifications for this location. The classifications for this facility will be used for returns address steering.</div> </div> <div class=q-marg-vert-md> {%= inboundClassificationTypes %} </div> </div> </div> </div>";

/***/ },
/* 1316 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-max-page-width-md q-default-base q-default\"> <div class=\"q-card q-card-white\"> <div class=\"q-main-header clearfix\"> <div class=\"q-inline-block-til-md q-text-center-at-md\"> <div class=\"q-border-bottom-at-md q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"> <i class=\"fa fa-building q-icon-marg-right\"></i> {%- data.cadLocationName %} </h2> </div> </div> <div class=q-pull-right-til-md> <div class=\"q-main-header-actions-container q-text-right-til-md q-text-center-at-md\"> <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn v2-btn backToList\"> Back to List </a> <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn configSupplyChainBtn\"> Configure </a> </div> </div> </div> {%= details %} </div> </div>";

/***/ },
/* 1317 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-max-page-width-md q-default-base q-default\"> <div class=\"q-card q-card-white\"> <div class=\"q-main-header clearfix\"> <div class=\"q-inline-block-til-md q-text-center-at-md\"> <div class=\"q-border-bottom-at-md q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"> <i class=\"fa fa-building q-icon-marg-right\"></i> {%- data.cadLocationName %} </h2> <span class=\"q-pill q-pill-detail {%- statusPillClass %}\">{%- facStatusForPill %}</span> </div> </div> <div class=q-pull-right-til-md> <div class=\"q-main-header-actions-container q-text-right-til-md q-text-center-at-md\"> <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn v2-btn backToList\"> Back to List </a> {%= iseditPersmission %} </div> </div> </div> {%= details %} </div> </div>";

/***/ },
/* 1318 */
/***/ function(module, exports) {

	module.exports = "<div> <div class=\"divider-group dg-no-top-border\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>{%- fTypes.cdmMeaning %}:</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12\"> <div class=row> <div class=col-md-2> {%= isOn %} </div> <div class=\"col-md-10 q-marg-top-xxxs\"> {%- fTypes.cdmDescription %} </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1319 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=\"q-marg-horz-xl q-marg-top-xl q-marg-bottom-md\"> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Details\"> <span>Facility Details</span> {%= editPencil %} </a> </h2> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Organization Name:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadOrganizationName %} </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility Name:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadLocationName %} </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility Type:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- facilityTypeForHoneyComb %} </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility Id:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadAddressId %} </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-overflow-hidden> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-all-xl> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Address\"> <span>Facility Address</span> {%= editPencil %} </a> </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Address:</span> </div> <div class=\"col-md-6 col-xs-12\"> <div> {%- data.cadAddress1 %} </div> <div> {%- optional.data.cadAddress2 %} </div> <div> {%- data.cadCity %}, {%- data.cadState %} {%- data.cadZipcode %} </div> <div> {%- country %} </div> </div> </div> </div> </div> <div class=\"solo-divider ds-bottom-at-md ds-grey\"></div> <div class=\"solo-divider ds-pulled-full-height ds-right-til-md ds-full-height ds-grey\"></div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-all-xl> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Contact\"> <span>Facility Contact</span> {%= editPencil %} </a> </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Name:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadContactName %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Email:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadContactEmail %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Phone Number:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadContactCountryPhoneCode %} {%- data.cadContactPhone %} </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1320 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section id=inboundClassificationsSection> <div class=q-marg-all-xl> <div class=q-expandable-header> <h2 class=\"q-expandable-title q-fw-normal\"> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Inbound Classifications\"> <span>Inbound Classifications</span> <i class=\"fa fa-pencil q-icon-marg-left q-icon-md\" aria-hidden=true></i> </a> </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.inbound-classifications data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"q-expandable-default-start-open q-expandee-open inbound-classifications\"> <div class=\"q-marg-top-xl q-marg-horz-xs\"> <h4 class=q-fw-normal>Facility Inbound Classifications</h4> </div> {%= classificationType %} </div> </div> </div>";

/***/ },
/* 1321 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=\"q-marg-horz-xl q-marg-top-xl q-marg-bottom-md\"> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Details\"> <span>Facility Details</span> {%= editPencil %} </a> </h2> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Organization Name:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadOrganizationName %} </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility Name:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadLocationName %} </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility ID:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadAddressId %} </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Return Point ID:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadId %} </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility Type:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- facilityTypeForRMS %} </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>FedEx Account Number:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- fedExAccountNo %} </div> </div> </div> {%= rmsShipToAddress %} <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>FedEx Hub ID:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- hubId %} </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>CAS Account Number:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- casAccountNumber %} </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-overflow-hidden> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-all-xl> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Address\"> <span>Facility Address</span> {%= editPencil %} </a> </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Address:</span> </div> <div class=\"col-md-6 col-xs-12\"> <div> {%- data.cadAddress1 %} </div> <div> {%- optional.data.cadAddress2 %} </div> <div> {%- data.cadCity %}, {%- data.cadState %} {%- data.cadZipcode %} </div> <div> {%- country %} </div> </div> </div> </div> </div> <div class=\"solo-divider ds-bottom-at-md ds-grey\"></div> <div class=\"solo-divider ds-pulled-full-height ds-right-til-md ds-full-height ds-grey\"></div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-all-xl> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Contact\"> <span>Facility Contact</span> {%= editPencil %} </a> </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Name:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadContactName %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Email:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadContactEmail %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Phone Number:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadContactCountryPhoneCode %} {%- data.cadContactPhone %} </div> </div> </div> </div> </div> </div> </div> </div> <div class=q-section id=vendorAuthorizationSection> <div class=q-marg-all-xl> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Vendor Authorization Number\"> <span>Vendor Authorization Number</span> {%= editPencil %} </a> </h2> <div class=q-marg-vert-xl> <div class=\"divider-group dg-md\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-top-xxxs-til-md\"> <span class=q-boldest>Vendor Authorization Required:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%= isAuthValueOn %} </div> </div> </div> <div class=\"divider-group dg-lg\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <span class=q-boldest>Standing RA Number:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- stndRaNumber %} </div> </div> </div> </div> </div> </div> {%= inboundClassificationTypes %} ";

/***/ },
/* 1322 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Ship to Address ID:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- cadShipAddressId %} </div> </div> </div>";

/***/ },
/* 1323 */
187,
/* 1324 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section id=fulfillemntTypesSupplyChain> <div class=q-marg-all-xl> <div class=q-expandable-header> <h2 class=\"q-expandable-title q-fw-normal\"> <a class=section-step-title-inner data-target-form=\"\" href=# title=\"Supply Chain Fulfillment\"> <span>Fulfillment</span> </a> </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.supply-chain-fulfillment data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"q-expandable-default-start-open q-expandee-open supply-chain-fulfillment\"> <div class=\"q-marg-top-xl q-marg-horz-xs\"> <h4 class=q-fw-normal>Fulfillment Functionality</h4> </div> {%= facilityType %} </div> </div> </div>";

/***/ },
/* 1325 */
/***/ function(module, exports) {

	module.exports = "<div> <div class=\"divider-group dg-no-top-border\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>Returnable:</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12\"> <div class=row> <div class=col-md-2> {%= isOn %} </div> <div class=\"col-md-10 q-marg-top-xxxs\"> {%- rTypes.cdmDescription %} </div> </div> </div> </div> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>Use own Fedex Account:</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12\"> <div class=row> <div class=col-md-2> {%= isFedexAccountOn %} </div> </div> </div> </div> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>FedEx Account Number:</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12\"> <div class=row> <div class=\"col-md-2 q-marg-top-xs-til-md\"> <span class=\"q-pad-horz-xxs q-marg-horz-md\"> {%- fedExAccountNumber %} </span> </div> </div> </div> </div> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xs-til-md\"> <span class=q-tag>FedEx Hub ID:</span> </div> <div class=\"col-md-9 q-col-spacer col-xs-12\"> <div class=row> <div class=\"col-md-2 q-marg-top-xs-til-md\"> <span class=\"q-pad-horz-xxs q-marg-horz-md\"> {%- fedExHubID %} </span> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1326 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section id=returnTypeSupplyChain> <div class=q-marg-all-xl> <div class=q-expandable-header> <h2 class=\"q-expandable-title q-fw-normal\"> <a class=section-step-title-inner data-target-form=\"\" href=# title=\"Supply Chain Returns\"> <span>Returns</span> </a> </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.supply-chain-returns data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"q-expandable-default-start-open q-expandee-open supply-chain-returns\"> <div class=\"q-marg-top-xl q-marg-horz-xs\"> <h4 class=q-fw-normal>Returns Functionality</h4> </div> {%= returnType %} </div> </div> </div>";

/***/ },
/* 1327 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=\"q-marg-horz-xl q-marg-top-xl q-marg-bottom-md\"> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Details\"> <span>Facility Details</span> </a> </h2> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility Name:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadLocationName %} </div> </div> </div> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility Id:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- data.cadFacId %} </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-overflow-hidden> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-all-xl> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Address\"> <span>Facility Address</span> </a> </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Address:</span> </div> <div class=\"col-md-6 col-xs-12\"> <div> {%- data.cadAddress1 %} </div> <div> {%- optional.data.cadAddress2 %} </div> <div> {%- data.cadCity %}, {%- data.cadState %} {%- data.cadZipcode %} </div> <div> {%- country %} </div> </div> </div> </div> </div> <div class=\"solo-divider ds-bottom-at-md ds-grey\"></div> <div class=\"solo-divider ds-pulled-full-height ds-right-til-md ds-full-height ds-grey\"></div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-all-xl> <h2 class=q-section-title> <a class=\"section-step-title-inner editPencilBtn\" data-target-form=\"\" href=# title=\"Edit Facility Contact\"> <span>Facility Contact</span> </a> </h2> <div class=q-marg-vert-md> <div class=\"q-alert q-marg-vert-lg q-alert-grey\"> <span>For questions, call your dedicated customer success specialist.</span> </div> </div> </div> </div> </div> </div> </div> {%= facilityTypesData %} {%= returnTypesData %}";

/***/ },
/* 1328 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-vert-lg fedex-acct-block\"> <div class=\"q-alert q-alert-grey q-no-pad q-text-left\"> <div class=q-marg-all-md> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-11\"> <label class=q-label>Location Account Number</label> </div> <div class=\"col-md-6 col-xs-10\"> <input type=hidden class=fedex-accnt-hidden-id /> <input type=text placeholder=\"Enter a FedEx Account Number\" class=\"q-input q-stretch fedex-acct-number\"/> </div> <div class=\"col-md-3 col-xs-2\"> <div class=q-pull-right> <a class=remove-fedex-acct-block-btn><i class=\"fa fa-times q-close-btn\"></i></a> </div> </div> </div> </div> <div class=\"q-marg-vert-md if-smartpost-required\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>SmartPost Hub ID</label> </div> <div class=\"col-md-9 col-xs-12\"> <select class=\"select2-select q-input smartpost-acct-number\" data-minimum-results-for-search=5 style=width:100% data-placeholder=\"Select the Smart Post Hub ID Associated to this Account\" data-error-placement-append-closest=div data-s2-allow-clear=true> <option value=\"\">Select the SmartPost Hub ID Associated to this Account</option> </select> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1329 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xs-at-md><a href=\"{%= url %}&cbrId=2\"> {%- name %} </a></div>";

/***/ },
/* 1330 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group fxo-cas-account-wrapper fxo-cas-account-exist\"> <div class=q-remove-btn-group> <div class=row> <div class=\"col-md-5 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md\"> <div class=\"q-boldest q-display-none q-block-at-md\">Fedex CAS Account:</div> <input type=text name=\"\" value=\"\" class=cas-account-no-hidden> <span class=cas-account-no></span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md\"> <div class=\"q-boldest q-display-none q-block-at-md\">Account Type:</div> <input type=hidden name=\"\" value=\"\" class=cas-account-type-hidden> <span class=cas-account-type></span> </div> <div class=\"col-md-2 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md\"> <div class=\"q-boldest q-display-none q-block-at-md\">Service SKU (Required for Full Service):</div> <input type=hidden name=\"\" value=\"\" class=cas-service-sku-hidden> <span class=cas-service-sku></span> </div> <center> <div class=\"col-md-1 col-xs-12 q-col-spacer q-marg-vert-xxs-til-md\"> <div class=\"q-boldest q-display-none q-block-at-md\">Remove:</div> <a href=# class=remove-acct aria-label=Remove> <i class=\"fa fa-times\" aria-hidden=true></i> </a> </div> </center> </div> </div> </div>";

/***/ },
/* 1331 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row q-marg-all-sm\"> <div class=\"col-xs-8 q-no-pad\"> <div> <span><strong>SKU:</strong> {%- optional.dataItem.itmSku %} </span> </div> <div> <span><strong>UPC:</strong> {%- optional.dataItem.itmUpc %} </span> </div> <div> <span><strong>Description:</strong> {%- optional.dataItem.product.prdName %} </span> </div> <div> <span><strong>Model Number:</strong> {%- optional.dataItem.itmModel %} </span> </div> </div> <div class=\"col-xs-4 q-no-pad\"> <a class=\"base-btn purple-btn v2-btn q-pull-right model-add-return-item-btn\" data-item=\"{%- JSON.stringify(optional.dataItem) %}\">Add to Return</a> </div> </div> <hr class=q-no-marg />";

/***/ },
/* 1332 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=\"q-alert q-alert-red\"> Serial number entry is invalid. </div> </div> <div class=q-marg-all-xl> <p>Please make sure you have entered the correct value as the serial number and that it contains no commas (,), periods (.), spaces, and meets the max. character length of 25 characters.</p> <p>No other values other than the serial number will be accepted in this entry.</p> </div> </div>";

/***/ },
/* 1333 */
/***/ function(module, exports) {

	module.exports = "<form name=serial-search-modal-form id=serial-search-modal-form> <div class=q-section> <div class=q-marg-all-xl> <span>The scanned serial number is not recognized in this response. To add the product to this return, search for the item SKU, UPC or Model Number below, or cancel the return.</span> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <div class=\"row text-center\"> <div class=\"col-xs-6 sku_upc_btn\"> <h4><a href=# class=q-boldest><span class=sku_upc_btn_txt>SKU/UPC</span></a></h4> </div> <div class=\"col-xs-6 model_number_btn\"> <h4><a href=# class=q-boldest><span class=model_num_btn_txt>Model Number</span></a></h4> </div> </div> <div class=\"q-marg-vert-xl sku_upc_section\"> <span>Enter the products SKU or UPC below to add to the return.</span> <div class=\"q-input-group-flex-container q-marg-top-md\"> <div class=q-input-group> <input type=text name=sku_upc_section_search_input class=\"q-input q-ig-flex-fill sku_upc_section_search_input\" placeholder=\"Enter SKU / UPC\"/> <a href=# class=\"base-btn purple-btn q-pad-horz-xl sku_upc_section_search\">Search</a> </div> </div> <div class=\"panel panel-default q-marg-top-xl sku_upc_section_panel\"> <div class=panel-heading> <h4 class=panel-title>Found Products</h4> </div> <div class=\"panel-body sku-add-products-container pre-scrollable\"> </div> </div> <div class=\"q-marg-top-xl alert alert-danger alert-dismissible sku-add-product-err\" id=server-error role=alert> No result found. Please search again. </div> </div> <div class=\"q-marg-vert-xl model_number_section\"> <span>Enter the products Model Number to add to the return.</span> <div class=\"q-input-group-flex-container q-marg-top-md\"> <div class=q-input-group> <input type=text name=model_number_section_search_input class=\"q-input q-ig-flex-fill model_number_section_search_input\" placeholder=\"Enter Model Number\"/> <a href=# class=\"base-btn purple-btn q-pad-horz-xl model_number_section_search\">Search</a> </div> </div> <div class=\"panel panel-default q-marg-top-xl model_number_section_panel\"> <div class=panel-heading> <h4 class=panel-title>Found Products</h4> </div> <div class=\"panel-body model-add-products-container\"> </div> </div> <div class=\"q-marg-top-xl alert alert-danger alert-dismissible model-add-product-err\" id=server-error role=alert> No result found. Please search again. </div> </div> </div> </div> </form>";

/***/ },
/* 1334 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=\"q-marg-all-xl q-fs-md\"> Ask the customer if the returning equipment is being sent back to AT&amp;T or Frontier Cable. </div> </div> <div class=q-section> <div class=q-marg-all-xl> <div class=att-step-item> <div class=att-step-item-number> <div class=\"q-circle qc-purple\"> 1 </div> </div> <div class=att-step-item-text> If the returning equipment is being sent back to<span class=q-tag> AT&amp;T</span>, select <span class=q-tag>Continue AT&amp;T Return </span>below. </div> </div> <div class=\"q-marg-top-xl att-step-item\"> <div class=att-step-item-number> <div class=\"q-circle qc-purple\"> 2 </div> </div> <div class=att-step-item-text> If the returning equipment is being sent back to <span class=q-tag>Frontier Cable</span> please advise the customer of the below message and select <span class=q-tag>Cancel Return</span>. </div> </div> <div class=\"q-marg-top-xl att-step-item\"> <div class=att-step-item-number> </div> <div class=\"q-alert q-alert-red att-step-item-text q-text-center q-pad-vert-md q-pad-horz-xl\"> Returns cannot be accepted for Frontier Cable at this time and the customer must contact their cable provider for further details on how to return the equipment. </div> </div> </div> </div>";

/***/ },
/* 1335 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-vert-xl multi-box-paking-sku-div\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-label-top multi-box-paking-sku-label\">[Box {%- boxId %} of {%- totalBoxes %}] Packing SKU*</label> </div> <div class=\"col-md-6 col-xs-12\"> <select style=width:100% data-placeholder=\"Select packaging SKU\" class=\"select2-select q-input multi-box-paking-sku-select required\" id=\"recCasSku{%- (boxId - 1) %}\" name=\"recCasSku[{%- (boxId - 1) %}]\" data-s2-placeholder=\"Select packaging SKU\" data-s2-allow-clear=true data-s2-auto-open-on-clear=false> <option value=\"\">Select packaging SKU</option> {%=packingSkuList%} </select> </div> </div></div>";

/***/ },
/* 1336 */
/***/ function(module, exports) {

	module.exports = "<option value=\"{%-key %}\">{%-value %}</option>";

/***/ },
/* 1337 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red q-pad-vert-md q-pad-horz-xl q-text-center\"> <span class=\"q-boldest q-block\">The serial number entered has been received for this BAN.</span> If you are completing this action to reprint labels/receipts, please go to the Return Lookup and reprint the labels/receipts. </div> </div>";

/***/ },
/* 1338 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-boldest> Please select the total number of boxes needed for this return* </div> <div class=q-marg-top-md> <div class=row> <div class=col-xs-5> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=hidden class=\"q-input q-stretch q-text-right number-of-boxes-input\" id=number-of-boxes-input-hidden name=number-of-boxes-input-hidden data-error-placement-append-closest=.q-input-group placeholder=QTY min=0 value=1 /> <input type=number class=\"q-input q-stretch q-text-right number-of-boxes-input\" id=number-of-boxes name=number-of-boxes data-error-placement-append-closest=.q-input-group placeholder=QTY min=0 value=1 /> <span class=q-ig-units>Boxes</span> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <label class=\"error add-box-modal-error\"></label> </div> </div> </div> </div>";

/***/ },
/* 1339 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-boldest> Please select the total number of poly bags needed for this return* </div> <div class=q-marg-top-md> <div class=row> <div class=col-xs-5> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=hidden class=\"q-input q-stretch q-text-right number-of-poly-bags-input\" id=number-of-poly-bags-hidden name=number-of-poly-bags-hidden data-error-placement-append-closest=.q-input-group placeholder=QTY min=1 value=1 /> <input type=number class=\"q-input q-stretch q-text-right number-of-poly-bags-input\" id=number-of-poly-bags name=number-of-poly-bags data-error-placement-append-closest=.q-input-group placeholder=QTY min=1 value=1 /> <span class=q-ig-units>Poly Bags</span> </div> </div> </div> <div class=col-xs-7> <label class=\"error add-poly-bag-modal-error\"></label> </div> </div> </div> </div>";

/***/ },
/* 1340 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red q-pad-vert-md q-pad-horz-xl\"> You are adding {%- warnDisplay %} or more boxes. The maximum number of boxes is {%- maxDisplay %}. </div> </div>";

/***/ },
/* 1341 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red q-pad-vert-md q-pad-horz-xl\"> You are adding {%- warnDisplay %} or more poly bags. The maximum number of poly bags is {%- maxDisplay %}. </div> </div>";

/***/ },
/* 1342 */
/***/ function(module, exports) {

	module.exports = "<div class=all-warehouses-cell-inner> <div class=q-inline-block> All Warehouses </div> <a href=# class=\"base-btn v2-btn btn-down-arrow q-marg-left-md warehouse-down-btn\"> <i class=\"fa fa-angle-down\" aria-hidden=true></i> </a> </div>";

/***/ },
/* 1343 */
/***/ function(module, exports) {

	module.exports = "<span class=\"q-pill {%- statusClass %} q-pill-table\"> {%- statusText %} </span>";

/***/ },
/* 1344 */
/***/ function(module, exports) {

	module.exports = "<div class=warehouse-child-row-inner> <table class=\"q-table q-table-stretch q-child-table\"> <tbody> {% _(data).each((childRow)=>{ %} <tr class=child-table-row> {% _(columns).each((column)=>{ %} <td style=\"{%= column.style %}\" class=\"{%= column.className %}\"> {%= column.render ? column.render(childRow[column.data], column.data, childRow) : childRow[column.data] %} </td> {% }) %} </tr> {% }) %} </tbody> </table> </div>";

/***/ },
/* 1345 */
/***/ function(module, exports) {

	module.exports = "<form class=edit-location-form action=#> <div class=\"q-section q-no-border-bottom\"> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=q-title>State to location mappings</h2> </div> <div class=q-section> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-4 col-xs-12\"> <label for=\"\" class=q-label>Return type *</label> </div> <div class=\"col-md-8 col-xs-12\"> <input type=text id=returnType name=returnType class=\"q-input q-stretch required\" placeholder=\"Select a return type\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-4 col-xs-12\"> <label for=\"\" class=q-label>Inbound Classification *</label> </div> <div class=\"col-md-8 col-xs-12\"> <select id=inboundClassification name=inboundClassification class=\"select2-select required\" style=width:100% data-error-placement-append-closest=div data-s2-minimum-results-for-search=10 data-s2-placeholder=\"Select an inbound classification\"> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-4 col-xs-12\"> <label for=\"\" class=q-label>Origin State *</label> </div> <div class=\"col-md-8 col-xs-12\"> <select name=originalState id=originalState class=\"select2-select required\" style=width:100% data-error-placement-append-closest=div data-s2-minimum-results-for-search=10 data-s2-placeholder=\"Select a state where a return can be created\"> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-4 col-xs-12\"> <label for=\"\" class=q-label>Ship to Address ID *</label> </div> <div class=\"col-md-8 col-xs-12\"> <select name=shipToAddress id=shipToAddress class=\"select2-select required\" style=width:100% data-error-placement-append-closest=div data-s2-minimum-results-for-search=10 data-s2-placeholder=\"Select the address ID in which to send the return\"> </select> </div> </div> </div> </div> </div> </div> </form> <div class=\"q-section show-on-error\"> <div class=q-marg-all-xl> <div class=\"q-alert q-alert-yellow q-text-center\"> A similar state to location mapping already exists. ghddfg Please make adjustments above and save again. </div> </div> </div>";

/***/ },
/* 1346 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title>{%- sectionTitle %}</h2> {% if (hasSwitchery) { %} <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\">{%- sectionTitle %} shares Primary Account Information</label> </div> <div class=\"col-md-2 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input checked=true name=billing-acct-shares-primary type=checkbox class=\"js-switchery b2b-b2c-togglers switch-share-primary\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.togglable-parent data-quick-toggler-target=.togglable-target /> </div> </div> </div> </div> {% } %} <div class=address-section> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=country class=q-label>Country *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div> <select name=country class=\"select2-select ret-country\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Country\" data-s2-minimum-results-for-search=5 required> <option value=-1 disabled=\"\" selected=\"\">Select Country</option> </select> </div> </div> </div> {% if(primaryphone) { %} <div class=\"q-marg-vert-lg country-not-supported-primary\" style=display:none> <div class=row> <div class=\"col-md-3 col-xs-12\"> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-yellow q-alert-pad-all-sm q-text-left\"> <p> Country not supported for Address Validation </p> </div> </div> </div> </div> {% }  %} {% if(shippingphone) { %} <div class=\"q-marg-vert-lg country_not_supported_shipping\" style=display:none> <div class=row> <div class=\"col-md-3 col-xs-12\"> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-yellow q-alert-pad-all-sm q-text-left\"> <p> Country not supported for Address Validation </p> </div> </div> </div> </div> {% }  %} {% if(billingphone) { %} <div class=\"q-marg-vert-lg country_not_supported_billing\" style=display:none> <div class=row> <div class=\"col-md-3 col-xs-12\"> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-yellow q-alert-pad-all-sm q-text-left\"> <p> Country not supported for Address Validation </p> </div> </div> </div> </div> {% }  %} </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=address1 class=q-label>Street Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> {% if (isMerchant ) { %} <input id=address1 maxlength=50 required class=\"q-input q-stretch ret-address1\" name=address1 type=text placeholder=\"Address 1\"/> {% } else { %} <input id=address1 required class=\"q-input q-stretch ret-address1\" name=address1 type=text placeholder=\"Address 1\"/> {% } %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> </div> <div class=\"col-md-9 col-xs-12\"> {% if (isMerchant ) { %} <input id=address2 maxlength=50 class=\"q-input q-stretch ret-address2\" name=address2 type=text placeholder=\"Address 2 (Optional)\"/> {% } else { %} <input id=address2 class=\"q-input q-stretch ret-address2\" name=address2 type=text placeholder=\"Address 2 (Optional)\"/> {% } %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=city class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> {% if (isMerchant ) { %} <input id=city maxlength=50 class=\"q-input q-stretch ret-city\" required name=city type=text placeholder=City /> {% } else { %} <input id=city class=\"q-input q-stretch ret-city\" required name=city type=text placeholder=City /> {% } %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=state id=state-label class=q-label>State/Province/Region *</label> </div> <div class=\"col-md-6 col-xs-12 state-wrapper\"> <div> <select name=state class=\"select2-select q-input ret-state\" id=state style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select State/Province/Region\" data-s2-minimum-results-for-search=5 required> <option value=-1 disabled=\"\" selected=\"\">Select State/Province/Region</option> </select> </div> </div> <div class=\"col-md-6 col-xs-12 state-text-wrapper\" style=display:none> <div> <input class=\"qw-input stretch ret-state-text\" id=stateText maxlength=40 name=stateText placeholder=State/Province/Region type=text>  </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=postalCode id=postalcode-label class=q-label>Postal Code *</label> </div> <div class=\"col-md-3 col-xs-12\"> <input id=postalCode required class=\"q-input q-stretch ret-zip-code\" name=postalCode type=text placeholder=\"Postal Code\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=county class=\"q-label county-mandatory-label\">County</label> </div> <div class=\"col-md-6 col-xs-12\"> {% if (isMerchant ) { %} <input id=county maxlength=50 class=\"q-input q-stretch ret-county\" name=county type=text placeholder=County /> {% } else { %} <input id=county class=\"q-input q-stretch ret-county\" name=county type=text placeholder=County /> {% } %} </div> </div> </div> <input class=\"q-input q-stretch commercial-addr-flag\" type=hidden /> </div> </div> </div>";

/***/ },
/* 1347 */
/***/ function(module, exports) {

	module.exports = "<div class=details-tab-inner> {%= billingAccountAddressForm %} <div class=\"q-section contact-section\"> <div class=q-marg-all-xl> <h2 class=q-section-title> Billing Contact </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=billingPrefix class=q-label>Name *</label> </div> <div class=\"col-md-1_5 col-xs-12 q-marg-bottom-md-at-md\"> <div> <select name=billingPrefix id=billingPrefix class=\"select2-select q-inpu ret-prefix\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=Prefix data-s2-minimum-results-for-search=Infinity> <option value=-1 disabled=\"\" selected=\"\">Prefix</option> </select> </div> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> {% if (hasMerchent) { %} <input id=billingFirstName maxlength=50 required class=\"q-input q-stretch ret-first-name\" name=billingFirstName type=text placeholder=\"First Name\"/> {% } else { %} <input id=billingFirstName required class=\"q-input q-stretch ret-first-name\" name=billingFirstName type=text placeholder=\"First Name\"/> {% } %} </div> <div class=\"col-md-4_5 col-xs-12 q-marg-bottom-md-at-md\"> {% if (hasMerchent) { %} <input id=billingLastName maxlength=50 required class=\"q-input q-stretch ret-last-name\" name=billingLastName type=text placeholder=\"Last Name\"/> {% } else { %} <input id=billingLastName required class=\"q-input q-stretch ret-last-name\" name=billingLastName type=text placeholder=\"Last Name\"/> {% } %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> {% if (hasMerchent) { %} <label for=billingEmail class=q-label>Email</label> {% } else { %} <label for=billingEmail class=q-label>Email *</label> {% } %} </div> <div class=\"col-md-4_5 col-xs-12\"> {% if (hasMerchent) { %} <input id=billingEmail class=\"q-input q-stretch ret-email email\" name=billingEmail type=text placeholder=Email /> {% } else { %} <input id=billingEmail required class=\"q-input q-stretch ret-email email\" name=billingEmail type=text placeholder=Email /> {% } %} </div> </div> </div> </div> </div> {%= billingAccountPhoneForm %} </div>";

/***/ },
/* 1348 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal fade\" class=confirmation-modal role=dialog> <div class=modal-dialog> <div class=modal-content> <div class=modal-header> <button type=button class=close data-dismiss=modal>&times;</button> <h4 class=modal-title>Submit</h4> </div> <div class=modal-body> Upon the confirmation of this new merchant, they will be sent information regarding the new service with instructions on how to log in to their account and get started. </div> <div class=modal-footer> <button type=button class=\"base-btn purple-btn v2-btn cancel-btn\" data-dismiss=modal>Cancel</button> <button type=button class=\"base-btn purple-btn submit-confirmation-btn\" data-dismiss=modal>Confirm</button> </div> </div> </div> </div>";

/***/ },
/* 1349 */
/***/ function(module, exports) {

	module.exports = "<div class=details-tab-inner> <div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-bottom-xl> <div class=\"q-inline-block-til-md q-marg-top-xxs-til-md q-marg-bottom-md-at-md\"> <h2 class=q-title> Merchant Details </h2> </div> <div class=q-pull-right-til-md> <a href=# class=\"base-btn purple-btn q-block-at-md q-text-center-at-md search-merchant-btn\"> Search Again </a> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=companyName class=q-label>Company Name *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input id=companyName required class=\"q-input q-stretch\" name=companyName type=text placeholder=\"Company Name\" maxlength=100 /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=taxId class=q-label>Tax ID</label> </div> <div class=\"col-md-6 col-xs-12\"> <input id=taxId class=\"q-input q-stretch number\" name=taxId type=text placeholder=\"Tax ID\" maxlength=9 /> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Business Information </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> FSC Business Unit </label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select fsc-business-unit\" style=width:100% data-s2-minimum-results-for-search=Infinity data-s2-placeholder=\"Select a FSC business unit\" data-s2-alloe-clear=true> <option value=\"\"></option> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Customer Business Unit </label> </div> <div class=\"col-md-6 col-xs-12\"> <input class=\"q-input q-stretch customer-business-unit\" type=text placeholder=\"Enter a customer business unit\" maxlength=25 /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Contract Start and End Date </label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"datepicker contract-start-and-end-date\" data-dp-type=range data-dp-unique-identifier=contract-date></div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Contract Type </label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select contract-type\" style=width:100% data-s2-minimum-results-for-search=Infinity data-s2-placeholder=\"Select contact type\" data-s2-alloe-clear=true> <option value=\"\"></option> </select> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Additional Information </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=primaryUrl class=q-label>Primary URL *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input id=primaryUrl required class=\"q-input q-stretch primary-url url\" name=primaryUrl type=text placeholder=\"Primary URL\" maxlength=250 /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=host-system class=q-label>Host system</label> </div> <div class=\"col-md-6 col-xs-12\"> <input id=host-system class=\"q-input q-stretch\" name=host-system type=text placeholder=\"Enter a host system\" maxlength=100 /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Require forward stocking locations </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-on q-switchery-af-text-off q-marg-top-xs-at-md\"> <input name=largeSwitcheryTextInputName type=checkbox class=\"js-switchery quick-toggler require-forward-stocking-locations\" data-js-switchery-color=#3399FF /> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=\"q-marg-all-xl merchant-billing-toggle-parent\"> <div class=q-marg-vert-md> <h2 class=q-section-title> Merchant Billing </h2> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\" for=\"\"> Merchant is Direct Bill? </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no q-marg-top-xs-at-md\"> <input name=largeSwitcheryTextInputName id=merchantDirectBillCheckbox type=checkbox class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.merchant-billing-toggle-parent data-quick-toggler-target=.merchant-billing-toggle-target /> </div> <div id=bothno-message class=col-md-9 style=display:none> <label class=q-sim-error> At any time only one of these two toggles can be turned ON. Get the correct information or error message here. </label> </div> </div> <div id=mbone-affiliated-message class=col-md-9 style=display:none> <label class=q-sim-error> At least one affiliated merchant is required. </label> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\" for=\"\"> Merchant is approved for discounted fuel surcharge billing? </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no q-marg-top-xs-at-md\"> <input name=largeSwitcheryTextInputName id=merchantFuelSurchargeCheckbox type=checkbox class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.merchant-billing-toggle-parent data-quick-toggler-target=.merchant-billing-toggle-target /> </div> <div id=fuelbothno-message class=col-md-9 style=display:none> <label class=q-sim-error> At any time only one of these two toggles can be turned ON. Get the correct information or error message here. </label> </div> </div> <div id=fuelone-affiliated-message class=col-md-9 style=display:none> <label class=q-sim-error> At least one affiliated merchant is required. </label> </div> </div> </div> </div> </div>  <div class=q-section> <div class=\"q-marg-all-xl affiliated-merchant-toggle-parent\"> <div class=q-marg-vert-md> <h2 class=q-section-title> Affiliated Merchant </h2> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\" for=\"\"> Do you have any merchants to assign? </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no q-marg-top-xs-at-md\"> <input name=largeSwitcheryTextInputName id=addMerchantCheckbox type=checkbox class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.affiliated-merchant-toggle-parent data-quick-toggler-target=.affiliated-merchant-toggle-target /> </div> </div> </div> </div> <div class=\"q-marg-vert-md affiliated-merchant-toggle-target\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label for=\"\"> Affiliated Merchant Name * </label> </div> <div class=\"col-md-9 col-xs-12\"> <div class=\"row add-aff-merchant\"> <div class=col-xs-12> <input class=\"q-input q-stretch aff-merchant-name-val\" type=text placeholder=\"Enter merchant name\" maxlength=50 id=aff-merchant-name /> </div> <div id=duplicate-message class=col-md-9 style=display:none> <label class=q-sim-error> Affiliated Merchant Name matches another, please enter a unique name. </label> </div> </div> <div id=one-affiliated-message class=col-md-9 style=display:none> <label class=q-sim-error> At least one affiliated merchant is required. </label> </div> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-md-offset-3 col-xs-12\"> <a href=# class=\"base-btn purple-btn q-block-at-md q-text-center add-merchant-btn\"> Add Affiliated Merchant </a> </div> </div> </div> </div> </div>";

/***/ },
/* 1350 */
/***/ function(module, exports) {

	module.exports = "<div class=divider-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=q-marg-top-xs-til-md> <span class=q-tag>{%- facility.cdmValue %}</span> </div> </div> <div class=\"col-md-9 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large q-marg-top-xs-at-md\"> <input type=checkbox data-error-placement-append-closest=.error-wrapper class=fscFacilityType id=\"{%- facility.cdmMeaning %}{%- optional.arrayIndex  %}\" value=\"{%- facility.cdmMeaning %}\" name=facilityType {%- optional.isChecked %} /> <label for=\"{%- facility.cdmMeaning %}{%- optional.arrayIndex  %}\">{%- facility.cdmDescription %}</label> </div> </div> </div> </div>";

/***/ },
/* 1351 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-xl> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent\"> <div class=q-pct-header> <div class=\"q-pad-horz-lg q-pad-vert-md\"> <span class=\"q-tag q-fs-lg\"> <i class=\"fa fa-building q-icon-lg q-icon-marg-right\" aria-hidden=true></i> {%- facilitiesConfig.facCode %} - {%- facilitiesConfig.facName %} </span> </div> </div> <div class=q-pct-body> <div class=\"q-pad-horz-lg q-pad-vert-md\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <span class=q-tag> Address: </span> </div> <div class=\"col-md-8 col-xs-12\"> <div> {%- facilitiesConfig.facAddressLine1 %},{%- facilitiesConfig.facAddressLine2 %} </div> <div> {%- facilitiesConfig.facCity %}, {%- facilitiesConfig.facState %} {%- facilitiesConfig.facZipcode %} </div> <div> {%- facilitiesConfig.facCountry %} </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"row q-marg-top-md-at-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-tag> Contact: </span> </div> <div class=\"col-md-6 col-xs-12\"> <div> {%- facilitiesConfig.facContactName %} </div> <div> {%- facilitiesConfig.facContactEmail %} </div> <div> {%- facilitiesConfig.facContactPhone %} </div> <div> {%- facilitiesConfig.facContactPhone %} </div> </div> </div> </div> </div> </div> </div> <div class=\"q-pct-header q-pct-secondary-header\"> <div class=q-pct-header-group-main> <div class=row> <div class=col-xs-12> <div class=\"q-pad-vert-md q-pad-horz-lg\"> <strong>Configure Facility Uses</strong> (At least one facility use is required) * <strong class=\"txt-c-red select-atleastone-facuse\">Please select at least one facility use.</strong> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.toggler-facility-usage data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-facility-usage q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-lg q-pad-vert-md q-pad-bottom-xl\"> <div class=\"divider-group divider-group-title\"> <h4 class=q-fw-normal> Facility Uses </h4> </div> {%= facilityTypes %} </div> </div> </div> <div class=\"q-pct-header q-pct-secondary-header\"> <div class=q-pct-header-group-main> <div class=row> <div class=col-xs-12> <div class=\"q-pad-vert-md q-pad-horz-lg\"> <strong>Configure Required Square Footage</strong> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.toggler-facility-sqft data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-facility-sqft q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-lg q-pad-vert-xl\"> <div class=\"row q-display-none-at-md\"> <div class=\"col-md-3 col-xs-4 col-md-offset-3 text-center\"> <label class=q-label>Total Sq. Ft.</label> </div> <div class=\"col-md-3 col-xs-4 text-center\"> <label class=q-label>Available Sq. Ft.</label> </div> <div class=\"col-md-3 col-xs-4 text-center\"> <label class=q-label>Required Sq. Ft.</label> </div> </div> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox value=\"\" name=\"\" class=\"\"/> <span class=\"cb-label-inner q-tag\"> Ambient </span> </label> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Total Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Available Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Required Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> </div> <div class=q-marg-top-md> <div class=\"q-alert q-alert-red\"> The required square footage exceeds the amount that is available at this facility. This may cause issues in the future. </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox value=\"\" name=\"\" class=\"\"/> <span class=\"cb-label-inner q-tag\"> Controlled Room Temperature </span> </label> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Total Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Available Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Required Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox value=\"\" name=\"\" class=\"\"/> <span class=\"cb-label-inner q-tag\"> Cooler </span> </label> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Total Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Available Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Required Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <label> <input type=checkbox value=\"\" name=\"\" class=\"\"/> <span class=\"cb-label-inner q-tag\"> Freezer </span> </label> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Total Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Available Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Required Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> </div> </div> <div class=q-marg-top-lg> <div class=\"divider-group dg-lg dg-no-bottom-border dg-no-pad-horz\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <h4 class=\"q-boldest q-marg-top-xs-til-md\"> TOTAL SQ. FT. </h4> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Total Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Available Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-display-none q-block-at-md q-marg-top-md-at-md\"> <label class=q-label>Required Sq. Ft.</label> </div> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input type=number class=q-input data-dim-connect=\"\" id=\"\" name=\"\" data-error-placement-append-closest=.q-input-group placeholder=\"\" min=0 max=\"\"/> <span class=q-ig-units>sq.ft.</span> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=q-marg-vert-xl> <div class=row> <div class=col-xs-12> <div class=q-pull-right-til-md> <a href=# class=\"base-btn purple-btn v2-btn q-block-at-md q-text-center q-marg-right-md remove-facility-btn\"> Remove Facility </a> <a href=# class=\"base-btn purple-btn q-block-at-md q-text-center q-marg-top-md-at-md add-facility-btn\"> Add Facility </a> </div> </div> </div> </div>";

/***/ },
/* 1352 */
/***/ function(module, exports) {

	module.exports = "<div class=details-tab-inner> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Add FedEx Supply Chain Facilities </h2> <div class=q-marg-vert-md> Select FedEx Supply Chain Facilities from the drop list below and configure each facility's operational uses. </div> <div class=\"q-marg-vert-md facilitiesListDiv\"> <div class=row> <div class=col-xs-12> <select class=select2-select id=facilitieslist style=width:100% data-s2-placeholder=\"Begin typing a Fedex Supply Chain facility name and/or code\"> <option value=\"\"></option> </select> </div> </div> </div> <div class=\"q-marg-vert-xl fsc-bussines-unit-msg\"> <div class=\"q-alert q-alert-red\"> Facility selected has different FSC business unit than customer. </div> </div> <div id=fscfacilitesuses> </div> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Saved Facilities </h2> <div class=q-marg-vert-md> <div class=q-overflow-x-auto> <div class=\"q-overflow-x-hidden q-min-width-sm\"> <table class=\"table q-table q-table-vert-middle q-table-min-height q-table-pad-tds-md\"> <thead> <tr> <th>Facility Name</th> <th>Business Unit</th> <th colspan=2>Operational Uses</th> </tr> </thead> <tbody id=savedfacilities> </tbody> </table> </div> </div> <div class=q-marg-top-md> <div class=\"q-alert q-alert-grey\"> Use the drop down above to add FedEx Supply Chain facilities to this list. </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1353 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section q-pad-vert-xl q-pad-horz-xl phone-section\"> <h2 class=q-section-title> {%- sectionTitle %} </h2> {% if (hasSwitchery) { %} <div class=\"q-marg-vert-md q-marg-bottom-xl\"> <div class=row> <div class=\"col-md-7 col-xs-12\"> <h4 class=\"q-title q-pad-vert-sm\"> {%- sharedAddressSwitchTitle %} </h4> </div> <div class=\"col-md-2 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-on q-switchery-af-text-off\"> <input name=include-packing-slip type=checkbox class=\"js-switchery b2b-b2c-togglers\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.togglable-parent data-quick-toggler-target=.togglable-target /> </div> </div> </div> </div> {% } %} {% if (canAllowFedexToCall) { %} <div class=q-marg-vert-md> <div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=fedex-can-call class=fedex-can-call value=1 name=fedex-can-call /> <label class=q-label for=fedex-can-call>Okay for FedEx to Call</label> </div> </div> {% } %} <div class=q-marg-vert-md> <div class=\"divider-group divider-group-title\"> <h4 class=\"q-title q-skinnier\"> Phone Numbers </h4> </div> <div class=\"divider-group q-no-pad\"> <div class=\"q-marg-horz-xs q-marg-vert-md\"> <div class=q-remove-btn-group> {% if(primaryphone) { %} <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=phoneType1 class=q-label>Office Phone <span class=nobreak>Number *</span></label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <select name=CountryCode class=\"select2-select q-input ret-office-country-code\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=Infinity required> <option value=-1 disabled=\"\" selected=\"\">Select Country Code</option> </select> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <div class=\"q-input-group-flex-container error-msg-wrapper\"> <div class=\"q-input-group q-ig-multi-fields\"> <input type=text class=\"q-input q-igm-field q-ig-static-80 ret-office-area-code\" data-dim-connect=1 id=retailerAreaCodeOffice name=retailerAreaCodeOffice data-error-placement-append-closest=.error-msg-wrapper placeholder=(___) required/> <input type=text class=\"q-input q-igm-field q-stretch ret-office-phone ret-phone-number-jqv\" data-dim-connect=1 id=retailerPhoneOffice name=retailerPhoneOffice required data-error-placement-append-closest=.error-msg-wrapper /> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> {% if (isMerchant ) { %} <input id=phoneExt1 maxlength=20 class=\"q-input q-stretch ret-office-ext\" name=phoneExt1 type=text placeholder=\"Ext. (Optional)\"/> {% } else { %} <input id=phoneExt1 class=\"q-input q-stretch ret-office-ext\" name=phoneExt1 type=text placeholder=\"Ext. (Optional)\"/> {% } %} </div> </div> {% }  %} {% if(shippingphone){ %} <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=phoneType1 class=q-label>Office Phone <span class=nobreak>Number *</span></label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <select name=CountryCode class=\"select2-select q-input ret-office-country-code-ship\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=Infinity required> <option value=-1 disabled=\"\" selected=\"\">Select Country Code</option> </select> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <div class=\"q-input-group-flex-container error-msg-wrapper\"> <div class=\"q-input-group q-ig-multi-fields\"> <input type=text class=\"q-input q-igm-field q-ig-static-80 ret-office-area-code-ship\" data-dim-connect=1 id=retailerAreaCodeOffice name=retailerAreaCodeOffice data-error-placement-append-closest=.error-msg-wrapper placeholder=(___) required/> <input type=text class=\"q-input q-igm-field q-stretch ret-office-phone-ship ret-phone-number-jqv\" data-dim-connect=1 id=retailerPhoneOffice name=retailerPhoneOffice required data-error-placement-append-closest=.error-msg-wrapper /> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> {% if (isMerchant ) { %} <input id=phoneExt1 maxlength=20 class=\"q-input q-stretch ret-office-ext\" name=phoneExt1 type=text placeholder=\"Ext. (Optional)\"/> {% } else { %} <input id=phoneExt1 class=\"q-input q-stretch ret-office-ext\" name=phoneExt1 type=text placeholder=\"Ext. (Optional)\"/> {% } %} </div> </div> {% }  %} {% if(billingphone) { %} <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=phoneType1 class=q-label>Office Phone <span class=nobreak>Number *</span></label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <select name=CountryCode class=\"select2-select q-input ret-office-country-code-bill\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=Infinity required> <option value=-1 disabled=\"\" selected=\"\">Select Country Code</option> </select> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <div class=\"q-input-group-flex-container error-msg-wrapper\"> <div class=\"q-input-group q-ig-multi-fields\"> <input type=text class=\"q-input q-igm-field q-ig-static-80 ret-office-area-code-bill\" data-dim-connect=1 id=retailerAreaCodeOffice name=retailerAreaCodeOffice data-error-placement-append-closest=.error-msg-wrapper placeholder=(___) required/> <input type=text class=\"q-input q-igm-field q-stretch ret-office-phone-bill ret-phone-number-jqv\" data-dim-connect=1 id=retailerPhoneOffice name=retailerPhoneOffice required data-error-placement-append-closest=.error-msg-wrapper /> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> {% if (isMerchant ) { %} <input id=phoneExt1 maxlength=20 class=\"q-input q-stretch ret-office-ext\" name=phoneExt1 type=text placeholder=\"Ext. (Optional)\"/> {% } else { %} <input id=phoneExt1 class=\"q-input q-stretch ret-office-ext\" name=phoneExt1 type=text placeholder=\"Ext. (Optional)\"/> {% } %} </div> </div> {% }  %} </div> </div> {% if(primaryphone) { %} <div class=\"q-marg-horz-xs q-marg-vert-md ret-mobile-number-section\"> <div class=q-remove-btn-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=phoneType1 class=q-label>Mobile Phone Number</label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <select name=CountryCode class=\"select2-select q-input ret-mobile-country-code\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=Infinity> <option value=-1 disabled=\"\" selected=\"\">Select Country Code</option> </select> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <div class=\"q-input-group-flex-container error-msg-wrapper\"> <div class=\"q-input-group q-ig-multi-fields\"> <input type=text class=\"q-input q-igm-field q-ig-static-80 ret-mobile-area-code\" data-dim-connect=1 id=retailerAreaCodeMobile name=retailerAreaCodeMobile data-error-placement-append-closest=.error-msg-wrapper placeholder=(___) /> <input type=text class=\"q-input q-igm-field q-stretch ret-mobile-phone ret-phone-number-jqv\" data-dim-connect=1 id=retailerPhoneMobile name=retailerPhoneMobile data-error-placement-append-closest=.error-msg-wrapper /> </div> </div> </div> </div> <div class=\"q-rbg-remove-btn remove-mobile-btn\"> <a class=\"q-close-btn q-pull-right\"><i class=\"fa fa-times\"></i></a> </div> </div> </div> {% }  %} {% if(shippingphone){ %} <div class=\"q-marg-horz-xs q-marg-vert-md ret-mobile-number-section\"> <div class=q-remove-btn-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=phoneType1 class=q-label>Mobile Phone Number</label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <select name=CountryCode class=\"select2-select q-input ret-mobile-country-code-ship\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=Infinity> <option value=-1 disabled=\"\" selected=\"\">Select Country Code</option> </select> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <div class=\"q-input-group-flex-container error-msg-wrapper\"> <div class=\"q-input-group q-ig-multi-fields\"> <input type=text class=\"q-input q-igm-field q-ig-static-80 ret-mobile-area-code-ship\" data-dim-connect=1 id=retailerAreaCodeMobile name=retailerAreaCodeMobile data-error-placement-append-closest=.error-msg-wrapper placeholder=(___) /> <input type=text class=\"q-input q-igm-field q-stretch ret-mobile-phone-ship ret-phone-number-jqv\" data-dim-connect=1 id=retailerPhoneMobile name=retailerPhoneMobile data-error-placement-append-closest=.error-msg-wrapper /> </div> </div> </div> </div> <div class=\"q-rbg-remove-btn remove-mobile-btn\"> <a class=\"q-close-btn q-pull-right\"><i class=\"fa fa-times\"></i></a> </div> </div> </div> {% }  %} {% if(billingphone) { %} <div class=\"q-marg-horz-xs q-marg-vert-md ret-mobile-number-section\"> <div class=q-remove-btn-group> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=phoneType1 class=q-label>Mobile Phone Number</label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <select name=CountryCode class=\"select2-select q-input ret-mobile-country-code-bill\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=Infinity> <option value=-1 disabled=\"\" selected=\"\">Select Country Code</option> </select> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <div class=\"q-input-group-flex-container error-msg-wrapper\"> <div class=\"q-input-group q-ig-multi-fields\"> <input type=text class=\"q-input q-igm-field q-ig-static-80 ret-mobile-area-code-bill\" data-dim-connect=1 id=retailerAreaCodeMobile name=retailerAreaCodeMobile data-error-placement-append-closest=.error-msg-wrapper placeholder=(___) /> <input type=text class=\"q-input q-igm-field q-stretch ret-mobile-phone-bill ret-phone-number-jqv\" data-dim-connect=1 id=retailerPhoneMobile name=retailerPhoneMobile data-error-placement-append-closest=.error-msg-wrapper /> </div> </div> </div> </div> <div class=\"q-rbg-remove-btn remove-mobile-btn\"> <a class=\"q-close-btn q-pull-right\"><i class=\"fa fa-times\"></i></a> </div> </div> </div> {% }  %} </div> </div> <div class=\"q-marg-top-xl add-mobile-number-btn\"> <a class=\"btn base-btn purple-btn\" type=button id=\"\"> Add Mobile Number </a> </div> </div>";

/***/ },
/* 1354 */
/***/ function(module, exports) {

	module.exports = "<div class=details-tab-inner> {% if (!hasMerchent) { %} <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Primary Account Name </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=companyName class=q-label>Company Name *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input id=companyName required class=\"q-input q-stretch company-name\" name=companyName type=text placeholder=\"Company Name\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=taxId class=q-label>Tax ID</label> </div> <div class=\"col-md-9 col-xs-12\"> <input id=taxId class=\"q-input q-stretch tax-id\" name=taxId type=text placeholder=\"Tax ID\"/> </div> </div> </div> </div> </div> {% }%} {%= addressForm1 %} {% if (!hasMerchent) { %} <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Additional Primary Account Information </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=primaryUrl class=q-label>Primary URL *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input id=primaryUrl required class=\"q-input q-stretch primary-url url\" name=primaryUrl type=text placeholder=\"Primary URL\"/> </div> </div> </div> </div> </div> {% if (isCSR) { %} <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Insight Tracking </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\"> Has the merchant signed off for insight tracking ? </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input name=insightFeed id=insightFeedSwitchery type=checkbox class=\"js-switchery b2b-b2c-togglers insight-feed-switch\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.togglable-parent data-quick-toggler-target=.togglable-target /> </div> </div> </div> </div> </div> </div> {% }%}  {% if(rltType === \"HONEYCOMB_RMS\"){ %} <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Merchant Tier </h2> <p>Please check the SOW for the merchant tier. Discounts and DIM divisors are determined by the merchant tier, with the exception of direct bill customers.</p> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Merchant Tier * </label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select merchant-tier\" style=width:100% data-s2-minimum-results-for-search=Infinity data-s2-placeholder=\"Select Merchant Tier\" data-error-placement-append-closest=div required> <option value=-1 disabled=\"\" selected=\"\">Select Merchant Tier</option> </select> </div> </div> </div> </div> </div> {% }%}  {% if (isCSR) { %} <div class=q-section> <div class=\"q-marg-all-xl merchant-billing-toggle-parent\"> <div class=q-marg-vert-md> <h2 class=q-section-title> Merchant Billing </h2> </div> <div class=\"q-marg-vert-md error-alert-fuelSurchrgmsgg\" style=display:none> <div class=row> <div class=\"col-md-offset-3 col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-red q-text-center\"> Please uncheck Fuel Surcharge Discount and try again. </div> </div> </div> </div> <div class=\"q-marg-vert-md error-alert-merbillmsgg\" style=display:none> <div class=row> <div class=\"col-md-offset-3 col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-red q-text-center\"> Please uncheck Direct Bill and try again. </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\" for=\"\"> Merchant is Direct Bill? </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no q-marg-top-xs-at-md\"> <input name=directBillMerchantSwitchery id=directBillMerchantSwitchery type=checkbox class=\"js-switchery quick-toggler direct-bill-switch\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.merchant-billing-toggle-parent data-quick-toggler-target=.merchant-billing-toggle-target /> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\" for=\"\"> Merchant is approved for discounted fuel surcharge billing? </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no q-marg-top-xs-at-md\"> <input name=fuelSurchrgSwitchery id=fuelSurchrgSwitchery type=checkbox class=\"js-switchery quick-toggler fuel-Surchrg-switch\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.merchant-billing-toggle-parent data-quick-toggler-target=.merchant-billing-toggle-target /> </div> </div> </div> </div> </div> </div> {% }%} <div class=q-section> <div class=\"q-marg-all-xl affiliated-merchant-toggle-parent\"> <div class=q-marg-vert-md> <h2 class=q-section-title> Affiliated Merchant </h2> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\" for=\"\"> Do you have any merchants to assign? </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no q-marg-top-xs-at-md\"> <input name=affMerchantSwitchery id=affMerchantSwitchery type=checkbox class=\"js-switchery quick-toggler\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.affiliated-merchant-toggle-parent data-quick-toggler-target=.affiliated-merchant-toggle-target /> </div> </div> </div> </div> <div class=\"q-marg-vert-md affiliated-merchant-toggle-target\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label for=\"\"> Affiliated Merchant Name </label> </div> <div class=\"col-md-9 col-xs-12\"> <div class=\"row add-aff-merchant\"> <div class=col-xs-12> <input class=\"q-input q-stretch\" type=text placeholder=\"Enter merchant name\" id=aff-merchant-name /> </div> <div id=duplicate-message class=col-md-9 style=display:none> <label class=q-sim-error> Affiliated Merchant Name matches another, please enter a unique name. </label> </div> </div> </div> </div> <div class=\"row q-marg-top-md\"> <div class=\"col-md-6 col-md-offset-3 col-xs-12\"> <a href=# class=\"base-btn purple-btn q-block-at-md q-text-center add-merchant-btn\"> Add Affiliated Merchant </a> </div> </div> </div> </div> </div> {% if (isCSR) { %} {% if(rltType == \"HONEYCOMB_RMS\"){ %} <div class=\"q-section supply-chain-facilities\"> <div class=q-marg-all-xl> <h2 class=q-section-title> Supply Chain Facilities </h2> </div> <div class=q-marg-all-xl> <div class=\"q-marg-vert-md error-alert-msg\" style=display:none> <div class=row> <div class=\"col-md-offset-3 col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-red q-text-center\"> You must select atleast one facility. </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> {%=supplyChainFac%} </div> </div> </div> </div> {% }%} {% }%} {% if (isCSR) { %} {% if(rltType == \"HONEYCOMB_RMS\"){ %} <div class=\"q-section shipping-services\"> <div class=q-marg-all-xl> <h2 class=q-section-title> Shipping Services </h2> </div> <div class=q-marg-all-xl> <div class=\"q-marg-vert-md error-alert-msgg\" style=display:none> <div class=row> <div class=\"col-md-offset-3 col-md-6 col-xs-12\"> <div class=\"q-alert q-alert-red q-text-center\"> You must select atleast one shipping service. </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> {%=shippingServ%} </div> </div> </div> </div> {% }%} {% }%} <div class=\"q-section master-account-section\"> <div class=\"q-marg-all-xl master-account-toggle-parent\"> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\" for=master-account-toggle-checkbox> Is this a Master account </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no\"> <input id=master-account-toggle-chk name=master-account-toggle-chk type=checkbox class=\"js-switchery quick-toggler master-account-toggle-checkbox\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.togglable-parent data-quick-toggler-target=.togglable-target /> </div> </div> </div> </div> </div> </div> <div class=\"q-section managed-by-master-account-section\"> <div class=\"q-marg-all-xl managed-by-master-account-toggle-parent\"> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=\"q-label q-no-marg\" for=managed-by-masteraccount-toggle-checkbox> Is this Managed by Master account </label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-switchery q-switchery-large q-switchery-bf-text-yes q-switchery-af-text-no q-marg-top-xs-at-md\"> <input name=managed-by-masteraccount-toggle-chk id=managed-by-masteraccount-toggle-chk type=checkbox class=\"js-switchery quick-toggler managed-by-masteraccount-toggle-checkbox\" data-js-switchery-color=#3399FF data-quick-toggler-show-on-checked=true data-quick-toggler-closest=.managed-by-master-account-toggle-parent data-quick-toggler-target=.managed-by-master-account-toggle-target /> </div> </div> </div> </div> <div class=\"q-marg-vert-md managed-by-master-account-toggle-target\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Master Account* </label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select masteraccount-dropdown\" required style=width:100% data-s2-minimum-results-for-search=Infinity data-s2-placeholder=\"Select Master Account\" data-s2-alloe-clear=true name=masteraccount-dropdown id=masteraccount-dropdown> <option value=\"\"></option> </select> </div> </div> </div> </div> </div> {% }%} <div class=q-section> <div class=q-marg-all-xl> <h2 class=q-section-title> Primary Contact </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=primaryPrefix class=q-label>Name *</label> </div> <div class=\"col-md-1_5 col-xs-12 q-marg-bottom-md-at-md\"> <div> <select name=primaryPrefix id=primaryPrefix class=\"select2-select q-input ret-prefix\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=Prefix data-s2-minimum-results-for-search=Infinity> <option value=-1 disabled=\"\" selected=\"\">Prefix</option> </select> </div> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> {% if (hasMerchent) { %} <input id=primaryFirstName maxlength=50 required class=\"q-input q-stretch ret-first-name notAllSpaces\" name=firstName type=text placeholder=\"First Name\"/> {% } else { %} <input id=primaryFirstName required class=\"q-input q-stretch ret-first-name notAllSpaces\" name=firstName type=text placeholder=\"First Name\"/> {% } %} </div> <div class=\"col-md-4_5 col-xs-12 q-marg-bottom-md-at-md\"> {% if (hasMerchent) { %} <input id=primaryLastName maxlength=50 required class=\"q-input q-stretch ret-last-name notAllSpaces\" name=lastName type=text placeholder=\"Last Name\"/> {% } else { %} <input id=primaryLastName required class=\"q-input q-stretch ret-last-name notAllSpaces\" name=lastName type=text placeholder=\"Last Name\"/> {% } %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> {% if (hasMerchent) { %} <label for=primaryEmail class=q-label>Email </label> {% } else { %} <label for=primaryEmail class=q-label>Email *</label> {% } %} </div> <div class=\"col-md-4_5 col-xs-12\"> {% if (hasMerchent) { %} <input id=primaryEmail class=\"q-input q-stretch ret-email email\" name=email type=text placeholder=Email /> {% } else { %} <input id=primaryEmail required class=\"q-input q-stretch ret-email email\" name=email type=text placeholder=Email /> {% } %} </div> </div> </div> </div> </div> {%= multiPhoneForm1 %} </div>";

/***/ },
/* 1355 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"{%- supplyChainFac.facCity %}FedexId\" class=q-label>FedEx Id ({%- supplyChainFac.facCity %})</label> </div> <div class=\"col-md-9 col-xs-12\"> <input id=\"{%- supplyChainFac.facCity %}FedexId\" class=\"q-input q-stretch {%- supplyChainFac.facCity %}-fedex-id\" name=\"{%- supplyChainFac.facCity %}FedexId\" type=text placeholder=\"{%- supplyChainFac.facCity %} FedEx ID\"/> <input id=\"facId{%- supplyChainFac.facId %}\" value=\"{%- supplyChainFac.facId %}\" class=\"q-input q-stretch facId-{%- supplyChainFac.facId %} hidden\" name=\"facId{%- supplyChainFac.facId %}\" type=text /> </div> </div> </div>";

/***/ },
/* 1356 */
/***/ function(module, exports) {

	module.exports = "<div class=qw-title-outer> <h2 class=qw-title> <span class=new-retailer-text>New Retailer</span> <span class=edit-retailer-text>Edit Retailer</span> <span class=new-merchant-text>New Merchant</span> </h2> </div> <div class=qw-nav-steps> {% if (hasMerchent) { %} <a href=# class=\"qw-nav-step active\" data-qw-form-target=.details-tab> <span class=qw-nav-step-inner> Details </span> </a> {% }%} <a href=# class=qw-nav-step data-qw-form-target=.primary-information-tab> <span class=qw-nav-step-inner> Primary Information </span> </a> <a href=# class=qw-nav-step data-qw-form-target=.shipping-information-tab> <span class=qw-nav-step-inner> Shipping Information </span> </a> <a href=# class=qw-nav-step data-qw-form-target=.billing-information-tab> <span class=qw-nav-step-inner> Billing Information </span> </a> {% if (hasMerchent) { %} <a href=# class=qw-nav-step data-qw-form-target=.fscFacilities-tab> <span class=qw-nav-step-inner> FSC Facilities </span> </a> {% }%} <a href=# class=qw-nav-step data-qw-form-target=.review-tab> <span class=qw-nav-step-inner> Review </span> </a> </div> <div class=qw-forms-outer> {% if (hasMerchent) { %} <div class=\"qw-form details-tab\"> <div class=qw-form-inner> {%= detailsTab %} </div> </div> {% }%} <div class=\"qw-form primary-information-tab\"> <div class=qw-form-inner> {%= primaryInformationTab %} </div> </div> <div class=\"qw-form shipping-information-tab\"> <div class=qw-form-inner> {%= shippingInformationTab %} </div> </div> <div class=\"qw-form billing-information-tab\"> <div class=qw-form-inner> {%= billingInformationTab %} </div> </div> {% if (hasMerchent) { %} <div class=\"qw-form fscFacilities-tab\"> <div class=qw-form-inner> {%= fscFacilitiesTab %} </div> </div> {% }%} <div class=\"qw-form review-tab\"> <div class=qw-form-inner> {%= reviewTab %} </div> </div> </div> <div class=qw-footer> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <a href=# class=\"qw-prev base-btn purple-btn\"> <i class=\"fa fa-angle-left\" aria-hidden=true></i> Previous </a> <a href=# class=\"qw-next base-btn purple-btn\"> Next <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> <a href=# id=retailer-cancel-btn class=\"qw-cancel base-btn purple-btn stretch-mobile v2-btn\"> Cancel </a> </div>";

/***/ },
/* 1357 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section {%- sectionWrapper %}\"> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> <a data-target-form=\"{%- targetTab %}\" href=#> <span>{%- contactType %} Account Information</span> <i class=\"fa fa-pencil q-icon-marg-left q-icon-md\" aria-hidden=true></i> </a> </h2> {% if (expandableTarget) { %} <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=\".{%- expandableTarget %}\" data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-expand q-icon-md\" aria-hidden=true></i></a> {% } %} </div> <div class=\" {% if (expandableTarget) { %} {%= expandableTarget %} q-expandable-default {% } %} \"> <div class=q-expandable-body> <div class=\"row q-pad-top-md\"> <div class=\"col-md-6 col-xs-12\"> {% if (hasPrimaryFields) { %} <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Company Name:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-valuable revCompanyName\"></div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Tax ID:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-valuable revTaxId\"></div> </div> </div> </div> {% } %} <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>{%- contactType %} Address:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=q-valuable> <div><span class=ret-address1></span> <span class=ret-address2></span></div> <div><span class=ret-city></span>, <span class=ret-state></span> <span class=ret-zip-code></span></div> <div class=ret-country></div> </div> </div> </div> </div> {% if (hasPrimaryFields && isCSR) { %} <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Supply Chain Facilities:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=revSupplychainfacilities> </div> </div> </div> </div> {% } %} {% if (hasPrimaryFields && isCSR) { %} <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Shipping Services:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=revShippingServices> </div> </div> </div> </div> {% } %} {% if(rltType === \"HONEYCOMB_RMS\"){ %} <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Merchant Tier:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-valuable revTier\"></div> </div> </div> </div> {% } %} {% if (isCSR) { %} <div class=q-marg-top-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <span class=q-tag> Has the merchant signed off for insight tracking ? </span> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-valuable insight-toggler\"> </div> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <span class=q-tag> Direct Bill: </span> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-valuable directbill-toggler\"> </div> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <span class=q-tag> Fuel Surcharge discount: </span> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-valuable fuelsurchrg-toggler\"> </div> </div> </div> </div> {% }%} </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Contact Name:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=revContactPersonName></div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Email:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=revEmailAddress></div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Phone:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=revOfficeNumber></div> </div> </div> <div class=row> <div class=\"col-md-offset-5 col-md-7 col-xs-12\"> <div class=revMobileNumber></div> </div> </div> {% if (hasPrimaryFields) { %} <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-tag>Primary Ecommerce URL:</div> </div> <div class=\"col-md-7 col-xs-12\"> <a href=# target=new class=\"q-underline revPrimaryUrl\"></a> </div> </div> </div> {% } %} </div> </div> </div> </div> </div> </div> </div> {% if (hasPrimaryFields) { %} <div class=\"q-section {%- sectionWrapper %}\"> <div class=\"q-expandable-wrap merchants-target-section\"> <div class=q-expandable-header> <h2 class=q-expandable-title> <a href=# data-target-form=.primary-information-tab> <span> Affilated Merchants </span> <i class=\"fa fa-pencil q-icon-marg-left q-icon-md\" aria-hidden=true></i> </a> </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.affiliated-merchants-target data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-expand q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"affiliated-merchants-target q-expandable-default\"> <div class=q-expandable-body> <div class=q-overflow-x-auto> <div class=\"q-overflow-x-hidden q-min-width-sm\"> <div class=\"divider-group divider-group-headers\"> <div class=row> <div class=col-xs-3> Merchant </div> </div> </div> <div class=merchantNames> </div> </div> </div> </div> </div> </div> </div> {% } %}";

/***/ },
/* 1358 */
/***/ function(module, exports) {

	module.exports = "<div class=details-tab-inner> {%= primaryAccountInformation %} {%= shippingAccountInformation %} {%= billingAccountInformation %} <div class=q-section> <div class=q-marg-all-xl> <a href=# class=\"base-btn middle-btn purple-btn block-btn q-text-center submit-btn\"> Submit </a> </div> </div> </div>";

/***/ },
/* 1359 */
/***/ function(module, exports) {

	module.exports = "<tr> <td class=q-tag> {%- savedobject.facilityname  %} </td> <td>{%- savedobject.selectedbussinessunit  %}</td> <td>{%- savedobject.facilitiesuses  %}</td> <td class=q-text-right> <a href=# id=\"{%- index %}\" class=\"base-btn purple-btn v2-btn q-text-center q-marg-right-md saved-facility-remove-btn\">Remove</a> <a href=# id=\"{%- index %}\" class=\"base-btn purple-btn q-text-center saved-facility-edit-btn\">Edit</a> </td> </tr>";

/***/ },
/* 1360 */
/***/ function(module, exports) {

	module.exports = "<div class=details-tab-inner> {%= shippingAccountAddressForm %} <div class=\"q-section contact-section\"> <div class=q-marg-all-xl> <h2 class=q-section-title> Shipping Contact </h2> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=shippingPrefix class=q-label>Name *</label> </div> <div class=\"col-md-1_5 col-xs-12 q-marg-bottom-md-at-md\"> <div> <select name=shippingPrefix id=shippingPrefix class=\"select2-select q-input ret-prefix\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=Prefix data-s2-minimum-results-for-search=Infinity> <option value=-1 disabled=\"\" selected=\"\">Prefix</option> </select> </div> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> {% if (hasMerchent) { %} <input id=shippingFirstName maxlength=50 required class=\"q-input q-stretch ret-first-name\" name=shippingFirstName type=text placeholder=\"First Name\"/> {% } else { %} <input id=shippingFirstName required class=\"q-input q-stretch ret-first-name\" name=shippingFirstName type=text placeholder=\"First Name\"/> {% } %} </div> <div class=\"col-md-4_5 col-xs-12 q-marg-bottom-md-at-md\"> {% if (hasMerchent) { %} <input id=shippingLastName maxlength=50 required class=\"q-input q-stretch ret-last-name\" name=shippingLastName type=text placeholder=\"Last Name\"/> {% } else { %} <input id=shippingLastName required class=\"q-input q-stretch ret-last-name\" name=shippingLastName type=text placeholder=\"Last Name\"/> {% } %} </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> {% if (hasMerchent) { %} <label for=shippingEmail class=q-label>Email</label> {% } else { %} <label for=shippingEmail class=q-label>Email *</label> {% } %} </div> <div class=\"col-md-4_5 col-xs-12\"> {% if (hasMerchent) { %} <input id=shippingEmail class=\"q-input q-stretch ret-email email\" name=shippingEmail type=text placeholder=Email /> {% } else { %} <input id=shippingEmail required class=\"q-input q-stretch ret-email email\" name=shippingEmail type=text placeholder=Email /> {% } %} </div> </div> </div> </div> </div> {%= shippingContactPhoneForm %} </div>";

/***/ },
/* 1361 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-md-3 col-xs-12\"> <label class=q-label>{%- shippingServ.cdmMeaning %}</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox checkboxTes q-checkbox checkbox-success cb-large\"> <input type=checkbox id=\"{%- shippingServ.cdmMeaning %}\" value=\"{%- shippingServ.cdmMeaning %}\" class=shipping-serv {% if(shippingServ.cdmValue==\"FXSD\" || shippingServ.cdmDescription==\"Y\" ) { %} checked=checked {% } %} /> <label for=\"{%- shippingServ.cdmMeaning %}\"></label> </div> </div>";

/***/ },
/* 1362 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-md-3 col-xs-12\"> <label class=q-label>{%- supplyChainFac.facName %}</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"checkbox checkboxTest q-checkbox checkbox-success cb-large\"> <input type=checkbox id=\"{%- supplyChainFac.facName %}\" value=\"{%- supplyChainFac.facName %}\" class=supply-chain-fac {% if(supplyChainFac.facDeactiveActive==\"1\") { %} checked=checked {% } %} /> <label for=\"{%- supplyChainFac.facName %}\"></label> </div> </div>";

/***/ },
/* 1363 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <label class=\"q-label q-label-top\">Export Date Range</label> <div> <div class=q-grid> <div class=\"q-input-group q-input-group-connected no-pad-bottom q-row q-input-group-connected-break-at-sm wrapper-helper\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-input-first func-date-range-wrapper q-static-col-datepicker-stretch\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input export-date-range-start\" name=dateRange1 required type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"   /   /   \"/> </div> <div class=\"q-input-group-connected-inner q-static-col\"> <div class=\"q-sim-input q-text-center\"> to </div> </div> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-last q-inner-text-right q-input-last func-date-range-wrapper wrapper-helper q-static-col-datepicker-stretch\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input export-date-range-end\" name=dateRange2 required type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"   /   /   \"/> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1364 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default-base q-max-page-width-lg q-page-center-margin\"> <div class=\"q-card q-card-white q-marg-bottom-lg q-no-border-bottom\"> <div class=\"q-main-header clearfix\"> <div class=q-inline-block-til-md> <div class=\"q-border-bottom-at-md q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"> <i class=\"fa fa-bell q-icon-marg-right\" aria-hidden=true></i> Notifications </h2> </div> </div> <div class=q-pull-right-til-md> <div class=\"q-main-header-actions-container q-text-right-til-md q-pad-left-sm-til-md\"> <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn export-widgets\"> Export </a> <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn manage-btn\"> <i class=\"fa fa-gear q-icon-marg-right\" aria-hidden=true></i> Manage </a> </div> </div> </div> </div> <div class=widget-engine-target> </div> </div>";

/***/ },
/* 1365 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=we-main-toggle-container> <a href=# class=\"we-main-toggle-btn active\"> <div class=q-inline-block>Alerts</div> <span class=\"q-pill q-pill-white-and-purple q-marg-left-xs notifications-count\">{%- alertNumber %}</span> </a> </div> </div>";

/***/ },
/* 1366 */
1271,
/* 1367 */
/***/ function(module, exports) {

	module.exports = "<div class=box-dim-row> <div class=bdr-left-outer> <div class=row> <div class=\"col-md-1 col-xs-12\"> <div class=\"q-label bdr-idx\"> 1 </div> </div> <div class=\"col-md-11 col-xs-12\"> <div class=row> <div class=\"col-md-2 col-xs-12\"> <label class=q-label> Dimensions* </label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"row wrapper-helper\"> <div class=\"col-md-4 col-xs-12 q-marg-vert-xxs-at-md\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input id=\"{%- lengthId %}\" class=\"q-input q-stretch box-length\" name=\"boxLength-{%- lengthId %}\" min=1 required type=number placeholder=Length data-error-placement-append-closest=.wrapper-helper /> <span class=q-ig-units>in.</span> </div> </div> </div> <div class=\"col-md-4 col-xs-12 q-marg-vert-xxs-at-md\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input id=\"{%- widthId %}\" class=\"q-input q-stretch box-width\" name=\"boxWidth-{%- widthId %}\" min=1 required type=number placeholder=Width data-error-placement-append-closest=.wrapper-helper /> <span class=q-ig-units>in.</span> </div> </div> </div> <div class=\"col-md-4 col-xs-12 q-marg-vert-xxs-at-md\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input id=\"{%- heightId %}\" class=\"q-input q-stretch box-height\" min=1 required name=\"boxHeight-{%- heightId %}\" type=number placeholder=Height data-error-placement-append-closest=.wrapper-helper /> <span class=q-ig-units>in.</span> </div> </div> </div> </div> </div> <div class=\"col-md-1 col-xs-12\"> <label class=q-label> Weight* </label> </div> <div class=\"col-md-3 col-xs-12 wrapper-helper\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input id=\"{%- weightId %}\" class=\"q-input q-stretch box-weight\" min=1 required name=\"boxWeight-{%- weightId %}\" type=number placeholder=Weight data-error-placement-append-closest=.wrapper-helper /> <span class=q-ig-units>lb.</span> </div> </div> </div> </div> </div> </div> </div> <div class=bdr-right-outer> <a href=# class=remove-btn> &times; </a> </div> </div>";

/***/ },
/* 1368 */
/***/ function(module, exports) {

	module.exports = "<div class=clearfix> <form class=modal-form> <div class=q-section> <div class=\"q-marg-horz-xl q-marg-vert\"> <h4 class=\"q-title q-marg-vert txt-c-grey\"> Select a facility to ship from </h4> <div class=q-marg-vert> <select name=addressId style=width:100% class=\"select2-select required ship-fedex-addr-dropdown\" data-error-placement-append-closest=div data-s2-minimum-results-for-search=Infinity> <option value=\"\">Select Origin From Locations</option> </select> </div> <div class=q-marg-vert> <div class=\"q-alert q-alert-grey\">Only saved locations can be selected. <a class=q-underline href=./locations>Click here</a> to add a new location</div> </div> </div> </div> <div class=q-section> <div class=\"q-marg-horz-xl q-marg-vert\"> <h4 class=\"q-title q-marg-vert txt-c-grey\"> Enter the Dimensions for Each Box Below </h4> <div class=\"box-dim-rows-outer q-marg-vert\"> </div> <div> <a href=# class=\"sf-add-box-btn q-icon-plus-link\"> <i class=\"fa fa-plus-circle q-marg-horz q-fs-xl\" aria-hidden=true></i> <span class=sf-add-box-text> Add Another Box </span> </a> </div> <div class=q-marg-vert-xl> <div class=\"checkbox q-checkbox checkbox-success cb-large cb-unchecked-white\"> <label> <input type=checkbox value=1 name=shareShipInfo class=share-ship-info-checkbox /> <span class=cb-label-inner> Share shipping information with channel </span> </label> </div> </div> </div> </div> </form> </div>";

/***/ },
/* 1369 */
/***/ function(module, exports) {

	module.exports = "<div class=clearfix> <form class=modal-form> <div class=\"q-marg-horz-xl q-marg-vert\"> <h4 class=\"q-title q-marg-vert txt-c-grey\"> Enter the Shipping Information Below </h4> <div class=q-marg-vert> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=q-label> Carrier </div> </div> <div class=\"col-md-8 col-xs-12\"> <div class=stp-left-input-outer> <select name=fileFormat class=\"select2-select q-input carrier-select\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Carrier\" data-s2-minimum-results-for-search=Infinity required> <option></option> <option value=UPS>UPS</option> <option value=DHL>DHL</option> <option value=USPS>USPS</option> </select> </div> </div> </div> </div> <div class=q-marg-vert> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=q-label> Tracking Number(s) </div> </div> <div class=\"col-md-8 col-xs-12\"> <div class=tracking-rows-outer> </div> <div> <a href=# class=\"st-add-tracking-btn q-icon-plus-link inline-block\"> <i class=\"fa fa-plus-circle q-marg-horz q-fs-xl\" aria-hidden=true></i> <span class=st-add-tracking-text> Add Another Tracking Number </span> </a> </div> </div> </div> </div> <div class=q-marg-vert-xl> <div class=\"checkbox q-checkbox checkbox-success cb-large cb-unchecked-white\"> <label> <input type=checkbox value=1 name=shareShipInfo class=share-ship-info-checkbox /> <span class=cb-label-inner> Share shipping information with channel </span> </label> </div> </div> </div> </form> </div>";

/***/ },
/* 1370 */
/***/ function(module, exports) {

	module.exports = "<div class=\"tracking-row q-marg-bottom-md\"> <div class=stp-left-input-outer> <input id=\"tracking-{%- trackingId %}\" required class=\"q-input q-stretch tracking-number\" name=\"tracking-{%- trackingId %}\" type=text placeholder=\"Enter the tracking number\"/> </div> <div class=stp-right-input-outer> <a href=# class=remove-btn> &times; </a> </div> </div>";

/***/ },
/* 1371 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group divider-group-box bundle-child-product-row\"> <div class=row> <div class=col-xs-4> </div> <div class=col-xs-2> <div class=\"q-marg-vert-xxs q-boldest\"> <i class=\"fa fa-level-down q-icon-lg q-icon-marg-right\" aria-hidden=true></i> <span class=\"products-tab-child-product-name q-break-word\">{%- productSku %}</span> </div> </div> <div class=col-xs-3> <div class=q-marg-vert-xxs> <span class=\"products-tab-child-product-description q-break-word\">{%- prodDesc %}</span> </div> </div> <div class=col-xs-2> <span class=products-tab-child-available-units>{%= productUnitsAvail %}</span> </div> </div> </div>";

/***/ },
/* 1372 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group divider-group-box\"> <div class=row> <div class=col-xs-3> </div> <div class=col-xs-3> <div class=\"q-marg-vert-xxs q-boldest\"> <i class=\"fa fa-level-down q-icon-lg q-icon-marg-right\" aria-hidden=true></i> {%- productSku %} </div> </div> <div class=col-xs-4> <div class=\"q-marg-vert-xxs q-break-word\"> {%- prodDesc %} </div> </div> <div class=col-xs-2> {%= productUnitsAvail %} </div> </div> </div>";

/***/ },
/* 1373 */
/***/ function(module, exports) {

	module.exports = "<div class=cssNotesModalBody> <form class=q-pad-all-xl name=cssNotesInputForm id=cssNotesInputForm> <div class=wrapper-helper> <p class=q-marg-bottom-md>You are resolving this error. Please write some notes that explain the error that occurred and the actions that were taken to resolve this error.</p> <div class=q-marg-top-md> <textarea class=\"q-input q-stretch resolution-notes required\" data-error-placement-append-closest=.wrapper-helper name=resolutionNotes></textarea> </div> </div> </form> </div>";

/***/ },
/* 1374 */
/***/ function(module, exports) {

	module.exports = "<div class=q-pad-all-xl> <div> <p class=q-marg-bottom-md><span class=q-boldest>Notes Created:</span> (By {%- optional.css %} {%- optional.date %})</p> <div class=q-marg-top-md> <div class=\"pretty-well pw-border-rad q-text-left pw-pad-md\">{%- optional.notes %}</div> </div> </div> </div>";

/***/ },
/* 1375 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-top-md file-name-row\"> <div class=\"pretty-well pw-pad-xs q-pad-vert-xxs pw-border pw-white-bg\"> <div class=row> <div class=col-xs-10> <div class=\"q-marg-top-xs q-marg-bottom-xs-at-md q-text-left\"> <span class=q-boldest id=filenames>{%- fileName %}</span> </div> </div> <div class=col-xs-2> <a href=# class=\"q-close-btn q-pull-right q-no-pad-horz file-remove-btn-edit\"> <i class=\"fa fa-times\"></i> <input type=hidden value=\"{%- cisId %}\" name=cisId class=qfu-file-text-input id=wo-cis-id /> </a> </div> </div> </div> </div>";

/***/ },
/* 1376 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert> <h4 class=\"q-title q-marg-vert\" style=display:none> Electronic Export Information (EEI) </h4> <div class=row style=display:none> <div class=\"col-md-8 col-xs-12\"> Based on the information provided by you, Internal Transaction Number (ITN) is required for your shipment. </div> <div class=\"col-md-4 col-xs-12\"> <input type=text name=itnNumber id=itnNumberInput placeholder=\"Enter 15 digit ITN\" maxlength=15 class=\"q-input stretch\"/> </div> </div> <h4 class=\"q-title q-marg-top-xl\"> Document Recommendations </h4> <div class=row> <div class=\"col-md-12 col-xs-12 q-marg-top-md\"> Note: Based on the provided information these documents are recommended according to the government rules in the FedEx databases. These rules are updated periodically. You may choose to proceed without the recommended documents. FedEx Transportation policies as outlined in the Service Guide will apply. </div> </div> </div> <div class=row> <div class=\"col-md-12 col-xs-12\"> <h4 class=q-title>Insert the list of missing documents</h4> </div> <div class=\"col-md-4 col-xs-12\"> <ol class=q-marg-top-sm> {%= documentationFiles %} </ol> </div> <div class=\"col-md-8 col-xs-12\"> <div class=\"documnet-uploader qfu-default-styles\"> </div> <div class=\"q-alert q-alert-red q-marg-top-xs maxFileError\" style=display:none>Maximum of 10 files can be uploaded. Please remove extra files</div> </div> </div> <div class=row> <div class=\"col-md-4 col-xs-12\"> </div> <div class=\"col-md-8 col-xs-12\"> <div class=q-marg-vert-md> <a href=# class=\"base-btn middle-btn purple-btn block-btn q-text-center upload-file\"> Upload File </a> </div> <div class=document-validation-loading-outer style=display:none> <div class=inline-dots-loader></div> </div> <div class=\"q-marg-vert-md q-alert q-alert-green successUploadMsg\" style=display:none> <p>Files uploaded successfully.</p> </div> <div class=\"q-marg-vert-md q-alert q-alert-red erroruploadMsg\" style=display:none> <p>Couldn’t store documents, please try again.</p> </div> </div> </div> </div> </div>";

/***/ },
/* 1377 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> This order has updated to a status which prohibits any editing to the order moving forward. No changes you've made will be saved to this order. </div>";

/***/ },
/* 1378 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-top-sm hs-code-missing\"> <div class=\"q-alert q-alert-red\"> This SKU is <span class=q-boldest>missing the HS Code and/or the Country of Origin</span> and cannot be shipped internationally. Please add this information to the product, or remove this SKU to continue editing. </div> </div>";

/***/ },
/* 1379 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=\"q-pad-vert-md q-pad-horz-xl\"> Changing from a US destination to a non-US destination will cause the products added on the Products tab to be deleted. Please cancel if you not wish to lose these products. If you wish to continue with a non-US destination, please add new products in the Product tab. </div> </div>";

/***/ },
/* 1380 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group dg-md\"> <div class=row> <div class=col-xs-3> <div class=q-marg-vert-xxs> {%- updatedOn %} </div> </div> <div class=col-xs-2> <div class=q-marg-vert-xxs> {%- updatedBy %} </div> </div> <div class=col-xs-2> <div class=q-marg-top-xxxs> {%= statusPill %} </div> </div> <div class=col-xs-5> <div class=q-marg-vert-xxs> {%- description %} </div> </div> </div> </div>";

/***/ },
/* 1381 */
/***/ function(module, exports) {

	module.exports = "<div class=internal-order-grace-period> <span class=q-boldest>Scheduled Release:</span> <span> {%- orderScheduledReleaseTimePeriod %}</span> </div>";

/***/ },
/* 1382 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-xxs> {%= errorIcon %} {%= bundleIcon %} <input type=hidden name=\"{%- portletNamespace %}prodTabSku\" value=\"{%- prodId %}_row_{%- highestId%}\"> <input type=hidden class=products-tab-sku name=\"prodTabProductName_row_{%= highestId %}\" value=\"{%- prodId %}\"> <input type=hidden class=products-tab-par-itm-id name=\"prodTabParItmId_row_{%= highestId %}\" value=\"{%- parItmId %}\"> <input type=hidden class=products-tab-par-ori-id name=\"prodTabParOriId_row_{%= highestId %}\" value=\"{%- parOriId %}\"> <span class=\"products-tab-product-name q-boldest q-break-word\"> {%- prodId %} </span> </div>";

/***/ },
/* 1383 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group divider-group-box\"> <div class=row> <div class=col-xs-3> <div class=q-marg-vert-xxs> <span class=q-boldest>{%- orderedQty %}</span> {%- unitOfMeasure %} </div> </div> <div class=col-xs-3> <div class=\"q-marg-vert-xxs q-boldest\"> {%= bundleIcon %} {%= productId %} </div> </div> <div class=col-xs-4> <div class=\"q-marg-vert-xxs q-break-word\"> {%- productDescription %} </div> </div> <div class=col-xs-2> {%= productUnitsAvail %} </div> </div> </div> {%= optional.children %}";

/***/ },
/* 1384 */
/***/ function(module, exports) {

	module.exports = "<div class=product-data-row id=\"{%- highestId %}\"> <div class=\"divider-group divider-group-box dg-no-top-border\"> <div class=row> <div class=\"col-xs-1 q-no-pad-right\"> <input type=number id=\"{%- portletNamespace %}quantity{%- highestId %}\" name=\"quantity_row_{%- highestId %}\" min=1 class=\"form-control required q-input q-text-left products-tab-quantity-input jqv-whole-number full\" placeholder=Qty value=1 aria-required=true {%- error %}> </div> <div class=col-xs-3> {%= unitOfMeasure %} </div> <div class=col-xs-2> {%= productId %} </div> <div class=col-xs-3> <div class={%- (skuInvalid) ? 'q-display-none':'' %}> <div class=q-marg-vert-xxs> <input type=hidden name=\"prodTabProdDescription_row_{%- highestId %}\" value=\"{%- productDescription %}\"> <span class=\"products-tab-product-description q-break-word\">{%- productDescription %}</span> </div> </div> </div> <div class=col-xs-2> <span class=\"products-tab-avail-units products-tab-parent-avail-units\">{%= productUnitsAvail %}</span> <span class=\"hidden availableUnitsOfProduct\">{%- availProdUnits %}</span> </div> <div class=col-xs-1> <a class=q-close-btn><i class=\"fa fa-times product-remove-btn\" data-id=\"{%- highestId %}\"></i></a> </div> </div> {%= skuInvalid %} {%= missingCode %} {%= skuInactive %} </div> {%= optional.children %} </div>";

/***/ },
/* 1385 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red\"> The channel in which this order came from will not be updated to reflect the removal of this product in which case the the order will stay in a partial status. </div> </div>";

/***/ },
/* 1386 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-top-sm sku-inactive-error\"> <div class=\"q-alert q-alert-red\"> <span class=q-boldest>This SKU is inactive.</span> Please remove this SKU to continue editing. </div> </div>";

/***/ },
/* 1387 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-top-sm sku-invalid-error\"> <div class=\"q-alert q-alert-red\"> <span class=q-boldest>This SKU is invalid.</span> Please remove this SKU to continue editing. </div> </div>";

/***/ },
/* 1388 */
/***/ function(module, exports) {

	module.exports = "<select class=\"select2-select q-input disabled products-tab-uom\" style=width:100% name=\"prodTabUom_row_{%- highestId %}\" data-minimum-results-for-search=Infinity data-target-closest=.divider-group {%- isDisabled %}> {%= dropDownOptions %} </select> <input type=hidden class=prod-tab-unitsPerCase name=\"prodTabUnitperCase_row_{%- highestId %}\" value=\"{%- unitsPerCase %}\"> <input type=hidden class=prod-tab-unitsPerPallet name=\"prodTabUnitPerPallet_row_{%- highestId %}\" value=\"{%- unitsPerPallet %}\">";

/***/ },
/* 1389 */
/***/ function(module, exports) {

	module.exports = "<option value=\"{%- id %}\">{%- text %}</option>";

/***/ },
/* 1390 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=\"q-alert q-alert-red\"> Invalid entry, the data you have entered is not available. Please try again. </div> </div>";

/***/ },
/* 1391 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default q-default-base q-max-page-width-md\"> <div class=\"q-card q-card-white\"> <div class=\"q-main-header clearfix\"> <div class=q-inline-block-til-md> <div class=\"q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"> <i class=\"fa fa-search q-icon-marg-right\"></i> Shipment Search </h2> </div> </div> </div> <div class=\"q-section form\"> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=q-title>Basic Search</h2> </div> <div class=q-marg-vert-xl> Use the below search attributes to track your shipments. By default it searches the last 60 days of shipments. <br>For older transactions, remove the \"Last 60 days\" filter from the search results screen. </div> <div class=q-section> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Package Number</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text path=shpPacakgeId name=shpPacakgeId id=shpPacakgeId class=\"q-input q-stretch\" placeholder=\"Enter a packaging number\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Tracking / PRO Number</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text name=shpTrackingNumber id=shpTrackingNumber class=\"q-input q-stretch\" placeholder=\"Enter a tracking / pro number\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Purchase Order Number</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text name=purchaseOrderNbr id=purchaseOrderNbr class=\"q-input q-stretch\" placeholder=\"Enter a purchase order number\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Shipment Number</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text name=shpShipmentNumber id=shpShipmentNumber class=\"q-input q-stretch\" placeholder=\"Enter a shipment number\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Sales Order Number</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text name=salesOrderNbr id=salesOrderNbr class=\"q-input q-stretch\" placeholder=\"Enter a sales order number\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Order ID Number</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text name=shpEntityId id=shpEntityId class=\"q-input q-stretch\" placeholder=\"Enter an order ID number\"/> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Shipper</label> </div> <div class=\"col-md-6 col-xs-12\"> <select name=shpMerchantBuId id=shpMerchantBuId class=select2-select style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Shipper\" data-s2-minimum-results-for-search=7><option disabled=disabled selected=selected value=\"\">Select Status</option></select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Status</label> </div> <div class=\"col-md-6 col-xs-12\"> <select id=shpStatus name=shpStatus class=select2-select style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Status\" data-s2-minimum-results-for-search=7><option disabled=disabled selected=selected value=\"\">Select Status</option></select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Carrier</label> </div> <div class=\"col-md-6 col-xs-12\"> <select id=shpCarrier name=shpCarrier class=select2-select style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Carrier\" data-s2-minimum-results-for-search=7><option disabled=disabled selected=selected value=\"\">Select Carrier</option></select> </div> </div> </div> </div> <div class=q-section> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Ship Date</label> </div> <div class=\"col-md-9 col-xs-12\"> <div class=q-grid> <div class=\"q-input-group q-input-group-connected no-pad-bottom q-row q-input-group-connected-break-at-sm wrapper-helper\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-static-col-2 q-input-first func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input name=shpShipFromDate id=shpShipFromDate class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input ship-date-start\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> <div class=\"q-input-group-connected-inner q-static-col\"> <div class=\"q-sim-input q-text-center\"> to </div> </div> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-last q-inner-text-right q-static-col-2 q-input-last func-date-range-wrapper wrapper-helper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input name=shpShipToDate id=shpShipToDate class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input ship-date-end\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> </div> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Due Date</label> </div> <div class=\"col-md-9 col-xs-12\"> <div class=q-grid> <div class=\"q-input-group q-input-group-connected no-pad-bottom q-row q-input-group-connected-break-at-sm wrapper-helper\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-static-col-2 q-input-first func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input name=shpDueFromDate id=shpDueFromDate class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input due-date-start\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> <div class=\"q-input-group-connected-inner q-static-col\"> <div class=\"q-sim-input q-text-center\"> to </div> </div> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-last q-inner-text-right q-static-col-2 q-input-last func-date-range-wrapper wrapper-helper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input name=shpDueToDate id=shpDueToDate class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input due-date-end\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Shipment Weight</label> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md errormsg\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input class=\"number q-input q-ig-flex-fill\" name=MinshpWeight type=text id=MinshpWeight data-error-placement-append-closest=.errormsg placeholder=\"Weight min.\"/> <span class=q-ig-units>lbs.</span> </div> </div> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md errormsg\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <input class=\"number q-input q-ig-flex-fill\" name=MaxshpWeight type=text id=MaxshpWeight data-error-placement-append-closest=.errormsg placeholder=\"Weight max.\"/> <span class=q-ig-units>lbs.</span> </div> </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title>Search by Receiver Information</h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.search-by-receiver-information data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-expand q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"search-by-receiver-information q-expandable-default\"> <div class=\"q-expandable-body q-no-marg\"> <div class=q-marg-top-xl> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Name</label> </div> <div class=\"col-md-6 col-xs-12\"> <input name=shpShipToName id=shpShipToName type=text class=\"q-input q-stretch\" placeholder=\"Enter receiver name\"/> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Postal Code</label> </div> <div class=\"col-md-3 col-xs-12\"> <input name=shpShipToPostalCode id=shpShipToPostalCode type=text class=\"q-input q-stretch\" placeholder=\"Receiver postal code\"/> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>City</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text name=shpShipToCity id=shpShipToCity class=\"q-input q-stretch\" placeholder=\"Enter receiver city\"/> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Country</label> </div> <div class=\"col-md-6 col-xs-12\"> <select id=shpShipToCountry name=shpShipToCountry class=select2-select style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Country\" data-s2-minimum-results-for-search=7> <option value=All>All</option> </select> </div> </div> </div> </div> </div> </div> </div> </div> <div class=q-section id=errordisplay> </div> <div class=q-section> <div class=q-marg-all-xl> <a href=# class=\"base-btn purple-btn q-block middle-btn q-text-center advanced-search-btn\" id=searchBtn>Search</a> </div> </div> </div> </div>";

/***/ },
/* 1392 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-md-3 col-xs-12\"> <span class=q-boldest>Shipper:</span> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <div>{%- shipper %}</div> <div>{%- shipperName %}</div> <div>{%- shipperAddressLine1 %}</div> <div>{%- shipperAddressLine2 %}</div> <div>{%- shipperCity %}</div> <div>{%- shipperState %}, {%- shipperCountry %}</div> <div>{%- shipperPostalCode %}</div> </div> <div class=\"col-md-3 col-xs-12\"> <span class=q-boldest>Receiver:</span> </div> <div class=\"col-md-3 col-xs-12\"> <div>{%- recipientName %}</div> <div>{%- recipientAddressLine1 %}</div> <div>{%- recipientAddressLine2 %}</div> <div>{%- recipientCity %}</div> <div>{%- recipientState %}, {%- recipientCountry %}</div> <div>{%- recipientPostalCode %}</div> </div>";

/***/ },
/* 1393 */
/***/ function(module, exports) {

	module.exports = "<div class=\"divider-group divider-group-box\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=q-marg-top-xs-til-md> <span class=\"q-tag q-col-spacer\"> {%- fileName %} </span> </div> </div> <div class=\"col-md-5 col-xs-12\"> <div class=q-marg-vert-xs> <span> Uploaded on {%- fileUploadDate %} </span> </div> </div> <div class=\"col-md-4 col-xs-12\"> <div class=\"q-pull-right-til-md q-text-center\"> <a class=\"base-btn purple-btn q-display-none-at-md download-doc-row-btn\" data-document-id=\"{%- documentId %}\"><i class=\"fa fa-download\" aria-hidden=true></i></a> <a class=\"base-btn purple-btn q-display-none q-block-at-md q-marg-bottom-md-at-md\">Download</a> <a class=\"base-btn q-close-btn q-display-none-at-md remove-doc-row-btn\" data-document-id=\"{%- documentId %}\"><i class=\"fa fa-times\" aria-hidden=true></i></a> <a class=\"base-btn purple-btn v2-btn q-display-none q-block-at-md\">Remove</a> </div> </div> </div> </div>";

/***/ },
/* 1394 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-alert q-alert-grey\"> No documents have been attached yet. </div>";

/***/ },
/* 1395 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md>There are <span class=q-boldest>{%- shpPackageCount %} packages</span> related to the original order ID.</div> <div class=q-marg-vert-md>Would you like to view a summary of all related packages? You will be redirected from this detail page.</div> </div>";

/***/ },
/* 1396 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container-fluid no-indent animated fadeInRight\" id=pod-package-details> <div class=\"q-default q-default-base q-max-page-width-md\"> <div class=\"q-card q-card-white q-marg-bottom-xl\"> <div class=\"q-main-header clearfix\"> <div class=q-inline-block-til-md> <div class=\"q-border-bottom-at-md q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"> <i class=\"fa fa-cube q-icon-marg-right\"></i> {%- trackingNumber %} </h2> </div> </div> <div class=q-pull-right-til-md> <div class=\"q-main-header-actions-container q-text-right-til-md q-text-center-at-md\"> {% if (flag === true) { %} <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn v2-btn\" id=searchAgainBtn> <i class=\"fa fa-search q-icon-marg-right\" aria-hidden=true></i> Search Again </a> {% } else { %} <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn v2-btn\" id=backToListBtn> Back to List </a> {% } %} </div> </div> </div> {%= shipmentStatusrenderRow %} </div> <div class=\"q-card q-card-white\"> <div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=q-title>Shipment Details</h2> </div> <div class=row> {%= shipmentDetailsRow %} </div> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=q-title>Delivery Details</h2> </div> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-3 col-xs-12\"> <span class=q-boldest>Ship Date:</span> </div> <div class=\"col-md-3 col-xs-12\"> <span class=q-boldest>{%- shipDate %}</span> </div> </div> <div class=row> {%= deliveryDetailsRow %} </div> </div> </div> {%= shippingDocSection %} <div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title>Status History</h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.status-history data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"status-history q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> {%= statusHistoryWrap %} </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1397 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-md-6 col-xs-12\"> <div class=\"row q-marg-bottom-md-at-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Carrier:</span> </div> <div class=\"col-md-6 col-xs-12\"> {% if (shipperCarrier === \"DHL\") { %} <div class=\"q-img q-img-thumbnail qit-lg\" style=background-image:url(https://129d5gnposv45pipg3fffi67-wpengine.netdna-ssl.com/wp-content/uploads/2017/01/DHL-Logo.jpg)> </div> {% } else if(shipperCarrier === \"USPS\") { %} <div class=\"q-img q-img-thumbnail qit-lg\" style=background-image:url(https://www.logolynx.com/images/logolynx/df/df907f1f4d5e04607fd86b51ca31f621.jpeg)> </div> {% } else if(shipperCarrier.toUpperCase() === \"FEDEX\") { %} <div class=\"q-img q-img-thumbnail qit-lg\" style=background-image:url(http://images.more.mdpcdn.com/sites/more.com/files/fedex2.jpg)> </div> {% } else { %} <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>{%- shipperCarrier %}</span> </div> {% } %} </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Tracking / PRO Number :</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- trackingNumber %} </div> </div> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Shipment:</span> </div> <div class=\"col-md-6 col-xs-12\"> {%- shpPackageCount %} Package(s) </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Order ID Number:</span> </div> <div class=\"col-md-6 col-xs-12\"> <a href=# class=order-id-number>{%- shipperOrderId %}</a> </div> </div> </div>";

/***/ },
/* 1398 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-alert q-alert-grey\"> Tracking history and package status updates are not available at this time. </div>";

/***/ },
/* 1399 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title>Shipping Documents</h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.shipping-doc data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-expand q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"shipping-doc q-expandable-default\"> <div class=q-expandable-body> <div class=q-marg-vert-md> {%= fileNameArea %} </div> <div class=q-marg-top-md> <div class=row> <div class=col-xs-12> <div class=\"q-pull-right-til-md q-text-center\"> <a href=# class=\"base-btn purple-btn v2-btn q-block-at-md download-shipping-doc-btn\">Download All </a> <a href=# class=\"base-btn purple-btn q-marg-top-md-at-md q-marg-left-md-til-md upload-shipping-doc-btn q-block-at-md\"> <i class=\"fa fa-upload q-icon-marg-right\" aria-hidden=true></i> Upload Documents </a> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1400 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-ib-container q-marg-top-lg q-icon-box q-icon-box-{%- statusColor %}\"> <div class=q-ib-icon-wrap> <i class=\"q-ib-icon fa fa-{%- icon %}\"></i> </div> <div class=q-ib-content> <div class=q-ibc-title-row> <div class=q-ibc-item>Status: {%- status %}</div> </div> <div class=q-ibc-detail-row> <div class=q-ibc-item>Date: {%- date %}</div> <div class=q-ibc-item>City: {%- city %}</div> </div> </div> </div>";

/***/ },
/* 1401 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=\"q-marg-vert-md q-marg-horz-xl\"> <div class=q-tc-container> <div class=\"q-tc-row q-v-align-children-middle\"> <div class=q-col-2> <div class=q-marg-vert-md-at-md> <div class=\"q-pill q-pill-detail q-pill-{%- statusColor %} q-stretch\">{%- status %} </div> </div> </div> <div class=q-col-7> <div class=q-marg-vert-md-at-md> <p class=q-marg-top-xs>{%- status2 %} | {%- date %} | {%- city %}</p> </div> </div> <div class=q-col-3> <div class=q-text-right-til-md> <a href=# class=\"base-btn purple-btn q-text-center proof-of-delivery {%- podBtnStatus %}\" id=podBtn>Proof of Delivery</a> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1402 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=ship-docs-file-uploader-body> </div> <div class=\"q-marg-top-xl upload-error\" style=display:none> <div class=\"q-alert q-alert-red\"> Error uploading files </div> </div> </div>";

/***/ },
/* 1403 */
/***/ function(module, exports) {

	module.exports = "<div class=q-v-align-children-middle> <span class=\"q-circle-icon q-ci-{%- statusColor %} fa fa-{%- icon %}\"></span> <span class=q-marg-left-xs>{%- ordStatus %}</span> </div>";

/***/ },
/* 1404 */
1402,
/* 1405 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=discrepancies-delete-body> Deleted record cannot be updated </div> <div class=\"q-marg-top-xl delete-error\" style=display:none> <div class=\"q-alert q-alert-red\"> Error deleting record </div> </div> </div>";

/***/ },
/* 1406 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=discrepancies-duplicate-alert-body> </div> <div class=\"q-marg-top-xl duplicate-check-error\" style=display:none> <div class=\"q-alert q-alert-red\"> Error while checking duplicate records </div> </div> </div>";

/***/ },
/* 1407 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=discrepancies-edit-record-body> </div> <div class=\"q-marg-top-xl edit-error\" style=display:none> <div class=\"q-alert q-alert-red\"> Error editing Discrepancy Record </div> </div> </div>";

/***/ },
/* 1408 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Discrepancy Codes * </label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=select-discrepancy-codes> <select class=\"select2-select q-input stretch\" data-minimum-results-for-search=Infinity data-error-placement-append-closest=div style=width:100% data-placeholder=\"Enter Discrepancy Codes\"> <option></option> {%= DiscrepancyCodesDropDown %} <select> </select></select></div> </div> </div> </div>";

/***/ },
/* 1409 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=discrepancies-reslved-alert-body> </div> </div>";

/***/ },
/* 1410 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=discrepancies-photos-uploader-body> </div> <div class=\"q-marg-top-xl upload-error\" style=display:none> <div class=\"q-alert q-alert-red\"> Error uploading photos </div> </div> </div>";

/***/ },
/* 1411 */
/***/ function(module, exports) {

	module.exports = "";

/***/ },
/* 1412 */
/***/ function(module, exports) {

	module.exports = "<a href=# class=\"q-btn {%-displayClass%} {%-activeClass%}\" data-qb-key=\"{%-value%}\"> {%-display%} </a>";

/***/ },
/* 1413 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-lg> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> Date Range: </div> <div class=\"col-lg-3 q-marg-bottom-md-at-md\"> <select name=DATE_RANGE class=\"select2-select q-input\" data-minimum-results-for-search=Infinity style=width:100% id=DATE_RANGE> <option value=24_HOURS {% if(dropDownValue == '24_HOURS') { %} selected=selected {% } %}>Last 24 Hours</option> <option value=48_HOURS {% if(dropDownValue == '48_HOURS') { %} selected=selected {% } %}>Last 48 Hours</option> <option value=7_DAYS {% if(dropDownValue == '7_DAYS') { %} selected=selected {% } %}>Last 7 Days</option> <option value=30_DAYS {% if(dropDownValue == '30_DAYS') { %} selected=selected {% } %}>Last 30 Days</option> <option value=90_DAYS {% if(dropDownValue == '90_DAYS') { %} selected=selected {% } %}>Last 90 Days</option> {% if (allowCustomDateRange) { %} <option value=customDate {% if(dropDownValue == 'customDate') { %} selected=selected {% } %}>Custom</option> {% } %} </select> </div> <div class=\"col-lg-6 q-marg-bottom-md-at-md\"> <div class=\"q-reports-flex reports-custom-date-schedule\"> <div class=\"q-reports-flex-child-outer-input q-marg-bottom-md-at-md wrapper-helper\" id=customDateRangeFields> <div class=\"q-input-group q-input-group-connected no-pad-bottom q-row q-input-group-connected-break-at-sm\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-static-col-1_5 q-input-first func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input\" id=DATE_RANGE1 name=DATE_RANGE1 type=text placeholder=\"   /   /   \" value=\"{%=dateRange1%}\" data-error-placement-append-closest=.wrapper-helper /> </div> <div class=\"q-input-group-connected-inner q-static-col\"> <div class=\"q-sim-input q-text-center\"> to </div> </div> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-last q-inner-text-right q-static-col-1_5 q-input-last func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input\" id=DATE_RANGE2 name=DATE_RANGE2 type=text placeholder=\"   /   /   \" value=\"{%=dateRange2%}\" data-error-placement-append-closest=.wrapper-helper /> </div> </div> </div> </div> </div> <div class=col-lg-3> </div> <div class=\"col-lg-9 q-marg-bottom-md-at-md q-marg-top-md\"> <div class=\"q-reports-flex-child-rest q-boldest q-alert q-alert-grey q-pad-vert-xxs q-marg-bottom-xxs-at-md cannot-schedule-custom-date-warning hide\"> Report cannot be scheduled with a custom date range. </div> </div> </div> </div>";

/***/ },
/* 1414 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-lg> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> {%-name%}: </div> <div class=\"col-lg-6 q-marg-bottom-md-at-md\"> <div class=\"quick-btn-group qb-default qb-purple-theme q-text-center date-range-type-toggler\"> {%=options%} <input type=hidden class=quick-btn-group-hidden-input id=\"{%-key%}\" name=\"{%-key%}\" value=\"{%-value%}\"/> </div> </div> </div> </div>";

/***/ },
/* 1415 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-lg> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> {%-name%}: </div> <div class=\"col-lg-3 q-marg-bottom-md-at-md\"> <div class=error-wrapper> <select id=\"{%-key%}\" name=\"{%-key%}\" class=\"select2-select q-input required\" data-placeholder=\"Select {%-name%}\" data-error-placement-append-closest=.error-wrapper data-minimum-results-for-search=10 style=width:100%> {% if(hasAll){ %} <option value=%>All</option> {% } %} </select> </div> </div> <div class=col-lg-6> </div> </div> </div>";

/***/ },
/* 1416 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-lg> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> {%-name%}: </div> <div class=\"col-lg-3 q-marg-bottom-md-at-md\"> <div class=error-wrapper> <input type=text id=\"{%-key%}\" name=\"{%-key%}\" class=\"q-input q-stretch\" placeholder=\"Type {%-name%}\" value=\"{%-value%}\" data-error-placement-append-closest=.error-wrapper /> </div> </div> <div class=col-lg-6> </div> </div> </div>";

/***/ },
/* 1417 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row q-marg-vert-md recipient-row\"> <div class=col-xs-10> <input required class=\"q-input q-stretch schedule-modal-recipients-input\" type=text name=\"modalReportRecipientsInput{%-index%}\" placeholder=johnsmith@retailer1.com /> </div> <div class=\"col-xs-2 q-marg-vert-xxs q-text-center-at-md\"> <a href=# class=delete-recipient> <i class=\"fa fa-times\" aria-hidden=true></i> </a> </div> </div>";

/***/ },
/* 1418 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-md report-schedule-expander\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-vert q-pad-left-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-boldest q-fs-md report-title\"> {%- scheduleName %} </span> </div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=\"q-marg-horz-at-md q-marg-vert-md\"> <div class=row> <div class=\"col-lg-6 q-text-center-til-md q-text-center-at-md\"> <span class=\"q-tag q-pad-right-sm-til-md\"> Next Scheduled Run: </span> <span> {%- nextScheduledRun %} </span> </div> {% if(endRun){ %} <div class=\"col-lg-6 q-text-center-til-md q-text-center-at-md\"> <span class=\"q-tag q-pad-right-sm-til-md\"> End Date: </span> <span> {%- endRun %} </span> </div> {% } %} </div> </div> </div> <div class=\"col-md-2 q-fs-lg q-text-center-at-md\"> <div class=\"q-marg-vert-xxs q-marg-horz q-pull-right-til-md\"> <span> <a class=\"base-btn purple-btn edit-report-schedule\" data-job-name=\"{%= jobName %}\" data-job-id=\"{%= jobId %}\"> <i class=\"q-boldest fa fa-pencil\" aria-hidden=true></i> </a> </span> <span> <a class=\"base-btn purple-btn delete-report-schedule\" data-job-name=\"{%= jobName %}\" data-job-id=\"{%= jobId %}\"> <i class=\"q-boldest fa fa-times\" aria-hidden=true></i> </a> </span> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=\"q-pct-body q-overflow-hidden\"> <div class=\"q-row full-vertical-break-at-md\"> <div class=\"q-col-6 q-relfix q-pad-horz-xl q-pad-bottom-lg\"> <div class=q-pad-vert> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-boldest q-fs-md\"> Parameters </div> </div> <div class=\"col-md-6 col-xs-12\"> </div> </div> </div> </div> </div> {% _(reportParams).each((childRow)=>{ %} <div class=q-pad-vert-sm> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-boldest> <span>{%-paramDetails[childRow.cspKey]%}:</span> </div> </div> <div class=\"col-md-6 col-xs-12\"> <span>{%- (childRow.cspValue == '%') ? 'All' : childRow.displayValue == null ? childRow.cspValue : childRow.displayValue %}</span> </div> </div> </div> </div> </div> {% }) %} <div class=\"solo-divider ds-bottom-at-md ds-grey\"></div> <div class=\"solo-divider ds-pulled-full-height ds-right-til-md ds-full-height ds-grey\"></div> </div> <div class=\"q-col-6 q-relfix q-pad-horz-xl q-pad-bottom-lg\"> <div class=\"q-pad-vert q-overflow-hidden\"> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=\"q-boldest q-fs-md\"> <span>Schedule Details</span> </div> </div> <div class=\"col-md-6 col-xs-12\"> </div> </div> </div> </div> </div> <div class=q-pad-vert-xxs> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=q-boldest> <span>Run Frequency:</span> </div> </div> <div class=\"col-md-8 col-xs-12\"> <span>{%-runFrequency %}</span> </div> </div> </div> </div> </div> <div class=q-pad-vert-xxs> <div class=row> <div class=\"col-md-9 col-xs-12\"> <div class=row> <div class=\"col-md-4 col-xs-12\"> <div class=q-boldest> <span>Recipients:</span> </div> </div> <div class=\"col-md-8 col-xs-12\"> {% _(recipients).each((childRow)=>{ %} <div>{%-childRow%}</div> {% }) %} </div> </div> </div> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1419 */
/***/ function(module, exports) {

	module.exports = "<form class=scheduleModalForm action=\"\" method=POST> <input id=action type=hidden value=Create /> <input id=jobId type=hidden value=\"\"/> <div class=q-section> <div class=q-marg-vert-lg> <div class=q-marg-horz-xl> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> Schedule Name: </div> <div class=col-lg-8> <input id=scheduleName class=\"q-input q-stretch required\" type=text name=scheduleName placeholder=\"Add a name for the schedule\"/> </div> </div> </div> </div> </div> <div class=q-section> <div class=\"q-marg-vert-xl q-marg-top-xxl q-marg-horz-xl\"> <div class=\"q-inline-block-til-md q-text-center-at-md\"> <div class=q-pad-bottom-lg> <h2 class=q-title> Parameters </h2> </div> </div> <div id=reportParamsModalInputAnchor> </div> </div> </div> <div class=q-section> <div class=\"q-marg-vert-xl q-marg-top-xxl q-marg-horz-xl\"> <div class=\"q-inline-block-til-md q-text-center-at-md\"> <div class=q-pad-bottom-lg> <h2 class=q-title> Schedule </h2> </div> </div> <div class=q-marg-vert-lg> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> Run Frequency: </div> <div class=col-lg-3> <select name=frequency class=\"select2-select q-input modal-run-freq-selector\" data-minimum-results-for-search=Infinity style=width:100%> <option selected=selected value=Daily>Daily</option> <option value=Weekly>Weekly</option> <option value=Monthly>Monthly</option> </select> </div> </div> </div> <div class=q-marg-vert-lg id=runDailySched> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> Run Time: </div> <div class=\"col-lg-3 q-marg-bottom-md-at-md\"> <div class=\"time-picker-daily-run q-time-picker-default\"> <div class=time-picker-hours-select-outer> <select selected=selected value=12 class=\"time-picker-hours-select select2-select quick-toggler\"> </select> </div> <span class=time-picker-seperater>:</span> <div class=time-picker-minutes-select-outer> <select class=time-picker-minutes-select> </select> </div> <div class=time-picker-period-select-outer> <select class=time-picker-period-select> </select> </div> </div> </div> <div class=col-lg-3> <select name=modalTimeZone class=\"select2-select q-input modal-time-zone-selector\" data-minimum-results-for-search=Infinity style=width:100%> <option value=\"\" disabled=disabled>Time Zone</option> <option value=EST selected=selected>EST</option> </select> </div> </div> <div class=row> <div class=col-lg-3></div> <div id=invalidTime class=col-lg-3> </div> <div class=col-lg-3></div> </div> </div> <div class=q-marg-vert-lg id=runWeeklySched> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> Run Day/Time: </div> <div class=\"col-lg-6 q-marg-bottom-md-at-md\"> <div class=\"q-btn-flex-group qb-purple-theme q-text-center multi-btn-group modal-schedule-day-toggler\"> <a href=# class=\"q-btn q-btn-cube first-child active\" data-qb-key=Sunday> S </a> <a href=# class=\"q-btn q-btn-cube\" data-qb-key=Monday> M </a> <a href=# class=\"q-btn q-btn-cube\" data-qb-key=Tuesday> T </a> <a href=# class=\"q-btn q-btn-cube\" data-qb-key=Wednesday> W </a> <a href=# class=\"q-btn q-btn-cube\" data-qb-key=Thursday> TH </a> <a href=# class=\"q-btn q-btn-cube\" data-qb-key=Friday> F </a> <a href=# class=\"q-btn q-btn-cube last-child\" data-qb-key=Saturday> S </a> <input type=hidden class=quick-btn-group-hidden-input name=specificDay /> </div> </div> <div class=col-lg-3> <div class=\"time-picker-weekly-run q-time-picker-default\"> <div class=time-picker-hours-select-outer> <select class=time-picker-hours-select> </select> </div> <span class=time-picker-seperater>:</span> <div class=time-picker-minutes-select-outer> <select class=time-picker-minutes-select> </select> </div> <div class=time-picker-period-select-outer> <select class=time-picker-period-select> </select> </div> </div> </div> </div> </div> <div class=q-marg-vert-lg id=runMonthlySched> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> Day of Month: </div> <div class=\"col-lg-3 q-marg-bottom-md-at-md\"> <select name=specificDay id=dayOfMonth class=\"select2-select q-input modal-day-of-month-selector\" data-minimum-results-for-search=Infinity style=width:100%> <option value=FirstDay>First Day of Month</option> <option value=LastDay>Last Day of Month</option> <option value=SpecificDay>Specific Day of Month</option> </select> </div> <div class=col-lg-6 id=specificDayDiv> Select Specific Day: <select name=dayOfMonth id=specificDay class=\"select2-select q-input modal-day-of-month-selector\" data-minimum-results-for-search=Infinity style=width:50px> <option value=1>1</option> <option value=2>2</option> <option value=3>3</option> <option value=4>4</option> <option value=5>5</option> <option value=6>6</option> <option value=7>7</option> <option value=8>8</option> <option value=9>9</option> <option value=10>10</option> <option value=11>11</option> <option value=12>12</option> <option value=13>13</option> <option value=14>14</option> <option value=15>15</option> <option value=16>16</option> <option value=17>17</option> <option value=18>18</option> <option value=19>19</option> <option value=20>20</option> <option value=21>21</option> <option value=22>22</option> <option value=23>23</option> <option value=24>24</option> <option value=25>25</option> <option value=26>26</option> <option value=27>27</option> <option value=28>28</option> </select> </div> </div> </div> <div class=q-marg-vert-lg id=runQuarterlySched> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> First Quarter Start: </div> <div class=\"col-lg-3 q-marg-bottom-md-at-md\"> <select name=modalActualMonthName class=\"select2-select q-input modal-actual-month-name-selector\" data-minimum-results-for-search=Infinity style=width:100%> <option value=March>March</option> <option value=June>June</option> <option value=September>September</option> <option value=December>December</option> </select> </div> <div class=col-lg-6> </div> </div> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> </div> <div class=\"col-lg-5 q-marg-bottom-md-at-md\"> <div class=\"q-alert q-alert-grey q-pad-vert-xxs q-marg-bottom-xxs-at-md\"> Report to run on last day of <strong>the selected month</strong> </div> </div> </div> </div> <div class=q-marg-vert-lg> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> End Date: </div> <div class=\"col-lg-4 q-marg-bottom-md-at-md\"> <select name=endDate class=\"select2-select q-input modal-schedule-end-date-selector\" data-minimum-results-for-search=Infinity style=width:100%> <option value=noSchedEndDate>No End Date</option> <option value=schedEndDate>End Date</option> </select> </div> <div class=\"col-lg-3 end-date-input-div\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-static-col-1_5 q-input-first func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input required\" id=endDateInput name=modalEndDateRange type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"   /   /   \"/> </div> </div> </div> <div class=row> <div class=col-lg-3></div> <div class=col-lg-4></div> <div id=invalidDate class=col-lg-3> </div> </div> </div> <div class=q-marg-vert-lg> <div class=\"row q-marg-vert-md\"> <div class=col-lg-3> <div class=q-marg-vert-xxs> Recipients: </div> </div> <div class=col-lg-9> <div id=recipients> <div class=row> <div class=col-xs-10> <input class=\"q-input q-stretch schedule-modal-recipients-input required\" type=text name=modalReportRecipientsInput placeholder=\"Enter email address\"/> </div> </div> <div class=\"row q-marg-vert-md recipient-row\"> <div class=col-xs-10> <input class=\"q-input q-stretch schedule-modal-recipients-input\" type=text name=modalReportRecipientsInput1 placeholder=\"Enter email address\"/> </div> <div class=\"col-xs-2 q-marg-vert-xxs q-text-center-at-md\"> <a href=# class=delete-recipient> <i class=\"fa fa-times\" aria-hidden=true></i> </a> </div> </div> </div> <div class=\"row q-marg-vert-md\"> <div class=col-xs-10> <a href=# class=\"q-block-at-md q-text-center-at-md base-btn purple-btn v2-btn add-recipient\"> <i class=\"fa fa-plus-circle\" aria-hidden=true></i> Add another recipient </a> </div> </div> </div> </div> </div> </div> </div> </form>";

/***/ },
/* 1420 */
/***/ function(module, exports) {

	module.exports = "<span class=\"q-pill q-pill-min-sm {%- statusClass %}\"> {%- statusText %} </span>";

/***/ },
/* 1421 */
1271,
/* 1422 */
/***/ function(module, exports) {

	module.exports = "{% if (showOrHide === \"show\" && rmdAmlStatus === \"U\" && rmaFromCountry === \"CA\" && unauthPrintHeader) {  %} <div class=\"q-marg-vert-xl unauthorizedMessageDiv\"> <div class=\"q-alert q-alert-red\"> There are unauthorized products for a Canadian return below. Please remove any products marked. </div> </div> {% } %} <div class=\"q-marg-vert-xl warehouse-item-returning-loop-wrapper\"> <div class=\"q-bg-c-lightest-grey q-border-all\"> <div class=q-pad-all-md> <div class=\"q-flex-row qfr-vert-center-align\"> <div class=\"q-col-2 q-marg-vert-md-at-md\" style=display:none> <input type=hidden name=\"{%-formIndexEle %}.rmdId\" value=\"{%-optional.rmdId %}\" class=itmSkuHidden /> </div> <div class=\"q-col-2 q-marg-vert-md-at-md\"> {% if (showOrHide === \"show\" && rmdAmlStatus === \"U\" && rmaFromCountry === \"CA\") { %} <i class=\"fa fa-exclamation-circle q-icon-md q-icon-marg-right txt-c-red\" aria-hidden=true></i> {% } %} <span class=q-tag>Item SKU:</span> <span class=warehouseitmSku>{%- sku %}</span> <input type=hidden name=\"{%-formIndexEle %}.itemSku\" value=\"{%- skuHidden %}\" class=itmSkuHidden /> </div> <div class=\"q-col-2 q-marg-bottom-md-at-md\"> <span class=q-tag>UPC:</span> <span class=warehouseitmUpc>{%- upc %}</span> </div> <div class=\"q-col-3 q-marg-bottom-md-at-md\"> <span class=q-tag>Model:</span> <span class=warehouseitmModel>{%- model %}</span> </div> <div class=\"q-col-fix-130 q-marg-bottom-md-at-md\"> <div class=q-input-group-flex-container> <div class=\"q-input-group q-ig-with-units\"> <span class=\"q-ig-units q-tag\">QTY</span> <input type=number placeholder=00* class=\"q-input required add-warehouse-rma-product-quantity\" name=\"{%-formIndexEle %}.itemExpectedQty\" id=\"add-warehouse-rma-product-quantity-{%-formIndexEle %}\" min=1 data-error-placement-append-closest=.q-col-fix-130 value=\"{%-optional.itemExpectedQty %}\"/> </div> </div> </div> <div class=\"q-col-3 q-marg-bottom-md-at-md\"> <div class=\"q-input-group-flex-container q-marg-top-md-at-md\"> <div class=\"q-input-group q-ig-with-units\"> <span class=\"q-ig-units q-tag\">RTV</span> <input type=text placeholder=\"Enter Number\" class=q-input name=\"{%-formIndexEle %}.rtvNum\" id=warehouseRTV value=\"{%-optional.rtvNum %}\"/> </div> </div> </div> <div class=q-col-fix-40> <a href=# class=\"base-btn q-close-btn q-display-none-at-md\"><i class=\"fa fa-times warehouse-rma-item-remove\" aria-hidden=true></i></a> <a href=# class=\"base-btn purple-btn v2-btn q-display-none q-block-at-md q-text-center\">Remove</a> </div> </div> </div> </div> </div>";

/***/ },
/* 1423 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=\"q-alert q-alert-yellow\"> A similar SKU has already been added to this RMA. </div> </div> <div class=q-marg-vert-md> <span class=q-boldest>If this was done to accurately document different return captures (such as the return reason and original order number):</span> Please continue in adding this as an additional SKU. </div> <div class=q-marg-vert-md> <span class=q-boldest>If the SKUs share the same return captures:</span> Please select \"Do Not Add\" and change the quantity of the shared SKU from 1 to the amount of similar SKUs being added to this RMA. </div> </div>";

/***/ },
/* 1424 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-all-xl item-returning-loop-wrapper\"> <div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-md\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-pad-vert q-pad-left-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-pad-right-sm-til-md\"> SKU: </span> <span class=itmSku> </span> <input type=hidden name=\"\" value=\"\" class=itmSkuHidden /> </div> </div> <div class=\"col-md-9 col-xs-12\"> <div class=\"q-marg-horz-at-md q-marg-vert-md\"> <div class=row> <div class=\"col-lg-6 q-text-center-at-md\"> <span class=\"q-tag q-pad-right-sm-til-md\"> UPC: </span> <span class=itmUpc> </span> </div> <div class=\"col-lg-6 q-text-center-at-md\"> <span class=\"q-tag q-pad-right-sm-til-md\"> Description: </span> <span class=itmDescription> </span> </div> </div> </div> </div> </div> </div> <div class=\"q-pct-header-group-expander add-rma-itm-attr-dropdown\"> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-marg-horz-md q-marg-top-md\"> <div class=\"row add-rma-itm-attr\"> <div class=\"col-md-6 col-xl-12 q-marg-bottom-md add-rma-itm-attr-div\"> <div class=row> <div class=\"col-md-6 col-xl-12\"> <span class=\"q-tag add-rma-itm-attr-name\">Brand:</span> </div> <div class=\"col-md-6 col-xl-12\"> <span class=\"itmBrand add-rma-itm-attr-value\"></span> </div> </div> </div> <div class=\"col-md-6 col-xl-12 q-marg-bottom-md add-rma-itm-attr-div\"> <div class=row> <div class=\"col-md-6 col-xl-12\"> <span class=\"q-tag add-rma-itm-attr-name\">Model:</span> </div> <div class=\"col-md-6 col-xl-12\"> <span class=\"itmModel add-rma-itm-attr-value\"></span> </div> </div> </div> </div> </div> </div> </div> <div class=q-pct-footer> <div class=q-pad-all-xl> <div class=row> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <div class=row> <div class=col-xs-12> <label class=\"q-label q-label-top\">Returning Quantity *</label> <div class=clearfix></div> <input type=number min=1 max=1000 value=0 class=\"q-input required add-rma-product-quantity\" id=add-rma-return-quantity /> </div> </div> <div class=row> <div class=\"col-xs-12 q-fs-lg q-text-center-at-md\"> <div class=\"q-marg-vert-lg q-pull-left-til-md q-marg-bottom-md-at-md\"> <a class=\"base-btn purple-btn v2-btn rma-item-remove\"> Remove Product </a> </div> </div> </div> </div> <div class=\"col-md-9 col-xs-12 q-marg-bottom-md-at-md\"> <div class=row> <div class=\"col-md-8 col-xs-12 q-marg-bottom-md-at-md add-rma-reason-div\"> <label class=\"q-label q-label-top\">Reason for The Return *</label> <select class=\"select2-select required product-select-block add-rma-reason\" style=width:100% data-error-placement-append-closest=div> <option value=\"\">Select the reason for returning the item</option> </select> </div> <div class=\"col-md-4 col-xs-12 add-rma-product-final-sale-div\"> <div class=\"checkbox q-checkbox checkbox-success cb-large cb-unchecked-white pwc-checkbox-top-marg\"> <label class=\"q-tag q-no-pad-vert\"> <input type=checkbox class=add-rma-product-final-sale value=1 /> <span class=cb-label-inner>This Item is final sale</span> </label> </div> </div> <div class=\"col-md-8 col-xs-12 original-order-number\"> <label class=\"q-label q-label-top original-order-number-required\">Original Order Number *</label> <label class=\"q-label q-label-top original-order-number-not-required\">Original Order Number</label> <input type=text class=\"q-input q-stretch add-rma-order-number\" placeholder=\"Order Number\"/> </div> <div class=\"col-md-4 col-xs-12 add-rma-product-weight-div\"> <label class=\"q-label q-label-top\">Product Weight </label> <input type=number min=0.1 class=\"q-number q-stretch add-rma-product-weight\" placeholder=\"Weight (Pounds)\"/> </div> <div class=\"col-md-12 col-xs-12 add-rma-notes-div\"> <label class=\"q-label q-label-top\">Notes</label> <textarea class=\"q-input q-stretch add-rma-notes\" placeholder=\"\" rows=4 maxlength=200 />\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"q-marg-vert-xl item-marked-as-non-returnable-msg\">\r\n      <div class=\"q-alert q-alert-yellow\">\r\n        This product is marked as non-returnable. To override the return eligibility, select the quantity and reason for return above.\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1425 */
/***/ function(module, exports) {

	module.exports = "<div class=\"col-md-6 col-xl-12 q-marg-bottom-md add-rma-itm-attr-div\"> <div class=row> <div class=\"col-md-6 col-xl-12\"> <span class=\"q-tag add-rma-itm-attr-name\"></span> </div> <div class=\"col-md-6 col-xl-12\"> <span class=add-rma-itm-attr-value></span> </div> </div> </div>";

/***/ },
/* 1426 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pct-no-marg-util\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=q-pad-all-md> <div class=row> <div class=\"col-xs-12 q-display-none q-block-at-md\"> <span class=q-tag>Product Name (SKU):</span> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-xs-at-md\"> <span class=rev-rma-prod-sku> </span> </div> <div class=\"col-xs-12 q-display-none q-block-at-md\"> <span class=q-tag>UPC:</span> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-xs-at-md\"> <span class=rev-rma-upc> </span> </div> <div class=\"col-xs-12 q-display-none q-block-at-md\"> <span class=q-tag>Product Description:</span> </div> <div class=\"col-md-4 col-xs-12 q-marg-bottom-xs-at-md\"> <span class=rev-rma-prod-descrip> </span> </div> <div class=\"col-xs-12 q-display-none q-block-at-md\"> <span class=q-tag>Return QTY:</span> </div> <div class=\"col-md-2 col-xs-12 q-marg-bottom-xs-at-md\"> <span class=rev-rma-qty> </span> </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-marg-horz-md q-marg-top-md\"> <div class=\"row review-rma-itm-attr\"> </div> </div> <div class=\"q-pad-all-md q-border-top review-rma-notes\"> <div class=row> <div class=\"col-md-3 col-xl-12\"> <span class=\"q-tag add-rma-itm-attr-name\">Notes:</span> </div> <div class=\"col-md-9 col-xl-12\"> <span class=add-rma-itm-attr-value></span> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1427 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-top-md> <div class=\"q-bg-c-lightest-grey q-border-all\"> <div class=q-pad-all-md> <div class=row> <div class=\"col-md-2 col-xs-12 q-marg-bottom-md-at-md\"> <span class=q-tag>SKU: </span> <span class=\"rev-whs-rma-prod-sku q-boldest boldest\">{%- sku %}</span> </div> <div class=\"col-md-2 col-xs-12 q-marg-bottom-md-at-md\"> <span class=q-tag>UPC: </span> <span class=rev-whs-rma-upc>{%- upc %}</span> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <span class=q-tag>Model: </span> <span class=rev-whs-rma-modal>{%- desc %}</span> </div> <div class=\"col-md-2 col-xs-12 q-marg-bottom-md-at-md\"> <span class=q-tag>QTY: </span> <span class=rev-whs-rma-qty>{%- qty %}</span> </div> <div class=\"col-md-3 col-xs-12\"> <span class=q-tag>RTV: </span> <span class=rev-whs-rma-rtv>{%- rtv %}</span> </div> </div> </div> </div> </div>";

/***/ },
/* 1428 */
/***/ function(module, exports) {

	module.exports = "<a href={%- ruleHref %}> {%- value %} </a>";

/***/ },
/* 1429 */
/***/ function(module, exports) {

	module.exports = "<a href=#><i class=\"fa q-link-icon q-marg-right-xs {%- toggleStatusIconClassName %}\"></i></a> <a href=#><i class=\"fa fa-pencil q-link-icon return-rule-edit-btn\"></i></a>";

/***/ },
/* 1430 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pill q-pill-table rr-table-status-text {%- pillClassName %}\"> {%- value %} </div>";

/***/ },
/* 1431 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-md> <h2 class=q-section-title> 1. Accounts and stuff </h2> </div> <p class=\"q-italic text-grey\">Add Your FedEx shipping Account you use for returns, your account will be assigned to your ship to locations as to what account to charge the shipments to.</p> <hr> <span class=\"q-boldest q-italic q-text-purple\">Account Information:</span> <div class=\"accounts-section q-marg-top-md\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <label class=q-label>FedEx Shipping Account Number *</label> <input required type=text class=\"q-input q-stretch fedex-shipping-account-num\"> <p class=\"q-italic text-grey q-marg-top-md\">The account number must be registered to the address provided when the setup process started. </p></div> <div class=\"col-md-5 col-xs-12\"> <label class=q-label>SmartPost Hub Id</label> <input type=text class=\"q-input q-stretch smart-post-hub-id\"> <p class=\"q-italic text-grey q-marg-top-md\">If you are registered with smart-post and hold a HUB ID enter it here. If you do not use smart-post leave this field blank.</p> </div> <div class=\"col-md-2 col-xs-12\"> <a href=\"\" class=\"base-btn purple-btn q-marg-top-xl-til-md q-marg-top-md-at-md create-btn\" id=createBtnAccount>Create</a> </div> </div> </div> <div class=edit-account-address-section> <div class=\"q-section q-section-border-top q-marg-top-md\"> <div class=\"q-expandable-wrap q-no-pad q-marg-top-lg\"> <div class=q-expandable-header> <span class=\"q-boldest q-italic q-text-purple\">Edit Account Address:</span> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.fields-sectiion data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div id=editAddressSection class=\"fields-sectiion q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Merchant Name * & Merchant URL *</label> </div> <div class=\"col-md-4_5 col-xs-12\"> <input type=text class=\"q-input q-stretch merchant-name\" placeholder=\"Enter merchant name\"> </div> <div class=\"col-md-4_5 col-xs-12\"> <input type=text class=\"q-input q-stretch merchant-web-url\" placeholder=\"Enter merchant url\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input required type=text class=\"q-input q-stretch ret-address1\" placeholder=\"Enter address\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <input type=text class=\"q-input q-stretch ret-address2\" placeholder=\"Enter address line 2 (optional)\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required type=text class=\"q-input q-stretch ret-city\" placeholder=\"Enter city\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>State *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select required id=address-state class=\"select2-select q-input ret-state\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select a state\" data-s2-minimum-results-for-search=7> <option></option> </select> </div> </div> <div class=\"col-md-6 col-xs-12 state-text-wrapper\" id=stateTextContainer style=display:none> <div> <input class=\"qw-input stretch ret-state-text\" id=stateText maxlength=40 name=stateText placeholder=State/Province/Region type=text>  </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Zipcode *</label> </div> <div class=\"col-md-3 col-xs-12\"> <input required type=text class=\"q-input q-stretch ret-zip-code\" placeholder=\"Enter postal code\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=selfAccountCountry class=q-label>Country *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select q-input acc-country\" style=width:100% data-error-placement-append-closest=div id=selfAccountCountry name=selfAccountCountry data-s2-placeholder=\"Select Country\" data-s2-minimum-results-for-search=7 required> <option value=-1 disabled=\"\" selected=\"\">Select Country</option> </select> </div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-5 col-xs-12 col-md-offset-3\"> <a href=\"\" class=\"base-btn purple-btn save-account-address-btn\">Save Account Address</a> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <a href=# class=\"qw-next base-btn purple-btn accounts-prod-btn disabled\" style=display:block> Next <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> </div> </div>";

/***/ },
/* 1432 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-md> <h2 class=q-section-title> 1. Accounts and stuff </h2> </div> <p class=\"q-italic text-grey\"> A FedEx test shipping account has been added for this merchant. You can create as many test RMAs with labels as needed in this environment using this account. </p> <hr> <span class=\"q-boldest q-italic q-text-purple\">Account Information:</span> <div class=\"accounts-section q-marg-top-md\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <label class=q-label>FedEx Shipping Account Number</label> <input required type=text class=\"q-input q-stretch\" id=fedex-shipping-account-num value=510087020 disabled=disabled> <p class=\"q-italic text-grey q-marg-top-md\">The account number must be registered to the address provided when the setup process started. </p></div> <div class=\"col-md-5 col-xs-12\"> <label class=q-label>SmartPost Hub Id</label> <input type=text class=\"q-input q-stretch\" id=smart-post-hub-id value=5531 disabled=disabled> </div> </div> </div> <div class=q-marg-vert-xl> <div class=\"togglable-parent q-marg-vert-md\"> <div class=row> </div> </div> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <a href=# class=\"qw-next base-btn purple-btn smart-post-btn enabled\" style=display:block> Next <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> </div> </div> </div>";

/***/ },
/* 1433 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default-base q-max-page-width-md q-page-center-margin\"> <div class=\"q-card q-card-white\"> <div class=\"q-section enroll-steps-section\"> <div class=\"header q-pad-vert-sm q-pad-horz-xl q-bg-c-purple\"></div> <div class=\"q-section q-no-border-bottom\"> <div class=q-marg-all-xl> <div class=logo-section> <img src=data:image/png;base64,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 /> </div> <h2 class=\"q-title q-boldest q-underline\"> Returns Technology Registration </h2> <hr> </div> </div> <div class=q-marg-all-xl> <div class=\"q-marg-bottom-md q-italic txt-c-grey\"> At this time you will input the merchant name and address that is affillated with the FedEx shipping account that will be utilized with the Returns Technology application.</div> <div class=\"q-title txt-c-red q-marg-vert-md\"> * The address entered must be the address associated with your nine digit shipping account registration. </div> <h2 class=q-title> Enrollment Steps: </h2> <div class=\"q-marg-vert-xl q-step-item\"> <div class=q-step-item-number> <div class=\"q-circle qc-purple\"> 1 </div> </div> <div class=\"q-step-item-text q-boldest\"> Merchant Account Creation </div> </div> <form class=initialRegistrationForm action=\"\" method=POST> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Merchant Name * & Merchant URL *</label> </div> <div class=\"col-md-4_5 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-MerchantName\" id=selfMerchantName name=selfMerchantName placeholder=\"Enter merchant name\" data-error-placement-append-closest=div /> <label class=\"merchantNameError q-sim-error\" id=merchant-name-exist-error hidden=true style=display:none>Retailer name already exist.</label> </div> <div class=\"col-md-4_5 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-MerchantUrl\" id=selfMerchantUrl name=selfMerchantUrl placeholder=\"Enter merchant url\" data-error-placement-append-closest=div /> <label class=\"merchantUrlError q-sim-error\" id=merchant-invalid-error hidden=true style=display:none>URL is not valid.</label> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=selfMerchantCountry class=q-label>Country *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select q-input ret-country\" style=width:100% data-error-placement-append-closest=div id=selfMerchantCountry name=selfMerchantCountry data-s2-placeholder=\"Select Country\" data-s2-minimum-results-for-search=7 required> <option value=-1 disabled=\"\" selected=selected>Select Country</option> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input required type=text class=\"q-input q-stretch ret-address1\" id=selfMerchantAddress1 name=selfMerchantAddress1 placeholder=\"Enter address\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <input type=text class=\"q-input q-stretch ret-address2\" id=selfMerchantAddress2 name=selfMerchantAddress2 placeholder=\"Enter address line 2 (optional)\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-city\" id=selfMerchantCity name=selfMerchantCity placeholder=\"Enter city\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=selfMerchantState id=state-label class=q-label>Select State/Province/Region *</label> </div> <div class=\"col-md-6 col-xs-12 state-wrapper\" id=selfMerchantStateContainer> <div> <select name=selfMerchantState class=\"select2-select q-input ret-state\" id=selfMerchantState style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select State/Province/Region\" data-s2-minimum-results-for-search=5 required=true> <option value=-1 disabled=\"\" selected=\"\">Select State/Province/Region</option> </select> </div> </div> <div class=\"col-md-6 col-xs-12 state-text-wrapper\" id=stateTextContainer style=display:none> <div> <input class=\"qw-input stretch ret-state-text\" id=stateText maxlength=40 name=stateText placeholder=State/Province/Region type=text>  </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Zipcode *</label> </div> <div class=\"col-md-3 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-zip-code\" id=selfMerchantZip name=selfMerchantZip placeholder=\"Enter postal code\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Contact First Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-Contact-first-name\" id=selfMerchantContactFirstName name=selfMerchantContactFirstName placeholder=\"Enter contact First name\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Contact Last Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-Contact-last-name\" id=selfMerchantContactLastName name=selfMerchantContactLastName placeholder=\"Enter contact Last name\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Email Address *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-Contact-Email\" id=selfMerchantEmail name=selfMerchantEmail placeholder=\"Enter email address\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone Number *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select required class=select2-select style=width:35% data-s2-full-width-list=true data-error-placement-append-closest=div id=selfMerchantPhoneCode name=selfMerchantPhoneCode data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=7> <option></option> </select> <input required=true class=\"q-input q-ig-flex-fill ret-Merchant-Contact-Phone\" id=selfMerchantPhone name=selfMerchantPhone placeholder=\"Enter phone number\"/> </div> </div> </div> </div> </div> <div class=\"q-marg-vert-xl q-step-item\"> <div class=q-step-item-number> <div class=\"q-circle qc-purple\"> 2 </div> </div> <div class=\"q-step-item-text q-boldest\"> Initial User Account </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>First & Last Name *</label> </div> <div class=\"col-md-4_5 col-sm-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-User-FirstName\" id=selfUserFirstName name=selfUserFirstName placeholder=\"First name\" data-error-placement-append-closest=div /> </div> <div class=\"col-md-4_5 col-sm-6 col-xs-12\"> <div class=q-marg-top-md-at-xs> <input required=true type=text class=\"q-input q-stretch ret-Merchant-User-LastName\" id=selfUserLastName name=selfUserLastName placeholder=\"Last name\" data-error-placement-append-closest=div /> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Title *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-User-Org-Title\" id=selfUserOrgTitle name=selfUserOrgTitle placeholder=\"Enter organizational title\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select required class=select2-select style=width:35% data-s2-full-width-list=true data-error-placement-append-closest=.col-md-6 id=selfUserCountryCode name=selfUserCountryCode data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=7> <option></option> </select> <input required=true class=\"q-input q-ig-flex-fill ret-Merchant-User-Phone\" id=selfUserPhone name=selfUserPhone placeholder=\"Enter phone number\"/> </div> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Account Email *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch required emailAddress ret-Merchant-User-Email\" id=selfUserEmail name=selfUserEmail placeholder=\"Enter account email\" data-error-placement-append-closest=div /> <label class=\"userNameError q-sim-error\" id=user-email-exist-error hidden=true style=display:none>Email is already taken.</label> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>User ID *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch required screenName ret-Merchant-User-Id\" id=selfUserId name=selfUser placeholder=\"Enter user id\" data-error-placement-append-closest=div /> <label class=\"userNameError q-sim-error\" id=user-exist-error hidden=true style=display:none>UserName is already taken.</label> </div> </div> </div> <div class=\"q-marg-vert-md q-italic txt-c-grey\"> This account will automatically be added to the retail admin group and have full administration of the merchants environment.</div> </form></div> <div class=q-footer> <div class=\"q-footer-btn-group q-pull-right-til-md\"> <a href=# class=\"q-block-at-md q-marg-top-md-at-md q-text-center-at-md base-btn purple-btn submit-account-btn\">Submit</a> </div> </div>  </div> <div class=\"modal fade q-modal q-default-base q-default fedex-account-select-modal q-reset\" style=display:none id=confirmationBox role=dialog> <div class=modal-dialog> <div class=modal-content> <div class=\"modal-header q-modal-header-double\"> <h4 class=\"q-modal-title q-text-center\">Attention</h4> <h5 class=q-modal-sub-title>At this time you will exit the returns technology system and be required to change your password through link sent throgh your initial user email account Once completed the configuration process will contnue Click the below button to continue. </h5> </div> <div class=modal-body> <div class=q-bg-c-lightest-grey> <div class=q-section> </div> </div> </div> <div class=modal-footer> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <a href=# id=initail-reg-modal-cancel class=\"base-btn purple-btn\"> <i class=\"fa fa-angle-left\" aria-hidden=true></i> Cancel </a> <a href=# id=initail-reg-modal-continue class=\"base-btn purple-btn\"> Continue <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1434 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default-base q-max-page-width-md q-page-center-margin\"> <div class=\"q-card q-card-white\"> <div class=\"q-section enroll-steps-section\"> <div class=\"header q-pad-vert-sm q-pad-horz-xl q-bg-c-purple\"></div> <div class=\"q-section q-no-border-bottom\"> <div class=q-marg-all-xl> <div class=logo-section> <img src=data:image/png;base64,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 /> </div> <h2 class=\"q-title q-boldest q-underline\"> Returns Technology Registration </h2> <hr> </div> </div> <div class=q-marg-all-xl> <h2 class=q-title> Enrollment Steps: </h2> <div class=\"q-marg-vert-xl q-step-item\"> <div class=q-step-item-number> <div class=\"q-circle qc-purple\"> 1 </div> </div> <div class=\"q-step-item-text q-boldest\"> Merchant Account Creation </div> </div> <form class=initialSandboxRegistrationForm action=\"\" method=POST> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Merchant Name * & Merchant URL *</label> </div> <div class=\"col-md-4_5 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-MerchantName\" id=selfMerchantName name=selfMerchantName placeholder=\"Enter merchant name\" data-error-placement-append-closest=div /> <label class=\"merchantNameError q-sim-error\" id=merchant-name-exist-error hidden=true style=display:none>Retailer name already exist.</label> </div> <div class=\"col-md-4_5 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-MerchantUrl\" id=selfMerchantUrl name=selfMerchantUrl placeholder=\"Enter merchant url\" data-error-placement-append-closest=div /> <label class=\"merchantUrlError q-sim-error\" id=merchant-invalid-error hidden=true style=display:none>URL is not valid.</label> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Contact First Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-Contact-first-name\" id=selfMerchantContactFirstName name=selfMerchantContactFirstName placeholder=\"Enter contact First name\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Contact Last Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-Contact-last-name\" id=selfMerchantContactLastName name=selfMerchantContactLastName placeholder=\"Enter contact Last name\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Email Address *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-Contact-Email\" id=selfMerchantEmail name=selfMerchantEmail placeholder=\"Enter email address\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone Number *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select required class=select2-select style=width:35% data-s2-full-width-list=true data-error-placement-append-closest=div id=selfMerchantPhoneCode name=selfMerchantPhoneCode data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=7> <option></option> </select> <input required=true class=\"q-input q-ig-flex-fill ret-Merchant-Contact-Phone\" id=selfMerchantPhone name=selfMerchantPhone placeholder=\"Enter phone number\"/> </div> </div> </div> </div> </div> <div class=\"q-marg-vert-xl q-step-item\"> <div class=q-step-item-number> <div class=\"q-circle qc-purple\"> 2 </div> </div> <div class=\"q-step-item-text q-boldest\"> Initial User Account </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>First & Last Name *</label> </div> <div class=\"col-md-4_5 col-sm-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-User-FirstName\" id=selfUserFirstName name=selfUserFirstName placeholder=\"First name\" data-error-placement-append-closest=div /> </div> <div class=\"col-md-4_5 col-sm-6 col-xs-12\"> <div class=q-marg-top-md-at-xs> <input required=true type=text class=\"q-input q-stretch ret-Merchant-User-LastName\" id=selfUserLastName name=selfUserLastName placeholder=\"Last name\" data-error-placement-append-closest=div /> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Title *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch ret-Merchant-User-Org-Title\" id=selfUserOrgTitle name=selfUserOrgTitle placeholder=\"Enter organizational title\" data-error-placement-append-closest=div /> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select required class=select2-select style=width:35% data-s2-full-width-list=true data-error-placement-append-closest=.col-md-6 id=selfUserCountryCode name=selfUserCountryCode data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=7> <option></option> </select> <input required=true class=\"q-input q-ig-flex-fill ret-Merchant-User-Phone\" id=selfUserPhone name=selfUserPhone placeholder=\"Enter phone number\"/> </div> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Account Email *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch required emailAddress ret-Merchant-User-Email\" id=selfUserEmail name=selfUserEmail placeholder=\"Enter account email\" data-error-placement-append-closest=div /> <label class=\"userNameError q-sim-error\" id=user-email-exist-error hidden=true style=display:none>Email is already taken.</label> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>User ID *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required=true type=text class=\"q-input q-stretch required screenName ret-Merchant-User-Id\" id=selfUserId name=selfUser placeholder=\"Enter user id\" data-error-placement-append-closest=div /> <label class=\"userNameError q-sim-error\" id=user-exist-error hidden=true style=display:none>UserName is already taken.</label> </div> </div> </div> <div class=\"q-marg-vert-md q-italic txt-c-grey\"> This account will automatically be added to the retail admin group and have full administration of the merchants environment.</div> </form></div> <div class=q-footer> <div class=\"q-footer-btn-group q-pull-right-til-md\"> <a href=# class=\"q-block-at-md q-marg-top-md-at-md q-text-center-at-md base-btn purple-btn submit-account-btn\">Submit</a> </div> </div>  </div> <div class=\"modal fade q-modal q-default-base q-default fedex-account-select-modal q-reset\" style=display:none id=confirmationBox role=dialog> <div class=modal-dialog> <div class=modal-content> <div class=\"modal-header q-modal-header-double\"> <h4 class=\"q-modal-title q-text-center\">Attention</h4> <h5 class=q-modal-sub-title>At this time you will exit the returns technology system and be required to change your password through link sent throgh your initial user email account Once completed the configuration process will contnue Click the below button to continue. </h5> </div> <div class=modal-body> <div class=q-bg-c-lightest-grey> <div class=q-section> </div> </div> </div> <div class=modal-footer> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <a href=# id=initail-reg-modal-cancel class=\"base-btn purple-btn\"> <i class=\"fa fa-angle-left\" aria-hidden=true></i> Cancel </a> <a href=# id=initail-reg-modal-continue class=\"base-btn purple-btn\"> Continue <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1435 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-md> <h2 class=q-section-title> 2. Locations </h2> </div> <p class=\"q-italic text-grey\">Add all of the ship to locations you use for returns, your accounts will be assigned to your ship to locations as to what account to charge the shipments to.</p> <hr> <div class=\"q-section q-marg-bottom-md\" style=display:none id=shipToLocations> <div class=\"q-marg-top-xl q-marg-bottom-md\"> <h2 class=q-section-title> Ship to locations </h2> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility ID:</span> </div> <div class=\"col-md-6 col-xs-12 fac-id-view\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility Name:</span> </div> <div class=\"col-md-6 col-xs-12 fac-name-view\"> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Address :</span> </div> <div class=\"col-md-6 col-xs-12 fac-address1-view\"> <div class=\"col-md-6 col-xs-12 fac-address2-view\"></div> <div class=\"col-md-6 col-xs-12 fac-countrty-view\"></div> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>City:</span> </div> <div class=\"col-md-6 col-xs-12 fac-city-view\"> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>State:</span> </div> <div class=\"col-md-6 col-xs-12 fac-state-view\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Zipcode:</span> </div> <div class=\"col-md-6 col-xs-12 fac-zipcode-view\"> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Contact Name:</span> </div> <div class=\"col-md-6 col-xs-12 fac-contactname-view\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Email Address:</span> </div> <div class=\"col-md-6 col-xs-12 fac-contact-email-view\"> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Phone Number:</span> </div> <div class=\"col-md-6 col-xs-12 fac-phone-view\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>FedEx Shipping Account Number:</span> </div> <div class=\"col-md-6 col-xs-12 fac-shipping-account-view\"> </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=\"q-expandable-wrap q-no-pad q-marg-top-lg\"> <div class=q-expandable-header> <span id=completeFieldsMsg class=\"q-boldest q-italic q-text-purple\">Complete all required fields below:</span> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.fields-sectiion data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> <a href=\"\" id=shipToLocationsEdit style=display:none class=\"base-btn purple-btn q-pull-right q-marg-horz-xs loc-edit\">Edit</a> </div> <div id=saveLocationSection style=display:block class=\"fields-sectiion q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <span id=noneAddedMsg class=q-italic>None added at this time</span> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Facility ID* & Facility Name*</label> </div> <div class=\"col-md-4 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-loc-id\" id=selfMerchantLocId name=selfMerchantLocID placeholder=\"Enter Facility ID *\"> <label class=\"q-sim-error dup-facId\" style=display:none> Fac Id alredy existed! </label> </div> <div class=\"col-md-4 col-xs-12 q-marg-top-md-at-md\"> <input required type=text class=\"q-input q-stretch fac-loc-name\" id=selfMerchantLocName name=selfMerchantLocName placeholder=\"Enter Facility Name *\"> <label class=\"q-sim-error dup-facName\" style=display:none> Fac name alredy existed! </label> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=selfLocationCountry class=q-label>Country *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select q-input fac-country\" style=width:100% data-error-placement-append-closest=div id=selfLocationCountry name=selfLocationCountry data-s2-placeholder=\"Select Country\" data-s2-minimum-results-for-search=7 required> <option value=-1 disabled=\"\" selected=\"\">Select Country</option> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-address1\" id=selfMerchantLocAdd1 name=selfMerchantLocAdd1 placeholder=\"Enter address\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <input type=text class=\"q-input q-stretch fac-address2\" id=selfMerchantLocAdd2 name=selfMerchantLocAdd2 placeholder=\"Enter address line 2 (optional)\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-city\" id=selfMerchantLocCity name=selfMerchantLocCity placeholder=\"Enter city\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=selfLocationState id=state-label class=q-label>State *</label> </div> <div class=\"col-md-6 col-xs-12 state-wrapper\" id=selfLocationStateContainer> <div> <select name=selfLocationState class=\"select2-select q-input fac-state\" id=selfLocationState name=selfLocationState style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select State/Province/Region\" data-s2-minimum-results-for-search=5> <option value=-1 disabled=\"\" selected=\"\">Select State/Province/Region</option> <option value=1>Tennessee</option> </select> </div> </div> <div class=\"col-md-6 col-xs-12 state-text-wrapper\" id=facstateTextContainer style=display:none> <div> <input class=\"qw-input stretch fac-state-text\" id=facstateText maxlength=40 name=facstateText placeholder=State/Province/Region type=text>  </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Zipcode *</label> </div> <div class=\"col-md-3 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-zip-code\" id=selfMerchantLocZip name=selfMerchantLocZip placeholder=\"Enter postal code\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Contact Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-contactname\" id=selfLocContactName name=selfLocContactName placeholder=\"Enter contact name\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Email Address</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch fac-contact-email\" id=selfLocContactEmail name=selfLocContactEmail placeholder=\"Enter email address\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone Number *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select class=select2-select style=width:35% data-s2-full-width-list=true data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=7> <option value=1>United States +1</option> <option value=2>+2</option> <option value=3>+3</option> </select> <input required class=\"q-input q-ig-flex-fill loc-contact-phone\" id=selfLocContactPhone name=selfLocContactPhone placeholder=\"Enter phone number\"/> </div> </div> </div> </div> </div> <div class=q-marg-bottom-md> <span class=\"q-boldest q-italic q-text-purple\">Account to use for this location:</span> </div> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>FedEx Shipping Account Number</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch fac-ship-acc-number\" id=selfLocshipAccNumber name=selfLocshipAccNumber placeholder=\"Enter shipping account number\"></div> <div class=\"col-md-2 col-xs-12\"> <input type=hidden name=addLocationFlagForAddressValidation id=addLocationFlagForAddressValidation value=true /> <a href=\"\" class=\"base-btn purple-btn q-marg-top-md-at-md add-location-btn\">Add Location</a> </div> </div> </div> </div> </div> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <input type=hidden name=locNextBtn id=locNextBtn /> <a href=# class=\"qw-next base-btn purple-btn loc-next-btn disabled\"> Next <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> </div> </div> </div>";

/***/ },
/* 1436 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default-base q-max-page-width-md q-page-center-margin\"> <div class=\"q-card q-card-white\"> <div class=\"header q-pad-vert-sm q-pad-horz-xl q-bg-c-purple\"></div> <div class=\"q-section q-no-border-bottom\"> <div class=q-marg-all-xl> <div class=logo-section> <img src=data:image/png;base64,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 /> </div> <h2 class=\"q-title q-boldest q-underline\"> Returns Technology Registration </h2> <hr> </div> </div> <div class=\"q-section q-no-border get-started-section\"> <div class=q-marg-all-xl> <h2 class=\"q-title q-italic\"> Welcome, lets get started </h2> <div class=q-marg-vert-md> Returns Technology by FedEx allows a merchant full return capabilities and the ability to: </div> <ol class=q-marg-left-md> <li>Create RMAs using FedEx Shipping Labels</li> <li>Take part in our QR code experience that allows your customers the ability to have their shipping label printed for them at one of our many locations.</li> </ol> <h2 class=\"q-title txt-c-red q-marg-top-md\"> <u>All merchants are required to have:</u> </h2> <ol class=q-marg-top-sm> <li>At least one FedEx Shipping Account in place prior to enrollment.</li> </ol> <div class=q-marg-vert-md> Steps that will be completed in the enrollment process: </div> <ol class=q-marg-left-md> <li>Merchant enrollment and initial user account setup.</li> <li>System configurations to include <ol class=lower-case-latin> <li>Accounts</li> <li>Ship to locations</li> <li>RMA configurations</li> </ol> </li> </ol> <div class=\"q-marg-vert-md txt-c-purple q-italic q-boldest\"> User acceptance: You must read and agree to the articles of acceptance to proceed. </div> <div class=row> <div class=\"col-md-6 col-md-offset-3 col-xs-12\"> <div class=q-marg-horz-xl-til-md> <a href=# class=\"base-btn pill-btn middle-btn block-btn purple-btn q-text-center view-articles-acceptance\"> View Articles of Acceptance </a> </div> </div> </div> </div> </div> <div class=\"q-section user-acceptance-section\"> <div class=q-marg-all-xl> <div class=\"q-marg-vert-md txt-c-purple q-italic q-boldest\"> User acceptance: You must read and accept to the articles of acceptance to proceed. </div> <div> <div id=ScrollableDiv> <strong> <h3>Terms of Use</h3> </strong> <p> IMPORTANT LEGALLY BINDING AGREEMENT<br> Please read these terms of use before using the FedEx Platform (the “Platform”) and the services accessible from the Platform (the Platform and such services are hereinafter collectively referred to as the “Service”). <br> Access to the Service <br> <br> The Service is intended for use only by legal entities doing business with FedEx Supply Chain, Inc. and/or its affiliates and subsidiaries (collectively, “FedEx”, “we”, “us” or “our”) that FedEx instructs, invites or requests use the Service (each such entity, a “Platform Customer, and by authorized users of Platform Customers. By accessing the Service, you represent and warrant to FedEx that you are acting within the scope of your employment with or your retention by a Platform Customer and that you are authorized to bind yourself and such Platform Customer (hereinafter, individually and collectively, “You” or “Your”) to these terms of use. These terms of use govern Your access to and use of the Service and constitute a legally binding agreement between You and FedEx (this “Agreement”). By checking the “I accept the terms and conditions of use” box, or otherwise indicating agreement electronically, or by using the Service, You agree to the terms and conditions of this Agreement.<br><br> IF YOU DO NOT AGREE TO ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT, CLICK THE “CANCEL” OR “NO” BUTTON OR OTHERWISE INDICATE YOUR REFUSAL AND DO NOT ACCESS OR USE THE PORTAL OR THE SERVICE.<br><br> FedEx reserves the right, without notice to You, to amend, modify and revise the terms and conditions of this Agreement at any time by posting the revised terms and conditions on the Portal. All such changes to this Agreement will be effective immediately upon posting. FedEx may also make improvements or changes in the Service, including temporarily or permanently disabling use of the Service, at any time without notice to You. If at any time this Agreement is no longer acceptable to You, You should immediately cease all use of the Service.<br><br> In addition to this Agreement, certain components of the Portal or Service may require You to agree to additional terms of use concerning Your use of the applicable components. In that event, this Agreement and such additional terms of use will be binding on You. In the event of any conflict between the terms and conditions of this Agreement and the terms and conditions of any such additional terms of use, the terms and conditions of such additional terms of use will be deemed to govern and control.<br><br> Code of Conduct <br> You are responsible for all data and content that You upload and/or submit to the Service or otherwise create using the Service (collectively, “Data”). By uploading and/or submitting Data to the Service, You represent and warrant to FEDEX that all such Data is current, true and accurate. In addition to the other terms and conditions of this Agreement, YOU AGREE TO ABIDE BY THE FOLLOWING RULES IN CONNECTION WITH YOUR ACCESS TO AND/OR USE OF THE SERVICE:<br> <ul> <li> You will not share passwords or other access information or devices or otherwise authorize any third party to access or use the Service on Your behalf.<br></li> <li> You will not engage in unlawful or illegal activity, including, without limitation, by engaging in unauthorized access or unauthorized use of the Service or any accounts, computers or networks related to the Service.<br></li> <li> You will not view any information that You are not authorized to view nor will You attempt to view or obtain any data through any means from the Service that You are not authorized to access or view.<br> </li> <li> You will not use the Service to breach or violate any confidentiality obligations or privacy requirements, including, without limitation, by collecting or harvesting confidential information.<br> </li> <li> You will not use the Service to misappropriate or violate the rights of any third party, including, without limitation, using the Service to store, send, or make available materials protected by intellectual property rights of third parties without the permission of the owner of the intellectual property rights, unless otherwise permitted by applicable law.<br></li> <li> You represent, warrant and covenant that You have all necessary rights in and to all Data You upload and/or submit to the Service, and that the storage of such Data on the Service is proper and legal and not subject to any right of ownership of a third party.<br></li> <li> You will not damage, disrupt, interfere with, diminish, or render inaccessible or unusable the Service, the Platform or others’ equipment or software or others’ data, communications or use of the Service, or attempt to do so, or encourage or assist others to do so.<br></li> <li> You will not act in any manner that would be likely to cause computer failures of whatsoever nature which would disrupt or create a risk of disruption to the Service or its environment.<br></li> <li> You will not initiate a denial of service attack from or against the Service or release a virus, trojan horse, worms or other malware or spyware from or against the Service.<br></li> <li> You will not transmit through the Service documents and files containing viruses.<br></li> <li> You will not transmit through the Service documents and files containing hypertext links unless You have received FEDEX’s prior written consent with respect thereto.<br></li> <li> You will not use the Service to engage in fraudulent activity.<br></li> <li> You will not resell or charge others for the Service, either directly or indirectly.<br></li> <li> You will not attempt to reverse engineer any software provided in connection with the Service.<br> </li> <li> You will not take any action that encourages or assists others in engaging in any acts prohibited under this Agreement (including, without limitation, providing others with the ability to access data they should not be able to access).<br></li> <li> You will not use the Service to misrepresent Your identity or impersonate any person.<br></li> <li> You will abide by all administrative directives issued by FEDEX from time to time concerning the access or use of the Service.<br></li> </ul> Suspension and Termination of Your Use of the Service<br> If You breach or violate the terms and conditions of this Agreement, Your access to and use of the Service may be suspended or terminated without prior notice to You. In addition, Your access to and use of the Service may be suspended or terminated without prior notice to You in the event FEDEX deems it necessary and acceptable to do so. You acknowledge that if Your access to and/or use of the Service is suspended or terminated, it is possible that You may no longer have access to the Data that You uploaded and/or submitted to the Service or otherwise created using the Service.<br><br> Information Contained in the Service<br> Without limitation of any other provision contained in this Agreement, FEDEX makes no warranty or representation as to the exhaustiveness or accuracy of any information, data, documents or graphics contained in the Service. Information, data, documents and graphics contained in the Service may contain errors or omissions, including, without limitation, technical inaccuracies and typographical errors. FEDEX reserves the right to correct any errors, inaccuracies or omissions, although FEDEX will not have an obligation to make any such corrections, and FEDEX reserves the right to change or update information, data, documents and graphics contained in the Service at any time without prior notice to You. Without limitation of any other provision contained in this Agreement, FEDEX will not be liable to You for any errors, inaccuracies or omissions in the Service.<br><br> General Availability and Maintenance of the Service<br> FEDEX strives to make the Service available to users on a convenient basis. We will, from time to time, perform maintenance work on the Platform and the Service. There may be times when You will not be able to access the Platform or the Service due to maintenance work being performed. Such downtime is necessary and does not constitute a breach of contract. FEDEX reserves the right to make, at its convenience, improvements and/or changes to the Service, at any time without prior communication to You. In the same manner, FEDEX may, at any time, decide to stop providing the Service, without prior communication to You and without any liability to You whatsoever.<br><br> Login Credentials<br> FEDEX implements technical means for the purpose of identifying and authenticating users of the Service. A login and a password to access the Service will be provided to You at the time You establish Your account. You will be required to change Your password at the time of Your initial log-on through the Platform. You are responsible for, and agree to take all necessary measures for, ensuring that Your login and password are kept confidential, as well for the confidentiality of Data and Documents uploaded and/or submitted to the Service. You are solely responsible to FEDEX for all activity that occurs via Your account for the Platform and Service. If You lose Your login credentials, or if You discover or suspect that Your login credentials or any information contain in the Service was stolen and/or is being used by a third party, You must immediately notify us in writing to this effect. In no circumstances will FEDEX be held liable for misuse or fraudulent use by a third party of Your login credentials. FEDEX may require that You change Your login credentials or certain parts of Your account information at any time for any reason. FEDEX reserves the right to, without any recourse from You, suspend at any time Your login credentials if Your use of the Service is deemed by FEDEX as abnormal. In addition, You agree to immediately inform FEDEX in writing of the termination or resignation of any employees having a login and a password provided by FEDEX. Following receipt of any such written notification, FEDEX will endeavor to erase the login and password of the person(s) concerned.<br><br> Security<br> We may use techniques to identify fraudulent activities. You agree to cooperate with such efforts as we may, in our sole discretion, deem necessary to identify attempted fraud. You further agree that if, for any reason, You are suspected of fraud or other breach of this Agreement, we may, in our sole discretion, declare You to be in breach of this Agreement, suspend Your use of the Service, terminate Your use of the Service and/or seek prosecution against You to the fullest extent of the law.<br><br> Personal Information given by You<br> Any personal information that You communicate through the Service will be used solely to respond to or process to a request that You send to FEDEX. FEDEX does not sell or rent to third parties, for any reason whatsoever, the personal information that users provide online through the Service. Notwithstanding the foregoing, in the event of any transfer or assignment by FEDEX of its rights under this Agreement, FEDEX will have the right to transfer to the transferee or assignee, Your personal information in order that the transferee or assignee may maintain and operate the Service.<br><br> Disclaimer of Warranties<br> YOUR USE AND BROWSING OF, AND ANY RELIANCE BY YOU UPON, THE SERVICE IS AT YOUR OWN RISK. IF YOU ARE DISSATISFIED WITH THE SERVICE, OR WITH ANY OF THE TERMS AND CONDITIONS OF THIS AGREEMENT, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE ACCESSING AND USING THE SERVICE. TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE SERVICE AND THE PLATFORM AND ALL CONTENT, DOCUMENTS AND MATERIAL ACCESSIBLE FROM AND/OR THROUGH THE SERVICE ARE PROVIDED “AS IS”, “AS AVAILABLE”, WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY. FEDEX DOES NOT REPRESENT OR ENDORSE THE TIMELINESS, ACCURACY, ADEQUACY, RELIABILITY OR COMPLETENESS OF THE SERVICE, OR ANY CONTENT, INFORMATION OR MATERIALS, AND FEDEX EXPRESSLY DISCLAIMS LIABILITY FOR ERRORS OR OMISSIONS IN THE SERVICE AND ANY SUCH CONTENT, INFORMATION AND MATERIALS. FEDEX DISCLAIMS ALL WARRANTIES AND CONDITIONS OF ANY KIND WITH RESPECT TO THE SERVICE, WHETHER EXPRESS, IMPLIED OR STATUTORY INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF NON-INFRINGEMENT OF INTELLECTUAL PROPERTY RIGHTS, NON-INTERFERENCE, ACCURACY, TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE (EVEN IF FEDEX HAS BEEN MADE AWARE OF SUCH PURPOSE), FREEDOM FROM COMPUTER VIRUS, SPYWARE AND DESTRUCTIVE MATERIALS AND FREEDOM FROM LOSS OR DETERIORATION OF YOUR DATA OR DOCUMENTS. WITHOUT LIMITING THE FOREGOING, FEDEX DOES NOT WARRANT AND SPECIFICALLY DISCLAIMS ANY WARRANTIES THAT THE OPERATION OF THE SERVICE WILL BE UNINTERRUPTED OR ERROR FREE, OR THAT DEFECTS IN THE SERVICE BE CORRECTED. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY FEDEX OR AN AUTHORIZED REPRESENTATIVE OF FEDEX SHALL CREATE A WARRANTY. NO NEWS ITEMS, PRESS RELEASES, CASE STUDIES OR CUSTOMER TESTIMONIALS PUBLISHED ON OR ACCESSIBLE THROUGH THE SERVICE SHALL CREATE A WARRANTY.<br><br> Limitation of Liability<br> TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, WHATEVER THE LEGAL BASIS FOR THE CLAIM, NEITHER FEDEX NOR ANY OF FEDEX’S TECHNOLOGY OR SERVICE PROVIDERS OR LICENSORS INVOLVED IN THE DELIVERY, OPERATION OR MAINTENANCE OF THE SERVICE, NOR ANY OF THEIR RESPECTIVE AFFILIATES, DIRECTORS, OFFICERS, AGENTS, EMPLOYEES OR CONTRACTORS, WILL BE LIABLE TO YOU FOR ANY INJURY (WHETHER A COMMERCIAL INJURY OR OTHERWISE) OR FOR ANY DAMAGES, INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, PUNITIVE, SPECIAL, OR INCIDENTAL DAMAGES ARISING IN CONNECTION WITH THIS AGREEMENT, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR IF SUCH POSSIBILITY WAS REASONABLY FORESEEABLE, LOSSES (INCLUDING, WITHOUT LIMITATION, LOSS OF PROFIT AND LOSS OF DATA) OR EXPENSES, INCLUDING, WITHOUT LIMITATION, LOSSES, EXPENSES, INJURY OR DAMAGES CAUSED BY ANY CONTENT, DATA, DOCUMENTS, SOFTWARE, MATERIALS OR INFORMATION RECEIVED FROM OR THROUGH THE USE OF THE SERVICE, ANY EMAIL DISTRIBUTED TO YOU, OR IN CONNECTION WITH ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, DISRUPTION, INTERRUPTION, MALFUNCTION, DEFECT, DELAY IN OPERATION OR TRANSMISSION OF THE SERVICE, OR ANY SUSPENSION OR TERMINATION OF THE SERVICE, OR FROM COMPUTER VIRUS OR INTERNET OR SERVICE FAILURE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH INJURY, DAMAGES, LOSSES OR EXPENSES.<br><br> NOTWITHSTANDING THE FOREGOING, IN THE EVENT THAT APPLICABLE LAW DOES NOT PERMIT FEDEX TO ENTIRELY DISCLAIM LIABILITY TO YOU FOR INJURY, DAMAGES OR LOSS THEN, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE AGGREGATE LIABILITY OF FEDEX, FEDEX’S TECHNOLOGY AND SERVICE PROVIDERS AND LICENSORS INVOLVED IN THE DELIVERY, OPERATION OR MAINTENANCE OF THE SERVICE, AND THEIR RESPECTIVE AFFILIATES, DIRECTORS, OFFICERS, AGENTS, EMPLOYEES AND CONTRACTORS TO YOU ARISING OUT OF OR RELATED TO THIS AGREEMENT WILL BE LIMITED IN THE AGGREGATE TO DIRECT DAMAGES UP TO THE AMOUNT OF FIVE DOLLARS (USD $5.00) OR THE MINIMUM AMOUNT ALLOWED BY LAW, WHICHEVER IS GREATER.<br><br> Indemnity<br> You agree to indemnify, defend and hold harmless FEDEX and FEDEX’s technology and service providers and licensors and its and each of their respective officers, directors, employees, agents and representatives from and against any and all losses, expenses, damages and costs (including reasonable attorneys' fees) arising out of or related to any claim, demand, action, suit or proceeding resulting from any breach by You of this Agreement or any activity related to Your account (including, without limitation, negligent or wrongful conduct) by You or any other person accessing the Platform or the Service using Your account.<br><br> International Users<br> The Service is operated by FEDEX from within the United States. FEDEX makes no representation that the Platform or the Service are appropriate or available for use at locations outside of the United States, and access to the Service from territories where the Platform or the Service are illegal is prohibited. If You access the Platform or the Service from a location outside the United States, You are responsible for compliance with all applicable local laws, regulations and restrictions.<br><br> Governing Law<br> This Agreement shall not be governed by the United Nations Convention on Contracts for the International Sale of Goods. All matters arising out of or relating to this Agreement, including its construction, and Your access to, and use of, the Service shall be governed by the internal laws of the Commonwealth of Pennsylvania in the United States without regard to its conflicts of law principles. You and FEDEX irrevocably consent to bring any action to enforce this Agreement in the federal or state courts located in Allegheny County in the Commonwealth of Pennsylvania. You agree to the personal and exclusive jurisdiction of the federal or state courts located in Allegheny County in the Commonwealth of Pennsylvania.<br><br> General<br> If any part of this Agreement is determined to be invalid or unenforceable pursuant to applicable law including, but not limited to, the warranty disclaimers and liability limitations set forth above, then the invalid or unenforceable provision will be deemed superseded by a valid enforceable provision that most closely matches the intent of the original provision, and the remainder of this Agreement will continue in effect. The failure of FEDEX to exercise or enforce any right or provision of this Agreement will not constitute a waiver of such right or provision. The section titles in these terms and conditions are for convenience only and have no legal or contractual effect. You are prohibited from assigning this Agreement or transferring Your rights under this Agreement to a third party; any assignment or transfer by You will be deemed void from inception. This Agreement constitutes the entire agreement between FEDEX and You relating to the subject matter of this Agreement, supersedes any and all prior understandings and agreements between FEDEX and You relating to the subject matter of this Agreement, and shall not be amended, modified or revised by You.<br><br> </p> </div> </div> <div class=q-pull-right-til-md> <a href=# class=\"q-block-at-md q-text-center-at-md q-pill q-pill-green accept-btn\">Accept</a> <a href=# class=\"q-block-at-md q-text-center-at-md q-pill q-pill-red q-marg-top-md-at-md not-accept-btn\">Not Accept</a> </div> <div class=clearfix></div> </div> </div> <div class=q-footer> <div class=\"q-footer-btn-group q-pull-right-til-md\"> <a href=# class=\"q-block-at-md q-marg-top-md-at-md q-text-center-at-md base-btn purple-btn self-initial-reg-next-btn disabled\">Next <i class=\"fa fa-angle-right\" aria-hidden=true></i></a> </div> </div> </div> <html> <head> <meta http-equiv=Content-Type content=\"text/html; charset=utf-8\"> <meta name=Robots content=\"NOINDEX \"/> </head> <body></body> <script>var gearPage=document.getElementById(\"GearPage\");null!=gearPage&&(gearPage.parentNode.removeChild(gearPage),document.title=\"Error\")</script> </html></div>";

/***/ },
/* 1437 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default-base q-max-page-width-md q-page-center-margin\"> <div class=\"q-card q-card-white\"> <div class=\"header q-pad-vert-sm q-pad-horz-xl q-bg-c-purple\"></div> <div class=\"q-section q-no-border-bottom\"> <div class=q-marg-all-xl> <div class=logo-section> <img src=data:image/png;base64,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 /> </div> <h2 class=\"q-title q-boldest q-underline\"> Returns Technology Registration </h2> <hr> </div> </div> <div class=\"q-section q-no-border get-started-section\"> <div class=q-marg-all-xl> <h2 class=\"q-title q-italic\"> Welcome, lets get started </h2> <div class=q-marg-vert-md> Returns Technology by FedEx allows a merchant full return capabilities and the ability to: </div> <ol class=q-marg-left-md> <li>Create RMAs using FedEx Shipping Labels</li> <li>Take part in our QR code experience that allows your customers the ability to have their shipping label printed for them at one of our many locations.</li> </ol> <h2 class=\"q-title txt-c-red q-marg-top-md\"> <u>All merchants are required to have:</u> </h2> <ol class=q-marg-left-md> <li>Merchant enrollment and initial user account setup.</li> <li>System configurations to include <ol class=lower-case-latin> <li>Ship to locations</li> <li>RMA configurations</li> </ol> </li> </ol> <div class=\"q-marg-vert-md txt-c-purple q-italic q-boldest\"> User acceptance: You must read and agree to the articles of acceptance to proceed. </div> <div class=row> <div class=\"col-md-6 col-md-offset-3 col-xs-12\"> <div class=q-marg-horz-xl-til-md> <a href=# class=\"base-btn pill-btn middle-btn block-btn purple-btn q-text-center view-articles-acceptance\"> View Articles of Acceptance </a> </div> </div> </div> </div> </div> <div class=\"q-section user-acceptance-section\"> <div class=q-marg-all-xl> <div class=\"q-marg-vert-md txt-c-purple q-italic q-boldest\"> User acceptance: You must read and accept to the articles of acceptance to proceed. </div> <div> <div id=ScrollableDiv> <strong><h3>Terms of Use</h3></strong> <p> IMPORTANT LEGALLY BINDING AGREEMENT<br> Please read these terms of use before using the FedEx Platform (the “Platform”) and the services accessible from the Platform (the Platform and such services are hereinafter collectively referred to as the “Service”). <br> Access to the Service <br> <br> The Service is intended for use only by legal entities doing business with FedEx Supply Chain, Inc. and/or its affiliates and subsidiaries (collectively, “FedEx”, “we”, “us” or “our”) that FedEx instructs, invites or requests use the Service (each such entity, a “Platform Customer, and by authorized users of Platform Customers. By accessing the Service, you represent and warrant to FedEx that you are acting within the scope of your employment with or your retention by a Platform Customer and that you are authorized to bind yourself and such Platform Customer (hereinafter, individually and collectively, “You” or “Your”) to these terms of use. These terms of use govern Your access to and use of the Service and constitute a legally binding agreement between You and FedEx (this “Agreement”). By checking the “I accept the terms and conditions of use” box, or otherwise indicating agreement electronically, or by using the Service, You agree to the terms and conditions of this Agreement.<br><br> IF YOU DO NOT AGREE TO ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT, CLICK THE “CANCEL” OR “NO” BUTTON OR OTHERWISE INDICATE YOUR REFUSAL AND DO NOT ACCESS OR USE THE PORTAL OR THE SERVICE.<br><br> FedEx reserves the right, without notice to You, to amend, modify and revise the terms and conditions of this Agreement at any time by posting the revised terms and conditions on the Portal. All such changes to this Agreement will be effective immediately upon posting. FedEx may also make improvements or changes in the Service, including temporarily or permanently disabling use of the Service, at any time without notice to You. If at any time this Agreement is no longer acceptable to You, You should immediately cease all use of the Service.<br><br> In addition to this Agreement, certain components of the Portal or Service may require You to agree to additional terms of use concerning Your use of the applicable components. In that event, this Agreement and such additional terms of use will be binding on You. In the event of any conflict between the terms and conditions of this Agreement and the terms and conditions of any such additional terms of use, the terms and conditions of such additional terms of use will be deemed to govern and control.<br><br> Code of Conduct <br> You are responsible for all data and content that You upload and/or submit to the Service or otherwise create using the Service (collectively, “Data”). By uploading and/or submitting Data to the Service, You represent and warrant to FEDEX that all such Data is current, true and accurate. In addition to the other terms and conditions of this Agreement, YOU AGREE TO ABIDE BY THE FOLLOWING RULES IN CONNECTION WITH YOUR ACCESS TO AND/OR USE OF THE SERVICE:<br><br> • You will not share passwords or other access information or devices or otherwise authorize any third party to access or use the Service on Your behalf.<br> • You will not engage in unlawful or illegal activity, including, without limitation, by engaging in unauthorized access or unauthorized use of the Service or any accounts, computers or networks related to the Service.<br> • You will not view any information that You are not authorized to view nor will You attempt to view or obtain any data through any means from the Service that You are not authorized to access or view.<br> • You will not use the Service to breach or violate any confidentiality obligations or privacy requirements, including, without limitation, by collecting or harvesting confidential information.<br> • You will not use the Service to misappropriate or violate the rights of any third party, including, without limitation, using the Service to store, send, or make available materials protected by intellectual property rights of third parties without the permission of the owner of the intellectual property rights, unless otherwise permitted by applicable law.<br> • You represent, warrant and covenant that You have all necessary rights in and to all Data You upload and/or submit to the Service, and that the storage of such Data on the Service is proper and legal and not subject to any right of ownership of a third party.<br> • You will not damage, disrupt, interfere with, diminish, or render inaccessible or unusable the Service, the Platform or others’ equipment or software or others’ data, communications or use of the Service, or attempt to do so, or encourage or assist others to do so.<br> • You will not act in any manner that would be likely to cause computer failures of whatsoever nature which would disrupt or create a risk of disruption to the Service or its environment.<br> • You will not initiate a denial of service attack from or against the Service or release a virus, trojan horse, worms or other malware or spyware from or against the Service.<br> • You will not transmit through the Service documents and files containing viruses.<br> • You will not transmit through the Service documents and files containing hypertext links unless You have received FEDEX’s prior written consent with respect thereto.<br> • You will not use the Service to engage in fraudulent activity.<br> • You will not resell or charge others for the Service, either directly or indirectly.<br> • You will not attempt to reverse engineer any software provided in connection with the Service.<br> • You will not take any action that encourages or assists others in engaging in any acts prohibited under this Agreement (including, without limitation, providing others with the ability to access data they should not be able to access).<br> • You will not use the Service to misrepresent Your identity or impersonate any person.<br> • You will abide by all administrative directives issued by FEDEX from time to time concerning the access or use of the Service.<br><br> Suspension and Termination of Your Use of the Service<br> If You breach or violate the terms and conditions of this Agreement, Your access to and use of the Service may be suspended or terminated without prior notice to You. In addition, Your access to and use of the Service may be suspended or terminated without prior notice to You in the event FEDEX deems it necessary and acceptable to do so. You acknowledge that if Your access to and/or use of the Service is suspended or terminated, it is possible that You may no longer have access to the Data that You uploaded and/or submitted to the Service or otherwise created using the Service.<br><br> Information Contained in the Service<br> Without limitation of any other provision contained in this Agreement, FEDEX makes no warranty or representation as to the exhaustiveness or accuracy of any information, data, documents or graphics contained in the Service. Information, data, documents and graphics contained in the Service may contain errors or omissions, including, without limitation, technical inaccuracies and typographical errors. FEDEX reserves the right to correct any errors, inaccuracies or omissions, although FEDEX will not have an obligation to make any such corrections, and FEDEX reserves the right to change or update information, data, documents and graphics contained in the Service at any time without prior notice to You. Without limitation of any other provision contained in this Agreement, FEDEX will not be liable to You for any errors, inaccuracies or omissions in the Service.<br><br> General Availability and Maintenance of the Service<br> FEDEX strives to make the Service available to users on a convenient basis. We will, from time to time, perform maintenance work on the Platform and the Service. There may be times when You will not be able to access the Platform or the Service due to maintenance work being performed. Such downtime is necessary and does not constitute a breach of contract. FEDEX reserves the right to make, at its convenience, improvements and/or changes to the Service, at any time without prior communication to You. In the same manner, FEDEX may, at any time, decide to stop providing the Service, without prior communication to You and without any liability to You whatsoever.<br><br> Login Credentials<br> FEDEX implements technical means for the purpose of identifying and authenticating users of the Service. A login and a password to access the Service will be provided to You at the time You establish Your account. You will be required to change Your password at the time of Your initial log-on through the Platform. You are responsible for, and agree to take all necessary measures for, ensuring that Your login and password are kept confidential, as well for the confidentiality of Data and Documents uploaded and/or submitted to the Service. You are solely responsible to FEDEX for all activity that occurs via Your account for the Platform and Service. If You lose Your login credentials, or if You discover or suspect that Your login credentials or any information contain in the Service was stolen and/or is being used by a third party, You must immediately notify us in writing to this effect. In no circumstances will FEDEX be held liable for misuse or fraudulent use by a third party of Your login credentials. FEDEX may require that You change Your login credentials or certain parts of Your account information at any time for any reason. FEDEX reserves the right to, without any recourse from You, suspend at any time Your login credentials if Your use of the Service is deemed by FEDEX as abnormal. In addition, You agree to immediately inform FEDEX in writing of the termination or resignation of any employees having a login and a password provided by FEDEX. Following receipt of any such written notification, FEDEX will endeavor to erase the login and password of the person(s) concerned.<br><br> Security<br> We may use techniques to identify fraudulent activities. You agree to cooperate with such efforts as we may, in our sole discretion, deem necessary to identify attempted fraud. You further agree that if, for any reason, You are suspected of fraud or other breach of this Agreement, we may, in our sole discretion, declare You to be in breach of this Agreement, suspend Your use of the Service, terminate Your use of the Service and/or seek prosecution against You to the fullest extent of the law.<br><br> Personal Information given by You<br> Any personal information that You communicate through the Service will be used solely to respond to or process to a request that You send to FEDEX. FEDEX does not sell or rent to third parties, for any reason whatsoever, the personal information that users provide online through the Service. Notwithstanding the foregoing, in the event of any transfer or assignment by FEDEX of its rights under this Agreement, FEDEX will have the right to transfer to the transferee or assignee, Your personal information in order that the transferee or assignee may maintain and operate the Service.<br><br> Disclaimer of Warranties<br> YOUR USE AND BROWSING OF, AND ANY RELIANCE BY YOU UPON, THE SERVICE IS AT YOUR OWN RISK. IF YOU ARE DISSATISFIED WITH THE SERVICE, OR WITH ANY OF THE TERMS AND CONDITIONS OF THIS AGREEMENT, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE ACCESSING AND USING THE SERVICE. TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE SERVICE AND THE PLATFORM AND ALL CONTENT, DOCUMENTS AND MATERIAL ACCESSIBLE FROM AND/OR THROUGH THE SERVICE ARE PROVIDED “AS IS”, “AS AVAILABLE”, WITH ALL FAULTS AND WITHOUT WARRANTY OF ANY KIND, WHETHER EXPRESS, IMPLIED OR STATUTORY. FEDEX DOES NOT REPRESENT OR ENDORSE THE TIMELINESS, ACCURACY, ADEQUACY, RELIABILITY OR COMPLETENESS OF THE SERVICE, OR ANY CONTENT, INFORMATION OR MATERIALS, AND FEDEX EXPRESSLY DISCLAIMS LIABILITY FOR ERRORS OR OMISSIONS IN THE SERVICE AND ANY SUCH CONTENT, INFORMATION AND MATERIALS. FEDEX DISCLAIMS ALL WARRANTIES AND CONDITIONS OF ANY KIND WITH RESPECT TO THE SERVICE, WHETHER EXPRESS, IMPLIED OR STATUTORY INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF NON-INFRINGEMENT OF INTELLECTUAL PROPERTY RIGHTS, NON-INTERFERENCE, ACCURACY, TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE (EVEN IF FEDEX HAS BEEN MADE AWARE OF SUCH PURPOSE), FREEDOM FROM COMPUTER VIRUS, SPYWARE AND DESTRUCTIVE MATERIALS AND FREEDOM FROM LOSS OR DETERIORATION OF YOUR DATA OR DOCUMENTS. WITHOUT LIMITING THE FOREGOING, FEDEX DOES NOT WARRANT AND SPECIFICALLY DISCLAIMS ANY WARRANTIES THAT THE OPERATION OF THE SERVICE WILL BE UNINTERRUPTED OR ERROR FREE, OR THAT DEFECTS IN THE SERVICE BE CORRECTED. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY FEDEX OR AN AUTHORIZED REPRESENTATIVE OF FEDEX SHALL CREATE A WARRANTY. NO NEWS ITEMS, PRESS RELEASES, CASE STUDIES OR CUSTOMER TESTIMONIALS PUBLISHED ON OR ACCESSIBLE THROUGH THE SERVICE SHALL CREATE A WARRANTY.<br><br> Limitation of Liability<br> TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, WHATEVER THE LEGAL BASIS FOR THE CLAIM, NEITHER FEDEX NOR ANY OF FEDEX’S TECHNOLOGY OR SERVICE PROVIDERS OR LICENSORS INVOLVED IN THE DELIVERY, OPERATION OR MAINTENANCE OF THE SERVICE, NOR ANY OF THEIR RESPECTIVE AFFILIATES, DIRECTORS, OFFICERS, AGENTS, EMPLOYEES OR CONTRACTORS, WILL BE LIABLE TO YOU FOR ANY INJURY (WHETHER A COMMERCIAL INJURY OR OTHERWISE) OR FOR ANY DAMAGES, INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, PUNITIVE, SPECIAL, OR INCIDENTAL DAMAGES ARISING IN CONNECTION WITH THIS AGREEMENT, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES OR IF SUCH POSSIBILITY WAS REASONABLY FORESEEABLE, LOSSES (INCLUDING, WITHOUT LIMITATION, LOSS OF PROFIT AND LOSS OF DATA) OR EXPENSES, INCLUDING, WITHOUT LIMITATION, LOSSES, EXPENSES, INJURY OR DAMAGES CAUSED BY ANY CONTENT, DATA, DOCUMENTS, SOFTWARE, MATERIALS OR INFORMATION RECEIVED FROM OR THROUGH THE USE OF THE SERVICE, ANY EMAIL DISTRIBUTED TO YOU, OR IN CONNECTION WITH ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, DISRUPTION, INTERRUPTION, MALFUNCTION, DEFECT, DELAY IN OPERATION OR TRANSMISSION OF THE SERVICE, OR ANY SUSPENSION OR TERMINATION OF THE SERVICE, OR FROM COMPUTER VIRUS OR INTERNET OR SERVICE FAILURE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH INJURY, DAMAGES, LOSSES OR EXPENSES.<br><br> NOTWITHSTANDING THE FOREGOING, IN THE EVENT THAT APPLICABLE LAW DOES NOT PERMIT FEDEX TO ENTIRELY DISCLAIM LIABILITY TO YOU FOR INJURY, DAMAGES OR LOSS THEN, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE AGGREGATE LIABILITY OF FEDEX, FEDEX’S TECHNOLOGY AND SERVICE PROVIDERS AND LICENSORS INVOLVED IN THE DELIVERY, OPERATION OR MAINTENANCE OF THE SERVICE, AND THEIR RESPECTIVE AFFILIATES, DIRECTORS, OFFICERS, AGENTS, EMPLOYEES AND CONTRACTORS TO YOU ARISING OUT OF OR RELATED TO THIS AGREEMENT WILL BE LIMITED IN THE AGGREGATE TO DIRECT DAMAGES UP TO THE AMOUNT OF FIVE DOLLARS (USD $5.00) OR THE MINIMUM AMOUNT ALLOWED BY LAW, WHICHEVER IS GREATER.<br><br> Indemnity<br> You agree to indemnify, defend and hold harmless FEDEX and FEDEX’s technology and service providers and licensors and its and each of their respective officers, directors, employees, agents and representatives from and against any and all losses, expenses, damages and costs (including reasonable attorneys' fees) arising out of or related to any claim, demand, action, suit or proceeding resulting from any breach by You of this Agreement or any activity related to Your account (including, without limitation, negligent or wrongful conduct) by You or any other person accessing the Platform or the Service using Your account.<br><br> International Users<br> The Service is operated by FEDEX from within the United States. FEDEX makes no representation that the Platform or the Service are appropriate or available for use at locations outside of the United States, and access to the Service from territories where the Platform or the Service are illegal is prohibited. If You access the Platform or the Service from a location outside the United States, You are responsible for compliance with all applicable local laws, regulations and restrictions.<br><br> Governing Law<br> This Agreement shall not be governed by the United Nations Convention on Contracts for the International Sale of Goods. All matters arising out of or relating to this Agreement, including its construction, and Your access to, and use of, the Service shall be governed by the internal laws of the Commonwealth of Pennsylvania in the United States without regard to its conflicts of law principles. You and FEDEX irrevocably consent to bring any action to enforce this Agreement in the federal or state courts located in Allegheny County in the Commonwealth of Pennsylvania. You agree to the personal and exclusive jurisdiction of the federal or state courts located in Allegheny County in the Commonwealth of Pennsylvania.<br><br> General<br> If any part of this Agreement is determined to be invalid or unenforceable pursuant to applicable law including, but not limited to, the warranty disclaimers and liability limitations set forth above, then the invalid or unenforceable provision will be deemed superseded by a valid enforceable provision that most closely matches the intent of the original provision, and the remainder of this Agreement will continue in effect. The failure of FEDEX to exercise or enforce any right or provision of this Agreement will not constitute a waiver of such right or provision. The section titles in these terms and conditions are for convenience only and have no legal or contractual effect. You are prohibited from assigning this Agreement or transferring Your rights under this Agreement to a third party; any assignment or transfer by You will be deemed void from inception. This Agreement constitutes the entire agreement between FEDEX and You relating to the subject matter of this Agreement, supersedes any and all prior understandings and agreements between FEDEX and You relating to the subject matter of this Agreement, and shall not be amended, modified or revised by You.<br><br> </p> </div> </div> <div class=q-pull-right-til-md> <a href=# class=\"q-block-at-md q-text-center-at-md q-pill q-pill-green accept-btn\">Accept</a> <a href=# class=\"q-block-at-md q-text-center-at-md q-pill q-pill-red q-marg-top-md-at-md not-accept-btn\">Not Accept</a> </div> <div class=clearfix></div> </div> </div> <div class=q-footer> <div class=\"q-footer-btn-group q-pull-right-til-md\"> <a href=# class=\"q-block-at-md q-marg-top-md-at-md q-text-center-at-md base-btn purple-btn self-initial-reg-next-btn disabled\">Next <i class=\"fa fa-angle-right\" aria-hidden=true></i></a> </div> </div> </div><html><head><meta http-equiv=Content-Type content=\"text/html; charset=utf-8\"><meta name=Robots content=\"NOINDEX \"/></head><body></body> <script>var gearPage=document.getElementById(\"GearPage\");null!=gearPage&&(gearPage.parentNode.removeChild(gearPage),document.title=\"Error\")</script> </html></div>";

/***/ },
/* 1438 */
/***/ function(module, exports) {

	module.exports = "<div class=q-section> <div class=q-marg-all-xl> <div class=q-marg-vert-md> <h2 class=q-section-title> 2. Locations </h2> </div> <p class=\"q-italic text-grey\">Add all of the ship to locations you use for returns, your accounts will be assigned to your ship to locations as to what account to charge the shipments to.</p> <hr> <div class=\"q-section q-marg-bottom-md\" style=display:none id=shipToLocations> <div class=\"q-marg-top-xl q-marg-bottom-md\"> <h2 class=q-section-title> Ship to locations </h2> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility ID:</span> </div> <div class=\"col-md-6 col-xs-12 fac-id-view\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Facility Name:</span> </div> <div class=\"col-md-6 col-xs-12 fac-name-view\"> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Address :</span> </div> <div class=\"col-md-6 col-xs-12 fac-address1-view\"> <div class=\"col-md-6 col-xs-12 fac-address2-view\"></div> <div class=\"col-md-6 col-xs-12 fac-countrty-view\"></div> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>City:</span> </div> <div class=\"col-md-6 col-xs-12 fac-city-view\"> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>State:</span> </div> <div class=\"col-md-6 col-xs-12 fac-state-view\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Zipcode:</span> </div> <div class=\"col-md-6 col-xs-12 fac-zipcode-view\"> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Contact Name:</span> </div> <div class=\"col-md-6 col-xs-12 fac-contactname-view\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Email Address:</span> </div> <div class=\"col-md-6 col-xs-12 fac-contact-email-view\"> </div> </div> </div> </div> </div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>Phone Number:</span> </div> <div class=\"col-md-6 col-xs-12 fac-phone-view\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-marg-bottom-md> <div class=row> <div class=\"col-md-6 col-xs-12\"> <span class=q-boldest>FedEx Shipping Account Number:</span> </div> <div class=\"col-md-6 col-xs-12 fac-shipping-account-view\"> </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=\"q-expandable-wrap q-no-pad q-marg-top-lg\"> <div class=q-expandable-header> <span id=completeFieldsMsg class=\"q-boldest q-italic q-text-purple\">Complete all required fields below:</span> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.fields-sectiion data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> <a href=\"\" id=shipToLocationsEdit style=display:none class=\"base-btn purple-btn q-pull-right q-marg-horz-xs loc-edit\">Edit</a> </div> <div id=saveLocationSection style=display:block class=\"fields-sectiion q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <span id=noneAddedMsg class=q-italic>None added at this time</span> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Facility ID* & Facility Name*</label> </div> <div class=\"col-md-4 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-loc-id\" id=selfMerchantLocId name=selfMerchantLocID placeholder=\"Enter Facility ID *\"> <label class=\"q-sim-error dup-facId\" style=display:none> Fac Id alredy existed! </label> </div> <div class=\"col-md-4 col-xs-12 q-marg-top-md-at-md\"> <input required type=text class=\"q-input q-stretch fac-loc-name\" id=selfMerchantLocName name=selfMerchantLocName placeholder=\"Enter Facility Name *\"> <label class=\"q-sim-error dup-facName\" style=display:none> Fac name alredy existed! </label> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=selfLocationCountry class=q-label>Country *</label> </div> <div class=\"col-md-6 col-xs-12\"> <select class=\"select2-select q-input fac-country\" style=width:100% data-error-placement-append-closest=div id=selfLocationCountry name=selfLocationCountry data-s2-placeholder=\"Select Country\" data-s2-minimum-results-for-search=7 required> <option value=-1 disabled=\"\" selected=\"\">Select Country</option> </select> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-address1\" id=selfMerchantLocAdd1 name=selfMerchantLocAdd1 placeholder=\"Enter address\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <input type=text class=\"q-input q-stretch fac-address2\" id=selfMerchantLocAdd2 name=selfMerchantLocAdd2 placeholder=\"Enter address line 2 (optional)\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>City *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-city\" id=selfMerchantLocCity name=selfMerchantLocCity placeholder=\"Enter city\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=selfLocationState id=state-label class=q-label>State *</label> </div> <div class=\"col-md-6 col-xs-12 state-wrapper\" id=selfLocationStateContainer> <div> <select name=selfLocationState class=\"select2-select q-input fac-state\" id=selfLocationState name=selfLocationState style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select State/Province/Region\" data-s2-minimum-results-for-search=5> <option value=-1 disabled=\"\" selected=\"\">Select State/Province/Region</option> <option value=1>Tennessee</option> </select> </div> </div> <div class=\"col-md-6 col-xs-12 state-text-wrapper\" id=facstateTextContainer style=display:none> <div> <input class=\"qw-input stretch fac-state-text\" id=facstateText maxlength=40 name=facstateText placeholder=State/Province/Region type=text>  </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Zipcode *</label> </div> <div class=\"col-md-3 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-zip-code\" id=selfMerchantLocZip name=selfMerchantLocZip placeholder=\"Enter postal code\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Contact Name *</label> </div> <div class=\"col-md-6 col-xs-12\"> <input required type=text class=\"q-input q-stretch fac-contactname\" id=selfLocContactName name=selfLocContactName placeholder=\"Enter contact name\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=\"\" class=q-label>Email Address</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text class=\"q-input q-stretch fac-contact-email\" id=selfLocContactEmail name=selfLocContactEmail placeholder=\"Enter email address\"> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Phone Number *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=q-input-group-flex-container> <div class=q-input-group> <select class=select2-select style=width:35% data-s2-full-width-list=true data-error-placement-append-closest=div data-s2-placeholder=\"Country Code\" data-s2-minimum-results-for-search=7> <option value=1>United States +1</option> <option value=2>+2</option> <option value=3>+3</option> </select> <input required class=\"q-input q-ig-flex-fill loc-contact-phone\" id=selfLocContactPhone name=selfLocContactPhone placeholder=\"Enter phone number\"/> </div> </div> </div> </div> </div> <div class=q-marg-bottom-md> <span class=\"q-boldest q-italic q-text-purple\">Account to use for this location:</span> </div> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>FedEx Shipping Account Number</label> </div> <div class=\"col-md-6 col-xs-12\"> <input type=text value=510087020 class=\"q-input q-stretch fac-ship-acc-number\" id=selfLocshipAccNumber name=selfLocshipAccNumber placeholder=510087020 disabled=disabled></div> <div class=\"col-md-2 col-xs-12\"> <input type=hidden name=addLocationFlagForAddressValidation id=addLocationFlagForAddressValidation value=true /> <a href=\"\" class=\"base-btn purple-btn q-marg-top-md-at-md add-location-btn\">Add Location</a> </div> </div> </div> </div> </div> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <input type=hidden name=locNextBtn id=locNextBtn /> <a href=# class=\"qw-next base-btn purple-btn loc-next-btn disabled\"> Next <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> </div> </div> </div>";

/***/ },
/* 1439 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xs-at-md>{%- firstname %}&nbsp;{%- lastname %}</div>";

/***/ },
/* 1440 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xs-at-md><a href=\"{%= url %}&{%- portletnamespace %}selectedRmaId={%- id %}\"> {%- name %} </a></div>";

/***/ },
/* 1441 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-top-md> <div class=\"q-bg-c-lightest-grey q-border-all\"> <div class=q-pad-all-md> <div class=row> <div class=\"col-md-2 col-xs-12 q-marg-bottom-md-at-md\"> <span class=q-tag>{%- sku %}</span> </div> <div class=\"col-md-2 col-xs-12 q-marg-bottom-md-at-md\"> <span class=\"\">UPC: {%- upc %}</span> </div> <div class=\"col-md-3 col-xs-12 q-marg-bottom-md-at-md\"> <span class=\"\">Model: {%- modal %}</span> </div> <div class=\"col-md-2 col-xs-12 q-marg-bottom-md-at-md\"> <span class=\"\">QTY: {%- qty %}</span> </div> <div class=\"col-md-3 col-xs-12\"> <span class=\"\">RTV: {%- rtv %}</span> </div> </div> </div> </div> </div>";

/***/ },
/* 1442 */
/***/ function(module, exports) {

	module.exports = "<form class=schedulePickUpAltAddress> <div class=q-marg-all-xl> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Address *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input type=text class=\"q-input {%-consumerClass%} q-stretch required scheduleReportAddress1\" name=scheduleReportAddress1 id=scheduleReportAddress1 placeholder=\"Address 1\"/> </div> </div> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <input type=text class=\"q-input {%-consumerClass%} q-stretch scheduleReportAddress2\" name=scheduleReportAddress2 id=scheduleReportAddress2 placeholder=\"Address 2 (optional)\"/> </div> </div> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>City *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input type=text class=\"q-input {%-consumerClass%} q-stretch required scheduleReportCity\" name=scheduleReportCity id=scheduleReportCity placeholder=City /> </div> </div> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>State *</label> </div> <div class=\"col-md-9 col-xs-12\"> <select name=scheduleReportState id=scheduleReportState data-custom-select2-cls=\"{%-consumerClass%}\" class=\"select2-select select-valid-target q-input required scheduleReportState\" data-minimum-results-for-search=7 style=width:100% data-placeholder=\"Select State\" data-error-placement-append-closest=div> <option value=\"\">Select State</option> <option value=AL>Alabama</option> <option value=AK>Alaska</option> <option value=AZ>Arizona</option> <option value=AR>Arkansas</option> <option value=CA>California</option> <option value=CO>Colorado</option> <option value=CT>Connecticut</option> <option value=DE>Delaware</option> <option value=DC>District Of Columbia</option> <option value=FL>Florida</option> <option value=GA>Georgia</option> <option value=HI>Hawaii</option> <option value=ID>Idaho</option> <option value=IL>Illinois</option> <option value=IN>Indiana</option> <option value=IA>Iowa</option> <option value=KS>Kansas</option> <option value=KY>Kentucky</option> <option value=LA>Louisiana</option> <option value=ME>Maine</option> <option value=MD>Maryland</option> <option value=MA>Massachusetts</option> <option value=MI>Michigan</option> <option value=MN>Minnesota</option> <option value=MS>Mississippi</option> <option value=MO>Missouri</option> <option value=MT>Montana</option> <option value=NE>Nebraska</option> <option value=NV>Nevada</option> <option value=NH>New Hampshire</option> <option value=NJ>New Jersey</option> <option value=NM>New Mexico</option> <option value=NY>New York</option> <option value=NC>North Carolina</option> <option value=ND>North Dakota</option> <option value=OH>Ohio</option> <option value=OK>Oklahoma</option> <option value=OR>Oregon</option> <option value=PA>Pennsylvania</option> <option value=RI>Rhode Island</option> <option value=SC>South Carolina</option> <option value=SD>South Dakota</option> <option value=TN>Tennessee</option> <option value=TX>Texas</option> <option value=UT>Utah</option> <option value=VT>Vermont</option> <option value=VA>Virginia</option> <option value=WA>Washington</option> <option value=WV>West Virginia</option> <option value=WI>Wisconsin</option> <option value=WY>Wyoming</option> </select> </div> </div> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Postal Code *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input type=text class=\"q-input {%-consumerClass%} q-stretch required scheduleReportPostalCode\" name=scheduleReportPostalCode id=scheduleReportPostalCode placeholder=\"Postal Code\"/> </div> </div> <div class=\"row q-marg-bottom-md\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Country *</label> </div> <div class=\"col-md-9 col-xs-12\"> <select name=scheduleReportCountry id=scheduleReportCountry data-custom-select2-cls=\"{%-consumerClass%}\" class=\"select2-select select-valid-target q-input required scheduleReportCountry\" data-minimum-results-for-search=7 style=width:100% data-placeholder=\"Select Country\" data-error-placement-append-closest=div> <option value=US>USA</option> </select> </div> </div> </div> </form>";

/***/ },
/* 1443 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=\"q-title q-fw-normal\"> Map to a Shipping Method: </h2> </div> <div class=q-marg-vert-xl> <div class=\"row shipping-method-btn-toggler-section\"> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Shipping Method Type * </label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=\"quick-btn-group qb-default qb-purple-theme q-text-center shipping-method-btn-toggler\"> <a href=# class=\"q-btn first-child q-pad-horz-xs active shipping-method-btn\" data-qb-key=shipping-method-btn>Shipping Method</a> <a href=# class=\"q-btn last-child q-center q-pad-horz-xs service-levels-btn\" data-qb-key=service-levels-btn>Service Levels</a> <input type=hidden class=quick-btn-group-hidden-input name=btnTogglerName> </div> </div> </div> </div> <div class=shipping-method-section> <div class=q-marg-vert-xl> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Select Shipping Method* </label> </div> <div class=\"col-md-6 col-xs-12\"> <select id=shipment-method-select name=default-shipping-method class=select2-select style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select Shipping Method\" data-s2-minimum-results-for-search=Infinity> <option></option> </select> </div> </div> </div> </div> <div class=service-level-section> <div class=q-marg-vert-xl> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Select Service Level * </label> </div> <div class=\"col-md-6 col-xs-12\"> <select id=service-level-select name=default-service-level class=select2-select style=width:100% data-s2-placeholder=\"Select Service level\" data-s2-minimum-results-for-search=Infinity> <option value=\"\"></option> </select> </div> </div> </div> </div> </div>";

/***/ },
/* 1444 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-xl> <h2 class=\"q-title q-fw-normal\"> Create Custom Shipping String Name: </h2> </div> <div class=q-marg-vert-xl> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label> Custom Shipping String * </label> </div> <div class=\"col-md-9 col-x-12\"> <input type=text class=\"q-input q-stretch required customeShippingString\" placeholder=\"Free Shipping (5-7 Business Days)\"/> </div> <div id=custom-string-mapping-invalid class=\"col-md-9 col-md-offset-3 col-xs-12\" style=display:none> <label class=q-sim-error> String Name doesn't meet the requirements. </label> </div> <div id=custom-string-mapping-already-exist class=\"col-md-9 col-md-offset-3 col-xs-12\" style=display:none> <label class=q-sim-error> Name already exist. </label> </div> <div id=custom-string-mapping-predefined-shm-exist class=\"col-md-9 col-md-offset-3 col-xs-12\" style=display:none> <label class=q-sim-error> Pre-defined shipping methods cannot be used. </label> </div> <div class=\"col-md-9 col-md-offset-3 col-xs-12\"> <div class=q-marg-top-md> <div class=\"q-alert q-alert-grey q-text-left\"> The string entered in this field must match exactly as it appears in your shopping cart. <ul class=q-marg-top-md> <li>Must be unique</li> <li>100 character limit</li> <li>Alphanumeric</li> <li>Case and space sensitive</li> <li>Special Characters Accepted: (),{},[], dot(.), hyphen (--), comma(,), underscore (_), forward/backward slash</li> </ul> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1445 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-default-base q-max-page-width-md q-page-center-margin\"> <div class=\"q-card q-card-white\"> <div class=\"q-main-header clearfix\"> <div class=q-inline-block-til-md> <div class=\"q-main-header-title-container q-pad-right-sm-til-md\"> <h2 class=\"q-title q-boldest\"> {%= text %} Shipping String Mapping </h2> </div> </div> </div> <div class=q-section> {%= methodName %} </div> <div class=q-section> {%= mapToShippingType %} </div> <div class=\"q-footer q-no-border\"> <div class=\"q-footer-btn-group q-pull-right-til-md\"> <a href=# class=\"q-block-at-md q-text-center-at-md base-btn purple-btn v2-btn cancel-shipping-method-btn\" data-edit-checker-redirect=\"{%- editCheckerRedirect %} \">Cancel</a> <a href=# class=\"q-block-at-md q-text-center-at-md base-btn purple-btn save-shipping-method-btn\"> Submit </a> </div> </div> </div> </div>";

/***/ },
/* 1446 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row q-marg-bottom-lg certificate\" id=certificates> <div class=\"col-md-3 col-xs-12\"> </div> <div class=\"col-md-7 col-xs-12\"> <input type=text class=\"q-input q-stretch var-attr-val\" name=certificate id=\"certficate-row-{%- highestId %}\" placeholder=\"Enter certification name \" maxlength=75 /> </div> <div class=\"col-md-2 col-xs-12\"> <a href=# name=remove_certficate_row id=\"certficate-remove-row-{%- highestId %}\" class=\"base-btn purple-btn q-marg-top-md-at-md remove_certficate_row\"> Remove </a> </div> </div>";

/***/ },
/* 1447 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pretty-container q-pct-lightest-grey toggler-parent q-pad-top-md\"> <div class=q-pct-header> <div class=q-pct-header-group-main> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-pad-vert q-marg-left-md-til-md q-pad-horz-at-md q-pct-header-group-title q-text-center-at-md\"> <span class=\"q-tag q-fs-md\"> {%- sqFtHeader %}</span> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-horz-lg q-marg-vert-md\"> <div class=q-text-center-at-md> <span class=q-pad-right-sm-til-md> Total: </span> <span class=q-tag> {%- total %} sq. ft. </span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-horz-lg q-marg-vert-md\"> <div class=q-text-center-at-md> <span class=q-pad-right-sm-til-md> Available: </span> <span class=q-tag> {%- available %} sq. ft. </span> </div> </div> </div> <div class=\"col-md-3 col-xs-12\"> <div class=\"q-marg-top-xxs q-marg-horz-md q-marg-bottom-xl-at-md\"> {%= utilizationPill %} </div> </div> </div> </div> <div class=q-pct-header-group-expander> <a href=# class=\"q-pct-expander-icon-link quick-expander\" data-q-expander-close-icon=fa-angle-up data-q-expander-open-icon=fa-angle-down data-q-expander-target=.toggler-target data-q-expander-closest=.toggler-parent> <i class=\"fa fa-angle-down q-pct-expander-icon\" aria-hidden=true></i> </a> </div> </div> <div class=\"toggler-target q-expandable-default\"> <div class=q-pct-body> <div class=\"q-pad-horz-lg q-pad-vert-lg\"> <div class=\"divider-group dg-md dg-reversed\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs-til-md\"> <span class=q-boldest> Merchant 1 </span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs\"> Requested: <span class=q-boldest>5,000 sq. ft.</span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs\"> Percentage of Space: <span class=q-boldest>26%</span> </div> </div> </div> <div class=\"divider-group dg-md dg-reversed\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs-til-md\"> <span class=q-boldest> Merchant 2 </span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs\"> Requested: <span class=q-boldest>5,000 sq. ft.</span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs\"> Percentage of Space: <span class=q-boldest>26%</span> </div> </div> </div> <div class=\"divider-group dg-md dg-reversed\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs-til-md\"> <span class=q-boldest> Merchant 3 </span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs\"> Requested: <span class=q-boldest>5,000 sq. ft.</span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs\"> Percentage of Space: <span class=q-boldest>26%</span> </div> </div> </div> <div class=\"divider-group dg-md dg-reversed\"> <div class=row> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs-til-md\"> <span class=q-boldest> Merchant 4 </span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs\"> Requested: <span class=q-boldest>5,000 sq. ft.</span> </div> <div class=\"col-md-3 col-xs-12 q-col-spacer q-marg-top-xxxs\"> Percentage of Space: <span class=q-boldest>26%</span> </div> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1448 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pill q-pill-table {%- pillClass %} q-boldest\"> <span>{%- utilization %}</span>% Utilization </div>";

/***/ },
/* 1449 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-lg> <div class=q-marg-horz-xl> <div class=\"row q-marg-bottom-md\"> <div class=col-xs-12> <span>By reactivating this team member they will be able to log in and resume all current privileges captured within their profile.</span> </div> </div> <div class=row> <div class=col-xs-12> <span>Do you wish to continue?</span> </div> </div> </div> </div>";

/***/ },
/* 1450 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-lg> <div class=q-marg-horz-xl> <div class=\"row q-marg-bottom-md\"> <div class=col-xs-12> <span>By deactivating this team member you are removing all privileges and this team member will no longer be able to log in.</span> </div> </div> <div class=row> <div class=col-xs-12> <span>Do you wish to continue?</span> </div> </div> </div> </div>";

/***/ },
/* 1451 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-vert-lg> <div class=q-marg-horz-xl> <div class=\"row q-marg-bottom-md\"> <div class=col-xs-12> <span>By updating a team member's password, an email will be sent with a temporary password and instructions for the team member to log in and change their password.</span> </div> </div> <div class=row> <div class=col-xs-12> <span>Do you wish to continue?</span> </div> </div> </div> </div>";

/***/ },
/* 1452 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row org-row\" data-uso-id=\"{%- optional.usoId %}\"> <div class=col-xs-3> <div class=q-marg-vert-xxs> {%- orgName %} </div> </div> <div class=col-xs-7> <div class=q-marg-vert-xxs> {%- facilitiesCount %} </div> </div> <div class=\"col-xs-2 q-text-center\"> <a class=\"q-close-btn remove-org\" id=\"{%- orgId %}\"><i class=\"fa fa-times\"></i></a> </div> </div>";

/***/ },
/* 1453 */
/***/ function(module, exports) {

	module.exports = "<div class=facility-tab-inner> <div class=q-section> <div class=q-pad-all-xl> <h2 class=q-section-title> Origin and Destination Facilities </h2> <div class=\"q-alert q-alert-grey q-marg-vert-xl\">Inventory transfers require an origin and destination facility. You can manage your FedEx Supply Chain settings on the Facilities page.</div> <div class=q-marg-top-xl> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=orderFulfillmentCenter class=q-label>Origin Facility</label> </div> <div class=\"col-md-6 col-xs-12\"> <div> <select name=orderFulfillmentCenter class=\"select2-select q-input origin-facility\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select origin facility\" data-s2-minimum-results-for-search=5 required> <option></option> </select> </div> <div class=\"q-alert q-alert-grey q-marg-top-md q-text-left origin-fac-address-wrapper\" style=display:none> <div class=q-boldest>Facility Address:</div> <div class=origin-fac-address> <div>123 Store One Dr.</div> <div>Columbus, OH 12345</div> </div> <div class=\"q-marg-top-xs origin-fac-uses-list\"> <div class=q-boldest>Facility Uses:</div> <span class=\"q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border\">No Facility Uses</span> </div> </div> </div> </div> </div> <div class=q-marg-top-xl> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=destinationFulfillmentCenter class=q-label>Destination Facility</label> </div> <div class=\"col-md-6 col-xs-12\"> <div> <select name=destinationFulfillmentCenter class=\"select2-select q-input destination-facility\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select destination facility\" data-s2-minimum-results-for-search=5 required> <option></option> </select> </div> <div class=\"q-alert q-alert-grey q-marg-top-md q-text-left dest-fac-address-wrapper\" style=display:none> <div class=q-boldest>Facility Address:</div> <div class=dest-fac-address> <div>123 Store One Dr.</div> <div>Columbus, OH 12345</div> </div> <div class=\"q-marg-top-xs dest-fac-uses-list\"> <div class=q-boldest>Facility Uses:</div> <span class=\"q-pill q-pill-detail q-marg-top-xxs q-pill-blue-border\">No Facility Uses</span> </div> </div> </div> </div> </div> </div> </div> <input type=hidden name=orderType value=TRF /> </div>";

/***/ },
/* 1454 */
/***/ function(module, exports) {

	module.exports = "<tr id=\"{%- highestId %}\" class=product-item> <td class=vert-middle> <input type=number id=\"{%- portletNamespace %}quantity{%- highestId %}\" name=\"quantity_row_{%- highestId %}\" min=1 class=\"form-control required {%- portletNamespace %}quantity q-input text-center products-tab-quantity-input jqv-whole-number\" placeholder=Quantity value=1 aria-required=true> <input type=hidden name=prodTabSku value=\"{%- productName %}_row_{%- highestId %}\"> </td> <td class=vert-middle> <span class=\"text-purple products-tab-product-name\" id=\"{%- productName %}_row_{%- highestId %}\">{%- productName %}</span> <input type=hidden name=\"prodTabProductName_row_{%- highestId %}\" value=\"{%- productName %}\"> </td> <td class=vert-middle> <span class=products-tab-product-description name=\"{%- portletNamespace %}prodDescription\" id=\"{%- portletNamespace %}prodDescription\">{%- prodDescription %}</span> <input type=hidden name=\"prodTabProdDescription_row_{%- highestId %}\" value=\"{%- prodDescription %}\"> </td> <td class=vert-middle> <span class=\"products-tab-available-units qw-pill\" name=\"{%- portletNamespace %}availUnit\" id=\"{%- portletNamespace %}availUnit{%- highestId %}\">{%- availUnit %}</span> <input type=hidden name=\"availUnit_row_{%- highestId %}\" value=\"{%- availUnit %}\"> </td> <td class=\"text-center vert-middle\"> <span id=\"delete_row{%- highestId %}\" class=icon-remove style=cursor:pointer></span> </td> </tr>";

/***/ },
/* 1455 */
/***/ function(module, exports) {

	module.exports = "<div id=products-empty-table-validator class=products-tab data-qw-custom-validator=true> <div class=q-section> <div class=q-marg-all-xl> <h2 class=\"q-section-title q-marg-vert-xl\">Products to Include</h2> <div class=\"products-tab-products-table-error-message qw-error-wrapper qw-error-marg-top\" style=display:none> <div class=\"alert alert-danger\" role=alert> <i class=\"fa fa-exclamation-circle\" aria-hidden=true></i> <span class=sr-only>Error:</span> Add at least one product to continue </div> </div> <div class=\"q-input-group q-marg-vert-lg\"> <div class=\"q-alert q-alert-grey q-marg-vert-xl\">Only products that exist in the origin facility can be added to this transfer order.</div> <div class=row> <div class=\"col-md-6 col-xs-12\"> <select name=selectSku id=product-item-lookup class=quick-toggler style=width:100% data-s2-placeholder=\"Type product name (SKU)\" data-s2-minimum-results-for-search=Infinity data-error-placement-append-closest=div> <option value=\"\"></option> </select> </div> <div class=\"col-md-6 col-xs-12\"> </div> </div> </div> <div class=q-marg-vert-lg> <div class=q-overflow-x-auto> <div class=\"q-min-width-sm q-overflow-hidden selected-products-table\" style=display:none> <table id=product-tab-transfer-ord-table class=\"table q-table q-table-vert-middle q-table-rows-min-height q-no-marg\"> <thead> <tr> <th style=width:10%> Quantity </th> <th style=width:20%> Product Name (SKU) </th> <th style=width:30%> Product Description </th> <th class=q-text-center style=width:10%> Available </th> <th class=q-text-center style=width:10%> Remove </th> </tr> </thead> <tbody> </tbody> </table> </div> </div> </div> </div> </div> </div>";

/***/ },
/* 1456 */
/***/ function(module, exports) {

	module.exports = "<div class=review-tab-inner> <div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> <a data-target-form=.facilities-tab href=#> <span>Destination</span> <i class=\"fa fa-pencil q-icon-marg-left q-icon-md\" aria-hidden=true></i> </a> </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.destination data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"destination q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=row> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-boldest>Origin Facility:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=origin-facility-name></div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-5 col-xs-12\"></div> <div class=\"col-md-7 col-xs-12 origin-facility-address\"> </div> </div> </div> </div> <div class=\"col-md-6 col-xs-12\"> <div class=row> <div class=\"col-md-5 col-xs-12\"> <div class=q-boldest>Destination Facility:</div> </div> <div class=\"col-md-7 col-xs-12\"> <div class=dest-facility-name></div> </div> </div> <div class=q-marg-top-md> <div class=row> <div class=\"col-md-5 col-xs-12\"></div> <div class=\"col-md-7 col-xs-12 dest-facility-address\"> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> <a data-target-form=.products-tab href=#> <span>Products</span> <i class=\"fa fa-pencil q-icon-marg-left q-icon-md\" aria-hidden=true></i> </a> </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.contents data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"contents q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=q-overflow-x-auto> <div class=\"q-overflow-x-hidden q-min-width-xs\"> <table class=\"table q-table q-table-vert-middle q-table-rows-min-height q-table-pad-tds-md q-no-marg\"> <thead> <th style=width:20%> Product Name </th> <th style=width:52%> Product Description </th> <th style=width:28%> Quantity </th> </thead> <tbody class=review-tab-products-table-body> </tbody> </table> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=q-expandable-wrap> <div class=q-expandable-header> <h2 class=q-expandable-title> <a data-target-form=.shipping-tab href=#> <span>Shipping</span> <i class=\"fa fa-pencil q-icon-marg-left q-icon-md\" aria-hidden=true></i> </a> </h2> <a href=# class=\"q-expander q-pull-right\" data-q-expander-target=.shipping data-q-expander-open-icon=fa-expand data-q-expander-close-icon=fa-compress> <i class=\"q-expandable-icon fa fa-compress q-icon-md\" aria-hidden=true></i> </a> </div> <div class=\"shipping q-expandable-default-start-open q-expandee-open\"> <div class=q-expandable-body> <div class=\"divider-group dg-lg\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest>Target Completion Date:</div> </div> <div class=\"col-md-9 col-xs-12\"> <div class=rev-target-completion-date></div> </div> </div> </div> <div class=\"divider-group dg-lg\"> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=q-boldest>Shipping Type:</div> </div> <div class=\"col-md-9 col-xs-12\"> <div class=rev-shipping-type></div> </div> </div> </div> </div> </div> </div> </div> <div class=q-section> <div class=\"q-marg-horz-xl q-marg-vert-xl\"> <a href=# class=\"base-btn middle-btn purple-btn block-btn q-text-center create-button\"> Submit </a> </div> </div> </div>";

/***/ },
/* 1457 */
/***/ function(module, exports) {

	module.exports = "<div class=products-tab> <div class=q-section> <div class=q-marg-all-xl> <h2 class=\"q-section-title q-marg-vert-xl\">Shipping</h2> <div class=q-marg-vert-lg> <div class=\"q-alert q-alert-grey q-marg-vert-xl\">Please select the target completion date and shipping type for this transfer order.</div> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=targetCompletionDate class=q-label>Target Completion Date *</label> </div> <div class=\"col-md-3 col-xs-12\"> <div class=wrapper-helper> <div class=\"q-input-with-inner-text q-inner-text-right func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input\" id=targetCompletionDate name=targetCompletionDate required type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"   /   /   \" aria-required=true> </div> </div> </div> </div> <div class=q-marg-vert-lg> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=shippingType class=q-label>Shipping Type *</label> </div> <div class=\"col-md-6 col-xs-12\"> <div class=wrapper-helper> <select id=shippingType name=shippingType class=\"select2-select q-input shipping-type\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"Select shipping type\" data-s2-minimum-results-for-search=5 required> <option></option> </select> </div> </div> </div> </div> <div class=\"q-alert q-alert-yellow q-marg-vert-lg freight-shipping-message\" style=display:none> <div>Transfer orders that need Freight shipping require a custom quote.</div> <div>Once you have submitted this order, your dedicated customer success specialist will send a quote via email.</div> </div> </div> </div> </div> <div class=q-section> <div class=q-marg-all-xl> <h2 class=\"q-section-title q-marg-vert-xl\">Packaging</h2> <div class=\"q-alert q-alert-yellow q-marg-vert-lg\"> Transfer Orders do not include collateral or alternate packaging. </div> </div> </div> </div>";

/***/ },
/* 1458 */
/***/ function(module, exports) {

	module.exports = "<div class=qw-title-outer> <h2 class=qw-title> Transfer Order </h2> </div> <div class=qw-nav-steps> <a href=# class=\"qw-nav-step active\" data-qw-form-target=.facilities-tab> <span class=qw-nav-step-inner> Facilities </span> </a> <a href=# class=qw-nav-step data-qw-form-target=.products-tab> <span class=qw-nav-step-inner> Products </span> </a> <a href=# class=qw-nav-step data-qw-form-target=.shipping-tab> <span class=qw-nav-step-inner> Shipping </span> </a> <a href=# class=qw-nav-step data-qw-form-target=.review-tab> <span class=qw-nav-step-inner> Review </span> </a> </div> <div class=qw-forms-outer> <div class=\"qw-form facilities-tab\"> <div class=qw-form-inner> {%= facilityTab %} </div> </div> <div class=\"qw-form products-tab\"> <div class=qw-form-inner> {%= productsTab %} </div> </div> <div class=\"qw-form shipping-tab\"> <div class=qw-form-inner> {%= shippingTab %} </div> </div> <div class=\"qw-form review-tab\"> <div class=qw-form-inner> <div> {%= reviewTab %} </div> </div> </div> </div> <div class=qw-footer> <div class=\"q-pull-right next-prev-outer mobile-split-50-perc\"> <a href=# class=\"qw-prev base-btn purple-btn\"> <i class=\"fa fa-angle-left\" aria-hidden=true></i> Previous </a> <a href=# class=\"qw-next base-btn purple-btn\"> Next <i class=\"fa fa-angle-right\" aria-hidden=true></i> </a> </div> <a href=# id=order-cancel-btn class=\"qw-cancel base-btn purple-btn stretch-mobile v2-btn\"> Cancel </a> </div>";

/***/ },
/* 1459 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-section q-no-border-bottom\" id=add-webhook-modal-div> <div class=q-marg-all-xl> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label class=q-label>Webhook Event *</label> </div> <div class=\"col-md-9 col-xs-12\"> <select name=webhook-event-type id=webhook-event-type class=\"select2-select webhook-event-select\" style=width:100% data-error-placement-append-closest=div data-s2-minimum-results-for-search=Infinity data-s2-placeholder=\"Select an Event Type\"> <option></option> </select> <div id=eventtype-dropdown-error style=display:none> <label class=q-sim-error> This field is required </label> </div> </div> </div> </div> <div class=q-marg-vert-xl> <h5 class=\"q-title q-skinnier\">Please enter a Callback URL and optional Secret Key below. If your server is using a firewall, make sure to whitelist FedEx IPs before testing. (IPs: 31.31.24.0/21, 66.220.144.0/20). <a href=# id=redirectWebhookHelpcenterpage>See Help Center for more information.</a> </h5> </div> <div class=\"q-section q-no-border-bottom\"> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <div class=q-tag>Webhook ID:</div> </div> <div class=\"col-md-9 col-xs-12 webhook-unique-id\" id=webhook-unique-id> An ID will be generated after adding the webhook <div id=webhookid-error style=display:none> <label class=q-sim-error> This field is required </label> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=callbackUrl class=q-label>Callback URL *</label> </div> <div class=\"col-md-9 col-xs-12\"> <input id=callbackUrl required class=\"q-input q-stretch\" name=callbackUrl type=text placeholder=\"Callback URL\"/> <div id=callbackurl-error style=display:none> <label class=q-sim-error> This field is required </label> </div> </div> </div> </div> <div class=q-marg-vert-md> <div class=row> <div class=\"col-md-3 col-xs-12\"> <label for=secretkey class=q-label>Enter a Secret Key</label> </div> <div class=\"col-md-9 col-xs-12\"> <input id=secretkey required class=\"q-input q-stretch\" name=secretkey type=text placeholder=\"Enter a Secret Key\"/> </div> </div> </div> </div> <div class=q-marg-vert-lg id=dup-webhook> <div class=\"q-alert q-alert-red\"> The Callback URL you entered is being used by another Webhook ID. Please try another Callback URL and submit. </div> </div> </div> </div>";

/***/ },
/* 1460 */
/***/ function(module, exports) {

	module.exports = "<a href=# class=edit-webhook-btn id=\"{%- index %}\">{%- webHookClassName %} </a>";

/***/ },
/* 1461 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-marg-top-md file-name-row\"> <div class=\"pretty-well pw-pad-xs q-pad-vert-xxs pw-border pw-white-bg\"> <div class=row> <div class=col-xs-10> <div class=\"q-marg-top-xs q-marg-bottom-xs-at-md q-text-left\"> <span class=q-boldest>{%- fileName %}</span> </div> </div> <div class=col-xs-2> <a href=# class=\"q-close-btn q-pull-right q-no-pad-horz file-remove-btn-edit\"> <i class=\"fa fa-times\"></i> <input type=hidden value=\"{%- cisId %}\" name=cisId class=qfu-file-text-input id=wo-cis-id /> </a> </div> </div> </div> </div>";

/***/ },
/* 1462 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-link-list-container q-display-none-at-md q-overflow-auto\"> <span class=qllc-wrap> {%= linkList %} </span> </div> <div class=\"q-display-none q-block-at-md\"> <select id=\"{%- dropdownId %}\" name=\"{%- dropdownName %}\" class=\"select2-select q-input filter-by-select\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"{%- dropdownPlaceholder %}\" data-s2-minimum-results-for-search=\"{%- dropdownMinResultsForSearch %}\"> {%= optionList %} </select> </div>";

/***/ },
/* 1463 */
1170,
/* 1464 */
/***/ function(module, exports) {

	module.exports = "<a href=# class=\"list-group-item borderless\"> <span class=filter-text> {%= _.has(optional, 'text') ? text : value %} </span> <input type=checkbox class=pull-right value=\"{%- value %}\"> </a>";

/***/ },
/* 1465 */
/***/ function(module, exports) {

	module.exports = "<div class=q-grid> <div class=\"q-input-group q-input-group-connected no-pad-bottom q-row q-input-group-connected-break-at-sm wrapper-helper\"> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-first q-inner-text-right q-static-col-2 q-input-first func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input {%- uniqueIdentifier %}-start\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> <div class=\"q-input-group-connected-inner q-static-col\"> <div class=\"q-sim-input q-text-center\"> to </div> </div> <div class=\"q-input-with-inner-text q-input-group-connected-inner q-input-last q-inner-text-right q-static-col-2 q-input-last func-date-range-wrapper wrapper-helper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input {%- uniqueIdentifier %}-end\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> </div> </div>";

/***/ },
/* 1466 */
/***/ function(module, exports) {

	module.exports = "<div class=wrapper-helper> <div class=\"q-input-with-inner-text q-inner-text-right func-date-range-wrapper\"> <i class=\"fa fa-calendar q-inner-text-of-input q-icon-pointer func-date-range-icon-focuser\" aria-hidden=true></i> <input class=\"q-input q-stretch with-inner-text q-text-left func-date-range-input {%- uniqueIdentifier %}\" type=text data-error-placement-append-closest=.wrapper-helper placeholder=\"MM / DD / YYYY\"/> </div> </div>";

/***/ },
/* 1467 */
/***/ function(module, exports) {

	module.exports = "<div class=\"export-modal-body q-marg-all-xl\"> <div class=q-marg-vert-md> {%- exportAttemptTextPart1Lang %} <span id=row-count class=\"row-count {%-cssClassNameForCount%}\">{%- totalRows %}</span> {%- exportAttemptTextPart2Lang %} </div> <div class=q-marg-vert-md> {%- exportMaxLimitLang %} </div> <div class=q-marg-vert-md> <select class=\"form-control custom-select faux-placeholder dataFileType {%-cssClassNameForSelectFileTypeOnPopup%}\" name=dataFileType> <option class=defaultDropDnVal value=0 disabled=disabled selected=selected>Select file format</option> <option value=csv>CSV</option> <option value=pdf>PDF</option> </select> </div> </div>";

/***/ },
/* 1468 */
/***/ function(module, exports) {

	module.exports = "<button id=modalClose type=button class=\"base-btn purple-btn v2-btn\" data-dismiss=modal>Cancel</button> <button type=button disabled=true class=\"btn btn-primary modalExportData {%- cssClassNameForExportButtonOnPopup %}\">Export</button>";

/***/ },
/* 1469 */
/***/ function(module, exports) {

	module.exports = "<div class=\"checkbox q-checkbox checkbox-success cb-large\"> <input type=checkbox id=\"{%- value %}\" class=order-modal-checkbox value=\"{%- value %}\" name=\"{%- value %}\"/> <label for=\"{%- value %}\"></label> </div>";

/***/ },
/* 1470 */
/***/ function(module, exports) {

	module.exports = "<div class=q-marg-all-xl> {% if( optional.internationalAlertBlock ){ %} <div class=\"qw-products-intl-order q-alert q-alert-grey q-no-pad q-marg-vert-xl q-text-center\"> <p class=q-marg-all-sm> This is an international order, only international eligible products can be added. </p> </div> {% } %}  {% if( optional.originFacilityAlertBlock ){ %} <div class=\"qw-products-intl-order q-alert q-alert-grey q-no-pad q-marg-vert-xl q-text-center\"> <p class=q-marg-all-sm> Only products that exist in the origin facility can be added to this transfer order. </p> </div> {% } %} <div class=q-marg-vert-xl> <input type=text class=\"q-input q-stretch product-search-modal-input\" placeholder=\"Type product name (SKU) to filter class\"/> </div> <div class=\"\"> <div class=q-overflow-x-auto> <table class=\"modal-order-table table q-table q-table-vert-middle\"> <thead> <tr style=text-align:left> <th></th> <th align=center>Product Name</th> <th align=center>Description</th> {% if( optional.availableQuantityColumn ){ %} <th align=center>Available Quantity</th> {% } %} {% if( optional.typeColumn ){ %} <th align=center>Type</th> {% } %} </tr> </thead> </table> </div> </div> </div>";

/***/ },
/* 1471 */
/***/ function(module, exports) {

	module.exports = "<a href=# class=\"base-btn v2-btn purple-btn modal-auto-hide\">Close</a> <a href=# class=\"base-btn purple-btn add-products-btn\">Add Products</a>";

/***/ },
/* 1472 */
/***/ function(module, exports) {

	module.exports = "<div class=order-wizard-modal-total-checked></div>";

/***/ },
/* 1473 */
/***/ function(module, exports) {

	module.exports = "<div class=\"q-pill {%- pillClassQty %} q-pill-table\">{%- value %}</div>";

/***/ },
/* 1474 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	          value: ctor,
	          enumerable: false,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    if (superCtor) {
	      ctor.super_ = superCtor
	      var TempCtor = function () {}
	      TempCtor.prototype = superCtor.prototype
	      ctor.prototype = new TempCtor()
	      ctor.prototype.constructor = ctor
	    }
	  }
	}


/***/ },
/* 1475 */,
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = __webpack_require__(134)();
	var callBound = __webpack_require__(72);
	
	var $toString = callBound('Object.prototype.toString');
	
	/** @type {import('.')} */
	var isStandardArguments = function isArguments(value) {
		if (
			hasToStringTag
			&& value
			&& typeof value === 'object'
			&& Symbol.toStringTag in value
		) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	/** @type {import('.')} */
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null
			&& typeof value === 'object'
			&& 'length' in value
			&& typeof value.length === 'number'
			&& value.length >= 0
			&& $toString(value) !== '[object Array]'
			&& 'callee' in value
			&& $toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	// @ts-expect-error TODO make this not error
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	/** @type {import('.')} */
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 1477 */
/***/ function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
	var badArrayLike;
	var isCallableMarker;
	if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
		try {
			badArrayLike = Object.defineProperty({}, 'length', {
				get: function () {
					throw isCallableMarker;
				}
			});
			isCallableMarker = {};
			// eslint-disable-next-line no-throw-literal
			reflectApply(function () { throw 42; }, null, badArrayLike);
		} catch (_) {
			if (_ !== isCallableMarker) {
				reflectApply = null;
			}
		}
	} else {
		reflectApply = null;
	}
	
	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var objectClass = '[object Object]';
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var ddaClass = '[object HTMLAllCollection]'; // IE 11
	var ddaClass2 = '[object HTML document.all class]';
	var ddaClass3 = '[object HTMLCollection]'; // IE 9-10
	var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
	
	var isIE68 = !(0 in [,]); // eslint-disable-line no-sparse-arrays, comma-spacing
	
	var isDDA = function isDocumentDotAll() { return false; };
	if (typeof document === 'object') {
		// Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
		var all = document.all;
		if (toStr.call(all) === toStr.call(document.all)) {
			isDDA = function isDocumentDotAll(value) {
				/* globals document: false */
				// in IE 6-8, typeof document.all is "object" and it's truthy
				if ((isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) {
					try {
						var str = toStr.call(value);
						return (
							str === ddaClass
							|| str === ddaClass2
							|| str === ddaClass3 // opera 12.16
							|| str === objectClass // IE 6-8
						) && value('') == null; // eslint-disable-line eqeqeq
					} catch (e) { /**/ }
				}
				return false;
			};
		}
	}
	
	module.exports = reflectApply
		? function isCallable(value) {
			if (isDDA(value)) { return true; }
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			try {
				reflectApply(value, null, badArrayLike);
			} catch (e) {
				if (e !== isCallableMarker) { return false; }
			}
			return !isES6ClassFn(value) && tryFunctionObject(value);
		}
		: function isCallable(value) {
			if (isDDA(value)) { return true; }
			if (!value) { return false; }
			if (typeof value !== 'function' && typeof value !== 'object') { return false; }
			if (hasToStringTag) { return tryFunctionObject(value); }
			if (isES6ClassFn(value)) { return false; }
			var strClass = toStr.call(value);
			if (strClass !== fnClass && strClass !== genClass && !(/^\[object HTML/).test(strClass)) { return false; }
			return tryFunctionObject(value);
		};


/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(72);
	var safeRegexTest = __webpack_require__(1563);
	var isFnRegex = safeRegexTest(/^\s*(?:function)?\*/);
	var hasToStringTag = __webpack_require__(134)();
	var getProto = __webpack_require__(181);
	
	var toStr = callBound('Object.prototype.toString');
	var fnToStr = callBound('Function.prototype.toString');
	
	var getGeneratorFunction = __webpack_require__(1132);
	
	/** @type {import('.')} */
	module.exports = function isGeneratorFunction(fn) {
		if (typeof fn !== 'function') {
			return false;
		}
		if (isFnRegex(fnToStr(fn))) {
			return true;
		}
		if (!hasToStringTag) {
			var str = toStr(fn);
			return str === '[object GeneratorFunction]';
		}
		if (!getProto) {
			return false;
		}
		var GeneratorFunction = getGeneratorFunction();
		return GeneratorFunction && getProto(fn) === GeneratorFunction.prototype;
	};


/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(72);
	var hasToStringTag = __webpack_require__(134)();
	var hasOwn = __webpack_require__(282);
	var gOPD = __webpack_require__(93);
	
	/** @type {import('.')} */
	var fn;
	
	if (hasToStringTag) {
		/** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */
		var $exec = callBound('RegExp.prototype.exec');
		/** @type {object} */
		var isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		/** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */
		var badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	
		/** @type {import('.')} */
		// @ts-expect-error TS can't figure out that the $exec call always throws
		// eslint-disable-next-line consistent-return
		fn = function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {NonNullable<typeof gOPD>} */ (gOPD)(/** @type {{ lastIndex?: unknown }} */ (value), 'lastIndex');
			var hasLastIndexDataProperty = descriptor && hasOwn(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				// eslint-disable-next-line no-extra-parens
				$exec(value, /** @type {string} */ (/** @type {unknown} */ (badStringifier)));
			} catch (e) {
				return e === isRegexMarker;
			}
		};
	} else {
		/** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */
		var $toString = callBound('Object.prototype.toString');
		/** @const @type {'[object RegExp]'} */
		var regexClass = '[object RegExp]';
	
		/** @type {import('.')} */
		fn = function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};
	}
	
	module.exports = fn;


/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var whichTypedArray = __webpack_require__(460);
	
	/** @type {import('.')} */
	module.exports = function isTypedArray(value) {
		return !!whichTypedArray(value);
	};


/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(94),
	    root = __webpack_require__(64);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1511),
	    hashDelete = __webpack_require__(1512),
	    hashGet = __webpack_require__(1513),
	    hashHas = __webpack_require__(1514),
	    hashSet = __webpack_require__(1515);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(94),
	    root = __webpack_require__(64);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(94),
	    root = __webpack_require__(64);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(325),
	    setCacheAdd = __webpack_require__(1535),
	    setCacheHas = __webpack_require__(1536);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(136),
	    stackClear = __webpack_require__(1538),
	    stackDelete = __webpack_require__(1539),
	    stackGet = __webpack_require__(1540),
	    stackHas = __webpack_require__(1541),
	    stackSet = __webpack_require__(1542);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(64);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(94),
	    root = __webpack_require__(64);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1489 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1500),
	    isArguments = __webpack_require__(1543),
	    isArray = __webpack_require__(191),
	    isBuffer = __webpack_require__(330),
	    isIndex = __webpack_require__(1516),
	    isTypedArray = __webpack_require__(333);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 1491 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 1492 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(1491),
	    isArray = __webpack_require__(191);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(138),
	    isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1496),
	    isObjectLike = __webpack_require__(141);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(1486),
	    equalArrays = __webpack_require__(326),
	    equalByTag = __webpack_require__(1504),
	    equalObjects = __webpack_require__(1505),
	    getTag = __webpack_require__(1509),
	    isArray = __webpack_require__(191),
	    isBuffer = __webpack_require__(330),
	    isTypedArray = __webpack_require__(333);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(331),
	    isMasked = __webpack_require__(1518),
	    isObject = __webpack_require__(106),
	    toSource = __webpack_require__(328);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(138),
	    isLength = __webpack_require__(332),
	    isObjectLike = __webpack_require__(141);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(1519),
	    nativeKeys = __webpack_require__(1531);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1500 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1501 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 1502 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(64);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(190),
	    Uint8Array = __webpack_require__(1487),
	    eq = __webpack_require__(329),
	    equalArrays = __webpack_require__(326),
	    mapToArray = __webpack_require__(1530),
	    setToArray = __webpack_require__(1537);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(1506);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(1493),
	    getSymbols = __webpack_require__(1508),
	    keys = __webpack_require__(1546);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(190);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(1489),
	    stubArray = __webpack_require__(1547);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1481),
	    Map = __webpack_require__(189),
	    Promise = __webpack_require__(1483),
	    Set = __webpack_require__(1484),
	    WeakMap = __webpack_require__(1488),
	    baseGetTag = __webpack_require__(138),
	    toSource = __webpack_require__(328);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 1510 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(140);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1512 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(140);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(140);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(140);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1516 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 1517 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1503);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1519 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 1520 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(137);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(137);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(137);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(137);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1482),
	    ListCache = __webpack_require__(136),
	    Map = __webpack_require__(189);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(139);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(139);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(139);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(139);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1530 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(1534);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(327);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)(module)))

/***/ },
/* 1533 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1534 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 1535 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1536 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1537 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(136);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1539 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1540 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1541 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(136),
	    Map = __webpack_require__(189),
	    MapCache = __webpack_require__(325);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1494),
	    isObjectLike = __webpack_require__(141);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(331),
	    isLength = __webpack_require__(332);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(1495);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1490),
	    baseKeys = __webpack_require__(1499),
	    isArrayLike = __webpack_require__(1544);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 1547 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 1548 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1549 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./abs')} */
	module.exports = Math.abs;


/***/ },
/* 1550 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./floor')} */
	module.exports = Math.floor;


/***/ },
/* 1551 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./isNaN')} */
	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ },
/* 1552 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./max')} */
	module.exports = Math.max;


/***/ },
/* 1553 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./min')} */
	module.exports = Math.min;


/***/ },
/* 1554 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./pow')} */
	module.exports = Math.pow;


/***/ },
/* 1555 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('./round')} */
	module.exports = Math.round;


/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(1551);
	
	/** @type {import('./sign')} */
	module.exports = function sign(number) {
		if ($isNaN(number) || number === 0) {
			return number;
		}
		return number < 0 ? -1 : +1;
	};


/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	// THIS FILE IS GENERATED - DO NOT EDIT!
	/*!mobile-detect v1.3.6 2017-04-05*/
	/*global module:false, define:false*/
	/*jshint latedef:false*/
	/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
	(function (define, undefined) {
	define(function () {
	    'use strict';
	
	    var impl = {};
	
	    impl.mobileDetectRules = {
	    "phones": {
	        "iPhone": "\\biPhone\\b|\\biPod\\b",
	        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+",
	        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m",
	        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 6",
	        "Dell": "Dell.*Streak|Dell.*Aero|Dell.*Venue|DELL.*Venue Pro|Dell Flash|Dell Smoke|Dell Mini 3iX|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
	        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b",
	        "Samsung": "\\bSamsung\\b|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C",
	        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323)",
	        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533",
	        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
	        "NokiaLumia": "Lumia [0-9]{3,4}",
	        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
	        "Palm": "PalmSource|Palm",
	        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
	        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
	        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
	        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
	        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
	        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
	        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
	        "Alcatel": "Alcatel",
	        "Nintendo": "Nintendo 3DS",
	        "Amoi": "Amoi",
	        "INQ": "INQ",
	        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
	    },
	    "tablets": {
	        "iPad": "iPad|iPad.*Mobile",
	        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
	        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587",
	        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
	        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
	        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
	        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z",
	        "BlackBerryTablet": "PlayBook|RIM Tablet",
	        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
	        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
	        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
	        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30",
	        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
	        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
	        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
	        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
	        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)",
	        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
	        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
	        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
	        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
	        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
	        "IRUTablet": "M702pro",
	        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
	        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
	        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
	        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
	        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
	        "NokiaLumiaTablet": "Lumia 2520",
	        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP612|SOT31",
	        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
	        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
	        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
	        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
	        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
	        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
	        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
	        "FlyTablet": "IQ310|Fly Vision",
	        "bqTablet": "Android.*(bq)?.*(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris [E|M]10)|Maxwell.*Lite|Maxwell.*Plus",
	        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim",
	        "NecTablet": "\\bN-06D|\\bN-08D",
	        "PantechTablet": "Pantech.*P4100",
	        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
	        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
	        "ZyncTablet": "z1000|Z99 2G|z99|z930|z999|z990|z909|Z919|z900",
	        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
	        "NabiTablet": "Android.*\\bNabi",
	        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
	        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
	        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
	        "PlaystationTablet": "Playstation.*(Portable|Vita)",
	        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
	        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
	        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
	        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
	        "GalapadTablet": "Android.*\\bG1\\b",
	        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
	        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
	        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
	        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
	        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
	        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
	        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
	        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
	        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)",
	        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
	        "DPSTablet": "DPS Dream 9|DPS Dual 7",
	        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
	        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
	        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
	        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
	        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
	        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
	        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
	        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
	        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
	        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497",
	        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
	        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
	        "iMobileTablet": "i-mobile i-note",
	        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
	        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
	        "AMPETablet": "Android.* A78 ",
	        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
	        "TecnoTablet": "TECNO P9",
	        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
	        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
	        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
	        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
	        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
	        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
	        "CaptivaTablet": "CAPTIVA PAD",
	        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
	        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
	        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+",
	        "JaytechTablet": "TPC-PA762",
	        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
	        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
	        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
	        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
	        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
	        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
	        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
	        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
	        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
	        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
	        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
	        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
	        "UbislateTablet": "UbiSlate[\\s]?7C",
	        "PocketBookTablet": "Pocketbook",
	        "KocasoTablet": "\\b(TB-1207)\\b",
	        "HisenseTablet": "\\b(F5281|E2371)\\b",
	        "Hudl": "Hudl HT7S3|Hudl 2",
	        "TelstraTablet": "T-Hub2",
	        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b"
	    },
	    "oss": {
	        "AndroidOS": "Android",
	        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
	        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
	        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
	        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Window Mobile|Windows Phone [0-9.]+|WCE;",
	        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
	        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad",
	        "MeeGoOS": "MeeGo",
	        "MaemoOS": "Maemo",
	        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
	        "webOS": "webOS|hpwOS",
	        "badaOS": "\\bBada\\b",
	        "BREWOS": "BREW"
	    },
	    "uas": {
	        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
	        "Dolfin": "\\bDolfin\\b",
	        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+|Coast\/[0-9.]+",
	        "Skyfire": "Skyfire",
	        "Edge": "Mobile Safari\/[.0-9]* Edge",
	        "IE": "IEMobile|MSIEMobile",
	        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
	        "Bolt": "bolt",
	        "TeaShark": "teashark",
	        "Blazer": "Blazer",
	        "Safari": "Version.*Mobile.*Safari|Safari.*Mobile|MobileSafari",
	        "UCBrowser": "UC.*Browser|UCWEB",
	        "baiduboxapp": "baiduboxapp",
	        "baidubrowser": "baidubrowser",
	        "DiigoBrowser": "DiigoBrowser",
	        "Puffin": "Puffin",
	        "Mercury": "\\bMercury\\b",
	        "ObigoBrowser": "Obigo",
	        "NetFront": "NF-Browser",
	        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
	        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
	    },
	    "props": {
	        "Mobile": "Mobile\/[VER]",
	        "Build": "Build\/[VER]",
	        "Version": "Version\/[VER]",
	        "VendorID": "VendorID\/[VER]",
	        "iPad": "iPad.*CPU[a-z ]+[VER]",
	        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
	        "iPod": "iPod.*CPU[a-z ]+[VER]",
	        "Kindle": "Kindle\/[VER]",
	        "Chrome": [
	            "Chrome\/[VER]",
	            "CriOS\/[VER]",
	            "CrMo\/[VER]"
	        ],
	        "Coast": [
	            "Coast\/[VER]"
	        ],
	        "Dolfin": "Dolfin\/[VER]",
	        "Firefox": [
	            "Firefox\/[VER]",
	            "FxiOS\/[VER]"
	        ],
	        "Fennec": "Fennec\/[VER]",
	        "Edge": "Edge\/[VER]",
	        "IE": [
	            "IEMobile\/[VER];",
	            "IEMobile [VER]",
	            "MSIE [VER];",
	            "Trident\/[0-9.]+;.*rv:[VER]"
	        ],
	        "NetFront": "NetFront\/[VER]",
	        "NokiaBrowser": "NokiaBrowser\/[VER]",
	        "Opera": [
	            " OPR\/[VER]",
	            "Opera Mini\/[VER]",
	            "Version\/[VER]"
	        ],
	        "Opera Mini": "Opera Mini\/[VER]",
	        "Opera Mobi": "Version\/[VER]",
	        "UC Browser": "UC Browser[VER]",
	        "MQQBrowser": "MQQBrowser\/[VER]",
	        "MicroMessenger": "MicroMessenger\/[VER]",
	        "baiduboxapp": "baiduboxapp\/[VER]",
	        "baidubrowser": "baidubrowser\/[VER]",
	        "SamsungBrowser": "SamsungBrowser\/[VER]",
	        "Iron": "Iron\/[VER]",
	        "Safari": [
	            "Version\/[VER]",
	            "Safari\/[VER]"
	        ],
	        "Skyfire": "Skyfire\/[VER]",
	        "Tizen": "Tizen\/[VER]",
	        "Webkit": "webkit[ \/][VER]",
	        "PaleMoon": "PaleMoon\/[VER]",
	        "Gecko": "Gecko\/[VER]",
	        "Trident": "Trident\/[VER]",
	        "Presto": "Presto\/[VER]",
	        "Goanna": "Goanna\/[VER]",
	        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
	        "Android": "Android [VER]",
	        "BlackBerry": [
	            "BlackBerry[\\w]+\/[VER]",
	            "BlackBerry.*Version\/[VER]",
	            "Version\/[VER]"
	        ],
	        "BREW": "BREW [VER]",
	        "Java": "Java\/[VER]",
	        "Windows Phone OS": [
	            "Windows Phone OS [VER]",
	            "Windows Phone [VER]"
	        ],
	        "Windows Phone": "Windows Phone [VER]",
	        "Windows CE": "Windows CE\/[VER]",
	        "Windows NT": "Windows NT [VER]",
	        "Symbian": [
	            "SymbianOS\/[VER]",
	            "Symbian\/[VER]"
	        ],
	        "webOS": [
	            "webOS\/[VER]",
	            "hpwOS\/[VER];"
	        ]
	    },
	    "utils": {
	        "Bot": "Googlebot|facebookexternalhit|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom",
	        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
	        "DesktopMode": "WPDesktop",
	        "TV": "SonyDTV|HbbTV",
	        "WebKit": "(webkit)[ \/]([\\w.]+)",
	        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|PLAYSTATION|Xbox)\\b",
	        "Watch": "SM-V700"
	    }
	};
	
	    // following patterns come from http://detectmobilebrowsers.com/
	    impl.detectMobileBrowsers = {
	        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
	        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
	        tabletPattern: /android|ipad|playbook|silk/i
	    };
	
	    var hasOwnProp = Object.prototype.hasOwnProperty,
	        isArray;
	
	    impl.FALLBACK_PHONE = 'UnknownPhone';
	    impl.FALLBACK_TABLET = 'UnknownTablet';
	    impl.FALLBACK_MOBILE = 'UnknownMobile';
	
	    isArray = ('isArray' in Array) ?
	        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };
	
	    function equalIC(a, b) {
	        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
	    }
	
	    function containsIC(array, value) {
	        var valueLC, i, len = array.length;
	        if (!len || !value) {
	            return false;
	        }
	        valueLC = value.toLowerCase();
	        for (i = 0; i < len; ++i) {
	            if (valueLC === array[i].toLowerCase()) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    function convertPropsToRegExp(object) {
	        for (var key in object) {
	            if (hasOwnProp.call(object, key)) {
	                object[key] = new RegExp(object[key], 'i');
	            }
	        }
	    }
	
	    (function init() {
	        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
	        for (key in mobileDetectRules.props) {
	            if (hasOwnProp.call(mobileDetectRules.props, key)) {
	                values = mobileDetectRules.props[key];
	                if (!isArray(values)) {
	                    values = [values];
	                }
	                len = values.length;
	                for (i = 0; i < len; ++i) {
	                    value = values[i];
	                    verPos = value.indexOf('[VER]');
	                    if (verPos >= 0) {
	                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
	                    }
	                    values[i] = new RegExp(value, 'i');
	                }
	                mobileDetectRules.props[key] = values;
	            }
	        }
	        convertPropsToRegExp(mobileDetectRules.oss);
	        convertPropsToRegExp(mobileDetectRules.phones);
	        convertPropsToRegExp(mobileDetectRules.tablets);
	        convertPropsToRegExp(mobileDetectRules.uas);
	        convertPropsToRegExp(mobileDetectRules.utils);
	
	        // copy some patterns to oss0 which are tested first (see issue#15)
	        mobileDetectRules.oss0 = {
	            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
	            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
	        };
	    }());
	
	    /**
	     * Test userAgent string against a set of rules and find the first matched key.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
	     * @private
	     */
	    impl.findMatch = function(rules, userAgent) {
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    return key;
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Test userAgent string against a set of rules and return an array of matched keys.
	     * @param {Object} rules (key is String, value is RegExp)
	     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
	     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
	     * @private
	     */
	    impl.findMatches = function(rules, userAgent) {
	        var result = [];
	        for (var key in rules) {
	            if (hasOwnProp.call(rules, key)) {
	                if (rules[key].test(userAgent)) {
	                    result.push(key);
	                }
	            }
	        }
	        return result;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {String} version or <tt>null</tt> if version not found
	     * @private
	     */
	    impl.getVersionStr = function (propertyName, userAgent) {
	        var props = impl.mobileDetectRules.props, patterns, i, len, match;
	        if (hasOwnProp.call(props, propertyName)) {
	            patterns = props[propertyName];
	            len = patterns.length;
	            for (i = 0; i < len; ++i) {
	                match = patterns[i].exec(userAgent);
	                if (match !== null) {
	                    return match[1];
	                }
	            }
	        }
	        return null;
	    };
	
	    /**
	     * Check the version of the given property in the User-Agent.
	     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	     *
	     * @param {String} propertyName
	     * @param {String} userAgent
	     * @return {Number} version or <tt>NaN</tt> if version not found
	     * @private
	     */
	    impl.getVersion = function (propertyName, userAgent) {
	        var version = impl.getVersionStr(propertyName, userAgent);
	        return version ? impl.prepareVersionNo(version) : NaN;
	    };
	
	    /**
	     * Prepare the version number.
	     *
	     * @param {String} version
	     * @return {Number} the version number as a floating number
	     * @private
	     */
	    impl.prepareVersionNo = function (version) {
	        var numbers;
	
	        numbers = version.split(/[a-z._ \/\-]/i);
	        if (numbers.length === 1) {
	            version = numbers[0];
	        }
	        if (numbers.length > 1) {
	            version = numbers[0] + '.';
	            numbers.shift();
	            version += numbers.join('');
	        }
	        return Number(version);
	    };
	
	    impl.isMobileFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
	            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
	    };
	
	    impl.isTabletFallback = function (userAgent) {
	        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
	    };
	
	    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
	        if (cache.mobile !== undefined) {
	            return;
	        }
	        var phone, tablet, phoneSized;
	
	        // first check for stronger tablet rules, then phone (see issue#5)
	        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
	        if (tablet) {
	            cache.mobile = cache.tablet = tablet;
	            cache.phone = null;
	            return; // unambiguously identified as tablet
	        }
	
	        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
	        if (phone) {
	            cache.mobile = cache.phone = phone;
	            cache.tablet = null;
	            return; // unambiguously identified as phone
	        }
	
	        // our rules haven't found a match -> try more general fallback rules
	        if (impl.isMobileFallback(userAgent)) {
	            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
	            if (phoneSized === undefined) {
	                cache.mobile = impl.FALLBACK_MOBILE;
	                cache.tablet = cache.phone = null;
	            } else if (phoneSized) {
	                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
	                cache.tablet = null;
	            } else {
	                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	                cache.phone = null;
	            }
	        } else if (impl.isTabletFallback(userAgent)) {
	            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
	            cache.phone = null;
	        } else {
	            // not mobile at all!
	            cache.mobile = cache.tablet = cache.phone = null;
	        }
	    };
	
	    // t is a reference to a MobileDetect instance
	    impl.mobileGrade = function (t) {
	        // impl note:
	        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
	        // When changes are made in Mobile_Detect.php, copy this method and replace:
	        //     $this-> / t.
	        //     self::MOBILE_GRADE_(.) / '$1'
	        //     , self::VERSION_TYPE_FLOAT / (nothing)
	        //     isIOS() / os('iOS')
	        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
	        var $isMobile = t.mobile() !== null;
	
	        if (
	            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
	            t.os('iOS') && t.version('iPad')>=4.3 ||
	            t.os('iOS') && t.version('iPhone')>=3.1 ||
	            t.os('iOS') && t.version('iPod')>=3.1 ||
	
	            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
	            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
	            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
	            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
	            ( t.version('Android')>2.1 && t.is('Webkit') ) ||
	
	            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
	            t.version('Windows Phone OS')>=7.0 ||
	
	            // Blackberry 7 - Tested on BlackBerry Torch 9810
	            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
	            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
	            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
	            t.match('Playbook.*Tablet') ||
	
	            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
	            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
	            // Palm WebOS 3.0  - Tested on HP TouchPad
	            t.match('hp.*TouchPad') ||
	
	            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
	            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||
	
	            // Chrome for Android - Tested on Android 4.0, 4.1 device
	            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||
	
	            // Skyfire 4.1 - Tested on Android 2.3 device
	            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||
	
	            // Opera Mobile 11.5-12: Tested on Android 2.3
	            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||
	
	            // Meego 1.2 - Tested on Nokia 950 and N9
	            t.is('MeeGoOS') ||
	
	            // Tizen (pre-release) - Tested on early hardware
	            t.is('Tizen') ||
	
	            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
	            // @todo: more tests here!
	            t.is('Dolfin') && t.version('Bada')>=2.0 ||
	
	            // UC Browser - Tested on Android 2.3 device
	            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||
	
	            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
	            ( t.match('Kindle Fire') ||
	                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||
	
	            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
	            t.is('AndroidOS') && t.is('NookTablet') ||
	
	            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
	            t.version('Chrome')>=11 && !$isMobile ||
	
	            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
	            t.version('Safari')>=5.0 && !$isMobile ||
	
	            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
	            t.version('Firefox')>=4.0 && !$isMobile ||
	
	            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
	            t.version('MSIE')>=7.0 && !$isMobile ||
	
	            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
	            // @reference: http://my.opera.com/community/openweb/idopera/
	            t.version('Opera')>=10 && !$isMobile
	
	            ){
	            return 'A';
	        }
	
	        if (
	            t.os('iOS') && t.version('iPad')<4.3 ||
	            t.os('iOS') && t.version('iPhone')<3.1 ||
	            t.os('iOS') && t.version('iPod')<3.1 ||
	
	            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
	            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||
	
	            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
	            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
	                (t.version('Android')>=2.3 || t.is('iOS')) ) ||
	
	            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
	            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||
	
	            // @todo: report this (tested on Nokia N71)
	            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
	            ){
	            return 'B';
	        }
	
	        if (
	        // Blackberry 4.x - Tested on the Curve 8330
	            t.version('BlackBerry')<5.0 ||
	            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
	            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2
	
	            ){
	            return 'C';
	        }
	
	        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
	        //will receive the basic, C grade experience.
	        return 'C';
	    };
	
	    impl.detectOS = function (ua) {
	        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
	            impl.findMatch(impl.mobileDetectRules.oss, ua);
	    };
	
	    impl.getDeviceSmallerSide = function () {
	        return window.screen.width < window.screen.height ?
	            window.screen.width :
	            window.screen.height;
	    };
	
	    /**
	     * Constructor for MobileDetect object.
	     * <br>
	     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
	     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
	     *     <strong>Find information how to download and install:</strong>
	     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
	     * </div>
	     *
	     * @example <pre>
	     *     var md = new MobileDetect(window.navigator.userAgent);
	     *     if (md.mobile()) {
	     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
	     *     }
	     * </pre>
	     *
	     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
	     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
	     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
	     *        as phone.
	     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
	     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
	     *        for Android</a>.<br>
	     *        If you provide a value < 0, then this "fuzzy" check is disabled.
	     * @constructor
	     * @global
	     */
	    function MobileDetect(userAgent, maxPhoneWidth) {
	        this.ua = userAgent || '';
	        this._cache = {};
	        //600dp is typical 7" tablet minimum width
	        this.maxPhoneWidth = maxPhoneWidth || 600;
	    }
	
	    MobileDetect.prototype = {
	        constructor: MobileDetect,
	
	        /**
	         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
	         * <br>
	         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
	         * <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
	         * @function MobileDetect#mobile
	         */
	        mobile: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.mobile;
	        },
	
	        /**
	         * Returns the detected phone type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPhone, BlackBerry, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
	         * NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile, SimValley,
	         * Wolfgang, Alcatel, Nintendo, Amoi, INQ, GenericPhone</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
	         * @function MobileDetect#phone
	         */
	        phone: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.phone;
	        },
	
	        /**
	         * Returns the detected tablet type/family string or <tt>null</tt>.
	         * <br>
	         * The returned tablet (family or producer) is one of following keys:<br>
	         * <br><tt>iPad, NexusTablet, SamsungTablet, Kindle, SurfaceTablet, HPTablet, AsusTablet,
	         * BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet, AcerTablet,
	         * ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet, LenovoTablet,
	         * DellTablet, YarvikTablet, MedionTablet, ArnovaTablet, IntensoTablet, IRUTablet,
	         * MegafonTablet, EbodaTablet, AllViewTablet, ArchosTablet, AinolTablet,
	         * NokiaLumiaTablet, SonyTablet, PhilipsTablet, CubeTablet, CobyTablet, MIDTablet,
	         * MSITablet, SMiTTablet, RockChipTablet, FlyTablet, bqTablet, HuaweiTablet,
	         * NecTablet, PantechTablet, BronchoTablet, VersusTablet, ZyncTablet,
	         * PositivoTablet, NabiTablet, KoboTablet, DanewTablet, TexetTablet,
	         * PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
	         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
	         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
	         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
	         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
	         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
	         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
	         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
	         * OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet, OndaTablet,
	         * JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet, LavaTablet,
	         * AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MiTablet, NibiruTablet,
	         * NexoTablet, LeaderTablet, UbislateTablet, PocketBookTablet, KocasoTablet,
	         * HisenseTablet, Hudl, TelstraTablet, GenericTablet</tt><br>
	         * <br>
	         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
	         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
	         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
	         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
	         * <br>
	         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
	         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
	         * will return <code>UnknownMobile</code>.<br>
	         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
	         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
	         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
	         * <br>
	         * In most cases you will use the return value just as a boolean.
	         *
	         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
	         * @function MobileDetect#tablet
	         */
	        tablet: function () {
	            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
	            return this._cache.tablet;
	        },
	
	        /**
	         * Returns the (first) detected user-agent string or <tt>null</tt>.
	         * <br>
	         * The returned user-agent is one of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {String} the key for the detected user-agent or <tt>null</tt>
	         * @function MobileDetect#userAgent
	         */
	        userAgent: function () {
	            if (this._cache.userAgent === undefined) {
	                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgent;
	        },
	
	        /**
	         * Returns all detected user-agent strings.
	         * <br>
	         * The array is empty or contains one or more of following keys:<br>
	         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
	         * Safari, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Puffin, Mercury,
	         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
	         * <br>
	         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
	         * cases where a mobile device pretends to be more than one particular browser. You can get the
	         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
	         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
	         *
	         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
	         * @function MobileDetect#userAgents
	         */
	        userAgents: function () {
	            if (this._cache.userAgents === undefined) {
	                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
	            }
	            return this._cache.userAgents;
	        },
	
	        /**
	         * Returns the detected operating system string or <tt>null</tt>.
	         * <br>
	         * The operating system is one of following keys:<br>
	         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
	         * iOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
	         *
	         * @returns {String} the key for the detected operating system.
	         * @function MobileDetect#os
	         */
	        os: function () {
	            if (this._cache.os === undefined) {
	                this._cache.os = impl.detectOS(this.ua);
	            }
	            return this._cache.os;
	        },
	
	        /**
	         * Get the version (as Number) of the given property in the User-Agent.
	         * <br>
	         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
	         *          Be careful when comparing this value with '==' operator!
	         * @function MobileDetect#version
	         */
	        version: function (key) {
	            return impl.getVersion(key, this.ua);
	        },
	
	        /**
	         * Get the version (as String) of the given property in the User-Agent.
	         * <br>
	         *
	         * @param {String} key a key defining a thing which has a version.<br>
	         *        You can use one of following keys:<br>
	         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
	         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
	         * Opera Mobi, UC Browser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
	         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon, Gecko, Trident,
	         * Presto, Goanna, iOS, Android, BlackBerry, BREW, Java, Windows Phone OS, Windows
	         * Phone, Windows CE, Windows NT, Symbian, webOS</tt><br>
	         *
	         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
	         *
	         * @function MobileDetect#versionStr
	         */
	        versionStr: function (key) {
	            return impl.getVersionStr(key, this.ua);
	        },
	
	        /**
	         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
	         *
	         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
	         *        tablet family.<br>
	         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
	         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
	         *        Additionally you have following keys:<br>
	         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
	         *
	         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
	         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
	         * @function MobileDetect#is
	         */
	        is: function (key) {
	            return containsIC(this.userAgents(), key) ||
	                   equalIC(key, this.os()) ||
	                   equalIC(key, this.phone()) ||
	                   equalIC(key, this.tablet()) ||
	                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
	        },
	
	        /**
	         * Do a quick test against navigator::userAgent.
	         *
	         * @param {String|RegExp} pattern the pattern, either as String or RegExp
	         *                        (a string will be converted to a case-insensitive RegExp).
	         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
	         * @function MobileDetect#match
	         */
	        match: function (pattern) {
	            if (!(pattern instanceof RegExp)) {
	                pattern = new RegExp(pattern, 'i');
	            }
	            return pattern.test(this.ua);
	        },
	
	        /**
	         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
	         * <br>
	         * Obviously this method makes sense in browser environments only (not for Node.js)!
	         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
	         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
	         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
	         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
	         *          Will always return <code>undefined</code> server-side.
	         */
	        isPhoneSized: function (maxPhoneWidth) {
	            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
	        },
	
	        /**
	         * Returns the mobile grade ('A', 'B', 'C').
	         *
	         * @returns {String} one of the mobile grades ('A', 'B', 'C').
	         * @function MobileDetect#mobileGrade
	         */
	        mobileGrade: function () {
	            if (this._cache.grade === undefined) {
	                this._cache.grade = impl.mobileGrade(this);
	            }
	            return this._cache.grade;
	        }
	    };
	
	    // environment-dependent
	    if (typeof window !== 'undefined' && window.screen) {
	        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
	            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
	        };
	    } else {
	        MobileDetect.isPhoneSized = function () {};
	    }
	
	    // should not be replaced by a completely new object - just overwrite existing methods
	    MobileDetect._impl = impl;
	    
	    MobileDetect.version = '1.3.6 2017-04-05';
	
	    return MobileDetect;
	}); // end of call of define()
	})((function (undefined) {
	    if (typeof module !== 'undefined' && module.exports) {
	        return function (factory) { module.exports = factory(); };
	    } else if (true) {
	        return __webpack_require__(1580);
	    } else if (typeof window !== 'undefined') {
	        return function (factory) { window.MobileDetect = factory(); };
	    } else {
	        // please file a bug if you get this error!
	        throw new Error('unknown environment');
	    }
	})());

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 334,
		"./af.js": 334,
		"./ar": 341,
		"./ar-dz": 335,
		"./ar-dz.js": 335,
		"./ar-kw": 336,
		"./ar-kw.js": 336,
		"./ar-ly": 337,
		"./ar-ly.js": 337,
		"./ar-ma": 338,
		"./ar-ma.js": 338,
		"./ar-sa": 339,
		"./ar-sa.js": 339,
		"./ar-tn": 340,
		"./ar-tn.js": 340,
		"./ar.js": 341,
		"./az": 342,
		"./az.js": 342,
		"./be": 343,
		"./be.js": 343,
		"./bg": 344,
		"./bg.js": 344,
		"./bm": 345,
		"./bm.js": 345,
		"./bn": 346,
		"./bn.js": 346,
		"./bo": 347,
		"./bo.js": 347,
		"./br": 348,
		"./br.js": 348,
		"./bs": 349,
		"./bs.js": 349,
		"./ca": 350,
		"./ca.js": 350,
		"./cs": 351,
		"./cs.js": 351,
		"./cv": 352,
		"./cv.js": 352,
		"./cy": 353,
		"./cy.js": 353,
		"./da": 354,
		"./da.js": 354,
		"./de": 357,
		"./de-at": 355,
		"./de-at.js": 355,
		"./de-ch": 356,
		"./de-ch.js": 356,
		"./de.js": 357,
		"./dv": 358,
		"./dv.js": 358,
		"./el": 359,
		"./el.js": 359,
		"./en-au": 360,
		"./en-au.js": 360,
		"./en-ca": 361,
		"./en-ca.js": 361,
		"./en-gb": 362,
		"./en-gb.js": 362,
		"./en-ie": 363,
		"./en-ie.js": 363,
		"./en-il": 364,
		"./en-il.js": 364,
		"./en-nz": 365,
		"./en-nz.js": 365,
		"./eo": 366,
		"./eo.js": 366,
		"./es": 369,
		"./es-do": 367,
		"./es-do.js": 367,
		"./es-us": 368,
		"./es-us.js": 368,
		"./es.js": 369,
		"./et": 370,
		"./et.js": 370,
		"./eu": 371,
		"./eu.js": 371,
		"./fa": 372,
		"./fa.js": 372,
		"./fi": 373,
		"./fi.js": 373,
		"./fo": 374,
		"./fo.js": 374,
		"./fr": 377,
		"./fr-ca": 375,
		"./fr-ca.js": 375,
		"./fr-ch": 376,
		"./fr-ch.js": 376,
		"./fr.js": 377,
		"./fy": 378,
		"./fy.js": 378,
		"./gd": 379,
		"./gd.js": 379,
		"./gl": 380,
		"./gl.js": 380,
		"./gom-latn": 381,
		"./gom-latn.js": 381,
		"./gu": 382,
		"./gu.js": 382,
		"./he": 383,
		"./he.js": 383,
		"./hi": 384,
		"./hi.js": 384,
		"./hr": 385,
		"./hr.js": 385,
		"./hu": 386,
		"./hu.js": 386,
		"./hy-am": 387,
		"./hy-am.js": 387,
		"./id": 388,
		"./id.js": 388,
		"./is": 389,
		"./is.js": 389,
		"./it": 390,
		"./it.js": 390,
		"./ja": 391,
		"./ja.js": 391,
		"./jv": 392,
		"./jv.js": 392,
		"./ka": 393,
		"./ka.js": 393,
		"./kk": 394,
		"./kk.js": 394,
		"./km": 395,
		"./km.js": 395,
		"./kn": 396,
		"./kn.js": 396,
		"./ko": 397,
		"./ko.js": 397,
		"./ky": 398,
		"./ky.js": 398,
		"./lb": 399,
		"./lb.js": 399,
		"./lo": 400,
		"./lo.js": 400,
		"./lt": 401,
		"./lt.js": 401,
		"./lv": 402,
		"./lv.js": 402,
		"./me": 403,
		"./me.js": 403,
		"./mi": 404,
		"./mi.js": 404,
		"./mk": 405,
		"./mk.js": 405,
		"./ml": 406,
		"./ml.js": 406,
		"./mn": 407,
		"./mn.js": 407,
		"./mr": 408,
		"./mr.js": 408,
		"./ms": 410,
		"./ms-my": 409,
		"./ms-my.js": 409,
		"./ms.js": 410,
		"./mt": 411,
		"./mt.js": 411,
		"./my": 412,
		"./my.js": 412,
		"./nb": 413,
		"./nb.js": 413,
		"./ne": 414,
		"./ne.js": 414,
		"./nl": 416,
		"./nl-be": 415,
		"./nl-be.js": 415,
		"./nl.js": 416,
		"./nn": 417,
		"./nn.js": 417,
		"./pa-in": 418,
		"./pa-in.js": 418,
		"./pl": 419,
		"./pl.js": 419,
		"./pt": 421,
		"./pt-br": 420,
		"./pt-br.js": 420,
		"./pt.js": 421,
		"./ro": 422,
		"./ro.js": 422,
		"./ru": 423,
		"./ru.js": 423,
		"./sd": 424,
		"./sd.js": 424,
		"./se": 425,
		"./se.js": 425,
		"./si": 426,
		"./si.js": 426,
		"./sk": 427,
		"./sk.js": 427,
		"./sl": 428,
		"./sl.js": 428,
		"./sq": 429,
		"./sq.js": 429,
		"./sr": 431,
		"./sr-cyrl": 430,
		"./sr-cyrl.js": 430,
		"./sr.js": 431,
		"./ss": 432,
		"./ss.js": 432,
		"./sv": 433,
		"./sv.js": 433,
		"./sw": 434,
		"./sw.js": 434,
		"./ta": 435,
		"./ta.js": 435,
		"./te": 436,
		"./te.js": 436,
		"./tet": 437,
		"./tet.js": 437,
		"./tg": 438,
		"./tg.js": 438,
		"./th": 439,
		"./th.js": 439,
		"./tl-ph": 440,
		"./tl-ph.js": 440,
		"./tlh": 441,
		"./tlh.js": 441,
		"./tr": 442,
		"./tr.js": 442,
		"./tzl": 443,
		"./tzl.js": 443,
		"./tzm": 445,
		"./tzm-latn": 444,
		"./tzm-latn.js": 444,
		"./tzm.js": 445,
		"./ug-cn": 446,
		"./ug-cn.js": 446,
		"./uk": 447,
		"./uk.js": 447,
		"./ur": 448,
		"./ur.js": 448,
		"./uz": 450,
		"./uz-latn": 449,
		"./uz-latn.js": 449,
		"./uz.js": 450,
		"./vi": 451,
		"./vi.js": 451,
		"./x-pseudo": 452,
		"./x-pseudo.js": 452,
		"./yo": 453,
		"./yo.js": 453,
		"./zh-cn": 454,
		"./zh-cn.js": 454,
		"./zh-hk": 455,
		"./zh-hk.js": 455,
		"./zh-tw": 456,
		"./zh-tw.js": 456
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1558;


/***/ },
/* 1559 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EntitySchema = function () {
	  function EntitySchema(key) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    _classCallCheck(this, EntitySchema);
	
	    if (!key || typeof key !== 'string') {
	      throw new Error('A string non-empty key is required');
	    }
	
	    this._key = key;
	    this._assignEntity = options.assignEntity;
	
	    var idAttribute = options.idAttribute || 'id';
	    this._getId = typeof idAttribute === 'function' ? idAttribute : function (x) {
	      return x[idAttribute];
	    };
	    this._idAttribute = idAttribute;
	    this._meta = options.meta;
	    this._defaults = options.defaults;
	  }
	
	  _createClass(EntitySchema, [{
	    key: 'getAssignEntity',
	    value: function getAssignEntity() {
	      return this._assignEntity;
	    }
	  }, {
	    key: 'getKey',
	    value: function getKey() {
	      return this._key;
	    }
	  }, {
	    key: 'getId',
	    value: function getId(entity) {
	      return this._getId(entity);
	    }
	  }, {
	    key: 'getIdAttribute',
	    value: function getIdAttribute() {
	      return this._idAttribute;
	    }
	  }, {
	    key: 'getMeta',
	    value: function getMeta(prop) {
	      if (!prop || typeof prop !== 'string') {
	        throw new Error('A string non-empty property name is required');
	      }
	      return this._meta && this._meta[prop];
	    }
	  }, {
	    key: 'getDefaults',
	    value: function getDefaults() {
	      return this._defaults;
	    }
	  }, {
	    key: 'define',
	    value: function define(nestedSchema) {
	      for (var key in nestedSchema) {
	        if (nestedSchema.hasOwnProperty(key)) {
	          this[key] = nestedSchema[key];
	        }
	      }
	    }
	  }]);
	
	  return EntitySchema;
	}();
	
	exports.default = EntitySchema;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isObject = __webpack_require__(106);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _UnionSchema = __webpack_require__(457);
	
	var _UnionSchema2 = _interopRequireDefault(_UnionSchema);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ArraySchema = function () {
	  function ArraySchema(itemSchema) {
	    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    _classCallCheck(this, ArraySchema);
	
	    if (!(0, _isObject2.default)(itemSchema)) {
	      throw new Error('ArraySchema requires item schema to be an object.');
	    }
	
	    if (options.schemaAttribute) {
	      var schemaAttribute = options.schemaAttribute;
	      this._itemSchema = new _UnionSchema2.default(itemSchema, { schemaAttribute: schemaAttribute });
	    } else {
	      this._itemSchema = itemSchema;
	    }
	  }
	
	  _createClass(ArraySchema, [{
	    key: 'getItemSchema',
	    value: function getItemSchema() {
	      return this._itemSchema;
	    }
	  }]);
	
	  return ArraySchema;
	}();
	
	exports.default = ArraySchema;

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * numeral.js
	 * version : 1.5.3
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function () {
	
	    /************************************
	        Constants
	    ************************************/
	
	    var numeral,
	        VERSION = '1.5.3',
	        // internal storage for language config files
	        languages = {},
	        currentLanguage = 'en',
	        zeroFormat = null,
	        defaultFormat = '0,0',
	        // check for nodeJS
	        hasModule = (typeof module !== 'undefined' && module.exports);
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	
	    // Numeral prototype object
	    function Numeral (number) {
	        this._value = number;
	    }
	
	    /**
	     * Implementation of toFixed() that treats floats more like decimals
	     *
	     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	     * problems for accounting- and finance-related software.
	     */
	    function toFixed (value, precision, roundingFunction, optionals) {
	        var power = Math.pow(10, precision),
	            optionalsRegExp,
	            output;
	            
	        //roundingFunction = (roundingFunction !== undefined ? roundingFunction : Math.round);
	        // Multiply up by precision, round accurately, then divide and use native toFixed():
	        output = (roundingFunction(value * power) / power).toFixed(precision);
	
	        if (optionals) {
	            optionalsRegExp = new RegExp('0{1,' + optionals + '}$');
	            output = output.replace(optionalsRegExp, '');
	        }
	
	        return output;
	    }
	
	    /************************************
	        Formatting
	    ************************************/
	
	    // determine what type of formatting we need to do
	    function formatNumeral (n, format, roundingFunction) {
	        var output;
	
	        // figure out what kind of format we are dealing with
	        if (format.indexOf('$') > -1) { // currency!!!!!
	            output = formatCurrency(n, format, roundingFunction);
	        } else if (format.indexOf('%') > -1) { // percentage
	            output = formatPercentage(n, format, roundingFunction);
	        } else if (format.indexOf(':') > -1) { // time
	            output = formatTime(n, format);
	        } else { // plain ol' numbers or bytes
	            output = formatNumber(n._value, format, roundingFunction);
	        }
	
	        // return string
	        return output;
	    }
	
	    // revert to number
	    function unformatNumeral (n, string) {
	        var stringOriginal = string,
	            thousandRegExp,
	            millionRegExp,
	            billionRegExp,
	            trillionRegExp,
	            suffixes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	            bytesMultiplier = false,
	            power;
	
	        if (string.indexOf(':') > -1) {
	            n._value = unformatTime(string);
	        } else {
	            if (string === zeroFormat) {
	                n._value = 0;
	            } else {
	                if (languages[currentLanguage].delimiters.decimal !== '.') {
	                    string = string.replace(/\./g,'').replace(languages[currentLanguage].delimiters.decimal, '.');
	                }
	
	                // see if abbreviations are there so that we can multiply to the correct number
	                thousandRegExp = new RegExp('[^a-zA-Z]' + languages[currentLanguage].abbreviations.thousand + '(?:\\)|(\\' + languages[currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                millionRegExp = new RegExp('[^a-zA-Z]' + languages[currentLanguage].abbreviations.million + '(?:\\)|(\\' + languages[currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                billionRegExp = new RegExp('[^a-zA-Z]' + languages[currentLanguage].abbreviations.billion + '(?:\\)|(\\' + languages[currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	                trillionRegExp = new RegExp('[^a-zA-Z]' + languages[currentLanguage].abbreviations.trillion + '(?:\\)|(\\' + languages[currentLanguage].currency.symbol + ')?(?:\\))?)?$');
	
	                // see if bytes are there so that we can multiply to the correct number
	                for (power = 0; power <= suffixes.length; power++) {
	                    bytesMultiplier = (string.indexOf(suffixes[power]) > -1) ? Math.pow(1024, power + 1) : false;
	
	                    if (bytesMultiplier) {
	                        break;
	                    }
	                }
	
	                // do some math to create our number
	                n._value = ((bytesMultiplier) ? bytesMultiplier : 1) * ((stringOriginal.match(thousandRegExp)) ? Math.pow(10, 3) : 1) * ((stringOriginal.match(millionRegExp)) ? Math.pow(10, 6) : 1) * ((stringOriginal.match(billionRegExp)) ? Math.pow(10, 9) : 1) * ((stringOriginal.match(trillionRegExp)) ? Math.pow(10, 12) : 1) * ((string.indexOf('%') > -1) ? 0.01 : 1) * (((string.split('-').length + Math.min(string.split('(').length-1, string.split(')').length-1)) % 2)? 1: -1) * Number(string.replace(/[^0-9\.]+/g, ''));
	
	                // round if we are talking about bytes
	                n._value = (bytesMultiplier) ? Math.ceil(n._value) : n._value;
	            }
	        }
	        return n._value;
	    }
	
	    function formatCurrency (n, format, roundingFunction) {
	        var symbolIndex = format.indexOf('$'),
	            openParenIndex = format.indexOf('('),
	            minusSignIndex = format.indexOf('-'),
	            space = '',
	            spliceIndex,
	            output;
	
	        // check for space before or after currency
	        if (format.indexOf(' $') > -1) {
	            space = ' ';
	            format = format.replace(' $', '');
	        } else if (format.indexOf('$ ') > -1) {
	            space = ' ';
	            format = format.replace('$ ', '');
	        } else {
	            format = format.replace('$', '');
	        }
	
	        // format the number
	        output = formatNumber(n._value, format, roundingFunction);
	
	        // position the symbol
	        if (symbolIndex <= 1) {
	            if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
	                output = output.split('');
	                spliceIndex = 1;
	                if (symbolIndex < openParenIndex || symbolIndex < minusSignIndex){
	                    // the symbol appears before the "(" or "-"
	                    spliceIndex = 0;
	                }
	                output.splice(spliceIndex, 0, languages[currentLanguage].currency.symbol + space);
	                output = output.join('');
	            } else {
	                output = languages[currentLanguage].currency.symbol + space + output;
	            }
	        } else {
	            if (output.indexOf(')') > -1) {
	                output = output.split('');
	                output.splice(-1, 0, space + languages[currentLanguage].currency.symbol);
	                output = output.join('');
	            } else {
	                output = output + space + languages[currentLanguage].currency.symbol;
	            }
	        }
	
	        return output;
	    }
	
	    function formatPercentage (n, format, roundingFunction) {
	        var space = '',
	            output,
	            value = n._value * 100;
	
	        // check for space before %
	        if (format.indexOf(' %') > -1) {
	            space = ' ';
	            format = format.replace(' %', '');
	        } else {
	            format = format.replace('%', '');
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	        
	        if (output.indexOf(')') > -1 ) {
	            output = output.split('');
	            output.splice(-1, 0, space + '%');
	            output = output.join('');
	        } else {
	            output = output + space + '%';
	        }
	
	        return output;
	    }
	
	    function formatTime (n) {
	        var hours = Math.floor(n._value/60/60),
	            minutes = Math.floor((n._value - (hours * 60 * 60))/60),
	            seconds = Math.round(n._value - (hours * 60 * 60) - (minutes * 60));
	        return hours + ':' + ((minutes < 10) ? '0' + minutes : minutes) + ':' + ((seconds < 10) ? '0' + seconds : seconds);
	    }
	
	    function unformatTime (string) {
	        var timeArray = string.split(':'),
	            seconds = 0;
	        // turn hours and minutes into seconds and add them all up
	        if (timeArray.length === 3) {
	            // hours
	            seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	            // minutes
	            seconds = seconds + (Number(timeArray[1]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[2]);
	        } else if (timeArray.length === 2) {
	            // minutes
	            seconds = seconds + (Number(timeArray[0]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[1]);
	        }
	        return Number(seconds);
	    }
	
	    function formatNumber (value, format, roundingFunction) {
	        var negP = false,
	            signed = false,
	            optDec = false,
	            abbr = '',
	            abbrK = false, // force abbreviation to thousands
	            abbrM = false, // force abbreviation to millions
	            abbrB = false, // force abbreviation to billions
	            abbrT = false, // force abbreviation to trillions
	            abbrForce = false, // force abbreviation
	            bytes = '',
	            ord = '',
	            abs = Math.abs(value),
	            suffixes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	            min,
	            max,
	            power,
	            w,
	            precision,
	            thousands,
	            d = '',
	            neg = false;
	
	        // check if number is zero and a custom zero format has been set
	        if (value === 0 && zeroFormat !== null) {
	            return zeroFormat;
	        } else {
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (format.indexOf('(') > -1) {
	                negP = true;
	                format = format.slice(1, -1);
	            } else if (format.indexOf('+') > -1) {
	                signed = true;
	                format = format.replace(/\+/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (format.indexOf('a') > -1) {
	                // check if abbreviation is specified
	                abbrK = format.indexOf('aK') >= 0;
	                abbrM = format.indexOf('aM') >= 0;
	                abbrB = format.indexOf('aB') >= 0;
	                abbrT = format.indexOf('aT') >= 0;
	                abbrForce = abbrK || abbrM || abbrB || abbrT;
	
	                // check for space before abbreviation
	                if (format.indexOf(' a') > -1) {
	                    abbr = ' ';
	                    format = format.replace(' a', '');
	                } else {
	                    format = format.replace('a', '');
	                }
	
	                if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
	                    // trillion
	                    abbr = abbr + languages[currentLanguage].abbreviations.trillion;
	                    value = value / Math.pow(10, 12);
	                } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
	                    // billion
	                    abbr = abbr + languages[currentLanguage].abbreviations.billion;
	                    value = value / Math.pow(10, 9);
	                } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
	                    // million
	                    abbr = abbr + languages[currentLanguage].abbreviations.million;
	                    value = value / Math.pow(10, 6);
	                } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
	                    // thousand
	                    abbr = abbr + languages[currentLanguage].abbreviations.thousand;
	                    value = value / Math.pow(10, 3);
	                }
	            }
	
	            // see if we are formatting bytes
	            if (format.indexOf('b') > -1) {
	                // check for space before
	                if (format.indexOf(' b') > -1) {
	                    bytes = ' ';
	                    format = format.replace(' b', '');
	                } else {
	                    format = format.replace('b', '');
	                }
	
	                for (power = 0; power <= suffixes.length; power++) {
	                    min = Math.pow(1024, power);
	                    max = Math.pow(1024, power+1);
	
	                    if (value >= min && value < max) {
	                        bytes = bytes + suffixes[power];
	                        if (min > 0) {
	                            value = value / min;
	                        }
	                        break;
	                    }
	                }
	            }
	
	            // see if ordinal is wanted
	            if (format.indexOf('o') > -1) {
	                // check for space before
	                if (format.indexOf(' o') > -1) {
	                    ord = ' ';
	                    format = format.replace(' o', '');
	                } else {
	                    format = format.replace('o', '');
	                }
	
	                ord = ord + languages[currentLanguage].ordinal(value);
	            }
	
	            if (format.indexOf('[.]') > -1) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            w = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	
	            if (precision) {
	                if (precision.indexOf('[') > -1) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    d = toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    d = toFixed(value, precision.length, roundingFunction);
	                }
	
	                w = d.split('.')[0];
	
	                if (d.split('.')[1].length) {
	                    d = languages[currentLanguage].delimiters.decimal + d.split('.')[1];
	                } else {
	                    d = '';
	                }
	
	                if (optDec && Number(d.slice(1)) === 0) {
	                    d = '';
	                }
	            } else {
	                w = toFixed(value, null, roundingFunction);
	            }
	
	            // format number
	            if (w.indexOf('-') > -1) {
	                w = w.slice(1);
	                neg = true;
	            }
	
	            if (thousands > -1) {
	                w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + languages[currentLanguage].delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                w = '';
	            }
	
	            return ((negP && neg) ? '(' : '') + ((!negP && neg) ? '-' : '') + ((!neg && signed) ? '+' : '') + w + d + ((ord) ? ord : '') + ((abbr) ? abbr : '') + ((bytes) ? bytes : '') + ((negP && neg) ? ')' : '');
	        }
	    }
	
	    /************************************
	        Top Level Functions
	    ************************************/
	
	    numeral = function (input) {
	        if (numeral.isNumeral(input)) {
	            input = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            input = 0;
	        } else if (!Number(input)) {
	            input = numeral.fn.unformat(input);
	        }
	
	        return new Numeral(Number(input));
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function (obj) {
	        return obj instanceof Numeral;
	    };
	
	    // This function will load languages and then set the global language.  If
	    // no arguments are passed in, it will simply return the current global
	    // language key.
	    numeral.language = function (key, values) {
	        if (!key) {
	            return currentLanguage;
	        }
	
	        if (key && !values) {
	            if(!languages[key]) {
	                throw new Error('Unknown language : ' + key);
	            }
	            currentLanguage = key;
	        }
	
	        if (values || !languages[key]) {
	            loadLanguage(key, values);
	        }
	
	        return numeral;
	    };
	    
	    // This function provides access to the loaded language data.  If
	    // no arguments are passed in, it will simply return the current
	    // global language object.
	    numeral.languageData = function (key) {
	        if (!key) {
	            return languages[currentLanguage];
	        }
	        
	        if (!languages[key]) {
	            throw new Error('Unknown language : ' + key);
	        }
	        
	        return languages[key];
	    };
	
	    numeral.language('en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (~~ (number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    numeral.zeroFormat = function (format) {
	        zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function (format) {
	        defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    /************************************
	        Helpers
	    ************************************/
	
	    function loadLanguage(key, values) {
	        languages[key] = values;
	    }
	
	    /************************************
	        Floating-point helpers
	    ************************************/
	
	    // The floating-point helper functions and implementation
	    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
	
	    /**
	     * Array.prototype.reduce for browsers that don't support it
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce#Compatibility
	     */
	    if ('function' !== typeof Array.prototype.reduce) {
	        Array.prototype.reduce = function (callback, opt_initialValue) {
	            'use strict';
	            
	            if (null === this || 'undefined' === typeof this) {
	                // At the moment all modern browsers, that support strict mode, have
	                // native implementation of Array.prototype.reduce. For instance, IE8
	                // does not support strict mode, so this check is actually useless.
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	            
	            if ('function' !== typeof callback) {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var index,
	                value,
	                length = this.length >>> 0,
	                isValueSet = false;
	
	            if (1 < arguments.length) {
	                value = opt_initialValue;
	                isValueSet = true;
	            }
	
	            for (index = 0; length > index; ++index) {
	                if (this.hasOwnProperty(index)) {
	                    if (isValueSet) {
	                        value = callback(value, this[index], index, this);
	                    } else {
	                        value = this[index];
	                        isValueSet = true;
	                    }
	                }
	            }
	
	            if (!isValueSet) {
	                throw new TypeError('Reduce of empty array with no initial value');
	            }
	
	            return value;
	        };
	    }
	
	    
	    /**
	     * Computes the multiplier necessary to make x >= 1,
	     * effectively eliminating miscalculations caused by
	     * finite precision.
	     */
	    function multiplier(x) {
	        var parts = x.toString().split('.');
	        if (parts.length < 2) {
	            return 1;
	        }
	        return Math.pow(10, parts[1].length);
	    }
	
	    /**
	     * Given a variable number of arguments, returns the maximum
	     * multiplier that must be used to normalize an operation involving
	     * all of them.
	     */
	    function correctionFactor() {
	        var args = Array.prototype.slice.call(arguments);
	        return args.reduce(function (prev, next) {
	            var mp = multiplier(prev),
	                mn = multiplier(next);
	        return mp > mn ? mp : mn;
	        }, -Infinity);
	    }        
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	
	    numeral.fn = Numeral.prototype = {
	
	        clone : function () {
	            return numeral(this);
	        },
	
	        format : function (inputString, roundingFunction) {
	            return formatNumeral(this, 
	                  inputString ? inputString : defaultFormat, 
	                  (roundingFunction !== undefined) ? roundingFunction : Math.round
	              );
	        },
	
	        unformat : function (inputString) {
	            if (Object.prototype.toString.call(inputString) === '[object Number]') { 
	                return inputString; 
	            }
	            return unformatNumeral(this, inputString ? inputString : defaultFormat);
	        },
	
	        value : function () {
	            return this._value;
	        },
	
	        valueOf : function () {
	            return this._value;
	        },
	
	        set : function (value) {
	            this._value = Number(value);
	            return this;
	        },
	
	        add : function (value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	            function cback(accum, curr, currI, O) {
	                return accum + corrFactor * curr;
	            }
	            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
	            return this;
	        },
	
	        subtract : function (value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	            function cback(accum, curr, currI, O) {
	                return accum - corrFactor * curr;
	            }
	            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;            
	            return this;
	        },
	
	        multiply : function (value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) * (curr * corrFactor) /
	                    (corrFactor * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback, 1);
	            return this;
	        },
	
	        divide : function (value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) / (curr * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback);            
	            return this;
	        },
	
	        difference : function (value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	
	    };
	
	    /************************************
	        Exposing Numeral
	    ************************************/
	
	    // CommonJS module is defined
	    if (hasModule) {
	        module.exports = numeral;
	    }
	
	    /*global ender:false */
	    if (typeof ender === 'undefined') {
	        // here, `this` means `window` in the browser, or `global` on the server
	        // add `numeral` as a global object via a string identifier,
	        // for Closure Compiler 'advanced' mode
	        this['numeral'] = numeral;
	    }
	
	    /*global define:false */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return numeral;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}).call(this);


/***/ },
/* 1562 */
/***/ function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = [
		'Float16Array',
		'Float32Array',
		'Float64Array',
		'Int8Array',
		'Int16Array',
		'Int32Array',
		'Uint8Array',
		'Uint8ClampedArray',
		'Uint16Array',
		'Uint32Array',
		'BigInt64Array',
		'BigUint64Array'
	];


/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(72);
	var isRegex = __webpack_require__(1479);
	
	var $exec = callBound('RegExp.prototype.exec');
	var $TypeError = __webpack_require__(63);
	
	/** @type {import('.')} */
	module.exports = function regexTester(regex) {
		if (!isRegex(regex)) {
			throw new $TypeError('`regex` must be a RegExp');
		}
		return function test(s) {
			return $exec(regex, s) !== null;
		};
	};


/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/*!
	 * Select2 4.0.3
	 * https://select2.github.io
	 *
	 * Released under the MIT license
	 * https://github.com/select2/select2/blob/master/LICENSE.md
	 */
	(function (factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node/CommonJS
	    factory(require('jquery'));
	  } else {
	    // Browser globals
	    factory(jQuery);
	  }
	}(function (jQuery) {
	  // This is needed so we can catch the AMD loader configuration and use it
	  // The inner file should be wrapped (by `banner.start.js`) in a function that
	  // returns the AMD loader references.
	  var S2 =
	(function () {
	  // Restore the Select2 AMD loader so it can be used
	  // Needed mostly in the language files, where the loader is not inserted
	  if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) {
	    var S2 = jQuery.fn.select2.amd;
	  }
	var S2;(function () { if (!S2 || !S2.requirejs) {
	if (!S2) { S2 = {}; } else { require = S2; }
	/**
	 * @license almond 0.3.1 Copyright (c) 2011-2014, The Dojo Foundation All Rights Reserved.
	 * Available via the MIT or new BSD license.
	 * see: http://github.com/jrburke/almond for details
	 */
	//Going sloppy to avoid 'use strict' string cost, but strict practices should
	//be followed.
	/*jslint sloppy: true */
	/*global setTimeout: false */
	
	var requirejs, require, define;
	(function (undef) {
	    var main, req, makeMap, handlers,
	        defined = {},
	        waiting = {},
	        config = {},
	        defining = {},
	        hasOwn = Object.prototype.hasOwnProperty,
	        aps = [].slice,
	        jsSuffixRegExp = /\.js$/;
	
	    function hasProp(obj, prop) {
	        return hasOwn.call(obj, prop);
	    }
	
	    /**
	     * Given a relative module name, like ./something, normalize it to
	     * a real name that can be mapped to a path.
	     * @param {String} name the relative name
	     * @param {String} baseName a real name that the name arg is relative
	     * to.
	     * @returns {String} normalized name
	     */
	    function normalize(name, baseName) {
	        var nameParts, nameSegment, mapValue, foundMap, lastIndex,
	            foundI, foundStarMap, starI, i, j, part,
	            baseParts = baseName && baseName.split("/"),
	            map = config.map,
	            starMap = (map && map['*']) || {};
	
	        //Adjust any relative paths.
	        if (name && name.charAt(0) === ".") {
	            //If have a base name, try to normalize against it,
	            //otherwise, assume it is a top-level require that will
	            //be relative to baseUrl in the end.
	            if (baseName) {
	                name = name.split('/');
	                lastIndex = name.length - 1;
	
	                // Node .js allowance:
	                if (config.nodeIdCompat && jsSuffixRegExp.test(name[lastIndex])) {
	                    name[lastIndex] = name[lastIndex].replace(jsSuffixRegExp, '');
	                }
	
	                //Lop off the last part of baseParts, so that . matches the
	                //"directory" and not name of the baseName's module. For instance,
	                //baseName of "one/two/three", maps to "one/two/three.js", but we
	                //want the directory, "one/two" for this normalization.
	                name = baseParts.slice(0, baseParts.length - 1).concat(name);
	
	                //start trimDots
	                for (i = 0; i < name.length; i += 1) {
	                    part = name[i];
	                    if (part === ".") {
	                        name.splice(i, 1);
	                        i -= 1;
	                    } else if (part === "..") {
	                        if (i === 1 && (name[2] === '..' || name[0] === '..')) {
	                            //End of the line. Keep at least one non-dot
	                            //path segment at the front so it can be mapped
	                            //correctly to disk. Otherwise, there is likely
	                            //no path mapping for a path starting with '..'.
	                            //This can still fail, but catches the most reasonable
	                            //uses of ..
	                            break;
	                        } else if (i > 0) {
	                            name.splice(i - 1, 2);
	                            i -= 2;
	                        }
	                    }
	                }
	                //end trimDots
	
	                name = name.join("/");
	            } else if (name.indexOf('./') === 0) {
	                // No baseName, so this is ID is resolved relative
	                // to baseUrl, pull off the leading dot.
	                name = name.substring(2);
	            }
	        }
	
	        //Apply map config if available.
	        if ((baseParts || starMap) && map) {
	            nameParts = name.split('/');
	
	            for (i = nameParts.length; i > 0; i -= 1) {
	                nameSegment = nameParts.slice(0, i).join("/");
	
	                if (baseParts) {
	                    //Find the longest baseName segment match in the config.
	                    //So, do joins on the biggest to smallest lengths of baseParts.
	                    for (j = baseParts.length; j > 0; j -= 1) {
	                        mapValue = map[baseParts.slice(0, j).join('/')];
	
	                        //baseName segment has  config, find if it has one for
	                        //this name.
	                        if (mapValue) {
	                            mapValue = mapValue[nameSegment];
	                            if (mapValue) {
	                                //Match, update name to the new value.
	                                foundMap = mapValue;
	                                foundI = i;
	                                break;
	                            }
	                        }
	                    }
	                }
	
	                if (foundMap) {
	                    break;
	                }
	
	                //Check for a star map match, but just hold on to it,
	                //if there is a shorter segment match later in a matching
	                //config, then favor over this star map.
	                if (!foundStarMap && starMap && starMap[nameSegment]) {
	                    foundStarMap = starMap[nameSegment];
	                    starI = i;
	                }
	            }
	
	            if (!foundMap && foundStarMap) {
	                foundMap = foundStarMap;
	                foundI = starI;
	            }
	
	            if (foundMap) {
	                nameParts.splice(0, foundI, foundMap);
	                name = nameParts.join('/');
	            }
	        }
	
	        return name;
	    }
	
	    function makeRequire(relName, forceSync) {
	        return function () {
	            //A version of a require function that passes a moduleName
	            //value for items that may need to
	            //look up paths relative to the moduleName
	            var args = aps.call(arguments, 0);
	
	            //If first arg is not require('string'), and there is only
	            //one arg, it is the array form without a callback. Insert
	            //a null so that the following concat is correct.
	            if (typeof args[0] !== 'string' && args.length === 1) {
	                args.push(null);
	            }
	            return req.apply(undef, args.concat([relName, forceSync]));
	        };
	    }
	
	    function makeNormalize(relName) {
	        return function (name) {
	            return normalize(name, relName);
	        };
	    }
	
	    function makeLoad(depName) {
	        return function (value) {
	            defined[depName] = value;
	        };
	    }
	
	    function callDep(name) {
	        if (hasProp(waiting, name)) {
	            var args = waiting[name];
	            delete waiting[name];
	            defining[name] = true;
	            main.apply(undef, args);
	        }
	
	        if (!hasProp(defined, name) && !hasProp(defining, name)) {
	            throw new Error('No ' + name);
	        }
	        return defined[name];
	    }
	
	    //Turns a plugin!resource to [plugin, resource]
	    //with the plugin being undefined if the name
	    //did not have a plugin prefix.
	    function splitPrefix(name) {
	        var prefix,
	            index = name ? name.indexOf('!') : -1;
	        if (index > -1) {
	            prefix = name.substring(0, index);
	            name = name.substring(index + 1, name.length);
	        }
	        return [prefix, name];
	    }
	
	    /**
	     * Makes a name map, normalizing the name, and using a plugin
	     * for normalization if necessary. Grabs a ref to plugin
	     * too, as an optimization.
	     */
	    makeMap = function (name, relName) {
	        var plugin,
	            parts = splitPrefix(name),
	            prefix = parts[0];
	
	        name = parts[1];
	
	        if (prefix) {
	            prefix = normalize(prefix, relName);
	            plugin = callDep(prefix);
	        }
	
	        //Normalize according
	        if (prefix) {
	            if (plugin && plugin.normalize) {
	                name = plugin.normalize(name, makeNormalize(relName));
	            } else {
	                name = normalize(name, relName);
	            }
	        } else {
	            name = normalize(name, relName);
	            parts = splitPrefix(name);
	            prefix = parts[0];
	            name = parts[1];
	            if (prefix) {
	                plugin = callDep(prefix);
	            }
	        }
	
	        //Using ridiculous property names for space reasons
	        return {
	            f: prefix ? prefix + '!' + name : name, //fullName
	            n: name,
	            pr: prefix,
	            p: plugin
	        };
	    };
	
	    function makeConfig(name) {
	        return function () {
	            return (config && config.config && config.config[name]) || {};
	        };
	    }
	
	    handlers = {
	        require: function (name) {
	            return makeRequire(name);
	        },
	        exports: function (name) {
	            var e = defined[name];
	            if (typeof e !== 'undefined') {
	                return e;
	            } else {
	                return (defined[name] = {});
	            }
	        },
	        module: function (name) {
	            return {
	                id: name,
	                uri: '',
	                exports: defined[name],
	                config: makeConfig(name)
	            };
	        }
	    };
	
	    main = function (name, deps, callback, relName) {
	        var cjsModule, depName, ret, map, i,
	            args = [],
	            callbackType = typeof callback,
	            usingExports;
	
	        //Use name if no relName
	        relName = relName || name;
	
	        //Call the callback to define the module, if necessary.
	        if (callbackType === 'undefined' || callbackType === 'function') {
	            //Pull out the defined dependencies and pass the ordered
	            //values to the callback.
	            //Default to [require, exports, module] if no deps
	            deps = !deps.length && callback.length ? ['require', 'exports', 'module'] : deps;
	            for (i = 0; i < deps.length; i += 1) {
	                map = makeMap(deps[i], relName);
	                depName = map.f;
	
	                //Fast path CommonJS standard dependencies.
	                if (depName === "require") {
	                    args[i] = handlers.require(name);
	                } else if (depName === "exports") {
	                    //CommonJS module spec 1.1
	                    args[i] = handlers.exports(name);
	                    usingExports = true;
	                } else if (depName === "module") {
	                    //CommonJS module spec 1.1
	                    cjsModule = args[i] = handlers.module(name);
	                } else if (hasProp(defined, depName) ||
	                           hasProp(waiting, depName) ||
	                           hasProp(defining, depName)) {
	                    args[i] = callDep(depName);
	                } else if (map.p) {
	                    map.p.load(map.n, makeRequire(relName, true), makeLoad(depName), {});
	                    args[i] = defined[depName];
	                } else {
	                    throw new Error(name + ' missing ' + depName);
	                }
	            }
	
	            ret = callback ? callback.apply(defined[name], args) : undefined;
	
	            if (name) {
	                //If setting exports via "module" is in play,
	                //favor that over return value and exports. After that,
	                //favor a non-undefined return value over exports use.
	                if (cjsModule && cjsModule.exports !== undef &&
	                        cjsModule.exports !== defined[name]) {
	                    defined[name] = cjsModule.exports;
	                } else if (ret !== undef || !usingExports) {
	                    //Use the return value from the function.
	                    defined[name] = ret;
	                }
	            }
	        } else if (name) {
	            //May just be an object definition for the module. Only
	            //worry about defining if have a module name.
	            defined[name] = callback;
	        }
	    };
	
	    requirejs = require = req = function (deps, callback, relName, forceSync, alt) {
	        if (typeof deps === "string") {
	            if (handlers[deps]) {
	                //callback in this case is really relName
	                return handlers[deps](callback);
	            }
	            //Just return the module wanted. In this scenario, the
	            //deps arg is the module name, and second arg (if passed)
	            //is just the relName.
	            //Normalize module name, if it contains . or ..
	            return callDep(makeMap(deps, callback).f);
	        } else if (!deps.splice) {
	            //deps is a config object, not an array.
	            config = deps;
	            if (config.deps) {
	                req(config.deps, config.callback);
	            }
	            if (!callback) {
	                return;
	            }
	
	            if (callback.splice) {
	                //callback is an array, which means it is a dependency list.
	                //Adjust args if there are dependencies
	                deps = callback;
	                callback = relName;
	                relName = null;
	            } else {
	                deps = undef;
	            }
	        }
	
	        //Support require(['a'])
	        callback = callback || function () {};
	
	        //If relName is a function, it is an errback handler,
	        //so remove it.
	        if (typeof relName === 'function') {
	            relName = forceSync;
	            forceSync = alt;
	        }
	
	        //Simulate async callback;
	        if (forceSync) {
	            main(undef, deps, callback, relName);
	        } else {
	            //Using a non-zero value because of concern for what old browsers
	            //do, and latest browsers "upgrade" to 4 if lower value is used:
	            //http://www.whatwg.org/specs/web-apps/current-work/multipage/timers.html#dom-windowtimers-settimeout:
	            //If want a value immediately, use require('id') instead -- something
	            //that works in almond on the global level, but not guaranteed and
	            //unlikely to work in other AMD implementations.
	            setTimeout(function () {
	                main(undef, deps, callback, relName);
	            }, 4);
	        }
	
	        return req;
	    };
	
	    /**
	     * Just drops the config on the floor, but returns req in case
	     * the config return value is used.
	     */
	    req.config = function (cfg) {
	        return req(cfg);
	    };
	
	    /**
	     * Expose module registry for debugging and tooling
	     */
	    requirejs._defined = defined;
	
	    define = function (name, deps, callback) {
	        if (typeof name !== 'string') {
	            throw new Error('See almond README: incorrect module build, no module name');
	        }
	
	        //This module may not have dependencies
	        if (!deps.splice) {
	            //deps is not an array, so probably means
	            //an object literal or factory function for
	            //the value. Adjust args.
	            callback = deps;
	            deps = [];
	        }
	
	        if (!hasProp(defined, name) && !hasProp(waiting, name)) {
	            waiting[name] = [name, deps, callback];
	        }
	    };
	
	    define.amd = {
	        jQuery: true
	    };
	}());
	
	S2.requirejs = requirejs;S2.require = require;S2.define = define;
	}
	}());
	S2.define("almond", function(){});
	
	/* global jQuery:false, $:false */
	S2.define('jquery',[],function () {
	  var _$ = jQuery || $;
	
	  if (_$ == null && console && console.error) {
	    console.error(
	      'Select2: An instance of jQuery or a jQuery-compatible library was not ' +
	      'found. Make sure that you are including jQuery before Select2 on your ' +
	      'web page.'
	    );
	  }
	
	  return _$;
	});
	
	S2.define('select2/utils',[
	  'jquery'
	], function ($) {
	  var Utils = {};
	
	  Utils.Extend = function (ChildClass, SuperClass) {
	    var __hasProp = {}.hasOwnProperty;
	
	    function BaseConstructor () {
	      this.constructor = ChildClass;
	    }
	
	    for (var key in SuperClass) {
	      if (__hasProp.call(SuperClass, key)) {
	        ChildClass[key] = SuperClass[key];
	      }
	    }
	
	    BaseConstructor.prototype = SuperClass.prototype;
	    ChildClass.prototype = new BaseConstructor();
	    ChildClass.__super__ = SuperClass.prototype;
	
	    return ChildClass;
	  };
	
	  function getMethods (theClass) {
	    var proto = theClass.prototype;
	
	    var methods = [];
	
	    for (var methodName in proto) {
	      var m = proto[methodName];
	
	      if (typeof m !== 'function') {
	        continue;
	      }
	
	      if (methodName === 'constructor') {
	        continue;
	      }
	
	      methods.push(methodName);
	    }
	
	    return methods;
	  }
	
	  Utils.Decorate = function (SuperClass, DecoratorClass) {
	    var decoratedMethods = getMethods(DecoratorClass);
	    var superMethods = getMethods(SuperClass);
	
	    function DecoratedClass () {
	      var unshift = Array.prototype.unshift;
	
	      var argCount = DecoratorClass.prototype.constructor.length;
	
	      var calledConstructor = SuperClass.prototype.constructor;
	
	      if (argCount > 0) {
	        unshift.call(arguments, SuperClass.prototype.constructor);
	
	        calledConstructor = DecoratorClass.prototype.constructor;
	      }
	
	      calledConstructor.apply(this, arguments);
	    }
	
	    DecoratorClass.displayName = SuperClass.displayName;
	
	    function ctr () {
	      this.constructor = DecoratedClass;
	    }
	
	    DecoratedClass.prototype = new ctr();
	
	    for (var m = 0; m < superMethods.length; m++) {
	        var superMethod = superMethods[m];
	
	        DecoratedClass.prototype[superMethod] =
	          SuperClass.prototype[superMethod];
	    }
	
	    var calledMethod = function (methodName) {
	      // Stub out the original method if it's not decorating an actual method
	      var originalMethod = function () {};
	
	      if (methodName in DecoratedClass.prototype) {
	        originalMethod = DecoratedClass.prototype[methodName];
	      }
	
	      var decoratedMethod = DecoratorClass.prototype[methodName];
	
	      return function () {
	        var unshift = Array.prototype.unshift;
	
	        unshift.call(arguments, originalMethod);
	
	        return decoratedMethod.apply(this, arguments);
	      };
	    };
	
	    for (var d = 0; d < decoratedMethods.length; d++) {
	      var decoratedMethod = decoratedMethods[d];
	
	      DecoratedClass.prototype[decoratedMethod] = calledMethod(decoratedMethod);
	    }
	
	    return DecoratedClass;
	  };
	
	  var Observable = function () {
	    this.listeners = {};
	  };
	
	  Observable.prototype.on = function (event, callback) {
	    this.listeners = this.listeners || {};
	
	    if (event in this.listeners) {
	      this.listeners[event].push(callback);
	    } else {
	      this.listeners[event] = [callback];
	    }
	  };
	
	  Observable.prototype.trigger = function (event) {
	    var slice = Array.prototype.slice;
	    var params = slice.call(arguments, 1);
	
	    this.listeners = this.listeners || {};
	
	    // Params should always come in as an array
	    if (params == null) {
	      params = [];
	    }
	
	    // If there are no arguments to the event, use a temporary object
	    if (params.length === 0) {
	      params.push({});
	    }
	
	    // Set the `_type` of the first object to the event
	    params[0]._type = event;
	
	    if (event in this.listeners) {
	      this.invoke(this.listeners[event], slice.call(arguments, 1));
	    }
	
	    if ('*' in this.listeners) {
	      this.invoke(this.listeners['*'], arguments);
	    }
	  };
	
	  Observable.prototype.invoke = function (listeners, params) {
	    for (var i = 0, len = listeners.length; i < len; i++) {
	      listeners[i].apply(this, params);
	    }
	  };
	
	  Utils.Observable = Observable;
	
	  Utils.generateChars = function (length) {
	    var chars = '';
	
	    for (var i = 0; i < length; i++) {
	      var randomChar = Math.floor(Math.random() * 36);
	      chars += randomChar.toString(36);
	    }
	
	    return chars;
	  };
	
	  Utils.bind = function (func, context) {
	    return function () {
	      func.apply(context, arguments);
	    };
	  };
	
	  Utils._convertData = function (data) {
	    for (var originalKey in data) {
	      var keys = originalKey.split('-');
	
	      var dataLevel = data;
	
	      if (keys.length === 1) {
	        continue;
	      }
	
	      for (var k = 0; k < keys.length; k++) {
	        var key = keys[k];
	
	        // Lowercase the first letter
	        // By default, dash-separated becomes camelCase
	        key = key.substring(0, 1).toLowerCase() + key.substring(1);
	
	        if (!(key in dataLevel)) {
	          dataLevel[key] = {};
	        }
	
	        if (k == keys.length - 1) {
	          dataLevel[key] = data[originalKey];
	        }
	
	        dataLevel = dataLevel[key];
	      }
	
	      delete data[originalKey];
	    }
	
	    return data;
	  };
	
	  Utils.hasScroll = function (index, el) {
	    // Adapted from the function created by @ShadowScripter
	    // and adapted by @BillBarry on the Stack Exchange Code Review website.
	    // The original code can be found at
	    // http://codereview.stackexchange.com/q/13338
	    // and was designed to be used with the Sizzle selector engine.
	
	    var $el = $(el);
	    var overflowX = el.style.overflowX;
	    var overflowY = el.style.overflowY;
	
	    //Check both x and y declarations
	    if (overflowX === overflowY &&
	        (overflowY === 'hidden' || overflowY === 'visible')) {
	      return false;
	    }
	
	    if (overflowX === 'scroll' || overflowY === 'scroll') {
	      return true;
	    }
	
	    return ($el.innerHeight() < el.scrollHeight ||
	      $el.innerWidth() < el.scrollWidth);
	  };
	
	  Utils.escapeMarkup = function (markup) {
	    var replaceMap = {
	      '\\': '&#92;',
	      '&': '&amp;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '"': '&quot;',
	      '\'': '&#39;',
	      '/': '&#47;'
	    };
	
	    // Do not try to escape the markup if it's not a string
	    if (typeof markup !== 'string') {
	      return markup;
	    }
	
	    return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
	      return replaceMap[match];
	    });
	  };
	
	  // Append an array of jQuery nodes to a given element.
	  Utils.appendMany = function ($element, $nodes) {
	    // jQuery 1.7.x does not support $.fn.append() with an array
	    // Fall back to a jQuery object collection using $.fn.add()
	    if ($.fn.jquery.substr(0, 3) === '1.7') {
	      var $jqNodes = $();
	
	      $.map($nodes, function (node) {
	        $jqNodes = $jqNodes.add(node);
	      });
	
	      $nodes = $jqNodes;
	    }
	
	    $element.append($nodes);
	  };
	
	  return Utils;
	});
	
	S2.define('select2/results',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Results ($element, options, dataAdapter) {
	    this.$element = $element;
	    this.data = dataAdapter;
	    this.options = options;
	
	    Results.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Results, Utils.Observable);
	
	  Results.prototype.render = function () {
	    var $results = $(
	      '<ul class="select2-results__options" role="tree"></ul>'
	    );
	
	    if (this.options.get('multiple')) {
	      $results.attr('aria-multiselectable', 'true');
	    }
	
	    this.$results = $results;
	
	    return $results;
	  };
	
	  Results.prototype.clear = function () {
	    this.$results.empty();
	  };
	
	  Results.prototype.displayMessage = function (params) {
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    this.clear();
	    this.hideLoading();
	
	    var $message = $(
	      '<li role="treeitem" aria-live="assertive"' +
	      ' class="select2-results__option"></li>'
	    );
	
	    var message = this.options.get('translations').get(params.message);
	
	    $message.append(
	      escapeMarkup(
	        message(params.args)
	      )
	    );
	
	    $message[0].className += ' select2-results__message';
	
	    this.$results.append($message);
	  };
	
	  Results.prototype.hideMessages = function () {
	    this.$results.find('.select2-results__message').remove();
	  };
	
	  Results.prototype.append = function (data) {
	    this.hideLoading();
	
	    var $options = [];
	
	    if (data.results == null || data.results.length === 0) {
	      if (this.$results.children().length === 0) {
	        this.trigger('results:message', {
	          message: 'noResults'
	        });
	      }
	
	      return;
	    }
	
	    data.results = this.sort(data.results);
	
	    for (var d = 0; d < data.results.length; d++) {
	      var item = data.results[d];
	
	      var $option = this.option(item);
	
	      $options.push($option);
	    }
	
	    this.$results.append($options);
	  };
	
	  Results.prototype.position = function ($results, $dropdown) {
	    var $resultsContainer = $dropdown.find('.select2-results');
	    $resultsContainer.append($results);
	  };
	
	  Results.prototype.sort = function (data) {
	    var sorter = this.options.get('sorter');
	
	    return sorter(data);
	  };
	
	  Results.prototype.highlightFirstItem = function () {
	    var $options = this.$results
	      .find('.select2-results__option[aria-selected]');
	
	    var $selected = $options.filter('[aria-selected=true]');
	
	    // Check if there are any selected options
	    if ($selected.length > 0) {
	      // If there are selected options, highlight the first
	      $selected.first().trigger('mouseenter');
	    } else {
	      // If there are no selected options, highlight the first option
	      // in the dropdown
	      $options.first().trigger('mouseenter');
	    }
	
	    this.ensureHighlightVisible();
	  };
	
	  Results.prototype.setClasses = function () {
	    var self = this;
	
	    this.data.current(function (selected) {
	      var selectedIds = $.map(selected, function (s) {
	        return s.id.toString();
	      });
	
	      var $options = self.$results
	        .find('.select2-results__option[aria-selected]');
	
	      $options.each(function () {
	        var $option = $(this);
	
	        var item = $.data(this, 'data');
	
	        // id needs to be converted to a string when comparing
	        var id = '' + item.id;
	
	        if ((item.element != null && item.element.selected) ||
	            (item.element == null && $.inArray(id, selectedIds) > -1)) {
	          $option.attr('aria-selected', 'true');
	        } else {
	          $option.attr('aria-selected', 'false');
	        }
	      });
	
	    });
	  };
	
	  Results.prototype.showLoading = function (params) {
	    this.hideLoading();
	
	    var loadingMore = this.options.get('translations').get('searching');
	
	    var loading = {
	      disabled: true,
	      loading: true,
	      text: loadingMore(params)
	    };
	    var $loading = this.option(loading);
	    $loading.className += ' loading-results';
	
	    this.$results.prepend($loading);
	  };
	
	  Results.prototype.hideLoading = function () {
	    this.$results.find('.loading-results').remove();
	  };
	
	  Results.prototype.option = function (data) {
	    var option = document.createElement('li');
	    option.className = 'select2-results__option';
	
	    var attrs = {
	      'role': 'treeitem',
	      'aria-selected': 'false'
	    };
	
	    if (data.disabled) {
	      delete attrs['aria-selected'];
	      attrs['aria-disabled'] = 'true';
	    }
	
	    if (data.id == null) {
	      delete attrs['aria-selected'];
	    }
	
	    if (data._resultId != null) {
	      option.id = data._resultId;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    if (data.children) {
	      attrs.role = 'group';
	      attrs['aria-label'] = data.text;
	      delete attrs['aria-selected'];
	    }
	
	    for (var attr in attrs) {
	      var val = attrs[attr];
	
	      option.setAttribute(attr, val);
	    }
	
	    if (data.children) {
	      var $option = $(option);
	
	      var label = document.createElement('strong');
	      label.className = 'select2-results__group';
	
	      var $label = $(label);
	      this.template(data, label);
	
	      var $children = [];
	
	      for (var c = 0; c < data.children.length; c++) {
	        var child = data.children[c];
	
	        var $child = this.option(child);
	
	        $children.push($child);
	      }
	
	      var $childrenContainer = $('<ul></ul>', {
	        'class': 'select2-results__options select2-results__options--nested'
	      });
	
	      $childrenContainer.append($children);
	
	      $option.append(label);
	      $option.append($childrenContainer);
	    } else {
	      this.template(data, option);
	    }
	
	    $.data(option, 'data', data);
	
	    return option;
	  };
	
	  Results.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var id = container.id + '-results';
	
	    this.$results.attr('id', id);
	
	    container.on('results:all', function (params) {
	      self.clear();
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	        self.highlightFirstItem();
	      }
	    });
	
	    container.on('results:append', function (params) {
	      self.append(params.data);
	
	      if (container.isOpen()) {
	        self.setClasses();
	      }
	    });
	
	    container.on('query', function (params) {
	      self.hideMessages();
	      self.showLoading(params);
	    });
	
	    container.on('select', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	      self.highlightFirstItem();
	    });
	
	    container.on('unselect', function () {
	      if (!container.isOpen()) {
	        return;
	      }
	
	      self.setClasses();
	      self.highlightFirstItem();
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expended="true"
	      self.$results.attr('aria-expanded', 'true');
	      self.$results.attr('aria-hidden', 'false');
	
	      self.setClasses();
	      self.ensureHighlightVisible();
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expended="false"
	      self.$results.attr('aria-expanded', 'false');
	      self.$results.attr('aria-hidden', 'true');
	      self.$results.removeAttr('aria-activedescendant');
	    });
	
	    container.on('results:toggle', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      $highlighted.trigger('mouseup');
	    });
	
	    container.on('results:select', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      if ($highlighted.length === 0) {
	        return;
	      }
	
	      var data = $highlighted.data('data');
	
	      if ($highlighted.attr('aria-selected') == 'true') {
	        self.trigger('close', {});
	      } else {
	        self.trigger('select', {
	          data: data
	        });
	      }
	    });
	
	    container.on('results:previous', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      // If we are already at te top, don't move further
	      if (currentIndex === 0) {
	        return;
	      }
	
	      var nextIndex = currentIndex - 1;
	
	      // If none are highlighted, highlight the first
	      if ($highlighted.length === 0) {
	        nextIndex = 0;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top;
	      var nextTop = $next.offset().top;
	      var nextOffset = self.$results.scrollTop() + (nextTop - currentOffset);
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextTop - currentOffset < 0) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:next', function () {
	      var $highlighted = self.getHighlightedResults();
	
	      var $options = self.$results.find('[aria-selected]');
	
	      var currentIndex = $options.index($highlighted);
	
	      var nextIndex = currentIndex + 1;
	
	      // If we are at the last option, stay there
	      if (nextIndex >= $options.length) {
	        return;
	      }
	
	      var $next = $options.eq(nextIndex);
	
	      $next.trigger('mouseenter');
	
	      var currentOffset = self.$results.offset().top +
	        self.$results.outerHeight(false);
	      var nextBottom = $next.offset().top + $next.outerHeight(false);
	      var nextOffset = self.$results.scrollTop() + nextBottom - currentOffset;
	
	      if (nextIndex === 0) {
	        self.$results.scrollTop(0);
	      } else if (nextBottom > currentOffset) {
	        self.$results.scrollTop(nextOffset);
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      params.element.addClass('select2-results__option--highlighted');
	    });
	
	    container.on('results:message', function (params) {
	      self.displayMessage(params);
	    });
	
	    if ($.fn.mousewheel) {
	      this.$results.on('mousewheel', function (e) {
	        var top = self.$results.scrollTop();
	
	        var bottom = self.$results.get(0).scrollHeight - top + e.deltaY;
	
	        var isAtTop = e.deltaY > 0 && top - e.deltaY <= 0;
	        var isAtBottom = e.deltaY < 0 && bottom <= self.$results.height();
	
	        if (isAtTop) {
	          self.$results.scrollTop(0);
	
	          e.preventDefault();
	          e.stopPropagation();
	        } else if (isAtBottom) {
	          self.$results.scrollTop(
	            self.$results.get(0).scrollHeight - self.$results.height()
	          );
	
	          e.preventDefault();
	          e.stopPropagation();
	        }
	      });
	    }
	
	    this.$results.on('mouseup', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var $this = $(this);
	
	      var data = $this.data('data');
	
	      if ($this.attr('aria-selected') === 'true') {
	        if (self.options.get('multiple')) {
	          self.trigger('unselect', {
	            originalEvent: evt,
	            data: data
	          });
	        } else {
	          self.trigger('close', {});
	        }
	
	        return;
	      }
	
	      self.trigger('select', {
	        originalEvent: evt,
	        data: data
	      });
	    });
	
	    this.$results.on('mouseenter', '.select2-results__option[aria-selected]',
	      function (evt) {
	      var data = $(this).data('data');
	
	      self.getHighlightedResults()
	          .removeClass('select2-results__option--highlighted');
	
	      self.trigger('results:focus', {
	        data: data,
	        element: $(this)
	      });
	    });
	  };
	
	  Results.prototype.getHighlightedResults = function () {
	    var $highlighted = this.$results
	    .find('.select2-results__option--highlighted');
	
	    return $highlighted;
	  };
	
	  Results.prototype.destroy = function () {
	    this.$results.remove();
	  };
	
	  Results.prototype.ensureHighlightVisible = function () {
	    var $highlighted = this.getHighlightedResults();
	
	    if ($highlighted.length === 0) {
	      return;
	    }
	
	    var $options = this.$results.find('[aria-selected]');
	
	    var currentIndex = $options.index($highlighted);
	
	    var currentOffset = this.$results.offset().top;
	    var nextTop = $highlighted.offset().top;
	    var nextOffset = this.$results.scrollTop() + (nextTop - currentOffset);
	
	    var offsetDelta = nextTop - currentOffset;
	    nextOffset -= $highlighted.outerHeight(false) * 2;
	
	    if (currentIndex <= 2) {
	      this.$results.scrollTop(0);
	    } else if (offsetDelta > this.$results.outerHeight() || offsetDelta < 0) {
	      this.$results.scrollTop(nextOffset);
	    }
	  };
	
	  Results.prototype.template = function (result, container) {
	    var template = this.options.get('templateResult');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    var content = template(result, container);
	
	    if (content == null) {
	      container.style.display = 'none';
	    } else if (typeof content === 'string') {
	      container.innerHTML = escapeMarkup(content);
	    } else {
	      $(container).append(content);
	    }
	  };
	
	  return Results;
	});
	
	S2.define('select2/keys',[
	
	], function () {
	  var KEYS = {
	    BACKSPACE: 8,
	    TAB: 9,
	    ENTER: 13,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    ESC: 27,
	    SPACE: 32,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    END: 35,
	    HOME: 36,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    DELETE: 46
	  };
	
	  return KEYS;
	});
	
	S2.define('select2/selection/base',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function BaseSelection ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    BaseSelection.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseSelection, Utils.Observable);
	
	  BaseSelection.prototype.render = function () {
	    var $selection = $(
	      '<span class="select2-selection" role="combobox" ' +
	      ' aria-haspopup="true" aria-expanded="false">' +
	      '</span>'
	    );
	
	    this._tabindex = 0;
	
	    if (this.$element.data('old-tabindex') != null) {
	      this._tabindex = this.$element.data('old-tabindex');
	    } else if (this.$element.attr('tabindex') != null) {
	      this._tabindex = this.$element.attr('tabindex');
	    }
	
	    $selection.attr('title', this.$element.attr('title'));
	    $selection.attr('tabindex', this._tabindex);
	
	    this.$selection = $selection;
	
	    return $selection;
	  };
	
	  BaseSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    var id = container.id + '-container';
	    var resultsId = container.id + '-results';
	
	    this.container = container;
	
	    this.$selection.on('focus', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('blur', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      if (evt.which === KEYS.SPACE) {
	        evt.preventDefault();
	      }
	    });
	
	    container.on('results:focus', function (params) {
	      self.$selection.attr('aria-activedescendant', params.data._resultId);
	    });
	
	    container.on('selection:update', function (params) {
	      self.update(params.data);
	    });
	
	    container.on('open', function () {
	      // When the dropdown is open, aria-expanded="true"
	      self.$selection.attr('aria-expanded', 'true');
	      self.$selection.attr('aria-owns', resultsId);
	
	      self._attachCloseHandler(container);
	    });
	
	    container.on('close', function () {
	      // When the dropdown is closed, aria-expanded="false"
	      self.$selection.attr('aria-expanded', 'false');
	      self.$selection.removeAttr('aria-activedescendant');
	      self.$selection.removeAttr('aria-owns');
	
	      self.$selection.focus();
	
	      self._detachCloseHandler(container);
	    });
	
	    container.on('enable', function () {
	      self.$selection.attr('tabindex', self._tabindex);
	    });
	
	    container.on('disable', function () {
	      self.$selection.attr('tabindex', '-1');
	    });
	  };
	
	  BaseSelection.prototype._handleBlur = function (evt) {
	    var self = this;
	
	    // This needs to be delayed as the active element is the body when the tab
	    // key is pressed, possibly along with others.
	    window.setTimeout(function () {
	      // Don't trigger `blur` if the focus is still in the selection
	      if (
	        (document.activeElement == self.$selection[0]) ||
	        ($.contains(self.$selection[0], document.activeElement))
	      ) {
	        return;
	      }
	
	      self.trigger('blur', evt);
	    }, 1);
	  };
	
	  BaseSelection.prototype._attachCloseHandler = function (container) {
	    var self = this;
	
	    $(document.body).on('mousedown.select2.' + container.id, function (e) {
	      var $target = $(e.target);
	
	      var $select = $target.closest('.select2');
	
	      var $all = $('.select2.select2-container--open');
	
	      $all.each(function () {
	        var $this = $(this);
	
	        if (this == $select[0]) {
	          return;
	        }
	
	        var $element = $this.data('element');
	
	        $element.select2('close');
	      });
	    });
	  };
	
	  BaseSelection.prototype._detachCloseHandler = function (container) {
	    $(document.body).off('mousedown.select2.' + container.id);
	  };
	
	  BaseSelection.prototype.position = function ($selection, $container) {
	    var $selectionContainer = $container.find('.selection');
	    $selectionContainer.append($selection);
	  };
	
	  BaseSelection.prototype.destroy = function () {
	    this._detachCloseHandler(this.container);
	  };
	
	  BaseSelection.prototype.update = function (data) {
	    throw new Error('The `update` method must be defined in child classes.');
	  };
	
	  return BaseSelection;
	});
	
	S2.define('select2/selection/single',[
	  'jquery',
	  './base',
	  '../utils',
	  '../keys'
	], function ($, BaseSelection, Utils, KEYS) {
	  function SingleSelection () {
	    SingleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(SingleSelection, BaseSelection);
	
	  SingleSelection.prototype.render = function () {
	    var $selection = SingleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--single');
	
	    $selection.html(
	      '<span class="select2-selection__rendered"></span>' +
	      '<span class="select2-selection__arrow" role="presentation">' +
	        '<b role="presentation"></b>' +
	      '</span>'
	    );
	
	    return $selection;
	  };
	
	  SingleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    SingleSelection.__super__.bind.apply(this, arguments);
	
	    var id = container.id + '-container';
	
	    this.$selection.find('.select2-selection__rendered').attr('id', id);
	    this.$selection.attr('aria-labelledby', id);
	
	    this.$selection.on('mousedown', function (evt) {
	      // Only respond to left clicks
	      if (evt.which !== 1) {
	        return;
	      }
	
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on('focus', function (evt) {
	      // User focuses on the container
	    });
	
	    this.$selection.on('blur', function (evt) {
	      // User exits the container
	    });
	
	    container.on('focus', function (evt) {
	      if (!container.isOpen()) {
	        self.$selection.focus();
	      }
	    });
	
	    container.on('selection:update', function (params) {
	      self.update(params.data);
	    });
	  };
	
	  SingleSelection.prototype.clear = function () {
	    this.$selection.find('.select2-selection__rendered').empty();
	  };
	
	  SingleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  SingleSelection.prototype.selectionContainer = function () {
	    return $('<span></span>');
	  };
	
	  SingleSelection.prototype.update = function (data) {
	    if (data.length === 0) {
	      this.clear();
	      return;
	    }
	
	    var selection = data[0];
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	    var formatted = this.display(selection, $rendered);
	
	    $rendered.empty().append(formatted);
	    $rendered.prop('title', selection.title || selection.text);
	  };
	
	  return SingleSelection;
	});
	
	S2.define('select2/selection/multiple',[
	  'jquery',
	  './base',
	  '../utils'
	], function ($, BaseSelection, Utils) {
	  function MultipleSelection ($element, options) {
	    MultipleSelection.__super__.constructor.apply(this, arguments);
	  }
	
	  Utils.Extend(MultipleSelection, BaseSelection);
	
	  MultipleSelection.prototype.render = function () {
	    var $selection = MultipleSelection.__super__.render.call(this);
	
	    $selection.addClass('select2-selection--multiple');
	
	    $selection.html(
	      '<ul class="select2-selection__rendered"></ul>'
	    );
	
	    return $selection;
	  };
	
	  MultipleSelection.prototype.bind = function (container, $container) {
	    var self = this;
	
	    MultipleSelection.__super__.bind.apply(this, arguments);
	
	    this.$selection.on('click', function (evt) {
	      self.trigger('toggle', {
	        originalEvent: evt
	      });
	    });
	
	    this.$selection.on(
	      'click',
	      '.select2-selection__choice__remove',
	      function (evt) {
	        // Ignore the event if it is disabled
	        if (self.options.get('disabled')) {
	          return;
	        }
	
	        var $remove = $(this);
	        var $selection = $remove.parent();
	
	        var data = $selection.data('data');
	
	        self.trigger('unselect', {
	          originalEvent: evt,
	          data: data
	        });
	      }
	    );
	  };
	
	  MultipleSelection.prototype.clear = function () {
	    this.$selection.find('.select2-selection__rendered').empty();
	  };
	
	  MultipleSelection.prototype.display = function (data, container) {
	    var template = this.options.get('templateSelection');
	    var escapeMarkup = this.options.get('escapeMarkup');
	
	    return escapeMarkup(template(data, container));
	  };
	
	  MultipleSelection.prototype.selectionContainer = function () {
	    var $container = $(
	      '<li class="select2-selection__choice">' +
	        '<span class="select2-selection__choice__remove" role="presentation">' +
	          '&times;' +
	        '</span>' +
	      '</li>'
	    );
	
	    return $container;
	  };
	
	  MultipleSelection.prototype.update = function (data) {
	    this.clear();
	
	    if (data.length === 0) {
	      return;
	    }
	
	    var $selections = [];
	
	    for (var d = 0; d < data.length; d++) {
	      var selection = data[d];
	
	      var $selection = this.selectionContainer();
	      var formatted = this.display(selection, $selection);
	
	      $selection.append(formatted);
	      $selection.prop('title', selection.title || selection.text);
	
	      $selection.data('data', selection);
	
	      $selections.push($selection);
	    }
	
	    var $rendered = this.$selection.find('.select2-selection__rendered');
	
	    Utils.appendMany($rendered, $selections);
	  };
	
	  return MultipleSelection;
	});
	
	S2.define('select2/selection/placeholder',[
	  '../utils'
	], function (Utils) {
	  function Placeholder (decorated, $element, options) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options);
	  }
	
	  Placeholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  Placeholder.prototype.createPlaceholder = function (decorated, placeholder) {
	    var $placeholder = this.selectionContainer();
	
	    $placeholder.html(this.display(placeholder));
	    $placeholder.addClass('select2-selection__placeholder')
	                .removeClass('select2-selection__choice');
	
	    return $placeholder;
	  };
	
	  Placeholder.prototype.update = function (decorated, data) {
	    var singlePlaceholder = (
	      data.length == 1 && data[0].id != this.placeholder.id
	    );
	    var multipleSelections = data.length > 1;
	
	    if (multipleSelections || singlePlaceholder) {
	      return decorated.call(this, data);
	    }
	
	    this.clear();
	
	    var $placeholder = this.createPlaceholder(this.placeholder);
	
	    this.$selection.find('.select2-selection__rendered').append($placeholder);
	  };
	
	  return Placeholder;
	});
	
	S2.define('select2/selection/allowClear',[
	  'jquery',
	  '../keys'
	], function ($, KEYS) {
	  function AllowClear () { }
	
	  AllowClear.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    if (this.placeholder == null) {
	      if (this.options.get('debug') && window.console && console.error) {
	        console.error(
	          'Select2: The `allowClear` option should be used in combination ' +
	          'with the `placeholder` option.'
	        );
	      }
	    }
	
	    this.$selection.on('mousedown', '.select2-selection__clear',
	      function (evt) {
	        self._handleClear(evt);
	    });
	
	    container.on('keypress', function (evt) {
	      self._handleKeyboardClear(evt, container);
	    });
	  };
	
	  AllowClear.prototype._handleClear = function (_, evt) {
	    // Ignore the event if it is disabled
	    if (this.options.get('disabled')) {
	      return;
	    }
	
	    var $clear = this.$selection.find('.select2-selection__clear');
	
	    // Ignore the event if nothing has been selected
	    if ($clear.length === 0) {
	      return;
	    }
	
	    evt.stopPropagation();
	
	    var data = $clear.data('data');
	
	    for (var d = 0; d < data.length; d++) {
	      var unselectData = {
	        data: data[d]
	      };
	
	      // Trigger the `unselect` event, so people can prevent it from being
	      // cleared.
	      this.trigger('unselect', unselectData);
	
	      // If the event was prevented, don't clear it out.
	      if (unselectData.prevented) {
	        return;
	      }
	    }
	
	    this.$element.val(this.placeholder.id).trigger('change');
	
	    this.trigger('toggle', {});
	  };
	
	  AllowClear.prototype._handleKeyboardClear = function (_, evt, container) {
	    if (container.isOpen()) {
	      return;
	    }
	
	    if (evt.which == KEYS.DELETE || evt.which == KEYS.BACKSPACE) {
	      this._handleClear(evt);
	    }
	  };
	
	  AllowClear.prototype.update = function (decorated, data) {
	    decorated.call(this, data);
	
	    if (this.$selection.find('.select2-selection__placeholder').length > 0 ||
	        data.length === 0) {
	      return;
	    }
	
	    var $remove = $(
	      '<span class="select2-selection__clear">' +
	        '&times;' +
	      '</span>'
	    );
	    $remove.data('data', data);
	
	    this.$selection.find('.select2-selection__rendered').prepend($remove);
	  };
	
	  return AllowClear;
	});
	
	S2.define('select2/selection/search',[
	  'jquery',
	  '../utils',
	  '../keys'
	], function ($, Utils, KEYS) {
	  function Search (decorated, $element, options) {
	    decorated.call(this, $element, options);
	  }
	
	  Search.prototype.render = function (decorated) {
	    var $search = $(
	      '<li class="select2-search select2-search--inline">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
	        ' spellcheck="false" role="textbox" aria-autocomplete="list" />' +
	      '</li>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    var $rendered = decorated.call(this);
	
	    this._transferTabIndex();
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self.$search.trigger('focus');
	    });
	
	    container.on('close', function () {
	      self.$search.val('');
	      self.$search.removeAttr('aria-activedescendant');
	      self.$search.trigger('focus');
	    });
	
	    container.on('enable', function () {
	      self.$search.prop('disabled', false);
	
	      self._transferTabIndex();
	    });
	
	    container.on('disable', function () {
	      self.$search.prop('disabled', true);
	    });
	
	    container.on('focus', function (evt) {
	      self.$search.trigger('focus');
	    });
	
	    container.on('results:focus', function (params) {
	      self.$search.attr('aria-activedescendant', params.id);
	    });
	
	    this.$selection.on('focusin', '.select2-search--inline', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this.$selection.on('focusout', '.select2-search--inline', function (evt) {
	      self._handleBlur(evt);
	    });
	
	    this.$selection.on('keydown', '.select2-search--inline', function (evt) {
	      evt.stopPropagation();
	
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	
	      var key = evt.which;
	
	      if (key === KEYS.BACKSPACE && self.$search.val() === '') {
	        var $previousChoice = self.$searchContainer
	          .prev('.select2-selection__choice');
	
	        if ($previousChoice.length > 0) {
	          var item = $previousChoice.data('data');
	
	          self.searchRemoveChoice(item);
	
	          evt.preventDefault();
	        }
	      }
	    });
	
	    // Try to detect the IE version should the `documentMode` property that
	    // is stored on the document. This is only implemented in IE and is
	    // slightly cleaner than doing a user agent check.
	    // This property is not available in Edge, but Edge also doesn't have
	    // this bug.
	    var msie = document.documentMode;
	    var disableInputEvents = msie && msie <= 11;
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$selection.on(
	      'input.searchcheck',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents) {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        // Unbind the duplicated `keyup` event
	        self.$selection.off('keyup.search');
	      }
	    );
	
	    this.$selection.on(
	      'keyup.search input.search',
	      '.select2-search--inline',
	      function (evt) {
	        // IE will trigger the `input` event when a placeholder is used on a
	        // search box. To get around this issue, we are forced to ignore all
	        // `input` events in IE and keep using `keyup`.
	        if (disableInputEvents && evt.type === 'input') {
	          self.$selection.off('input.search input.searchcheck');
	          return;
	        }
	
	        var key = evt.which;
	
	        // We can freely ignore events from modifier keys
	        if (key == KEYS.SHIFT || key == KEYS.CTRL || key == KEYS.ALT) {
	          return;
	        }
	
	        // Tabbing will be handled during the `keydown` phase
	        if (key == KEYS.TAB) {
	          return;
	        }
	
	        self.handleSearch(evt);
	      }
	    );
	  };
	
	  /**
	   * This method will transfer the tabindex attribute from the rendered
	   * selection to the search box. This allows for the search box to be used as
	   * the primary focus instead of the selection container.
	   *
	   * @private
	   */
	  Search.prototype._transferTabIndex = function (decorated) {
	    this.$search.attr('tabindex', this.$selection.attr('tabindex'));
	    this.$selection.attr('tabindex', '-1');
	  };
	
	  Search.prototype.createPlaceholder = function (decorated, placeholder) {
	    this.$search.attr('placeholder', placeholder.text);
	  };
	
	  Search.prototype.update = function (decorated, data) {
	    var searchHadFocus = this.$search[0] == document.activeElement;
	
	    this.$search.attr('placeholder', '');
	
	    decorated.call(this, data);
	
	    this.$selection.find('.select2-selection__rendered')
	                   .append(this.$searchContainer);
	
	    this.resizeSearch();
	    if (searchHadFocus) {
	      this.$search.focus();
	    }
	  };
	
	  Search.prototype.handleSearch = function () {
	    this.resizeSearch();
	
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.searchRemoveChoice = function (decorated, item) {
	    this.trigger('unselect', {
	      data: item
	    });
	
	    this.$search.val(item.text);
	    this.handleSearch();
	  };
	
	  Search.prototype.resizeSearch = function () {
	    this.$search.css('width', '25px');
	
	    var width = '';
	
	    if (this.$search.attr('placeholder') !== '') {
	      width = this.$selection.find('.select2-selection__rendered').innerWidth();
	    } else {
	      var minimumWidth = this.$search.val().length + 1;
	
	      width = (minimumWidth * 0.75) + 'em';
	    }
	
	    this.$search.css('width', width);
	  };
	
	  return Search;
	});
	
	S2.define('select2/selection/eventRelay',[
	  'jquery'
	], function ($) {
	  function EventRelay () { }
	
	  EventRelay.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	    var relayEvents = [
	      'open', 'opening',
	      'close', 'closing',
	      'select', 'selecting',
	      'unselect', 'unselecting'
	    ];
	
	    var preventableEvents = ['opening', 'closing', 'selecting', 'unselecting'];
	
	    decorated.call(this, container, $container);
	
	    container.on('*', function (name, params) {
	      // Ignore events that should not be relayed
	      if ($.inArray(name, relayEvents) === -1) {
	        return;
	      }
	
	      // The parameters should always be an object
	      params = params || {};
	
	      // Generate the jQuery event for the Select2 event
	      var evt = $.Event('select2:' + name, {
	        params: params
	      });
	
	      self.$element.trigger(evt);
	
	      // Only handle preventable events if it was one
	      if ($.inArray(name, preventableEvents) === -1) {
	        return;
	      }
	
	      params.prevented = evt.isDefaultPrevented();
	    });
	  };
	
	  return EventRelay;
	});
	
	S2.define('select2/translation',[
	  'jquery',
	  'require'
	], function ($, require) {
	  function Translation (dict) {
	    this.dict = dict || {};
	  }
	
	  Translation.prototype.all = function () {
	    return this.dict;
	  };
	
	  Translation.prototype.get = function (key) {
	    return this.dict[key];
	  };
	
	  Translation.prototype.extend = function (translation) {
	    this.dict = $.extend({}, translation.all(), this.dict);
	  };
	
	  // Static functions
	
	  Translation._cache = {};
	
	  Translation.loadPath = function (path) {
	    if (!(path in Translation._cache)) {
	      var translations = require(path);
	
	      Translation._cache[path] = translations;
	    }
	
	    return new Translation(Translation._cache[path]);
	  };
	
	  return Translation;
	});
	
	S2.define('select2/diacritics',[
	
	], function () {
	  var diacritics = {
	    '\u24B6': 'A',
	    '\uFF21': 'A',
	    '\u00C0': 'A',
	    '\u00C1': 'A',
	    '\u00C2': 'A',
	    '\u1EA6': 'A',
	    '\u1EA4': 'A',
	    '\u1EAA': 'A',
	    '\u1EA8': 'A',
	    '\u00C3': 'A',
	    '\u0100': 'A',
	    '\u0102': 'A',
	    '\u1EB0': 'A',
	    '\u1EAE': 'A',
	    '\u1EB4': 'A',
	    '\u1EB2': 'A',
	    '\u0226': 'A',
	    '\u01E0': 'A',
	    '\u00C4': 'A',
	    '\u01DE': 'A',
	    '\u1EA2': 'A',
	    '\u00C5': 'A',
	    '\u01FA': 'A',
	    '\u01CD': 'A',
	    '\u0200': 'A',
	    '\u0202': 'A',
	    '\u1EA0': 'A',
	    '\u1EAC': 'A',
	    '\u1EB6': 'A',
	    '\u1E00': 'A',
	    '\u0104': 'A',
	    '\u023A': 'A',
	    '\u2C6F': 'A',
	    '\uA732': 'AA',
	    '\u00C6': 'AE',
	    '\u01FC': 'AE',
	    '\u01E2': 'AE',
	    '\uA734': 'AO',
	    '\uA736': 'AU',
	    '\uA738': 'AV',
	    '\uA73A': 'AV',
	    '\uA73C': 'AY',
	    '\u24B7': 'B',
	    '\uFF22': 'B',
	    '\u1E02': 'B',
	    '\u1E04': 'B',
	    '\u1E06': 'B',
	    '\u0243': 'B',
	    '\u0182': 'B',
	    '\u0181': 'B',
	    '\u24B8': 'C',
	    '\uFF23': 'C',
	    '\u0106': 'C',
	    '\u0108': 'C',
	    '\u010A': 'C',
	    '\u010C': 'C',
	    '\u00C7': 'C',
	    '\u1E08': 'C',
	    '\u0187': 'C',
	    '\u023B': 'C',
	    '\uA73E': 'C',
	    '\u24B9': 'D',
	    '\uFF24': 'D',
	    '\u1E0A': 'D',
	    '\u010E': 'D',
	    '\u1E0C': 'D',
	    '\u1E10': 'D',
	    '\u1E12': 'D',
	    '\u1E0E': 'D',
	    '\u0110': 'D',
	    '\u018B': 'D',
	    '\u018A': 'D',
	    '\u0189': 'D',
	    '\uA779': 'D',
	    '\u01F1': 'DZ',
	    '\u01C4': 'DZ',
	    '\u01F2': 'Dz',
	    '\u01C5': 'Dz',
	    '\u24BA': 'E',
	    '\uFF25': 'E',
	    '\u00C8': 'E',
	    '\u00C9': 'E',
	    '\u00CA': 'E',
	    '\u1EC0': 'E',
	    '\u1EBE': 'E',
	    '\u1EC4': 'E',
	    '\u1EC2': 'E',
	    '\u1EBC': 'E',
	    '\u0112': 'E',
	    '\u1E14': 'E',
	    '\u1E16': 'E',
	    '\u0114': 'E',
	    '\u0116': 'E',
	    '\u00CB': 'E',
	    '\u1EBA': 'E',
	    '\u011A': 'E',
	    '\u0204': 'E',
	    '\u0206': 'E',
	    '\u1EB8': 'E',
	    '\u1EC6': 'E',
	    '\u0228': 'E',
	    '\u1E1C': 'E',
	    '\u0118': 'E',
	    '\u1E18': 'E',
	    '\u1E1A': 'E',
	    '\u0190': 'E',
	    '\u018E': 'E',
	    '\u24BB': 'F',
	    '\uFF26': 'F',
	    '\u1E1E': 'F',
	    '\u0191': 'F',
	    '\uA77B': 'F',
	    '\u24BC': 'G',
	    '\uFF27': 'G',
	    '\u01F4': 'G',
	    '\u011C': 'G',
	    '\u1E20': 'G',
	    '\u011E': 'G',
	    '\u0120': 'G',
	    '\u01E6': 'G',
	    '\u0122': 'G',
	    '\u01E4': 'G',
	    '\u0193': 'G',
	    '\uA7A0': 'G',
	    '\uA77D': 'G',
	    '\uA77E': 'G',
	    '\u24BD': 'H',
	    '\uFF28': 'H',
	    '\u0124': 'H',
	    '\u1E22': 'H',
	    '\u1E26': 'H',
	    '\u021E': 'H',
	    '\u1E24': 'H',
	    '\u1E28': 'H',
	    '\u1E2A': 'H',
	    '\u0126': 'H',
	    '\u2C67': 'H',
	    '\u2C75': 'H',
	    '\uA78D': 'H',
	    '\u24BE': 'I',
	    '\uFF29': 'I',
	    '\u00CC': 'I',
	    '\u00CD': 'I',
	    '\u00CE': 'I',
	    '\u0128': 'I',
	    '\u012A': 'I',
	    '\u012C': 'I',
	    '\u0130': 'I',
	    '\u00CF': 'I',
	    '\u1E2E': 'I',
	    '\u1EC8': 'I',
	    '\u01CF': 'I',
	    '\u0208': 'I',
	    '\u020A': 'I',
	    '\u1ECA': 'I',
	    '\u012E': 'I',
	    '\u1E2C': 'I',
	    '\u0197': 'I',
	    '\u24BF': 'J',
	    '\uFF2A': 'J',
	    '\u0134': 'J',
	    '\u0248': 'J',
	    '\u24C0': 'K',
	    '\uFF2B': 'K',
	    '\u1E30': 'K',
	    '\u01E8': 'K',
	    '\u1E32': 'K',
	    '\u0136': 'K',
	    '\u1E34': 'K',
	    '\u0198': 'K',
	    '\u2C69': 'K',
	    '\uA740': 'K',
	    '\uA742': 'K',
	    '\uA744': 'K',
	    '\uA7A2': 'K',
	    '\u24C1': 'L',
	    '\uFF2C': 'L',
	    '\u013F': 'L',
	    '\u0139': 'L',
	    '\u013D': 'L',
	    '\u1E36': 'L',
	    '\u1E38': 'L',
	    '\u013B': 'L',
	    '\u1E3C': 'L',
	    '\u1E3A': 'L',
	    '\u0141': 'L',
	    '\u023D': 'L',
	    '\u2C62': 'L',
	    '\u2C60': 'L',
	    '\uA748': 'L',
	    '\uA746': 'L',
	    '\uA780': 'L',
	    '\u01C7': 'LJ',
	    '\u01C8': 'Lj',
	    '\u24C2': 'M',
	    '\uFF2D': 'M',
	    '\u1E3E': 'M',
	    '\u1E40': 'M',
	    '\u1E42': 'M',
	    '\u2C6E': 'M',
	    '\u019C': 'M',
	    '\u24C3': 'N',
	    '\uFF2E': 'N',
	    '\u01F8': 'N',
	    '\u0143': 'N',
	    '\u00D1': 'N',
	    '\u1E44': 'N',
	    '\u0147': 'N',
	    '\u1E46': 'N',
	    '\u0145': 'N',
	    '\u1E4A': 'N',
	    '\u1E48': 'N',
	    '\u0220': 'N',
	    '\u019D': 'N',
	    '\uA790': 'N',
	    '\uA7A4': 'N',
	    '\u01CA': 'NJ',
	    '\u01CB': 'Nj',
	    '\u24C4': 'O',
	    '\uFF2F': 'O',
	    '\u00D2': 'O',
	    '\u00D3': 'O',
	    '\u00D4': 'O',
	    '\u1ED2': 'O',
	    '\u1ED0': 'O',
	    '\u1ED6': 'O',
	    '\u1ED4': 'O',
	    '\u00D5': 'O',
	    '\u1E4C': 'O',
	    '\u022C': 'O',
	    '\u1E4E': 'O',
	    '\u014C': 'O',
	    '\u1E50': 'O',
	    '\u1E52': 'O',
	    '\u014E': 'O',
	    '\u022E': 'O',
	    '\u0230': 'O',
	    '\u00D6': 'O',
	    '\u022A': 'O',
	    '\u1ECE': 'O',
	    '\u0150': 'O',
	    '\u01D1': 'O',
	    '\u020C': 'O',
	    '\u020E': 'O',
	    '\u01A0': 'O',
	    '\u1EDC': 'O',
	    '\u1EDA': 'O',
	    '\u1EE0': 'O',
	    '\u1EDE': 'O',
	    '\u1EE2': 'O',
	    '\u1ECC': 'O',
	    '\u1ED8': 'O',
	    '\u01EA': 'O',
	    '\u01EC': 'O',
	    '\u00D8': 'O',
	    '\u01FE': 'O',
	    '\u0186': 'O',
	    '\u019F': 'O',
	    '\uA74A': 'O',
	    '\uA74C': 'O',
	    '\u01A2': 'OI',
	    '\uA74E': 'OO',
	    '\u0222': 'OU',
	    '\u24C5': 'P',
	    '\uFF30': 'P',
	    '\u1E54': 'P',
	    '\u1E56': 'P',
	    '\u01A4': 'P',
	    '\u2C63': 'P',
	    '\uA750': 'P',
	    '\uA752': 'P',
	    '\uA754': 'P',
	    '\u24C6': 'Q',
	    '\uFF31': 'Q',
	    '\uA756': 'Q',
	    '\uA758': 'Q',
	    '\u024A': 'Q',
	    '\u24C7': 'R',
	    '\uFF32': 'R',
	    '\u0154': 'R',
	    '\u1E58': 'R',
	    '\u0158': 'R',
	    '\u0210': 'R',
	    '\u0212': 'R',
	    '\u1E5A': 'R',
	    '\u1E5C': 'R',
	    '\u0156': 'R',
	    '\u1E5E': 'R',
	    '\u024C': 'R',
	    '\u2C64': 'R',
	    '\uA75A': 'R',
	    '\uA7A6': 'R',
	    '\uA782': 'R',
	    '\u24C8': 'S',
	    '\uFF33': 'S',
	    '\u1E9E': 'S',
	    '\u015A': 'S',
	    '\u1E64': 'S',
	    '\u015C': 'S',
	    '\u1E60': 'S',
	    '\u0160': 'S',
	    '\u1E66': 'S',
	    '\u1E62': 'S',
	    '\u1E68': 'S',
	    '\u0218': 'S',
	    '\u015E': 'S',
	    '\u2C7E': 'S',
	    '\uA7A8': 'S',
	    '\uA784': 'S',
	    '\u24C9': 'T',
	    '\uFF34': 'T',
	    '\u1E6A': 'T',
	    '\u0164': 'T',
	    '\u1E6C': 'T',
	    '\u021A': 'T',
	    '\u0162': 'T',
	    '\u1E70': 'T',
	    '\u1E6E': 'T',
	    '\u0166': 'T',
	    '\u01AC': 'T',
	    '\u01AE': 'T',
	    '\u023E': 'T',
	    '\uA786': 'T',
	    '\uA728': 'TZ',
	    '\u24CA': 'U',
	    '\uFF35': 'U',
	    '\u00D9': 'U',
	    '\u00DA': 'U',
	    '\u00DB': 'U',
	    '\u0168': 'U',
	    '\u1E78': 'U',
	    '\u016A': 'U',
	    '\u1E7A': 'U',
	    '\u016C': 'U',
	    '\u00DC': 'U',
	    '\u01DB': 'U',
	    '\u01D7': 'U',
	    '\u01D5': 'U',
	    '\u01D9': 'U',
	    '\u1EE6': 'U',
	    '\u016E': 'U',
	    '\u0170': 'U',
	    '\u01D3': 'U',
	    '\u0214': 'U',
	    '\u0216': 'U',
	    '\u01AF': 'U',
	    '\u1EEA': 'U',
	    '\u1EE8': 'U',
	    '\u1EEE': 'U',
	    '\u1EEC': 'U',
	    '\u1EF0': 'U',
	    '\u1EE4': 'U',
	    '\u1E72': 'U',
	    '\u0172': 'U',
	    '\u1E76': 'U',
	    '\u1E74': 'U',
	    '\u0244': 'U',
	    '\u24CB': 'V',
	    '\uFF36': 'V',
	    '\u1E7C': 'V',
	    '\u1E7E': 'V',
	    '\u01B2': 'V',
	    '\uA75E': 'V',
	    '\u0245': 'V',
	    '\uA760': 'VY',
	    '\u24CC': 'W',
	    '\uFF37': 'W',
	    '\u1E80': 'W',
	    '\u1E82': 'W',
	    '\u0174': 'W',
	    '\u1E86': 'W',
	    '\u1E84': 'W',
	    '\u1E88': 'W',
	    '\u2C72': 'W',
	    '\u24CD': 'X',
	    '\uFF38': 'X',
	    '\u1E8A': 'X',
	    '\u1E8C': 'X',
	    '\u24CE': 'Y',
	    '\uFF39': 'Y',
	    '\u1EF2': 'Y',
	    '\u00DD': 'Y',
	    '\u0176': 'Y',
	    '\u1EF8': 'Y',
	    '\u0232': 'Y',
	    '\u1E8E': 'Y',
	    '\u0178': 'Y',
	    '\u1EF6': 'Y',
	    '\u1EF4': 'Y',
	    '\u01B3': 'Y',
	    '\u024E': 'Y',
	    '\u1EFE': 'Y',
	    '\u24CF': 'Z',
	    '\uFF3A': 'Z',
	    '\u0179': 'Z',
	    '\u1E90': 'Z',
	    '\u017B': 'Z',
	    '\u017D': 'Z',
	    '\u1E92': 'Z',
	    '\u1E94': 'Z',
	    '\u01B5': 'Z',
	    '\u0224': 'Z',
	    '\u2C7F': 'Z',
	    '\u2C6B': 'Z',
	    '\uA762': 'Z',
	    '\u24D0': 'a',
	    '\uFF41': 'a',
	    '\u1E9A': 'a',
	    '\u00E0': 'a',
	    '\u00E1': 'a',
	    '\u00E2': 'a',
	    '\u1EA7': 'a',
	    '\u1EA5': 'a',
	    '\u1EAB': 'a',
	    '\u1EA9': 'a',
	    '\u00E3': 'a',
	    '\u0101': 'a',
	    '\u0103': 'a',
	    '\u1EB1': 'a',
	    '\u1EAF': 'a',
	    '\u1EB5': 'a',
	    '\u1EB3': 'a',
	    '\u0227': 'a',
	    '\u01E1': 'a',
	    '\u00E4': 'a',
	    '\u01DF': 'a',
	    '\u1EA3': 'a',
	    '\u00E5': 'a',
	    '\u01FB': 'a',
	    '\u01CE': 'a',
	    '\u0201': 'a',
	    '\u0203': 'a',
	    '\u1EA1': 'a',
	    '\u1EAD': 'a',
	    '\u1EB7': 'a',
	    '\u1E01': 'a',
	    '\u0105': 'a',
	    '\u2C65': 'a',
	    '\u0250': 'a',
	    '\uA733': 'aa',
	    '\u00E6': 'ae',
	    '\u01FD': 'ae',
	    '\u01E3': 'ae',
	    '\uA735': 'ao',
	    '\uA737': 'au',
	    '\uA739': 'av',
	    '\uA73B': 'av',
	    '\uA73D': 'ay',
	    '\u24D1': 'b',
	    '\uFF42': 'b',
	    '\u1E03': 'b',
	    '\u1E05': 'b',
	    '\u1E07': 'b',
	    '\u0180': 'b',
	    '\u0183': 'b',
	    '\u0253': 'b',
	    '\u24D2': 'c',
	    '\uFF43': 'c',
	    '\u0107': 'c',
	    '\u0109': 'c',
	    '\u010B': 'c',
	    '\u010D': 'c',
	    '\u00E7': 'c',
	    '\u1E09': 'c',
	    '\u0188': 'c',
	    '\u023C': 'c',
	    '\uA73F': 'c',
	    '\u2184': 'c',
	    '\u24D3': 'd',
	    '\uFF44': 'd',
	    '\u1E0B': 'd',
	    '\u010F': 'd',
	    '\u1E0D': 'd',
	    '\u1E11': 'd',
	    '\u1E13': 'd',
	    '\u1E0F': 'd',
	    '\u0111': 'd',
	    '\u018C': 'd',
	    '\u0256': 'd',
	    '\u0257': 'd',
	    '\uA77A': 'd',
	    '\u01F3': 'dz',
	    '\u01C6': 'dz',
	    '\u24D4': 'e',
	    '\uFF45': 'e',
	    '\u00E8': 'e',
	    '\u00E9': 'e',
	    '\u00EA': 'e',
	    '\u1EC1': 'e',
	    '\u1EBF': 'e',
	    '\u1EC5': 'e',
	    '\u1EC3': 'e',
	    '\u1EBD': 'e',
	    '\u0113': 'e',
	    '\u1E15': 'e',
	    '\u1E17': 'e',
	    '\u0115': 'e',
	    '\u0117': 'e',
	    '\u00EB': 'e',
	    '\u1EBB': 'e',
	    '\u011B': 'e',
	    '\u0205': 'e',
	    '\u0207': 'e',
	    '\u1EB9': 'e',
	    '\u1EC7': 'e',
	    '\u0229': 'e',
	    '\u1E1D': 'e',
	    '\u0119': 'e',
	    '\u1E19': 'e',
	    '\u1E1B': 'e',
	    '\u0247': 'e',
	    '\u025B': 'e',
	    '\u01DD': 'e',
	    '\u24D5': 'f',
	    '\uFF46': 'f',
	    '\u1E1F': 'f',
	    '\u0192': 'f',
	    '\uA77C': 'f',
	    '\u24D6': 'g',
	    '\uFF47': 'g',
	    '\u01F5': 'g',
	    '\u011D': 'g',
	    '\u1E21': 'g',
	    '\u011F': 'g',
	    '\u0121': 'g',
	    '\u01E7': 'g',
	    '\u0123': 'g',
	    '\u01E5': 'g',
	    '\u0260': 'g',
	    '\uA7A1': 'g',
	    '\u1D79': 'g',
	    '\uA77F': 'g',
	    '\u24D7': 'h',
	    '\uFF48': 'h',
	    '\u0125': 'h',
	    '\u1E23': 'h',
	    '\u1E27': 'h',
	    '\u021F': 'h',
	    '\u1E25': 'h',
	    '\u1E29': 'h',
	    '\u1E2B': 'h',
	    '\u1E96': 'h',
	    '\u0127': 'h',
	    '\u2C68': 'h',
	    '\u2C76': 'h',
	    '\u0265': 'h',
	    '\u0195': 'hv',
	    '\u24D8': 'i',
	    '\uFF49': 'i',
	    '\u00EC': 'i',
	    '\u00ED': 'i',
	    '\u00EE': 'i',
	    '\u0129': 'i',
	    '\u012B': 'i',
	    '\u012D': 'i',
	    '\u00EF': 'i',
	    '\u1E2F': 'i',
	    '\u1EC9': 'i',
	    '\u01D0': 'i',
	    '\u0209': 'i',
	    '\u020B': 'i',
	    '\u1ECB': 'i',
	    '\u012F': 'i',
	    '\u1E2D': 'i',
	    '\u0268': 'i',
	    '\u0131': 'i',
	    '\u24D9': 'j',
	    '\uFF4A': 'j',
	    '\u0135': 'j',
	    '\u01F0': 'j',
	    '\u0249': 'j',
	    '\u24DA': 'k',
	    '\uFF4B': 'k',
	    '\u1E31': 'k',
	    '\u01E9': 'k',
	    '\u1E33': 'k',
	    '\u0137': 'k',
	    '\u1E35': 'k',
	    '\u0199': 'k',
	    '\u2C6A': 'k',
	    '\uA741': 'k',
	    '\uA743': 'k',
	    '\uA745': 'k',
	    '\uA7A3': 'k',
	    '\u24DB': 'l',
	    '\uFF4C': 'l',
	    '\u0140': 'l',
	    '\u013A': 'l',
	    '\u013E': 'l',
	    '\u1E37': 'l',
	    '\u1E39': 'l',
	    '\u013C': 'l',
	    '\u1E3D': 'l',
	    '\u1E3B': 'l',
	    '\u017F': 'l',
	    '\u0142': 'l',
	    '\u019A': 'l',
	    '\u026B': 'l',
	    '\u2C61': 'l',
	    '\uA749': 'l',
	    '\uA781': 'l',
	    '\uA747': 'l',
	    '\u01C9': 'lj',
	    '\u24DC': 'm',
	    '\uFF4D': 'm',
	    '\u1E3F': 'm',
	    '\u1E41': 'm',
	    '\u1E43': 'm',
	    '\u0271': 'm',
	    '\u026F': 'm',
	    '\u24DD': 'n',
	    '\uFF4E': 'n',
	    '\u01F9': 'n',
	    '\u0144': 'n',
	    '\u00F1': 'n',
	    '\u1E45': 'n',
	    '\u0148': 'n',
	    '\u1E47': 'n',
	    '\u0146': 'n',
	    '\u1E4B': 'n',
	    '\u1E49': 'n',
	    '\u019E': 'n',
	    '\u0272': 'n',
	    '\u0149': 'n',
	    '\uA791': 'n',
	    '\uA7A5': 'n',
	    '\u01CC': 'nj',
	    '\u24DE': 'o',
	    '\uFF4F': 'o',
	    '\u00F2': 'o',
	    '\u00F3': 'o',
	    '\u00F4': 'o',
	    '\u1ED3': 'o',
	    '\u1ED1': 'o',
	    '\u1ED7': 'o',
	    '\u1ED5': 'o',
	    '\u00F5': 'o',
	    '\u1E4D': 'o',
	    '\u022D': 'o',
	    '\u1E4F': 'o',
	    '\u014D': 'o',
	    '\u1E51': 'o',
	    '\u1E53': 'o',
	    '\u014F': 'o',
	    '\u022F': 'o',
	    '\u0231': 'o',
	    '\u00F6': 'o',
	    '\u022B': 'o',
	    '\u1ECF': 'o',
	    '\u0151': 'o',
	    '\u01D2': 'o',
	    '\u020D': 'o',
	    '\u020F': 'o',
	    '\u01A1': 'o',
	    '\u1EDD': 'o',
	    '\u1EDB': 'o',
	    '\u1EE1': 'o',
	    '\u1EDF': 'o',
	    '\u1EE3': 'o',
	    '\u1ECD': 'o',
	    '\u1ED9': 'o',
	    '\u01EB': 'o',
	    '\u01ED': 'o',
	    '\u00F8': 'o',
	    '\u01FF': 'o',
	    '\u0254': 'o',
	    '\uA74B': 'o',
	    '\uA74D': 'o',
	    '\u0275': 'o',
	    '\u01A3': 'oi',
	    '\u0223': 'ou',
	    '\uA74F': 'oo',
	    '\u24DF': 'p',
	    '\uFF50': 'p',
	    '\u1E55': 'p',
	    '\u1E57': 'p',
	    '\u01A5': 'p',
	    '\u1D7D': 'p',
	    '\uA751': 'p',
	    '\uA753': 'p',
	    '\uA755': 'p',
	    '\u24E0': 'q',
	    '\uFF51': 'q',
	    '\u024B': 'q',
	    '\uA757': 'q',
	    '\uA759': 'q',
	    '\u24E1': 'r',
	    '\uFF52': 'r',
	    '\u0155': 'r',
	    '\u1E59': 'r',
	    '\u0159': 'r',
	    '\u0211': 'r',
	    '\u0213': 'r',
	    '\u1E5B': 'r',
	    '\u1E5D': 'r',
	    '\u0157': 'r',
	    '\u1E5F': 'r',
	    '\u024D': 'r',
	    '\u027D': 'r',
	    '\uA75B': 'r',
	    '\uA7A7': 'r',
	    '\uA783': 'r',
	    '\u24E2': 's',
	    '\uFF53': 's',
	    '\u00DF': 's',
	    '\u015B': 's',
	    '\u1E65': 's',
	    '\u015D': 's',
	    '\u1E61': 's',
	    '\u0161': 's',
	    '\u1E67': 's',
	    '\u1E63': 's',
	    '\u1E69': 's',
	    '\u0219': 's',
	    '\u015F': 's',
	    '\u023F': 's',
	    '\uA7A9': 's',
	    '\uA785': 's',
	    '\u1E9B': 's',
	    '\u24E3': 't',
	    '\uFF54': 't',
	    '\u1E6B': 't',
	    '\u1E97': 't',
	    '\u0165': 't',
	    '\u1E6D': 't',
	    '\u021B': 't',
	    '\u0163': 't',
	    '\u1E71': 't',
	    '\u1E6F': 't',
	    '\u0167': 't',
	    '\u01AD': 't',
	    '\u0288': 't',
	    '\u2C66': 't',
	    '\uA787': 't',
	    '\uA729': 'tz',
	    '\u24E4': 'u',
	    '\uFF55': 'u',
	    '\u00F9': 'u',
	    '\u00FA': 'u',
	    '\u00FB': 'u',
	    '\u0169': 'u',
	    '\u1E79': 'u',
	    '\u016B': 'u',
	    '\u1E7B': 'u',
	    '\u016D': 'u',
	    '\u00FC': 'u',
	    '\u01DC': 'u',
	    '\u01D8': 'u',
	    '\u01D6': 'u',
	    '\u01DA': 'u',
	    '\u1EE7': 'u',
	    '\u016F': 'u',
	    '\u0171': 'u',
	    '\u01D4': 'u',
	    '\u0215': 'u',
	    '\u0217': 'u',
	    '\u01B0': 'u',
	    '\u1EEB': 'u',
	    '\u1EE9': 'u',
	    '\u1EEF': 'u',
	    '\u1EED': 'u',
	    '\u1EF1': 'u',
	    '\u1EE5': 'u',
	    '\u1E73': 'u',
	    '\u0173': 'u',
	    '\u1E77': 'u',
	    '\u1E75': 'u',
	    '\u0289': 'u',
	    '\u24E5': 'v',
	    '\uFF56': 'v',
	    '\u1E7D': 'v',
	    '\u1E7F': 'v',
	    '\u028B': 'v',
	    '\uA75F': 'v',
	    '\u028C': 'v',
	    '\uA761': 'vy',
	    '\u24E6': 'w',
	    '\uFF57': 'w',
	    '\u1E81': 'w',
	    '\u1E83': 'w',
	    '\u0175': 'w',
	    '\u1E87': 'w',
	    '\u1E85': 'w',
	    '\u1E98': 'w',
	    '\u1E89': 'w',
	    '\u2C73': 'w',
	    '\u24E7': 'x',
	    '\uFF58': 'x',
	    '\u1E8B': 'x',
	    '\u1E8D': 'x',
	    '\u24E8': 'y',
	    '\uFF59': 'y',
	    '\u1EF3': 'y',
	    '\u00FD': 'y',
	    '\u0177': 'y',
	    '\u1EF9': 'y',
	    '\u0233': 'y',
	    '\u1E8F': 'y',
	    '\u00FF': 'y',
	    '\u1EF7': 'y',
	    '\u1E99': 'y',
	    '\u1EF5': 'y',
	    '\u01B4': 'y',
	    '\u024F': 'y',
	    '\u1EFF': 'y',
	    '\u24E9': 'z',
	    '\uFF5A': 'z',
	    '\u017A': 'z',
	    '\u1E91': 'z',
	    '\u017C': 'z',
	    '\u017E': 'z',
	    '\u1E93': 'z',
	    '\u1E95': 'z',
	    '\u01B6': 'z',
	    '\u0225': 'z',
	    '\u0240': 'z',
	    '\u2C6C': 'z',
	    '\uA763': 'z',
	    '\u0386': '\u0391',
	    '\u0388': '\u0395',
	    '\u0389': '\u0397',
	    '\u038A': '\u0399',
	    '\u03AA': '\u0399',
	    '\u038C': '\u039F',
	    '\u038E': '\u03A5',
	    '\u03AB': '\u03A5',
	    '\u038F': '\u03A9',
	    '\u03AC': '\u03B1',
	    '\u03AD': '\u03B5',
	    '\u03AE': '\u03B7',
	    '\u03AF': '\u03B9',
	    '\u03CA': '\u03B9',
	    '\u0390': '\u03B9',
	    '\u03CC': '\u03BF',
	    '\u03CD': '\u03C5',
	    '\u03CB': '\u03C5',
	    '\u03B0': '\u03C5',
	    '\u03C9': '\u03C9',
	    '\u03C2': '\u03C3'
	  };
	
	  return diacritics;
	});
	
	S2.define('select2/data/base',[
	  '../utils'
	], function (Utils) {
	  function BaseAdapter ($element, options) {
	    BaseAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(BaseAdapter, Utils.Observable);
	
	  BaseAdapter.prototype.current = function (callback) {
	    throw new Error('The `current` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.query = function (params, callback) {
	    throw new Error('The `query` method must be defined in child classes.');
	  };
	
	  BaseAdapter.prototype.bind = function (container, $container) {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.destroy = function () {
	    // Can be implemented in subclasses
	  };
	
	  BaseAdapter.prototype.generateResultId = function (container, data) {
	    var id = container.id + '-result-';
	
	    id += Utils.generateChars(4);
	
	    if (data.id != null) {
	      id += '-' + data.id.toString();
	    } else {
	      id += '-' + Utils.generateChars(4);
	    }
	    return id;
	  };
	
	  return BaseAdapter;
	});
	
	S2.define('select2/data/select',[
	  './base',
	  '../utils',
	  'jquery'
	], function (BaseAdapter, Utils, $) {
	  function SelectAdapter ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    SelectAdapter.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(SelectAdapter, BaseAdapter);
	
	  SelectAdapter.prototype.current = function (callback) {
	    var data = [];
	    var self = this;
	
	    this.$element.find(':selected').each(function () {
	      var $option = $(this);
	
	      var option = self.item($option);
	
	      data.push(option);
	    });
	
	    callback(data);
	  };
	
	  SelectAdapter.prototype.select = function (data) {
	    var self = this;
	
	    data.selected = true;
	
	    // If data.element is a DOM node, use it instead
	    if ($(data.element).is('option')) {
	      data.element.selected = true;
	
	      this.$element.trigger('change');
	
	      return;
	    }
	
	    if (this.$element.prop('multiple')) {
	      this.current(function (currentData) {
	        var val = [];
	
	        data = [data];
	        data.push.apply(data, currentData);
	
	        for (var d = 0; d < data.length; d++) {
	          var id = data[d].id;
	
	          if ($.inArray(id, val) === -1) {
	            val.push(id);
	          }
	        }
	
	        self.$element.val(val);
	        self.$element.trigger('change');
	      });
	    } else {
	      var val = data.id;
	
	      this.$element.val(val);
	      this.$element.trigger('change');
	    }
	  };
	
	  SelectAdapter.prototype.unselect = function (data) {
	    var self = this;
	
	    if (!this.$element.prop('multiple')) {
	      return;
	    }
	
	    data.selected = false;
	
	    if ($(data.element).is('option')) {
	      data.element.selected = false;
	
	      this.$element.trigger('change');
	
	      return;
	    }
	
	    this.current(function (currentData) {
	      var val = [];
	
	      for (var d = 0; d < currentData.length; d++) {
	        var id = currentData[d].id;
	
	        if (id !== data.id && $.inArray(id, val) === -1) {
	          val.push(id);
	        }
	      }
	
	      self.$element.val(val);
	
	      self.$element.trigger('change');
	    });
	  };
	
	  SelectAdapter.prototype.bind = function (container, $container) {
	    var self = this;
	
	    this.container = container;
	
	    container.on('select', function (params) {
	      self.select(params.data);
	    });
	
	    container.on('unselect', function (params) {
	      self.unselect(params.data);
	    });
	  };
	
	  SelectAdapter.prototype.destroy = function () {
	    // Remove anything added to child elements
	    this.$element.find('*').each(function () {
	      // Remove any custom data set by Select2
	      $.removeData(this, 'data');
	    });
	  };
	
	  SelectAdapter.prototype.query = function (params, callback) {
	    var data = [];
	    var self = this;
	
	    var $options = this.$element.children();
	
	    $options.each(function () {
	      var $option = $(this);
	
	      if (!$option.is('option') && !$option.is('optgroup')) {
	        return;
	      }
	
	      var option = self.item($option);
	
	      var matches = self.matches(params, option);
	
	      if (matches !== null) {
	        data.push(matches);
	      }
	    });
	
	    callback({
	      results: data
	    });
	  };
	
	  SelectAdapter.prototype.addOptions = function ($options) {
	    Utils.appendMany(this.$element, $options);
	  };
	
	  SelectAdapter.prototype.option = function (data) {
	    var option;
	
	    if (data.children) {
	      option = document.createElement('optgroup');
	      option.label = data.text;
	    } else {
	      option = document.createElement('option');
	
	      if (option.textContent !== undefined) {
	        option.textContent = data.text;
	      } else {
	        option.innerText = data.text;
	      }
	    }
	
	    if (data.id) {
	      option.value = data.id;
	    }
	
	    if (data.disabled) {
	      option.disabled = true;
	    }
	
	    if (data.selected) {
	      option.selected = true;
	    }
	
	    if (data.title) {
	      option.title = data.title;
	    }
	
	    var $option = $(option);
	
	    var normalizedData = this._normalizeItem(data);
	    normalizedData.element = option;
	
	    // Override the option's data with the combined data
	    $.data(option, 'data', normalizedData);
	
	    return $option;
	  };
	
	  SelectAdapter.prototype.item = function ($option) {
	    var data = {};
	
	    data = $.data($option[0], 'data');
	
	    if (data != null) {
	      return data;
	    }
	
	    if ($option.is('option')) {
	      data = {
	        id: $option.val(),
	        text: $option.text(),
	        disabled: $option.prop('disabled'),
	        selected: $option.prop('selected'),
	        title: $option.prop('title')
	      };
	    } else if ($option.is('optgroup')) {
	      data = {
	        text: $option.prop('label'),
	        children: [],
	        title: $option.prop('title')
	      };
	
	      var $children = $option.children('option');
	      var children = [];
	
	      for (var c = 0; c < $children.length; c++) {
	        var $child = $($children[c]);
	
	        var child = this.item($child);
	
	        children.push(child);
	      }
	
	      data.children = children;
	    }
	
	    data = this._normalizeItem(data);
	    data.element = $option[0];
	
	    $.data($option[0], 'data', data);
	
	    return data;
	  };
	
	  SelectAdapter.prototype._normalizeItem = function (item) {
	    if (!$.isPlainObject(item)) {
	      item = {
	        id: item,
	        text: item
	      };
	    }
	
	    item = $.extend({}, {
	      text: ''
	    }, item);
	
	    var defaults = {
	      selected: false,
	      disabled: false
	    };
	
	    if (item.id != null) {
	      item.id = item.id.toString();
	    }
	
	    if (item.text != null) {
	      item.text = item.text.toString();
	    }
	
	    if (item._resultId == null && item.id && this.container != null) {
	      item._resultId = this.generateResultId(this.container, item);
	    }
	
	    return $.extend({}, defaults, item);
	  };
	
	  SelectAdapter.prototype.matches = function (params, data) {
	    var matcher = this.options.get('matcher');
	
	    return matcher(params, data);
	  };
	
	  return SelectAdapter;
	});
	
	S2.define('select2/data/array',[
	  './select',
	  '../utils',
	  'jquery'
	], function (SelectAdapter, Utils, $) {
	  function ArrayAdapter ($element, options) {
	    var data = options.get('data') || [];
	
	    ArrayAdapter.__super__.constructor.call(this, $element, options);
	
	    this.addOptions(this.convertToOptions(data));
	  }
	
	  Utils.Extend(ArrayAdapter, SelectAdapter);
	
	  ArrayAdapter.prototype.select = function (data) {
	    var $option = this.$element.find('option').filter(function (i, elm) {
	      return elm.value == data.id.toString();
	    });
	
	    if ($option.length === 0) {
	      $option = this.option(data);
	
	      this.addOptions($option);
	    }
	
	    ArrayAdapter.__super__.select.call(this, data);
	  };
	
	  ArrayAdapter.prototype.convertToOptions = function (data) {
	    var self = this;
	
	    var $existing = this.$element.find('option');
	    var existingIds = $existing.map(function () {
	      return self.item($(this)).id;
	    }).get();
	
	    var $options = [];
	
	    // Filter out all items except for the one passed in the argument
	    function onlyItem (item) {
	      return function () {
	        return $(this).val() == item.id;
	      };
	    }
	
	    for (var d = 0; d < data.length; d++) {
	      var item = this._normalizeItem(data[d]);
	
	      // Skip items which were pre-loaded, only merge the data
	      if ($.inArray(item.id, existingIds) >= 0) {
	        var $existingOption = $existing.filter(onlyItem(item));
	
	        var existingData = this.item($existingOption);
	        var newData = $.extend(true, {}, item, existingData);
	
	        var $newOption = this.option(newData);
	
	        $existingOption.replaceWith($newOption);
	
	        continue;
	      }
	
	      var $option = this.option(item);
	
	      if (item.children) {
	        var $children = this.convertToOptions(item.children);
	
	        Utils.appendMany($option, $children);
	      }
	
	      $options.push($option);
	    }
	
	    return $options;
	  };
	
	  return ArrayAdapter;
	});
	
	S2.define('select2/data/ajax',[
	  './array',
	  '../utils',
	  'jquery'
	], function (ArrayAdapter, Utils, $) {
	  function AjaxAdapter ($element, options) {
	    this.ajaxOptions = this._applyDefaults(options.get('ajax'));
	
	    if (this.ajaxOptions.processResults != null) {
	      this.processResults = this.ajaxOptions.processResults;
	    }
	
	    AjaxAdapter.__super__.constructor.call(this, $element, options);
	  }
	
	  Utils.Extend(AjaxAdapter, ArrayAdapter);
	
	  AjaxAdapter.prototype._applyDefaults = function (options) {
	    var defaults = {
	      data: function (params) {
	        return $.extend({}, params, {
	          q: params.term
	        });
	      },
	      transport: function (params, success, failure) {
	        var $request = $.ajax(params);
	
	        $request.then(success);
	        $request.fail(failure);
	
	        return $request;
	      }
	    };
	
	    return $.extend({}, defaults, options, true);
	  };
	
	  AjaxAdapter.prototype.processResults = function (results) {
	    return results;
	  };
	
	  AjaxAdapter.prototype.query = function (params, callback) {
	    var matches = [];
	    var self = this;
	
	    if (this._request != null) {
	      // JSONP requests cannot always be aborted
	      if ($.isFunction(this._request.abort)) {
	        this._request.abort();
	      }
	
	      this._request = null;
	    }
	
	    var options = $.extend({
	      type: 'GET'
	    }, this.ajaxOptions);
	
	    if (typeof options.url === 'function') {
	      options.url = options.url.call(this.$element, params);
	    }
	
	    if (typeof options.data === 'function') {
	      options.data = options.data.call(this.$element, params);
	    }
	
	    function request () {
	      var $request = options.transport(options, function (data) {
	        var results = self.processResults(data, params);
	
	        if (self.options.get('debug') && window.console && console.error) {
	          // Check to make sure that the response included a `results` key.
	          if (!results || !results.results || !$.isArray(results.results)) {
	            console.error(
	              'Select2: The AJAX results did not return an array in the ' +
	              '`results` key of the response.'
	            );
	          }
	        }
	
	        callback(results);
	      }, function () {
	        // Attempt to detect if a request was aborted
	        // Only works if the transport exposes a status property
	        if ($request.status && $request.status === '0') {
	          return;
	        }
	
	        self.trigger('results:message', {
	          message: 'errorLoading'
	        });
	      });
	
	      self._request = $request;
	    }
	
	    if (this.ajaxOptions.delay && params.term != null) {
	      if (this._queryTimeout) {
	        window.clearTimeout(this._queryTimeout);
	      }
	
	      this._queryTimeout = window.setTimeout(request, this.ajaxOptions.delay);
	    } else {
	      request();
	    }
	  };
	
	  return AjaxAdapter;
	});
	
	S2.define('select2/data/tags',[
	  'jquery'
	], function ($) {
	  function Tags (decorated, $element, options) {
	    var tags = options.get('tags');
	
	    var createTag = options.get('createTag');
	
	    if (createTag !== undefined) {
	      this.createTag = createTag;
	    }
	
	    var insertTag = options.get('insertTag');
	
	    if (insertTag !== undefined) {
	        this.insertTag = insertTag;
	    }
	
	    decorated.call(this, $element, options);
	
	    if ($.isArray(tags)) {
	      for (var t = 0; t < tags.length; t++) {
	        var tag = tags[t];
	        var item = this._normalizeItem(tag);
	
	        var $option = this.option(item);
	
	        this.$element.append($option);
	      }
	    }
	  }
	
	  Tags.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    this._removeOldTags();
	
	    if (params.term == null || params.page != null) {
	      decorated.call(this, params, callback);
	      return;
	    }
	
	    function wrapper (obj, child) {
	      var data = obj.results;
	
	      for (var i = 0; i < data.length; i++) {
	        var option = data[i];
	
	        var checkChildren = (
	          option.children != null &&
	          !wrapper({
	            results: option.children
	          }, true)
	        );
	
	        var checkText = option.text === params.term;
	
	        if (checkText || checkChildren) {
	          if (child) {
	            return false;
	          }
	
	          obj.data = data;
	          callback(obj);
	
	          return;
	        }
	      }
	
	      if (child) {
	        return true;
	      }
	
	      var tag = self.createTag(params);
	
	      if (tag != null) {
	        var $option = self.option(tag);
	        $option.attr('data-select2-tag', true);
	
	        self.addOptions([$option]);
	
	        self.insertTag(data, tag);
	      }
	
	      obj.results = data;
	
	      callback(obj);
	    }
	
	    decorated.call(this, params, wrapper);
	  };
	
	  Tags.prototype.createTag = function (decorated, params) {
	    var term = $.trim(params.term);
	
	    if (term === '') {
	      return null;
	    }
	
	    return {
	      id: term,
	      text: term
	    };
	  };
	
	  Tags.prototype.insertTag = function (_, data, tag) {
	    data.unshift(tag);
	  };
	
	  Tags.prototype._removeOldTags = function (_) {
	    var tag = this._lastTag;
	
	    var $options = this.$element.find('option[data-select2-tag]');
	
	    $options.each(function () {
	      if (this.selected) {
	        return;
	      }
	
	      $(this).remove();
	    });
	  };
	
	  return Tags;
	});
	
	S2.define('select2/data/tokenizer',[
	  'jquery'
	], function ($) {
	  function Tokenizer (decorated, $element, options) {
	    var tokenizer = options.get('tokenizer');
	
	    if (tokenizer !== undefined) {
	      this.tokenizer = tokenizer;
	    }
	
	    decorated.call(this, $element, options);
	  }
	
	  Tokenizer.prototype.bind = function (decorated, container, $container) {
	    decorated.call(this, container, $container);
	
	    this.$search =  container.dropdown.$search || container.selection.$search ||
	      $container.find('.select2-search__field');
	  };
	
	  Tokenizer.prototype.query = function (decorated, params, callback) {
	    var self = this;
	
	    function createAndSelect (data) {
	      // Normalize the data object so we can use it for checks
	      var item = self._normalizeItem(data);
	
	      // Check if the data object already exists as a tag
	      // Select it if it doesn't
	      var $existingOptions = self.$element.find('option').filter(function () {
	        return $(this).val() === item.id;
	      });
	
	      // If an existing option wasn't found for it, create the option
	      if (!$existingOptions.length) {
	        var $option = self.option(item);
	        $option.attr('data-select2-tag', true);
	
	        self._removeOldTags();
	        self.addOptions([$option]);
	      }
	
	      // Select the item, now that we know there is an option for it
	      select(item);
	    }
	
	    function select (data) {
	      self.trigger('select', {
	        data: data
	      });
	    }
	
	    params.term = params.term || '';
	
	    var tokenData = this.tokenizer(params, this.options, createAndSelect);
	
	    if (tokenData.term !== params.term) {
	      // Replace the search term if we have the search box
	      if (this.$search.length) {
	        this.$search.val(tokenData.term);
	        this.$search.focus();
	      }
	
	      params.term = tokenData.term;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  Tokenizer.prototype.tokenizer = function (_, params, options, callback) {
	    var separators = options.get('tokenSeparators') || [];
	    var term = params.term;
	    var i = 0;
	
	    var createTag = this.createTag || function (params) {
	      return {
	        id: params.term,
	        text: params.term
	      };
	    };
	
	    while (i < term.length) {
	      var termChar = term[i];
	
	      if ($.inArray(termChar, separators) === -1) {
	        i++;
	
	        continue;
	      }
	
	      var part = term.substr(0, i);
	      var partParams = $.extend({}, params, {
	        term: part
	      });
	
	      var data = createTag(partParams);
	
	      if (data == null) {
	        i++;
	        continue;
	      }
	
	      callback(data);
	
	      // Reset the term to not include the tokenized portion
	      term = term.substr(i + 1) || '';
	      i = 0;
	    }
	
	    return {
	      term: term
	    };
	  };
	
	  return Tokenizer;
	});
	
	S2.define('select2/data/minimumInputLength',[
	
	], function () {
	  function MinimumInputLength (decorated, $e, options) {
	    this.minimumInputLength = options.get('minimumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MinimumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (params.term.length < this.minimumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooShort',
	        args: {
	          minimum: this.minimumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MinimumInputLength;
	});
	
	S2.define('select2/data/maximumInputLength',[
	
	], function () {
	  function MaximumInputLength (decorated, $e, options) {
	    this.maximumInputLength = options.get('maximumInputLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumInputLength.prototype.query = function (decorated, params, callback) {
	    params.term = params.term || '';
	
	    if (this.maximumInputLength > 0 &&
	        params.term.length > this.maximumInputLength) {
	      this.trigger('results:message', {
	        message: 'inputTooLong',
	        args: {
	          maximum: this.maximumInputLength,
	          input: params.term,
	          params: params
	        }
	      });
	
	      return;
	    }
	
	    decorated.call(this, params, callback);
	  };
	
	  return MaximumInputLength;
	});
	
	S2.define('select2/data/maximumSelectionLength',[
	
	], function (){
	  function MaximumSelectionLength (decorated, $e, options) {
	    this.maximumSelectionLength = options.get('maximumSelectionLength');
	
	    decorated.call(this, $e, options);
	  }
	
	  MaximumSelectionLength.prototype.query =
	    function (decorated, params, callback) {
	      var self = this;
	
	      this.current(function (currentData) {
	        var count = currentData != null ? currentData.length : 0;
	        if (self.maximumSelectionLength > 0 &&
	          count >= self.maximumSelectionLength) {
	          self.trigger('results:message', {
	            message: 'maximumSelected',
	            args: {
	              maximum: self.maximumSelectionLength
	            }
	          });
	          return;
	        }
	        decorated.call(self, params, callback);
	      });
	  };
	
	  return MaximumSelectionLength;
	});
	
	S2.define('select2/dropdown',[
	  'jquery',
	  './utils'
	], function ($, Utils) {
	  function Dropdown ($element, options) {
	    this.$element = $element;
	    this.options = options;
	
	    Dropdown.__super__.constructor.call(this);
	  }
	
	  Utils.Extend(Dropdown, Utils.Observable);
	
	  Dropdown.prototype.render = function () {
	    var $dropdown = $(
	      '<span class="select2-dropdown">' +
	        '<span class="select2-results"></span>' +
	      '</span>'
	    );
	
	    $dropdown.attr('dir', this.options.get('dir'));
	
	    this.$dropdown = $dropdown;
	
	    return $dropdown;
	  };
	
	  Dropdown.prototype.bind = function () {
	    // Should be implemented in subclasses
	  };
	
	  Dropdown.prototype.position = function ($dropdown, $container) {
	    // Should be implmented in subclasses
	  };
	
	  Dropdown.prototype.destroy = function () {
	    // Remove the dropdown from the DOM
	    this.$dropdown.remove();
	  };
	
	  return Dropdown;
	});
	
	S2.define('select2/dropdown/search',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function Search () { }
	
	  Search.prototype.render = function (decorated) {
	    var $rendered = decorated.call(this);
	
	    var $search = $(
	      '<span class="select2-search select2-search--dropdown">' +
	        '<input class="select2-search__field" type="search" tabindex="-1"' +
	        ' autocomplete="off" autocorrect="off" autocapitalize="off"' +
	        ' spellcheck="false" role="textbox" />' +
	      '</span>'
	    );
	
	    this.$searchContainer = $search;
	    this.$search = $search.find('input');
	
	    $rendered.prepend($search);
	
	    return $rendered;
	  };
	
	  Search.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    this.$search.on('keydown', function (evt) {
	      self.trigger('keypress', evt);
	
	      self._keyUpPrevented = evt.isDefaultPrevented();
	    });
	
	    // Workaround for browsers which do not support the `input` event
	    // This will prevent double-triggering of events for browsers which support
	    // both the `keyup` and `input` events.
	    this.$search.on('input', function (evt) {
	      // Unbind the duplicated `keyup` event
	      $(this).off('keyup');
	    });
	
	    this.$search.on('keyup input', function (evt) {
	      self.handleSearch(evt);
	    });
	
	    container.on('open', function () {
	      self.$search.attr('tabindex', 0);
	
	      self.$search.focus();
	
	      window.setTimeout(function () {
	        self.$search.focus();
	      }, 0);
	    });
	
	    container.on('close', function () {
	      self.$search.attr('tabindex', -1);
	
	      self.$search.val('');
	    });
	
	    container.on('focus', function () {
	      if (container.isOpen()) {
	        self.$search.focus();
	      }
	    });
	
	    container.on('results:all', function (params) {
	      if (params.query.term == null || params.query.term === '') {
	        var showSearch = self.showSearch(params);
	
	        if (showSearch) {
	          self.$searchContainer.removeClass('select2-search--hide');
	        } else {
	          self.$searchContainer.addClass('select2-search--hide');
	        }
	      }
	    });
	  };
	
	  Search.prototype.handleSearch = function (evt) {
	    if (!this._keyUpPrevented) {
	      var input = this.$search.val();
	
	      this.trigger('query', {
	        term: input
	      });
	    }
	
	    this._keyUpPrevented = false;
	  };
	
	  Search.prototype.showSearch = function (_, params) {
	    return true;
	  };
	
	  return Search;
	});
	
	S2.define('select2/dropdown/hidePlaceholder',[
	
	], function () {
	  function HidePlaceholder (decorated, $element, options, dataAdapter) {
	    this.placeholder = this.normalizePlaceholder(options.get('placeholder'));
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  HidePlaceholder.prototype.append = function (decorated, data) {
	    data.results = this.removePlaceholder(data.results);
	
	    decorated.call(this, data);
	  };
	
	  HidePlaceholder.prototype.normalizePlaceholder = function (_, placeholder) {
	    if (typeof placeholder === 'string') {
	      placeholder = {
	        id: '',
	        text: placeholder
	      };
	    }
	
	    return placeholder;
	  };
	
	  HidePlaceholder.prototype.removePlaceholder = function (_, data) {
	    var modifiedData = data.slice(0);
	
	    for (var d = data.length - 1; d >= 0; d--) {
	      var item = data[d];
	
	      if (this.placeholder.id === item.id) {
	        modifiedData.splice(d, 1);
	      }
	    }
	
	    return modifiedData;
	  };
	
	  return HidePlaceholder;
	});
	
	S2.define('select2/dropdown/infiniteScroll',[
	  'jquery'
	], function ($) {
	  function InfiniteScroll (decorated, $element, options, dataAdapter) {
	    this.lastParams = {};
	
	    decorated.call(this, $element, options, dataAdapter);
	
	    this.$loadingMore = this.createLoadingMore();
	    this.loading = false;
	  }
	
	  InfiniteScroll.prototype.append = function (decorated, data) {
	    this.$loadingMore.remove();
	    this.loading = false;
	
	    decorated.call(this, data);
	
	    if (this.showLoadingMore(data)) {
	      this.$results.append(this.$loadingMore);
	    }
	  };
	
	  InfiniteScroll.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('query', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    container.on('query:append', function (params) {
	      self.lastParams = params;
	      self.loading = true;
	    });
	
	    this.$results.on('scroll', function () {
	      var isLoadMoreVisible = $.contains(
	        document.documentElement,
	        self.$loadingMore[0]
	      );
	
	      if (self.loading || !isLoadMoreVisible) {
	        return;
	      }
	
	      var currentOffset = self.$results.offset().top +
	        self.$results.outerHeight(false);
	      var loadingMoreOffset = self.$loadingMore.offset().top +
	        self.$loadingMore.outerHeight(false);
	
	      if (currentOffset + 50 >= loadingMoreOffset) {
	        self.loadMore();
	      }
	    });
	  };
	
	  InfiniteScroll.prototype.loadMore = function () {
	    this.loading = true;
	
	    var params = $.extend({}, {page: 1}, this.lastParams);
	
	    params.page++;
	
	    this.trigger('query:append', params);
	  };
	
	  InfiniteScroll.prototype.showLoadingMore = function (_, data) {
	    return data.pagination && data.pagination.more;
	  };
	
	  InfiniteScroll.prototype.createLoadingMore = function () {
	    var $option = $(
	      '<li ' +
	      'class="select2-results__option select2-results__option--load-more"' +
	      'role="treeitem" aria-disabled="true"></li>'
	    );
	
	    var message = this.options.get('translations').get('loadingMore');
	
	    $option.html(message(this.lastParams));
	
	    return $option;
	  };
	
	  return InfiniteScroll;
	});
	
	S2.define('select2/dropdown/attachBody',[
	  'jquery',
	  '../utils'
	], function ($, Utils) {
	  function AttachBody (decorated, $element, options) {
	    this.$dropdownParent = options.get('dropdownParent') || $(document.body);
	
	    decorated.call(this, $element, options);
	  }
	
	  AttachBody.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    var setupResultsEvents = false;
	
	    decorated.call(this, container, $container);
	
	    container.on('open', function () {
	      self._showDropdown();
	      self._attachPositioningHandler(container);
	
	      if (!setupResultsEvents) {
	        setupResultsEvents = true;
	
	        container.on('results:all', function () {
	          self._positionDropdown();
	          self._resizeDropdown();
	        });
	
	        container.on('results:append', function () {
	          self._positionDropdown();
	          self._resizeDropdown();
	        });
	      }
	    });
	
	    container.on('close', function () {
	      self._hideDropdown();
	      self._detachPositioningHandler(container);
	    });
	
	    this.$dropdownContainer.on('mousedown', function (evt) {
	      evt.stopPropagation();
	    });
	  };
	
	  AttachBody.prototype.destroy = function (decorated) {
	    decorated.call(this);
	
	    this.$dropdownContainer.remove();
	  };
	
	  AttachBody.prototype.position = function (decorated, $dropdown, $container) {
	    // Clone all of the container classes
	    $dropdown.attr('class', $container.attr('class'));
	
	    $dropdown.removeClass('select2');
	    $dropdown.addClass('select2-container--open');
	
	    $dropdown.css({
	      position: 'absolute',
	      top: -999999
	    });
	
	    this.$container = $container;
	  };
	
	  AttachBody.prototype.render = function (decorated) {
	    var $container = $('<span></span>');
	
	    var $dropdown = decorated.call(this);
	    $container.append($dropdown);
	
	    this.$dropdownContainer = $container;
	
	    return $container;
	  };
	
	  AttachBody.prototype._hideDropdown = function (decorated) {
	    this.$dropdownContainer.detach();
	  };
	
	  AttachBody.prototype._attachPositioningHandler =
	      function (decorated, container) {
	    var self = this;
	
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.each(function () {
	      $(this).data('select2-scroll-position', {
	        x: $(this).scrollLeft(),
	        y: $(this).scrollTop()
	      });
	    });
	
	    $watchers.on(scrollEvent, function (ev) {
	      var position = $(this).data('select2-scroll-position');
	      $(this).scrollTop(position.y);
	    });
	
	    $(window).on(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent,
	      function (e) {
	      self._positionDropdown();
	      self._resizeDropdown();
	    });
	  };
	
	  AttachBody.prototype._detachPositioningHandler =
	      function (decorated, container) {
	    var scrollEvent = 'scroll.select2.' + container.id;
	    var resizeEvent = 'resize.select2.' + container.id;
	    var orientationEvent = 'orientationchange.select2.' + container.id;
	
	    var $watchers = this.$container.parents().filter(Utils.hasScroll);
	    $watchers.off(scrollEvent);
	
	    $(window).off(scrollEvent + ' ' + resizeEvent + ' ' + orientationEvent);
	  };
	
	  AttachBody.prototype._positionDropdown = function () {
	    var $window = $(window);
	
	    var isCurrentlyAbove = this.$dropdown.hasClass('select2-dropdown--above');
	    var isCurrentlyBelow = this.$dropdown.hasClass('select2-dropdown--below');
	
	    var newDirection = null;
	
	    var offset = this.$container.offset();
	
	    offset.bottom = offset.top + this.$container.outerHeight(false);
	
	    var container = {
	      height: this.$container.outerHeight(false)
	    };
	
	    container.top = offset.top;
	    container.bottom = offset.top + container.height;
	
	    var dropdown = {
	      height: this.$dropdown.outerHeight(false)
	    };
	
	    var viewport = {
	      top: $window.scrollTop(),
	      bottom: $window.scrollTop() + $window.height()
	    };
	
	    var enoughRoomAbove = viewport.top < (offset.top - dropdown.height);
	    var enoughRoomBelow = viewport.bottom > (offset.bottom + dropdown.height);
	
	    var css = {
	      left: offset.left,
	      top: container.bottom
	    };
	
	    // Determine what the parent element is to use for calciulating the offset
	    var $offsetParent = this.$dropdownParent;
	
	    // For statically positoned elements, we need to get the element
	    // that is determining the offset
	    if ($offsetParent.css('position') === 'static') {
	      $offsetParent = $offsetParent.offsetParent();
	    }
	
	    var parentOffset = $offsetParent.offset();
	
	    css.top -= parentOffset.top;
	    css.left -= parentOffset.left;
	
	    if (!isCurrentlyAbove && !isCurrentlyBelow) {
	      newDirection = 'below';
	    }
	
	    if (!enoughRoomBelow && enoughRoomAbove && !isCurrentlyAbove) {
	      newDirection = 'above';
	    } else if (!enoughRoomAbove && enoughRoomBelow && isCurrentlyAbove) {
	      newDirection = 'below';
	    }
	
	    if (newDirection == 'above' ||
	      (isCurrentlyAbove && newDirection !== 'below')) {
	      css.top = container.top - parentOffset.top - dropdown.height;
	    }
	
	    if (newDirection != null) {
	      this.$dropdown
	        .removeClass('select2-dropdown--below select2-dropdown--above')
	        .addClass('select2-dropdown--' + newDirection);
	      this.$container
	        .removeClass('select2-container--below select2-container--above')
	        .addClass('select2-container--' + newDirection);
	    }
	
	    this.$dropdownContainer.css(css);
	  };
	
	  AttachBody.prototype._resizeDropdown = function () {
	    var css = {
	      width: this.$container.outerWidth(false) + 'px'
	    };
	
	    if (this.options.get('dropdownAutoWidth')) {
	      css.minWidth = css.width;
	      css.position = 'relative';
	      css.width = 'auto';
	    }
	
	    this.$dropdown.css(css);
	  };
	
	  AttachBody.prototype._showDropdown = function (decorated) {
	    this.$dropdownContainer.appendTo(this.$dropdownParent);
	
	    this._positionDropdown();
	    this._resizeDropdown();
	  };
	
	  return AttachBody;
	});
	
	S2.define('select2/dropdown/minimumResultsForSearch',[
	
	], function () {
	  function countResults (data) {
	    var count = 0;
	
	    for (var d = 0; d < data.length; d++) {
	      var item = data[d];
	
	      if (item.children) {
	        count += countResults(item.children);
	      } else {
	        count++;
	      }
	    }
	
	    return count;
	  }
	
	  function MinimumResultsForSearch (decorated, $element, options, dataAdapter) {
	    this.minimumResultsForSearch = options.get('minimumResultsForSearch');
	
	    if (this.minimumResultsForSearch < 0) {
	      this.minimumResultsForSearch = Infinity;
	    }
	
	    decorated.call(this, $element, options, dataAdapter);
	  }
	
	  MinimumResultsForSearch.prototype.showSearch = function (decorated, params) {
	    if (countResults(params.data.results) < this.minimumResultsForSearch) {
	      return false;
	    }
	
	    return decorated.call(this, params);
	  };
	
	  return MinimumResultsForSearch;
	});
	
	S2.define('select2/dropdown/selectOnClose',[
	
	], function () {
	  function SelectOnClose () { }
	
	  SelectOnClose.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('close', function (params) {
	      self._handleSelectOnClose(params);
	    });
	  };
	
	  SelectOnClose.prototype._handleSelectOnClose = function (_, params) {
	    if (params && params.originalSelect2Event != null) {
	      var event = params.originalSelect2Event;
	
	      // Don't select an item if the close event was triggered from a select or
	      // unselect event
	      if (event._type === 'select' || event._type === 'unselect') {
	        return;
	      }
	    }
	
	    var $highlightedResults = this.getHighlightedResults();
	
	    // Only select highlighted results
	    if ($highlightedResults.length < 1) {
	      return;
	    }
	
	    var data = $highlightedResults.data('data');
	
	    // Don't re-select already selected resulte
	    if (
	      (data.element != null && data.element.selected) ||
	      (data.element == null && data.selected)
	    ) {
	      return;
	    }
	
	    this.trigger('select', {
	        data: data
	    });
	  };
	
	  return SelectOnClose;
	});
	
	S2.define('select2/dropdown/closeOnSelect',[
	
	], function () {
	  function CloseOnSelect () { }
	
	  CloseOnSelect.prototype.bind = function (decorated, container, $container) {
	    var self = this;
	
	    decorated.call(this, container, $container);
	
	    container.on('select', function (evt) {
	      self._selectTriggered(evt);
	    });
	
	    container.on('unselect', function (evt) {
	      self._selectTriggered(evt);
	    });
	  };
	
	  CloseOnSelect.prototype._selectTriggered = function (_, evt) {
	    var originalEvent = evt.originalEvent;
	
	    // Don't close if the control key is being held
	    if (originalEvent && originalEvent.ctrlKey) {
	      return;
	    }
	
	    this.trigger('close', {
	      originalEvent: originalEvent,
	      originalSelect2Event: evt
	    });
	  };
	
	  return CloseOnSelect;
	});
	
	S2.define('select2/i18n/en',[],function () {
	  // English
	  return {
	    errorLoading: function () {
	      return 'The results could not be loaded.';
	    },
	    inputTooLong: function (args) {
	      var overChars = args.input.length - args.maximum;
	
	      var message = 'Please delete ' + overChars + ' character';
	
	      if (overChars != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    inputTooShort: function (args) {
	      var remainingChars = args.minimum - args.input.length;
	
	      var message = 'Please enter ' + remainingChars + ' or more characters';
	
	      return message;
	    },
	    loadingMore: function () {
	      return 'Loading more results…';
	    },
	    maximumSelected: function (args) {
	      var message = 'You can only select ' + args.maximum + ' item';
	
	      if (args.maximum != 1) {
	        message += 's';
	      }
	
	      return message;
	    },
	    noResults: function () {
	      return 'No results found';
	    },
	    searching: function () {
	      return 'Searching…';
	    }
	  };
	});
	
	S2.define('select2/defaults',[
	  'jquery',
	  'require',
	
	  './results',
	
	  './selection/single',
	  './selection/multiple',
	  './selection/placeholder',
	  './selection/allowClear',
	  './selection/search',
	  './selection/eventRelay',
	
	  './utils',
	  './translation',
	  './diacritics',
	
	  './data/select',
	  './data/array',
	  './data/ajax',
	  './data/tags',
	  './data/tokenizer',
	  './data/minimumInputLength',
	  './data/maximumInputLength',
	  './data/maximumSelectionLength',
	
	  './dropdown',
	  './dropdown/search',
	  './dropdown/hidePlaceholder',
	  './dropdown/infiniteScroll',
	  './dropdown/attachBody',
	  './dropdown/minimumResultsForSearch',
	  './dropdown/selectOnClose',
	  './dropdown/closeOnSelect',
	
	  './i18n/en'
	], function ($, require,
	
	             ResultsList,
	
	             SingleSelection, MultipleSelection, Placeholder, AllowClear,
	             SelectionSearch, EventRelay,
	
	             Utils, Translation, DIACRITICS,
	
	             SelectData, ArrayData, AjaxData, Tags, Tokenizer,
	             MinimumInputLength, MaximumInputLength, MaximumSelectionLength,
	
	             Dropdown, DropdownSearch, HidePlaceholder, InfiniteScroll,
	             AttachBody, MinimumResultsForSearch, SelectOnClose, CloseOnSelect,
	
	             EnglishTranslation) {
	  function Defaults () {
	    this.reset();
	  }
	
	  Defaults.prototype.apply = function (options) {
	    options = $.extend(true, {}, this.defaults, options);
	
	    if (options.dataAdapter == null) {
	      if (options.ajax != null) {
	        options.dataAdapter = AjaxData;
	      } else if (options.data != null) {
	        options.dataAdapter = ArrayData;
	      } else {
	        options.dataAdapter = SelectData;
	      }
	
	      if (options.minimumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MinimumInputLength
	        );
	      }
	
	      if (options.maximumInputLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumInputLength
	        );
	      }
	
	      if (options.maximumSelectionLength > 0) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          MaximumSelectionLength
	        );
	      }
	
	      if (options.tags) {
	        options.dataAdapter = Utils.Decorate(options.dataAdapter, Tags);
	      }
	
	      if (options.tokenSeparators != null || options.tokenizer != null) {
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Tokenizer
	        );
	      }
	
	      if (options.query != null) {
	        var Query = require(options.amdBase + 'compat/query');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          Query
	        );
	      }
	
	      if (options.initSelection != null) {
	        var InitSelection = require(options.amdBase + 'compat/initSelection');
	
	        options.dataAdapter = Utils.Decorate(
	          options.dataAdapter,
	          InitSelection
	        );
	      }
	    }
	
	    if (options.resultsAdapter == null) {
	      options.resultsAdapter = ResultsList;
	
	      if (options.ajax != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          InfiniteScroll
	        );
	      }
	
	      if (options.placeholder != null) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          HidePlaceholder
	        );
	      }
	
	      if (options.selectOnClose) {
	        options.resultsAdapter = Utils.Decorate(
	          options.resultsAdapter,
	          SelectOnClose
	        );
	      }
	    }
	
	    if (options.dropdownAdapter == null) {
	      if (options.multiple) {
	        options.dropdownAdapter = Dropdown;
	      } else {
	        var SearchableDropdown = Utils.Decorate(Dropdown, DropdownSearch);
	
	        options.dropdownAdapter = SearchableDropdown;
	      }
	
	      if (options.minimumResultsForSearch !== 0) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          MinimumResultsForSearch
	        );
	      }
	
	      if (options.closeOnSelect) {
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          CloseOnSelect
	        );
	      }
	
	      if (
	        options.dropdownCssClass != null ||
	        options.dropdownCss != null ||
	        options.adaptDropdownCssClass != null
	      ) {
	        var DropdownCSS = require(options.amdBase + 'compat/dropdownCss');
	
	        options.dropdownAdapter = Utils.Decorate(
	          options.dropdownAdapter,
	          DropdownCSS
	        );
	      }
	
	      options.dropdownAdapter = Utils.Decorate(
	        options.dropdownAdapter,
	        AttachBody
	      );
	    }
	
	    if (options.selectionAdapter == null) {
	      if (options.multiple) {
	        options.selectionAdapter = MultipleSelection;
	      } else {
	        options.selectionAdapter = SingleSelection;
	      }
	
	      // Add the placeholder mixin if a placeholder was specified
	      if (options.placeholder != null) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          Placeholder
	        );
	      }
	
	      if (options.allowClear) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          AllowClear
	        );
	      }
	
	      if (options.multiple) {
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          SelectionSearch
	        );
	      }
	
	      if (
	        options.containerCssClass != null ||
	        options.containerCss != null ||
	        options.adaptContainerCssClass != null
	      ) {
	        var ContainerCSS = require(options.amdBase + 'compat/containerCss');
	
	        options.selectionAdapter = Utils.Decorate(
	          options.selectionAdapter,
	          ContainerCSS
	        );
	      }
	
	      options.selectionAdapter = Utils.Decorate(
	        options.selectionAdapter,
	        EventRelay
	      );
	    }
	
	    if (typeof options.language === 'string') {
	      // Check if the language is specified with a region
	      if (options.language.indexOf('-') > 0) {
	        // Extract the region information if it is included
	        var languageParts = options.language.split('-');
	        var baseLanguage = languageParts[0];
	
	        options.language = [options.language, baseLanguage];
	      } else {
	        options.language = [options.language];
	      }
	    }
	
	    if ($.isArray(options.language)) {
	      var languages = new Translation();
	      options.language.push('en');
	
	      var languageNames = options.language;
	
	      for (var l = 0; l < languageNames.length; l++) {
	        var name = languageNames[l];
	        var language = {};
	
	        try {
	          // Try to load it with the original name
	          language = Translation.loadPath(name);
	        } catch (e) {
	          try {
	            // If we couldn't load it, check if it wasn't the full path
	            name = this.defaults.amdLanguageBase + name;
	            language = Translation.loadPath(name);
	          } catch (ex) {
	            // The translation could not be loaded at all. Sometimes this is
	            // because of a configuration problem, other times this can be
	            // because of how Select2 helps load all possible translation files.
	            if (options.debug && window.console && console.warn) {
	              console.warn(
	                'Select2: The language file for "' + name + '" could not be ' +
	                'automatically loaded. A fallback will be used instead.'
	              );
	            }
	
	            continue;
	          }
	        }
	
	        languages.extend(language);
	      }
	
	      options.translations = languages;
	    } else {
	      var baseTranslation = Translation.loadPath(
	        this.defaults.amdLanguageBase + 'en'
	      );
	      var customTranslation = new Translation(options.language);
	
	      customTranslation.extend(baseTranslation);
	
	      options.translations = customTranslation;
	    }
	
	    return options;
	  };
	
	  Defaults.prototype.reset = function () {
	    function stripDiacritics (text) {
	      // Used 'uni range + named function' from http://jsperf.com/diacritics/18
	      function match(a) {
	        return DIACRITICS[a] || a;
	      }
	
	      return text.replace(/[^\u0000-\u007E]/g, match);
	    }
	
	    function matcher (params, data) {
	      // Always return the object if there is nothing to compare
	      if ($.trim(params.term) === '') {
	        return data;
	      }
	
	      // Do a recursive check for options with children
	      if (data.children && data.children.length > 0) {
	        // Clone the data object if there are children
	        // This is required as we modify the object to remove any non-matches
	        var match = $.extend(true, {}, data);
	
	        // Check each child of the option
	        for (var c = data.children.length - 1; c >= 0; c--) {
	          var child = data.children[c];
	
	          var matches = matcher(params, child);
	
	          // If there wasn't a match, remove the object in the array
	          if (matches == null) {
	            match.children.splice(c, 1);
	          }
	        }
	
	        // If any children matched, return the new object
	        if (match.children.length > 0) {
	          return match;
	        }
	
	        // If there were no matching children, check just the plain object
	        return matcher(params, match);
	      }
	
	      var original = stripDiacritics(data.text).toUpperCase();
	      var term = stripDiacritics(params.term).toUpperCase();
	
	      // Check if the text contains the term
	      if (original.indexOf(term) > -1) {
	        return data;
	      }
	
	      // If it doesn't contain the term, don't return anything
	      return null;
	    }
	
	    this.defaults = {
	      amdBase: './',
	      amdLanguageBase: './i18n/',
	      closeOnSelect: true,
	      debug: false,
	      dropdownAutoWidth: false,
	      escapeMarkup: Utils.escapeMarkup,
	      language: EnglishTranslation,
	      matcher: matcher,
	      minimumInputLength: 0,
	      maximumInputLength: 0,
	      maximumSelectionLength: 0,
	      minimumResultsForSearch: 0,
	      selectOnClose: false,
	      sorter: function (data) {
	        return data;
	      },
	      templateResult: function (result) {
	        return result.text;
	      },
	      templateSelection: function (selection) {
	        return selection.text;
	      },
	      theme: 'default',
	      width: 'resolve'
	    };
	  };
	
	  Defaults.prototype.set = function (key, value) {
	    var camelKey = $.camelCase(key);
	
	    var data = {};
	    data[camelKey] = value;
	
	    var convertedData = Utils._convertData(data);
	
	    $.extend(this.defaults, convertedData);
	  };
	
	  var defaults = new Defaults();
	
	  return defaults;
	});
	
	S2.define('select2/options',[
	  'require',
	  'jquery',
	  './defaults',
	  './utils'
	], function (require, $, Defaults, Utils) {
	  function Options (options, $element) {
	    this.options = options;
	
	    if ($element != null) {
	      this.fromElement($element);
	    }
	
	    this.options = Defaults.apply(this.options);
	
	    if ($element && $element.is('input')) {
	      var InputCompat = require(this.get('amdBase') + 'compat/inputData');
	
	      this.options.dataAdapter = Utils.Decorate(
	        this.options.dataAdapter,
	        InputCompat
	      );
	    }
	  }
	
	  Options.prototype.fromElement = function ($e) {
	    var excludedData = ['select2'];
	
	    if (this.options.multiple == null) {
	      this.options.multiple = $e.prop('multiple');
	    }
	
	    if (this.options.disabled == null) {
	      this.options.disabled = $e.prop('disabled');
	    }
	
	    if (this.options.language == null) {
	      if ($e.prop('lang')) {
	        this.options.language = $e.prop('lang').toLowerCase();
	      } else if ($e.closest('[lang]').prop('lang')) {
	        this.options.language = $e.closest('[lang]').prop('lang');
	      }
	    }
	
	    if (this.options.dir == null) {
	      if ($e.prop('dir')) {
	        this.options.dir = $e.prop('dir');
	      } else if ($e.closest('[dir]').prop('dir')) {
	        this.options.dir = $e.closest('[dir]').prop('dir');
	      } else {
	        this.options.dir = 'ltr';
	      }
	    }
	
	    $e.prop('disabled', this.options.disabled);
	    $e.prop('multiple', this.options.multiple);
	
	    if ($e.data('select2Tags')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-select2-tags` attribute has been changed to ' +
	          'use the `data-data` and `data-tags="true"` attributes and will be ' +
	          'removed in future versions of Select2.'
	        );
	      }
	
	      $e.data('data', $e.data('select2Tags'));
	      $e.data('tags', true);
	    }
	
	    if ($e.data('ajaxUrl')) {
	      if (this.options.debug && window.console && console.warn) {
	        console.warn(
	          'Select2: The `data-ajax-url` attribute has been changed to ' +
	          '`data-ajax--url` and support for the old attribute will be removed' +
	          ' in future versions of Select2.'
	        );
	      }
	
	      $e.attr('ajax--url', $e.data('ajaxUrl'));
	      $e.data('ajax--url', $e.data('ajaxUrl'));
	    }
	
	    var dataset = {};
	
	    // Prefer the element's `dataset` attribute if it exists
	    // jQuery 1.x does not correctly handle data attributes with multiple dashes
	    if ($.fn.jquery && $.fn.jquery.substr(0, 2) == '1.' && $e[0].dataset) {
	      dataset = $.extend(true, {}, $e[0].dataset, $e.data());
	    } else {
	      dataset = $e.data();
	    }
	
	    var data = $.extend(true, {}, dataset);
	
	    data = Utils._convertData(data);
	
	    for (var key in data) {
	      if ($.inArray(key, excludedData) > -1) {
	        continue;
	      }
	
	      if ($.isPlainObject(this.options[key])) {
	        $.extend(this.options[key], data[key]);
	      } else {
	        this.options[key] = data[key];
	      }
	    }
	
	    return this;
	  };
	
	  Options.prototype.get = function (key) {
	    return this.options[key];
	  };
	
	  Options.prototype.set = function (key, val) {
	    this.options[key] = val;
	  };
	
	  return Options;
	});
	
	S2.define('select2/core',[
	  'jquery',
	  './options',
	  './utils',
	  './keys'
	], function ($, Options, Utils, KEYS) {
	  var Select2 = function ($element, options) {
	    if ($element.data('select2') != null) {
	      $element.data('select2').destroy();
	    }
	
	    this.$element = $element;
	
	    this.id = this._generateId($element);
	
	    options = options || {};
	
	    this.options = new Options(options, $element);
	
	    Select2.__super__.constructor.call(this);
	
	    // Set up the tabindex
	
	    var tabindex = $element.attr('tabindex') || 0;
	    $element.data('old-tabindex', tabindex);
	    $element.attr('tabindex', '-1');
	
	    // Set up containers and adapters
	
	    var DataAdapter = this.options.get('dataAdapter');
	    this.dataAdapter = new DataAdapter($element, this.options);
	
	    var $container = this.render();
	
	    this._placeContainer($container);
	
	    var SelectionAdapter = this.options.get('selectionAdapter');
	    this.selection = new SelectionAdapter($element, this.options);
	    this.$selection = this.selection.render();
	
	    this.selection.position(this.$selection, $container);
	
	    var DropdownAdapter = this.options.get('dropdownAdapter');
	    this.dropdown = new DropdownAdapter($element, this.options);
	    this.$dropdown = this.dropdown.render();
	
	    this.dropdown.position(this.$dropdown, $container);
	
	    var ResultsAdapter = this.options.get('resultsAdapter');
	    this.results = new ResultsAdapter($element, this.options, this.dataAdapter);
	    this.$results = this.results.render();
	
	    this.results.position(this.$results, this.$dropdown);
	
	    // Bind events
	
	    var self = this;
	
	    // Bind the container to all of the adapters
	    this._bindAdapters();
	
	    // Register any DOM event handlers
	    this._registerDomEvents();
	
	    // Register any internal event handlers
	    this._registerDataEvents();
	    this._registerSelectionEvents();
	    this._registerDropdownEvents();
	    this._registerResultsEvents();
	    this._registerEvents();
	
	    // Set the initial state
	    this.dataAdapter.current(function (initialData) {
	      self.trigger('selection:update', {
	        data: initialData
	      });
	    });
	
	    // Hide the original select
	    $element.addClass('select2-hidden-accessible');
	    $element.attr('aria-hidden', 'true');
	
	    // Synchronize any monitored attributes
	    this._syncAttributes();
	
	    $element.data('select2', this);
	  };
	
	  Utils.Extend(Select2, Utils.Observable);
	
	  Select2.prototype._generateId = function ($element) {
	    var id = '';
	
	    if ($element.attr('id') != null) {
	      id = $element.attr('id');
	    } else if ($element.attr('name') != null) {
	      id = $element.attr('name') + '-' + Utils.generateChars(2);
	    } else {
	      id = Utils.generateChars(4);
	    }
	
	    id = id.replace(/(:|\.|\[|\]|,)/g, '');
	    id = 'select2-' + id;
	
	    return id;
	  };
	
	  Select2.prototype._placeContainer = function ($container) {
	    $container.insertAfter(this.$element);
	
	    var width = this._resolveWidth(this.$element, this.options.get('width'));
	
	    if (width != null) {
	      $container.css('width', width);
	    }
	  };
	
	  Select2.prototype._resolveWidth = function ($element, method) {
	    var WIDTH = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
	
	    if (method == 'resolve') {
	      var styleWidth = this._resolveWidth($element, 'style');
	
	      if (styleWidth != null) {
	        return styleWidth;
	      }
	
	      return this._resolveWidth($element, 'element');
	    }
	
	    if (method == 'element') {
	      var elementWidth = $element.outerWidth(false);
	
	      if (elementWidth <= 0) {
	        return 'auto';
	      }
	
	      return elementWidth + 'px';
	    }
	
	    if (method == 'style') {
	      var style = $element.attr('style');
	
	      if (typeof(style) !== 'string') {
	        return null;
	      }
	
	      var attrs = style.split(';');
	
	      for (var i = 0, l = attrs.length; i < l; i = i + 1) {
	        var attr = attrs[i].replace(/\s/g, '');
	        var matches = attr.match(WIDTH);
	
	        if (matches !== null && matches.length >= 1) {
	          return matches[1];
	        }
	      }
	
	      return null;
	    }
	
	    return method;
	  };
	
	  Select2.prototype._bindAdapters = function () {
	    this.dataAdapter.bind(this, this.$container);
	    this.selection.bind(this, this.$container);
	
	    this.dropdown.bind(this, this.$container);
	    this.results.bind(this, this.$container);
	  };
	
	  Select2.prototype._registerDomEvents = function () {
	    var self = this;
	
	    this.$element.on('change.select2', function () {
	      self.dataAdapter.current(function (data) {
	        self.trigger('selection:update', {
	          data: data
	        });
	      });
	    });
	
	    this.$element.on('focus.select2', function (evt) {
	      self.trigger('focus', evt);
	    });
	
	    this._syncA = Utils.bind(this._syncAttributes, this);
	    this._syncS = Utils.bind(this._syncSubtree, this);
	
	    if (this.$element[0].attachEvent) {
	      this.$element[0].attachEvent('onpropertychange', this._syncA);
	    }
	
	    var observer = window.MutationObserver ||
	      window.WebKitMutationObserver ||
	      window.MozMutationObserver
	    ;
	
	    if (observer != null) {
	      this._observer = new observer(function (mutations) {
	        $.each(mutations, self._syncA);
	        $.each(mutations, self._syncS);
	      });
	      this._observer.observe(this.$element[0], {
	        attributes: true,
	        childList: true,
	        subtree: false
	      });
	    } else if (this.$element[0].addEventListener) {
	      this.$element[0].addEventListener(
	        'DOMAttrModified',
	        self._syncA,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeInserted',
	        self._syncS,
	        false
	      );
	      this.$element[0].addEventListener(
	        'DOMNodeRemoved',
	        self._syncS,
	        false
	      );
	    }
	  };
	
	  Select2.prototype._registerDataEvents = function () {
	    var self = this;
	
	    this.dataAdapter.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerSelectionEvents = function () {
	    var self = this;
	    var nonRelayEvents = ['toggle', 'focus'];
	
	    this.selection.on('toggle', function () {
	      self.toggleDropdown();
	    });
	
	    this.selection.on('focus', function (params) {
	      self.focus(params);
	    });
	
	    this.selection.on('*', function (name, params) {
	      if ($.inArray(name, nonRelayEvents) !== -1) {
	        return;
	      }
	
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerDropdownEvents = function () {
	    var self = this;
	
	    this.dropdown.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerResultsEvents = function () {
	    var self = this;
	
	    this.results.on('*', function (name, params) {
	      self.trigger(name, params);
	    });
	  };
	
	  Select2.prototype._registerEvents = function () {
	    var self = this;
	
	    this.on('open', function () {
	      self.$container.addClass('select2-container--open');
	    });
	
	    this.on('close', function () {
	      self.$container.removeClass('select2-container--open');
	    });
	
	    this.on('enable', function () {
	      self.$container.removeClass('select2-container--disabled');
	    });
	
	    this.on('disable', function () {
	      self.$container.addClass('select2-container--disabled');
	    });
	
	    this.on('blur', function () {
	      self.$container.removeClass('select2-container--focus');
	    });
	
	    this.on('query', function (params) {
	      if (!self.isOpen()) {
	        self.trigger('open', {});
	      }
	
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:all', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('query:append', function (params) {
	      this.dataAdapter.query(params, function (data) {
	        self.trigger('results:append', {
	          data: data,
	          query: params
	        });
	      });
	    });
	
	    this.on('keypress', function (evt) {
	      var key = evt.which;
	
	      if (self.isOpen()) {
	        if (key === KEYS.ESC || key === KEYS.TAB ||
	            (key === KEYS.UP && evt.altKey)) {
	          self.close();
	
	          evt.preventDefault();
	        } else if (key === KEYS.ENTER) {
	          self.trigger('results:select', {});
	
	          evt.preventDefault();
	        } else if ((key === KEYS.SPACE && evt.ctrlKey)) {
	          self.trigger('results:toggle', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.UP) {
	          self.trigger('results:previous', {});
	
	          evt.preventDefault();
	        } else if (key === KEYS.DOWN) {
	          self.trigger('results:next', {});
	
	          evt.preventDefault();
	        }
	      } else {
	        if (key === KEYS.ENTER || key === KEYS.SPACE ||
	            (key === KEYS.DOWN && evt.altKey)) {
	          self.open();
	
	          evt.preventDefault();
	        }
	      }
	    });
	  };
	
	  Select2.prototype._syncAttributes = function () {
	    this.options.set('disabled', this.$element.prop('disabled'));
	
	    if (this.options.get('disabled')) {
	      if (this.isOpen()) {
	        this.close();
	      }
	
	      this.trigger('disable', {});
	    } else {
	      this.trigger('enable', {});
	    }
	  };
	
	  Select2.prototype._syncSubtree = function (evt, mutations) {
	    var changed = false;
	    var self = this;
	
	    // Ignore any mutation events raised for elements that aren't options or
	    // optgroups. This handles the case when the select element is destroyed
	    if (
	      evt && evt.target && (
	        evt.target.nodeName !== 'OPTION' && evt.target.nodeName !== 'OPTGROUP'
	      )
	    ) {
	      return;
	    }
	
	    if (!mutations) {
	      // If mutation events aren't supported, then we can only assume that the
	      // change affected the selections
	      changed = true;
	    } else if (mutations.addedNodes && mutations.addedNodes.length > 0) {
	      for (var n = 0; n < mutations.addedNodes.length; n++) {
	        var node = mutations.addedNodes[n];
	
	        if (node.selected) {
	          changed = true;
	        }
	      }
	    } else if (mutations.removedNodes && mutations.removedNodes.length > 0) {
	      changed = true;
	    }
	
	    // Only re-pull the data if we think there is a change
	    if (changed) {
	      this.dataAdapter.current(function (currentData) {
	        self.trigger('selection:update', {
	          data: currentData
	        });
	      });
	    }
	  };
	
	  /**
	   * Override the trigger method to automatically trigger pre-events when
	   * there are events that can be prevented.
	   */
	  Select2.prototype.trigger = function (name, args) {
	    var actualTrigger = Select2.__super__.trigger;
	    var preTriggerMap = {
	      'open': 'opening',
	      'close': 'closing',
	      'select': 'selecting',
	      'unselect': 'unselecting'
	    };
	
	    if (args === undefined) {
	      args = {};
	    }
	
	    if (name in preTriggerMap) {
	      var preTriggerName = preTriggerMap[name];
	      var preTriggerArgs = {
	        prevented: false,
	        name: name,
	        args: args
	      };
	
	      actualTrigger.call(this, preTriggerName, preTriggerArgs);
	
	      if (preTriggerArgs.prevented) {
	        args.prevented = true;
	
	        return;
	      }
	    }
	
	    actualTrigger.call(this, name, args);
	  };
	
	  Select2.prototype.toggleDropdown = function () {
	    if (this.options.get('disabled')) {
	      return;
	    }
	
	    if (this.isOpen()) {
	      this.close();
	    } else {
	      this.open();
	    }
	  };
	
	  Select2.prototype.open = function () {
	    if (this.isOpen()) {
	      return;
	    }
	
	    this.trigger('query', {});
	  };
	
	  Select2.prototype.close = function () {
	    if (!this.isOpen()) {
	      return;
	    }
	
	    this.trigger('close', {});
	  };
	
	  Select2.prototype.isOpen = function () {
	    return this.$container.hasClass('select2-container--open');
	  };
	
	  Select2.prototype.hasFocus = function () {
	    return this.$container.hasClass('select2-container--focus');
	  };
	
	  Select2.prototype.focus = function (data) {
	    // No need to re-trigger focus events if we are already focused
	    if (this.hasFocus()) {
	      return;
	    }
	
	    this.$container.addClass('select2-container--focus');
	    this.trigger('focus', {});
	  };
	
	  Select2.prototype.enable = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("enable")` method has been deprecated and will' +
	        ' be removed in later Select2 versions. Use $element.prop("disabled")' +
	        ' instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      args = [true];
	    }
	
	    var disabled = !args[0];
	
	    this.$element.prop('disabled', disabled);
	  };
	
	  Select2.prototype.data = function () {
	    if (this.options.get('debug') &&
	        arguments.length > 0 && window.console && console.warn) {
	      console.warn(
	        'Select2: Data can no longer be set using `select2("data")`. You ' +
	        'should consider setting the value instead using `$element.val()`.'
	      );
	    }
	
	    var data = [];
	
	    this.dataAdapter.current(function (currentData) {
	      data = currentData;
	    });
	
	    return data;
	  };
	
	  Select2.prototype.val = function (args) {
	    if (this.options.get('debug') && window.console && console.warn) {
	      console.warn(
	        'Select2: The `select2("val")` method has been deprecated and will be' +
	        ' removed in later Select2 versions. Use $element.val() instead.'
	      );
	    }
	
	    if (args == null || args.length === 0) {
	      return this.$element.val();
	    }
	
	    var newVal = args[0];
	
	    if ($.isArray(newVal)) {
	      newVal = $.map(newVal, function (obj) {
	        return obj.toString();
	      });
	    }
	
	    this.$element.val(newVal).trigger('change');
	  };
	
	  Select2.prototype.destroy = function () {
	    this.$container.remove();
	
	    if (this.$element[0].detachEvent) {
	      this.$element[0].detachEvent('onpropertychange', this._syncA);
	    }
	
	    if (this._observer != null) {
	      this._observer.disconnect();
	      this._observer = null;
	    } else if (this.$element[0].removeEventListener) {
	      this.$element[0]
	        .removeEventListener('DOMAttrModified', this._syncA, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeInserted', this._syncS, false);
	      this.$element[0]
	        .removeEventListener('DOMNodeRemoved', this._syncS, false);
	    }
	
	    this._syncA = null;
	    this._syncS = null;
	
	    this.$element.off('.select2');
	    this.$element.attr('tabindex', this.$element.data('old-tabindex'));
	
	    this.$element.removeClass('select2-hidden-accessible');
	    this.$element.attr('aria-hidden', 'false');
	    this.$element.removeData('select2');
	
	    this.dataAdapter.destroy();
	    this.selection.destroy();
	    this.dropdown.destroy();
	    this.results.destroy();
	
	    this.dataAdapter = null;
	    this.selection = null;
	    this.dropdown = null;
	    this.results = null;
	  };
	
	  Select2.prototype.render = function () {
	    var $container = $(
	      '<span class="select2 select2-container">' +
	        '<span class="selection"></span>' +
	        '<span class="dropdown-wrapper" aria-hidden="true"></span>' +
	      '</span>'
	    );
	
	    $container.attr('dir', this.options.get('dir'));
	
	    this.$container = $container;
	
	    this.$container.addClass('select2-container--' + this.options.get('theme'));
	
	    $container.data('element', this.$element);
	
	    return $container;
	  };
	
	  return Select2;
	});
	
	S2.define('jquery-mousewheel',[
	  'jquery'
	], function ($) {
	  // Used to shim jQuery.mousewheel for non-full builds.
	  return $;
	});
	
	S2.define('jquery.select2',[
	  'jquery',
	  'jquery-mousewheel',
	
	  './select2/core',
	  './select2/defaults'
	], function ($, _, Select2, Defaults) {
	  if ($.fn.select2 == null) {
	    // All methods that should return the element
	    var thisMethods = ['open', 'close', 'destroy'];
	
	    $.fn.select2 = function (options) {
	      options = options || {};
	
	      if (typeof options === 'object') {
	        this.each(function () {
	          var instanceOptions = $.extend(true, {}, options);
	
	          var instance = new Select2($(this), instanceOptions);
	        });
	
	        return this;
	      } else if (typeof options === 'string') {
	        var ret;
	        var args = Array.prototype.slice.call(arguments, 1);
	
	        this.each(function () {
	          var instance = $(this).data('select2');
	
	          if (instance == null && window.console && console.error) {
	            console.error(
	              'The select2(\'' + options + '\') method was called on an ' +
	              'element that is not using Select2.'
	            );
	          }
	
	          ret = instance[options].apply(instance, args);
	        });
	
	        // Check if we should be returning `this`
	        if ($.inArray(options, thisMethods) > -1) {
	          return this;
	        }
	
	        return ret;
	      } else {
	        throw new Error('Invalid arguments for Select2: ' + options);
	      }
	    };
	  }
	
	  if ($.fn.select2.defaults == null) {
	    $.fn.select2.defaults = Defaults;
	  }
	
	  return Select2;
	});
	
	  // Return the AMD loader configuration so it can be used outside of this file
	  return {
	    define: S2.define,
	    require: S2.require
	  };
	}());
	
	  // Autoload the jQuery bindings
	  // We know that all of the modules exist above this, so we're safe
	  var select2 = S2.require('jquery.select2');
	
	  // Hold the AMD module references on the jQuery function that was just loaded
	  // This allows Select2 to use the internal loader outside of this file, such
	  // as in the language files.
	  jQuery.fn.select2.amd = S2;
	
	  // Return the Select2 instance for anyone who is importing it.
	  return select2;
	}));


/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(133);
	var define = __webpack_require__(1053);
	var hasDescriptors = __webpack_require__(1134)();
	var gOPD = __webpack_require__(93);
	
	var $TypeError = __webpack_require__(63);
	var $floor = GetIntrinsic('%Math.floor%');
	
	/** @type {import('.')} */
	module.exports = function setFunctionLength(fn, length) {
		if (typeof fn !== 'function') {
			throw new $TypeError('`fn` is not a function');
		}
		if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
			throw new $TypeError('`length` must be a positive 32-bit integer');
		}
	
		var loose = arguments.length > 2 && !!arguments[2];
	
		var functionLengthIsConfigurable = true;
		var functionLengthIsWritable = true;
		if ('length' in fn && gOPD) {
			var desc = gOPD(fn, 'length');
			if (desc && !desc.configurable) {
				functionLengthIsConfigurable = false;
			}
			if (desc && !desc.writable) {
				functionLengthIsWritable = false;
			}
		}
	
		if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
			if (hasDescriptors) {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
			} else {
				define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
			}
		}
		return fn;
	};


/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(193)))

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var inspect = __webpack_require__(142);
	
	var $TypeError = __webpack_require__(63);
	
	/*
	* This function traverses the list returning the node corresponding to the given key.
	*
	* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
	* By doing so, all the recently used nodes can be accessed relatively quickly.
	*/
	/** @type {import('./list.d.ts').listGetNode} */
	// eslint-disable-next-line consistent-return
	var listGetNode = function (list, key, isDelete) {
		/** @type {typeof list | NonNullable<(typeof list)['next']>} */
		var prev = list;
		/** @type {(typeof list)['next']} */
		var curr;
		// eslint-disable-next-line eqeqeq
		for (; (curr = prev.next) != null; prev = curr) {
			if (curr.key === key) {
				prev.next = curr.next;
				if (!isDelete) {
					// eslint-disable-next-line no-extra-parens
					curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
					list.next = curr; // eslint-disable-line no-param-reassign
				}
				return curr;
			}
		}
	};
	
	/** @type {import('./list.d.ts').listGet} */
	var listGet = function (objects, key) {
		if (!objects) {
			return void undefined;
		}
		var node = listGetNode(objects, key);
		return node && node.value;
	};
	/** @type {import('./list.d.ts').listSet} */
	var listSet = function (objects, key, value) {
		var node = listGetNode(objects, key);
		if (node) {
			node.value = value;
		} else {
			// Prepend the new node to the beginning of the list
			objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
				key: key,
				next: objects.next,
				value: value
			});
		}
	};
	/** @type {import('./list.d.ts').listHas} */
	var listHas = function (objects, key) {
		if (!objects) {
			return false;
		}
		return !!listGetNode(objects, key);
	};
	/** @type {import('./list.d.ts').listDelete} */
	// eslint-disable-next-line consistent-return
	var listDelete = function (objects, key) {
		if (objects) {
			return listGetNode(objects, key, true);
		}
	};
	
	/** @type {import('.')} */
	module.exports = function getSideChannelList() {
		/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */
	
		/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
	
		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				var root = $o && $o.next;
				var deletedNode = listDelete($o, key);
				if (deletedNode && root && root === deletedNode) {
					$o = void undefined;
				}
				return !!deletedNode;
			},
			get: function (key) {
				return listGet($o, key);
			},
			has: function (key) {
				return listHas($o, key);
			},
			set: function (key, value) {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = {
						next: void undefined
					};
				}
				// eslint-disable-next-line no-extra-parens
				listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
			}
		};
		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	};


/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(133);
	var callBound = __webpack_require__(72);
	var inspect = __webpack_require__(142);
	var getSideChannelMap = __webpack_require__(458);
	
	var $TypeError = __webpack_require__(63);
	var $WeakMap = GetIntrinsic('%WeakMap%', true);
	
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
	var $weakMapGet = callBound('WeakMap.prototype.get', true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
	var $weakMapSet = callBound('WeakMap.prototype.set', true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
	var $weakMapHas = callBound('WeakMap.prototype.has', true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
	var $weakMapDelete = callBound('WeakMap.prototype.delete', true);
	
	/** @type {import('.')} */
	module.exports = $WeakMap
		? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
			/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
			/** @typedef {Parameters<Channel['get']>[0]} K */
			/** @typedef {Parameters<Channel['set']>[1]} V */
	
			/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
			/** @type {Channel | undefined} */ var $m;
	
			/** @type {Channel} */
			var channel = {
				assert: function (key) {
					if (!channel.has(key)) {
						throw new $TypeError('Side channel does not contain ' + inspect(key));
					}
				},
				'delete': function (key) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if ($wm) {
							return $weakMapDelete($wm, key);
						}
					} else if (getSideChannelMap) {
						if ($m) {
							return $m['delete'](key);
						}
					}
					return false;
				},
				get: function (key) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if ($wm) {
							return $weakMapGet($wm, key);
						}
					}
					return $m && $m.get(key);
				},
				has: function (key) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if ($wm) {
							return $weakMapHas($wm, key);
						}
					}
					return !!$m && $m.has(key);
				},
				set: function (key, value) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if (!$wm) {
							$wm = new $WeakMap();
						}
						$weakMapSet($wm, key, value);
					} else if (getSideChannelMap) {
						if (!$m) {
							$m = getSideChannelMap();
						}
						// eslint-disable-next-line no-extra-parens
						/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
					}
				}
			};
	
			// @ts-expect-error TODO: figure out why this is erroring
			return channel;
		}
		: getSideChannelMap;


/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(63);
	var inspect = __webpack_require__(142);
	var getSideChannelList = __webpack_require__(1567);
	var getSideChannelMap = __webpack_require__(458);
	var getSideChannelWeakMap = __webpack_require__(1568);
	
	var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;
	
	/** @type {import('.')} */
	module.exports = function getSideChannel() {
		/** @typedef {ReturnType<typeof getSideChannel>} Channel */
	
		/** @type {Channel | undefined} */ var $channelData;
	
		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				return !!$channelData && $channelData['delete'](key);
			},
			get: function (key) {
				return $channelData && $channelData.get(key);
			},
			has: function (key) {
				return !!$channelData && $channelData.has(key);
			},
			set: function (key, value) {
				if (!$channelData) {
					$channelData = makeChannel();
				}
	
				$channelData.set(key, value);
			}
		};
		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	};


/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1566);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(setImmediate) {/*!
	 * typeahead.js 0.11.1
	 * https://github.com/twitter/typeahead.js
	 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
	 */
	
	(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(a0) {
	            return root["Bloodhound"] = factory(a0);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === "object") {
	        module.exports = factory(require("jquery"));
	    } else {
	        root["Bloodhound"] = factory(jQuery);
	    }
	})(this, function($) {
	    var _ = function() {
	        "use strict";
	        return {
	            isMsie: function() {
	                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
	            },
	            isBlankString: function(str) {
	                return !str || /^\s*$/.test(str);
	            },
	            escapeRegExChars: function(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            },
	            isString: function(obj) {
	                return typeof obj === "string";
	            },
	            isNumber: function(obj) {
	                return typeof obj === "number";
	            },
	            isArray: $.isArray,
	            isFunction: $.isFunction,
	            isObject: $.isPlainObject,
	            isUndefined: function(obj) {
	                return typeof obj === "undefined";
	            },
	            isElement: function(obj) {
	                return !!(obj && obj.nodeType === 1);
	            },
	            isJQuery: function(obj) {
	                return obj instanceof $;
	            },
	            toStr: function toStr(s) {
	                return _.isUndefined(s) || s === null ? "" : s + "";
	            },
	            bind: $.proxy,
	            each: function(collection, cb) {
	                $.each(collection, reverseArgs);
	                function reverseArgs(index, value) {
	                    return cb(value, index);
	                }
	            },
	            map: $.map,
	            filter: $.grep,
	            every: function(obj, test) {
	                var result = true;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (!(result = test.call(null, val, key, obj))) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            some: function(obj, test) {
	                var result = false;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (result = test.call(null, val, key, obj)) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            mixin: $.extend,
	            identity: function(x) {
	                return x;
	            },
	            clone: function(obj) {
	                return $.extend(true, {}, obj);
	            },
	            getIdGenerator: function() {
	                var counter = 0;
	                return function() {
	                    return counter++;
	                };
	            },
	            templatify: function templatify(obj) {
	                return $.isFunction(obj) ? obj : template;
	                function template() {
	                    return String(obj);
	                }
	            },
	            defer: function(fn) {
	                setTimeout(fn, 0);
	            },
	            debounce: function(func, wait, immediate) {
	                var timeout, result;
	                return function() {
	                    var context = this, args = arguments, later, callNow;
	                    later = function() {
	                        timeout = null;
	                        if (!immediate) {
	                            result = func.apply(context, args);
	                        }
	                    };
	                    callNow = immediate && !timeout;
	                    clearTimeout(timeout);
	                    timeout = setTimeout(later, wait);
	                    if (callNow) {
	                        result = func.apply(context, args);
	                    }
	                    return result;
	                };
	            },
	            throttle: function(func, wait) {
	                var context, args, timeout, result, previous, later;
	                previous = 0;
	                later = function() {
	                    previous = new Date();
	                    timeout = null;
	                    result = func.apply(context, args);
	                };
	                return function() {
	                    var now = new Date(), remaining = wait - (now - previous);
	                    context = this;
	                    args = arguments;
	                    if (remaining <= 0) {
	                        clearTimeout(timeout);
	                        timeout = null;
	                        previous = now;
	                        result = func.apply(context, args);
	                    } else if (!timeout) {
	                        timeout = setTimeout(later, remaining);
	                    }
	                    return result;
	                };
	            },
	            stringify: function(val) {
	                return _.isString(val) ? val : JSON.stringify(val);
	            },
	            noop: function() {}
	        };
	    }();
	    var VERSION = "0.11.1";
	    var tokenizers = function() {
	        "use strict";
	        return {
	            nonword: nonword,
	            whitespace: whitespace,
	            obj: {
	                nonword: getObjTokenizer(nonword),
	                whitespace: getObjTokenizer(whitespace)
	            }
	        };
	        function whitespace(str) {
	            str = _.toStr(str);
	            return str ? str.split(/\s+/) : [];
	        }
	        function nonword(str) {
	            str = _.toStr(str);
	            return str ? str.split(/\W+/) : [];
	        }
	        function getObjTokenizer(tokenizer) {
	            return function setKey(keys) {
	                keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
	                return function tokenize(o) {
	                    var tokens = [];
	                    _.each(keys, function(k) {
	                        tokens = tokens.concat(tokenizer(_.toStr(o[k])));
	                    });
	                    return tokens;
	                };
	            };
	        }
	    }();
	    var LruCache = function() {
	        "use strict";
	        function LruCache(maxSize) {
	            this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
	            this.reset();
	            if (this.maxSize <= 0) {
	                this.set = this.get = $.noop;
	            }
	        }
	        _.mixin(LruCache.prototype, {
	            set: function set(key, val) {
	                var tailItem = this.list.tail, node;
	                if (this.size >= this.maxSize) {
	                    this.list.remove(tailItem);
	                    delete this.hash[tailItem.key];
	                    this.size--;
	                }
	                if (node = this.hash[key]) {
	                    node.val = val;
	                    this.list.moveToFront(node);
	                } else {
	                    node = new Node(key, val);
	                    this.list.add(node);
	                    this.hash[key] = node;
	                    this.size++;
	                }
	            },
	            get: function get(key) {
	                var node = this.hash[key];
	                if (node) {
	                    this.list.moveToFront(node);
	                    return node.val;
	                }
	            },
	            reset: function reset() {
	                this.size = 0;
	                this.hash = {};
	                this.list = new List();
	            }
	        });
	        function List() {
	            this.head = this.tail = null;
	        }
	        _.mixin(List.prototype, {
	            add: function add(node) {
	                if (this.head) {
	                    node.next = this.head;
	                    this.head.prev = node;
	                }
	                this.head = node;
	                this.tail = this.tail || node;
	            },
	            remove: function remove(node) {
	                node.prev ? node.prev.next = node.next : this.head = node.next;
	                node.next ? node.next.prev = node.prev : this.tail = node.prev;
	            },
	            moveToFront: function(node) {
	                this.remove(node);
	                this.add(node);
	            }
	        });
	        function Node(key, val) {
	            this.key = key;
	            this.val = val;
	            this.prev = this.next = null;
	        }
	        return LruCache;
	    }();
	    var PersistentStorage = function() {
	        "use strict";
	        var LOCAL_STORAGE;
	        try {
	            LOCAL_STORAGE = window.localStorage;
	            LOCAL_STORAGE.setItem("~~~", "!");
	            LOCAL_STORAGE.removeItem("~~~");
	        } catch (err) {
	            LOCAL_STORAGE = null;
	        }
	        function PersistentStorage(namespace, override) {
	            this.prefix = [ "__", namespace, "__" ].join("");
	            this.ttlKey = "__ttl__";
	            this.keyMatcher = new RegExp("^" + _.escapeRegExChars(this.prefix));
	            this.ls = override || LOCAL_STORAGE;
	            !this.ls && this._noop();
	        }
	        _.mixin(PersistentStorage.prototype, {
	            _prefix: function(key) {
	                return this.prefix + key;
	            },
	            _ttlKey: function(key) {
	                return this._prefix(key) + this.ttlKey;
	            },
	            _noop: function() {
	                this.get = this.set = this.remove = this.clear = this.isExpired = _.noop;
	            },
	            _safeSet: function(key, val) {
	                try {
	                    this.ls.setItem(key, val);
	                } catch (err) {
	                    if (err.name === "QuotaExceededError") {
	                        this.clear();
	                        this._noop();
	                    }
	                }
	            },
	            get: function(key) {
	                if (this.isExpired(key)) {
	                    this.remove(key);
	                }
	                return decode(this.ls.getItem(this._prefix(key)));
	            },
	            set: function(key, val, ttl) {
	                if (_.isNumber(ttl)) {
	                    this._safeSet(this._ttlKey(key), encode(now() + ttl));
	                } else {
	                    this.ls.removeItem(this._ttlKey(key));
	                }
	                return this._safeSet(this._prefix(key), encode(val));
	            },
	            remove: function(key) {
	                this.ls.removeItem(this._ttlKey(key));
	                this.ls.removeItem(this._prefix(key));
	                return this;
	            },
	            clear: function() {
	                var i, keys = gatherMatchingKeys(this.keyMatcher);
	                for (i = keys.length; i--; ) {
	                    this.remove(keys[i]);
	                }
	                return this;
	            },
	            isExpired: function(key) {
	                var ttl = decode(this.ls.getItem(this._ttlKey(key)));
	                return _.isNumber(ttl) && now() > ttl ? true : false;
	            }
	        });
	        return PersistentStorage;
	        function now() {
	            return new Date().getTime();
	        }
	        function encode(val) {
	            return JSON.stringify(_.isUndefined(val) ? null : val);
	        }
	        function decode(val) {
	            return $.parseJSON(val);
	        }
	        function gatherMatchingKeys(keyMatcher) {
	            var i, key, keys = [], len = LOCAL_STORAGE.length;
	            for (i = 0; i < len; i++) {
	                if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
	                    keys.push(key.replace(keyMatcher, ""));
	                }
	            }
	            return keys;
	        }
	    }();
	    var Transport = function() {
	        "use strict";
	        var pendingRequestsCount = 0, pendingRequests = {}, maxPendingRequests = 6, sharedCache = new LruCache(10);
	        function Transport(o) {
	            o = o || {};
	            this.cancelled = false;
	            this.lastReq = null;
	            this._send = o.transport;
	            this._get = o.limiter ? o.limiter(this._get) : this._get;
	            this._cache = o.cache === false ? new LruCache(0) : sharedCache;
	        }
	        Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
	            maxPendingRequests = num;
	        };
	        Transport.resetCache = function resetCache() {
	            sharedCache.reset();
	        };
	        _.mixin(Transport.prototype, {
	            _fingerprint: function fingerprint(o) {
	                o = o || {};
	                return o.url + o.type + $.param(o.data || {});
	            },
	            _get: function(o, cb) {
	                var that = this, fingerprint, jqXhr;
	                fingerprint = this._fingerprint(o);
	                if (this.cancelled || fingerprint !== this.lastReq) {
	                    return;
	                }
	                if (jqXhr = pendingRequests[fingerprint]) {
	                    jqXhr.done(done).fail(fail);
	                } else if (pendingRequestsCount < maxPendingRequests) {
	                    pendingRequestsCount++;
	                    pendingRequests[fingerprint] = this._send(o).done(done).fail(fail).always(always);
	                } else {
	                    this.onDeckRequestArgs = [].slice.call(arguments, 0);
	                }
	                function done(resp) {
	                    cb(null, resp);
	                    that._cache.set(fingerprint, resp);
	                }
	                function fail() {
	                    cb(true);
	                }
	                function always() {
	                    pendingRequestsCount--;
	                    delete pendingRequests[fingerprint];
	                    if (that.onDeckRequestArgs) {
	                        that._get.apply(that, that.onDeckRequestArgs);
	                        that.onDeckRequestArgs = null;
	                    }
	                }
	            },
	            get: function(o, cb) {
	                var resp, fingerprint;
	                cb = cb || $.noop;
	                o = _.isString(o) ? {
	                    url: o
	                } : o || {};
	                fingerprint = this._fingerprint(o);
	                this.cancelled = false;
	                this.lastReq = fingerprint;
	                if (resp = this._cache.get(fingerprint)) {
	                    cb(null, resp);
	                } else {
	                    this._get(o, cb);
	                }
	            },
	            cancel: function() {
	                this.cancelled = true;
	            }
	        });
	        return Transport;
	    }();
	    var SearchIndex = window.SearchIndex = function() {
	        "use strict";
	        var CHILDREN = "c", IDS = "i";
	        function SearchIndex(o) {
	            o = o || {};
	            if (!o.datumTokenizer || !o.queryTokenizer) {
	                $.error("datumTokenizer and queryTokenizer are both required");
	            }
	            this.identify = o.identify || _.stringify;
	            this.datumTokenizer = o.datumTokenizer;
	            this.queryTokenizer = o.queryTokenizer;
	            this.reset();
	        }
	        _.mixin(SearchIndex.prototype, {
	            bootstrap: function bootstrap(o) {
	                this.datums = o.datums;
	                this.trie = o.trie;
	            },
	            add: function(data) {
	                var that = this;
	                data = _.isArray(data) ? data : [ data ];
	                _.each(data, function(datum) {
	                    var id, tokens;
	                    that.datums[id = that.identify(datum)] = datum;
	                    tokens = normalizeTokens(that.datumTokenizer(datum));
	                    _.each(tokens, function(token) {
	                        var node, chars, ch;
	                        node = that.trie;
	                        chars = token.split("");
	                        while (ch = chars.shift()) {
	                            node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
	                            node[IDS].push(id);
	                        }
	                    });
	                });
	            },
	            get: function get(ids) {
	                var that = this;
	                return _.map(ids, function(id) {
	                    return that.datums[id];
	                });
	            },
	            search: function search(query) {
	                var that = this, tokens, matches;
	                tokens = normalizeTokens(this.queryTokenizer(query));
	                _.each(tokens, function(token) {
	                    var node, chars, ch, ids;
	                    if (matches && matches.length === 0) {
	                        return false;
	                    }
	                    node = that.trie;
	                    chars = token.split("");
	                    while (node && (ch = chars.shift())) {
	                        node = node[CHILDREN][ch];
	                    }
	                    if (node && chars.length === 0) {
	                        ids = node[IDS].slice(0);
	                        matches = matches ? getIntersection(matches, ids) : ids;
	                    } else {
	                        matches = [];
	                        return false;
	                    }
	                });
	                return matches ? _.map(unique(matches), function(id) {
	                    return that.datums[id];
	                }) : [];
	            },
	            all: function all() {
	                var values = [];
	                for (var key in this.datums) {
	                    values.push(this.datums[key]);
	                }
	                return values;
	            },
	            reset: function reset() {
	                this.datums = {};
	                this.trie = newNode();
	            },
	            serialize: function serialize() {
	                return {
	                    datums: this.datums,
	                    trie: this.trie
	                };
	            }
	        });
	        return SearchIndex;
	        function normalizeTokens(tokens) {
	            tokens = _.filter(tokens, function(token) {
	                return !!token;
	            });
	            tokens = _.map(tokens, function(token) {
	                return token.toLowerCase();
	            });
	            return tokens;
	        }
	        function newNode() {
	            var node = {};
	            node[IDS] = [];
	            node[CHILDREN] = {};
	            return node;
	        }
	        function unique(array) {
	            var seen = {}, uniques = [];
	            for (var i = 0, len = array.length; i < len; i++) {
	                if (!seen[array[i]]) {
	                    seen[array[i]] = true;
	                    uniques.push(array[i]);
	                }
	            }
	            return uniques;
	        }
	        function getIntersection(arrayA, arrayB) {
	            var ai = 0, bi = 0, intersection = [];
	            arrayA = arrayA.sort();
	            arrayB = arrayB.sort();
	            var lenArrayA = arrayA.length, lenArrayB = arrayB.length;
	            while (ai < lenArrayA && bi < lenArrayB) {
	                if (arrayA[ai] < arrayB[bi]) {
	                    ai++;
	                } else if (arrayA[ai] > arrayB[bi]) {
	                    bi++;
	                } else {
	                    intersection.push(arrayA[ai]);
	                    ai++;
	                    bi++;
	                }
	            }
	            return intersection;
	        }
	    }();
	    var Prefetch = function() {
	        "use strict";
	        var keys;
	        keys = {
	            data: "data",
	            protocol: "protocol",
	            thumbprint: "thumbprint"
	        };
	        function Prefetch(o) {
	            this.url = o.url;
	            this.ttl = o.ttl;
	            this.cache = o.cache;
	            this.prepare = o.prepare;
	            this.transform = o.transform;
	            this.transport = o.transport;
	            this.thumbprint = o.thumbprint;
	            this.storage = new PersistentStorage(o.cacheKey);
	        }
	        _.mixin(Prefetch.prototype, {
	            _settings: function settings() {
	                return {
	                    url: this.url,
	                    type: "GET",
	                    dataType: "json"
	                };
	            },
	            store: function store(data) {
	                if (!this.cache) {
	                    return;
	                }
	                this.storage.set(keys.data, data, this.ttl);
	                this.storage.set(keys.protocol, location.protocol, this.ttl);
	                this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
	            },
	            fromCache: function fromCache() {
	                var stored = {}, isExpired;
	                if (!this.cache) {
	                    return null;
	                }
	                stored.data = this.storage.get(keys.data);
	                stored.protocol = this.storage.get(keys.protocol);
	                stored.thumbprint = this.storage.get(keys.thumbprint);
	                isExpired = stored.thumbprint !== this.thumbprint || stored.protocol !== location.protocol;
	                return stored.data && !isExpired ? stored.data : null;
	            },
	            fromNetwork: function(cb) {
	                var that = this, settings;
	                if (!cb) {
	                    return;
	                }
	                settings = this.prepare(this._settings());
	                this.transport(settings).fail(onError).done(onResponse);
	                function onError() {
	                    cb(true);
	                }
	                function onResponse(resp) {
	                    cb(null, that.transform(resp));
	                }
	            },
	            clear: function clear() {
	                this.storage.clear();
	                return this;
	            }
	        });
	        return Prefetch;
	    }();
	    var Remote = function() {
	        "use strict";
	        function Remote(o) {
	            this.url = o.url;
	            this.prepare = o.prepare;
	            this.transform = o.transform;
	            this.transport = new Transport({
	                cache: o.cache,
	                limiter: o.limiter,
	                transport: o.transport
	            });
	        }
	        _.mixin(Remote.prototype, {
	            _settings: function settings() {
	                return {
	                    url: this.url,
	                    type: "GET",
	                    dataType: "json"
	                };
	            },
	            get: function get(query, cb) {
	                var that = this, settings;
	                if (!cb) {
	                    return;
	                }
	                query = query || "";
	                settings = this.prepare(query, this._settings());
	                return this.transport.get(settings, onResponse);
	                function onResponse(err, resp) {
	                    err ? cb([]) : cb(that.transform(resp));
	                }
	            },
	            cancelLastRequest: function cancelLastRequest() {
	                this.transport.cancel();
	            }
	        });
	        return Remote;
	    }();
	    var oParser = function() {
	        "use strict";
	        return function parse(o) {
	            var defaults, sorter;
	            defaults = {
	                initialize: true,
	                identify: _.stringify,
	                datumTokenizer: null,
	                queryTokenizer: null,
	                sufficient: 5,
	                sorter: null,
	                local: [],
	                prefetch: null,
	                remote: null
	            };
	            o = _.mixin(defaults, o || {});
	            !o.datumTokenizer && $.error("datumTokenizer is required");
	            !o.queryTokenizer && $.error("queryTokenizer is required");
	            sorter = o.sorter;
	            o.sorter = sorter ? function(x) {
	                return x.sort(sorter);
	            } : _.identity;
	            o.local = _.isFunction(o.local) ? o.local() : o.local;
	            o.prefetch = parsePrefetch(o.prefetch);
	            o.remote = parseRemote(o.remote);
	            return o;
	        };
	        function parsePrefetch(o) {
	            var defaults;
	            if (!o) {
	                return null;
	            }
	            defaults = {
	                url: null,
	                ttl: 24 * 60 * 60 * 1e3,
	                cache: true,
	                cacheKey: null,
	                thumbprint: "",
	                prepare: _.identity,
	                transform: _.identity,
	                transport: null
	            };
	            o = _.isString(o) ? {
	                url: o
	            } : o;
	            o = _.mixin(defaults, o);
	            !o.url && $.error("prefetch requires url to be set");
	            o.transform = o.filter || o.transform;
	            o.cacheKey = o.cacheKey || o.url;
	            o.thumbprint = VERSION + o.thumbprint;
	            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
	            return o;
	        }
	        function parseRemote(o) {
	            var defaults;
	            if (!o) {
	                return;
	            }
	            defaults = {
	                url: null,
	                cache: true,
	                prepare: null,
	                replace: null,
	                wildcard: null,
	                limiter: null,
	                rateLimitBy: "debounce",
	                rateLimitWait: 300,
	                transform: _.identity,
	                transport: null
	            };
	            o = _.isString(o) ? {
	                url: o
	            } : o;
	            o = _.mixin(defaults, o);
	            !o.url && $.error("remote requires url to be set");
	            o.transform = o.filter || o.transform;
	            o.prepare = toRemotePrepare(o);
	            o.limiter = toLimiter(o);
	            o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
	            delete o.replace;
	            delete o.wildcard;
	            delete o.rateLimitBy;
	            delete o.rateLimitWait;
	            return o;
	        }
	        function toRemotePrepare(o) {
	            var prepare, replace, wildcard;
	            prepare = o.prepare;
	            replace = o.replace;
	            wildcard = o.wildcard;
	            if (prepare) {
	                return prepare;
	            }
	            if (replace) {
	                prepare = prepareByReplace;
	            } else if (o.wildcard) {
	                prepare = prepareByWildcard;
	            } else {
	                prepare = idenityPrepare;
	            }
	            return prepare;
	            function prepareByReplace(query, settings) {
	                settings.url = replace(settings.url, query);
	                return settings;
	            }
	            function prepareByWildcard(query, settings) {
	                settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
	                return settings;
	            }
	            function idenityPrepare(query, settings) {
	                return settings;
	            }
	        }
	        function toLimiter(o) {
	            var limiter, method, wait;
	            limiter = o.limiter;
	            method = o.rateLimitBy;
	            wait = o.rateLimitWait;
	            if (!limiter) {
	                limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
	            }
	            return limiter;
	            function debounce(wait) {
	                return function debounce(fn) {
	                    return _.debounce(fn, wait);
	                };
	            }
	            function throttle(wait) {
	                return function throttle(fn) {
	                    return _.throttle(fn, wait);
	                };
	            }
	        }
	        function callbackToDeferred(fn) {
	            return function wrapper(o) {
	                var deferred = $.Deferred();
	                fn(o, onSuccess, onError);
	                return deferred;
	                function onSuccess(resp) {
	                    _.defer(function() {
	                        deferred.resolve(resp);
	                    });
	                }
	                function onError(err) {
	                    _.defer(function() {
	                        deferred.reject(err);
	                    });
	                }
	            };
	        }
	    }();
	    var Bloodhound = function() {
	        "use strict";
	        var old;
	        old = window && window.Bloodhound;
	        function Bloodhound(o) {
	            o = oParser(o);
	            this.sorter = o.sorter;
	            this.identify = o.identify;
	            this.sufficient = o.sufficient;
	            this.local = o.local;
	            this.remote = o.remote ? new Remote(o.remote) : null;
	            this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;
	            this.index = new SearchIndex({
	                identify: this.identify,
	                datumTokenizer: o.datumTokenizer,
	                queryTokenizer: o.queryTokenizer
	            });
	            o.initialize !== false && this.initialize();
	        }
	        Bloodhound.noConflict = function noConflict() {
	            window && (window.Bloodhound = old);
	            return Bloodhound;
	        };
	        Bloodhound.tokenizers = tokenizers;
	        _.mixin(Bloodhound.prototype, {
	            __ttAdapter: function ttAdapter() {
	                var that = this;
	                return this.remote ? withAsync : withoutAsync;
	                function withAsync(query, sync, async) {
	                    return that.search(query, sync, async);
	                }
	                function withoutAsync(query, sync) {
	                    return that.search(query, sync);
	                }
	            },
	            _loadPrefetch: function loadPrefetch() {
	                var that = this, deferred, serialized;
	                deferred = $.Deferred();
	                if (!this.prefetch) {
	                    deferred.resolve();
	                } else if (serialized = this.prefetch.fromCache()) {
	                    this.index.bootstrap(serialized);
	                    deferred.resolve();
	                } else {
	                    this.prefetch.fromNetwork(done);
	                }
	                return deferred.promise();
	                function done(err, data) {
	                    if (err) {
	                        return deferred.reject();
	                    }
	                    that.add(data);
	                    that.prefetch.store(that.index.serialize());
	                    deferred.resolve();
	                }
	            },
	            _initialize: function initialize() {
	                var that = this, deferred;
	                this.clear();
	                (this.initPromise = this._loadPrefetch()).done(addLocalToIndex);
	                return this.initPromise;
	                function addLocalToIndex() {
	                    that.add(that.local);
	                }
	            },
	            initialize: function initialize(force) {
	                return !this.initPromise || force ? this._initialize() : this.initPromise;
	            },
	            add: function add(data) {
	                this.index.add(data);
	                return this;
	            },
	            get: function get(ids) {
	                ids = _.isArray(ids) ? ids : [].slice.call(arguments);
	                return this.index.get(ids);
	            },
	            search: function search(query, sync, async) {
	                var that = this, local;
	                local = this.sorter(this.index.search(query));
	                sync(this.remote ? local.slice() : local);
	                if (this.remote && local.length < this.sufficient) {
	                    this.remote.get(query, processRemote);
	                } else if (this.remote) {
	                    this.remote.cancelLastRequest();
	                }
	                return this;
	                function processRemote(remote) {
	                    var nonDuplicates = [];
	                    _.each(remote, function(r) {
	                        !_.some(local, function(l) {
	                            return that.identify(r) === that.identify(l);
	                        }) && nonDuplicates.push(r);
	                    });
	                    async && async(nonDuplicates);
	                }
	            },
	            all: function all() {
	                return this.index.all();
	            },
	            clear: function clear() {
	                this.index.reset();
	                return this;
	            },
	            clearPrefetchCache: function clearPrefetchCache() {
	                this.prefetch && this.prefetch.clear();
	                return this;
	            },
	            clearRemoteCache: function clearRemoteCache() {
	                Transport.resetCache();
	                return this;
	            },
	            ttAdapter: function ttAdapter() {
	                return this.__ttAdapter();
	            }
	        });
	        return Bloodhound;
	    }();
	    return Bloodhound;
	});
	
	(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(1) ], __WEBPACK_AMD_DEFINE_RESULT__ = function(a0) {
	            return factory(a0);
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === "object") {
	        module.exports = factory(require("jquery"));
	    } else {
	        factory(jQuery);
	    }
	})(this, function($) {
	    var _ = function() {
	        "use strict";
	        return {
	            isMsie: function() {
	                return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
	            },
	            isBlankString: function(str) {
	                return !str || /^\s*$/.test(str);
	            },
	            escapeRegExChars: function(str) {
	                return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	            },
	            isString: function(obj) {
	                return typeof obj === "string";
	            },
	            isNumber: function(obj) {
	                return typeof obj === "number";
	            },
	            isArray: $.isArray,
	            isFunction: $.isFunction,
	            isObject: $.isPlainObject,
	            isUndefined: function(obj) {
	                return typeof obj === "undefined";
	            },
	            isElement: function(obj) {
	                return !!(obj && obj.nodeType === 1);
	            },
	            isJQuery: function(obj) {
	                return obj instanceof $;
	            },
	            toStr: function toStr(s) {
	                return _.isUndefined(s) || s === null ? "" : s + "";
	            },
	            bind: $.proxy,
	            each: function(collection, cb) {
	                $.each(collection, reverseArgs);
	                function reverseArgs(index, value) {
	                    return cb(value, index);
	                }
	            },
	            map: $.map,
	            filter: $.grep,
	            every: function(obj, test) {
	                var result = true;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (!(result = test.call(null, val, key, obj))) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            some: function(obj, test) {
	                var result = false;
	                if (!obj) {
	                    return result;
	                }
	                $.each(obj, function(key, val) {
	                    if (result = test.call(null, val, key, obj)) {
	                        return false;
	                    }
	                });
	                return !!result;
	            },
	            mixin: $.extend,
	            identity: function(x) {
	                return x;
	            },
	            clone: function(obj) {
	                return $.extend(true, {}, obj);
	            },
	            getIdGenerator: function() {
	                var counter = 0;
	                return function() {
	                    return counter++;
	                };
	            },
	            templatify: function templatify(obj) {
	                return $.isFunction(obj) ? obj : template;
	                function template() {
	                    return String(obj);
	                }
	            },
	            defer: function(fn) {
	                setTimeout(fn, 0);
	            },
	            debounce: function(func, wait, immediate) {
	                var timeout, result;
	                return function() {
	                    var context = this, args = arguments, later, callNow;
	                    later = function() {
	                        timeout = null;
	                        if (!immediate) {
	                            result = func.apply(context, args);
	                        }
	                    };
	                    callNow = immediate && !timeout;
	                    clearTimeout(timeout);
	                    timeout = setTimeout(later, wait);
	                    if (callNow) {
	                        result = func.apply(context, args);
	                    }
	                    return result;
	                };
	            },
	            throttle: function(func, wait) {
	                var context, args, timeout, result, previous, later;
	                previous = 0;
	                later = function() {
	                    previous = new Date();
	                    timeout = null;
	                    result = func.apply(context, args);
	                };
	                return function() {
	                    var now = new Date(), remaining = wait - (now - previous);
	                    context = this;
	                    args = arguments;
	                    if (remaining <= 0) {
	                        clearTimeout(timeout);
	                        timeout = null;
	                        previous = now;
	                        result = func.apply(context, args);
	                    } else if (!timeout) {
	                        timeout = setTimeout(later, remaining);
	                    }
	                    return result;
	                };
	            },
	            stringify: function(val) {
	                return _.isString(val) ? val : JSON.stringify(val);
	            },
	            noop: function() {}
	        };
	    }();
	    var WWW = function() {
	        "use strict";
	        var defaultClassNames = {
	            wrapper: "twitter-typeahead",
	            input: "tt-input",
	            hint: "tt-hint",
	            menu: "tt-menu",
	            dataset: "tt-dataset",
	            suggestion: "tt-suggestion",
	            selectable: "tt-selectable",
	            empty: "tt-empty",
	            open: "tt-open",
	            cursor: "tt-cursor",
	            highlight: "tt-highlight"
	        };
	        return build;
	        function build(o) {
	            var www, classes;
	            classes = _.mixin({}, defaultClassNames, o);
	            www = {
	                css: buildCss(),
	                classes: classes,
	                html: buildHtml(classes),
	                selectors: buildSelectors(classes)
	            };
	            return {
	                css: www.css,
	                html: www.html,
	                classes: www.classes,
	                selectors: www.selectors,
	                mixin: function(o) {
	                    _.mixin(o, www);
	                }
	            };
	        }
	        function buildHtml(c) {
	            return {
	                wrapper: '<span class="' + c.wrapper + '"></span>',
	                menu: '<div class="' + c.menu + '"></div>'
	            };
	        }
	        function buildSelectors(classes) {
	            var selectors = {};
	            _.each(classes, function(v, k) {
	                selectors[k] = "." + v;
	            });
	            return selectors;
	        }
	        function buildCss() {
	            var css = {
	                wrapper: {
	                    position: "relative",
	                    display: "inline-block"
	                },
	                hint: {
	                    position: "absolute",
	                    top: "0",
	                    left: "0",
	                    borderColor: "transparent",
	                    boxShadow: "none",
	                    opacity: "1"
	                },
	                input: {
	                    position: "relative",
	                    verticalAlign: "top",
	                    backgroundColor: "transparent"
	                },
	                inputWithNoHint: {
	                    position: "relative",
	                    verticalAlign: "top"
	                },
	                menu: {
	                    position: "absolute",
	                    top: "100%",
	                    left: "0",
	                    zIndex: "100",
	                    display: "none"
	                },
	                ltr: {
	                    left: "0",
	                    right: "auto"
	                },
	                rtl: {
	                    left: "auto",
	                    right: " 0"
	                }
	            };
	            if (_.isMsie()) {
	                _.mixin(css.input, {
	                    backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
	                });
	            }
	            return css;
	        }
	    }();
	    var EventBus = function() {
	        "use strict";
	        var namespace, deprecationMap;
	        namespace = "typeahead:";
	        deprecationMap = {
	            render: "rendered",
	            cursorchange: "cursorchanged",
	            select: "selected",
	            autocomplete: "autocompleted"
	        };
	        function EventBus(o) {
	            if (!o || !o.el) {
	                $.error("EventBus initialized without el");
	            }
	            this.$el = $(o.el);
	        }
	        _.mixin(EventBus.prototype, {
	            _trigger: function(type, args) {
	                var $e;
	                $e = $.Event(namespace + type);
	                (args = args || []).unshift($e);
	                this.$el.trigger.apply(this.$el, args);
	                return $e;
	            },
	            before: function(type) {
	                var args, $e;
	                args = [].slice.call(arguments, 1);
	                $e = this._trigger("before" + type, args);
	                return $e.isDefaultPrevented();
	            },
	            trigger: function(type) {
	                var deprecatedType;
	                this._trigger(type, [].slice.call(arguments, 1));
	                if (deprecatedType = deprecationMap[type]) {
	                    this._trigger(deprecatedType, [].slice.call(arguments, 1));
	                }
	            }
	        });
	        return EventBus;
	    }();
	    var EventEmitter = function() {
	        "use strict";
	        var splitter = /\s+/, nextTick = getNextTick();
	        return {
	            onSync: onSync,
	            onAsync: onAsync,
	            off: off,
	            trigger: trigger
	        };
	        function on(method, types, cb, context) {
	            var type;
	            if (!cb) {
	                return this;
	            }
	            types = types.split(splitter);
	            cb = context ? bindContext(cb, context) : cb;
	            this._callbacks = this._callbacks || {};
	            while (type = types.shift()) {
	                this._callbacks[type] = this._callbacks[type] || {
	                    sync: [],
	                    async: []
	                };
	                this._callbacks[type][method].push(cb);
	            }
	            return this;
	        }
	        function onAsync(types, cb, context) {
	            return on.call(this, "async", types, cb, context);
	        }
	        function onSync(types, cb, context) {
	            return on.call(this, "sync", types, cb, context);
	        }
	        function off(types) {
	            var type;
	            if (!this._callbacks) {
	                return this;
	            }
	            types = types.split(splitter);
	            while (type = types.shift()) {
	                delete this._callbacks[type];
	            }
	            return this;
	        }
	        function trigger(types) {
	            var type, callbacks, args, syncFlush, asyncFlush;
	            if (!this._callbacks) {
	                return this;
	            }
	            types = types.split(splitter);
	            args = [].slice.call(arguments, 1);
	            while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
	                syncFlush = getFlush(callbacks.sync, this, [ type ].concat(args));
	                asyncFlush = getFlush(callbacks.async, this, [ type ].concat(args));
	                syncFlush() && nextTick(asyncFlush);
	            }
	            return this;
	        }
	        function getFlush(callbacks, context, args) {
	            return flush;
	            function flush() {
	                var cancelled;
	                for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
	                    cancelled = callbacks[i].apply(context, args) === false;
	                }
	                return !cancelled;
	            }
	        }
	        function getNextTick() {
	            var nextTickFn;
	            if (window.setImmediate) {
	                nextTickFn = function nextTickSetImmediate(fn) {
	                    setImmediate(function() {
	                        fn();
	                    });
	                };
	            } else {
	                nextTickFn = function nextTickSetTimeout(fn) {
	                    setTimeout(function() {
	                        fn();
	                    }, 0);
	                };
	            }
	            return nextTickFn;
	        }
	        function bindContext(fn, context) {
	            return fn.bind ? fn.bind(context) : function() {
	                fn.apply(context, [].slice.call(arguments, 0));
	            };
	        }
	    }();
	    var highlight = function(doc) {
	        "use strict";
	        var defaults = {
	            node: null,
	            pattern: null,
	            tagName: "strong",
	            className: null,
	            wordsOnly: false,
	            caseSensitive: false
	        };
	        return function hightlight(o) {
	            var regex;
	            o = _.mixin({}, defaults, o);
	            if (!o.node || !o.pattern) {
	                return;
	            }
	            o.pattern = _.isArray(o.pattern) ? o.pattern : [ o.pattern ];
	            regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
	            traverse(o.node, hightlightTextNode);
	            function hightlightTextNode(textNode) {
	                var match, patternNode, wrapperNode;
	                if (match = regex.exec(textNode.data)) {
	                    wrapperNode = doc.createElement(o.tagName);
	                    o.className && (wrapperNode.className = o.className);
	                    patternNode = textNode.splitText(match.index);
	                    patternNode.splitText(match[0].length);
	                    wrapperNode.appendChild(patternNode.cloneNode(true));
	                    textNode.parentNode.replaceChild(wrapperNode, patternNode);
	                }
	                return !!match;
	            }
	            function traverse(el, hightlightTextNode) {
	                var childNode, TEXT_NODE_TYPE = 3;
	                for (var i = 0; i < el.childNodes.length; i++) {
	                    childNode = el.childNodes[i];
	                    if (childNode.nodeType === TEXT_NODE_TYPE) {
	                        i += hightlightTextNode(childNode) ? 1 : 0;
	                    } else {
	                        traverse(childNode, hightlightTextNode);
	                    }
	                }
	            }
	        };
	        function getRegex(patterns, caseSensitive, wordsOnly) {
	            var escapedPatterns = [], regexStr;
	            for (var i = 0, len = patterns.length; i < len; i++) {
	                escapedPatterns.push(_.escapeRegExChars(patterns[i]));
	            }
	            regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
	            return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
	        }
	    }(window.document);
	    var Input = function() {
	        "use strict";
	        var specialKeyCodeMap;
	        specialKeyCodeMap = {
	            9: "tab",
	            27: "esc",
	            37: "left",
	            39: "right",
	            13: "enter",
	            38: "up",
	            40: "down"
	        };
	        function Input(o, www) {
	            o = o || {};
	            if (!o.input) {
	                $.error("input is missing");
	            }
	            www.mixin(this);
	            this.$hint = $(o.hint);
	            this.$input = $(o.input);
	            this.query = this.$input.val();
	            this.queryWhenFocused = this.hasFocus() ? this.query : null;
	            this.$overflowHelper = buildOverflowHelper(this.$input);
	            this._checkLanguageDirection();
	            if (this.$hint.length === 0) {
	                this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
	            }
	        }
	        Input.normalizeQuery = function(str) {
	            return _.toStr(str).replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
	        };
	        _.mixin(Input.prototype, EventEmitter, {
	            _onBlur: function onBlur() {
	                this.resetInputValue();
	                this.trigger("blurred");
	            },
	            _onFocus: function onFocus() {
	                this.queryWhenFocused = this.query;
	                this.trigger("focused");
	            },
	            _onKeydown: function onKeydown($e) {
	                var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
	                this._managePreventDefault(keyName, $e);
	                if (keyName && this._shouldTrigger(keyName, $e)) {
	                    this.trigger(keyName + "Keyed", $e);
	                }
	            },
	            _onInput: function onInput() {
	                this._setQuery(this.getInputValue());
	                this.clearHintIfInvalid();
	                this._checkLanguageDirection();
	            },
	            _managePreventDefault: function managePreventDefault(keyName, $e) {
	                var preventDefault;
	                switch (keyName) {
	                  case "up":
	                  case "down":
	                    preventDefault = !withModifier($e);
	                    break;
	
	                  default:
	                    preventDefault = false;
	                }
	                preventDefault && $e.preventDefault();
	            },
	            _shouldTrigger: function shouldTrigger(keyName, $e) {
	                var trigger;
	                switch (keyName) {
	                  case "tab":
	                    trigger = !withModifier($e);
	                    break;
	
	                  default:
	                    trigger = true;
	                }
	                return trigger;
	            },
	            _checkLanguageDirection: function checkLanguageDirection() {
	                var dir = (this.$input.css("direction") || "ltr").toLowerCase();
	                if (this.dir !== dir) {
	                    this.dir = dir;
	                    this.$hint.attr("dir", dir);
	                    this.trigger("langDirChanged", dir);
	                }
	            },
	            _setQuery: function setQuery(val, silent) {
	                var areEquivalent, hasDifferentWhitespace;
	                areEquivalent = areQueriesEquivalent(val, this.query);
	                hasDifferentWhitespace = areEquivalent ? this.query.length !== val.length : false;
	                this.query = val;
	                if (!silent && !areEquivalent) {
	                    this.trigger("queryChanged", this.query);
	                } else if (!silent && hasDifferentWhitespace) {
	                    this.trigger("whitespaceChanged", this.query);
	                }
	            },
	            bind: function() {
	                var that = this, onBlur, onFocus, onKeydown, onInput;
	                onBlur = _.bind(this._onBlur, this);
	                onFocus = _.bind(this._onFocus, this);
	                onKeydown = _.bind(this._onKeydown, this);
	                onInput = _.bind(this._onInput, this);
	                this.$input.on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
	                if (!_.isMsie() || _.isMsie() > 9) {
	                    this.$input.on("input.tt", onInput);
	                } else {
	                    this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function($e) {
	                        if (specialKeyCodeMap[$e.which || $e.keyCode]) {
	                            return;
	                        }
	                        _.defer(_.bind(that._onInput, that, $e));
	                    });
	                }
	                return this;
	            },
	            focus: function focus() {
	                this.$input.focus();
	            },
	            blur: function blur() {
	                this.$input.blur();
	            },
	            getLangDir: function getLangDir() {
	                return this.dir;
	            },
	            getQuery: function getQuery() {
	                return this.query || "";
	            },
	            setQuery: function setQuery(val, silent) {
	                this.setInputValue(val);
	                this._setQuery(val, silent);
	            },
	            hasQueryChangedSinceLastFocus: function hasQueryChangedSinceLastFocus() {
	                return this.query !== this.queryWhenFocused;
	            },
	            getInputValue: function getInputValue() {
	                return this.$input.val();
	            },
	            setInputValue: function setInputValue(value) {
	                this.$input.val(value);
	                this.clearHintIfInvalid();
	                this._checkLanguageDirection();
	            },
	            resetInputValue: function resetInputValue() {
	                this.setInputValue(this.query);
	            },
	            getHint: function getHint() {
	                return this.$hint.val();
	            },
	            setHint: function setHint(value) {
	                this.$hint.val(value);
	            },
	            clearHint: function clearHint() {
	                this.setHint("");
	            },
	            clearHintIfInvalid: function clearHintIfInvalid() {
	                var val, hint, valIsPrefixOfHint, isValid;
	                val = this.getInputValue();
	                hint = this.getHint();
	                valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
	                isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
	                !isValid && this.clearHint();
	            },
	            hasFocus: function hasFocus() {
	                return this.$input.is(":focus");
	            },
	            hasOverflow: function hasOverflow() {
	                var constraint = this.$input.width() - 2;
	                this.$overflowHelper.text(this.getInputValue());
	                return this.$overflowHelper.width() >= constraint;
	            },
	            isCursorAtEnd: function() {
	                var valueLength, selectionStart, range;
	                valueLength = this.$input.val().length;
	                selectionStart = this.$input[0].selectionStart;
	                if (_.isNumber(selectionStart)) {
	                    return selectionStart === valueLength;
	                } else if (document.selection) {
	                    range = document.selection.createRange();
	                    range.moveStart("character", -valueLength);
	                    return valueLength === range.text.length;
	                }
	                return true;
	            },
	            destroy: function destroy() {
	                this.$hint.off(".tt");
	                this.$input.off(".tt");
	                this.$overflowHelper.remove();
	                this.$hint = this.$input = this.$overflowHelper = $("<div>");
	            }
	        });
	        return Input;
	        function buildOverflowHelper($input) {
	            return $('<pre aria-hidden="true"></pre>').css({
	                position: "absolute",
	                visibility: "hidden",
	                whiteSpace: "pre",
	                fontFamily: $input.css("font-family"),
	                fontSize: $input.css("font-size"),
	                fontStyle: $input.css("font-style"),
	                fontVariant: $input.css("font-variant"),
	                fontWeight: $input.css("font-weight"),
	                wordSpacing: $input.css("word-spacing"),
	                letterSpacing: $input.css("letter-spacing"),
	                textIndent: $input.css("text-indent"),
	                textRendering: $input.css("text-rendering"),
	                textTransform: $input.css("text-transform")
	            }).insertAfter($input);
	        }
	        function areQueriesEquivalent(a, b) {
	            return Input.normalizeQuery(a) === Input.normalizeQuery(b);
	        }
	        function withModifier($e) {
	            return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
	        }
	    }();
	    var Dataset = function() {
	        "use strict";
	        var keys, nameGenerator;
	        keys = {
	            val: "tt-selectable-display",
	            obj: "tt-selectable-object"
	        };
	        nameGenerator = _.getIdGenerator();
	        function Dataset(o, www) {
	            o = o || {};
	            o.templates = o.templates || {};
	            o.templates.notFound = o.templates.notFound || o.templates.empty;
	            if (!o.source) {
	                $.error("missing source");
	            }
	            if (!o.node) {
	                $.error("missing node");
	            }
	            if (o.name && !isValidName(o.name)) {
	                $.error("invalid dataset name: " + o.name);
	            }
	            www.mixin(this);
	            this.highlight = !!o.highlight;
	            this.name = o.name || nameGenerator();
	            this.limit = o.limit || 5;
	            this.displayFn = getDisplayFn(o.display || o.displayKey);
	            this.templates = getTemplates(o.templates, this.displayFn);
	            this.source = o.source.__ttAdapter ? o.source.__ttAdapter() : o.source;
	            this.async = _.isUndefined(o.async) ? this.source.length > 2 : !!o.async;
	            this._resetLastSuggestion();
	            this.$el = $(o.node).addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name);
	        }
	        Dataset.extractData = function extractData(el) {
	            var $el = $(el);
	            if ($el.data(keys.obj)) {
	                return {
	                    val: $el.data(keys.val) || "",
	                    obj: $el.data(keys.obj) || null
	                };
	            }
	            return null;
	        };
	        _.mixin(Dataset.prototype, EventEmitter, {
	            _overwrite: function overwrite(query, suggestions) {
	                suggestions = suggestions || [];
	                if (suggestions.length) {
	                    this._renderSuggestions(query, suggestions);
	                } else if (this.async && this.templates.pending) {
	                    this._renderPending(query);
	                } else if (!this.async && this.templates.notFound) {
	                    this._renderNotFound(query);
	                } else {
	                    this._empty();
	                }
	                this.trigger("rendered", this.name, suggestions, false);
	            },
	            _append: function append(query, suggestions) {
	                suggestions = suggestions || [];
	                if (suggestions.length && this.$lastSuggestion.length) {
	                    this._appendSuggestions(query, suggestions);
	                } else if (suggestions.length) {
	                    this._renderSuggestions(query, suggestions);
	                } else if (!this.$lastSuggestion.length && this.templates.notFound) {
	                    this._renderNotFound(query);
	                }
	                this.trigger("rendered", this.name, suggestions, true);
	            },
	            _renderSuggestions: function renderSuggestions(query, suggestions) {
	                var $fragment;
	                $fragment = this._getSuggestionsFragment(query, suggestions);
	                this.$lastSuggestion = $fragment.children().last();
	                this.$el.html($fragment).prepend(this._getHeader(query, suggestions)).append(this._getFooter(query, suggestions));
	            },
	            _appendSuggestions: function appendSuggestions(query, suggestions) {
	                var $fragment, $lastSuggestion;
	                $fragment = this._getSuggestionsFragment(query, suggestions);
	                $lastSuggestion = $fragment.children().last();
	                this.$lastSuggestion.after($fragment);
	                this.$lastSuggestion = $lastSuggestion;
	            },
	            _renderPending: function renderPending(query) {
	                var template = this.templates.pending;
	                this._resetLastSuggestion();
	                template && this.$el.html(template({
	                    query: query,
	                    dataset: this.name
	                }));
	            },
	            _renderNotFound: function renderNotFound(query) {
	                var template = this.templates.notFound;
	                this._resetLastSuggestion();
	                template && this.$el.html(template({
	                    query: query,
	                    dataset: this.name
	                }));
	            },
	            _empty: function empty() {
	                this.$el.empty();
	                this._resetLastSuggestion();
	            },
	            _getSuggestionsFragment: function getSuggestionsFragment(query, suggestions) {
	                var that = this, fragment;
	                fragment = document.createDocumentFragment();
	                _.each(suggestions, function getSuggestionNode(suggestion) {
	                    var $el, context;
	                    context = that._injectQuery(query, suggestion);
	                    $el = $(that.templates.suggestion(context)).data(keys.obj, suggestion).data(keys.val, that.displayFn(suggestion)).addClass(that.classes.suggestion + " " + that.classes.selectable);
	                    fragment.appendChild($el[0]);
	                });
	                this.highlight && highlight({
	                    className: this.classes.highlight,
	                    node: fragment,
	                    pattern: query
	                });
	                return $(fragment);
	            },
	            _getFooter: function getFooter(query, suggestions) {
	                return this.templates.footer ? this.templates.footer({
	                    query: query,
	                    suggestions: suggestions,
	                    dataset: this.name
	                }) : null;
	            },
	            _getHeader: function getHeader(query, suggestions) {
	                return this.templates.header ? this.templates.header({
	                    query: query,
	                    suggestions: suggestions,
	                    dataset: this.name
	                }) : null;
	            },
	            _resetLastSuggestion: function resetLastSuggestion() {
	                this.$lastSuggestion = $();
	            },
	            _injectQuery: function injectQuery(query, obj) {
	                return _.isObject(obj) ? _.mixin({
	                    _query: query
	                }, obj) : obj;
	            },
	            update: function update(query) {
	                var that = this, canceled = false, syncCalled = false, rendered = 0;
	                this.cancel();
	                this.cancel = function cancel() {
	                    canceled = true;
	                    that.cancel = $.noop;
	                    that.async && that.trigger("asyncCanceled", query);
	                };
	                this.source(query, sync, async);
	                !syncCalled && sync([]);
	                function sync(suggestions) {
	                    if (syncCalled) {
	                        return;
	                    }
	                    syncCalled = true;
	                    suggestions = (suggestions || []).slice(0, that.limit);
	                    rendered = suggestions.length;
	                    that._overwrite(query, suggestions);
	                    if (rendered < that.limit && that.async) {
	                        that.trigger("asyncRequested", query);
	                    }
	                }
	                function async(suggestions) {
	                    suggestions = suggestions || [];
	                    if (!canceled && rendered < that.limit) {
	                        that.cancel = $.noop;
	                        rendered += suggestions.length;
	                        that._append(query, suggestions.slice(0, that.limit - rendered));
	                        that.async && that.trigger("asyncReceived", query);
	                    }
	                }
	            },
	            cancel: $.noop,
	            clear: function clear() {
	                this._empty();
	                this.cancel();
	                this.trigger("cleared");
	            },
	            isEmpty: function isEmpty() {
	                return this.$el.is(":empty");
	            },
	            destroy: function destroy() {
	                this.$el = $("<div>");
	            }
	        });
	        return Dataset;
	        function getDisplayFn(display) {
	            display = display || _.stringify;
	            return _.isFunction(display) ? display : displayFn;
	            function displayFn(obj) {
	                return obj[display];
	            }
	        }
	        function getTemplates(templates, displayFn) {
	            return {
	                notFound: templates.notFound && _.templatify(templates.notFound),
	                pending: templates.pending && _.templatify(templates.pending),
	                header: templates.header && _.templatify(templates.header),
	                footer: templates.footer && _.templatify(templates.footer),
	                suggestion: templates.suggestion || suggestionTemplate
	            };
	            function suggestionTemplate(context) {
	                return $("<div>").text(displayFn(context));
	            }
	        }
	        function isValidName(str) {
	            return /^[_a-zA-Z0-9-]+$/.test(str);
	        }
	    }();
	    var Menu = function() {
	        "use strict";
	        function Menu(o, www) {
	            var that = this;
	            o = o || {};
	            if (!o.node) {
	                $.error("node is required");
	            }
	            www.mixin(this);
	            this.$node = $(o.node);
	            this.query = null;
	            this.datasets = _.map(o.datasets, initializeDataset);
	            function initializeDataset(oDataset) {
	                var node = that.$node.find(oDataset.node).first();
	                oDataset.node = node.length ? node : $("<div>").appendTo(that.$node);
	                return new Dataset(oDataset, www);
	            }
	        }
	        _.mixin(Menu.prototype, EventEmitter, {
	            _onSelectableClick: function onSelectableClick($e) {
	                this.trigger("selectableClicked", $($e.currentTarget));
	            },
	            _onRendered: function onRendered(type, dataset, suggestions, async) {
	                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
	                this.trigger("datasetRendered", dataset, suggestions, async);
	            },
	            _onCleared: function onCleared() {
	                this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
	                this.trigger("datasetCleared");
	            },
	            _propagate: function propagate() {
	                this.trigger.apply(this, arguments);
	            },
	            _allDatasetsEmpty: function allDatasetsEmpty() {
	                return _.every(this.datasets, isDatasetEmpty);
	                function isDatasetEmpty(dataset) {
	                    return dataset.isEmpty();
	                }
	            },
	            _getSelectables: function getSelectables() {
	                return this.$node.find(this.selectors.selectable);
	            },
	            _removeCursor: function _removeCursor() {
	                var $selectable = this.getActiveSelectable();
	                $selectable && $selectable.removeClass(this.classes.cursor);
	            },
	            _ensureVisible: function ensureVisible($el) {
	                var elTop, elBottom, nodeScrollTop, nodeHeight;
	                elTop = $el.position().top;
	                elBottom = elTop + $el.outerHeight(true);
	                nodeScrollTop = this.$node.scrollTop();
	                nodeHeight = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10);
	                if (elTop < 0) {
	                    this.$node.scrollTop(nodeScrollTop + elTop);
	                } else if (nodeHeight < elBottom) {
	                    this.$node.scrollTop(nodeScrollTop + (elBottom - nodeHeight));
	                }
	            },
	            bind: function() {
	                var that = this, onSelectableClick;
	                onSelectableClick = _.bind(this._onSelectableClick, this);
	                this.$node.on("click.tt", this.selectors.selectable, onSelectableClick);
	                _.each(this.datasets, function(dataset) {
	                    dataset.onSync("asyncRequested", that._propagate, that).onSync("asyncCanceled", that._propagate, that).onSync("asyncReceived", that._propagate, that).onSync("rendered", that._onRendered, that).onSync("cleared", that._onCleared, that);
	                });
	                return this;
	            },
	            isOpen: function isOpen() {
	                return this.$node.hasClass(this.classes.open);
	            },
	            open: function open() {
	                this.$node.addClass(this.classes.open);
	            },
	            close: function close() {
	                this.$node.removeClass(this.classes.open);
	                this._removeCursor();
	            },
	            setLanguageDirection: function setLanguageDirection(dir) {
	                this.$node.attr("dir", dir);
	            },
	            selectableRelativeToCursor: function selectableRelativeToCursor(delta) {
	                var $selectables, $oldCursor, oldIndex, newIndex;
	                $oldCursor = this.getActiveSelectable();
	                $selectables = this._getSelectables();
	                oldIndex = $oldCursor ? $selectables.index($oldCursor) : -1;
	                newIndex = oldIndex + delta;
	                newIndex = (newIndex + 1) % ($selectables.length + 1) - 1;
	                newIndex = newIndex < -1 ? $selectables.length - 1 : newIndex;
	                return newIndex === -1 ? null : $selectables.eq(newIndex);
	            },
	            setCursor: function setCursor($selectable) {
	                this._removeCursor();
	                if ($selectable = $selectable && $selectable.first()) {
	                    $selectable.addClass(this.classes.cursor);
	                    this._ensureVisible($selectable);
	                }
	            },
	            getSelectableData: function getSelectableData($el) {
	                return $el && $el.length ? Dataset.extractData($el) : null;
	            },
	            getActiveSelectable: function getActiveSelectable() {
	                var $selectable = this._getSelectables().filter(this.selectors.cursor).first();
	                return $selectable.length ? $selectable : null;
	            },
	            getTopSelectable: function getTopSelectable() {
	                var $selectable = this._getSelectables().first();
	                return $selectable.length ? $selectable : null;
	            },
	            update: function update(query) {
	                var isValidUpdate = query !== this.query;
	                if (isValidUpdate) {
	                    this.query = query;
	                    _.each(this.datasets, updateDataset);
	                }
	                return isValidUpdate;
	                function updateDataset(dataset) {
	                    dataset.update(query);
	                }
	            },
	            empty: function empty() {
	                _.each(this.datasets, clearDataset);
	                this.query = null;
	                this.$node.addClass(this.classes.empty);
	                function clearDataset(dataset) {
	                    dataset.clear();
	                }
	            },
	            destroy: function destroy() {
	                this.$node.off(".tt");
	                this.$node = $("<div>");
	                _.each(this.datasets, destroyDataset);
	                function destroyDataset(dataset) {
	                    dataset.destroy();
	                }
	            }
	        });
	        return Menu;
	    }();
	    var DefaultMenu = function() {
	        "use strict";
	        var s = Menu.prototype;
	        function DefaultMenu() {
	            Menu.apply(this, [].slice.call(arguments, 0));
	        }
	        _.mixin(DefaultMenu.prototype, Menu.prototype, {
	            open: function open() {
	                !this._allDatasetsEmpty() && this._show();
	                return s.open.apply(this, [].slice.call(arguments, 0));
	            },
	            close: function close() {
	                this._hide();
	                return s.close.apply(this, [].slice.call(arguments, 0));
	            },
	            _onRendered: function onRendered() {
	                if (this._allDatasetsEmpty()) {
	                    this._hide();
	                } else {
	                    this.isOpen() && this._show();
	                }
	                return s._onRendered.apply(this, [].slice.call(arguments, 0));
	            },
	            _onCleared: function onCleared() {
	                if (this._allDatasetsEmpty()) {
	                    this._hide();
	                } else {
	                    this.isOpen() && this._show();
	                }
	                return s._onCleared.apply(this, [].slice.call(arguments, 0));
	            },
	            setLanguageDirection: function setLanguageDirection(dir) {
	                this.$node.css(dir === "ltr" ? this.css.ltr : this.css.rtl);
	                return s.setLanguageDirection.apply(this, [].slice.call(arguments, 0));
	            },
	            _hide: function hide() {
	                this.$node.hide();
	            },
	            _show: function show() {
	                this.$node.css("display", "block");
	            }
	        });
	        return DefaultMenu;
	    }();
	    var Typeahead = function() {
	        "use strict";
	        function Typeahead(o, www) {
	            var onFocused, onBlurred, onEnterKeyed, onTabKeyed, onEscKeyed, onUpKeyed, onDownKeyed, onLeftKeyed, onRightKeyed, onQueryChanged, onWhitespaceChanged;
	            o = o || {};
	            if (!o.input) {
	                $.error("missing input");
	            }
	            if (!o.menu) {
	                $.error("missing menu");
	            }
	            if (!o.eventBus) {
	                $.error("missing event bus");
	            }
	            www.mixin(this);
	            this.eventBus = o.eventBus;
	            this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
	            this.input = o.input;
	            this.menu = o.menu;
	            this.enabled = true;
	            this.active = false;
	            this.input.hasFocus() && this.activate();
	            this.dir = this.input.getLangDir();
	            this._hacks();
	            this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this);
	            onFocused = c(this, "activate", "open", "_onFocused");
	            onBlurred = c(this, "deactivate", "_onBlurred");
	            onEnterKeyed = c(this, "isActive", "isOpen", "_onEnterKeyed");
	            onTabKeyed = c(this, "isActive", "isOpen", "_onTabKeyed");
	            onEscKeyed = c(this, "isActive", "_onEscKeyed");
	            onUpKeyed = c(this, "isActive", "open", "_onUpKeyed");
	            onDownKeyed = c(this, "isActive", "open", "_onDownKeyed");
	            onLeftKeyed = c(this, "isActive", "isOpen", "_onLeftKeyed");
	            onRightKeyed = c(this, "isActive", "isOpen", "_onRightKeyed");
	            onQueryChanged = c(this, "_openIfActive", "_onQueryChanged");
	            onWhitespaceChanged = c(this, "_openIfActive", "_onWhitespaceChanged");
	            this.input.bind().onSync("focused", onFocused, this).onSync("blurred", onBlurred, this).onSync("enterKeyed", onEnterKeyed, this).onSync("tabKeyed", onTabKeyed, this).onSync("escKeyed", onEscKeyed, this).onSync("upKeyed", onUpKeyed, this).onSync("downKeyed", onDownKeyed, this).onSync("leftKeyed", onLeftKeyed, this).onSync("rightKeyed", onRightKeyed, this).onSync("queryChanged", onQueryChanged, this).onSync("whitespaceChanged", onWhitespaceChanged, this).onSync("langDirChanged", this._onLangDirChanged, this);
	        }
	        _.mixin(Typeahead.prototype, {
	            _hacks: function hacks() {
	                var $input, $menu;
	                $input = this.input.$input || $("<div>");
	                $menu = this.menu.$node || $("<div>");
	                $input.on("blur.tt", function($e) {
	                    var active, isActive, hasActive;
	                    active = document.activeElement;
	                    isActive = $menu.is(active);
	                    hasActive = $menu.has(active).length > 0;
	                    if (_.isMsie() && (isActive || hasActive)) {
	                        $e.preventDefault();
	                        $e.stopImmediatePropagation();
	                        _.defer(function() {
	                            $input.focus();
	                        });
	                    }
	                });
	                $menu.on("mousedown.tt", function($e) {
	                    $e.preventDefault();
	                });
	            },
	            _onSelectableClicked: function onSelectableClicked(type, $el) {
	                this.select($el);
	            },
	            _onDatasetCleared: function onDatasetCleared() {
	                this._updateHint();
	            },
	            _onDatasetRendered: function onDatasetRendered(type, dataset, suggestions, async) {
	                this._updateHint();
	                this.eventBus.trigger("render", suggestions, async, dataset);
	            },
	            _onAsyncRequested: function onAsyncRequested(type, dataset, query) {
	                this.eventBus.trigger("asyncrequest", query, dataset);
	            },
	            _onAsyncCanceled: function onAsyncCanceled(type, dataset, query) {
	                this.eventBus.trigger("asynccancel", query, dataset);
	            },
	            _onAsyncReceived: function onAsyncReceived(type, dataset, query) {
	                this.eventBus.trigger("asyncreceive", query, dataset);
	            },
	            _onFocused: function onFocused() {
	                this._minLengthMet() && this.menu.update(this.input.getQuery());
	            },
	            _onBlurred: function onBlurred() {
	                if (this.input.hasQueryChangedSinceLastFocus()) {
	                    this.eventBus.trigger("change", this.input.getQuery());
	                }
	            },
	            _onEnterKeyed: function onEnterKeyed(type, $e) {
	                var $selectable;
	                if ($selectable = this.menu.getActiveSelectable()) {
	                    this.select($selectable) && $e.preventDefault();
	                }
	            },
	            _onTabKeyed: function onTabKeyed(type, $e) {
	                var $selectable;
	                if ($selectable = this.menu.getActiveSelectable()) {
	                    this.select($selectable) && $e.preventDefault();
	                } else if ($selectable = this.menu.getTopSelectable()) {
	                    this.autocomplete($selectable) && $e.preventDefault();
	                }
	            },
	            _onEscKeyed: function onEscKeyed() {
	                this.close();
	            },
	            _onUpKeyed: function onUpKeyed() {
	                this.moveCursor(-1);
	            },
	            _onDownKeyed: function onDownKeyed() {
	                this.moveCursor(+1);
	            },
	            _onLeftKeyed: function onLeftKeyed() {
	                if (this.dir === "rtl" && this.input.isCursorAtEnd()) {
	                    this.autocomplete(this.menu.getTopSelectable());
	                }
	            },
	            _onRightKeyed: function onRightKeyed() {
	                if (this.dir === "ltr" && this.input.isCursorAtEnd()) {
	                    this.autocomplete(this.menu.getTopSelectable());
	                }
	            },
	            _onQueryChanged: function onQueryChanged(e, query) {
	                this._minLengthMet(query) ? this.menu.update(query) : this.menu.empty();
	            },
	            _onWhitespaceChanged: function onWhitespaceChanged() {
	                this._updateHint();
	            },
	            _onLangDirChanged: function onLangDirChanged(e, dir) {
	                if (this.dir !== dir) {
	                    this.dir = dir;
	                    this.menu.setLanguageDirection(dir);
	                }
	            },
	            _openIfActive: function openIfActive() {
	                this.isActive() && this.open();
	            },
	            _minLengthMet: function minLengthMet(query) {
	                query = _.isString(query) ? query : this.input.getQuery() || "";
	                return query.length >= this.minLength;
	            },
	            _updateHint: function updateHint() {
	                var $selectable, data, val, query, escapedQuery, frontMatchRegEx, match;
	                $selectable = this.menu.getTopSelectable();
	                data = this.menu.getSelectableData($selectable);
	                val = this.input.getInputValue();
	                if (data && !_.isBlankString(val) && !this.input.hasOverflow()) {
	                    query = Input.normalizeQuery(val);
	                    escapedQuery = _.escapeRegExChars(query);
	                    frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
	                    match = frontMatchRegEx.exec(data.val);
	                    match && this.input.setHint(val + match[1]);
	                } else {
	                    this.input.clearHint();
	                }
	            },
	            isEnabled: function isEnabled() {
	                return this.enabled;
	            },
	            enable: function enable() {
	                this.enabled = true;
	            },
	            disable: function disable() {
	                this.enabled = false;
	            },
	            isActive: function isActive() {
	                return this.active;
	            },
	            activate: function activate() {
	                if (this.isActive()) {
	                    return true;
	                } else if (!this.isEnabled() || this.eventBus.before("active")) {
	                    return false;
	                } else {
	                    this.active = true;
	                    this.eventBus.trigger("active");
	                    return true;
	                }
	            },
	            deactivate: function deactivate() {
	                if (!this.isActive()) {
	                    return true;
	                } else if (this.eventBus.before("idle")) {
	                    return false;
	                } else {
	                    this.active = false;
	                    this.close();
	                    this.eventBus.trigger("idle");
	                    return true;
	                }
	            },
	            isOpen: function isOpen() {
	                return this.menu.isOpen();
	            },
	            open: function open() {
	                if (!this.isOpen() && !this.eventBus.before("open")) {
	                    this.menu.open();
	                    this._updateHint();
	                    this.eventBus.trigger("open");
	                }
	                return this.isOpen();
	            },
	            close: function close() {
	                if (this.isOpen() && !this.eventBus.before("close")) {
	                    this.menu.close();
	                    this.input.clearHint();
	                    this.input.resetInputValue();
	                    this.eventBus.trigger("close");
	                }
	                return !this.isOpen();
	            },
	            setVal: function setVal(val) {
	                this.input.setQuery(_.toStr(val));
	            },
	            getVal: function getVal() {
	                return this.input.getQuery();
	            },
	            select: function select($selectable) {
	                var data = this.menu.getSelectableData($selectable);
	                if (data && !this.eventBus.before("select", data.obj)) {
	                    this.input.setQuery(data.val, true);
	                    this.eventBus.trigger("select", data.obj);
	                    this.close();
	                    return true;
	                }
	                return false;
	            },
	            autocomplete: function autocomplete($selectable) {
	                var query, data, isValid;
	                query = this.input.getQuery();
	                data = this.menu.getSelectableData($selectable);
	                isValid = data && query !== data.val;
	                if (isValid && !this.eventBus.before("autocomplete", data.obj)) {
	                    this.input.setQuery(data.val);
	                    this.eventBus.trigger("autocomplete", data.obj);
	                    return true;
	                }
	                return false;
	            },
	            moveCursor: function moveCursor(delta) {
	                var query, $candidate, data, payload, cancelMove;
	                query = this.input.getQuery();
	                $candidate = this.menu.selectableRelativeToCursor(delta);
	                data = this.menu.getSelectableData($candidate);
	                payload = data ? data.obj : null;
	                cancelMove = this._minLengthMet() && this.menu.update(query);
	                if (!cancelMove && !this.eventBus.before("cursorchange", payload)) {
	                    this.menu.setCursor($candidate);
	                    if (data) {
	                        this.input.setInputValue(data.val);
	                    } else {
	                        this.input.resetInputValue();
	                        this._updateHint();
	                    }
	                    this.eventBus.trigger("cursorchange", payload);
	                    return true;
	                }
	                return false;
	            },
	            destroy: function destroy() {
	                this.input.destroy();
	                this.menu.destroy();
	            }
	        });
	        return Typeahead;
	        function c(ctx) {
	            var methods = [].slice.call(arguments, 1);
	            return function() {
	                var args = [].slice.call(arguments);
	                _.each(methods, function(method) {
	                    return ctx[method].apply(ctx, args);
	                });
	            };
	        }
	    }();
	    (function() {
	        "use strict";
	        var old, keys, methods;
	        old = $.fn.typeahead;
	        keys = {
	            www: "tt-www",
	            attrs: "tt-attrs",
	            typeahead: "tt-typeahead"
	        };
	        methods = {
	            initialize: function initialize(o, datasets) {
	                var www;
	                datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
	                o = o || {};
	                www = WWW(o.classNames);
	                return this.each(attach);
	                function attach() {
	                    var $input, $wrapper, $hint, $menu, defaultHint, defaultMenu, eventBus, input, menu, typeahead, MenuConstructor;
	                    _.each(datasets, function(d) {
	                        d.highlight = !!o.highlight;
	                    });
	                    $input = $(this);
	                    $wrapper = $(www.html.wrapper);
	                    $hint = $elOrNull(o.hint);
	                    $menu = $elOrNull(o.menu);
	                    defaultHint = o.hint !== false && !$hint;
	                    defaultMenu = o.menu !== false && !$menu;
	                    defaultHint && ($hint = buildHintFromInput($input, www));
	                    defaultMenu && ($menu = $(www.html.menu).css(www.css.menu));
	                    $hint && $hint.val("");
	                    $input = prepInput($input, www);
	                    if (defaultHint || defaultMenu) {
	                        $wrapper.css(www.css.wrapper);
	                        $input.css(defaultHint ? www.css.input : www.css.inputWithNoHint);
	                        $input.wrap($wrapper).parent().prepend(defaultHint ? $hint : null).append(defaultMenu ? $menu : null);
	                    }
	                    MenuConstructor = defaultMenu ? DefaultMenu : Menu;
	                    eventBus = new EventBus({
	                        el: $input
	                    });
	                    input = new Input({
	                        hint: $hint,
	                        input: $input
	                    }, www);
	                    menu = new MenuConstructor({
	                        node: $menu,
	                        datasets: datasets
	                    }, www);
	                    typeahead = new Typeahead({
	                        input: input,
	                        menu: menu,
	                        eventBus: eventBus,
	                        minLength: o.minLength
	                    }, www);
	                    $input.data(keys.www, www);
	                    $input.data(keys.typeahead, typeahead);
	                }
	            },
	            isEnabled: function isEnabled() {
	                var enabled;
	                ttEach(this.first(), function(t) {
	                    enabled = t.isEnabled();
	                });
	                return enabled;
	            },
	            enable: function enable() {
	                ttEach(this, function(t) {
	                    t.enable();
	                });
	                return this;
	            },
	            disable: function disable() {
	                ttEach(this, function(t) {
	                    t.disable();
	                });
	                return this;
	            },
	            isActive: function isActive() {
	                var active;
	                ttEach(this.first(), function(t) {
	                    active = t.isActive();
	                });
	                return active;
	            },
	            activate: function activate() {
	                ttEach(this, function(t) {
	                    t.activate();
	                });
	                return this;
	            },
	            deactivate: function deactivate() {
	                ttEach(this, function(t) {
	                    t.deactivate();
	                });
	                return this;
	            },
	            isOpen: function isOpen() {
	                var open;
	                ttEach(this.first(), function(t) {
	                    open = t.isOpen();
	                });
	                return open;
	            },
	            open: function open() {
	                ttEach(this, function(t) {
	                    t.open();
	                });
	                return this;
	            },
	            close: function close() {
	                ttEach(this, function(t) {
	                    t.close();
	                });
	                return this;
	            },
	            select: function select(el) {
	                var success = false, $el = $(el);
	                ttEach(this.first(), function(t) {
	                    success = t.select($el);
	                });
	                return success;
	            },
	            autocomplete: function autocomplete(el) {
	                var success = false, $el = $(el);
	                ttEach(this.first(), function(t) {
	                    success = t.autocomplete($el);
	                });
	                return success;
	            },
	            moveCursor: function moveCursoe(delta) {
	                var success = false;
	                ttEach(this.first(), function(t) {
	                    success = t.moveCursor(delta);
	                });
	                return success;
	            },
	            val: function val(newVal) {
	                var query;
	                if (!arguments.length) {
	                    ttEach(this.first(), function(t) {
	                        query = t.getVal();
	                    });
	                    return query;
	                } else {
	                    ttEach(this, function(t) {
	                        t.setVal(newVal);
	                    });
	                    return this;
	                }
	            },
	            destroy: function destroy() {
	                ttEach(this, function(typeahead, $input) {
	                    revert($input);
	                    typeahead.destroy();
	                });
	                return this;
	            }
	        };
	        $.fn.typeahead = function(method) {
	            if (methods[method]) {
	                return methods[method].apply(this, [].slice.call(arguments, 1));
	            } else {
	                return methods.initialize.apply(this, arguments);
	            }
	        };
	        $.fn.typeahead.noConflict = function noConflict() {
	            $.fn.typeahead = old;
	            return this;
	        };
	        function ttEach($els, fn) {
	            $els.each(function() {
	                var $input = $(this), typeahead;
	                (typeahead = $input.data(keys.typeahead)) && fn(typeahead, $input);
	            });
	        }
	        function buildHintFromInput($input, www) {
	            return $input.clone().addClass(www.classes.hint).removeData().css(www.css.hint).css(getBackgroundStyles($input)).prop("readonly", true).removeAttr("id name placeholder required").attr({
	                autocomplete: "off",
	                spellcheck: "false",
	                tabindex: -1
	            });
	        }
	        function prepInput($input, www) {
	            $input.data(keys.attrs, {
	                dir: $input.attr("dir"),
	                autocomplete: $input.attr("autocomplete"),
	                spellcheck: $input.attr("spellcheck"),
	                style: $input.attr("style")
	            });
	            $input.addClass(www.classes.input).attr({
	                autocomplete: "off",
	                spellcheck: false
	            });
	            try {
	                !$input.attr("dir") && $input.attr("dir", "auto");
	            } catch (e) {}
	            return $input;
	        }
	        function getBackgroundStyles($el) {
	            return {
	                backgroundAttachment: $el.css("background-attachment"),
	                backgroundClip: $el.css("background-clip"),
	                backgroundColor: $el.css("background-color"),
	                backgroundImage: $el.css("background-image"),
	                backgroundOrigin: $el.css("background-origin"),
	                backgroundPosition: $el.css("background-position"),
	                backgroundRepeat: $el.css("background-repeat"),
	                backgroundSize: $el.css("background-size")
	            };
	        }
	        function revert($input) {
	            var www, $wrapper;
	            www = $input.data(keys.www);
	            $wrapper = $input.parent().filter(www.selectors.wrapper);
	            _.each($input.data(keys.attrs), function(val, key) {
	                _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
	            });
	            $input.removeData(keys.typeahead).removeData(keys.www).removeData(keys.attr).removeClass(www.classes.input);
	            if ($wrapper.length) {
	                $input.detach().insertAfter($wrapper);
	                $wrapper.remove();
	            }
	        }
	        function $elOrNull(obj) {
	            var isValid, $el;
	            isValid = _.isJQuery(obj) || _.isElement(obj);
	            $el = isValid ? $(obj).first() : [];
	            return $el.length ? $el : null;
	        }
	    })();
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1570).setImmediate))

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.4.1 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw new RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * https://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.4.1',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) {
				// in Node.js, io.js, or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else {
				// in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else {
			// in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(95)(module), (function() { return this; }())))

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(1575);
	var parse = __webpack_require__(1574);
	var formats = __webpack_require__(194);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(459);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	var defaults = {
	    allowDots: false,
	    allowEmptyArrays: false,
	    allowPrototypes: false,
	    allowSparse: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decodeDotInKeys: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    duplicates: 'combine',
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictDepth: false,
	    strictNullHandling: false,
	    throwOnLimitExceeded: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	var parseArrayValue = function (val, options, currentArrayLength) {
	    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	        return val.split(',');
	    }
	
	    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
	        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	    }
	
	    return val;
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = { __proto__: null };
	
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
	
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(
	        options.delimiter,
	        options.throwOnLimitExceeded ? limit + 1 : limit
	    );
	
	    if (options.throwOnLimitExceeded && parts.length > limit) {
	        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
	    }
	
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key;
	        var val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset, 'key');
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
	
	            val = utils.maybeMap(
	                parseArrayValue(
	                    part.slice(pos + 1),
	                    options,
	                    isArray(obj[key]) ? obj[key].length : 0
	                ),
	                function (encodedVal) {
	                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
	                }
	            );
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(String(val));
	        }
	
	        if (part.indexOf('[]=') > -1) {
	            val = isArray(val) ? [val] : val;
	        }
	
	        var existing = has.call(obj, key);
	        if (existing && options.duplicates === 'combine') {
	            obj[key] = utils.combine(obj[key], val);
	        } else if (!existing || options.duplicates === 'last') {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options, valuesParsed) {
	    var currentArrayLength = 0;
	    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
	        var parentKey = chain.slice(0, -1).join('');
	        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
	    }
	
	    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
	                ? []
	                : utils.combine([], leaf);
	        } else {
	            obj = options.plainObjects ? { __proto__: null } : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
	            var index = parseInt(decodedRoot, 10);
	            if (!options.parseArrays && decodedRoot === '') {
	                obj = { 0: leaf };
	            } else if (
	                !isNaN(index)
	                && root !== decodedRoot
	                && String(index) === decodedRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else if (decodedRoot !== '__proto__') {
	                obj[decodedRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = options.depth > 0 && brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
	
	    if (segment) {
	        if (options.strictDepth === true) {
	            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
	        }
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options, valuesParsed);
	};
	
	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
	        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
	    }
	
	    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
	        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
	    }
	
	    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
	        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
	    }
	
	    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	
	    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;
	
	    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
	        throw new TypeError('The duplicates option must be either combine, first, or last');
	    }
	
	    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
	
	    return {
	        allowDots: allowDots,
	        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
	        duplicates: duplicates,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
	        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
	    };
	};
	
	module.exports = function (str, opts) {
	    var options = normalizeParseOptions(opts);
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? { __proto__: null } : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? { __proto__: null } : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    if (options.allowSparse === true) {
	        return obj;
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getSideChannel = __webpack_require__(1569);
	var utils = __webpack_require__(459);
	var formats = __webpack_require__(194);
	var has = Object.prototype.hasOwnProperty;
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaultFormat = formats['default'];
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    allowEmptyArrays: false,
	    arrayFormat: 'indices',
	    charset: 'utf-8',
	    charsetSentinel: false,
	    commaRoundTrip: false,
	    delimiter: '&',
	    encode: true,
	    encodeDotInKeys: false,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    filter: void undefined,
	    format: defaultFormat,
	    formatter: formats.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint';
	};
	
	var sentinel = {};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    commaRoundTrip,
	    allowEmptyArrays,
	    strictNullHandling,
	    skipNulls,
	    encodeDotInKeys,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    format,
	    formatter,
	    encodeValuesOnly,
	    charset,
	    sideChannel
	) {
	    var obj = object;
	
	    var tmpSc = sideChannel;
	    var step = 0;
	    var findFlag = false;
	    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
	        // Where object last appeared in the ref tree
	        var pos = tmpSc.get(object);
	        step += 1;
	        if (typeof pos !== 'undefined') {
	            if (pos === step) {
	                throw new RangeError('Cyclic object value');
	            } else {
	                findFlag = true; // Break while
	            }
	        }
	        if (typeof tmpSc.get(sentinel) === 'undefined') {
	            step = 0;
	        }
	    }
	
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        obj = utils.maybeMap(obj, function (value) {
	            if (value instanceof Date) {
	                return serializeDate(value);
	            }
	            return value;
	        });
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        // we need to join elements in
	        if (encodeValuesOnly && encoder) {
	            obj = utils.maybeMap(obj, encoder);
	        }
	        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
	    } else if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
	
	    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
	
	    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
	        return adjustedPrefix + '[]';
	    }
	
	    for (var j = 0; j < objKeys.length; ++j) {
	        var key = objKeys[j];
	        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
	            ? key.value
	            : obj[key];
	
	        if (skipNulls && value === null) {
	            continue;
	        }
	
	        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
	        var keyPrefix = isArray(obj)
	            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
	            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
	
	        sideChannel.set(object, step);
	        var valueSideChannel = getSideChannel();
	        valueSideChannel.set(sentinel, sideChannel);
	        pushToArray(values, stringify(
	            value,
	            keyPrefix,
	            generateArrayPrefix,
	            commaRoundTrip,
	            allowEmptyArrays,
	            strictNullHandling,
	            skipNulls,
	            encodeDotInKeys,
	            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            format,
	            formatter,
	            encodeValuesOnly,
	            charset,
	            valueSideChannel
	        ));
	    }
	
	    return values;
	};
	
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
	        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
	    }
	
	    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
	        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
	    }
	
	    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var charset = opts.charset || defaults.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    var format = formats['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has.call(formats.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats.formatters[format];
	
	    var filter = defaults.filter;
	    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
	        filter = opts.filter;
	    }
	
	    var arrayFormat;
	    if (opts.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = opts.arrayFormat;
	    } else if ('indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = defaults.arrayFormat;
	    }
	
	    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
	        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
	    }
	
	    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
	
	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
	        allowDots: allowDots,
	        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
	        arrayFormat: arrayFormat,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        commaRoundTrip: !!opts.commaRoundTrip,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
	        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
	        filter: filter,
	        format: format,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);
	
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
	    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }
	
	    var sideChannel = getSideChannel();
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	        var value = obj[key];
	
	        if (options.skipNulls && value === null) {
	            continue;
	        }
	        pushToArray(keys, stringify(
	            value,
	            key,
	            generateArrayPrefix,
	            commaRoundTrip,
	            options.allowEmptyArrays,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encodeDotInKeys,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.format,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset,
	            sideChannel
	        ));
	    }
	
	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B&';
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93&';
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright Joyent, Inc. and other Node contributors.
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a
	 * copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the
	 * following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included
	 * in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	 * USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	'use strict';
	
	var punycode = __webpack_require__(1572);
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	/*
	 * define these here so at least they only have to be
	 * compiled once on the first module load.
	 */
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	  portPattern = /:[0-9]*$/,
	
	  // Special case for a simple path URL
	  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,
	
	  /*
	   * RFC 2396: characters reserved for delimiting URLs.
	   * We actually just auto-escape these.
	   */
	  delims = [
	    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
	  ],
	
	  // RFC 2396: characters not allowed for various reasons.
	  unwise = [
	    '{', '}', '|', '\\', '^', '`'
	  ].concat(delims),
	
	  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	  autoEscape = ['\''].concat(unwise),
	  /*
	   * Characters that are never ever allowed in a hostname.
	   * Note that any invalid chars are also handled, but these
	   * are the ones that are *expected* to be seen, so we fast-path
	   * them.
	   */
	  nonHostChars = [
	    '%', '/', '?', ';', '#'
	  ].concat(autoEscape),
	  hostEndingChars = [
	    '/', '?', '#'
	  ],
	  hostnameMaxLen = 255,
	  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	  // protocols that can allow "unsafe" and "unwise" chars.
	  unsafeProtocol = {
	    javascript: true,
	    'javascript:': true
	  },
	  // protocols that never have a hostname.
	  hostlessProtocol = {
	    javascript: true,
	    'javascript:': true
	  },
	  // protocols that always contain a // bit.
	  slashedProtocol = {
	    http: true,
	    https: true,
	    ftp: true,
	    gopher: true,
	    file: true,
	    'http:': true,
	    'https:': true,
	    'ftp:': true,
	    'gopher:': true,
	    'file:': true
	  },
	  querystring = __webpack_require__(1573);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && typeof url === 'object' && url instanceof Url) { return url; }
	
	  var u = new Url();
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
	  if (typeof url !== 'string') {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  /*
	   * Copy chrome, IE, opera backslash-handling behavior.
	   * Back slashes before the query string get converted to forward slashes
	   * See: https://code.google.com/p/chromium/issues/detail?id=25916
	   */
	  var queryIndex = url.indexOf('?'),
	    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
	    uSplit = url.split(splitter),
	    slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  /*
	   * trim before proceeding.
	   * This is to support parse stuff like "  http://foo.com  \n"
	   */
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  /*
	   * figure out if it's got a host
	   * user@server is *always* interpreted as a hostname, and url
	   * resolution will treat //foo/bar as host=foo,path=bar because that's
	   * how the browser resolves relative URLs.
	   */
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {
	
	    /*
	     * there's a hostname.
	     * the first instance of /, ?, ;, or # ends the host.
	     *
	     * If there is an @ in the hostname, then non-host chars *are* allowed
	     * to the left of the last @ sign, unless some host-ending character
	     * comes *before* the @-sign.
	     * URLs are obnoxious.
	     *
	     * ex:
	     * http://a@b@c/ => user:a@b host:c
	     * http://a@b?@c => user:a host:c path:/?@c
	     */
	
	    /*
	     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
	     * Review our test case against browsers more comprehensively.
	     */
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
	    }
	
	    /*
	     * at this point, either we have an explicit point where the
	     * auth portion cannot go past, or the last @ char is the decider.
	     */
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      /*
	       * atSign must be in auth portion.
	       * http://a@b/c@d => host:b auth:a path:/c@d
	       */
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    /*
	     * Now we have a portion which is definitely the auth.
	     * Pull that off.
	     */
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1) { hostEnd = rest.length; }
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    /*
	     * we've indicated that there is a hostname,
	     * so even if it's empty, it has to be present.
	     */
	    this.hostname = this.hostname || '';
	
	    /*
	     * if hostname begins with [ and ends with ]
	     * assume that it's an IPv6 address.
	     */
	    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) { continue; }
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              /*
	               * we replace non-ASCII char with a temporary placeholder
	               * we need this to make sure size of hostname is not
	               * broken by replacing non-ASCII by nothing
	               */
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      /*
	       * IDNA Support: Returns a punycoded representation of "domain".
	       * It only converts parts of the domain name that
	       * have non-ASCII characters, i.e. it doesn't matter if
	       * you call it with a domain that already is ASCII-only.
	       */
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    /*
	     * strip [ and ] from the hostname
	     * the host field still retains them, though
	     */
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  /*
	   * now rest is set to the post-host stuff.
	   * chop off any delim chars.
	   */
	  if (!unsafeProtocol[lowerProto]) {
	
	    /*
	     * First, make 100% sure that any "autoEscape" chars get
	     * escaped, even if encodeURIComponent doesn't think they
	     * need to be.
	     */
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1) { continue; }
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) { this.pathname = rest; }
	  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  // to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  /*
	   * ensure it's an object, and not a string url.
	   * If it's an obj, this is a no-op.
	   * this way, you can call url_format() on strings
	   * to clean up potentially wonky urls.
	   */
	  if (typeof obj === 'string') { obj = urlParse(obj); }
	  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
	  return obj.format();
	}
	
	Url.prototype.format = function () {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	    pathname = this.pathname || '',
	    hash = this.hash || '',
	    host = false,
	    query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
	    query = querystring.stringify(this.query, {
	      arrayFormat: 'repeat',
	      addQueryPrefix: false
	    });
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }
	
	  /*
	   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	   * unless they had them to begin with.
	   */
	  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
	  if (search && search.charAt(0) !== '?') { search = '?' + search; }
	
	  pathname = pathname.replace(/[?#]/g, function (match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function (relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) { return relative; }
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function (relative) {
	  if (typeof relative === 'string') {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  /*
	   * hash is always overridden, no matter what.
	   * even href="" will remove it.
	   */
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
	    }
	
	    // urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
	      result.pathname = '/';
	      result.path = result.pathname;
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    /*
	     * if it's a known url protocol, then changing
	     * the protocol does weird things
	     * first, if it's not file:, then we MUST have a host,
	     * and if there was a path
	     * to begin with, then we MUST have a path.
	     * if it is file:, then the host is dropped,
	     * because that's known to be hostless.
	     * anything else is assumed to be absolute.
	     */
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift())) { }
	      if (!relative.host) { relative.host = ''; }
	      if (!relative.hostname) { relative.hostname = ''; }
	      if (relPath[0] !== '') { relPath.unshift(''); }
	      if (relPath.length < 2) { relPath.unshift(''); }
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
	    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
	    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
	    removeAllDots = mustEndAbs,
	    srcPath = result.pathname && result.pathname.split('/') || [],
	    relPath = relative.pathname && relative.pathname.split('/') || [],
	    psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  /*
	   * if the url is a non-slashed url, then relative
	   * links like ../.. should be able
	   * to crawl up to the hostname, as well.  This is strange.
	   * result.protocol has already been set by now.
	   * Later on, put the first path part into the host field.
	   */
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = relative.host || relative.host === '' ? relative.host : result.host;
	    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    /*
	     * it's relative
	     * throw away the existing file, and take the new path instead.
	     */
	    if (!srcPath) { srcPath = []; }
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (relative.search != null) {
	    /*
	     * just pull out the search.
	     * like href='?foo'.
	     * Put this after the other two cases because it simplifies the booleans
	     */
	    if (psychotic) {
	      result.host = srcPath.shift();
	      result.hostname = result.host;
	      /*
	       * occationaly the auth can get stuck only in host
	       * this especially happens in cases like
	       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	       */
	      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.hostname = authInHost.shift();
	        result.host = result.hostname;
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    // to support http.request
	    if (result.pathname !== null || result.search !== null) {
	      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    /*
	     * no path at all.  easy.
	     * we've already handled the other stuff above.
	     */
	    result.pathname = null;
	    // to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  /*
	   * if a url ENDs in . or .., then it must get a trailing slash.
	   * however, if it ends in anything else non-slashy,
	   * then it must NOT get a trailing slash.
	   */
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
	
	  /*
	   * strip single dots, resolve double dots to parent dir
	   * if the path tries to go above the root, `up` ends up > 0
	   */
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
	    result.host = result.hostname;
	    /*
	     * occationaly the auth can get stuck only in host
	     * this especially happens in cases like
	     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	     */
	    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.hostname = authInHost.shift();
	      result.host = result.hostname;
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (srcPath.length > 0) {
	    result.pathname = srcPath.join('/');
	  } else {
	    result.pathname = null;
	    result.path = null;
	  }
	
	  // to support request.http
	  if (result.pathname !== null || result.search !== null) {
	    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function () {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) { this.hostname = host; }
	};
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;


/***/ },
/* 1577 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	// Currently in sync with Node.js lib/internal/util/types.js
	// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
	
	'use strict';
	
	var isArgumentsObject = __webpack_require__(1476);
	var isGeneratorFunction = __webpack_require__(1478);
	var whichTypedArray = __webpack_require__(460);
	var isTypedArray = __webpack_require__(1480);
	
	function uncurryThis(f) {
	  return f.call.bind(f);
	}
	
	var BigIntSupported = typeof BigInt !== 'undefined';
	var SymbolSupported = typeof Symbol !== 'undefined';
	
	var ObjectToString = uncurryThis(Object.prototype.toString);
	
	var numberValue = uncurryThis(Number.prototype.valueOf);
	var stringValue = uncurryThis(String.prototype.valueOf);
	var booleanValue = uncurryThis(Boolean.prototype.valueOf);
	
	if (BigIntSupported) {
	  var bigIntValue = uncurryThis(BigInt.prototype.valueOf);
	}
	
	if (SymbolSupported) {
	  var symbolValue = uncurryThis(Symbol.prototype.valueOf);
	}
	
	function checkBoxedPrimitive(value, prototypeValueOf) {
	  if (typeof value !== 'object') {
	    return false;
	  }
	  try {
	    prototypeValueOf(value);
	    return true;
	  } catch(e) {
	    return false;
	  }
	}
	
	exports.isArgumentsObject = isArgumentsObject;
	exports.isGeneratorFunction = isGeneratorFunction;
	exports.isTypedArray = isTypedArray;
	
	// Taken from here and modified for better browser support
	// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
	function isPromise(input) {
		return (
			(
				typeof Promise !== 'undefined' &&
				input instanceof Promise
			) ||
			(
				input !== null &&
				typeof input === 'object' &&
				typeof input.then === 'function' &&
				typeof input.catch === 'function'
			)
		);
	}
	exports.isPromise = isPromise;
	
	function isArrayBufferView(value) {
	  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
	    return ArrayBuffer.isView(value);
	  }
	
	  return (
	    isTypedArray(value) ||
	    isDataView(value)
	  );
	}
	exports.isArrayBufferView = isArrayBufferView;
	
	
	function isUint8Array(value) {
	  return whichTypedArray(value) === 'Uint8Array';
	}
	exports.isUint8Array = isUint8Array;
	
	function isUint8ClampedArray(value) {
	  return whichTypedArray(value) === 'Uint8ClampedArray';
	}
	exports.isUint8ClampedArray = isUint8ClampedArray;
	
	function isUint16Array(value) {
	  return whichTypedArray(value) === 'Uint16Array';
	}
	exports.isUint16Array = isUint16Array;
	
	function isUint32Array(value) {
	  return whichTypedArray(value) === 'Uint32Array';
	}
	exports.isUint32Array = isUint32Array;
	
	function isInt8Array(value) {
	  return whichTypedArray(value) === 'Int8Array';
	}
	exports.isInt8Array = isInt8Array;
	
	function isInt16Array(value) {
	  return whichTypedArray(value) === 'Int16Array';
	}
	exports.isInt16Array = isInt16Array;
	
	function isInt32Array(value) {
	  return whichTypedArray(value) === 'Int32Array';
	}
	exports.isInt32Array = isInt32Array;
	
	function isFloat32Array(value) {
	  return whichTypedArray(value) === 'Float32Array';
	}
	exports.isFloat32Array = isFloat32Array;
	
	function isFloat64Array(value) {
	  return whichTypedArray(value) === 'Float64Array';
	}
	exports.isFloat64Array = isFloat64Array;
	
	function isBigInt64Array(value) {
	  return whichTypedArray(value) === 'BigInt64Array';
	}
	exports.isBigInt64Array = isBigInt64Array;
	
	function isBigUint64Array(value) {
	  return whichTypedArray(value) === 'BigUint64Array';
	}
	exports.isBigUint64Array = isBigUint64Array;
	
	function isMapToString(value) {
	  return ObjectToString(value) === '[object Map]';
	}
	isMapToString.working = (
	  typeof Map !== 'undefined' &&
	  isMapToString(new Map())
	);
	
	function isMap(value) {
	  if (typeof Map === 'undefined') {
	    return false;
	  }
	
	  return isMapToString.working
	    ? isMapToString(value)
	    : value instanceof Map;
	}
	exports.isMap = isMap;
	
	function isSetToString(value) {
	  return ObjectToString(value) === '[object Set]';
	}
	isSetToString.working = (
	  typeof Set !== 'undefined' &&
	  isSetToString(new Set())
	);
	function isSet(value) {
	  if (typeof Set === 'undefined') {
	    return false;
	  }
	
	  return isSetToString.working
	    ? isSetToString(value)
	    : value instanceof Set;
	}
	exports.isSet = isSet;
	
	function isWeakMapToString(value) {
	  return ObjectToString(value) === '[object WeakMap]';
	}
	isWeakMapToString.working = (
	  typeof WeakMap !== 'undefined' &&
	  isWeakMapToString(new WeakMap())
	);
	function isWeakMap(value) {
	  if (typeof WeakMap === 'undefined') {
	    return false;
	  }
	
	  return isWeakMapToString.working
	    ? isWeakMapToString(value)
	    : value instanceof WeakMap;
	}
	exports.isWeakMap = isWeakMap;
	
	function isWeakSetToString(value) {
	  return ObjectToString(value) === '[object WeakSet]';
	}
	isWeakSetToString.working = (
	  typeof WeakSet !== 'undefined' &&
	  isWeakSetToString(new WeakSet())
	);
	function isWeakSet(value) {
	  return isWeakSetToString(value);
	}
	exports.isWeakSet = isWeakSet;
	
	function isArrayBufferToString(value) {
	  return ObjectToString(value) === '[object ArrayBuffer]';
	}
	isArrayBufferToString.working = (
	  typeof ArrayBuffer !== 'undefined' &&
	  isArrayBufferToString(new ArrayBuffer())
	);
	function isArrayBuffer(value) {
	  if (typeof ArrayBuffer === 'undefined') {
	    return false;
	  }
	
	  return isArrayBufferToString.working
	    ? isArrayBufferToString(value)
	    : value instanceof ArrayBuffer;
	}
	exports.isArrayBuffer = isArrayBuffer;
	
	function isDataViewToString(value) {
	  return ObjectToString(value) === '[object DataView]';
	}
	isDataViewToString.working = (
	  typeof ArrayBuffer !== 'undefined' &&
	  typeof DataView !== 'undefined' &&
	  isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1))
	);
	function isDataView(value) {
	  if (typeof DataView === 'undefined') {
	    return false;
	  }
	
	  return isDataViewToString.working
	    ? isDataViewToString(value)
	    : value instanceof DataView;
	}
	exports.isDataView = isDataView;
	
	// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
	var SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
	function isSharedArrayBufferToString(value) {
	  return ObjectToString(value) === '[object SharedArrayBuffer]';
	}
	function isSharedArrayBuffer(value) {
	  if (typeof SharedArrayBufferCopy === 'undefined') {
	    return false;
	  }
	
	  if (typeof isSharedArrayBufferToString.working === 'undefined') {
	    isSharedArrayBufferToString.working = isSharedArrayBufferToString(new SharedArrayBufferCopy());
	  }
	
	  return isSharedArrayBufferToString.working
	    ? isSharedArrayBufferToString(value)
	    : value instanceof SharedArrayBufferCopy;
	}
	exports.isSharedArrayBuffer = isSharedArrayBuffer;
	
	function isAsyncFunction(value) {
	  return ObjectToString(value) === '[object AsyncFunction]';
	}
	exports.isAsyncFunction = isAsyncFunction;
	
	function isMapIterator(value) {
	  return ObjectToString(value) === '[object Map Iterator]';
	}
	exports.isMapIterator = isMapIterator;
	
	function isSetIterator(value) {
	  return ObjectToString(value) === '[object Set Iterator]';
	}
	exports.isSetIterator = isSetIterator;
	
	function isGeneratorObject(value) {
	  return ObjectToString(value) === '[object Generator]';
	}
	exports.isGeneratorObject = isGeneratorObject;
	
	function isWebAssemblyCompiledModule(value) {
	  return ObjectToString(value) === '[object WebAssembly.Module]';
	}
	exports.isWebAssemblyCompiledModule = isWebAssemblyCompiledModule;
	
	function isNumberObject(value) {
	  return checkBoxedPrimitive(value, numberValue);
	}
	exports.isNumberObject = isNumberObject;
	
	function isStringObject(value) {
	  return checkBoxedPrimitive(value, stringValue);
	}
	exports.isStringObject = isStringObject;
	
	function isBooleanObject(value) {
	  return checkBoxedPrimitive(value, booleanValue);
	}
	exports.isBooleanObject = isBooleanObject;
	
	function isBigIntObject(value) {
	  return BigIntSupported && checkBoxedPrimitive(value, bigIntValue);
	}
	exports.isBigIntObject = isBigIntObject;
	
	function isSymbolObject(value) {
	  return SymbolSupported && checkBoxedPrimitive(value, symbolValue);
	}
	exports.isSymbolObject = isSymbolObject;
	
	function isBoxedPrimitive(value) {
	  return (
	    isNumberObject(value) ||
	    isStringObject(value) ||
	    isBooleanObject(value) ||
	    isBigIntObject(value) ||
	    isSymbolObject(value)
	  );
	}
	exports.isBoxedPrimitive = isBoxedPrimitive;
	
	function isAnyArrayBuffer(value) {
	  return typeof Uint8Array !== 'undefined' && (
	    isArrayBuffer(value) ||
	    isSharedArrayBuffer(value)
	  );
	}
	exports.isAnyArrayBuffer = isAnyArrayBuffer;
	
	['isProxy', 'isExternal', 'isModuleNamespaceObject'].forEach(function(method) {
	  Object.defineProperty(exports, method, {
	    enumerable: false,
	    value: function() {
	      throw new Error(method + ' is not supported in userland');
	    }
	  });
	});


/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! VelocityJS.org (1.2.3). (C) 2014 Julian Shapiro. MIT @license: en.wikipedia.org/wiki/MIT_License */
	
	/*************************
	   Velocity jQuery Shim
	*************************/
	
	/*! VelocityJS.org jQuery Shim (1.0.1). (C) 2014 The jQuery Foundation. MIT @license: en.wikipedia.org/wiki/MIT_License. */
	
	/* This file contains the jQuery functions that Velocity relies on, thereby removing Velocity's dependency on a full copy of jQuery, and allowing it to work in any environment. */
	/* These shimmed functions are only used if jQuery isn't present. If both this shim and jQuery are loaded, Velocity defaults to jQuery proper. */
	/* Browser support: Using this shim instead of jQuery proper removes support for IE8. */
	
	;(function (window) {
	    /***************
	         Setup
	    ***************/
	
	    /* If jQuery is already loaded, there's no point in loading this shim. */
	    if (window.jQuery) {
	        return;
	    }
	
	    /* jQuery base. */
	    var $ = function (selector, context) {
	        return new $.fn.init(selector, context);
	    };
	
	    /********************
	       Private Methods
	    ********************/
	
	    /* jQuery */
	    $.isWindow = function (obj) {
	        /* jshint eqeqeq: false */
	        return obj != null && obj == obj.window;
	    };
	
	    /* jQuery */
	    $.type = function (obj) {
	        if (obj == null) {
	            return obj + "";
	        }
	
	        return typeof obj === "object" || typeof obj === "function" ?
	            class2type[toString.call(obj)] || "object" :
	            typeof obj;
	    };
	
	    /* jQuery */
	    $.isArray = Array.isArray || function (obj) {
	        return $.type(obj) === "array";
	    };
	
	    /* jQuery */
	    function isArraylike (obj) {
	        var length = obj.length,
	            type = $.type(obj);
	
	        if (type === "function" || $.isWindow(obj)) {
	            return false;
	        }
	
	        if (obj.nodeType === 1 && length) {
	            return true;
	        }
	
	        return type === "array" || length === 0 || typeof length === "number" && length > 0 && (length - 1) in obj;
	    }
	
	    /***************
	       $ Methods
	    ***************/
	
	    /* jQuery: Support removed for IE<9. */
	    $.isPlainObject = function (obj) {
	        var key;
	
	        if (!obj || $.type(obj) !== "object" || obj.nodeType || $.isWindow(obj)) {
	            return false;
	        }
	
	        try {
	            if (obj.constructor &&
	                !hasOwn.call(obj, "constructor") &&
	                !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
	                return false;
	            }
	        } catch (e) {
	            return false;
	        }
	
	        for (key in obj) {}
	
	        return key === undefined || hasOwn.call(obj, key);
	    };
	
	    /* jQuery */
	    $.each = function(obj, callback, args) {
	        var value,
	            i = 0,
	            length = obj.length,
	            isArray = isArraylike(obj);
	
	        if (args) {
	            if (isArray) {
	                for (; i < length; i++) {
	                    value = callback.apply(obj[i], args);
	
	                    if (value === false) {
	                        break;
	                    }
	                }
	            } else {
	                for (i in obj) {
	                    value = callback.apply(obj[i], args);
	
	                    if (value === false) {
	                        break;
	                    }
	                }
	            }
	
	        } else {
	            if (isArray) {
	                for (; i < length; i++) {
	                    value = callback.call(obj[i], i, obj[i]);
	
	                    if (value === false) {
	                        break;
	                    }
	                }
	            } else {
	                for (i in obj) {
	                    value = callback.call(obj[i], i, obj[i]);
	
	                    if (value === false) {
	                        break;
	                    }
	                }
	            }
	        }
	
	        return obj;
	    };
	
	    /* Custom */
	    $.data = function (node, key, value) {
	        /* $.getData() */
	        if (value === undefined) {
	            var id = node[$.expando],
	                store = id && cache[id];
	
	            if (key === undefined) {
	                return store;
	            } else if (store) {
	                if (key in store) {
	                    return store[key];
	                }
	            }
	        /* $.setData() */
	        } else if (key !== undefined) {
	            var id = node[$.expando] || (node[$.expando] = ++$.uuid);
	
	            cache[id] = cache[id] || {};
	            cache[id][key] = value;
	
	            return value;
	        }
	    };
	
	    /* Custom */
	    $.removeData = function (node, keys) {
	        var id = node[$.expando],
	            store = id && cache[id];
	
	        if (store) {
	            $.each(keys, function(_, key) {
	                delete store[key];
	            });
	        }
	    };
	
	    /* jQuery */
	    $.extend = function () {
	        var src, copyIsArray, copy, name, options, clone,
	            target = arguments[0] || {},
	            i = 1,
	            length = arguments.length,
	            deep = false;
	
	        if (typeof target === "boolean") {
	            deep = target;
	
	            target = arguments[i] || {};
	            i++;
	        }
	
	        if (typeof target !== "object" && $.type(target) !== "function") {
	            target = {};
	        }
	
	        if (i === length) {
	            target = this;
	            i--;
	        }
	
	        for (; i < length; i++) {
	            if ((options = arguments[i]) != null) {
	                for (name in options) {
	                    src = target[name];
	                    copy = options[name];
	
	                    if (target === copy) {
	                        continue;
	                    }
	
	                    if (deep && copy && ($.isPlainObject(copy) || (copyIsArray = $.isArray(copy)))) {
	                        if (copyIsArray) {
	                            copyIsArray = false;
	                            clone = src && $.isArray(src) ? src : [];
	
	                        } else {
	                            clone = src && $.isPlainObject(src) ? src : {};
	                        }
	
	                        target[name] = $.extend(deep, clone, copy);
	
	                    } else if (copy !== undefined) {
	                        target[name] = copy;
	                    }
	                }
	            }
	        }
	
	        return target;
	    };
	
	    /* jQuery 1.4.3 */
	    $.queue = function (elem, type, data) {
	        function $makeArray (arr, results) {
	            var ret = results || [];
	
	            if (arr != null) {
	                if (isArraylike(Object(arr))) {
	                    /* $.merge */
	                    (function(first, second) {
	                        var len = +second.length,
	                            j = 0,
	                            i = first.length;
	
	                        while (j < len) {
	                            first[i++] = second[j++];
	                        }
	
	                        if (len !== len) {
	                            while (second[j] !== undefined) {
	                                first[i++] = second[j++];
	                            }
	                        }
	
	                        first.length = i;
	
	                        return first;
	                    })(ret, typeof arr === "string" ? [arr] : arr);
	                } else {
	                    [].push.call(ret, arr);
	                }
	            }
	
	            return ret;
	        }
	
	        if (!elem) {
	            return;
	        }
	
	        type = (type || "fx") + "queue";
	
	        var q = $.data(elem, type);
	
	        if (!data) {
	            return q || [];
	        }
	
	        if (!q || $.isArray(data)) {
	            q = $.data(elem, type, $makeArray(data));
	        } else {
	            q.push(data);
	        }
	
	        return q;
	    };
	
	    /* jQuery 1.4.3 */
	    $.dequeue = function (elems, type) {
	        /* Custom: Embed element iteration. */
	        $.each(elems.nodeType ? [ elems ] : elems, function(i, elem) {
	            type = type || "fx";
	
	            var queue = $.queue(elem, type),
	                fn = queue.shift();
	
	            if (fn === "inprogress") {
	                fn = queue.shift();
	            }
	
	            if (fn) {
	                if (type === "fx") {
	                    queue.unshift("inprogress");
	                }
	
	                fn.call(elem, function() {
	                    $.dequeue(elem, type);
	                });
	            }
	        });
	    };
	
	    /******************
	       $.fn Methods
	    ******************/
	
	    /* jQuery */
	    $.fn = $.prototype = {
	        init: function (selector) {
	            /* Just return the element wrapped inside an array; don't proceed with the actual jQuery node wrapping process. */
	            if (selector.nodeType) {
	                this[0] = selector;
	
	                return this;
	            } else {
	                throw new Error("Not a DOM node.");
	            }
	        },
	
	        offset: function () {
	            /* jQuery altered code: Dropped disconnected DOM node checking. */
	            var box = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : { top: 0, left: 0 };
	
	            return {
	                top: box.top + (window.pageYOffset || document.scrollTop  || 0)  - (document.clientTop  || 0),
	                left: box.left + (window.pageXOffset || document.scrollLeft  || 0) - (document.clientLeft || 0)
	            };
	        },
	
	        position: function () {
	            /* jQuery */
	            function offsetParent() {
	                var offsetParent = this.offsetParent || document;
	
	                while (offsetParent && (!offsetParent.nodeType.toLowerCase === "html" && offsetParent.style.position === "static")) {
	                    offsetParent = offsetParent.offsetParent;
	                }
	
	                return offsetParent || document;
	            }
	
	            /* Zepto */
	            var elem = this[0],
	                offsetParent = offsetParent.apply(elem),
	                offset = this.offset(),
	                parentOffset = /^(?:body|html)$/i.test(offsetParent.nodeName) ? { top: 0, left: 0 } : $(offsetParent).offset()
	
	            offset.top -= parseFloat(elem.style.marginTop) || 0;
	            offset.left -= parseFloat(elem.style.marginLeft) || 0;
	
	            if (offsetParent.style) {
	                parentOffset.top += parseFloat(offsetParent.style.borderTopWidth) || 0
	                parentOffset.left += parseFloat(offsetParent.style.borderLeftWidth) || 0
	            }
	
	            return {
	                top: offset.top - parentOffset.top,
	                left: offset.left - parentOffset.left
	            };
	        }
	    };
	
	    /**********************
	       Private Variables
	    **********************/
	
	    /* For $.data() */
	    var cache = {};
	    $.expando = "velocity" + (new Date().getTime());
	    $.uuid = 0;
	
	    /* For $.queue() */
	    var class2type = {},
	        hasOwn = class2type.hasOwnProperty,
	        toString = class2type.toString;
	
	    var types = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
	    for (var i = 0; i < types.length; i++) {
	        class2type["[object " + types[i] + "]"] = types[i].toLowerCase();
	    }
	
	    /* Makes $(node) possible, without having to call init. */
	    $.fn.init.prototype = $.fn;
	
	    /* Globalize Velocity onto the window, and assign its Utilities property. */
	    window.Velocity = { Utilities: $ };
	})(window);
	
	/******************
	    Velocity.js
	******************/
	
	;(function (factory) {
	    /* CommonJS module. */
	    if (typeof module === "object" && typeof module.exports === "object") {
	        module.exports = factory();
	    /* AMD module. */
	    } else if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    /* Browser globals. */
	    } else {
	        factory();
	    }
	}(function() {
	return function (global, window, document, undefined) {
	
	    /***************
	        Summary
	    ***************/
	
	    /*
	    - CSS: CSS stack that works independently from the rest of Velocity.
	    - animate(): Core animation method that iterates over the targeted elements and queues the incoming call onto each element individually.
	      - Pre-Queueing: Prepare the element for animation by instantiating its data cache and processing the call's options.
	      - Queueing: The logic that runs once the call has reached its point of execution in the element's $.queue() stack.
	                  Most logic is placed here to avoid risking it becoming stale (if the element's properties have changed).
	      - Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
	    - tick(): The single requestAnimationFrame loop responsible for tweening all in-progress calls.
	    - completeCall(): Handles the cleanup process for each Velocity call.
	    */
	
	    /*********************
	       Helper Functions
	    *********************/
	
	    /* IE detection. Gist: https://gist.github.com/julianshapiro/9098609 */
	    var IE = (function() {
	        if (document.documentMode) {
	            return document.documentMode;
	        } else {
	            for (var i = 7; i > 4; i--) {
	                var div = document.createElement("div");
	
	                div.innerHTML = "<!--[if IE " + i + "]><span></span><![endif]-->";
	
	                if (div.getElementsByTagName("span").length) {
	                    div = null;
	
	                    return i;
	                }
	            }
	        }
	
	        return undefined;
	    })();
	
	    /* rAF shim. Gist: https://gist.github.com/julianshapiro/9497513 */
	    var rAFShim = (function() {
	        var timeLast = 0;
	
	        return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
	            var timeCurrent = (new Date()).getTime(),
	                timeDelta;
	
	            /* Dynamically set delay on a per-tick basis to match 60fps. */
	            /* Technique by Erik Moller. MIT license: https://gist.github.com/paulirish/1579671 */
	            timeDelta = Math.max(0, 16 - (timeCurrent - timeLast));
	            timeLast = timeCurrent + timeDelta;
	
	            return setTimeout(function() { callback(timeCurrent + timeDelta); }, timeDelta);
	        };
	    })();
	
	    /* Array compacting. Copyright Lo-Dash. MIT License: https://github.com/lodash/lodash/blob/master/LICENSE.txt */
	    function compactSparseArray (array) {
	        var index = -1,
	            length = array ? array.length : 0,
	            result = [];
	
	        while (++index < length) {
	            var value = array[index];
	
	            if (value) {
	                result.push(value);
	            }
	        }
	
	        return result;
	    }
	
	    function sanitizeElements (elements) {
	        /* Unwrap jQuery/Zepto objects. */
	        if (Type.isWrapped(elements)) {
	            elements = [].slice.call(elements);
	        /* Wrap a single element in an array so that $.each() can iterate with the element instead of its node's children. */
	        } else if (Type.isNode(elements)) {
	            elements = [ elements ];
	        }
	
	        return elements;
	    }
	
	    var Type = {
	        isString: function (variable) {
	            return (typeof variable === "string");
	        },
	        isArray: Array.isArray || function (variable) {
	            return Object.prototype.toString.call(variable) === "[object Array]";
	        },
	        isFunction: function (variable) {
	            return Object.prototype.toString.call(variable) === "[object Function]";
	        },
	        isNode: function (variable) {
	            return variable && variable.nodeType;
	        },
	        /* Copyright Martin Bohm. MIT License: https://gist.github.com/Tomalak/818a78a226a0738eaade */
	        isNodeList: function (variable) {
	            return typeof variable === "object" &&
	                /^\[object (HTMLCollection|NodeList|Object)\]$/.test(Object.prototype.toString.call(variable)) &&
	                variable.length !== undefined &&
	                (variable.length === 0 || (typeof variable[0] === "object" && variable[0].nodeType > 0));
	        },
	        /* Determine if variable is a wrapped jQuery or Zepto element. */
	        isWrapped: function (variable) {
	            return variable && (variable.jquery || (window.Zepto && window.Zepto.zepto.isZ(variable)));
	        },
	        isSVG: function (variable) {
	            return window.SVGElement && (variable instanceof window.SVGElement);
	        },
	        isEmptyObject: function (variable) {
	            for (var name in variable) {
	                return false;
	            }
	
	            return true;
	        }
	    };
	
	    /*****************
	       Dependencies
	    *****************/
	
	    var $,
	        isJQuery = false;
	
	    if (global.fn && global.fn.jquery) {
	        $ = global;
	        isJQuery = true;
	    } else {
	        $ = window.Velocity.Utilities;
	    }
	
	    if (IE <= 8 && !isJQuery) {
	        throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
	    } else if (IE <= 7) {
	        /* Revert to jQuery's $.animate(), and lose Velocity's extra features. */
	        jQuery.fn.velocity = jQuery.fn.animate;
	
	        /* Now that $.fn.velocity is aliased, abort this Velocity declaration. */
	        return;
	    }
	
	    /*****************
	        Constants
	    *****************/
	
	    var DURATION_DEFAULT = 400,
	        EASING_DEFAULT = "swing";
	
	    /*************
	        State
	    *************/
	
	    var Velocity = {
	        /* Container for page-wide Velocity state data. */
	        State: {
	            /* Detect mobile devices to determine if mobileHA should be turned on. */
	            isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
	            /* The mobileHA option's behavior changes on older Android devices (Gingerbread, versions 2.3.3-2.3.7). */
	            isAndroid: /Android/i.test(navigator.userAgent),
	            isGingerbread: /Android 2\.3\.[3-7]/i.test(navigator.userAgent),
	            isChrome: window.chrome,
	            isFirefox: /Firefox/i.test(navigator.userAgent),
	            /* Create a cached element for re-use when checking for CSS property prefixes. */
	            prefixElement: document.createElement("div"),
	            /* Cache every prefix match to avoid repeating lookups. */
	            prefixMatches: {},
	            /* Cache the anchor used for animating window scrolling. */
	            scrollAnchor: null,
	            /* Cache the browser-specific property names associated with the scroll anchor. */
	            scrollPropertyLeft: null,
	            scrollPropertyTop: null,
	            /* Keep track of whether our RAF tick is running. */
	            isTicking: false,
	            /* Container for every in-progress call to Velocity. */
	            calls: []
	        },
	        /* Velocity's custom CSS stack. Made global for unit testing. */
	        CSS: { /* Defined below. */ },
	        /* A shim of the jQuery utility functions used by Velocity -- provided by Velocity's optional jQuery shim. */
	        Utilities: $,
	        /* Container for the user's custom animation redirects that are referenced by name in place of the properties map argument. */
	        Redirects: { /* Manually registered by the user. */ },
	        Easings: { /* Defined below. */ },
	        /* Attempt to use ES6 Promises by default. Users can override this with a third-party promises library. */
	        Promise: window.Promise,
	        /* Velocity option defaults, which can be overriden by the user. */
	        defaults: {
	            queue: "",
	            duration: DURATION_DEFAULT,
	            easing: EASING_DEFAULT,
	            begin: undefined,
	            complete: undefined,
	            progress: undefined,
	            display: undefined,
	            visibility: undefined,
	            loop: false,
	            delay: false,
	            mobileHA: true,
	            /* Advanced: Set to false to prevent property values from being cached between consecutive Velocity-initiated chain calls. */
	            _cacheValues: true
	        },
	        /* A design goal of Velocity is to cache data wherever possible in order to avoid DOM requerying. Accordingly, each element has a data cache. */
	        init: function (element) {
	            $.data(element, "velocity", {
	                /* Store whether this is an SVG element, since its properties are retrieved and updated differently than standard HTML elements. */
	                isSVG: Type.isSVG(element),
	                /* Keep track of whether the element is currently being animated by Velocity.
	                   This is used to ensure that property values are not transferred between non-consecutive (stale) calls. */
	                isAnimating: false,
	                /* A reference to the element's live computedStyle object. Learn more here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
	                computedStyle: null,
	                /* Tween data is cached for each animation on the element so that data can be passed across calls --
	                   in particular, end values are used as subsequent start values in consecutive Velocity calls. */
	                tweensContainer: null,
	                /* The full root property values of each CSS hook being animated on this element are cached so that:
	                   1) Concurrently-animating hooks sharing the same root can have their root values' merged into one while tweening.
	                   2) Post-hook-injection root values can be transferred over to consecutively chained Velocity calls as starting root values. */
	                rootPropertyValueCache: {},
	                /* A cache for transform updates, which must be manually flushed via CSS.flushTransformCache(). */
	                transformCache: {}
	            });
	        },
	        /* A parallel to jQuery's $.css(), used for getting/setting Velocity's hooked CSS properties. */
	        hook: null, /* Defined below. */
	        /* Velocity-wide animation time remapping for testing purposes. */
	        mock: false,
	        version: { major: 1, minor: 2, patch: 2 },
	        /* Set to 1 or 2 (most verbose) to output debug info to console. */
	        debug: false
	    };
	
	    /* Retrieve the appropriate scroll anchor and property name for the browser: https://developer.mozilla.org/en-US/docs/Web/API/Window.scrollY */
	    if (window.pageYOffset !== undefined) {
	        Velocity.State.scrollAnchor = window;
	        Velocity.State.scrollPropertyLeft = "pageXOffset";
	        Velocity.State.scrollPropertyTop = "pageYOffset";
	    } else {
	        Velocity.State.scrollAnchor = document.documentElement || document.body.parentNode || document.body;
	        Velocity.State.scrollPropertyLeft = "scrollLeft";
	        Velocity.State.scrollPropertyTop = "scrollTop";
	    }
	
	    /* Shorthand alias for jQuery's $.data() utility. */
	    function Data (element) {
	        /* Hardcode a reference to the plugin name. */
	        var response = $.data(element, "velocity");
	
	        /* jQuery <=1.4.2 returns null instead of undefined when no match is found. We normalize this behavior. */
	        return response === null ? undefined : response;
	    };
	
	    /**************
	        Easing
	    **************/
	
	    /* Step easing generator. */
	    function generateStep (steps) {
	        return function (p) {
	            return Math.round(p * steps) * (1 / steps);
	        };
	    }
	
	    /* Bezier curve function generator. Copyright Gaetan Renaudeau. MIT License: http://en.wikipedia.org/wiki/MIT_License */
	    function generateBezier (mX1, mY1, mX2, mY2) {
	        var NEWTON_ITERATIONS = 4,
	            NEWTON_MIN_SLOPE = 0.001,
	            SUBDIVISION_PRECISION = 0.0000001,
	            SUBDIVISION_MAX_ITERATIONS = 10,
	            kSplineTableSize = 11,
	            kSampleStepSize = 1.0 / (kSplineTableSize - 1.0),
	            float32ArraySupported = "Float32Array" in window;
	
	        /* Must contain four arguments. */
	        if (arguments.length !== 4) {
	            return false;
	        }
	
	        /* Arguments must be numbers. */
	        for (var i = 0; i < 4; ++i) {
	            if (typeof arguments[i] !== "number" || isNaN(arguments[i]) || !isFinite(arguments[i])) {
	                return false;
	            }
	        }
	
	        /* X values must be in the [0, 1] range. */
	        mX1 = Math.min(mX1, 1);
	        mX2 = Math.min(mX2, 1);
	        mX1 = Math.max(mX1, 0);
	        mX2 = Math.max(mX2, 0);
	
	        var mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	
	        function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	        function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	        function C (aA1)      { return 3.0 * aA1; }
	
	        function calcBezier (aT, aA1, aA2) {
	            return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	        }
	
	        function getSlope (aT, aA1, aA2) {
	            return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	        }
	
	        function newtonRaphsonIterate (aX, aGuessT) {
	            for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	                var currentSlope = getSlope(aGuessT, mX1, mX2);
	
	                if (currentSlope === 0.0) return aGuessT;
	
	                var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	                aGuessT -= currentX / currentSlope;
	            }
	
	            return aGuessT;
	        }
	
	        function calcSampleValues () {
	            for (var i = 0; i < kSplineTableSize; ++i) {
	                mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	            }
	        }
	
	        function binarySubdivide (aX, aA, aB) {
	            var currentX, currentT, i = 0;
	
	            do {
	                currentT = aA + (aB - aA) / 2.0;
	                currentX = calcBezier(currentT, mX1, mX2) - aX;
	                if (currentX > 0.0) {
	                  aB = currentT;
	                } else {
	                  aA = currentT;
	                }
	            } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	
	            return currentT;
	        }
	
	        function getTForX (aX) {
	            var intervalStart = 0.0,
	                currentSample = 1,
	                lastSample = kSplineTableSize - 1;
	
	            for (; currentSample != lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	                intervalStart += kSampleStepSize;
	            }
	
	            --currentSample;
	
	            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]),
	                guessForT = intervalStart + dist * kSampleStepSize,
	                initialSlope = getSlope(guessForT, mX1, mX2);
	
	            if (initialSlope >= NEWTON_MIN_SLOPE) {
	                return newtonRaphsonIterate(aX, guessForT);
	            } else if (initialSlope == 0.0) {
	                return guessForT;
	            } else {
	                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize);
	            }
	        }
	
	        var _precomputed = false;
	
	        function precompute() {
	            _precomputed = true;
	            if (mX1 != mY1 || mX2 != mY2) calcSampleValues();
	        }
	
	        var f = function (aX) {
	            if (!_precomputed) precompute();
	            if (mX1 === mY1 && mX2 === mY2) return aX;
	            if (aX === 0) return 0;
	            if (aX === 1) return 1;
	
	            return calcBezier(getTForX(aX), mY1, mY2);
	        };
	
	        f.getControlPoints = function() { return [{ x: mX1, y: mY1 }, { x: mX2, y: mY2 }]; };
	
	        var str = "generateBezier(" + [mX1, mY1, mX2, mY2] + ")";
	        f.toString = function () { return str; };
	
	        return f;
	    }
	
	    /* Runge-Kutta spring physics function generator. Adapted from Framer.js, copyright Koen Bok. MIT License: http://en.wikipedia.org/wiki/MIT_License */
	    /* Given a tension, friction, and duration, a simulation at 60FPS will first run without a defined duration in order to calculate the full path. A second pass
	       then adjusts the time delta -- using the relation between actual time and duration -- to calculate the path for the duration-constrained animation. */
	    var generateSpringRK4 = (function () {
	        function springAccelerationForState (state) {
	            return (-state.tension * state.x) - (state.friction * state.v);
	        }
	
	        function springEvaluateStateWithDerivative (initialState, dt, derivative) {
	            var state = {
	                x: initialState.x + derivative.dx * dt,
	                v: initialState.v + derivative.dv * dt,
	                tension: initialState.tension,
	                friction: initialState.friction
	            };
	
	            return { dx: state.v, dv: springAccelerationForState(state) };
	        }
	
	        function springIntegrateState (state, dt) {
	            var a = {
	                    dx: state.v,
	                    dv: springAccelerationForState(state)
	                },
	                b = springEvaluateStateWithDerivative(state, dt * 0.5, a),
	                c = springEvaluateStateWithDerivative(state, dt * 0.5, b),
	                d = springEvaluateStateWithDerivative(state, dt, c),
	                dxdt = 1.0 / 6.0 * (a.dx + 2.0 * (b.dx + c.dx) + d.dx),
	                dvdt = 1.0 / 6.0 * (a.dv + 2.0 * (b.dv + c.dv) + d.dv);
	
	            state.x = state.x + dxdt * dt;
	            state.v = state.v + dvdt * dt;
	
	            return state;
	        }
	
	        return function springRK4Factory (tension, friction, duration) {
	
	            var initState = {
	                    x: -1,
	                    v: 0,
	                    tension: null,
	                    friction: null
	                },
	                path = [0],
	                time_lapsed = 0,
	                tolerance = 1 / 10000,
	                DT = 16 / 1000,
	                have_duration, dt, last_state;
	
	            tension = parseFloat(tension) || 500;
	            friction = parseFloat(friction) || 20;
	            duration = duration || null;
	
	            initState.tension = tension;
	            initState.friction = friction;
	
	            have_duration = duration !== null;
	
	            /* Calculate the actual time it takes for this animation to complete with the provided conditions. */
	            if (have_duration) {
	                /* Run the simulation without a duration. */
	                time_lapsed = springRK4Factory(tension, friction);
	                /* Compute the adjusted time delta. */
	                dt = time_lapsed / duration * DT;
	            } else {
	                dt = DT;
	            }
	
	            while (true) {
	                /* Next/step function .*/
	                last_state = springIntegrateState(last_state || initState, dt);
	                /* Store the position. */
	                path.push(1 + last_state.x);
	                time_lapsed += 16;
	                /* If the change threshold is reached, break. */
	                if (!(Math.abs(last_state.x) > tolerance && Math.abs(last_state.v) > tolerance)) {
	                    break;
	                }
	            }
	
	            /* If duration is not defined, return the actual time required for completing this animation. Otherwise, return a closure that holds the
	               computed path and returns a snapshot of the position according to a given percentComplete. */
	            return !have_duration ? time_lapsed : function(percentComplete) { return path[ (percentComplete * (path.length - 1)) | 0 ]; };
	        };
	    }());
	
	    /* jQuery easings. */
	    Velocity.Easings = {
	        linear: function(p) { return p; },
	        swing: function(p) { return 0.5 - Math.cos( p * Math.PI ) / 2 },
	        /* Bonus "spring" easing, which is a less exaggerated version of easeInOutElastic. */
	        spring: function(p) { return 1 - (Math.cos(p * 4.5 * Math.PI) * Math.exp(-p * 6)); }
	    };
	
	    /* CSS3 and Robert Penner easings. */
	    $.each(
	        [
	            [ "ease", [ 0.25, 0.1, 0.25, 1.0 ] ],
	            [ "ease-in", [ 0.42, 0.0, 1.00, 1.0 ] ],
	            [ "ease-out", [ 0.00, 0.0, 0.58, 1.0 ] ],
	            [ "ease-in-out", [ 0.42, 0.0, 0.58, 1.0 ] ],
	            [ "easeInSine", [ 0.47, 0, 0.745, 0.715 ] ],
	            [ "easeOutSine", [ 0.39, 0.575, 0.565, 1 ] ],
	            [ "easeInOutSine", [ 0.445, 0.05, 0.55, 0.95 ] ],
	            [ "easeInQuad", [ 0.55, 0.085, 0.68, 0.53 ] ],
	            [ "easeOutQuad", [ 0.25, 0.46, 0.45, 0.94 ] ],
	            [ "easeInOutQuad", [ 0.455, 0.03, 0.515, 0.955 ] ],
	            [ "easeInCubic", [ 0.55, 0.055, 0.675, 0.19 ] ],
	            [ "easeOutCubic", [ 0.215, 0.61, 0.355, 1 ] ],
	            [ "easeInOutCubic", [ 0.645, 0.045, 0.355, 1 ] ],
	            [ "easeInQuart", [ 0.895, 0.03, 0.685, 0.22 ] ],
	            [ "easeOutQuart", [ 0.165, 0.84, 0.44, 1 ] ],
	            [ "easeInOutQuart", [ 0.77, 0, 0.175, 1 ] ],
	            [ "easeInQuint", [ 0.755, 0.05, 0.855, 0.06 ] ],
	            [ "easeOutQuint", [ 0.23, 1, 0.32, 1 ] ],
	            [ "easeInOutQuint", [ 0.86, 0, 0.07, 1 ] ],
	            [ "easeInExpo", [ 0.95, 0.05, 0.795, 0.035 ] ],
	            [ "easeOutExpo", [ 0.19, 1, 0.22, 1 ] ],
	            [ "easeInOutExpo", [ 1, 0, 0, 1 ] ],
	            [ "easeInCirc", [ 0.6, 0.04, 0.98, 0.335 ] ],
	            [ "easeOutCirc", [ 0.075, 0.82, 0.165, 1 ] ],
	            [ "easeInOutCirc", [ 0.785, 0.135, 0.15, 0.86 ] ]
	        ], function(i, easingArray) {
	            Velocity.Easings[easingArray[0]] = generateBezier.apply(null, easingArray[1]);
	        });
	
	    /* Determine the appropriate easing type given an easing input. */
	    function getEasing(value, duration) {
	        var easing = value;
	
	        /* The easing option can either be a string that references a pre-registered easing,
	           or it can be a two-/four-item array of integers to be converted into a bezier/spring function. */
	        if (Type.isString(value)) {
	            /* Ensure that the easing has been assigned to jQuery's Velocity.Easings object. */
	            if (!Velocity.Easings[value]) {
	                easing = false;
	            }
	        } else if (Type.isArray(value) && value.length === 1) {
	            easing = generateStep.apply(null, value);
	        } else if (Type.isArray(value) && value.length === 2) {
	            /* springRK4 must be passed the animation's duration. */
	            /* Note: If the springRK4 array contains non-numbers, generateSpringRK4() returns an easing
	               function generated with default tension and friction values. */
	            easing = generateSpringRK4.apply(null, value.concat([ duration ]));
	        } else if (Type.isArray(value) && value.length === 4) {
	            /* Note: If the bezier array contains non-numbers, generateBezier() returns false. */
	            easing = generateBezier.apply(null, value);
	        } else {
	            easing = false;
	        }
	
	        /* Revert to the Velocity-wide default easing type, or fall back to "swing" (which is also jQuery's default)
	           if the Velocity-wide default has been incorrectly modified. */
	        if (easing === false) {
	            if (Velocity.Easings[Velocity.defaults.easing]) {
	                easing = Velocity.defaults.easing;
	            } else {
	                easing = EASING_DEFAULT;
	            }
	        }
	
	        return easing;
	    }
	
	    /*****************
	        CSS Stack
	    *****************/
	
	    /* The CSS object is a highly condensed and performant CSS stack that fully replaces jQuery's.
	       It handles the validation, getting, and setting of both standard CSS properties and CSS property hooks. */
	    /* Note: A "CSS" shorthand is aliased so that our code is easier to read. */
	    var CSS = Velocity.CSS = {
	
	        /*************
	            RegEx
	        *************/
	
	        RegEx: {
	            isHex: /^#([A-f\d]{3}){1,2}$/i,
	            /* Unwrap a property value's surrounding text, e.g. "rgba(4, 3, 2, 1)" ==> "4, 3, 2, 1" and "rect(4px 3px 2px 1px)" ==> "4px 3px 2px 1px". */
	            valueUnwrap: /^[A-z]+\((.*)\)$/i,
	            wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
	            /* Split a multi-value property into an array of subvalues, e.g. "rgba(4, 3, 2, 1) 4px 3px 2px 1px" ==> [ "rgba(4, 3, 2, 1)", "4px", "3px", "2px", "1px" ]. */
	            valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/ig
	        },
	
	        /************
	            Lists
	        ************/
	
	        Lists: {
	            colors: [ "fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor" ],
	            transformsBase: [ "translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ" ],
	            transforms3D: [ "transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY" ]
	        },
	
	        /************
	            Hooks
	        ************/
	
	        /* Hooks allow a subproperty (e.g. "boxShadowBlur") of a compound-value CSS property
	           (e.g. "boxShadow: X Y Blur Spread Color") to be animated as if it were a discrete property. */
	        /* Note: Beyond enabling fine-grained property animation, hooking is necessary since Velocity only
	           tweens properties with single numeric values; unlike CSS transitions, Velocity does not interpolate compound-values. */
	        Hooks: {
	            /********************
	                Registration
	            ********************/
	
	            /* Templates are a concise way of indicating which subproperties must be individually registered for each compound-value CSS property. */
	            /* Each template consists of the compound-value's base name, its constituent subproperty names, and those subproperties' default values. */
	            templates: {
	                "textShadow": [ "Color X Y Blur", "black 0px 0px 0px" ],
	                "boxShadow": [ "Color X Y Blur Spread", "black 0px 0px 0px 0px" ],
	                "clip": [ "Top Right Bottom Left", "0px 0px 0px 0px" ],
	                "backgroundPosition": [ "X Y", "0% 0%" ],
	                "transformOrigin": [ "X Y Z", "50% 50% 0px" ],
	                "perspectiveOrigin": [ "X Y", "50% 50%" ]
	            },
	
	            /* A "registered" hook is one that has been converted from its template form into a live,
	               tweenable property. It contains data to associate it with its root property. */
	            registered: {
	                /* Note: A registered hook looks like this ==> textShadowBlur: [ "textShadow", 3 ],
	                   which consists of the subproperty's name, the associated root property's name,
	                   and the subproperty's position in the root's value. */
	            },
	            /* Convert the templates into individual hooks then append them to the registered object above. */
	            register: function () {
	                /* Color hooks registration: Colors are defaulted to white -- as opposed to black -- since colors that are
	                   currently set to "transparent" default to their respective template below when color-animated,
	                   and white is typically a closer match to transparent than black is. An exception is made for text ("color"),
	                   which is almost always set closer to black than white. */
	                for (var i = 0; i < CSS.Lists.colors.length; i++) {
	                    var rgbComponents = (CSS.Lists.colors[i] === "color") ? "0 0 0 1" : "255 255 255 1";
	                    CSS.Hooks.templates[CSS.Lists.colors[i]] = [ "Red Green Blue Alpha", rgbComponents ];
	                }
	
	                var rootProperty,
	                    hookTemplate,
	                    hookNames;
	
	                /* In IE, color values inside compound-value properties are positioned at the end the value instead of at the beginning.
	                   Thus, we re-arrange the templates accordingly. */
	                if (IE) {
	                    for (rootProperty in CSS.Hooks.templates) {
	                        hookTemplate = CSS.Hooks.templates[rootProperty];
	                        hookNames = hookTemplate[0].split(" ");
	
	                        var defaultValues = hookTemplate[1].match(CSS.RegEx.valueSplit);
	
	                        if (hookNames[0] === "Color") {
	                            /* Reposition both the hook's name and its default value to the end of their respective strings. */
	                            hookNames.push(hookNames.shift());
	                            defaultValues.push(defaultValues.shift());
	
	                            /* Replace the existing template for the hook's root property. */
	                            CSS.Hooks.templates[rootProperty] = [ hookNames.join(" "), defaultValues.join(" ") ];
	                        }
	                    }
	                }
	
	                /* Hook registration. */
	                for (rootProperty in CSS.Hooks.templates) {
	                    hookTemplate = CSS.Hooks.templates[rootProperty];
	                    hookNames = hookTemplate[0].split(" ");
	
	                    for (var i in hookNames) {
	                        var fullHookName = rootProperty + hookNames[i],
	                            hookPosition = i;
	
	                        /* For each hook, register its full name (e.g. textShadowBlur) with its root property (e.g. textShadow)
	                           and the hook's position in its template's default value string. */
	                        CSS.Hooks.registered[fullHookName] = [ rootProperty, hookPosition ];
	                    }
	                }
	            },
	
	            /*****************************
	               Injection and Extraction
	            *****************************/
	
	            /* Look up the root property associated with the hook (e.g. return "textShadow" for "textShadowBlur"). */
	            /* Since a hook cannot be set directly (the browser won't recognize it), style updating for hooks is routed through the hook's root property. */
	            getRoot: function (property) {
	                var hookData = CSS.Hooks.registered[property];
	
	                if (hookData) {
	                    return hookData[0];
	                } else {
	                    /* If there was no hook match, return the property name untouched. */
	                    return property;
	                }
	            },
	            /* Convert any rootPropertyValue, null or otherwise, into a space-delimited list of hook values so that
	               the targeted hook can be injected or extracted at its standard position. */
	            cleanRootPropertyValue: function(rootProperty, rootPropertyValue) {
	                /* If the rootPropertyValue is wrapped with "rgb()", "clip()", etc., remove the wrapping to normalize the value before manipulation. */
	                if (CSS.RegEx.valueUnwrap.test(rootPropertyValue)) {
	                    rootPropertyValue = rootPropertyValue.match(CSS.RegEx.valueUnwrap)[1];
	                }
	
	                /* If rootPropertyValue is a CSS null-value (from which there's inherently no hook value to extract),
	                   default to the root's default value as defined in CSS.Hooks.templates. */
	                /* Note: CSS null-values include "none", "auto", and "transparent". They must be converted into their
	                   zero-values (e.g. textShadow: "none" ==> textShadow: "0px 0px 0px black") for hook manipulation to proceed. */
	                if (CSS.Values.isCSSNullValue(rootPropertyValue)) {
	                    rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
	                }
	
	                return rootPropertyValue;
	            },
	            /* Extracted the hook's value from its root property's value. This is used to get the starting value of an animating hook. */
	            extractValue: function (fullHookName, rootPropertyValue) {
	                var hookData = CSS.Hooks.registered[fullHookName];
	
	                if (hookData) {
	                    var hookRoot = hookData[0],
	                        hookPosition = hookData[1];
	
	                    rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
	                    /* Split rootPropertyValue into its constituent hook values then grab the desired hook at its standard position. */
	                    return rootPropertyValue.toString().match(CSS.RegEx.valueSplit)[hookPosition];
	                } else {
	                    /* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
	                    return rootPropertyValue;
	                }
	            },
	            /* Inject the hook's value into its root property's value. This is used to piece back together the root property
	               once Velocity has updated one of its individually hooked values through tweening. */
	            injectValue: function (fullHookName, hookValue, rootPropertyValue) {
	                var hookData = CSS.Hooks.registered[fullHookName];
	
	                if (hookData) {
	                    var hookRoot = hookData[0],
	                        hookPosition = hookData[1],
	                        rootPropertyValueParts,
	                        rootPropertyValueUpdated;
	
	                    rootPropertyValue = CSS.Hooks.cleanRootPropertyValue(hookRoot, rootPropertyValue);
	
	                    /* Split rootPropertyValue into its individual hook values, replace the targeted value with hookValue,
	                       then reconstruct the rootPropertyValue string. */
	                    rootPropertyValueParts = rootPropertyValue.toString().match(CSS.RegEx.valueSplit);
	                    rootPropertyValueParts[hookPosition] = hookValue;
	                    rootPropertyValueUpdated = rootPropertyValueParts.join(" ");
	
	                    return rootPropertyValueUpdated;
	                } else {
	                    /* If the provided fullHookName isn't a registered hook, return the rootPropertyValue that was passed in. */
	                    return rootPropertyValue;
	                }
	            }
	        },
	
	        /*******************
	           Normalizations
	        *******************/
	
	        /* Normalizations standardize CSS property manipulation by pollyfilling browser-specific implementations (e.g. opacity)
	           and reformatting special properties (e.g. clip, rgba) to look like standard ones. */
	        Normalizations: {
	            /* Normalizations are passed a normalization target (either the property's name, its extracted value, or its injected value),
	               the targeted element (which may need to be queried), and the targeted property value. */
	            registered: {
	                clip: function (type, element, propertyValue) {
	                    switch (type) {
	                        case "name":
	                            return "clip";
	                        /* Clip needs to be unwrapped and stripped of its commas during extraction. */
	                        case "extract":
	                            var extracted;
	
	                            /* If Velocity also extracted this value, skip extraction. */
	                            if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
	                                extracted = propertyValue;
	                            } else {
	                                /* Remove the "rect()" wrapper. */
	                                extracted = propertyValue.toString().match(CSS.RegEx.valueUnwrap);
	
	                                /* Strip off commas. */
	                                extracted = extracted ? extracted[1].replace(/,(\s+)?/g, " ") : propertyValue;
	                            }
	
	                            return extracted;
	                        /* Clip needs to be re-wrapped during injection. */
	                        case "inject":
	                            return "rect(" + propertyValue + ")";
	                    }
	                },
	
	                blur: function(type, element, propertyValue) {
	                    switch (type) {
	                        case "name":
	                            return Velocity.State.isFirefox ? "filter" : "-webkit-filter";
	                        case "extract":
	                            var extracted = parseFloat(propertyValue);
	
	                            /* If extracted is NaN, meaning the value isn't already extracted. */
	                            if (!(extracted || extracted === 0)) {
	                                var blurComponent = propertyValue.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
	
	                                /* If the filter string had a blur component, return just the blur value and unit type. */
	                                if (blurComponent) {
	                                    extracted = blurComponent[1];
	                                /* If the component doesn't exist, default blur to 0. */
	                                } else {
	                                    extracted = 0;
	                                }
	                            }
	
	                            return extracted;
	                        /* Blur needs to be re-wrapped during injection. */
	                        case "inject":
	                            /* For the blur effect to be fully de-applied, it needs to be set to "none" instead of 0. */
	                            if (!parseFloat(propertyValue)) {
	                                return "none";
	                            } else {
	                                return "blur(" + propertyValue + ")";
	                            }
	                    }
	                },
	
	                /* <=IE8 do not support the standard opacity property. They use filter:alpha(opacity=INT) instead. */
	                opacity: function (type, element, propertyValue) {
	                    if (IE <= 8) {
	                        switch (type) {
	                            case "name":
	                                return "filter";
	                            case "extract":
	                                /* <=IE8 return a "filter" value of "alpha(opacity=\d{1,3})".
	                                   Extract the value and convert it to a decimal value to match the standard CSS opacity property's formatting. */
	                                var extracted = propertyValue.toString().match(/alpha\(opacity=(.*)\)/i);
	
	                                if (extracted) {
	                                    /* Convert to decimal value. */
	                                    propertyValue = extracted[1] / 100;
	                                } else {
	                                    /* When extracting opacity, default to 1 since a null value means opacity hasn't been set. */
	                                    propertyValue = 1;
	                                }
	
	                                return propertyValue;
	                            case "inject":
	                                /* Opacified elements are required to have their zoom property set to a non-zero value. */
	                                element.style.zoom = 1;
	
	                                /* Setting the filter property on elements with certain font property combinations can result in a
	                                   highly unappealing ultra-bolding effect. There's no way to remedy this throughout a tween, but dropping the
	                                   value altogether (when opacity hits 1) at leasts ensures that the glitch is gone post-tweening. */
	                                if (parseFloat(propertyValue) >= 1) {
	                                    return "";
	                                } else {
	                                  /* As per the filter property's spec, convert the decimal value to a whole number and wrap the value. */
	                                  return "alpha(opacity=" + parseInt(parseFloat(propertyValue) * 100, 10) + ")";
	                                }
	                        }
	                    /* With all other browsers, normalization is not required; return the same values that were passed in. */
	                    } else {
	                        switch (type) {
	                            case "name":
	                                return "opacity";
	                            case "extract":
	                                return propertyValue;
	                            case "inject":
	                                return propertyValue;
	                        }
	                    }
	                }
	            },
	
	            /*****************************
	                Batched Registrations
	            *****************************/
	
	            /* Note: Batched normalizations extend the CSS.Normalizations.registered object. */
	            register: function () {
	
	                /*****************
	                    Transforms
	                *****************/
	
	                /* Transforms are the subproperties contained by the CSS "transform" property. Transforms must undergo normalization
	                   so that they can be referenced in a properties map by their individual names. */
	                /* Note: When transforms are "set", they are actually assigned to a per-element transformCache. When all transform
	                   setting is complete complete, CSS.flushTransformCache() must be manually called to flush the values to the DOM.
	                   Transform setting is batched in this way to improve performance: the transform style only needs to be updated
	                   once when multiple transform subproperties are being animated simultaneously. */
	                /* Note: IE9 and Android Gingerbread have support for 2D -- but not 3D -- transforms. Since animating unsupported
	                   transform properties results in the browser ignoring the *entire* transform string, we prevent these 3D values
	                   from being normalized for these browsers so that tweening skips these properties altogether
	                   (since it will ignore them as being unsupported by the browser.) */
	                if (!(IE <= 9) && !Velocity.State.isGingerbread) {
	                    /* Note: Since the standalone CSS "perspective" property and the CSS transform "perspective" subproperty
	                    share the same name, the latter is given a unique token within Velocity: "transformPerspective". */
	                    CSS.Lists.transformsBase = CSS.Lists.transformsBase.concat(CSS.Lists.transforms3D);
	                }
	
	                for (var i = 0; i < CSS.Lists.transformsBase.length; i++) {
	                    /* Wrap the dynamically generated normalization function in a new scope so that transformName's value is
	                    paired with its respective function. (Otherwise, all functions would take the final for loop's transformName.) */
	                    (function() {
	                        var transformName = CSS.Lists.transformsBase[i];
	
	                        CSS.Normalizations.registered[transformName] = function (type, element, propertyValue) {
	                            switch (type) {
	                                /* The normalized property name is the parent "transform" property -- the property that is actually set in CSS. */
	                                case "name":
	                                    return "transform";
	                                /* Transform values are cached onto a per-element transformCache object. */
	                                case "extract":
	                                    /* If this transform has yet to be assigned a value, return its null value. */
	                                    if (Data(element) === undefined || Data(element).transformCache[transformName] === undefined) {
	                                        /* Scale CSS.Lists.transformsBase default to 1 whereas all other transform properties default to 0. */
	                                        return /^scale/i.test(transformName) ? 1 : 0;
	                                    /* When transform values are set, they are wrapped in parentheses as per the CSS spec.
	                                       Thus, when extracting their values (for tween calculations), we strip off the parentheses. */
	                                    } else {
	                                        return Data(element).transformCache[transformName].replace(/[()]/g, "");
	                                    }
	                                case "inject":
	                                    var invalid = false;
	
	                                    /* If an individual transform property contains an unsupported unit type, the browser ignores the *entire* transform property.
	                                       Thus, protect users from themselves by skipping setting for transform values supplied with invalid unit types. */
	                                    /* Switch on the base transform type; ignore the axis by removing the last letter from the transform's name. */
	                                    switch (transformName.substr(0, transformName.length - 1)) {
	                                        /* Whitelist unit types for each transform. */
	                                        case "translate":
	                                            invalid = !/(%|px|em|rem|vw|vh|\d)$/i.test(propertyValue);
	                                            break;
	                                        /* Since an axis-free "scale" property is supported as well, a little hack is used here to detect it by chopping off its last letter. */
	                                        case "scal":
	                                        case "scale":
	                                            /* Chrome on Android has a bug in which scaled elements blur if their initial scale
	                                               value is below 1 (which can happen with forcefeeding). Thus, we detect a yet-unset scale property
	                                               and ensure that its first value is always 1. More info: http://stackoverflow.com/questions/10417890/css3-animations-with-transform-causes-blurred-elements-on-webkit/10417962#10417962 */
	                                            if (Velocity.State.isAndroid && Data(element).transformCache[transformName] === undefined && propertyValue < 1) {
	                                                propertyValue = 1;
	                                            }
	
	                                            invalid = !/(\d)$/i.test(propertyValue);
	                                            break;
	                                        case "skew":
	                                            invalid = !/(deg|\d)$/i.test(propertyValue);
	                                            break;
	                                        case "rotate":
	                                            invalid = !/(deg|\d)$/i.test(propertyValue);
	                                            break;
	                                    }
	
	                                    if (!invalid) {
	                                        /* As per the CSS spec, wrap the value in parentheses. */
	                                        Data(element).transformCache[transformName] = "(" + propertyValue + ")";
	                                    }
	
	                                    /* Although the value is set on the transformCache object, return the newly-updated value for the calling code to process as normal. */
	                                    return Data(element).transformCache[transformName];
	                            }
	                        };
	                    })();
	                }
	
	                /*************
	                    Colors
	                *************/
	
	                /* Since Velocity only animates a single numeric value per property, color animation is achieved by hooking the individual RGBA components of CSS color properties.
	                   Accordingly, color values must be normalized (e.g. "#ff0000", "red", and "rgb(255, 0, 0)" ==> "255 0 0 1") so that their components can be injected/extracted by CSS.Hooks logic. */
	                for (var i = 0; i < CSS.Lists.colors.length; i++) {
	                    /* Wrap the dynamically generated normalization function in a new scope so that colorName's value is paired with its respective function.
	                       (Otherwise, all functions would take the final for loop's colorName.) */
	                    (function () {
	                        var colorName = CSS.Lists.colors[i];
	
	                        /* Note: In IE<=8, which support rgb but not rgba, color properties are reverted to rgb by stripping off the alpha component. */
	                        CSS.Normalizations.registered[colorName] = function(type, element, propertyValue) {
	                            switch (type) {
	                                case "name":
	                                    return colorName;
	                                /* Convert all color values into the rgb format. (Old IE can return hex values and color names instead of rgb/rgba.) */
	                                case "extract":
	                                    var extracted;
	
	                                    /* If the color is already in its hookable form (e.g. "255 255 255 1") due to having been previously extracted, skip extraction. */
	                                    if (CSS.RegEx.wrappedValueAlreadyExtracted.test(propertyValue)) {
	                                        extracted = propertyValue;
	                                    } else {
	                                        var converted,
	                                            colorNames = {
	                                                black: "rgb(0, 0, 0)",
	                                                blue: "rgb(0, 0, 255)",
	                                                gray: "rgb(128, 128, 128)",
	                                                green: "rgb(0, 128, 0)",
	                                                red: "rgb(255, 0, 0)",
	                                                white: "rgb(255, 255, 255)"
	                                            };
	
	                                        /* Convert color names to rgb. */
	                                        if (/^[A-z]+$/i.test(propertyValue)) {
	                                            if (colorNames[propertyValue] !== undefined) {
	                                                converted = colorNames[propertyValue]
	                                            } else {
	                                                /* If an unmatched color name is provided, default to black. */
	                                                converted = colorNames.black;
	                                            }
	                                        /* Convert hex values to rgb. */
	                                        } else if (CSS.RegEx.isHex.test(propertyValue)) {
	                                            converted = "rgb(" + CSS.Values.hexToRgb(propertyValue).join(" ") + ")";
	                                        /* If the provided color doesn't match any of the accepted color formats, default to black. */
	                                        } else if (!(/^rgba?\(/i.test(propertyValue))) {
	                                            converted = colorNames.black;
	                                        }
	
	                                        /* Remove the surrounding "rgb/rgba()" string then replace commas with spaces and strip
	                                           repeated spaces (in case the value included spaces to begin with). */
	                                        extracted = (converted || propertyValue).toString().match(CSS.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ");
	                                    }
	
	                                    /* So long as this isn't <=IE8, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
	                                    if (!(IE <= 8) && extracted.split(" ").length === 3) {
	                                        extracted += " 1";
	                                    }
	
	                                    return extracted;
	                                case "inject":
	                                    /* If this is IE<=8 and an alpha component exists, strip it off. */
	                                    if (IE <= 8) {
	                                        if (propertyValue.split(" ").length === 4) {
	                                            propertyValue = propertyValue.split(/\s+/).slice(0, 3).join(" ");
	                                        }
	                                    /* Otherwise, add a fourth (alpha) component if it's missing and default it to 1 (visible). */
	                                    } else if (propertyValue.split(" ").length === 3) {
	                                        propertyValue += " 1";
	                                    }
	
	                                    /* Re-insert the browser-appropriate wrapper("rgb/rgba()"), insert commas, and strip off decimal units
	                                       on all values but the fourth (R, G, and B only accept whole numbers). */
	                                    return (IE <= 8 ? "rgb" : "rgba") + "(" + propertyValue.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")";
	                            }
	                        };
	                    })();
	                }
	            }
	        },
	
	        /************************
	           CSS Property Names
	        ************************/
	
	        Names: {
	            /* Camelcase a property name into its JavaScript notation (e.g. "background-color" ==> "backgroundColor").
	               Camelcasing is used to normalize property names between and across calls. */
	            camelCase: function (property) {
	                return property.replace(/-(\w)/g, function (match, subMatch) {
	                    return subMatch.toUpperCase();
	                });
	            },
	
	            /* For SVG elements, some properties (namely, dimensional ones) are GET/SET via the element's HTML attributes (instead of via CSS styles). */
	            SVGAttribute: function (property) {
	                var SVGAttributes = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
	
	                /* Certain browsers require an SVG transform to be applied as an attribute. (Otherwise, application via CSS is preferable due to 3D support.) */
	                if (IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) {
	                    SVGAttributes += "|transform";
	                }
	
	                return new RegExp("^(" + SVGAttributes + ")$", "i").test(property);
	            },
	
	            /* Determine whether a property should be set with a vendor prefix. */
	            /* If a prefixed version of the property exists, return it. Otherwise, return the original property name.
	               If the property is not at all supported by the browser, return a false flag. */
	            prefixCheck: function (property) {
	                /* If this property has already been checked, return the cached value. */
	                if (Velocity.State.prefixMatches[property]) {
	                    return [ Velocity.State.prefixMatches[property], true ];
	                } else {
	                    var vendors = [ "", "Webkit", "Moz", "ms", "O" ];
	
	                    for (var i = 0, vendorsLength = vendors.length; i < vendorsLength; i++) {
	                        var propertyPrefixed;
	
	                        if (i === 0) {
	                            propertyPrefixed = property;
	                        } else {
	                            /* Capitalize the first letter of the property to conform to JavaScript vendor prefix notation (e.g. webkitFilter). */
	                            propertyPrefixed = vendors[i] + property.replace(/^\w/, function(match) { return match.toUpperCase(); });
	                        }
	
	                        /* Check if the browser supports this property as prefixed. */
	                        if (Type.isString(Velocity.State.prefixElement.style[propertyPrefixed])) {
	                            /* Cache the match. */
	                            Velocity.State.prefixMatches[property] = propertyPrefixed;
	
	                            return [ propertyPrefixed, true ];
	                        }
	                    }
	
	                    /* If the browser doesn't support this property in any form, include a false flag so that the caller can decide how to proceed. */
	                    return [ property, false ];
	                }
	            }
	        },
	
	        /************************
	           CSS Property Values
	        ************************/
	
	        Values: {
	            /* Hex to RGB conversion. Copyright Tim Down: http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb */
	            hexToRgb: function (hex) {
	                var shortformRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
	                    longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
	                    rgbParts;
	
	                hex = hex.replace(shortformRegex, function (m, r, g, b) {
	                    return r + r + g + g + b + b;
	                });
	
	                rgbParts = longformRegex.exec(hex);
	
	                return rgbParts ? [ parseInt(rgbParts[1], 16), parseInt(rgbParts[2], 16), parseInt(rgbParts[3], 16) ] : [ 0, 0, 0 ];
	            },
	
	            isCSSNullValue: function (value) {
	                /* The browser defaults CSS values that have not been set to either 0 or one of several possible null-value strings.
	                   Thus, we check for both falsiness and these special strings. */
	                /* Null-value checking is performed to default the special strings to 0 (for the sake of tweening) or their hook
	                   templates as defined as CSS.Hooks (for the sake of hook injection/extraction). */
	                /* Note: Chrome returns "rgba(0, 0, 0, 0)" for an undefined color whereas IE returns "transparent". */
	                return (value == 0 || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(value));
	            },
	
	            /* Retrieve a property's default unit type. Used for assigning a unit type when one is not supplied by the user. */
	            getUnitType: function (property) {
	                if (/^(rotate|skew)/i.test(property)) {
	                    return "deg";
	                } else if (/(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(property)) {
	                    /* The above properties are unitless. */
	                    return "";
	                } else {
	                    /* Default to px for all other properties. */
	                    return "px";
	                }
	            },
	
	            /* HTML elements default to an associated display type when they're not set to display:none. */
	            /* Note: This function is used for correctly setting the non-"none" display value in certain Velocity redirects, such as fadeIn/Out. */
	            getDisplayType: function (element) {
	                var tagName = element && element.tagName.toString().toLowerCase();
	
	                if (/^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(tagName)) {
	                    return "inline";
	                } else if (/^(li)$/i.test(tagName)) {
	                    return "list-item";
	                } else if (/^(tr)$/i.test(tagName)) {
	                    return "table-row";
	                } else if (/^(table)$/i.test(tagName)) {
	                    return "table";
	                } else if (/^(tbody)$/i.test(tagName)) {
	                    return "table-row-group";
	                /* Default to "block" when no match is found. */
	                } else {
	                    return "block";
	                }
	            },
	
	            /* The class add/remove functions are used to temporarily apply a "velocity-animating" class to elements while they're animating. */
	            addClass: function (element, className) {
	                if (element.classList) {
	                    element.classList.add(className);
	                } else {
	                    element.className += (element.className.length ? " " : "") + className;
	                }
	            },
	
	            removeClass: function (element, className) {
	                if (element.classList) {
	                    element.classList.remove(className);
	                } else {
	                    element.className = element.className.toString().replace(new RegExp("(^|\\s)" + className.split(" ").join("|") + "(\\s|$)", "gi"), " ");
	                }
	            }
	        },
	
	        /****************************
	           Style Getting & Setting
	        ****************************/
	
	        /* The singular getPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
	        getPropertyValue: function (element, property, rootPropertyValue, forceStyleLookup) {
	            /* Get an element's computed property value. */
	            /* Note: Retrieving the value of a CSS property cannot simply be performed by checking an element's
	               style attribute (which only reflects user-defined values). Instead, the browser must be queried for a property's
	               *computed* value. You can read more about getComputedStyle here: https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle */
	            function computePropertyValue (element, property) {
	                /* When box-sizing isn't set to border-box, height and width style values are incorrectly computed when an
	                   element's scrollbars are visible (which expands the element's dimensions). Thus, we defer to the more accurate
	                   offsetHeight/Width property, which includes the total dimensions for interior, border, padding, and scrollbar.
	                   We subtract border and padding to get the sum of interior + scrollbar. */
	                var computedValue = 0;
	
	                /* IE<=8 doesn't support window.getComputedStyle, thus we defer to jQuery, which has an extensive array
	                   of hacks to accurately retrieve IE8 property values. Re-implementing that logic here is not worth bloating the
	                   codebase for a dying browser. The performance repercussions of using jQuery here are minimal since
	                   Velocity is optimized to rarely (and sometimes never) query the DOM. Further, the $.css() codepath isn't that slow. */
	                if (IE <= 8) {
	                    computedValue = $.css(element, property); /* GET */
	                /* All other browsers support getComputedStyle. The returned live object reference is cached onto its
	                   associated element so that it does not need to be refetched upon every GET. */
	                } else {
	                    /* Browsers do not return height and width values for elements that are set to display:"none". Thus, we temporarily
	                       toggle display to the element type's default value. */
	                    var toggleDisplay = false;
	
	                    if (/^(width|height)$/.test(property) && CSS.getPropertyValue(element, "display") === 0) {
	                        toggleDisplay = true;
	                        CSS.setPropertyValue(element, "display", CSS.Values.getDisplayType(element));
	                    }
	
	                    function revertDisplay () {
	                        if (toggleDisplay) {
	                            CSS.setPropertyValue(element, "display", "none");
	                        }
	                    }
	
	                    if (!forceStyleLookup) {
	                        if (property === "height" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
	                            var contentBoxHeight = element.offsetHeight - (parseFloat(CSS.getPropertyValue(element, "borderTopWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderBottomWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingTop")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingBottom")) || 0);
	                            revertDisplay();
	
	                            return contentBoxHeight;
	                        } else if (property === "width" && CSS.getPropertyValue(element, "boxSizing").toString().toLowerCase() !== "border-box") {
	                            var contentBoxWidth = element.offsetWidth - (parseFloat(CSS.getPropertyValue(element, "borderLeftWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "borderRightWidth")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingLeft")) || 0) - (parseFloat(CSS.getPropertyValue(element, "paddingRight")) || 0);
	                            revertDisplay();
	
	                            return contentBoxWidth;
	                        }
	                    }
	
	                    var computedStyle;
	
	                    /* For elements that Velocity hasn't been called on directly (e.g. when Velocity queries the DOM on behalf
	                       of a parent of an element its animating), perform a direct getComputedStyle lookup since the object isn't cached. */
	                    if (Data(element) === undefined) {
	                        computedStyle = window.getComputedStyle(element, null); /* GET */
	                    /* If the computedStyle object has yet to be cached, do so now. */
	                    } else if (!Data(element).computedStyle) {
	                        computedStyle = Data(element).computedStyle = window.getComputedStyle(element, null); /* GET */
	                    /* If computedStyle is cached, use it. */
	                    } else {
	                        computedStyle = Data(element).computedStyle;
	                    }
	
	                    /* IE and Firefox do not return a value for the generic borderColor -- they only return individual values for each border side's color.
	                       Also, in all browsers, when border colors aren't all the same, a compound value is returned that Velocity isn't setup to parse.
	                       So, as a polyfill for querying individual border side colors, we just return the top border's color and animate all borders from that value. */
	                    if (property === "borderColor") {
	                        property = "borderTopColor";
	                    }
	
	                    /* IE9 has a bug in which the "filter" property must be accessed from computedStyle using the getPropertyValue method
	                       instead of a direct property lookup. The getPropertyValue method is slower than a direct lookup, which is why we avoid it by default. */
	                    if (IE === 9 && property === "filter") {
	                        computedValue = computedStyle.getPropertyValue(property); /* GET */
	                    } else {
	                        computedValue = computedStyle[property];
	                    }
	
	                    /* Fall back to the property's style value (if defined) when computedValue returns nothing,
	                       which can happen when the element hasn't been painted. */
	                    if (computedValue === "" || computedValue === null) {
	                        computedValue = element.style[property];
	                    }
	
	                    revertDisplay();
	                }
	
	                /* For top, right, bottom, and left (TRBL) values that are set to "auto" on elements of "fixed" or "absolute" position,
	                   defer to jQuery for converting "auto" to a numeric value. (For elements with a "static" or "relative" position, "auto" has the same
	                   effect as being set to 0, so no conversion is necessary.) */
	                /* An example of why numeric conversion is necessary: When an element with "position:absolute" has an untouched "left"
	                   property, which reverts to "auto", left's value is 0 relative to its parent element, but is often non-zero relative
	                   to its *containing* (not parent) element, which is the nearest "position:relative" ancestor or the viewport (and always the viewport in the case of "position:fixed"). */
	                if (computedValue === "auto" && /^(top|right|bottom|left)$/i.test(property)) {
	                    var position = computePropertyValue(element, "position"); /* GET */
	
	                    /* For absolute positioning, jQuery's $.position() only returns values for top and left;
	                       right and bottom will have their "auto" value reverted to 0. */
	                    /* Note: A jQuery object must be created here since jQuery doesn't have a low-level alias for $.position().
	                       Not a big deal since we're currently in a GET batch anyway. */
	                    if (position === "fixed" || (position === "absolute" && /top|left/i.test(property))) {
	                        /* Note: jQuery strips the pixel unit from its returned values; we re-add it here to conform with computePropertyValue's behavior. */
	                        computedValue = $(element).position()[property] + "px"; /* GET */
	                    }
	                }
	
	                return computedValue;
	            }
	
	            var propertyValue;
	
	            /* If this is a hooked property (e.g. "clipLeft" instead of the root property of "clip"),
	               extract the hook's value from a normalized rootPropertyValue using CSS.Hooks.extractValue(). */
	            if (CSS.Hooks.registered[property]) {
	                var hook = property,
	                    hookRoot = CSS.Hooks.getRoot(hook);
	
	                /* If a cached rootPropertyValue wasn't passed in (which Velocity always attempts to do in order to avoid requerying the DOM),
	                   query the DOM for the root property's value. */
	                if (rootPropertyValue === undefined) {
	                    /* Since the browser is now being directly queried, use the official post-prefixing property name for this lookup. */
	                    rootPropertyValue = CSS.getPropertyValue(element, CSS.Names.prefixCheck(hookRoot)[0]); /* GET */
	                }
	
	                /* If this root has a normalization registered, peform the associated normalization extraction. */
	                if (CSS.Normalizations.registered[hookRoot]) {
	                    rootPropertyValue = CSS.Normalizations.registered[hookRoot]("extract", element, rootPropertyValue);
	                }
	
	                /* Extract the hook's value. */
	                propertyValue = CSS.Hooks.extractValue(hook, rootPropertyValue);
	
	            /* If this is a normalized property (e.g. "opacity" becomes "filter" in <=IE8) or "translateX" becomes "transform"),
	               normalize the property's name and value, and handle the special case of transforms. */
	            /* Note: Normalizing a property is mutually exclusive from hooking a property since hook-extracted values are strictly
	               numerical and therefore do not require normalization extraction. */
	            } else if (CSS.Normalizations.registered[property]) {
	                var normalizedPropertyName,
	                    normalizedPropertyValue;
	
	                normalizedPropertyName = CSS.Normalizations.registered[property]("name", element);
	
	                /* Transform values are calculated via normalization extraction (see below), which checks against the element's transformCache.
	                   At no point do transform GETs ever actually query the DOM; initial stylesheet values are never processed.
	                   This is because parsing 3D transform matrices is not always accurate and would bloat our codebase;
	                   thus, normalization extraction defaults initial transform values to their zero-values (e.g. 1 for scaleX and 0 for translateX). */
	                if (normalizedPropertyName !== "transform") {
	                    normalizedPropertyValue = computePropertyValue(element, CSS.Names.prefixCheck(normalizedPropertyName)[0]); /* GET */
	
	                    /* If the value is a CSS null-value and this property has a hook template, use that zero-value template so that hooks can be extracted from it. */
	                    if (CSS.Values.isCSSNullValue(normalizedPropertyValue) && CSS.Hooks.templates[property]) {
	                        normalizedPropertyValue = CSS.Hooks.templates[property][1];
	                    }
	                }
	
	                propertyValue = CSS.Normalizations.registered[property]("extract", element, normalizedPropertyValue);
	            }
	
	            /* If a (numeric) value wasn't produced via hook extraction or normalization, query the DOM. */
	            if (!/^[\d-]/.test(propertyValue)) {
	                /* For SVG elements, dimensional properties (which SVGAttribute() detects) are tweened via
	                   their HTML attribute values instead of their CSS style values. */
	                if (Data(element) && Data(element).isSVG && CSS.Names.SVGAttribute(property)) {
	                    /* Since the height/width attribute values must be set manually, they don't reflect computed values.
	                       Thus, we use use getBBox() to ensure we always get values for elements with undefined height/width attributes. */
	                    if (/^(height|width)$/i.test(property)) {
	                        /* Firefox throws an error if .getBBox() is called on an SVG that isn't attached to the DOM. */
	                        try {
	                            propertyValue = element.getBBox()[property];
	                        } catch (error) {
	                            propertyValue = 0;
	                        }
	                    /* Otherwise, access the attribute value directly. */
	                    } else {
	                        propertyValue = element.getAttribute(property);
	                    }
	                } else {
	                    propertyValue = computePropertyValue(element, CSS.Names.prefixCheck(property)[0]); /* GET */
	                }
	            }
	
	            /* Since property lookups are for animation purposes (which entails computing the numeric delta between start and end values),
	               convert CSS null-values to an integer of value 0. */
	            if (CSS.Values.isCSSNullValue(propertyValue)) {
	                propertyValue = 0;
	            }
	
	            if (Velocity.debug >= 2) console.log("Get " + property + ": " + propertyValue);
	
	            return propertyValue;
	        },
	
	        /* The singular setPropertyValue, which routes the logic for all normalizations, hooks, and standard CSS properties. */
	        setPropertyValue: function(element, property, propertyValue, rootPropertyValue, scrollData) {
	            var propertyName = property;
	
	            /* In order to be subjected to call options and element queueing, scroll animation is routed through Velocity as if it were a standard CSS property. */
	            if (property === "scroll") {
	                /* If a container option is present, scroll the container instead of the browser window. */
	                if (scrollData.container) {
	                    scrollData.container["scroll" + scrollData.direction] = propertyValue;
	                /* Otherwise, Velocity defaults to scrolling the browser window. */
	                } else {
	                    if (scrollData.direction === "Left") {
	                        window.scrollTo(propertyValue, scrollData.alternateValue);
	                    } else {
	                        window.scrollTo(scrollData.alternateValue, propertyValue);
	                    }
	                }
	            } else {
	                /* Transforms (translateX, rotateZ, etc.) are applied to a per-element transformCache object, which is manually flushed via flushTransformCache().
	                   Thus, for now, we merely cache transforms being SET. */
	                if (CSS.Normalizations.registered[property] && CSS.Normalizations.registered[property]("name", element) === "transform") {
	                    /* Perform a normalization injection. */
	                    /* Note: The normalization logic handles the transformCache updating. */
	                    CSS.Normalizations.registered[property]("inject", element, propertyValue);
	
	                    propertyName = "transform";
	                    propertyValue = Data(element).transformCache[property];
	                } else {
	                    /* Inject hooks. */
	                    if (CSS.Hooks.registered[property]) {
	                        var hookName = property,
	                            hookRoot = CSS.Hooks.getRoot(property);
	
	                        /* If a cached rootPropertyValue was not provided, query the DOM for the hookRoot's current value. */
	                        rootPropertyValue = rootPropertyValue || CSS.getPropertyValue(element, hookRoot); /* GET */
	
	                        propertyValue = CSS.Hooks.injectValue(hookName, propertyValue, rootPropertyValue);
	                        property = hookRoot;
	                    }
	
	                    /* Normalize names and values. */
	                    if (CSS.Normalizations.registered[property]) {
	                        propertyValue = CSS.Normalizations.registered[property]("inject", element, propertyValue);
	                        property = CSS.Normalizations.registered[property]("name", element);
	                    }
	
	                    /* Assign the appropriate vendor prefix before performing an official style update. */
	                    propertyName = CSS.Names.prefixCheck(property)[0];
	
	                    /* A try/catch is used for IE<=8, which throws an error when "invalid" CSS values are set, e.g. a negative width.
	                       Try/catch is avoided for other browsers since it incurs a performance overhead. */
	                    if (IE <= 8) {
	                        try {
	                            element.style[propertyName] = propertyValue;
	                        } catch (error) { if (Velocity.debug) console.log("Browser does not support [" + propertyValue + "] for [" + propertyName + "]"); }
	                    /* SVG elements have their dimensional properties (width, height, x, y, cx, etc.) applied directly as attributes instead of as styles. */
	                    /* Note: IE8 does not support SVG elements, so it's okay that we skip it for SVG animation. */
	                    } else if (Data(element) && Data(element).isSVG && CSS.Names.SVGAttribute(property)) {
	                        /* Note: For SVG attributes, vendor-prefixed property names are never used. */
	                        /* Note: Not all CSS properties can be animated via attributes, but the browser won't throw an error for unsupported properties. */
	                        element.setAttribute(property, propertyValue);
	                    } else {
	                        element.style[propertyName] = propertyValue;
	                    }
	
	                    if (Velocity.debug >= 2) console.log("Set " + property + " (" + propertyName + "): " + propertyValue);
	                }
	            }
	
	            /* Return the normalized property name and value in case the caller wants to know how these values were modified before being applied to the DOM. */
	            return [ propertyName, propertyValue ];
	        },
	
	        /* To increase performance by batching transform updates into a single SET, transforms are not directly applied to an element until flushTransformCache() is called. */
	        /* Note: Velocity applies transform properties in the same order that they are chronogically introduced to the element's CSS styles. */
	        flushTransformCache: function(element) {
	            var transformString = "";
	
	            /* Certain browsers require that SVG transforms be applied as an attribute. However, the SVG transform attribute takes a modified version of CSS's transform string
	               (units are dropped and, except for skewX/Y, subproperties are merged into their master property -- e.g. scaleX and scaleY are merged into scale(X Y). */
	            if ((IE || (Velocity.State.isAndroid && !Velocity.State.isChrome)) && Data(element).isSVG) {
	                /* Since transform values are stored in their parentheses-wrapped form, we use a helper function to strip out their numeric values.
	                   Further, SVG transform properties only take unitless (representing pixels) values, so it's okay that parseFloat() strips the unit suffixed to the float value. */
	                function getTransformFloat (transformProperty) {
	                    return parseFloat(CSS.getPropertyValue(element, transformProperty));
	                }
	
	                /* Create an object to organize all the transforms that we'll apply to the SVG element. To keep the logic simple,
	                   we process *all* transform properties -- even those that may not be explicitly applied (since they default to their zero-values anyway). */
	                var SVGTransforms = {
	                    translate: [ getTransformFloat("translateX"), getTransformFloat("translateY") ],
	                    skewX: [ getTransformFloat("skewX") ], skewY: [ getTransformFloat("skewY") ],
	                    /* If the scale property is set (non-1), use that value for the scaleX and scaleY values
	                       (this behavior mimics the result of animating all these properties at once on HTML elements). */
	                    scale: getTransformFloat("scale") !== 1 ? [ getTransformFloat("scale"), getTransformFloat("scale") ] : [ getTransformFloat("scaleX"), getTransformFloat("scaleY") ],
	                    /* Note: SVG's rotate transform takes three values: rotation degrees followed by the X and Y values
	                       defining the rotation's origin point. We ignore the origin values (default them to 0). */
	                    rotate: [ getTransformFloat("rotateZ"), 0, 0 ]
	                };
	
	                /* Iterate through the transform properties in the user-defined property map order.
	                   (This mimics the behavior of non-SVG transform animation.) */
	                $.each(Data(element).transformCache, function(transformName) {
	                    /* Except for with skewX/Y, revert the axis-specific transform subproperties to their axis-free master
	                       properties so that they match up with SVG's accepted transform properties. */
	                    if (/^translate/i.test(transformName)) {
	                        transformName = "translate";
	                    } else if (/^scale/i.test(transformName)) {
	                        transformName = "scale";
	                    } else if (/^rotate/i.test(transformName)) {
	                        transformName = "rotate";
	                    }
	
	                    /* Check that we haven't yet deleted the property from the SVGTransforms container. */
	                    if (SVGTransforms[transformName]) {
	                        /* Append the transform property in the SVG-supported transform format. As per the spec, surround the space-delimited values in parentheses. */
	                        transformString += transformName + "(" + SVGTransforms[transformName].join(" ") + ")" + " ";
	
	                        /* After processing an SVG transform property, delete it from the SVGTransforms container so we don't
	                           re-insert the same master property if we encounter another one of its axis-specific properties. */
	                        delete SVGTransforms[transformName];
	                    }
	                });
	            } else {
	                var transformValue,
	                    perspective;
	
	                /* Transform properties are stored as members of the transformCache object. Concatenate all the members into a string. */
	                $.each(Data(element).transformCache, function(transformName) {
	                    transformValue = Data(element).transformCache[transformName];
	
	                    /* Transform's perspective subproperty must be set first in order to take effect. Store it temporarily. */
	                    if (transformName === "transformPerspective") {
	                        perspective = transformValue;
	                        return true;
	                    }
	
	                    /* IE9 only supports one rotation type, rotateZ, which it refers to as "rotate". */
	                    if (IE === 9 && transformName === "rotateZ") {
	                        transformName = "rotate";
	                    }
	
	                    transformString += transformName + transformValue + " ";
	                });
	
	                /* If present, set the perspective subproperty first. */
	                if (perspective) {
	                    transformString = "perspective" + perspective + " " + transformString;
	                }
	            }
	
	            CSS.setPropertyValue(element, "transform", transformString);
	        }
	    };
	
	    /* Register hooks and normalizations. */
	    CSS.Hooks.register();
	    CSS.Normalizations.register();
	
	    /* Allow hook setting in the same fashion as jQuery's $.css(). */
	    Velocity.hook = function (elements, arg2, arg3) {
	        var value = undefined;
	
	        elements = sanitizeElements(elements);
	
	        $.each(elements, function(i, element) {
	            /* Initialize Velocity's per-element data cache if this element hasn't previously been animated. */
	            if (Data(element) === undefined) {
	                Velocity.init(element);
	            }
	
	            /* Get property value. If an element set was passed in, only return the value for the first element. */
	            if (arg3 === undefined) {
	                if (value === undefined) {
	                    value = Velocity.CSS.getPropertyValue(element, arg2);
	                }
	            /* Set property value. */
	            } else {
	                /* sPV returns an array of the normalized propertyName/propertyValue pair used to update the DOM. */
	                var adjustedSet = Velocity.CSS.setPropertyValue(element, arg2, arg3);
	
	                /* Transform properties don't automatically set. They have to be flushed to the DOM. */
	                if (adjustedSet[0] === "transform") {
	                    Velocity.CSS.flushTransformCache(element);
	                }
	
	                value = adjustedSet;
	            }
	        });
	
	        return value;
	    };
	
	    /*****************
	        Animation
	    *****************/
	
	    var animate = function() {
	
	        /******************
	            Call Chain
	        ******************/
	
	        /* Logic for determining what to return to the call stack when exiting out of Velocity. */
	        function getChain () {
	            /* If we are using the utility function, attempt to return this call's promise. If no promise library was detected,
	               default to null instead of returning the targeted elements so that utility function's return value is standardized. */
	            if (isUtility) {
	                return promiseData.promise || null;
	            /* Otherwise, if we're using $.fn, return the jQuery-/Zepto-wrapped element set. */
	            } else {
	                return elementsWrapped;
	            }
	        }
	
	        /*************************
	           Arguments Assignment
	        *************************/
	
	        /* To allow for expressive CoffeeScript code, Velocity supports an alternative syntax in which "elements" (or "e"), "properties" (or "p"), and "options" (or "o")
	           objects are defined on a container object that's passed in as Velocity's sole argument. */
	        /* Note: Some browsers automatically populate arguments with a "properties" object. We detect it by checking for its default "names" property. */
	        var syntacticSugar = (arguments[0] && (arguments[0].p || (($.isPlainObject(arguments[0].properties) && !arguments[0].properties.names) || Type.isString(arguments[0].properties)))),
	            /* Whether Velocity was called via the utility function (as opposed to on a jQuery/Zepto object). */
	            isUtility,
	            /* When Velocity is called via the utility function ($.Velocity()/Velocity()), elements are explicitly
	               passed in as the first parameter. Thus, argument positioning varies. We normalize them here. */
	            elementsWrapped,
	            argumentIndex;
	
	        var elements,
	            propertiesMap,
	            options;
	
	        /* Detect jQuery/Zepto elements being animated via the $.fn method. */
	        if (Type.isWrapped(this)) {
	            isUtility = false;
	
	            argumentIndex = 0;
	            elements = this;
	            elementsWrapped = this;
	        /* Otherwise, raw elements are being animated via the utility function. */
	        } else {
	            isUtility = true;
	
	            argumentIndex = 1;
	            elements = syntacticSugar ? (arguments[0].elements || arguments[0].e) : arguments[0];
	        }
	
	        elements = sanitizeElements(elements);
	
	        if (!elements) {
	            return;
	        }
	
	        if (syntacticSugar) {
	            propertiesMap = arguments[0].properties || arguments[0].p;
	            options = arguments[0].options || arguments[0].o;
	        } else {
	            propertiesMap = arguments[argumentIndex];
	            options = arguments[argumentIndex + 1];
	        }
	
	        /* The length of the element set (in the form of a nodeList or an array of elements) is defaulted to 1 in case a
	           single raw DOM element is passed in (which doesn't contain a length property). */
	        var elementsLength = elements.length,
	            elementsIndex = 0;
	
	        /***************************
	            Argument Overloading
	        ***************************/
	
	        /* Support is included for jQuery's argument overloading: $.animate(propertyMap [, duration] [, easing] [, complete]).
	           Overloading is detected by checking for the absence of an object being passed into options. */
	        /* Note: The stop and finish actions do not accept animation options, and are therefore excluded from this check. */
	        if (!/^(stop|finish|finishAll)$/i.test(propertiesMap) && !$.isPlainObject(options)) {
	            /* The utility function shifts all arguments one position to the right, so we adjust for that offset. */
	            var startingArgumentPosition = argumentIndex + 1;
	
	            options = {};
	
	            /* Iterate through all options arguments */
	            for (var i = startingArgumentPosition; i < arguments.length; i++) {
	                /* Treat a number as a duration. Parse it out. */
	                /* Note: The following RegEx will return true if passed an array with a number as its first item.
	                   Thus, arrays are skipped from this check. */
	                if (!Type.isArray(arguments[i]) && (/^(fast|normal|slow)$/i.test(arguments[i]) || /^\d/.test(arguments[i]))) {
	                    options.duration = arguments[i];
	                /* Treat strings and arrays as easings. */
	                } else if (Type.isString(arguments[i]) || Type.isArray(arguments[i])) {
	                    options.easing = arguments[i];
	                /* Treat a function as a complete callback. */
	                } else if (Type.isFunction(arguments[i])) {
	                    options.complete = arguments[i];
	                }
	            }
	        }
	
	        /***************
	            Promises
	        ***************/
	
	        var promiseData = {
	                promise: null,
	                resolver: null,
	                rejecter: null
	            };
	
	        /* If this call was made via the utility function (which is the default method of invocation when jQuery/Zepto are not being used), and if
	           promise support was detected, create a promise object for this call and store references to its resolver and rejecter methods. The resolve
	           method is used when a call completes naturally or is prematurely stopped by the user. In both cases, completeCall() handles the associated
	           call cleanup and promise resolving logic. The reject method is used when an invalid set of arguments is passed into a Velocity call. */
	        /* Note: Velocity employs a call-based queueing architecture, which means that stopping an animating element actually stops the full call that
	           triggered it -- not that one element exclusively. Similarly, there is one promise per call, and all elements targeted by a Velocity call are
	           grouped together for the purposes of resolving and rejecting a promise. */
	        if (isUtility && Velocity.Promise) {
	            promiseData.promise = new Velocity.Promise(function (resolve, reject) {
	                promiseData.resolver = resolve;
	                promiseData.rejecter = reject;
	            });
	        }
	
	        /*********************
	           Action Detection
	        *********************/
	
	        /* Velocity's behavior is categorized into "actions": Elements can either be specially scrolled into view,
	           or they can be started, stopped, or reversed. If a literal or referenced properties map is passed in as Velocity's
	           first argument, the associated action is "start". Alternatively, "scroll", "reverse", or "stop" can be passed in instead of a properties map. */
	        var action;
	
	        switch (propertiesMap) {
	            case "scroll":
	                action = "scroll";
	                break;
	
	            case "reverse":
	                action = "reverse";
	                break;
	
	            case "finish":
	            case "finishAll":
	            case "stop":
	                /*******************
	                    Action: Stop
	                *******************/
	
	                /* Clear the currently-active delay on each targeted element. */
	                $.each(elements, function(i, element) {
	                    if (Data(element) && Data(element).delayTimer) {
	                        /* Stop the timer from triggering its cached next() function. */
	                        clearTimeout(Data(element).delayTimer.setTimeout);
	
	                        /* Manually call the next() function so that the subsequent queue items can progress. */
	                        if (Data(element).delayTimer.next) {
	                            Data(element).delayTimer.next();
	                        }
	
	                        delete Data(element).delayTimer;
	                    }
	
	                    /* If we want to finish everything in the queue, we have to iterate through it
	                       and call each function. This will make them active calls below, which will
	                       cause them to be applied via the duration setting. */
	                    if (propertiesMap === "finishAll" && (options === true || Type.isString(options))) {
	                        /* Iterate through the items in the element's queue. */
	                        $.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
	                            /* The queue array can contain an "inprogress" string, which we skip. */
	                            if (Type.isFunction(item)) {
	                                item();
	                            }
	                        });
	
	                        /* Clearing the $.queue() array is achieved by resetting it to []. */
	                        $.queue(element, Type.isString(options) ? options : "", []);
	                    }
	                });
	
	                var callsToStop = [];
	
	                /* When the stop action is triggered, the elements' currently active call is immediately stopped. The active call might have
	                   been applied to multiple elements, in which case all of the call's elements will be stopped. When an element
	                   is stopped, the next item in its animation queue is immediately triggered. */
	                /* An additional argument may be passed in to clear an element's remaining queued calls. Either true (which defaults to the "fx" queue)
	                   or a custom queue string can be passed in. */
	                /* Note: The stop command runs prior to Velocity's Queueing phase since its behavior is intended to take effect *immediately*,
	                   regardless of the element's current queue state. */
	
	                /* Iterate through every active call. */
	                $.each(Velocity.State.calls, function(i, activeCall) {
	                    /* Inactive calls are set to false by the logic inside completeCall(). Skip them. */
	                    if (activeCall) {
	                        /* Iterate through the active call's targeted elements. */
	                        $.each(activeCall[1], function(k, activeElement) {
	                            /* If true was passed in as a secondary argument, clear absolutely all calls on this element. Otherwise, only
	                               clear calls associated with the relevant queue. */
	                            /* Call stopping logic works as follows:
	                               - options === true --> stop current default queue calls (and queue:false calls), including remaining queued ones.
	                               - options === undefined --> stop current queue:"" call and all queue:false calls.
	                               - options === false --> stop only queue:false calls.
	                               - options === "custom" --> stop current queue:"custom" call, including remaining queued ones (there is no functionality to only clear the currently-running queue:"custom" call). */
	                            var queueName = (options === undefined) ? "" : options;
	
	                            if (queueName !== true && (activeCall[2].queue !== queueName) && !(options === undefined && activeCall[2].queue === false)) {
	                                return true;
	                            }
	
	                            /* Iterate through the calls targeted by the stop command. */
	                            $.each(elements, function(l, element) {
	                                /* Check that this call was applied to the target element. */
	                                if (element === activeElement) {
	                                    /* Optionally clear the remaining queued calls. If we're doing "finishAll" this won't find anything,
	                                       due to the queue-clearing above. */
	                                    if (options === true || Type.isString(options)) {
	                                        /* Iterate through the items in the element's queue. */
	                                        $.each($.queue(element, Type.isString(options) ? options : ""), function(_, item) {
	                                            /* The queue array can contain an "inprogress" string, which we skip. */
	                                            if (Type.isFunction(item)) {
	                                                /* Pass the item's callback a flag indicating that we want to abort from the queue call.
	                                                   (Specifically, the queue will resolve the call's associated promise then abort.)  */
	                                                item(null, true);
	                                            }
	                                        });
	
	                                        /* Clearing the $.queue() array is achieved by resetting it to []. */
	                                        $.queue(element, Type.isString(options) ? options : "", []);
	                                    }
	
	                                    if (propertiesMap === "stop") {
	                                        /* Since "reverse" uses cached start values (the previous call's endValues), these values must be
	                                           changed to reflect the final value that the elements were actually tweened to. */
	                                        /* Note: If only queue:false animations are currently running on an element, it won't have a tweensContainer
	                                           object. Also, queue:false animations can't be reversed. */
	                                        if (Data(element) && Data(element).tweensContainer && queueName !== false) {
	                                            $.each(Data(element).tweensContainer, function(m, activeTween) {
	                                                activeTween.endValue = activeTween.currentValue;
	                                            });
	                                        }
	
	                                        callsToStop.push(i);
	                                    } else if (propertiesMap === "finish" || propertiesMap === "finishAll") {
	                                        /* To get active tweens to finish immediately, we forcefully shorten their durations to 1ms so that
	                                        they finish upon the next rAf tick then proceed with normal call completion logic. */
	                                        activeCall[2].duration = 1;
	                                    }
	                                }
	                            });
	                        });
	                    }
	                });
	
	                /* Prematurely call completeCall() on each matched active call. Pass an additional flag for "stop" to indicate
	                   that the complete callback and display:none setting should be skipped since we're completing prematurely. */
	                if (propertiesMap === "stop") {
	                    $.each(callsToStop, function(i, j) {
	                        completeCall(j, true);
	                    });
	
	                    if (promiseData.promise) {
	                        /* Immediately resolve the promise associated with this stop call since stop runs synchronously. */
	                        promiseData.resolver(elements);
	                    }
	                }
	
	                /* Since we're stopping, and not proceeding with queueing, exit out of Velocity. */
	                return getChain();
	
	            default:
	                /* Treat a non-empty plain object as a literal properties map. */
	                if ($.isPlainObject(propertiesMap) && !Type.isEmptyObject(propertiesMap)) {
	                    action = "start";
	
	                /****************
	                    Redirects
	                ****************/
	
	                /* Check if a string matches a registered redirect (see Redirects above). */
	                } else if (Type.isString(propertiesMap) && Velocity.Redirects[propertiesMap]) {
	                    var opts = $.extend({}, options),
	                        durationOriginal = opts.duration,
	                        delayOriginal = opts.delay || 0;
	
	                    /* If the backwards option was passed in, reverse the element set so that elements animate from the last to the first. */
	                    if (opts.backwards === true) {
	                        elements = $.extend(true, [], elements).reverse();
	                    }
	
	                    /* Individually trigger the redirect for each element in the set to prevent users from having to handle iteration logic in their redirect. */
	                    $.each(elements, function(elementIndex, element) {
	                        /* If the stagger option was passed in, successively delay each element by the stagger value (in ms). Retain the original delay value. */
	                        if (parseFloat(opts.stagger)) {
	                            opts.delay = delayOriginal + (parseFloat(opts.stagger) * elementIndex);
	                        } else if (Type.isFunction(opts.stagger)) {
	                            opts.delay = delayOriginal + opts.stagger.call(element, elementIndex, elementsLength);
	                        }
	
	                        /* If the drag option was passed in, successively increase/decrease (depending on the presense of opts.backwards)
	                           the duration of each element's animation, using floors to prevent producing very short durations. */
	                        if (opts.drag) {
	                            /* Default the duration of UI pack effects (callouts and transitions) to 1000ms instead of the usual default duration of 400ms. */
	                            opts.duration = parseFloat(durationOriginal) || (/^(callout|transition)/.test(propertiesMap) ? 1000 : DURATION_DEFAULT);
	
	                            /* For each element, take the greater duration of: A) animation completion percentage relative to the original duration,
	                               B) 75% of the original duration, or C) a 200ms fallback (in case duration is already set to a low value).
	                               The end result is a baseline of 75% of the redirect's duration that increases/decreases as the end of the element set is approached. */
	                            opts.duration = Math.max(opts.duration * (opts.backwards ? 1 - elementIndex/elementsLength : (elementIndex + 1) / elementsLength), opts.duration * 0.75, 200);
	                        }
	
	                        /* Pass in the call's opts object so that the redirect can optionally extend it. It defaults to an empty object instead of null to
	                           reduce the opts checking logic required inside the redirect. */
	                        Velocity.Redirects[propertiesMap].call(element, element, opts || {}, elementIndex, elementsLength, elements, promiseData.promise ? promiseData : undefined);
	                    });
	
	                    /* Since the animation logic resides within the redirect's own code, abort the remainder of this call.
	                       (The performance overhead up to this point is virtually non-existant.) */
	                    /* Note: The jQuery call chain is kept intact by returning the complete element set. */
	                    return getChain();
	                } else {
	                    var abortError = "Velocity: First argument (" + propertiesMap + ") was not a property map, a known action, or a registered redirect. Aborting.";
	
	                    if (promiseData.promise) {
	                        promiseData.rejecter(new Error(abortError));
	                    } else {
	                        console.log(abortError);
	                    }
	
	                    return getChain();
	                }
	        }
	
	        /**************************
	            Call-Wide Variables
	        **************************/
	
	        /* A container for CSS unit conversion ratios (e.g. %, rem, and em ==> px) that is used to cache ratios across all elements
	           being animated in a single Velocity call. Calculating unit ratios necessitates DOM querying and updating, and is therefore
	           avoided (via caching) wherever possible. This container is call-wide instead of page-wide to avoid the risk of using stale
	           conversion metrics across Velocity animations that are not immediately consecutively chained. */
	        var callUnitConversionData = {
	                lastParent: null,
	                lastPosition: null,
	                lastFontSize: null,
	                lastPercentToPxWidth: null,
	                lastPercentToPxHeight: null,
	                lastEmToPx: null,
	                remToPx: null,
	                vwToPx: null,
	                vhToPx: null
	            };
	
	        /* A container for all the ensuing tween data and metadata associated with this call. This container gets pushed to the page-wide
	           Velocity.State.calls array that is processed during animation ticking. */
	        var call = [];
	
	        /************************
	           Element Processing
	        ************************/
	
	        /* Element processing consists of three parts -- data processing that cannot go stale and data processing that *can* go stale (i.e. third-party style modifications):
	           1) Pre-Queueing: Element-wide variables, including the element's data storage, are instantiated. Call options are prepared. If triggered, the Stop action is executed.
	           2) Queueing: The logic that runs once this call has reached its point of execution in the element's $.queue() stack. Most logic is placed here to avoid risking it becoming stale.
	           3) Pushing: Consolidation of the tween data followed by its push onto the global in-progress calls container.
	        */
	
	        function processElement () {
	
	            /*************************
	               Part I: Pre-Queueing
	            *************************/
	
	            /***************************
	               Element-Wide Variables
	            ***************************/
	
	            var element = this,
	                /* The runtime opts object is the extension of the current call's options and Velocity's page-wide option defaults. */
	                opts = $.extend({}, Velocity.defaults, options),
	                /* A container for the processed data associated with each property in the propertyMap.
	                   (Each property in the map produces its own "tween".) */
	                tweensContainer = {},
	                elementUnitConversionData;
	
	            /******************
	               Element Init
	            ******************/
	
	            if (Data(element) === undefined) {
	                Velocity.init(element);
	            }
	
	            /******************
	               Option: Delay
	            ******************/
	
	            /* Since queue:false doesn't respect the item's existing queue, we avoid injecting its delay here (it's set later on). */
	            /* Note: Velocity rolls its own delay function since jQuery doesn't have a utility alias for $.fn.delay()
	               (and thus requires jQuery element creation, which we avoid since its overhead includes DOM querying). */
	            if (parseFloat(opts.delay) && opts.queue !== false) {
	                $.queue(element, opts.queue, function(next) {
	                    /* This is a flag used to indicate to the upcoming completeCall() function that this queue entry was initiated by Velocity. See completeCall() for further details. */
	                    Velocity.velocityQueueEntryFlag = true;
	
	                    /* The ensuing queue item (which is assigned to the "next" argument that $.queue() automatically passes in) will be triggered after a setTimeout delay.
	                       The setTimeout is stored so that it can be subjected to clearTimeout() if this animation is prematurely stopped via Velocity's "stop" command. */
	                    Data(element).delayTimer = {
	                        setTimeout: setTimeout(next, parseFloat(opts.delay)),
	                        next: next
	                    };
	                });
	            }
	
	            /*********************
	               Option: Duration
	            *********************/
	
	            /* Support for jQuery's named durations. */
	            switch (opts.duration.toString().toLowerCase()) {
	                case "fast":
	                    opts.duration = 200;
	                    break;
	
	                case "normal":
	                    opts.duration = DURATION_DEFAULT;
	                    break;
	
	                case "slow":
	                    opts.duration = 600;
	                    break;
	
	                default:
	                    /* Remove the potential "ms" suffix and default to 1 if the user is attempting to set a duration of 0 (in order to produce an immediate style change). */
	                    opts.duration = parseFloat(opts.duration) || 1;
	            }
	
	            /************************
	               Global Option: Mock
	            ************************/
	
	            if (Velocity.mock !== false) {
	                /* In mock mode, all animations are forced to 1ms so that they occur immediately upon the next rAF tick.
	                   Alternatively, a multiplier can be passed in to time remap all delays and durations. */
	                if (Velocity.mock === true) {
	                    opts.duration = opts.delay = 1;
	                } else {
	                    opts.duration *= parseFloat(Velocity.mock) || 1;
	                    opts.delay *= parseFloat(Velocity.mock) || 1;
	                }
	            }
	
	            /*******************
	               Option: Easing
	            *******************/
	
	            opts.easing = getEasing(opts.easing, opts.duration);
	
	            /**********************
	               Option: Callbacks
	            **********************/
	
	            /* Callbacks must functions. Otherwise, default to null. */
	            if (opts.begin && !Type.isFunction(opts.begin)) {
	                opts.begin = null;
	            }
	
	            if (opts.progress && !Type.isFunction(opts.progress)) {
	                opts.progress = null;
	            }
	
	            if (opts.complete && !Type.isFunction(opts.complete)) {
	                opts.complete = null;
	            }
	
	            /*********************************
	               Option: Display & Visibility
	            *********************************/
	
	            /* Refer to Velocity's documentation (VelocityJS.org/#displayAndVisibility) for a description of the display and visibility options' behavior. */
	            /* Note: We strictly check for undefined instead of falsiness because display accepts an empty string value. */
	            if (opts.display !== undefined && opts.display !== null) {
	                opts.display = opts.display.toString().toLowerCase();
	
	                /* Users can pass in a special "auto" value to instruct Velocity to set the element to its default display value. */
	                if (opts.display === "auto") {
	                    opts.display = Velocity.CSS.Values.getDisplayType(element);
	                }
	            }
	
	            if (opts.visibility !== undefined && opts.visibility !== null) {
	                opts.visibility = opts.visibility.toString().toLowerCase();
	            }
	
	            /**********************
	               Option: mobileHA
	            **********************/
	
	            /* When set to true, and if this is a mobile device, mobileHA automatically enables hardware acceleration (via a null transform hack)
	               on animating elements. HA is removed from the element at the completion of its animation. */
	            /* Note: Android Gingerbread doesn't support HA. If a null transform hack (mobileHA) is in fact set, it will prevent other tranform subproperties from taking effect. */
	            /* Note: You can read more about the use of mobileHA in Velocity's documentation: VelocityJS.org/#mobileHA. */
	            opts.mobileHA = (opts.mobileHA && Velocity.State.isMobile && !Velocity.State.isGingerbread);
	
	            /***********************
	               Part II: Queueing
	            ***********************/
	
	            /* When a set of elements is targeted by a Velocity call, the set is broken up and each element has the current Velocity call individually queued onto it.
	               In this way, each element's existing queue is respected; some elements may already be animating and accordingly should not have this current Velocity call triggered immediately. */
	            /* In each queue, tween data is processed for each animating property then pushed onto the call-wide calls array. When the last element in the set has had its tweens processed,
	               the call array is pushed to Velocity.State.calls for live processing by the requestAnimationFrame tick. */
	            function buildQueue (next) {
	
	                /*******************
	                   Option: Begin
	                *******************/
	
	                /* The begin callback is fired once per call -- not once per elemenet -- and is passed the full raw DOM element set as both its context and its first argument. */
	                if (opts.begin && elementsIndex === 0) {
	                    /* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
	                    try {
	                        opts.begin.call(elements, elements);
	                    } catch (error) {
	                        setTimeout(function() { throw error; }, 1);
	                    }
	                }
	
	                /*****************************************
	                   Tween Data Construction (for Scroll)
	                *****************************************/
	
	                /* Note: In order to be subjected to chaining and animation options, scroll's tweening is routed through Velocity as if it were a standard CSS property animation. */
	                if (action === "scroll") {
	                    /* The scroll action uniquely takes an optional "offset" option -- specified in pixels -- that offsets the targeted scroll position. */
	                    var scrollDirection = (/^x$/i.test(opts.axis) ? "Left" : "Top"),
	                        scrollOffset = parseFloat(opts.offset) || 0,
	                        scrollPositionCurrent,
	                        scrollPositionCurrentAlternate,
	                        scrollPositionEnd;
	
	                    /* Scroll also uniquely takes an optional "container" option, which indicates the parent element that should be scrolled --
	                       as opposed to the browser window itself. This is useful for scrolling toward an element that's inside an overflowing parent element. */
	                    if (opts.container) {
	                        /* Ensure that either a jQuery object or a raw DOM element was passed in. */
	                        if (Type.isWrapped(opts.container) || Type.isNode(opts.container)) {
	                            /* Extract the raw DOM element from the jQuery wrapper. */
	                            opts.container = opts.container[0] || opts.container;
	                            /* Note: Unlike other properties in Velocity, the browser's scroll position is never cached since it so frequently changes
	                               (due to the user's natural interaction with the page). */
	                            scrollPositionCurrent = opts.container["scroll" + scrollDirection]; /* GET */
	
	                            /* $.position() values are relative to the container's currently viewable area (without taking into account the container's true dimensions
	                               -- say, for example, if the container was not overflowing). Thus, the scroll end value is the sum of the child element's position *and*
	                               the scroll container's current scroll position. */
	                            scrollPositionEnd = (scrollPositionCurrent + $(element).position()[scrollDirection.toLowerCase()]) + scrollOffset; /* GET */
	                        /* If a value other than a jQuery object or a raw DOM element was passed in, default to null so that this option is ignored. */
	                        } else {
	                            opts.container = null;
	                        }
	                    } else {
	                        /* If the window itself is being scrolled -- not a containing element -- perform a live scroll position lookup using
	                           the appropriate cached property names (which differ based on browser type). */
	                        scrollPositionCurrent = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + scrollDirection]]; /* GET */
	                        /* When scrolling the browser window, cache the alternate axis's current value since window.scrollTo() doesn't let us change only one value at a time. */
	                        scrollPositionCurrentAlternate = Velocity.State.scrollAnchor[Velocity.State["scrollProperty" + (scrollDirection === "Left" ? "Top" : "Left")]]; /* GET */
	
	                        /* Unlike $.position(), $.offset() values are relative to the browser window's true dimensions -- not merely its currently viewable area --
	                           and therefore end values do not need to be compounded onto current values. */
	                        scrollPositionEnd = $(element).offset()[scrollDirection.toLowerCase()] + scrollOffset; /* GET */
	                    }
	
	                    /* Since there's only one format that scroll's associated tweensContainer can take, we create it manually. */
	                    tweensContainer = {
	                        scroll: {
	                            rootPropertyValue: false,
	                            startValue: scrollPositionCurrent,
	                            currentValue: scrollPositionCurrent,
	                            endValue: scrollPositionEnd,
	                            unitType: "",
	                            easing: opts.easing,
	                            scrollData: {
	                                container: opts.container,
	                                direction: scrollDirection,
	                                alternateValue: scrollPositionCurrentAlternate
	                            }
	                        },
	                        element: element
	                    };
	
	                    if (Velocity.debug) console.log("tweensContainer (scroll): ", tweensContainer.scroll, element);
	
	                /******************************************
	                   Tween Data Construction (for Reverse)
	                ******************************************/
	
	                /* Reverse acts like a "start" action in that a property map is animated toward. The only difference is
	                   that the property map used for reverse is the inverse of the map used in the previous call. Thus, we manipulate
	                   the previous call to construct our new map: use the previous map's end values as our new map's start values. Copy over all other data. */
	                /* Note: Reverse can be directly called via the "reverse" parameter, or it can be indirectly triggered via the loop option. (Loops are composed of multiple reverses.) */
	                /* Note: Reverse calls do not need to be consecutively chained onto a currently-animating element in order to operate on cached values;
	                   there is no harm to reverse being called on a potentially stale data cache since reverse's behavior is simply defined
	                   as reverting to the element's values as they were prior to the previous *Velocity* call. */
	                } else if (action === "reverse") {
	                    /* Abort if there is no prior animation data to reverse to. */
	                    if (!Data(element).tweensContainer) {
	                        /* Dequeue the element so that this queue entry releases itself immediately, allowing subsequent queue entries to run. */
	                        $.dequeue(element, opts.queue);
	
	                        return;
	                    } else {
	                        /*********************
	                           Options Parsing
	                        *********************/
	
	                        /* If the element was hidden via the display option in the previous call,
	                           revert display to "auto" prior to reversal so that the element is visible again. */
	                        if (Data(element).opts.display === "none") {
	                            Data(element).opts.display = "auto";
	                        }
	
	                        if (Data(element).opts.visibility === "hidden") {
	                            Data(element).opts.visibility = "visible";
	                        }
	
	                        /* If the loop option was set in the previous call, disable it so that "reverse" calls aren't recursively generated.
	                           Further, remove the previous call's callback options; typically, users do not want these to be refired. */
	                        Data(element).opts.loop = false;
	                        Data(element).opts.begin = null;
	                        Data(element).opts.complete = null;
	
	                        /* Since we're extending an opts object that has already been extended with the defaults options object,
	                           we remove non-explicitly-defined properties that are auto-assigned values. */
	                        if (!options.easing) {
	                            delete opts.easing;
	                        }
	
	                        if (!options.duration) {
	                            delete opts.duration;
	                        }
	
	                        /* The opts object used for reversal is an extension of the options object optionally passed into this
	                           reverse call plus the options used in the previous Velocity call. */
	                        opts = $.extend({}, Data(element).opts, opts);
	
	                        /*************************************
	                           Tweens Container Reconstruction
	                        *************************************/
	
	                        /* Create a deepy copy (indicated via the true flag) of the previous call's tweensContainer. */
	                        var lastTweensContainer = $.extend(true, {}, Data(element).tweensContainer);
	
	                        /* Manipulate the previous tweensContainer by replacing its end values and currentValues with its start values. */
	                        for (var lastTween in lastTweensContainer) {
	                            /* In addition to tween data, tweensContainers contain an element property that we ignore here. */
	                            if (lastTween !== "element") {
	                                var lastStartValue = lastTweensContainer[lastTween].startValue;
	
	                                lastTweensContainer[lastTween].startValue = lastTweensContainer[lastTween].currentValue = lastTweensContainer[lastTween].endValue;
	                                lastTweensContainer[lastTween].endValue = lastStartValue;
	
	                                /* Easing is the only option that embeds into the individual tween data (since it can be defined on a per-property basis).
	                                   Accordingly, every property's easing value must be updated when an options object is passed in with a reverse call.
	                                   The side effect of this extensibility is that all per-property easing values are forcefully reset to the new value. */
	                                if (!Type.isEmptyObject(options)) {
	                                    lastTweensContainer[lastTween].easing = opts.easing;
	                                }
	
	                                if (Velocity.debug) console.log("reverse tweensContainer (" + lastTween + "): " + JSON.stringify(lastTweensContainer[lastTween]), element);
	                            }
	                        }
	
	                        tweensContainer = lastTweensContainer;
	                    }
	
	                /*****************************************
	                   Tween Data Construction (for Start)
	                *****************************************/
	
	                } else if (action === "start") {
	
	                    /*************************
	                        Value Transferring
	                    *************************/
	
	                    /* If this queue entry follows a previous Velocity-initiated queue entry *and* if this entry was created
	                       while the element was in the process of being animated by Velocity, then this current call is safe to use
	                       the end values from the prior call as its start values. Velocity attempts to perform this value transfer
	                       process whenever possible in order to avoid requerying the DOM. */
	                    /* If values aren't transferred from a prior call and start values were not forcefed by the user (more on this below),
	                       then the DOM is queried for the element's current values as a last resort. */
	                    /* Note: Conversely, animation reversal (and looping) *always* perform inter-call value transfers; they never requery the DOM. */
	                    var lastTweensContainer;
	
	                    /* The per-element isAnimating flag is used to indicate whether it's safe (i.e. the data isn't stale)
	                       to transfer over end values to use as start values. If it's set to true and there is a previous
	                       Velocity call to pull values from, do so. */
	                    if (Data(element).tweensContainer && Data(element).isAnimating === true) {
	                        lastTweensContainer = Data(element).tweensContainer;
	                    }
	
	                    /***************************
	                       Tween Data Calculation
	                    ***************************/
	
	                    /* This function parses property data and defaults endValue, easing, and startValue as appropriate. */
	                    /* Property map values can either take the form of 1) a single value representing the end value,
	                       or 2) an array in the form of [ endValue, [, easing] [, startValue] ].
	                       The optional third parameter is a forcefed startValue to be used instead of querying the DOM for
	                       the element's current value. Read Velocity's docmentation to learn more about forcefeeding: VelocityJS.org/#forcefeeding */
	                    function parsePropertyValue (valueData, skipResolvingEasing) {
	                        var endValue = undefined,
	                            easing = undefined,
	                            startValue = undefined;
	
	                        /* Handle the array format, which can be structured as one of three potential overloads:
	                           A) [ endValue, easing, startValue ], B) [ endValue, easing ], or C) [ endValue, startValue ] */
	                        if (Type.isArray(valueData)) {
	                            /* endValue is always the first item in the array. Don't bother validating endValue's value now
	                               since the ensuing property cycling logic does that. */
	                            endValue = valueData[0];
	
	                            /* Two-item array format: If the second item is a number, function, or hex string, treat it as a
	                               start value since easings can only be non-hex strings or arrays. */
	                            if ((!Type.isArray(valueData[1]) && /^[\d-]/.test(valueData[1])) || Type.isFunction(valueData[1]) || CSS.RegEx.isHex.test(valueData[1])) {
	                                startValue = valueData[1];
	                            /* Two or three-item array: If the second item is a non-hex string or an array, treat it as an easing. */
	                            } else if ((Type.isString(valueData[1]) && !CSS.RegEx.isHex.test(valueData[1])) || Type.isArray(valueData[1])) {
	                                easing = skipResolvingEasing ? valueData[1] : getEasing(valueData[1], opts.duration);
	
	                                /* Don't bother validating startValue's value now since the ensuing property cycling logic inherently does that. */
	                                if (valueData[2] !== undefined) {
	                                    startValue = valueData[2];
	                                }
	                            }
	                        /* Handle the single-value format. */
	                        } else {
	                            endValue = valueData;
	                        }
	
	                        /* Default to the call's easing if a per-property easing type was not defined. */
	                        if (!skipResolvingEasing) {
	                            easing = easing || opts.easing;
	                        }
	
	                        /* If functions were passed in as values, pass the function the current element as its context,
	                           plus the element's index and the element set's size as arguments. Then, assign the returned value. */
	                        if (Type.isFunction(endValue)) {
	                            endValue = endValue.call(element, elementsIndex, elementsLength);
	                        }
	
	                        if (Type.isFunction(startValue)) {
	                            startValue = startValue.call(element, elementsIndex, elementsLength);
	                        }
	
	                        /* Allow startValue to be left as undefined to indicate to the ensuing code that its value was not forcefed. */
	                        return [ endValue || 0, easing, startValue ];
	                    }
	
	                    /* Cycle through each property in the map, looking for shorthand color properties (e.g. "color" as opposed to "colorRed"). Inject the corresponding
	                       colorRed, colorGreen, and colorBlue RGB component tweens into the propertiesMap (which Velocity understands) and remove the shorthand property. */
	                    $.each(propertiesMap, function(property, value) {
	                        /* Find shorthand color properties that have been passed a hex string. */
	                        if (RegExp("^" + CSS.Lists.colors.join("$|^") + "$").test(property)) {
	                            /* Parse the value data for each shorthand. */
	                            var valueData = parsePropertyValue(value, true),
	                                endValue = valueData[0],
	                                easing = valueData[1],
	                                startValue = valueData[2];
	
	                            if (CSS.RegEx.isHex.test(endValue)) {
	                                /* Convert the hex strings into their RGB component arrays. */
	                                var colorComponents = [ "Red", "Green", "Blue" ],
	                                    endValueRGB = CSS.Values.hexToRgb(endValue),
	                                    startValueRGB = startValue ? CSS.Values.hexToRgb(startValue) : undefined;
	
	                                /* Inject the RGB component tweens into propertiesMap. */
	                                for (var i = 0; i < colorComponents.length; i++) {
	                                    var dataArray = [ endValueRGB[i] ];
	
	                                    if (easing) {
	                                        dataArray.push(easing);
	                                    }
	
	                                    if (startValueRGB !== undefined) {
	                                        dataArray.push(startValueRGB[i]);
	                                    }
	
	                                    propertiesMap[property + colorComponents[i]] = dataArray;
	                                }
	
	                                /* Remove the intermediary shorthand property entry now that we've processed it. */
	                                delete propertiesMap[property];
	                            }
	                        }
	                    });
	
	                    /* Create a tween out of each property, and append its associated data to tweensContainer. */
	                    for (var property in propertiesMap) {
	
	                        /**************************
	                           Start Value Sourcing
	                        **************************/
	
	                        /* Parse out endValue, easing, and startValue from the property's data. */
	                        var valueData = parsePropertyValue(propertiesMap[property]),
	                            endValue = valueData[0],
	                            easing = valueData[1],
	                            startValue = valueData[2];
	
	                        /* Now that the original property name's format has been used for the parsePropertyValue() lookup above,
	                           we force the property to its camelCase styling to normalize it for manipulation. */
	                        property = CSS.Names.camelCase(property);
	
	                        /* In case this property is a hook, there are circumstances where we will intend to work on the hook's root property and not the hooked subproperty. */
	                        var rootProperty = CSS.Hooks.getRoot(property),
	                            rootPropertyValue = false;
	
	                        /* Other than for the dummy tween property, properties that are not supported by the browser (and do not have an associated normalization) will
	                           inherently produce no style changes when set, so they are skipped in order to decrease animation tick overhead.
	                           Property support is determined via prefixCheck(), which returns a false flag when no supported is detected. */
	                        /* Note: Since SVG elements have some of their properties directly applied as HTML attributes,
	                           there is no way to check for their explicit browser support, and so we skip skip this check for them. */
	                        if (!Data(element).isSVG && rootProperty !== "tween" && CSS.Names.prefixCheck(rootProperty)[1] === false && CSS.Normalizations.registered[rootProperty] === undefined) {
	                            if (Velocity.debug) console.log("Skipping [" + rootProperty + "] due to a lack of browser support.");
	
	                            continue;
	                        }
	
	                        /* If the display option is being set to a non-"none" (e.g. "block") and opacity (filter on IE<=8) is being
	                           animated to an endValue of non-zero, the user's intention is to fade in from invisible, thus we forcefeed opacity
	                           a startValue of 0 if its startValue hasn't already been sourced by value transferring or prior forcefeeding. */
	                        if (((opts.display !== undefined && opts.display !== null && opts.display !== "none") || (opts.visibility !== undefined && opts.visibility !== "hidden")) && /opacity|filter/.test(property) && !startValue && endValue !== 0) {
	                            startValue = 0;
	                        }
	
	                        /* If values have been transferred from the previous Velocity call, extract the endValue and rootPropertyValue
	                           for all of the current call's properties that were *also* animated in the previous call. */
	                        /* Note: Value transferring can optionally be disabled by the user via the _cacheValues option. */
	                        if (opts._cacheValues && lastTweensContainer && lastTweensContainer[property]) {
	                            if (startValue === undefined) {
	                                startValue = lastTweensContainer[property].endValue + lastTweensContainer[property].unitType;
	                            }
	
	                            /* The previous call's rootPropertyValue is extracted from the element's data cache since that's the
	                               instance of rootPropertyValue that gets freshly updated by the tweening process, whereas the rootPropertyValue
	                               attached to the incoming lastTweensContainer is equal to the root property's value prior to any tweening. */
	                            rootPropertyValue = Data(element).rootPropertyValueCache[rootProperty];
	                        /* If values were not transferred from a previous Velocity call, query the DOM as needed. */
	                        } else {
	                            /* Handle hooked properties. */
	                            if (CSS.Hooks.registered[property]) {
	                               if (startValue === undefined) {
	                                    rootPropertyValue = CSS.getPropertyValue(element, rootProperty); /* GET */
	                                    /* Note: The following getPropertyValue() call does not actually trigger a DOM query;
	                                       getPropertyValue() will extract the hook from rootPropertyValue. */
	                                    startValue = CSS.getPropertyValue(element, property, rootPropertyValue);
	                                /* If startValue is already defined via forcefeeding, do not query the DOM for the root property's value;
	                                   just grab rootProperty's zero-value template from CSS.Hooks. This overwrites the element's actual
	                                   root property value (if one is set), but this is acceptable since the primary reason users forcefeed is
	                                   to avoid DOM queries, and thus we likewise avoid querying the DOM for the root property's value. */
	                                } else {
	                                    /* Grab this hook's zero-value template, e.g. "0px 0px 0px black". */
	                                    rootPropertyValue = CSS.Hooks.templates[rootProperty][1];
	                                }
	                            /* Handle non-hooked properties that haven't already been defined via forcefeeding. */
	                            } else if (startValue === undefined) {
	                                startValue = CSS.getPropertyValue(element, property); /* GET */
	                            }
	                        }
	
	                        /**************************
	                           Value Data Extraction
	                        **************************/
	
	                        var separatedValue,
	                            endValueUnitType,
	                            startValueUnitType,
	                            operator = false;
	
	                        /* Separates a property value into its numeric value and its unit type. */
	                        function separateValue (property, value) {
	                            var unitType,
	                                numericValue;
	
	                            numericValue = (value || "0")
	                                .toString()
	                                .toLowerCase()
	                                /* Match the unit type at the end of the value. */
	                                .replace(/[%A-z]+$/, function(match) {
	                                    /* Grab the unit type. */
	                                    unitType = match;
	
	                                    /* Strip the unit type off of value. */
	                                    return "";
	                                });
	
	                            /* If no unit type was supplied, assign one that is appropriate for this property (e.g. "deg" for rotateZ or "px" for width). */
	                            if (!unitType) {
	                                unitType = CSS.Values.getUnitType(property);
	                            }
	
	                            return [ numericValue, unitType ];
	                        }
	
	                        /* Separate startValue. */
	                        separatedValue = separateValue(property, startValue);
	                        startValue = separatedValue[0];
	                        startValueUnitType = separatedValue[1];
	
	                        /* Separate endValue, and extract a value operator (e.g. "+=", "-=") if one exists. */
	                        separatedValue = separateValue(property, endValue);
	                        endValue = separatedValue[0].replace(/^([+-\/*])=/, function(match, subMatch) {
	                            operator = subMatch;
	
	                            /* Strip the operator off of the value. */
	                            return "";
	                        });
	                        endValueUnitType = separatedValue[1];
	
	                        /* Parse float values from endValue and startValue. Default to 0 if NaN is returned. */
	                        startValue = parseFloat(startValue) || 0;
	                        endValue = parseFloat(endValue) || 0;
	
	                        /***************************************
	                           Property-Specific Value Conversion
	                        ***************************************/
	
	                        /* Custom support for properties that don't actually accept the % unit type, but where pollyfilling is trivial and relatively foolproof. */
	                        if (endValueUnitType === "%") {
	                            /* A %-value fontSize/lineHeight is relative to the parent's fontSize (as opposed to the parent's dimensions),
	                               which is identical to the em unit's behavior, so we piggyback off of that. */
	                            if (/^(fontSize|lineHeight)$/.test(property)) {
	                                /* Convert % into an em decimal value. */
	                                endValue = endValue / 100;
	                                endValueUnitType = "em";
	                            /* For scaleX and scaleY, convert the value into its decimal format and strip off the unit type. */
	                            } else if (/^scale/.test(property)) {
	                                endValue = endValue / 100;
	                                endValueUnitType = "";
	                            /* For RGB components, take the defined percentage of 255 and strip off the unit type. */
	                            } else if (/(Red|Green|Blue)$/i.test(property)) {
	                                endValue = (endValue / 100) * 255;
	                                endValueUnitType = "";
	                            }
	                        }
	
	                        /***************************
	                           Unit Ratio Calculation
	                        ***************************/
	
	                        /* When queried, the browser returns (most) CSS property values in pixels. Therefore, if an endValue with a unit type of
	                           %, em, or rem is animated toward, startValue must be converted from pixels into the same unit type as endValue in order
	                           for value manipulation logic (increment/decrement) to proceed. Further, if the startValue was forcefed or transferred
	                           from a previous call, startValue may also not be in pixels. Unit conversion logic therefore consists of two steps:
	                           1) Calculating the ratio of %/em/rem/vh/vw relative to pixels
	                           2) Converting startValue into the same unit of measurement as endValue based on these ratios. */
	                        /* Unit conversion ratios are calculated by inserting a sibling node next to the target node, copying over its position property,
	                           setting values with the target unit type then comparing the returned pixel value. */
	                        /* Note: Even if only one of these unit types is being animated, all unit ratios are calculated at once since the overhead
	                           of batching the SETs and GETs together upfront outweights the potential overhead
	                           of layout thrashing caused by re-querying for uncalculated ratios for subsequently-processed properties. */
	                        /* Todo: Shift this logic into the calls' first tick instance so that it's synced with RAF. */
	                        function calculateUnitRatios () {
	
	                            /************************
	                                Same Ratio Checks
	                            ************************/
	
	                            /* The properties below are used to determine whether the element differs sufficiently from this call's
	                               previously iterated element to also differ in its unit conversion ratios. If the properties match up with those
	                               of the prior element, the prior element's conversion ratios are used. Like most optimizations in Velocity,
	                               this is done to minimize DOM querying. */
	                            var sameRatioIndicators = {
	                                    myParent: element.parentNode || document.body, /* GET */
	                                    position: CSS.getPropertyValue(element, "position"), /* GET */
	                                    fontSize: CSS.getPropertyValue(element, "fontSize") /* GET */
	                                },
	                                /* Determine if the same % ratio can be used. % is based on the element's position value and its parent's width and height dimensions. */
	                                samePercentRatio = ((sameRatioIndicators.position === callUnitConversionData.lastPosition) && (sameRatioIndicators.myParent === callUnitConversionData.lastParent)),
	                                /* Determine if the same em ratio can be used. em is relative to the element's fontSize. */
	                                sameEmRatio = (sameRatioIndicators.fontSize === callUnitConversionData.lastFontSize);
	
	                            /* Store these ratio indicators call-wide for the next element to compare against. */
	                            callUnitConversionData.lastParent = sameRatioIndicators.myParent;
	                            callUnitConversionData.lastPosition = sameRatioIndicators.position;
	                            callUnitConversionData.lastFontSize = sameRatioIndicators.fontSize;
	
	                            /***************************
	                               Element-Specific Units
	                            ***************************/
	
	                            /* Note: IE8 rounds to the nearest pixel when returning CSS values, thus we perform conversions using a measurement
	                               of 100 (instead of 1) to give our ratios a precision of at least 2 decimal values. */
	                            var measurement = 100,
	                                unitRatios = {};
	
	                            if (!sameEmRatio || !samePercentRatio) {
	                                var dummy = Data(element).isSVG ? document.createElementNS("http://www.w3.org/2000/svg", "rect") : document.createElement("div");
	
	                                Velocity.init(dummy);
	                                sameRatioIndicators.myParent.appendChild(dummy);
	
	                                /* To accurately and consistently calculate conversion ratios, the element's cascaded overflow and box-sizing are stripped.
	                                   Similarly, since width/height can be artificially constrained by their min-/max- equivalents, these are controlled for as well. */
	                                /* Note: Overflow must be also be controlled for per-axis since the overflow property overwrites its per-axis values. */
	                                $.each([ "overflow", "overflowX", "overflowY" ], function(i, property) {
	                                    Velocity.CSS.setPropertyValue(dummy, property, "hidden");
	                                });
	                                Velocity.CSS.setPropertyValue(dummy, "position", sameRatioIndicators.position);
	                                Velocity.CSS.setPropertyValue(dummy, "fontSize", sameRatioIndicators.fontSize);
	                                Velocity.CSS.setPropertyValue(dummy, "boxSizing", "content-box");
	
	                                /* width and height act as our proxy properties for measuring the horizontal and vertical % ratios. */
	                                $.each([ "minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height" ], function(i, property) {
	                                    Velocity.CSS.setPropertyValue(dummy, property, measurement + "%");
	                                });
	                                /* paddingLeft arbitrarily acts as our proxy property for the em ratio. */
	                                Velocity.CSS.setPropertyValue(dummy, "paddingLeft", measurement + "em");
	
	                                /* Divide the returned value by the measurement to get the ratio between 1% and 1px. Default to 1 since working with 0 can produce Infinite. */
	                                unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth = (parseFloat(CSS.getPropertyValue(dummy, "width", null, true)) || 1) / measurement; /* GET */
	                                unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight = (parseFloat(CSS.getPropertyValue(dummy, "height", null, true)) || 1) / measurement; /* GET */
	                                unitRatios.emToPx = callUnitConversionData.lastEmToPx = (parseFloat(CSS.getPropertyValue(dummy, "paddingLeft")) || 1) / measurement; /* GET */
	
	                                sameRatioIndicators.myParent.removeChild(dummy);
	                            } else {
	                                unitRatios.emToPx = callUnitConversionData.lastEmToPx;
	                                unitRatios.percentToPxWidth = callUnitConversionData.lastPercentToPxWidth;
	                                unitRatios.percentToPxHeight = callUnitConversionData.lastPercentToPxHeight;
	                            }
	
	                            /***************************
	                               Element-Agnostic Units
	                            ***************************/
	
	                            /* Whereas % and em ratios are determined on a per-element basis, the rem unit only needs to be checked
	                               once per call since it's exclusively dependant upon document.body's fontSize. If this is the first time
	                               that calculateUnitRatios() is being run during this call, remToPx will still be set to its default value of null,
	                               so we calculate it now. */
	                            if (callUnitConversionData.remToPx === null) {
	                                /* Default to browsers' default fontSize of 16px in the case of 0. */
	                                callUnitConversionData.remToPx = parseFloat(CSS.getPropertyValue(document.body, "fontSize")) || 16; /* GET */
	                            }
	
	                            /* Similarly, viewport units are %-relative to the window's inner dimensions. */
	                            if (callUnitConversionData.vwToPx === null) {
	                                callUnitConversionData.vwToPx = parseFloat(window.innerWidth) / 100; /* GET */
	                                callUnitConversionData.vhToPx = parseFloat(window.innerHeight) / 100; /* GET */
	                            }
	
	                            unitRatios.remToPx = callUnitConversionData.remToPx;
	                            unitRatios.vwToPx = callUnitConversionData.vwToPx;
	                            unitRatios.vhToPx = callUnitConversionData.vhToPx;
	
	                            if (Velocity.debug >= 1) console.log("Unit ratios: " + JSON.stringify(unitRatios), element);
	
	                            return unitRatios;
	                        }
	
	                        /********************
	                           Unit Conversion
	                        ********************/
	
	                        /* The * and / operators, which are not passed in with an associated unit, inherently use startValue's unit. Skip value and unit conversion. */
	                        if (/[\/*]/.test(operator)) {
	                            endValueUnitType = startValueUnitType;
	                        /* If startValue and endValue differ in unit type, convert startValue into the same unit type as endValue so that if endValueUnitType
	                           is a relative unit (%, em, rem), the values set during tweening will continue to be accurately relative even if the metrics they depend
	                           on are dynamically changing during the course of the animation. Conversely, if we always normalized into px and used px for setting values, the px ratio
	                           would become stale if the original unit being animated toward was relative and the underlying metrics change during the animation. */
	                        /* Since 0 is 0 in any unit type, no conversion is necessary when startValue is 0 -- we just start at 0 with endValueUnitType. */
	                        } else if ((startValueUnitType !== endValueUnitType) && startValue !== 0) {
	                            /* Unit conversion is also skipped when endValue is 0, but *startValueUnitType* must be used for tween values to remain accurate. */
	                            /* Note: Skipping unit conversion here means that if endValueUnitType was originally a relative unit, the animation won't relatively
	                               match the underlying metrics if they change, but this is acceptable since we're animating toward invisibility instead of toward visibility,
	                               which remains past the point of the animation's completion. */
	                            if (endValue === 0) {
	                                endValueUnitType = startValueUnitType;
	                            } else {
	                                /* By this point, we cannot avoid unit conversion (it's undesirable since it causes layout thrashing).
	                                   If we haven't already, we trigger calculateUnitRatios(), which runs once per element per call. */
	                                elementUnitConversionData = elementUnitConversionData || calculateUnitRatios();
	
	                                /* The following RegEx matches CSS properties that have their % values measured relative to the x-axis. */
	                                /* Note: W3C spec mandates that all of margin and padding's properties (even top and bottom) are %-relative to the *width* of the parent element. */
	                                var axis = (/margin|padding|left|right|width|text|word|letter/i.test(property) || /X$/.test(property) || property === "x") ? "x" : "y";
	
	                                /* In order to avoid generating n^2 bespoke conversion functions, unit conversion is a two-step process:
	                                   1) Convert startValue into pixels. 2) Convert this new pixel value into endValue's unit type. */
	                                switch (startValueUnitType) {
	                                    case "%":
	                                        /* Note: translateX and translateY are the only properties that are %-relative to an element's own dimensions -- not its parent's dimensions.
	                                           Velocity does not include a special conversion process to account for this behavior. Therefore, animating translateX/Y from a % value
	                                           to a non-% value will produce an incorrect start value. Fortunately, this sort of cross-unit conversion is rarely done by users in practice. */
	                                        startValue *= (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
	                                        break;
	
	                                    case "px":
	                                        /* px acts as our midpoint in the unit conversion process; do nothing. */
	                                        break;
	
	                                    default:
	                                        startValue *= elementUnitConversionData[startValueUnitType + "ToPx"];
	                                }
	
	                                /* Invert the px ratios to convert into to the target unit. */
	                                switch (endValueUnitType) {
	                                    case "%":
	                                        startValue *= 1 / (axis === "x" ? elementUnitConversionData.percentToPxWidth : elementUnitConversionData.percentToPxHeight);
	                                        break;
	
	                                    case "px":
	                                        /* startValue is already in px, do nothing; we're done. */
	                                        break;
	
	                                    default:
	                                        startValue *= 1 / elementUnitConversionData[endValueUnitType + "ToPx"];
	                                }
	                            }
	                        }
	
	                        /*********************
	                           Relative Values
	                        *********************/
	
	                        /* Operator logic must be performed last since it requires unit-normalized start and end values. */
	                        /* Note: Relative *percent values* do not behave how most people think; while one would expect "+=50%"
	                           to increase the property 1.5x its current value, it in fact increases the percent units in absolute terms:
	                           50 points is added on top of the current % value. */
	                        switch (operator) {
	                            case "+":
	                                endValue = startValue + endValue;
	                                break;
	
	                            case "-":
	                                endValue = startValue - endValue;
	                                break;
	
	                            case "*":
	                                endValue = startValue * endValue;
	                                break;
	
	                            case "/":
	                                endValue = startValue / endValue;
	                                break;
	                        }
	
	                        /**************************
	                           tweensContainer Push
	                        **************************/
	
	                        /* Construct the per-property tween object, and push it to the element's tweensContainer. */
	                        tweensContainer[property] = {
	                            rootPropertyValue: rootPropertyValue,
	                            startValue: startValue,
	                            currentValue: startValue,
	                            endValue: endValue,
	                            unitType: endValueUnitType,
	                            easing: easing
	                        };
	
	                        if (Velocity.debug) console.log("tweensContainer (" + property + "): " + JSON.stringify(tweensContainer[property]), element);
	                    }
	
	                    /* Along with its property data, store a reference to the element itself onto tweensContainer. */
	                    tweensContainer.element = element;
	                }
	
	                /*****************
	                    Call Push
	                *****************/
	
	                /* Note: tweensContainer can be empty if all of the properties in this call's property map were skipped due to not
	                   being supported by the browser. The element property is used for checking that the tweensContainer has been appended to. */
	                if (tweensContainer.element) {
	                    /* Apply the "velocity-animating" indicator class. */
	                    CSS.Values.addClass(element, "velocity-animating");
	
	                    /* The call array houses the tweensContainers for each element being animated in the current call. */
	                    call.push(tweensContainer);
	
	                    /* Store the tweensContainer and options if we're working on the default effects queue, so that they can be used by the reverse command. */
	                    if (opts.queue === "") {
	                        Data(element).tweensContainer = tweensContainer;
	                        Data(element).opts = opts;
	                    }
	
	                    /* Switch on the element's animating flag. */
	                    Data(element).isAnimating = true;
	
	                    /* Once the final element in this call's element set has been processed, push the call array onto
	                       Velocity.State.calls for the animation tick to immediately begin processing. */
	                    if (elementsIndex === elementsLength - 1) {
	                        /* Add the current call plus its associated metadata (the element set and the call's options) onto the global call container.
	                           Anything on this call container is subjected to tick() processing. */
	                        Velocity.State.calls.push([ call, elements, opts, null, promiseData.resolver ]);
	
	                        /* If the animation tick isn't running, start it. (Velocity shuts it off when there are no active calls to process.) */
	                        if (Velocity.State.isTicking === false) {
	                            Velocity.State.isTicking = true;
	
	                            /* Start the tick loop. */
	                            tick();
	                        }
	                    } else {
	                        elementsIndex++;
	                    }
	                }
	            }
	
	            /* When the queue option is set to false, the call skips the element's queue and fires immediately. */
	            if (opts.queue === false) {
	                /* Since this buildQueue call doesn't respect the element's existing queue (which is where a delay option would have been appended),
	                   we manually inject the delay property here with an explicit setTimeout. */
	                if (opts.delay) {
	                    setTimeout(buildQueue, opts.delay);
	                } else {
	                    buildQueue();
	                }
	            /* Otherwise, the call undergoes element queueing as normal. */
	            /* Note: To interoperate with jQuery, Velocity uses jQuery's own $.queue() stack for queuing logic. */
	            } else {
	                $.queue(element, opts.queue, function(next, clearQueue) {
	                    /* If the clearQueue flag was passed in by the stop command, resolve this call's promise. (Promises can only be resolved once,
	                       so it's fine if this is repeatedly triggered for each element in the associated call.) */
	                    if (clearQueue === true) {
	                        if (promiseData.promise) {
	                            promiseData.resolver(elements);
	                        }
	
	                        /* Do not continue with animation queueing. */
	                        return true;
	                    }
	
	                    /* This flag indicates to the upcoming completeCall() function that this queue entry was initiated by Velocity.
	                       See completeCall() for further details. */
	                    Velocity.velocityQueueEntryFlag = true;
	
	                    buildQueue(next);
	                });
	            }
	
	            /*********************
	                Auto-Dequeuing
	            *********************/
	
	            /* As per jQuery's $.queue() behavior, to fire the first non-custom-queue entry on an element, the element
	               must be dequeued if its queue stack consists *solely* of the current call. (This can be determined by checking
	               for the "inprogress" item that jQuery prepends to active queue stack arrays.) Regardless, whenever the element's
	               queue is further appended with additional items -- including $.delay()'s or even $.animate() calls, the queue's
	               first entry is automatically fired. This behavior contrasts that of custom queues, which never auto-fire. */
	            /* Note: When an element set is being subjected to a non-parallel Velocity call, the animation will not begin until
	               each one of the elements in the set has reached the end of its individually pre-existing queue chain. */
	            /* Note: Unfortunately, most people don't fully grasp jQuery's powerful, yet quirky, $.queue() function.
	               Lean more here: http://stackoverflow.com/questions/1058158/can-somebody-explain-jquery-queue-to-me */
	            if ((opts.queue === "" || opts.queue === "fx") && $.queue(element)[0] !== "inprogress") {
	                $.dequeue(element);
	            }
	        }
	
	        /**************************
	           Element Set Iteration
	        **************************/
	
	        /* If the "nodeType" property exists on the elements variable, we're animating a single element.
	           Place it in an array so that $.each() can iterate over it. */
	        $.each(elements, function(i, element) {
	            /* Ensure each element in a set has a nodeType (is a real element) to avoid throwing errors. */
	            if (Type.isNode(element)) {
	                processElement.call(element);
	            }
	        });
	
	        /******************
	           Option: Loop
	        ******************/
	
	        /* The loop option accepts an integer indicating how many times the element should loop between the values in the
	           current call's properties map and the element's property values prior to this call. */
	        /* Note: The loop option's logic is performed here -- after element processing -- because the current call needs
	           to undergo its queue insertion prior to the loop option generating its series of constituent "reverse" calls,
	           which chain after the current call. Two reverse calls (two "alternations") constitute one loop. */
	        var opts = $.extend({}, Velocity.defaults, options),
	            reverseCallsCount;
	
	        opts.loop = parseInt(opts.loop);
	        reverseCallsCount = (opts.loop * 2) - 1;
	
	        if (opts.loop) {
	            /* Double the loop count to convert it into its appropriate number of "reverse" calls.
	               Subtract 1 from the resulting value since the current call is included in the total alternation count. */
	            for (var x = 0; x < reverseCallsCount; x++) {
	                /* Since the logic for the reverse action occurs inside Queueing and therefore this call's options object
	                   isn't parsed until then as well, the current call's delay option must be explicitly passed into the reverse
	                   call so that the delay logic that occurs inside *Pre-Queueing* can process it. */
	                var reverseOptions = {
	                    delay: opts.delay,
	                    progress: opts.progress
	                };
	
	                /* If a complete callback was passed into this call, transfer it to the loop redirect's final "reverse" call
	                   so that it's triggered when the entire redirect is complete (and not when the very first animation is complete). */
	                if (x === reverseCallsCount - 1) {
	                    reverseOptions.display = opts.display;
	                    reverseOptions.visibility = opts.visibility;
	                    reverseOptions.complete = opts.complete;
	                }
	
	                animate(elements, "reverse", reverseOptions);
	            }
	        }
	
	        /***************
	            Chaining
	        ***************/
	
	        /* Return the elements back to the call chain, with wrapped elements taking precedence in case Velocity was called via the $.fn. extension. */
	        return getChain();
	    };
	
	    /* Turn Velocity into the animation function, extended with the pre-existing Velocity object. */
	    Velocity = $.extend(animate, Velocity);
	    /* For legacy support, also expose the literal animate method. */
	    Velocity.animate = animate;
	
	    /**************
	        Timing
	    **************/
	
	    /* Ticker function. */
	    var ticker = window.requestAnimationFrame || rAFShim;
	
	    /* Inactive browser tabs pause rAF, which results in all active animations immediately sprinting to their completion states when the tab refocuses.
	       To get around this, we dynamically switch rAF to setTimeout (which the browser *doesn't* pause) when the tab loses focus. We skip this for mobile
	       devices to avoid wasting battery power on inactive tabs. */
	    /* Note: Tab focus detection doesn't work on older versions of IE, but that's okay since they don't support rAF to begin with. */
	    if (!Velocity.State.isMobile && document.hidden !== undefined) {
	        document.addEventListener("visibilitychange", function() {
	            /* Reassign the rAF function (which the global tick() function uses) based on the tab's focus state. */
	            if (document.hidden) {
	                ticker = function(callback) {
	                    /* The tick function needs a truthy first argument in order to pass its internal timestamp check. */
	                    return setTimeout(function() { callback(true) }, 16);
	                };
	
	                /* The rAF loop has been paused by the browser, so we manually restart the tick. */
	                tick();
	            } else {
	                ticker = window.requestAnimationFrame || rAFShim;
	            }
	        });
	    }
	
	    /************
	        Tick
	    ************/
	
	    /* Note: All calls to Velocity are pushed to the Velocity.State.calls array, which is fully iterated through upon each tick. */
	    function tick (timestamp) {
	        /* An empty timestamp argument indicates that this is the first tick occurence since ticking was turned on.
	           We leverage this metadata to fully ignore the first tick pass since RAF's initial pass is fired whenever
	           the browser's next tick sync time occurs, which results in the first elements subjected to Velocity
	           calls being animated out of sync with any elements animated immediately thereafter. In short, we ignore
	           the first RAF tick pass so that elements being immediately consecutively animated -- instead of simultaneously animated
	           by the same Velocity call -- are properly batched into the same initial RAF tick and consequently remain in sync thereafter. */
	        if (timestamp) {
	            /* We ignore RAF's high resolution timestamp since it can be significantly offset when the browser is
	               under high stress; we opt for choppiness over allowing the browser to drop huge chunks of frames. */
	            var timeCurrent = (new Date).getTime();
	
	            /********************
	               Call Iteration
	            ********************/
	
	            var callsLength = Velocity.State.calls.length;
	
	            /* To speed up iterating over this array, it is compacted (falsey items -- calls that have completed -- are removed)
	               when its length has ballooned to a point that can impact tick performance. This only becomes necessary when animation
	               has been continuous with many elements over a long period of time; whenever all active calls are completed, completeCall() clears Velocity.State.calls. */
	            if (callsLength > 10000) {
	                Velocity.State.calls = compactSparseArray(Velocity.State.calls);
	            }
	
	            /* Iterate through each active call. */
	            for (var i = 0; i < callsLength; i++) {
	                /* When a Velocity call is completed, its Velocity.State.calls entry is set to false. Continue on to the next call. */
	                if (!Velocity.State.calls[i]) {
	                    continue;
	                }
	
	                /************************
	                   Call-Wide Variables
	                ************************/
	
	                var callContainer = Velocity.State.calls[i],
	                    call = callContainer[0],
	                    opts = callContainer[2],
	                    timeStart = callContainer[3],
	                    firstTick = !!timeStart,
	                    tweenDummyValue = null;
	
	                /* If timeStart is undefined, then this is the first time that this call has been processed by tick().
	                   We assign timeStart now so that its value is as close to the real animation start time as possible.
	                   (Conversely, had timeStart been defined when this call was added to Velocity.State.calls, the delay
	                   between that time and now would cause the first few frames of the tween to be skipped since
	                   percentComplete is calculated relative to timeStart.) */
	                /* Further, subtract 16ms (the approximate resolution of RAF) from the current time value so that the
	                   first tick iteration isn't wasted by animating at 0% tween completion, which would produce the
	                   same style value as the element's current value. */
	                if (!timeStart) {
	                    timeStart = Velocity.State.calls[i][3] = timeCurrent - 16;
	                }
	
	                /* The tween's completion percentage is relative to the tween's start time, not the tween's start value
	                   (which would result in unpredictable tween durations since JavaScript's timers are not particularly accurate).
	                   Accordingly, we ensure that percentComplete does not exceed 1. */
	                var percentComplete = Math.min((timeCurrent - timeStart) / opts.duration, 1);
	
	                /**********************
	                   Element Iteration
	                **********************/
	
	                /* For every call, iterate through each of the elements in its set. */
	                for (var j = 0, callLength = call.length; j < callLength; j++) {
	                    var tweensContainer = call[j],
	                        element = tweensContainer.element;
	
	                    /* Check to see if this element has been deleted midway through the animation by checking for the
	                       continued existence of its data cache. If it's gone, skip animating this element. */
	                    if (!Data(element)) {
	                        continue;
	                    }
	
	                    var transformPropertyExists = false;
	
	                    /**********************************
	                       Display & Visibility Toggling
	                    **********************************/
	
	                    /* If the display option is set to non-"none", set it upfront so that the element can become visible before tweening begins.
	                       (Otherwise, display's "none" value is set in completeCall() once the animation has completed.) */
	                    if (opts.display !== undefined && opts.display !== null && opts.display !== "none") {
	                        if (opts.display === "flex") {
	                            var flexValues = [ "-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex" ];
	
	                            $.each(flexValues, function(i, flexValue) {
	                                CSS.setPropertyValue(element, "display", flexValue);
	                            });
	                        }
	
	                        CSS.setPropertyValue(element, "display", opts.display);
	                    }
	
	                    /* Same goes with the visibility option, but its "none" equivalent is "hidden". */
	                    if (opts.visibility !== undefined && opts.visibility !== "hidden") {
	                        CSS.setPropertyValue(element, "visibility", opts.visibility);
	                    }
	
	                    /************************
	                       Property Iteration
	                    ************************/
	
	                    /* For every element, iterate through each property. */
	                    for (var property in tweensContainer) {
	                        /* Note: In addition to property tween data, tweensContainer contains a reference to its associated element. */
	                        if (property !== "element") {
	                            var tween = tweensContainer[property],
	                                currentValue,
	                                /* Easing can either be a pre-genereated function or a string that references a pre-registered easing
	                                   on the Velocity.Easings object. In either case, return the appropriate easing *function*. */
	                                easing = Type.isString(tween.easing) ? Velocity.Easings[tween.easing] : tween.easing;
	
	                            /******************************
	                               Current Value Calculation
	                            ******************************/
	
	                            /* If this is the last tick pass (if we've reached 100% completion for this tween),
	                               ensure that currentValue is explicitly set to its target endValue so that it's not subjected to any rounding. */
	                            if (percentComplete === 1) {
	                                currentValue = tween.endValue;
	                            /* Otherwise, calculate currentValue based on the current delta from startValue. */
	                            } else {
	                                var tweenDelta = tween.endValue - tween.startValue;
	                                currentValue = tween.startValue + (tweenDelta * easing(percentComplete, opts, tweenDelta));
	
	                                /* If no value change is occurring, don't proceed with DOM updating. */
	                                if (!firstTick && (currentValue === tween.currentValue)) {
	                                    continue;
	                                }
	                            }
	
	                            tween.currentValue = currentValue;
	
	                            /* If we're tweening a fake 'tween' property in order to log transition values, update the one-per-call variable so that
	                               it can be passed into the progress callback. */
	                            if (property === "tween") {
	                                tweenDummyValue = currentValue;
	                            } else {
	                                /******************
	                                   Hooks: Part I
	                                ******************/
	
	                                /* For hooked properties, the newly-updated rootPropertyValueCache is cached onto the element so that it can be used
	                                   for subsequent hooks in this call that are associated with the same root property. If we didn't cache the updated
	                                   rootPropertyValue, each subsequent update to the root property in this tick pass would reset the previous hook's
	                                   updates to rootPropertyValue prior to injection. A nice performance byproduct of rootPropertyValue caching is that
	                                   subsequently chained animations using the same hookRoot but a different hook can use this cached rootPropertyValue. */
	                                if (CSS.Hooks.registered[property]) {
	                                    var hookRoot = CSS.Hooks.getRoot(property),
	                                        rootPropertyValueCache = Data(element).rootPropertyValueCache[hookRoot];
	
	                                    if (rootPropertyValueCache) {
	                                        tween.rootPropertyValue = rootPropertyValueCache;
	                                    }
	                                }
	
	                                /*****************
	                                    DOM Update
	                                *****************/
	
	                                /* setPropertyValue() returns an array of the property name and property value post any normalization that may have been performed. */
	                                /* Note: To solve an IE<=8 positioning bug, the unit type is dropped when setting a property value of 0. */
	                                var adjustedSetData = CSS.setPropertyValue(element, /* SET */
	                                                                           property,
	                                                                           tween.currentValue + (parseFloat(currentValue) === 0 ? "" : tween.unitType),
	                                                                           tween.rootPropertyValue,
	                                                                           tween.scrollData);
	
	                                /*******************
	                                   Hooks: Part II
	                                *******************/
	
	                                /* Now that we have the hook's updated rootPropertyValue (the post-processed value provided by adjustedSetData), cache it onto the element. */
	                                if (CSS.Hooks.registered[property]) {
	                                    /* Since adjustedSetData contains normalized data ready for DOM updating, the rootPropertyValue needs to be re-extracted from its normalized form. ?? */
	                                    if (CSS.Normalizations.registered[hookRoot]) {
	                                        Data(element).rootPropertyValueCache[hookRoot] = CSS.Normalizations.registered[hookRoot]("extract", null, adjustedSetData[1]);
	                                    } else {
	                                        Data(element).rootPropertyValueCache[hookRoot] = adjustedSetData[1];
	                                    }
	                                }
	
	                                /***************
	                                   Transforms
	                                ***************/
	
	                                /* Flag whether a transform property is being animated so that flushTransformCache() can be triggered once this tick pass is complete. */
	                                if (adjustedSetData[0] === "transform") {
	                                    transformPropertyExists = true;
	                                }
	
	                            }
	                        }
	                    }
	
	                    /****************
	                        mobileHA
	                    ****************/
	
	                    /* If mobileHA is enabled, set the translate3d transform to null to force hardware acceleration.
	                       It's safe to override this property since Velocity doesn't actually support its animation (hooks are used in its place). */
	                    if (opts.mobileHA) {
	                        /* Don't set the null transform hack if we've already done so. */
	                        if (Data(element).transformCache.translate3d === undefined) {
	                            /* All entries on the transformCache object are later concatenated into a single transform string via flushTransformCache(). */
	                            Data(element).transformCache.translate3d = "(0px, 0px, 0px)";
	
	                            transformPropertyExists = true;
	                        }
	                    }
	
	                    if (transformPropertyExists) {
	                        CSS.flushTransformCache(element);
	                    }
	                }
	
	                /* The non-"none" display value is only applied to an element once -- when its associated call is first ticked through.
	                   Accordingly, it's set to false so that it isn't re-processed by this call in the next tick. */
	                if (opts.display !== undefined && opts.display !== "none") {
	                    Velocity.State.calls[i][2].display = false;
	                }
	                if (opts.visibility !== undefined && opts.visibility !== "hidden") {
	                    Velocity.State.calls[i][2].visibility = false;
	                }
	
	                /* Pass the elements and the timing data (percentComplete, msRemaining, timeStart, tweenDummyValue) into the progress callback. */
	                if (opts.progress) {
	                    opts.progress.call(callContainer[1],
	                                       callContainer[1],
	                                       percentComplete,
	                                       Math.max(0, (timeStart + opts.duration) - timeCurrent),
	                                       timeStart,
	                                       tweenDummyValue);
	                }
	
	                /* If this call has finished tweening, pass its index to completeCall() to handle call cleanup. */
	                if (percentComplete === 1) {
	                    completeCall(i);
	                }
	            }
	        }
	
	        /* Note: completeCall() sets the isTicking flag to false when the last call on Velocity.State.calls has completed. */
	        if (Velocity.State.isTicking) {
	            ticker(tick);
	        }
	    }
	
	    /**********************
	        Call Completion
	    **********************/
	
	    /* Note: Unlike tick(), which processes all active calls at once, call completion is handled on a per-call basis. */
	    function completeCall (callIndex, isStopped) {
	        /* Ensure the call exists. */
	        if (!Velocity.State.calls[callIndex]) {
	            return false;
	        }
	
	        /* Pull the metadata from the call. */
	        var call = Velocity.State.calls[callIndex][0],
	            elements = Velocity.State.calls[callIndex][1],
	            opts = Velocity.State.calls[callIndex][2],
	            resolver = Velocity.State.calls[callIndex][4];
	
	        var remainingCallsExist = false;
	
	        /*************************
	           Element Finalization
	        *************************/
	
	        for (var i = 0, callLength = call.length; i < callLength; i++) {
	            var element = call[i].element;
	
	            /* If the user set display to "none" (intending to hide the element), set it now that the animation has completed. */
	            /* Note: display:none isn't set when calls are manually stopped (via Velocity("stop"). */
	            /* Note: Display gets ignored with "reverse" calls and infinite loops, since this behavior would be undesirable. */
	            if (!isStopped && !opts.loop) {
	                if (opts.display === "none") {
	                    CSS.setPropertyValue(element, "display", opts.display);
	                }
	
	                if (opts.visibility === "hidden") {
	                    CSS.setPropertyValue(element, "visibility", opts.visibility);
	                }
	            }
	
	            /* If the element's queue is empty (if only the "inprogress" item is left at position 0) or if its queue is about to run
	               a non-Velocity-initiated entry, turn off the isAnimating flag. A non-Velocity-initiatied queue entry's logic might alter
	               an element's CSS values and thereby cause Velocity's cached value data to go stale. To detect if a queue entry was initiated by Velocity,
	               we check for the existence of our special Velocity.queueEntryFlag declaration, which minifiers won't rename since the flag
	               is assigned to jQuery's global $ object and thus exists out of Velocity's own scope. */
	            if (opts.loop !== true && ($.queue(element)[1] === undefined || !/\.velocityQueueEntryFlag/i.test($.queue(element)[1]))) {
	                /* The element may have been deleted. Ensure that its data cache still exists before acting on it. */
	                if (Data(element)) {
	                    Data(element).isAnimating = false;
	                    /* Clear the element's rootPropertyValueCache, which will become stale. */
	                    Data(element).rootPropertyValueCache = {};
	
	                    var transformHAPropertyExists = false;
	                    /* If any 3D transform subproperty is at its default value (regardless of unit type), remove it. */
	                    $.each(CSS.Lists.transforms3D, function(i, transformName) {
	                        var defaultValue = /^scale/.test(transformName) ? 1 : 0,
	                            currentValue = Data(element).transformCache[transformName];
	
	                        if (Data(element).transformCache[transformName] !== undefined && new RegExp("^\\(" + defaultValue + "[^.]").test(currentValue)) {
	                            transformHAPropertyExists = true;
	
	                            delete Data(element).transformCache[transformName];
	                        }
	                    });
	
	                    /* Mobile devices have hardware acceleration removed at the end of the animation in order to avoid hogging the GPU's memory. */
	                    if (opts.mobileHA) {
	                        transformHAPropertyExists = true;
	                        delete Data(element).transformCache.translate3d;
	                    }
	
	                    /* Flush the subproperty removals to the DOM. */
	                    if (transformHAPropertyExists) {
	                        CSS.flushTransformCache(element);
	                    }
	
	                    /* Remove the "velocity-animating" indicator class. */
	                    CSS.Values.removeClass(element, "velocity-animating");
	                }
	            }
	
	            /*********************
	               Option: Complete
	            *********************/
	
	            /* Complete is fired once per call (not once per element) and is passed the full raw DOM element set as both its context and its first argument. */
	            /* Note: Callbacks aren't fired when calls are manually stopped (via Velocity("stop"). */
	            if (!isStopped && opts.complete && !opts.loop && (i === callLength - 1)) {
	                /* We throw callbacks in a setTimeout so that thrown errors don't halt the execution of Velocity itself. */
	                try {
	                    opts.complete.call(elements, elements);
	                } catch (error) {
	                    setTimeout(function() { throw error; }, 1);
	                }
	            }
	
	            /**********************
	               Promise Resolving
	            **********************/
	
	            /* Note: Infinite loops don't return promises. */
	            if (resolver && opts.loop !== true) {
	                resolver(elements);
	            }
	
	            /****************************
	               Option: Loop (Infinite)
	            ****************************/
	
	            if (Data(element) && opts.loop === true && !isStopped) {
	                /* If a rotateX/Y/Z property is being animated to 360 deg with loop:true, swap tween start/end values to enable
	                   continuous iterative rotation looping. (Otherise, the element would just rotate back and forth.) */
	                $.each(Data(element).tweensContainer, function(propertyName, tweenContainer) {
	                    if (/^rotate/.test(propertyName) && parseFloat(tweenContainer.endValue) === 360) {
	                        tweenContainer.endValue = 0;
	                        tweenContainer.startValue = 360;
	                    }
	
	                    if (/^backgroundPosition/.test(propertyName) && parseFloat(tweenContainer.endValue) === 100 && tweenContainer.unitType === "%") {
	                        tweenContainer.endValue = 0;
	                        tweenContainer.startValue = 100;
	                    }
	                });
	
	                Velocity(element, "reverse", { loop: true, delay: opts.delay });
	            }
	
	            /***************
	               Dequeueing
	            ***************/
	
	            /* Fire the next call in the queue so long as this call's queue wasn't set to false (to trigger a parallel animation),
	               which would have already caused the next call to fire. Note: Even if the end of the animation queue has been reached,
	               $.dequeue() must still be called in order to completely clear jQuery's animation queue. */
	            if (opts.queue !== false) {
	                $.dequeue(element, opts.queue);
	            }
	        }
	
	        /************************
	           Calls Array Cleanup
	        ************************/
	
	        /* Since this call is complete, set it to false so that the rAF tick skips it. This array is later compacted via compactSparseArray().
	          (For performance reasons, the call is set to false instead of being deleted from the array: http://www.html5rocks.com/en/tutorials/speed/v8/) */
	        Velocity.State.calls[callIndex] = false;
	
	        /* Iterate through the calls array to determine if this was the final in-progress animation.
	           If so, set a flag to end ticking and clear the calls array. */
	        for (var j = 0, callsLength = Velocity.State.calls.length; j < callsLength; j++) {
	            if (Velocity.State.calls[j] !== false) {
	                remainingCallsExist = true;
	
	                break;
	            }
	        }
	
	        if (remainingCallsExist === false) {
	            /* tick() will detect this flag upon its next iteration and subsequently turn itself off. */
	            Velocity.State.isTicking = false;
	
	            /* Clear the calls array so that its length is reset. */
	            delete Velocity.State.calls;
	            Velocity.State.calls = [];
	        }
	    }
	
	    /******************
	        Frameworks
	    ******************/
	
	    /* Both jQuery and Zepto allow their $.fn object to be extended to allow wrapped elements to be subjected to plugin calls.
	       If either framework is loaded, register a "velocity" extension pointing to Velocity's core animate() method.  Velocity
	       also registers itself onto a global container (window.jQuery || window.Zepto || window) so that certain features are
	       accessible beyond just a per-element scope. This master object contains an .animate() method, which is later assigned to $.fn
	       (if jQuery or Zepto are present). Accordingly, Velocity can both act on wrapped DOM elements and stand alone for targeting raw DOM elements. */
	    global.Velocity = Velocity;
	
	    if (global !== window) {
	        /* Assign the element function to Velocity's core animate() method. */
	        global.fn.velocity = animate;
	        /* Assign the object function's defaults to Velocity's global defaults object. */
	        global.fn.velocity.defaults = Velocity.defaults;
	    }
	
	    /***********************
	       Packaged Redirects
	    ***********************/
	
	    /* slideUp, slideDown */
	    $.each([ "Down", "Up" ], function(i, direction) {
	        Velocity.Redirects["slide" + direction] = function (element, options, elementsIndex, elementsSize, elements, promiseData) {
	            var opts = $.extend({}, options),
	                begin = opts.begin,
	                complete = opts.complete,
	                computedValues = { height: "", marginTop: "", marginBottom: "", paddingTop: "", paddingBottom: "" },
	                inlineValues = {};
	
	            if (opts.display === undefined) {
	                /* Show the element before slideDown begins and hide the element after slideUp completes. */
	                /* Note: Inline elements cannot have dimensions animated, so they're reverted to inline-block. */
	                opts.display = (direction === "Down" ? (Velocity.CSS.Values.getDisplayType(element) === "inline" ? "inline-block" : "block") : "none");
	            }
	
	            opts.begin = function() {
	                /* If the user passed in a begin callback, fire it now. */
	                begin && begin.call(elements, elements);
	
	                /* Cache the elements' original vertical dimensional property values so that we can animate back to them. */
	                for (var property in computedValues) {
	                    inlineValues[property] = element.style[property];
	
	                    /* For slideDown, use forcefeeding to animate all vertical properties from 0. For slideUp,
	                       use forcefeeding to start from computed values and animate down to 0. */
	                    var propertyValue = Velocity.CSS.getPropertyValue(element, property);
	                    computedValues[property] = (direction === "Down") ? [ propertyValue, 0 ] : [ 0, propertyValue ];
	                }
	
	                /* Force vertical overflow content to clip so that sliding works as expected. */
	                inlineValues.overflow = element.style.overflow;
	                element.style.overflow = "hidden";
	            }
	
	            opts.complete = function() {
	                /* Reset element to its pre-slide inline values once its slide animation is complete. */
	                for (var property in inlineValues) {
	                    element.style[property] = inlineValues[property];
	                }
	
	                /* If the user passed in a complete callback, fire it now. */
	                complete && complete.call(elements, elements);
	                promiseData && promiseData.resolver(elements);
	            };
	
	            Velocity(element, computedValues, opts);
	        };
	    });
	
	    /* fadeIn, fadeOut */
	    $.each([ "In", "Out" ], function(i, direction) {
	        Velocity.Redirects["fade" + direction] = function (element, options, elementsIndex, elementsSize, elements, promiseData) {
	            var opts = $.extend({}, options),
	                propertiesMap = { opacity: (direction === "In") ? 1 : 0 },
	                originalComplete = opts.complete;
	
	            /* Since redirects are triggered individually for each element in the animated set, avoid repeatedly triggering
	               callbacks by firing them only when the final element has been reached. */
	            if (elementsIndex !== elementsSize - 1) {
	                opts.complete = opts.begin = null;
	            } else {
	                opts.complete = function() {
	                    if (originalComplete) {
	                        originalComplete.call(elements, elements);
	                    }
	
	                    promiseData && promiseData.resolver(elements);
	                }
	            }
	
	            /* If a display was passed in, use it. Otherwise, default to "none" for fadeOut or the element-specific default for fadeIn. */
	            /* Note: We allow users to pass in "null" to skip display setting altogether. */
	            if (opts.display === undefined) {
	                opts.display = (direction === "In" ? "auto" : "none");
	            }
	
	            Velocity(this, propertiesMap, opts);
	        };
	    });
	
	    return Velocity;
	}((window.jQuery || window.Zepto || window), window, document);
	}));
	
	/******************
	   Known Issues
	******************/
	
	/* The CSS spec mandates that the translateX/Y/Z transforms are %-relative to the element itself -- not its parent.
	Velocity, however, doesn't make this distinction. Thus, converting to or from the % unit with these subproperties
	will produce an inaccurate conversion value. The same issue exists with the cx/cy attributes of SVG circles and ellipses. */

/***/ },
/* 1580 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 1581 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	"use strict";
	
	__webpack_require__(__webpack_module_template_argument_0__);

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	__webpack_require__(__webpack_module_template_argument_0__);

/***/ }
]);


// WEBPACK FOOTER //
// js/frontend/bundle-fcf91eb676381d9e26c5.js